module.exports = {
	"weather": 0,
	"date": "26 January, 2026",
	"referee": {
		"name": "Стелиос Трифонос",
		"nation": "Кипр",
		"ycards": 1462,
		"rcards": 74,
		"games": 577,
		"flag": "system/img/flags/50.gif"
	},
	"stadium": {
		"name": "Нейтральное поле."
	},
	"home": {
		"team": {
			"name": "Галвэй Юнайтед",
			"flag": "system/img/club/492.gif",
			"form": "system/img/forms/492a.png",
			"back": "800020",
			"color": "FFFFFF"
		},
		"players": [
			{
				"id": 89321,
				"num": 1,
				"name": "М.Глэдхилл",
				"number": 1,
				"position": 1
			},
			{
				"id": 85485,
				"num": 2,
				"name": "Т.Эверс",
				"number": 6,
				"position": 3
			},
			{
				"id": 92240,
				"num": 3,
				"name": "П.Клинтон",
				"number": 5,
				"position": 4,
				"captain": true
			},
			{
				"id": 112396,
				"num": 4,
				"name": "Р.Дриссенс",
				"number": 38,
				"position": 6
			},
			{
				"id": 95795,
				"num": 5,
				"name": "С.Фридйонссон",
				"number": 9,
				"position": 7
			},
			{
				"id": 108678,
				"num": 6,
				"name": "К.Колман",
				"number": 7,
				"position": 13
			},
			{
				"id": 121866,
				"num": 7,
				"name": "А.Хлинссон",
				"number": 8,
				"position": 14
			},
			{
				"id": 130097,
				"num": 8,
				"name": "К.Нолан",
				"number": 17,
				"position": 16
			},
			{
				"id": 112645,
				"num": 9,
				"name": "Э.Бвомоно",
				"number": 66,
				"position": 17
			},
			{
				"id": 108538,
				"num": 10,
				"name": "Д.Квигли",
				"number": 10,
				"position": 23
			},
			{
				"id": 111797,
				"num": 11,
				"name": "А.Гилберт",
				"number": 71,
				"position": 25
			},
			{
				"id": 130106,
				"num": 12,
				"name": "К.Доран",
				"number": 16
			},
			{
				"id": 145215,
				"num": 13,
				"name": "Б.Реган",
				"number": 4
			},
			{
				"id": 88004,
				"num": 14,
				"name": "Т.Смит",
				"number": 3
			},
			{
				"id": 112085,
				"num": 15,
				"name": "К.Келли",
				"number": 89
			},
			{
				"id": 140765,
				"num": 16,
				"name": "Т.Перри",
				"number": 28
			},
			{
				"id": 121574,
				"num": 17,
				"name": "М.Раум",
				"number": 34
			},
			{
				"id": 101556,
				"num": 18,
				"name": "Р.Уотсон",
				"number": 41
			},
			{
				"id": 115561,
				"num": 19,
				"name": "Б.О`Горман",
				"number": 55
			},
			{
				"id": 146940,
				"num": 20,
				"name": "Т.Дэвлин",
				"number": 18
			}
		],
		"manager": "serge78"
	},
	"away": {
		"team": {
			"name": "Опава",
			"flag": "system/img/club/1290.gif",
			"form": "system/img/forms/1290a.png",
			"back": "FFD000",
			"color": "0030A0"
		},
		"players": [
			{
				"id": 121174,
				"num": 1,
				"name": "К.Ласак",
				"number": 49,
				"position": 1
			},
			{
				"id": 117730,
				"num": 2,
				"name": "Л.Седлачек",
				"number": 26,
				"position": 3
			},
			{
				"id": 84295,
				"num": 3,
				"name": "Н.Мансур",
				"number": 5,
				"position": 4
			},
			{
				"id": 141751,
				"num": 4,
				"name": "С.Пейша",
				"number": 16,
				"position": 6
			},
			{
				"id": 140987,
				"num": 5,
				"name": "Т.Прохазка",
				"number": 25,
				"position": 7
			},
			{
				"id": 112817,
				"num": 6,
				"name": "О.Дюмон",
				"number": 6,
				"position": 10
			},
			{
				"id": 57083,
				"num": 7,
				"name": "М.Манолов",
				"number": 88,
				"position": 15,
				"captain": true
			},
			{
				"id": 85689,
				"num": 8,
				"name": "Д.Прохазка",
				"number": 33,
				"position": 17
			},
			{
				"id": 140222,
				"num": 9,
				"name": "М.Юрасек",
				"number": 31,
				"position": 18
			},
			{
				"id": 145687,
				"num": 10,
				"name": "П.Крамарж",
				"number": 19,
				"position": 23
			},
			{
				"id": 92286,
				"num": 11,
				"name": "Ш.Товарек",
				"number": 29,
				"position": 25
			},
			{
				"id": 145690,
				"num": 12,
				"name": "Т.Крамарж",
				"number": 1
			},
			{
				"id": 88423,
				"num": 13,
				"name": "К.Удре",
				"number": 42
			},
			{
				"id": 145688,
				"num": 14,
				"name": "В.Сланина",
				"number": 12
			},
			{
				"id": 133289,
				"num": 15,
				"name": "А.Карабец",
				"number": 22
			},
			{
				"id": 141749,
				"num": 16,
				"name": "М.Владарж",
				"number": 36
			},
			{
				"id": 77710,
				"num": 17,
				"name": "М.Томасов",
				"number": 10
			},
			{
				"id": 91950,
				"num": 18,
				"name": "Н.Томпсон",
				"number": 55
			},
			{
				"id": 78905,
				"num": 19,
				"name": "А.Фрешль",
				"number": 20
			},
			{
				"id": 96348,
				"num": 20,
				"name": "Т.Анри",
				"number": 44
			}
		],
		"manager": "Forsage"
	},
	"game": [
		{
			"num": 0,
			"minute": 1,
			"possession": 50,
			"messages": [],
			"N": {
				"team": 1
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 15,
						"f": 100,
						"m": 600,
						"c": 0
					},
					{
						"n": 2,
						"h": 45,
						"w": 90,
						"f": 100,
						"m": 600,
						"c": 0
					},
					{
						"n": 3,
						"h": 135,
						"w": 90,
						"f": 100,
						"m": 600,
						"c": 0
					},
					{
						"n": 4,
						"h": 315,
						"w": 90,
						"f": 100,
						"m": 600,
						"c": 0
					},
					{
						"n": 5,
						"h": 405,
						"w": 90,
						"f": 100,
						"m": 600,
						"c": 0
					},
					{
						"n": 6,
						"h": 45,
						"w": 210,
						"f": 100,
						"m": 600,
						"c": 0
					},
					{
						"n": 7,
						"h": 135,
						"w": 210,
						"f": 100,
						"m": 600,
						"c": 0
					},
					{
						"n": 8,
						"h": 315,
						"w": 210,
						"f": 100,
						"m": 600,
						"c": 0
					},
					{
						"n": 9,
						"h": 405,
						"w": 210,
						"f": 100,
						"m": 600,
						"c": 0
					},
					{
						"n": 10,
						"h": 215,
						"w": 355,
						"f": 100,
						"m": 600,
						"c": 0
					},
					{
						"n": 11,
						"h": 238,
						"w": 340,
						"f": 100,
						"m": 600,
						"c": 0
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 15,
						"f": 98,
						"m": 600,
						"c": 0
					},
					{
						"n": 2,
						"h": 37,
						"w": 90,
						"f": 97,
						"m": 600,
						"c": 0
					},
					{
						"n": 3,
						"h": 131,
						"w": 90,
						"f": 97,
						"m": 600,
						"c": 0
					},
					{
						"n": 4,
						"h": 319,
						"w": 90,
						"f": 98,
						"m": 600,
						"c": 0
					},
					{
						"n": 5,
						"h": 413,
						"w": 90,
						"f": 99,
						"m": 600,
						"c": 0
					},
					{
						"n": 6,
						"h": 225,
						"w": 150,
						"f": 99,
						"m": 600,
						"c": 0
					},
					{
						"n": 7,
						"h": 225,
						"w": 210,
						"f": 100,
						"m": 600,
						"c": 0
					},
					{
						"n": 8,
						"h": 413,
						"w": 210,
						"f": 98,
						"m": 600,
						"c": 0
					},
					{
						"n": 9,
						"h": 37,
						"w": 270,
						"f": 99,
						"m": 600,
						"c": 0
					},
					{
						"n": 10,
						"h": 100,
						"w": 330,
						"f": 99,
						"m": 600,
						"c": 0
					},
					{
						"n": 11,
						"h": 350,
						"w": 330,
						"f": 99,
						"m": 600,
						"c": 0
					}
				],
				"ball": {
					"n": 0,
					"h": 225,
					"w": 360,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 300
		},
		{
			"num": 1,
			"minute": 1,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 15
					},
					{
						"n": 2,
						"h": 45,
						"w": 90
					},
					{
						"n": 3,
						"h": 135,
						"w": 90
					},
					{
						"n": 4,
						"h": 315,
						"w": 90
					},
					{
						"n": 5,
						"h": 405,
						"w": 90
					},
					{
						"n": 6,
						"h": 45,
						"w": 210
					},
					{
						"n": 7,
						"h": 135,
						"w": 210
					},
					{
						"n": 8,
						"h": 315,
						"w": 210
					},
					{
						"n": 9,
						"h": 405,
						"w": 210
					},
					{
						"n": 10,
						"h": 215,
						"w": 355
					},
					{
						"n": 11,
						"h": 238,
						"w": 340
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 15
					},
					{
						"n": 2,
						"h": 37,
						"w": 90
					},
					{
						"n": 3,
						"h": 131,
						"w": 90
					},
					{
						"n": 4,
						"h": 319,
						"w": 90
					},
					{
						"n": 5,
						"h": 413,
						"w": 90
					},
					{
						"n": 6,
						"h": 225,
						"w": 150
					},
					{
						"n": 7,
						"h": 225,
						"w": 210
					},
					{
						"n": 8,
						"h": 413,
						"w": 210
					},
					{
						"n": 9,
						"h": 37,
						"w": 270
					},
					{
						"n": 10,
						"h": 100,
						"w": 330
					},
					{
						"n": 11,
						"h": 350,
						"w": 330
					}
				],
				"ball": {
					"n": 0,
					"h": 225,
					"w": 360,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 30
		},
		{
			"num": 2,
			"minute": 1,
			"messages": [
				{
					"owner": 1,
					"mes": "Джо Квигли[10](Галвэй Юнайтед) разыгрывает мяч... Пас назад..."
				},
				{
					"owner": 1,
					"mes": "Адам Гилберт[11](Галвэй Юнайтед) держит мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 15
					},
					{
						"n": 2,
						"h": 45,
						"w": 90
					},
					{
						"n": 3,
						"h": 135,
						"w": 90
					},
					{
						"n": 4,
						"h": 315,
						"w": 90
					},
					{
						"n": 5,
						"h": 405,
						"w": 90
					},
					{
						"n": 6,
						"h": 45,
						"w": 210
					},
					{
						"n": 7,
						"h": 135,
						"w": 210
					},
					{
						"n": 8,
						"h": 315,
						"w": 210
					},
					{
						"n": 9,
						"h": 405,
						"w": 210
					},
					{
						"n": 10,
						"h": 215,
						"w": 355
					},
					{
						"n": 11,
						"h": 238,
						"w": 340
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 15
					},
					{
						"n": 2,
						"h": 37,
						"w": 90
					},
					{
						"n": 3,
						"h": 131,
						"w": 90
					},
					{
						"n": 4,
						"h": 319,
						"w": 90
					},
					{
						"n": 5,
						"h": 413,
						"w": 90
					},
					{
						"n": 6,
						"h": 225,
						"w": 150
					},
					{
						"n": 7,
						"h": 225,
						"w": 210
					},
					{
						"n": 8,
						"h": 413,
						"w": 210
					},
					{
						"n": 9,
						"h": 37,
						"w": 270
					},
					{
						"n": 10,
						"h": 100,
						"w": 330
					},
					{
						"n": 11,
						"h": 350,
						"w": 330
					}
				],
				"ball": {
					"n": 0,
					"h": 238,
					"w": 340,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 15
		},
		{
			"num": 3,
			"minute": 1,
			"messages": [
				{
					"owner": 1,
					"mes": "Адам Гилберт[11](Галвэй Юнайтед) отбрасывает мяч назад..."
				},
				{
					"owner": 1,
					"mes": "Киран Нолан[08](Галвэй Юнайтед) достает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 14
					},
					{
						"n": 2,
						"h": 35,
						"w": 106
					},
					{
						"n": 3,
						"h": 166,
						"w": 82
					},
					{
						"n": 4,
						"h": 273,
						"w": 88
					},
					{
						"n": 5,
						"h": 403,
						"w": 96
					},
					{
						"n": 6,
						"h": 42,
						"w": 252
					},
					{
						"n": 7,
						"h": 146,
						"w": 251
					},
					{
						"n": 8,
						"h": 290,
						"w": 225
					},
					{
						"n": 9,
						"h": 409,
						"w": 252
					},
					{
						"n": 10,
						"h": 195,
						"w": 392
					},
					{
						"n": 11,
						"h": 240,
						"w": 350
					}
				],
				"away": [
					{
						"n": 1,
						"h": 226,
						"w": 16
					},
					{
						"n": 2,
						"h": 74,
						"w": 109
					},
					{
						"n": 3,
						"h": 170,
						"w": 105
					},
					{
						"n": 4,
						"h": 284,
						"w": 114
					},
					{
						"n": 5,
						"h": 374,
						"w": 106
					},
					{
						"n": 6,
						"h": 221,
						"w": 176
					},
					{
						"n": 7,
						"h": 219,
						"w": 226
					},
					{
						"n": 8,
						"h": 399,
						"w": 220
					},
					{
						"n": 9,
						"h": 51,
						"w": 270
					},
					{
						"n": 10,
						"h": 142,
						"w": 328
					},
					{
						"n": 11,
						"h": 321,
						"w": 300
					}
				],
				"ball": {
					"n": 0,
					"h": 290,
					"w": 225,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 42
		},
		{
			"num": 4,
			"minute": 1,
			"messages": [
				{
					"owner": 1,
					"mes": "Пас налево А.Хлинссону[07](Галвэй Юнайтед)..."
				},
				{
					"owner": 1,
					"mes": "Агуст Хлинссон[07](Галвэй Юнайтед) подрабатывает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 15
					},
					{
						"n": 2,
						"h": 54,
						"w": 143
					},
					{
						"n": 3,
						"h": 174,
						"w": 122
					},
					{
						"n": 4,
						"h": 267,
						"w": 128
					},
					{
						"n": 5,
						"h": 405,
						"w": 137
					},
					{
						"n": 6,
						"h": 45,
						"w": 293
					},
					{
						"n": 7,
						"h": 167,
						"w": 239
					},
					{
						"n": 8,
						"h": 289,
						"w": 215
					},
					{
						"n": 9,
						"h": 408,
						"w": 293
					},
					{
						"n": 10,
						"h": 183,
						"w": 431
					},
					{
						"n": 11,
						"h": 247,
						"w": 390
					}
				],
				"away": [
					{
						"n": 1,
						"h": 232,
						"w": 57
					},
					{
						"n": 2,
						"h": 110,
						"w": 110
					},
					{
						"n": 3,
						"h": 176,
						"w": 115
					},
					{
						"n": 4,
						"h": 265,
						"w": 116
					},
					{
						"n": 5,
						"h": 340,
						"w": 117
					},
					{
						"n": 6,
						"h": 232,
						"w": 171
					},
					{
						"n": 7,
						"h": 229,
						"w": 228
					},
					{
						"n": 8,
						"h": 398,
						"w": 220
					},
					{
						"n": 9,
						"h": 35,
						"w": 270
					},
					{
						"n": 10,
						"h": 127,
						"w": 305
					},
					{
						"n": 11,
						"h": 326,
						"w": 285
					}
				],
				"ball": {
					"n": 0,
					"h": 167,
					"w": 239,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 41
		},
		{
			"num": 5,
			"minute": 1,
			"messages": [
				{
					"owner": 1,
					"mes": "Пас левее на К.Колмана[06](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 11
					},
					{
						"n": 2,
						"h": 47,
						"w": 137
					},
					{
						"n": 3,
						"h": 180,
						"w": 124
					},
					{
						"n": 4,
						"h": 274,
						"w": 136
					},
					{
						"n": 5,
						"h": 408,
						"w": 153
					},
					{
						"n": 6,
						"h": 74,
						"w": 267
					},
					{
						"n": 7,
						"h": 164,
						"w": 248
					},
					{
						"n": 8,
						"h": 256,
						"w": 236
					},
					{
						"n": 9,
						"h": 404,
						"w": 332
					},
					{
						"n": 10,
						"h": 171,
						"w": 462
					},
					{
						"n": 11,
						"h": 257,
						"w": 428
					}
				],
				"away": [
					{
						"n": 1,
						"h": 245,
						"w": 71
					},
					{
						"n": 2,
						"h": 110,
						"w": 121
					},
					{
						"n": 3,
						"h": 213,
						"w": 127
					},
					{
						"n": 4,
						"h": 278,
						"w": 127
					},
					{
						"n": 5,
						"h": 340,
						"w": 112
					},
					{
						"n": 6,
						"h": 271,
						"w": 170
					},
					{
						"n": 7,
						"h": 265,
						"w": 242
					},
					{
						"n": 8,
						"h": 408,
						"w": 220
					},
					{
						"n": 9,
						"h": 40,
						"w": 309
					},
					{
						"n": 10,
						"h": 162,
						"w": 288
					},
					{
						"n": 11,
						"h": 293,
						"w": 305
					}
				],
				"ball": {
					"n": 0,
					"h": 74,
					"w": 267,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 6,
			"minute": 1,
			"messages": [
				{
					"owner": 1,
					"mes": "Пас направо Р.Дриссенсу[04](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 14
					},
					{
						"n": 2,
						"h": 21,
						"w": 155
					},
					{
						"n": 3,
						"h": 181,
						"w": 121
					},
					{
						"n": 4,
						"h": 259,
						"w": 166
					},
					{
						"n": 5,
						"h": 420,
						"w": 158
					},
					{
						"n": 6,
						"h": 71,
						"w": 277
					},
					{
						"n": 7,
						"h": 168,
						"w": 301
					},
					{
						"n": 8,
						"h": 286,
						"w": 234
					},
					{
						"n": 9,
						"h": 416,
						"w": 383
					},
					{
						"n": 10,
						"h": 163,
						"w": 465
					},
					{
						"n": 11,
						"h": 264,
						"w": 480
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 71
					},
					{
						"n": 2,
						"h": 110,
						"w": 174
					},
					{
						"n": 3,
						"h": 192,
						"w": 175
					},
					{
						"n": 4,
						"h": 245,
						"w": 168
					},
					{
						"n": 5,
						"h": 340,
						"w": 165
					},
					{
						"n": 6,
						"h": 229,
						"w": 202
					},
					{
						"n": 7,
						"h": 284,
						"w": 292
					},
					{
						"n": 8,
						"h": 419,
						"w": 272
					},
					{
						"n": 9,
						"h": 44,
						"w": 301
					},
					{
						"n": 10,
						"h": 159,
						"w": 341
					},
					{
						"n": 11,
						"h": 294,
						"w": 358
					}
				],
				"ball": {
					"n": 0,
					"h": 259,
					"w": 166,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 53
		},
		{
			"num": 7,
			"minute": 1,
			"messages": [
				{
					"owner": 1,
					"mes": "Передача вперед..."
				},
				{
					"owner": 1,
					"mes": "Киран Нолан[08](Галвэй Юнайтед) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 14
					},
					{
						"n": 2,
						"h": 37,
						"w": 174
					},
					{
						"n": 3,
						"h": 182,
						"w": 154
					},
					{
						"n": 4,
						"h": 263,
						"w": 167
					},
					{
						"n": 5,
						"h": 408,
						"w": 180
					},
					{
						"n": 6,
						"h": 57,
						"w": 298
					},
					{
						"n": 7,
						"h": 160,
						"w": 325
					},
					{
						"n": 8,
						"h": 277,
						"w": 211
					},
					{
						"n": 9,
						"h": 406,
						"w": 361
					},
					{
						"n": 10,
						"h": 155,
						"w": 484
					},
					{
						"n": 11,
						"h": 289,
						"w": 483
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 78
					},
					{
						"n": 2,
						"h": 131,
						"w": 188
					},
					{
						"n": 3,
						"h": 207,
						"w": 196
					},
					{
						"n": 4,
						"h": 263,
						"w": 186
					},
					{
						"n": 5,
						"h": 340,
						"w": 190
					},
					{
						"n": 6,
						"h": 246,
						"w": 221
					},
					{
						"n": 7,
						"h": 268,
						"w": 311
					},
					{
						"n": 8,
						"h": 416,
						"w": 297
					},
					{
						"n": 9,
						"h": 44,
						"w": 323
					},
					{
						"n": 10,
						"h": 163,
						"w": 365
					},
					{
						"n": 11,
						"h": 313,
						"w": 375
					}
				],
				"ball": {
					"n": 0,
					"h": 277,
					"w": 211,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 25
		},
		{
			"num": 8,
			"minute": 1,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 18
					},
					{
						"n": 2,
						"h": 49,
						"w": 212
					},
					{
						"n": 3,
						"h": 175,
						"w": 194
					},
					{
						"n": 4,
						"h": 270,
						"w": 198
					},
					{
						"n": 5,
						"h": 394,
						"w": 217
					},
					{
						"n": 6,
						"h": 56,
						"w": 338
					},
					{
						"n": 7,
						"h": 156,
						"w": 365
					},
					{
						"n": 8,
						"h": 287,
						"w": 245
					},
					{
						"n": 9,
						"h": 398,
						"w": 365
					},
					{
						"n": 10,
						"h": 164,
						"w": 521
					},
					{
						"n": 11,
						"h": 294,
						"w": 496
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 71
					},
					{
						"n": 2,
						"h": 110,
						"w": 167
					},
					{
						"n": 3,
						"h": 179,
						"w": 167
					},
					{
						"n": 4,
						"h": 266,
						"w": 146
					},
					{
						"n": 5,
						"h": 340,
						"w": 165
					},
					{
						"n": 6,
						"h": 206,
						"w": 215
					},
					{
						"n": 7,
						"h": 235,
						"w": 291
					},
					{
						"n": 8,
						"h": 400,
						"w": 333
					},
					{
						"n": 9,
						"h": 52,
						"w": 319
					},
					{
						"n": 10,
						"h": 168,
						"w": 367
					},
					{
						"n": 11,
						"h": 281,
						"w": 368
					}
				],
				"ball": {
					"n": 0,
					"h": 287,
					"w": 245,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 9,
			"minute": 1,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 14
					},
					{
						"n": 2,
						"h": 59,
						"w": 251
					},
					{
						"n": 3,
						"h": 170,
						"w": 233
					},
					{
						"n": 4,
						"h": 266,
						"w": 238
					},
					{
						"n": 5,
						"h": 391,
						"w": 257
					},
					{
						"n": 6,
						"h": 56,
						"w": 378
					},
					{
						"n": 7,
						"h": 154,
						"w": 405
					},
					{
						"n": 8,
						"h": 287,
						"w": 280
					},
					{
						"n": 9,
						"h": 397,
						"w": 405
					},
					{
						"n": 10,
						"h": 172,
						"w": 546
					},
					{
						"n": 11,
						"h": 289,
						"w": 536
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 70
					},
					{
						"n": 2,
						"h": 110,
						"w": 127
					},
					{
						"n": 3,
						"h": 171,
						"w": 131
					},
					{
						"n": 4,
						"h": 266,
						"w": 128
					},
					{
						"n": 5,
						"h": 340,
						"w": 127
					},
					{
						"n": 6,
						"h": 181,
						"w": 184
					},
					{
						"n": 7,
						"h": 227,
						"w": 252
					},
					{
						"n": 8,
						"h": 394,
						"w": 306
					},
					{
						"n": 9,
						"h": 54,
						"w": 279
					},
					{
						"n": 10,
						"h": 164,
						"w": 407
					},
					{
						"n": 11,
						"h": 287,
						"w": 328
					}
				],
				"ball": {
					"n": 0,
					"h": 287,
					"w": 280,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 10,
			"minute": 1,
			"messages": [
				{
					"owner": 1,
					"mes": "Передача С.Фридйонссону[05](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 13
					},
					{
						"n": 2,
						"h": 64,
						"w": 280
					},
					{
						"n": 3,
						"h": 175,
						"w": 262
					},
					{
						"n": 4,
						"h": 273,
						"w": 266
					},
					{
						"n": 5,
						"h": 376,
						"w": 281
					},
					{
						"n": 6,
						"h": 56,
						"w": 407
					},
					{
						"n": 7,
						"h": 173,
						"w": 427
					},
					{
						"n": 8,
						"h": 290,
						"w": 309
					},
					{
						"n": 9,
						"h": 399,
						"w": 434
					},
					{
						"n": 10,
						"h": 177,
						"w": 575
					},
					{
						"n": 11,
						"h": 284,
						"w": 564
					}
				],
				"away": [
					{
						"n": 1,
						"h": 205,
						"w": 75
					},
					{
						"n": 2,
						"h": 110,
						"w": 126
					},
					{
						"n": 3,
						"h": 176,
						"w": 128
					},
					{
						"n": 4,
						"h": 256,
						"w": 130
					},
					{
						"n": 5,
						"h": 340,
						"w": 113
					},
					{
						"n": 6,
						"h": 161,
						"w": 166
					},
					{
						"n": 7,
						"h": 204,
						"w": 234
					},
					{
						"n": 8,
						"h": 394,
						"w": 277
					},
					{
						"n": 9,
						"h": 51,
						"w": 250
					},
					{
						"n": 10,
						"h": 135,
						"w": 411
					},
					{
						"n": 11,
						"h": 275,
						"w": 316
					}
				],
				"ball": {
					"n": 0,
					"h": 376,
					"w": 281,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 29
		},
		{
			"num": 11,
			"minute": 1,
			"messages": [
				{
					"owner": 1,
					"mes": "Самуэль Кари Фридйонссон[05](Галвэй Юнайтед) теряет мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 16
					},
					{
						"n": 2,
						"h": 64,
						"w": 283
					},
					{
						"n": 3,
						"h": 175,
						"w": 265
					},
					{
						"n": 4,
						"h": 275,
						"w": 269
					},
					{
						"n": 5,
						"h": 376,
						"w": 281
					},
					{
						"n": 6,
						"h": 56,
						"w": 410
					},
					{
						"n": 7,
						"h": 174,
						"w": 429
					},
					{
						"n": 8,
						"h": 293,
						"w": 308
					},
					{
						"n": 9,
						"h": 398,
						"w": 437
					},
					{
						"n": 10,
						"h": 177,
						"w": 577
					},
					{
						"n": 11,
						"h": 284,
						"w": 567
					}
				],
				"away": [
					{
						"n": 1,
						"h": 205,
						"w": 77
					},
					{
						"n": 2,
						"h": 110,
						"w": 123
					},
					{
						"n": 3,
						"h": 176,
						"w": 125
					},
					{
						"n": 4,
						"h": 258,
						"w": 128
					},
					{
						"n": 5,
						"h": 340,
						"w": 116
					},
					{
						"n": 6,
						"h": 162,
						"w": 169
					},
					{
						"n": 7,
						"h": 205,
						"w": 237
					},
					{
						"n": 8,
						"h": 394,
						"w": 274
					},
					{
						"n": 9,
						"h": 52,
						"w": 247
					},
					{
						"n": 10,
						"h": 132,
						"w": 412
					},
					{
						"n": 11,
						"h": 278,
						"w": 316
					}
				],
				"ball": {
					"n": 0,
					"h": 368,
					"w": 290,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 3
		},
		{
			"num": 12,
			"minute": 1,
			"messages": [
				{
					"owner": 1,
					"mes": "Самуэль Кари Фридйонссон[05](Галвэй Юнайтед) сам подхватывает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 14
					},
					{
						"n": 2,
						"h": 63,
						"w": 295
					},
					{
						"n": 3,
						"h": 181,
						"w": 275
					},
					{
						"n": 4,
						"h": 277,
						"w": 280
					},
					{
						"n": 5,
						"h": 368,
						"w": 290
					},
					{
						"n": 6,
						"h": 56,
						"w": 422
					},
					{
						"n": 7,
						"h": 181,
						"w": 439
					},
					{
						"n": 8,
						"h": 305,
						"w": 305
					},
					{
						"n": 9,
						"h": 399,
						"w": 449
					},
					{
						"n": 10,
						"h": 166,
						"w": 582
					},
					{
						"n": 11,
						"h": 288,
						"w": 579
					}
				],
				"away": [
					{
						"n": 1,
						"h": 205,
						"w": 73
					},
					{
						"n": 2,
						"h": 110,
						"w": 114
					},
					{
						"n": 3,
						"h": 173,
						"w": 119
					},
					{
						"n": 4,
						"h": 261,
						"w": 116
					},
					{
						"n": 5,
						"h": 340,
						"w": 126
					},
					{
						"n": 6,
						"h": 164,
						"w": 181
					},
					{
						"n": 7,
						"h": 204,
						"w": 240
					},
					{
						"n": 8,
						"h": 394,
						"w": 262
					},
					{
						"n": 9,
						"h": 51,
						"w": 235
					},
					{
						"n": 10,
						"h": 121,
						"w": 416
					},
					{
						"n": 11,
						"h": 278,
						"w": 318
					}
				],
				"ball": {
					"n": 0,
					"h": 368,
					"w": 290,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 12
		},
		{
			"num": 13,
			"minute": 1,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 15
					},
					{
						"n": 2,
						"h": 63,
						"w": 335
					},
					{
						"n": 3,
						"h": 182,
						"w": 301
					},
					{
						"n": 4,
						"h": 267,
						"w": 296
					},
					{
						"n": 5,
						"h": 373,
						"w": 330
					},
					{
						"n": 6,
						"h": 54,
						"w": 461
					},
					{
						"n": 7,
						"h": 198,
						"w": 475
					},
					{
						"n": 8,
						"h": 284,
						"w": 340
					},
					{
						"n": 9,
						"h": 402,
						"w": 489
					},
					{
						"n": 10,
						"h": 179,
						"w": 596
					},
					{
						"n": 11,
						"h": 295,
						"w": 606
					}
				],
				"away": [
					{
						"n": 1,
						"h": 205,
						"w": 64
					},
					{
						"n": 2,
						"h": 75,
						"w": 104
					},
					{
						"n": 3,
						"h": 175,
						"w": 83
					},
					{
						"n": 4,
						"h": 256,
						"w": 77
					},
					{
						"n": 5,
						"h": 340,
						"w": 97
					},
					{
						"n": 6,
						"h": 199,
						"w": 161
					},
					{
						"n": 7,
						"h": 238,
						"w": 220
					},
					{
						"n": 8,
						"h": 396,
						"w": 223
					},
					{
						"n": 9,
						"h": 28,
						"w": 240
					},
					{
						"n": 10,
						"h": 93,
						"w": 387
					},
					{
						"n": 11,
						"h": 286,
						"w": 305
					}
				],
				"ball": {
					"n": 0,
					"h": 373,
					"w": 330,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 14,
			"minute": 1,
			"messages": [
				{
					"owner": 1,
					"mes": "Самуэль Кари Фридйонссон[05](Галвэй Юнайтед) пасует на Э.Бвомоно[09](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 11
					},
					{
						"n": 2,
						"h": 67,
						"w": 359
					},
					{
						"n": 3,
						"h": 183,
						"w": 309
					},
					{
						"n": 4,
						"h": 273,
						"w": 311
					},
					{
						"n": 5,
						"h": 374,
						"w": 340
					},
					{
						"n": 6,
						"h": 48,
						"w": 527
					},
					{
						"n": 7,
						"h": 213,
						"w": 534
					},
					{
						"n": 8,
						"h": 317,
						"w": 395
					},
					{
						"n": 9,
						"h": 364,
						"w": 527
					},
					{
						"n": 10,
						"h": 171,
						"w": 616
					},
					{
						"n": 11,
						"h": 291,
						"w": 626
					}
				],
				"away": [
					{
						"n": 1,
						"h": 216,
						"w": 12
					},
					{
						"n": 2,
						"h": 79,
						"w": 87
					},
					{
						"n": 3,
						"h": 174,
						"w": 78
					},
					{
						"n": 4,
						"h": 267,
						"w": 89
					},
					{
						"n": 5,
						"h": 340,
						"w": 71
					},
					{
						"n": 6,
						"h": 229,
						"w": 133
					},
					{
						"n": 7,
						"h": 209,
						"w": 206
					},
					{
						"n": 8,
						"h": 402,
						"w": 157
					},
					{
						"n": 9,
						"h": 76,
						"w": 195
					},
					{
						"n": 10,
						"h": 122,
						"w": 327
					},
					{
						"n": 11,
						"h": 293,
						"w": 297
					}
				],
				"ball": {
					"n": 0,
					"h": 364,
					"w": 527,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 66
		},
		{
			"num": 15,
			"minute": 1,
			"messages": [
				{
					"owner": 1,
					"mes": "Матей Юрасек[29](Опава) пытается отобрать мяч у Э.Бвомоно[09](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 15
					},
					{
						"n": 2,
						"h": 58,
						"w": 360
					},
					{
						"n": 3,
						"h": 184,
						"w": 313
					},
					{
						"n": 4,
						"h": 276,
						"w": 312
					},
					{
						"n": 5,
						"h": 373,
						"w": 360
					},
					{
						"n": 6,
						"h": 49,
						"w": 547
					},
					{
						"n": 7,
						"h": 218,
						"w": 553
					},
					{
						"n": 8,
						"h": 305,
						"w": 411
					},
					{
						"n": 9,
						"h": 364,
						"w": 545
					},
					{
						"n": 10,
						"h": 155,
						"w": 628
					},
					{
						"n": 11,
						"h": 288,
						"w": 638
					}
				],
				"away": [
					{
						"n": 1,
						"h": 216,
						"w": 12
					},
					{
						"n": 2,
						"h": 91,
						"w": 77
					},
					{
						"n": 3,
						"h": 177,
						"w": 59
					},
					{
						"n": 4,
						"h": 275,
						"w": 80
					},
					{
						"n": 5,
						"h": 340,
						"w": 58
					},
					{
						"n": 6,
						"h": 214,
						"w": 120
					},
					{
						"n": 7,
						"h": 201,
						"w": 188
					},
					{
						"n": 8,
						"h": 401,
						"w": 137
					},
					{
						"n": 9,
						"h": 86,
						"w": 175
					},
					{
						"n": 10,
						"h": 132,
						"w": 310
					},
					{
						"n": 11,
						"h": 291,
						"w": 301
					}
				],
				"ball": {
					"n": 0,
					"h": 364,
					"w": 545,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 20
		},
		{
			"num": 16,
			"minute": 1,
			"messages": [
				{
					"owner": 1,
					"mes": "Э.Бвомоно[09](Галвэй Юнайтед) за счет скорости пытается убежать от М.Юрасека[29](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 16
					},
					{
						"n": 2,
						"h": 60,
						"w": 368
					},
					{
						"n": 3,
						"h": 165,
						"w": 318
					},
					{
						"n": 4,
						"h": 275,
						"w": 329
					},
					{
						"n": 5,
						"h": 376,
						"w": 369
					},
					{
						"n": 6,
						"h": 45,
						"w": 567
					},
					{
						"n": 7,
						"h": 204,
						"w": 568
					},
					{
						"n": 8,
						"h": 298,
						"w": 430
					},
					{
						"n": 9,
						"h": 364,
						"w": 568
					},
					{
						"n": 10,
						"h": 169,
						"w": 637
					},
					{
						"n": 11,
						"h": 286,
						"w": 634
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 10
					},
					{
						"n": 2,
						"h": 83,
						"w": 63
					},
					{
						"n": 3,
						"h": 181,
						"w": 73
					},
					{
						"n": 4,
						"h": 271,
						"w": 60
					},
					{
						"n": 5,
						"h": 340,
						"w": 54
					},
					{
						"n": 6,
						"h": 233,
						"w": 114
					},
					{
						"n": 7,
						"h": 204,
						"w": 187
					},
					{
						"n": 8,
						"h": 405,
						"w": 117
					},
					{
						"n": 9,
						"h": 86,
						"w": 154,
						"m": 610
					},
					{
						"n": 10,
						"h": 141,
						"w": 292
					},
					{
						"n": 11,
						"h": 295,
						"w": 304
					}
				],
				"ball": {
					"n": 0,
					"h": 364,
					"w": 591,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 20
		},
		{
			"num": 17,
			"minute": 1,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 13
					},
					{
						"n": 2,
						"h": 65,
						"w": 375
					},
					{
						"n": 3,
						"h": 165,
						"w": 319
					},
					{
						"n": 4,
						"h": 270,
						"w": 316
					},
					{
						"n": 5,
						"h": 378,
						"w": 370
					},
					{
						"n": 6,
						"h": 50,
						"w": 586
					},
					{
						"n": 7,
						"h": 197,
						"w": 586
					},
					{
						"n": 8,
						"h": 299,
						"w": 450
					},
					{
						"n": 9,
						"h": 364,
						"w": 591
					},
					{
						"n": 10,
						"h": 156,
						"w": 633
					},
					{
						"n": 11,
						"h": 281,
						"w": 635
					}
				],
				"away": [
					{
						"n": 1,
						"h": 214,
						"w": 10
					},
					{
						"n": 2,
						"h": 87,
						"w": 84
					},
					{
						"n": 3,
						"h": 184,
						"w": 71
					},
					{
						"n": 4,
						"h": 278,
						"w": 74
					},
					{
						"n": 5,
						"h": 340,
						"w": 56
					},
					{
						"n": 6,
						"h": 248,
						"w": 128
					},
					{
						"n": 7,
						"h": 199,
						"w": 192
					},
					{
						"n": 8,
						"h": 400,
						"w": 98
					},
					{
						"n": 9,
						"h": 86,
						"w": 131
					},
					{
						"n": 10,
						"h": 145,
						"w": 273
					},
					{
						"n": 11,
						"h": 294,
						"w": 300
					}
				],
				"ball": {
					"n": 0,
					"h": 364,
					"w": 591,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 20
		},
		{
			"num": 18,
			"minute": 1,
			"messages": [
				{
					"owner": 1,
					"mes": "Но Матей Юрасек[29](Опава) с трудом выбивает мяч в подкате..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 17
					},
					{
						"n": 2,
						"h": 58,
						"w": 365
					},
					{
						"n": 3,
						"h": 165,
						"w": 318
					},
					{
						"n": 4,
						"h": 271,
						"w": 323
					},
					{
						"n": 5,
						"h": 384,
						"w": 367
					},
					{
						"n": 6,
						"h": 48,
						"w": 580
					},
					{
						"n": 7,
						"h": 203,
						"w": 558
					},
					{
						"n": 8,
						"h": 318,
						"w": 429
					},
					{
						"n": 9,
						"h": 364,
						"w": 591
					},
					{
						"n": 10,
						"h": 156,
						"w": 604
					},
					{
						"n": 11,
						"h": 290,
						"w": 616
					}
				],
				"away": [
					{
						"n": 1,
						"h": 214,
						"w": 10
					},
					{
						"n": 2,
						"h": 89,
						"w": 113
					},
					{
						"n": 3,
						"h": 185,
						"w": 100
					},
					{
						"n": 4,
						"h": 280,
						"w": 97
					},
					{
						"n": 5,
						"h": 340,
						"w": 85
					},
					{
						"n": 6,
						"h": 252,
						"w": 146
					},
					{
						"n": 7,
						"h": 198,
						"w": 221
					},
					{
						"n": 8,
						"h": 400,
						"w": 132
					},
					{
						"n": 9,
						"h": 95,
						"w": 113
					},
					{
						"n": 10,
						"h": 151,
						"w": 250
					},
					{
						"n": 11,
						"h": 291,
						"w": 308
					}
				],
				"ball": {
					"n": 0,
					"h": 450,
					"w": 580,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 29
		},
		{
			"num": 19,
			"minute": 1,
			"messages": [
				{
					"owner": 1,
					"mes": "Э.Бвомоно[09](Галвэй Юнайтед) бросает из-за боковой..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 238,
						"w": 40
					},
					{
						"n": 2,
						"h": 46,
						"w": 278
					},
					{
						"n": 3,
						"h": 161,
						"w": 275
					},
					{
						"n": 4,
						"h": 334,
						"w": 278
					},
					{
						"n": 5,
						"h": 392,
						"w": 494
					},
					{
						"n": 6,
						"h": 71,
						"w": 456
					},
					{
						"n": 7,
						"h": 163,
						"w": 447
					},
					{
						"n": 8,
						"h": 345,
						"w": 492
					},
					{
						"n": 9,
						"h": 450,
						"w": 580
					},
					{
						"n": 10,
						"h": 159,
						"w": 621
					},
					{
						"n": 11,
						"h": 375,
						"w": 623
					}
				],
				"away": [
					{
						"n": 1,
						"h": 212,
						"w": 8
					},
					{
						"n": 2,
						"h": 76,
						"w": 74
					},
					{
						"n": 3,
						"h": 106,
						"w": 60
					},
					{
						"n": 4,
						"h": 203,
						"w": 70
					},
					{
						"n": 5,
						"h": 291,
						"w": 79
					},
					{
						"n": 6,
						"h": 283,
						"w": 102
					},
					{
						"n": 7,
						"h": 211,
						"w": 186
					},
					{
						"n": 8,
						"h": 379,
						"w": 228
					},
					{
						"n": 9,
						"h": 60,
						"w": 189
					},
					{
						"n": 10,
						"h": 107,
						"w": 206
					},
					{
						"n": 11,
						"h": 293,
						"w": 303
					}
				],
				"ball": {
					"n": 0,
					"h": 450,
					"w": 580,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 102
		},
		{
			"num": 20,
			"minute": 1,
			"messages": [
				{
					"owner": 1,
					"mes": "Самуэль Кари Фридйонссон[05](Галвэй Юнайтед) достает мяч..."
				}
			],
			"A": {
				"team": 1
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 15
					},
					{
						"n": 2,
						"h": 52,
						"w": 322
					},
					{
						"n": 3,
						"h": 173,
						"w": 317
					},
					{
						"n": 4,
						"h": 294,
						"w": 297
					},
					{
						"n": 5,
						"h": 384,
						"w": 466
					},
					{
						"n": 6,
						"h": 62,
						"w": 499
					},
					{
						"n": 7,
						"h": 191,
						"w": 481
					},
					{
						"n": 8,
						"h": 318,
						"w": 527
					},
					{
						"n": 9,
						"h": 450,
						"w": 580
					},
					{
						"n": 10,
						"h": 155,
						"w": 631
					},
					{
						"n": 11,
						"h": 331,
						"w": 627
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 11
					},
					{
						"n": 2,
						"h": 51,
						"w": 110
					},
					{
						"n": 3,
						"h": 131,
						"w": 67
					},
					{
						"n": 4,
						"h": 205,
						"w": 78
					},
					{
						"n": 5,
						"h": 279,
						"w": 78
					},
					{
						"n": 6,
						"h": 241,
						"w": 115
					},
					{
						"n": 7,
						"h": 204,
						"w": 180
					},
					{
						"n": 8,
						"h": 388,
						"w": 185
					},
					{
						"n": 9,
						"h": 31,
						"w": 220
					},
					{
						"n": 10,
						"h": 79,
						"w": 239
					},
					{
						"n": 11,
						"h": 286,
						"w": 290
					}
				],
				"ball": {
					"n": 0,
					"h": 384,
					"w": 466,
					"z": 1,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 44
		},
		{
			"num": 21,
			"minute": 1,
			"messages": [
				{
					"owner": 1,
					"mes": "Пас в центр на К.Нолана[08](Галвэй Юнайтед)..."
				},
				{
					"owner": 1,
					"mes": "Киран Нолан[08](Галвэй Юнайтед) технично принимает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 13
					},
					{
						"n": 2,
						"h": 67,
						"w": 353
					},
					{
						"n": 3,
						"h": 172,
						"w": 316
					},
					{
						"n": 4,
						"h": 270,
						"w": 322
					},
					{
						"n": 5,
						"h": 383,
						"w": 456
					},
					{
						"n": 6,
						"h": 57,
						"w": 534
					},
					{
						"n": 7,
						"h": 170,
						"w": 453
					},
					{
						"n": 8,
						"h": 291,
						"w": 513
					},
					{
						"n": 9,
						"h": 418,
						"w": 593
					},
					{
						"n": 10,
						"h": 179,
						"w": 625
					},
					{
						"n": 11,
						"h": 296,
						"w": 629
					}
				],
				"away": [
					{
						"n": 1,
						"h": 226,
						"w": 11
					},
					{
						"n": 2,
						"h": 57,
						"w": 107
					},
					{
						"n": 3,
						"h": 152,
						"w": 71
					},
					{
						"n": 4,
						"h": 178,
						"w": 80
					},
					{
						"n": 5,
						"h": 262,
						"w": 57
					},
					{
						"n": 6,
						"h": 225,
						"w": 145
					},
					{
						"n": 7,
						"h": 169,
						"w": 184
					},
					{
						"n": 8,
						"h": 393,
						"w": 150
					},
					{
						"n": 9,
						"h": 35,
						"w": 185
					},
					{
						"n": 10,
						"h": 106,
						"w": 262
					},
					{
						"n": 11,
						"h": 281,
						"w": 255
					}
				],
				"ball": {
					"n": 0,
					"h": 291,
					"w": 513,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 35
		},
		{
			"num": 22,
			"minute": 1,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 10
					},
					{
						"n": 2,
						"h": 78,
						"w": 376
					},
					{
						"n": 3,
						"h": 167,
						"w": 325
					},
					{
						"n": 4,
						"h": 275,
						"w": 320
					},
					{
						"n": 5,
						"h": 386,
						"w": 421
					},
					{
						"n": 6,
						"h": 59,
						"w": 569
					},
					{
						"n": 7,
						"h": 164,
						"w": 442
					},
					{
						"n": 8,
						"h": 311,
						"w": 548
					},
					{
						"n": 9,
						"h": 391,
						"w": 609
					},
					{
						"n": 10,
						"h": 180,
						"w": 637
					},
					{
						"n": 11,
						"h": 288,
						"w": 628
					}
				],
				"away": [
					{
						"n": 1,
						"h": 218,
						"w": 13
					},
					{
						"n": 2,
						"h": 65,
						"w": 99
					},
					{
						"n": 3,
						"h": 146,
						"w": 73
					},
					{
						"n": 4,
						"h": 172,
						"w": 61
					},
					{
						"n": 5,
						"h": 261,
						"w": 77
					},
					{
						"n": 6,
						"h": 192,
						"w": 134
					},
					{
						"n": 7,
						"h": 142,
						"w": 156
					},
					{
						"n": 8,
						"h": 391,
						"w": 115
					},
					{
						"n": 9,
						"h": 36,
						"w": 213
					},
					{
						"n": 10,
						"h": 136,
						"w": 278
					},
					{
						"n": 11,
						"h": 286,
						"w": 258
					}
				],
				"ball": {
					"n": 0,
					"h": 311,
					"w": 548,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 35
		},
		{
			"num": 23,
			"minute": 1,
			"messages": [
				{
					"owner": 1,
					"mes": "Пасует вперед..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 13
					},
					{
						"n": 2,
						"h": 77,
						"w": 378
					},
					{
						"n": 3,
						"h": 166,
						"w": 311
					},
					{
						"n": 4,
						"h": 268,
						"w": 325
					},
					{
						"n": 5,
						"h": 388,
						"w": 393
					},
					{
						"n": 6,
						"h": 54,
						"w": 596
					},
					{
						"n": 7,
						"h": 161,
						"w": 470
					},
					{
						"n": 8,
						"h": 307,
						"w": 556,
						"m": 610
					},
					{
						"n": 9,
						"h": 386,
						"w": 628
					},
					{
						"n": 10,
						"h": 161,
						"w": 636
					},
					{
						"n": 11,
						"h": 312,
						"w": 621
					}
				],
				"away": [
					{
						"n": 1,
						"h": 216,
						"w": 12
					},
					{
						"n": 2,
						"h": 72,
						"w": 72
					},
					{
						"n": 3,
						"h": 173,
						"w": 69
					},
					{
						"n": 4,
						"h": 200,
						"w": 60
					},
					{
						"n": 5,
						"h": 274,
						"w": 69
					},
					{
						"n": 6,
						"h": 174,
						"w": 112
					},
					{
						"n": 7,
						"h": 139,
						"w": 151
					},
					{
						"n": 8,
						"h": 409,
						"w": 137
					},
					{
						"n": 9,
						"h": 28,
						"w": 214
					},
					{
						"n": 10,
						"h": 157,
						"w": 298
					},
					{
						"n": 11,
						"h": 289,
						"w": 230
					}
				],
				"ball": {
					"n": 0,
					"h": 334,
					"w": 598,
					"z": 0,
					"r": 0,
					"p": 1,
					"x": 0
				}
			},
			"interval": 28
		},
		{
			"num": 24,
			"minute": 1,
			"messages": [
				{
					"owner": 1,
					"mes": "Адам Гилберт[11](Галвэй Юнайтед) технично принимает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 12
					},
					{
						"n": 2,
						"h": 64,
						"w": 371
					},
					{
						"n": 3,
						"h": 166,
						"w": 325
					},
					{
						"n": 4,
						"h": 284,
						"w": 319
					},
					{
						"n": 5,
						"h": 379,
						"w": 373
					},
					{
						"n": 6,
						"h": 54,
						"w": 618
					},
					{
						"n": 7,
						"h": 163,
						"w": 448
					},
					{
						"n": 8,
						"h": 290,
						"w": 569
					},
					{
						"n": 9,
						"h": 396,
						"w": 618
					},
					{
						"n": 10,
						"h": 163,
						"w": 633
					},
					{
						"n": 11,
						"h": 340,
						"w": 612
					}
				],
				"away": [
					{
						"n": 1,
						"h": 214,
						"w": 10
					},
					{
						"n": 2,
						"h": 91,
						"w": 90
					},
					{
						"n": 3,
						"h": 176,
						"w": 57
					},
					{
						"n": 4,
						"h": 217,
						"w": 74
					},
					{
						"n": 5,
						"h": 272,
						"w": 75
					},
					{
						"n": 6,
						"h": 159,
						"w": 129
					},
					{
						"n": 7,
						"h": 128,
						"w": 137
					},
					{
						"n": 8,
						"h": 399,
						"w": 117
					},
					{
						"n": 9,
						"h": 50,
						"w": 217
					},
					{
						"n": 10,
						"h": 175,
						"w": 291
					},
					{
						"n": 11,
						"h": 287,
						"w": 252
					}
				],
				"ball": {
					"n": 0,
					"h": 340,
					"w": 612,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 22
		},
		{
			"num": 25,
			"minute": 1,
			"messages": [
				{
					"owner": 1,
					"mes": "Адам Гилберт[11](Галвэй Юнайтед) врывается в штрафную..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 17
					},
					{
						"n": 2,
						"h": 71,
						"w": 377
					},
					{
						"n": 3,
						"h": 180,
						"w": 310
					},
					{
						"n": 4,
						"h": 279,
						"w": 320
					},
					{
						"n": 5,
						"h": 387,
						"w": 367
					},
					{
						"n": 6,
						"h": 60,
						"w": 636
					},
					{
						"n": 7,
						"h": 158,
						"w": 445
					},
					{
						"n": 8,
						"h": 273,
						"w": 606
					},
					{
						"n": 9,
						"h": 405,
						"w": 636
					},
					{
						"n": 10,
						"h": 169,
						"w": 666
					},
					{
						"n": 11,
						"h": 320,
						"w": 647
					}
				],
				"away": [
					{
						"n": 1,
						"h": 213,
						"w": 9
					},
					{
						"n": 2,
						"h": 118,
						"w": 65
					},
					{
						"n": 3,
						"h": 138,
						"w": 70
					},
					{
						"n": 4,
						"h": 259,
						"w": 52
					},
					{
						"n": 5,
						"h": 315,
						"w": 56
					},
					{
						"n": 6,
						"h": 144,
						"w": 82
					},
					{
						"n": 7,
						"h": 164,
						"w": 119
					},
					{
						"n": 8,
						"h": 417,
						"w": 135
					},
					{
						"n": 9,
						"h": 23,
						"w": 187
					},
					{
						"n": 10,
						"h": 175,
						"w": 307
					},
					{
						"n": 11,
						"h": 292,
						"w": 255
					}
				],
				"ball": {
					"n": 0,
					"h": 320,
					"w": 647,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 26,
			"minute": 1,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 12
					},
					{
						"n": 2,
						"h": 62,
						"w": 372
					},
					{
						"n": 3,
						"h": 171,
						"w": 315
					},
					{
						"n": 4,
						"h": 269,
						"w": 322
					},
					{
						"n": 5,
						"h": 377,
						"w": 370
					},
					{
						"n": 6,
						"h": 62,
						"w": 640
					},
					{
						"n": 7,
						"h": 152,
						"w": 440
					},
					{
						"n": 8,
						"h": 265,
						"w": 611
					},
					{
						"n": 9,
						"h": 396,
						"w": 641
					},
					{
						"n": 10,
						"h": 160,
						"w": 670
					},
					{
						"n": 11,
						"h": 320,
						"w": 655
					}
				],
				"away": [
					{
						"n": 1,
						"h": 213,
						"w": 8
					},
					{
						"n": 2,
						"h": 128,
						"w": 65
					},
					{
						"n": 3,
						"h": 130,
						"w": 65
					},
					{
						"n": 4,
						"h": 249,
						"w": 51
					},
					{
						"n": 5,
						"h": 305,
						"w": 53
					},
					{
						"n": 6,
						"h": 139,
						"w": 78
					},
					{
						"n": 7,
						"h": 173,
						"w": 115
					},
					{
						"n": 8,
						"h": 412,
						"w": 127
					},
					{
						"n": 9,
						"h": 17,
						"w": 190
					},
					{
						"n": 10,
						"h": 167,
						"w": 301
					},
					{
						"n": 11,
						"h": 298,
						"w": 260
					}
				],
				"ball": {
					"n": 0,
					"h": 320,
					"w": 655,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 10
		},
		{
			"num": 27,
			"minute": 1,
			"messages": [
				{
					"owner": 1,
					"mes": "А.Гилберт[11](Галвэй Юнайтед) пытается переиграть Н.Мансура[23](Опава)..."
				},
				{
					"owner": 1,
					"mes": "Адам Гилберт[11](Галвэй Юнайтед) теряет мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 12
					},
					{
						"n": 2,
						"h": 58,
						"w": 370
					},
					{
						"n": 3,
						"h": 166,
						"w": 318
					},
					{
						"n": 4,
						"h": 266,
						"w": 322
					},
					{
						"n": 5,
						"h": 372,
						"w": 371
					},
					{
						"n": 6,
						"h": 62,
						"w": 640
					},
					{
						"n": 7,
						"h": 152,
						"w": 440
					},
					{
						"n": 8,
						"h": 256,
						"w": 617
					},
					{
						"n": 9,
						"h": 388,
						"w": 646
					},
					{
						"n": 10,
						"h": 160,
						"w": 670
					},
					{
						"n": 11,
						"h": 320,
						"w": 665
					}
				],
				"away": [
					{
						"n": 1,
						"h": 213,
						"w": 8
					},
					{
						"n": 2,
						"h": 130,
						"w": 65
					},
					{
						"n": 3,
						"h": 121,
						"w": 59,
						"m": 610
					},
					{
						"n": 4,
						"h": 240,
						"w": 50
					},
					{
						"n": 5,
						"h": 295,
						"w": 51
					},
					{
						"n": 6,
						"h": 130,
						"w": 70
					},
					{
						"n": 7,
						"h": 182,
						"w": 110
					},
					{
						"n": 8,
						"h": 407,
						"w": 118
					},
					{
						"n": 9,
						"h": 17,
						"w": 190
					},
					{
						"n": 10,
						"h": 162,
						"w": 297
					},
					{
						"n": 11,
						"h": 298,
						"w": 260
					}
				],
				"ball": {
					"n": 0,
					"h": 329,
					"w": 661,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 4
				}
			},
			"interval": 10
		},
		{
			"num": 28,
			"minute": 1,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 12
					},
					{
						"n": 2,
						"h": 82,
						"w": 338
					},
					{
						"n": 3,
						"h": 200,
						"w": 317
					},
					{
						"n": 4,
						"h": 274,
						"w": 318
					},
					{
						"n": 5,
						"h": 364,
						"w": 332
					},
					{
						"n": 6,
						"h": 59,
						"w": 600
					},
					{
						"n": 7,
						"h": 181,
						"w": 413
					},
					{
						"n": 8,
						"h": 256,
						"w": 577
					},
					{
						"n": 9,
						"h": 392,
						"w": 606
					},
					{
						"n": 10,
						"h": 169,
						"w": 631
					},
					{
						"n": 11,
						"h": 317,
						"w": 656
					}
				],
				"away": [
					{
						"n": 1,
						"h": 223,
						"w": 13
					},
					{
						"n": 2,
						"h": 108,
						"w": 98
					},
					{
						"n": 3,
						"h": 146,
						"w": 84
					},
					{
						"n": 4,
						"h": 254,
						"w": 64
					},
					{
						"n": 5,
						"h": 328,
						"w": 75
					},
					{
						"n": 6,
						"h": 147,
						"w": 106
					},
					{
						"n": 7,
						"h": 202,
						"w": 144
					},
					{
						"n": 8,
						"h": 408,
						"w": 158
					},
					{
						"n": 9,
						"h": 51,
						"w": 212
					},
					{
						"n": 10,
						"h": 160,
						"w": 337
					},
					{
						"n": 11,
						"h": 261,
						"w": 275
					}
				],
				"ball": {
					"n": 0,
					"h": 304,
					"w": 636,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 29,
			"minute": 1,
			"messages": [
				{
					"owner": 2,
					"mes": "Нир Мансур[23](Опава) пасует вперед на О.Дюмона[26](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 13
					},
					{
						"n": 2,
						"h": 88,
						"w": 329
					},
					{
						"n": 3,
						"h": 199,
						"w": 306
					},
					{
						"n": 4,
						"h": 264,
						"w": 312
					},
					{
						"n": 5,
						"h": 354,
						"w": 327
					},
					{
						"n": 6,
						"h": 58,
						"w": 589
					},
					{
						"n": 7,
						"h": 182,
						"w": 402
					},
					{
						"n": 8,
						"h": 257,
						"w": 566
					},
					{
						"n": 9,
						"h": 392,
						"w": 595
					},
					{
						"n": 10,
						"h": 170,
						"w": 620
					},
					{
						"n": 11,
						"h": 313,
						"w": 645
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 12
					},
					{
						"n": 2,
						"h": 101,
						"w": 107
					},
					{
						"n": 3,
						"h": 146,
						"w": 84
					},
					{
						"n": 4,
						"h": 260,
						"w": 73
					},
					{
						"n": 5,
						"h": 336,
						"w": 82
					},
					{
						"n": 6,
						"h": 147,
						"w": 106
					},
					{
						"n": 7,
						"h": 208,
						"w": 153
					},
					{
						"n": 8,
						"h": 408,
						"w": 169
					},
					{
						"n": 9,
						"h": 59,
						"w": 219
					},
					{
						"n": 10,
						"h": 157,
						"w": 347
					},
					{
						"n": 11,
						"h": 252,
						"w": 281
					}
				],
				"ball": {
					"n": 0,
					"h": 303,
					"w": 614,
					"z": 0,
					"r": 0,
					"p": 1,
					"x": 0
				}
			},
			"interval": 11
		},
		{
			"num": 30,
			"minute": 1,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 12
					},
					{
						"n": 2,
						"h": 111,
						"w": 296
					},
					{
						"n": 3,
						"h": 235,
						"w": 287
					},
					{
						"n": 4,
						"h": 283,
						"w": 284
					},
					{
						"n": 5,
						"h": 332,
						"w": 293
					},
					{
						"n": 6,
						"h": 59,
						"w": 549
					},
					{
						"n": 7,
						"h": 212,
						"w": 375
					},
					{
						"n": 8,
						"h": 297,
						"w": 561
					},
					{
						"n": 9,
						"h": 393,
						"w": 555
					},
					{
						"n": 10,
						"h": 174,
						"w": 580
					},
					{
						"n": 11,
						"h": 312,
						"w": 605
					}
				],
				"away": [
					{
						"n": 1,
						"h": 221,
						"w": 13
					},
					{
						"n": 2,
						"h": 78,
						"w": 140
					},
					{
						"n": 3,
						"h": 174,
						"w": 99
					},
					{
						"n": 4,
						"h": 265,
						"w": 93
					},
					{
						"n": 5,
						"h": 370,
						"w": 102
					},
					{
						"n": 6,
						"h": 144,
						"w": 141
					},
					{
						"n": 7,
						"h": 216,
						"w": 192
					},
					{
						"n": 8,
						"h": 409,
						"w": 209
					},
					{
						"n": 9,
						"h": 91,
						"w": 243
					},
					{
						"n": 10,
						"h": 150,
						"w": 387
					},
					{
						"n": 11,
						"h": 215,
						"w": 297
					}
				],
				"ball": {
					"n": 0,
					"h": 306,
					"w": 579,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 31,
			"minute": 1,
			"messages": [
				{
					"owner": 2,
					"mes": "Передача вперед..."
				},
				{
					"owner": 2,
					"mes": "Матей Юрасек[29](Опава) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 15
					},
					{
						"n": 2,
						"h": 118,
						"w": 268
					},
					{
						"n": 3,
						"h": 241,
						"w": 270
					},
					{
						"n": 4,
						"h": 284,
						"w": 264
					},
					{
						"n": 5,
						"h": 348,
						"w": 269
					},
					{
						"n": 6,
						"h": 56,
						"w": 520
					},
					{
						"n": 7,
						"h": 204,
						"w": 347
					},
					{
						"n": 8,
						"h": 294,
						"w": 532
					},
					{
						"n": 9,
						"h": 393,
						"w": 526
					},
					{
						"n": 10,
						"h": 177,
						"w": 551
					},
					{
						"n": 11,
						"h": 309,
						"w": 577
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 17
					},
					{
						"n": 2,
						"h": 76,
						"w": 152
					},
					{
						"n": 3,
						"h": 180,
						"w": 108
					},
					{
						"n": 4,
						"h": 262,
						"w": 122
					},
					{
						"n": 5,
						"h": 384,
						"w": 128
					},
					{
						"n": 6,
						"h": 152,
						"w": 148
					},
					{
						"n": 7,
						"h": 218,
						"w": 221
					},
					{
						"n": 8,
						"h": 407,
						"w": 238
					},
					{
						"n": 9,
						"h": 103,
						"w": 218
					},
					{
						"n": 10,
						"h": 147,
						"w": 416
					},
					{
						"n": 11,
						"h": 190,
						"w": 311
					}
				],
				"ball": {
					"n": 0,
					"h": 347,
					"w": 502,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 29
		},
		{
			"num": 32,
			"minute": 1,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 10
					},
					{
						"n": 2,
						"h": 120,
						"w": 270
					},
					{
						"n": 3,
						"h": 215,
						"w": 270
					},
					{
						"n": 4,
						"h": 296,
						"w": 256
					},
					{
						"n": 5,
						"h": 330,
						"w": 258
					},
					{
						"n": 6,
						"h": 56,
						"w": 480
					},
					{
						"n": 7,
						"h": 197,
						"w": 354
					},
					{
						"n": 8,
						"h": 294,
						"w": 492
					},
					{
						"n": 9,
						"h": 398,
						"w": 486
					},
					{
						"n": 10,
						"h": 162,
						"w": 515
					},
					{
						"n": 11,
						"h": 313,
						"w": 537
					}
				],
				"away": [
					{
						"n": 1,
						"h": 221,
						"w": 11
					},
					{
						"n": 2,
						"h": 59,
						"w": 158
					},
					{
						"n": 3,
						"h": 181,
						"w": 110
					},
					{
						"n": 4,
						"h": 281,
						"w": 116
					},
					{
						"n": 5,
						"h": 392,
						"w": 106
					},
					{
						"n": 6,
						"h": 174,
						"w": 181
					},
					{
						"n": 7,
						"h": 196,
						"w": 255
					},
					{
						"n": 8,
						"h": 406,
						"w": 278
					},
					{
						"n": 9,
						"h": 100,
						"w": 253
					},
					{
						"n": 10,
						"h": 155,
						"w": 418
					},
					{
						"n": 11,
						"h": 159,
						"w": 336
					}
				],
				"ball": {
					"n": 0,
					"h": 350,
					"w": 467,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 33,
			"minute": 1,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 10
					},
					{
						"n": 2,
						"h": 120,
						"w": 246
					},
					{
						"n": 3,
						"h": 217,
						"w": 264
					},
					{
						"n": 4,
						"h": 302,
						"w": 260
					},
					{
						"n": 5,
						"h": 345,
						"w": 286
					},
					{
						"n": 6,
						"h": 55,
						"w": 440
					},
					{
						"n": 7,
						"h": 207,
						"w": 324
					},
					{
						"n": 8,
						"h": 290,
						"w": 452
					},
					{
						"n": 9,
						"h": 403,
						"w": 447
					},
					{
						"n": 10,
						"h": 173,
						"w": 476
					},
					{
						"n": 11,
						"h": 300,
						"w": 499
					}
				],
				"away": [
					{
						"n": 1,
						"h": 229,
						"w": 12
					},
					{
						"n": 2,
						"h": 74,
						"w": 176
					},
					{
						"n": 3,
						"h": 167,
						"w": 130
					},
					{
						"n": 4,
						"h": 267,
						"w": 128
					},
					{
						"n": 5,
						"h": 385,
						"w": 124
					},
					{
						"n": 6,
						"h": 190,
						"w": 211
					},
					{
						"n": 7,
						"h": 212,
						"w": 283
					},
					{
						"n": 8,
						"h": 409,
						"w": 318
					},
					{
						"n": 9,
						"h": 100,
						"w": 288
					},
					{
						"n": 10,
						"h": 153,
						"w": 434
					},
					{
						"n": 11,
						"h": 140,
						"w": 358
					}
				],
				"ball": {
					"n": 0,
					"h": 350,
					"w": 432,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 34,
			"minute": 2,
			"possession": 76,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 19,
						"f": 99
					},
					{
						"n": 2,
						"h": 120,
						"w": 236,
						"f": 99
					},
					{
						"n": 3,
						"h": 217,
						"w": 244,
						"f": 99
					},
					{
						"n": 4,
						"h": 292,
						"w": 252,
						"f": 99
					},
					{
						"n": 5,
						"h": 345,
						"w": 276,
						"f": 99
					},
					{
						"n": 6,
						"h": 56,
						"w": 400,
						"f": 99
					},
					{
						"n": 7,
						"h": 223,
						"w": 316,
						"f": 99
					},
					{
						"n": 8,
						"h": 288,
						"w": 412,
						"f": 99
					},
					{
						"n": 9,
						"h": 410,
						"w": 407,
						"f": 99
					},
					{
						"n": 10,
						"h": 164,
						"w": 437,
						"f": 99
					},
					{
						"n": 11,
						"h": 303,
						"w": 459,
						"f": 99
					}
				],
				"away": [
					{
						"n": 1,
						"h": 221,
						"w": 13,
						"f": 97
					},
					{
						"n": 2,
						"h": 75,
						"w": 180,
						"f": 96
					},
					{
						"n": 3,
						"h": 171,
						"w": 122,
						"f": 96
					},
					{
						"n": 4,
						"h": 286,
						"w": 124,
						"f": 97
					},
					{
						"n": 5,
						"h": 394,
						"w": 136,
						"f": 98
					},
					{
						"n": 6,
						"h": 207,
						"w": 247,
						"f": 98
					},
					{
						"n": 7,
						"h": 187,
						"w": 314,
						"f": 99
					},
					{
						"n": 8,
						"h": 406,
						"w": 358,
						"f": 97
					},
					{
						"n": 9,
						"h": 100,
						"w": 324,
						"f": 98
					},
					{
						"n": 10,
						"h": 159,
						"w": 458,
						"f": 98
					},
					{
						"n": 11,
						"h": 140,
						"w": 385,
						"f": 98
					}
				],
				"ball": {
					"n": 0,
					"h": 350,
					"w": 396,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 35,
			"minute": 2,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 19
					},
					{
						"n": 2,
						"h": 120,
						"w": 224
					},
					{
						"n": 3,
						"h": 223,
						"w": 210
					},
					{
						"n": 4,
						"h": 278,
						"w": 218
					},
					{
						"n": 5,
						"h": 344,
						"w": 246
					},
					{
						"n": 6,
						"h": 56,
						"w": 360
					},
					{
						"n": 7,
						"h": 202,
						"w": 304
					},
					{
						"n": 8,
						"h": 283,
						"w": 373
					},
					{
						"n": 9,
						"h": 407,
						"w": 367
					},
					{
						"n": 10,
						"h": 168,
						"w": 400
					},
					{
						"n": 11,
						"h": 311,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 35
					},
					{
						"n": 2,
						"h": 57,
						"w": 215
					},
					{
						"n": 3,
						"h": 173,
						"w": 150
					},
					{
						"n": 4,
						"h": 282,
						"w": 164
					},
					{
						"n": 5,
						"h": 393,
						"w": 168
					},
					{
						"n": 6,
						"h": 170,
						"w": 244
					},
					{
						"n": 7,
						"h": 209,
						"w": 337
					},
					{
						"n": 8,
						"h": 410,
						"w": 397
					},
					{
						"n": 9,
						"h": 100,
						"w": 359
					},
					{
						"n": 10,
						"h": 173,
						"w": 478
					},
					{
						"n": 11,
						"h": 170,
						"w": 393
					}
				],
				"ball": {
					"n": 0,
					"h": 350,
					"w": 361,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 36,
			"minute": 2,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 15
					},
					{
						"n": 2,
						"h": 120,
						"w": 200
					},
					{
						"n": 3,
						"h": 222,
						"w": 188
					},
					{
						"n": 4,
						"h": 286,
						"w": 198
					},
					{
						"n": 5,
						"h": 344,
						"w": 220
					},
					{
						"n": 6,
						"h": 56,
						"w": 320
					},
					{
						"n": 7,
						"h": 217,
						"w": 274
					},
					{
						"n": 8,
						"h": 281,
						"w": 333
					},
					{
						"n": 9,
						"h": 412,
						"w": 328
					},
					{
						"n": 10,
						"h": 171,
						"w": 400
					},
					{
						"n": 11,
						"h": 273,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 56
					},
					{
						"n": 2,
						"h": 59,
						"w": 242
					},
					{
						"n": 3,
						"h": 177,
						"w": 188
					},
					{
						"n": 4,
						"h": 279,
						"w": 182
					},
					{
						"n": 5,
						"h": 388,
						"w": 207
					},
					{
						"n": 6,
						"h": 200,
						"w": 271
					},
					{
						"n": 7,
						"h": 186,
						"w": 370
					},
					{
						"n": 8,
						"h": 411,
						"w": 437
					},
					{
						"n": 9,
						"h": 100,
						"w": 394
					},
					{
						"n": 10,
						"h": 167,
						"w": 500
					},
					{
						"n": 11,
						"h": 170,
						"w": 433
					}
				],
				"ball": {
					"n": 0,
					"h": 350,
					"w": 326,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 37,
			"minute": 2,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 19
					},
					{
						"n": 2,
						"h": 120,
						"w": 172
					},
					{
						"n": 3,
						"h": 220,
						"w": 174
					},
					{
						"n": 4,
						"h": 292,
						"w": 160
					},
					{
						"n": 5,
						"h": 337,
						"w": 260
					},
					{
						"n": 6,
						"h": 56,
						"w": 280
					},
					{
						"n": 7,
						"h": 205,
						"w": 242
					},
					{
						"n": 8,
						"h": 285,
						"w": 293
					},
					{
						"n": 9,
						"h": 409,
						"w": 288
					},
					{
						"n": 10,
						"h": 175,
						"w": 400
					},
					{
						"n": 11,
						"h": 313,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 223,
						"w": 79
					},
					{
						"n": 2,
						"h": 75,
						"w": 252
					},
					{
						"n": 3,
						"h": 169,
						"w": 200
					},
					{
						"n": 4,
						"h": 275,
						"w": 220
					},
					{
						"n": 5,
						"h": 379,
						"w": 218
					},
					{
						"n": 6,
						"h": 215,
						"w": 308
					},
					{
						"n": 7,
						"h": 223,
						"w": 383
					},
					{
						"n": 8,
						"h": 415,
						"w": 477
					},
					{
						"n": 9,
						"h": 108,
						"w": 428
					},
					{
						"n": 10,
						"h": 158,
						"w": 532
					},
					{
						"n": 11,
						"h": 177,
						"w": 447
					}
				],
				"ball": {
					"n": 0,
					"h": 342,
					"w": 292,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 38,
			"minute": 2,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 14
					},
					{
						"n": 2,
						"h": 120,
						"w": 148
					},
					{
						"n": 3,
						"h": 249,
						"w": 146
					},
					{
						"n": 4,
						"h": 307,
						"w": 142
					},
					{
						"n": 5,
						"h": 323,
						"w": 241
					},
					{
						"n": 6,
						"h": 56,
						"w": 240
					},
					{
						"n": 7,
						"h": 194,
						"w": 216
					},
					{
						"n": 8,
						"h": 310,
						"w": 262
					},
					{
						"n": 9,
						"h": 401,
						"w": 269
					},
					{
						"n": 10,
						"h": 165,
						"w": 400
					},
					{
						"n": 11,
						"h": 311,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 228,
						"w": 104
					},
					{
						"n": 2,
						"h": 74,
						"w": 276
					},
					{
						"n": 3,
						"h": 171,
						"w": 234
					},
					{
						"n": 4,
						"h": 285,
						"w": 232
					},
					{
						"n": 5,
						"h": 392,
						"w": 240
					},
					{
						"n": 6,
						"h": 231,
						"w": 332
					},
					{
						"n": 7,
						"h": 230,
						"w": 423
					},
					{
						"n": 8,
						"h": 406,
						"w": 516
					},
					{
						"n": 9,
						"h": 125,
						"w": 459
					},
					{
						"n": 10,
						"h": 168,
						"w": 552
					},
					{
						"n": 11,
						"h": 175,
						"w": 487
					}
				],
				"ball": {
					"n": 0,
					"h": 325,
					"w": 261,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 39,
			"minute": 2,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 15
					},
					{
						"n": 2,
						"h": 120,
						"w": 108
					},
					{
						"n": 3,
						"h": 230,
						"w": 111
					},
					{
						"n": 4,
						"h": 302,
						"w": 103
					},
					{
						"n": 5,
						"h": 330,
						"w": 218
					},
					{
						"n": 6,
						"h": 53,
						"w": 220
					},
					{
						"n": 7,
						"h": 215,
						"w": 181
					},
					{
						"n": 8,
						"h": 338,
						"w": 243
					},
					{
						"n": 9,
						"h": 410,
						"w": 231
					},
					{
						"n": 10,
						"h": 173,
						"w": 398
					},
					{
						"n": 11,
						"h": 319,
						"w": 411
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 120
					},
					{
						"n": 2,
						"h": 67,
						"w": 316
					},
					{
						"n": 3,
						"h": 167,
						"w": 273
					},
					{
						"n": 4,
						"h": 277,
						"w": 271
					},
					{
						"n": 5,
						"h": 387,
						"w": 279
					},
					{
						"n": 6,
						"h": 226,
						"w": 372
					},
					{
						"n": 7,
						"h": 226,
						"w": 463
					},
					{
						"n": 8,
						"h": 426,
						"w": 550
					},
					{
						"n": 9,
						"h": 112,
						"w": 482
					},
					{
						"n": 10,
						"h": 152,
						"w": 588
					},
					{
						"n": 11,
						"h": 160,
						"w": 524
					}
				],
				"ball": {
					"n": 0,
					"h": 338,
					"w": 238,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 40,
			"minute": 2,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 17
					},
					{
						"n": 2,
						"h": 120,
						"w": 69
					},
					{
						"n": 3,
						"h": 222,
						"w": 72
					},
					{
						"n": 4,
						"h": 295,
						"w": 69
					},
					{
						"n": 5,
						"h": 362,
						"w": 206
					},
					{
						"n": 6,
						"h": 46,
						"w": 181
					},
					{
						"n": 7,
						"h": 222,
						"w": 152
					},
					{
						"n": 8,
						"h": 371,
						"w": 231
					},
					{
						"n": 9,
						"h": 373,
						"w": 216
					},
					{
						"n": 10,
						"h": 180,
						"w": 390
					},
					{
						"n": 11,
						"h": 314,
						"w": 400
					}
				],
				"away": [
					{
						"n": 1,
						"h": 228,
						"w": 118
					},
					{
						"n": 2,
						"h": 64,
						"w": 350
					},
					{
						"n": 3,
						"h": 180,
						"w": 299
					},
					{
						"n": 4,
						"h": 270,
						"w": 295
					},
					{
						"n": 5,
						"h": 392,
						"w": 319
					},
					{
						"n": 6,
						"h": 233,
						"w": 411
					},
					{
						"n": 7,
						"h": 228,
						"w": 500
					},
					{
						"n": 8,
						"h": 421,
						"w": 590
					},
					{
						"n": 9,
						"h": 79,
						"w": 494
					},
					{
						"n": 10,
						"h": 160,
						"w": 627
					},
					{
						"n": 11,
						"h": 158,
						"w": 564
					}
				],
				"ball": {
					"n": 0,
					"h": 371,
					"w": 226,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 41,
			"minute": 2,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 17
					},
					{
						"n": 2,
						"h": 120,
						"w": 75
					},
					{
						"n": 3,
						"h": 223,
						"w": 86
					},
					{
						"n": 4,
						"h": 286,
						"w": 80
					},
					{
						"n": 5,
						"h": 363,
						"w": 192
					},
					{
						"n": 6,
						"h": 48,
						"w": 167
					},
					{
						"n": 7,
						"h": 220,
						"w": 166
					},
					{
						"n": 8,
						"h": 357,
						"w": 228
					},
					{
						"n": 9,
						"h": 360,
						"w": 219
					},
					{
						"n": 10,
						"h": 180,
						"w": 390
					},
					{
						"n": 11,
						"h": 308,
						"w": 400
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 119
					},
					{
						"n": 2,
						"h": 71,
						"w": 344
					},
					{
						"n": 3,
						"h": 174,
						"w": 290
					},
					{
						"n": 4,
						"h": 270,
						"w": 300
					},
					{
						"n": 5,
						"h": 382,
						"w": 309
					},
					{
						"n": 6,
						"h": 219,
						"w": 412
					},
					{
						"n": 7,
						"h": 217,
						"w": 491
					},
					{
						"n": 8,
						"h": 415,
						"w": 602
					},
					{
						"n": 9,
						"h": 88,
						"w": 485
					},
					{
						"n": 10,
						"h": 171,
						"w": 619
					},
					{
						"n": 11,
						"h": 170,
						"w": 556
					}
				],
				"ball": {
					"n": 0,
					"h": 362,
					"w": 235,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 14
		},
		{
			"num": 42,
			"minute": 2,
			"messages": [
				{
					"owner": 2,
					"mes": "Подача в штрафную..."
				},
				{
					"owner": 2,
					"mes": "Патрик Клинтон[03](Галвэй Юнайтед) в высоком прыжке выбивает мяч подальше..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 9
					},
					{
						"n": 2,
						"h": 141,
						"w": 41
					},
					{
						"n": 3,
						"h": 220,
						"w": 46
					},
					{
						"n": 4,
						"h": 255,
						"w": 60
					},
					{
						"n": 5,
						"h": 361,
						"w": 152
					},
					{
						"n": 6,
						"h": 31,
						"w": 157
					},
					{
						"n": 7,
						"h": 220,
						"w": 128
					},
					{
						"n": 8,
						"h": 333,
						"w": 197
					},
					{
						"n": 9,
						"h": 353,
						"w": 221
					},
					{
						"n": 10,
						"h": 162,
						"w": 390
					},
					{
						"n": 11,
						"h": 322,
						"w": 400
					}
				],
				"away": [
					{
						"n": 1,
						"h": 228,
						"w": 123
					},
					{
						"n": 2,
						"h": 68,
						"w": 357
					},
					{
						"n": 3,
						"h": 163,
						"w": 296
					},
					{
						"n": 4,
						"h": 288,
						"w": 296
					},
					{
						"n": 5,
						"h": 377,
						"w": 315
					},
					{
						"n": 6,
						"h": 224,
						"w": 415
					},
					{
						"n": 7,
						"h": 224,
						"w": 471
					},
					{
						"n": 8,
						"h": 392,
						"w": 635
					},
					{
						"n": 9,
						"h": 89,
						"w": 484,
						"m": 620
					},
					{
						"n": 10,
						"h": 195,
						"w": 646
					},
					{
						"n": 11,
						"h": 168,
						"w": 596
					}
				],
				"ball": {
					"n": 0,
					"h": 220,
					"w": 46,
					"z": 1,
					"r": 2,
					"p": 4,
					"x": 1
				}
			},
			"interval": 40
		},
		{
			"num": 43,
			"minute": 2,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 17
					},
					{
						"n": 2,
						"h": 120,
						"w": 70
					},
					{
						"n": 3,
						"h": 223,
						"w": 47
					},
					{
						"n": 4,
						"h": 270,
						"w": 78
					},
					{
						"n": 5,
						"h": 364,
						"w": 109
					},
					{
						"n": 6,
						"h": 44,
						"w": 116
					},
					{
						"n": 7,
						"h": 185,
						"w": 172
					},
					{
						"n": 8,
						"h": 297,
						"w": 172
					},
					{
						"n": 9,
						"h": 368,
						"w": 204
					},
					{
						"n": 10,
						"h": 163,
						"w": 390
					},
					{
						"n": 11,
						"h": 283,
						"w": 400
					}
				],
				"away": [
					{
						"n": 1,
						"h": 223,
						"w": 124
					},
					{
						"n": 2,
						"h": 66,
						"w": 350
					},
					{
						"n": 3,
						"h": 167,
						"w": 306
					},
					{
						"n": 4,
						"h": 287,
						"w": 309
					},
					{
						"n": 5,
						"h": 381,
						"w": 311
					},
					{
						"n": 6,
						"h": 237,
						"w": 430
					},
					{
						"n": 7,
						"h": 266,
						"w": 470
					},
					{
						"n": 8,
						"h": 418,
						"w": 640
					},
					{
						"n": 9,
						"h": 117,
						"w": 516
					},
					{
						"n": 10,
						"h": 156,
						"w": 627
					},
					{
						"n": 11,
						"h": 195,
						"w": 587
					}
				],
				"ball": {
					"n": 0,
					"h": 145,
					"w": 203,
					"z": 1,
					"r": 0,
					"p": 1,
					"x": 0
				}
			},
			"interval": 43
		},
		{
			"num": 44,
			"minute": 2,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 17
					},
					{
						"n": 2,
						"h": 120,
						"w": 57
					},
					{
						"n": 3,
						"h": 235,
						"w": 53
					},
					{
						"n": 4,
						"h": 277,
						"w": 67
					},
					{
						"n": 5,
						"h": 365,
						"w": 96
					},
					{
						"n": 6,
						"h": 48,
						"w": 104
					},
					{
						"n": 7,
						"h": 174,
						"w": 185
					},
					{
						"n": 8,
						"h": 287,
						"w": 164
					},
					{
						"n": 9,
						"h": 371,
						"w": 217
					},
					{
						"n": 10,
						"h": 169,
						"w": 390
					},
					{
						"n": 11,
						"h": 280,
						"w": 400
					}
				],
				"away": [
					{
						"n": 1,
						"h": 226,
						"w": 121
					},
					{
						"n": 2,
						"h": 60,
						"w": 352
					},
					{
						"n": 3,
						"h": 170,
						"w": 306
					},
					{
						"n": 4,
						"h": 281,
						"w": 300
					},
					{
						"n": 5,
						"h": 387,
						"w": 323
					},
					{
						"n": 6,
						"h": 235,
						"w": 417
					},
					{
						"n": 7,
						"h": 279,
						"w": 470
					},
					{
						"n": 8,
						"h": 405,
						"w": 640
					},
					{
						"n": 9,
						"h": 129,
						"w": 522
					},
					{
						"n": 10,
						"h": 158,
						"w": 630
					},
					{
						"n": 11,
						"h": 183,
						"w": 583
					}
				],
				"ball": {
					"n": 0,
					"h": 123,
					"w": 250,
					"z": 0,
					"r": 0,
					"p": 1,
					"x": 0
				}
			},
			"interval": 13
		},
		{
			"num": 45,
			"minute": 2,
			"messages": [
				{
					"owner": 2,
					"mes": "Мирослав Манолов[27](Опава) подхватывает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 18
					},
					{
						"n": 2,
						"h": 120,
						"w": 58
					},
					{
						"n": 3,
						"h": 224,
						"w": 53
					},
					{
						"n": 4,
						"h": 286,
						"w": 70
					},
					{
						"n": 5,
						"h": 330,
						"w": 68
					},
					{
						"n": 6,
						"h": 62,
						"w": 75
					},
					{
						"n": 7,
						"h": 133,
						"w": 242
					},
					{
						"n": 8,
						"h": 283,
						"w": 142
					},
					{
						"n": 9,
						"h": 380,
						"w": 269
					},
					{
						"n": 10,
						"h": 176,
						"w": 390
					},
					{
						"n": 11,
						"h": 287,
						"w": 400
					}
				],
				"away": [
					{
						"n": 1,
						"h": 228,
						"w": 121
					},
					{
						"n": 2,
						"h": 57,
						"w": 347
					},
					{
						"n": 3,
						"h": 163,
						"w": 304
					},
					{
						"n": 4,
						"h": 274,
						"w": 290
					},
					{
						"n": 5,
						"h": 374,
						"w": 300
					},
					{
						"n": 6,
						"h": 223,
						"w": 394
					},
					{
						"n": 7,
						"h": 335,
						"w": 454
					},
					{
						"n": 8,
						"h": 403,
						"w": 637
					},
					{
						"n": 9,
						"h": 181,
						"w": 530
					},
					{
						"n": 10,
						"h": 159,
						"w": 630
					},
					{
						"n": 11,
						"h": 165,
						"w": 563
					}
				],
				"ball": {
					"n": 0,
					"h": 115,
					"w": 266,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 53
		},
		{
			"num": 46,
			"minute": 2,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 17
					},
					{
						"n": 2,
						"h": 120,
						"w": 73
					},
					{
						"n": 3,
						"h": 224,
						"w": 64
					},
					{
						"n": 4,
						"h": 288,
						"w": 76
					},
					{
						"n": 5,
						"h": 330,
						"w": 68
					},
					{
						"n": 6,
						"h": 68,
						"w": 83
					},
					{
						"n": 7,
						"h": 103,
						"w": 222
					},
					{
						"n": 8,
						"h": 244,
						"w": 141
					},
					{
						"n": 9,
						"h": 387,
						"w": 308
					},
					{
						"n": 10,
						"h": 185,
						"w": 390
					},
					{
						"n": 11,
						"h": 317,
						"w": 400
					}
				],
				"away": [
					{
						"n": 1,
						"h": 226,
						"w": 125
					},
					{
						"n": 2,
						"h": 58,
						"w": 350
					},
					{
						"n": 3,
						"h": 165,
						"w": 297
					},
					{
						"n": 4,
						"h": 265,
						"w": 302
					},
					{
						"n": 5,
						"h": 392,
						"w": 305
					},
					{
						"n": 6,
						"h": 235,
						"w": 415
					},
					{
						"n": 7,
						"h": 347,
						"w": 476
					},
					{
						"n": 8,
						"h": 397,
						"w": 612
					},
					{
						"n": 9,
						"h": 213,
						"w": 553
					},
					{
						"n": 10,
						"h": 164,
						"w": 628
					},
					{
						"n": 11,
						"h": 172,
						"w": 563
					}
				],
				"ball": {
					"n": 0,
					"h": 103,
					"w": 244,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 47,
			"minute": 2,
			"messages": [
				{
					"owner": 2,
					"mes": "Мирослав Манолов[27](Опава) отдает пас на Ш.Товарека[31](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 233,
						"w": 13
					},
					{
						"n": 2,
						"h": 120,
						"w": 84
					},
					{
						"n": 3,
						"h": 222,
						"w": 66
					},
					{
						"n": 4,
						"h": 282,
						"w": 81
					},
					{
						"n": 5,
						"h": 330,
						"w": 86
					},
					{
						"n": 6,
						"h": 56,
						"w": 91
					},
					{
						"n": 7,
						"h": 166,
						"w": 173
					},
					{
						"n": 8,
						"h": 321,
						"w": 161
					},
					{
						"n": 9,
						"h": 389,
						"w": 336
					},
					{
						"n": 10,
						"h": 171,
						"w": 390
					},
					{
						"n": 11,
						"h": 307,
						"w": 400
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 121
					},
					{
						"n": 2,
						"h": 61,
						"w": 349
					},
					{
						"n": 3,
						"h": 175,
						"w": 290
					},
					{
						"n": 4,
						"h": 279,
						"w": 314
					},
					{
						"n": 5,
						"h": 374,
						"w": 324
					},
					{
						"n": 6,
						"h": 225,
						"w": 421
					},
					{
						"n": 7,
						"h": 329,
						"w": 484
					},
					{
						"n": 8,
						"h": 417,
						"w": 608
					},
					{
						"n": 9,
						"h": 191,
						"w": 584
					},
					{
						"n": 10,
						"h": 172,
						"w": 624
					},
					{
						"n": 11,
						"h": 114,
						"w": 534
					}
				],
				"ball": {
					"n": 0,
					"h": 336,
					"w": 186,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 80
		},
		{
			"num": 48,
			"minute": 2,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 235,
						"w": 11
					},
					{
						"n": 2,
						"h": 120,
						"w": 77
					},
					{
						"n": 3,
						"h": 219,
						"w": 68
					},
					{
						"n": 4,
						"h": 271,
						"w": 67
					},
					{
						"n": 5,
						"h": 330,
						"w": 69
					},
					{
						"n": 6,
						"h": 68,
						"w": 84
					},
					{
						"n": 7,
						"h": 195,
						"w": 146
					},
					{
						"n": 8,
						"h": 356,
						"w": 128
					},
					{
						"n": 9,
						"h": 394,
						"w": 297
					},
					{
						"n": 10,
						"h": 177,
						"w": 391
					},
					{
						"n": 11,
						"h": 320,
						"w": 401
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 124
					},
					{
						"n": 2,
						"h": 70,
						"w": 340
					},
					{
						"n": 3,
						"h": 164,
						"w": 296
					},
					{
						"n": 4,
						"h": 273,
						"w": 296
					},
					{
						"n": 5,
						"h": 376,
						"w": 325
					},
					{
						"n": 6,
						"h": 202,
						"w": 453
					},
					{
						"n": 7,
						"h": 293,
						"w": 499
					},
					{
						"n": 8,
						"h": 397,
						"w": 604
					},
					{
						"n": 9,
						"h": 178,
						"w": 578
					},
					{
						"n": 10,
						"h": 177,
						"w": 631
					},
					{
						"n": 11,
						"h": 94,
						"w": 569
					}
				],
				"ball": {
					"n": 0,
					"h": 356,
					"w": 151,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 49,
			"minute": 2,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 233,
						"w": 13
					},
					{
						"n": 2,
						"h": 120,
						"w": 54
					},
					{
						"n": 3,
						"h": 235,
						"w": 80
					},
					{
						"n": 4,
						"h": 275,
						"w": 53
					},
					{
						"n": 5,
						"h": 330,
						"w": 49
					},
					{
						"n": 6,
						"h": 62,
						"w": 124
					},
					{
						"n": 7,
						"h": 176,
						"w": 140
					},
					{
						"n": 8,
						"h": 317,
						"w": 124
					},
					{
						"n": 9,
						"h": 394,
						"w": 257
					},
					{
						"n": 10,
						"h": 181,
						"w": 390
					},
					{
						"n": 11,
						"h": 280,
						"w": 400
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 126
					},
					{
						"n": 2,
						"h": 41,
						"w": 360
					},
					{
						"n": 3,
						"h": 173,
						"w": 302
					},
					{
						"n": 4,
						"h": 269,
						"w": 295
					},
					{
						"n": 5,
						"h": 375,
						"w": 325
					},
					{
						"n": 6,
						"h": 210,
						"w": 492
					},
					{
						"n": 7,
						"h": 286,
						"w": 538
					},
					{
						"n": 8,
						"h": 401,
						"w": 644
					},
					{
						"n": 9,
						"h": 191,
						"w": 616
					},
					{
						"n": 10,
						"h": 157,
						"w": 645
					},
					{
						"n": 11,
						"h": 132,
						"w": 579
					}
				],
				"ball": {
					"n": 0,
					"h": 318,
					"w": 141,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 50,
			"minute": 2,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 231,
						"w": 14
					},
					{
						"n": 2,
						"h": 120,
						"w": 52
					},
					{
						"n": 3,
						"h": 234,
						"w": 43
					},
					{
						"n": 4,
						"h": 297,
						"w": 45
					},
					{
						"n": 5,
						"h": 330,
						"w": 48
					},
					{
						"n": 6,
						"h": 46,
						"w": 149
					},
					{
						"n": 7,
						"h": 179,
						"w": 139
					},
					{
						"n": 8,
						"h": 278,
						"w": 108
					},
					{
						"n": 9,
						"h": 399,
						"w": 218
					},
					{
						"n": 10,
						"h": 184,
						"w": 390
					},
					{
						"n": 11,
						"h": 303,
						"w": 400
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 127
					},
					{
						"n": 2,
						"h": 41,
						"w": 360
					},
					{
						"n": 3,
						"h": 183,
						"w": 296
					},
					{
						"n": 4,
						"h": 266,
						"w": 320
					},
					{
						"n": 5,
						"h": 386,
						"w": 293
					},
					{
						"n": 6,
						"h": 219,
						"w": 531
					},
					{
						"n": 7,
						"h": 276,
						"w": 577
					},
					{
						"n": 8,
						"h": 403,
						"w": 652
					},
					{
						"n": 9,
						"h": 211,
						"w": 647
					},
					{
						"n": 10,
						"h": 137,
						"w": 653
					},
					{
						"n": 11,
						"h": 169,
						"w": 594
					}
				],
				"ball": {
					"n": 0,
					"h": 281,
					"w": 126,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 51,
			"minute": 2,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 15
					},
					{
						"n": 2,
						"h": 80,
						"w": 47
					},
					{
						"n": 3,
						"h": 212,
						"w": 57
					},
					{
						"n": 4,
						"h": 278,
						"w": 35
					},
					{
						"n": 5,
						"h": 330,
						"w": 51
					},
					{
						"n": 6,
						"h": 60,
						"w": 141
					},
					{
						"n": 7,
						"h": 213,
						"w": 119
					},
					{
						"n": 8,
						"h": 241,
						"w": 96
					},
					{
						"n": 9,
						"h": 402,
						"w": 178
					},
					{
						"n": 10,
						"h": 170,
						"w": 390
					},
					{
						"n": 11,
						"h": 322,
						"w": 400
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 118
					},
					{
						"n": 2,
						"h": 43,
						"w": 360
					},
					{
						"n": 3,
						"h": 169,
						"w": 291
					},
					{
						"n": 4,
						"h": 280,
						"w": 303
					},
					{
						"n": 5,
						"h": 380,
						"w": 330
					},
					{
						"n": 6,
						"h": 231,
						"w": 569
					},
					{
						"n": 7,
						"h": 267,
						"w": 616
					},
					{
						"n": 8,
						"h": 407,
						"w": 662
					},
					{
						"n": 9,
						"h": 251,
						"w": 649
					},
					{
						"n": 10,
						"h": 157,
						"w": 656
					},
					{
						"n": 11,
						"h": 207,
						"w": 604
					}
				],
				"ball": {
					"n": 0,
					"h": 243,
					"w": 116,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 52,
			"minute": 2,
			"messages": [
				{
					"owner": 2,
					"mes": "Передача в штрафную..."
				},
				{
					"owner": 2,
					"mes": "Петр Крамарж[30](Опава) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 235,
						"w": 12
					},
					{
						"n": 2,
						"h": 110,
						"w": 44
					},
					{
						"n": 3,
						"h": 227,
						"w": 50
					},
					{
						"n": 4,
						"h": 283,
						"w": 65
					},
					{
						"n": 5,
						"h": 330,
						"w": 37
					},
					{
						"n": 6,
						"h": 30,
						"w": 146
					},
					{
						"n": 7,
						"h": 214,
						"w": 109
					},
					{
						"n": 8,
						"h": 263,
						"w": 115
					},
					{
						"n": 9,
						"h": 390,
						"w": 150
					},
					{
						"n": 10,
						"h": 182,
						"w": 390
					},
					{
						"n": 11,
						"h": 292,
						"w": 400
					}
				],
				"away": [
					{
						"n": 1,
						"h": 226,
						"w": 118
					},
					{
						"n": 2,
						"h": 72,
						"w": 351
					},
					{
						"n": 3,
						"h": 169,
						"w": 310
					},
					{
						"n": 4,
						"h": 268,
						"w": 302
					},
					{
						"n": 5,
						"h": 378,
						"w": 304
					},
					{
						"n": 6,
						"h": 231,
						"w": 539
					},
					{
						"n": 7,
						"h": 237,
						"w": 615
					},
					{
						"n": 8,
						"h": 405,
						"w": 646
					},
					{
						"n": 9,
						"h": 222,
						"w": 641
					},
					{
						"n": 10,
						"h": 164,
						"w": 646
					},
					{
						"n": 11,
						"h": 197,
						"w": 606
					}
				],
				"ball": {
					"n": 0,
					"h": 286,
					"w": 74,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 30
		},
		{
			"num": 53,
			"minute": 3,
			"possession": 48,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 235,
						"w": 12
					},
					{
						"n": 2,
						"h": 114,
						"w": 47
					},
					{
						"n": 3,
						"h": 228,
						"w": 45
					},
					{
						"n": 4,
						"h": 286,
						"w": 69
					},
					{
						"n": 5,
						"h": 330,
						"w": 35
					},
					{
						"n": 6,
						"h": 35,
						"w": 144
					},
					{
						"n": 7,
						"h": 214,
						"w": 104
					},
					{
						"n": 8,
						"h": 261,
						"w": 110
					},
					{
						"n": 9,
						"h": 388,
						"w": 145
					},
					{
						"n": 10,
						"h": 182,
						"w": 390
					},
					{
						"n": 11,
						"h": 287,
						"w": 400
					}
				],
				"away": [
					{
						"n": 1,
						"h": 229,
						"w": 122
					},
					{
						"n": 2,
						"h": 67,
						"w": 354
					},
					{
						"n": 3,
						"h": 169,
						"w": 305
					},
					{
						"n": 4,
						"h": 273,
						"w": 300
					},
					{
						"n": 5,
						"h": 378,
						"w": 309
					},
					{
						"n": 6,
						"h": 231,
						"w": 534
					},
					{
						"n": 7,
						"h": 232,
						"w": 614
					},
					{
						"n": 8,
						"h": 406,
						"w": 651
					},
					{
						"n": 9,
						"h": 224,
						"w": 646
					},
					{
						"n": 10,
						"h": 164,
						"w": 651
					},
					{
						"n": 11,
						"h": 192,
						"w": 603
					}
				],
				"ball": {
					"n": 0,
					"h": 286,
					"w": 69,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 5
		},
		{
			"num": 54,
			"minute": 3,
			"messages": [
				{
					"owner": 2,
					"mes": "Р.Дриссенс[04](Галвэй Юнайтед) вступает в единоборство с П.Крамаржем[30](Опава)..."
				},
				{
					"owner": 2,
					"mes": "Роббе Дриссенс[04](Галвэй Юнайтед) выбивает мяч из-под ног П.Крамаржа[30](Опава)..."
				},
				{
					"owner": 1,
					"mes": "Мяч подбирает К.Нолан[08](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 235,
						"w": 11
					},
					{
						"n": 2,
						"h": 120,
						"w": 52
					},
					{
						"n": 3,
						"h": 213,
						"w": 39
					},
					{
						"n": 4,
						"h": 283,
						"w": 65,
						"m": 610
					},
					{
						"n": 5,
						"h": 330,
						"w": 43
					},
					{
						"n": 6,
						"h": 35,
						"w": 144
					},
					{
						"n": 7,
						"h": 210,
						"w": 107
					},
					{
						"n": 8,
						"h": 276,
						"w": 104
					},
					{
						"n": 9,
						"h": 404,
						"w": 143
					},
					{
						"n": 10,
						"h": 177,
						"w": 390
					},
					{
						"n": 11,
						"h": 303,
						"w": 400
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 121
					},
					{
						"n": 2,
						"h": 72,
						"w": 341
					},
					{
						"n": 3,
						"h": 167,
						"w": 290
					},
					{
						"n": 4,
						"h": 273,
						"w": 316
					},
					{
						"n": 5,
						"h": 386,
						"w": 295
					},
					{
						"n": 6,
						"h": 230,
						"w": 518
					},
					{
						"n": 7,
						"h": 232,
						"w": 622
					},
					{
						"n": 8,
						"h": 407,
						"w": 656
					},
					{
						"n": 9,
						"h": 240,
						"w": 648
					},
					{
						"n": 10,
						"h": 164,
						"w": 651
					},
					{
						"n": 11,
						"h": 177,
						"w": 606
					}
				],
				"ball": {
					"n": 0,
					"h": 276,
					"w": 104,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 4
				}
			},
			"interval": 16
		},
		{
			"num": 55,
			"minute": 3,
			"messages": [
				{
					"owner": 1,
					"mes": "Киран Нолан[08](Галвэй Юнайтед) подключает к атаке по левому флангу К.Колмана[06](Галвэй Юнайтед)..."
				},
				{
					"owner": 1,
					"mes": "Киэн Колман[06](Галвэй Юнайтед) останавливает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 17
					},
					{
						"n": 2,
						"h": 95,
						"w": 114
					},
					{
						"n": 3,
						"h": 186,
						"w": 100
					},
					{
						"n": 4,
						"h": 250,
						"w": 94
					},
					{
						"n": 5,
						"h": 353,
						"w": 106
					},
					{
						"n": 6,
						"h": 27,
						"w": 205
					},
					{
						"n": 7,
						"h": 182,
						"w": 168
					},
					{
						"n": 8,
						"h": 274,
						"w": 114
					},
					{
						"n": 9,
						"h": 406,
						"w": 210
					},
					{
						"n": 10,
						"h": 162,
						"w": 409
					},
					{
						"n": 11,
						"h": 308,
						"w": 411
					}
				],
				"away": [
					{
						"n": 1,
						"h": 245,
						"w": 72
					},
					{
						"n": 2,
						"h": 96,
						"w": 279
					},
					{
						"n": 3,
						"h": 175,
						"w": 246
					},
					{
						"n": 4,
						"h": 257,
						"w": 254
					},
					{
						"n": 5,
						"h": 390,
						"w": 362
					},
					{
						"n": 6,
						"h": 249,
						"w": 454
					},
					{
						"n": 7,
						"h": 237,
						"w": 555
					},
					{
						"n": 8,
						"h": 407,
						"w": 589
					},
					{
						"n": 9,
						"h": 234,
						"w": 581
					},
					{
						"n": 10,
						"h": 176,
						"w": 586
					},
					{
						"n": 11,
						"h": 176,
						"w": 539
					}
				],
				"ball": {
					"n": 0,
					"h": 27,
					"w": 205,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 67
		},
		{
			"num": 56,
			"minute": 3,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 19
					},
					{
						"n": 2,
						"h": 85,
						"w": 153
					},
					{
						"n": 3,
						"h": 186,
						"w": 120
					},
					{
						"n": 4,
						"h": 256,
						"w": 113
					},
					{
						"n": 5,
						"h": 365,
						"w": 144
					},
					{
						"n": 6,
						"h": 10,
						"w": 236
					},
					{
						"n": 7,
						"h": 173,
						"w": 207
					},
					{
						"n": 8,
						"h": 264,
						"w": 153
					},
					{
						"n": 9,
						"h": 405,
						"w": 250
					},
					{
						"n": 10,
						"h": 159,
						"w": 449
					},
					{
						"n": 11,
						"h": 306,
						"w": 451
					}
				],
				"away": [
					{
						"n": 1,
						"h": 245,
						"w": 76
					},
					{
						"n": 2,
						"h": 110,
						"w": 246
					},
					{
						"n": 3,
						"h": 155,
						"w": 253
					},
					{
						"n": 4,
						"h": 275,
						"w": 260
					},
					{
						"n": 5,
						"h": 382,
						"w": 323
					},
					{
						"n": 6,
						"h": 264,
						"w": 417
					},
					{
						"n": 7,
						"h": 240,
						"w": 515
					},
					{
						"n": 8,
						"h": 406,
						"w": 549
					},
					{
						"n": 9,
						"h": 205,
						"w": 553
					},
					{
						"n": 10,
						"h": 186,
						"w": 547
					},
					{
						"n": 11,
						"h": 212,
						"w": 523
					}
				],
				"ball": {
					"n": 0,
					"h": 10,
					"w": 236,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 57,
			"minute": 3,
			"messages": [
				{
					"owner": 1,
					"mes": "Киэн Колман[06](Галвэй Юнайтед) пасует направо на А.Хлинссона[07](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 15
					},
					{
						"n": 2,
						"h": 76,
						"w": 197
					},
					{
						"n": 3,
						"h": 179,
						"w": 161
					},
					{
						"n": 4,
						"h": 274,
						"w": 154
					},
					{
						"n": 5,
						"h": 378,
						"w": 187
					},
					{
						"n": 6,
						"h": 14,
						"w": 245
					},
					{
						"n": 7,
						"h": 145,
						"w": 225
					},
					{
						"n": 8,
						"h": 275,
						"w": 196
					},
					{
						"n": 9,
						"h": 403,
						"w": 295
					},
					{
						"n": 10,
						"h": 153,
						"w": 435
					},
					{
						"n": 11,
						"h": 291,
						"w": 448
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 77
					},
					{
						"n": 2,
						"h": 110,
						"w": 253
					},
					{
						"n": 3,
						"h": 176,
						"w": 247
					},
					{
						"n": 4,
						"h": 283,
						"w": 264
					},
					{
						"n": 5,
						"h": 380,
						"w": 278
					},
					{
						"n": 6,
						"h": 274,
						"w": 373
					},
					{
						"n": 7,
						"h": 234,
						"w": 471
					},
					{
						"n": 8,
						"h": 409,
						"w": 504
					},
					{
						"n": 9,
						"h": 172,
						"w": 523
					},
					{
						"n": 10,
						"h": 167,
						"w": 507
					},
					{
						"n": 11,
						"h": 236,
						"w": 515
					}
				],
				"ball": {
					"n": 0,
					"h": 145,
					"w": 225,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 45
		},
		{
			"num": 58,
			"minute": 3,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 13
					},
					{
						"n": 2,
						"h": 78,
						"w": 213
					},
					{
						"n": 3,
						"h": 181,
						"w": 168
					},
					{
						"n": 4,
						"h": 268,
						"w": 153
					},
					{
						"n": 5,
						"h": 376,
						"w": 212
					},
					{
						"n": 6,
						"h": 24,
						"w": 284
					},
					{
						"n": 7,
						"h": 130,
						"w": 257
					},
					{
						"n": 8,
						"h": 278,
						"w": 236
					},
					{
						"n": 9,
						"h": 400,
						"w": 335
					},
					{
						"n": 10,
						"h": 152,
						"w": 444
					},
					{
						"n": 11,
						"h": 308,
						"w": 446
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 75
					},
					{
						"n": 2,
						"h": 110,
						"w": 220
					},
					{
						"n": 3,
						"h": 178,
						"w": 231
					},
					{
						"n": 4,
						"h": 268,
						"w": 227
					},
					{
						"n": 5,
						"h": 357,
						"w": 246
					},
					{
						"n": 6,
						"h": 282,
						"w": 334
					},
					{
						"n": 7,
						"h": 233,
						"w": 431
					},
					{
						"n": 8,
						"h": 410,
						"w": 464
					},
					{
						"n": 9,
						"h": 146,
						"w": 492
					},
					{
						"n": 10,
						"h": 171,
						"w": 467
					},
					{
						"n": 11,
						"h": 267,
						"w": 489
					}
				],
				"ball": {
					"n": 0,
					"h": 130,
					"w": 257,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 59,
			"minute": 3,
			"messages": [
				{
					"owner": 1,
					"mes": "Агуст Хлинссон[07](Галвэй Юнайтед) отдает мяч рванувшемуся вперед К.Колману[06](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 13
					},
					{
						"n": 2,
						"h": 77,
						"w": 243
					},
					{
						"n": 3,
						"h": 179,
						"w": 176
					},
					{
						"n": 4,
						"h": 265,
						"w": 179
					},
					{
						"n": 5,
						"h": 372,
						"w": 231
					},
					{
						"n": 6,
						"h": 46,
						"w": 329
					},
					{
						"n": 7,
						"h": 130,
						"w": 257,
						"m": 610
					},
					{
						"n": 8,
						"h": 246,
						"w": 254
					},
					{
						"n": 9,
						"h": 397,
						"w": 372
					},
					{
						"n": 10,
						"h": 165,
						"w": 475
					},
					{
						"n": 11,
						"h": 290,
						"w": 478
					}
				],
				"away": [
					{
						"n": 1,
						"h": 245,
						"w": 78
					},
					{
						"n": 2,
						"h": 110,
						"w": 190
					},
					{
						"n": 3,
						"h": 177,
						"w": 206
					},
					{
						"n": 4,
						"h": 268,
						"w": 205
					},
					{
						"n": 5,
						"h": 363,
						"w": 282
					},
					{
						"n": 6,
						"h": 285,
						"w": 297
					},
					{
						"n": 7,
						"h": 237,
						"w": 394
					},
					{
						"n": 8,
						"h": 412,
						"w": 427
					},
					{
						"n": 9,
						"h": 125,
						"w": 462
					},
					{
						"n": 10,
						"h": 203,
						"w": 447
					},
					{
						"n": 11,
						"h": 295,
						"w": 465
					}
				],
				"ball": {
					"n": 0,
					"h": 46,
					"w": 329,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 37
		},
		{
			"num": 60,
			"minute": 3,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 16
					},
					{
						"n": 2,
						"h": 63,
						"w": 272
					},
					{
						"n": 3,
						"h": 184,
						"w": 214
					},
					{
						"n": 4,
						"h": 283,
						"w": 215
					},
					{
						"n": 5,
						"h": 379,
						"w": 269
					},
					{
						"n": 6,
						"h": 68,
						"w": 356
					},
					{
						"n": 7,
						"h": 140,
						"w": 296
					},
					{
						"n": 8,
						"h": 249,
						"w": 293
					},
					{
						"n": 9,
						"h": 396,
						"w": 412
					},
					{
						"n": 10,
						"h": 160,
						"w": 515
					},
					{
						"n": 11,
						"h": 286,
						"w": 518
					}
				],
				"away": [
					{
						"n": 1,
						"h": 245,
						"w": 79
					},
					{
						"n": 2,
						"h": 110,
						"w": 168
					},
					{
						"n": 3,
						"h": 174,
						"w": 166
					},
					{
						"n": 4,
						"h": 270,
						"w": 165
					},
					{
						"n": 5,
						"h": 370,
						"w": 322
					},
					{
						"n": 6,
						"h": 289,
						"w": 257
					},
					{
						"n": 7,
						"h": 244,
						"w": 355
					},
					{
						"n": 8,
						"h": 415,
						"w": 387
					},
					{
						"n": 9,
						"h": 105,
						"w": 427
					},
					{
						"n": 10,
						"h": 201,
						"w": 407
					},
					{
						"n": 11,
						"h": 305,
						"w": 426
					}
				],
				"ball": {
					"n": 0,
					"h": 68,
					"w": 356,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 61,
			"minute": 3,
			"messages": [
				{
					"owner": 1,
					"mes": "Пас назад..."
				},
				{
					"owner": 1,
					"mes": "Тимо Эверс[02](Галвэй Юнайтед) технично принимает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 11
					},
					{
						"n": 2,
						"h": 93,
						"w": 301
					},
					{
						"n": 3,
						"h": 172,
						"w": 246
					},
					{
						"n": 4,
						"h": 284,
						"w": 234
					},
					{
						"n": 5,
						"h": 382,
						"w": 295
					},
					{
						"n": 6,
						"h": 67,
						"w": 366,
						"m": 610
					},
					{
						"n": 7,
						"h": 149,
						"w": 337
					},
					{
						"n": 8,
						"h": 253,
						"w": 335
					},
					{
						"n": 9,
						"h": 398,
						"w": 454
					},
					{
						"n": 10,
						"h": 158,
						"w": 540
					},
					{
						"n": 11,
						"h": 285,
						"w": 559
					}
				],
				"away": [
					{
						"n": 1,
						"h": 245,
						"w": 79
					},
					{
						"n": 2,
						"h": 110,
						"w": 137
					},
					{
						"n": 3,
						"h": 182,
						"w": 132
					},
					{
						"n": 4,
						"h": 277,
						"w": 124
					},
					{
						"n": 5,
						"h": 372,
						"w": 280
					},
					{
						"n": 6,
						"h": 289,
						"w": 215
					},
					{
						"n": 7,
						"h": 241,
						"w": 313
					},
					{
						"n": 8,
						"h": 397,
						"w": 349
					},
					{
						"n": 9,
						"h": 89,
						"w": 388
					},
					{
						"n": 10,
						"h": 197,
						"w": 366
					},
					{
						"n": 11,
						"h": 342,
						"w": 407
					}
				],
				"ball": {
					"n": 0,
					"h": 93,
					"w": 301,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 42
		},
		{
			"num": 62,
			"minute": 3,
			"messages": [
				{
					"owner": 1,
					"mes": "Тимо Эверс[02](Галвэй Юнайтед) пасует на ход А.Хлинссону[07](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 17
					},
					{
						"n": 2,
						"h": 93,
						"w": 301
					},
					{
						"n": 3,
						"h": 166,
						"w": 281
					},
					{
						"n": 4,
						"h": 279,
						"w": 269
					},
					{
						"n": 5,
						"h": 388,
						"w": 327
					},
					{
						"n": 6,
						"h": 65,
						"w": 402
					},
					{
						"n": 7,
						"h": 124,
						"w": 367
					},
					{
						"n": 8,
						"h": 265,
						"w": 369
					},
					{
						"n": 9,
						"h": 398,
						"w": 490
					},
					{
						"n": 10,
						"h": 170,
						"w": 574
					},
					{
						"n": 11,
						"h": 279,
						"w": 594
					}
				],
				"away": [
					{
						"n": 1,
						"h": 245,
						"w": 72
					},
					{
						"n": 2,
						"h": 110,
						"w": 111
					},
					{
						"n": 3,
						"h": 191,
						"w": 111
					},
					{
						"n": 4,
						"h": 262,
						"w": 97
					},
					{
						"n": 5,
						"h": 371,
						"w": 244
					},
					{
						"n": 6,
						"h": 289,
						"w": 179
					},
					{
						"n": 7,
						"h": 276,
						"w": 321
					},
					{
						"n": 8,
						"h": 391,
						"w": 314
					},
					{
						"n": 9,
						"h": 73,
						"w": 356
					},
					{
						"n": 10,
						"h": 185,
						"w": 332
					},
					{
						"n": 11,
						"h": 326,
						"w": 380
					}
				],
				"ball": {
					"n": 0,
					"h": 124,
					"w": 367,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 36
		},
		{
			"num": 63,
			"minute": 3,
			"messages": [
				{
					"owner": 1,
					"mes": "Агуст Хлинссон[07](Галвэй Юнайтед) отдает мяч рванувшемуся вперед К.Колману[06](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 10
					},
					{
						"n": 2,
						"h": 81,
						"w": 330
					},
					{
						"n": 3,
						"h": 180,
						"w": 306
					},
					{
						"n": 4,
						"h": 277,
						"w": 294
					},
					{
						"n": 5,
						"h": 377,
						"w": 356
					},
					{
						"n": 6,
						"h": 70,
						"w": 442
					},
					{
						"n": 7,
						"h": 124,
						"w": 367
					},
					{
						"n": 8,
						"h": 249,
						"w": 379
					},
					{
						"n": 9,
						"h": 398,
						"w": 521
					},
					{
						"n": 10,
						"h": 178,
						"w": 603
					},
					{
						"n": 11,
						"h": 286,
						"w": 613
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 43
					},
					{
						"n": 2,
						"h": 110,
						"w": 88
					},
					{
						"n": 3,
						"h": 181,
						"w": 90
					},
					{
						"n": 4,
						"h": 262,
						"w": 109
					},
					{
						"n": 5,
						"h": 369,
						"w": 218
					},
					{
						"n": 6,
						"h": 293,
						"w": 148
					},
					{
						"n": 7,
						"h": 266,
						"w": 292
					},
					{
						"n": 8,
						"h": 385,
						"w": 299
					},
					{
						"n": 9,
						"h": 66,
						"w": 326
					},
					{
						"n": 10,
						"h": 201,
						"w": 321
					},
					{
						"n": 11,
						"h": 326,
						"w": 349
					}
				],
				"ball": {
					"n": 0,
					"h": 70,
					"w": 442,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 31
		},
		{
			"num": 64,
			"minute": 3,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 16
					},
					{
						"n": 2,
						"h": 75,
						"w": 358
					},
					{
						"n": 3,
						"h": 171,
						"w": 305
					},
					{
						"n": 4,
						"h": 265,
						"w": 310
					},
					{
						"n": 5,
						"h": 388,
						"w": 371
					},
					{
						"n": 6,
						"h": 89,
						"w": 471
					},
					{
						"n": 7,
						"h": 138,
						"w": 404
					},
					{
						"n": 8,
						"h": 254,
						"w": 419
					},
					{
						"n": 9,
						"h": 400,
						"w": 561
					},
					{
						"n": 10,
						"h": 158,
						"w": 600
					},
					{
						"n": 11,
						"h": 275,
						"w": 619
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 17
					},
					{
						"n": 2,
						"h": 110,
						"w": 81
					},
					{
						"n": 3,
						"h": 191,
						"w": 87
					},
					{
						"n": 4,
						"h": 278,
						"w": 86
					},
					{
						"n": 5,
						"h": 353,
						"w": 229
					},
					{
						"n": 6,
						"h": 298,
						"w": 130
					},
					{
						"n": 7,
						"h": 262,
						"w": 252
					},
					{
						"n": 8,
						"h": 375,
						"w": 282
					},
					{
						"n": 9,
						"h": 47,
						"w": 291
					},
					{
						"n": 10,
						"h": 196,
						"w": 281
					},
					{
						"n": 11,
						"h": 316,
						"w": 311
					}
				],
				"ball": {
					"n": 0,
					"h": 89,
					"w": 471,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 65,
			"minute": 3,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 15
					},
					{
						"n": 2,
						"h": 58,
						"w": 350
					},
					{
						"n": 3,
						"h": 165,
						"w": 295
					},
					{
						"n": 4,
						"h": 271,
						"w": 301
					},
					{
						"n": 5,
						"h": 384,
						"w": 344
					},
					{
						"n": 6,
						"h": 42,
						"w": 471
					},
					{
						"n": 7,
						"h": 143,
						"w": 444
					},
					{
						"n": 8,
						"h": 225,
						"w": 391
					},
					{
						"n": 9,
						"h": 394,
						"w": 593
					},
					{
						"n": 10,
						"h": 165,
						"w": 602
					},
					{
						"n": 11,
						"h": 298,
						"w": 613
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 19
					},
					{
						"n": 2,
						"h": 110,
						"w": 87
					},
					{
						"n": 3,
						"h": 167,
						"w": 94
					},
					{
						"n": 4,
						"h": 266,
						"w": 104
					},
					{
						"n": 5,
						"h": 383,
						"w": 229
					},
					{
						"n": 6,
						"h": 276,
						"w": 135
					},
					{
						"n": 7,
						"h": 244,
						"w": 216
					},
					{
						"n": 8,
						"h": 389,
						"w": 237
					},
					{
						"n": 9,
						"h": 34,
						"w": 253
					},
					{
						"n": 10,
						"h": 225,
						"w": 309
					},
					{
						"n": 11,
						"h": 309,
						"w": 271
					}
				],
				"ball": {
					"n": 0,
					"h": 42,
					"w": 471,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 66,
			"minute": 3,
			"messages": [
				{
					"owner": 1,
					"mes": "Пас в центр..."
				},
				{
					"owner": 1,
					"mes": "Киран Нолан[08](Галвэй Юнайтед) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 16
					},
					{
						"n": 2,
						"h": 58,
						"w": 373
					},
					{
						"n": 3,
						"h": 184,
						"w": 312
					},
					{
						"n": 4,
						"h": 265,
						"w": 310
					},
					{
						"n": 5,
						"h": 376,
						"w": 358
					},
					{
						"n": 6,
						"h": 41,
						"w": 481
					},
					{
						"n": 7,
						"h": 155,
						"w": 498
					},
					{
						"n": 8,
						"h": 166,
						"w": 362
					},
					{
						"n": 9,
						"h": 400,
						"w": 594
					},
					{
						"n": 10,
						"h": 173,
						"w": 603
					},
					{
						"n": 11,
						"h": 292,
						"w": 630
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 12
					},
					{
						"n": 2,
						"h": 110,
						"w": 79
					},
					{
						"n": 3,
						"h": 171,
						"w": 74
					},
					{
						"n": 4,
						"h": 265,
						"w": 74
					},
					{
						"n": 5,
						"h": 384,
						"w": 219
					},
					{
						"n": 6,
						"h": 275,
						"w": 120
					},
					{
						"n": 7,
						"h": 304,
						"w": 206
					},
					{
						"n": 8,
						"h": 404,
						"w": 193
					},
					{
						"n": 9,
						"h": 21,
						"w": 221
					},
					{
						"n": 10,
						"h": 284,
						"w": 338
					},
					{
						"n": 11,
						"h": 277,
						"w": 293
					}
				],
				"ball": {
					"n": 0,
					"h": 166,
					"w": 362,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 67
		},
		{
			"num": 67,
			"minute": 3,
			"messages": [
				{
					"owner": 1,
					"mes": "Пасует вперед..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 19
					},
					{
						"n": 2,
						"h": 73,
						"w": 375
					},
					{
						"n": 3,
						"h": 172,
						"w": 305
					},
					{
						"n": 4,
						"h": 279,
						"w": 306
					},
					{
						"n": 5,
						"h": 359,
						"w": 401
					},
					{
						"n": 6,
						"h": 50,
						"w": 532
					},
					{
						"n": 7,
						"h": 205,
						"w": 513
					},
					{
						"n": 8,
						"h": 180,
						"w": 367
					},
					{
						"n": 9,
						"h": 403,
						"w": 610
					},
					{
						"n": 10,
						"h": 175,
						"w": 620
					},
					{
						"n": 11,
						"h": 282,
						"w": 630
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 13
					},
					{
						"n": 2,
						"h": 72,
						"w": 90
					},
					{
						"n": 3,
						"h": 185,
						"w": 63
					},
					{
						"n": 4,
						"h": 263,
						"w": 86
					},
					{
						"n": 5,
						"h": 382,
						"w": 167
					},
					{
						"n": 6,
						"h": 223,
						"w": 126
					},
					{
						"n": 7,
						"h": 252,
						"w": 200
					},
					{
						"n": 8,
						"h": 400,
						"w": 152
					},
					{
						"n": 9,
						"h": 45,
						"w": 221
					},
					{
						"n": 10,
						"h": 234,
						"w": 324
					},
					{
						"n": 11,
						"h": 261,
						"w": 293
					}
				],
				"ball": {
					"n": 0,
					"h": 312,
					"w": 412,
					"z": 0,
					"r": 0,
					"p": 1,
					"x": 0
				}
			},
			"interval": 52
		},
		{
			"num": 68,
			"minute": 3,
			"messages": [
				{
					"owner": 1,
					"mes": "Самуэль Кари Фридйонссон[05](Галвэй Юнайтед) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 17
					},
					{
						"n": 2,
						"h": 61,
						"w": 370
					},
					{
						"n": 3,
						"h": 183,
						"w": 314
					},
					{
						"n": 4,
						"h": 277,
						"w": 316
					},
					{
						"n": 5,
						"h": 335,
						"w": 420
					},
					{
						"n": 6,
						"h": 46,
						"w": 557
					},
					{
						"n": 7,
						"h": 184,
						"w": 527
					},
					{
						"n": 8,
						"h": 200,
						"w": 382
					},
					{
						"n": 9,
						"h": 416,
						"w": 602
					},
					{
						"n": 10,
						"h": 161,
						"w": 632
					},
					{
						"n": 11,
						"h": 291,
						"w": 635
					}
				],
				"away": [
					{
						"n": 1,
						"h": 221,
						"w": 18
					},
					{
						"n": 2,
						"h": 52,
						"w": 105
					},
					{
						"n": 3,
						"h": 171,
						"w": 57
					},
					{
						"n": 4,
						"h": 269,
						"w": 65
					},
					{
						"n": 5,
						"h": 377,
						"w": 143
					},
					{
						"n": 6,
						"h": 200,
						"w": 119
					},
					{
						"n": 7,
						"h": 267,
						"w": 180
					},
					{
						"n": 8,
						"h": 404,
						"w": 127
					},
					{
						"n": 9,
						"h": 63,
						"w": 238
					},
					{
						"n": 10,
						"h": 210,
						"w": 317
					},
					{
						"n": 11,
						"h": 275,
						"w": 306
					}
				],
				"ball": {
					"n": 0,
					"h": 335,
					"w": 420,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 25
		},
		{
			"num": 69,
			"minute": 3,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 19
					},
					{
						"n": 2,
						"h": 69,
						"w": 376
					},
					{
						"n": 3,
						"h": 175,
						"w": 318
					},
					{
						"n": 4,
						"h": 284,
						"w": 323
					},
					{
						"n": 5,
						"h": 327,
						"w": 463
					},
					{
						"n": 6,
						"h": 44,
						"w": 597
					},
					{
						"n": 7,
						"h": 160,
						"w": 540
					},
					{
						"n": 8,
						"h": 234,
						"w": 403
					},
					{
						"n": 9,
						"h": 406,
						"w": 563
					},
					{
						"n": 10,
						"h": 174,
						"w": 630
					},
					{
						"n": 11,
						"h": 275,
						"w": 636
					}
				],
				"away": [
					{
						"n": 1,
						"h": 229,
						"w": 16
					},
					{
						"n": 2,
						"h": 50,
						"w": 144
					},
					{
						"n": 3,
						"h": 191,
						"w": 71
					},
					{
						"n": 4,
						"h": 264,
						"w": 76
					},
					{
						"n": 5,
						"h": 368,
						"w": 104
					},
					{
						"n": 6,
						"h": 240,
						"w": 120
					},
					{
						"n": 7,
						"h": 232,
						"w": 178
					},
					{
						"n": 8,
						"h": 406,
						"w": 87
					},
					{
						"n": 9,
						"h": 112,
						"w": 241
					},
					{
						"n": 10,
						"h": 216,
						"w": 297
					},
					{
						"n": 11,
						"h": 293,
						"w": 291
					}
				],
				"ball": {
					"n": 0,
					"h": 327,
					"w": 463,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 70,
			"minute": 3,
			"messages": [
				{
					"owner": 1,
					"mes": "Пас в штрафную..."
				},
				{
					"owner": 1,
					"mes": "Оливье Дюмон[26](Опава) легко перехватывает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 17
					},
					{
						"n": 2,
						"h": 70,
						"w": 375
					},
					{
						"n": 3,
						"h": 176,
						"w": 329
					},
					{
						"n": 4,
						"h": 272,
						"w": 330
					},
					{
						"n": 5,
						"h": 334,
						"w": 448,
						"m": 590
					},
					{
						"n": 6,
						"h": 36,
						"w": 609
					},
					{
						"n": 7,
						"h": 164,
						"w": 585
					},
					{
						"n": 8,
						"h": 253,
						"w": 445
					},
					{
						"n": 9,
						"h": 401,
						"w": 609
					},
					{
						"n": 10,
						"h": 163,
						"w": 637
					},
					{
						"n": 11,
						"h": 260,
						"w": 599,
						"m": 590
					}
				],
				"away": [
					{
						"n": 1,
						"h": 221,
						"w": 14
					},
					{
						"n": 2,
						"h": 69,
						"w": 103
					},
					{
						"n": 3,
						"h": 203,
						"w": 69
					},
					{
						"n": 4,
						"h": 277,
						"w": 58
					},
					{
						"n": 5,
						"h": 340,
						"w": 72
					},
					{
						"n": 6,
						"h": 198,
						"w": 140
					},
					{
						"n": 7,
						"h": 219,
						"w": 139
					},
					{
						"n": 8,
						"h": 398,
						"w": 79
					},
					{
						"n": 9,
						"h": 87,
						"w": 232
					},
					{
						"n": 10,
						"h": 197,
						"w": 255
					},
					{
						"n": 11,
						"h": 290,
						"w": 297
					}
				],
				"ball": {
					"n": 0,
					"h": 252,
					"w": 580,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 46
		},
		{
			"num": 71,
			"minute": 3,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 17
					},
					{
						"n": 2,
						"h": 88,
						"w": 339
					},
					{
						"n": 3,
						"h": 139,
						"w": 319
					},
					{
						"n": 4,
						"h": 246,
						"w": 327
					},
					{
						"n": 5,
						"h": 342,
						"w": 409
					},
					{
						"n": 6,
						"h": 41,
						"w": 570
					},
					{
						"n": 7,
						"h": 153,
						"w": 547
					},
					{
						"n": 8,
						"h": 241,
						"w": 483
					},
					{
						"n": 9,
						"h": 405,
						"w": 569
					},
					{
						"n": 10,
						"h": 168,
						"w": 597
					},
					{
						"n": 11,
						"h": 265,
						"w": 559
					}
				],
				"away": [
					{
						"n": 1,
						"h": 223,
						"w": 10
					},
					{
						"n": 2,
						"h": 61,
						"w": 142
					},
					{
						"n": 3,
						"h": 178,
						"w": 100
					},
					{
						"n": 4,
						"h": 272,
						"w": 93
					},
					{
						"n": 5,
						"h": 358,
						"w": 89
					},
					{
						"n": 6,
						"h": 223,
						"w": 165,
						"m": 610
					},
					{
						"n": 7,
						"h": 209,
						"w": 178
					},
					{
						"n": 8,
						"h": 401,
						"w": 119
					},
					{
						"n": 9,
						"h": 75,
						"w": 270
					},
					{
						"n": 10,
						"h": 185,
						"w": 293
					},
					{
						"n": 11,
						"h": 330,
						"w": 295
					}
				],
				"ball": {
					"n": 0,
					"h": 227,
					"w": 555,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 72,
			"minute": 3,
			"messages": [
				{
					"owner": 2,
					"mes": "Оливье Дюмон[26](Опава) пасует назад..."
				},
				{
					"owner": 2,
					"mes": "Теперь с мячом Нир Мансур[23](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 12
					},
					{
						"n": 2,
						"h": 108,
						"w": 312
					},
					{
						"n": 3,
						"h": 172,
						"w": 311
					},
					{
						"n": 4,
						"h": 277,
						"w": 314
					},
					{
						"n": 5,
						"h": 346,
						"w": 375
					},
					{
						"n": 6,
						"h": 45,
						"w": 536
					},
					{
						"n": 7,
						"h": 156,
						"w": 530
					},
					{
						"n": 8,
						"h": 251,
						"w": 451
					},
					{
						"n": 9,
						"h": 402,
						"w": 535
					},
					{
						"n": 10,
						"h": 170,
						"w": 563
					},
					{
						"n": 11,
						"h": 267,
						"w": 592
					}
				],
				"away": [
					{
						"n": 1,
						"h": 228,
						"w": 18
					},
					{
						"n": 2,
						"h": 76,
						"w": 149
					},
					{
						"n": 3,
						"h": 183,
						"w": 108
					},
					{
						"n": 4,
						"h": 275,
						"w": 108
					},
					{
						"n": 5,
						"h": 372,
						"w": 102
					},
					{
						"n": 6,
						"h": 229,
						"w": 172
					},
					{
						"n": 7,
						"h": 213,
						"w": 212
					},
					{
						"n": 8,
						"h": 399,
						"w": 153
					},
					{
						"n": 9,
						"h": 97,
						"w": 296
					},
					{
						"n": 10,
						"h": 177,
						"w": 326
					},
					{
						"n": 11,
						"h": 364,
						"w": 293
					}
				],
				"ball": {
					"n": 0,
					"h": 267,
					"w": 612,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 34
		},
		{
			"num": 73,
			"minute": 4,
			"possession": 60,
			"messages": [
				{
					"owner": 2,
					"mes": "Пас направо..."
				},
				{
					"owner": 2,
					"mes": "Себастьян Пейша[24](Опава) технично принимает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 15
					},
					{
						"n": 2,
						"h": 138,
						"w": 304
					},
					{
						"n": 3,
						"h": 202,
						"w": 303
					},
					{
						"n": 4,
						"h": 304,
						"w": 300
					},
					{
						"n": 5,
						"h": 351,
						"w": 345
					},
					{
						"n": 6,
						"h": 51,
						"w": 505
					},
					{
						"n": 7,
						"h": 159,
						"w": 515
					},
					{
						"n": 8,
						"h": 259,
						"w": 421,
						"f": 98
					},
					{
						"n": 9,
						"h": 404,
						"w": 504,
						"f": 98
					},
					{
						"n": 10,
						"h": 175,
						"w": 592,
						"f": 98
					},
					{
						"n": 11,
						"h": 269,
						"w": 561
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 13
					},
					{
						"n": 2,
						"h": 58,
						"w": 152
					},
					{
						"n": 3,
						"h": 176,
						"w": 102
					},
					{
						"n": 4,
						"h": 275,
						"w": 108
					},
					{
						"n": 5,
						"h": 376,
						"w": 118
					},
					{
						"n": 6,
						"h": 256,
						"w": 188
					},
					{
						"n": 7,
						"h": 214,
						"w": 243
					},
					{
						"n": 8,
						"h": 402,
						"w": 184
					},
					{
						"n": 9,
						"h": 106,
						"w": 325
					},
					{
						"n": 10,
						"h": 165,
						"w": 355
					},
					{
						"n": 11,
						"h": 370,
						"w": 323
					}
				],
				"ball": {
					"n": 0,
					"h": 175,
					"w": 612,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 31
		},
		{
			"num": 74,
			"minute": 4,
			"messages": [
				{
					"owner": 2,
					"mes": "Себастьян Пейша[24](Опава) делает передачу направо на Ш.Товарека[31](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 19
					},
					{
						"n": 2,
						"h": 71,
						"w": 334
					},
					{
						"n": 3,
						"h": 173,
						"w": 266
					},
					{
						"n": 4,
						"h": 291,
						"w": 266
					},
					{
						"n": 5,
						"h": 333,
						"w": 274
					},
					{
						"n": 6,
						"h": 50,
						"w": 433
					},
					{
						"n": 7,
						"h": 162,
						"w": 478
					},
					{
						"n": 8,
						"h": 267,
						"w": 348
					},
					{
						"n": 9,
						"h": 406,
						"w": 431
					},
					{
						"n": 10,
						"h": 175,
						"w": 519
					},
					{
						"n": 11,
						"h": 279,
						"w": 488
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 13
					},
					{
						"n": 2,
						"h": 75,
						"w": 168
					},
					{
						"n": 3,
						"h": 165,
						"w": 116
					},
					{
						"n": 4,
						"h": 275,
						"w": 114
					},
					{
						"n": 5,
						"h": 389,
						"w": 134
					},
					{
						"n": 6,
						"h": 246,
						"w": 202
					},
					{
						"n": 7,
						"h": 257,
						"w": 302
					},
					{
						"n": 8,
						"h": 401,
						"w": 257
					},
					{
						"n": 9,
						"h": 174,
						"w": 353
					},
					{
						"n": 10,
						"h": 158,
						"w": 427
					},
					{
						"n": 11,
						"h": 412,
						"w": 365
					}
				],
				"ball": {
					"n": 0,
					"h": 38,
					"w": 355,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 73
		},
		{
			"num": 75,
			"minute": 4,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 18
					},
					{
						"n": 2,
						"h": 57,
						"w": 312
					},
					{
						"n": 3,
						"h": 207,
						"w": 244
					},
					{
						"n": 4,
						"h": 273,
						"w": 230
					},
					{
						"n": 5,
						"h": 330,
						"w": 234
					},
					{
						"n": 6,
						"h": 50,
						"w": 413
					},
					{
						"n": 7,
						"h": 163,
						"w": 438
					},
					{
						"n": 8,
						"h": 247,
						"w": 322
					},
					{
						"n": 9,
						"h": 405,
						"w": 391
					},
					{
						"n": 10,
						"h": 172,
						"w": 479
					},
					{
						"n": 11,
						"h": 280,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 19
					},
					{
						"n": 2,
						"h": 64,
						"w": 202
					},
					{
						"n": 3,
						"h": 170,
						"w": 156
					},
					{
						"n": 4,
						"h": 283,
						"w": 143
					},
					{
						"n": 5,
						"h": 379,
						"w": 140
					},
					{
						"n": 6,
						"h": 250,
						"w": 241
					},
					{
						"n": 7,
						"h": 238,
						"w": 321
					},
					{
						"n": 8,
						"h": 400,
						"w": 297
					},
					{
						"n": 9,
						"h": 197,
						"w": 385
					},
					{
						"n": 10,
						"h": 162,
						"w": 466
					},
					{
						"n": 11,
						"h": 423,
						"w": 388
					}
				],
				"ball": {
					"n": 0,
					"h": 27,
					"w": 332,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 76,
			"minute": 4,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 13
					},
					{
						"n": 2,
						"h": 56,
						"w": 286
					},
					{
						"n": 3,
						"h": 214,
						"w": 206
					},
					{
						"n": 4,
						"h": 277,
						"w": 191
					},
					{
						"n": 5,
						"h": 330,
						"w": 195
					},
					{
						"n": 6,
						"h": 48,
						"w": 374
					},
					{
						"n": 7,
						"h": 162,
						"w": 399
					},
					{
						"n": 8,
						"h": 250,
						"w": 283
					},
					{
						"n": 9,
						"h": 401,
						"w": 353
					},
					{
						"n": 10,
						"h": 169,
						"w": 440
					},
					{
						"n": 11,
						"h": 306,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 39
					},
					{
						"n": 2,
						"h": 65,
						"w": 241
					},
					{
						"n": 3,
						"h": 171,
						"w": 195
					},
					{
						"n": 4,
						"h": 285,
						"w": 182
					},
					{
						"n": 5,
						"h": 378,
						"w": 179
					},
					{
						"n": 6,
						"h": 249,
						"w": 280
					},
					{
						"n": 7,
						"h": 240,
						"w": 360
					},
					{
						"n": 8,
						"h": 407,
						"w": 335
					},
					{
						"n": 9,
						"h": 189,
						"w": 424
					},
					{
						"n": 10,
						"h": 167,
						"w": 505
					},
					{
						"n": 11,
						"h": 426,
						"w": 414
					}
				],
				"ball": {
					"n": 0,
					"h": 24,
					"w": 306,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 77,
			"minute": 4,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 11
					},
					{
						"n": 2,
						"h": 57,
						"w": 261
					},
					{
						"n": 3,
						"h": 203,
						"w": 169
					},
					{
						"n": 4,
						"h": 278,
						"w": 152
					},
					{
						"n": 5,
						"h": 330,
						"w": 156
					},
					{
						"n": 6,
						"h": 46,
						"w": 355
					},
					{
						"n": 7,
						"h": 163,
						"w": 360
					},
					{
						"n": 8,
						"h": 253,
						"w": 244
					},
					{
						"n": 9,
						"h": 398,
						"w": 314
					},
					{
						"n": 10,
						"h": 170,
						"w": 401
					},
					{
						"n": 11,
						"h": 309,
						"w": 441
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 61
					},
					{
						"n": 2,
						"h": 68,
						"w": 280
					},
					{
						"n": 3,
						"h": 170,
						"w": 234
					},
					{
						"n": 4,
						"h": 280,
						"w": 221
					},
					{
						"n": 5,
						"h": 381,
						"w": 218
					},
					{
						"n": 6,
						"h": 257,
						"w": 318
					},
					{
						"n": 7,
						"h": 241,
						"w": 398
					},
					{
						"n": 8,
						"h": 399,
						"w": 374
					},
					{
						"n": 9,
						"h": 185,
						"w": 462
					},
					{
						"n": 10,
						"h": 168,
						"w": 544
					},
					{
						"n": 11,
						"h": 423,
						"w": 439
					}
				],
				"ball": {
					"n": 0,
					"h": 27,
					"w": 281,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 78,
			"minute": 4,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 16
					},
					{
						"n": 2,
						"h": 60,
						"w": 236
					},
					{
						"n": 3,
						"h": 187,
						"w": 133
					},
					{
						"n": 4,
						"h": 277,
						"w": 113
					},
					{
						"n": 5,
						"h": 330,
						"w": 117
					},
					{
						"n": 6,
						"h": 47,
						"w": 336
					},
					{
						"n": 7,
						"h": 165,
						"w": 322
					},
					{
						"n": 8,
						"h": 259,
						"w": 206
					},
					{
						"n": 9,
						"h": 395,
						"w": 275
					},
					{
						"n": 10,
						"h": 169,
						"w": 398
					},
					{
						"n": 11,
						"h": 314,
						"w": 408
					}
				],
				"away": [
					{
						"n": 1,
						"h": 229,
						"w": 83
					},
					{
						"n": 2,
						"h": 67,
						"w": 319
					},
					{
						"n": 3,
						"h": 166,
						"w": 273
					},
					{
						"n": 4,
						"h": 281,
						"w": 260
					},
					{
						"n": 5,
						"h": 386,
						"w": 257
					},
					{
						"n": 6,
						"h": 256,
						"w": 357
					},
					{
						"n": 7,
						"h": 246,
						"w": 437
					},
					{
						"n": 8,
						"h": 403,
						"w": 412
					},
					{
						"n": 9,
						"h": 183,
						"w": 501
					},
					{
						"n": 10,
						"h": 177,
						"w": 582
					},
					{
						"n": 11,
						"h": 420,
						"w": 464
					}
				],
				"ball": {
					"n": 0,
					"h": 30,
					"w": 256,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 79,
			"minute": 4,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 13
					},
					{
						"n": 2,
						"h": 63,
						"w": 210
					},
					{
						"n": 3,
						"h": 213,
						"w": 104
					},
					{
						"n": 4,
						"h": 285,
						"w": 75
					},
					{
						"n": 5,
						"h": 330,
						"w": 85
					},
					{
						"n": 6,
						"h": 52,
						"w": 297
					},
					{
						"n": 7,
						"h": 168,
						"w": 283
					},
					{
						"n": 8,
						"h": 254,
						"w": 167
					},
					{
						"n": 9,
						"h": 402,
						"w": 236
					},
					{
						"n": 10,
						"h": 175,
						"w": 398
					},
					{
						"n": 11,
						"h": 310,
						"w": 408
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 106
					},
					{
						"n": 2,
						"h": 59,
						"w": 335
					},
					{
						"n": 3,
						"h": 169,
						"w": 284
					},
					{
						"n": 4,
						"h": 275,
						"w": 283
					},
					{
						"n": 5,
						"h": 382,
						"w": 295
					},
					{
						"n": 6,
						"h": 252,
						"w": 396
					},
					{
						"n": 7,
						"h": 254,
						"w": 475
					},
					{
						"n": 8,
						"h": 392,
						"w": 450
					},
					{
						"n": 9,
						"h": 188,
						"w": 540
					},
					{
						"n": 10,
						"h": 165,
						"w": 600
					},
					{
						"n": 11,
						"h": 417,
						"w": 490
					}
				],
				"ball": {
					"n": 0,
					"h": 33,
					"w": 230,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 80,
			"minute": 4,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 14
					},
					{
						"n": 2,
						"h": 67,
						"w": 182
					},
					{
						"n": 3,
						"h": 238,
						"w": 90
					},
					{
						"n": 4,
						"h": 282,
						"w": 87
					},
					{
						"n": 5,
						"h": 330,
						"w": 77
					},
					{
						"n": 6,
						"h": 54,
						"w": 259
					},
					{
						"n": 7,
						"h": 168,
						"w": 245
					},
					{
						"n": 8,
						"h": 284,
						"w": 145
					},
					{
						"n": 9,
						"h": 393,
						"w": 200
					},
					{
						"n": 10,
						"h": 166,
						"w": 398
					},
					{
						"n": 11,
						"h": 318,
						"w": 408
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 120
					},
					{
						"n": 2,
						"h": 68,
						"w": 342
					},
					{
						"n": 3,
						"h": 168,
						"w": 287
					},
					{
						"n": 4,
						"h": 284,
						"w": 311
					},
					{
						"n": 5,
						"h": 392,
						"w": 320
					},
					{
						"n": 6,
						"h": 235,
						"w": 409
					},
					{
						"n": 7,
						"h": 256,
						"w": 513
					},
					{
						"n": 8,
						"h": 415,
						"w": 452
					},
					{
						"n": 9,
						"h": 169,
						"w": 570
					},
					{
						"n": 10,
						"h": 191,
						"w": 600
					},
					{
						"n": 11,
						"h": 413,
						"w": 518
					}
				],
				"ball": {
					"n": 0,
					"h": 37,
					"w": 202,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 38
		},
		{
			"num": 81,
			"minute": 4,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 13
					},
					{
						"n": 2,
						"h": 86,
						"w": 182
					},
					{
						"n": 3,
						"h": 225,
						"w": 111
					},
					{
						"n": 4,
						"h": 279,
						"w": 122
					},
					{
						"n": 5,
						"h": 330,
						"w": 117
					},
					{
						"n": 6,
						"h": 55,
						"w": 219
					},
					{
						"n": 7,
						"h": 192,
						"w": 213
					},
					{
						"n": 8,
						"h": 283,
						"w": 178
					},
					{
						"n": 9,
						"h": 397,
						"w": 214
					},
					{
						"n": 10,
						"h": 170,
						"w": 400
					},
					{
						"n": 11,
						"h": 289,
						"w": 436
					}
				],
				"away": [
					{
						"n": 1,
						"h": 229,
						"w": 120
					},
					{
						"n": 2,
						"h": 70,
						"w": 302
					},
					{
						"n": 3,
						"h": 171,
						"w": 263
					},
					{
						"n": 4,
						"h": 280,
						"w": 271
					},
					{
						"n": 5,
						"h": 394,
						"w": 281
					},
					{
						"n": 6,
						"h": 261,
						"w": 418
					},
					{
						"n": 7,
						"h": 249,
						"w": 508
					},
					{
						"n": 8,
						"h": 427,
						"w": 490
					},
					{
						"n": 9,
						"h": 162,
						"w": 539
					},
					{
						"n": 10,
						"h": 170,
						"w": 589
					},
					{
						"n": 11,
						"h": 373,
						"w": 518
					}
				],
				"ball": {
					"n": 0,
					"h": 77,
					"w": 202,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 82,
			"minute": 4,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 16
					},
					{
						"n": 2,
						"h": 105,
						"w": 182
					},
					{
						"n": 3,
						"h": 244,
						"w": 106
					},
					{
						"n": 4,
						"h": 277,
						"w": 106
					},
					{
						"n": 5,
						"h": 330,
						"w": 105
					},
					{
						"n": 6,
						"h": 56,
						"w": 179
					},
					{
						"n": 7,
						"h": 143,
						"w": 194
					},
					{
						"n": 8,
						"h": 254,
						"w": 188
					},
					{
						"n": 9,
						"h": 422,
						"w": 214
					},
					{
						"n": 10,
						"h": 175,
						"w": 400
					},
					{
						"n": 11,
						"h": 317,
						"w": 417
					}
				],
				"away": [
					{
						"n": 1,
						"h": 223,
						"w": 123
					},
					{
						"n": 2,
						"h": 70,
						"w": 333
					},
					{
						"n": 3,
						"h": 168,
						"w": 274
					},
					{
						"n": 4,
						"h": 275,
						"w": 290
					},
					{
						"n": 5,
						"h": 381,
						"w": 276
					},
					{
						"n": 6,
						"h": 246,
						"w": 383
					},
					{
						"n": 7,
						"h": 250,
						"w": 508
					},
					{
						"n": 8,
						"h": 427,
						"w": 540
					},
					{
						"n": 9,
						"h": 201,
						"w": 531
					},
					{
						"n": 10,
						"h": 166,
						"w": 589
					},
					{
						"n": 11,
						"h": 350,
						"w": 518
					}
				],
				"ball": {
					"n": 0,
					"h": 100,
					"w": 202,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 83,
			"minute": 4,
			"messages": [
				{
					"owner": 2,
					"mes": "Даниэль Прохазка[28](Опава) подключается к атаке... Даниэль Прохазка[28](Опава) получает пас на ход..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 212,
						"w": 8
					},
					{
						"n": 2,
						"h": 102,
						"w": 152
					},
					{
						"n": 3,
						"h": 221,
						"w": 93
					},
					{
						"n": 4,
						"h": 253,
						"w": 100
					},
					{
						"n": 5,
						"h": 330,
						"w": 100
					},
					{
						"n": 6,
						"h": 45,
						"w": 140
					},
					{
						"n": 7,
						"h": 103,
						"w": 188
					},
					{
						"n": 8,
						"h": 241,
						"w": 150
					},
					{
						"n": 9,
						"h": 420,
						"w": 193
					},
					{
						"n": 10,
						"h": 172,
						"w": 400
					},
					{
						"n": 11,
						"h": 278,
						"w": 425
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 118
					},
					{
						"n": 2,
						"h": 59,
						"w": 316
					},
					{
						"n": 3,
						"h": 172,
						"w": 279
					},
					{
						"n": 4,
						"h": 278,
						"w": 294
					},
					{
						"n": 5,
						"h": 387,
						"w": 286
					},
					{
						"n": 6,
						"h": 270,
						"w": 369
					},
					{
						"n": 7,
						"h": 252,
						"w": 468
					},
					{
						"n": 8,
						"h": 427,
						"w": 590
					},
					{
						"n": 9,
						"h": 215,
						"w": 567
					},
					{
						"n": 10,
						"h": 162,
						"w": 610
					},
					{
						"n": 11,
						"h": 350,
						"w": 518
					}
				],
				"ball": {
					"n": 0,
					"h": 23,
					"w": 130,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 84,
			"minute": 4,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 211,
						"w": 6
					},
					{
						"n": 2,
						"h": 96,
						"w": 102
					},
					{
						"n": 3,
						"h": 222,
						"w": 58
					},
					{
						"n": 4,
						"h": 239,
						"w": 70
					},
					{
						"n": 5,
						"h": 330,
						"w": 50
					},
					{
						"n": 6,
						"h": 40,
						"w": 87
					},
					{
						"n": 7,
						"h": 114,
						"w": 150
					},
					{
						"n": 8,
						"h": 239,
						"w": 123
					},
					{
						"n": 9,
						"h": 414,
						"w": 174
					},
					{
						"n": 10,
						"h": 178,
						"w": 390
					},
					{
						"n": 11,
						"h": 277,
						"w": 400
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 119
					},
					{
						"n": 2,
						"h": 60,
						"w": 354
					},
					{
						"n": 3,
						"h": 173,
						"w": 309
					},
					{
						"n": 4,
						"h": 272,
						"w": 292
					},
					{
						"n": 5,
						"h": 386,
						"w": 293
					},
					{
						"n": 6,
						"h": 249,
						"w": 404
					},
					{
						"n": 7,
						"h": 245,
						"w": 507
					},
					{
						"n": 8,
						"h": 427,
						"w": 631
					},
					{
						"n": 9,
						"h": 205,
						"w": 606
					},
					{
						"n": 10,
						"h": 196,
						"w": 630
					},
					{
						"n": 11,
						"h": 336,
						"w": 556
					}
				],
				"ball": {
					"n": 0,
					"h": 23,
					"w": 89,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 85,
			"minute": 4,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 211,
						"w": 4
					},
					{
						"n": 2,
						"h": 93,
						"w": 78
					},
					{
						"n": 3,
						"h": 220,
						"w": 50
					},
					{
						"n": 4,
						"h": 236,
						"w": 55
					},
					{
						"n": 5,
						"h": 330,
						"w": 48
					},
					{
						"n": 6,
						"h": 40,
						"w": 64
					},
					{
						"n": 7,
						"h": 112,
						"w": 130
					},
					{
						"n": 8,
						"h": 248,
						"w": 105
					},
					{
						"n": 9,
						"h": 418,
						"w": 154
					},
					{
						"n": 10,
						"h": 172,
						"w": 390
					},
					{
						"n": 11,
						"h": 275,
						"w": 400
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 126
					},
					{
						"n": 2,
						"h": 62,
						"w": 343
					},
					{
						"n": 3,
						"h": 175,
						"w": 309
					},
					{
						"n": 4,
						"h": 278,
						"w": 309
					},
					{
						"n": 5,
						"h": 385,
						"w": 313
					},
					{
						"n": 6,
						"h": 249,
						"w": 424
					},
					{
						"n": 7,
						"h": 245,
						"w": 527
					},
					{
						"n": 8,
						"h": 427,
						"w": 656
					},
					{
						"n": 9,
						"h": 202,
						"w": 623
					},
					{
						"n": 10,
						"h": 191,
						"w": 650
					},
					{
						"n": 11,
						"h": 334,
						"w": 576
					}
				],
				"ball": {
					"n": 0,
					"h": 23,
					"w": 64,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 20
		},
		{
			"num": 86,
			"minute": 4,
			"messages": [
				{
					"owner": 2,
					"mes": "Прострел вдоль лицевой линии..."
				},
				{
					"owner": 2,
					"mes": "Патрик Клинтон[03](Галвэй Юнайтед) выбивает мяч из штрафной..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 211,
						"w": 4
					},
					{
						"n": 2,
						"h": 84,
						"w": 37
					},
					{
						"n": 3,
						"h": 187,
						"w": 49
					},
					{
						"n": 4,
						"h": 194,
						"w": 49
					},
					{
						"n": 5,
						"h": 330,
						"w": 35
					},
					{
						"n": 6,
						"h": 39,
						"w": 50
					},
					{
						"n": 7,
						"h": 102,
						"w": 114
					},
					{
						"n": 8,
						"h": 251,
						"w": 72
					},
					{
						"n": 9,
						"h": 397,
						"w": 140
					},
					{
						"n": 10,
						"h": 174,
						"w": 390
					},
					{
						"n": 11,
						"h": 280,
						"w": 400
					}
				],
				"away": [
					{
						"n": 1,
						"h": 223,
						"w": 123
					},
					{
						"n": 2,
						"h": 69,
						"w": 359
					},
					{
						"n": 3,
						"h": 170,
						"w": 308
					},
					{
						"n": 4,
						"h": 276,
						"w": 309
					},
					{
						"n": 5,
						"h": 386,
						"w": 307
					},
					{
						"n": 6,
						"h": 250,
						"w": 457
					},
					{
						"n": 7,
						"h": 244,
						"w": 560
					},
					{
						"n": 8,
						"h": 427,
						"w": 656
					},
					{
						"n": 9,
						"h": 193,
						"w": 633
					},
					{
						"n": 10,
						"h": 223,
						"w": 659
					},
					{
						"n": 11,
						"h": 347,
						"w": 606
					}
				],
				"ball": {
					"n": 0,
					"h": 187,
					"w": 49,
					"z": 0,
					"r": 0,
					"p": 1,
					"x": 0
				}
			},
			"interval": 33
		},
		{
			"num": 87,
			"minute": 4,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 216,
						"w": 12
					},
					{
						"n": 2,
						"h": 114,
						"w": 86
					},
					{
						"n": 3,
						"h": 223,
						"w": 57
					},
					{
						"n": 4,
						"h": 254,
						"w": 34
					},
					{
						"n": 5,
						"h": 330,
						"w": 43
					},
					{
						"n": 6,
						"h": 39,
						"w": 50
					},
					{
						"n": 7,
						"h": 58,
						"w": 182
					},
					{
						"n": 8,
						"h": 233,
						"w": 90
					},
					{
						"n": 9,
						"h": 390,
						"w": 221
					},
					{
						"n": 10,
						"h": 199,
						"w": 390
					},
					{
						"n": 11,
						"h": 284,
						"w": 400
					}
				],
				"away": [
					{
						"n": 1,
						"h": 223,
						"w": 123
					},
					{
						"n": 2,
						"h": 69,
						"w": 354
					},
					{
						"n": 3,
						"h": 166,
						"w": 300
					},
					{
						"n": 4,
						"h": 276,
						"w": 318
					},
					{
						"n": 5,
						"h": 416,
						"w": 382
					},
					{
						"n": 6,
						"h": 251,
						"w": 395
					},
					{
						"n": 7,
						"h": 275,
						"w": 492
					},
					{
						"n": 8,
						"h": 427,
						"w": 656
					},
					{
						"n": 9,
						"h": 170,
						"w": 661
					},
					{
						"n": 10,
						"h": 216,
						"w": 652
					},
					{
						"n": 11,
						"h": 344,
						"w": 626
					}
				],
				"ball": {
					"n": 0,
					"h": -55,
					"w": 263,
					"z": 1,
					"r": 0,
					"p": 1,
					"x": 1
				}
			},
			"interval": 81
		},
		{
			"num": 88,
			"minute": 4,
			"messages": [
				{
					"owner": 2,
					"mes": "Мяч из аута будет вводить в игру Д.Прохазка[28](Опава)..."
				},
				{
					"owner": 2,
					"mes": "Д.Прохазка[28](Опава) вбрасывает из-за боковой..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 11
					},
					{
						"n": 2,
						"h": 90,
						"w": 98
					},
					{
						"n": 3,
						"h": 137,
						"w": 88
					},
					{
						"n": 4,
						"h": 235,
						"w": 86
					},
					{
						"n": 5,
						"h": 330,
						"w": 85
					},
					{
						"n": 6,
						"h": 56,
						"w": 266
					},
					{
						"n": 7,
						"h": 167,
						"w": 210
					},
					{
						"n": 8,
						"h": 290,
						"w": 212
					},
					{
						"n": 9,
						"h": 394,
						"w": 195
					},
					{
						"n": 10,
						"h": 156,
						"w": 360
					},
					{
						"n": 11,
						"h": 303,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 40
					},
					{
						"n": 2,
						"h": 60,
						"w": 239
					},
					{
						"n": 3,
						"h": 156,
						"w": 228
					},
					{
						"n": 4,
						"h": 334,
						"w": 222
					},
					{
						"n": 5,
						"h": 419,
						"w": 419
					},
					{
						"n": 6,
						"h": 347,
						"w": 308
					},
					{
						"n": 7,
						"h": 343,
						"w": 405
					},
					{
						"n": 8,
						"h": 450,
						"w": 457
					},
					{
						"n": 9,
						"h": 49,
						"w": 490
					},
					{
						"n": 10,
						"h": 166,
						"w": 580
					},
					{
						"n": 11,
						"h": 351,
						"w": 559
					}
				],
				"ball": {
					"n": 0,
					"h": 0,
					"w": 263,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 176
		},
		{
			"num": 89,
			"minute": 4,
			"messages": [
				{
					"owner": 2,
					"mes": "Мирослав Манолов[27](Опава) получает мяч..."
				}
			],
			"A": {
				"team": 2
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 12
					},
					{
						"n": 2,
						"h": 84,
						"w": 138
					},
					{
						"n": 3,
						"h": 176,
						"w": 95
					},
					{
						"n": 4,
						"h": 273,
						"w": 100
					},
					{
						"n": 5,
						"h": 301,
						"w": 112
					},
					{
						"n": 6,
						"h": 56,
						"w": 228
					},
					{
						"n": 7,
						"h": 175,
						"w": 182
					},
					{
						"n": 8,
						"h": 252,
						"w": 201
					},
					{
						"n": 9,
						"h": 394,
						"w": 230
					},
					{
						"n": 10,
						"h": 127,
						"w": 333
					},
					{
						"n": 11,
						"h": 313,
						"w": 435
					}
				],
				"away": [
					{
						"n": 1,
						"h": 228,
						"w": 61
					},
					{
						"n": 2,
						"h": 63,
						"w": 278
					},
					{
						"n": 3,
						"h": 178,
						"w": 261
					},
					{
						"n": 4,
						"h": 302,
						"w": 247
					},
					{
						"n": 5,
						"h": 410,
						"w": 380
					},
					{
						"n": 6,
						"h": 314,
						"w": 330
					},
					{
						"n": 7,
						"h": 343,
						"w": 405
					},
					{
						"n": 8,
						"h": 450,
						"w": 457
					},
					{
						"n": 9,
						"h": 49,
						"w": 455
					},
					{
						"n": 10,
						"h": 136,
						"w": 590
					},
					{
						"n": 11,
						"h": 380,
						"w": 532
					}
				],
				"ball": {
					"n": 0,
					"h": 107,
					"w": 315,
					"z": 1,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 90,
			"minute": 5,
			"possession": 48,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 18
					},
					{
						"n": 2,
						"h": 69,
						"w": 175,
						"f": 98
					},
					{
						"n": 3,
						"h": 214,
						"w": 109
					},
					{
						"n": 4,
						"h": 285,
						"w": 126
					},
					{
						"n": 5,
						"h": 330,
						"w": 111,
						"f": 98
					},
					{
						"n": 6,
						"h": 61,
						"w": 192,
						"f": 98
					},
					{
						"n": 7,
						"h": 151,
						"w": 214,
						"f": 98
					},
					{
						"n": 8,
						"h": 239,
						"w": 189
					},
					{
						"n": 9,
						"h": 383,
						"w": 194
					},
					{
						"n": 10,
						"h": 122,
						"w": 313
					},
					{
						"n": 11,
						"h": 316,
						"w": 433,
						"f": 98
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 85
					},
					{
						"n": 2,
						"h": 72,
						"w": 318,
						"f": 95
					},
					{
						"n": 3,
						"h": 169,
						"w": 261
					},
					{
						"n": 4,
						"h": 286,
						"w": 262
					},
					{
						"n": 5,
						"h": 399,
						"w": 341,
						"f": 97
					},
					{
						"n": 6,
						"h": 277,
						"w": 347,
						"f": 97
					},
					{
						"n": 7,
						"h": 335,
						"w": 440
					},
					{
						"n": 8,
						"h": 434,
						"w": 493,
						"f": 96
					},
					{
						"n": 9,
						"h": 67,
						"w": 491,
						"f": 97
					},
					{
						"n": 10,
						"h": 161,
						"w": 571,
						"f": 97
					},
					{
						"n": 11,
						"h": 389,
						"w": 493,
						"f": 97
					}
				],
				"ball": {
					"n": 0,
					"h": 115,
					"w": 280,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 91,
			"minute": 5,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 14
					},
					{
						"n": 2,
						"h": 56,
						"w": 175
					},
					{
						"n": 3,
						"h": 254,
						"w": 112
					},
					{
						"n": 4,
						"h": 303,
						"w": 111
					},
					{
						"n": 5,
						"h": 342,
						"w": 111
					},
					{
						"n": 6,
						"h": 57,
						"w": 232
					},
					{
						"n": 7,
						"h": 131,
						"w": 226
					},
					{
						"n": 8,
						"h": 270,
						"w": 188
					},
					{
						"n": 9,
						"h": 399,
						"w": 221
					},
					{
						"n": 10,
						"h": 141,
						"w": 349
					},
					{
						"n": 11,
						"h": 279,
						"w": 446
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 101
					},
					{
						"n": 2,
						"h": 56,
						"w": 296
					},
					{
						"n": 3,
						"h": 171,
						"w": 259
					},
					{
						"n": 4,
						"h": 282,
						"w": 245
					},
					{
						"n": 5,
						"h": 384,
						"w": 304
					},
					{
						"n": 6,
						"h": 239,
						"w": 356
					},
					{
						"n": 7,
						"h": 321,
						"w": 476
					},
					{
						"n": 8,
						"h": 428,
						"w": 533
					},
					{
						"n": 9,
						"h": 93,
						"w": 521
					},
					{
						"n": 10,
						"h": 136,
						"w": 563
					},
					{
						"n": 11,
						"h": 393,
						"w": 453
					}
				],
				"ball": {
					"n": 0,
					"h": 129,
					"w": 244,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 92,
			"minute": 5,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 16
					},
					{
						"n": 2,
						"h": 56,
						"w": 179
					},
					{
						"n": 3,
						"h": 257,
						"w": 115
					},
					{
						"n": 4,
						"h": 303,
						"w": 115
					},
					{
						"n": 5,
						"h": 343,
						"w": 115
					},
					{
						"n": 6,
						"h": 57,
						"w": 232
					},
					{
						"n": 7,
						"h": 131,
						"w": 230
					},
					{
						"n": 8,
						"h": 274,
						"w": 187
					},
					{
						"n": 9,
						"h": 403,
						"w": 221
					},
					{
						"n": 10,
						"h": 143,
						"w": 352
					},
					{
						"n": 11,
						"h": 279,
						"w": 446
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 105
					},
					{
						"n": 2,
						"h": 59,
						"w": 298
					},
					{
						"n": 3,
						"h": 175,
						"w": 260
					},
					{
						"n": 4,
						"h": 279,
						"w": 248
					},
					{
						"n": 5,
						"h": 384,
						"w": 300
					},
					{
						"n": 6,
						"h": 236,
						"w": 359
					},
					{
						"n": 7,
						"h": 320,
						"w": 480
					},
					{
						"n": 8,
						"h": 426,
						"w": 537
					},
					{
						"n": 9,
						"h": 97,
						"w": 520
					},
					{
						"n": 10,
						"h": 140,
						"w": 564
					},
					{
						"n": 11,
						"h": 393,
						"w": 449
					}
				],
				"ball": {
					"n": 0,
					"h": 130,
					"w": 240,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 4
		},
		{
			"num": 93,
			"minute": 5,
			"messages": [
				{
					"owner": 2,
					"mes": "М.Манолов[27](Опава) пытается переиграть А.Хлинссона[07](Галвэй Юнайтед)..."
				},
				{
					"owner": 2,
					"mes": "А.Хлинссон[07](Галвэй Юнайтед) отбирает мяч у М.Манолова[27](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 17
					},
					{
						"n": 2,
						"h": 56,
						"w": 180
					},
					{
						"n": 3,
						"h": 260,
						"w": 118
					},
					{
						"n": 4,
						"h": 303,
						"w": 117
					},
					{
						"n": 5,
						"h": 344,
						"w": 116
					},
					{
						"n": 6,
						"h": 57,
						"w": 232
					},
					{
						"n": 7,
						"h": 130,
						"w": 235,
						"m": 620
					},
					{
						"n": 8,
						"h": 279,
						"w": 185
					},
					{
						"n": 9,
						"h": 408,
						"w": 221
					},
					{
						"n": 10,
						"h": 145,
						"w": 357
					},
					{
						"n": 11,
						"h": 279,
						"w": 446
					}
				],
				"away": [
					{
						"n": 1,
						"h": 228,
						"w": 110
					},
					{
						"n": 2,
						"h": 62,
						"w": 300
					},
					{
						"n": 3,
						"h": 180,
						"w": 262
					},
					{
						"n": 4,
						"h": 276,
						"w": 252
					},
					{
						"n": 5,
						"h": 383,
						"w": 295
					},
					{
						"n": 6,
						"h": 232,
						"w": 362
					},
					{
						"n": 7,
						"h": 320,
						"w": 489
					},
					{
						"n": 8,
						"h": 424,
						"w": 541
					},
					{
						"n": 9,
						"h": 102,
						"w": 520
					},
					{
						"n": 10,
						"h": 145,
						"w": 564
					},
					{
						"n": 11,
						"h": 393,
						"w": 444
					}
				],
				"ball": {
					"n": 0,
					"h": 130,
					"w": 235,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 5
		},
		{
			"num": 94,
			"minute": 5,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 17
					},
					{
						"n": 2,
						"h": 56,
						"w": 180
					},
					{
						"n": 3,
						"h": 267,
						"w": 125
					},
					{
						"n": 4,
						"h": 303,
						"w": 117
					},
					{
						"n": 5,
						"h": 344,
						"w": 116
					},
					{
						"n": 6,
						"h": 57,
						"w": 232
					},
					{
						"n": 7,
						"h": 129,
						"w": 245
					},
					{
						"n": 8,
						"h": 288,
						"w": 182
					},
					{
						"n": 9,
						"h": 418,
						"w": 221
					},
					{
						"n": 10,
						"h": 150,
						"w": 365
					},
					{
						"n": 11,
						"h": 279,
						"w": 446
					}
				],
				"away": [
					{
						"n": 1,
						"h": 229,
						"w": 120
					},
					{
						"n": 2,
						"h": 62,
						"w": 300
					},
					{
						"n": 3,
						"h": 180,
						"w": 262
					},
					{
						"n": 4,
						"h": 273,
						"w": 255
					},
					{
						"n": 5,
						"h": 382,
						"w": 286
					},
					{
						"n": 6,
						"h": 225,
						"w": 369
					},
					{
						"n": 7,
						"h": 320,
						"w": 489
					},
					{
						"n": 8,
						"h": 420,
						"w": 550
					},
					{
						"n": 9,
						"h": 112,
						"w": 518
					},
					{
						"n": 10,
						"h": 155,
						"w": 566
					},
					{
						"n": 11,
						"h": 392,
						"w": 434
					}
				],
				"ball": {
					"n": 0,
					"h": 129,
					"w": 245,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 10
		},
		{
			"num": 95,
			"minute": 5,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 19
					},
					{
						"n": 2,
						"h": 66,
						"w": 209
					},
					{
						"n": 3,
						"h": 230,
						"w": 140
					},
					{
						"n": 4,
						"h": 281,
						"w": 151
					},
					{
						"n": 5,
						"h": 362,
						"w": 152
					},
					{
						"n": 6,
						"h": 57,
						"w": 272
					},
					{
						"n": 7,
						"h": 157,
						"w": 273
					},
					{
						"n": 8,
						"h": 291,
						"w": 222
					},
					{
						"n": 9,
						"h": 415,
						"w": 261
					},
					{
						"n": 10,
						"h": 149,
						"w": 405
					},
					{
						"n": 11,
						"h": 301,
						"w": 458
					}
				],
				"away": [
					{
						"n": 1,
						"h": 234,
						"w": 80
					},
					{
						"n": 2,
						"h": 91,
						"w": 273
					},
					{
						"n": 3,
						"h": 166,
						"w": 257
					},
					{
						"n": 4,
						"h": 276,
						"w": 251
					},
					{
						"n": 5,
						"h": 348,
						"w": 264
					},
					{
						"n": 6,
						"h": 264,
						"w": 400
					},
					{
						"n": 7,
						"h": 315,
						"w": 479
					},
					{
						"n": 8,
						"h": 419,
						"w": 510
					},
					{
						"n": 9,
						"h": 139,
						"w": 489
					},
					{
						"n": 10,
						"h": 157,
						"w": 526
					},
					{
						"n": 11,
						"h": 345,
						"w": 435
					}
				],
				"ball": {
					"n": 0,
					"h": 157,
					"w": 273,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 96,
			"minute": 5,
			"messages": [
				{
					"owner": 1,
					"mes": "Коротким пасом А.Хлинссон[07](Галвэй Юнайтед) отправляет мяч на К.Нолана[08](Галвэй Юнайтед)..."
				},
				{
					"owner": 1,
					"mes": "Киран Нолан[08](Галвэй Юнайтед) достает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 10
					},
					{
						"n": 2,
						"h": 77,
						"w": 220
					},
					{
						"n": 3,
						"h": 196,
						"w": 157
					},
					{
						"n": 4,
						"h": 283,
						"w": 161
					},
					{
						"n": 5,
						"h": 376,
						"w": 187
					},
					{
						"n": 6,
						"h": 57,
						"w": 310
					},
					{
						"n": 7,
						"h": 157,
						"w": 273,
						"m": 630
					},
					{
						"n": 8,
						"h": 273,
						"w": 269
					},
					{
						"n": 9,
						"h": 415,
						"w": 299
					},
					{
						"n": 10,
						"h": 172,
						"w": 435
					},
					{
						"n": 11,
						"h": 292,
						"w": 469
					}
				],
				"away": [
					{
						"n": 1,
						"h": 226,
						"w": 71
					},
					{
						"n": 2,
						"h": 104,
						"w": 237
					},
					{
						"n": 3,
						"h": 178,
						"w": 236
					},
					{
						"n": 4,
						"h": 261,
						"w": 242
					},
					{
						"n": 5,
						"h": 340,
						"w": 228
					},
					{
						"n": 6,
						"h": 271,
						"w": 362
					},
					{
						"n": 7,
						"h": 291,
						"w": 449
					},
					{
						"n": 8,
						"h": 419,
						"w": 472
					},
					{
						"n": 9,
						"h": 128,
						"w": 474
					},
					{
						"n": 10,
						"h": 165,
						"w": 489
					},
					{
						"n": 11,
						"h": 308,
						"w": 429
					}
				],
				"ball": {
					"n": 0,
					"h": 273,
					"w": 269,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 38
		},
		{
			"num": 97,
			"minute": 5,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 12
					},
					{
						"n": 2,
						"h": 67,
						"w": 235
					},
					{
						"n": 3,
						"h": 183,
						"w": 178
					},
					{
						"n": 4,
						"h": 283,
						"w": 184
					},
					{
						"n": 5,
						"h": 386,
						"w": 218
					},
					{
						"n": 6,
						"h": 56,
						"w": 350
					},
					{
						"n": 7,
						"h": 161,
						"w": 313
					},
					{
						"n": 8,
						"h": 273,
						"w": 304
					},
					{
						"n": 9,
						"h": 411,
						"w": 339
					},
					{
						"n": 10,
						"h": 175,
						"w": 470
					},
					{
						"n": 11,
						"h": 280,
						"w": 493
					}
				],
				"away": [
					{
						"n": 1,
						"h": 226,
						"w": 74
					},
					{
						"n": 2,
						"h": 110,
						"w": 234
					},
					{
						"n": 3,
						"h": 187,
						"w": 231
					},
					{
						"n": 4,
						"h": 255,
						"w": 222
					},
					{
						"n": 5,
						"h": 340,
						"w": 228
					},
					{
						"n": 6,
						"h": 233,
						"w": 374
					},
					{
						"n": 7,
						"h": 277,
						"w": 412
					},
					{
						"n": 8,
						"h": 412,
						"w": 433
					},
					{
						"n": 9,
						"h": 101,
						"w": 445
					},
					{
						"n": 10,
						"h": 169,
						"w": 449
					},
					{
						"n": 11,
						"h": 284,
						"w": 397
					}
				],
				"ball": {
					"n": 0,
					"h": 273,
					"w": 304,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 98,
			"minute": 5,
			"messages": [
				{
					"owner": 1,
					"mes": "Передача вперед на А.Гилберта[11](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 14
					},
					{
						"n": 2,
						"h": 65,
						"w": 254
					},
					{
						"n": 3,
						"h": 180,
						"w": 191
					},
					{
						"n": 4,
						"h": 268,
						"w": 189
					},
					{
						"n": 5,
						"h": 386,
						"w": 247
					},
					{
						"n": 6,
						"h": 56,
						"w": 399
					},
					{
						"n": 7,
						"h": 157,
						"w": 362
					},
					{
						"n": 8,
						"h": 277,
						"w": 304,
						"m": 600
					},
					{
						"n": 9,
						"h": 403,
						"w": 387
					},
					{
						"n": 10,
						"h": 178,
						"w": 475
					},
					{
						"n": 11,
						"h": 308,
						"w": 452
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 77
					},
					{
						"n": 2,
						"h": 137,
						"w": 275
					},
					{
						"n": 3,
						"h": 170,
						"w": 186
					},
					{
						"n": 4,
						"h": 274,
						"w": 209
					},
					{
						"n": 5,
						"h": 340,
						"w": 191
					},
					{
						"n": 6,
						"h": 245,
						"w": 327
					},
					{
						"n": 7,
						"h": 252,
						"w": 370
					},
					{
						"n": 8,
						"h": 406,
						"w": 384
					},
					{
						"n": 9,
						"h": 84,
						"w": 398
					},
					{
						"n": 10,
						"h": 173,
						"w": 400
					},
					{
						"n": 11,
						"h": 290,
						"w": 394
					}
				],
				"ball": {
					"n": 0,
					"h": 313,
					"w": 445,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 49
		},
		{
			"num": 99,
			"minute": 5,
			"messages": [
				{
					"owner": 1,
					"mes": "Лука Седлачек[22](Опава) классно перехватывает мяч!..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 18
					},
					{
						"n": 2,
						"h": 82,
						"w": 217
					},
					{
						"n": 3,
						"h": 171,
						"w": 182
					},
					{
						"n": 4,
						"h": 266,
						"w": 181
					},
					{
						"n": 5,
						"h": 376,
						"w": 266
					},
					{
						"n": 6,
						"h": 56,
						"w": 359
					},
					{
						"n": 7,
						"h": 175,
						"w": 326
					},
					{
						"n": 8,
						"h": 287,
						"w": 265
					},
					{
						"n": 9,
						"h": 411,
						"w": 348
					},
					{
						"n": 10,
						"h": 176,
						"w": 435
					},
					{
						"n": 11,
						"h": 333,
						"w": 421
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 94
					},
					{
						"n": 2,
						"h": 107,
						"w": 292,
						"m": 610
					},
					{
						"n": 3,
						"h": 179,
						"w": 194
					},
					{
						"n": 4,
						"h": 275,
						"w": 190
					},
					{
						"n": 5,
						"h": 373,
						"w": 213
					},
					{
						"n": 6,
						"h": 240,
						"w": 295
					},
					{
						"n": 7,
						"h": 231,
						"w": 400
					},
					{
						"n": 8,
						"h": 405,
						"w": 424
					},
					{
						"n": 9,
						"h": 65,
						"w": 434
					},
					{
						"n": 10,
						"h": 164,
						"w": 439
					},
					{
						"n": 11,
						"h": 299,
						"w": 433
					}
				],
				"ball": {
					"n": 0,
					"h": 343,
					"w": 428,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 100,
			"minute": 5,
			"messages": [
				{
					"owner": 2,
					"mes": "Лука Седлачек[22](Опава) отправляет мяч направо..."
				},
				{
					"owner": 2,
					"mes": "Оливье Дюмон[26](Опава) получил мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 13
					},
					{
						"n": 2,
						"h": 71,
						"w": 237
					},
					{
						"n": 3,
						"h": 205,
						"w": 160
					},
					{
						"n": 4,
						"h": 294,
						"w": 153
					},
					{
						"n": 5,
						"h": 369,
						"w": 227
					},
					{
						"n": 6,
						"h": 58,
						"w": 319
					},
					{
						"n": 7,
						"h": 150,
						"w": 295
					},
					{
						"n": 8,
						"h": 282,
						"w": 237
					},
					{
						"n": 9,
						"h": 409,
						"w": 328
					},
					{
						"n": 10,
						"h": 145,
						"w": 410
					},
					{
						"n": 11,
						"h": 312,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 105
					},
					{
						"n": 2,
						"h": 100,
						"w": 285,
						"m": 620
					},
					{
						"n": 3,
						"h": 175,
						"w": 204
					},
					{
						"n": 4,
						"h": 282,
						"w": 214
					},
					{
						"n": 5,
						"h": 386,
						"w": 243
					},
					{
						"n": 6,
						"h": 225,
						"w": 268
					},
					{
						"n": 7,
						"h": 232,
						"w": 410
					},
					{
						"n": 8,
						"h": 409,
						"w": 463
					},
					{
						"n": 9,
						"h": 105,
						"w": 439
					},
					{
						"n": 10,
						"h": 158,
						"w": 479
					},
					{
						"n": 11,
						"h": 338,
						"w": 428
					}
				],
				"ball": {
					"n": 0,
					"h": 225,
					"w": 452,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 101,
			"minute": 5,
			"messages": [
				{
					"owner": 2,
					"mes": "Оливье Дюмон[26](Опава) делает передачу направо на Т.Прохазку[25](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 14
					},
					{
						"n": 2,
						"h": 97,
						"w": 235
					},
					{
						"n": 3,
						"h": 216,
						"w": 151
					},
					{
						"n": 4,
						"h": 306,
						"w": 162
					},
					{
						"n": 5,
						"h": 357,
						"w": 185
					},
					{
						"n": 6,
						"h": 47,
						"w": 298
					},
					{
						"n": 7,
						"h": 177,
						"w": 260
					},
					{
						"n": 8,
						"h": 317,
						"w": 216
					},
					{
						"n": 9,
						"h": 417,
						"w": 285
					},
					{
						"n": 10,
						"h": 144,
						"w": 400
					},
					{
						"n": 11,
						"h": 282,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 107
					},
					{
						"n": 2,
						"h": 75,
						"w": 268
					},
					{
						"n": 3,
						"h": 168,
						"w": 220
					},
					{
						"n": 4,
						"h": 279,
						"w": 209
					},
					{
						"n": 5,
						"h": 356,
						"w": 259
					},
					{
						"n": 6,
						"h": 230,
						"w": 277,
						"m": 620
					},
					{
						"n": 7,
						"h": 259,
						"w": 405
					},
					{
						"n": 8,
						"h": 401,
						"w": 419
					},
					{
						"n": 9,
						"h": 144,
						"w": 459
					},
					{
						"n": 10,
						"h": 142,
						"w": 520
					},
					{
						"n": 11,
						"h": 362,
						"w": 465
					}
				],
				"ball": {
					"n": 0,
					"h": 94,
					"w": 461,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 44
		},
		{
			"num": 102,
			"minute": 5,
			"messages": [
				{
					"owner": 2,
					"mes": "Не найдя свободных партнеров, Томаш Прохазка[25](Опава) пасует назад..."
				},
				{
					"owner": 2,
					"mes": "Крыштоф Ласак[21](Опава) останавливает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 19
					},
					{
						"n": 2,
						"h": 57,
						"w": 229
					},
					{
						"n": 3,
						"h": 231,
						"w": 203
					},
					{
						"n": 4,
						"h": 285,
						"w": 212
					},
					{
						"n": 5,
						"h": 330,
						"w": 223
					},
					{
						"n": 6,
						"h": 28,
						"w": 324
					},
					{
						"n": 7,
						"h": 180,
						"w": 314
					},
					{
						"n": 8,
						"h": 298,
						"w": 267
					},
					{
						"n": 9,
						"h": 394,
						"w": 324
					},
					{
						"n": 10,
						"h": 137,
						"w": 400
					},
					{
						"n": 11,
						"h": 321,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 252,
						"w": 136
					},
					{
						"n": 2,
						"h": 71,
						"w": 214
					},
					{
						"n": 3,
						"h": 171,
						"w": 166
					},
					{
						"n": 4,
						"h": 290,
						"w": 156
					},
					{
						"n": 5,
						"h": 358,
						"w": 250
					},
					{
						"n": 6,
						"h": 229,
						"w": 285
					},
					{
						"n": 7,
						"h": 237,
						"w": 356
					},
					{
						"n": 8,
						"h": 398,
						"w": 366
					},
					{
						"n": 9,
						"h": 197,
						"w": 449
					},
					{
						"n": 10,
						"h": 152,
						"w": 467
					},
					{
						"n": 11,
						"h": 409,
						"w": 479
					}
				],
				"ball": {
					"n": 0,
					"h": 198,
					"w": 584,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 54
		},
		{
			"num": 103,
			"minute": 5,
			"messages": [
				{
					"owner": 2,
					"mes": "Крыштоф Ласак[21](Опава) отправляет мяч вперед О.Дюмону[26](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 17
					},
					{
						"n": 2,
						"h": 70,
						"w": 223
					},
					{
						"n": 3,
						"h": 221,
						"w": 194
					},
					{
						"n": 4,
						"h": 257,
						"w": 195
					},
					{
						"n": 5,
						"h": 330,
						"w": 213
					},
					{
						"n": 6,
						"h": 36,
						"w": 313
					},
					{
						"n": 7,
						"h": 186,
						"w": 284
					},
					{
						"n": 8,
						"h": 274,
						"w": 275
					},
					{
						"n": 9,
						"h": 408,
						"w": 303
					},
					{
						"n": 10,
						"h": 152,
						"w": 430
					},
					{
						"n": 11,
						"h": 305,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 244,
						"w": 130
					},
					{
						"n": 2,
						"h": 74,
						"w": 227
					},
					{
						"n": 3,
						"h": 172,
						"w": 164
					},
					{
						"n": 4,
						"h": 280,
						"w": 172
					},
					{
						"n": 5,
						"h": 373,
						"w": 219
					},
					{
						"n": 6,
						"h": 261,
						"w": 274
					},
					{
						"n": 7,
						"h": 222,
						"w": 380
					},
					{
						"n": 8,
						"h": 397,
						"w": 400
					},
					{
						"n": 9,
						"h": 231,
						"w": 447
					},
					{
						"n": 10,
						"h": 173,
						"w": 493
					},
					{
						"n": 11,
						"h": 410,
						"w": 477
					}
				],
				"ball": {
					"n": 0,
					"h": 170,
					"w": 486,
					"z": 0,
					"r": 0,
					"p": 2,
					"x": 0
				}
			},
			"interval": 34
		},
		{
			"num": 104,
			"minute": 5,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 13
					},
					{
						"n": 2,
						"h": 79,
						"w": 205
					},
					{
						"n": 3,
						"h": 230,
						"w": 177
					},
					{
						"n": 4,
						"h": 270,
						"w": 180
					},
					{
						"n": 5,
						"h": 330,
						"w": 193
					},
					{
						"n": 6,
						"h": 36,
						"w": 313
					},
					{
						"n": 7,
						"h": 184,
						"w": 267
					},
					{
						"n": 8,
						"h": 258,
						"w": 263
					},
					{
						"n": 9,
						"h": 408,
						"w": 303
					},
					{
						"n": 10,
						"h": 159,
						"w": 449
					},
					{
						"n": 11,
						"h": 322,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 112
					},
					{
						"n": 2,
						"h": 73,
						"w": 238
					},
					{
						"n": 3,
						"h": 176,
						"w": 184
					},
					{
						"n": 4,
						"h": 281,
						"w": 192
					},
					{
						"n": 5,
						"h": 380,
						"w": 201
					},
					{
						"n": 6,
						"h": 278,
						"w": 268
					},
					{
						"n": 7,
						"h": 227,
						"w": 399
					},
					{
						"n": 8,
						"h": 396,
						"w": 420
					},
					{
						"n": 9,
						"h": 225,
						"w": 467
					},
					{
						"n": 10,
						"h": 156,
						"w": 503
					},
					{
						"n": 11,
						"h": 401,
						"w": 495
					}
				],
				"ball": {
					"n": 0,
					"h": 162,
					"w": 456,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 20
		},
		{
			"num": 105,
			"minute": 5,
			"messages": [
				{
					"owner": 1,
					"mes": "Джо Квигли[10](Галвэй Юнайтед) первый на подборе..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 10
					},
					{
						"n": 2,
						"h": 76,
						"w": 198
					},
					{
						"n": 3,
						"h": 225,
						"w": 170
					},
					{
						"n": 4,
						"h": 274,
						"w": 177
					},
					{
						"n": 5,
						"h": 330,
						"w": 185
					},
					{
						"n": 6,
						"h": 39,
						"w": 305
					},
					{
						"n": 7,
						"h": 187,
						"w": 259
					},
					{
						"n": 8,
						"h": 259,
						"w": 255
					},
					{
						"n": 9,
						"h": 410,
						"w": 295
					},
					{
						"n": 10,
						"h": 162,
						"w": 456,
						"m": 610
					},
					{
						"n": 11,
						"h": 314,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 110,
						"m": 590
					},
					{
						"n": 2,
						"h": 67,
						"w": 243
					},
					{
						"n": 3,
						"h": 173,
						"w": 191
					},
					{
						"n": 4,
						"h": 281,
						"w": 200
					},
					{
						"n": 5,
						"h": 381,
						"w": 208
					},
					{
						"n": 6,
						"h": 285,
						"w": 265,
						"m": 610
					},
					{
						"n": 7,
						"h": 222,
						"w": 405
					},
					{
						"n": 8,
						"h": 398,
						"w": 427
					},
					{
						"n": 9,
						"h": 224,
						"w": 474
					},
					{
						"n": 10,
						"h": 160,
						"w": 510
					},
					{
						"n": 11,
						"h": 404,
						"w": 502
					}
				],
				"ball": {
					"n": 0,
					"h": 162,
					"w": 456,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 8
		},
		{
			"num": 106,
			"minute": 5,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 18
					},
					{
						"n": 2,
						"h": 77,
						"w": 238
					},
					{
						"n": 3,
						"h": 192,
						"w": 193
					},
					{
						"n": 4,
						"h": 281,
						"w": 209
					},
					{
						"n": 5,
						"h": 353,
						"w": 218
					},
					{
						"n": 6,
						"h": 40,
						"w": 345
					},
					{
						"n": 7,
						"h": 181,
						"w": 299
					},
					{
						"n": 8,
						"h": 271,
						"w": 293
					},
					{
						"n": 9,
						"h": 411,
						"w": 335
					},
					{
						"n": 10,
						"h": 134,
						"w": 484
					},
					{
						"n": 11,
						"h": 303,
						"w": 488
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 77
					},
					{
						"n": 2,
						"h": 79,
						"w": 205
					},
					{
						"n": 3,
						"h": 177,
						"w": 164
					},
					{
						"n": 4,
						"h": 273,
						"w": 161
					},
					{
						"n": 5,
						"h": 356,
						"w": 178
					},
					{
						"n": 6,
						"h": 312,
						"w": 223
					},
					{
						"n": 7,
						"h": 222,
						"w": 365
					},
					{
						"n": 8,
						"h": 400,
						"w": 407
					},
					{
						"n": 9,
						"h": 225,
						"w": 435
					},
					{
						"n": 10,
						"h": 167,
						"w": 471
					},
					{
						"n": 11,
						"h": 386,
						"w": 467
					}
				],
				"ball": {
					"n": 0,
					"h": 134,
					"w": 484,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 107,
			"minute": 5,
			"messages": [
				{
					"owner": 1,
					"mes": "Справа открывается Адам Гилберт[11](Галвэй Юнайтед)... Передача..."
				},
				{
					"owner": 1,
					"mes": "Нир Мансур[23](Опава) в подкате прерывает передачу!..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 13
					},
					{
						"n": 2,
						"h": 67,
						"w": 277
					},
					{
						"n": 3,
						"h": 179,
						"w": 232
					},
					{
						"n": 4,
						"h": 278,
						"w": 237
					},
					{
						"n": 5,
						"h": 366,
						"w": 257
					},
					{
						"n": 6,
						"h": 42,
						"w": 386
					},
					{
						"n": 7,
						"h": 174,
						"w": 339
					},
					{
						"n": 8,
						"h": 287,
						"w": 331
					},
					{
						"n": 9,
						"h": 400,
						"w": 374
					},
					{
						"n": 10,
						"h": 134,
						"w": 495,
						"m": 600
					},
					{
						"n": 11,
						"h": 273,
						"w": 508,
						"m": 580
					}
				],
				"away": [
					{
						"n": 1,
						"h": 229,
						"w": 70
					},
					{
						"n": 2,
						"h": 98,
						"w": 169
					},
					{
						"n": 3,
						"h": 201,
						"w": 197
					},
					{
						"n": 4,
						"h": 235,
						"w": 146
					},
					{
						"n": 5,
						"h": 340,
						"w": 144
					},
					{
						"n": 6,
						"h": 320,
						"w": 188
					},
					{
						"n": 7,
						"h": 225,
						"w": 324
					},
					{
						"n": 8,
						"h": 401,
						"w": 387
					},
					{
						"n": 9,
						"h": 193,
						"w": 409
					},
					{
						"n": 10,
						"h": 165,
						"w": 430
					},
					{
						"n": 11,
						"h": 357,
						"w": 438
					}
				],
				"ball": {
					"n": 0,
					"h": 249,
					"w": 523,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 41
		},
		{
			"num": 108,
			"minute": 5,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 11
					},
					{
						"n": 2,
						"h": 70,
						"w": 238
					},
					{
						"n": 3,
						"h": 219,
						"w": 226
					},
					{
						"n": 4,
						"h": 307,
						"w": 229
					},
					{
						"n": 5,
						"h": 348,
						"w": 233
					},
					{
						"n": 6,
						"h": 42,
						"w": 346
					},
					{
						"n": 7,
						"h": 213,
						"w": 329
					},
					{
						"n": 8,
						"h": 287,
						"w": 314
					},
					{
						"n": 9,
						"h": 418,
						"w": 339
					},
					{
						"n": 10,
						"h": 133,
						"w": 455
					},
					{
						"n": 11,
						"h": 298,
						"w": 477
					}
				],
				"away": [
					{
						"n": 1,
						"h": 226,
						"w": 30
					},
					{
						"n": 2,
						"h": 72,
						"w": 190
					},
					{
						"n": 3,
						"h": 226,
						"w": 222,
						"m": 620
					},
					{
						"n": 4,
						"h": 274,
						"w": 140
					},
					{
						"n": 5,
						"h": 375,
						"w": 164
					},
					{
						"n": 6,
						"h": 288,
						"w": 212
					},
					{
						"n": 7,
						"h": 229,
						"w": 362
					},
					{
						"n": 8,
						"h": 405,
						"w": 367
					},
					{
						"n": 9,
						"h": 163,
						"w": 383
					},
					{
						"n": 10,
						"h": 143,
						"w": 463
					},
					{
						"n": 11,
						"h": 389,
						"w": 462
					}
				],
				"ball": {
					"n": 0,
					"h": 224,
					"w": 498,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 109,
			"minute": 5,
			"messages": [
				{
					"owner": 2,
					"mes": "Нир Мансур[23](Опава) отдает передачу направо..."
				},
				{
					"owner": 2,
					"mes": "Томаш Прохазка[25](Опава) с мячом..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 14
					},
					{
						"n": 2,
						"h": 56,
						"w": 258
					},
					{
						"n": 3,
						"h": 221,
						"w": 251
					},
					{
						"n": 4,
						"h": 312,
						"w": 253
					},
					{
						"n": 5,
						"h": 350,
						"w": 249
					},
					{
						"n": 6,
						"h": 54,
						"w": 353
					},
					{
						"n": 7,
						"h": 173,
						"w": 337
					},
					{
						"n": 8,
						"h": 319,
						"w": 312
					},
					{
						"n": 9,
						"h": 424,
						"w": 353
					},
					{
						"n": 10,
						"h": 147,
						"w": 443
					},
					{
						"n": 11,
						"h": 314,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 17
					},
					{
						"n": 2,
						"h": 56,
						"w": 166
					},
					{
						"n": 3,
						"h": 221,
						"w": 213,
						"m": 630
					},
					{
						"n": 4,
						"h": 282,
						"w": 127
					},
					{
						"n": 5,
						"h": 350,
						"w": 178
					},
					{
						"n": 6,
						"h": 289,
						"w": 211
					},
					{
						"n": 7,
						"h": 254,
						"w": 325
					},
					{
						"n": 8,
						"h": 400,
						"w": 346
					},
					{
						"n": 9,
						"h": 134,
						"w": 350
					},
					{
						"n": 10,
						"h": 134,
						"w": 422
					},
					{
						"n": 11,
						"h": 417,
						"w": 450
					}
				],
				"ball": {
					"n": 0,
					"h": 100,
					"w": 542,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 44
		},
		{
			"num": 110,
			"minute": 5,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 14
					},
					{
						"n": 2,
						"h": 58,
						"w": 258
					},
					{
						"n": 3,
						"h": 215,
						"w": 256
					},
					{
						"n": 4,
						"h": 288,
						"w": 253
					},
					{
						"n": 5,
						"h": 330,
						"w": 254
					},
					{
						"n": 6,
						"h": 28,
						"w": 353
					},
					{
						"n": 7,
						"h": 158,
						"w": 336
					},
					{
						"n": 8,
						"h": 281,
						"w": 325
					},
					{
						"n": 9,
						"h": 386,
						"w": 353
					},
					{
						"n": 10,
						"h": 127,
						"w": 443
					},
					{
						"n": 11,
						"h": 320,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 13
					},
					{
						"n": 2,
						"h": 65,
						"w": 159
					},
					{
						"n": 3,
						"h": 203,
						"w": 177
					},
					{
						"n": 4,
						"h": 278,
						"w": 121
					},
					{
						"n": 5,
						"h": 368,
						"w": 209
					},
					{
						"n": 6,
						"h": 274,
						"w": 213
					},
					{
						"n": 7,
						"h": 234,
						"w": 306
					},
					{
						"n": 8,
						"h": 407,
						"w": 307
					},
					{
						"n": 9,
						"h": 105,
						"w": 322
					},
					{
						"n": 10,
						"h": 157,
						"w": 443
					},
					{
						"n": 11,
						"h": 408,
						"w": 450
					}
				],
				"ball": {
					"n": 0,
					"h": 82,
					"w": 511,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 111,
			"minute": 5,
			"messages": [
				{
					"owner": 2,
					"mes": "Пас в центр М.Манолову[27](Опава)..."
				},
				{
					"owner": 2,
					"mes": "Мирослав Манолов[27](Опава) принимает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 19
					},
					{
						"n": 2,
						"h": 113,
						"w": 254
					},
					{
						"n": 3,
						"h": 223,
						"w": 251
					},
					{
						"n": 4,
						"h": 288,
						"w": 241
					},
					{
						"n": 5,
						"h": 330,
						"w": 238
					},
					{
						"n": 6,
						"h": 50,
						"w": 303
					},
					{
						"n": 7,
						"h": 195,
						"w": 377
					},
					{
						"n": 8,
						"h": 273,
						"w": 328
					},
					{
						"n": 9,
						"h": 404,
						"w": 347
					},
					{
						"n": 10,
						"h": 177,
						"w": 437
					},
					{
						"n": 11,
						"h": 274,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 18
					},
					{
						"n": 2,
						"h": 65,
						"w": 189
					},
					{
						"n": 3,
						"h": 176,
						"w": 143
					},
					{
						"n": 4,
						"h": 273,
						"w": 131
					},
					{
						"n": 5,
						"h": 371,
						"w": 199
					},
					{
						"n": 6,
						"h": 250,
						"w": 224
					},
					{
						"n": 7,
						"h": 234,
						"w": 306
					},
					{
						"n": 8,
						"h": 414,
						"w": 361
					},
					{
						"n": 9,
						"h": 60,
						"w": 291
					},
					{
						"n": 10,
						"h": 157,
						"w": 456
					},
					{
						"n": 11,
						"h": 405,
						"w": 395
					}
				],
				"ball": {
					"n": 0,
					"h": 216,
					"w": 414,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 55
		},
		{
			"num": 112,
			"minute": 6,
			"possession": 46,
			"messages": [
				{
					"owner": 2,
					"mes": "Мирослав Манолов[27](Опава) отдает пас на О.Дюмона[26](Опава)..."
				},
				{
					"owner": 2,
					"mes": "Джо Квигли[10](Галвэй Юнайтед) оказывается первым на мяче..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 19
					},
					{
						"n": 2,
						"h": 99,
						"w": 265
					},
					{
						"n": 3,
						"h": 222,
						"w": 233,
						"f": 98
					},
					{
						"n": 4,
						"h": 296,
						"w": 225,
						"f": 98
					},
					{
						"n": 5,
						"h": 339,
						"w": 222
					},
					{
						"n": 6,
						"h": 34,
						"w": 310
					},
					{
						"n": 7,
						"h": 194,
						"w": 359
					},
					{
						"n": 8,
						"h": 267,
						"w": 311
					},
					{
						"n": 9,
						"h": 405,
						"w": 329
					},
					{
						"n": 10,
						"h": 194,
						"w": 442
					},
					{
						"n": 11,
						"h": 292,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 36
					},
					{
						"n": 2,
						"h": 73,
						"w": 205
					},
					{
						"n": 3,
						"h": 165,
						"w": 157
					},
					{
						"n": 4,
						"h": 276,
						"w": 149,
						"f": 96
					},
					{
						"n": 5,
						"h": 379,
						"w": 186
					},
					{
						"n": 6,
						"h": 252,
						"w": 240
					},
					{
						"n": 7,
						"h": 232,
						"w": 313,
						"f": 98,
						"m": 590
					},
					{
						"n": 8,
						"h": 414,
						"w": 343
					},
					{
						"n": 9,
						"h": 53,
						"w": 308
					},
					{
						"n": 10,
						"h": 143,
						"w": 467
					},
					{
						"n": 11,
						"h": 406,
						"w": 413
					}
				],
				"ball": {
					"n": 0,
					"h": 194,
					"w": 442,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 18
		},
		{
			"num": 113,
			"minute": 6,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 17
					},
					{
						"n": 2,
						"h": 85,
						"w": 303
					},
					{
						"n": 3,
						"h": 189,
						"w": 255
					},
					{
						"n": 4,
						"h": 269,
						"w": 254
					},
					{
						"n": 5,
						"h": 358,
						"w": 258
					},
					{
						"n": 6,
						"h": 42,
						"w": 349
					},
					{
						"n": 7,
						"h": 191,
						"w": 399
					},
					{
						"n": 8,
						"h": 280,
						"w": 349
					},
					{
						"n": 9,
						"h": 403,
						"w": 369
					},
					{
						"n": 10,
						"h": 154,
						"w": 442,
						"m": 610
					},
					{
						"n": 11,
						"h": 291,
						"w": 490
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 72
					},
					{
						"n": 2,
						"h": 82,
						"w": 166
					},
					{
						"n": 3,
						"h": 171,
						"w": 118
					},
					{
						"n": 4,
						"h": 278,
						"w": 116
					},
					{
						"n": 5,
						"h": 359,
						"w": 151
					},
					{
						"n": 6,
						"h": 294,
						"w": 258
					},
					{
						"n": 7,
						"h": 230,
						"w": 273
					},
					{
						"n": 8,
						"h": 406,
						"w": 335
					},
					{
						"n": 9,
						"h": 44,
						"w": 269
					},
					{
						"n": 10,
						"h": 152,
						"w": 428
					},
					{
						"n": 11,
						"h": 383,
						"w": 380
					}
				],
				"ball": {
					"n": 0,
					"h": 154,
					"w": 442,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 114,
			"minute": 6,
			"messages": [
				{
					"owner": 1,
					"mes": "Справа просит мяч Адам Гилберт[11](Галвэй Юнайтед)... Пас ему..."
				},
				{
					"owner": 1,
					"mes": "Адам Гилберт[11](Галвэй Юнайтед) принимает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 10
					},
					{
						"n": 2,
						"h": 75,
						"w": 334
					},
					{
						"n": 3,
						"h": 172,
						"w": 283
					},
					{
						"n": 4,
						"h": 279,
						"w": 282
					},
					{
						"n": 5,
						"h": 375,
						"w": 309
					},
					{
						"n": 6,
						"h": 41,
						"w": 403
					},
					{
						"n": 7,
						"h": 192,
						"w": 453
					},
					{
						"n": 8,
						"h": 298,
						"w": 400
					},
					{
						"n": 9,
						"h": 406,
						"w": 423
					},
					{
						"n": 10,
						"h": 154,
						"w": 452
					},
					{
						"n": 11,
						"h": 237,
						"w": 498
					}
				],
				"away": [
					{
						"n": 1,
						"h": 223,
						"w": 73
					},
					{
						"n": 2,
						"h": 104,
						"w": 117
					},
					{
						"n": 3,
						"h": 183,
						"w": 102
					},
					{
						"n": 4,
						"h": 277,
						"w": 94
					},
					{
						"n": 5,
						"h": 340,
						"w": 115
					},
					{
						"n": 6,
						"h": 261,
						"w": 215
					},
					{
						"n": 7,
						"h": 221,
						"w": 220
					},
					{
						"n": 8,
						"h": 406,
						"w": 281
					},
					{
						"n": 9,
						"h": 44,
						"w": 261
					},
					{
						"n": 10,
						"h": 152,
						"w": 374
					},
					{
						"n": 11,
						"h": 339,
						"w": 348
					}
				],
				"ball": {
					"n": 0,
					"h": 237,
					"w": 498,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 54
		},
		{
			"num": 115,
			"minute": 6,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 19
					},
					{
						"n": 2,
						"h": 75,
						"w": 356
					},
					{
						"n": 3,
						"h": 182,
						"w": 292
					},
					{
						"n": 4,
						"h": 282,
						"w": 299
					},
					{
						"n": 5,
						"h": 388,
						"w": 339
					},
					{
						"n": 6,
						"h": 47,
						"w": 435
					},
					{
						"n": 7,
						"h": 170,
						"w": 476
					},
					{
						"n": 8,
						"h": 302,
						"w": 432
					},
					{
						"n": 9,
						"h": 408,
						"w": 456
					},
					{
						"n": 10,
						"h": 147,
						"w": 484
					},
					{
						"n": 11,
						"h": 257,
						"w": 533
					}
				],
				"away": [
					{
						"n": 1,
						"h": 223,
						"w": 40
					},
					{
						"n": 2,
						"h": 110,
						"w": 102
					},
					{
						"n": 3,
						"h": 208,
						"w": 127
					},
					{
						"n": 4,
						"h": 244,
						"w": 91
					},
					{
						"n": 5,
						"h": 340,
						"w": 107
					},
					{
						"n": 6,
						"h": 237,
						"w": 182
					},
					{
						"n": 7,
						"h": 204,
						"w": 188
					},
					{
						"n": 8,
						"h": 403,
						"w": 249
					},
					{
						"n": 9,
						"h": 44,
						"w": 228
					},
					{
						"n": 10,
						"h": 151,
						"w": 341
					},
					{
						"n": 11,
						"h": 312,
						"w": 330
					}
				],
				"ball": {
					"n": 0,
					"h": 257,
					"w": 533,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 33
		},
		{
			"num": 116,
			"minute": 6,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 15
					},
					{
						"n": 2,
						"h": 70,
						"w": 345
					},
					{
						"n": 3,
						"h": 171,
						"w": 289
					},
					{
						"n": 4,
						"h": 272,
						"w": 305
					},
					{
						"n": 5,
						"h": 373,
						"w": 356
					},
					{
						"n": 6,
						"h": 45,
						"w": 468
					},
					{
						"n": 7,
						"h": 179,
						"w": 508
					},
					{
						"n": 8,
						"h": 283,
						"w": 419
					},
					{
						"n": 9,
						"h": 407,
						"w": 489
					},
					{
						"n": 10,
						"h": 151,
						"w": 517
					},
					{
						"n": 11,
						"h": 277,
						"w": 567
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 14
					},
					{
						"n": 2,
						"h": 110,
						"w": 102
					},
					{
						"n": 3,
						"h": 185,
						"w": 117
					},
					{
						"n": 4,
						"h": 277,
						"w": 91
					},
					{
						"n": 5,
						"h": 340,
						"w": 99
					},
					{
						"n": 6,
						"h": 268,
						"w": 158
					},
					{
						"n": 7,
						"h": 184,
						"w": 157
					},
					{
						"n": 8,
						"h": 405,
						"w": 216
					},
					{
						"n": 9,
						"h": 44,
						"w": 195
					},
					{
						"n": 10,
						"h": 159,
						"w": 309
					},
					{
						"n": 11,
						"h": 292,
						"w": 304
					}
				],
				"ball": {
					"n": 0,
					"h": 277,
					"w": 567,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 33
		},
		{
			"num": 117,
			"minute": 6,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 16
					},
					{
						"n": 2,
						"h": 76,
						"w": 348
					},
					{
						"n": 3,
						"h": 180,
						"w": 308
					},
					{
						"n": 4,
						"h": 281,
						"w": 305
					},
					{
						"n": 5,
						"h": 386,
						"w": 355
					},
					{
						"n": 6,
						"h": 44,
						"w": 489
					},
					{
						"n": 7,
						"h": 185,
						"w": 528
					},
					{
						"n": 8,
						"h": 286,
						"w": 440
					},
					{
						"n": 9,
						"h": 406,
						"w": 510
					},
					{
						"n": 10,
						"h": 150,
						"w": 538
					},
					{
						"n": 11,
						"h": 277,
						"w": 585
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 14
					},
					{
						"n": 2,
						"h": 110,
						"w": 116
					},
					{
						"n": 3,
						"h": 173,
						"w": 135
					},
					{
						"n": 4,
						"h": 256,
						"w": 94
					},
					{
						"n": 5,
						"h": 340,
						"w": 106
					},
					{
						"n": 6,
						"h": 263,
						"w": 159
					},
					{
						"n": 7,
						"h": 174,
						"w": 137
					},
					{
						"n": 8,
						"h": 406,
						"w": 195
					},
					{
						"n": 9,
						"h": 44,
						"w": 174
					},
					{
						"n": 10,
						"h": 161,
						"w": 288
					},
					{
						"n": 11,
						"h": 287,
						"w": 298
					}
				],
				"ball": {
					"n": 0,
					"h": 277,
					"w": 585,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 21
		},
		{
			"num": 118,
			"minute": 6,
			"messages": [
				{
					"owner": 1,
					"mes": "Адам Гилберт[11](Галвэй Юнайтед) сближается с Н.Мансуром[23](Опава)..."
				},
				{
					"owner": 1,
					"mes": "Мяч отобран..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 16
					},
					{
						"n": 2,
						"h": 76,
						"w": 348
					},
					{
						"n": 3,
						"h": 181,
						"w": 309
					},
					{
						"n": 4,
						"h": 281,
						"w": 305
					},
					{
						"n": 5,
						"h": 386,
						"w": 355
					},
					{
						"n": 6,
						"h": 43,
						"w": 499
					},
					{
						"n": 7,
						"h": 187,
						"w": 538
					},
					{
						"n": 8,
						"h": 288,
						"w": 450
					},
					{
						"n": 9,
						"h": 406,
						"w": 520
					},
					{
						"n": 10,
						"h": 150,
						"w": 548
					},
					{
						"n": 11,
						"h": 277,
						"w": 595
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 14
					},
					{
						"n": 2,
						"h": 110,
						"w": 116
					},
					{
						"n": 3,
						"h": 167,
						"w": 143,
						"m": 640
					},
					{
						"n": 4,
						"h": 247,
						"w": 96
					},
					{
						"n": 5,
						"h": 340,
						"w": 106
					},
					{
						"n": 6,
						"h": 263,
						"w": 159
					},
					{
						"n": 7,
						"h": 173,
						"w": 135
					},
					{
						"n": 8,
						"h": 406,
						"w": 195
					},
					{
						"n": 9,
						"h": 44,
						"w": 174
					},
					{
						"n": 10,
						"h": 162,
						"w": 278
					},
					{
						"n": 11,
						"h": 287,
						"w": 298
					}
				],
				"ball": {
					"n": 0,
					"h": 283,
					"w": 577,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 10
		},
		{
			"num": 119,
			"minute": 6,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 12
					},
					{
						"n": 2,
						"h": 104,
						"w": 320
					},
					{
						"n": 3,
						"h": 159,
						"w": 289
					},
					{
						"n": 4,
						"h": 258,
						"w": 302
					},
					{
						"n": 5,
						"h": 369,
						"w": 319
					},
					{
						"n": 6,
						"h": 40,
						"w": 459
					},
					{
						"n": 7,
						"h": 171,
						"w": 501
					},
					{
						"n": 8,
						"h": 297,
						"w": 489
					},
					{
						"n": 9,
						"h": 408,
						"w": 480
					},
					{
						"n": 10,
						"h": 167,
						"w": 512
					},
					{
						"n": 11,
						"h": 280,
						"w": 586
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 17
					},
					{
						"n": 2,
						"h": 82,
						"w": 144
					},
					{
						"n": 3,
						"h": 142,
						"w": 168
					},
					{
						"n": 4,
						"h": 270,
						"w": 102
					},
					{
						"n": 5,
						"h": 378,
						"w": 117
					},
					{
						"n": 6,
						"h": 228,
						"w": 179
					},
					{
						"n": 7,
						"h": 185,
						"w": 173
					},
					{
						"n": 8,
						"h": 404,
						"w": 235
					},
					{
						"n": 9,
						"h": 41,
						"w": 214
					},
					{
						"n": 10,
						"h": 160,
						"w": 318
					},
					{
						"n": 11,
						"h": 327,
						"w": 295
					}
				],
				"ball": {
					"n": 0,
					"h": 308,
					"w": 552,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 120,
			"minute": 6,
			"messages": [
				{
					"owner": 2,
					"mes": "Пас направо..."
				},
				{
					"owner": 2,
					"mes": "Томаш Прохазка[25](Опава) достает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 16
					},
					{
						"n": 2,
						"h": 120,
						"w": 267
					},
					{
						"n": 3,
						"h": 215,
						"w": 268
					},
					{
						"n": 4,
						"h": 287,
						"w": 268
					},
					{
						"n": 5,
						"h": 331,
						"w": 273
					},
					{
						"n": 6,
						"h": 39,
						"w": 399
					},
					{
						"n": 7,
						"h": 164,
						"w": 442
					},
					{
						"n": 8,
						"h": 273,
						"w": 434
					},
					{
						"n": 9,
						"h": 417,
						"w": 421
					},
					{
						"n": 10,
						"h": 119,
						"w": 548
					},
					{
						"n": 11,
						"h": 297,
						"w": 528
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 13
					},
					{
						"n": 2,
						"h": 72,
						"w": 156
					},
					{
						"n": 3,
						"h": 146,
						"w": 158
					},
					{
						"n": 4,
						"h": 268,
						"w": 116
					},
					{
						"n": 5,
						"h": 378,
						"w": 117
					},
					{
						"n": 6,
						"h": 277,
						"w": 198
					},
					{
						"n": 7,
						"h": 220,
						"w": 222
					},
					{
						"n": 8,
						"h": 399,
						"w": 267
					},
					{
						"n": 9,
						"h": 43,
						"w": 274
					},
					{
						"n": 10,
						"h": 161,
						"w": 378
					},
					{
						"n": 11,
						"h": 386,
						"w": 304
					}
				],
				"ball": {
					"n": 0,
					"h": 72,
					"w": 603,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 60
		},
		{
			"num": 121,
			"minute": 6,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 16
					},
					{
						"n": 2,
						"h": 120,
						"w": 252
					},
					{
						"n": 3,
						"h": 219,
						"w": 257
					},
					{
						"n": 4,
						"h": 302,
						"w": 262
					},
					{
						"n": 5,
						"h": 335,
						"w": 268
					},
					{
						"n": 6,
						"h": 51,
						"w": 361
					},
					{
						"n": 7,
						"h": 165,
						"w": 402
					},
					{
						"n": 8,
						"h": 265,
						"w": 394
					},
					{
						"n": 9,
						"h": 412,
						"w": 381
					},
					{
						"n": 10,
						"h": 100,
						"w": 555
					},
					{
						"n": 11,
						"h": 294,
						"w": 488
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 15
					},
					{
						"n": 2,
						"h": 71,
						"w": 165
					},
					{
						"n": 3,
						"h": 160,
						"w": 121
					},
					{
						"n": 4,
						"h": 272,
						"w": 115
					},
					{
						"n": 5,
						"h": 380,
						"w": 153
					},
					{
						"n": 6,
						"h": 238,
						"w": 190
					},
					{
						"n": 7,
						"h": 231,
						"w": 260
					},
					{
						"n": 8,
						"h": 398,
						"w": 307
					},
					{
						"n": 9,
						"h": 34,
						"w": 306
					},
					{
						"n": 10,
						"h": 151,
						"w": 417
					},
					{
						"n": 11,
						"h": 393,
						"w": 343
					}
				],
				"ball": {
					"n": 0,
					"h": 70,
					"w": 567,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 122,
			"minute": 6,
			"messages": [
				{
					"owner": 2,
					"mes": "Томаш Прохазка[25](Опава) делает передачу налево на С.Пейшу[24](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 11
					},
					{
						"n": 2,
						"h": 120,
						"w": 260
					},
					{
						"n": 3,
						"h": 218,
						"w": 251
					},
					{
						"n": 4,
						"h": 315,
						"w": 268
					},
					{
						"n": 5,
						"h": 352,
						"w": 264
					},
					{
						"n": 6,
						"h": 54,
						"w": 325
					},
					{
						"n": 7,
						"h": 179,
						"w": 369
					},
					{
						"n": 8,
						"h": 261,
						"w": 359
					},
					{
						"n": 9,
						"h": 404,
						"w": 360
					},
					{
						"n": 10,
						"h": 136,
						"w": 558
					},
					{
						"n": 11,
						"h": 310,
						"w": 456
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 16
					},
					{
						"n": 2,
						"h": 64,
						"w": 172
					},
					{
						"n": 3,
						"h": 174,
						"w": 116
					},
					{
						"n": 4,
						"h": 298,
						"w": 140
					},
					{
						"n": 5,
						"h": 380,
						"w": 143,
						"m": 610
					},
					{
						"n": 6,
						"h": 224,
						"w": 223
					},
					{
						"n": 7,
						"h": 230,
						"w": 296
					},
					{
						"n": 8,
						"h": 396,
						"w": 343
					},
					{
						"n": 9,
						"h": 50,
						"w": 273
					},
					{
						"n": 10,
						"h": 139,
						"w": 420
					},
					{
						"n": 11,
						"h": 400,
						"w": 379
					}
				],
				"ball": {
					"n": 0,
					"h": 152,
					"w": 580,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 36
		},
		{
			"num": 123,
			"minute": 6,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 11
					},
					{
						"n": 2,
						"h": 120,
						"w": 255
					},
					{
						"n": 3,
						"h": 227,
						"w": 254
					},
					{
						"n": 4,
						"h": 278,
						"w": 253
					},
					{
						"n": 5,
						"h": 330,
						"w": 247
					},
					{
						"n": 6,
						"h": 56,
						"w": 288
					},
					{
						"n": 7,
						"h": 179,
						"w": 342
					},
					{
						"n": 8,
						"h": 230,
						"w": 343
					},
					{
						"n": 9,
						"h": 422,
						"w": 356
					},
					{
						"n": 10,
						"h": 165,
						"w": 531
					},
					{
						"n": 11,
						"h": 323,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 221,
						"w": 15
					},
					{
						"n": 2,
						"h": 67,
						"w": 174
					},
					{
						"n": 3,
						"h": 176,
						"w": 116
					},
					{
						"n": 4,
						"h": 282,
						"w": 172
					},
					{
						"n": 5,
						"h": 380,
						"w": 145
					},
					{
						"n": 6,
						"h": 236,
						"w": 215
					},
					{
						"n": 7,
						"h": 224,
						"w": 336
					},
					{
						"n": 8,
						"h": 393,
						"w": 304
					},
					{
						"n": 9,
						"h": 45,
						"w": 313
					},
					{
						"n": 10,
						"h": 169,
						"w": 447
					},
					{
						"n": 11,
						"h": 411,
						"w": 417
					}
				],
				"ball": {
					"n": 0,
					"h": 168,
					"w": 548,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 124,
			"minute": 6,
			"messages": [
				{
					"owner": 2,
					"mes": "Себастьян Пейша[24](Опава) пасует налево на Л.Седлачека[22](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 16
					},
					{
						"n": 2,
						"h": 120,
						"w": 252
					},
					{
						"n": 3,
						"h": 222,
						"w": 260
					},
					{
						"n": 4,
						"h": 273,
						"w": 259
					},
					{
						"n": 5,
						"h": 330,
						"w": 263
					},
					{
						"n": 6,
						"h": 37,
						"w": 334
					},
					{
						"n": 7,
						"h": 191,
						"w": 327
					},
					{
						"n": 8,
						"h": 254,
						"w": 335
					},
					{
						"n": 9,
						"h": 394,
						"w": 322
					},
					{
						"n": 10,
						"h": 171,
						"w": 481
					},
					{
						"n": 11,
						"h": 322,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 229,
						"w": 12
					},
					{
						"n": 2,
						"h": 83,
						"w": 156
					},
					{
						"n": 3,
						"h": 182,
						"w": 127
					},
					{
						"n": 4,
						"h": 275,
						"w": 165
					},
					{
						"n": 5,
						"h": 391,
						"w": 129
					},
					{
						"n": 6,
						"h": 186,
						"w": 222
					},
					{
						"n": 7,
						"h": 190,
						"w": 372
					},
					{
						"n": 8,
						"h": 399,
						"w": 353
					},
					{
						"n": 9,
						"h": 50,
						"w": 363
					},
					{
						"n": 10,
						"h": 176,
						"w": 445
					},
					{
						"n": 11,
						"h": 398,
						"w": 420
					}
				],
				"ball": {
					"n": 0,
					"h": 367,
					"w": 564,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 50
		},
		{
			"num": 125,
			"minute": 6,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 17
					},
					{
						"n": 2,
						"h": 120,
						"w": 255
					},
					{
						"n": 3,
						"h": 241,
						"w": 255
					},
					{
						"n": 4,
						"h": 278,
						"w": 269
					},
					{
						"n": 5,
						"h": 330,
						"w": 251
					},
					{
						"n": 6,
						"h": 52,
						"w": 297
					},
					{
						"n": 7,
						"h": 198,
						"w": 336
					},
					{
						"n": 8,
						"h": 250,
						"w": 354
					},
					{
						"n": 9,
						"h": 394,
						"w": 304
					},
					{
						"n": 10,
						"h": 174,
						"w": 450
					},
					{
						"n": 11,
						"h": 317,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 13
					},
					{
						"n": 2,
						"h": 66,
						"w": 187
					},
					{
						"n": 3,
						"h": 177,
						"w": 112
					},
					{
						"n": 4,
						"h": 276,
						"w": 125
					},
					{
						"n": 5,
						"h": 381,
						"w": 142
					},
					{
						"n": 6,
						"h": 203,
						"w": 252
					},
					{
						"n": 7,
						"h": 204,
						"w": 357
					},
					{
						"n": 8,
						"h": 394,
						"w": 313
					},
					{
						"n": 9,
						"h": 37,
						"w": 401
					},
					{
						"n": 10,
						"h": 154,
						"w": 424
					},
					{
						"n": 11,
						"h": 412,
						"w": 420
					}
				],
				"ball": {
					"n": 0,
					"h": 384,
					"w": 533,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 126,
			"minute": 6,
			"messages": [
				{
					"owner": 2,
					"mes": "Лука Седлачек[22](Опава) отдает передачу направо Н.Мансуру[23](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 17
					},
					{
						"n": 2,
						"h": 120,
						"w": 268
					},
					{
						"n": 3,
						"h": 222,
						"w": 267
					},
					{
						"n": 4,
						"h": 284,
						"w": 270
					},
					{
						"n": 5,
						"h": 330,
						"w": 268
					},
					{
						"n": 6,
						"h": 83,
						"w": 276
					},
					{
						"n": 7,
						"h": 178,
						"w": 340
					},
					{
						"n": 8,
						"h": 229,
						"w": 332
					},
					{
						"n": 9,
						"h": 394,
						"w": 321
					},
					{
						"n": 10,
						"h": 136,
						"w": 450
					},
					{
						"n": 11,
						"h": 313,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 14
					},
					{
						"n": 2,
						"h": 63,
						"w": 177
					},
					{
						"n": 3,
						"h": 163,
						"w": 128
					},
					{
						"n": 4,
						"h": 295,
						"w": 135
					},
					{
						"n": 5,
						"h": 400,
						"w": 135
					},
					{
						"n": 6,
						"h": 224,
						"w": 221
					},
					{
						"n": 7,
						"h": 219,
						"w": 322
					},
					{
						"n": 8,
						"h": 401,
						"w": 287
					},
					{
						"n": 9,
						"h": 45,
						"w": 364
					},
					{
						"n": 10,
						"h": 163,
						"w": 440
					},
					{
						"n": 11,
						"h": 374,
						"w": 426
					}
				],
				"ball": {
					"n": 0,
					"h": 287,
					"w": 592,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 38
		},
		{
			"num": 127,
			"minute": 6,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 13
					},
					{
						"n": 2,
						"h": 126,
						"w": 264
					},
					{
						"n": 3,
						"h": 198,
						"w": 252
					},
					{
						"n": 4,
						"h": 269,
						"w": 257
					},
					{
						"n": 5,
						"h": 330,
						"w": 260
					},
					{
						"n": 6,
						"h": 60,
						"w": 309
					},
					{
						"n": 7,
						"h": 177,
						"w": 345
					},
					{
						"n": 8,
						"h": 268,
						"w": 330
					},
					{
						"n": 9,
						"h": 394,
						"w": 319
					},
					{
						"n": 10,
						"h": 143,
						"w": 450
					},
					{
						"n": 11,
						"h": 319,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 17
					},
					{
						"n": 2,
						"h": 39,
						"w": 146
					},
					{
						"n": 3,
						"h": 155,
						"w": 162
					},
					{
						"n": 4,
						"h": 292,
						"w": 145
					},
					{
						"n": 5,
						"h": 408,
						"w": 145
					},
					{
						"n": 6,
						"h": 232,
						"w": 219
					},
					{
						"n": 7,
						"h": 230,
						"w": 292
					},
					{
						"n": 8,
						"h": 419,
						"w": 292
					},
					{
						"n": 9,
						"h": 50,
						"w": 366
					},
					{
						"n": 10,
						"h": 168,
						"w": 440
					},
					{
						"n": 11,
						"h": 335,
						"w": 432
					}
				],
				"ball": {
					"n": 0,
					"h": 295,
					"w": 558,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 128,
			"minute": 6,
			"messages": [
				{
					"owner": 2,
					"mes": "Нир Мансур[23](Опава) играет направо..."
				},
				{
					"owner": 2,
					"mes": "Оливье Дюмон[26](Опава) останавливает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 15
					},
					{
						"n": 2,
						"h": 120,
						"w": 251
					},
					{
						"n": 3,
						"h": 175,
						"w": 252
					},
					{
						"n": 4,
						"h": 257,
						"w": 262
					},
					{
						"n": 5,
						"h": 330,
						"w": 256
					},
					{
						"n": 6,
						"h": 51,
						"w": 338
					},
					{
						"n": 7,
						"h": 179,
						"w": 351
					},
					{
						"n": 8,
						"h": 255,
						"w": 344
					},
					{
						"n": 9,
						"h": 394,
						"w": 336
					},
					{
						"n": 10,
						"h": 142,
						"w": 450
					},
					{
						"n": 11,
						"h": 323,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 38
					},
					{
						"n": 2,
						"h": 45,
						"w": 155
					},
					{
						"n": 3,
						"h": 150,
						"w": 155
					},
					{
						"n": 4,
						"h": 286,
						"w": 155
					},
					{
						"n": 5,
						"h": 415,
						"w": 155
					},
					{
						"n": 6,
						"h": 214,
						"w": 193
					},
					{
						"n": 7,
						"h": 218,
						"w": 297
					},
					{
						"n": 8,
						"h": 404,
						"w": 297
					},
					{
						"n": 9,
						"h": 42,
						"w": 369
					},
					{
						"n": 10,
						"h": 157,
						"w": 440
					},
					{
						"n": 11,
						"h": 305,
						"w": 439
					}
				],
				"ball": {
					"n": 0,
					"h": 236,
					"w": 527,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 31
		},
		{
			"num": 129,
			"minute": 6,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 12
					},
					{
						"n": 2,
						"h": 120,
						"w": 238
					},
					{
						"n": 3,
						"h": 173,
						"w": 234
					},
					{
						"n": 4,
						"h": 272,
						"w": 244
					},
					{
						"n": 5,
						"h": 330,
						"w": 242
					},
					{
						"n": 6,
						"h": 36,
						"w": 336
					},
					{
						"n": 7,
						"h": 180,
						"w": 318
					},
					{
						"n": 8,
						"h": 256,
						"w": 304
					},
					{
						"n": 9,
						"h": 394,
						"w": 296
					},
					{
						"n": 10,
						"h": 140,
						"w": 426
					},
					{
						"n": 11,
						"h": 309,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 54
					},
					{
						"n": 2,
						"h": 36,
						"w": 165
					},
					{
						"n": 3,
						"h": 151,
						"w": 165
					},
					{
						"n": 4,
						"h": 296,
						"w": 165
					},
					{
						"n": 5,
						"h": 417,
						"w": 165
					},
					{
						"n": 6,
						"h": 232,
						"w": 224
					},
					{
						"n": 7,
						"h": 229,
						"w": 315
					},
					{
						"n": 8,
						"h": 415,
						"w": 315
					},
					{
						"n": 9,
						"h": 46,
						"w": 390
					},
					{
						"n": 10,
						"h": 149,
						"w": 464
					},
					{
						"n": 11,
						"h": 287,
						"w": 464
					}
				],
				"ball": {
					"n": 0,
					"h": 218,
					"w": 496,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 130,
			"minute": 6,
			"messages": [
				{
					"owner": 2,
					"mes": "Пас направо С.Пейше[24](Опава)..."
				},
				{
					"owner": 2,
					"mes": "Себастьян Пейша[24](Опава) получил мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 18
					},
					{
						"n": 2,
						"h": 120,
						"w": 261
					},
					{
						"n": 3,
						"h": 172,
						"w": 268
					},
					{
						"n": 4,
						"h": 271,
						"w": 270
					},
					{
						"n": 5,
						"h": 330,
						"w": 255
					},
					{
						"n": 6,
						"h": 30,
						"w": 360
					},
					{
						"n": 7,
						"h": 188,
						"w": 334
					},
					{
						"n": 8,
						"h": 266,
						"w": 330
					},
					{
						"n": 9,
						"h": 394,
						"w": 311
					},
					{
						"n": 10,
						"h": 130,
						"w": 450
					},
					{
						"n": 11,
						"h": 309,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 78
					},
					{
						"n": 2,
						"h": 40,
						"w": 175
					},
					{
						"n": 3,
						"h": 159,
						"w": 175
					},
					{
						"n": 4,
						"h": 286,
						"w": 179
					},
					{
						"n": 5,
						"h": 406,
						"w": 175
					},
					{
						"n": 6,
						"h": 228,
						"w": 233
					},
					{
						"n": 7,
						"h": 227,
						"w": 307
					},
					{
						"n": 8,
						"h": 408,
						"w": 307
					},
					{
						"n": 9,
						"h": 44,
						"w": 374
					},
					{
						"n": 10,
						"h": 168,
						"w": 440
					},
					{
						"n": 11,
						"h": 291,
						"w": 440
					}
				],
				"ball": {
					"n": 0,
					"h": 164,
					"w": 541,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 35
		},
		{
			"num": 131,
			"minute": 6,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 18
					},
					{
						"n": 2,
						"h": 120,
						"w": 268
					},
					{
						"n": 3,
						"h": 181,
						"w": 251
					},
					{
						"n": 4,
						"h": 275,
						"w": 260
					},
					{
						"n": 5,
						"h": 330,
						"w": 260
					},
					{
						"n": 6,
						"h": 32,
						"w": 360
					},
					{
						"n": 7,
						"h": 183,
						"w": 348
					},
					{
						"n": 8,
						"h": 256,
						"w": 327
					},
					{
						"n": 9,
						"h": 394,
						"w": 309
					},
					{
						"n": 10,
						"h": 161,
						"w": 425
					},
					{
						"n": 11,
						"h": 304,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 91
					},
					{
						"n": 2,
						"h": 34,
						"w": 185
					},
					{
						"n": 3,
						"h": 166,
						"w": 185
					},
					{
						"n": 4,
						"h": 290,
						"w": 214
					},
					{
						"n": 5,
						"h": 408,
						"w": 185
					},
					{
						"n": 6,
						"h": 221,
						"w": 249
					},
					{
						"n": 7,
						"h": 234,
						"w": 312
					},
					{
						"n": 8,
						"h": 418,
						"w": 312
					},
					{
						"n": 9,
						"h": 49,
						"w": 376
					},
					{
						"n": 10,
						"h": 148,
						"w": 440
					},
					{
						"n": 11,
						"h": 289,
						"w": 440
					}
				],
				"ball": {
					"n": 0,
					"h": 160,
					"w": 506,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 132,
			"minute": 6,
			"messages": [
				{
					"owner": 2,
					"mes": "Себастьян Пейша[24](Опава) пасует вперед М.Манолову[27](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 10
					},
					{
						"n": 2,
						"h": 120,
						"w": 245
					},
					{
						"n": 3,
						"h": 169,
						"w": 244
					},
					{
						"n": 4,
						"h": 273,
						"w": 247
					},
					{
						"n": 5,
						"h": 330,
						"w": 259
					},
					{
						"n": 6,
						"h": 56,
						"w": 383
					},
					{
						"n": 7,
						"h": 206,
						"w": 378
					},
					{
						"n": 8,
						"h": 273,
						"w": 346
					},
					{
						"n": 9,
						"h": 394,
						"w": 300
					},
					{
						"n": 10,
						"h": 162,
						"w": 421
					},
					{
						"n": 11,
						"h": 301,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 87
					},
					{
						"n": 2,
						"h": 44,
						"w": 195
					},
					{
						"n": 3,
						"h": 149,
						"w": 195
					},
					{
						"n": 4,
						"h": 294,
						"w": 205,
						"m": 610
					},
					{
						"n": 5,
						"h": 402,
						"w": 195
					},
					{
						"n": 6,
						"h": 224,
						"w": 258
					},
					{
						"n": 7,
						"h": 234,
						"w": 312
					},
					{
						"n": 8,
						"h": 417,
						"w": 322
					},
					{
						"n": 9,
						"h": 45,
						"w": 385
					},
					{
						"n": 10,
						"h": 157,
						"w": 449
					},
					{
						"n": 11,
						"h": 301,
						"w": 449
					}
				],
				"ball": {
					"n": 0,
					"h": 216,
					"w": 408,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 38
		},
		{
			"num": 133,
			"minute": 7,
			"possession": 42,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 11
					},
					{
						"n": 2,
						"h": 120,
						"w": 206
					},
					{
						"n": 3,
						"h": 166,
						"w": 205
					},
					{
						"n": 4,
						"h": 275,
						"w": 208
					},
					{
						"n": 5,
						"h": 330,
						"w": 220
					},
					{
						"n": 6,
						"h": 56,
						"w": 344
					},
					{
						"n": 7,
						"h": 211,
						"w": 359
					},
					{
						"n": 8,
						"h": 273,
						"w": 307,
						"f": 97
					},
					{
						"n": 9,
						"h": 394,
						"w": 281,
						"f": 97
					},
					{
						"n": 10,
						"h": 165,
						"w": 382,
						"f": 97
					},
					{
						"n": 11,
						"h": 264,
						"w": 438
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 109,
						"f": 96
					},
					{
						"n": 2,
						"h": 49,
						"w": 233
					},
					{
						"n": 3,
						"h": 157,
						"w": 233
					},
					{
						"n": 4,
						"h": 288,
						"w": 244
					},
					{
						"n": 5,
						"h": 395,
						"w": 233
					},
					{
						"n": 6,
						"h": 207,
						"w": 294
					},
					{
						"n": 7,
						"h": 237,
						"w": 338
					},
					{
						"n": 8,
						"h": 419,
						"w": 361
					},
					{
						"n": 9,
						"h": 40,
						"w": 424
					},
					{
						"n": 10,
						"h": 156,
						"w": 488
					},
					{
						"n": 11,
						"h": 306,
						"w": 488
					}
				],
				"ball": {
					"n": 0,
					"h": 213,
					"w": 382,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 134,
			"minute": 7,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 13
					},
					{
						"n": 2,
						"h": 120,
						"w": 166
					},
					{
						"n": 3,
						"h": 164,
						"w": 165
					},
					{
						"n": 4,
						"h": 274,
						"w": 168
					},
					{
						"n": 5,
						"h": 330,
						"w": 180
					},
					{
						"n": 6,
						"h": 56,
						"w": 304
					},
					{
						"n": 7,
						"h": 193,
						"w": 351
					},
					{
						"n": 8,
						"h": 270,
						"w": 267
					},
					{
						"n": 9,
						"h": 394,
						"w": 241
					},
					{
						"n": 10,
						"h": 162,
						"w": 342
					},
					{
						"n": 11,
						"h": 303,
						"w": 434
					}
				],
				"away": [
					{
						"n": 1,
						"h": 221,
						"w": 119
					},
					{
						"n": 2,
						"h": 57,
						"w": 273
					},
					{
						"n": 3,
						"h": 165,
						"w": 265
					},
					{
						"n": 4,
						"h": 269,
						"w": 276
					},
					{
						"n": 5,
						"h": 377,
						"w": 266
					},
					{
						"n": 6,
						"h": 202,
						"w": 333
					},
					{
						"n": 7,
						"h": 260,
						"w": 351
					},
					{
						"n": 8,
						"h": 422,
						"w": 401
					},
					{
						"n": 9,
						"h": 36,
						"w": 464
					},
					{
						"n": 10,
						"h": 147,
						"w": 527
					},
					{
						"n": 11,
						"h": 301,
						"w": 527
					}
				],
				"ball": {
					"n": 0,
					"h": 190,
					"w": 369,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 135,
			"minute": 7,
			"messages": [
				{
					"owner": 2,
					"mes": "Мирослав Манолов[27](Опава) пасует назад..."
				},
				{
					"owner": 2,
					"mes": "Крыштоф Ласак[21](Опава) останавливает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 10
					},
					{
						"n": 2,
						"h": 120,
						"w": 218
					},
					{
						"n": 3,
						"h": 164,
						"w": 217
					},
					{
						"n": 4,
						"h": 280,
						"w": 220
					},
					{
						"n": 5,
						"h": 330,
						"w": 232
					},
					{
						"n": 6,
						"h": 56,
						"w": 270
					},
					{
						"n": 7,
						"h": 192,
						"w": 311
					},
					{
						"n": 8,
						"h": 300,
						"w": 292
					},
					{
						"n": 9,
						"h": 392,
						"w": 250
					},
					{
						"n": 10,
						"h": 147,
						"w": 392
					},
					{
						"n": 11,
						"h": 322,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 243,
						"w": 145
					},
					{
						"n": 2,
						"h": 58,
						"w": 221
					},
					{
						"n": 3,
						"h": 167,
						"w": 213
					},
					{
						"n": 4,
						"h": 271,
						"w": 224
					},
					{
						"n": 5,
						"h": 376,
						"w": 214
					},
					{
						"n": 6,
						"h": 219,
						"w": 284
					},
					{
						"n": 7,
						"h": 251,
						"w": 346,
						"m": 600
					},
					{
						"n": 8,
						"h": 410,
						"w": 435
					},
					{
						"n": 9,
						"h": 58,
						"w": 435
					},
					{
						"n": 10,
						"h": 154,
						"w": 475
					},
					{
						"n": 11,
						"h": 300,
						"w": 475
					}
				],
				"ball": {
					"n": 0,
					"h": 207,
					"w": 575,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 52
		},
		{
			"num": 136,
			"minute": 7,
			"messages": [
				{
					"owner": 2,
					"mes": "Крыштоф Ласак[21](Опава) теряет мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 15
					},
					{
						"n": 2,
						"h": 120,
						"w": 225
					},
					{
						"n": 3,
						"h": 168,
						"w": 222
					},
					{
						"n": 4,
						"h": 281,
						"w": 227
					},
					{
						"n": 5,
						"h": 330,
						"w": 232
					},
					{
						"n": 6,
						"h": 56,
						"w": 263
					},
					{
						"n": 7,
						"h": 195,
						"w": 309
					},
					{
						"n": 8,
						"h": 294,
						"w": 295
					},
					{
						"n": 9,
						"h": 393,
						"w": 257
					},
					{
						"n": 10,
						"h": 149,
						"w": 399
					},
					{
						"n": 11,
						"h": 317,
						"w": 455
					}
				],
				"away": [
					{
						"n": 1,
						"h": 243,
						"w": 145
					},
					{
						"n": 2,
						"h": 59,
						"w": 214
					},
					{
						"n": 3,
						"h": 168,
						"w": 206
					},
					{
						"n": 4,
						"h": 270,
						"w": 217
					},
					{
						"n": 5,
						"h": 376,
						"w": 207
					},
					{
						"n": 6,
						"h": 218,
						"w": 277
					},
					{
						"n": 7,
						"h": 246,
						"w": 341
					},
					{
						"n": 8,
						"h": 407,
						"w": 429
					},
					{
						"n": 9,
						"h": 57,
						"w": 428
					},
					{
						"n": 10,
						"h": 153,
						"w": 468
					},
					{
						"n": 11,
						"h": 293,
						"w": 472
					}
				],
				"ball": {
					"n": 0,
					"h": 187,
					"w": 555,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 7
		},
		{
			"num": 137,
			"minute": 7,
			"messages": [
				{
					"owner": 2,
					"mes": "Крыштоф Ласак[21](Опава) первый успевает к мячу..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 15
					},
					{
						"n": 2,
						"h": 120,
						"w": 243
					},
					{
						"n": 3,
						"h": 195,
						"w": 232
					},
					{
						"n": 4,
						"h": 263,
						"w": 224
					},
					{
						"n": 5,
						"h": 330,
						"w": 241
					},
					{
						"n": 6,
						"h": 57,
						"w": 265
					},
					{
						"n": 7,
						"h": 178,
						"w": 315
					},
					{
						"n": 8,
						"h": 277,
						"w": 303
					},
					{
						"n": 9,
						"h": 394,
						"w": 285
					},
					{
						"n": 10,
						"h": 156,
						"w": 426
					},
					{
						"n": 11,
						"h": 293,
						"w": 469
					}
				],
				"away": [
					{
						"n": 1,
						"h": 263,
						"w": 165
					},
					{
						"n": 2,
						"h": 65,
						"w": 186
					},
					{
						"n": 3,
						"h": 169,
						"w": 178
					},
					{
						"n": 4,
						"h": 267,
						"w": 189
					},
					{
						"n": 5,
						"h": 381,
						"w": 179
					},
					{
						"n": 6,
						"h": 218,
						"w": 249
					},
					{
						"n": 7,
						"h": 236,
						"w": 349
					},
					{
						"n": 8,
						"h": 393,
						"w": 420
					},
					{
						"n": 9,
						"h": 42,
						"w": 420
					},
					{
						"n": 10,
						"h": 175,
						"w": 451
					},
					{
						"n": 11,
						"h": 266,
						"w": 469
					}
				],
				"ball": {
					"n": 0,
					"h": 187,
					"w": 555,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 28
		},
		{
			"num": 138,
			"minute": 7,
			"messages": [
				{
					"owner": 2,
					"mes": "Крыштоф Ласак[21](Опава) отдает передачу направо Т.Прохазке[25](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 12
					},
					{
						"n": 2,
						"h": 120,
						"w": 260
					},
					{
						"n": 3,
						"h": 180,
						"w": 259
					},
					{
						"n": 4,
						"h": 234,
						"w": 249
					},
					{
						"n": 5,
						"h": 295,
						"w": 255
					},
					{
						"n": 6,
						"h": 56,
						"w": 285
					},
					{
						"n": 7,
						"h": 171,
						"w": 331
					},
					{
						"n": 8,
						"h": 276,
						"w": 321
					},
					{
						"n": 9,
						"h": 394,
						"w": 285
					},
					{
						"n": 10,
						"h": 134,
						"w": 450
					},
					{
						"n": 11,
						"h": 315,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 259,
						"w": 156
					},
					{
						"n": 2,
						"h": 75,
						"w": 156
					},
					{
						"n": 3,
						"h": 166,
						"w": 140
					},
					{
						"n": 4,
						"h": 272,
						"w": 152
					},
					{
						"n": 5,
						"h": 355,
						"w": 152
					},
					{
						"n": 6,
						"h": 254,
						"w": 239
					},
					{
						"n": 7,
						"h": 253,
						"w": 345
					},
					{
						"n": 8,
						"h": 408,
						"w": 420
					},
					{
						"n": 9,
						"h": 32,
						"w": 420
					},
					{
						"n": 10,
						"h": 178,
						"w": 424
					},
					{
						"n": 11,
						"h": 278,
						"w": 433
					}
				],
				"ball": {
					"n": 0,
					"h": 95,
					"w": 568,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 38
		},
		{
			"num": 139,
			"minute": 7,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 18
					},
					{
						"n": 2,
						"h": 120,
						"w": 269
					},
					{
						"n": 3,
						"h": 208,
						"w": 252
					},
					{
						"n": 4,
						"h": 271,
						"w": 266
					},
					{
						"n": 5,
						"h": 330,
						"w": 259
					},
					{
						"n": 6,
						"h": 65,
						"w": 275
					},
					{
						"n": 7,
						"h": 196,
						"w": 328
					},
					{
						"n": 8,
						"h": 244,
						"w": 326
					},
					{
						"n": 9,
						"h": 394,
						"w": 285
					},
					{
						"n": 10,
						"h": 165,
						"w": 450
					},
					{
						"n": 11,
						"h": 285,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 243,
						"w": 119
					},
					{
						"n": 2,
						"h": 72,
						"w": 156
					},
					{
						"n": 3,
						"h": 165,
						"w": 116
					},
					{
						"n": 4,
						"h": 285,
						"w": 135
					},
					{
						"n": 5,
						"h": 368,
						"w": 184
					},
					{
						"n": 6,
						"h": 248,
						"w": 221
					},
					{
						"n": 7,
						"h": 257,
						"w": 341
					},
					{
						"n": 8,
						"h": 400,
						"w": 420
					},
					{
						"n": 9,
						"h": 34,
						"w": 420
					},
					{
						"n": 10,
						"h": 159,
						"w": 441
					},
					{
						"n": 11,
						"h": 238,
						"w": 426
					}
				],
				"ball": {
					"n": 0,
					"h": 82,
					"w": 536,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 140,
			"minute": 7,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 15
					},
					{
						"n": 2,
						"h": 81,
						"w": 261
					},
					{
						"n": 3,
						"h": 224,
						"w": 258
					},
					{
						"n": 4,
						"h": 277,
						"w": 253
					},
					{
						"n": 5,
						"h": 330,
						"w": 261
					},
					{
						"n": 6,
						"h": 58,
						"w": 314
					},
					{
						"n": 7,
						"h": 170,
						"w": 329
					},
					{
						"n": 8,
						"h": 215,
						"w": 319
					},
					{
						"n": 9,
						"h": 380,
						"w": 267
					},
					{
						"n": 10,
						"h": 146,
						"w": 442
					},
					{
						"n": 11,
						"h": 286,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 236,
						"w": 80
					},
					{
						"n": 2,
						"h": 66,
						"w": 163
					},
					{
						"n": 3,
						"h": 164,
						"w": 133
					},
					{
						"n": 4,
						"h": 282,
						"w": 139
					},
					{
						"n": 5,
						"h": 367,
						"w": 224
					},
					{
						"n": 6,
						"h": 258,
						"w": 213
					},
					{
						"n": 7,
						"h": 247,
						"w": 302
					},
					{
						"n": 8,
						"h": 407,
						"w": 448
					},
					{
						"n": 9,
						"h": 55,
						"w": 428
					},
					{
						"n": 10,
						"h": 156,
						"w": 433
					},
					{
						"n": 11,
						"h": 230,
						"w": 386
					}
				],
				"ball": {
					"n": 0,
					"h": 83,
					"w": 496,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 141,
			"minute": 7,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 12
					},
					{
						"n": 2,
						"h": 70,
						"w": 253
					},
					{
						"n": 3,
						"h": 202,
						"w": 239
					},
					{
						"n": 4,
						"h": 283,
						"w": 237
					},
					{
						"n": 5,
						"h": 330,
						"w": 238
					},
					{
						"n": 6,
						"h": 28,
						"w": 332
					},
					{
						"n": 7,
						"h": 193,
						"w": 303
					},
					{
						"n": 8,
						"h": 244,
						"w": 314
					},
					{
						"n": 9,
						"h": 395,
						"w": 304
					},
					{
						"n": 10,
						"h": 144,
						"w": 422
					},
					{
						"n": 11,
						"h": 286,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 40
					},
					{
						"n": 2,
						"h": 62,
						"w": 203
					},
					{
						"n": 3,
						"h": 164,
						"w": 149
					},
					{
						"n": 4,
						"h": 279,
						"w": 155
					},
					{
						"n": 5,
						"h": 371,
						"w": 259
					},
					{
						"n": 6,
						"h": 232,
						"w": 244
					},
					{
						"n": 7,
						"h": 260,
						"w": 332
					},
					{
						"n": 8,
						"h": 410,
						"w": 447
					},
					{
						"n": 9,
						"h": 43,
						"w": 448
					},
					{
						"n": 10,
						"h": 156,
						"w": 452
					},
					{
						"n": 11,
						"h": 262,
						"w": 402
					}
				],
				"ball": {
					"n": 0,
					"h": 79,
					"w": 461,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 142,
			"minute": 7,
			"messages": [
				{
					"owner": 2,
					"mes": "Томаш Прохазка[25](Опава) пасует О.Дюмону[26](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 18
					},
					{
						"n": 2,
						"h": 105,
						"w": 230
					},
					{
						"n": 3,
						"h": 184,
						"w": 219
					},
					{
						"n": 4,
						"h": 282,
						"w": 214
					},
					{
						"n": 5,
						"h": 330,
						"w": 212
					},
					{
						"n": 6,
						"h": 56,
						"w": 300
					},
					{
						"n": 7,
						"h": 167,
						"w": 274
					},
					{
						"n": 8,
						"h": 257,
						"w": 306
					},
					{
						"n": 9,
						"h": 394,
						"w": 278
					},
					{
						"n": 10,
						"h": 128,
						"w": 400
					},
					{
						"n": 11,
						"h": 289,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 221,
						"w": 65
					},
					{
						"n": 2,
						"h": 48,
						"w": 163
					},
					{
						"n": 3,
						"h": 161,
						"w": 159
					},
					{
						"n": 4,
						"h": 297,
						"w": 159
					},
					{
						"n": 5,
						"h": 375,
						"w": 250
					},
					{
						"n": 6,
						"h": 247,
						"w": 254
					},
					{
						"n": 7,
						"h": 224,
						"w": 324
					},
					{
						"n": 8,
						"h": 410,
						"w": 405
					},
					{
						"n": 9,
						"h": 50,
						"w": 407
					},
					{
						"n": 10,
						"h": 156,
						"w": 488
					},
					{
						"n": 11,
						"h": 278,
						"w": 441
					}
				],
				"ball": {
					"n": 0,
					"h": 203,
					"w": 466,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 42
		},
		{
			"num": 143,
			"minute": 7,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 16
					},
					{
						"n": 2,
						"h": 116,
						"w": 191
					},
					{
						"n": 3,
						"h": 174,
						"w": 186
					},
					{
						"n": 4,
						"h": 288,
						"w": 181
					},
					{
						"n": 5,
						"h": 330,
						"w": 176
					},
					{
						"n": 6,
						"h": 56,
						"w": 260
					},
					{
						"n": 7,
						"h": 160,
						"w": 242
					},
					{
						"n": 8,
						"h": 261,
						"w": 275
					},
					{
						"n": 9,
						"h": 394,
						"w": 238
					},
					{
						"n": 10,
						"h": 167,
						"w": 406
					},
					{
						"n": 11,
						"h": 317,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 85
					},
					{
						"n": 2,
						"h": 58,
						"w": 202
					},
					{
						"n": 3,
						"h": 169,
						"w": 188
					},
					{
						"n": 4,
						"h": 285,
						"w": 197
					},
					{
						"n": 5,
						"h": 393,
						"w": 220
					},
					{
						"n": 6,
						"h": 253,
						"w": 289
					},
					{
						"n": 7,
						"h": 219,
						"w": 363
					},
					{
						"n": 8,
						"h": 408,
						"w": 445
					},
					{
						"n": 9,
						"h": 49,
						"w": 447
					},
					{
						"n": 10,
						"h": 136,
						"w": 519
					},
					{
						"n": 11,
						"h": 288,
						"w": 479
					}
				],
				"ball": {
					"n": 0,
					"h": 197,
					"w": 431,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 144,
			"minute": 7,
			"messages": [
				{
					"owner": 2,
					"mes": "Оливье Дюмон[26](Опава) пасует на ход М.Манолову[27](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 15
					},
					{
						"n": 2,
						"h": 120,
						"w": 157
					},
					{
						"n": 3,
						"h": 183,
						"w": 161
					},
					{
						"n": 4,
						"h": 287,
						"w": 154
					},
					{
						"n": 5,
						"h": 330,
						"w": 151
					},
					{
						"n": 6,
						"h": 56,
						"w": 225
					},
					{
						"n": 7,
						"h": 183,
						"w": 268
					},
					{
						"n": 8,
						"h": 261,
						"w": 240
					},
					{
						"n": 9,
						"h": 394,
						"w": 204
					},
					{
						"n": 10,
						"h": 171,
						"w": 400
					},
					{
						"n": 11,
						"h": 282,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 226,
						"w": 107
					},
					{
						"n": 2,
						"h": 63,
						"w": 237
					},
					{
						"n": 3,
						"h": 177,
						"w": 222
					},
					{
						"n": 4,
						"h": 279,
						"w": 232
					},
					{
						"n": 5,
						"h": 394,
						"w": 242
					},
					{
						"n": 6,
						"h": 253,
						"w": 289
					},
					{
						"n": 7,
						"h": 234,
						"w": 393
					},
					{
						"n": 8,
						"h": 410,
						"w": 480
					},
					{
						"n": 9,
						"h": 44,
						"w": 481
					},
					{
						"n": 10,
						"h": 153,
						"w": 537
					},
					{
						"n": 11,
						"h": 282,
						"w": 504
					}
				],
				"ball": {
					"n": 0,
					"h": 216,
					"w": 327,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 35
		},
		{
			"num": 145,
			"minute": 7,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 17
					},
					{
						"n": 2,
						"h": 120,
						"w": 142
					},
					{
						"n": 3,
						"h": 160,
						"w": 128
					},
					{
						"n": 4,
						"h": 278,
						"w": 140
					},
					{
						"n": 5,
						"h": 330,
						"w": 128
					},
					{
						"n": 6,
						"h": 56,
						"w": 185
					},
					{
						"n": 7,
						"h": 180,
						"w": 306
					},
					{
						"n": 8,
						"h": 271,
						"w": 228
					},
					{
						"n": 9,
						"h": 394,
						"w": 164
					},
					{
						"n": 10,
						"h": 170,
						"w": 400
					},
					{
						"n": 11,
						"h": 319,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 103
					},
					{
						"n": 2,
						"h": 58,
						"w": 276
					},
					{
						"n": 3,
						"h": 165,
						"w": 238
					},
					{
						"n": 4,
						"h": 280,
						"w": 242
					},
					{
						"n": 5,
						"h": 387,
						"w": 272
					},
					{
						"n": 6,
						"h": 242,
						"w": 327
					},
					{
						"n": 7,
						"h": 269,
						"w": 394
					},
					{
						"n": 8,
						"h": 401,
						"w": 519
					},
					{
						"n": 9,
						"h": 44,
						"w": 521
					},
					{
						"n": 10,
						"h": 155,
						"w": 568
					},
					{
						"n": 11,
						"h": 300,
						"w": 526
					}
				],
				"ball": {
					"n": 0,
					"h": 181,
					"w": 326,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 146,
			"minute": 7,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 18
					},
					{
						"n": 2,
						"h": 120,
						"w": 102
					},
					{
						"n": 3,
						"h": 182,
						"w": 102
					},
					{
						"n": 4,
						"h": 268,
						"w": 103
					},
					{
						"n": 5,
						"h": 330,
						"w": 103
					},
					{
						"n": 6,
						"h": 56,
						"w": 145
					},
					{
						"n": 7,
						"h": 149,
						"w": 300
					},
					{
						"n": 8,
						"h": 262,
						"w": 204
					},
					{
						"n": 9,
						"h": 394,
						"w": 125
					},
					{
						"n": 10,
						"h": 184,
						"w": 400
					},
					{
						"n": 11,
						"h": 281,
						"w": 438
					}
				],
				"away": [
					{
						"n": 1,
						"h": 228,
						"w": 122
					},
					{
						"n": 2,
						"h": 71,
						"w": 314
					},
					{
						"n": 3,
						"h": 180,
						"w": 273
					},
					{
						"n": 4,
						"h": 266,
						"w": 279
					},
					{
						"n": 5,
						"h": 376,
						"w": 284
					},
					{
						"n": 6,
						"h": 238,
						"w": 367
					},
					{
						"n": 7,
						"h": 304,
						"w": 397
					},
					{
						"n": 8,
						"h": 400,
						"w": 559
					},
					{
						"n": 9,
						"h": 52,
						"w": 560
					},
					{
						"n": 10,
						"h": 167,
						"w": 594
					},
					{
						"n": 11,
						"h": 280,
						"w": 550
					}
				],
				"ball": {
					"n": 0,
					"h": 146,
					"w": 323,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 147,
			"minute": 7,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 10
					},
					{
						"n": 2,
						"h": 80,
						"w": 106
					},
					{
						"n": 3,
						"h": 174,
						"w": 106
					},
					{
						"n": 4,
						"h": 279,
						"w": 99
					},
					{
						"n": 5,
						"h": 370,
						"w": 107
					},
					{
						"n": 6,
						"h": 46,
						"w": 184
					},
					{
						"n": 7,
						"h": 177,
						"w": 294
					},
					{
						"n": 8,
						"h": 270,
						"w": 197
					},
					{
						"n": 9,
						"h": 395,
						"w": 165
					},
					{
						"n": 10,
						"h": 178,
						"w": 400
					},
					{
						"n": 11,
						"h": 308,
						"w": 428
					}
				],
				"away": [
					{
						"n": 1,
						"h": 229,
						"w": 124
					},
					{
						"n": 2,
						"h": 62,
						"w": 315
					},
					{
						"n": 3,
						"h": 166,
						"w": 265
					},
					{
						"n": 4,
						"h": 272,
						"w": 318
					},
					{
						"n": 5,
						"h": 379,
						"w": 291
					},
					{
						"n": 6,
						"h": 229,
						"w": 406
					},
					{
						"n": 7,
						"h": 270,
						"w": 406
					},
					{
						"n": 8,
						"h": 402,
						"w": 599
					},
					{
						"n": 9,
						"h": 45,
						"w": 600
					},
					{
						"n": 10,
						"h": 147,
						"w": 596
					},
					{
						"n": 11,
						"h": 295,
						"w": 587
					}
				],
				"ball": {
					"n": 0,
					"h": 180,
					"w": 314,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 148,
			"minute": 7,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 16
					},
					{
						"n": 2,
						"h": 60,
						"w": 98
					},
					{
						"n": 3,
						"h": 186,
						"w": 87
					},
					{
						"n": 4,
						"h": 267,
						"w": 102
					},
					{
						"n": 5,
						"h": 349,
						"w": 98
					},
					{
						"n": 6,
						"h": 51,
						"w": 193
					},
					{
						"n": 7,
						"h": 216,
						"w": 287
					},
					{
						"n": 8,
						"h": 269,
						"w": 163
					},
					{
						"n": 9,
						"h": 412,
						"w": 193
					},
					{
						"n": 10,
						"h": 180,
						"w": 400
					},
					{
						"n": 11,
						"h": 280,
						"w": 415
					}
				],
				"away": [
					{
						"n": 1,
						"h": 229,
						"w": 119
					},
					{
						"n": 2,
						"h": 68,
						"w": 326
					},
					{
						"n": 3,
						"h": 170,
						"w": 293
					},
					{
						"n": 4,
						"h": 270,
						"w": 300
					},
					{
						"n": 5,
						"h": 392,
						"w": 307
					},
					{
						"n": 6,
						"h": 236,
						"w": 445
					},
					{
						"n": 7,
						"h": 236,
						"w": 415
					},
					{
						"n": 8,
						"h": 406,
						"w": 603
					},
					{
						"n": 9,
						"h": 85,
						"w": 603
					},
					{
						"n": 10,
						"h": 167,
						"w": 610
					},
					{
						"n": 11,
						"h": 275,
						"w": 580
					}
				],
				"ball": {
					"n": 0,
					"h": 214,
					"w": 305,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 149,
			"minute": 7,
			"messages": [
				{
					"owner": 2,
					"mes": "Найдя свободного Ш.Товарека[31](Опава), Мирослав Манолов[27](Опава) пасует вперед..."
				},
				{
					"owner": 2,
					"mes": "Неточный пас..."
				},
				{
					"owner": 2,
					"mes": "Оливье Дюмон[26](Опава) устремляется к свободному мячу и подхватывает его..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 10
					},
					{
						"n": 2,
						"h": 59,
						"w": 107
					},
					{
						"n": 3,
						"h": 186,
						"w": 96
					},
					{
						"n": 4,
						"h": 265,
						"w": 111
					},
					{
						"n": 5,
						"h": 355,
						"w": 105
					},
					{
						"n": 6,
						"h": 43,
						"w": 198
					},
					{
						"n": 7,
						"h": 212,
						"w": 278
					},
					{
						"n": 8,
						"h": 263,
						"w": 170
					},
					{
						"n": 9,
						"h": 418,
						"w": 200
					},
					{
						"n": 10,
						"h": 178,
						"w": 400
					},
					{
						"n": 11,
						"h": 280,
						"w": 424
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 121
					},
					{
						"n": 2,
						"h": 69,
						"w": 317
					},
					{
						"n": 3,
						"h": 169,
						"w": 284
					},
					{
						"n": 4,
						"h": 272,
						"w": 291
					},
					{
						"n": 5,
						"h": 390,
						"w": 298
					},
					{
						"n": 6,
						"h": 240,
						"w": 440,
						"m": 620
					},
					{
						"n": 7,
						"h": 236,
						"w": 415,
						"m": 590
					},
					{
						"n": 8,
						"h": 407,
						"w": 594
					},
					{
						"n": 9,
						"h": 77,
						"w": 599
					},
					{
						"n": 10,
						"h": 166,
						"w": 601
					},
					{
						"n": 11,
						"h": 282,
						"w": 574
					}
				],
				"ball": {
					"n": 0,
					"h": 210,
					"w": 280,
					"z": 0,
					"r": 0,
					"p": 1,
					"x": 0
				}
			},
			"interval": 9
		},
		{
			"num": 150,
			"minute": 7,
			"messages": [
				{
					"owner": 2,
					"mes": "Оливье Дюмон[26](Опава) закрывает мяч от соперника..."
				},
				{
					"owner": 2,
					"mes": "Агуст Хлинссон[07](Галвэй Юнайтед) отнимает у него мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 14
					},
					{
						"n": 2,
						"h": 57,
						"w": 112
					},
					{
						"n": 3,
						"h": 184,
						"w": 101
					},
					{
						"n": 4,
						"h": 266,
						"w": 111
					},
					{
						"n": 5,
						"h": 360,
						"w": 108
					},
					{
						"n": 6,
						"h": 39,
						"w": 200
					},
					{
						"n": 7,
						"h": 212,
						"w": 283,
						"m": 640
					},
					{
						"n": 8,
						"h": 263,
						"w": 175
					},
					{
						"n": 9,
						"h": 413,
						"w": 202
					},
					{
						"n": 10,
						"h": 178,
						"w": 400
					},
					{
						"n": 11,
						"h": 280,
						"w": 429
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 119
					},
					{
						"n": 2,
						"h": 65,
						"w": 313
					},
					{
						"n": 3,
						"h": 169,
						"w": 279
					},
					{
						"n": 4,
						"h": 272,
						"w": 286
					},
					{
						"n": 5,
						"h": 390,
						"w": 293
					},
					{
						"n": 6,
						"h": 240,
						"w": 445
					},
					{
						"n": 7,
						"h": 234,
						"w": 411
					},
					{
						"n": 8,
						"h": 407,
						"w": 589
					},
					{
						"n": 9,
						"h": 73,
						"w": 595
					},
					{
						"n": 10,
						"h": 167,
						"w": 596
					},
					{
						"n": 11,
						"h": 287,
						"w": 572
					}
				],
				"ball": {
					"n": 0,
					"h": 212,
					"w": 283,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 5
		},
		{
			"num": 151,
			"minute": 7,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 15
					},
					{
						"n": 2,
						"h": 63,
						"w": 152
					},
					{
						"n": 3,
						"h": 180,
						"w": 141
					},
					{
						"n": 4,
						"h": 269,
						"w": 151
					},
					{
						"n": 5,
						"h": 371,
						"w": 146
					},
					{
						"n": 6,
						"h": 41,
						"w": 240
					},
					{
						"n": 7,
						"h": 187,
						"w": 308
					},
					{
						"n": 8,
						"h": 284,
						"w": 208
					},
					{
						"n": 9,
						"h": 413,
						"w": 242
					},
					{
						"n": 10,
						"h": 168,
						"w": 439
					},
					{
						"n": 11,
						"h": 294,
						"w": 431
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 79
					},
					{
						"n": 2,
						"h": 83,
						"w": 277
					},
					{
						"n": 3,
						"h": 167,
						"w": 239
					},
					{
						"n": 4,
						"h": 267,
						"w": 246
					},
					{
						"n": 5,
						"h": 366,
						"w": 261
					},
					{
						"n": 6,
						"h": 246,
						"w": 432
					},
					{
						"n": 7,
						"h": 233,
						"w": 371
					},
					{
						"n": 8,
						"h": 407,
						"w": 549
					},
					{
						"n": 9,
						"h": 66,
						"w": 556
					},
					{
						"n": 10,
						"h": 167,
						"w": 556
					},
					{
						"n": 11,
						"h": 285,
						"w": 532
					}
				],
				"ball": {
					"n": 0,
					"h": 187,
					"w": 308,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 152,
			"minute": 7,
			"messages": [
				{
					"owner": 1,
					"mes": "Пас налево К.Колману[06](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 19
					},
					{
						"n": 2,
						"h": 69,
						"w": 205
					},
					{
						"n": 3,
						"h": 179,
						"w": 169
					},
					{
						"n": 4,
						"h": 268,
						"w": 189
					},
					{
						"n": 5,
						"h": 377,
						"w": 200
					},
					{
						"n": 6,
						"h": 49,
						"w": 294
					},
					{
						"n": 7,
						"h": 179,
						"w": 315
					},
					{
						"n": 8,
						"h": 257,
						"w": 255
					},
					{
						"n": 9,
						"h": 411,
						"w": 296
					},
					{
						"n": 10,
						"h": 162,
						"w": 470
					},
					{
						"n": 11,
						"h": 310,
						"w": 475
					}
				],
				"away": [
					{
						"n": 1,
						"h": 245,
						"w": 79
					},
					{
						"n": 2,
						"h": 110,
						"w": 240
					},
					{
						"n": 3,
						"h": 172,
						"w": 245
					},
					{
						"n": 4,
						"h": 258,
						"w": 231
					},
					{
						"n": 5,
						"h": 369,
						"w": 315
					},
					{
						"n": 6,
						"h": 263,
						"w": 380
					},
					{
						"n": 7,
						"h": 258,
						"w": 361
					},
					{
						"n": 8,
						"h": 410,
						"w": 495
					},
					{
						"n": 9,
						"h": 56,
						"w": 503
					},
					{
						"n": 10,
						"h": 179,
						"w": 503
					},
					{
						"n": 11,
						"h": 281,
						"w": 478
					}
				],
				"ball": {
					"n": 0,
					"h": 49,
					"w": 294,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 54
		},
		{
			"num": 153,
			"minute": 7,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 18
					},
					{
						"n": 2,
						"h": 58,
						"w": 233
					},
					{
						"n": 3,
						"h": 179,
						"w": 191
					},
					{
						"n": 4,
						"h": 273,
						"w": 195
					},
					{
						"n": 5,
						"h": 372,
						"w": 240
					},
					{
						"n": 6,
						"h": 49,
						"w": 329
					},
					{
						"n": 7,
						"h": 156,
						"w": 347
					},
					{
						"n": 8,
						"h": 248,
						"w": 290
					},
					{
						"n": 9,
						"h": 406,
						"w": 335
					},
					{
						"n": 10,
						"h": 173,
						"w": 479
					},
					{
						"n": 11,
						"h": 273,
						"w": 489
					}
				],
				"away": [
					{
						"n": 1,
						"h": 245,
						"w": 79
					},
					{
						"n": 2,
						"h": 110,
						"w": 231
					},
					{
						"n": 3,
						"h": 193,
						"w": 231
					},
					{
						"n": 4,
						"h": 261,
						"w": 233
					},
					{
						"n": 5,
						"h": 374,
						"w": 355
					},
					{
						"n": 6,
						"h": 279,
						"w": 344
					},
					{
						"n": 7,
						"h": 298,
						"w": 357
					},
					{
						"n": 8,
						"h": 409,
						"w": 455
					},
					{
						"n": 9,
						"h": 47,
						"w": 464
					},
					{
						"n": 10,
						"h": 188,
						"w": 464
					},
					{
						"n": 11,
						"h": 291,
						"w": 440
					}
				],
				"ball": {
					"n": 0,
					"h": 49,
					"w": 329,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 154,
			"minute": 7,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 12
					},
					{
						"n": 2,
						"h": 67,
						"w": 265
					},
					{
						"n": 3,
						"h": 180,
						"w": 214
					},
					{
						"n": 4,
						"h": 277,
						"w": 204
					},
					{
						"n": 5,
						"h": 385,
						"w": 271
					},
					{
						"n": 6,
						"h": 39,
						"w": 369
					},
					{
						"n": 7,
						"h": 137,
						"w": 383
					},
					{
						"n": 8,
						"h": 233,
						"w": 297
					},
					{
						"n": 9,
						"h": 408,
						"w": 375
					},
					{
						"n": 10,
						"h": 177,
						"w": 479
					},
					{
						"n": 11,
						"h": 289,
						"w": 489
					}
				],
				"away": [
					{
						"n": 1,
						"h": 245,
						"w": 74
					},
					{
						"n": 2,
						"h": 110,
						"w": 199
					},
					{
						"n": 3,
						"h": 180,
						"w": 193
					},
					{
						"n": 4,
						"h": 260,
						"w": 193
					},
					{
						"n": 5,
						"h": 374,
						"w": 351
					},
					{
						"n": 6,
						"h": 279,
						"w": 304
					},
					{
						"n": 7,
						"h": 273,
						"w": 326
					},
					{
						"n": 8,
						"h": 414,
						"w": 415
					},
					{
						"n": 9,
						"h": 46,
						"w": 424
					},
					{
						"n": 10,
						"h": 205,
						"w": 428
					},
					{
						"n": 11,
						"h": 285,
						"w": 400
					}
				],
				"ball": {
					"n": 0,
					"h": 39,
					"w": 369,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 155,
			"minute": 7,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 19
					},
					{
						"n": 2,
						"h": 74,
						"w": 261
					},
					{
						"n": 3,
						"h": 185,
						"w": 211
					},
					{
						"n": 4,
						"h": 281,
						"w": 211
					},
					{
						"n": 5,
						"h": 372,
						"w": 262
					},
					{
						"n": 6,
						"h": 39,
						"w": 417
					},
					{
						"n": 7,
						"h": 169,
						"w": 407
					},
					{
						"n": 8,
						"h": 242,
						"w": 294
					},
					{
						"n": 9,
						"h": 406,
						"w": 415
					},
					{
						"n": 10,
						"h": 160,
						"w": 507
					},
					{
						"n": 11,
						"h": 281,
						"w": 528
					}
				],
				"away": [
					{
						"n": 1,
						"h": 245,
						"w": 71
					},
					{
						"n": 2,
						"h": 110,
						"w": 161
					},
					{
						"n": 3,
						"h": 187,
						"w": 163
					},
					{
						"n": 4,
						"h": 279,
						"w": 162
					},
					{
						"n": 5,
						"h": 382,
						"w": 305
					},
					{
						"n": 6,
						"h": 282,
						"w": 254
					},
					{
						"n": 7,
						"h": 287,
						"w": 289
					},
					{
						"n": 8,
						"h": 412,
						"w": 395
					},
					{
						"n": 9,
						"h": 46,
						"w": 384
					},
					{
						"n": 10,
						"h": 208,
						"w": 406
					},
					{
						"n": 11,
						"h": 289,
						"w": 372
					}
				],
				"ball": {
					"n": 0,
					"h": 39,
					"w": 417,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 156,
			"minute": 7,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 13
					},
					{
						"n": 2,
						"h": 67,
						"w": 285
					},
					{
						"n": 3,
						"h": 174,
						"w": 234
					},
					{
						"n": 4,
						"h": 269,
						"w": 238
					},
					{
						"n": 5,
						"h": 383,
						"w": 301
					},
					{
						"n": 6,
						"h": 39,
						"w": 464
					},
					{
						"n": 7,
						"h": 145,
						"w": 434
					},
					{
						"n": 8,
						"h": 251,
						"w": 328
					},
					{
						"n": 9,
						"h": 407,
						"w": 455
					},
					{
						"n": 10,
						"h": 153,
						"w": 547
					},
					{
						"n": 11,
						"h": 277,
						"w": 559
					}
				],
				"away": [
					{
						"n": 1,
						"h": 245,
						"w": 70
					},
					{
						"n": 2,
						"h": 110,
						"w": 146
					},
					{
						"n": 3,
						"h": 184,
						"w": 130
					},
					{
						"n": 4,
						"h": 283,
						"w": 140
					},
					{
						"n": 5,
						"h": 385,
						"w": 258
					},
					{
						"n": 6,
						"h": 294,
						"w": 206
					},
					{
						"n": 7,
						"h": 305,
						"w": 262
					},
					{
						"n": 8,
						"h": 413,
						"w": 375
					},
					{
						"n": 9,
						"h": 44,
						"w": 344
					},
					{
						"n": 10,
						"h": 199,
						"w": 372
					},
					{
						"n": 11,
						"h": 291,
						"w": 332
					}
				],
				"ball": {
					"n": 0,
					"h": 39,
					"w": 464,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 157,
			"minute": 7,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 19
					},
					{
						"n": 2,
						"h": 60,
						"w": 324
					},
					{
						"n": 3,
						"h": 165,
						"w": 268
					},
					{
						"n": 4,
						"h": 271,
						"w": 278
					},
					{
						"n": 5,
						"h": 379,
						"w": 321
					},
					{
						"n": 6,
						"h": 39,
						"w": 512
					},
					{
						"n": 7,
						"h": 163,
						"w": 470
					},
					{
						"n": 8,
						"h": 244,
						"w": 367
					},
					{
						"n": 9,
						"h": 405,
						"w": 495
					},
					{
						"n": 10,
						"h": 177,
						"w": 579
					},
					{
						"n": 11,
						"h": 270,
						"w": 590
					}
				],
				"away": [
					{
						"n": 1,
						"h": 245,
						"w": 72
					},
					{
						"n": 2,
						"h": 110,
						"w": 106
					},
					{
						"n": 3,
						"h": 196,
						"w": 107
					},
					{
						"n": 4,
						"h": 266,
						"w": 104
					},
					{
						"n": 5,
						"h": 386,
						"w": 211
					},
					{
						"n": 6,
						"h": 265,
						"w": 165
					},
					{
						"n": 7,
						"h": 294,
						"w": 237
					},
					{
						"n": 8,
						"h": 412,
						"w": 335
					},
					{
						"n": 9,
						"h": 41,
						"w": 304
					},
					{
						"n": 10,
						"h": 206,
						"w": 333
					},
					{
						"n": 11,
						"h": 289,
						"w": 305
					}
				],
				"ball": {
					"n": 0,
					"h": 39,
					"w": 512,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 158,
			"minute": 7,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 16
					},
					{
						"n": 2,
						"h": 78,
						"w": 360
					},
					{
						"n": 3,
						"h": 165,
						"w": 308
					},
					{
						"n": 4,
						"h": 284,
						"w": 315
					},
					{
						"n": 5,
						"h": 380,
						"w": 361
					},
					{
						"n": 6,
						"h": 39,
						"w": 559
					},
					{
						"n": 7,
						"h": 150,
						"w": 508
					},
					{
						"n": 8,
						"h": 247,
						"w": 407
					},
					{
						"n": 9,
						"h": 405,
						"w": 535
					},
					{
						"n": 10,
						"h": 167,
						"w": 618
					},
					{
						"n": 11,
						"h": 283,
						"w": 628
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 39
					},
					{
						"n": 2,
						"h": 110,
						"w": 66
					},
					{
						"n": 3,
						"h": 187,
						"w": 71
					},
					{
						"n": 4,
						"h": 270,
						"w": 77
					},
					{
						"n": 5,
						"h": 399,
						"w": 166
					},
					{
						"n": 6,
						"h": 304,
						"w": 134
					},
					{
						"n": 7,
						"h": 296,
						"w": 200
					},
					{
						"n": 8,
						"h": 414,
						"w": 295
					},
					{
						"n": 9,
						"h": 45,
						"w": 264
					},
					{
						"n": 10,
						"h": 203,
						"w": 293
					},
					{
						"n": 11,
						"h": 293,
						"w": 291
					}
				],
				"ball": {
					"n": 0,
					"h": 39,
					"w": 559,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 159,
			"minute": 7,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 16
					},
					{
						"n": 2,
						"h": 65,
						"w": 375
					},
					{
						"n": 3,
						"h": 179,
						"w": 329
					},
					{
						"n": 4,
						"h": 268,
						"w": 320
					},
					{
						"n": 5,
						"h": 381,
						"w": 369
					},
					{
						"n": 6,
						"h": 39,
						"w": 607
					},
					{
						"n": 7,
						"h": 149,
						"w": 548
					},
					{
						"n": 8,
						"h": 244,
						"w": 447
					},
					{
						"n": 9,
						"h": 400,
						"w": 575
					},
					{
						"n": 10,
						"h": 170,
						"w": 658
					},
					{
						"n": 11,
						"h": 247,
						"w": 646
					}
				],
				"away": [
					{
						"n": 1,
						"h": 238,
						"w": 8
					},
					{
						"n": 2,
						"h": 110,
						"w": 45
					},
					{
						"n": 3,
						"h": 199,
						"w": 53
					},
					{
						"n": 4,
						"h": 268,
						"w": 48
					},
					{
						"n": 5,
						"h": 404,
						"w": 119
					},
					{
						"n": 6,
						"h": 258,
						"w": 114
					},
					{
						"n": 7,
						"h": 295,
						"w": 162
					},
					{
						"n": 8,
						"h": 412,
						"w": 255
					},
					{
						"n": 9,
						"h": 51,
						"w": 225
					},
					{
						"n": 10,
						"h": 206,
						"w": 253
					},
					{
						"n": 11,
						"h": 285,
						"w": 291
					}
				],
				"ball": {
					"n": 0,
					"h": 39,
					"w": 607,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 160,
			"minute": 7,
			"messages": [
				{
					"owner": 1,
					"mes": "Острый пас в штрафную..."
				},
				{
					"owner": 1,
					"mes": "Теперь с мячом Джо Квигли[10](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 18
					},
					{
						"n": 2,
						"h": 78,
						"w": 378
					},
					{
						"n": 3,
						"h": 169,
						"w": 313
					},
					{
						"n": 4,
						"h": 268,
						"w": 330
					},
					{
						"n": 5,
						"h": 391,
						"w": 364
					},
					{
						"n": 6,
						"h": 35,
						"w": 616
					},
					{
						"n": 7,
						"h": 151,
						"w": 595
					},
					{
						"n": 8,
						"h": 258,
						"w": 492
					},
					{
						"n": 9,
						"h": 397,
						"w": 622
					},
					{
						"n": 10,
						"h": 125,
						"w": 669
					},
					{
						"n": 11,
						"h": 218,
						"w": 649
					}
				],
				"away": [
					{
						"n": 1,
						"h": 238,
						"w": 7
					},
					{
						"n": 2,
						"h": 110,
						"w": 31
					},
					{
						"n": 3,
						"h": 230,
						"w": 44
					},
					{
						"n": 4,
						"h": 308,
						"w": 41
					},
					{
						"n": 5,
						"h": 390,
						"w": 84
					},
					{
						"n": 6,
						"h": 303,
						"w": 101
					},
					{
						"n": 7,
						"h": 301,
						"w": 121
					},
					{
						"n": 8,
						"h": 409,
						"w": 208
					},
					{
						"n": 9,
						"h": 24,
						"w": 190
					},
					{
						"n": 10,
						"h": 192,
						"w": 208
					},
					{
						"n": 11,
						"h": 293,
						"w": 304
					}
				],
				"ball": {
					"n": 0,
					"h": 125,
					"w": 669,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 47
		},
		{
			"num": 161,
			"minute": 8,
			"possession": 42,
			"messages": [
				{
					"owner": 1,
					"mes": "Джо Квигли[10](Галвэй Юнайтед) сильно бьет в нижний угол..."
				},
				{
					"owner": 1,
					"mes": "Себастьян Пейша[24](Опава) блокирует удар..."
				}
			],
			"U": {
				"team": 3,
				"player": 10
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 11
					},
					{
						"n": 2,
						"h": 74,
						"w": 370,
						"f": 97
					},
					{
						"n": 3,
						"h": 166,
						"w": 312
					},
					{
						"n": 4,
						"h": 277,
						"w": 327
					},
					{
						"n": 5,
						"h": 381,
						"w": 366,
						"f": 97
					},
					{
						"n": 6,
						"h": 40,
						"w": 625,
						"f": 97
					},
					{
						"n": 7,
						"h": 160,
						"w": 599,
						"f": 97
					},
					{
						"n": 8,
						"h": 264,
						"w": 483
					},
					{
						"n": 9,
						"h": 400,
						"w": 632
					},
					{
						"n": 10,
						"h": 125,
						"w": 669
					},
					{
						"n": 11,
						"h": 227,
						"w": 653,
						"f": 97
					}
				],
				"away": [
					{
						"n": 1,
						"h": 238,
						"w": 7
					},
					{
						"n": 2,
						"h": 110,
						"w": 41
					},
					{
						"n": 3,
						"h": 228,
						"w": 34,
						"f": 95
					},
					{
						"n": 4,
						"h": 316,
						"w": 46
					},
					{
						"n": 5,
						"h": 399,
						"w": 81,
						"f": 96
					},
					{
						"n": 6,
						"h": 291,
						"w": 104
					},
					{
						"n": 7,
						"h": 291,
						"w": 121
					},
					{
						"n": 8,
						"h": 409,
						"w": 198
					},
					{
						"n": 9,
						"h": 27,
						"w": 190,
						"f": 96
					},
					{
						"n": 10,
						"h": 186,
						"w": 217,
						"f": 96
					},
					{
						"n": 11,
						"h": 289,
						"w": 295,
						"f": 96
					}
				],
				"ball": {
					"n": 0,
					"h": 134,
					"w": 674,
					"z": 0,
					"r": 0,
					"p": 1,
					"x": 0
				}
			},
			"interval": 10
		},
		{
			"num": 162,
			"minute": 8,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 11
					},
					{
						"n": 2,
						"h": 62,
						"w": 364
					},
					{
						"n": 3,
						"h": 166,
						"w": 320
					},
					{
						"n": 4,
						"h": 267,
						"w": 310
					},
					{
						"n": 5,
						"h": 389,
						"w": 370
					},
					{
						"n": 6,
						"h": 44,
						"w": 605
					},
					{
						"n": 7,
						"h": 161,
						"w": 579
					},
					{
						"n": 8,
						"h": 267,
						"w": 464
					},
					{
						"n": 9,
						"h": 393,
						"w": 613
					},
					{
						"n": 10,
						"h": 125,
						"w": 669
					},
					{
						"n": 11,
						"h": 247,
						"w": 649
					}
				],
				"away": [
					{
						"n": 1,
						"h": 238,
						"w": 7
					},
					{
						"n": 2,
						"h": 110,
						"w": 30
					},
					{
						"n": 3,
						"h": 218,
						"w": 35
					},
					{
						"n": 4,
						"h": 316,
						"w": 46
					},
					{
						"n": 5,
						"h": 404,
						"w": 80
					},
					{
						"n": 6,
						"h": 297,
						"w": 100
					},
					{
						"n": 7,
						"h": 293,
						"w": 117
					},
					{
						"n": 8,
						"h": 407,
						"w": 218
					},
					{
						"n": 9,
						"h": 31,
						"w": 210
					},
					{
						"n": 10,
						"h": 186,
						"w": 217
					},
					{
						"n": 11,
						"h": 275,
						"w": 291
					}
				],
				"ball": {
					"n": 0,
					"h": 179,
					"w": 740,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 20
		},
		{
			"num": 163,
			"minute": 8,
			"messages": [
				{
					"owner": 1,
					"mes": "Боковой судья показывает на угловой..."
				}
			],
			"C": {
				"team": 1
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 40
					},
					{
						"n": 2,
						"h": 230,
						"w": 648
					},
					{
						"n": 3,
						"h": -8,
						"w": 736
					},
					{
						"n": 4,
						"h": 240,
						"w": 660
					},
					{
						"n": 5,
						"h": 215,
						"w": 672
					},
					{
						"n": 6,
						"h": 150,
						"w": 300
					},
					{
						"n": 7,
						"h": 225,
						"w": 600
					},
					{
						"n": 8,
						"h": 225,
						"w": 460
					},
					{
						"n": 9,
						"h": 300,
						"w": 300
					},
					{
						"n": 10,
						"h": 190,
						"w": 660
					},
					{
						"n": 11,
						"h": 260,
						"w": 680
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 10
					},
					{
						"n": 2,
						"h": 225,
						"w": 110
					},
					{
						"n": 3,
						"h": 235,
						"w": 38
					},
					{
						"n": 4,
						"h": 190,
						"w": 30
					},
					{
						"n": 5,
						"h": 245,
						"w": 50
					},
					{
						"n": 6,
						"h": 220,
						"w": 62
					},
					{
						"n": 7,
						"h": 260,
						"w": 50
					},
					{
						"n": 8,
						"h": 225,
						"w": 245
					},
					{
						"n": 9,
						"h": 210,
						"w": 50
					},
					{
						"n": 10,
						"h": 275,
						"w": 40
					},
					{
						"n": 11,
						"h": 300,
						"w": 400
					}
				],
				"ball": {
					"n": 0,
					"h": 0,
					"w": 720,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 100
		},
		{
			"num": 164,
			"minute": 8,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 40
					},
					{
						"n": 2,
						"h": 234,
						"w": 647
					},
					{
						"n": 3,
						"h": 0,
						"w": 720
					},
					{
						"n": 4,
						"h": 243,
						"w": 667
					},
					{
						"n": 5,
						"h": 219,
						"w": 677
					},
					{
						"n": 6,
						"h": 147,
						"w": 296
					},
					{
						"n": 7,
						"h": 228,
						"w": 607
					},
					{
						"n": 8,
						"h": 232,
						"w": 457
					},
					{
						"n": 9,
						"h": 307,
						"w": 296
					},
					{
						"n": 10,
						"h": 187,
						"w": 662
					},
					{
						"n": 11,
						"h": 254,
						"w": 673
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 20
					},
					{
						"n": 2,
						"h": 221,
						"w": 108
					},
					{
						"n": 3,
						"h": 242,
						"w": 33
					},
					{
						"n": 4,
						"h": 184,
						"w": 28
					},
					{
						"n": 5,
						"h": 244,
						"w": 55
					},
					{
						"n": 6,
						"h": 215,
						"w": 56
					},
					{
						"n": 7,
						"h": 254,
						"w": 46
					},
					{
						"n": 8,
						"h": 219,
						"w": 251
					},
					{
						"n": 9,
						"h": 209,
						"w": 51
					},
					{
						"n": 10,
						"h": 276,
						"w": 40
					},
					{
						"n": 11,
						"h": 295,
						"w": 396
					}
				],
				"ball": {
					"n": 0,
					"h": 0,
					"w": 720,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 15
		},
		{
			"num": 165,
			"minute": 8,
			"messages": [
				{
					"owner": 1,
					"mes": "У мяча Патрик Клинтон[03](Галвэй Юнайтед)..."
				},
				{
					"owner": 1,
					"mes": "П.Клинтон[03](Галвэй Юнайтед) навешивает в штрафную..."
				},
				{
					"owner": 1,
					"mes": "Нир Мансур[23](Опава) головой разряжает обстановку в штрафной..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 18
					},
					{
						"n": 2,
						"h": 225,
						"w": 652
					},
					{
						"n": 3,
						"h": 2,
						"w": 715
					},
					{
						"n": 4,
						"h": 240,
						"w": 677
					},
					{
						"n": 5,
						"h": 214,
						"w": 672
					},
					{
						"n": 6,
						"h": 172,
						"w": 322
					},
					{
						"n": 7,
						"h": 212,
						"w": 597
					},
					{
						"n": 8,
						"h": 205,
						"w": 488
					},
					{
						"n": 9,
						"h": 275,
						"w": 322
					},
					{
						"n": 10,
						"h": 181,
						"w": 661
					},
					{
						"n": 11,
						"h": 251,
						"w": 665
					}
				],
				"away": [
					{
						"n": 1,
						"h": 223,
						"w": 13
					},
					{
						"n": 2,
						"h": 187,
						"w": 85
					},
					{
						"n": 3,
						"h": 243,
						"w": 44
					},
					{
						"n": 4,
						"h": 209,
						"w": 48
					},
					{
						"n": 5,
						"h": 254,
						"w": 64
					},
					{
						"n": 6,
						"h": 222,
						"w": 58
					},
					{
						"n": 7,
						"h": 267,
						"w": 53
					},
					{
						"n": 8,
						"h": 238,
						"w": 214
					},
					{
						"n": 9,
						"h": 206,
						"w": 43
					},
					{
						"n": 10,
						"h": 286,
						"w": 36
					},
					{
						"n": 11,
						"h": 284,
						"w": 357
					}
				],
				"ball": {
					"n": 0,
					"h": 207,
					"w": 676,
					"z": 1,
					"r": 2,
					"p": 4,
					"x": 1
				}
			},
			"interval": 41
		},
		{
			"num": 166,
			"minute": 8,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 14
					},
					{
						"n": 2,
						"h": 225,
						"w": 651
					},
					{
						"n": 3,
						"h": 8,
						"w": 696
					},
					{
						"n": 4,
						"h": 239,
						"w": 697
					},
					{
						"n": 5,
						"h": 214,
						"w": 681
					},
					{
						"n": 6,
						"h": 175,
						"w": 332
					},
					{
						"n": 7,
						"h": 194,
						"w": 588
					},
					{
						"n": 8,
						"h": 195,
						"w": 470
					},
					{
						"n": 9,
						"h": 267,
						"w": 327
					},
					{
						"n": 10,
						"h": 171,
						"w": 678
					},
					{
						"n": 11,
						"h": 237,
						"w": 679
					}
				],
				"away": [
					{
						"n": 1,
						"h": 212,
						"w": 5
					},
					{
						"n": 2,
						"h": 170,
						"w": 74
					},
					{
						"n": 3,
						"h": 240,
						"w": 35
					},
					{
						"n": 4,
						"h": 208,
						"w": 32
					},
					{
						"n": 5,
						"h": 274,
						"w": 66
					},
					{
						"n": 6,
						"h": 240,
						"w": 68
					},
					{
						"n": 7,
						"h": 274,
						"w": 40
					},
					{
						"n": 8,
						"h": 251,
						"w": 199
					},
					{
						"n": 9,
						"h": 191,
						"w": 57
					},
					{
						"n": 10,
						"h": 306,
						"w": 34
					},
					{
						"n": 11,
						"h": 280,
						"w": 337
					}
				],
				"ball": {
					"n": 0,
					"h": 238,
					"w": 750,
					"z": 1,
					"r": 0,
					"p": 1,
					"x": 0
				}
			},
			"interval": 20
		},
		{
			"num": 167,
			"minute": 8,
			"messages": [
				{
					"owner": 1,
					"mes": "Угловой..."
				}
			],
			"C": {
				"team": 1
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 40
					},
					{
						"n": 2,
						"h": 230,
						"w": 648
					},
					{
						"n": 3,
						"h": 458,
						"w": 704
					},
					{
						"n": 4,
						"h": 240,
						"w": 660
					},
					{
						"n": 5,
						"h": 215,
						"w": 672
					},
					{
						"n": 6,
						"h": 150,
						"w": 300
					},
					{
						"n": 7,
						"h": 225,
						"w": 600
					},
					{
						"n": 8,
						"h": 225,
						"w": 460
					},
					{
						"n": 9,
						"h": 300,
						"w": 300
					},
					{
						"n": 10,
						"h": 190,
						"w": 660
					},
					{
						"n": 11,
						"h": 260,
						"w": 680
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 10
					},
					{
						"n": 2,
						"h": 225,
						"w": 110
					},
					{
						"n": 3,
						"h": 235,
						"w": 38
					},
					{
						"n": 4,
						"h": 190,
						"w": 30
					},
					{
						"n": 5,
						"h": 245,
						"w": 50
					},
					{
						"n": 6,
						"h": 220,
						"w": 62
					},
					{
						"n": 7,
						"h": 260,
						"w": 50
					},
					{
						"n": 8,
						"h": 225,
						"w": 245
					},
					{
						"n": 9,
						"h": 210,
						"w": 50
					},
					{
						"n": 10,
						"h": 175,
						"w": 40
					},
					{
						"n": 11,
						"h": 300,
						"w": 400
					}
				],
				"ball": {
					"n": 0,
					"h": 450,
					"w": 720,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 100
		},
		{
			"num": 168,
			"minute": 8,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 41
					},
					{
						"n": 2,
						"h": 236,
						"w": 654
					},
					{
						"n": 3,
						"h": 450,
						"w": 720
					},
					{
						"n": 4,
						"h": 236,
						"w": 663
					},
					{
						"n": 5,
						"h": 221,
						"w": 667
					},
					{
						"n": 6,
						"h": 152,
						"w": 301
					},
					{
						"n": 7,
						"h": 218,
						"w": 597
					},
					{
						"n": 8,
						"h": 229,
						"w": 456
					},
					{
						"n": 9,
						"h": 299,
						"w": 307
					},
					{
						"n": 10,
						"h": 187,
						"w": 666
					},
					{
						"n": 11,
						"h": 262,
						"w": 684
					}
				],
				"away": [
					{
						"n": 1,
						"h": 226,
						"w": 20
					},
					{
						"n": 2,
						"h": 221,
						"w": 116
					},
					{
						"n": 3,
						"h": 234,
						"w": 45
					},
					{
						"n": 4,
						"h": 195,
						"w": 35
					},
					{
						"n": 5,
						"h": 244,
						"w": 50
					},
					{
						"n": 6,
						"h": 226,
						"w": 64
					},
					{
						"n": 7,
						"h": 259,
						"w": 57
					},
					{
						"n": 8,
						"h": 223,
						"w": 238
					},
					{
						"n": 9,
						"h": 213,
						"w": 47
					},
					{
						"n": 10,
						"h": 173,
						"w": 34
					},
					{
						"n": 11,
						"h": 301,
						"w": 398
					}
				],
				"ball": {
					"n": 0,
					"h": 450,
					"w": 720,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 15
		},
		{
			"num": 169,
			"minute": 8,
			"messages": [
				{
					"owner": 1,
					"mes": "У мяча Патрик Клинтон[03](Галвэй Юнайтед)..."
				},
				{
					"owner": 1,
					"mes": "П.Клинтон[03](Галвэй Юнайтед) закручивает мяч в штрафную..."
				},
				{
					"owner": 1,
					"mes": "Матей Юрасек[29](Опава) головой разряжает обстановку в штрафной..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 16
					},
					{
						"n": 2,
						"h": 242,
						"w": 652
					},
					{
						"n": 3,
						"h": 448,
						"w": 715
					},
					{
						"n": 4,
						"h": 231,
						"w": 661
					},
					{
						"n": 5,
						"h": 223,
						"w": 666
					},
					{
						"n": 6,
						"h": 166,
						"w": 321
					},
					{
						"n": 7,
						"h": 206,
						"w": 602
					},
					{
						"n": 8,
						"h": 221,
						"w": 497
					},
					{
						"n": 9,
						"h": 276,
						"w": 332
					},
					{
						"n": 10,
						"h": 181,
						"w": 661
					},
					{
						"n": 11,
						"h": 271,
						"w": 687
					}
				],
				"away": [
					{
						"n": 1,
						"h": 229,
						"w": 13
					},
					{
						"n": 2,
						"h": 200,
						"w": 124
					},
					{
						"n": 3,
						"h": 220,
						"w": 52
					},
					{
						"n": 4,
						"h": 171,
						"w": 26
					},
					{
						"n": 5,
						"h": 243,
						"w": 50
					},
					{
						"n": 6,
						"h": 217,
						"w": 65
					},
					{
						"n": 7,
						"h": 274,
						"w": 56
					},
					{
						"n": 8,
						"h": 216,
						"w": 197
					},
					{
						"n": 9,
						"h": 216,
						"w": 58
					},
					{
						"n": 10,
						"h": 175,
						"w": 25
					},
					{
						"n": 11,
						"h": 286,
						"w": 358
					}
				],
				"ball": {
					"n": 0,
					"h": 234,
					"w": 662,
					"z": 1,
					"r": 2,
					"p": 4,
					"x": 1
				}
			},
			"interval": 42
		},
		{
			"num": 170,
			"minute": 8,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 11
					},
					{
						"n": 2,
						"h": 224,
						"w": 625
					},
					{
						"n": 3,
						"h": 430,
						"w": 689
					},
					{
						"n": 4,
						"h": 233,
						"w": 629
					},
					{
						"n": 5,
						"h": 238,
						"w": 638
					},
					{
						"n": 6,
						"h": 169,
						"w": 339
					},
					{
						"n": 7,
						"h": 189,
						"w": 575
					},
					{
						"n": 8,
						"h": 256,
						"w": 507
					},
					{
						"n": 9,
						"h": 280,
						"w": 340
					},
					{
						"n": 10,
						"h": 159,
						"w": 638
					},
					{
						"n": 11,
						"h": 272,
						"w": 656
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 16
					},
					{
						"n": 2,
						"h": 166,
						"w": 110
					},
					{
						"n": 3,
						"h": 188,
						"w": 52
					},
					{
						"n": 4,
						"h": 197,
						"w": 44
					},
					{
						"n": 5,
						"h": 235,
						"w": 51
					},
					{
						"n": 6,
						"h": 224,
						"w": 80
					},
					{
						"n": 7,
						"h": 287,
						"w": 61
					},
					{
						"n": 8,
						"h": 178,
						"w": 195
					},
					{
						"n": 9,
						"h": 216,
						"w": 58
					},
					{
						"n": 10,
						"h": 173,
						"w": 57
					},
					{
						"n": 11,
						"h": 279,
						"w": 327
					}
				],
				"ball": {
					"n": 0,
					"h": 306,
					"w": 558,
					"z": 1,
					"r": 0,
					"p": 1,
					"x": 0
				}
			},
			"interval": 32
		},
		{
			"num": 171,
			"minute": 8,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 11
					},
					{
						"n": 2,
						"h": 219,
						"w": 617
					},
					{
						"n": 3,
						"h": 425,
						"w": 681
					},
					{
						"n": 4,
						"h": 234,
						"w": 620
					},
					{
						"n": 5,
						"h": 243,
						"w": 631
					},
					{
						"n": 6,
						"h": 178,
						"w": 336
					},
					{
						"n": 7,
						"h": 181,
						"w": 572
					},
					{
						"n": 8,
						"h": 266,
						"w": 510
					},
					{
						"n": 9,
						"h": 272,
						"w": 336
					},
					{
						"n": 10,
						"h": 163,
						"w": 635
					},
					{
						"n": 11,
						"h": 278,
						"w": 649
					}
				],
				"away": [
					{
						"n": 1,
						"h": 228,
						"w": 16
					},
					{
						"n": 2,
						"h": 158,
						"w": 105
					},
					{
						"n": 3,
						"h": 182,
						"w": 58
					},
					{
						"n": 4,
						"h": 199,
						"w": 53
					},
					{
						"n": 5,
						"h": 231,
						"w": 59
					},
					{
						"n": 6,
						"h": 219,
						"w": 80
					},
					{
						"n": 7,
						"h": 284,
						"w": 63
					},
					{
						"n": 8,
						"h": 168,
						"w": 195
					},
					{
						"n": 9,
						"h": 209,
						"w": 63
					},
					{
						"n": 10,
						"h": 172,
						"w": 66
					},
					{
						"n": 11,
						"h": 284,
						"w": 319
					}
				],
				"ball": {
					"n": 0,
					"h": 328,
					"w": 527,
					"z": 0,
					"r": 0,
					"p": 1,
					"x": 0
				}
			},
			"interval": 9
		},
		{
			"num": 172,
			"minute": 8,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 14
					},
					{
						"n": 2,
						"h": 195,
						"w": 566
					},
					{
						"n": 3,
						"h": 398,
						"w": 644
					},
					{
						"n": 4,
						"h": 242,
						"w": 562
					},
					{
						"n": 5,
						"h": 263,
						"w": 577
					},
					{
						"n": 6,
						"h": 209,
						"w": 331
					},
					{
						"n": 7,
						"h": 184,
						"w": 526
					},
					{
						"n": 8,
						"h": 327,
						"w": 516
					},
					{
						"n": 9,
						"h": 266,
						"w": 339
					},
					{
						"n": 10,
						"h": 169,
						"w": 589
					},
					{
						"n": 11,
						"h": 261,
						"w": 606
					}
				],
				"away": [
					{
						"n": 1,
						"h": 223,
						"w": 19
					},
					{
						"n": 2,
						"h": 116,
						"w": 123
					},
					{
						"n": 3,
						"h": 162,
						"w": 76
					},
					{
						"n": 4,
						"h": 221,
						"w": 67
					},
					{
						"n": 5,
						"h": 274,
						"w": 76
					},
					{
						"n": 6,
						"h": 222,
						"w": 126
					},
					{
						"n": 7,
						"h": 275,
						"w": 108
					},
					{
						"n": 8,
						"h": 115,
						"w": 203
					},
					{
						"n": 9,
						"h": 187,
						"w": 104
					},
					{
						"n": 10,
						"h": 171,
						"w": 112
					},
					{
						"n": 11,
						"h": 276,
						"w": 351
					}
				],
				"ball": {
					"n": 0,
					"h": 335,
					"w": 517,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 46
		},
		{
			"num": 173,
			"minute": 8,
			"messages": [
				{
					"owner": 2,
					"mes": "Мяч подбирает Д.Прохазка[28](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 16
					},
					{
						"n": 2,
						"h": 175,
						"w": 521
					},
					{
						"n": 3,
						"h": 375,
						"w": 613
					},
					{
						"n": 4,
						"h": 247,
						"w": 513
					},
					{
						"n": 5,
						"h": 280,
						"w": 532
					},
					{
						"n": 6,
						"h": 195,
						"w": 325
					},
					{
						"n": 7,
						"h": 190,
						"w": 488
					},
					{
						"n": 8,
						"h": 345,
						"w": 468
					},
					{
						"n": 9,
						"h": 244,
						"w": 332
					},
					{
						"n": 10,
						"h": 186,
						"w": 541
					},
					{
						"n": 11,
						"h": 269,
						"w": 553
					}
				],
				"away": [
					{
						"n": 1,
						"h": 226,
						"w": 15
					},
					{
						"n": 2,
						"h": 80,
						"w": 150
					},
					{
						"n": 3,
						"h": 159,
						"w": 88
					},
					{
						"n": 4,
						"h": 256,
						"w": 98
					},
					{
						"n": 5,
						"h": 318,
						"w": 88
					},
					{
						"n": 6,
						"h": 177,
						"w": 144
					},
					{
						"n": 7,
						"h": 269,
						"w": 147
					},
					{
						"n": 8,
						"h": 102,
						"w": 241
					},
					{
						"n": 9,
						"h": 163,
						"w": 145
					},
					{
						"n": 10,
						"h": 209,
						"w": 116
					},
					{
						"n": 11,
						"h": 252,
						"w": 374
					}
				],
				"ball": {
					"n": 0,
					"h": 348,
					"w": 479,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 174,
			"minute": 8,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 16
					},
					{
						"n": 2,
						"h": 175,
						"w": 520
					},
					{
						"n": 3,
						"h": 375,
						"w": 612
					},
					{
						"n": 4,
						"h": 247,
						"w": 512
					},
					{
						"n": 5,
						"h": 281,
						"w": 531
					},
					{
						"n": 6,
						"h": 195,
						"w": 326
					},
					{
						"n": 7,
						"h": 190,
						"w": 487
					},
					{
						"n": 8,
						"h": 345,
						"w": 469
					},
					{
						"n": 9,
						"h": 244,
						"w": 331
					},
					{
						"n": 10,
						"h": 186,
						"w": 540
					},
					{
						"n": 11,
						"h": 269,
						"w": 552
					}
				],
				"away": [
					{
						"n": 1,
						"h": 226,
						"w": 14
					},
					{
						"n": 2,
						"h": 79,
						"w": 151
					},
					{
						"n": 3,
						"h": 160,
						"w": 88
					},
					{
						"n": 4,
						"h": 257,
						"w": 98
					},
					{
						"n": 5,
						"h": 319,
						"w": 89
					},
					{
						"n": 6,
						"h": 176,
						"w": 145
					},
					{
						"n": 7,
						"h": 268,
						"w": 148
					},
					{
						"n": 8,
						"h": 102,
						"w": 242
					},
					{
						"n": 9,
						"h": 163,
						"w": 146
					},
					{
						"n": 10,
						"h": 210,
						"w": 117
					},
					{
						"n": 11,
						"h": 251,
						"w": 375
					}
				],
				"ball": {
					"n": 0,
					"h": 348,
					"w": 478,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 1
		},
		{
			"num": 175,
			"minute": 8,
			"messages": [
				{
					"owner": 2,
					"mes": "Д.Прохазка[28](Опава) пытается пройти К.Нолана[08](Галвэй Юнайтед)..."
				},
				{
					"owner": 2,
					"mes": "Даниэль Прохазка[28](Опава) оставляет К.Нолана[08](Галвэй Юнайтед) не у дел..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 12
					},
					{
						"n": 2,
						"h": 157,
						"w": 474
					},
					{
						"n": 3,
						"h": 352,
						"w": 579
					},
					{
						"n": 4,
						"h": 252,
						"w": 461
					},
					{
						"n": 5,
						"h": 300,
						"w": 485
					},
					{
						"n": 6,
						"h": 217,
						"w": 317
					},
					{
						"n": 7,
						"h": 195,
						"w": 447
					},
					{
						"n": 8,
						"h": 345,
						"w": 469,
						"m": 590
					},
					{
						"n": 9,
						"h": 267,
						"w": 319
					},
					{
						"n": 10,
						"h": 166,
						"w": 514
					},
					{
						"n": 11,
						"h": 275,
						"w": 514
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 19
					},
					{
						"n": 2,
						"h": 48,
						"w": 186
					},
					{
						"n": 3,
						"h": 175,
						"w": 102
					},
					{
						"n": 4,
						"h": 284,
						"w": 110
					},
					{
						"n": 5,
						"h": 365,
						"w": 96
					},
					{
						"n": 6,
						"h": 189,
						"w": 165
					},
					{
						"n": 7,
						"h": 246,
						"w": 185
					},
					{
						"n": 8,
						"h": 114,
						"w": 280,
						"m": 610
					},
					{
						"n": 9,
						"h": 140,
						"w": 188
					},
					{
						"n": 10,
						"h": 237,
						"w": 157
					},
					{
						"n": 11,
						"h": 228,
						"w": 381
					}
				],
				"ball": {
					"n": 0,
					"h": 336,
					"w": 440,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 176,
			"minute": 8,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 15
					},
					{
						"n": 2,
						"h": 138,
						"w": 428
					},
					{
						"n": 3,
						"h": 332,
						"w": 545
					},
					{
						"n": 4,
						"h": 256,
						"w": 410
					},
					{
						"n": 5,
						"h": 316,
						"w": 438
					},
					{
						"n": 6,
						"h": 174,
						"w": 303
					},
					{
						"n": 7,
						"h": 207,
						"w": 396
					},
					{
						"n": 8,
						"h": 334,
						"w": 417
					},
					{
						"n": 9,
						"h": 278,
						"w": 295
					},
					{
						"n": 10,
						"h": 172,
						"w": 487
					},
					{
						"n": 11,
						"h": 270,
						"w": 487
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 13
					},
					{
						"n": 2,
						"h": 69,
						"w": 226
					},
					{
						"n": 3,
						"h": 180,
						"w": 109
					},
					{
						"n": 4,
						"h": 278,
						"w": 109
					},
					{
						"n": 5,
						"h": 391,
						"w": 127
					},
					{
						"n": 6,
						"h": 181,
						"w": 185
					},
					{
						"n": 7,
						"h": 235,
						"w": 228
					},
					{
						"n": 8,
						"h": 117,
						"w": 321
					},
					{
						"n": 9,
						"h": 118,
						"w": 232
					},
					{
						"n": 10,
						"h": 260,
						"w": 162
					},
					{
						"n": 11,
						"h": 272,
						"w": 398
					}
				],
				"ball": {
					"n": 0,
					"h": 333,
					"w": 399,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 177,
			"minute": 8,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 15
					},
					{
						"n": 2,
						"h": 119,
						"w": 382
					},
					{
						"n": 3,
						"h": 313,
						"w": 509
					},
					{
						"n": 4,
						"h": 265,
						"w": 359
					},
					{
						"n": 5,
						"h": 328,
						"w": 389
					},
					{
						"n": 6,
						"h": 158,
						"w": 267
					},
					{
						"n": 7,
						"h": 221,
						"w": 345
					},
					{
						"n": 8,
						"h": 330,
						"w": 365
					},
					{
						"n": 9,
						"h": 277,
						"w": 271
					},
					{
						"n": 10,
						"h": 169,
						"w": 463
					},
					{
						"n": 11,
						"h": 300,
						"w": 460
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 13
					},
					{
						"n": 2,
						"h": 60,
						"w": 266
					},
					{
						"n": 3,
						"h": 174,
						"w": 93
					},
					{
						"n": 4,
						"h": 281,
						"w": 104
					},
					{
						"n": 5,
						"h": 375,
						"w": 109
					},
					{
						"n": 6,
						"h": 188,
						"w": 200
					},
					{
						"n": 7,
						"h": 219,
						"w": 270
					},
					{
						"n": 8,
						"h": 120,
						"w": 362
					},
					{
						"n": 9,
						"h": 102,
						"w": 277
					},
					{
						"n": 10,
						"h": 259,
						"w": 197
					},
					{
						"n": 11,
						"h": 295,
						"w": 430
					}
				],
				"ball": {
					"n": 0,
					"h": 330,
					"w": 358,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 178,
			"minute": 8,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 15
					},
					{
						"n": 2,
						"h": 106,
						"w": 334
					},
					{
						"n": 3,
						"h": 294,
						"w": 474
					},
					{
						"n": 4,
						"h": 266,
						"w": 308
					},
					{
						"n": 5,
						"h": 338,
						"w": 340
					},
					{
						"n": 6,
						"h": 156,
						"w": 241
					},
					{
						"n": 7,
						"h": 214,
						"w": 306
					},
					{
						"n": 8,
						"h": 332,
						"w": 312
					},
					{
						"n": 9,
						"h": 277,
						"w": 241
					},
					{
						"n": 10,
						"h": 183,
						"w": 435
					},
					{
						"n": 11,
						"h": 285,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 19
					},
					{
						"n": 2,
						"h": 55,
						"w": 306
					},
					{
						"n": 3,
						"h": 165,
						"w": 132
					},
					{
						"n": 4,
						"h": 267,
						"w": 127
					},
					{
						"n": 5,
						"h": 374,
						"w": 146
					},
					{
						"n": 6,
						"h": 190,
						"w": 220
					},
					{
						"n": 7,
						"h": 223,
						"w": 314
					},
					{
						"n": 8,
						"h": 120,
						"w": 404
					},
					{
						"n": 9,
						"h": 87,
						"w": 323
					},
					{
						"n": 10,
						"h": 264,
						"w": 237
					},
					{
						"n": 11,
						"h": 297,
						"w": 458
					}
				],
				"ball": {
					"n": 0,
					"h": 330,
					"w": 316,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 179,
			"minute": 8,
			"messages": [
				{
					"owner": 2,
					"mes": "Даниэль Прохазка[28](Опава) пасует Л.Седлачеку[22](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 12
					},
					{
						"n": 2,
						"h": 98,
						"w": 295
					},
					{
						"n": 3,
						"h": 275,
						"w": 431
					},
					{
						"n": 4,
						"h": 274,
						"w": 259
					},
					{
						"n": 5,
						"h": 349,
						"w": 293
					},
					{
						"n": 6,
						"h": 193,
						"w": 229
					},
					{
						"n": 7,
						"h": 217,
						"w": 255
					},
					{
						"n": 8,
						"h": 319,
						"w": 262
					},
					{
						"n": 9,
						"h": 277,
						"w": 228
					},
					{
						"n": 10,
						"h": 185,
						"w": 400
					},
					{
						"n": 11,
						"h": 317,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 39
					},
					{
						"n": 2,
						"h": 27,
						"w": 334
					},
					{
						"n": 3,
						"h": 165,
						"w": 148
					},
					{
						"n": 4,
						"h": 265,
						"w": 156
					},
					{
						"n": 5,
						"h": 376,
						"w": 156
					},
					{
						"n": 6,
						"h": 174,
						"w": 240
					},
					{
						"n": 7,
						"h": 198,
						"w": 318
					},
					{
						"n": 8,
						"h": 129,
						"w": 411
					},
					{
						"n": 9,
						"h": 72,
						"w": 278
					},
					{
						"n": 10,
						"h": 225,
						"w": 266
					},
					{
						"n": 11,
						"h": 294,
						"w": 484
					}
				],
				"ball": {
					"n": 0,
					"h": 423,
					"w": 386,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 180,
			"minute": 8,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 17
					},
					{
						"n": 2,
						"h": 87,
						"w": 247
					},
					{
						"n": 3,
						"h": 256,
						"w": 386
					},
					{
						"n": 4,
						"h": 269,
						"w": 208
					},
					{
						"n": 5,
						"h": 390,
						"w": 323
					},
					{
						"n": 6,
						"h": 202,
						"w": 193
					},
					{
						"n": 7,
						"h": 200,
						"w": 224
					},
					{
						"n": 8,
						"h": 275,
						"w": 240
					},
					{
						"n": 9,
						"h": 267,
						"w": 198
					},
					{
						"n": 10,
						"h": 177,
						"w": 400
					},
					{
						"n": 11,
						"h": 310,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 221,
						"w": 62
					},
					{
						"n": 2,
						"h": 27,
						"w": 375
					},
					{
						"n": 3,
						"h": 173,
						"w": 166
					},
					{
						"n": 4,
						"h": 273,
						"w": 168
					},
					{
						"n": 5,
						"h": 393,
						"w": 191
					},
					{
						"n": 6,
						"h": 157,
						"w": 230
					},
					{
						"n": 7,
						"h": 207,
						"w": 362
					},
					{
						"n": 8,
						"h": 165,
						"w": 442
					},
					{
						"n": 9,
						"h": 64,
						"w": 326
					},
					{
						"n": 10,
						"h": 229,
						"w": 301
					},
					{
						"n": 11,
						"h": 250,
						"w": 500
					}
				],
				"ball": {
					"n": 0,
					"h": 423,
					"w": 345,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 181,
			"minute": 8,
			"messages": [
				{
					"owner": 2,
					"mes": "Лука Седлачек[22](Опава) отдает передачу направо М.Манолову[27](Опава)..."
				},
				{
					"owner": 2,
					"mes": "Патрик Клинтон[03](Галвэй Юнайтед) выбирает хорошую позицию и перехватывает мяч!..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 14
					},
					{
						"n": 2,
						"h": 88,
						"w": 193
					},
					{
						"n": 3,
						"h": 296,
						"w": 369
					},
					{
						"n": 4,
						"h": 271,
						"w": 174
					},
					{
						"n": 5,
						"h": 377,
						"w": 270
					},
					{
						"n": 6,
						"h": 181,
						"w": 175
					},
					{
						"n": 7,
						"h": 179,
						"w": 191
					},
					{
						"n": 8,
						"h": 282,
						"w": 190
					},
					{
						"n": 9,
						"h": 310,
						"w": 232
					},
					{
						"n": 10,
						"h": 180,
						"w": 400
					},
					{
						"n": 11,
						"h": 268,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 226,
						"w": 83
					},
					{
						"n": 2,
						"h": 37,
						"w": 387,
						"m": 610
					},
					{
						"n": 3,
						"h": 178,
						"w": 200
					},
					{
						"n": 4,
						"h": 270,
						"w": 199
					},
					{
						"n": 5,
						"h": 390,
						"w": 200
					},
					{
						"n": 6,
						"h": 182,
						"w": 250
					},
					{
						"n": 7,
						"h": 166,
						"w": 353
					},
					{
						"n": 8,
						"h": 161,
						"w": 482
					},
					{
						"n": 9,
						"h": 65,
						"w": 378
					},
					{
						"n": 10,
						"h": 248,
						"w": 336
					},
					{
						"n": 11,
						"h": 289,
						"w": 532
					}
				],
				"ball": {
					"n": 0,
					"h": 296,
					"w": 369,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 43
		},
		{
			"num": 182,
			"minute": 9,
			"possession": 42,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 18
					},
					{
						"n": 2,
						"h": 78,
						"w": 232
					},
					{
						"n": 3,
						"h": 321,
						"w": 394,
						"m": 610
					},
					{
						"n": 4,
						"h": 275,
						"w": 194
					},
					{
						"n": 5,
						"h": 391,
						"w": 273
					},
					{
						"n": 6,
						"h": 160,
						"w": 210
					},
					{
						"n": 7,
						"h": 174,
						"w": 231
					},
					{
						"n": 8,
						"h": 281,
						"w": 230
					},
					{
						"n": 9,
						"h": 327,
						"w": 268
					},
					{
						"n": 10,
						"h": 173,
						"w": 439
					},
					{
						"n": 11,
						"h": 280,
						"w": 488
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 74
					},
					{
						"n": 2,
						"h": 45,
						"w": 348,
						"f": 94
					},
					{
						"n": 3,
						"h": 187,
						"w": 161
					},
					{
						"n": 4,
						"h": 267,
						"w": 159
					},
					{
						"n": 5,
						"h": 364,
						"w": 170
					},
					{
						"n": 6,
						"h": 165,
						"w": 214,
						"f": 96
					},
					{
						"n": 7,
						"h": 143,
						"w": 321
					},
					{
						"n": 8,
						"h": 174,
						"w": 444,
						"f": 95
					},
					{
						"n": 9,
						"h": 47,
						"w": 342
					},
					{
						"n": 10,
						"h": 216,
						"w": 361
					},
					{
						"n": 11,
						"h": 281,
						"w": 493
					}
				],
				"ball": {
					"n": 0,
					"h": 321,
					"w": 394,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 183,
			"minute": 9,
			"messages": [
				{
					"owner": 1,
					"mes": "Пас Э.Бвомоно[09](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 19
					},
					{
						"n": 2,
						"h": 62,
						"w": 271
					},
					{
						"n": 3,
						"h": 314,
						"w": 387,
						"m": 620
					},
					{
						"n": 4,
						"h": 271,
						"w": 219
					},
					{
						"n": 5,
						"h": 382,
						"w": 271
					},
					{
						"n": 6,
						"h": 139,
						"w": 246
					},
					{
						"n": 7,
						"h": 168,
						"w": 273
					},
					{
						"n": 8,
						"h": 280,
						"w": 272
					},
					{
						"n": 9,
						"h": 327,
						"w": 268
					},
					{
						"n": 10,
						"h": 159,
						"w": 479
					},
					{
						"n": 11,
						"h": 302,
						"w": 524
					}
				],
				"away": [
					{
						"n": 1,
						"h": 205,
						"w": 73
					},
					{
						"n": 2,
						"h": 53,
						"w": 306
					},
					{
						"n": 3,
						"h": 161,
						"w": 153
					},
					{
						"n": 4,
						"h": 271,
						"w": 140
					},
					{
						"n": 5,
						"h": 340,
						"w": 168
					},
					{
						"n": 6,
						"h": 207,
						"w": 221
					},
					{
						"n": 7,
						"h": 183,
						"w": 308
					},
					{
						"n": 8,
						"h": 207,
						"w": 417
					},
					{
						"n": 9,
						"h": 51,
						"w": 309
					},
					{
						"n": 10,
						"h": 175,
						"w": 353
					},
					{
						"n": 11,
						"h": 282,
						"w": 451
					}
				],
				"ball": {
					"n": 0,
					"h": 327,
					"w": 268,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 42
		},
		{
			"num": 184,
			"minute": 9,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 10
					},
					{
						"n": 2,
						"h": 72,
						"w": 309
					},
					{
						"n": 3,
						"h": 286,
						"w": 359
					},
					{
						"n": 4,
						"h": 273,
						"w": 262
					},
					{
						"n": 5,
						"h": 379,
						"w": 296
					},
					{
						"n": 6,
						"h": 123,
						"w": 283
					},
					{
						"n": 7,
						"h": 167,
						"w": 313
					},
					{
						"n": 8,
						"h": 287,
						"w": 312
					},
					{
						"n": 9,
						"h": 334,
						"w": 303
					},
					{
						"n": 10,
						"h": 158,
						"w": 519
					},
					{
						"n": 11,
						"h": 294,
						"w": 549
					}
				],
				"away": [
					{
						"n": 1,
						"h": 205,
						"w": 77
					},
					{
						"n": 2,
						"h": 61,
						"w": 267
					},
					{
						"n": 3,
						"h": 168,
						"w": 128
					},
					{
						"n": 4,
						"h": 279,
						"w": 128
					},
					{
						"n": 5,
						"h": 340,
						"w": 128
					},
					{
						"n": 6,
						"h": 179,
						"w": 192
					},
					{
						"n": 7,
						"h": 193,
						"w": 269
					},
					{
						"n": 8,
						"h": 234,
						"w": 389
					},
					{
						"n": 9,
						"h": 43,
						"w": 291
					},
					{
						"n": 10,
						"h": 143,
						"w": 377
					},
					{
						"n": 11,
						"h": 283,
						"w": 411
					}
				],
				"ball": {
					"n": 0,
					"h": 334,
					"w": 303,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 185,
			"minute": 9,
			"messages": [
				{
					"owner": 1,
					"mes": "Э.Бвомоно[09](Галвэй Юнайтед) делает передачу К.Нолану[08](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 11
					},
					{
						"n": 2,
						"h": 69,
						"w": 332
					},
					{
						"n": 3,
						"h": 264,
						"w": 349
					},
					{
						"n": 4,
						"h": 272,
						"w": 267
					},
					{
						"n": 5,
						"h": 383,
						"w": 304
					},
					{
						"n": 6,
						"h": 115,
						"w": 305
					},
					{
						"n": 7,
						"h": 166,
						"w": 337
					},
					{
						"n": 8,
						"h": 287,
						"w": 312
					},
					{
						"n": 9,
						"h": 339,
						"w": 312
					},
					{
						"n": 10,
						"h": 156,
						"w": 543
					},
					{
						"n": 11,
						"h": 311,
						"w": 562
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 78
					},
					{
						"n": 2,
						"h": 65,
						"w": 244
					},
					{
						"n": 3,
						"h": 157,
						"w": 116
					},
					{
						"n": 4,
						"h": 275,
						"w": 119
					},
					{
						"n": 5,
						"h": 340,
						"w": 119
					},
					{
						"n": 6,
						"h": 203,
						"w": 189
					},
					{
						"n": 7,
						"h": 213,
						"w": 256
					},
					{
						"n": 8,
						"h": 251,
						"w": 372
					},
					{
						"n": 9,
						"h": 40,
						"w": 289
					},
					{
						"n": 10,
						"h": 157,
						"w": 396
					},
					{
						"n": 11,
						"h": 284,
						"w": 387
					}
				],
				"ball": {
					"n": 0,
					"h": 287,
					"w": 312,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 24
		},
		{
			"num": 186,
			"minute": 9,
			"messages": [
				{
					"owner": 1,
					"mes": "Киран Нолан[08](Галвэй Юнайтед) отдает пас на К.Колмана[06](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 19
					},
					{
						"n": 2,
						"h": 59,
						"w": 333
					},
					{
						"n": 3,
						"h": 203,
						"w": 305
					},
					{
						"n": 4,
						"h": 277,
						"w": 290
					},
					{
						"n": 5,
						"h": 389,
						"w": 336
					},
					{
						"n": 6,
						"h": 63,
						"w": 279
					},
					{
						"n": 7,
						"h": 151,
						"w": 410
					},
					{
						"n": 8,
						"h": 284,
						"w": 326
					},
					{
						"n": 9,
						"h": 372,
						"w": 379
					},
					{
						"n": 10,
						"h": 144,
						"w": 561
					},
					{
						"n": 11,
						"h": 285,
						"w": 569
					}
				],
				"away": [
					{
						"n": 1,
						"h": 245,
						"w": 77
					},
					{
						"n": 2,
						"h": 84,
						"w": 316
					},
					{
						"n": 3,
						"h": 182,
						"w": 130
					},
					{
						"n": 4,
						"h": 283,
						"w": 131
					},
					{
						"n": 5,
						"h": 340,
						"w": 130
					},
					{
						"n": 6,
						"h": 273,
						"w": 163
					},
					{
						"n": 7,
						"h": 245,
						"w": 253
					},
					{
						"n": 8,
						"h": 326,
						"w": 361
					},
					{
						"n": 9,
						"h": 56,
						"w": 270
					},
					{
						"n": 10,
						"h": 166,
						"w": 374
					},
					{
						"n": 11,
						"h": 357,
						"w": 401
					}
				],
				"ball": {
					"n": 0,
					"h": 63,
					"w": 279,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 75
		},
		{
			"num": 187,
			"minute": 9,
			"messages": [
				{
					"owner": 1,
					"mes": "Пас вперед..."
				},
				{
					"owner": 1,
					"mes": "Тимо Эверс[02](Галвэй Юнайтед) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 16
					},
					{
						"n": 2,
						"h": 63,
						"w": 359
					},
					{
						"n": 3,
						"h": 171,
						"w": 281
					},
					{
						"n": 4,
						"h": 281,
						"w": 278
					},
					{
						"n": 5,
						"h": 380,
						"w": 329
					},
					{
						"n": 6,
						"h": 57,
						"w": 288
					},
					{
						"n": 7,
						"h": 141,
						"w": 449
					},
					{
						"n": 8,
						"h": 248,
						"w": 344
					},
					{
						"n": 9,
						"h": 378,
						"w": 418
					},
					{
						"n": 10,
						"h": 161,
						"w": 578
					},
					{
						"n": 11,
						"h": 296,
						"w": 590
					}
				],
				"away": [
					{
						"n": 1,
						"h": 245,
						"w": 75
					},
					{
						"n": 2,
						"h": 80,
						"w": 282
					},
					{
						"n": 3,
						"h": 173,
						"w": 132
					},
					{
						"n": 4,
						"h": 271,
						"w": 146
					},
					{
						"n": 5,
						"h": 368,
						"w": 147
					},
					{
						"n": 6,
						"h": 303,
						"w": 188
					},
					{
						"n": 7,
						"h": 264,
						"w": 255
					},
					{
						"n": 8,
						"h": 364,
						"w": 349
					},
					{
						"n": 9,
						"h": 45,
						"w": 280
					},
					{
						"n": 10,
						"h": 202,
						"w": 356
					},
					{
						"n": 11,
						"h": 329,
						"w": 373
					}
				],
				"ball": {
					"n": 0,
					"h": 63,
					"w": 359,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 188,
			"minute": 9,
			"messages": [
				{
					"owner": 1,
					"mes": "Передача вперед..."
				},
				{
					"owner": 1,
					"mes": "Агуст Хлинссон[07](Галвэй Юнайтед) получает передачу..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 11
					},
					{
						"n": 2,
						"h": 64,
						"w": 349,
						"m": 610
					},
					{
						"n": 3,
						"h": 175,
						"w": 303
					},
					{
						"n": 4,
						"h": 275,
						"w": 290
					},
					{
						"n": 5,
						"h": 384,
						"w": 342
					},
					{
						"n": 6,
						"h": 48,
						"w": 329
					},
					{
						"n": 7,
						"h": 113,
						"w": 477
					},
					{
						"n": 8,
						"h": 270,
						"w": 380
					},
					{
						"n": 9,
						"h": 390,
						"w": 459
					},
					{
						"n": 10,
						"h": 159,
						"w": 572
					},
					{
						"n": 11,
						"h": 272,
						"w": 590
					}
				],
				"away": [
					{
						"n": 1,
						"h": 245,
						"w": 76
					},
					{
						"n": 2,
						"h": 68,
						"w": 241
					},
					{
						"n": 3,
						"h": 193,
						"w": 100
					},
					{
						"n": 4,
						"h": 276,
						"w": 104
					},
					{
						"n": 5,
						"h": 344,
						"w": 112
					},
					{
						"n": 6,
						"h": 300,
						"w": 158
					},
					{
						"n": 7,
						"h": 302,
						"w": 238
					},
					{
						"n": 8,
						"h": 386,
						"w": 335
					},
					{
						"n": 9,
						"h": 31,
						"w": 257
					},
					{
						"n": 10,
						"h": 180,
						"w": 320
					},
					{
						"n": 11,
						"h": 309,
						"w": 336
					}
				],
				"ball": {
					"n": 0,
					"h": 113,
					"w": 477,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 42
		},
		{
			"num": 189,
			"minute": 9,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 14
					},
					{
						"n": 2,
						"h": 71,
						"w": 351
					},
					{
						"n": 3,
						"h": 183,
						"w": 316
					},
					{
						"n": 4,
						"h": 266,
						"w": 309
					},
					{
						"n": 5,
						"h": 387,
						"w": 370
					},
					{
						"n": 6,
						"h": 51,
						"w": 363
					},
					{
						"n": 7,
						"h": 93,
						"w": 512
					},
					{
						"n": 8,
						"h": 254,
						"w": 411
					},
					{
						"n": 9,
						"h": 396,
						"w": 493
					},
					{
						"n": 10,
						"h": 161,
						"w": 593
					},
					{
						"n": 11,
						"h": 275,
						"w": 613
					}
				],
				"away": [
					{
						"n": 1,
						"h": 233,
						"w": 43
					},
					{
						"n": 2,
						"h": 78,
						"w": 208
					},
					{
						"n": 3,
						"h": 187,
						"w": 91
					},
					{
						"n": 4,
						"h": 278,
						"w": 76
					},
					{
						"n": 5,
						"h": 340,
						"w": 78
					},
					{
						"n": 6,
						"h": 298,
						"w": 131
					},
					{
						"n": 7,
						"h": 331,
						"w": 212
					},
					{
						"n": 8,
						"h": 399,
						"w": 321
					},
					{
						"n": 9,
						"h": 42,
						"w": 247
					},
					{
						"n": 10,
						"h": 196,
						"w": 289
					},
					{
						"n": 11,
						"h": 291,
						"w": 306
					}
				],
				"ball": {
					"n": 0,
					"h": 93,
					"w": 512,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 35
		},
		{
			"num": 190,
			"minute": 9,
			"messages": [
				{
					"owner": 1,
					"mes": "Пас вперед..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 17
					},
					{
						"n": 2,
						"h": 75,
						"w": 376
					},
					{
						"n": 3,
						"h": 184,
						"w": 315
					},
					{
						"n": 4,
						"h": 265,
						"w": 327
					},
					{
						"n": 5,
						"h": 376,
						"w": 369
					},
					{
						"n": 6,
						"h": 48,
						"w": 410
					},
					{
						"n": 7,
						"h": 104,
						"w": 520
					},
					{
						"n": 8,
						"h": 263,
						"w": 457
					},
					{
						"n": 9,
						"h": 396,
						"w": 540
					},
					{
						"n": 10,
						"h": 150,
						"w": 614
					},
					{
						"n": 11,
						"h": 258,
						"w": 575
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 15
					},
					{
						"n": 2,
						"h": 83,
						"w": 161
					},
					{
						"n": 3,
						"h": 212,
						"w": 87
					},
					{
						"n": 4,
						"h": 288,
						"w": 102
					},
					{
						"n": 5,
						"h": 340,
						"w": 85
					},
					{
						"n": 6,
						"h": 289,
						"w": 132
					},
					{
						"n": 7,
						"h": 343,
						"w": 166
					},
					{
						"n": 8,
						"h": 402,
						"w": 274
					},
					{
						"n": 9,
						"h": 19,
						"w": 236
					},
					{
						"n": 10,
						"h": 187,
						"w": 243
					},
					{
						"n": 11,
						"h": 294,
						"w": 304
					}
				],
				"ball": {
					"n": 0,
					"h": 224,
					"w": 562,
					"z": 0,
					"r": 0,
					"p": 1,
					"x": 0
				}
			},
			"interval": 47
		},
		{
			"num": 191,
			"minute": 9,
			"messages": [
				{
					"owner": 1,
					"mes": "Адам Гилберт[11](Галвэй Юнайтед) принимает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 17
					},
					{
						"n": 2,
						"h": 65,
						"w": 370
					},
					{
						"n": 3,
						"h": 169,
						"w": 318
					},
					{
						"n": 4,
						"h": 278,
						"w": 327
					},
					{
						"n": 5,
						"h": 373,
						"w": 364
					},
					{
						"n": 6,
						"h": 49,
						"w": 425
					},
					{
						"n": 7,
						"h": 116,
						"w": 529
					},
					{
						"n": 8,
						"h": 276,
						"w": 450
					},
					{
						"n": 9,
						"h": 397,
						"w": 555
					},
					{
						"n": 10,
						"h": 164,
						"w": 619
					},
					{
						"n": 11,
						"h": 238,
						"w": 567
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 15
					},
					{
						"n": 2,
						"h": 82,
						"w": 146
					},
					{
						"n": 3,
						"h": 213,
						"w": 102
					},
					{
						"n": 4,
						"h": 274,
						"w": 98
					},
					{
						"n": 5,
						"h": 340,
						"w": 90
					},
					{
						"n": 6,
						"h": 302,
						"w": 139
					},
					{
						"n": 7,
						"h": 328,
						"w": 170
					},
					{
						"n": 8,
						"h": 401,
						"w": 259
					},
					{
						"n": 9,
						"h": 19,
						"w": 236
					},
					{
						"n": 10,
						"h": 174,
						"w": 250
					},
					{
						"n": 11,
						"h": 285,
						"w": 309
					}
				],
				"ball": {
					"n": 0,
					"h": 238,
					"w": 567,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 15
		},
		{
			"num": 192,
			"minute": 9,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 16
					},
					{
						"n": 2,
						"h": 65,
						"w": 362
					},
					{
						"n": 3,
						"h": 182,
						"w": 315
					},
					{
						"n": 4,
						"h": 272,
						"w": 318
					},
					{
						"n": 5,
						"h": 386,
						"w": 364
					},
					{
						"n": 6,
						"h": 51,
						"w": 445
					},
					{
						"n": 7,
						"h": 132,
						"w": 541
					},
					{
						"n": 8,
						"h": 290,
						"w": 447
					},
					{
						"n": 9,
						"h": 395,
						"w": 575
					},
					{
						"n": 10,
						"h": 176,
						"w": 625
					},
					{
						"n": 11,
						"h": 238,
						"w": 587
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 15
					},
					{
						"n": 2,
						"h": 85,
						"w": 126
					},
					{
						"n": 3,
						"h": 212,
						"w": 122
					},
					{
						"n": 4,
						"h": 254,
						"w": 98
					},
					{
						"n": 5,
						"h": 340,
						"w": 89
					},
					{
						"n": 6,
						"h": 294,
						"w": 121
					},
					{
						"n": 7,
						"h": 328,
						"w": 182
					},
					{
						"n": 8,
						"h": 401,
						"w": 259
					},
					{
						"n": 9,
						"h": 19,
						"w": 236
					},
					{
						"n": 10,
						"h": 169,
						"w": 269
					},
					{
						"n": 11,
						"h": 291,
						"w": 292
					}
				],
				"ball": {
					"n": 0,
					"h": 238,
					"w": 587,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 20
		},
		{
			"num": 193,
			"minute": 9,
			"messages": [
				{
					"owner": 1,
					"mes": "Нир Мансур[23](Опава) пытается отобрать мяч у А.Гилберта[11](Галвэй Юнайтед)..."
				},
				{
					"owner": 1,
					"mes": "Адам Гилберт[11](Галвэй Юнайтед) с помощью дриблинга уходит от Н.Мансура[23](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 14
					},
					{
						"n": 2,
						"h": 70,
						"w": 375
					},
					{
						"n": 3,
						"h": 165,
						"w": 321
					},
					{
						"n": 4,
						"h": 270,
						"w": 321
					},
					{
						"n": 5,
						"h": 385,
						"w": 369
					},
					{
						"n": 6,
						"h": 51,
						"w": 485
					},
					{
						"n": 7,
						"h": 156,
						"w": 573
					},
					{
						"n": 8,
						"h": 276,
						"w": 438
					},
					{
						"n": 9,
						"h": 397,
						"w": 615
					},
					{
						"n": 10,
						"h": 176,
						"w": 632
					},
					{
						"n": 11,
						"h": 237,
						"w": 627,
						"m": 590
					}
				],
				"away": [
					{
						"n": 1,
						"h": 223,
						"w": 15
					},
					{
						"n": 2,
						"h": 59,
						"w": 98
					},
					{
						"n": 3,
						"h": 212,
						"w": 122,
						"m": 630
					},
					{
						"n": 4,
						"h": 215,
						"w": 88
					},
					{
						"n": 5,
						"h": 302,
						"w": 76
					},
					{
						"n": 6,
						"h": 288,
						"w": 134
					},
					{
						"n": 7,
						"h": 288,
						"w": 181
					},
					{
						"n": 8,
						"h": 400,
						"w": 219
					},
					{
						"n": 9,
						"h": 41,
						"w": 214
					},
					{
						"n": 10,
						"h": 174,
						"w": 262
					},
					{
						"n": 11,
						"h": 291,
						"w": 309
					}
				],
				"ball": {
					"n": 0,
					"h": 237,
					"w": 627,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 194,
			"minute": 9,
			"messages": [
				{
					"owner": 1,
					"mes": "Изящный пас на Д.Квигли[10](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 19
					},
					{
						"n": 2,
						"h": 66,
						"w": 378
					},
					{
						"n": 3,
						"h": 168,
						"w": 327
					},
					{
						"n": 4,
						"h": 279,
						"w": 320
					},
					{
						"n": 5,
						"h": 380,
						"w": 368
					},
					{
						"n": 6,
						"h": 52,
						"w": 518
					},
					{
						"n": 7,
						"h": 174,
						"w": 600
					},
					{
						"n": 8,
						"h": 282,
						"w": 470
					},
					{
						"n": 9,
						"h": 394,
						"w": 640
					},
					{
						"n": 10,
						"h": 180,
						"w": 660
					},
					{
						"n": 11,
						"h": 237,
						"w": 627,
						"m": 600
					}
				],
				"away": [
					{
						"n": 1,
						"h": 234,
						"w": 12
					},
					{
						"n": 2,
						"h": 75,
						"w": 70
					},
					{
						"n": 3,
						"h": 214,
						"w": 89
					},
					{
						"n": 4,
						"h": 224,
						"w": 75
					},
					{
						"n": 5,
						"h": 277,
						"w": 55
					},
					{
						"n": 6,
						"h": 276,
						"w": 103
					},
					{
						"n": 7,
						"h": 256,
						"w": 173
					},
					{
						"n": 8,
						"h": 399,
						"w": 186
					},
					{
						"n": 9,
						"h": 18,
						"w": 190
					},
					{
						"n": 10,
						"h": 174,
						"w": 295
					},
					{
						"n": 11,
						"h": 275,
						"w": 294
					}
				],
				"ball": {
					"n": 0,
					"h": 180,
					"w": 660,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 33
		},
		{
			"num": 195,
			"minute": 9,
			"messages": [
				{
					"owner": 1,
					"mes": "Джо Квигли[10](Галвэй Юнайтед) бьет навесным ударом..."
				}
			],
			"U": {
				"team": 1,
				"player": 10,
				"xg": "0.19"
			},
			"V": {
				"team": 1,
				"player": 10
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 18
					},
					{
						"n": 2,
						"h": 66,
						"w": 379
					},
					{
						"n": 3,
						"h": 177,
						"w": 329
					},
					{
						"n": 4,
						"h": 278,
						"w": 313
					},
					{
						"n": 5,
						"h": 377,
						"w": 360
					},
					{
						"n": 6,
						"h": 52,
						"w": 536
					},
					{
						"n": 7,
						"h": 173,
						"w": 618
					},
					{
						"n": 8,
						"h": 276,
						"w": 454
					},
					{
						"n": 9,
						"h": 393,
						"w": 640
					},
					{
						"n": 10,
						"h": 180,
						"w": 660,
						"m": 620
					},
					{
						"n": 11,
						"h": 250,
						"w": 640
					}
				],
				"away": [
					{
						"n": 1,
						"h": 223,
						"w": 12
					},
					{
						"n": 2,
						"h": 89,
						"w": 58
					},
					{
						"n": 3,
						"h": 215,
						"w": 69
					},
					{
						"n": 4,
						"h": 242,
						"w": 62
					},
					{
						"n": 5,
						"h": 267,
						"w": 56
					},
					{
						"n": 6,
						"h": 279,
						"w": 100
					},
					{
						"n": 7,
						"h": 241,
						"w": 164
					},
					{
						"n": 8,
						"h": 399,
						"w": 168
					},
					{
						"n": 9,
						"h": 28,
						"w": 190
					},
					{
						"n": 10,
						"h": 174,
						"w": 277
					},
					{
						"n": 11,
						"h": 286,
						"w": 294
					}
				],
				"ball": {
					"n": 0,
					"h": 247,
					"w": 720,
					"z": 1,
					"r": 0,
					"p": 1,
					"x": 9
				}
			},
			"interval": 18
		},
		{
			"num": 196,
			"minute": 9,
			"messages": [
				{
					"owner": 1,
					"mes": "Гол!!!"
				},
				{
					"owner": 1,
					"mes": " СЧЕТ 1:0"
				}
			],
			"G": {
				"team": 1,
				"player": 10,
				"assist": 11
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 18
					},
					{
						"n": 2,
						"h": 66,
						"w": 379
					},
					{
						"n": 3,
						"h": 177,
						"w": 329
					},
					{
						"n": 4,
						"h": 278,
						"w": 313
					},
					{
						"n": 5,
						"h": 377,
						"w": 360
					},
					{
						"n": 6,
						"h": 52,
						"w": 536
					},
					{
						"n": 7,
						"h": 173,
						"w": 618
					},
					{
						"n": 8,
						"h": 276,
						"w": 454
					},
					{
						"n": 9,
						"h": 393,
						"w": 640
					},
					{
						"n": 10,
						"h": 180,
						"w": 660,
						"m": 690
					},
					{
						"n": 11,
						"h": 250,
						"w": 640,
						"m": 650
					}
				],
				"away": [
					{
						"n": 1,
						"h": 223,
						"w": 12,
						"m": 570
					},
					{
						"n": 2,
						"h": 89,
						"w": 58
					},
					{
						"n": 3,
						"h": 215,
						"w": 69,
						"m": 600
					},
					{
						"n": 4,
						"h": 242,
						"w": 62
					},
					{
						"n": 5,
						"h": 267,
						"w": 56
					},
					{
						"n": 6,
						"h": 279,
						"w": 100
					},
					{
						"n": 7,
						"h": 241,
						"w": 164
					},
					{
						"n": 8,
						"h": 399,
						"w": 168
					},
					{
						"n": 9,
						"h": 28,
						"w": 190
					},
					{
						"n": 10,
						"h": 174,
						"w": 277
					},
					{
						"n": 11,
						"h": 286,
						"w": 294
					}
				],
				"ball": {
					"n": 0,
					"h": 226,
					"w": 733,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 20
		},
		{
			"num": 197,
			"minute": 10,
			"possession": 46,
			"messages": [],
			"N": {
				"team": 2
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 15
					},
					{
						"n": 2,
						"h": 45,
						"w": 90
					},
					{
						"n": 3,
						"h": 135,
						"w": 90
					},
					{
						"n": 4,
						"h": 315,
						"w": 90,
						"f": 97
					},
					{
						"n": 5,
						"h": 405,
						"w": 90
					},
					{
						"n": 6,
						"h": 45,
						"w": 210
					},
					{
						"n": 7,
						"h": 135,
						"w": 210
					},
					{
						"n": 8,
						"h": 315,
						"w": 210,
						"f": 96
					},
					{
						"n": 9,
						"h": 405,
						"w": 210,
						"f": 96
					},
					{
						"n": 10,
						"h": 100,
						"w": 330,
						"f": 96
					},
					{
						"n": 11,
						"h": 350,
						"w": 330
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 15
					},
					{
						"n": 2,
						"h": 37,
						"w": 90
					},
					{
						"n": 3,
						"h": 131,
						"w": 90
					},
					{
						"n": 4,
						"h": 319,
						"w": 90,
						"f": 95
					},
					{
						"n": 5,
						"h": 413,
						"w": 90
					},
					{
						"n": 6,
						"h": 225,
						"w": 150
					},
					{
						"n": 7,
						"h": 225,
						"w": 210,
						"f": 97
					},
					{
						"n": 8,
						"h": 413,
						"w": 210
					},
					{
						"n": 9,
						"h": 37,
						"w": 270
					},
					{
						"n": 10,
						"h": 213,
						"w": 331
					},
					{
						"n": 11,
						"h": 235,
						"w": 355
					}
				],
				"ball": {
					"n": 0,
					"h": 225,
					"w": 360,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 300
		},
		{
			"num": 198,
			"minute": 10,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 15
					},
					{
						"n": 2,
						"h": 45,
						"w": 90
					},
					{
						"n": 3,
						"h": 135,
						"w": 90
					},
					{
						"n": 4,
						"h": 315,
						"w": 90
					},
					{
						"n": 5,
						"h": 405,
						"w": 90
					},
					{
						"n": 6,
						"h": 45,
						"w": 210
					},
					{
						"n": 7,
						"h": 135,
						"w": 210
					},
					{
						"n": 8,
						"h": 315,
						"w": 210
					},
					{
						"n": 9,
						"h": 405,
						"w": 210
					},
					{
						"n": 10,
						"h": 100,
						"w": 330
					},
					{
						"n": 11,
						"h": 350,
						"w": 330
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 15
					},
					{
						"n": 2,
						"h": 37,
						"w": 90
					},
					{
						"n": 3,
						"h": 131,
						"w": 90
					},
					{
						"n": 4,
						"h": 319,
						"w": 90
					},
					{
						"n": 5,
						"h": 413,
						"w": 90
					},
					{
						"n": 6,
						"h": 225,
						"w": 150
					},
					{
						"n": 7,
						"h": 225,
						"w": 210
					},
					{
						"n": 8,
						"h": 413,
						"w": 210
					},
					{
						"n": 9,
						"h": 37,
						"w": 270
					},
					{
						"n": 10,
						"h": 213,
						"w": 331
					},
					{
						"n": 11,
						"h": 235,
						"w": 355
					}
				],
				"ball": {
					"n": 0,
					"h": 225,
					"w": 360,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 30
		},
		{
			"num": 199,
			"minute": 10,
			"messages": [
				{
					"owner": 2,
					"mes": "Команда Опава разыгрывает мяч..."
				},
				{
					"owner": 2,
					"mes": "С мячом Петр Крамарж[30](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 15
					},
					{
						"n": 2,
						"h": 45,
						"w": 90
					},
					{
						"n": 3,
						"h": 135,
						"w": 90
					},
					{
						"n": 4,
						"h": 315,
						"w": 90
					},
					{
						"n": 5,
						"h": 405,
						"w": 90
					},
					{
						"n": 6,
						"h": 45,
						"w": 210
					},
					{
						"n": 7,
						"h": 135,
						"w": 210
					},
					{
						"n": 8,
						"h": 315,
						"w": 210
					},
					{
						"n": 9,
						"h": 405,
						"w": 210
					},
					{
						"n": 10,
						"h": 100,
						"w": 330
					},
					{
						"n": 11,
						"h": 350,
						"w": 330
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 15
					},
					{
						"n": 2,
						"h": 37,
						"w": 90
					},
					{
						"n": 3,
						"h": 131,
						"w": 90
					},
					{
						"n": 4,
						"h": 319,
						"w": 90
					},
					{
						"n": 5,
						"h": 413,
						"w": 90
					},
					{
						"n": 6,
						"h": 225,
						"w": 150
					},
					{
						"n": 7,
						"h": 225,
						"w": 210
					},
					{
						"n": 8,
						"h": 413,
						"w": 210
					},
					{
						"n": 9,
						"h": 37,
						"w": 270
					},
					{
						"n": 10,
						"h": 213,
						"w": 331
					},
					{
						"n": 11,
						"h": 235,
						"w": 355
					}
				],
				"ball": {
					"n": 0,
					"h": 237,
					"w": 389,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 15
		},
		{
			"num": 200,
			"minute": 10,
			"messages": [
				{
					"owner": 2,
					"mes": "Петр Крамарж[30](Опава) отдает передачу направо..."
				},
				{
					"owner": 2,
					"mes": "Даниэль Прохазка[28](Опава) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 11
					},
					{
						"n": 2,
						"h": 81,
						"w": 126
					},
					{
						"n": 3,
						"h": 168,
						"w": 129
					},
					{
						"n": 4,
						"h": 285,
						"w": 131
					},
					{
						"n": 5,
						"h": 368,
						"w": 125
					},
					{
						"n": 6,
						"h": 44,
						"w": 260
					},
					{
						"n": 7,
						"h": 177,
						"w": 226
					},
					{
						"n": 8,
						"h": 268,
						"w": 229
					},
					{
						"n": 9,
						"h": 402,
						"w": 261
					},
					{
						"n": 10,
						"h": 143,
						"w": 358
					},
					{
						"n": 11,
						"h": 334,
						"w": 379
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 10
					},
					{
						"n": 2,
						"h": 20,
						"w": 112
					},
					{
						"n": 3,
						"h": 174,
						"w": 84
					},
					{
						"n": 4,
						"h": 273,
						"w": 81
					},
					{
						"n": 5,
						"h": 417,
						"w": 99
					},
					{
						"n": 6,
						"h": 250,
						"w": 194
					},
					{
						"n": 7,
						"h": 242,
						"w": 258
					},
					{
						"n": 8,
						"h": 395,
						"w": 234
					},
					{
						"n": 9,
						"h": 38,
						"w": 321
					},
					{
						"n": 10,
						"h": 208,
						"w": 340
					},
					{
						"n": 11,
						"h": 265,
						"w": 396
					}
				],
				"ball": {
					"n": 0,
					"h": 55,
					"w": 486,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 51
		},
		{
			"num": 201,
			"minute": 10,
			"messages": [
				{
					"owner": 2,
					"mes": "Даниэль Прохазка[28](Опава) пасует назад..."
				},
				{
					"owner": 2,
					"mes": "Томаш Прохазка[25](Опава) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 16
					},
					{
						"n": 2,
						"h": 93,
						"w": 164
					},
					{
						"n": 3,
						"h": 155,
						"w": 167
					},
					{
						"n": 4,
						"h": 259,
						"w": 161
					},
					{
						"n": 5,
						"h": 351,
						"w": 161
					},
					{
						"n": 6,
						"h": 29,
						"w": 297
					},
					{
						"n": 7,
						"h": 161,
						"w": 263
					},
					{
						"n": 8,
						"h": 254,
						"w": 267
					},
					{
						"n": 9,
						"h": 398,
						"w": 301
					},
					{
						"n": 10,
						"h": 176,
						"w": 380
					},
					{
						"n": 11,
						"h": 319,
						"w": 415
					}
				],
				"away": [
					{
						"n": 1,
						"h": 226,
						"w": 16
					},
					{
						"n": 2,
						"h": 34,
						"w": 149
					},
					{
						"n": 3,
						"h": 180,
						"w": 123
					},
					{
						"n": 4,
						"h": 282,
						"w": 120
					},
					{
						"n": 5,
						"h": 391,
						"w": 114
					},
					{
						"n": 6,
						"h": 232,
						"w": 230
					},
					{
						"n": 7,
						"h": 246,
						"w": 298
					},
					{
						"n": 8,
						"h": 395,
						"w": 244
					},
					{
						"n": 9,
						"h": 41,
						"w": 361
					},
					{
						"n": 10,
						"h": 188,
						"w": 374
					},
					{
						"n": 11,
						"h": 280,
						"w": 426
					}
				],
				"ball": {
					"n": 0,
					"h": 59,
					"w": 606,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 202,
			"minute": 10,
			"messages": [
				{
					"owner": 2,
					"mes": "Пас С.Пейше[24](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 17
					},
					{
						"n": 2,
						"h": 105,
						"w": 195
					},
					{
						"n": 3,
						"h": 155,
						"w": 200
					},
					{
						"n": 4,
						"h": 246,
						"w": 192
					},
					{
						"n": 5,
						"h": 343,
						"w": 194
					},
					{
						"n": 6,
						"h": 39,
						"w": 328
					},
					{
						"n": 7,
						"h": 155,
						"w": 295
					},
					{
						"n": 8,
						"h": 258,
						"w": 300
					},
					{
						"n": 9,
						"h": 394,
						"w": 291
					},
					{
						"n": 10,
						"h": 159,
						"w": 409
					},
					{
						"n": 11,
						"h": 306,
						"w": 446
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 19
					},
					{
						"n": 2,
						"h": 33,
						"w": 132
					},
					{
						"n": 3,
						"h": 170,
						"w": 125
					},
					{
						"n": 4,
						"h": 303,
						"w": 95
					},
					{
						"n": 5,
						"h": 394,
						"w": 124
					},
					{
						"n": 6,
						"h": 240,
						"w": 249
					},
					{
						"n": 7,
						"h": 230,
						"w": 327
					},
					{
						"n": 8,
						"h": 401,
						"w": 277
					},
					{
						"n": 9,
						"h": 45,
						"w": 394
					},
					{
						"n": 10,
						"h": 181,
						"w": 407
					},
					{
						"n": 11,
						"h": 299,
						"w": 422
					}
				],
				"ball": {
					"n": 0,
					"h": 147,
					"w": 625,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 33
		},
		{
			"num": 203,
			"minute": 10,
			"messages": [
				{
					"owner": 2,
					"mes": "С.Пейша[24](Опава) делает передачу К.Ласаку[21](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 18
					},
					{
						"n": 2,
						"h": 111,
						"w": 224
					},
					{
						"n": 3,
						"h": 170,
						"w": 225
					},
					{
						"n": 4,
						"h": 254,
						"w": 220
					},
					{
						"n": 5,
						"h": 338,
						"w": 222
					},
					{
						"n": 6,
						"h": 54,
						"w": 353
					},
					{
						"n": 7,
						"h": 172,
						"w": 318
					},
					{
						"n": 8,
						"h": 282,
						"w": 316
					},
					{
						"n": 9,
						"h": 394,
						"w": 283
					},
					{
						"n": 10,
						"h": 142,
						"w": 432
					},
					{
						"n": 11,
						"h": 311,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 237,
						"w": 40
					},
					{
						"n": 2,
						"h": 22,
						"w": 139
					},
					{
						"n": 3,
						"h": 168,
						"w": 125
					},
					{
						"n": 4,
						"h": 297,
						"w": 103
					},
					{
						"n": 5,
						"h": 418,
						"w": 139
					},
					{
						"n": 6,
						"h": 218,
						"w": 230
					},
					{
						"n": 7,
						"h": 240,
						"w": 354
					},
					{
						"n": 8,
						"h": 406,
						"w": 305
					},
					{
						"n": 9,
						"h": 36,
						"w": 422
					},
					{
						"n": 10,
						"h": 164,
						"w": 430
					},
					{
						"n": 11,
						"h": 274,
						"w": 420
					}
				],
				"ball": {
					"n": 0,
					"h": 213,
					"w": 680,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 29
		},
		{
			"num": 204,
			"minute": 10,
			"messages": [
				{
					"owner": 2,
					"mes": "Передача вперед..."
				},
				{
					"owner": 2,
					"mes": "Нир Мансур[23](Опава) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 14
					},
					{
						"n": 2,
						"h": 120,
						"w": 262
					},
					{
						"n": 3,
						"h": 190,
						"w": 265
					},
					{
						"n": 4,
						"h": 274,
						"w": 251
					},
					{
						"n": 5,
						"h": 330,
						"w": 254
					},
					{
						"n": 6,
						"h": 56,
						"w": 354
					},
					{
						"n": 7,
						"h": 165,
						"w": 320
					},
					{
						"n": 8,
						"h": 266,
						"w": 339
					},
					{
						"n": 9,
						"h": 386,
						"w": 275
					},
					{
						"n": 10,
						"h": 137,
						"w": 450
					},
					{
						"n": 11,
						"h": 320,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 232,
						"w": 31
					},
					{
						"n": 2,
						"h": 55,
						"w": 171
					},
					{
						"n": 3,
						"h": 173,
						"w": 162
					},
					{
						"n": 4,
						"h": 265,
						"w": 122
					},
					{
						"n": 5,
						"h": 385,
						"w": 116
					},
					{
						"n": 6,
						"h": 222,
						"w": 234
					},
					{
						"n": 7,
						"h": 224,
						"w": 335
					},
					{
						"n": 8,
						"h": 410,
						"w": 351
					},
					{
						"n": 9,
						"h": 49,
						"w": 420
					},
					{
						"n": 10,
						"h": 161,
						"w": 434
					},
					{
						"n": 11,
						"h": 279,
						"w": 424
					}
				],
				"ball": {
					"n": 0,
					"h": 277,
					"w": 558,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 46
		},
		{
			"num": 205,
			"minute": 10,
			"messages": [
				{
					"owner": 2,
					"mes": "Нир Мансур[23](Опава) отпускает мяч слишком далеко от себя..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 11
					},
					{
						"n": 2,
						"h": 120,
						"w": 263
					},
					{
						"n": 3,
						"h": 187,
						"w": 262
					},
					{
						"n": 4,
						"h": 270,
						"w": 250
					},
					{
						"n": 5,
						"h": 330,
						"w": 258
					},
					{
						"n": 6,
						"h": 56,
						"w": 350
					},
					{
						"n": 7,
						"h": 168,
						"w": 323
					},
					{
						"n": 8,
						"h": 264,
						"w": 339
					},
					{
						"n": 9,
						"h": 390,
						"w": 275
					},
					{
						"n": 10,
						"h": 141,
						"w": 450
					},
					{
						"n": 11,
						"h": 318,
						"w": 454
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 28
					},
					{
						"n": 2,
						"h": 59,
						"w": 171
					},
					{
						"n": 3,
						"h": 173,
						"w": 162
					},
					{
						"n": 4,
						"h": 261,
						"w": 124
					},
					{
						"n": 5,
						"h": 383,
						"w": 120
					},
					{
						"n": 6,
						"h": 223,
						"w": 231
					},
					{
						"n": 7,
						"h": 226,
						"w": 332
					},
					{
						"n": 8,
						"h": 410,
						"w": 355
					},
					{
						"n": 9,
						"h": 45,
						"w": 420
					},
					{
						"n": 10,
						"h": 164,
						"w": 432
					},
					{
						"n": 11,
						"h": 283,
						"w": 425
					}
				],
				"ball": {
					"n": 0,
					"h": 267,
					"w": 568,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 4
		},
		{
			"num": 206,
			"minute": 10,
			"messages": [
				{
					"owner": 2,
					"mes": "Нир Мансур[23](Опава) сам подхватывает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 12
					},
					{
						"n": 2,
						"h": 134,
						"w": 263
					},
					{
						"n": 3,
						"h": 201,
						"w": 259
					},
					{
						"n": 4,
						"h": 280,
						"w": 260
					},
					{
						"n": 5,
						"h": 330,
						"w": 260
					},
					{
						"n": 6,
						"h": 56,
						"w": 336
					},
					{
						"n": 7,
						"h": 167,
						"w": 313
					},
					{
						"n": 8,
						"h": 260,
						"w": 346
					},
					{
						"n": 9,
						"h": 394,
						"w": 285
					},
					{
						"n": 10,
						"h": 135,
						"w": 450
					},
					{
						"n": 11,
						"h": 313,
						"w": 466
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 19
					},
					{
						"n": 2,
						"h": 63,
						"w": 166
					},
					{
						"n": 3,
						"h": 183,
						"w": 152
					},
					{
						"n": 4,
						"h": 248,
						"w": 128
					},
					{
						"n": 5,
						"h": 377,
						"w": 127
					},
					{
						"n": 6,
						"h": 235,
						"w": 224
					},
					{
						"n": 7,
						"h": 238,
						"w": 331
					},
					{
						"n": 8,
						"h": 409,
						"w": 369
					},
					{
						"n": 9,
						"h": 35,
						"w": 420
					},
					{
						"n": 10,
						"h": 156,
						"w": 443
					},
					{
						"n": 11,
						"h": 292,
						"w": 414
					}
				],
				"ball": {
					"n": 0,
					"h": 267,
					"w": 568,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 14
		},
		{
			"num": 207,
			"minute": 10,
			"messages": [
				{
					"owner": 2,
					"mes": "Нир Мансур[23](Опава) делает передачу налево на Л.Седлачека[22](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 13
					},
					{
						"n": 2,
						"h": 136,
						"w": 270
					},
					{
						"n": 3,
						"h": 203,
						"w": 268
					},
					{
						"n": 4,
						"h": 271,
						"w": 251
					},
					{
						"n": 5,
						"h": 330,
						"w": 269
					},
					{
						"n": 6,
						"h": 56,
						"w": 294
					},
					{
						"n": 7,
						"h": 126,
						"w": 318
					},
					{
						"n": 8,
						"h": 284,
						"w": 323
					},
					{
						"n": 9,
						"h": 380,
						"w": 275
					},
					{
						"n": 10,
						"h": 168,
						"w": 450
					},
					{
						"n": 11,
						"h": 312,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 10
					},
					{
						"n": 2,
						"h": 68,
						"w": 206
					},
					{
						"n": 3,
						"h": 181,
						"w": 142
					},
					{
						"n": 4,
						"h": 282,
						"w": 120
					},
					{
						"n": 5,
						"h": 382,
						"w": 135
					},
					{
						"n": 6,
						"h": 193,
						"w": 220
					},
					{
						"n": 7,
						"h": 200,
						"w": 312
					},
					{
						"n": 8,
						"h": 395,
						"w": 409
					},
					{
						"n": 9,
						"h": 55,
						"w": 420
					},
					{
						"n": 10,
						"h": 163,
						"w": 422
					},
					{
						"n": 11,
						"h": 333,
						"w": 421
					}
				],
				"ball": {
					"n": 0,
					"h": 382,
					"w": 514,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 42
		},
		{
			"num": 208,
			"minute": 10,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 12
					},
					{
						"n": 2,
						"h": 120,
						"w": 236
					},
					{
						"n": 3,
						"h": 220,
						"w": 231
					},
					{
						"n": 4,
						"h": 287,
						"w": 233
					},
					{
						"n": 5,
						"h": 367,
						"w": 255
					},
					{
						"n": 6,
						"h": 36,
						"w": 328
					},
					{
						"n": 7,
						"h": 166,
						"w": 318
					},
					{
						"n": 8,
						"h": 293,
						"w": 303
					},
					{
						"n": 9,
						"h": 401,
						"w": 309
					},
					{
						"n": 10,
						"h": 170,
						"w": 410
					},
					{
						"n": 11,
						"h": 352,
						"w": 456
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 11
					},
					{
						"n": 2,
						"h": 51,
						"w": 237
					},
					{
						"n": 3,
						"h": 179,
						"w": 153
					},
					{
						"n": 4,
						"h": 279,
						"w": 143
					},
					{
						"n": 5,
						"h": 374,
						"w": 168
					},
					{
						"n": 6,
						"h": 197,
						"w": 240
					},
					{
						"n": 7,
						"h": 173,
						"w": 306
					},
					{
						"n": 8,
						"h": 404,
						"w": 448
					},
					{
						"n": 9,
						"h": 39,
						"w": 450
					},
					{
						"n": 10,
						"h": 164,
						"w": 462
					},
					{
						"n": 11,
						"h": 370,
						"w": 436
					}
				],
				"ball": {
					"n": 0,
					"h": 399,
					"w": 483,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 209,
			"minute": 10,
			"messages": [
				{
					"owner": 2,
					"mes": "Пас в центр..."
				},
				{
					"owner": 2,
					"mes": "Оливье Дюмон[26](Опава) останавливает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 19
					},
					{
						"n": 2,
						"h": 138,
						"w": 259
					},
					{
						"n": 3,
						"h": 208,
						"w": 258
					},
					{
						"n": 4,
						"h": 278,
						"w": 268
					},
					{
						"n": 5,
						"h": 330,
						"w": 259
					},
					{
						"n": 6,
						"h": 56,
						"w": 301
					},
					{
						"n": 7,
						"h": 190,
						"w": 340
					},
					{
						"n": 8,
						"h": 255,
						"w": 326
					},
					{
						"n": 9,
						"h": 394,
						"w": 299
					},
					{
						"n": 10,
						"h": 145,
						"w": 446
					},
					{
						"n": 11,
						"h": 308,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 221,
						"w": 35
					},
					{
						"n": 2,
						"h": 51,
						"w": 227
					},
					{
						"n": 3,
						"h": 158,
						"w": 153
					},
					{
						"n": 4,
						"h": 286,
						"w": 153
					},
					{
						"n": 5,
						"h": 402,
						"w": 153
					},
					{
						"n": 6,
						"h": 179,
						"w": 212
					},
					{
						"n": 7,
						"h": 216,
						"w": 298
					},
					{
						"n": 8,
						"h": 409,
						"w": 404
					},
					{
						"n": 9,
						"h": 41,
						"w": 406
					},
					{
						"n": 10,
						"h": 160,
						"w": 440
					},
					{
						"n": 11,
						"h": 326,
						"w": 438
					}
				],
				"ball": {
					"n": 0,
					"h": 271,
					"w": 508,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 44
		},
		{
			"num": 210,
			"minute": 10,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 16
					},
					{
						"n": 2,
						"h": 120,
						"w": 231
					},
					{
						"n": 3,
						"h": 176,
						"w": 234
					},
					{
						"n": 4,
						"h": 268,
						"w": 231
					},
					{
						"n": 5,
						"h": 330,
						"w": 238
					},
					{
						"n": 6,
						"h": 56,
						"w": 341
					},
					{
						"n": 7,
						"h": 180,
						"w": 311
					},
					{
						"n": 8,
						"h": 272,
						"w": 313
					},
					{
						"n": 9,
						"h": 394,
						"w": 316
					},
					{
						"n": 10,
						"h": 144,
						"w": 426
					},
					{
						"n": 11,
						"h": 268,
						"w": 455
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 55
					},
					{
						"n": 2,
						"h": 47,
						"w": 187
					},
					{
						"n": 3,
						"h": 155,
						"w": 163
					},
					{
						"n": 4,
						"h": 298,
						"w": 163
					},
					{
						"n": 5,
						"h": 408,
						"w": 163
					},
					{
						"n": 6,
						"h": 192,
						"w": 244
					},
					{
						"n": 7,
						"h": 234,
						"w": 314
					},
					{
						"n": 8,
						"h": 407,
						"w": 364
					},
					{
						"n": 9,
						"h": 42,
						"w": 389
					},
					{
						"n": 10,
						"h": 166,
						"w": 464
					},
					{
						"n": 11,
						"h": 292,
						"w": 459
					}
				],
				"ball": {
					"n": 0,
					"h": 258,
					"w": 476,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 211,
			"minute": 10,
			"messages": [
				{
					"owner": 2,
					"mes": "Пас вперед..."
				},
				{
					"owner": 2,
					"mes": "Джо Квигли[10](Галвэй Юнайтед) демонстрирует позиционное чутье и перехватывает мяч!..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 19
					},
					{
						"n": 2,
						"h": 120,
						"w": 220
					},
					{
						"n": 3,
						"h": 174,
						"w": 211
					},
					{
						"n": 4,
						"h": 282,
						"w": 210
					},
					{
						"n": 5,
						"h": 330,
						"w": 215
					},
					{
						"n": 6,
						"h": 56,
						"w": 374
					},
					{
						"n": 7,
						"h": 187,
						"w": 288
					},
					{
						"n": 8,
						"h": 268,
						"w": 300
					},
					{
						"n": 9,
						"h": 394,
						"w": 275
					},
					{
						"n": 10,
						"h": 184,
						"w": 438
					},
					{
						"n": 11,
						"h": 290,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 72
					},
					{
						"n": 2,
						"h": 31,
						"w": 173
					},
					{
						"n": 3,
						"h": 160,
						"w": 173
					},
					{
						"n": 4,
						"h": 300,
						"w": 173
					},
					{
						"n": 5,
						"h": 404,
						"w": 173
					},
					{
						"n": 6,
						"h": 203,
						"w": 247,
						"m": 610
					},
					{
						"n": 7,
						"h": 260,
						"w": 288,
						"m": 580
					},
					{
						"n": 8,
						"h": 418,
						"w": 331
					},
					{
						"n": 9,
						"h": 49,
						"w": 410
					},
					{
						"n": 10,
						"h": 153,
						"w": 489
					},
					{
						"n": 11,
						"h": 291,
						"w": 489
					}
				],
				"ball": {
					"n": 0,
					"h": 184,
					"w": 438,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 41
		},
		{
			"num": 212,
			"minute": 10,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 11
					},
					{
						"n": 2,
						"h": 99,
						"w": 254
					},
					{
						"n": 3,
						"h": 176,
						"w": 251
					},
					{
						"n": 4,
						"h": 274,
						"w": 249
					},
					{
						"n": 5,
						"h": 352,
						"w": 248
					},
					{
						"n": 6,
						"h": 60,
						"w": 414
					},
					{
						"n": 7,
						"h": 180,
						"w": 327
					},
					{
						"n": 8,
						"h": 275,
						"w": 339
					},
					{
						"n": 9,
						"h": 395,
						"w": 315
					},
					{
						"n": 10,
						"h": 159,
						"w": 462,
						"m": 700
					},
					{
						"n": 11,
						"h": 290,
						"w": 490
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 76
					},
					{
						"n": 2,
						"h": 63,
						"w": 149
					},
					{
						"n": 3,
						"h": 169,
						"w": 134
					},
					{
						"n": 4,
						"h": 286,
						"w": 135
					},
					{
						"n": 5,
						"h": 373,
						"w": 148
					},
					{
						"n": 6,
						"h": 183,
						"w": 212
					},
					{
						"n": 7,
						"h": 280,
						"w": 254
					},
					{
						"n": 8,
						"h": 401,
						"w": 295
					},
					{
						"n": 9,
						"h": 41,
						"w": 371
					},
					{
						"n": 10,
						"h": 160,
						"w": 450
					},
					{
						"n": 11,
						"h": 284,
						"w": 450
					}
				],
				"ball": {
					"n": 0,
					"h": 159,
					"w": 462,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 213,
			"minute": 10,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 14
					},
					{
						"n": 2,
						"h": 91,
						"w": 273
					},
					{
						"n": 3,
						"h": 173,
						"w": 271
					},
					{
						"n": 4,
						"h": 280,
						"w": 268
					},
					{
						"n": 5,
						"h": 359,
						"w": 267
					},
					{
						"n": 6,
						"h": 49,
						"w": 431
					},
					{
						"n": 7,
						"h": 175,
						"w": 347
					},
					{
						"n": 8,
						"h": 277,
						"w": 359
					},
					{
						"n": 9,
						"h": 396,
						"w": 335
					},
					{
						"n": 10,
						"h": 169,
						"w": 462
					},
					{
						"n": 11,
						"h": 291,
						"w": 510
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 77
					},
					{
						"n": 2,
						"h": 79,
						"w": 137
					},
					{
						"n": 3,
						"h": 161,
						"w": 116
					},
					{
						"n": 4,
						"h": 270,
						"w": 124
					},
					{
						"n": 5,
						"h": 361,
						"w": 132
					},
					{
						"n": 6,
						"h": 174,
						"w": 194
					},
					{
						"n": 7,
						"h": 279,
						"w": 248
					},
					{
						"n": 8,
						"h": 401,
						"w": 275
					},
					{
						"n": 9,
						"h": 51,
						"w": 354
					},
					{
						"n": 10,
						"h": 162,
						"w": 430
					},
					{
						"n": 11,
						"h": 282,
						"w": 430
					}
				],
				"ball": {
					"n": 0,
					"h": 169,
					"w": 462,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 20
		},
		{
			"num": 214,
			"minute": 10,
			"messages": [
				{
					"owner": 1,
					"mes": "Джо Квигли[10](Галвэй Юнайтед) закрывает мяч от соперника..."
				},
				{
					"owner": 1,
					"mes": "Джо Квигли[10](Галвэй Юнайтед) резко разворачивается..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 14
					},
					{
						"n": 2,
						"h": 85,
						"w": 286
					},
					{
						"n": 3,
						"h": 171,
						"w": 286
					},
					{
						"n": 4,
						"h": 282,
						"w": 273
					},
					{
						"n": 5,
						"h": 364,
						"w": 281
					},
					{
						"n": 6,
						"h": 41,
						"w": 443
					},
					{
						"n": 7,
						"h": 171,
						"w": 361
					},
					{
						"n": 8,
						"h": 278,
						"w": 374
					},
					{
						"n": 9,
						"h": 397,
						"w": 350
					},
					{
						"n": 10,
						"h": 179,
						"w": 472,
						"m": 720
					},
					{
						"n": 11,
						"h": 293,
						"w": 525
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 77
					},
					{
						"n": 2,
						"h": 90,
						"w": 127
					},
					{
						"n": 3,
						"h": 157,
						"w": 108
					},
					{
						"n": 4,
						"h": 257,
						"w": 116
					},
					{
						"n": 5,
						"h": 352,
						"w": 120
					},
					{
						"n": 6,
						"h": 167,
						"w": 181
					},
					{
						"n": 7,
						"h": 279,
						"w": 248,
						"m": 570
					},
					{
						"n": 8,
						"h": 401,
						"w": 260
					},
					{
						"n": 9,
						"h": 54,
						"w": 349
					},
					{
						"n": 10,
						"h": 164,
						"w": 415
					},
					{
						"n": 11,
						"h": 281,
						"w": 415
					}
				],
				"ball": {
					"n": 0,
					"h": 179,
					"w": 472,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 15
		},
		{
			"num": 215,
			"minute": 10,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 11
					},
					{
						"n": 2,
						"h": 79,
						"w": 326
					},
					{
						"n": 3,
						"h": 184,
						"w": 302
					},
					{
						"n": 4,
						"h": 270,
						"w": 295
					},
					{
						"n": 5,
						"h": 373,
						"w": 320
					},
					{
						"n": 6,
						"h": 53,
						"w": 471
					},
					{
						"n": 7,
						"h": 160,
						"w": 400
					},
					{
						"n": 8,
						"h": 280,
						"w": 414
					},
					{
						"n": 9,
						"h": 397,
						"w": 390
					},
					{
						"n": 10,
						"h": 187,
						"w": 507
					},
					{
						"n": 11,
						"h": 289,
						"w": 565
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 70
					},
					{
						"n": 2,
						"h": 110,
						"w": 105
					},
					{
						"n": 3,
						"h": 175,
						"w": 101
					},
					{
						"n": 4,
						"h": 244,
						"w": 101
					},
					{
						"n": 5,
						"h": 340,
						"w": 114
					},
					{
						"n": 6,
						"h": 207,
						"w": 187
					},
					{
						"n": 7,
						"h": 274,
						"w": 228
					},
					{
						"n": 8,
						"h": 398,
						"w": 220
					},
					{
						"n": 9,
						"h": 48,
						"w": 309
					},
					{
						"n": 10,
						"h": 166,
						"w": 375
					},
					{
						"n": 11,
						"h": 284,
						"w": 375
					}
				],
				"ball": {
					"n": 0,
					"h": 187,
					"w": 507,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 216,
			"minute": 10,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 10
					},
					{
						"n": 2,
						"h": 78,
						"w": 359
					},
					{
						"n": 3,
						"h": 180,
						"w": 317
					},
					{
						"n": 4,
						"h": 268,
						"w": 312
					},
					{
						"n": 5,
						"h": 383,
						"w": 359
					},
					{
						"n": 6,
						"h": 55,
						"w": 511
					},
					{
						"n": 7,
						"h": 168,
						"w": 439
					},
					{
						"n": 8,
						"h": 278,
						"w": 454
					},
					{
						"n": 9,
						"h": 400,
						"w": 430
					},
					{
						"n": 10,
						"h": 188,
						"w": 553
					},
					{
						"n": 11,
						"h": 281,
						"w": 604
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 37
					},
					{
						"n": 2,
						"h": 110,
						"w": 89
					},
					{
						"n": 3,
						"h": 189,
						"w": 99
					},
					{
						"n": 4,
						"h": 242,
						"w": 102
					},
					{
						"n": 5,
						"h": 340,
						"w": 94
					},
					{
						"n": 6,
						"h": 247,
						"w": 158
					},
					{
						"n": 7,
						"h": 267,
						"w": 194
					},
					{
						"n": 8,
						"h": 396,
						"w": 180
					},
					{
						"n": 9,
						"h": 46,
						"w": 269
					},
					{
						"n": 10,
						"h": 165,
						"w": 335
					},
					{
						"n": 11,
						"h": 283,
						"w": 335
					}
				],
				"ball": {
					"n": 0,
					"h": 188,
					"w": 553,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 217,
			"minute": 10,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 11
					},
					{
						"n": 2,
						"h": 63,
						"w": 360
					},
					{
						"n": 3,
						"h": 173,
						"w": 304
					},
					{
						"n": 4,
						"h": 265,
						"w": 301
					},
					{
						"n": 5,
						"h": 375,
						"w": 359
					},
					{
						"n": 6,
						"h": 52,
						"w": 526
					},
					{
						"n": 7,
						"h": 161,
						"w": 437
					},
					{
						"n": 8,
						"h": 280,
						"w": 469
					},
					{
						"n": 9,
						"h": 401,
						"w": 445
					},
					{
						"n": 10,
						"h": 188,
						"w": 566
					},
					{
						"n": 11,
						"h": 276,
						"w": 618
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 22
					},
					{
						"n": 2,
						"h": 110,
						"w": 80
					},
					{
						"n": 3,
						"h": 187,
						"w": 84
					},
					{
						"n": 4,
						"h": 245,
						"w": 88
					},
					{
						"n": 5,
						"h": 340,
						"w": 92
					},
					{
						"n": 6,
						"h": 262,
						"w": 154
					},
					{
						"n": 7,
						"h": 265,
						"w": 184
					},
					{
						"n": 8,
						"h": 397,
						"w": 165
					},
					{
						"n": 9,
						"h": 47,
						"w": 254
					},
					{
						"n": 10,
						"h": 160,
						"w": 321
					},
					{
						"n": 11,
						"h": 284,
						"w": 320
					}
				],
				"ball": {
					"n": 0,
					"h": 188,
					"w": 566,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 15
		},
		{
			"num": 218,
			"minute": 10,
			"messages": [
				{
					"owner": 1,
					"mes": "Д.Квигли[10](Галвэй Юнайтед) пытается пройти О.Дюмона[26](Опава)..."
				},
				{
					"owner": 1,
					"mes": "Д.Квигли[10](Галвэй Юнайтед) теряет мяч. Оливье Дюмон[26](Опава) жестко ставит ногу..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 11
					},
					{
						"n": 2,
						"h": 60,
						"w": 360
					},
					{
						"n": 3,
						"h": 170,
						"w": 300
					},
					{
						"n": 4,
						"h": 265,
						"w": 301
					},
					{
						"n": 5,
						"h": 375,
						"w": 359
					},
					{
						"n": 6,
						"h": 50,
						"w": 534
					},
					{
						"n": 7,
						"h": 161,
						"w": 437
					},
					{
						"n": 8,
						"h": 281,
						"w": 479
					},
					{
						"n": 9,
						"h": 402,
						"w": 455
					},
					{
						"n": 10,
						"h": 188,
						"w": 576
					},
					{
						"n": 11,
						"h": 274,
						"w": 624
					}
				],
				"away": [
					{
						"n": 1,
						"h": 228,
						"w": 15
					},
					{
						"n": 2,
						"h": 110,
						"w": 80
					},
					{
						"n": 3,
						"h": 186,
						"w": 74
					},
					{
						"n": 4,
						"h": 246,
						"w": 83
					},
					{
						"n": 5,
						"h": 340,
						"w": 92
					},
					{
						"n": 6,
						"h": 271,
						"w": 152,
						"m": 620
					},
					{
						"n": 7,
						"h": 264,
						"w": 174
					},
					{
						"n": 8,
						"h": 398,
						"w": 158
					},
					{
						"n": 9,
						"h": 48,
						"w": 244
					},
					{
						"n": 10,
						"h": 156,
						"w": 312
					},
					{
						"n": 11,
						"h": 285,
						"w": 310
					}
				],
				"ball": {
					"n": 0,
					"h": 179,
					"w": 568,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 10
		},
		{
			"num": 219,
			"minute": 10,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 13
					},
					{
						"n": 2,
						"h": 76,
						"w": 323
					},
					{
						"n": 3,
						"h": 164,
						"w": 286
					},
					{
						"n": 4,
						"h": 257,
						"w": 293
					},
					{
						"n": 5,
						"h": 365,
						"w": 320
					},
					{
						"n": 6,
						"h": 45,
						"w": 495
					},
					{
						"n": 7,
						"h": 138,
						"w": 405
					},
					{
						"n": 8,
						"h": 271,
						"w": 440
					},
					{
						"n": 9,
						"h": 408,
						"w": 436
					},
					{
						"n": 10,
						"h": 183,
						"w": 567
					},
					{
						"n": 11,
						"h": 284,
						"w": 585
					}
				],
				"away": [
					{
						"n": 1,
						"h": 229,
						"w": 13
					},
					{
						"n": 2,
						"h": 88,
						"w": 113
					},
					{
						"n": 3,
						"h": 183,
						"w": 98
					},
					{
						"n": 4,
						"h": 275,
						"w": 94
					},
					{
						"n": 5,
						"h": 374,
						"w": 112
					},
					{
						"n": 6,
						"h": 296,
						"w": 177
					},
					{
						"n": 7,
						"h": 243,
						"w": 209
					},
					{
						"n": 8,
						"h": 395,
						"w": 198
					},
					{
						"n": 9,
						"h": 51,
						"w": 284
					},
					{
						"n": 10,
						"h": 153,
						"w": 352
					},
					{
						"n": 11,
						"h": 325,
						"w": 304
					}
				],
				"ball": {
					"n": 0,
					"h": 154,
					"w": 543,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 220,
			"minute": 10,
			"messages": [
				{
					"owner": 2,
					"mes": "Оливье Дюмон[26](Опава) пасует на ближайшего партнера по команде..."
				},
				{
					"owner": 2,
					"mes": "Мирослав Манолов[27](Опава) останавливает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 16
					},
					{
						"n": 2,
						"h": 79,
						"w": 300
					},
					{
						"n": 3,
						"h": 142,
						"w": 280
					},
					{
						"n": 4,
						"h": 236,
						"w": 285
					},
					{
						"n": 5,
						"h": 345,
						"w": 309
					},
					{
						"n": 6,
						"h": 42,
						"w": 472
					},
					{
						"n": 7,
						"h": 128,
						"w": 384
					},
					{
						"n": 8,
						"h": 270,
						"w": 417
					},
					{
						"n": 9,
						"h": 407,
						"w": 413
					},
					{
						"n": 10,
						"h": 188,
						"w": 545
					},
					{
						"n": 11,
						"h": 290,
						"w": 563
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 18
					},
					{
						"n": 2,
						"h": 80,
						"w": 135
					},
					{
						"n": 3,
						"h": 163,
						"w": 103
					},
					{
						"n": 4,
						"h": 276,
						"w": 117
					},
					{
						"n": 5,
						"h": 390,
						"w": 125
					},
					{
						"n": 6,
						"h": 292,
						"w": 186
					},
					{
						"n": 7,
						"h": 257,
						"w": 201
					},
					{
						"n": 8,
						"h": 403,
						"w": 220
					},
					{
						"n": 9,
						"h": 59,
						"w": 306
					},
					{
						"n": 10,
						"h": 155,
						"w": 374
					},
					{
						"n": 11,
						"h": 348,
						"w": 304
					}
				],
				"ball": {
					"n": 0,
					"h": 193,
					"w": 519,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 23
		},
		{
			"num": 221,
			"minute": 10,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 13
					},
					{
						"n": 2,
						"h": 108,
						"w": 274
					},
					{
						"n": 3,
						"h": 181,
						"w": 269
					},
					{
						"n": 4,
						"h": 269,
						"w": 263
					},
					{
						"n": 5,
						"h": 335,
						"w": 270
					},
					{
						"n": 6,
						"h": 55,
						"w": 434
					},
					{
						"n": 7,
						"h": 160,
						"w": 360
					},
					{
						"n": 8,
						"h": 281,
						"w": 366
					},
					{
						"n": 9,
						"h": 394,
						"w": 375
					},
					{
						"n": 10,
						"h": 199,
						"w": 493
					},
					{
						"n": 11,
						"h": 300,
						"w": 524
					}
				],
				"away": [
					{
						"n": 1,
						"h": 229,
						"w": 15
					},
					{
						"n": 2,
						"h": 65,
						"w": 172
					},
					{
						"n": 3,
						"h": 164,
						"w": 112
					},
					{
						"n": 4,
						"h": 268,
						"w": 120
					},
					{
						"n": 5,
						"h": 392,
						"w": 144
					},
					{
						"n": 6,
						"h": 253,
						"w": 195
					},
					{
						"n": 7,
						"h": 237,
						"w": 235
					},
					{
						"n": 8,
						"h": 405,
						"w": 260
					},
					{
						"n": 9,
						"h": 67,
						"w": 345
					},
					{
						"n": 10,
						"h": 157,
						"w": 414
					},
					{
						"n": 11,
						"h": 364,
						"w": 341
					}
				],
				"ball": {
					"n": 0,
					"h": 213,
					"w": 485,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 222,
			"minute": 11,
			"possession": 44,
			"messages": [
				{
					"owner": 2,
					"mes": "Мирослав Манолов[27](Опава) отбрасывает мяч назад..."
				},
				{
					"owner": 2,
					"mes": "Себастьян Пейша[24](Опава) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 10
					},
					{
						"n": 2,
						"h": 89,
						"w": 307,
						"f": 96
					},
					{
						"n": 3,
						"h": 218,
						"w": 268,
						"f": 97
					},
					{
						"n": 4,
						"h": 299,
						"w": 266
					},
					{
						"n": 5,
						"h": 330,
						"w": 255,
						"f": 96
					},
					{
						"n": 6,
						"h": 55,
						"w": 395,
						"f": 96
					},
					{
						"n": 7,
						"h": 177,
						"w": 346,
						"f": 96
					},
					{
						"n": 8,
						"h": 261,
						"w": 332
					},
					{
						"n": 9,
						"h": 394,
						"w": 336
					},
					{
						"n": 10,
						"h": 204,
						"w": 532
					},
					{
						"n": 11,
						"h": 303,
						"w": 485
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 12
					},
					{
						"n": 2,
						"h": 62,
						"w": 172
					},
					{
						"n": 3,
						"h": 176,
						"w": 106
					},
					{
						"n": 4,
						"h": 243,
						"w": 149
					},
					{
						"n": 5,
						"h": 375,
						"w": 140
					},
					{
						"n": 6,
						"h": 265,
						"w": 209
					},
					{
						"n": 7,
						"h": 236,
						"w": 244
					},
					{
						"n": 8,
						"h": 406,
						"w": 299
					},
					{
						"n": 9,
						"h": 49,
						"w": 363
					},
					{
						"n": 10,
						"h": 149,
						"w": 425,
						"f": 95
					},
					{
						"n": 11,
						"h": 380,
						"w": 376,
						"f": 95
					}
				],
				"ball": {
					"n": 0,
					"h": 207,
					"w": 571,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 223,
			"minute": 11,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 10
					},
					{
						"n": 2,
						"h": 84,
						"w": 287
					},
					{
						"n": 3,
						"h": 219,
						"w": 259
					},
					{
						"n": 4,
						"h": 294,
						"w": 256
					},
					{
						"n": 5,
						"h": 330,
						"w": 266
					},
					{
						"n": 6,
						"h": 44,
						"w": 378
					},
					{
						"n": 7,
						"h": 188,
						"w": 328
					},
					{
						"n": 8,
						"h": 257,
						"w": 342
					},
					{
						"n": 9,
						"h": 382,
						"w": 312
					},
					{
						"n": 10,
						"h": 223,
						"w": 520
					},
					{
						"n": 11,
						"h": 317,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 226,
						"w": 18
					},
					{
						"n": 2,
						"h": 71,
						"w": 157
					},
					{
						"n": 3,
						"h": 178,
						"w": 109
					},
					{
						"n": 4,
						"h": 227,
						"w": 180
					},
					{
						"n": 5,
						"h": 377,
						"w": 111
					},
					{
						"n": 6,
						"h": 230,
						"w": 229
					},
					{
						"n": 7,
						"h": 236,
						"w": 284
					},
					{
						"n": 8,
						"h": 399,
						"w": 275
					},
					{
						"n": 9,
						"h": 68,
						"w": 373
					},
					{
						"n": 10,
						"h": 152,
						"w": 431
					},
					{
						"n": 11,
						"h": 396,
						"w": 413
					}
				],
				"ball": {
					"n": 0,
					"h": 223,
					"w": 540,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 224,
			"minute": 11,
			"messages": [
				{
					"owner": 2,
					"mes": "Себастьян Пейша[24](Опава) пасует на Н.Мансура[23](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 11
					},
					{
						"n": 2,
						"h": 107,
						"w": 259
					},
					{
						"n": 3,
						"h": 215,
						"w": 250
					},
					{
						"n": 4,
						"h": 293,
						"w": 248
					},
					{
						"n": 5,
						"h": 330,
						"w": 256
					},
					{
						"n": 6,
						"h": 51,
						"w": 341
					},
					{
						"n": 7,
						"h": 182,
						"w": 324
					},
					{
						"n": 8,
						"h": 273,
						"w": 326
					},
					{
						"n": 9,
						"h": 367,
						"w": 328
					},
					{
						"n": 10,
						"h": 194,
						"w": 496
					},
					{
						"n": 11,
						"h": 304,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 221,
						"w": 18
					},
					{
						"n": 2,
						"h": 73,
						"w": 174
					},
					{
						"n": 3,
						"h": 185,
						"w": 119
					},
					{
						"n": 4,
						"h": 233,
						"w": 172
					},
					{
						"n": 5,
						"h": 384,
						"w": 106
					},
					{
						"n": 6,
						"h": 225,
						"w": 240
					},
					{
						"n": 7,
						"h": 230,
						"w": 321
					},
					{
						"n": 8,
						"h": 397,
						"w": 312
					},
					{
						"n": 9,
						"h": 83,
						"w": 357
					},
					{
						"n": 10,
						"h": 157,
						"w": 449
					},
					{
						"n": 11,
						"h": 398,
						"w": 376
					}
				],
				"ball": {
					"n": 0,
					"h": 265,
					"w": 601,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 37
		},
		{
			"num": 225,
			"minute": 11,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 18
					},
					{
						"n": 2,
						"h": 120,
						"w": 261
					},
					{
						"n": 3,
						"h": 216,
						"w": 269
					},
					{
						"n": 4,
						"h": 299,
						"w": 269
					},
					{
						"n": 5,
						"h": 330,
						"w": 265
					},
					{
						"n": 6,
						"h": 55,
						"w": 301
					},
					{
						"n": 7,
						"h": 222,
						"w": 328
					},
					{
						"n": 8,
						"h": 299,
						"w": 331
					},
					{
						"n": 9,
						"h": 399,
						"w": 352
					},
					{
						"n": 10,
						"h": 162,
						"w": 472
					},
					{
						"n": 11,
						"h": 320,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 228,
						"w": 13
					},
					{
						"n": 2,
						"h": 64,
						"w": 201
					},
					{
						"n": 3,
						"h": 182,
						"w": 155
					},
					{
						"n": 4,
						"h": 267,
						"w": 152
					},
					{
						"n": 5,
						"h": 379,
						"w": 156
					},
					{
						"n": 6,
						"h": 211,
						"w": 230
					},
					{
						"n": 7,
						"h": 230,
						"w": 361
					},
					{
						"n": 8,
						"h": 407,
						"w": 273
					},
					{
						"n": 9,
						"h": 108,
						"w": 365
					},
					{
						"n": 10,
						"h": 155,
						"w": 425
					},
					{
						"n": 11,
						"h": 415,
						"w": 412
					}
				],
				"ball": {
					"n": 0,
					"h": 268,
					"w": 565,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 226,
			"minute": 11,
			"messages": [
				{
					"owner": 2,
					"mes": "Пас направо на Д.Прохазку[28](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 10
					},
					{
						"n": 2,
						"h": 120,
						"w": 267
					},
					{
						"n": 3,
						"h": 220,
						"w": 258
					},
					{
						"n": 4,
						"h": 289,
						"w": 259
					},
					{
						"n": 5,
						"h": 330,
						"w": 259
					},
					{
						"n": 6,
						"h": 85,
						"w": 275
					},
					{
						"n": 7,
						"h": 166,
						"w": 334
					},
					{
						"n": 8,
						"h": 245,
						"w": 334
					},
					{
						"n": 9,
						"h": 394,
						"w": 315
					},
					{
						"n": 10,
						"h": 150,
						"w": 450
					},
					{
						"n": 11,
						"h": 304,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 35
					},
					{
						"n": 2,
						"h": 34,
						"w": 162
					},
					{
						"n": 3,
						"h": 173,
						"w": 158
					},
					{
						"n": 4,
						"h": 300,
						"w": 162
					},
					{
						"n": 5,
						"h": 399,
						"w": 162
					},
					{
						"n": 6,
						"h": 219,
						"w": 231
					},
					{
						"n": 7,
						"h": 234,
						"w": 305
					},
					{
						"n": 8,
						"h": 386,
						"w": 244
					},
					{
						"n": 9,
						"h": 52,
						"w": 370
					},
					{
						"n": 10,
						"h": 159,
						"w": 440
					},
					{
						"n": 11,
						"h": 360,
						"w": 424
					}
				],
				"ball": {
					"n": 0,
					"h": 64,
					"w": 476,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 56
		},
		{
			"num": 227,
			"minute": 11,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 10
					},
					{
						"n": 2,
						"h": 120,
						"w": 229
					},
					{
						"n": 3,
						"h": 184,
						"w": 241
					},
					{
						"n": 4,
						"h": 255,
						"w": 239
					},
					{
						"n": 5,
						"h": 330,
						"w": 221
					},
					{
						"n": 6,
						"h": 70,
						"w": 312
					},
					{
						"n": 7,
						"h": 161,
						"w": 303
					},
					{
						"n": 8,
						"h": 239,
						"w": 304
					},
					{
						"n": 9,
						"h": 394,
						"w": 311
					},
					{
						"n": 10,
						"h": 111,
						"w": 439
					},
					{
						"n": 11,
						"h": 286,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 58
					},
					{
						"n": 2,
						"h": 43,
						"w": 168
					},
					{
						"n": 3,
						"h": 164,
						"w": 168
					},
					{
						"n": 4,
						"h": 290,
						"w": 168
					},
					{
						"n": 5,
						"h": 408,
						"w": 168
					},
					{
						"n": 6,
						"h": 234,
						"w": 243
					},
					{
						"n": 7,
						"h": 222,
						"w": 319
					},
					{
						"n": 8,
						"h": 397,
						"w": 277
					},
					{
						"n": 9,
						"h": 38,
						"w": 394
					},
					{
						"n": 10,
						"h": 164,
						"w": 470
					},
					{
						"n": 11,
						"h": 327,
						"w": 446
					}
				],
				"ball": {
					"n": 0,
					"h": 53,
					"w": 443,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 228,
			"minute": 11,
			"messages": [
				{
					"owner": 2,
					"mes": "Даниэль Прохазка[28](Опава) отпасовывает назад..."
				},
				{
					"owner": 2,
					"mes": "Себастьян Пейша[24](Опава) сбрасывает мяч себе на ход..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 11
					},
					{
						"n": 2,
						"h": 120,
						"w": 251
					},
					{
						"n": 3,
						"h": 173,
						"w": 269
					},
					{
						"n": 4,
						"h": 281,
						"w": 266
					},
					{
						"n": 5,
						"h": 330,
						"w": 258
					},
					{
						"n": 6,
						"h": 44,
						"w": 349
					},
					{
						"n": 7,
						"h": 189,
						"w": 336
					},
					{
						"n": 8,
						"h": 275,
						"w": 327
					},
					{
						"n": 9,
						"h": 394,
						"w": 311
					},
					{
						"n": 10,
						"h": 132,
						"w": 450
					},
					{
						"n": 11,
						"h": 305,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 75
					},
					{
						"n": 2,
						"h": 41,
						"w": 178
					},
					{
						"n": 3,
						"h": 154,
						"w": 178
					},
					{
						"n": 4,
						"h": 301,
						"w": 181
					},
					{
						"n": 5,
						"h": 417,
						"w": 178
					},
					{
						"n": 6,
						"h": 226,
						"w": 243
					},
					{
						"n": 7,
						"h": 233,
						"w": 309
					},
					{
						"n": 8,
						"h": 401,
						"w": 286
					},
					{
						"n": 9,
						"h": 47,
						"w": 374
					},
					{
						"n": 10,
						"h": 153,
						"w": 440
					},
					{
						"n": 11,
						"h": 294,
						"w": 440
					}
				],
				"ball": {
					"n": 0,
					"h": 149,
					"w": 539,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 45
		},
		{
			"num": 229,
			"minute": 11,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 16
					},
					{
						"n": 2,
						"h": 120,
						"w": 267
					},
					{
						"n": 3,
						"h": 181,
						"w": 264
					},
					{
						"n": 4,
						"h": 270,
						"w": 266
					},
					{
						"n": 5,
						"h": 330,
						"w": 256
					},
					{
						"n": 6,
						"h": 41,
						"w": 360
					},
					{
						"n": 7,
						"h": 192,
						"w": 349
					},
					{
						"n": 8,
						"h": 257,
						"w": 353
					},
					{
						"n": 9,
						"h": 394,
						"w": 308
					},
					{
						"n": 10,
						"h": 155,
						"w": 417
					},
					{
						"n": 11,
						"h": 311,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 95
					},
					{
						"n": 2,
						"h": 47,
						"w": 188
					},
					{
						"n": 3,
						"h": 168,
						"w": 188
					},
					{
						"n": 4,
						"h": 286,
						"w": 213
					},
					{
						"n": 5,
						"h": 417,
						"w": 188
					},
					{
						"n": 6,
						"h": 216,
						"w": 251
					},
					{
						"n": 7,
						"h": 232,
						"w": 314
					},
					{
						"n": 8,
						"h": 408,
						"w": 314
					},
					{
						"n": 9,
						"h": 43,
						"w": 377
					},
					{
						"n": 10,
						"h": 162,
						"w": 440
					},
					{
						"n": 11,
						"h": 288,
						"w": 440
					}
				],
				"ball": {
					"n": 0,
					"h": 164,
					"w": 507,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 230,
			"minute": 11,
			"messages": [
				{
					"owner": 2,
					"mes": "Пас направо Т.Прохазке[25](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 17
					},
					{
						"n": 2,
						"h": 120,
						"w": 260
					},
					{
						"n": 3,
						"h": 164,
						"w": 269
					},
					{
						"n": 4,
						"h": 282,
						"w": 259
					},
					{
						"n": 5,
						"h": 330,
						"w": 251
					},
					{
						"n": 6,
						"h": 31,
						"w": 360
					},
					{
						"n": 7,
						"h": 163,
						"w": 343
					},
					{
						"n": 8,
						"h": 237,
						"w": 332
					},
					{
						"n": 9,
						"h": 394,
						"w": 306
					},
					{
						"n": 10,
						"h": 167,
						"w": 413
					},
					{
						"n": 11,
						"h": 293,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 94
					},
					{
						"n": 2,
						"h": 51,
						"w": 198
					},
					{
						"n": 3,
						"h": 157,
						"w": 198
					},
					{
						"n": 4,
						"h": 294,
						"w": 206,
						"m": 620
					},
					{
						"n": 5,
						"h": 399,
						"w": 199
					},
					{
						"n": 6,
						"h": 235,
						"w": 258
					},
					{
						"n": 7,
						"h": 221,
						"w": 319
					},
					{
						"n": 8,
						"h": 415,
						"w": 319
					},
					{
						"n": 9,
						"h": 46,
						"w": 379
					},
					{
						"n": 10,
						"h": 156,
						"w": 440
					},
					{
						"n": 11,
						"h": 297,
						"w": 440
					}
				],
				"ball": {
					"n": 0,
					"h": 51,
					"w": 521,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 38
		},
		{
			"num": 231,
			"minute": 11,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 14
					},
					{
						"n": 2,
						"h": 120,
						"w": 223
					},
					{
						"n": 3,
						"h": 180,
						"w": 234
					},
					{
						"n": 4,
						"h": 274,
						"w": 224
					},
					{
						"n": 5,
						"h": 330,
						"w": 223
					},
					{
						"n": 6,
						"h": 56,
						"w": 347
					},
					{
						"n": 7,
						"h": 174,
						"w": 305
					},
					{
						"n": 8,
						"h": 229,
						"w": 320
					},
					{
						"n": 9,
						"h": 394,
						"w": 302
					},
					{
						"n": 10,
						"h": 175,
						"w": 392
					},
					{
						"n": 11,
						"h": 300,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 102
					},
					{
						"n": 2,
						"h": 46,
						"w": 208
					},
					{
						"n": 3,
						"h": 150,
						"w": 208
					},
					{
						"n": 4,
						"h": 282,
						"w": 208
					},
					{
						"n": 5,
						"h": 384,
						"w": 231
					},
					{
						"n": 6,
						"h": 235,
						"w": 273
					},
					{
						"n": 7,
						"h": 219,
						"w": 338
					},
					{
						"n": 8,
						"h": 406,
						"w": 338
					},
					{
						"n": 9,
						"h": 38,
						"w": 403
					},
					{
						"n": 10,
						"h": 148,
						"w": 468
					},
					{
						"n": 11,
						"h": 283,
						"w": 468
					}
				],
				"ball": {
					"n": 0,
					"h": 66,
					"w": 489,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 232,
			"minute": 11,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 12
					},
					{
						"n": 2,
						"h": 120,
						"w": 193
					},
					{
						"n": 3,
						"h": 172,
						"w": 208
					},
					{
						"n": 4,
						"h": 271,
						"w": 201
					},
					{
						"n": 5,
						"h": 330,
						"w": 195
					},
					{
						"n": 6,
						"h": 67,
						"w": 400
					},
					{
						"n": 7,
						"h": 156,
						"w": 269
					},
					{
						"n": 8,
						"h": 239,
						"w": 281
					},
					{
						"n": 9,
						"h": 394,
						"w": 262
					},
					{
						"n": 10,
						"h": 179,
						"w": 400
					},
					{
						"n": 11,
						"h": 315,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 93
					},
					{
						"n": 2,
						"h": 59,
						"w": 217
					},
					{
						"n": 3,
						"h": 167,
						"w": 172
					},
					{
						"n": 4,
						"h": 271,
						"w": 173
					},
					{
						"n": 5,
						"h": 384,
						"w": 271
					},
					{
						"n": 6,
						"h": 258,
						"w": 291
					},
					{
						"n": 7,
						"h": 245,
						"w": 368
					},
					{
						"n": 8,
						"h": 402,
						"w": 378
					},
					{
						"n": 9,
						"h": 45,
						"w": 442
					},
					{
						"n": 10,
						"h": 162,
						"w": 482
					},
					{
						"n": 11,
						"h": 293,
						"w": 473
					}
				],
				"ball": {
					"n": 0,
					"h": 66,
					"w": 449,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 233,
			"minute": 11,
			"messages": [
				{
					"owner": 2,
					"mes": "Томаш Прохазка[25](Опава) играет налево на Н.Мансура[23](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 10
					},
					{
						"n": 2,
						"h": 92,
						"w": 246
					},
					{
						"n": 3,
						"h": 136,
						"w": 237
					},
					{
						"n": 4,
						"h": 266,
						"w": 256
					},
					{
						"n": 5,
						"h": 330,
						"w": 239
					},
					{
						"n": 6,
						"h": 38,
						"w": 347
					},
					{
						"n": 7,
						"h": 184,
						"w": 322
					},
					{
						"n": 8,
						"h": 296,
						"w": 299
					},
					{
						"n": 9,
						"h": 394,
						"w": 265
					},
					{
						"n": 10,
						"h": 138,
						"w": 436
					},
					{
						"n": 11,
						"h": 308,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 110
					},
					{
						"n": 2,
						"h": 65,
						"w": 257
					},
					{
						"n": 3,
						"h": 209,
						"w": 214
					},
					{
						"n": 4,
						"h": 279,
						"w": 226
					},
					{
						"n": 5,
						"h": 387,
						"w": 262
					},
					{
						"n": 6,
						"h": 232,
						"w": 284
					},
					{
						"n": 7,
						"h": 216,
						"w": 350
					},
					{
						"n": 8,
						"h": 396,
						"w": 437
					},
					{
						"n": 9,
						"h": 52,
						"w": 420
					},
					{
						"n": 10,
						"h": 152,
						"w": 434
					},
					{
						"n": 11,
						"h": 351,
						"w": 457
					}
				],
				"ball": {
					"n": 0,
					"h": 241,
					"w": 506,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 60
		},
		{
			"num": 234,
			"minute": 11,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 10
					},
					{
						"n": 2,
						"h": 79,
						"w": 216
					},
					{
						"n": 3,
						"h": 168,
						"w": 213
					},
					{
						"n": 4,
						"h": 270,
						"w": 216
					},
					{
						"n": 5,
						"h": 365,
						"w": 240
					},
					{
						"n": 6,
						"h": 45,
						"w": 308
					},
					{
						"n": 7,
						"h": 181,
						"w": 282
					},
					{
						"n": 8,
						"h": 300,
						"w": 259
					},
					{
						"n": 9,
						"h": 397,
						"w": 277
					},
					{
						"n": 10,
						"h": 142,
						"w": 400
					},
					{
						"n": 11,
						"h": 268,
						"w": 451
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 94
					},
					{
						"n": 2,
						"h": 75,
						"w": 253
					},
					{
						"n": 3,
						"h": 200,
						"w": 248
					},
					{
						"n": 4,
						"h": 271,
						"w": 202
					},
					{
						"n": 5,
						"h": 386,
						"w": 226
					},
					{
						"n": 6,
						"h": 262,
						"w": 264
					},
					{
						"n": 7,
						"h": 223,
						"w": 390
					},
					{
						"n": 8,
						"h": 417,
						"w": 457
					},
					{
						"n": 9,
						"h": 55,
						"w": 460
					},
					{
						"n": 10,
						"h": 156,
						"w": 474
					},
					{
						"n": 11,
						"h": 380,
						"w": 484
					}
				],
				"ball": {
					"n": 0,
					"h": 250,
					"w": 472,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 235,
			"minute": 11,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 10
					},
					{
						"n": 2,
						"h": 73,
						"w": 187
					},
					{
						"n": 3,
						"h": 187,
						"w": 179
					},
					{
						"n": 4,
						"h": 274,
						"w": 178
					},
					{
						"n": 5,
						"h": 377,
						"w": 203
					},
					{
						"n": 6,
						"h": 50,
						"w": 269
					},
					{
						"n": 7,
						"h": 196,
						"w": 246
					},
					{
						"n": 8,
						"h": 283,
						"w": 224
					},
					{
						"n": 9,
						"h": 394,
						"w": 258
					},
					{
						"n": 10,
						"h": 153,
						"w": 363
					},
					{
						"n": 11,
						"h": 254,
						"w": 418
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 109
					},
					{
						"n": 2,
						"h": 73,
						"w": 292
					},
					{
						"n": 3,
						"h": 196,
						"w": 282
					},
					{
						"n": 4,
						"h": 267,
						"w": 251
					},
					{
						"n": 5,
						"h": 383,
						"w": 265
					},
					{
						"n": 6,
						"h": 251,
						"w": 302
					},
					{
						"n": 7,
						"h": 227,
						"w": 428
					},
					{
						"n": 8,
						"h": 409,
						"w": 496
					},
					{
						"n": 9,
						"h": 43,
						"w": 497
					},
					{
						"n": 10,
						"h": 158,
						"w": 513
					},
					{
						"n": 11,
						"h": 407,
						"w": 513
					}
				],
				"ball": {
					"n": 0,
					"h": 254,
					"w": 438,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 236,
			"minute": 11,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 12
					},
					{
						"n": 2,
						"h": 92,
						"w": 152
					},
					{
						"n": 3,
						"h": 209,
						"w": 145
					},
					{
						"n": 4,
						"h": 275,
						"w": 138
					},
					{
						"n": 5,
						"h": 394,
						"w": 179
					},
					{
						"n": 6,
						"h": 53,
						"w": 229
					},
					{
						"n": 7,
						"h": 184,
						"w": 208
					},
					{
						"n": 8,
						"h": 275,
						"w": 198
					},
					{
						"n": 9,
						"h": 405,
						"w": 241
					},
					{
						"n": 10,
						"h": 167,
						"w": 325
					},
					{
						"n": 11,
						"h": 285,
						"w": 401
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 120
					},
					{
						"n": 2,
						"h": 76,
						"w": 309
					},
					{
						"n": 3,
						"h": 165,
						"w": 299
					},
					{
						"n": 4,
						"h": 266,
						"w": 280
					},
					{
						"n": 5,
						"h": 379,
						"w": 293
					},
					{
						"n": 6,
						"h": 229,
						"w": 335
					},
					{
						"n": 7,
						"h": 225,
						"w": 468
					},
					{
						"n": 8,
						"h": 414,
						"w": 516
					},
					{
						"n": 9,
						"h": 31,
						"w": 535
					},
					{
						"n": 10,
						"h": 148,
						"w": 551
					},
					{
						"n": 11,
						"h": 421,
						"w": 550
					}
				],
				"ball": {
					"n": 0,
					"h": 285,
					"w": 421,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 237,
			"minute": 11,
			"messages": [
				{
					"owner": 2,
					"mes": "Нир Мансур[23](Опава) пасует Л.Седлачеку[22](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 10
					},
					{
						"n": 2,
						"h": 120,
						"w": 158
					},
					{
						"n": 3,
						"h": 223,
						"w": 151
					},
					{
						"n": 4,
						"h": 282,
						"w": 153
					},
					{
						"n": 5,
						"h": 378,
						"w": 180
					},
					{
						"n": 6,
						"h": 61,
						"w": 189
					},
					{
						"n": 7,
						"h": 200,
						"w": 236
					},
					{
						"n": 8,
						"h": 288,
						"w": 227
					},
					{
						"n": 9,
						"h": 417,
						"w": 253
					},
					{
						"n": 10,
						"h": 174,
						"w": 365
					},
					{
						"n": 11,
						"h": 326,
						"w": 399
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 104
					},
					{
						"n": 2,
						"h": 84,
						"w": 303
					},
					{
						"n": 3,
						"h": 166,
						"w": 289
					},
					{
						"n": 4,
						"h": 270,
						"w": 239
					},
					{
						"n": 5,
						"h": 382,
						"w": 252
					},
					{
						"n": 6,
						"h": 192,
						"w": 348
					},
					{
						"n": 7,
						"h": 191,
						"w": 453
					},
					{
						"n": 8,
						"h": 399,
						"w": 530
					},
					{
						"n": 9,
						"h": 42,
						"w": 520
					},
					{
						"n": 10,
						"h": 172,
						"w": 527
					},
					{
						"n": 11,
						"h": 380,
						"w": 550
					}
				],
				"ball": {
					"n": 0,
					"h": 366,
					"w": 417,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 41
		},
		{
			"num": 238,
			"minute": 11,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 16
					},
					{
						"n": 2,
						"h": 120,
						"w": 119
					},
					{
						"n": 3,
						"h": 239,
						"w": 115
					},
					{
						"n": 4,
						"h": 284,
						"w": 114
					},
					{
						"n": 5,
						"h": 394,
						"w": 156
					},
					{
						"n": 6,
						"h": 56,
						"w": 164
					},
					{
						"n": 7,
						"h": 198,
						"w": 202
					},
					{
						"n": 8,
						"h": 270,
						"w": 192
					},
					{
						"n": 9,
						"h": 412,
						"w": 235
					},
					{
						"n": 10,
						"h": 178,
						"w": 400
					},
					{
						"n": 11,
						"h": 356,
						"w": 375
					}
				],
				"away": [
					{
						"n": 1,
						"h": 226,
						"w": 124
					},
					{
						"n": 2,
						"h": 80,
						"w": 337
					},
					{
						"n": 3,
						"h": 173,
						"w": 258
					},
					{
						"n": 4,
						"h": 272,
						"w": 276
					},
					{
						"n": 5,
						"h": 380,
						"w": 269
					},
					{
						"n": 6,
						"h": 194,
						"w": 387
					},
					{
						"n": 7,
						"h": 191,
						"w": 492
					},
					{
						"n": 8,
						"h": 406,
						"w": 568
					},
					{
						"n": 9,
						"h": 23,
						"w": 554
					},
					{
						"n": 10,
						"h": 146,
						"w": 556
					},
					{
						"n": 11,
						"h": 417,
						"w": 541
					}
				],
				"ball": {
					"n": 0,
					"h": 370,
					"w": 383,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 239,
			"minute": 11,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 15
					},
					{
						"n": 2,
						"h": 120,
						"w": 92
					},
					{
						"n": 3,
						"h": 237,
						"w": 92
					},
					{
						"n": 4,
						"h": 279,
						"w": 104
					},
					{
						"n": 5,
						"h": 394,
						"w": 150
					},
					{
						"n": 6,
						"h": 56,
						"w": 160
					},
					{
						"n": 7,
						"h": 221,
						"w": 191
					},
					{
						"n": 8,
						"h": 256,
						"w": 195
					},
					{
						"n": 9,
						"h": 416,
						"w": 215
					},
					{
						"n": 10,
						"h": 168,
						"w": 400
					},
					{
						"n": 11,
						"h": 380,
						"w": 343
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 118
					},
					{
						"n": 2,
						"h": 62,
						"w": 367
					},
					{
						"n": 3,
						"h": 183,
						"w": 267
					},
					{
						"n": 4,
						"h": 282,
						"w": 275
					},
					{
						"n": 5,
						"h": 375,
						"w": 259
					},
					{
						"n": 6,
						"h": 204,
						"w": 392
					},
					{
						"n": 7,
						"h": 189,
						"w": 516
					},
					{
						"n": 8,
						"h": 402,
						"w": 603
					},
					{
						"n": 9,
						"h": 18,
						"w": 563
					},
					{
						"n": 10,
						"h": 111,
						"w": 576
					},
					{
						"n": 11,
						"h": 425,
						"w": 525
					}
				],
				"ball": {
					"n": 0,
					"h": 388,
					"w": 353,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 240,
			"minute": 12,
			"possession": 40,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 12
					},
					{
						"n": 2,
						"h": 120,
						"w": 78
					},
					{
						"n": 3,
						"h": 240,
						"w": 86
					},
					{
						"n": 4,
						"h": 274,
						"w": 68
					},
					{
						"n": 5,
						"h": 394,
						"w": 122
					},
					{
						"n": 6,
						"h": 56,
						"w": 131
					},
					{
						"n": 7,
						"h": 209,
						"w": 153
					},
					{
						"n": 8,
						"h": 250,
						"w": 160
					},
					{
						"n": 9,
						"h": 404,
						"w": 177
					},
					{
						"n": 10,
						"h": 170,
						"w": 392
					},
					{
						"n": 11,
						"h": 408,
						"w": 313,
						"f": 96
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 119,
						"f": 95
					},
					{
						"n": 2,
						"h": 37,
						"w": 392,
						"f": 93
					},
					{
						"n": 3,
						"h": 165,
						"w": 288
					},
					{
						"n": 4,
						"h": 280,
						"w": 314
					},
					{
						"n": 5,
						"h": 376,
						"w": 292,
						"f": 95
					},
					{
						"n": 6,
						"h": 190,
						"w": 417
					},
					{
						"n": 7,
						"h": 193,
						"w": 556
					},
					{
						"n": 8,
						"h": 411,
						"w": 634
					},
					{
						"n": 9,
						"h": 32,
						"w": 590,
						"f": 95
					},
					{
						"n": 10,
						"h": 139,
						"w": 604
					},
					{
						"n": 11,
						"h": 397,
						"w": 554
					}
				],
				"ball": {
					"n": 0,
					"h": 413,
					"w": 328,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 241,
			"minute": 12,
			"messages": [
				{
					"owner": 2,
					"mes": "Лука Седлачек[22](Опава) отправляет мяч в центр..."
				},
				{
					"owner": 2,
					"mes": "Оливье Дюмон[26](Опава) принимает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 18
					},
					{
						"n": 2,
						"h": 65,
						"w": 81
					},
					{
						"n": 3,
						"h": 219,
						"w": 82
					},
					{
						"n": 4,
						"h": 278,
						"w": 82
					},
					{
						"n": 5,
						"h": 389,
						"w": 96
					},
					{
						"n": 6,
						"h": 56,
						"w": 165
					},
					{
						"n": 7,
						"h": 228,
						"w": 144
					},
					{
						"n": 8,
						"h": 261,
						"w": 214
					},
					{
						"n": 9,
						"h": 398,
						"w": 122
					},
					{
						"n": 10,
						"h": 183,
						"w": 392
					},
					{
						"n": 11,
						"h": 362,
						"w": 345
					}
				],
				"away": [
					{
						"n": 1,
						"h": 221,
						"w": 122
					},
					{
						"n": 2,
						"h": 42,
						"w": 383
					},
					{
						"n": 3,
						"h": 169,
						"w": 304
					},
					{
						"n": 4,
						"h": 267,
						"w": 298
					},
					{
						"n": 5,
						"h": 384,
						"w": 328
					},
					{
						"n": 6,
						"h": 184,
						"w": 469
					},
					{
						"n": 7,
						"h": 227,
						"w": 513
					},
					{
						"n": 8,
						"h": 403,
						"w": 622
					},
					{
						"n": 9,
						"h": 31,
						"w": 604
					},
					{
						"n": 10,
						"h": 149,
						"w": 632
					},
					{
						"n": 11,
						"h": 416,
						"w": 520
					}
				],
				"ball": {
					"n": 0,
					"h": 266,
					"w": 251,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 55
		},
		{
			"num": 242,
			"minute": 12,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 12
					},
					{
						"n": 2,
						"h": 105,
						"w": 75
					},
					{
						"n": 3,
						"h": 227,
						"w": 80
					},
					{
						"n": 4,
						"h": 268,
						"w": 80
					},
					{
						"n": 5,
						"h": 394,
						"w": 76
					},
					{
						"n": 6,
						"h": 56,
						"w": 167
					},
					{
						"n": 7,
						"h": 235,
						"w": 158
					},
					{
						"n": 8,
						"h": 289,
						"w": 209
					},
					{
						"n": 9,
						"h": 391,
						"w": 92
					},
					{
						"n": 10,
						"h": 179,
						"w": 392
					},
					{
						"n": 11,
						"h": 330,
						"w": 368
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 126
					},
					{
						"n": 2,
						"h": 57,
						"w": 356
					},
					{
						"n": 3,
						"h": 166,
						"w": 343
					},
					{
						"n": 4,
						"h": 271,
						"w": 337
					},
					{
						"n": 5,
						"h": 385,
						"w": 296
					},
					{
						"n": 6,
						"h": 159,
						"w": 493
					},
					{
						"n": 7,
						"h": 221,
						"w": 552
					},
					{
						"n": 8,
						"h": 401,
						"w": 638
					},
					{
						"n": 9,
						"h": 44,
						"w": 630
					},
					{
						"n": 10,
						"h": 169,
						"w": 630
					},
					{
						"n": 11,
						"h": 401,
						"w": 518
					}
				],
				"ball": {
					"n": 0,
					"h": 291,
					"w": 227,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 243,
			"minute": 12,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 13
					},
					{
						"n": 2,
						"h": 65,
						"w": 83
					},
					{
						"n": 3,
						"h": 217,
						"w": 84
					},
					{
						"n": 4,
						"h": 279,
						"w": 68
					},
					{
						"n": 5,
						"h": 394,
						"w": 72
					},
					{
						"n": 6,
						"h": 56,
						"w": 169
					},
					{
						"n": 7,
						"h": 220,
						"w": 140
					},
					{
						"n": 8,
						"h": 256,
						"w": 196
					},
					{
						"n": 9,
						"h": 398,
						"w": 131
					},
					{
						"n": 10,
						"h": 165,
						"w": 354
					},
					{
						"n": 11,
						"h": 321,
						"w": 400
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 123
					},
					{
						"n": 2,
						"h": 68,
						"w": 350
					},
					{
						"n": 3,
						"h": 163,
						"w": 383
					},
					{
						"n": 4,
						"h": 277,
						"w": 377
					},
					{
						"n": 5,
						"h": 380,
						"w": 296
					},
					{
						"n": 6,
						"h": 193,
						"w": 502
					},
					{
						"n": 7,
						"h": 230,
						"w": 591
					},
					{
						"n": 8,
						"h": 406,
						"w": 628
					},
					{
						"n": 9,
						"h": 48,
						"w": 634
					},
					{
						"n": 10,
						"h": 149,
						"w": 634
					},
					{
						"n": 11,
						"h": 420,
						"w": 516
					}
				],
				"ball": {
					"n": 0,
					"h": 257,
					"w": 218,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 244,
			"minute": 12,
			"messages": [
				{
					"owner": 2,
					"mes": "Острый пас в штрафную площадь..."
				},
				{
					"owner": 2,
					"mes": "Киран Нолан[08](Галвэй Юнайтед) оказывается первым на мяче..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 232,
						"w": 12
					},
					{
						"n": 2,
						"h": 71,
						"w": 80
					},
					{
						"n": 3,
						"h": 221,
						"w": 80
					},
					{
						"n": 4,
						"h": 284,
						"w": 71
					},
					{
						"n": 5,
						"h": 388,
						"w": 70
					},
					{
						"n": 6,
						"h": 56,
						"w": 163
					},
					{
						"n": 7,
						"h": 218,
						"w": 135
					},
					{
						"n": 8,
						"h": 260,
						"w": 200
					},
					{
						"n": 9,
						"h": 396,
						"w": 131
					},
					{
						"n": 10,
						"h": 167,
						"w": 360
					},
					{
						"n": 11,
						"h": 319,
						"w": 400
					}
				],
				"away": [
					{
						"n": 1,
						"h": 229,
						"w": 119
					},
					{
						"n": 2,
						"h": 74,
						"w": 352
					},
					{
						"n": 3,
						"h": 164,
						"w": 377
					},
					{
						"n": 4,
						"h": 277,
						"w": 371
					},
					{
						"n": 5,
						"h": 386,
						"w": 302
					},
					{
						"n": 6,
						"h": 193,
						"w": 502,
						"m": 610
					},
					{
						"n": 7,
						"h": 233,
						"w": 588
					},
					{
						"n": 8,
						"h": 402,
						"w": 633
					},
					{
						"n": 9,
						"h": 42,
						"w": 634
					},
					{
						"n": 10,
						"h": 151,
						"w": 630,
						"m": 590
					},
					{
						"n": 11,
						"h": 419,
						"w": 522
					}
				],
				"ball": {
					"n": 0,
					"h": 260,
					"w": 200,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 6
		},
		{
			"num": 245,
			"minute": 12,
			"messages": [
				{
					"owner": 1,
					"mes": "Киран Нолан[08](Галвэй Юнайтед) отдает передачу направо Э.Бвомоно[09](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 19
					},
					{
						"n": 2,
						"h": 73,
						"w": 132
					},
					{
						"n": 3,
						"h": 192,
						"w": 123
					},
					{
						"n": 4,
						"h": 281,
						"w": 123
					},
					{
						"n": 5,
						"h": 386,
						"w": 122
					},
					{
						"n": 6,
						"h": 56,
						"w": 215
					},
					{
						"n": 7,
						"h": 197,
						"w": 182
					},
					{
						"n": 8,
						"h": 262,
						"w": 209,
						"m": 600
					},
					{
						"n": 9,
						"h": 406,
						"w": 182
					},
					{
						"n": 10,
						"h": 165,
						"w": 412
					},
					{
						"n": 11,
						"h": 317,
						"w": 452
					}
				],
				"away": [
					{
						"n": 1,
						"h": 206,
						"w": 72
					},
					{
						"n": 2,
						"h": 72,
						"w": 404
					},
					{
						"n": 3,
						"h": 161,
						"w": 325
					},
					{
						"n": 4,
						"h": 275,
						"w": 319
					},
					{
						"n": 5,
						"h": 376,
						"w": 251
					},
					{
						"n": 6,
						"h": 188,
						"w": 455
					},
					{
						"n": 7,
						"h": 229,
						"w": 536
					},
					{
						"n": 8,
						"h": 405,
						"w": 581
					},
					{
						"n": 9,
						"h": 40,
						"w": 582
					},
					{
						"n": 10,
						"h": 164,
						"w": 579
					},
					{
						"n": 11,
						"h": 401,
						"w": 473
					}
				],
				"ball": {
					"n": 0,
					"h": 406,
					"w": 182,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 52
		},
		{
			"num": 246,
			"minute": 12,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 14
					},
					{
						"n": 2,
						"h": 75,
						"w": 172
					},
					{
						"n": 3,
						"h": 183,
						"w": 162
					},
					{
						"n": 4,
						"h": 271,
						"w": 162
					},
					{
						"n": 5,
						"h": 381,
						"w": 162
					},
					{
						"n": 6,
						"h": 52,
						"w": 255
					},
					{
						"n": 7,
						"h": 196,
						"w": 222
					},
					{
						"n": 8,
						"h": 278,
						"w": 246
					},
					{
						"n": 9,
						"h": 417,
						"w": 215
					},
					{
						"n": 10,
						"h": 160,
						"w": 451
					},
					{
						"n": 11,
						"h": 316,
						"w": 492
					}
				],
				"away": [
					{
						"n": 1,
						"h": 205,
						"w": 72
					},
					{
						"n": 2,
						"h": 66,
						"w": 443
					},
					{
						"n": 3,
						"h": 162,
						"w": 285
					},
					{
						"n": 4,
						"h": 272,
						"w": 279
					},
					{
						"n": 5,
						"h": 368,
						"w": 211
					},
					{
						"n": 6,
						"h": 183,
						"w": 415
					},
					{
						"n": 7,
						"h": 226,
						"w": 496
					},
					{
						"n": 8,
						"h": 407,
						"w": 541
					},
					{
						"n": 9,
						"h": 38,
						"w": 542
					},
					{
						"n": 10,
						"h": 167,
						"w": 539
					},
					{
						"n": 11,
						"h": 361,
						"w": 474
					}
				],
				"ball": {
					"n": 0,
					"h": 417,
					"w": 215,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 247,
			"minute": 12,
			"messages": [
				{
					"owner": 1,
					"mes": "Пасует вперед..."
				},
				{
					"owner": 1,
					"mes": "Адам Гилберт[11](Галвэй Юнайтед) подрабатывает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 11
					},
					{
						"n": 2,
						"h": 66,
						"w": 254
					},
					{
						"n": 3,
						"h": 172,
						"w": 244
					},
					{
						"n": 4,
						"h": 277,
						"w": 234
					},
					{
						"n": 5,
						"h": 382,
						"w": 245
					},
					{
						"n": 6,
						"h": 54,
						"w": 338
					},
					{
						"n": 7,
						"h": 197,
						"w": 305
					},
					{
						"n": 8,
						"h": 289,
						"w": 328
					},
					{
						"n": 9,
						"h": 416,
						"w": 238
					},
					{
						"n": 10,
						"h": 158,
						"w": 534
					},
					{
						"n": 11,
						"h": 368,
						"w": 544
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 38
					},
					{
						"n": 2,
						"h": 73,
						"w": 361
					},
					{
						"n": 3,
						"h": 162,
						"w": 202
					},
					{
						"n": 4,
						"h": 268,
						"w": 196
					},
					{
						"n": 5,
						"h": 354,
						"w": 130
					},
					{
						"n": 6,
						"h": 173,
						"w": 333
					},
					{
						"n": 7,
						"h": 218,
						"w": 414
					},
					{
						"n": 8,
						"h": 405,
						"w": 499
					},
					{
						"n": 9,
						"h": 36,
						"w": 479
					},
					{
						"n": 10,
						"h": 164,
						"w": 456
					},
					{
						"n": 11,
						"h": 295,
						"w": 425
					}
				],
				"ball": {
					"n": 0,
					"h": 368,
					"w": 544,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 83
		},
		{
			"num": 248,
			"minute": 12,
			"messages": [
				{
					"owner": 1,
					"mes": "Адам Гилберт[11](Галвэй Юнайтед) уходит в центр..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 11
					},
					{
						"n": 2,
						"h": 70,
						"w": 294
					},
					{
						"n": 3,
						"h": 174,
						"w": 284
					},
					{
						"n": 4,
						"h": 271,
						"w": 273
					},
					{
						"n": 5,
						"h": 380,
						"w": 285
					},
					{
						"n": 6,
						"h": 55,
						"w": 378
					},
					{
						"n": 7,
						"h": 199,
						"w": 345
					},
					{
						"n": 8,
						"h": 294,
						"w": 368
					},
					{
						"n": 9,
						"h": 416,
						"w": 278
					},
					{
						"n": 10,
						"h": 160,
						"w": 574
					},
					{
						"n": 11,
						"h": 333,
						"w": 578,
						"m": 660
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 30
					},
					{
						"n": 2,
						"h": 73,
						"w": 321
					},
					{
						"n": 3,
						"h": 161,
						"w": 158
					},
					{
						"n": 4,
						"h": 237,
						"w": 159
					},
					{
						"n": 5,
						"h": 329,
						"w": 98
					},
					{
						"n": 6,
						"h": 195,
						"w": 288
					},
					{
						"n": 7,
						"h": 217,
						"w": 374
					},
					{
						"n": 8,
						"h": 406,
						"w": 479
					},
					{
						"n": 9,
						"h": 37,
						"w": 439
					},
					{
						"n": 10,
						"h": 161,
						"w": 416
					},
					{
						"n": 11,
						"h": 273,
						"w": 391
					}
				],
				"ball": {
					"n": 0,
					"h": 333,
					"w": 578,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 249,
			"minute": 12,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 17
					},
					{
						"n": 2,
						"h": 72,
						"w": 334
					},
					{
						"n": 3,
						"h": 166,
						"w": 314
					},
					{
						"n": 4,
						"h": 267,
						"w": 313
					},
					{
						"n": 5,
						"h": 384,
						"w": 325
					},
					{
						"n": 6,
						"h": 52,
						"w": 418
					},
					{
						"n": 7,
						"h": 188,
						"w": 384
					},
					{
						"n": 8,
						"h": 291,
						"w": 408
					},
					{
						"n": 9,
						"h": 415,
						"w": 318
					},
					{
						"n": 10,
						"h": 167,
						"w": 613
					},
					{
						"n": 11,
						"h": 308,
						"w": 620
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 12
					},
					{
						"n": 2,
						"h": 75,
						"w": 281
					},
					{
						"n": 3,
						"h": 157,
						"w": 114
					},
					{
						"n": 4,
						"h": 252,
						"w": 113
					},
					{
						"n": 5,
						"h": 292,
						"w": 83
					},
					{
						"n": 6,
						"h": 215,
						"w": 242
					},
					{
						"n": 7,
						"h": 219,
						"w": 334
					},
					{
						"n": 8,
						"h": 405,
						"w": 459
					},
					{
						"n": 9,
						"h": 34,
						"w": 399
					},
					{
						"n": 10,
						"h": 161,
						"w": 376
					},
					{
						"n": 11,
						"h": 267,
						"w": 351
					}
				],
				"ball": {
					"n": 0,
					"h": 308,
					"w": 620,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 250,
			"minute": 12,
			"messages": [
				{
					"owner": 1,
					"mes": "Адам Гилберт[11](Галвэй Юнайтед) врывается в штрафную..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 18
					},
					{
						"n": 2,
						"h": 78,
						"w": 371
					},
					{
						"n": 3,
						"h": 169,
						"w": 320
					},
					{
						"n": 4,
						"h": 272,
						"w": 318
					},
					{
						"n": 5,
						"h": 380,
						"w": 364
					},
					{
						"n": 6,
						"h": 53,
						"w": 458
					},
					{
						"n": 7,
						"h": 177,
						"w": 422
					},
					{
						"n": 8,
						"h": 289,
						"w": 448
					},
					{
						"n": 9,
						"h": 415,
						"w": 358
					},
					{
						"n": 10,
						"h": 173,
						"w": 653
					},
					{
						"n": 11,
						"h": 267,
						"w": 646
					}
				],
				"away": [
					{
						"n": 1,
						"h": 218,
						"w": 13
					},
					{
						"n": 2,
						"h": 76,
						"w": 241
					},
					{
						"n": 3,
						"h": 181,
						"w": 77
					},
					{
						"n": 4,
						"h": 216,
						"w": 80
					},
					{
						"n": 5,
						"h": 267,
						"w": 47
					},
					{
						"n": 6,
						"h": 217,
						"w": 193
					},
					{
						"n": 7,
						"h": 219,
						"w": 294
					},
					{
						"n": 8,
						"h": 404,
						"w": 419
					},
					{
						"n": 9,
						"h": 34,
						"w": 359
					},
					{
						"n": 10,
						"h": 161,
						"w": 336
					},
					{
						"n": 11,
						"h": 270,
						"w": 312
					}
				],
				"ball": {
					"n": 0,
					"h": 267,
					"w": 646,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 251,
			"minute": 12,
			"messages": [
				{
					"owner": 1,
					"mes": "Адам Гилберт[11](Галвэй Юнайтед) решает пробить низом..."
				},
				{
					"owner": 1,
					"mes": "Крыштоф Ласак[21](Опава) отбивает мяч..."
				}
			],
			"U": {
				"team": 1,
				"player": 11,
				"xg": "0.18"
			},
			"V": {
				"team": 1,
				"player": 11
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 19
					},
					{
						"n": 2,
						"h": 74,
						"w": 369
					},
					{
						"n": 3,
						"h": 173,
						"w": 312
					},
					{
						"n": 4,
						"h": 270,
						"w": 330
					},
					{
						"n": 5,
						"h": 392,
						"w": 363
					},
					{
						"n": 6,
						"h": 54,
						"w": 472
					},
					{
						"n": 7,
						"h": 175,
						"w": 436
					},
					{
						"n": 8,
						"h": 289,
						"w": 462
					},
					{
						"n": 9,
						"h": 414,
						"w": 372
					},
					{
						"n": 10,
						"h": 174,
						"w": 667
					},
					{
						"n": 11,
						"h": 267,
						"w": 646,
						"m": 670
					}
				],
				"away": [
					{
						"n": 1,
						"h": 214,
						"w": 13,
						"m": 580
					},
					{
						"n": 2,
						"h": 76,
						"w": 227
					},
					{
						"n": 3,
						"h": 186,
						"w": 70
					},
					{
						"n": 4,
						"h": 204,
						"w": 68
					},
					{
						"n": 5,
						"h": 251,
						"w": 50
					},
					{
						"n": 6,
						"h": 218,
						"w": 175
					},
					{
						"n": 7,
						"h": 220,
						"w": 280
					},
					{
						"n": 8,
						"h": 403,
						"w": 405
					},
					{
						"n": 9,
						"h": 35,
						"w": 345
					},
					{
						"n": 10,
						"h": 161,
						"w": 322
					},
					{
						"n": 11,
						"h": 272,
						"w": 298
					}
				],
				"ball": {
					"n": 0,
					"h": 236,
					"w": 707,
					"z": 0,
					"r": 0,
					"p": 1,
					"x": 6
				}
			},
			"interval": 14
		},
		{
			"num": 252,
			"minute": 12,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 17
					},
					{
						"n": 2,
						"h": 81,
						"w": 377
					},
					{
						"n": 3,
						"h": 166,
						"w": 321
					},
					{
						"n": 4,
						"h": 274,
						"w": 323
					},
					{
						"n": 5,
						"h": 384,
						"w": 358
					},
					{
						"n": 6,
						"h": 49,
						"w": 469
					},
					{
						"n": 7,
						"h": 171,
						"w": 444
					},
					{
						"n": 8,
						"h": 293,
						"w": 466
					},
					{
						"n": 9,
						"h": 410,
						"w": 376
					},
					{
						"n": 10,
						"h": 175,
						"w": 691
					},
					{
						"n": 11,
						"h": 267,
						"w": 646
					}
				],
				"away": [
					{
						"n": 1,
						"h": 214,
						"w": 13
					},
					{
						"n": 2,
						"h": 76,
						"w": 217
					},
					{
						"n": 3,
						"h": 181,
						"w": 66
					},
					{
						"n": 4,
						"h": 211,
						"w": 48
					},
					{
						"n": 5,
						"h": 230,
						"w": 57
					},
					{
						"n": 6,
						"h": 223,
						"w": 173
					},
					{
						"n": 7,
						"h": 215,
						"w": 272
					},
					{
						"n": 8,
						"h": 403,
						"w": 387
					},
					{
						"n": 9,
						"h": 32,
						"w": 345
					},
					{
						"n": 10,
						"h": 161,
						"w": 304
					},
					{
						"n": 11,
						"h": 277,
						"w": 280
					}
				],
				"ball": {
					"n": 0,
					"h": 239,
					"w": 672,
					"z": 0,
					"r": 0,
					"p": 1,
					"x": 5
				}
			},
			"interval": 18
		},
		{
			"num": 253,
			"minute": 12,
			"messages": [
				{
					"owner": 1,
					"mes": "Себастьян Пейша[24](Опава) выносит мяч подальше от ворот..."
				},
				{
					"owner": 2,
					"mes": "Мяч подбирает Л.Седлачек[22](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 19
					},
					{
						"n": 2,
						"h": 72,
						"w": 376
					},
					{
						"n": 3,
						"h": 182,
						"w": 314
					},
					{
						"n": 4,
						"h": 269,
						"w": 311
					},
					{
						"n": 5,
						"h": 392,
						"w": 367
					},
					{
						"n": 6,
						"h": 53,
						"w": 532
					},
					{
						"n": 7,
						"h": 204,
						"w": 443
					},
					{
						"n": 8,
						"h": 290,
						"w": 458
					},
					{
						"n": 9,
						"h": 415,
						"w": 447
					},
					{
						"n": 10,
						"h": 179,
						"w": 680
					},
					{
						"n": 11,
						"h": 267,
						"w": 646
					}
				],
				"away": [
					{
						"n": 1,
						"h": 214,
						"w": 13
					},
					{
						"n": 2,
						"h": 31,
						"w": 226
					},
					{
						"n": 3,
						"h": 198,
						"w": 55
					},
					{
						"n": 4,
						"h": 211,
						"w": 48,
						"m": 630
					},
					{
						"n": 5,
						"h": 271,
						"w": 32
					},
					{
						"n": 6,
						"h": 177,
						"w": 131
					},
					{
						"n": 7,
						"h": 211,
						"w": 209
					},
					{
						"n": 8,
						"h": 401,
						"w": 324
					},
					{
						"n": 9,
						"h": 35,
						"w": 282
					},
					{
						"n": 10,
						"h": 160,
						"w": 242
					},
					{
						"n": 11,
						"h": 246,
						"w": 257
					}
				],
				"ball": {
					"n": 0,
					"h": 419,
					"w": 494,
					"z": 1,
					"r": 0,
					"p": 4,
					"x": 0
				}
			},
			"interval": 63
		},
		{
			"num": 254,
			"minute": 12,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 15
					},
					{
						"n": 2,
						"h": 76,
						"w": 336
					},
					{
						"n": 3,
						"h": 187,
						"w": 274
					},
					{
						"n": 4,
						"h": 271,
						"w": 271
					},
					{
						"n": 5,
						"h": 387,
						"w": 327
					},
					{
						"n": 6,
						"h": 54,
						"w": 492
					},
					{
						"n": 7,
						"h": 205,
						"w": 403
					},
					{
						"n": 8,
						"h": 289,
						"w": 418
					},
					{
						"n": 9,
						"h": 394,
						"w": 448
					},
					{
						"n": 10,
						"h": 184,
						"w": 640
					},
					{
						"n": 11,
						"h": 278,
						"w": 607
					}
				],
				"away": [
					{
						"n": 1,
						"h": 228,
						"w": 15,
						"m": 590
					},
					{
						"n": 2,
						"h": 13,
						"w": 257
					},
					{
						"n": 3,
						"h": 187,
						"w": 72
					},
					{
						"n": 4,
						"h": 238,
						"w": 77
					},
					{
						"n": 5,
						"h": 301,
						"w": 59
					},
					{
						"n": 6,
						"h": 187,
						"w": 169
					},
					{
						"n": 7,
						"h": 209,
						"w": 249
					},
					{
						"n": 8,
						"h": 403,
						"w": 285
					},
					{
						"n": 9,
						"h": 57,
						"w": 316
					},
					{
						"n": 10,
						"h": 159,
						"w": 282
					},
					{
						"n": 11,
						"h": 244,
						"w": 297
					}
				],
				"ball": {
					"n": 0,
					"h": 437,
					"w": 463,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 255,
			"minute": 12,
			"messages": [
				{
					"owner": 2,
					"mes": "Л.Седлачек[22](Опава) делает передачу М.Юрасеку[29](Опава)..."
				},
				{
					"owner": 2,
					"mes": "Элвис Бвомоно[09](Галвэй Юнайтед) неплохо выбирает позицию и перехватывает мяч!..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 11
					},
					{
						"n": 2,
						"h": 77,
						"w": 320
					},
					{
						"n": 3,
						"h": 188,
						"w": 258
					},
					{
						"n": 4,
						"h": 268,
						"w": 255
					},
					{
						"n": 5,
						"h": 383,
						"w": 343
					},
					{
						"n": 6,
						"h": 54,
						"w": 476
					},
					{
						"n": 7,
						"h": 205,
						"w": 387
					},
					{
						"n": 8,
						"h": 289,
						"w": 402
					},
					{
						"n": 9,
						"h": 410,
						"w": 446
					},
					{
						"n": 10,
						"h": 185,
						"w": 624
					},
					{
						"n": 11,
						"h": 276,
						"w": 591
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 13
					},
					{
						"n": 2,
						"h": 16,
						"w": 252,
						"m": 600
					},
					{
						"n": 3,
						"h": 185,
						"w": 88
					},
					{
						"n": 4,
						"h": 246,
						"w": 91
					},
					{
						"n": 5,
						"h": 312,
						"w": 71
					},
					{
						"n": 6,
						"h": 191,
						"w": 185
					},
					{
						"n": 7,
						"h": 208,
						"w": 265
					},
					{
						"n": 8,
						"h": 402,
						"w": 301
					},
					{
						"n": 9,
						"h": 51,
						"w": 303
					},
					{
						"n": 10,
						"h": 159,
						"w": 298
					},
					{
						"n": 11,
						"h": 243,
						"w": 313
					}
				],
				"ball": {
					"n": 0,
					"h": 410,
					"w": 446,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 16
		},
		{
			"num": 256,
			"minute": 12,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 19
					},
					{
						"n": 2,
						"h": 72,
						"w": 360
					},
					{
						"n": 3,
						"h": 177,
						"w": 297
					},
					{
						"n": 4,
						"h": 270,
						"w": 295
					},
					{
						"n": 5,
						"h": 384,
						"w": 379
					},
					{
						"n": 6,
						"h": 43,
						"w": 514
					},
					{
						"n": 7,
						"h": 183,
						"w": 378
					},
					{
						"n": 8,
						"h": 326,
						"w": 416
					},
					{
						"n": 9,
						"h": 382,
						"w": 474,
						"m": 610
					},
					{
						"n": 10,
						"h": 157,
						"w": 618
					},
					{
						"n": 11,
						"h": 288,
						"w": 629
					}
				],
				"away": [
					{
						"n": 1,
						"h": 228,
						"w": 14
					},
					{
						"n": 2,
						"h": 60,
						"w": 233
					},
					{
						"n": 3,
						"h": 179,
						"w": 76
					},
					{
						"n": 4,
						"h": 280,
						"w": 72
					},
					{
						"n": 5,
						"h": 340,
						"w": 66
					},
					{
						"n": 6,
						"h": 224,
						"w": 161
					},
					{
						"n": 7,
						"h": 209,
						"w": 225
					},
					{
						"n": 8,
						"h": 404,
						"w": 261
					},
					{
						"n": 9,
						"h": 62,
						"w": 265
					},
					{
						"n": 10,
						"h": 124,
						"w": 284
					},
					{
						"n": 11,
						"h": 231,
						"w": 275
					}
				],
				"ball": {
					"n": 0,
					"h": 382,
					"w": 474,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 257,
			"minute": 12,
			"messages": [
				{
					"owner": 1,
					"mes": "Игра накоротке..."
				},
				{
					"owner": 1,
					"mes": "Киран Нолан[08](Галвэй Юнайтед) подрабатывает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 15
					},
					{
						"n": 2,
						"h": 67,
						"w": 371
					},
					{
						"n": 3,
						"h": 182,
						"w": 318
					},
					{
						"n": 4,
						"h": 266,
						"w": 319
					},
					{
						"n": 5,
						"h": 392,
						"w": 366
					},
					{
						"n": 6,
						"h": 47,
						"w": 538
					},
					{
						"n": 7,
						"h": 179,
						"w": 402
					},
					{
						"n": 8,
						"h": 345,
						"w": 442
					},
					{
						"n": 9,
						"h": 382,
						"w": 474,
						"m": 620
					},
					{
						"n": 10,
						"h": 172,
						"w": 624
					},
					{
						"n": 11,
						"h": 277,
						"w": 634
					}
				],
				"away": [
					{
						"n": 1,
						"h": 221,
						"w": 14
					},
					{
						"n": 2,
						"h": 76,
						"w": 226
					},
					{
						"n": 3,
						"h": 187,
						"w": 74
					},
					{
						"n": 4,
						"h": 267,
						"w": 80
					},
					{
						"n": 5,
						"h": 340,
						"w": 70
					},
					{
						"n": 6,
						"h": 239,
						"w": 143
					},
					{
						"n": 7,
						"h": 196,
						"w": 205
					},
					{
						"n": 8,
						"h": 403,
						"w": 237
					},
					{
						"n": 9,
						"h": 60,
						"w": 261
					},
					{
						"n": 10,
						"h": 117,
						"w": 274
					},
					{
						"n": 11,
						"h": 252,
						"w": 287
					}
				],
				"ball": {
					"n": 0,
					"h": 345,
					"w": 442,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 24
		},
		{
			"num": 258,
			"minute": 12,
			"messages": [
				{
					"owner": 1,
					"mes": "Пас в штрафную..."
				},
				{
					"owner": 1,
					"mes": "Адам Гилберт[11](Галвэй Юнайтед) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 17
					},
					{
						"n": 2,
						"h": 71,
						"w": 361
					},
					{
						"n": 3,
						"h": 176,
						"w": 310
					},
					{
						"n": 4,
						"h": 267,
						"w": 313
					},
					{
						"n": 5,
						"h": 384,
						"w": 362
					},
					{
						"n": 6,
						"h": 43,
						"w": 589
					},
					{
						"n": 7,
						"h": 171,
						"w": 452
					},
					{
						"n": 8,
						"h": 342,
						"w": 451
					},
					{
						"n": 9,
						"h": 389,
						"w": 524
					},
					{
						"n": 10,
						"h": 217,
						"w": 648
					},
					{
						"n": 11,
						"h": 326,
						"w": 646
					}
				],
				"away": [
					{
						"n": 1,
						"h": 213,
						"w": 9
					},
					{
						"n": 2,
						"h": 76,
						"w": 175
					},
					{
						"n": 3,
						"h": 139,
						"w": 61
					},
					{
						"n": 4,
						"h": 238,
						"w": 60
					},
					{
						"n": 5,
						"h": 340,
						"w": 52
					},
					{
						"n": 6,
						"h": 202,
						"w": 109
					},
					{
						"n": 7,
						"h": 228,
						"w": 175
					},
					{
						"n": 8,
						"h": 416,
						"w": 187
					},
					{
						"n": 9,
						"h": 49,
						"w": 232
					},
					{
						"n": 10,
						"h": 108,
						"w": 249
					},
					{
						"n": 11,
						"h": 279,
						"w": 248
					}
				],
				"ball": {
					"n": 0,
					"h": 326,
					"w": 646,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 51
		},
		{
			"num": 259,
			"minute": 12,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 18
					},
					{
						"n": 2,
						"h": 62,
						"w": 370
					},
					{
						"n": 3,
						"h": 182,
						"w": 322
					},
					{
						"n": 4,
						"h": 267,
						"w": 328
					},
					{
						"n": 5,
						"h": 387,
						"w": 377
					},
					{
						"n": 6,
						"h": 48,
						"w": 603
					},
					{
						"n": 7,
						"h": 171,
						"w": 467
					},
					{
						"n": 8,
						"h": 328,
						"w": 446
					},
					{
						"n": 9,
						"h": 391,
						"w": 539
					},
					{
						"n": 10,
						"h": 217,
						"w": 645
					},
					{
						"n": 11,
						"h": 326,
						"w": 659
					}
				],
				"away": [
					{
						"n": 1,
						"h": 212,
						"w": 8
					},
					{
						"n": 2,
						"h": 76,
						"w": 160
					},
					{
						"n": 3,
						"h": 124,
						"w": 61
					},
					{
						"n": 4,
						"h": 228,
						"w": 48
					},
					{
						"n": 5,
						"h": 340,
						"w": 37
					},
					{
						"n": 6,
						"h": 215,
						"w": 95
					},
					{
						"n": 7,
						"h": 226,
						"w": 167
					},
					{
						"n": 8,
						"h": 414,
						"w": 172
					},
					{
						"n": 9,
						"h": 49,
						"w": 232
					},
					{
						"n": 10,
						"h": 122,
						"w": 254
					},
					{
						"n": 11,
						"h": 279,
						"w": 233
					}
				],
				"ball": {
					"n": 0,
					"h": 326,
					"w": 659,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 15
		},
		{
			"num": 260,
			"minute": 12,
			"messages": [
				{
					"owner": 1,
					"mes": "А.Гилберт[11](Галвэй Юнайтед) пытается обыграть Н.Мансура[23](Опава)..."
				},
				{
					"owner": 1,
					"mes": "Нир Мансур[23](Опава) отбирает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 18
					},
					{
						"n": 2,
						"h": 62,
						"w": 370
					},
					{
						"n": 3,
						"h": 182,
						"w": 322
					},
					{
						"n": 4,
						"h": 267,
						"w": 328
					},
					{
						"n": 5,
						"h": 388,
						"w": 380
					},
					{
						"n": 6,
						"h": 52,
						"w": 612
					},
					{
						"n": 7,
						"h": 171,
						"w": 477
					},
					{
						"n": 8,
						"h": 319,
						"w": 442
					},
					{
						"n": 9,
						"h": 392,
						"w": 549
					},
					{
						"n": 10,
						"h": 217,
						"w": 645
					},
					{
						"n": 11,
						"h": 326,
						"w": 669,
						"m": 660
					}
				],
				"away": [
					{
						"n": 1,
						"h": 212,
						"w": 8
					},
					{
						"n": 2,
						"h": 76,
						"w": 150
					},
					{
						"n": 3,
						"h": 114,
						"w": 61,
						"m": 610
					},
					{
						"n": 4,
						"h": 228,
						"w": 48
					},
					{
						"n": 5,
						"h": 340,
						"w": 30
					},
					{
						"n": 6,
						"h": 223,
						"w": 86
					},
					{
						"n": 7,
						"h": 226,
						"w": 167
					},
					{
						"n": 8,
						"h": 413,
						"w": 162
					},
					{
						"n": 9,
						"h": 47,
						"w": 228
					},
					{
						"n": 10,
						"h": 122,
						"w": 254
					},
					{
						"n": 11,
						"h": 279,
						"w": 233
					}
				],
				"ball": {
					"n": 0,
					"h": 336,
					"w": 659,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 4
				}
			},
			"interval": 10
		},
		{
			"num": 261,
			"minute": 13,
			"possession": 43,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 10
					},
					{
						"n": 2,
						"h": 70,
						"w": 331
					},
					{
						"n": 3,
						"h": 189,
						"w": 283
					},
					{
						"n": 4,
						"h": 274,
						"w": 289
					},
					{
						"n": 5,
						"h": 385,
						"w": 340
					},
					{
						"n": 6,
						"h": 53,
						"w": 572
					},
					{
						"n": 7,
						"h": 172,
						"w": 437
					},
					{
						"n": 8,
						"h": 320,
						"w": 402,
						"f": 95
					},
					{
						"n": 9,
						"h": 394,
						"w": 509,
						"f": 95
					},
					{
						"n": 10,
						"h": 214,
						"w": 605,
						"f": 95
					},
					{
						"n": 11,
						"h": 324,
						"w": 659
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 13
					},
					{
						"n": 2,
						"h": 73,
						"w": 150
					},
					{
						"n": 3,
						"h": 138,
						"w": 86,
						"m": 620
					},
					{
						"n": 4,
						"h": 251,
						"w": 81
					},
					{
						"n": 5,
						"h": 354,
						"w": 68
					},
					{
						"n": 6,
						"h": 221,
						"w": 126,
						"f": 95
					},
					{
						"n": 7,
						"h": 228,
						"w": 207
					},
					{
						"n": 8,
						"h": 413,
						"w": 202,
						"f": 94
					},
					{
						"n": 9,
						"h": 48,
						"w": 268
					},
					{
						"n": 10,
						"h": 125,
						"w": 294
					},
					{
						"n": 11,
						"h": 319,
						"w": 235
					}
				],
				"ball": {
					"n": 0,
					"h": 312,
					"w": 634,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 262,
			"minute": 13,
			"messages": [
				{
					"owner": 2,
					"mes": "Пас вперед..."
				},
				{
					"owner": 2,
					"mes": "Мирослав Манолов[27](Опава) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 18
					},
					{
						"n": 2,
						"h": 78,
						"w": 290
					},
					{
						"n": 3,
						"h": 195,
						"w": 241
					},
					{
						"n": 4,
						"h": 281,
						"w": 247
					},
					{
						"n": 5,
						"h": 381,
						"w": 298
					},
					{
						"n": 6,
						"h": 50,
						"w": 530
					},
					{
						"n": 7,
						"h": 202,
						"w": 467
					},
					{
						"n": 8,
						"h": 319,
						"w": 360
					},
					{
						"n": 9,
						"h": 394,
						"w": 467
					},
					{
						"n": 10,
						"h": 208,
						"w": 564
					},
					{
						"n": 11,
						"h": 321,
						"w": 617
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 19
					},
					{
						"n": 2,
						"h": 64,
						"w": 189
					},
					{
						"n": 3,
						"h": 143,
						"w": 95
					},
					{
						"n": 4,
						"h": 267,
						"w": 119
					},
					{
						"n": 5,
						"h": 365,
						"w": 108
					},
					{
						"n": 6,
						"h": 234,
						"w": 166
					},
					{
						"n": 7,
						"h": 208,
						"w": 190
					},
					{
						"n": 8,
						"h": 410,
						"w": 244
					},
					{
						"n": 9,
						"h": 40,
						"w": 308
					},
					{
						"n": 10,
						"h": 129,
						"w": 336
					},
					{
						"n": 11,
						"h": 355,
						"w": 257
					}
				],
				"ball": {
					"n": 0,
					"h": 242,
					"w": 530,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 42
		},
		{
			"num": 263,
			"minute": 13,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 18
					},
					{
						"n": 2,
						"h": 85,
						"w": 250
					},
					{
						"n": 3,
						"h": 200,
						"w": 201
					},
					{
						"n": 4,
						"h": 289,
						"w": 208
					},
					{
						"n": 5,
						"h": 379,
						"w": 258
					},
					{
						"n": 6,
						"h": 50,
						"w": 490
					},
					{
						"n": 7,
						"h": 201,
						"w": 427
					},
					{
						"n": 8,
						"h": 319,
						"w": 320
					},
					{
						"n": 9,
						"h": 394,
						"w": 427
					},
					{
						"n": 10,
						"h": 192,
						"w": 527
					},
					{
						"n": 11,
						"h": 320,
						"w": 577
					}
				],
				"away": [
					{
						"n": 1,
						"h": 228,
						"w": 17
					},
					{
						"n": 2,
						"h": 57,
						"w": 219
					},
					{
						"n": 3,
						"h": 160,
						"w": 131
					},
					{
						"n": 4,
						"h": 272,
						"w": 139
					},
					{
						"n": 5,
						"h": 371,
						"w": 148
					},
					{
						"n": 6,
						"h": 241,
						"w": 206
					},
					{
						"n": 7,
						"h": 203,
						"w": 225
					},
					{
						"n": 8,
						"h": 411,
						"w": 284
					},
					{
						"n": 9,
						"h": 57,
						"w": 339
					},
					{
						"n": 10,
						"h": 131,
						"w": 376
					},
					{
						"n": 11,
						"h": 364,
						"w": 295
					}
				],
				"ball": {
					"n": 0,
					"h": 247,
					"w": 495,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 264,
			"minute": 13,
			"messages": [
				{
					"owner": 2,
					"mes": "Мирослав Манолов[27](Опава) пасует Л.Седлачеку[22](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 17
					},
					{
						"n": 2,
						"h": 93,
						"w": 211
					},
					{
						"n": 3,
						"h": 206,
						"w": 162
					},
					{
						"n": 4,
						"h": 297,
						"w": 169
					},
					{
						"n": 5,
						"h": 377,
						"w": 218
					},
					{
						"n": 6,
						"h": 56,
						"w": 451
					},
					{
						"n": 7,
						"h": 202,
						"w": 387
					},
					{
						"n": 8,
						"h": 316,
						"w": 280
					},
					{
						"n": 9,
						"h": 394,
						"w": 387
					},
					{
						"n": 10,
						"h": 188,
						"w": 487
					},
					{
						"n": 11,
						"h": 300,
						"w": 543
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 38
					},
					{
						"n": 2,
						"h": 83,
						"w": 233
					},
					{
						"n": 3,
						"h": 163,
						"w": 171
					},
					{
						"n": 4,
						"h": 271,
						"w": 179
					},
					{
						"n": 5,
						"h": 374,
						"w": 187
					},
					{
						"n": 6,
						"h": 237,
						"w": 246
					},
					{
						"n": 7,
						"h": 203,
						"w": 235
					},
					{
						"n": 8,
						"h": 407,
						"w": 324
					},
					{
						"n": 9,
						"h": 36,
						"w": 373
					},
					{
						"n": 10,
						"h": 134,
						"w": 416
					},
					{
						"n": 11,
						"h": 377,
						"w": 333
					}
				],
				"ball": {
					"n": 0,
					"h": 367,
					"w": 487,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 265,
			"minute": 13,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 18
					},
					{
						"n": 2,
						"h": 101,
						"w": 172
					},
					{
						"n": 3,
						"h": 214,
						"w": 123
					},
					{
						"n": 4,
						"h": 301,
						"w": 129
					},
					{
						"n": 5,
						"h": 369,
						"w": 179
					},
					{
						"n": 6,
						"h": 58,
						"w": 411
					},
					{
						"n": 7,
						"h": 204,
						"w": 347
					},
					{
						"n": 8,
						"h": 316,
						"w": 240
					},
					{
						"n": 9,
						"h": 368,
						"w": 418
					},
					{
						"n": 10,
						"h": 170,
						"w": 451
					},
					{
						"n": 11,
						"h": 281,
						"w": 507
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 61
					},
					{
						"n": 2,
						"h": 100,
						"w": 264
					},
					{
						"n": 3,
						"h": 164,
						"w": 211
					},
					{
						"n": 4,
						"h": 270,
						"w": 219
					},
					{
						"n": 5,
						"h": 379,
						"w": 227
					},
					{
						"n": 6,
						"h": 234,
						"w": 285
					},
					{
						"n": 7,
						"h": 200,
						"w": 274
					},
					{
						"n": 8,
						"h": 403,
						"w": 364
					},
					{
						"n": 9,
						"h": 52,
						"w": 409
					},
					{
						"n": 10,
						"h": 139,
						"w": 456
					},
					{
						"n": 11,
						"h": 389,
						"w": 371
					}
				],
				"ball": {
					"n": 0,
					"h": 350,
					"w": 456,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 266,
			"minute": 13,
			"messages": [
				{
					"owner": 2,
					"mes": "Л.Седлачек[22](Опава) отдает передачу О.Дюмону[26](Опава)..."
				},
				{
					"owner": 2,
					"mes": "Неточно..."
				},
				{
					"owner": 2,
					"mes": "Мирослав Манолов[27](Опава) подхватывает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 10
					},
					{
						"n": 2,
						"h": 107,
						"w": 140
					},
					{
						"n": 3,
						"h": 219,
						"w": 91
					},
					{
						"n": 4,
						"h": 308,
						"w": 98
					},
					{
						"n": 5,
						"h": 368,
						"w": 147
					},
					{
						"n": 6,
						"h": 58,
						"w": 379
					},
					{
						"n": 7,
						"h": 228,
						"w": 367
					},
					{
						"n": 8,
						"h": 313,
						"w": 208
					},
					{
						"n": 9,
						"h": 374,
						"w": 386
					},
					{
						"n": 10,
						"h": 190,
						"w": 426
					},
					{
						"n": 11,
						"h": 305,
						"w": 485
					}
				],
				"away": [
					{
						"n": 1,
						"h": 228,
						"w": 85
					},
					{
						"n": 2,
						"h": 94,
						"w": 272
					},
					{
						"n": 3,
						"h": 164,
						"w": 243
					},
					{
						"n": 4,
						"h": 279,
						"w": 249
					},
					{
						"n": 5,
						"h": 380,
						"w": 259
					},
					{
						"n": 6,
						"h": 238,
						"w": 317
					},
					{
						"n": 7,
						"h": 187,
						"w": 303,
						"m": 580
					},
					{
						"n": 8,
						"h": 405,
						"w": 396
					},
					{
						"n": 9,
						"h": 53,
						"w": 423
					},
					{
						"n": 10,
						"h": 142,
						"w": 487
					},
					{
						"n": 11,
						"h": 391,
						"w": 403
					}
				],
				"ball": {
					"n": 0,
					"h": 263,
					"w": 417,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 32
		},
		{
			"num": 267,
			"minute": 13,
			"messages": [
				{
					"owner": 2,
					"mes": "Мирослав Манолов[27](Опава) делает передачу направо..."
				},
				{
					"owner": 2,
					"mes": "Но Киэн Колман[06](Галвэй Юнайтед) перехватывает мяч!..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 18
					},
					{
						"n": 2,
						"h": 100,
						"w": 99
					},
					{
						"n": 3,
						"h": 219,
						"w": 74
					},
					{
						"n": 4,
						"h": 307,
						"w": 78
					},
					{
						"n": 5,
						"h": 362,
						"w": 106
					},
					{
						"n": 6,
						"h": 100,
						"w": 372
					},
					{
						"n": 7,
						"h": 187,
						"w": 359
					},
					{
						"n": 8,
						"h": 311,
						"w": 167
					},
					{
						"n": 9,
						"h": 379,
						"w": 345
					},
					{
						"n": 10,
						"h": 167,
						"w": 392
					},
					{
						"n": 11,
						"h": 284,
						"w": 449
					}
				],
				"away": [
					{
						"n": 1,
						"h": 223,
						"w": 105
					},
					{
						"n": 2,
						"h": 77,
						"w": 310
					},
					{
						"n": 3,
						"h": 171,
						"w": 285
					},
					{
						"n": 4,
						"h": 283,
						"w": 291
					},
					{
						"n": 5,
						"h": 385,
						"w": 301
					},
					{
						"n": 6,
						"h": 242,
						"w": 359
					},
					{
						"n": 7,
						"h": 193,
						"w": 314,
						"m": 570
					},
					{
						"n": 8,
						"h": 407,
						"w": 438
					},
					{
						"n": 9,
						"h": 52,
						"w": 465
					},
					{
						"n": 10,
						"h": 141,
						"w": 529
					},
					{
						"n": 11,
						"h": 369,
						"w": 374
					}
				],
				"ball": {
					"n": 0,
					"h": 100,
					"w": 372,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 42
		},
		{
			"num": 268,
			"minute": 13,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 19
					},
					{
						"n": 2,
						"h": 84,
						"w": 136
					},
					{
						"n": 3,
						"h": 200,
						"w": 110
					},
					{
						"n": 4,
						"h": 289,
						"w": 113
					},
					{
						"n": 5,
						"h": 373,
						"w": 144
					},
					{
						"n": 6,
						"h": 69,
						"w": 389,
						"m": 620
					},
					{
						"n": 7,
						"h": 162,
						"w": 328
					},
					{
						"n": 8,
						"h": 294,
						"w": 203
					},
					{
						"n": 9,
						"h": 390,
						"w": 383
					},
					{
						"n": 10,
						"h": 162,
						"w": 431
					},
					{
						"n": 11,
						"h": 289,
						"w": 488
					}
				],
				"away": [
					{
						"n": 1,
						"h": 245,
						"w": 78
					},
					{
						"n": 2,
						"h": 83,
						"w": 271
					},
					{
						"n": 3,
						"h": 171,
						"w": 245
					},
					{
						"n": 4,
						"h": 281,
						"w": 251
					},
					{
						"n": 5,
						"h": 384,
						"w": 261
					},
					{
						"n": 6,
						"h": 249,
						"w": 320
					},
					{
						"n": 7,
						"h": 208,
						"w": 277
					},
					{
						"n": 8,
						"h": 407,
						"w": 418
					},
					{
						"n": 9,
						"h": 47,
						"w": 426
					},
					{
						"n": 10,
						"h": 156,
						"w": 497
					},
					{
						"n": 11,
						"h": 376,
						"w": 334
					}
				],
				"ball": {
					"n": 0,
					"h": 69,
					"w": 389,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 269,
			"minute": 13,
			"messages": [
				{
					"owner": 1,
					"mes": "Киэн Колман[06](Галвэй Юнайтед) посылает мяч в направлении Д.Квигли[10](Галвэй Юнайтед)..."
				},
				{
					"owner": 1,
					"mes": "Джо Квигли[10](Галвэй Юнайтед) получил мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 12
					},
					{
						"n": 2,
						"h": 82,
						"w": 164
					},
					{
						"n": 3,
						"h": 194,
						"w": 137
					},
					{
						"n": 4,
						"h": 284,
						"w": 141
					},
					{
						"n": 5,
						"h": 374,
						"w": 172
					},
					{
						"n": 6,
						"h": 65,
						"w": 398
					},
					{
						"n": 7,
						"h": 162,
						"w": 356
					},
					{
						"n": 8,
						"h": 290,
						"w": 230
					},
					{
						"n": 9,
						"h": 394,
						"w": 410
					},
					{
						"n": 10,
						"h": 138,
						"w": 417
					},
					{
						"n": 11,
						"h": 288,
						"w": 516
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 71
					},
					{
						"n": 2,
						"h": 86,
						"w": 243
					},
					{
						"n": 3,
						"h": 172,
						"w": 217
					},
					{
						"n": 4,
						"h": 281,
						"w": 223
					},
					{
						"n": 5,
						"h": 378,
						"w": 233
					},
					{
						"n": 6,
						"h": 257,
						"w": 293
					},
					{
						"n": 7,
						"h": 213,
						"w": 249
					},
					{
						"n": 8,
						"h": 403,
						"w": 390
					},
					{
						"n": 9,
						"h": 46,
						"w": 398
					},
					{
						"n": 10,
						"h": 160,
						"w": 470
					},
					{
						"n": 11,
						"h": 350,
						"w": 326
					}
				],
				"ball": {
					"n": 0,
					"h": 138,
					"w": 417,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 28
		},
		{
			"num": 270,
			"minute": 13,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 18
					},
					{
						"n": 2,
						"h": 78,
						"w": 204
					},
					{
						"n": 3,
						"h": 185,
						"w": 176
					},
					{
						"n": 4,
						"h": 279,
						"w": 181
					},
					{
						"n": 5,
						"h": 374,
						"w": 212
					},
					{
						"n": 6,
						"h": 65,
						"w": 438
					},
					{
						"n": 7,
						"h": 165,
						"w": 396
					},
					{
						"n": 8,
						"h": 298,
						"w": 270
					},
					{
						"n": 9,
						"h": 399,
						"w": 450
					},
					{
						"n": 10,
						"h": 141,
						"w": 452
					},
					{
						"n": 11,
						"h": 291,
						"w": 556
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 71
					},
					{
						"n": 2,
						"h": 92,
						"w": 203
					},
					{
						"n": 3,
						"h": 173,
						"w": 177
					},
					{
						"n": 4,
						"h": 277,
						"w": 184
					},
					{
						"n": 5,
						"h": 369,
						"w": 194
					},
					{
						"n": 6,
						"h": 289,
						"w": 269
					},
					{
						"n": 7,
						"h": 219,
						"w": 210
					},
					{
						"n": 8,
						"h": 398,
						"w": 350
					},
					{
						"n": 9,
						"h": 48,
						"w": 358
					},
					{
						"n": 10,
						"h": 152,
						"w": 430
					},
					{
						"n": 11,
						"h": 311,
						"w": 316
					}
				],
				"ball": {
					"n": 0,
					"h": 141,
					"w": 452,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 271,
			"minute": 13,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 13
					},
					{
						"n": 2,
						"h": 76,
						"w": 244
					},
					{
						"n": 3,
						"h": 177,
						"w": 215
					},
					{
						"n": 4,
						"h": 273,
						"w": 220
					},
					{
						"n": 5,
						"h": 374,
						"w": 252
					},
					{
						"n": 6,
						"h": 43,
						"w": 472
					},
					{
						"n": 7,
						"h": 161,
						"w": 436
					},
					{
						"n": 8,
						"h": 290,
						"w": 309
					},
					{
						"n": 9,
						"h": 394,
						"w": 490
					},
					{
						"n": 10,
						"h": 141,
						"w": 498
					},
					{
						"n": 11,
						"h": 295,
						"w": 596
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 74
					},
					{
						"n": 2,
						"h": 97,
						"w": 164
					},
					{
						"n": 3,
						"h": 172,
						"w": 137
					},
					{
						"n": 4,
						"h": 276,
						"w": 135
					},
					{
						"n": 5,
						"h": 361,
						"w": 155
					},
					{
						"n": 6,
						"h": 304,
						"w": 222
					},
					{
						"n": 7,
						"h": 227,
						"w": 170
					},
					{
						"n": 8,
						"h": 400,
						"w": 310
					},
					{
						"n": 9,
						"h": 50,
						"w": 318
					},
					{
						"n": 10,
						"h": 160,
						"w": 391
					},
					{
						"n": 11,
						"h": 293,
						"w": 303
					}
				],
				"ball": {
					"n": 0,
					"h": 141,
					"w": 498,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 272,
			"minute": 13,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 18
					},
					{
						"n": 2,
						"h": 74,
						"w": 284
					},
					{
						"n": 3,
						"h": 172,
						"w": 255
					},
					{
						"n": 4,
						"h": 276,
						"w": 260
					},
					{
						"n": 5,
						"h": 377,
						"w": 292
					},
					{
						"n": 6,
						"h": 42,
						"w": 512
					},
					{
						"n": 7,
						"h": 157,
						"w": 476
					},
					{
						"n": 8,
						"h": 293,
						"w": 349
					},
					{
						"n": 9,
						"h": 399,
						"w": 530
					},
					{
						"n": 10,
						"h": 141,
						"w": 533
					},
					{
						"n": 11,
						"h": 310,
						"w": 633
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 38
					},
					{
						"n": 2,
						"h": 103,
						"w": 124
					},
					{
						"n": 3,
						"h": 176,
						"w": 97
					},
					{
						"n": 4,
						"h": 267,
						"w": 96
					},
					{
						"n": 5,
						"h": 383,
						"w": 188
					},
					{
						"n": 6,
						"h": 305,
						"w": 182
					},
					{
						"n": 7,
						"h": 216,
						"w": 154
					},
					{
						"n": 8,
						"h": 407,
						"w": 271
					},
					{
						"n": 9,
						"h": 50,
						"w": 278
					},
					{
						"n": 10,
						"h": 157,
						"w": 351
					},
					{
						"n": 11,
						"h": 279,
						"w": 293
					}
				],
				"ball": {
					"n": 0,
					"h": 141,
					"w": 533,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 273,
			"minute": 13,
			"messages": [
				{
					"owner": 1,
					"mes": "Пас направо..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 18
					},
					{
						"n": 2,
						"h": 68,
						"w": 339
					},
					{
						"n": 3,
						"h": 184,
						"w": 310
					},
					{
						"n": 4,
						"h": 269,
						"w": 313
					},
					{
						"n": 5,
						"h": 375,
						"w": 348
					},
					{
						"n": 6,
						"h": 53,
						"w": 520
					},
					{
						"n": 7,
						"h": 196,
						"w": 489
					},
					{
						"n": 8,
						"h": 322,
						"w": 396
					},
					{
						"n": 9,
						"h": 362,
						"w": 487
					},
					{
						"n": 10,
						"h": 144,
						"w": 543
					},
					{
						"n": 11,
						"h": 305,
						"w": 630
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 10
					},
					{
						"n": 2,
						"h": 90,
						"w": 70
					},
					{
						"n": 3,
						"h": 165,
						"w": 66
					},
					{
						"n": 4,
						"h": 276,
						"w": 70
					},
					{
						"n": 5,
						"h": 372,
						"w": 180
					},
					{
						"n": 6,
						"h": 277,
						"w": 134
					},
					{
						"n": 7,
						"h": 204,
						"w": 194
					},
					{
						"n": 8,
						"h": 410,
						"w": 235
					},
					{
						"n": 9,
						"h": 84,
						"w": 234
					},
					{
						"n": 10,
						"h": 128,
						"w": 304
					},
					{
						"n": 11,
						"h": 288,
						"w": 291
					}
				],
				"ball": {
					"n": 0,
					"h": 362,
					"w": 487,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 56
		},
		{
			"num": 274,
			"minute": 13,
			"messages": [
				{
					"owner": 1,
					"mes": "Элвис Бвомоно[09](Галвэй Юнайтед) технично обрабатывает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 15
					},
					{
						"n": 2,
						"h": 68,
						"w": 349
					},
					{
						"n": 3,
						"h": 174,
						"w": 310
					},
					{
						"n": 4,
						"h": 275,
						"w": 321
					},
					{
						"n": 5,
						"h": 379,
						"w": 357
					},
					{
						"n": 6,
						"h": 53,
						"w": 530
					},
					{
						"n": 7,
						"h": 201,
						"w": 498
					},
					{
						"n": 8,
						"h": 313,
						"w": 398
					},
					{
						"n": 9,
						"h": 360,
						"w": 497
					},
					{
						"n": 10,
						"h": 146,
						"w": 553
					},
					{
						"n": 11,
						"h": 295,
						"w": 632
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 18
					},
					{
						"n": 2,
						"h": 80,
						"w": 68
					},
					{
						"n": 3,
						"h": 168,
						"w": 75
					},
					{
						"n": 4,
						"h": 277,
						"w": 60
					},
					{
						"n": 5,
						"h": 382,
						"w": 182
					},
					{
						"n": 6,
						"h": 285,
						"w": 129
					},
					{
						"n": 7,
						"h": 198,
						"w": 188
					},
					{
						"n": 8,
						"h": 410,
						"w": 235
					},
					{
						"n": 9,
						"h": 83,
						"w": 231
					},
					{
						"n": 10,
						"h": 137,
						"w": 302
					},
					{
						"n": 11,
						"h": 294,
						"w": 298
					}
				],
				"ball": {
					"n": 0,
					"h": 360,
					"w": 497,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 10
		},
		{
			"num": 275,
			"minute": 13,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 13
					},
					{
						"n": 2,
						"h": 66,
						"w": 370
					},
					{
						"n": 3,
						"h": 167,
						"w": 323
					},
					{
						"n": 4,
						"h": 278,
						"w": 326
					},
					{
						"n": 5,
						"h": 387,
						"w": 375
					},
					{
						"n": 6,
						"h": 52,
						"w": 570
					},
					{
						"n": 7,
						"h": 201,
						"w": 538
					},
					{
						"n": 8,
						"h": 306,
						"w": 438
					},
					{
						"n": 9,
						"h": 372,
						"w": 540
					},
					{
						"n": 10,
						"h": 154,
						"w": 592
					},
					{
						"n": 11,
						"h": 286,
						"w": 632
					}
				],
				"away": [
					{
						"n": 1,
						"h": 214,
						"w": 14
					},
					{
						"n": 2,
						"h": 82,
						"w": 115
					},
					{
						"n": 3,
						"h": 180,
						"w": 64
					},
					{
						"n": 4,
						"h": 285,
						"w": 56
					},
					{
						"n": 5,
						"h": 390,
						"w": 143
					},
					{
						"n": 6,
						"h": 292,
						"w": 124
					},
					{
						"n": 7,
						"h": 237,
						"w": 178
					},
					{
						"n": 8,
						"h": 407,
						"w": 215
					},
					{
						"n": 9,
						"h": 86,
						"w": 183
					},
					{
						"n": 10,
						"h": 144,
						"w": 262
					},
					{
						"n": 11,
						"h": 284,
						"w": 301
					}
				],
				"ball": {
					"n": 0,
					"h": 372,
					"w": 540,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 276,
			"minute": 13,
			"messages": [
				{
					"owner": 1,
					"mes": "Элвис Бвомоно[09](Галвэй Юнайтед) пасует на ход А.Гилберту[11](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 10
					},
					{
						"n": 2,
						"h": 67,
						"w": 378
					},
					{
						"n": 3,
						"h": 183,
						"w": 313
					},
					{
						"n": 4,
						"h": 283,
						"w": 314
					},
					{
						"n": 5,
						"h": 387,
						"w": 376
					},
					{
						"n": 6,
						"h": 46,
						"w": 620
					},
					{
						"n": 7,
						"h": 184,
						"w": 585
					},
					{
						"n": 8,
						"h": 297,
						"w": 487
					},
					{
						"n": 9,
						"h": 372,
						"w": 540
					},
					{
						"n": 10,
						"h": 158,
						"w": 642
					},
					{
						"n": 11,
						"h": 301,
						"w": 672
					}
				],
				"away": [
					{
						"n": 1,
						"h": 212,
						"w": 8
					},
					{
						"n": 2,
						"h": 100,
						"w": 69
					},
					{
						"n": 3,
						"h": 166,
						"w": 38
					},
					{
						"n": 4,
						"h": 262,
						"w": 54
					},
					{
						"n": 5,
						"h": 382,
						"w": 94
					},
					{
						"n": 6,
						"h": 261,
						"w": 109
					},
					{
						"n": 7,
						"h": 219,
						"w": 170
					},
					{
						"n": 8,
						"h": 416,
						"w": 187
					},
					{
						"n": 9,
						"h": 37,
						"w": 190
					},
					{
						"n": 10,
						"h": 174,
						"w": 303
					},
					{
						"n": 11,
						"h": 281,
						"w": 299
					}
				],
				"ball": {
					"n": 0,
					"h": 301,
					"w": 672,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 50
		},
		{
			"num": 277,
			"minute": 13,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 18
					},
					{
						"n": 2,
						"h": 64,
						"w": 375
					},
					{
						"n": 3,
						"h": 180,
						"w": 325
					},
					{
						"n": 4,
						"h": 268,
						"w": 328
					},
					{
						"n": 5,
						"h": 374,
						"w": 371
					},
					{
						"n": 6,
						"h": 55,
						"w": 637
					},
					{
						"n": 7,
						"h": 174,
						"w": 602
					},
					{
						"n": 8,
						"h": 294,
						"w": 467
					},
					{
						"n": 9,
						"h": 378,
						"w": 559
					},
					{
						"n": 10,
						"h": 163,
						"w": 661
					},
					{
						"n": 11,
						"h": 291,
						"w": 671
					}
				],
				"away": [
					{
						"n": 1,
						"h": 213,
						"w": 9
					},
					{
						"n": 2,
						"h": 107,
						"w": 46
					},
					{
						"n": 3,
						"h": 167,
						"w": 43
					},
					{
						"n": 4,
						"h": 265,
						"w": 37
					},
					{
						"n": 5,
						"h": 370,
						"w": 78
					},
					{
						"n": 6,
						"h": 272,
						"w": 102
					},
					{
						"n": 7,
						"h": 225,
						"w": 151
					},
					{
						"n": 8,
						"h": 416,
						"w": 187
					},
					{
						"n": 9,
						"h": 36,
						"w": 190
					},
					{
						"n": 10,
						"h": 169,
						"w": 283
					},
					{
						"n": 11,
						"h": 284,
						"w": 308
					}
				],
				"ball": {
					"n": 0,
					"h": 291,
					"w": 671,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 20
		},
		{
			"num": 278,
			"minute": 13,
			"messages": [
				{
					"owner": 1,
					"mes": "Адам Гилберт[11](Галвэй Юнайтед) укрывает мяч корпусом..."
				},
				{
					"owner": 1,
					"mes": "Нир Мансур[23](Опава) отнимает у него мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 18
					},
					{
						"n": 2,
						"h": 64,
						"w": 375
					},
					{
						"n": 3,
						"h": 180,
						"w": 325
					},
					{
						"n": 4,
						"h": 266,
						"w": 330
					},
					{
						"n": 5,
						"h": 374,
						"w": 371
					},
					{
						"n": 6,
						"h": 57,
						"w": 640
					},
					{
						"n": 7,
						"h": 166,
						"w": 615
					},
					{
						"n": 8,
						"h": 292,
						"w": 452
					},
					{
						"n": 9,
						"h": 383,
						"w": 574
					},
					{
						"n": 10,
						"h": 165,
						"w": 669
					},
					{
						"n": 11,
						"h": 276,
						"w": 673,
						"m": 650
					}
				],
				"away": [
					{
						"n": 1,
						"h": 213,
						"w": 9
					},
					{
						"n": 2,
						"h": 110,
						"w": 34
					},
					{
						"n": 3,
						"h": 167,
						"w": 43,
						"m": 630
					},
					{
						"n": 4,
						"h": 265,
						"w": 37
					},
					{
						"n": 5,
						"h": 361,
						"w": 65
					},
					{
						"n": 6,
						"h": 272,
						"w": 102
					},
					{
						"n": 7,
						"h": 226,
						"w": 149
					},
					{
						"n": 8,
						"h": 418,
						"w": 172
					},
					{
						"n": 9,
						"h": 36,
						"w": 190
					},
					{
						"n": 10,
						"h": 165,
						"w": 269
					},
					{
						"n": 11,
						"h": 284,
						"w": 308
					}
				],
				"ball": {
					"n": 0,
					"h": 283,
					"w": 677,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 15
		},
		{
			"num": 279,
			"minute": 13,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 17
					},
					{
						"n": 2,
						"h": 69,
						"w": 335
					},
					{
						"n": 3,
						"h": 180,
						"w": 285
					},
					{
						"n": 4,
						"h": 267,
						"w": 290
					},
					{
						"n": 5,
						"h": 368,
						"w": 331
					},
					{
						"n": 6,
						"h": 55,
						"w": 600
					},
					{
						"n": 7,
						"h": 168,
						"w": 575
					},
					{
						"n": 8,
						"h": 293,
						"w": 412
					},
					{
						"n": 9,
						"h": 386,
						"w": 534
					},
					{
						"n": 10,
						"h": 168,
						"w": 629
					},
					{
						"n": 11,
						"h": 285,
						"w": 661
					}
				],
				"away": [
					{
						"n": 1,
						"h": 228,
						"w": 11
					},
					{
						"n": 2,
						"h": 98,
						"w": 72
					},
					{
						"n": 3,
						"h": 142,
						"w": 68
					},
					{
						"n": 4,
						"h": 264,
						"w": 77
					},
					{
						"n": 5,
						"h": 383,
						"w": 99
					},
					{
						"n": 6,
						"h": 261,
						"w": 141
					},
					{
						"n": 7,
						"h": 225,
						"w": 189
					},
					{
						"n": 8,
						"h": 416,
						"w": 212
					},
					{
						"n": 9,
						"h": 39,
						"w": 230
					},
					{
						"n": 10,
						"h": 165,
						"w": 309
					},
					{
						"n": 11,
						"h": 287,
						"w": 348
					}
				],
				"ball": {
					"n": 0,
					"h": 308,
					"w": 652,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 280,
			"minute": 13,
			"messages": [
				{
					"owner": 2,
					"mes": "Пас налево Л.Седлачеку[22](Опава)..."
				},
				{
					"owner": 2,
					"mes": "Лука Седлачек[22](Опава) получает передачу..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 16
					},
					{
						"n": 2,
						"h": 71,
						"w": 313
					},
					{
						"n": 3,
						"h": 181,
						"w": 263
					},
					{
						"n": 4,
						"h": 268,
						"w": 268
					},
					{
						"n": 5,
						"h": 365,
						"w": 310
					},
					{
						"n": 6,
						"h": 54,
						"w": 578
					},
					{
						"n": 7,
						"h": 170,
						"w": 553
					},
					{
						"n": 8,
						"h": 293,
						"w": 390
					},
					{
						"n": 9,
						"h": 377,
						"w": 554
					},
					{
						"n": 10,
						"h": 170,
						"w": 607
					},
					{
						"n": 11,
						"h": 289,
						"w": 639
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 17
					},
					{
						"n": 2,
						"h": 98,
						"w": 72
					},
					{
						"n": 3,
						"h": 145,
						"w": 77
					},
					{
						"n": 4,
						"h": 266,
						"w": 99
					},
					{
						"n": 5,
						"h": 384,
						"w": 121
					},
					{
						"n": 6,
						"h": 256,
						"w": 162
					},
					{
						"n": 7,
						"h": 222,
						"w": 211
					},
					{
						"n": 8,
						"h": 413,
						"w": 234
					},
					{
						"n": 9,
						"h": 42,
						"w": 252
					},
					{
						"n": 10,
						"h": 163,
						"w": 331
					},
					{
						"n": 11,
						"h": 282,
						"w": 369
					}
				],
				"ball": {
					"n": 0,
					"h": 352,
					"w": 648,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 22
		},
		{
			"num": 281,
			"minute": 13,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 19
					},
					{
						"n": 2,
						"h": 73,
						"w": 273
					},
					{
						"n": 3,
						"h": 184,
						"w": 223
					},
					{
						"n": 4,
						"h": 269,
						"w": 228
					},
					{
						"n": 5,
						"h": 359,
						"w": 270
					},
					{
						"n": 6,
						"h": 53,
						"w": 538
					},
					{
						"n": 7,
						"h": 173,
						"w": 513
					},
					{
						"n": 8,
						"h": 293,
						"w": 350
					},
					{
						"n": 9,
						"h": 367,
						"w": 571
					},
					{
						"n": 10,
						"h": 163,
						"w": 568
					},
					{
						"n": 11,
						"h": 294,
						"w": 600
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 18
					},
					{
						"n": 2,
						"h": 94,
						"w": 107
					},
					{
						"n": 3,
						"h": 161,
						"w": 125
					},
					{
						"n": 4,
						"h": 268,
						"w": 119
					},
					{
						"n": 5,
						"h": 378,
						"w": 160
					},
					{
						"n": 6,
						"h": 229,
						"w": 191
					},
					{
						"n": 7,
						"h": 217,
						"w": 251
					},
					{
						"n": 8,
						"h": 405,
						"w": 273
					},
					{
						"n": 9,
						"h": 48,
						"w": 291
					},
					{
						"n": 10,
						"h": 161,
						"w": 371
					},
					{
						"n": 11,
						"h": 275,
						"w": 409
					}
				],
				"ball": {
					"n": 0,
					"h": 356,
					"w": 613,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 282,
			"minute": 14,
			"possession": 43,
			"messages": [
				{
					"owner": 2,
					"mes": "Лука Седлачек[22](Опава) играет направо..."
				},
				{
					"owner": 2,
					"mes": "Крыштоф Ласак[21](Опава) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 19
					},
					{
						"n": 2,
						"h": 83,
						"w": 232
					},
					{
						"n": 3,
						"h": 188,
						"w": 180
					},
					{
						"n": 4,
						"h": 272,
						"w": 185,
						"f": 96
					},
					{
						"n": 5,
						"h": 352,
						"w": 228
					},
					{
						"n": 6,
						"h": 54,
						"w": 495,
						"f": 95
					},
					{
						"n": 7,
						"h": 175,
						"w": 470
					},
					{
						"n": 8,
						"h": 292,
						"w": 307
					},
					{
						"n": 9,
						"h": 370,
						"w": 529
					},
					{
						"n": 10,
						"h": 156,
						"w": 525
					},
					{
						"n": 11,
						"h": 302,
						"w": 557
					}
				],
				"away": [
					{
						"n": 1,
						"h": 208,
						"w": 47
					},
					{
						"n": 2,
						"h": 92,
						"w": 117
					},
					{
						"n": 3,
						"h": 169,
						"w": 167,
						"f": 94
					},
					{
						"n": 4,
						"h": 267,
						"w": 162,
						"f": 94
					},
					{
						"n": 5,
						"h": 385,
						"w": 201
					},
					{
						"n": 6,
						"h": 228,
						"w": 234
					},
					{
						"n": 7,
						"h": 216,
						"w": 294,
						"f": 96
					},
					{
						"n": 8,
						"h": 397,
						"w": 315
					},
					{
						"n": 9,
						"h": 71,
						"w": 328
					},
					{
						"n": 10,
						"h": 158,
						"w": 413,
						"f": 94,
						"m": 600
					},
					{
						"n": 11,
						"h": 264,
						"w": 450,
						"f": 94
					}
				],
				"ball": {
					"n": 0,
					"h": 242,
					"w": 673,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 43
		},
		{
			"num": 283,
			"minute": 14,
			"messages": [
				{
					"owner": 2,
					"mes": "Крыштоф Ласак[21](Опава) пасует прямо на С.Пейшу[24](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 11
					},
					{
						"n": 2,
						"h": 86,
						"w": 200
					},
					{
						"n": 3,
						"h": 194,
						"w": 149
					},
					{
						"n": 4,
						"h": 273,
						"w": 153
					},
					{
						"n": 5,
						"h": 348,
						"w": 196
					},
					{
						"n": 6,
						"h": 55,
						"w": 463
					},
					{
						"n": 7,
						"h": 176,
						"w": 438
					},
					{
						"n": 8,
						"h": 294,
						"w": 275
					},
					{
						"n": 9,
						"h": 369,
						"w": 497
					},
					{
						"n": 10,
						"h": 177,
						"w": 549
					},
					{
						"n": 11,
						"h": 306,
						"w": 526
					}
				],
				"away": [
					{
						"n": 1,
						"h": 212,
						"w": 37
					},
					{
						"n": 2,
						"h": 82,
						"w": 158
					},
					{
						"n": 3,
						"h": 168,
						"w": 179
					},
					{
						"n": 4,
						"h": 256,
						"w": 131
					},
					{
						"n": 5,
						"h": 379,
						"w": 195
					},
					{
						"n": 6,
						"h": 226,
						"w": 266
					},
					{
						"n": 7,
						"h": 216,
						"w": 326
					},
					{
						"n": 8,
						"h": 408,
						"w": 345
					},
					{
						"n": 9,
						"h": 86,
						"w": 356
					},
					{
						"n": 10,
						"h": 158,
						"w": 445
					},
					{
						"n": 11,
						"h": 258,
						"w": 482
					}
				],
				"ball": {
					"n": 0,
					"h": 194,
					"w": 589,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 32
		},
		{
			"num": 284,
			"minute": 14,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 12
					},
					{
						"n": 2,
						"h": 86,
						"w": 160
					},
					{
						"n": 3,
						"h": 209,
						"w": 112
					},
					{
						"n": 4,
						"h": 276,
						"w": 113
					},
					{
						"n": 5,
						"h": 342,
						"w": 156
					},
					{
						"n": 6,
						"h": 55,
						"w": 423
					},
					{
						"n": 7,
						"h": 176,
						"w": 398
					},
					{
						"n": 8,
						"h": 290,
						"w": 235
					},
					{
						"n": 9,
						"h": 373,
						"w": 457
					},
					{
						"n": 10,
						"h": 202,
						"w": 534
					},
					{
						"n": 11,
						"h": 311,
						"w": 486
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 59
					},
					{
						"n": 2,
						"h": 77,
						"w": 197
					},
					{
						"n": 3,
						"h": 168,
						"w": 199
					},
					{
						"n": 4,
						"h": 248,
						"w": 166
					},
					{
						"n": 5,
						"h": 380,
						"w": 235
					},
					{
						"n": 6,
						"h": 227,
						"w": 306
					},
					{
						"n": 7,
						"h": 216,
						"w": 366
					},
					{
						"n": 8,
						"h": 403,
						"w": 385
					},
					{
						"n": 9,
						"h": 97,
						"w": 394
					},
					{
						"n": 10,
						"h": 158,
						"w": 485
					},
					{
						"n": 11,
						"h": 250,
						"w": 521
					}
				],
				"ball": {
					"n": 0,
					"h": 202,
					"w": 554,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 285,
			"minute": 14,
			"messages": [
				{
					"owner": 2,
					"mes": "Себастьян Пейша[24](Опава) отпасовывает вперед М.Юрасеку[29](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 16
					},
					{
						"n": 2,
						"h": 108,
						"w": 101
					},
					{
						"n": 3,
						"h": 224,
						"w": 68
					},
					{
						"n": 4,
						"h": 279,
						"w": 84
					},
					{
						"n": 5,
						"h": 334,
						"w": 94
					},
					{
						"n": 6,
						"h": 55,
						"w": 360
					},
					{
						"n": 7,
						"h": 180,
						"w": 335
					},
					{
						"n": 8,
						"h": 317,
						"w": 293
					},
					{
						"n": 9,
						"h": 383,
						"w": 395
					},
					{
						"n": 10,
						"h": 193,
						"w": 472
					},
					{
						"n": 11,
						"h": 307,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 82
					},
					{
						"n": 2,
						"h": 64,
						"w": 259
					},
					{
						"n": 3,
						"h": 175,
						"w": 242
					},
					{
						"n": 4,
						"h": 253,
						"w": 174
					},
					{
						"n": 5,
						"h": 389,
						"w": 256
					},
					{
						"n": 6,
						"h": 245,
						"w": 367
					},
					{
						"n": 7,
						"h": 218,
						"w": 428
					},
					{
						"n": 8,
						"h": 406,
						"w": 448
					},
					{
						"n": 9,
						"h": 123,
						"w": 383
					},
					{
						"n": 10,
						"h": 154,
						"w": 548
					},
					{
						"n": 11,
						"h": 231,
						"w": 581
					}
				],
				"ball": {
					"n": 0,
					"h": 327,
					"w": 337,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 63
		},
		{
			"num": 286,
			"minute": 14,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 18
					},
					{
						"n": 2,
						"h": 120,
						"w": 80
					},
					{
						"n": 3,
						"h": 215,
						"w": 80
					},
					{
						"n": 4,
						"h": 292,
						"w": 74
					},
					{
						"n": 5,
						"h": 330,
						"w": 74
					},
					{
						"n": 6,
						"h": 56,
						"w": 320
					},
					{
						"n": 7,
						"h": 185,
						"w": 295
					},
					{
						"n": 8,
						"h": 340,
						"w": 283
					},
					{
						"n": 9,
						"h": 388,
						"w": 355
					},
					{
						"n": 10,
						"h": 184,
						"w": 433
					},
					{
						"n": 11,
						"h": 311,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 226,
						"w": 99
					},
					{
						"n": 2,
						"h": 74,
						"w": 265
					},
					{
						"n": 3,
						"h": 178,
						"w": 213
					},
					{
						"n": 4,
						"h": 265,
						"w": 204
					},
					{
						"n": 5,
						"h": 391,
						"w": 216
					},
					{
						"n": 6,
						"h": 211,
						"w": 362
					},
					{
						"n": 7,
						"h": 216,
						"w": 468
					},
					{
						"n": 8,
						"h": 403,
						"w": 488
					},
					{
						"n": 9,
						"h": 112,
						"w": 416
					},
					{
						"n": 10,
						"h": 142,
						"w": 587
					},
					{
						"n": 11,
						"h": 235,
						"w": 612
					}
				],
				"ball": {
					"n": 0,
					"h": 338,
					"w": 304,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 287,
			"minute": 14,
			"messages": [
				{
					"owner": 2,
					"mes": "Матей Юрасек[29](Опава) отдает на О.Дюмона[26](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 10
					},
					{
						"n": 2,
						"h": 120,
						"w": 72
					},
					{
						"n": 3,
						"h": 223,
						"w": 88
					},
					{
						"n": 4,
						"h": 278,
						"w": 84
					},
					{
						"n": 5,
						"h": 330,
						"w": 68
					},
					{
						"n": 6,
						"h": 56,
						"w": 286
					},
					{
						"n": 7,
						"h": 218,
						"w": 305
					},
					{
						"n": 8,
						"h": 323,
						"w": 253
					},
					{
						"n": 9,
						"h": 394,
						"w": 321
					},
					{
						"n": 10,
						"h": 184,
						"w": 400
					},
					{
						"n": 11,
						"h": 314,
						"w": 416
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 115
					},
					{
						"n": 2,
						"h": 68,
						"w": 299
					},
					{
						"n": 3,
						"h": 171,
						"w": 247
					},
					{
						"n": 4,
						"h": 266,
						"w": 238
					},
					{
						"n": 5,
						"h": 387,
						"w": 249
					},
					{
						"n": 6,
						"h": 183,
						"w": 381
					},
					{
						"n": 7,
						"h": 214,
						"w": 502
					},
					{
						"n": 8,
						"h": 409,
						"w": 500
					},
					{
						"n": 9,
						"h": 117,
						"w": 408
					},
					{
						"n": 10,
						"h": 155,
						"w": 618
					},
					{
						"n": 11,
						"h": 228,
						"w": 620
					}
				],
				"ball": {
					"n": 0,
					"h": 267,
					"w": 339,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 34
		},
		{
			"num": 288,
			"minute": 14,
			"messages": [
				{
					"owner": 2,
					"mes": "Оливье Дюмон[26](Опава) играет налево на Л.Седлачека[22](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 15
					},
					{
						"n": 2,
						"h": 120,
						"w": 70
					},
					{
						"n": 3,
						"h": 231,
						"w": 80
					},
					{
						"n": 4,
						"h": 279,
						"w": 70
					},
					{
						"n": 5,
						"h": 358,
						"w": 86
					},
					{
						"n": 6,
						"h": 56,
						"w": 245
					},
					{
						"n": 7,
						"h": 249,
						"w": 331
					},
					{
						"n": 8,
						"h": 309,
						"w": 215
					},
					{
						"n": 9,
						"h": 369,
						"w": 354
					},
					{
						"n": 10,
						"h": 176,
						"w": 392
					},
					{
						"n": 11,
						"h": 348,
						"w": 394
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 124
					},
					{
						"n": 2,
						"h": 89,
						"w": 330
					},
					{
						"n": 3,
						"h": 170,
						"w": 288
					},
					{
						"n": 4,
						"h": 274,
						"w": 279
					},
					{
						"n": 5,
						"h": 391,
						"w": 290
					},
					{
						"n": 6,
						"h": 192,
						"w": 374
					},
					{
						"n": 7,
						"h": 188,
						"w": 532
					},
					{
						"n": 8,
						"h": 417,
						"w": 500
					},
					{
						"n": 9,
						"h": 156,
						"w": 397
					},
					{
						"n": 10,
						"h": 153,
						"w": 626
					},
					{
						"n": 11,
						"h": 223,
						"w": 608
					}
				],
				"ball": {
					"n": 0,
					"h": 339,
					"w": 378,
					"z": 0,
					"r": 0,
					"p": 2,
					"x": 0
				}
			},
			"interval": 41
		},
		{
			"num": 289,
			"minute": 14,
			"messages": [
				{
					"owner": 2,
					"mes": "Лука Седлачек[22](Опава) принимает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 10
					},
					{
						"n": 2,
						"h": 120,
						"w": 72
					},
					{
						"n": 3,
						"h": 224,
						"w": 78
					},
					{
						"n": 4,
						"h": 286,
						"w": 68
					},
					{
						"n": 5,
						"h": 353,
						"w": 90
					},
					{
						"n": 6,
						"h": 56,
						"w": 221
					},
					{
						"n": 7,
						"h": 268,
						"w": 346
					},
					{
						"n": 8,
						"h": 305,
						"w": 191
					},
					{
						"n": 9,
						"h": 354,
						"w": 373
					},
					{
						"n": 10,
						"h": 173,
						"w": 391
					},
					{
						"n": 11,
						"h": 359,
						"w": 387
					}
				],
				"away": [
					{
						"n": 1,
						"h": 226,
						"w": 119
					},
					{
						"n": 2,
						"h": 89,
						"w": 330,
						"m": 610
					},
					{
						"n": 3,
						"h": 167,
						"w": 300
					},
					{
						"n": 4,
						"h": 277,
						"w": 302
					},
					{
						"n": 5,
						"h": 383,
						"w": 308
					},
					{
						"n": 6,
						"h": 201,
						"w": 391
					},
					{
						"n": 7,
						"h": 208,
						"w": 519
					},
					{
						"n": 8,
						"h": 417,
						"w": 524
					},
					{
						"n": 9,
						"h": 133,
						"w": 403
					},
					{
						"n": 10,
						"h": 152,
						"w": 606
					},
					{
						"n": 11,
						"h": 226,
						"w": 610
					}
				],
				"ball": {
					"n": 0,
					"h": 361,
					"w": 390,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 24
		},
		{
			"num": 290,
			"minute": 14,
			"messages": [
				{
					"owner": 2,
					"mes": "Справа открывается Нир Мансур[23](Опава)... Передача..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 19
					},
					{
						"n": 2,
						"h": 120,
						"w": 72
					},
					{
						"n": 3,
						"h": 224,
						"w": 92
					},
					{
						"n": 4,
						"h": 261,
						"w": 70
					},
					{
						"n": 5,
						"h": 330,
						"w": 76
					},
					{
						"n": 6,
						"h": 56,
						"w": 187
					},
					{
						"n": 7,
						"h": 255,
						"w": 315
					},
					{
						"n": 8,
						"h": 279,
						"w": 170
					},
					{
						"n": 9,
						"h": 368,
						"w": 348
					},
					{
						"n": 10,
						"h": 169,
						"w": 392
					},
					{
						"n": 11,
						"h": 325,
						"w": 391
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 119
					},
					{
						"n": 2,
						"h": 82,
						"w": 337
					},
					{
						"n": 3,
						"h": 153,
						"w": 306
					},
					{
						"n": 4,
						"h": 281,
						"w": 288
					},
					{
						"n": 5,
						"h": 383,
						"w": 296
					},
					{
						"n": 6,
						"h": 232,
						"w": 404
					},
					{
						"n": 7,
						"h": 220,
						"w": 534
					},
					{
						"n": 8,
						"h": 409,
						"w": 557
					},
					{
						"n": 9,
						"h": 167,
						"w": 402
					},
					{
						"n": 10,
						"h": 172,
						"w": 630
					},
					{
						"n": 11,
						"h": 227,
						"w": 612
					}
				],
				"ball": {
					"n": 0,
					"h": 297,
					"w": 414,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 34
		},
		{
			"num": 291,
			"minute": 14,
			"messages": [
				{
					"owner": 2,
					"mes": "Пас О.Дюмону[26](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 17
					},
					{
						"n": 2,
						"h": 120,
						"w": 76
					},
					{
						"n": 3,
						"h": 230,
						"w": 70
					},
					{
						"n": 4,
						"h": 279,
						"w": 84
					},
					{
						"n": 5,
						"h": 330,
						"w": 78
					},
					{
						"n": 6,
						"h": 56,
						"w": 155
					},
					{
						"n": 7,
						"h": 234,
						"w": 339
					},
					{
						"n": 8,
						"h": 266,
						"w": 164
					},
					{
						"n": 9,
						"h": 392,
						"w": 344
					},
					{
						"n": 10,
						"h": 178,
						"w": 392
					},
					{
						"n": 11,
						"h": 294,
						"w": 400
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 127
					},
					{
						"n": 2,
						"h": 58,
						"w": 342
					},
					{
						"n": 3,
						"h": 162,
						"w": 308
					},
					{
						"n": 4,
						"h": 272,
						"w": 302
					},
					{
						"n": 5,
						"h": 393,
						"w": 312
					},
					{
						"n": 6,
						"h": 215,
						"w": 377
					},
					{
						"n": 7,
						"h": 239,
						"w": 522
					},
					{
						"n": 8,
						"h": 409,
						"w": 589
					},
					{
						"n": 9,
						"h": 151,
						"w": 404
					},
					{
						"n": 10,
						"h": 161,
						"w": 632
					},
					{
						"n": 11,
						"h": 225,
						"w": 598
					}
				],
				"ball": {
					"n": 0,
					"h": 235,
					"w": 343,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 32
		},
		{
			"num": 292,
			"minute": 14,
			"messages": [
				{
					"owner": 2,
					"mes": "Оливье Дюмон[26](Опава) контролирует мяч..."
				},
				{
					"owner": 2,
					"mes": "О.Дюмон[26](Опава) теряет мяч. Агуст Хлинссон[07](Галвэй Юнайтед) жестко ставит ногу..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 12
					},
					{
						"n": 2,
						"h": 125,
						"w": 76
					},
					{
						"n": 3,
						"h": 226,
						"w": 73
					},
					{
						"n": 4,
						"h": 275,
						"w": 81
					},
					{
						"n": 5,
						"h": 330,
						"w": 84
					},
					{
						"n": 6,
						"h": 56,
						"w": 150
					},
					{
						"n": 7,
						"h": 234,
						"w": 344,
						"m": 650
					},
					{
						"n": 8,
						"h": 264,
						"w": 160
					},
					{
						"n": 9,
						"h": 389,
						"w": 340
					},
					{
						"n": 10,
						"h": 178,
						"w": 392
					},
					{
						"n": 11,
						"h": 290,
						"w": 400
					}
				],
				"away": [
					{
						"n": 1,
						"h": 226,
						"w": 125
					},
					{
						"n": 2,
						"h": 61,
						"w": 345
					},
					{
						"n": 3,
						"h": 167,
						"w": 307
					},
					{
						"n": 4,
						"h": 272,
						"w": 298
					},
					{
						"n": 5,
						"h": 389,
						"w": 314
					},
					{
						"n": 6,
						"h": 215,
						"w": 382
					},
					{
						"n": 7,
						"h": 234,
						"w": 522
					},
					{
						"n": 8,
						"h": 408,
						"w": 594
					},
					{
						"n": 9,
						"h": 156,
						"w": 404
					},
					{
						"n": 10,
						"h": 164,
						"w": 628
					},
					{
						"n": 11,
						"h": 230,
						"w": 598
					}
				],
				"ball": {
					"n": 0,
					"h": 234,
					"w": 344,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 5
		},
		{
			"num": 293,
			"minute": 14,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 16
					},
					{
						"n": 2,
						"h": 108,
						"w": 112
					},
					{
						"n": 3,
						"h": 203,
						"w": 106
					},
					{
						"n": 4,
						"h": 281,
						"w": 121
					},
					{
						"n": 5,
						"h": 347,
						"w": 119
					},
					{
						"n": 6,
						"h": 56,
						"w": 190
					},
					{
						"n": 7,
						"h": 209,
						"w": 369
					},
					{
						"n": 8,
						"h": 278,
						"w": 197
					},
					{
						"n": 9,
						"h": 388,
						"w": 380
					},
					{
						"n": 10,
						"h": 172,
						"w": 431
					},
					{
						"n": 11,
						"h": 293,
						"w": 440
					}
				],
				"away": [
					{
						"n": 1,
						"h": 229,
						"w": 81
					},
					{
						"n": 2,
						"h": 68,
						"w": 306
					},
					{
						"n": 3,
						"h": 168,
						"w": 268
					},
					{
						"n": 4,
						"h": 271,
						"w": 258
					},
					{
						"n": 5,
						"h": 381,
						"w": 274
					},
					{
						"n": 6,
						"h": 222,
						"w": 369
					},
					{
						"n": 7,
						"h": 234,
						"w": 482
					},
					{
						"n": 8,
						"h": 410,
						"w": 554
					},
					{
						"n": 9,
						"h": 161,
						"w": 364
					},
					{
						"n": 10,
						"h": 167,
						"w": 588
					},
					{
						"n": 11,
						"h": 231,
						"w": 558
					}
				],
				"ball": {
					"n": 0,
					"h": 209,
					"w": 369,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 294,
			"minute": 14,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 19
					},
					{
						"n": 2,
						"h": 97,
						"w": 151
					},
					{
						"n": 3,
						"h": 193,
						"w": 144
					},
					{
						"n": 4,
						"h": 273,
						"w": 160
					},
					{
						"n": 5,
						"h": 356,
						"w": 159
					},
					{
						"n": 6,
						"h": 56,
						"w": 230
					},
					{
						"n": 7,
						"h": 209,
						"w": 404
					},
					{
						"n": 8,
						"h": 283,
						"w": 237
					},
					{
						"n": 9,
						"h": 397,
						"w": 419
					},
					{
						"n": 10,
						"h": 165,
						"w": 470
					},
					{
						"n": 11,
						"h": 295,
						"w": 480
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 79
					},
					{
						"n": 2,
						"h": 75,
						"w": 266
					},
					{
						"n": 3,
						"h": 169,
						"w": 228
					},
					{
						"n": 4,
						"h": 270,
						"w": 218
					},
					{
						"n": 5,
						"h": 373,
						"w": 235
					},
					{
						"n": 6,
						"h": 235,
						"w": 336
					},
					{
						"n": 7,
						"h": 232,
						"w": 442
					},
					{
						"n": 8,
						"h": 409,
						"w": 514
					},
					{
						"n": 9,
						"h": 137,
						"w": 332
					},
					{
						"n": 10,
						"h": 167,
						"w": 548
					},
					{
						"n": 11,
						"h": 239,
						"w": 519
					}
				],
				"ball": {
					"n": 0,
					"h": 209,
					"w": 404,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 295,
			"minute": 14,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 14
					},
					{
						"n": 2,
						"h": 90,
						"w": 190
					},
					{
						"n": 3,
						"h": 183,
						"w": 183
					},
					{
						"n": 4,
						"h": 270,
						"w": 200
					},
					{
						"n": 5,
						"h": 362,
						"w": 198
					},
					{
						"n": 6,
						"h": 55,
						"w": 270
					},
					{
						"n": 7,
						"h": 209,
						"w": 440
					},
					{
						"n": 8,
						"h": 285,
						"w": 277
					},
					{
						"n": 9,
						"h": 394,
						"w": 459
					},
					{
						"n": 10,
						"h": 165,
						"w": 510
					},
					{
						"n": 11,
						"h": 294,
						"w": 520
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 74
					},
					{
						"n": 2,
						"h": 82,
						"w": 227
					},
					{
						"n": 3,
						"h": 182,
						"w": 190
					},
					{
						"n": 4,
						"h": 248,
						"w": 250
					},
					{
						"n": 5,
						"h": 337,
						"w": 217
					},
					{
						"n": 6,
						"h": 239,
						"w": 302
					},
					{
						"n": 7,
						"h": 232,
						"w": 402
					},
					{
						"n": 8,
						"h": 408,
						"w": 494
					},
					{
						"n": 9,
						"h": 113,
						"w": 300
					},
					{
						"n": 10,
						"h": 166,
						"w": 508
					},
					{
						"n": 11,
						"h": 246,
						"w": 479
					}
				],
				"ball": {
					"n": 0,
					"h": 209,
					"w": 440,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 296,
			"minute": 14,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 11
					},
					{
						"n": 2,
						"h": 85,
						"w": 230
					},
					{
						"n": 3,
						"h": 180,
						"w": 223
					},
					{
						"n": 4,
						"h": 270,
						"w": 240
					},
					{
						"n": 5,
						"h": 367,
						"w": 238
					},
					{
						"n": 6,
						"h": 52,
						"w": 310
					},
					{
						"n": 7,
						"h": 227,
						"w": 470
					},
					{
						"n": 8,
						"h": 287,
						"w": 317
					},
					{
						"n": 9,
						"h": 398,
						"w": 486
					},
					{
						"n": 10,
						"h": 159,
						"w": 550
					},
					{
						"n": 11,
						"h": 299,
						"w": 560
					}
				],
				"away": [
					{
						"n": 1,
						"h": 221,
						"w": 71
					},
					{
						"n": 2,
						"h": 89,
						"w": 188
					},
					{
						"n": 3,
						"h": 178,
						"w": 150
					},
					{
						"n": 4,
						"h": 223,
						"w": 230
					},
					{
						"n": 5,
						"h": 321,
						"w": 180
					},
					{
						"n": 6,
						"h": 228,
						"w": 268
					},
					{
						"n": 7,
						"h": 230,
						"w": 363
					},
					{
						"n": 8,
						"h": 408,
						"w": 474
					},
					{
						"n": 9,
						"h": 99,
						"w": 286
					},
					{
						"n": 10,
						"h": 165,
						"w": 468
					},
					{
						"n": 11,
						"h": 253,
						"w": 440
					}
				],
				"ball": {
					"n": 0,
					"h": 227,
					"w": 470,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 297,
			"minute": 14,
			"messages": [
				{
					"owner": 1,
					"mes": "Агуст Хлинссон[07](Галвэй Юнайтед) пасует вперед Д.Квигли[10](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 15
					},
					{
						"n": 2,
						"h": 80,
						"w": 256
					},
					{
						"n": 3,
						"h": 177,
						"w": 250
					},
					{
						"n": 4,
						"h": 272,
						"w": 267
					},
					{
						"n": 5,
						"h": 371,
						"w": 265
					},
					{
						"n": 6,
						"h": 52,
						"w": 337
					},
					{
						"n": 7,
						"h": 221,
						"w": 478
					},
					{
						"n": 8,
						"h": 289,
						"w": 344
					},
					{
						"n": 9,
						"h": 395,
						"w": 501
					},
					{
						"n": 10,
						"h": 166,
						"w": 524
					},
					{
						"n": 11,
						"h": 299,
						"w": 587
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 45
					},
					{
						"n": 2,
						"h": 93,
						"w": 161
					},
					{
						"n": 3,
						"h": 187,
						"w": 124
					},
					{
						"n": 4,
						"h": 232,
						"w": 204
					},
					{
						"n": 5,
						"h": 296,
						"w": 189
					},
					{
						"n": 6,
						"h": 229,
						"w": 241
					},
					{
						"n": 7,
						"h": 229,
						"w": 336
					},
					{
						"n": 8,
						"h": 407,
						"w": 461
					},
					{
						"n": 9,
						"h": 94,
						"w": 281
					},
					{
						"n": 10,
						"h": 164,
						"w": 441
					},
					{
						"n": 11,
						"h": 259,
						"w": 414
					}
				],
				"ball": {
					"n": 0,
					"h": 166,
					"w": 524,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 27
		},
		{
			"num": 298,
			"minute": 14,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 12
					},
					{
						"n": 2,
						"h": 77,
						"w": 291
					},
					{
						"n": 3,
						"h": 178,
						"w": 285
					},
					{
						"n": 4,
						"h": 273,
						"w": 302
					},
					{
						"n": 5,
						"h": 376,
						"w": 299
					},
					{
						"n": 6,
						"h": 53,
						"w": 372
					},
					{
						"n": 7,
						"h": 205,
						"w": 510
					},
					{
						"n": 8,
						"h": 294,
						"w": 379
					},
					{
						"n": 9,
						"h": 397,
						"w": 536
					},
					{
						"n": 10,
						"h": 186,
						"w": 559
					},
					{
						"n": 11,
						"h": 286,
						"w": 619
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 39
					},
					{
						"n": 2,
						"h": 118,
						"w": 136
					},
					{
						"n": 3,
						"h": 219,
						"w": 103
					},
					{
						"n": 4,
						"h": 214,
						"w": 166
					},
					{
						"n": 5,
						"h": 270,
						"w": 157
					},
					{
						"n": 6,
						"h": 236,
						"w": 199
					},
					{
						"n": 7,
						"h": 229,
						"w": 301
					},
					{
						"n": 8,
						"h": 407,
						"w": 443
					},
					{
						"n": 9,
						"h": 72,
						"w": 254
					},
					{
						"n": 10,
						"h": 162,
						"w": 406
					},
					{
						"n": 11,
						"h": 270,
						"w": 380
					}
				],
				"ball": {
					"n": 0,
					"h": 186,
					"w": 559,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 35
		},
		{
			"num": 299,
			"minute": 14,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 10
					},
					{
						"n": 2,
						"h": 74,
						"w": 326
					},
					{
						"n": 3,
						"h": 170,
						"w": 314
					},
					{
						"n": 4,
						"h": 277,
						"w": 326
					},
					{
						"n": 5,
						"h": 377,
						"w": 334
					},
					{
						"n": 6,
						"h": 53,
						"w": 407
					},
					{
						"n": 7,
						"h": 189,
						"w": 540
					},
					{
						"n": 8,
						"h": 279,
						"w": 410
					},
					{
						"n": 9,
						"h": 396,
						"w": 571
					},
					{
						"n": 10,
						"h": 206,
						"w": 594
					},
					{
						"n": 11,
						"h": 285,
						"w": 630
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 15
					},
					{
						"n": 2,
						"h": 146,
						"w": 106
					},
					{
						"n": 3,
						"h": 244,
						"w": 90
					},
					{
						"n": 4,
						"h": 235,
						"w": 129
					},
					{
						"n": 5,
						"h": 254,
						"w": 119
					},
					{
						"n": 6,
						"h": 233,
						"w": 155
					},
					{
						"n": 7,
						"h": 235,
						"w": 266
					},
					{
						"n": 8,
						"h": 407,
						"w": 426
					},
					{
						"n": 9,
						"h": 46,
						"w": 231
					},
					{
						"n": 10,
						"h": 164,
						"w": 371
					},
					{
						"n": 11,
						"h": 275,
						"w": 346
					}
				],
				"ball": {
					"n": 0,
					"h": 206,
					"w": 594,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 35
		},
		{
			"num": 300,
			"minute": 14,
			"messages": [
				{
					"owner": 1,
					"mes": "Острый пас в штрафную площадь..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 19
					},
					{
						"n": 2,
						"h": 75,
						"w": 360
					},
					{
						"n": 3,
						"h": 183,
						"w": 316
					},
					{
						"n": 4,
						"h": 284,
						"w": 320
					},
					{
						"n": 5,
						"h": 376,
						"w": 371
					},
					{
						"n": 6,
						"h": 52,
						"w": 444
					},
					{
						"n": 7,
						"h": 179,
						"w": 576
					},
					{
						"n": 8,
						"h": 283,
						"w": 447
					},
					{
						"n": 9,
						"h": 404,
						"w": 607
					},
					{
						"n": 10,
						"h": 200,
						"w": 602
					},
					{
						"n": 11,
						"h": 275,
						"w": 618
					}
				],
				"away": [
					{
						"n": 1,
						"h": 218,
						"w": 13
					},
					{
						"n": 2,
						"h": 177,
						"w": 100
					},
					{
						"n": 3,
						"h": 207,
						"w": 86
					},
					{
						"n": 4,
						"h": 207,
						"w": 105
					},
					{
						"n": 5,
						"h": 251,
						"w": 83
					},
					{
						"n": 6,
						"h": 264,
						"w": 135
					},
					{
						"n": 7,
						"h": 228,
						"w": 230
					},
					{
						"n": 8,
						"h": 405,
						"w": 389
					},
					{
						"n": 9,
						"h": 46,
						"w": 194
					},
					{
						"n": 10,
						"h": 165,
						"w": 334
					},
					{
						"n": 11,
						"h": 275,
						"w": 309
					}
				],
				"ball": {
					"n": 0,
					"h": 275,
					"w": 618,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 37
		},
		{
			"num": 301,
			"minute": 14,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 13
					},
					{
						"n": 2,
						"h": 76,
						"w": 360
					},
					{
						"n": 3,
						"h": 167,
						"w": 319
					},
					{
						"n": 4,
						"h": 273,
						"w": 328
					},
					{
						"n": 5,
						"h": 381,
						"w": 377
					},
					{
						"n": 6,
						"h": 50,
						"w": 464
					},
					{
						"n": 7,
						"h": 160,
						"w": 584
					},
					{
						"n": 8,
						"h": 300,
						"w": 440
					},
					{
						"n": 9,
						"h": 399,
						"w": 620
					},
					{
						"n": 10,
						"h": 185,
						"w": 615
					},
					{
						"n": 11,
						"h": 265,
						"w": 614
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 14
					},
					{
						"n": 2,
						"h": 189,
						"w": 97
					},
					{
						"n": 3,
						"h": 217,
						"w": 69
					},
					{
						"n": 4,
						"h": 221,
						"w": 90
					},
					{
						"n": 5,
						"h": 265,
						"w": 94
					},
					{
						"n": 6,
						"h": 260,
						"w": 115
					},
					{
						"n": 7,
						"h": 239,
						"w": 213
					},
					{
						"n": 8,
						"h": 404,
						"w": 369
					},
					{
						"n": 9,
						"h": 49,
						"w": 174
					},
					{
						"n": 10,
						"h": 161,
						"w": 315
					},
					{
						"n": 11,
						"h": 276,
						"w": 292
					}
				],
				"ball": {
					"n": 0,
					"h": 265,
					"w": 614,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 20
		},
		{
			"num": 302,
			"minute": 14,
			"messages": [
				{
					"owner": 1,
					"mes": "Адам Гилберт[11](Галвэй Юнайтед) прикрывает мяч корпусом..."
				},
				{
					"owner": 1,
					"mes": "Адам Гилберт[11](Галвэй Юнайтед) плечом продавливает Л.Седлачека[22](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 13
					},
					{
						"n": 2,
						"h": 76,
						"w": 360
					},
					{
						"n": 3,
						"h": 167,
						"w": 319
					},
					{
						"n": 4,
						"h": 273,
						"w": 328
					},
					{
						"n": 5,
						"h": 381,
						"w": 377
					},
					{
						"n": 6,
						"h": 49,
						"w": 479
					},
					{
						"n": 7,
						"h": 157,
						"w": 585
					},
					{
						"n": 8,
						"h": 300,
						"w": 440
					},
					{
						"n": 9,
						"h": 399,
						"w": 620
					},
					{
						"n": 10,
						"h": 174,
						"w": 625
					},
					{
						"n": 11,
						"h": 253,
						"w": 623,
						"m": 670
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 14
					},
					{
						"n": 2,
						"h": 189,
						"w": 97,
						"m": 590
					},
					{
						"n": 3,
						"h": 220,
						"w": 64
					},
					{
						"n": 4,
						"h": 231,
						"w": 79
					},
					{
						"n": 5,
						"h": 265,
						"w": 94
					},
					{
						"n": 6,
						"h": 260,
						"w": 115
					},
					{
						"n": 7,
						"h": 247,
						"w": 200
					},
					{
						"n": 8,
						"h": 404,
						"w": 354
					},
					{
						"n": 9,
						"h": 52,
						"w": 159
					},
					{
						"n": 10,
						"h": 158,
						"w": 300
					},
					{
						"n": 11,
						"h": 276,
						"w": 292
					}
				],
				"ball": {
					"n": 0,
					"h": 253,
					"w": 623,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 15
		},
		{
			"num": 303,
			"minute": 14,
			"messages": [
				{
					"owner": 1,
					"mes": "Адам Гилберт[11](Галвэй Юнайтед) бьет из-за пределов штрафной..."
				},
				{
					"owner": 1,
					"mes": "Мяч проходит в метре от штанги."
				}
			],
			"U": {
				"team": 1,
				"player": 11,
				"xg": "0.12"
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 11
					},
					{
						"n": 2,
						"h": 65,
						"w": 368
					},
					{
						"n": 3,
						"h": 174,
						"w": 326
					},
					{
						"n": 4,
						"h": 277,
						"w": 315
					},
					{
						"n": 5,
						"h": 374,
						"w": 363
					},
					{
						"n": 6,
						"h": 47,
						"w": 510
					},
					{
						"n": 7,
						"h": 180,
						"w": 591
					},
					{
						"n": 8,
						"h": 291,
						"w": 470
					},
					{
						"n": 9,
						"h": 391,
						"w": 623
					},
					{
						"n": 10,
						"h": 170,
						"w": 650
					},
					{
						"n": 11,
						"h": 253,
						"w": 623
					}
				],
				"away": [
					{
						"n": 1,
						"h": 245,
						"w": 14
					},
					{
						"n": 2,
						"h": 199,
						"w": 81
					},
					{
						"n": 3,
						"h": 223,
						"w": 53
					},
					{
						"n": 4,
						"h": 261,
						"w": 70
					},
					{
						"n": 5,
						"h": 292,
						"w": 79
					},
					{
						"n": 6,
						"h": 269,
						"w": 101
					},
					{
						"n": 7,
						"h": 232,
						"w": 173
					},
					{
						"n": 8,
						"h": 404,
						"w": 323
					},
					{
						"n": 9,
						"h": 59,
						"w": 129
					},
					{
						"n": 10,
						"h": 159,
						"w": 269
					},
					{
						"n": 11,
						"h": 286,
						"w": 297
					}
				],
				"ball": {
					"n": 0,
					"h": 166,
					"w": 751,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 4
				}
			},
			"interval": 31
		},
		{
			"num": 304,
			"minute": 15,
			"possession": 43,
			"messages": [
				{
					"owner": 2,
					"mes": "Удар от ворот..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 40
					},
					{
						"n": 2,
						"h": 65,
						"w": 173,
						"f": 95
					},
					{
						"n": 3,
						"h": 165,
						"w": 150
					},
					{
						"n": 4,
						"h": 287,
						"w": 150
					},
					{
						"n": 5,
						"h": 383,
						"w": 177,
						"f": 95
					},
					{
						"n": 6,
						"h": 75,
						"w": 277
					},
					{
						"n": 7,
						"h": 163,
						"w": 250,
						"f": 95
					},
					{
						"n": 8,
						"h": 270,
						"w": 250
					},
					{
						"n": 9,
						"h": 373,
						"w": 274
					},
					{
						"n": 10,
						"h": 167,
						"w": 350
					},
					{
						"n": 11,
						"h": 289,
						"w": 350,
						"f": 95
					}
				],
				"away": [
					{
						"n": 1,
						"h": 260,
						"w": 14
					},
					{
						"n": 2,
						"h": 59,
						"w": 175,
						"m": 600
					},
					{
						"n": 3,
						"h": 172,
						"w": 175
					},
					{
						"n": 4,
						"h": 292,
						"w": 175
					},
					{
						"n": 5,
						"h": 387,
						"w": 175,
						"f": 94
					},
					{
						"n": 6,
						"h": 225,
						"w": 283
					},
					{
						"n": 7,
						"h": 221,
						"w": 392
					},
					{
						"n": 8,
						"h": 387,
						"w": 372,
						"m": 620
					},
					{
						"n": 9,
						"h": 62,
						"w": 422,
						"f": 94
					},
					{
						"n": 10,
						"h": 163,
						"w": 500
					},
					{
						"n": 11,
						"h": 287,
						"w": 500
					}
				],
				"ball": {
					"n": 0,
					"h": 190,
					"w": 686,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 150
		},
		{
			"num": 305,
			"minute": 15,
			"messages": [],
			"T": {
				"team": 2
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 43
					},
					{
						"n": 2,
						"h": 72,
						"w": 167
					},
					{
						"n": 3,
						"h": 165,
						"w": 153
					},
					{
						"n": 4,
						"h": 292,
						"w": 145
					},
					{
						"n": 5,
						"h": 385,
						"w": 183
					},
					{
						"n": 6,
						"h": 71,
						"w": 272
					},
					{
						"n": 7,
						"h": 158,
						"w": 253
					},
					{
						"n": 8,
						"h": 275,
						"w": 253
					},
					{
						"n": 9,
						"h": 378,
						"w": 269
					},
					{
						"n": 10,
						"h": 165,
						"w": 347
					},
					{
						"n": 11,
						"h": 283,
						"w": 349
					}
				],
				"away": [
					{
						"n": 1,
						"h": 260,
						"w": 34
					},
					{
						"n": 2,
						"h": 65,
						"w": 178
					},
					{
						"n": 3,
						"h": 170,
						"w": 169
					},
					{
						"n": 4,
						"h": 298,
						"w": 169
					},
					{
						"n": 5,
						"h": 387,
						"w": 176
					},
					{
						"n": 6,
						"h": 232,
						"w": 281
					},
					{
						"n": 7,
						"h": 220,
						"w": 388
					},
					{
						"n": 8,
						"h": 388,
						"w": 366
					},
					{
						"n": 9,
						"h": 57,
						"w": 428
					},
					{
						"n": 10,
						"h": 168,
						"w": 493
					},
					{
						"n": 11,
						"h": 289,
						"w": 498
					}
				],
				"ball": {
					"n": 0,
					"h": 190,
					"w": 686,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 15
		},
		{
			"num": 306,
			"minute": 15,
			"messages": [
				{
					"owner": 2,
					"mes": "Крыштоф Ласак[21](Опава) бьет вперед..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 11
					},
					{
						"n": 2,
						"h": 88,
						"w": 202
					},
					{
						"n": 3,
						"h": 224,
						"w": 145
					},
					{
						"n": 4,
						"h": 301,
						"w": 138
					},
					{
						"n": 5,
						"h": 331,
						"w": 137
					},
					{
						"n": 6,
						"h": 12,
						"w": 313
					},
					{
						"n": 7,
						"h": 156,
						"w": 219
					},
					{
						"n": 8,
						"h": 306,
						"w": 225
					},
					{
						"n": 9,
						"h": 409,
						"w": 245
					},
					{
						"n": 10,
						"h": 140,
						"w": 400
					},
					{
						"n": 11,
						"h": 308,
						"w": 449
					}
				],
				"away": [
					{
						"n": 1,
						"h": 229,
						"w": 53
					},
					{
						"n": 2,
						"h": 58,
						"w": 217
					},
					{
						"n": 3,
						"h": 163,
						"w": 170
					},
					{
						"n": 4,
						"h": 283,
						"w": 167
					},
					{
						"n": 5,
						"h": 389,
						"w": 174
					},
					{
						"n": 6,
						"h": 266,
						"w": 303
					},
					{
						"n": 7,
						"h": 322,
						"w": 383
					},
					{
						"n": 8,
						"h": 438,
						"w": 407
					},
					{
						"n": 9,
						"h": 135,
						"w": 361
					},
					{
						"n": 10,
						"h": 144,
						"w": 494
					},
					{
						"n": 11,
						"h": 392,
						"w": 498
					}
				],
				"ball": {
					"n": 0,
					"h": 12,
					"w": 313,
					"z": 1,
					"r": 0,
					"p": 4,
					"x": 0
				}
			},
			"interval": 103
		},
		{
			"num": 307,
			"minute": 15,
			"messages": [
				{
					"owner": 2,
					"mes": "Даниэль Прохазка[28](Опава) в единоборстве с К.Колманом[06](Галвэй Юнайтед) сбрасывает мяч головой..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 10
					},
					{
						"n": 2,
						"h": 52,
						"w": 205
					},
					{
						"n": 3,
						"h": 192,
						"w": 129
					},
					{
						"n": 4,
						"h": 307,
						"w": 121
					},
					{
						"n": 5,
						"h": 339,
						"w": 123
					},
					{
						"n": 6,
						"h": 12,
						"w": 313
					},
					{
						"n": 7,
						"h": 167,
						"w": 203
					},
					{
						"n": 8,
						"h": 319,
						"w": 215
					},
					{
						"n": 9,
						"h": 392,
						"w": 221
					},
					{
						"n": 10,
						"h": 176,
						"w": 400
					},
					{
						"n": 11,
						"h": 279,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 73,
						"m": 600
					},
					{
						"n": 2,
						"h": 76,
						"w": 216
					},
					{
						"n": 3,
						"h": 171,
						"w": 177
					},
					{
						"n": 4,
						"h": 274,
						"w": 180
					},
					{
						"n": 5,
						"h": 381,
						"w": 174
					},
					{
						"n": 6,
						"h": 242,
						"w": 290
					},
					{
						"n": 7,
						"h": 339,
						"w": 414
					},
					{
						"n": 8,
						"h": 430,
						"w": 414
					},
					{
						"n": 9,
						"h": 160,
						"w": 335
					},
					{
						"n": 10,
						"h": 140,
						"w": 488
					},
					{
						"n": 11,
						"h": 416,
						"w": 513
					}
				],
				"ball": {
					"n": 0,
					"h": 34,
					"w": 207,
					"z": 1,
					"r": 0,
					"p": 4,
					"x": 0
				}
			},
			"interval": 36
		},
		{
			"num": 308,
			"minute": 15,
			"messages": [
				{
					"owner": 2,
					"mes": "Шимон Товарек[31](Опава) скидывает мяч головой..."
				},
				{
					"owner": 2,
					"mes": "Даниэль Прохазка[28](Опава) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 10
					},
					{
						"n": 2,
						"h": 54,
						"w": 202
					},
					{
						"n": 3,
						"h": 219,
						"w": 116
					},
					{
						"n": 4,
						"h": 308,
						"w": 115
					},
					{
						"n": 5,
						"h": 341,
						"w": 119
					},
					{
						"n": 6,
						"h": 41,
						"w": 297
					},
					{
						"n": 7,
						"h": 158,
						"w": 206
					},
					{
						"n": 8,
						"h": 310,
						"w": 200
					},
					{
						"n": 9,
						"h": 416,
						"w": 221
					},
					{
						"n": 10,
						"h": 185,
						"w": 400
					},
					{
						"n": 11,
						"h": 274,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 221,
						"w": 90
					},
					{
						"n": 2,
						"h": 61,
						"w": 225
					},
					{
						"n": 3,
						"h": 176,
						"w": 185
					},
					{
						"n": 4,
						"h": 283,
						"w": 183
					},
					{
						"n": 5,
						"h": 380,
						"w": 193
					},
					{
						"n": 6,
						"h": 265,
						"w": 274
					},
					{
						"n": 7,
						"h": 307,
						"w": 420
					},
					{
						"n": 8,
						"h": 428,
						"w": 416
					},
					{
						"n": 9,
						"h": 173,
						"w": 305
					},
					{
						"n": 10,
						"h": 144,
						"w": 485
					},
					{
						"n": 11,
						"h": 413,
						"w": 513
					}
				],
				"ball": {
					"n": 0,
					"h": 22,
					"w": 304,
					"z": 1,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 33
		},
		{
			"num": 309,
			"minute": 15,
			"messages": [
				{
					"owner": 2,
					"mes": "Пас М.Манолову[27](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 15
					},
					{
						"n": 2,
						"h": 72,
						"w": 240
					},
					{
						"n": 3,
						"h": 215,
						"w": 114
					},
					{
						"n": 4,
						"h": 314,
						"w": 103
					},
					{
						"n": 5,
						"h": 349,
						"w": 104
					},
					{
						"n": 6,
						"h": 56,
						"w": 259
					},
					{
						"n": 7,
						"h": 169,
						"w": 258
					},
					{
						"n": 8,
						"h": 316,
						"w": 172
					},
					{
						"n": 9,
						"h": 418,
						"w": 210
					},
					{
						"n": 10,
						"h": 168,
						"w": 400
					},
					{
						"n": 11,
						"h": 307,
						"w": 437
					}
				],
				"away": [
					{
						"n": 1,
						"h": 226,
						"w": 112
					},
					{
						"n": 2,
						"h": 66,
						"w": 278
					},
					{
						"n": 3,
						"h": 181,
						"w": 238
					},
					{
						"n": 4,
						"h": 282,
						"w": 236
					},
					{
						"n": 5,
						"h": 382,
						"w": 246
					},
					{
						"n": 6,
						"h": 250,
						"w": 325
					},
					{
						"n": 7,
						"h": 271,
						"w": 402
					},
					{
						"n": 8,
						"h": 427,
						"w": 426
					},
					{
						"n": 9,
						"h": 157,
						"w": 355
					},
					{
						"n": 10,
						"h": 140,
						"w": 538
					},
					{
						"n": 11,
						"h": 408,
						"w": 460
					}
				],
				"ball": {
					"n": 0,
					"h": 179,
					"w": 318,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 53
		},
		{
			"num": 310,
			"minute": 15,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 13
					},
					{
						"n": 2,
						"h": 56,
						"w": 234
					},
					{
						"n": 3,
						"h": 214,
						"w": 117
					},
					{
						"n": 4,
						"h": 288,
						"w": 123
					},
					{
						"n": 5,
						"h": 330,
						"w": 127
					},
					{
						"n": 6,
						"h": 56,
						"w": 264
					},
					{
						"n": 7,
						"h": 191,
						"w": 262
					},
					{
						"n": 8,
						"h": 324,
						"w": 168
					},
					{
						"n": 9,
						"h": 390,
						"w": 221
					},
					{
						"n": 10,
						"h": 182,
						"w": 400
					},
					{
						"n": 11,
						"h": 311,
						"w": 446
					}
				],
				"away": [
					{
						"n": 1,
						"h": 223,
						"w": 124
					},
					{
						"n": 2,
						"h": 65,
						"w": 295
					},
					{
						"n": 3,
						"h": 168,
						"w": 244
					},
					{
						"n": 4,
						"h": 268,
						"w": 259
					},
					{
						"n": 5,
						"h": 387,
						"w": 268
					},
					{
						"n": 6,
						"h": 237,
						"w": 363
					},
					{
						"n": 7,
						"h": 256,
						"w": 438
					},
					{
						"n": 8,
						"h": 425,
						"w": 466
					},
					{
						"n": 9,
						"h": 148,
						"w": 394
					},
					{
						"n": 10,
						"h": 136,
						"w": 561
					},
					{
						"n": 11,
						"h": 398,
						"w": 421
					}
				],
				"ball": {
					"n": 0,
					"h": 194,
					"w": 282,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 311,
			"minute": 15,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 16
					},
					{
						"n": 2,
						"h": 61,
						"w": 194
					},
					{
						"n": 3,
						"h": 229,
						"w": 125
					},
					{
						"n": 4,
						"h": 281,
						"w": 126
					},
					{
						"n": 5,
						"h": 330,
						"w": 107
					},
					{
						"n": 6,
						"h": 56,
						"w": 226
					},
					{
						"n": 7,
						"h": 227,
						"w": 255
					},
					{
						"n": 8,
						"h": 289,
						"w": 188
					},
					{
						"n": 9,
						"h": 391,
						"w": 261
					},
					{
						"n": 10,
						"h": 177,
						"w": 400
					},
					{
						"n": 11,
						"h": 271,
						"w": 441
					}
				],
				"away": [
					{
						"n": 1,
						"h": 223,
						"w": 124
					},
					{
						"n": 2,
						"h": 52,
						"w": 333
					},
					{
						"n": 3,
						"h": 180,
						"w": 261
					},
					{
						"n": 4,
						"h": 273,
						"w": 299
					},
					{
						"n": 5,
						"h": 379,
						"w": 272
					},
					{
						"n": 6,
						"h": 233,
						"w": 403
					},
					{
						"n": 7,
						"h": 222,
						"w": 447
					},
					{
						"n": 8,
						"h": 419,
						"w": 506
					},
					{
						"n": 9,
						"h": 152,
						"w": 434
					},
					{
						"n": 10,
						"h": 156,
						"w": 587
					},
					{
						"n": 11,
						"h": 398,
						"w": 459
					}
				],
				"ball": {
					"n": 0,
					"h": 228,
					"w": 273,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 312,
			"minute": 15,
			"messages": [
				{
					"owner": 2,
					"mes": "Короткий пас на М.Юрасека[29](Опава)..."
				},
				{
					"owner": 2,
					"mes": "Матей Юрасек[29](Опава) останавливает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 19
					},
					{
						"n": 2,
						"h": 70,
						"w": 170
					},
					{
						"n": 3,
						"h": 254,
						"w": 119
					},
					{
						"n": 4,
						"h": 303,
						"w": 125
					},
					{
						"n": 5,
						"h": 341,
						"w": 116
					},
					{
						"n": 6,
						"h": 56,
						"w": 252
					},
					{
						"n": 7,
						"h": 227,
						"w": 229
					},
					{
						"n": 8,
						"h": 283,
						"w": 213
					},
					{
						"n": 9,
						"h": 388,
						"w": 287
					},
					{
						"n": 10,
						"h": 176,
						"w": 400
					},
					{
						"n": 11,
						"h": 294,
						"w": 429
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 125
					},
					{
						"n": 2,
						"h": 72,
						"w": 332
					},
					{
						"n": 3,
						"h": 169,
						"w": 279
					},
					{
						"n": 4,
						"h": 274,
						"w": 286
					},
					{
						"n": 5,
						"h": 388,
						"w": 281
					},
					{
						"n": 6,
						"h": 225,
						"w": 378
					},
					{
						"n": 7,
						"h": 222,
						"w": 447
					},
					{
						"n": 8,
						"h": 410,
						"w": 530
					},
					{
						"n": 9,
						"h": 172,
						"w": 458
					},
					{
						"n": 10,
						"h": 171,
						"w": 572
					},
					{
						"n": 11,
						"h": 400,
						"w": 433
					}
				],
				"ball": {
					"n": 0,
					"h": 278,
					"w": 262,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 26
		},
		{
			"num": 313,
			"minute": 15,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 18
					},
					{
						"n": 2,
						"h": 63,
						"w": 147
					},
					{
						"n": 3,
						"h": 243,
						"w": 114
					},
					{
						"n": 4,
						"h": 288,
						"w": 129
					},
					{
						"n": 5,
						"h": 330,
						"w": 112
					},
					{
						"n": 6,
						"h": 44,
						"w": 236
					},
					{
						"n": 7,
						"h": 205,
						"w": 196
					},
					{
						"n": 8,
						"h": 265,
						"w": 207
					},
					{
						"n": 9,
						"h": 407,
						"w": 252
					},
					{
						"n": 10,
						"h": 180,
						"w": 400
					},
					{
						"n": 11,
						"h": 316,
						"w": 446
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 124
					},
					{
						"n": 2,
						"h": 65,
						"w": 307
					},
					{
						"n": 3,
						"h": 171,
						"w": 253
					},
					{
						"n": 4,
						"h": 270,
						"w": 246
					},
					{
						"n": 5,
						"h": 382,
						"w": 258
					},
					{
						"n": 6,
						"h": 237,
						"w": 347
					},
					{
						"n": 7,
						"h": 244,
						"w": 461
					},
					{
						"n": 8,
						"h": 395,
						"w": 559
					},
					{
						"n": 9,
						"h": 187,
						"w": 495
					},
					{
						"n": 10,
						"h": 153,
						"w": 575
					},
					{
						"n": 11,
						"h": 407,
						"w": 394
					}
				],
				"ball": {
					"n": 0,
					"h": 263,
					"w": 225,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 314,
			"minute": 15,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 17
					},
					{
						"n": 2,
						"h": 63,
						"w": 148
					},
					{
						"n": 3,
						"h": 243,
						"w": 118
					},
					{
						"n": 4,
						"h": 286,
						"w": 126
					},
					{
						"n": 5,
						"h": 330,
						"w": 116
					},
					{
						"n": 6,
						"h": 44,
						"w": 236
					},
					{
						"n": 7,
						"h": 201,
						"w": 198
					},
					{
						"n": 8,
						"h": 265,
						"w": 211
					},
					{
						"n": 9,
						"h": 407,
						"w": 248
					},
					{
						"n": 10,
						"h": 180,
						"w": 400
					},
					{
						"n": 11,
						"h": 313,
						"w": 443
					}
				],
				"away": [
					{
						"n": 1,
						"h": 226,
						"w": 120
					},
					{
						"n": 2,
						"h": 63,
						"w": 310
					},
					{
						"n": 3,
						"h": 173,
						"w": 257
					},
					{
						"n": 4,
						"h": 270,
						"w": 250
					},
					{
						"n": 5,
						"h": 383,
						"w": 262
					},
					{
						"n": 6,
						"h": 234,
						"w": 350
					},
					{
						"n": 7,
						"h": 242,
						"w": 464
					},
					{
						"n": 8,
						"h": 399,
						"w": 559
					},
					{
						"n": 9,
						"h": 187,
						"w": 499
					},
					{
						"n": 10,
						"h": 157,
						"w": 573
					},
					{
						"n": 11,
						"h": 404,
						"w": 391
					}
				],
				"ball": {
					"n": 0,
					"h": 263,
					"w": 221,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 4
		},
		{
			"num": 315,
			"minute": 15,
			"messages": [
				{
					"owner": 2,
					"mes": "М.Юрасек[29](Опава) пытается пройти К.Нолана[08](Галвэй Юнайтед)..."
				},
				{
					"owner": 2,
					"mes": "Матей Юрасек[29](Опава) прокидывает мяч мимо К.Нолана[08](Галвэй Юнайтед)..."
				},
				{
					"owner": 2,
					"mes": "Нарушение правил! Киран Нолан[08](Галвэй Юнайтед) цепляет М.Юрасека[29](Опава)..."
				},
				{
					"owner": 2,
					"mes": "Судья тянется к карману... Желтая карточка!..."
				}
			],
			"L": {
				"team": 1
			},
			"Y": {
				"team": 1,
				"player": 8
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 16
					},
					{
						"n": 2,
						"h": 56,
						"w": 148
					},
					{
						"n": 3,
						"h": 248,
						"w": 125
					},
					{
						"n": 4,
						"h": 280,
						"w": 114
					},
					{
						"n": 5,
						"h": 330,
						"w": 121
					},
					{
						"n": 6,
						"h": 44,
						"w": 236
					},
					{
						"n": 7,
						"h": 191,
						"w": 199
					},
					{
						"n": 8,
						"h": 265,
						"w": 211,
						"m": 590
					},
					{
						"n": 9,
						"h": 410,
						"w": 233
					},
					{
						"n": 10,
						"h": 179,
						"w": 400
					},
					{
						"n": 11,
						"h": 298,
						"w": 444
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 123
					},
					{
						"n": 2,
						"h": 72,
						"w": 309
					},
					{
						"n": 3,
						"h": 168,
						"w": 259
					},
					{
						"n": 4,
						"h": 271,
						"w": 254
					},
					{
						"n": 5,
						"h": 382,
						"w": 277
					},
					{
						"n": 6,
						"h": 238,
						"w": 365
					},
					{
						"n": 7,
						"h": 238,
						"w": 479
					},
					{
						"n": 8,
						"h": 414,
						"w": 559
					},
					{
						"n": 9,
						"h": 185,
						"w": 514,
						"m": 640
					},
					{
						"n": 10,
						"h": 167,
						"w": 584
					},
					{
						"n": 11,
						"h": 409,
						"w": 382
					}
				],
				"ball": {
					"n": 0,
					"h": 265,
					"w": 206,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 2
				}
			},
			"interval": 15
		},
		{
			"num": 316,
			"minute": 15,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 10
					},
					{
						"n": 2,
						"h": 225,
						"w": 120
					},
					{
						"n": 3,
						"h": 200,
						"w": 70
					},
					{
						"n": 4,
						"h": 225,
						"w": 70
					},
					{
						"n": 5,
						"h": 250,
						"w": 70
					},
					{
						"n": 6,
						"h": 150,
						"w": 420
					},
					{
						"n": 7,
						"h": 270,
						"w": 120
					},
					{
						"n": 8,
						"h": 261,
						"w": 152
					},
					{
						"n": 9,
						"h": 249,
						"w": 153
					},
					{
						"n": 10,
						"h": 235,
						"w": 90
					},
					{
						"n": 11,
						"h": 215,
						"w": 90
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 40
					},
					{
						"n": 2,
						"h": 150,
						"w": 280
					},
					{
						"n": 3,
						"h": 200,
						"w": 640
					},
					{
						"n": 4,
						"h": 250,
						"w": 640
					},
					{
						"n": 5,
						"h": 193,
						"w": 507
					},
					{
						"n": 6,
						"h": 300,
						"w": 280
					},
					{
						"n": 7,
						"h": 177,
						"w": 498
					},
					{
						"n": 8,
						"h": 215,
						"w": 620
					},
					{
						"n": 9,
						"h": 225,
						"w": 640
					},
					{
						"n": 10,
						"h": 225,
						"w": 590
					},
					{
						"n": 11,
						"h": 235,
						"w": 620
					}
				],
				"ball": {
					"n": 0,
					"h": 265,
					"w": 206,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 100
		},
		{
			"num": 317,
			"minute": 15,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 15
					},
					{
						"n": 2,
						"h": 223,
						"w": 121
					},
					{
						"n": 3,
						"h": 202,
						"w": 72
					},
					{
						"n": 4,
						"h": 223,
						"w": 69
					},
					{
						"n": 5,
						"h": 250,
						"w": 72
					},
					{
						"n": 6,
						"h": 148,
						"w": 421
					},
					{
						"n": 7,
						"h": 272,
						"w": 118
					},
					{
						"n": 8,
						"h": 261,
						"w": 152
					},
					{
						"n": 9,
						"h": 249,
						"w": 153
					},
					{
						"n": 10,
						"h": 234,
						"w": 89
					},
					{
						"n": 11,
						"h": 217,
						"w": 91
					}
				],
				"away": [
					{
						"n": 1,
						"h": 223,
						"w": 40
					},
					{
						"n": 2,
						"h": 148,
						"w": 280
					},
					{
						"n": 3,
						"h": 201,
						"w": 638
					},
					{
						"n": 4,
						"h": 251,
						"w": 638
					},
					{
						"n": 5,
						"h": 191,
						"w": 504
					},
					{
						"n": 6,
						"h": 302,
						"w": 280
					},
					{
						"n": 7,
						"h": 175,
						"w": 495
					},
					{
						"n": 8,
						"h": 216,
						"w": 618
					},
					{
						"n": 9,
						"h": 227,
						"w": 639
					},
					{
						"n": 10,
						"h": 226,
						"w": 590
					},
					{
						"n": 11,
						"h": 236,
						"w": 619
					}
				],
				"ball": {
					"n": 0,
					"h": 265,
					"w": 206,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 30
		},
		{
			"num": 318,
			"minute": 15,
			"messages": [
				{
					"owner": 2,
					"mes": "До ворот 35 метров... У мяча М.Манолов[27](Опава)... Мирослав Манолов[27](Опава) разбегается..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 20
					},
					{
						"n": 2,
						"h": 220,
						"w": 122
					},
					{
						"n": 3,
						"h": 195,
						"w": 66
					},
					{
						"n": 4,
						"h": 229,
						"w": 76
					},
					{
						"n": 5,
						"h": 256,
						"w": 77
					},
					{
						"n": 6,
						"h": 144,
						"w": 414
					},
					{
						"n": 7,
						"h": 268,
						"w": 119
					},
					{
						"n": 8,
						"h": 261,
						"w": 152
					},
					{
						"n": 9,
						"h": 249,
						"w": 153
					},
					{
						"n": 10,
						"h": 241,
						"w": 87
					},
					{
						"n": 11,
						"h": 225,
						"w": 96
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 40
					},
					{
						"n": 2,
						"h": 152,
						"w": 282
					},
					{
						"n": 3,
						"h": 208,
						"w": 633
					},
					{
						"n": 4,
						"h": 254,
						"w": 640
					},
					{
						"n": 5,
						"h": 185,
						"w": 511
					},
					{
						"n": 6,
						"h": 308,
						"w": 275
					},
					{
						"n": 7,
						"h": 185,
						"w": 514
					},
					{
						"n": 8,
						"h": 219,
						"w": 624
					},
					{
						"n": 9,
						"h": 222,
						"w": 644
					},
					{
						"n": 10,
						"h": 228,
						"w": 583
					},
					{
						"n": 11,
						"h": 238,
						"w": 617
					}
				],
				"ball": {
					"n": 0,
					"h": 265,
					"w": 206,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 15
		},
		{
			"num": 319,
			"minute": 15,
			"messages": [
				{
					"owner": 2,
					"mes": "Мощнейший удар..."
				},
				{
					"owner": 2,
					"mes": "Выше ворот."
				}
			],
			"F": {
				"team": 2
			},
			"U": {
				"team": 2,
				"player": 7,
				"xg": "0.01"
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 245,
						"w": 20
					},
					{
						"n": 2,
						"h": 179,
						"w": 118
					},
					{
						"n": 3,
						"h": 202,
						"w": 64
					},
					{
						"n": 4,
						"h": 215,
						"w": 52
					},
					{
						"n": 5,
						"h": 298,
						"w": 61
					},
					{
						"n": 6,
						"h": 152,
						"w": 378
					},
					{
						"n": 7,
						"h": 277,
						"w": 170
					},
					{
						"n": 8,
						"h": 261,
						"w": 152
					},
					{
						"n": 9,
						"h": 249,
						"w": 153
					},
					{
						"n": 10,
						"h": 250,
						"w": 112
					},
					{
						"n": 11,
						"h": 187,
						"w": 91
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 64
					},
					{
						"n": 2,
						"h": 175,
						"w": 324
					},
					{
						"n": 3,
						"h": 208,
						"w": 605
					},
					{
						"n": 4,
						"h": 258,
						"w": 612
					},
					{
						"n": 5,
						"h": 219,
						"w": 486
					},
					{
						"n": 6,
						"h": 276,
						"w": 324
					},
					{
						"n": 7,
						"h": 185,
						"w": 514,
						"m": 560
					},
					{
						"n": 8,
						"h": 255,
						"w": 612
					},
					{
						"n": 9,
						"h": 184,
						"w": 634
					},
					{
						"n": 10,
						"h": 181,
						"w": 575
					},
					{
						"n": 11,
						"h": 287,
						"w": 634
					}
				],
				"ball": {
					"n": 0,
					"h": 248,
					"w": -32,
					"z": 1,
					"r": 2,
					"p": 0,
					"x": 4
				}
			},
			"interval": 48
		},
		{
			"num": 320,
			"minute": 16,
			"possession": 42,
			"messages": [
				{
					"owner": 1,
					"mes": "Удар от ворот... Мэттью Глэдхилл[01](Галвэй Юнайтед) устанавливает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 261,
						"w": 14,
						"f": 98
					},
					{
						"n": 2,
						"h": 61,
						"w": 205
					},
					{
						"n": 3,
						"h": 168,
						"w": 205,
						"f": 96
					},
					{
						"n": 4,
						"h": 276,
						"w": 205
					},
					{
						"n": 5,
						"h": 377,
						"w": 205
					},
					{
						"n": 6,
						"h": 67,
						"w": 332
					},
					{
						"n": 7,
						"h": 171,
						"w": 352
					},
					{
						"n": 8,
						"h": 291,
						"w": 352,
						"f": 94
					},
					{
						"n": 9,
						"h": 390,
						"w": 332,
						"f": 94
					},
					{
						"n": 10,
						"h": 166,
						"w": 500,
						"f": 94
					},
					{
						"n": 11,
						"h": 291,
						"w": 500
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 40,
						"f": 94
					},
					{
						"n": 2,
						"h": 63,
						"w": 157,
						"f": 92
					},
					{
						"n": 3,
						"h": 164,
						"w": 130
					},
					{
						"n": 4,
						"h": 294,
						"w": 130
					},
					{
						"n": 5,
						"h": 373,
						"w": 150
					},
					{
						"n": 6,
						"h": 223,
						"w": 200
					},
					{
						"n": 7,
						"h": 226,
						"w": 348
					},
					{
						"n": 8,
						"h": 380,
						"w": 372
					},
					{
						"n": 9,
						"h": 77,
						"w": 424
					},
					{
						"n": 10,
						"h": 165,
						"w": 448
					},
					{
						"n": 11,
						"h": 292,
						"w": 448
					}
				],
				"ball": {
					"n": 0,
					"h": 260,
					"w": 34,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 150
		},
		{
			"num": 321,
			"minute": 16,
			"messages": [],
			"T": {
				"team": 1
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 260,
						"w": 34
					},
					{
						"n": 2,
						"h": 68,
						"w": 200
					},
					{
						"n": 3,
						"h": 172,
						"w": 210
					},
					{
						"n": 4,
						"h": 282,
						"w": 208
					},
					{
						"n": 5,
						"h": 382,
						"w": 202
					},
					{
						"n": 6,
						"h": 67,
						"w": 328
					},
					{
						"n": 7,
						"h": 164,
						"w": 354
					},
					{
						"n": 8,
						"h": 285,
						"w": 350
					},
					{
						"n": 9,
						"h": 393,
						"w": 333
					},
					{
						"n": 10,
						"h": 170,
						"w": 504
					},
					{
						"n": 11,
						"h": 290,
						"w": 500
					}
				],
				"away": [
					{
						"n": 1,
						"h": 229,
						"w": 42
					},
					{
						"n": 2,
						"h": 66,
						"w": 161
					},
					{
						"n": 3,
						"h": 160,
						"w": 128
					},
					{
						"n": 4,
						"h": 290,
						"w": 135
					},
					{
						"n": 5,
						"h": 369,
						"w": 156
					},
					{
						"n": 6,
						"h": 219,
						"w": 197
					},
					{
						"n": 7,
						"h": 229,
						"w": 341
					},
					{
						"n": 8,
						"h": 374,
						"w": 370
					},
					{
						"n": 9,
						"h": 77,
						"w": 420
					},
					{
						"n": 10,
						"h": 159,
						"w": 447
					},
					{
						"n": 11,
						"h": 298,
						"w": 452
					}
				],
				"ball": {
					"n": 0,
					"h": 260,
					"w": 34,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 15
		},
		{
			"num": 322,
			"minute": 16,
			"messages": [
				{
					"owner": 1,
					"mes": "Мэттью Глэдхилл[01](Галвэй Юнайтед) далеко выбивает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 24
					},
					{
						"n": 2,
						"h": 67,
						"w": 253
					},
					{
						"n": 3,
						"h": 171,
						"w": 212
					},
					{
						"n": 4,
						"h": 274,
						"w": 205
					},
					{
						"n": 5,
						"h": 375,
						"w": 247
					},
					{
						"n": 6,
						"h": 49,
						"w": 404
					},
					{
						"n": 7,
						"h": 164,
						"w": 375
					},
					{
						"n": 8,
						"h": 244,
						"w": 345
					},
					{
						"n": 9,
						"h": 402,
						"w": 410
					},
					{
						"n": 10,
						"h": 159,
						"w": 507
					},
					{
						"n": 11,
						"h": 299,
						"w": 497
					}
				],
				"away": [
					{
						"n": 1,
						"h": 228,
						"w": 72
					},
					{
						"n": 2,
						"h": 110,
						"w": 123
					},
					{
						"n": 3,
						"h": 162,
						"w": 138
					},
					{
						"n": 4,
						"h": 272,
						"w": 111
					},
					{
						"n": 5,
						"h": 340,
						"w": 120
					},
					{
						"n": 6,
						"h": 293,
						"w": 180
					},
					{
						"n": 7,
						"h": 206,
						"w": 375
					},
					{
						"n": 8,
						"h": 397,
						"w": 296
					},
					{
						"n": 9,
						"h": 66,
						"w": 343
					},
					{
						"n": 10,
						"h": 163,
						"w": 369
					},
					{
						"n": 11,
						"h": 291,
						"w": 375
					}
				],
				"ball": {
					"n": 0,
					"h": 244,
					"w": 345,
					"z": 1,
					"r": 0,
					"p": 4,
					"x": 0
				}
			},
			"interval": 78
		},
		{
			"num": 323,
			"minute": 16,
			"messages": [
				{
					"owner": 1,
					"mes": "Киран Нолан[08](Галвэй Юнайтед) прыгает выше, чем М.Манолов[27](Опава) и пасует головой..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 15
					},
					{
						"n": 2,
						"h": 78,
						"w": 260
					},
					{
						"n": 3,
						"h": 181,
						"w": 200
					},
					{
						"n": 4,
						"h": 277,
						"w": 198
					},
					{
						"n": 5,
						"h": 383,
						"w": 253
					},
					{
						"n": 6,
						"h": 48,
						"w": 441
					},
					{
						"n": 7,
						"h": 176,
						"w": 406
					},
					{
						"n": 8,
						"h": 261,
						"w": 340,
						"m": 600
					},
					{
						"n": 9,
						"h": 397,
						"w": 447
					},
					{
						"n": 10,
						"h": 175,
						"w": 474
					},
					{
						"n": 11,
						"h": 312,
						"w": 494
					}
				],
				"away": [
					{
						"n": 1,
						"h": 221,
						"w": 77
					},
					{
						"n": 2,
						"h": 110,
						"w": 114
					},
					{
						"n": 3,
						"h": 155,
						"w": 102
					},
					{
						"n": 4,
						"h": 260,
						"w": 107
					},
					{
						"n": 5,
						"h": 340,
						"w": 109
					},
					{
						"n": 6,
						"h": 286,
						"w": 217
					},
					{
						"n": 7,
						"h": 206,
						"w": 375
					},
					{
						"n": 8,
						"h": 400,
						"w": 259
					},
					{
						"n": 9,
						"h": 60,
						"w": 306
					},
					{
						"n": 10,
						"h": 189,
						"w": 360
					},
					{
						"n": 11,
						"h": 281,
						"w": 344
					}
				],
				"ball": {
					"n": 0,
					"h": 190,
					"w": 441,
					"z": 1,
					"r": 0,
					"p": 1,
					"x": 0
				}
			},
			"interval": 37
		},
		{
			"num": 324,
			"minute": 16,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 17
					},
					{
						"n": 2,
						"h": 69,
						"w": 253
					},
					{
						"n": 3,
						"h": 174,
						"w": 209
					},
					{
						"n": 4,
						"h": 268,
						"w": 205
					},
					{
						"n": 5,
						"h": 386,
						"w": 250
					},
					{
						"n": 6,
						"h": 47,
						"w": 452
					},
					{
						"n": 7,
						"h": 167,
						"w": 400
					},
					{
						"n": 8,
						"h": 269,
						"w": 333
					},
					{
						"n": 9,
						"h": 397,
						"w": 458
					},
					{
						"n": 10,
						"h": 180,
						"w": 460
					},
					{
						"n": 11,
						"h": 311,
						"w": 505
					}
				],
				"away": [
					{
						"n": 1,
						"h": 226,
						"w": 75
					},
					{
						"n": 2,
						"h": 110,
						"w": 116
					},
					{
						"n": 3,
						"h": 166,
						"w": 102
					},
					{
						"n": 4,
						"h": 267,
						"w": 113
					},
					{
						"n": 5,
						"h": 340,
						"w": 108
					},
					{
						"n": 6,
						"h": 282,
						"w": 227
					},
					{
						"n": 7,
						"h": 207,
						"w": 364
					},
					{
						"n": 8,
						"h": 401,
						"w": 248
					},
					{
						"n": 9,
						"h": 57,
						"w": 296
					},
					{
						"n": 10,
						"h": 183,
						"w": 351
					},
					{
						"n": 11,
						"h": 282,
						"w": 333
					}
				],
				"ball": {
					"n": 0,
					"h": 180,
					"w": 460,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 11
		},
		{
			"num": 325,
			"minute": 16,
			"messages": [
				{
					"owner": 1,
					"mes": "Джо Квигли[10](Галвэй Юнайтед) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 11
					},
					{
						"n": 2,
						"h": 67,
						"w": 288
					},
					{
						"n": 3,
						"h": 174,
						"w": 244
					},
					{
						"n": 4,
						"h": 269,
						"w": 240
					},
					{
						"n": 5,
						"h": 387,
						"w": 285
					},
					{
						"n": 6,
						"h": 49,
						"w": 487
					},
					{
						"n": 7,
						"h": 166,
						"w": 435
					},
					{
						"n": 8,
						"h": 292,
						"w": 329
					},
					{
						"n": 9,
						"h": 401,
						"w": 493
					},
					{
						"n": 10,
						"h": 200,
						"w": 495
					},
					{
						"n": 11,
						"h": 300,
						"w": 538
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 72
					},
					{
						"n": 2,
						"h": 110,
						"w": 104
					},
					{
						"n": 3,
						"h": 160,
						"w": 104
					},
					{
						"n": 4,
						"h": 240,
						"w": 91
					},
					{
						"n": 5,
						"h": 340,
						"w": 102
					},
					{
						"n": 6,
						"h": 250,
						"w": 204
					},
					{
						"n": 7,
						"h": 209,
						"w": 329
					},
					{
						"n": 8,
						"h": 401,
						"w": 213
					},
					{
						"n": 9,
						"h": 32,
						"w": 272
					},
					{
						"n": 10,
						"h": 169,
						"w": 319
					},
					{
						"n": 11,
						"h": 283,
						"w": 298
					}
				],
				"ball": {
					"n": 0,
					"h": 200,
					"w": 495,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 35
		},
		{
			"num": 326,
			"minute": 16,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 13
					},
					{
						"n": 2,
						"h": 71,
						"w": 328
					},
					{
						"n": 3,
						"h": 172,
						"w": 284
					},
					{
						"n": 4,
						"h": 268,
						"w": 280
					},
					{
						"n": 5,
						"h": 383,
						"w": 325
					},
					{
						"n": 6,
						"h": 46,
						"w": 527
					},
					{
						"n": 7,
						"h": 158,
						"w": 475
					},
					{
						"n": 8,
						"h": 291,
						"w": 369
					},
					{
						"n": 9,
						"h": 404,
						"w": 532
					},
					{
						"n": 10,
						"h": 160,
						"w": 491
					},
					{
						"n": 11,
						"h": 296,
						"w": 578
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 32
					},
					{
						"n": 2,
						"h": 110,
						"w": 98
					},
					{
						"n": 3,
						"h": 171,
						"w": 102
					},
					{
						"n": 4,
						"h": 272,
						"w": 115
					},
					{
						"n": 5,
						"h": 340,
						"w": 103
					},
					{
						"n": 6,
						"h": 286,
						"w": 207
					},
					{
						"n": 7,
						"h": 226,
						"w": 293
					},
					{
						"n": 8,
						"h": 403,
						"w": 173
					},
					{
						"n": 9,
						"h": 37,
						"w": 257
					},
					{
						"n": 10,
						"h": 159,
						"w": 331
					},
					{
						"n": 11,
						"h": 288,
						"w": 305
					}
				],
				"ball": {
					"n": 0,
					"h": 160,
					"w": 491,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 327,
			"minute": 16,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 17
					},
					{
						"n": 2,
						"h": 63,
						"w": 359
					},
					{
						"n": 3,
						"h": 180,
						"w": 298
					},
					{
						"n": 4,
						"h": 273,
						"w": 305
					},
					{
						"n": 5,
						"h": 387,
						"w": 343
					},
					{
						"n": 6,
						"h": 60,
						"w": 564
					},
					{
						"n": 7,
						"h": 150,
						"w": 514
					},
					{
						"n": 8,
						"h": 293,
						"w": 409
					},
					{
						"n": 9,
						"h": 410,
						"w": 572
					},
					{
						"n": 10,
						"h": 121,
						"w": 483
					},
					{
						"n": 11,
						"h": 287,
						"w": 613
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 13
					},
					{
						"n": 2,
						"h": 110,
						"w": 91
					},
					{
						"n": 3,
						"h": 175,
						"w": 92
					},
					{
						"n": 4,
						"h": 276,
						"w": 95
					},
					{
						"n": 5,
						"h": 340,
						"w": 80
					},
					{
						"n": 6,
						"h": 332,
						"w": 220
					},
					{
						"n": 7,
						"h": 226,
						"w": 253
					},
					{
						"n": 8,
						"h": 394,
						"w": 134
					},
					{
						"n": 9,
						"h": 42,
						"w": 238
					},
					{
						"n": 10,
						"h": 157,
						"w": 291
					},
					{
						"n": 11,
						"h": 285,
						"w": 303
					}
				],
				"ball": {
					"n": 0,
					"h": 121,
					"w": 483,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 328,
			"minute": 16,
			"messages": [
				{
					"owner": 1,
					"mes": "Передача вперед..."
				},
				{
					"owner": 1,
					"mes": "Агуст Хлинссон[07](Галвэй Юнайтед) принимает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 11
					},
					{
						"n": 2,
						"h": 78,
						"w": 372
					},
					{
						"n": 3,
						"h": 179,
						"w": 319
					},
					{
						"n": 4,
						"h": 267,
						"w": 312
					},
					{
						"n": 5,
						"h": 376,
						"w": 358
					},
					{
						"n": 6,
						"h": 57,
						"w": 573
					},
					{
						"n": 7,
						"h": 150,
						"w": 514
					},
					{
						"n": 8,
						"h": 289,
						"w": 429
					},
					{
						"n": 9,
						"h": 407,
						"w": 593
					},
					{
						"n": 10,
						"h": 122,
						"w": 493
					},
					{
						"n": 11,
						"h": 291,
						"w": 613
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 11
					},
					{
						"n": 2,
						"h": 110,
						"w": 95
					},
					{
						"n": 3,
						"h": 172,
						"w": 85
					},
					{
						"n": 4,
						"h": 279,
						"w": 100
					},
					{
						"n": 5,
						"h": 340,
						"w": 95
					},
					{
						"n": 6,
						"h": 308,
						"w": 209
					},
					{
						"n": 7,
						"h": 226,
						"w": 232
					},
					{
						"n": 8,
						"h": 393,
						"w": 113
					},
					{
						"n": 9,
						"h": 40,
						"w": 238
					},
					{
						"n": 10,
						"h": 161,
						"w": 271
					},
					{
						"n": 11,
						"h": 284,
						"w": 298
					}
				],
				"ball": {
					"n": 0,
					"h": 150,
					"w": 514,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 21
		},
		{
			"num": 329,
			"minute": 16,
			"messages": [
				{
					"owner": 1,
					"mes": "Агуст Хлинссон[07](Галвэй Юнайтед) смотрит направо... Пас Э.Бвомоно[09](Галвэй Юнайтед)..."
				},
				{
					"owner": 1,
					"mes": "Элвис Бвомоно[09](Галвэй Юнайтед) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 18
					},
					{
						"n": 2,
						"h": 64,
						"w": 360
					},
					{
						"n": 3,
						"h": 165,
						"w": 317
					},
					{
						"n": 4,
						"h": 277,
						"w": 320
					},
					{
						"n": 5,
						"h": 388,
						"w": 364
					},
					{
						"n": 6,
						"h": 50,
						"w": 593
					},
					{
						"n": 7,
						"h": 158,
						"w": 522,
						"m": 660
					},
					{
						"n": 8,
						"h": 301,
						"w": 500
					},
					{
						"n": 9,
						"h": 435,
						"w": 563
					},
					{
						"n": 10,
						"h": 148,
						"w": 560
					},
					{
						"n": 11,
						"h": 276,
						"w": 633
					}
				],
				"away": [
					{
						"n": 1,
						"h": 213,
						"w": 9
					},
					{
						"n": 2,
						"h": 91,
						"w": 69
					},
					{
						"n": 3,
						"h": 193,
						"w": 69
					},
					{
						"n": 4,
						"h": 272,
						"w": 82
					},
					{
						"n": 5,
						"h": 340,
						"w": 58
					},
					{
						"n": 6,
						"h": 277,
						"w": 144
					},
					{
						"n": 7,
						"h": 281,
						"w": 185
					},
					{
						"n": 8,
						"h": 408,
						"w": 168
					},
					{
						"n": 9,
						"h": 35,
						"w": 166
					},
					{
						"n": 10,
						"h": 166,
						"w": 291
					},
					{
						"n": 11,
						"h": 292,
						"w": 293
					}
				],
				"ball": {
					"n": 0,
					"h": 435,
					"w": 563,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 72
		},
		{
			"num": 330,
			"minute": 16,
			"messages": [
				{
					"owner": 1,
					"mes": "Передача в штрафную..."
				},
				{
					"owner": 1,
					"mes": "Адам Гилберт[11](Галвэй Юнайтед) технично принимает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 16
					},
					{
						"n": 2,
						"h": 64,
						"w": 371
					},
					{
						"n": 3,
						"h": 167,
						"w": 312
					},
					{
						"n": 4,
						"h": 271,
						"w": 328
					},
					{
						"n": 5,
						"h": 382,
						"w": 365
					},
					{
						"n": 6,
						"h": 58,
						"w": 626
					},
					{
						"n": 7,
						"h": 184,
						"w": 562
					},
					{
						"n": 8,
						"h": 279,
						"w": 458
					},
					{
						"n": 9,
						"h": 429,
						"w": 571
					},
					{
						"n": 10,
						"h": 163,
						"w": 606
					},
					{
						"n": 11,
						"h": 299,
						"w": 613
					}
				],
				"away": [
					{
						"n": 1,
						"h": 216,
						"w": 12
					},
					{
						"n": 2,
						"h": 62,
						"w": 107
					},
					{
						"n": 3,
						"h": 161,
						"w": 87
					},
					{
						"n": 4,
						"h": 224,
						"w": 78
					},
					{
						"n": 5,
						"h": 340,
						"w": 65
					},
					{
						"n": 6,
						"h": 287,
						"w": 110
					},
					{
						"n": 7,
						"h": 236,
						"w": 201
					},
					{
						"n": 8,
						"h": 408,
						"w": 173
					},
					{
						"n": 9,
						"h": 46,
						"w": 213
					},
					{
						"n": 10,
						"h": 171,
						"w": 243
					},
					{
						"n": 11,
						"h": 287,
						"w": 290
					}
				],
				"ball": {
					"n": 0,
					"h": 299,
					"w": 613,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 48
		},
		{
			"num": 331,
			"minute": 16,
			"messages": [
				{
					"owner": 1,
					"mes": "Адам Гилберт[11](Галвэй Юнайтед) выходит на ударную позицию в штрафной..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 15
					},
					{
						"n": 2,
						"h": 76,
						"w": 375
					},
					{
						"n": 3,
						"h": 178,
						"w": 319
					},
					{
						"n": 4,
						"h": 280,
						"w": 319
					},
					{
						"n": 5,
						"h": 380,
						"w": 374
					},
					{
						"n": 6,
						"h": 63,
						"w": 619
					},
					{
						"n": 7,
						"h": 177,
						"w": 573
					},
					{
						"n": 8,
						"h": 291,
						"w": 452
					},
					{
						"n": 9,
						"h": 424,
						"w": 583
					},
					{
						"n": 10,
						"h": 162,
						"w": 619
					},
					{
						"n": 11,
						"h": 299,
						"w": 624
					}
				],
				"away": [
					{
						"n": 1,
						"h": 216,
						"w": 12
					},
					{
						"n": 2,
						"h": 54,
						"w": 118
					},
					{
						"n": 3,
						"h": 151,
						"w": 96
					},
					{
						"n": 4,
						"h": 234,
						"w": 69
					},
					{
						"n": 5,
						"h": 340,
						"w": 66
					},
					{
						"n": 6,
						"h": 284,
						"w": 98
					},
					{
						"n": 7,
						"h": 246,
						"w": 192
					},
					{
						"n": 8,
						"h": 421,
						"w": 170
					},
					{
						"n": 9,
						"h": 33,
						"w": 217
					},
					{
						"n": 10,
						"h": 159,
						"w": 248
					},
					{
						"n": 11,
						"h": 288,
						"w": 303
					}
				],
				"ball": {
					"n": 0,
					"h": 299,
					"w": 624,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 13
		},
		{
			"num": 332,
			"minute": 16,
			"messages": [
				{
					"owner": 1,
					"mes": "А.Гилберт[11](Галвэй Юнайтед) пытается пройти Н.Мансура[23](Опава)..."
				},
				{
					"owner": 1,
					"mes": "Адам Гилберт[11](Галвэй Юнайтед) с помощью дриблинга проходит Н.Мансура[23](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 11
					},
					{
						"n": 2,
						"h": 75,
						"w": 374
					},
					{
						"n": 3,
						"h": 170,
						"w": 321
					},
					{
						"n": 4,
						"h": 268,
						"w": 329
					},
					{
						"n": 5,
						"h": 388,
						"w": 362
					},
					{
						"n": 6,
						"h": 53,
						"w": 640
					},
					{
						"n": 7,
						"h": 161,
						"w": 610
					},
					{
						"n": 8,
						"h": 272,
						"w": 439
					},
					{
						"n": 9,
						"h": 409,
						"w": 620
					},
					{
						"n": 10,
						"h": 158,
						"w": 658
					},
					{
						"n": 11,
						"h": 279,
						"w": 659,
						"m": 680
					}
				],
				"away": [
					{
						"n": 1,
						"h": 217,
						"w": 9
					},
					{
						"n": 2,
						"h": 47,
						"w": 88
					},
					{
						"n": 3,
						"h": 151,
						"w": 96,
						"m": 620
					},
					{
						"n": 4,
						"h": 195,
						"w": 61
					},
					{
						"n": 5,
						"h": 386,
						"w": 73
					},
					{
						"n": 6,
						"h": 287,
						"w": 61
					},
					{
						"n": 7,
						"h": 265,
						"w": 157
					},
					{
						"n": 8,
						"h": 427,
						"w": 140
					},
					{
						"n": 9,
						"h": 43,
						"w": 199
					},
					{
						"n": 10,
						"h": 178,
						"w": 261
					},
					{
						"n": 11,
						"h": 277,
						"w": 306
					}
				],
				"ball": {
					"n": 0,
					"h": 279,
					"w": 659,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 4
				}
			},
			"interval": 40
		},
		{
			"num": 333,
			"minute": 16,
			"messages": [
				{
					"owner": 1,
					"mes": "Адам Гилберт[11](Галвэй Юнайтед) наносит резаный удар..."
				},
				{
					"owner": 1,
					"mes": "Крыштоф Ласак[21](Опава) дотягивается до мяча, но выпускает его из рук!..."
				}
			],
			"U": {
				"team": 1,
				"player": 11,
				"xg": "0.18"
			},
			"V": {
				"team": 1,
				"player": 11
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 12
					},
					{
						"n": 2,
						"h": 64,
						"w": 366
					},
					{
						"n": 3,
						"h": 170,
						"w": 330
					},
					{
						"n": 4,
						"h": 278,
						"w": 326
					},
					{
						"n": 5,
						"h": 386,
						"w": 376
					},
					{
						"n": 6,
						"h": 43,
						"w": 640
					},
					{
						"n": 7,
						"h": 167,
						"w": 605
					},
					{
						"n": 8,
						"h": 277,
						"w": 453
					},
					{
						"n": 9,
						"h": 410,
						"w": 634
					},
					{
						"n": 10,
						"h": 162,
						"w": 672
					},
					{
						"n": 11,
						"h": 279,
						"w": 659,
						"m": 690
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 9,
						"m": 580
					},
					{
						"n": 2,
						"h": 56,
						"w": 77
					},
					{
						"n": 3,
						"h": 165,
						"w": 89
					},
					{
						"n": 4,
						"h": 181,
						"w": 58
					},
					{
						"n": 5,
						"h": 380,
						"w": 61
					},
					{
						"n": 6,
						"h": 290,
						"w": 48
					},
					{
						"n": 7,
						"h": 269,
						"w": 144
					},
					{
						"n": 8,
						"h": 416,
						"w": 140
					},
					{
						"n": 9,
						"h": 45,
						"w": 190
					},
					{
						"n": 10,
						"h": 173,
						"w": 247
					},
					{
						"n": 11,
						"h": 283,
						"w": 294
					}
				],
				"ball": {
					"n": 0,
					"h": 235,
					"w": 711,
					"z": 1,
					"r": 0,
					"p": 1,
					"x": 6
				}
			},
			"interval": 14
		},
		{
			"num": 334,
			"minute": 16,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 236,
						"w": 19
					},
					{
						"n": 2,
						"h": 62,
						"w": 360
					},
					{
						"n": 3,
						"h": 179,
						"w": 334
					},
					{
						"n": 4,
						"h": 282,
						"w": 317
					},
					{
						"n": 5,
						"h": 389,
						"w": 368
					},
					{
						"n": 6,
						"h": 51,
						"w": 644
					},
					{
						"n": 7,
						"h": 161,
						"w": 614
					},
					{
						"n": 8,
						"h": 276,
						"w": 451
					},
					{
						"n": 9,
						"h": 410,
						"w": 631
					},
					{
						"n": 10,
						"h": 165,
						"w": 696
					},
					{
						"n": 11,
						"h": 279,
						"w": 659
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 9
					},
					{
						"n": 2,
						"h": 41,
						"w": 90
					},
					{
						"n": 3,
						"h": 160,
						"w": 81
					},
					{
						"n": 4,
						"h": 194,
						"w": 40
					},
					{
						"n": 5,
						"h": 397,
						"w": 70
					},
					{
						"n": 6,
						"h": 283,
						"w": 30
					},
					{
						"n": 7,
						"h": 278,
						"w": 127
					},
					{
						"n": 8,
						"h": 412,
						"w": 130
					},
					{
						"n": 9,
						"h": 41,
						"w": 188
					},
					{
						"n": 10,
						"h": 176,
						"w": 266
					},
					{
						"n": 11,
						"h": 280,
						"w": 292
					}
				],
				"ball": {
					"n": 0,
					"h": 256,
					"w": 680,
					"z": 0,
					"r": 0,
					"p": 1,
					"x": 5
				}
			},
			"interval": 19
		},
		{
			"num": 335,
			"minute": 16,
			"messages": [
				{
					"owner": 1,
					"mes": "Себастьян Пейша[24](Опава) изо всех сил выносит подальше..."
				},
				{
					"owner": 2,
					"mes": "Матей Юрасек[29](Опава) устремляется к свободному мячу и подхватывает его..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 15
					},
					{
						"n": 2,
						"h": 62,
						"w": 375
					},
					{
						"n": 3,
						"h": 169,
						"w": 324
					},
					{
						"n": 4,
						"h": 278,
						"w": 325
					},
					{
						"n": 5,
						"h": 426,
						"w": 436
					},
					{
						"n": 6,
						"h": 36,
						"w": 620
					},
					{
						"n": 7,
						"h": 219,
						"w": 584
					},
					{
						"n": 8,
						"h": 302,
						"w": 494
					},
					{
						"n": 9,
						"h": 409,
						"w": 640
					},
					{
						"n": 10,
						"h": 175,
						"w": 680
					},
					{
						"n": 11,
						"h": 279,
						"w": 659
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 9
					},
					{
						"n": 2,
						"h": 56,
						"w": 65
					},
					{
						"n": 3,
						"h": 189,
						"w": 55
					},
					{
						"n": 4,
						"h": 194,
						"w": 40,
						"m": 650
					},
					{
						"n": 5,
						"h": 340,
						"w": 52
					},
					{
						"n": 6,
						"h": 279,
						"w": 40
					},
					{
						"n": 7,
						"h": 227,
						"w": 133
					},
					{
						"n": 8,
						"h": 398,
						"w": 75
					},
					{
						"n": 9,
						"h": 11,
						"w": 259
					},
					{
						"n": 10,
						"h": 148,
						"w": 206
					},
					{
						"n": 11,
						"h": 292,
						"w": 298
					}
				],
				"ball": {
					"n": 0,
					"h": 439,
					"w": 461,
					"z": 1,
					"r": 0,
					"p": 4,
					"x": 0
				}
			},
			"interval": 71
		},
		{
			"num": 336,
			"minute": 16,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 10
					},
					{
						"n": 2,
						"h": 86,
						"w": 343
					},
					{
						"n": 3,
						"h": 174,
						"w": 316
					},
					{
						"n": 4,
						"h": 238,
						"w": 326
					},
					{
						"n": 5,
						"h": 397,
						"w": 409
					},
					{
						"n": 6,
						"h": 37,
						"w": 580
					},
					{
						"n": 7,
						"h": 217,
						"w": 544
					},
					{
						"n": 8,
						"h": 301,
						"w": 454
					},
					{
						"n": 9,
						"h": 410,
						"w": 600
					},
					{
						"n": 10,
						"h": 180,
						"w": 640
					},
					{
						"n": 11,
						"h": 287,
						"w": 620
					}
				],
				"away": [
					{
						"n": 1,
						"h": 226,
						"w": 19,
						"m": 590
					},
					{
						"n": 2,
						"h": 62,
						"w": 105
					},
					{
						"n": 3,
						"h": 186,
						"w": 75
					},
					{
						"n": 4,
						"h": 212,
						"w": 48
					},
					{
						"n": 5,
						"h": 356,
						"w": 71
					},
					{
						"n": 6,
						"h": 256,
						"w": 73
					},
					{
						"n": 7,
						"h": 215,
						"w": 171
					},
					{
						"n": 8,
						"h": 400,
						"w": 115
					},
					{
						"n": 9,
						"h": 4,
						"w": 293
					},
					{
						"n": 10,
						"h": 151,
						"w": 246
					},
					{
						"n": 11,
						"h": 271,
						"w": 332
					}
				],
				"ball": {
					"n": 0,
					"h": 446,
					"w": 427,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 337,
			"minute": 16,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 19
					},
					{
						"n": 2,
						"h": 92,
						"w": 304
					},
					{
						"n": 3,
						"h": 180,
						"w": 277
					},
					{
						"n": 4,
						"h": 245,
						"w": 288
					},
					{
						"n": 5,
						"h": 394,
						"w": 381
					},
					{
						"n": 6,
						"h": 36,
						"w": 541
					},
					{
						"n": 7,
						"h": 215,
						"w": 505
					},
					{
						"n": 8,
						"h": 302,
						"w": 415
					},
					{
						"n": 9,
						"h": 411,
						"w": 561
					},
					{
						"n": 10,
						"h": 184,
						"w": 602
					},
					{
						"n": 11,
						"h": 294,
						"w": 582
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 15
					},
					{
						"n": 2,
						"h": 68,
						"w": 143
					},
					{
						"n": 3,
						"h": 180,
						"w": 93
					},
					{
						"n": 4,
						"h": 223,
						"w": 64
					},
					{
						"n": 5,
						"h": 366,
						"w": 109
					},
					{
						"n": 6,
						"h": 243,
						"w": 110
					},
					{
						"n": 7,
						"h": 214,
						"w": 210
					},
					{
						"n": 8,
						"h": 402,
						"w": 154
					},
					{
						"n": 9,
						"h": 6,
						"w": 319
					},
					{
						"n": 10,
						"h": 147,
						"w": 285
					},
					{
						"n": 11,
						"h": 247,
						"w": 363
					}
				],
				"ball": {
					"n": 0,
					"h": 444,
					"w": 401,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 338,
			"minute": 16,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 18
					},
					{
						"n": 2,
						"h": 97,
						"w": 266
					},
					{
						"n": 3,
						"h": 190,
						"w": 240
					},
					{
						"n": 4,
						"h": 252,
						"w": 249
					},
					{
						"n": 5,
						"h": 394,
						"w": 356
					},
					{
						"n": 6,
						"h": 39,
						"w": 502
					},
					{
						"n": 7,
						"h": 214,
						"w": 466
					},
					{
						"n": 8,
						"h": 301,
						"w": 376
					},
					{
						"n": 9,
						"h": 410,
						"w": 522
					},
					{
						"n": 10,
						"h": 190,
						"w": 563
					},
					{
						"n": 11,
						"h": 299,
						"w": 543
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 16
					},
					{
						"n": 2,
						"h": 67,
						"w": 182
					},
					{
						"n": 3,
						"h": 175,
						"w": 111
					},
					{
						"n": 4,
						"h": 248,
						"w": 106
					},
					{
						"n": 5,
						"h": 377,
						"w": 146
					},
					{
						"n": 6,
						"h": 233,
						"w": 147
					},
					{
						"n": 7,
						"h": 212,
						"w": 249
					},
					{
						"n": 8,
						"h": 405,
						"w": 193
					},
					{
						"n": 9,
						"h": 7,
						"w": 344
					},
					{
						"n": 10,
						"h": 145,
						"w": 324
					},
					{
						"n": 11,
						"h": 224,
						"w": 394
					}
				],
				"ball": {
					"n": 0,
					"h": 443,
					"w": 376,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 339,
			"minute": 16,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 11
					},
					{
						"n": 2,
						"h": 125,
						"w": 239
					},
					{
						"n": 3,
						"h": 215,
						"w": 210
					},
					{
						"n": 4,
						"h": 271,
						"w": 215
					},
					{
						"n": 5,
						"h": 394,
						"w": 330
					},
					{
						"n": 6,
						"h": 38,
						"w": 463
					},
					{
						"n": 7,
						"h": 214,
						"w": 427
					},
					{
						"n": 8,
						"h": 298,
						"w": 337
					},
					{
						"n": 9,
						"h": 410,
						"w": 483
					},
					{
						"n": 10,
						"h": 190,
						"w": 524
					},
					{
						"n": 11,
						"h": 304,
						"w": 504
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 11
					},
					{
						"n": 2,
						"h": 73,
						"w": 221
					},
					{
						"n": 3,
						"h": 177,
						"w": 150
					},
					{
						"n": 4,
						"h": 262,
						"w": 142
					},
					{
						"n": 5,
						"h": 376,
						"w": 185
					},
					{
						"n": 6,
						"h": 224,
						"w": 185
					},
					{
						"n": 7,
						"h": 211,
						"w": 288
					},
					{
						"n": 8,
						"h": 409,
						"w": 232
					},
					{
						"n": 9,
						"h": 7,
						"w": 370
					},
					{
						"n": 10,
						"h": 140,
						"w": 362
					},
					{
						"n": 11,
						"h": 197,
						"w": 423
					}
				],
				"ball": {
					"n": 0,
					"h": 443,
					"w": 350,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 340,
			"minute": 16,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 14
					},
					{
						"n": 2,
						"h": 153,
						"w": 211
					},
					{
						"n": 3,
						"h": 241,
						"w": 181
					},
					{
						"n": 4,
						"h": 294,
						"w": 183
					},
					{
						"n": 5,
						"h": 394,
						"w": 305
					},
					{
						"n": 6,
						"h": 41,
						"w": 424
					},
					{
						"n": 7,
						"h": 212,
						"w": 388
					},
					{
						"n": 8,
						"h": 295,
						"w": 298
					},
					{
						"n": 9,
						"h": 411,
						"w": 444
					},
					{
						"n": 10,
						"h": 186,
						"w": 485
					},
					{
						"n": 11,
						"h": 273,
						"w": 481
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 30
					},
					{
						"n": 2,
						"h": 65,
						"w": 259
					},
					{
						"n": 3,
						"h": 178,
						"w": 189
					},
					{
						"n": 4,
						"h": 272,
						"w": 180
					},
					{
						"n": 5,
						"h": 375,
						"w": 224
					},
					{
						"n": 6,
						"h": 217,
						"w": 223
					},
					{
						"n": 7,
						"h": 208,
						"w": 327
					},
					{
						"n": 8,
						"h": 411,
						"w": 271
					},
					{
						"n": 9,
						"h": 7,
						"w": 395
					},
					{
						"n": 10,
						"h": 137,
						"w": 401
					},
					{
						"n": 11,
						"h": 170,
						"w": 451
					}
				],
				"ball": {
					"n": 0,
					"h": 443,
					"w": 325,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 341,
			"minute": 16,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 18
					},
					{
						"n": 2,
						"h": 142,
						"w": 174
					},
					{
						"n": 3,
						"h": 231,
						"w": 143
					},
					{
						"n": 4,
						"h": 299,
						"w": 145
					},
					{
						"n": 5,
						"h": 394,
						"w": 279
					},
					{
						"n": 6,
						"h": 44,
						"w": 385
					},
					{
						"n": 7,
						"h": 215,
						"w": 349
					},
					{
						"n": 8,
						"h": 289,
						"w": 260
					},
					{
						"n": 9,
						"h": 412,
						"w": 405
					},
					{
						"n": 10,
						"h": 180,
						"w": 447
					},
					{
						"n": 11,
						"h": 251,
						"w": 449
					}
				],
				"away": [
					{
						"n": 1,
						"h": 226,
						"w": 49
					},
					{
						"n": 2,
						"h": 61,
						"w": 298
					},
					{
						"n": 3,
						"h": 177,
						"w": 228
					},
					{
						"n": 4,
						"h": 276,
						"w": 219
					},
					{
						"n": 5,
						"h": 385,
						"w": 262
					},
					{
						"n": 6,
						"h": 205,
						"w": 261
					},
					{
						"n": 7,
						"h": 208,
						"w": 366
					},
					{
						"n": 8,
						"h": 414,
						"w": 309
					},
					{
						"n": 9,
						"h": 10,
						"w": 421
					},
					{
						"n": 10,
						"h": 132,
						"w": 440
					},
					{
						"n": 11,
						"h": 146,
						"w": 482
					}
				],
				"ball": {
					"n": 0,
					"h": 440,
					"w": 299,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 342,
			"minute": 16,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 16
					},
					{
						"n": 2,
						"h": 133,
						"w": 136
					},
					{
						"n": 3,
						"h": 227,
						"w": 104
					},
					{
						"n": 4,
						"h": 309,
						"w": 107
					},
					{
						"n": 5,
						"h": 394,
						"w": 254
					},
					{
						"n": 6,
						"h": 53,
						"w": 348
					},
					{
						"n": 7,
						"h": 211,
						"w": 310
					},
					{
						"n": 8,
						"h": 287,
						"w": 221
					},
					{
						"n": 9,
						"h": 408,
						"w": 366
					},
					{
						"n": 10,
						"h": 178,
						"w": 408
					},
					{
						"n": 11,
						"h": 252,
						"w": 410
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 70
					},
					{
						"n": 2,
						"h": 65,
						"w": 336
					},
					{
						"n": 3,
						"h": 179,
						"w": 267
					},
					{
						"n": 4,
						"h": 273,
						"w": 258
					},
					{
						"n": 5,
						"h": 388,
						"w": 301
					},
					{
						"n": 6,
						"h": 198,
						"w": 299
					},
					{
						"n": 7,
						"h": 203,
						"w": 405
					},
					{
						"n": 8,
						"h": 415,
						"w": 348
					},
					{
						"n": 9,
						"h": 8,
						"w": 446
					},
					{
						"n": 10,
						"h": 128,
						"w": 479
					},
					{
						"n": 11,
						"h": 136,
						"w": 520
					}
				],
				"ball": {
					"n": 0,
					"h": 442,
					"w": 274,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 343,
			"minute": 16,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 13
					},
					{
						"n": 2,
						"h": 124,
						"w": 98
					},
					{
						"n": 3,
						"h": 261,
						"w": 85
					},
					{
						"n": 4,
						"h": 312,
						"w": 82
					},
					{
						"n": 5,
						"h": 394,
						"w": 229
					},
					{
						"n": 6,
						"h": 55,
						"w": 309
					},
					{
						"n": 7,
						"h": 209,
						"w": 271
					},
					{
						"n": 8,
						"h": 305,
						"w": 186
					},
					{
						"n": 9,
						"h": 408,
						"w": 327
					},
					{
						"n": 10,
						"h": 177,
						"w": 398
					},
					{
						"n": 11,
						"h": 250,
						"w": 408
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 87
					},
					{
						"n": 2,
						"h": 68,
						"w": 347
					},
					{
						"n": 3,
						"h": 177,
						"w": 295
					},
					{
						"n": 4,
						"h": 273,
						"w": 297
					},
					{
						"n": 5,
						"h": 381,
						"w": 303
					},
					{
						"n": 6,
						"h": 200,
						"w": 338
					},
					{
						"n": 7,
						"h": 203,
						"w": 444
					},
					{
						"n": 8,
						"h": 418,
						"w": 387
					},
					{
						"n": 9,
						"h": 11,
						"w": 471
					},
					{
						"n": 10,
						"h": 120,
						"w": 517
					},
					{
						"n": 11,
						"h": 124,
						"w": 540
					}
				],
				"ball": {
					"n": 0,
					"h": 439,
					"w": 249,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 344,
			"minute": 16,
			"messages": [
				{
					"owner": 2,
					"mes": "Пасует в центральную зону..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 15
					},
					{
						"n": 2,
						"h": 120,
						"w": 127
					},
					{
						"n": 3,
						"h": 271,
						"w": 127
					},
					{
						"n": 4,
						"h": 304,
						"w": 131
					},
					{
						"n": 5,
						"h": 375,
						"w": 170
					},
					{
						"n": 6,
						"h": 56,
						"w": 247
					},
					{
						"n": 7,
						"h": 255,
						"w": 269
					},
					{
						"n": 8,
						"h": 297,
						"w": 202
					},
					{
						"n": 9,
						"h": 402,
						"w": 266
					},
					{
						"n": 10,
						"h": 215,
						"w": 400
					},
					{
						"n": 11,
						"h": 281,
						"w": 446
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 106
					},
					{
						"n": 2,
						"h": 63,
						"w": 313
					},
					{
						"n": 3,
						"h": 169,
						"w": 255
					},
					{
						"n": 4,
						"h": 282,
						"w": 269
					},
					{
						"n": 5,
						"h": 391,
						"w": 279
					},
					{
						"n": 6,
						"h": 235,
						"w": 350
					},
					{
						"n": 7,
						"h": 195,
						"w": 451
					},
					{
						"n": 8,
						"h": 411,
						"w": 449
					},
					{
						"n": 9,
						"h": 32,
						"w": 495
					},
					{
						"n": 10,
						"h": 137,
						"w": 573
					},
					{
						"n": 11,
						"h": 162,
						"w": 504
					}
				],
				"ball": {
					"n": 0,
					"h": 255,
					"w": 269,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 62
		},
		{
			"num": 345,
			"minute": 16,
			"messages": [
				{
					"owner": 2,
					"mes": "Мирослав Манолов[27](Опава) обрабатывает мяч одним касанием..."
				},
				{
					"owner": 2,
					"mes": "А.Хлинссон[07](Галвэй Юнайтед) попадает локтём по корпусу М.Манолова[27](Опава)!..."
				}
			],
			"L": {
				"team": 1
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 15
					},
					{
						"n": 2,
						"h": 120,
						"w": 127
					},
					{
						"n": 3,
						"h": 271,
						"w": 127
					},
					{
						"n": 4,
						"h": 304,
						"w": 131
					},
					{
						"n": 5,
						"h": 375,
						"w": 170
					},
					{
						"n": 6,
						"h": 56,
						"w": 247
					},
					{
						"n": 7,
						"h": 255,
						"w": 269,
						"m": 650
					},
					{
						"n": 8,
						"h": 297,
						"w": 202
					},
					{
						"n": 9,
						"h": 402,
						"w": 266
					},
					{
						"n": 10,
						"h": 215,
						"w": 400
					},
					{
						"n": 11,
						"h": 281,
						"w": 446
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 106
					},
					{
						"n": 2,
						"h": 63,
						"w": 313
					},
					{
						"n": 3,
						"h": 169,
						"w": 255
					},
					{
						"n": 4,
						"h": 282,
						"w": 269
					},
					{
						"n": 5,
						"h": 391,
						"w": 279
					},
					{
						"n": 6,
						"h": 235,
						"w": 350
					},
					{
						"n": 7,
						"h": 195,
						"w": 451,
						"m": 570
					},
					{
						"n": 8,
						"h": 411,
						"w": 449
					},
					{
						"n": 9,
						"h": 32,
						"w": 495
					},
					{
						"n": 10,
						"h": 137,
						"w": 573
					},
					{
						"n": 11,
						"h": 162,
						"w": 504
					}
				],
				"ball": {
					"n": 0,
					"h": 255,
					"w": 269,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 5
		},
		{
			"num": 346,
			"minute": 17,
			"possession": 43,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 10
					},
					{
						"n": 2,
						"h": 76,
						"w": 150
					},
					{
						"n": 3,
						"h": 196,
						"w": 154
					},
					{
						"n": 4,
						"h": 269,
						"w": 151
					},
					{
						"n": 5,
						"h": 372,
						"w": 146
					},
					{
						"n": 6,
						"h": 72,
						"w": 300,
						"f": 94
					},
					{
						"n": 7,
						"h": 194,
						"w": 306
					},
					{
						"n": 8,
						"h": 250,
						"w": 224
					},
					{
						"n": 9,
						"h": 381,
						"w": 292
					},
					{
						"n": 10,
						"h": 183,
						"w": 473
					},
					{
						"n": 11,
						"h": 257,
						"w": 490
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 106
					},
					{
						"n": 2,
						"h": 69,
						"w": 273
					},
					{
						"n": 3,
						"h": 172,
						"w": 226
					},
					{
						"n": 4,
						"h": 293,
						"w": 222
					},
					{
						"n": 5,
						"h": 387,
						"w": 245
					},
					{
						"n": 6,
						"h": 215,
						"w": 303
					},
					{
						"n": 7,
						"h": 190,
						"w": 443
					},
					{
						"n": 8,
						"h": 387,
						"w": 378,
						"f": 93
					},
					{
						"n": 9,
						"h": 60,
						"w": 454
					},
					{
						"n": 10,
						"h": 175,
						"w": 546,
						"f": 93
					},
					{
						"n": 11,
						"h": 275,
						"w": 549,
						"f": 93,
						"m": 610
					}
				],
				"ball": {
					"n": 0,
					"h": 255,
					"w": 269,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 100
		},
		{
			"num": 347,
			"minute": 17,
			"messages": [
				{
					"owner": 2,
					"mes": "Штрафной..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 20
					},
					{
						"n": 2,
						"h": 69,
						"w": 152
					},
					{
						"n": 3,
						"h": 197,
						"w": 161
					},
					{
						"n": 4,
						"h": 272,
						"w": 156
					},
					{
						"n": 5,
						"h": 369,
						"w": 153
					},
					{
						"n": 6,
						"h": 76,
						"w": 295
					},
					{
						"n": 7,
						"h": 190,
						"w": 302
					},
					{
						"n": 8,
						"h": 244,
						"w": 221
					},
					{
						"n": 9,
						"h": 376,
						"w": 296
					},
					{
						"n": 10,
						"h": 184,
						"w": 473
					},
					{
						"n": 11,
						"h": 264,
						"w": 489
					}
				],
				"away": [
					{
						"n": 1,
						"h": 223,
						"w": 108
					},
					{
						"n": 2,
						"h": 69,
						"w": 272
					},
					{
						"n": 3,
						"h": 177,
						"w": 228
					},
					{
						"n": 4,
						"h": 286,
						"w": 222
					},
					{
						"n": 5,
						"h": 380,
						"w": 251
					},
					{
						"n": 6,
						"h": 221,
						"w": 303
					},
					{
						"n": 7,
						"h": 195,
						"w": 451
					},
					{
						"n": 8,
						"h": 386,
						"w": 375
					},
					{
						"n": 9,
						"h": 59,
						"w": 450
					},
					{
						"n": 10,
						"h": 170,
						"w": 544
					},
					{
						"n": 11,
						"h": 280,
						"w": 553
					}
				],
				"ball": {
					"n": 0,
					"h": 255,
					"w": 269,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 15
		},
		{
			"num": 348,
			"minute": 17,
			"messages": [
				{
					"owner": 2,
					"mes": "Мяч разыгран..."
				},
				{
					"owner": 2,
					"mes": "Слева открывается Матей Юрасек[29](Опава)... Передача..."
				}
			],
			"F": {
				"team": 2
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 16
					},
					{
						"n": 2,
						"h": 110,
						"w": 123
					},
					{
						"n": 3,
						"h": 177,
						"w": 117
					},
					{
						"n": 4,
						"h": 274,
						"w": 131
					},
					{
						"n": 5,
						"h": 369,
						"w": 203
					},
					{
						"n": 6,
						"h": 56,
						"w": 261
					},
					{
						"n": 7,
						"h": 204,
						"w": 254
					},
					{
						"n": 8,
						"h": 264,
						"w": 216
					},
					{
						"n": 9,
						"h": 394,
						"w": 249
					},
					{
						"n": 10,
						"h": 175,
						"w": 423
					},
					{
						"n": 11,
						"h": 275,
						"w": 446
					}
				],
				"away": [
					{
						"n": 1,
						"h": 229,
						"w": 124
					},
					{
						"n": 2,
						"h": 74,
						"w": 304
					},
					{
						"n": 3,
						"h": 175,
						"w": 254
					},
					{
						"n": 4,
						"h": 279,
						"w": 266
					},
					{
						"n": 5,
						"h": 382,
						"w": 273
					},
					{
						"n": 6,
						"h": 204,
						"w": 350
					},
					{
						"n": 7,
						"h": 192,
						"w": 454
					},
					{
						"n": 8,
						"h": 395,
						"w": 424
					},
					{
						"n": 9,
						"h": 51,
						"w": 496
					},
					{
						"n": 10,
						"h": 148,
						"w": 572
					},
					{
						"n": 11,
						"h": 284,
						"w": 569
					}
				],
				"ball": {
					"n": 0,
					"h": 399,
					"w": 224,
					"z": 0,
					"r": 2,
					"p": 0,
					"x": 0
				}
			},
			"interval": 50
		},
		{
			"num": 349,
			"minute": 17,
			"messages": [
				{
					"owner": 2,
					"mes": "М.Юрасек[29](Опава) смещается в центр..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 12
					},
					{
						"n": 2,
						"h": 120,
						"w": 126
					},
					{
						"n": 3,
						"h": 167,
						"w": 118
					},
					{
						"n": 4,
						"h": 280,
						"w": 129
					},
					{
						"n": 5,
						"h": 345,
						"w": 204
					},
					{
						"n": 6,
						"h": 56,
						"w": 222
					},
					{
						"n": 7,
						"h": 225,
						"w": 220
					},
					{
						"n": 8,
						"h": 284,
						"w": 208
					},
					{
						"n": 9,
						"h": 356,
						"w": 214
					},
					{
						"n": 10,
						"h": 169,
						"w": 400
					},
					{
						"n": 11,
						"h": 272,
						"w": 446
					}
				],
				"away": [
					{
						"n": 1,
						"h": 229,
						"w": 120
					},
					{
						"n": 2,
						"h": 62,
						"w": 294
					},
					{
						"n": 3,
						"h": 178,
						"w": 256
					},
					{
						"n": 4,
						"h": 281,
						"w": 254
					},
					{
						"n": 5,
						"h": 392,
						"w": 257
					},
					{
						"n": 6,
						"h": 194,
						"w": 347
					},
					{
						"n": 7,
						"h": 211,
						"w": 470
					},
					{
						"n": 8,
						"h": 401,
						"w": 463
					},
					{
						"n": 9,
						"h": 91,
						"w": 496
					},
					{
						"n": 10,
						"h": 155,
						"w": 569
					},
					{
						"n": 11,
						"h": 297,
						"w": 569
					}
				],
				"ball": {
					"n": 0,
					"h": 359,
					"w": 224,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 350,
			"minute": 17,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 17
					},
					{
						"n": 2,
						"h": 120,
						"w": 86
					},
					{
						"n": 3,
						"h": 178,
						"w": 79
					},
					{
						"n": 4,
						"h": 271,
						"w": 90
					},
					{
						"n": 5,
						"h": 348,
						"w": 164
					},
					{
						"n": 6,
						"h": 56,
						"w": 182
					},
					{
						"n": 7,
						"h": 215,
						"w": 181
					},
					{
						"n": 8,
						"h": 278,
						"w": 168
					},
					{
						"n": 9,
						"h": 375,
						"w": 195
					},
					{
						"n": 10,
						"h": 172,
						"w": 390
					},
					{
						"n": 11,
						"h": 299,
						"w": 417
					}
				],
				"away": [
					{
						"n": 1,
						"h": 223,
						"w": 124
					},
					{
						"n": 2,
						"h": 68,
						"w": 334
					},
					{
						"n": 3,
						"h": 174,
						"w": 296
					},
					{
						"n": 4,
						"h": 278,
						"w": 294
					},
					{
						"n": 5,
						"h": 383,
						"w": 296
					},
					{
						"n": 6,
						"h": 198,
						"w": 387
					},
					{
						"n": 7,
						"h": 213,
						"w": 467
					},
					{
						"n": 8,
						"h": 400,
						"w": 503
					},
					{
						"n": 9,
						"h": 59,
						"w": 510
					},
					{
						"n": 10,
						"h": 167,
						"w": 607
					},
					{
						"n": 11,
						"h": 284,
						"w": 607
					}
				],
				"ball": {
					"n": 0,
					"h": 391,
					"w": 210,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 351,
			"minute": 17,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 236,
						"w": 10
					},
					{
						"n": 2,
						"h": 120,
						"w": 64
					},
					{
						"n": 3,
						"h": 196,
						"w": 53
					},
					{
						"n": 4,
						"h": 242,
						"w": 63
					},
					{
						"n": 5,
						"h": 350,
						"w": 124
					},
					{
						"n": 6,
						"h": 56,
						"w": 142
					},
					{
						"n": 7,
						"h": 231,
						"w": 145
					},
					{
						"n": 8,
						"h": 289,
						"w": 153
					},
					{
						"n": 9,
						"h": 404,
						"w": 174
					},
					{
						"n": 10,
						"h": 182,
						"w": 390
					},
					{
						"n": 11,
						"h": 280,
						"w": 400
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 126
					},
					{
						"n": 2,
						"h": 58,
						"w": 342
					},
					{
						"n": 3,
						"h": 170,
						"w": 306
					},
					{
						"n": 4,
						"h": 268,
						"w": 303
					},
					{
						"n": 5,
						"h": 384,
						"w": 323
					},
					{
						"n": 6,
						"h": 181,
						"w": 412
					},
					{
						"n": 7,
						"h": 211,
						"w": 507
					},
					{
						"n": 8,
						"h": 404,
						"w": 543
					},
					{
						"n": 9,
						"h": 30,
						"w": 531
					},
					{
						"n": 10,
						"h": 196,
						"w": 635
					},
					{
						"n": 11,
						"h": 266,
						"w": 642
					}
				],
				"ball": {
					"n": 0,
					"h": 420,
					"w": 189,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 352,
			"minute": 17,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 236,
						"w": 11
					},
					{
						"n": 2,
						"h": 120,
						"w": 65
					},
					{
						"n": 3,
						"h": 210,
						"w": 53
					},
					{
						"n": 4,
						"h": 251,
						"w": 61
					},
					{
						"n": 5,
						"h": 355,
						"w": 111
					},
					{
						"n": 6,
						"h": 56,
						"w": 128
					},
					{
						"n": 7,
						"h": 219,
						"w": 139
					},
					{
						"n": 8,
						"h": 276,
						"w": 147
					},
					{
						"n": 9,
						"h": 403,
						"w": 188
					},
					{
						"n": 10,
						"h": 176,
						"w": 390
					},
					{
						"n": 11,
						"h": 294,
						"w": 400
					}
				],
				"away": [
					{
						"n": 1,
						"h": 221,
						"w": 125
					},
					{
						"n": 2,
						"h": 63,
						"w": 355
					},
					{
						"n": 3,
						"h": 181,
						"w": 297
					},
					{
						"n": 4,
						"h": 274,
						"w": 296
					},
					{
						"n": 5,
						"h": 387,
						"w": 309
					},
					{
						"n": 6,
						"h": 194,
						"w": 419
					},
					{
						"n": 7,
						"h": 207,
						"w": 521
					},
					{
						"n": 8,
						"h": 404,
						"w": 557
					},
					{
						"n": 9,
						"h": 39,
						"w": 523
					},
					{
						"n": 10,
						"h": 182,
						"w": 634
					},
					{
						"n": 11,
						"h": 252,
						"w": 643
					}
				],
				"ball": {
					"n": 0,
					"h": 411,
					"w": 197,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 14
		},
		{
			"num": 353,
			"minute": 17,
			"messages": [
				{
					"owner": 2,
					"mes": "Подача в штрафную..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 236,
						"w": 11
					},
					{
						"n": 2,
						"h": 120,
						"w": 65
					},
					{
						"n": 3,
						"h": 210,
						"w": 53
					},
					{
						"n": 4,
						"h": 251,
						"w": 61
					},
					{
						"n": 5,
						"h": 355,
						"w": 111
					},
					{
						"n": 6,
						"h": 56,
						"w": 128
					},
					{
						"n": 7,
						"h": 219,
						"w": 139
					},
					{
						"n": 8,
						"h": 276,
						"w": 147
					},
					{
						"n": 9,
						"h": 403,
						"w": 188,
						"m": 630
					},
					{
						"n": 10,
						"h": 176,
						"w": 390
					},
					{
						"n": 11,
						"h": 294,
						"w": 400
					}
				],
				"away": [
					{
						"n": 1,
						"h": 221,
						"w": 125
					},
					{
						"n": 2,
						"h": 63,
						"w": 355
					},
					{
						"n": 3,
						"h": 181,
						"w": 297
					},
					{
						"n": 4,
						"h": 274,
						"w": 296
					},
					{
						"n": 5,
						"h": 387,
						"w": 309
					},
					{
						"n": 6,
						"h": 194,
						"w": 419
					},
					{
						"n": 7,
						"h": 207,
						"w": 521
					},
					{
						"n": 8,
						"h": 404,
						"w": 557
					},
					{
						"n": 9,
						"h": 39,
						"w": 523
					},
					{
						"n": 10,
						"h": 182,
						"w": 634
					},
					{
						"n": 11,
						"h": 252,
						"w": 643
					}
				],
				"ball": {
					"n": 0,
					"h": 403,
					"w": 188,
					"z": 1,
					"r": 2,
					"p": 1,
					"x": 0
				}
			},
			"interval": 6
		},
		{
			"num": 354,
			"minute": 17,
			"messages": [
				{
					"owner": 2,
					"mes": "Но Э.Бвомоно[09](Галвэй Юнайтед) не дает выполнить навес, выбивая мяч в аут..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 235,
						"w": 11
					},
					{
						"n": 2,
						"h": 120,
						"w": 82
					},
					{
						"n": 3,
						"h": 210,
						"w": 70
					},
					{
						"n": 4,
						"h": 252,
						"w": 78
					},
					{
						"n": 5,
						"h": 362,
						"w": 126
					},
					{
						"n": 6,
						"h": 60,
						"w": 145
					},
					{
						"n": 7,
						"h": 219,
						"w": 156
					},
					{
						"n": 8,
						"h": 281,
						"w": 163
					},
					{
						"n": 9,
						"h": 401,
						"w": 187
					},
					{
						"n": 10,
						"h": 176,
						"w": 407
					},
					{
						"n": 11,
						"h": 296,
						"w": 417
					}
				],
				"away": [
					{
						"n": 1,
						"h": 221,
						"w": 108
					},
					{
						"n": 2,
						"h": 63,
						"w": 338
					},
					{
						"n": 3,
						"h": 180,
						"w": 280
					},
					{
						"n": 4,
						"h": 275,
						"w": 279
					},
					{
						"n": 5,
						"h": 387,
						"w": 292
					},
					{
						"n": 6,
						"h": 200,
						"w": 403
					},
					{
						"n": 7,
						"h": 207,
						"w": 538
					},
					{
						"n": 8,
						"h": 410,
						"w": 573
					},
					{
						"n": 9,
						"h": 40,
						"w": 521
					},
					{
						"n": 10,
						"h": 172,
						"w": 647
					},
					{
						"n": 11,
						"h": 235,
						"w": 643
					}
				],
				"ball": {
					"n": 0,
					"h": 450,
					"w": 202,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 17
		},
		{
			"num": 355,
			"minute": 17,
			"messages": [
				{
					"owner": 2,
					"mes": "Матей Юрасек[29](Опава) бросает мяч из-за боковой..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 16
					},
					{
						"n": 2,
						"h": 120,
						"w": 59
					},
					{
						"n": 3,
						"h": 264,
						"w": 59
					},
					{
						"n": 4,
						"h": 335,
						"w": 52
					},
					{
						"n": 5,
						"h": 364,
						"w": 69
					},
					{
						"n": 6,
						"h": 56,
						"w": 233
					},
					{
						"n": 7,
						"h": 141,
						"w": 174
					},
					{
						"n": 8,
						"h": 382,
						"w": 232
					},
					{
						"n": 9,
						"h": 345,
						"w": 152
					},
					{
						"n": 10,
						"h": 161,
						"w": 355
					},
					{
						"n": 11,
						"h": 315,
						"w": 296
					}
				],
				"away": [
					{
						"n": 1,
						"h": 217,
						"w": 40
					},
					{
						"n": 2,
						"h": 49,
						"w": 459
					},
					{
						"n": 3,
						"h": 100,
						"w": 222
					},
					{
						"n": 4,
						"h": 291,
						"w": 224
					},
					{
						"n": 5,
						"h": 387,
						"w": 235
					},
					{
						"n": 6,
						"h": 210,
						"w": 305
					},
					{
						"n": 7,
						"h": 117,
						"w": 460
					},
					{
						"n": 8,
						"h": 395,
						"w": 452
					},
					{
						"n": 9,
						"h": 0,
						"w": 518
					},
					{
						"n": 10,
						"h": 102,
						"w": 547
					},
					{
						"n": 11,
						"h": 300,
						"w": 539
					}
				],
				"ball": {
					"n": 0,
					"h": 450,
					"w": 202,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 98
		},
		{
			"num": 356,
			"minute": 17,
			"messages": [
				{
					"owner": 2,
					"mes": "Лука Седлачек[22](Опава) достает мяч..."
				}
			],
			"A": {
				"team": 2
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 17
					},
					{
						"n": 2,
						"h": 120,
						"w": 74
					},
					{
						"n": 3,
						"h": 232,
						"w": 63
					},
					{
						"n": 4,
						"h": 307,
						"w": 67
					},
					{
						"n": 5,
						"h": 361,
						"w": 68
					},
					{
						"n": 6,
						"h": 56,
						"w": 201
					},
					{
						"n": 7,
						"h": 155,
						"w": 145
					},
					{
						"n": 8,
						"h": 392,
						"w": 262
					},
					{
						"n": 9,
						"h": 375,
						"w": 161
					},
					{
						"n": 10,
						"h": 165,
						"w": 387
					},
					{
						"n": 11,
						"h": 297,
						"w": 323
					}
				],
				"away": [
					{
						"n": 1,
						"h": 229,
						"w": 63
					},
					{
						"n": 2,
						"h": 52,
						"w": 437
					},
					{
						"n": 3,
						"h": 121,
						"w": 246
					},
					{
						"n": 4,
						"h": 284,
						"w": 255
					},
					{
						"n": 5,
						"h": 383,
						"w": 267
					},
					{
						"n": 6,
						"h": 203,
						"w": 336
					},
					{
						"n": 7,
						"h": 144,
						"w": 478
					},
					{
						"n": 8,
						"h": 396,
						"w": 484
					},
					{
						"n": 9,
						"h": 0,
						"w": 518
					},
					{
						"n": 10,
						"h": 117,
						"w": 576
					},
					{
						"n": 11,
						"h": 298,
						"w": 571
					}
				],
				"ball": {
					"n": 0,
					"h": 398,
					"w": 283,
					"z": 1,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 32
		},
		{
			"num": 357,
			"minute": 17,
			"messages": [
				{
					"owner": 2,
					"mes": "Лука Седлачек[22](Опава) смещается в центр..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 12
					},
					{
						"n": 2,
						"h": 160,
						"w": 75
					},
					{
						"n": 3,
						"h": 237,
						"w": 75
					},
					{
						"n": 4,
						"h": 300,
						"w": 76
					},
					{
						"n": 5,
						"h": 358,
						"w": 82
					},
					{
						"n": 6,
						"h": 56,
						"w": 228
					},
					{
						"n": 7,
						"h": 164,
						"w": 153
					},
					{
						"n": 8,
						"h": 360,
						"w": 261
					},
					{
						"n": 9,
						"h": 394,
						"w": 133
					},
					{
						"n": 10,
						"h": 172,
						"w": 393
					},
					{
						"n": 11,
						"h": 309,
						"w": 362
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 81
					},
					{
						"n": 2,
						"h": 87,
						"w": 437
					},
					{
						"n": 3,
						"h": 151,
						"w": 272
					},
					{
						"n": 4,
						"h": 278,
						"w": 291
					},
					{
						"n": 5,
						"h": 385,
						"w": 307
					},
					{
						"n": 6,
						"h": 185,
						"w": 372
					},
					{
						"n": 7,
						"h": 182,
						"w": 489
					},
					{
						"n": 8,
						"h": 410,
						"w": 457
					},
					{
						"n": 9,
						"h": 21,
						"w": 552
					},
					{
						"n": 10,
						"h": 135,
						"w": 604
					},
					{
						"n": 11,
						"h": 293,
						"w": 611
					}
				],
				"ball": {
					"n": 0,
					"h": 363,
					"w": 283,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 358,
			"minute": 17,
			"messages": [
				{
					"owner": 2,
					"mes": "Пас направо О.Дюмону[26](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 15
					},
					{
						"n": 2,
						"h": 182,
						"w": 113
					},
					{
						"n": 3,
						"h": 233,
						"w": 119
					},
					{
						"n": 4,
						"h": 282,
						"w": 106
					},
					{
						"n": 5,
						"h": 331,
						"w": 117
					},
					{
						"n": 6,
						"h": 56,
						"w": 184
					},
					{
						"n": 7,
						"h": 173,
						"w": 174
					},
					{
						"n": 8,
						"h": 322,
						"w": 239
					},
					{
						"n": 9,
						"h": 380,
						"w": 125
					},
					{
						"n": 10,
						"h": 183,
						"w": 350
					},
					{
						"n": 11,
						"h": 285,
						"w": 398
					}
				],
				"away": [
					{
						"n": 1,
						"h": 221,
						"w": 106
					},
					{
						"n": 2,
						"h": 83,
						"w": 423
					},
					{
						"n": 3,
						"h": 171,
						"w": 294
					},
					{
						"n": 4,
						"h": 278,
						"w": 283
					},
					{
						"n": 5,
						"h": 392,
						"w": 322
					},
					{
						"n": 6,
						"h": 224,
						"w": 393
					},
					{
						"n": 7,
						"h": 226,
						"w": 486
					},
					{
						"n": 8,
						"h": 411,
						"w": 501
					},
					{
						"n": 9,
						"h": 55,
						"w": 570
					},
					{
						"n": 10,
						"h": 156,
						"w": 582
					},
					{
						"n": 11,
						"h": 276,
						"w": 575
					}
				],
				"ball": {
					"n": 0,
					"h": 232,
					"w": 304,
					"z": 0,
					"r": 0,
					"p": 2,
					"x": 0
				}
			},
			"interval": 44
		},
		{
			"num": 359,
			"minute": 17,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 18
					},
					{
						"n": 2,
						"h": 184,
						"w": 104
					},
					{
						"n": 3,
						"h": 237,
						"w": 108
					},
					{
						"n": 4,
						"h": 290,
						"w": 105
					},
					{
						"n": 5,
						"h": 330,
						"w": 106
					},
					{
						"n": 6,
						"h": 56,
						"w": 158
					},
					{
						"n": 7,
						"h": 185,
						"w": 157
					},
					{
						"n": 8,
						"h": 299,
						"w": 251
					},
					{
						"n": 9,
						"h": 382,
						"w": 125
					},
					{
						"n": 10,
						"h": 190,
						"w": 325
					},
					{
						"n": 11,
						"h": 279,
						"w": 424
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 123
					},
					{
						"n": 2,
						"h": 80,
						"w": 403
					},
					{
						"n": 3,
						"h": 173,
						"w": 269
					},
					{
						"n": 4,
						"h": 280,
						"w": 262
					},
					{
						"n": 5,
						"h": 383,
						"w": 298
					},
					{
						"n": 6,
						"h": 247,
						"w": 405
					},
					{
						"n": 7,
						"h": 216,
						"w": 466
					},
					{
						"n": 8,
						"h": 410,
						"w": 527
					},
					{
						"n": 9,
						"h": 53,
						"w": 570
					},
					{
						"n": 10,
						"h": 149,
						"w": 580
					},
					{
						"n": 11,
						"h": 272,
						"w": 580
					}
				],
				"ball": {
					"n": 0,
					"h": 193,
					"w": 310,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 26
		},
		{
			"num": 360,
			"minute": 17,
			"messages": [
				{
					"owner": 2,
					"mes": "Оливье Дюмон[26](Опава) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 12
					},
					{
						"n": 2,
						"h": 184,
						"w": 109
					},
					{
						"n": 3,
						"h": 234,
						"w": 118
					},
					{
						"n": 4,
						"h": 287,
						"w": 115
					},
					{
						"n": 5,
						"h": 330,
						"w": 117
					},
					{
						"n": 6,
						"h": 56,
						"w": 147
					},
					{
						"n": 7,
						"h": 180,
						"w": 167
					},
					{
						"n": 8,
						"h": 288,
						"w": 255
					},
					{
						"n": 9,
						"h": 391,
						"w": 125
					},
					{
						"n": 10,
						"h": 193,
						"w": 315
					},
					{
						"n": 11,
						"h": 278,
						"w": 435
					}
				],
				"away": [
					{
						"n": 1,
						"h": 229,
						"w": 122
					},
					{
						"n": 2,
						"h": 78,
						"w": 392
					},
					{
						"n": 3,
						"h": 172,
						"w": 266
					},
					{
						"n": 4,
						"h": 275,
						"w": 260
					},
					{
						"n": 5,
						"h": 383,
						"w": 287
					},
					{
						"n": 6,
						"h": 257,
						"w": 410,
						"m": 620
					},
					{
						"n": 7,
						"h": 215,
						"w": 477
					},
					{
						"n": 8,
						"h": 409,
						"w": 538
					},
					{
						"n": 9,
						"h": 44,
						"w": 570
					},
					{
						"n": 10,
						"h": 149,
						"w": 591
					},
					{
						"n": 11,
						"h": 283,
						"w": 580
					}
				],
				"ball": {
					"n": 0,
					"h": 193,
					"w": 310,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 11
		},
		{
			"num": 361,
			"minute": 17,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 17
					},
					{
						"n": 2,
						"h": 163,
						"w": 107
					},
					{
						"n": 3,
						"h": 197,
						"w": 109
					},
					{
						"n": 4,
						"h": 266,
						"w": 106
					},
					{
						"n": 5,
						"h": 370,
						"w": 115
					},
					{
						"n": 6,
						"h": 59,
						"w": 120
					},
					{
						"n": 7,
						"h": 177,
						"w": 193
					},
					{
						"n": 8,
						"h": 271,
						"w": 219
					},
					{
						"n": 9,
						"h": 402,
						"w": 163
					},
					{
						"n": 10,
						"h": 193,
						"w": 275
					},
					{
						"n": 11,
						"h": 285,
						"w": 420
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 124
					},
					{
						"n": 2,
						"h": 70,
						"w": 353
					},
					{
						"n": 3,
						"h": 165,
						"w": 284
					},
					{
						"n": 4,
						"h": 271,
						"w": 288
					},
					{
						"n": 5,
						"h": 392,
						"w": 299
					},
					{
						"n": 6,
						"h": 257,
						"w": 446
					},
					{
						"n": 7,
						"h": 221,
						"w": 516
					},
					{
						"n": 8,
						"h": 406,
						"w": 578
					},
					{
						"n": 9,
						"h": 49,
						"w": 598
					},
					{
						"n": 10,
						"h": 169,
						"w": 574
					},
					{
						"n": 11,
						"h": 303,
						"w": 595
					}
				],
				"ball": {
					"n": 0,
					"h": 193,
					"w": 274,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 362,
			"minute": 17,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 12
					},
					{
						"n": 2,
						"h": 124,
						"w": 96
					},
					{
						"n": 3,
						"h": 179,
						"w": 96
					},
					{
						"n": 4,
						"h": 274,
						"w": 94
					},
					{
						"n": 5,
						"h": 353,
						"w": 109
					},
					{
						"n": 6,
						"h": 65,
						"w": 110
					},
					{
						"n": 7,
						"h": 203,
						"w": 163
					},
					{
						"n": 8,
						"h": 264,
						"w": 181
					},
					{
						"n": 9,
						"h": 387,
						"w": 195
					},
					{
						"n": 10,
						"h": 193,
						"w": 235
					},
					{
						"n": 11,
						"h": 276,
						"w": 420
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 127
					},
					{
						"n": 2,
						"h": 58,
						"w": 321
					},
					{
						"n": 3,
						"h": 174,
						"w": 284
					},
					{
						"n": 4,
						"h": 269,
						"w": 293
					},
					{
						"n": 5,
						"h": 382,
						"w": 283
					},
					{
						"n": 6,
						"h": 256,
						"w": 481
					},
					{
						"n": 7,
						"h": 233,
						"w": 554
					},
					{
						"n": 8,
						"h": 400,
						"w": 604
					},
					{
						"n": 9,
						"h": 89,
						"w": 599
					},
					{
						"n": 10,
						"h": 149,
						"w": 608
					},
					{
						"n": 11,
						"h": 283,
						"w": 600
					}
				],
				"ball": {
					"n": 0,
					"h": 194,
					"w": 239,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 363,
			"minute": 17,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 18
					},
					{
						"n": 2,
						"h": 120,
						"w": 120
					},
					{
						"n": 3,
						"h": 158,
						"w": 105
					},
					{
						"n": 4,
						"h": 266,
						"w": 106
					},
					{
						"n": 5,
						"h": 318,
						"w": 128
					},
					{
						"n": 6,
						"h": 56,
						"w": 125
					},
					{
						"n": 7,
						"h": 181,
						"w": 196
					},
					{
						"n": 8,
						"h": 277,
						"w": 185
					},
					{
						"n": 9,
						"h": 390,
						"w": 210
					},
					{
						"n": 10,
						"h": 224,
						"w": 237
					},
					{
						"n": 11,
						"h": 303,
						"w": 435
					}
				],
				"away": [
					{
						"n": 1,
						"h": 221,
						"w": 127
					},
					{
						"n": 2,
						"h": 71,
						"w": 313
					},
					{
						"n": 3,
						"h": 176,
						"w": 259
					},
					{
						"n": 4,
						"h": 265,
						"w": 269
					},
					{
						"n": 5,
						"h": 376,
						"w": 259
					},
					{
						"n": 6,
						"h": 226,
						"w": 463
					},
					{
						"n": 7,
						"h": 213,
						"w": 586
					},
					{
						"n": 8,
						"h": 410,
						"w": 584
					},
					{
						"n": 9,
						"h": 126,
						"w": 585
					},
					{
						"n": 10,
						"h": 165,
						"w": 571
					},
					{
						"n": 11,
						"h": 303,
						"w": 593
					}
				],
				"ball": {
					"n": 0,
					"h": 224,
					"w": 257,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 364,
			"minute": 17,
			"messages": [
				{
					"owner": 2,
					"mes": "Оливье Дюмон[26](Опава) пасом на 20 метров отправляет мяч в направлении Ш.Товарека[31](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 213,
						"w": 9
					},
					{
						"n": 2,
						"h": 116,
						"w": 69
					},
					{
						"n": 3,
						"h": 128,
						"w": 75
					},
					{
						"n": 4,
						"h": 217,
						"w": 59
					},
					{
						"n": 5,
						"h": 271,
						"w": 80
					},
					{
						"n": 6,
						"h": 59,
						"w": 125
					},
					{
						"n": 7,
						"h": 187,
						"w": 128
					},
					{
						"n": 8,
						"h": 297,
						"w": 120
					},
					{
						"n": 9,
						"h": 389,
						"w": 147
					},
					{
						"n": 10,
						"h": 204,
						"w": 302
					},
					{
						"n": 11,
						"h": 271,
						"w": 400
					}
				],
				"away": [
					{
						"n": 1,
						"h": 229,
						"w": 122
					},
					{
						"n": 2,
						"h": 70,
						"w": 357
					},
					{
						"n": 3,
						"h": 179,
						"w": 306
					},
					{
						"n": 4,
						"h": 273,
						"w": 295
					},
					{
						"n": 5,
						"h": 376,
						"w": 307
					},
					{
						"n": 6,
						"h": 231,
						"w": 426
					},
					{
						"n": 7,
						"h": 216,
						"w": 654
					},
					{
						"n": 8,
						"h": 399,
						"w": 641
					},
					{
						"n": 9,
						"h": 135,
						"w": 631
					},
					{
						"n": 10,
						"h": 186,
						"w": 636
					},
					{
						"n": 11,
						"h": 322,
						"w": 643
					}
				],
				"ball": {
					"n": 0,
					"h": 128,
					"w": 77,
					"z": 1,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 68
		},
		{
			"num": 365,
			"minute": 17,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 214,
						"w": 10
					},
					{
						"n": 2,
						"h": 96,
						"w": 73
					},
					{
						"n": 3,
						"h": 145,
						"w": 74
					},
					{
						"n": 4,
						"h": 236,
						"w": 53
					},
					{
						"n": 5,
						"h": 270,
						"w": 60
					},
					{
						"n": 6,
						"h": 39,
						"w": 125
					},
					{
						"n": 7,
						"h": 177,
						"w": 116
					},
					{
						"n": 8,
						"h": 303,
						"w": 101
					},
					{
						"n": 9,
						"h": 400,
						"w": 147
					},
					{
						"n": 10,
						"h": 197,
						"w": 320
					},
					{
						"n": 11,
						"h": 284,
						"w": 400
					}
				],
				"away": [
					{
						"n": 1,
						"h": 223,
						"w": 125
					},
					{
						"n": 2,
						"h": 73,
						"w": 341
					},
					{
						"n": 3,
						"h": 166,
						"w": 300
					},
					{
						"n": 4,
						"h": 279,
						"w": 310
					},
					{
						"n": 5,
						"h": 380,
						"w": 299
					},
					{
						"n": 6,
						"h": 227,
						"w": 445
					},
					{
						"n": 7,
						"h": 219,
						"w": 653
					},
					{
						"n": 8,
						"h": 411,
						"w": 632
					},
					{
						"n": 9,
						"h": 132,
						"w": 635
					},
					{
						"n": 10,
						"h": 172,
						"w": 651
					},
					{
						"n": 11,
						"h": 312,
						"w": 639
					}
				],
				"ball": {
					"n": 0,
					"h": 138,
					"w": 81,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 20
		},
		{
			"num": 366,
			"minute": 17,
			"messages": [
				{
					"owner": 2,
					"mes": "Шимон Товарек[31](Опава) отдает на М.Манолова[27](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 15
					},
					{
						"n": 2,
						"h": 77,
						"w": 55
					},
					{
						"n": 3,
						"h": 171,
						"w": 69
					},
					{
						"n": 4,
						"h": 212,
						"w": 63
					},
					{
						"n": 5,
						"h": 277,
						"w": 43
					},
					{
						"n": 6,
						"h": 57,
						"w": 140
					},
					{
						"n": 7,
						"h": 175,
						"w": 116
					},
					{
						"n": 8,
						"h": 309,
						"w": 75
					},
					{
						"n": 9,
						"h": 392,
						"w": 140
					},
					{
						"n": 10,
						"h": 187,
						"w": 345
					},
					{
						"n": 11,
						"h": 286,
						"w": 400
					}
				],
				"away": [
					{
						"n": 1,
						"h": 223,
						"w": 121
					},
					{
						"n": 2,
						"h": 73,
						"w": 347
					},
					{
						"n": 3,
						"h": 164,
						"w": 307
					},
					{
						"n": 4,
						"h": 281,
						"w": 313
					},
					{
						"n": 5,
						"h": 379,
						"w": 304
					},
					{
						"n": 6,
						"h": 233,
						"w": 420
					},
					{
						"n": 7,
						"h": 238,
						"w": 657
					},
					{
						"n": 8,
						"h": 408,
						"w": 657
					},
					{
						"n": 9,
						"h": 134,
						"w": 642
					},
					{
						"n": 10,
						"h": 173,
						"w": 670
					},
					{
						"n": 11,
						"h": 317,
						"w": 631
					}
				],
				"ball": {
					"n": 0,
					"h": 212,
					"w": 63,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 26
		},
		{
			"num": 367,
			"minute": 17,
			"messages": [
				{
					"owner": 2,
					"mes": "Мирослав Манолов[27](Опава) получает мяч..."
				},
				{
					"owner": 2,
					"mes": "Его атакует Роббе Дриссенс[04](Галвэй Юнайтед)..."
				},
				{
					"owner": 2,
					"mes": "Мирослав Манолов[27](Опава) смещается вправо..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 208,
						"w": 22
					},
					{
						"n": 2,
						"h": 56,
						"w": 69
					},
					{
						"n": 3,
						"h": 182,
						"w": 41
					},
					{
						"n": 4,
						"h": 202,
						"w": 35
					},
					{
						"n": 5,
						"h": 278,
						"w": 44
					},
					{
						"n": 6,
						"h": 27,
						"w": 140
					},
					{
						"n": 7,
						"h": 153,
						"w": 106
					},
					{
						"n": 8,
						"h": 308,
						"w": 71
					},
					{
						"n": 9,
						"h": 404,
						"w": 140
					},
					{
						"n": 10,
						"h": 206,
						"w": 368
					},
					{
						"n": 11,
						"h": 284,
						"w": 400
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 120
					},
					{
						"n": 2,
						"h": 63,
						"w": 359
					},
					{
						"n": 3,
						"h": 166,
						"w": 308
					},
					{
						"n": 4,
						"h": 263,
						"w": 316
					},
					{
						"n": 5,
						"h": 387,
						"w": 301
					},
					{
						"n": 6,
						"h": 227,
						"w": 390
					},
					{
						"n": 7,
						"h": 252,
						"w": 679
					},
					{
						"n": 8,
						"h": 412,
						"w": 638
					},
					{
						"n": 9,
						"h": 137,
						"w": 631
					},
					{
						"n": 10,
						"h": 164,
						"w": 668
					},
					{
						"n": 11,
						"h": 293,
						"w": 612
					}
				],
				"ball": {
					"n": 0,
					"h": 198,
					"w": 41,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 4
				}
			},
			"interval": 30
		},
		{
			"num": 368,
			"minute": 17,
			"messages": [
				{
					"owner": 2,
					"mes": "Мирослав Манолов[27](Опава) наносит сильный удар низом..."
				},
				{
					"owner": 2,
					"mes": "Роббе Дриссенс[04](Галвэй Юнайтед) бросается под удар..."
				}
			],
			"U": {
				"team": 4,
				"player": 7
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 213,
						"w": 8
					},
					{
						"n": 2,
						"h": 62,
						"w": 66
					},
					{
						"n": 3,
						"h": 182,
						"w": 21
					},
					{
						"n": 4,
						"h": 202,
						"w": 21,
						"m": 630
					},
					{
						"n": 5,
						"h": 276,
						"w": 26
					},
					{
						"n": 6,
						"h": 30,
						"w": 140
					},
					{
						"n": 7,
						"h": 171,
						"w": 114
					},
					{
						"n": 8,
						"h": 315,
						"w": 69
					},
					{
						"n": 9,
						"h": 396,
						"w": 140
					},
					{
						"n": 10,
						"h": 189,
						"w": 378
					},
					{
						"n": 11,
						"h": 304,
						"w": 400
					}
				],
				"away": [
					{
						"n": 1,
						"h": 226,
						"w": 119
					},
					{
						"n": 2,
						"h": 70,
						"w": 346
					},
					{
						"n": 3,
						"h": 175,
						"w": 299
					},
					{
						"n": 4,
						"h": 282,
						"w": 311
					},
					{
						"n": 5,
						"h": 379,
						"w": 319
					},
					{
						"n": 6,
						"h": 228,
						"w": 410
					},
					{
						"n": 7,
						"h": 256,
						"w": 696,
						"m": 560
					},
					{
						"n": 8,
						"h": 396,
						"w": 645
					},
					{
						"n": 9,
						"h": 130,
						"w": 632
					},
					{
						"n": 10,
						"h": 166,
						"w": 680
					},
					{
						"n": 11,
						"h": 278,
						"w": 599
					}
				],
				"ball": {
					"n": 0,
					"h": 194,
					"w": 24,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 20
		},
		{
			"num": 369,
			"minute": 17,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 213,
						"w": 9
					},
					{
						"n": 2,
						"h": 59,
						"w": 62
					},
					{
						"n": 3,
						"h": 187,
						"w": 22
					},
					{
						"n": 4,
						"h": 201,
						"w": 17
					},
					{
						"n": 5,
						"h": 273,
						"w": 30
					},
					{
						"n": 6,
						"h": 35,
						"w": 140
					},
					{
						"n": 7,
						"h": 170,
						"w": 119
					},
					{
						"n": 8,
						"h": 317,
						"w": 65
					},
					{
						"n": 9,
						"h": 401,
						"w": 140
					},
					{
						"n": 10,
						"h": 193,
						"w": 380
					},
					{
						"n": 11,
						"h": 299,
						"w": 400
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 124
					},
					{
						"n": 2,
						"h": 65,
						"w": 344
					},
					{
						"n": 3,
						"h": 171,
						"w": 302
					},
					{
						"n": 4,
						"h": 278,
						"w": 310
					},
					{
						"n": 5,
						"h": 382,
						"w": 315
					},
					{
						"n": 6,
						"h": 231,
						"w": 407
					},
					{
						"n": 7,
						"h": 256,
						"w": 696
					},
					{
						"n": 8,
						"h": 401,
						"w": 647
					},
					{
						"n": 9,
						"h": 127,
						"w": 636
					},
					{
						"n": 10,
						"h": 171,
						"w": 680
					},
					{
						"n": 11,
						"h": 275,
						"w": 596
					}
				],
				"ball": {
					"n": 0,
					"h": 201,
					"w": 17,
					"z": 0,
					"r": 0,
					"p": 1,
					"x": 0
				}
			},
			"interval": 5
		},
		{
			"num": 370,
			"minute": 17,
			"messages": [
				{
					"owner": 1,
					"mes": "Агуст Хлинссон[07](Галвэй Юнайтед) первый на подборе..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 213,
						"w": 9
					},
					{
						"n": 2,
						"h": 61,
						"w": 65
					},
					{
						"n": 3,
						"h": 182,
						"w": 14
					},
					{
						"n": 4,
						"h": 201,
						"w": 12
					},
					{
						"n": 5,
						"h": 294,
						"w": 31
					},
					{
						"n": 6,
						"h": 37,
						"w": 140
					},
					{
						"n": 7,
						"h": 127,
						"w": 85
					},
					{
						"n": 8,
						"h": 326,
						"w": 67
					},
					{
						"n": 9,
						"h": 405,
						"w": 140
					},
					{
						"n": 10,
						"h": 214,
						"w": 390
					},
					{
						"n": 11,
						"h": 285,
						"w": 400
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 121
					},
					{
						"n": 2,
						"h": 69,
						"w": 349
					},
					{
						"n": 3,
						"h": 165,
						"w": 309
					},
					{
						"n": 4,
						"h": 272,
						"w": 311
					},
					{
						"n": 5,
						"h": 394,
						"w": 311
					},
					{
						"n": 6,
						"h": 236,
						"w": 386
					},
					{
						"n": 7,
						"h": 256,
						"w": 698
					},
					{
						"n": 8,
						"h": 397,
						"w": 645
					},
					{
						"n": 9,
						"h": 121,
						"w": 635
					},
					{
						"n": 10,
						"h": 148,
						"w": 680
					},
					{
						"n": 11,
						"h": 304,
						"w": 613
					}
				],
				"ball": {
					"n": 0,
					"h": 127,
					"w": 85,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 50
		},
		{
			"num": 371,
			"minute": 18,
			"possession": 41,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 16
					},
					{
						"n": 2,
						"h": 69,
						"w": 104,
						"f": 94
					},
					{
						"n": 3,
						"h": 179,
						"w": 54
					},
					{
						"n": 4,
						"h": 224,
						"w": 45,
						"f": 95
					},
					{
						"n": 5,
						"h": 319,
						"w": 63,
						"f": 94
					},
					{
						"n": 6,
						"h": 38,
						"w": 180
					},
					{
						"n": 7,
						"h": 118,
						"w": 119,
						"f": 94
					},
					{
						"n": 8,
						"h": 322,
						"w": 107
					},
					{
						"n": 9,
						"h": 404,
						"w": 180
					},
					{
						"n": 10,
						"h": 176,
						"w": 402
					},
					{
						"n": 11,
						"h": 296,
						"w": 439,
						"f": 94
					}
				],
				"away": [
					{
						"n": 1,
						"h": 243,
						"w": 79
					},
					{
						"n": 2,
						"h": 84,
						"w": 312
					},
					{
						"n": 3,
						"h": 167,
						"w": 269
					},
					{
						"n": 4,
						"h": 265,
						"w": 272,
						"f": 93
					},
					{
						"n": 5,
						"h": 368,
						"w": 281,
						"f": 93,
						"m": 620
					},
					{
						"n": 6,
						"h": 254,
						"w": 350,
						"f": 94
					},
					{
						"n": 7,
						"h": 256,
						"w": 658,
						"f": 95
					},
					{
						"n": 8,
						"h": 398,
						"w": 605
					},
					{
						"n": 9,
						"h": 106,
						"w": 598,
						"f": 93
					},
					{
						"n": 10,
						"h": 139,
						"w": 641
					},
					{
						"n": 11,
						"h": 331,
						"w": 583
					}
				],
				"ball": {
					"n": 0,
					"h": 118,
					"w": 119,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 372,
			"minute": 18,
			"messages": [
				{
					"owner": 1,
					"mes": "Агуст Хлинссон[07](Галвэй Юнайтед) посылает мяч налево в направлении К.Колмана[06](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 16
					},
					{
						"n": 2,
						"h": 67,
						"w": 147
					},
					{
						"n": 3,
						"h": 182,
						"w": 97
					},
					{
						"n": 4,
						"h": 242,
						"w": 84
					},
					{
						"n": 5,
						"h": 340,
						"w": 100
					},
					{
						"n": 6,
						"h": 33,
						"w": 214
					},
					{
						"n": 7,
						"h": 119,
						"w": 129,
						"m": 660
					},
					{
						"n": 8,
						"h": 294,
						"w": 140
					},
					{
						"n": 9,
						"h": 405,
						"w": 223
					},
					{
						"n": 10,
						"h": 152,
						"w": 438
					},
					{
						"n": 11,
						"h": 292,
						"w": 466
					}
				],
				"away": [
					{
						"n": 1,
						"h": 245,
						"w": 79
					},
					{
						"n": 2,
						"h": 96,
						"w": 271
					},
					{
						"n": 3,
						"h": 174,
						"w": 228
					},
					{
						"n": 4,
						"h": 280,
						"w": 231
					},
					{
						"n": 5,
						"h": 351,
						"w": 241
					},
					{
						"n": 6,
						"h": 276,
						"w": 313
					},
					{
						"n": 7,
						"h": 255,
						"w": 615
					},
					{
						"n": 8,
						"h": 399,
						"w": 562
					},
					{
						"n": 9,
						"h": 96,
						"w": 556
					},
					{
						"n": 10,
						"h": 180,
						"w": 626
					},
					{
						"n": 11,
						"h": 318,
						"w": 542
					}
				],
				"ball": {
					"n": 0,
					"h": 33,
					"w": 214,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 43
		},
		{
			"num": 373,
			"minute": 18,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 14
					},
					{
						"n": 2,
						"h": 69,
						"w": 187
					},
					{
						"n": 3,
						"h": 177,
						"w": 137
					},
					{
						"n": 4,
						"h": 258,
						"w": 121
					},
					{
						"n": 5,
						"h": 353,
						"w": 138
					},
					{
						"n": 6,
						"h": 15,
						"w": 249
					},
					{
						"n": 7,
						"h": 123,
						"w": 168
					},
					{
						"n": 8,
						"h": 280,
						"w": 177
					},
					{
						"n": 9,
						"h": 404,
						"w": 263
					},
					{
						"n": 10,
						"h": 136,
						"w": 462
					},
					{
						"n": 11,
						"h": 290,
						"w": 487
					}
				],
				"away": [
					{
						"n": 1,
						"h": 245,
						"w": 79
					},
					{
						"n": 2,
						"h": 103,
						"w": 231
					},
					{
						"n": 3,
						"h": 177,
						"w": 199
					},
					{
						"n": 4,
						"h": 286,
						"w": 200
					},
					{
						"n": 5,
						"h": 343,
						"w": 202
					},
					{
						"n": 6,
						"h": 321,
						"w": 335
					},
					{
						"n": 7,
						"h": 254,
						"w": 575
					},
					{
						"n": 8,
						"h": 399,
						"w": 515
					},
					{
						"n": 9,
						"h": 88,
						"w": 517
					},
					{
						"n": 10,
						"h": 176,
						"w": 586
					},
					{
						"n": 11,
						"h": 313,
						"w": 502
					}
				],
				"ball": {
					"n": 0,
					"h": 15,
					"w": 249,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 374,
			"minute": 18,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 14
					},
					{
						"n": 2,
						"h": 73,
						"w": 227
					},
					{
						"n": 3,
						"h": 178,
						"w": 177
					},
					{
						"n": 4,
						"h": 265,
						"w": 160
					},
					{
						"n": 5,
						"h": 360,
						"w": 177
					},
					{
						"n": 6,
						"h": 15,
						"w": 297
					},
					{
						"n": 7,
						"h": 126,
						"w": 208
					},
					{
						"n": 8,
						"h": 271,
						"w": 216
					},
					{
						"n": 9,
						"h": 402,
						"w": 303
					},
					{
						"n": 10,
						"h": 144,
						"w": 501
					},
					{
						"n": 11,
						"h": 300,
						"w": 508
					}
				],
				"away": [
					{
						"n": 1,
						"h": 245,
						"w": 74
					},
					{
						"n": 2,
						"h": 110,
						"w": 204
					},
					{
						"n": 3,
						"h": 166,
						"w": 201
					},
					{
						"n": 4,
						"h": 285,
						"w": 196
					},
					{
						"n": 5,
						"h": 340,
						"w": 208
					},
					{
						"n": 6,
						"h": 368,
						"w": 352
					},
					{
						"n": 7,
						"h": 254,
						"w": 535
					},
					{
						"n": 8,
						"h": 406,
						"w": 469
					},
					{
						"n": 9,
						"h": 75,
						"w": 479
					},
					{
						"n": 10,
						"h": 177,
						"w": 547
					},
					{
						"n": 11,
						"h": 306,
						"w": 462
					}
				],
				"ball": {
					"n": 0,
					"h": 15,
					"w": 297,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 375,
			"minute": 18,
			"messages": [
				{
					"owner": 1,
					"mes": "Передача Т.Эверсу[02](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 18
					},
					{
						"n": 2,
						"h": 94,
						"w": 248
					},
					{
						"n": 3,
						"h": 180,
						"w": 199
					},
					{
						"n": 4,
						"h": 274,
						"w": 190
					},
					{
						"n": 5,
						"h": 371,
						"w": 206
					},
					{
						"n": 6,
						"h": 19,
						"w": 306
					},
					{
						"n": 7,
						"h": 137,
						"w": 237
					},
					{
						"n": 8,
						"h": 259,
						"w": 245
					},
					{
						"n": 9,
						"h": 402,
						"w": 334
					},
					{
						"n": 10,
						"h": 162,
						"w": 500
					},
					{
						"n": 11,
						"h": 307,
						"w": 513
					}
				],
				"away": [
					{
						"n": 1,
						"h": 245,
						"w": 72
					},
					{
						"n": 2,
						"h": 110,
						"w": 187
					},
					{
						"n": 3,
						"h": 161,
						"w": 193
					},
					{
						"n": 4,
						"h": 277,
						"w": 180
					},
					{
						"n": 5,
						"h": 340,
						"w": 195
					},
					{
						"n": 6,
						"h": 353,
						"w": 325
					},
					{
						"n": 7,
						"h": 252,
						"w": 504
					},
					{
						"n": 8,
						"h": 405,
						"w": 438
					},
					{
						"n": 9,
						"h": 65,
						"w": 450
					},
					{
						"n": 10,
						"h": 171,
						"w": 516
					},
					{
						"n": 11,
						"h": 298,
						"w": 433
					}
				],
				"ball": {
					"n": 0,
					"h": 94,
					"w": 248,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 31
		},
		{
			"num": 376,
			"minute": 18,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 16
					},
					{
						"n": 2,
						"h": 95,
						"w": 284
					},
					{
						"n": 3,
						"h": 179,
						"w": 216
					},
					{
						"n": 4,
						"h": 279,
						"w": 229
					},
					{
						"n": 5,
						"h": 381,
						"w": 245
					},
					{
						"n": 6,
						"h": 24,
						"w": 346
					},
					{
						"n": 7,
						"h": 149,
						"w": 276
					},
					{
						"n": 8,
						"h": 252,
						"w": 284
					},
					{
						"n": 9,
						"h": 398,
						"w": 374
					},
					{
						"n": 10,
						"h": 140,
						"w": 530
					},
					{
						"n": 11,
						"h": 289,
						"w": 524
					}
				],
				"away": [
					{
						"n": 1,
						"h": 245,
						"w": 72
					},
					{
						"n": 2,
						"h": 110,
						"w": 185
					},
					{
						"n": 3,
						"h": 172,
						"w": 182
					},
					{
						"n": 4,
						"h": 285,
						"w": 170
					},
					{
						"n": 5,
						"h": 340,
						"w": 190
					},
					{
						"n": 6,
						"h": 337,
						"w": 288
					},
					{
						"n": 7,
						"h": 252,
						"w": 464
					},
					{
						"n": 8,
						"h": 405,
						"w": 398
					},
					{
						"n": 9,
						"h": 61,
						"w": 410
					},
					{
						"n": 10,
						"h": 181,
						"w": 478
					},
					{
						"n": 11,
						"h": 336,
						"w": 422
					}
				],
				"ball": {
					"n": 0,
					"h": 95,
					"w": 284,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 377,
			"minute": 18,
			"messages": [
				{
					"owner": 1,
					"mes": "Т.Эверс[02](Галвэй Юнайтед) отдает передачу К.Нолану[08](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 19
					},
					{
						"n": 2,
						"h": 86,
						"w": 281
					},
					{
						"n": 3,
						"h": 174,
						"w": 238
					},
					{
						"n": 4,
						"h": 278,
						"w": 233
					},
					{
						"n": 5,
						"h": 374,
						"w": 277
					},
					{
						"n": 6,
						"h": 40,
						"w": 397
					},
					{
						"n": 7,
						"h": 150,
						"w": 330
					},
					{
						"n": 8,
						"h": 249,
						"w": 337
					},
					{
						"n": 9,
						"h": 395,
						"w": 428
					},
					{
						"n": 10,
						"h": 159,
						"w": 540
					},
					{
						"n": 11,
						"h": 293,
						"w": 550
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 72
					},
					{
						"n": 2,
						"h": 110,
						"w": 137
					},
					{
						"n": 3,
						"h": 167,
						"w": 136
					},
					{
						"n": 4,
						"h": 273,
						"w": 153
					},
					{
						"n": 5,
						"h": 340,
						"w": 143
					},
					{
						"n": 6,
						"h": 289,
						"w": 313
					},
					{
						"n": 7,
						"h": 249,
						"w": 410
					},
					{
						"n": 8,
						"h": 406,
						"w": 344
					},
					{
						"n": 9,
						"h": 50,
						"w": 357
					},
					{
						"n": 10,
						"h": 177,
						"w": 424
					},
					{
						"n": 11,
						"h": 305,
						"w": 378
					}
				],
				"ball": {
					"n": 0,
					"h": 249,
					"w": 337,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 54
		},
		{
			"num": 378,
			"minute": 18,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 19
					},
					{
						"n": 2,
						"h": 76,
						"w": 311
					},
					{
						"n": 3,
						"h": 183,
						"w": 269
					},
					{
						"n": 4,
						"h": 282,
						"w": 273
					},
					{
						"n": 5,
						"h": 385,
						"w": 315
					},
					{
						"n": 6,
						"h": 40,
						"w": 437
					},
					{
						"n": 7,
						"h": 153,
						"w": 369
					},
					{
						"n": 8,
						"h": 249,
						"w": 372
					},
					{
						"n": 9,
						"h": 393,
						"w": 468
					},
					{
						"n": 10,
						"h": 160,
						"w": 555
					},
					{
						"n": 11,
						"h": 290,
						"w": 584
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 76
					},
					{
						"n": 2,
						"h": 110,
						"w": 133
					},
					{
						"n": 3,
						"h": 171,
						"w": 140
					},
					{
						"n": 4,
						"h": 276,
						"w": 149
					},
					{
						"n": 5,
						"h": 340,
						"w": 139
					},
					{
						"n": 6,
						"h": 250,
						"w": 320
					},
					{
						"n": 7,
						"h": 242,
						"w": 371
					},
					{
						"n": 8,
						"h": 406,
						"w": 304
					},
					{
						"n": 9,
						"h": 41,
						"w": 318
					},
					{
						"n": 10,
						"h": 172,
						"w": 384
					},
					{
						"n": 11,
						"h": 298,
						"w": 338
					}
				],
				"ball": {
					"n": 0,
					"h": 249,
					"w": 372,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 379,
			"minute": 18,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 12
					},
					{
						"n": 2,
						"h": 74,
						"w": 346
					},
					{
						"n": 3,
						"h": 176,
						"w": 289
					},
					{
						"n": 4,
						"h": 267,
						"w": 284
					},
					{
						"n": 5,
						"h": 389,
						"w": 331
					},
					{
						"n": 6,
						"h": 43,
						"w": 477
					},
					{
						"n": 7,
						"h": 158,
						"w": 409
					},
					{
						"n": 8,
						"h": 249,
						"w": 407
					},
					{
						"n": 9,
						"h": 396,
						"w": 507
					},
					{
						"n": 10,
						"h": 156,
						"w": 576
					},
					{
						"n": 11,
						"h": 291,
						"w": 587
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 77
					},
					{
						"n": 2,
						"h": 110,
						"w": 132
					},
					{
						"n": 3,
						"h": 176,
						"w": 140
					},
					{
						"n": 4,
						"h": 281,
						"w": 145
					},
					{
						"n": 5,
						"h": 340,
						"w": 127
					},
					{
						"n": 6,
						"h": 215,
						"w": 300
					},
					{
						"n": 7,
						"h": 236,
						"w": 331
					},
					{
						"n": 8,
						"h": 406,
						"w": 264
					},
					{
						"n": 9,
						"h": 28,
						"w": 283
					},
					{
						"n": 10,
						"h": 166,
						"w": 344
					},
					{
						"n": 11,
						"h": 284,
						"w": 301
					}
				],
				"ball": {
					"n": 0,
					"h": 249,
					"w": 407,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 380,
			"minute": 18,
			"messages": [
				{
					"owner": 1,
					"mes": "Киран Нолан[08](Галвэй Юнайтед) пасует Э.Бвомоно[09](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 17
					},
					{
						"n": 2,
						"h": 76,
						"w": 349
					},
					{
						"n": 3,
						"h": 184,
						"w": 297
					},
					{
						"n": 4,
						"h": 274,
						"w": 304
					},
					{
						"n": 5,
						"h": 378,
						"w": 347
					},
					{
						"n": 6,
						"h": 39,
						"w": 536
					},
					{
						"n": 7,
						"h": 157,
						"w": 468
					},
					{
						"n": 8,
						"h": 253,
						"w": 416
					},
					{
						"n": 9,
						"h": 339,
						"w": 522
					},
					{
						"n": 10,
						"h": 152,
						"w": 582
					},
					{
						"n": 11,
						"h": 287,
						"w": 593
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 39
					},
					{
						"n": 2,
						"h": 120,
						"w": 178
					},
					{
						"n": 3,
						"h": 173,
						"w": 112
					},
					{
						"n": 4,
						"h": 284,
						"w": 110
					},
					{
						"n": 5,
						"h": 340,
						"w": 117
					},
					{
						"n": 6,
						"h": 240,
						"w": 247
					},
					{
						"n": 7,
						"h": 219,
						"w": 274
					},
					{
						"n": 8,
						"h": 406,
						"w": 205
					},
					{
						"n": 9,
						"h": 65,
						"w": 329
					},
					{
						"n": 10,
						"h": 162,
						"w": 316
					},
					{
						"n": 11,
						"h": 276,
						"w": 316
					}
				],
				"ball": {
					"n": 0,
					"h": 339,
					"w": 522,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 59
		},
		{
			"num": 381,
			"minute": 18,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 13
					},
					{
						"n": 2,
						"h": 74,
						"w": 362
					},
					{
						"n": 3,
						"h": 173,
						"w": 303
					},
					{
						"n": 4,
						"h": 277,
						"w": 316
					},
					{
						"n": 5,
						"h": 383,
						"w": 359
					},
					{
						"n": 6,
						"h": 38,
						"w": 549
					},
					{
						"n": 7,
						"h": 158,
						"w": 481
					},
					{
						"n": 8,
						"h": 256,
						"w": 429
					},
					{
						"n": 9,
						"h": 339,
						"w": 532
					},
					{
						"n": 10,
						"h": 164,
						"w": 587
					},
					{
						"n": 11,
						"h": 294,
						"w": 604
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 37
					},
					{
						"n": 2,
						"h": 111,
						"w": 188
					},
					{
						"n": 3,
						"h": 173,
						"w": 99
					},
					{
						"n": 4,
						"h": 280,
						"w": 98
					},
					{
						"n": 5,
						"h": 340,
						"w": 105
					},
					{
						"n": 6,
						"h": 246,
						"w": 231
					},
					{
						"n": 7,
						"h": 215,
						"w": 262
					},
					{
						"n": 8,
						"h": 406,
						"w": 192
					},
					{
						"n": 9,
						"h": 63,
						"w": 316
					},
					{
						"n": 10,
						"h": 170,
						"w": 305
					},
					{
						"n": 11,
						"h": 287,
						"w": 310
					}
				],
				"ball": {
					"n": 0,
					"h": 339,
					"w": 532,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 13
		},
		{
			"num": 382,
			"minute": 18,
			"messages": [
				{
					"owner": 1,
					"mes": "Элвис Бвомоно[09](Галвэй Юнайтед) прокидывает мяч мимо Л.Седлачека[22](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 15
					},
					{
						"n": 2,
						"h": 61,
						"w": 361
					},
					{
						"n": 3,
						"h": 171,
						"w": 304
					},
					{
						"n": 4,
						"h": 281,
						"w": 312
					},
					{
						"n": 5,
						"h": 389,
						"w": 359
					},
					{
						"n": 6,
						"h": 35,
						"w": 588
					},
					{
						"n": 7,
						"h": 165,
						"w": 520
					},
					{
						"n": 8,
						"h": 264,
						"w": 468
					},
					{
						"n": 9,
						"h": 339,
						"w": 572,
						"m": 640
					},
					{
						"n": 10,
						"h": 169,
						"w": 613
					},
					{
						"n": 11,
						"h": 294,
						"w": 613
					}
				],
				"away": [
					{
						"n": 1,
						"h": 202,
						"w": 29
					},
					{
						"n": 2,
						"h": 104,
						"w": 195,
						"m": 580
					},
					{
						"n": 3,
						"h": 134,
						"w": 121
					},
					{
						"n": 4,
						"h": 241,
						"w": 104
					},
					{
						"n": 5,
						"h": 300,
						"w": 100
					},
					{
						"n": 6,
						"h": 216,
						"w": 191
					},
					{
						"n": 7,
						"h": 200,
						"w": 225
					},
					{
						"n": 8,
						"h": 402,
						"w": 152
					},
					{
						"n": 9,
						"h": 58,
						"w": 276
					},
					{
						"n": 10,
						"h": 164,
						"w": 290
					},
					{
						"n": 11,
						"h": 279,
						"w": 307
					}
				],
				"ball": {
					"n": 0,
					"h": 339,
					"w": 572,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 383,
			"minute": 18,
			"messages": [
				{
					"owner": 1,
					"mes": "Э.Бвомоно[09](Галвэй Юнайтед) пасует на А.Гилберта[11](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 18
					},
					{
						"n": 2,
						"h": 64,
						"w": 377
					},
					{
						"n": 3,
						"h": 177,
						"w": 317
					},
					{
						"n": 4,
						"h": 273,
						"w": 329
					},
					{
						"n": 5,
						"h": 387,
						"w": 372
					},
					{
						"n": 6,
						"h": 52,
						"w": 617
					},
					{
						"n": 7,
						"h": 160,
						"w": 553
					},
					{
						"n": 8,
						"h": 273,
						"w": 437
					},
					{
						"n": 9,
						"h": 345,
						"w": 581
					},
					{
						"n": 10,
						"h": 199,
						"w": 627
					},
					{
						"n": 11,
						"h": 315,
						"w": 634
					}
				],
				"away": [
					{
						"n": 1,
						"h": 214,
						"w": 10
					},
					{
						"n": 2,
						"h": 106,
						"w": 162
					},
					{
						"n": 3,
						"h": 137,
						"w": 84
					},
					{
						"n": 4,
						"h": 246,
						"w": 71
					},
					{
						"n": 5,
						"h": 293,
						"w": 132
					},
					{
						"n": 6,
						"h": 190,
						"w": 171
					},
					{
						"n": 7,
						"h": 228,
						"w": 208
					},
					{
						"n": 8,
						"h": 394,
						"w": 120
					},
					{
						"n": 9,
						"h": 55,
						"w": 264
					},
					{
						"n": 10,
						"h": 177,
						"w": 263
					},
					{
						"n": 11,
						"h": 283,
						"w": 292
					}
				],
				"ball": {
					"n": 0,
					"h": 315,
					"w": 634,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 33
		},
		{
			"num": 384,
			"minute": 18,
			"messages": [
				{
					"owner": 1,
					"mes": "Прекрасную технику демонстрирует Адам Гилберт[11](Галвэй Юнайтед)..."
				},
				{
					"owner": 1,
					"mes": "Пас назад..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 14
					},
					{
						"n": 2,
						"h": 70,
						"w": 367
					},
					{
						"n": 3,
						"h": 171,
						"w": 327
					},
					{
						"n": 4,
						"h": 269,
						"w": 313
					},
					{
						"n": 5,
						"h": 377,
						"w": 378
					},
					{
						"n": 6,
						"h": 42,
						"w": 615
					},
					{
						"n": 7,
						"h": 164,
						"w": 572
					},
					{
						"n": 8,
						"h": 275,
						"w": 456
					},
					{
						"n": 9,
						"h": 335,
						"w": 598
					},
					{
						"n": 10,
						"h": 179,
						"w": 628
					},
					{
						"n": 11,
						"h": 343,
						"w": 636
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 11
					},
					{
						"n": 2,
						"h": 99,
						"w": 143
					},
					{
						"n": 3,
						"h": 137,
						"w": 84
					},
					{
						"n": 4,
						"h": 227,
						"w": 78
					},
					{
						"n": 5,
						"h": 286,
						"w": 114
					},
					{
						"n": 6,
						"h": 207,
						"w": 161
					},
					{
						"n": 7,
						"h": 215,
						"w": 193
					},
					{
						"n": 8,
						"h": 393,
						"w": 100
					},
					{
						"n": 9,
						"h": 45,
						"w": 247
					},
					{
						"n": 10,
						"h": 175,
						"w": 244
					},
					{
						"n": 11,
						"h": 282,
						"w": 294
					}
				],
				"ball": {
					"n": 0,
					"h": 335,
					"w": 598,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 20
		},
		{
			"num": 385,
			"minute": 18,
			"messages": [
				{
					"owner": 1,
					"mes": "Адам Гилберт[11](Галвэй Юнайтед) вновь получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 16
					},
					{
						"n": 2,
						"h": 72,
						"w": 376
					},
					{
						"n": 3,
						"h": 178,
						"w": 315
					},
					{
						"n": 4,
						"h": 282,
						"w": 327
					},
					{
						"n": 5,
						"h": 383,
						"w": 372
					},
					{
						"n": 6,
						"h": 53,
						"w": 625
					},
					{
						"n": 7,
						"h": 165,
						"w": 553
					},
					{
						"n": 8,
						"h": 277,
						"w": 447
					},
					{
						"n": 9,
						"h": 335,
						"w": 598,
						"m": 650
					},
					{
						"n": 10,
						"h": 195,
						"w": 638
					},
					{
						"n": 11,
						"h": 343,
						"w": 636
					}
				],
				"away": [
					{
						"n": 1,
						"h": 213,
						"w": 9
					},
					{
						"n": 2,
						"h": 108,
						"w": 122
					},
					{
						"n": 3,
						"h": 123,
						"w": 71
					},
					{
						"n": 4,
						"h": 244,
						"w": 70
					},
					{
						"n": 5,
						"h": 283,
						"w": 136
					},
					{
						"n": 6,
						"h": 187,
						"w": 149
					},
					{
						"n": 7,
						"h": 233,
						"w": 186
					},
					{
						"n": 8,
						"h": 386,
						"w": 82
					},
					{
						"n": 9,
						"h": 48,
						"w": 228
					},
					{
						"n": 10,
						"h": 173,
						"w": 253
					},
					{
						"n": 11,
						"h": 290,
						"w": 308
					}
				],
				"ball": {
					"n": 0,
					"h": 343,
					"w": 636,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 19
		},
		{
			"num": 386,
			"minute": 18,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 16
					},
					{
						"n": 2,
						"h": 63,
						"w": 380
					},
					{
						"n": 3,
						"h": 166,
						"w": 326
					},
					{
						"n": 4,
						"h": 272,
						"w": 330
					},
					{
						"n": 5,
						"h": 386,
						"w": 369
					},
					{
						"n": 6,
						"h": 59,
						"w": 638
					},
					{
						"n": 7,
						"h": 167,
						"w": 569
					},
					{
						"n": 8,
						"h": 279,
						"w": 463
					},
					{
						"n": 9,
						"h": 347,
						"w": 607
					},
					{
						"n": 10,
						"h": 209,
						"w": 645
					},
					{
						"n": 11,
						"h": 343,
						"w": 649
					}
				],
				"away": [
					{
						"n": 1,
						"h": 212,
						"w": 8
					},
					{
						"n": 2,
						"h": 109,
						"w": 104
					},
					{
						"n": 3,
						"h": 107,
						"w": 71
					},
					{
						"n": 4,
						"h": 241,
						"w": 54
					},
					{
						"n": 5,
						"h": 297,
						"w": 123
					},
					{
						"n": 6,
						"h": 169,
						"w": 140
					},
					{
						"n": 7,
						"h": 221,
						"w": 175
					},
					{
						"n": 8,
						"h": 380,
						"w": 68
					},
					{
						"n": 9,
						"h": 49,
						"w": 212
					},
					{
						"n": 10,
						"h": 171,
						"w": 237
					},
					{
						"n": 11,
						"h": 286,
						"w": 303
					}
				],
				"ball": {
					"n": 0,
					"h": 343,
					"w": 649,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 16
		},
		{
			"num": 387,
			"minute": 18,
			"messages": [
				{
					"owner": 1,
					"mes": "Адам Гилберт[11](Галвэй Юнайтед) один в один пытается обыграть Н.Мансура[23](Опава)..."
				},
				{
					"owner": 1,
					"mes": "Адам Гилберт[11](Галвэй Юнайтед) обводит Н.Мансура[23](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 11
					},
					{
						"n": 2,
						"h": 71,
						"w": 373
					},
					{
						"n": 3,
						"h": 185,
						"w": 322
					},
					{
						"n": 4,
						"h": 272,
						"w": 312
					},
					{
						"n": 5,
						"h": 392,
						"w": 369
					},
					{
						"n": 6,
						"h": 49,
						"w": 640
					},
					{
						"n": 7,
						"h": 150,
						"w": 577
					},
					{
						"n": 8,
						"h": 293,
						"w": 450
					},
					{
						"n": 9,
						"h": 347,
						"w": 635
					},
					{
						"n": 10,
						"h": 178,
						"w": 669
					},
					{
						"n": 11,
						"h": 305,
						"w": 662,
						"m": 710
					}
				],
				"away": [
					{
						"n": 1,
						"h": 219,
						"w": 5
					},
					{
						"n": 2,
						"h": 136,
						"w": 65
					},
					{
						"n": 3,
						"h": 97,
						"w": 70,
						"m": 600
					},
					{
						"n": 4,
						"h": 193,
						"w": 48
					},
					{
						"n": 5,
						"h": 280,
						"w": 79
					},
					{
						"n": 6,
						"h": 133,
						"w": 105
					},
					{
						"n": 7,
						"h": 260,
						"w": 164
					},
					{
						"n": 8,
						"h": 385,
						"w": 55
					},
					{
						"n": 9,
						"h": 54,
						"w": 190
					},
					{
						"n": 10,
						"h": 157,
						"w": 250
					},
					{
						"n": 11,
						"h": 292,
						"w": 310
					}
				],
				"ball": {
					"n": 0,
					"h": 305,
					"w": 662,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 388,
			"minute": 18,
			"messages": [
				{
					"owner": 1,
					"mes": "А.Гилберт[11](Галвэй Юнайтед) подрабатывает мяч под удар..."
				},
				{
					"owner": 1,
					"mes": "Удар по воротам..."
				},
				{
					"owner": 1,
					"mes": "Гол!!!"
				},
				{
					"owner": 1,
					"mes": " СЧЕТ 2:0"
				}
			],
			"U": {
				"team": 1,
				"player": 11,
				"xg": "0.13"
			},
			"V": {
				"team": 1,
				"player": 11
			},
			"G": {
				"team": 1,
				"player": 11,
				"assist": 9
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 16
					},
					{
						"n": 2,
						"h": 70,
						"w": 371
					},
					{
						"n": 3,
						"h": 181,
						"w": 320
					},
					{
						"n": 4,
						"h": 266,
						"w": 321
					},
					{
						"n": 5,
						"h": 373,
						"w": 375
					},
					{
						"n": 6,
						"h": 56,
						"w": 640
					},
					{
						"n": 7,
						"h": 153,
						"w": 598
					},
					{
						"n": 8,
						"h": 274,
						"w": 442
					},
					{
						"n": 9,
						"h": 357,
						"w": 640,
						"m": 700
					},
					{
						"n": 10,
						"h": 167,
						"w": 670
					},
					{
						"n": 11,
						"h": 305,
						"w": 662,
						"m": 790
					}
				],
				"away": [
					{
						"n": 1,
						"h": 200,
						"w": 5,
						"m": 570
					},
					{
						"n": 2,
						"h": 149,
						"w": 55
					},
					{
						"n": 3,
						"h": 120,
						"w": 67,
						"m": 550
					},
					{
						"n": 4,
						"h": 167,
						"w": 45
					},
					{
						"n": 5,
						"h": 304,
						"w": 72
					},
					{
						"n": 6,
						"h": 159,
						"w": 106
					},
					{
						"n": 7,
						"h": 273,
						"w": 148
					},
					{
						"n": 8,
						"h": 378,
						"w": 55
					},
					{
						"n": 9,
						"h": 33,
						"w": 190
					},
					{
						"n": 10,
						"h": 176,
						"w": 258
					},
					{
						"n": 11,
						"h": 294,
						"w": 290
					}
				],
				"ball": {
					"n": 0,
					"h": 232,
					"w": 732,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 9
				}
			},
			"interval": 21
		},
		{
			"num": 389,
			"minute": 19,
			"possession": 44,
			"messages": [],
			"N": {
				"team": 2
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 15
					},
					{
						"n": 2,
						"h": 45,
						"w": 90
					},
					{
						"n": 3,
						"h": 135,
						"w": 90
					},
					{
						"n": 4,
						"h": 315,
						"w": 90
					},
					{
						"n": 5,
						"h": 405,
						"w": 90
					},
					{
						"n": 6,
						"h": 45,
						"w": 210
					},
					{
						"n": 7,
						"h": 135,
						"w": 210
					},
					{
						"n": 8,
						"h": 315,
						"w": 210,
						"f": 93
					},
					{
						"n": 9,
						"h": 405,
						"w": 210,
						"f": 93
					},
					{
						"n": 10,
						"h": 100,
						"w": 330,
						"f": 93,
						"m": 730
					},
					{
						"n": 11,
						"h": 350,
						"w": 330
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 15
					},
					{
						"n": 2,
						"h": 37,
						"w": 90,
						"f": 91
					},
					{
						"n": 3,
						"h": 131,
						"w": 90,
						"f": 93
					},
					{
						"n": 4,
						"h": 319,
						"w": 90
					},
					{
						"n": 5,
						"h": 413,
						"w": 90
					},
					{
						"n": 6,
						"h": 225,
						"w": 150
					},
					{
						"n": 7,
						"h": 225,
						"w": 210,
						"m": 570
					},
					{
						"n": 8,
						"h": 413,
						"w": 210
					},
					{
						"n": 9,
						"h": 37,
						"w": 270
					},
					{
						"n": 10,
						"h": 214,
						"w": 331
					},
					{
						"n": 11,
						"h": 235,
						"w": 355
					}
				],
				"ball": {
					"n": 0,
					"h": 225,
					"w": 360,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 300
		},
		{
			"num": 390,
			"minute": 19,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 15
					},
					{
						"n": 2,
						"h": 45,
						"w": 90
					},
					{
						"n": 3,
						"h": 135,
						"w": 90
					},
					{
						"n": 4,
						"h": 315,
						"w": 90
					},
					{
						"n": 5,
						"h": 405,
						"w": 90
					},
					{
						"n": 6,
						"h": 45,
						"w": 210
					},
					{
						"n": 7,
						"h": 135,
						"w": 210
					},
					{
						"n": 8,
						"h": 315,
						"w": 210
					},
					{
						"n": 9,
						"h": 405,
						"w": 210
					},
					{
						"n": 10,
						"h": 100,
						"w": 330
					},
					{
						"n": 11,
						"h": 350,
						"w": 330
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 15
					},
					{
						"n": 2,
						"h": 37,
						"w": 90
					},
					{
						"n": 3,
						"h": 131,
						"w": 90
					},
					{
						"n": 4,
						"h": 319,
						"w": 90
					},
					{
						"n": 5,
						"h": 413,
						"w": 90
					},
					{
						"n": 6,
						"h": 225,
						"w": 150
					},
					{
						"n": 7,
						"h": 225,
						"w": 210
					},
					{
						"n": 8,
						"h": 413,
						"w": 210
					},
					{
						"n": 9,
						"h": 37,
						"w": 270
					},
					{
						"n": 10,
						"h": 214,
						"w": 331
					},
					{
						"n": 11,
						"h": 235,
						"w": 355
					}
				],
				"ball": {
					"n": 0,
					"h": 225,
					"w": 360,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 30
		},
		{
			"num": 391,
			"minute": 19,
			"messages": [
				{
					"owner": 2,
					"mes": "Футболисты Опава разыграли мяч с центра поля..."
				},
				{
					"owner": 2,
					"mes": "Петр Крамарж[30](Опава) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 15
					},
					{
						"n": 2,
						"h": 45,
						"w": 90
					},
					{
						"n": 3,
						"h": 135,
						"w": 90
					},
					{
						"n": 4,
						"h": 315,
						"w": 90
					},
					{
						"n": 5,
						"h": 405,
						"w": 90
					},
					{
						"n": 6,
						"h": 45,
						"w": 210
					},
					{
						"n": 7,
						"h": 135,
						"w": 210
					},
					{
						"n": 8,
						"h": 315,
						"w": 210
					},
					{
						"n": 9,
						"h": 405,
						"w": 210
					},
					{
						"n": 10,
						"h": 100,
						"w": 330
					},
					{
						"n": 11,
						"h": 350,
						"w": 330
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 15
					},
					{
						"n": 2,
						"h": 37,
						"w": 90
					},
					{
						"n": 3,
						"h": 131,
						"w": 90
					},
					{
						"n": 4,
						"h": 319,
						"w": 90
					},
					{
						"n": 5,
						"h": 413,
						"w": 90
					},
					{
						"n": 6,
						"h": 225,
						"w": 150
					},
					{
						"n": 7,
						"h": 225,
						"w": 210
					},
					{
						"n": 8,
						"h": 413,
						"w": 210
					},
					{
						"n": 9,
						"h": 37,
						"w": 270
					},
					{
						"n": 10,
						"h": 214,
						"w": 331
					},
					{
						"n": 11,
						"h": 235,
						"w": 355
					}
				],
				"ball": {
					"n": 0,
					"h": 236,
					"w": 389,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 15
		},
		{
			"num": 392,
			"minute": 19,
			"messages": [
				{
					"owner": 2,
					"mes": "Петр Крамарж[30](Опава) отдает на М.Манолова[27](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 14
					},
					{
						"n": 2,
						"h": 72,
						"w": 113
					},
					{
						"n": 3,
						"h": 151,
						"w": 121
					},
					{
						"n": 4,
						"h": 293,
						"w": 117
					},
					{
						"n": 5,
						"h": 381,
						"w": 115
					},
					{
						"n": 6,
						"h": 45,
						"w": 245
					},
					{
						"n": 7,
						"h": 164,
						"w": 229
					},
					{
						"n": 8,
						"h": 287,
						"w": 230
					},
					{
						"n": 9,
						"h": 417,
						"w": 243
					},
					{
						"n": 10,
						"h": 134,
						"w": 320
					},
					{
						"n": 11,
						"h": 330,
						"w": 358
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 18
					},
					{
						"n": 2,
						"h": 56,
						"w": 92
					},
					{
						"n": 3,
						"h": 166,
						"w": 89
					},
					{
						"n": 4,
						"h": 284,
						"w": 89
					},
					{
						"n": 5,
						"h": 430,
						"w": 95
					},
					{
						"n": 6,
						"h": 257,
						"w": 165
					},
					{
						"n": 7,
						"h": 199,
						"w": 233
					},
					{
						"n": 8,
						"h": 416,
						"w": 245
					},
					{
						"n": 9,
						"h": 37,
						"w": 305
					},
					{
						"n": 10,
						"h": 209,
						"w": 340
					},
					{
						"n": 11,
						"h": 270,
						"w": 356
					}
				],
				"ball": {
					"n": 0,
					"h": 251,
					"w": 487,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 35
		},
		{
			"num": 393,
			"minute": 19,
			"messages": [
				{
					"owner": 2,
					"mes": "Пас Д.Прохазке[28](Опава)..."
				},
				{
					"owner": 2,
					"mes": "Даниэль Прохазка[28](Опава) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 10
					},
					{
						"n": 2,
						"h": 103,
						"w": 149
					},
					{
						"n": 3,
						"h": 188,
						"w": 151
					},
					{
						"n": 4,
						"h": 273,
						"w": 159
					},
					{
						"n": 5,
						"h": 345,
						"w": 147
					},
					{
						"n": 6,
						"h": 31,
						"w": 260
					},
					{
						"n": 7,
						"h": 178,
						"w": 235
					},
					{
						"n": 8,
						"h": 255,
						"w": 232
					},
					{
						"n": 9,
						"h": 407,
						"w": 290
					},
					{
						"n": 10,
						"h": 155,
						"w": 364
					},
					{
						"n": 11,
						"h": 325,
						"w": 406
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 15
					},
					{
						"n": 2,
						"h": 50,
						"w": 135
					},
					{
						"n": 3,
						"h": 180,
						"w": 132
					},
					{
						"n": 4,
						"h": 274,
						"w": 133
					},
					{
						"n": 5,
						"h": 434,
						"w": 138
					},
					{
						"n": 6,
						"h": 277,
						"w": 209
					},
					{
						"n": 7,
						"h": 204,
						"w": 241
					},
					{
						"n": 8,
						"h": 391,
						"w": 227
					},
					{
						"n": 9,
						"h": 40,
						"w": 353
					},
					{
						"n": 10,
						"h": 188,
						"w": 383
					},
					{
						"n": 11,
						"h": 283,
						"w": 402
					}
				],
				"ball": {
					"n": 0,
					"h": 59,
					"w": 493,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 48
		},
		{
			"num": 394,
			"minute": 19,
			"messages": [
				{
					"owner": 2,
					"mes": "Пас С.Пейше[24](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 12
					},
					{
						"n": 2,
						"h": 112,
						"w": 187
					},
					{
						"n": 3,
						"h": 181,
						"w": 189
					},
					{
						"n": 4,
						"h": 251,
						"w": 192
					},
					{
						"n": 5,
						"h": 338,
						"w": 186
					},
					{
						"n": 6,
						"h": 34,
						"w": 299
					},
					{
						"n": 7,
						"h": 175,
						"w": 274
					},
					{
						"n": 8,
						"h": 257,
						"w": 271
					},
					{
						"n": 9,
						"h": 394,
						"w": 313
					},
					{
						"n": 10,
						"h": 146,
						"w": 400
					},
					{
						"n": 11,
						"h": 322,
						"w": 445
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 11
					},
					{
						"n": 2,
						"h": 20,
						"w": 134
					},
					{
						"n": 3,
						"h": 176,
						"w": 119
					},
					{
						"n": 4,
						"h": 303,
						"w": 159
					},
					{
						"n": 5,
						"h": 411,
						"w": 152
					},
					{
						"n": 6,
						"h": 238,
						"w": 206
					},
					{
						"n": 7,
						"h": 216,
						"w": 278
					},
					{
						"n": 8,
						"h": 392,
						"w": 237,
						"m": 630
					},
					{
						"n": 9,
						"h": 41,
						"w": 392
					},
					{
						"n": 10,
						"h": 177,
						"w": 420
					},
					{
						"n": 11,
						"h": 275,
						"w": 435
					}
				],
				"ball": {
					"n": 0,
					"h": 147,
					"w": 561,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 395,
			"minute": 19,
			"messages": [
				{
					"owner": 2,
					"mes": "Пас направо Т.Прохазке[25](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 13
					},
					{
						"n": 2,
						"h": 116,
						"w": 219
					},
					{
						"n": 3,
						"h": 180,
						"w": 222
					},
					{
						"n": 4,
						"h": 263,
						"w": 222
					},
					{
						"n": 5,
						"h": 334,
						"w": 219
					},
					{
						"n": 6,
						"h": 29,
						"w": 331
					},
					{
						"n": 7,
						"h": 165,
						"w": 305
					},
					{
						"n": 8,
						"h": 276,
						"w": 298
					},
					{
						"n": 9,
						"h": 394,
						"w": 280
					},
					{
						"n": 10,
						"h": 150,
						"w": 433
					},
					{
						"n": 11,
						"h": 290,
						"w": 449
					}
				],
				"away": [
					{
						"n": 1,
						"h": 223,
						"w": 17
					},
					{
						"n": 2,
						"h": 50,
						"w": 130
					},
					{
						"n": 3,
						"h": 167,
						"w": 126
					},
					{
						"n": 4,
						"h": 298,
						"w": 150
					},
					{
						"n": 5,
						"h": 387,
						"w": 174
					},
					{
						"n": 6,
						"h": 268,
						"w": 221
					},
					{
						"n": 7,
						"h": 235,
						"w": 305
					},
					{
						"n": 8,
						"h": 395,
						"w": 269
					},
					{
						"n": 9,
						"h": 36,
						"w": 425
					},
					{
						"n": 10,
						"h": 161,
						"w": 449
					},
					{
						"n": 11,
						"h": 287,
						"w": 422
					}
				],
				"ball": {
					"n": 0,
					"h": 63,
					"w": 546,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 33
		},
		{
			"num": 396,
			"minute": 19,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 19
					},
					{
						"n": 2,
						"h": 120,
						"w": 250
					},
					{
						"n": 3,
						"h": 175,
						"w": 256
					},
					{
						"n": 4,
						"h": 256,
						"w": 251
					},
					{
						"n": 5,
						"h": 330,
						"w": 252
					},
					{
						"n": 6,
						"h": 29,
						"w": 358
					},
					{
						"n": 7,
						"h": 129,
						"w": 309
					},
					{
						"n": 8,
						"h": 248,
						"w": 326
					},
					{
						"n": 9,
						"h": 394,
						"w": 299
					},
					{
						"n": 10,
						"h": 176,
						"w": 448
					},
					{
						"n": 11,
						"h": 316,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 15
					},
					{
						"n": 2,
						"h": 66,
						"w": 161
					},
					{
						"n": 3,
						"h": 172,
						"w": 108
					},
					{
						"n": 4,
						"h": 274,
						"w": 135
					},
					{
						"n": 5,
						"h": 386,
						"w": 214
					},
					{
						"n": 6,
						"h": 232,
						"w": 217
					},
					{
						"n": 7,
						"h": 270,
						"w": 286
					},
					{
						"n": 8,
						"h": 394,
						"w": 309
					},
					{
						"n": 9,
						"h": 46,
						"w": 386
					},
					{
						"n": 10,
						"h": 161,
						"w": 445
					},
					{
						"n": 11,
						"h": 315,
						"w": 394
					}
				],
				"ball": {
					"n": 0,
					"h": 64,
					"w": 506,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 397,
			"minute": 19,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 16
					},
					{
						"n": 2,
						"h": 120,
						"w": 239
					},
					{
						"n": 3,
						"h": 153,
						"w": 234
					},
					{
						"n": 4,
						"h": 271,
						"w": 238
					},
					{
						"n": 5,
						"h": 330,
						"w": 247
					},
					{
						"n": 6,
						"h": 53,
						"w": 406
					},
					{
						"n": 7,
						"h": 137,
						"w": 334
					},
					{
						"n": 8,
						"h": 235,
						"w": 337
					},
					{
						"n": 9,
						"h": 394,
						"w": 259
					},
					{
						"n": 10,
						"h": 175,
						"w": 433
					},
					{
						"n": 11,
						"h": 312,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 223,
						"w": 11
					},
					{
						"n": 2,
						"h": 69,
						"w": 168
					},
					{
						"n": 3,
						"h": 167,
						"w": 124
					},
					{
						"n": 4,
						"h": 275,
						"w": 129
					},
					{
						"n": 5,
						"h": 391,
						"w": 254
					},
					{
						"n": 6,
						"h": 264,
						"w": 231
					},
					{
						"n": 7,
						"h": 256,
						"w": 315
					},
					{
						"n": 8,
						"h": 396,
						"w": 349
					},
					{
						"n": 9,
						"h": 47,
						"w": 426
					},
					{
						"n": 10,
						"h": 168,
						"w": 460
					},
					{
						"n": 11,
						"h": 314,
						"w": 361
					}
				],
				"ball": {
					"n": 0,
					"h": 59,
					"w": 466,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 398,
			"minute": 19,
			"messages": [
				{
					"owner": 2,
					"mes": "Томаш Прохазка[25](Опава) пасует О.Дюмону[26](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 15
					},
					{
						"n": 2,
						"h": 120,
						"w": 211
					},
					{
						"n": 3,
						"h": 164,
						"w": 217
					},
					{
						"n": 4,
						"h": 279,
						"w": 205
					},
					{
						"n": 5,
						"h": 330,
						"w": 205
					},
					{
						"n": 6,
						"h": 54,
						"w": 363
					},
					{
						"n": 7,
						"h": 161,
						"w": 301
					},
					{
						"n": 8,
						"h": 258,
						"w": 301
					},
					{
						"n": 9,
						"h": 360,
						"w": 263
					},
					{
						"n": 10,
						"h": 142,
						"w": 405
					},
					{
						"n": 11,
						"h": 308,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 35
					},
					{
						"n": 2,
						"h": 61,
						"w": 210
					},
					{
						"n": 3,
						"h": 165,
						"w": 155
					},
					{
						"n": 4,
						"h": 282,
						"w": 159
					},
					{
						"n": 5,
						"h": 391,
						"w": 244
					},
					{
						"n": 6,
						"h": 264,
						"w": 231
					},
					{
						"n": 7,
						"h": 239,
						"w": 355
					},
					{
						"n": 8,
						"h": 404,
						"w": 392
					},
					{
						"n": 9,
						"h": 90,
						"w": 422
					},
					{
						"n": 10,
						"h": 152,
						"w": 490
					},
					{
						"n": 11,
						"h": 299,
						"w": 402
					}
				],
				"ball": {
					"n": 0,
					"h": 186,
					"w": 489,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 43
		},
		{
			"num": 399,
			"minute": 19,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 19
					},
					{
						"n": 2,
						"h": 120,
						"w": 182
					},
					{
						"n": 3,
						"h": 181,
						"w": 190
					},
					{
						"n": 4,
						"h": 261,
						"w": 178
					},
					{
						"n": 5,
						"h": 330,
						"w": 182
					},
					{
						"n": 6,
						"h": 55,
						"w": 323
					},
					{
						"n": 7,
						"h": 167,
						"w": 261
					},
					{
						"n": 8,
						"h": 264,
						"w": 264
					},
					{
						"n": 9,
						"h": 389,
						"w": 284
					},
					{
						"n": 10,
						"h": 147,
						"w": 400
					},
					{
						"n": 11,
						"h": 308,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 52
					},
					{
						"n": 2,
						"h": 73,
						"w": 236
					},
					{
						"n": 3,
						"h": 163,
						"w": 186
					},
					{
						"n": 4,
						"h": 276,
						"w": 196
					},
					{
						"n": 5,
						"h": 388,
						"w": 205
					},
					{
						"n": 6,
						"h": 257,
						"w": 266
					},
					{
						"n": 7,
						"h": 239,
						"w": 377
					},
					{
						"n": 8,
						"h": 401,
						"w": 432
					},
					{
						"n": 9,
						"h": 91,
						"w": 437
					},
					{
						"n": 10,
						"h": 176,
						"w": 512
					},
					{
						"n": 11,
						"h": 288,
						"w": 440
					}
				],
				"ball": {
					"n": 0,
					"h": 193,
					"w": 454,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 400,
			"minute": 19,
			"messages": [
				{
					"owner": 2,
					"mes": "О.Дюмон[26](Опава) пасует С.Пейше[24](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 12
					},
					{
						"n": 2,
						"h": 147,
						"w": 191
					},
					{
						"n": 3,
						"h": 207,
						"w": 202
					},
					{
						"n": 4,
						"h": 283,
						"w": 198
					},
					{
						"n": 5,
						"h": 346,
						"w": 207
					},
					{
						"n": 6,
						"h": 55,
						"w": 294
					},
					{
						"n": 7,
						"h": 163,
						"w": 290
					},
					{
						"n": 8,
						"h": 275,
						"w": 290
					},
					{
						"n": 9,
						"h": 391,
						"w": 312
					},
					{
						"n": 10,
						"h": 127,
						"w": 400
					},
					{
						"n": 11,
						"h": 310,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 23
					},
					{
						"n": 2,
						"h": 69,
						"w": 207
					},
					{
						"n": 3,
						"h": 172,
						"w": 159
					},
					{
						"n": 4,
						"h": 266,
						"w": 208
					},
					{
						"n": 5,
						"h": 390,
						"w": 176
					},
					{
						"n": 6,
						"h": 248,
						"w": 262
					},
					{
						"n": 7,
						"h": 234,
						"w": 348
					},
					{
						"n": 8,
						"h": 394,
						"w": 442
					},
					{
						"n": 9,
						"h": 112,
						"w": 417
					},
					{
						"n": 10,
						"h": 170,
						"w": 483
					},
					{
						"n": 11,
						"h": 289,
						"w": 411
					}
				],
				"ball": {
					"n": 0,
					"h": 184,
					"w": 512,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 29
		},
		{
			"num": 401,
			"minute": 19,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 12
					},
					{
						"n": 2,
						"h": 120,
						"w": 187
					},
					{
						"n": 3,
						"h": 244,
						"w": 188
					},
					{
						"n": 4,
						"h": 291,
						"w": 175
					},
					{
						"n": 5,
						"h": 330,
						"w": 179
					},
					{
						"n": 6,
						"h": 56,
						"w": 254
					},
					{
						"n": 7,
						"h": 186,
						"w": 257
					},
					{
						"n": 8,
						"h": 292,
						"w": 254
					},
					{
						"n": 9,
						"h": 417,
						"w": 282
					},
					{
						"n": 10,
						"h": 145,
						"w": 400
					},
					{
						"n": 11,
						"h": 317,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 48
					},
					{
						"n": 2,
						"h": 66,
						"w": 243
					},
					{
						"n": 3,
						"h": 169,
						"w": 196
					},
					{
						"n": 4,
						"h": 283,
						"w": 239
					},
					{
						"n": 5,
						"h": 387,
						"w": 212
					},
					{
						"n": 6,
						"h": 223,
						"w": 294
					},
					{
						"n": 7,
						"h": 198,
						"w": 365
					},
					{
						"n": 8,
						"h": 404,
						"w": 480
					},
					{
						"n": 9,
						"h": 152,
						"w": 422
					},
					{
						"n": 10,
						"h": 175,
						"w": 522
					},
					{
						"n": 11,
						"h": 275,
						"w": 374
					}
				],
				"ball": {
					"n": 0,
					"h": 167,
					"w": 481,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 402,
			"minute": 19,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 10
					},
					{
						"n": 2,
						"h": 80,
						"w": 181
					},
					{
						"n": 3,
						"h": 224,
						"w": 154
					},
					{
						"n": 4,
						"h": 299,
						"w": 157
					},
					{
						"n": 5,
						"h": 330,
						"w": 162
					},
					{
						"n": 6,
						"h": 64,
						"w": 255
					},
					{
						"n": 7,
						"h": 180,
						"w": 226
					},
					{
						"n": 8,
						"h": 290,
						"w": 221
					},
					{
						"n": 9,
						"h": 408,
						"w": 255
					},
					{
						"n": 10,
						"h": 164,
						"w": 426
					},
					{
						"n": 11,
						"h": 305,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 66
					},
					{
						"n": 2,
						"h": 57,
						"w": 282
					},
					{
						"n": 3,
						"h": 170,
						"w": 217
					},
					{
						"n": 4,
						"h": 286,
						"w": 274
					},
					{
						"n": 5,
						"h": 383,
						"w": 238
					},
					{
						"n": 6,
						"h": 232,
						"w": 311
					},
					{
						"n": 7,
						"h": 209,
						"w": 401
					},
					{
						"n": 8,
						"h": 405,
						"w": 520
					},
					{
						"n": 9,
						"h": 158,
						"w": 462
					},
					{
						"n": 10,
						"h": 155,
						"w": 548
					},
					{
						"n": 11,
						"h": 280,
						"w": 414
					}
				],
				"ball": {
					"n": 0,
					"h": 164,
					"w": 446,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 403,
			"minute": 19,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 19
					},
					{
						"n": 2,
						"h": 56,
						"w": 159
					},
					{
						"n": 3,
						"h": 264,
						"w": 154
					},
					{
						"n": 4,
						"h": 299,
						"w": 148
					},
					{
						"n": 5,
						"h": 330,
						"w": 154
					},
					{
						"n": 6,
						"h": 44,
						"w": 251
					},
					{
						"n": 7,
						"h": 156,
						"w": 233
					},
					{
						"n": 8,
						"h": 279,
						"w": 226
					},
					{
						"n": 9,
						"h": 393,
						"w": 251
					},
					{
						"n": 10,
						"h": 198,
						"w": 417
					},
					{
						"n": 11,
						"h": 275,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 223,
						"w": 91
					},
					{
						"n": 2,
						"h": 42,
						"w": 319
					},
					{
						"n": 3,
						"h": 175,
						"w": 244
					},
					{
						"n": 4,
						"h": 252,
						"w": 283
					},
					{
						"n": 5,
						"h": 380,
						"w": 237
					},
					{
						"n": 6,
						"h": 212,
						"w": 331
					},
					{
						"n": 7,
						"h": 212,
						"w": 394
					},
					{
						"n": 8,
						"h": 402,
						"w": 550
					},
					{
						"n": 9,
						"h": 166,
						"w": 501
					},
					{
						"n": 10,
						"h": 135,
						"w": 552
					},
					{
						"n": 11,
						"h": 287,
						"w": 453
					}
				],
				"ball": {
					"n": 0,
					"h": 198,
					"w": 437,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 404,
			"minute": 19,
			"messages": [
				{
					"owner": 2,
					"mes": "Себастьян Пейша[24](Опава) отдает мяч рванувшемуся вперед М.Манолову[27](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 13
					},
					{
						"n": 2,
						"h": 64,
						"w": 148
					},
					{
						"n": 3,
						"h": 238,
						"w": 125
					},
					{
						"n": 4,
						"h": 271,
						"w": 132
					},
					{
						"n": 5,
						"h": 330,
						"w": 129
					},
					{
						"n": 6,
						"h": 35,
						"w": 228
					},
					{
						"n": 7,
						"h": 130,
						"w": 211
					},
					{
						"n": 8,
						"h": 253,
						"w": 268
					},
					{
						"n": 9,
						"h": 389,
						"w": 228
					},
					{
						"n": 10,
						"h": 198,
						"w": 400
					},
					{
						"n": 11,
						"h": 269,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 223,
						"w": 107
					},
					{
						"n": 2,
						"h": 71,
						"w": 300
					},
					{
						"n": 3,
						"h": 181,
						"w": 253
					},
					{
						"n": 4,
						"h": 252,
						"w": 283,
						"m": 660
					},
					{
						"n": 5,
						"h": 383,
						"w": 270
					},
					{
						"n": 6,
						"h": 216,
						"w": 343
					},
					{
						"n": 7,
						"h": 202,
						"w": 424
					},
					{
						"n": 8,
						"h": 416,
						"w": 552
					},
					{
						"n": 9,
						"h": 215,
						"w": 493
					},
					{
						"n": 10,
						"h": 166,
						"w": 567
					},
					{
						"n": 11,
						"h": 314,
						"w": 437
					}
				],
				"ball": {
					"n": 0,
					"h": 248,
					"w": 296,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 50
		},
		{
			"num": 405,
			"minute": 19,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 12
					},
					{
						"n": 2,
						"h": 56,
						"w": 148
					},
					{
						"n": 3,
						"h": 216,
						"w": 125
					},
					{
						"n": 4,
						"h": 281,
						"w": 120
					},
					{
						"n": 5,
						"h": 330,
						"w": 129
					},
					{
						"n": 6,
						"h": 30,
						"w": 221
					},
					{
						"n": 7,
						"h": 168,
						"w": 201
					},
					{
						"n": 8,
						"h": 264,
						"w": 251
					},
					{
						"n": 9,
						"h": 402,
						"w": 221
					},
					{
						"n": 10,
						"h": 179,
						"w": 400
					},
					{
						"n": 11,
						"h": 275,
						"w": 446
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 126
					},
					{
						"n": 2,
						"h": 67,
						"w": 302
					},
					{
						"n": 3,
						"h": 175,
						"w": 259
					},
					{
						"n": 4,
						"h": 271,
						"w": 273
					},
					{
						"n": 5,
						"h": 377,
						"w": 256
					},
					{
						"n": 6,
						"h": 217,
						"w": 361
					},
					{
						"n": 7,
						"h": 189,
						"w": 446
					},
					{
						"n": 8,
						"h": 417,
						"w": 559
					},
					{
						"n": 9,
						"h": 252,
						"w": 505
					},
					{
						"n": 10,
						"h": 149,
						"w": 578
					},
					{
						"n": 11,
						"h": 292,
						"w": 443
					}
				],
				"ball": {
					"n": 0,
					"h": 261,
					"w": 274,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 406,
			"minute": 19,
			"messages": [
				{
					"owner": 2,
					"mes": "Пас направо..."
				},
				{
					"owner": 2,
					"mes": "Шимон Товарек[31](Опава) достает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 15
					},
					{
						"n": 2,
						"h": 70,
						"w": 141
					},
					{
						"n": 3,
						"h": 217,
						"w": 123
					},
					{
						"n": 4,
						"h": 253,
						"w": 126
					},
					{
						"n": 5,
						"h": 330,
						"w": 112
					},
					{
						"n": 6,
						"h": 36,
						"w": 221
					},
					{
						"n": 7,
						"h": 170,
						"w": 237
					},
					{
						"n": 8,
						"h": 261,
						"w": 215
					},
					{
						"n": 9,
						"h": 397,
						"w": 221
					},
					{
						"n": 10,
						"h": 175,
						"w": 400
					},
					{
						"n": 11,
						"h": 277,
						"w": 446
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 124
					},
					{
						"n": 2,
						"h": 70,
						"w": 306
					},
					{
						"n": 3,
						"h": 173,
						"w": 260
					},
					{
						"n": 4,
						"h": 275,
						"w": 254
					},
					{
						"n": 5,
						"h": 374,
						"w": 273
					},
					{
						"n": 6,
						"h": 221,
						"w": 382
					},
					{
						"n": 7,
						"h": 199,
						"w": 443
					},
					{
						"n": 8,
						"h": 410,
						"w": 559
					},
					{
						"n": 9,
						"h": 229,
						"w": 525
					},
					{
						"n": 10,
						"h": 177,
						"w": 569
					},
					{
						"n": 11,
						"h": 282,
						"w": 477
					}
				],
				"ball": {
					"n": 0,
					"h": 168,
					"w": 243,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 36
		},
		{
			"num": 407,
			"minute": 19,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 16
					},
					{
						"n": 2,
						"h": 69,
						"w": 141
					},
					{
						"n": 3,
						"h": 217,
						"w": 124
					},
					{
						"n": 4,
						"h": 254,
						"w": 126
					},
					{
						"n": 5,
						"h": 330,
						"w": 113
					},
					{
						"n": 6,
						"h": 35,
						"w": 221
					},
					{
						"n": 7,
						"h": 169,
						"w": 238
					},
					{
						"n": 8,
						"h": 260,
						"w": 214
					},
					{
						"n": 9,
						"h": 398,
						"w": 221
					},
					{
						"n": 10,
						"h": 175,
						"w": 400
					},
					{
						"n": 11,
						"h": 277,
						"w": 446
					}
				],
				"away": [
					{
						"n": 1,
						"h": 221,
						"w": 123
					},
					{
						"n": 2,
						"h": 69,
						"w": 306
					},
					{
						"n": 3,
						"h": 174,
						"w": 260
					},
					{
						"n": 4,
						"h": 275,
						"w": 255
					},
					{
						"n": 5,
						"h": 375,
						"w": 273
					},
					{
						"n": 6,
						"h": 222,
						"w": 381
					},
					{
						"n": 7,
						"h": 200,
						"w": 442
					},
					{
						"n": 8,
						"h": 411,
						"w": 559
					},
					{
						"n": 9,
						"h": 229,
						"w": 526
					},
					{
						"n": 10,
						"h": 176,
						"w": 569
					},
					{
						"n": 11,
						"h": 282,
						"w": 478
					}
				],
				"ball": {
					"n": 0,
					"h": 168,
					"w": 242,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 1
		},
		{
			"num": 408,
			"minute": 19,
			"messages": [
				{
					"owner": 2,
					"mes": "Шимон Товарек[31](Опава) отдает передачу налево..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 10
					},
					{
						"n": 2,
						"h": 69,
						"w": 141
					},
					{
						"n": 3,
						"h": 194,
						"w": 128
					},
					{
						"n": 4,
						"h": 267,
						"w": 127
					},
					{
						"n": 5,
						"h": 330,
						"w": 113
					},
					{
						"n": 6,
						"h": 55,
						"w": 221
					},
					{
						"n": 7,
						"h": 159,
						"w": 216
					},
					{
						"n": 8,
						"h": 236,
						"w": 216
					},
					{
						"n": 9,
						"h": 386,
						"w": 221
					},
					{
						"n": 10,
						"h": 172,
						"w": 400
					},
					{
						"n": 11,
						"h": 301,
						"w": 446
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 127
					},
					{
						"n": 2,
						"h": 58,
						"w": 314
					},
					{
						"n": 3,
						"h": 174,
						"w": 252
					},
					{
						"n": 4,
						"h": 278,
						"w": 259
					},
					{
						"n": 5,
						"h": 380,
						"w": 266
					},
					{
						"n": 6,
						"h": 232,
						"w": 373
					},
					{
						"n": 7,
						"h": 210,
						"w": 464
					},
					{
						"n": 8,
						"h": 411,
						"w": 559
					},
					{
						"n": 9,
						"h": 222,
						"w": 503
					},
					{
						"n": 10,
						"h": 164,
						"w": 582
					},
					{
						"n": 11,
						"h": 283,
						"w": 488
					}
				],
				"ball": {
					"n": 0,
					"h": 228,
					"w": 217,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 24
		},
		{
			"num": 409,
			"minute": 19,
			"messages": [
				{
					"owner": 2,
					"mes": "Матей Юрасек[29](Опава) пытается выиграть позицию..."
				},
				{
					"owner": 2,
					"mes": "К.Нолан[08](Галвэй Юнайтед) выбивает мяч у М.Юрасека[29](Опава)..."
				},
				{
					"owner": 2,
					"mes": "Мяч оказывается у М.Манолова[27](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 17
					},
					{
						"n": 2,
						"h": 62,
						"w": 147
					},
					{
						"n": 3,
						"h": 184,
						"w": 117
					},
					{
						"n": 4,
						"h": 281,
						"w": 121
					},
					{
						"n": 5,
						"h": 330,
						"w": 121
					},
					{
						"n": 6,
						"h": 55,
						"w": 221
					},
					{
						"n": 7,
						"h": 167,
						"w": 204
					},
					{
						"n": 8,
						"h": 237,
						"w": 213,
						"m": 610
					},
					{
						"n": 9,
						"h": 400,
						"w": 216
					},
					{
						"n": 10,
						"h": 180,
						"w": 400
					},
					{
						"n": 11,
						"h": 305,
						"w": 432
					}
				],
				"away": [
					{
						"n": 1,
						"h": 221,
						"w": 121
					},
					{
						"n": 2,
						"h": 69,
						"w": 325
					},
					{
						"n": 3,
						"h": 177,
						"w": 263
					},
					{
						"n": 4,
						"h": 270,
						"w": 272
					},
					{
						"n": 5,
						"h": 376,
						"w": 281
					},
					{
						"n": 6,
						"h": 230,
						"w": 376
					},
					{
						"n": 7,
						"h": 223,
						"w": 472
					},
					{
						"n": 8,
						"h": 396,
						"w": 559
					},
					{
						"n": 9,
						"h": 222,
						"w": 503
					},
					{
						"n": 10,
						"h": 150,
						"w": 588
					},
					{
						"n": 11,
						"h": 287,
						"w": 502
					}
				],
				"ball": {
					"n": 0,
					"h": 227,
					"w": 248,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 15
		},
		{
			"num": 410,
			"minute": 19,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 11
					},
					{
						"n": 2,
						"h": 56,
						"w": 155
					},
					{
						"n": 3,
						"h": 216,
						"w": 115
					},
					{
						"n": 4,
						"h": 269,
						"w": 122
					},
					{
						"n": 5,
						"h": 330,
						"w": 112
					},
					{
						"n": 6,
						"h": 58,
						"w": 214
					},
					{
						"n": 7,
						"h": 205,
						"w": 201
					},
					{
						"n": 8,
						"h": 222,
						"w": 177
					},
					{
						"n": 9,
						"h": 410,
						"w": 214
					},
					{
						"n": 10,
						"h": 183,
						"w": 400
					},
					{
						"n": 11,
						"h": 320,
						"w": 417
					}
				],
				"away": [
					{
						"n": 1,
						"h": 223,
						"w": 121
					},
					{
						"n": 2,
						"h": 58,
						"w": 325
					},
					{
						"n": 3,
						"h": 167,
						"w": 282
					},
					{
						"n": 4,
						"h": 267,
						"w": 286
					},
					{
						"n": 5,
						"h": 380,
						"w": 278
					},
					{
						"n": 6,
						"h": 236,
						"w": 377
					},
					{
						"n": 7,
						"h": 240,
						"w": 502
					},
					{
						"n": 8,
						"h": 419,
						"w": 559
					},
					{
						"n": 9,
						"h": 229,
						"w": 526
					},
					{
						"n": 10,
						"h": 167,
						"w": 589
					},
					{
						"n": 11,
						"h": 289,
						"w": 497
					}
				],
				"ball": {
					"n": 0,
					"h": 210,
					"w": 218,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 411,
			"minute": 19,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 16
					},
					{
						"n": 2,
						"h": 56,
						"w": 149
					},
					{
						"n": 3,
						"h": 219,
						"w": 111
					},
					{
						"n": 4,
						"h": 272,
						"w": 123
					},
					{
						"n": 5,
						"h": 330,
						"w": 119
					},
					{
						"n": 6,
						"h": 26,
						"w": 214
					},
					{
						"n": 7,
						"h": 168,
						"w": 197
					},
					{
						"n": 8,
						"h": 201,
						"w": 184
					},
					{
						"n": 9,
						"h": 422,
						"w": 214
					},
					{
						"n": 10,
						"h": 181,
						"w": 400
					},
					{
						"n": 11,
						"h": 309,
						"w": 446
					}
				],
				"away": [
					{
						"n": 1,
						"h": 223,
						"w": 119
					},
					{
						"n": 2,
						"h": 70,
						"w": 297
					},
					{
						"n": 3,
						"h": 170,
						"w": 252
					},
					{
						"n": 4,
						"h": 269,
						"w": 273
					},
					{
						"n": 5,
						"h": 387,
						"w": 283
					},
					{
						"n": 6,
						"h": 235,
						"w": 343
					},
					{
						"n": 7,
						"h": 279,
						"w": 505
					},
					{
						"n": 8,
						"h": 413,
						"w": 559
					},
					{
						"n": 9,
						"h": 251,
						"w": 547
					},
					{
						"n": 10,
						"h": 164,
						"w": 589
					},
					{
						"n": 11,
						"h": 320,
						"w": 471
					}
				],
				"ball": {
					"n": 0,
					"h": 171,
					"w": 215,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 412,
			"minute": 20,
			"possession": 41,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 10
					},
					{
						"n": 2,
						"h": 56,
						"w": 123
					},
					{
						"n": 3,
						"h": 198,
						"w": 110,
						"f": 95
					},
					{
						"n": 4,
						"h": 280,
						"w": 106
					},
					{
						"n": 5,
						"h": 330,
						"w": 113
					},
					{
						"n": 6,
						"h": 37,
						"w": 213,
						"f": 93
					},
					{
						"n": 7,
						"h": 213,
						"w": 183
					},
					{
						"n": 8,
						"h": 176,
						"w": 188
					},
					{
						"n": 9,
						"h": 420,
						"w": 213
					},
					{
						"n": 10,
						"h": 182,
						"w": 400
					},
					{
						"n": 11,
						"h": 311,
						"w": 428
					}
				],
				"away": [
					{
						"n": 1,
						"h": 223,
						"w": 123,
						"f": 93
					},
					{
						"n": 2,
						"h": 53,
						"w": 333,
						"m": 590
					},
					{
						"n": 3,
						"h": 166,
						"w": 271
					},
					{
						"n": 4,
						"h": 268,
						"w": 264
					},
					{
						"n": 5,
						"h": 384,
						"w": 286
					},
					{
						"n": 6,
						"h": 230,
						"w": 383
					},
					{
						"n": 7,
						"h": 241,
						"w": 515
					},
					{
						"n": 8,
						"h": 402,
						"w": 590
					},
					{
						"n": 9,
						"h": 271,
						"w": 562
					},
					{
						"n": 10,
						"h": 144,
						"w": 588,
						"f": 92
					},
					{
						"n": 11,
						"h": 313,
						"w": 511,
						"f": 92
					}
				],
				"ball": {
					"n": 0,
					"h": 209,
					"w": 205,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 413,
			"minute": 20,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 15
					},
					{
						"n": 2,
						"h": 58,
						"w": 120
					},
					{
						"n": 3,
						"h": 200,
						"w": 98
					},
					{
						"n": 4,
						"h": 282,
						"w": 96
					},
					{
						"n": 5,
						"h": 318,
						"w": 118
					},
					{
						"n": 6,
						"h": 29,
						"w": 206
					},
					{
						"n": 7,
						"h": 242,
						"w": 172
					},
					{
						"n": 8,
						"h": 163,
						"w": 150
					},
					{
						"n": 9,
						"h": 391,
						"w": 206
					},
					{
						"n": 10,
						"h": 188,
						"w": 400
					},
					{
						"n": 11,
						"h": 278,
						"w": 416
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 124
					},
					{
						"n": 2,
						"h": 42,
						"w": 360
					},
					{
						"n": 3,
						"h": 172,
						"w": 287
					},
					{
						"n": 4,
						"h": 262,
						"w": 278
					},
					{
						"n": 5,
						"h": 394,
						"w": 277
					},
					{
						"n": 6,
						"h": 223,
						"w": 422
					},
					{
						"n": 7,
						"h": 203,
						"w": 525
					},
					{
						"n": 8,
						"h": 400,
						"w": 594
					},
					{
						"n": 9,
						"h": 290,
						"w": 597
					},
					{
						"n": 10,
						"h": 124,
						"w": 595
					},
					{
						"n": 11,
						"h": 300,
						"w": 549
					}
				],
				"ball": {
					"n": 0,
					"h": 247,
					"w": 195,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 414,
			"minute": 20,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 15
					},
					{
						"n": 2,
						"h": 56,
						"w": 101
					},
					{
						"n": 3,
						"h": 171,
						"w": 93
					},
					{
						"n": 4,
						"h": 259,
						"w": 89
					},
					{
						"n": 5,
						"h": 298,
						"w": 109
					},
					{
						"n": 6,
						"h": 46,
						"w": 195
					},
					{
						"n": 7,
						"h": 211,
						"w": 163
					},
					{
						"n": 8,
						"h": 145,
						"w": 114
					},
					{
						"n": 9,
						"h": 424,
						"w": 193
					},
					{
						"n": 10,
						"h": 176,
						"w": 400
					},
					{
						"n": 11,
						"h": 314,
						"w": 418
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 119
					},
					{
						"n": 2,
						"h": 45,
						"w": 360
					},
					{
						"n": 3,
						"h": 170,
						"w": 281
					},
					{
						"n": 4,
						"h": 274,
						"w": 298
					},
					{
						"n": 5,
						"h": 376,
						"w": 296
					},
					{
						"n": 6,
						"h": 240,
						"w": 404
					},
					{
						"n": 7,
						"h": 241,
						"w": 535
					},
					{
						"n": 8,
						"h": 410,
						"w": 610
					},
					{
						"n": 9,
						"h": 310,
						"w": 608
					},
					{
						"n": 10,
						"h": 144,
						"w": 602
					},
					{
						"n": 11,
						"h": 280,
						"w": 579
					}
				],
				"ball": {
					"n": 0,
					"h": 209,
					"w": 185,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 415,
			"minute": 20,
			"messages": [
				{
					"owner": 2,
					"mes": "Мирослав Манолов[27](Опава) пасует вперед на Ш.Товарека[31](Опава)..."
				},
				{
					"owner": 2,
					"mes": "Агуст Хлинссон[07](Галвэй Юнайтед) преграждает путь мячу!..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 14
					},
					{
						"n": 2,
						"h": 63,
						"w": 97
					},
					{
						"n": 3,
						"h": 164,
						"w": 88
					},
					{
						"n": 4,
						"h": 251,
						"w": 89
					},
					{
						"n": 5,
						"h": 292,
						"w": 103
					},
					{
						"n": 6,
						"h": 46,
						"w": 195
					},
					{
						"n": 7,
						"h": 206,
						"w": 170
					},
					{
						"n": 8,
						"h": 153,
						"w": 117
					},
					{
						"n": 9,
						"h": 416,
						"w": 192
					},
					{
						"n": 10,
						"h": 174,
						"w": 400
					},
					{
						"n": 11,
						"h": 306,
						"w": 418
					}
				],
				"away": [
					{
						"n": 1,
						"h": 229,
						"w": 119
					},
					{
						"n": 2,
						"h": 50,
						"w": 354
					},
					{
						"n": 3,
						"h": 176,
						"w": 287
					},
					{
						"n": 4,
						"h": 276,
						"w": 290
					},
					{
						"n": 5,
						"h": 381,
						"w": 290
					},
					{
						"n": 6,
						"h": 234,
						"w": 409
					},
					{
						"n": 7,
						"h": 241,
						"w": 535,
						"m": 560
					},
					{
						"n": 8,
						"h": 403,
						"w": 606
					},
					{
						"n": 9,
						"h": 302,
						"w": 608
					},
					{
						"n": 10,
						"h": 149,
						"w": 608
					},
					{
						"n": 11,
						"h": 275,
						"w": 575
					}
				],
				"ball": {
					"n": 0,
					"h": 206,
					"w": 170,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 8
		},
		{
			"num": 416,
			"minute": 20,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 13
					},
					{
						"n": 2,
						"h": 61,
						"w": 137
					},
					{
						"n": 3,
						"h": 168,
						"w": 108
					},
					{
						"n": 4,
						"h": 260,
						"w": 107
					},
					{
						"n": 5,
						"h": 323,
						"w": 129
					},
					{
						"n": 6,
						"h": 46,
						"w": 223
					},
					{
						"n": 7,
						"h": 241,
						"w": 170,
						"m": 670
					},
					{
						"n": 8,
						"h": 174,
						"w": 151
					},
					{
						"n": 9,
						"h": 408,
						"w": 232
					},
					{
						"n": 10,
						"h": 154,
						"w": 412
					},
					{
						"n": 11,
						"h": 286,
						"w": 415
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 80
					},
					{
						"n": 2,
						"h": 63,
						"w": 316
					},
					{
						"n": 3,
						"h": 183,
						"w": 247
					},
					{
						"n": 4,
						"h": 276,
						"w": 250
					},
					{
						"n": 5,
						"h": 348,
						"w": 267
					},
					{
						"n": 6,
						"h": 253,
						"w": 374
					},
					{
						"n": 7,
						"h": 214,
						"w": 530
					},
					{
						"n": 8,
						"h": 404,
						"w": 566
					},
					{
						"n": 9,
						"h": 293,
						"w": 569
					},
					{
						"n": 10,
						"h": 128,
						"w": 574
					},
					{
						"n": 11,
						"h": 270,
						"w": 535
					}
				],
				"ball": {
					"n": 0,
					"h": 241,
					"w": 170,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 417,
			"minute": 20,
			"messages": [
				{
					"owner": 1,
					"mes": "Пас назад..."
				},
				{
					"owner": 1,
					"mes": "Роббе Дриссенс[04](Галвэй Юнайтед) останавливает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 14
					},
					{
						"n": 2,
						"h": 65,
						"w": 163
					},
					{
						"n": 3,
						"h": 168,
						"w": 133
					},
					{
						"n": 4,
						"h": 247,
						"w": 118
					},
					{
						"n": 5,
						"h": 338,
						"w": 150
					},
					{
						"n": 6,
						"h": 45,
						"w": 249
					},
					{
						"n": 7,
						"h": 236,
						"w": 178
					},
					{
						"n": 8,
						"h": 188,
						"w": 172
					},
					{
						"n": 9,
						"h": 406,
						"w": 257
					},
					{
						"n": 10,
						"h": 145,
						"w": 436
					},
					{
						"n": 11,
						"h": 303,
						"w": 435
					}
				],
				"away": [
					{
						"n": 1,
						"h": 229,
						"w": 79
					},
					{
						"n": 2,
						"h": 68,
						"w": 290
					},
					{
						"n": 3,
						"h": 167,
						"w": 227
					},
					{
						"n": 4,
						"h": 285,
						"w": 244
					},
					{
						"n": 5,
						"h": 342,
						"w": 242
					},
					{
						"n": 6,
						"h": 263,
						"w": 350
					},
					{
						"n": 7,
						"h": 215,
						"w": 504
					},
					{
						"n": 8,
						"h": 404,
						"w": 540
					},
					{
						"n": 9,
						"h": 272,
						"w": 554
					},
					{
						"n": 10,
						"h": 130,
						"w": 548
					},
					{
						"n": 11,
						"h": 273,
						"w": 509
					}
				],
				"ball": {
					"n": 0,
					"h": 247,
					"w": 118,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 26
		},
		{
			"num": 418,
			"minute": 20,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 17
					},
					{
						"n": 2,
						"h": 66,
						"w": 203
					},
					{
						"n": 3,
						"h": 173,
						"w": 172
					},
					{
						"n": 4,
						"h": 262,
						"w": 150
					},
					{
						"n": 5,
						"h": 362,
						"w": 182
					},
					{
						"n": 6,
						"h": 44,
						"w": 289
					},
					{
						"n": 7,
						"h": 222,
						"w": 216
					},
					{
						"n": 8,
						"h": 224,
						"w": 191
					},
					{
						"n": 9,
						"h": 401,
						"w": 297
					},
					{
						"n": 10,
						"h": 144,
						"w": 468
					},
					{
						"n": 11,
						"h": 288,
						"w": 472
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 79
					},
					{
						"n": 2,
						"h": 78,
						"w": 252
					},
					{
						"n": 3,
						"h": 174,
						"w": 217
					},
					{
						"n": 4,
						"h": 278,
						"w": 222
					},
					{
						"n": 5,
						"h": 340,
						"w": 220
					},
					{
						"n": 6,
						"h": 279,
						"w": 313
					},
					{
						"n": 7,
						"h": 215,
						"w": 464
					},
					{
						"n": 8,
						"h": 409,
						"w": 500
					},
					{
						"n": 9,
						"h": 241,
						"w": 529
					},
					{
						"n": 10,
						"h": 138,
						"w": 509
					},
					{
						"n": 11,
						"h": 286,
						"w": 471
					}
				],
				"ball": {
					"n": 0,
					"h": 262,
					"w": 150,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 419,
			"minute": 20,
			"messages": [
				{
					"owner": 1,
					"mes": "Роббе Дриссенс[04](Галвэй Юнайтед) переправляет мяч на ход К.Нолану[08](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 19
					},
					{
						"n": 2,
						"h": 67,
						"w": 234
					},
					{
						"n": 3,
						"h": 173,
						"w": 183
					},
					{
						"n": 4,
						"h": 262,
						"w": 150,
						"m": 640
					},
					{
						"n": 5,
						"h": 367,
						"w": 213
					},
					{
						"n": 6,
						"h": 43,
						"w": 320
					},
					{
						"n": 7,
						"h": 219,
						"w": 247
					},
					{
						"n": 8,
						"h": 214,
						"w": 231
					},
					{
						"n": 9,
						"h": 399,
						"w": 328
					},
					{
						"n": 10,
						"h": 164,
						"w": 492
					},
					{
						"n": 11,
						"h": 287,
						"w": 503
					}
				],
				"away": [
					{
						"n": 1,
						"h": 226,
						"w": 72
					},
					{
						"n": 2,
						"h": 102,
						"w": 232
					},
					{
						"n": 3,
						"h": 180,
						"w": 208
					},
					{
						"n": 4,
						"h": 268,
						"w": 223
					},
					{
						"n": 5,
						"h": 340,
						"w": 216
					},
					{
						"n": 6,
						"h": 252,
						"w": 298
					},
					{
						"n": 7,
						"h": 216,
						"w": 449
					},
					{
						"n": 8,
						"h": 410,
						"w": 469
					},
					{
						"n": 9,
						"h": 228,
						"w": 520
					},
					{
						"n": 10,
						"h": 148,
						"w": 480
					},
					{
						"n": 11,
						"h": 295,
						"w": 442
					}
				],
				"ball": {
					"n": 0,
					"h": 214,
					"w": 231,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 31
		},
		{
			"num": 420,
			"minute": 20,
			"messages": [
				{
					"owner": 1,
					"mes": "Киран Нолан[08](Галвэй Юнайтед) переправляет мяч на ход Э.Бвомоно[09](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 11
					},
					{
						"n": 2,
						"h": 69,
						"w": 238
					},
					{
						"n": 3,
						"h": 185,
						"w": 201
					},
					{
						"n": 4,
						"h": 266,
						"w": 191
					},
					{
						"n": 5,
						"h": 390,
						"w": 252
					},
					{
						"n": 6,
						"h": 50,
						"w": 375
					},
					{
						"n": 7,
						"h": 215,
						"w": 302
					},
					{
						"n": 8,
						"h": 214,
						"w": 231,
						"m": 620
					},
					{
						"n": 9,
						"h": 384,
						"w": 378
					},
					{
						"n": 10,
						"h": 164,
						"w": 502
					},
					{
						"n": 11,
						"h": 284,
						"w": 512
					}
				],
				"away": [
					{
						"n": 1,
						"h": 205,
						"w": 74
					},
					{
						"n": 2,
						"h": 85,
						"w": 285
					},
					{
						"n": 3,
						"h": 185,
						"w": 174
					},
					{
						"n": 4,
						"h": 267,
						"w": 167
					},
					{
						"n": 5,
						"h": 340,
						"w": 171
					},
					{
						"n": 6,
						"h": 269,
						"w": 245
					},
					{
						"n": 7,
						"h": 210,
						"w": 393
					},
					{
						"n": 8,
						"h": 406,
						"w": 414
					},
					{
						"n": 9,
						"h": 189,
						"w": 481
					},
					{
						"n": 10,
						"h": 159,
						"w": 425
					},
					{
						"n": 11,
						"h": 250,
						"w": 409
					}
				],
				"ball": {
					"n": 0,
					"h": 384,
					"w": 378,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 56
		},
		{
			"num": 421,
			"minute": 20,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 15
					},
					{
						"n": 2,
						"h": 68,
						"w": 278
					},
					{
						"n": 3,
						"h": 178,
						"w": 220
					},
					{
						"n": 4,
						"h": 281,
						"w": 228
					},
					{
						"n": 5,
						"h": 391,
						"w": 281
					},
					{
						"n": 6,
						"h": 53,
						"w": 415
					},
					{
						"n": 7,
						"h": 210,
						"w": 342
					},
					{
						"n": 8,
						"h": 243,
						"w": 258
					},
					{
						"n": 9,
						"h": 394,
						"w": 418
					},
					{
						"n": 10,
						"h": 162,
						"w": 540
					},
					{
						"n": 11,
						"h": 279,
						"w": 552
					}
				],
				"away": [
					{
						"n": 1,
						"h": 205,
						"w": 75
					},
					{
						"n": 2,
						"h": 85,
						"w": 285
					},
					{
						"n": 3,
						"h": 181,
						"w": 143
					},
					{
						"n": 4,
						"h": 269,
						"w": 157
					},
					{
						"n": 5,
						"h": 340,
						"w": 132
					},
					{
						"n": 6,
						"h": 277,
						"w": 206
					},
					{
						"n": 7,
						"h": 208,
						"w": 353
					},
					{
						"n": 8,
						"h": 404,
						"w": 374
					},
					{
						"n": 9,
						"h": 163,
						"w": 450
					},
					{
						"n": 10,
						"h": 166,
						"w": 385
					},
					{
						"n": 11,
						"h": 242,
						"w": 369
					}
				],
				"ball": {
					"n": 0,
					"h": 394,
					"w": 418,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 422,
			"minute": 20,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 19
					},
					{
						"n": 2,
						"h": 60,
						"w": 317
					},
					{
						"n": 3,
						"h": 169,
						"w": 259
					},
					{
						"n": 4,
						"h": 293,
						"w": 266
					},
					{
						"n": 5,
						"h": 381,
						"w": 316
					},
					{
						"n": 6,
						"h": 56,
						"w": 455
					},
					{
						"n": 7,
						"h": 211,
						"w": 382
					},
					{
						"n": 8,
						"h": 267,
						"w": 290
					},
					{
						"n": 9,
						"h": 404,
						"w": 458
					},
					{
						"n": 10,
						"h": 171,
						"w": 578
					},
					{
						"n": 11,
						"h": 285,
						"w": 588
					}
				],
				"away": [
					{
						"n": 1,
						"h": 205,
						"w": 72
					},
					{
						"n": 2,
						"h": 84,
						"w": 254
					},
					{
						"n": 3,
						"h": 184,
						"w": 103
					},
					{
						"n": 4,
						"h": 261,
						"w": 118
					},
					{
						"n": 5,
						"h": 340,
						"w": 110
					},
					{
						"n": 6,
						"h": 283,
						"w": 166
					},
					{
						"n": 7,
						"h": 206,
						"w": 314
					},
					{
						"n": 8,
						"h": 401,
						"w": 334
					},
					{
						"n": 9,
						"h": 139,
						"w": 418
					},
					{
						"n": 10,
						"h": 167,
						"w": 345
					},
					{
						"n": 11,
						"h": 240,
						"w": 329
					}
				],
				"ball": {
					"n": 0,
					"h": 404,
					"w": 458,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 423,
			"minute": 20,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 16
					},
					{
						"n": 2,
						"h": 78,
						"w": 353
					},
					{
						"n": 3,
						"h": 182,
						"w": 297
					},
					{
						"n": 4,
						"h": 281,
						"w": 282
					},
					{
						"n": 5,
						"h": 372,
						"w": 344
					},
					{
						"n": 6,
						"h": 51,
						"w": 495
					},
					{
						"n": 7,
						"h": 213,
						"w": 422
					},
					{
						"n": 8,
						"h": 276,
						"w": 329
					},
					{
						"n": 9,
						"h": 404,
						"w": 503
					},
					{
						"n": 10,
						"h": 166,
						"w": 603
					},
					{
						"n": 11,
						"h": 289,
						"w": 613
					}
				],
				"away": [
					{
						"n": 1,
						"h": 205,
						"w": 57
					},
					{
						"n": 2,
						"h": 74,
						"w": 209
					},
					{
						"n": 3,
						"h": 175,
						"w": 92
					},
					{
						"n": 4,
						"h": 265,
						"w": 103
					},
					{
						"n": 5,
						"h": 340,
						"w": 87
					},
					{
						"n": 6,
						"h": 244,
						"w": 158
					},
					{
						"n": 7,
						"h": 206,
						"w": 274
					},
					{
						"n": 8,
						"h": 401,
						"w": 294
					},
					{
						"n": 9,
						"h": 118,
						"w": 384
					},
					{
						"n": 10,
						"h": 169,
						"w": 305
					},
					{
						"n": 11,
						"h": 238,
						"w": 290
					}
				],
				"ball": {
					"n": 0,
					"h": 404,
					"w": 503,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 424,
			"minute": 20,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 19
					},
					{
						"n": 2,
						"h": 73,
						"w": 375
					},
					{
						"n": 3,
						"h": 178,
						"w": 324
					},
					{
						"n": 4,
						"h": 267,
						"w": 316
					},
					{
						"n": 5,
						"h": 379,
						"w": 363
					},
					{
						"n": 6,
						"h": 54,
						"w": 532
					},
					{
						"n": 7,
						"h": 215,
						"w": 459
					},
					{
						"n": 8,
						"h": 278,
						"w": 366
					},
					{
						"n": 9,
						"h": 414,
						"w": 543
					},
					{
						"n": 10,
						"h": 176,
						"w": 623
					},
					{
						"n": 11,
						"h": 278,
						"w": 633
					}
				],
				"away": [
					{
						"n": 1,
						"h": 212,
						"w": 21
					},
					{
						"n": 2,
						"h": 74,
						"w": 171
					},
					{
						"n": 3,
						"h": 182,
						"w": 60
					},
					{
						"n": 4,
						"h": 255,
						"w": 75
					},
					{
						"n": 5,
						"h": 340,
						"w": 74
					},
					{
						"n": 6,
						"h": 207,
						"w": 151
					},
					{
						"n": 7,
						"h": 203,
						"w": 237
					},
					{
						"n": 8,
						"h": 399,
						"w": 257
					},
					{
						"n": 9,
						"h": 104,
						"w": 350
					},
					{
						"n": 10,
						"h": 172,
						"w": 334
					},
					{
						"n": 11,
						"h": 271,
						"w": 307
					}
				],
				"ball": {
					"n": 0,
					"h": 414,
					"w": 543,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 37
		},
		{
			"num": 425,
			"minute": 20,
			"messages": [
				{
					"owner": 1,
					"mes": "Острый пас в штрафную площадь..."
				},
				{
					"owner": 1,
					"mes": "Нир Мансур[23](Опава) делает важный перехват..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 11
					},
					{
						"n": 2,
						"h": 70,
						"w": 370
					},
					{
						"n": 3,
						"h": 178,
						"w": 322
					},
					{
						"n": 4,
						"h": 267,
						"w": 312
					},
					{
						"n": 5,
						"h": 388,
						"w": 371
					},
					{
						"n": 6,
						"h": 58,
						"w": 592
					},
					{
						"n": 7,
						"h": 194,
						"w": 515
					},
					{
						"n": 8,
						"h": 278,
						"w": 426
					},
					{
						"n": 9,
						"h": 414,
						"w": 573,
						"m": 690
					},
					{
						"n": 10,
						"h": 169,
						"w": 664
					},
					{
						"n": 11,
						"h": 306,
						"w": 678
					}
				],
				"away": [
					{
						"n": 1,
						"h": 212,
						"w": 7
					},
					{
						"n": 2,
						"h": 61,
						"w": 127
					},
					{
						"n": 3,
						"h": 133,
						"w": 25
					},
					{
						"n": 4,
						"h": 262,
						"w": 25
					},
					{
						"n": 5,
						"h": 340,
						"w": 33
					},
					{
						"n": 6,
						"h": 183,
						"w": 100
					},
					{
						"n": 7,
						"h": 227,
						"w": 182
					},
					{
						"n": 8,
						"h": 406,
						"w": 197
					},
					{
						"n": 9,
						"h": 75,
						"w": 297
					},
					{
						"n": 10,
						"h": 172,
						"w": 274
					},
					{
						"n": 11,
						"h": 281,
						"w": 308
					}
				],
				"ball": {
					"n": 0,
					"h": 317,
					"w": 695,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 60
		},
		{
			"num": 426,
			"minute": 20,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 16
					},
					{
						"n": 2,
						"h": 80,
						"w": 331
					},
					{
						"n": 3,
						"h": 180,
						"w": 313
					},
					{
						"n": 4,
						"h": 275,
						"w": 322
					},
					{
						"n": 5,
						"h": 365,
						"w": 338
					},
					{
						"n": 6,
						"h": 57,
						"w": 552
					},
					{
						"n": 7,
						"h": 200,
						"w": 476
					},
					{
						"n": 8,
						"h": 278,
						"w": 403
					},
					{
						"n": 9,
						"h": 412,
						"w": 533
					},
					{
						"n": 10,
						"h": 172,
						"w": 624
					},
					{
						"n": 11,
						"h": 338,
						"w": 653
					}
				],
				"away": [
					{
						"n": 1,
						"h": 223,
						"w": 19
					},
					{
						"n": 2,
						"h": 59,
						"w": 150
					},
					{
						"n": 3,
						"h": 108,
						"w": 50,
						"m": 560
					},
					{
						"n": 4,
						"h": 267,
						"w": 65
					},
					{
						"n": 5,
						"h": 365,
						"w": 64
					},
					{
						"n": 6,
						"h": 202,
						"w": 135
					},
					{
						"n": 7,
						"h": 226,
						"w": 222
					},
					{
						"n": 8,
						"h": 403,
						"w": 237
					},
					{
						"n": 9,
						"h": 55,
						"w": 262
					},
					{
						"n": 10,
						"h": 164,
						"w": 313
					},
					{
						"n": 11,
						"h": 286,
						"w": 348
					}
				],
				"ball": {
					"n": 0,
					"h": 342,
					"w": 670,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 427,
			"minute": 20,
			"messages": [
				{
					"owner": 2,
					"mes": "Н.Мансур[23](Опава) делает передачу С.Пейше[24](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 10
					},
					{
						"n": 2,
						"h": 114,
						"w": 300
					},
					{
						"n": 3,
						"h": 158,
						"w": 293
					},
					{
						"n": 4,
						"h": 257,
						"w": 296
					},
					{
						"n": 5,
						"h": 335,
						"w": 304
					},
					{
						"n": 6,
						"h": 54,
						"w": 506
					},
					{
						"n": 7,
						"h": 172,
						"w": 439
					},
					{
						"n": 8,
						"h": 288,
						"w": 365
					},
					{
						"n": 9,
						"h": 408,
						"w": 487
					},
					{
						"n": 10,
						"h": 203,
						"w": 658
					},
					{
						"n": 11,
						"h": 329,
						"w": 608
					}
				],
				"away": [
					{
						"n": 1,
						"h": 228,
						"w": 12
					},
					{
						"n": 2,
						"h": 70,
						"w": 144
					},
					{
						"n": 3,
						"h": 116,
						"w": 56
					},
					{
						"n": 4,
						"h": 245,
						"w": 39
					},
					{
						"n": 5,
						"h": 384,
						"w": 100
					},
					{
						"n": 6,
						"h": 213,
						"w": 180
					},
					{
						"n": 7,
						"h": 232,
						"w": 267
					},
					{
						"n": 8,
						"h": 401,
						"w": 260
					},
					{
						"n": 9,
						"h": 51,
						"w": 300
					},
					{
						"n": 10,
						"h": 157,
						"w": 359
					},
					{
						"n": 11,
						"h": 327,
						"w": 327
					}
				],
				"ball": {
					"n": 0,
					"h": 205,
					"w": 681,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 46
		},
		{
			"num": 428,
			"minute": 20,
			"messages": [
				{
					"owner": 2,
					"mes": "Себастьян Пейша[24](Опава) пасует Т.Прохазке[25](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 14
					},
					{
						"n": 2,
						"h": 120,
						"w": 279
					},
					{
						"n": 3,
						"h": 195,
						"w": 274
					},
					{
						"n": 4,
						"h": 277,
						"w": 266
					},
					{
						"n": 5,
						"h": 330,
						"w": 277
					},
					{
						"n": 6,
						"h": 69,
						"w": 545
					},
					{
						"n": 7,
						"h": 175,
						"w": 397
					},
					{
						"n": 8,
						"h": 293,
						"w": 341
					},
					{
						"n": 9,
						"h": 404,
						"w": 446
					},
					{
						"n": 10,
						"h": 202,
						"w": 616
					},
					{
						"n": 11,
						"h": 326,
						"w": 566
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 16
					},
					{
						"n": 2,
						"h": 58,
						"w": 157
					},
					{
						"n": 3,
						"h": 147,
						"w": 84
					},
					{
						"n": 4,
						"h": 249,
						"w": 48
					},
					{
						"n": 5,
						"h": 362,
						"w": 83
					},
					{
						"n": 6,
						"h": 255,
						"w": 177
					},
					{
						"n": 7,
						"h": 264,
						"w": 294
					},
					{
						"n": 8,
						"h": 402,
						"w": 302
					},
					{
						"n": 9,
						"h": 53,
						"w": 342
					},
					{
						"n": 10,
						"h": 155,
						"w": 401
					},
					{
						"n": 11,
						"h": 365,
						"w": 309
					}
				],
				"ball": {
					"n": 0,
					"h": 88,
					"w": 637,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 42
		},
		{
			"num": 429,
			"minute": 20,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 11
					},
					{
						"n": 2,
						"h": 120,
						"w": 263
					},
					{
						"n": 3,
						"h": 201,
						"w": 257
					},
					{
						"n": 4,
						"h": 280,
						"w": 266
					},
					{
						"n": 5,
						"h": 330,
						"w": 268
					},
					{
						"n": 6,
						"h": 81,
						"w": 561
					},
					{
						"n": 7,
						"h": 190,
						"w": 360
					},
					{
						"n": 8,
						"h": 253,
						"w": 346
					},
					{
						"n": 9,
						"h": 412,
						"w": 406
					},
					{
						"n": 10,
						"h": 187,
						"w": 580
					},
					{
						"n": 11,
						"h": 320,
						"w": 527
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 17
					},
					{
						"n": 2,
						"h": 62,
						"w": 173
					},
					{
						"n": 3,
						"h": 157,
						"w": 101
					},
					{
						"n": 4,
						"h": 262,
						"w": 96
					},
					{
						"n": 5,
						"h": 352,
						"w": 117
					},
					{
						"n": 6,
						"h": 246,
						"w": 216
					},
					{
						"n": 7,
						"h": 259,
						"w": 334
					},
					{
						"n": 8,
						"h": 398,
						"w": 275
					},
					{
						"n": 9,
						"h": 52,
						"w": 382
					},
					{
						"n": 10,
						"h": 154,
						"w": 435
					},
					{
						"n": 11,
						"h": 376,
						"w": 348
					}
				],
				"ball": {
					"n": 0,
					"h": 98,
					"w": 603,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 430,
			"minute": 20,
			"messages": [
				{
					"owner": 2,
					"mes": "Томаш Прохазка[25](Опава) отдает на К.Ласака[21](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 18
					},
					{
						"n": 2,
						"h": 87,
						"w": 294
					},
					{
						"n": 3,
						"h": 212,
						"w": 253
					},
					{
						"n": 4,
						"h": 286,
						"w": 251
					},
					{
						"n": 5,
						"h": 369,
						"w": 273
					},
					{
						"n": 6,
						"h": 72,
						"w": 517
					},
					{
						"n": 7,
						"h": 210,
						"w": 328
					},
					{
						"n": 8,
						"h": 272,
						"w": 355
					},
					{
						"n": 9,
						"h": 413,
						"w": 361
					},
					{
						"n": 10,
						"h": 169,
						"w": 538
					},
					{
						"n": 11,
						"h": 318,
						"w": 482
					}
				],
				"away": [
					{
						"n": 1,
						"h": 249,
						"w": 31
					},
					{
						"n": 2,
						"h": 62,
						"w": 160
					},
					{
						"n": 3,
						"h": 175,
						"w": 125
					},
					{
						"n": 4,
						"h": 269,
						"w": 109
					},
					{
						"n": 5,
						"h": 361,
						"w": 120
					},
					{
						"n": 6,
						"h": 227,
						"w": 212
					},
					{
						"n": 7,
						"h": 236,
						"w": 373
					},
					{
						"n": 8,
						"h": 400,
						"w": 276
					},
					{
						"n": 9,
						"h": 51,
						"w": 427
					},
					{
						"n": 10,
						"h": 136,
						"w": 423
					},
					{
						"n": 11,
						"h": 387,
						"w": 391
					}
				],
				"ball": {
					"n": 0,
					"h": 201,
					"w": 689,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 45
		},
		{
			"num": 431,
			"minute": 21,
			"possession": 42,
			"messages": [
				{
					"owner": 2,
					"mes": "Пас вперед..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 16
					},
					{
						"n": 2,
						"h": 98,
						"w": 294,
						"f": 93
					},
					{
						"n": 3,
						"h": 210,
						"w": 251
					},
					{
						"n": 4,
						"h": 272,
						"w": 266
					},
					{
						"n": 5,
						"h": 340,
						"w": 268,
						"f": 93
					},
					{
						"n": 6,
						"h": 70,
						"w": 487,
						"m": 630
					},
					{
						"n": 7,
						"h": 204,
						"w": 336,
						"f": 93
					},
					{
						"n": 8,
						"h": 273,
						"w": 329,
						"f": 92
					},
					{
						"n": 9,
						"h": 405,
						"w": 332
					},
					{
						"n": 10,
						"h": 162,
						"w": 567,
						"f": 92
					},
					{
						"n": 11,
						"h": 312,
						"w": 452,
						"f": 93
					}
				],
				"away": [
					{
						"n": 1,
						"h": 240,
						"w": 27
					},
					{
						"n": 2,
						"h": 48,
						"w": 133
					},
					{
						"n": 3,
						"h": 149,
						"w": 119,
						"m": 570
					},
					{
						"n": 4,
						"h": 295,
						"w": 93
					},
					{
						"n": 5,
						"h": 391,
						"w": 119
					},
					{
						"n": 6,
						"h": 234,
						"w": 199,
						"f": 93
					},
					{
						"n": 7,
						"h": 236,
						"w": 343
					},
					{
						"n": 8,
						"h": 400,
						"w": 279,
						"f": 92
					},
					{
						"n": 9,
						"h": 45,
						"w": 397,
						"f": 92
					},
					{
						"n": 10,
						"h": 159,
						"w": 440
					},
					{
						"n": 11,
						"h": 361,
						"w": 406
					}
				],
				"ball": {
					"n": 0,
					"h": 158,
					"w": 646,
					"z": 0,
					"r": 0,
					"p": 2,
					"x": 0
				}
			},
			"interval": 30
		},
		{
			"num": 432,
			"minute": 21,
			"messages": [
				{
					"owner": 2,
					"mes": "Себастьян Пейша[24](Опава) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 12
					},
					{
						"n": 2,
						"h": 106,
						"w": 278
					},
					{
						"n": 3,
						"h": 199,
						"w": 265
					},
					{
						"n": 4,
						"h": 277,
						"w": 250
					},
					{
						"n": 5,
						"h": 330,
						"w": 261
					},
					{
						"n": 6,
						"h": 64,
						"w": 470
					},
					{
						"n": 7,
						"h": 186,
						"w": 338
					},
					{
						"n": 8,
						"h": 263,
						"w": 344
					},
					{
						"n": 9,
						"h": 398,
						"w": 316
					},
					{
						"n": 10,
						"h": 158,
						"w": 585
					},
					{
						"n": 11,
						"h": 310,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 231,
						"w": 17,
						"m": 580
					},
					{
						"n": 2,
						"h": 49,
						"w": 115
					},
					{
						"n": 3,
						"h": 148,
						"w": 101
					},
					{
						"n": 4,
						"h": 304,
						"w": 87
					},
					{
						"n": 5,
						"h": 400,
						"w": 104
					},
					{
						"n": 6,
						"h": 229,
						"w": 183
					},
					{
						"n": 7,
						"h": 234,
						"w": 325
					},
					{
						"n": 8,
						"h": 415,
						"w": 270
					},
					{
						"n": 9,
						"h": 47,
						"w": 380
					},
					{
						"n": 10,
						"h": 162,
						"w": 440
					},
					{
						"n": 11,
						"h": 345,
						"w": 413
					}
				],
				"ball": {
					"n": 0,
					"h": 146,
					"w": 633,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 18
		},
		{
			"num": 433,
			"minute": 21,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 12
					},
					{
						"n": 2,
						"h": 136,
						"w": 259
					},
					{
						"n": 3,
						"h": 216,
						"w": 264
					},
					{
						"n": 4,
						"h": 295,
						"w": 258
					},
					{
						"n": 5,
						"h": 330,
						"w": 254
					},
					{
						"n": 6,
						"h": 62,
						"w": 430
					},
					{
						"n": 7,
						"h": 189,
						"w": 333
					},
					{
						"n": 8,
						"h": 230,
						"w": 329
					},
					{
						"n": 9,
						"h": 376,
						"w": 283
					},
					{
						"n": 10,
						"h": 149,
						"w": 578
					},
					{
						"n": 11,
						"h": 316,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 11
					},
					{
						"n": 2,
						"h": 63,
						"w": 153
					},
					{
						"n": 3,
						"h": 176,
						"w": 121
					},
					{
						"n": 4,
						"h": 301,
						"w": 122
					},
					{
						"n": 5,
						"h": 375,
						"w": 124
					},
					{
						"n": 6,
						"h": 216,
						"w": 216
					},
					{
						"n": 7,
						"h": 225,
						"w": 364
					},
					{
						"n": 8,
						"h": 414,
						"w": 310
					},
					{
						"n": 9,
						"h": 77,
						"w": 406
					},
					{
						"n": 10,
						"h": 142,
						"w": 445
					},
					{
						"n": 11,
						"h": 325,
						"w": 446
					}
				],
				"ball": {
					"n": 0,
					"h": 149,
					"w": 598,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 434,
			"minute": 21,
			"messages": [
				{
					"owner": 2,
					"mes": "Себастьян Пейша[24](Опава) переправляет мяч на ход О.Дюмону[26](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 19
					},
					{
						"n": 2,
						"h": 120,
						"w": 234
					},
					{
						"n": 3,
						"h": 188,
						"w": 229
					},
					{
						"n": 4,
						"h": 282,
						"w": 229
					},
					{
						"n": 5,
						"h": 365,
						"w": 255
					},
					{
						"n": 6,
						"h": 59,
						"w": 385
					},
					{
						"n": 7,
						"h": 162,
						"w": 305
					},
					{
						"n": 8,
						"h": 217,
						"w": 325
					},
					{
						"n": 9,
						"h": 394,
						"w": 324
					},
					{
						"n": 10,
						"h": 148,
						"w": 533
					},
					{
						"n": 11,
						"h": 271,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 16
					},
					{
						"n": 2,
						"h": 73,
						"w": 190
					},
					{
						"n": 3,
						"h": 179,
						"w": 144
					},
					{
						"n": 4,
						"h": 301,
						"w": 122,
						"m": 670
					},
					{
						"n": 5,
						"h": 390,
						"w": 141
					},
					{
						"n": 6,
						"h": 246,
						"w": 246
					},
					{
						"n": 7,
						"h": 225,
						"w": 368
					},
					{
						"n": 8,
						"h": 416,
						"w": 355
					},
					{
						"n": 9,
						"h": 55,
						"w": 445
					},
					{
						"n": 10,
						"h": 153,
						"w": 451
					},
					{
						"n": 11,
						"h": 280,
						"w": 443
					}
				],
				"ball": {
					"n": 0,
					"h": 204,
					"w": 474,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 45
		},
		{
			"num": 435,
			"minute": 21,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 13
					},
					{
						"n": 2,
						"h": 120,
						"w": 195
					},
					{
						"n": 3,
						"h": 179,
						"w": 191
					},
					{
						"n": 4,
						"h": 280,
						"w": 190
					},
					{
						"n": 5,
						"h": 377,
						"w": 218
					},
					{
						"n": 6,
						"h": 57,
						"w": 346
					},
					{
						"n": 7,
						"h": 157,
						"w": 266
					},
					{
						"n": 8,
						"h": 222,
						"w": 286
					},
					{
						"n": 9,
						"h": 393,
						"w": 305
					},
					{
						"n": 10,
						"h": 152,
						"w": 494
					},
					{
						"n": 11,
						"h": 234,
						"w": 439
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 32
					},
					{
						"n": 2,
						"h": 62,
						"w": 227
					},
					{
						"n": 3,
						"h": 175,
						"w": 162
					},
					{
						"n": 4,
						"h": 288,
						"w": 159
					},
					{
						"n": 5,
						"h": 379,
						"w": 178
					},
					{
						"n": 6,
						"h": 249,
						"w": 272
					},
					{
						"n": 7,
						"h": 224,
						"w": 407
					},
					{
						"n": 8,
						"h": 419,
						"w": 394
					},
					{
						"n": 9,
						"h": 43,
						"w": 482
					},
					{
						"n": 10,
						"h": 155,
						"w": 490
					},
					{
						"n": 11,
						"h": 309,
						"w": 469
					}
				],
				"ball": {
					"n": 0,
					"h": 201,
					"w": 448,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 436,
			"minute": 21,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 11
					},
					{
						"n": 2,
						"h": 126,
						"w": 156
					},
					{
						"n": 3,
						"h": 190,
						"w": 154
					},
					{
						"n": 4,
						"h": 277,
						"w": 151
					},
					{
						"n": 5,
						"h": 387,
						"w": 180
					},
					{
						"n": 6,
						"h": 57,
						"w": 307
					},
					{
						"n": 7,
						"h": 169,
						"w": 229
					},
					{
						"n": 8,
						"h": 227,
						"w": 248
					},
					{
						"n": 9,
						"h": 395,
						"w": 286
					},
					{
						"n": 10,
						"h": 158,
						"w": 455
					},
					{
						"n": 11,
						"h": 206,
						"w": 411
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 53
					},
					{
						"n": 2,
						"h": 60,
						"w": 266
					},
					{
						"n": 3,
						"h": 170,
						"w": 201
					},
					{
						"n": 4,
						"h": 283,
						"w": 198
					},
					{
						"n": 5,
						"h": 380,
						"w": 217
					},
					{
						"n": 6,
						"h": 252,
						"w": 297
					},
					{
						"n": 7,
						"h": 221,
						"w": 446
					},
					{
						"n": 8,
						"h": 422,
						"w": 433
					},
					{
						"n": 9,
						"h": 33,
						"w": 520
					},
					{
						"n": 10,
						"h": 157,
						"w": 529
					},
					{
						"n": 11,
						"h": 335,
						"w": 498
					}
				],
				"ball": {
					"n": 0,
					"h": 198,
					"w": 423,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 437,
			"minute": 21,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 17
					},
					{
						"n": 2,
						"h": 97,
						"w": 172
					},
					{
						"n": 3,
						"h": 209,
						"w": 119
					},
					{
						"n": 4,
						"h": 278,
						"w": 111
					},
					{
						"n": 5,
						"h": 361,
						"w": 149
					},
					{
						"n": 6,
						"h": 56,
						"w": 267
					},
					{
						"n": 7,
						"h": 196,
						"w": 200
					},
					{
						"n": 8,
						"h": 246,
						"w": 212
					},
					{
						"n": 9,
						"h": 406,
						"w": 248
					},
					{
						"n": 10,
						"h": 167,
						"w": 416
					},
					{
						"n": 11,
						"h": 172,
						"w": 389
					}
				],
				"away": [
					{
						"n": 1,
						"h": 228,
						"w": 78
					},
					{
						"n": 2,
						"h": 69,
						"w": 305
					},
					{
						"n": 3,
						"h": 172,
						"w": 241
					},
					{
						"n": 4,
						"h": 280,
						"w": 238
					},
					{
						"n": 5,
						"h": 384,
						"w": 257
					},
					{
						"n": 6,
						"h": 283,
						"w": 314
					},
					{
						"n": 7,
						"h": 227,
						"w": 485
					},
					{
						"n": 8,
						"h": 424,
						"w": 472
					},
					{
						"n": 9,
						"h": 19,
						"w": 557
					},
					{
						"n": 10,
						"h": 154,
						"w": 569
					},
					{
						"n": 11,
						"h": 362,
						"w": 528
					}
				],
				"ball": {
					"n": 0,
					"h": 167,
					"w": 406,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 438,
			"minute": 21,
			"messages": [
				{
					"owner": 2,
					"mes": "Оливье Дюмон[26](Опава) пасует Т.Прохазке[25](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 14
					},
					{
						"n": 2,
						"h": 84,
						"w": 178
					},
					{
						"n": 3,
						"h": 197,
						"w": 151
					},
					{
						"n": 4,
						"h": 258,
						"w": 140
					},
					{
						"n": 5,
						"h": 326,
						"w": 151
					},
					{
						"n": 6,
						"h": 56,
						"w": 232
					},
					{
						"n": 7,
						"h": 197,
						"w": 235
					},
					{
						"n": 8,
						"h": 252,
						"w": 240
					},
					{
						"n": 9,
						"h": 400,
						"w": 213
					},
					{
						"n": 10,
						"h": 132,
						"w": 418
					},
					{
						"n": 11,
						"h": 203,
						"w": 406
					}
				],
				"away": [
					{
						"n": 1,
						"h": 223,
						"w": 93
					},
					{
						"n": 2,
						"h": 75,
						"w": 311
					},
					{
						"n": 3,
						"h": 183,
						"w": 268
					},
					{
						"n": 4,
						"h": 277,
						"w": 273
					},
					{
						"n": 5,
						"h": 358,
						"w": 280
					},
					{
						"n": 6,
						"h": 277,
						"w": 322
					},
					{
						"n": 7,
						"h": 259,
						"w": 472
					},
					{
						"n": 8,
						"h": 417,
						"w": 487
					},
					{
						"n": 9,
						"h": 38,
						"w": 528
					},
					{
						"n": 10,
						"h": 154,
						"w": 543
					},
					{
						"n": 11,
						"h": 396,
						"w": 522
					}
				],
				"ball": {
					"n": 0,
					"h": 92,
					"w": 440,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 35
		},
		{
			"num": 439,
			"minute": 21,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 19
					},
					{
						"n": 2,
						"h": 56,
						"w": 176
					},
					{
						"n": 3,
						"h": 216,
						"w": 117
					},
					{
						"n": 4,
						"h": 277,
						"w": 108
					},
					{
						"n": 5,
						"h": 330,
						"w": 112
					},
					{
						"n": 6,
						"h": 56,
						"w": 193
					},
					{
						"n": 7,
						"h": 175,
						"w": 203
					},
					{
						"n": 8,
						"h": 233,
						"w": 206
					},
					{
						"n": 9,
						"h": 397,
						"w": 174
					},
					{
						"n": 10,
						"h": 103,
						"w": 392
					},
					{
						"n": 11,
						"h": 240,
						"w": 420
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 110
					},
					{
						"n": 2,
						"h": 60,
						"w": 326
					},
					{
						"n": 3,
						"h": 178,
						"w": 273
					},
					{
						"n": 4,
						"h": 283,
						"w": 262
					},
					{
						"n": 5,
						"h": 354,
						"w": 314
					},
					{
						"n": 6,
						"h": 250,
						"w": 351
					},
					{
						"n": 7,
						"h": 230,
						"w": 498
					},
					{
						"n": 8,
						"h": 404,
						"w": 506
					},
					{
						"n": 9,
						"h": 24,
						"w": 564
					},
					{
						"n": 10,
						"h": 148,
						"w": 576
					},
					{
						"n": 11,
						"h": 433,
						"w": 535
					}
				],
				"ball": {
					"n": 0,
					"h": 96,
					"w": 406,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 440,
			"minute": 21,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 16
					},
					{
						"n": 2,
						"h": 56,
						"w": 167
					},
					{
						"n": 3,
						"h": 211,
						"w": 97
					},
					{
						"n": 4,
						"h": 285,
						"w": 115
					},
					{
						"n": 5,
						"h": 330,
						"w": 106
					},
					{
						"n": 6,
						"h": 55,
						"w": 207
					},
					{
						"n": 7,
						"h": 171,
						"w": 186
					},
					{
						"n": 8,
						"h": 208,
						"w": 200
					},
					{
						"n": 9,
						"h": 394,
						"w": 149
					},
					{
						"n": 10,
						"h": 69,
						"w": 370
					},
					{
						"n": 11,
						"h": 273,
						"w": 432
					}
				],
				"away": [
					{
						"n": 1,
						"h": 221,
						"w": 122
					},
					{
						"n": 2,
						"h": 76,
						"w": 309
					},
					{
						"n": 3,
						"h": 177,
						"w": 278
					},
					{
						"n": 4,
						"h": 285,
						"w": 264
					},
					{
						"n": 5,
						"h": 385,
						"w": 332
					},
					{
						"n": 6,
						"h": 255,
						"w": 378
					},
					{
						"n": 7,
						"h": 238,
						"w": 516
					},
					{
						"n": 8,
						"h": 407,
						"w": 546
					},
					{
						"n": 9,
						"h": 22,
						"w": 556
					},
					{
						"n": 10,
						"h": 135,
						"w": 576
					},
					{
						"n": 11,
						"h": 425,
						"w": 525
					}
				],
				"ball": {
					"n": 0,
					"h": 65,
					"w": 388,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 441,
			"minute": 21,
			"messages": [
				{
					"owner": 2,
					"mes": "Томаш Прохазка[25](Опава) делает передачу налево на С.Пейшу[24](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 12
					},
					{
						"n": 2,
						"h": 84,
						"w": 168
					},
					{
						"n": 3,
						"h": 201,
						"w": 123
					},
					{
						"n": 4,
						"h": 262,
						"w": 132
					},
					{
						"n": 5,
						"h": 313,
						"w": 129
					},
					{
						"n": 6,
						"h": 61,
						"w": 180
					},
					{
						"n": 7,
						"h": 176,
						"w": 214
					},
					{
						"n": 8,
						"h": 232,
						"w": 214
					},
					{
						"n": 9,
						"h": 394,
						"w": 173
					},
					{
						"n": 10,
						"h": 93,
						"w": 385
					},
					{
						"n": 11,
						"h": 273,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 102
					},
					{
						"n": 2,
						"h": 76,
						"w": 281
					},
					{
						"n": 3,
						"h": 177,
						"w": 250
					},
					{
						"n": 4,
						"h": 301,
						"w": 287
					},
					{
						"n": 5,
						"h": 385,
						"w": 322
					},
					{
						"n": 6,
						"h": 231,
						"w": 392
					},
					{
						"n": 7,
						"h": 229,
						"w": 489
					},
					{
						"n": 8,
						"h": 402,
						"w": 520
					},
					{
						"n": 9,
						"h": 37,
						"w": 532
					},
					{
						"n": 10,
						"h": 143,
						"w": 549
					},
					{
						"n": 11,
						"h": 420,
						"w": 498
					}
				],
				"ball": {
					"n": 0,
					"h": 118,
					"w": 407,
					"z": 0,
					"r": 0,
					"p": 2,
					"x": 0
				}
			},
			"interval": 28
		},
		{
			"num": 442,
			"minute": 21,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 13
					},
					{
						"n": 2,
						"h": 70,
						"w": 176
					},
					{
						"n": 3,
						"h": 192,
						"w": 136
					},
					{
						"n": 4,
						"h": 249,
						"w": 140
					},
					{
						"n": 5,
						"h": 301,
						"w": 139
					},
					{
						"n": 6,
						"h": 59,
						"w": 195
					},
					{
						"n": 7,
						"h": 175,
						"w": 229
					},
					{
						"n": 8,
						"h": 241,
						"w": 227
					},
					{
						"n": 9,
						"h": 394,
						"w": 185
					},
					{
						"n": 10,
						"h": 107,
						"w": 393
					},
					{
						"n": 11,
						"h": 275,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 111
					},
					{
						"n": 2,
						"h": 64,
						"w": 270
					},
					{
						"n": 3,
						"h": 175,
						"w": 234
					},
					{
						"n": 4,
						"h": 311,
						"w": 300
					},
					{
						"n": 5,
						"h": 385,
						"w": 311
					},
					{
						"n": 6,
						"h": 233,
						"w": 376
					},
					{
						"n": 7,
						"h": 232,
						"w": 474
					},
					{
						"n": 8,
						"h": 418,
						"w": 520
					},
					{
						"n": 9,
						"h": 34,
						"w": 520
					},
					{
						"n": 10,
						"h": 150,
						"w": 543
					},
					{
						"n": 11,
						"h": 411,
						"w": 484
					}
				],
				"ball": {
					"n": 0,
					"h": 134,
					"w": 413,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 16
		},
		{
			"num": 443,
			"minute": 21,
			"messages": [
				{
					"owner": 2,
					"mes": "Себастьян Пейша[24](Опава) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 10
					},
					{
						"n": 2,
						"h": 67,
						"w": 180
					},
					{
						"n": 3,
						"h": 190,
						"w": 146
					},
					{
						"n": 4,
						"h": 241,
						"w": 147
					},
					{
						"n": 5,
						"h": 292,
						"w": 143
					},
					{
						"n": 6,
						"h": 58,
						"w": 205
					},
					{
						"n": 7,
						"h": 183,
						"w": 236
					},
					{
						"n": 8,
						"h": 232,
						"w": 231
					},
					{
						"n": 9,
						"h": 394,
						"w": 185
					},
					{
						"n": 10,
						"h": 115,
						"w": 398
					},
					{
						"n": 11,
						"h": 278,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 107
					},
					{
						"n": 2,
						"h": 70,
						"w": 262
					},
					{
						"n": 3,
						"h": 172,
						"w": 225
					},
					{
						"n": 4,
						"h": 316,
						"w": 307
					},
					{
						"n": 5,
						"h": 384,
						"w": 301
					},
					{
						"n": 6,
						"h": 234,
						"w": 367
					},
					{
						"n": 7,
						"h": 223,
						"w": 476
					},
					{
						"n": 8,
						"h": 413,
						"w": 520
					},
					{
						"n": 9,
						"h": 42,
						"w": 520
					},
					{
						"n": 10,
						"h": 160,
						"w": 545
					},
					{
						"n": 11,
						"h": 412,
						"w": 474
					}
				],
				"ball": {
					"n": 0,
					"h": 134,
					"w": 413,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 10
		},
		{
			"num": 444,
			"minute": 21,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 17
					},
					{
						"n": 2,
						"h": 56,
						"w": 154
					},
					{
						"n": 3,
						"h": 204,
						"w": 137
					},
					{
						"n": 4,
						"h": 243,
						"w": 137
					},
					{
						"n": 5,
						"h": 297,
						"w": 143
					},
					{
						"n": 6,
						"h": 56,
						"w": 239
					},
					{
						"n": 7,
						"h": 184,
						"w": 214
					},
					{
						"n": 8,
						"h": 237,
						"w": 212
					},
					{
						"n": 9,
						"h": 388,
						"w": 158
					},
					{
						"n": 10,
						"h": 148,
						"w": 375
					},
					{
						"n": 11,
						"h": 305,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 229,
						"w": 110
					},
					{
						"n": 2,
						"h": 60,
						"w": 276
					},
					{
						"n": 3,
						"h": 176,
						"w": 226
					},
					{
						"n": 4,
						"h": 292,
						"w": 332
					},
					{
						"n": 5,
						"h": 378,
						"w": 261
					},
					{
						"n": 6,
						"h": 229,
						"w": 406
					},
					{
						"n": 7,
						"h": 207,
						"w": 512
					},
					{
						"n": 8,
						"h": 406,
						"w": 553
					},
					{
						"n": 9,
						"h": 47,
						"w": 554
					},
					{
						"n": 10,
						"h": 140,
						"w": 547
					},
					{
						"n": 11,
						"h": 404,
						"w": 446
					}
				],
				"ball": {
					"n": 0,
					"h": 158,
					"w": 388,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 445,
			"minute": 21,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 10
					},
					{
						"n": 2,
						"h": 56,
						"w": 136
					},
					{
						"n": 3,
						"h": 231,
						"w": 124
					},
					{
						"n": 4,
						"h": 272,
						"w": 108
					},
					{
						"n": 5,
						"h": 330,
						"w": 123
					},
					{
						"n": 6,
						"h": 56,
						"w": 199
					},
					{
						"n": 7,
						"h": 187,
						"w": 202
					},
					{
						"n": 8,
						"h": 226,
						"w": 191
					},
					{
						"n": 9,
						"h": 389,
						"w": 132
					},
					{
						"n": 10,
						"h": 178,
						"w": 348
					},
					{
						"n": 11,
						"h": 309,
						"w": 442
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 123
					},
					{
						"n": 2,
						"h": 75,
						"w": 303
					},
					{
						"n": 3,
						"h": 168,
						"w": 251
					},
					{
						"n": 4,
						"h": 267,
						"w": 357
					},
					{
						"n": 5,
						"h": 385,
						"w": 252
					},
					{
						"n": 6,
						"h": 223,
						"w": 446
					},
					{
						"n": 7,
						"h": 221,
						"w": 550
					},
					{
						"n": 8,
						"h": 404,
						"w": 571
					},
					{
						"n": 9,
						"h": 46,
						"w": 562
					},
					{
						"n": 10,
						"h": 160,
						"w": 562
					},
					{
						"n": 11,
						"h": 405,
						"w": 486
					}
				],
				"ball": {
					"n": 0,
					"h": 183,
					"w": 363,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 446,
			"minute": 21,
			"messages": [
				{
					"owner": 2,
					"mes": "Себастьян Пейша[24](Опава) переправляет мяч на ход О.Дюмону[26](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 18
					},
					{
						"n": 2,
						"h": 81,
						"w": 141
					},
					{
						"n": 3,
						"h": 234,
						"w": 131
					},
					{
						"n": 4,
						"h": 265,
						"w": 129
					},
					{
						"n": 5,
						"h": 330,
						"w": 115
					},
					{
						"n": 6,
						"h": 56,
						"w": 239
					},
					{
						"n": 7,
						"h": 197,
						"w": 223
					},
					{
						"n": 8,
						"h": 248,
						"w": 205
					},
					{
						"n": 9,
						"h": 379,
						"w": 136
					},
					{
						"n": 10,
						"h": 174,
						"w": 335
					},
					{
						"n": 11,
						"h": 272,
						"w": 446
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 127
					},
					{
						"n": 2,
						"h": 75,
						"w": 306
					},
					{
						"n": 3,
						"h": 178,
						"w": 257
					},
					{
						"n": 4,
						"h": 267,
						"w": 357,
						"m": 680
					},
					{
						"n": 5,
						"h": 379,
						"w": 248
					},
					{
						"n": 6,
						"h": 253,
						"w": 476
					},
					{
						"n": 7,
						"h": 201,
						"w": 515
					},
					{
						"n": 8,
						"h": 399,
						"w": 559
					},
					{
						"n": 9,
						"h": 56,
						"w": 559
					},
					{
						"n": 10,
						"h": 176,
						"w": 573
					},
					{
						"n": 11,
						"h": 419,
						"w": 451
					}
				],
				"ball": {
					"n": 0,
					"h": 197,
					"w": 244,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 447,
			"minute": 21,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 13
					},
					{
						"n": 2,
						"h": 58,
						"w": 126
					},
					{
						"n": 3,
						"h": 234,
						"w": 112
					},
					{
						"n": 4,
						"h": 279,
						"w": 104
					},
					{
						"n": 5,
						"h": 370,
						"w": 119
					},
					{
						"n": 6,
						"h": 56,
						"w": 199
					},
					{
						"n": 7,
						"h": 226,
						"w": 216
					},
					{
						"n": 8,
						"h": 246,
						"w": 165
					},
					{
						"n": 9,
						"h": 394,
						"w": 173
					},
					{
						"n": 10,
						"h": 170,
						"w": 334
					},
					{
						"n": 11,
						"h": 276,
						"w": 435
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 125
					},
					{
						"n": 2,
						"h": 66,
						"w": 317
					},
					{
						"n": 3,
						"h": 174,
						"w": 297
					},
					{
						"n": 4,
						"h": 271,
						"w": 397
					},
					{
						"n": 5,
						"h": 389,
						"w": 261
					},
					{
						"n": 6,
						"h": 219,
						"w": 485
					},
					{
						"n": 7,
						"h": 212,
						"w": 553
					},
					{
						"n": 8,
						"h": 400,
						"w": 584
					},
					{
						"n": 9,
						"h": 50,
						"w": 593
					},
					{
						"n": 10,
						"h": 156,
						"w": 592
					},
					{
						"n": 11,
						"h": 409,
						"w": 490
					}
				],
				"ball": {
					"n": 0,
					"h": 231,
					"w": 235,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 448,
			"minute": 21,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 16
					},
					{
						"n": 2,
						"h": 56,
						"w": 107
					},
					{
						"n": 3,
						"h": 216,
						"w": 104
					},
					{
						"n": 4,
						"h": 304,
						"w": 96
					},
					{
						"n": 5,
						"h": 352,
						"w": 117
					},
					{
						"n": 6,
						"h": 56,
						"w": 165
					},
					{
						"n": 7,
						"h": 194,
						"w": 205
					},
					{
						"n": 8,
						"h": 211,
						"w": 159
					},
					{
						"n": 9,
						"h": 414,
						"w": 200
					},
					{
						"n": 10,
						"h": 167,
						"w": 344
					},
					{
						"n": 11,
						"h": 313,
						"w": 419
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 121
					},
					{
						"n": 2,
						"h": 56,
						"w": 332
					},
					{
						"n": 3,
						"h": 170,
						"w": 337
					},
					{
						"n": 4,
						"h": 274,
						"w": 437
					},
					{
						"n": 5,
						"h": 391,
						"w": 287
					},
					{
						"n": 6,
						"h": 253,
						"w": 494
					},
					{
						"n": 7,
						"h": 232,
						"w": 574
					},
					{
						"n": 8,
						"h": 405,
						"w": 603
					},
					{
						"n": 9,
						"h": 90,
						"w": 598
					},
					{
						"n": 10,
						"h": 136,
						"w": 596
					},
					{
						"n": 11,
						"h": 404,
						"w": 520
					}
				],
				"ball": {
					"n": 0,
					"h": 197,
					"w": 226,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 449,
			"minute": 21,
			"messages": [
				{
					"owner": 2,
					"mes": "Оливье Дюмон[26](Опава) пасует на ближайшего партнера по команде..."
				},
				{
					"owner": 2,
					"mes": "Себастьян Пейша[24](Опава) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 15
					},
					{
						"n": 2,
						"h": 56,
						"w": 126
					},
					{
						"n": 3,
						"h": 221,
						"w": 112
					},
					{
						"n": 4,
						"h": 286,
						"w": 118
					},
					{
						"n": 5,
						"h": 330,
						"w": 130
					},
					{
						"n": 6,
						"h": 56,
						"w": 193
					},
					{
						"n": 7,
						"h": 172,
						"w": 223
					},
					{
						"n": 8,
						"h": 222,
						"w": 185
					},
					{
						"n": 9,
						"h": 402,
						"w": 221
					},
					{
						"n": 10,
						"h": 165,
						"w": 334
					},
					{
						"n": 11,
						"h": 289,
						"w": 405
					}
				],
				"away": [
					{
						"n": 1,
						"h": 228,
						"w": 123
					},
					{
						"n": 2,
						"h": 59,
						"w": 341
					},
					{
						"n": 3,
						"h": 169,
						"w": 309
					},
					{
						"n": 4,
						"h": 298,
						"w": 461
					},
					{
						"n": 5,
						"h": 389,
						"w": 324
					},
					{
						"n": 6,
						"h": 253,
						"w": 494,
						"m": 630
					},
					{
						"n": 7,
						"h": 224,
						"w": 547
					},
					{
						"n": 8,
						"h": 414,
						"w": 576
					},
					{
						"n": 9,
						"h": 69,
						"w": 579
					},
					{
						"n": 10,
						"h": 153,
						"w": 573
					},
					{
						"n": 11,
						"h": 399,
						"w": 492
					}
				],
				"ball": {
					"n": 0,
					"h": 152,
					"w": 259,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 28
		},
		{
			"num": 450,
			"minute": 21,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 13
					},
					{
						"n": 2,
						"h": 56,
						"w": 123
					},
					{
						"n": 3,
						"h": 239,
						"w": 117
					},
					{
						"n": 4,
						"h": 302,
						"w": 112
					},
					{
						"n": 5,
						"h": 346,
						"w": 101
					},
					{
						"n": 6,
						"h": 56,
						"w": 166
					},
					{
						"n": 7,
						"h": 143,
						"w": 206
					},
					{
						"n": 8,
						"h": 214,
						"w": 184
					},
					{
						"n": 9,
						"h": 419,
						"w": 211
					},
					{
						"n": 10,
						"h": 161,
						"w": 335
					},
					{
						"n": 11,
						"h": 276,
						"w": 436
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 120
					},
					{
						"n": 2,
						"h": 70,
						"w": 324
					},
					{
						"n": 3,
						"h": 174,
						"w": 269
					},
					{
						"n": 4,
						"h": 302,
						"w": 496
					},
					{
						"n": 5,
						"h": 388,
						"w": 285
					},
					{
						"n": 6,
						"h": 242,
						"w": 532
					},
					{
						"n": 7,
						"h": 208,
						"w": 583
					},
					{
						"n": 8,
						"h": 410,
						"w": 589
					},
					{
						"n": 9,
						"h": 47,
						"w": 592
					},
					{
						"n": 10,
						"h": 133,
						"w": 588
					},
					{
						"n": 11,
						"h": 397,
						"w": 519
					}
				],
				"ball": {
					"n": 0,
					"h": 148,
					"w": 224,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 451,
			"minute": 21,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 14
					},
					{
						"n": 2,
						"h": 56,
						"w": 107
					},
					{
						"n": 3,
						"h": 202,
						"w": 102
					},
					{
						"n": 4,
						"h": 262,
						"w": 111
					},
					{
						"n": 5,
						"h": 386,
						"w": 109
					},
					{
						"n": 6,
						"h": 56,
						"w": 179
					},
					{
						"n": 7,
						"h": 183,
						"w": 199
					},
					{
						"n": 8,
						"h": 254,
						"w": 188
					},
					{
						"n": 9,
						"h": 421,
						"w": 200
					},
					{
						"n": 10,
						"h": 167,
						"w": 344
					},
					{
						"n": 11,
						"h": 314,
						"w": 425
					}
				],
				"away": [
					{
						"n": 1,
						"h": 223,
						"w": 126
					},
					{
						"n": 2,
						"h": 72,
						"w": 327
					},
					{
						"n": 3,
						"h": 168,
						"w": 272
					},
					{
						"n": 4,
						"h": 268,
						"w": 505
					},
					{
						"n": 5,
						"h": 392,
						"w": 299
					},
					{
						"n": 6,
						"h": 231,
						"w": 571
					},
					{
						"n": 7,
						"h": 228,
						"w": 595
					},
					{
						"n": 8,
						"h": 403,
						"w": 603
					},
					{
						"n": 9,
						"h": 49,
						"w": 597
					},
					{
						"n": 10,
						"h": 153,
						"w": 567
					},
					{
						"n": 11,
						"h": 397,
						"w": 506
					}
				],
				"ball": {
					"n": 0,
					"h": 182,
					"w": 215,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 452,
			"minute": 21,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 10
					},
					{
						"n": 2,
						"h": 56,
						"w": 144
					},
					{
						"n": 3,
						"h": 200,
						"w": 118
					},
					{
						"n": 4,
						"h": 224,
						"w": 120
					},
					{
						"n": 5,
						"h": 346,
						"w": 116
					},
					{
						"n": 6,
						"h": 56,
						"w": 219
					},
					{
						"n": 7,
						"h": 222,
						"w": 196
					},
					{
						"n": 8,
						"h": 216,
						"w": 180
					},
					{
						"n": 9,
						"h": 398,
						"w": 167
					},
					{
						"n": 10,
						"h": 175,
						"w": 331
					},
					{
						"n": 11,
						"h": 307,
						"w": 408
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 122
					},
					{
						"n": 2,
						"h": 58,
						"w": 346
					},
					{
						"n": 3,
						"h": 177,
						"w": 286
					},
					{
						"n": 4,
						"h": 228,
						"w": 507
					},
					{
						"n": 5,
						"h": 382,
						"w": 284
					},
					{
						"n": 6,
						"h": 226,
						"w": 531
					},
					{
						"n": 7,
						"h": 226,
						"w": 578
					},
					{
						"n": 8,
						"h": 411,
						"w": 564
					},
					{
						"n": 9,
						"h": 58,
						"w": 559
					},
					{
						"n": 10,
						"h": 132,
						"w": 559
					},
					{
						"n": 11,
						"h": 402,
						"w": 466
					}
				],
				"ball": {
					"n": 0,
					"h": 222,
					"w": 213,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 453,
			"minute": 21,
			"messages": [
				{
					"owner": 2,
					"mes": "Пас П.Крамаржу[30](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 231,
						"w": 14
					},
					{
						"n": 2,
						"h": 82,
						"w": 133
					},
					{
						"n": 3,
						"h": 227,
						"w": 124
					},
					{
						"n": 4,
						"h": 250,
						"w": 130
					},
					{
						"n": 5,
						"h": 374,
						"w": 123
					},
					{
						"n": 6,
						"h": 56,
						"w": 244
					},
					{
						"n": 7,
						"h": 228,
						"w": 202
					},
					{
						"n": 8,
						"h": 216,
						"w": 208
					},
					{
						"n": 9,
						"h": 395,
						"w": 195
					},
					{
						"n": 10,
						"h": 161,
						"w": 336
					},
					{
						"n": 11,
						"h": 289,
						"w": 430
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 118
					},
					{
						"n": 2,
						"h": 57,
						"w": 318
					},
					{
						"n": 3,
						"h": 174,
						"w": 258
					},
					{
						"n": 4,
						"h": 231,
						"w": 497
					},
					{
						"n": 5,
						"h": 378,
						"w": 256
					},
					{
						"n": 6,
						"h": 225,
						"w": 503
					},
					{
						"n": 7,
						"h": 212,
						"w": 578
					},
					{
						"n": 8,
						"h": 395,
						"w": 559
					},
					{
						"n": 9,
						"h": 48,
						"w": 579
					},
					{
						"n": 10,
						"h": 160,
						"w": 556
					},
					{
						"n": 11,
						"h": 405,
						"w": 441
					}
				],
				"ball": {
					"n": 0,
					"h": 290,
					"w": 164,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 28
		},
		{
			"num": 454,
			"minute": 21,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 237,
						"w": 9
					},
					{
						"n": 2,
						"h": 99,
						"w": 97
					},
					{
						"n": 3,
						"h": 228,
						"w": 84
					},
					{
						"n": 4,
						"h": 292,
						"w": 144
					},
					{
						"n": 5,
						"h": 385,
						"w": 101
					},
					{
						"n": 6,
						"h": 56,
						"w": 204
					},
					{
						"n": 7,
						"h": 217,
						"w": 163
					},
					{
						"n": 8,
						"h": 245,
						"w": 180
					},
					{
						"n": 9,
						"h": 406,
						"w": 178
					},
					{
						"n": 10,
						"h": 165,
						"w": 342
					},
					{
						"n": 11,
						"h": 318,
						"w": 402
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 119
					},
					{
						"n": 2,
						"h": 62,
						"w": 353
					},
					{
						"n": 3,
						"h": 174,
						"w": 291
					},
					{
						"n": 4,
						"h": 248,
						"w": 461
					},
					{
						"n": 5,
						"h": 383,
						"w": 296
					},
					{
						"n": 6,
						"h": 224,
						"w": 463
					},
					{
						"n": 7,
						"h": 218,
						"w": 618
					},
					{
						"n": 8,
						"h": 398,
						"w": 599
					},
					{
						"n": 9,
						"h": 48,
						"w": 627
					},
					{
						"n": 10,
						"h": 120,
						"w": 556
					},
					{
						"n": 11,
						"h": 402,
						"w": 481
					}
				],
				"ball": {
					"n": 0,
					"h": 330,
					"w": 164,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 455,
			"minute": 21,
			"messages": [
				{
					"owner": 2,
					"mes": "Петр Крамарж[30](Опава) наносит сильнейший удар издали..."
				},
				{
					"owner": 2,
					"mes": "Выше ворот."
				}
			],
			"U": {
				"team": 2,
				"player": 10,
				"xg": "0.02"
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 245,
						"w": 9
					},
					{
						"n": 2,
						"h": 116,
						"w": 56
					},
					{
						"n": 3,
						"h": 214,
						"w": 56
					},
					{
						"n": 4,
						"h": 328,
						"w": 154
					},
					{
						"n": 5,
						"h": 365,
						"w": 61
					},
					{
						"n": 6,
						"h": 56,
						"w": 160
					},
					{
						"n": 7,
						"h": 204,
						"w": 122
					},
					{
						"n": 8,
						"h": 277,
						"w": 149
					},
					{
						"n": 9,
						"h": 391,
						"w": 157
					},
					{
						"n": 10,
						"h": 165,
						"w": 349
					},
					{
						"n": 11,
						"h": 323,
						"w": 400
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 120
					},
					{
						"n": 2,
						"h": 75,
						"w": 354
					},
					{
						"n": 3,
						"h": 183,
						"w": 292
					},
					{
						"n": 4,
						"h": 267,
						"w": 420
					},
					{
						"n": 5,
						"h": 392,
						"w": 325
					},
					{
						"n": 6,
						"h": 217,
						"w": 419
					},
					{
						"n": 7,
						"h": 235,
						"w": 624
					},
					{
						"n": 8,
						"h": 397,
						"w": 628
					},
					{
						"n": 9,
						"h": 38,
						"w": 624
					},
					{
						"n": 10,
						"h": 120,
						"w": 556
					},
					{
						"n": 11,
						"h": 410,
						"w": 525
					}
				],
				"ball": {
					"n": 0,
					"h": 223,
					"w": -32,
					"z": 1,
					"r": 0,
					"p": 0,
					"x": 4
				}
			},
			"interval": 45
		},
		{
			"num": 456,
			"minute": 22,
			"possession": 40,
			"messages": [
				{
					"owner": 1,
					"mes": "Удар от ворот... Мэттью Глэдхилл[01](Галвэй Юнайтед) устанавливает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 257,
						"w": 14
					},
					{
						"n": 2,
						"h": 76,
						"w": 205,
						"m": 620
					},
					{
						"n": 3,
						"h": 165,
						"w": 205
					},
					{
						"n": 4,
						"h": 275,
						"w": 205,
						"f": 94
					},
					{
						"n": 5,
						"h": 379,
						"w": 205,
						"m": 600
					},
					{
						"n": 6,
						"h": 68,
						"w": 332
					},
					{
						"n": 7,
						"h": 167,
						"w": 352
					},
					{
						"n": 8,
						"h": 276,
						"w": 352
					},
					{
						"n": 9,
						"h": 375,
						"w": 332,
						"f": 92
					},
					{
						"n": 10,
						"h": 169,
						"w": 500
					},
					{
						"n": 11,
						"h": 279,
						"w": 500
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 40
					},
					{
						"n": 2,
						"h": 75,
						"w": 157
					},
					{
						"n": 3,
						"h": 169,
						"w": 130
					},
					{
						"n": 4,
						"h": 281,
						"w": 130,
						"f": 92
					},
					{
						"n": 5,
						"h": 377,
						"w": 152,
						"f": 92
					},
					{
						"n": 6,
						"h": 216,
						"w": 200
					},
					{
						"n": 7,
						"h": 232,
						"w": 348,
						"f": 94
					},
					{
						"n": 8,
						"h": 387,
						"w": 368
					},
					{
						"n": 9,
						"h": 68,
						"w": 424
					},
					{
						"n": 10,
						"h": 171,
						"w": 448
					},
					{
						"n": 11,
						"h": 284,
						"w": 448
					}
				],
				"ball": {
					"n": 0,
					"h": 260,
					"w": 34,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 150
		},
		{
			"num": 457,
			"minute": 22,
			"messages": [],
			"T": {
				"team": 1
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 260,
						"w": 34
					},
					{
						"n": 2,
						"h": 78,
						"w": 210
					},
					{
						"n": 3,
						"h": 163,
						"w": 201
					},
					{
						"n": 4,
						"h": 281,
						"w": 205
					},
					{
						"n": 5,
						"h": 383,
						"w": 200
					},
					{
						"n": 6,
						"h": 67,
						"w": 328
					},
					{
						"n": 7,
						"h": 170,
						"w": 347
					},
					{
						"n": 8,
						"h": 270,
						"w": 351
					},
					{
						"n": 9,
						"h": 381,
						"w": 328
					},
					{
						"n": 10,
						"h": 163,
						"w": 505
					},
					{
						"n": 11,
						"h": 286,
						"w": 499
					}
				],
				"away": [
					{
						"n": 1,
						"h": 228,
						"w": 37
					},
					{
						"n": 2,
						"h": 70,
						"w": 154
					},
					{
						"n": 3,
						"h": 168,
						"w": 123
					},
					{
						"n": 4,
						"h": 283,
						"w": 125
					},
					{
						"n": 5,
						"h": 383,
						"w": 154
					},
					{
						"n": 6,
						"h": 219,
						"w": 200
					},
					{
						"n": 7,
						"h": 229,
						"w": 351
					},
					{
						"n": 8,
						"h": 384,
						"w": 362
					},
					{
						"n": 9,
						"h": 75,
						"w": 419
					},
					{
						"n": 10,
						"h": 175,
						"w": 447
					},
					{
						"n": 11,
						"h": 279,
						"w": 440
					}
				],
				"ball": {
					"n": 0,
					"h": 260,
					"w": 34,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 15
		},
		{
			"num": 458,
			"minute": 22,
			"messages": [
				{
					"owner": 1,
					"mes": "Мэттью Глэдхилл[01](Галвэй Юнайтед) выбивает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 13
					},
					{
						"n": 2,
						"h": 78,
						"w": 261
					},
					{
						"n": 3,
						"h": 174,
						"w": 209
					},
					{
						"n": 4,
						"h": 275,
						"w": 201
					},
					{
						"n": 5,
						"h": 379,
						"w": 250
					},
					{
						"n": 6,
						"h": 38,
						"w": 365
					},
					{
						"n": 7,
						"h": 172,
						"w": 440
					},
					{
						"n": 8,
						"h": 292,
						"w": 441
					},
					{
						"n": 9,
						"h": 394,
						"w": 420
					},
					{
						"n": 10,
						"h": 205,
						"w": 496
					},
					{
						"n": 11,
						"h": 286,
						"w": 526
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 73
					},
					{
						"n": 2,
						"h": 110,
						"w": 115
					},
					{
						"n": 3,
						"h": 176,
						"w": 104
					},
					{
						"n": 4,
						"h": 248,
						"w": 104
					},
					{
						"n": 5,
						"h": 340,
						"w": 112
					},
					{
						"n": 6,
						"h": 245,
						"w": 224
					},
					{
						"n": 7,
						"h": 232,
						"w": 258
					},
					{
						"n": 8,
						"h": 406,
						"w": 319
					},
					{
						"n": 9,
						"h": 50,
						"w": 329
					},
					{
						"n": 10,
						"h": 167,
						"w": 354
					},
					{
						"n": 11,
						"h": 284,
						"w": 347
					}
				],
				"ball": {
					"n": 0,
					"h": 205,
					"w": 496,
					"z": 1,
					"r": 0,
					"p": 4,
					"x": 0
				}
			},
			"interval": 93
		},
		{
			"num": 459,
			"minute": 22,
			"messages": [
				{
					"owner": 1,
					"mes": "Джо Квигли[10](Галвэй Юнайтед) прыгает выше О.Дюмона[26](Опава) и скидывает мяч головой..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 16,
						"m": 610
					},
					{
						"n": 2,
						"h": 70,
						"w": 265
					},
					{
						"n": 3,
						"h": 177,
						"w": 197
					},
					{
						"n": 4,
						"h": 269,
						"w": 215
					},
					{
						"n": 5,
						"h": 374,
						"w": 255
					},
					{
						"n": 6,
						"h": 38,
						"w": 381
					},
					{
						"n": 7,
						"h": 171,
						"w": 424
					},
					{
						"n": 8,
						"h": 287,
						"w": 426
					},
					{
						"n": 9,
						"h": 393,
						"w": 436
					},
					{
						"n": 10,
						"h": 205,
						"w": 496
					},
					{
						"n": 11,
						"h": 277,
						"w": 515
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 78
					},
					{
						"n": 2,
						"h": 110,
						"w": 109
					},
					{
						"n": 3,
						"h": 176,
						"w": 120
					},
					{
						"n": 4,
						"h": 232,
						"w": 108
					},
					{
						"n": 5,
						"h": 340,
						"w": 107
					},
					{
						"n": 6,
						"h": 245,
						"w": 224,
						"m": 620
					},
					{
						"n": 7,
						"h": 231,
						"w": 242
					},
					{
						"n": 8,
						"h": 406,
						"w": 303
					},
					{
						"n": 9,
						"h": 51,
						"w": 313
					},
					{
						"n": 10,
						"h": 166,
						"w": 338
					},
					{
						"n": 11,
						"h": 283,
						"w": 331
					}
				],
				"ball": {
					"n": 0,
					"h": 252,
					"w": 487,
					"z": 1,
					"r": 0,
					"p": 1,
					"x": 0
				}
			},
			"interval": 16
		},
		{
			"num": 460,
			"minute": 22,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 11
					},
					{
						"n": 2,
						"h": 78,
						"w": 253
					},
					{
						"n": 3,
						"h": 169,
						"w": 196
					},
					{
						"n": 4,
						"h": 273,
						"w": 204
					},
					{
						"n": 5,
						"h": 392,
						"w": 261
					},
					{
						"n": 6,
						"h": 38,
						"w": 405
					},
					{
						"n": 7,
						"h": 171,
						"w": 400
					},
					{
						"n": 8,
						"h": 264,
						"w": 423
					},
					{
						"n": 9,
						"h": 396,
						"w": 459
					},
					{
						"n": 10,
						"h": 205,
						"w": 496
					},
					{
						"n": 11,
						"h": 264,
						"w": 485
					}
				],
				"away": [
					{
						"n": 1,
						"h": 228,
						"w": 78
					},
					{
						"n": 2,
						"h": 110,
						"w": 97
					},
					{
						"n": 3,
						"h": 193,
						"w": 104
					},
					{
						"n": 4,
						"h": 242,
						"w": 118
					},
					{
						"n": 5,
						"h": 340,
						"w": 97
					},
					{
						"n": 6,
						"h": 245,
						"w": 224
					},
					{
						"n": 7,
						"h": 207,
						"w": 238
					},
					{
						"n": 8,
						"h": 406,
						"w": 279
					},
					{
						"n": 9,
						"h": 44,
						"w": 290
					},
					{
						"n": 10,
						"h": 173,
						"w": 316
					},
					{
						"n": 11,
						"h": 280,
						"w": 307
					}
				],
				"ball": {
					"n": 0,
					"h": 264,
					"w": 485,
					"z": 0,
					"r": 0,
					"p": 1,
					"x": 0
				}
			},
			"interval": 24
		},
		{
			"num": 461,
			"minute": 22,
			"messages": [
				{
					"owner": 1,
					"mes": "Адам Гилберт[11](Галвэй Юнайтед) технично принимает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 11
					},
					{
						"n": 2,
						"h": 73,
						"w": 293
					},
					{
						"n": 3,
						"h": 170,
						"w": 236
					},
					{
						"n": 4,
						"h": 272,
						"w": 244
					},
					{
						"n": 5,
						"h": 385,
						"w": 300
					},
					{
						"n": 6,
						"h": 41,
						"w": 445
					},
					{
						"n": 7,
						"h": 161,
						"w": 361
					},
					{
						"n": 8,
						"h": 274,
						"w": 462
					},
					{
						"n": 9,
						"h": 400,
						"w": 499
					},
					{
						"n": 10,
						"h": 192,
						"w": 533
					},
					{
						"n": 11,
						"h": 261,
						"w": 534
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 38
					},
					{
						"n": 2,
						"h": 110,
						"w": 114
					},
					{
						"n": 3,
						"h": 205,
						"w": 105
					},
					{
						"n": 4,
						"h": 245,
						"w": 101
					},
					{
						"n": 5,
						"h": 340,
						"w": 115
					},
					{
						"n": 6,
						"h": 252,
						"w": 175
					},
					{
						"n": 7,
						"h": 195,
						"w": 196
					},
					{
						"n": 8,
						"h": 406,
						"w": 239
					},
					{
						"n": 9,
						"h": 28,
						"w": 257
					},
					{
						"n": 10,
						"h": 159,
						"w": 294
					},
					{
						"n": 11,
						"h": 289,
						"w": 339
					}
				],
				"ball": {
					"n": 0,
					"h": 261,
					"w": 534,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 462,
			"minute": 22,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 14
					},
					{
						"n": 2,
						"h": 68,
						"w": 332
					},
					{
						"n": 3,
						"h": 176,
						"w": 276
					},
					{
						"n": 4,
						"h": 278,
						"w": 284
					},
					{
						"n": 5,
						"h": 378,
						"w": 340
					},
					{
						"n": 6,
						"h": 40,
						"w": 485
					},
					{
						"n": 7,
						"h": 166,
						"w": 401
					},
					{
						"n": 8,
						"h": 275,
						"w": 502
					},
					{
						"n": 9,
						"h": 404,
						"w": 539
					},
					{
						"n": 10,
						"h": 181,
						"w": 571
					},
					{
						"n": 11,
						"h": 246,
						"w": 571
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 32
					},
					{
						"n": 2,
						"h": 110,
						"w": 111
					},
					{
						"n": 3,
						"h": 205,
						"w": 129
					},
					{
						"n": 4,
						"h": 214,
						"w": 124
					},
					{
						"n": 5,
						"h": 340,
						"w": 116
					},
					{
						"n": 6,
						"h": 267,
						"w": 147
					},
					{
						"n": 7,
						"h": 198,
						"w": 151
					},
					{
						"n": 8,
						"h": 406,
						"w": 199
					},
					{
						"n": 9,
						"h": 37,
						"w": 257
					},
					{
						"n": 10,
						"h": 175,
						"w": 308
					},
					{
						"n": 11,
						"h": 284,
						"w": 299
					}
				],
				"ball": {
					"n": 0,
					"h": 246,
					"w": 571,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 463,
			"minute": 22,
			"messages": [
				{
					"owner": 1,
					"mes": "Справа просит мяч Элвис Бвомоно[09](Галвэй Юнайтед)... Пас ему..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 13
					},
					{
						"n": 2,
						"h": 59,
						"w": 356
					},
					{
						"n": 3,
						"h": 171,
						"w": 292
					},
					{
						"n": 4,
						"h": 277,
						"w": 292
					},
					{
						"n": 5,
						"h": 382,
						"w": 344
					},
					{
						"n": 6,
						"h": 39,
						"w": 548
					},
					{
						"n": 7,
						"h": 189,
						"w": 459
					},
					{
						"n": 8,
						"h": 294,
						"w": 519
					},
					{
						"n": 9,
						"h": 435,
						"w": 577
					},
					{
						"n": 10,
						"h": 160,
						"w": 603
					},
					{
						"n": 11,
						"h": 252,
						"w": 579
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 35
					},
					{
						"n": 2,
						"h": 48,
						"w": 122
					},
					{
						"n": 3,
						"h": 200,
						"w": 90
					},
					{
						"n": 4,
						"h": 256,
						"w": 98
					},
					{
						"n": 5,
						"h": 340,
						"w": 93
					},
					{
						"n": 6,
						"h": 295,
						"w": 115
					},
					{
						"n": 7,
						"h": 196,
						"w": 198
					},
					{
						"n": 8,
						"h": 406,
						"w": 136
					},
					{
						"n": 9,
						"h": 36,
						"w": 248
					},
					{
						"n": 10,
						"h": 157,
						"w": 300
					},
					{
						"n": 11,
						"h": 288,
						"w": 308
					}
				],
				"ball": {
					"n": 0,
					"h": 435,
					"w": 577,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 63
		},
		{
			"num": 464,
			"minute": 22,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 11
					},
					{
						"n": 2,
						"h": 78,
						"w": 364
					},
					{
						"n": 3,
						"h": 173,
						"w": 328
					},
					{
						"n": 4,
						"h": 283,
						"w": 314
					},
					{
						"n": 5,
						"h": 383,
						"w": 369
					},
					{
						"n": 6,
						"h": 52,
						"w": 581
					},
					{
						"n": 7,
						"h": 198,
						"w": 425
					},
					{
						"n": 8,
						"h": 302,
						"w": 554
					},
					{
						"n": 9,
						"h": 440,
						"w": 617
					},
					{
						"n": 10,
						"h": 192,
						"w": 619
					},
					{
						"n": 11,
						"h": 268,
						"w": 611
					}
				],
				"away": [
					{
						"n": 1,
						"h": 211,
						"w": 6
					},
					{
						"n": 2,
						"h": 48,
						"w": 96
					},
					{
						"n": 3,
						"h": 179,
						"w": 82
					},
					{
						"n": 4,
						"h": 223,
						"w": 84
					},
					{
						"n": 5,
						"h": 340,
						"w": 74
					},
					{
						"n": 6,
						"h": 251,
						"w": 109
					},
					{
						"n": 7,
						"h": 167,
						"w": 176
					},
					{
						"n": 8,
						"h": 395,
						"w": 170
					},
					{
						"n": 9,
						"h": 28,
						"w": 224
					},
					{
						"n": 10,
						"h": 165,
						"w": 294
					},
					{
						"n": 11,
						"h": 261,
						"w": 284
					}
				],
				"ball": {
					"n": 0,
					"h": 440,
					"w": 617,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 36
		},
		{
			"num": 465,
			"minute": 22,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 14
					},
					{
						"n": 2,
						"h": 74,
						"w": 380
					},
					{
						"n": 3,
						"h": 178,
						"w": 320
					},
					{
						"n": 4,
						"h": 272,
						"w": 310
					},
					{
						"n": 5,
						"h": 376,
						"w": 370
					},
					{
						"n": 6,
						"h": 46,
						"w": 621
					},
					{
						"n": 7,
						"h": 212,
						"w": 462
					},
					{
						"n": 8,
						"h": 279,
						"w": 587
					},
					{
						"n": 9,
						"h": 440,
						"w": 662
					},
					{
						"n": 10,
						"h": 223,
						"w": 644
					},
					{
						"n": 11,
						"h": 292,
						"w": 643
					}
				],
				"away": [
					{
						"n": 1,
						"h": 211,
						"w": 4
					},
					{
						"n": 2,
						"h": 23,
						"w": 56
					},
					{
						"n": 3,
						"h": 160,
						"w": 62
					},
					{
						"n": 4,
						"h": 211,
						"w": 55
					},
					{
						"n": 5,
						"h": 340,
						"w": 46
					},
					{
						"n": 6,
						"h": 202,
						"w": 98
					},
					{
						"n": 7,
						"h": 166,
						"w": 136
					},
					{
						"n": 8,
						"h": 401,
						"w": 151
					},
					{
						"n": 9,
						"h": 49,
						"w": 190
					},
					{
						"n": 10,
						"h": 162,
						"w": 296
					},
					{
						"n": 11,
						"h": 243,
						"w": 248
					}
				],
				"ball": {
					"n": 0,
					"h": 440,
					"w": 662,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 466,
			"minute": 22,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 19
					},
					{
						"n": 2,
						"h": 65,
						"w": 368
					},
					{
						"n": 3,
						"h": 175,
						"w": 312
					},
					{
						"n": 4,
						"h": 274,
						"w": 315
					},
					{
						"n": 5,
						"h": 390,
						"w": 373
					},
					{
						"n": 6,
						"h": 49,
						"w": 641
					},
					{
						"n": 7,
						"h": 210,
						"w": 482
					},
					{
						"n": 8,
						"h": 276,
						"w": 606
					},
					{
						"n": 9,
						"h": 440,
						"w": 690
					},
					{
						"n": 10,
						"h": 207,
						"w": 656
					},
					{
						"n": 11,
						"h": 278,
						"w": 657
					}
				],
				"away": [
					{
						"n": 1,
						"h": 210,
						"w": 2
					},
					{
						"n": 2,
						"h": 23,
						"w": 46
					},
					{
						"n": 3,
						"h": 167,
						"w": 41
					},
					{
						"n": 4,
						"h": 224,
						"w": 34
					},
					{
						"n": 5,
						"h": 340,
						"w": 41
					},
					{
						"n": 6,
						"h": 177,
						"w": 100
					},
					{
						"n": 7,
						"h": 184,
						"w": 145
					},
					{
						"n": 8,
						"h": 419,
						"w": 144
					},
					{
						"n": 9,
						"h": 29,
						"w": 190
					},
					{
						"n": 10,
						"h": 165,
						"w": 309
					},
					{
						"n": 11,
						"h": 241,
						"w": 228
					}
				],
				"ball": {
					"n": 0,
					"h": 440,
					"w": 690,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 20
		},
		{
			"num": 467,
			"minute": 22,
			"messages": [
				{
					"owner": 1,
					"mes": "Э.Бвомоно[09](Галвэй Юнайтед) сильно простреливает низом..."
				},
				{
					"owner": 1,
					"mes": "Но Л.Седлачек[22](Опава) не дает выполнить прострел, выбивая мяч за лицевую линию..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 18
					},
					{
						"n": 2,
						"h": 72,
						"w": 372
					},
					{
						"n": 3,
						"h": 173,
						"w": 320
					},
					{
						"n": 4,
						"h": 281,
						"w": 318
					},
					{
						"n": 5,
						"h": 383,
						"w": 378
					},
					{
						"n": 6,
						"h": 43,
						"w": 645
					},
					{
						"n": 7,
						"h": 209,
						"w": 490
					},
					{
						"n": 8,
						"h": 273,
						"w": 614
					},
					{
						"n": 9,
						"h": 440,
						"w": 690
					},
					{
						"n": 10,
						"h": 199,
						"w": 657
					},
					{
						"n": 11,
						"h": 270,
						"w": 659
					}
				],
				"away": [
					{
						"n": 1,
						"h": 210,
						"w": 2
					},
					{
						"n": 2,
						"h": 23,
						"w": 37
					},
					{
						"n": 3,
						"h": 175,
						"w": 37
					},
					{
						"n": 4,
						"h": 222,
						"w": 44
					},
					{
						"n": 5,
						"h": 340,
						"w": 32
					},
					{
						"n": 6,
						"h": 169,
						"w": 106
					},
					{
						"n": 7,
						"h": 191,
						"w": 150
					},
					{
						"n": 8,
						"h": 417,
						"w": 136
					},
					{
						"n": 9,
						"h": 31,
						"w": 190
					},
					{
						"n": 10,
						"h": 169,
						"w": 302
					},
					{
						"n": 11,
						"h": 241,
						"w": 220
					}
				],
				"ball": {
					"n": 0,
					"h": 427,
					"w": 683,
					"z": 0,
					"r": 0,
					"p": 1,
					"x": 0
				}
			},
			"interval": 8
		},
		{
			"num": 468,
			"minute": 22,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 20
					},
					{
						"n": 2,
						"h": 81,
						"w": 377
					},
					{
						"n": 3,
						"h": 170,
						"w": 313
					},
					{
						"n": 4,
						"h": 290,
						"w": 317
					},
					{
						"n": 5,
						"h": 383,
						"w": 373
					},
					{
						"n": 6,
						"h": 40,
						"w": 638
					},
					{
						"n": 7,
						"h": 203,
						"w": 492
					},
					{
						"n": 8,
						"h": 279,
						"w": 607
					},
					{
						"n": 9,
						"h": 440,
						"w": 690
					},
					{
						"n": 10,
						"h": 193,
						"w": 649
					},
					{
						"n": 11,
						"h": 264,
						"w": 661
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 16
					},
					{
						"n": 2,
						"h": 28,
						"w": 28
					},
					{
						"n": 3,
						"h": 183,
						"w": 30
					},
					{
						"n": 4,
						"h": 213,
						"w": 39
					},
					{
						"n": 5,
						"h": 339,
						"w": 32
					},
					{
						"n": 6,
						"h": 175,
						"w": 99
					},
					{
						"n": 7,
						"h": 182,
						"w": 154
					},
					{
						"n": 8,
						"h": 411,
						"w": 142
					},
					{
						"n": 9,
						"h": 36,
						"w": 197
					},
					{
						"n": 10,
						"h": 159,
						"w": 293
					},
					{
						"n": 11,
						"h": 236,
						"w": 222
					}
				],
				"ball": {
					"n": 0,
					"h": 396,
					"w": 751,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 20
		},
		{
			"num": 469,
			"minute": 22,
			"messages": [
				{
					"owner": 1,
					"mes": "Угловой удар..."
				}
			],
			"C": {
				"team": 1
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 40
					},
					{
						"n": 2,
						"h": 230,
						"w": 648
					},
					{
						"n": 3,
						"h": 458,
						"w": 704
					},
					{
						"n": 4,
						"h": 240,
						"w": 660
					},
					{
						"n": 5,
						"h": 215,
						"w": 672
					},
					{
						"n": 6,
						"h": 150,
						"w": 300
					},
					{
						"n": 7,
						"h": 225,
						"w": 600
					},
					{
						"n": 8,
						"h": 225,
						"w": 460
					},
					{
						"n": 9,
						"h": 300,
						"w": 300
					},
					{
						"n": 10,
						"h": 190,
						"w": 660
					},
					{
						"n": 11,
						"h": 260,
						"w": 680
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 10
					},
					{
						"n": 2,
						"h": 225,
						"w": 110
					},
					{
						"n": 3,
						"h": 235,
						"w": 38
					},
					{
						"n": 4,
						"h": 190,
						"w": 30
					},
					{
						"n": 5,
						"h": 245,
						"w": 50
					},
					{
						"n": 6,
						"h": 220,
						"w": 62
					},
					{
						"n": 7,
						"h": 260,
						"w": 50
					},
					{
						"n": 8,
						"h": 225,
						"w": 245
					},
					{
						"n": 9,
						"h": 210,
						"w": 50
					},
					{
						"n": 10,
						"h": 175,
						"w": 40
					},
					{
						"n": 11,
						"h": 150,
						"w": 400
					}
				],
				"ball": {
					"n": 0,
					"h": 450,
					"w": 720,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 100
		},
		{
			"num": 470,
			"minute": 22,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 41
					},
					{
						"n": 2,
						"h": 231,
						"w": 647
					},
					{
						"n": 3,
						"h": 450,
						"w": 720
					},
					{
						"n": 4,
						"h": 240,
						"w": 663
					},
					{
						"n": 5,
						"h": 221,
						"w": 679
					},
					{
						"n": 6,
						"h": 156,
						"w": 302
					},
					{
						"n": 7,
						"h": 220,
						"w": 596
					},
					{
						"n": 8,
						"h": 230,
						"w": 464
					},
					{
						"n": 9,
						"h": 305,
						"w": 296
					},
					{
						"n": 10,
						"h": 187,
						"w": 655
					},
					{
						"n": 11,
						"h": 267,
						"w": 674
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 20
					},
					{
						"n": 2,
						"h": 224,
						"w": 113
					},
					{
						"n": 3,
						"h": 237,
						"w": 35
					},
					{
						"n": 4,
						"h": 185,
						"w": 29
					},
					{
						"n": 5,
						"h": 242,
						"w": 48
					},
					{
						"n": 6,
						"h": 227,
						"w": 63
					},
					{
						"n": 7,
						"h": 267,
						"w": 46
					},
					{
						"n": 8,
						"h": 230,
						"w": 239
					},
					{
						"n": 9,
						"h": 208,
						"w": 44
					},
					{
						"n": 10,
						"h": 178,
						"w": 47
					},
					{
						"n": 11,
						"h": 155,
						"w": 407
					}
				],
				"ball": {
					"n": 0,
					"h": 450,
					"w": 720,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 15
		},
		{
			"num": 471,
			"minute": 22,
			"messages": [
				{
					"owner": 1,
					"mes": "Патрик Клинтон[03](Галвэй Юнайтед) устанавливает мяч у углового флажка..."
				},
				{
					"owner": 1,
					"mes": "Навес в штрафную..."
				},
				{
					"owner": 1,
					"mes": "Нир Мансур[23](Опава) показывает свою прыгучесть и выбивает мяч из штрафной..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 12
					},
					{
						"n": 2,
						"h": 223,
						"w": 649
					},
					{
						"n": 3,
						"h": 448,
						"w": 715
					},
					{
						"n": 4,
						"h": 247,
						"w": 654
					},
					{
						"n": 5,
						"h": 225,
						"w": 672
					},
					{
						"n": 6,
						"h": 167,
						"w": 326
					},
					{
						"n": 7,
						"h": 203,
						"w": 579
					},
					{
						"n": 8,
						"h": 224,
						"w": 508
					},
					{
						"n": 9,
						"h": 282,
						"w": 332
					},
					{
						"n": 10,
						"h": 187,
						"w": 657
					},
					{
						"n": 11,
						"h": 266,
						"w": 665
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 12
					},
					{
						"n": 2,
						"h": 221,
						"w": 110
					},
					{
						"n": 3,
						"h": 231,
						"w": 44
					},
					{
						"n": 4,
						"h": 180,
						"w": 46
					},
					{
						"n": 5,
						"h": 232,
						"w": 48
					},
					{
						"n": 6,
						"h": 235,
						"w": 62
					},
					{
						"n": 7,
						"h": 265,
						"w": 60
					},
					{
						"n": 8,
						"h": 204,
						"w": 204
					},
					{
						"n": 9,
						"h": 209,
						"w": 56
					},
					{
						"n": 10,
						"h": 179,
						"w": 53
					},
					{
						"n": 11,
						"h": 169,
						"w": 365
					}
				],
				"ball": {
					"n": 0,
					"h": 219,
					"w": 676,
					"z": 1,
					"r": 2,
					"p": 4,
					"x": 1
				}
			},
			"interval": 44
		},
		{
			"num": 472,
			"minute": 22,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 11
					},
					{
						"n": 2,
						"h": 204,
						"w": 615
					},
					{
						"n": 3,
						"h": 426,
						"w": 683
					},
					{
						"n": 4,
						"h": 254,
						"w": 615
					},
					{
						"n": 5,
						"h": 243,
						"w": 637
					},
					{
						"n": 6,
						"h": 181,
						"w": 324
					},
					{
						"n": 7,
						"h": 170,
						"w": 558
					},
					{
						"n": 8,
						"h": 269,
						"w": 513
					},
					{
						"n": 9,
						"h": 284,
						"w": 330
					},
					{
						"n": 10,
						"h": 166,
						"w": 632
					},
					{
						"n": 11,
						"h": 288,
						"w": 634
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 15
					},
					{
						"n": 2,
						"h": 185,
						"w": 96
					},
					{
						"n": 3,
						"h": 231,
						"w": 44
					},
					{
						"n": 4,
						"h": 204,
						"w": 50
					},
					{
						"n": 5,
						"h": 270,
						"w": 40
					},
					{
						"n": 6,
						"h": 244,
						"w": 80
					},
					{
						"n": 7,
						"h": 233,
						"w": 83
					},
					{
						"n": 8,
						"h": 158,
						"w": 201
					},
					{
						"n": 9,
						"h": 181,
						"w": 83
					},
					{
						"n": 10,
						"h": 175,
						"w": 91
					},
					{
						"n": 11,
						"h": 202,
						"w": 345
					}
				],
				"ball": {
					"n": 0,
					"h": 323,
					"w": 558,
					"z": 1,
					"r": 0,
					"p": 1,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 473,
			"minute": 22,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 10
					},
					{
						"n": 2,
						"h": 198,
						"w": 604
					},
					{
						"n": 3,
						"h": 419,
						"w": 673
					},
					{
						"n": 4,
						"h": 256,
						"w": 604
					},
					{
						"n": 5,
						"h": 249,
						"w": 626
					},
					{
						"n": 6,
						"h": 171,
						"w": 331
					},
					{
						"n": 7,
						"h": 158,
						"w": 557
					},
					{
						"n": 8,
						"h": 283,
						"w": 514
					},
					{
						"n": 9,
						"h": 278,
						"w": 326
					},
					{
						"n": 10,
						"h": 169,
						"w": 631
					},
					{
						"n": 11,
						"h": 293,
						"w": 637
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 14
					},
					{
						"n": 2,
						"h": 173,
						"w": 94
					},
					{
						"n": 3,
						"h": 221,
						"w": 51
					},
					{
						"n": 4,
						"h": 214,
						"w": 55
					},
					{
						"n": 5,
						"h": 281,
						"w": 44
					},
					{
						"n": 6,
						"h": 256,
						"w": 80
					},
					{
						"n": 7,
						"h": 240,
						"w": 90
					},
					{
						"n": 8,
						"h": 144,
						"w": 200
					},
					{
						"n": 9,
						"h": 169,
						"w": 80
					},
					{
						"n": 10,
						"h": 167,
						"w": 100
					},
					{
						"n": 11,
						"h": 212,
						"w": 338
					}
				],
				"ball": {
					"n": 0,
					"h": 354,
					"w": 522,
					"z": 0,
					"r": 0,
					"p": 1,
					"x": 0
				}
			},
			"interval": 12
		},
		{
			"num": 474,
			"minute": 22,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 19
					},
					{
						"n": 2,
						"h": 176,
						"w": 547
					},
					{
						"n": 3,
						"h": 390,
						"w": 633
					},
					{
						"n": 4,
						"h": 261,
						"w": 540
					},
					{
						"n": 5,
						"h": 271,
						"w": 568
					},
					{
						"n": 6,
						"h": 200,
						"w": 331
					},
					{
						"n": 7,
						"h": 170,
						"w": 508
					},
					{
						"n": 8,
						"h": 349,
						"w": 511
					},
					{
						"n": 9,
						"h": 275,
						"w": 328
					},
					{
						"n": 10,
						"h": 206,
						"w": 577
					},
					{
						"n": 11,
						"h": 272,
						"w": 592
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 14
					},
					{
						"n": 2,
						"h": 130,
						"w": 118
					},
					{
						"n": 3,
						"h": 202,
						"w": 74
					},
					{
						"n": 4,
						"h": 238,
						"w": 74
					},
					{
						"n": 5,
						"h": 325,
						"w": 69
					},
					{
						"n": 6,
						"h": 215,
						"w": 110
					},
					{
						"n": 7,
						"h": 229,
						"w": 139
					},
					{
						"n": 8,
						"h": 85,
						"w": 210
					},
					{
						"n": 9,
						"h": 147,
						"w": 125
					},
					{
						"n": 10,
						"h": 165,
						"w": 150
					},
					{
						"n": 11,
						"h": 262,
						"w": 346
					}
				],
				"ball": {
					"n": 0,
					"h": 365,
					"w": 510,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 50
		},
		{
			"num": 475,
			"minute": 22,
			"messages": [
				{
					"owner": 2,
					"mes": "Даниэль Прохазка[28](Опава) устремляется к свободному мячу и подхватывает его..."
				}
			]
		},
		{
			"num": 476,
			"minute": 23,
			"possession": 42,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 13
					},
					{
						"n": 2,
						"h": 157,
						"w": 502
					},
					{
						"n": 3,
						"h": 368,
						"w": 601
					},
					{
						"n": 4,
						"h": 266,
						"w": 490
					},
					{
						"n": 5,
						"h": 288,
						"w": 523
					},
					{
						"n": 6,
						"h": 209,
						"w": 316,
						"f": 92
					},
					{
						"n": 7,
						"h": 178,
						"w": 470
					},
					{
						"n": 8,
						"h": 374,
						"w": 466
					},
					{
						"n": 9,
						"h": 268,
						"w": 325
					},
					{
						"n": 10,
						"h": 183,
						"w": 531,
						"m": 740
					},
					{
						"n": 11,
						"h": 255,
						"w": 540
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 17
					},
					{
						"n": 2,
						"h": 88,
						"w": 137,
						"f": 90
					},
					{
						"n": 3,
						"h": 177,
						"w": 103
					},
					{
						"n": 4,
						"h": 275,
						"w": 103
					},
					{
						"n": 5,
						"h": 357,
						"w": 101
					},
					{
						"n": 6,
						"h": 203,
						"w": 147
					},
					{
						"n": 7,
						"h": 265,
						"w": 159
					},
					{
						"n": 8,
						"h": 65,
						"w": 244
					},
					{
						"n": 9,
						"h": 135,
						"w": 115
					},
					{
						"n": 10,
						"h": 165,
						"w": 199,
						"f": 91
					},
					{
						"n": 11,
						"h": 241,
						"w": 377,
						"f": 91
					}
				],
				"ball": {
					"n": 0,
					"h": 385,
					"w": 476,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 477,
			"minute": 23,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 13
					},
					{
						"n": 2,
						"h": 140,
						"w": 455
					},
					{
						"n": 3,
						"h": 346,
						"w": 567
					},
					{
						"n": 4,
						"h": 269,
						"w": 439
					},
					{
						"n": 5,
						"h": 304,
						"w": 475
					},
					{
						"n": 6,
						"h": 188,
						"w": 308
					},
					{
						"n": 7,
						"h": 193,
						"w": 420
					},
					{
						"n": 8,
						"h": 419,
						"w": 445
					},
					{
						"n": 9,
						"h": 234,
						"w": 307
					},
					{
						"n": 10,
						"h": 164,
						"w": 498
					},
					{
						"n": 11,
						"h": 269,
						"w": 498
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 10
					},
					{
						"n": 2,
						"h": 57,
						"w": 153
					},
					{
						"n": 3,
						"h": 181,
						"w": 109
					},
					{
						"n": 4,
						"h": 286,
						"w": 117
					},
					{
						"n": 5,
						"h": 392,
						"w": 115
					},
					{
						"n": 6,
						"h": 215,
						"w": 195
					},
					{
						"n": 7,
						"h": 261,
						"w": 203
					},
					{
						"n": 8,
						"h": 27,
						"w": 254
					},
					{
						"n": 9,
						"h": 166,
						"w": 153
					},
					{
						"n": 10,
						"h": 159,
						"w": 248
					},
					{
						"n": 11,
						"h": 221,
						"w": 395
					}
				],
				"ball": {
					"n": 0,
					"h": 423,
					"w": 466,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 478,
			"minute": 23,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 19
					},
					{
						"n": 2,
						"h": 123,
						"w": 408
					},
					{
						"n": 3,
						"h": 320,
						"w": 526
					},
					{
						"n": 4,
						"h": 271,
						"w": 388
					},
					{
						"n": 5,
						"h": 320,
						"w": 428
					},
					{
						"n": 6,
						"h": 207,
						"w": 293
					},
					{
						"n": 7,
						"h": 204,
						"w": 368
					},
					{
						"n": 8,
						"h": 382,
						"w": 434
					},
					{
						"n": 9,
						"h": 277,
						"w": 279
					},
					{
						"n": 10,
						"h": 165,
						"w": 477
					},
					{
						"n": 11,
						"h": 305,
						"w": 481
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 17
					},
					{
						"n": 2,
						"h": 58,
						"w": 147
					},
					{
						"n": 3,
						"h": 171,
						"w": 98
					},
					{
						"n": 4,
						"h": 285,
						"w": 117
					},
					{
						"n": 5,
						"h": 395,
						"w": 162
					},
					{
						"n": 6,
						"h": 232,
						"w": 242
					},
					{
						"n": 7,
						"h": 256,
						"w": 247
					},
					{
						"n": 8,
						"h": 65,
						"w": 264
					},
					{
						"n": 9,
						"h": 182,
						"w": 193
					},
					{
						"n": 10,
						"h": 153,
						"w": 298
					},
					{
						"n": 11,
						"h": 241,
						"w": 367
					}
				],
				"ball": {
					"n": 0,
					"h": 385,
					"w": 456,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 479,
			"minute": 23,
			"messages": [
				{
					"owner": 2,
					"mes": "Даниэль Прохазка[28](Опава) отдает мяч рванувшемуся вперед П.Крамаржу[30](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 10
					},
					{
						"n": 2,
						"h": 114,
						"w": 371
					},
					{
						"n": 3,
						"h": 303,
						"w": 493
					},
					{
						"n": 4,
						"h": 281,
						"w": 356
					},
					{
						"n": 5,
						"h": 328,
						"w": 397
					},
					{
						"n": 6,
						"h": 192,
						"w": 254
					},
					{
						"n": 7,
						"h": 191,
						"w": 330
					},
					{
						"n": 8,
						"h": 352,
						"w": 406
					},
					{
						"n": 9,
						"h": 244,
						"w": 258
					},
					{
						"n": 10,
						"h": 178,
						"w": 449
					},
					{
						"n": 11,
						"h": 274,
						"w": 452
					}
				],
				"away": [
					{
						"n": 1,
						"h": 228,
						"w": 15
					},
					{
						"n": 2,
						"h": 70,
						"w": 170
					},
					{
						"n": 3,
						"h": 178,
						"w": 125
					},
					{
						"n": 4,
						"h": 272,
						"w": 119
					},
					{
						"n": 5,
						"h": 394,
						"w": 126
					},
					{
						"n": 6,
						"h": 229,
						"w": 211
					},
					{
						"n": 7,
						"h": 277,
						"w": 267
					},
					{
						"n": 8,
						"h": 65,
						"w": 264
					},
					{
						"n": 9,
						"h": 157,
						"w": 212
					},
					{
						"n": 10,
						"h": 133,
						"w": 328
					},
					{
						"n": 11,
						"h": 263,
						"w": 396
					}
				],
				"ball": {
					"n": 0,
					"h": 317,
					"w": 392,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 31
		},
		{
			"num": 480,
			"minute": 23,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 11
					},
					{
						"n": 2,
						"h": 102,
						"w": 322
					},
					{
						"n": 3,
						"h": 281,
						"w": 450
					},
					{
						"n": 4,
						"h": 291,
						"w": 306
					},
					{
						"n": 5,
						"h": 340,
						"w": 349
					},
					{
						"n": 6,
						"h": 206,
						"w": 229
					},
					{
						"n": 7,
						"h": 210,
						"w": 280
					},
					{
						"n": 8,
						"h": 325,
						"w": 377
					},
					{
						"n": 9,
						"h": 261,
						"w": 238
					},
					{
						"n": 10,
						"h": 176,
						"w": 428
					},
					{
						"n": 11,
						"h": 277,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 18
					},
					{
						"n": 2,
						"h": 71,
						"w": 178
					},
					{
						"n": 3,
						"h": 173,
						"w": 144
					},
					{
						"n": 4,
						"h": 274,
						"w": 139
					},
					{
						"n": 5,
						"h": 384,
						"w": 162
					},
					{
						"n": 6,
						"h": 251,
						"w": 211
					},
					{
						"n": 7,
						"h": 263,
						"w": 287
					},
					{
						"n": 8,
						"h": 47,
						"w": 304
					},
					{
						"n": 9,
						"h": 183,
						"w": 232
					},
					{
						"n": 10,
						"h": 148,
						"w": 365
					},
					{
						"n": 11,
						"h": 243,
						"w": 436
					}
				],
				"ball": {
					"n": 0,
					"h": 302,
					"w": 355,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 481,
			"minute": 23,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 11
					},
					{
						"n": 2,
						"h": 99,
						"w": 273
					},
					{
						"n": 3,
						"h": 261,
						"w": 406
					},
					{
						"n": 4,
						"h": 286,
						"w": 255
					},
					{
						"n": 5,
						"h": 350,
						"w": 300
					},
					{
						"n": 6,
						"h": 206,
						"w": 213
					},
					{
						"n": 7,
						"h": 216,
						"w": 240
					},
					{
						"n": 8,
						"h": 302,
						"w": 344
					},
					{
						"n": 9,
						"h": 262,
						"w": 209
					},
					{
						"n": 10,
						"h": 162,
						"w": 400
					},
					{
						"n": 11,
						"h": 275,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 41
					},
					{
						"n": 2,
						"h": 63,
						"w": 212
					},
					{
						"n": 3,
						"h": 175,
						"w": 170
					},
					{
						"n": 4,
						"h": 288,
						"w": 176
					},
					{
						"n": 5,
						"h": 375,
						"w": 190
					},
					{
						"n": 6,
						"h": 241,
						"w": 250
					},
					{
						"n": 7,
						"h": 259,
						"w": 307
					},
					{
						"n": 8,
						"h": 44,
						"w": 344
					},
					{
						"n": 9,
						"h": 185,
						"w": 252
					},
					{
						"n": 10,
						"h": 163,
						"w": 402
					},
					{
						"n": 11,
						"h": 236,
						"w": 476
					}
				],
				"ball": {
					"n": 0,
					"h": 287,
					"w": 318,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 482,
			"minute": 23,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 11
					},
					{
						"n": 2,
						"h": 97,
						"w": 223
					},
					{
						"n": 3,
						"h": 245,
						"w": 360
					},
					{
						"n": 4,
						"h": 270,
						"w": 261
					},
					{
						"n": 5,
						"h": 356,
						"w": 250
					},
					{
						"n": 6,
						"h": 216,
						"w": 194
					},
					{
						"n": 7,
						"h": 175,
						"w": 217
					},
					{
						"n": 8,
						"h": 283,
						"w": 309
					},
					{
						"n": 9,
						"h": 263,
						"w": 181
					},
					{
						"n": 10,
						"h": 173,
						"w": 400
					},
					{
						"n": 11,
						"h": 315,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 229,
						"w": 57
					},
					{
						"n": 2,
						"h": 64,
						"w": 229
					},
					{
						"n": 3,
						"h": 183,
						"w": 177
					},
					{
						"n": 4,
						"h": 277,
						"w": 192
					},
					{
						"n": 5,
						"h": 375,
						"w": 209
					},
					{
						"n": 6,
						"h": 233,
						"w": 299
					},
					{
						"n": 7,
						"h": 278,
						"w": 327
					},
					{
						"n": 8,
						"h": 66,
						"w": 384
					},
					{
						"n": 9,
						"h": 177,
						"w": 272
					},
					{
						"n": 10,
						"h": 178,
						"w": 439
					},
					{
						"n": 11,
						"h": 228,
						"w": 516
					}
				],
				"ball": {
					"n": 0,
					"h": 272,
					"w": 281,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 483,
			"minute": 23,
			"messages": [
				{
					"owner": 2,
					"mes": "Петр Крамарж[30](Опава) делает передачу налево на Д.Прохазку[28](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 15
					},
					{
						"n": 2,
						"h": 114,
						"w": 173
					},
					{
						"n": 3,
						"h": 229,
						"w": 312
					},
					{
						"n": 4,
						"h": 269,
						"w": 208
					},
					{
						"n": 5,
						"h": 381,
						"w": 274
					},
					{
						"n": 6,
						"h": 219,
						"w": 153
					},
					{
						"n": 7,
						"h": 195,
						"w": 179
					},
					{
						"n": 8,
						"h": 281,
						"w": 267
					},
					{
						"n": 9,
						"h": 309,
						"w": 209
					},
					{
						"n": 10,
						"h": 173,
						"w": 400
					},
					{
						"n": 11,
						"h": 304,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 223,
						"w": 74
					},
					{
						"n": 2,
						"h": 75,
						"w": 266
					},
					{
						"n": 3,
						"h": 170,
						"w": 205
					},
					{
						"n": 4,
						"h": 277,
						"w": 218
					},
					{
						"n": 5,
						"h": 386,
						"w": 244
					},
					{
						"n": 6,
						"h": 181,
						"w": 302
					},
					{
						"n": 7,
						"h": 255,
						"w": 347
					},
					{
						"n": 8,
						"h": 60,
						"w": 426
					},
					{
						"n": 9,
						"h": 146,
						"w": 262
					},
					{
						"n": 10,
						"h": 175,
						"w": 451,
						"m": 610
					},
					{
						"n": 11,
						"h": 238,
						"w": 544
					}
				],
				"ball": {
					"n": 0,
					"h": 390,
					"w": 294,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 42
		},
		{
			"num": 484,
			"minute": 23,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 15
					},
					{
						"n": 2,
						"h": 119,
						"w": 124
					},
					{
						"n": 3,
						"h": 217,
						"w": 274
					},
					{
						"n": 4,
						"h": 267,
						"w": 156
					},
					{
						"n": 5,
						"h": 368,
						"w": 226
					},
					{
						"n": 6,
						"h": 231,
						"w": 121
					},
					{
						"n": 7,
						"h": 200,
						"w": 156
					},
					{
						"n": 8,
						"h": 284,
						"w": 214
					},
					{
						"n": 9,
						"h": 338,
						"w": 166
					},
					{
						"n": 10,
						"h": 180,
						"w": 400
					},
					{
						"n": 11,
						"h": 260,
						"w": 448
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 92
					},
					{
						"n": 2,
						"h": 70,
						"w": 312
					},
					{
						"n": 3,
						"h": 164,
						"w": 244
					},
					{
						"n": 4,
						"h": 270,
						"w": 251
					},
					{
						"n": 5,
						"h": 394,
						"w": 290
					},
					{
						"n": 6,
						"h": 192,
						"w": 351
					},
					{
						"n": 7,
						"h": 251,
						"w": 391
					},
					{
						"n": 8,
						"h": 95,
						"w": 406
					},
					{
						"n": 9,
						"h": 190,
						"w": 282
					},
					{
						"n": 10,
						"h": 167,
						"w": 500
					},
					{
						"n": 11,
						"h": 218,
						"w": 580
					}
				],
				"ball": {
					"n": 0,
					"h": 355,
					"w": 314,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 485,
			"minute": 23,
			"messages": [
				{
					"owner": 2,
					"mes": "Коротким пасом Д.Прохазка[28](Опава) отправляет мяч на О.Дюмона[26](Опава)..."
				},
				{
					"owner": 2,
					"mes": "Оливье Дюмон[26](Опава) принимает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 11
					},
					{
						"n": 2,
						"h": 120,
						"w": 101
					},
					{
						"n": 3,
						"h": 208,
						"w": 223
					},
					{
						"n": 4,
						"h": 265,
						"w": 110
					},
					{
						"n": 5,
						"h": 360,
						"w": 173
					},
					{
						"n": 6,
						"h": 200,
						"w": 104
					},
					{
						"n": 7,
						"h": 184,
						"w": 147
					},
					{
						"n": 8,
						"h": 288,
						"w": 158
					},
					{
						"n": 9,
						"h": 331,
						"w": 111
					},
					{
						"n": 10,
						"h": 182,
						"w": 400
					},
					{
						"n": 11,
						"h": 301,
						"w": 436
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 112
					},
					{
						"n": 2,
						"h": 69,
						"w": 307
					},
					{
						"n": 3,
						"h": 176,
						"w": 260
					},
					{
						"n": 4,
						"h": 268,
						"w": 277
					},
					{
						"n": 5,
						"h": 383,
						"w": 261
					},
					{
						"n": 6,
						"h": 222,
						"w": 381
					},
					{
						"n": 7,
						"h": 276,
						"w": 431
					},
					{
						"n": 8,
						"h": 95,
						"w": 406,
						"m": 640
					},
					{
						"n": 9,
						"h": 174,
						"w": 322
					},
					{
						"n": 10,
						"h": 167,
						"w": 540
					},
					{
						"n": 11,
						"h": 267,
						"w": 590
					}
				],
				"ball": {
					"n": 0,
					"h": 228,
					"w": 339,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 43
		},
		{
			"num": 486,
			"minute": 23,
			"messages": [
				{
					"owner": 2,
					"mes": "Пас налево на Д.Прохазку[28](Опава)..."
				},
				{
					"owner": 2,
					"mes": "Даниэль Прохазка[28](Опава) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 12
					},
					{
						"n": 2,
						"h": 120,
						"w": 113
					},
					{
						"n": 3,
						"h": 196,
						"w": 176
					},
					{
						"n": 4,
						"h": 222,
						"w": 128
					},
					{
						"n": 5,
						"h": 352,
						"w": 220
					},
					{
						"n": 6,
						"h": 179,
						"w": 126
					},
					{
						"n": 7,
						"h": 195,
						"w": 194
					},
					{
						"n": 8,
						"h": 307,
						"w": 137
					},
					{
						"n": 9,
						"h": 368,
						"w": 132
					},
					{
						"n": 10,
						"h": 175,
						"w": 400
					},
					{
						"n": 11,
						"h": 276,
						"w": 420
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 126
					},
					{
						"n": 2,
						"h": 64,
						"w": 329
					},
					{
						"n": 3,
						"h": 174,
						"w": 283
					},
					{
						"n": 4,
						"h": 275,
						"w": 285
					},
					{
						"n": 5,
						"h": 380,
						"w": 308
					},
					{
						"n": 6,
						"h": 215,
						"w": 373,
						"m": 630
					},
					{
						"n": 7,
						"h": 228,
						"w": 432
					},
					{
						"n": 8,
						"h": 96,
						"w": 449
					},
					{
						"n": 9,
						"h": 147,
						"w": 361
					},
					{
						"n": 10,
						"h": 145,
						"w": 580
					},
					{
						"n": 11,
						"h": 236,
						"w": 578
					}
				],
				"ball": {
					"n": 0,
					"h": 354,
					"w": 271,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 48
		},
		{
			"num": 487,
			"minute": 23,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 15
					},
					{
						"n": 2,
						"h": 120,
						"w": 114
					},
					{
						"n": 3,
						"h": 180,
						"w": 139
					},
					{
						"n": 4,
						"h": 221,
						"w": 126
					},
					{
						"n": 5,
						"h": 329,
						"w": 220
					},
					{
						"n": 6,
						"h": 147,
						"w": 151
					},
					{
						"n": 7,
						"h": 215,
						"w": 184
					},
					{
						"n": 8,
						"h": 301,
						"w": 128
					},
					{
						"n": 9,
						"h": 351,
						"w": 129
					},
					{
						"n": 10,
						"h": 173,
						"w": 400
					},
					{
						"n": 11,
						"h": 311,
						"w": 440
					}
				],
				"away": [
					{
						"n": 1,
						"h": 221,
						"w": 127
					},
					{
						"n": 2,
						"h": 71,
						"w": 298
					},
					{
						"n": 3,
						"h": 163,
						"w": 251
					},
					{
						"n": 4,
						"h": 277,
						"w": 245
					},
					{
						"n": 5,
						"h": 388,
						"w": 281
					},
					{
						"n": 6,
						"h": 233,
						"w": 368
					},
					{
						"n": 7,
						"h": 215,
						"w": 454
					},
					{
						"n": 8,
						"h": 113,
						"w": 480
					},
					{
						"n": 9,
						"h": 117,
						"w": 388
					},
					{
						"n": 10,
						"h": 144,
						"w": 572
					},
					{
						"n": 11,
						"h": 238,
						"w": 569
					}
				],
				"ball": {
					"n": 0,
					"h": 337,
					"w": 240,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 488,
			"minute": 23,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 17
					},
					{
						"n": 2,
						"h": 120,
						"w": 110
					},
					{
						"n": 3,
						"h": 207,
						"w": 110
					},
					{
						"n": 4,
						"h": 257,
						"w": 107
					},
					{
						"n": 5,
						"h": 301,
						"w": 238
					},
					{
						"n": 6,
						"h": 113,
						"w": 171
					},
					{
						"n": 7,
						"h": 176,
						"w": 177
					},
					{
						"n": 8,
						"h": 287,
						"w": 165
					},
					{
						"n": 9,
						"h": 354,
						"w": 125
					},
					{
						"n": 10,
						"h": 165,
						"w": 400
					},
					{
						"n": 11,
						"h": 310,
						"w": 435
					}
				],
				"away": [
					{
						"n": 1,
						"h": 221,
						"w": 127
					},
					{
						"n": 2,
						"h": 56,
						"w": 335
					},
					{
						"n": 3,
						"h": 181,
						"w": 262
					},
					{
						"n": 4,
						"h": 285,
						"w": 274
					},
					{
						"n": 5,
						"h": 399,
						"w": 320
					},
					{
						"n": 6,
						"h": 219,
						"w": 372
					},
					{
						"n": 7,
						"h": 221,
						"w": 493
					},
					{
						"n": 8,
						"h": 144,
						"w": 462
					},
					{
						"n": 9,
						"h": 103,
						"w": 425
					},
					{
						"n": 10,
						"h": 164,
						"w": 555
					},
					{
						"n": 11,
						"h": 258,
						"w": 593
					}
				],
				"ball": {
					"n": 0,
					"h": 306,
					"w": 258,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 489,
			"minute": 23,
			"messages": [
				{
					"owner": 2,
					"mes": "Даниэль Прохазка[28](Опава) отдает мяч рванувшемуся вперед М.Манолову[27](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 15
					},
					{
						"n": 2,
						"h": 120,
						"w": 103
					},
					{
						"n": 3,
						"h": 172,
						"w": 108
					},
					{
						"n": 4,
						"h": 287,
						"w": 116
					},
					{
						"n": 5,
						"h": 336,
						"w": 242
					},
					{
						"n": 6,
						"h": 83,
						"w": 190
					},
					{
						"n": 7,
						"h": 185,
						"w": 180
					},
					{
						"n": 8,
						"h": 253,
						"w": 172
					},
					{
						"n": 9,
						"h": 362,
						"w": 110
					},
					{
						"n": 10,
						"h": 169,
						"w": 400
					},
					{
						"n": 11,
						"h": 282,
						"w": 418
					}
				],
				"away": [
					{
						"n": 1,
						"h": 228,
						"w": 127
					},
					{
						"n": 2,
						"h": 62,
						"w": 331
					},
					{
						"n": 3,
						"h": 168,
						"w": 283
					},
					{
						"n": 4,
						"h": 281,
						"w": 273
					},
					{
						"n": 5,
						"h": 383,
						"w": 293
					},
					{
						"n": 6,
						"h": 213,
						"w": 398
					},
					{
						"n": 7,
						"h": 231,
						"w": 523
					},
					{
						"n": 8,
						"h": 144,
						"w": 462
					},
					{
						"n": 9,
						"h": 85,
						"w": 455
					},
					{
						"n": 10,
						"h": 136,
						"w": 575
					},
					{
						"n": 11,
						"h": 293,
						"w": 595
					}
				],
				"ball": {
					"n": 0,
					"h": 219,
					"w": 197,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 35
		},
		{
			"num": 490,
			"minute": 23,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 15
					},
					{
						"n": 2,
						"h": 120,
						"w": 106
					},
					{
						"n": 3,
						"h": 171,
						"w": 105
					},
					{
						"n": 4,
						"h": 283,
						"w": 111
					},
					{
						"n": 5,
						"h": 367,
						"w": 222
					},
					{
						"n": 6,
						"h": 48,
						"w": 200
					},
					{
						"n": 7,
						"h": 219,
						"w": 166
					},
					{
						"n": 8,
						"h": 272,
						"w": 186
					},
					{
						"n": 9,
						"h": 354,
						"w": 109
					},
					{
						"n": 10,
						"h": 165,
						"w": 400
					},
					{
						"n": 11,
						"h": 277,
						"w": 430
					}
				],
				"away": [
					{
						"n": 1,
						"h": 229,
						"w": 121
					},
					{
						"n": 2,
						"h": 61,
						"w": 315
					},
					{
						"n": 3,
						"h": 173,
						"w": 274
					},
					{
						"n": 4,
						"h": 285,
						"w": 284
					},
					{
						"n": 5,
						"h": 375,
						"w": 280
					},
					{
						"n": 6,
						"h": 212,
						"w": 396
					},
					{
						"n": 7,
						"h": 231,
						"w": 554
					},
					{
						"n": 8,
						"h": 179,
						"w": 472
					},
					{
						"n": 9,
						"h": 63,
						"w": 485
					},
					{
						"n": 10,
						"h": 154,
						"w": 596
					},
					{
						"n": 11,
						"h": 296,
						"w": 585
					}
				],
				"ball": {
					"n": 0,
					"h": 219,
					"w": 166,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 37
		},
		{
			"num": 491,
			"minute": 23,
			"messages": [
				{
					"owner": 2,
					"mes": "М.Манолов[27](Опава) пытается обыграть А.Хлинссона[07](Галвэй Юнайтед)..."
				},
				{
					"owner": 2,
					"mes": "Агуст Хлинссон[07](Галвэй Юнайтед) отбирает мяч у М.Манолова[27](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 15
					},
					{
						"n": 2,
						"h": 120,
						"w": 106
					},
					{
						"n": 3,
						"h": 171,
						"w": 105
					},
					{
						"n": 4,
						"h": 283,
						"w": 111
					},
					{
						"n": 5,
						"h": 375,
						"w": 217
					},
					{
						"n": 6,
						"h": 38,
						"w": 202
					},
					{
						"n": 7,
						"h": 228,
						"w": 162,
						"m": 680
					},
					{
						"n": 8,
						"h": 272,
						"w": 186
					},
					{
						"n": 9,
						"h": 354,
						"w": 109
					},
					{
						"n": 10,
						"h": 165,
						"w": 400
					},
					{
						"n": 11,
						"h": 277,
						"w": 430
					}
				],
				"away": [
					{
						"n": 1,
						"h": 229,
						"w": 121
					},
					{
						"n": 2,
						"h": 61,
						"w": 315
					},
					{
						"n": 3,
						"h": 173,
						"w": 274
					},
					{
						"n": 4,
						"h": 285,
						"w": 284
					},
					{
						"n": 5,
						"h": 375,
						"w": 280
					},
					{
						"n": 6,
						"h": 212,
						"w": 396
					},
					{
						"n": 7,
						"h": 231,
						"w": 564
					},
					{
						"n": 8,
						"h": 189,
						"w": 475
					},
					{
						"n": 9,
						"h": 57,
						"w": 493
					},
					{
						"n": 10,
						"h": 154,
						"w": 596
					},
					{
						"n": 11,
						"h": 296,
						"w": 585
					}
				],
				"ball": {
					"n": 0,
					"h": 228,
					"w": 162,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 10
		},
		{
			"num": 492,
			"minute": 23,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 11
					},
					{
						"n": 2,
						"h": 104,
						"w": 143
					},
					{
						"n": 3,
						"h": 181,
						"w": 138
					},
					{
						"n": 4,
						"h": 285,
						"w": 151
					},
					{
						"n": 5,
						"h": 377,
						"w": 191
					},
					{
						"n": 6,
						"h": 39,
						"w": 242
					},
					{
						"n": 7,
						"h": 203,
						"w": 187
					},
					{
						"n": 8,
						"h": 276,
						"w": 226
					},
					{
						"n": 9,
						"h": 372,
						"w": 145
					},
					{
						"n": 10,
						"h": 162,
						"w": 440
					},
					{
						"n": 11,
						"h": 279,
						"w": 470
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 78
					},
					{
						"n": 2,
						"h": 79,
						"w": 279
					},
					{
						"n": 3,
						"h": 181,
						"w": 234
					},
					{
						"n": 4,
						"h": 276,
						"w": 245
					},
					{
						"n": 5,
						"h": 355,
						"w": 245
					},
					{
						"n": 6,
						"h": 233,
						"w": 362
					},
					{
						"n": 7,
						"h": 233,
						"w": 554
					},
					{
						"n": 8,
						"h": 222,
						"w": 452
					},
					{
						"n": 9,
						"h": 50,
						"w": 454
					},
					{
						"n": 10,
						"h": 148,
						"w": 556
					},
					{
						"n": 11,
						"h": 273,
						"w": 552
					}
				],
				"ball": {
					"n": 0,
					"h": 203,
					"w": 187,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 493,
			"minute": 23,
			"messages": [
				{
					"owner": 1,
					"mes": "А.Хлинссон[07](Галвэй Юнайтед) пасует К.Нолану[08](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 19
					},
					{
						"n": 2,
						"h": 90,
						"w": 182
					},
					{
						"n": 3,
						"h": 162,
						"w": 174
					},
					{
						"n": 4,
						"h": 277,
						"w": 179
					},
					{
						"n": 5,
						"h": 373,
						"w": 232
					},
					{
						"n": 6,
						"h": 42,
						"w": 283
					},
					{
						"n": 7,
						"h": 202,
						"w": 197
					},
					{
						"n": 8,
						"h": 273,
						"w": 267
					},
					{
						"n": 9,
						"h": 376,
						"w": 186
					},
					{
						"n": 10,
						"h": 162,
						"w": 475
					},
					{
						"n": 11,
						"h": 293,
						"w": 500
					}
				],
				"away": [
					{
						"n": 1,
						"h": 221,
						"w": 77
					},
					{
						"n": 2,
						"h": 101,
						"w": 244
					},
					{
						"n": 3,
						"h": 168,
						"w": 228
					},
					{
						"n": 4,
						"h": 275,
						"w": 245
					},
					{
						"n": 5,
						"h": 340,
						"w": 237
					},
					{
						"n": 6,
						"h": 227,
						"w": 321
					},
					{
						"n": 7,
						"h": 218,
						"w": 516
					},
					{
						"n": 8,
						"h": 181,
						"w": 451
					},
					{
						"n": 9,
						"h": 53,
						"w": 413
					},
					{
						"n": 10,
						"h": 158,
						"w": 516
					},
					{
						"n": 11,
						"h": 255,
						"w": 515
					}
				],
				"ball": {
					"n": 0,
					"h": 273,
					"w": 267,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 41
		},
		{
			"num": 494,
			"minute": 23,
			"messages": [
				{
					"owner": 1,
					"mes": "Киран Нолан[08](Галвэй Юнайтед) борется за позицию..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 19
					},
					{
						"n": 2,
						"h": 86,
						"w": 191
					},
					{
						"n": 3,
						"h": 162,
						"w": 174
					},
					{
						"n": 4,
						"h": 277,
						"w": 179
					},
					{
						"n": 5,
						"h": 375,
						"w": 242
					},
					{
						"n": 6,
						"h": 41,
						"w": 293
					},
					{
						"n": 7,
						"h": 200,
						"w": 207
					},
					{
						"n": 8,
						"h": 274,
						"w": 257
					},
					{
						"n": 9,
						"h": 377,
						"w": 196
					},
					{
						"n": 10,
						"h": 169,
						"w": 468
					},
					{
						"n": 11,
						"h": 289,
						"w": 492
					}
				],
				"away": [
					{
						"n": 1,
						"h": 229,
						"w": 71
					},
					{
						"n": 2,
						"h": 105,
						"w": 235
					},
					{
						"n": 3,
						"h": 173,
						"w": 230
					},
					{
						"n": 4,
						"h": 268,
						"w": 238
					},
					{
						"n": 5,
						"h": 340,
						"w": 232
					},
					{
						"n": 6,
						"h": 224,
						"w": 312
					},
					{
						"n": 7,
						"h": 213,
						"w": 507
					},
					{
						"n": 8,
						"h": 181,
						"w": 448
					},
					{
						"n": 9,
						"h": 51,
						"w": 403
					},
					{
						"n": 10,
						"h": 160,
						"w": 506
					},
					{
						"n": 11,
						"h": 252,
						"w": 505
					}
				],
				"ball": {
					"n": 0,
					"h": 274,
					"w": 257,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 10
		},
		{
			"num": 495,
			"minute": 23,
			"messages": [
				{
					"owner": 1,
					"mes": "Пас С.Фридйонссону[05](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 13
					},
					{
						"n": 2,
						"h": 80,
						"w": 217
					},
					{
						"n": 3,
						"h": 177,
						"w": 182
					},
					{
						"n": 4,
						"h": 278,
						"w": 186
					},
					{
						"n": 5,
						"h": 356,
						"w": 253
					},
					{
						"n": 6,
						"h": 43,
						"w": 320
					},
					{
						"n": 7,
						"h": 198,
						"w": 234
					},
					{
						"n": 8,
						"h": 278,
						"w": 284
					},
					{
						"n": 9,
						"h": 391,
						"w": 219
					},
					{
						"n": 10,
						"h": 179,
						"w": 482
					},
					{
						"n": 11,
						"h": 298,
						"w": 492
					}
				],
				"away": [
					{
						"n": 1,
						"h": 205,
						"w": 76
					},
					{
						"n": 2,
						"h": 110,
						"w": 221
					},
					{
						"n": 3,
						"h": 172,
						"w": 220
					},
					{
						"n": 4,
						"h": 252,
						"w": 217
					},
					{
						"n": 5,
						"h": 340,
						"w": 229
					},
					{
						"n": 6,
						"h": 198,
						"w": 305
					},
					{
						"n": 7,
						"h": 210,
						"w": 481
					},
					{
						"n": 8,
						"h": 205,
						"w": 436
					},
					{
						"n": 9,
						"h": 30,
						"w": 386
					},
					{
						"n": 10,
						"h": 164,
						"w": 480
					},
					{
						"n": 11,
						"h": 252,
						"w": 478
					}
				],
				"ball": {
					"n": 0,
					"h": 356,
					"w": 253,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 27
		},
		{
			"num": 496,
			"minute": 23,
			"messages": [
				{
					"owner": 1,
					"mes": "Коротким пасом отдает на К.Нолана[08](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 19
					},
					{
						"n": 2,
						"h": 66,
						"w": 248
					},
					{
						"n": 3,
						"h": 168,
						"w": 208
					},
					{
						"n": 4,
						"h": 276,
						"w": 211
					},
					{
						"n": 5,
						"h": 366,
						"w": 253
					},
					{
						"n": 6,
						"h": 41,
						"w": 362
					},
					{
						"n": 7,
						"h": 187,
						"w": 274
					},
					{
						"n": 8,
						"h": 284,
						"w": 326
					},
					{
						"n": 9,
						"h": 390,
						"w": 261
					},
					{
						"n": 10,
						"h": 157,
						"w": 491
					},
					{
						"n": 11,
						"h": 281,
						"w": 503
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 71
					},
					{
						"n": 2,
						"h": 110,
						"w": 208
					},
					{
						"n": 3,
						"h": 184,
						"w": 216
					},
					{
						"n": 4,
						"h": 274,
						"w": 213
					},
					{
						"n": 5,
						"h": 340,
						"w": 219
					},
					{
						"n": 6,
						"h": 181,
						"w": 344
					},
					{
						"n": 7,
						"h": 214,
						"w": 439
					},
					{
						"n": 8,
						"h": 224,
						"w": 424
					},
					{
						"n": 9,
						"h": 22,
						"w": 367
					},
					{
						"n": 10,
						"h": 165,
						"w": 438
					},
					{
						"n": 11,
						"h": 261,
						"w": 437
					}
				],
				"ball": {
					"n": 0,
					"h": 284,
					"w": 326,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 42
		},
		{
			"num": 497,
			"minute": 24,
			"possession": 41,
			"messages": [
				{
					"owner": 1,
					"mes": "Передача вперед..."
				},
				{
					"owner": 1,
					"mes": "Джо Квигли[10](Галвэй Юнайтед) получил мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 15,
						"f": 97
					},
					{
						"n": 2,
						"h": 65,
						"w": 287,
						"f": 92
					},
					{
						"n": 3,
						"h": 184,
						"w": 238
					},
					{
						"n": 4,
						"h": 274,
						"w": 221
					},
					{
						"n": 5,
						"h": 383,
						"w": 272
					},
					{
						"n": 6,
						"h": 39,
						"w": 419
					},
					{
						"n": 7,
						"h": 176,
						"w": 330,
						"f": 92
					},
					{
						"n": 8,
						"h": 285,
						"w": 343,
						"f": 91
					},
					{
						"n": 9,
						"h": 389,
						"w": 318
					},
					{
						"n": 10,
						"h": 138,
						"w": 416,
						"f": 91
					},
					{
						"n": 11,
						"h": 274,
						"w": 512,
						"f": 92
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 72,
						"f": 92
					},
					{
						"n": 2,
						"h": 110,
						"w": 169
					},
					{
						"n": 3,
						"h": 177,
						"w": 172,
						"f": 92
					},
					{
						"n": 4,
						"h": 282,
						"w": 156
					},
					{
						"n": 5,
						"h": 322,
						"w": 273
					},
					{
						"n": 6,
						"h": 174,
						"w": 287,
						"f": 92
					},
					{
						"n": 7,
						"h": 215,
						"w": 382
					},
					{
						"n": 8,
						"h": 270,
						"w": 391
					},
					{
						"n": 9,
						"h": 44,
						"w": 322
					},
					{
						"n": 10,
						"h": 167,
						"w": 381
					},
					{
						"n": 11,
						"h": 272,
						"w": 381
					}
				],
				"ball": {
					"n": 0,
					"h": 138,
					"w": 416,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 57
		},
		{
			"num": 498,
			"minute": 24,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 19
					},
					{
						"n": 2,
						"h": 75,
						"w": 297
					},
					{
						"n": 3,
						"h": 167,
						"w": 246
					},
					{
						"n": 4,
						"h": 283,
						"w": 248
					},
					{
						"n": 5,
						"h": 378,
						"w": 304
					},
					{
						"n": 6,
						"h": 47,
						"w": 458
					},
					{
						"n": 7,
						"h": 174,
						"w": 370
					},
					{
						"n": 8,
						"h": 285,
						"w": 383
					},
					{
						"n": 9,
						"h": 393,
						"w": 358
					},
					{
						"n": 10,
						"h": 155,
						"w": 447
					},
					{
						"n": 11,
						"h": 278,
						"w": 552
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 75
					},
					{
						"n": 2,
						"h": 110,
						"w": 129
					},
					{
						"n": 3,
						"h": 171,
						"w": 132
					},
					{
						"n": 4,
						"h": 243,
						"w": 148
					},
					{
						"n": 5,
						"h": 291,
						"w": 253
					},
					{
						"n": 6,
						"h": 174,
						"w": 247
					},
					{
						"n": 7,
						"h": 215,
						"w": 342
					},
					{
						"n": 8,
						"h": 295,
						"w": 360
					},
					{
						"n": 9,
						"h": 57,
						"w": 326
					},
					{
						"n": 10,
						"h": 166,
						"w": 341
					},
					{
						"n": 11,
						"h": 275,
						"w": 341
					}
				],
				"ball": {
					"n": 0,
					"h": 155,
					"w": 447,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 499,
			"minute": 24,
			"messages": [
				{
					"owner": 1,
					"mes": "Пас налево на К.Колмана[06](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 15
					},
					{
						"n": 2,
						"h": 72,
						"w": 316
					},
					{
						"n": 3,
						"h": 179,
						"w": 269
					},
					{
						"n": 4,
						"h": 269,
						"w": 278
					},
					{
						"n": 5,
						"h": 387,
						"w": 318
					},
					{
						"n": 6,
						"h": 41,
						"w": 508
					},
					{
						"n": 7,
						"h": 149,
						"w": 368
					},
					{
						"n": 8,
						"h": 239,
						"w": 364
					},
					{
						"n": 9,
						"h": 398,
						"w": 408
					},
					{
						"n": 10,
						"h": 155,
						"w": 467
					},
					{
						"n": 11,
						"h": 282,
						"w": 591
					}
				],
				"away": [
					{
						"n": 1,
						"h": 245,
						"w": 76
					},
					{
						"n": 2,
						"h": 110,
						"w": 98
					},
					{
						"n": 3,
						"h": 187,
						"w": 100
					},
					{
						"n": 4,
						"h": 273,
						"w": 108
					},
					{
						"n": 5,
						"h": 291,
						"w": 253
					},
					{
						"n": 6,
						"h": 218,
						"w": 223
					},
					{
						"n": 7,
						"h": 244,
						"w": 301
					},
					{
						"n": 8,
						"h": 312,
						"w": 335
					},
					{
						"n": 9,
						"h": 54,
						"w": 276
					},
					{
						"n": 10,
						"h": 211,
						"w": 336
					},
					{
						"n": 11,
						"h": 301,
						"w": 332
					}
				],
				"ball": {
					"n": 0,
					"h": 60,
					"w": 563,
					"z": 0,
					"r": 0,
					"p": 2,
					"x": 0
				}
			},
			"interval": 50
		},
		{
			"num": 500,
			"minute": 24,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 12
					},
					{
						"n": 2,
						"h": 71,
						"w": 346
					},
					{
						"n": 3,
						"h": 174,
						"w": 299
					},
					{
						"n": 4,
						"h": 283,
						"w": 301
					},
					{
						"n": 5,
						"h": 383,
						"w": 348
					},
					{
						"n": 6,
						"h": 38,
						"w": 538
					},
					{
						"n": 7,
						"h": 153,
						"w": 398
					},
					{
						"n": 8,
						"h": 237,
						"w": 394
					},
					{
						"n": 9,
						"h": 400,
						"w": 437
					},
					{
						"n": 10,
						"h": 159,
						"w": 491
					},
					{
						"n": 11,
						"h": 295,
						"w": 613
					}
				],
				"away": [
					{
						"n": 1,
						"h": 241,
						"w": 46
					},
					{
						"n": 2,
						"h": 140,
						"w": 98
					},
					{
						"n": 3,
						"h": 202,
						"w": 86
					},
					{
						"n": 4,
						"h": 303,
						"w": 110
					},
					{
						"n": 5,
						"h": 306,
						"w": 227
					},
					{
						"n": 6,
						"h": 241,
						"w": 204
					},
					{
						"n": 7,
						"h": 243,
						"w": 271
					},
					{
						"n": 8,
						"h": 330,
						"w": 311
					},
					{
						"n": 9,
						"h": 50,
						"w": 247
					},
					{
						"n": 10,
						"h": 213,
						"w": 306
					},
					{
						"n": 11,
						"h": 297,
						"w": 302
					}
				],
				"ball": {
					"n": 0,
					"h": 32,
					"w": 598,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 30
		},
		{
			"num": 501,
			"minute": 24,
			"messages": [
				{
					"owner": 1,
					"mes": "Киэн Колман[06](Галвэй Юнайтед) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 11
					},
					{
						"n": 2,
						"h": 64,
						"w": 370
					},
					{
						"n": 3,
						"h": 184,
						"w": 310
					},
					{
						"n": 4,
						"h": 283,
						"w": 325
					},
					{
						"n": 5,
						"h": 373,
						"w": 371
					},
					{
						"n": 6,
						"h": 32,
						"w": 598
					},
					{
						"n": 7,
						"h": 149,
						"w": 458
					},
					{
						"n": 8,
						"h": 235,
						"w": 454
					},
					{
						"n": 9,
						"h": 397,
						"w": 497
					},
					{
						"n": 10,
						"h": 164,
						"w": 551
					},
					{
						"n": 11,
						"h": 286,
						"w": 633
					}
				],
				"away": [
					{
						"n": 1,
						"h": 238,
						"w": 8
					},
					{
						"n": 2,
						"h": 194,
						"w": 72
					},
					{
						"n": 3,
						"h": 260,
						"w": 74
					},
					{
						"n": 4,
						"h": 335,
						"w": 102
					},
					{
						"n": 5,
						"h": 325,
						"w": 170
					},
					{
						"n": 6,
						"h": 272,
						"w": 153
					},
					{
						"n": 7,
						"h": 240,
						"w": 211
					},
					{
						"n": 8,
						"h": 356,
						"w": 257
					},
					{
						"n": 9,
						"h": 53,
						"w": 187
					},
					{
						"n": 10,
						"h": 215,
						"w": 246
					},
					{
						"n": 11,
						"h": 284,
						"w": 305
					}
				],
				"ball": {
					"n": 0,
					"h": 32,
					"w": 598,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 60
		},
		{
			"num": 502,
			"minute": 24,
			"messages": [
				{
					"owner": 1,
					"mes": "Киэн Колман[06](Галвэй Юнайтед) смещается в центр..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 10
					},
					{
						"n": 2,
						"h": 64,
						"w": 373
					},
					{
						"n": 3,
						"h": 178,
						"w": 330
					},
					{
						"n": 4,
						"h": 270,
						"w": 322
					},
					{
						"n": 5,
						"h": 392,
						"w": 373
					},
					{
						"n": 6,
						"h": 78,
						"w": 610
					},
					{
						"n": 7,
						"h": 160,
						"w": 496
					},
					{
						"n": 8,
						"h": 249,
						"w": 445
					},
					{
						"n": 9,
						"h": 396,
						"w": 537
					},
					{
						"n": 10,
						"h": 161,
						"w": 591
					},
					{
						"n": 11,
						"h": 250,
						"w": 650
					}
				],
				"away": [
					{
						"n": 1,
						"h": 237,
						"w": 9
					},
					{
						"n": 2,
						"h": 211,
						"w": 48
					},
					{
						"n": 3,
						"h": 290,
						"w": 56
					},
					{
						"n": 4,
						"h": 357,
						"w": 90
					},
					{
						"n": 5,
						"h": 347,
						"w": 129
					},
					{
						"n": 6,
						"h": 296,
						"w": 126
					},
					{
						"n": 7,
						"h": 251,
						"w": 176
					},
					{
						"n": 8,
						"h": 371,
						"w": 220
					},
					{
						"n": 9,
						"h": 54,
						"w": 147
					},
					{
						"n": 10,
						"h": 201,
						"w": 255
					},
					{
						"n": 11,
						"h": 289,
						"w": 308
					}
				],
				"ball": {
					"n": 0,
					"h": 78,
					"w": 610,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 503,
			"minute": 24,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 18
					},
					{
						"n": 2,
						"h": 62,
						"w": 378
					},
					{
						"n": 3,
						"h": 172,
						"w": 320
					},
					{
						"n": 4,
						"h": 279,
						"w": 324
					},
					{
						"n": 5,
						"h": 389,
						"w": 371
					},
					{
						"n": 6,
						"h": 78,
						"w": 624
					},
					{
						"n": 7,
						"h": 157,
						"w": 513
					},
					{
						"n": 8,
						"h": 250,
						"w": 462
					},
					{
						"n": 9,
						"h": 399,
						"w": 554
					},
					{
						"n": 10,
						"h": 156,
						"w": 607
					},
					{
						"n": 11,
						"h": 235,
						"w": 647
					}
				],
				"away": [
					{
						"n": 1,
						"h": 238,
						"w": 8
					},
					{
						"n": 2,
						"h": 213,
						"w": 44
					},
					{
						"n": 3,
						"h": 281,
						"w": 45
					},
					{
						"n": 4,
						"h": 372,
						"w": 96
					},
					{
						"n": 5,
						"h": 354,
						"w": 110
					},
					{
						"n": 6,
						"h": 297,
						"w": 105
					},
					{
						"n": 7,
						"h": 237,
						"w": 166
					},
					{
						"n": 8,
						"h": 371,
						"w": 220
					},
					{
						"n": 9,
						"h": 51,
						"w": 130
					},
					{
						"n": 10,
						"h": 200,
						"w": 238
					},
					{
						"n": 11,
						"h": 279,
						"w": 310
					}
				],
				"ball": {
					"n": 0,
					"h": 78,
					"w": 624,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 17
		},
		{
			"num": 504,
			"minute": 24,
			"messages": [
				{
					"owner": 1,
					"mes": "С.Пейша[24](Опава) вступает в единоборство с К.Колманом[06](Галвэй Юнайтед)..."
				},
				{
					"owner": 1,
					"mes": "Прекрасную технику демонстрирует Киэн Колман[06](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 16
					},
					{
						"n": 2,
						"h": 70,
						"w": 379
					},
					{
						"n": 3,
						"h": 172,
						"w": 325
					},
					{
						"n": 4,
						"h": 285,
						"w": 325
					},
					{
						"n": 5,
						"h": 375,
						"w": 379
					},
					{
						"n": 6,
						"h": 78,
						"w": 664,
						"m": 650
					},
					{
						"n": 7,
						"h": 143,
						"w": 550
					},
					{
						"n": 8,
						"h": 259,
						"w": 444
					},
					{
						"n": 9,
						"h": 404,
						"w": 594
					},
					{
						"n": 10,
						"h": 156,
						"w": 647
					},
					{
						"n": 11,
						"h": 223,
						"w": 654
					}
				],
				"away": [
					{
						"n": 1,
						"h": 239,
						"w": 5
					},
					{
						"n": 2,
						"h": 173,
						"w": 39
					},
					{
						"n": 3,
						"h": 246,
						"w": 41
					},
					{
						"n": 4,
						"h": 381,
						"w": 100,
						"m": 670
					},
					{
						"n": 5,
						"h": 363,
						"w": 64
					},
					{
						"n": 6,
						"h": 299,
						"w": 70
					},
					{
						"n": 7,
						"h": 242,
						"w": 157
					},
					{
						"n": 8,
						"h": 387,
						"w": 187
					},
					{
						"n": 9,
						"h": 46,
						"w": 90
					},
					{
						"n": 10,
						"h": 191,
						"w": 256
					},
					{
						"n": 11,
						"h": 293,
						"w": 293
					}
				],
				"ball": {
					"n": 0,
					"h": 78,
					"w": 664,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 505,
			"minute": 24,
			"messages": [
				{
					"owner": 1,
					"mes": "К.Колман[06](Галвэй Юнайтед) врывается в штрафную..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 12
					},
					{
						"n": 2,
						"h": 63,
						"w": 361
					},
					{
						"n": 3,
						"h": 165,
						"w": 329
					},
					{
						"n": 4,
						"h": 265,
						"w": 312
					},
					{
						"n": 5,
						"h": 376,
						"w": 368
					},
					{
						"n": 6,
						"h": 108,
						"w": 690
					},
					{
						"n": 7,
						"h": 161,
						"w": 579
					},
					{
						"n": 8,
						"h": 264,
						"w": 478
					},
					{
						"n": 9,
						"h": 409,
						"w": 627
					},
					{
						"n": 10,
						"h": 165,
						"w": 678
					},
					{
						"n": 11,
						"h": 253,
						"w": 669
					}
				],
				"away": [
					{
						"n": 1,
						"h": 240,
						"w": 4
					},
					{
						"n": 2,
						"h": 203,
						"w": 36
					},
					{
						"n": 3,
						"h": 231,
						"w": 35
					},
					{
						"n": 4,
						"h": 355,
						"w": 79
					},
					{
						"n": 5,
						"h": 337,
						"w": 34
					},
					{
						"n": 6,
						"h": 328,
						"w": 38
					},
					{
						"n": 7,
						"h": 253,
						"w": 125
					},
					{
						"n": 8,
						"h": 395,
						"w": 175
					},
					{
						"n": 9,
						"h": 44,
						"w": 57
					},
					{
						"n": 10,
						"h": 186,
						"w": 222
					},
					{
						"n": 11,
						"h": 293,
						"w": 291
					}
				],
				"ball": {
					"n": 0,
					"h": 108,
					"w": 690,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 34
		},
		{
			"num": 506,
			"minute": 24,
			"messages": [
				{
					"owner": 1,
					"mes": "К.Колман[06](Галвэй Юнайтед) катит мяч на Д.Квигли[10](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 19
					},
					{
						"n": 2,
						"h": 62,
						"w": 374
					},
					{
						"n": 3,
						"h": 171,
						"w": 314
					},
					{
						"n": 4,
						"h": 268,
						"w": 328
					},
					{
						"n": 5,
						"h": 373,
						"w": 379
					},
					{
						"n": 6,
						"h": 105,
						"w": 681
					},
					{
						"n": 7,
						"h": 167,
						"w": 581
					},
					{
						"n": 8,
						"h": 274,
						"w": 459
					},
					{
						"n": 9,
						"h": 402,
						"w": 640
					},
					{
						"n": 10,
						"h": 152,
						"w": 692
					},
					{
						"n": 11,
						"h": 272,
						"w": 680
					}
				],
				"away": [
					{
						"n": 1,
						"h": 239,
						"w": 5
					},
					{
						"n": 2,
						"h": 195,
						"w": 35
					},
					{
						"n": 3,
						"h": 251,
						"w": 28
					},
					{
						"n": 4,
						"h": 333,
						"w": 73
					},
					{
						"n": 5,
						"h": 315,
						"w": 35
					},
					{
						"n": 6,
						"h": 302,
						"w": 28
					},
					{
						"n": 7,
						"h": 236,
						"w": 139
					},
					{
						"n": 8,
						"h": 401,
						"w": 154
					},
					{
						"n": 9,
						"h": 64,
						"w": 55
					},
					{
						"n": 10,
						"h": 176,
						"w": 241
					},
					{
						"n": 11,
						"h": 284,
						"w": 299
					}
				],
				"ball": {
					"n": 0,
					"h": 152,
					"w": 692,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 22
		},
		{
			"num": 507,
			"minute": 24,
			"messages": [
				{
					"owner": 1,
					"mes": "Джо Квигли[10](Галвэй Юнайтед) укрывает мяч корпусом..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 13
					},
					{
						"n": 2,
						"h": 67,
						"w": 365
					},
					{
						"n": 3,
						"h": 178,
						"w": 321
					},
					{
						"n": 4,
						"h": 274,
						"w": 320
					},
					{
						"n": 5,
						"h": 372,
						"w": 369
					},
					{
						"n": 6,
						"h": 100,
						"w": 672
					},
					{
						"n": 7,
						"h": 166,
						"w": 591
					},
					{
						"n": 8,
						"h": 284,
						"w": 455
					},
					{
						"n": 9,
						"h": 395,
						"w": 640
					},
					{
						"n": 10,
						"h": 162,
						"w": 692
					},
					{
						"n": 11,
						"h": 277,
						"w": 672
					}
				],
				"away": [
					{
						"n": 1,
						"h": 239,
						"w": 6
					},
					{
						"n": 2,
						"h": 185,
						"w": 35
					},
					{
						"n": 3,
						"h": 260,
						"w": 23
					},
					{
						"n": 4,
						"h": 324,
						"w": 70
					},
					{
						"n": 5,
						"h": 305,
						"w": 35
					},
					{
						"n": 6,
						"h": 299,
						"w": 27
					},
					{
						"n": 7,
						"h": 235,
						"w": 149
					},
					{
						"n": 8,
						"h": 405,
						"w": 144
					},
					{
						"n": 9,
						"h": 62,
						"w": 65
					},
					{
						"n": 10,
						"h": 166,
						"w": 245
					},
					{
						"n": 11,
						"h": 292,
						"w": 306
					}
				],
				"ball": {
					"n": 0,
					"h": 162,
					"w": 692,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 10
		},
		{
			"num": 508,
			"minute": 24,
			"messages": [
				{
					"owner": 1,
					"mes": "Джо Квигли[10](Галвэй Юнайтед) с острого угла пытается обвести К.Ласака[21](Опава)..."
				},
				{
					"owner": 1,
					"mes": "Крыштоф Ласак[21](Опава) бросается влево...  но не достает... мяч проходит мимо ворот!"
				}
			],
			"U": {
				"team": 1,
				"player": 10,
				"xg": "0.09"
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 18
					},
					{
						"n": 2,
						"h": 59,
						"w": 380
					},
					{
						"n": 3,
						"h": 166,
						"w": 327
					},
					{
						"n": 4,
						"h": 273,
						"w": 321
					},
					{
						"n": 5,
						"h": 380,
						"w": 371
					},
					{
						"n": 6,
						"h": 90,
						"w": 660
					},
					{
						"n": 7,
						"h": 173,
						"w": 575
					},
					{
						"n": 8,
						"h": 283,
						"w": 494
					},
					{
						"n": 9,
						"h": 394,
						"w": 640
					},
					{
						"n": 10,
						"h": 162,
						"w": 692,
						"m": 730
					},
					{
						"n": 11,
						"h": 297,
						"w": 692
					}
				],
				"away": [
					{
						"n": 1,
						"h": 205,
						"w": 6
					},
					{
						"n": 2,
						"h": 153,
						"w": 19
					},
					{
						"n": 3,
						"h": 270,
						"w": 18
					},
					{
						"n": 4,
						"h": 277,
						"w": 63
					},
					{
						"n": 5,
						"h": 259,
						"w": 34
					},
					{
						"n": 6,
						"h": 283,
						"w": 26
					},
					{
						"n": 7,
						"h": 229,
						"w": 170
					},
					{
						"n": 8,
						"h": 426,
						"w": 140
					},
					{
						"n": 9,
						"h": 59,
						"w": 104
					},
					{
						"n": 10,
						"h": 167,
						"w": 206
					},
					{
						"n": 11,
						"h": 275,
						"w": 294
					}
				],
				"ball": {
					"n": 0,
					"h": 350,
					"w": 750,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 6
				}
			},
			"interval": 39
		},
		{
			"num": 509,
			"minute": 25,
			"possession": 42,
			"messages": [
				{
					"owner": 2,
					"mes": "Удар от ворот..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 40
					},
					{
						"n": 2,
						"h": 82,
						"w": 176
					},
					{
						"n": 3,
						"h": 167,
						"w": 150,
						"f": 94
					},
					{
						"n": 4,
						"h": 272,
						"w": 150
					},
					{
						"n": 5,
						"h": 385,
						"w": 179,
						"f": 92
					},
					{
						"n": 6,
						"h": 79,
						"w": 277
					},
					{
						"n": 7,
						"h": 166,
						"w": 250
					},
					{
						"n": 8,
						"h": 289,
						"w": 250
					},
					{
						"n": 9,
						"h": 368,
						"w": 274,
						"f": 91,
						"m": 700
					},
					{
						"n": 10,
						"h": 177,
						"w": 350
					},
					{
						"n": 11,
						"h": 272,
						"w": 350
					}
				],
				"away": [
					{
						"n": 1,
						"h": 190,
						"w": 14
					},
					{
						"n": 2,
						"h": 60,
						"w": 175
					},
					{
						"n": 3,
						"h": 154,
						"w": 175
					},
					{
						"n": 4,
						"h": 283,
						"w": 175,
						"f": 91
					},
					{
						"n": 5,
						"h": 388,
						"w": 175,
						"f": 91,
						"m": 630
					},
					{
						"n": 6,
						"h": 235,
						"w": 283
					},
					{
						"n": 7,
						"h": 218,
						"w": 392,
						"f": 93
					},
					{
						"n": 8,
						"h": 387,
						"w": 372,
						"f": 91
					},
					{
						"n": 9,
						"h": 65,
						"w": 422,
						"f": 91
					},
					{
						"n": 10,
						"h": 166,
						"w": 500
					},
					{
						"n": 11,
						"h": 285,
						"w": 500
					}
				],
				"ball": {
					"n": 0,
					"h": 260,
					"w": 686,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 150
		},
		{
			"num": 510,
			"minute": 25,
			"messages": [],
			"T": {
				"team": 2
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 40
					},
					{
						"n": 2,
						"h": 86,
						"w": 180
					},
					{
						"n": 3,
						"h": 164,
						"w": 157
					},
					{
						"n": 4,
						"h": 269,
						"w": 147
					},
					{
						"n": 5,
						"h": 383,
						"w": 175
					},
					{
						"n": 6,
						"h": 77,
						"w": 282
					},
					{
						"n": 7,
						"h": 159,
						"w": 254
					},
					{
						"n": 8,
						"h": 284,
						"w": 251
					},
					{
						"n": 9,
						"h": 369,
						"w": 277
					},
					{
						"n": 10,
						"h": 170,
						"w": 347
					},
					{
						"n": 11,
						"h": 272,
						"w": 357
					}
				],
				"away": [
					{
						"n": 1,
						"h": 190,
						"w": 34
					},
					{
						"n": 2,
						"h": 62,
						"w": 169
					},
					{
						"n": 3,
						"h": 153,
						"w": 181
					},
					{
						"n": 4,
						"h": 276,
						"w": 181
					},
					{
						"n": 5,
						"h": 386,
						"w": 174
					},
					{
						"n": 6,
						"h": 234,
						"w": 290
					},
					{
						"n": 7,
						"h": 211,
						"w": 393
					},
					{
						"n": 8,
						"h": 386,
						"w": 366
					},
					{
						"n": 9,
						"h": 72,
						"w": 428
					},
					{
						"n": 10,
						"h": 171,
						"w": 497
					},
					{
						"n": 11,
						"h": 289,
						"w": 494
					}
				],
				"ball": {
					"n": 0,
					"h": 260,
					"w": 686,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 15
		},
		{
			"num": 511,
			"minute": 25,
			"messages": [
				{
					"owner": 2,
					"mes": "Крыштоф Ласак[21](Опава) бьет далеко вперед..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 15
					},
					{
						"n": 2,
						"h": 79,
						"w": 206
					},
					{
						"n": 3,
						"h": 225,
						"w": 130
					},
					{
						"n": 4,
						"h": 288,
						"w": 137
					},
					{
						"n": 5,
						"h": 330,
						"w": 136
					},
					{
						"n": 6,
						"h": 24,
						"w": 305
					},
					{
						"n": 7,
						"h": 146,
						"w": 212
					},
					{
						"n": 8,
						"h": 283,
						"w": 208
					},
					{
						"n": 9,
						"h": 397,
						"w": 239
					},
					{
						"n": 10,
						"h": 144,
						"w": 400
					},
					{
						"n": 11,
						"h": 282,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 226,
						"w": 49
					},
					{
						"n": 2,
						"h": 57,
						"w": 223
					},
					{
						"n": 3,
						"h": 168,
						"w": 176
					},
					{
						"n": 4,
						"h": 277,
						"w": 170
					},
					{
						"n": 5,
						"h": 375,
						"w": 179
					},
					{
						"n": 6,
						"h": 266,
						"w": 296
					},
					{
						"n": 7,
						"h": 323,
						"w": 389
					},
					{
						"n": 8,
						"h": 426,
						"w": 415
					},
					{
						"n": 9,
						"h": 133,
						"w": 405
					},
					{
						"n": 10,
						"h": 159,
						"w": 480
					},
					{
						"n": 11,
						"h": 401,
						"w": 494
					}
				],
				"ball": {
					"n": 0,
					"h": 24,
					"w": 305,
					"z": 1,
					"r": 0,
					"p": 4,
					"x": 0
				}
			},
			"interval": 112
		},
		{
			"num": 512,
			"minute": 25,
			"messages": [
				{
					"owner": 2,
					"mes": "Даниэль Прохазка[28](Опава) прыгает выше, чем К.Колман[06](Галвэй Юнайтед) и скидывает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 14
					},
					{
						"n": 2,
						"h": 46,
						"w": 206
					},
					{
						"n": 3,
						"h": 192,
						"w": 128
					},
					{
						"n": 4,
						"h": 302,
						"w": 113
					},
					{
						"n": 5,
						"h": 338,
						"w": 121
					},
					{
						"n": 6,
						"h": 24,
						"w": 305,
						"m": 640
					},
					{
						"n": 7,
						"h": 157,
						"w": 205
					},
					{
						"n": 8,
						"h": 312,
						"w": 192
					},
					{
						"n": 9,
						"h": 424,
						"w": 221
					},
					{
						"n": 10,
						"h": 177,
						"w": 400
					},
					{
						"n": 11,
						"h": 315,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 73
					},
					{
						"n": 2,
						"h": 74,
						"w": 218
					},
					{
						"n": 3,
						"h": 173,
						"w": 172
					},
					{
						"n": 4,
						"h": 271,
						"w": 186
					},
					{
						"n": 5,
						"h": 377,
						"w": 188
					},
					{
						"n": 6,
						"h": 246,
						"w": 270
					},
					{
						"n": 7,
						"h": 339,
						"w": 418
					},
					{
						"n": 8,
						"h": 420,
						"w": 420,
						"m": 650
					},
					{
						"n": 9,
						"h": 166,
						"w": 407
					},
					{
						"n": 10,
						"h": 148,
						"w": 488
					},
					{
						"n": 11,
						"h": 412,
						"w": 514
					}
				],
				"ball": {
					"n": 0,
					"h": 38,
					"w": 206,
					"z": 1,
					"r": 0,
					"p": 4,
					"x": 0
				}
			},
			"interval": 33
		},
		{
			"num": 513,
			"minute": 25,
			"messages": [
				{
					"owner": 1,
					"mes": "Тимо Эверс[02](Галвэй Юнайтед) перепрыгивает Ш.Товарека[31](Опава) и скидывает мяч..."
				},
				{
					"owner": 1,
					"mes": "Киэн Колман[06](Галвэй Юнайтед) технично принимает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 11
					},
					{
						"n": 2,
						"h": 48,
						"w": 203
					},
					{
						"n": 3,
						"h": 224,
						"w": 129
					},
					{
						"n": 4,
						"h": 304,
						"w": 117
					},
					{
						"n": 5,
						"h": 348,
						"w": 122
					},
					{
						"n": 6,
						"h": 28,
						"w": 309
					},
					{
						"n": 7,
						"h": 191,
						"w": 211
					},
					{
						"n": 8,
						"h": 299,
						"w": 215
					},
					{
						"n": 9,
						"h": 390,
						"w": 221
					},
					{
						"n": 10,
						"h": 170,
						"w": 400
					},
					{
						"n": 11,
						"h": 322,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 90
					},
					{
						"n": 2,
						"h": 74,
						"w": 218
					},
					{
						"n": 3,
						"h": 179,
						"w": 179
					},
					{
						"n": 4,
						"h": 280,
						"w": 185
					},
					{
						"n": 5,
						"h": 391,
						"w": 202
					},
					{
						"n": 6,
						"h": 213,
						"w": 281
					},
					{
						"n": 7,
						"h": 305,
						"w": 423
					},
					{
						"n": 8,
						"h": 420,
						"w": 454
					},
					{
						"n": 9,
						"h": 134,
						"w": 414
					},
					{
						"n": 10,
						"h": 144,
						"w": 495
					},
					{
						"n": 11,
						"h": 412,
						"w": 510
					}
				],
				"ball": {
					"n": 0,
					"h": 28,
					"w": 309,
					"z": 1,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 34
		},
		{
			"num": 514,
			"minute": 25,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 13
					},
					{
						"n": 2,
						"h": 69,
						"w": 237
					},
					{
						"n": 3,
						"h": 199,
						"w": 160
					},
					{
						"n": 4,
						"h": 289,
						"w": 154
					},
					{
						"n": 5,
						"h": 356,
						"w": 161
					},
					{
						"n": 6,
						"h": 53,
						"w": 334
					},
					{
						"n": 7,
						"h": 177,
						"w": 248
					},
					{
						"n": 8,
						"h": 283,
						"w": 252
					},
					{
						"n": 9,
						"h": 391,
						"w": 261
					},
					{
						"n": 10,
						"h": 159,
						"w": 438
					},
					{
						"n": 11,
						"h": 308,
						"w": 487
					}
				],
				"away": [
					{
						"n": 1,
						"h": 245,
						"w": 70
					},
					{
						"n": 2,
						"h": 103,
						"w": 191
					},
					{
						"n": 3,
						"h": 178,
						"w": 178
					},
					{
						"n": 4,
						"h": 259,
						"w": 161
					},
					{
						"n": 5,
						"h": 386,
						"w": 242
					},
					{
						"n": 6,
						"h": 247,
						"w": 259
					},
					{
						"n": 7,
						"h": 292,
						"w": 385
					},
					{
						"n": 8,
						"h": 418,
						"w": 414
					},
					{
						"n": 9,
						"h": 169,
						"w": 395
					},
					{
						"n": 10,
						"h": 162,
						"w": 459
					},
					{
						"n": 11,
						"h": 393,
						"w": 474
					}
				],
				"ball": {
					"n": 0,
					"h": 53,
					"w": 334,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 515,
			"minute": 25,
			"messages": [
				{
					"owner": 1,
					"mes": "Киэн Колман[06](Галвэй Юнайтед) отдает пас П.Клинтону[03](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 10
					},
					{
						"n": 2,
						"h": 72,
						"w": 226
					},
					{
						"n": 3,
						"h": 182,
						"w": 173
					},
					{
						"n": 4,
						"h": 279,
						"w": 182
					},
					{
						"n": 5,
						"h": 371,
						"w": 211
					},
					{
						"n": 6,
						"h": 51,
						"w": 344,
						"m": 650
					},
					{
						"n": 7,
						"h": 168,
						"w": 299
					},
					{
						"n": 8,
						"h": 314,
						"w": 282
					},
					{
						"n": 9,
						"h": 396,
						"w": 313
					},
					{
						"n": 10,
						"h": 140,
						"w": 466
					},
					{
						"n": 11,
						"h": 296,
						"w": 479
					}
				],
				"away": [
					{
						"n": 1,
						"h": 221,
						"w": 72
					},
					{
						"n": 2,
						"h": 110,
						"w": 214
					},
					{
						"n": 3,
						"h": 173,
						"w": 228
					},
					{
						"n": 4,
						"h": 279,
						"w": 209
					},
					{
						"n": 5,
						"h": 360,
						"w": 238
					},
					{
						"n": 6,
						"h": 298,
						"w": 251
					},
					{
						"n": 7,
						"h": 249,
						"w": 355
					},
					{
						"n": 8,
						"h": 405,
						"w": 364
					},
					{
						"n": 9,
						"h": 118,
						"w": 386
					},
					{
						"n": 10,
						"h": 145,
						"w": 410
					},
					{
						"n": 11,
						"h": 358,
						"w": 436
					}
				],
				"ball": {
					"n": 0,
					"h": 182,
					"w": 173,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 52
		},
		{
			"num": 516,
			"minute": 25,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 14
					},
					{
						"n": 2,
						"h": 68,
						"w": 255
					},
					{
						"n": 3,
						"h": 165,
						"w": 204
					},
					{
						"n": 4,
						"h": 283,
						"w": 194
					},
					{
						"n": 5,
						"h": 384,
						"w": 249
					},
					{
						"n": 6,
						"h": 48,
						"w": 384
					},
					{
						"n": 7,
						"h": 164,
						"w": 339
					},
					{
						"n": 8,
						"h": 279,
						"w": 281
					},
					{
						"n": 9,
						"h": 395,
						"w": 353
					},
					{
						"n": 10,
						"h": 151,
						"w": 472
					},
					{
						"n": 11,
						"h": 271,
						"w": 500
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 74
					},
					{
						"n": 2,
						"h": 110,
						"w": 212
					},
					{
						"n": 3,
						"h": 199,
						"w": 208
					},
					{
						"n": 4,
						"h": 286,
						"w": 196
					},
					{
						"n": 5,
						"h": 340,
						"w": 215
					},
					{
						"n": 6,
						"h": 305,
						"w": 250
					},
					{
						"n": 7,
						"h": 234,
						"w": 322
					},
					{
						"n": 8,
						"h": 403,
						"w": 324
					},
					{
						"n": 9,
						"h": 81,
						"w": 370
					},
					{
						"n": 10,
						"h": 126,
						"w": 394
					},
					{
						"n": 11,
						"h": 320,
						"w": 425
					}
				],
				"ball": {
					"n": 0,
					"h": 165,
					"w": 204,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 517,
			"minute": 25,
			"messages": [
				{
					"owner": 1,
					"mes": "Патрик Клинтон[03](Галвэй Юнайтед) пасует на ход К.Нолану[08](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 11
					},
					{
						"n": 2,
						"h": 58,
						"w": 262
					},
					{
						"n": 3,
						"h": 165,
						"w": 204,
						"m": 630
					},
					{
						"n": 4,
						"h": 278,
						"w": 215
					},
					{
						"n": 5,
						"h": 382,
						"w": 269
					},
					{
						"n": 6,
						"h": 56,
						"w": 435
					},
					{
						"n": 7,
						"h": 168,
						"w": 391
					},
					{
						"n": 8,
						"h": 254,
						"w": 331
					},
					{
						"n": 9,
						"h": 401,
						"w": 404
					},
					{
						"n": 10,
						"h": 153,
						"w": 498
					},
					{
						"n": 11,
						"h": 284,
						"w": 524
					}
				],
				"away": [
					{
						"n": 1,
						"h": 229,
						"w": 78
					},
					{
						"n": 2,
						"h": 110,
						"w": 162
					},
					{
						"n": 3,
						"h": 178,
						"w": 170
					},
					{
						"n": 4,
						"h": 283,
						"w": 181
					},
					{
						"n": 5,
						"h": 340,
						"w": 164
					},
					{
						"n": 6,
						"h": 300,
						"w": 212
					},
					{
						"n": 7,
						"h": 222,
						"w": 292
					},
					{
						"n": 8,
						"h": 397,
						"w": 272
					},
					{
						"n": 9,
						"h": 46,
						"w": 332
					},
					{
						"n": 10,
						"h": 156,
						"w": 383
					},
					{
						"n": 11,
						"h": 293,
						"w": 380
					}
				],
				"ball": {
					"n": 0,
					"h": 254,
					"w": 331,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 52
		},
		{
			"num": 518,
			"minute": 25,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 13
					},
					{
						"n": 2,
						"h": 64,
						"w": 286
					},
					{
						"n": 3,
						"h": 184,
						"w": 235
					},
					{
						"n": 4,
						"h": 275,
						"w": 244
					},
					{
						"n": 5,
						"h": 372,
						"w": 297
					},
					{
						"n": 6,
						"h": 52,
						"w": 475
					},
					{
						"n": 7,
						"h": 166,
						"w": 431
					},
					{
						"n": 8,
						"h": 254,
						"w": 366
					},
					{
						"n": 9,
						"h": 396,
						"w": 444
					},
					{
						"n": 10,
						"h": 151,
						"w": 538
					},
					{
						"n": 11,
						"h": 276,
						"w": 558
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 73
					},
					{
						"n": 2,
						"h": 110,
						"w": 142
					},
					{
						"n": 3,
						"h": 190,
						"w": 146
					},
					{
						"n": 4,
						"h": 283,
						"w": 141
					},
					{
						"n": 5,
						"h": 340,
						"w": 143
					},
					{
						"n": 6,
						"h": 297,
						"w": 175
					},
					{
						"n": 7,
						"h": 202,
						"w": 326
					},
					{
						"n": 8,
						"h": 397,
						"w": 232
					},
					{
						"n": 9,
						"h": 42,
						"w": 292
					},
					{
						"n": 10,
						"h": 186,
						"w": 365
					},
					{
						"n": 11,
						"h": 287,
						"w": 340
					}
				],
				"ball": {
					"n": 0,
					"h": 254,
					"w": 366,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 519,
			"minute": 25,
			"messages": [
				{
					"owner": 1,
					"mes": "Пас вперед..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 15
					},
					{
						"n": 2,
						"h": 67,
						"w": 305
					},
					{
						"n": 3,
						"h": 169,
						"w": 256
					},
					{
						"n": 4,
						"h": 270,
						"w": 264
					},
					{
						"n": 5,
						"h": 389,
						"w": 316
					},
					{
						"n": 6,
						"h": 45,
						"w": 510
					},
					{
						"n": 7,
						"h": 191,
						"w": 457
					},
					{
						"n": 8,
						"h": 265,
						"w": 365
					},
					{
						"n": 9,
						"h": 368,
						"w": 458
					},
					{
						"n": 10,
						"h": 180,
						"w": 555
					},
					{
						"n": 11,
						"h": 270,
						"w": 579
					}
				],
				"away": [
					{
						"n": 1,
						"h": 205,
						"w": 75
					},
					{
						"n": 2,
						"h": 103,
						"w": 177
					},
					{
						"n": 3,
						"h": 190,
						"w": 110
					},
					{
						"n": 4,
						"h": 259,
						"w": 123
					},
					{
						"n": 5,
						"h": 340,
						"w": 110
					},
					{
						"n": 6,
						"h": 277,
						"w": 146
					},
					{
						"n": 7,
						"h": 197,
						"w": 321
					},
					{
						"n": 8,
						"h": 402,
						"w": 196
					},
					{
						"n": 9,
						"h": 55,
						"w": 268
					},
					{
						"n": 10,
						"h": 185,
						"w": 335
					},
					{
						"n": 11,
						"h": 277,
						"w": 307
					}
				],
				"ball": {
					"n": 0,
					"h": 312,
					"w": 456,
					"z": 0,
					"r": 0,
					"p": 1,
					"x": 0
				}
			},
			"interval": 36
		},
		{
			"num": 520,
			"minute": 25,
			"messages": [
				{
					"owner": 1,
					"mes": "Элвис Бвомоно[09](Галвэй Юнайтед) сбрасывает мяч себе на ход..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 10
					},
					{
						"n": 2,
						"h": 71,
						"w": 341
					},
					{
						"n": 3,
						"h": 182,
						"w": 290
					},
					{
						"n": 4,
						"h": 283,
						"w": 298
					},
					{
						"n": 5,
						"h": 375,
						"w": 335
					},
					{
						"n": 6,
						"h": 53,
						"w": 545
					},
					{
						"n": 7,
						"h": 159,
						"w": 473
					},
					{
						"n": 8,
						"h": 272,
						"w": 401
					},
					{
						"n": 9,
						"h": 327,
						"w": 479
					},
					{
						"n": 10,
						"h": 160,
						"w": 585
					},
					{
						"n": 11,
						"h": 294,
						"w": 606
					}
				],
				"away": [
					{
						"n": 1,
						"h": 205,
						"w": 64
					},
					{
						"n": 2,
						"h": 116,
						"w": 217
					},
					{
						"n": 3,
						"h": 174,
						"w": 97
					},
					{
						"n": 4,
						"h": 272,
						"w": 92
					},
					{
						"n": 5,
						"h": 340,
						"w": 86
					},
					{
						"n": 6,
						"h": 284,
						"w": 146
					},
					{
						"n": 7,
						"h": 209,
						"w": 287
					},
					{
						"n": 8,
						"h": 399,
						"w": 161
					},
					{
						"n": 9,
						"h": 75,
						"w": 268
					},
					{
						"n": 10,
						"h": 178,
						"w": 299
					},
					{
						"n": 11,
						"h": 280,
						"w": 303
					}
				],
				"ball": {
					"n": 0,
					"h": 327,
					"w": 479,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 36
		},
		{
			"num": 521,
			"minute": 25,
			"messages": [
				{
					"owner": 1,
					"mes": "Элвис Бвомоно[09](Галвэй Юнайтед) отдает на К.Нолана[08](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 10
					},
					{
						"n": 2,
						"h": 64,
						"w": 358
					},
					{
						"n": 3,
						"h": 184,
						"w": 308
					},
					{
						"n": 4,
						"h": 276,
						"w": 313
					},
					{
						"n": 5,
						"h": 387,
						"w": 361
					},
					{
						"n": 6,
						"h": 58,
						"w": 573
					},
					{
						"n": 7,
						"h": 172,
						"w": 498
					},
					{
						"n": 8,
						"h": 290,
						"w": 422
					},
					{
						"n": 9,
						"h": 332,
						"w": 488,
						"m": 690
					},
					{
						"n": 10,
						"h": 177,
						"w": 603
					},
					{
						"n": 11,
						"h": 278,
						"w": 603
					}
				],
				"away": [
					{
						"n": 1,
						"h": 217,
						"w": 38
					},
					{
						"n": 2,
						"h": 109,
						"w": 190
					},
					{
						"n": 3,
						"h": 191,
						"w": 100
					},
					{
						"n": 4,
						"h": 263,
						"w": 99
					},
					{
						"n": 5,
						"h": 340,
						"w": 103
					},
					{
						"n": 6,
						"h": 256,
						"w": 147
					},
					{
						"n": 7,
						"h": 216,
						"w": 260
					},
					{
						"n": 8,
						"h": 387,
						"w": 135
					},
					{
						"n": 9,
						"h": 69,
						"w": 296
					},
					{
						"n": 10,
						"h": 152,
						"w": 289
					},
					{
						"n": 11,
						"h": 275,
						"w": 300
					}
				],
				"ball": {
					"n": 0,
					"h": 298,
					"w": 431,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 28
		},
		{
			"num": 522,
			"minute": 25,
			"messages": [
				{
					"owner": 1,
					"mes": "Петр Крамарж[30](Опава) оказывается первым на мяче..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 12
					},
					{
						"n": 2,
						"h": 85,
						"w": 324
					},
					{
						"n": 3,
						"h": 189,
						"w": 301
					},
					{
						"n": 4,
						"h": 250,
						"w": 310
					},
					{
						"n": 5,
						"h": 361,
						"w": 366
					},
					{
						"n": 6,
						"h": 56,
						"w": 533
					},
					{
						"n": 7,
						"h": 175,
						"w": 458
					},
					{
						"n": 8,
						"h": 318,
						"w": 393
					},
					{
						"n": 9,
						"h": 359,
						"w": 458
					},
					{
						"n": 10,
						"h": 176,
						"w": 563
					},
					{
						"n": 11,
						"h": 278,
						"w": 563
					}
				],
				"away": [
					{
						"n": 1,
						"h": 223,
						"w": 17
					},
					{
						"n": 2,
						"h": 85,
						"w": 158
					},
					{
						"n": 3,
						"h": 172,
						"w": 109
					},
					{
						"n": 4,
						"h": 276,
						"w": 111
					},
					{
						"n": 5,
						"h": 380,
						"w": 101
					},
					{
						"n": 6,
						"h": 223,
						"w": 170
					},
					{
						"n": 7,
						"h": 201,
						"w": 283
					},
					{
						"n": 8,
						"h": 397,
						"w": 174
					},
					{
						"n": 9,
						"h": 80,
						"w": 334
					},
					{
						"n": 10,
						"h": 127,
						"w": 314,
						"m": 620
					},
					{
						"n": 11,
						"h": 256,
						"w": 335
					}
				],
				"ball": {
					"n": 0,
					"h": 323,
					"w": 406,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 523,
			"minute": 25,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 14
					},
					{
						"n": 2,
						"h": 86,
						"w": 322
					},
					{
						"n": 3,
						"h": 189,
						"w": 299
					},
					{
						"n": 4,
						"h": 250,
						"w": 308
					},
					{
						"n": 5,
						"h": 361,
						"w": 364
					},
					{
						"n": 6,
						"h": 55,
						"w": 531
					},
					{
						"n": 7,
						"h": 175,
						"w": 456
					},
					{
						"n": 8,
						"h": 319,
						"w": 395
					},
					{
						"n": 9,
						"h": 359,
						"w": 456
					},
					{
						"n": 10,
						"h": 176,
						"w": 561
					},
					{
						"n": 11,
						"h": 278,
						"w": 561
					}
				],
				"away": [
					{
						"n": 1,
						"h": 221,
						"w": 17
					},
					{
						"n": 2,
						"h": 83,
						"w": 157
					},
					{
						"n": 3,
						"h": 172,
						"w": 107
					},
					{
						"n": 4,
						"h": 276,
						"w": 109
					},
					{
						"n": 5,
						"h": 379,
						"w": 103
					},
					{
						"n": 6,
						"h": 224,
						"w": 172
					},
					{
						"n": 7,
						"h": 201,
						"w": 285
					},
					{
						"n": 8,
						"h": 397,
						"w": 176
					},
					{
						"n": 9,
						"h": 82,
						"w": 335
					},
					{
						"n": 10,
						"h": 127,
						"w": 316
					},
					{
						"n": 11,
						"h": 255,
						"w": 337
					}
				],
				"ball": {
					"n": 0,
					"h": 323,
					"w": 404,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 2
		},
		{
			"num": 524,
			"minute": 25,
			"messages": [
				{
					"owner": 2,
					"mes": "П.Крамарж[30](Опава) пытается пройти К.Нолана[08](Галвэй Юнайтед)..."
				},
				{
					"owner": 2,
					"mes": "Петр Крамарж[30](Опава) обыгрывает К.Нолана[08](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 12
					},
					{
						"n": 2,
						"h": 108,
						"w": 289
					},
					{
						"n": 3,
						"h": 203,
						"w": 278
					},
					{
						"n": 4,
						"h": 260,
						"w": 275
					},
					{
						"n": 5,
						"h": 336,
						"w": 333
					},
					{
						"n": 6,
						"h": 55,
						"w": 491
					},
					{
						"n": 7,
						"h": 177,
						"w": 416
					},
					{
						"n": 8,
						"h": 319,
						"w": 395,
						"m": 610
					},
					{
						"n": 9,
						"h": 368,
						"w": 438
					},
					{
						"n": 10,
						"h": 174,
						"w": 521
					},
					{
						"n": 11,
						"h": 290,
						"w": 523
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 16
					},
					{
						"n": 2,
						"h": 74,
						"w": 156
					},
					{
						"n": 3,
						"h": 163,
						"w": 96
					},
					{
						"n": 4,
						"h": 278,
						"w": 117
					},
					{
						"n": 5,
						"h": 379,
						"w": 130
					},
					{
						"n": 6,
						"h": 218,
						"w": 212
					},
					{
						"n": 7,
						"h": 222,
						"w": 319
					},
					{
						"n": 8,
						"h": 396,
						"w": 216
					},
					{
						"n": 9,
						"h": 82,
						"w": 375
					},
					{
						"n": 10,
						"h": 137,
						"w": 354,
						"m": 630
					},
					{
						"n": 11,
						"h": 239,
						"w": 374
					}
				],
				"ball": {
					"n": 0,
					"h": 313,
					"w": 366,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 525,
			"minute": 25,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 18
					},
					{
						"n": 2,
						"h": 119,
						"w": 250
					},
					{
						"n": 3,
						"h": 227,
						"w": 253
					},
					{
						"n": 4,
						"h": 299,
						"w": 264
					},
					{
						"n": 5,
						"h": 318,
						"w": 297
					},
					{
						"n": 6,
						"h": 57,
						"w": 451
					},
					{
						"n": 7,
						"h": 182,
						"w": 377
					},
					{
						"n": 8,
						"h": 327,
						"w": 356
					},
					{
						"n": 9,
						"h": 384,
						"w": 402
					},
					{
						"n": 10,
						"h": 178,
						"w": 481
					},
					{
						"n": 11,
						"h": 304,
						"w": 485
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 14
					},
					{
						"n": 2,
						"h": 67,
						"w": 174
					},
					{
						"n": 3,
						"h": 173,
						"w": 118
					},
					{
						"n": 4,
						"h": 268,
						"w": 114
					},
					{
						"n": 5,
						"h": 392,
						"w": 121
					},
					{
						"n": 6,
						"h": 223,
						"w": 239
					},
					{
						"n": 7,
						"h": 201,
						"w": 327
					},
					{
						"n": 8,
						"h": 396,
						"w": 256
					},
					{
						"n": 9,
						"h": 108,
						"w": 345
					},
					{
						"n": 10,
						"h": 133,
						"w": 389
					},
					{
						"n": 11,
						"h": 226,
						"w": 411
					}
				],
				"ball": {
					"n": 0,
					"h": 317,
					"w": 331,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 526,
			"minute": 25,
			"messages": [
				{
					"owner": 2,
					"mes": "Петр Крамарж[30](Опава) отпасовывает назад..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 19
					},
					{
						"n": 2,
						"h": 120,
						"w": 236
					},
					{
						"n": 3,
						"h": 222,
						"w": 235
					},
					{
						"n": 4,
						"h": 278,
						"w": 234
					},
					{
						"n": 5,
						"h": 327,
						"w": 247
					},
					{
						"n": 6,
						"h": 55,
						"w": 400
					},
					{
						"n": 7,
						"h": 182,
						"w": 326
					},
					{
						"n": 8,
						"h": 308,
						"w": 309
					},
					{
						"n": 9,
						"h": 387,
						"w": 351
					},
					{
						"n": 10,
						"h": 218,
						"w": 450
					},
					{
						"n": 11,
						"h": 318,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 10
					},
					{
						"n": 2,
						"h": 63,
						"w": 188
					},
					{
						"n": 3,
						"h": 179,
						"w": 142
					},
					{
						"n": 4,
						"h": 275,
						"w": 143
					},
					{
						"n": 5,
						"h": 384,
						"w": 153
					},
					{
						"n": 6,
						"h": 231,
						"w": 270
					},
					{
						"n": 7,
						"h": 186,
						"w": 316
					},
					{
						"n": 8,
						"h": 396,
						"w": 307
					},
					{
						"n": 9,
						"h": 112,
						"w": 387
					},
					{
						"n": 10,
						"h": 142,
						"w": 409
					},
					{
						"n": 11,
						"h": 231,
						"w": 455
					}
				],
				"ball": {
					"n": 0,
					"h": 219,
					"w": 450,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 51
		},
		{
			"num": 527,
			"minute": 25,
			"messages": [
				{
					"owner": 2,
					"mes": "Оливье Дюмон[26](Опава) укрывает мяч от соперника..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 17
					},
					{
						"n": 2,
						"h": 120,
						"w": 226
					},
					{
						"n": 3,
						"h": 221,
						"w": 225
					},
					{
						"n": 4,
						"h": 279,
						"w": 224
					},
					{
						"n": 5,
						"h": 328,
						"w": 237
					},
					{
						"n": 6,
						"h": 55,
						"w": 390
					},
					{
						"n": 7,
						"h": 185,
						"w": 316
					},
					{
						"n": 8,
						"h": 307,
						"w": 299
					},
					{
						"n": 9,
						"h": 391,
						"w": 342
					},
					{
						"n": 10,
						"h": 218,
						"w": 447
					},
					{
						"n": 11,
						"h": 320,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 20
					},
					{
						"n": 2,
						"h": 66,
						"w": 197
					},
					{
						"n": 3,
						"h": 177,
						"w": 152
					},
					{
						"n": 4,
						"h": 271,
						"w": 152
					},
					{
						"n": 5,
						"h": 380,
						"w": 162
					},
					{
						"n": 6,
						"h": 226,
						"w": 279
					},
					{
						"n": 7,
						"h": 188,
						"w": 326
					},
					{
						"n": 8,
						"h": 397,
						"w": 317
					},
					{
						"n": 9,
						"h": 122,
						"w": 387
					},
					{
						"n": 10,
						"h": 145,
						"w": 418
					},
					{
						"n": 11,
						"h": 229,
						"w": 465
					}
				],
				"ball": {
					"n": 0,
					"h": 224,
					"w": 441,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 10
		},
		{
			"num": 528,
			"minute": 26,
			"possession": 43,
			"messages": [
				{
					"owner": 2,
					"mes": "Оливье Дюмон[26](Опава) пасует Л.Седлачеку[22](Опава)..."
				},
				{
					"owner": 2,
					"mes": "Лука Седлачек[22](Опава) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 18
					},
					{
						"n": 2,
						"h": 120,
						"w": 256
					},
					{
						"n": 3,
						"h": 180,
						"w": 252
					},
					{
						"n": 4,
						"h": 277,
						"w": 259
					},
					{
						"n": 5,
						"h": 330,
						"w": 258
					},
					{
						"n": 6,
						"h": 37,
						"w": 360,
						"f": 91
					},
					{
						"n": 7,
						"h": 206,
						"w": 355
					},
					{
						"n": 8,
						"h": 277,
						"w": 351,
						"f": 90
					},
					{
						"n": 9,
						"h": 387,
						"w": 310
					},
					{
						"n": 10,
						"h": 158,
						"w": 450,
						"m": 740
					},
					{
						"n": 11,
						"h": 305,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 39
					},
					{
						"n": 2,
						"h": 66,
						"w": 197,
						"f": 89,
						"c": 1
					},
					{
						"n": 3,
						"h": 163,
						"w": 162
					},
					{
						"n": 4,
						"h": 292,
						"w": 162
					},
					{
						"n": 5,
						"h": 402,
						"w": 162
					},
					{
						"n": 6,
						"h": 224,
						"w": 269
					},
					{
						"n": 7,
						"h": 231,
						"w": 301
					},
					{
						"n": 8,
						"h": 410,
						"w": 301
					},
					{
						"n": 9,
						"h": 63,
						"w": 375
					},
					{
						"n": 10,
						"h": 161,
						"w": 440,
						"f": 90
					},
					{
						"n": 11,
						"h": 283,
						"w": 440,
						"f": 90
					}
				],
				"ball": {
					"n": 0,
					"h": 384,
					"w": 523,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 60
		},
		{
			"num": 529,
			"minute": 26,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 12
					},
					{
						"n": 2,
						"h": 120,
						"w": 226
					},
					{
						"n": 3,
						"h": 167,
						"w": 214
					},
					{
						"n": 4,
						"h": 270,
						"w": 227
					},
					{
						"n": 5,
						"h": 330,
						"w": 232
					},
					{
						"n": 6,
						"h": 56,
						"w": 380
					},
					{
						"n": 7,
						"h": 209,
						"w": 315
					},
					{
						"n": 8,
						"h": 300,
						"w": 318
					},
					{
						"n": 9,
						"h": 394,
						"w": 304
					},
					{
						"n": 10,
						"h": 162,
						"w": 410
					},
					{
						"n": 11,
						"h": 344,
						"w": 458
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 57
					},
					{
						"n": 2,
						"h": 55,
						"w": 231
					},
					{
						"n": 3,
						"h": 158,
						"w": 172
					},
					{
						"n": 4,
						"h": 287,
						"w": 172
					},
					{
						"n": 5,
						"h": 408,
						"w": 172
					},
					{
						"n": 6,
						"h": 216,
						"w": 248
					},
					{
						"n": 7,
						"h": 217,
						"w": 325
					},
					{
						"n": 8,
						"h": 409,
						"w": 325
					},
					{
						"n": 9,
						"h": 37,
						"w": 401
					},
					{
						"n": 10,
						"h": 162,
						"w": 478
					},
					{
						"n": 11,
						"h": 295,
						"w": 478
					}
				],
				"ball": {
					"n": 0,
					"h": 395,
					"w": 489,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 530,
			"minute": 26,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 13
					},
					{
						"n": 2,
						"h": 120,
						"w": 187
					},
					{
						"n": 3,
						"h": 171,
						"w": 175
					},
					{
						"n": 4,
						"h": 274,
						"w": 188
					},
					{
						"n": 5,
						"h": 330,
						"w": 193
					},
					{
						"n": 6,
						"h": 56,
						"w": 341
					},
					{
						"n": 7,
						"h": 209,
						"w": 276
					},
					{
						"n": 8,
						"h": 294,
						"w": 279
					},
					{
						"n": 9,
						"h": 394,
						"w": 265
					},
					{
						"n": 10,
						"h": 166,
						"w": 400
					},
					{
						"n": 11,
						"h": 380,
						"w": 444
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 82
					},
					{
						"n": 2,
						"h": 50,
						"w": 265
					},
					{
						"n": 3,
						"h": 167,
						"w": 210
					},
					{
						"n": 4,
						"h": 284,
						"w": 210
					},
					{
						"n": 5,
						"h": 394,
						"w": 208
					},
					{
						"n": 6,
						"h": 206,
						"w": 286
					},
					{
						"n": 7,
						"h": 213,
						"w": 364
					},
					{
						"n": 8,
						"h": 411,
						"w": 364
					},
					{
						"n": 9,
						"h": 33,
						"w": 440
					},
					{
						"n": 10,
						"h": 142,
						"w": 512
					},
					{
						"n": 11,
						"h": 289,
						"w": 517
					}
				],
				"ball": {
					"n": 0,
					"h": 400,
					"w": 455,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 531,
			"minute": 26,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 12
					},
					{
						"n": 2,
						"h": 120,
						"w": 147
					},
					{
						"n": 3,
						"h": 184,
						"w": 137
					},
					{
						"n": 4,
						"h": 283,
						"w": 149
					},
					{
						"n": 5,
						"h": 330,
						"w": 153
					},
					{
						"n": 6,
						"h": 56,
						"w": 301
					},
					{
						"n": 7,
						"h": 207,
						"w": 236
					},
					{
						"n": 8,
						"h": 302,
						"w": 240
					},
					{
						"n": 9,
						"h": 394,
						"w": 225
					},
					{
						"n": 10,
						"h": 175,
						"w": 400
					},
					{
						"n": 11,
						"h": 408,
						"w": 415
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 105
					},
					{
						"n": 2,
						"h": 33,
						"w": 295
					},
					{
						"n": 3,
						"h": 168,
						"w": 250
					},
					{
						"n": 4,
						"h": 275,
						"w": 249
					},
					{
						"n": 5,
						"h": 388,
						"w": 247
					},
					{
						"n": 6,
						"h": 199,
						"w": 325
					},
					{
						"n": 7,
						"h": 209,
						"w": 403
					},
					{
						"n": 8,
						"h": 413,
						"w": 404
					},
					{
						"n": 9,
						"h": 28,
						"w": 480
					},
					{
						"n": 10,
						"h": 133,
						"w": 551
					},
					{
						"n": 11,
						"h": 279,
						"w": 555
					}
				],
				"ball": {
					"n": 0,
					"h": 417,
					"w": 425,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 532,
			"minute": 26,
			"messages": [
				{
					"owner": 2,
					"mes": "Пас вперед..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 16
					},
					{
						"n": 2,
						"h": 120,
						"w": 134
					},
					{
						"n": 3,
						"h": 178,
						"w": 146
					},
					{
						"n": 4,
						"h": 264,
						"w": 146
					},
					{
						"n": 5,
						"h": 355,
						"w": 140
					},
					{
						"n": 6,
						"h": 56,
						"w": 251
					},
					{
						"n": 7,
						"h": 212,
						"w": 211
					},
					{
						"n": 8,
						"h": 285,
						"w": 226
					},
					{
						"n": 9,
						"h": 381,
						"w": 275
					},
					{
						"n": 10,
						"h": 171,
						"w": 400
					},
					{
						"n": 11,
						"h": 358,
						"w": 427
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 108
					},
					{
						"n": 2,
						"h": 54,
						"w": 293,
						"m": 580
					},
					{
						"n": 3,
						"h": 178,
						"w": 247
					},
					{
						"n": 4,
						"h": 279,
						"w": 256
					},
					{
						"n": 5,
						"h": 375,
						"w": 261
					},
					{
						"n": 6,
						"h": 199,
						"w": 363
					},
					{
						"n": 7,
						"h": 180,
						"w": 439
					},
					{
						"n": 8,
						"h": 408,
						"w": 454
					},
					{
						"n": 9,
						"h": 67,
						"w": 447
					},
					{
						"n": 10,
						"h": 175,
						"w": 553
					},
					{
						"n": 11,
						"h": 285,
						"w": 553
					}
				],
				"ball": {
					"n": 0,
					"h": 381,
					"w": 275,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 51
		},
		{
			"num": 533,
			"minute": 26,
			"messages": [
				{
					"owner": 2,
					"mes": "Элвис Бвомоно[09](Галвэй Юнайтед) в подкате дотягивается до мяча и прерывает передачу!..."
				},
				{
					"owner": 1,
					"mes": "Э.Бвомоно[09](Галвэй Юнайтед) смещается в центр..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 13
					},
					{
						"n": 2,
						"h": 97,
						"w": 167
					},
					{
						"n": 3,
						"h": 165,
						"w": 158
					},
					{
						"n": 4,
						"h": 277,
						"w": 149
					},
					{
						"n": 5,
						"h": 373,
						"w": 176
					},
					{
						"n": 6,
						"h": 44,
						"w": 289
					},
					{
						"n": 7,
						"h": 210,
						"w": 251
					},
					{
						"n": 8,
						"h": 313,
						"w": 255
					},
					{
						"n": 9,
						"h": 356,
						"w": 300,
						"m": 700
					},
					{
						"n": 10,
						"h": 159,
						"w": 438
					},
					{
						"n": 11,
						"h": 320,
						"w": 438
					}
				],
				"away": [
					{
						"n": 1,
						"h": 206,
						"w": 74
					},
					{
						"n": 2,
						"h": 81,
						"w": 263
					},
					{
						"n": 3,
						"h": 170,
						"w": 222
					},
					{
						"n": 4,
						"h": 260,
						"w": 242
					},
					{
						"n": 5,
						"h": 352,
						"w": 228
					},
					{
						"n": 6,
						"h": 226,
						"w": 334
					},
					{
						"n": 7,
						"h": 166,
						"w": 402
					},
					{
						"n": 8,
						"h": 407,
						"w": 414
					},
					{
						"n": 9,
						"h": 92,
						"w": 416
					},
					{
						"n": 10,
						"h": 162,
						"w": 515
					},
					{
						"n": 11,
						"h": 269,
						"w": 516
					}
				],
				"ball": {
					"n": 0,
					"h": 356,
					"w": 300,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 534,
			"minute": 26,
			"messages": [
				{
					"owner": 1,
					"mes": "Элвис Бвомоно[09](Галвэй Юнайтед) отдает пас на К.Нолана[08](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 16
					},
					{
						"n": 2,
						"h": 89,
						"w": 192
					},
					{
						"n": 3,
						"h": 169,
						"w": 178
					},
					{
						"n": 4,
						"h": 272,
						"w": 175
					},
					{
						"n": 5,
						"h": 378,
						"w": 201
					},
					{
						"n": 6,
						"h": 48,
						"w": 314
					},
					{
						"n": 7,
						"h": 185,
						"w": 259
					},
					{
						"n": 8,
						"h": 323,
						"w": 261
					},
					{
						"n": 9,
						"h": 359,
						"w": 310
					},
					{
						"n": 10,
						"h": 153,
						"w": 463
					},
					{
						"n": 11,
						"h": 313,
						"w": 463
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 72
					},
					{
						"n": 2,
						"h": 91,
						"w": 239
					},
					{
						"n": 3,
						"h": 170,
						"w": 211
					},
					{
						"n": 4,
						"h": 266,
						"w": 216
					},
					{
						"n": 5,
						"h": 340,
						"w": 207
					},
					{
						"n": 6,
						"h": 243,
						"w": 314
					},
					{
						"n": 7,
						"h": 179,
						"w": 379
					},
					{
						"n": 8,
						"h": 404,
						"w": 389
					},
					{
						"n": 9,
						"h": 76,
						"w": 396
					},
					{
						"n": 10,
						"h": 151,
						"w": 491
					},
					{
						"n": 11,
						"h": 268,
						"w": 490
					}
				],
				"ball": {
					"n": 0,
					"h": 323,
					"w": 261,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 26
		},
		{
			"num": 535,
			"minute": 26,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 18
					},
					{
						"n": 2,
						"h": 71,
						"w": 227
					},
					{
						"n": 3,
						"h": 180,
						"w": 199
					},
					{
						"n": 4,
						"h": 277,
						"w": 202
					},
					{
						"n": 5,
						"h": 379,
						"w": 241
					},
					{
						"n": 6,
						"h": 49,
						"w": 354
					},
					{
						"n": 7,
						"h": 155,
						"w": 285
					},
					{
						"n": 8,
						"h": 323,
						"w": 296
					},
					{
						"n": 9,
						"h": 370,
						"w": 348
					},
					{
						"n": 10,
						"h": 166,
						"w": 501
					},
					{
						"n": 11,
						"h": 294,
						"w": 498
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 78
					},
					{
						"n": 2,
						"h": 103,
						"w": 201
					},
					{
						"n": 3,
						"h": 167,
						"w": 188
					},
					{
						"n": 4,
						"h": 273,
						"w": 178
					},
					{
						"n": 5,
						"h": 340,
						"w": 188
					},
					{
						"n": 6,
						"h": 214,
						"w": 286
					},
					{
						"n": 7,
						"h": 143,
						"w": 397
					},
					{
						"n": 8,
						"h": 402,
						"w": 349
					},
					{
						"n": 9,
						"h": 57,
						"w": 361
					},
					{
						"n": 10,
						"h": 157,
						"w": 452
					},
					{
						"n": 11,
						"h": 281,
						"w": 452
					}
				],
				"ball": {
					"n": 0,
					"h": 323,
					"w": 296,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 536,
			"minute": 26,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 14
					},
					{
						"n": 2,
						"h": 68,
						"w": 267
					},
					{
						"n": 3,
						"h": 180,
						"w": 237
					},
					{
						"n": 4,
						"h": 283,
						"w": 241
					},
					{
						"n": 5,
						"h": 385,
						"w": 277
					},
					{
						"n": 6,
						"h": 49,
						"w": 394
					},
					{
						"n": 7,
						"h": 152,
						"w": 325
					},
					{
						"n": 8,
						"h": 322,
						"w": 331
					},
					{
						"n": 9,
						"h": 377,
						"w": 387
					},
					{
						"n": 10,
						"h": 146,
						"w": 528
					},
					{
						"n": 11,
						"h": 314,
						"w": 530
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 72
					},
					{
						"n": 2,
						"h": 110,
						"w": 177
					},
					{
						"n": 3,
						"h": 173,
						"w": 173
					},
					{
						"n": 4,
						"h": 258,
						"w": 169
					},
					{
						"n": 5,
						"h": 300,
						"w": 188
					},
					{
						"n": 6,
						"h": 195,
						"w": 251
					},
					{
						"n": 7,
						"h": 126,
						"w": 368
					},
					{
						"n": 8,
						"h": 401,
						"w": 309
					},
					{
						"n": 9,
						"h": 40,
						"w": 328
					},
					{
						"n": 10,
						"h": 160,
						"w": 412
					},
					{
						"n": 11,
						"h": 290,
						"w": 413
					}
				],
				"ball": {
					"n": 0,
					"h": 322,
					"w": 331,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 537,
			"minute": 26,
			"messages": [
				{
					"owner": 1,
					"mes": "Киран Нолан[08](Галвэй Юнайтед) подключает к атаке Э.Бвомоно[09](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 19
					},
					{
						"n": 2,
						"h": 75,
						"w": 277
					},
					{
						"n": 3,
						"h": 182,
						"w": 235
					},
					{
						"n": 4,
						"h": 270,
						"w": 246
					},
					{
						"n": 5,
						"h": 392,
						"w": 281
					},
					{
						"n": 6,
						"h": 53,
						"w": 435
					},
					{
						"n": 7,
						"h": 172,
						"w": 360
					},
					{
						"n": 8,
						"h": 322,
						"w": 331
					},
					{
						"n": 9,
						"h": 382,
						"w": 437
					},
					{
						"n": 10,
						"h": 154,
						"w": 541
					},
					{
						"n": 11,
						"h": 299,
						"w": 551
					}
				],
				"away": [
					{
						"n": 1,
						"h": 205,
						"w": 70
					},
					{
						"n": 2,
						"h": 95,
						"w": 215
					},
					{
						"n": 3,
						"h": 170,
						"w": 144
					},
					{
						"n": 4,
						"h": 277,
						"w": 135
					},
					{
						"n": 5,
						"h": 327,
						"w": 156
					},
					{
						"n": 6,
						"h": 226,
						"w": 225
					},
					{
						"n": 7,
						"h": 152,
						"w": 336
					},
					{
						"n": 8,
						"h": 398,
						"w": 268
					},
					{
						"n": 9,
						"h": 32,
						"w": 309
					},
					{
						"n": 10,
						"h": 136,
						"w": 379
					},
					{
						"n": 11,
						"h": 283,
						"w": 373
					}
				],
				"ball": {
					"n": 0,
					"h": 382,
					"w": 437,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 41
		},
		{
			"num": 538,
			"minute": 26,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 14
					},
					{
						"n": 2,
						"h": 64,
						"w": 315
					},
					{
						"n": 3,
						"h": 182,
						"w": 275
					},
					{
						"n": 4,
						"h": 273,
						"w": 263
					},
					{
						"n": 5,
						"h": 390,
						"w": 320
					},
					{
						"n": 6,
						"h": 52,
						"w": 475
					},
					{
						"n": 7,
						"h": 182,
						"w": 399
					},
					{
						"n": 8,
						"h": 329,
						"w": 371
					},
					{
						"n": 9,
						"h": 371,
						"w": 471
					},
					{
						"n": 10,
						"h": 153,
						"w": 561
					},
					{
						"n": 11,
						"h": 306,
						"w": 565
					}
				],
				"away": [
					{
						"n": 1,
						"h": 205,
						"w": 72
					},
					{
						"n": 2,
						"h": 87,
						"w": 229
					},
					{
						"n": 3,
						"h": 182,
						"w": 113
					},
					{
						"n": 4,
						"h": 265,
						"w": 97
					},
					{
						"n": 5,
						"h": 291,
						"w": 152
					},
					{
						"n": 6,
						"h": 256,
						"w": 199
					},
					{
						"n": 7,
						"h": 167,
						"w": 299
					},
					{
						"n": 8,
						"h": 398,
						"w": 228
					},
					{
						"n": 9,
						"h": 34,
						"w": 289
					},
					{
						"n": 10,
						"h": 125,
						"w": 341
					},
					{
						"n": 11,
						"h": 275,
						"w": 334
					}
				],
				"ball": {
					"n": 0,
					"h": 371,
					"w": 471,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 539,
			"minute": 26,
			"messages": [
				{
					"owner": 1,
					"mes": "Передача вперед..."
				},
				{
					"owner": 1,
					"mes": "Адам Гилберт[11](Галвэй Юнайтед) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 13
					},
					{
						"n": 2,
						"h": 70,
						"w": 352
					},
					{
						"n": 3,
						"h": 185,
						"w": 293
					},
					{
						"n": 4,
						"h": 276,
						"w": 299
					},
					{
						"n": 5,
						"h": 373,
						"w": 352
					},
					{
						"n": 6,
						"h": 46,
						"w": 516
					},
					{
						"n": 7,
						"h": 177,
						"w": 441
					},
					{
						"n": 8,
						"h": 316,
						"w": 411
					},
					{
						"n": 9,
						"h": 372,
						"w": 481
					},
					{
						"n": 10,
						"h": 178,
						"w": 593
					},
					{
						"n": 11,
						"h": 272,
						"w": 548
					}
				],
				"away": [
					{
						"n": 1,
						"h": 216,
						"w": 32
					},
					{
						"n": 2,
						"h": 81,
						"w": 188
					},
					{
						"n": 3,
						"h": 182,
						"w": 152
					},
					{
						"n": 4,
						"h": 226,
						"w": 112
					},
					{
						"n": 5,
						"h": 264,
						"w": 120
					},
					{
						"n": 6,
						"h": 224,
						"w": 171
					},
					{
						"n": 7,
						"h": 194,
						"w": 267
					},
					{
						"n": 8,
						"h": 402,
						"w": 186
					},
					{
						"n": 9,
						"h": 26,
						"w": 269
					},
					{
						"n": 10,
						"h": 132,
						"w": 299
					},
					{
						"n": 11,
						"h": 274,
						"w": 292
					}
				],
				"ball": {
					"n": 0,
					"h": 272,
					"w": 548,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 42
		},
		{
			"num": 540,
			"minute": 26,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 16
					},
					{
						"n": 2,
						"h": 71,
						"w": 372
					},
					{
						"n": 3,
						"h": 169,
						"w": 308
					},
					{
						"n": 4,
						"h": 265,
						"w": 319
					},
					{
						"n": 5,
						"h": 387,
						"w": 360
					},
					{
						"n": 6,
						"h": 38,
						"w": 556
					},
					{
						"n": 7,
						"h": 178,
						"w": 481
					},
					{
						"n": 8,
						"h": 304,
						"w": 449
					},
					{
						"n": 9,
						"h": 370,
						"w": 532
					},
					{
						"n": 10,
						"h": 174,
						"w": 601
					},
					{
						"n": 11,
						"h": 312,
						"w": 548
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 30
					},
					{
						"n": 2,
						"h": 80,
						"w": 148
					},
					{
						"n": 3,
						"h": 146,
						"w": 152
					},
					{
						"n": 4,
						"h": 201,
						"w": 115
					},
					{
						"n": 5,
						"h": 276,
						"w": 112
					},
					{
						"n": 6,
						"h": 202,
						"w": 170
					},
					{
						"n": 7,
						"h": 227,
						"w": 244
					},
					{
						"n": 8,
						"h": 405,
						"w": 146
					},
					{
						"n": 9,
						"h": 38,
						"w": 253
					},
					{
						"n": 10,
						"h": 164,
						"w": 293
					},
					{
						"n": 11,
						"h": 279,
						"w": 300
					}
				],
				"ball": {
					"n": 0,
					"h": 312,
					"w": 548,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 541,
			"minute": 26,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 19
					},
					{
						"n": 2,
						"h": 62,
						"w": 348
					},
					{
						"n": 3,
						"h": 175,
						"w": 314
					},
					{
						"n": 4,
						"h": 273,
						"w": 309
					},
					{
						"n": 5,
						"h": 378,
						"w": 352
					},
					{
						"n": 6,
						"h": 42,
						"w": 581
					},
					{
						"n": 7,
						"h": 193,
						"w": 518
					},
					{
						"n": 8,
						"h": 279,
						"w": 439
					},
					{
						"n": 9,
						"h": 362,
						"w": 582
					},
					{
						"n": 10,
						"h": 164,
						"w": 606
					},
					{
						"n": 11,
						"h": 352,
						"w": 548
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 32
					},
					{
						"n": 2,
						"h": 94,
						"w": 128
					},
					{
						"n": 3,
						"h": 115,
						"w": 152
					},
					{
						"n": 4,
						"h": 205,
						"w": 105
					},
					{
						"n": 5,
						"h": 314,
						"w": 101
					},
					{
						"n": 6,
						"h": 240,
						"w": 158
					},
					{
						"n": 7,
						"h": 200,
						"w": 223
					},
					{
						"n": 8,
						"h": 424,
						"w": 181
					},
					{
						"n": 9,
						"h": 32,
						"w": 245
					},
					{
						"n": 10,
						"h": 168,
						"w": 293
					},
					{
						"n": 11,
						"h": 281,
						"w": 307
					}
				],
				"ball": {
					"n": 0,
					"h": 352,
					"w": 548,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 542,
			"minute": 26,
			"messages": [
				{
					"owner": 1,
					"mes": "Адам Гилберт[11](Галвэй Юнайтед) отдает передачу направо Э.Бвомоно[09](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 18
					},
					{
						"n": 2,
						"h": 72,
						"w": 354
					},
					{
						"n": 3,
						"h": 170,
						"w": 315
					},
					{
						"n": 4,
						"h": 278,
						"w": 306
					},
					{
						"n": 5,
						"h": 381,
						"w": 350
					},
					{
						"n": 6,
						"h": 52,
						"w": 588
					},
					{
						"n": 7,
						"h": 198,
						"w": 528
					},
					{
						"n": 8,
						"h": 291,
						"w": 437
					},
					{
						"n": 9,
						"h": 359,
						"w": 571
					},
					{
						"n": 10,
						"h": 174,
						"w": 608
					},
					{
						"n": 11,
						"h": 352,
						"w": 550
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 38
					},
					{
						"n": 2,
						"h": 93,
						"w": 142
					},
					{
						"n": 3,
						"h": 113,
						"w": 160
					},
					{
						"n": 4,
						"h": 205,
						"w": 97
					},
					{
						"n": 5,
						"h": 302,
						"w": 100
					},
					{
						"n": 6,
						"h": 251,
						"w": 165
					},
					{
						"n": 7,
						"h": 197,
						"w": 211
					},
					{
						"n": 8,
						"h": 418,
						"w": 171
					},
					{
						"n": 9,
						"h": 44,
						"w": 243
					},
					{
						"n": 10,
						"h": 165,
						"w": 281
					},
					{
						"n": 11,
						"h": 280,
						"w": 298
					}
				],
				"ball": {
					"n": 0,
					"h": 359,
					"w": 571,
					"z": 0,
					"r": 0,
					"p": 1,
					"x": 0
				}
			},
			"interval": 12
		},
		{
			"num": 543,
			"minute": 26,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 18
					},
					{
						"n": 2,
						"h": 68,
						"w": 357
					},
					{
						"n": 3,
						"h": 175,
						"w": 317
					},
					{
						"n": 4,
						"h": 279,
						"w": 303
					},
					{
						"n": 5,
						"h": 379,
						"w": 355
					},
					{
						"n": 6,
						"h": 57,
						"w": 587
					},
					{
						"n": 7,
						"h": 201,
						"w": 533
					},
					{
						"n": 8,
						"h": 296,
						"w": 437
					},
					{
						"n": 9,
						"h": 359,
						"w": 576
					},
					{
						"n": 10,
						"h": 170,
						"w": 611
					},
					{
						"n": 11,
						"h": 349,
						"w": 553
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 33
					},
					{
						"n": 2,
						"h": 91,
						"w": 144
					},
					{
						"n": 3,
						"h": 113,
						"w": 160
					},
					{
						"n": 4,
						"h": 206,
						"w": 92
					},
					{
						"n": 5,
						"h": 298,
						"w": 101
					},
					{
						"n": 6,
						"h": 250,
						"w": 159
					},
					{
						"n": 7,
						"h": 195,
						"w": 208
					},
					{
						"n": 8,
						"h": 416,
						"w": 166
					},
					{
						"n": 9,
						"h": 49,
						"w": 243
					},
					{
						"n": 10,
						"h": 163,
						"w": 277
					},
					{
						"n": 11,
						"h": 280,
						"w": 300
					}
				],
				"ball": {
					"n": 0,
					"h": 359,
					"w": 576,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 5
		},
		{
			"num": 544,
			"minute": 26,
			"messages": [
				{
					"owner": 1,
					"mes": "Э.Бвомоно[09](Галвэй Юнайтед) пытается пройти Л.Седлачека[22](Опава)..."
				},
				{
					"owner": 1,
					"mes": "Лука Седлачек[22](Опава) выбивает мяч из-под ног Э.Бвомоно[09](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 14
					},
					{
						"n": 2,
						"h": 67,
						"w": 365
					},
					{
						"n": 3,
						"h": 171,
						"w": 309
					},
					{
						"n": 4,
						"h": 274,
						"w": 320
					},
					{
						"n": 5,
						"h": 376,
						"w": 357
					},
					{
						"n": 6,
						"h": 47,
						"w": 593
					},
					{
						"n": 7,
						"h": 202,
						"w": 537
					},
					{
						"n": 8,
						"h": 314,
						"w": 437
					},
					{
						"n": 9,
						"h": 359,
						"w": 576
					},
					{
						"n": 10,
						"h": 179,
						"w": 618
					},
					{
						"n": 11,
						"h": 369,
						"w": 536
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 11
					},
					{
						"n": 2,
						"h": 95,
						"w": 139,
						"m": 590
					},
					{
						"n": 3,
						"h": 131,
						"w": 140
					},
					{
						"n": 4,
						"h": 200,
						"w": 93
					},
					{
						"n": 5,
						"h": 272,
						"w": 92
					},
					{
						"n": 6,
						"h": 245,
						"w": 129
					},
					{
						"n": 7,
						"h": 206,
						"w": 216
					},
					{
						"n": 8,
						"h": 405,
						"w": 141
					},
					{
						"n": 9,
						"h": 59,
						"w": 218
					},
					{
						"n": 10,
						"h": 139,
						"w": 265
					},
					{
						"n": 11,
						"h": 284,
						"w": 294
					}
				],
				"ball": {
					"n": 0,
					"h": 380,
					"w": 527,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 27
		},
		{
			"num": 545,
			"minute": 26,
			"messages": [
				{
					"owner": 1,
					"mes": "Адам Гилберт[11](Галвэй Юнайтед) первый на подборе..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 12
					},
					{
						"n": 2,
						"h": 60,
						"w": 362
					},
					{
						"n": 3,
						"h": 170,
						"w": 310
					},
					{
						"n": 4,
						"h": 284,
						"w": 318
					},
					{
						"n": 5,
						"h": 382,
						"w": 365
					},
					{
						"n": 6,
						"h": 53,
						"w": 601
					},
					{
						"n": 7,
						"h": 202,
						"w": 547
					},
					{
						"n": 8,
						"h": 312,
						"w": 446
					},
					{
						"n": 9,
						"h": 359,
						"w": 576
					},
					{
						"n": 10,
						"h": 169,
						"w": 620
					},
					{
						"n": 11,
						"h": 380,
						"w": 527
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 11
					},
					{
						"n": 2,
						"h": 101,
						"w": 129
					},
					{
						"n": 3,
						"h": 140,
						"w": 135
					},
					{
						"n": 4,
						"h": 210,
						"w": 93
					},
					{
						"n": 5,
						"h": 275,
						"w": 91
					},
					{
						"n": 6,
						"h": 235,
						"w": 131
					},
					{
						"n": 7,
						"h": 213,
						"w": 209
					},
					{
						"n": 8,
						"h": 410,
						"w": 150
					},
					{
						"n": 9,
						"h": 63,
						"w": 209
					},
					{
						"n": 10,
						"h": 139,
						"w": 255
					},
					{
						"n": 11,
						"h": 276,
						"w": 298
					}
				],
				"ball": {
					"n": 0,
					"h": 380,
					"w": 527,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 10
		},
		{
			"num": 546,
			"minute": 26,
			"messages": [
				{
					"owner": 1,
					"mes": "Адам Гилберт[11](Галвэй Юнайтед) пасует вперед на Э.Бвомоно[09](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 18
					},
					{
						"n": 2,
						"h": 63,
						"w": 373
					},
					{
						"n": 3,
						"h": 174,
						"w": 310
					},
					{
						"n": 4,
						"h": 270,
						"w": 310
					},
					{
						"n": 5,
						"h": 382,
						"w": 361
					},
					{
						"n": 6,
						"h": 53,
						"w": 599
					},
					{
						"n": 7,
						"h": 212,
						"w": 576
					},
					{
						"n": 8,
						"h": 277,
						"w": 438
					},
					{
						"n": 9,
						"h": 385,
						"w": 604
					},
					{
						"n": 10,
						"h": 179,
						"w": 629
					},
					{
						"n": 11,
						"h": 373,
						"w": 534
					}
				],
				"away": [
					{
						"n": 1,
						"h": 213,
						"w": 9
					},
					{
						"n": 2,
						"h": 69,
						"w": 107
					},
					{
						"n": 3,
						"h": 172,
						"w": 113
					},
					{
						"n": 4,
						"h": 237,
						"w": 75
					},
					{
						"n": 5,
						"h": 256,
						"w": 77
					},
					{
						"n": 6,
						"h": 230,
						"w": 137
					},
					{
						"n": 7,
						"h": 207,
						"w": 196
					},
					{
						"n": 8,
						"h": 394,
						"w": 115
					},
					{
						"n": 9,
						"h": 48,
						"w": 222
					},
					{
						"n": 10,
						"h": 173,
						"w": 262
					},
					{
						"n": 11,
						"h": 275,
						"w": 303
					}
				],
				"ball": {
					"n": 0,
					"h": 399,
					"w": 603,
					"z": 0,
					"r": 0,
					"p": 2,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 547,
			"minute": 26,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 11
					},
					{
						"n": 2,
						"h": 68,
						"w": 365
					},
					{
						"n": 3,
						"h": 165,
						"w": 320
					},
					{
						"n": 4,
						"h": 271,
						"w": 311
					},
					{
						"n": 5,
						"h": 379,
						"w": 362
					},
					{
						"n": 6,
						"h": 43,
						"w": 609
					},
					{
						"n": 7,
						"h": 203,
						"w": 573
					},
					{
						"n": 8,
						"h": 291,
						"w": 458
					},
					{
						"n": 9,
						"h": 400,
						"w": 620
					},
					{
						"n": 10,
						"h": 201,
						"w": 639
					},
					{
						"n": 11,
						"h": 358,
						"w": 553
					}
				],
				"away": [
					{
						"n": 1,
						"h": 212,
						"w": 7
					},
					{
						"n": 2,
						"h": 45,
						"w": 94
					},
					{
						"n": 3,
						"h": 187,
						"w": 95
					},
					{
						"n": 4,
						"h": 255,
						"w": 59
					},
					{
						"n": 5,
						"h": 279,
						"w": 70
					},
					{
						"n": 6,
						"h": 244,
						"w": 135
					},
					{
						"n": 7,
						"h": 201,
						"w": 195
					},
					{
						"n": 8,
						"h": 407,
						"w": 135
					},
					{
						"n": 9,
						"h": 25,
						"w": 214
					},
					{
						"n": 10,
						"h": 159,
						"w": 242
					},
					{
						"n": 11,
						"h": 284,
						"w": 301
					}
				],
				"ball": {
					"n": 0,
					"h": 405,
					"w": 626,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 24
		},
		{
			"num": 548,
			"minute": 26,
			"messages": [
				{
					"owner": 2,
					"mes": "Лука Седлачек[22](Опава) удачно выбирает позицию и подбирает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 13
					},
					{
						"n": 2,
						"h": 70,
						"w": 367
					},
					{
						"n": 3,
						"h": 168,
						"w": 321
					},
					{
						"n": 4,
						"h": 270,
						"w": 314
					},
					{
						"n": 5,
						"h": 382,
						"w": 364
					},
					{
						"n": 6,
						"h": 42,
						"w": 612
					},
					{
						"n": 7,
						"h": 205,
						"w": 576
					},
					{
						"n": 8,
						"h": 291,
						"w": 455
					},
					{
						"n": 9,
						"h": 402,
						"w": 622,
						"m": 690
					},
					{
						"n": 10,
						"h": 204,
						"w": 640
					},
					{
						"n": 11,
						"h": 357,
						"w": 555,
						"m": 780
					}
				],
				"away": [
					{
						"n": 1,
						"h": 212,
						"w": 7
					},
					{
						"n": 2,
						"h": 45,
						"w": 94,
						"m": 600
					},
					{
						"n": 3,
						"h": 189,
						"w": 92
					},
					{
						"n": 4,
						"h": 255,
						"w": 56
					},
					{
						"n": 5,
						"h": 282,
						"w": 70
					},
					{
						"n": 6,
						"h": 244,
						"w": 135
					},
					{
						"n": 7,
						"h": 203,
						"w": 192
					},
					{
						"n": 8,
						"h": 407,
						"w": 132
					},
					{
						"n": 9,
						"h": 28,
						"w": 213
					},
					{
						"n": 10,
						"h": 159,
						"w": 245
					},
					{
						"n": 11,
						"h": 287,
						"w": 301
					}
				],
				"ball": {
					"n": 0,
					"h": 405,
					"w": 626,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 3
		},
		{
			"num": 549,
			"minute": 26,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 11
					},
					{
						"n": 2,
						"h": 93,
						"w": 335
					},
					{
						"n": 3,
						"h": 162,
						"w": 318
					},
					{
						"n": 4,
						"h": 259,
						"w": 309
					},
					{
						"n": 5,
						"h": 351,
						"w": 337
					},
					{
						"n": 6,
						"h": 41,
						"w": 572
					},
					{
						"n": 7,
						"h": 206,
						"w": 536
					},
					{
						"n": 8,
						"h": 290,
						"w": 415
					},
					{
						"n": 9,
						"h": 394,
						"w": 636
					},
					{
						"n": 10,
						"h": 197,
						"w": 600
					},
					{
						"n": 11,
						"h": 323,
						"w": 534
					}
				],
				"away": [
					{
						"n": 1,
						"h": 221,
						"w": 18
					},
					{
						"n": 2,
						"h": 20,
						"w": 69
					},
					{
						"n": 3,
						"h": 174,
						"w": 106
					},
					{
						"n": 4,
						"h": 268,
						"w": 94
					},
					{
						"n": 5,
						"h": 317,
						"w": 89
					},
					{
						"n": 6,
						"h": 212,
						"w": 159
					},
					{
						"n": 7,
						"h": 197,
						"w": 232
					},
					{
						"n": 8,
						"h": 405,
						"w": 172
					},
					{
						"n": 9,
						"h": 37,
						"w": 230
					},
					{
						"n": 10,
						"h": 159,
						"w": 285
					},
					{
						"n": 11,
						"h": 321,
						"w": 279
					}
				],
				"ball": {
					"n": 0,
					"h": 430,
					"w": 651,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 550,
			"minute": 26,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 17
					},
					{
						"n": 2,
						"h": 114,
						"w": 301
					},
					{
						"n": 3,
						"h": 201,
						"w": 306
					},
					{
						"n": 4,
						"h": 291,
						"w": 295
					},
					{
						"n": 5,
						"h": 333,
						"w": 302
					},
					{
						"n": 6,
						"h": 38,
						"w": 532
					},
					{
						"n": 7,
						"h": 208,
						"w": 496
					},
					{
						"n": 8,
						"h": 288,
						"w": 375
					},
					{
						"n": 9,
						"h": 394,
						"w": 600
					},
					{
						"n": 10,
						"h": 191,
						"w": 561
					},
					{
						"n": 11,
						"h": 299,
						"w": 502
					}
				],
				"away": [
					{
						"n": 1,
						"h": 223,
						"w": 19
					},
					{
						"n": 2,
						"h": 18,
						"w": 105
					},
					{
						"n": 3,
						"h": 168,
						"w": 107
					},
					{
						"n": 4,
						"h": 273,
						"w": 99
					},
					{
						"n": 5,
						"h": 354,
						"w": 104
					},
					{
						"n": 6,
						"h": 188,
						"w": 191
					},
					{
						"n": 7,
						"h": 198,
						"w": 271
					},
					{
						"n": 8,
						"h": 405,
						"w": 212
					},
					{
						"n": 9,
						"h": 37,
						"w": 270
					},
					{
						"n": 10,
						"h": 156,
						"w": 325
					},
					{
						"n": 11,
						"h": 355,
						"w": 258
					}
				],
				"ball": {
					"n": 0,
					"h": 432,
					"w": 615,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 551,
			"minute": 26,
			"messages": [
				{
					"owner": 2,
					"mes": "Длинный пас вперед на М.Юрасека[29](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 19
					},
					{
						"n": 2,
						"h": 120,
						"w": 263
					},
					{
						"n": 3,
						"h": 237,
						"w": 272
					},
					{
						"n": 4,
						"h": 286,
						"w": 277
					},
					{
						"n": 5,
						"h": 360,
						"w": 344
					},
					{
						"n": 6,
						"h": 36,
						"w": 482
					},
					{
						"n": 7,
						"h": 208,
						"w": 446
					},
					{
						"n": 8,
						"h": 304,
						"w": 337
					},
					{
						"n": 9,
						"h": 400,
						"w": 551
					},
					{
						"n": 10,
						"h": 183,
						"w": 512
					},
					{
						"n": 11,
						"h": 286,
						"w": 453
					}
				],
				"away": [
					{
						"n": 1,
						"h": 226,
						"w": 14
					},
					{
						"n": 2,
						"h": 38,
						"w": 127
					},
					{
						"n": 3,
						"h": 165,
						"w": 106
					},
					{
						"n": 4,
						"h": 275,
						"w": 126
					},
					{
						"n": 5,
						"h": 393,
						"w": 118
					},
					{
						"n": 6,
						"h": 211,
						"w": 210
					},
					{
						"n": 7,
						"h": 203,
						"w": 321
					},
					{
						"n": 8,
						"h": 405,
						"w": 262
					},
					{
						"n": 9,
						"h": 33,
						"w": 314
					},
					{
						"n": 10,
						"h": 154,
						"w": 375
					},
					{
						"n": 11,
						"h": 370,
						"w": 306
					}
				],
				"ball": {
					"n": 0,
					"h": 420,
					"w": 366,
					"z": 1,
					"r": 0,
					"p": 1,
					"x": 0
				}
			},
			"interval": 50
		},
		{
			"num": 552,
			"minute": 26,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 17
					},
					{
						"n": 2,
						"h": 120,
						"w": 231
					},
					{
						"n": 3,
						"h": 271,
						"w": 236
					},
					{
						"n": 4,
						"h": 297,
						"w": 243
					},
					{
						"n": 5,
						"h": 417,
						"w": 303
					},
					{
						"n": 6,
						"h": 47,
						"w": 427
					},
					{
						"n": 7,
						"h": 203,
						"w": 390
					},
					{
						"n": 8,
						"h": 296,
						"w": 312
					},
					{
						"n": 9,
						"h": 396,
						"w": 495
					},
					{
						"n": 10,
						"h": 179,
						"w": 456
					},
					{
						"n": 11,
						"h": 313,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 17
					},
					{
						"n": 2,
						"h": 57,
						"w": 180
					},
					{
						"n": 3,
						"h": 178,
						"w": 136
					},
					{
						"n": 4,
						"h": 273,
						"w": 137
					},
					{
						"n": 5,
						"h": 391,
						"w": 153
					},
					{
						"n": 6,
						"h": 190,
						"w": 259
					},
					{
						"n": 7,
						"h": 148,
						"w": 330
					},
					{
						"n": 8,
						"h": 407,
						"w": 318
					},
					{
						"n": 9,
						"h": 33,
						"w": 363
					},
					{
						"n": 10,
						"h": 98,
						"w": 379
					},
					{
						"n": 11,
						"h": 381,
						"w": 360
					}
				],
				"ball": {
					"n": 0,
					"h": 417,
					"w": 303,
					"z": 0,
					"r": 0,
					"p": 1,
					"x": 0
				}
			},
			"interval": 56
		},
		{
			"num": 553,
			"minute": 26,
			"messages": [
				{
					"owner": 1,
					"mes": "Самуэль Кари Фридйонссон[05](Галвэй Юнайтед) подхватывает мяч..."
				}
			]
		},
		{
			"num": 554,
			"minute": 27,
			"possession": 43,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 10
					},
					{
						"n": 2,
						"h": 101,
						"w": 266
					},
					{
						"n": 3,
						"h": 233,
						"w": 249
					},
					{
						"n": 4,
						"h": 270,
						"w": 259,
						"f": 93
					},
					{
						"n": 5,
						"h": 392,
						"w": 278,
						"m": 610
					},
					{
						"n": 6,
						"h": 60,
						"w": 439
					},
					{
						"n": 7,
						"h": 194,
						"w": 429,
						"f": 91
					},
					{
						"n": 8,
						"h": 319,
						"w": 345
					},
					{
						"n": 9,
						"h": 409,
						"w": 457,
						"f": 90
					},
					{
						"n": 10,
						"h": 163,
						"w": 492,
						"f": 90
					},
					{
						"n": 11,
						"h": 308,
						"w": 490,
						"f": 91
					}
				],
				"away": [
					{
						"n": 1,
						"h": 210,
						"w": 56
					},
					{
						"n": 2,
						"h": 89,
						"w": 156
					},
					{
						"n": 3,
						"h": 172,
						"w": 136
					},
					{
						"n": 4,
						"h": 256,
						"w": 143
					},
					{
						"n": 5,
						"h": 356,
						"w": 135
					},
					{
						"n": 6,
						"h": 160,
						"w": 232,
						"f": 91
					},
					{
						"n": 7,
						"h": 173,
						"w": 299
					},
					{
						"n": 8,
						"h": 398,
						"w": 279
					},
					{
						"n": 9,
						"h": 39,
						"w": 324
					},
					{
						"n": 10,
						"h": 70,
						"w": 409
					},
					{
						"n": 11,
						"h": 351,
						"w": 335
					}
				],
				"ball": {
					"n": 0,
					"h": 392,
					"w": 278,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 555,
			"minute": 27,
			"messages": [
				{
					"owner": 1,
					"mes": "Роббе Дриссенс[04](Галвэй Юнайтед) в центре просит мяч... Пас ему..."
				},
				{
					"owner": 1,
					"mes": "Роббе Дриссенс[04](Галвэй Юнайтед) принимает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 15
					},
					{
						"n": 2,
						"h": 89,
						"w": 296
					},
					{
						"n": 3,
						"h": 204,
						"w": 264
					},
					{
						"n": 4,
						"h": 294,
						"w": 282
					},
					{
						"n": 5,
						"h": 389,
						"w": 288
					},
					{
						"n": 6,
						"h": 50,
						"w": 449
					},
					{
						"n": 7,
						"h": 173,
						"w": 455
					},
					{
						"n": 8,
						"h": 315,
						"w": 378
					},
					{
						"n": 9,
						"h": 408,
						"w": 450
					},
					{
						"n": 10,
						"h": 162,
						"w": 525
					},
					{
						"n": 11,
						"h": 308,
						"w": 523
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 78
					},
					{
						"n": 2,
						"h": 108,
						"w": 129
					},
					{
						"n": 3,
						"h": 172,
						"w": 118
					},
					{
						"n": 4,
						"h": 254,
						"w": 127
					},
					{
						"n": 5,
						"h": 340,
						"w": 118
					},
					{
						"n": 6,
						"h": 191,
						"w": 220
					},
					{
						"n": 7,
						"h": 195,
						"w": 275
					},
					{
						"n": 8,
						"h": 399,
						"w": 246
					},
					{
						"n": 9,
						"h": 41,
						"w": 291
					},
					{
						"n": 10,
						"h": 103,
						"w": 412
					},
					{
						"n": 11,
						"h": 318,
						"w": 328
					}
				],
				"ball": {
					"n": 0,
					"h": 294,
					"w": 282,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 33
		},
		{
			"num": 556,
			"minute": 27,
			"messages": [
				{
					"owner": 1,
					"mes": "Роббе Дриссенс[04](Галвэй Юнайтед) пасует на ход К.Нолану[08](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 19
					},
					{
						"n": 2,
						"h": 74,
						"w": 339
					},
					{
						"n": 3,
						"h": 166,
						"w": 287
					},
					{
						"n": 4,
						"h": 294,
						"w": 282
					},
					{
						"n": 5,
						"h": 380,
						"w": 332
					},
					{
						"n": 6,
						"h": 47,
						"w": 494
					},
					{
						"n": 7,
						"h": 166,
						"w": 473
					},
					{
						"n": 8,
						"h": 285,
						"w": 418
					},
					{
						"n": 9,
						"h": 407,
						"w": 495
					},
					{
						"n": 10,
						"h": 158,
						"w": 570
					},
					{
						"n": 11,
						"h": 295,
						"w": 566
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 78
					},
					{
						"n": 2,
						"h": 110,
						"w": 89
					},
					{
						"n": 3,
						"h": 168,
						"w": 87
					},
					{
						"n": 4,
						"h": 273,
						"w": 88
					},
					{
						"n": 5,
						"h": 340,
						"w": 88
					},
					{
						"n": 6,
						"h": 171,
						"w": 180
					},
					{
						"n": 7,
						"h": 171,
						"w": 279
					},
					{
						"n": 8,
						"h": 402,
						"w": 201
					},
					{
						"n": 9,
						"h": 31,
						"w": 247
					},
					{
						"n": 10,
						"h": 123,
						"w": 372
					},
					{
						"n": 11,
						"h": 295,
						"w": 302
					}
				],
				"ball": {
					"n": 0,
					"h": 285,
					"w": 418,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 45
		},
		{
			"num": 557,
			"minute": 27,
			"messages": [
				{
					"owner": 1,
					"mes": "Пас А.Хлинссону[07](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 10
					},
					{
						"n": 2,
						"h": 58,
						"w": 358
					},
					{
						"n": 3,
						"h": 175,
						"w": 307
					},
					{
						"n": 4,
						"h": 275,
						"w": 302
					},
					{
						"n": 5,
						"h": 378,
						"w": 339
					},
					{
						"n": 6,
						"h": 55,
						"w": 535
					},
					{
						"n": 7,
						"h": 194,
						"w": 502
					},
					{
						"n": 8,
						"h": 292,
						"w": 410,
						"m": 620
					},
					{
						"n": 9,
						"h": 407,
						"w": 536
					},
					{
						"n": 10,
						"h": 166,
						"w": 603
					},
					{
						"n": 11,
						"h": 292,
						"w": 607
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 38
					},
					{
						"n": 2,
						"h": 110,
						"w": 96
					},
					{
						"n": 3,
						"h": 174,
						"w": 85
					},
					{
						"n": 4,
						"h": 269,
						"w": 100
					},
					{
						"n": 5,
						"h": 340,
						"w": 87
					},
					{
						"n": 6,
						"h": 210,
						"w": 190
					},
					{
						"n": 7,
						"h": 189,
						"w": 243
					},
					{
						"n": 8,
						"h": 397,
						"w": 160
					},
					{
						"n": 9,
						"h": 33,
						"w": 244
					},
					{
						"n": 10,
						"h": 139,
						"w": 334
					},
					{
						"n": 11,
						"h": 285,
						"w": 297
					}
				],
				"ball": {
					"n": 0,
					"h": 194,
					"w": 502,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 41
		},
		{
			"num": 558,
			"minute": 27,
			"messages": [
				{
					"owner": 1,
					"mes": "Агуст Хлинссон[07](Галвэй Юнайтед) пасует направо..."
				},
				{
					"owner": 1,
					"mes": "Элвис Бвомоно[09](Галвэй Юнайтед) с мячом..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 14
					},
					{
						"n": 2,
						"h": 66,
						"w": 352
					},
					{
						"n": 3,
						"h": 168,
						"w": 309
					},
					{
						"n": 4,
						"h": 274,
						"w": 322
					},
					{
						"n": 5,
						"h": 384,
						"w": 361
					},
					{
						"n": 6,
						"h": 35,
						"w": 587
					},
					{
						"n": 7,
						"h": 200,
						"w": 510
					},
					{
						"n": 8,
						"h": 305,
						"w": 471
					},
					{
						"n": 9,
						"h": 435,
						"w": 574
					},
					{
						"n": 10,
						"h": 160,
						"w": 617
					},
					{
						"n": 11,
						"h": 298,
						"w": 627
					}
				],
				"away": [
					{
						"n": 1,
						"h": 213,
						"w": 9
					},
					{
						"n": 2,
						"h": 52,
						"w": 121
					},
					{
						"n": 3,
						"h": 172,
						"w": 75
					},
					{
						"n": 4,
						"h": 273,
						"w": 75
					},
					{
						"n": 5,
						"h": 340,
						"w": 75
					},
					{
						"n": 6,
						"h": 150,
						"w": 173
					},
					{
						"n": 7,
						"h": 243,
						"w": 211
					},
					{
						"n": 8,
						"h": 406,
						"w": 98
					},
					{
						"n": 9,
						"h": 54,
						"w": 224
					},
					{
						"n": 10,
						"h": 172,
						"w": 295
					},
					{
						"n": 11,
						"h": 282,
						"w": 301
					}
				],
				"ball": {
					"n": 0,
					"h": 435,
					"w": 574,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 63
		},
		{
			"num": 559,
			"minute": 27,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 12
					},
					{
						"n": 2,
						"h": 78,
						"w": 375
					},
					{
						"n": 3,
						"h": 184,
						"w": 327
					},
					{
						"n": 4,
						"h": 274,
						"w": 314
					},
					{
						"n": 5,
						"h": 388,
						"w": 361
					},
					{
						"n": 6,
						"h": 40,
						"w": 626
					},
					{
						"n": 7,
						"h": 192,
						"w": 549
					},
					{
						"n": 8,
						"h": 298,
						"w": 511
					},
					{
						"n": 9,
						"h": 447,
						"w": 613
					},
					{
						"n": 10,
						"h": 140,
						"w": 636
					},
					{
						"n": 11,
						"h": 318,
						"w": 637
					}
				],
				"away": [
					{
						"n": 1,
						"h": 211,
						"w": 7
					},
					{
						"n": 2,
						"h": 14,
						"w": 95
					},
					{
						"n": 3,
						"h": 154,
						"w": 54
					},
					{
						"n": 4,
						"h": 255,
						"w": 63
					},
					{
						"n": 5,
						"h": 340,
						"w": 60
					},
					{
						"n": 6,
						"h": 197,
						"w": 156
					},
					{
						"n": 7,
						"h": 207,
						"w": 194
					},
					{
						"n": 8,
						"h": 404,
						"w": 138
					},
					{
						"n": 9,
						"h": 29,
						"w": 214
					},
					{
						"n": 10,
						"h": 161,
						"w": 310
					},
					{
						"n": 11,
						"h": 275,
						"w": 291
					}
				],
				"ball": {
					"n": 0,
					"h": 447,
					"w": 613,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 560,
			"minute": 27,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 17
					},
					{
						"n": 2,
						"h": 59,
						"w": 380
					},
					{
						"n": 3,
						"h": 175,
						"w": 323
					},
					{
						"n": 4,
						"h": 283,
						"w": 318
					},
					{
						"n": 5,
						"h": 390,
						"w": 379
					},
					{
						"n": 6,
						"h": 41,
						"w": 635
					},
					{
						"n": 7,
						"h": 202,
						"w": 566
					},
					{
						"n": 8,
						"h": 299,
						"w": 491
					},
					{
						"n": 9,
						"h": 447,
						"w": 633
					},
					{
						"n": 10,
						"h": 160,
						"w": 637
					},
					{
						"n": 11,
						"h": 301,
						"w": 648
					}
				],
				"away": [
					{
						"n": 1,
						"h": 211,
						"w": 5
					},
					{
						"n": 2,
						"h": 14,
						"w": 90
					},
					{
						"n": 3,
						"h": 145,
						"w": 60
					},
					{
						"n": 4,
						"h": 261,
						"w": 71
					},
					{
						"n": 5,
						"h": 340,
						"w": 43
					},
					{
						"n": 6,
						"h": 213,
						"w": 137
					},
					{
						"n": 7,
						"h": 195,
						"w": 179
					},
					{
						"n": 8,
						"h": 401,
						"w": 118
					},
					{
						"n": 9,
						"h": 43,
						"w": 203
					},
					{
						"n": 10,
						"h": 171,
						"w": 304
					},
					{
						"n": 11,
						"h": 281,
						"w": 293
					}
				],
				"ball": {
					"n": 0,
					"h": 447,
					"w": 633,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 20
		},
		{
			"num": 561,
			"minute": 27,
			"messages": [
				{
					"owner": 1,
					"mes": "Навес в штрафную..."
				},
				{
					"owner": 1,
					"mes": "Себастьян Пейша[24](Опава) прерывает навес удачной игрой на втором этаже..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 13
					},
					{
						"n": 2,
						"h": 76,
						"w": 377
					},
					{
						"n": 3,
						"h": 169,
						"w": 316
					},
					{
						"n": 4,
						"h": 280,
						"w": 311
					},
					{
						"n": 5,
						"h": 381,
						"w": 364
					},
					{
						"n": 6,
						"h": 38,
						"w": 659
					},
					{
						"n": 7,
						"h": 201,
						"w": 612
					},
					{
						"n": 8,
						"h": 298,
						"w": 445
					},
					{
						"n": 9,
						"h": 447,
						"w": 633,
						"m": 700
					},
					{
						"n": 10,
						"h": 175,
						"w": 680
					},
					{
						"n": 11,
						"h": 287,
						"w": 680
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 14
					},
					{
						"n": 2,
						"h": 9,
						"w": 73
					},
					{
						"n": 3,
						"h": 173,
						"w": 39
					},
					{
						"n": 4,
						"h": 269,
						"w": 36
					},
					{
						"n": 5,
						"h": 294,
						"w": 40
					},
					{
						"n": 6,
						"h": 249,
						"w": 100
					},
					{
						"n": 7,
						"h": 203,
						"w": 163
					},
					{
						"n": 8,
						"h": 406,
						"w": 140
					},
					{
						"n": 9,
						"h": 28,
						"w": 190
					},
					{
						"n": 10,
						"h": 154,
						"w": 261
					},
					{
						"n": 11,
						"h": 295,
						"w": 300
					}
				],
				"ball": {
					"n": 0,
					"h": 181,
					"w": 684,
					"z": 1,
					"r": 2,
					"p": 4,
					"x": 1
				}
			},
			"interval": 46
		},
		{
			"num": 562,
			"minute": 27,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 18
					},
					{
						"n": 2,
						"h": 66,
						"w": 376
					},
					{
						"n": 3,
						"h": 174,
						"w": 329
					},
					{
						"n": 4,
						"h": 280,
						"w": 311
					},
					{
						"n": 5,
						"h": 385,
						"w": 360
					},
					{
						"n": 6,
						"h": 10,
						"w": 706
					},
					{
						"n": 7,
						"h": 173,
						"w": 566
					},
					{
						"n": 8,
						"h": 275,
						"w": 429
					},
					{
						"n": 9,
						"h": 414,
						"w": 620
					},
					{
						"n": 10,
						"h": 158,
						"w": 638
					},
					{
						"n": 11,
						"h": 276,
						"w": 632
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 15
					},
					{
						"n": 2,
						"h": 63,
						"w": 76
					},
					{
						"n": 3,
						"h": 194,
						"w": 60
					},
					{
						"n": 4,
						"h": 273,
						"w": 49
					},
					{
						"n": 5,
						"h": 340,
						"w": 56
					},
					{
						"n": 6,
						"h": 267,
						"w": 80
					},
					{
						"n": 7,
						"h": 234,
						"w": 182
					},
					{
						"n": 8,
						"h": 421,
						"w": 88
					},
					{
						"n": 9,
						"h": 52,
						"w": 210
					},
					{
						"n": 10,
						"h": 161,
						"w": 315
					},
					{
						"n": 11,
						"h": 278,
						"w": 293
					}
				],
				"ball": {
					"n": 0,
					"h": -30,
					"w": 722,
					"z": 1,
					"r": 0,
					"p": 1,
					"x": 0
				}
			},
			"interval": 54
		},
		{
			"num": 563,
			"minute": 27,
			"messages": [
				{
					"owner": 1,
					"mes": "К.Колман[06](Галвэй Юнайтед) вбрасывает аут..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 219,
						"w": 40
					},
					{
						"n": 2,
						"h": 57,
						"w": 537
					},
					{
						"n": 3,
						"h": 108,
						"w": 401
					},
					{
						"n": 4,
						"h": 296,
						"w": 402
					},
					{
						"n": 5,
						"h": 376,
						"w": 408
					},
					{
						"n": 6,
						"h": 0,
						"w": 700
					},
					{
						"n": 7,
						"h": 97,
						"w": 656
					},
					{
						"n": 8,
						"h": 286,
						"w": 533
					},
					{
						"n": 9,
						"h": 379,
						"w": 625
					},
					{
						"n": 10,
						"h": 45,
						"w": 666
					},
					{
						"n": 11,
						"h": 161,
						"w": 642
					}
				],
				"away": [
					{
						"n": 1,
						"h": 240,
						"w": 1
					},
					{
						"n": 2,
						"h": 110,
						"w": 31
					},
					{
						"n": 3,
						"h": 252,
						"w": 35
					},
					{
						"n": 4,
						"h": 345,
						"w": 34
					},
					{
						"n": 5,
						"h": 403,
						"w": 41
					},
					{
						"n": 6,
						"h": 348,
						"w": 50
					},
					{
						"n": 7,
						"h": 282,
						"w": 137
					},
					{
						"n": 8,
						"h": 433,
						"w": 100
					},
					{
						"n": 9,
						"h": 39,
						"w": 160
					},
					{
						"n": 10,
						"h": 172,
						"w": 303
					},
					{
						"n": 11,
						"h": 293,
						"w": 300
					}
				],
				"ball": {
					"n": 0,
					"h": 0,
					"w": 700,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 129
		},
		{
			"num": 564,
			"minute": 27,
			"messages": [
				{
					"owner": 1,
					"mes": "Джо Квигли[10](Галвэй Юнайтед) получает мяч..."
				}
			],
			"A": {
				"team": 1
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 13
					},
					{
						"n": 2,
						"h": 58,
						"w": 505
					},
					{
						"n": 3,
						"h": 128,
						"w": 377
					},
					{
						"n": 4,
						"h": 290,
						"w": 370
					},
					{
						"n": 5,
						"h": 380,
						"w": 377
					},
					{
						"n": 6,
						"h": 0,
						"w": 700
					},
					{
						"n": 7,
						"h": 128,
						"w": 650
					},
					{
						"n": 8,
						"h": 265,
						"w": 557
					},
					{
						"n": 9,
						"h": 389,
						"w": 654
					},
					{
						"n": 10,
						"h": 63,
						"w": 627
					},
					{
						"n": 11,
						"h": 193,
						"w": 646
					}
				],
				"away": [
					{
						"n": 1,
						"h": 238,
						"w": 7
					},
					{
						"n": 2,
						"h": 110,
						"w": 34
					},
					{
						"n": 3,
						"h": 238,
						"w": 48
					},
					{
						"n": 4,
						"h": 313,
						"w": 40
					},
					{
						"n": 5,
						"h": 406,
						"w": 13
					},
					{
						"n": 6,
						"h": 318,
						"w": 61
					},
					{
						"n": 7,
						"h": 250,
						"w": 142
					},
					{
						"n": 8,
						"h": 401,
						"w": 95
					},
					{
						"n": 9,
						"h": 25,
						"w": 189
					},
					{
						"n": 10,
						"h": 166,
						"w": 299
					},
					{
						"n": 11,
						"h": 279,
						"w": 298
					}
				],
				"ball": {
					"n": 0,
					"h": 63,
					"w": 627,
					"z": 1,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 32
		},
		{
			"num": 565,
			"minute": 27,
			"messages": [
				{
					"owner": 1,
					"mes": "Передача в штрафную..."
				},
				{
					"owner": 1,
					"mes": "Теперь с мячом Адам Гилберт[11](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 15
					},
					{
						"n": 2,
						"h": 59,
						"w": 467
					},
					{
						"n": 3,
						"h": 150,
						"w": 345
					},
					{
						"n": 4,
						"h": 281,
						"w": 333
					},
					{
						"n": 5,
						"h": 381,
						"w": 377
					},
					{
						"n": 6,
						"h": 18,
						"w": 666
					},
					{
						"n": 7,
						"h": 152,
						"w": 648
					},
					{
						"n": 8,
						"h": 275,
						"w": 592
					},
					{
						"n": 9,
						"h": 399,
						"w": 650
					},
					{
						"n": 10,
						"h": 73,
						"w": 628
					},
					{
						"n": 11,
						"h": 177,
						"w": 618
					}
				],
				"away": [
					{
						"n": 1,
						"h": 231,
						"w": 14
					},
					{
						"n": 2,
						"h": 76,
						"w": 50
					},
					{
						"n": 3,
						"h": 201,
						"w": 41
					},
					{
						"n": 4,
						"h": 283,
						"w": 50
					},
					{
						"n": 5,
						"h": 406,
						"w": 50
					},
					{
						"n": 6,
						"h": 282,
						"w": 72
					},
					{
						"n": 7,
						"h": 267,
						"w": 108
					},
					{
						"n": 8,
						"h": 381,
						"w": 63
					},
					{
						"n": 9,
						"h": 29,
						"w": 190
					},
					{
						"n": 10,
						"h": 171,
						"w": 301
					},
					{
						"n": 11,
						"h": 275,
						"w": 303
					}
				],
				"ball": {
					"n": 0,
					"h": 177,
					"w": 618,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 38
		},
		{
			"num": 566,
			"minute": 27,
			"messages": [
				{
					"owner": 1,
					"mes": "Справа открывается Киран Нолан[08](Галвэй Юнайтед)... Передача..."
				},
				{
					"owner": 1,
					"mes": "Киран Нолан[08](Галвэй Юнайтед) подрабатывает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 13
					},
					{
						"n": 2,
						"h": 64,
						"w": 431
					},
					{
						"n": 3,
						"h": 179,
						"w": 324
					},
					{
						"n": 4,
						"h": 272,
						"w": 325
					},
					{
						"n": 5,
						"h": 392,
						"w": 377
					},
					{
						"n": 6,
						"h": 43,
						"w": 641
					},
					{
						"n": 7,
						"h": 173,
						"w": 648
					},
					{
						"n": 8,
						"h": 285,
						"w": 626
					},
					{
						"n": 9,
						"h": 408,
						"w": 640
					},
					{
						"n": 10,
						"h": 106,
						"w": 640
					},
					{
						"n": 11,
						"h": 179,
						"w": 627
					}
				],
				"away": [
					{
						"n": 1,
						"h": 217,
						"w": 13
					},
					{
						"n": 2,
						"h": 67,
						"w": 60
					},
					{
						"n": 3,
						"h": 179,
						"w": 70
					},
					{
						"n": 4,
						"h": 258,
						"w": 55
					},
					{
						"n": 5,
						"h": 370,
						"w": 51
					},
					{
						"n": 6,
						"h": 317,
						"w": 75
					},
					{
						"n": 7,
						"h": 263,
						"w": 143
					},
					{
						"n": 8,
						"h": 382,
						"w": 99
					},
					{
						"n": 9,
						"h": 56,
						"w": 202
					},
					{
						"n": 10,
						"h": 168,
						"w": 306
					},
					{
						"n": 11,
						"h": 287,
						"w": 297
					}
				],
				"ball": {
					"n": 0,
					"h": 285,
					"w": 626,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 36
		},
		{
			"num": 567,
			"minute": 27,
			"messages": [
				{
					"owner": 1,
					"mes": "Киран Нолан[08](Галвэй Юнайтед) отдает пас А.Хлинссону[07](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 16
					},
					{
						"n": 2,
						"h": 65,
						"w": 405
					},
					{
						"n": 3,
						"h": 183,
						"w": 324
					},
					{
						"n": 4,
						"h": 269,
						"w": 318
					},
					{
						"n": 5,
						"h": 380,
						"w": 367
					},
					{
						"n": 6,
						"h": 64,
						"w": 648
					},
					{
						"n": 7,
						"h": 197,
						"w": 657
					},
					{
						"n": 8,
						"h": 285,
						"w": 616,
						"m": 610
					},
					{
						"n": 9,
						"h": 396,
						"w": 640
					},
					{
						"n": 10,
						"h": 124,
						"w": 659
					},
					{
						"n": 11,
						"h": 191,
						"w": 651
					}
				],
				"away": [
					{
						"n": 1,
						"h": 231,
						"w": 14
					},
					{
						"n": 2,
						"h": 79,
						"w": 60
					},
					{
						"n": 3,
						"h": 202,
						"w": 57
					},
					{
						"n": 4,
						"h": 232,
						"w": 55
					},
					{
						"n": 5,
						"h": 378,
						"w": 52
					},
					{
						"n": 6,
						"h": 328,
						"w": 57
					},
					{
						"n": 7,
						"h": 260,
						"w": 118
					},
					{
						"n": 8,
						"h": 400,
						"w": 118
					},
					{
						"n": 9,
						"h": 72,
						"w": 182
					},
					{
						"n": 10,
						"h": 158,
						"w": 298
					},
					{
						"n": 11,
						"h": 281,
						"w": 290
					}
				],
				"ball": {
					"n": 0,
					"h": 218,
					"w": 665,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 26
		},
		{
			"num": 568,
			"minute": 27,
			"messages": [
				{
					"owner": 1,
					"mes": "Себастьян Пейша[24](Опава) выбирает хорошую позицию и перехватывает мяч!..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 17
					},
					{
						"n": 2,
						"h": 80,
						"w": 368
					},
					{
						"n": 3,
						"h": 165,
						"w": 311
					},
					{
						"n": 4,
						"h": 281,
						"w": 308
					},
					{
						"n": 5,
						"h": 352,
						"w": 338
					},
					{
						"n": 6,
						"h": 61,
						"w": 608
					},
					{
						"n": 7,
						"h": 227,
						"w": 630
					},
					{
						"n": 8,
						"h": 284,
						"w": 576
					},
					{
						"n": 9,
						"h": 397,
						"w": 600
					},
					{
						"n": 10,
						"h": 130,
						"w": 620
					},
					{
						"n": 11,
						"h": 217,
						"w": 621
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 18
					},
					{
						"n": 2,
						"h": 69,
						"w": 99
					},
					{
						"n": 3,
						"h": 183,
						"w": 66
					},
					{
						"n": 4,
						"h": 207,
						"w": 80,
						"m": 680
					},
					{
						"n": 5,
						"h": 384,
						"w": 92
					},
					{
						"n": 6,
						"h": 305,
						"w": 90
					},
					{
						"n": 7,
						"h": 256,
						"w": 157
					},
					{
						"n": 8,
						"h": 401,
						"w": 158
					},
					{
						"n": 9,
						"h": 49,
						"w": 214
					},
					{
						"n": 10,
						"h": 151,
						"w": 337
					},
					{
						"n": 11,
						"h": 303,
						"w": 323
					}
				],
				"ball": {
					"n": 0,
					"h": 243,
					"w": 640,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 569,
			"minute": 27,
			"messages": [
				{
					"owner": 2,
					"mes": "Пас налево на Н.Мансура[23](Опава)..."
				},
				{
					"owner": 2,
					"mes": "Нир Мансур[23](Опава) принимает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 13
					},
					{
						"n": 2,
						"h": 83,
						"w": 355
					},
					{
						"n": 3,
						"h": 174,
						"w": 300
					},
					{
						"n": 4,
						"h": 280,
						"w": 294
					},
					{
						"n": 5,
						"h": 347,
						"w": 325
					},
					{
						"n": 6,
						"h": 61,
						"w": 594
					},
					{
						"n": 7,
						"h": 225,
						"w": 617
					},
					{
						"n": 8,
						"h": 282,
						"w": 562
					},
					{
						"n": 9,
						"h": 399,
						"w": 586
					},
					{
						"n": 10,
						"h": 132,
						"w": 606
					},
					{
						"n": 11,
						"h": 231,
						"w": 625
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 12
					},
					{
						"n": 2,
						"h": 69,
						"w": 113
					},
					{
						"n": 3,
						"h": 183,
						"w": 66
					},
					{
						"n": 4,
						"h": 207,
						"w": 80
					},
					{
						"n": 5,
						"h": 382,
						"w": 106
					},
					{
						"n": 6,
						"h": 297,
						"w": 101
					},
					{
						"n": 7,
						"h": 250,
						"w": 170
					},
					{
						"n": 8,
						"h": 399,
						"w": 172
					},
					{
						"n": 9,
						"h": 48,
						"w": 228
					},
					{
						"n": 10,
						"h": 150,
						"w": 351
					},
					{
						"n": 11,
						"h": 289,
						"w": 325
					}
				],
				"ball": {
					"n": 0,
					"h": 267,
					"w": 654,
					"z": 0,
					"r": 0,
					"p": 1,
					"x": 0
				}
			},
			"interval": 14
		},
		{
			"num": 570,
			"minute": 27,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 10
					},
					{
						"n": 2,
						"h": 87,
						"w": 315
					},
					{
						"n": 3,
						"h": 211,
						"w": 286
					},
					{
						"n": 4,
						"h": 275,
						"w": 287
					},
					{
						"n": 5,
						"h": 332,
						"w": 288
					},
					{
						"n": 6,
						"h": 57,
						"w": 554
					},
					{
						"n": 7,
						"h": 218,
						"w": 577
					},
					{
						"n": 8,
						"h": 276,
						"w": 522
					},
					{
						"n": 9,
						"h": 398,
						"w": 546
					},
					{
						"n": 10,
						"h": 144,
						"w": 568
					},
					{
						"n": 11,
						"h": 268,
						"w": 609
					}
				],
				"away": [
					{
						"n": 1,
						"h": 221,
						"w": 11
					},
					{
						"n": 2,
						"h": 72,
						"w": 148
					},
					{
						"n": 3,
						"h": 168,
						"w": 97
					},
					{
						"n": 4,
						"h": 225,
						"w": 90
					},
					{
						"n": 5,
						"h": 379,
						"w": 107
					},
					{
						"n": 6,
						"h": 276,
						"w": 135
					},
					{
						"n": 7,
						"h": 233,
						"w": 206
					},
					{
						"n": 8,
						"h": 395,
						"w": 212
					},
					{
						"n": 9,
						"h": 45,
						"w": 268
					},
					{
						"n": 10,
						"h": 146,
						"w": 391
					},
					{
						"n": 11,
						"h": 250,
						"w": 334
					}
				],
				"ball": {
					"n": 0,
					"h": 282,
					"w": 623,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 571,
			"minute": 27,
			"messages": [
				{
					"owner": 2,
					"mes": "Нир Мансур[23](Опава) отдает пас на К.Ласака[21](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 18
					},
					{
						"n": 2,
						"h": 106,
						"w": 286
					},
					{
						"n": 3,
						"h": 232,
						"w": 269
					},
					{
						"n": 4,
						"h": 284,
						"w": 269
					},
					{
						"n": 5,
						"h": 330,
						"w": 254
					},
					{
						"n": 6,
						"h": 54,
						"w": 520
					},
					{
						"n": 7,
						"h": 231,
						"w": 608
					},
					{
						"n": 8,
						"h": 275,
						"w": 488
					},
					{
						"n": 9,
						"h": 402,
						"w": 512
					},
					{
						"n": 10,
						"h": 157,
						"w": 536
					},
					{
						"n": 11,
						"h": 279,
						"w": 577
					}
				],
				"away": [
					{
						"n": 1,
						"h": 195,
						"w": 34
					},
					{
						"n": 2,
						"h": 62,
						"w": 172
					},
					{
						"n": 3,
						"h": 168,
						"w": 107,
						"m": 580
					},
					{
						"n": 4,
						"h": 258,
						"w": 98
					},
					{
						"n": 5,
						"h": 392,
						"w": 132
					},
					{
						"n": 6,
						"h": 259,
						"w": 164
					},
					{
						"n": 7,
						"h": 223,
						"w": 239
					},
					{
						"n": 8,
						"h": 399,
						"w": 245
					},
					{
						"n": 9,
						"h": 43,
						"w": 302
					},
					{
						"n": 10,
						"h": 152,
						"w": 425
					},
					{
						"n": 11,
						"h": 217,
						"w": 342
					}
				],
				"ball": {
					"n": 0,
					"h": 255,
					"w": 686,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 34
		},
		{
			"num": 572,
			"minute": 28,
			"possession": 44,
			"messages": [
				{
					"owner": 2,
					"mes": "Крыштоф Ласак[21](Опава) с подкруткой пасует вперед на С.Пейшу[24](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 13
					},
					{
						"n": 2,
						"h": 120,
						"w": 267,
						"f": 91
					},
					{
						"n": 3,
						"h": 243,
						"w": 258
					},
					{
						"n": 4,
						"h": 283,
						"w": 266
					},
					{
						"n": 5,
						"h": 330,
						"w": 253,
						"f": 91
					},
					{
						"n": 6,
						"h": 49,
						"w": 491
					},
					{
						"n": 7,
						"h": 209,
						"w": 624
					},
					{
						"n": 8,
						"h": 274,
						"w": 458
					},
					{
						"n": 9,
						"h": 400,
						"w": 482
					},
					{
						"n": 10,
						"h": 162,
						"w": 545
					},
					{
						"n": 11,
						"h": 285,
						"w": 548
					}
				],
				"away": [
					{
						"n": 1,
						"h": 204,
						"w": 30,
						"f": 91
					},
					{
						"n": 2,
						"h": 74,
						"w": 161
					},
					{
						"n": 3,
						"h": 170,
						"w": 114,
						"f": 91
					},
					{
						"n": 4,
						"h": 237,
						"w": 77
					},
					{
						"n": 5,
						"h": 377,
						"w": 134,
						"f": 90
					},
					{
						"n": 6,
						"h": 244,
						"w": 191
					},
					{
						"n": 7,
						"h": 222,
						"w": 269
					},
					{
						"n": 8,
						"h": 399,
						"w": 275
					},
					{
						"n": 9,
						"h": 41,
						"w": 332,
						"f": 90
					},
					{
						"n": 10,
						"h": 153,
						"w": 421
					},
					{
						"n": 11,
						"h": 189,
						"w": 352
					}
				],
				"ball": {
					"n": 0,
					"h": 213,
					"w": 643,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 30
		},
		{
			"num": 573,
			"minute": 28,
			"messages": [
				{
					"owner": 2,
					"mes": "Себастьян Пейша[24](Опава) пасует Л.Седлачеку[22](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 15
					},
					{
						"n": 2,
						"h": 120,
						"w": 261
					},
					{
						"n": 3,
						"h": 223,
						"w": 252
					},
					{
						"n": 4,
						"h": 311,
						"w": 253
					},
					{
						"n": 5,
						"h": 377,
						"w": 293
					},
					{
						"n": 6,
						"h": 52,
						"w": 416
					},
					{
						"n": 7,
						"h": 208,
						"w": 549
					},
					{
						"n": 8,
						"h": 284,
						"w": 384
					},
					{
						"n": 9,
						"h": 408,
						"w": 408
					},
					{
						"n": 10,
						"h": 190,
						"w": 476
					},
					{
						"n": 11,
						"h": 279,
						"w": 473
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 16
					},
					{
						"n": 2,
						"h": 19,
						"w": 134
					},
					{
						"n": 3,
						"h": 173,
						"w": 118
					},
					{
						"n": 4,
						"h": 249,
						"w": 86
					},
					{
						"n": 5,
						"h": 374,
						"w": 131
					},
					{
						"n": 6,
						"h": 188,
						"w": 240
					},
					{
						"n": 7,
						"h": 189,
						"w": 308
					},
					{
						"n": 8,
						"h": 400,
						"w": 350
					},
					{
						"n": 9,
						"h": 43,
						"w": 407
					},
					{
						"n": 10,
						"h": 144,
						"w": 444
					},
					{
						"n": 11,
						"h": 129,
						"w": 374
					}
				],
				"ball": {
					"n": 0,
					"h": 431,
					"w": 586,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 75
		},
		{
			"num": 574,
			"minute": 28,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 17
					},
					{
						"n": 2,
						"h": 120,
						"w": 251
					},
					{
						"n": 3,
						"h": 216,
						"w": 261
					},
					{
						"n": 4,
						"h": 299,
						"w": 262
					},
					{
						"n": 5,
						"h": 382,
						"w": 280
					},
					{
						"n": 6,
						"h": 53,
						"w": 376
					},
					{
						"n": 7,
						"h": 205,
						"w": 509
					},
					{
						"n": 8,
						"h": 295,
						"w": 345
					},
					{
						"n": 9,
						"h": 421,
						"w": 370
					},
					{
						"n": 10,
						"h": 169,
						"w": 450
					},
					{
						"n": 11,
						"h": 305,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 228,
						"w": 10
					},
					{
						"n": 2,
						"h": 5,
						"w": 166
					},
					{
						"n": 3,
						"h": 179,
						"w": 107
					},
					{
						"n": 4,
						"h": 281,
						"w": 124
					},
					{
						"n": 5,
						"h": 382,
						"w": 139
					},
					{
						"n": 6,
						"h": 194,
						"w": 219
					},
					{
						"n": 7,
						"h": 209,
						"w": 297
					},
					{
						"n": 8,
						"h": 405,
						"w": 390
					},
					{
						"n": 9,
						"h": 38,
						"w": 420
					},
					{
						"n": 10,
						"h": 149,
						"w": 432
					},
					{
						"n": 11,
						"h": 146,
						"w": 361
					}
				],
				"ball": {
					"n": 0,
					"h": 445,
					"w": 554,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 575,
			"minute": 28,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 19
					},
					{
						"n": 2,
						"h": 120,
						"w": 255
					},
					{
						"n": 3,
						"h": 240,
						"w": 247
					},
					{
						"n": 4,
						"h": 287,
						"w": 258
					},
					{
						"n": 5,
						"h": 370,
						"w": 280
					},
					{
						"n": 6,
						"h": 40,
						"w": 354
					},
					{
						"n": 7,
						"h": 203,
						"w": 469
					},
					{
						"n": 8,
						"h": 266,
						"w": 332
					},
					{
						"n": 9,
						"h": 416,
						"w": 354
					},
					{
						"n": 10,
						"h": 167,
						"w": 444
					},
					{
						"n": 11,
						"h": 285,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 17
					},
					{
						"n": 2,
						"h": 8,
						"w": 201
					},
					{
						"n": 3,
						"h": 165,
						"w": 120
					},
					{
						"n": 4,
						"h": 283,
						"w": 135
					},
					{
						"n": 5,
						"h": 389,
						"w": 111
					},
					{
						"n": 6,
						"h": 198,
						"w": 224
					},
					{
						"n": 7,
						"h": 183,
						"w": 296
					},
					{
						"n": 8,
						"h": 400,
						"w": 430
					},
					{
						"n": 9,
						"h": 50,
						"w": 420
					},
					{
						"n": 10,
						"h": 163,
						"w": 449
					},
					{
						"n": 11,
						"h": 186,
						"w": 356
					}
				],
				"ball": {
					"n": 0,
					"h": 442,
					"w": 519,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 576,
			"minute": 28,
			"messages": [
				{
					"owner": 2,
					"mes": "Пас правее на К.Ласака[21](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 18
					},
					{
						"n": 2,
						"h": 120,
						"w": 270
					},
					{
						"n": 3,
						"h": 254,
						"w": 261
					},
					{
						"n": 4,
						"h": 298,
						"w": 260
					},
					{
						"n": 5,
						"h": 369,
						"w": 280
					},
					{
						"n": 6,
						"h": 55,
						"w": 291
					},
					{
						"n": 7,
						"h": 190,
						"w": 405
					},
					{
						"n": 8,
						"h": 302,
						"w": 336
					},
					{
						"n": 9,
						"h": 393,
						"w": 360
					},
					{
						"n": 10,
						"h": 133,
						"w": 450
					},
					{
						"n": 11,
						"h": 313,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 211,
						"w": 37
					},
					{
						"n": 2,
						"h": 18,
						"w": 198
					},
					{
						"n": 3,
						"h": 178,
						"w": 134
					},
					{
						"n": 4,
						"h": 267,
						"w": 124
					},
					{
						"n": 5,
						"h": 377,
						"w": 146
					},
					{
						"n": 6,
						"h": 221,
						"w": 220
					},
					{
						"n": 7,
						"h": 211,
						"w": 323
					},
					{
						"n": 8,
						"h": 415,
						"w": 420
					},
					{
						"n": 9,
						"h": 51,
						"w": 420
					},
					{
						"n": 10,
						"h": 175,
						"w": 442
					},
					{
						"n": 11,
						"h": 146,
						"w": 358
					}
				],
				"ball": {
					"n": 0,
					"h": 239,
					"w": 683,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 65
		},
		{
			"num": 577,
			"minute": 28,
			"messages": [
				{
					"owner": 2,
					"mes": "Видя свободного С.Пейшу[24](Опава), Крыштоф Ласак[21](Опава) отдает пас вперед..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 14
					},
					{
						"n": 2,
						"h": 120,
						"w": 270
					},
					{
						"n": 3,
						"h": 216,
						"w": 269
					},
					{
						"n": 4,
						"h": 293,
						"w": 270
					},
					{
						"n": 5,
						"h": 380,
						"w": 280
					},
					{
						"n": 6,
						"h": 56,
						"w": 285
					},
					{
						"n": 7,
						"h": 186,
						"w": 361
					},
					{
						"n": 8,
						"h": 304,
						"w": 352
					},
					{
						"n": 9,
						"h": 396,
						"w": 360
					},
					{
						"n": 10,
						"h": 140,
						"w": 450
					},
					{
						"n": 11,
						"h": 313,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 216,
						"w": 28
					},
					{
						"n": 2,
						"h": 60,
						"w": 181
					},
					{
						"n": 3,
						"h": 175,
						"w": 124
					},
					{
						"n": 4,
						"h": 268,
						"w": 158
					},
					{
						"n": 5,
						"h": 386,
						"w": 109
					},
					{
						"n": 6,
						"h": 264,
						"w": 234
					},
					{
						"n": 7,
						"h": 219,
						"w": 288
					},
					{
						"n": 8,
						"h": 415,
						"w": 420
					},
					{
						"n": 9,
						"h": 40,
						"w": 420
					},
					{
						"n": 10,
						"h": 156,
						"w": 439
					},
					{
						"n": 11,
						"h": 147,
						"w": 358
					}
				],
				"ball": {
					"n": 0,
					"h": 182,
					"w": 562,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 45
		},
		{
			"num": 578,
			"minute": 28,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 14
					},
					{
						"n": 2,
						"h": 120,
						"w": 262
					},
					{
						"n": 3,
						"h": 255,
						"w": 259
					},
					{
						"n": 4,
						"h": 297,
						"w": 267
					},
					{
						"n": 5,
						"h": 380,
						"w": 280
					},
					{
						"n": 6,
						"h": 60,
						"w": 273
					},
					{
						"n": 7,
						"h": 193,
						"w": 352
					},
					{
						"n": 8,
						"h": 304,
						"w": 340
					},
					{
						"n": 9,
						"h": 411,
						"w": 358
					},
					{
						"n": 10,
						"h": 158,
						"w": 414
					},
					{
						"n": 11,
						"h": 321,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 14
					},
					{
						"n": 2,
						"h": 67,
						"w": 169
					},
					{
						"n": 3,
						"h": 172,
						"w": 125
					},
					{
						"n": 4,
						"h": 250,
						"w": 189
					},
					{
						"n": 5,
						"h": 387,
						"w": 149
					},
					{
						"n": 6,
						"h": 226,
						"w": 248
					},
					{
						"n": 7,
						"h": 222,
						"w": 303
					},
					{
						"n": 8,
						"h": 405,
						"w": 420
					},
					{
						"n": 9,
						"h": 40,
						"w": 420
					},
					{
						"n": 10,
						"h": 171,
						"w": 445
					},
					{
						"n": 11,
						"h": 150,
						"w": 361
					}
				],
				"ball": {
					"n": 0,
					"h": 200,
					"w": 531,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 579,
			"minute": 28,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 18
					},
					{
						"n": 2,
						"h": 80,
						"w": 260
					},
					{
						"n": 3,
						"h": 223,
						"w": 261
					},
					{
						"n": 4,
						"h": 302,
						"w": 260
					},
					{
						"n": 5,
						"h": 384,
						"w": 259
					},
					{
						"n": 6,
						"h": 47,
						"w": 311
					},
					{
						"n": 7,
						"h": 219,
						"w": 349
					},
					{
						"n": 8,
						"h": 292,
						"w": 314
					},
					{
						"n": 9,
						"h": 401,
						"w": 354
					},
					{
						"n": 10,
						"h": 168,
						"w": 413
					},
					{
						"n": 11,
						"h": 320,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 19
					},
					{
						"n": 2,
						"h": 61,
						"w": 164
					},
					{
						"n": 3,
						"h": 171,
						"w": 115
					},
					{
						"n": 4,
						"h": 251,
						"w": 224
					},
					{
						"n": 5,
						"h": 384,
						"w": 136
					},
					{
						"n": 6,
						"h": 191,
						"w": 256
					},
					{
						"n": 7,
						"h": 229,
						"w": 342
					},
					{
						"n": 8,
						"h": 400,
						"w": 445
					},
					{
						"n": 9,
						"h": 50,
						"w": 449
					},
					{
						"n": 10,
						"h": 151,
						"w": 445
					},
					{
						"n": 11,
						"h": 158,
						"w": 400
					}
				],
				"ball": {
					"n": 0,
					"h": 199,
					"w": 496,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 580,
			"minute": 28,
			"messages": [
				{
					"owner": 2,
					"mes": "Себастьян Пейша[24](Опава) пасует на ход О.Дюмону[26](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 16
					},
					{
						"n": 2,
						"h": 87,
						"w": 254
					},
					{
						"n": 3,
						"h": 218,
						"w": 230
					},
					{
						"n": 4,
						"h": 298,
						"w": 237
					},
					{
						"n": 5,
						"h": 382,
						"w": 254
					},
					{
						"n": 6,
						"h": 29,
						"w": 334
					},
					{
						"n": 7,
						"h": 240,
						"w": 372
					},
					{
						"n": 8,
						"h": 300,
						"w": 314
					},
					{
						"n": 9,
						"h": 396,
						"w": 344
					},
					{
						"n": 10,
						"h": 164,
						"w": 399
					},
					{
						"n": 11,
						"h": 289,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 223,
						"w": 17
					},
					{
						"n": 2,
						"h": 73,
						"w": 193
					},
					{
						"n": 3,
						"h": 170,
						"w": 144
					},
					{
						"n": 4,
						"h": 251,
						"w": 224,
						"m": 690
					},
					{
						"n": 5,
						"h": 383,
						"w": 160
					},
					{
						"n": 6,
						"h": 181,
						"w": 286
					},
					{
						"n": 7,
						"h": 210,
						"w": 362
					},
					{
						"n": 8,
						"h": 393,
						"w": 446
					},
					{
						"n": 9,
						"h": 38,
						"w": 446
					},
					{
						"n": 10,
						"h": 151,
						"w": 452
					},
					{
						"n": 11,
						"h": 146,
						"w": 377
					}
				],
				"ball": {
					"n": 0,
					"h": 269,
					"w": 434,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 31
		},
		{
			"num": 581,
			"minute": 28,
			"messages": [
				{
					"owner": 2,
					"mes": "О.Дюмон[26](Опава) пасует Н.Мансуру[23](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 19
					},
					{
						"n": 2,
						"h": 130,
						"w": 256
					},
					{
						"n": 3,
						"h": 254,
						"w": 253
					},
					{
						"n": 4,
						"h": 288,
						"w": 254
					},
					{
						"n": 5,
						"h": 340,
						"w": 263
					},
					{
						"n": 6,
						"h": 55,
						"w": 300
					},
					{
						"n": 7,
						"h": 227,
						"w": 355
					},
					{
						"n": 8,
						"h": 297,
						"w": 334
					},
					{
						"n": 9,
						"h": 385,
						"w": 303
					},
					{
						"n": 10,
						"h": 148,
						"w": 439
					},
					{
						"n": 11,
						"h": 284,
						"w": 473
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 16
					},
					{
						"n": 2,
						"h": 74,
						"w": 171
					},
					{
						"n": 3,
						"h": 185,
						"w": 157
					},
					{
						"n": 4,
						"h": 262,
						"w": 183
					},
					{
						"n": 5,
						"h": 389,
						"w": 121
					},
					{
						"n": 6,
						"h": 183,
						"w": 277
					},
					{
						"n": 7,
						"h": 226,
						"w": 322
					},
					{
						"n": 8,
						"h": 392,
						"w": 420
					},
					{
						"n": 9,
						"h": 58,
						"w": 420
					},
					{
						"n": 10,
						"h": 173,
						"w": 420
					},
					{
						"n": 11,
						"h": 146,
						"w": 364
					}
				],
				"ball": {
					"n": 0,
					"h": 265,
					"w": 563,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 43
		},
		{
			"num": 582,
			"minute": 28,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 14
					},
					{
						"n": 2,
						"h": 120,
						"w": 264
					},
					{
						"n": 3,
						"h": 239,
						"w": 253
					},
					{
						"n": 4,
						"h": 284,
						"w": 263
					},
					{
						"n": 5,
						"h": 330,
						"w": 268
					},
					{
						"n": 6,
						"h": 56,
						"w": 285
					},
					{
						"n": 7,
						"h": 196,
						"w": 330
					},
					{
						"n": 8,
						"h": 268,
						"w": 332
					},
					{
						"n": 9,
						"h": 394,
						"w": 285
					},
					{
						"n": 10,
						"h": 144,
						"w": 450
					},
					{
						"n": 11,
						"h": 258,
						"w": 503
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 36
					},
					{
						"n": 2,
						"h": 59,
						"w": 202
					},
					{
						"n": 3,
						"h": 199,
						"w": 190
					},
					{
						"n": 4,
						"h": 270,
						"w": 162
					},
					{
						"n": 5,
						"h": 378,
						"w": 170
					},
					{
						"n": 6,
						"h": 199,
						"w": 248
					},
					{
						"n": 7,
						"h": 210,
						"w": 309
					},
					{
						"n": 8,
						"h": 413,
						"w": 420
					},
					{
						"n": 9,
						"h": 37,
						"w": 420
					},
					{
						"n": 10,
						"h": 160,
						"w": 430
					},
					{
						"n": 11,
						"h": 186,
						"w": 367
					}
				],
				"ball": {
					"n": 0,
					"h": 251,
					"w": 530,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 583,
			"minute": 28,
			"messages": [
				{
					"owner": 2,
					"mes": "Игра накоротке..."
				},
				{
					"owner": 2,
					"mes": "Себастьян Пейша[24](Опава) принимает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 16
					},
					{
						"n": 2,
						"h": 120,
						"w": 266
					},
					{
						"n": 3,
						"h": 247,
						"w": 265
					},
					{
						"n": 4,
						"h": 287,
						"w": 264
					},
					{
						"n": 5,
						"h": 330,
						"w": 270
					},
					{
						"n": 6,
						"h": 64,
						"w": 275
					},
					{
						"n": 7,
						"h": 192,
						"w": 338
					},
					{
						"n": 8,
						"h": 246,
						"w": 331
					},
					{
						"n": 9,
						"h": 394,
						"w": 285
					},
					{
						"n": 10,
						"h": 161,
						"w": 424
					},
					{
						"n": 11,
						"h": 287,
						"w": 477
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 10
					},
					{
						"n": 2,
						"h": 64,
						"w": 171
					},
					{
						"n": 3,
						"h": 197,
						"w": 180
					},
					{
						"n": 4,
						"h": 264,
						"w": 200
					},
					{
						"n": 5,
						"h": 378,
						"w": 131
					},
					{
						"n": 6,
						"h": 203,
						"w": 209
					},
					{
						"n": 7,
						"h": 221,
						"w": 284
					},
					{
						"n": 8,
						"h": 401,
						"w": 420
					},
					{
						"n": 9,
						"h": 34,
						"w": 420
					},
					{
						"n": 10,
						"h": 151,
						"w": 426
					},
					{
						"n": 11,
						"h": 203,
						"w": 344
					}
				],
				"ball": {
					"n": 0,
					"h": 186,
					"w": 520,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 584,
			"minute": 28,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 15
					},
					{
						"n": 2,
						"h": 80,
						"w": 262
					},
					{
						"n": 3,
						"h": 223,
						"w": 234
					},
					{
						"n": 4,
						"h": 285,
						"w": 234
					},
					{
						"n": 5,
						"h": 330,
						"w": 236
					},
					{
						"n": 6,
						"h": 60,
						"w": 315
					},
					{
						"n": 7,
						"h": 176,
						"w": 326
					},
					{
						"n": 8,
						"h": 271,
						"w": 308
					},
					{
						"n": 9,
						"h": 388,
						"w": 325
					},
					{
						"n": 10,
						"h": 171,
						"w": 398
					},
					{
						"n": 11,
						"h": 280,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 228,
						"w": 27
					},
					{
						"n": 2,
						"h": 60,
						"w": 211
					},
					{
						"n": 3,
						"h": 170,
						"w": 177
					},
					{
						"n": 4,
						"h": 281,
						"w": 231
					},
					{
						"n": 5,
						"h": 388,
						"w": 173
					},
					{
						"n": 6,
						"h": 213,
						"w": 248
					},
					{
						"n": 7,
						"h": 229,
						"w": 323
					},
					{
						"n": 8,
						"h": 390,
						"w": 440
					},
					{
						"n": 9,
						"h": 30,
						"w": 440
					},
					{
						"n": 10,
						"h": 169,
						"w": 462
					},
					{
						"n": 11,
						"h": 173,
						"w": 370
					}
				],
				"ball": {
					"n": 0,
					"h": 169,
					"w": 489,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 585,
			"minute": 28,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 19
					},
					{
						"n": 2,
						"h": 77,
						"w": 224
					},
					{
						"n": 3,
						"h": 222,
						"w": 196
					},
					{
						"n": 4,
						"h": 286,
						"w": 196
					},
					{
						"n": 5,
						"h": 368,
						"w": 227
					},
					{
						"n": 6,
						"h": 58,
						"w": 296
					},
					{
						"n": 7,
						"h": 189,
						"w": 289
					},
					{
						"n": 8,
						"h": 274,
						"w": 269
					},
					{
						"n": 9,
						"h": 393,
						"w": 306
					},
					{
						"n": 10,
						"h": 169,
						"w": 359
					},
					{
						"n": 11,
						"h": 241,
						"w": 447
					}
				],
				"away": [
					{
						"n": 1,
						"h": 226,
						"w": 46
					},
					{
						"n": 2,
						"h": 66,
						"w": 249
					},
					{
						"n": 3,
						"h": 176,
						"w": 215
					},
					{
						"n": 4,
						"h": 276,
						"w": 265
					},
					{
						"n": 5,
						"h": 386,
						"w": 212
					},
					{
						"n": 6,
						"h": 211,
						"w": 287
					},
					{
						"n": 7,
						"h": 229,
						"w": 362
					},
					{
						"n": 8,
						"h": 403,
						"w": 476
					},
					{
						"n": 9,
						"h": 27,
						"w": 478
					},
					{
						"n": 10,
						"h": 163,
						"w": 500
					},
					{
						"n": 11,
						"h": 168,
						"w": 409
					}
				],
				"ball": {
					"n": 0,
					"h": 174,
					"w": 455,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 586,
			"minute": 28,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 16
					},
					{
						"n": 2,
						"h": 66,
						"w": 186
					},
					{
						"n": 3,
						"h": 222,
						"w": 157
					},
					{
						"n": 4,
						"h": 294,
						"w": 157
					},
					{
						"n": 5,
						"h": 361,
						"w": 189
					},
					{
						"n": 6,
						"h": 53,
						"w": 278
					},
					{
						"n": 7,
						"h": 199,
						"w": 251
					},
					{
						"n": 8,
						"h": 282,
						"w": 230
					},
					{
						"n": 9,
						"h": 397,
						"w": 288
					},
					{
						"n": 10,
						"h": 169,
						"w": 398
					},
					{
						"n": 11,
						"h": 279,
						"w": 438
					}
				],
				"away": [
					{
						"n": 1,
						"h": 228,
						"w": 65
					},
					{
						"n": 2,
						"h": 63,
						"w": 288
					},
					{
						"n": 3,
						"h": 180,
						"w": 254
					},
					{
						"n": 4,
						"h": 281,
						"w": 299
					},
					{
						"n": 5,
						"h": 390,
						"w": 251
					},
					{
						"n": 6,
						"h": 212,
						"w": 326
					},
					{
						"n": 7,
						"h": 226,
						"w": 401
					},
					{
						"n": 8,
						"h": 414,
						"w": 514
					},
					{
						"n": 9,
						"h": 24,
						"w": 517
					},
					{
						"n": 10,
						"h": 149,
						"w": 537
					},
					{
						"n": 11,
						"h": 157,
						"w": 446
					}
				],
				"ball": {
					"n": 0,
					"h": 169,
					"w": 421,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 587,
			"minute": 28,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 19
					},
					{
						"n": 2,
						"h": 56,
						"w": 158
					},
					{
						"n": 3,
						"h": 220,
						"w": 117
					},
					{
						"n": 4,
						"h": 307,
						"w": 120
					},
					{
						"n": 5,
						"h": 357,
						"w": 149
					},
					{
						"n": 6,
						"h": 50,
						"w": 258
					},
					{
						"n": 7,
						"h": 193,
						"w": 211
					},
					{
						"n": 8,
						"h": 288,
						"w": 191
					},
					{
						"n": 9,
						"h": 402,
						"w": 268
					},
					{
						"n": 10,
						"h": 139,
						"w": 383
					},
					{
						"n": 11,
						"h": 276,
						"w": 429
					}
				],
				"away": [
					{
						"n": 1,
						"h": 229,
						"w": 82
					},
					{
						"n": 2,
						"h": 68,
						"w": 322
					},
					{
						"n": 3,
						"h": 174,
						"w": 280
					},
					{
						"n": 4,
						"h": 311,
						"w": 317
					},
					{
						"n": 5,
						"h": 376,
						"w": 288
					},
					{
						"n": 6,
						"h": 226,
						"w": 363
					},
					{
						"n": 7,
						"h": 221,
						"w": 440
					},
					{
						"n": 8,
						"h": 425,
						"w": 551
					},
					{
						"n": 9,
						"h": 23,
						"w": 557
					},
					{
						"n": 10,
						"h": 136,
						"w": 575
					},
					{
						"n": 11,
						"h": 154,
						"w": 486
					}
				],
				"ball": {
					"n": 0,
					"h": 139,
					"w": 403,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 588,
			"minute": 28,
			"messages": [
				{
					"owner": 2,
					"mes": "Себастьян Пейша[24](Опава) пасует налево..."
				},
				{
					"owner": 2,
					"mes": "Оливье Дюмон[26](Опава) получает передачу..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 14
					},
					{
						"n": 2,
						"h": 61,
						"w": 130
					},
					{
						"n": 3,
						"h": 253,
						"w": 102
					},
					{
						"n": 4,
						"h": 299,
						"w": 107
					},
					{
						"n": 5,
						"h": 384,
						"w": 130
					},
					{
						"n": 6,
						"h": 51,
						"w": 242
					},
					{
						"n": 7,
						"h": 185,
						"w": 176
					},
					{
						"n": 8,
						"h": 294,
						"w": 177
					},
					{
						"n": 9,
						"h": 411,
						"w": 233
					},
					{
						"n": 10,
						"h": 173,
						"w": 374
					},
					{
						"n": 11,
						"h": 277,
						"w": 435
					}
				],
				"away": [
					{
						"n": 1,
						"h": 228,
						"w": 99
					},
					{
						"n": 2,
						"h": 58,
						"w": 306
					},
					{
						"n": 3,
						"h": 173,
						"w": 266
					},
					{
						"n": 4,
						"h": 305,
						"w": 309
					},
					{
						"n": 5,
						"h": 374,
						"w": 260
					},
					{
						"n": 6,
						"h": 247,
						"w": 335
					},
					{
						"n": 7,
						"h": 220,
						"w": 435
					},
					{
						"n": 8,
						"h": 419,
						"w": 570
					},
					{
						"n": 9,
						"h": 36,
						"w": 570
					},
					{
						"n": 10,
						"h": 172,
						"w": 579
					},
					{
						"n": 11,
						"h": 146,
						"w": 514
					}
				],
				"ball": {
					"n": 0,
					"h": 203,
					"w": 385,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 36
		},
		{
			"num": 589,
			"minute": 28,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 15
					},
					{
						"n": 2,
						"h": 60,
						"w": 163
					},
					{
						"n": 3,
						"h": 222,
						"w": 105
					},
					{
						"n": 4,
						"h": 305,
						"w": 105
					},
					{
						"n": 5,
						"h": 394,
						"w": 145
					},
					{
						"n": 6,
						"h": 43,
						"w": 204
					},
					{
						"n": 7,
						"h": 182,
						"w": 175
					},
					{
						"n": 8,
						"h": 302,
						"w": 159
					},
					{
						"n": 9,
						"h": 396,
						"w": 204
					},
					{
						"n": 10,
						"h": 198,
						"w": 343
					},
					{
						"n": 11,
						"h": 276,
						"w": 432
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 124
					},
					{
						"n": 2,
						"h": 74,
						"w": 314
					},
					{
						"n": 3,
						"h": 174,
						"w": 278
					},
					{
						"n": 4,
						"h": 273,
						"w": 286
					},
					{
						"n": 5,
						"h": 379,
						"w": 290
					},
					{
						"n": 6,
						"h": 243,
						"w": 369
					},
					{
						"n": 7,
						"h": 226,
						"w": 473
					},
					{
						"n": 8,
						"h": 420,
						"w": 537
					},
					{
						"n": 9,
						"h": 24,
						"w": 555
					},
					{
						"n": 10,
						"h": 148,
						"w": 576
					},
					{
						"n": 11,
						"h": 132,
						"w": 486
					}
				],
				"ball": {
					"n": 0,
					"h": 207,
					"w": 351,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 590,
			"minute": 28,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 16
					},
					{
						"n": 2,
						"h": 79,
						"w": 128
					},
					{
						"n": 3,
						"h": 243,
						"w": 109
					},
					{
						"n": 4,
						"h": 276,
						"w": 97
					},
					{
						"n": 5,
						"h": 394,
						"w": 142
					},
					{
						"n": 6,
						"h": 55,
						"w": 166
					},
					{
						"n": 7,
						"h": 180,
						"w": 177
					},
					{
						"n": 8,
						"h": 270,
						"w": 183
					},
					{
						"n": 9,
						"h": 412,
						"w": 207
					},
					{
						"n": 10,
						"h": 230,
						"w": 320
					},
					{
						"n": 11,
						"h": 267,
						"w": 432
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 127
					},
					{
						"n": 2,
						"h": 74,
						"w": 321
					},
					{
						"n": 3,
						"h": 183,
						"w": 277
					},
					{
						"n": 4,
						"h": 283,
						"w": 258
					},
					{
						"n": 5,
						"h": 390,
						"w": 264
					},
					{
						"n": 6,
						"h": 212,
						"w": 386
					},
					{
						"n": 7,
						"h": 212,
						"w": 511
					},
					{
						"n": 8,
						"h": 420,
						"w": 522
					},
					{
						"n": 9,
						"h": 20,
						"w": 558
					},
					{
						"n": 10,
						"h": 144,
						"w": 576
					},
					{
						"n": 11,
						"h": 153,
						"w": 486
					}
				],
				"ball": {
					"n": 0,
					"h": 238,
					"w": 334,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 591,
			"minute": 29,
			"possession": 43,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 14
					},
					{
						"n": 2,
						"h": 113,
						"w": 106
					},
					{
						"n": 3,
						"h": 226,
						"w": 111
					},
					{
						"n": 4,
						"h": 268,
						"w": 97,
						"m": 650
					},
					{
						"n": 5,
						"h": 394,
						"w": 110
					},
					{
						"n": 6,
						"h": 56,
						"w": 126
					},
					{
						"n": 7,
						"h": 193,
						"w": 182
					},
					{
						"n": 8,
						"h": 236,
						"w": 162,
						"f": 89,
						"c": 1
					},
					{
						"n": 9,
						"h": 393,
						"w": 205
					},
					{
						"n": 10,
						"h": 207,
						"w": 331
					},
					{
						"n": 11,
						"h": 307,
						"w": 430,
						"f": 90
					}
				],
				"away": [
					{
						"n": 1,
						"h": 223,
						"w": 126
					},
					{
						"n": 2,
						"h": 63,
						"w": 314,
						"f": 88
					},
					{
						"n": 3,
						"h": 168,
						"w": 266
					},
					{
						"n": 4,
						"h": 264,
						"w": 287,
						"f": 90
					},
					{
						"n": 5,
						"h": 381,
						"w": 269
					},
					{
						"n": 6,
						"h": 243,
						"w": 369
					},
					{
						"n": 7,
						"h": 221,
						"w": 550,
						"f": 92
					},
					{
						"n": 8,
						"h": 412,
						"w": 561,
						"f": 90
					},
					{
						"n": 9,
						"h": 37,
						"w": 594
					},
					{
						"n": 10,
						"h": 164,
						"w": 598,
						"f": 89,
						"c": 1
					},
					{
						"n": 11,
						"h": 144,
						"w": 525,
						"f": 89,
						"c": 1
					}
				],
				"ball": {
					"n": 0,
					"h": 207,
					"w": 351,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 592,
			"minute": 29,
			"messages": [
				{
					"owner": 2,
					"mes": "Оливье Дюмон[26](Опава) переправляет мяч на ход Ш.Товареку[31](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 232,
						"w": 13
					},
					{
						"n": 2,
						"h": 120,
						"w": 90
					},
					{
						"n": 3,
						"h": 226,
						"w": 88
					},
					{
						"n": 4,
						"h": 272,
						"w": 85
					},
					{
						"n": 5,
						"h": 366,
						"w": 116
					},
					{
						"n": 6,
						"h": 56,
						"w": 110
					},
					{
						"n": 7,
						"h": 232,
						"w": 146
					},
					{
						"n": 8,
						"h": 283,
						"w": 152
					},
					{
						"n": 9,
						"h": 393,
						"w": 195
					},
					{
						"n": 10,
						"h": 186,
						"w": 380
					},
					{
						"n": 11,
						"h": 283,
						"w": 414
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 125
					},
					{
						"n": 2,
						"h": 68,
						"w": 333
					},
					{
						"n": 3,
						"h": 167,
						"w": 293
					},
					{
						"n": 4,
						"h": 273,
						"w": 285
					},
					{
						"n": 5,
						"h": 381,
						"w": 283
					},
					{
						"n": 6,
						"h": 243,
						"w": 369,
						"m": 640
					},
					{
						"n": 7,
						"h": 222,
						"w": 559
					},
					{
						"n": 8,
						"h": 418,
						"w": 578
					},
					{
						"n": 9,
						"h": 54,
						"w": 584
					},
					{
						"n": 10,
						"h": 162,
						"w": 608
					},
					{
						"n": 11,
						"h": 144,
						"w": 555
					}
				],
				"ball": {
					"n": 0,
					"h": 306,
					"w": 165,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 53
		},
		{
			"num": 593,
			"minute": 29,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 231,
						"w": 14
					},
					{
						"n": 2,
						"h": 120,
						"w": 93
					},
					{
						"n": 3,
						"h": 228,
						"w": 86
					},
					{
						"n": 4,
						"h": 271,
						"w": 80
					},
					{
						"n": 5,
						"h": 384,
						"w": 124
					},
					{
						"n": 6,
						"h": 65,
						"w": 100
					},
					{
						"n": 7,
						"h": 233,
						"w": 158
					},
					{
						"n": 8,
						"h": 292,
						"w": 160
					},
					{
						"n": 9,
						"h": 393,
						"w": 195
					},
					{
						"n": 10,
						"h": 172,
						"w": 394
					},
					{
						"n": 11,
						"h": 303,
						"w": 416
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 124
					},
					{
						"n": 2,
						"h": 58,
						"w": 329
					},
					{
						"n": 3,
						"h": 171,
						"w": 282
					},
					{
						"n": 4,
						"h": 284,
						"w": 302
					},
					{
						"n": 5,
						"h": 376,
						"w": 290
					},
					{
						"n": 6,
						"h": 235,
						"w": 387
					},
					{
						"n": 7,
						"h": 218,
						"w": 557
					},
					{
						"n": 8,
						"h": 400,
						"w": 587
					},
					{
						"n": 9,
						"h": 56,
						"w": 588
					},
					{
						"n": 10,
						"h": 165,
						"w": 618
					},
					{
						"n": 11,
						"h": 154,
						"w": 551
					}
				],
				"ball": {
					"n": 0,
					"h": 296,
					"w": 169,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 20
		},
		{
			"num": 594,
			"minute": 29,
			"messages": [
				{
					"owner": 2,
					"mes": "Шимон Товарек[31](Опава) закрывает мяч от соперника..."
				},
				{
					"owner": 2,
					"mes": "Шимон Товарек[31](Опава) движением корпуса продавливает К.Нолана[08](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 231,
						"w": 14
					},
					{
						"n": 2,
						"h": 120,
						"w": 93
					},
					{
						"n": 3,
						"h": 228,
						"w": 86
					},
					{
						"n": 4,
						"h": 271,
						"w": 80
					},
					{
						"n": 5,
						"h": 386,
						"w": 125
					},
					{
						"n": 6,
						"h": 65,
						"w": 100
					},
					{
						"n": 7,
						"h": 233,
						"w": 158
					},
					{
						"n": 8,
						"h": 292,
						"w": 160,
						"m": 590
					},
					{
						"n": 9,
						"h": 394,
						"w": 185
					},
					{
						"n": 10,
						"h": 166,
						"w": 400
					},
					{
						"n": 11,
						"h": 314,
						"w": 417
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 124
					},
					{
						"n": 2,
						"h": 58,
						"w": 329
					},
					{
						"n": 3,
						"h": 171,
						"w": 282
					},
					{
						"n": 4,
						"h": 285,
						"w": 303
					},
					{
						"n": 5,
						"h": 376,
						"w": 290
					},
					{
						"n": 6,
						"h": 230,
						"w": 401
					},
					{
						"n": 7,
						"h": 218,
						"w": 557
					},
					{
						"n": 8,
						"h": 399,
						"w": 588
					},
					{
						"n": 9,
						"h": 56,
						"w": 588
					},
					{
						"n": 10,
						"h": 165,
						"w": 618
					},
					{
						"n": 11,
						"h": 164,
						"w": 561,
						"m": 620
					}
				],
				"ball": {
					"n": 0,
					"h": 286,
					"w": 159,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 15
		},
		{
			"num": 595,
			"minute": 29,
			"messages": [
				{
					"owner": 2,
					"mes": "Шимон Товарек[31](Опава) наносит удар с дальней дистанции..."
				},
				{
					"owner": 2,
					"mes": "Мяч летит выше ворот."
				}
			],
			"U": {
				"team": 2,
				"player": 11,
				"xg": "0.02"
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 205,
						"w": 14
					},
					{
						"n": 2,
						"h": 120,
						"w": 73
					},
					{
						"n": 3,
						"h": 217,
						"w": 79
					},
					{
						"n": 4,
						"h": 281,
						"w": 81
					},
					{
						"n": 5,
						"h": 367,
						"w": 86
					},
					{
						"n": 6,
						"h": 56,
						"w": 95
					},
					{
						"n": 7,
						"h": 219,
						"w": 127
					},
					{
						"n": 8,
						"h": 291,
						"w": 139
					},
					{
						"n": 9,
						"h": 416,
						"w": 180
					},
					{
						"n": 10,
						"h": 185,
						"w": 397
					},
					{
						"n": 11,
						"h": 306,
						"w": 407
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 119
					},
					{
						"n": 2,
						"h": 59,
						"w": 341
					},
					{
						"n": 3,
						"h": 182,
						"w": 283
					},
					{
						"n": 4,
						"h": 265,
						"w": 297
					},
					{
						"n": 5,
						"h": 392,
						"w": 303
					},
					{
						"n": 6,
						"h": 219,
						"w": 437
					},
					{
						"n": 7,
						"h": 228,
						"w": 578
					},
					{
						"n": 8,
						"h": 409,
						"w": 598
					},
					{
						"n": 9,
						"h": 48,
						"w": 598
					},
					{
						"n": 10,
						"h": 152,
						"w": 620
					},
					{
						"n": 11,
						"h": 164,
						"w": 561
					}
				],
				"ball": {
					"n": 0,
					"h": 188,
					"w": -30,
					"z": 1,
					"r": 0,
					"p": 0,
					"x": 4
				}
			},
			"interval": 43
		},
		{
			"num": 596,
			"minute": 29,
			"messages": [
				{
					"owner": 1,
					"mes": "Удар от ворот..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 188,
						"w": 14
					},
					{
						"n": 2,
						"h": 66,
						"w": 205,
						"m": 630
					},
					{
						"n": 3,
						"h": 170,
						"w": 205
					},
					{
						"n": 4,
						"h": 286,
						"w": 205
					},
					{
						"n": 5,
						"h": 389,
						"w": 205
					},
					{
						"n": 6,
						"h": 73,
						"w": 332
					},
					{
						"n": 7,
						"h": 175,
						"w": 352
					},
					{
						"n": 8,
						"h": 282,
						"w": 352
					},
					{
						"n": 9,
						"h": 376,
						"w": 332
					},
					{
						"n": 10,
						"h": 164,
						"w": 500
					},
					{
						"n": 11,
						"h": 294,
						"w": 500
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 40
					},
					{
						"n": 2,
						"h": 68,
						"w": 150
					},
					{
						"n": 3,
						"h": 175,
						"w": 130
					},
					{
						"n": 4,
						"h": 281,
						"w": 130
					},
					{
						"n": 5,
						"h": 376,
						"w": 158
					},
					{
						"n": 6,
						"h": 227,
						"w": 200
					},
					{
						"n": 7,
						"h": 215,
						"w": 348
					},
					{
						"n": 8,
						"h": 377,
						"w": 368
					},
					{
						"n": 9,
						"h": 77,
						"w": 420
					},
					{
						"n": 10,
						"h": 174,
						"w": 448
					},
					{
						"n": 11,
						"h": 286,
						"w": 448
					}
				],
				"ball": {
					"n": 0,
					"h": 190,
					"w": 34,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 150
		},
		{
			"num": 597,
			"minute": 29,
			"messages": [],
			"T": {
				"team": 1
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 190,
						"w": 34
					},
					{
						"n": 2,
						"h": 64,
						"w": 212
					},
					{
						"n": 3,
						"h": 163,
						"w": 199
					},
					{
						"n": 4,
						"h": 291,
						"w": 205
					},
					{
						"n": 5,
						"h": 384,
						"w": 198
					},
					{
						"n": 6,
						"h": 67,
						"w": 330
					},
					{
						"n": 7,
						"h": 179,
						"w": 353
					},
					{
						"n": 8,
						"h": 278,
						"w": 355
					},
					{
						"n": 9,
						"h": 383,
						"w": 338
					},
					{
						"n": 10,
						"h": 171,
						"w": 494
					},
					{
						"n": 11,
						"h": 294,
						"w": 507
					}
				],
				"away": [
					{
						"n": 1,
						"h": 223,
						"w": 38
					},
					{
						"n": 2,
						"h": 63,
						"w": 146
					},
					{
						"n": 3,
						"h": 178,
						"w": 130
					},
					{
						"n": 4,
						"h": 278,
						"w": 130
					},
					{
						"n": 5,
						"h": 374,
						"w": 154
					},
					{
						"n": 6,
						"h": 225,
						"w": 195
					},
					{
						"n": 7,
						"h": 210,
						"w": 346
					},
					{
						"n": 8,
						"h": 370,
						"w": 371
					},
					{
						"n": 9,
						"h": 76,
						"w": 421
					},
					{
						"n": 10,
						"h": 175,
						"w": 444
					},
					{
						"n": 11,
						"h": 280,
						"w": 454
					}
				],
				"ball": {
					"n": 0,
					"h": 190,
					"w": 34,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 15
		},
		{
			"num": 598,
			"minute": 29,
			"messages": [
				{
					"owner": 1,
					"mes": "Мэттью Глэдхилл[01](Галвэй Юнайтед) бьет вперед..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 24
					},
					{
						"n": 2,
						"h": 71,
						"w": 246
					},
					{
						"n": 3,
						"h": 179,
						"w": 213
					},
					{
						"n": 4,
						"h": 278,
						"w": 207
					},
					{
						"n": 5,
						"h": 384,
						"w": 255
					},
					{
						"n": 6,
						"h": 50,
						"w": 365
					},
					{
						"n": 7,
						"h": 176,
						"w": 353
					},
					{
						"n": 8,
						"h": 298,
						"w": 434
					},
					{
						"n": 9,
						"h": 398,
						"w": 419
					},
					{
						"n": 10,
						"h": 206,
						"w": 445
					},
					{
						"n": 11,
						"h": 294,
						"w": 507
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 73
					},
					{
						"n": 2,
						"h": 110,
						"w": 110
					},
					{
						"n": 3,
						"h": 175,
						"w": 101
					},
					{
						"n": 4,
						"h": 243,
						"w": 99
					},
					{
						"n": 5,
						"h": 340,
						"w": 103
					},
					{
						"n": 6,
						"h": 244,
						"w": 275
					},
					{
						"n": 7,
						"h": 213,
						"w": 264
					},
					{
						"n": 8,
						"h": 400,
						"w": 319
					},
					{
						"n": 9,
						"h": 52,
						"w": 343
					},
					{
						"n": 10,
						"h": 172,
						"w": 362
					},
					{
						"n": 11,
						"h": 275,
						"w": 372
					}
				],
				"ball": {
					"n": 0,
					"h": 206,
					"w": 445,
					"z": 1,
					"r": 0,
					"p": 4,
					"x": 0
				}
			},
			"interval": 82
		},
		{
			"num": 599,
			"minute": 29,
			"messages": [
				{
					"owner": 1,
					"mes": "Джо Квигли[10](Галвэй Юнайтед) перепрыгивает О.Дюмона[26](Опава) и скидывает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 18
					},
					{
						"n": 2,
						"h": 66,
						"w": 260
					},
					{
						"n": 3,
						"h": 185,
						"w": 215
					},
					{
						"n": 4,
						"h": 278,
						"w": 203
					},
					{
						"n": 5,
						"h": 385,
						"w": 262
					},
					{
						"n": 6,
						"h": 62,
						"w": 395
					},
					{
						"n": 7,
						"h": 148,
						"w": 338
					},
					{
						"n": 8,
						"h": 321,
						"w": 454
					},
					{
						"n": 9,
						"h": 368,
						"w": 431
					},
					{
						"n": 10,
						"h": 200,
						"w": 448
					},
					{
						"n": 11,
						"h": 291,
						"w": 488
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 41
					},
					{
						"n": 2,
						"h": 110,
						"w": 104
					},
					{
						"n": 3,
						"h": 171,
						"w": 107
					},
					{
						"n": 4,
						"h": 255,
						"w": 89
					},
					{
						"n": 5,
						"h": 340,
						"w": 97
					},
					{
						"n": 6,
						"h": 244,
						"w": 275,
						"m": 630
					},
					{
						"n": 7,
						"h": 205,
						"w": 233
					},
					{
						"n": 8,
						"h": 388,
						"w": 289
					},
					{
						"n": 9,
						"h": 49,
						"w": 311
					},
					{
						"n": 10,
						"h": 169,
						"w": 330
					},
					{
						"n": 11,
						"h": 281,
						"w": 341
					}
				],
				"ball": {
					"n": 0,
					"h": 291,
					"w": 488,
					"z": 1,
					"r": 0,
					"p": 4,
					"x": 0
				}
			},
			"interval": 32
		},
		{
			"num": 600,
			"minute": 29,
			"messages": [
				{
					"owner": 1,
					"mes": "Адам Гилберт[11](Галвэй Юнайтед) скидывает мяч головой..."
				},
				{
					"owner": 1,
					"mes": "Киран Нолан[08](Галвэй Юнайтед) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 10
					},
					{
						"n": 2,
						"h": 64,
						"w": 260
					},
					{
						"n": 3,
						"h": 172,
						"w": 214
					},
					{
						"n": 4,
						"h": 282,
						"w": 210
					},
					{
						"n": 5,
						"h": 389,
						"w": 256
					},
					{
						"n": 6,
						"h": 60,
						"w": 425
					},
					{
						"n": 7,
						"h": 178,
						"w": 335
					},
					{
						"n": 8,
						"h": 331,
						"w": 443
					},
					{
						"n": 9,
						"h": 376,
						"w": 460
					},
					{
						"n": 10,
						"h": 196,
						"w": 478
					},
					{
						"n": 11,
						"h": 291,
						"w": 488,
						"m": 790
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 19
					},
					{
						"n": 2,
						"h": 110,
						"w": 114
					},
					{
						"n": 3,
						"h": 155,
						"w": 100
					},
					{
						"n": 4,
						"h": 234,
						"w": 87
					},
					{
						"n": 5,
						"h": 340,
						"w": 99
					},
					{
						"n": 6,
						"h": 232,
						"w": 248
					},
					{
						"n": 7,
						"h": 205,
						"w": 233
					},
					{
						"n": 8,
						"h": 390,
						"w": 259
					},
					{
						"n": 9,
						"h": 47,
						"w": 281
					},
					{
						"n": 10,
						"h": 175,
						"w": 310
					},
					{
						"n": 11,
						"h": 287,
						"w": 311
					}
				],
				"ball": {
					"n": 0,
					"h": 331,
					"w": 443,
					"z": 1,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 30
		},
		{
			"num": 601,
			"minute": 29,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 18
					},
					{
						"n": 2,
						"h": 62,
						"w": 300
					},
					{
						"n": 3,
						"h": 176,
						"w": 254
					},
					{
						"n": 4,
						"h": 280,
						"w": 250
					},
					{
						"n": 5,
						"h": 385,
						"w": 296
					},
					{
						"n": 6,
						"h": 57,
						"w": 465
					},
					{
						"n": 7,
						"h": 163,
						"w": 334
					},
					{
						"n": 8,
						"h": 322,
						"w": 489
					},
					{
						"n": 9,
						"h": 384,
						"w": 499
					},
					{
						"n": 10,
						"h": 186,
						"w": 517
					},
					{
						"n": 11,
						"h": 288,
						"w": 527
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 16
					},
					{
						"n": 2,
						"h": 110,
						"w": 108
					},
					{
						"n": 3,
						"h": 174,
						"w": 99
					},
					{
						"n": 4,
						"h": 253,
						"w": 87
					},
					{
						"n": 5,
						"h": 340,
						"w": 103
					},
					{
						"n": 6,
						"h": 198,
						"w": 211
					},
					{
						"n": 7,
						"h": 162,
						"w": 222
					},
					{
						"n": 8,
						"h": 393,
						"w": 219
					},
					{
						"n": 9,
						"h": 34,
						"w": 257
					},
					{
						"n": 10,
						"h": 174,
						"w": 294
					},
					{
						"n": 11,
						"h": 292,
						"w": 308
					}
				],
				"ball": {
					"n": 0,
					"h": 322,
					"w": 489,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 602,
			"minute": 29,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 12
					},
					{
						"n": 2,
						"h": 62,
						"w": 339
					},
					{
						"n": 3,
						"h": 175,
						"w": 294
					},
					{
						"n": 4,
						"h": 272,
						"w": 289
					},
					{
						"n": 5,
						"h": 382,
						"w": 336
					},
					{
						"n": 6,
						"h": 52,
						"w": 504
					},
					{
						"n": 7,
						"h": 166,
						"w": 374
					},
					{
						"n": 8,
						"h": 307,
						"w": 526
					},
					{
						"n": 9,
						"h": 387,
						"w": 539
					},
					{
						"n": 10,
						"h": 180,
						"w": 556
					},
					{
						"n": 11,
						"h": 292,
						"w": 567
					}
				],
				"away": [
					{
						"n": 1,
						"h": 219,
						"w": 14
					},
					{
						"n": 2,
						"h": 110,
						"w": 112
					},
					{
						"n": 3,
						"h": 143,
						"w": 111
					},
					{
						"n": 4,
						"h": 213,
						"w": 91
					},
					{
						"n": 5,
						"h": 300,
						"w": 100
					},
					{
						"n": 6,
						"h": 171,
						"w": 169
					},
					{
						"n": 7,
						"h": 150,
						"w": 179
					},
					{
						"n": 8,
						"h": 398,
						"w": 180
					},
					{
						"n": 9,
						"h": 20,
						"w": 257
					},
					{
						"n": 10,
						"h": 165,
						"w": 302
					},
					{
						"n": 11,
						"h": 284,
						"w": 326
					}
				],
				"ball": {
					"n": 0,
					"h": 307,
					"w": 526,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 603,
			"minute": 29,
			"messages": [
				{
					"owner": 1,
					"mes": "Киран Нолан[08](Галвэй Юнайтед) посылает мяч направо в направлении Э.Бвомоно[09](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 19
					},
					{
						"n": 2,
						"h": 73,
						"w": 339
					},
					{
						"n": 3,
						"h": 179,
						"w": 288
					},
					{
						"n": 4,
						"h": 269,
						"w": 293
					},
					{
						"n": 5,
						"h": 391,
						"w": 346
					},
					{
						"n": 6,
						"h": 59,
						"w": 545
					},
					{
						"n": 7,
						"h": 186,
						"w": 410
					},
					{
						"n": 8,
						"h": 300,
						"w": 533
					},
					{
						"n": 9,
						"h": 380,
						"w": 579
					},
					{
						"n": 10,
						"h": 162,
						"w": 593
					},
					{
						"n": 11,
						"h": 296,
						"w": 608
					}
				],
				"away": [
					{
						"n": 1,
						"h": 214,
						"w": 10
					},
					{
						"n": 2,
						"h": 77,
						"w": 136
					},
					{
						"n": 3,
						"h": 172,
						"w": 96
					},
					{
						"n": 4,
						"h": 221,
						"w": 94
					},
					{
						"n": 5,
						"h": 271,
						"w": 95
					},
					{
						"n": 6,
						"h": 149,
						"w": 140
					},
					{
						"n": 7,
						"h": 188,
						"w": 194
					},
					{
						"n": 8,
						"h": 391,
						"w": 139
					},
					{
						"n": 9,
						"h": 41,
						"w": 242
					},
					{
						"n": 10,
						"h": 156,
						"w": 294
					},
					{
						"n": 11,
						"h": 264,
						"w": 290
					}
				],
				"ball": {
					"n": 0,
					"h": 380,
					"w": 579,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 41
		},
		{
			"num": 604,
			"minute": 29,
			"messages": [
				{
					"owner": 1,
					"mes": "Элвис Бвомоно[09](Галвэй Юнайтед) один в один пытается обыграть Л.Седлачека[22](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 17
					},
					{
						"n": 2,
						"h": 73,
						"w": 345
					},
					{
						"n": 3,
						"h": 177,
						"w": 294
					},
					{
						"n": 4,
						"h": 270,
						"w": 299
					},
					{
						"n": 5,
						"h": 387,
						"w": 351
					},
					{
						"n": 6,
						"h": 58,
						"w": 551
					},
					{
						"n": 7,
						"h": 188,
						"w": 415
					},
					{
						"n": 8,
						"h": 303,
						"w": 538
					},
					{
						"n": 9,
						"h": 380,
						"w": 584
					},
					{
						"n": 10,
						"h": 164,
						"w": 599
					},
					{
						"n": 11,
						"h": 297,
						"w": 614
					}
				],
				"away": [
					{
						"n": 1,
						"h": 214,
						"w": 10
					},
					{
						"n": 2,
						"h": 70,
						"w": 136
					},
					{
						"n": 3,
						"h": 169,
						"w": 91
					},
					{
						"n": 4,
						"h": 227,
						"w": 94
					},
					{
						"n": 5,
						"h": 277,
						"w": 95
					},
					{
						"n": 6,
						"h": 145,
						"w": 147
					},
					{
						"n": 7,
						"h": 194,
						"w": 194
					},
					{
						"n": 8,
						"h": 395,
						"w": 144
					},
					{
						"n": 9,
						"h": 38,
						"w": 237
					},
					{
						"n": 10,
						"h": 160,
						"w": 298
					},
					{
						"n": 11,
						"h": 262,
						"w": 285
					}
				],
				"ball": {
					"n": 0,
					"h": 380,
					"w": 584,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 6
		},
		{
			"num": 605,
			"minute": 29,
			"messages": [
				{
					"owner": 1,
					"mes": "Элвис Бвомоно[09](Галвэй Юнайтед) легко отрывается от Л.Седлачека[22](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 14
					},
					{
						"n": 2,
						"h": 69,
						"w": 365
					},
					{
						"n": 3,
						"h": 181,
						"w": 313
					},
					{
						"n": 4,
						"h": 276,
						"w": 318
					},
					{
						"n": 5,
						"h": 380,
						"w": 369
					},
					{
						"n": 6,
						"h": 57,
						"w": 571
					},
					{
						"n": 7,
						"h": 201,
						"w": 430
					},
					{
						"n": 8,
						"h": 289,
						"w": 552
					},
					{
						"n": 9,
						"h": 372,
						"w": 607
					},
					{
						"n": 10,
						"h": 179,
						"w": 612
					},
					{
						"n": 11,
						"h": 280,
						"w": 624
					}
				],
				"away": [
					{
						"n": 1,
						"h": 213,
						"w": 9
					},
					{
						"n": 2,
						"h": 70,
						"w": 124
					},
					{
						"n": 3,
						"h": 169,
						"w": 71
					},
					{
						"n": 4,
						"h": 243,
						"w": 81
					},
					{
						"n": 5,
						"h": 296,
						"w": 90
					},
					{
						"n": 6,
						"h": 152,
						"w": 147
					},
					{
						"n": 7,
						"h": 214,
						"w": 192
					},
					{
						"n": 8,
						"h": 409,
						"w": 158
					},
					{
						"n": 9,
						"h": 41,
						"w": 227
					},
					{
						"n": 10,
						"h": 164,
						"w": 308
					},
					{
						"n": 11,
						"h": 249,
						"w": 270
					}
				],
				"ball": {
					"n": 0,
					"h": 365,
					"w": 629,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 20
		},
		{
			"num": 606,
			"minute": 29,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 15
					},
					{
						"n": 2,
						"h": 65,
						"w": 373
					},
					{
						"n": 3,
						"h": 169,
						"w": 328
					},
					{
						"n": 4,
						"h": 269,
						"w": 317
					},
					{
						"n": 5,
						"h": 389,
						"w": 361
					},
					{
						"n": 6,
						"h": 54,
						"w": 590
					},
					{
						"n": 7,
						"h": 197,
						"w": 450
					},
					{
						"n": 8,
						"h": 307,
						"w": 561
					},
					{
						"n": 9,
						"h": 365,
						"w": 629
					},
					{
						"n": 10,
						"h": 193,
						"w": 627
					},
					{
						"n": 11,
						"h": 294,
						"w": 639
					}
				],
				"away": [
					{
						"n": 1,
						"h": 212,
						"w": 8
					},
					{
						"n": 2,
						"h": 70,
						"w": 112
					},
					{
						"n": 3,
						"h": 148,
						"w": 74
					},
					{
						"n": 4,
						"h": 223,
						"w": 77
					},
					{
						"n": 5,
						"h": 277,
						"w": 84
					},
					{
						"n": 6,
						"h": 153,
						"w": 122
					},
					{
						"n": 7,
						"h": 213,
						"w": 182
					},
					{
						"n": 8,
						"h": 405,
						"w": 138
					},
					{
						"n": 9,
						"h": 50,
						"w": 212
					},
					{
						"n": 10,
						"h": 162,
						"w": 299
					},
					{
						"n": 11,
						"h": 253,
						"w": 250
					}
				],
				"ball": {
					"n": 0,
					"h": 365,
					"w": 629,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 20
		},
		{
			"num": 607,
			"minute": 29,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 10
					},
					{
						"n": 2,
						"h": 67,
						"w": 380
					},
					{
						"n": 3,
						"h": 173,
						"w": 319
					},
					{
						"n": 4,
						"h": 280,
						"w": 328
					},
					{
						"n": 5,
						"h": 384,
						"w": 370
					},
					{
						"n": 6,
						"h": 48,
						"w": 626
					},
					{
						"n": 7,
						"h": 229,
						"w": 448
					},
					{
						"n": 8,
						"h": 286,
						"w": 591
					},
					{
						"n": 9,
						"h": 365,
						"w": 670,
						"m": 710
					},
					{
						"n": 10,
						"h": 216,
						"w": 654
					},
					{
						"n": 11,
						"h": 302,
						"w": 658
					}
				],
				"away": [
					{
						"n": 1,
						"h": 217,
						"w": 3
					},
					{
						"n": 2,
						"h": 91,
						"w": 76,
						"m": 590
					},
					{
						"n": 3,
						"h": 151,
						"w": 39
					},
					{
						"n": 4,
						"h": 214,
						"w": 46
					},
					{
						"n": 5,
						"h": 313,
						"w": 61
					},
					{
						"n": 6,
						"h": 156,
						"w": 100
					},
					{
						"n": 7,
						"h": 216,
						"w": 148
					},
					{
						"n": 8,
						"h": 404,
						"w": 102
					},
					{
						"n": 9,
						"h": 36,
						"w": 190
					},
					{
						"n": 10,
						"h": 190,
						"w": 277
					},
					{
						"n": 11,
						"h": 278,
						"w": 276
					}
				],
				"ball": {
					"n": 0,
					"h": 365,
					"w": 670,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 36
		},
		{
			"num": 608,
			"minute": 29,
			"messages": [
				{
					"owner": 1,
					"mes": "Э.Бвомоно[09](Галвэй Юнайтед) забрасывает мяч в штрафную..."
				},
				{
					"owner": 1,
					"mes": "Джо Квигли[10](Галвэй Юнайтед) прыгает выше С.Пейши[24](Опава) и наносит удар головой..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 16
					},
					{
						"n": 2,
						"h": 66,
						"w": 377
					},
					{
						"n": 3,
						"h": 166,
						"w": 326
					},
					{
						"n": 4,
						"h": 278,
						"w": 330
					},
					{
						"n": 5,
						"h": 388,
						"w": 366
					},
					{
						"n": 6,
						"h": 46,
						"w": 660
					},
					{
						"n": 7,
						"h": 231,
						"w": 483
					},
					{
						"n": 8,
						"h": 302,
						"w": 622
					},
					{
						"n": 9,
						"h": 365,
						"w": 670,
						"m": 730
					},
					{
						"n": 10,
						"h": 226,
						"w": 687,
						"m": 760
					},
					{
						"n": 11,
						"h": 286,
						"w": 679
					}
				],
				"away": [
					{
						"n": 1,
						"h": 229,
						"w": 12
					},
					{
						"n": 2,
						"h": 91,
						"w": 42
					},
					{
						"n": 3,
						"h": 158,
						"w": 37
					},
					{
						"n": 4,
						"h": 224,
						"w": 33,
						"m": 680
					},
					{
						"n": 5,
						"h": 294,
						"w": 25
					},
					{
						"n": 6,
						"h": 179,
						"w": 83
					},
					{
						"n": 7,
						"h": 216,
						"w": 164
					},
					{
						"n": 8,
						"h": 422,
						"w": 132
					},
					{
						"n": 9,
						"h": 31,
						"w": 190
					},
					{
						"n": 10,
						"h": 205,
						"w": 245
					},
					{
						"n": 11,
						"h": 292,
						"w": 296
					}
				],
				"ball": {
					"n": 0,
					"h": 226,
					"w": 687,
					"z": 1,
					"r": 2,
					"p": 4,
					"x": 6
				}
			},
			"interval": 35
		},
		{
			"num": 609,
			"minute": 29,
			"messages": [
				{
					"owner": 1,
					"mes": "Мяч проходит чуть выше ворот."
				}
			],
			"U": {
				"team": 1,
				"player": 10,
				"xg": "0.31"
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 14
					},
					{
						"n": 2,
						"h": 77,
						"w": 374
					},
					{
						"n": 3,
						"h": 176,
						"w": 317
					},
					{
						"n": 4,
						"h": 277,
						"w": 317
					},
					{
						"n": 5,
						"h": 390,
						"w": 366
					},
					{
						"n": 6,
						"h": 49,
						"w": 660
					},
					{
						"n": 7,
						"h": 224,
						"w": 472
					},
					{
						"n": 8,
						"h": 297,
						"w": 634
					},
					{
						"n": 9,
						"h": 374,
						"w": 661
					},
					{
						"n": 10,
						"h": 226,
						"w": 687,
						"m": 750
					},
					{
						"n": 11,
						"h": 279,
						"w": 676
					}
				],
				"away": [
					{
						"n": 1,
						"h": 216,
						"w": 12
					},
					{
						"n": 2,
						"h": 81,
						"w": 46
					},
					{
						"n": 3,
						"h": 170,
						"w": 35
					},
					{
						"n": 4,
						"h": 224,
						"w": 21
					},
					{
						"n": 5,
						"h": 306,
						"w": 29
					},
					{
						"n": 6,
						"h": 166,
						"w": 81
					},
					{
						"n": 7,
						"h": 219,
						"w": 151
					},
					{
						"n": 8,
						"h": 416,
						"w": 120
					},
					{
						"n": 9,
						"h": 26,
						"w": 190
					},
					{
						"n": 10,
						"h": 199,
						"w": 256
					},
					{
						"n": 11,
						"h": 283,
						"w": 287
					}
				],
				"ball": {
					"n": 0,
					"h": 247,
					"w": 750,
					"z": 1,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 13
		},
		{
			"num": 610,
			"minute": 30,
			"possession": 44,
			"messages": [
				{
					"owner": 2,
					"mes": "Удар от ворот..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 40
					},
					{
						"n": 2,
						"h": 73,
						"w": 178
					},
					{
						"n": 3,
						"h": 161,
						"w": 150,
						"f": 93
					},
					{
						"n": 4,
						"h": 290,
						"w": 150
					},
					{
						"n": 5,
						"h": 368,
						"w": 176
					},
					{
						"n": 6,
						"h": 80,
						"w": 277,
						"f": 90
					},
					{
						"n": 7,
						"h": 177,
						"w": 250
					},
					{
						"n": 8,
						"h": 289,
						"w": 250
					},
					{
						"n": 9,
						"h": 373,
						"w": 271,
						"f": 89,
						"c": 1
					},
					{
						"n": 10,
						"h": 171,
						"w": 350,
						"f": 89,
						"c": 1
					},
					{
						"n": 11,
						"h": 274,
						"w": 350
					}
				],
				"away": [
					{
						"n": 1,
						"h": 187,
						"w": 14
					},
					{
						"n": 2,
						"h": 68,
						"w": 175
					},
					{
						"n": 3,
						"h": 165,
						"w": 175
					},
					{
						"n": 4,
						"h": 280,
						"w": 175
					},
					{
						"n": 5,
						"h": 400,
						"w": 175
					},
					{
						"n": 6,
						"h": 217,
						"w": 283
					},
					{
						"n": 7,
						"h": 230,
						"w": 392
					},
					{
						"n": 8,
						"h": 394,
						"w": 372
					},
					{
						"n": 9,
						"h": 63,
						"w": 422
					},
					{
						"n": 10,
						"h": 158,
						"w": 500
					},
					{
						"n": 11,
						"h": 282,
						"w": 500
					}
				],
				"ball": {
					"n": 0,
					"h": 260,
					"w": 686,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 150
		},
		{
			"num": 611,
			"minute": 30,
			"messages": [],
			"T": {
				"team": 2
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 37
					},
					{
						"n": 2,
						"h": 72,
						"w": 174
					},
					{
						"n": 3,
						"h": 157,
						"w": 146
					},
					{
						"n": 4,
						"h": 291,
						"w": 150
					},
					{
						"n": 5,
						"h": 370,
						"w": 182
					},
					{
						"n": 6,
						"h": 82,
						"w": 282
					},
					{
						"n": 7,
						"h": 177,
						"w": 243
					},
					{
						"n": 8,
						"h": 290,
						"w": 256
					},
					{
						"n": 9,
						"h": 369,
						"w": 269
					},
					{
						"n": 10,
						"h": 176,
						"w": 357
					},
					{
						"n": 11,
						"h": 279,
						"w": 357
					}
				],
				"away": [
					{
						"n": 1,
						"h": 190,
						"w": 34
					},
					{
						"n": 2,
						"h": 67,
						"w": 175
					},
					{
						"n": 3,
						"h": 166,
						"w": 168
					},
					{
						"n": 4,
						"h": 275,
						"w": 178
					},
					{
						"n": 5,
						"h": 404,
						"w": 173
					},
					{
						"n": 6,
						"h": 224,
						"w": 283
					},
					{
						"n": 7,
						"h": 225,
						"w": 387
					},
					{
						"n": 8,
						"h": 398,
						"w": 373
					},
					{
						"n": 9,
						"h": 56,
						"w": 425
					},
					{
						"n": 10,
						"h": 153,
						"w": 494
					},
					{
						"n": 11,
						"h": 281,
						"w": 497
					}
				],
				"ball": {
					"n": 0,
					"h": 260,
					"w": 686,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 15
		},
		{
			"num": 612,
			"minute": 30,
			"messages": [
				{
					"owner": 2,
					"mes": "Крыштоф Ласак[21](Опава) далеко выбивает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 19
					},
					{
						"n": 2,
						"h": 120,
						"w": 133
					},
					{
						"n": 3,
						"h": 216,
						"w": 139
					},
					{
						"n": 4,
						"h": 315,
						"w": 141
					},
					{
						"n": 5,
						"h": 347,
						"w": 134
					},
					{
						"n": 6,
						"h": 56,
						"w": 233
					},
					{
						"n": 7,
						"h": 156,
						"w": 217
					},
					{
						"n": 8,
						"h": 316,
						"w": 213
					},
					{
						"n": 9,
						"h": 395,
						"w": 238
					},
					{
						"n": 10,
						"h": 176,
						"w": 400
					},
					{
						"n": 11,
						"h": 270,
						"w": 371
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 52
					},
					{
						"n": 2,
						"h": 69,
						"w": 224
					},
					{
						"n": 3,
						"h": 164,
						"w": 173
					},
					{
						"n": 4,
						"h": 274,
						"w": 177
					},
					{
						"n": 5,
						"h": 376,
						"w": 203
					},
					{
						"n": 6,
						"h": 210,
						"w": 283
					},
					{
						"n": 7,
						"h": 180,
						"w": 349
					},
					{
						"n": 8,
						"h": 406,
						"w": 452
					},
					{
						"n": 9,
						"h": 135,
						"w": 425
					},
					{
						"n": 10,
						"h": 140,
						"w": 503
					},
					{
						"n": 11,
						"h": 292,
						"w": 428
					}
				],
				"ball": {
					"n": 0,
					"h": 270,
					"w": 371,
					"z": 1,
					"r": 0,
					"p": 4,
					"x": 0
				}
			},
			"interval": 79
		},
		{
			"num": 613,
			"minute": 30,
			"messages": [
				{
					"owner": 1,
					"mes": "Адам Гилберт[11](Галвэй Юнайтед) в борьбе с М.Маноловом[27](Опава) кивком головы скидывает мяч..."
				},
				{
					"owner": 1,
					"mes": "Джо Квигли[10](Галвэй Юнайтед) принимает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 14
					},
					{
						"n": 2,
						"h": 120,
						"w": 112
					},
					{
						"n": 3,
						"h": 218,
						"w": 117
					},
					{
						"n": 4,
						"h": 302,
						"w": 113
					},
					{
						"n": 5,
						"h": 333,
						"w": 106
					},
					{
						"n": 6,
						"h": 56,
						"w": 223
					},
					{
						"n": 7,
						"h": 159,
						"w": 248
					},
					{
						"n": 8,
						"h": 290,
						"w": 200
					},
					{
						"n": 9,
						"h": 393,
						"w": 210
					},
					{
						"n": 10,
						"h": 181,
						"w": 401
					},
					{
						"n": 11,
						"h": 270,
						"w": 372
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 69
					},
					{
						"n": 2,
						"h": 72,
						"w": 232
					},
					{
						"n": 3,
						"h": 175,
						"w": 177
					},
					{
						"n": 4,
						"h": 286,
						"w": 168
					},
					{
						"n": 5,
						"h": 382,
						"w": 173
					},
					{
						"n": 6,
						"h": 232,
						"w": 295
					},
					{
						"n": 7,
						"h": 181,
						"w": 349,
						"m": 550
					},
					{
						"n": 8,
						"h": 412,
						"w": 482
					},
					{
						"n": 9,
						"h": 114,
						"w": 448
					},
					{
						"n": 10,
						"h": 152,
						"w": 497
					},
					{
						"n": 11,
						"h": 292,
						"w": 428
					}
				],
				"ball": {
					"n": 0,
					"h": 181,
					"w": 401,
					"z": 1,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 31
		},
		{
			"num": 614,
			"minute": 30,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 14
					},
					{
						"n": 2,
						"h": 103,
						"w": 148
					},
					{
						"n": 3,
						"h": 196,
						"w": 150
					},
					{
						"n": 4,
						"h": 290,
						"w": 151
					},
					{
						"n": 5,
						"h": 349,
						"w": 143
					},
					{
						"n": 6,
						"h": 52,
						"w": 263
					},
					{
						"n": 7,
						"h": 156,
						"w": 288
					},
					{
						"n": 8,
						"h": 293,
						"w": 240
					},
					{
						"n": 9,
						"h": 395,
						"w": 250
					},
					{
						"n": 10,
						"h": 156,
						"w": 426
					},
					{
						"n": 11,
						"h": 277,
						"w": 412
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 73
					},
					{
						"n": 2,
						"h": 72,
						"w": 192
					},
					{
						"n": 3,
						"h": 194,
						"w": 142
					},
					{
						"n": 4,
						"h": 287,
						"w": 141
					},
					{
						"n": 5,
						"h": 348,
						"w": 151
					},
					{
						"n": 6,
						"h": 270,
						"w": 283
					},
					{
						"n": 7,
						"h": 196,
						"w": 312
					},
					{
						"n": 8,
						"h": 410,
						"w": 442
					},
					{
						"n": 9,
						"h": 94,
						"w": 413
					},
					{
						"n": 10,
						"h": 157,
						"w": 460
					},
					{
						"n": 11,
						"h": 294,
						"w": 412
					}
				],
				"ball": {
					"n": 0,
					"h": 156,
					"w": 426,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 615,
			"minute": 30,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 16
					},
					{
						"n": 2,
						"h": 91,
						"w": 186
					},
					{
						"n": 3,
						"h": 181,
						"w": 188
					},
					{
						"n": 4,
						"h": 283,
						"w": 190
					},
					{
						"n": 5,
						"h": 359,
						"w": 182
					},
					{
						"n": 6,
						"h": 48,
						"w": 302
					},
					{
						"n": 7,
						"h": 155,
						"w": 328
					},
					{
						"n": 8,
						"h": 293,
						"w": 280
					},
					{
						"n": 9,
						"h": 396,
						"w": 290
					},
					{
						"n": 10,
						"h": 139,
						"w": 456
					},
					{
						"n": 11,
						"h": 287,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 74
					},
					{
						"n": 2,
						"h": 82,
						"w": 153
					},
					{
						"n": 3,
						"h": 176,
						"w": 109
					},
					{
						"n": 4,
						"h": 288,
						"w": 132
					},
					{
						"n": 5,
						"h": 340,
						"w": 111
					},
					{
						"n": 6,
						"h": 299,
						"w": 255
					},
					{
						"n": 7,
						"h": 184,
						"w": 274
					},
					{
						"n": 8,
						"h": 412,
						"w": 402
					},
					{
						"n": 9,
						"h": 80,
						"w": 376
					},
					{
						"n": 10,
						"h": 157,
						"w": 420
					},
					{
						"n": 11,
						"h": 295,
						"w": 372
					}
				],
				"ball": {
					"n": 0,
					"h": 139,
					"w": 456,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 616,
			"minute": 30,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 17
					},
					{
						"n": 2,
						"h": 87,
						"w": 221
					},
					{
						"n": 3,
						"h": 178,
						"w": 222
					},
					{
						"n": 4,
						"h": 278,
						"w": 225
					},
					{
						"n": 5,
						"h": 367,
						"w": 216
					},
					{
						"n": 6,
						"h": 53,
						"w": 337
					},
					{
						"n": 7,
						"h": 152,
						"w": 363
					},
					{
						"n": 8,
						"h": 295,
						"w": 315
					},
					{
						"n": 9,
						"h": 394,
						"w": 325
					},
					{
						"n": 10,
						"h": 119,
						"w": 491
					},
					{
						"n": 11,
						"h": 291,
						"w": 485
					}
				],
				"away": [
					{
						"n": 1,
						"h": 245,
						"w": 77
					},
					{
						"n": 2,
						"h": 98,
						"w": 122
					},
					{
						"n": 3,
						"h": 159,
						"w": 104
					},
					{
						"n": 4,
						"h": 276,
						"w": 115
					},
					{
						"n": 5,
						"h": 340,
						"w": 109
					},
					{
						"n": 6,
						"h": 321,
						"w": 218
					},
					{
						"n": 7,
						"h": 176,
						"w": 240
					},
					{
						"n": 8,
						"h": 413,
						"w": 367
					},
					{
						"n": 9,
						"h": 65,
						"w": 344
					},
					{
						"n": 10,
						"h": 155,
						"w": 385
					},
					{
						"n": 11,
						"h": 298,
						"w": 337
					}
				],
				"ball": {
					"n": 0,
					"h": 119,
					"w": 491,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 35
		},
		{
			"num": 617,
			"minute": 30,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 16
					},
					{
						"n": 2,
						"h": 85,
						"w": 255
					},
					{
						"n": 3,
						"h": 175,
						"w": 256
					},
					{
						"n": 4,
						"h": 275,
						"w": 259
					},
					{
						"n": 5,
						"h": 370,
						"w": 250
					},
					{
						"n": 6,
						"h": 52,
						"w": 371
					},
					{
						"n": 7,
						"h": 148,
						"w": 396
					},
					{
						"n": 8,
						"h": 283,
						"w": 347
					},
					{
						"n": 9,
						"h": 393,
						"w": 359
					},
					{
						"n": 10,
						"h": 91,
						"w": 519
					},
					{
						"n": 11,
						"h": 292,
						"w": 519
					}
				],
				"away": [
					{
						"n": 1,
						"h": 245,
						"w": 74
					},
					{
						"n": 2,
						"h": 110,
						"w": 114
					},
					{
						"n": 3,
						"h": 154,
						"w": 108
					},
					{
						"n": 4,
						"h": 280,
						"w": 88
					},
					{
						"n": 5,
						"h": 340,
						"w": 98
					},
					{
						"n": 6,
						"h": 353,
						"w": 190
					},
					{
						"n": 7,
						"h": 160,
						"w": 210
					},
					{
						"n": 8,
						"h": 404,
						"w": 335
					},
					{
						"n": 9,
						"h": 52,
						"w": 312
					},
					{
						"n": 10,
						"h": 167,
						"w": 353
					},
					{
						"n": 11,
						"h": 302,
						"w": 304
					}
				],
				"ball": {
					"n": 0,
					"h": 91,
					"w": 519,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 34
		},
		{
			"num": 618,
			"minute": 30,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 11
					},
					{
						"n": 2,
						"h": 83,
						"w": 263
					},
					{
						"n": 3,
						"h": 177,
						"w": 264
					},
					{
						"n": 4,
						"h": 276,
						"w": 267
					},
					{
						"n": 5,
						"h": 371,
						"w": 258
					},
					{
						"n": 6,
						"h": 51,
						"w": 379
					},
					{
						"n": 7,
						"h": 149,
						"w": 404
					},
					{
						"n": 8,
						"h": 281,
						"w": 354
					},
					{
						"n": 9,
						"h": 395,
						"w": 367
					},
					{
						"n": 10,
						"h": 91,
						"w": 526
					},
					{
						"n": 11,
						"h": 294,
						"w": 527
					}
				],
				"away": [
					{
						"n": 1,
						"h": 244,
						"w": 66
					},
					{
						"n": 2,
						"h": 110,
						"w": 106
					},
					{
						"n": 3,
						"h": 151,
						"w": 101
					},
					{
						"n": 4,
						"h": 272,
						"w": 90
					},
					{
						"n": 5,
						"h": 340,
						"w": 98
					},
					{
						"n": 6,
						"h": 359,
						"w": 194
					},
					{
						"n": 7,
						"h": 162,
						"w": 202
					},
					{
						"n": 8,
						"h": 403,
						"w": 327
					},
					{
						"n": 9,
						"h": 52,
						"w": 304
					},
					{
						"n": 10,
						"h": 168,
						"w": 345
					},
					{
						"n": 11,
						"h": 301,
						"w": 296
					}
				],
				"ball": {
					"n": 0,
					"h": 91,
					"w": 526,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 8
		},
		{
			"num": 619,
			"minute": 30,
			"messages": [
				{
					"owner": 1,
					"mes": "Д.Квигли[10](Галвэй Юнайтед) пытается обыграть О.Дюмона[26](Опава)..."
				},
				{
					"owner": 1,
					"mes": "Уверенный отбор мяча демонстрирует Оливье Дюмон[26](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 11
					},
					{
						"n": 2,
						"h": 82,
						"w": 273
					},
					{
						"n": 3,
						"h": 179,
						"w": 274
					},
					{
						"n": 4,
						"h": 278,
						"w": 277
					},
					{
						"n": 5,
						"h": 373,
						"w": 268
					},
					{
						"n": 6,
						"h": 50,
						"w": 388
					},
					{
						"n": 7,
						"h": 150,
						"w": 414
					},
					{
						"n": 8,
						"h": 279,
						"w": 364
					},
					{
						"n": 9,
						"h": 397,
						"w": 377
					},
					{
						"n": 10,
						"h": 91,
						"w": 536
					},
					{
						"n": 11,
						"h": 296,
						"w": 536
					}
				],
				"away": [
					{
						"n": 1,
						"h": 242,
						"w": 56
					},
					{
						"n": 2,
						"h": 110,
						"w": 104
					},
					{
						"n": 3,
						"h": 151,
						"w": 101
					},
					{
						"n": 4,
						"h": 262,
						"w": 92
					},
					{
						"n": 5,
						"h": 340,
						"w": 98
					},
					{
						"n": 6,
						"h": 367,
						"w": 200,
						"m": 640
					},
					{
						"n": 7,
						"h": 164,
						"w": 193
					},
					{
						"n": 8,
						"h": 401,
						"w": 317
					},
					{
						"n": 9,
						"h": 51,
						"w": 294
					},
					{
						"n": 10,
						"h": 169,
						"w": 335
					},
					{
						"n": 11,
						"h": 301,
						"w": 296
					}
				],
				"ball": {
					"n": 0,
					"h": 83,
					"w": 520,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 10
		},
		{
			"num": 620,
			"minute": 30,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 10
					},
					{
						"n": 2,
						"h": 120,
						"w": 272
					},
					{
						"n": 3,
						"h": 216,
						"w": 269
					},
					{
						"n": 4,
						"h": 281,
						"w": 272
					},
					{
						"n": 5,
						"h": 334,
						"w": 259
					},
					{
						"n": 6,
						"h": 56,
						"w": 355
					},
					{
						"n": 7,
						"h": 153,
						"w": 374
					},
					{
						"n": 8,
						"h": 281,
						"w": 340
					},
					{
						"n": 9,
						"h": 376,
						"w": 358
					},
					{
						"n": 10,
						"h": 96,
						"w": 527
					},
					{
						"n": 11,
						"h": 290,
						"w": 497
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 20
					},
					{
						"n": 2,
						"h": 92,
						"w": 140
					},
					{
						"n": 3,
						"h": 168,
						"w": 120
					},
					{
						"n": 4,
						"h": 277,
						"w": 130
					},
					{
						"n": 5,
						"h": 378,
						"w": 110
					},
					{
						"n": 6,
						"h": 403,
						"w": 200
					},
					{
						"n": 7,
						"h": 193,
						"w": 220
					},
					{
						"n": 8,
						"h": 412,
						"w": 350
					},
					{
						"n": 9,
						"h": 74,
						"w": 327
					},
					{
						"n": 10,
						"h": 164,
						"w": 375
					},
					{
						"n": 11,
						"h": 337,
						"w": 278
					}
				],
				"ball": {
					"n": 0,
					"h": 47,
					"w": 520,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 621,
			"minute": 30,
			"messages": [
				{
					"owner": 2,
					"mes": "Оливье Дюмон[26](Опава) отдает пас Д.Прохазке[28](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 17
					},
					{
						"n": 2,
						"h": 81,
						"w": 263
					},
					{
						"n": 3,
						"h": 256,
						"w": 261
					},
					{
						"n": 4,
						"h": 309,
						"w": 267
					},
					{
						"n": 5,
						"h": 340,
						"w": 251
					},
					{
						"n": 6,
						"h": 50,
						"w": 396
					},
					{
						"n": 7,
						"h": 162,
						"w": 344
					},
					{
						"n": 8,
						"h": 285,
						"w": 321
					},
					{
						"n": 9,
						"h": 406,
						"w": 359
					},
					{
						"n": 10,
						"h": 124,
						"w": 497
					},
					{
						"n": 11,
						"h": 283,
						"w": 456
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 13
					},
					{
						"n": 2,
						"h": 57,
						"w": 161
					},
					{
						"n": 3,
						"h": 168,
						"w": 117
					},
					{
						"n": 4,
						"h": 281,
						"w": 114
					},
					{
						"n": 5,
						"h": 387,
						"w": 146
					},
					{
						"n": 6,
						"h": 392,
						"w": 200
					},
					{
						"n": 7,
						"h": 225,
						"w": 246
					},
					{
						"n": 8,
						"h": 400,
						"w": 324
					},
					{
						"n": 9,
						"h": 113,
						"w": 340
					},
					{
						"n": 10,
						"h": 158,
						"w": 416
					},
					{
						"n": 11,
						"h": 378,
						"w": 275
					}
				],
				"ball": {
					"n": 0,
					"h": 50,
					"w": 396,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 41
		},
		{
			"num": 622,
			"minute": 30,
			"messages": [
				{
					"owner": 2,
					"mes": "Даниэль Прохазка[28](Опава) контролирует мяч..."
				},
				{
					"owner": 2,
					"mes": "Киэн Колман[06](Галвэй Юнайтед) выбивает мяч из-под ног Д.Прохазки[28](Опава)..."
				},
				{
					"owner": 2,
					"mes": "Шимон Товарек[31](Опава) устремляется к свободному мячу и подхватывает его..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 10
					},
					{
						"n": 2,
						"h": 81,
						"w": 246
					},
					{
						"n": 3,
						"h": 268,
						"w": 248
					},
					{
						"n": 4,
						"h": 316,
						"w": 252
					},
					{
						"n": 5,
						"h": 353,
						"w": 240
					},
					{
						"n": 6,
						"h": 51,
						"w": 393,
						"m": 660
					},
					{
						"n": 7,
						"h": 157,
						"w": 328
					},
					{
						"n": 8,
						"h": 294,
						"w": 307
					},
					{
						"n": 9,
						"h": 406,
						"w": 342
					},
					{
						"n": 10,
						"h": 133,
						"w": 483
					},
					{
						"n": 11,
						"h": 300,
						"w": 453
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 11
					},
					{
						"n": 2,
						"h": 63,
						"w": 176
					},
					{
						"n": 3,
						"h": 177,
						"w": 131
					},
					{
						"n": 4,
						"h": 275,
						"w": 130
					},
					{
						"n": 5,
						"h": 381,
						"w": 155
					},
					{
						"n": 6,
						"h": 376,
						"w": 206
					},
					{
						"n": 7,
						"h": 232,
						"w": 261
					},
					{
						"n": 8,
						"h": 400,
						"w": 324
					},
					{
						"n": 9,
						"h": 128,
						"w": 347
					},
					{
						"n": 10,
						"h": 150,
						"w": 431
					},
					{
						"n": 11,
						"h": 390,
						"w": 288
					}
				],
				"ball": {
					"n": 0,
					"h": 60,
					"w": 432,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 17
		},
		{
			"num": 623,
			"minute": 30,
			"messages": [
				{
					"owner": 2,
					"mes": "Шимон Товарек[31](Опава) пасует на Т.Прохазку[25](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 14
					},
					{
						"n": 2,
						"h": 118,
						"w": 258
					},
					{
						"n": 3,
						"h": 229,
						"w": 254
					},
					{
						"n": 4,
						"h": 301,
						"w": 265
					},
					{
						"n": 5,
						"h": 333,
						"w": 257
					},
					{
						"n": 6,
						"h": 54,
						"w": 354
					},
					{
						"n": 7,
						"h": 155,
						"w": 336
					},
					{
						"n": 8,
						"h": 290,
						"w": 345
					},
					{
						"n": 9,
						"h": 392,
						"w": 360
					},
					{
						"n": 10,
						"h": 158,
						"w": 453
					},
					{
						"n": 11,
						"h": 314,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 17
					},
					{
						"n": 2,
						"h": 58,
						"w": 165
					},
					{
						"n": 3,
						"h": 169,
						"w": 105
					},
					{
						"n": 4,
						"h": 289,
						"w": 111
					},
					{
						"n": 5,
						"h": 401,
						"w": 172
					},
					{
						"n": 6,
						"h": 337,
						"w": 213
					},
					{
						"n": 7,
						"h": 257,
						"w": 292
					},
					{
						"n": 8,
						"h": 403,
						"w": 350
					},
					{
						"n": 9,
						"h": 165,
						"w": 361
					},
					{
						"n": 10,
						"h": 149,
						"w": 426
					},
					{
						"n": 11,
						"h": 394,
						"w": 279
					}
				],
				"ball": {
					"n": 0,
					"h": 49,
					"w": 548,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 624,
			"minute": 30,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 18
					},
					{
						"n": 2,
						"h": 120,
						"w": 249
					},
					{
						"n": 3,
						"h": 241,
						"w": 253
					},
					{
						"n": 4,
						"h": 268,
						"w": 247
					},
					{
						"n": 5,
						"h": 330,
						"w": 251
					},
					{
						"n": 6,
						"h": 55,
						"w": 314
					},
					{
						"n": 7,
						"h": 153,
						"w": 341
					},
					{
						"n": 8,
						"h": 250,
						"w": 344
					},
					{
						"n": 9,
						"h": 426,
						"w": 355
					},
					{
						"n": 10,
						"h": 166,
						"w": 445
					},
					{
						"n": 11,
						"h": 314,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 223,
						"w": 19
					},
					{
						"n": 2,
						"h": 72,
						"w": 170
					},
					{
						"n": 3,
						"h": 167,
						"w": 105
					},
					{
						"n": 4,
						"h": 284,
						"w": 134
					},
					{
						"n": 5,
						"h": 407,
						"w": 207
					},
					{
						"n": 6,
						"h": 297,
						"w": 215
					},
					{
						"n": 7,
						"h": 233,
						"w": 277
					},
					{
						"n": 8,
						"h": 402,
						"w": 390
					},
					{
						"n": 9,
						"h": 204,
						"w": 372
					},
					{
						"n": 10,
						"h": 174,
						"w": 448
					},
					{
						"n": 11,
						"h": 407,
						"w": 271
					}
				],
				"ball": {
					"n": 0,
					"h": 43,
					"w": 513,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 625,
			"minute": 30,
			"messages": [
				{
					"owner": 2,
					"mes": "Пасует в центральную зону..."
				},
				{
					"owner": 2,
					"mes": "Оливье Дюмон[26](Опава) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 19
					},
					{
						"n": 2,
						"h": 120,
						"w": 258
					},
					{
						"n": 3,
						"h": 237,
						"w": 258
					},
					{
						"n": 4,
						"h": 274,
						"w": 257
					},
					{
						"n": 5,
						"h": 330,
						"w": 267
					},
					{
						"n": 6,
						"h": 67,
						"w": 286
					},
					{
						"n": 7,
						"h": 183,
						"w": 341
					},
					{
						"n": 8,
						"h": 260,
						"w": 340
					},
					{
						"n": 9,
						"h": 398,
						"w": 360
					},
					{
						"n": 10,
						"h": 136,
						"w": 449
					},
					{
						"n": 11,
						"h": 317,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 10
					},
					{
						"n": 2,
						"h": 67,
						"w": 178
					},
					{
						"n": 3,
						"h": 170,
						"w": 131
					},
					{
						"n": 4,
						"h": 280,
						"w": 127
					},
					{
						"n": 5,
						"h": 404,
						"w": 197
					},
					{
						"n": 6,
						"h": 316,
						"w": 200
					},
					{
						"n": 7,
						"h": 229,
						"w": 303
					},
					{
						"n": 8,
						"h": 394,
						"w": 418
					},
					{
						"n": 9,
						"h": 197,
						"w": 359
					},
					{
						"n": 10,
						"h": 172,
						"w": 430
					},
					{
						"n": 11,
						"h": 401,
						"w": 276
					}
				],
				"ball": {
					"n": 0,
					"h": 134,
					"w": 520,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 30
		},
		{
			"num": 626,
			"minute": 30,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 16
					},
					{
						"n": 2,
						"h": 83,
						"w": 262
					},
					{
						"n": 3,
						"h": 220,
						"w": 232
					},
					{
						"n": 4,
						"h": 275,
						"w": 249
					},
					{
						"n": 5,
						"h": 330,
						"w": 232
					},
					{
						"n": 6,
						"h": 46,
						"w": 320
					},
					{
						"n": 7,
						"h": 171,
						"w": 320
					},
					{
						"n": 8,
						"h": 262,
						"w": 335
					},
					{
						"n": 9,
						"h": 414,
						"w": 348
					},
					{
						"n": 10,
						"h": 131,
						"w": 432
					},
					{
						"n": 11,
						"h": 277,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 16
					},
					{
						"n": 2,
						"h": 76,
						"w": 179
					},
					{
						"n": 3,
						"h": 179,
						"w": 141
					},
					{
						"n": 4,
						"h": 267,
						"w": 144
					},
					{
						"n": 5,
						"h": 390,
						"w": 160
					},
					{
						"n": 6,
						"h": 333,
						"w": 231
					},
					{
						"n": 7,
						"h": 219,
						"w": 299
					},
					{
						"n": 8,
						"h": 397,
						"w": 438
					},
					{
						"n": 9,
						"h": 183,
						"w": 371
					},
					{
						"n": 10,
						"h": 172,
						"w": 461
					},
					{
						"n": 11,
						"h": 417,
						"w": 262
					}
				],
				"ball": {
					"n": 0,
					"h": 117,
					"w": 489,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 627,
			"minute": 30,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 10
					},
					{
						"n": 2,
						"h": 69,
						"w": 226
					},
					{
						"n": 3,
						"h": 220,
						"w": 193
					},
					{
						"n": 4,
						"h": 279,
						"w": 210
					},
					{
						"n": 5,
						"h": 330,
						"w": 193
					},
					{
						"n": 6,
						"h": 47,
						"w": 301
					},
					{
						"n": 7,
						"h": 173,
						"w": 281
					},
					{
						"n": 8,
						"h": 265,
						"w": 296
					},
					{
						"n": 9,
						"h": 414,
						"w": 309
					},
					{
						"n": 10,
						"h": 140,
						"w": 400
					},
					{
						"n": 11,
						"h": 305,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 226,
						"w": 37
					},
					{
						"n": 2,
						"h": 67,
						"w": 217
					},
					{
						"n": 3,
						"h": 176,
						"w": 180
					},
					{
						"n": 4,
						"h": 267,
						"w": 183
					},
					{
						"n": 5,
						"h": 387,
						"w": 199
					},
					{
						"n": 6,
						"h": 329,
						"w": 265
					},
					{
						"n": 7,
						"h": 222,
						"w": 337
					},
					{
						"n": 8,
						"h": 411,
						"w": 474
					},
					{
						"n": 9,
						"h": 173,
						"w": 408
					},
					{
						"n": 10,
						"h": 164,
						"w": 499
					},
					{
						"n": 11,
						"h": 417,
						"w": 301
					}
				],
				"ball": {
					"n": 0,
					"h": 121,
					"w": 455,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 628,
			"minute": 30,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 17
					},
					{
						"n": 2,
						"h": 63,
						"w": 187
					},
					{
						"n": 3,
						"h": 219,
						"w": 154
					},
					{
						"n": 4,
						"h": 284,
						"w": 172
					},
					{
						"n": 5,
						"h": 330,
						"w": 154
					},
					{
						"n": 6,
						"h": 50,
						"w": 283
					},
					{
						"n": 7,
						"h": 182,
						"w": 243
					},
					{
						"n": 8,
						"h": 274,
						"w": 258
					},
					{
						"n": 9,
						"h": 411,
						"w": 270
					},
					{
						"n": 10,
						"h": 126,
						"w": 401
					},
					{
						"n": 11,
						"h": 310,
						"w": 440
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 57
					},
					{
						"n": 2,
						"h": 68,
						"w": 256
					},
					{
						"n": 3,
						"h": 176,
						"w": 219
					},
					{
						"n": 4,
						"h": 270,
						"w": 222
					},
					{
						"n": 5,
						"h": 391,
						"w": 237
					},
					{
						"n": 6,
						"h": 324,
						"w": 299
					},
					{
						"n": 7,
						"h": 222,
						"w": 376
					},
					{
						"n": 8,
						"h": 417,
						"w": 513
					},
					{
						"n": 9,
						"h": 157,
						"w": 444
					},
					{
						"n": 10,
						"h": 157,
						"w": 537
					},
					{
						"n": 11,
						"h": 416,
						"w": 340
					}
				],
				"ball": {
					"n": 0,
					"h": 126,
					"w": 421,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 629,
			"minute": 30,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 10
					},
					{
						"n": 2,
						"h": 56,
						"w": 179
					},
					{
						"n": 3,
						"h": 246,
						"w": 125
					},
					{
						"n": 4,
						"h": 300,
						"w": 135
					},
					{
						"n": 5,
						"h": 344,
						"w": 117
					},
					{
						"n": 6,
						"h": 44,
						"w": 264
					},
					{
						"n": 7,
						"h": 182,
						"w": 203
					},
					{
						"n": 8,
						"h": 292,
						"w": 222
					},
					{
						"n": 9,
						"h": 397,
						"w": 233
					},
					{
						"n": 10,
						"h": 156,
						"w": 384
					},
					{
						"n": 11,
						"h": 316,
						"w": 429
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 79
					},
					{
						"n": 2,
						"h": 69,
						"w": 296
					},
					{
						"n": 3,
						"h": 170,
						"w": 259
					},
					{
						"n": 4,
						"h": 281,
						"w": 261
					},
					{
						"n": 5,
						"h": 380,
						"w": 276
					},
					{
						"n": 6,
						"h": 294,
						"w": 316
					},
					{
						"n": 7,
						"h": 220,
						"w": 416
					},
					{
						"n": 8,
						"h": 436,
						"w": 533
					},
					{
						"n": 9,
						"h": 138,
						"w": 480
					},
					{
						"n": 10,
						"h": 161,
						"w": 576
					},
					{
						"n": 11,
						"h": 415,
						"w": 380
					}
				],
				"ball": {
					"n": 0,
					"h": 156,
					"w": 404,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 630,
			"minute": 30,
			"messages": [
				{
					"owner": 2,
					"mes": "Оливье Дюмон[26](Опава) пасует направо на Ш.Товарека[31](Опава)..."
				},
				{
					"owner": 2,
					"mes": "Киэн Колман[06](Галвэй Юнайтед) делает важный перехват..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 17
					},
					{
						"n": 2,
						"h": 71,
						"w": 137
					},
					{
						"n": 3,
						"h": 221,
						"w": 117
					},
					{
						"n": 4,
						"h": 279,
						"w": 113
					},
					{
						"n": 5,
						"h": 330,
						"w": 107
					},
					{
						"n": 6,
						"h": 75,
						"w": 296
					},
					{
						"n": 7,
						"h": 174,
						"w": 184
					},
					{
						"n": 8,
						"h": 280,
						"w": 185
					},
					{
						"n": 9,
						"h": 418,
						"w": 210
					},
					{
						"n": 10,
						"h": 174,
						"w": 400
					},
					{
						"n": 11,
						"h": 287,
						"w": 435
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 99
					},
					{
						"n": 2,
						"h": 67,
						"w": 314
					},
					{
						"n": 3,
						"h": 163,
						"w": 268
					},
					{
						"n": 4,
						"h": 276,
						"w": 268
					},
					{
						"n": 5,
						"h": 376,
						"w": 291
					},
					{
						"n": 6,
						"h": 287,
						"w": 329,
						"m": 630
					},
					{
						"n": 7,
						"h": 253,
						"w": 446
					},
					{
						"n": 8,
						"h": 407,
						"w": 568
					},
					{
						"n": 9,
						"h": 178,
						"w": 500
					},
					{
						"n": 10,
						"h": 173,
						"w": 580
					},
					{
						"n": 11,
						"h": 388,
						"w": 409
					}
				],
				"ball": {
					"n": 0,
					"h": 75,
					"w": 296,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 45
		},
		{
			"num": 631,
			"minute": 31,
			"possession": 43,
			"messages": [
				{
					"owner": 1,
					"mes": "Киэн Колман[06](Галвэй Юнайтед) смещается в центр..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 14
					},
					{
						"n": 2,
						"h": 70,
						"w": 177,
						"f": 90
					},
					{
						"n": 3,
						"h": 196,
						"w": 148
					},
					{
						"n": 4,
						"h": 281,
						"w": 153,
						"f": 92
					},
					{
						"n": 5,
						"h": 346,
						"w": 144,
						"f": 90
					},
					{
						"n": 6,
						"h": 100,
						"w": 321,
						"m": 670
					},
					{
						"n": 7,
						"h": 166,
						"w": 223,
						"f": 90
					},
					{
						"n": 8,
						"h": 293,
						"w": 223,
						"f": 88
					},
					{
						"n": 9,
						"h": 408,
						"w": 249
					},
					{
						"n": 10,
						"h": 158,
						"w": 437
					},
					{
						"n": 11,
						"h": 310,
						"w": 467
					}
				],
				"away": [
					{
						"n": 1,
						"h": 245,
						"w": 73
					},
					{
						"n": 2,
						"h": 83,
						"w": 277
					},
					{
						"n": 3,
						"h": 174,
						"w": 229
					},
					{
						"n": 4,
						"h": 260,
						"w": 231
					},
					{
						"n": 5,
						"h": 359,
						"w": 255,
						"c": 1
					},
					{
						"n": 6,
						"h": 293,
						"w": 290,
						"f": 90
					},
					{
						"n": 7,
						"h": 254,
						"w": 406
					},
					{
						"n": 8,
						"h": 410,
						"w": 528
					},
					{
						"n": 9,
						"h": 180,
						"w": 460,
						"f": 89,
						"c": 1
					},
					{
						"n": 10,
						"h": 167,
						"w": 540,
						"m": 640
					},
					{
						"n": 11,
						"h": 357,
						"w": 385
					}
				],
				"ball": {
					"n": 0,
					"h": 100,
					"w": 321,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 632,
			"minute": 31,
			"messages": [
				{
					"owner": 1,
					"mes": "Киэн Колман[06](Галвэй Юнайтед) низом пасует мяч назад..."
				},
				{
					"owner": 1,
					"mes": "Патрик Клинтон[03](Галвэй Юнайтед) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 16
					},
					{
						"n": 2,
						"h": 76,
						"w": 227
					},
					{
						"n": 3,
						"h": 170,
						"w": 176
					},
					{
						"n": 4,
						"h": 283,
						"w": 178
					},
					{
						"n": 5,
						"h": 360,
						"w": 196
					},
					{
						"n": 6,
						"h": 91,
						"w": 324
					},
					{
						"n": 7,
						"h": 156,
						"w": 276
					},
					{
						"n": 8,
						"h": 292,
						"w": 264
					},
					{
						"n": 9,
						"h": 409,
						"w": 303
					},
					{
						"n": 10,
						"h": 141,
						"w": 478
					},
					{
						"n": 11,
						"h": 291,
						"w": 488
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 79
					},
					{
						"n": 2,
						"h": 103,
						"w": 227
					},
					{
						"n": 3,
						"h": 176,
						"w": 215
					},
					{
						"n": 4,
						"h": 289,
						"w": 230
					},
					{
						"n": 5,
						"h": 340,
						"w": 220
					},
					{
						"n": 6,
						"h": 241,
						"w": 274
					},
					{
						"n": 7,
						"h": 231,
						"w": 357
					},
					{
						"n": 8,
						"h": 416,
						"w": 474
					},
					{
						"n": 9,
						"h": 134,
						"w": 431
					},
					{
						"n": 10,
						"h": 151,
						"w": 489
					},
					{
						"n": 11,
						"h": 312,
						"w": 378
					}
				],
				"ball": {
					"n": 0,
					"h": 170,
					"w": 176,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 54
		},
		{
			"num": 633,
			"minute": 31,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 16
					},
					{
						"n": 2,
						"h": 63,
						"w": 250
					},
					{
						"n": 3,
						"h": 153,
						"w": 206
					},
					{
						"n": 4,
						"h": 268,
						"w": 199
					},
					{
						"n": 5,
						"h": 375,
						"w": 233
					},
					{
						"n": 6,
						"h": 80,
						"w": 363
					},
					{
						"n": 7,
						"h": 163,
						"w": 316
					},
					{
						"n": 8,
						"h": 277,
						"w": 296
					},
					{
						"n": 9,
						"h": 409,
						"w": 343
					},
					{
						"n": 10,
						"h": 161,
						"w": 489
					},
					{
						"n": 11,
						"h": 292,
						"w": 500
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 79
					},
					{
						"n": 2,
						"h": 110,
						"w": 207
					},
					{
						"n": 3,
						"h": 173,
						"w": 197
					},
					{
						"n": 4,
						"h": 272,
						"w": 194
					},
					{
						"n": 5,
						"h": 340,
						"w": 193
					},
					{
						"n": 6,
						"h": 277,
						"w": 257
					},
					{
						"n": 7,
						"h": 234,
						"w": 318
					},
					{
						"n": 8,
						"h": 404,
						"w": 436
					},
					{
						"n": 9,
						"h": 104,
						"w": 405
					},
					{
						"n": 10,
						"h": 146,
						"w": 449
					},
					{
						"n": 11,
						"h": 310,
						"w": 366
					}
				],
				"ball": {
					"n": 0,
					"h": 153,
					"w": 206,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 634,
			"minute": 31,
			"messages": [
				{
					"owner": 1,
					"mes": "Патрик Клинтон[03](Галвэй Юнайтед) подключает к атаке А.Хлинссона[07](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 11
					},
					{
						"n": 2,
						"h": 72,
						"w": 271
					},
					{
						"n": 3,
						"h": 153,
						"w": 206
					},
					{
						"n": 4,
						"h": 265,
						"w": 211
					},
					{
						"n": 5,
						"h": 375,
						"w": 271
					},
					{
						"n": 6,
						"h": 73,
						"w": 414
					},
					{
						"n": 7,
						"h": 193,
						"w": 356
					},
					{
						"n": 8,
						"h": 282,
						"w": 348
					},
					{
						"n": 9,
						"h": 405,
						"w": 395
					},
					{
						"n": 10,
						"h": 177,
						"w": 505
					},
					{
						"n": 11,
						"h": 277,
						"w": 527
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 70
					},
					{
						"n": 2,
						"h": 110,
						"w": 166
					},
					{
						"n": 3,
						"h": 191,
						"w": 156
					},
					{
						"n": 4,
						"h": 259,
						"w": 148
					},
					{
						"n": 5,
						"h": 340,
						"w": 166
					},
					{
						"n": 6,
						"h": 271,
						"w": 205
					},
					{
						"n": 7,
						"h": 255,
						"w": 342
					},
					{
						"n": 8,
						"h": 396,
						"w": 384
					},
					{
						"n": 9,
						"h": 79,
						"w": 360
					},
					{
						"n": 10,
						"h": 156,
						"w": 398
					},
					{
						"n": 11,
						"h": 298,
						"w": 336
					}
				],
				"ball": {
					"n": 0,
					"h": 193,
					"w": 356,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 52
		},
		{
			"num": 635,
			"minute": 31,
			"messages": [
				{
					"owner": 1,
					"mes": "А.Хлинссон[07](Галвэй Юнайтед) снабжает мячом открывшегося К.Нолана[08](Галвэй Юнайтед)..."
				},
				{
					"owner": 1,
					"mes": "Киран Нолан[08](Галвэй Юнайтед) с мячом..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 10
					},
					{
						"n": 2,
						"h": 75,
						"w": 302
					},
					{
						"n": 3,
						"h": 172,
						"w": 239
					},
					{
						"n": 4,
						"h": 276,
						"w": 247
					},
					{
						"n": 5,
						"h": 373,
						"w": 309
					},
					{
						"n": 6,
						"h": 64,
						"w": 451
					},
					{
						"n": 7,
						"h": 193,
						"w": 356,
						"m": 690
					},
					{
						"n": 8,
						"h": 260,
						"w": 392
					},
					{
						"n": 9,
						"h": 403,
						"w": 433
					},
					{
						"n": 10,
						"h": 166,
						"w": 541
					},
					{
						"n": 11,
						"h": 280,
						"w": 565
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 72
					},
					{
						"n": 2,
						"h": 110,
						"w": 128
					},
					{
						"n": 3,
						"h": 180,
						"w": 131
					},
					{
						"n": 4,
						"h": 270,
						"w": 111
					},
					{
						"n": 5,
						"h": 340,
						"w": 128
					},
					{
						"n": 6,
						"h": 278,
						"w": 168
					},
					{
						"n": 7,
						"h": 221,
						"w": 325
					},
					{
						"n": 8,
						"h": 393,
						"w": 347
					},
					{
						"n": 9,
						"h": 57,
						"w": 328
					},
					{
						"n": 10,
						"h": 156,
						"w": 360
					},
					{
						"n": 11,
						"h": 261,
						"w": 344
					}
				],
				"ball": {
					"n": 0,
					"h": 260,
					"w": 392,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 38
		},
		{
			"num": 636,
			"minute": 31,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 16
					},
					{
						"n": 2,
						"h": 69,
						"w": 341
					},
					{
						"n": 3,
						"h": 167,
						"w": 278
					},
					{
						"n": 4,
						"h": 272,
						"w": 287
					},
					{
						"n": 5,
						"h": 387,
						"w": 347
					},
					{
						"n": 6,
						"h": 60,
						"w": 491
					},
					{
						"n": 7,
						"h": 183,
						"w": 395
					},
					{
						"n": 8,
						"h": 260,
						"w": 427
					},
					{
						"n": 9,
						"h": 400,
						"w": 472
					},
					{
						"n": 10,
						"h": 170,
						"w": 581
					},
					{
						"n": 11,
						"h": 280,
						"w": 605
					}
				],
				"away": [
					{
						"n": 1,
						"h": 221,
						"w": 65
					},
					{
						"n": 2,
						"h": 110,
						"w": 114
					},
					{
						"n": 3,
						"h": 183,
						"w": 115
					},
					{
						"n": 4,
						"h": 262,
						"w": 113
					},
					{
						"n": 5,
						"h": 340,
						"w": 118
					},
					{
						"n": 6,
						"h": 239,
						"w": 176
					},
					{
						"n": 7,
						"h": 198,
						"w": 293
					},
					{
						"n": 8,
						"h": 392,
						"w": 307
					},
					{
						"n": 9,
						"h": 41,
						"w": 292
					},
					{
						"n": 10,
						"h": 166,
						"w": 321
					},
					{
						"n": 11,
						"h": 267,
						"w": 305
					}
				],
				"ball": {
					"n": 0,
					"h": 260,
					"w": 427,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 637,
			"minute": 31,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 12
					},
					{
						"n": 2,
						"h": 68,
						"w": 338
					},
					{
						"n": 3,
						"h": 176,
						"w": 295
					},
					{
						"n": 4,
						"h": 272,
						"w": 291
					},
					{
						"n": 5,
						"h": 381,
						"w": 351
					},
					{
						"n": 6,
						"h": 53,
						"w": 530
					},
					{
						"n": 7,
						"h": 174,
						"w": 434
					},
					{
						"n": 8,
						"h": 278,
						"w": 457
					},
					{
						"n": 9,
						"h": 403,
						"w": 512
					},
					{
						"n": 10,
						"h": 153,
						"w": 579
					},
					{
						"n": 11,
						"h": 300,
						"w": 607
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 63
					},
					{
						"n": 2,
						"h": 110,
						"w": 97
					},
					{
						"n": 3,
						"h": 169,
						"w": 86
					},
					{
						"n": 4,
						"h": 285,
						"w": 80
					},
					{
						"n": 5,
						"h": 366,
						"w": 149
					},
					{
						"n": 6,
						"h": 272,
						"w": 153
					},
					{
						"n": 7,
						"h": 177,
						"w": 259
					},
					{
						"n": 8,
						"h": 399,
						"w": 267
					},
					{
						"n": 9,
						"h": 44,
						"w": 252
					},
					{
						"n": 10,
						"h": 155,
						"w": 292
					},
					{
						"n": 11,
						"h": 295,
						"w": 292
					}
				],
				"ball": {
					"n": 0,
					"h": 278,
					"w": 457,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 638,
			"minute": 31,
			"messages": [
				{
					"owner": 1,
					"mes": "Пас направо Э.Бвомоно[09](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 10
					},
					{
						"n": 2,
						"h": 58,
						"w": 372
					},
					{
						"n": 3,
						"h": 180,
						"w": 312
					},
					{
						"n": 4,
						"h": 267,
						"w": 314
					},
					{
						"n": 5,
						"h": 385,
						"w": 357
					},
					{
						"n": 6,
						"h": 57,
						"w": 585
					},
					{
						"n": 7,
						"h": 219,
						"w": 415
					},
					{
						"n": 8,
						"h": 280,
						"w": 467,
						"m": 600
					},
					{
						"n": 9,
						"h": 409,
						"w": 558
					},
					{
						"n": 10,
						"h": 172,
						"w": 617
					},
					{
						"n": 11,
						"h": 298,
						"w": 627
					}
				],
				"away": [
					{
						"n": 1,
						"h": 214,
						"w": 10
					},
					{
						"n": 2,
						"h": 72,
						"w": 137
					},
					{
						"n": 3,
						"h": 169,
						"w": 67
					},
					{
						"n": 4,
						"h": 263,
						"w": 75
					},
					{
						"n": 5,
						"h": 368,
						"w": 115
					},
					{
						"n": 6,
						"h": 217,
						"w": 151
					},
					{
						"n": 7,
						"h": 200,
						"w": 208
					},
					{
						"n": 8,
						"h": 400,
						"w": 212
					},
					{
						"n": 9,
						"h": 39,
						"w": 224
					},
					{
						"n": 10,
						"h": 160,
						"w": 296
					},
					{
						"n": 11,
						"h": 240,
						"w": 286
					}
				],
				"ball": {
					"n": 0,
					"h": 409,
					"w": 558,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 55
		},
		{
			"num": 639,
			"minute": 31,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 11
					},
					{
						"n": 2,
						"h": 77,
						"w": 380
					},
					{
						"n": 3,
						"h": 172,
						"w": 321
					},
					{
						"n": 4,
						"h": 271,
						"w": 325
					},
					{
						"n": 5,
						"h": 372,
						"w": 376
					},
					{
						"n": 6,
						"h": 47,
						"w": 607
					},
					{
						"n": 7,
						"h": 213,
						"w": 453
					},
					{
						"n": 8,
						"h": 293,
						"w": 503
					},
					{
						"n": 9,
						"h": 419,
						"w": 598
					},
					{
						"n": 10,
						"h": 177,
						"w": 637
					},
					{
						"n": 11,
						"h": 288,
						"w": 637
					}
				],
				"away": [
					{
						"n": 1,
						"h": 212,
						"w": 8
					},
					{
						"n": 2,
						"h": 69,
						"w": 122
					},
					{
						"n": 3,
						"h": 172,
						"w": 62
					},
					{
						"n": 4,
						"h": 263,
						"w": 56
					},
					{
						"n": 5,
						"h": 352,
						"w": 80
					},
					{
						"n": 6,
						"h": 173,
						"w": 135
					},
					{
						"n": 7,
						"h": 166,
						"w": 191
					},
					{
						"n": 8,
						"h": 402,
						"w": 194
					},
					{
						"n": 9,
						"h": 25,
						"w": 214
					},
					{
						"n": 10,
						"h": 162,
						"w": 297
					},
					{
						"n": 11,
						"h": 237,
						"w": 248
					}
				],
				"ball": {
					"n": 0,
					"h": 419,
					"w": 598,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 38
		},
		{
			"num": 640,
			"minute": 31,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 10
					},
					{
						"n": 2,
						"h": 76,
						"w": 379
					},
					{
						"n": 3,
						"h": 180,
						"w": 310
					},
					{
						"n": 4,
						"h": 285,
						"w": 310
					},
					{
						"n": 5,
						"h": 373,
						"w": 380
					},
					{
						"n": 6,
						"h": 46,
						"w": 647
					},
					{
						"n": 7,
						"h": 203,
						"w": 445
					},
					{
						"n": 8,
						"h": 296,
						"w": 543
					},
					{
						"n": 9,
						"h": 419,
						"w": 642
					},
					{
						"n": 10,
						"h": 216,
						"w": 645
					},
					{
						"n": 11,
						"h": 310,
						"w": 665
					}
				],
				"away": [
					{
						"n": 1,
						"h": 211,
						"w": 6
					},
					{
						"n": 2,
						"h": 45,
						"w": 83
					},
					{
						"n": 3,
						"h": 137,
						"w": 45
					},
					{
						"n": 4,
						"h": 223,
						"w": 56
					},
					{
						"n": 5,
						"h": 340,
						"w": 41
					},
					{
						"n": 6,
						"h": 209,
						"w": 101
					},
					{
						"n": 7,
						"h": 156,
						"w": 165
					},
					{
						"n": 8,
						"h": 422,
						"w": 159
					},
					{
						"n": 9,
						"h": 39,
						"w": 199
					},
					{
						"n": 10,
						"h": 170,
						"w": 291
					},
					{
						"n": 11,
						"h": 247,
						"w": 255
					}
				],
				"ball": {
					"n": 0,
					"h": 419,
					"w": 642,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 641,
			"minute": 31,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 19
					},
					{
						"n": 2,
						"h": 64,
						"w": 369
					},
					{
						"n": 3,
						"h": 167,
						"w": 316
					},
					{
						"n": 4,
						"h": 284,
						"w": 316
					},
					{
						"n": 5,
						"h": 372,
						"w": 380
					},
					{
						"n": 6,
						"h": 56,
						"w": 652
					},
					{
						"n": 7,
						"h": 209,
						"w": 430
					},
					{
						"n": 8,
						"h": 299,
						"w": 569
					},
					{
						"n": 9,
						"h": 419,
						"w": 670
					},
					{
						"n": 10,
						"h": 226,
						"w": 644
					},
					{
						"n": 11,
						"h": 295,
						"w": 654
					}
				],
				"away": [
					{
						"n": 1,
						"h": 210,
						"w": 4
					},
					{
						"n": 2,
						"h": 40,
						"w": 54
					},
					{
						"n": 3,
						"h": 154,
						"w": 54
					},
					{
						"n": 4,
						"h": 206,
						"w": 46
					},
					{
						"n": 5,
						"h": 340,
						"w": 36
					},
					{
						"n": 6,
						"h": 220,
						"w": 94
					},
					{
						"n": 7,
						"h": 159,
						"w": 145
					},
					{
						"n": 8,
						"h": 406,
						"w": 140
					},
					{
						"n": 9,
						"h": 31,
						"w": 190
					},
					{
						"n": 10,
						"h": 158,
						"w": 309
					},
					{
						"n": 11,
						"h": 241,
						"w": 270
					}
				],
				"ball": {
					"n": 0,
					"h": 419,
					"w": 670,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 26
		},
		{
			"num": 642,
			"minute": 31,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 13
					},
					{
						"n": 2,
						"h": 71,
						"w": 362
					},
					{
						"n": 3,
						"h": 170,
						"w": 313
					},
					{
						"n": 4,
						"h": 270,
						"w": 316
					},
					{
						"n": 5,
						"h": 372,
						"w": 376
					},
					{
						"n": 6,
						"h": 55,
						"w": 657
					},
					{
						"n": 7,
						"h": 209,
						"w": 450
					},
					{
						"n": 8,
						"h": 293,
						"w": 588
					},
					{
						"n": 9,
						"h": 419,
						"w": 692
					},
					{
						"n": 10,
						"h": 210,
						"w": 656
					},
					{
						"n": 11,
						"h": 280,
						"w": 667
					}
				],
				"away": [
					{
						"n": 1,
						"h": 210,
						"w": 2
					},
					{
						"n": 2,
						"h": 38,
						"w": 31
					},
					{
						"n": 3,
						"h": 165,
						"w": 35
					},
					{
						"n": 4,
						"h": 228,
						"w": 55
					},
					{
						"n": 5,
						"h": 340,
						"w": 41
					},
					{
						"n": 6,
						"h": 196,
						"w": 99
					},
					{
						"n": 7,
						"h": 175,
						"w": 157
					},
					{
						"n": 8,
						"h": 395,
						"w": 140
					},
					{
						"n": 9,
						"h": 31,
						"w": 190
					},
					{
						"n": 10,
						"h": 171,
						"w": 298
					},
					{
						"n": 11,
						"h": 241,
						"w": 250
					}
				],
				"ball": {
					"n": 0,
					"h": 419,
					"w": 692,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 20
		},
		{
			"num": 643,
			"minute": 31,
			"messages": [
				{
					"owner": 1,
					"mes": "Э.Бвомоно[09](Галвэй Юнайтед) простреливает низом..."
				},
				{
					"owner": 1,
					"mes": "Нир Мансур[23](Опава) прерывает передачу и выносит мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 14
					},
					{
						"n": 2,
						"h": 66,
						"w": 375
					},
					{
						"n": 3,
						"h": 165,
						"w": 322
					},
					{
						"n": 4,
						"h": 284,
						"w": 327
					},
					{
						"n": 5,
						"h": 384,
						"w": 378
					},
					{
						"n": 6,
						"h": 45,
						"w": 656
					},
					{
						"n": 7,
						"h": 208,
						"w": 475
					},
					{
						"n": 8,
						"h": 291,
						"w": 613
					},
					{
						"n": 9,
						"h": 419,
						"w": 692
					},
					{
						"n": 10,
						"h": 190,
						"w": 657
					},
					{
						"n": 11,
						"h": 291,
						"w": 689
					}
				],
				"away": [
					{
						"n": 1,
						"h": 210,
						"w": 2
					},
					{
						"n": 2,
						"h": 37,
						"w": 23
					},
					{
						"n": 3,
						"h": 155,
						"w": 23
					},
					{
						"n": 4,
						"h": 232,
						"w": 50
					},
					{
						"n": 5,
						"h": 340,
						"w": 40
					},
					{
						"n": 6,
						"h": 165,
						"w": 100
					},
					{
						"n": 7,
						"h": 200,
						"w": 153
					},
					{
						"n": 8,
						"h": 409,
						"w": 140
					},
					{
						"n": 9,
						"h": 56,
						"w": 190
					},
					{
						"n": 10,
						"h": 169,
						"w": 305
					},
					{
						"n": 11,
						"h": 242,
						"w": 225
					}
				],
				"ball": {
					"n": 0,
					"h": 295,
					"w": 697,
					"z": 0,
					"r": 0,
					"p": 1,
					"x": 0
				}
			},
			"interval": 25
		},
		{
			"num": 644,
			"minute": 31,
			"messages": [
				{
					"owner": 2,
					"mes": "Матей Юрасек[29](Опава) устремляется к свободному мячу и подхватывает его..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 19
					},
					{
						"n": 2,
						"h": 71,
						"w": 377
					},
					{
						"n": 3,
						"h": 165,
						"w": 312
					},
					{
						"n": 4,
						"h": 283,
						"w": 328
					},
					{
						"n": 5,
						"h": 408,
						"w": 439
					},
					{
						"n": 6,
						"h": 35,
						"w": 640
					},
					{
						"n": 7,
						"h": 215,
						"w": 415
					},
					{
						"n": 8,
						"h": 299,
						"w": 553
					},
					{
						"n": 9,
						"h": 409,
						"w": 633
					},
					{
						"n": 10,
						"h": 165,
						"w": 630
					},
					{
						"n": 11,
						"h": 284,
						"w": 635
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 11
					},
					{
						"n": 2,
						"h": 66,
						"w": 67
					},
					{
						"n": 3,
						"h": 164,
						"w": 40
					},
					{
						"n": 4,
						"h": 271,
						"w": 62
					},
					{
						"n": 5,
						"h": 340,
						"w": 65
					},
					{
						"n": 6,
						"h": 142,
						"w": 80
					},
					{
						"n": 7,
						"h": 260,
						"w": 156
					},
					{
						"n": 8,
						"h": 400,
						"w": 81
					},
					{
						"n": 9,
						"h": 19,
						"w": 222
					},
					{
						"n": 10,
						"h": 167,
						"w": 291
					},
					{
						"n": 11,
						"h": 266,
						"w": 280
					}
				],
				"ball": {
					"n": 0,
					"h": 431,
					"w": 498,
					"z": 1,
					"r": 0,
					"p": 4,
					"x": 1
				}
			},
			"interval": 60
		},
		{
			"num": 645,
			"minute": 31,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 15
					},
					{
						"n": 2,
						"h": 91,
						"w": 342
					},
					{
						"n": 3,
						"h": 158,
						"w": 304
					},
					{
						"n": 4,
						"h": 268,
						"w": 302
					},
					{
						"n": 5,
						"h": 394,
						"w": 446
					},
					{
						"n": 6,
						"h": 39,
						"w": 600
					},
					{
						"n": 7,
						"h": 208,
						"w": 388
					},
					{
						"n": 8,
						"h": 297,
						"w": 513
					},
					{
						"n": 9,
						"h": 410,
						"w": 613
					},
					{
						"n": 10,
						"h": 168,
						"w": 590
					},
					{
						"n": 11,
						"h": 284,
						"w": 595
					}
				],
				"away": [
					{
						"n": 1,
						"h": 221,
						"w": 16
					},
					{
						"n": 2,
						"h": 61,
						"w": 107
					},
					{
						"n": 3,
						"h": 149,
						"w": 74
					},
					{
						"n": 4,
						"h": 275,
						"w": 82
					},
					{
						"n": 5,
						"h": 354,
						"w": 85
					},
					{
						"n": 6,
						"h": 164,
						"w": 113
					},
					{
						"n": 7,
						"h": 234,
						"w": 186
					},
					{
						"n": 8,
						"h": 402,
						"w": 121
					},
					{
						"n": 9,
						"h": 5,
						"w": 254
					},
					{
						"n": 10,
						"h": 163,
						"w": 331
					},
					{
						"n": 11,
						"h": 306,
						"w": 283
					}
				],
				"ball": {
					"n": 0,
					"h": 445,
					"w": 466,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 646,
			"minute": 31,
			"messages": [
				{
					"owner": 2,
					"mes": "Пас направо М.Манолову[27](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 18
					},
					{
						"n": 2,
						"h": 117,
						"w": 288
					},
					{
						"n": 3,
						"h": 213,
						"w": 280
					},
					{
						"n": 4,
						"h": 296,
						"w": 292
					},
					{
						"n": 5,
						"h": 379,
						"w": 388
					},
					{
						"n": 6,
						"h": 38,
						"w": 540
					},
					{
						"n": 7,
						"h": 212,
						"w": 448
					},
					{
						"n": 8,
						"h": 286,
						"w": 454
					},
					{
						"n": 9,
						"h": 408,
						"w": 583
					},
					{
						"n": 10,
						"h": 173,
						"w": 530
					},
					{
						"n": 11,
						"h": 278,
						"w": 535
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 11
					},
					{
						"n": 2,
						"h": 73,
						"w": 156
					},
					{
						"n": 3,
						"h": 179,
						"w": 103
					},
					{
						"n": 4,
						"h": 272,
						"w": 101
					},
					{
						"n": 5,
						"h": 390,
						"w": 98
					},
					{
						"n": 6,
						"h": 210,
						"w": 152
					},
					{
						"n": 7,
						"h": 237,
						"w": 246
					},
					{
						"n": 8,
						"h": 400,
						"w": 181
					},
					{
						"n": 9,
						"h": 9,
						"w": 264
					},
					{
						"n": 10,
						"h": 151,
						"w": 390
					},
					{
						"n": 11,
						"h": 366,
						"w": 288
					}
				],
				"ball": {
					"n": 0,
					"h": 213,
					"w": 474,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 60
		},
		{
			"num": 647,
			"minute": 31,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 17
					},
					{
						"n": 2,
						"h": 120,
						"w": 286
					},
					{
						"n": 3,
						"h": 218,
						"w": 289
					},
					{
						"n": 4,
						"h": 311,
						"w": 277
					},
					{
						"n": 5,
						"h": 371,
						"w": 348
					},
					{
						"n": 6,
						"h": 45,
						"w": 501
					},
					{
						"n": 7,
						"h": 201,
						"w": 426
					},
					{
						"n": 8,
						"h": 273,
						"w": 416
					},
					{
						"n": 9,
						"h": 407,
						"w": 543
					},
					{
						"n": 10,
						"h": 155,
						"w": 495
					},
					{
						"n": 11,
						"h": 293,
						"w": 498
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 12
					},
					{
						"n": 2,
						"h": 58,
						"w": 160
					},
					{
						"n": 3,
						"h": 170,
						"w": 99
					},
					{
						"n": 4,
						"h": 275,
						"w": 90
					},
					{
						"n": 5,
						"h": 385,
						"w": 118
					},
					{
						"n": 6,
						"h": 228,
						"w": 188
					},
					{
						"n": 7,
						"h": 254,
						"w": 277
					},
					{
						"n": 8,
						"h": 398,
						"w": 221
					},
					{
						"n": 9,
						"h": 24,
						"w": 301
					},
					{
						"n": 10,
						"h": 137,
						"w": 400
					},
					{
						"n": 11,
						"h": 380,
						"w": 325
					}
				],
				"ball": {
					"n": 0,
					"h": 196,
					"w": 443,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 648,
			"minute": 31,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 13
					},
					{
						"n": 2,
						"h": 99,
						"w": 320
					},
					{
						"n": 3,
						"h": 219,
						"w": 272
					},
					{
						"n": 4,
						"h": 289,
						"w": 275
					},
					{
						"n": 5,
						"h": 364,
						"w": 309
					},
					{
						"n": 6,
						"h": 49,
						"w": 461
					},
					{
						"n": 7,
						"h": 226,
						"w": 414
					},
					{
						"n": 8,
						"h": 267,
						"w": 377
					},
					{
						"n": 9,
						"h": 404,
						"w": 503
					},
					{
						"n": 10,
						"h": 171,
						"w": 465
					},
					{
						"n": 11,
						"h": 284,
						"w": 459
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 18
					},
					{
						"n": 2,
						"h": 73,
						"w": 158
					},
					{
						"n": 3,
						"h": 167,
						"w": 139
					},
					{
						"n": 4,
						"h": 279,
						"w": 130
					},
					{
						"n": 5,
						"h": 378,
						"w": 95
					},
					{
						"n": 6,
						"h": 225,
						"w": 227
					},
					{
						"n": 7,
						"h": 220,
						"w": 286
					},
					{
						"n": 8,
						"h": 400,
						"w": 261
					},
					{
						"n": 9,
						"h": 31,
						"w": 340
					},
					{
						"n": 10,
						"h": 157,
						"w": 428
					},
					{
						"n": 11,
						"h": 390,
						"w": 364
					}
				],
				"ball": {
					"n": 0,
					"h": 230,
					"w": 434,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 649,
			"minute": 31,
			"messages": [
				{
					"owner": 2,
					"mes": "Мирослав Манолов[27](Опава) пасует низом..."
				},
				{
					"owner": 2,
					"mes": "Оливье Дюмон[26](Опава) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 17
					},
					{
						"n": 2,
						"h": 82,
						"w": 314
					},
					{
						"n": 3,
						"h": 215,
						"w": 251
					},
					{
						"n": 4,
						"h": 288,
						"w": 252
					},
					{
						"n": 5,
						"h": 352,
						"w": 289
					},
					{
						"n": 6,
						"h": 51,
						"w": 438
					},
					{
						"n": 7,
						"h": 218,
						"w": 393
					},
					{
						"n": 8,
						"h": 265,
						"w": 354
					},
					{
						"n": 9,
						"h": 403,
						"w": 480
					},
					{
						"n": 10,
						"h": 156,
						"w": 454
					},
					{
						"n": 11,
						"h": 306,
						"w": 451
					}
				],
				"away": [
					{
						"n": 1,
						"h": 223,
						"w": 14
					},
					{
						"n": 2,
						"h": 66,
						"w": 180
					},
					{
						"n": 3,
						"h": 167,
						"w": 116
					},
					{
						"n": 4,
						"h": 280,
						"w": 120
					},
					{
						"n": 5,
						"h": 376,
						"w": 126
					},
					{
						"n": 6,
						"h": 245,
						"w": 248
					},
					{
						"n": 7,
						"h": 220,
						"w": 286,
						"m": 560
					},
					{
						"n": 8,
						"h": 401,
						"w": 284
					},
					{
						"n": 9,
						"h": 31,
						"w": 363
					},
					{
						"n": 10,
						"h": 165,
						"w": 442
					},
					{
						"n": 11,
						"h": 398,
						"w": 386
					}
				],
				"ball": {
					"n": 0,
					"h": 205,
					"w": 472,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 23
		},
		{
			"num": 650,
			"minute": 32,
			"possession": 44,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 13,
						"f": 96
					},
					{
						"n": 2,
						"h": 79,
						"w": 274
					},
					{
						"n": 3,
						"h": 220,
						"w": 242
					},
					{
						"n": 4,
						"h": 310,
						"w": 229
					},
					{
						"n": 5,
						"h": 385,
						"w": 297
					},
					{
						"n": 6,
						"h": 44,
						"w": 399
					},
					{
						"n": 7,
						"h": 207,
						"w": 417
					},
					{
						"n": 8,
						"h": 271,
						"w": 314
					},
					{
						"n": 9,
						"h": 403,
						"w": 440
					},
					{
						"n": 10,
						"h": 167,
						"w": 424
					},
					{
						"n": 11,
						"h": 288,
						"w": 450,
						"f": 89,
						"c": 1
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 16,
						"f": 90
					},
					{
						"n": 2,
						"h": 57,
						"w": 182
					},
					{
						"n": 3,
						"h": 162,
						"w": 156,
						"m": 590
					},
					{
						"n": 4,
						"h": 283,
						"w": 160,
						"f": 89,
						"c": 1
					},
					{
						"n": 5,
						"h": 391,
						"w": 139,
						"f": 89
					},
					{
						"n": 6,
						"h": 246,
						"w": 283
					},
					{
						"n": 7,
						"h": 224,
						"w": 326,
						"f": 91
					},
					{
						"n": 8,
						"h": 405,
						"w": 323
					},
					{
						"n": 9,
						"h": 35,
						"w": 403
					},
					{
						"n": 10,
						"h": 145,
						"w": 469
					},
					{
						"n": 11,
						"h": 401,
						"w": 426
					}
				],
				"ball": {
					"n": 0,
					"h": 204,
					"w": 437,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 651,
			"minute": 32,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 18
					},
					{
						"n": 2,
						"h": 77,
						"w": 234
					},
					{
						"n": 3,
						"h": 238,
						"w": 227
					},
					{
						"n": 4,
						"h": 275,
						"w": 234
					},
					{
						"n": 5,
						"h": 381,
						"w": 257
					},
					{
						"n": 6,
						"h": 44,
						"w": 359
					},
					{
						"n": 7,
						"h": 235,
						"w": 406
					},
					{
						"n": 8,
						"h": 231,
						"w": 309
					},
					{
						"n": 9,
						"h": 405,
						"w": 400
					},
					{
						"n": 10,
						"h": 165,
						"w": 400
					},
					{
						"n": 11,
						"h": 295,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 32
					},
					{
						"n": 2,
						"h": 71,
						"w": 204
					},
					{
						"n": 3,
						"h": 155,
						"w": 195
					},
					{
						"n": 4,
						"h": 285,
						"w": 200
					},
					{
						"n": 5,
						"h": 389,
						"w": 177
					},
					{
						"n": 6,
						"h": 212,
						"w": 292
					},
					{
						"n": 7,
						"h": 217,
						"w": 365
					},
					{
						"n": 8,
						"h": 404,
						"w": 363
					},
					{
						"n": 9,
						"h": 39,
						"w": 443
					},
					{
						"n": 10,
						"h": 165,
						"w": 476
					},
					{
						"n": 11,
						"h": 403,
						"w": 466
					}
				],
				"ball": {
					"n": 0,
					"h": 238,
					"w": 428,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 652,
			"minute": 32,
			"messages": [
				{
					"owner": 2,
					"mes": "Оливье Дюмон[26](Опава) отдает передачу низом..."
				},
				{
					"owner": 2,
					"mes": "Себастьян Пейша[24](Опава) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 17
					},
					{
						"n": 2,
						"h": 62,
						"w": 227
					},
					{
						"n": 3,
						"h": 229,
						"w": 213
					},
					{
						"n": 4,
						"h": 285,
						"w": 209
					},
					{
						"n": 5,
						"h": 356,
						"w": 228
					},
					{
						"n": 6,
						"h": 50,
						"w": 320
					},
					{
						"n": 7,
						"h": 218,
						"w": 371
					},
					{
						"n": 8,
						"h": 217,
						"w": 287
					},
					{
						"n": 9,
						"h": 411,
						"w": 361
					},
					{
						"n": 10,
						"h": 175,
						"w": 375
					},
					{
						"n": 11,
						"h": 322,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 53
					},
					{
						"n": 2,
						"h": 57,
						"w": 217
					},
					{
						"n": 3,
						"h": 180,
						"w": 166
					},
					{
						"n": 4,
						"h": 310,
						"w": 230
					},
					{
						"n": 5,
						"h": 377,
						"w": 168
					},
					{
						"n": 6,
						"h": 212,
						"w": 292,
						"m": 640
					},
					{
						"n": 7,
						"h": 225,
						"w": 403
					},
					{
						"n": 8,
						"h": 399,
						"w": 402
					},
					{
						"n": 9,
						"h": 37,
						"w": 473
					},
					{
						"n": 10,
						"h": 153,
						"w": 479
					},
					{
						"n": 11,
						"h": 418,
						"w": 473
					}
				],
				"ball": {
					"n": 0,
					"h": 140,
					"w": 490,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 653,
			"minute": 32,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 19
					},
					{
						"n": 2,
						"h": 56,
						"w": 193
					},
					{
						"n": 3,
						"h": 223,
						"w": 198
					},
					{
						"n": 4,
						"h": 271,
						"w": 188
					},
					{
						"n": 5,
						"h": 330,
						"w": 198
					},
					{
						"n": 6,
						"h": 53,
						"w": 280
					},
					{
						"n": 7,
						"h": 206,
						"w": 333
					},
					{
						"n": 8,
						"h": 255,
						"w": 275
					},
					{
						"n": 9,
						"h": 409,
						"w": 321
					},
					{
						"n": 10,
						"h": 155,
						"w": 343
					},
					{
						"n": 11,
						"h": 308,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 74
					},
					{
						"n": 2,
						"h": 76,
						"w": 239
					},
					{
						"n": 3,
						"h": 182,
						"w": 182
					},
					{
						"n": 4,
						"h": 305,
						"w": 265
					},
					{
						"n": 5,
						"h": 394,
						"w": 192
					},
					{
						"n": 6,
						"h": 216,
						"w": 332
					},
					{
						"n": 7,
						"h": 232,
						"w": 443
					},
					{
						"n": 8,
						"h": 404,
						"w": 442
					},
					{
						"n": 9,
						"h": 42,
						"w": 512
					},
					{
						"n": 10,
						"h": 169,
						"w": 515
					},
					{
						"n": 11,
						"h": 411,
						"w": 512
					}
				],
				"ball": {
					"n": 0,
					"h": 145,
					"w": 455,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 654,
			"minute": 32,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 15
					},
					{
						"n": 2,
						"h": 87,
						"w": 184
					},
					{
						"n": 3,
						"h": 212,
						"w": 160
					},
					{
						"n": 4,
						"h": 276,
						"w": 178
					},
					{
						"n": 5,
						"h": 330,
						"w": 169
					},
					{
						"n": 6,
						"h": 55,
						"w": 240
					},
					{
						"n": 7,
						"h": 193,
						"w": 295
					},
					{
						"n": 8,
						"h": 269,
						"w": 243
					},
					{
						"n": 9,
						"h": 407,
						"w": 281
					},
					{
						"n": 10,
						"h": 147,
						"w": 382
					},
					{
						"n": 11,
						"h": 276,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 93
					},
					{
						"n": 2,
						"h": 63,
						"w": 249
					},
					{
						"n": 3,
						"h": 174,
						"w": 211
					},
					{
						"n": 4,
						"h": 306,
						"w": 300
					},
					{
						"n": 5,
						"h": 393,
						"w": 218
					},
					{
						"n": 6,
						"h": 211,
						"w": 371
					},
					{
						"n": 7,
						"h": 242,
						"w": 481
					},
					{
						"n": 8,
						"h": 397,
						"w": 481
					},
					{
						"n": 9,
						"h": 48,
						"w": 517
					},
					{
						"n": 10,
						"h": 149,
						"w": 522
					},
					{
						"n": 11,
						"h": 372,
						"w": 516
					}
				],
				"ball": {
					"n": 0,
					"h": 144,
					"w": 420,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 655,
			"minute": 32,
			"messages": [
				{
					"owner": 2,
					"mes": "Себастьян Пейша[24](Опава) отдает мяч рванувшемуся вперед О.Дюмону[26](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 14
					},
					{
						"n": 2,
						"h": 67,
						"w": 163
					},
					{
						"n": 3,
						"h": 203,
						"w": 130
					},
					{
						"n": 4,
						"h": 285,
						"w": 139
					},
					{
						"n": 5,
						"h": 369,
						"w": 160
					},
					{
						"n": 6,
						"h": 56,
						"w": 194
					},
					{
						"n": 7,
						"h": 234,
						"w": 298
					},
					{
						"n": 8,
						"h": 265,
						"w": 216
					},
					{
						"n": 9,
						"h": 395,
						"w": 240
					},
					{
						"n": 10,
						"h": 155,
						"w": 337
					},
					{
						"n": 11,
						"h": 282,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 229,
						"w": 110
					},
					{
						"n": 2,
						"h": 75,
						"w": 279
					},
					{
						"n": 3,
						"h": 168,
						"w": 235
					},
					{
						"n": 4,
						"h": 306,
						"w": 300
					},
					{
						"n": 5,
						"h": 380,
						"w": 232
					},
					{
						"n": 6,
						"h": 211,
						"w": 401
					},
					{
						"n": 7,
						"h": 246,
						"w": 459
					},
					{
						"n": 8,
						"h": 403,
						"w": 513
					},
					{
						"n": 9,
						"h": 51,
						"w": 540
					},
					{
						"n": 10,
						"h": 150,
						"w": 555
					},
					{
						"n": 11,
						"h": 413,
						"w": 537
					}
				],
				"ball": {
					"n": 0,
					"h": 239,
					"w": 319,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 46
		},
		{
			"num": 656,
			"minute": 32,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 16
					},
					{
						"n": 2,
						"h": 67,
						"w": 145
					},
					{
						"n": 3,
						"h": 211,
						"w": 116
					},
					{
						"n": 4,
						"h": 264,
						"w": 105
					},
					{
						"n": 5,
						"h": 394,
						"w": 145
					},
					{
						"n": 6,
						"h": 56,
						"w": 154
					},
					{
						"n": 7,
						"h": 273,
						"w": 289
					},
					{
						"n": 8,
						"h": 269,
						"w": 176
					},
					{
						"n": 9,
						"h": 396,
						"w": 220
					},
					{
						"n": 10,
						"h": 160,
						"w": 376
					},
					{
						"n": 11,
						"h": 318,
						"w": 435
					}
				],
				"away": [
					{
						"n": 1,
						"h": 229,
						"w": 123
					},
					{
						"n": 2,
						"h": 72,
						"w": 311
					},
					{
						"n": 3,
						"h": 177,
						"w": 258
					},
					{
						"n": 4,
						"h": 287,
						"w": 265
					},
					{
						"n": 5,
						"h": 391,
						"w": 265
					},
					{
						"n": 6,
						"h": 177,
						"w": 411
					},
					{
						"n": 7,
						"h": 237,
						"w": 467
					},
					{
						"n": 8,
						"h": 404,
						"w": 533
					},
					{
						"n": 9,
						"h": 42,
						"w": 570
					},
					{
						"n": 10,
						"h": 167,
						"w": 580
					},
					{
						"n": 11,
						"h": 391,
						"w": 570
					}
				],
				"ball": {
					"n": 0,
					"h": 273,
					"w": 309,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 657,
			"minute": 32,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 19
					},
					{
						"n": 2,
						"h": 56,
						"w": 112
					},
					{
						"n": 3,
						"h": 224,
						"w": 105
					},
					{
						"n": 4,
						"h": 279,
						"w": 107
					},
					{
						"n": 5,
						"h": 394,
						"w": 113
					},
					{
						"n": 6,
						"h": 72,
						"w": 120
					},
					{
						"n": 7,
						"h": 240,
						"w": 282
					},
					{
						"n": 8,
						"h": 259,
						"w": 175
					},
					{
						"n": 9,
						"h": 386,
						"w": 205
					},
					{
						"n": 10,
						"h": 161,
						"w": 400
					},
					{
						"n": 11,
						"h": 278,
						"w": 430
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 118
					},
					{
						"n": 2,
						"h": 60,
						"w": 312
					},
					{
						"n": 3,
						"h": 172,
						"w": 298
					},
					{
						"n": 4,
						"h": 289,
						"w": 305
					},
					{
						"n": 5,
						"h": 381,
						"w": 283
					},
					{
						"n": 6,
						"h": 211,
						"w": 420
					},
					{
						"n": 7,
						"h": 231,
						"w": 506
					},
					{
						"n": 8,
						"h": 393,
						"w": 572
					},
					{
						"n": 9,
						"h": 44,
						"w": 601
					},
					{
						"n": 10,
						"h": 147,
						"w": 599
					},
					{
						"n": 11,
						"h": 407,
						"w": 599
					}
				],
				"ball": {
					"n": 0,
					"h": 239,
					"w": 300,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 658,
			"minute": 32,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 18
					},
					{
						"n": 2,
						"h": 56,
						"w": 111
					},
					{
						"n": 3,
						"h": 232,
						"w": 99
					},
					{
						"n": 4,
						"h": 268,
						"w": 115
					},
					{
						"n": 5,
						"h": 393,
						"w": 105
					},
					{
						"n": 6,
						"h": 64,
						"w": 120
					},
					{
						"n": 7,
						"h": 201,
						"w": 273
					},
					{
						"n": 8,
						"h": 236,
						"w": 174
					},
					{
						"n": 9,
						"h": 402,
						"w": 205
					},
					{
						"n": 10,
						"h": 159,
						"w": 360
					},
					{
						"n": 11,
						"h": 303,
						"w": 430
					}
				],
				"away": [
					{
						"n": 1,
						"h": 226,
						"w": 124
					},
					{
						"n": 2,
						"h": 68,
						"w": 321
					},
					{
						"n": 3,
						"h": 165,
						"w": 337
					},
					{
						"n": 4,
						"h": 292,
						"w": 345
					},
					{
						"n": 5,
						"h": 389,
						"w": 277
					},
					{
						"n": 6,
						"h": 245,
						"w": 429
					},
					{
						"n": 7,
						"h": 223,
						"w": 545
					},
					{
						"n": 8,
						"h": 401,
						"w": 574
					},
					{
						"n": 9,
						"h": 49,
						"w": 602
					},
					{
						"n": 10,
						"h": 167,
						"w": 607
					},
					{
						"n": 11,
						"h": 408,
						"w": 600
					}
				],
				"ball": {
					"n": 0,
					"h": 205,
					"w": 291,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 659,
			"minute": 32,
			"messages": [
				{
					"owner": 2,
					"mes": "О.Дюмон[26](Опава) катит мяч на Н.Мансура[23](Опава)..."
				},
				{
					"owner": 2,
					"mes": "Нир Мансур[23](Опава) достает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 13
					},
					{
						"n": 2,
						"h": 81,
						"w": 130
					},
					{
						"n": 3,
						"h": 234,
						"w": 110
					},
					{
						"n": 4,
						"h": 273,
						"w": 107
					},
					{
						"n": 5,
						"h": 365,
						"w": 130
					},
					{
						"n": 6,
						"h": 56,
						"w": 136
					},
					{
						"n": 7,
						"h": 231,
						"w": 304
					},
					{
						"n": 8,
						"h": 234,
						"w": 194
					},
					{
						"n": 9,
						"h": 409,
						"w": 210
					},
					{
						"n": 10,
						"h": 175,
						"w": 390
					},
					{
						"n": 11,
						"h": 305,
						"w": 400
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 122
					},
					{
						"n": 2,
						"h": 70,
						"w": 352
					},
					{
						"n": 3,
						"h": 185,
						"w": 367
					},
					{
						"n": 4,
						"h": 275,
						"w": 306
					},
					{
						"n": 5,
						"h": 379,
						"w": 303
					},
					{
						"n": 6,
						"h": 245,
						"w": 429
					},
					{
						"n": 7,
						"h": 221,
						"w": 510
					},
					{
						"n": 8,
						"h": 394,
						"w": 549
					},
					{
						"n": 9,
						"h": 55,
						"w": 570
					},
					{
						"n": 10,
						"h": 149,
						"w": 586
					},
					{
						"n": 11,
						"h": 399,
						"w": 570
					}
				],
				"ball": {
					"n": 0,
					"h": 265,
					"w": 353,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 43
		},
		{
			"num": 660,
			"minute": 32,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 19
					},
					{
						"n": 2,
						"h": 63,
						"w": 126
					},
					{
						"n": 3,
						"h": 231,
						"w": 106
					},
					{
						"n": 4,
						"h": 275,
						"w": 111
					},
					{
						"n": 5,
						"h": 393,
						"w": 129
					},
					{
						"n": 6,
						"h": 56,
						"w": 141
					},
					{
						"n": 7,
						"h": 269,
						"w": 298
					},
					{
						"n": 8,
						"h": 233,
						"w": 182
					},
					{
						"n": 9,
						"h": 402,
						"w": 204
					},
					{
						"n": 10,
						"h": 173,
						"w": 400
					},
					{
						"n": 11,
						"h": 315,
						"w": 432
					}
				],
				"away": [
					{
						"n": 1,
						"h": 228,
						"w": 126
					},
					{
						"n": 2,
						"h": 69,
						"w": 326
					},
					{
						"n": 3,
						"h": 181,
						"w": 401
					},
					{
						"n": 4,
						"h": 277,
						"w": 287
					},
					{
						"n": 5,
						"h": 383,
						"w": 268
					},
					{
						"n": 6,
						"h": 239,
						"w": 446
					},
					{
						"n": 7,
						"h": 223,
						"w": 516
					},
					{
						"n": 8,
						"h": 417,
						"w": 574
					},
					{
						"n": 9,
						"h": 27,
						"w": 571
					},
					{
						"n": 10,
						"h": 157,
						"w": 576
					},
					{
						"n": 11,
						"h": 428,
						"w": 544
					}
				],
				"ball": {
					"n": 0,
					"h": 269,
					"w": 319,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 661,
			"minute": 32,
			"messages": [
				{
					"owner": 2,
					"mes": "Нир Мансур[23](Опава) смотрит налево... Пас Л.Седлачеку[22](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 13
					},
					{
						"n": 2,
						"h": 98,
						"w": 114
					},
					{
						"n": 3,
						"h": 240,
						"w": 96
					},
					{
						"n": 4,
						"h": 277,
						"w": 107
					},
					{
						"n": 5,
						"h": 379,
						"w": 130
					},
					{
						"n": 6,
						"h": 56,
						"w": 166
					},
					{
						"n": 7,
						"h": 300,
						"w": 319
					},
					{
						"n": 8,
						"h": 259,
						"w": 182
					},
					{
						"n": 9,
						"h": 426,
						"w": 206
					},
					{
						"n": 10,
						"h": 164,
						"w": 400
					},
					{
						"n": 11,
						"h": 307,
						"w": 435
					}
				],
				"away": [
					{
						"n": 1,
						"h": 223,
						"w": 127
					},
					{
						"n": 2,
						"h": 98,
						"w": 349
					},
					{
						"n": 3,
						"h": 178,
						"w": 392
					},
					{
						"n": 4,
						"h": 286,
						"w": 266
					},
					{
						"n": 5,
						"h": 388,
						"w": 294
					},
					{
						"n": 6,
						"h": 211,
						"w": 422
					},
					{
						"n": 7,
						"h": 191,
						"w": 530
					},
					{
						"n": 8,
						"h": 392,
						"w": 570
					},
					{
						"n": 9,
						"h": 41,
						"w": 570
					},
					{
						"n": 10,
						"h": 151,
						"w": 599
					},
					{
						"n": 11,
						"h": 401,
						"w": 519
					}
				],
				"ball": {
					"n": 0,
					"h": 352,
					"w": 371,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 37
		},
		{
			"num": 662,
			"minute": 32,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 16
					},
					{
						"n": 2,
						"h": 120,
						"w": 108
					},
					{
						"n": 3,
						"h": 249,
						"w": 90
					},
					{
						"n": 4,
						"h": 295,
						"w": 89
					},
					{
						"n": 5,
						"h": 394,
						"w": 104
					},
					{
						"n": 6,
						"h": 56,
						"w": 185
					},
					{
						"n": 7,
						"h": 340,
						"w": 315
					},
					{
						"n": 8,
						"h": 258,
						"w": 174
					},
					{
						"n": 9,
						"h": 420,
						"w": 199
					},
					{
						"n": 10,
						"h": 169,
						"w": 400
					},
					{
						"n": 11,
						"h": 314,
						"w": 414
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 124
					},
					{
						"n": 2,
						"h": 101,
						"w": 384
					},
					{
						"n": 3,
						"h": 179,
						"w": 352
					},
					{
						"n": 4,
						"h": 281,
						"w": 281
					},
					{
						"n": 5,
						"h": 378,
						"w": 302
					},
					{
						"n": 6,
						"h": 217,
						"w": 462
					},
					{
						"n": 7,
						"h": 202,
						"w": 568
					},
					{
						"n": 8,
						"h": 404,
						"w": 603
					},
					{
						"n": 9,
						"h": 44,
						"w": 604
					},
					{
						"n": 10,
						"h": 131,
						"w": 601
					},
					{
						"n": 11,
						"h": 414,
						"w": 520
					}
				],
				"ball": {
					"n": 0,
					"h": 349,
					"w": 336,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 663,
			"minute": 32,
			"messages": [
				{
					"owner": 2,
					"mes": "Лука Седлачек[22](Опава) переправляет мяч на ход О.Дюмону[26](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 14
					},
					{
						"n": 2,
						"h": 75,
						"w": 121
					},
					{
						"n": 3,
						"h": 220,
						"w": 111
					},
					{
						"n": 4,
						"h": 269,
						"w": 126
					},
					{
						"n": 5,
						"h": 347,
						"w": 111
					},
					{
						"n": 6,
						"h": 56,
						"w": 210
					},
					{
						"n": 7,
						"h": 307,
						"w": 280
					},
					{
						"n": 8,
						"h": 262,
						"w": 211
					},
					{
						"n": 9,
						"h": 397,
						"w": 158
					},
					{
						"n": 10,
						"h": 177,
						"w": 400
					},
					{
						"n": 11,
						"h": 311,
						"w": 446
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 121
					},
					{
						"n": 2,
						"h": 101,
						"w": 384
					},
					{
						"n": 3,
						"h": 179,
						"w": 305
					},
					{
						"n": 4,
						"h": 273,
						"w": 253
					},
					{
						"n": 5,
						"h": 379,
						"w": 261
					},
					{
						"n": 6,
						"h": 192,
						"w": 492
					},
					{
						"n": 7,
						"h": 227,
						"w": 529
					},
					{
						"n": 8,
						"h": 415,
						"w": 579
					},
					{
						"n": 9,
						"h": 50,
						"w": 559
					},
					{
						"n": 10,
						"h": 165,
						"w": 569
					},
					{
						"n": 11,
						"h": 400,
						"w": 475
					}
				],
				"ball": {
					"n": 0,
					"h": 258,
					"w": 228,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 47
		},
		{
			"num": 664,
			"minute": 32,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 12
					},
					{
						"n": 2,
						"h": 56,
						"w": 119
					},
					{
						"n": 3,
						"h": 231,
						"w": 119
					},
					{
						"n": 4,
						"h": 277,
						"w": 120
					},
					{
						"n": 5,
						"h": 386,
						"w": 119
					},
					{
						"n": 6,
						"h": 56,
						"w": 170
					},
					{
						"n": 7,
						"h": 275,
						"w": 257
					},
					{
						"n": 8,
						"h": 225,
						"w": 199
					},
					{
						"n": 9,
						"h": 395,
						"w": 198
					},
					{
						"n": 10,
						"h": 167,
						"w": 400
					},
					{
						"n": 11,
						"h": 308,
						"w": 427
					}
				],
				"away": [
					{
						"n": 1,
						"h": 223,
						"w": 119
					},
					{
						"n": 2,
						"h": 96,
						"w": 424
					},
					{
						"n": 3,
						"h": 174,
						"w": 344
					},
					{
						"n": 4,
						"h": 283,
						"w": 283
					},
					{
						"n": 5,
						"h": 391,
						"w": 281
					},
					{
						"n": 6,
						"h": 226,
						"w": 501
					},
					{
						"n": 7,
						"h": 214,
						"w": 566
					},
					{
						"n": 8,
						"h": 406,
						"w": 591
					},
					{
						"n": 9,
						"h": 46,
						"w": 586
					},
					{
						"n": 10,
						"h": 145,
						"w": 585
					},
					{
						"n": 11,
						"h": 406,
						"w": 515
					}
				],
				"ball": {
					"n": 0,
					"h": 224,
					"w": 219,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 665,
			"minute": 32,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 12
					},
					{
						"n": 2,
						"h": 56,
						"w": 153
					},
					{
						"n": 3,
						"h": 235,
						"w": 126
					},
					{
						"n": 4,
						"h": 273,
						"w": 130
					},
					{
						"n": 5,
						"h": 347,
						"w": 114
					},
					{
						"n": 6,
						"h": 56,
						"w": 210
					},
					{
						"n": 7,
						"h": 241,
						"w": 236
					},
					{
						"n": 8,
						"h": 186,
						"w": 206
					},
					{
						"n": 9,
						"h": 394,
						"w": 158
					},
					{
						"n": 10,
						"h": 168,
						"w": 400
					},
					{
						"n": 11,
						"h": 306,
						"w": 446
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 122
					},
					{
						"n": 2,
						"h": 87,
						"w": 385
					},
					{
						"n": 3,
						"h": 174,
						"w": 304
					},
					{
						"n": 4,
						"h": 282,
						"w": 249
					},
					{
						"n": 5,
						"h": 378,
						"w": 262
					},
					{
						"n": 6,
						"h": 265,
						"w": 493
					},
					{
						"n": 7,
						"h": 214,
						"w": 526
					},
					{
						"n": 8,
						"h": 407,
						"w": 559
					},
					{
						"n": 9,
						"h": 30,
						"w": 559
					},
					{
						"n": 10,
						"h": 148,
						"w": 569
					},
					{
						"n": 11,
						"h": 406,
						"w": 475
					}
				],
				"ball": {
					"n": 0,
					"h": 185,
					"w": 227,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 666,
			"minute": 32,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 10
					},
					{
						"n": 2,
						"h": 56,
						"w": 151
					},
					{
						"n": 3,
						"h": 228,
						"w": 124
					},
					{
						"n": 4,
						"h": 277,
						"w": 126
					},
					{
						"n": 5,
						"h": 330,
						"w": 118
					},
					{
						"n": 6,
						"h": 56,
						"w": 242
					},
					{
						"n": 7,
						"h": 246,
						"w": 204
					},
					{
						"n": 8,
						"h": 144,
						"w": 205
					},
					{
						"n": 9,
						"h": 394,
						"w": 136
					},
					{
						"n": 10,
						"h": 169,
						"w": 400
					},
					{
						"n": 11,
						"h": 270,
						"w": 446
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 120
					},
					{
						"n": 2,
						"h": 79,
						"w": 346
					},
					{
						"n": 3,
						"h": 180,
						"w": 265
					},
					{
						"n": 4,
						"h": 281,
						"w": 256
					},
					{
						"n": 5,
						"h": 393,
						"w": 282
					},
					{
						"n": 6,
						"h": 305,
						"w": 495
					},
					{
						"n": 7,
						"h": 212,
						"w": 486
					},
					{
						"n": 8,
						"h": 413,
						"w": 559
					},
					{
						"n": 9,
						"h": 35,
						"w": 559
					},
					{
						"n": 10,
						"h": 166,
						"w": 569
					},
					{
						"n": 11,
						"h": 411,
						"w": 443
					}
				],
				"ball": {
					"n": 0,
					"h": 145,
					"w": 225,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 667,
			"minute": 32,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 10
					},
					{
						"n": 2,
						"h": 56,
						"w": 125
					},
					{
						"n": 3,
						"h": 227,
						"w": 120
					},
					{
						"n": 4,
						"h": 276,
						"w": 119
					},
					{
						"n": 5,
						"h": 330,
						"w": 124
					},
					{
						"n": 6,
						"h": 56,
						"w": 202
					},
					{
						"n": 7,
						"h": 218,
						"w": 180
					},
					{
						"n": 8,
						"h": 176,
						"w": 199
					},
					{
						"n": 9,
						"h": 365,
						"w": 132
					},
					{
						"n": 10,
						"h": 165,
						"w": 400
					},
					{
						"n": 11,
						"h": 273,
						"w": 442
					}
				],
				"away": [
					{
						"n": 1,
						"h": 229,
						"w": 125
					},
					{
						"n": 2,
						"h": 64,
						"w": 309
					},
					{
						"n": 3,
						"h": 177,
						"w": 305
					},
					{
						"n": 4,
						"h": 285,
						"w": 296
					},
					{
						"n": 5,
						"h": 375,
						"w": 256
					},
					{
						"n": 6,
						"h": 271,
						"w": 504
					},
					{
						"n": 7,
						"h": 223,
						"w": 525
					},
					{
						"n": 8,
						"h": 405,
						"w": 585
					},
					{
						"n": 9,
						"h": 73,
						"w": 571
					},
					{
						"n": 10,
						"h": 146,
						"w": 586
					},
					{
						"n": 11,
						"h": 414,
						"w": 483
					}
				],
				"ball": {
					"n": 0,
					"h": 179,
					"w": 216,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 668,
			"minute": 32,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 13
					},
					{
						"n": 2,
						"h": 56,
						"w": 119
					},
					{
						"n": 3,
						"h": 221,
						"w": 112
					},
					{
						"n": 4,
						"h": 306,
						"w": 109
					},
					{
						"n": 5,
						"h": 370,
						"w": 120
					},
					{
						"n": 6,
						"h": 56,
						"w": 180
					},
					{
						"n": 7,
						"h": 221,
						"w": 181
					},
					{
						"n": 8,
						"h": 214,
						"w": 187
					},
					{
						"n": 9,
						"h": 390,
						"w": 163
					},
					{
						"n": 10,
						"h": 159,
						"w": 361
					},
					{
						"n": 11,
						"h": 306,
						"w": 424
					}
				],
				"away": [
					{
						"n": 1,
						"h": 226,
						"w": 124
					},
					{
						"n": 2,
						"h": 57,
						"w": 325
					},
					{
						"n": 3,
						"h": 174,
						"w": 345
					},
					{
						"n": 4,
						"h": 288,
						"w": 336
					},
					{
						"n": 5,
						"h": 380,
						"w": 294
					},
					{
						"n": 6,
						"h": 237,
						"w": 513
					},
					{
						"n": 7,
						"h": 234,
						"w": 563
					},
					{
						"n": 8,
						"h": 407,
						"w": 589
					},
					{
						"n": 9,
						"h": 44,
						"w": 588
					},
					{
						"n": 10,
						"h": 126,
						"w": 596
					},
					{
						"n": 11,
						"h": 402,
						"w": 505
					}
				],
				"ball": {
					"n": 0,
					"h": 213,
					"w": 207,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 669,
			"minute": 33,
			"possession": 43,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 11
					},
					{
						"n": 2,
						"h": 56,
						"w": 94
					},
					{
						"n": 3,
						"h": 231,
						"w": 73
					},
					{
						"n": 4,
						"h": 288,
						"w": 73
					},
					{
						"n": 5,
						"h": 390,
						"w": 86
					},
					{
						"n": 6,
						"h": 56,
						"w": 140,
						"f": 89,
						"c": 1
					},
					{
						"n": 7,
						"h": 241,
						"w": 146
					},
					{
						"n": 8,
						"h": 170,
						"w": 185
					},
					{
						"n": 9,
						"h": 406,
						"w": 152,
						"f": 88
					},
					{
						"n": 10,
						"h": 174,
						"w": 390,
						"f": 88
					},
					{
						"n": 11,
						"h": 274,
						"w": 400
					}
				],
				"away": [
					{
						"n": 1,
						"h": 228,
						"w": 119
					},
					{
						"n": 2,
						"h": 61,
						"w": 348,
						"f": 87
					},
					{
						"n": 3,
						"h": 177,
						"w": 305
					},
					{
						"n": 4,
						"h": 276,
						"w": 309
					},
					{
						"n": 5,
						"h": 374,
						"w": 313
					},
					{
						"n": 6,
						"h": 277,
						"w": 513
					},
					{
						"n": 7,
						"h": 210,
						"w": 589
					},
					{
						"n": 8,
						"h": 402,
						"w": 636,
						"f": 89,
						"c": 1
					},
					{
						"n": 9,
						"h": 46,
						"w": 628
					},
					{
						"n": 10,
						"h": 146,
						"w": 631,
						"f": 88
					},
					{
						"n": 11,
						"h": 398,
						"w": 545,
						"f": 88
					}
				],
				"ball": {
					"n": 0,
					"h": 173,
					"w": 207,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 670,
			"minute": 33,
			"messages": [
				{
					"owner": 2,
					"mes": "Пас вперед..."
				},
				{
					"owner": 2,
					"mes": "Но Агуст Хлинссон[07](Галвэй Юнайтед) бросается наперерез и перехватывает мяч!..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 15
					},
					{
						"n": 2,
						"h": 74,
						"w": 80
					},
					{
						"n": 3,
						"h": 229,
						"w": 70
					},
					{
						"n": 4,
						"h": 265,
						"w": 73
					},
					{
						"n": 5,
						"h": 373,
						"w": 82
					},
					{
						"n": 6,
						"h": 56,
						"w": 162
					},
					{
						"n": 7,
						"h": 222,
						"w": 160
					},
					{
						"n": 8,
						"h": 181,
						"w": 165
					},
					{
						"n": 9,
						"h": 407,
						"w": 173
					},
					{
						"n": 10,
						"h": 176,
						"w": 390
					},
					{
						"n": 11,
						"h": 274,
						"w": 400
					}
				],
				"away": [
					{
						"n": 1,
						"h": 228,
						"w": 125
					},
					{
						"n": 2,
						"h": 70,
						"w": 350
					},
					{
						"n": 3,
						"h": 176,
						"w": 300
					},
					{
						"n": 4,
						"h": 274,
						"w": 319
					},
					{
						"n": 5,
						"h": 380,
						"w": 307
					},
					{
						"n": 6,
						"h": 269,
						"w": 506
					},
					{
						"n": 7,
						"h": 221,
						"w": 572
					},
					{
						"n": 8,
						"h": 390,
						"w": 626
					},
					{
						"n": 9,
						"h": 47,
						"w": 618
					},
					{
						"n": 10,
						"h": 168,
						"w": 627
					},
					{
						"n": 11,
						"h": 406,
						"w": 523
					}
				],
				"ball": {
					"n": 0,
					"h": 222,
					"w": 160,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 23
		},
		{
			"num": 671,
			"minute": 33,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 11
					},
					{
						"n": 2,
						"h": 75,
						"w": 120
					},
					{
						"n": 3,
						"h": 198,
						"w": 95
					},
					{
						"n": 4,
						"h": 273,
						"w": 112
					},
					{
						"n": 5,
						"h": 376,
						"w": 122
					},
					{
						"n": 6,
						"h": 50,
						"w": 201
					},
					{
						"n": 7,
						"h": 247,
						"w": 184,
						"m": 700
					},
					{
						"n": 8,
						"h": 199,
						"w": 201
					},
					{
						"n": 9,
						"h": 410,
						"w": 213
					},
					{
						"n": 10,
						"h": 145,
						"w": 405
					},
					{
						"n": 11,
						"h": 292,
						"w": 415
					}
				],
				"away": [
					{
						"n": 1,
						"h": 221,
						"w": 81
					},
					{
						"n": 2,
						"h": 73,
						"w": 310
					},
					{
						"n": 3,
						"h": 177,
						"w": 260
					},
					{
						"n": 4,
						"h": 275,
						"w": 279
					},
					{
						"n": 5,
						"h": 354,
						"w": 277
					},
					{
						"n": 6,
						"h": 251,
						"w": 471
					},
					{
						"n": 7,
						"h": 211,
						"w": 533
					},
					{
						"n": 8,
						"h": 393,
						"w": 586
					},
					{
						"n": 9,
						"h": 44,
						"w": 578
					},
					{
						"n": 10,
						"h": 177,
						"w": 588
					},
					{
						"n": 11,
						"h": 376,
						"w": 497
					}
				],
				"ball": {
					"n": 0,
					"h": 247,
					"w": 184,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 672,
			"minute": 33,
			"messages": [
				{
					"owner": 1,
					"mes": "Агуст Хлинссон[07](Галвэй Юнайтед) пасует А.Гилберту[11](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 11
					},
					{
						"n": 2,
						"h": 76,
						"w": 172
					},
					{
						"n": 3,
						"h": 181,
						"w": 144
					},
					{
						"n": 4,
						"h": 265,
						"w": 148
					},
					{
						"n": 5,
						"h": 380,
						"w": 174
					},
					{
						"n": 6,
						"h": 52,
						"w": 253
					},
					{
						"n": 7,
						"h": 239,
						"w": 191
					},
					{
						"n": 8,
						"h": 225,
						"w": 246
					},
					{
						"n": 9,
						"h": 398,
						"w": 263
					},
					{
						"n": 10,
						"h": 156,
						"w": 440
					},
					{
						"n": 11,
						"h": 264,
						"w": 393
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 78
					},
					{
						"n": 2,
						"h": 95,
						"w": 263
					},
					{
						"n": 3,
						"h": 206,
						"w": 220
					},
					{
						"n": 4,
						"h": 282,
						"w": 242
					},
					{
						"n": 5,
						"h": 342,
						"w": 226
					},
					{
						"n": 6,
						"h": 263,
						"w": 420
					},
					{
						"n": 7,
						"h": 217,
						"w": 481
					},
					{
						"n": 8,
						"h": 398,
						"w": 554
					},
					{
						"n": 9,
						"h": 44,
						"w": 526
					},
					{
						"n": 10,
						"h": 197,
						"w": 540
					},
					{
						"n": 11,
						"h": 326,
						"w": 483
					}
				],
				"ball": {
					"n": 0,
					"h": 264,
					"w": 393,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 52
		},
		{
			"num": 673,
			"minute": 33,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 15
					},
					{
						"n": 2,
						"h": 78,
						"w": 212
					},
					{
						"n": 3,
						"h": 171,
						"w": 180
					},
					{
						"n": 4,
						"h": 277,
						"w": 186
					},
					{
						"n": 5,
						"h": 387,
						"w": 213
					},
					{
						"n": 6,
						"h": 51,
						"w": 293
					},
					{
						"n": 7,
						"h": 220,
						"w": 226
					},
					{
						"n": 8,
						"h": 242,
						"w": 283
					},
					{
						"n": 9,
						"h": 396,
						"w": 303
					},
					{
						"n": 10,
						"h": 152,
						"w": 479
					},
					{
						"n": 11,
						"h": 263,
						"w": 428
					}
				],
				"away": [
					{
						"n": 1,
						"h": 221,
						"w": 72
					},
					{
						"n": 2,
						"h": 104,
						"w": 224
					},
					{
						"n": 3,
						"h": 193,
						"w": 257
					},
					{
						"n": 4,
						"h": 246,
						"w": 224
					},
					{
						"n": 5,
						"h": 340,
						"w": 193
					},
					{
						"n": 6,
						"h": 273,
						"w": 381
					},
					{
						"n": 7,
						"h": 218,
						"w": 441
					},
					{
						"n": 8,
						"h": 398,
						"w": 514
					},
					{
						"n": 9,
						"h": 45,
						"w": 486
					},
					{
						"n": 10,
						"h": 201,
						"w": 500
					},
					{
						"n": 11,
						"h": 309,
						"w": 447
					}
				],
				"ball": {
					"n": 0,
					"h": 263,
					"w": 428,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 674,
			"minute": 33,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 15
					},
					{
						"n": 2,
						"h": 68,
						"w": 250
					},
					{
						"n": 3,
						"h": 171,
						"w": 217
					},
					{
						"n": 4,
						"h": 283,
						"w": 212
					},
					{
						"n": 5,
						"h": 382,
						"w": 253
					},
					{
						"n": 6,
						"h": 51,
						"w": 333
					},
					{
						"n": 7,
						"h": 203,
						"w": 262
					},
					{
						"n": 8,
						"h": 256,
						"w": 320
					},
					{
						"n": 9,
						"h": 394,
						"w": 343
					},
					{
						"n": 10,
						"h": 150,
						"w": 487
					},
					{
						"n": 11,
						"h": 245,
						"w": 459
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 77
					},
					{
						"n": 2,
						"h": 109,
						"w": 184
					},
					{
						"n": 3,
						"h": 205,
						"w": 241
					},
					{
						"n": 4,
						"h": 229,
						"w": 188
					},
					{
						"n": 5,
						"h": 340,
						"w": 166
					},
					{
						"n": 6,
						"h": 278,
						"w": 342
					},
					{
						"n": 7,
						"h": 218,
						"w": 401
					},
					{
						"n": 8,
						"h": 398,
						"w": 474
					},
					{
						"n": 9,
						"h": 40,
						"w": 446
					},
					{
						"n": 10,
						"h": 199,
						"w": 460
					},
					{
						"n": 11,
						"h": 269,
						"w": 441
					}
				],
				"ball": {
					"n": 0,
					"h": 245,
					"w": 459,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 675,
			"minute": 33,
			"messages": [
				{
					"owner": 1,
					"mes": "Адам Гилберт[11](Галвэй Юнайтед) подключает к атаке Д.Квигли[10](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 13
					},
					{
						"n": 2,
						"h": 71,
						"w": 290
					},
					{
						"n": 3,
						"h": 176,
						"w": 257
					},
					{
						"n": 4,
						"h": 273,
						"w": 251
					},
					{
						"n": 5,
						"h": 382,
						"w": 293
					},
					{
						"n": 6,
						"h": 50,
						"w": 373
					},
					{
						"n": 7,
						"h": 194,
						"w": 301
					},
					{
						"n": 8,
						"h": 265,
						"w": 359
					},
					{
						"n": 9,
						"h": 398,
						"w": 383
					},
					{
						"n": 10,
						"h": 155,
						"w": 537
					},
					{
						"n": 11,
						"h": 245,
						"w": 459,
						"m": 800
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 37
					},
					{
						"n": 2,
						"h": 110,
						"w": 144
					},
					{
						"n": 3,
						"h": 195,
						"w": 203
					},
					{
						"n": 4,
						"h": 227,
						"w": 148
					},
					{
						"n": 5,
						"h": 320,
						"w": 165
					},
					{
						"n": 6,
						"h": 266,
						"w": 304
					},
					{
						"n": 7,
						"h": 217,
						"w": 361
					},
					{
						"n": 8,
						"h": 399,
						"w": 434
					},
					{
						"n": 9,
						"h": 41,
						"w": 406
					},
					{
						"n": 10,
						"h": 194,
						"w": 421
					},
					{
						"n": 11,
						"h": 258,
						"w": 403
					}
				],
				"ball": {
					"n": 0,
					"h": 155,
					"w": 537,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 676,
			"minute": 33,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 13
					},
					{
						"n": 2,
						"h": 68,
						"w": 315
					},
					{
						"n": 3,
						"h": 169,
						"w": 281
					},
					{
						"n": 4,
						"h": 270,
						"w": 276
					},
					{
						"n": 5,
						"h": 386,
						"w": 318
					},
					{
						"n": 6,
						"h": 50,
						"w": 398
					},
					{
						"n": 7,
						"h": 188,
						"w": 325
					},
					{
						"n": 8,
						"h": 268,
						"w": 384
					},
					{
						"n": 9,
						"h": 398,
						"w": 408
					},
					{
						"n": 10,
						"h": 155,
						"w": 558
					},
					{
						"n": 11,
						"h": 255,
						"w": 482
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 34
					},
					{
						"n": 2,
						"h": 110,
						"w": 119
					},
					{
						"n": 3,
						"h": 190,
						"w": 178
					},
					{
						"n": 4,
						"h": 208,
						"w": 132
					},
					{
						"n": 5,
						"h": 295,
						"w": 162
					},
					{
						"n": 6,
						"h": 254,
						"w": 282
					},
					{
						"n": 7,
						"h": 217,
						"w": 336
					},
					{
						"n": 8,
						"h": 399,
						"w": 409
					},
					{
						"n": 9,
						"h": 41,
						"w": 381
					},
					{
						"n": 10,
						"h": 191,
						"w": 396
					},
					{
						"n": 11,
						"h": 262,
						"w": 378
					}
				],
				"ball": {
					"n": 0,
					"h": 155,
					"w": 558,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 25
		},
		{
			"num": 677,
			"minute": 33,
			"messages": [
				{
					"owner": 1,
					"mes": "Д.Квигли[10](Галвэй Юнайтед) пытается пройти Т.Прохазку[25](Опава)..."
				},
				{
					"owner": 1,
					"mes": "Классный отбор Т.Прохазки[25](Опава)!.."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 13
					},
					{
						"n": 2,
						"h": 67,
						"w": 325
					},
					{
						"n": 3,
						"h": 167,
						"w": 290
					},
					{
						"n": 4,
						"h": 269,
						"w": 286
					},
					{
						"n": 5,
						"h": 387,
						"w": 326
					},
					{
						"n": 6,
						"h": 50,
						"w": 408
					},
					{
						"n": 7,
						"h": 185,
						"w": 335
					},
					{
						"n": 8,
						"h": 270,
						"w": 394
					},
					{
						"n": 9,
						"h": 397,
						"w": 418
					},
					{
						"n": 10,
						"h": 155,
						"w": 568
					},
					{
						"n": 11,
						"h": 258,
						"w": 491
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 34
					},
					{
						"n": 2,
						"h": 110,
						"w": 110
					},
					{
						"n": 3,
						"h": 188,
						"w": 169
					},
					{
						"n": 4,
						"h": 201,
						"w": 126
					},
					{
						"n": 5,
						"h": 285,
						"w": 160,
						"m": 640
					},
					{
						"n": 6,
						"h": 250,
						"w": 273
					},
					{
						"n": 7,
						"h": 217,
						"w": 326
					},
					{
						"n": 8,
						"h": 399,
						"w": 399
					},
					{
						"n": 9,
						"h": 41,
						"w": 371
					},
					{
						"n": 10,
						"h": 190,
						"w": 386
					},
					{
						"n": 11,
						"h": 262,
						"w": 375
					}
				],
				"ball": {
					"n": 0,
					"h": 165,
					"w": 560,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 10
		},
		{
			"num": 678,
			"minute": 33,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 18
					},
					{
						"n": 2,
						"h": 65,
						"w": 285
					},
					{
						"n": 3,
						"h": 177,
						"w": 281
					},
					{
						"n": 4,
						"h": 286,
						"w": 277
					},
					{
						"n": 5,
						"h": 357,
						"w": 300
					},
					{
						"n": 6,
						"h": 50,
						"w": 388
					},
					{
						"n": 7,
						"h": 175,
						"w": 325
					},
					{
						"n": 8,
						"h": 263,
						"w": 358
					},
					{
						"n": 9,
						"h": 394,
						"w": 378
					},
					{
						"n": 10,
						"h": 151,
						"w": 559
					},
					{
						"n": 11,
						"h": 270,
						"w": 453
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 15
					},
					{
						"n": 2,
						"h": 77,
						"w": 132
					},
					{
						"n": 3,
						"h": 179,
						"w": 129
					},
					{
						"n": 4,
						"h": 240,
						"w": 118
					},
					{
						"n": 5,
						"h": 316,
						"w": 178
					},
					{
						"n": 6,
						"h": 234,
						"w": 236
					},
					{
						"n": 7,
						"h": 237,
						"w": 303
					},
					{
						"n": 8,
						"h": 401,
						"w": 429
					},
					{
						"n": 9,
						"h": 39,
						"w": 331
					},
					{
						"n": 10,
						"h": 154,
						"w": 403
					},
					{
						"n": 11,
						"h": 285,
						"w": 408
					}
				],
				"ball": {
					"n": 0,
					"h": 134,
					"w": 542,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 679,
			"minute": 33,
			"messages": [
				{
					"owner": 2,
					"mes": "Т.Прохазка[25](Опава) отдает передачу С.Пейше[24](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 18
					},
					{
						"n": 2,
						"h": 79,
						"w": 306
					},
					{
						"n": 3,
						"h": 176,
						"w": 252
					},
					{
						"n": 4,
						"h": 277,
						"w": 267
					},
					{
						"n": 5,
						"h": 337,
						"w": 271
					},
					{
						"n": 6,
						"h": 31,
						"w": 360
					},
					{
						"n": 7,
						"h": 173,
						"w": 324
					},
					{
						"n": 8,
						"h": 246,
						"w": 341
					},
					{
						"n": 9,
						"h": 394,
						"w": 343
					},
					{
						"n": 10,
						"h": 156,
						"w": 525
					},
					{
						"n": 11,
						"h": 305,
						"w": 451
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 16
					},
					{
						"n": 2,
						"h": 57,
						"w": 160
					},
					{
						"n": 3,
						"h": 163,
						"w": 108
					},
					{
						"n": 4,
						"h": 217,
						"w": 140
					},
					{
						"n": 5,
						"h": 324,
						"w": 172,
						"m": 650
					},
					{
						"n": 6,
						"h": 228,
						"w": 242
					},
					{
						"n": 7,
						"h": 214,
						"w": 327
					},
					{
						"n": 8,
						"h": 401,
						"w": 394
					},
					{
						"n": 9,
						"h": 46,
						"w": 366
					},
					{
						"n": 10,
						"h": 158,
						"w": 433
					},
					{
						"n": 11,
						"h": 285,
						"w": 426
					}
				],
				"ball": {
					"n": 0,
					"h": 233,
					"w": 580,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 35
		},
		{
			"num": 680,
			"minute": 33,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 13
					},
					{
						"n": 2,
						"h": 73,
						"w": 302
					},
					{
						"n": 3,
						"h": 188,
						"w": 270
					},
					{
						"n": 4,
						"h": 273,
						"w": 251
					},
					{
						"n": 5,
						"h": 330,
						"w": 266
					},
					{
						"n": 6,
						"h": 61,
						"w": 360
					},
					{
						"n": 7,
						"h": 167,
						"w": 330
					},
					{
						"n": 8,
						"h": 237,
						"w": 350
					},
					{
						"n": 9,
						"h": 394,
						"w": 303
					},
					{
						"n": 10,
						"h": 161,
						"w": 485
					},
					{
						"n": 11,
						"h": 311,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 14
					},
					{
						"n": 2,
						"h": 67,
						"w": 199
					},
					{
						"n": 3,
						"h": 182,
						"w": 143
					},
					{
						"n": 4,
						"h": 206,
						"w": 174
					},
					{
						"n": 5,
						"h": 364,
						"w": 165
					},
					{
						"n": 6,
						"h": 234,
						"w": 252
					},
					{
						"n": 7,
						"h": 214,
						"w": 340
					},
					{
						"n": 8,
						"h": 407,
						"w": 398
					},
					{
						"n": 9,
						"h": 42,
						"w": 406
					},
					{
						"n": 10,
						"h": 163,
						"w": 421
					},
					{
						"n": 11,
						"h": 275,
						"w": 422
					}
				],
				"ball": {
					"n": 0,
					"h": 244,
					"w": 546,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 681,
			"minute": 33,
			"messages": [
				{
					"owner": 2,
					"mes": "Себастьян Пейша[24](Опава) низом пасует мяч назад..."
				},
				{
					"owner": 2,
					"mes": "Крыштоф Ласак[21](Опава) принимает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 11
					},
					{
						"n": 2,
						"h": 81,
						"w": 280
					},
					{
						"n": 3,
						"h": 175,
						"w": 267
					},
					{
						"n": 4,
						"h": 257,
						"w": 251
					},
					{
						"n": 5,
						"h": 330,
						"w": 253
					},
					{
						"n": 6,
						"h": 56,
						"w": 360
					},
					{
						"n": 7,
						"h": 147,
						"w": 328
					},
					{
						"n": 8,
						"h": 267,
						"w": 355
					},
					{
						"n": 9,
						"h": 386,
						"w": 275
					},
					{
						"n": 10,
						"h": 170,
						"w": 438
					},
					{
						"n": 11,
						"h": 321,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 208,
						"w": 31
					},
					{
						"n": 2,
						"h": 68,
						"w": 168
					},
					{
						"n": 3,
						"h": 173,
						"w": 122
					},
					{
						"n": 4,
						"h": 213,
						"w": 167
					},
					{
						"n": 5,
						"h": 374,
						"w": 120
					},
					{
						"n": 6,
						"h": 225,
						"w": 213
					},
					{
						"n": 7,
						"h": 230,
						"w": 320
					},
					{
						"n": 8,
						"h": 399,
						"w": 420
					},
					{
						"n": 9,
						"h": 49,
						"w": 420
					},
					{
						"n": 10,
						"h": 153,
						"w": 428
					},
					{
						"n": 11,
						"h": 308,
						"w": 388
					}
				],
				"ball": {
					"n": 0,
					"h": 242,
					"w": 689,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 48
		},
		{
			"num": 682,
			"minute": 33,
			"messages": [
				{
					"owner": 2,
					"mes": "Передача вперед..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 16
					},
					{
						"n": 2,
						"h": 105,
						"w": 258
					},
					{
						"n": 3,
						"h": 149,
						"w": 262
					},
					{
						"n": 4,
						"h": 256,
						"w": 250
					},
					{
						"n": 5,
						"h": 330,
						"w": 264
					},
					{
						"n": 6,
						"h": 47,
						"w": 360
					},
					{
						"n": 7,
						"h": 117,
						"w": 344
					},
					{
						"n": 8,
						"h": 264,
						"w": 337
					},
					{
						"n": 9,
						"h": 376,
						"w": 275
					},
					{
						"n": 10,
						"h": 139,
						"w": 450
					},
					{
						"n": 11,
						"h": 319,
						"w": 484
					}
				],
				"away": [
					{
						"n": 1,
						"h": 216,
						"w": 25
					},
					{
						"n": 2,
						"h": 74,
						"w": 159
					},
					{
						"n": 3,
						"h": 150,
						"w": 97
					},
					{
						"n": 4,
						"h": 239,
						"w": 145
					},
					{
						"n": 5,
						"h": 390,
						"w": 134
					},
					{
						"n": 6,
						"h": 235,
						"w": 198
					},
					{
						"n": 7,
						"h": 232,
						"w": 286
					},
					{
						"n": 8,
						"h": 391,
						"w": 420
					},
					{
						"n": 9,
						"h": 59,
						"w": 420
					},
					{
						"n": 10,
						"h": 154,
						"w": 422
					},
					{
						"n": 11,
						"h": 331,
						"w": 362
					}
				],
				"ball": {
					"n": 0,
					"h": 296,
					"w": 647,
					"z": 0,
					"r": 0,
					"p": 2,
					"x": 0
				}
			},
			"interval": 34
		},
		{
			"num": 683,
			"minute": 33,
			"messages": [
				{
					"owner": 2,
					"mes": "Нир Мансур[23](Опава) получил мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 11
					},
					{
						"n": 2,
						"h": 86,
						"w": 253
					},
					{
						"n": 3,
						"h": 130,
						"w": 255
					},
					{
						"n": 4,
						"h": 236,
						"w": 253
					},
					{
						"n": 5,
						"h": 310,
						"w": 260
					},
					{
						"n": 6,
						"h": 49,
						"w": 340
					},
					{
						"n": 7,
						"h": 113,
						"w": 354
					},
					{
						"n": 8,
						"h": 268,
						"w": 352
					},
					{
						"n": 9,
						"h": 393,
						"w": 285
					},
					{
						"n": 10,
						"h": 132,
						"w": 450
					},
					{
						"n": 11,
						"h": 318,
						"w": 504
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 12
					},
					{
						"n": 2,
						"h": 63,
						"w": 175
					},
					{
						"n": 3,
						"h": 138,
						"w": 85
					},
					{
						"n": 4,
						"h": 256,
						"w": 134
					},
					{
						"n": 5,
						"h": 390,
						"w": 131
					},
					{
						"n": 6,
						"h": 221,
						"w": 213
					},
					{
						"n": 7,
						"h": 236,
						"w": 305
					},
					{
						"n": 8,
						"h": 411,
						"w": 420
					},
					{
						"n": 9,
						"h": 39,
						"w": 420
					},
					{
						"n": 10,
						"h": 150,
						"w": 442
					},
					{
						"n": 11,
						"h": 344,
						"w": 347
					}
				],
				"ball": {
					"n": 0,
					"h": 312,
					"w": 635,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 20
		},
		{
			"num": 684,
			"minute": 33,
			"messages": [
				{
					"owner": 2,
					"mes": "Нир Мансур[23](Опава) пасует направо..."
				},
				{
					"owner": 2,
					"mes": "Себастьян Пейша[24](Опава) с мячом..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 17
					},
					{
						"n": 2,
						"h": 120,
						"w": 264
					},
					{
						"n": 3,
						"h": 179,
						"w": 259
					},
					{
						"n": 4,
						"h": 284,
						"w": 255
					},
					{
						"n": 5,
						"h": 330,
						"w": 263
					},
					{
						"n": 6,
						"h": 60,
						"w": 292
					},
					{
						"n": 7,
						"h": 160,
						"w": 338
					},
					{
						"n": 8,
						"h": 282,
						"w": 315
					},
					{
						"n": 9,
						"h": 394,
						"w": 285
					},
					{
						"n": 10,
						"h": 143,
						"w": 450
					},
					{
						"n": 11,
						"h": 305,
						"w": 457
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 10
					},
					{
						"n": 2,
						"h": 70,
						"w": 181
					},
					{
						"n": 3,
						"h": 145,
						"w": 92
					},
					{
						"n": 4,
						"h": 252,
						"w": 176
					},
					{
						"n": 5,
						"h": 390,
						"w": 130
					},
					{
						"n": 6,
						"h": 194,
						"w": 219
					},
					{
						"n": 7,
						"h": 225,
						"w": 282
					},
					{
						"n": 8,
						"h": 401,
						"w": 420
					},
					{
						"n": 9,
						"h": 34,
						"w": 420
					},
					{
						"n": 10,
						"h": 166,
						"w": 421
					},
					{
						"n": 11,
						"h": 374,
						"w": 308
					}
				],
				"ball": {
					"n": 0,
					"h": 198,
					"w": 544,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 49
		},
		{
			"num": 685,
			"minute": 33,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 10
					},
					{
						"n": 2,
						"h": 120,
						"w": 251
					},
					{
						"n": 3,
						"h": 219,
						"w": 253
					},
					{
						"n": 4,
						"h": 273,
						"w": 258
					},
					{
						"n": 5,
						"h": 330,
						"w": 258
					},
					{
						"n": 6,
						"h": 58,
						"w": 271
					},
					{
						"n": 7,
						"h": 179,
						"w": 333
					},
					{
						"n": 8,
						"h": 245,
						"w": 330
					},
					{
						"n": 9,
						"h": 394,
						"w": 285
					},
					{
						"n": 10,
						"h": 164,
						"w": 416
					},
					{
						"n": 11,
						"h": 314,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 12
					},
					{
						"n": 2,
						"h": 69,
						"w": 172
					},
					{
						"n": 3,
						"h": 168,
						"w": 120
					},
					{
						"n": 4,
						"h": 267,
						"w": 208
					},
					{
						"n": 5,
						"h": 389,
						"w": 129
					},
					{
						"n": 6,
						"h": 210,
						"w": 225
					},
					{
						"n": 7,
						"h": 220,
						"w": 322
					},
					{
						"n": 8,
						"h": 407,
						"w": 420
					},
					{
						"n": 9,
						"h": 33,
						"w": 420
					},
					{
						"n": 10,
						"h": 173,
						"w": 447
					},
					{
						"n": 11,
						"h": 394,
						"w": 274
					}
				],
				"ball": {
					"n": 0,
					"h": 183,
					"w": 512,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 686,
			"minute": 33,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 16
					},
					{
						"n": 2,
						"h": 80,
						"w": 253
					},
					{
						"n": 3,
						"h": 219,
						"w": 251
					},
					{
						"n": 4,
						"h": 279,
						"w": 242
					},
					{
						"n": 5,
						"h": 370,
						"w": 255
					},
					{
						"n": 6,
						"h": 46,
						"w": 309
					},
					{
						"n": 7,
						"h": 219,
						"w": 336
					},
					{
						"n": 8,
						"h": 258,
						"w": 334
					},
					{
						"n": 9,
						"h": 391,
						"w": 325
					},
					{
						"n": 10,
						"h": 158,
						"w": 419
					},
					{
						"n": 11,
						"h": 316,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 17
					},
					{
						"n": 2,
						"h": 58,
						"w": 195
					},
					{
						"n": 3,
						"h": 166,
						"w": 133
					},
					{
						"n": 4,
						"h": 266,
						"w": 243
					},
					{
						"n": 5,
						"h": 387,
						"w": 169
					},
					{
						"n": 6,
						"h": 214,
						"w": 265
					},
					{
						"n": 7,
						"h": 227,
						"w": 361
					},
					{
						"n": 8,
						"h": 408,
						"w": 454
					},
					{
						"n": 9,
						"h": 46,
						"w": 445
					},
					{
						"n": 10,
						"h": 153,
						"w": 447
					},
					{
						"n": 11,
						"h": 390,
						"w": 262
					}
				],
				"ball": {
					"n": 0,
					"h": 184,
					"w": 477,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 687,
			"minute": 33,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 10
					},
					{
						"n": 2,
						"h": 71,
						"w": 237
					},
					{
						"n": 3,
						"h": 212,
						"w": 218
					},
					{
						"n": 4,
						"h": 291,
						"w": 229
					},
					{
						"n": 5,
						"h": 356,
						"w": 246
					},
					{
						"n": 6,
						"h": 48,
						"w": 322
					},
					{
						"n": 7,
						"h": 217,
						"w": 296
					},
					{
						"n": 8,
						"h": 265,
						"w": 295
					},
					{
						"n": 9,
						"h": 395,
						"w": 322
					},
					{
						"n": 10,
						"h": 167,
						"w": 380
					},
					{
						"n": 11,
						"h": 318,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 36
					},
					{
						"n": 2,
						"h": 71,
						"w": 196
					},
					{
						"n": 3,
						"h": 170,
						"w": 149
					},
					{
						"n": 4,
						"h": 271,
						"w": 278
					},
					{
						"n": 5,
						"h": 390,
						"w": 159
					},
					{
						"n": 6,
						"h": 219,
						"w": 305
					},
					{
						"n": 7,
						"h": 235,
						"w": 400
					},
					{
						"n": 8,
						"h": 409,
						"w": 463
					},
					{
						"n": 9,
						"h": 85,
						"w": 454
					},
					{
						"n": 10,
						"h": 133,
						"w": 463
					},
					{
						"n": 11,
						"h": 404,
						"w": 299
					}
				],
				"ball": {
					"n": 0,
					"h": 179,
					"w": 442,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 688,
			"minute": 33,
			"messages": [
				{
					"owner": 2,
					"mes": "С.Пейша[24](Опава) стелящимся пасом отдает мяч О.Дюмону[26](Опава)..."
				},
				{
					"owner": 2,
					"mes": "Оливье Дюмон[26](Опава) получает передачу..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 19
					},
					{
						"n": 2,
						"h": 72,
						"w": 218
					},
					{
						"n": 3,
						"h": 206,
						"w": 190
					},
					{
						"n": 4,
						"h": 272,
						"w": 208
					},
					{
						"n": 5,
						"h": 365,
						"w": 231
					},
					{
						"n": 6,
						"h": 51,
						"w": 309
					},
					{
						"n": 7,
						"h": 198,
						"w": 293
					},
					{
						"n": 8,
						"h": 260,
						"w": 268
					},
					{
						"n": 9,
						"h": 399,
						"w": 310
					},
					{
						"n": 10,
						"h": 194,
						"w": 371
					},
					{
						"n": 11,
						"h": 285,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 56
					},
					{
						"n": 2,
						"h": 74,
						"w": 229
					},
					{
						"n": 3,
						"h": 178,
						"w": 181
					},
					{
						"n": 4,
						"h": 271,
						"w": 278,
						"m": 690
					},
					{
						"n": 5,
						"h": 374,
						"w": 188
					},
					{
						"n": 6,
						"h": 239,
						"w": 335
					},
					{
						"n": 7,
						"h": 245,
						"w": 405
					},
					{
						"n": 8,
						"h": 408,
						"w": 482
					},
					{
						"n": 9,
						"h": 55,
						"w": 469
					},
					{
						"n": 10,
						"h": 158,
						"w": 484
					},
					{
						"n": 11,
						"h": 396,
						"w": 332
					}
				],
				"ball": {
					"n": 0,
					"h": 211,
					"w": 385,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 33
		},
		{
			"num": 689,
			"minute": 33,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 19
					},
					{
						"n": 2,
						"h": 61,
						"w": 179
					},
					{
						"n": 3,
						"h": 211,
						"w": 184
					},
					{
						"n": 4,
						"h": 287,
						"w": 180
					},
					{
						"n": 5,
						"h": 370,
						"w": 191
					},
					{
						"n": 6,
						"h": 47,
						"w": 290
					},
					{
						"n": 7,
						"h": 210,
						"w": 255
					},
					{
						"n": 8,
						"h": 270,
						"w": 242
					},
					{
						"n": 9,
						"h": 392,
						"w": 291
					},
					{
						"n": 10,
						"h": 226,
						"w": 347
					},
					{
						"n": 11,
						"h": 277,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 223,
						"w": 74
					},
					{
						"n": 2,
						"h": 70,
						"w": 256
					},
					{
						"n": 3,
						"h": 173,
						"w": 221
					},
					{
						"n": 4,
						"h": 274,
						"w": 318
					},
					{
						"n": 5,
						"h": 384,
						"w": 212
					},
					{
						"n": 6,
						"h": 214,
						"w": 360
					},
					{
						"n": 7,
						"h": 238,
						"w": 444
					},
					{
						"n": 8,
						"h": 405,
						"w": 522
					},
					{
						"n": 9,
						"h": 50,
						"w": 509
					},
					{
						"n": 10,
						"h": 143,
						"w": 521
					},
					{
						"n": 11,
						"h": 409,
						"w": 369
					}
				],
				"ball": {
					"n": 0,
					"h": 236,
					"w": 360,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 690,
			"minute": 33,
			"messages": [
				{
					"owner": 2,
					"mes": "Игра накоротке с С.Пейшой[24](Опава)..."
				},
				{
					"owner": 2,
					"mes": "Теперь с мячом Себастьян Пейша[24](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 14
					},
					{
						"n": 2,
						"h": 66,
						"w": 174
					},
					{
						"n": 3,
						"h": 226,
						"w": 160
					},
					{
						"n": 4,
						"h": 269,
						"w": 158
					},
					{
						"n": 5,
						"h": 352,
						"w": 170
					},
					{
						"n": 6,
						"h": 51,
						"w": 262
					},
					{
						"n": 7,
						"h": 197,
						"w": 280
					},
					{
						"n": 8,
						"h": 242,
						"w": 240
					},
					{
						"n": 9,
						"h": 398,
						"w": 285
					},
					{
						"n": 10,
						"h": 204,
						"w": 330
					},
					{
						"n": 11,
						"h": 305,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 92
					},
					{
						"n": 2,
						"h": 58,
						"w": 278
					},
					{
						"n": 3,
						"h": 165,
						"w": 218
					},
					{
						"n": 4,
						"h": 298,
						"w": 341
					},
					{
						"n": 5,
						"h": 391,
						"w": 239
					},
					{
						"n": 6,
						"h": 214,
						"w": 360
					},
					{
						"n": 7,
						"h": 226,
						"w": 469
					},
					{
						"n": 8,
						"h": 414,
						"w": 526
					},
					{
						"n": 9,
						"h": 46,
						"w": 526
					},
					{
						"n": 10,
						"h": 170,
						"w": 526
					},
					{
						"n": 11,
						"h": 406,
						"w": 384
					}
				],
				"ball": {
					"n": 0,
					"h": 152,
					"w": 379,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 28
		},
		{
			"num": 691,
			"minute": 34,
			"possession": 42,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 12
					},
					{
						"n": 2,
						"h": 56,
						"w": 148,
						"f": 89,
						"c": 1
					},
					{
						"n": 3,
						"h": 236,
						"w": 146,
						"f": 92
					},
					{
						"n": 4,
						"h": 284,
						"w": 137
					},
					{
						"n": 5,
						"h": 332,
						"w": 136
					},
					{
						"n": 6,
						"h": 46,
						"w": 243
					},
					{
						"n": 7,
						"h": 190,
						"w": 240,
						"f": 89,
						"c": 1
					},
					{
						"n": 8,
						"h": 242,
						"w": 200,
						"f": 87
					},
					{
						"n": 9,
						"h": 389,
						"w": 246
					},
					{
						"n": 10,
						"h": 164,
						"w": 325
					},
					{
						"n": 11,
						"h": 279,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 111
					},
					{
						"n": 2,
						"h": 64,
						"w": 281
					},
					{
						"n": 3,
						"h": 171,
						"w": 247,
						"f": 90
					},
					{
						"n": 4,
						"h": 300,
						"w": 377
					},
					{
						"n": 5,
						"h": 384,
						"w": 262
					},
					{
						"n": 6,
						"h": 218,
						"w": 400,
						"f": 89,
						"c": 1
					},
					{
						"n": 7,
						"h": 218,
						"w": 509
					},
					{
						"n": 8,
						"h": 402,
						"w": 565
					},
					{
						"n": 9,
						"h": 81,
						"w": 545,
						"m": 650
					},
					{
						"n": 10,
						"h": 150,
						"w": 536
					},
					{
						"n": 11,
						"h": 390,
						"w": 390
					}
				],
				"ball": {
					"n": 0,
					"h": 150,
					"w": 343,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 692,
			"minute": 34,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 17
					},
					{
						"n": 2,
						"h": 56,
						"w": 135
					},
					{
						"n": 3,
						"h": 215,
						"w": 126
					},
					{
						"n": 4,
						"h": 266,
						"w": 106
					},
					{
						"n": 5,
						"h": 330,
						"w": 108
					},
					{
						"n": 6,
						"h": 56,
						"w": 256
					},
					{
						"n": 7,
						"h": 188,
						"w": 209
					},
					{
						"n": 8,
						"h": 266,
						"w": 194
					},
					{
						"n": 9,
						"h": 420,
						"w": 221
					},
					{
						"n": 10,
						"h": 131,
						"w": 303
					},
					{
						"n": 11,
						"h": 282,
						"w": 441
					}
				],
				"away": [
					{
						"n": 1,
						"h": 223,
						"w": 120
					},
					{
						"n": 2,
						"h": 74,
						"w": 306
					},
					{
						"n": 3,
						"h": 168,
						"w": 263
					},
					{
						"n": 4,
						"h": 325,
						"w": 401
					},
					{
						"n": 5,
						"h": 392,
						"w": 261
					},
					{
						"n": 6,
						"h": 223,
						"w": 439
					},
					{
						"n": 7,
						"h": 230,
						"w": 547
					},
					{
						"n": 8,
						"h": 408,
						"w": 576
					},
					{
						"n": 9,
						"h": 48,
						"w": 566
					},
					{
						"n": 10,
						"h": 170,
						"w": 569
					},
					{
						"n": 11,
						"h": 396,
						"w": 429
					}
				],
				"ball": {
					"n": 0,
					"h": 125,
					"w": 319,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 693,
			"minute": 34,
			"messages": [
				{
					"owner": 2,
					"mes": "Себастьян Пейша[24](Опава) переправляет мяч на ход О.Дюмону[26](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 19
					},
					{
						"n": 2,
						"h": 87,
						"w": 141
					},
					{
						"n": 3,
						"h": 229,
						"w": 124
					},
					{
						"n": 4,
						"h": 271,
						"w": 118
					},
					{
						"n": 5,
						"h": 365,
						"w": 120
					},
					{
						"n": 6,
						"h": 57,
						"w": 221
					},
					{
						"n": 7,
						"h": 209,
						"w": 233
					},
					{
						"n": 8,
						"h": 237,
						"w": 184
					},
					{
						"n": 9,
						"h": 387,
						"w": 221
					},
					{
						"n": 10,
						"h": 158,
						"w": 328
					},
					{
						"n": 11,
						"h": 268,
						"w": 446
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 123
					},
					{
						"n": 2,
						"h": 70,
						"w": 299
					},
					{
						"n": 3,
						"h": 182,
						"w": 258
					},
					{
						"n": 4,
						"h": 325,
						"w": 401
					},
					{
						"n": 5,
						"h": 392,
						"w": 268
					},
					{
						"n": 6,
						"h": 238,
						"w": 469
					},
					{
						"n": 7,
						"h": 208,
						"w": 517
					},
					{
						"n": 8,
						"h": 393,
						"w": 559
					},
					{
						"n": 9,
						"h": 50,
						"w": 579
					},
					{
						"n": 10,
						"h": 176,
						"w": 569
					},
					{
						"n": 11,
						"h": 398,
						"w": 392
					}
				],
				"ball": {
					"n": 0,
					"h": 212,
					"w": 251,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 37
		},
		{
			"num": 694,
			"minute": 34,
			"messages": [
				{
					"owner": 2,
					"mes": "Оливье Дюмон[26](Опава) играет направо на Ш.Товарека[31](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 15
					},
					{
						"n": 2,
						"h": 88,
						"w": 138
					},
					{
						"n": 3,
						"h": 207,
						"w": 111
					},
					{
						"n": 4,
						"h": 273,
						"w": 120
					},
					{
						"n": 5,
						"h": 333,
						"w": 120
					},
					{
						"n": 6,
						"h": 69,
						"w": 272
					},
					{
						"n": 7,
						"h": 188,
						"w": 185
					},
					{
						"n": 8,
						"h": 242,
						"w": 189
					},
					{
						"n": 9,
						"h": 395,
						"w": 215
					},
					{
						"n": 10,
						"h": 168,
						"w": 305
					},
					{
						"n": 11,
						"h": 284,
						"w": 443
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 124
					},
					{
						"n": 2,
						"h": 64,
						"w": 303
					},
					{
						"n": 3,
						"h": 166,
						"w": 266
					},
					{
						"n": 4,
						"h": 311,
						"w": 351
					},
					{
						"n": 5,
						"h": 374,
						"w": 280
					},
					{
						"n": 6,
						"h": 241,
						"w": 459
					},
					{
						"n": 7,
						"h": 260,
						"w": 525
					},
					{
						"n": 8,
						"h": 392,
						"w": 562
					},
					{
						"n": 9,
						"h": 101,
						"w": 588
					},
					{
						"n": 10,
						"h": 165,
						"w": 583
					},
					{
						"n": 11,
						"h": 383,
						"w": 409
					}
				],
				"ball": {
					"n": 0,
					"h": 67,
					"w": 311,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 52
		},
		{
			"num": 695,
			"minute": 34,
			"messages": [
				{
					"owner": 2,
					"mes": "Шимон Товарек[31](Опава) пасует на Д.Прохазку[28](Опава)..."
				},
				{
					"owner": 2,
					"mes": "Киэн Колман[06](Галвэй Юнайтед) читает комбинацию и перехватывает мяч!..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 218,
						"w": 12
					},
					{
						"n": 2,
						"h": 89,
						"w": 147
					},
					{
						"n": 3,
						"h": 197,
						"w": 109
					},
					{
						"n": 4,
						"h": 271,
						"w": 118
					},
					{
						"n": 5,
						"h": 328,
						"w": 111
					},
					{
						"n": 6,
						"h": 69,
						"w": 281
					},
					{
						"n": 7,
						"h": 187,
						"w": 195
					},
					{
						"n": 8,
						"h": 236,
						"w": 185
					},
					{
						"n": 9,
						"h": 395,
						"w": 215
					},
					{
						"n": 10,
						"h": 167,
						"w": 315
					},
					{
						"n": 11,
						"h": 275,
						"w": 438
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 121
					},
					{
						"n": 2,
						"h": 69,
						"w": 311
					},
					{
						"n": 3,
						"h": 176,
						"w": 266
					},
					{
						"n": 4,
						"h": 307,
						"w": 342
					},
					{
						"n": 5,
						"h": 382,
						"w": 274
					},
					{
						"n": 6,
						"h": 247,
						"w": 452
					},
					{
						"n": 7,
						"h": 259,
						"w": 515
					},
					{
						"n": 8,
						"h": 391,
						"w": 553
					},
					{
						"n": 9,
						"h": 110,
						"w": 592
					},
					{
						"n": 10,
						"h": 168,
						"w": 593
					},
					{
						"n": 11,
						"h": 383,
						"w": 409,
						"m": 610
					}
				],
				"ball": {
					"n": 0,
					"h": 69,
					"w": 281,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 10
		},
		{
			"num": 696,
			"minute": 34,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 19
					},
					{
						"n": 2,
						"h": 72,
						"w": 183
					},
					{
						"n": 3,
						"h": 174,
						"w": 142
					},
					{
						"n": 4,
						"h": 274,
						"w": 145
					},
					{
						"n": 5,
						"h": 347,
						"w": 146
					},
					{
						"n": 6,
						"h": 38,
						"w": 299,
						"m": 680
					},
					{
						"n": 7,
						"h": 174,
						"w": 233
					},
					{
						"n": 8,
						"h": 253,
						"w": 221
					},
					{
						"n": 9,
						"h": 397,
						"w": 245
					},
					{
						"n": 10,
						"h": 159,
						"w": 354
					},
					{
						"n": 11,
						"h": 304,
						"w": 444
					}
				],
				"away": [
					{
						"n": 1,
						"h": 242,
						"w": 80
					},
					{
						"n": 2,
						"h": 89,
						"w": 277
					},
					{
						"n": 3,
						"h": 199,
						"w": 233
					},
					{
						"n": 4,
						"h": 294,
						"w": 304
					},
					{
						"n": 5,
						"h": 356,
						"w": 244
					},
					{
						"n": 6,
						"h": 227,
						"w": 417
					},
					{
						"n": 7,
						"h": 257,
						"w": 475
					},
					{
						"n": 8,
						"h": 393,
						"w": 513
					},
					{
						"n": 9,
						"h": 97,
						"w": 555
					},
					{
						"n": 10,
						"h": 177,
						"w": 554
					},
					{
						"n": 11,
						"h": 412,
						"w": 401
					}
				],
				"ball": {
					"n": 0,
					"h": 38,
					"w": 299,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 697,
			"minute": 34,
			"messages": [
				{
					"owner": 1,
					"mes": "К.Колман[06](Галвэй Юнайтед) отдает передачу П.Клинтону[03](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 11
					},
					{
						"n": 2,
						"h": 70,
						"w": 218
					},
					{
						"n": 3,
						"h": 161,
						"w": 155
					},
					{
						"n": 4,
						"h": 285,
						"w": 180
					},
					{
						"n": 5,
						"h": 367,
						"w": 189
					},
					{
						"n": 6,
						"h": 41,
						"w": 308,
						"m": 690
					},
					{
						"n": 7,
						"h": 165,
						"w": 279
					},
					{
						"n": 8,
						"h": 283,
						"w": 257
					},
					{
						"n": 9,
						"h": 394,
						"w": 292
					},
					{
						"n": 10,
						"h": 159,
						"w": 401
					},
					{
						"n": 11,
						"h": 302,
						"w": 465
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 73
					},
					{
						"n": 2,
						"h": 104,
						"w": 232
					},
					{
						"n": 3,
						"h": 209,
						"w": 224
					},
					{
						"n": 4,
						"h": 285,
						"w": 258
					},
					{
						"n": 5,
						"h": 340,
						"w": 214
					},
					{
						"n": 6,
						"h": 249,
						"w": 375
					},
					{
						"n": 7,
						"h": 231,
						"w": 436
					},
					{
						"n": 8,
						"h": 399,
						"w": 467
					},
					{
						"n": 9,
						"h": 83,
						"w": 510
					},
					{
						"n": 10,
						"h": 165,
						"w": 509
					},
					{
						"n": 11,
						"h": 366,
						"w": 392
					}
				],
				"ball": {
					"n": 0,
					"h": 161,
					"w": 155,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 47
		},
		{
			"num": 698,
			"minute": 34,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 16
					},
					{
						"n": 2,
						"h": 68,
						"w": 241
					},
					{
						"n": 3,
						"h": 174,
						"w": 188
					},
					{
						"n": 4,
						"h": 267,
						"w": 194
					},
					{
						"n": 5,
						"h": 379,
						"w": 227
					},
					{
						"n": 6,
						"h": 45,
						"w": 348
					},
					{
						"n": 7,
						"h": 163,
						"w": 319
					},
					{
						"n": 8,
						"h": 308,
						"w": 289
					},
					{
						"n": 9,
						"h": 393,
						"w": 332
					},
					{
						"n": 10,
						"h": 150,
						"w": 440
					},
					{
						"n": 11,
						"h": 302,
						"w": 475
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 78
					},
					{
						"n": 2,
						"h": 110,
						"w": 221
					},
					{
						"n": 3,
						"h": 169,
						"w": 229
					},
					{
						"n": 4,
						"h": 275,
						"w": 219
					},
					{
						"n": 5,
						"h": 340,
						"w": 226
					},
					{
						"n": 6,
						"h": 269,
						"w": 341
					},
					{
						"n": 7,
						"h": 226,
						"w": 396
					},
					{
						"n": 8,
						"h": 401,
						"w": 427
					},
					{
						"n": 9,
						"h": 68,
						"w": 473
					},
					{
						"n": 10,
						"h": 157,
						"w": 469
					},
					{
						"n": 11,
						"h": 326,
						"w": 385
					}
				],
				"ball": {
					"n": 0,
					"h": 174,
					"w": 188,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 699,
			"minute": 34,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 13
					},
					{
						"n": 2,
						"h": 64,
						"w": 237
					},
					{
						"n": 3,
						"h": 175,
						"w": 223
					},
					{
						"n": 4,
						"h": 282,
						"w": 194
					},
					{
						"n": 5,
						"h": 381,
						"w": 235
					},
					{
						"n": 6,
						"h": 45,
						"w": 388
					},
					{
						"n": 7,
						"h": 158,
						"w": 359
					},
					{
						"n": 8,
						"h": 282,
						"w": 290
					},
					{
						"n": 9,
						"h": 397,
						"w": 372
					},
					{
						"n": 10,
						"h": 135,
						"w": 478
					},
					{
						"n": 11,
						"h": 282,
						"w": 486
					}
				],
				"away": [
					{
						"n": 1,
						"h": 223,
						"w": 78
					},
					{
						"n": 2,
						"h": 110,
						"w": 225
					},
					{
						"n": 3,
						"h": 181,
						"w": 212
					},
					{
						"n": 4,
						"h": 290,
						"w": 237
					},
					{
						"n": 5,
						"h": 340,
						"w": 221
					},
					{
						"n": 6,
						"h": 248,
						"w": 307
					},
					{
						"n": 7,
						"h": 224,
						"w": 356
					},
					{
						"n": 8,
						"h": 402,
						"w": 387
					},
					{
						"n": 9,
						"h": 53,
						"w": 435
					},
					{
						"n": 10,
						"h": 140,
						"w": 433
					},
					{
						"n": 11,
						"h": 293,
						"w": 407
					}
				],
				"ball": {
					"n": 0,
					"h": 175,
					"w": 223,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 700,
			"minute": 34,
			"messages": [
				{
					"owner": 1,
					"mes": "Патрик Клинтон[03](Галвэй Юнайтед) пасует на ход К.Нолану[08](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 11
					},
					{
						"n": 2,
						"h": 75,
						"w": 250
					},
					{
						"n": 3,
						"h": 175,
						"w": 223,
						"m": 640
					},
					{
						"n": 4,
						"h": 280,
						"w": 202
					},
					{
						"n": 5,
						"h": 389,
						"w": 234
					},
					{
						"n": 6,
						"h": 43,
						"w": 439
					},
					{
						"n": 7,
						"h": 161,
						"w": 383
					},
					{
						"n": 8,
						"h": 272,
						"w": 340
					},
					{
						"n": 9,
						"h": 399,
						"w": 423
					},
					{
						"n": 10,
						"h": 152,
						"w": 498
					},
					{
						"n": 11,
						"h": 273,
						"w": 508
					}
				],
				"away": [
					{
						"n": 1,
						"h": 229,
						"w": 74
					},
					{
						"n": 2,
						"h": 110,
						"w": 184
					},
					{
						"n": 3,
						"h": 190,
						"w": 176
					},
					{
						"n": 4,
						"h": 288,
						"w": 186
					},
					{
						"n": 5,
						"h": 340,
						"w": 187
					},
					{
						"n": 6,
						"h": 272,
						"w": 262
					},
					{
						"n": 7,
						"h": 193,
						"w": 358
					},
					{
						"n": 8,
						"h": 404,
						"w": 336
					},
					{
						"n": 9,
						"h": 44,
						"w": 385
					},
					{
						"n": 10,
						"h": 149,
						"w": 403
					},
					{
						"n": 11,
						"h": 279,
						"w": 358
					}
				],
				"ball": {
					"n": 0,
					"h": 272,
					"w": 340,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 51
		},
		{
			"num": 701,
			"minute": 34,
			"messages": [
				{
					"owner": 1,
					"mes": "Передача вперед..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 18
					},
					{
						"n": 2,
						"h": 74,
						"w": 285
					},
					{
						"n": 3,
						"h": 180,
						"w": 230
					},
					{
						"n": 4,
						"h": 271,
						"w": 239
					},
					{
						"n": 5,
						"h": 381,
						"w": 272
					},
					{
						"n": 6,
						"h": 42,
						"w": 478
					},
					{
						"n": 7,
						"h": 162,
						"w": 422
					},
					{
						"n": 8,
						"h": 272,
						"w": 352
					},
					{
						"n": 9,
						"h": 401,
						"w": 462
					},
					{
						"n": 10,
						"h": 160,
						"w": 529
					},
					{
						"n": 11,
						"h": 302,
						"w": 490
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 77
					},
					{
						"n": 2,
						"h": 112,
						"w": 192
					},
					{
						"n": 3,
						"h": 171,
						"w": 152
					},
					{
						"n": 4,
						"h": 291,
						"w": 147
					},
					{
						"n": 5,
						"h": 340,
						"w": 157
					},
					{
						"n": 6,
						"h": 284,
						"w": 225
					},
					{
						"n": 7,
						"h": 204,
						"w": 321
					},
					{
						"n": 8,
						"h": 417,
						"w": 299
					},
					{
						"n": 9,
						"h": 38,
						"w": 347
					},
					{
						"n": 10,
						"h": 167,
						"w": 369
					},
					{
						"n": 11,
						"h": 295,
						"w": 355
					}
				],
				"ball": {
					"n": 0,
					"h": 312,
					"w": 450,
					"z": 0,
					"r": 0,
					"p": 1,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 702,
			"minute": 34,
			"messages": [
				{
					"owner": 1,
					"mes": "Адам Гилберт[11](Галвэй Юнайтед) подрабатывает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 16
					},
					{
						"n": 2,
						"h": 75,
						"w": 302
					},
					{
						"n": 3,
						"h": 173,
						"w": 248
					},
					{
						"n": 4,
						"h": 276,
						"w": 258
					},
					{
						"n": 5,
						"h": 379,
						"w": 292
					},
					{
						"n": 6,
						"h": 42,
						"w": 498
					},
					{
						"n": 7,
						"h": 160,
						"w": 442
					},
					{
						"n": 8,
						"h": 279,
						"w": 371
					},
					{
						"n": 9,
						"h": 399,
						"w": 481
					},
					{
						"n": 10,
						"h": 153,
						"w": 547
					},
					{
						"n": 11,
						"h": 319,
						"w": 469
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 71
					},
					{
						"n": 2,
						"h": 123,
						"w": 209
					},
					{
						"n": 3,
						"h": 171,
						"w": 144
					},
					{
						"n": 4,
						"h": 299,
						"w": 149
					},
					{
						"n": 5,
						"h": 340,
						"w": 137
					},
					{
						"n": 6,
						"h": 288,
						"w": 205
					},
					{
						"n": 7,
						"h": 209,
						"w": 301
					},
					{
						"n": 8,
						"h": 415,
						"w": 279
					},
					{
						"n": 9,
						"h": 37,
						"w": 327
					},
					{
						"n": 10,
						"h": 169,
						"w": 349
					},
					{
						"n": 11,
						"h": 281,
						"w": 341
					}
				],
				"ball": {
					"n": 0,
					"h": 319,
					"w": 469,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 20
		},
		{
			"num": 703,
			"minute": 34,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 11
					},
					{
						"n": 2,
						"h": 68,
						"w": 328
					},
					{
						"n": 3,
						"h": 165,
						"w": 276
					},
					{
						"n": 4,
						"h": 267,
						"w": 271
					},
					{
						"n": 5,
						"h": 377,
						"w": 329
					},
					{
						"n": 6,
						"h": 45,
						"w": 538
					},
					{
						"n": 7,
						"h": 161,
						"w": 482
					},
					{
						"n": 8,
						"h": 276,
						"w": 410
					},
					{
						"n": 9,
						"h": 408,
						"w": 520
					},
					{
						"n": 10,
						"h": 173,
						"w": 575
					},
					{
						"n": 11,
						"h": 304,
						"w": 506
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 74
					},
					{
						"n": 2,
						"h": 152,
						"w": 194
					},
					{
						"n": 3,
						"h": 175,
						"w": 113
					},
					{
						"n": 4,
						"h": 280,
						"w": 114
					},
					{
						"n": 5,
						"h": 340,
						"w": 101
					},
					{
						"n": 6,
						"h": 278,
						"w": 166
					},
					{
						"n": 7,
						"h": 212,
						"w": 262
					},
					{
						"n": 8,
						"h": 405,
						"w": 240
					},
					{
						"n": 9,
						"h": 39,
						"w": 287
					},
					{
						"n": 10,
						"h": 169,
						"w": 309
					},
					{
						"n": 11,
						"h": 277,
						"w": 320
					}
				],
				"ball": {
					"n": 0,
					"h": 304,
					"w": 506,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 704,
			"minute": 34,
			"messages": [
				{
					"owner": 1,
					"mes": "Пас на левый фланг на К.Колмана[06](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 12
					},
					{
						"n": 2,
						"h": 75,
						"w": 351
					},
					{
						"n": 3,
						"h": 181,
						"w": 292
					},
					{
						"n": 4,
						"h": 265,
						"w": 305
					},
					{
						"n": 5,
						"h": 375,
						"w": 345
					},
					{
						"n": 6,
						"h": 66,
						"w": 524
					},
					{
						"n": 7,
						"h": 156,
						"w": 536
					},
					{
						"n": 8,
						"h": 244,
						"w": 396
					},
					{
						"n": 9,
						"h": 408,
						"w": 580
					},
					{
						"n": 10,
						"h": 173,
						"w": 603
					},
					{
						"n": 11,
						"h": 303,
						"w": 516
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 32
					},
					{
						"n": 2,
						"h": 107,
						"w": 155
					},
					{
						"n": 3,
						"h": 215,
						"w": 88
					},
					{
						"n": 4,
						"h": 276,
						"w": 82
					},
					{
						"n": 5,
						"h": 364,
						"w": 104
					},
					{
						"n": 6,
						"h": 301,
						"w": 170
					},
					{
						"n": 7,
						"h": 242,
						"w": 209
					},
					{
						"n": 8,
						"h": 382,
						"w": 194
					},
					{
						"n": 9,
						"h": 45,
						"w": 227
					},
					{
						"n": 10,
						"h": 206,
						"w": 304
					},
					{
						"n": 11,
						"h": 278,
						"w": 307
					}
				],
				"ball": {
					"n": 0,
					"h": 66,
					"w": 524,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 60
		},
		{
			"num": 705,
			"minute": 34,
			"messages": [
				{
					"owner": 1,
					"mes": "Киэн Колман[06](Галвэй Юнайтед) укрывает мяч корпусом..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 14
					},
					{
						"n": 2,
						"h": 77,
						"w": 361
					},
					{
						"n": 3,
						"h": 175,
						"w": 300
					},
					{
						"n": 4,
						"h": 274,
						"w": 309
					},
					{
						"n": 5,
						"h": 379,
						"w": 354
					},
					{
						"n": 6,
						"h": 76,
						"w": 524
					},
					{
						"n": 7,
						"h": 156,
						"w": 546
					},
					{
						"n": 8,
						"h": 245,
						"w": 406
					},
					{
						"n": 9,
						"h": 402,
						"w": 589
					},
					{
						"n": 10,
						"h": 172,
						"w": 605
					},
					{
						"n": 11,
						"h": 302,
						"w": 526
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 22
					},
					{
						"n": 2,
						"h": 98,
						"w": 150
					},
					{
						"n": 3,
						"h": 217,
						"w": 92
					},
					{
						"n": 4,
						"h": 282,
						"w": 87
					},
					{
						"n": 5,
						"h": 362,
						"w": 102
					},
					{
						"n": 6,
						"h": 297,
						"w": 170
					},
					{
						"n": 7,
						"h": 232,
						"w": 207
					},
					{
						"n": 8,
						"h": 383,
						"w": 191
					},
					{
						"n": 9,
						"h": 49,
						"w": 237
					},
					{
						"n": 10,
						"h": 205,
						"w": 294
					},
					{
						"n": 11,
						"h": 288,
						"w": 304
					}
				],
				"ball": {
					"n": 0,
					"h": 76,
					"w": 524,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 10
		},
		{
			"num": 706,
			"minute": 34,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 13
					},
					{
						"n": 2,
						"h": 61,
						"w": 353
					},
					{
						"n": 3,
						"h": 176,
						"w": 306
					},
					{
						"n": 4,
						"h": 280,
						"w": 308
					},
					{
						"n": 5,
						"h": 387,
						"w": 346
					},
					{
						"n": 6,
						"h": 115,
						"w": 515
					},
					{
						"n": 7,
						"h": 179,
						"w": 541
					},
					{
						"n": 8,
						"h": 258,
						"w": 444
					},
					{
						"n": 9,
						"h": 406,
						"w": 593
					},
					{
						"n": 10,
						"h": 169,
						"w": 599
					},
					{
						"n": 11,
						"h": 293,
						"w": 529
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 18
					},
					{
						"n": 2,
						"h": 66,
						"w": 125
					},
					{
						"n": 3,
						"h": 218,
						"w": 109
					},
					{
						"n": 4,
						"h": 285,
						"w": 93
					},
					{
						"n": 5,
						"h": 340,
						"w": 112
					},
					{
						"n": 6,
						"h": 273,
						"w": 168
					},
					{
						"n": 7,
						"h": 194,
						"w": 197
					},
					{
						"n": 8,
						"h": 337,
						"w": 190
					},
					{
						"n": 9,
						"h": 32,
						"w": 252
					},
					{
						"n": 10,
						"h": 192,
						"w": 256
					},
					{
						"n": 11,
						"h": 282,
						"w": 306
					}
				],
				"ball": {
					"n": 0,
					"h": 115,
					"w": 515,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 707,
			"minute": 34,
			"messages": [
				{
					"owner": 1,
					"mes": "Пас А.Хлинссону[07](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 11
					},
					{
						"n": 2,
						"h": 77,
						"w": 353
					},
					{
						"n": 3,
						"h": 180,
						"w": 302
					},
					{
						"n": 4,
						"h": 274,
						"w": 314
					},
					{
						"n": 5,
						"h": 372,
						"w": 355
					},
					{
						"n": 6,
						"h": 114,
						"w": 518
					},
					{
						"n": 7,
						"h": 148,
						"w": 526
					},
					{
						"n": 8,
						"h": 282,
						"w": 433
					},
					{
						"n": 9,
						"h": 389,
						"w": 579
					},
					{
						"n": 10,
						"h": 175,
						"w": 609
					},
					{
						"n": 11,
						"h": 302,
						"w": 546
					}
				],
				"away": [
					{
						"n": 1,
						"h": 231,
						"w": 14
					},
					{
						"n": 2,
						"h": 86,
						"w": 108
					},
					{
						"n": 3,
						"h": 194,
						"w": 100
					},
					{
						"n": 4,
						"h": 263,
						"w": 107
					},
					{
						"n": 5,
						"h": 340,
						"w": 102
					},
					{
						"n": 6,
						"h": 298,
						"w": 173
					},
					{
						"n": 7,
						"h": 173,
						"w": 181
					},
					{
						"n": 8,
						"h": 363,
						"w": 190
					},
					{
						"n": 9,
						"h": 26,
						"w": 242
					},
					{
						"n": 10,
						"h": 168,
						"w": 267
					},
					{
						"n": 11,
						"h": 290,
						"w": 290
					}
				],
				"ball": {
					"n": 0,
					"h": 148,
					"w": 526,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 26
		},
		{
			"num": 708,
			"minute": 34,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 11
					},
					{
						"n": 2,
						"h": 78,
						"w": 363
					},
					{
						"n": 3,
						"h": 166,
						"w": 317
					},
					{
						"n": 4,
						"h": 267,
						"w": 320
					},
					{
						"n": 5,
						"h": 378,
						"w": 367
					},
					{
						"n": 6,
						"h": 88,
						"w": 549
					},
					{
						"n": 7,
						"h": 188,
						"w": 527
					},
					{
						"n": 8,
						"h": 254,
						"w": 462
					},
					{
						"n": 9,
						"h": 401,
						"w": 588
					},
					{
						"n": 10,
						"h": 175,
						"w": 618
					},
					{
						"n": 11,
						"h": 322,
						"w": 544
					}
				],
				"away": [
					{
						"n": 1,
						"h": 228,
						"w": 15
					},
					{
						"n": 2,
						"h": 55,
						"w": 119
					},
					{
						"n": 3,
						"h": 217,
						"w": 91
					},
					{
						"n": 4,
						"h": 273,
						"w": 73
					},
					{
						"n": 5,
						"h": 340,
						"w": 82
					},
					{
						"n": 6,
						"h": 262,
						"w": 172
					},
					{
						"n": 7,
						"h": 139,
						"w": 161
					},
					{
						"n": 8,
						"h": 362,
						"w": 150
					},
					{
						"n": 9,
						"h": 32,
						"w": 233
					},
					{
						"n": 10,
						"h": 157,
						"w": 305
					},
					{
						"n": 11,
						"h": 280,
						"w": 293
					}
				],
				"ball": {
					"n": 0,
					"h": 188,
					"w": 527,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 709,
			"minute": 34,
			"messages": [
				{
					"owner": 1,
					"mes": "Пас направо А.Гилберту[11](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 10
					},
					{
						"n": 2,
						"h": 75,
						"w": 365
					},
					{
						"n": 3,
						"h": 172,
						"w": 322
					},
					{
						"n": 4,
						"h": 268,
						"w": 320
					},
					{
						"n": 5,
						"h": 382,
						"w": 374
					},
					{
						"n": 6,
						"h": 57,
						"w": 581
					},
					{
						"n": 7,
						"h": 183,
						"w": 535
					},
					{
						"n": 8,
						"h": 272,
						"w": 440
					},
					{
						"n": 9,
						"h": 403,
						"w": 598
					},
					{
						"n": 10,
						"h": 157,
						"w": 628
					},
					{
						"n": 11,
						"h": 282,
						"w": 523
					}
				],
				"away": [
					{
						"n": 1,
						"h": 221,
						"w": 14
					},
					{
						"n": 2,
						"h": 72,
						"w": 102
					},
					{
						"n": 3,
						"h": 249,
						"w": 82
					},
					{
						"n": 4,
						"h": 290,
						"w": 60
					},
					{
						"n": 5,
						"h": 340,
						"w": 77
					},
					{
						"n": 6,
						"h": 258,
						"w": 144
					},
					{
						"n": 7,
						"h": 169,
						"w": 194
					},
					{
						"n": 8,
						"h": 387,
						"w": 112
					},
					{
						"n": 9,
						"h": 24,
						"w": 223
					},
					{
						"n": 10,
						"h": 176,
						"w": 264
					},
					{
						"n": 11,
						"h": 293,
						"w": 309
					}
				],
				"ball": {
					"n": 0,
					"h": 282,
					"w": 523,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 45
		},
		{
			"num": 710,
			"minute": 34,
			"messages": [
				{
					"owner": 1,
					"mes": "Адам Гилберт[11](Галвэй Юнайтед) пробрасывает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 17
					},
					{
						"n": 2,
						"h": 69,
						"w": 369
					},
					{
						"n": 3,
						"h": 171,
						"w": 329
					},
					{
						"n": 4,
						"h": 270,
						"w": 321
					},
					{
						"n": 5,
						"h": 386,
						"w": 370
					},
					{
						"n": 6,
						"h": 59,
						"w": 591
					},
					{
						"n": 7,
						"h": 180,
						"w": 545
					},
					{
						"n": 8,
						"h": 275,
						"w": 450
					},
					{
						"n": 9,
						"h": 401,
						"w": 608
					},
					{
						"n": 10,
						"h": 160,
						"w": 631
					},
					{
						"n": 11,
						"h": 272,
						"w": 525
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 15
					},
					{
						"n": 2,
						"h": 62,
						"w": 99
					},
					{
						"n": 3,
						"h": 250,
						"w": 72
					},
					{
						"n": 4,
						"h": 288,
						"w": 56
					},
					{
						"n": 5,
						"h": 347,
						"w": 84
					},
					{
						"n": 6,
						"h": 263,
						"w": 135
					},
					{
						"n": 7,
						"h": 169,
						"w": 191
					},
					{
						"n": 8,
						"h": 391,
						"w": 121
					},
					{
						"n": 9,
						"h": 33,
						"w": 219
					},
					{
						"n": 10,
						"h": 175,
						"w": 254
					},
					{
						"n": 11,
						"h": 285,
						"w": 303
					}
				],
				"ball": {
					"n": 0,
					"h": 272,
					"w": 525,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 10
		},
		{
			"num": 711,
			"minute": 34,
			"messages": [
				{
					"owner": 1,
					"mes": "Адам Гилберт[11](Галвэй Юнайтед) уходит правее..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 11
					},
					{
						"n": 2,
						"h": 73,
						"w": 376
					},
					{
						"n": 3,
						"h": 166,
						"w": 314
					},
					{
						"n": 4,
						"h": 275,
						"w": 313
					},
					{
						"n": 5,
						"h": 375,
						"w": 368
					},
					{
						"n": 6,
						"h": 45,
						"w": 608
					},
					{
						"n": 7,
						"h": 175,
						"w": 566
					},
					{
						"n": 8,
						"h": 275,
						"w": 449
					},
					{
						"n": 9,
						"h": 404,
						"w": 611
					},
					{
						"n": 10,
						"h": 179,
						"w": 630
					},
					{
						"n": 11,
						"h": 282,
						"w": 545
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 14
					},
					{
						"n": 2,
						"h": 52,
						"w": 98
					},
					{
						"n": 3,
						"h": 228,
						"w": 70
					},
					{
						"n": 4,
						"h": 273,
						"w": 72
					},
					{
						"n": 5,
						"h": 340,
						"w": 66
					},
					{
						"n": 6,
						"h": 270,
						"w": 138
					},
					{
						"n": 7,
						"h": 169,
						"w": 170
					},
					{
						"n": 8,
						"h": 395,
						"w": 143
					},
					{
						"n": 9,
						"h": 49,
						"w": 220
					},
					{
						"n": 10,
						"h": 175,
						"w": 251
					},
					{
						"n": 11,
						"h": 275,
						"w": 308
					}
				],
				"ball": {
					"n": 0,
					"h": 282,
					"w": 545,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 22
		},
		{
			"num": 712,
			"minute": 34,
			"messages": [
				{
					"owner": 1,
					"mes": "Удар с 30 метров..."
				},
				{
					"owner": 1,
					"mes": "Крыштоф Ласак[21](Опава) падает и ловит мяч."
				}
			],
			"U": {
				"team": 1,
				"player": 11,
				"xg": "0.01"
			},
			"V": {
				"team": 1,
				"player": 11
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 11
					},
					{
						"n": 2,
						"h": 78,
						"w": 369
					},
					{
						"n": 3,
						"h": 170,
						"w": 312
					},
					{
						"n": 4,
						"h": 274,
						"w": 322
					},
					{
						"n": 5,
						"h": 382,
						"w": 374
					},
					{
						"n": 6,
						"h": 52,
						"w": 614
					},
					{
						"n": 7,
						"h": 161,
						"w": 570
					},
					{
						"n": 8,
						"h": 294,
						"w": 434
					},
					{
						"n": 9,
						"h": 416,
						"w": 610
					},
					{
						"n": 10,
						"h": 162,
						"w": 629
					},
					{
						"n": 11,
						"h": 282,
						"w": 545
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 14,
						"m": 600
					},
					{
						"n": 2,
						"h": 79,
						"w": 83
					},
					{
						"n": 3,
						"h": 194,
						"w": 65
					},
					{
						"n": 4,
						"h": 276,
						"w": 62
					},
					{
						"n": 5,
						"h": 340,
						"w": 63
					},
					{
						"n": 6,
						"h": 287,
						"w": 137
					},
					{
						"n": 7,
						"h": 168,
						"w": 170
					},
					{
						"n": 8,
						"h": 387,
						"w": 110
					},
					{
						"n": 9,
						"h": 28,
						"w": 221
					},
					{
						"n": 10,
						"h": 156,
						"w": 266
					},
					{
						"n": 11,
						"h": 282,
						"w": 298
					}
				],
				"ball": {
					"n": 0,
					"h": 230,
					"w": 706,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 5
				}
			},
			"interval": 34
		},
		{
			"num": 713,
			"minute": 34,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 17
					},
					{
						"n": 2,
						"h": 73,
						"w": 371
					},
					{
						"n": 3,
						"h": 183,
						"w": 325
					},
					{
						"n": 4,
						"h": 277,
						"w": 329
					},
					{
						"n": 5,
						"h": 375,
						"w": 371
					},
					{
						"n": 6,
						"h": 38,
						"w": 629
					},
					{
						"n": 7,
						"h": 166,
						"w": 577
					},
					{
						"n": 8,
						"h": 293,
						"w": 454
					},
					{
						"n": 9,
						"h": 396,
						"w": 610
					},
					{
						"n": 10,
						"h": 174,
						"w": 634
					},
					{
						"n": 11,
						"h": 282,
						"w": 545
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 14
					},
					{
						"n": 2,
						"h": 76,
						"w": 72
					},
					{
						"n": 3,
						"h": 185,
						"w": 66
					},
					{
						"n": 4,
						"h": 266,
						"w": 70
					},
					{
						"n": 5,
						"h": 340,
						"w": 60
					},
					{
						"n": 6,
						"h": 276,
						"w": 135
					},
					{
						"n": 7,
						"h": 164,
						"w": 156
					},
					{
						"n": 8,
						"h": 393,
						"w": 129
					},
					{
						"n": 9,
						"h": 27,
						"w": 216
					},
					{
						"n": 10,
						"h": 157,
						"w": 246
					},
					{
						"n": 11,
						"h": 294,
						"w": 299
					}
				],
				"ball": {
					"n": 0,
					"h": 230,
					"w": 706,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 20
		},
		{
			"num": 714,
			"minute": 35,
			"possession": 43,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 40
					},
					{
						"n": 2,
						"h": 71,
						"w": 178
					},
					{
						"n": 3,
						"h": 180,
						"w": 150
					},
					{
						"n": 4,
						"h": 281,
						"w": 150,
						"f": 91
					},
					{
						"n": 5,
						"h": 383,
						"w": 175,
						"f": 89,
						"c": 1
					},
					{
						"n": 6,
						"h": 83,
						"w": 272
					},
					{
						"n": 7,
						"h": 162,
						"w": 250
					},
					{
						"n": 8,
						"h": 281,
						"w": 250
					},
					{
						"n": 9,
						"h": 374,
						"w": 277,
						"f": 87
					},
					{
						"n": 10,
						"h": 178,
						"w": 350
					},
					{
						"n": 11,
						"h": 283,
						"w": 350,
						"f": 88
					}
				],
				"away": [
					{
						"n": 1,
						"h": 226,
						"w": 18,
						"f": 89,
						"m": 610,
						"c": 1
					},
					{
						"n": 2,
						"h": 67,
						"w": 175
					},
					{
						"n": 3,
						"h": 167,
						"w": 175
					},
					{
						"n": 4,
						"h": 280,
						"w": 175
					},
					{
						"n": 5,
						"h": 394,
						"w": 175,
						"f": 88
					},
					{
						"n": 6,
						"h": 220,
						"w": 283
					},
					{
						"n": 7,
						"h": 218,
						"w": 392
					},
					{
						"n": 8,
						"h": 397,
						"w": 372
					},
					{
						"n": 9,
						"h": 64,
						"w": 422,
						"f": 88
					},
					{
						"n": 10,
						"h": 153,
						"w": 500
					},
					{
						"n": 11,
						"h": 281,
						"w": 500
					}
				],
				"ball": {
					"n": 0,
					"h": 224,
					"w": 702,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 100
		},
		{
			"num": 715,
			"minute": 35,
			"messages": [
				{
					"owner": 2,
					"mes": "Крыштоф Ласак[21](Опава) выбивает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 10
					},
					{
						"n": 2,
						"h": 120,
						"w": 155
					},
					{
						"n": 3,
						"h": 208,
						"w": 153
					},
					{
						"n": 4,
						"h": 253,
						"w": 159
					},
					{
						"n": 5,
						"h": 370,
						"w": 163
					},
					{
						"n": 6,
						"h": 58,
						"w": 239
					},
					{
						"n": 7,
						"h": 233,
						"w": 225
					},
					{
						"n": 8,
						"h": 288,
						"w": 238
					},
					{
						"n": 9,
						"h": 376,
						"w": 352
					},
					{
						"n": 10,
						"h": 178,
						"w": 400
					},
					{
						"n": 11,
						"h": 298,
						"w": 423
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 38
					},
					{
						"n": 2,
						"h": 58,
						"w": 223
					},
					{
						"n": 3,
						"h": 168,
						"w": 170
					},
					{
						"n": 4,
						"h": 272,
						"w": 175
					},
					{
						"n": 5,
						"h": 378,
						"w": 190
					},
					{
						"n": 6,
						"h": 191,
						"w": 264
					},
					{
						"n": 7,
						"h": 143,
						"w": 392
					},
					{
						"n": 8,
						"h": 392,
						"w": 446
					},
					{
						"n": 9,
						"h": 73,
						"w": 362
					},
					{
						"n": 10,
						"h": 153,
						"w": 425
					},
					{
						"n": 11,
						"h": 224,
						"w": 520
					}
				],
				"ball": {
					"n": 0,
					"h": 377,
					"w": 358,
					"z": 1,
					"r": 0,
					"p": 4,
					"x": 0
				}
			},
			"interval": 75
		},
		{
			"num": 716,
			"minute": 35,
			"messages": [
				{
					"owner": 1,
					"mes": "Элвис Бвомоно[09](Галвэй Юнайтед) выигрывает верховую дуэль у М.Юрасека[29](Опава) и скидывает мяч..."
				},
				{
					"owner": 1,
					"mes": "Адам Гилберт[11](Галвэй Юнайтед) останавливает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 15
					},
					{
						"n": 2,
						"h": 120,
						"w": 122
					},
					{
						"n": 3,
						"h": 221,
						"w": 123
					},
					{
						"n": 4,
						"h": 269,
						"w": 130
					},
					{
						"n": 5,
						"h": 366,
						"w": 130
					},
					{
						"n": 6,
						"h": 56,
						"w": 207
					},
					{
						"n": 7,
						"h": 228,
						"w": 192
					},
					{
						"n": 8,
						"h": 295,
						"w": 208
					},
					{
						"n": 9,
						"h": 374,
						"w": 350
					},
					{
						"n": 10,
						"h": 166,
						"w": 400
					},
					{
						"n": 11,
						"h": 299,
						"w": 421
					}
				],
				"away": [
					{
						"n": 1,
						"h": 229,
						"w": 59
					},
					{
						"n": 2,
						"h": 65,
						"w": 223
					},
					{
						"n": 3,
						"h": 178,
						"w": 169
					},
					{
						"n": 4,
						"h": 284,
						"w": 169
					},
					{
						"n": 5,
						"h": 389,
						"w": 168
					},
					{
						"n": 6,
						"h": 193,
						"w": 275
					},
					{
						"n": 7,
						"h": 175,
						"w": 386
					},
					{
						"n": 8,
						"h": 401,
						"w": 478
					},
					{
						"n": 9,
						"h": 73,
						"w": 362,
						"m": 640
					},
					{
						"n": 10,
						"h": 154,
						"w": 458
					},
					{
						"n": 11,
						"h": 225,
						"w": 506
					}
				],
				"ball": {
					"n": 0,
					"h": 299,
					"w": 421,
					"z": 1,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 33
		},
		{
			"num": 717,
			"minute": 35,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 11
					},
					{
						"n": 2,
						"h": 108,
						"w": 160
					},
					{
						"n": 3,
						"h": 199,
						"w": 156
					},
					{
						"n": 4,
						"h": 267,
						"w": 170
					},
					{
						"n": 5,
						"h": 371,
						"w": 170
					},
					{
						"n": 6,
						"h": 55,
						"w": 247
					},
					{
						"n": 7,
						"h": 214,
						"w": 230
					},
					{
						"n": 8,
						"h": 295,
						"w": 247
					},
					{
						"n": 9,
						"h": 390,
						"w": 386
					},
					{
						"n": 10,
						"h": 159,
						"w": 439
					},
					{
						"n": 11,
						"h": 324,
						"w": 446
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 75
					},
					{
						"n": 2,
						"h": 69,
						"w": 183
					},
					{
						"n": 3,
						"h": 162,
						"w": 132
					},
					{
						"n": 4,
						"h": 266,
						"w": 133
					},
					{
						"n": 5,
						"h": 357,
						"w": 144
					},
					{
						"n": 6,
						"h": 155,
						"w": 262
					},
					{
						"n": 7,
						"h": 185,
						"w": 347
					},
					{
						"n": 8,
						"h": 404,
						"w": 438
					},
					{
						"n": 9,
						"h": 54,
						"w": 327
					},
					{
						"n": 10,
						"h": 159,
						"w": 418
					},
					{
						"n": 11,
						"h": 231,
						"w": 466
					}
				],
				"ball": {
					"n": 0,
					"h": 324,
					"w": 446,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 718,
			"minute": 35,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 19
					},
					{
						"n": 2,
						"h": 100,
						"w": 193
					},
					{
						"n": 3,
						"h": 192,
						"w": 190
					},
					{
						"n": 4,
						"h": 267,
						"w": 204
					},
					{
						"n": 5,
						"h": 371,
						"w": 204
					},
					{
						"n": 6,
						"h": 56,
						"w": 281
					},
					{
						"n": 7,
						"h": 206,
						"w": 262
					},
					{
						"n": 8,
						"h": 296,
						"w": 281
					},
					{
						"n": 9,
						"h": 401,
						"w": 419
					},
					{
						"n": 10,
						"h": 157,
						"w": 473
					},
					{
						"n": 11,
						"h": 344,
						"w": 481
					}
				],
				"away": [
					{
						"n": 1,
						"h": 205,
						"w": 74
					},
					{
						"n": 2,
						"h": 79,
						"w": 146
					},
					{
						"n": 3,
						"h": 192,
						"w": 115
					},
					{
						"n": 4,
						"h": 290,
						"w": 110
					},
					{
						"n": 5,
						"h": 343,
						"w": 113
					},
					{
						"n": 6,
						"h": 125,
						"w": 235
					},
					{
						"n": 7,
						"h": 188,
						"w": 313
					},
					{
						"n": 8,
						"h": 405,
						"w": 404
					},
					{
						"n": 9,
						"h": 50,
						"w": 293
					},
					{
						"n": 10,
						"h": 159,
						"w": 384
					},
					{
						"n": 11,
						"h": 244,
						"w": 438
					}
				],
				"ball": {
					"n": 0,
					"h": 344,
					"w": 481,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 34
		},
		{
			"num": 719,
			"minute": 35,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 11
					},
					{
						"n": 2,
						"h": 89,
						"w": 232
					},
					{
						"n": 3,
						"h": 185,
						"w": 229
					},
					{
						"n": 4,
						"h": 270,
						"w": 244
					},
					{
						"n": 5,
						"h": 377,
						"w": 244
					},
					{
						"n": 6,
						"h": 55,
						"w": 321
					},
					{
						"n": 7,
						"h": 196,
						"w": 301
					},
					{
						"n": 8,
						"h": 296,
						"w": 321
					},
					{
						"n": 9,
						"h": 403,
						"w": 459
					},
					{
						"n": 10,
						"h": 161,
						"w": 513
					},
					{
						"n": 11,
						"h": 377,
						"w": 495
					}
				],
				"away": [
					{
						"n": 1,
						"h": 205,
						"w": 73
					},
					{
						"n": 2,
						"h": 80,
						"w": 186
					},
					{
						"n": 3,
						"h": 215,
						"w": 97
					},
					{
						"n": 4,
						"h": 291,
						"w": 101
					},
					{
						"n": 5,
						"h": 340,
						"w": 107
					},
					{
						"n": 6,
						"h": 91,
						"w": 214
					},
					{
						"n": 7,
						"h": 192,
						"w": 273
					},
					{
						"n": 8,
						"h": 405,
						"w": 364
					},
					{
						"n": 9,
						"h": 55,
						"w": 257
					},
					{
						"n": 10,
						"h": 161,
						"w": 344
					},
					{
						"n": 11,
						"h": 254,
						"w": 399
					}
				],
				"ball": {
					"n": 0,
					"h": 377,
					"w": 495,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 720,
			"minute": 35,
			"messages": [
				{
					"owner": 1,
					"mes": "Пас Д.Квигли[10](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 11
					},
					{
						"n": 2,
						"h": 82,
						"w": 285
					},
					{
						"n": 3,
						"h": 172,
						"w": 281
					},
					{
						"n": 4,
						"h": 285,
						"w": 289
					},
					{
						"n": 5,
						"h": 375,
						"w": 298
					},
					{
						"n": 6,
						"h": 55,
						"w": 375
					},
					{
						"n": 7,
						"h": 186,
						"w": 354
					},
					{
						"n": 8,
						"h": 292,
						"w": 375
					},
					{
						"n": 9,
						"h": 426,
						"w": 496
					},
					{
						"n": 10,
						"h": 199,
						"w": 551
					},
					{
						"n": 11,
						"h": 370,
						"w": 502,
						"m": 810
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 23
					},
					{
						"n": 2,
						"h": 87,
						"w": 132
					},
					{
						"n": 3,
						"h": 245,
						"w": 142
					},
					{
						"n": 4,
						"h": 238,
						"w": 111
					},
					{
						"n": 5,
						"h": 340,
						"w": 106
					},
					{
						"n": 6,
						"h": 143,
						"w": 201
					},
					{
						"n": 7,
						"h": 220,
						"w": 229
					},
					{
						"n": 8,
						"h": 396,
						"w": 311
					},
					{
						"n": 9,
						"h": 20,
						"w": 257
					},
					{
						"n": 10,
						"h": 158,
						"w": 325
					},
					{
						"n": 11,
						"h": 264,
						"w": 346
					}
				],
				"ball": {
					"n": 0,
					"h": 199,
					"w": 551,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 54
		},
		{
			"num": 721,
			"minute": 35,
			"messages": [
				{
					"owner": 1,
					"mes": "Джо Квигли[10](Галвэй Юнайтед) уходит правее..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 16
					},
					{
						"n": 2,
						"h": 73,
						"w": 312
					},
					{
						"n": 3,
						"h": 182,
						"w": 300
					},
					{
						"n": 4,
						"h": 279,
						"w": 308
					},
					{
						"n": 5,
						"h": 377,
						"w": 326
					},
					{
						"n": 6,
						"h": 53,
						"w": 403
					},
					{
						"n": 7,
						"h": 180,
						"w": 382
					},
					{
						"n": 8,
						"h": 286,
						"w": 403
					},
					{
						"n": 9,
						"h": 414,
						"w": 502
					},
					{
						"n": 10,
						"h": 219,
						"w": 571
					},
					{
						"n": 11,
						"h": 353,
						"w": 524
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 30
					},
					{
						"n": 2,
						"h": 105,
						"w": 111
					},
					{
						"n": 3,
						"h": 245,
						"w": 144
					},
					{
						"n": 4,
						"h": 222,
						"w": 114
					},
					{
						"n": 5,
						"h": 340,
						"w": 100
					},
					{
						"n": 6,
						"h": 169,
						"w": 190
					},
					{
						"n": 7,
						"h": 234,
						"w": 213
					},
					{
						"n": 8,
						"h": 397,
						"w": 283
					},
					{
						"n": 9,
						"h": 18,
						"w": 257
					},
					{
						"n": 10,
						"h": 164,
						"w": 297
					},
					{
						"n": 11,
						"h": 270,
						"w": 318
					}
				],
				"ball": {
					"n": 0,
					"h": 219,
					"w": 571,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 28
		},
		{
			"num": 722,
			"minute": 35,
			"messages": [
				{
					"owner": 1,
					"mes": "Джо Квигли[10](Галвэй Юнайтед) бьет издали..."
				},
				{
					"owner": 1,
					"mes": "Мяч летит выше ворот."
				}
			],
			"U": {
				"team": 1,
				"player": 10,
				"xg": "0.05"
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 11
					},
					{
						"n": 2,
						"h": 64,
						"w": 346
					},
					{
						"n": 3,
						"h": 166,
						"w": 307
					},
					{
						"n": 4,
						"h": 283,
						"w": 299
					},
					{
						"n": 5,
						"h": 383,
						"w": 356
					},
					{
						"n": 6,
						"h": 54,
						"w": 439
					},
					{
						"n": 7,
						"h": 175,
						"w": 417
					},
					{
						"n": 8,
						"h": 288,
						"w": 438
					},
					{
						"n": 9,
						"h": 407,
						"w": 537
					},
					{
						"n": 10,
						"h": 219,
						"w": 571
					},
					{
						"n": 11,
						"h": 333,
						"w": 554
					}
				],
				"away": [
					{
						"n": 1,
						"h": 245,
						"w": 20
					},
					{
						"n": 2,
						"h": 88,
						"w": 113
					},
					{
						"n": 3,
						"h": 238,
						"w": 139
					},
					{
						"n": 4,
						"h": 218,
						"w": 121
					},
					{
						"n": 5,
						"h": 340,
						"w": 116
					},
					{
						"n": 6,
						"h": 142,
						"w": 166
					},
					{
						"n": 7,
						"h": 219,
						"w": 214
					},
					{
						"n": 8,
						"h": 396,
						"w": 247
					},
					{
						"n": 9,
						"h": 34,
						"w": 257
					},
					{
						"n": 10,
						"h": 162,
						"w": 262
					},
					{
						"n": 11,
						"h": 275,
						"w": 283
					}
				],
				"ball": {
					"n": 0,
					"h": 201,
					"w": 752,
					"z": 1,
					"r": 0,
					"p": 0,
					"x": 4
				}
			},
			"interval": 36
		},
		{
			"num": 723,
			"minute": 36,
			"possession": 44,
			"messages": [
				{
					"owner": 2,
					"mes": "Удар от ворот..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 40
					},
					{
						"n": 2,
						"h": 84,
						"w": 177
					},
					{
						"n": 3,
						"h": 161,
						"w": 150
					},
					{
						"n": 4,
						"h": 273,
						"w": 150
					},
					{
						"n": 5,
						"h": 385,
						"w": 170
					},
					{
						"n": 6,
						"h": 82,
						"w": 270,
						"f": 88
					},
					{
						"n": 7,
						"h": 165,
						"w": 250
					},
					{
						"n": 8,
						"h": 280,
						"w": 250,
						"f": 86
					},
					{
						"n": 9,
						"h": 372,
						"w": 270
					},
					{
						"n": 10,
						"h": 165,
						"w": 350,
						"f": 87
					},
					{
						"n": 11,
						"h": 271,
						"w": 350
					}
				],
				"away": [
					{
						"n": 1,
						"h": 260,
						"w": 14
					},
					{
						"n": 2,
						"h": 58,
						"w": 175,
						"f": 86
					},
					{
						"n": 3,
						"h": 166,
						"w": 175,
						"m": 600
					},
					{
						"n": 4,
						"h": 296,
						"w": 175,
						"f": 88
					},
					{
						"n": 5,
						"h": 395,
						"w": 175
					},
					{
						"n": 6,
						"h": 231,
						"w": 283
					},
					{
						"n": 7,
						"h": 229,
						"w": 392,
						"f": 90
					},
					{
						"n": 8,
						"h": 385,
						"w": 372,
						"f": 88
					},
					{
						"n": 9,
						"h": 65,
						"w": 422
					},
					{
						"n": 10,
						"h": 164,
						"w": 500,
						"f": 87
					},
					{
						"n": 11,
						"h": 279,
						"w": 500,
						"f": 87
					}
				],
				"ball": {
					"n": 0,
					"h": 190,
					"w": 686,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 150
		},
		{
			"num": 724,
			"minute": 36,
			"messages": [],
			"T": {
				"team": 2
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 40
					},
					{
						"n": 2,
						"h": 87,
						"w": 174
					},
					{
						"n": 3,
						"h": 168,
						"w": 149
					},
					{
						"n": 4,
						"h": 272,
						"w": 148
					},
					{
						"n": 5,
						"h": 378,
						"w": 166
					},
					{
						"n": 6,
						"h": 77,
						"w": 273
					},
					{
						"n": 7,
						"h": 167,
						"w": 246
					},
					{
						"n": 8,
						"h": 287,
						"w": 246
					},
					{
						"n": 9,
						"h": 374,
						"w": 274
					},
					{
						"n": 10,
						"h": 167,
						"w": 349
					},
					{
						"n": 11,
						"h": 278,
						"w": 349
					}
				],
				"away": [
					{
						"n": 1,
						"h": 260,
						"w": 34
					},
					{
						"n": 2,
						"h": 59,
						"w": 169
					},
					{
						"n": 3,
						"h": 172,
						"w": 169
					},
					{
						"n": 4,
						"h": 292,
						"w": 178
					},
					{
						"n": 5,
						"h": 390,
						"w": 172
					},
					{
						"n": 6,
						"h": 227,
						"w": 282
					},
					{
						"n": 7,
						"h": 232,
						"w": 393
					},
					{
						"n": 8,
						"h": 383,
						"w": 366
					},
					{
						"n": 9,
						"h": 58,
						"w": 426
					},
					{
						"n": 10,
						"h": 161,
						"w": 496
					},
					{
						"n": 11,
						"h": 282,
						"w": 500
					}
				],
				"ball": {
					"n": 0,
					"h": 190,
					"w": 686,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 15
		},
		{
			"num": 725,
			"minute": 36,
			"messages": [
				{
					"owner": 2,
					"mes": "Крыштоф Ласак[21](Опава) бьет вперед..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 12
					},
					{
						"n": 2,
						"h": 120,
						"w": 145
					},
					{
						"n": 3,
						"h": 179,
						"w": 132
					},
					{
						"n": 4,
						"h": 285,
						"w": 139
					},
					{
						"n": 5,
						"h": 330,
						"w": 144
					},
					{
						"n": 6,
						"h": 62,
						"w": 240
					},
					{
						"n": 7,
						"h": 163,
						"w": 218
					},
					{
						"n": 8,
						"h": 308,
						"w": 216
					},
					{
						"n": 9,
						"h": 413,
						"w": 241
					},
					{
						"n": 10,
						"h": 135,
						"w": 400
					},
					{
						"n": 11,
						"h": 279,
						"w": 382
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 50
					},
					{
						"n": 2,
						"h": 68,
						"w": 217
					},
					{
						"n": 3,
						"h": 177,
						"w": 166
					},
					{
						"n": 4,
						"h": 281,
						"w": 166
					},
					{
						"n": 5,
						"h": 386,
						"w": 175
					},
					{
						"n": 6,
						"h": 178,
						"w": 331
					},
					{
						"n": 7,
						"h": 232,
						"w": 393
					},
					{
						"n": 8,
						"h": 388,
						"w": 445
					},
					{
						"n": 9,
						"h": 137,
						"w": 426
					},
					{
						"n": 10,
						"h": 144,
						"w": 492
					},
					{
						"n": 11,
						"h": 288,
						"w": 492
					}
				],
				"ball": {
					"n": 0,
					"h": 279,
					"w": 382,
					"z": 1,
					"r": 0,
					"p": 4,
					"x": 0
				}
			},
			"interval": 79
		},
		{
			"num": 726,
			"minute": 36,
			"messages": [
				{
					"owner": 1,
					"mes": "Адам Гилберт[11](Галвэй Юнайтед) прыгает выше О.Дюмона[26](Опава) и скидывает мяч головой..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 12
					},
					{
						"n": 2,
						"h": 120,
						"w": 120
					},
					{
						"n": 3,
						"h": 181,
						"w": 110
					},
					{
						"n": 4,
						"h": 284,
						"w": 114
					},
					{
						"n": 5,
						"h": 330,
						"w": 119
					},
					{
						"n": 6,
						"h": 60,
						"w": 215
					},
					{
						"n": 7,
						"h": 162,
						"w": 209
					},
					{
						"n": 8,
						"h": 304,
						"w": 191
					},
					{
						"n": 9,
						"h": 411,
						"w": 236
					},
					{
						"n": 10,
						"h": 159,
						"w": 406
					},
					{
						"n": 11,
						"h": 279,
						"w": 382
					}
				],
				"away": [
					{
						"n": 1,
						"h": 223,
						"w": 65
					},
					{
						"n": 2,
						"h": 88,
						"w": 231
					},
					{
						"n": 3,
						"h": 172,
						"w": 165
					},
					{
						"n": 4,
						"h": 275,
						"w": 189
					},
					{
						"n": 5,
						"h": 391,
						"w": 174
					},
					{
						"n": 6,
						"h": 178,
						"w": 331
					},
					{
						"n": 7,
						"h": 226,
						"w": 368
					},
					{
						"n": 8,
						"h": 390,
						"w": 470
					},
					{
						"n": 9,
						"h": 119,
						"w": 443
					},
					{
						"n": 10,
						"h": 156,
						"w": 503
					},
					{
						"n": 11,
						"h": 288,
						"w": 492
					}
				],
				"ball": {
					"n": 0,
					"h": 292,
					"w": 430,
					"z": 1,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 25
		},
		{
			"num": 727,
			"minute": 36,
			"messages": [
				{
					"owner": 2,
					"mes": "Оливье Дюмон[26](Опава) подхватывает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 19
					},
					{
						"n": 2,
						"h": 120,
						"w": 115
					},
					{
						"n": 3,
						"h": 218,
						"w": 105
					},
					{
						"n": 4,
						"h": 306,
						"w": 118
					},
					{
						"n": 5,
						"h": 346,
						"w": 104
					},
					{
						"n": 6,
						"h": 56,
						"w": 198
					},
					{
						"n": 7,
						"h": 135,
						"w": 186
					},
					{
						"n": 8,
						"h": 312,
						"w": 203
					},
					{
						"n": 9,
						"h": 415,
						"w": 210
					},
					{
						"n": 10,
						"h": 133,
						"w": 400
					},
					{
						"n": 11,
						"h": 291,
						"w": 428
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 89
					},
					{
						"n": 2,
						"h": 74,
						"w": 231
					},
					{
						"n": 3,
						"h": 178,
						"w": 183
					},
					{
						"n": 4,
						"h": 271,
						"w": 191
					},
					{
						"n": 5,
						"h": 384,
						"w": 191
					},
					{
						"n": 6,
						"h": 155,
						"w": 278
					},
					{
						"n": 7,
						"h": 215,
						"w": 354
					},
					{
						"n": 8,
						"h": 412,
						"w": 508
					},
					{
						"n": 9,
						"h": 92,
						"w": 404
					},
					{
						"n": 10,
						"h": 146,
						"w": 489
					},
					{
						"n": 11,
						"h": 321,
						"w": 457
					}
				],
				"ball": {
					"n": 0,
					"h": 295,
					"w": 442,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 48
		},
		{
			"num": 728,
			"minute": 36,
			"messages": [
				{
					"owner": 2,
					"mes": "Пас М.Юрасеку[29](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 14
					},
					{
						"n": 2,
						"h": 120,
						"w": 103
					},
					{
						"n": 3,
						"h": 215,
						"w": 104
					},
					{
						"n": 4,
						"h": 298,
						"w": 112
					},
					{
						"n": 5,
						"h": 330,
						"w": 109
					},
					{
						"n": 6,
						"h": 56,
						"w": 234
					},
					{
						"n": 7,
						"h": 171,
						"w": 192
					},
					{
						"n": 8,
						"h": 320,
						"w": 239
					},
					{
						"n": 9,
						"h": 416,
						"w": 210
					},
					{
						"n": 10,
						"h": 170,
						"w": 400
					},
					{
						"n": 11,
						"h": 288,
						"w": 437
					}
				],
				"away": [
					{
						"n": 1,
						"h": 223,
						"w": 108
					},
					{
						"n": 2,
						"h": 69,
						"w": 268
					},
					{
						"n": 3,
						"h": 174,
						"w": 220
					},
					{
						"n": 4,
						"h": 273,
						"w": 228
					},
					{
						"n": 5,
						"h": 382,
						"w": 228
					},
					{
						"n": 6,
						"h": 162,
						"w": 285
					},
					{
						"n": 7,
						"h": 224,
						"w": 389
					},
					{
						"n": 8,
						"h": 414,
						"w": 471
					},
					{
						"n": 9,
						"h": 118,
						"w": 378
					},
					{
						"n": 10,
						"h": 152,
						"w": 525
					},
					{
						"n": 11,
						"h": 349,
						"w": 433
					}
				],
				"ball": {
					"n": 0,
					"h": 332,
					"w": 342,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 37
		},
		{
			"num": 729,
			"minute": 36,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 16
					},
					{
						"n": 2,
						"h": 120,
						"w": 104
					},
					{
						"n": 3,
						"h": 221,
						"w": 109
					},
					{
						"n": 4,
						"h": 302,
						"w": 108
					},
					{
						"n": 5,
						"h": 344,
						"w": 115
					},
					{
						"n": 6,
						"h": 56,
						"w": 194
					},
					{
						"n": 7,
						"h": 193,
						"w": 177
					},
					{
						"n": 8,
						"h": 324,
						"w": 279
					},
					{
						"n": 9,
						"h": 421,
						"w": 210
					},
					{
						"n": 10,
						"h": 177,
						"w": 400
					},
					{
						"n": 11,
						"h": 257,
						"w": 435
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 123
					},
					{
						"n": 2,
						"h": 64,
						"w": 305
					},
					{
						"n": 3,
						"h": 178,
						"w": 258
					},
					{
						"n": 4,
						"h": 273,
						"w": 268
					},
					{
						"n": 5,
						"h": 388,
						"w": 268
					},
					{
						"n": 6,
						"h": 193,
						"w": 310
					},
					{
						"n": 7,
						"h": 216,
						"w": 428
					},
					{
						"n": 8,
						"h": 412,
						"w": 511
					},
					{
						"n": 9,
						"h": 123,
						"w": 413
					},
					{
						"n": 10,
						"h": 151,
						"w": 565
					},
					{
						"n": 11,
						"h": 382,
						"w": 410
					}
				],
				"ball": {
					"n": 0,
					"h": 327,
					"w": 307,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 730,
			"minute": 36,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 13
					},
					{
						"n": 2,
						"h": 120,
						"w": 106
					},
					{
						"n": 3,
						"h": 223,
						"w": 103
					},
					{
						"n": 4,
						"h": 295,
						"w": 103
					},
					{
						"n": 5,
						"h": 333,
						"w": 117
					},
					{
						"n": 6,
						"h": 56,
						"w": 182
					},
					{
						"n": 7,
						"h": 188,
						"w": 186
					},
					{
						"n": 8,
						"h": 325,
						"w": 291
					},
					{
						"n": 9,
						"h": 409,
						"w": 210
					},
					{
						"n": 10,
						"h": 177,
						"w": 400
					},
					{
						"n": 11,
						"h": 257,
						"w": 435
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 126
					},
					{
						"n": 2,
						"h": 60,
						"w": 305
					},
					{
						"n": 3,
						"h": 177,
						"w": 270
					},
					{
						"n": 4,
						"h": 280,
						"w": 258
					},
					{
						"n": 5,
						"h": 378,
						"w": 274
					},
					{
						"n": 6,
						"h": 198,
						"w": 321
					},
					{
						"n": 7,
						"h": 213,
						"w": 440
					},
					{
						"n": 8,
						"h": 411,
						"w": 522
					},
					{
						"n": 9,
						"h": 125,
						"w": 425
					},
					{
						"n": 10,
						"h": 156,
						"w": 576
					},
					{
						"n": 11,
						"h": 390,
						"w": 419
					}
				],
				"ball": {
					"n": 0,
					"h": 325,
					"w": 295,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 12
		},
		{
			"num": 731,
			"minute": 36,
			"messages": [
				{
					"owner": 2,
					"mes": "Матей Юрасек[29](Опава) отдает передачу низом..."
				},
				{
					"owner": 2,
					"mes": "Мирослав Манолов[27](Опава) принимает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 14
					},
					{
						"n": 2,
						"h": 120,
						"w": 127
					},
					{
						"n": 3,
						"h": 236,
						"w": 123
					},
					{
						"n": 4,
						"h": 269,
						"w": 118
					},
					{
						"n": 5,
						"h": 330,
						"w": 112
					},
					{
						"n": 6,
						"h": 64,
						"w": 146
					},
					{
						"n": 7,
						"h": 209,
						"w": 216
					},
					{
						"n": 8,
						"h": 307,
						"w": 259
					},
					{
						"n": 9,
						"h": 415,
						"w": 221
					},
					{
						"n": 10,
						"h": 173,
						"w": 400
					},
					{
						"n": 11,
						"h": 275,
						"w": 446
					}
				],
				"away": [
					{
						"n": 1,
						"h": 228,
						"w": 124
					},
					{
						"n": 2,
						"h": 59,
						"w": 311
					},
					{
						"n": 3,
						"h": 175,
						"w": 260
					},
					{
						"n": 4,
						"h": 277,
						"w": 253
					},
					{
						"n": 5,
						"h": 377,
						"w": 246
					},
					{
						"n": 6,
						"h": 206,
						"w": 357
					},
					{
						"n": 7,
						"h": 199,
						"w": 426
					},
					{
						"n": 8,
						"h": 399,
						"w": 557
					},
					{
						"n": 9,
						"h": 120,
						"w": 434
					},
					{
						"n": 10,
						"h": 163,
						"w": 571
					},
					{
						"n": 11,
						"h": 406,
						"w": 389
					}
				],
				"ball": {
					"n": 0,
					"h": 251,
					"w": 294,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 37
		},
		{
			"num": 732,
			"minute": 36,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 18
					},
					{
						"n": 2,
						"h": 120,
						"w": 122
					},
					{
						"n": 3,
						"h": 222,
						"w": 130
					},
					{
						"n": 4,
						"h": 286,
						"w": 118
					},
					{
						"n": 5,
						"h": 330,
						"w": 128
					},
					{
						"n": 6,
						"h": 56,
						"w": 136
					},
					{
						"n": 7,
						"h": 243,
						"w": 238
					},
					{
						"n": 8,
						"h": 267,
						"w": 258
					},
					{
						"n": 9,
						"h": 397,
						"w": 221
					},
					{
						"n": 10,
						"h": 179,
						"w": 400
					},
					{
						"n": 11,
						"h": 313,
						"w": 446
					}
				],
				"away": [
					{
						"n": 1,
						"h": 226,
						"w": 125
					},
					{
						"n": 2,
						"h": 63,
						"w": 299
					},
					{
						"n": 3,
						"h": 173,
						"w": 250
					},
					{
						"n": 4,
						"h": 271,
						"w": 274
					},
					{
						"n": 5,
						"h": 390,
						"w": 262
					},
					{
						"n": 6,
						"h": 225,
						"w": 376
					},
					{
						"n": 7,
						"h": 200,
						"w": 453
					},
					{
						"n": 8,
						"h": 414,
						"w": 559
					},
					{
						"n": 9,
						"h": 104,
						"w": 471
					},
					{
						"n": 10,
						"h": 162,
						"w": 571
					},
					{
						"n": 11,
						"h": 405,
						"w": 390
					}
				],
				"ball": {
					"n": 0,
					"h": 250,
					"w": 267,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 733,
			"minute": 36,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 19
					},
					{
						"n": 2,
						"h": 120,
						"w": 127
					},
					{
						"n": 3,
						"h": 229,
						"w": 122
					},
					{
						"n": 4,
						"h": 271,
						"w": 126
					},
					{
						"n": 5,
						"h": 330,
						"w": 114
					},
					{
						"n": 6,
						"h": 60,
						"w": 136
					},
					{
						"n": 7,
						"h": 238,
						"w": 216
					},
					{
						"n": 8,
						"h": 242,
						"w": 228
					},
					{
						"n": 9,
						"h": 373,
						"w": 190
					},
					{
						"n": 10,
						"h": 172,
						"w": 400
					},
					{
						"n": 11,
						"h": 276,
						"w": 446
					}
				],
				"away": [
					{
						"n": 1,
						"h": 221,
						"w": 121
					},
					{
						"n": 2,
						"h": 62,
						"w": 307
					},
					{
						"n": 3,
						"h": 174,
						"w": 264
					},
					{
						"n": 4,
						"h": 278,
						"w": 268
					},
					{
						"n": 5,
						"h": 387,
						"w": 267
					},
					{
						"n": 6,
						"h": 213,
						"w": 368
					},
					{
						"n": 7,
						"h": 217,
						"w": 482
					},
					{
						"n": 8,
						"h": 405,
						"w": 559
					},
					{
						"n": 9,
						"h": 83,
						"w": 504
					},
					{
						"n": 10,
						"h": 149,
						"w": 569
					},
					{
						"n": 11,
						"h": 391,
						"w": 387
					}
				],
				"ball": {
					"n": 0,
					"h": 233,
					"w": 238,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 734,
			"minute": 36,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 19
					},
					{
						"n": 2,
						"h": 120,
						"w": 107
					},
					{
						"n": 3,
						"h": 201,
						"w": 117
					},
					{
						"n": 4,
						"h": 263,
						"w": 119
					},
					{
						"n": 5,
						"h": 330,
						"w": 124
					},
					{
						"n": 6,
						"h": 56,
						"w": 129
					},
					{
						"n": 7,
						"h": 206,
						"w": 216
					},
					{
						"n": 8,
						"h": 207,
						"w": 192
					},
					{
						"n": 9,
						"h": 387,
						"w": 154
					},
					{
						"n": 10,
						"h": 169,
						"w": 400
					},
					{
						"n": 11,
						"h": 313,
						"w": 446
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 122
					},
					{
						"n": 2,
						"h": 65,
						"w": 295
					},
					{
						"n": 3,
						"h": 166,
						"w": 248
					},
					{
						"n": 4,
						"h": 281,
						"w": 247
					},
					{
						"n": 5,
						"h": 375,
						"w": 266
					},
					{
						"n": 6,
						"h": 217,
						"w": 389
					},
					{
						"n": 7,
						"h": 244,
						"w": 509
					},
					{
						"n": 8,
						"h": 409,
						"w": 559
					},
					{
						"n": 9,
						"h": 61,
						"w": 536
					},
					{
						"n": 10,
						"h": 171,
						"w": 589
					},
					{
						"n": 11,
						"h": 407,
						"w": 383
					}
				],
				"ball": {
					"n": 0,
					"h": 206,
					"w": 211,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 735,
			"minute": 36,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 15
					},
					{
						"n": 2,
						"h": 82,
						"w": 119
					},
					{
						"n": 3,
						"h": 214,
						"w": 124
					},
					{
						"n": 4,
						"h": 282,
						"w": 121
					},
					{
						"n": 5,
						"h": 330,
						"w": 120
					},
					{
						"n": 6,
						"h": 56,
						"w": 169
					},
					{
						"n": 7,
						"h": 213,
						"w": 182
					},
					{
						"n": 8,
						"h": 216,
						"w": 155
					},
					{
						"n": 9,
						"h": 389,
						"w": 131
					},
					{
						"n": 10,
						"h": 166,
						"w": 400
					},
					{
						"n": 11,
						"h": 286,
						"w": 433
					}
				],
				"away": [
					{
						"n": 1,
						"h": 223,
						"w": 119
					},
					{
						"n": 2,
						"h": 60,
						"w": 322
					},
					{
						"n": 3,
						"h": 164,
						"w": 288
					},
					{
						"n": 4,
						"h": 284,
						"w": 287
					},
					{
						"n": 5,
						"h": 385,
						"w": 266
					},
					{
						"n": 6,
						"h": 221,
						"w": 429
					},
					{
						"n": 7,
						"h": 236,
						"w": 547
					},
					{
						"n": 8,
						"h": 407,
						"w": 587
					},
					{
						"n": 9,
						"h": 46,
						"w": 573
					},
					{
						"n": 10,
						"h": 151,
						"w": 562
					},
					{
						"n": 11,
						"h": 406,
						"w": 423
					}
				],
				"ball": {
					"n": 0,
					"h": 214,
					"w": 173,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 736,
			"minute": 36,
			"messages": [
				{
					"owner": 2,
					"mes": "М.Манолов[27](Опава) отдает передачу П.Крамаржу[30](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 14
					},
					{
						"n": 2,
						"h": 117,
						"w": 109
					},
					{
						"n": 3,
						"h": 246,
						"w": 108
					},
					{
						"n": 4,
						"h": 278,
						"w": 128
					},
					{
						"n": 5,
						"h": 330,
						"w": 128
					},
					{
						"n": 6,
						"h": 43,
						"w": 204
					},
					{
						"n": 7,
						"h": 203,
						"w": 172
					},
					{
						"n": 8,
						"h": 246,
						"w": 176
					},
					{
						"n": 9,
						"h": 392,
						"w": 133
					},
					{
						"n": 10,
						"h": 169,
						"w": 400
					},
					{
						"n": 11,
						"h": 320,
						"w": 446
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 119
					},
					{
						"n": 2,
						"h": 68,
						"w": 302
					},
					{
						"n": 3,
						"h": 170,
						"w": 251
					},
					{
						"n": 4,
						"h": 281,
						"w": 250
					},
					{
						"n": 5,
						"h": 388,
						"w": 273
					},
					{
						"n": 6,
						"h": 223,
						"w": 404
					},
					{
						"n": 7,
						"h": 237,
						"w": 538
					},
					{
						"n": 8,
						"h": 411,
						"w": 577
					},
					{
						"n": 9,
						"h": 43,
						"w": 563
					},
					{
						"n": 10,
						"h": 167,
						"w": 572
					},
					{
						"n": 11,
						"h": 414,
						"w": 389
					}
				],
				"ball": {
					"n": 0,
					"h": 283,
					"w": 148,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 37
		},
		{
			"num": 737,
			"minute": 36,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 231,
						"w": 14
					},
					{
						"n": 2,
						"h": 120,
						"w": 103
					},
					{
						"n": 3,
						"h": 245,
						"w": 119
					},
					{
						"n": 4,
						"h": 283,
						"w": 139
					},
					{
						"n": 5,
						"h": 330,
						"w": 116
					},
					{
						"n": 6,
						"h": 45,
						"w": 192
					},
					{
						"n": 7,
						"h": 214,
						"w": 174
					},
					{
						"n": 8,
						"h": 257,
						"w": 180
					},
					{
						"n": 9,
						"h": 388,
						"w": 127
					},
					{
						"n": 10,
						"h": 178,
						"w": 400
					},
					{
						"n": 11,
						"h": 321,
						"w": 434
					}
				],
				"away": [
					{
						"n": 1,
						"h": 228,
						"w": 120
					},
					{
						"n": 2,
						"h": 69,
						"w": 314
					},
					{
						"n": 3,
						"h": 169,
						"w": 263
					},
					{
						"n": 4,
						"h": 272,
						"w": 258
					},
					{
						"n": 5,
						"h": 387,
						"w": 261
					},
					{
						"n": 6,
						"h": 226,
						"w": 416
					},
					{
						"n": 7,
						"h": 240,
						"w": 534
					},
					{
						"n": 8,
						"h": 412,
						"w": 575
					},
					{
						"n": 9,
						"h": 47,
						"w": 572
					},
					{
						"n": 10,
						"h": 167,
						"w": 581
					},
					{
						"n": 11,
						"h": 415,
						"w": 401
					}
				],
				"ball": {
					"n": 0,
					"h": 283,
					"w": 139,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 12
		},
		{
			"num": 738,
			"minute": 36,
			"messages": [
				{
					"owner": 2,
					"mes": "Роббе Дриссенс[04](Галвэй Юнайтед) пытается отобрать мяч у П.Крамаржа[30](Опава)..."
				},
				{
					"owner": 2,
					"mes": "Роббе Дриссенс[04](Галвэй Юнайтед) отнимает у него мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 231,
						"w": 14
					},
					{
						"n": 2,
						"h": 120,
						"w": 103
					},
					{
						"n": 3,
						"h": 245,
						"w": 119
					},
					{
						"n": 4,
						"h": 288,
						"w": 147,
						"m": 660
					},
					{
						"n": 5,
						"h": 330,
						"w": 110
					},
					{
						"n": 6,
						"h": 46,
						"w": 182
					},
					{
						"n": 7,
						"h": 214,
						"w": 174
					},
					{
						"n": 8,
						"h": 266,
						"w": 184
					},
					{
						"n": 9,
						"h": 388,
						"w": 127
					},
					{
						"n": 10,
						"h": 178,
						"w": 400
					},
					{
						"n": 11,
						"h": 322,
						"w": 430
					}
				],
				"away": [
					{
						"n": 1,
						"h": 228,
						"w": 120
					},
					{
						"n": 2,
						"h": 70,
						"w": 324
					},
					{
						"n": 3,
						"h": 169,
						"w": 273
					},
					{
						"n": 4,
						"h": 269,
						"w": 261
					},
					{
						"n": 5,
						"h": 387,
						"w": 261
					},
					{
						"n": 6,
						"h": 227,
						"w": 418
					},
					{
						"n": 7,
						"h": 240,
						"w": 534
					},
					{
						"n": 8,
						"h": 412,
						"w": 575
					},
					{
						"n": 9,
						"h": 47,
						"w": 572
					},
					{
						"n": 10,
						"h": 167,
						"w": 591
					},
					{
						"n": 11,
						"h": 416,
						"w": 411
					}
				],
				"ball": {
					"n": 0,
					"h": 288,
					"w": 147,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 10
		},
		{
			"num": 739,
			"minute": 36,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 12
					},
					{
						"n": 2,
						"h": 104,
						"w": 139
					},
					{
						"n": 3,
						"h": 209,
						"w": 137
					},
					{
						"n": 4,
						"h": 313,
						"w": 172
					},
					{
						"n": 5,
						"h": 342,
						"w": 132
					},
					{
						"n": 6,
						"h": 48,
						"w": 222
					},
					{
						"n": 7,
						"h": 199,
						"w": 211
					},
					{
						"n": 8,
						"h": 278,
						"w": 222
					},
					{
						"n": 9,
						"h": 393,
						"w": 166
					},
					{
						"n": 10,
						"h": 161,
						"w": 436
					},
					{
						"n": 11,
						"h": 295,
						"w": 441
					}
				],
				"away": [
					{
						"n": 1,
						"h": 216,
						"w": 82
					},
					{
						"n": 2,
						"h": 74,
						"w": 284
					},
					{
						"n": 3,
						"h": 170,
						"w": 233
					},
					{
						"n": 4,
						"h": 272,
						"w": 221
					},
					{
						"n": 5,
						"h": 356,
						"w": 236
					},
					{
						"n": 6,
						"h": 244,
						"w": 382
					},
					{
						"n": 7,
						"h": 236,
						"w": 495
					},
					{
						"n": 8,
						"h": 411,
						"w": 535
					},
					{
						"n": 9,
						"h": 45,
						"w": 532
					},
					{
						"n": 10,
						"h": 162,
						"w": 582
					},
					{
						"n": 11,
						"h": 377,
						"w": 401
					}
				],
				"ball": {
					"n": 0,
					"h": 313,
					"w": 172,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 740,
			"minute": 36,
			"messages": [
				{
					"owner": 1,
					"mes": "Роббе Дриссенс[04](Галвэй Юнайтед) пасует на К.Нолана[08](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 11
					},
					{
						"n": 2,
						"h": 93,
						"w": 156
					},
					{
						"n": 3,
						"h": 192,
						"w": 147
					},
					{
						"n": 4,
						"h": 303,
						"w": 169
					},
					{
						"n": 5,
						"h": 345,
						"w": 136
					},
					{
						"n": 6,
						"h": 48,
						"w": 242
					},
					{
						"n": 7,
						"h": 193,
						"w": 230
					},
					{
						"n": 8,
						"h": 289,
						"w": 205
					},
					{
						"n": 9,
						"h": 395,
						"w": 186
					},
					{
						"n": 10,
						"h": 157,
						"w": 456
					},
					{
						"n": 11,
						"h": 297,
						"w": 461
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 74
					},
					{
						"n": 2,
						"h": 75,
						"w": 264
					},
					{
						"n": 3,
						"h": 166,
						"w": 213
					},
					{
						"n": 4,
						"h": 282,
						"w": 204
					},
					{
						"n": 5,
						"h": 344,
						"w": 220
					},
					{
						"n": 6,
						"h": 251,
						"w": 363
					},
					{
						"n": 7,
						"h": 234,
						"w": 475
					},
					{
						"n": 8,
						"h": 410,
						"w": 515
					},
					{
						"n": 9,
						"h": 42,
						"w": 512
					},
					{
						"n": 10,
						"h": 162,
						"w": 562
					},
					{
						"n": 11,
						"h": 358,
						"w": 395
					}
				],
				"ball": {
					"n": 0,
					"h": 289,
					"w": 205,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 20
		},
		{
			"num": 741,
			"minute": 36,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 18
					},
					{
						"n": 2,
						"h": 81,
						"w": 194
					},
					{
						"n": 3,
						"h": 174,
						"w": 182
					},
					{
						"n": 4,
						"h": 292,
						"w": 186
					},
					{
						"n": 5,
						"h": 359,
						"w": 173
					},
					{
						"n": 6,
						"h": 49,
						"w": 282
					},
					{
						"n": 7,
						"h": 181,
						"w": 268
					},
					{
						"n": 8,
						"h": 302,
						"w": 243
					},
					{
						"n": 9,
						"h": 399,
						"w": 226
					},
					{
						"n": 10,
						"h": 139,
						"w": 481
					},
					{
						"n": 11,
						"h": 311,
						"w": 489
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 70
					},
					{
						"n": 2,
						"h": 81,
						"w": 225
					},
					{
						"n": 3,
						"h": 176,
						"w": 208
					},
					{
						"n": 4,
						"h": 270,
						"w": 193
					},
					{
						"n": 5,
						"h": 340,
						"w": 197
					},
					{
						"n": 6,
						"h": 266,
						"w": 326
					},
					{
						"n": 7,
						"h": 229,
						"w": 431
					},
					{
						"n": 8,
						"h": 410,
						"w": 475
					},
					{
						"n": 9,
						"h": 45,
						"w": 472
					},
					{
						"n": 10,
						"h": 159,
						"w": 543
					},
					{
						"n": 11,
						"h": 327,
						"w": 369
					}
				],
				"ball": {
					"n": 0,
					"h": 302,
					"w": 243,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 742,
			"minute": 37,
			"possession": 43,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 16
					},
					{
						"n": 2,
						"h": 77,
						"w": 234
					},
					{
						"n": 3,
						"h": 167,
						"w": 218
					},
					{
						"n": 4,
						"h": 276,
						"w": 202
					},
					{
						"n": 5,
						"h": 371,
						"w": 211
					},
					{
						"n": 6,
						"h": 51,
						"w": 322
					},
					{
						"n": 7,
						"h": 176,
						"w": 308,
						"f": 88
					},
					{
						"n": 8,
						"h": 302,
						"w": 278
					},
					{
						"n": 9,
						"h": 401,
						"w": 266,
						"m": 740
					},
					{
						"n": 10,
						"h": 156,
						"w": 493
					},
					{
						"n": 11,
						"h": 308,
						"w": 491
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 77
					},
					{
						"n": 2,
						"h": 110,
						"w": 201,
						"m": 600
					},
					{
						"n": 3,
						"h": 154,
						"w": 192
					},
					{
						"n": 4,
						"h": 274,
						"w": 184
					},
					{
						"n": 5,
						"h": 340,
						"w": 195
					},
					{
						"n": 6,
						"h": 236,
						"w": 299,
						"f": 88
					},
					{
						"n": 7,
						"h": 190,
						"w": 427
					},
					{
						"n": 8,
						"h": 408,
						"w": 455
					},
					{
						"n": 9,
						"h": 39,
						"w": 433
					},
					{
						"n": 10,
						"h": 172,
						"w": 505
					},
					{
						"n": 11,
						"h": 291,
						"w": 385
					}
				],
				"ball": {
					"n": 0,
					"h": 302,
					"w": 278,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 743,
			"minute": 37,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 11
					},
					{
						"n": 2,
						"h": 66,
						"w": 272
					},
					{
						"n": 3,
						"h": 167,
						"w": 215
					},
					{
						"n": 4,
						"h": 266,
						"w": 231
					},
					{
						"n": 5,
						"h": 376,
						"w": 251
					},
					{
						"n": 6,
						"h": 50,
						"w": 362
					},
					{
						"n": 7,
						"h": 171,
						"w": 347
					},
					{
						"n": 8,
						"h": 302,
						"w": 314
					},
					{
						"n": 9,
						"h": 397,
						"w": 306
					},
					{
						"n": 10,
						"h": 151,
						"w": 511
					},
					{
						"n": 11,
						"h": 294,
						"w": 525
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 70
					},
					{
						"n": 2,
						"h": 110,
						"w": 161
					},
					{
						"n": 3,
						"h": 167,
						"w": 154
					},
					{
						"n": 4,
						"h": 287,
						"w": 166
					},
					{
						"n": 5,
						"h": 340,
						"w": 162
					},
					{
						"n": 6,
						"h": 259,
						"w": 266
					},
					{
						"n": 7,
						"h": 163,
						"w": 398
					},
					{
						"n": 8,
						"h": 407,
						"w": 435
					},
					{
						"n": 9,
						"h": 32,
						"w": 393
					},
					{
						"n": 10,
						"h": 184,
						"w": 469
					},
					{
						"n": 11,
						"h": 279,
						"w": 353
					}
				],
				"ball": {
					"n": 0,
					"h": 302,
					"w": 314,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 744,
			"minute": 37,
			"messages": [
				{
					"owner": 1,
					"mes": "Киран Нолан[08](Галвэй Юнайтед) пасует А.Хлинссону[07](Галвэй Юнайтед)..."
				},
				{
					"owner": 1,
					"mes": "Теперь с мячом Агуст Хлинссон[07](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 15
					},
					{
						"n": 2,
						"h": 61,
						"w": 295
					},
					{
						"n": 3,
						"h": 181,
						"w": 253
					},
					{
						"n": 4,
						"h": 271,
						"w": 251
					},
					{
						"n": 5,
						"h": 388,
						"w": 289
					},
					{
						"n": 6,
						"h": 53,
						"w": 402
					},
					{
						"n": 7,
						"h": 201,
						"w": 321
					},
					{
						"n": 8,
						"h": 303,
						"w": 324
					},
					{
						"n": 9,
						"h": 402,
						"w": 345
					},
					{
						"n": 10,
						"h": 140,
						"w": 549
					},
					{
						"n": 11,
						"h": 292,
						"w": 551
					}
				],
				"away": [
					{
						"n": 1,
						"h": 228,
						"w": 73
					},
					{
						"n": 2,
						"h": 110,
						"w": 134
					},
					{
						"n": 3,
						"h": 177,
						"w": 130
					},
					{
						"n": 4,
						"h": 284,
						"w": 126
					},
					{
						"n": 5,
						"h": 340,
						"w": 122
					},
					{
						"n": 6,
						"h": 226,
						"w": 242
					},
					{
						"n": 7,
						"h": 176,
						"w": 360
					},
					{
						"n": 8,
						"h": 405,
						"w": 415
					},
					{
						"n": 9,
						"h": 27,
						"w": 353
					},
					{
						"n": 10,
						"h": 169,
						"w": 432
					},
					{
						"n": 11,
						"h": 249,
						"w": 379
					}
				],
				"ball": {
					"n": 0,
					"h": 201,
					"w": 321,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 745,
			"minute": 37,
			"messages": [
				{
					"owner": 1,
					"mes": "Агуст Хлинссон[07](Галвэй Юнайтед) владеет мячом..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 19
					},
					{
						"n": 2,
						"h": 78,
						"w": 331
					},
					{
						"n": 3,
						"h": 185,
						"w": 282
					},
					{
						"n": 4,
						"h": 284,
						"w": 284
					},
					{
						"n": 5,
						"h": 383,
						"w": 328
					},
					{
						"n": 6,
						"h": 51,
						"w": 442
					},
					{
						"n": 7,
						"h": 172,
						"w": 340
					},
					{
						"n": 8,
						"h": 299,
						"w": 363
					},
					{
						"n": 9,
						"h": 404,
						"w": 385
					},
					{
						"n": 10,
						"h": 174,
						"w": 570
					},
					{
						"n": 11,
						"h": 283,
						"w": 590
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 79
					},
					{
						"n": 2,
						"h": 110,
						"w": 115
					},
					{
						"n": 3,
						"h": 182,
						"w": 112
					},
					{
						"n": 4,
						"h": 256,
						"w": 103
					},
					{
						"n": 5,
						"h": 340,
						"w": 121
					},
					{
						"n": 6,
						"h": 227,
						"w": 202
					},
					{
						"n": 7,
						"h": 190,
						"w": 322
					},
					{
						"n": 8,
						"h": 405,
						"w": 395
					},
					{
						"n": 9,
						"h": 22,
						"w": 314
					},
					{
						"n": 10,
						"h": 162,
						"w": 392
					},
					{
						"n": 11,
						"h": 274,
						"w": 376
					}
				],
				"ball": {
					"n": 0,
					"h": 172,
					"w": 340,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 746,
			"minute": 37,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 10
					},
					{
						"n": 2,
						"h": 73,
						"w": 355
					},
					{
						"n": 3,
						"h": 179,
						"w": 292
					},
					{
						"n": 4,
						"h": 267,
						"w": 304
					},
					{
						"n": 5,
						"h": 382,
						"w": 352
					},
					{
						"n": 6,
						"h": 53,
						"w": 477
					},
					{
						"n": 7,
						"h": 146,
						"w": 322
					},
					{
						"n": 8,
						"h": 294,
						"w": 399
					},
					{
						"n": 9,
						"h": 404,
						"w": 421
					},
					{
						"n": 10,
						"h": 165,
						"w": 605
					},
					{
						"n": 11,
						"h": 292,
						"w": 617
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 53
					},
					{
						"n": 2,
						"h": 110,
						"w": 111
					},
					{
						"n": 3,
						"h": 171,
						"w": 104
					},
					{
						"n": 4,
						"h": 274,
						"w": 83
					},
					{
						"n": 5,
						"h": 340,
						"w": 97
					},
					{
						"n": 6,
						"h": 253,
						"w": 177
					},
					{
						"n": 7,
						"h": 205,
						"w": 290
					},
					{
						"n": 8,
						"h": 404,
						"w": 377
					},
					{
						"n": 9,
						"h": 39,
						"w": 282
					},
					{
						"n": 10,
						"h": 160,
						"w": 357
					},
					{
						"n": 11,
						"h": 290,
						"w": 377
					}
				],
				"ball": {
					"n": 0,
					"h": 146,
					"w": 322,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 36
		},
		{
			"num": 747,
			"minute": 37,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 12
					},
					{
						"n": 2,
						"h": 66,
						"w": 373
					},
					{
						"n": 3,
						"h": 168,
						"w": 305
					},
					{
						"n": 4,
						"h": 271,
						"w": 312
					},
					{
						"n": 5,
						"h": 376,
						"w": 369
					},
					{
						"n": 6,
						"h": 52,
						"w": 517
					},
					{
						"n": 7,
						"h": 142,
						"w": 367
					},
					{
						"n": 8,
						"h": 296,
						"w": 439
					},
					{
						"n": 9,
						"h": 405,
						"w": 461
					},
					{
						"n": 10,
						"h": 165,
						"w": 620
					},
					{
						"n": 11,
						"h": 299,
						"w": 630
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 16
					},
					{
						"n": 2,
						"h": 110,
						"w": 77
					},
					{
						"n": 3,
						"h": 164,
						"w": 79
					},
					{
						"n": 4,
						"h": 273,
						"w": 101
					},
					{
						"n": 5,
						"h": 354,
						"w": 134
					},
					{
						"n": 6,
						"h": 271,
						"w": 151
					},
					{
						"n": 7,
						"h": 212,
						"w": 250
					},
					{
						"n": 8,
						"h": 410,
						"w": 338
					},
					{
						"n": 9,
						"h": 51,
						"w": 244
					},
					{
						"n": 10,
						"h": 157,
						"w": 317
					},
					{
						"n": 11,
						"h": 305,
						"w": 340
					}
				],
				"ball": {
					"n": 0,
					"h": 142,
					"w": 367,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 748,
			"minute": 37,
			"messages": [
				{
					"owner": 1,
					"mes": "Пас К.Нолану[08](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 16
					},
					{
						"n": 2,
						"h": 60,
						"w": 353
					},
					{
						"n": 3,
						"h": 184,
						"w": 292
					},
					{
						"n": 4,
						"h": 266,
						"w": 304
					},
					{
						"n": 5,
						"h": 392,
						"w": 341
					},
					{
						"n": 6,
						"h": 45,
						"w": 559
					},
					{
						"n": 7,
						"h": 143,
						"w": 379,
						"m": 690
					},
					{
						"n": 8,
						"h": 255,
						"w": 430
					},
					{
						"n": 9,
						"h": 409,
						"w": 503
					},
					{
						"n": 10,
						"h": 162,
						"w": 588
					},
					{
						"n": 11,
						"h": 282,
						"w": 613
					}
				],
				"away": [
					{
						"n": 1,
						"h": 221,
						"w": 18
					},
					{
						"n": 2,
						"h": 110,
						"w": 88
					},
					{
						"n": 3,
						"h": 179,
						"w": 84
					},
					{
						"n": 4,
						"h": 278,
						"w": 98
					},
					{
						"n": 5,
						"h": 380,
						"w": 141
					},
					{
						"n": 6,
						"h": 290,
						"w": 139
					},
					{
						"n": 7,
						"h": 197,
						"w": 290
					},
					{
						"n": 8,
						"h": 410,
						"w": 296
					},
					{
						"n": 9,
						"h": 28,
						"w": 238
					},
					{
						"n": 10,
						"h": 184,
						"w": 284
					},
					{
						"n": 11,
						"h": 307,
						"w": 321
					}
				],
				"ball": {
					"n": 0,
					"h": 253,
					"w": 430,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 42
		},
		{
			"num": 749,
			"minute": 37,
			"messages": [
				{
					"owner": 1,
					"mes": "Но Мирослав Манолов[27](Опава) перехватывает пас!..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 17
					},
					{
						"n": 2,
						"h": 66,
						"w": 364
					},
					{
						"n": 3,
						"h": 219,
						"w": 302
					},
					{
						"n": 4,
						"h": 287,
						"w": 296
					},
					{
						"n": 5,
						"h": 360,
						"w": 317
					},
					{
						"n": 6,
						"h": 45,
						"w": 519
					},
					{
						"n": 7,
						"h": 122,
						"w": 379
					},
					{
						"n": 8,
						"h": 235,
						"w": 396
					},
					{
						"n": 9,
						"h": 401,
						"w": 464
					},
					{
						"n": 10,
						"h": 167,
						"w": 548
					},
					{
						"n": 11,
						"h": 280,
						"w": 573
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 10
					},
					{
						"n": 2,
						"h": 83,
						"w": 117
					},
					{
						"n": 3,
						"h": 176,
						"w": 106
					},
					{
						"n": 4,
						"h": 275,
						"w": 112
					},
					{
						"n": 5,
						"h": 391,
						"w": 125
					},
					{
						"n": 6,
						"h": 261,
						"w": 167
					},
					{
						"n": 7,
						"h": 222,
						"w": 315,
						"m": 570
					},
					{
						"n": 8,
						"h": 414,
						"w": 336
					},
					{
						"n": 9,
						"h": 34,
						"w": 278
					},
					{
						"n": 10,
						"h": 162,
						"w": 318
					},
					{
						"n": 11,
						"h": 336,
						"w": 294
					}
				],
				"ball": {
					"n": 0,
					"h": 228,
					"w": 405,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 750,
			"minute": 37,
			"messages": [
				{
					"owner": 2,
					"mes": "П.Крамарж[30](Опава) открывается поблизости... Пас ему..."
				},
				{
					"owner": 2,
					"mes": "Но Киран Нолан[08](Галвэй Юнайтед) перехватывает пас!..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 18
					},
					{
						"n": 2,
						"h": 68,
						"w": 359
					},
					{
						"n": 3,
						"h": 214,
						"w": 298
					},
					{
						"n": 4,
						"h": 281,
						"w": 294
					},
					{
						"n": 5,
						"h": 357,
						"w": 312
					},
					{
						"n": 6,
						"h": 46,
						"w": 513
					},
					{
						"n": 7,
						"h": 127,
						"w": 376
					},
					{
						"n": 8,
						"h": 233,
						"w": 401
					},
					{
						"n": 9,
						"h": 400,
						"w": 458
					},
					{
						"n": 10,
						"h": 167,
						"w": 542
					},
					{
						"n": 11,
						"h": 281,
						"w": 567
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 14
					},
					{
						"n": 2,
						"h": 82,
						"w": 123
					},
					{
						"n": 3,
						"h": 171,
						"w": 102
					},
					{
						"n": 4,
						"h": 278,
						"w": 107
					},
					{
						"n": 5,
						"h": 392,
						"w": 119
					},
					{
						"n": 6,
						"h": 257,
						"w": 171
					},
					{
						"n": 7,
						"h": 222,
						"w": 315,
						"m": 560
					},
					{
						"n": 8,
						"h": 413,
						"w": 341
					},
					{
						"n": 9,
						"h": 35,
						"w": 283
					},
					{
						"n": 10,
						"h": 167,
						"w": 318,
						"m": 630
					},
					{
						"n": 11,
						"h": 341,
						"w": 290
					}
				],
				"ball": {
					"n": 0,
					"h": 233,
					"w": 401,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 6
		},
		{
			"num": 751,
			"minute": 37,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 10
					},
					{
						"n": 2,
						"h": 63,
						"w": 357
					},
					{
						"n": 3,
						"h": 177,
						"w": 297
					},
					{
						"n": 4,
						"h": 265,
						"w": 302
					},
					{
						"n": 5,
						"h": 374,
						"w": 342
					},
					{
						"n": 6,
						"h": 51,
						"w": 553
					},
					{
						"n": 7,
						"h": 141,
						"w": 413
					},
					{
						"n": 8,
						"h": 258,
						"w": 426,
						"m": 610
					},
					{
						"n": 9,
						"h": 405,
						"w": 498
					},
					{
						"n": 10,
						"h": 160,
						"w": 582
					},
					{
						"n": 11,
						"h": 288,
						"w": 607
					}
				],
				"away": [
					{
						"n": 1,
						"h": 226,
						"w": 54
					},
					{
						"n": 2,
						"h": 110,
						"w": 98
					},
					{
						"n": 3,
						"h": 175,
						"w": 108
					},
					{
						"n": 4,
						"h": 277,
						"w": 87
					},
					{
						"n": 5,
						"h": 374,
						"w": 147
					},
					{
						"n": 6,
						"h": 282,
						"w": 146
					},
					{
						"n": 7,
						"h": 226,
						"w": 279
					},
					{
						"n": 8,
						"h": 413,
						"w": 301
					},
					{
						"n": 9,
						"h": 29,
						"w": 252
					},
					{
						"n": 10,
						"h": 187,
						"w": 283
					},
					{
						"n": 11,
						"h": 311,
						"w": 267
					}
				],
				"ball": {
					"n": 0,
					"h": 258,
					"w": 426,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 752,
			"minute": 37,
			"messages": [
				{
					"owner": 1,
					"mes": "Передача вперед..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 11
					},
					{
						"n": 2,
						"h": 75,
						"w": 372
					},
					{
						"n": 3,
						"h": 165,
						"w": 316
					},
					{
						"n": 4,
						"h": 274,
						"w": 310
					},
					{
						"n": 5,
						"h": 375,
						"w": 370
					},
					{
						"n": 6,
						"h": 55,
						"w": 573
					},
					{
						"n": 7,
						"h": 145,
						"w": 448
					},
					{
						"n": 8,
						"h": 261,
						"w": 436
					},
					{
						"n": 9,
						"h": 404,
						"w": 533
					},
					{
						"n": 10,
						"h": 171,
						"w": 597
					},
					{
						"n": 11,
						"h": 303,
						"w": 580
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 19
					},
					{
						"n": 2,
						"h": 110,
						"w": 102
					},
					{
						"n": 3,
						"h": 161,
						"w": 100
					},
					{
						"n": 4,
						"h": 269,
						"w": 101
					},
					{
						"n": 5,
						"h": 370,
						"w": 127
					},
					{
						"n": 6,
						"h": 248,
						"w": 153
					},
					{
						"n": 7,
						"h": 222,
						"w": 244
					},
					{
						"n": 8,
						"h": 414,
						"w": 266
					},
					{
						"n": 9,
						"h": 37,
						"w": 254
					},
					{
						"n": 10,
						"h": 183,
						"w": 277
					},
					{
						"n": 11,
						"h": 305,
						"w": 252
					}
				],
				"ball": {
					"n": 0,
					"h": 312,
					"w": 516,
					"z": 0,
					"r": 0,
					"p": 1,
					"x": 0
				}
			},
			"interval": 35
		},
		{
			"num": 753,
			"minute": 37,
			"messages": [
				{
					"owner": 1,
					"mes": "Адам Гилберт[11](Галвэй Юнайтед) сбрасывает мяч себе на ход..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 11
					},
					{
						"n": 2,
						"h": 75,
						"w": 351
					},
					{
						"n": 3,
						"h": 182,
						"w": 295
					},
					{
						"n": 4,
						"h": 271,
						"w": 309
					},
					{
						"n": 5,
						"h": 373,
						"w": 362
					},
					{
						"n": 6,
						"h": 64,
						"w": 577
					},
					{
						"n": 7,
						"h": 149,
						"w": 482
					},
					{
						"n": 8,
						"h": 276,
						"w": 436
					},
					{
						"n": 9,
						"h": 399,
						"w": 567
					},
					{
						"n": 10,
						"h": 163,
						"w": 607
					},
					{
						"n": 11,
						"h": 326,
						"w": 539
					}
				],
				"away": [
					{
						"n": 1,
						"h": 218,
						"w": 13
					},
					{
						"n": 2,
						"h": 117,
						"w": 141
					},
					{
						"n": 3,
						"h": 166,
						"w": 94
					},
					{
						"n": 4,
						"h": 288,
						"w": 111
					},
					{
						"n": 5,
						"h": 350,
						"w": 99
					},
					{
						"n": 6,
						"h": 214,
						"w": 161
					},
					{
						"n": 7,
						"h": 220,
						"w": 210
					},
					{
						"n": 8,
						"h": 413,
						"w": 231
					},
					{
						"n": 9,
						"h": 41,
						"w": 244
					},
					{
						"n": 10,
						"h": 174,
						"w": 264
					},
					{
						"n": 11,
						"h": 298,
						"w": 286
					}
				],
				"ball": {
					"n": 0,
					"h": 326,
					"w": 539,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 35
		},
		{
			"num": 754,
			"minute": 37,
			"messages": [
				{
					"owner": 1,
					"mes": "Адам Гилберт[11](Галвэй Юнайтед) посылает мяч направо в направлении Э.Бвомоно[09](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 10
					},
					{
						"n": 2,
						"h": 71,
						"w": 361
					},
					{
						"n": 3,
						"h": 180,
						"w": 325
					},
					{
						"n": 4,
						"h": 266,
						"w": 325
					},
					{
						"n": 5,
						"h": 391,
						"w": 377
					},
					{
						"n": 6,
						"h": 59,
						"w": 605
					},
					{
						"n": 7,
						"h": 176,
						"w": 512
					},
					{
						"n": 8,
						"h": 311,
						"w": 429
					},
					{
						"n": 9,
						"h": 398,
						"w": 607
					},
					{
						"n": 10,
						"h": 193,
						"w": 633
					},
					{
						"n": 11,
						"h": 322,
						"w": 548
					}
				],
				"away": [
					{
						"n": 1,
						"h": 212,
						"w": 8
					},
					{
						"n": 2,
						"h": 91,
						"w": 111
					},
					{
						"n": 3,
						"h": 197,
						"w": 69
					},
					{
						"n": 4,
						"h": 268,
						"w": 77
					},
					{
						"n": 5,
						"h": 340,
						"w": 61
					},
					{
						"n": 6,
						"h": 175,
						"w": 151
					},
					{
						"n": 7,
						"h": 259,
						"w": 202
					},
					{
						"n": 8,
						"h": 410,
						"w": 192
					},
					{
						"n": 9,
						"h": 29,
						"w": 218
					},
					{
						"n": 10,
						"h": 139,
						"w": 271
					},
					{
						"n": 11,
						"h": 286,
						"w": 298
					}
				],
				"ball": {
					"n": 0,
					"h": 398,
					"w": 607,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 755,
			"minute": 37,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 13
					},
					{
						"n": 2,
						"h": 76,
						"w": 367
					},
					{
						"n": 3,
						"h": 180,
						"w": 329
					},
					{
						"n": 4,
						"h": 270,
						"w": 330
					},
					{
						"n": 5,
						"h": 387,
						"w": 373
					},
					{
						"n": 6,
						"h": 58,
						"w": 629
					},
					{
						"n": 7,
						"h": 175,
						"w": 536
					},
					{
						"n": 8,
						"h": 309,
						"w": 453
					},
					{
						"n": 9,
						"h": 378,
						"w": 620
					},
					{
						"n": 10,
						"h": 213,
						"w": 647
					},
					{
						"n": 11,
						"h": 315,
						"w": 571
					}
				],
				"away": [
					{
						"n": 1,
						"h": 212,
						"w": 8
					},
					{
						"n": 2,
						"h": 78,
						"w": 87
					},
					{
						"n": 3,
						"h": 175,
						"w": 60
					},
					{
						"n": 4,
						"h": 245,
						"w": 68
					},
					{
						"n": 5,
						"h": 340,
						"w": 56
					},
					{
						"n": 6,
						"h": 167,
						"w": 123
					},
					{
						"n": 7,
						"h": 263,
						"w": 178
					},
					{
						"n": 8,
						"h": 415,
						"w": 168
					},
					{
						"n": 9,
						"h": 22,
						"w": 204
					},
					{
						"n": 10,
						"h": 141,
						"w": 247
					},
					{
						"n": 11,
						"h": 295,
						"w": 296
					}
				],
				"ball": {
					"n": 0,
					"h": 378,
					"w": 620,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 24
		},
		{
			"num": 756,
			"minute": 37,
			"messages": [
				{
					"owner": 1,
					"mes": "Э.Бвомоно[09](Галвэй Юнайтед) смещается в центр..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 18
					},
					{
						"n": 2,
						"h": 72,
						"w": 371
					},
					{
						"n": 3,
						"h": 167,
						"w": 323
					},
					{
						"n": 4,
						"h": 281,
						"w": 329
					},
					{
						"n": 5,
						"h": 390,
						"w": 367
					},
					{
						"n": 6,
						"h": 56,
						"w": 641
					},
					{
						"n": 7,
						"h": 176,
						"w": 573
					},
					{
						"n": 8,
						"h": 286,
						"w": 450
					},
					{
						"n": 9,
						"h": 343,
						"w": 602
					},
					{
						"n": 10,
						"h": 176,
						"w": 641
					},
					{
						"n": 11,
						"h": 305,
						"w": 607
					}
				],
				"away": [
					{
						"n": 1,
						"h": 214,
						"w": 11
					},
					{
						"n": 2,
						"h": 120,
						"w": 93
					},
					{
						"n": 3,
						"h": 156,
						"w": 49
					},
					{
						"n": 4,
						"h": 260,
						"w": 60
					},
					{
						"n": 5,
						"h": 340,
						"w": 58
					},
					{
						"n": 6,
						"h": 126,
						"w": 105
					},
					{
						"n": 7,
						"h": 273,
						"w": 143
					},
					{
						"n": 8,
						"h": 431,
						"w": 159
					},
					{
						"n": 9,
						"h": 29,
						"w": 209
					},
					{
						"n": 10,
						"h": 164,
						"w": 250
					},
					{
						"n": 11,
						"h": 292,
						"w": 300
					}
				],
				"ball": {
					"n": 0,
					"h": 343,
					"w": 602,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 37
		},
		{
			"num": 757,
			"minute": 37,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 10
					},
					{
						"n": 2,
						"h": 78,
						"w": 367
					},
					{
						"n": 3,
						"h": 178,
						"w": 310
					},
					{
						"n": 4,
						"h": 284,
						"w": 311
					},
					{
						"n": 5,
						"h": 386,
						"w": 371
					},
					{
						"n": 6,
						"h": 48,
						"w": 635
					},
					{
						"n": 7,
						"h": 167,
						"w": 556
					},
					{
						"n": 8,
						"h": 285,
						"w": 469
					},
					{
						"n": 9,
						"h": 343,
						"w": 618
					},
					{
						"n": 10,
						"h": 166,
						"w": 636
					},
					{
						"n": 11,
						"h": 290,
						"w": 618
					}
				],
				"away": [
					{
						"n": 1,
						"h": 214,
						"w": 10
					},
					{
						"n": 2,
						"h": 138,
						"w": 82
					},
					{
						"n": 3,
						"h": 175,
						"w": 53
					},
					{
						"n": 4,
						"h": 267,
						"w": 77
					},
					{
						"n": 5,
						"h": 340,
						"w": 52
					},
					{
						"n": 6,
						"h": 107,
						"w": 102
					},
					{
						"n": 7,
						"h": 276,
						"w": 131
					},
					{
						"n": 8,
						"h": 432,
						"w": 162
					},
					{
						"n": 9,
						"h": 45,
						"w": 212
					},
					{
						"n": 10,
						"h": 165,
						"w": 231
					},
					{
						"n": 11,
						"h": 275,
						"w": 306
					}
				],
				"ball": {
					"n": 0,
					"h": 343,
					"w": 618,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 19
		},
		{
			"num": 758,
			"minute": 37,
			"messages": [
				{
					"owner": 1,
					"mes": "Элвис Бвомоно[09](Галвэй Юнайтед) технично обыгрывает О.Дюмона[26](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 18
					},
					{
						"n": 2,
						"h": 63,
						"w": 375
					},
					{
						"n": 3,
						"h": 182,
						"w": 328
					},
					{
						"n": 4,
						"h": 269,
						"w": 328
					},
					{
						"n": 5,
						"h": 377,
						"w": 375
					},
					{
						"n": 6,
						"h": 52,
						"w": 640
					},
					{
						"n": 7,
						"h": 176,
						"w": 595
					},
					{
						"n": 8,
						"h": 300,
						"w": 432
					},
					{
						"n": 9,
						"h": 343,
						"w": 658,
						"m": 750
					},
					{
						"n": 10,
						"h": 168,
						"w": 670
					},
					{
						"n": 11,
						"h": 251,
						"w": 628
					}
				],
				"away": [
					{
						"n": 1,
						"h": 216,
						"w": 5
					},
					{
						"n": 2,
						"h": 107,
						"w": 57
					},
					{
						"n": 3,
						"h": 195,
						"w": 51
					},
					{
						"n": 4,
						"h": 258,
						"w": 31
					},
					{
						"n": 5,
						"h": 340,
						"w": 36
					},
					{
						"n": 6,
						"h": 98,
						"w": 101,
						"m": 630
					},
					{
						"n": 7,
						"h": 237,
						"w": 122
					},
					{
						"n": 8,
						"h": 422,
						"w": 140
					},
					{
						"n": 9,
						"h": 24,
						"w": 190
					},
					{
						"n": 10,
						"h": 150,
						"w": 268
					},
					{
						"n": 11,
						"h": 275,
						"w": 305
					}
				],
				"ball": {
					"n": 0,
					"h": 343,
					"w": 658,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 759,
			"minute": 37,
			"messages": [
				{
					"owner": 1,
					"mes": "Э.Бвомоно[09](Галвэй Юнайтед) делает передачу А.Гилберту[11](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 14
					},
					{
						"n": 2,
						"h": 68,
						"w": 371
					},
					{
						"n": 3,
						"h": 175,
						"w": 330
					},
					{
						"n": 4,
						"h": 285,
						"w": 324
					},
					{
						"n": 5,
						"h": 383,
						"w": 377
					},
					{
						"n": 6,
						"h": 42,
						"w": 655
					},
					{
						"n": 7,
						"h": 172,
						"w": 563
					},
					{
						"n": 8,
						"h": 294,
						"w": 463
					},
					{
						"n": 9,
						"h": 351,
						"w": 652
					},
					{
						"n": 10,
						"h": 170,
						"w": 665
					},
					{
						"n": 11,
						"h": 282,
						"w": 636
					}
				],
				"away": [
					{
						"n": 1,
						"h": 217,
						"w": 12
					},
					{
						"n": 2,
						"h": 107,
						"w": 50
					},
					{
						"n": 3,
						"h": 175,
						"w": 76
					},
					{
						"n": 4,
						"h": 269,
						"w": 26
					},
					{
						"n": 5,
						"h": 340,
						"w": 33
					},
					{
						"n": 6,
						"h": 130,
						"w": 101
					},
					{
						"n": 7,
						"h": 228,
						"w": 153
					},
					{
						"n": 8,
						"h": 425,
						"w": 140
					},
					{
						"n": 9,
						"h": 48,
						"w": 190
					},
					{
						"n": 10,
						"h": 156,
						"w": 237
					},
					{
						"n": 11,
						"h": 290,
						"w": 310
					}
				],
				"ball": {
					"n": 0,
					"h": 282,
					"w": 636,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 32
		},
		{
			"num": 760,
			"minute": 37,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 19
					},
					{
						"n": 2,
						"h": 61,
						"w": 370
					},
					{
						"n": 3,
						"h": 172,
						"w": 324
					},
					{
						"n": 4,
						"h": 278,
						"w": 322
					},
					{
						"n": 5,
						"h": 385,
						"w": 370
					},
					{
						"n": 6,
						"h": 49,
						"w": 658
					},
					{
						"n": 7,
						"h": 171,
						"w": 570
					},
					{
						"n": 8,
						"h": 290,
						"w": 458
					},
					{
						"n": 9,
						"h": 356,
						"w": 656
					},
					{
						"n": 10,
						"h": 167,
						"w": 670
					},
					{
						"n": 11,
						"h": 282,
						"w": 642
					}
				],
				"away": [
					{
						"n": 1,
						"h": 216,
						"w": 12
					},
					{
						"n": 2,
						"h": 102,
						"w": 54
					},
					{
						"n": 3,
						"h": 168,
						"w": 78
					},
					{
						"n": 4,
						"h": 269,
						"w": 33
					},
					{
						"n": 5,
						"h": 340,
						"w": 31
					},
					{
						"n": 6,
						"h": 138,
						"w": 101
					},
					{
						"n": 7,
						"h": 226,
						"w": 151
					},
					{
						"n": 8,
						"h": 418,
						"w": 140
					},
					{
						"n": 9,
						"h": 41,
						"w": 190
					},
					{
						"n": 10,
						"h": 160,
						"w": 242
					},
					{
						"n": 11,
						"h": 283,
						"w": 309
					}
				],
				"ball": {
					"n": 0,
					"h": 282,
					"w": 642,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 7
		},
		{
			"num": 761,
			"minute": 37,
			"messages": [
				{
					"owner": 1,
					"mes": "Адам Гилберт[11](Галвэй Юнайтед) сближается с Н.Мансуром[23](Опава)..."
				},
				{
					"owner": 1,
					"mes": "Прекрасную технику демонстрирует Адам Гилберт[11](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 13
					},
					{
						"n": 2,
						"h": 62,
						"w": 377
					},
					{
						"n": 3,
						"h": 180,
						"w": 324
					},
					{
						"n": 4,
						"h": 265,
						"w": 311
					},
					{
						"n": 5,
						"h": 389,
						"w": 375
					},
					{
						"n": 6,
						"h": 50,
						"w": 655
					},
					{
						"n": 7,
						"h": 162,
						"w": 609
					},
					{
						"n": 8,
						"h": 278,
						"w": 444
					},
					{
						"n": 9,
						"h": 366,
						"w": 655
					},
					{
						"n": 10,
						"h": 201,
						"w": 649
					},
					{
						"n": 11,
						"h": 242,
						"w": 642,
						"m": 830
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 15
					},
					{
						"n": 2,
						"h": 90,
						"w": 56
					},
					{
						"n": 3,
						"h": 168,
						"w": 78,
						"m": 580
					},
					{
						"n": 4,
						"h": 251,
						"w": 62
					},
					{
						"n": 5,
						"h": 376,
						"w": 49
					},
					{
						"n": 6,
						"h": 183,
						"w": 83
					},
					{
						"n": 7,
						"h": 258,
						"w": 127
					},
					{
						"n": 8,
						"h": 399,
						"w": 146
					},
					{
						"n": 9,
						"h": 17,
						"w": 196
					},
					{
						"n": 10,
						"h": 172,
						"w": 256
					},
					{
						"n": 11,
						"h": 287,
						"w": 307
					}
				],
				"ball": {
					"n": 0,
					"h": 242,
					"w": 642,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 4
				}
			},
			"interval": 40
		},
		{
			"num": 762,
			"minute": 37,
			"messages": [
				{
					"owner": 1,
					"mes": "Удар по воротам..."
				},
				{
					"owner": 1,
					"mes": "Крыштоф Ласак[21](Опава) с трудом переводит мяч на угловой..."
				}
			],
			"U": {
				"team": 1,
				"player": 11,
				"xg": "0.20"
			},
			"V": {
				"team": 1,
				"player": 11
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 13
					},
					{
						"n": 2,
						"h": 73,
						"w": 370
					},
					{
						"n": 3,
						"h": 169,
						"w": 317
					},
					{
						"n": 4,
						"h": 277,
						"w": 316
					},
					{
						"n": 5,
						"h": 384,
						"w": 375
					},
					{
						"n": 6,
						"h": 41,
						"w": 646
					},
					{
						"n": 7,
						"h": 159,
						"w": 621
					},
					{
						"n": 8,
						"h": 279,
						"w": 457
					},
					{
						"n": 9,
						"h": 375,
						"w": 646
					},
					{
						"n": 10,
						"h": 191,
						"w": 658
					},
					{
						"n": 11,
						"h": 242,
						"w": 642,
						"m": 840
					}
				],
				"away": [
					{
						"n": 1,
						"h": 210,
						"w": 15,
						"m": 620
					},
					{
						"n": 2,
						"h": 79,
						"w": 59
					},
					{
						"n": 3,
						"h": 181,
						"w": 72
					},
					{
						"n": 4,
						"h": 236,
						"w": 63
					},
					{
						"n": 5,
						"h": 375,
						"w": 51
					},
					{
						"n": 6,
						"h": 198,
						"w": 78
					},
					{
						"n": 7,
						"h": 258,
						"w": 114
					},
					{
						"n": 8,
						"h": 394,
						"w": 134
					},
					{
						"n": 9,
						"h": 30,
						"w": 194
					},
					{
						"n": 10,
						"h": 171,
						"w": 243
					},
					{
						"n": 11,
						"h": 293,
						"w": 306
					}
				],
				"ball": {
					"n": 0,
					"h": 240,
					"w": 705,
					"z": 1,
					"r": 0,
					"p": 1,
					"x": 6
				}
			},
			"interval": 13
		},
		{
			"num": 763,
			"minute": 37,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 13
					},
					{
						"n": 2,
						"h": 73,
						"w": 370
					},
					{
						"n": 3,
						"h": 169,
						"w": 317
					},
					{
						"n": 4,
						"h": 277,
						"w": 316
					},
					{
						"n": 5,
						"h": 384,
						"w": 375
					},
					{
						"n": 6,
						"h": 41,
						"w": 646
					},
					{
						"n": 7,
						"h": 159,
						"w": 621
					},
					{
						"n": 8,
						"h": 279,
						"w": 457
					},
					{
						"n": 9,
						"h": 375,
						"w": 646
					},
					{
						"n": 10,
						"h": 191,
						"w": 658
					},
					{
						"n": 11,
						"h": 242,
						"w": 642
					}
				],
				"away": [
					{
						"n": 1,
						"h": 205,
						"w": 15,
						"m": 630
					},
					{
						"n": 2,
						"h": 79,
						"w": 59
					},
					{
						"n": 3,
						"h": 181,
						"w": 72
					},
					{
						"n": 4,
						"h": 236,
						"w": 63
					},
					{
						"n": 5,
						"h": 375,
						"w": 51
					},
					{
						"n": 6,
						"h": 198,
						"w": 78
					},
					{
						"n": 7,
						"h": 258,
						"w": 114
					},
					{
						"n": 8,
						"h": 394,
						"w": 134
					},
					{
						"n": 9,
						"h": 30,
						"w": 194
					},
					{
						"n": 10,
						"h": 171,
						"w": 243
					},
					{
						"n": 11,
						"h": 293,
						"w": 306
					}
				],
				"ball": {
					"n": 0,
					"h": 285,
					"w": 730,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 20
		},
		{
			"num": 764,
			"minute": 37,
			"messages": [
				{
					"owner": 1,
					"mes": "Судья назначает угловой удар..."
				}
			],
			"C": {
				"team": 1
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 40
					},
					{
						"n": 2,
						"h": 230,
						"w": 648
					},
					{
						"n": 3,
						"h": 458,
						"w": 704
					},
					{
						"n": 4,
						"h": 240,
						"w": 660
					},
					{
						"n": 5,
						"h": 215,
						"w": 672
					},
					{
						"n": 6,
						"h": 150,
						"w": 300
					},
					{
						"n": 7,
						"h": 225,
						"w": 600
					},
					{
						"n": 8,
						"h": 225,
						"w": 460
					},
					{
						"n": 9,
						"h": 300,
						"w": 300
					},
					{
						"n": 10,
						"h": 190,
						"w": 660
					},
					{
						"n": 11,
						"h": 260,
						"w": 680
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 10
					},
					{
						"n": 2,
						"h": 225,
						"w": 110
					},
					{
						"n": 3,
						"h": 235,
						"w": 38
					},
					{
						"n": 4,
						"h": 190,
						"w": 30
					},
					{
						"n": 5,
						"h": 245,
						"w": 50
					},
					{
						"n": 6,
						"h": 220,
						"w": 62
					},
					{
						"n": 7,
						"h": 260,
						"w": 50
					},
					{
						"n": 8,
						"h": 225,
						"w": 245
					},
					{
						"n": 9,
						"h": 210,
						"w": 50
					},
					{
						"n": 10,
						"h": 175,
						"w": 40
					},
					{
						"n": 11,
						"h": 150,
						"w": 400
					}
				],
				"ball": {
					"n": 0,
					"h": 450,
					"w": 720,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 100
		},
		{
			"num": 765,
			"minute": 37,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 40
					},
					{
						"n": 2,
						"h": 234,
						"w": 644
					},
					{
						"n": 3,
						"h": 450,
						"w": 720
					},
					{
						"n": 4,
						"h": 233,
						"w": 658
					},
					{
						"n": 5,
						"h": 216,
						"w": 679
					},
					{
						"n": 6,
						"h": 152,
						"w": 298
					},
					{
						"n": 7,
						"h": 220,
						"w": 605
					},
					{
						"n": 8,
						"h": 227,
						"w": 453
					},
					{
						"n": 9,
						"h": 293,
						"w": 296
					},
					{
						"n": 10,
						"h": 186,
						"w": 667
					},
					{
						"n": 11,
						"h": 261,
						"w": 684
					}
				],
				"away": [
					{
						"n": 1,
						"h": 223,
						"w": 20
					},
					{
						"n": 2,
						"h": 222,
						"w": 104
					},
					{
						"n": 3,
						"h": 236,
						"w": 32
					},
					{
						"n": 4,
						"h": 187,
						"w": 36
					},
					{
						"n": 5,
						"h": 243,
						"w": 57
					},
					{
						"n": 6,
						"h": 220,
						"w": 58
					},
					{
						"n": 7,
						"h": 259,
						"w": 47
					},
					{
						"n": 8,
						"h": 222,
						"w": 250
					},
					{
						"n": 9,
						"h": 203,
						"w": 43
					},
					{
						"n": 10,
						"h": 177,
						"w": 33
					},
					{
						"n": 11,
						"h": 151,
						"w": 398
					}
				],
				"ball": {
					"n": 0,
					"h": 450,
					"w": 720,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 15
		},
		{
			"num": 766,
			"minute": 37,
			"messages": [
				{
					"owner": 1,
					"mes": "К мячу подходит Патрик Клинтон[03](Галвэй Юнайтед)..."
				},
				{
					"owner": 1,
					"mes": "П.Клинтон[03](Галвэй Юнайтед) закидывает мяч в штрафную..."
				},
				{
					"owner": 1,
					"mes": "Себастьян Пейша[24](Опава) выносит мяч головой..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 13
					},
					{
						"n": 2,
						"h": 237,
						"w": 653
					},
					{
						"n": 3,
						"h": 448,
						"w": 715
					},
					{
						"n": 4,
						"h": 223,
						"w": 656
					},
					{
						"n": 5,
						"h": 226,
						"w": 687
					},
					{
						"n": 6,
						"h": 172,
						"w": 328
					},
					{
						"n": 7,
						"h": 205,
						"w": 580
					},
					{
						"n": 8,
						"h": 241,
						"w": 472
					},
					{
						"n": 9,
						"h": 284,
						"w": 322
					},
					{
						"n": 10,
						"h": 182,
						"w": 669
					},
					{
						"n": 11,
						"h": 253,
						"w": 677
					}
				],
				"away": [
					{
						"n": 1,
						"h": 228,
						"w": 7
					},
					{
						"n": 2,
						"h": 201,
						"w": 104
					},
					{
						"n": 3,
						"h": 229,
						"w": 23
					},
					{
						"n": 4,
						"h": 189,
						"w": 41
					},
					{
						"n": 5,
						"h": 253,
						"w": 54
					},
					{
						"n": 6,
						"h": 209,
						"w": 64
					},
					{
						"n": 7,
						"h": 277,
						"w": 42
					},
					{
						"n": 8,
						"h": 210,
						"w": 213
					},
					{
						"n": 9,
						"h": 236,
						"w": 60
					},
					{
						"n": 10,
						"h": 182,
						"w": 36
					},
					{
						"n": 11,
						"h": 189,
						"w": 390
					}
				],
				"ball": {
					"n": 0,
					"h": 261,
					"w": 679,
					"z": 1,
					"r": 2,
					"p": 4,
					"x": 1
				}
			},
			"interval": 39
		},
		{
			"num": 767,
			"minute": 37,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 10
					},
					{
						"n": 2,
						"h": 216,
						"w": 616
					},
					{
						"n": 3,
						"h": 424,
						"w": 681
					},
					{
						"n": 4,
						"h": 225,
						"w": 614
					},
					{
						"n": 5,
						"h": 245,
						"w": 650
					},
					{
						"n": 6,
						"h": 181,
						"w": 337
					},
					{
						"n": 7,
						"h": 166,
						"w": 562
					},
					{
						"n": 8,
						"h": 287,
						"w": 478
					},
					{
						"n": 9,
						"h": 283,
						"w": 335
					},
					{
						"n": 10,
						"h": 179,
						"w": 632
					},
					{
						"n": 11,
						"h": 283,
						"w": 648
					}
				],
				"away": [
					{
						"n": 1,
						"h": 228,
						"w": 14
					},
					{
						"n": 2,
						"h": 180,
						"w": 67
					},
					{
						"n": 3,
						"h": 202,
						"w": 51
					},
					{
						"n": 4,
						"h": 191,
						"w": 41,
						"m": 700
					},
					{
						"n": 5,
						"h": 270,
						"w": 68
					},
					{
						"n": 6,
						"h": 233,
						"w": 80
					},
					{
						"n": 7,
						"h": 243,
						"w": 68
					},
					{
						"n": 8,
						"h": 162,
						"w": 220
					},
					{
						"n": 9,
						"h": 201,
						"w": 84
					},
					{
						"n": 10,
						"h": 174,
						"w": 77
					},
					{
						"n": 11,
						"h": 229,
						"w": 377
					}
				],
				"ball": {
					"n": 0,
					"h": 341,
					"w": 532,
					"z": 1,
					"r": 0,
					"p": 1,
					"x": 0
				}
			},
			"interval": 42
		},
		{
			"num": 768,
			"minute": 37,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 11
					},
					{
						"n": 2,
						"h": 209,
						"w": 605
					},
					{
						"n": 3,
						"h": 417,
						"w": 670
					},
					{
						"n": 4,
						"h": 229,
						"w": 601
					},
					{
						"n": 5,
						"h": 251,
						"w": 638
					},
					{
						"n": 6,
						"h": 174,
						"w": 332
					},
					{
						"n": 7,
						"h": 167,
						"w": 549
					},
					{
						"n": 8,
						"h": 302,
						"w": 480
					},
					{
						"n": 9,
						"h": 280,
						"w": 340
					},
					{
						"n": 10,
						"h": 174,
						"w": 632
					},
					{
						"n": 11,
						"h": 291,
						"w": 637
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 10
					},
					{
						"n": 2,
						"h": 168,
						"w": 65
					},
					{
						"n": 3,
						"h": 204,
						"w": 56
					},
					{
						"n": 4,
						"h": 202,
						"w": 48
					},
					{
						"n": 5,
						"h": 275,
						"w": 80
					},
					{
						"n": 6,
						"h": 229,
						"w": 80
					},
					{
						"n": 7,
						"h": 239,
						"w": 80
					},
					{
						"n": 8,
						"h": 148,
						"w": 222
					},
					{
						"n": 9,
						"h": 191,
						"w": 92
					},
					{
						"n": 10,
						"h": 173,
						"w": 90
					},
					{
						"n": 11,
						"h": 236,
						"w": 366
					}
				],
				"ball": {
					"n": 0,
					"h": 365,
					"w": 488,
					"z": 0,
					"r": 0,
					"p": 1,
					"x": 0
				}
			},
			"interval": 13
		},
		{
			"num": 769,
			"minute": 37,
			"messages": [
				{
					"owner": 1,
					"mes": "Киран Нолан[08](Галвэй Юнайтед) подхватывает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 19
					},
					{
						"n": 2,
						"h": 178,
						"w": 559
					},
					{
						"n": 3,
						"h": 384,
						"w": 625
					},
					{
						"n": 4,
						"h": 237,
						"w": 546
					},
					{
						"n": 5,
						"h": 276,
						"w": 588
					},
					{
						"n": 6,
						"h": 182,
						"w": 322
					},
					{
						"n": 7,
						"h": 188,
						"w": 497
					},
					{
						"n": 8,
						"h": 373,
						"w": 473
					},
					{
						"n": 9,
						"h": 273,
						"w": 321
					},
					{
						"n": 10,
						"h": 151,
						"w": 636
					},
					{
						"n": 11,
						"h": 282,
						"w": 629
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 15
					},
					{
						"n": 2,
						"h": 112,
						"w": 74
					},
					{
						"n": 3,
						"h": 185,
						"w": 68
					},
					{
						"n": 4,
						"h": 234,
						"w": 71
					},
					{
						"n": 5,
						"h": 282,
						"w": 75
					},
					{
						"n": 6,
						"h": 173,
						"w": 80
					},
					{
						"n": 7,
						"h": 183,
						"w": 87
					},
					{
						"n": 8,
						"h": 87,
						"w": 243
					},
					{
						"n": 9,
						"h": 136,
						"w": 84
					},
					{
						"n": 10,
						"h": 163,
						"w": 110
					},
					{
						"n": 11,
						"h": 271,
						"w": 322
					}
				],
				"ball": {
					"n": 0,
					"h": 373,
					"w": 473,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 56
		},
		{
			"num": 770,
			"minute": 38,
			"possession": 45,
			"messages": [
				{
					"owner": 1,
					"mes": "К.Нолан[08](Галвэй Юнайтед) отдает передачу П.Клинтону[03](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 11
					},
					{
						"n": 2,
						"h": 158,
						"w": 524,
						"f": 88
					},
					{
						"n": 3,
						"h": 362,
						"w": 592
					},
					{
						"n": 4,
						"h": 246,
						"w": 507
					},
					{
						"n": 5,
						"h": 295,
						"w": 553,
						"f": 88,
						"m": 620
					},
					{
						"n": 6,
						"h": 176,
						"w": 330
					},
					{
						"n": 7,
						"h": 199,
						"w": 459
					},
					{
						"n": 8,
						"h": 364,
						"w": 478
					},
					{
						"n": 9,
						"h": 273,
						"w": 324,
						"f": 86
					},
					{
						"n": 10,
						"h": 166,
						"w": 635
					},
					{
						"n": 11,
						"h": 285,
						"w": 637,
						"f": 87
					}
				],
				"away": [
					{
						"n": 1,
						"h": 214,
						"w": 10
					},
					{
						"n": 2,
						"h": 96,
						"w": 108
					},
					{
						"n": 3,
						"h": 181,
						"w": 64
					},
					{
						"n": 4,
						"h": 270,
						"w": 77
					},
					{
						"n": 5,
						"h": 320,
						"w": 63,
						"f": 87
					},
					{
						"n": 6,
						"h": 153,
						"w": 114
					},
					{
						"n": 7,
						"h": 192,
						"w": 126
					},
					{
						"n": 8,
						"h": 124,
						"w": 228
					},
					{
						"n": 9,
						"h": 122,
						"w": 98,
						"f": 87
					},
					{
						"n": 10,
						"h": 162,
						"w": 150
					},
					{
						"n": 11,
						"h": 261,
						"w": 283,
						"m": 620
					}
				],
				"ball": {
					"n": 0,
					"h": 362,
					"w": 592,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 771,
			"minute": 38,
			"messages": [
				{
					"owner": 1,
					"mes": "П.Клинтон[03](Галвэй Юнайтед) смещается в центр..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 11
					},
					{
						"n": 2,
						"h": 136,
						"w": 491
					},
					{
						"n": 3,
						"h": 325,
						"w": 577
					},
					{
						"n": 4,
						"h": 253,
						"w": 468
					},
					{
						"n": 5,
						"h": 314,
						"w": 518
					},
					{
						"n": 6,
						"h": 182,
						"w": 328
					},
					{
						"n": 7,
						"h": 186,
						"w": 421
					},
					{
						"n": 8,
						"h": 343,
						"w": 512
					},
					{
						"n": 9,
						"h": 268,
						"w": 338
					},
					{
						"n": 10,
						"h": 154,
						"w": 637
					},
					{
						"n": 11,
						"h": 290,
						"w": 636
					}
				],
				"away": [
					{
						"n": 1,
						"h": 216,
						"w": 12
					},
					{
						"n": 2,
						"h": 140,
						"w": 118
					},
					{
						"n": 3,
						"h": 175,
						"w": 66
					},
					{
						"n": 4,
						"h": 276,
						"w": 67
					},
					{
						"n": 5,
						"h": 340,
						"w": 67
					},
					{
						"n": 6,
						"h": 191,
						"w": 124
					},
					{
						"n": 7,
						"h": 207,
						"w": 163
					},
					{
						"n": 8,
						"h": 164,
						"w": 223
					},
					{
						"n": 9,
						"h": 82,
						"w": 98
					},
					{
						"n": 10,
						"h": 129,
						"w": 126
					},
					{
						"n": 11,
						"h": 264,
						"w": 279
					}
				],
				"ball": {
					"n": 0,
					"h": 325,
					"w": 577,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 772,
			"minute": 38,
			"messages": [
				{
					"owner": 1,
					"mes": "П.Клинтон[03](Галвэй Юнайтед) стелящимся пасом отдает мяч С.Фридйонссону[05](Галвэй Юнайтед)..."
				},
				{
					"owner": 1,
					"mes": "Самуэль Кари Фридйонссон[05](Галвэй Юнайтед) подрабатывает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 12
					},
					{
						"n": 2,
						"h": 124,
						"w": 471
					},
					{
						"n": 3,
						"h": 325,
						"w": 577,
						"m": 650
					},
					{
						"n": 4,
						"h": 257,
						"w": 445
					},
					{
						"n": 5,
						"h": 297,
						"w": 540
					},
					{
						"n": 6,
						"h": 182,
						"w": 313
					},
					{
						"n": 7,
						"h": 183,
						"w": 444
					},
					{
						"n": 8,
						"h": 335,
						"w": 534
					},
					{
						"n": 9,
						"h": 272,
						"w": 326
					},
					{
						"n": 10,
						"h": 168,
						"w": 632
					},
					{
						"n": 11,
						"h": 277,
						"w": 634
					}
				],
				"away": [
					{
						"n": 1,
						"h": 219,
						"w": 14
					},
					{
						"n": 2,
						"h": 124,
						"w": 103
					},
					{
						"n": 3,
						"h": 192,
						"w": 72
					},
					{
						"n": 4,
						"h": 269,
						"w": 81
					},
					{
						"n": 5,
						"h": 340,
						"w": 67
					},
					{
						"n": 6,
						"h": 168,
						"w": 124
					},
					{
						"n": 7,
						"h": 184,
						"w": 162
					},
					{
						"n": 8,
						"h": 186,
						"w": 217
					},
					{
						"n": 9,
						"h": 75,
						"w": 120
					},
					{
						"n": 10,
						"h": 140,
						"w": 147
					},
					{
						"n": 11,
						"h": 267,
						"w": 256
					}
				],
				"ball": {
					"n": 0,
					"h": 297,
					"w": 540,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 23
		},
		{
			"num": 773,
			"minute": 38,
			"messages": [
				{
					"owner": 1,
					"mes": "С.Фридйонссон[05](Галвэй Юнайтед) стелящимся пасом отдает мяч К.Нолану[08](Галвэй Юнайтед)..."
				},
				{
					"owner": 1,
					"mes": "Киран Нолан[08](Галвэй Юнайтед) принимает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 15
					},
					{
						"n": 2,
						"h": 114,
						"w": 455
					},
					{
						"n": 3,
						"h": 313,
						"w": 562
					},
					{
						"n": 4,
						"h": 261,
						"w": 426
					},
					{
						"n": 5,
						"h": 301,
						"w": 532
					},
					{
						"n": 6,
						"h": 168,
						"w": 321
					},
					{
						"n": 7,
						"h": 181,
						"w": 463
					},
					{
						"n": 8,
						"h": 321,
						"w": 547
					},
					{
						"n": 9,
						"h": 278,
						"w": 325
					},
					{
						"n": 10,
						"h": 157,
						"w": 644
					},
					{
						"n": 11,
						"h": 294,
						"w": 643
					}
				],
				"away": [
					{
						"n": 1,
						"h": 218,
						"w": 13
					},
					{
						"n": 2,
						"h": 118,
						"w": 85
					},
					{
						"n": 3,
						"h": 178,
						"w": 60
					},
					{
						"n": 4,
						"h": 271,
						"w": 63
					},
					{
						"n": 5,
						"h": 340,
						"w": 58
					},
					{
						"n": 6,
						"h": 167,
						"w": 132
					},
					{
						"n": 7,
						"h": 203,
						"w": 164
					},
					{
						"n": 8,
						"h": 205,
						"w": 212
					},
					{
						"n": 9,
						"h": 56,
						"w": 120
					},
					{
						"n": 10,
						"h": 133,
						"w": 165
					},
					{
						"n": 11,
						"h": 269,
						"w": 237
					}
				],
				"ball": {
					"n": 0,
					"h": 321,
					"w": 547,
					"z": 0,
					"r": 0,
					"p": 1,
					"x": 0
				}
			},
			"interval": 19
		},
		{
			"num": 774,
			"minute": 38,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 15
					},
					{
						"n": 2,
						"h": 101,
						"w": 436
					},
					{
						"n": 3,
						"h": 299,
						"w": 544
					},
					{
						"n": 4,
						"h": 264,
						"w": 404
					},
					{
						"n": 5,
						"h": 313,
						"w": 512
					},
					{
						"n": 6,
						"h": 172,
						"w": 337
					},
					{
						"n": 7,
						"h": 180,
						"w": 486
					},
					{
						"n": 8,
						"h": 337,
						"w": 531
					},
					{
						"n": 9,
						"h": 266,
						"w": 331
					},
					{
						"n": 10,
						"h": 157,
						"w": 644
					},
					{
						"n": 11,
						"h": 275,
						"w": 644
					}
				],
				"away": [
					{
						"n": 1,
						"h": 212,
						"w": 8
					},
					{
						"n": 2,
						"h": 114,
						"w": 62
					},
					{
						"n": 3,
						"h": 195,
						"w": 48
					},
					{
						"n": 4,
						"h": 279,
						"w": 53
					},
					{
						"n": 5,
						"h": 340,
						"w": 35
					},
					{
						"n": 6,
						"h": 177,
						"w": 112
					},
					{
						"n": 7,
						"h": 202,
						"w": 166
					},
					{
						"n": 8,
						"h": 226,
						"w": 205
					},
					{
						"n": 9,
						"h": 45,
						"w": 140
					},
					{
						"n": 10,
						"h": 113,
						"w": 169
					},
					{
						"n": 11,
						"h": 291,
						"w": 245
					}
				],
				"ball": {
					"n": 0,
					"h": 337,
					"w": 531,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 23
		},
		{
			"num": 775,
			"minute": 38,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 12
					},
					{
						"n": 2,
						"h": 90,
						"w": 419
					},
					{
						"n": 3,
						"h": 289,
						"w": 526
					},
					{
						"n": 4,
						"h": 267,
						"w": 384
					},
					{
						"n": 5,
						"h": 321,
						"w": 494
					},
					{
						"n": 6,
						"h": 171,
						"w": 328
					},
					{
						"n": 7,
						"h": 174,
						"w": 505
					},
					{
						"n": 8,
						"h": 357,
						"w": 535
					},
					{
						"n": 9,
						"h": 280,
						"w": 317
					},
					{
						"n": 10,
						"h": 170,
						"w": 659
					},
					{
						"n": 11,
						"h": 285,
						"w": 661
					}
				],
				"away": [
					{
						"n": 1,
						"h": 212,
						"w": 7
					},
					{
						"n": 2,
						"h": 111,
						"w": 42
					},
					{
						"n": 3,
						"h": 179,
						"w": 36
					},
					{
						"n": 4,
						"h": 271,
						"w": 35
					},
					{
						"n": 5,
						"h": 340,
						"w": 46
					},
					{
						"n": 6,
						"h": 158,
						"w": 110
					},
					{
						"n": 7,
						"h": 204,
						"w": 148
					},
					{
						"n": 8,
						"h": 245,
						"w": 199
					},
					{
						"n": 9,
						"h": 34,
						"w": 140
					},
					{
						"n": 10,
						"h": 103,
						"w": 167
					},
					{
						"n": 11,
						"h": 309,
						"w": 254
					}
				],
				"ball": {
					"n": 0,
					"h": 357,
					"w": 535,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 20
		},
		{
			"num": 776,
			"minute": 38,
			"messages": [
				{
					"owner": 1,
					"mes": "Киран Нолан[08](Галвэй Юнайтед) делает передачу в штрафную..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 19
					},
					{
						"n": 2,
						"h": 81,
						"w": 397
					},
					{
						"n": 3,
						"h": 278,
						"w": 505
					},
					{
						"n": 4,
						"h": 274,
						"w": 361
					},
					{
						"n": 5,
						"h": 331,
						"w": 472
					},
					{
						"n": 6,
						"h": 170,
						"w": 311
					},
					{
						"n": 7,
						"h": 169,
						"w": 528
					},
					{
						"n": 8,
						"h": 349,
						"w": 540,
						"m": 600
					},
					{
						"n": 9,
						"h": 296,
						"w": 299
					},
					{
						"n": 10,
						"h": 188,
						"w": 644,
						"m": 740
					},
					{
						"n": 11,
						"h": 278,
						"w": 680
					}
				],
				"away": [
					{
						"n": 1,
						"h": 232,
						"w": 13
					},
					{
						"n": 2,
						"h": 135,
						"w": 41
					},
					{
						"n": 3,
						"h": 191,
						"w": 33
					},
					{
						"n": 4,
						"h": 258,
						"w": 55
					},
					{
						"n": 5,
						"h": 340,
						"w": 36
					},
					{
						"n": 6,
						"h": 181,
						"w": 107
					},
					{
						"n": 7,
						"h": 180,
						"w": 143
					},
					{
						"n": 8,
						"h": 268,
						"w": 191
					},
					{
						"n": 9,
						"h": 31,
						"w": 164
					},
					{
						"n": 10,
						"h": 109,
						"w": 190
					},
					{
						"n": 11,
						"h": 295,
						"w": 274
					}
				],
				"ball": {
					"n": 0,
					"h": 270,
					"w": 577,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 24
		},
		{
			"num": 777,
			"minute": 38,
			"messages": [
				{
					"owner": 1,
					"mes": "Мирослав Манолов[27](Опава) делает важный перехват..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 18
					},
					{
						"n": 2,
						"h": 115,
						"w": 375
					},
					{
						"n": 3,
						"h": 259,
						"w": 470
					},
					{
						"n": 4,
						"h": 279,
						"w": 321
					},
					{
						"n": 5,
						"h": 337,
						"w": 432
					},
					{
						"n": 6,
						"h": 178,
						"w": 296
					},
					{
						"n": 7,
						"h": 206,
						"w": 544
					},
					{
						"n": 8,
						"h": 323,
						"w": 510
					},
					{
						"n": 9,
						"h": 277,
						"w": 294
					},
					{
						"n": 10,
						"h": 187,
						"w": 604
					},
					{
						"n": 11,
						"h": 274,
						"w": 640
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 14
					},
					{
						"n": 2,
						"h": 117,
						"w": 77
					},
					{
						"n": 3,
						"h": 184,
						"w": 72
					},
					{
						"n": 4,
						"h": 265,
						"w": 74
					},
					{
						"n": 5,
						"h": 362,
						"w": 70
					},
					{
						"n": 6,
						"h": 189,
						"w": 146
					},
					{
						"n": 7,
						"h": 215,
						"w": 143,
						"m": 570
					},
					{
						"n": 8,
						"h": 303,
						"w": 210
					},
					{
						"n": 9,
						"h": 41,
						"w": 203
					},
					{
						"n": 10,
						"h": 114,
						"w": 230
					},
					{
						"n": 11,
						"h": 335,
						"w": 279
					}
				],
				"ball": {
					"n": 0,
					"h": 235,
					"w": 577,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 778,
			"minute": 38,
			"messages": [
				{
					"owner": 2,
					"mes": "Мирослав Манолов[27](Опава) посылает мяч налево в направлении О.Дюмона[26](Опава)..."
				},
				{
					"owner": 2,
					"mes": "Оливье Дюмон[26](Опава) с мячом..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 16
					},
					{
						"n": 2,
						"h": 110,
						"w": 363
					},
					{
						"n": 3,
						"h": 255,
						"w": 458
					},
					{
						"n": 4,
						"h": 271,
						"w": 311
					},
					{
						"n": 5,
						"h": 340,
						"w": 420
					},
					{
						"n": 6,
						"h": 173,
						"w": 284
					},
					{
						"n": 7,
						"h": 205,
						"w": 531
					},
					{
						"n": 8,
						"h": 312,
						"w": 518
					},
					{
						"n": 9,
						"h": 288,
						"w": 300
					},
					{
						"n": 10,
						"h": 186,
						"w": 591
					},
					{
						"n": 11,
						"h": 274,
						"w": 640
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 14
					},
					{
						"n": 2,
						"h": 109,
						"w": 87
					},
					{
						"n": 3,
						"h": 179,
						"w": 84
					},
					{
						"n": 4,
						"h": 272,
						"w": 85
					},
					{
						"n": 5,
						"h": 370,
						"w": 80
					},
					{
						"n": 6,
						"h": 189,
						"w": 146
					},
					{
						"n": 7,
						"h": 218,
						"w": 145
					},
					{
						"n": 8,
						"h": 310,
						"w": 221
					},
					{
						"n": 9,
						"h": 41,
						"w": 216
					},
					{
						"n": 10,
						"h": 116,
						"w": 243
					},
					{
						"n": 11,
						"h": 348,
						"w": 282
					}
				],
				"ball": {
					"n": 0,
					"h": 261,
					"w": 574,
					"z": 0,
					"r": 0,
					"p": 1,
					"x": 0
				}
			},
			"interval": 13
		},
		{
			"num": 779,
			"minute": 38,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 13
					},
					{
						"n": 2,
						"h": 100,
						"w": 324
					},
					{
						"n": 3,
						"h": 240,
						"w": 421
					},
					{
						"n": 4,
						"h": 250,
						"w": 277
					},
					{
						"n": 5,
						"h": 345,
						"w": 380
					},
					{
						"n": 6,
						"h": 167,
						"w": 270
					},
					{
						"n": 7,
						"h": 245,
						"w": 525
					},
					{
						"n": 8,
						"h": 295,
						"w": 482
					},
					{
						"n": 9,
						"h": 321,
						"w": 323
					},
					{
						"n": 10,
						"h": 180,
						"w": 551
					},
					{
						"n": 11,
						"h": 282,
						"w": 608
					}
				],
				"away": [
					{
						"n": 1,
						"h": 223,
						"w": 10
					},
					{
						"n": 2,
						"h": 85,
						"w": 119
					},
					{
						"n": 3,
						"h": 164,
						"w": 99
					},
					{
						"n": 4,
						"h": 285,
						"w": 115
					},
					{
						"n": 5,
						"h": 384,
						"w": 117
					},
					{
						"n": 6,
						"h": 186,
						"w": 181
					},
					{
						"n": 7,
						"h": 251,
						"w": 168
					},
					{
						"n": 8,
						"h": 334,
						"w": 253
					},
					{
						"n": 9,
						"h": 39,
						"w": 256
					},
					{
						"n": 10,
						"h": 125,
						"w": 282
					},
					{
						"n": 11,
						"h": 383,
						"w": 299
					}
				],
				"ball": {
					"n": 0,
					"h": 264,
					"w": 539,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 780,
			"minute": 38,
			"messages": [
				{
					"owner": 2,
					"mes": "Оливье Дюмон[26](Опава) пасует налево на Л.Седлачека[22](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 11
					},
					{
						"n": 2,
						"h": 92,
						"w": 292
					},
					{
						"n": 3,
						"h": 227,
						"w": 390
					},
					{
						"n": 4,
						"h": 248,
						"w": 259
					},
					{
						"n": 5,
						"h": 347,
						"w": 347
					},
					{
						"n": 6,
						"h": 179,
						"w": 265
					},
					{
						"n": 7,
						"h": 238,
						"w": 492
					},
					{
						"n": 8,
						"h": 281,
						"w": 452
					},
					{
						"n": 9,
						"h": 352,
						"w": 335
					},
					{
						"n": 10,
						"h": 166,
						"w": 522
					},
					{
						"n": 11,
						"h": 289,
						"w": 576
					}
				],
				"away": [
					{
						"n": 1,
						"h": 228,
						"w": 19
					},
					{
						"n": 2,
						"h": 109,
						"w": 141
					},
					{
						"n": 3,
						"h": 170,
						"w": 121
					},
					{
						"n": 4,
						"h": 288,
						"w": 126
					},
					{
						"n": 5,
						"h": 388,
						"w": 113
					},
					{
						"n": 6,
						"h": 193,
						"w": 188
					},
					{
						"n": 7,
						"h": 250,
						"w": 201
					},
					{
						"n": 8,
						"h": 347,
						"w": 283
					},
					{
						"n": 9,
						"h": 45,
						"w": 288
					},
					{
						"n": 10,
						"h": 128,
						"w": 315
					},
					{
						"n": 11,
						"h": 386,
						"w": 332
					}
				],
				"ball": {
					"n": 0,
					"h": 341,
					"w": 579,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 33
		},
		{
			"num": 781,
			"minute": 38,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 10
					},
					{
						"n": 2,
						"h": 120,
						"w": 270
					},
					{
						"n": 3,
						"h": 214,
						"w": 352
					},
					{
						"n": 4,
						"h": 247,
						"w": 262
					},
					{
						"n": 5,
						"h": 367,
						"w": 373
					},
					{
						"n": 6,
						"h": 179,
						"w": 259
					},
					{
						"n": 7,
						"h": 230,
						"w": 453
					},
					{
						"n": 8,
						"h": 290,
						"w": 413
					},
					{
						"n": 9,
						"h": 370,
						"w": 345
					},
					{
						"n": 10,
						"h": 149,
						"w": 486
					},
					{
						"n": 11,
						"h": 297,
						"w": 537
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 16
					},
					{
						"n": 2,
						"h": 100,
						"w": 175
					},
					{
						"n": 3,
						"h": 166,
						"w": 116
					},
					{
						"n": 4,
						"h": 267,
						"w": 107
					},
					{
						"n": 5,
						"h": 388,
						"w": 106
					},
					{
						"n": 6,
						"h": 186,
						"w": 187
					},
					{
						"n": 7,
						"h": 236,
						"w": 238
					},
					{
						"n": 8,
						"h": 387,
						"w": 278
					},
					{
						"n": 9,
						"h": 53,
						"w": 327
					},
					{
						"n": 10,
						"h": 138,
						"w": 353
					},
					{
						"n": 11,
						"h": 397,
						"w": 371
					}
				],
				"ball": {
					"n": 0,
					"h": 350,
					"w": 545,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 782,
			"minute": 38,
			"messages": [
				{
					"owner": 2,
					"mes": "Слева открывается Матей Юрасек[29](Опава)... Передача..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 12
					},
					{
						"n": 2,
						"h": 120,
						"w": 265
					},
					{
						"n": 3,
						"h": 195,
						"w": 314
					},
					{
						"n": 4,
						"h": 248,
						"w": 261
					},
					{
						"n": 5,
						"h": 359,
						"w": 415
					},
					{
						"n": 6,
						"h": 179,
						"w": 263
					},
					{
						"n": 7,
						"h": 226,
						"w": 410
					},
					{
						"n": 8,
						"h": 302,
						"w": 371
					},
					{
						"n": 9,
						"h": 391,
						"w": 352
					},
					{
						"n": 10,
						"h": 160,
						"w": 449
					},
					{
						"n": 11,
						"h": 308,
						"w": 495
					}
				],
				"away": [
					{
						"n": 1,
						"h": 228,
						"w": 16
					},
					{
						"n": 2,
						"h": 87,
						"w": 174,
						"m": 590
					},
					{
						"n": 3,
						"h": 166,
						"w": 107
					},
					{
						"n": 4,
						"h": 290,
						"w": 135
					},
					{
						"n": 5,
						"h": 388,
						"w": 131
					},
					{
						"n": 6,
						"h": 211,
						"w": 212
					},
					{
						"n": 7,
						"h": 217,
						"w": 277
					},
					{
						"n": 8,
						"h": 404,
						"w": 276
					},
					{
						"n": 9,
						"h": 90,
						"w": 305
					},
					{
						"n": 10,
						"h": 139,
						"w": 396
					},
					{
						"n": 11,
						"h": 396,
						"w": 414
					}
				],
				"ball": {
					"n": 0,
					"h": 359,
					"w": 415,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 43
		},
		{
			"num": 783,
			"minute": 38,
			"messages": [
				{
					"owner": 2,
					"mes": "Самуэль Кари Фридйонссон[05](Галвэй Юнайтед) читает комбинацию и перехватывает мяч!..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 16
					},
					{
						"n": 2,
						"h": 99,
						"w": 299
					},
					{
						"n": 3,
						"h": 185,
						"w": 296
					},
					{
						"n": 4,
						"h": 271,
						"w": 292
					},
					{
						"n": 5,
						"h": 334,
						"w": 440,
						"m": 630
					},
					{
						"n": 6,
						"h": 159,
						"w": 298
					},
					{
						"n": 7,
						"h": 196,
						"w": 436
					},
					{
						"n": 8,
						"h": 290,
						"w": 410
					},
					{
						"n": 9,
						"h": 392,
						"w": 392
					},
					{
						"n": 10,
						"h": 156,
						"w": 489
					},
					{
						"n": 11,
						"h": 306,
						"w": 535
					}
				],
				"away": [
					{
						"n": 1,
						"h": 213,
						"w": 53
					},
					{
						"n": 2,
						"h": 86,
						"w": 134
					},
					{
						"n": 3,
						"h": 179,
						"w": 103
					},
					{
						"n": 4,
						"h": 266,
						"w": 103
					},
					{
						"n": 5,
						"h": 354,
						"w": 109
					},
					{
						"n": 6,
						"h": 175,
						"w": 194
					},
					{
						"n": 7,
						"h": 214,
						"w": 237
					},
					{
						"n": 8,
						"h": 408,
						"w": 236
					},
					{
						"n": 9,
						"h": 112,
						"w": 271
					},
					{
						"n": 10,
						"h": 147,
						"w": 357
					},
					{
						"n": 11,
						"h": 376,
						"w": 380
					}
				],
				"ball": {
					"n": 0,
					"h": 334,
					"w": 440,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 784,
			"minute": 38,
			"messages": [
				{
					"owner": 1,
					"mes": "Коротким пасом С.Фридйонссон[05](Галвэй Юнайтед) отправляет мяч на К.Нолана[08](Галвэй Юнайтед)..."
				},
				{
					"owner": 1,
					"mes": "Киран Нолан[08](Галвэй Юнайтед) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 11
					},
					{
						"n": 2,
						"h": 85,
						"w": 322
					},
					{
						"n": 3,
						"h": 180,
						"w": 292
					},
					{
						"n": 4,
						"h": 275,
						"w": 299
					},
					{
						"n": 5,
						"h": 339,
						"w": 432
					},
					{
						"n": 6,
						"h": 146,
						"w": 321
					},
					{
						"n": 7,
						"h": 182,
						"w": 460
					},
					{
						"n": 8,
						"h": 285,
						"w": 437
					},
					{
						"n": 9,
						"h": 394,
						"w": 419
					},
					{
						"n": 10,
						"h": 156,
						"w": 516
					},
					{
						"n": 11,
						"h": 309,
						"w": 562
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 73
					},
					{
						"n": 2,
						"h": 112,
						"w": 125
					},
					{
						"n": 3,
						"h": 185,
						"w": 113
					},
					{
						"n": 4,
						"h": 281,
						"w": 101
					},
					{
						"n": 5,
						"h": 340,
						"w": 104
					},
					{
						"n": 6,
						"h": 154,
						"w": 178
					},
					{
						"n": 7,
						"h": 190,
						"w": 249
					},
					{
						"n": 8,
						"h": 399,
						"w": 262
					},
					{
						"n": 9,
						"h": 85,
						"w": 268
					},
					{
						"n": 10,
						"h": 137,
						"w": 332
					},
					{
						"n": 11,
						"h": 354,
						"w": 363
					}
				],
				"ball": {
					"n": 0,
					"h": 285,
					"w": 437,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 27
		},
		{
			"num": 785,
			"minute": 38,
			"messages": [
				{
					"owner": 1,
					"mes": "Пас С.Фридйонссону[05](Галвэй Юнайтед)..."
				},
				{
					"owner": 1,
					"mes": "Самуэль Кари Фридйонссон[05](Галвэй Юнайтед) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 14
					},
					{
						"n": 2,
						"h": 72,
						"w": 346
					},
					{
						"n": 3,
						"h": 170,
						"w": 295
					},
					{
						"n": 4,
						"h": 267,
						"w": 302
					},
					{
						"n": 5,
						"h": 320,
						"w": 451
					},
					{
						"n": 6,
						"h": 137,
						"w": 347
					},
					{
						"n": 7,
						"h": 198,
						"w": 481
					},
					{
						"n": 8,
						"h": 277,
						"w": 442
					},
					{
						"n": 9,
						"h": 399,
						"w": 446
					},
					{
						"n": 10,
						"h": 158,
						"w": 543
					},
					{
						"n": 11,
						"h": 294,
						"w": 584
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 78
					},
					{
						"n": 2,
						"h": 110,
						"w": 101
					},
					{
						"n": 3,
						"h": 166,
						"w": 99
					},
					{
						"n": 4,
						"h": 282,
						"w": 90
					},
					{
						"n": 5,
						"h": 340,
						"w": 99
					},
					{
						"n": 6,
						"h": 181,
						"w": 177
					},
					{
						"n": 7,
						"h": 211,
						"w": 232
					},
					{
						"n": 8,
						"h": 392,
						"w": 288
					},
					{
						"n": 9,
						"h": 112,
						"w": 268
					},
					{
						"n": 10,
						"h": 155,
						"w": 313
					},
					{
						"n": 11,
						"h": 334,
						"w": 345
					}
				],
				"ball": {
					"n": 0,
					"h": 320,
					"w": 451,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 27
		},
		{
			"num": 786,
			"minute": 38,
			"messages": [
				{
					"owner": 1,
					"mes": "Короткий пас на Э.Бвомоно[09](Галвэй Юнайтед)..."
				},
				{
					"owner": 1,
					"mes": "Элвис Бвомоно[09](Галвэй Юнайтед) подрабатывает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 18
					},
					{
						"n": 2,
						"h": 60,
						"w": 353
					},
					{
						"n": 3,
						"h": 166,
						"w": 300
					},
					{
						"n": 4,
						"h": 280,
						"w": 291
					},
					{
						"n": 5,
						"h": 320,
						"w": 451
					},
					{
						"n": 6,
						"h": 123,
						"w": 385
					},
					{
						"n": 7,
						"h": 219,
						"w": 505
					},
					{
						"n": 8,
						"h": 260,
						"w": 445
					},
					{
						"n": 9,
						"h": 389,
						"w": 496
					},
					{
						"n": 10,
						"h": 168,
						"w": 582
					},
					{
						"n": 11,
						"h": 296,
						"w": 613
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 37
					},
					{
						"n": 2,
						"h": 84,
						"w": 94
					},
					{
						"n": 3,
						"h": 172,
						"w": 90
					},
					{
						"n": 4,
						"h": 268,
						"w": 83
					},
					{
						"n": 5,
						"h": 340,
						"w": 95
					},
					{
						"n": 6,
						"h": 217,
						"w": 157
					},
					{
						"n": 7,
						"h": 240,
						"w": 211
					},
					{
						"n": 8,
						"h": 390,
						"w": 329
					},
					{
						"n": 9,
						"h": 88,
						"w": 234
					},
					{
						"n": 10,
						"h": 177,
						"w": 278
					},
					{
						"n": 11,
						"h": 327,
						"w": 315
					}
				],
				"ball": {
					"n": 0,
					"h": 389,
					"w": 496,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 41
		},
		{
			"num": 787,
			"minute": 38,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 13
					},
					{
						"n": 2,
						"h": 71,
						"w": 377
					},
					{
						"n": 3,
						"h": 177,
						"w": 319
					},
					{
						"n": 4,
						"h": 269,
						"w": 311
					},
					{
						"n": 5,
						"h": 323,
						"w": 491
					},
					{
						"n": 6,
						"h": 109,
						"w": 423
					},
					{
						"n": 7,
						"h": 216,
						"w": 545
					},
					{
						"n": 8,
						"h": 262,
						"w": 485
					},
					{
						"n": 9,
						"h": 364,
						"w": 521
					},
					{
						"n": 10,
						"h": 166,
						"w": 620
					},
					{
						"n": 11,
						"h": 280,
						"w": 633
					}
				],
				"away": [
					{
						"n": 1,
						"h": 216,
						"w": 12
					},
					{
						"n": 2,
						"h": 85,
						"w": 78
					},
					{
						"n": 3,
						"h": 188,
						"w": 60
					},
					{
						"n": 4,
						"h": 269,
						"w": 87
					},
					{
						"n": 5,
						"h": 340,
						"w": 59
					},
					{
						"n": 6,
						"h": 205,
						"w": 119
					},
					{
						"n": 7,
						"h": 241,
						"w": 178
					},
					{
						"n": 8,
						"h": 379,
						"w": 307
					},
					{
						"n": 9,
						"h": 94,
						"w": 194
					},
					{
						"n": 10,
						"h": 165,
						"w": 304
					},
					{
						"n": 11,
						"h": 341,
						"w": 277
					}
				],
				"ball": {
					"n": 0,
					"h": 364,
					"w": 521,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 788,
			"minute": 38,
			"messages": [
				{
					"owner": 1,
					"mes": "Пас в центр на С.Фридйонссона[05](Галвэй Юнайтед)..."
				},
				{
					"owner": 1,
					"mes": "Самуэль Кари Фридйонссон[05](Галвэй Юнайтед) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 16
					},
					{
						"n": 2,
						"h": 70,
						"w": 365
					},
					{
						"n": 3,
						"h": 179,
						"w": 313
					},
					{
						"n": 4,
						"h": 276,
						"w": 313
					},
					{
						"n": 5,
						"h": 318,
						"w": 516
					},
					{
						"n": 6,
						"h": 100,
						"w": 447
					},
					{
						"n": 7,
						"h": 194,
						"w": 558
					},
					{
						"n": 8,
						"h": 261,
						"w": 511
					},
					{
						"n": 9,
						"h": 370,
						"w": 529
					},
					{
						"n": 10,
						"h": 165,
						"w": 631
					},
					{
						"n": 11,
						"h": 293,
						"w": 636
					}
				],
				"away": [
					{
						"n": 1,
						"h": 228,
						"w": 10
					},
					{
						"n": 2,
						"h": 107,
						"w": 64
					},
					{
						"n": 3,
						"h": 169,
						"w": 62
					},
					{
						"n": 4,
						"h": 266,
						"w": 73
					},
					{
						"n": 5,
						"h": 340,
						"w": 74
					},
					{
						"n": 6,
						"h": 231,
						"w": 122
					},
					{
						"n": 7,
						"h": 217,
						"w": 176
					},
					{
						"n": 8,
						"h": 385,
						"w": 282
					},
					{
						"n": 9,
						"h": 119,
						"w": 199
					},
					{
						"n": 10,
						"h": 157,
						"w": 304
					},
					{
						"n": 11,
						"h": 350,
						"w": 253
					}
				],
				"ball": {
					"n": 0,
					"h": 318,
					"w": 516,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 26
		},
		{
			"num": 789,
			"minute": 38,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 19
					},
					{
						"n": 2,
						"h": 76,
						"w": 369
					},
					{
						"n": 3,
						"h": 176,
						"w": 310
					},
					{
						"n": 4,
						"h": 282,
						"w": 327
					},
					{
						"n": 5,
						"h": 298,
						"w": 551
					},
					{
						"n": 6,
						"h": 88,
						"w": 483
					},
					{
						"n": 7,
						"h": 164,
						"w": 582
					},
					{
						"n": 8,
						"h": 265,
						"w": 548
					},
					{
						"n": 9,
						"h": 378,
						"w": 566
					},
					{
						"n": 10,
						"h": 162,
						"w": 629
					},
					{
						"n": 11,
						"h": 297,
						"w": 631
					}
				],
				"away": [
					{
						"n": 1,
						"h": 219,
						"w": 14
					},
					{
						"n": 2,
						"h": 110,
						"w": 71
					},
					{
						"n": 3,
						"h": 173,
						"w": 63
					},
					{
						"n": 4,
						"h": 278,
						"w": 85
					},
					{
						"n": 5,
						"h": 340,
						"w": 75
					},
					{
						"n": 6,
						"h": 269,
						"w": 121
					},
					{
						"n": 7,
						"h": 188,
						"w": 169
					},
					{
						"n": 8,
						"h": 375,
						"w": 245
					},
					{
						"n": 9,
						"h": 145,
						"w": 163
					},
					{
						"n": 10,
						"h": 165,
						"w": 294
					},
					{
						"n": 11,
						"h": 318,
						"w": 274
					}
				],
				"ball": {
					"n": 0,
					"h": 298,
					"w": 551,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 38
		},
		{
			"num": 790,
			"minute": 38,
			"messages": [
				{
					"owner": 1,
					"mes": "Самуэль Кари Фридйонссон[05](Галвэй Юнайтед) наносит сильнейший удар издали..."
				},
				{
					"owner": 1,
					"mes": "Выше ворот."
				}
			],
			"U": {
				"team": 1,
				"player": 5,
				"xg": "0.02"
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 13
					},
					{
						"n": 2,
						"h": 71,
						"w": 380
					},
					{
						"n": 3,
						"h": 169,
						"w": 326
					},
					{
						"n": 4,
						"h": 282,
						"w": 312
					},
					{
						"n": 5,
						"h": 298,
						"w": 551
					},
					{
						"n": 6,
						"h": 77,
						"w": 527
					},
					{
						"n": 7,
						"h": 164,
						"w": 566
					},
					{
						"n": 8,
						"h": 262,
						"w": 503
					},
					{
						"n": 9,
						"h": 386,
						"w": 610
					},
					{
						"n": 10,
						"h": 171,
						"w": 637
					},
					{
						"n": 11,
						"h": 273,
						"w": 634
					}
				],
				"away": [
					{
						"n": 1,
						"h": 245,
						"w": 14
					},
					{
						"n": 2,
						"h": 81,
						"w": 82
					},
					{
						"n": 3,
						"h": 193,
						"w": 74
					},
					{
						"n": 4,
						"h": 262,
						"w": 69
					},
					{
						"n": 5,
						"h": 340,
						"w": 68
					},
					{
						"n": 6,
						"h": 282,
						"w": 126
					},
					{
						"n": 7,
						"h": 150,
						"w": 149
					},
					{
						"n": 8,
						"h": 374,
						"w": 200
					},
					{
						"n": 9,
						"h": 149,
						"w": 158
					},
					{
						"n": 10,
						"h": 164,
						"w": 290
					},
					{
						"n": 11,
						"h": 285,
						"w": 295
					}
				],
				"ball": {
					"n": 0,
					"h": 198,
					"w": 750,
					"z": 1,
					"r": 0,
					"p": 0,
					"x": 4
				}
			},
			"interval": 45
		},
		{
			"num": 791,
			"minute": 39,
			"possession": 45,
			"messages": [
				{
					"owner": 2,
					"mes": "Удар от ворот..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 40,
						"m": 620
					},
					{
						"n": 2,
						"h": 80,
						"w": 171
					},
					{
						"n": 3,
						"h": 168,
						"w": 150,
						"f": 91
					},
					{
						"n": 4,
						"h": 277,
						"w": 150,
						"f": 90
					},
					{
						"n": 5,
						"h": 369,
						"w": 172
					},
					{
						"n": 6,
						"h": 67,
						"w": 277,
						"f": 87
					},
					{
						"n": 7,
						"h": 162,
						"w": 250
					},
					{
						"n": 8,
						"h": 271,
						"w": 250,
						"f": 85
					},
					{
						"n": 9,
						"h": 385,
						"w": 279,
						"m": 760
					},
					{
						"n": 10,
						"h": 169,
						"w": 350,
						"f": 86
					},
					{
						"n": 11,
						"h": 283,
						"w": 350
					}
				],
				"away": [
					{
						"n": 1,
						"h": 255,
						"w": 14,
						"f": 88
					},
					{
						"n": 2,
						"h": 53,
						"w": 175,
						"f": 85
					},
					{
						"n": 3,
						"h": 154,
						"w": 175,
						"f": 89,
						"c": 1
					},
					{
						"n": 4,
						"h": 287,
						"w": 175,
						"f": 87
					},
					{
						"n": 5,
						"h": 381,
						"w": 175
					},
					{
						"n": 6,
						"h": 224,
						"w": 283
					},
					{
						"n": 7,
						"h": 220,
						"w": 392
					},
					{
						"n": 8,
						"h": 393,
						"w": 372
					},
					{
						"n": 9,
						"h": 55,
						"w": 422
					},
					{
						"n": 10,
						"h": 164,
						"w": 500,
						"f": 86
					},
					{
						"n": 11,
						"h": 295,
						"w": 500,
						"f": 86
					}
				],
				"ball": {
					"n": 0,
					"h": 190,
					"w": 686,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 150
		},
		{
			"num": 792,
			"minute": 39,
			"messages": [],
			"T": {
				"team": 2
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 41
					},
					{
						"n": 2,
						"h": 85,
						"w": 172
					},
					{
						"n": 3,
						"h": 175,
						"w": 147
					},
					{
						"n": 4,
						"h": 275,
						"w": 148
					},
					{
						"n": 5,
						"h": 369,
						"w": 171
					},
					{
						"n": 6,
						"h": 63,
						"w": 272
					},
					{
						"n": 7,
						"h": 165,
						"w": 256
					},
					{
						"n": 8,
						"h": 276,
						"w": 243
					},
					{
						"n": 9,
						"h": 387,
						"w": 285
					},
					{
						"n": 10,
						"h": 176,
						"w": 346
					},
					{
						"n": 11,
						"h": 276,
						"w": 357
					}
				],
				"away": [
					{
						"n": 1,
						"h": 260,
						"w": 34
					},
					{
						"n": 2,
						"h": 56,
						"w": 171
					},
					{
						"n": 3,
						"h": 159,
						"w": 179
					},
					{
						"n": 4,
						"h": 293,
						"w": 169
					},
					{
						"n": 5,
						"h": 379,
						"w": 169
					},
					{
						"n": 6,
						"h": 221,
						"w": 283
					},
					{
						"n": 7,
						"h": 221,
						"w": 396
					},
					{
						"n": 8,
						"h": 388,
						"w": 365
					},
					{
						"n": 9,
						"h": 54,
						"w": 429
					},
					{
						"n": 10,
						"h": 164,
						"w": 501
					},
					{
						"n": 11,
						"h": 297,
						"w": 497
					}
				],
				"ball": {
					"n": 0,
					"h": 190,
					"w": 686,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 15
		},
		{
			"num": 793,
			"minute": 39,
			"messages": [
				{
					"owner": 2,
					"mes": "Крыштоф Ласак[21](Опава) далеко выбивает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 16
					},
					{
						"n": 2,
						"h": 120,
						"w": 137
					},
					{
						"n": 3,
						"h": 224,
						"w": 133
					},
					{
						"n": 4,
						"h": 290,
						"w": 131
					},
					{
						"n": 5,
						"h": 330,
						"w": 144
					},
					{
						"n": 6,
						"h": 49,
						"w": 240
					},
					{
						"n": 7,
						"h": 175,
						"w": 219
					},
					{
						"n": 8,
						"h": 292,
						"w": 208
					},
					{
						"n": 9,
						"h": 394,
						"w": 208
					},
					{
						"n": 10,
						"h": 144,
						"w": 341
					},
					{
						"n": 11,
						"h": 304,
						"w": 439
					}
				],
				"away": [
					{
						"n": 1,
						"h": 226,
						"w": 52
					},
					{
						"n": 2,
						"h": 72,
						"w": 223
					},
					{
						"n": 3,
						"h": 166,
						"w": 172
					},
					{
						"n": 4,
						"h": 284,
						"w": 180
					},
					{
						"n": 5,
						"h": 393,
						"w": 193
					},
					{
						"n": 6,
						"h": 267,
						"w": 291
					},
					{
						"n": 7,
						"h": 221,
						"w": 409
					},
					{
						"n": 8,
						"h": 313,
						"w": 378
					},
					{
						"n": 9,
						"h": 49,
						"w": 477
					},
					{
						"n": 10,
						"h": 163,
						"w": 502
					},
					{
						"n": 11,
						"h": 289,
						"w": 410
					}
				],
				"ball": {
					"n": 0,
					"h": 144,
					"w": 341,
					"z": 1,
					"r": 0,
					"p": 4,
					"x": 0
				}
			},
			"interval": 87
		},
		{
			"num": 794,
			"minute": 39,
			"messages": [
				{
					"owner": 1,
					"mes": "Джо Квигли[10](Галвэй Юнайтед) в единоборстве с Д.Прохазкой[28](Опава) скидывает мяч в сторону..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 16
					},
					{
						"n": 2,
						"h": 120,
						"w": 117
					},
					{
						"n": 3,
						"h": 211,
						"w": 117
					},
					{
						"n": 4,
						"h": 295,
						"w": 120
					},
					{
						"n": 5,
						"h": 330,
						"w": 124
					},
					{
						"n": 6,
						"h": 58,
						"w": 257
					},
					{
						"n": 7,
						"h": 176,
						"w": 199
					},
					{
						"n": 8,
						"h": 287,
						"w": 201
					},
					{
						"n": 9,
						"h": 394,
						"w": 188
					},
					{
						"n": 10,
						"h": 144,
						"w": 341,
						"m": 750
					},
					{
						"n": 11,
						"h": 285,
						"w": 446
					}
				],
				"away": [
					{
						"n": 1,
						"h": 221,
						"w": 71
					},
					{
						"n": 2,
						"h": 72,
						"w": 225
					},
					{
						"n": 3,
						"h": 175,
						"w": 181
					},
					{
						"n": 4,
						"h": 269,
						"w": 194
					},
					{
						"n": 5,
						"h": 393,
						"w": 183
					},
					{
						"n": 6,
						"h": 283,
						"w": 303
					},
					{
						"n": 7,
						"h": 231,
						"w": 426
					},
					{
						"n": 8,
						"h": 313,
						"w": 378
					},
					{
						"n": 9,
						"h": 50,
						"w": 497
					},
					{
						"n": 10,
						"h": 163,
						"w": 502
					},
					{
						"n": 11,
						"h": 306,
						"w": 401
					}
				],
				"ball": {
					"n": 0,
					"h": 131,
					"w": 379,
					"z": 1,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 20
		},
		{
			"num": 795,
			"minute": 39,
			"messages": [
				{
					"owner": 2,
					"mes": "Мяч отскакивает прямо к О.Дюмону[26](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 19
					},
					{
						"n": 2,
						"h": 120,
						"w": 109
					},
					{
						"n": 3,
						"h": 225,
						"w": 115
					},
					{
						"n": 4,
						"h": 299,
						"w": 119
					},
					{
						"n": 5,
						"h": 330,
						"w": 107
					},
					{
						"n": 6,
						"h": 47,
						"w": 219
					},
					{
						"n": 7,
						"h": 178,
						"w": 187
					},
					{
						"n": 8,
						"h": 295,
						"w": 176
					},
					{
						"n": 9,
						"h": 394,
						"w": 176
					},
					{
						"n": 10,
						"h": 131,
						"w": 379
					},
					{
						"n": 11,
						"h": 277,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 229,
						"w": 90
					},
					{
						"n": 2,
						"h": 72,
						"w": 224
					},
					{
						"n": 3,
						"h": 173,
						"w": 178
					},
					{
						"n": 4,
						"h": 265,
						"w": 191
					},
					{
						"n": 5,
						"h": 385,
						"w": 201
					},
					{
						"n": 6,
						"h": 323,
						"w": 331
					},
					{
						"n": 7,
						"h": 211,
						"w": 427
					},
					{
						"n": 8,
						"h": 313,
						"w": 378
					},
					{
						"n": 9,
						"h": 46,
						"w": 510
					},
					{
						"n": 10,
						"h": 152,
						"w": 507
					},
					{
						"n": 11,
						"h": 343,
						"w": 384
					}
				],
				"ball": {
					"n": 0,
					"h": 127,
					"w": 389,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 796,
			"minute": 39,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 13
					},
					{
						"n": 2,
						"h": 120,
						"w": 101
					},
					{
						"n": 3,
						"h": 222,
						"w": 107
					},
					{
						"n": 4,
						"h": 309,
						"w": 102
					},
					{
						"n": 5,
						"h": 347,
						"w": 103
					},
					{
						"n": 6,
						"h": 57,
						"w": 258
					},
					{
						"n": 7,
						"h": 157,
						"w": 181
					},
					{
						"n": 8,
						"h": 303,
						"w": 173
					},
					{
						"n": 9,
						"h": 394,
						"w": 215
					},
					{
						"n": 10,
						"h": 92,
						"w": 369
					},
					{
						"n": 11,
						"h": 309,
						"w": 442
					}
				],
				"away": [
					{
						"n": 1,
						"h": 229,
						"w": 108
					},
					{
						"n": 2,
						"h": 67,
						"w": 264
					},
					{
						"n": 3,
						"h": 176,
						"w": 218
					},
					{
						"n": 4,
						"h": 267,
						"w": 231
					},
					{
						"n": 5,
						"h": 382,
						"w": 241
					},
					{
						"n": 6,
						"h": 358,
						"w": 331
					},
					{
						"n": 7,
						"h": 234,
						"w": 459
					},
					{
						"n": 8,
						"h": 332,
						"w": 386
					},
					{
						"n": 9,
						"h": 43,
						"w": 470
					},
					{
						"n": 10,
						"h": 145,
						"w": 546
					},
					{
						"n": 11,
						"h": 383,
						"w": 386
					}
				],
				"ball": {
					"n": 0,
					"h": 92,
					"w": 389,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 797,
			"minute": 39,
			"messages": [
				{
					"owner": 2,
					"mes": "Оливье Дюмон[26](Опава) делает передачу направо на Т.Прохазку[25](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 15
					},
					{
						"n": 2,
						"h": 120,
						"w": 135
					},
					{
						"n": 3,
						"h": 219,
						"w": 141
					},
					{
						"n": 4,
						"h": 299,
						"w": 134
					},
					{
						"n": 5,
						"h": 337,
						"w": 136
					},
					{
						"n": 6,
						"h": 56,
						"w": 292
					},
					{
						"n": 7,
						"h": 164,
						"w": 214
					},
					{
						"n": 8,
						"h": 293,
						"w": 206
					},
					{
						"n": 9,
						"h": 394,
						"w": 249
					},
					{
						"n": 10,
						"h": 121,
						"w": 387
					},
					{
						"n": 11,
						"h": 318,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 108
					},
					{
						"n": 2,
						"h": 66,
						"w": 295
					},
					{
						"n": 3,
						"h": 169,
						"w": 234
					},
					{
						"n": 4,
						"h": 266,
						"w": 249
					},
					{
						"n": 5,
						"h": 357,
						"w": 264
					},
					{
						"n": 6,
						"h": 348,
						"w": 333
					},
					{
						"n": 7,
						"h": 264,
						"w": 476
					},
					{
						"n": 8,
						"h": 344,
						"w": 418
					},
					{
						"n": 9,
						"h": 41,
						"w": 436
					},
					{
						"n": 10,
						"h": 163,
						"w": 520
					},
					{
						"n": 11,
						"h": 402,
						"w": 390
					}
				],
				"ball": {
					"n": 0,
					"h": 93,
					"w": 456,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 34
		},
		{
			"num": 798,
			"minute": 39,
			"messages": [
				{
					"owner": 2,
					"mes": "Томаш Прохазка[25](Опава) пасует направо на Ш.Товарека[31](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 10
					},
					{
						"n": 2,
						"h": 96,
						"w": 142
					},
					{
						"n": 3,
						"h": 218,
						"w": 142
					},
					{
						"n": 4,
						"h": 275,
						"w": 141
					},
					{
						"n": 5,
						"h": 330,
						"w": 124
					},
					{
						"n": 6,
						"h": 75,
						"w": 321
					},
					{
						"n": 7,
						"h": 165,
						"w": 226
					},
					{
						"n": 8,
						"h": 298,
						"w": 201
					},
					{
						"n": 9,
						"h": 394,
						"w": 250
					},
					{
						"n": 10,
						"h": 155,
						"w": 396
					},
					{
						"n": 11,
						"h": 285,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 110
					},
					{
						"n": 2,
						"h": 65,
						"w": 288
					},
					{
						"n": 3,
						"h": 165,
						"w": 247
					},
					{
						"n": 4,
						"h": 281,
						"w": 237
					},
					{
						"n": 5,
						"h": 365,
						"w": 258
					},
					{
						"n": 6,
						"h": 313,
						"w": 339
					},
					{
						"n": 7,
						"h": 233,
						"w": 482
					},
					{
						"n": 8,
						"h": 365,
						"w": 446
					},
					{
						"n": 9,
						"h": 47,
						"w": 435
					},
					{
						"n": 10,
						"h": 160,
						"w": 555
					},
					{
						"n": 11,
						"h": 374,
						"w": 369
					}
				],
				"ball": {
					"n": 0,
					"h": 76,
					"w": 351,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 35
		},
		{
			"num": 799,
			"minute": 39,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 12
					},
					{
						"n": 2,
						"h": 120,
						"w": 110
					},
					{
						"n": 3,
						"h": 197,
						"w": 108
					},
					{
						"n": 4,
						"h": 275,
						"w": 108
					},
					{
						"n": 5,
						"h": 330,
						"w": 102
					},
					{
						"n": 6,
						"h": 102,
						"w": 305
					},
					{
						"n": 7,
						"h": 188,
						"w": 200
					},
					{
						"n": 8,
						"h": 259,
						"w": 194
					},
					{
						"n": 9,
						"h": 394,
						"w": 215
					},
					{
						"n": 10,
						"h": 176,
						"w": 400
					},
					{
						"n": 11,
						"h": 270,
						"w": 435
					}
				],
				"away": [
					{
						"n": 1,
						"h": 226,
						"w": 120
					},
					{
						"n": 2,
						"h": 70,
						"w": 311
					},
					{
						"n": 3,
						"h": 180,
						"w": 269
					},
					{
						"n": 4,
						"h": 274,
						"w": 276
					},
					{
						"n": 5,
						"h": 388,
						"w": 260
					},
					{
						"n": 6,
						"h": 275,
						"w": 348
					},
					{
						"n": 7,
						"h": 269,
						"w": 500
					},
					{
						"n": 8,
						"h": 375,
						"w": 485
					},
					{
						"n": 9,
						"h": 46,
						"w": 470
					},
					{
						"n": 10,
						"h": 157,
						"w": 587
					},
					{
						"n": 11,
						"h": 356,
						"w": 400
					}
				],
				"ball": {
					"n": 0,
					"h": 94,
					"w": 320,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 800,
			"minute": 39,
			"messages": [
				{
					"owner": 2,
					"mes": "Пас правее на Д.Прохазку[28](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 216,
						"w": 12
					},
					{
						"n": 2,
						"h": 101,
						"w": 150
					},
					{
						"n": 3,
						"h": 217,
						"w": 113
					},
					{
						"n": 4,
						"h": 273,
						"w": 116
					},
					{
						"n": 5,
						"h": 330,
						"w": 111
					},
					{
						"n": 6,
						"h": 81,
						"w": 267
					},
					{
						"n": 7,
						"h": 203,
						"w": 191
					},
					{
						"n": 8,
						"h": 251,
						"w": 191
					},
					{
						"n": 9,
						"h": 394,
						"w": 209
					},
					{
						"n": 10,
						"h": 171,
						"w": 400
					},
					{
						"n": 11,
						"h": 268,
						"w": 420
					}
				],
				"away": [
					{
						"n": 1,
						"h": 221,
						"w": 120
					},
					{
						"n": 2,
						"h": 60,
						"w": 326
					},
					{
						"n": 3,
						"h": 182,
						"w": 280
					},
					{
						"n": 4,
						"h": 279,
						"w": 290
					},
					{
						"n": 5,
						"h": 375,
						"w": 302
					},
					{
						"n": 6,
						"h": 246,
						"w": 382
					},
					{
						"n": 7,
						"h": 251,
						"w": 502
					},
					{
						"n": 8,
						"h": 369,
						"w": 528
					},
					{
						"n": 9,
						"h": 36,
						"w": 476
					},
					{
						"n": 10,
						"h": 148,
						"w": 582
					},
					{
						"n": 11,
						"h": 365,
						"w": 404
					}
				],
				"ball": {
					"n": 0,
					"h": 81,
					"w": 192,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 44
		},
		{
			"num": 801,
			"minute": 39,
			"messages": [
				{
					"owner": 2,
					"mes": "Пас налево М.Манолову[27](Опава)..."
				},
				{
					"owner": 2,
					"mes": "Агуст Хлинссон[07](Галвэй Юнайтед) четко перехватывает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 16
					},
					{
						"n": 2,
						"h": 88,
						"w": 162
					},
					{
						"n": 3,
						"h": 196,
						"w": 121
					},
					{
						"n": 4,
						"h": 270,
						"w": 123
					},
					{
						"n": 5,
						"h": 330,
						"w": 112
					},
					{
						"n": 6,
						"h": 71,
						"w": 237
					},
					{
						"n": 7,
						"h": 173,
						"w": 197
					},
					{
						"n": 8,
						"h": 260,
						"w": 196
					},
					{
						"n": 9,
						"h": 394,
						"w": 178
					},
					{
						"n": 10,
						"h": 176,
						"w": 400
					},
					{
						"n": 11,
						"h": 278,
						"w": 446
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 121
					},
					{
						"n": 2,
						"h": 74,
						"w": 302
					},
					{
						"n": 3,
						"h": 172,
						"w": 262
					},
					{
						"n": 4,
						"h": 274,
						"w": 274
					},
					{
						"n": 5,
						"h": 378,
						"w": 271
					},
					{
						"n": 6,
						"h": 226,
						"w": 360
					},
					{
						"n": 7,
						"h": 272,
						"w": 519,
						"m": 560
					},
					{
						"n": 8,
						"h": 371,
						"w": 538,
						"m": 640
					},
					{
						"n": 9,
						"h": 35,
						"w": 507
					},
					{
						"n": 10,
						"h": 170,
						"w": 589
					},
					{
						"n": 11,
						"h": 359,
						"w": 434
					}
				],
				"ball": {
					"n": 0,
					"h": 173,
					"w": 197,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 31
		},
		{
			"num": 802,
			"minute": 39,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 17
					},
					{
						"n": 2,
						"h": 76,
						"w": 200
					},
					{
						"n": 3,
						"h": 181,
						"w": 158
					},
					{
						"n": 4,
						"h": 276,
						"w": 160
					},
					{
						"n": 5,
						"h": 351,
						"w": 146
					},
					{
						"n": 6,
						"h": 58,
						"w": 275
					},
					{
						"n": 7,
						"h": 148,
						"w": 222,
						"m": 700
					},
					{
						"n": 8,
						"h": 270,
						"w": 235
					},
					{
						"n": 9,
						"h": 393,
						"w": 218
					},
					{
						"n": 10,
						"h": 165,
						"w": 439
					},
					{
						"n": 11,
						"h": 295,
						"w": 466
					}
				],
				"away": [
					{
						"n": 1,
						"h": 234,
						"w": 79
					},
					{
						"n": 2,
						"h": 89,
						"w": 265
					},
					{
						"n": 3,
						"h": 171,
						"w": 222
					},
					{
						"n": 4,
						"h": 274,
						"w": 234
					},
					{
						"n": 5,
						"h": 356,
						"w": 238
					},
					{
						"n": 6,
						"h": 249,
						"w": 327
					},
					{
						"n": 7,
						"h": 264,
						"w": 480
					},
					{
						"n": 8,
						"h": 379,
						"w": 499
					},
					{
						"n": 9,
						"h": 33,
						"w": 467
					},
					{
						"n": 10,
						"h": 161,
						"w": 550
					},
					{
						"n": 11,
						"h": 334,
						"w": 403
					}
				],
				"ball": {
					"n": 0,
					"h": 148,
					"w": 222,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 803,
			"minute": 39,
			"messages": [
				{
					"owner": 1,
					"mes": "Пас направо на К.Нолана[08](Галвэй Юнайтед)..."
				},
				{
					"owner": 1,
					"mes": "Киран Нолан[08](Галвэй Юнайтед) с мячом..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 18
					},
					{
						"n": 2,
						"h": 63,
						"w": 228
					},
					{
						"n": 3,
						"h": 175,
						"w": 187
					},
					{
						"n": 4,
						"h": 269,
						"w": 191
					},
					{
						"n": 5,
						"h": 362,
						"w": 175
					},
					{
						"n": 6,
						"h": 57,
						"w": 306
					},
					{
						"n": 7,
						"h": 148,
						"w": 232
					},
					{
						"n": 8,
						"h": 240,
						"w": 232
					},
					{
						"n": 9,
						"h": 394,
						"w": 249
					},
					{
						"n": 10,
						"h": 155,
						"w": 468
					},
					{
						"n": 11,
						"h": 289,
						"w": 484
					}
				],
				"away": [
					{
						"n": 1,
						"h": 221,
						"w": 74
					},
					{
						"n": 2,
						"h": 97,
						"w": 235
					},
					{
						"n": 3,
						"h": 178,
						"w": 192
					},
					{
						"n": 4,
						"h": 277,
						"w": 203
					},
					{
						"n": 5,
						"h": 346,
						"w": 209
					},
					{
						"n": 6,
						"h": 262,
						"w": 299
					},
					{
						"n": 7,
						"h": 233,
						"w": 479
					},
					{
						"n": 8,
						"h": 385,
						"w": 468
					},
					{
						"n": 9,
						"h": 29,
						"w": 436
					},
					{
						"n": 10,
						"h": 177,
						"w": 523
					},
					{
						"n": 11,
						"h": 323,
						"w": 374
					}
				],
				"ball": {
					"n": 0,
					"h": 240,
					"w": 232,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 31
		},
		{
			"num": 804,
			"minute": 39,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 11
					},
					{
						"n": 2,
						"h": 69,
						"w": 266
					},
					{
						"n": 3,
						"h": 166,
						"w": 219
					},
					{
						"n": 4,
						"h": 270,
						"w": 203
					},
					{
						"n": 5,
						"h": 373,
						"w": 214
					},
					{
						"n": 6,
						"h": 52,
						"w": 346
					},
					{
						"n": 7,
						"h": 145,
						"w": 272
					},
					{
						"n": 8,
						"h": 256,
						"w": 263
					},
					{
						"n": 9,
						"h": 399,
						"w": 289
					},
					{
						"n": 10,
						"h": 147,
						"w": 498
					},
					{
						"n": 11,
						"h": 311,
						"w": 513
					}
				],
				"away": [
					{
						"n": 1,
						"h": 228,
						"w": 73
					},
					{
						"n": 2,
						"h": 110,
						"w": 198
					},
					{
						"n": 3,
						"h": 172,
						"w": 185
					},
					{
						"n": 4,
						"h": 258,
						"w": 206
					},
					{
						"n": 5,
						"h": 340,
						"w": 197
					},
					{
						"n": 6,
						"h": 283,
						"w": 265
					},
					{
						"n": 7,
						"h": 205,
						"w": 450
					},
					{
						"n": 8,
						"h": 389,
						"w": 429
					},
					{
						"n": 9,
						"h": 30,
						"w": 396
					},
					{
						"n": 10,
						"h": 185,
						"w": 484
					},
					{
						"n": 11,
						"h": 310,
						"w": 411
					}
				],
				"ball": {
					"n": 0,
					"h": 256,
					"w": 263,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 805,
			"minute": 39,
			"messages": [
				{
					"owner": 1,
					"mes": "Передача Э.Бвомоно[09](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 19
					},
					{
						"n": 2,
						"h": 61,
						"w": 265
					},
					{
						"n": 3,
						"h": 181,
						"w": 229
					},
					{
						"n": 4,
						"h": 277,
						"w": 224
					},
					{
						"n": 5,
						"h": 374,
						"w": 256
					},
					{
						"n": 6,
						"h": 53,
						"w": 388
					},
					{
						"n": 7,
						"h": 167,
						"w": 308
					},
					{
						"n": 8,
						"h": 260,
						"w": 305
					},
					{
						"n": 9,
						"h": 382,
						"w": 260
					},
					{
						"n": 10,
						"h": 172,
						"w": 506
					},
					{
						"n": 11,
						"h": 284,
						"w": 535
					}
				],
				"away": [
					{
						"n": 1,
						"h": 205,
						"w": 71
					},
					{
						"n": 2,
						"h": 110,
						"w": 156
					},
					{
						"n": 3,
						"h": 186,
						"w": 164
					},
					{
						"n": 4,
						"h": 266,
						"w": 170
					},
					{
						"n": 5,
						"h": 340,
						"w": 159
					},
					{
						"n": 6,
						"h": 286,
						"w": 223
					},
					{
						"n": 7,
						"h": 204,
						"w": 408
					},
					{
						"n": 8,
						"h": 392,
						"w": 387
					},
					{
						"n": 9,
						"h": 41,
						"w": 356
					},
					{
						"n": 10,
						"h": 187,
						"w": 442
					},
					{
						"n": 11,
						"h": 283,
						"w": 392
					}
				],
				"ball": {
					"n": 0,
					"h": 382,
					"w": 260,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 42
		},
		{
			"num": 806,
			"minute": 39,
			"messages": [
				{
					"owner": 1,
					"mes": "Игра в стенку..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 10
					},
					{
						"n": 2,
						"h": 66,
						"w": 296
					},
					{
						"n": 3,
						"h": 171,
						"w": 251
					},
					{
						"n": 4,
						"h": 281,
						"w": 250
					},
					{
						"n": 5,
						"h": 382,
						"w": 282
					},
					{
						"n": 6,
						"h": 50,
						"w": 431
					},
					{
						"n": 7,
						"h": 168,
						"w": 351
					},
					{
						"n": 8,
						"h": 291,
						"w": 335
					},
					{
						"n": 9,
						"h": 383,
						"w": 270
					},
					{
						"n": 10,
						"h": 157,
						"w": 547
					},
					{
						"n": 11,
						"h": 287,
						"w": 564
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 70
					},
					{
						"n": 2,
						"h": 110,
						"w": 139
					},
					{
						"n": 3,
						"h": 178,
						"w": 129
					},
					{
						"n": 4,
						"h": 282,
						"w": 130
					},
					{
						"n": 5,
						"h": 340,
						"w": 120
					},
					{
						"n": 6,
						"h": 291,
						"w": 181
					},
					{
						"n": 7,
						"h": 188,
						"w": 391
					},
					{
						"n": 8,
						"h": 394,
						"w": 344
					},
					{
						"n": 9,
						"h": 43,
						"w": 313
					},
					{
						"n": 10,
						"h": 169,
						"w": 409
					},
					{
						"n": 11,
						"h": 282,
						"w": 349
					}
				],
				"ball": {
					"n": 0,
					"h": 291,
					"w": 335,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 43
		},
		{
			"num": 807,
			"minute": 39,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 15
					},
					{
						"n": 2,
						"h": 64,
						"w": 327
					},
					{
						"n": 3,
						"h": 171,
						"w": 282
					},
					{
						"n": 4,
						"h": 284,
						"w": 276
					},
					{
						"n": 5,
						"h": 379,
						"w": 322
					},
					{
						"n": 6,
						"h": 47,
						"w": 471
					},
					{
						"n": 7,
						"h": 166,
						"w": 391
					},
					{
						"n": 8,
						"h": 291,
						"w": 371
					},
					{
						"n": 9,
						"h": 387,
						"w": 309
					},
					{
						"n": 10,
						"h": 165,
						"w": 583
					},
					{
						"n": 11,
						"h": 294,
						"w": 600
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 70
					},
					{
						"n": 2,
						"h": 110,
						"w": 99
					},
					{
						"n": 3,
						"h": 176,
						"w": 104
					},
					{
						"n": 4,
						"h": 271,
						"w": 91
					},
					{
						"n": 5,
						"h": 340,
						"w": 85
					},
					{
						"n": 6,
						"h": 276,
						"w": 148
					},
					{
						"n": 7,
						"h": 172,
						"w": 355
					},
					{
						"n": 8,
						"h": 397,
						"w": 304
					},
					{
						"n": 9,
						"h": 63,
						"w": 348
					},
					{
						"n": 10,
						"h": 163,
						"w": 374
					},
					{
						"n": 11,
						"h": 284,
						"w": 309
					}
				],
				"ball": {
					"n": 0,
					"h": 291,
					"w": 371,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 808,
			"minute": 40,
			"possession": 45,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 10
					},
					{
						"n": 2,
						"h": 75,
						"w": 358
					},
					{
						"n": 3,
						"h": 165,
						"w": 307
					},
					{
						"n": 4,
						"h": 274,
						"w": 315
					},
					{
						"n": 5,
						"h": 378,
						"w": 362
					},
					{
						"n": 6,
						"h": 46,
						"w": 511
					},
					{
						"n": 7,
						"h": 169,
						"w": 431,
						"f": 87
					},
					{
						"n": 8,
						"h": 291,
						"w": 406,
						"m": 610
					},
					{
						"n": 9,
						"h": 392,
						"w": 349
					},
					{
						"n": 10,
						"h": 163,
						"w": 602
					},
					{
						"n": 11,
						"h": 289,
						"w": 630
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 30
					},
					{
						"n": 2,
						"h": 110,
						"w": 76
					},
					{
						"n": 3,
						"h": 177,
						"w": 67
					},
					{
						"n": 4,
						"h": 276,
						"w": 73
					},
					{
						"n": 5,
						"h": 340,
						"w": 75
					},
					{
						"n": 6,
						"h": 278,
						"w": 110,
						"f": 87
					},
					{
						"n": 7,
						"h": 163,
						"w": 316,
						"f": 89,
						"m": 570,
						"c": 1
					},
					{
						"n": 8,
						"h": 399,
						"w": 264,
						"f": 87
					},
					{
						"n": 9,
						"h": 72,
						"w": 322
					},
					{
						"n": 10,
						"h": 160,
						"w": 339
					},
					{
						"n": 11,
						"h": 281,
						"w": 269
					}
				],
				"ball": {
					"n": 0,
					"h": 291,
					"w": 406,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 809,
			"minute": 40,
			"messages": [
				{
					"owner": 1,
					"mes": "Пас налево..."
				},
				{
					"owner": 1,
					"mes": "Киэн Колман[06](Галвэй Юнайтед) получает передачу..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 18
					},
					{
						"n": 2,
						"h": 73,
						"w": 378
					},
					{
						"n": 3,
						"h": 176,
						"w": 322
					},
					{
						"n": 4,
						"h": 265,
						"w": 328
					},
					{
						"n": 5,
						"h": 385,
						"w": 370
					},
					{
						"n": 6,
						"h": 51,
						"w": 577
					},
					{
						"n": 7,
						"h": 161,
						"w": 505
					},
					{
						"n": 8,
						"h": 286,
						"w": 419
					},
					{
						"n": 9,
						"h": 402,
						"w": 422
					},
					{
						"n": 10,
						"h": 165,
						"w": 630
					},
					{
						"n": 11,
						"h": 271,
						"w": 637
					}
				],
				"away": [
					{
						"n": 1,
						"h": 237,
						"w": 10
					},
					{
						"n": 2,
						"h": 110,
						"w": 62
					},
					{
						"n": 3,
						"h": 192,
						"w": 68
					},
					{
						"n": 4,
						"h": 267,
						"w": 61
					},
					{
						"n": 5,
						"h": 374,
						"w": 123
					},
					{
						"n": 6,
						"h": 295,
						"w": 135
					},
					{
						"n": 7,
						"h": 202,
						"w": 253
					},
					{
						"n": 8,
						"h": 395,
						"w": 210
					},
					{
						"n": 9,
						"h": 56,
						"w": 249
					},
					{
						"n": 10,
						"h": 164,
						"w": 281
					},
					{
						"n": 11,
						"h": 279,
						"w": 303
					}
				],
				"ball": {
					"n": 0,
					"h": 51,
					"w": 577,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 74
		},
		{
			"num": 810,
			"minute": 40,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 12
					},
					{
						"n": 2,
						"h": 72,
						"w": 364
					},
					{
						"n": 3,
						"h": 165,
						"w": 315
					},
					{
						"n": 4,
						"h": 278,
						"w": 317
					},
					{
						"n": 5,
						"h": 373,
						"w": 361
					},
					{
						"n": 6,
						"h": 32,
						"w": 619
					},
					{
						"n": 7,
						"h": 160,
						"w": 545
					},
					{
						"n": 8,
						"h": 277,
						"w": 458
					},
					{
						"n": 9,
						"h": 400,
						"w": 462
					},
					{
						"n": 10,
						"h": 172,
						"w": 659
					},
					{
						"n": 11,
						"h": 232,
						"w": 644
					}
				],
				"away": [
					{
						"n": 1,
						"h": 238,
						"w": 7
					},
					{
						"n": 2,
						"h": 110,
						"w": 43
					},
					{
						"n": 3,
						"h": 232,
						"w": 65
					},
					{
						"n": 4,
						"h": 280,
						"w": 42
					},
					{
						"n": 5,
						"h": 409,
						"w": 94
					},
					{
						"n": 6,
						"h": 256,
						"w": 106
					},
					{
						"n": 7,
						"h": 217,
						"w": 216
					},
					{
						"n": 8,
						"h": 403,
						"w": 192
					},
					{
						"n": 9,
						"h": 50,
						"w": 222
					},
					{
						"n": 10,
						"h": 173,
						"w": 242
					},
					{
						"n": 11,
						"h": 283,
						"w": 297
					}
				],
				"ball": {
					"n": 0,
					"h": 32,
					"w": 619,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 811,
			"minute": 40,
			"messages": [
				{
					"owner": 1,
					"mes": "Пас в штрафную..."
				},
				{
					"owner": 1,
					"mes": "Оливье Дюмон[26](Опава) в подкате дотягивается до мяча и прерывает передачу!..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 15
					},
					{
						"n": 2,
						"h": 78,
						"w": 369
					},
					{
						"n": 3,
						"h": 165,
						"w": 319
					},
					{
						"n": 4,
						"h": 272,
						"w": 329
					},
					{
						"n": 5,
						"h": 379,
						"w": 378
					},
					{
						"n": 6,
						"h": 37,
						"w": 628,
						"m": 680
					},
					{
						"n": 7,
						"h": 173,
						"w": 582
					},
					{
						"n": 8,
						"h": 283,
						"w": 437
					},
					{
						"n": 9,
						"h": 398,
						"w": 502
					},
					{
						"n": 10,
						"h": 155,
						"w": 635
					},
					{
						"n": 11,
						"h": 263,
						"w": 668
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 12
					},
					{
						"n": 2,
						"h": 110,
						"w": 27
					},
					{
						"n": 3,
						"h": 205,
						"w": 36
					},
					{
						"n": 4,
						"h": 281,
						"w": 69
					},
					{
						"n": 5,
						"h": 388,
						"w": 72
					},
					{
						"n": 6,
						"h": 299,
						"w": 91
					},
					{
						"n": 7,
						"h": 222,
						"w": 176
					},
					{
						"n": 8,
						"h": 406,
						"w": 172
					},
					{
						"n": 9,
						"h": 36,
						"w": 184
					},
					{
						"n": 10,
						"h": 167,
						"w": 263
					},
					{
						"n": 11,
						"h": 295,
						"w": 305
					}
				],
				"ball": {
					"n": 0,
					"h": 151,
					"w": 629,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 812,
			"minute": 40,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 12
					},
					{
						"n": 2,
						"h": 86,
						"w": 335
					},
					{
						"n": 3,
						"h": 149,
						"w": 326
					},
					{
						"n": 4,
						"h": 256,
						"w": 325
					},
					{
						"n": 5,
						"h": 370,
						"w": 339
					},
					{
						"n": 6,
						"h": 37,
						"w": 588
					},
					{
						"n": 7,
						"h": 177,
						"w": 542
					},
					{
						"n": 8,
						"h": 285,
						"w": 404
					},
					{
						"n": 9,
						"h": 407,
						"w": 463
					},
					{
						"n": 10,
						"h": 135,
						"w": 600
					},
					{
						"n": 11,
						"h": 276,
						"w": 630
					}
				],
				"away": [
					{
						"n": 1,
						"h": 221,
						"w": 13
					},
					{
						"n": 2,
						"h": 99,
						"w": 65
					},
					{
						"n": 3,
						"h": 183,
						"w": 69
					},
					{
						"n": 4,
						"h": 277,
						"w": 88
					},
					{
						"n": 5,
						"h": 381,
						"w": 109
					},
					{
						"n": 6,
						"h": 324,
						"w": 116,
						"m": 640
					},
					{
						"n": 7,
						"h": 219,
						"w": 216
					},
					{
						"n": 8,
						"h": 399,
						"w": 212
					},
					{
						"n": 9,
						"h": 36,
						"w": 224
					},
					{
						"n": 10,
						"h": 163,
						"w": 303
					},
					{
						"n": 11,
						"h": 335,
						"w": 300
					}
				],
				"ball": {
					"n": 0,
					"h": 126,
					"w": 604,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 813,
			"minute": 40,
			"messages": [
				{
					"owner": 2,
					"mes": "Оливье Дюмон[26](Опава) делает передачу направо на Т.Прохазку[25](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 15
					},
					{
						"n": 2,
						"h": 97,
						"w": 316
					},
					{
						"n": 3,
						"h": 140,
						"w": 306
					},
					{
						"n": 4,
						"h": 251,
						"w": 304
					},
					{
						"n": 5,
						"h": 356,
						"w": 322
					},
					{
						"n": 6,
						"h": 58,
						"w": 594
					},
					{
						"n": 7,
						"h": 177,
						"w": 520
					},
					{
						"n": 8,
						"h": 282,
						"w": 382
					},
					{
						"n": 9,
						"h": 404,
						"w": 442
					},
					{
						"n": 10,
						"h": 143,
						"w": 580
					},
					{
						"n": 11,
						"h": 281,
						"w": 609
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 13
					},
					{
						"n": 2,
						"h": 92,
						"w": 86
					},
					{
						"n": 3,
						"h": 170,
						"w": 87
					},
					{
						"n": 4,
						"h": 276,
						"w": 90
					},
					{
						"n": 5,
						"h": 369,
						"w": 116
					},
					{
						"n": 6,
						"h": 315,
						"w": 121
					},
					{
						"n": 7,
						"h": 233,
						"w": 233
					},
					{
						"n": 8,
						"h": 399,
						"w": 234
					},
					{
						"n": 9,
						"h": 57,
						"w": 230
					},
					{
						"n": 10,
						"h": 161,
						"w": 325
					},
					{
						"n": 11,
						"h": 346,
						"w": 319
					}
				],
				"ball": {
					"n": 0,
					"h": 81,
					"w": 604,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 22
		},
		{
			"num": 814,
			"minute": 40,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 15
					},
					{
						"n": 2,
						"h": 92,
						"w": 347
					},
					{
						"n": 3,
						"h": 179,
						"w": 301
					},
					{
						"n": 4,
						"h": 290,
						"w": 293
					},
					{
						"n": 5,
						"h": 331,
						"w": 291
					},
					{
						"n": 6,
						"h": 76,
						"w": 584
					},
					{
						"n": 7,
						"h": 174,
						"w": 480
					},
					{
						"n": 8,
						"h": 295,
						"w": 359
					},
					{
						"n": 9,
						"h": 405,
						"w": 402
					},
					{
						"n": 10,
						"h": 108,
						"w": 559
					},
					{
						"n": 11,
						"h": 293,
						"w": 571
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 10
					},
					{
						"n": 2,
						"h": 80,
						"w": 124
					},
					{
						"n": 3,
						"h": 177,
						"w": 91
					},
					{
						"n": 4,
						"h": 255,
						"w": 124
					},
					{
						"n": 5,
						"h": 354,
						"w": 148
					},
					{
						"n": 6,
						"h": 283,
						"w": 145
					},
					{
						"n": 7,
						"h": 249,
						"w": 270
					},
					{
						"n": 8,
						"h": 397,
						"w": 260
					},
					{
						"n": 9,
						"h": 32,
						"w": 240
					},
					{
						"n": 10,
						"h": 154,
						"w": 364
					},
					{
						"n": 11,
						"h": 367,
						"w": 353
					}
				],
				"ball": {
					"n": 0,
					"h": 96,
					"w": 572,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 815,
			"minute": 40,
			"messages": [
				{
					"owner": 2,
					"mes": "Томаш Прохазка[25](Опава) отдает передачу налево..."
				},
				{
					"owner": 2,
					"mes": "Себастьян Пейша[24](Опава) получает передачу..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 18
					},
					{
						"n": 2,
						"h": 81,
						"w": 315
					},
					{
						"n": 3,
						"h": 199,
						"w": 274
					},
					{
						"n": 4,
						"h": 279,
						"w": 262
					},
					{
						"n": 5,
						"h": 330,
						"w": 273
					},
					{
						"n": 6,
						"h": 74,
						"w": 550
					},
					{
						"n": 7,
						"h": 180,
						"w": 514
					},
					{
						"n": 8,
						"h": 294,
						"w": 325
					},
					{
						"n": 9,
						"h": 412,
						"w": 368
					},
					{
						"n": 10,
						"h": 124,
						"w": 529
					},
					{
						"n": 11,
						"h": 301,
						"w": 538
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 17
					},
					{
						"n": 2,
						"h": 74,
						"w": 158
					},
					{
						"n": 3,
						"h": 170,
						"w": 97
					},
					{
						"n": 4,
						"h": 255,
						"w": 124
					},
					{
						"n": 5,
						"h": 362,
						"w": 142
					},
					{
						"n": 6,
						"h": 274,
						"w": 178
					},
					{
						"n": 7,
						"h": 245,
						"w": 304
					},
					{
						"n": 8,
						"h": 406,
						"w": 267
					},
					{
						"n": 9,
						"h": 43,
						"w": 272
					},
					{
						"n": 10,
						"h": 146,
						"w": 397
					},
					{
						"n": 11,
						"h": 378,
						"w": 385
					}
				],
				"ball": {
					"n": 0,
					"h": 195,
					"w": 596,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 34
		},
		{
			"num": 816,
			"minute": 40,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 13
					},
					{
						"n": 2,
						"h": 88,
						"w": 278
					},
					{
						"n": 3,
						"h": 219,
						"w": 259
					},
					{
						"n": 4,
						"h": 286,
						"w": 259
					},
					{
						"n": 5,
						"h": 330,
						"w": 267
					},
					{
						"n": 6,
						"h": 70,
						"w": 510
					},
					{
						"n": 7,
						"h": 182,
						"w": 474
					},
					{
						"n": 8,
						"h": 314,
						"w": 323
					},
					{
						"n": 9,
						"h": 406,
						"w": 360
					},
					{
						"n": 10,
						"h": 127,
						"w": 489
					},
					{
						"n": 11,
						"h": 310,
						"w": 499
					}
				],
				"away": [
					{
						"n": 1,
						"h": 223,
						"w": 14
					},
					{
						"n": 2,
						"h": 64,
						"w": 194
					},
					{
						"n": 3,
						"h": 167,
						"w": 145
					},
					{
						"n": 4,
						"h": 239,
						"w": 156
					},
					{
						"n": 5,
						"h": 394,
						"w": 163
					},
					{
						"n": 6,
						"h": 260,
						"w": 215
					},
					{
						"n": 7,
						"h": 230,
						"w": 341
					},
					{
						"n": 8,
						"h": 419,
						"w": 297
					},
					{
						"n": 9,
						"h": 53,
						"w": 308
					},
					{
						"n": 10,
						"h": 141,
						"w": 423
					},
					{
						"n": 11,
						"h": 392,
						"w": 422
					}
				],
				"ball": {
					"n": 0,
					"h": 211,
					"w": 564,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 817,
			"minute": 40,
			"messages": [
				{
					"owner": 2,
					"mes": "Себастьян Пейша[24](Опава) пасует на Н.Мансура[23](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 13
					},
					{
						"n": 2,
						"h": 86,
						"w": 310
					},
					{
						"n": 3,
						"h": 220,
						"w": 257
					},
					{
						"n": 4,
						"h": 269,
						"w": 262
					},
					{
						"n": 5,
						"h": 330,
						"w": 256
					},
					{
						"n": 6,
						"h": 63,
						"w": 479
					},
					{
						"n": 7,
						"h": 205,
						"w": 496
					},
					{
						"n": 8,
						"h": 284,
						"w": 334
					},
					{
						"n": 9,
						"h": 394,
						"w": 345
					},
					{
						"n": 10,
						"h": 130,
						"w": 457
					},
					{
						"n": 11,
						"h": 290,
						"w": 524
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 18
					},
					{
						"n": 2,
						"h": 74,
						"w": 164
					},
					{
						"n": 3,
						"h": 174,
						"w": 156
					},
					{
						"n": 4,
						"h": 246,
						"w": 149
					},
					{
						"n": 5,
						"h": 393,
						"w": 131
					},
					{
						"n": 6,
						"h": 237,
						"w": 237
					},
					{
						"n": 7,
						"h": 232,
						"w": 370
					},
					{
						"n": 8,
						"h": 418,
						"w": 329
					},
					{
						"n": 9,
						"h": 53,
						"w": 340
					},
					{
						"n": 10,
						"h": 161,
						"w": 448
					},
					{
						"n": 11,
						"h": 394,
						"w": 390
					}
				],
				"ball": {
					"n": 0,
					"h": 276,
					"w": 564,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 32
		},
		{
			"num": 818,
			"minute": 40,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 17
					},
					{
						"n": 2,
						"h": 73,
						"w": 280
					},
					{
						"n": 3,
						"h": 210,
						"w": 264
					},
					{
						"n": 4,
						"h": 279,
						"w": 250
					},
					{
						"n": 5,
						"h": 330,
						"w": 257
					},
					{
						"n": 6,
						"h": 54,
						"w": 440
					},
					{
						"n": 7,
						"h": 239,
						"w": 518
					},
					{
						"n": 8,
						"h": 264,
						"w": 330
					},
					{
						"n": 9,
						"h": 394,
						"w": 306
					},
					{
						"n": 10,
						"h": 140,
						"w": 450
					},
					{
						"n": 11,
						"h": 271,
						"w": 530
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 15
					},
					{
						"n": 2,
						"h": 62,
						"w": 156
					},
					{
						"n": 3,
						"h": 192,
						"w": 186
					},
					{
						"n": 4,
						"h": 275,
						"w": 120
					},
					{
						"n": 5,
						"h": 391,
						"w": 107
					},
					{
						"n": 6,
						"h": 233,
						"w": 250
					},
					{
						"n": 7,
						"h": 240,
						"w": 382
					},
					{
						"n": 8,
						"h": 400,
						"w": 293
					},
					{
						"n": 9,
						"h": 48,
						"w": 379
					},
					{
						"n": 10,
						"h": 154,
						"w": 441
					},
					{
						"n": 11,
						"h": 407,
						"w": 420
					}
				],
				"ball": {
					"n": 0,
					"h": 258,
					"w": 534,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 819,
			"minute": 40,
			"messages": [
				{
					"owner": 2,
					"mes": "Нир Мансур[23](Опава) отдает передачу налево Л.Седлачеку[22](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 12
					},
					{
						"n": 2,
						"h": 120,
						"w": 265
					},
					{
						"n": 3,
						"h": 218,
						"w": 254
					},
					{
						"n": 4,
						"h": 282,
						"w": 258
					},
					{
						"n": 5,
						"h": 330,
						"w": 254
					},
					{
						"n": 6,
						"h": 42,
						"w": 384
					},
					{
						"n": 7,
						"h": 234,
						"w": 489
					},
					{
						"n": 8,
						"h": 265,
						"w": 329
					},
					{
						"n": 9,
						"h": 376,
						"w": 275
					},
					{
						"n": 10,
						"h": 176,
						"w": 450
					},
					{
						"n": 11,
						"h": 264,
						"w": 472
					}
				],
				"away": [
					{
						"n": 1,
						"h": 229,
						"w": 16
					},
					{
						"n": 2,
						"h": 19,
						"w": 167
					},
					{
						"n": 3,
						"h": 189,
						"w": 177
					},
					{
						"n": 4,
						"h": 274,
						"w": 135
					},
					{
						"n": 5,
						"h": 389,
						"w": 150
					},
					{
						"n": 6,
						"h": 194,
						"w": 262
					},
					{
						"n": 7,
						"h": 188,
						"w": 357
					},
					{
						"n": 8,
						"h": 399,
						"w": 351
					},
					{
						"n": 9,
						"h": 59,
						"w": 420
					},
					{
						"n": 10,
						"h": 170,
						"w": 422
					},
					{
						"n": 11,
						"h": 393,
						"w": 420
					}
				],
				"ball": {
					"n": 0,
					"h": 431,
					"w": 553,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 58
		},
		{
			"num": 820,
			"minute": 40,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 13
					},
					{
						"n": 2,
						"h": 120,
						"w": 250
					},
					{
						"n": 3,
						"h": 233,
						"w": 259
					},
					{
						"n": 4,
						"h": 270,
						"w": 260
					},
					{
						"n": 5,
						"h": 330,
						"w": 268
					},
					{
						"n": 6,
						"h": 43,
						"w": 360
					},
					{
						"n": 7,
						"h": 230,
						"w": 469
					},
					{
						"n": 8,
						"h": 250,
						"w": 348
					},
					{
						"n": 9,
						"h": 389,
						"w": 275
					},
					{
						"n": 10,
						"h": 180,
						"w": 450
					},
					{
						"n": 11,
						"h": 265,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 12
					},
					{
						"n": 2,
						"h": 13,
						"w": 201
					},
					{
						"n": 3,
						"h": 185,
						"w": 137
					},
					{
						"n": 4,
						"h": 270,
						"w": 130
					},
					{
						"n": 5,
						"h": 382,
						"w": 144
					},
					{
						"n": 6,
						"h": 193,
						"w": 226
					},
					{
						"n": 7,
						"h": 199,
						"w": 360
					},
					{
						"n": 8,
						"h": 401,
						"w": 311
					},
					{
						"n": 9,
						"h": 46,
						"w": 420
					},
					{
						"n": 10,
						"h": 160,
						"w": 431
					},
					{
						"n": 11,
						"h": 409,
						"w": 428
					}
				],
				"ball": {
					"n": 0,
					"h": 437,
					"w": 519,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 821,
			"minute": 40,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 15
					},
					{
						"n": 2,
						"h": 120,
						"w": 256
					},
					{
						"n": 3,
						"h": 231,
						"w": 255
					},
					{
						"n": 4,
						"h": 280,
						"w": 247
					},
					{
						"n": 5,
						"h": 369,
						"w": 260
					},
					{
						"n": 6,
						"h": 50,
						"w": 321
					},
					{
						"n": 7,
						"h": 226,
						"w": 450
					},
					{
						"n": 8,
						"h": 251,
						"w": 337
					},
					{
						"n": 9,
						"h": 394,
						"w": 315
					},
					{
						"n": 10,
						"h": 173,
						"w": 440
					},
					{
						"n": 11,
						"h": 318,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 16
					},
					{
						"n": 2,
						"h": 14,
						"w": 241
					},
					{
						"n": 3,
						"h": 173,
						"w": 120
					},
					{
						"n": 4,
						"h": 277,
						"w": 128
					},
					{
						"n": 5,
						"h": 391,
						"w": 138
					},
					{
						"n": 6,
						"h": 194,
						"w": 242
					},
					{
						"n": 7,
						"h": 205,
						"w": 359
					},
					{
						"n": 8,
						"h": 401,
						"w": 351
					},
					{
						"n": 9,
						"h": 44,
						"w": 450
					},
					{
						"n": 10,
						"h": 167,
						"w": 437
					},
					{
						"n": 11,
						"h": 406,
						"w": 433
					}
				],
				"ball": {
					"n": 0,
					"h": 436,
					"w": 479,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 822,
			"minute": 40,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 14
					},
					{
						"n": 2,
						"h": 120,
						"w": 217
					},
					{
						"n": 3,
						"h": 235,
						"w": 216
					},
					{
						"n": 4,
						"h": 282,
						"w": 208
					},
					{
						"n": 5,
						"h": 380,
						"w": 222
					},
					{
						"n": 6,
						"h": 49,
						"w": 302
					},
					{
						"n": 7,
						"h": 222,
						"w": 411
					},
					{
						"n": 8,
						"h": 251,
						"w": 298
					},
					{
						"n": 9,
						"h": 394,
						"w": 296
					},
					{
						"n": 10,
						"h": 176,
						"w": 401
					},
					{
						"n": 11,
						"h": 304,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 15
					},
					{
						"n": 2,
						"h": 10,
						"w": 267
					},
					{
						"n": 3,
						"h": 170,
						"w": 159
					},
					{
						"n": 4,
						"h": 274,
						"w": 167
					},
					{
						"n": 5,
						"h": 384,
						"w": 176
					},
					{
						"n": 6,
						"h": 194,
						"w": 281
					},
					{
						"n": 7,
						"h": 204,
						"w": 398
					},
					{
						"n": 8,
						"h": 394,
						"w": 313
					},
					{
						"n": 9,
						"h": 37,
						"w": 488
					},
					{
						"n": 10,
						"h": 152,
						"w": 473
					},
					{
						"n": 11,
						"h": 412,
						"w": 472
					}
				],
				"ball": {
					"n": 0,
					"h": 440,
					"w": 453,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 823,
			"minute": 40,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 11
					},
					{
						"n": 2,
						"h": 120,
						"w": 178
					},
					{
						"n": 3,
						"h": 240,
						"w": 178
					},
					{
						"n": 4,
						"h": 285,
						"w": 169
					},
					{
						"n": 5,
						"h": 385,
						"w": 183
					},
					{
						"n": 6,
						"h": 47,
						"w": 283
					},
					{
						"n": 7,
						"h": 222,
						"w": 372
					},
					{
						"n": 8,
						"h": 252,
						"w": 259
					},
					{
						"n": 9,
						"h": 394,
						"w": 335
					},
					{
						"n": 10,
						"h": 179,
						"w": 400
					},
					{
						"n": 11,
						"h": 303,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 221,
						"w": 37
					},
					{
						"n": 2,
						"h": 14,
						"w": 292
					},
					{
						"n": 3,
						"h": 170,
						"w": 198
					},
					{
						"n": 4,
						"h": 271,
						"w": 206
					},
					{
						"n": 5,
						"h": 389,
						"w": 215
					},
					{
						"n": 6,
						"h": 193,
						"w": 320
					},
					{
						"n": 7,
						"h": 203,
						"w": 437
					},
					{
						"n": 8,
						"h": 397,
						"w": 352
					},
					{
						"n": 9,
						"h": 33,
						"w": 527
					},
					{
						"n": 10,
						"h": 136,
						"w": 509
					},
					{
						"n": 11,
						"h": 420,
						"w": 510
					}
				],
				"ball": {
					"n": 0,
					"h": 436,
					"w": 428,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 824,
			"minute": 40,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 19
					},
					{
						"n": 2,
						"h": 120,
						"w": 139
					},
					{
						"n": 3,
						"h": 237,
						"w": 139
					},
					{
						"n": 4,
						"h": 276,
						"w": 131
					},
					{
						"n": 5,
						"h": 393,
						"w": 145
					},
					{
						"n": 6,
						"h": 52,
						"w": 244
					},
					{
						"n": 7,
						"h": 220,
						"w": 333
					},
					{
						"n": 8,
						"h": 251,
						"w": 220
					},
					{
						"n": 9,
						"h": 394,
						"w": 374
					},
					{
						"n": 10,
						"h": 175,
						"w": 400
					},
					{
						"n": 11,
						"h": 317,
						"w": 432
					}
				],
				"away": [
					{
						"n": 1,
						"h": 226,
						"w": 53
					},
					{
						"n": 2,
						"h": 18,
						"w": 326
					},
					{
						"n": 3,
						"h": 177,
						"w": 236
					},
					{
						"n": 4,
						"h": 275,
						"w": 244
					},
					{
						"n": 5,
						"h": 390,
						"w": 254
					},
					{
						"n": 6,
						"h": 201,
						"w": 359
					},
					{
						"n": 7,
						"h": 196,
						"w": 475
					},
					{
						"n": 8,
						"h": 397,
						"w": 391
					},
					{
						"n": 9,
						"h": 19,
						"w": 563
					},
					{
						"n": 10,
						"h": 125,
						"w": 546
					},
					{
						"n": 11,
						"h": 432,
						"w": 543
					}
				],
				"ball": {
					"n": 0,
					"h": 432,
					"w": 394,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 825,
			"minute": 40,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 15
					},
					{
						"n": 2,
						"h": 120,
						"w": 104
					},
					{
						"n": 3,
						"h": 242,
						"w": 112
					},
					{
						"n": 4,
						"h": 284,
						"w": 100
					},
					{
						"n": 5,
						"h": 394,
						"w": 136
					},
					{
						"n": 6,
						"h": 56,
						"w": 255
					},
					{
						"n": 7,
						"h": 214,
						"w": 295
					},
					{
						"n": 8,
						"h": 251,
						"w": 181
					},
					{
						"n": 9,
						"h": 394,
						"w": 345
					},
					{
						"n": 10,
						"h": 179,
						"w": 400
					},
					{
						"n": 11,
						"h": 287,
						"w": 432
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 78
					},
					{
						"n": 2,
						"h": 22,
						"w": 360
					},
					{
						"n": 3,
						"h": 163,
						"w": 273
					},
					{
						"n": 4,
						"h": 271,
						"w": 262
					},
					{
						"n": 5,
						"h": 386,
						"w": 265
					},
					{
						"n": 6,
						"h": 175,
						"w": 387
					},
					{
						"n": 7,
						"h": 188,
						"w": 513
					},
					{
						"n": 8,
						"h": 397,
						"w": 430
					},
					{
						"n": 9,
						"h": 15,
						"w": 577
					},
					{
						"n": 10,
						"h": 116,
						"w": 576
					},
					{
						"n": 11,
						"h": 423,
						"w": 538
					}
				],
				"ball": {
					"n": 0,
					"h": 428,
					"w": 360,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 826,
			"minute": 40,
			"messages": [
				{
					"owner": 2,
					"mes": "Л.Седлачек[22](Опава) отдает передачу М.Юрасеку[29](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 239,
						"w": 6
					},
					{
						"n": 2,
						"h": 120,
						"w": 58
					},
					{
						"n": 3,
						"h": 259,
						"w": 53
					},
					{
						"n": 4,
						"h": 286,
						"w": 95
					},
					{
						"n": 5,
						"h": 396,
						"w": 69
					},
					{
						"n": 6,
						"h": 56,
						"w": 188
					},
					{
						"n": 7,
						"h": 212,
						"w": 227
					},
					{
						"n": 8,
						"h": 251,
						"w": 130
					},
					{
						"n": 9,
						"h": 391,
						"w": 277
					},
					{
						"n": 10,
						"h": 172,
						"w": 390
					},
					{
						"n": 11,
						"h": 320,
						"w": 400
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 94
					},
					{
						"n": 2,
						"h": 31,
						"w": 356
					},
					{
						"n": 3,
						"h": 171,
						"w": 290
					},
					{
						"n": 4,
						"h": 278,
						"w": 316
					},
					{
						"n": 5,
						"h": 388,
						"w": 300
					},
					{
						"n": 6,
						"h": 220,
						"w": 396
					},
					{
						"n": 7,
						"h": 201,
						"w": 580
					},
					{
						"n": 8,
						"h": 405,
						"w": 497
					},
					{
						"n": 9,
						"h": 24,
						"w": 631
					},
					{
						"n": 10,
						"h": 175,
						"w": 610
					},
					{
						"n": 11,
						"h": 376,
						"w": 587
					}
				],
				"ball": {
					"n": 0,
					"h": 426,
					"w": 89,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 68
		},
		{
			"num": 827,
			"minute": 41,
			"possession": 44,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 239,
						"w": 6,
						"f": 95
					},
					{
						"n": 2,
						"h": 120,
						"w": 69,
						"f": 87
					},
					{
						"n": 3,
						"h": 245,
						"w": 56
					},
					{
						"n": 4,
						"h": 274,
						"w": 89
					},
					{
						"n": 5,
						"h": 401,
						"w": 82,
						"f": 87
					},
					{
						"n": 6,
						"h": 56,
						"w": 174
					},
					{
						"n": 7,
						"h": 210,
						"w": 213
					},
					{
						"n": 8,
						"h": 242,
						"w": 128
					},
					{
						"n": 9,
						"h": 392,
						"w": 263,
						"f": 85
					},
					{
						"n": 10,
						"h": 172,
						"w": 390,
						"f": 85
					},
					{
						"n": 11,
						"h": 306,
						"w": 400,
						"f": 86
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 107
					},
					{
						"n": 2,
						"h": 45,
						"w": 357
					},
					{
						"n": 3,
						"h": 177,
						"w": 303
					},
					{
						"n": 4,
						"h": 278,
						"w": 316
					},
					{
						"n": 5,
						"h": 375,
						"w": 302
					},
					{
						"n": 6,
						"h": 212,
						"w": 407
					},
					{
						"n": 7,
						"h": 200,
						"w": 594
					},
					{
						"n": 8,
						"h": 404,
						"w": 511
					},
					{
						"n": 9,
						"h": 34,
						"w": 621,
						"f": 86
					},
					{
						"n": 10,
						"h": 185,
						"w": 619
					},
					{
						"n": 11,
						"h": 365,
						"w": 596
					}
				],
				"ball": {
					"n": 0,
					"h": 416,
					"w": 99,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 14
		},
		{
			"num": 828,
			"minute": 41,
			"messages": [
				{
					"owner": 2,
					"mes": "М.Юрасек[29](Опава) сильно бьет в направлении штрафной..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 239,
						"w": 6
					},
					{
						"n": 2,
						"h": 120,
						"w": 69
					},
					{
						"n": 3,
						"h": 245,
						"w": 56
					},
					{
						"n": 4,
						"h": 274,
						"w": 89
					},
					{
						"n": 5,
						"h": 401,
						"w": 82,
						"m": 640
					},
					{
						"n": 6,
						"h": 56,
						"w": 174
					},
					{
						"n": 7,
						"h": 210,
						"w": 213
					},
					{
						"n": 8,
						"h": 242,
						"w": 128
					},
					{
						"n": 9,
						"h": 392,
						"w": 263
					},
					{
						"n": 10,
						"h": 172,
						"w": 390
					},
					{
						"n": 11,
						"h": 306,
						"w": 400
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 107
					},
					{
						"n": 2,
						"h": 45,
						"w": 357
					},
					{
						"n": 3,
						"h": 177,
						"w": 303
					},
					{
						"n": 4,
						"h": 278,
						"w": 316
					},
					{
						"n": 5,
						"h": 375,
						"w": 302
					},
					{
						"n": 6,
						"h": 212,
						"w": 407
					},
					{
						"n": 7,
						"h": 200,
						"w": 594
					},
					{
						"n": 8,
						"h": 404,
						"w": 511
					},
					{
						"n": 9,
						"h": 34,
						"w": 621
					},
					{
						"n": 10,
						"h": 185,
						"w": 619
					},
					{
						"n": 11,
						"h": 365,
						"w": 596
					}
				],
				"ball": {
					"n": 0,
					"h": 401,
					"w": 82,
					"z": 1,
					"r": 2,
					"p": 1,
					"x": 0
				}
			},
			"interval": 6
		},
		{
			"num": 829,
			"minute": 41,
			"messages": [
				{
					"owner": 2,
					"mes": "Но С.Фридйонссон[05](Галвэй Юнайтед) прерывает навес."
				},
				{
					"owner": 1,
					"mes": "Роббе Дриссенс[04](Галвэй Юнайтед) первый на подборе..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 238,
						"w": 7
					},
					{
						"n": 2,
						"h": 117,
						"w": 56
					},
					{
						"n": 3,
						"h": 232,
						"w": 67
					},
					{
						"n": 4,
						"h": 274,
						"w": 119
					},
					{
						"n": 5,
						"h": 401,
						"w": 82
					},
					{
						"n": 6,
						"h": 56,
						"w": 144
					},
					{
						"n": 7,
						"h": 206,
						"w": 183
					},
					{
						"n": 8,
						"h": 269,
						"w": 140
					},
					{
						"n": 9,
						"h": 395,
						"w": 233
					},
					{
						"n": 10,
						"h": 176,
						"w": 390
					},
					{
						"n": 11,
						"h": 287,
						"w": 400
					}
				],
				"away": [
					{
						"n": 1,
						"h": 229,
						"w": 127
					},
					{
						"n": 2,
						"h": 56,
						"w": 352
					},
					{
						"n": 3,
						"h": 163,
						"w": 307
					},
					{
						"n": 4,
						"h": 274,
						"w": 303
					},
					{
						"n": 5,
						"h": 377,
						"w": 308
					},
					{
						"n": 6,
						"h": 211,
						"w": 437
					},
					{
						"n": 7,
						"h": 212,
						"w": 622
					},
					{
						"n": 8,
						"h": 407,
						"w": 541
					},
					{
						"n": 9,
						"h": 34,
						"w": 621
					},
					{
						"n": 10,
						"h": 213,
						"w": 631
					},
					{
						"n": 11,
						"h": 344,
						"w": 617
					}
				],
				"ball": {
					"n": 0,
					"h": 274,
					"w": 119,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 30
		},
		{
			"num": 830,
			"minute": 41,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 15
					},
					{
						"n": 2,
						"h": 101,
						"w": 93
					},
					{
						"n": 3,
						"h": 202,
						"w": 94
					},
					{
						"n": 4,
						"h": 289,
						"w": 151
					},
					{
						"n": 5,
						"h": 392,
						"w": 121
					},
					{
						"n": 6,
						"h": 50,
						"w": 184
					},
					{
						"n": 7,
						"h": 193,
						"w": 221
					},
					{
						"n": 8,
						"h": 267,
						"w": 180
					},
					{
						"n": 9,
						"h": 395,
						"w": 273
					},
					{
						"n": 10,
						"h": 165,
						"w": 411
					},
					{
						"n": 11,
						"h": 297,
						"w": 400
					}
				],
				"away": [
					{
						"n": 1,
						"h": 217,
						"w": 86
					},
					{
						"n": 2,
						"h": 74,
						"w": 317
					},
					{
						"n": 3,
						"h": 165,
						"w": 267
					},
					{
						"n": 4,
						"h": 273,
						"w": 263
					},
					{
						"n": 5,
						"h": 352,
						"w": 277
					},
					{
						"n": 6,
						"h": 193,
						"w": 473
					},
					{
						"n": 7,
						"h": 190,
						"w": 588
					},
					{
						"n": 8,
						"h": 405,
						"w": 501
					},
					{
						"n": 9,
						"h": 37,
						"w": 581
					},
					{
						"n": 10,
						"h": 202,
						"w": 593
					},
					{
						"n": 11,
						"h": 338,
						"w": 577
					}
				],
				"ball": {
					"n": 0,
					"h": 289,
					"w": 151,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 831,
			"minute": 41,
			"messages": [
				{
					"owner": 1,
					"mes": "Роббе Дриссенс[04](Галвэй Юнайтед) пасует Э.Бвомоно[09](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 13
					},
					{
						"n": 2,
						"h": 84,
						"w": 136
					},
					{
						"n": 3,
						"h": 177,
						"w": 133
					},
					{
						"n": 4,
						"h": 285,
						"w": 151
					},
					{
						"n": 5,
						"h": 386,
						"w": 167
					},
					{
						"n": 6,
						"h": 45,
						"w": 230
					},
					{
						"n": 7,
						"h": 198,
						"w": 268
					},
					{
						"n": 8,
						"h": 305,
						"w": 208
					},
					{
						"n": 9,
						"h": 384,
						"w": 256
					},
					{
						"n": 10,
						"h": 157,
						"w": 431
					},
					{
						"n": 11,
						"h": 285,
						"w": 436
					}
				],
				"away": [
					{
						"n": 1,
						"h": 205,
						"w": 70
					},
					{
						"n": 2,
						"h": 93,
						"w": 273
					},
					{
						"n": 3,
						"h": 180,
						"w": 223
					},
					{
						"n": 4,
						"h": 277,
						"w": 228
					},
					{
						"n": 5,
						"h": 341,
						"w": 231
					},
					{
						"n": 6,
						"h": 188,
						"w": 426
					},
					{
						"n": 7,
						"h": 163,
						"w": 549
					},
					{
						"n": 8,
						"h": 407,
						"w": 454
					},
					{
						"n": 9,
						"h": 35,
						"w": 534
					},
					{
						"n": 10,
						"h": 179,
						"w": 552
					},
					{
						"n": 11,
						"h": 314,
						"w": 537
					}
				],
				"ball": {
					"n": 0,
					"h": 384,
					"w": 256,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 47
		},
		{
			"num": 832,
			"minute": 41,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 13
					},
					{
						"n": 2,
						"h": 76,
						"w": 176
					},
					{
						"n": 3,
						"h": 171,
						"w": 173
					},
					{
						"n": 4,
						"h": 279,
						"w": 178
					},
					{
						"n": 5,
						"h": 381,
						"w": 207
					},
					{
						"n": 6,
						"h": 52,
						"w": 270
					},
					{
						"n": 7,
						"h": 198,
						"w": 308
					},
					{
						"n": 8,
						"h": 304,
						"w": 248
					},
					{
						"n": 9,
						"h": 384,
						"w": 291
					},
					{
						"n": 10,
						"h": 157,
						"w": 460
					},
					{
						"n": 11,
						"h": 314,
						"w": 462
					}
				],
				"away": [
					{
						"n": 1,
						"h": 205,
						"w": 72
					},
					{
						"n": 2,
						"h": 87,
						"w": 313
					},
					{
						"n": 3,
						"h": 167,
						"w": 229
					},
					{
						"n": 4,
						"h": 259,
						"w": 243
					},
					{
						"n": 5,
						"h": 340,
						"w": 213
					},
					{
						"n": 6,
						"h": 174,
						"w": 389
					},
					{
						"n": 7,
						"h": 172,
						"w": 510
					},
					{
						"n": 8,
						"h": 414,
						"w": 415
					},
					{
						"n": 9,
						"h": 37,
						"w": 494
					},
					{
						"n": 10,
						"h": 166,
						"w": 514
					},
					{
						"n": 11,
						"h": 298,
						"w": 500
					}
				],
				"ball": {
					"n": 0,
					"h": 384,
					"w": 291,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 833,
			"minute": 41,
			"messages": [
				{
					"owner": 1,
					"mes": "Пас в центр на К.Нолана[08](Галвэй Юнайтед)..."
				},
				{
					"owner": 1,
					"mes": "Киран Нолан[08](Галвэй Юнайтед) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 18
					},
					{
						"n": 2,
						"h": 70,
						"w": 211
					},
					{
						"n": 3,
						"h": 174,
						"w": 199
					},
					{
						"n": 4,
						"h": 280,
						"w": 184
					},
					{
						"n": 5,
						"h": 379,
						"w": 239
					},
					{
						"n": 6,
						"h": 48,
						"w": 306
					},
					{
						"n": 7,
						"h": 178,
						"w": 338
					},
					{
						"n": 8,
						"h": 330,
						"w": 274
					},
					{
						"n": 9,
						"h": 388,
						"w": 300
					},
					{
						"n": 10,
						"h": 144,
						"w": 493
					},
					{
						"n": 11,
						"h": 289,
						"w": 482
					}
				],
				"away": [
					{
						"n": 1,
						"h": 205,
						"w": 70
					},
					{
						"n": 2,
						"h": 85,
						"w": 277
					},
					{
						"n": 3,
						"h": 178,
						"w": 207
					},
					{
						"n": 4,
						"h": 277,
						"w": 221
					},
					{
						"n": 5,
						"h": 340,
						"w": 210
					},
					{
						"n": 6,
						"h": 145,
						"w": 410
					},
					{
						"n": 7,
						"h": 179,
						"w": 475
					},
					{
						"n": 8,
						"h": 414,
						"w": 397
					},
					{
						"n": 9,
						"h": 39,
						"w": 458
					},
					{
						"n": 10,
						"h": 166,
						"w": 478
					},
					{
						"n": 11,
						"h": 296,
						"w": 464
					}
				],
				"ball": {
					"n": 0,
					"h": 330,
					"w": 274,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 36
		},
		{
			"num": 834,
			"minute": 41,
			"messages": [
				{
					"owner": 1,
					"mes": "Пас направо С.Фридйонссону[05](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 18
					},
					{
						"n": 2,
						"h": 72,
						"w": 233
					},
					{
						"n": 3,
						"h": 182,
						"w": 200
					},
					{
						"n": 4,
						"h": 275,
						"w": 206
					},
					{
						"n": 5,
						"h": 369,
						"w": 253
					},
					{
						"n": 6,
						"h": 47,
						"w": 328
					},
					{
						"n": 7,
						"h": 185,
						"w": 359
					},
					{
						"n": 8,
						"h": 322,
						"w": 280
					},
					{
						"n": 9,
						"h": 391,
						"w": 322
					},
					{
						"n": 10,
						"h": 149,
						"w": 494
					},
					{
						"n": 11,
						"h": 293,
						"w": 479
					}
				],
				"away": [
					{
						"n": 1,
						"h": 205,
						"w": 76
					},
					{
						"n": 2,
						"h": 82,
						"w": 255
					},
					{
						"n": 3,
						"h": 173,
						"w": 211
					},
					{
						"n": 4,
						"h": 274,
						"w": 199
					},
					{
						"n": 5,
						"h": 340,
						"w": 197
					},
					{
						"n": 6,
						"h": 146,
						"w": 388
					},
					{
						"n": 7,
						"h": 184,
						"w": 454
					},
					{
						"n": 8,
						"h": 411,
						"w": 386
					},
					{
						"n": 9,
						"h": 60,
						"w": 462
					},
					{
						"n": 10,
						"h": 157,
						"w": 458
					},
					{
						"n": 11,
						"h": 292,
						"w": 442
					}
				],
				"ball": {
					"n": 0,
					"h": 369,
					"w": 253,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 22
		},
		{
			"num": 835,
			"minute": 41,
			"messages": [
				{
					"owner": 1,
					"mes": "Самуэль Кари Фридйонссон[05](Галвэй Юнайтед) смотрит налево... Пас К.Нолану[08](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 17
					},
					{
						"n": 2,
						"h": 77,
						"w": 257
					},
					{
						"n": 3,
						"h": 177,
						"w": 213
					},
					{
						"n": 4,
						"h": 275,
						"w": 217
					},
					{
						"n": 5,
						"h": 371,
						"w": 263
					},
					{
						"n": 6,
						"h": 47,
						"w": 355
					},
					{
						"n": 7,
						"h": 176,
						"w": 384
					},
					{
						"n": 8,
						"h": 341,
						"w": 299
					},
					{
						"n": 9,
						"h": 390,
						"w": 349
					},
					{
						"n": 10,
						"h": 176,
						"w": 494
					},
					{
						"n": 11,
						"h": 291,
						"w": 506
					}
				],
				"away": [
					{
						"n": 1,
						"h": 205,
						"w": 73
					},
					{
						"n": 2,
						"h": 78,
						"w": 229
					},
					{
						"n": 3,
						"h": 178,
						"w": 201
					},
					{
						"n": 4,
						"h": 255,
						"w": 217
					},
					{
						"n": 5,
						"h": 340,
						"w": 193
					},
					{
						"n": 6,
						"h": 126,
						"w": 406
					},
					{
						"n": 7,
						"h": 187,
						"w": 427
					},
					{
						"n": 8,
						"h": 409,
						"w": 373
					},
					{
						"n": 9,
						"h": 51,
						"w": 436
					},
					{
						"n": 10,
						"h": 160,
						"w": 431
					},
					{
						"n": 11,
						"h": 291,
						"w": 415
					}
				],
				"ball": {
					"n": 0,
					"h": 341,
					"w": 299,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 27
		},
		{
			"num": 836,
			"minute": 41,
			"messages": [
				{
					"owner": 1,
					"mes": "Отдает пас Э.Бвомоно[09](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 16
					},
					{
						"n": 2,
						"h": 62,
						"w": 267
					},
					{
						"n": 3,
						"h": 172,
						"w": 219
					},
					{
						"n": 4,
						"h": 273,
						"w": 212
					},
					{
						"n": 5,
						"h": 373,
						"w": 272
					},
					{
						"n": 6,
						"h": 50,
						"w": 381
					},
					{
						"n": 7,
						"h": 200,
						"w": 394
					},
					{
						"n": 8,
						"h": 341,
						"w": 325
					},
					{
						"n": 9,
						"h": 381,
						"w": 335
					},
					{
						"n": 10,
						"h": 173,
						"w": 517
					},
					{
						"n": 11,
						"h": 290,
						"w": 527
					}
				],
				"away": [
					{
						"n": 1,
						"h": 205,
						"w": 76
					},
					{
						"n": 2,
						"h": 78,
						"w": 255
					},
					{
						"n": 3,
						"h": 170,
						"w": 185
					},
					{
						"n": 4,
						"h": 258,
						"w": 191
					},
					{
						"n": 5,
						"h": 340,
						"w": 195
					},
					{
						"n": 6,
						"h": 126,
						"w": 406
					},
					{
						"n": 7,
						"h": 188,
						"w": 414
					},
					{
						"n": 8,
						"h": 407,
						"w": 360
					},
					{
						"n": 9,
						"h": 44,
						"w": 411
					},
					{
						"n": 10,
						"h": 143,
						"w": 412
					},
					{
						"n": 11,
						"h": 295,
						"w": 390
					}
				],
				"ball": {
					"n": 0,
					"h": 381,
					"w": 335,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 26
		},
		{
			"num": 837,
			"minute": 41,
			"messages": [
				{
					"owner": 1,
					"mes": "Играет накоротке с К.Ноланом[08](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 13
					},
					{
						"n": 2,
						"h": 63,
						"w": 286
					},
					{
						"n": 3,
						"h": 181,
						"w": 224
					},
					{
						"n": 4,
						"h": 274,
						"w": 232
					},
					{
						"n": 5,
						"h": 374,
						"w": 288
					},
					{
						"n": 6,
						"h": 47,
						"w": 400
					},
					{
						"n": 7,
						"h": 183,
						"w": 405
					},
					{
						"n": 8,
						"h": 344,
						"w": 346
					},
					{
						"n": 9,
						"h": 381,
						"w": 345
					},
					{
						"n": 10,
						"h": 169,
						"w": 525
					},
					{
						"n": 11,
						"h": 282,
						"w": 535
					}
				],
				"away": [
					{
						"n": 1,
						"h": 205,
						"w": 79
					},
					{
						"n": 2,
						"h": 80,
						"w": 235
					},
					{
						"n": 3,
						"h": 179,
						"w": 184
					},
					{
						"n": 4,
						"h": 261,
						"w": 194
					},
					{
						"n": 5,
						"h": 340,
						"w": 184
					},
					{
						"n": 6,
						"h": 126,
						"w": 406
					},
					{
						"n": 7,
						"h": 189,
						"w": 404
					},
					{
						"n": 8,
						"h": 407,
						"w": 350
					},
					{
						"n": 9,
						"h": 40,
						"w": 391
					},
					{
						"n": 10,
						"h": 149,
						"w": 393
					},
					{
						"n": 11,
						"h": 294,
						"w": 370
					}
				],
				"ball": {
					"n": 0,
					"h": 344,
					"w": 346,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 20
		},
		{
			"num": 838,
			"minute": 41,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 14
					},
					{
						"n": 2,
						"h": 66,
						"w": 286
					},
					{
						"n": 3,
						"h": 167,
						"w": 249
					},
					{
						"n": 4,
						"h": 277,
						"w": 243
					},
					{
						"n": 5,
						"h": 384,
						"w": 294
					},
					{
						"n": 6,
						"h": 45,
						"w": 440
					},
					{
						"n": 7,
						"h": 169,
						"w": 425
					},
					{
						"n": 8,
						"h": 344,
						"w": 381
					},
					{
						"n": 9,
						"h": 384,
						"w": 385
					},
					{
						"n": 10,
						"h": 153,
						"w": 518
					},
					{
						"n": 11,
						"h": 285,
						"w": 536
					}
				],
				"away": [
					{
						"n": 1,
						"h": 205,
						"w": 79
					},
					{
						"n": 2,
						"h": 111,
						"w": 214
					},
					{
						"n": 3,
						"h": 183,
						"w": 185
					},
					{
						"n": 4,
						"h": 282,
						"w": 197
					},
					{
						"n": 5,
						"h": 340,
						"w": 178
					},
					{
						"n": 6,
						"h": 115,
						"w": 373
					},
					{
						"n": 7,
						"h": 191,
						"w": 384
					},
					{
						"n": 8,
						"h": 406,
						"w": 330
					},
					{
						"n": 9,
						"h": 36,
						"w": 352
					},
					{
						"n": 10,
						"h": 175,
						"w": 367
					},
					{
						"n": 11,
						"h": 290,
						"w": 373
					}
				],
				"ball": {
					"n": 0,
					"h": 344,
					"w": 381,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 839,
			"minute": 41,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 19
					},
					{
						"n": 2,
						"h": 70,
						"w": 284
					},
					{
						"n": 3,
						"h": 176,
						"w": 235
					},
					{
						"n": 4,
						"h": 284,
						"w": 230
					},
					{
						"n": 5,
						"h": 372,
						"w": 279
					},
					{
						"n": 6,
						"h": 53,
						"w": 479
					},
					{
						"n": 7,
						"h": 150,
						"w": 413
					},
					{
						"n": 8,
						"h": 344,
						"w": 416
					},
					{
						"n": 9,
						"h": 389,
						"w": 425
					},
					{
						"n": 10,
						"h": 179,
						"w": 532
					},
					{
						"n": 11,
						"h": 286,
						"w": 542
					}
				],
				"away": [
					{
						"n": 1,
						"h": 205,
						"w": 72
					},
					{
						"n": 2,
						"h": 112,
						"w": 183
					},
					{
						"n": 3,
						"h": 180,
						"w": 151
					},
					{
						"n": 4,
						"h": 263,
						"w": 162
					},
					{
						"n": 5,
						"h": 340,
						"w": 147
					},
					{
						"n": 6,
						"h": 110,
						"w": 338
					},
					{
						"n": 7,
						"h": 193,
						"w": 364
					},
					{
						"n": 8,
						"h": 405,
						"w": 310
					},
					{
						"n": 9,
						"h": 36,
						"w": 312
					},
					{
						"n": 10,
						"h": 175,
						"w": 350
					},
					{
						"n": 11,
						"h": 278,
						"w": 356
					}
				],
				"ball": {
					"n": 0,
					"h": 344,
					"w": 416,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 840,
			"minute": 41,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 15
					},
					{
						"n": 2,
						"h": 61,
						"w": 304
					},
					{
						"n": 3,
						"h": 176,
						"w": 252
					},
					{
						"n": 4,
						"h": 266,
						"w": 260
					},
					{
						"n": 5,
						"h": 373,
						"w": 310
					},
					{
						"n": 6,
						"h": 56,
						"w": 519
					},
					{
						"n": 7,
						"h": 167,
						"w": 377
					},
					{
						"n": 8,
						"h": 344,
						"w": 451
					},
					{
						"n": 9,
						"h": 391,
						"w": 464
					},
					{
						"n": 10,
						"h": 172,
						"w": 558
					},
					{
						"n": 11,
						"h": 286,
						"w": 573
					}
				],
				"away": [
					{
						"n": 1,
						"h": 205,
						"w": 77
					},
					{
						"n": 2,
						"h": 112,
						"w": 223
					},
					{
						"n": 3,
						"h": 175,
						"w": 123
					},
					{
						"n": 4,
						"h": 266,
						"w": 122
					},
					{
						"n": 5,
						"h": 340,
						"w": 108
					},
					{
						"n": 6,
						"h": 107,
						"w": 303
					},
					{
						"n": 7,
						"h": 194,
						"w": 324
					},
					{
						"n": 8,
						"h": 410,
						"w": 270
					},
					{
						"n": 9,
						"h": 51,
						"w": 275
					},
					{
						"n": 10,
						"h": 169,
						"w": 317
					},
					{
						"n": 11,
						"h": 283,
						"w": 323
					}
				],
				"ball": {
					"n": 0,
					"h": 344,
					"w": 451,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 841,
			"minute": 41,
			"messages": [
				{
					"owner": 1,
					"mes": "Киран Нолан[08](Галвэй Юнайтед) делает передачу налево на К.Колмана[06](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 17
					},
					{
						"n": 2,
						"h": 60,
						"w": 352
					},
					{
						"n": 3,
						"h": 170,
						"w": 308
					},
					{
						"n": 4,
						"h": 279,
						"w": 301
					},
					{
						"n": 5,
						"h": 381,
						"w": 344
					},
					{
						"n": 6,
						"h": 128,
						"w": 537
					},
					{
						"n": 7,
						"h": 170,
						"w": 451
					},
					{
						"n": 8,
						"h": 335,
						"w": 461
					},
					{
						"n": 9,
						"h": 403,
						"w": 537
					},
					{
						"n": 10,
						"h": 155,
						"w": 603
					},
					{
						"n": 11,
						"h": 271,
						"w": 613
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 33
					},
					{
						"n": 2,
						"h": 91,
						"w": 152
					},
					{
						"n": 3,
						"h": 192,
						"w": 84
					},
					{
						"n": 4,
						"h": 284,
						"w": 89
					},
					{
						"n": 5,
						"h": 314,
						"w": 163
					},
					{
						"n": 6,
						"h": 158,
						"w": 249
					},
					{
						"n": 7,
						"h": 219,
						"w": 255
					},
					{
						"n": 8,
						"h": 390,
						"w": 332
					},
					{
						"n": 9,
						"h": 21,
						"w": 238
					},
					{
						"n": 10,
						"h": 159,
						"w": 297
					},
					{
						"n": 11,
						"h": 280,
						"w": 305
					}
				],
				"ball": {
					"n": 0,
					"h": 128,
					"w": 537,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 74
		},
		{
			"num": 842,
			"minute": 41,
			"messages": [
				{
					"owner": 1,
					"mes": "К.Колман[06](Галвэй Юнайтед) делает передачу А.Хлинссону[07](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 17
					},
					{
						"n": 2,
						"h": 77,
						"w": 361
					},
					{
						"n": 3,
						"h": 173,
						"w": 311
					},
					{
						"n": 4,
						"h": 280,
						"w": 323
					},
					{
						"n": 5,
						"h": 381,
						"w": 369
					},
					{
						"n": 6,
						"h": 127,
						"w": 538
					},
					{
						"n": 7,
						"h": 150,
						"w": 466
					},
					{
						"n": 8,
						"h": 349,
						"w": 451
					},
					{
						"n": 9,
						"h": 406,
						"w": 574
					},
					{
						"n": 10,
						"h": 176,
						"w": 623
					},
					{
						"n": 11,
						"h": 281,
						"w": 623
					}
				],
				"away": [
					{
						"n": 1,
						"h": 229,
						"w": 12
					},
					{
						"n": 2,
						"h": 69,
						"w": 126
					},
					{
						"n": 3,
						"h": 185,
						"w": 80
					},
					{
						"n": 4,
						"h": 261,
						"w": 81
					},
					{
						"n": 5,
						"h": 334,
						"w": 132
					},
					{
						"n": 6,
						"h": 190,
						"w": 231
					},
					{
						"n": 7,
						"h": 255,
						"w": 246
					},
					{
						"n": 8,
						"h": 400,
						"w": 296
					},
					{
						"n": 9,
						"h": 32,
						"w": 228
					},
					{
						"n": 10,
						"h": 131,
						"w": 273
					},
					{
						"n": 11,
						"h": 295,
						"w": 305
					}
				],
				"ball": {
					"n": 0,
					"h": 150,
					"w": 466,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 37
		},
		{
			"num": 843,
			"minute": 41,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 13
					},
					{
						"n": 2,
						"h": 65,
						"w": 354
					},
					{
						"n": 3,
						"h": 181,
						"w": 293
					},
					{
						"n": 4,
						"h": 266,
						"w": 289
					},
					{
						"n": 5,
						"h": 383,
						"w": 358
					},
					{
						"n": 6,
						"h": 93,
						"w": 559
					},
					{
						"n": 7,
						"h": 150,
						"w": 511
					},
					{
						"n": 8,
						"h": 309,
						"w": 447
					},
					{
						"n": 9,
						"h": 413,
						"w": 573
					},
					{
						"n": 10,
						"h": 151,
						"w": 603
					},
					{
						"n": 11,
						"h": 285,
						"w": 613
					}
				],
				"away": [
					{
						"n": 1,
						"h": 226,
						"w": 16
					},
					{
						"n": 2,
						"h": 96,
						"w": 95
					},
					{
						"n": 3,
						"h": 175,
						"w": 79
					},
					{
						"n": 4,
						"h": 279,
						"w": 77
					},
					{
						"n": 5,
						"h": 351,
						"w": 154
					},
					{
						"n": 6,
						"h": 209,
						"w": 186
					},
					{
						"n": 7,
						"h": 283,
						"w": 213
					},
					{
						"n": 8,
						"h": 404,
						"w": 257
					},
					{
						"n": 9,
						"h": 41,
						"w": 238
					},
					{
						"n": 10,
						"h": 141,
						"w": 253
					},
					{
						"n": 11,
						"h": 282,
						"w": 306
					}
				],
				"ball": {
					"n": 0,
					"h": 150,
					"w": 511,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 844,
			"minute": 41,
			"messages": [
				{
					"owner": 1,
					"mes": "Пас К.Колману[06](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 13
					},
					{
						"n": 2,
						"h": 69,
						"w": 368
					},
					{
						"n": 3,
						"h": 169,
						"w": 324
					},
					{
						"n": 4,
						"h": 265,
						"w": 317
					},
					{
						"n": 5,
						"h": 382,
						"w": 371
					},
					{
						"n": 6,
						"h": 60,
						"w": 542
					},
					{
						"n": 7,
						"h": 153,
						"w": 521
					},
					{
						"n": 8,
						"h": 275,
						"w": 432
					},
					{
						"n": 9,
						"h": 393,
						"w": 604
					},
					{
						"n": 10,
						"h": 177,
						"w": 616
					},
					{
						"n": 11,
						"h": 282,
						"w": 633
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 11
					},
					{
						"n": 2,
						"h": 110,
						"w": 63
					},
					{
						"n": 3,
						"h": 178,
						"w": 65
					},
					{
						"n": 4,
						"h": 256,
						"w": 81
					},
					{
						"n": 5,
						"h": 387,
						"w": 175
					},
					{
						"n": 6,
						"h": 235,
						"w": 160
					},
					{
						"n": 7,
						"h": 292,
						"w": 188
					},
					{
						"n": 8,
						"h": 412,
						"w": 220
					},
					{
						"n": 9,
						"h": 45,
						"w": 218
					},
					{
						"n": 10,
						"h": 175,
						"w": 268
					},
					{
						"n": 11,
						"h": 277,
						"w": 306
					}
				],
				"ball": {
					"n": 0,
					"h": 60,
					"w": 542,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 37
		},
		{
			"num": 845,
			"minute": 41,
			"messages": [
				{
					"owner": 1,
					"mes": "Киэн Колман[06](Галвэй Юнайтед) технично держит мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 15
					},
					{
						"n": 2,
						"h": 62,
						"w": 361
					},
					{
						"n": 3,
						"h": 172,
						"w": 315
					},
					{
						"n": 4,
						"h": 275,
						"w": 318
					},
					{
						"n": 5,
						"h": 386,
						"w": 371
					},
					{
						"n": 6,
						"h": 70,
						"w": 540
					},
					{
						"n": 7,
						"h": 152,
						"w": 531,
						"m": 710
					},
					{
						"n": 8,
						"h": 272,
						"w": 442
					},
					{
						"n": 9,
						"h": 395,
						"w": 614
					},
					{
						"n": 10,
						"h": 169,
						"w": 622
					},
					{
						"n": 11,
						"h": 286,
						"w": 630
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 11
					},
					{
						"n": 2,
						"h": 110,
						"w": 73
					},
					{
						"n": 3,
						"h": 179,
						"w": 71
					},
					{
						"n": 4,
						"h": 266,
						"w": 84
					},
					{
						"n": 5,
						"h": 386,
						"w": 172
					},
					{
						"n": 6,
						"h": 244,
						"w": 155
					},
					{
						"n": 7,
						"h": 283,
						"w": 190
					},
					{
						"n": 8,
						"h": 412,
						"w": 220
					},
					{
						"n": 9,
						"h": 35,
						"w": 219
					},
					{
						"n": 10,
						"h": 178,
						"w": 258
					},
					{
						"n": 11,
						"h": 281,
						"w": 299
					}
				],
				"ball": {
					"n": 0,
					"h": 70,
					"w": 540,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 10
		},
		{
			"num": 846,
			"minute": 41,
			"messages": [
				{
					"owner": 1,
					"mes": "Киэн Колман[06](Галвэй Юнайтед) отдает пас на Д.Квигли[10](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 17
					},
					{
						"n": 2,
						"h": 64,
						"w": 379
					},
					{
						"n": 3,
						"h": 171,
						"w": 324
					},
					{
						"n": 4,
						"h": 274,
						"w": 313
					},
					{
						"n": 5,
						"h": 392,
						"w": 362
					},
					{
						"n": 6,
						"h": 68,
						"w": 545
					},
					{
						"n": 7,
						"h": 163,
						"w": 565
					},
					{
						"n": 8,
						"h": 296,
						"w": 438
					},
					{
						"n": 9,
						"h": 405,
						"w": 612
					},
					{
						"n": 10,
						"h": 149,
						"w": 612
					},
					{
						"n": 11,
						"h": 284,
						"w": 599
					}
				],
				"away": [
					{
						"n": 1,
						"h": 234,
						"w": 12
					},
					{
						"n": 2,
						"h": 110,
						"w": 73
					},
					{
						"n": 3,
						"h": 202,
						"w": 73
					},
					{
						"n": 4,
						"h": 291,
						"w": 88
					},
					{
						"n": 5,
						"h": 374,
						"w": 155
					},
					{
						"n": 6,
						"h": 274,
						"w": 136
					},
					{
						"n": 7,
						"h": 249,
						"w": 202
					},
					{
						"n": 8,
						"h": 410,
						"w": 204
					},
					{
						"n": 9,
						"h": 27,
						"w": 229
					},
					{
						"n": 10,
						"h": 154,
						"w": 262
					},
					{
						"n": 11,
						"h": 278,
						"w": 306
					}
				],
				"ball": {
					"n": 0,
					"h": 149,
					"w": 612,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 36
		},
		{
			"num": 847,
			"minute": 41,
			"messages": [
				{
					"owner": 1,
					"mes": "Справа открывается Адам Гилберт[11](Галвэй Юнайтед)... Передача..."
				},
				{
					"owner": 1,
					"mes": "Нир Мансур[23](Опава) делает рывок и перехватывает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 19
					},
					{
						"n": 2,
						"h": 76,
						"w": 360
					},
					{
						"n": 3,
						"h": 181,
						"w": 319
					},
					{
						"n": 4,
						"h": 282,
						"w": 316
					},
					{
						"n": 5,
						"h": 386,
						"w": 380
					},
					{
						"n": 6,
						"h": 57,
						"w": 580
					},
					{
						"n": 7,
						"h": 172,
						"w": 584
					},
					{
						"n": 8,
						"h": 286,
						"w": 473
					},
					{
						"n": 9,
						"h": 389,
						"w": 620
					},
					{
						"n": 10,
						"h": 157,
						"w": 618,
						"m": 740
					},
					{
						"n": 11,
						"h": 255,
						"w": 611,
						"m": 830
					}
				],
				"away": [
					{
						"n": 1,
						"h": 221,
						"w": 14
					},
					{
						"n": 2,
						"h": 76,
						"w": 85
					},
					{
						"n": 3,
						"h": 230,
						"w": 95
					},
					{
						"n": 4,
						"h": 256,
						"w": 82
					},
					{
						"n": 5,
						"h": 368,
						"w": 120
					},
					{
						"n": 6,
						"h": 277,
						"w": 131
					},
					{
						"n": 7,
						"h": 220,
						"w": 197
					},
					{
						"n": 8,
						"h": 418,
						"w": 190
					},
					{
						"n": 9,
						"h": 20,
						"w": 230
					},
					{
						"n": 10,
						"h": 158,
						"w": 297
					},
					{
						"n": 11,
						"h": 287,
						"w": 306
					}
				],
				"ball": {
					"n": 0,
					"h": 220,
					"w": 625,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 36
		},
		{
			"num": 848,
			"minute": 41,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 15
					},
					{
						"n": 2,
						"h": 107,
						"w": 335
					},
					{
						"n": 3,
						"h": 181,
						"w": 314
					},
					{
						"n": 4,
						"h": 262,
						"w": 323
					},
					{
						"n": 5,
						"h": 368,
						"w": 344
					},
					{
						"n": 6,
						"h": 52,
						"w": 540
					},
					{
						"n": 7,
						"h": 174,
						"w": 544
					},
					{
						"n": 8,
						"h": 276,
						"w": 434
					},
					{
						"n": 9,
						"h": 392,
						"w": 580
					},
					{
						"n": 10,
						"h": 185,
						"w": 590
					},
					{
						"n": 11,
						"h": 274,
						"w": 576
					}
				],
				"away": [
					{
						"n": 1,
						"h": 226,
						"w": 14
					},
					{
						"n": 2,
						"h": 67,
						"w": 124
					},
					{
						"n": 3,
						"h": 255,
						"w": 120,
						"m": 590
					},
					{
						"n": 4,
						"h": 282,
						"w": 91
					},
					{
						"n": 5,
						"h": 393,
						"w": 96
					},
					{
						"n": 6,
						"h": 272,
						"w": 171
					},
					{
						"n": 7,
						"h": 223,
						"w": 237
					},
					{
						"n": 8,
						"h": 414,
						"w": 230
					},
					{
						"n": 9,
						"h": 46,
						"w": 230
					},
					{
						"n": 10,
						"h": 156,
						"w": 337
					},
					{
						"n": 11,
						"h": 303,
						"w": 343
					}
				],
				"ball": {
					"n": 0,
					"h": 195,
					"w": 600,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 849,
			"minute": 41,
			"messages": [
				{
					"owner": 2,
					"mes": "Пас назад..."
				},
				{
					"owner": 2,
					"mes": "Крыштоф Ласак[21](Опава) достает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 13
					},
					{
						"n": 2,
						"h": 116,
						"w": 304
					},
					{
						"n": 3,
						"h": 184,
						"w": 287
					},
					{
						"n": 4,
						"h": 269,
						"w": 292
					},
					{
						"n": 5,
						"h": 348,
						"w": 319
					},
					{
						"n": 6,
						"h": 49,
						"w": 508
					},
					{
						"n": 7,
						"h": 178,
						"w": 512
					},
					{
						"n": 8,
						"h": 274,
						"w": 403
					},
					{
						"n": 9,
						"h": 392,
						"w": 548
					},
					{
						"n": 10,
						"h": 191,
						"w": 559
					},
					{
						"n": 11,
						"h": 257,
						"w": 603
					}
				],
				"away": [
					{
						"n": 1,
						"h": 242,
						"w": 25
					},
					{
						"n": 2,
						"h": 67,
						"w": 151
					},
					{
						"n": 3,
						"h": 245,
						"w": 118,
						"m": 600
					},
					{
						"n": 4,
						"h": 284,
						"w": 100
					},
					{
						"n": 5,
						"h": 385,
						"w": 95
					},
					{
						"n": 6,
						"h": 252,
						"w": 196
					},
					{
						"n": 7,
						"h": 228,
						"w": 269
					},
					{
						"n": 8,
						"h": 412,
						"w": 262
					},
					{
						"n": 9,
						"h": 47,
						"w": 262
					},
					{
						"n": 10,
						"h": 160,
						"w": 369
					},
					{
						"n": 11,
						"h": 284,
						"w": 369
					}
				],
				"ball": {
					"n": 0,
					"h": 208,
					"w": 695,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 32
		},
		{
			"num": 850,
			"minute": 42,
			"possession": 45,
			"messages": [
				{
					"owner": 2,
					"mes": "Крыштоф Ласак[21](Опава) посылает мяч направо в направлении Т.Прохазки[25](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 15
					},
					{
						"n": 2,
						"h": 120,
						"w": 270
					},
					{
						"n": 3,
						"h": 213,
						"w": 278
					},
					{
						"n": 4,
						"h": 284,
						"w": 271
					},
					{
						"n": 5,
						"h": 330,
						"w": 281
					},
					{
						"n": 6,
						"h": 64,
						"w": 552,
						"f": 86
					},
					{
						"n": 7,
						"h": 171,
						"w": 466
					},
					{
						"n": 8,
						"h": 251,
						"w": 361,
						"f": 84,
						"c": 2
					},
					{
						"n": 9,
						"h": 392,
						"w": 501
					},
					{
						"n": 10,
						"h": 185,
						"w": 512
					},
					{
						"n": 11,
						"h": 255,
						"w": 556
					}
				],
				"away": [
					{
						"n": 1,
						"h": 233,
						"w": 19
					},
					{
						"n": 2,
						"h": 61,
						"w": 151
					},
					{
						"n": 3,
						"h": 200,
						"w": 106
					},
					{
						"n": 4,
						"h": 271,
						"w": 95
					},
					{
						"n": 5,
						"h": 371,
						"w": 84,
						"f": 86
					},
					{
						"n": 6,
						"h": 287,
						"w": 194
					},
					{
						"n": 7,
						"h": 253,
						"w": 270
					},
					{
						"n": 8,
						"h": 406,
						"w": 309
					},
					{
						"n": 9,
						"h": 43,
						"w": 309
					},
					{
						"n": 10,
						"h": 140,
						"w": 412,
						"f": 85
					},
					{
						"n": 11,
						"h": 238,
						"w": 362,
						"f": 85
					}
				],
				"ball": {
					"n": 0,
					"h": 79,
					"w": 636,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 47
		},
		{
			"num": 851,
			"minute": 42,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 15
					},
					{
						"n": 2,
						"h": 120,
						"w": 258
					},
					{
						"n": 3,
						"h": 231,
						"w": 251
					},
					{
						"n": 4,
						"h": 271,
						"w": 263
					},
					{
						"n": 5,
						"h": 330,
						"w": 262
					},
					{
						"n": 6,
						"h": 77,
						"w": 567
					},
					{
						"n": 7,
						"h": 171,
						"w": 426
					},
					{
						"n": 8,
						"h": 246,
						"w": 340
					},
					{
						"n": 9,
						"h": 393,
						"w": 461
					},
					{
						"n": 10,
						"h": 159,
						"w": 482
					},
					{
						"n": 11,
						"h": 274,
						"w": 521
					}
				],
				"away": [
					{
						"n": 1,
						"h": 226,
						"w": 17
					},
					{
						"n": 2,
						"h": 60,
						"w": 164
					},
					{
						"n": 3,
						"h": 178,
						"w": 121
					},
					{
						"n": 4,
						"h": 271,
						"w": 133
					},
					{
						"n": 5,
						"h": 353,
						"w": 115
					},
					{
						"n": 6,
						"h": 261,
						"w": 224
					},
					{
						"n": 7,
						"h": 235,
						"w": 306
					},
					{
						"n": 8,
						"h": 409,
						"w": 349
					},
					{
						"n": 9,
						"h": 39,
						"w": 349
					},
					{
						"n": 10,
						"h": 151,
						"w": 430
					},
					{
						"n": 11,
						"h": 199,
						"w": 372
					}
				],
				"ball": {
					"n": 0,
					"h": 97,
					"w": 605,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 852,
			"minute": 42,
			"messages": [
				{
					"owner": 2,
					"mes": "Пас налево..."
				},
				{
					"owner": 2,
					"mes": "Себастьян Пейша[24](Опава) получил мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 12
					},
					{
						"n": 2,
						"h": 96,
						"w": 285
					},
					{
						"n": 3,
						"h": 225,
						"w": 255
					},
					{
						"n": 4,
						"h": 291,
						"w": 253
					},
					{
						"n": 5,
						"h": 330,
						"w": 268
					},
					{
						"n": 6,
						"h": 72,
						"w": 532
					},
					{
						"n": 7,
						"h": 189,
						"w": 394
					},
					{
						"n": 8,
						"h": 282,
						"w": 336
					},
					{
						"n": 9,
						"h": 404,
						"w": 427
					},
					{
						"n": 10,
						"h": 144,
						"w": 450
					},
					{
						"n": 11,
						"h": 289,
						"w": 488
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 17
					},
					{
						"n": 2,
						"h": 63,
						"w": 169
					},
					{
						"n": 3,
						"h": 166,
						"w": 123
					},
					{
						"n": 4,
						"h": 282,
						"w": 127
					},
					{
						"n": 5,
						"h": 363,
						"w": 114,
						"m": 660
					},
					{
						"n": 6,
						"h": 227,
						"w": 236
					},
					{
						"n": 7,
						"h": 226,
						"w": 302
					},
					{
						"n": 8,
						"h": 412,
						"w": 385
					},
					{
						"n": 9,
						"h": 39,
						"w": 385
					},
					{
						"n": 10,
						"h": 157,
						"w": 437
					},
					{
						"n": 11,
						"h": 176,
						"w": 353
					}
				],
				"ball": {
					"n": 0,
					"h": 168,
					"w": 593,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 36
		},
		{
			"num": 853,
			"minute": 42,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 15
					},
					{
						"n": 2,
						"h": 60,
						"w": 280
					},
					{
						"n": 3,
						"h": 224,
						"w": 251
					},
					{
						"n": 4,
						"h": 291,
						"w": 260
					},
					{
						"n": 5,
						"h": 330,
						"w": 259
					},
					{
						"n": 6,
						"h": 63,
						"w": 493
					},
					{
						"n": 7,
						"h": 180,
						"w": 356
					},
					{
						"n": 8,
						"h": 285,
						"w": 346
					},
					{
						"n": 9,
						"h": 394,
						"w": 388
					},
					{
						"n": 10,
						"h": 138,
						"w": 450
					},
					{
						"n": 11,
						"h": 311,
						"w": 455
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 18
					},
					{
						"n": 2,
						"h": 59,
						"w": 168
					},
					{
						"n": 3,
						"h": 167,
						"w": 106
					},
					{
						"n": 4,
						"h": 287,
						"w": 161
					},
					{
						"n": 5,
						"h": 391,
						"w": 142
					},
					{
						"n": 6,
						"h": 228,
						"w": 218
					},
					{
						"n": 7,
						"h": 224,
						"w": 314
					},
					{
						"n": 8,
						"h": 420,
						"w": 420
					},
					{
						"n": 9,
						"h": 42,
						"w": 420
					},
					{
						"n": 10,
						"h": 160,
						"w": 429
					},
					{
						"n": 11,
						"h": 159,
						"w": 369
					}
				],
				"ball": {
					"n": 0,
					"h": 163,
					"w": 559,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 854,
			"minute": 42,
			"messages": [
				{
					"owner": 2,
					"mes": "Себастьян Пейша[24](Опава) делает пас на Н.Мансура[23](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 17
					},
					{
						"n": 2,
						"h": 82,
						"w": 280
					},
					{
						"n": 3,
						"h": 217,
						"w": 269
					},
					{
						"n": 4,
						"h": 277,
						"w": 267
					},
					{
						"n": 5,
						"h": 330,
						"w": 256
					},
					{
						"n": 6,
						"h": 55,
						"w": 456
					},
					{
						"n": 7,
						"h": 180,
						"w": 337
					},
					{
						"n": 8,
						"h": 280,
						"w": 328
					},
					{
						"n": 9,
						"h": 394,
						"w": 350
					},
					{
						"n": 10,
						"h": 127,
						"w": 450
					},
					{
						"n": 11,
						"h": 320,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 12
					},
					{
						"n": 2,
						"h": 64,
						"w": 160
					},
					{
						"n": 3,
						"h": 179,
						"w": 121
					},
					{
						"n": 4,
						"h": 284,
						"w": 152,
						"m": 710
					},
					{
						"n": 5,
						"h": 388,
						"w": 127
					},
					{
						"n": 6,
						"h": 218,
						"w": 239
					},
					{
						"n": 7,
						"h": 222,
						"w": 307
					},
					{
						"n": 8,
						"h": 398,
						"w": 420
					},
					{
						"n": 9,
						"h": 31,
						"w": 420
					},
					{
						"n": 10,
						"h": 168,
						"w": 439
					},
					{
						"n": 11,
						"h": 166,
						"w": 373
					}
				],
				"ball": {
					"n": 0,
					"h": 271,
					"w": 599,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 38
		},
		{
			"num": 855,
			"minute": 42,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 10
					},
					{
						"n": 2,
						"h": 119,
						"w": 264
					},
					{
						"n": 3,
						"h": 257,
						"w": 267
					},
					{
						"n": 4,
						"h": 297,
						"w": 252
					},
					{
						"n": 5,
						"h": 330,
						"w": 269
					},
					{
						"n": 6,
						"h": 56,
						"w": 416
					},
					{
						"n": 7,
						"h": 186,
						"w": 340
					},
					{
						"n": 8,
						"h": 319,
						"w": 319
					},
					{
						"n": 9,
						"h": 394,
						"w": 310
					},
					{
						"n": 10,
						"h": 131,
						"w": 450
					},
					{
						"n": 11,
						"h": 312,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 14
					},
					{
						"n": 2,
						"h": 65,
						"w": 159
					},
					{
						"n": 3,
						"h": 163,
						"w": 153
					},
					{
						"n": 4,
						"h": 265,
						"w": 117
					},
					{
						"n": 5,
						"h": 388,
						"w": 125
					},
					{
						"n": 6,
						"h": 233,
						"w": 241
					},
					{
						"n": 7,
						"h": 239,
						"w": 312
					},
					{
						"n": 8,
						"h": 419,
						"w": 420
					},
					{
						"n": 9,
						"h": 30,
						"w": 420
					},
					{
						"n": 10,
						"h": 170,
						"w": 435
					},
					{
						"n": 11,
						"h": 135,
						"w": 383
					}
				],
				"ball": {
					"n": 0,
					"h": 287,
					"w": 567,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 856,
			"minute": 42,
			"messages": [
				{
					"owner": 2,
					"mes": "Нир Мансур[23](Опава) пасует Л.Седлачеку[22](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 18
					},
					{
						"n": 2,
						"h": 120,
						"w": 256
					},
					{
						"n": 3,
						"h": 219,
						"w": 264
					},
					{
						"n": 4,
						"h": 285,
						"w": 259
					},
					{
						"n": 5,
						"h": 330,
						"w": 256
					},
					{
						"n": 6,
						"h": 47,
						"w": 379
					},
					{
						"n": 7,
						"h": 210,
						"w": 352
					},
					{
						"n": 8,
						"h": 300,
						"w": 332
					},
					{
						"n": 9,
						"h": 383,
						"w": 275
					},
					{
						"n": 10,
						"h": 162,
						"w": 450
					},
					{
						"n": 11,
						"h": 283,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 16
					},
					{
						"n": 2,
						"h": 55,
						"w": 192
					},
					{
						"n": 3,
						"h": 167,
						"w": 144
					},
					{
						"n": 4,
						"h": 288,
						"w": 110
					},
					{
						"n": 5,
						"h": 387,
						"w": 109
					},
					{
						"n": 6,
						"h": 199,
						"w": 224
					},
					{
						"n": 7,
						"h": 201,
						"w": 313
					},
					{
						"n": 8,
						"h": 391,
						"w": 420
					},
					{
						"n": 9,
						"h": 52,
						"w": 420
					},
					{
						"n": 10,
						"h": 165,
						"w": 440
					},
					{
						"n": 11,
						"h": 154,
						"w": 355
					}
				],
				"ball": {
					"n": 0,
					"h": 395,
					"w": 528,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 38
		},
		{
			"num": 857,
			"minute": 42,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 13
					},
					{
						"n": 2,
						"h": 120,
						"w": 243
					},
					{
						"n": 3,
						"h": 257,
						"w": 251
					},
					{
						"n": 4,
						"h": 296,
						"w": 243
					},
					{
						"n": 5,
						"h": 370,
						"w": 257
					},
					{
						"n": 6,
						"h": 51,
						"w": 339
					},
					{
						"n": 7,
						"h": 201,
						"w": 318
					},
					{
						"n": 8,
						"h": 323,
						"w": 313
					},
					{
						"n": 9,
						"h": 406,
						"w": 308
					},
					{
						"n": 10,
						"h": 175,
						"w": 427
					},
					{
						"n": 11,
						"h": 280,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 226,
						"w": 17
					},
					{
						"n": 2,
						"h": 37,
						"w": 222
					},
					{
						"n": 3,
						"h": 170,
						"w": 142
					},
					{
						"n": 4,
						"h": 275,
						"w": 148
					},
					{
						"n": 5,
						"h": 377,
						"w": 148
					},
					{
						"n": 6,
						"h": 219,
						"w": 242
					},
					{
						"n": 7,
						"h": 176,
						"w": 326
					},
					{
						"n": 8,
						"h": 418,
						"w": 448
					},
					{
						"n": 9,
						"h": 32,
						"w": 443
					},
					{
						"n": 10,
						"h": 149,
						"w": 454
					},
					{
						"n": 11,
						"h": 120,
						"w": 375
					}
				],
				"ball": {
					"n": 0,
					"h": 413,
					"w": 498,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 858,
			"minute": 42,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 17
					},
					{
						"n": 2,
						"h": 120,
						"w": 203
					},
					{
						"n": 3,
						"h": 248,
						"w": 212
					},
					{
						"n": 4,
						"h": 297,
						"w": 203
					},
					{
						"n": 5,
						"h": 385,
						"w": 220
					},
					{
						"n": 6,
						"h": 49,
						"w": 319
					},
					{
						"n": 7,
						"h": 202,
						"w": 278
					},
					{
						"n": 8,
						"h": 321,
						"w": 273
					},
					{
						"n": 9,
						"h": 405,
						"w": 288
					},
					{
						"n": 10,
						"h": 175,
						"w": 400
					},
					{
						"n": 11,
						"h": 316,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 228,
						"w": 35
					},
					{
						"n": 2,
						"h": 22,
						"w": 254
					},
					{
						"n": 3,
						"h": 174,
						"w": 182
					},
					{
						"n": 4,
						"h": 275,
						"w": 188
					},
					{
						"n": 5,
						"h": 384,
						"w": 187
					},
					{
						"n": 6,
						"h": 204,
						"w": 279
					},
					{
						"n": 7,
						"h": 182,
						"w": 365
					},
					{
						"n": 8,
						"h": 414,
						"w": 488
					},
					{
						"n": 9,
						"h": 34,
						"w": 483
					},
					{
						"n": 10,
						"h": 151,
						"w": 494
					},
					{
						"n": 11,
						"h": 133,
						"w": 413
					}
				],
				"ball": {
					"n": 0,
					"h": 428,
					"w": 466,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 859,
			"minute": 42,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 12
					},
					{
						"n": 2,
						"h": 120,
						"w": 163
					},
					{
						"n": 3,
						"h": 239,
						"w": 173
					},
					{
						"n": 4,
						"h": 297,
						"w": 163
					},
					{
						"n": 5,
						"h": 400,
						"w": 204
					},
					{
						"n": 6,
						"h": 47,
						"w": 279
					},
					{
						"n": 7,
						"h": 204,
						"w": 238
					},
					{
						"n": 8,
						"h": 323,
						"w": 233
					},
					{
						"n": 9,
						"h": 402,
						"w": 328
					},
					{
						"n": 10,
						"h": 172,
						"w": 400
					},
					{
						"n": 11,
						"h": 317,
						"w": 438
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 51
					},
					{
						"n": 2,
						"h": 21,
						"w": 289
					},
					{
						"n": 3,
						"h": 177,
						"w": 222
					},
					{
						"n": 4,
						"h": 278,
						"w": 228
					},
					{
						"n": 5,
						"h": 385,
						"w": 227
					},
					{
						"n": 6,
						"h": 198,
						"w": 319
					},
					{
						"n": 7,
						"h": 194,
						"w": 403
					},
					{
						"n": 8,
						"h": 412,
						"w": 528
					},
					{
						"n": 9,
						"h": 34,
						"w": 523
					},
					{
						"n": 10,
						"h": 158,
						"w": 533
					},
					{
						"n": 11,
						"h": 130,
						"w": 453
					}
				],
				"ball": {
					"n": 0,
					"h": 429,
					"w": 431,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 860,
			"minute": 42,
			"messages": [
				{
					"owner": 2,
					"mes": "Лука Седлачек[22](Опава) бьет вперед в сторону М.Юрасека[29](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 237,
						"w": 9
					},
					{
						"n": 2,
						"h": 120,
						"w": 107
					},
					{
						"n": 3,
						"h": 232,
						"w": 117
					},
					{
						"n": 4,
						"h": 305,
						"w": 108
					},
					{
						"n": 5,
						"h": 421,
						"w": 153
					},
					{
						"n": 6,
						"h": 52,
						"w": 223
					},
					{
						"n": 7,
						"h": 211,
						"w": 182
					},
					{
						"n": 8,
						"h": 340,
						"w": 180
					},
					{
						"n": 9,
						"h": 405,
						"w": 272
					},
					{
						"n": 10,
						"h": 161,
						"w": 345
					},
					{
						"n": 11,
						"h": 306,
						"w": 400
					}
				],
				"away": [
					{
						"n": 1,
						"h": 229,
						"w": 73
					},
					{
						"n": 2,
						"h": 41,
						"w": 312
					},
					{
						"n": 3,
						"h": 175,
						"w": 278
					},
					{
						"n": 4,
						"h": 281,
						"w": 284
					},
					{
						"n": 5,
						"h": 391,
						"w": 283
					},
					{
						"n": 6,
						"h": 202,
						"w": 375
					},
					{
						"n": 7,
						"h": 194,
						"w": 459
					},
					{
						"n": 8,
						"h": 413,
						"w": 584
					},
					{
						"n": 9,
						"h": 29,
						"w": 567
					},
					{
						"n": 10,
						"h": 102,
						"w": 535
					},
					{
						"n": 11,
						"h": 102,
						"w": 501
					}
				],
				"ball": {
					"n": 0,
					"h": 421,
					"w": 153,
					"z": 1,
					"r": 0,
					"p": 4,
					"x": 0
				}
			},
			"interval": 56
		},
		{
			"num": 861,
			"minute": 42,
			"messages": [
				{
					"owner": 1,
					"mes": "Самуэль Кари Фридйонссон[05](Галвэй Юнайтед) в борьбе с М.Юрасеком[29](Опава) сбрасывает мяч головой..."
				},
				{
					"owner": 1,
					"mes": "Киран Нолан[08](Галвэй Юнайтед) с мячом..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 14
					},
					{
						"n": 2,
						"h": 93,
						"w": 96
					},
					{
						"n": 3,
						"h": 224,
						"w": 89
					},
					{
						"n": 4,
						"h": 309,
						"w": 79
					},
					{
						"n": 5,
						"h": 421,
						"w": 153
					},
					{
						"n": 6,
						"h": 54,
						"w": 195
					},
					{
						"n": 7,
						"h": 187,
						"w": 165
					},
					{
						"n": 8,
						"h": 338,
						"w": 177
					},
					{
						"n": 9,
						"h": 403,
						"w": 243
					},
					{
						"n": 10,
						"h": 166,
						"w": 374
					},
					{
						"n": 11,
						"h": 307,
						"w": 400
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 90
					},
					{
						"n": 2,
						"h": 56,
						"w": 337
					},
					{
						"n": 3,
						"h": 173,
						"w": 299
					},
					{
						"n": 4,
						"h": 282,
						"w": 307
					},
					{
						"n": 5,
						"h": 392,
						"w": 291
					},
					{
						"n": 6,
						"h": 227,
						"w": 389
					},
					{
						"n": 7,
						"h": 215,
						"w": 480
					},
					{
						"n": 8,
						"h": 404,
						"w": 611
					},
					{
						"n": 9,
						"h": 29,
						"w": 567,
						"m": 630
					},
					{
						"n": 10,
						"h": 118,
						"w": 559
					},
					{
						"n": 11,
						"h": 124,
						"w": 519
					}
				],
				"ball": {
					"n": 0,
					"h": 338,
					"w": 177,
					"z": 1,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 29
		},
		{
			"num": 862,
			"minute": 42,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 16
					},
					{
						"n": 2,
						"h": 82,
						"w": 134
					},
					{
						"n": 3,
						"h": 198,
						"w": 119
					},
					{
						"n": 4,
						"h": 287,
						"w": 112
					},
					{
						"n": 5,
						"h": 387,
						"w": 172
					},
					{
						"n": 6,
						"h": 51,
						"w": 234
					},
					{
						"n": 7,
						"h": 179,
						"w": 205
					},
					{
						"n": 8,
						"h": 344,
						"w": 212
					},
					{
						"n": 9,
						"h": 410,
						"w": 282
					},
					{
						"n": 10,
						"h": 156,
						"w": 413
					},
					{
						"n": 11,
						"h": 293,
						"w": 417
					}
				],
				"away": [
					{
						"n": 1,
						"h": 205,
						"w": 71
					},
					{
						"n": 2,
						"h": 77,
						"w": 303
					},
					{
						"n": 3,
						"h": 174,
						"w": 259
					},
					{
						"n": 4,
						"h": 278,
						"w": 267
					},
					{
						"n": 5,
						"h": 363,
						"w": 263
					},
					{
						"n": 6,
						"h": 252,
						"w": 358
					},
					{
						"n": 7,
						"h": 207,
						"w": 441
					},
					{
						"n": 8,
						"h": 405,
						"w": 571
					},
					{
						"n": 9,
						"h": 34,
						"w": 528
					},
					{
						"n": 10,
						"h": 133,
						"w": 522
					},
					{
						"n": 11,
						"h": 106,
						"w": 488
					}
				],
				"ball": {
					"n": 0,
					"h": 344,
					"w": 212,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 863,
			"minute": 42,
			"messages": [
				{
					"owner": 1,
					"mes": "Киран Нолан[08](Галвэй Юнайтед) пасует на ход Э.Бвомоно[09](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 16
					},
					{
						"n": 2,
						"h": 77,
						"w": 177
					},
					{
						"n": 3,
						"h": 173,
						"w": 152
					},
					{
						"n": 4,
						"h": 284,
						"w": 155
					},
					{
						"n": 5,
						"h": 389,
						"w": 211
					},
					{
						"n": 6,
						"h": 50,
						"w": 277
					},
					{
						"n": 7,
						"h": 186,
						"w": 247
					},
					{
						"n": 8,
						"h": 344,
						"w": 212,
						"m": 620
					},
					{
						"n": 9,
						"h": 390,
						"w": 332
					},
					{
						"n": 10,
						"h": 156,
						"w": 455
					},
					{
						"n": 11,
						"h": 284,
						"w": 459
					}
				],
				"away": [
					{
						"n": 1,
						"h": 205,
						"w": 75
					},
					{
						"n": 2,
						"h": 82,
						"w": 346
					},
					{
						"n": 3,
						"h": 185,
						"w": 221
					},
					{
						"n": 4,
						"h": 282,
						"w": 224
					},
					{
						"n": 5,
						"h": 340,
						"w": 230
					},
					{
						"n": 6,
						"h": 271,
						"w": 319
					},
					{
						"n": 7,
						"h": 206,
						"w": 398
					},
					{
						"n": 8,
						"h": 407,
						"w": 529
					},
					{
						"n": 9,
						"h": 38,
						"w": 485
					},
					{
						"n": 10,
						"h": 106,
						"w": 488
					},
					{
						"n": 11,
						"h": 148,
						"w": 479
					}
				],
				"ball": {
					"n": 0,
					"h": 390,
					"w": 332,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 43
		},
		{
			"num": 864,
			"minute": 42,
			"messages": [
				{
					"owner": 1,
					"mes": "Э.Бвомоно[09](Галвэй Юнайтед) отдает передачу А.Хлинссону[07](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 16
					},
					{
						"n": 2,
						"h": 64,
						"w": 226
					},
					{
						"n": 3,
						"h": 171,
						"w": 180
					},
					{
						"n": 4,
						"h": 284,
						"w": 192
					},
					{
						"n": 5,
						"h": 388,
						"w": 238
					},
					{
						"n": 6,
						"h": 50,
						"w": 328
					},
					{
						"n": 7,
						"h": 199,
						"w": 264
					},
					{
						"n": 8,
						"h": 329,
						"w": 260
					},
					{
						"n": 9,
						"h": 393,
						"w": 353
					},
					{
						"n": 10,
						"h": 166,
						"w": 484
					},
					{
						"n": 11,
						"h": 300,
						"w": 499
					}
				],
				"away": [
					{
						"n": 1,
						"h": 229,
						"w": 73
					},
					{
						"n": 2,
						"h": 84,
						"w": 295
					},
					{
						"n": 3,
						"h": 167,
						"w": 197
					},
					{
						"n": 4,
						"h": 272,
						"w": 178
					},
					{
						"n": 5,
						"h": 340,
						"w": 191
					},
					{
						"n": 6,
						"h": 277,
						"w": 269
					},
					{
						"n": 7,
						"h": 213,
						"w": 347
					},
					{
						"n": 8,
						"h": 405,
						"w": 478
					},
					{
						"n": 9,
						"h": 43,
						"w": 434
					},
					{
						"n": 10,
						"h": 121,
						"w": 440
					},
					{
						"n": 11,
						"h": 195,
						"w": 460
					}
				],
				"ball": {
					"n": 0,
					"h": 199,
					"w": 264,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 51
		},
		{
			"num": 865,
			"minute": 42,
			"messages": [
				{
					"owner": 1,
					"mes": "Агуст Хлинссон[07](Галвэй Юнайтед) пасует на Т.Эверса[02](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 13
					},
					{
						"n": 2,
						"h": 98,
						"w": 236
					},
					{
						"n": 3,
						"h": 181,
						"w": 213
					},
					{
						"n": 4,
						"h": 268,
						"w": 223
					},
					{
						"n": 5,
						"h": 384,
						"w": 273
					},
					{
						"n": 6,
						"h": 54,
						"w": 363
					},
					{
						"n": 7,
						"h": 197,
						"w": 268
					},
					{
						"n": 8,
						"h": 298,
						"w": 276
					},
					{
						"n": 9,
						"h": 394,
						"w": 388
					},
					{
						"n": 10,
						"h": 159,
						"w": 517
					},
					{
						"n": 11,
						"h": 294,
						"w": 533
					}
				],
				"away": [
					{
						"n": 1,
						"h": 245,
						"w": 70
					},
					{
						"n": 2,
						"h": 82,
						"w": 260
					},
					{
						"n": 3,
						"h": 172,
						"w": 162
					},
					{
						"n": 4,
						"h": 277,
						"w": 162
					},
					{
						"n": 5,
						"h": 340,
						"w": 156
					},
					{
						"n": 6,
						"h": 279,
						"w": 234
					},
					{
						"n": 7,
						"h": 234,
						"w": 319
					},
					{
						"n": 8,
						"h": 403,
						"w": 443
					},
					{
						"n": 9,
						"h": 44,
						"w": 399
					},
					{
						"n": 10,
						"h": 127,
						"w": 405
					},
					{
						"n": 11,
						"h": 218,
						"w": 433
					}
				],
				"ball": {
					"n": 0,
					"h": 98,
					"w": 236,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 35
		},
		{
			"num": 866,
			"minute": 42,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 17
					},
					{
						"n": 2,
						"h": 82,
						"w": 273
					},
					{
						"n": 3,
						"h": 165,
						"w": 250
					},
					{
						"n": 4,
						"h": 272,
						"w": 255
					},
					{
						"n": 5,
						"h": 375,
						"w": 301
					},
					{
						"n": 6,
						"h": 62,
						"w": 402
					},
					{
						"n": 7,
						"h": 187,
						"w": 307
					},
					{
						"n": 8,
						"h": 274,
						"w": 308
					},
					{
						"n": 9,
						"h": 398,
						"w": 428
					},
					{
						"n": 10,
						"h": 160,
						"w": 543
					},
					{
						"n": 11,
						"h": 284,
						"w": 564
					}
				],
				"away": [
					{
						"n": 1,
						"h": 245,
						"w": 78
					},
					{
						"n": 2,
						"h": 82,
						"w": 220
					},
					{
						"n": 3,
						"h": 176,
						"w": 126
					},
					{
						"n": 4,
						"h": 272,
						"w": 132
					},
					{
						"n": 5,
						"h": 340,
						"w": 134
					},
					{
						"n": 6,
						"h": 279,
						"w": 194
					},
					{
						"n": 7,
						"h": 251,
						"w": 283
					},
					{
						"n": 8,
						"h": 399,
						"w": 397
					},
					{
						"n": 9,
						"h": 40,
						"w": 360
					},
					{
						"n": 10,
						"h": 166,
						"w": 395
					},
					{
						"n": 11,
						"h": 248,
						"w": 406
					}
				],
				"ball": {
					"n": 0,
					"h": 82,
					"w": 273,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 867,
			"minute": 42,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 15
					},
					{
						"n": 2,
						"h": 64,
						"w": 308
					},
					{
						"n": 3,
						"h": 182,
						"w": 270
					},
					{
						"n": 4,
						"h": 278,
						"w": 276
					},
					{
						"n": 5,
						"h": 385,
						"w": 332
					},
					{
						"n": 6,
						"h": 63,
						"w": 442
					},
					{
						"n": 7,
						"h": 175,
						"w": 345
					},
					{
						"n": 8,
						"h": 256,
						"w": 344
					},
					{
						"n": 9,
						"h": 397,
						"w": 468
					},
					{
						"n": 10,
						"h": 173,
						"w": 579
					},
					{
						"n": 11,
						"h": 285,
						"w": 594
					}
				],
				"away": [
					{
						"n": 1,
						"h": 245,
						"w": 76
					},
					{
						"n": 2,
						"h": 81,
						"w": 180
					},
					{
						"n": 3,
						"h": 180,
						"w": 104
					},
					{
						"n": 4,
						"h": 258,
						"w": 115
					},
					{
						"n": 5,
						"h": 340,
						"w": 103
					},
					{
						"n": 6,
						"h": 280,
						"w": 154
					},
					{
						"n": 7,
						"h": 250,
						"w": 243
					},
					{
						"n": 8,
						"h": 395,
						"w": 352
					},
					{
						"n": 9,
						"h": 41,
						"w": 320
					},
					{
						"n": 10,
						"h": 189,
						"w": 362
					},
					{
						"n": 11,
						"h": 267,
						"w": 371
					}
				],
				"ball": {
					"n": 0,
					"h": 64,
					"w": 308,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 868,
			"minute": 42,
			"messages": [
				{
					"owner": 1,
					"mes": "Передача вперед..."
				},
				{
					"owner": 1,
					"mes": "Киэн Колман[06](Галвэй Юнайтед) получил мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 19
					},
					{
						"n": 2,
						"h": 63,
						"w": 318,
						"m": 640
					},
					{
						"n": 3,
						"h": 180,
						"w": 299
					},
					{
						"n": 4,
						"h": 269,
						"w": 308
					},
					{
						"n": 5,
						"h": 386,
						"w": 353
					},
					{
						"n": 6,
						"h": 106,
						"w": 453
					},
					{
						"n": 7,
						"h": 170,
						"w": 395
					},
					{
						"n": 8,
						"h": 291,
						"w": 380
					},
					{
						"n": 9,
						"h": 401,
						"w": 517
					},
					{
						"n": 10,
						"h": 170,
						"w": 603
					},
					{
						"n": 11,
						"h": 271,
						"w": 613
					}
				],
				"away": [
					{
						"n": 1,
						"h": 245,
						"w": 57
					},
					{
						"n": 2,
						"h": 86,
						"w": 130
					},
					{
						"n": 3,
						"h": 199,
						"w": 94
					},
					{
						"n": 4,
						"h": 268,
						"w": 81
					},
					{
						"n": 5,
						"h": 340,
						"w": 97
					},
					{
						"n": 6,
						"h": 265,
						"w": 141
					},
					{
						"n": 7,
						"h": 300,
						"w": 244
					},
					{
						"n": 8,
						"h": 379,
						"w": 327
					},
					{
						"n": 9,
						"h": 46,
						"w": 270
					},
					{
						"n": 10,
						"h": 160,
						"w": 321
					},
					{
						"n": 11,
						"h": 277,
						"w": 322
					}
				],
				"ball": {
					"n": 0,
					"h": 106,
					"w": 453,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 50
		},
		{
			"num": 869,
			"minute": 43,
			"possession": 45,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 11
					},
					{
						"n": 2,
						"h": 74,
						"w": 351
					},
					{
						"n": 3,
						"h": 179,
						"w": 318
					},
					{
						"n": 4,
						"h": 281,
						"w": 326,
						"f": 89,
						"c": 1
					},
					{
						"n": 5,
						"h": 386,
						"w": 366
					},
					{
						"n": 6,
						"h": 86,
						"w": 488
					},
					{
						"n": 7,
						"h": 165,
						"w": 430
					},
					{
						"n": 8,
						"h": 262,
						"w": 400
					},
					{
						"n": 9,
						"h": 404,
						"w": 552
					},
					{
						"n": 10,
						"h": 162,
						"w": 603
					},
					{
						"n": 11,
						"h": 275,
						"w": 613
					}
				],
				"away": [
					{
						"n": 1,
						"h": 232,
						"w": 24,
						"f": 87
					},
					{
						"n": 2,
						"h": 107,
						"w": 102,
						"f": 84,
						"c": 2
					},
					{
						"n": 3,
						"h": 187,
						"w": 79
					},
					{
						"n": 4,
						"h": 269,
						"w": 100,
						"f": 86
					},
					{
						"n": 5,
						"h": 374,
						"w": 90
					},
					{
						"n": 6,
						"h": 300,
						"w": 141,
						"f": 86
					},
					{
						"n": 7,
						"h": 333,
						"w": 225
					},
					{
						"n": 8,
						"h": 387,
						"w": 293
					},
					{
						"n": 9,
						"h": 53,
						"w": 238
					},
					{
						"n": 10,
						"h": 188,
						"w": 300
					},
					{
						"n": 11,
						"h": 282,
						"w": 288
					}
				],
				"ball": {
					"n": 0,
					"h": 86,
					"w": 488,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 35
		},
		{
			"num": 870,
			"minute": 43,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 16
					},
					{
						"n": 2,
						"h": 72,
						"w": 368
					},
					{
						"n": 3,
						"h": 180,
						"w": 309
					},
					{
						"n": 4,
						"h": 269,
						"w": 308
					},
					{
						"n": 5,
						"h": 392,
						"w": 362
					},
					{
						"n": 6,
						"h": 86,
						"w": 535
					},
					{
						"n": 7,
						"h": 156,
						"w": 469
					},
					{
						"n": 8,
						"h": 255,
						"w": 440
					},
					{
						"n": 9,
						"h": 395,
						"w": 591
					},
					{
						"n": 10,
						"h": 152,
						"w": 623
					},
					{
						"n": 11,
						"h": 296,
						"w": 633
					}
				],
				"away": [
					{
						"n": 1,
						"h": 234,
						"w": 12
					},
					{
						"n": 2,
						"h": 110,
						"w": 63
					},
					{
						"n": 3,
						"h": 174,
						"w": 62
					},
					{
						"n": 4,
						"h": 284,
						"w": 71
					},
					{
						"n": 5,
						"h": 365,
						"w": 135
					},
					{
						"n": 6,
						"h": 285,
						"w": 131
					},
					{
						"n": 7,
						"h": 355,
						"w": 188
					},
					{
						"n": 8,
						"h": 391,
						"w": 253
					},
					{
						"n": 9,
						"h": 21,
						"w": 218
					},
					{
						"n": 10,
						"h": 195,
						"w": 260
					},
					{
						"n": 11,
						"h": 285,
						"w": 294
					}
				],
				"ball": {
					"n": 0,
					"h": 86,
					"w": 535,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 871,
			"minute": 43,
			"messages": [
				{
					"owner": 1,
					"mes": "Киэн Колман[06](Галвэй Юнайтед) отдает мяч рванувшемуся вперед Д.Квигли[10](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 17
					},
					{
						"n": 2,
						"h": 71,
						"w": 376
					},
					{
						"n": 3,
						"h": 168,
						"w": 325
					},
					{
						"n": 4,
						"h": 278,
						"w": 329
					},
					{
						"n": 5,
						"h": 373,
						"w": 367
					},
					{
						"n": 6,
						"h": 86,
						"w": 535,
						"m": 690
					},
					{
						"n": 7,
						"h": 162,
						"w": 513
					},
					{
						"n": 8,
						"h": 273,
						"w": 429
					},
					{
						"n": 9,
						"h": 404,
						"w": 635
					},
					{
						"n": 10,
						"h": 127,
						"w": 663
					},
					{
						"n": 11,
						"h": 252,
						"w": 641
					}
				],
				"away": [
					{
						"n": 1,
						"h": 238,
						"w": 8
					},
					{
						"n": 2,
						"h": 110,
						"w": 46
					},
					{
						"n": 3,
						"h": 198,
						"w": 45
					},
					{
						"n": 4,
						"h": 301,
						"w": 52
					},
					{
						"n": 5,
						"h": 356,
						"w": 165
					},
					{
						"n": 6,
						"h": 246,
						"w": 108
					},
					{
						"n": 7,
						"h": 312,
						"w": 174
					},
					{
						"n": 8,
						"h": 395,
						"w": 208
					},
					{
						"n": 9,
						"h": 43,
						"w": 190
					},
					{
						"n": 10,
						"h": 177,
						"w": 271
					},
					{
						"n": 11,
						"h": 278,
						"w": 308
					}
				],
				"ball": {
					"n": 0,
					"h": 127,
					"w": 663,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 45
		},
		{
			"num": 872,
			"minute": 43,
			"messages": [
				{
					"owner": 1,
					"mes": "Подкручивает мяч в ворота..."
				},
				{
					"owner": 1,
					"mes": "Мимо!"
				}
			],
			"U": {
				"team": 1,
				"player": 10,
				"xg": "0.06"
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 12
					},
					{
						"n": 2,
						"h": 72,
						"w": 376
					},
					{
						"n": 3,
						"h": 174,
						"w": 325
					},
					{
						"n": 4,
						"h": 274,
						"w": 313
					},
					{
						"n": 5,
						"h": 387,
						"w": 363
					},
					{
						"n": 6,
						"h": 79,
						"w": 577
					},
					{
						"n": 7,
						"h": 168,
						"w": 556
					},
					{
						"n": 8,
						"h": 278,
						"w": 472
					},
					{
						"n": 9,
						"h": 397,
						"w": 644
					},
					{
						"n": 10,
						"h": 127,
						"w": 663
					},
					{
						"n": 11,
						"h": 226,
						"w": 652
					}
				],
				"away": [
					{
						"n": 1,
						"h": 205,
						"w": 8
					},
					{
						"n": 2,
						"h": 110,
						"w": 38
					},
					{
						"n": 3,
						"h": 219,
						"w": 36
					},
					{
						"n": 4,
						"h": 319,
						"w": 54
					},
					{
						"n": 5,
						"h": 364,
						"w": 123
					},
					{
						"n": 6,
						"h": 266,
						"w": 100
					},
					{
						"n": 7,
						"h": 291,
						"w": 155
					},
					{
						"n": 8,
						"h": 402,
						"w": 186
					},
					{
						"n": 9,
						"h": 35,
						"w": 190
					},
					{
						"n": 10,
						"h": 172,
						"w": 228
					},
					{
						"n": 11,
						"h": 281,
						"w": 310
					}
				],
				"ball": {
					"n": 0,
					"h": 323,
					"w": 750,
					"z": 0,
					"r": 0,
					"p": 1,
					"x": 6
				}
			},
			"interval": 43
		},
		{
			"num": 873,
			"minute": 43,
			"messages": [
				{
					"owner": 2,
					"mes": "Удар от ворот..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 40
					},
					{
						"n": 2,
						"h": 68,
						"w": 177
					},
					{
						"n": 3,
						"h": 171,
						"w": 150
					},
					{
						"n": 4,
						"h": 276,
						"w": 150
					},
					{
						"n": 5,
						"h": 366,
						"w": 172
					},
					{
						"n": 6,
						"h": 80,
						"w": 279
					},
					{
						"n": 7,
						"h": 172,
						"w": 250
					},
					{
						"n": 8,
						"h": 282,
						"w": 250
					},
					{
						"n": 9,
						"h": 383,
						"w": 271
					},
					{
						"n": 10,
						"h": 168,
						"w": 350
					},
					{
						"n": 11,
						"h": 284,
						"w": 350
					}
				],
				"away": [
					{
						"n": 1,
						"h": 194,
						"w": 14
					},
					{
						"n": 2,
						"h": 53,
						"w": 175
					},
					{
						"n": 3,
						"h": 165,
						"w": 175
					},
					{
						"n": 4,
						"h": 284,
						"w": 175
					},
					{
						"n": 5,
						"h": 401,
						"w": 175
					},
					{
						"n": 6,
						"h": 233,
						"w": 283
					},
					{
						"n": 7,
						"h": 231,
						"w": 392
					},
					{
						"n": 8,
						"h": 382,
						"w": 372
					},
					{
						"n": 9,
						"h": 63,
						"w": 422
					},
					{
						"n": 10,
						"h": 164,
						"w": 500,
						"m": 640
					},
					{
						"n": 11,
						"h": 296,
						"w": 500
					}
				],
				"ball": {
					"n": 0,
					"h": 260,
					"w": 686,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 150
		},
		{
			"num": 874,
			"minute": 43,
			"messages": [],
			"T": {
				"team": 2
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 42
					},
					{
						"n": 2,
						"h": 73,
						"w": 172
					},
					{
						"n": 3,
						"h": 165,
						"w": 156
					},
					{
						"n": 4,
						"h": 273,
						"w": 155
					},
					{
						"n": 5,
						"h": 368,
						"w": 173
					},
					{
						"n": 6,
						"h": 86,
						"w": 272
					},
					{
						"n": 7,
						"h": 176,
						"w": 250
					},
					{
						"n": 8,
						"h": 282,
						"w": 246
					},
					{
						"n": 9,
						"h": 387,
						"w": 268
					},
					{
						"n": 10,
						"h": 161,
						"w": 347
					},
					{
						"n": 11,
						"h": 291,
						"w": 346
					}
				],
				"away": [
					{
						"n": 1,
						"h": 190,
						"w": 34
					},
					{
						"n": 2,
						"h": 54,
						"w": 178
					},
					{
						"n": 3,
						"h": 172,
						"w": 170
					},
					{
						"n": 4,
						"h": 285,
						"w": 176
					},
					{
						"n": 5,
						"h": 396,
						"w": 171
					},
					{
						"n": 6,
						"h": 232,
						"w": 277
					},
					{
						"n": 7,
						"h": 227,
						"w": 398
					},
					{
						"n": 8,
						"h": 375,
						"w": 366
					},
					{
						"n": 9,
						"h": 64,
						"w": 419
					},
					{
						"n": 10,
						"h": 160,
						"w": 506
					},
					{
						"n": 11,
						"h": 291,
						"w": 493
					}
				],
				"ball": {
					"n": 0,
					"h": 260,
					"w": 686,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 15
		},
		{
			"num": 875,
			"minute": 43,
			"messages": [
				{
					"owner": 2,
					"mes": "Крыштоф Ласак[21](Опава) выбивает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 14
					},
					{
						"n": 2,
						"h": 120,
						"w": 134
					},
					{
						"n": 3,
						"h": 171,
						"w": 136
					},
					{
						"n": 4,
						"h": 279,
						"w": 144
					},
					{
						"n": 5,
						"h": 330,
						"w": 136
					},
					{
						"n": 6,
						"h": 60,
						"w": 228
					},
					{
						"n": 7,
						"h": 166,
						"w": 228
					},
					{
						"n": 8,
						"h": 324,
						"w": 233
					},
					{
						"n": 9,
						"h": 399,
						"w": 242
					},
					{
						"n": 10,
						"h": 129,
						"w": 400
					},
					{
						"n": 11,
						"h": 312,
						"w": 436
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 53
					},
					{
						"n": 2,
						"h": 66,
						"w": 220
					},
					{
						"n": 3,
						"h": 172,
						"w": 166
					},
					{
						"n": 4,
						"h": 275,
						"w": 165
					},
					{
						"n": 5,
						"h": 376,
						"w": 182
					},
					{
						"n": 6,
						"h": 200,
						"w": 301
					},
					{
						"n": 7,
						"h": 135,
						"w": 398
					},
					{
						"n": 8,
						"h": 390,
						"w": 457
					},
					{
						"n": 9,
						"h": 119,
						"w": 479
					},
					{
						"n": 10,
						"h": 156,
						"w": 517
					},
					{
						"n": 11,
						"h": 294,
						"w": 488
					}
				],
				"ball": {
					"n": 0,
					"h": 324,
					"w": 233,
					"z": 1,
					"r": 0,
					"p": 4,
					"x": 0
				}
			},
			"interval": 92
		},
		{
			"num": 876,
			"minute": 43,
			"messages": [
				{
					"owner": 1,
					"mes": "Киран Нолан[08](Галвэй Юнайтед) скидывает мяч головой..."
				},
				{
					"owner": 1,
					"mes": "Элвис Бвомоно[09](Галвэй Юнайтед) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 13
					},
					{
						"n": 2,
						"h": 98,
						"w": 122
					},
					{
						"n": 3,
						"h": 146,
						"w": 128
					},
					{
						"n": 4,
						"h": 257,
						"w": 129
					},
					{
						"n": 5,
						"h": 330,
						"w": 113
					},
					{
						"n": 6,
						"h": 74,
						"w": 235
					},
					{
						"n": 7,
						"h": 151,
						"w": 206
					},
					{
						"n": 8,
						"h": 324,
						"w": 233
					},
					{
						"n": 9,
						"h": 402,
						"w": 242
					},
					{
						"n": 10,
						"h": 155,
						"w": 400
					},
					{
						"n": 11,
						"h": 288,
						"w": 447
					}
				],
				"away": [
					{
						"n": 1,
						"h": 226,
						"w": 73
					},
					{
						"n": 2,
						"h": 68,
						"w": 233
					},
					{
						"n": 3,
						"h": 168,
						"w": 175
					},
					{
						"n": 4,
						"h": 283,
						"w": 168
					},
					{
						"n": 5,
						"h": 377,
						"w": 191
					},
					{
						"n": 6,
						"h": 225,
						"w": 296
					},
					{
						"n": 7,
						"h": 160,
						"w": 391
					},
					{
						"n": 8,
						"h": 392,
						"w": 470
					},
					{
						"n": 9,
						"h": 119,
						"w": 479
					},
					{
						"n": 10,
						"h": 154,
						"w": 491
					},
					{
						"n": 11,
						"h": 312,
						"w": 506
					}
				],
				"ball": {
					"n": 0,
					"h": 402,
					"w": 242,
					"z": 1,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 26
		},
		{
			"num": 877,
			"minute": 43,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 15
					},
					{
						"n": 2,
						"h": 90,
						"w": 161
					},
					{
						"n": 3,
						"h": 159,
						"w": 166
					},
					{
						"n": 4,
						"h": 263,
						"w": 169
					},
					{
						"n": 5,
						"h": 345,
						"w": 150
					},
					{
						"n": 6,
						"h": 66,
						"w": 274
					},
					{
						"n": 7,
						"h": 160,
						"w": 245
					},
					{
						"n": 8,
						"h": 315,
						"w": 268
					},
					{
						"n": 9,
						"h": 433,
						"w": 260
					},
					{
						"n": 10,
						"h": 153,
						"w": 440
					},
					{
						"n": 11,
						"h": 294,
						"w": 487
					}
				],
				"away": [
					{
						"n": 1,
						"h": 205,
						"w": 74
					},
					{
						"n": 2,
						"h": 70,
						"w": 193
					},
					{
						"n": 3,
						"h": 172,
						"w": 174
					},
					{
						"n": 4,
						"h": 278,
						"w": 173
					},
					{
						"n": 5,
						"h": 346,
						"w": 166
					},
					{
						"n": 6,
						"h": 199,
						"w": 266
					},
					{
						"n": 7,
						"h": 177,
						"w": 355
					},
					{
						"n": 8,
						"h": 394,
						"w": 430
					},
					{
						"n": 9,
						"h": 101,
						"w": 447
					},
					{
						"n": 10,
						"h": 142,
						"w": 453
					},
					{
						"n": 11,
						"h": 296,
						"w": 470
					}
				],
				"ball": {
					"n": 0,
					"h": 433,
					"w": 260,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 878,
			"minute": 43,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 15
					},
					{
						"n": 2,
						"h": 84,
						"w": 201
					},
					{
						"n": 3,
						"h": 172,
						"w": 204
					},
					{
						"n": 4,
						"h": 275,
						"w": 207
					},
					{
						"n": 5,
						"h": 354,
						"w": 189
					},
					{
						"n": 6,
						"h": 56,
						"w": 312
					},
					{
						"n": 7,
						"h": 166,
						"w": 285
					},
					{
						"n": 8,
						"h": 312,
						"w": 307
					},
					{
						"n": 9,
						"h": 430,
						"w": 295
					},
					{
						"n": 10,
						"h": 147,
						"w": 479
					},
					{
						"n": 11,
						"h": 304,
						"w": 525
					}
				],
				"away": [
					{
						"n": 1,
						"h": 205,
						"w": 74
					},
					{
						"n": 2,
						"h": 96,
						"w": 162
					},
					{
						"n": 3,
						"h": 178,
						"w": 141
					},
					{
						"n": 4,
						"h": 263,
						"w": 143
					},
					{
						"n": 5,
						"h": 340,
						"w": 133
					},
					{
						"n": 6,
						"h": 174,
						"w": 235
					},
					{
						"n": 7,
						"h": 189,
						"w": 317
					},
					{
						"n": 8,
						"h": 396,
						"w": 391
					},
					{
						"n": 9,
						"h": 68,
						"w": 425
					},
					{
						"n": 10,
						"h": 139,
						"w": 413
					},
					{
						"n": 11,
						"h": 287,
						"w": 431
					}
				],
				"ball": {
					"n": 0,
					"h": 430,
					"w": 295,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 879,
			"minute": 43,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 17
					},
					{
						"n": 2,
						"h": 80,
						"w": 241
					},
					{
						"n": 3,
						"h": 172,
						"w": 244
					},
					{
						"n": 4,
						"h": 280,
						"w": 246
					},
					{
						"n": 5,
						"h": 362,
						"w": 228
					},
					{
						"n": 6,
						"h": 54,
						"w": 352
					},
					{
						"n": 7,
						"h": 173,
						"w": 324
					},
					{
						"n": 8,
						"h": 301,
						"w": 346
					},
					{
						"n": 9,
						"h": 427,
						"w": 339
					},
					{
						"n": 10,
						"h": 149,
						"w": 519
					},
					{
						"n": 11,
						"h": 302,
						"w": 558
					}
				],
				"away": [
					{
						"n": 1,
						"h": 205,
						"w": 74
					},
					{
						"n": 2,
						"h": 80,
						"w": 125
					},
					{
						"n": 3,
						"h": 167,
						"w": 108
					},
					{
						"n": 4,
						"h": 272,
						"w": 104
					},
					{
						"n": 5,
						"h": 340,
						"w": 105
					},
					{
						"n": 6,
						"h": 159,
						"w": 198
					},
					{
						"n": 7,
						"h": 196,
						"w": 274
					},
					{
						"n": 8,
						"h": 396,
						"w": 351
					},
					{
						"n": 9,
						"h": 51,
						"w": 382
					},
					{
						"n": 10,
						"h": 146,
						"w": 374
					},
					{
						"n": 11,
						"h": 280,
						"w": 392
					}
				],
				"ball": {
					"n": 0,
					"h": 427,
					"w": 339,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 880,
			"minute": 43,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 14
					},
					{
						"n": 2,
						"h": 79,
						"w": 280
					},
					{
						"n": 3,
						"h": 179,
						"w": 283
					},
					{
						"n": 4,
						"h": 270,
						"w": 285
					},
					{
						"n": 5,
						"h": 368,
						"w": 268
					},
					{
						"n": 6,
						"h": 54,
						"w": 392
					},
					{
						"n": 7,
						"h": 181,
						"w": 363
					},
					{
						"n": 8,
						"h": 296,
						"w": 386
					},
					{
						"n": 9,
						"h": 426,
						"w": 374
					},
					{
						"n": 10,
						"h": 159,
						"w": 558
					},
					{
						"n": 11,
						"h": 301,
						"w": 576
					}
				],
				"away": [
					{
						"n": 1,
						"h": 205,
						"w": 77
					},
					{
						"n": 2,
						"h": 78,
						"w": 91
					},
					{
						"n": 3,
						"h": 164,
						"w": 81
					},
					{
						"n": 4,
						"h": 273,
						"w": 110
					},
					{
						"n": 5,
						"h": 340,
						"w": 87
					},
					{
						"n": 6,
						"h": 196,
						"w": 182
					},
					{
						"n": 7,
						"h": 194,
						"w": 234
					},
					{
						"n": 8,
						"h": 396,
						"w": 311
					},
					{
						"n": 9,
						"h": 45,
						"w": 342
					},
					{
						"n": 10,
						"h": 151,
						"w": 334
					},
					{
						"n": 11,
						"h": 272,
						"w": 352
					}
				],
				"ball": {
					"n": 0,
					"h": 426,
					"w": 374,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 881,
			"minute": 43,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 12
					},
					{
						"n": 2,
						"h": 73,
						"w": 320
					},
					{
						"n": 3,
						"h": 184,
						"w": 313
					},
					{
						"n": 4,
						"h": 272,
						"w": 313
					},
					{
						"n": 5,
						"h": 371,
						"w": 308
					},
					{
						"n": 6,
						"h": 56,
						"w": 432
					},
					{
						"n": 7,
						"h": 182,
						"w": 403
					},
					{
						"n": 8,
						"h": 317,
						"w": 407
					},
					{
						"n": 9,
						"h": 443,
						"w": 405
					},
					{
						"n": 10,
						"h": 157,
						"w": 596
					},
					{
						"n": 11,
						"h": 298,
						"w": 615
					}
				],
				"away": [
					{
						"n": 1,
						"h": 219,
						"w": 39
					},
					{
						"n": 2,
						"h": 82,
						"w": 97
					},
					{
						"n": 3,
						"h": 164,
						"w": 84
					},
					{
						"n": 4,
						"h": 282,
						"w": 71
					},
					{
						"n": 5,
						"h": 340,
						"w": 94
					},
					{
						"n": 6,
						"h": 232,
						"w": 164
					},
					{
						"n": 7,
						"h": 216,
						"w": 201
					},
					{
						"n": 8,
						"h": 395,
						"w": 271
					},
					{
						"n": 9,
						"h": 44,
						"w": 302
					},
					{
						"n": 10,
						"h": 135,
						"w": 297
					},
					{
						"n": 11,
						"h": 269,
						"w": 312
					}
				],
				"ball": {
					"n": 0,
					"h": 443,
					"w": 405,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 882,
			"minute": 43,
			"messages": [
				{
					"owner": 1,
					"mes": "Элвис Бвомоно[09](Галвэй Юнайтед) сближается с М.Юрасеком[29](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 19
					},
					{
						"n": 2,
						"h": 77,
						"w": 341
					},
					{
						"n": 3,
						"h": 172,
						"w": 292
					},
					{
						"n": 4,
						"h": 269,
						"w": 308
					},
					{
						"n": 5,
						"h": 373,
						"w": 346
					},
					{
						"n": 6,
						"h": 54,
						"w": 471
					},
					{
						"n": 7,
						"h": 199,
						"w": 439
					},
					{
						"n": 8,
						"h": 299,
						"w": 388
					},
					{
						"n": 9,
						"h": 443,
						"w": 439
					},
					{
						"n": 10,
						"h": 158,
						"w": 596
					},
					{
						"n": 11,
						"h": 284,
						"w": 613
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 18
					},
					{
						"n": 2,
						"h": 89,
						"w": 102
					},
					{
						"n": 3,
						"h": 181,
						"w": 84
					},
					{
						"n": 4,
						"h": 272,
						"w": 97
					},
					{
						"n": 5,
						"h": 340,
						"w": 95
					},
					{
						"n": 6,
						"h": 265,
						"w": 143
					},
					{
						"n": 7,
						"h": 196,
						"w": 218
					},
					{
						"n": 8,
						"h": 396,
						"w": 232
					},
					{
						"n": 9,
						"h": 11,
						"w": 281
					},
					{
						"n": 10,
						"h": 151,
						"w": 312
					},
					{
						"n": 11,
						"h": 256,
						"w": 276
					}
				],
				"ball": {
					"n": 0,
					"h": 443,
					"w": 439,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 883,
			"minute": 43,
			"messages": [
				{
					"owner": 1,
					"mes": "Элвис Бвомоно[09](Галвэй Юнайтед) пробрасывает мяч вперед и убегает от М.Юрасека[29](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 15
					},
					{
						"n": 2,
						"h": 72,
						"w": 360
					},
					{
						"n": 3,
						"h": 172,
						"w": 312
					},
					{
						"n": 4,
						"h": 274,
						"w": 307
					},
					{
						"n": 5,
						"h": 383,
						"w": 352
					},
					{
						"n": 6,
						"h": 52,
						"w": 491
					},
					{
						"n": 7,
						"h": 201,
						"w": 458
					},
					{
						"n": 8,
						"h": 309,
						"w": 406
					},
					{
						"n": 9,
						"h": 443,
						"w": 467
					},
					{
						"n": 10,
						"h": 150,
						"w": 596
					},
					{
						"n": 11,
						"h": 289,
						"w": 613
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 13
					},
					{
						"n": 2,
						"h": 82,
						"w": 121
					},
					{
						"n": 3,
						"h": 175,
						"w": 90
					},
					{
						"n": 4,
						"h": 283,
						"w": 80
					},
					{
						"n": 5,
						"h": 340,
						"w": 78
					},
					{
						"n": 6,
						"h": 283,
						"w": 135
					},
					{
						"n": 7,
						"h": 189,
						"w": 200
					},
					{
						"n": 8,
						"h": 397,
						"w": 212
					},
					{
						"n": 9,
						"h": 11,
						"w": 268
					},
					{
						"n": 10,
						"h": 141,
						"w": 294
					},
					{
						"n": 11,
						"h": 271,
						"w": 289
					}
				],
				"ball": {
					"n": 0,
					"h": 443,
					"w": 495,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 20
		},
		{
			"num": 884,
			"minute": 43,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 18
					},
					{
						"n": 2,
						"h": 74,
						"w": 344
					},
					{
						"n": 3,
						"h": 179,
						"w": 303
					},
					{
						"n": 4,
						"h": 266,
						"w": 292
					},
					{
						"n": 5,
						"h": 389,
						"w": 355
					},
					{
						"n": 6,
						"h": 48,
						"w": 511
					},
					{
						"n": 7,
						"h": 206,
						"w": 478
					},
					{
						"n": 8,
						"h": 290,
						"w": 401
					},
					{
						"n": 9,
						"h": 443,
						"w": 495
					},
					{
						"n": 10,
						"h": 163,
						"w": 587
					},
					{
						"n": 11,
						"h": 279,
						"w": 613
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 15
					},
					{
						"n": 2,
						"h": 72,
						"w": 138
					},
					{
						"n": 3,
						"h": 190,
						"w": 82
					},
					{
						"n": 4,
						"h": 263,
						"w": 82
					},
					{
						"n": 5,
						"h": 321,
						"w": 85
					},
					{
						"n": 6,
						"h": 286,
						"w": 131
					},
					{
						"n": 7,
						"h": 206,
						"w": 211
					},
					{
						"n": 8,
						"h": 400,
						"w": 192
					},
					{
						"n": 9,
						"h": 11,
						"w": 255
					},
					{
						"n": 10,
						"h": 160,
						"w": 299
					},
					{
						"n": 11,
						"h": 286,
						"w": 298
					}
				],
				"ball": {
					"n": 0,
					"h": 443,
					"w": 495,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 20
		},
		{
			"num": 885,
			"minute": 43,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 18
					},
					{
						"n": 2,
						"h": 74,
						"w": 369
					},
					{
						"n": 3,
						"h": 169,
						"w": 322
					},
					{
						"n": 4,
						"h": 276,
						"w": 321
					},
					{
						"n": 5,
						"h": 374,
						"w": 358
					},
					{
						"n": 6,
						"h": 53,
						"w": 550
					},
					{
						"n": 7,
						"h": 200,
						"w": 517
					},
					{
						"n": 8,
						"h": 294,
						"w": 441
					},
					{
						"n": 9,
						"h": 432,
						"w": 538,
						"m": 770
					},
					{
						"n": 10,
						"h": 180,
						"w": 614
					},
					{
						"n": 11,
						"h": 273,
						"w": 633
					}
				],
				"away": [
					{
						"n": 1,
						"h": 214,
						"w": 10
					},
					{
						"n": 2,
						"h": 35,
						"w": 165
					},
					{
						"n": 3,
						"h": 188,
						"w": 75
					},
					{
						"n": 4,
						"h": 253,
						"w": 86
					},
					{
						"n": 5,
						"h": 340,
						"w": 58
					},
					{
						"n": 6,
						"h": 263,
						"w": 107
					},
					{
						"n": 7,
						"h": 238,
						"w": 187
					},
					{
						"n": 8,
						"h": 398,
						"w": 152
					},
					{
						"n": 9,
						"h": 31,
						"w": 220,
						"m": 620
					},
					{
						"n": 10,
						"h": 156,
						"w": 259
					},
					{
						"n": 11,
						"h": 283,
						"w": 295
					}
				],
				"ball": {
					"n": 0,
					"h": 432,
					"w": 538,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 886,
			"minute": 43,
			"messages": [
				{
					"owner": 1,
					"mes": "Э.Бвомоно[09](Галвэй Юнайтед) пытается обыграть Л.Седлачека[22](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 17
					},
					{
						"n": 2,
						"h": 75,
						"w": 371
					},
					{
						"n": 3,
						"h": 172,
						"w": 317
					},
					{
						"n": 4,
						"h": 275,
						"w": 326
					},
					{
						"n": 5,
						"h": 378,
						"w": 369
					},
					{
						"n": 6,
						"h": 49,
						"w": 566
					},
					{
						"n": 7,
						"h": 206,
						"w": 532
					},
					{
						"n": 8,
						"h": 295,
						"w": 457
					},
					{
						"n": 9,
						"h": 432,
						"w": 552,
						"m": 780
					},
					{
						"n": 10,
						"h": 178,
						"w": 630
					},
					{
						"n": 11,
						"h": 289,
						"w": 634
					}
				],
				"away": [
					{
						"n": 1,
						"h": 213,
						"w": 9
					},
					{
						"n": 2,
						"h": 18,
						"w": 168
					},
					{
						"n": 3,
						"h": 179,
						"w": 66
					},
					{
						"n": 4,
						"h": 256,
						"w": 76
					},
					{
						"n": 5,
						"h": 340,
						"w": 57
					},
					{
						"n": 6,
						"h": 248,
						"w": 111
					},
					{
						"n": 7,
						"h": 246,
						"w": 173
					},
					{
						"n": 8,
						"h": 399,
						"w": 136
					},
					{
						"n": 9,
						"h": 31,
						"w": 220
					},
					{
						"n": 10,
						"h": 155,
						"w": 243
					},
					{
						"n": 11,
						"h": 290,
						"w": 306
					}
				],
				"ball": {
					"n": 0,
					"h": 432,
					"w": 552,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 16
		},
		{
			"num": 887,
			"minute": 43,
			"messages": [
				{
					"owner": 1,
					"mes": "Элвис Бвомоно[09](Галвэй Юнайтед) на скорости уходит от Л.Седлачека[22](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 11
					},
					{
						"n": 2,
						"h": 73,
						"w": 379
					},
					{
						"n": 3,
						"h": 183,
						"w": 315
					},
					{
						"n": 4,
						"h": 284,
						"w": 327
					},
					{
						"n": 5,
						"h": 389,
						"w": 371
					},
					{
						"n": 6,
						"h": 53,
						"w": 585
					},
					{
						"n": 7,
						"h": 208,
						"w": 552
					},
					{
						"n": 8,
						"h": 313,
						"w": 448
					},
					{
						"n": 9,
						"h": 425,
						"w": 573
					},
					{
						"n": 10,
						"h": 158,
						"w": 631
					},
					{
						"n": 11,
						"h": 296,
						"w": 634
					}
				],
				"away": [
					{
						"n": 1,
						"h": 213,
						"w": 9
					},
					{
						"n": 2,
						"h": 18,
						"w": 156
					},
					{
						"n": 3,
						"h": 169,
						"w": 70
					},
					{
						"n": 4,
						"h": 272,
						"w": 73
					},
					{
						"n": 5,
						"h": 340,
						"w": 68
					},
					{
						"n": 6,
						"h": 234,
						"w": 114
					},
					{
						"n": 7,
						"h": 226,
						"w": 174
					},
					{
						"n": 8,
						"h": 398,
						"w": 116
					},
					{
						"n": 9,
						"h": 31,
						"w": 220
					},
					{
						"n": 10,
						"h": 137,
						"w": 252
					},
					{
						"n": 11,
						"h": 294,
						"w": 296
					}
				],
				"ball": {
					"n": 0,
					"h": 418,
					"w": 594,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 20
		},
		{
			"num": 888,
			"minute": 43,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 18
					},
					{
						"n": 2,
						"h": 73,
						"w": 369
					},
					{
						"n": 3,
						"h": 185,
						"w": 321
					},
					{
						"n": 4,
						"h": 271,
						"w": 327
					},
					{
						"n": 5,
						"h": 391,
						"w": 379
					},
					{
						"n": 6,
						"h": 46,
						"w": 604
					},
					{
						"n": 7,
						"h": 207,
						"w": 556
					},
					{
						"n": 8,
						"h": 293,
						"w": 447
					},
					{
						"n": 9,
						"h": 418,
						"w": 594
					},
					{
						"n": 10,
						"h": 153,
						"w": 628
					},
					{
						"n": 11,
						"h": 285,
						"w": 636
					}
				],
				"away": [
					{
						"n": 1,
						"h": 212,
						"w": 8
					},
					{
						"n": 2,
						"h": 18,
						"w": 144
					},
					{
						"n": 3,
						"h": 151,
						"w": 82
					},
					{
						"n": 4,
						"h": 254,
						"w": 63
					},
					{
						"n": 5,
						"h": 340,
						"w": 63
					},
					{
						"n": 6,
						"h": 215,
						"w": 105
					},
					{
						"n": 7,
						"h": 245,
						"w": 178
					},
					{
						"n": 8,
						"h": 385,
						"w": 101
					},
					{
						"n": 9,
						"h": 31,
						"w": 220
					},
					{
						"n": 10,
						"h": 157,
						"w": 253
					},
					{
						"n": 11,
						"h": 292,
						"w": 292
					}
				],
				"ball": {
					"n": 0,
					"h": 418,
					"w": 594,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 20
		},
		{
			"num": 889,
			"minute": 43,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 16
					},
					{
						"n": 2,
						"h": 71,
						"w": 374
					},
					{
						"n": 3,
						"h": 178,
						"w": 312
					},
					{
						"n": 4,
						"h": 272,
						"w": 330
					},
					{
						"n": 5,
						"h": 378,
						"w": 363
					},
					{
						"n": 6,
						"h": 42,
						"w": 616
					},
					{
						"n": 7,
						"h": 217,
						"w": 584
					},
					{
						"n": 8,
						"h": 291,
						"w": 447
					},
					{
						"n": 9,
						"h": 383,
						"w": 613,
						"m": 790
					},
					{
						"n": 10,
						"h": 192,
						"w": 638
					},
					{
						"n": 11,
						"h": 247,
						"w": 647
					}
				],
				"away": [
					{
						"n": 1,
						"h": 213,
						"w": 8
					},
					{
						"n": 2,
						"h": 58,
						"w": 122,
						"m": 580
					},
					{
						"n": 3,
						"h": 191,
						"w": 64
					},
					{
						"n": 4,
						"h": 244,
						"w": 61
					},
					{
						"n": 5,
						"h": 340,
						"w": 52
					},
					{
						"n": 6,
						"h": 231,
						"w": 110
					},
					{
						"n": 7,
						"h": 210,
						"w": 166
					},
					{
						"n": 8,
						"h": 407,
						"w": 134
					},
					{
						"n": 9,
						"h": 46,
						"w": 208
					},
					{
						"n": 10,
						"h": 159,
						"w": 253
					},
					{
						"n": 11,
						"h": 288,
						"w": 293
					}
				],
				"ball": {
					"n": 0,
					"h": 383,
					"w": 613,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 890,
			"minute": 43,
			"messages": [
				{
					"owner": 1,
					"mes": "Элвис Бвомоно[09](Галвэй Юнайтед) уходит в центр..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 15
					},
					{
						"n": 2,
						"h": 69,
						"w": 360
					},
					{
						"n": 3,
						"h": 174,
						"w": 329
					},
					{
						"n": 4,
						"h": 285,
						"w": 329
					},
					{
						"n": 5,
						"h": 376,
						"w": 370
					},
					{
						"n": 6,
						"h": 64,
						"w": 642
					},
					{
						"n": 7,
						"h": 180,
						"w": 586
					},
					{
						"n": 8,
						"h": 287,
						"w": 484
					},
					{
						"n": 9,
						"h": 349,
						"w": 635
					},
					{
						"n": 10,
						"h": 174,
						"w": 657
					},
					{
						"n": 11,
						"h": 281,
						"w": 660
					}
				],
				"away": [
					{
						"n": 1,
						"h": 213,
						"w": 8
					},
					{
						"n": 2,
						"h": 89,
						"w": 93
					},
					{
						"n": 3,
						"h": 151,
						"w": 68
					},
					{
						"n": 4,
						"h": 208,
						"w": 56
					},
					{
						"n": 5,
						"h": 340,
						"w": 36
					},
					{
						"n": 6,
						"h": 260,
						"w": 75
					},
					{
						"n": 7,
						"h": 242,
						"w": 147
					},
					{
						"n": 8,
						"h": 426,
						"w": 141
					},
					{
						"n": 9,
						"h": 40,
						"w": 192
					},
					{
						"n": 10,
						"h": 163,
						"w": 216
					},
					{
						"n": 11,
						"h": 287,
						"w": 303
					}
				],
				"ball": {
					"n": 0,
					"h": 349,
					"w": 635,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 37
		},
		{
			"num": 891,
			"minute": 43,
			"messages": [
				{
					"owner": 1,
					"mes": "Элвис Бвомоно[09](Галвэй Юнайтед) уже в пределах штрафной площади..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 19
					},
					{
						"n": 2,
						"h": 67,
						"w": 374
					},
					{
						"n": 3,
						"h": 167,
						"w": 317
					},
					{
						"n": 4,
						"h": 281,
						"w": 320
					},
					{
						"n": 5,
						"h": 380,
						"w": 371
					},
					{
						"n": 6,
						"h": 54,
						"w": 654
					},
					{
						"n": 7,
						"h": 150,
						"w": 605
					},
					{
						"n": 8,
						"h": 288,
						"w": 449
					},
					{
						"n": 9,
						"h": 305,
						"w": 635
					},
					{
						"n": 10,
						"h": 178,
						"w": 670
					},
					{
						"n": 11,
						"h": 281,
						"w": 680
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 11
					},
					{
						"n": 2,
						"h": 124,
						"w": 91
					},
					{
						"n": 3,
						"h": 157,
						"w": 69
					},
					{
						"n": 4,
						"h": 193,
						"w": 58
					},
					{
						"n": 5,
						"h": 340,
						"w": 40
					},
					{
						"n": 6,
						"h": 267,
						"w": 50
					},
					{
						"n": 7,
						"h": 276,
						"w": 126
					},
					{
						"n": 8,
						"h": 415,
						"w": 140
					},
					{
						"n": 9,
						"h": 53,
						"w": 190
					},
					{
						"n": 10,
						"h": 162,
						"w": 251
					},
					{
						"n": 11,
						"h": 295,
						"w": 301
					}
				],
				"ball": {
					"n": 0,
					"h": 305,
					"w": 635,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 892,
			"minute": 43,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 17
					},
					{
						"n": 2,
						"h": 60,
						"w": 366
					},
					{
						"n": 3,
						"h": 176,
						"w": 325
					},
					{
						"n": 4,
						"h": 275,
						"w": 318
					},
					{
						"n": 5,
						"h": 391,
						"w": 363
					},
					{
						"n": 6,
						"h": 45,
						"w": 652
					},
					{
						"n": 7,
						"h": 153,
						"w": 592
					},
					{
						"n": 8,
						"h": 288,
						"w": 462
					},
					{
						"n": 9,
						"h": 305,
						"w": 646
					},
					{
						"n": 10,
						"h": 165,
						"w": 670
					},
					{
						"n": 11,
						"h": 270,
						"w": 680
					}
				],
				"away": [
					{
						"n": 1,
						"h": 214,
						"w": 10
					},
					{
						"n": 2,
						"h": 132,
						"w": 86
					},
					{
						"n": 3,
						"h": 145,
						"w": 74
					},
					{
						"n": 4,
						"h": 189,
						"w": 46
					},
					{
						"n": 5,
						"h": 340,
						"w": 50
					},
					{
						"n": 6,
						"h": 280,
						"w": 50
					},
					{
						"n": 7,
						"h": 289,
						"w": 125
					},
					{
						"n": 8,
						"h": 402,
						"w": 140
					},
					{
						"n": 9,
						"h": 40,
						"w": 190
					},
					{
						"n": 10,
						"h": 162,
						"w": 238
					},
					{
						"n": 11,
						"h": 282,
						"w": 304
					}
				],
				"ball": {
					"n": 0,
					"h": 305,
					"w": 646,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 13
		},
		{
			"num": 893,
			"minute": 43,
			"messages": [
				{
					"owner": 1,
					"mes": "Элвис Бвомоно[09](Галвэй Юнайтед) сближается с Н.Мансуром[23](Опава)..."
				},
				{
					"owner": 1,
					"mes": "Нир Мансур[23](Опава) выбивает мяч у Э.Бвомоно[09](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 17
					},
					{
						"n": 2,
						"h": 60,
						"w": 366
					},
					{
						"n": 3,
						"h": 176,
						"w": 325
					},
					{
						"n": 4,
						"h": 275,
						"w": 318
					},
					{
						"n": 5,
						"h": 391,
						"w": 363
					},
					{
						"n": 6,
						"h": 45,
						"w": 652
					},
					{
						"n": 7,
						"h": 155,
						"w": 582
					},
					{
						"n": 8,
						"h": 289,
						"w": 472
					},
					{
						"n": 9,
						"h": 305,
						"w": 656,
						"m": 780
					},
					{
						"n": 10,
						"h": 155,
						"w": 670
					},
					{
						"n": 11,
						"h": 270,
						"w": 680
					}
				],
				"away": [
					{
						"n": 1,
						"h": 214,
						"w": 10
					},
					{
						"n": 2,
						"h": 142,
						"w": 81
					},
					{
						"n": 3,
						"h": 135,
						"w": 78,
						"m": 610
					},
					{
						"n": 4,
						"h": 187,
						"w": 37
					},
					{
						"n": 5,
						"h": 340,
						"w": 50
					},
					{
						"n": 6,
						"h": 288,
						"w": 50
					},
					{
						"n": 7,
						"h": 299,
						"w": 124
					},
					{
						"n": 8,
						"h": 398,
						"w": 140
					},
					{
						"n": 9,
						"h": 30,
						"w": 190
					},
					{
						"n": 10,
						"h": 162,
						"w": 238
					},
					{
						"n": 11,
						"h": 279,
						"w": 305
					}
				],
				"ball": {
					"n": 0,
					"h": 315,
					"w": 642,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 4
				}
			},
			"interval": 10
		},
		{
			"num": 894,
			"minute": 44,
			"possession": 46,
			"messages": [
				{
					"owner": 2,
					"mes": "Нир Мансур[23](Опава) отправляет мяч за боковую линию..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 17
					},
					{
						"n": 2,
						"h": 120,
						"w": 322,
						"f": 86
					},
					{
						"n": 3,
						"h": 168,
						"w": 323,
						"f": 90
					},
					{
						"n": 4,
						"h": 276,
						"w": 306
					},
					{
						"n": 5,
						"h": 331,
						"w": 320
					},
					{
						"n": 6,
						"h": 41,
						"w": 578
					},
					{
						"n": 7,
						"h": 167,
						"w": 510,
						"f": 86
					},
					{
						"n": 8,
						"h": 307,
						"w": 401,
						"f": 83
					},
					{
						"n": 9,
						"h": 312,
						"w": 615,
						"f": 84,
						"c": 2
					},
					{
						"n": 10,
						"h": 170,
						"w": 598,
						"f": 84,
						"c": 2
					},
					{
						"n": 11,
						"h": 287,
						"w": 608,
						"f": 85
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 15
					},
					{
						"n": 2,
						"h": 90,
						"w": 134
					},
					{
						"n": 3,
						"h": 135,
						"w": 90,
						"f": 88
					},
					{
						"n": 4,
						"h": 233,
						"w": 65
					},
					{
						"n": 5,
						"h": 392,
						"w": 103
					},
					{
						"n": 6,
						"h": 261,
						"w": 119,
						"m": 650
					},
					{
						"n": 7,
						"h": 272,
						"w": 193,
						"f": 88
					},
					{
						"n": 8,
						"h": 400,
						"w": 214,
						"f": 86
					},
					{
						"n": 9,
						"h": 64,
						"w": 256,
						"m": 630
					},
					{
						"n": 10,
						"h": 149,
						"w": 311
					},
					{
						"n": 11,
						"h": 294,
						"w": 378
					}
				],
				"ball": {
					"n": 0,
					"h": 461,
					"w": 387,
					"z": 1,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 74
		},
		{
			"num": 895,
			"minute": 44,
			"messages": [
				{
					"owner": 1,
					"mes": "С.Фридйонссон[05](Галвэй Юнайтед) вбрасывает аут..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 239,
						"w": 40
					},
					{
						"n": 2,
						"h": 68,
						"w": 254
					},
					{
						"n": 3,
						"h": 163,
						"w": 246
					},
					{
						"n": 4,
						"h": 339,
						"w": 244
					},
					{
						"n": 5,
						"h": 450,
						"w": 387
					},
					{
						"n": 6,
						"h": 56,
						"w": 413
					},
					{
						"n": 7,
						"h": 157,
						"w": 384
					},
					{
						"n": 8,
						"h": 364,
						"w": 387
					},
					{
						"n": 9,
						"h": 391,
						"w": 469
					},
					{
						"n": 10,
						"h": 158,
						"w": 535
					},
					{
						"n": 11,
						"h": 348,
						"w": 558
					}
				],
				"away": [
					{
						"n": 1,
						"h": 226,
						"w": 13
					},
					{
						"n": 2,
						"h": 103,
						"w": 142
					},
					{
						"n": 3,
						"h": 135,
						"w": 127
					},
					{
						"n": 4,
						"h": 233,
						"w": 137
					},
					{
						"n": 5,
						"h": 340,
						"w": 122
					},
					{
						"n": 6,
						"h": 298,
						"w": 166
					},
					{
						"n": 7,
						"h": 113,
						"w": 240
					},
					{
						"n": 8,
						"h": 394,
						"w": 271
					},
					{
						"n": 9,
						"h": 20,
						"w": 289
					},
					{
						"n": 10,
						"h": 170,
						"w": 344
					},
					{
						"n": 11,
						"h": 277,
						"w": 341
					}
				],
				"ball": {
					"n": 0,
					"h": 450,
					"w": 387,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 133
		},
		{
			"num": 896,
			"minute": 44,
			"messages": [
				{
					"owner": 1,
					"mes": "Киран Нолан[08](Галвэй Юнайтед) сбрасывает мяч себе на ход..."
				}
			],
			"A": {
				"team": 1
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 16
					},
					{
						"n": 2,
						"h": 69,
						"w": 283
					},
					{
						"n": 3,
						"h": 167,
						"w": 274
					},
					{
						"n": 4,
						"h": 321,
						"w": 267
					},
					{
						"n": 5,
						"h": 450,
						"w": 387
					},
					{
						"n": 6,
						"h": 57,
						"w": 442
					},
					{
						"n": 7,
						"h": 166,
						"w": 412
					},
					{
						"n": 8,
						"h": 364,
						"w": 387
					},
					{
						"n": 9,
						"h": 396,
						"w": 498
					},
					{
						"n": 10,
						"h": 150,
						"w": 562
					},
					{
						"n": 11,
						"h": 328,
						"w": 579
					}
				],
				"away": [
					{
						"n": 1,
						"h": 217,
						"w": 41
					},
					{
						"n": 2,
						"h": 96,
						"w": 114
					},
					{
						"n": 3,
						"h": 133,
						"w": 98
					},
					{
						"n": 4,
						"h": 218,
						"w": 113
					},
					{
						"n": 5,
						"h": 317,
						"w": 105
					},
					{
						"n": 6,
						"h": 269,
						"w": 162
					},
					{
						"n": 7,
						"h": 141,
						"w": 233
					},
					{
						"n": 8,
						"h": 393,
						"w": 242
					},
					{
						"n": 9,
						"h": 44,
						"w": 305
					},
					{
						"n": 10,
						"h": 161,
						"w": 317
					},
					{
						"n": 11,
						"h": 281,
						"w": 312
					}
				],
				"ball": {
					"n": 0,
					"h": 364,
					"w": 387,
					"z": 1,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 29
		},
		{
			"num": 897,
			"minute": 44,
			"messages": [
				{
					"owner": 1,
					"mes": "К.Нолан[08](Галвэй Юнайтед) делает передачу Э.Бвомоно[09](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 14
					},
					{
						"n": 2,
						"h": 72,
						"w": 333
					},
					{
						"n": 3,
						"h": 168,
						"w": 292
					},
					{
						"n": 4,
						"h": 280,
						"w": 296
					},
					{
						"n": 5,
						"h": 404,
						"w": 368
					},
					{
						"n": 6,
						"h": 51,
						"w": 491
					},
					{
						"n": 7,
						"h": 186,
						"w": 457
					},
					{
						"n": 8,
						"h": 358,
						"w": 395
					},
					{
						"n": 9,
						"h": 386,
						"w": 536
					},
					{
						"n": 10,
						"h": 156,
						"w": 603
					},
					{
						"n": 11,
						"h": 291,
						"w": 612
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 11
					},
					{
						"n": 2,
						"h": 74,
						"w": 159
					},
					{
						"n": 3,
						"h": 174,
						"w": 86
					},
					{
						"n": 4,
						"h": 266,
						"w": 101
					},
					{
						"n": 5,
						"h": 340,
						"w": 97
					},
					{
						"n": 6,
						"h": 219,
						"w": 159
					},
					{
						"n": 7,
						"h": 189,
						"w": 218
					},
					{
						"n": 8,
						"h": 399,
						"w": 193
					},
					{
						"n": 9,
						"h": 46,
						"w": 255
					},
					{
						"n": 10,
						"h": 112,
						"w": 308
					},
					{
						"n": 11,
						"h": 278,
						"w": 293
					}
				],
				"ball": {
					"n": 0,
					"h": 386,
					"w": 536,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 50
		},
		{
			"num": 898,
			"minute": 44,
			"messages": [
				{
					"owner": 1,
					"mes": "Элвис Бвомоно[09](Галвэй Юнайтед) смещается в центр..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 15
					},
					{
						"n": 2,
						"h": 76,
						"w": 369
					},
					{
						"n": 3,
						"h": 175,
						"w": 313
					},
					{
						"n": 4,
						"h": 278,
						"w": 323
					},
					{
						"n": 5,
						"h": 387,
						"w": 364
					},
					{
						"n": 6,
						"h": 48,
						"w": 528
					},
					{
						"n": 7,
						"h": 194,
						"w": 494
					},
					{
						"n": 8,
						"h": 340,
						"w": 427
					},
					{
						"n": 9,
						"h": 360,
						"w": 567
					},
					{
						"n": 10,
						"h": 176,
						"w": 626
					},
					{
						"n": 11,
						"h": 300,
						"w": 632
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 11
					},
					{
						"n": 2,
						"h": 103,
						"w": 133
					},
					{
						"n": 3,
						"h": 169,
						"w": 72
					},
					{
						"n": 4,
						"h": 260,
						"w": 67
					},
					{
						"n": 5,
						"h": 340,
						"w": 65
					},
					{
						"n": 6,
						"h": 179,
						"w": 140
					},
					{
						"n": 7,
						"h": 190,
						"w": 193
					},
					{
						"n": 8,
						"h": 402,
						"w": 156
					},
					{
						"n": 9,
						"h": 40,
						"w": 239
					},
					{
						"n": 10,
						"h": 110,
						"w": 273
					},
					{
						"n": 11,
						"h": 279,
						"w": 297
					}
				],
				"ball": {
					"n": 0,
					"h": 360,
					"w": 567,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 37
		},
		{
			"num": 899,
			"minute": 44,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 10
					},
					{
						"n": 2,
						"h": 64,
						"w": 367
					},
					{
						"n": 3,
						"h": 176,
						"w": 328
					},
					{
						"n": 4,
						"h": 269,
						"w": 313
					},
					{
						"n": 5,
						"h": 374,
						"w": 375
					},
					{
						"n": 6,
						"h": 50,
						"w": 568
					},
					{
						"n": 7,
						"h": 178,
						"w": 530
					},
					{
						"n": 8,
						"h": 329,
						"w": 466
					},
					{
						"n": 9,
						"h": 322,
						"w": 554
					},
					{
						"n": 10,
						"h": 170,
						"w": 650
					},
					{
						"n": 11,
						"h": 291,
						"w": 636
					}
				],
				"away": [
					{
						"n": 1,
						"h": 217,
						"w": 13
					},
					{
						"n": 2,
						"h": 132,
						"w": 146
					},
					{
						"n": 3,
						"h": 170,
						"w": 73
					},
					{
						"n": 4,
						"h": 261,
						"w": 56
					},
					{
						"n": 5,
						"h": 340,
						"w": 47
					},
					{
						"n": 6,
						"h": 131,
						"w": 148
					},
					{
						"n": 7,
						"h": 210,
						"w": 158
					},
					{
						"n": 8,
						"h": 400,
						"w": 116
					},
					{
						"n": 9,
						"h": 51,
						"w": 201
					},
					{
						"n": 10,
						"h": 121,
						"w": 234
					},
					{
						"n": 11,
						"h": 288,
						"w": 296
					}
				],
				"ball": {
					"n": 0,
					"h": 322,
					"w": 554,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 900,
			"minute": 44,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 19
					},
					{
						"n": 2,
						"h": 65,
						"w": 371
					},
					{
						"n": 3,
						"h": 184,
						"w": 310
					},
					{
						"n": 4,
						"h": 282,
						"w": 330
					},
					{
						"n": 5,
						"h": 374,
						"w": 369
					},
					{
						"n": 6,
						"h": 52,
						"w": 600
					},
					{
						"n": 7,
						"h": 174,
						"w": 562
					},
					{
						"n": 8,
						"h": 300,
						"w": 453
					},
					{
						"n": 9,
						"h": 292,
						"w": 565
					},
					{
						"n": 10,
						"h": 192,
						"w": 666
					},
					{
						"n": 11,
						"h": 287,
						"w": 637
					}
				],
				"away": [
					{
						"n": 1,
						"h": 219,
						"w": 14
					},
					{
						"n": 2,
						"h": 116,
						"w": 114
					},
					{
						"n": 3,
						"h": 180,
						"w": 59
					},
					{
						"n": 4,
						"h": 247,
						"w": 52
					},
					{
						"n": 5,
						"h": 340,
						"w": 38
					},
					{
						"n": 6,
						"h": 160,
						"w": 132
					},
					{
						"n": 7,
						"h": 222,
						"w": 128
					},
					{
						"n": 8,
						"h": 398,
						"w": 84
					},
					{
						"n": 9,
						"h": 47,
						"w": 190
					},
					{
						"n": 10,
						"h": 150,
						"w": 247
					},
					{
						"n": 11,
						"h": 279,
						"w": 294
					}
				],
				"ball": {
					"n": 0,
					"h": 292,
					"w": 565,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 32
		},
		{
			"num": 901,
			"minute": 44,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 17
					},
					{
						"n": 2,
						"h": 60,
						"w": 378
					},
					{
						"n": 3,
						"h": 166,
						"w": 316
					},
					{
						"n": 4,
						"h": 277,
						"w": 326
					},
					{
						"n": 5,
						"h": 378,
						"w": 376
					},
					{
						"n": 6,
						"h": 46,
						"w": 640
					},
					{
						"n": 7,
						"h": 162,
						"w": 589
					},
					{
						"n": 8,
						"h": 284,
						"w": 450
					},
					{
						"n": 9,
						"h": 253,
						"w": 574
					},
					{
						"n": 10,
						"h": 171,
						"w": 674
					},
					{
						"n": 11,
						"h": 274,
						"w": 634
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 15
					},
					{
						"n": 2,
						"h": 113,
						"w": 74
					},
					{
						"n": 3,
						"h": 195,
						"w": 62
					},
					{
						"n": 4,
						"h": 261,
						"w": 47
					},
					{
						"n": 5,
						"h": 375,
						"w": 57
					},
					{
						"n": 6,
						"h": 200,
						"w": 128
					},
					{
						"n": 7,
						"h": 223,
						"w": 110
					},
					{
						"n": 8,
						"h": 408,
						"w": 123
					},
					{
						"n": 9,
						"h": 23,
						"w": 190
					},
					{
						"n": 10,
						"h": 166,
						"w": 250
					},
					{
						"n": 11,
						"h": 284,
						"w": 304
					}
				],
				"ball": {
					"n": 0,
					"h": 253,
					"w": 574,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 902,
			"minute": 44,
			"messages": [
				{
					"owner": 1,
					"mes": "Элвис Бвомоно[09](Галвэй Юнайтед) пасует в штрафную..."
				},
				{
					"owner": 1,
					"mes": "Джо Квигли[10](Галвэй Юнайтед) останавливает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 15
					},
					{
						"n": 2,
						"h": 59,
						"w": 365
					},
					{
						"n": 3,
						"h": 166,
						"w": 325
					},
					{
						"n": 4,
						"h": 272,
						"w": 320
					},
					{
						"n": 5,
						"h": 384,
						"w": 371
					},
					{
						"n": 6,
						"h": 37,
						"w": 640
					},
					{
						"n": 7,
						"h": 158,
						"w": 601
					},
					{
						"n": 8,
						"h": 296,
						"w": 446
					},
					{
						"n": 9,
						"h": 254,
						"w": 584
					},
					{
						"n": 10,
						"h": 133,
						"w": 655
					},
					{
						"n": 11,
						"h": 229,
						"w": 649
					}
				],
				"away": [
					{
						"n": 1,
						"h": 237,
						"w": 9
					},
					{
						"n": 2,
						"h": 156,
						"w": 54
					},
					{
						"n": 3,
						"h": 224,
						"w": 38
					},
					{
						"n": 4,
						"h": 302,
						"w": 52
					},
					{
						"n": 5,
						"h": 340,
						"w": 43
					},
					{
						"n": 6,
						"h": 246,
						"w": 115
					},
					{
						"n": 7,
						"h": 271,
						"w": 115
					},
					{
						"n": 8,
						"h": 400,
						"w": 75
					},
					{
						"n": 9,
						"h": 22,
						"w": 190
					},
					{
						"n": 10,
						"h": 154,
						"w": 254
					},
					{
						"n": 11,
						"h": 293,
						"w": 294
					}
				],
				"ball": {
					"n": 0,
					"h": 133,
					"w": 655,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 48
		},
		{
			"num": 903,
			"minute": 44,
			"messages": [
				{
					"owner": 1,
					"mes": "Боковой судья показывает, что Джо Квигли[10](Галвэй Юнайтед) попал в офсайд."
				}
			],
			"O": {
				"team": 1,
				"player": 10
			}
		},
		{
			"num": 904,
			"minute": 45,
			"possession": 46,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 10
					},
					{
						"n": 2,
						"h": 67,
						"w": 265
					},
					{
						"n": 3,
						"h": 181,
						"w": 226
					},
					{
						"n": 4,
						"h": 269,
						"w": 220,
						"m": 670
					},
					{
						"n": 5,
						"h": 376,
						"w": 271,
						"f": 86,
						"m": 650
					},
					{
						"n": 6,
						"h": 52,
						"w": 541,
						"f": 85
					},
					{
						"n": 7,
						"h": 171,
						"w": 502
					},
					{
						"n": 8,
						"h": 255,
						"w": 355
					},
					{
						"n": 9,
						"h": 300,
						"w": 533
					},
					{
						"n": 10,
						"h": 182,
						"w": 578,
						"m": 730
					},
					{
						"n": 11,
						"h": 260,
						"w": 581
					}
				],
				"away": [
					{
						"n": 1,
						"h": 237,
						"w": 9
					},
					{
						"n": 2,
						"h": 78,
						"w": 116
					},
					{
						"n": 3,
						"h": 166,
						"w": 114
					},
					{
						"n": 4,
						"h": 310,
						"w": 57
					},
					{
						"n": 5,
						"h": 392,
						"w": 128,
						"f": 85
					},
					{
						"n": 6,
						"h": 233,
						"w": 214
					},
					{
						"n": 7,
						"h": 253,
						"w": 214
					},
					{
						"n": 8,
						"h": 396,
						"w": 175
					},
					{
						"n": 9,
						"h": 41,
						"w": 288,
						"f": 85
					},
					{
						"n": 10,
						"h": 163,
						"w": 354,
						"f": 84,
						"c": 2
					},
					{
						"n": 11,
						"h": 289,
						"w": 394,
						"f": 84,
						"c": 2
					}
				],
				"ball": {
					"n": 0,
					"h": 133,
					"w": 655,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 100
		},
		{
			"num": 905,
			"minute": 45,
			"messages": [
				{
					"owner": 2,
					"mes": "Свободный удар..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 20
					},
					{
						"n": 2,
						"h": 68,
						"w": 262
					},
					{
						"n": 3,
						"h": 174,
						"w": 222
					},
					{
						"n": 4,
						"h": 265,
						"w": 217
					},
					{
						"n": 5,
						"h": 372,
						"w": 272
					},
					{
						"n": 6,
						"h": 51,
						"w": 537
					},
					{
						"n": 7,
						"h": 169,
						"w": 497
					},
					{
						"n": 8,
						"h": 256,
						"w": 350
					},
					{
						"n": 9,
						"h": 300,
						"w": 535
					},
					{
						"n": 10,
						"h": 183,
						"w": 579
					},
					{
						"n": 11,
						"h": 254,
						"w": 586
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 17
					},
					{
						"n": 2,
						"h": 77,
						"w": 117
					},
					{
						"n": 3,
						"h": 172,
						"w": 120
					},
					{
						"n": 4,
						"h": 317,
						"w": 65
					},
					{
						"n": 5,
						"h": 387,
						"w": 132
					},
					{
						"n": 6,
						"h": 229,
						"w": 210
					},
					{
						"n": 7,
						"h": 253,
						"w": 221
					},
					{
						"n": 8,
						"h": 388,
						"w": 176
					},
					{
						"n": 9,
						"h": 34,
						"w": 289
					},
					{
						"n": 10,
						"h": 161,
						"w": 353
					},
					{
						"n": 11,
						"h": 291,
						"w": 400
					}
				],
				"ball": {
					"n": 0,
					"h": 133,
					"w": 655,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 15
		},
		{
			"num": 906,
			"minute": 45,
			"messages": [
				{
					"owner": 2,
					"mes": "Разыграли мяч..."
				},
				{
					"owner": 2,
					"mes": "Пас направо Т.Прохазке[25](Опава)..."
				}
			],
			"F": {
				"team": 2
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 13
					},
					{
						"n": 2,
						"h": 95,
						"w": 258
					},
					{
						"n": 3,
						"h": 171,
						"w": 248
					},
					{
						"n": 4,
						"h": 261,
						"w": 244
					},
					{
						"n": 5,
						"h": 365,
						"w": 268
					},
					{
						"n": 6,
						"h": 51,
						"w": 510
					},
					{
						"n": 7,
						"h": 168,
						"w": 471
					},
					{
						"n": 8,
						"h": 277,
						"w": 333
					},
					{
						"n": 9,
						"h": 313,
						"w": 511
					},
					{
						"n": 10,
						"h": 174,
						"w": 554
					},
					{
						"n": 11,
						"h": 264,
						"w": 561
					}
				],
				"away": [
					{
						"n": 1,
						"h": 221,
						"w": 14
					},
					{
						"n": 2,
						"h": 67,
						"w": 142
					},
					{
						"n": 3,
						"h": 172,
						"w": 101
					},
					{
						"n": 4,
						"h": 312,
						"w": 74
					},
					{
						"n": 5,
						"h": 364,
						"w": 117
					},
					{
						"n": 6,
						"h": 238,
						"w": 184
					},
					{
						"n": 7,
						"h": 250,
						"w": 247
					},
					{
						"n": 8,
						"h": 394,
						"w": 203
					},
					{
						"n": 9,
						"h": 39,
						"w": 315
					},
					{
						"n": 10,
						"h": 156,
						"w": 379
					},
					{
						"n": 11,
						"h": 313,
						"w": 385
					}
				],
				"ball": {
					"n": 0,
					"h": 86,
					"w": 603,
					"z": 0,
					"r": 2,
					"p": 0,
					"x": 0
				}
			},
			"interval": 27
		},
		{
			"num": 907,
			"minute": 45,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 17
					},
					{
						"n": 2,
						"h": 108,
						"w": 261
					},
					{
						"n": 3,
						"h": 140,
						"w": 255
					},
					{
						"n": 4,
						"h": 258,
						"w": 255
					},
					{
						"n": 5,
						"h": 330,
						"w": 268
					},
					{
						"n": 6,
						"h": 44,
						"w": 470
					},
					{
						"n": 7,
						"h": 171,
						"w": 431
					},
					{
						"n": 8,
						"h": 295,
						"w": 306
					},
					{
						"n": 9,
						"h": 332,
						"w": 476
					},
					{
						"n": 10,
						"h": 163,
						"w": 515
					},
					{
						"n": 11,
						"h": 278,
						"w": 524
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 17
					},
					{
						"n": 2,
						"h": 71,
						"w": 156
					},
					{
						"n": 3,
						"h": 166,
						"w": 116
					},
					{
						"n": 4,
						"h": 278,
						"w": 110
					},
					{
						"n": 5,
						"h": 348,
						"w": 149
					},
					{
						"n": 6,
						"h": 238,
						"w": 221
					},
					{
						"n": 7,
						"h": 233,
						"w": 284
					},
					{
						"n": 8,
						"h": 393,
						"w": 243
					},
					{
						"n": 9,
						"h": 48,
						"w": 305
					},
					{
						"n": 10,
						"h": 160,
						"w": 419
					},
					{
						"n": 11,
						"h": 342,
						"w": 357
					}
				],
				"ball": {
					"n": 0,
					"h": 102,
					"w": 571,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 908,
			"minute": 45,
			"messages": [
				{
					"owner": 2,
					"mes": "Пас налево..."
				},
				{
					"owner": 2,
					"mes": "Себастьян Пейша[24](Опава) принимает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 10
					},
					{
						"n": 2,
						"h": 101,
						"w": 294
					},
					{
						"n": 3,
						"h": 174,
						"w": 255
					},
					{
						"n": 4,
						"h": 292,
						"w": 259
					},
					{
						"n": 5,
						"h": 346,
						"w": 259
					},
					{
						"n": 6,
						"h": 49,
						"w": 437
					},
					{
						"n": 7,
						"h": 180,
						"w": 398
					},
					{
						"n": 8,
						"h": 314,
						"w": 333
					},
					{
						"n": 9,
						"h": 346,
						"w": 445
					},
					{
						"n": 10,
						"h": 147,
						"w": 485
					},
					{
						"n": 11,
						"h": 293,
						"w": 493
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 11
					},
					{
						"n": 2,
						"h": 70,
						"w": 172
					},
					{
						"n": 3,
						"h": 183,
						"w": 116
					},
					{
						"n": 4,
						"h": 288,
						"w": 119
					},
					{
						"n": 5,
						"h": 358,
						"w": 147
					},
					{
						"n": 6,
						"h": 238,
						"w": 217
					},
					{
						"n": 7,
						"h": 217,
						"w": 307
					},
					{
						"n": 8,
						"h": 404,
						"w": 275
					},
					{
						"n": 9,
						"h": 50,
						"w": 339
					},
					{
						"n": 10,
						"h": 138,
						"w": 423
					},
					{
						"n": 11,
						"h": 362,
						"w": 386
					}
				],
				"ball": {
					"n": 0,
					"h": 162,
					"w": 601,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 34
		},
		{
			"num": 909,
			"minute": 45,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 15
					},
					{
						"n": 2,
						"h": 79,
						"w": 279
					},
					{
						"n": 3,
						"h": 214,
						"w": 256
					},
					{
						"n": 4,
						"h": 279,
						"w": 250
					},
					{
						"n": 5,
						"h": 360,
						"w": 296
					},
					{
						"n": 6,
						"h": 56,
						"w": 397
					},
					{
						"n": 7,
						"h": 178,
						"w": 358
					},
					{
						"n": 8,
						"h": 275,
						"w": 343
					},
					{
						"n": 9,
						"h": 368,
						"w": 412
					},
					{
						"n": 10,
						"h": 139,
						"w": 448
					},
					{
						"n": 11,
						"h": 308,
						"w": 456
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 13
					},
					{
						"n": 2,
						"h": 67,
						"w": 155
					},
					{
						"n": 3,
						"h": 181,
						"w": 124
					},
					{
						"n": 4,
						"h": 280,
						"w": 153
					},
					{
						"n": 5,
						"h": 386,
						"w": 118
					},
					{
						"n": 6,
						"h": 220,
						"w": 216
					},
					{
						"n": 7,
						"h": 221,
						"w": 346
					},
					{
						"n": 8,
						"h": 399,
						"w": 275
					},
					{
						"n": 9,
						"h": 50,
						"w": 379
					},
					{
						"n": 10,
						"h": 153,
						"w": 445
					},
					{
						"n": 11,
						"h": 380,
						"w": 421
					}
				],
				"ball": {
					"n": 0,
					"h": 170,
					"w": 567,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 910,
			"minute": 45,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 17
					},
					{
						"n": 2,
						"h": 58,
						"w": 254
					},
					{
						"n": 3,
						"h": 220,
						"w": 243
					},
					{
						"n": 4,
						"h": 292,
						"w": 257
					},
					{
						"n": 5,
						"h": 372,
						"w": 281
					},
					{
						"n": 6,
						"h": 54,
						"w": 357
					},
					{
						"n": 7,
						"h": 212,
						"w": 337
					},
					{
						"n": 8,
						"h": 266,
						"w": 334
					},
					{
						"n": 9,
						"h": 393,
						"w": 380
					},
					{
						"n": 10,
						"h": 135,
						"w": 439
					},
					{
						"n": 11,
						"h": 320,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 10
					},
					{
						"n": 2,
						"h": 64,
						"w": 188
					},
					{
						"n": 3,
						"h": 170,
						"w": 142
					},
					{
						"n": 4,
						"h": 278,
						"w": 188
					},
					{
						"n": 5,
						"h": 393,
						"w": 154
					},
					{
						"n": 6,
						"h": 224,
						"w": 256
					},
					{
						"n": 7,
						"h": 228,
						"w": 386
					},
					{
						"n": 8,
						"h": 401,
						"w": 315
					},
					{
						"n": 9,
						"h": 48,
						"w": 419
					},
					{
						"n": 10,
						"h": 133,
						"w": 454
					},
					{
						"n": 11,
						"h": 408,
						"w": 449
					}
				],
				"ball": {
					"n": 0,
					"h": 172,
					"w": 532,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 911,
			"minute": 45,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 14
					},
					{
						"n": 2,
						"h": 75,
						"w": 235
					},
					{
						"n": 3,
						"h": 238,
						"w": 227
					},
					{
						"n": 4,
						"h": 280,
						"w": 227
					},
					{
						"n": 5,
						"h": 357,
						"w": 263
					},
					{
						"n": 6,
						"h": 59,
						"w": 323
					},
					{
						"n": 7,
						"h": 191,
						"w": 310
					},
					{
						"n": 8,
						"h": 241,
						"w": 303
					},
					{
						"n": 9,
						"h": 393,
						"w": 360
					},
					{
						"n": 10,
						"h": 150,
						"w": 402
					},
					{
						"n": 11,
						"h": 312,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 31
					},
					{
						"n": 2,
						"h": 72,
						"w": 206
					},
					{
						"n": 3,
						"h": 181,
						"w": 155
					},
					{
						"n": 4,
						"h": 276,
						"w": 223
					},
					{
						"n": 5,
						"h": 375,
						"w": 163
					},
					{
						"n": 6,
						"h": 228,
						"w": 296
					},
					{
						"n": 7,
						"h": 217,
						"w": 424
					},
					{
						"n": 8,
						"h": 398,
						"w": 355
					},
					{
						"n": 9,
						"h": 84,
						"w": 437
					},
					{
						"n": 10,
						"h": 153,
						"w": 465
					},
					{
						"n": 11,
						"h": 405,
						"w": 465
					}
				],
				"ball": {
					"n": 0,
					"h": 174,
					"w": 497,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 912,
			"minute": 45,
			"messages": [
				{
					"owner": 2,
					"mes": "Себастьян Пейша[24](Опава) пасует на ход О.Дюмону[26](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 13
					},
					{
						"n": 2,
						"h": 84,
						"w": 223
					},
					{
						"n": 3,
						"h": 219,
						"w": 204
					},
					{
						"n": 4,
						"h": 283,
						"w": 195
					},
					{
						"n": 5,
						"h": 361,
						"w": 239
					},
					{
						"n": 6,
						"h": 52,
						"w": 310
					},
					{
						"n": 7,
						"h": 216,
						"w": 286
					},
					{
						"n": 8,
						"h": 256,
						"w": 282
					},
					{
						"n": 9,
						"h": 399,
						"w": 347
					},
					{
						"n": 10,
						"h": 175,
						"w": 386
					},
					{
						"n": 11,
						"h": 309,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 221,
						"w": 56
					},
					{
						"n": 2,
						"h": 73,
						"w": 227
					},
					{
						"n": 3,
						"h": 165,
						"w": 162
					},
					{
						"n": 4,
						"h": 276,
						"w": 223
					},
					{
						"n": 5,
						"h": 386,
						"w": 196
					},
					{
						"n": 6,
						"h": 258,
						"w": 325
					},
					{
						"n": 7,
						"h": 226,
						"w": 390
					},
					{
						"n": 8,
						"h": 405,
						"w": 389
					},
					{
						"n": 9,
						"h": 59,
						"w": 461
					},
					{
						"n": 10,
						"h": 156,
						"w": 500
					},
					{
						"n": 11,
						"h": 396,
						"w": 477
					}
				],
				"ball": {
					"n": 0,
					"h": 192,
					"w": 395,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 35
		},
		{
			"num": 913,
			"minute": 45,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 11
					},
					{
						"n": 2,
						"h": 84,
						"w": 198
					},
					{
						"n": 3,
						"h": 240,
						"w": 182
					},
					{
						"n": 4,
						"h": 275,
						"w": 176
					},
					{
						"n": 5,
						"h": 368,
						"w": 200
					},
					{
						"n": 6,
						"h": 55,
						"w": 270
					},
					{
						"n": 7,
						"h": 188,
						"w": 258
					},
					{
						"n": 8,
						"h": 264,
						"w": 268
					},
					{
						"n": 9,
						"h": 391,
						"w": 307
					},
					{
						"n": 10,
						"h": 215,
						"w": 380
					},
					{
						"n": 11,
						"h": 315,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 226,
						"w": 80
					},
					{
						"n": 2,
						"h": 62,
						"w": 250
					},
					{
						"n": 3,
						"h": 172,
						"w": 190
					},
					{
						"n": 4,
						"h": 287,
						"w": 210
					},
					{
						"n": 5,
						"h": 381,
						"w": 212
					},
					{
						"n": 6,
						"h": 223,
						"w": 322
					},
					{
						"n": 7,
						"h": 211,
						"w": 397
					},
					{
						"n": 8,
						"h": 406,
						"w": 429
					},
					{
						"n": 9,
						"h": 52,
						"w": 500
					},
					{
						"n": 10,
						"h": 163,
						"w": 510
					},
					{
						"n": 11,
						"h": 396,
						"w": 502
					}
				],
				"ball": {
					"n": 0,
					"h": 227,
					"w": 398,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 914,
			"minute": 45,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 16
					},
					{
						"n": 2,
						"h": 71,
						"w": 176
					},
					{
						"n": 3,
						"h": 214,
						"w": 159
					},
					{
						"n": 4,
						"h": 268,
						"w": 149
					},
					{
						"n": 5,
						"h": 368,
						"w": 176
					},
					{
						"n": 6,
						"h": 56,
						"w": 236
					},
					{
						"n": 7,
						"h": 225,
						"w": 245
					},
					{
						"n": 8,
						"h": 270,
						"w": 248
					},
					{
						"n": 9,
						"h": 407,
						"w": 270
					},
					{
						"n": 10,
						"h": 255,
						"w": 376
					},
					{
						"n": 11,
						"h": 282,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 98
					},
					{
						"n": 2,
						"h": 57,
						"w": 270
					},
					{
						"n": 3,
						"h": 168,
						"w": 222
					},
					{
						"n": 4,
						"h": 274,
						"w": 212
					},
					{
						"n": 5,
						"h": 388,
						"w": 246
					},
					{
						"n": 6,
						"h": 188,
						"w": 325
					},
					{
						"n": 7,
						"h": 234,
						"w": 430
					},
					{
						"n": 8,
						"h": 411,
						"w": 469
					},
					{
						"n": 9,
						"h": 52,
						"w": 524
					},
					{
						"n": 10,
						"h": 167,
						"w": 550
					},
					{
						"n": 11,
						"h": 409,
						"w": 524
					}
				],
				"ball": {
					"n": 0,
					"h": 262,
					"w": 395,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 915,
			"minute": 45,
			"messages": [
				{
					"owner": 2,
					"mes": "Оливье Дюмон[26](Опава) отдает пас на М.Манолова[27](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 12
					},
					{
						"n": 2,
						"h": 88,
						"w": 160
					},
					{
						"n": 3,
						"h": 221,
						"w": 137
					},
					{
						"n": 4,
						"h": 304,
						"w": 130
					},
					{
						"n": 5,
						"h": 371,
						"w": 149
					},
					{
						"n": 6,
						"h": 56,
						"w": 196
					},
					{
						"n": 7,
						"h": 198,
						"w": 274
					},
					{
						"n": 8,
						"h": 261,
						"w": 224
					},
					{
						"n": 9,
						"h": 400,
						"w": 252
					},
					{
						"n": 10,
						"h": 216,
						"w": 387
					},
					{
						"n": 11,
						"h": 319,
						"w": 450
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 111
					},
					{
						"n": 2,
						"h": 56,
						"w": 291
					},
					{
						"n": 3,
						"h": 170,
						"w": 244
					},
					{
						"n": 4,
						"h": 279,
						"w": 252
					},
					{
						"n": 5,
						"h": 394,
						"w": 250
					},
					{
						"n": 6,
						"h": 200,
						"w": 328
					},
					{
						"n": 7,
						"h": 269,
						"w": 412
					},
					{
						"n": 8,
						"h": 400,
						"w": 502
					},
					{
						"n": 9,
						"h": 49,
						"w": 551
					},
					{
						"n": 10,
						"h": 148,
						"w": 574
					},
					{
						"n": 11,
						"h": 392,
						"w": 540
					}
				],
				"ball": {
					"n": 0,
					"h": 181,
					"w": 308,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 916,
			"minute": 45,
			"messages": [
				{
					"owner": 2,
					"mes": "Мирослав Манолов[27](Опава) пасует на Д.Прохазку[28](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 16
					},
					{
						"n": 2,
						"h": 87,
						"w": 155
					},
					{
						"n": 3,
						"h": 219,
						"w": 112
					},
					{
						"n": 4,
						"h": 273,
						"w": 113
					},
					{
						"n": 5,
						"h": 334,
						"w": 129
					},
					{
						"n": 6,
						"h": 81,
						"w": 227
					},
					{
						"n": 7,
						"h": 186,
						"w": 234
					},
					{
						"n": 8,
						"h": 247,
						"w": 198
					},
					{
						"n": 9,
						"h": 413,
						"w": 221
					},
					{
						"n": 10,
						"h": 177,
						"w": 400
					},
					{
						"n": 11,
						"h": 319,
						"w": 436
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 127
					},
					{
						"n": 2,
						"h": 65,
						"w": 324
					},
					{
						"n": 3,
						"h": 172,
						"w": 256
					},
					{
						"n": 4,
						"h": 273,
						"w": 257
					},
					{
						"n": 5,
						"h": 387,
						"w": 269
					},
					{
						"n": 6,
						"h": 240,
						"w": 343
					},
					{
						"n": 7,
						"h": 268,
						"w": 420
					},
					{
						"n": 8,
						"h": 377,
						"w": 478
					},
					{
						"n": 9,
						"h": 86,
						"w": 571
					},
					{
						"n": 10,
						"h": 177,
						"w": 573
					},
					{
						"n": 11,
						"h": 372,
						"w": 545
					}
				],
				"ball": {
					"n": 0,
					"h": 73,
					"w": 242,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 42
		},
		{
			"num": 917,
			"minute": 45,
			"messages": [
				{
					"owner": 2,
					"mes": "Пас Ш.Товареку[31](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 215,
						"w": 11
					},
					{
						"n": 2,
						"h": 84,
						"w": 165
					},
					{
						"n": 3,
						"h": 194,
						"w": 104
					},
					{
						"n": 4,
						"h": 268,
						"w": 111
					},
					{
						"n": 5,
						"h": 321,
						"w": 118
					},
					{
						"n": 6,
						"h": 58,
						"w": 215
					},
					{
						"n": 7,
						"h": 165,
						"w": 218
					},
					{
						"n": 8,
						"h": 238,
						"w": 180
					},
					{
						"n": 9,
						"h": 414,
						"w": 215
					},
					{
						"n": 10,
						"h": 170,
						"w": 400
					},
					{
						"n": 11,
						"h": 294,
						"w": 442
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 120
					},
					{
						"n": 2,
						"h": 73,
						"w": 309
					},
					{
						"n": 3,
						"h": 172,
						"w": 260
					},
					{
						"n": 4,
						"h": 280,
						"w": 252
					},
					{
						"n": 5,
						"h": 376,
						"w": 278
					},
					{
						"n": 6,
						"h": 246,
						"w": 368
					},
					{
						"n": 7,
						"h": 261,
						"w": 445
					},
					{
						"n": 8,
						"h": 384,
						"w": 471
					},
					{
						"n": 9,
						"h": 110,
						"w": 580
					},
					{
						"n": 10,
						"h": 176,
						"w": 589
					},
					{
						"n": 11,
						"h": 396,
						"w": 535
					}
				],
				"ball": {
					"n": 0,
					"h": 32,
					"w": 209,
					"z": 0,
					"r": 0,
					"p": 2,
					"x": 0
				}
			},
			"interval": 26
		},
		{
			"num": 918,
			"minute": 45,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 215,
						"w": 11
					},
					{
						"n": 2,
						"h": 69,
						"w": 171
					},
					{
						"n": 3,
						"h": 186,
						"w": 101
					},
					{
						"n": 4,
						"h": 272,
						"w": 98
					},
					{
						"n": 5,
						"h": 314,
						"w": 104
					},
					{
						"n": 6,
						"h": 43,
						"w": 207
					},
					{
						"n": 7,
						"h": 161,
						"w": 203
					},
					{
						"n": 8,
						"h": 238,
						"w": 182
					},
					{
						"n": 9,
						"h": 410,
						"w": 204
					},
					{
						"n": 10,
						"h": 169,
						"w": 400
					},
					{
						"n": 11,
						"h": 286,
						"w": 428
					}
				],
				"away": [
					{
						"n": 1,
						"h": 226,
						"w": 121
					},
					{
						"n": 2,
						"h": 60,
						"w": 313
					},
					{
						"n": 3,
						"h": 164,
						"w": 273
					},
					{
						"n": 4,
						"h": 281,
						"w": 264
					},
					{
						"n": 5,
						"h": 386,
						"w": 291
					},
					{
						"n": 6,
						"h": 257,
						"w": 369
					},
					{
						"n": 7,
						"h": 254,
						"w": 460
					},
					{
						"n": 8,
						"h": 392,
						"w": 463
					},
					{
						"n": 9,
						"h": 121,
						"w": 592
					},
					{
						"n": 10,
						"h": 167,
						"w": 599
					},
					{
						"n": 11,
						"h": 411,
						"w": 529
					}
				],
				"ball": {
					"n": 0,
					"h": 20,
					"w": 199,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 16
		},
		{
			"num": 919,
			"minute": 45,
			"messages": [
				{
					"owner": 2,
					"mes": "Шимон Товарек[31](Опава) принимает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 214,
						"w": 10
					},
					{
						"n": 2,
						"h": 89,
						"w": 164
					},
					{
						"n": 3,
						"h": 194,
						"w": 104
					},
					{
						"n": 4,
						"h": 271,
						"w": 91
					},
					{
						"n": 5,
						"h": 304,
						"w": 85
					},
					{
						"n": 6,
						"h": 25,
						"w": 197
					},
					{
						"n": 7,
						"h": 155,
						"w": 183
					},
					{
						"n": 8,
						"h": 250,
						"w": 183
					},
					{
						"n": 9,
						"h": 420,
						"w": 194
					},
					{
						"n": 10,
						"h": 166,
						"w": 400
					},
					{
						"n": 11,
						"h": 303,
						"w": 416
					}
				],
				"away": [
					{
						"n": 1,
						"h": 226,
						"w": 122
					},
					{
						"n": 2,
						"h": 69,
						"w": 326
					},
					{
						"n": 3,
						"h": 178,
						"w": 278
					},
					{
						"n": 4,
						"h": 284,
						"w": 285
					},
					{
						"n": 5,
						"h": 392,
						"w": 306
					},
					{
						"n": 6,
						"h": 253,
						"w": 389
					},
					{
						"n": 7,
						"h": 255,
						"w": 472
					},
					{
						"n": 8,
						"h": 395,
						"w": 442
					},
					{
						"n": 9,
						"h": 129,
						"w": 609
					},
					{
						"n": 10,
						"h": 173,
						"w": 603
					},
					{
						"n": 11,
						"h": 430,
						"w": 521,
						"m": 630
					}
				],
				"ball": {
					"n": 0,
					"h": 20,
					"w": 199,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 21
		},
		{
			"num": 920,
			"minute": 45,
			"messages": [
				{
					"owner": 2,
					"mes": "Шимон Товарек[31](Опава) отправляет мяч в центр..."
				},
				{
					"owner": 2,
					"mes": "Мирослав Манолов[27](Опава) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 12
					},
					{
						"n": 2,
						"h": 56,
						"w": 169
					},
					{
						"n": 3,
						"h": 166,
						"w": 108
					},
					{
						"n": 4,
						"h": 257,
						"w": 98
					},
					{
						"n": 5,
						"h": 330,
						"w": 109
					},
					{
						"n": 6,
						"h": 56,
						"w": 197
					},
					{
						"n": 7,
						"h": 148,
						"w": 212
					},
					{
						"n": 8,
						"h": 277,
						"w": 173
					},
					{
						"n": 9,
						"h": 389,
						"w": 208
					},
					{
						"n": 10,
						"h": 181,
						"w": 392
					},
					{
						"n": 11,
						"h": 269,
						"w": 402
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 118
					},
					{
						"n": 2,
						"h": 67,
						"w": 338
					},
					{
						"n": 3,
						"h": 181,
						"w": 301
					},
					{
						"n": 4,
						"h": 269,
						"w": 309
					},
					{
						"n": 5,
						"h": 389,
						"w": 296
					},
					{
						"n": 6,
						"h": 217,
						"w": 409
					},
					{
						"n": 7,
						"h": 299,
						"w": 485
					},
					{
						"n": 8,
						"h": 403,
						"w": 488
					},
					{
						"n": 9,
						"h": 85,
						"w": 595
					},
					{
						"n": 10,
						"h": 175,
						"w": 569
					},
					{
						"n": 11,
						"h": 430,
						"w": 531
					}
				],
				"ball": {
					"n": 0,
					"h": 151,
					"w": 235,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 46
		},
		{
			"num": 921,
			"minute": 45,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 19
					},
					{
						"n": 2,
						"h": 56,
						"w": 142
					},
					{
						"n": 3,
						"h": 203,
						"w": 117
					},
					{
						"n": 4,
						"h": 285,
						"w": 118
					},
					{
						"n": 5,
						"h": 330,
						"w": 118
					},
					{
						"n": 6,
						"h": 56,
						"w": 157
					},
					{
						"n": 7,
						"h": 185,
						"w": 207
					},
					{
						"n": 8,
						"h": 270,
						"w": 184
					},
					{
						"n": 9,
						"h": 387,
						"w": 168
					},
					{
						"n": 10,
						"h": 165,
						"w": 356
					},
					{
						"n": 11,
						"h": 301,
						"w": 426
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 126
					},
					{
						"n": 2,
						"h": 58,
						"w": 304
					},
					{
						"n": 3,
						"h": 176,
						"w": 341
					},
					{
						"n": 4,
						"h": 272,
						"w": 349
					},
					{
						"n": 5,
						"h": 376,
						"w": 259
					},
					{
						"n": 6,
						"h": 222,
						"w": 448
					},
					{
						"n": 7,
						"h": 265,
						"w": 494
					},
					{
						"n": 8,
						"h": 406,
						"w": 528
					},
					{
						"n": 9,
						"h": 49,
						"w": 585
					},
					{
						"n": 10,
						"h": 155,
						"w": 587
					},
					{
						"n": 11,
						"h": 412,
						"w": 567
					}
				],
				"ball": {
					"n": 0,
					"h": 185,
					"w": 226,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 922,
			"minute": 45,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 19
					},
					{
						"n": 2,
						"h": 56,
						"w": 124
					},
					{
						"n": 3,
						"h": 215,
						"w": 112
					},
					{
						"n": 4,
						"h": 262,
						"w": 119
					},
					{
						"n": 5,
						"h": 354,
						"w": 122
					},
					{
						"n": 6,
						"h": 71,
						"w": 127
					},
					{
						"n": 7,
						"h": 219,
						"w": 199
					},
					{
						"n": 8,
						"h": 307,
						"w": 170
					},
					{
						"n": 9,
						"h": 413,
						"w": 198
					},
					{
						"n": 10,
						"h": 170,
						"w": 347
					},
					{
						"n": 11,
						"h": 321,
						"w": 401
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 118
					},
					{
						"n": 2,
						"h": 70,
						"w": 342
					},
					{
						"n": 3,
						"h": 171,
						"w": 380
					},
					{
						"n": 4,
						"h": 276,
						"w": 389
					},
					{
						"n": 5,
						"h": 384,
						"w": 308
					},
					{
						"n": 6,
						"h": 234,
						"w": 486
					},
					{
						"n": 7,
						"h": 231,
						"w": 503
					},
					{
						"n": 8,
						"h": 394,
						"w": 566
					},
					{
						"n": 9,
						"h": 88,
						"w": 591
					},
					{
						"n": 10,
						"h": 135,
						"w": 560
					},
					{
						"n": 11,
						"h": 408,
						"w": 591
					}
				],
				"ball": {
					"n": 0,
					"h": 219,
					"w": 217,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 923,
			"minute": 45,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 13
					},
					{
						"n": 2,
						"h": 66,
						"w": 114
					},
					{
						"n": 3,
						"h": 238,
						"w": 88
					},
					{
						"n": 4,
						"h": 272,
						"w": 90
					},
					{
						"n": 5,
						"h": 391,
						"w": 118
					},
					{
						"n": 6,
						"h": 56,
						"w": 117
					},
					{
						"n": 7,
						"h": 253,
						"w": 183
					},
					{
						"n": 8,
						"h": 281,
						"w": 142
					},
					{
						"n": 9,
						"h": 409,
						"w": 181
					},
					{
						"n": 10,
						"h": 171,
						"w": 347
					},
					{
						"n": 11,
						"h": 304,
						"w": 409
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 125
					},
					{
						"n": 2,
						"h": 66,
						"w": 342
					},
					{
						"n": 3,
						"h": 169,
						"w": 342
					},
					{
						"n": 4,
						"h": 274,
						"w": 351
					},
					{
						"n": 5,
						"h": 379,
						"w": 291
					},
					{
						"n": 6,
						"h": 232,
						"w": 449
					},
					{
						"n": 7,
						"h": 197,
						"w": 514
					},
					{
						"n": 8,
						"h": 413,
						"w": 568
					},
					{
						"n": 9,
						"h": 51,
						"w": 595
					},
					{
						"n": 10,
						"h": 163,
						"w": 597
					},
					{
						"n": 11,
						"h": 392,
						"w": 596
					}
				],
				"ball": {
					"n": 0,
					"h": 253,
					"w": 206,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 38
		},
		{
			"num": 924,
			"minute": 45,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 235,
						"w": 11
					},
					{
						"n": 2,
						"h": 87,
						"w": 83
					},
					{
						"n": 3,
						"h": 254,
						"w": 54
					},
					{
						"n": 4,
						"h": 291,
						"w": 57
					},
					{
						"n": 5,
						"h": 385,
						"w": 81
					},
					{
						"n": 6,
						"h": 56,
						"w": 81
					},
					{
						"n": 7,
						"h": 282,
						"w": 171
					},
					{
						"n": 8,
						"h": 258,
						"w": 130
					},
					{
						"n": 9,
						"h": 406,
						"w": 163
					},
					{
						"n": 10,
						"h": 176,
						"w": 385
					},
					{
						"n": 11,
						"h": 275,
						"w": 400
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 120
					},
					{
						"n": 2,
						"h": 61,
						"w": 358
					},
					{
						"n": 3,
						"h": 175,
						"w": 305
					},
					{
						"n": 4,
						"h": 273,
						"w": 313
					},
					{
						"n": 5,
						"h": 376,
						"w": 300
					},
					{
						"n": 6,
						"h": 222,
						"w": 412
					},
					{
						"n": 7,
						"h": 163,
						"w": 526
					},
					{
						"n": 8,
						"h": 401,
						"w": 604
					},
					{
						"n": 9,
						"h": 57,
						"w": 632
					},
					{
						"n": 10,
						"h": 161,
						"w": 639
					},
					{
						"n": 11,
						"h": 401,
						"w": 633
					}
				],
				"ball": {
					"n": 0,
					"h": 287,
					"w": 194,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 38
		},
		{
			"num": 925,
			"minute": 45,
			"messages": [
				{
					"owner": 2,
					"mes": "Мирослав Манолов[27](Опава) пасует в штрафную..."
				},
				{
					"owner": 2,
					"mes": "Агуст Хлинссон[07](Галвэй Юнайтед) преграждает путь мячу!..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 234,
						"w": 12
					},
					{
						"n": 2,
						"h": 93,
						"w": 79
					},
					{
						"n": 3,
						"h": 250,
						"w": 60
					},
					{
						"n": 4,
						"h": 285,
						"w": 64
					},
					{
						"n": 5,
						"h": 382,
						"w": 75
					},
					{
						"n": 6,
						"h": 56,
						"w": 87
					},
					{
						"n": 7,
						"h": 287,
						"w": 175
					},
					{
						"n": 8,
						"h": 260,
						"w": 137
					},
					{
						"n": 9,
						"h": 406,
						"w": 163
					},
					{
						"n": 10,
						"h": 173,
						"w": 390
					},
					{
						"n": 11,
						"h": 282,
						"w": 400
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 119
					},
					{
						"n": 2,
						"h": 63,
						"w": 351
					},
					{
						"n": 3,
						"h": 177,
						"w": 298
					},
					{
						"n": 4,
						"h": 277,
						"w": 307
					},
					{
						"n": 5,
						"h": 381,
						"w": 305
					},
					{
						"n": 6,
						"h": 219,
						"w": 405
					},
					{
						"n": 7,
						"h": 163,
						"w": 526,
						"m": 560
					},
					{
						"n": 8,
						"h": 404,
						"w": 598
					},
					{
						"n": 9,
						"h": 57,
						"w": 639
					},
					{
						"n": 10,
						"h": 161,
						"w": 631,
						"m": 630
					},
					{
						"n": 11,
						"h": 406,
						"w": 628
					}
				],
				"ball": {
					"n": 0,
					"h": 287,
					"w": 175,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 7
		},
		{
			"num": 926,
			"minute": 45,
			"possession": 45,
			"messages": [
				{
					"owner": 0,
					"mes": "Первый тайм завершен."
				}
			],
			"M": "1"
		},
		{
			"num": 927,
			"minute": 46,
			"possession": 45,
			"messages": [],
			"N": {
				"team": 2
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 705
					},
					{
						"n": 2,
						"h": 405,
						"w": 630,
						"f": 88
					},
					{
						"n": 3,
						"h": 315,
						"w": 630
					},
					{
						"n": 4,
						"h": 135,
						"w": 630
					},
					{
						"n": 5,
						"h": 45,
						"w": 630,
						"f": 88
					},
					{
						"n": 6,
						"h": 405,
						"w": 510,
						"f": 87
					},
					{
						"n": 7,
						"h": 315,
						"w": 510,
						"f": 88,
						"m": 720
					},
					{
						"n": 8,
						"h": 135,
						"w": 510,
						"f": 86,
						"c": 1
					},
					{
						"n": 9,
						"h": 45,
						"w": 510,
						"f": 86,
						"c": 1
					},
					{
						"n": 10,
						"h": 350,
						"w": 390,
						"f": 87,
						"c": 1
					},
					{
						"n": 11,
						"h": 100,
						"w": 390,
						"f": 87
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 705
					},
					{
						"n": 2,
						"h": 413,
						"w": 630,
						"f": 85,
						"c": 1
					},
					{
						"n": 3,
						"h": 319,
						"w": 630
					},
					{
						"n": 4,
						"h": 131,
						"w": 630
					},
					{
						"n": 5,
						"h": 37,
						"w": 630,
						"f": 87
					},
					{
						"n": 6,
						"h": 225,
						"w": 570,
						"f": 87
					},
					{
						"n": 7,
						"h": 225,
						"w": 510,
						"f": 89
					},
					{
						"n": 8,
						"h": 37,
						"w": 510,
						"f": 87
					},
					{
						"n": 9,
						"h": 413,
						"w": 450,
						"f": 87
					},
					{
						"n": 10,
						"h": 237,
						"w": 386,
						"f": 86,
						"c": 1
					},
					{
						"n": 11,
						"h": 215,
						"w": 365,
						"f": 86,
						"c": 1
					}
				],
				"ball": {
					"n": 0,
					"h": 225,
					"w": 360,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 300
		},
		{
			"num": 928,
			"minute": 46,
			"messages": [
				{
					"owner": 1,
					"mes": "В команде Галвэй Юнайтед замена:"
				}
			],
			"S": {
				"team": 1,
				"out": 9,
				"in": 17
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 705
					},
					{
						"n": 2,
						"h": 405,
						"w": 630
					},
					{
						"n": 3,
						"h": 315,
						"w": 630
					},
					{
						"n": 4,
						"h": 135,
						"w": 630
					},
					{
						"n": 5,
						"h": 45,
						"w": 630
					},
					{
						"n": 6,
						"h": 405,
						"w": 510
					},
					{
						"n": 7,
						"h": 315,
						"w": 510
					},
					{
						"n": 8,
						"h": 135,
						"w": 510
					},
					{
						"n": 9,
						"h": 34,
						"w": 472
					},
					{
						"n": 10,
						"h": 350,
						"w": 390
					},
					{
						"n": 11,
						"h": 100,
						"w": 390
					},
					{
						"n": 17,
						"h": -1,
						"w": 358
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 705
					},
					{
						"n": 2,
						"h": 415,
						"w": 590
					},
					{
						"n": 3,
						"h": 319,
						"w": 630
					},
					{
						"n": 4,
						"h": 163,
						"w": 607
					},
					{
						"n": 5,
						"h": 37,
						"w": 630
					},
					{
						"n": 6,
						"h": 225,
						"w": 570
					},
					{
						"n": 7,
						"h": 225,
						"w": 510
					},
					{
						"n": 8,
						"h": 37,
						"w": 510
					},
					{
						"n": 9,
						"h": 424,
						"w": 412
					},
					{
						"n": 10,
						"h": 277,
						"w": 386
					},
					{
						"n": 11,
						"h": 199,
						"w": 377
					},
					{
						"n": 13,
						"h": 460,
						"w": 340
					},
					{
						"n": 14,
						"h": 460,
						"w": 320
					},
					{
						"n": 17,
						"h": 460,
						"w": 300
					},
					{
						"n": 19,
						"h": 460,
						"w": 280
					}
				],
				"ball": {
					"n": 0,
					"h": 225,
					"w": 360,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 20
		},
		{
			"num": 929,
			"minute": 46,
			"messages": [
				{
					"owner": 1,
					"mes": "Маттиас Раум[17](Галвэй Юнайтед) меняет Э.Бвомоно[09](Галвэй Юнайтед)."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 705
					},
					{
						"n": 2,
						"h": 405,
						"w": 630
					},
					{
						"n": 3,
						"h": 315,
						"w": 630
					},
					{
						"n": 4,
						"h": 135,
						"w": 630
					},
					{
						"n": 5,
						"h": 45,
						"w": 630
					},
					{
						"n": 6,
						"h": 405,
						"w": 510
					},
					{
						"n": 7,
						"h": 315,
						"w": 510
					},
					{
						"n": 8,
						"h": 135,
						"w": 510
					},
					{
						"n": 9,
						"h": 0,
						"w": 361
					},
					{
						"n": 10,
						"h": 350,
						"w": 390
					},
					{
						"n": 11,
						"h": 100,
						"w": 390
					},
					{
						"n": 17,
						"h": 0,
						"w": 360
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 705
					},
					{
						"n": 2,
						"h": 422,
						"w": 474
					},
					{
						"n": 3,
						"h": 319,
						"w": 630
					},
					{
						"n": 4,
						"h": 258,
						"w": 539
					},
					{
						"n": 5,
						"h": 37,
						"w": 630
					},
					{
						"n": 6,
						"h": 225,
						"w": 570
					},
					{
						"n": 7,
						"h": 225,
						"w": 510
					},
					{
						"n": 8,
						"h": 37,
						"w": 510
					},
					{
						"n": 9,
						"h": 428,
						"w": 397
					},
					{
						"n": 10,
						"h": 393,
						"w": 386
					},
					{
						"n": 11,
						"h": 153,
						"w": 413
					},
					{
						"n": 13,
						"h": 460,
						"w": 340
					},
					{
						"n": 14,
						"h": 460,
						"w": 320
					},
					{
						"n": 17,
						"h": 460,
						"w": 300
					},
					{
						"n": 19,
						"h": 460,
						"w": 280
					}
				],
				"ball": {
					"n": 0,
					"h": 225,
					"w": 360,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 58
		},
		{
			"num": 930,
			"minute": 46,
			"possession": 45,
			"messages": [
				{
					"owner": 2,
					"mes": "Опава производит замену:"
				}
			],
			"S": {
				"team": 2,
				"out": 2,
				"in": 13
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 705
					},
					{
						"n": 2,
						"h": 405,
						"w": 630
					},
					{
						"n": 3,
						"h": 315,
						"w": 630
					},
					{
						"n": 4,
						"h": 135,
						"w": 630
					},
					{
						"n": 5,
						"h": 45,
						"w": 630
					},
					{
						"n": 6,
						"h": 405,
						"w": 510
					},
					{
						"n": 7,
						"h": 315,
						"w": 510
					},
					{
						"n": 8,
						"h": 135,
						"w": 510
					},
					{
						"n": 17,
						"h": 12,
						"w": 378,
						"f": 100,
						"m": 600,
						"c": 0
					},
					{
						"n": 10,
						"h": 350,
						"w": 390
					},
					{
						"n": 11,
						"h": 100,
						"w": 390
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 705
					},
					{
						"n": 2,
						"h": 432,
						"w": 432
					},
					{
						"n": 3,
						"h": 319,
						"w": 630
					},
					{
						"n": 4,
						"h": 293,
						"w": 513
					},
					{
						"n": 5,
						"h": 37,
						"w": 630
					},
					{
						"n": 6,
						"h": 225,
						"w": 570
					},
					{
						"n": 7,
						"h": 225,
						"w": 510
					},
					{
						"n": 8,
						"h": 37,
						"w": 510
					},
					{
						"n": 9,
						"h": 428,
						"w": 397
					},
					{
						"n": 10,
						"h": 432,
						"w": 386
					},
					{
						"n": 11,
						"h": 136,
						"w": 426
					},
					{
						"n": 13,
						"h": 450,
						"w": 360
					},
					{
						"n": 14,
						"h": 460,
						"w": 320
					},
					{
						"n": 17,
						"h": 460,
						"w": 300
					},
					{
						"n": 19,
						"h": 460,
						"w": 280
					}
				],
				"ball": {
					"n": 0,
					"h": 225,
					"w": 360,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 22
		},
		{
			"num": 931,
			"minute": 46,
			"messages": [
				{
					"owner": 2,
					"mes": "Лука Седлачек[22](Опава) уходит с поля... Кеннет Удре[33](Опава) в игре."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 705
					},
					{
						"n": 2,
						"h": 405,
						"w": 630
					},
					{
						"n": 3,
						"h": 315,
						"w": 630
					},
					{
						"n": 4,
						"h": 135,
						"w": 630
					},
					{
						"n": 5,
						"h": 45,
						"w": 630
					},
					{
						"n": 6,
						"h": 405,
						"w": 510
					},
					{
						"n": 7,
						"h": 315,
						"w": 510
					},
					{
						"n": 8,
						"h": 135,
						"w": 510
					},
					{
						"n": 17,
						"h": 81,
						"w": 480
					},
					{
						"n": 10,
						"h": 350,
						"w": 390
					},
					{
						"n": 11,
						"h": 100,
						"w": 390
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 705
					},
					{
						"n": 2,
						"h": 450,
						"w": 360
					},
					{
						"n": 3,
						"h": 319,
						"w": 630
					},
					{
						"n": 4,
						"h": 353,
						"w": 470
					},
					{
						"n": 5,
						"h": 37,
						"w": 630
					},
					{
						"n": 6,
						"h": 225,
						"w": 570
					},
					{
						"n": 7,
						"h": 225,
						"w": 510
					},
					{
						"n": 8,
						"h": 37,
						"w": 510
					},
					{
						"n": 9,
						"h": 428,
						"w": 397
					},
					{
						"n": 10,
						"h": 432,
						"w": 386
					},
					{
						"n": 11,
						"h": 131,
						"w": 430
					},
					{
						"n": 13,
						"h": 450,
						"w": 360
					},
					{
						"n": 14,
						"h": 460,
						"w": 320
					},
					{
						"n": 17,
						"h": 460,
						"w": 300
					},
					{
						"n": 19,
						"h": 460,
						"w": 280
					}
				],
				"ball": {
					"n": 0,
					"h": 225,
					"w": 360,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 37
		},
		{
			"num": 932,
			"minute": 46,
			"messages": [
				{
					"owner": 2,
					"mes": "И занимает позицию левого опорного."
				}
			],
			"ZT": {
				"team": 2,
				"positions": [
					1,
					8,
					4,
					6,
					7,
					10,
					15,
					17,
					18,
					23,
					25
				],
				"text": ""
			}
		},
		{
			"num": 933,
			"minute": 46,
			"possession": 45,
			"messages": [
				{
					"owner": 2,
					"mes": "Замена в команде Опава:"
				}
			],
			"S": {
				"team": 2,
				"out": 4,
				"in": 14
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 705
					},
					{
						"n": 2,
						"h": 405,
						"w": 630
					},
					{
						"n": 3,
						"h": 315,
						"w": 630
					},
					{
						"n": 4,
						"h": 135,
						"w": 630
					},
					{
						"n": 5,
						"h": 45,
						"w": 630
					},
					{
						"n": 6,
						"h": 405,
						"w": 510
					},
					{
						"n": 7,
						"h": 315,
						"w": 510
					},
					{
						"n": 8,
						"h": 135,
						"w": 510
					},
					{
						"n": 17,
						"h": 81,
						"w": 480
					},
					{
						"n": 10,
						"h": 350,
						"w": 390
					},
					{
						"n": 11,
						"h": 100,
						"w": 390
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 705
					},
					{
						"n": 13,
						"h": 436,
						"w": 399,
						"f": 98,
						"m": 600,
						"c": 0
					},
					{
						"n": 3,
						"h": 319,
						"w": 630
					},
					{
						"n": 4,
						"h": 408,
						"w": 408
					},
					{
						"n": 5,
						"h": 37,
						"w": 630
					},
					{
						"n": 6,
						"h": 225,
						"w": 570
					},
					{
						"n": 7,
						"h": 225,
						"w": 510
					},
					{
						"n": 8,
						"h": 37,
						"w": 510
					},
					{
						"n": 9,
						"h": 428,
						"w": 397
					},
					{
						"n": 10,
						"h": 432,
						"w": 386
					},
					{
						"n": 11,
						"h": 131,
						"w": 430
					},
					{
						"n": 14,
						"h": 450,
						"w": 360
					},
					{
						"n": 17,
						"h": 460,
						"w": 300
					},
					{
						"n": 19,
						"h": 460,
						"w": 280
					}
				],
				"ball": {
					"n": 0,
					"h": 225,
					"w": 360,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 41
		},
		{
			"num": 934,
			"minute": 46,
			"messages": [
				{
					"owner": 2,
					"mes": "Вацлав Сланина[34](Опава) входит в игру вместо С.Пейши[24](Опава)."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 705
					},
					{
						"n": 2,
						"h": 405,
						"w": 630
					},
					{
						"n": 3,
						"h": 315,
						"w": 630
					},
					{
						"n": 4,
						"h": 135,
						"w": 630
					},
					{
						"n": 5,
						"h": 45,
						"w": 630
					},
					{
						"n": 6,
						"h": 405,
						"w": 510
					},
					{
						"n": 7,
						"h": 315,
						"w": 510
					},
					{
						"n": 8,
						"h": 135,
						"w": 510
					},
					{
						"n": 17,
						"h": 81,
						"w": 480
					},
					{
						"n": 10,
						"h": 350,
						"w": 390
					},
					{
						"n": 11,
						"h": 100,
						"w": 390
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 705
					},
					{
						"n": 13,
						"h": 393,
						"w": 519
					},
					{
						"n": 3,
						"h": 319,
						"w": 630
					},
					{
						"n": 4,
						"h": 450,
						"w": 360
					},
					{
						"n": 5,
						"h": 37,
						"w": 630
					},
					{
						"n": 6,
						"h": 225,
						"w": 570
					},
					{
						"n": 7,
						"h": 225,
						"w": 510
					},
					{
						"n": 8,
						"h": 37,
						"w": 510
					},
					{
						"n": 9,
						"h": 428,
						"w": 397
					},
					{
						"n": 10,
						"h": 432,
						"w": 386
					},
					{
						"n": 11,
						"h": 131,
						"w": 430
					},
					{
						"n": 14,
						"h": 450,
						"w": 360
					},
					{
						"n": 17,
						"h": 460,
						"w": 300
					},
					{
						"n": 19,
						"h": 460,
						"w": 280
					}
				],
				"ball": {
					"n": 0,
					"h": 225,
					"w": 360,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 32
		},
		{
			"num": 935,
			"minute": 46,
			"possession": 45,
			"messages": [
				{
					"owner": 2,
					"mes": "Замена в команде Опава:"
				}
			],
			"S": {
				"team": 2,
				"out": 9,
				"in": 17
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 705
					},
					{
						"n": 2,
						"h": 405,
						"w": 630
					},
					{
						"n": 3,
						"h": 315,
						"w": 630
					},
					{
						"n": 4,
						"h": 135,
						"w": 630
					},
					{
						"n": 5,
						"h": 45,
						"w": 630
					},
					{
						"n": 6,
						"h": 405,
						"w": 510
					},
					{
						"n": 7,
						"h": 315,
						"w": 510
					},
					{
						"n": 8,
						"h": 135,
						"w": 510
					},
					{
						"n": 17,
						"h": 81,
						"w": 480
					},
					{
						"n": 10,
						"h": 350,
						"w": 390
					},
					{
						"n": 11,
						"h": 100,
						"w": 390
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 705
					},
					{
						"n": 13,
						"h": 385,
						"w": 540
					},
					{
						"n": 3,
						"h": 319,
						"w": 630
					},
					{
						"n": 14,
						"h": 402,
						"w": 398,
						"f": 97,
						"m": 600,
						"c": 0
					},
					{
						"n": 5,
						"h": 37,
						"w": 630
					},
					{
						"n": 6,
						"h": 225,
						"w": 570
					},
					{
						"n": 7,
						"h": 225,
						"w": 510
					},
					{
						"n": 8,
						"h": 37,
						"w": 510
					},
					{
						"n": 9,
						"h": 450,
						"w": 360
					},
					{
						"n": 10,
						"h": 432,
						"w": 386
					},
					{
						"n": 11,
						"h": 131,
						"w": 430
					},
					{
						"n": 17,
						"h": 450,
						"w": 360
					},
					{
						"n": 19,
						"h": 460,
						"w": 280
					}
				],
				"ball": {
					"n": 0,
					"h": 225,
					"w": 360,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 61
		},
		{
			"num": 936,
			"minute": 46,
			"messages": [
				{
					"owner": 2,
					"mes": "Марин Томасов[37](Опава) входит в игру вместо М.Юрасека[29](Опава)."
				}
			]
		},
		{
			"num": 937,
			"minute": 46,
			"possession": 45,
			"messages": [
				{
					"owner": 2,
					"mes": "Замена в команде Опава:"
				}
			],
			"S": {
				"team": 2,
				"out": 10,
				"in": 19
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 705
					},
					{
						"n": 2,
						"h": 405,
						"w": 630
					},
					{
						"n": 3,
						"h": 315,
						"w": 630
					},
					{
						"n": 4,
						"h": 135,
						"w": 630
					},
					{
						"n": 5,
						"h": 45,
						"w": 630
					},
					{
						"n": 6,
						"h": 405,
						"w": 510
					},
					{
						"n": 7,
						"h": 315,
						"w": 510
					},
					{
						"n": 8,
						"h": 135,
						"w": 510
					},
					{
						"n": 17,
						"h": 81,
						"w": 480
					},
					{
						"n": 10,
						"h": 350,
						"w": 390
					},
					{
						"n": 11,
						"h": 100,
						"w": 390
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 705
					},
					{
						"n": 13,
						"h": 385,
						"w": 540
					},
					{
						"n": 3,
						"h": 319,
						"w": 630
					},
					{
						"n": 14,
						"h": 339,
						"w": 449
					},
					{
						"n": 5,
						"h": 37,
						"w": 630
					},
					{
						"n": 6,
						"h": 225,
						"w": 570
					},
					{
						"n": 7,
						"h": 225,
						"w": 510
					},
					{
						"n": 8,
						"h": 37,
						"w": 510
					},
					{
						"n": 17,
						"h": 385,
						"w": 408,
						"f": 97,
						"m": 600,
						"c": 0
					},
					{
						"n": 10,
						"h": 450,
						"w": 360
					},
					{
						"n": 11,
						"h": 131,
						"w": 430
					},
					{
						"n": 19,
						"h": 450,
						"w": 360
					}
				],
				"ball": {
					"n": 0,
					"h": 225,
					"w": 360,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 81
		},
		{
			"num": 938,
			"minute": 46,
			"messages": [
				{
					"owner": 2,
					"mes": "Петр Крамарж[30](Опава) уходит с поля... Александр Фрешль[39](Опава) в игре."
				}
			]
		},
		{
			"num": 939,
			"minute": 46,
			"possession": 45,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 705
					},
					{
						"n": 2,
						"h": 405,
						"w": 630
					},
					{
						"n": 3,
						"h": 315,
						"w": 630
					},
					{
						"n": 4,
						"h": 135,
						"w": 630
					},
					{
						"n": 5,
						"h": 45,
						"w": 630
					},
					{
						"n": 6,
						"h": 405,
						"w": 510
					},
					{
						"n": 7,
						"h": 315,
						"w": 510
					},
					{
						"n": 8,
						"h": 135,
						"w": 510
					},
					{
						"n": 17,
						"h": 81,
						"w": 480
					},
					{
						"n": 10,
						"h": 350,
						"w": 390
					},
					{
						"n": 11,
						"h": 100,
						"w": 390
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 705
					},
					{
						"n": 13,
						"h": 385,
						"w": 540
					},
					{
						"n": 3,
						"h": 319,
						"w": 630
					},
					{
						"n": 14,
						"h": 284,
						"w": 492
					},
					{
						"n": 5,
						"h": 37,
						"w": 630
					},
					{
						"n": 6,
						"h": 225,
						"w": 570
					},
					{
						"n": 7,
						"h": 225,
						"w": 510
					},
					{
						"n": 8,
						"h": 37,
						"w": 510
					},
					{
						"n": 17,
						"h": 368,
						"w": 420
					},
					{
						"n": 19,
						"h": 380,
						"w": 360,
						"f": 99,
						"m": 600,
						"c": 0
					},
					{
						"n": 11,
						"h": 131,
						"w": 430
					}
				],
				"ball": {
					"n": 0,
					"h": 225,
					"w": 360,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 70
		},
		{
			"num": 940,
			"minute": 46,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 705
					},
					{
						"n": 2,
						"h": 405,
						"w": 630
					},
					{
						"n": 3,
						"h": 315,
						"w": 630
					},
					{
						"n": 4,
						"h": 135,
						"w": 630
					},
					{
						"n": 5,
						"h": 45,
						"w": 630
					},
					{
						"n": 6,
						"h": 405,
						"w": 510
					},
					{
						"n": 7,
						"h": 315,
						"w": 510
					},
					{
						"n": 8,
						"h": 135,
						"w": 510
					},
					{
						"n": 17,
						"h": 81,
						"w": 480
					},
					{
						"n": 10,
						"h": 350,
						"w": 390
					},
					{
						"n": 11,
						"h": 100,
						"w": 390
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 705
					},
					{
						"n": 13,
						"h": 385,
						"w": 540
					},
					{
						"n": 3,
						"h": 319,
						"w": 630
					},
					{
						"n": 14,
						"h": 165,
						"w": 588
					},
					{
						"n": 5,
						"h": 37,
						"w": 630
					},
					{
						"n": 6,
						"h": 225,
						"w": 570
					},
					{
						"n": 7,
						"h": 225,
						"w": 510
					},
					{
						"n": 8,
						"h": 37,
						"w": 510
					},
					{
						"n": 17,
						"h": 368,
						"w": 420
					},
					{
						"n": 19,
						"h": 310,
						"w": 360
					},
					{
						"n": 11,
						"h": 131,
						"w": 430
					}
				],
				"ball": {
					"n": 0,
					"h": 225,
					"w": 360,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 153
		},
		{
			"num": 941,
			"minute": 46,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 705
					},
					{
						"n": 2,
						"h": 405,
						"w": 630
					},
					{
						"n": 3,
						"h": 315,
						"w": 630
					},
					{
						"n": 4,
						"h": 135,
						"w": 630
					},
					{
						"n": 5,
						"h": 45,
						"w": 630
					},
					{
						"n": 6,
						"h": 405,
						"w": 510
					},
					{
						"n": 7,
						"h": 315,
						"w": 510
					},
					{
						"n": 8,
						"h": 135,
						"w": 510
					},
					{
						"n": 17,
						"h": 45,
						"w": 510
					},
					{
						"n": 10,
						"h": 350,
						"w": 390
					},
					{
						"n": 11,
						"h": 100,
						"w": 390
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 705
					},
					{
						"n": 13,
						"h": 413,
						"w": 570
					},
					{
						"n": 3,
						"h": 319,
						"w": 630
					},
					{
						"n": 14,
						"h": 131,
						"w": 630
					},
					{
						"n": 5,
						"h": 37,
						"w": 630
					},
					{
						"n": 6,
						"h": 225,
						"w": 570
					},
					{
						"n": 7,
						"h": 225,
						"w": 510
					},
					{
						"n": 8,
						"h": 37,
						"w": 510
					},
					{
						"n": 17,
						"h": 413,
						"w": 450
					},
					{
						"n": 19,
						"h": 215,
						"w": 365
					},
					{
						"n": 11,
						"h": 237,
						"w": 386
					}
				],
				"ball": {
					"n": 0,
					"h": 225,
					"w": 360,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 30
		},
		{
			"num": 942,
			"minute": 46,
			"messages": [
				{
					"owner": 2,
					"mes": "Разыграли мяч..."
				},
				{
					"owner": 2,
					"mes": "Шимон Товарек[31](Опава) держит мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 705
					},
					{
						"n": 2,
						"h": 405,
						"w": 630
					},
					{
						"n": 3,
						"h": 315,
						"w": 630
					},
					{
						"n": 4,
						"h": 135,
						"w": 630
					},
					{
						"n": 5,
						"h": 45,
						"w": 630
					},
					{
						"n": 6,
						"h": 405,
						"w": 510
					},
					{
						"n": 7,
						"h": 315,
						"w": 510
					},
					{
						"n": 8,
						"h": 135,
						"w": 510
					},
					{
						"n": 17,
						"h": 45,
						"w": 510
					},
					{
						"n": 10,
						"h": 350,
						"w": 390
					},
					{
						"n": 11,
						"h": 100,
						"w": 390
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 705
					},
					{
						"n": 13,
						"h": 413,
						"w": 570
					},
					{
						"n": 3,
						"h": 319,
						"w": 630
					},
					{
						"n": 14,
						"h": 131,
						"w": 630
					},
					{
						"n": 5,
						"h": 37,
						"w": 630
					},
					{
						"n": 6,
						"h": 225,
						"w": 570
					},
					{
						"n": 7,
						"h": 225,
						"w": 510
					},
					{
						"n": 8,
						"h": 37,
						"w": 510
					},
					{
						"n": 17,
						"h": 413,
						"w": 450
					},
					{
						"n": 19,
						"h": 215,
						"w": 365
					},
					{
						"n": 11,
						"h": 237,
						"w": 386
					}
				],
				"ball": {
					"n": 0,
					"h": 213,
					"w": 334,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 15
		},
		{
			"num": 943,
			"minute": 46,
			"messages": [
				{
					"owner": 2,
					"mes": "Шимон Товарек[31](Опава) возвращает мяч назад..."
				},
				{
					"owner": 2,
					"mes": "Мирослав Манолов[27](Опава) достает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 707
					},
					{
						"n": 2,
						"h": 378,
						"w": 607
					},
					{
						"n": 3,
						"h": 295,
						"w": 601
					},
					{
						"n": 4,
						"h": 160,
						"w": 605
					},
					{
						"n": 5,
						"h": 70,
						"w": 606
					},
					{
						"n": 6,
						"h": 397,
						"w": 476
					},
					{
						"n": 7,
						"h": 287,
						"w": 489
					},
					{
						"n": 8,
						"h": 167,
						"w": 496
					},
					{
						"n": 17,
						"h": 46,
						"w": 475
					},
					{
						"n": 10,
						"h": 315,
						"w": 394
					},
					{
						"n": 11,
						"h": 113,
						"w": 357
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 701
					},
					{
						"n": 13,
						"h": 407,
						"w": 550
					},
					{
						"n": 3,
						"h": 284,
						"w": 634
					},
					{
						"n": 14,
						"h": 163,
						"w": 643
					},
					{
						"n": 5,
						"h": 52,
						"w": 626
					},
					{
						"n": 6,
						"h": 191,
						"w": 563
					},
					{
						"n": 7,
						"h": 240,
						"w": 491
					},
					{
						"n": 8,
						"h": 35,
						"w": 475
					},
					{
						"n": 17,
						"h": 415,
						"w": 415
					},
					{
						"n": 19,
						"h": 240,
						"w": 341
					},
					{
						"n": 11,
						"h": 228,
						"w": 390
					}
				],
				"ball": {
					"n": 0,
					"h": 210,
					"w": 229,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 35
		},
		{
			"num": 944,
			"minute": 46,
			"messages": [
				{
					"owner": 2,
					"mes": "Слева просит мяч Кеннет Удре[33](Опава)... Пас ему..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 705
					},
					{
						"n": 2,
						"h": 351,
						"w": 564
					},
					{
						"n": 3,
						"h": 277,
						"w": 554
					},
					{
						"n": 4,
						"h": 179,
						"w": 558
					},
					{
						"n": 5,
						"h": 100,
						"w": 565
					},
					{
						"n": 6,
						"h": 418,
						"w": 430
					},
					{
						"n": 7,
						"h": 250,
						"w": 454
					},
					{
						"n": 8,
						"h": 167,
						"w": 448
					},
					{
						"n": 17,
						"h": 51,
						"w": 424
					},
					{
						"n": 10,
						"h": 285,
						"w": 364
					},
					{
						"n": 11,
						"h": 126,
						"w": 308
					}
				],
				"away": [
					{
						"n": 1,
						"h": 228,
						"w": 702
					},
					{
						"n": 13,
						"h": 389,
						"w": 526
					},
					{
						"n": 3,
						"h": 276,
						"w": 597
					},
					{
						"n": 14,
						"h": 174,
						"w": 620
					},
					{
						"n": 5,
						"h": 50,
						"w": 582
					},
					{
						"n": 6,
						"h": 236,
						"w": 540
					},
					{
						"n": 7,
						"h": 243,
						"w": 482
					},
					{
						"n": 8,
						"h": 30,
						"w": 424
					},
					{
						"n": 17,
						"h": 412,
						"w": 364
					},
					{
						"n": 19,
						"h": 270,
						"w": 299
					},
					{
						"n": 11,
						"h": 203,
						"w": 345
					}
				],
				"ball": {
					"n": 0,
					"h": 61,
					"w": 194,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 51
		},
		{
			"num": 945,
			"minute": 46,
			"messages": [
				{
					"owner": 2,
					"mes": "Справа просит мяч Оливье Дюмон[26](Опава)... Пас ему..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 706
					},
					{
						"n": 2,
						"h": 338,
						"w": 520
					},
					{
						"n": 3,
						"h": 247,
						"w": 518
					},
					{
						"n": 4,
						"h": 173,
						"w": 512
					},
					{
						"n": 5,
						"h": 111,
						"w": 520
					},
					{
						"n": 6,
						"h": 404,
						"w": 386
					},
					{
						"n": 7,
						"h": 273,
						"w": 418
					},
					{
						"n": 8,
						"h": 156,
						"w": 411
					},
					{
						"n": 17,
						"h": 56,
						"w": 436
					},
					{
						"n": 10,
						"h": 278,
						"w": 321
					},
					{
						"n": 11,
						"h": 127,
						"w": 270
					}
				],
				"away": [
					{
						"n": 1,
						"h": 228,
						"w": 701
					},
					{
						"n": 13,
						"h": 395,
						"w": 535
					},
					{
						"n": 3,
						"h": 278,
						"w": 599
					},
					{
						"n": 14,
						"h": 178,
						"w": 592
					},
					{
						"n": 5,
						"h": 29,
						"w": 575
					},
					{
						"n": 6,
						"h": 252,
						"w": 525
					},
					{
						"n": 7,
						"h": 237,
						"w": 436
					},
					{
						"n": 8,
						"h": 35,
						"w": 379
					},
					{
						"n": 17,
						"h": 406,
						"w": 319
					},
					{
						"n": 19,
						"h": 285,
						"w": 262
					},
					{
						"n": 11,
						"h": 181,
						"w": 305
					}
				],
				"ball": {
					"n": 0,
					"h": 198,
					"w": 195,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 46
		},
		{
			"num": 946,
			"minute": 46,
			"messages": [
				{
					"owner": 2,
					"mes": "Видя свободного М.Манолова[27](Опава), Оливье Дюмон[26](Опава) отдает пас вперед..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 708
					},
					{
						"n": 2,
						"h": 330,
						"w": 518
					},
					{
						"n": 3,
						"h": 256,
						"w": 515
					},
					{
						"n": 4,
						"h": 171,
						"w": 518
					},
					{
						"n": 5,
						"h": 120,
						"w": 522
					},
					{
						"n": 6,
						"h": 394,
						"w": 382
					},
					{
						"n": 7,
						"h": 280,
						"w": 438
					},
					{
						"n": 8,
						"h": 181,
						"w": 422
					},
					{
						"n": 17,
						"h": 56,
						"w": 463
					},
					{
						"n": 10,
						"h": 305,
						"w": 320
					},
					{
						"n": 11,
						"h": 153,
						"w": 278
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 702
					},
					{
						"n": 13,
						"h": 402,
						"w": 550
					},
					{
						"n": 3,
						"h": 272,
						"w": 589
					},
					{
						"n": 14,
						"h": 182,
						"w": 590
					},
					{
						"n": 5,
						"h": 16,
						"w": 571
					},
					{
						"n": 6,
						"h": 246,
						"w": 517
					},
					{
						"n": 7,
						"h": 260,
						"w": 451
					},
					{
						"n": 8,
						"h": 43,
						"w": 353
					},
					{
						"n": 17,
						"h": 403,
						"w": 292
					},
					{
						"n": 19,
						"h": 302,
						"w": 252
					},
					{
						"n": 11,
						"h": 177,
						"w": 332
					}
				],
				"ball": {
					"n": 0,
					"h": 190,
					"w": 269,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 27
		},
		{
			"num": 947,
			"minute": 46,
			"messages": [
				{
					"owner": 2,
					"mes": "Мирослав Манолов[27](Опава) играет налево на К.Удре[33](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 707
					},
					{
						"n": 2,
						"h": 330,
						"w": 546
					},
					{
						"n": 3,
						"h": 227,
						"w": 529
					},
					{
						"n": 4,
						"h": 145,
						"w": 531
					},
					{
						"n": 5,
						"h": 108,
						"w": 543
					},
					{
						"n": 6,
						"h": 394,
						"w": 383
					},
					{
						"n": 7,
						"h": 237,
						"w": 468
					},
					{
						"n": 8,
						"h": 171,
						"w": 467
					},
					{
						"n": 17,
						"h": 46,
						"w": 436
					},
					{
						"n": 10,
						"h": 284,
						"w": 320
					},
					{
						"n": 11,
						"h": 129,
						"w": 270
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 685
					},
					{
						"n": 13,
						"h": 399,
						"w": 492
					},
					{
						"n": 3,
						"h": 279,
						"w": 542
					},
					{
						"n": 14,
						"h": 166,
						"w": 541
					},
					{
						"n": 5,
						"h": 50,
						"w": 524
					},
					{
						"n": 6,
						"h": 287,
						"w": 477
					},
					{
						"n": 7,
						"h": 260,
						"w": 441
					},
					{
						"n": 8,
						"h": 51,
						"w": 372
					},
					{
						"n": 17,
						"h": 351,
						"w": 317
					},
					{
						"n": 19,
						"h": 306,
						"w": 219
					},
					{
						"n": 11,
						"h": 203,
						"w": 280
					}
				],
				"ball": {
					"n": 0,
					"h": 51,
					"w": 228,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 58
		},
		{
			"num": 948,
			"minute": 46,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 709
					},
					{
						"n": 2,
						"h": 330,
						"w": 562
					},
					{
						"n": 3,
						"h": 238,
						"w": 550
					},
					{
						"n": 4,
						"h": 174,
						"w": 557
					},
					{
						"n": 5,
						"h": 120,
						"w": 564
					},
					{
						"n": 6,
						"h": 394,
						"w": 423
					},
					{
						"n": 7,
						"h": 248,
						"w": 486
					},
					{
						"n": 8,
						"h": 151,
						"w": 482
					},
					{
						"n": 17,
						"h": 54,
						"w": 460
					},
					{
						"n": 10,
						"h": 278,
						"w": 320
					},
					{
						"n": 11,
						"h": 89,
						"w": 274
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 666
					},
					{
						"n": 13,
						"h": 413,
						"w": 460
					},
					{
						"n": 3,
						"h": 280,
						"w": 502
					},
					{
						"n": 14,
						"h": 172,
						"w": 507
					},
					{
						"n": 5,
						"h": 74,
						"w": 509
					},
					{
						"n": 6,
						"h": 254,
						"w": 455
					},
					{
						"n": 7,
						"h": 260,
						"w": 401
					},
					{
						"n": 8,
						"h": 48,
						"w": 332
					},
					{
						"n": 17,
						"h": 315,
						"w": 334
					},
					{
						"n": 19,
						"h": 294,
						"w": 181
					},
					{
						"n": 11,
						"h": 208,
						"w": 240
					}
				],
				"ball": {
					"n": 0,
					"h": 37,
					"w": 260,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 949,
			"minute": 46,
			"messages": [
				{
					"owner": 2,
					"mes": "Кеннет Удре[33](Опава) пасует направо на О.Дюмона[26](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 702
					},
					{
						"n": 2,
						"h": 330,
						"w": 554
					},
					{
						"n": 3,
						"h": 239,
						"w": 554
					},
					{
						"n": 4,
						"h": 164,
						"w": 551
					},
					{
						"n": 5,
						"h": 120,
						"w": 567
					},
					{
						"n": 6,
						"h": 394,
						"w": 472
					},
					{
						"n": 7,
						"h": 228,
						"w": 488
					},
					{
						"n": 8,
						"h": 179,
						"w": 466
					},
					{
						"n": 17,
						"h": 55,
						"w": 460
					},
					{
						"n": 10,
						"h": 316,
						"w": 320
					},
					{
						"n": 11,
						"h": 138,
						"w": 268
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 642
					},
					{
						"n": 13,
						"h": 412,
						"w": 450,
						"m": 610
					},
					{
						"n": 3,
						"h": 300,
						"w": 499
					},
					{
						"n": 14,
						"h": 179,
						"w": 482
					},
					{
						"n": 5,
						"h": 74,
						"w": 466
					},
					{
						"n": 6,
						"h": 268,
						"w": 477
					},
					{
						"n": 7,
						"h": 230,
						"w": 361
					},
					{
						"n": 8,
						"h": 51,
						"w": 283
					},
					{
						"n": 17,
						"h": 267,
						"w": 346
					},
					{
						"n": 19,
						"h": 315,
						"w": 185
					},
					{
						"n": 11,
						"h": 215,
						"w": 192
					}
				],
				"ball": {
					"n": 0,
					"h": 182,
					"w": 243,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 49
		},
		{
			"num": 950,
			"minute": 46,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 705
					},
					{
						"n": 2,
						"h": 330,
						"w": 571
					},
					{
						"n": 3,
						"h": 230,
						"w": 573
					},
					{
						"n": 4,
						"h": 164,
						"w": 560
					},
					{
						"n": 5,
						"h": 120,
						"w": 560
					},
					{
						"n": 6,
						"h": 394,
						"w": 511
					},
					{
						"n": 7,
						"h": 233,
						"w": 508
					},
					{
						"n": 8,
						"h": 179,
						"w": 485
					},
					{
						"n": 17,
						"h": 30,
						"w": 465
					},
					{
						"n": 10,
						"h": 311,
						"w": 320
					},
					{
						"n": 11,
						"h": 174,
						"w": 285
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 625
					},
					{
						"n": 13,
						"h": 402,
						"w": 411
					},
					{
						"n": 3,
						"h": 275,
						"w": 510
					},
					{
						"n": 14,
						"h": 167,
						"w": 489
					},
					{
						"n": 5,
						"h": 73,
						"w": 479
					},
					{
						"n": 6,
						"h": 254,
						"w": 445
					},
					{
						"n": 7,
						"h": 242,
						"w": 323
					},
					{
						"n": 8,
						"h": 48,
						"w": 244
					},
					{
						"n": 17,
						"h": 230,
						"w": 361
					},
					{
						"n": 19,
						"h": 297,
						"w": 172
					},
					{
						"n": 11,
						"h": 218,
						"w": 197
					}
				],
				"ball": {
					"n": 0,
					"h": 196,
					"w": 275,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 951,
			"minute": 46,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 707
					},
					{
						"n": 2,
						"h": 330,
						"w": 577
					},
					{
						"n": 3,
						"h": 217,
						"w": 571
					},
					{
						"n": 4,
						"h": 162,
						"w": 576
					},
					{
						"n": 5,
						"h": 120,
						"w": 564
					},
					{
						"n": 6,
						"h": 394,
						"w": 551
					},
					{
						"n": 7,
						"h": 263,
						"w": 487
					},
					{
						"n": 8,
						"h": 206,
						"w": 498
					},
					{
						"n": 17,
						"h": 42,
						"w": 427
					},
					{
						"n": 10,
						"h": 273,
						"w": 320
					},
					{
						"n": 11,
						"h": 195,
						"w": 319
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 618
					},
					{
						"n": 13,
						"h": 402,
						"w": 371
					},
					{
						"n": 3,
						"h": 275,
						"w": 495
					},
					{
						"n": 14,
						"h": 177,
						"w": 475
					},
					{
						"n": 5,
						"h": 59,
						"w": 462
					},
					{
						"n": 6,
						"h": 248,
						"w": 410
					},
					{
						"n": 7,
						"h": 237,
						"w": 283
					},
					{
						"n": 8,
						"h": 44,
						"w": 204
					},
					{
						"n": 17,
						"h": 207,
						"w": 394
					},
					{
						"n": 19,
						"h": 317,
						"w": 196
					},
					{
						"n": 11,
						"h": 238,
						"w": 170
					}
				],
				"ball": {
					"n": 0,
					"h": 202,
					"w": 310,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 952,
			"minute": 46,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 703
					},
					{
						"n": 2,
						"h": 370,
						"w": 572
					},
					{
						"n": 3,
						"h": 230,
						"w": 590
					},
					{
						"n": 4,
						"h": 172,
						"w": 599
					},
					{
						"n": 5,
						"h": 120,
						"w": 603
					},
					{
						"n": 6,
						"h": 412,
						"w": 515
					},
					{
						"n": 7,
						"h": 273,
						"w": 526
					},
					{
						"n": 8,
						"h": 183,
						"w": 516
					},
					{
						"n": 17,
						"h": 56,
						"w": 424
					},
					{
						"n": 10,
						"h": 285,
						"w": 320
					},
					{
						"n": 11,
						"h": 222,
						"w": 349
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 596
					},
					{
						"n": 13,
						"h": 402,
						"w": 331
					},
					{
						"n": 3,
						"h": 273,
						"w": 460
					},
					{
						"n": 14,
						"h": 165,
						"w": 468
					},
					{
						"n": 5,
						"h": 74,
						"w": 441
					},
					{
						"n": 6,
						"h": 223,
						"w": 385
					},
					{
						"n": 7,
						"h": 228,
						"w": 244
					},
					{
						"n": 8,
						"h": 42,
						"w": 164
					},
					{
						"n": 17,
						"h": 171,
						"w": 411
					},
					{
						"n": 19,
						"h": 297,
						"w": 168
					},
					{
						"n": 11,
						"h": 218,
						"w": 164
					}
				],
				"ball": {
					"n": 0,
					"h": 227,
					"w": 335,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 953,
			"minute": 46,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 704
					},
					{
						"n": 2,
						"h": 342,
						"w": 601
					},
					{
						"n": 3,
						"h": 208,
						"w": 615
					},
					{
						"n": 4,
						"h": 171,
						"w": 617
					},
					{
						"n": 5,
						"h": 120,
						"w": 625
					},
					{
						"n": 6,
						"h": 394,
						"w": 540
					},
					{
						"n": 7,
						"h": 273,
						"w": 547
					},
					{
						"n": 8,
						"h": 208,
						"w": 536
					},
					{
						"n": 17,
						"h": 56,
						"w": 463
					},
					{
						"n": 10,
						"h": 274,
						"w": 320
					},
					{
						"n": 11,
						"h": 255,
						"w": 371
					}
				],
				"away": [
					{
						"n": 1,
						"h": 228,
						"w": 595
					},
					{
						"n": 13,
						"h": 407,
						"w": 292
					},
					{
						"n": 3,
						"h": 280,
						"w": 451
					},
					{
						"n": 14,
						"h": 176,
						"w": 435
					},
					{
						"n": 5,
						"h": 65,
						"w": 421
					},
					{
						"n": 6,
						"h": 192,
						"w": 368
					},
					{
						"n": 7,
						"h": 233,
						"w": 204
					},
					{
						"n": 8,
						"h": 24,
						"w": 195
					},
					{
						"n": 17,
						"h": 134,
						"w": 394
					},
					{
						"n": 19,
						"h": 297,
						"w": 144
					},
					{
						"n": 11,
						"h": 240,
						"w": 144
					}
				],
				"ball": {
					"n": 0,
					"h": 258,
					"w": 352,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 954,
			"minute": 46,
			"messages": [
				{
					"owner": 2,
					"mes": "Оливье Дюмон[26](Опава) пасует направо..."
				},
				{
					"owner": 2,
					"mes": "Марин Томасов[37](Опава) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 706
					},
					{
						"n": 2,
						"h": 330,
						"w": 614
					},
					{
						"n": 3,
						"h": 227,
						"w": 622
					},
					{
						"n": 4,
						"h": 168,
						"w": 612
					},
					{
						"n": 5,
						"h": 120,
						"w": 616
					},
					{
						"n": 6,
						"h": 394,
						"w": 564
					},
					{
						"n": 7,
						"h": 261,
						"w": 536
					},
					{
						"n": 8,
						"h": 187,
						"w": 544
					},
					{
						"n": 17,
						"h": 56,
						"w": 467
					},
					{
						"n": 10,
						"h": 294,
						"w": 333
					},
					{
						"n": 11,
						"h": 238,
						"w": 354
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 596
					},
					{
						"n": 13,
						"h": 409,
						"w": 268
					},
					{
						"n": 3,
						"h": 284,
						"w": 454
					},
					{
						"n": 14,
						"h": 175,
						"w": 436
					},
					{
						"n": 5,
						"h": 67,
						"w": 445
					},
					{
						"n": 6,
						"h": 202,
						"w": 365
					},
					{
						"n": 7,
						"h": 236,
						"w": 228
					},
					{
						"n": 8,
						"h": 27,
						"w": 171
					},
					{
						"n": 17,
						"h": 148,
						"w": 386
					},
					{
						"n": 19,
						"h": 302,
						"w": 121
					},
					{
						"n": 11,
						"h": 221,
						"w": 154
					}
				],
				"ball": {
					"n": 0,
					"h": 302,
					"w": 334,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 24
		},
		{
			"num": 955,
			"minute": 46,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 708
					},
					{
						"n": 2,
						"h": 330,
						"w": 609
					},
					{
						"n": 3,
						"h": 208,
						"w": 619
					},
					{
						"n": 4,
						"h": 169,
						"w": 613
					},
					{
						"n": 5,
						"h": 120,
						"w": 618
					},
					{
						"n": 6,
						"h": 394,
						"w": 583
					},
					{
						"n": 7,
						"h": 255,
						"w": 523
					},
					{
						"n": 8,
						"h": 213,
						"w": 538
					},
					{
						"n": 17,
						"h": 56,
						"w": 507
					},
					{
						"n": 10,
						"h": 312,
						"w": 369
					},
					{
						"n": 11,
						"h": 201,
						"w": 338
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 599
					},
					{
						"n": 13,
						"h": 414,
						"w": 228
					},
					{
						"n": 3,
						"h": 269,
						"w": 444
					},
					{
						"n": 14,
						"h": 178,
						"w": 433
					},
					{
						"n": 5,
						"h": 62,
						"w": 429
					},
					{
						"n": 6,
						"h": 232,
						"w": 344
					},
					{
						"n": 7,
						"h": 231,
						"w": 204
					},
					{
						"n": 8,
						"h": 30,
						"w": 172
					},
					{
						"n": 17,
						"h": 130,
						"w": 355
					},
					{
						"n": 19,
						"h": 309,
						"w": 144
					},
					{
						"n": 11,
						"h": 239,
						"w": 144
					}
				],
				"ball": {
					"n": 0,
					"h": 320,
					"w": 365,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 956,
			"minute": 46,
			"messages": [
				{
					"owner": 2,
					"mes": "Марин Томасов[37](Опава) низом пасует мяч назад..."
				},
				{
					"owner": 2,
					"mes": "Теперь с мячом Вацлав Сланина[34](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 702
					},
					{
						"n": 2,
						"h": 307,
						"w": 595
					},
					{
						"n": 3,
						"h": 215,
						"w": 593
					},
					{
						"n": 4,
						"h": 173,
						"w": 586
					},
					{
						"n": 5,
						"h": 120,
						"w": 591
					},
					{
						"n": 6,
						"h": 391,
						"w": 559
					},
					{
						"n": 7,
						"h": 237,
						"w": 503
					},
					{
						"n": 8,
						"h": 194,
						"w": 519
					},
					{
						"n": 17,
						"h": 56,
						"w": 500
					},
					{
						"n": 10,
						"h": 296,
						"w": 390
					},
					{
						"n": 11,
						"h": 228,
						"w": 334
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 616
					},
					{
						"n": 13,
						"h": 412,
						"w": 255
					},
					{
						"n": 3,
						"h": 270,
						"w": 471
					},
					{
						"n": 14,
						"h": 156,
						"w": 418
					},
					{
						"n": 5,
						"h": 69,
						"w": 455
					},
					{
						"n": 6,
						"h": 224,
						"w": 324
					},
					{
						"n": 7,
						"h": 232,
						"w": 231
					},
					{
						"n": 8,
						"h": 44,
						"w": 195
					},
					{
						"n": 17,
						"h": 140,
						"w": 358
					},
					{
						"n": 19,
						"h": 290,
						"w": 163
					},
					{
						"n": 11,
						"h": 223,
						"w": 166
					}
				],
				"ball": {
					"n": 0,
					"h": 294,
					"w": 302,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 27
		},
		{
			"num": 957,
			"minute": 46,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 708
					},
					{
						"n": 2,
						"h": 330,
						"w": 610
					},
					{
						"n": 3,
						"h": 233,
						"w": 626
					},
					{
						"n": 4,
						"h": 168,
						"w": 615
					},
					{
						"n": 5,
						"h": 120,
						"w": 626
					},
					{
						"n": 6,
						"h": 394,
						"w": 540
					},
					{
						"n": 7,
						"h": 250,
						"w": 526
					},
					{
						"n": 8,
						"h": 187,
						"w": 538
					},
					{
						"n": 17,
						"h": 56,
						"w": 519
					},
					{
						"n": 10,
						"h": 290,
						"w": 356
					},
					{
						"n": 11,
						"h": 193,
						"w": 317
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 597
					},
					{
						"n": 13,
						"h": 417,
						"w": 216
					},
					{
						"n": 3,
						"h": 286,
						"w": 456
					},
					{
						"n": 14,
						"h": 160,
						"w": 384
					},
					{
						"n": 5,
						"h": 63,
						"w": 442
					},
					{
						"n": 6,
						"h": 217,
						"w": 335
					},
					{
						"n": 7,
						"h": 210,
						"w": 204
					},
					{
						"n": 8,
						"h": 25,
						"w": 195
					},
					{
						"n": 17,
						"h": 153,
						"w": 322
					},
					{
						"n": 19,
						"h": 293,
						"w": 144
					},
					{
						"n": 11,
						"h": 214,
						"w": 144
					}
				],
				"ball": {
					"n": 0,
					"h": 290,
					"w": 336,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 958,
			"minute": 46,
			"messages": [
				{
					"owner": 2,
					"mes": "Пас налево О.Дюмону[26](Опава)..."
				},
				{
					"owner": 2,
					"mes": "Оливье Дюмон[26](Опава) принимает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 705
					},
					{
						"n": 2,
						"h": 330,
						"w": 610
					},
					{
						"n": 3,
						"h": 238,
						"w": 608
					},
					{
						"n": 4,
						"h": 164,
						"w": 608
					},
					{
						"n": 5,
						"h": 120,
						"w": 613
					},
					{
						"n": 6,
						"h": 394,
						"w": 566
					},
					{
						"n": 7,
						"h": 238,
						"w": 554
					},
					{
						"n": 8,
						"h": 177,
						"w": 515
					},
					{
						"n": 17,
						"h": 56,
						"w": 490
					},
					{
						"n": 10,
						"h": 264,
						"w": 371
					},
					{
						"n": 11,
						"h": 168,
						"w": 300
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 593
					},
					{
						"n": 13,
						"h": 409,
						"w": 245
					},
					{
						"n": 3,
						"h": 277,
						"w": 461
					},
					{
						"n": 14,
						"h": 164,
						"w": 393
					},
					{
						"n": 5,
						"h": 69,
						"w": 425
					},
					{
						"n": 6,
						"h": 203,
						"w": 341
					},
					{
						"n": 7,
						"h": 230,
						"w": 226
					},
					{
						"n": 8,
						"h": 39,
						"w": 169
					},
					{
						"n": 17,
						"h": 139,
						"w": 344
					},
					{
						"n": 19,
						"h": 300,
						"w": 135
					},
					{
						"n": 11,
						"h": 211,
						"w": 151
					}
				],
				"ball": {
					"n": 0,
					"h": 247,
					"w": 379,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 30
		},
		{
			"num": 959,
			"minute": 46,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 708
					},
					{
						"n": 2,
						"h": 330,
						"w": 622
					},
					{
						"n": 3,
						"h": 232,
						"w": 610
					},
					{
						"n": 4,
						"h": 183,
						"w": 611
					},
					{
						"n": 5,
						"h": 120,
						"w": 614
					},
					{
						"n": 6,
						"h": 384,
						"w": 602
					},
					{
						"n": 7,
						"h": 241,
						"w": 568
					},
					{
						"n": 8,
						"h": 215,
						"w": 526
					},
					{
						"n": 17,
						"h": 56,
						"w": 477
					},
					{
						"n": 10,
						"h": 228,
						"w": 389
					},
					{
						"n": 11,
						"h": 170,
						"w": 299
					}
				],
				"away": [
					{
						"n": 1,
						"h": 226,
						"w": 601
					},
					{
						"n": 13,
						"h": 408,
						"w": 278
					},
					{
						"n": 3,
						"h": 280,
						"w": 432
					},
					{
						"n": 14,
						"h": 166,
						"w": 433
					},
					{
						"n": 5,
						"h": 60,
						"w": 448
					},
					{
						"n": 6,
						"h": 238,
						"w": 343
					},
					{
						"n": 7,
						"h": 234,
						"w": 218
					},
					{
						"n": 8,
						"h": 51,
						"w": 142
					},
					{
						"n": 17,
						"h": 136,
						"w": 345
					},
					{
						"n": 19,
						"h": 283,
						"w": 120
					},
					{
						"n": 11,
						"h": 217,
						"w": 151
					}
				],
				"ball": {
					"n": 0,
					"h": 212,
					"w": 377,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 960,
			"minute": 46,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 709
					},
					{
						"n": 2,
						"h": 330,
						"w": 620
					},
					{
						"n": 3,
						"h": 234,
						"w": 615
					},
					{
						"n": 4,
						"h": 176,
						"w": 601
					},
					{
						"n": 5,
						"h": 120,
						"w": 603
					},
					{
						"n": 6,
						"h": 394,
						"w": 595
					},
					{
						"n": 7,
						"h": 243,
						"w": 564
					},
					{
						"n": 8,
						"h": 222,
						"w": 523
					},
					{
						"n": 17,
						"h": 56,
						"w": 493
					},
					{
						"n": 10,
						"h": 188,
						"w": 392
					},
					{
						"n": 11,
						"h": 179,
						"w": 312
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 597
					},
					{
						"n": 13,
						"h": 399,
						"w": 262
					},
					{
						"n": 3,
						"h": 271,
						"w": 423
					},
					{
						"n": 14,
						"h": 162,
						"w": 429
					},
					{
						"n": 5,
						"h": 73,
						"w": 431
					},
					{
						"n": 6,
						"h": 273,
						"w": 347
					},
					{
						"n": 7,
						"h": 228,
						"w": 239
					},
					{
						"n": 8,
						"h": 35,
						"w": 146
					},
					{
						"n": 17,
						"h": 172,
						"w": 329
					},
					{
						"n": 19,
						"h": 294,
						"w": 138
					},
					{
						"n": 11,
						"h": 211,
						"w": 144
					}
				],
				"ball": {
					"n": 0,
					"h": 177,
					"w": 373,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 961,
			"minute": 46,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 704
					},
					{
						"n": 2,
						"h": 330,
						"w": 619
					},
					{
						"n": 3,
						"h": 221,
						"w": 623
					},
					{
						"n": 4,
						"h": 155,
						"w": 625
					},
					{
						"n": 5,
						"h": 120,
						"w": 630
					},
					{
						"n": 6,
						"h": 407,
						"w": 557
					},
					{
						"n": 7,
						"h": 274,
						"w": 541
					},
					{
						"n": 8,
						"h": 221,
						"w": 541
					},
					{
						"n": 17,
						"h": 56,
						"w": 533
					},
					{
						"n": 10,
						"h": 156,
						"w": 415
					},
					{
						"n": 11,
						"h": 141,
						"w": 298
					}
				],
				"away": [
					{
						"n": 1,
						"h": 221,
						"w": 600
					},
					{
						"n": 13,
						"h": 402,
						"w": 222
					},
					{
						"n": 3,
						"h": 271,
						"w": 450
					},
					{
						"n": 14,
						"h": 175,
						"w": 434
					},
					{
						"n": 5,
						"h": 62,
						"w": 444
					},
					{
						"n": 6,
						"h": 298,
						"w": 323
					},
					{
						"n": 7,
						"h": 237,
						"w": 200
					},
					{
						"n": 8,
						"h": 43,
						"w": 116
					},
					{
						"n": 17,
						"h": 152,
						"w": 346
					},
					{
						"n": 19,
						"h": 314,
						"w": 124
					},
					{
						"n": 11,
						"h": 231,
						"w": 119
					}
				],
				"ball": {
					"n": 0,
					"h": 152,
					"w": 397,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 962,
			"minute": 46,
			"messages": [
				{
					"owner": 2,
					"mes": "Передача вперед..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 707
					},
					{
						"n": 2,
						"h": 330,
						"w": 616
					},
					{
						"n": 3,
						"h": 226,
						"w": 608
					},
					{
						"n": 4,
						"h": 178,
						"w": 603
					},
					{
						"n": 5,
						"h": 93,
						"w": 595
					},
					{
						"n": 6,
						"h": 387,
						"w": 591
					},
					{
						"n": 7,
						"h": 230,
						"w": 547
					},
					{
						"n": 8,
						"h": 187,
						"w": 518
					},
					{
						"n": 17,
						"h": 66,
						"w": 490
					},
					{
						"n": 10,
						"h": 116,
						"w": 434
					},
					{
						"n": 11,
						"h": 175,
						"w": 310
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 593
					},
					{
						"n": 13,
						"h": 389,
						"w": 259
					},
					{
						"n": 3,
						"h": 275,
						"w": 424
					},
					{
						"n": 14,
						"h": 170,
						"w": 439
					},
					{
						"n": 5,
						"h": 74,
						"w": 421
					},
					{
						"n": 6,
						"h": 284,
						"w": 322
					},
					{
						"n": 7,
						"h": 254,
						"w": 230
					},
					{
						"n": 8,
						"h": 48,
						"w": 131
					},
					{
						"n": 17,
						"h": 187,
						"w": 328
					},
					{
						"n": 19,
						"h": 279,
						"w": 133
					},
					{
						"n": 11,
						"h": 231,
						"w": 151
					}
				],
				"ball": {
					"n": 0,
					"h": 80,
					"w": 447,
					"z": 0,
					"r": 0,
					"p": 1,
					"x": 0
				}
			},
			"interval": 44
		},
		{
			"num": 963,
			"minute": 46,
			"messages": [
				{
					"owner": 2,
					"mes": "Кеннет Удре[33](Опава) останавливает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 705
					},
					{
						"n": 2,
						"h": 330,
						"w": 608
					},
					{
						"n": 3,
						"h": 228,
						"w": 600
					},
					{
						"n": 4,
						"h": 176,
						"w": 606
					},
					{
						"n": 5,
						"h": 95,
						"w": 604
					},
					{
						"n": 6,
						"h": 388,
						"w": 580
					},
					{
						"n": 7,
						"h": 234,
						"w": 543
					},
					{
						"n": 8,
						"h": 176,
						"w": 517
					},
					{
						"n": 17,
						"h": 72,
						"w": 481
					},
					{
						"n": 10,
						"h": 125,
						"w": 428
					},
					{
						"n": 11,
						"h": 175,
						"w": 299
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 598
					},
					{
						"n": 13,
						"h": 379,
						"w": 266
					},
					{
						"n": 3,
						"h": 274,
						"w": 435
					},
					{
						"n": 14,
						"h": 171,
						"w": 450
					},
					{
						"n": 5,
						"h": 72,
						"w": 432
					},
					{
						"n": 6,
						"h": 279,
						"w": 331
					},
					{
						"n": 7,
						"h": 247,
						"w": 239
					},
					{
						"n": 8,
						"h": 51,
						"w": 131
					},
					{
						"n": 17,
						"h": 195,
						"w": 336
					},
					{
						"n": 19,
						"h": 285,
						"w": 141
					},
					{
						"n": 11,
						"h": 222,
						"w": 151
					}
				],
				"ball": {
					"n": 0,
					"h": 71,
					"w": 454,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 11
		},
		{
			"num": 964,
			"minute": 46,
			"messages": [
				{
					"owner": 2,
					"mes": "Пас направо М.Томасову[37](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 701
					},
					{
						"n": 2,
						"h": 388,
						"w": 594
					},
					{
						"n": 3,
						"h": 215,
						"w": 591
					},
					{
						"n": 4,
						"h": 181,
						"w": 609
					},
					{
						"n": 5,
						"h": 120,
						"w": 591
					},
					{
						"n": 6,
						"h": 389,
						"w": 514
					},
					{
						"n": 7,
						"h": 252,
						"w": 479
					},
					{
						"n": 8,
						"h": 201,
						"w": 525
					},
					{
						"n": 17,
						"h": 67,
						"w": 479
					},
					{
						"n": 10,
						"h": 179,
						"w": 391
					},
					{
						"n": 11,
						"h": 143,
						"w": 274
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 600
					},
					{
						"n": 13,
						"h": 383,
						"w": 276
					},
					{
						"n": 3,
						"h": 275,
						"w": 473
					},
					{
						"n": 14,
						"h": 167,
						"w": 452
					},
					{
						"n": 5,
						"h": 61,
						"w": 443
					},
					{
						"n": 6,
						"h": 221,
						"w": 356
					},
					{
						"n": 7,
						"h": 259,
						"w": 215
					},
					{
						"n": 8,
						"h": 46,
						"w": 141
					},
					{
						"n": 17,
						"h": 196,
						"w": 270
					},
					{
						"n": 19,
						"h": 286,
						"w": 151
					},
					{
						"n": 11,
						"h": 239,
						"w": 151
					}
				],
				"ball": {
					"n": 0,
					"h": 254,
					"w": 450,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 66
		},
		{
			"num": 965,
			"minute": 46,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 708
					},
					{
						"n": 2,
						"h": 394,
						"w": 564
					},
					{
						"n": 3,
						"h": 239,
						"w": 609
					},
					{
						"n": 4,
						"h": 176,
						"w": 606
					},
					{
						"n": 5,
						"h": 120,
						"w": 605
					},
					{
						"n": 6,
						"h": 413,
						"w": 499
					},
					{
						"n": 7,
						"h": 241,
						"w": 494
					},
					{
						"n": 8,
						"h": 186,
						"w": 527
					},
					{
						"n": 17,
						"h": 56,
						"w": 445
					},
					{
						"n": 10,
						"h": 212,
						"w": 369
					},
					{
						"n": 11,
						"h": 168,
						"w": 287
					}
				],
				"away": [
					{
						"n": 1,
						"h": 228,
						"w": 595
					},
					{
						"n": 13,
						"h": 401,
						"w": 310
					},
					{
						"n": 3,
						"h": 282,
						"w": 451
					},
					{
						"n": 14,
						"h": 165,
						"w": 436
					},
					{
						"n": 5,
						"h": 69,
						"w": 462
					},
					{
						"n": 6,
						"h": 234,
						"w": 331
					},
					{
						"n": 7,
						"h": 259,
						"w": 207
					},
					{
						"n": 8,
						"h": 34,
						"w": 161
					},
					{
						"n": 17,
						"h": 208,
						"w": 248
					},
					{
						"n": 19,
						"h": 285,
						"w": 140
					},
					{
						"n": 11,
						"h": 214,
						"w": 151
					}
				],
				"ball": {
					"n": 0,
					"h": 242,
					"w": 472,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 966,
			"minute": 46,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 706
					},
					{
						"n": 2,
						"h": 394,
						"w": 564
					},
					{
						"n": 3,
						"h": 237,
						"w": 593
					},
					{
						"n": 4,
						"h": 172,
						"w": 599
					},
					{
						"n": 5,
						"h": 120,
						"w": 601
					},
					{
						"n": 6,
						"h": 407,
						"w": 499
					},
					{
						"n": 7,
						"h": 275,
						"w": 499
					},
					{
						"n": 8,
						"h": 221,
						"w": 508
					},
					{
						"n": 17,
						"h": 56,
						"w": 420
					},
					{
						"n": 10,
						"h": 244,
						"w": 345
					},
					{
						"n": 11,
						"h": 135,
						"w": 274
					}
				],
				"away": [
					{
						"n": 1,
						"h": 223,
						"w": 595
					},
					{
						"n": 13,
						"h": 404,
						"w": 335
					},
					{
						"n": 3,
						"h": 271,
						"w": 468
					},
					{
						"n": 14,
						"h": 173,
						"w": 467
					},
					{
						"n": 5,
						"h": 66,
						"w": 459
					},
					{
						"n": 6,
						"h": 226,
						"w": 370
					},
					{
						"n": 7,
						"h": 237,
						"w": 238
					},
					{
						"n": 8,
						"h": 39,
						"w": 161
					},
					{
						"n": 17,
						"h": 174,
						"w": 240
					},
					{
						"n": 19,
						"h": 302,
						"w": 142
					},
					{
						"n": 11,
						"h": 210,
						"w": 151
					}
				],
				"ball": {
					"n": 0,
					"h": 276,
					"w": 480,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 967,
			"minute": 46,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 707
					},
					{
						"n": 2,
						"h": 394,
						"w": 593
					},
					{
						"n": 3,
						"h": 216,
						"w": 608
					},
					{
						"n": 4,
						"h": 144,
						"w": 596
					},
					{
						"n": 5,
						"h": 100,
						"w": 602
					},
					{
						"n": 6,
						"h": 391,
						"w": 506
					},
					{
						"n": 7,
						"h": 246,
						"w": 507
					},
					{
						"n": 8,
						"h": 207,
						"w": 538
					},
					{
						"n": 17,
						"h": 56,
						"w": 460
					},
					{
						"n": 10,
						"h": 277,
						"w": 323
					},
					{
						"n": 11,
						"h": 169,
						"w": 292
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 598
					},
					{
						"n": 13,
						"h": 405,
						"w": 295
					},
					{
						"n": 3,
						"h": 281,
						"w": 447
					},
					{
						"n": 14,
						"h": 169,
						"w": 451
					},
					{
						"n": 5,
						"h": 70,
						"w": 436
					},
					{
						"n": 6,
						"h": 215,
						"w": 347
					},
					{
						"n": 7,
						"h": 237,
						"w": 198
					},
					{
						"n": 8,
						"h": 45,
						"w": 132
					},
					{
						"n": 17,
						"h": 208,
						"w": 231
					},
					{
						"n": 19,
						"h": 322,
						"w": 131
					},
					{
						"n": 11,
						"h": 230,
						"w": 132
					}
				],
				"ball": {
					"n": 0,
					"h": 242,
					"w": 489,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 968,
			"minute": 46,
			"messages": [
				{
					"owner": 2,
					"mes": "Игра накоротке..."
				},
				{
					"owner": 2,
					"mes": "Мирослав Манолов[27](Опава) сбрасывает мяч себе на ход..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 705
					},
					{
						"n": 2,
						"h": 366,
						"w": 588
					},
					{
						"n": 3,
						"h": 220,
						"w": 608
					},
					{
						"n": 4,
						"h": 167,
						"w": 615
					},
					{
						"n": 5,
						"h": 120,
						"w": 619
					},
					{
						"n": 6,
						"h": 401,
						"w": 509
					},
					{
						"n": 7,
						"h": 238,
						"w": 531
					},
					{
						"n": 8,
						"h": 223,
						"w": 558
					},
					{
						"n": 17,
						"h": 56,
						"w": 490
					},
					{
						"n": 10,
						"h": 277,
						"w": 320
					},
					{
						"n": 11,
						"h": 142,
						"w": 283
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 595
					},
					{
						"n": 13,
						"h": 403,
						"w": 265
					},
					{
						"n": 3,
						"h": 286,
						"w": 458
					},
					{
						"n": 14,
						"h": 173,
						"w": 467
					},
					{
						"n": 5,
						"h": 65,
						"w": 431
					},
					{
						"n": 6,
						"h": 232,
						"w": 345
					},
					{
						"n": 7,
						"h": 219,
						"w": 171
					},
					{
						"n": 8,
						"h": 54,
						"w": 152
					},
					{
						"n": 17,
						"h": 208,
						"w": 231,
						"m": 610
					},
					{
						"n": 19,
						"h": 293,
						"w": 125
					},
					{
						"n": 11,
						"h": 232,
						"w": 123
					}
				],
				"ball": {
					"n": 0,
					"h": 231,
					"w": 549,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 30
		},
		{
			"num": 969,
			"minute": 47,
			"possession": 43,
			"messages": [
				{
					"owner": 2,
					"mes": "Передача вперед..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 705
					},
					{
						"n": 2,
						"h": 375,
						"w": 615,
						"f": 87
					},
					{
						"n": 3,
						"h": 254,
						"w": 599
					},
					{
						"n": 4,
						"h": 194,
						"w": 624
					},
					{
						"n": 5,
						"h": 120,
						"w": 626
					},
					{
						"n": 6,
						"h": 398,
						"w": 516
					},
					{
						"n": 7,
						"h": 260,
						"w": 549,
						"f": 87
					},
					{
						"n": 8,
						"h": 224,
						"w": 569
					},
					{
						"n": 17,
						"h": 56,
						"w": 518
					},
					{
						"n": 10,
						"h": 281,
						"w": 320,
						"f": 86
					},
					{
						"n": 11,
						"h": 130,
						"w": 301
					}
				],
				"away": [
					{
						"n": 1,
						"h": 226,
						"w": 596
					},
					{
						"n": 13,
						"h": 402,
						"w": 237
					},
					{
						"n": 3,
						"h": 280,
						"w": 443
					},
					{
						"n": 14,
						"h": 169,
						"w": 439
					},
					{
						"n": 5,
						"h": 71,
						"w": 420
					},
					{
						"n": 6,
						"h": 234,
						"w": 324
					},
					{
						"n": 7,
						"h": 227,
						"w": 168,
						"f": 88
					},
					{
						"n": 8,
						"h": 45,
						"w": 125
					},
					{
						"n": 17,
						"h": 181,
						"w": 238
					},
					{
						"n": 19,
						"h": 289,
						"w": 104
					},
					{
						"n": 11,
						"h": 196,
						"w": 121
					}
				],
				"ball": {
					"n": 0,
					"h": 254,
					"w": 599,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 28
		},
		{
			"num": 970,
			"minute": 47,
			"messages": [
				{
					"owner": 2,
					"mes": "Шимон Товарек[31](Опава) пробрасывает мяч влево..."
				},
				{
					"owner": 2,
					"mes": "Патрик Клинтон[03](Галвэй Юнайтед) отбирает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 701
					},
					{
						"n": 2,
						"h": 380,
						"w": 614
					},
					{
						"n": 3,
						"h": 254,
						"w": 594,
						"m": 660
					},
					{
						"n": 4,
						"h": 194,
						"w": 629
					},
					{
						"n": 5,
						"h": 120,
						"w": 631
					},
					{
						"n": 6,
						"h": 398,
						"w": 516
					},
					{
						"n": 7,
						"h": 261,
						"w": 554
					},
					{
						"n": 8,
						"h": 220,
						"w": 571
					},
					{
						"n": 17,
						"h": 56,
						"w": 523
					},
					{
						"n": 10,
						"h": 280,
						"w": 325
					},
					{
						"n": 11,
						"h": 133,
						"w": 304
					}
				],
				"away": [
					{
						"n": 1,
						"h": 226,
						"w": 594
					},
					{
						"n": 13,
						"h": 402,
						"w": 232
					},
					{
						"n": 3,
						"h": 280,
						"w": 438
					},
					{
						"n": 14,
						"h": 172,
						"w": 435
					},
					{
						"n": 5,
						"h": 66,
						"w": 419
					},
					{
						"n": 6,
						"h": 232,
						"w": 319
					},
					{
						"n": 7,
						"h": 227,
						"w": 163
					},
					{
						"n": 8,
						"h": 47,
						"w": 121
					},
					{
						"n": 17,
						"h": 182,
						"w": 233
					},
					{
						"n": 19,
						"h": 292,
						"w": 101
					},
					{
						"n": 11,
						"h": 196,
						"w": 116
					}
				],
				"ball": {
					"n": 0,
					"h": 254,
					"w": 594,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 5
		},
		{
			"num": 971,
			"minute": 47,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 703
					},
					{
						"n": 2,
						"h": 383,
						"w": 574
					},
					{
						"n": 3,
						"h": 279,
						"w": 569
					},
					{
						"n": 4,
						"h": 176,
						"w": 593
					},
					{
						"n": 5,
						"h": 102,
						"w": 595
					},
					{
						"n": 6,
						"h": 400,
						"w": 491
					},
					{
						"n": 7,
						"h": 260,
						"w": 514
					},
					{
						"n": 8,
						"h": 195,
						"w": 540
					},
					{
						"n": 17,
						"h": 50,
						"w": 483
					},
					{
						"n": 10,
						"h": 303,
						"w": 292
					},
					{
						"n": 11,
						"h": 153,
						"w": 314
					}
				],
				"away": [
					{
						"n": 1,
						"h": 217,
						"w": 636
					},
					{
						"n": 13,
						"h": 401,
						"w": 272
					},
					{
						"n": 3,
						"h": 280,
						"w": 467
					},
					{
						"n": 14,
						"h": 173,
						"w": 457
					},
					{
						"n": 5,
						"h": 93,
						"w": 449
					},
					{
						"n": 6,
						"h": 253,
						"w": 354
					},
					{
						"n": 7,
						"h": 226,
						"w": 203
					},
					{
						"n": 8,
						"h": 43,
						"w": 160
					},
					{
						"n": 17,
						"h": 174,
						"w": 272
					},
					{
						"n": 19,
						"h": 278,
						"w": 138
					},
					{
						"n": 11,
						"h": 190,
						"w": 130
					}
				],
				"ball": {
					"n": 0,
					"h": 279,
					"w": 569,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 972,
			"minute": 47,
			"messages": [
				{
					"owner": 1,
					"mes": "Пасом в ноги П.Клинтон[03](Галвэй Юнайтед) пытается найти К.Нолана[08](Галвэй Юнайтед)..."
				},
				{
					"owner": 1,
					"mes": "Киран Нолан[08](Галвэй Юнайтед) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 707
					},
					{
						"n": 2,
						"h": 381,
						"w": 530
					},
					{
						"n": 3,
						"h": 272,
						"w": 576
					},
					{
						"n": 4,
						"h": 176,
						"w": 566
					},
					{
						"n": 5,
						"h": 79,
						"w": 558
					},
					{
						"n": 6,
						"h": 398,
						"w": 447
					},
					{
						"n": 7,
						"h": 271,
						"w": 471
					},
					{
						"n": 8,
						"h": 152,
						"w": 530
					},
					{
						"n": 17,
						"h": 49,
						"w": 439
					},
					{
						"n": 10,
						"h": 300,
						"w": 281
					},
					{
						"n": 11,
						"h": 152,
						"w": 270
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 642
					},
					{
						"n": 13,
						"h": 408,
						"w": 316
					},
					{
						"n": 3,
						"h": 287,
						"w": 489
					},
					{
						"n": 14,
						"h": 169,
						"w": 501
					},
					{
						"n": 5,
						"h": 110,
						"w": 488
					},
					{
						"n": 6,
						"h": 273,
						"w": 393
					},
					{
						"n": 7,
						"h": 225,
						"w": 247
					},
					{
						"n": 8,
						"h": 40,
						"w": 204
					},
					{
						"n": 17,
						"h": 216,
						"w": 285
					},
					{
						"n": 19,
						"h": 290,
						"w": 180
					},
					{
						"n": 11,
						"h": 177,
						"w": 172
					}
				],
				"ball": {
					"n": 0,
					"h": 152,
					"w": 530,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 44
		},
		{
			"num": 973,
			"minute": 47,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 705
					},
					{
						"n": 2,
						"h": 382,
						"w": 490
					},
					{
						"n": 3,
						"h": 282,
						"w": 537
					},
					{
						"n": 4,
						"h": 185,
						"w": 548
					},
					{
						"n": 5,
						"h": 72,
						"w": 518
					},
					{
						"n": 6,
						"h": 401,
						"w": 408
					},
					{
						"n": 7,
						"h": 281,
						"w": 432
					},
					{
						"n": 8,
						"h": 136,
						"w": 498
					},
					{
						"n": 17,
						"h": 52,
						"w": 399
					},
					{
						"n": 10,
						"h": 306,
						"w": 257
					},
					{
						"n": 11,
						"h": 161,
						"w": 237
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 647
					},
					{
						"n": 13,
						"h": 398,
						"w": 354
					},
					{
						"n": 3,
						"h": 277,
						"w": 500
					},
					{
						"n": 14,
						"h": 174,
						"w": 515
					},
					{
						"n": 5,
						"h": 110,
						"w": 501
					},
					{
						"n": 6,
						"h": 238,
						"w": 412
					},
					{
						"n": 7,
						"h": 224,
						"w": 287
					},
					{
						"n": 8,
						"h": 38,
						"w": 244
					},
					{
						"n": 17,
						"h": 254,
						"w": 299
					},
					{
						"n": 19,
						"h": 305,
						"w": 218
					},
					{
						"n": 11,
						"h": 167,
						"w": 211
					}
				],
				"ball": {
					"n": 0,
					"h": 136,
					"w": 498,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 974,
			"minute": 47,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 704
					},
					{
						"n": 2,
						"h": 379,
						"w": 467
					},
					{
						"n": 3,
						"h": 285,
						"w": 514
					},
					{
						"n": 4,
						"h": 170,
						"w": 530
					},
					{
						"n": 5,
						"h": 63,
						"w": 479
					},
					{
						"n": 6,
						"h": 398,
						"w": 368
					},
					{
						"n": 7,
						"h": 280,
						"w": 392
					},
					{
						"n": 8,
						"h": 136,
						"w": 463
					},
					{
						"n": 17,
						"h": 53,
						"w": 359
					},
					{
						"n": 10,
						"h": 292,
						"w": 235
					},
					{
						"n": 11,
						"h": 179,
						"w": 205
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 641
					},
					{
						"n": 13,
						"h": 397,
						"w": 394
					},
					{
						"n": 3,
						"h": 256,
						"w": 520
					},
					{
						"n": 14,
						"h": 168,
						"w": 533
					},
					{
						"n": 5,
						"h": 110,
						"w": 524
					},
					{
						"n": 6,
						"h": 204,
						"w": 433
					},
					{
						"n": 7,
						"h": 225,
						"w": 327
					},
					{
						"n": 8,
						"h": 42,
						"w": 284
					},
					{
						"n": 17,
						"h": 291,
						"w": 314
					},
					{
						"n": 19,
						"h": 311,
						"w": 257
					},
					{
						"n": 11,
						"h": 156,
						"w": 249
					}
				],
				"ball": {
					"n": 0,
					"h": 136,
					"w": 463,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 975,
			"minute": 47,
			"messages": [
				{
					"owner": 1,
					"mes": "Пас М.Рауму[17](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 707
					},
					{
						"n": 2,
						"h": 390,
						"w": 455
					},
					{
						"n": 3,
						"h": 276,
						"w": 511
					},
					{
						"n": 4,
						"h": 181,
						"w": 506
					},
					{
						"n": 5,
						"h": 73,
						"w": 457
					},
					{
						"n": 6,
						"h": 400,
						"w": 318
					},
					{
						"n": 7,
						"h": 259,
						"w": 347
					},
					{
						"n": 8,
						"h": 150,
						"w": 415
					},
					{
						"n": 17,
						"h": 15,
						"w": 382
					},
					{
						"n": 10,
						"h": 276,
						"w": 197
					},
					{
						"n": 11,
						"h": 156,
						"w": 187
					}
				],
				"away": [
					{
						"n": 1,
						"h": 245,
						"w": 650
					},
					{
						"n": 13,
						"h": 406,
						"w": 354
					},
					{
						"n": 3,
						"h": 277,
						"w": 531
					},
					{
						"n": 14,
						"h": 190,
						"w": 542
					},
					{
						"n": 5,
						"h": 110,
						"w": 536
					},
					{
						"n": 6,
						"h": 251,
						"w": 448
					},
					{
						"n": 7,
						"h": 229,
						"w": 377
					},
					{
						"n": 8,
						"h": 45,
						"w": 334
					},
					{
						"n": 17,
						"h": 334,
						"w": 339
					},
					{
						"n": 19,
						"h": 303,
						"w": 307
					},
					{
						"n": 11,
						"h": 160,
						"w": 299
					}
				],
				"ball": {
					"n": 0,
					"h": 6,
					"w": 387,
					"z": 0,
					"r": 0,
					"p": 1,
					"x": 0
				}
			},
			"interval": 50
		},
		{
			"num": 976,
			"minute": 47,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 704
					},
					{
						"n": 2,
						"h": 391,
						"w": 444
					},
					{
						"n": 3,
						"h": 271,
						"w": 501
					},
					{
						"n": 4,
						"h": 175,
						"w": 497
					},
					{
						"n": 5,
						"h": 64,
						"w": 450
					},
					{
						"n": 6,
						"h": 400,
						"w": 307
					},
					{
						"n": 7,
						"h": 255,
						"w": 337
					},
					{
						"n": 8,
						"h": 150,
						"w": 415,
						"m": 630
					},
					{
						"n": 17,
						"h": 1,
						"w": 381
					},
					{
						"n": 10,
						"h": 280,
						"w": 188
					},
					{
						"n": 11,
						"h": 165,
						"w": 181
					}
				],
				"away": [
					{
						"n": 1,
						"h": 245,
						"w": 649
					},
					{
						"n": 13,
						"h": 416,
						"w": 350
					},
					{
						"n": 3,
						"h": 276,
						"w": 542
					},
					{
						"n": 14,
						"h": 189,
						"w": 552
					},
					{
						"n": 5,
						"h": 110,
						"w": 547
					},
					{
						"n": 6,
						"h": 259,
						"w": 456
					},
					{
						"n": 7,
						"h": 232,
						"w": 388
					},
					{
						"n": 8,
						"h": 45,
						"w": 345
					},
					{
						"n": 17,
						"h": 334,
						"w": 339
					},
					{
						"n": 19,
						"h": 301,
						"w": 317
					},
					{
						"n": 11,
						"h": 162,
						"w": 310
					}
				],
				"ball": {
					"n": 0,
					"h": 1,
					"w": 381,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 11
		},
		{
			"num": 977,
			"minute": 47,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 704
					},
					{
						"n": 2,
						"h": 376,
						"w": 407
					},
					{
						"n": 3,
						"h": 281,
						"w": 462
					},
					{
						"n": 4,
						"h": 170,
						"w": 474
					},
					{
						"n": 5,
						"h": 63,
						"w": 410
					},
					{
						"n": 6,
						"h": 401,
						"w": 267
					},
					{
						"n": 7,
						"h": 260,
						"w": 297
					},
					{
						"n": 8,
						"h": 165,
						"w": 378
					},
					{
						"n": 17,
						"h": 14,
						"w": 349
					},
					{
						"n": 10,
						"h": 300,
						"w": 204
					},
					{
						"n": 11,
						"h": 145,
						"w": 170
					}
				],
				"away": [
					{
						"n": 1,
						"h": 245,
						"w": 646
					},
					{
						"n": 13,
						"h": 406,
						"w": 387
					},
					{
						"n": 3,
						"h": 273,
						"w": 582
					},
					{
						"n": 14,
						"h": 190,
						"w": 592
					},
					{
						"n": 5,
						"h": 110,
						"w": 587
					},
					{
						"n": 6,
						"h": 275,
						"w": 493
					},
					{
						"n": 7,
						"h": 242,
						"w": 426
					},
					{
						"n": 8,
						"h": 46,
						"w": 385
					},
					{
						"n": 17,
						"h": 348,
						"w": 354
					},
					{
						"n": 19,
						"h": 287,
						"w": 355
					},
					{
						"n": 11,
						"h": 165,
						"w": 350
					}
				],
				"ball": {
					"n": 0,
					"h": 14,
					"w": 349,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 978,
			"minute": 47,
			"messages": [
				{
					"owner": 1,
					"mes": "Пас вперед..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 705
					},
					{
						"n": 2,
						"h": 387,
						"w": 387
					},
					{
						"n": 3,
						"h": 268,
						"w": 436
					},
					{
						"n": 4,
						"h": 166,
						"w": 450
					},
					{
						"n": 5,
						"h": 78,
						"w": 381
					},
					{
						"n": 6,
						"h": 399,
						"w": 226
					},
					{
						"n": 7,
						"h": 264,
						"w": 256
					},
					{
						"n": 8,
						"h": 162,
						"w": 337
					},
					{
						"n": 17,
						"h": 16,
						"w": 338,
						"m": 590
					},
					{
						"n": 10,
						"h": 286,
						"w": 165
					},
					{
						"n": 11,
						"h": 139,
						"w": 210
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 647
					},
					{
						"n": 13,
						"h": 406,
						"w": 418
					},
					{
						"n": 3,
						"h": 294,
						"w": 606
					},
					{
						"n": 14,
						"h": 180,
						"w": 618
					},
					{
						"n": 5,
						"h": 110,
						"w": 618
					},
					{
						"n": 6,
						"h": 315,
						"w": 484
					},
					{
						"n": 7,
						"h": 237,
						"w": 467
					},
					{
						"n": 8,
						"h": 48,
						"w": 426
					},
					{
						"n": 17,
						"h": 357,
						"w": 372
					},
					{
						"n": 19,
						"h": 287,
						"w": 396
					},
					{
						"n": 11,
						"h": 166,
						"w": 391
					}
				],
				"ball": {
					"n": 0,
					"h": 135,
					"w": 236,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 41
		},
		{
			"num": 979,
			"minute": 47,
			"messages": [
				{
					"owner": 1,
					"mes": "Оливье Дюмон[26](Опава) классно перехватывает мяч!..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 704
					},
					{
						"n": 2,
						"h": 367,
						"w": 421
					},
					{
						"n": 3,
						"h": 242,
						"w": 460
					},
					{
						"n": 4,
						"h": 181,
						"w": 447
					},
					{
						"n": 5,
						"h": 88,
						"w": 405
					},
					{
						"n": 6,
						"h": 397,
						"w": 266
					},
					{
						"n": 7,
						"h": 255,
						"w": 295
					},
					{
						"n": 8,
						"h": 171,
						"w": 371
					},
					{
						"n": 17,
						"h": 35,
						"w": 344
					},
					{
						"n": 10,
						"h": 296,
						"w": 204
					},
					{
						"n": 11,
						"h": 156,
						"w": 246
					}
				],
				"away": [
					{
						"n": 1,
						"h": 232,
						"w": 687
					},
					{
						"n": 13,
						"h": 405,
						"w": 458
					},
					{
						"n": 3,
						"h": 282,
						"w": 614
					},
					{
						"n": 14,
						"h": 168,
						"w": 616
					},
					{
						"n": 5,
						"h": 71,
						"w": 609
					},
					{
						"n": 6,
						"h": 340,
						"w": 459,
						"m": 660
					},
					{
						"n": 7,
						"h": 231,
						"w": 441
					},
					{
						"n": 8,
						"h": 52,
						"w": 386
					},
					{
						"n": 17,
						"h": 371,
						"w": 335
					},
					{
						"n": 19,
						"h": 289,
						"w": 356
					},
					{
						"n": 11,
						"h": 206,
						"w": 384
					}
				],
				"ball": {
					"n": 0,
					"h": 110,
					"w": 261,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 980,
			"minute": 47,
			"messages": [
				{
					"owner": 2,
					"mes": "Передача вперед..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 705
					},
					{
						"n": 2,
						"h": 352,
						"w": 448
					},
					{
						"n": 3,
						"h": 233,
						"w": 482
					},
					{
						"n": 4,
						"h": 186,
						"w": 470
					},
					{
						"n": 5,
						"h": 79,
						"w": 409
					},
					{
						"n": 6,
						"h": 397,
						"w": 297
					},
					{
						"n": 7,
						"h": 256,
						"w": 326
					},
					{
						"n": 8,
						"h": 155,
						"w": 344
					},
					{
						"n": 17,
						"h": 34,
						"w": 355
					},
					{
						"n": 10,
						"h": 289,
						"w": 234
					},
					{
						"n": 11,
						"h": 170,
						"w": 270
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 706
					},
					{
						"n": 13,
						"h": 420,
						"w": 440
					},
					{
						"n": 3,
						"h": 280,
						"w": 584
					},
					{
						"n": 14,
						"h": 173,
						"w": 602
					},
					{
						"n": 5,
						"h": 74,
						"w": 582
					},
					{
						"n": 6,
						"h": 330,
						"w": 461
					},
					{
						"n": 7,
						"h": 210,
						"w": 418
					},
					{
						"n": 8,
						"h": 45,
						"w": 356
					},
					{
						"n": 17,
						"h": 401,
						"w": 331
					},
					{
						"n": 19,
						"h": 296,
						"w": 376
					},
					{
						"n": 11,
						"h": 224,
						"w": 360
					}
				],
				"ball": {
					"n": 0,
					"h": 154,
					"w": 344,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 31
		},
		{
			"num": 981,
			"minute": 47,
			"messages": [
				{
					"owner": 2,
					"mes": "Александр Фрешль[39](Опава) пытается позиционно переиграть соперника..."
				},
				{
					"owner": 2,
					"mes": "Киран Нолан[08](Галвэй Юнайтед) надежно играет в отборе..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 704
					},
					{
						"n": 2,
						"h": 350,
						"w": 453
					},
					{
						"n": 3,
						"h": 237,
						"w": 483
					},
					{
						"n": 4,
						"h": 190,
						"w": 472
					},
					{
						"n": 5,
						"h": 79,
						"w": 414
					},
					{
						"n": 6,
						"h": 396,
						"w": 302
					},
					{
						"n": 7,
						"h": 256,
						"w": 331
					},
					{
						"n": 8,
						"h": 155,
						"w": 339,
						"m": 640
					},
					{
						"n": 17,
						"h": 35,
						"w": 360
					},
					{
						"n": 10,
						"h": 289,
						"w": 239
					},
					{
						"n": 11,
						"h": 165,
						"w": 270
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 707
					},
					{
						"n": 13,
						"h": 415,
						"w": 439
					},
					{
						"n": 3,
						"h": 279,
						"w": 579
					},
					{
						"n": 14,
						"h": 174,
						"w": 597
					},
					{
						"n": 5,
						"h": 74,
						"w": 577
					},
					{
						"n": 6,
						"h": 325,
						"w": 462
					},
					{
						"n": 7,
						"h": 210,
						"w": 413
					},
					{
						"n": 8,
						"h": 45,
						"w": 351
					},
					{
						"n": 17,
						"h": 402,
						"w": 326
					},
					{
						"n": 19,
						"h": 296,
						"w": 371
					},
					{
						"n": 11,
						"h": 225,
						"w": 355
					}
				],
				"ball": {
					"n": 0,
					"h": 155,
					"w": 339,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 5
		},
		{
			"num": 982,
			"minute": 47,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 702
					},
					{
						"n": 2,
						"h": 368,
						"w": 417
					},
					{
						"n": 3,
						"h": 260,
						"w": 450
					},
					{
						"n": 4,
						"h": 172,
						"w": 437
					},
					{
						"n": 5,
						"h": 59,
						"w": 383
					},
					{
						"n": 6,
						"h": 405,
						"w": 263
					},
					{
						"n": 7,
						"h": 276,
						"w": 297
					},
					{
						"n": 8,
						"h": 179,
						"w": 314
					},
					{
						"n": 17,
						"h": 44,
						"w": 320
					},
					{
						"n": 10,
						"h": 287,
						"w": 199
					},
					{
						"n": 11,
						"h": 160,
						"w": 230
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 667
					},
					{
						"n": 13,
						"h": 406,
						"w": 436
					},
					{
						"n": 3,
						"h": 276,
						"w": 589
					},
					{
						"n": 14,
						"h": 182,
						"w": 610
					},
					{
						"n": 5,
						"h": 106,
						"w": 601
					},
					{
						"n": 6,
						"h": 288,
						"w": 478
					},
					{
						"n": 7,
						"h": 220,
						"w": 452
					},
					{
						"n": 8,
						"h": 45,
						"w": 391
					},
					{
						"n": 17,
						"h": 401,
						"w": 366
					},
					{
						"n": 19,
						"h": 289,
						"w": 385
					},
					{
						"n": 11,
						"h": 231,
						"w": 394
					}
				],
				"ball": {
					"n": 0,
					"h": 179,
					"w": 314,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 983,
			"minute": 47,
			"messages": [
				{
					"owner": 1,
					"mes": "Пас налево К.Колману[06](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 708
					},
					{
						"n": 2,
						"h": 389,
						"w": 369
					},
					{
						"n": 3,
						"h": 284,
						"w": 423
					},
					{
						"n": 4,
						"h": 180,
						"w": 415
					},
					{
						"n": 5,
						"h": 64,
						"w": 383
					},
					{
						"n": 6,
						"h": 396,
						"w": 205
					},
					{
						"n": 7,
						"h": 312,
						"w": 247
					},
					{
						"n": 8,
						"h": 189,
						"w": 316
					},
					{
						"n": 17,
						"h": 54,
						"w": 260
					},
					{
						"n": 10,
						"h": 296,
						"w": 138
					},
					{
						"n": 11,
						"h": 147,
						"w": 171
					}
				],
				"away": [
					{
						"n": 1,
						"h": 205,
						"w": 641
					},
					{
						"n": 13,
						"h": 396,
						"w": 496
					},
					{
						"n": 3,
						"h": 283,
						"w": 616
					},
					{
						"n": 14,
						"h": 171,
						"w": 598
					},
					{
						"n": 5,
						"h": 83,
						"w": 545
					},
					{
						"n": 6,
						"h": 240,
						"w": 515
					},
					{
						"n": 7,
						"h": 202,
						"w": 504
					},
					{
						"n": 8,
						"h": 51,
						"w": 432
					},
					{
						"n": 17,
						"h": 413,
						"w": 405
					},
					{
						"n": 19,
						"h": 261,
						"w": 424
					},
					{
						"n": 11,
						"h": 172,
						"w": 411
					}
				],
				"ball": {
					"n": 0,
					"h": 396,
					"w": 205,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 61
		},
		{
			"num": 984,
			"minute": 47,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 708
					},
					{
						"n": 2,
						"h": 392,
						"w": 379
					},
					{
						"n": 3,
						"h": 280,
						"w": 427
					},
					{
						"n": 4,
						"h": 166,
						"w": 422
					},
					{
						"n": 5,
						"h": 65,
						"w": 367
					},
					{
						"n": 6,
						"h": 364,
						"w": 225
					},
					{
						"n": 7,
						"h": 314,
						"w": 224
					},
					{
						"n": 8,
						"h": 202,
						"w": 334
					},
					{
						"n": 17,
						"h": 51,
						"w": 223
					},
					{
						"n": 10,
						"h": 282,
						"w": 117
					},
					{
						"n": 11,
						"h": 164,
						"w": 137
					}
				],
				"away": [
					{
						"n": 1,
						"h": 205,
						"w": 653
					},
					{
						"n": 13,
						"h": 399,
						"w": 533
					},
					{
						"n": 3,
						"h": 275,
						"w": 616
					},
					{
						"n": 14,
						"h": 184,
						"w": 607
					},
					{
						"n": 5,
						"h": 94,
						"w": 515
					},
					{
						"n": 6,
						"h": 257,
						"w": 549
					},
					{
						"n": 7,
						"h": 218,
						"w": 491
					},
					{
						"n": 8,
						"h": 38,
						"w": 467
					},
					{
						"n": 17,
						"h": 418,
						"w": 422
					},
					{
						"n": 19,
						"h": 248,
						"w": 406
					},
					{
						"n": 11,
						"h": 163,
						"w": 428
					}
				],
				"ball": {
					"n": 0,
					"h": 364,
					"w": 225,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 38
		},
		{
			"num": 985,
			"minute": 47,
			"messages": [
				{
					"owner": 1,
					"mes": "Киэн Колман[06](Галвэй Юнайтед) отдает передачу в центр..."
				},
				{
					"owner": 1,
					"mes": "Агуст Хлинссон[07](Галвэй Юнайтед) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 705
					},
					{
						"n": 2,
						"h": 379,
						"w": 353
					},
					{
						"n": 3,
						"h": 266,
						"w": 403
					},
					{
						"n": 4,
						"h": 183,
						"w": 414
					},
					{
						"n": 5,
						"h": 68,
						"w": 357
					},
					{
						"n": 6,
						"h": 367,
						"w": 215
					},
					{
						"n": 7,
						"h": 313,
						"w": 199
					},
					{
						"n": 8,
						"h": 186,
						"w": 310
					},
					{
						"n": 17,
						"h": 56,
						"w": 194
					},
					{
						"n": 10,
						"h": 292,
						"w": 113
					},
					{
						"n": 11,
						"h": 171,
						"w": 109
					}
				],
				"away": [
					{
						"n": 1,
						"h": 218,
						"w": 679
					},
					{
						"n": 13,
						"h": 394,
						"w": 562
					},
					{
						"n": 3,
						"h": 265,
						"w": 629
					},
					{
						"n": 14,
						"h": 175,
						"w": 625
					},
					{
						"n": 5,
						"h": 127,
						"w": 521
					},
					{
						"n": 6,
						"h": 229,
						"w": 556
					},
					{
						"n": 7,
						"h": 232,
						"w": 517
					},
					{
						"n": 8,
						"h": 39,
						"w": 476
					},
					{
						"n": 17,
						"h": 419,
						"w": 451
					},
					{
						"n": 19,
						"h": 264,
						"w": 430
					},
					{
						"n": 11,
						"h": 160,
						"w": 410
					}
				],
				"ball": {
					"n": 0,
					"h": 313,
					"w": 199,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 29
		},
		{
			"num": 986,
			"minute": 47,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 703
					},
					{
						"n": 2,
						"h": 382,
						"w": 371
					},
					{
						"n": 3,
						"h": 275,
						"w": 428
					},
					{
						"n": 4,
						"h": 168,
						"w": 413
					},
					{
						"n": 5,
						"h": 58,
						"w": 369
					},
					{
						"n": 6,
						"h": 375,
						"w": 176
					},
					{
						"n": 7,
						"h": 274,
						"w": 208
					},
					{
						"n": 8,
						"h": 148,
						"w": 296
					},
					{
						"n": 17,
						"h": 42,
						"w": 156
					},
					{
						"n": 10,
						"h": 299,
						"w": 117
					},
					{
						"n": 11,
						"h": 156,
						"w": 107
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 702
					},
					{
						"n": 13,
						"h": 406,
						"w": 600
					},
					{
						"n": 3,
						"h": 275,
						"w": 641
					},
					{
						"n": 14,
						"h": 164,
						"w": 619
					},
					{
						"n": 5,
						"h": 95,
						"w": 541
					},
					{
						"n": 6,
						"h": 220,
						"w": 557
					},
					{
						"n": 7,
						"h": 190,
						"w": 528
					},
					{
						"n": 8,
						"h": 26,
						"w": 514
					},
					{
						"n": 17,
						"h": 416,
						"w": 482
					},
					{
						"n": 19,
						"h": 302,
						"w": 444
					},
					{
						"n": 11,
						"h": 159,
						"w": 421
					}
				],
				"ball": {
					"n": 0,
					"h": 274,
					"w": 208,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 987,
			"minute": 47,
			"messages": [
				{
					"owner": 1,
					"mes": "Агуст Хлинссон[07](Галвэй Юнайтед) смотрит направо... Пас К.Нолану[08](Галвэй Юнайтед)..."
				},
				{
					"owner": 1,
					"mes": "Киран Нолан[08](Галвэй Юнайтед) технично принимает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 710
					},
					{
						"n": 2,
						"h": 374,
						"w": 357
					},
					{
						"n": 3,
						"h": 278,
						"w": 396
					},
					{
						"n": 4,
						"h": 174,
						"w": 400
					},
					{
						"n": 5,
						"h": 60,
						"w": 350
					},
					{
						"n": 6,
						"h": 396,
						"w": 129
					},
					{
						"n": 7,
						"h": 272,
						"w": 218
					},
					{
						"n": 8,
						"h": 194,
						"w": 318
					},
					{
						"n": 17,
						"h": 59,
						"w": 130
					},
					{
						"n": 10,
						"h": 288,
						"w": 100
					},
					{
						"n": 11,
						"h": 164,
						"w": 90
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 706
					},
					{
						"n": 13,
						"h": 391,
						"w": 626
					},
					{
						"n": 3,
						"h": 269,
						"w": 647
					},
					{
						"n": 14,
						"h": 173,
						"w": 635
					},
					{
						"n": 5,
						"h": 84,
						"w": 591
					},
					{
						"n": 6,
						"h": 222,
						"w": 585
					},
					{
						"n": 7,
						"h": 177,
						"w": 531
					},
					{
						"n": 8,
						"h": 18,
						"w": 544
					},
					{
						"n": 17,
						"h": 398,
						"w": 499
					},
					{
						"n": 19,
						"h": 256,
						"w": 422
					},
					{
						"n": 11,
						"h": 165,
						"w": 413
					}
				],
				"ball": {
					"n": 0,
					"h": 194,
					"w": 318,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 51
		},
		{
			"num": 988,
			"minute": 47,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 708
					},
					{
						"n": 2,
						"h": 391,
						"w": 360
					},
					{
						"n": 3,
						"h": 277,
						"w": 397
					},
					{
						"n": 4,
						"h": 165,
						"w": 390
					},
					{
						"n": 5,
						"h": 62,
						"w": 348
					},
					{
						"n": 6,
						"h": 396,
						"w": 89
					},
					{
						"n": 7,
						"h": 272,
						"w": 178
					},
					{
						"n": 8,
						"h": 227,
						"w": 307
					},
					{
						"n": 17,
						"h": 59,
						"w": 90
					},
					{
						"n": 10,
						"h": 257,
						"w": 68
					},
					{
						"n": 11,
						"h": 171,
						"w": 51
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 708
					},
					{
						"n": 13,
						"h": 376,
						"w": 663
					},
					{
						"n": 3,
						"h": 260,
						"w": 686
					},
					{
						"n": 14,
						"h": 199,
						"w": 665
					},
					{
						"n": 5,
						"h": 81,
						"w": 631
					},
					{
						"n": 6,
						"h": 216,
						"w": 620
					},
					{
						"n": 7,
						"h": 168,
						"w": 559
					},
					{
						"n": 8,
						"h": 28,
						"w": 562
					},
					{
						"n": 17,
						"h": 398,
						"w": 530
					},
					{
						"n": 19,
						"h": 223,
						"w": 433
					},
					{
						"n": 11,
						"h": 156,
						"w": 416
					}
				],
				"ball": {
					"n": 0,
					"h": 227,
					"w": 307,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 989,
			"minute": 47,
			"messages": [
				{
					"owner": 1,
					"mes": "Передача вперед..."
				},
				{
					"owner": 1,
					"mes": "Агуст Хлинссон[07](Галвэй Юнайтед) получает передачу..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 702
					},
					{
						"n": 2,
						"h": 381,
						"w": 349
					},
					{
						"n": 3,
						"h": 283,
						"w": 402
					},
					{
						"n": 4,
						"h": 181,
						"w": 390
					},
					{
						"n": 5,
						"h": 61,
						"w": 358
					},
					{
						"n": 6,
						"h": 386,
						"w": 65
					},
					{
						"n": 7,
						"h": 312,
						"w": 217
					},
					{
						"n": 8,
						"h": 222,
						"w": 296
					},
					{
						"n": 17,
						"h": 51,
						"w": 85
					},
					{
						"n": 10,
						"h": 285,
						"w": 87
					},
					{
						"n": 11,
						"h": 156,
						"w": 88
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 702
					},
					{
						"n": 13,
						"h": 383,
						"w": 659
					},
					{
						"n": 3,
						"h": 274,
						"w": 663
					},
					{
						"n": 14,
						"h": 178,
						"w": 659
					},
					{
						"n": 5,
						"h": 79,
						"w": 669
					},
					{
						"n": 6,
						"h": 175,
						"w": 624
					},
					{
						"n": 7,
						"h": 148,
						"w": 523
					},
					{
						"n": 8,
						"h": 28,
						"w": 574
					},
					{
						"n": 17,
						"h": 394,
						"w": 524
					},
					{
						"n": 19,
						"h": 228,
						"w": 444
					},
					{
						"n": 11,
						"h": 174,
						"w": 430
					}
				],
				"ball": {
					"n": 0,
					"h": 312,
					"w": 217,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 41
		},
		{
			"num": 990,
			"minute": 48,
			"possession": 44,
			"messages": [
				{
					"owner": 1,
					"mes": "Передача в штрафную..."
				},
				{
					"owner": 1,
					"mes": "Адам Гилберт[11](Галвэй Юнайтед) принимает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 702
					},
					{
						"n": 2,
						"h": 374,
						"w": 359
					},
					{
						"n": 3,
						"h": 269,
						"w": 396
					},
					{
						"n": 4,
						"h": 175,
						"w": 390
					},
					{
						"n": 5,
						"h": 58,
						"w": 349,
						"f": 87
					},
					{
						"n": 6,
						"h": 396,
						"w": 86
					},
					{
						"n": 7,
						"h": 311,
						"w": 207
					},
					{
						"n": 8,
						"h": 200,
						"w": 250,
						"f": 85
					},
					{
						"n": 17,
						"h": 41,
						"w": 95,
						"f": 99
					},
					{
						"n": 10,
						"h": 283,
						"w": 83
					},
					{
						"n": 11,
						"h": 201,
						"w": 111,
						"f": 86
					}
				],
				"away": [
					{
						"n": 1,
						"h": 228,
						"w": 705
					},
					{
						"n": 13,
						"h": 393,
						"w": 642,
						"f": 97
					},
					{
						"n": 3,
						"h": 253,
						"w": 663
					},
					{
						"n": 14,
						"h": 183,
						"w": 663,
						"f": 96
					},
					{
						"n": 5,
						"h": 69,
						"w": 652,
						"f": 86
					},
					{
						"n": 6,
						"h": 226,
						"w": 626
					},
					{
						"n": 7,
						"h": 135,
						"w": 572
					},
					{
						"n": 8,
						"h": 18,
						"w": 557,
						"f": 86
					},
					{
						"n": 17,
						"h": 421,
						"w": 507,
						"f": 96
					},
					{
						"n": 19,
						"h": 250,
						"w": 490,
						"f": 98
					},
					{
						"n": 11,
						"h": 165,
						"w": 423
					}
				],
				"ball": {
					"n": 0,
					"h": 201,
					"w": 111,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 51
		},
		{
			"num": 991,
			"minute": 48,
			"messages": [
				{
					"owner": 1,
					"mes": "Адам Гилберт[11](Галвэй Юнайтед) в опасной близости от ворот..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 708
					},
					{
						"n": 2,
						"h": 391,
						"w": 342
					},
					{
						"n": 3,
						"h": 279,
						"w": 402
					},
					{
						"n": 4,
						"h": 179,
						"w": 393
					},
					{
						"n": 5,
						"h": 66,
						"w": 352
					},
					{
						"n": 6,
						"h": 406,
						"w": 76
					},
					{
						"n": 7,
						"h": 304,
						"w": 174
					},
					{
						"n": 8,
						"h": 170,
						"w": 266
					},
					{
						"n": 17,
						"h": 55,
						"w": 87
					},
					{
						"n": 10,
						"h": 283,
						"w": 57
					},
					{
						"n": 11,
						"h": 221,
						"w": 76
					}
				],
				"away": [
					{
						"n": 1,
						"h": 226,
						"w": 705
					},
					{
						"n": 13,
						"h": 379,
						"w": 667
					},
					{
						"n": 3,
						"h": 235,
						"w": 654
					},
					{
						"n": 14,
						"h": 183,
						"w": 686
					},
					{
						"n": 5,
						"h": 50,
						"w": 649
					},
					{
						"n": 6,
						"h": 223,
						"w": 667
					},
					{
						"n": 7,
						"h": 146,
						"w": 604
					},
					{
						"n": 8,
						"h": 23,
						"w": 571
					},
					{
						"n": 17,
						"h": 407,
						"w": 532
					},
					{
						"n": 19,
						"h": 280,
						"w": 474
					},
					{
						"n": 11,
						"h": 170,
						"w": 415
					}
				],
				"ball": {
					"n": 0,
					"h": 221,
					"w": 76,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 34
		},
		{
			"num": 992,
			"minute": 48,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 706
					},
					{
						"n": 2,
						"h": 376,
						"w": 345
					},
					{
						"n": 3,
						"h": 265,
						"w": 403
					},
					{
						"n": 4,
						"h": 168,
						"w": 406
					},
					{
						"n": 5,
						"h": 66,
						"w": 356
					},
					{
						"n": 6,
						"h": 399,
						"w": 80
					},
					{
						"n": 7,
						"h": 293,
						"w": 157
					},
					{
						"n": 8,
						"h": 152,
						"w": 273
					},
					{
						"n": 17,
						"h": 45,
						"w": 76
					},
					{
						"n": 10,
						"h": 285,
						"w": 50
					},
					{
						"n": 11,
						"h": 231,
						"w": 77
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 705
					},
					{
						"n": 13,
						"h": 389,
						"w": 665
					},
					{
						"n": 3,
						"h": 225,
						"w": 653
					},
					{
						"n": 14,
						"h": 167,
						"w": 689
					},
					{
						"n": 5,
						"h": 57,
						"w": 652
					},
					{
						"n": 6,
						"h": 220,
						"w": 653
					},
					{
						"n": 7,
						"h": 166,
						"w": 604
					},
					{
						"n": 8,
						"h": 23,
						"w": 571
					},
					{
						"n": 17,
						"h": 418,
						"w": 530
					},
					{
						"n": 19,
						"h": 298,
						"w": 467
					},
					{
						"n": 11,
						"h": 155,
						"w": 425
					}
				],
				"ball": {
					"n": 0,
					"h": 231,
					"w": 77,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 20
		},
		{
			"num": 993,
			"minute": 48,
			"messages": [
				{
					"owner": 1,
					"mes": "Адам Гилберт[11](Галвэй Юнайтед) закрывает мяч от соперника..."
				},
				{
					"owner": 1,
					"mes": "Оливье Дюмон[26](Опава) отбирает мяч у А.Гилберта[11](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 706
					},
					{
						"n": 2,
						"h": 376,
						"w": 345
					},
					{
						"n": 3,
						"h": 265,
						"w": 403
					},
					{
						"n": 4,
						"h": 168,
						"w": 406
					},
					{
						"n": 5,
						"h": 66,
						"w": 356
					},
					{
						"n": 6,
						"h": 399,
						"w": 80
					},
					{
						"n": 7,
						"h": 286,
						"w": 144
					},
					{
						"n": 8,
						"h": 152,
						"w": 273
					},
					{
						"n": 17,
						"h": 45,
						"w": 76
					},
					{
						"n": 10,
						"h": 285,
						"w": 50
					},
					{
						"n": 11,
						"h": 220,
						"w": 67,
						"m": 820
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 705
					},
					{
						"n": 13,
						"h": 389,
						"w": 665
					},
					{
						"n": 3,
						"h": 225,
						"w": 653
					},
					{
						"n": 14,
						"h": 167,
						"w": 689
					},
					{
						"n": 5,
						"h": 57,
						"w": 652
					},
					{
						"n": 6,
						"h": 220,
						"w": 653,
						"m": 670
					},
					{
						"n": 7,
						"h": 181,
						"w": 605
					},
					{
						"n": 8,
						"h": 21,
						"w": 580
					},
					{
						"n": 17,
						"h": 418,
						"w": 530
					},
					{
						"n": 19,
						"h": 298,
						"w": 467
					},
					{
						"n": 11,
						"h": 155,
						"w": 425
					}
				],
				"ball": {
					"n": 0,
					"h": 230,
					"w": 67,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 15
		},
		{
			"num": 994,
			"minute": 48,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 710
					},
					{
						"n": 2,
						"h": 365,
						"w": 384
					},
					{
						"n": 3,
						"h": 300,
						"w": 414
					},
					{
						"n": 4,
						"h": 196,
						"w": 418
					},
					{
						"n": 5,
						"h": 78,
						"w": 394
					},
					{
						"n": 6,
						"h": 402,
						"w": 120
					},
					{
						"n": 7,
						"h": 295,
						"w": 183
					},
					{
						"n": 8,
						"h": 147,
						"w": 313
					},
					{
						"n": 17,
						"h": 47,
						"w": 116
					},
					{
						"n": 10,
						"h": 283,
						"w": 90
					},
					{
						"n": 11,
						"h": 215,
						"w": 82
					}
				],
				"away": [
					{
						"n": 1,
						"h": 228,
						"w": 702
					},
					{
						"n": 13,
						"h": 392,
						"w": 625
					},
					{
						"n": 3,
						"h": 245,
						"w": 652
					},
					{
						"n": 14,
						"h": 175,
						"w": 640
					},
					{
						"n": 5,
						"h": 66,
						"w": 619
					},
					{
						"n": 6,
						"h": 244,
						"w": 628
					},
					{
						"n": 7,
						"h": 189,
						"w": 565
					},
					{
						"n": 8,
						"h": 27,
						"w": 540
					},
					{
						"n": 17,
						"h": 412,
						"w": 491
					},
					{
						"n": 19,
						"h": 302,
						"w": 427
					},
					{
						"n": 11,
						"h": 115,
						"w": 427
					}
				],
				"ball": {
					"n": 0,
					"h": 206,
					"w": 92,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 995,
			"minute": 48,
			"messages": [
				{
					"owner": 2,
					"mes": "Пас вперед М.Манолову[27](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 707
					},
					{
						"n": 2,
						"h": 363,
						"w": 416
					},
					{
						"n": 3,
						"h": 319,
						"w": 441
					},
					{
						"n": 4,
						"h": 184,
						"w": 436
					},
					{
						"n": 5,
						"h": 99,
						"w": 419
					},
					{
						"n": 6,
						"h": 404,
						"w": 153
					},
					{
						"n": 7,
						"h": 263,
						"w": 172
					},
					{
						"n": 8,
						"h": 154,
						"w": 345
					},
					{
						"n": 17,
						"h": 46,
						"w": 149
					},
					{
						"n": 10,
						"h": 281,
						"w": 123
					},
					{
						"n": 11,
						"h": 213,
						"w": 114
					}
				],
				"away": [
					{
						"n": 1,
						"h": 226,
						"w": 709
					},
					{
						"n": 13,
						"h": 396,
						"w": 592
					},
					{
						"n": 3,
						"h": 257,
						"w": 649
					},
					{
						"n": 14,
						"h": 177,
						"w": 627
					},
					{
						"n": 5,
						"h": 56,
						"w": 617
					},
					{
						"n": 6,
						"h": 247,
						"w": 619,
						"m": 680
					},
					{
						"n": 7,
						"h": 203,
						"w": 577
					},
					{
						"n": 8,
						"h": 37,
						"w": 509
					},
					{
						"n": 17,
						"h": 413,
						"w": 458
					},
					{
						"n": 19,
						"h": 300,
						"w": 394
					},
					{
						"n": 11,
						"h": 93,
						"w": 403
					}
				],
				"ball": {
					"n": 0,
					"h": 247,
					"w": 143,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 33
		},
		{
			"num": 996,
			"minute": 48,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 706
					},
					{
						"n": 2,
						"h": 339,
						"w": 449
					},
					{
						"n": 3,
						"h": 280,
						"w": 447
					},
					{
						"n": 4,
						"h": 148,
						"w": 452
					},
					{
						"n": 5,
						"h": 104,
						"w": 459
					},
					{
						"n": 6,
						"h": 399,
						"w": 193
					},
					{
						"n": 7,
						"h": 229,
						"w": 168
					},
					{
						"n": 8,
						"h": 148,
						"w": 385
					},
					{
						"n": 17,
						"h": 48,
						"w": 189
					},
					{
						"n": 10,
						"h": 290,
						"w": 162
					},
					{
						"n": 11,
						"h": 196,
						"w": 151
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 709
					},
					{
						"n": 13,
						"h": 397,
						"w": 552
					},
					{
						"n": 3,
						"h": 290,
						"w": 612
					},
					{
						"n": 14,
						"h": 177,
						"w": 607
					},
					{
						"n": 5,
						"h": 72,
						"w": 582
					},
					{
						"n": 6,
						"h": 255,
						"w": 579
					},
					{
						"n": 7,
						"h": 221,
						"w": 547
					},
					{
						"n": 8,
						"h": 40,
						"w": 469
					},
					{
						"n": 17,
						"h": 402,
						"w": 419
					},
					{
						"n": 19,
						"h": 303,
						"w": 354
					},
					{
						"n": 11,
						"h": 75,
						"w": 367
					}
				],
				"ball": {
					"n": 0,
					"h": 229,
					"w": 173,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 997,
			"minute": 48,
			"messages": [
				{
					"owner": 2,
					"mes": "Мирослав Манолов[27](Опава) делает передачу налево на М.Томасова[37](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 701
					},
					{
						"n": 2,
						"h": 330,
						"w": 460
					},
					{
						"n": 3,
						"h": 233,
						"w": 452
					},
					{
						"n": 4,
						"h": 158,
						"w": 470
					},
					{
						"n": 5,
						"h": 120,
						"w": 459
					},
					{
						"n": 6,
						"h": 406,
						"w": 239
					},
					{
						"n": 7,
						"h": 232,
						"w": 215
					},
					{
						"n": 8,
						"h": 163,
						"w": 402
					},
					{
						"n": 17,
						"h": 45,
						"w": 236
					},
					{
						"n": 10,
						"h": 290,
						"w": 209
					},
					{
						"n": 11,
						"h": 177,
						"w": 194
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 707
					},
					{
						"n": 13,
						"h": 407,
						"w": 507
					},
					{
						"n": 3,
						"h": 277,
						"w": 611
					},
					{
						"n": 14,
						"h": 161,
						"w": 609
					},
					{
						"n": 5,
						"h": 57,
						"w": 596
					},
					{
						"n": 6,
						"h": 272,
						"w": 536
					},
					{
						"n": 7,
						"h": 224,
						"w": 537
					},
					{
						"n": 8,
						"h": 36,
						"w": 445
					},
					{
						"n": 17,
						"h": 377,
						"w": 442
					},
					{
						"n": 19,
						"h": 294,
						"w": 308
					},
					{
						"n": 11,
						"h": 59,
						"w": 323
					}
				],
				"ball": {
					"n": 0,
					"h": 73,
					"w": 278,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 47
		},
		{
			"num": 998,
			"minute": 48,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 710
					},
					{
						"n": 2,
						"h": 330,
						"w": 478
					},
					{
						"n": 3,
						"h": 231,
						"w": 475
					},
					{
						"n": 4,
						"h": 151,
						"w": 471
					},
					{
						"n": 5,
						"h": 120,
						"w": 468
					},
					{
						"n": 6,
						"h": 412,
						"w": 279
					},
					{
						"n": 7,
						"h": 233,
						"w": 255
					},
					{
						"n": 8,
						"h": 122,
						"w": 371
					},
					{
						"n": 17,
						"h": 44,
						"w": 285
					},
					{
						"n": 10,
						"h": 282,
						"w": 248
					},
					{
						"n": 11,
						"h": 175,
						"w": 234
					}
				],
				"away": [
					{
						"n": 1,
						"h": 223,
						"w": 704
					},
					{
						"n": 13,
						"h": 408,
						"w": 467
					},
					{
						"n": 3,
						"h": 276,
						"w": 588
					},
					{
						"n": 14,
						"h": 174,
						"w": 602
					},
					{
						"n": 5,
						"h": 67,
						"w": 588
					},
					{
						"n": 6,
						"h": 265,
						"w": 496
					},
					{
						"n": 7,
						"h": 231,
						"w": 498
					},
					{
						"n": 8,
						"h": 36,
						"w": 405
					},
					{
						"n": 17,
						"h": 377,
						"w": 403
					},
					{
						"n": 19,
						"h": 297,
						"w": 288
					},
					{
						"n": 11,
						"h": 44,
						"w": 285
					}
				],
				"ball": {
					"n": 0,
					"h": 73,
					"w": 317,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 999,
			"minute": 48,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 704
					},
					{
						"n": 2,
						"h": 330,
						"w": 489
					},
					{
						"n": 3,
						"h": 226,
						"w": 488
					},
					{
						"n": 4,
						"h": 155,
						"w": 495
					},
					{
						"n": 5,
						"h": 91,
						"w": 467
					},
					{
						"n": 6,
						"h": 407,
						"w": 318
					},
					{
						"n": 7,
						"h": 235,
						"w": 295
					},
					{
						"n": 8,
						"h": 72,
						"w": 378
					},
					{
						"n": 17,
						"h": 60,
						"w": 333
					},
					{
						"n": 10,
						"h": 283,
						"w": 288
					},
					{
						"n": 11,
						"h": 151,
						"w": 265
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 702
					},
					{
						"n": 13,
						"h": 411,
						"w": 457
					},
					{
						"n": 3,
						"h": 276,
						"w": 590
					},
					{
						"n": 14,
						"h": 167,
						"w": 588
					},
					{
						"n": 5,
						"h": 57,
						"w": 584
					},
					{
						"n": 6,
						"h": 262,
						"w": 456
					},
					{
						"n": 7,
						"h": 233,
						"w": 458
					},
					{
						"n": 8,
						"h": 49,
						"w": 427
					},
					{
						"n": 17,
						"h": 377,
						"w": 364
					},
					{
						"n": 19,
						"h": 291,
						"w": 279
					},
					{
						"n": 11,
						"h": 59,
						"w": 252
					}
				],
				"ball": {
					"n": 0,
					"h": 73,
					"w": 356,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1000,
			"minute": 48,
			"messages": [
				{
					"owner": 2,
					"mes": "М.Томасов[37](Опава) пасует Н.Мансуру[23](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 705
					},
					{
						"n": 2,
						"h": 330,
						"w": 477
					},
					{
						"n": 3,
						"h": 235,
						"w": 463
					},
					{
						"n": 4,
						"h": 149,
						"w": 458
					},
					{
						"n": 5,
						"h": 114,
						"w": 476
					},
					{
						"n": 6,
						"h": 397,
						"w": 367
					},
					{
						"n": 7,
						"h": 254,
						"w": 345
					},
					{
						"n": 8,
						"h": 124,
						"w": 387
					},
					{
						"n": 17,
						"h": 72,
						"w": 384
					},
					{
						"n": 10,
						"h": 320,
						"w": 277
					},
					{
						"n": 11,
						"h": 145,
						"w": 270
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 687
					},
					{
						"n": 13,
						"h": 390,
						"w": 438
					},
					{
						"n": 3,
						"h": 296,
						"w": 560
					},
					{
						"n": 14,
						"h": 167,
						"w": 576
					},
					{
						"n": 5,
						"h": 76,
						"w": 541
					},
					{
						"n": 6,
						"h": 239,
						"w": 408
					},
					{
						"n": 7,
						"h": 270,
						"w": 448
					},
					{
						"n": 8,
						"h": 55,
						"w": 374
					},
					{
						"n": 17,
						"h": 374,
						"w": 355
					},
					{
						"n": 19,
						"h": 306,
						"w": 283
					},
					{
						"n": 11,
						"h": 36,
						"w": 270
					}
				],
				"ball": {
					"n": 0,
					"h": 154,
					"w": 160,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 53
		},
		{
			"num": 1001,
			"minute": 48,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 704
					},
					{
						"n": 2,
						"h": 330,
						"w": 451
					},
					{
						"n": 3,
						"h": 209,
						"w": 461
					},
					{
						"n": 4,
						"h": 163,
						"w": 450
					},
					{
						"n": 5,
						"h": 120,
						"w": 468
					},
					{
						"n": 6,
						"h": 395,
						"w": 407
					},
					{
						"n": 7,
						"h": 259,
						"w": 384
					},
					{
						"n": 8,
						"h": 157,
						"w": 391
					},
					{
						"n": 17,
						"h": 72,
						"w": 424
					},
					{
						"n": 10,
						"h": 305,
						"w": 270
					},
					{
						"n": 11,
						"h": 137,
						"w": 270
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 709
					},
					{
						"n": 13,
						"h": 414,
						"w": 470
					},
					{
						"n": 3,
						"h": 282,
						"w": 528
					},
					{
						"n": 14,
						"h": 180,
						"w": 603
					},
					{
						"n": 5,
						"h": 67,
						"w": 580
					},
					{
						"n": 6,
						"h": 239,
						"w": 368
					},
					{
						"n": 7,
						"h": 233,
						"w": 433
					},
					{
						"n": 8,
						"h": 45,
						"w": 336
					},
					{
						"n": 17,
						"h": 378,
						"w": 315
					},
					{
						"n": 19,
						"h": 297,
						"w": 290
					},
					{
						"n": 11,
						"h": 32,
						"w": 300
					}
				],
				"ball": {
					"n": 0,
					"h": 168,
					"w": 192,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1002,
			"minute": 48,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 705
					},
					{
						"n": 2,
						"h": 330,
						"w": 475
					},
					{
						"n": 3,
						"h": 191,
						"w": 478
					},
					{
						"n": 4,
						"h": 154,
						"w": 473
					},
					{
						"n": 5,
						"h": 120,
						"w": 469
					},
					{
						"n": 6,
						"h": 417,
						"w": 373
					},
					{
						"n": 7,
						"h": 274,
						"w": 401
					},
					{
						"n": 8,
						"h": 197,
						"w": 397
					},
					{
						"n": 17,
						"h": 57,
						"w": 387
					},
					{
						"n": 10,
						"h": 319,
						"w": 278
					},
					{
						"n": 11,
						"h": 129,
						"w": 270
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 704
					},
					{
						"n": 13,
						"h": 416,
						"w": 444
					},
					{
						"n": 3,
						"h": 282,
						"w": 493
					},
					{
						"n": 14,
						"h": 180,
						"w": 584
					},
					{
						"n": 5,
						"h": 64,
						"w": 603
					},
					{
						"n": 6,
						"h": 238,
						"w": 349
					},
					{
						"n": 7,
						"h": 204,
						"w": 434
					},
					{
						"n": 8,
						"h": 45,
						"w": 334
					},
					{
						"n": 17,
						"h": 347,
						"w": 289
					},
					{
						"n": 19,
						"h": 279,
						"w": 280
					},
					{
						"n": 11,
						"h": 60,
						"w": 284
					}
				],
				"ball": {
					"n": 0,
					"h": 168,
					"w": 227,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1003,
			"minute": 48,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 710
					},
					{
						"n": 2,
						"h": 366,
						"w": 490
					},
					{
						"n": 3,
						"h": 187,
						"w": 517
					},
					{
						"n": 4,
						"h": 151,
						"w": 512
					},
					{
						"n": 5,
						"h": 118,
						"w": 508
					},
					{
						"n": 6,
						"h": 407,
						"w": 411
					},
					{
						"n": 7,
						"h": 273,
						"w": 440
					},
					{
						"n": 8,
						"h": 194,
						"w": 436
					},
					{
						"n": 17,
						"h": 57,
						"w": 406
					},
					{
						"n": 10,
						"h": 319,
						"w": 317
					},
					{
						"n": 11,
						"h": 167,
						"w": 280
					}
				],
				"away": [
					{
						"n": 1,
						"h": 228,
						"w": 706
					},
					{
						"n": 13,
						"h": 418,
						"w": 405
					},
					{
						"n": 3,
						"h": 277,
						"w": 459
					},
					{
						"n": 14,
						"h": 167,
						"w": 548
					},
					{
						"n": 5,
						"h": 60,
						"w": 564
					},
					{
						"n": 6,
						"h": 236,
						"w": 388
					},
					{
						"n": 7,
						"h": 210,
						"w": 396
					},
					{
						"n": 8,
						"h": 48,
						"w": 295
					},
					{
						"n": 17,
						"h": 313,
						"w": 270
					},
					{
						"n": 19,
						"h": 288,
						"w": 242
					},
					{
						"n": 11,
						"h": 48,
						"w": 247
					}
				],
				"ball": {
					"n": 0,
					"h": 173,
					"w": 261,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 1004,
			"minute": 48,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 707
					},
					{
						"n": 2,
						"h": 383,
						"w": 526
					},
					{
						"n": 3,
						"h": 204,
						"w": 553
					},
					{
						"n": 4,
						"h": 154,
						"w": 552
					},
					{
						"n": 5,
						"h": 119,
						"w": 548
					},
					{
						"n": 6,
						"h": 401,
						"w": 451
					},
					{
						"n": 7,
						"h": 272,
						"w": 480
					},
					{
						"n": 8,
						"h": 181,
						"w": 474
					},
					{
						"n": 17,
						"h": 56,
						"w": 370
					},
					{
						"n": 10,
						"h": 304,
						"w": 320
					},
					{
						"n": 11,
						"h": 202,
						"w": 298
					}
				],
				"away": [
					{
						"n": 1,
						"h": 226,
						"w": 690
					},
					{
						"n": 13,
						"h": 419,
						"w": 365
					},
					{
						"n": 3,
						"h": 247,
						"w": 441
					},
					{
						"n": 14,
						"h": 172,
						"w": 508
					},
					{
						"n": 5,
						"h": 62,
						"w": 524
					},
					{
						"n": 6,
						"h": 213,
						"w": 387
					},
					{
						"n": 7,
						"h": 215,
						"w": 356
					},
					{
						"n": 8,
						"h": 43,
						"w": 255
					},
					{
						"n": 17,
						"h": 279,
						"w": 249
					},
					{
						"n": 19,
						"h": 295,
						"w": 203
					},
					{
						"n": 11,
						"h": 35,
						"w": 209
					}
				],
				"ball": {
					"n": 0,
					"h": 203,
					"w": 279,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1005,
			"minute": 48,
			"messages": [
				{
					"owner": 2,
					"mes": "Нир Мансур[23](Опава) делает передачу направо на Т.Прохазку[25](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 705
					},
					{
						"n": 2,
						"h": 349,
						"w": 501
					},
					{
						"n": 3,
						"h": 232,
						"w": 520
					},
					{
						"n": 4,
						"h": 183,
						"w": 520
					},
					{
						"n": 5,
						"h": 146,
						"w": 515
					},
					{
						"n": 6,
						"h": 387,
						"w": 476
					},
					{
						"n": 7,
						"h": 279,
						"w": 438
					},
					{
						"n": 8,
						"h": 202,
						"w": 436
					},
					{
						"n": 17,
						"h": 58,
						"w": 391
					},
					{
						"n": 10,
						"h": 277,
						"w": 320
					},
					{
						"n": 11,
						"h": 163,
						"w": 280
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 705
					},
					{
						"n": 13,
						"h": 418,
						"w": 408
					},
					{
						"n": 3,
						"h": 248,
						"w": 451
					},
					{
						"n": 14,
						"h": 173,
						"w": 551
					},
					{
						"n": 5,
						"h": 88,
						"w": 510
					},
					{
						"n": 6,
						"h": 210,
						"w": 430
					},
					{
						"n": 7,
						"h": 198,
						"w": 396
					},
					{
						"n": 8,
						"h": 47,
						"w": 298
					},
					{
						"n": 17,
						"h": 241,
						"w": 270
					},
					{
						"n": 19,
						"h": 299,
						"w": 246
					},
					{
						"n": 11,
						"h": 48,
						"w": 250
					}
				],
				"ball": {
					"n": 0,
					"h": 362,
					"w": 210,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 43
		},
		{
			"num": 1006,
			"minute": 48,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 707
					},
					{
						"n": 2,
						"h": 374,
						"w": 522
					},
					{
						"n": 3,
						"h": 247,
						"w": 551
					},
					{
						"n": 4,
						"h": 173,
						"w": 546
					},
					{
						"n": 5,
						"h": 120,
						"w": 543
					},
					{
						"n": 6,
						"h": 406,
						"w": 442
					},
					{
						"n": 7,
						"h": 252,
						"w": 454
					},
					{
						"n": 8,
						"h": 213,
						"w": 468
					},
					{
						"n": 17,
						"h": 56,
						"w": 367
					},
					{
						"n": 10,
						"h": 279,
						"w": 320
					},
					{
						"n": 11,
						"h": 185,
						"w": 270
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 681
					},
					{
						"n": 13,
						"h": 417,
						"w": 368
					},
					{
						"n": 3,
						"h": 265,
						"w": 488
					},
					{
						"n": 14,
						"h": 171,
						"w": 509
					},
					{
						"n": 5,
						"h": 81,
						"w": 475
					},
					{
						"n": 6,
						"h": 199,
						"w": 430
					},
					{
						"n": 7,
						"h": 210,
						"w": 357
					},
					{
						"n": 8,
						"h": 40,
						"w": 259
					},
					{
						"n": 17,
						"h": 201,
						"w": 267
					},
					{
						"n": 19,
						"h": 291,
						"w": 206
					},
					{
						"n": 11,
						"h": 46,
						"w": 218
					}
				],
				"ball": {
					"n": 0,
					"h": 369,
					"w": 245,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1007,
			"minute": 48,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 708
					},
					{
						"n": 2,
						"h": 394,
						"w": 542
					},
					{
						"n": 3,
						"h": 253,
						"w": 589
					},
					{
						"n": 4,
						"h": 177,
						"w": 585
					},
					{
						"n": 5,
						"h": 120,
						"w": 582
					},
					{
						"n": 6,
						"h": 407,
						"w": 461
					},
					{
						"n": 7,
						"h": 258,
						"w": 493
					},
					{
						"n": 8,
						"h": 218,
						"w": 507
					},
					{
						"n": 17,
						"h": 56,
						"w": 406
					},
					{
						"n": 10,
						"h": 318,
						"w": 320
					},
					{
						"n": 11,
						"h": 148,
						"w": 283
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 658
					},
					{
						"n": 13,
						"h": 420,
						"w": 329
					},
					{
						"n": 3,
						"h": 266,
						"w": 469
					},
					{
						"n": 14,
						"h": 168,
						"w": 460
					},
					{
						"n": 5,
						"h": 86,
						"w": 441
					},
					{
						"n": 6,
						"h": 201,
						"w": 391
					},
					{
						"n": 7,
						"h": 203,
						"w": 319
					},
					{
						"n": 8,
						"h": 45,
						"w": 220
					},
					{
						"n": 17,
						"h": 176,
						"w": 237
					},
					{
						"n": 19,
						"h": 281,
						"w": 168
					},
					{
						"n": 11,
						"h": 22,
						"w": 198
					}
				],
				"ball": {
					"n": 0,
					"h": 364,
					"w": 279,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 1008,
			"minute": 48,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 703
					},
					{
						"n": 2,
						"h": 394,
						"w": 541
					},
					{
						"n": 3,
						"h": 284,
						"w": 613
					},
					{
						"n": 4,
						"h": 202,
						"w": 615
					},
					{
						"n": 5,
						"h": 120,
						"w": 603
					},
					{
						"n": 6,
						"h": 409,
						"w": 480
					},
					{
						"n": 7,
						"h": 281,
						"w": 523
					},
					{
						"n": 8,
						"h": 203,
						"w": 528
					},
					{
						"n": 17,
						"h": 56,
						"w": 445
					},
					{
						"n": 10,
						"h": 356,
						"w": 330
					},
					{
						"n": 11,
						"h": 128,
						"w": 288
					}
				],
				"away": [
					{
						"n": 1,
						"h": 226,
						"w": 637
					},
					{
						"n": 13,
						"h": 423,
						"w": 290
					},
					{
						"n": 3,
						"h": 275,
						"w": 458
					},
					{
						"n": 14,
						"h": 172,
						"w": 453
					},
					{
						"n": 5,
						"h": 81,
						"w": 407
					},
					{
						"n": 6,
						"h": 197,
						"w": 360
					},
					{
						"n": 7,
						"h": 197,
						"w": 280
					},
					{
						"n": 8,
						"h": 54,
						"w": 207
					},
					{
						"n": 17,
						"h": 147,
						"w": 211
					},
					{
						"n": 19,
						"h": 259,
						"w": 144
					},
					{
						"n": 11,
						"h": 17,
						"w": 187
					}
				],
				"ball": {
					"n": 0,
					"h": 369,
					"w": 313,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 1009,
			"minute": 48,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 708
					},
					{
						"n": 2,
						"h": 394,
						"w": 567
					},
					{
						"n": 3,
						"h": 287,
						"w": 611
					},
					{
						"n": 4,
						"h": 200,
						"w": 606
					},
					{
						"n": 5,
						"h": 159,
						"w": 594
					},
					{
						"n": 6,
						"h": 406,
						"w": 500
					},
					{
						"n": 7,
						"h": 317,
						"w": 542
					},
					{
						"n": 8,
						"h": 209,
						"w": 544
					},
					{
						"n": 17,
						"h": 56,
						"w": 485
					},
					{
						"n": 10,
						"h": 392,
						"w": 347
					},
					{
						"n": 11,
						"h": 131,
						"w": 288
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 613
					},
					{
						"n": 13,
						"h": 422,
						"w": 250
					},
					{
						"n": 3,
						"h": 280,
						"w": 453
					},
					{
						"n": 14,
						"h": 170,
						"w": 441
					},
					{
						"n": 5,
						"h": 51,
						"w": 389
					},
					{
						"n": 6,
						"h": 198,
						"w": 364
					},
					{
						"n": 7,
						"h": 200,
						"w": 240
					},
					{
						"n": 8,
						"h": 46,
						"w": 168
					},
					{
						"n": 17,
						"h": 127,
						"w": 177
					},
					{
						"n": 19,
						"h": 284,
						"w": 144
					},
					{
						"n": 11,
						"h": 24,
						"w": 199
					}
				],
				"ball": {
					"n": 0,
					"h": 399,
					"w": 331,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1010,
			"minute": 49,
			"possession": 44,
			"messages": [
				{
					"owner": 2,
					"mes": "Пас О.Дюмону[26](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 705,
						"f": 94
					},
					{
						"n": 2,
						"h": 389,
						"w": 596
					},
					{
						"n": 3,
						"h": 277,
						"w": 620,
						"f": 89,
						"c": 1
					},
					{
						"n": 4,
						"h": 173,
						"w": 605
					},
					{
						"n": 5,
						"h": 120,
						"w": 603
					},
					{
						"n": 6,
						"h": 400,
						"w": 544,
						"f": 86
					},
					{
						"n": 7,
						"h": 288,
						"w": 508
					},
					{
						"n": 8,
						"h": 175,
						"w": 532
					},
					{
						"n": 17,
						"h": 56,
						"w": 481
					},
					{
						"n": 10,
						"h": 348,
						"w": 337,
						"m": 740
					},
					{
						"n": 11,
						"h": 166,
						"w": 285
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 599,
						"f": 86
					},
					{
						"n": 13,
						"h": 396,
						"w": 274
					},
					{
						"n": 3,
						"h": 284,
						"w": 452,
						"f": 87
					},
					{
						"n": 14,
						"h": 182,
						"w": 457
					},
					{
						"n": 5,
						"h": 52,
						"w": 399,
						"m": 670
					},
					{
						"n": 6,
						"h": 185,
						"w": 384,
						"f": 86
					},
					{
						"n": 7,
						"h": 215,
						"w": 283
					},
					{
						"n": 8,
						"h": 31,
						"w": 144,
						"m": 650
					},
					{
						"n": 17,
						"h": 163,
						"w": 203
					},
					{
						"n": 19,
						"h": 296,
						"w": 134
					},
					{
						"n": 11,
						"h": 52,
						"w": 210,
						"f": 85
					}
				],
				"ball": {
					"n": 0,
					"h": 265,
					"w": 336,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 45
		},
		{
			"num": 1011,
			"minute": 49,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 701
					},
					{
						"n": 2,
						"h": 368,
						"w": 590
					},
					{
						"n": 3,
						"h": 283,
						"w": 611
					},
					{
						"n": 4,
						"h": 194,
						"w": 607
					},
					{
						"n": 5,
						"h": 160,
						"w": 597
					},
					{
						"n": 6,
						"h": 394,
						"w": 530
					},
					{
						"n": 7,
						"h": 274,
						"w": 470
					},
					{
						"n": 8,
						"h": 168,
						"w": 561
					},
					{
						"n": 17,
						"h": 56,
						"w": 470
					},
					{
						"n": 10,
						"h": 309,
						"w": 327
					},
					{
						"n": 11,
						"h": 182,
						"w": 285
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 595
					},
					{
						"n": 13,
						"h": 410,
						"w": 265
					},
					{
						"n": 3,
						"h": 268,
						"w": 450
					},
					{
						"n": 14,
						"h": 165,
						"w": 446
					},
					{
						"n": 5,
						"h": 67,
						"w": 437
					},
					{
						"n": 6,
						"h": 219,
						"w": 393
					},
					{
						"n": 7,
						"h": 210,
						"w": 259
					},
					{
						"n": 8,
						"h": 52,
						"w": 150
					},
					{
						"n": 17,
						"h": 128,
						"w": 220
					},
					{
						"n": 19,
						"h": 291,
						"w": 143
					},
					{
						"n": 11,
						"h": 36,
						"w": 205
					}
				],
				"ball": {
					"n": 0,
					"h": 231,
					"w": 327,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1012,
			"minute": 49,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 707
					},
					{
						"n": 2,
						"h": 390,
						"w": 592
					},
					{
						"n": 3,
						"h": 269,
						"w": 601
					},
					{
						"n": 4,
						"h": 188,
						"w": 619
					},
					{
						"n": 5,
						"h": 123,
						"w": 613
					},
					{
						"n": 6,
						"h": 394,
						"w": 541
					},
					{
						"n": 7,
						"h": 252,
						"w": 436
					},
					{
						"n": 8,
						"h": 187,
						"w": 526
					},
					{
						"n": 17,
						"h": 56,
						"w": 470
					},
					{
						"n": 10,
						"h": 285,
						"w": 320
					},
					{
						"n": 11,
						"h": 181,
						"w": 285
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 593
					},
					{
						"n": 13,
						"h": 408,
						"w": 265
					},
					{
						"n": 3,
						"h": 269,
						"w": 451
					},
					{
						"n": 14,
						"h": 165,
						"w": 449
					},
					{
						"n": 5,
						"h": 60,
						"w": 451
					},
					{
						"n": 6,
						"h": 254,
						"w": 391
					},
					{
						"n": 7,
						"h": 222,
						"w": 272
					},
					{
						"n": 8,
						"h": 30,
						"w": 148
					},
					{
						"n": 17,
						"h": 167,
						"w": 216
					},
					{
						"n": 19,
						"h": 279,
						"w": 130
					},
					{
						"n": 11,
						"h": 43,
						"w": 214
					}
				],
				"ball": {
					"n": 0,
					"h": 196,
					"w": 329,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1013,
			"minute": 49,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 707
					},
					{
						"n": 2,
						"h": 352,
						"w": 603
					},
					{
						"n": 3,
						"h": 299,
						"w": 611
					},
					{
						"n": 4,
						"h": 181,
						"w": 601
					},
					{
						"n": 5,
						"h": 120,
						"w": 619
					},
					{
						"n": 6,
						"h": 394,
						"w": 545
					},
					{
						"n": 7,
						"h": 222,
						"w": 410
					},
					{
						"n": 8,
						"h": 165,
						"w": 552
					},
					{
						"n": 17,
						"h": 56,
						"w": 455
					},
					{
						"n": 10,
						"h": 283,
						"w": 320
					},
					{
						"n": 11,
						"h": 170,
						"w": 285
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 599
					},
					{
						"n": 13,
						"h": 410,
						"w": 280
					},
					{
						"n": 3,
						"h": 280,
						"w": 453
					},
					{
						"n": 14,
						"h": 167,
						"w": 439
					},
					{
						"n": 5,
						"h": 71,
						"w": 447
					},
					{
						"n": 6,
						"h": 289,
						"w": 386
					},
					{
						"n": 7,
						"h": 210,
						"w": 262
					},
					{
						"n": 8,
						"h": 51,
						"w": 150
					},
					{
						"n": 17,
						"h": 138,
						"w": 220
					},
					{
						"n": 19,
						"h": 286,
						"w": 147
					},
					{
						"n": 11,
						"h": 45,
						"w": 210
					}
				],
				"ball": {
					"n": 0,
					"h": 161,
					"w": 334,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1014,
			"minute": 49,
			"messages": [
				{
					"owner": 2,
					"mes": "Пас вперед..."
				},
				{
					"owner": 2,
					"mes": "Агуст Хлинссон[07](Галвэй Юнайтед) легко перехватывает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 707
					},
					{
						"n": 2,
						"h": 375,
						"w": 600
					},
					{
						"n": 3,
						"h": 277,
						"w": 610
					},
					{
						"n": 4,
						"h": 174,
						"w": 603
					},
					{
						"n": 5,
						"h": 120,
						"w": 613
					},
					{
						"n": 6,
						"h": 394,
						"w": 521
					},
					{
						"n": 7,
						"h": 205,
						"w": 393
					},
					{
						"n": 8,
						"h": 179,
						"w": 533
					},
					{
						"n": 17,
						"h": 56,
						"w": 431
					},
					{
						"n": 10,
						"h": 277,
						"w": 320
					},
					{
						"n": 11,
						"h": 176,
						"w": 274
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 595
					},
					{
						"n": 13,
						"h": 414,
						"w": 304
					},
					{
						"n": 3,
						"h": 274,
						"w": 459
					},
					{
						"n": 14,
						"h": 173,
						"w": 462
					},
					{
						"n": 5,
						"h": 72,
						"w": 439
					},
					{
						"n": 6,
						"h": 280,
						"w": 381,
						"m": 670
					},
					{
						"n": 7,
						"h": 220,
						"w": 281
					},
					{
						"n": 8,
						"h": 60,
						"w": 141
					},
					{
						"n": 17,
						"h": 162,
						"w": 219
					},
					{
						"n": 19,
						"h": 287,
						"w": 132
					},
					{
						"n": 11,
						"h": 39,
						"w": 233
					}
				],
				"ball": {
					"n": 0,
					"h": 205,
					"w": 393,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 24
		},
		{
			"num": 1015,
			"minute": 49,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 705
					},
					{
						"n": 2,
						"h": 376,
						"w": 560
					},
					{
						"n": 3,
						"h": 282,
						"w": 570
					},
					{
						"n": 4,
						"h": 172,
						"w": 563
					},
					{
						"n": 5,
						"h": 103,
						"w": 577
					},
					{
						"n": 6,
						"h": 400,
						"w": 481
					},
					{
						"n": 7,
						"h": 230,
						"w": 368,
						"m": 730
					},
					{
						"n": 8,
						"h": 172,
						"w": 493
					},
					{
						"n": 17,
						"h": 54,
						"w": 391
					},
					{
						"n": 10,
						"h": 295,
						"w": 284
					},
					{
						"n": 11,
						"h": 163,
						"w": 268
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 638
					},
					{
						"n": 13,
						"h": 403,
						"w": 342
					},
					{
						"n": 3,
						"h": 276,
						"w": 499
					},
					{
						"n": 14,
						"h": 171,
						"w": 489
					},
					{
						"n": 5,
						"h": 90,
						"w": 475
					},
					{
						"n": 6,
						"h": 240,
						"w": 377
					},
					{
						"n": 7,
						"h": 220,
						"w": 321
					},
					{
						"n": 8,
						"h": 57,
						"w": 161
					},
					{
						"n": 17,
						"h": 169,
						"w": 258
					},
					{
						"n": 19,
						"h": 284,
						"w": 172
					},
					{
						"n": 11,
						"h": 66,
						"w": 263
					}
				],
				"ball": {
					"n": 0,
					"h": 230,
					"w": 368,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1016,
			"minute": 49,
			"messages": [
				{
					"owner": 1,
					"mes": "Передача вперед..."
				},
				{
					"owner": 1,
					"mes": "Джо Квигли[10](Галвэй Юнайтед) технично принимает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 706
					},
					{
						"n": 2,
						"h": 381,
						"w": 529
					},
					{
						"n": 3,
						"h": 274,
						"w": 540
					},
					{
						"n": 4,
						"h": 172,
						"w": 535
					},
					{
						"n": 5,
						"h": 94,
						"w": 547
					},
					{
						"n": 6,
						"h": 397,
						"w": 451
					},
					{
						"n": 7,
						"h": 238,
						"w": 362,
						"m": 740
					},
					{
						"n": 8,
						"h": 165,
						"w": 463
					},
					{
						"n": 17,
						"h": 41,
						"w": 363
					},
					{
						"n": 10,
						"h": 280,
						"w": 312
					},
					{
						"n": 11,
						"h": 145,
						"w": 243
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 648
					},
					{
						"n": 13,
						"h": 405,
						"w": 373
					},
					{
						"n": 3,
						"h": 290,
						"w": 523
					},
					{
						"n": 14,
						"h": 189,
						"w": 512
					},
					{
						"n": 5,
						"h": 102,
						"w": 503
					},
					{
						"n": 6,
						"h": 222,
						"w": 401
					},
					{
						"n": 7,
						"h": 219,
						"w": 352
					},
					{
						"n": 8,
						"h": 55,
						"w": 192
					},
					{
						"n": 17,
						"h": 197,
						"w": 272
					},
					{
						"n": 19,
						"h": 284,
						"w": 203
					},
					{
						"n": 11,
						"h": 94,
						"w": 277
					}
				],
				"ball": {
					"n": 0,
					"h": 280,
					"w": 312,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 31
		},
		{
			"num": 1017,
			"minute": 49,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 708
					},
					{
						"n": 2,
						"h": 379,
						"w": 489
					},
					{
						"n": 3,
						"h": 279,
						"w": 502
					},
					{
						"n": 4,
						"h": 179,
						"w": 514
					},
					{
						"n": 5,
						"h": 78,
						"w": 511
					},
					{
						"n": 6,
						"h": 400,
						"w": 411
					},
					{
						"n": 7,
						"h": 273,
						"w": 343
					},
					{
						"n": 8,
						"h": 156,
						"w": 424
					},
					{
						"n": 17,
						"h": 47,
						"w": 333
					},
					{
						"n": 10,
						"h": 279,
						"w": 277
					},
					{
						"n": 11,
						"h": 161,
						"w": 218
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 642
					},
					{
						"n": 13,
						"h": 403,
						"w": 413
					},
					{
						"n": 3,
						"h": 261,
						"w": 550
					},
					{
						"n": 14,
						"h": 177,
						"w": 474
					},
					{
						"n": 5,
						"h": 108,
						"w": 543
					},
					{
						"n": 6,
						"h": 197,
						"w": 433
					},
					{
						"n": 7,
						"h": 221,
						"w": 392
					},
					{
						"n": 8,
						"h": 49,
						"w": 231
					},
					{
						"n": 17,
						"h": 232,
						"w": 291
					},
					{
						"n": 19,
						"h": 288,
						"w": 243
					},
					{
						"n": 11,
						"h": 121,
						"w": 306
					}
				],
				"ball": {
					"n": 0,
					"h": 279,
					"w": 277,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1018,
			"minute": 49,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 709
					},
					{
						"n": 2,
						"h": 381,
						"w": 479
					},
					{
						"n": 3,
						"h": 276,
						"w": 491
					},
					{
						"n": 4,
						"h": 176,
						"w": 503
					},
					{
						"n": 5,
						"h": 76,
						"w": 500
					},
					{
						"n": 6,
						"h": 399,
						"w": 400
					},
					{
						"n": 7,
						"h": 275,
						"w": 332
					},
					{
						"n": 8,
						"h": 156,
						"w": 413
					},
					{
						"n": 17,
						"h": 48,
						"w": 322
					},
					{
						"n": 10,
						"h": 277,
						"w": 266
					},
					{
						"n": 11,
						"h": 164,
						"w": 207
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 645
					},
					{
						"n": 13,
						"h": 403,
						"w": 423
					},
					{
						"n": 3,
						"h": 250,
						"w": 554
					},
					{
						"n": 14,
						"h": 175,
						"w": 464
					},
					{
						"n": 5,
						"h": 110,
						"w": 544
					},
					{
						"n": 6,
						"h": 206,
						"w": 440
					},
					{
						"n": 7,
						"h": 222,
						"w": 403
					},
					{
						"n": 8,
						"h": 48,
						"w": 242
					},
					{
						"n": 17,
						"h": 241,
						"w": 297
					},
					{
						"n": 19,
						"h": 289,
						"w": 254
					},
					{
						"n": 11,
						"h": 128,
						"w": 315
					}
				],
				"ball": {
					"n": 0,
					"h": 277,
					"w": 266,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 11
		},
		{
			"num": 1019,
			"minute": 49,
			"messages": [
				{
					"owner": 1,
					"mes": "Вацлав Сланина[34](Опава) пытается отобрать мяч у Д.Квигли[10](Галвэй Юнайтед)..."
				},
				{
					"owner": 1,
					"mes": "Вацлав Сланина[34](Опава) обкрадывает Д.Квигли[10](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 709
					},
					{
						"n": 2,
						"h": 382,
						"w": 474
					},
					{
						"n": 3,
						"h": 275,
						"w": 486
					},
					{
						"n": 4,
						"h": 175,
						"w": 498
					},
					{
						"n": 5,
						"h": 76,
						"w": 495
					},
					{
						"n": 6,
						"h": 399,
						"w": 395
					},
					{
						"n": 7,
						"h": 275,
						"w": 327
					},
					{
						"n": 8,
						"h": 156,
						"w": 408
					},
					{
						"n": 17,
						"h": 48,
						"w": 317
					},
					{
						"n": 10,
						"h": 276,
						"w": 256,
						"m": 730
					},
					{
						"n": 11,
						"h": 165,
						"w": 202
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 645
					},
					{
						"n": 13,
						"h": 403,
						"w": 423
					},
					{
						"n": 3,
						"h": 246,
						"w": 556
					},
					{
						"n": 14,
						"h": 174,
						"w": 459,
						"m": 620
					},
					{
						"n": 5,
						"h": 110,
						"w": 544
					},
					{
						"n": 6,
						"h": 209,
						"w": 443
					},
					{
						"n": 7,
						"h": 222,
						"w": 408
					},
					{
						"n": 8,
						"h": 48,
						"w": 247
					},
					{
						"n": 17,
						"h": 245,
						"w": 300
					},
					{
						"n": 19,
						"h": 289,
						"w": 259
					},
					{
						"n": 11,
						"h": 131,
						"w": 319
					}
				],
				"ball": {
					"n": 0,
					"h": 276,
					"w": 261,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 5
		},
		{
			"num": 1020,
			"minute": 49,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 709
					},
					{
						"n": 2,
						"h": 384,
						"w": 464
					},
					{
						"n": 3,
						"h": 274,
						"w": 482
					},
					{
						"n": 4,
						"h": 172,
						"w": 489
					},
					{
						"n": 5,
						"h": 75,
						"w": 485
					},
					{
						"n": 6,
						"h": 398,
						"w": 385
					},
					{
						"n": 7,
						"h": 277,
						"w": 317
					},
					{
						"n": 8,
						"h": 157,
						"w": 398
					},
					{
						"n": 17,
						"h": 49,
						"w": 307
					},
					{
						"n": 10,
						"h": 276,
						"w": 256
					},
					{
						"n": 11,
						"h": 168,
						"w": 193
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 645
					},
					{
						"n": 13,
						"h": 403,
						"w": 423
					},
					{
						"n": 3,
						"h": 244,
						"w": 556
					},
					{
						"n": 14,
						"h": 172,
						"w": 449
					},
					{
						"n": 5,
						"h": 110,
						"w": 544
					},
					{
						"n": 6,
						"h": 217,
						"w": 450
					},
					{
						"n": 7,
						"h": 223,
						"w": 418
					},
					{
						"n": 8,
						"h": 47,
						"w": 257
					},
					{
						"n": 17,
						"h": 254,
						"w": 306
					},
					{
						"n": 19,
						"h": 290,
						"w": 269
					},
					{
						"n": 11,
						"h": 137,
						"w": 327
					}
				],
				"ball": {
					"n": 0,
					"h": 278,
					"w": 271,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 10
		},
		{
			"num": 1021,
			"minute": 49,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 707
					},
					{
						"n": 2,
						"h": 350,
						"w": 486
					},
					{
						"n": 3,
						"h": 280,
						"w": 493
					},
					{
						"n": 4,
						"h": 169,
						"w": 492
					},
					{
						"n": 5,
						"h": 112,
						"w": 499
					},
					{
						"n": 6,
						"h": 395,
						"w": 425
					},
					{
						"n": 7,
						"h": 275,
						"w": 357
					},
					{
						"n": 8,
						"h": 163,
						"w": 427
					},
					{
						"n": 17,
						"h": 45,
						"w": 347
					},
					{
						"n": 10,
						"h": 277,
						"w": 266
					},
					{
						"n": 11,
						"h": 156,
						"w": 231
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 630
					},
					{
						"n": 13,
						"h": 413,
						"w": 424
					},
					{
						"n": 3,
						"h": 282,
						"w": 569
					},
					{
						"n": 14,
						"h": 137,
						"w": 449
					},
					{
						"n": 5,
						"h": 76,
						"w": 552
					},
					{
						"n": 6,
						"h": 252,
						"w": 468
					},
					{
						"n": 7,
						"h": 230,
						"w": 398
					},
					{
						"n": 8,
						"h": 34,
						"w": 295
					},
					{
						"n": 17,
						"h": 294,
						"w": 306
					},
					{
						"n": 19,
						"h": 304,
						"w": 249
					},
					{
						"n": 11,
						"h": 150,
						"w": 289
					}
				],
				"ball": {
					"n": 0,
					"h": 313,
					"w": 271,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1022,
			"minute": 49,
			"messages": [
				{
					"owner": 2,
					"mes": "Вацлав Сланина[34](Опава) пасует налево..."
				},
				{
					"owner": 2,
					"mes": "Агуст Хлинссон[07](Галвэй Юнайтед) в подкате перехватывает мяч!..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 708
					},
					{
						"n": 2,
						"h": 340,
						"w": 508
					},
					{
						"n": 3,
						"h": 265,
						"w": 513
					},
					{
						"n": 4,
						"h": 167,
						"w": 517
					},
					{
						"n": 5,
						"h": 120,
						"w": 522
					},
					{
						"n": 6,
						"h": 394,
						"w": 450
					},
					{
						"n": 7,
						"h": 268,
						"w": 333
					},
					{
						"n": 8,
						"h": 188,
						"w": 432
					},
					{
						"n": 17,
						"h": 56,
						"w": 336
					},
					{
						"n": 10,
						"h": 279,
						"w": 291
					},
					{
						"n": 11,
						"h": 147,
						"w": 254
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 631
					},
					{
						"n": 13,
						"h": 414,
						"w": 399
					},
					{
						"n": 3,
						"h": 281,
						"w": 544
					},
					{
						"n": 14,
						"h": 139,
						"w": 453,
						"m": 610
					},
					{
						"n": 5,
						"h": 65,
						"w": 530
					},
					{
						"n": 6,
						"h": 232,
						"w": 454
					},
					{
						"n": 7,
						"h": 209,
						"w": 393,
						"m": 550
					},
					{
						"n": 8,
						"h": 41,
						"w": 271
					},
					{
						"n": 17,
						"h": 319,
						"w": 303
					},
					{
						"n": 19,
						"h": 311,
						"w": 225
					},
					{
						"n": 11,
						"h": 175,
						"w": 290
					}
				],
				"ball": {
					"n": 0,
					"h": 268,
					"w": 333,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 25
		},
		{
			"num": 1023,
			"minute": 49,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 705
					},
					{
						"n": 2,
						"h": 361,
						"w": 475
					},
					{
						"n": 3,
						"h": 274,
						"w": 474
					},
					{
						"n": 4,
						"h": 169,
						"w": 477
					},
					{
						"n": 5,
						"h": 101,
						"w": 486
					},
					{
						"n": 6,
						"h": 398,
						"w": 410
					},
					{
						"n": 7,
						"h": 304,
						"w": 333,
						"m": 750
					},
					{
						"n": 8,
						"h": 175,
						"w": 394
					},
					{
						"n": 17,
						"h": 41,
						"w": 299
					},
					{
						"n": 10,
						"h": 288,
						"w": 252
					},
					{
						"n": 11,
						"h": 156,
						"w": 215
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 648
					},
					{
						"n": 13,
						"h": 408,
						"w": 439
					},
					{
						"n": 3,
						"h": 251,
						"w": 570
					},
					{
						"n": 14,
						"h": 151,
						"w": 492
					},
					{
						"n": 5,
						"h": 88,
						"w": 563
					},
					{
						"n": 6,
						"h": 259,
						"w": 484
					},
					{
						"n": 7,
						"h": 170,
						"w": 403
					},
					{
						"n": 8,
						"h": 42,
						"w": 291
					},
					{
						"n": 17,
						"h": 340,
						"w": 337
					},
					{
						"n": 19,
						"h": 299,
						"w": 264
					},
					{
						"n": 11,
						"h": 188,
						"w": 329
					}
				],
				"ball": {
					"n": 0,
					"h": 304,
					"w": 333,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1024,
			"minute": 49,
			"messages": [
				{
					"owner": 1,
					"mes": "Агуст Хлинссон[07](Галвэй Юнайтед) играет направо..."
				},
				{
					"owner": 1,
					"mes": "Киран Нолан[08](Галвэй Юнайтед) принимает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 701
					},
					{
						"n": 2,
						"h": 374,
						"w": 435
					},
					{
						"n": 3,
						"h": 268,
						"w": 455
					},
					{
						"n": 4,
						"h": 170,
						"w": 452
					},
					{
						"n": 5,
						"h": 87,
						"w": 447
					},
					{
						"n": 6,
						"h": 400,
						"w": 368
					},
					{
						"n": 7,
						"h": 304,
						"w": 323
					},
					{
						"n": 8,
						"h": 186,
						"w": 376
					},
					{
						"n": 17,
						"h": 51,
						"w": 265
					},
					{
						"n": 10,
						"h": 294,
						"w": 211
					},
					{
						"n": 11,
						"h": 151,
						"w": 174
					}
				],
				"away": [
					{
						"n": 1,
						"h": 228,
						"w": 644
					},
					{
						"n": 13,
						"h": 401,
						"w": 480
					},
					{
						"n": 3,
						"h": 245,
						"w": 612
					},
					{
						"n": 14,
						"h": 162,
						"w": 532
					},
					{
						"n": 5,
						"h": 109,
						"w": 599
					},
					{
						"n": 6,
						"h": 265,
						"w": 525
					},
					{
						"n": 7,
						"h": 203,
						"w": 429
					},
					{
						"n": 8,
						"h": 44,
						"w": 312
					},
					{
						"n": 17,
						"h": 363,
						"w": 372
					},
					{
						"n": 19,
						"h": 280,
						"w": 288
					},
					{
						"n": 11,
						"h": 226,
						"w": 346
					}
				],
				"ball": {
					"n": 0,
					"h": 186,
					"w": 376,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 42
		},
		{
			"num": 1025,
			"minute": 49,
			"messages": [
				{
					"owner": 1,
					"mes": "Пас вперед..."
				},
				{
					"owner": 1,
					"mes": "Адам Гилберт[11](Галвэй Юнайтед) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 704
					},
					{
						"n": 2,
						"h": 387,
						"w": 374
					},
					{
						"n": 3,
						"h": 279,
						"w": 412
					},
					{
						"n": 4,
						"h": 180,
						"w": 416
					},
					{
						"n": 5,
						"h": 69,
						"w": 387
					},
					{
						"n": 6,
						"h": 404,
						"w": 306
					},
					{
						"n": 7,
						"h": 295,
						"w": 261
					},
					{
						"n": 8,
						"h": 184,
						"w": 366,
						"m": 650
					},
					{
						"n": 17,
						"h": 54,
						"w": 203
					},
					{
						"n": 10,
						"h": 283,
						"w": 150
					},
					{
						"n": 11,
						"h": 114,
						"w": 137
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 682
					},
					{
						"n": 13,
						"h": 397,
						"w": 542
					},
					{
						"n": 3,
						"h": 283,
						"w": 609
					},
					{
						"n": 14,
						"h": 165,
						"w": 594
					},
					{
						"n": 5,
						"h": 165,
						"w": 611
					},
					{
						"n": 6,
						"h": 306,
						"w": 572
					},
					{
						"n": 7,
						"h": 188,
						"w": 489
					},
					{
						"n": 8,
						"h": 44,
						"w": 343
					},
					{
						"n": 17,
						"h": 388,
						"w": 428
					},
					{
						"n": 19,
						"h": 270,
						"w": 349
					},
					{
						"n": 11,
						"h": 192,
						"w": 398
					}
				],
				"ball": {
					"n": 0,
					"h": 114,
					"w": 137,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 62
		},
		{
			"num": 1026,
			"minute": 49,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 706
					},
					{
						"n": 2,
						"h": 384,
						"w": 347
					},
					{
						"n": 3,
						"h": 267,
						"w": 394
					},
					{
						"n": 4,
						"h": 169,
						"w": 399
					},
					{
						"n": 5,
						"h": 73,
						"w": 353
					},
					{
						"n": 6,
						"h": 400,
						"w": 266
					},
					{
						"n": 7,
						"h": 293,
						"w": 221
					},
					{
						"n": 8,
						"h": 177,
						"w": 326
					},
					{
						"n": 17,
						"h": 55,
						"w": 163
					},
					{
						"n": 10,
						"h": 278,
						"w": 110
					},
					{
						"n": 11,
						"h": 134,
						"w": 102
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 709
					},
					{
						"n": 13,
						"h": 396,
						"w": 582
					},
					{
						"n": 3,
						"h": 316,
						"w": 618
					},
					{
						"n": 14,
						"h": 166,
						"w": 634
					},
					{
						"n": 5,
						"h": 207,
						"w": 628
					},
					{
						"n": 6,
						"h": 311,
						"w": 620
					},
					{
						"n": 7,
						"h": 207,
						"w": 525
					},
					{
						"n": 8,
						"h": 45,
						"w": 363
					},
					{
						"n": 17,
						"h": 406,
						"w": 464
					},
					{
						"n": 19,
						"h": 272,
						"w": 389
					},
					{
						"n": 11,
						"h": 173,
						"w": 417
					}
				],
				"ball": {
					"n": 0,
					"h": 134,
					"w": 102,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1027,
			"minute": 49,
			"messages": [
				{
					"owner": 1,
					"mes": "А.Гилберт[11](Галвэй Юнайтед) пытается пройти Н.Мансура[23](Опава)..."
				},
				{
					"owner": 1,
					"mes": "Мяч отобран..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 702
					},
					{
						"n": 2,
						"h": 389,
						"w": 346
					},
					{
						"n": 3,
						"h": 271,
						"w": 393
					},
					{
						"n": 4,
						"h": 173,
						"w": 402
					},
					{
						"n": 5,
						"h": 69,
						"w": 350
					},
					{
						"n": 6,
						"h": 400,
						"w": 261
					},
					{
						"n": 7,
						"h": 292,
						"w": 217
					},
					{
						"n": 8,
						"h": 175,
						"w": 322
					},
					{
						"n": 17,
						"h": 55,
						"w": 158
					},
					{
						"n": 10,
						"h": 279,
						"w": 105
					},
					{
						"n": 11,
						"h": 134,
						"w": 97
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 709
					},
					{
						"n": 13,
						"h": 395,
						"w": 587
					},
					{
						"n": 3,
						"h": 316,
						"w": 618,
						"m": 620
					},
					{
						"n": 14,
						"h": 167,
						"w": 639
					},
					{
						"n": 5,
						"h": 212,
						"w": 629
					},
					{
						"n": 6,
						"h": 314,
						"w": 618
					},
					{
						"n": 7,
						"h": 211,
						"w": 528
					},
					{
						"n": 8,
						"h": 45,
						"w": 368
					},
					{
						"n": 17,
						"h": 406,
						"w": 469
					},
					{
						"n": 19,
						"h": 272,
						"w": 394
					},
					{
						"n": 11,
						"h": 175,
						"w": 417
					}
				],
				"ball": {
					"n": 0,
					"h": 134,
					"w": 102,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 4
				}
			},
			"interval": 5
		},
		{
			"num": 1028,
			"minute": 49,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 702
					},
					{
						"n": 2,
						"h": 392,
						"w": 345
					},
					{
						"n": 3,
						"h": 279,
						"w": 392
					},
					{
						"n": 4,
						"h": 181,
						"w": 408
					},
					{
						"n": 5,
						"h": 60,
						"w": 345
					},
					{
						"n": 6,
						"h": 401,
						"w": 251
					},
					{
						"n": 7,
						"h": 290,
						"w": 207
					},
					{
						"n": 8,
						"h": 173,
						"w": 312
					},
					{
						"n": 17,
						"h": 56,
						"w": 148
					},
					{
						"n": 10,
						"h": 281,
						"w": 95
					},
					{
						"n": 11,
						"h": 134,
						"w": 97
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 709
					},
					{
						"n": 13,
						"h": 395,
						"w": 593
					},
					{
						"n": 3,
						"h": 316,
						"w": 618
					},
					{
						"n": 14,
						"h": 168,
						"w": 649
					},
					{
						"n": 5,
						"h": 222,
						"w": 631
					},
					{
						"n": 6,
						"h": 314,
						"w": 618
					},
					{
						"n": 7,
						"h": 216,
						"w": 532
					},
					{
						"n": 8,
						"h": 46,
						"w": 378
					},
					{
						"n": 17,
						"h": 404,
						"w": 479
					},
					{
						"n": 19,
						"h": 273,
						"w": 404
					},
					{
						"n": 11,
						"h": 175,
						"w": 417
					}
				],
				"ball": {
					"n": 0,
					"h": 134,
					"w": 102,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 10
		},
		{
			"num": 1029,
			"minute": 49,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 709
					},
					{
						"n": 2,
						"h": 378,
						"w": 351
					},
					{
						"n": 3,
						"h": 266,
						"w": 406
					},
					{
						"n": 4,
						"h": 172,
						"w": 424
					},
					{
						"n": 5,
						"h": 81,
						"w": 379
					},
					{
						"n": 6,
						"h": 400,
						"w": 271
					},
					{
						"n": 7,
						"h": 284,
						"w": 246
					},
					{
						"n": 8,
						"h": 166,
						"w": 350
					},
					{
						"n": 17,
						"h": 56,
						"w": 188
					},
					{
						"n": 10,
						"h": 286,
						"w": 135
					},
					{
						"n": 11,
						"h": 139,
						"w": 106
					}
				],
				"away": [
					{
						"n": 1,
						"h": 229,
						"w": 710
					},
					{
						"n": 13,
						"h": 395,
						"w": 553
					},
					{
						"n": 3,
						"h": 291,
						"w": 593
					},
					{
						"n": 14,
						"h": 152,
						"w": 649
					},
					{
						"n": 5,
						"h": 182,
						"w": 629
					},
					{
						"n": 6,
						"h": 298,
						"w": 581
					},
					{
						"n": 7,
						"h": 222,
						"w": 492
					},
					{
						"n": 8,
						"h": 42,
						"w": 389
					},
					{
						"n": 17,
						"h": 409,
						"w": 439
					},
					{
						"n": 19,
						"h": 290,
						"w": 368
					},
					{
						"n": 11,
						"h": 169,
						"w": 377
					}
				],
				"ball": {
					"n": 0,
					"h": 159,
					"w": 127,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1030,
			"minute": 49,
			"messages": [
				{
					"owner": 2,
					"mes": "Пас направо на Т.Прохазку[25](Опава)..."
				},
				{
					"owner": 2,
					"mes": "Томаш Прохазка[25](Опава) достает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 706
					},
					{
						"n": 2,
						"h": 366,
						"w": 369
					},
					{
						"n": 3,
						"h": 252,
						"w": 432
					},
					{
						"n": 4,
						"h": 171,
						"w": 437
					},
					{
						"n": 5,
						"h": 98,
						"w": 404
					},
					{
						"n": 6,
						"h": 403,
						"w": 281
					},
					{
						"n": 7,
						"h": 280,
						"w": 276
					},
					{
						"n": 8,
						"h": 162,
						"w": 379
					},
					{
						"n": 17,
						"h": 54,
						"w": 218
					},
					{
						"n": 10,
						"h": 257,
						"w": 128
					},
					{
						"n": 11,
						"h": 143,
						"w": 136
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 703
					},
					{
						"n": 13,
						"h": 397,
						"w": 523
					},
					{
						"n": 3,
						"h": 289,
						"w": 603
					},
					{
						"n": 14,
						"h": 160,
						"w": 610
					},
					{
						"n": 5,
						"h": 209,
						"w": 616
					},
					{
						"n": 6,
						"h": 277,
						"w": 559
					},
					{
						"n": 7,
						"h": 228,
						"w": 463
					},
					{
						"n": 8,
						"h": 54,
						"w": 371
					},
					{
						"n": 17,
						"h": 407,
						"w": 409
					},
					{
						"n": 19,
						"h": 294,
						"w": 338
					},
					{
						"n": 11,
						"h": 190,
						"w": 357
					}
				],
				"ball": {
					"n": 0,
					"h": 241,
					"w": 104,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 30
		},
		{
			"num": 1031,
			"minute": 49,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 702
					},
					{
						"n": 2,
						"h": 386,
						"w": 393
					},
					{
						"n": 3,
						"h": 254,
						"w": 468
					},
					{
						"n": 4,
						"h": 172,
						"w": 456
					},
					{
						"n": 5,
						"h": 113,
						"w": 441
					},
					{
						"n": 6,
						"h": 400,
						"w": 300
					},
					{
						"n": 7,
						"h": 276,
						"w": 316
					},
					{
						"n": 8,
						"h": 148,
						"w": 413
					},
					{
						"n": 17,
						"h": 54,
						"w": 258
					},
					{
						"n": 10,
						"h": 226,
						"w": 153
					},
					{
						"n": 11,
						"h": 150,
						"w": 175
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 707
					},
					{
						"n": 13,
						"h": 404,
						"w": 483
					},
					{
						"n": 3,
						"h": 283,
						"w": 600
					},
					{
						"n": 14,
						"h": 172,
						"w": 600
					},
					{
						"n": 5,
						"h": 227,
						"w": 585
					},
					{
						"n": 6,
						"h": 251,
						"w": 529
					},
					{
						"n": 7,
						"h": 221,
						"w": 423
					},
					{
						"n": 8,
						"h": 34,
						"w": 347
					},
					{
						"n": 17,
						"h": 405,
						"w": 369
					},
					{
						"n": 19,
						"h": 308,
						"w": 300
					},
					{
						"n": 11,
						"h": 200,
						"w": 318
					}
				],
				"ball": {
					"n": 0,
					"h": 223,
					"w": 135,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1032,
			"minute": 49,
			"messages": [
				{
					"owner": 2,
					"mes": "Т.Прохазка[25](Опава) играет низом в расчете на В.Сланину[34](Опава)..."
				},
				{
					"owner": 2,
					"mes": "Вацлав Сланина[34](Опава) с мячом..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 710
					},
					{
						"n": 2,
						"h": 379,
						"w": 416
					},
					{
						"n": 3,
						"h": 232,
						"w": 457
					},
					{
						"n": 4,
						"h": 163,
						"w": 463
					},
					{
						"n": 5,
						"h": 99,
						"w": 422
					},
					{
						"n": 6,
						"h": 401,
						"w": 304
					},
					{
						"n": 7,
						"h": 272,
						"w": 339
					},
					{
						"n": 8,
						"h": 162,
						"w": 393
					},
					{
						"n": 17,
						"h": 55,
						"w": 282
					},
					{
						"n": 10,
						"h": 250,
						"w": 151
					},
					{
						"n": 11,
						"h": 147,
						"w": 199
					}
				],
				"away": [
					{
						"n": 1,
						"h": 229,
						"w": 703
					},
					{
						"n": 13,
						"h": 399,
						"w": 460
					},
					{
						"n": 3,
						"h": 285,
						"w": 607
					},
					{
						"n": 14,
						"h": 178,
						"w": 590
					},
					{
						"n": 5,
						"h": 217,
						"w": 587
					},
					{
						"n": 6,
						"h": 228,
						"w": 521
					},
					{
						"n": 7,
						"h": 211,
						"w": 404
					},
					{
						"n": 8,
						"h": 41,
						"w": 324
					},
					{
						"n": 17,
						"h": 401,
						"w": 346
					},
					{
						"n": 19,
						"h": 297,
						"w": 283
					},
					{
						"n": 11,
						"h": 222,
						"w": 307
					}
				],
				"ball": {
					"n": 0,
					"h": 272,
					"w": 130,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 24
		},
		{
			"num": 1033,
			"minute": 49,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 710
					},
					{
						"n": 2,
						"h": 363,
						"w": 410
					},
					{
						"n": 3,
						"h": 227,
						"w": 454
					},
					{
						"n": 4,
						"h": 177,
						"w": 455
					},
					{
						"n": 5,
						"h": 120,
						"w": 454
					},
					{
						"n": 6,
						"h": 416,
						"w": 341
					},
					{
						"n": 7,
						"h": 260,
						"w": 378
					},
					{
						"n": 8,
						"h": 176,
						"w": 387
					},
					{
						"n": 17,
						"h": 49,
						"w": 322
					},
					{
						"n": 10,
						"h": 281,
						"w": 176
					},
					{
						"n": 11,
						"h": 137,
						"w": 238
					}
				],
				"away": [
					{
						"n": 1,
						"h": 228,
						"w": 708
					},
					{
						"n": 13,
						"h": 408,
						"w": 442
					},
					{
						"n": 3,
						"h": 269,
						"w": 596
					},
					{
						"n": 14,
						"h": 162,
						"w": 559
					},
					{
						"n": 5,
						"h": 177,
						"w": 592
					},
					{
						"n": 6,
						"h": 214,
						"w": 511
					},
					{
						"n": 7,
						"h": 239,
						"w": 377
					},
					{
						"n": 8,
						"h": 57,
						"w": 330
					},
					{
						"n": 17,
						"h": 402,
						"w": 306
					},
					{
						"n": 19,
						"h": 288,
						"w": 275
					},
					{
						"n": 11,
						"h": 219,
						"w": 294
					}
				],
				"ball": {
					"n": 0,
					"h": 288,
					"w": 161,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1034,
			"minute": 50,
			"possession": 44,
			"messages": [
				{
					"owner": 2,
					"mes": "Слева просит мяч Нир Мансур[23](Опава)... Пас ему..."
				},
				{
					"owner": 2,
					"mes": "Нир Мансур[23](Опава) останавливает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 701,
						"m": 630
					},
					{
						"n": 2,
						"h": 379,
						"w": 413
					},
					{
						"n": 3,
						"h": 242,
						"w": 462
					},
					{
						"n": 4,
						"h": 189,
						"w": 464,
						"f": 88
					},
					{
						"n": 5,
						"h": 86,
						"w": 443
					},
					{
						"n": 6,
						"h": 410,
						"w": 356,
						"m": 700
					},
					{
						"n": 7,
						"h": 241,
						"w": 396,
						"f": 86
					},
					{
						"n": 8,
						"h": 174,
						"w": 407
					},
					{
						"n": 17,
						"h": 52,
						"w": 358,
						"f": 98
					},
					{
						"n": 10,
						"h": 292,
						"w": 210,
						"f": 85
					},
					{
						"n": 11,
						"h": 133,
						"w": 270
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 705
					},
					{
						"n": 13,
						"h": 410,
						"w": 452
					},
					{
						"n": 3,
						"h": 248,
						"w": 567
					},
					{
						"n": 14,
						"h": 165,
						"w": 568
					},
					{
						"n": 5,
						"h": 141,
						"w": 597
					},
					{
						"n": 6,
						"h": 240,
						"w": 497
					},
					{
						"n": 7,
						"h": 226,
						"w": 406
					},
					{
						"n": 8,
						"h": 41,
						"w": 327
					},
					{
						"n": 17,
						"h": 402,
						"w": 300
					},
					{
						"n": 19,
						"h": 274,
						"w": 295
					},
					{
						"n": 11,
						"h": 210,
						"w": 300
					}
				],
				"ball": {
					"n": 0,
					"h": 202,
					"w": 153,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 36
		},
		{
			"num": 1035,
			"minute": 50,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 710
					},
					{
						"n": 2,
						"h": 371,
						"w": 443
					},
					{
						"n": 3,
						"h": 230,
						"w": 462
					},
					{
						"n": 4,
						"h": 182,
						"w": 457
					},
					{
						"n": 5,
						"h": 85,
						"w": 440
					},
					{
						"n": 6,
						"h": 400,
						"w": 395
					},
					{
						"n": 7,
						"h": 225,
						"w": 400
					},
					{
						"n": 8,
						"h": 175,
						"w": 386
					},
					{
						"n": 17,
						"h": 62,
						"w": 360
					},
					{
						"n": 10,
						"h": 310,
						"w": 246
					},
					{
						"n": 11,
						"h": 141,
						"w": 270
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 702
					},
					{
						"n": 13,
						"h": 407,
						"w": 443
					},
					{
						"n": 3,
						"h": 259,
						"w": 534
					},
					{
						"n": 14,
						"h": 175,
						"w": 599
					},
					{
						"n": 5,
						"h": 92,
						"w": 590
					},
					{
						"n": 6,
						"h": 209,
						"w": 480
					},
					{
						"n": 7,
						"h": 229,
						"w": 401
					},
					{
						"n": 8,
						"h": 55,
						"w": 337
					},
					{
						"n": 17,
						"h": 395,
						"w": 300
					},
					{
						"n": 19,
						"h": 285,
						"w": 299
					},
					{
						"n": 11,
						"h": 218,
						"w": 306
					}
				],
				"ball": {
					"n": 0,
					"h": 191,
					"w": 186,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1036,
			"minute": 50,
			"messages": [
				{
					"owner": 2,
					"mes": "Справа просит мяч Томаш Прохазка[25](Опава)... Пас ему..."
				},
				{
					"owner": 2,
					"mes": "Томаш Прохазка[25](Опава) получает передачу..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 710
					},
					{
						"n": 2,
						"h": 330,
						"w": 461
					},
					{
						"n": 3,
						"h": 230,
						"w": 460
					},
					{
						"n": 4,
						"h": 188,
						"w": 467
					},
					{
						"n": 5,
						"h": 120,
						"w": 466
					},
					{
						"n": 6,
						"h": 380,
						"w": 448
					},
					{
						"n": 7,
						"h": 259,
						"w": 380
					},
					{
						"n": 8,
						"h": 231,
						"w": 404
					},
					{
						"n": 17,
						"h": 33,
						"w": 363
					},
					{
						"n": 10,
						"h": 321,
						"w": 273
					},
					{
						"n": 11,
						"h": 184,
						"w": 270
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 684
					},
					{
						"n": 13,
						"h": 407,
						"w": 458
					},
					{
						"n": 3,
						"h": 266,
						"w": 541
					},
					{
						"n": 14,
						"h": 179,
						"w": 565
					},
					{
						"n": 5,
						"h": 83,
						"w": 531
					},
					{
						"n": 6,
						"h": 198,
						"w": 475
					},
					{
						"n": 7,
						"h": 186,
						"w": 361
					},
					{
						"n": 8,
						"h": 55,
						"w": 300
					},
					{
						"n": 17,
						"h": 416,
						"w": 300
					},
					{
						"n": 19,
						"h": 274,
						"w": 274
					},
					{
						"n": 11,
						"h": 216,
						"w": 302
					}
				],
				"ball": {
					"n": 0,
					"h": 367,
					"w": 189,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 59
		},
		{
			"num": 1037,
			"minute": 50,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 704
					},
					{
						"n": 2,
						"h": 369,
						"w": 470
					},
					{
						"n": 3,
						"h": 250,
						"w": 494
					},
					{
						"n": 4,
						"h": 174,
						"w": 492
					},
					{
						"n": 5,
						"h": 120,
						"w": 490
					},
					{
						"n": 6,
						"h": 401,
						"w": 414
					},
					{
						"n": 7,
						"h": 287,
						"w": 408
					},
					{
						"n": 8,
						"h": 244,
						"w": 406
					},
					{
						"n": 17,
						"h": 41,
						"w": 396
					},
					{
						"n": 10,
						"h": 317,
						"w": 313
					},
					{
						"n": 11,
						"h": 170,
						"w": 270
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 665
					},
					{
						"n": 13,
						"h": 415,
						"w": 419
					},
					{
						"n": 3,
						"h": 280,
						"w": 568
					},
					{
						"n": 14,
						"h": 179,
						"w": 574
					},
					{
						"n": 5,
						"h": 73,
						"w": 497
					},
					{
						"n": 6,
						"h": 199,
						"w": 477
					},
					{
						"n": 7,
						"h": 212,
						"w": 336
					},
					{
						"n": 8,
						"h": 34,
						"w": 266
					},
					{
						"n": 17,
						"h": 400,
						"w": 264
					},
					{
						"n": 19,
						"h": 288,
						"w": 258
					},
					{
						"n": 11,
						"h": 204,
						"w": 272
					}
				],
				"ball": {
					"n": 0,
					"h": 377,
					"w": 223,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1038,
			"minute": 50,
			"messages": [
				{
					"owner": 2,
					"mes": "Томаш Прохазка[25](Опава) посылает мяч в направлении О.Дюмона[26](Опава)..."
				},
				{
					"owner": 2,
					"mes": "Оливье Дюмон[26](Опава) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 707
					},
					{
						"n": 2,
						"h": 330,
						"w": 470
					},
					{
						"n": 3,
						"h": 268,
						"w": 457
					},
					{
						"n": 4,
						"h": 208,
						"w": 470
					},
					{
						"n": 5,
						"h": 154,
						"w": 467
					},
					{
						"n": 6,
						"h": 386,
						"w": 445
					},
					{
						"n": 7,
						"h": 259,
						"w": 379
					},
					{
						"n": 8,
						"h": 204,
						"w": 398
					},
					{
						"n": 17,
						"h": 59,
						"w": 433
					},
					{
						"n": 10,
						"h": 314,
						"w": 272
					},
					{
						"n": 11,
						"h": 129,
						"w": 270
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 702
					},
					{
						"n": 13,
						"h": 394,
						"w": 454
					},
					{
						"n": 3,
						"h": 283,
						"w": 602
					},
					{
						"n": 14,
						"h": 178,
						"w": 599
					},
					{
						"n": 5,
						"h": 73,
						"w": 507
					},
					{
						"n": 6,
						"h": 169,
						"w": 505
					},
					{
						"n": 7,
						"h": 233,
						"w": 371
					},
					{
						"n": 8,
						"h": 49,
						"w": 300
					},
					{
						"n": 17,
						"h": 400,
						"w": 280
					},
					{
						"n": 19,
						"h": 292,
						"w": 298
					},
					{
						"n": 11,
						"h": 225,
						"w": 307
					}
				],
				"ball": {
					"n": 0,
					"h": 281,
					"w": 215,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 41
		},
		{
			"num": 1039,
			"minute": 50,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 702
					},
					{
						"n": 2,
						"h": 363,
						"w": 471
					},
					{
						"n": 3,
						"h": 240,
						"w": 487
					},
					{
						"n": 4,
						"h": 187,
						"w": 484
					},
					{
						"n": 5,
						"h": 123,
						"w": 492
					},
					{
						"n": 6,
						"h": 397,
						"w": 406
					},
					{
						"n": 7,
						"h": 238,
						"w": 413
					},
					{
						"n": 8,
						"h": 176,
						"w": 422
					},
					{
						"n": 17,
						"h": 56,
						"w": 469
					},
					{
						"n": 10,
						"h": 316,
						"w": 312
					},
					{
						"n": 11,
						"h": 169,
						"w": 270
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 707
					},
					{
						"n": 13,
						"h": 407,
						"w": 416
					},
					{
						"n": 3,
						"h": 281,
						"w": 573
					},
					{
						"n": 14,
						"h": 170,
						"w": 579
					},
					{
						"n": 5,
						"h": 68,
						"w": 547
					},
					{
						"n": 6,
						"h": 183,
						"w": 473
					},
					{
						"n": 7,
						"h": 224,
						"w": 347
					},
					{
						"n": 8,
						"h": 57,
						"w": 269
					},
					{
						"n": 17,
						"h": 414,
						"w": 266
					},
					{
						"n": 19,
						"h": 281,
						"w": 260
					},
					{
						"n": 11,
						"h": 211,
						"w": 269
					}
				],
				"ball": {
					"n": 0,
					"h": 267,
					"w": 247,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1040,
			"minute": 50,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 708
					},
					{
						"n": 2,
						"h": 383,
						"w": 505
					},
					{
						"n": 3,
						"h": 227,
						"w": 510
					},
					{
						"n": 4,
						"h": 167,
						"w": 518
					},
					{
						"n": 5,
						"h": 120,
						"w": 507
					},
					{
						"n": 6,
						"h": 404,
						"w": 412
					},
					{
						"n": 7,
						"h": 237,
						"w": 445
					},
					{
						"n": 8,
						"h": 191,
						"w": 443
					},
					{
						"n": 17,
						"h": 62,
						"w": 497
					},
					{
						"n": 10,
						"h": 277,
						"w": 303
					},
					{
						"n": 11,
						"h": 166,
						"w": 270
					}
				],
				"away": [
					{
						"n": 1,
						"h": 228,
						"w": 691
					},
					{
						"n": 13,
						"h": 395,
						"w": 395
					},
					{
						"n": 3,
						"h": 284,
						"w": 545
					},
					{
						"n": 14,
						"h": 174,
						"w": 546
					},
					{
						"n": 5,
						"h": 75,
						"w": 548
					},
					{
						"n": 6,
						"h": 178,
						"w": 438
					},
					{
						"n": 7,
						"h": 216,
						"w": 307
					},
					{
						"n": 8,
						"h": 49,
						"w": 230
					},
					{
						"n": 17,
						"h": 403,
						"w": 227
					},
					{
						"n": 19,
						"h": 300,
						"w": 225
					},
					{
						"n": 11,
						"h": 225,
						"w": 232
					}
				],
				"ball": {
					"n": 0,
					"h": 272,
					"w": 282,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1041,
			"minute": 50,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 706
					},
					{
						"n": 2,
						"h": 371,
						"w": 525
					},
					{
						"n": 3,
						"h": 242,
						"w": 537
					},
					{
						"n": 4,
						"h": 186,
						"w": 541
					},
					{
						"n": 5,
						"h": 96,
						"w": 516
					},
					{
						"n": 6,
						"h": 394,
						"w": 429
					},
					{
						"n": 7,
						"h": 250,
						"w": 475
					},
					{
						"n": 8,
						"h": 224,
						"w": 463
					},
					{
						"n": 17,
						"h": 46,
						"w": 461
					},
					{
						"n": 10,
						"h": 238,
						"w": 311
					},
					{
						"n": 11,
						"h": 129,
						"w": 270
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 675
					},
					{
						"n": 13,
						"h": 407,
						"w": 392
					},
					{
						"n": 3,
						"h": 278,
						"w": 528
					},
					{
						"n": 14,
						"h": 174,
						"w": 526
					},
					{
						"n": 5,
						"h": 64,
						"w": 523
					},
					{
						"n": 6,
						"h": 212,
						"w": 429
					},
					{
						"n": 7,
						"h": 229,
						"w": 270
					},
					{
						"n": 8,
						"h": 49,
						"w": 215
					},
					{
						"n": 17,
						"h": 363,
						"w": 224
					},
					{
						"n": 19,
						"h": 280,
						"w": 216
					},
					{
						"n": 11,
						"h": 205,
						"w": 223
					}
				],
				"ball": {
					"n": 0,
					"h": 238,
					"w": 291,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1042,
			"minute": 50,
			"messages": [
				{
					"owner": 2,
					"mes": "Передача вперед..."
				},
				{
					"owner": 2,
					"mes": "Джо Квигли[10](Галвэй Юнайтед) читает комбинацию и перехватывает мяч!..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 706
					},
					{
						"n": 2,
						"h": 371,
						"w": 530
					},
					{
						"n": 3,
						"h": 241,
						"w": 542
					},
					{
						"n": 4,
						"h": 185,
						"w": 546
					},
					{
						"n": 5,
						"h": 93,
						"w": 520
					},
					{
						"n": 6,
						"h": 394,
						"w": 429
					},
					{
						"n": 7,
						"h": 245,
						"w": 474
					},
					{
						"n": 8,
						"h": 219,
						"w": 465
					},
					{
						"n": 17,
						"h": 51,
						"w": 460
					},
					{
						"n": 10,
						"h": 236,
						"w": 306
					},
					{
						"n": 11,
						"h": 134,
						"w": 270
					}
				],
				"away": [
					{
						"n": 1,
						"h": 221,
						"w": 670
					},
					{
						"n": 13,
						"h": 408,
						"w": 387
					},
					{
						"n": 3,
						"h": 278,
						"w": 523
					},
					{
						"n": 14,
						"h": 176,
						"w": 521
					},
					{
						"n": 5,
						"h": 64,
						"w": 518
					},
					{
						"n": 6,
						"h": 212,
						"w": 429,
						"m": 660
					},
					{
						"n": 7,
						"h": 229,
						"w": 274
					},
					{
						"n": 8,
						"h": 49,
						"w": 210
					},
					{
						"n": 17,
						"h": 366,
						"w": 220
					},
					{
						"n": 19,
						"h": 280,
						"w": 211
					},
					{
						"n": 11,
						"h": 206,
						"w": 218
					}
				],
				"ball": {
					"n": 0,
					"h": 236,
					"w": 306,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 5
		},
		{
			"num": 1043,
			"minute": 50,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 701
					},
					{
						"n": 2,
						"h": 374,
						"w": 490
					},
					{
						"n": 3,
						"h": 267,
						"w": 512
					},
					{
						"n": 4,
						"h": 171,
						"w": 509
					},
					{
						"n": 5,
						"h": 80,
						"w": 482
					},
					{
						"n": 6,
						"h": 396,
						"w": 404
					},
					{
						"n": 7,
						"h": 273,
						"w": 445
					},
					{
						"n": 8,
						"h": 206,
						"w": 427
					},
					{
						"n": 17,
						"h": 47,
						"w": 421
					},
					{
						"n": 10,
						"h": 201,
						"w": 306,
						"m": 740
					},
					{
						"n": 11,
						"h": 157,
						"w": 237
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 642
					},
					{
						"n": 13,
						"h": 413,
						"w": 427
					},
					{
						"n": 3,
						"h": 289,
						"w": 549
					},
					{
						"n": 14,
						"h": 212,
						"w": 539
					},
					{
						"n": 5,
						"h": 95,
						"w": 542
					},
					{
						"n": 6,
						"h": 247,
						"w": 431
					},
					{
						"n": 7,
						"h": 230,
						"w": 294
					},
					{
						"n": 8,
						"h": 44,
						"w": 249
					},
					{
						"n": 17,
						"h": 376,
						"w": 259
					},
					{
						"n": 19,
						"h": 267,
						"w": 249
					},
					{
						"n": 11,
						"h": 192,
						"w": 255
					}
				],
				"ball": {
					"n": 0,
					"h": 201,
					"w": 306,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1044,
			"minute": 50,
			"messages": [
				{
					"owner": 1,
					"mes": "Джо Квигли[10](Галвэй Юнайтед) пасует К.Колману[06](Галвэй Юнайтед)..."
				},
				{
					"owner": 1,
					"mes": "Киэн Колман[06](Галвэй Юнайтед) сбрасывает мяч себе на ход..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 703
					},
					{
						"n": 2,
						"h": 391,
						"w": 444
					},
					{
						"n": 3,
						"h": 267,
						"w": 481
					},
					{
						"n": 4,
						"h": 168,
						"w": 496
					},
					{
						"n": 5,
						"h": 63,
						"w": 443
					},
					{
						"n": 6,
						"h": 401,
						"w": 350
					},
					{
						"n": 7,
						"h": 290,
						"w": 393
					},
					{
						"n": 8,
						"h": 181,
						"w": 393
					},
					{
						"n": 17,
						"h": 45,
						"w": 366
					},
					{
						"n": 10,
						"h": 208,
						"w": 299
					},
					{
						"n": 11,
						"h": 153,
						"w": 202
					}
				],
				"away": [
					{
						"n": 1,
						"h": 205,
						"w": 644
					},
					{
						"n": 13,
						"h": 405,
						"w": 390
					},
					{
						"n": 3,
						"h": 282,
						"w": 557
					},
					{
						"n": 14,
						"h": 241,
						"w": 558
					},
					{
						"n": 5,
						"h": 88,
						"w": 488
					},
					{
						"n": 6,
						"h": 271,
						"w": 481
					},
					{
						"n": 7,
						"h": 226,
						"w": 321
					},
					{
						"n": 8,
						"h": 42,
						"w": 304
					},
					{
						"n": 17,
						"h": 387,
						"w": 313
					},
					{
						"n": 19,
						"h": 268,
						"w": 304
					},
					{
						"n": 11,
						"h": 174,
						"w": 307
					}
				],
				"ball": {
					"n": 0,
					"h": 401,
					"w": 350,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 55
		},
		{
			"num": 1045,
			"minute": 50,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 703
					},
					{
						"n": 2,
						"h": 380,
						"w": 434
					},
					{
						"n": 3,
						"h": 265,
						"w": 476
					},
					{
						"n": 4,
						"h": 170,
						"w": 470
					},
					{
						"n": 5,
						"h": 65,
						"w": 434
					},
					{
						"n": 6,
						"h": 419,
						"w": 319
					},
					{
						"n": 7,
						"h": 291,
						"w": 353
					},
					{
						"n": 8,
						"h": 215,
						"w": 380
					},
					{
						"n": 17,
						"h": 43,
						"w": 326
					},
					{
						"n": 10,
						"h": 228,
						"w": 264
					},
					{
						"n": 11,
						"h": 164,
						"w": 164
					}
				],
				"away": [
					{
						"n": 1,
						"h": 205,
						"w": 648
					},
					{
						"n": 13,
						"h": 406,
						"w": 430
					},
					{
						"n": 3,
						"h": 276,
						"w": 550
					},
					{
						"n": 14,
						"h": 225,
						"w": 546
					},
					{
						"n": 5,
						"h": 71,
						"w": 451
					},
					{
						"n": 6,
						"h": 236,
						"w": 499
					},
					{
						"n": 7,
						"h": 223,
						"w": 341
					},
					{
						"n": 8,
						"h": 39,
						"w": 344
					},
					{
						"n": 17,
						"h": 393,
						"w": 332
					},
					{
						"n": 19,
						"h": 248,
						"w": 338
					},
					{
						"n": 11,
						"h": 167,
						"w": 346
					}
				],
				"ball": {
					"n": 0,
					"h": 419,
					"w": 319,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1046,
			"minute": 50,
			"messages": [
				{
					"owner": 1,
					"mes": "Пасует А.Хлинссону[07](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 709
					},
					{
						"n": 2,
						"h": 390,
						"w": 401
					},
					{
						"n": 3,
						"h": 279,
						"w": 462
					},
					{
						"n": 4,
						"h": 166,
						"w": 460
					},
					{
						"n": 5,
						"h": 71,
						"w": 413
					},
					{
						"n": 6,
						"h": 412,
						"w": 285
					},
					{
						"n": 7,
						"h": 315,
						"w": 333
					},
					{
						"n": 8,
						"h": 203,
						"w": 347
					},
					{
						"n": 17,
						"h": 48,
						"w": 291
					},
					{
						"n": 10,
						"h": 248,
						"w": 235
					},
					{
						"n": 11,
						"h": 156,
						"w": 162
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 643
					},
					{
						"n": 13,
						"h": 402,
						"w": 465
					},
					{
						"n": 3,
						"h": 284,
						"w": 574
					},
					{
						"n": 14,
						"h": 206,
						"w": 575
					},
					{
						"n": 5,
						"h": 91,
						"w": 480
					},
					{
						"n": 6,
						"h": 205,
						"w": 515
					},
					{
						"n": 7,
						"h": 226,
						"w": 376
					},
					{
						"n": 8,
						"h": 41,
						"w": 379
					},
					{
						"n": 17,
						"h": 396,
						"w": 346
					},
					{
						"n": 19,
						"h": 273,
						"w": 362
					},
					{
						"n": 11,
						"h": 147,
						"w": 369
					}
				],
				"ball": {
					"n": 0,
					"h": 315,
					"w": 333,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 35
		},
		{
			"num": 1047,
			"minute": 50,
			"messages": [
				{
					"owner": 1,
					"mes": "Агуст Хлинссон[07](Галвэй Юнайтед) отправляет мяч налево К.Колману[06](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 704
					},
					{
						"n": 2,
						"h": 372,
						"w": 385
					},
					{
						"n": 3,
						"h": 268,
						"w": 435
					},
					{
						"n": 4,
						"h": 172,
						"w": 439
					},
					{
						"n": 5,
						"h": 63,
						"w": 392
					},
					{
						"n": 6,
						"h": 418,
						"w": 249
					},
					{
						"n": 7,
						"h": 313,
						"w": 323
					},
					{
						"n": 8,
						"h": 191,
						"w": 339
					},
					{
						"n": 17,
						"h": 44,
						"w": 247
					},
					{
						"n": 10,
						"h": 266,
						"w": 196
					},
					{
						"n": 11,
						"h": 156,
						"w": 140
					}
				],
				"away": [
					{
						"n": 1,
						"h": 205,
						"w": 642
					},
					{
						"n": 13,
						"h": 406,
						"w": 509
					},
					{
						"n": 3,
						"h": 274,
						"w": 609
					},
					{
						"n": 14,
						"h": 203,
						"w": 600
					},
					{
						"n": 5,
						"h": 57,
						"w": 491
					},
					{
						"n": 6,
						"h": 184,
						"w": 539
					},
					{
						"n": 7,
						"h": 222,
						"w": 420
					},
					{
						"n": 8,
						"h": 41,
						"w": 403
					},
					{
						"n": 17,
						"h": 401,
						"w": 390
					},
					{
						"n": 19,
						"h": 259,
						"w": 401
					},
					{
						"n": 11,
						"h": 164,
						"w": 409
					}
				],
				"ball": {
					"n": 0,
					"h": 418,
					"w": 249,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 44
		},
		{
			"num": 1048,
			"minute": 50,
			"messages": [
				{
					"owner": 1,
					"mes": "Т.Прохазка[25](Опава) вступает в единоборство с К.Колманом[06](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 708
					},
					{
						"n": 2,
						"h": 381,
						"w": 365
					},
					{
						"n": 3,
						"h": 269,
						"w": 426
					},
					{
						"n": 4,
						"h": 168,
						"w": 417
					},
					{
						"n": 5,
						"h": 64,
						"w": 370
					},
					{
						"n": 6,
						"h": 418,
						"w": 230
					},
					{
						"n": 7,
						"h": 310,
						"w": 302
					},
					{
						"n": 8,
						"h": 205,
						"w": 322
					},
					{
						"n": 17,
						"h": 42,
						"w": 225
					},
					{
						"n": 10,
						"h": 274,
						"w": 175
					},
					{
						"n": 11,
						"h": 169,
						"w": 122
					}
				],
				"away": [
					{
						"n": 1,
						"h": 205,
						"w": 648
					},
					{
						"n": 13,
						"h": 406,
						"w": 531
					},
					{
						"n": 3,
						"h": 271,
						"w": 626
					},
					{
						"n": 14,
						"h": 195,
						"w": 611
					},
					{
						"n": 5,
						"h": 35,
						"w": 492
					},
					{
						"n": 6,
						"h": 180,
						"w": 561
					},
					{
						"n": 7,
						"h": 220,
						"w": 442
					},
					{
						"n": 8,
						"h": 41,
						"w": 405
					},
					{
						"n": 17,
						"h": 409,
						"w": 410
					},
					{
						"n": 19,
						"h": 245,
						"w": 418
					},
					{
						"n": 11,
						"h": 150,
						"w": 427
					}
				],
				"ball": {
					"n": 0,
					"h": 418,
					"w": 230,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 22
		},
		{
			"num": 1049,
			"minute": 50,
			"messages": [
				{
					"owner": 1,
					"mes": "Киэн Колман[06](Галвэй Юнайтед) на рывке уходит от Т.Прохазки[25](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 709
					},
					{
						"n": 2,
						"h": 383,
						"w": 361
					},
					{
						"n": 3,
						"h": 275,
						"w": 407
					},
					{
						"n": 4,
						"h": 166,
						"w": 397
					},
					{
						"n": 5,
						"h": 63,
						"w": 364
					},
					{
						"n": 6,
						"h": 418,
						"w": 200
					},
					{
						"n": 7,
						"h": 304,
						"w": 282
					},
					{
						"n": 8,
						"h": 207,
						"w": 302
					},
					{
						"n": 17,
						"h": 41,
						"w": 205
					},
					{
						"n": 10,
						"h": 281,
						"w": 156
					},
					{
						"n": 11,
						"h": 169,
						"w": 102
					}
				],
				"away": [
					{
						"n": 1,
						"h": 208,
						"w": 668
					},
					{
						"n": 13,
						"h": 406,
						"w": 551
					},
					{
						"n": 3,
						"h": 263,
						"w": 641
					},
					{
						"n": 14,
						"h": 189,
						"w": 630
					},
					{
						"n": 5,
						"h": 35,
						"w": 504
					},
					{
						"n": 6,
						"h": 169,
						"w": 578
					},
					{
						"n": 7,
						"h": 215,
						"w": 461
					},
					{
						"n": 8,
						"h": 42,
						"w": 425
					},
					{
						"n": 17,
						"h": 405,
						"w": 430
					},
					{
						"n": 19,
						"h": 243,
						"w": 438
					},
					{
						"n": 11,
						"h": 147,
						"w": 446
					}
				],
				"ball": {
					"n": 0,
					"h": 418,
					"w": 170,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 20
		},
		{
			"num": 1050,
			"minute": 50,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 706
					},
					{
						"n": 2,
						"h": 382,
						"w": 345
					},
					{
						"n": 3,
						"h": 267,
						"w": 400
					},
					{
						"n": 4,
						"h": 182,
						"w": 410
					},
					{
						"n": 5,
						"h": 66,
						"w": 344
					},
					{
						"n": 6,
						"h": 418,
						"w": 170
					},
					{
						"n": 7,
						"h": 301,
						"w": 263
					},
					{
						"n": 8,
						"h": 208,
						"w": 282
					},
					{
						"n": 17,
						"h": 43,
						"w": 185
					},
					{
						"n": 10,
						"h": 279,
						"w": 137
					},
					{
						"n": 11,
						"h": 157,
						"w": 86
					}
				],
				"away": [
					{
						"n": 1,
						"h": 192,
						"w": 680
					},
					{
						"n": 13,
						"h": 406,
						"w": 571
					},
					{
						"n": 3,
						"h": 274,
						"w": 657
					},
					{
						"n": 14,
						"h": 191,
						"w": 650
					},
					{
						"n": 5,
						"h": 35,
						"w": 516
					},
					{
						"n": 6,
						"h": 171,
						"w": 597
					},
					{
						"n": 7,
						"h": 212,
						"w": 481
					},
					{
						"n": 8,
						"h": 43,
						"w": 445
					},
					{
						"n": 17,
						"h": 408,
						"w": 450
					},
					{
						"n": 19,
						"h": 242,
						"w": 458
					},
					{
						"n": 11,
						"h": 148,
						"w": 466
					}
				],
				"ball": {
					"n": 0,
					"h": 418,
					"w": 170,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 20
		},
		{
			"num": 1051,
			"minute": 50,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 704
					},
					{
						"n": 2,
						"h": 373,
						"w": 340
					},
					{
						"n": 3,
						"h": 265,
						"w": 394
					},
					{
						"n": 4,
						"h": 175,
						"w": 398
					},
					{
						"n": 5,
						"h": 73,
						"w": 352
					},
					{
						"n": 6,
						"h": 389,
						"w": 142,
						"m": 710
					},
					{
						"n": 7,
						"h": 299,
						"w": 223
					},
					{
						"n": 8,
						"h": 207,
						"w": 242
					},
					{
						"n": 17,
						"h": 48,
						"w": 146
					},
					{
						"n": 10,
						"h": 277,
						"w": 97
					},
					{
						"n": 11,
						"h": 162,
						"w": 92
					}
				],
				"away": [
					{
						"n": 1,
						"h": 195,
						"w": 694
					},
					{
						"n": 13,
						"h": 402,
						"w": 610
					},
					{
						"n": 3,
						"h": 270,
						"w": 655
					},
					{
						"n": 14,
						"h": 187,
						"w": 643
					},
					{
						"n": 5,
						"h": 50,
						"w": 559,
						"m": 660
					},
					{
						"n": 6,
						"h": 150,
						"w": 583
					},
					{
						"n": 7,
						"h": 210,
						"w": 521
					},
					{
						"n": 8,
						"h": 47,
						"w": 465
					},
					{
						"n": 17,
						"h": 405,
						"w": 490
					},
					{
						"n": 19,
						"h": 271,
						"w": 430
					},
					{
						"n": 11,
						"h": 156,
						"w": 427
					}
				],
				"ball": {
					"n": 0,
					"h": 389,
					"w": 142,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1052,
			"minute": 50,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 702
					},
					{
						"n": 2,
						"h": 378,
						"w": 348
					},
					{
						"n": 3,
						"h": 268,
						"w": 396
					},
					{
						"n": 4,
						"h": 175,
						"w": 390
					},
					{
						"n": 5,
						"h": 62,
						"w": 355
					},
					{
						"n": 6,
						"h": 360,
						"w": 114
					},
					{
						"n": 7,
						"h": 311,
						"w": 184
					},
					{
						"n": 8,
						"h": 214,
						"w": 274
					},
					{
						"n": 17,
						"h": 39,
						"w": 112
					},
					{
						"n": 10,
						"h": 243,
						"w": 76
					},
					{
						"n": 11,
						"h": 201,
						"w": 85
					}
				],
				"away": [
					{
						"n": 1,
						"h": 214,
						"w": 710
					},
					{
						"n": 13,
						"h": 406,
						"w": 644
					},
					{
						"n": 3,
						"h": 253,
						"w": 649
					},
					{
						"n": 14,
						"h": 202,
						"w": 671
					},
					{
						"n": 5,
						"h": 85,
						"w": 588
					},
					{
						"n": 6,
						"h": 151,
						"w": 608
					},
					{
						"n": 7,
						"h": 196,
						"w": 552
					},
					{
						"n": 8,
						"h": 42,
						"w": 484
					},
					{
						"n": 17,
						"h": 413,
						"w": 513
					},
					{
						"n": 19,
						"h": 243,
						"w": 459
					},
					{
						"n": 11,
						"h": 175,
						"w": 413
					}
				],
				"ball": {
					"n": 0,
					"h": 360,
					"w": 114,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1053,
			"minute": 50,
			"messages": [
				{
					"owner": 1,
					"mes": "Киэн Колман[06](Галвэй Юнайтед) уходит в центр..."
				},
				{
					"owner": 1,
					"mes": "Киэн Колман[06](Галвэй Юнайтед) врывается в штрафную... Режет угол..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 710
					},
					{
						"n": 2,
						"h": 385,
						"w": 350
					},
					{
						"n": 3,
						"h": 271,
						"w": 399
					},
					{
						"n": 4,
						"h": 185,
						"w": 401
					},
					{
						"n": 5,
						"h": 74,
						"w": 356
					},
					{
						"n": 6,
						"h": 317,
						"w": 97
					},
					{
						"n": 7,
						"h": 300,
						"w": 151
					},
					{
						"n": 8,
						"h": 203,
						"w": 236
					},
					{
						"n": 17,
						"h": 51,
						"w": 96
					},
					{
						"n": 10,
						"h": 281,
						"w": 66
					},
					{
						"n": 11,
						"h": 169,
						"w": 61
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 709
					},
					{
						"n": 13,
						"h": 399,
						"w": 660
					},
					{
						"n": 3,
						"h": 270,
						"w": 679
					},
					{
						"n": 14,
						"h": 187,
						"w": 679
					},
					{
						"n": 5,
						"h": 116,
						"w": 622
					},
					{
						"n": 6,
						"h": 138,
						"w": 644
					},
					{
						"n": 7,
						"h": 168,
						"w": 581
					},
					{
						"n": 8,
						"h": 42,
						"w": 524
					},
					{
						"n": 17,
						"h": 418,
						"w": 528
					},
					{
						"n": 19,
						"h": 247,
						"w": 498
					},
					{
						"n": 11,
						"h": 175,
						"w": 421
					}
				],
				"ball": {
					"n": 0,
					"h": 317,
					"w": 97,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1054,
			"minute": 50,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 705
					},
					{
						"n": 2,
						"h": 383,
						"w": 351
					},
					{
						"n": 3,
						"h": 275,
						"w": 400
					},
					{
						"n": 4,
						"h": 180,
						"w": 398
					},
					{
						"n": 5,
						"h": 68,
						"w": 356
					},
					{
						"n": 6,
						"h": 316,
						"w": 91
					},
					{
						"n": 7,
						"h": 298,
						"w": 145
					},
					{
						"n": 8,
						"h": 199,
						"w": 240
					},
					{
						"n": 17,
						"h": 48,
						"w": 91
					},
					{
						"n": 10,
						"h": 285,
						"w": 62
					},
					{
						"n": 11,
						"h": 165,
						"w": 57
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 709
					},
					{
						"n": 13,
						"h": 399,
						"w": 660
					},
					{
						"n": 3,
						"h": 268,
						"w": 673
					},
					{
						"n": 14,
						"h": 183,
						"w": 675
					},
					{
						"n": 5,
						"h": 117,
						"w": 621
					},
					{
						"n": 6,
						"h": 136,
						"w": 638
					},
					{
						"n": 7,
						"h": 164,
						"w": 585
					},
					{
						"n": 8,
						"h": 42,
						"w": 524
					},
					{
						"n": 17,
						"h": 424,
						"w": 528
					},
					{
						"n": 19,
						"h": 247,
						"w": 504
					},
					{
						"n": 11,
						"h": 170,
						"w": 419
					}
				],
				"ball": {
					"n": 0,
					"h": 316,
					"w": 91,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 6
		},
		{
			"num": 1055,
			"minute": 50,
			"messages": [
				{
					"owner": 1,
					"mes": "О.Дюмон[26](Опава) вступает в единоборство с К.Колманом[06](Галвэй Юнайтед)..."
				},
				{
					"owner": 1,
					"mes": "Оливье Дюмон[26](Опава) выбивает мяч у К.Колмана[06](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 705
					},
					{
						"n": 2,
						"h": 383,
						"w": 351
					},
					{
						"n": 3,
						"h": 275,
						"w": 400
					},
					{
						"n": 4,
						"h": 176,
						"w": 395
					},
					{
						"n": 5,
						"h": 63,
						"w": 355
					},
					{
						"n": 6,
						"h": 315,
						"w": 81,
						"m": 700
					},
					{
						"n": 7,
						"h": 296,
						"w": 141
					},
					{
						"n": 8,
						"h": 196,
						"w": 244
					},
					{
						"n": 17,
						"h": 45,
						"w": 87
					},
					{
						"n": 10,
						"h": 289,
						"w": 58
					},
					{
						"n": 11,
						"h": 162,
						"w": 53
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 709
					},
					{
						"n": 13,
						"h": 399,
						"w": 660
					},
					{
						"n": 3,
						"h": 266,
						"w": 670
					},
					{
						"n": 14,
						"h": 183,
						"w": 675
					},
					{
						"n": 5,
						"h": 122,
						"w": 620
					},
					{
						"n": 6,
						"h": 135,
						"w": 634,
						"m": 670
					},
					{
						"n": 7,
						"h": 161,
						"w": 589
					},
					{
						"n": 8,
						"h": 42,
						"w": 524
					},
					{
						"n": 17,
						"h": 429,
						"w": 529
					},
					{
						"n": 19,
						"h": 247,
						"w": 504
					},
					{
						"n": 11,
						"h": 170,
						"w": 419
					}
				],
				"ball": {
					"n": 0,
					"h": 315,
					"w": 86,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 4
				}
			},
			"interval": 5
		},
		{
			"num": 1056,
			"minute": 50,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 705
					},
					{
						"n": 2,
						"h": 383,
						"w": 351
					},
					{
						"n": 3,
						"h": 275,
						"w": 400
					},
					{
						"n": 4,
						"h": 172,
						"w": 393
					},
					{
						"n": 5,
						"h": 59,
						"w": 355
					},
					{
						"n": 6,
						"h": 315,
						"w": 81
					},
					{
						"n": 7,
						"h": 292,
						"w": 131
					},
					{
						"n": 8,
						"h": 189,
						"w": 252
					},
					{
						"n": 17,
						"h": 41,
						"w": 81
					},
					{
						"n": 10,
						"h": 296,
						"w": 51
					},
					{
						"n": 11,
						"h": 156,
						"w": 44
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 709
					},
					{
						"n": 13,
						"h": 399,
						"w": 660
					},
					{
						"n": 3,
						"h": 266,
						"w": 670
					},
					{
						"n": 14,
						"h": 183,
						"w": 675
					},
					{
						"n": 5,
						"h": 133,
						"w": 618
					},
					{
						"n": 6,
						"h": 133,
						"w": 624
					},
					{
						"n": 7,
						"h": 155,
						"w": 597
					},
					{
						"n": 8,
						"h": 42,
						"w": 525
					},
					{
						"n": 17,
						"h": 430,
						"w": 529
					},
					{
						"n": 19,
						"h": 247,
						"w": 504
					},
					{
						"n": 11,
						"h": 170,
						"w": 419
					}
				],
				"ball": {
					"n": 0,
					"h": 317,
					"w": 96,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 10
		},
		{
			"num": 1057,
			"minute": 51,
			"possession": 44,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 702
					},
					{
						"n": 2,
						"h": 358,
						"w": 382,
						"f": 86,
						"m": 650
					},
					{
						"n": 3,
						"h": 292,
						"w": 418,
						"m": 670
					},
					{
						"n": 4,
						"h": 211,
						"w": 400
					},
					{
						"n": 5,
						"h": 91,
						"w": 379,
						"f": 86
					},
					{
						"n": 6,
						"h": 322,
						"w": 88
					},
					{
						"n": 7,
						"h": 293,
						"w": 171
					},
					{
						"n": 8,
						"h": 192,
						"w": 292,
						"f": 84,
						"c": 2
					},
					{
						"n": 17,
						"h": 45,
						"w": 121
					},
					{
						"n": 10,
						"h": 290,
						"w": 91
					},
					{
						"n": 11,
						"h": 153,
						"w": 84,
						"f": 85
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 702
					},
					{
						"n": 13,
						"h": 402,
						"w": 620,
						"f": 96
					},
					{
						"n": 3,
						"h": 276,
						"w": 631
					},
					{
						"n": 14,
						"h": 180,
						"w": 635,
						"f": 95
					},
					{
						"n": 5,
						"h": 93,
						"w": 614,
						"f": 85
					},
					{
						"n": 6,
						"h": 98,
						"w": 624
					},
					{
						"n": 7,
						"h": 167,
						"w": 559,
						"f": 87
					},
					{
						"n": 8,
						"h": 41,
						"w": 485
					},
					{
						"n": 17,
						"h": 417,
						"w": 491,
						"f": 95
					},
					{
						"n": 19,
						"h": 260,
						"w": 466
					},
					{
						"n": 11,
						"h": 156,
						"w": 382
					}
				],
				"ball": {
					"n": 0,
					"h": 352,
					"w": 96,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1058,
			"minute": 51,
			"messages": [
				{
					"owner": 2,
					"mes": "Оливье Дюмон[26](Опава) отправляет мяч на Т.Прохазку[25](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 705
					},
					{
						"n": 2,
						"h": 350,
						"w": 401
					},
					{
						"n": 3,
						"h": 297,
						"w": 436
					},
					{
						"n": 4,
						"h": 215,
						"w": 420
					},
					{
						"n": 5,
						"h": 100,
						"w": 397
					},
					{
						"n": 6,
						"h": 335,
						"w": 103
					},
					{
						"n": 7,
						"h": 310,
						"w": 161
					},
					{
						"n": 8,
						"h": 200,
						"w": 310
					},
					{
						"n": 17,
						"h": 43,
						"w": 141
					},
					{
						"n": 10,
						"h": 296,
						"w": 110
					},
					{
						"n": 11,
						"h": 153,
						"w": 104
					}
				],
				"away": [
					{
						"n": 1,
						"h": 221,
						"w": 706
					},
					{
						"n": 13,
						"h": 403,
						"w": 600
					},
					{
						"n": 3,
						"h": 276,
						"w": 631
					},
					{
						"n": 14,
						"h": 180,
						"w": 635
					},
					{
						"n": 5,
						"h": 99,
						"w": 603
					},
					{
						"n": 6,
						"h": 107,
						"w": 619,
						"m": 680
					},
					{
						"n": 7,
						"h": 174,
						"w": 540
					},
					{
						"n": 8,
						"h": 41,
						"w": 465
					},
					{
						"n": 17,
						"h": 415,
						"w": 471
					},
					{
						"n": 19,
						"h": 265,
						"w": 447
					},
					{
						"n": 11,
						"h": 155,
						"w": 362
					}
				],
				"ball": {
					"n": 0,
					"h": 351,
					"w": 117,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 20
		},
		{
			"num": 1059,
			"minute": 51,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 709
					},
					{
						"n": 2,
						"h": 337,
						"w": 438
					},
					{
						"n": 3,
						"h": 299,
						"w": 454
					},
					{
						"n": 4,
						"h": 189,
						"w": 440
					},
					{
						"n": 5,
						"h": 117,
						"w": 433
					},
					{
						"n": 6,
						"h": 346,
						"w": 142
					},
					{
						"n": 7,
						"h": 350,
						"w": 168
					},
					{
						"n": 8,
						"h": 187,
						"w": 348
					},
					{
						"n": 17,
						"h": 46,
						"w": 181
					},
					{
						"n": 10,
						"h": 300,
						"w": 150
					},
					{
						"n": 11,
						"h": 148,
						"w": 144
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 705
					},
					{
						"n": 13,
						"h": 399,
						"w": 560
					},
					{
						"n": 3,
						"h": 285,
						"w": 620
					},
					{
						"n": 14,
						"h": 182,
						"w": 615
					},
					{
						"n": 5,
						"h": 82,
						"w": 572
					},
					{
						"n": 6,
						"h": 139,
						"w": 596
					},
					{
						"n": 7,
						"h": 183,
						"w": 501
					},
					{
						"n": 8,
						"h": 45,
						"w": 425
					},
					{
						"n": 17,
						"h": 415,
						"w": 431
					},
					{
						"n": 19,
						"h": 271,
						"w": 408
					},
					{
						"n": 11,
						"h": 141,
						"w": 324
					}
				],
				"ball": {
					"n": 0,
					"h": 368,
					"w": 148,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1060,
			"minute": 51,
			"messages": [
				{
					"owner": 2,
					"mes": "Томаш Прохазка[25](Опава) отдает пас на Д.Прохазку[28](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 702
					},
					{
						"n": 2,
						"h": 344,
						"w": 399
					},
					{
						"n": 3,
						"h": 305,
						"w": 455
					},
					{
						"n": 4,
						"h": 187,
						"w": 455
					},
					{
						"n": 5,
						"h": 120,
						"w": 468
					},
					{
						"n": 6,
						"h": 357,
						"w": 180
					},
					{
						"n": 7,
						"h": 340,
						"w": 207
					},
					{
						"n": 8,
						"h": 180,
						"w": 387
					},
					{
						"n": 17,
						"h": 48,
						"w": 221
					},
					{
						"n": 10,
						"h": 295,
						"w": 189
					},
					{
						"n": 11,
						"h": 148,
						"w": 184
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 710
					},
					{
						"n": 13,
						"h": 400,
						"w": 520
					},
					{
						"n": 3,
						"h": 278,
						"w": 614
					},
					{
						"n": 14,
						"h": 172,
						"w": 618
					},
					{
						"n": 5,
						"h": 81,
						"w": 582
					},
					{
						"n": 6,
						"h": 165,
						"w": 565
					},
					{
						"n": 7,
						"h": 190,
						"w": 462
					},
					{
						"n": 8,
						"h": 74,
						"w": 452
					},
					{
						"n": 17,
						"h": 414,
						"w": 391
					},
					{
						"n": 19,
						"h": 280,
						"w": 369
					},
					{
						"n": 11,
						"h": 128,
						"w": 286
					}
				],
				"ball": {
					"n": 0,
					"h": 376,
					"w": 268,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1061,
			"minute": 51,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 701
					},
					{
						"n": 2,
						"h": 356,
						"w": 361
					},
					{
						"n": 3,
						"h": 273,
						"w": 474
					},
					{
						"n": 4,
						"h": 167,
						"w": 476
					},
					{
						"n": 5,
						"h": 120,
						"w": 472
					},
					{
						"n": 6,
						"h": 366,
						"w": 219
					},
					{
						"n": 7,
						"h": 338,
						"w": 247
					},
					{
						"n": 8,
						"h": 152,
						"w": 401
					},
					{
						"n": 17,
						"h": 48,
						"w": 261
					},
					{
						"n": 10,
						"h": 283,
						"w": 228
					},
					{
						"n": 11,
						"h": 142,
						"w": 224
					}
				],
				"away": [
					{
						"n": 1,
						"h": 221,
						"w": 708
					},
					{
						"n": 13,
						"h": 398,
						"w": 481
					},
					{
						"n": 3,
						"h": 282,
						"w": 603
					},
					{
						"n": 14,
						"h": 182,
						"w": 596
					},
					{
						"n": 5,
						"h": 69,
						"w": 572
					},
					{
						"n": 6,
						"h": 177,
						"w": 527
					},
					{
						"n": 7,
						"h": 191,
						"w": 422
					},
					{
						"n": 8,
						"h": 74,
						"w": 417
					},
					{
						"n": 17,
						"h": 409,
						"w": 351
					},
					{
						"n": 19,
						"h": 294,
						"w": 331
					},
					{
						"n": 11,
						"h": 167,
						"w": 281
					}
				],
				"ball": {
					"n": 0,
					"h": 376,
					"w": 303,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1062,
			"minute": 51,
			"messages": [
				{
					"owner": 2,
					"mes": "Даниэль Прохазка[28](Опава) пасует М.Манолову[27](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 704
					},
					{
						"n": 2,
						"h": 333,
						"w": 384
					},
					{
						"n": 3,
						"h": 268,
						"w": 467
					},
					{
						"n": 4,
						"h": 182,
						"w": 477
					},
					{
						"n": 5,
						"h": 120,
						"w": 473
					},
					{
						"n": 6,
						"h": 374,
						"w": 250
					},
					{
						"n": 7,
						"h": 323,
						"w": 275
					},
					{
						"n": 8,
						"h": 150,
						"w": 397
					},
					{
						"n": 17,
						"h": 45,
						"w": 293
					},
					{
						"n": 10,
						"h": 275,
						"w": 259
					},
					{
						"n": 11,
						"h": 155,
						"w": 253
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 707
					},
					{
						"n": 13,
						"h": 406,
						"w": 454
					},
					{
						"n": 3,
						"h": 287,
						"w": 586
					},
					{
						"n": 14,
						"h": 182,
						"w": 578
					},
					{
						"n": 5,
						"h": 69,
						"w": 594
					},
					{
						"n": 6,
						"h": 202,
						"w": 508
					},
					{
						"n": 7,
						"h": 169,
						"w": 399
					},
					{
						"n": 8,
						"h": 71,
						"w": 407
					},
					{
						"n": 17,
						"h": 411,
						"w": 319
					},
					{
						"n": 19,
						"h": 300,
						"w": 331
					},
					{
						"n": 11,
						"h": 142,
						"w": 261
					}
				],
				"ball": {
					"n": 0,
					"h": 281,
					"w": 321,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 32
		},
		{
			"num": 1063,
			"minute": 51,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 705
					},
					{
						"n": 2,
						"h": 319,
						"w": 403
					},
					{
						"n": 3,
						"h": 265,
						"w": 480
					},
					{
						"n": 4,
						"h": 184,
						"w": 467
					},
					{
						"n": 5,
						"h": 120,
						"w": 472
					},
					{
						"n": 6,
						"h": 376,
						"w": 274
					},
					{
						"n": 7,
						"h": 311,
						"w": 296
					},
					{
						"n": 8,
						"h": 158,
						"w": 408
					},
					{
						"n": 17,
						"h": 49,
						"w": 316
					},
					{
						"n": 10,
						"h": 266,
						"w": 281
					},
					{
						"n": 11,
						"h": 174,
						"w": 269
					}
				],
				"away": [
					{
						"n": 1,
						"h": 229,
						"w": 701
					},
					{
						"n": 13,
						"h": 410,
						"w": 434
					},
					{
						"n": 3,
						"h": 275,
						"w": 565
					},
					{
						"n": 14,
						"h": 187,
						"w": 584
					},
					{
						"n": 5,
						"h": 67,
						"w": 570
					},
					{
						"n": 6,
						"h": 213,
						"w": 487
					},
					{
						"n": 7,
						"h": 164,
						"w": 378
					},
					{
						"n": 8,
						"h": 66,
						"w": 384
					},
					{
						"n": 17,
						"h": 411,
						"w": 295
					},
					{
						"n": 19,
						"h": 300,
						"w": 340
					},
					{
						"n": 11,
						"h": 148,
						"w": 238
					}
				],
				"ball": {
					"n": 0,
					"h": 286,
					"w": 342,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 2
				}
			},
			"interval": 24
		},
		{
			"num": 1064,
			"minute": 51,
			"messages": [
				{
					"owner": 2,
					"mes": "Мирослав Манолов[27](Опава) отправляет мяч вперед в расчете на Ш.Товарека[31](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 705
					},
					{
						"n": 2,
						"h": 337,
						"w": 446
					},
					{
						"n": 3,
						"h": 277,
						"w": 504
					},
					{
						"n": 4,
						"h": 225,
						"w": 490
					},
					{
						"n": 5,
						"h": 120,
						"w": 504
					},
					{
						"n": 6,
						"h": 381,
						"w": 321
					},
					{
						"n": 7,
						"h": 306,
						"w": 343
					},
					{
						"n": 8,
						"h": 156,
						"w": 455
					},
					{
						"n": 17,
						"h": 49,
						"w": 363
					},
					{
						"n": 10,
						"h": 276,
						"w": 320
					},
					{
						"n": 11,
						"h": 137,
						"w": 270
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 681
					},
					{
						"n": 13,
						"h": 409,
						"w": 387
					},
					{
						"n": 3,
						"h": 269,
						"w": 519
					},
					{
						"n": 14,
						"h": 174,
						"w": 539
					},
					{
						"n": 5,
						"h": 63,
						"w": 523
					},
					{
						"n": 6,
						"h": 222,
						"w": 441
					},
					{
						"n": 7,
						"h": 164,
						"w": 378,
						"m": 540
					},
					{
						"n": 8,
						"h": 57,
						"w": 338
					},
					{
						"n": 17,
						"h": 412,
						"w": 248
					},
					{
						"n": 19,
						"h": 299,
						"w": 293
					},
					{
						"n": 11,
						"h": 151,
						"w": 208
					}
				],
				"ball": {
					"n": 0,
					"h": 299,
					"w": 512,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 47
		},
		{
			"num": 1065,
			"minute": 51,
			"messages": [
				{
					"owner": 2,
					"mes": "Свисток судьи... Ш.Товарек[31](Опава) угодил в офсайд."
				}
			],
			"O": {
				"team": 2,
				"player": 11
			}
		},
		{
			"num": 1066,
			"minute": 52,
			"possession": 44,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 705
					},
					{
						"n": 2,
						"h": 391,
						"w": 486
					},
					{
						"n": 3,
						"h": 303,
						"w": 520
					},
					{
						"n": 4,
						"h": 169,
						"w": 540
					},
					{
						"n": 5,
						"h": 65,
						"w": 525
					},
					{
						"n": 6,
						"h": 393,
						"w": 358,
						"f": 85
					},
					{
						"n": 7,
						"h": 277,
						"w": 358
					},
					{
						"n": 8,
						"h": 164,
						"w": 358
					},
					{
						"n": 17,
						"h": 74,
						"w": 358,
						"f": 97
					},
					{
						"n": 10,
						"h": 277,
						"w": 220,
						"m": 750
					},
					{
						"n": 11,
						"h": 156,
						"w": 172
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 710
					},
					{
						"n": 13,
						"h": 393,
						"w": 449
					},
					{
						"n": 3,
						"h": 277,
						"w": 597,
						"m": 630
					},
					{
						"n": 14,
						"h": 181,
						"w": 586
					},
					{
						"n": 5,
						"h": 62,
						"w": 583,
						"m": 670
					},
					{
						"n": 6,
						"h": 231,
						"w": 497,
						"f": 85
					},
					{
						"n": 7,
						"h": 230,
						"w": 426
					},
					{
						"n": 8,
						"h": 57,
						"w": 398,
						"f": 85
					},
					{
						"n": 17,
						"h": 392,
						"w": 313
					},
					{
						"n": 19,
						"h": 275,
						"w": 231,
						"f": 97
					},
					{
						"n": 11,
						"h": 198,
						"w": 237,
						"f": 84,
						"c": 2
					}
				],
				"ball": {
					"n": 0,
					"h": 299,
					"w": 512,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 100
		},
		{
			"num": 1067,
			"minute": 52,
			"messages": [
				{
					"owner": 1,
					"mes": "Назначен свободный удар..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 700
					},
					{
						"n": 2,
						"h": 386,
						"w": 490
					},
					{
						"n": 3,
						"h": 299,
						"w": 512
					},
					{
						"n": 4,
						"h": 171,
						"w": 547
					},
					{
						"n": 5,
						"h": 60,
						"w": 522
					},
					{
						"n": 6,
						"h": 398,
						"w": 356
					},
					{
						"n": 7,
						"h": 280,
						"w": 358
					},
					{
						"n": 8,
						"h": 162,
						"w": 360
					},
					{
						"n": 17,
						"h": 69,
						"w": 354
					},
					{
						"n": 10,
						"h": 276,
						"w": 222
					},
					{
						"n": 11,
						"h": 153,
						"w": 164
					}
				],
				"away": [
					{
						"n": 1,
						"h": 226,
						"w": 700
					},
					{
						"n": 13,
						"h": 400,
						"w": 443
					},
					{
						"n": 3,
						"h": 281,
						"w": 601
					},
					{
						"n": 14,
						"h": 187,
						"w": 590
					},
					{
						"n": 5,
						"h": 57,
						"w": 588
					},
					{
						"n": 6,
						"h": 227,
						"w": 498
					},
					{
						"n": 7,
						"h": 225,
						"w": 433
					},
					{
						"n": 8,
						"h": 64,
						"w": 401
					},
					{
						"n": 17,
						"h": 398,
						"w": 316
					},
					{
						"n": 19,
						"h": 280,
						"w": 228
					},
					{
						"n": 11,
						"h": 203,
						"w": 230
					}
				],
				"ball": {
					"n": 0,
					"h": 299,
					"w": 512,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 15
		},
		{
			"num": 1068,
			"minute": 52,
			"messages": [
				{
					"owner": 1,
					"mes": "Разыграли свободный удар..."
				},
				{
					"owner": 1,
					"mes": "Пас направо..."
				},
				{
					"owner": 1,
					"mes": "Теперь с мячом Роббе Дриссенс[04](Галвэй Юнайтед)..."
				}
			],
			"F": {
				"team": 1
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 709
					},
					{
						"n": 2,
						"h": 389,
						"w": 467
					},
					{
						"n": 3,
						"h": 276,
						"w": 505
					},
					{
						"n": 4,
						"h": 171,
						"w": 547
					},
					{
						"n": 5,
						"h": 67,
						"w": 479
					},
					{
						"n": 6,
						"h": 397,
						"w": 312
					},
					{
						"n": 7,
						"h": 279,
						"w": 331
					},
					{
						"n": 8,
						"h": 167,
						"w": 403
					},
					{
						"n": 17,
						"h": 63,
						"w": 311
					},
					{
						"n": 10,
						"h": 273,
						"w": 213
					},
					{
						"n": 11,
						"h": 160,
						"w": 199
					}
				],
				"away": [
					{
						"n": 1,
						"h": 233,
						"w": 657
					},
					{
						"n": 13,
						"h": 387,
						"w": 445
					},
					{
						"n": 3,
						"h": 275,
						"w": 557
					},
					{
						"n": 14,
						"h": 194,
						"w": 547
					},
					{
						"n": 5,
						"h": 88,
						"w": 556
					},
					{
						"n": 6,
						"h": 183,
						"w": 500
					},
					{
						"n": 7,
						"h": 228,
						"w": 422
					},
					{
						"n": 8,
						"h": 53,
						"w": 444
					},
					{
						"n": 17,
						"h": 417,
						"w": 355
					},
					{
						"n": 19,
						"h": 292,
						"w": 271
					},
					{
						"n": 11,
						"h": 184,
						"w": 270
					}
				],
				"ball": {
					"n": 0,
					"h": 171,
					"w": 547,
					"z": 0,
					"r": 2,
					"p": 0,
					"x": 0
				}
			},
			"interval": 44
		},
		{
			"num": 1069,
			"minute": 52,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 705
					},
					{
						"n": 2,
						"h": 385,
						"w": 442
					},
					{
						"n": 3,
						"h": 272,
						"w": 491
					},
					{
						"n": 4,
						"h": 186,
						"w": 515
					},
					{
						"n": 5,
						"h": 63,
						"w": 439
					},
					{
						"n": 6,
						"h": 401,
						"w": 273
					},
					{
						"n": 7,
						"h": 282,
						"w": 338
					},
					{
						"n": 8,
						"h": 170,
						"w": 419
					},
					{
						"n": 17,
						"h": 55,
						"w": 272
					},
					{
						"n": 10,
						"h": 289,
						"w": 230
					},
					{
						"n": 11,
						"h": 175,
						"w": 220
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 649
					},
					{
						"n": 13,
						"h": 395,
						"w": 484
					},
					{
						"n": 3,
						"h": 262,
						"w": 525
					},
					{
						"n": 14,
						"h": 173,
						"w": 526
					},
					{
						"n": 5,
						"h": 105,
						"w": 520
					},
					{
						"n": 6,
						"h": 155,
						"w": 472
					},
					{
						"n": 7,
						"h": 216,
						"w": 401
					},
					{
						"n": 8,
						"h": 49,
						"w": 483
					},
					{
						"n": 17,
						"h": 416,
						"w": 369
					},
					{
						"n": 19,
						"h": 300,
						"w": 310
					},
					{
						"n": 11,
						"h": 168,
						"w": 307
					}
				],
				"ball": {
					"n": 0,
					"h": 186,
					"w": 515,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1070,
			"minute": 52,
			"messages": [
				{
					"owner": 1,
					"mes": "Роббе Дриссенс[04](Галвэй Юнайтед) отдает мяч рванувшемуся вперед К.Нолану[08](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 708
					},
					{
						"n": 2,
						"h": 384,
						"w": 464
					},
					{
						"n": 3,
						"h": 279,
						"w": 514
					},
					{
						"n": 4,
						"h": 186,
						"w": 515
					},
					{
						"n": 5,
						"h": 62,
						"w": 458
					},
					{
						"n": 6,
						"h": 413,
						"w": 234
					},
					{
						"n": 7,
						"h": 297,
						"w": 320
					},
					{
						"n": 8,
						"h": 200,
						"w": 379
					},
					{
						"n": 17,
						"h": 54,
						"w": 234
					},
					{
						"n": 10,
						"h": 271,
						"w": 204
					},
					{
						"n": 11,
						"h": 170,
						"w": 194
					}
				],
				"away": [
					{
						"n": 1,
						"h": 226,
						"w": 642
					},
					{
						"n": 13,
						"h": 396,
						"w": 522
					},
					{
						"n": 3,
						"h": 267,
						"w": 547
					},
					{
						"n": 14,
						"h": 192,
						"w": 535
					},
					{
						"n": 5,
						"h": 62,
						"w": 506
					},
					{
						"n": 6,
						"h": 184,
						"w": 502
					},
					{
						"n": 7,
						"h": 247,
						"w": 367
					},
					{
						"n": 8,
						"h": 39,
						"w": 455
					},
					{
						"n": 17,
						"h": 395,
						"w": 405
					},
					{
						"n": 19,
						"h": 297,
						"w": 336
					},
					{
						"n": 11,
						"h": 163,
						"w": 352
					}
				],
				"ball": {
					"n": 0,
					"h": 200,
					"w": 379,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 46
		},
		{
			"num": 1071,
			"minute": 52,
			"messages": [
				{
					"owner": 1,
					"mes": "К.Нолан[08](Галвэй Юнайтед) делает передачу А.Хлинссону[07](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 707
					},
					{
						"n": 2,
						"h": 390,
						"w": 435
					},
					{
						"n": 3,
						"h": 266,
						"w": 493
					},
					{
						"n": 4,
						"h": 175,
						"w": 496
					},
					{
						"n": 5,
						"h": 72,
						"w": 437
					},
					{
						"n": 6,
						"h": 397,
						"w": 213
					},
					{
						"n": 7,
						"h": 260,
						"w": 298
					},
					{
						"n": 8,
						"h": 188,
						"w": 384
					},
					{
						"n": 17,
						"h": 55,
						"w": 213
					},
					{
						"n": 10,
						"h": 275,
						"w": 183
					},
					{
						"n": 11,
						"h": 161,
						"w": 173
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 642
					},
					{
						"n": 13,
						"h": 395,
						"w": 543
					},
					{
						"n": 3,
						"h": 269,
						"w": 570
					},
					{
						"n": 14,
						"h": 190,
						"w": 578
					},
					{
						"n": 5,
						"h": 78,
						"w": 527
					},
					{
						"n": 6,
						"h": 188,
						"w": 459
					},
					{
						"n": 7,
						"h": 239,
						"w": 409
					},
					{
						"n": 8,
						"h": 52,
						"w": 474
					},
					{
						"n": 17,
						"h": 432,
						"w": 424
					},
					{
						"n": 19,
						"h": 262,
						"w": 356
					},
					{
						"n": 11,
						"h": 160,
						"w": 395
					}
				],
				"ball": {
					"n": 0,
					"h": 260,
					"w": 298,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 43
		},
		{
			"num": 1072,
			"minute": 52,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 702
					},
					{
						"n": 2,
						"h": 388,
						"w": 416
					},
					{
						"n": 3,
						"h": 281,
						"w": 456
					},
					{
						"n": 4,
						"h": 182,
						"w": 457
					},
					{
						"n": 5,
						"h": 76,
						"w": 412
					},
					{
						"n": 6,
						"h": 400,
						"w": 182
					},
					{
						"n": 7,
						"h": 243,
						"w": 268
					},
					{
						"n": 8,
						"h": 179,
						"w": 345
					},
					{
						"n": 17,
						"h": 50,
						"w": 182
					},
					{
						"n": 10,
						"h": 282,
						"w": 157
					},
					{
						"n": 11,
						"h": 174,
						"w": 142
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 643
					},
					{
						"n": 13,
						"h": 400,
						"w": 574
					},
					{
						"n": 3,
						"h": 266,
						"w": 600
					},
					{
						"n": 14,
						"h": 180,
						"w": 616
					},
					{
						"n": 5,
						"h": 56,
						"w": 552
					},
					{
						"n": 6,
						"h": 202,
						"w": 470
					},
					{
						"n": 7,
						"h": 233,
						"w": 449
					},
					{
						"n": 8,
						"h": 47,
						"w": 493
					},
					{
						"n": 17,
						"h": 429,
						"w": 453
					},
					{
						"n": 19,
						"h": 271,
						"w": 395
					},
					{
						"n": 11,
						"h": 158,
						"w": 414
					}
				],
				"ball": {
					"n": 0,
					"h": 243,
					"w": 268,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1073,
			"minute": 52,
			"messages": [
				{
					"owner": 1,
					"mes": "Пас А.Гилберту[11](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 701
					},
					{
						"n": 2,
						"h": 385,
						"w": 379
					},
					{
						"n": 3,
						"h": 274,
						"w": 420
					},
					{
						"n": 4,
						"h": 185,
						"w": 422
					},
					{
						"n": 5,
						"h": 64,
						"w": 381
					},
					{
						"n": 6,
						"h": 412,
						"w": 147
					},
					{
						"n": 7,
						"h": 243,
						"w": 231
					},
					{
						"n": 8,
						"h": 169,
						"w": 309
					},
					{
						"n": 17,
						"h": 43,
						"w": 147
					},
					{
						"n": 10,
						"h": 298,
						"w": 127
					},
					{
						"n": 11,
						"h": 201,
						"w": 164
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 680
					},
					{
						"n": 13,
						"h": 391,
						"w": 598
					},
					{
						"n": 3,
						"h": 248,
						"w": 576
					},
					{
						"n": 14,
						"h": 209,
						"w": 607
					},
					{
						"n": 5,
						"h": 62,
						"w": 588
					},
					{
						"n": 6,
						"h": 216,
						"w": 505
					},
					{
						"n": 7,
						"h": 214,
						"w": 481
					},
					{
						"n": 8,
						"h": 46,
						"w": 510
					},
					{
						"n": 17,
						"h": 430,
						"w": 463
					},
					{
						"n": 19,
						"h": 281,
						"w": 431
					},
					{
						"n": 11,
						"h": 163,
						"w": 403
					}
				],
				"ball": {
					"n": 0,
					"h": 201,
					"w": 164,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 37
		},
		{
			"num": 1074,
			"minute": 52,
			"messages": [
				{
					"owner": 1,
					"mes": "Пас налево..."
				},
				{
					"owner": 1,
					"mes": "Джо Квигли[10](Галвэй Юнайтед) принимает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 707
					},
					{
						"n": 2,
						"h": 390,
						"w": 348
					},
					{
						"n": 3,
						"h": 272,
						"w": 405
					},
					{
						"n": 4,
						"h": 168,
						"w": 394
					},
					{
						"n": 5,
						"h": 76,
						"w": 344
					},
					{
						"n": 6,
						"h": 409,
						"w": 102
					},
					{
						"n": 7,
						"h": 256,
						"w": 187
					},
					{
						"n": 8,
						"h": 163,
						"w": 263
					},
					{
						"n": 17,
						"h": 63,
						"w": 113
					},
					{
						"n": 10,
						"h": 323,
						"w": 102
					},
					{
						"n": 11,
						"h": 196,
						"w": 155
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 709
					},
					{
						"n": 13,
						"h": 371,
						"w": 632
					},
					{
						"n": 3,
						"h": 221,
						"w": 613
					},
					{
						"n": 14,
						"h": 166,
						"w": 623
					},
					{
						"n": 5,
						"h": 66,
						"w": 634
					},
					{
						"n": 6,
						"h": 232,
						"w": 548
					},
					{
						"n": 7,
						"h": 230,
						"w": 524
					},
					{
						"n": 8,
						"h": 34,
						"w": 533
					},
					{
						"n": 17,
						"h": 398,
						"w": 496
					},
					{
						"n": 19,
						"h": 292,
						"w": 410
					},
					{
						"n": 11,
						"h": 174,
						"w": 423
					}
				],
				"ball": {
					"n": 0,
					"h": 323,
					"w": 102,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 46
		},
		{
			"num": 1075,
			"minute": 52,
			"messages": [
				{
					"owner": 1,
					"mes": "Джо Квигли[10](Галвэй Юнайтед) отпускает мяч слишком далеко от себя..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 705
					},
					{
						"n": 2,
						"h": 389,
						"w": 350
					},
					{
						"n": 3,
						"h": 272,
						"w": 403
					},
					{
						"n": 4,
						"h": 169,
						"w": 396
					},
					{
						"n": 5,
						"h": 76,
						"w": 346
					},
					{
						"n": 6,
						"h": 407,
						"w": 103
					},
					{
						"n": 7,
						"h": 257,
						"w": 185
					},
					{
						"n": 8,
						"h": 164,
						"w": 264
					},
					{
						"n": 17,
						"h": 61,
						"w": 113
					},
					{
						"n": 10,
						"h": 323,
						"w": 102,
						"m": 740
					},
					{
						"n": 11,
						"h": 195,
						"w": 154
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 709
					},
					{
						"n": 13,
						"h": 373,
						"w": 632
					},
					{
						"n": 3,
						"h": 220,
						"w": 615
					},
					{
						"n": 14,
						"h": 164,
						"w": 623
					},
					{
						"n": 5,
						"h": 64,
						"w": 633
					},
					{
						"n": 6,
						"h": 233,
						"w": 549
					},
					{
						"n": 7,
						"h": 229,
						"w": 526
					},
					{
						"n": 8,
						"h": 33,
						"w": 535
					},
					{
						"n": 17,
						"h": 400,
						"w": 496
					},
					{
						"n": 19,
						"h": 290,
						"w": 411
					},
					{
						"n": 11,
						"h": 172,
						"w": 422
					}
				],
				"ball": {
					"n": 0,
					"h": 315,
					"w": 106,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 2
		},
		{
			"num": 1076,
			"minute": 52,
			"messages": [
				{
					"owner": 1,
					"mes": "Джо Квигли[10](Галвэй Юнайтед) все же подбирает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 705
					},
					{
						"n": 2,
						"h": 382,
						"w": 354
					},
					{
						"n": 3,
						"h": 276,
						"w": 396
					},
					{
						"n": 4,
						"h": 172,
						"w": 398
					},
					{
						"n": 5,
						"h": 68,
						"w": 343
					},
					{
						"n": 6,
						"h": 399,
						"w": 103
					},
					{
						"n": 7,
						"h": 261,
						"w": 178
					},
					{
						"n": 8,
						"h": 170,
						"w": 270
					},
					{
						"n": 17,
						"h": 54,
						"w": 116
					},
					{
						"n": 10,
						"h": 315,
						"w": 106
					},
					{
						"n": 11,
						"h": 191,
						"w": 147
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 709
					},
					{
						"n": 13,
						"h": 380,
						"w": 628
					},
					{
						"n": 3,
						"h": 217,
						"w": 622
					},
					{
						"n": 14,
						"h": 156,
						"w": 620
					},
					{
						"n": 5,
						"h": 60,
						"w": 627
					},
					{
						"n": 6,
						"h": 239,
						"w": 555
					},
					{
						"n": 7,
						"h": 226,
						"w": 519
					},
					{
						"n": 8,
						"h": 33,
						"w": 535
					},
					{
						"n": 17,
						"h": 408,
						"w": 495
					},
					{
						"n": 19,
						"h": 289,
						"w": 419
					},
					{
						"n": 11,
						"h": 164,
						"w": 424
					}
				],
				"ball": {
					"n": 0,
					"h": 315,
					"w": 106,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 8
		},
		{
			"num": 1077,
			"minute": 52,
			"messages": [
				{
					"owner": 1,
					"mes": "Джо Квигли[10](Галвэй Юнайтед) врывается в штрафную..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 706
					},
					{
						"n": 2,
						"h": 380,
						"w": 352
					},
					{
						"n": 3,
						"h": 269,
						"w": 410
					},
					{
						"n": 4,
						"h": 178,
						"w": 399
					},
					{
						"n": 5,
						"h": 71,
						"w": 351
					},
					{
						"n": 6,
						"h": 402,
						"w": 96
					},
					{
						"n": 7,
						"h": 275,
						"w": 156
					},
					{
						"n": 8,
						"h": 158,
						"w": 276
					},
					{
						"n": 17,
						"h": 54,
						"w": 96
					},
					{
						"n": 10,
						"h": 315,
						"w": 85
					},
					{
						"n": 11,
						"h": 186,
						"w": 121
					}
				],
				"away": [
					{
						"n": 1,
						"h": 214,
						"w": 710
					},
					{
						"n": 13,
						"h": 380,
						"w": 649
					},
					{
						"n": 3,
						"h": 231,
						"w": 646
					},
					{
						"n": 14,
						"h": 135,
						"w": 635
					},
					{
						"n": 5,
						"h": 54,
						"w": 638
					},
					{
						"n": 6,
						"h": 236,
						"w": 586
					},
					{
						"n": 7,
						"h": 243,
						"w": 538
					},
					{
						"n": 8,
						"h": 31,
						"w": 540
					},
					{
						"n": 17,
						"h": 427,
						"w": 514
					},
					{
						"n": 19,
						"h": 291,
						"w": 445
					},
					{
						"n": 11,
						"h": 172,
						"w": 425
					}
				],
				"ball": {
					"n": 0,
					"h": 315,
					"w": 85,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 26
		},
		{
			"num": 1078,
			"minute": 52,
			"messages": [
				{
					"owner": 1,
					"mes": "Д.Квигли[10](Галвэй Юнайтед) пытается пройти В.Сланину[34](Опава)..."
				},
				{
					"owner": 1,
					"mes": "Вацлав Сланина[34](Опава) буквально вырывает мяч у Д.Квигли[10](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 706
					},
					{
						"n": 2,
						"h": 380,
						"w": 352
					},
					{
						"n": 3,
						"h": 269,
						"w": 410
					},
					{
						"n": 4,
						"h": 178,
						"w": 399
					},
					{
						"n": 5,
						"h": 71,
						"w": 351
					},
					{
						"n": 6,
						"h": 402,
						"w": 96
					},
					{
						"n": 7,
						"h": 280,
						"w": 147
					},
					{
						"n": 8,
						"h": 158,
						"w": 276
					},
					{
						"n": 17,
						"h": 54,
						"w": 96
					},
					{
						"n": 10,
						"h": 315,
						"w": 75
					},
					{
						"n": 11,
						"h": 184,
						"w": 111
					}
				],
				"away": [
					{
						"n": 1,
						"h": 214,
						"w": 710
					},
					{
						"n": 13,
						"h": 380,
						"w": 649
					},
					{
						"n": 3,
						"h": 236,
						"w": 655
					},
					{
						"n": 14,
						"h": 127,
						"w": 641,
						"m": 630
					},
					{
						"n": 5,
						"h": 54,
						"w": 638
					},
					{
						"n": 6,
						"h": 235,
						"w": 598
					},
					{
						"n": 7,
						"h": 250,
						"w": 546
					},
					{
						"n": 8,
						"h": 29,
						"w": 550
					},
					{
						"n": 17,
						"h": 427,
						"w": 514
					},
					{
						"n": 19,
						"h": 291,
						"w": 455
					},
					{
						"n": 11,
						"h": 172,
						"w": 425
					}
				],
				"ball": {
					"n": 0,
					"h": 323,
					"w": 79,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 4
				}
			},
			"interval": 10
		},
		{
			"num": 1079,
			"minute": 52,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 710
					},
					{
						"n": 2,
						"h": 361,
						"w": 387
					},
					{
						"n": 3,
						"h": 276,
						"w": 415
					},
					{
						"n": 4,
						"h": 163,
						"w": 406
					},
					{
						"n": 5,
						"h": 88,
						"w": 387
					},
					{
						"n": 6,
						"h": 404,
						"w": 136
					},
					{
						"n": 7,
						"h": 285,
						"w": 187
					},
					{
						"n": 8,
						"h": 154,
						"w": 316
					},
					{
						"n": 17,
						"h": 51,
						"w": 136
					},
					{
						"n": 10,
						"h": 321,
						"w": 83
					},
					{
						"n": 11,
						"h": 167,
						"w": 148
					}
				],
				"away": [
					{
						"n": 1,
						"h": 221,
						"w": 702
					},
					{
						"n": 13,
						"h": 389,
						"w": 610
					},
					{
						"n": 3,
						"h": 266,
						"w": 629
					},
					{
						"n": 14,
						"h": 102,
						"w": 616
					},
					{
						"n": 5,
						"h": 65,
						"w": 613
					},
					{
						"n": 6,
						"h": 202,
						"w": 575
					},
					{
						"n": 7,
						"h": 238,
						"w": 508
					},
					{
						"n": 8,
						"h": 29,
						"w": 510
					},
					{
						"n": 17,
						"h": 418,
						"w": 475
					},
					{
						"n": 19,
						"h": 299,
						"w": 416
					},
					{
						"n": 11,
						"h": 163,
						"w": 386
					}
				],
				"ball": {
					"n": 0,
					"h": 348,
					"w": 104,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1080,
			"minute": 52,
			"messages": [
				{
					"owner": 2,
					"mes": "В.Сланина[34](Опава) делает передачу О.Дюмону[26](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 708
					},
					{
						"n": 2,
						"h": 347,
						"w": 411
					},
					{
						"n": 3,
						"h": 270,
						"w": 428
					},
					{
						"n": 4,
						"h": 175,
						"w": 426
					},
					{
						"n": 5,
						"h": 103,
						"w": 409
					},
					{
						"n": 6,
						"h": 404,
						"w": 163
					},
					{
						"n": 7,
						"h": 281,
						"w": 214
					},
					{
						"n": 8,
						"h": 155,
						"w": 342
					},
					{
						"n": 17,
						"h": 53,
						"w": 163
					},
					{
						"n": 10,
						"h": 297,
						"w": 97
					},
					{
						"n": 11,
						"h": 161,
						"w": 174
					}
				],
				"away": [
					{
						"n": 1,
						"h": 221,
						"w": 708
					},
					{
						"n": 13,
						"h": 395,
						"w": 584
					},
					{
						"n": 3,
						"h": 272,
						"w": 626
					},
					{
						"n": 14,
						"h": 112,
						"w": 617
					},
					{
						"n": 5,
						"h": 56,
						"w": 602
					},
					{
						"n": 6,
						"h": 186,
						"w": 596
					},
					{
						"n": 7,
						"h": 230,
						"w": 482
					},
					{
						"n": 8,
						"h": 31,
						"w": 483
					},
					{
						"n": 17,
						"h": 412,
						"w": 449
					},
					{
						"n": 19,
						"h": 303,
						"w": 389
					},
					{
						"n": 11,
						"h": 161,
						"w": 359
					}
				],
				"ball": {
					"n": 0,
					"h": 293,
					"w": 105,
					"z": 0,
					"r": 0,
					"p": 2,
					"x": 0
				}
			},
			"interval": 27
		},
		{
			"num": 1081,
			"minute": 52,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 706
					},
					{
						"n": 2,
						"h": 334,
						"w": 419
					},
					{
						"n": 3,
						"h": 255,
						"w": 434
					},
					{
						"n": 4,
						"h": 164,
						"w": 437
					},
					{
						"n": 5,
						"h": 109,
						"w": 424
					},
					{
						"n": 6,
						"h": 402,
						"w": 179
					},
					{
						"n": 7,
						"h": 280,
						"w": 198
					},
					{
						"n": 8,
						"h": 167,
						"w": 353
					},
					{
						"n": 17,
						"h": 54,
						"w": 179
					},
					{
						"n": 10,
						"h": 283,
						"w": 103
					},
					{
						"n": 11,
						"h": 158,
						"w": 190
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 707
					},
					{
						"n": 13,
						"h": 397,
						"w": 568
					},
					{
						"n": 3,
						"h": 276,
						"w": 628
					},
					{
						"n": 14,
						"h": 128,
						"w": 619
					},
					{
						"n": 5,
						"h": 57,
						"w": 618
					},
					{
						"n": 6,
						"h": 178,
						"w": 608
					},
					{
						"n": 7,
						"h": 226,
						"w": 467
					},
					{
						"n": 8,
						"h": 31,
						"w": 467
					},
					{
						"n": 17,
						"h": 410,
						"w": 433
					},
					{
						"n": 19,
						"h": 300,
						"w": 373
					},
					{
						"n": 11,
						"h": 156,
						"w": 344
					}
				],
				"ball": {
					"n": 0,
					"h": 277,
					"w": 106,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 16
		},
		{
			"num": 1082,
			"minute": 52,
			"messages": [
				{
					"owner": 1,
					"mes": "Джо Квигли[10](Галвэй Юнайтед) первый на подборе..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 707
					},
					{
						"n": 2,
						"h": 329,
						"w": 423
					},
					{
						"n": 3,
						"h": 251,
						"w": 437
					},
					{
						"n": 4,
						"h": 164,
						"w": 443
					},
					{
						"n": 5,
						"h": 110,
						"w": 430
					},
					{
						"n": 6,
						"h": 403,
						"w": 185
					},
					{
						"n": 7,
						"h": 279,
						"w": 204
					},
					{
						"n": 8,
						"h": 164,
						"w": 358
					},
					{
						"n": 17,
						"h": 53,
						"w": 185
					},
					{
						"n": 10,
						"h": 277,
						"w": 106,
						"m": 750
					},
					{
						"n": 11,
						"h": 157,
						"w": 196
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 710
					},
					{
						"n": 13,
						"h": 398,
						"w": 562
					},
					{
						"n": 3,
						"h": 276,
						"w": 628
					},
					{
						"n": 14,
						"h": 128,
						"w": 619,
						"m": 620
					},
					{
						"n": 5,
						"h": 63,
						"w": 620
					},
					{
						"n": 6,
						"h": 174,
						"w": 613,
						"m": 670
					},
					{
						"n": 7,
						"h": 224,
						"w": 461
					},
					{
						"n": 8,
						"h": 32,
						"w": 461
					},
					{
						"n": 17,
						"h": 410,
						"w": 427
					},
					{
						"n": 19,
						"h": 300,
						"w": 367
					},
					{
						"n": 11,
						"h": 156,
						"w": 338
					}
				],
				"ball": {
					"n": 0,
					"h": 277,
					"w": 106,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 6
		},
		{
			"num": 1083,
			"minute": 52,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 705
					},
					{
						"n": 2,
						"h": 339,
						"w": 406
					},
					{
						"n": 3,
						"h": 257,
						"w": 418
					},
					{
						"n": 4,
						"h": 165,
						"w": 424
					},
					{
						"n": 5,
						"h": 102,
						"w": 412
					},
					{
						"n": 6,
						"h": 403,
						"w": 165
					},
					{
						"n": 7,
						"h": 279,
						"w": 184
					},
					{
						"n": 8,
						"h": 165,
						"w": 338
					},
					{
						"n": 17,
						"h": 53,
						"w": 165
					},
					{
						"n": 10,
						"h": 267,
						"w": 108
					},
					{
						"n": 11,
						"h": 157,
						"w": 176
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 706
					},
					{
						"n": 13,
						"h": 397,
						"w": 582
					},
					{
						"n": 3,
						"h": 275,
						"w": 634
					},
					{
						"n": 14,
						"h": 133,
						"w": 622
					},
					{
						"n": 5,
						"h": 76,
						"w": 635
					},
					{
						"n": 6,
						"h": 186,
						"w": 621
					},
					{
						"n": 7,
						"h": 225,
						"w": 481
					},
					{
						"n": 8,
						"h": 29,
						"w": 481
					},
					{
						"n": 17,
						"h": 415,
						"w": 446
					},
					{
						"n": 19,
						"h": 292,
						"w": 386
					},
					{
						"n": 11,
						"h": 166,
						"w": 355
					}
				],
				"ball": {
					"n": 0,
					"h": 267,
					"w": 108,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 20
		},
		{
			"num": 1084,
			"minute": 52,
			"messages": [
				{
					"owner": 1,
					"mes": "Джо Квигли[10](Галвэй Юнайтед) прикрывает мяч корпусом..."
				},
				{
					"owner": 1,
					"mes": "Джо Квигли[10](Галвэй Юнайтед) резко разворачивается... О.Дюмон[26](Опава) остается не у дел..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 705
					},
					{
						"n": 2,
						"h": 347,
						"w": 393
					},
					{
						"n": 3,
						"h": 261,
						"w": 404
					},
					{
						"n": 4,
						"h": 166,
						"w": 409
					},
					{
						"n": 5,
						"h": 97,
						"w": 398
					},
					{
						"n": 6,
						"h": 402,
						"w": 150
					},
					{
						"n": 7,
						"h": 279,
						"w": 169
					},
					{
						"n": 8,
						"h": 165,
						"w": 323
					},
					{
						"n": 17,
						"h": 54,
						"w": 150
					},
					{
						"n": 10,
						"h": 253,
						"w": 102,
						"m": 760
					},
					{
						"n": 11,
						"h": 156,
						"w": 161
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 706
					},
					{
						"n": 13,
						"h": 397,
						"w": 591
					},
					{
						"n": 3,
						"h": 272,
						"w": 649
					},
					{
						"n": 14,
						"h": 145,
						"w": 630
					},
					{
						"n": 5,
						"h": 79,
						"w": 638
					},
					{
						"n": 6,
						"h": 186,
						"w": 621,
						"m": 660
					},
					{
						"n": 7,
						"h": 226,
						"w": 496
					},
					{
						"n": 8,
						"h": 28,
						"w": 496
					},
					{
						"n": 17,
						"h": 419,
						"w": 461
					},
					{
						"n": 19,
						"h": 286,
						"w": 400
					},
					{
						"n": 11,
						"h": 175,
						"w": 367
					}
				],
				"ball": {
					"n": 0,
					"h": 253,
					"w": 102,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 15
		},
		{
			"num": 1085,
			"minute": 52,
			"messages": [
				{
					"owner": 1,
					"mes": "Джо Квигли[10](Галвэй Юнайтед) на скорости входит с мячом в штрафную..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 708
					},
					{
						"n": 2,
						"h": 365,
						"w": 357
					},
					{
						"n": 3,
						"h": 275,
						"w": 396
					},
					{
						"n": 4,
						"h": 169,
						"w": 402
					},
					{
						"n": 5,
						"h": 78,
						"w": 363
					},
					{
						"n": 6,
						"h": 406,
						"w": 110
					},
					{
						"n": 7,
						"h": 277,
						"w": 129
					},
					{
						"n": 8,
						"h": 161,
						"w": 283
					},
					{
						"n": 17,
						"h": 58,
						"w": 110
					},
					{
						"n": 10,
						"h": 240,
						"w": 62
					},
					{
						"n": 11,
						"h": 162,
						"w": 121
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 705
					},
					{
						"n": 13,
						"h": 393,
						"w": 631
					},
					{
						"n": 3,
						"h": 231,
						"w": 663
					},
					{
						"n": 14,
						"h": 181,
						"w": 647
					},
					{
						"n": 5,
						"h": 50,
						"w": 618
					},
					{
						"n": 6,
						"h": 199,
						"w": 649
					},
					{
						"n": 7,
						"h": 245,
						"w": 531
					},
					{
						"n": 8,
						"h": 33,
						"w": 536
					},
					{
						"n": 17,
						"h": 419,
						"w": 501
					},
					{
						"n": 19,
						"h": 289,
						"w": 440
					},
					{
						"n": 11,
						"h": 167,
						"w": 407
					}
				],
				"ball": {
					"n": 0,
					"h": 240,
					"w": 62,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1086,
			"minute": 52,
			"messages": [
				{
					"owner": 1,
					"mes": "Удар по воротам..."
				},
				{
					"owner": 1,
					"mes": "Крыштоф Ласак[21](Опава), не рискуя, отбивает мяч на угловой..."
				}
			],
			"U": {
				"team": 1,
				"player": 10,
				"xg": "0.26"
			},
			"V": {
				"team": 1,
				"player": 10
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 709
					},
					{
						"n": 2,
						"h": 373,
						"w": 351
					},
					{
						"n": 3,
						"h": 278,
						"w": 401
					},
					{
						"n": 4,
						"h": 177,
						"w": 408
					},
					{
						"n": 5,
						"h": 70,
						"w": 357
					},
					{
						"n": 6,
						"h": 400,
						"w": 102
					},
					{
						"n": 7,
						"h": 280,
						"w": 119
					},
					{
						"n": 8,
						"h": 162,
						"w": 273
					},
					{
						"n": 17,
						"h": 59,
						"w": 100
					},
					{
						"n": 10,
						"h": 240,
						"w": 62,
						"m": 770
					},
					{
						"n": 11,
						"h": 163,
						"w": 112
					}
				],
				"away": [
					{
						"n": 1,
						"h": 211,
						"w": 705,
						"m": 640
					},
					{
						"n": 13,
						"h": 392,
						"w": 641
					},
					{
						"n": 3,
						"h": 221,
						"w": 667
					},
					{
						"n": 14,
						"h": 189,
						"w": 654
					},
					{
						"n": 5,
						"h": 55,
						"w": 627
					},
					{
						"n": 6,
						"h": 207,
						"w": 658
					},
					{
						"n": 7,
						"h": 250,
						"w": 540
					},
					{
						"n": 8,
						"h": 33,
						"w": 536
					},
					{
						"n": 17,
						"h": 414,
						"w": 509
					},
					{
						"n": 19,
						"h": 288,
						"w": 450
					},
					{
						"n": 11,
						"h": 163,
						"w": 416
					}
				],
				"ball": {
					"n": 0,
					"h": 239,
					"w": 15,
					"z": 1,
					"r": 0,
					"p": 4,
					"x": 6
				}
			},
			"interval": 10
		},
		{
			"num": 1087,
			"minute": 52,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 709
					},
					{
						"n": 2,
						"h": 373,
						"w": 351
					},
					{
						"n": 3,
						"h": 278,
						"w": 401
					},
					{
						"n": 4,
						"h": 177,
						"w": 408
					},
					{
						"n": 5,
						"h": 70,
						"w": 357
					},
					{
						"n": 6,
						"h": 400,
						"w": 102
					},
					{
						"n": 7,
						"h": 280,
						"w": 119
					},
					{
						"n": 8,
						"h": 162,
						"w": 273
					},
					{
						"n": 17,
						"h": 59,
						"w": 100
					},
					{
						"n": 10,
						"h": 240,
						"w": 62
					},
					{
						"n": 11,
						"h": 163,
						"w": 112
					}
				],
				"away": [
					{
						"n": 1,
						"h": 211,
						"w": 705,
						"m": 650
					},
					{
						"n": 13,
						"h": 392,
						"w": 641
					},
					{
						"n": 3,
						"h": 221,
						"w": 667
					},
					{
						"n": 14,
						"h": 189,
						"w": 654
					},
					{
						"n": 5,
						"h": 55,
						"w": 627
					},
					{
						"n": 6,
						"h": 207,
						"w": 658
					},
					{
						"n": 7,
						"h": 250,
						"w": 540
					},
					{
						"n": 8,
						"h": 33,
						"w": 536
					},
					{
						"n": 17,
						"h": 414,
						"w": 509
					},
					{
						"n": 19,
						"h": 288,
						"w": 450
					},
					{
						"n": 11,
						"h": 163,
						"w": 416
					}
				],
				"ball": {
					"n": 0,
					"h": 256,
					"w": -30,
					"z": 1,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 21
		},
		{
			"num": 1088,
			"minute": 52,
			"messages": [
				{
					"owner": 1,
					"mes": "Галвэй Юнайтед зарабатывает угловой..."
				}
			],
			"C": {
				"team": 1
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 680
					},
					{
						"n": 2,
						"h": 220,
						"w": 72
					},
					{
						"n": 3,
						"h": 458,
						"w": -16
					},
					{
						"n": 4,
						"h": 210,
						"w": 60
					},
					{
						"n": 5,
						"h": 235,
						"w": 48
					},
					{
						"n": 6,
						"h": 300,
						"w": 420
					},
					{
						"n": 7,
						"h": 225,
						"w": 120
					},
					{
						"n": 8,
						"h": 225,
						"w": 260
					},
					{
						"n": 17,
						"h": 150,
						"w": 420
					},
					{
						"n": 10,
						"h": 260,
						"w": 60
					},
					{
						"n": 11,
						"h": 190,
						"w": 40
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 710
					},
					{
						"n": 13,
						"h": 260,
						"w": 690
					},
					{
						"n": 3,
						"h": 215,
						"w": 682
					},
					{
						"n": 14,
						"h": 265,
						"w": 665
					},
					{
						"n": 5,
						"h": 175,
						"w": 680
					},
					{
						"n": 6,
						"h": 225,
						"w": 610
					},
					{
						"n": 7,
						"h": 230,
						"w": 658
					},
					{
						"n": 8,
						"h": 225,
						"w": 475
					},
					{
						"n": 17,
						"h": 190,
						"w": 670
					},
					{
						"n": 19,
						"h": 240,
						"w": 670
					},
					{
						"n": 11,
						"h": 300,
						"w": 320
					}
				],
				"ball": {
					"n": 0,
					"h": 450,
					"w": 0,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 100
		},
		{
			"num": 1089,
			"minute": 52,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 682
					},
					{
						"n": 2,
						"h": 213,
						"w": 71
					},
					{
						"n": 3,
						"h": 450,
						"w": 0
					},
					{
						"n": 4,
						"h": 207,
						"w": 54
					},
					{
						"n": 5,
						"h": 239,
						"w": 42
					},
					{
						"n": 6,
						"h": 293,
						"w": 426
					},
					{
						"n": 7,
						"h": 222,
						"w": 124
					},
					{
						"n": 8,
						"h": 228,
						"w": 254
					},
					{
						"n": 17,
						"h": 152,
						"w": 419
					},
					{
						"n": 10,
						"h": 261,
						"w": 65
					},
					{
						"n": 11,
						"h": 185,
						"w": 45
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 700
					},
					{
						"n": 13,
						"h": 256,
						"w": 693
					},
					{
						"n": 3,
						"h": 216,
						"w": 681
					},
					{
						"n": 14,
						"h": 271,
						"w": 672
					},
					{
						"n": 5,
						"h": 175,
						"w": 687
					},
					{
						"n": 6,
						"h": 222,
						"w": 616
					},
					{
						"n": 7,
						"h": 233,
						"w": 656
					},
					{
						"n": 8,
						"h": 223,
						"w": 470
					},
					{
						"n": 17,
						"h": 188,
						"w": 670
					},
					{
						"n": 19,
						"h": 242,
						"w": 664
					},
					{
						"n": 11,
						"h": 294,
						"w": 327
					}
				],
				"ball": {
					"n": 0,
					"h": 450,
					"w": 0,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 15
		},
		{
			"num": 1090,
			"minute": 52,
			"messages": [
				{
					"owner": 1,
					"mes": "К мячу подходит Патрик Клинтон[03](Галвэй Юнайтед)..."
				},
				{
					"owner": 1,
					"mes": "П.Клинтон[03](Галвэй Юнайтед) навешивает в штрафную..."
				},
				{
					"owner": 1,
					"mes": "Вацлав Сланина[34](Опава) головой разряжает обстановку..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 709
					},
					{
						"n": 2,
						"h": 216,
						"w": 67
					},
					{
						"n": 3,
						"h": 448,
						"w": 5
					},
					{
						"n": 4,
						"h": 197,
						"w": 60
					},
					{
						"n": 5,
						"h": 237,
						"w": 45
					},
					{
						"n": 6,
						"h": 271,
						"w": 399
					},
					{
						"n": 7,
						"h": 215,
						"w": 107
					},
					{
						"n": 8,
						"h": 257,
						"w": 229
					},
					{
						"n": 17,
						"h": 183,
						"w": 394
					},
					{
						"n": 10,
						"h": 258,
						"w": 62
					},
					{
						"n": 11,
						"h": 178,
						"w": 49
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 715
					},
					{
						"n": 13,
						"h": 273,
						"w": 677
					},
					{
						"n": 3,
						"h": 219,
						"w": 680
					},
					{
						"n": 14,
						"h": 277,
						"w": 671
					},
					{
						"n": 5,
						"h": 166,
						"w": 677
					},
					{
						"n": 6,
						"h": 230,
						"w": 620
					},
					{
						"n": 7,
						"h": 239,
						"w": 657
					},
					{
						"n": 8,
						"h": 203,
						"w": 514
					},
					{
						"n": 17,
						"h": 188,
						"w": 664
					},
					{
						"n": 19,
						"h": 255,
						"w": 664
					},
					{
						"n": 11,
						"h": 271,
						"w": 369
					}
				],
				"ball": {
					"n": 0,
					"h": 173,
					"w": 49,
					"z": 1,
					"r": 2,
					"p": 4,
					"x": 1
				}
			},
			"interval": 48
		},
		{
			"num": 1091,
			"minute": 52,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 707
					},
					{
						"n": 2,
						"h": 227,
						"w": 85
					},
					{
						"n": 3,
						"h": 439,
						"w": 25
					},
					{
						"n": 4,
						"h": 194,
						"w": 82
					},
					{
						"n": 5,
						"h": 226,
						"w": 64
					},
					{
						"n": 6,
						"h": 274,
						"w": 380
					},
					{
						"n": 7,
						"h": 226,
						"w": 126
					},
					{
						"n": 8,
						"h": 251,
						"w": 250
					},
					{
						"n": 17,
						"h": 175,
						"w": 398
					},
					{
						"n": 10,
						"h": 277,
						"w": 74
					},
					{
						"n": 11,
						"h": 168,
						"w": 38
					}
				],
				"away": [
					{
						"n": 1,
						"h": 240,
						"w": 720
					},
					{
						"n": 13,
						"h": 289,
						"w": 692
					},
					{
						"n": 3,
						"h": 203,
						"w": 665
					},
					{
						"n": 14,
						"h": 262,
						"w": 670,
						"m": 630
					},
					{
						"n": 5,
						"h": 144,
						"w": 679
					},
					{
						"n": 6,
						"h": 229,
						"w": 640
					},
					{
						"n": 7,
						"h": 260,
						"w": 651
					},
					{
						"n": 8,
						"h": 217,
						"w": 517
					},
					{
						"n": 17,
						"h": 206,
						"w": 651
					},
					{
						"n": 19,
						"h": 264,
						"w": 644
					},
					{
						"n": 11,
						"h": 272,
						"w": 391
					}
				],
				"ball": {
					"n": 0,
					"h": 138,
					"w": -30,
					"z": 1,
					"r": 0,
					"p": 1,
					"x": 0
				}
			},
			"interval": 22
		},
		{
			"num": 1092,
			"minute": 53,
			"possession": 44,
			"messages": [
				{
					"owner": 1,
					"mes": "Галвэй Юнайтед зарабатывает угловой..."
				}
			],
			"C": {
				"team": 1
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 680
					},
					{
						"n": 2,
						"h": 220,
						"w": 72
					},
					{
						"n": 3,
						"h": -8,
						"w": 16
					},
					{
						"n": 4,
						"h": 210,
						"w": 60
					},
					{
						"n": 5,
						"h": 235,
						"w": 48
					},
					{
						"n": 6,
						"h": 300,
						"w": 420,
						"m": 710
					},
					{
						"n": 7,
						"h": 225,
						"w": 120
					},
					{
						"n": 8,
						"h": 225,
						"w": 260,
						"f": 83
					},
					{
						"n": 17,
						"h": 150,
						"w": 420
					},
					{
						"n": 10,
						"h": 260,
						"w": 60,
						"f": 84,
						"c": 2
					},
					{
						"n": 11,
						"h": 190,
						"w": 40
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 710,
						"f": 85
					},
					{
						"n": 13,
						"h": 260,
						"w": 690
					},
					{
						"n": 3,
						"h": 215,
						"w": 682
					},
					{
						"n": 14,
						"h": 265,
						"w": 665
					},
					{
						"n": 5,
						"h": 275,
						"w": 680
					},
					{
						"n": 6,
						"h": 225,
						"w": 610
					},
					{
						"n": 7,
						"h": 230,
						"w": 658
					},
					{
						"n": 8,
						"h": 225,
						"w": 475
					},
					{
						"n": 17,
						"h": 190,
						"w": 670
					},
					{
						"n": 19,
						"h": 240,
						"w": 670
					},
					{
						"n": 11,
						"h": 150,
						"w": 320
					}
				],
				"ball": {
					"n": 0,
					"h": 0,
					"w": 0,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 100
		},
		{
			"num": 1093,
			"minute": 53,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 679
					},
					{
						"n": 2,
						"h": 224,
						"w": 66
					},
					{
						"n": 3,
						"h": 0,
						"w": 0
					},
					{
						"n": 4,
						"h": 217,
						"w": 58
					},
					{
						"n": 5,
						"h": 236,
						"w": 51
					},
					{
						"n": 6,
						"h": 303,
						"w": 427
					},
					{
						"n": 7,
						"h": 226,
						"w": 121
					},
					{
						"n": 8,
						"h": 222,
						"w": 263
					},
					{
						"n": 17,
						"h": 149,
						"w": 426
					},
					{
						"n": 10,
						"h": 258,
						"w": 55
					},
					{
						"n": 11,
						"h": 191,
						"w": 34
					}
				],
				"away": [
					{
						"n": 1,
						"h": 221,
						"w": 700
					},
					{
						"n": 13,
						"h": 258,
						"w": 683
					},
					{
						"n": 3,
						"h": 216,
						"w": 682
					},
					{
						"n": 14,
						"h": 271,
						"w": 659
					},
					{
						"n": 5,
						"h": 273,
						"w": 686
					},
					{
						"n": 6,
						"h": 229,
						"w": 610
					},
					{
						"n": 7,
						"h": 236,
						"w": 658
					},
					{
						"n": 8,
						"h": 232,
						"w": 474
					},
					{
						"n": 17,
						"h": 190,
						"w": 667
					},
					{
						"n": 19,
						"h": 235,
						"w": 673
					},
					{
						"n": 11,
						"h": 154,
						"w": 314
					}
				],
				"ball": {
					"n": 0,
					"h": 0,
					"w": 0,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 15
		},
		{
			"num": 1094,
			"minute": 53,
			"messages": [
				{
					"owner": 1,
					"mes": "Патрик Клинтон[03](Галвэй Юнайтед) устанавливает мяч у углового флажка..."
				},
				{
					"owner": 1,
					"mes": "П.Клинтон[03](Галвэй Юнайтед) закидывает мяч в штрафную..."
				},
				{
					"owner": 1,
					"mes": "Мирослав Манолов[27](Опава) в высоком прыжке выбивает мяч подальше..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 708
					},
					{
						"n": 2,
						"h": 234,
						"w": 64
					},
					{
						"n": 3,
						"h": 2,
						"w": 5
					},
					{
						"n": 4,
						"h": 226,
						"w": 60
					},
					{
						"n": 5,
						"h": 235,
						"w": 53
					},
					{
						"n": 6,
						"h": 277,
						"w": 394
					},
					{
						"n": 7,
						"h": 220,
						"w": 109
					},
					{
						"n": 8,
						"h": 197,
						"w": 230
					},
					{
						"n": 17,
						"h": 178,
						"w": 395
					},
					{
						"n": 10,
						"h": 264,
						"w": 60
					},
					{
						"n": 11,
						"h": 192,
						"w": 36
					}
				],
				"away": [
					{
						"n": 1,
						"h": 223,
						"w": 708
					},
					{
						"n": 13,
						"h": 256,
						"w": 685
					},
					{
						"n": 3,
						"h": 221,
						"w": 677
					},
					{
						"n": 14,
						"h": 269,
						"w": 652
					},
					{
						"n": 5,
						"h": 266,
						"w": 679
					},
					{
						"n": 6,
						"h": 236,
						"w": 616
					},
					{
						"n": 7,
						"h": 212,
						"w": 662
					},
					{
						"n": 8,
						"h": 246,
						"w": 513
					},
					{
						"n": 17,
						"h": 180,
						"w": 660
					},
					{
						"n": 19,
						"h": 220,
						"w": 669
					},
					{
						"n": 11,
						"h": 173,
						"w": 346
					}
				],
				"ball": {
					"n": 0,
					"h": 238,
					"w": 58,
					"z": 1,
					"r": 2,
					"p": 4,
					"x": 1
				}
			},
			"interval": 42
		},
		{
			"num": 1095,
			"minute": 53,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 707
					},
					{
						"n": 2,
						"h": 234,
						"w": 65
					},
					{
						"n": 3,
						"h": 44,
						"w": 6
					},
					{
						"n": 4,
						"h": 187,
						"w": 62
					},
					{
						"n": 5,
						"h": 235,
						"w": 66
					},
					{
						"n": 6,
						"h": 268,
						"w": 388
					},
					{
						"n": 7,
						"h": 249,
						"w": 135
					},
					{
						"n": 8,
						"h": 224,
						"w": 258
					},
					{
						"n": 17,
						"h": 165,
						"w": 392
					},
					{
						"n": 10,
						"h": 307,
						"w": 69
					},
					{
						"n": 11,
						"h": 166,
						"w": 60
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 709
					},
					{
						"n": 13,
						"h": 294,
						"w": 693
					},
					{
						"n": 3,
						"h": 218,
						"w": 659
					},
					{
						"n": 14,
						"h": 250,
						"w": 645
					},
					{
						"n": 5,
						"h": 228,
						"w": 669
					},
					{
						"n": 6,
						"h": 200,
						"w": 640
					},
					{
						"n": 7,
						"h": 212,
						"w": 662
					},
					{
						"n": 8,
						"h": 226,
						"w": 498
					},
					{
						"n": 17,
						"h": 138,
						"w": 650
					},
					{
						"n": 19,
						"h": 237,
						"w": 634
					},
					{
						"n": 11,
						"h": 169,
						"w": 385
					}
				],
				"ball": {
					"n": 0,
					"h": 393,
					"w": 89,
					"z": 1,
					"r": 0,
					"p": 1,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 1096,
			"minute": 53,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 705
					},
					{
						"n": 2,
						"h": 234,
						"w": 53
					},
					{
						"n": 3,
						"h": 56,
						"w": 6
					},
					{
						"n": 4,
						"h": 185,
						"w": 70
					},
					{
						"n": 5,
						"h": 235,
						"w": 72
					},
					{
						"n": 6,
						"h": 274,
						"w": 391
					},
					{
						"n": 7,
						"h": 255,
						"w": 146
					},
					{
						"n": 8,
						"h": 214,
						"w": 265
					},
					{
						"n": 17,
						"h": 177,
						"w": 393
					},
					{
						"n": 10,
						"h": 320,
						"w": 72
					},
					{
						"n": 11,
						"h": 167,
						"w": 60
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 709
					},
					{
						"n": 13,
						"h": 304,
						"w": 686
					},
					{
						"n": 3,
						"h": 218,
						"w": 650
					},
					{
						"n": 14,
						"h": 246,
						"w": 656
					},
					{
						"n": 5,
						"h": 217,
						"w": 664
					},
					{
						"n": 6,
						"h": 207,
						"w": 653
					},
					{
						"n": 7,
						"h": 216,
						"w": 651
					},
					{
						"n": 8,
						"h": 225,
						"w": 510
					},
					{
						"n": 17,
						"h": 125,
						"w": 647
					},
					{
						"n": 19,
						"h": 237,
						"w": 622
					},
					{
						"n": 11,
						"h": 164,
						"w": 396
					}
				],
				"ball": {
					"n": 0,
					"h": 439,
					"w": 98,
					"z": 0,
					"r": 0,
					"p": 1,
					"x": 0
				}
			},
			"interval": 12
		},
		{
			"num": 1097,
			"minute": 53,
			"messages": [
				{
					"owner": 1,
					"mes": "Джо Квигли[10](Галвэй Юнайтед) завладевает мячом..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 708
					},
					{
						"n": 2,
						"h": 234,
						"w": 57
					},
					{
						"n": 3,
						"h": 151,
						"w": 11
					},
					{
						"n": 4,
						"h": 173,
						"w": 80
					},
					{
						"n": 5,
						"h": 235,
						"w": 74
					},
					{
						"n": 6,
						"h": 284,
						"w": 394
					},
					{
						"n": 7,
						"h": 305,
						"w": 139
					},
					{
						"n": 8,
						"h": 277,
						"w": 271
					},
					{
						"n": 17,
						"h": 184,
						"w": 398
					},
					{
						"n": 10,
						"h": 439,
						"w": 98
					},
					{
						"n": 11,
						"h": 215,
						"w": 70
					}
				],
				"away": [
					{
						"n": 1,
						"h": 211,
						"w": 714
					},
					{
						"n": 13,
						"h": 293,
						"w": 710
					},
					{
						"n": 3,
						"h": 286,
						"w": 666
					},
					{
						"n": 14,
						"h": 217,
						"w": 677
					},
					{
						"n": 5,
						"h": 122,
						"w": 658
					},
					{
						"n": 6,
						"h": 143,
						"w": 640
					},
					{
						"n": 7,
						"h": 207,
						"w": 630
					},
					{
						"n": 8,
						"h": 207,
						"w": 521
					},
					{
						"n": 17,
						"h": 23,
						"w": 624
					},
					{
						"n": 19,
						"h": 276,
						"w": 610
					},
					{
						"n": 11,
						"h": 173,
						"w": 469
					}
				],
				"ball": {
					"n": 0,
					"h": 439,
					"w": 98,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 95
		},
		{
			"num": 1098,
			"minute": 53,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 701
					},
					{
						"n": 2,
						"h": 234,
						"w": 59
					},
					{
						"n": 3,
						"h": 171,
						"w": 12
					},
					{
						"n": 4,
						"h": 174,
						"w": 89
					},
					{
						"n": 5,
						"h": 235,
						"w": 60
					},
					{
						"n": 6,
						"h": 267,
						"w": 384
					},
					{
						"n": 7,
						"h": 304,
						"w": 119
					},
					{
						"n": 8,
						"h": 274,
						"w": 251
					},
					{
						"n": 17,
						"h": 184,
						"w": 395
					},
					{
						"n": 10,
						"h": 439,
						"w": 70
					},
					{
						"n": 11,
						"h": 198,
						"w": 60
					}
				],
				"away": [
					{
						"n": 1,
						"h": 211,
						"w": 715
					},
					{
						"n": 13,
						"h": 273,
						"w": 707
					},
					{
						"n": 3,
						"h": 268,
						"w": 674
					},
					{
						"n": 14,
						"h": 207,
						"w": 661
					},
					{
						"n": 5,
						"h": 100,
						"w": 663
					},
					{
						"n": 6,
						"h": 168,
						"w": 640
					},
					{
						"n": 7,
						"h": 206,
						"w": 610
					},
					{
						"n": 8,
						"h": 195,
						"w": 520
					},
					{
						"n": 17,
						"h": 23,
						"w": 632
					},
					{
						"n": 19,
						"h": 277,
						"w": 590
					},
					{
						"n": 11,
						"h": 176,
						"w": 489
					}
				],
				"ball": {
					"n": 0,
					"h": 439,
					"w": 70,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 20
		},
		{
			"num": 1099,
			"minute": 53,
			"messages": [
				{
					"owner": 1,
					"mes": "Прострел вдоль ворот..."
				},
				{
					"owner": 1,
					"mes": "Неточно..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 709
					},
					{
						"n": 2,
						"h": 234,
						"w": 56
					},
					{
						"n": 3,
						"h": 211,
						"w": 15
					},
					{
						"n": 4,
						"h": 179,
						"w": 99
					},
					{
						"n": 5,
						"h": 235,
						"w": 63
					},
					{
						"n": 6,
						"h": 278,
						"w": 384
					},
					{
						"n": 7,
						"h": 298,
						"w": 92
					},
					{
						"n": 8,
						"h": 272,
						"w": 211
					},
					{
						"n": 17,
						"h": 171,
						"w": 386
					},
					{
						"n": 10,
						"h": 439,
						"w": 70
					},
					{
						"n": 11,
						"h": 183,
						"w": 46
					}
				],
				"away": [
					{
						"n": 1,
						"h": 211,
						"w": 715
					},
					{
						"n": 13,
						"h": 233,
						"w": 705
					},
					{
						"n": 3,
						"h": 249,
						"w": 675
					},
					{
						"n": 14,
						"h": 207,
						"w": 665
					},
					{
						"n": 5,
						"h": 89,
						"w": 664
					},
					{
						"n": 6,
						"h": 146,
						"w": 638
					},
					{
						"n": 7,
						"h": 202,
						"w": 570
					},
					{
						"n": 8,
						"h": 200,
						"w": 536
					},
					{
						"n": 17,
						"h": 9,
						"w": 666
					},
					{
						"n": 19,
						"h": 281,
						"w": 550
					},
					{
						"n": 11,
						"h": 178,
						"w": 529
					}
				],
				"ball": {
					"n": 0,
					"h": 257,
					"w": -9,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1100,
			"minute": 54,
			"possession": 45,
			"messages": [
				{
					"owner": 2,
					"mes": "Удар от ворот... Крыштоф Ласак[21](Опава) устанавливает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 680
					},
					{
						"n": 2,
						"h": 369,
						"w": 546,
						"f": 85
					},
					{
						"n": 3,
						"h": 280,
						"w": 570,
						"f": 88
					},
					{
						"n": 4,
						"h": 176,
						"w": 570,
						"f": 87,
						"m": 680
					},
					{
						"n": 5,
						"h": 75,
						"w": 544,
						"f": 85
					},
					{
						"n": 6,
						"h": 383,
						"w": 442
					},
					{
						"n": 7,
						"h": 285,
						"w": 470,
						"f": 85
					},
					{
						"n": 8,
						"h": 175,
						"w": 470
					},
					{
						"n": 17,
						"h": 82,
						"w": 443
					},
					{
						"n": 10,
						"h": 283,
						"w": 370
					},
					{
						"n": 11,
						"h": 169,
						"w": 370,
						"f": 84,
						"c": 2
					}
				],
				"away": [
					{
						"n": 1,
						"h": 263,
						"w": 706
					},
					{
						"n": 13,
						"h": 393,
						"w": 437,
						"f": 95
					},
					{
						"n": 3,
						"h": 292,
						"w": 545
					},
					{
						"n": 14,
						"h": 153,
						"w": 545,
						"f": 94
					},
					{
						"n": 5,
						"h": 59,
						"w": 545,
						"f": 84,
						"c": 2
					},
					{
						"n": 6,
						"h": 216,
						"w": 437
					},
					{
						"n": 7,
						"h": 232,
						"w": 328
					},
					{
						"n": 8,
						"h": 60,
						"w": 348
					},
					{
						"n": 17,
						"h": 381,
						"w": 298,
						"f": 94
					},
					{
						"n": 19,
						"h": 282,
						"w": 220
					},
					{
						"n": 11,
						"h": 160,
						"w": 220
					}
				],
				"ball": {
					"n": 0,
					"h": 190,
					"w": 34,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 150
		},
		{
			"num": 1101,
			"minute": 54,
			"messages": [],
			"T": {
				"team": 2
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 681
					},
					{
						"n": 2,
						"h": 371,
						"w": 547
					},
					{
						"n": 3,
						"h": 275,
						"w": 575
					},
					{
						"n": 4,
						"h": 170,
						"w": 576
					},
					{
						"n": 5,
						"h": 78,
						"w": 546
					},
					{
						"n": 6,
						"h": 385,
						"w": 446
					},
					{
						"n": 7,
						"h": 291,
						"w": 468
					},
					{
						"n": 8,
						"h": 171,
						"w": 474
					},
					{
						"n": 17,
						"h": 83,
						"w": 447
					},
					{
						"n": 10,
						"h": 281,
						"w": 364
					},
					{
						"n": 11,
						"h": 164,
						"w": 367
					}
				],
				"away": [
					{
						"n": 1,
						"h": 260,
						"w": 686
					},
					{
						"n": 13,
						"h": 390,
						"w": 442
					},
					{
						"n": 3,
						"h": 299,
						"w": 547
					},
					{
						"n": 14,
						"h": 160,
						"w": 539
					},
					{
						"n": 5,
						"h": 52,
						"w": 550
					},
					{
						"n": 6,
						"h": 212,
						"w": 436
					},
					{
						"n": 7,
						"h": 228,
						"w": 334
					},
					{
						"n": 8,
						"h": 57,
						"w": 348
					},
					{
						"n": 17,
						"h": 374,
						"w": 297
					},
					{
						"n": 19,
						"h": 280,
						"w": 220
					},
					{
						"n": 11,
						"h": 155,
						"w": 216
					}
				],
				"ball": {
					"n": 0,
					"h": 190,
					"w": 34,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 15
		},
		{
			"num": 1102,
			"minute": 54,
			"messages": [
				{
					"owner": 2,
					"mes": "Крыштоф Ласак[21](Опава) далеко выбивает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 710
					},
					{
						"n": 2,
						"h": 330,
						"w": 574
					},
					{
						"n": 3,
						"h": 281,
						"w": 582
					},
					{
						"n": 4,
						"h": 166,
						"w": 567
					},
					{
						"n": 5,
						"h": 120,
						"w": 579
					},
					{
						"n": 6,
						"h": 394,
						"w": 481
					},
					{
						"n": 7,
						"h": 299,
						"w": 510
					},
					{
						"n": 8,
						"h": 129,
						"w": 488
					},
					{
						"n": 17,
						"h": 76,
						"w": 458
					},
					{
						"n": 10,
						"h": 285,
						"w": 320
					},
					{
						"n": 11,
						"h": 127,
						"w": 325
					}
				],
				"away": [
					{
						"n": 1,
						"h": 233,
						"w": 666
					},
					{
						"n": 13,
						"h": 336,
						"w": 405
					},
					{
						"n": 3,
						"h": 274,
						"w": 552
					},
					{
						"n": 14,
						"h": 165,
						"w": 537
					},
					{
						"n": 5,
						"h": 59,
						"w": 527
					},
					{
						"n": 6,
						"h": 276,
						"w": 430
					},
					{
						"n": 7,
						"h": 228,
						"w": 334
					},
					{
						"n": 8,
						"h": 54,
						"w": 274
					},
					{
						"n": 17,
						"h": 374,
						"w": 297
					},
					{
						"n": 19,
						"h": 314,
						"w": 237
					},
					{
						"n": 11,
						"h": 157,
						"w": 228
					}
				],
				"ball": {
					"n": 0,
					"h": 127,
					"w": 325,
					"z": 1,
					"r": 0,
					"p": 4,
					"x": 0
				}
			},
			"interval": 74
		},
		{
			"num": 1103,
			"minute": 54,
			"messages": [
				{
					"owner": 1,
					"mes": "Адам Гилберт[11](Галвэй Юнайтед) сбрасывает мяч головой..."
				},
				{
					"owner": 2,
					"mes": "Мяч оказывается у О.Дюмона[26](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 710
					},
					{
						"n": 2,
						"h": 330,
						"w": 598
					},
					{
						"n": 3,
						"h": 278,
						"w": 606
					},
					{
						"n": 4,
						"h": 164,
						"w": 591
					},
					{
						"n": 5,
						"h": 120,
						"w": 602
					},
					{
						"n": 6,
						"h": 394,
						"w": 504
					},
					{
						"n": 7,
						"h": 293,
						"w": 512
					},
					{
						"n": 8,
						"h": 137,
						"w": 511
					},
					{
						"n": 17,
						"h": 72,
						"w": 482
					},
					{
						"n": 10,
						"h": 262,
						"w": 314
					},
					{
						"n": 11,
						"h": 127,
						"w": 325
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 650
					},
					{
						"n": 13,
						"h": 336,
						"w": 405
					},
					{
						"n": 3,
						"h": 270,
						"w": 545
					},
					{
						"n": 14,
						"h": 166,
						"w": 535
					},
					{
						"n": 5,
						"h": 69,
						"w": 533
					},
					{
						"n": 6,
						"h": 299,
						"w": 437
					},
					{
						"n": 7,
						"h": 231,
						"w": 311
					},
					{
						"n": 8,
						"h": 49,
						"w": 251
					},
					{
						"n": 17,
						"h": 378,
						"w": 273
					},
					{
						"n": 19,
						"h": 307,
						"w": 216
					},
					{
						"n": 11,
						"h": 157,
						"w": 228
					}
				],
				"ball": {
					"n": 0,
					"h": 151,
					"w": 283,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 24
		},
		{
			"num": 1104,
			"minute": 54,
			"messages": [
				{
					"owner": 2,
					"mes": "Оливье Дюмон[26](Опава) отпасовывает назад..."
				},
				{
					"owner": 2,
					"mes": "Крыштоф Ласак[21](Опава) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 709
					},
					{
						"n": 2,
						"h": 330,
						"w": 541
					},
					{
						"n": 3,
						"h": 276,
						"w": 549
					},
					{
						"n": 4,
						"h": 163,
						"w": 534
					},
					{
						"n": 5,
						"h": 120,
						"w": 545
					},
					{
						"n": 6,
						"h": 382,
						"w": 511
					},
					{
						"n": 7,
						"h": 294,
						"w": 470
					},
					{
						"n": 8,
						"h": 143,
						"w": 461
					},
					{
						"n": 17,
						"h": 67,
						"w": 511
					},
					{
						"n": 10,
						"h": 319,
						"w": 320
					},
					{
						"n": 11,
						"h": 127,
						"w": 270
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 594
					},
					{
						"n": 13,
						"h": 391,
						"w": 388
					},
					{
						"n": 3,
						"h": 269,
						"w": 533
					},
					{
						"n": 14,
						"h": 171,
						"w": 506
					},
					{
						"n": 5,
						"h": 69,
						"w": 511
					},
					{
						"n": 6,
						"h": 289,
						"w": 434
					},
					{
						"n": 7,
						"h": 235,
						"w": 319
					},
					{
						"n": 8,
						"h": 53,
						"w": 234
					},
					{
						"n": 17,
						"h": 398,
						"w": 234
					},
					{
						"n": 19,
						"h": 300,
						"w": 211
					},
					{
						"n": 11,
						"h": 157,
						"w": 230
					}
				],
				"ball": {
					"n": 0,
					"h": 228,
					"w": 126,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 57
		},
		{
			"num": 1105,
			"minute": 54,
			"messages": [
				{
					"owner": 2,
					"mes": "Передача вперед..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 709
					},
					{
						"n": 2,
						"h": 330,
						"w": 501
					},
					{
						"n": 3,
						"h": 279,
						"w": 509
					},
					{
						"n": 4,
						"h": 167,
						"w": 494
					},
					{
						"n": 5,
						"h": 120,
						"w": 505
					},
					{
						"n": 6,
						"h": 384,
						"w": 471
					},
					{
						"n": 7,
						"h": 301,
						"w": 431
					},
					{
						"n": 8,
						"h": 148,
						"w": 421
					},
					{
						"n": 17,
						"h": 62,
						"w": 471
					},
					{
						"n": 10,
						"h": 282,
						"w": 304
					},
					{
						"n": 11,
						"h": 143,
						"w": 270
					}
				],
				"away": [
					{
						"n": 1,
						"h": 221,
						"w": 604
					},
					{
						"n": 13,
						"h": 401,
						"w": 427
					},
					{
						"n": 3,
						"h": 297,
						"w": 523
					},
					{
						"n": 14,
						"h": 168,
						"w": 546
					},
					{
						"n": 5,
						"h": 51,
						"w": 523
					},
					{
						"n": 6,
						"h": 249,
						"w": 437
					},
					{
						"n": 7,
						"h": 232,
						"w": 359
					},
					{
						"n": 8,
						"h": 51,
						"w": 274
					},
					{
						"n": 17,
						"h": 404,
						"w": 274
					},
					{
						"n": 19,
						"h": 299,
						"w": 251
					},
					{
						"n": 11,
						"h": 157,
						"w": 270
					}
				],
				"ball": {
					"n": 0,
					"h": 233,
					"w": 245,
					"z": 0,
					"r": 0,
					"p": 2,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1106,
			"minute": 54,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 705
					},
					{
						"n": 2,
						"h": 312,
						"w": 485
					},
					{
						"n": 3,
						"h": 262,
						"w": 492
					},
					{
						"n": 4,
						"h": 175,
						"w": 472
					},
					{
						"n": 5,
						"h": 120,
						"w": 481
					},
					{
						"n": 6,
						"h": 386,
						"w": 450
					},
					{
						"n": 7,
						"h": 296,
						"w": 418
					},
					{
						"n": 8,
						"h": 154,
						"w": 398
					},
					{
						"n": 17,
						"h": 59,
						"w": 450
					},
					{
						"n": 10,
						"h": 259,
						"w": 295
					},
					{
						"n": 11,
						"h": 146,
						"w": 270
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 623
					},
					{
						"n": 13,
						"h": 406,
						"w": 450
					},
					{
						"n": 3,
						"h": 290,
						"w": 536
					},
					{
						"n": 14,
						"h": 167,
						"w": 570
					},
					{
						"n": 5,
						"h": 40,
						"w": 536
					},
					{
						"n": 6,
						"h": 225,
						"w": 438
					},
					{
						"n": 7,
						"h": 225,
						"w": 382
					},
					{
						"n": 8,
						"h": 49,
						"w": 298
					},
					{
						"n": 17,
						"h": 406,
						"w": 298
					},
					{
						"n": 19,
						"h": 288,
						"w": 272
					},
					{
						"n": 11,
						"h": 153,
						"w": 280
					}
				],
				"ball": {
					"n": 0,
					"h": 235,
					"w": 281,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 24
		},
		{
			"num": 1107,
			"minute": 54,
			"messages": [
				{
					"owner": 2,
					"mes": "Мяч подбирает О.Дюмон[26](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 709
					},
					{
						"n": 2,
						"h": 306,
						"w": 477
					},
					{
						"n": 3,
						"h": 255,
						"w": 485
					},
					{
						"n": 4,
						"h": 175,
						"w": 462
					},
					{
						"n": 5,
						"h": 120,
						"w": 471
					},
					{
						"n": 6,
						"h": 387,
						"w": 445
					},
					{
						"n": 7,
						"h": 299,
						"w": 408
					},
					{
						"n": 8,
						"h": 160,
						"w": 390
					},
					{
						"n": 17,
						"h": 57,
						"w": 440
					},
					{
						"n": 10,
						"h": 250,
						"w": 291
					},
					{
						"n": 11,
						"h": 136,
						"w": 270
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 631
					},
					{
						"n": 13,
						"h": 409,
						"w": 460
					},
					{
						"n": 3,
						"h": 293,
						"w": 546
					},
					{
						"n": 14,
						"h": 166,
						"w": 579
					},
					{
						"n": 5,
						"h": 43,
						"w": 546
					},
					{
						"n": 6,
						"h": 215,
						"w": 439
					},
					{
						"n": 7,
						"h": 227,
						"w": 392
					},
					{
						"n": 8,
						"h": 48,
						"w": 308
					},
					{
						"n": 17,
						"h": 408,
						"w": 307
					},
					{
						"n": 19,
						"h": 286,
						"w": 280
					},
					{
						"n": 11,
						"h": 150,
						"w": 280
					}
				],
				"ball": {
					"n": 0,
					"h": 235,
					"w": 281,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 10
		},
		{
			"num": 1108,
			"minute": 54,
			"messages": [
				{
					"owner": 2,
					"mes": "Оливье Дюмон[26](Опава) отпасовывает вперед М.Манолову[27](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 706
					},
					{
						"n": 2,
						"h": 324,
						"w": 493
					},
					{
						"n": 3,
						"h": 272,
						"w": 481
					},
					{
						"n": 4,
						"h": 169,
						"w": 485
					},
					{
						"n": 5,
						"h": 120,
						"w": 495
					},
					{
						"n": 6,
						"h": 394,
						"w": 423
					},
					{
						"n": 7,
						"h": 275,
						"w": 408
					},
					{
						"n": 8,
						"h": 176,
						"w": 408
					},
					{
						"n": 17,
						"h": 56,
						"w": 426
					},
					{
						"n": 10,
						"h": 237,
						"w": 311
					},
					{
						"n": 11,
						"h": 160,
						"w": 270
					}
				],
				"away": [
					{
						"n": 1,
						"h": 226,
						"w": 630
					},
					{
						"n": 13,
						"h": 417,
						"w": 482
					},
					{
						"n": 3,
						"h": 284,
						"w": 568
					},
					{
						"n": 14,
						"h": 160,
						"w": 569
					},
					{
						"n": 5,
						"h": 48,
						"w": 569
					},
					{
						"n": 6,
						"h": 219,
						"w": 449
					},
					{
						"n": 7,
						"h": 227,
						"w": 392
					},
					{
						"n": 8,
						"h": 47,
						"w": 332
					},
					{
						"n": 17,
						"h": 407,
						"w": 329
					},
					{
						"n": 19,
						"h": 293,
						"w": 257
					},
					{
						"n": 11,
						"h": 161,
						"w": 258
					}
				],
				"ball": {
					"n": 0,
					"h": 223,
					"w": 328,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 24
		},
		{
			"num": 1109,
			"minute": 54,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 703
					},
					{
						"n": 2,
						"h": 330,
						"w": 508
					},
					{
						"n": 3,
						"h": 292,
						"w": 512
					},
					{
						"n": 4,
						"h": 202,
						"w": 508
					},
					{
						"n": 5,
						"h": 120,
						"w": 513
					},
					{
						"n": 6,
						"h": 394,
						"w": 463
					},
					{
						"n": 7,
						"h": 261,
						"w": 431
					},
					{
						"n": 8,
						"h": 222,
						"w": 385
					},
					{
						"n": 17,
						"h": 56,
						"w": 465
					},
					{
						"n": 10,
						"h": 230,
						"w": 351
					},
					{
						"n": 11,
						"h": 173,
						"w": 270
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 629
					},
					{
						"n": 13,
						"h": 407,
						"w": 444
					},
					{
						"n": 3,
						"h": 277,
						"w": 552
					},
					{
						"n": 14,
						"h": 185,
						"w": 568
					},
					{
						"n": 5,
						"h": 66,
						"w": 562
					},
					{
						"n": 6,
						"h": 228,
						"w": 449
					},
					{
						"n": 7,
						"h": 227,
						"w": 354
					},
					{
						"n": 8,
						"h": 45,
						"w": 292
					},
					{
						"n": 17,
						"h": 412,
						"w": 290
					},
					{
						"n": 19,
						"h": 275,
						"w": 225
					},
					{
						"n": 11,
						"h": 121,
						"w": 257
					}
				],
				"ball": {
					"n": 0,
					"h": 223,
					"w": 366,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1110,
			"minute": 54,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 704
					},
					{
						"n": 2,
						"h": 347,
						"w": 533
					},
					{
						"n": 3,
						"h": 311,
						"w": 544
					},
					{
						"n": 4,
						"h": 187,
						"w": 530
					},
					{
						"n": 5,
						"h": 120,
						"w": 545
					},
					{
						"n": 6,
						"h": 394,
						"w": 503
					},
					{
						"n": 7,
						"h": 255,
						"w": 468
					},
					{
						"n": 8,
						"h": 256,
						"w": 392
					},
					{
						"n": 17,
						"h": 56,
						"w": 505
					},
					{
						"n": 10,
						"h": 245,
						"w": 364
					},
					{
						"n": 11,
						"h": 169,
						"w": 270
					}
				],
				"away": [
					{
						"n": 1,
						"h": 221,
						"w": 631
					},
					{
						"n": 13,
						"h": 402,
						"w": 404
					},
					{
						"n": 3,
						"h": 281,
						"w": 512
					},
					{
						"n": 14,
						"h": 174,
						"w": 530
					},
					{
						"n": 5,
						"h": 59,
						"w": 523
					},
					{
						"n": 6,
						"h": 225,
						"w": 409
					},
					{
						"n": 7,
						"h": 193,
						"w": 345
					},
					{
						"n": 8,
						"h": 44,
						"w": 252
					},
					{
						"n": 17,
						"h": 408,
						"w": 250
					},
					{
						"n": 19,
						"h": 295,
						"w": 202
					},
					{
						"n": 11,
						"h": 101,
						"w": 228
					}
				],
				"ball": {
					"n": 0,
					"h": 257,
					"w": 375,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1111,
			"minute": 54,
			"messages": [
				{
					"owner": 2,
					"mes": "Мирослав Манолов[27](Опава) пасует на ближайшего партнера по команде..."
				},
				{
					"owner": 2,
					"mes": "Оливье Дюмон[26](Опава) с мячом..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 705
					},
					{
						"n": 2,
						"h": 361,
						"w": 522
					},
					{
						"n": 3,
						"h": 289,
						"w": 548
					},
					{
						"n": 4,
						"h": 169,
						"w": 544
					},
					{
						"n": 5,
						"h": 120,
						"w": 568
					},
					{
						"n": 6,
						"h": 394,
						"w": 526
					},
					{
						"n": 7,
						"h": 271,
						"w": 482
					},
					{
						"n": 8,
						"h": 244,
						"w": 411
					},
					{
						"n": 17,
						"h": 56,
						"w": 528
					},
					{
						"n": 10,
						"h": 243,
						"w": 352
					},
					{
						"n": 11,
						"h": 174,
						"w": 270
					}
				],
				"away": [
					{
						"n": 1,
						"h": 229,
						"w": 616
					},
					{
						"n": 13,
						"h": 398,
						"w": 381
					},
					{
						"n": 3,
						"h": 276,
						"w": 495
					},
					{
						"n": 14,
						"h": 173,
						"w": 519
					},
					{
						"n": 5,
						"h": 59,
						"w": 500
					},
					{
						"n": 6,
						"h": 207,
						"w": 388
					},
					{
						"n": 7,
						"h": 193,
						"w": 345,
						"m": 550
					},
					{
						"n": 8,
						"h": 44,
						"w": 229
					},
					{
						"n": 17,
						"h": 412,
						"w": 227
					},
					{
						"n": 19,
						"h": 301,
						"w": 184
					},
					{
						"n": 11,
						"h": 80,
						"w": 218
					}
				],
				"ball": {
					"n": 0,
					"h": 243,
					"w": 332,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 23
		},
		{
			"num": 1112,
			"minute": 54,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 705
					},
					{
						"n": 2,
						"h": 367,
						"w": 551
					},
					{
						"n": 3,
						"h": 254,
						"w": 568
					},
					{
						"n": 4,
						"h": 171,
						"w": 580
					},
					{
						"n": 5,
						"h": 120,
						"w": 580
					},
					{
						"n": 6,
						"h": 393,
						"w": 549
					},
					{
						"n": 7,
						"h": 267,
						"w": 512
					},
					{
						"n": 8,
						"h": 216,
						"w": 441
					},
					{
						"n": 17,
						"h": 56,
						"w": 547
					},
					{
						"n": 10,
						"h": 277,
						"w": 362
					},
					{
						"n": 11,
						"h": 138,
						"w": 270
					}
				],
				"away": [
					{
						"n": 1,
						"h": 226,
						"w": 618
					},
					{
						"n": 13,
						"h": 394,
						"w": 341
					},
					{
						"n": 3,
						"h": 273,
						"w": 494
					},
					{
						"n": 14,
						"h": 183,
						"w": 480
					},
					{
						"n": 5,
						"h": 71,
						"w": 468
					},
					{
						"n": 6,
						"h": 173,
						"w": 378
					},
					{
						"n": 7,
						"h": 206,
						"w": 307
					},
					{
						"n": 8,
						"h": 57,
						"w": 206
					},
					{
						"n": 17,
						"h": 417,
						"w": 188
					},
					{
						"n": 19,
						"h": 280,
						"w": 162
					},
					{
						"n": 11,
						"h": 53,
						"w": 189
					}
				],
				"ball": {
					"n": 0,
					"h": 277,
					"w": 342,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1113,
			"minute": 54,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 702
					},
					{
						"n": 2,
						"h": 371,
						"w": 591
					},
					{
						"n": 3,
						"h": 230,
						"w": 600
					},
					{
						"n": 4,
						"h": 148,
						"w": 598
					},
					{
						"n": 5,
						"h": 81,
						"w": 588
					},
					{
						"n": 6,
						"h": 394,
						"w": 569
					},
					{
						"n": 7,
						"h": 273,
						"w": 514
					},
					{
						"n": 8,
						"h": 200,
						"w": 477
					},
					{
						"n": 17,
						"h": 53,
						"w": 508
					},
					{
						"n": 10,
						"h": 242,
						"w": 367
					},
					{
						"n": 11,
						"h": 132,
						"w": 282
					}
				],
				"away": [
					{
						"n": 1,
						"h": 229,
						"w": 595
					},
					{
						"n": 13,
						"h": 404,
						"w": 303
					},
					{
						"n": 3,
						"h": 278,
						"w": 464
					},
					{
						"n": 14,
						"h": 172,
						"w": 460
					},
					{
						"n": 5,
						"h": 65,
						"w": 432
					},
					{
						"n": 6,
						"h": 208,
						"w": 373
					},
					{
						"n": 7,
						"h": 221,
						"w": 314
					},
					{
						"n": 8,
						"h": 49,
						"w": 186
					},
					{
						"n": 17,
						"h": 418,
						"w": 148
					},
					{
						"n": 19,
						"h": 297,
						"w": 130
					},
					{
						"n": 11,
						"h": 49,
						"w": 149
					}
				],
				"ball": {
					"n": 0,
					"h": 242,
					"w": 347,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1114,
			"minute": 54,
			"messages": [
				{
					"owner": 2,
					"mes": "Передача вперед..."
				},
				{
					"owner": 2,
					"mes": "Для Д.Квигли[10](Галвэй Юнайтед) не составляет особого труда перехватить этот пас!..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 708
					},
					{
						"n": 2,
						"h": 377,
						"w": 590
					},
					{
						"n": 3,
						"h": 229,
						"w": 607
					},
					{
						"n": 4,
						"h": 150,
						"w": 605
					},
					{
						"n": 5,
						"h": 74,
						"w": 589
					},
					{
						"n": 6,
						"h": 394,
						"w": 576
					},
					{
						"n": 7,
						"h": 273,
						"w": 521
					},
					{
						"n": 8,
						"h": 203,
						"w": 471
					},
					{
						"n": 17,
						"h": 53,
						"w": 501
					},
					{
						"n": 10,
						"h": 240,
						"w": 360
					},
					{
						"n": 11,
						"h": 133,
						"w": 288
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 593
					},
					{
						"n": 13,
						"h": 403,
						"w": 296
					},
					{
						"n": 3,
						"h": 282,
						"w": 459
					},
					{
						"n": 14,
						"h": 176,
						"w": 455
					},
					{
						"n": 5,
						"h": 63,
						"w": 439
					},
					{
						"n": 6,
						"h": 208,
						"w": 373,
						"m": 650
					},
					{
						"n": 7,
						"h": 219,
						"w": 320,
						"m": 540
					},
					{
						"n": 8,
						"h": 51,
						"w": 179
					},
					{
						"n": 17,
						"h": 412,
						"w": 150
					},
					{
						"n": 19,
						"h": 300,
						"w": 137
					},
					{
						"n": 11,
						"h": 43,
						"w": 150
					}
				],
				"ball": {
					"n": 0,
					"h": 240,
					"w": 360,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 7
		},
		{
			"num": 1115,
			"minute": 54,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 707
					},
					{
						"n": 2,
						"h": 380,
						"w": 566
					},
					{
						"n": 3,
						"h": 263,
						"w": 586
					},
					{
						"n": 4,
						"h": 169,
						"w": 572
					},
					{
						"n": 5,
						"h": 73,
						"w": 549
					},
					{
						"n": 6,
						"h": 395,
						"w": 536
					},
					{
						"n": 7,
						"h": 279,
						"w": 482
					},
					{
						"n": 8,
						"h": 187,
						"w": 434
					},
					{
						"n": 17,
						"h": 53,
						"w": 461
					},
					{
						"n": 10,
						"h": 205,
						"w": 360,
						"m": 780
					},
					{
						"n": 11,
						"h": 142,
						"w": 288
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 636
					},
					{
						"n": 13,
						"h": 410,
						"w": 335
					},
					{
						"n": 3,
						"h": 309,
						"w": 481
					},
					{
						"n": 14,
						"h": 214,
						"w": 467
					},
					{
						"n": 5,
						"h": 90,
						"w": 469
					},
					{
						"n": 6,
						"h": 237,
						"w": 397
					},
					{
						"n": 7,
						"h": 235,
						"w": 357
					},
					{
						"n": 8,
						"h": 49,
						"w": 219
					},
					{
						"n": 17,
						"h": 412,
						"w": 190
					},
					{
						"n": 19,
						"h": 281,
						"w": 168
					},
					{
						"n": 11,
						"h": 62,
						"w": 184
					}
				],
				"ball": {
					"n": 0,
					"h": 205,
					"w": 360,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1116,
			"minute": 54,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 704
					},
					{
						"n": 2,
						"h": 381,
						"w": 541
					},
					{
						"n": 3,
						"h": 269,
						"w": 546
					},
					{
						"n": 4,
						"h": 167,
						"w": 545
					},
					{
						"n": 5,
						"h": 66,
						"w": 510
					},
					{
						"n": 6,
						"h": 397,
						"w": 496
					},
					{
						"n": 7,
						"h": 305,
						"w": 451
					},
					{
						"n": 8,
						"h": 178,
						"w": 395
					},
					{
						"n": 17,
						"h": 46,
						"w": 421
					},
					{
						"n": 10,
						"h": 222,
						"w": 329
					},
					{
						"n": 11,
						"h": 154,
						"w": 262
					}
				],
				"away": [
					{
						"n": 1,
						"h": 223,
						"w": 648
					},
					{
						"n": 13,
						"h": 410,
						"w": 375
					},
					{
						"n": 3,
						"h": 295,
						"w": 505
					},
					{
						"n": 14,
						"h": 221,
						"w": 506
					},
					{
						"n": 5,
						"h": 106,
						"w": 505
					},
					{
						"n": 6,
						"h": 266,
						"w": 424
					},
					{
						"n": 7,
						"h": 230,
						"w": 397
					},
					{
						"n": 8,
						"h": 49,
						"w": 259
					},
					{
						"n": 17,
						"h": 410,
						"w": 230
					},
					{
						"n": 19,
						"h": 283,
						"w": 195
					},
					{
						"n": 11,
						"h": 87,
						"w": 216
					}
				],
				"ball": {
					"n": 0,
					"h": 222,
					"w": 329,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1117,
			"minute": 54,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 701
					},
					{
						"n": 2,
						"h": 378,
						"w": 501
					},
					{
						"n": 3,
						"h": 283,
						"w": 513
					},
					{
						"n": 4,
						"h": 182,
						"w": 523
					},
					{
						"n": 5,
						"h": 63,
						"w": 479
					},
					{
						"n": 6,
						"h": 394,
						"w": 456
					},
					{
						"n": 7,
						"h": 313,
						"w": 412
					},
					{
						"n": 8,
						"h": 164,
						"w": 358
					},
					{
						"n": 17,
						"h": 41,
						"w": 381
					},
					{
						"n": 10,
						"h": 245,
						"w": 356
					},
					{
						"n": 11,
						"h": 162,
						"w": 241
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 650
					},
					{
						"n": 13,
						"h": 406,
						"w": 375
					},
					{
						"n": 3,
						"h": 286,
						"w": 541
					},
					{
						"n": 14,
						"h": 219,
						"w": 546
					},
					{
						"n": 5,
						"h": 110,
						"w": 537
					},
					{
						"n": 6,
						"h": 276,
						"w": 462
					},
					{
						"n": 7,
						"h": 208,
						"w": 383
					},
					{
						"n": 8,
						"h": 49,
						"w": 299
					},
					{
						"n": 17,
						"h": 409,
						"w": 269
					},
					{
						"n": 19,
						"h": 268,
						"w": 217
					},
					{
						"n": 11,
						"h": 103,
						"w": 252
					}
				],
				"ball": {
					"n": 0,
					"h": 245,
					"w": 356,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1118,
			"minute": 54,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 708
					},
					{
						"n": 2,
						"h": 379,
						"w": 461
					},
					{
						"n": 3,
						"h": 279,
						"w": 498
					},
					{
						"n": 4,
						"h": 166,
						"w": 486
					},
					{
						"n": 5,
						"h": 67,
						"w": 439
					},
					{
						"n": 6,
						"h": 398,
						"w": 416
					},
					{
						"n": 7,
						"h": 313,
						"w": 372
					},
					{
						"n": 8,
						"h": 163,
						"w": 318
					},
					{
						"n": 17,
						"h": 51,
						"w": 343
					},
					{
						"n": 10,
						"h": 280,
						"w": 354
					},
					{
						"n": 11,
						"h": 154,
						"w": 202
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 649
					},
					{
						"n": 13,
						"h": 399,
						"w": 413
					},
					{
						"n": 3,
						"h": 299,
						"w": 565
					},
					{
						"n": 14,
						"h": 222,
						"w": 570
					},
					{
						"n": 5,
						"h": 110,
						"w": 577
					},
					{
						"n": 6,
						"h": 290,
						"w": 500
					},
					{
						"n": 7,
						"h": 171,
						"w": 387
					},
					{
						"n": 8,
						"h": 46,
						"w": 339
					},
					{
						"n": 17,
						"h": 408,
						"w": 309
					},
					{
						"n": 19,
						"h": 284,
						"w": 254
					},
					{
						"n": 11,
						"h": 115,
						"w": 291
					}
				],
				"ball": {
					"n": 0,
					"h": 280,
					"w": 354,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1119,
			"minute": 54,
			"messages": [
				{
					"owner": 1,
					"mes": "Джо Квигли[10](Галвэй Юнайтед) отправляет мяч направо..."
				},
				{
					"owner": 1,
					"mes": "Киран Нолан[08](Галвэй Юнайтед) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 704
					},
					{
						"n": 2,
						"h": 380,
						"w": 426
					},
					{
						"n": 3,
						"h": 284,
						"w": 463
					},
					{
						"n": 4,
						"h": 170,
						"w": 451
					},
					{
						"n": 5,
						"h": 75,
						"w": 407
					},
					{
						"n": 6,
						"h": 396,
						"w": 381
					},
					{
						"n": 7,
						"h": 313,
						"w": 337
					},
					{
						"n": 8,
						"h": 192,
						"w": 338
					},
					{
						"n": 17,
						"h": 59,
						"w": 309
					},
					{
						"n": 10,
						"h": 281,
						"w": 344
					},
					{
						"n": 11,
						"h": 137,
						"w": 177
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 642
					},
					{
						"n": 13,
						"h": 391,
						"w": 447
					},
					{
						"n": 3,
						"h": 316,
						"w": 575
					},
					{
						"n": 14,
						"h": 220,
						"w": 575
					},
					{
						"n": 5,
						"h": 110,
						"w": 577
					},
					{
						"n": 6,
						"h": 309,
						"w": 529
					},
					{
						"n": 7,
						"h": 205,
						"w": 394
					},
					{
						"n": 8,
						"h": 53,
						"w": 373
					},
					{
						"n": 17,
						"h": 414,
						"w": 344
					},
					{
						"n": 19,
						"h": 280,
						"w": 289
					},
					{
						"n": 11,
						"h": 121,
						"w": 325
					}
				],
				"ball": {
					"n": 0,
					"h": 192,
					"w": 338,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 35
		},
		{
			"num": 1120,
			"minute": 54,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 710
					},
					{
						"n": 2,
						"h": 375,
						"w": 415
					},
					{
						"n": 3,
						"h": 278,
						"w": 449
					},
					{
						"n": 4,
						"h": 183,
						"w": 449
					},
					{
						"n": 5,
						"h": 72,
						"w": 410
					},
					{
						"n": 6,
						"h": 401,
						"w": 341
					},
					{
						"n": 7,
						"h": 313,
						"w": 297
					},
					{
						"n": 8,
						"h": 226,
						"w": 327
					},
					{
						"n": 17,
						"h": 49,
						"w": 270
					},
					{
						"n": 10,
						"h": 281,
						"w": 304
					},
					{
						"n": 11,
						"h": 164,
						"w": 171
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 649
					},
					{
						"n": 13,
						"h": 401,
						"w": 486
					},
					{
						"n": 3,
						"h": 290,
						"w": 577
					},
					{
						"n": 14,
						"h": 220,
						"w": 584
					},
					{
						"n": 5,
						"h": 110,
						"w": 586
					},
					{
						"n": 6,
						"h": 269,
						"w": 529
					},
					{
						"n": 7,
						"h": 221,
						"w": 413
					},
					{
						"n": 8,
						"h": 49,
						"w": 413
					},
					{
						"n": 17,
						"h": 422,
						"w": 383
					},
					{
						"n": 19,
						"h": 281,
						"w": 329
					},
					{
						"n": 11,
						"h": 139,
						"w": 361
					}
				],
				"ball": {
					"n": 0,
					"h": 226,
					"w": 327,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1121,
			"minute": 54,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 705
					},
					{
						"n": 2,
						"h": 389,
						"w": 404
					},
					{
						"n": 3,
						"h": 282,
						"w": 443
					},
					{
						"n": 4,
						"h": 168,
						"w": 450
					},
					{
						"n": 5,
						"h": 78,
						"w": 397
					},
					{
						"n": 6,
						"h": 401,
						"w": 301
					},
					{
						"n": 7,
						"h": 313,
						"w": 257
					},
					{
						"n": 8,
						"h": 261,
						"w": 322
					},
					{
						"n": 17,
						"h": 46,
						"w": 230
					},
					{
						"n": 10,
						"h": 278,
						"w": 264
					},
					{
						"n": 11,
						"h": 170,
						"w": 134
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 649
					},
					{
						"n": 13,
						"h": 404,
						"w": 526
					},
					{
						"n": 3,
						"h": 263,
						"w": 578
					},
					{
						"n": 14,
						"h": 180,
						"w": 578
					},
					{
						"n": 5,
						"h": 110,
						"w": 595
					},
					{
						"n": 6,
						"h": 229,
						"w": 530
					},
					{
						"n": 7,
						"h": 188,
						"w": 417
					},
					{
						"n": 8,
						"h": 49,
						"w": 453
					},
					{
						"n": 17,
						"h": 409,
						"w": 421
					},
					{
						"n": 19,
						"h": 286,
						"w": 368
					},
					{
						"n": 11,
						"h": 155,
						"w": 398
					}
				],
				"ball": {
					"n": 0,
					"h": 261,
					"w": 322,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1122,
			"minute": 54,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 702
					},
					{
						"n": 2,
						"h": 380,
						"w": 388
					},
					{
						"n": 3,
						"h": 266,
						"w": 438
					},
					{
						"n": 4,
						"h": 180,
						"w": 440
					},
					{
						"n": 5,
						"h": 76,
						"w": 387
					},
					{
						"n": 6,
						"h": 404,
						"w": 261
					},
					{
						"n": 7,
						"h": 313,
						"w": 217
					},
					{
						"n": 8,
						"h": 285,
						"w": 348
					},
					{
						"n": 17,
						"h": 47,
						"w": 190
					},
					{
						"n": 10,
						"h": 274,
						"w": 225
					},
					{
						"n": 11,
						"h": 169,
						"w": 125
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 646
					},
					{
						"n": 13,
						"h": 403,
						"w": 566
					},
					{
						"n": 3,
						"h": 281,
						"w": 593
					},
					{
						"n": 14,
						"h": 213,
						"w": 600
					},
					{
						"n": 5,
						"h": 110,
						"w": 598
					},
					{
						"n": 6,
						"h": 189,
						"w": 526
					},
					{
						"n": 7,
						"h": 165,
						"w": 391
					},
					{
						"n": 8,
						"h": 46,
						"w": 493
					},
					{
						"n": 17,
						"h": 407,
						"w": 445
					},
					{
						"n": 19,
						"h": 290,
						"w": 408
					},
					{
						"n": 11,
						"h": 166,
						"w": 420
					}
				],
				"ball": {
					"n": 0,
					"h": 285,
					"w": 348,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1123,
			"minute": 54,
			"messages": [
				{
					"owner": 1,
					"mes": "Киран Нолан[08](Галвэй Юнайтед) смотрит направо... Пас Р.Дриссенсу[04](Галвэй Юнайтед)..."
				},
				{
					"owner": 1,
					"mes": "Роббе Дриссенс[04](Галвэй Юнайтед) принимает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 703
					},
					{
						"n": 2,
						"h": 392,
						"w": 350
					},
					{
						"n": 3,
						"h": 278,
						"w": 408
					},
					{
						"n": 4,
						"h": 179,
						"w": 393
					},
					{
						"n": 5,
						"h": 63,
						"w": 355
					},
					{
						"n": 6,
						"h": 405,
						"w": 214
					},
					{
						"n": 7,
						"h": 313,
						"w": 177
					},
					{
						"n": 8,
						"h": 277,
						"w": 341
					},
					{
						"n": 17,
						"h": 62,
						"w": 160
					},
					{
						"n": 10,
						"h": 273,
						"w": 178
					},
					{
						"n": 11,
						"h": 177,
						"w": 120
					}
				],
				"away": [
					{
						"n": 1,
						"h": 228,
						"w": 650
					},
					{
						"n": 13,
						"h": 388,
						"w": 596
					},
					{
						"n": 3,
						"h": 255,
						"w": 629
					},
					{
						"n": 14,
						"h": 191,
						"w": 631
					},
					{
						"n": 5,
						"h": 110,
						"w": 626
					},
					{
						"n": 6,
						"h": 169,
						"w": 568
					},
					{
						"n": 7,
						"h": 184,
						"w": 434
					},
					{
						"n": 8,
						"h": 45,
						"w": 540
					},
					{
						"n": 17,
						"h": 418,
						"w": 480
					},
					{
						"n": 19,
						"h": 276,
						"w": 363
					},
					{
						"n": 11,
						"h": 173,
						"w": 399
					}
				],
				"ball": {
					"n": 0,
					"h": 179,
					"w": 393,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 47
		},
		{
			"num": 1124,
			"minute": 54,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 707
					},
					{
						"n": 2,
						"h": 382,
						"w": 353
					},
					{
						"n": 3,
						"h": 265,
						"w": 414
					},
					{
						"n": 4,
						"h": 213,
						"w": 384
					},
					{
						"n": 5,
						"h": 75,
						"w": 364
					},
					{
						"n": 6,
						"h": 405,
						"w": 174
					},
					{
						"n": 7,
						"h": 313,
						"w": 137
					},
					{
						"n": 8,
						"h": 247,
						"w": 315
					},
					{
						"n": 17,
						"h": 64,
						"w": 130
					},
					{
						"n": 10,
						"h": 278,
						"w": 138
					},
					{
						"n": 11,
						"h": 163,
						"w": 90
					}
				],
				"away": [
					{
						"n": 1,
						"h": 226,
						"w": 690
					},
					{
						"n": 13,
						"h": 370,
						"w": 616
					},
					{
						"n": 3,
						"h": 269,
						"w": 628
					},
					{
						"n": 14,
						"h": 190,
						"w": 649
					},
					{
						"n": 5,
						"h": 110,
						"w": 635
					},
					{
						"n": 6,
						"h": 138,
						"w": 586
					},
					{
						"n": 7,
						"h": 206,
						"w": 468
					},
					{
						"n": 8,
						"h": 45,
						"w": 580
					},
					{
						"n": 17,
						"h": 404,
						"w": 481
					},
					{
						"n": 19,
						"h": 237,
						"w": 356
					},
					{
						"n": 11,
						"h": 203,
						"w": 425
					}
				],
				"ball": {
					"n": 0,
					"h": 213,
					"w": 384,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1125,
			"minute": 54,
			"messages": [
				{
					"owner": 1,
					"mes": "Роббе Дриссенс[04](Галвэй Юнайтед) отдает пас П.Клинтону[03](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 705
					},
					{
						"n": 2,
						"h": 373,
						"w": 360
					},
					{
						"n": 3,
						"h": 271,
						"w": 392
					},
					{
						"n": 4,
						"h": 204,
						"w": 387
					},
					{
						"n": 5,
						"h": 64,
						"w": 347
					},
					{
						"n": 6,
						"h": 402,
						"w": 152
					},
					{
						"n": 7,
						"h": 313,
						"w": 114
					},
					{
						"n": 8,
						"h": 231,
						"w": 298
					},
					{
						"n": 17,
						"h": 41,
						"w": 130
					},
					{
						"n": 10,
						"h": 269,
						"w": 136
					},
					{
						"n": 11,
						"h": 156,
						"w": 90
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 709
					},
					{
						"n": 13,
						"h": 392,
						"w": 622
					},
					{
						"n": 3,
						"h": 275,
						"w": 643
					},
					{
						"n": 14,
						"h": 212,
						"w": 655
					},
					{
						"n": 5,
						"h": 132,
						"w": 642
					},
					{
						"n": 6,
						"h": 161,
						"w": 586
					},
					{
						"n": 7,
						"h": 214,
						"w": 490
					},
					{
						"n": 8,
						"h": 48,
						"w": 603
					},
					{
						"n": 17,
						"h": 407,
						"w": 499
					},
					{
						"n": 19,
						"h": 215,
						"w": 350
					},
					{
						"n": 11,
						"h": 219,
						"w": 442
					}
				],
				"ball": {
					"n": 0,
					"h": 259,
					"w": 384,
					"z": 0,
					"r": 0,
					"p": 2,
					"x": 0
				}
			},
			"interval": 23
		},
		{
			"num": 1126,
			"minute": 54,
			"messages": [
				{
					"owner": 1,
					"mes": "Патрик Клинтон[03](Галвэй Юнайтед) подрабатывает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 709
					},
					{
						"n": 2,
						"h": 374,
						"w": 347
					},
					{
						"n": 3,
						"h": 273,
						"w": 384
					},
					{
						"n": 4,
						"h": 196,
						"w": 392
					},
					{
						"n": 5,
						"h": 65,
						"w": 346
					},
					{
						"n": 6,
						"h": 398,
						"w": 138
					},
					{
						"n": 7,
						"h": 305,
						"w": 125
					},
					{
						"n": 8,
						"h": 221,
						"w": 289
					},
					{
						"n": 17,
						"h": 54,
						"w": 124
					},
					{
						"n": 10,
						"h": 262,
						"w": 124
					},
					{
						"n": 11,
						"h": 170,
						"w": 88
					}
				],
				"away": [
					{
						"n": 1,
						"h": 221,
						"w": 708
					},
					{
						"n": 13,
						"h": 396,
						"w": 632
					},
					{
						"n": 3,
						"h": 261,
						"w": 642
					},
					{
						"n": 14,
						"h": 205,
						"w": 643
					},
					{
						"n": 5,
						"h": 120,
						"w": 634
					},
					{
						"n": 6,
						"h": 172,
						"w": 595
					},
					{
						"n": 7,
						"h": 215,
						"w": 504
					},
					{
						"n": 8,
						"h": 50,
						"w": 589
					},
					{
						"n": 17,
						"h": 421,
						"w": 501
					},
					{
						"n": 19,
						"h": 202,
						"w": 346
					},
					{
						"n": 11,
						"h": 205,
						"w": 438
					}
				],
				"ball": {
					"n": 0,
					"h": 273,
					"w": 384,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 14
		},
		{
			"num": 1127,
			"minute": 54,
			"messages": [
				{
					"owner": 1,
					"mes": "Патрик Клинтон[03](Галвэй Юнайтед) отправляет мяч вперед в расчете на К.Нолана[08](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 709
					},
					{
						"n": 2,
						"h": 387,
						"w": 341
					},
					{
						"n": 3,
						"h": 272,
						"w": 394,
						"m": 660
					},
					{
						"n": 4,
						"h": 184,
						"w": 403
					},
					{
						"n": 5,
						"h": 62,
						"w": 350
					},
					{
						"n": 6,
						"h": 392,
						"w": 124
					},
					{
						"n": 7,
						"h": 313,
						"w": 150
					},
					{
						"n": 8,
						"h": 243,
						"w": 303
					},
					{
						"n": 17,
						"h": 39,
						"w": 124
					},
					{
						"n": 10,
						"h": 279,
						"w": 113
					},
					{
						"n": 11,
						"h": 151,
						"w": 84
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 710
					},
					{
						"n": 13,
						"h": 406,
						"w": 632
					},
					{
						"n": 3,
						"h": 284,
						"w": 647
					},
					{
						"n": 14,
						"h": 186,
						"w": 649
					},
					{
						"n": 5,
						"h": 97,
						"w": 623
					},
					{
						"n": 6,
						"h": 167,
						"w": 605
					},
					{
						"n": 7,
						"h": 216,
						"w": 530
					},
					{
						"n": 8,
						"h": 46,
						"w": 563
					},
					{
						"n": 17,
						"h": 410,
						"w": 505
					},
					{
						"n": 19,
						"h": 222,
						"w": 362
					},
					{
						"n": 11,
						"h": 199,
						"w": 412
					}
				],
				"ball": {
					"n": 0,
					"h": 251,
					"w": 308,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 26
		},
		{
			"num": 1128,
			"minute": 54,
			"messages": [
				{
					"owner": 1,
					"mes": "Для Ш.Товарека[31](Опава) не составляет особого труда перехватить этот пас!..."
				}
			]
		},
		{
			"num": 1129,
			"minute": 55,
			"possession": 45,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 702
					},
					{
						"n": 2,
						"h": 369,
						"w": 377
					},
					{
						"n": 3,
						"h": 241,
						"w": 411
					},
					{
						"n": 4,
						"h": 187,
						"w": 402
					},
					{
						"n": 5,
						"h": 89,
						"w": 379
					},
					{
						"n": 6,
						"h": 394,
						"w": 163
					},
					{
						"n": 7,
						"h": 302,
						"w": 188
					},
					{
						"n": 8,
						"h": 267,
						"w": 334
					},
					{
						"n": 17,
						"h": 43,
						"w": 163,
						"f": 96
					},
					{
						"n": 10,
						"h": 272,
						"w": 152
					},
					{
						"n": 11,
						"h": 144,
						"w": 123
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 706
					},
					{
						"n": 13,
						"h": 405,
						"w": 592
					},
					{
						"n": 3,
						"h": 267,
						"w": 622,
						"f": 86
					},
					{
						"n": 14,
						"h": 188,
						"w": 630
					},
					{
						"n": 5,
						"h": 68,
						"w": 627
					},
					{
						"n": 6,
						"h": 186,
						"w": 571,
						"f": 84,
						"m": 660,
						"c": 2
					},
					{
						"n": 7,
						"h": 215,
						"w": 490,
						"f": 86
					},
					{
						"n": 8,
						"h": 51,
						"w": 523
					},
					{
						"n": 17,
						"h": 404,
						"w": 466
					},
					{
						"n": 19,
						"h": 259,
						"w": 347
					},
					{
						"n": 11,
						"h": 174,
						"w": 387,
						"f": 83,
						"m": 640
					}
				],
				"ball": {
					"n": 0,
					"h": 276,
					"w": 333,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1130,
			"minute": 55,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 705
					},
					{
						"n": 2,
						"h": 362,
						"w": 387
					},
					{
						"n": 3,
						"h": 232,
						"w": 420
					},
					{
						"n": 4,
						"h": 187,
						"w": 415
					},
					{
						"n": 5,
						"h": 97,
						"w": 390
					},
					{
						"n": 6,
						"h": 396,
						"w": 176
					},
					{
						"n": 7,
						"h": 299,
						"w": 201
					},
					{
						"n": 8,
						"h": 276,
						"w": 343
					},
					{
						"n": 17,
						"h": 45,
						"w": 176
					},
					{
						"n": 10,
						"h": 272,
						"w": 165
					},
					{
						"n": 11,
						"h": 147,
						"w": 136
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 703
					},
					{
						"n": 13,
						"h": 404,
						"w": 580
					},
					{
						"n": 3,
						"h": 277,
						"w": 614
					},
					{
						"n": 14,
						"h": 182,
						"w": 618
					},
					{
						"n": 5,
						"h": 68,
						"w": 626
					},
					{
						"n": 6,
						"h": 192,
						"w": 559
					},
					{
						"n": 7,
						"h": 216,
						"w": 477
					},
					{
						"n": 8,
						"h": 48,
						"w": 511
					},
					{
						"n": 17,
						"h": 402,
						"w": 453
					},
					{
						"n": 19,
						"h": 269,
						"w": 339
					},
					{
						"n": 11,
						"h": 174,
						"w": 377
					}
				],
				"ball": {
					"n": 0,
					"h": 276,
					"w": 343,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 13
		},
		{
			"num": 1131,
			"minute": 55,
			"messages": [
				{
					"owner": 2,
					"mes": "К.Нолан[08](Галвэй Юнайтед) вступает в единоборство с Ш.Товареком[31](Опава)..."
				},
				{
					"owner": 2,
					"mes": "Шимон Товарек[31](Опава) прокидывает мяч мимо К.Нолана[08](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 707
					},
					{
						"n": 2,
						"h": 341,
						"w": 422
					},
					{
						"n": 3,
						"h": 264,
						"w": 445
					},
					{
						"n": 4,
						"h": 191,
						"w": 436
					},
					{
						"n": 5,
						"h": 112,
						"w": 427
					},
					{
						"n": 6,
						"h": 394,
						"w": 216
					},
					{
						"n": 7,
						"h": 297,
						"w": 241
					},
					{
						"n": 8,
						"h": 276,
						"w": 343,
						"m": 640
					},
					{
						"n": 17,
						"h": 47,
						"w": 216
					},
					{
						"n": 10,
						"h": 269,
						"w": 205
					},
					{
						"n": 11,
						"h": 155,
						"w": 175
					}
				],
				"away": [
					{
						"n": 1,
						"h": 228,
						"w": 707
					},
					{
						"n": 13,
						"h": 399,
						"w": 540
					},
					{
						"n": 3,
						"h": 281,
						"w": 612
					},
					{
						"n": 14,
						"h": 184,
						"w": 608
					},
					{
						"n": 5,
						"h": 60,
						"w": 601
					},
					{
						"n": 6,
						"h": 223,
						"w": 533
					},
					{
						"n": 7,
						"h": 223,
						"w": 437
					},
					{
						"n": 8,
						"h": 49,
						"w": 471
					},
					{
						"n": 17,
						"h": 404,
						"w": 413
					},
					{
						"n": 19,
						"h": 269,
						"w": 299
					},
					{
						"n": 11,
						"h": 174,
						"w": 337,
						"m": 650
					}
				],
				"ball": {
					"n": 0,
					"h": 276,
					"w": 383,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1132,
			"minute": 55,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 705
					},
					{
						"n": 2,
						"h": 331,
						"w": 460
					},
					{
						"n": 3,
						"h": 250,
						"w": 463
					},
					{
						"n": 4,
						"h": 170,
						"w": 469
					},
					{
						"n": 5,
						"h": 120,
						"w": 466
					},
					{
						"n": 6,
						"h": 402,
						"w": 255
					},
					{
						"n": 7,
						"h": 286,
						"w": 280
					},
					{
						"n": 8,
						"h": 265,
						"w": 382
					},
					{
						"n": 17,
						"h": 49,
						"w": 256
					},
					{
						"n": 10,
						"h": 276,
						"w": 244
					},
					{
						"n": 11,
						"h": 149,
						"w": 214
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 703
					},
					{
						"n": 13,
						"h": 397,
						"w": 500
					},
					{
						"n": 3,
						"h": 272,
						"w": 601
					},
					{
						"n": 14,
						"h": 169,
						"w": 605
					},
					{
						"n": 5,
						"h": 69,
						"w": 584
					},
					{
						"n": 6,
						"h": 224,
						"w": 493
					},
					{
						"n": 7,
						"h": 220,
						"w": 398
					},
					{
						"n": 8,
						"h": 49,
						"w": 431
					},
					{
						"n": 17,
						"h": 400,
						"w": 373
					},
					{
						"n": 19,
						"h": 291,
						"w": 285
					},
					{
						"n": 11,
						"h": 189,
						"w": 300
					}
				],
				"ball": {
					"n": 0,
					"h": 261,
					"w": 420,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1133,
			"minute": 55,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 705
					},
					{
						"n": 2,
						"h": 330,
						"w": 492
					},
					{
						"n": 3,
						"h": 274,
						"w": 477
					},
					{
						"n": 4,
						"h": 201,
						"w": 485
					},
					{
						"n": 5,
						"h": 120,
						"w": 490
					},
					{
						"n": 6,
						"h": 399,
						"w": 295
					},
					{
						"n": 7,
						"h": 282,
						"w": 319
					},
					{
						"n": 8,
						"h": 226,
						"w": 390
					},
					{
						"n": 17,
						"h": 50,
						"w": 276
					},
					{
						"n": 10,
						"h": 277,
						"w": 284
					},
					{
						"n": 11,
						"h": 136,
						"w": 252
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 703
					},
					{
						"n": 13,
						"h": 406,
						"w": 461
					},
					{
						"n": 3,
						"h": 267,
						"w": 580
					},
					{
						"n": 14,
						"h": 173,
						"w": 565
					},
					{
						"n": 5,
						"h": 76,
						"w": 580
					},
					{
						"n": 6,
						"h": 223,
						"w": 473
					},
					{
						"n": 7,
						"h": 223,
						"w": 358
					},
					{
						"n": 8,
						"h": 46,
						"w": 391
					},
					{
						"n": 17,
						"h": 403,
						"w": 333
					},
					{
						"n": 19,
						"h": 295,
						"w": 262
					},
					{
						"n": 11,
						"h": 174,
						"w": 263
					}
				],
				"ball": {
					"n": 0,
					"h": 276,
					"w": 457,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1134,
			"minute": 55,
			"messages": [
				{
					"owner": 2,
					"mes": "Шимон Товарек[31](Опава) делает передачу на левый край..."
				},
				{
					"owner": 2,
					"mes": "Марин Томасов[37](Опава) сбрасывает мяч себе на ход..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 710
					},
					{
						"n": 2,
						"h": 330,
						"w": 521
					},
					{
						"n": 3,
						"h": 253,
						"w": 513
					},
					{
						"n": 4,
						"h": 163,
						"w": 519
					},
					{
						"n": 5,
						"h": 113,
						"w": 482
					},
					{
						"n": 6,
						"h": 397,
						"w": 355
					},
					{
						"n": 7,
						"h": 256,
						"w": 373
					},
					{
						"n": 8,
						"h": 205,
						"w": 439
					},
					{
						"n": 17,
						"h": 60,
						"w": 293
					},
					{
						"n": 10,
						"h": 276,
						"w": 320
					},
					{
						"n": 11,
						"h": 130,
						"w": 270
					}
				],
				"away": [
					{
						"n": 1,
						"h": 221,
						"w": 683
					},
					{
						"n": 13,
						"h": 396,
						"w": 415
					},
					{
						"n": 3,
						"h": 275,
						"w": 554
					},
					{
						"n": 14,
						"h": 174,
						"w": 544
					},
					{
						"n": 5,
						"h": 70,
						"w": 548
					},
					{
						"n": 6,
						"h": 227,
						"w": 435
					},
					{
						"n": 7,
						"h": 239,
						"w": 353
					},
					{
						"n": 8,
						"h": 51,
						"w": 331
					},
					{
						"n": 17,
						"h": 343,
						"w": 331
					},
					{
						"n": 19,
						"h": 308,
						"w": 234
					},
					{
						"n": 11,
						"h": 177,
						"w": 253
					}
				],
				"ball": {
					"n": 0,
					"h": 107,
					"w": 389,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 60
		},
		{
			"num": 1135,
			"minute": 55,
			"messages": [
				{
					"owner": 2,
					"mes": "Марин Томасов[37](Опава) делает пас на М.Манолова[27](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 702
					},
					{
						"n": 2,
						"h": 330,
						"w": 547
					},
					{
						"n": 3,
						"h": 272,
						"w": 533
					},
					{
						"n": 4,
						"h": 175,
						"w": 543
					},
					{
						"n": 5,
						"h": 116,
						"w": 509
					},
					{
						"n": 6,
						"h": 396,
						"w": 382
					},
					{
						"n": 7,
						"h": 256,
						"w": 400
					},
					{
						"n": 8,
						"h": 195,
						"w": 414
					},
					{
						"n": 17,
						"h": 59,
						"w": 307
					},
					{
						"n": 10,
						"h": 273,
						"w": 320
					},
					{
						"n": 11,
						"h": 139,
						"w": 270
					}
				],
				"away": [
					{
						"n": 1,
						"h": 228,
						"w": 667
					},
					{
						"n": 13,
						"h": 395,
						"w": 388
					},
					{
						"n": 3,
						"h": 270,
						"w": 527
					},
					{
						"n": 14,
						"h": 177,
						"w": 523
					},
					{
						"n": 5,
						"h": 73,
						"w": 521
					},
					{
						"n": 6,
						"h": 221,
						"w": 414
					},
					{
						"n": 7,
						"h": 263,
						"w": 341
					},
					{
						"n": 8,
						"h": 49,
						"w": 304
					},
					{
						"n": 17,
						"h": 348,
						"w": 323,
						"m": 620
					},
					{
						"n": 19,
						"h": 303,
						"w": 207
					},
					{
						"n": 11,
						"h": 153,
						"w": 265
					}
				],
				"ball": {
					"n": 0,
					"h": 187,
					"w": 379,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 27
		},
		{
			"num": 1136,
			"minute": 55,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 709
					},
					{
						"n": 2,
						"h": 342,
						"w": 562
					},
					{
						"n": 3,
						"h": 299,
						"w": 562
					},
					{
						"n": 4,
						"h": 196,
						"w": 567
					},
					{
						"n": 5,
						"h": 139,
						"w": 541
					},
					{
						"n": 6,
						"h": 395,
						"w": 422
					},
					{
						"n": 7,
						"h": 260,
						"w": 440
					},
					{
						"n": 8,
						"h": 176,
						"w": 425
					},
					{
						"n": 17,
						"h": 63,
						"w": 327
					},
					{
						"n": 10,
						"h": 269,
						"w": 320
					},
					{
						"n": 11,
						"h": 164,
						"w": 270
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 643
					},
					{
						"n": 13,
						"h": 399,
						"w": 349
					},
					{
						"n": 3,
						"h": 286,
						"w": 492
					},
					{
						"n": 14,
						"h": 181,
						"w": 490
					},
					{
						"n": 5,
						"h": 73,
						"w": 487
					},
					{
						"n": 6,
						"h": 224,
						"w": 382
					},
					{
						"n": 7,
						"h": 272,
						"w": 317
					},
					{
						"n": 8,
						"h": 41,
						"w": 265
					},
					{
						"n": 17,
						"h": 362,
						"w": 285
					},
					{
						"n": 19,
						"h": 303,
						"w": 167
					},
					{
						"n": 11,
						"h": 113,
						"w": 267
					}
				],
				"ball": {
					"n": 0,
					"h": 178,
					"w": 403,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1137,
			"minute": 55,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 707
					},
					{
						"n": 2,
						"h": 336,
						"w": 601
					},
					{
						"n": 3,
						"h": 293,
						"w": 602
					},
					{
						"n": 4,
						"h": 188,
						"w": 606
					},
					{
						"n": 5,
						"h": 142,
						"w": 581
					},
					{
						"n": 6,
						"h": 395,
						"w": 462
					},
					{
						"n": 7,
						"h": 262,
						"w": 480
					},
					{
						"n": 8,
						"h": 150,
						"w": 433
					},
					{
						"n": 17,
						"h": 65,
						"w": 367
					},
					{
						"n": 10,
						"h": 272,
						"w": 325
					},
					{
						"n": 11,
						"h": 142,
						"w": 304
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 624
					},
					{
						"n": 13,
						"h": 397,
						"w": 309
					},
					{
						"n": 3,
						"h": 285,
						"w": 452
					},
					{
						"n": 14,
						"h": 178,
						"w": 451
					},
					{
						"n": 5,
						"h": 73,
						"w": 447
					},
					{
						"n": 6,
						"h": 217,
						"w": 343
					},
					{
						"n": 7,
						"h": 295,
						"w": 304
					},
					{
						"n": 8,
						"h": 36,
						"w": 225
					},
					{
						"n": 17,
						"h": 376,
						"w": 248
					},
					{
						"n": 19,
						"h": 315,
						"w": 129
					},
					{
						"n": 11,
						"h": 126,
						"w": 229
					}
				],
				"ball": {
					"n": 0,
					"h": 155,
					"w": 416,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1138,
			"minute": 55,
			"messages": [
				{
					"owner": 2,
					"mes": "Пас направо на О.Дюмона[26](Опава)..."
				},
				{
					"owner": 2,
					"mes": "Оливье Дюмон[26](Опава) получил мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 702
					},
					{
						"n": 2,
						"h": 330,
						"w": 600
					},
					{
						"n": 3,
						"h": 277,
						"w": 597
					},
					{
						"n": 4,
						"h": 189,
						"w": 603
					},
					{
						"n": 5,
						"h": 112,
						"w": 558
					},
					{
						"n": 6,
						"h": 394,
						"w": 500
					},
					{
						"n": 7,
						"h": 246,
						"w": 446
					},
					{
						"n": 8,
						"h": 161,
						"w": 470
					},
					{
						"n": 17,
						"h": 57,
						"w": 404
					},
					{
						"n": 10,
						"h": 272,
						"w": 320
					},
					{
						"n": 11,
						"h": 177,
						"w": 287
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 605
					},
					{
						"n": 13,
						"h": 400,
						"w": 271
					},
					{
						"n": 3,
						"h": 269,
						"w": 446
					},
					{
						"n": 14,
						"h": 178,
						"w": 448
					},
					{
						"n": 5,
						"h": 59,
						"w": 428
					},
					{
						"n": 6,
						"h": 224,
						"w": 331
					},
					{
						"n": 7,
						"h": 286,
						"w": 301,
						"m": 550
					},
					{
						"n": 8,
						"h": 44,
						"w": 188
					},
					{
						"n": 17,
						"h": 383,
						"w": 211
					},
					{
						"n": 19,
						"h": 278,
						"w": 121
					},
					{
						"n": 11,
						"h": 160,
						"w": 213
					}
				],
				"ball": {
					"n": 0,
					"h": 226,
					"w": 389,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 38
		},
		{
			"num": 1139,
			"minute": 55,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 706
					},
					{
						"n": 2,
						"h": 330,
						"w": 615
					},
					{
						"n": 3,
						"h": 272,
						"w": 612
					},
					{
						"n": 4,
						"h": 185,
						"w": 615
					},
					{
						"n": 5,
						"h": 73,
						"w": 557
					},
					{
						"n": 6,
						"h": 394,
						"w": 539
					},
					{
						"n": 7,
						"h": 229,
						"w": 436
					},
					{
						"n": 8,
						"h": 177,
						"w": 505
					},
					{
						"n": 17,
						"h": 57,
						"w": 443
					},
					{
						"n": 10,
						"h": 280,
						"w": 322
					},
					{
						"n": 11,
						"h": 145,
						"w": 310
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 602
					},
					{
						"n": 13,
						"h": 404,
						"w": 232
					},
					{
						"n": 3,
						"h": 277,
						"w": 430
					},
					{
						"n": 14,
						"h": 170,
						"w": 432
					},
					{
						"n": 5,
						"h": 67,
						"w": 416
					},
					{
						"n": 6,
						"h": 221,
						"w": 306
					},
					{
						"n": 7,
						"h": 266,
						"w": 267
					},
					{
						"n": 8,
						"h": 25,
						"w": 169
					},
					{
						"n": 17,
						"h": 411,
						"w": 183
					},
					{
						"n": 19,
						"h": 297,
						"w": 144
					},
					{
						"n": 11,
						"h": 138,
						"w": 204
					}
				],
				"ball": {
					"n": 0,
					"h": 229,
					"w": 414,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 1140,
			"minute": 55,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 704
					},
					{
						"n": 2,
						"h": 369,
						"w": 608
					},
					{
						"n": 3,
						"h": 262,
						"w": 620
					},
					{
						"n": 4,
						"h": 176,
						"w": 620
					},
					{
						"n": 5,
						"h": 71,
						"w": 597
					},
					{
						"n": 6,
						"h": 425,
						"w": 513
					},
					{
						"n": 7,
						"h": 191,
						"w": 440
					},
					{
						"n": 8,
						"h": 193,
						"w": 540
					},
					{
						"n": 17,
						"h": 56,
						"w": 483
					},
					{
						"n": 10,
						"h": 278,
						"w": 320
					},
					{
						"n": 11,
						"h": 133,
						"w": 288
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 599
					},
					{
						"n": 13,
						"h": 414,
						"w": 265
					},
					{
						"n": 3,
						"h": 281,
						"w": 455
					},
					{
						"n": 14,
						"h": 172,
						"w": 451
					},
					{
						"n": 5,
						"h": 74,
						"w": 443
					},
					{
						"n": 6,
						"h": 255,
						"w": 297
					},
					{
						"n": 7,
						"h": 260,
						"w": 228
					},
					{
						"n": 8,
						"h": 43,
						"w": 133
					},
					{
						"n": 17,
						"h": 409,
						"w": 143
					},
					{
						"n": 19,
						"h": 317,
						"w": 124
					},
					{
						"n": 11,
						"h": 148,
						"w": 165
					}
				],
				"ball": {
					"n": 0,
					"h": 195,
					"w": 423,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1141,
			"minute": 55,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 701
					},
					{
						"n": 2,
						"h": 384,
						"w": 615
					},
					{
						"n": 3,
						"h": 275,
						"w": 620
					},
					{
						"n": 4,
						"h": 168,
						"w": 621
					},
					{
						"n": 5,
						"h": 65,
						"w": 615
					},
					{
						"n": 6,
						"h": 413,
						"w": 520
					},
					{
						"n": 7,
						"h": 229,
						"w": 454
					},
					{
						"n": 8,
						"h": 208,
						"w": 541
					},
					{
						"n": 17,
						"h": 56,
						"w": 479
					},
					{
						"n": 10,
						"h": 277,
						"w": 320
					},
					{
						"n": 11,
						"h": 131,
						"w": 305
					}
				],
				"away": [
					{
						"n": 1,
						"h": 226,
						"w": 598
					},
					{
						"n": 13,
						"h": 396,
						"w": 276
					},
					{
						"n": 3,
						"h": 277,
						"w": 436
					},
					{
						"n": 14,
						"h": 173,
						"w": 442
					},
					{
						"n": 5,
						"h": 62,
						"w": 407
					},
					{
						"n": 6,
						"h": 221,
						"w": 288
					},
					{
						"n": 7,
						"h": 250,
						"w": 189
					},
					{
						"n": 8,
						"h": 50,
						"w": 118
					},
					{
						"n": 17,
						"h": 401,
						"w": 113
					},
					{
						"n": 19,
						"h": 297,
						"w": 118
					},
					{
						"n": 11,
						"h": 164,
						"w": 129
					}
				],
				"ball": {
					"n": 0,
					"h": 229,
					"w": 432,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1142,
			"minute": 55,
			"messages": [
				{
					"owner": 2,
					"mes": "Оливье Дюмон[26](Опава) отпасовывает вперед Ш.Товареку[31](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 706
					},
					{
						"n": 2,
						"h": 361,
						"w": 612
					},
					{
						"n": 3,
						"h": 234,
						"w": 628
					},
					{
						"n": 4,
						"h": 170,
						"w": 625
					},
					{
						"n": 5,
						"h": 69,
						"w": 617
					},
					{
						"n": 6,
						"h": 413,
						"w": 527
					},
					{
						"n": 7,
						"h": 244,
						"w": 493
					},
					{
						"n": 8,
						"h": 245,
						"w": 561
					},
					{
						"n": 17,
						"h": 56,
						"w": 483
					},
					{
						"n": 10,
						"h": 282,
						"w": 328
					},
					{
						"n": 11,
						"h": 171,
						"w": 317
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 597
					},
					{
						"n": 13,
						"h": 394,
						"w": 272
					},
					{
						"n": 3,
						"h": 276,
						"w": 416
					},
					{
						"n": 14,
						"h": 168,
						"w": 432
					},
					{
						"n": 5,
						"h": 65,
						"w": 396
					},
					{
						"n": 6,
						"h": 219,
						"w": 298
					},
					{
						"n": 7,
						"h": 255,
						"w": 164
					},
					{
						"n": 8,
						"h": 59,
						"w": 128
					},
					{
						"n": 17,
						"h": 411,
						"w": 123
					},
					{
						"n": 19,
						"h": 281,
						"w": 110
					},
					{
						"n": 11,
						"h": 178,
						"w": 169
					}
				],
				"ball": {
					"n": 0,
					"h": 272,
					"w": 551,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 42
		},
		{
			"num": 1143,
			"minute": 55,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 236,
						"w": 710
					},
					{
						"n": 2,
						"h": 370,
						"w": 634
					},
					{
						"n": 3,
						"h": 222,
						"w": 666
					},
					{
						"n": 4,
						"h": 173,
						"w": 665
					},
					{
						"n": 5,
						"h": 94,
						"w": 648
					},
					{
						"n": 6,
						"h": 412,
						"w": 547
					},
					{
						"n": 7,
						"h": 252,
						"w": 533
					},
					{
						"n": 8,
						"h": 296,
						"w": 568
					},
					{
						"n": 17,
						"h": 56,
						"w": 522
					},
					{
						"n": 10,
						"h": 276,
						"w": 330
					},
					{
						"n": 11,
						"h": 179,
						"w": 320
					}
				],
				"away": [
					{
						"n": 1,
						"h": 228,
						"w": 599
					},
					{
						"n": 13,
						"h": 403,
						"w": 233
					},
					{
						"n": 3,
						"h": 271,
						"w": 419
					},
					{
						"n": 14,
						"h": 174,
						"w": 421
					},
					{
						"n": 5,
						"h": 73,
						"w": 398
					},
					{
						"n": 6,
						"h": 237,
						"w": 289
					},
					{
						"n": 7,
						"h": 238,
						"w": 128
					},
					{
						"n": 8,
						"h": 66,
						"w": 83
					},
					{
						"n": 17,
						"h": 395,
						"w": 86
					},
					{
						"n": 19,
						"h": 295,
						"w": 72
					},
					{
						"n": 11,
						"h": 138,
						"w": 169
					}
				],
				"ball": {
					"n": 0,
					"h": 312,
					"w": 551,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1144,
			"minute": 55,
			"messages": [
				{
					"owner": 2,
					"mes": "Пас налево..."
				},
				{
					"owner": 2,
					"mes": "Мирослав Манолов[27](Опава) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 219,
						"w": 706
					},
					{
						"n": 2,
						"h": 364,
						"w": 658
					},
					{
						"n": 3,
						"h": 190,
						"w": 630
					},
					{
						"n": 4,
						"h": 164,
						"w": 662
					},
					{
						"n": 5,
						"h": 69,
						"w": 649
					},
					{
						"n": 6,
						"h": 424,
						"w": 565
					},
					{
						"n": 7,
						"h": 269,
						"w": 577
					},
					{
						"n": 8,
						"h": 249,
						"w": 579
					},
					{
						"n": 17,
						"h": 56,
						"w": 555
					},
					{
						"n": 10,
						"h": 286,
						"w": 330
					},
					{
						"n": 11,
						"h": 182,
						"w": 320
					}
				],
				"away": [
					{
						"n": 1,
						"h": 221,
						"w": 599
					},
					{
						"n": 13,
						"h": 407,
						"w": 200
					},
					{
						"n": 3,
						"h": 268,
						"w": 416
					},
					{
						"n": 14,
						"h": 164,
						"w": 430
					},
					{
						"n": 5,
						"h": 66,
						"w": 411
					},
					{
						"n": 6,
						"h": 217,
						"w": 304
					},
					{
						"n": 7,
						"h": 273,
						"w": 119
					},
					{
						"n": 8,
						"h": 56,
						"w": 82
					},
					{
						"n": 17,
						"h": 390,
						"w": 91
					},
					{
						"n": 19,
						"h": 297,
						"w": 75
					},
					{
						"n": 11,
						"h": 136,
						"w": 159,
						"m": 660
					}
				],
				"ball": {
					"n": 0,
					"h": 177,
					"w": 601,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 48
		},
		{
			"num": 1145,
			"minute": 55,
			"messages": [
				{
					"owner": 2,
					"mes": "Мирослав Манолов[27](Опава) входит в штрафную площадь..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 216,
						"w": 708
					},
					{
						"n": 2,
						"h": 330,
						"w": 671
					},
					{
						"n": 3,
						"h": 169,
						"w": 649
					},
					{
						"n": 4,
						"h": 185,
						"w": 672
					},
					{
						"n": 5,
						"h": 58,
						"w": 645
					},
					{
						"n": 6,
						"h": 408,
						"w": 571
					},
					{
						"n": 7,
						"h": 302,
						"w": 596
					},
					{
						"n": 8,
						"h": 211,
						"w": 581
					},
					{
						"n": 17,
						"h": 56,
						"w": 541
					},
					{
						"n": 10,
						"h": 273,
						"w": 330
					},
					{
						"n": 11,
						"h": 144,
						"w": 320
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 594
					},
					{
						"n": 13,
						"h": 404,
						"w": 214
					},
					{
						"n": 3,
						"h": 275,
						"w": 429
					},
					{
						"n": 14,
						"h": 177,
						"w": 407
					},
					{
						"n": 5,
						"h": 62,
						"w": 417
					},
					{
						"n": 6,
						"h": 221,
						"w": 279
					},
					{
						"n": 7,
						"h": 291,
						"w": 88
					},
					{
						"n": 8,
						"h": 57,
						"w": 92
					},
					{
						"n": 17,
						"h": 400,
						"w": 87
					},
					{
						"n": 19,
						"h": 260,
						"w": 66
					},
					{
						"n": 11,
						"h": 134,
						"w": 121
					}
				],
				"ball": {
					"n": 0,
					"h": 159,
					"w": 632,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 38
		},
		{
			"num": 1146,
			"minute": 55,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 215,
						"w": 709
					},
					{
						"n": 2,
						"h": 319,
						"w": 675
					},
					{
						"n": 3,
						"h": 159,
						"w": 642
					},
					{
						"n": 4,
						"h": 196,
						"w": 677
					},
					{
						"n": 5,
						"h": 56,
						"w": 642
					},
					{
						"n": 6,
						"h": 405,
						"w": 582
					},
					{
						"n": 7,
						"h": 297,
						"w": 607
					},
					{
						"n": 8,
						"h": 206,
						"w": 591
					},
					{
						"n": 17,
						"h": 56,
						"w": 552
					},
					{
						"n": 10,
						"h": 278,
						"w": 330
					},
					{
						"n": 11,
						"h": 156,
						"w": 320
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 594
					},
					{
						"n": 13,
						"h": 409,
						"w": 203
					},
					{
						"n": 3,
						"h": 272,
						"w": 417
					},
					{
						"n": 14,
						"h": 172,
						"w": 418
					},
					{
						"n": 5,
						"h": 69,
						"w": 407
					},
					{
						"n": 6,
						"h": 224,
						"w": 290
					},
					{
						"n": 7,
						"h": 291,
						"w": 78
					},
					{
						"n": 8,
						"h": 49,
						"w": 83
					},
					{
						"n": 17,
						"h": 410,
						"w": 88
					},
					{
						"n": 19,
						"h": 263,
						"w": 55
					},
					{
						"n": 11,
						"h": 146,
						"w": 120
					}
				],
				"ball": {
					"n": 0,
					"h": 159,
					"w": 642,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 12
		},
		{
			"num": 1147,
			"minute": 55,
			"messages": [
				{
					"owner": 2,
					"mes": "М.Манолов[27](Опава) пытается пройти П.Клинтона[03](Галвэй Юнайтед)..."
				},
				{
					"owner": 2,
					"mes": "Патрик Клинтон[03](Галвэй Юнайтед) блокирует продвижение М.Манолова[27](Опава). Чистая игра в отборе!.."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 215,
						"w": 709
					},
					{
						"n": 2,
						"h": 309,
						"w": 678
					},
					{
						"n": 3,
						"h": 151,
						"w": 637,
						"m": 670
					},
					{
						"n": 4,
						"h": 197,
						"w": 677
					},
					{
						"n": 5,
						"h": 56,
						"w": 642
					},
					{
						"n": 6,
						"h": 403,
						"w": 592
					},
					{
						"n": 7,
						"h": 294,
						"w": 614
					},
					{
						"n": 8,
						"h": 201,
						"w": 600
					},
					{
						"n": 17,
						"h": 56,
						"w": 552
					},
					{
						"n": 10,
						"h": 278,
						"w": 330
					},
					{
						"n": 11,
						"h": 166,
						"w": 320
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 594
					},
					{
						"n": 13,
						"h": 410,
						"w": 200
					},
					{
						"n": 3,
						"h": 271,
						"w": 412
					},
					{
						"n": 14,
						"h": 169,
						"w": 422
					},
					{
						"n": 5,
						"h": 74,
						"w": 399
					},
					{
						"n": 6,
						"h": 227,
						"w": 300
					},
					{
						"n": 7,
						"h": 291,
						"w": 68,
						"m": 540
					},
					{
						"n": 8,
						"h": 47,
						"w": 81
					},
					{
						"n": 17,
						"h": 410,
						"w": 88
					},
					{
						"n": 19,
						"h": 263,
						"w": 55
					},
					{
						"n": 11,
						"h": 156,
						"w": 118
					}
				],
				"ball": {
					"n": 0,
					"h": 151,
					"w": 637,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 4
				}
			},
			"interval": 10
		},
		{
			"num": 1148,
			"minute": 55,
			"messages": [
				{
					"owner": 1,
					"mes": "Патрик Клинтон[03](Галвэй Юнайтед) не рискует и в простой ситуации выбивает мяч за боковую..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 706
					},
					{
						"n": 2,
						"h": 349,
						"w": 593
					},
					{
						"n": 3,
						"h": 151,
						"w": 618
					},
					{
						"n": 4,
						"h": 176,
						"w": 591
					},
					{
						"n": 5,
						"h": 60,
						"w": 552
					},
					{
						"n": 6,
						"h": 398,
						"w": 498
					},
					{
						"n": 7,
						"h": 304,
						"w": 521
					},
					{
						"n": 8,
						"h": 148,
						"w": 523
					},
					{
						"n": 17,
						"h": 40,
						"w": 459
					},
					{
						"n": 10,
						"h": 290,
						"w": 323
					},
					{
						"n": 11,
						"h": 150,
						"w": 304
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 648
					},
					{
						"n": 13,
						"h": 412,
						"w": 294
					},
					{
						"n": 3,
						"h": 290,
						"w": 490
					},
					{
						"n": 14,
						"h": 179,
						"w": 494
					},
					{
						"n": 5,
						"h": 105,
						"w": 488
					},
					{
						"n": 6,
						"h": 278,
						"w": 379
					},
					{
						"n": 7,
						"h": 299,
						"w": 120
					},
					{
						"n": 8,
						"h": 44,
						"w": 175
					},
					{
						"n": 17,
						"h": 405,
						"w": 181
					},
					{
						"n": 19,
						"h": 299,
						"w": 122
					},
					{
						"n": 11,
						"h": 169,
						"w": 211
					}
				],
				"ball": {
					"n": 0,
					"h": -12,
					"w": 296,
					"z": 1,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 94
		},
		{
			"num": 1149,
			"minute": 56,
			"possession": 44,
			"messages": [
				{
					"owner": 2,
					"mes": "К.Удре[33](Опава) вводит мяч из-за боковой..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 710
					},
					{
						"n": 2,
						"h": 330,
						"w": 554
					},
					{
						"n": 3,
						"h": 237,
						"w": 543
					},
					{
						"n": 4,
						"h": 155,
						"w": 558
					},
					{
						"n": 5,
						"h": 120,
						"w": 555,
						"m": 660
					},
					{
						"n": 6,
						"h": 394,
						"w": 421,
						"f": 84,
						"c": 2
					},
					{
						"n": 7,
						"h": 298,
						"w": 414
					},
					{
						"n": 8,
						"h": 137,
						"w": 414,
						"f": 82
					},
					{
						"n": 17,
						"h": 56,
						"w": 415
					},
					{
						"n": 10,
						"h": 288,
						"w": 261,
						"f": 83
					},
					{
						"n": 11,
						"h": 146,
						"w": 270
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 680
					},
					{
						"n": 13,
						"h": 450,
						"w": 424
					},
					{
						"n": 3,
						"h": 322,
						"w": 542
					},
					{
						"n": 14,
						"h": 157,
						"w": 540
					},
					{
						"n": 5,
						"h": 48,
						"w": 527
					},
					{
						"n": 6,
						"h": 339,
						"w": 443
					},
					{
						"n": 7,
						"h": 320,
						"w": 278
					},
					{
						"n": 8,
						"h": 55,
						"w": 334,
						"f": 84,
						"c": 2
					},
					{
						"n": 17,
						"h": 402,
						"w": 340
					},
					{
						"n": 19,
						"h": 342,
						"w": 202,
						"f": 96
					},
					{
						"n": 11,
						"h": 150,
						"w": 201
					}
				],
				"ball": {
					"n": 0,
					"h": 0,
					"w": 296,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 127
		},
		{
			"num": 1150,
			"minute": 56,
			"messages": [],
			"A": {
				"team": 2
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 705
					},
					{
						"n": 2,
						"h": 330,
						"w": 520
					},
					{
						"n": 3,
						"h": 264,
						"w": 522
					},
					{
						"n": 4,
						"h": 184,
						"w": 540
					},
					{
						"n": 5,
						"h": 138,
						"w": 526
					},
					{
						"n": 6,
						"h": 391,
						"w": 442
					},
					{
						"n": 7,
						"h": 264,
						"w": 417
					},
					{
						"n": 8,
						"h": 155,
						"w": 427
					},
					{
						"n": 17,
						"h": 56,
						"w": 448
					},
					{
						"n": 10,
						"h": 299,
						"w": 293
					},
					{
						"n": 11,
						"h": 123,
						"w": 245
					}
				],
				"away": [
					{
						"n": 1,
						"h": 229,
						"w": 657
					},
					{
						"n": 13,
						"h": 450,
						"w": 424
					},
					{
						"n": 3,
						"h": 289,
						"w": 533
					},
					{
						"n": 14,
						"h": 169,
						"w": 525
					},
					{
						"n": 5,
						"h": 60,
						"w": 514
					},
					{
						"n": 6,
						"h": 349,
						"w": 472
					},
					{
						"n": 7,
						"h": 297,
						"w": 302
					},
					{
						"n": 8,
						"h": 59,
						"w": 313
					},
					{
						"n": 17,
						"h": 405,
						"w": 307
					},
					{
						"n": 19,
						"h": 318,
						"w": 227
					},
					{
						"n": 11,
						"h": 146,
						"w": 235
					}
				],
				"ball": {
					"n": 0,
					"h": 67,
					"w": 219,
					"z": 1,
					"r": 0,
					"p": 1,
					"x": 0
				}
			},
			"interval": 34
		},
		{
			"num": 1151,
			"minute": 56,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 706
					},
					{
						"n": 2,
						"h": 330,
						"w": 476
					},
					{
						"n": 3,
						"h": 253,
						"w": 480
					},
					{
						"n": 4,
						"h": 171,
						"w": 498
					},
					{
						"n": 5,
						"h": 125,
						"w": 484
					},
					{
						"n": 6,
						"h": 390,
						"w": 416
					},
					{
						"n": 7,
						"h": 268,
						"w": 414
					},
					{
						"n": 8,
						"h": 187,
						"w": 402
					},
					{
						"n": 17,
						"h": 56,
						"w": 461
					},
					{
						"n": 10,
						"h": 282,
						"w": 286
					},
					{
						"n": 11,
						"h": 84,
						"w": 200
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 701
					},
					{
						"n": 13,
						"h": 414,
						"w": 450
					},
					{
						"n": 3,
						"h": 288,
						"w": 577
					},
					{
						"n": 14,
						"h": 168,
						"w": 569
					},
					{
						"n": 5,
						"h": 60,
						"w": 558
					},
					{
						"n": 6,
						"h": 366,
						"w": 520
					},
					{
						"n": 7,
						"h": 273,
						"w": 339
					},
					{
						"n": 8,
						"h": 60,
						"w": 338
					},
					{
						"n": 17,
						"h": 411,
						"w": 270
					},
					{
						"n": 19,
						"h": 308,
						"w": 270
					},
					{
						"n": 11,
						"h": 181,
						"w": 261
					}
				],
				"ball": {
					"n": 0,
					"h": 84,
					"w": 200,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 44
		},
		{
			"num": 1152,
			"minute": 56,
			"messages": [
				{
					"owner": 2,
					"mes": "Оливье Дюмон[26](Опава) финтом уходит в сторону..."
				},
				{
					"owner": 2,
					"mes": "Адам Гилберт[11](Галвэй Юнайтед) обкрадывает О.Дюмона[26](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 710
					},
					{
						"n": 2,
						"h": 330,
						"w": 481
					},
					{
						"n": 3,
						"h": 253,
						"w": 485
					},
					{
						"n": 4,
						"h": 171,
						"w": 503
					},
					{
						"n": 5,
						"h": 125,
						"w": 489
					},
					{
						"n": 6,
						"h": 390,
						"w": 421
					},
					{
						"n": 7,
						"h": 267,
						"w": 419
					},
					{
						"n": 8,
						"h": 187,
						"w": 407
					},
					{
						"n": 17,
						"h": 56,
						"w": 466
					},
					{
						"n": 10,
						"h": 282,
						"w": 291
					},
					{
						"n": 11,
						"h": 84,
						"w": 195,
						"m": 830
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 696
					},
					{
						"n": 13,
						"h": 414,
						"w": 445
					},
					{
						"n": 3,
						"h": 287,
						"w": 572
					},
					{
						"n": 14,
						"h": 166,
						"w": 565
					},
					{
						"n": 5,
						"h": 65,
						"w": 559
					},
					{
						"n": 6,
						"h": 366,
						"w": 515
					},
					{
						"n": 7,
						"h": 271,
						"w": 335
					},
					{
						"n": 8,
						"h": 60,
						"w": 334
					},
					{
						"n": 17,
						"h": 411,
						"w": 265
					},
					{
						"n": 19,
						"h": 308,
						"w": 265
					},
					{
						"n": 11,
						"h": 183,
						"w": 256
					}
				],
				"ball": {
					"n": 0,
					"h": 84,
					"w": 195,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 5
		},
		{
			"num": 1153,
			"minute": 56,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 702
					},
					{
						"n": 2,
						"h": 350,
						"w": 446
					},
					{
						"n": 3,
						"h": 269,
						"w": 448
					},
					{
						"n": 4,
						"h": 171,
						"w": 463
					},
					{
						"n": 5,
						"h": 109,
						"w": 452
					},
					{
						"n": 6,
						"h": 392,
						"w": 382
					},
					{
						"n": 7,
						"h": 257,
						"w": 380
					},
					{
						"n": 8,
						"h": 180,
						"w": 368
					},
					{
						"n": 17,
						"h": 53,
						"w": 426
					},
					{
						"n": 10,
						"h": 282,
						"w": 251
					},
					{
						"n": 11,
						"h": 70,
						"w": 151
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 687
					},
					{
						"n": 13,
						"h": 401,
						"w": 488
					},
					{
						"n": 3,
						"h": 281,
						"w": 614
					},
					{
						"n": 14,
						"h": 163,
						"w": 605
					},
					{
						"n": 5,
						"h": 94,
						"w": 587
					},
					{
						"n": 6,
						"h": 370,
						"w": 533
					},
					{
						"n": 7,
						"h": 265,
						"w": 374
					},
					{
						"n": 8,
						"h": 59,
						"w": 373
					},
					{
						"n": 17,
						"h": 411,
						"w": 305
					},
					{
						"n": 19,
						"h": 295,
						"w": 302
					},
					{
						"n": 11,
						"h": 195,
						"w": 294
					}
				],
				"ball": {
					"n": 0,
					"h": 70,
					"w": 151,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1154,
			"minute": 56,
			"messages": [
				{
					"owner": 1,
					"mes": "Адам Гилберт[11](Галвэй Юнайтед) уходит ближе к центру..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 710
					},
					{
						"n": 2,
						"h": 363,
						"w": 414
					},
					{
						"n": 3,
						"h": 279,
						"w": 415
					},
					{
						"n": 4,
						"h": 175,
						"w": 428
					},
					{
						"n": 5,
						"h": 101,
						"w": 434
					},
					{
						"n": 6,
						"h": 391,
						"w": 347
					},
					{
						"n": 7,
						"h": 252,
						"w": 346
					},
					{
						"n": 8,
						"h": 176,
						"w": 333
					},
					{
						"n": 17,
						"h": 52,
						"w": 391
					},
					{
						"n": 10,
						"h": 283,
						"w": 216
					},
					{
						"n": 11,
						"h": 96,
						"w": 121
					}
				],
				"away": [
					{
						"n": 1,
						"h": 236,
						"w": 710
					},
					{
						"n": 13,
						"h": 385,
						"w": 520
					},
					{
						"n": 3,
						"h": 299,
						"w": 619
					},
					{
						"n": 14,
						"h": 196,
						"w": 618
					},
					{
						"n": 5,
						"h": 106,
						"w": 625
					},
					{
						"n": 6,
						"h": 359,
						"w": 574
					},
					{
						"n": 7,
						"h": 262,
						"w": 409
					},
					{
						"n": 8,
						"h": 57,
						"w": 408
					},
					{
						"n": 17,
						"h": 408,
						"w": 340
					},
					{
						"n": 19,
						"h": 288,
						"w": 337
					},
					{
						"n": 11,
						"h": 196,
						"w": 329
					}
				],
				"ball": {
					"n": 0,
					"h": 96,
					"w": 121,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 35
		},
		{
			"num": 1155,
			"minute": 56,
			"messages": [
				{
					"owner": 1,
					"mes": "Адам Гилберт[11](Галвэй Юнайтед) опасно врывается в штрафную..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 703
					},
					{
						"n": 2,
						"h": 380,
						"w": 377
					},
					{
						"n": 3,
						"h": 271,
						"w": 391
					},
					{
						"n": 4,
						"h": 167,
						"w": 390
					},
					{
						"n": 5,
						"h": 87,
						"w": 396
					},
					{
						"n": 6,
						"h": 391,
						"w": 307
					},
					{
						"n": 7,
						"h": 262,
						"w": 307
					},
					{
						"n": 8,
						"h": 175,
						"w": 293
					},
					{
						"n": 17,
						"h": 56,
						"w": 351
					},
					{
						"n": 10,
						"h": 287,
						"w": 176
					},
					{
						"n": 11,
						"h": 131,
						"w": 99
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 709
					},
					{
						"n": 13,
						"h": 397,
						"w": 558
					},
					{
						"n": 3,
						"h": 307,
						"w": 636
					},
					{
						"n": 14,
						"h": 216,
						"w": 652
					},
					{
						"n": 5,
						"h": 110,
						"w": 648
					},
					{
						"n": 6,
						"h": 321,
						"w": 604
					},
					{
						"n": 7,
						"h": 253,
						"w": 448
					},
					{
						"n": 8,
						"h": 57,
						"w": 448
					},
					{
						"n": 17,
						"h": 406,
						"w": 380
					},
					{
						"n": 19,
						"h": 283,
						"w": 376
					},
					{
						"n": 11,
						"h": 193,
						"w": 369
					}
				],
				"ball": {
					"n": 0,
					"h": 131,
					"w": 99,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1156,
			"minute": 56,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 705
					},
					{
						"n": 2,
						"h": 382,
						"w": 357
					},
					{
						"n": 3,
						"h": 268,
						"w": 405
					},
					{
						"n": 4,
						"h": 173,
						"w": 409
					},
					{
						"n": 5,
						"h": 77,
						"w": 379
					},
					{
						"n": 6,
						"h": 394,
						"w": 287
					},
					{
						"n": 7,
						"h": 263,
						"w": 287
					},
					{
						"n": 8,
						"h": 172,
						"w": 273
					},
					{
						"n": 17,
						"h": 56,
						"w": 331
					},
					{
						"n": 10,
						"h": 290,
						"w": 156
					},
					{
						"n": 11,
						"h": 141,
						"w": 101
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 708
					},
					{
						"n": 13,
						"h": 406,
						"w": 576
					},
					{
						"n": 3,
						"h": 303,
						"w": 626
					},
					{
						"n": 14,
						"h": 223,
						"w": 652
					},
					{
						"n": 5,
						"h": 110,
						"w": 638
					},
					{
						"n": 6,
						"h": 309,
						"w": 614
					},
					{
						"n": 7,
						"h": 244,
						"w": 466
					},
					{
						"n": 8,
						"h": 56,
						"w": 468
					},
					{
						"n": 17,
						"h": 408,
						"w": 400
					},
					{
						"n": 19,
						"h": 282,
						"w": 396
					},
					{
						"n": 11,
						"h": 191,
						"w": 389
					}
				],
				"ball": {
					"n": 0,
					"h": 141,
					"w": 101,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 4
				}
			},
			"interval": 20
		},
		{
			"num": 1157,
			"minute": 56,
			"messages": [
				{
					"owner": 1,
					"mes": "Адам Гилберт[11](Галвэй Юнайтед) прикрывает мяч корпусом..."
				},
				{
					"owner": 1,
					"mes": "Нир Мансур[23](Опава) отбирает мяч у А.Гилберта[11](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 705
					},
					{
						"n": 2,
						"h": 383,
						"w": 342
					},
					{
						"n": 3,
						"h": 268,
						"w": 405
					},
					{
						"n": 4,
						"h": 173,
						"w": 410
					},
					{
						"n": 5,
						"h": 70,
						"w": 366
					},
					{
						"n": 6,
						"h": 396,
						"w": 272
					},
					{
						"n": 7,
						"h": 264,
						"w": 272
					},
					{
						"n": 8,
						"h": 169,
						"w": 258
					},
					{
						"n": 17,
						"h": 56,
						"w": 316
					},
					{
						"n": 10,
						"h": 291,
						"w": 141
					},
					{
						"n": 11,
						"h": 155,
						"w": 96,
						"m": 820
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 708
					},
					{
						"n": 13,
						"h": 413,
						"w": 589
					},
					{
						"n": 3,
						"h": 303,
						"w": 626,
						"m": 640
					},
					{
						"n": 14,
						"h": 223,
						"w": 652
					},
					{
						"n": 5,
						"h": 110,
						"w": 638
					},
					{
						"n": 6,
						"h": 309,
						"w": 614
					},
					{
						"n": 7,
						"h": 237,
						"w": 479
					},
					{
						"n": 8,
						"h": 56,
						"w": 469
					},
					{
						"n": 17,
						"h": 409,
						"w": 415
					},
					{
						"n": 19,
						"h": 281,
						"w": 411
					},
					{
						"n": 11,
						"h": 190,
						"w": 404
					}
				],
				"ball": {
					"n": 0,
					"h": 147,
					"w": 94,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 15
		},
		{
			"num": 1158,
			"minute": 56,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 704
					},
					{
						"n": 2,
						"h": 373,
						"w": 381
					},
					{
						"n": 3,
						"h": 259,
						"w": 414
					},
					{
						"n": 4,
						"h": 178,
						"w": 418
					},
					{
						"n": 5,
						"h": 99,
						"w": 393
					},
					{
						"n": 6,
						"h": 399,
						"w": 292
					},
					{
						"n": 7,
						"h": 252,
						"w": 310
					},
					{
						"n": 8,
						"h": 171,
						"w": 298
					},
					{
						"n": 17,
						"h": 56,
						"w": 356
					},
					{
						"n": 10,
						"h": 279,
						"w": 180
					},
					{
						"n": 11,
						"h": 141,
						"w": 102
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 703
					},
					{
						"n": 13,
						"h": 413,
						"w": 549
					},
					{
						"n": 3,
						"h": 338,
						"w": 626
					},
					{
						"n": 14,
						"h": 186,
						"w": 636
					},
					{
						"n": 5,
						"h": 73,
						"w": 623
					},
					{
						"n": 6,
						"h": 275,
						"w": 593
					},
					{
						"n": 7,
						"h": 215,
						"w": 446
					},
					{
						"n": 8,
						"h": 46,
						"w": 431
					},
					{
						"n": 17,
						"h": 398,
						"w": 381
					},
					{
						"n": 19,
						"h": 287,
						"w": 372
					},
					{
						"n": 11,
						"h": 179,
						"w": 366
					}
				],
				"ball": {
					"n": 0,
					"h": 112,
					"w": 94,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1159,
			"minute": 56,
			"messages": [
				{
					"owner": 2,
					"mes": "Нир Мансур[23](Опава) отправляет мяч налево К.Удре[33](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 707
					},
					{
						"n": 2,
						"h": 348,
						"w": 410
					},
					{
						"n": 3,
						"h": 264,
						"w": 436
					},
					{
						"n": 4,
						"h": 172,
						"w": 428
					},
					{
						"n": 5,
						"h": 118,
						"w": 426
					},
					{
						"n": 6,
						"h": 395,
						"w": 329
					},
					{
						"n": 7,
						"h": 253,
						"w": 348
					},
					{
						"n": 8,
						"h": 161,
						"w": 335
					},
					{
						"n": 17,
						"h": 56,
						"w": 394
					},
					{
						"n": 10,
						"h": 272,
						"w": 217
					},
					{
						"n": 11,
						"h": 140,
						"w": 140
					}
				],
				"away": [
					{
						"n": 1,
						"h": 226,
						"w": 705
					},
					{
						"n": 13,
						"h": 387,
						"w": 577
					},
					{
						"n": 3,
						"h": 328,
						"w": 624
					},
					{
						"n": 14,
						"h": 183,
						"w": 618
					},
					{
						"n": 5,
						"h": 66,
						"w": 606
					},
					{
						"n": 6,
						"h": 255,
						"w": 560
					},
					{
						"n": 7,
						"h": 250,
						"w": 432
					},
					{
						"n": 8,
						"h": 41,
						"w": 393
					},
					{
						"n": 17,
						"h": 398,
						"w": 360
					},
					{
						"n": 19,
						"h": 295,
						"w": 335
					},
					{
						"n": 11,
						"h": 169,
						"w": 329
					}
				],
				"ball": {
					"n": 0,
					"h": 63,
					"w": 143,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 38
		},
		{
			"num": 1160,
			"minute": 56,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 710
					},
					{
						"n": 2,
						"h": 336,
						"w": 448
					},
					{
						"n": 3,
						"h": 253,
						"w": 452
					},
					{
						"n": 4,
						"h": 172,
						"w": 466
					},
					{
						"n": 5,
						"h": 120,
						"w": 452
					},
					{
						"n": 6,
						"h": 394,
						"w": 369
					},
					{
						"n": 7,
						"h": 242,
						"w": 376
					},
					{
						"n": 8,
						"h": 194,
						"w": 357
					},
					{
						"n": 17,
						"h": 56,
						"w": 376
					},
					{
						"n": 10,
						"h": 278,
						"w": 257
					},
					{
						"n": 11,
						"h": 106,
						"w": 160
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 704
					},
					{
						"n": 13,
						"h": 404,
						"w": 546
					},
					{
						"n": 3,
						"h": 290,
						"w": 611
					},
					{
						"n": 14,
						"h": 170,
						"w": 600
					},
					{
						"n": 5,
						"h": 61,
						"w": 596
					},
					{
						"n": 6,
						"h": 239,
						"w": 524
					},
					{
						"n": 7,
						"h": 249,
						"w": 396
					},
					{
						"n": 8,
						"h": 33,
						"w": 354
					},
					{
						"n": 17,
						"h": 420,
						"w": 359
					},
					{
						"n": 19,
						"h": 307,
						"w": 297
					},
					{
						"n": 11,
						"h": 201,
						"w": 306
					}
				],
				"ball": {
					"n": 0,
					"h": 46,
					"w": 174,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1161,
			"minute": 56,
			"messages": [
				{
					"owner": 2,
					"mes": "Пас О.Дюмону[26](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 701
					},
					{
						"n": 2,
						"h": 330,
						"w": 469
					},
					{
						"n": 3,
						"h": 218,
						"w": 455
					},
					{
						"n": 4,
						"h": 174,
						"w": 470
					},
					{
						"n": 5,
						"h": 120,
						"w": 455
					},
					{
						"n": 6,
						"h": 394,
						"w": 404
					},
					{
						"n": 7,
						"h": 271,
						"w": 369
					},
					{
						"n": 8,
						"h": 197,
						"w": 391
					},
					{
						"n": 17,
						"h": 56,
						"w": 394
					},
					{
						"n": 10,
						"h": 315,
						"w": 273
					},
					{
						"n": 11,
						"h": 118,
						"w": 213
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 709
					},
					{
						"n": 13,
						"h": 403,
						"w": 536
					},
					{
						"n": 3,
						"h": 285,
						"w": 614
					},
					{
						"n": 14,
						"h": 165,
						"w": 611
					},
					{
						"n": 5,
						"h": 64,
						"w": 590
					},
					{
						"n": 6,
						"h": 239,
						"w": 524
					},
					{
						"n": 7,
						"h": 228,
						"w": 408
					},
					{
						"n": 8,
						"h": 48,
						"w": 350
					},
					{
						"n": 17,
						"h": 410,
						"w": 342
					},
					{
						"n": 19,
						"h": 297,
						"w": 274
					},
					{
						"n": 11,
						"h": 251,
						"w": 330
					}
				],
				"ball": {
					"n": 0,
					"h": 211,
					"w": 196,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 55
		},
		{
			"num": 1162,
			"minute": 56,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 709
					},
					{
						"n": 2,
						"h": 330,
						"w": 496
					},
					{
						"n": 3,
						"h": 193,
						"w": 486
					},
					{
						"n": 4,
						"h": 144,
						"w": 497
					},
					{
						"n": 5,
						"h": 106,
						"w": 492
					},
					{
						"n": 6,
						"h": 394,
						"w": 365
					},
					{
						"n": 7,
						"h": 271,
						"w": 409
					},
					{
						"n": 8,
						"h": 159,
						"w": 403
					},
					{
						"n": 17,
						"h": 78,
						"w": 426
					},
					{
						"n": 10,
						"h": 308,
						"w": 312
					},
					{
						"n": 11,
						"h": 130,
						"w": 252
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 708
					},
					{
						"n": 13,
						"h": 406,
						"w": 496
					},
					{
						"n": 3,
						"h": 282,
						"w": 574
					},
					{
						"n": 14,
						"h": 168,
						"w": 571
					},
					{
						"n": 5,
						"h": 71,
						"w": 551
					},
					{
						"n": 6,
						"h": 221,
						"w": 494
					},
					{
						"n": 7,
						"h": 214,
						"w": 405
					},
					{
						"n": 8,
						"h": 50,
						"w": 390
					},
					{
						"n": 17,
						"h": 372,
						"w": 329
					},
					{
						"n": 19,
						"h": 317,
						"w": 252
					},
					{
						"n": 11,
						"h": 291,
						"w": 325
					}
				],
				"ball": {
					"n": 0,
					"h": 229,
					"w": 226,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1163,
			"minute": 56,
			"messages": [
				{
					"owner": 2,
					"mes": "Слева просит мяч Кеннет Удре[33](Опава)... Пас ему..."
				},
				{
					"owner": 2,
					"mes": "Кеннет Удре[33](Опава) получил мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 710
					},
					{
						"n": 2,
						"h": 330,
						"w": 468
					},
					{
						"n": 3,
						"h": 178,
						"w": 464
					},
					{
						"n": 4,
						"h": 156,
						"w": 459
					},
					{
						"n": 5,
						"h": 120,
						"w": 473
					},
					{
						"n": 6,
						"h": 394,
						"w": 406
					},
					{
						"n": 7,
						"h": 232,
						"w": 400
					},
					{
						"n": 8,
						"h": 149,
						"w": 372
					},
					{
						"n": 17,
						"h": 42,
						"w": 376
					},
					{
						"n": 10,
						"h": 318,
						"w": 277
					},
					{
						"n": 11,
						"h": 128,
						"w": 270
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 707
					},
					{
						"n": 13,
						"h": 351,
						"w": 523
					},
					{
						"n": 3,
						"h": 277,
						"w": 608
					},
					{
						"n": 14,
						"h": 169,
						"w": 602
					},
					{
						"n": 5,
						"h": 76,
						"w": 588
					},
					{
						"n": 6,
						"h": 231,
						"w": 493
					},
					{
						"n": 7,
						"h": 251,
						"w": 433
					},
					{
						"n": 8,
						"h": 45,
						"w": 348
					},
					{
						"n": 17,
						"h": 341,
						"w": 320
					},
					{
						"n": 19,
						"h": 302,
						"w": 270
					},
					{
						"n": 11,
						"h": 311,
						"w": 368
					}
				],
				"ball": {
					"n": 0,
					"h": 99,
					"w": 197,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 62
		},
		{
			"num": 1164,
			"minute": 56,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 702
					},
					{
						"n": 2,
						"h": 330,
						"w": 501
					},
					{
						"n": 3,
						"h": 208,
						"w": 491
					},
					{
						"n": 4,
						"h": 141,
						"w": 496
					},
					{
						"n": 5,
						"h": 105,
						"w": 510
					},
					{
						"n": 6,
						"h": 394,
						"w": 366
					},
					{
						"n": 7,
						"h": 241,
						"w": 433
					},
					{
						"n": 8,
						"h": 151,
						"w": 412
					},
					{
						"n": 17,
						"h": 35,
						"w": 394
					},
					{
						"n": 10,
						"h": 291,
						"w": 306
					},
					{
						"n": 11,
						"h": 135,
						"w": 270
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 706
					},
					{
						"n": 13,
						"h": 368,
						"w": 492
					},
					{
						"n": 3,
						"h": 268,
						"w": 569
					},
					{
						"n": 14,
						"h": 172,
						"w": 562
					},
					{
						"n": 5,
						"h": 62,
						"w": 566
					},
					{
						"n": 6,
						"h": 247,
						"w": 456
					},
					{
						"n": 7,
						"h": 256,
						"w": 394
					},
					{
						"n": 8,
						"h": 43,
						"w": 388
					},
					{
						"n": 17,
						"h": 301,
						"w": 317
					},
					{
						"n": 19,
						"h": 309,
						"w": 241
					},
					{
						"n": 11,
						"h": 328,
						"w": 376
					}
				],
				"ball": {
					"n": 0,
					"h": 82,
					"w": 228,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1165,
			"minute": 56,
			"messages": [
				{
					"owner": 2,
					"mes": "Кеннет Удре[33](Опава) отдает пас К.Ласаку[21](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 708
					},
					{
						"n": 2,
						"h": 330,
						"w": 460
					},
					{
						"n": 3,
						"h": 209,
						"w": 467
					},
					{
						"n": 4,
						"h": 166,
						"w": 465
					},
					{
						"n": 5,
						"h": 120,
						"w": 456
					},
					{
						"n": 6,
						"h": 394,
						"w": 403
					},
					{
						"n": 7,
						"h": 264,
						"w": 391
					},
					{
						"n": 8,
						"h": 208,
						"w": 410
					},
					{
						"n": 17,
						"h": 44,
						"w": 360
					},
					{
						"n": 10,
						"h": 323,
						"w": 270
					},
					{
						"n": 11,
						"h": 146,
						"w": 270
					}
				],
				"away": [
					{
						"n": 1,
						"h": 246,
						"w": 687
					},
					{
						"n": 13,
						"h": 374,
						"w": 484
					},
					{
						"n": 3,
						"h": 272,
						"w": 551
					},
					{
						"n": 14,
						"h": 172,
						"w": 557
					},
					{
						"n": 5,
						"h": 74,
						"w": 549
					},
					{
						"n": 6,
						"h": 221,
						"w": 461
					},
					{
						"n": 7,
						"h": 240,
						"w": 397
					},
					{
						"n": 8,
						"h": 35,
						"w": 332
					},
					{
						"n": 17,
						"h": 244,
						"w": 321
					},
					{
						"n": 19,
						"h": 295,
						"w": 284
					},
					{
						"n": 11,
						"h": 306,
						"w": 396
					}
				],
				"ball": {
					"n": 0,
					"h": 204,
					"w": 33,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 57
		},
		{
			"num": 1166,
			"minute": 56,
			"messages": [
				{
					"owner": 2,
					"mes": "Пас вперед..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 706
					},
					{
						"n": 2,
						"h": 330,
						"w": 462
					},
					{
						"n": 3,
						"h": 230,
						"w": 469
					},
					{
						"n": 4,
						"h": 163,
						"w": 454
					},
					{
						"n": 5,
						"h": 120,
						"w": 455
					},
					{
						"n": 6,
						"h": 394,
						"w": 370
					},
					{
						"n": 7,
						"h": 260,
						"w": 366
					},
					{
						"n": 8,
						"h": 178,
						"w": 397
					},
					{
						"n": 17,
						"h": 55,
						"w": 360
					},
					{
						"n": 10,
						"h": 316,
						"w": 270
					},
					{
						"n": 11,
						"h": 145,
						"w": 237
					}
				],
				"away": [
					{
						"n": 1,
						"h": 239,
						"w": 679
					},
					{
						"n": 13,
						"h": 406,
						"w": 481
					},
					{
						"n": 3,
						"h": 300,
						"w": 569
					},
					{
						"n": 14,
						"h": 150,
						"w": 547
					},
					{
						"n": 5,
						"h": 41,
						"w": 547
					},
					{
						"n": 6,
						"h": 220,
						"w": 480
					},
					{
						"n": 7,
						"h": 229,
						"w": 414
					},
					{
						"n": 8,
						"h": 35,
						"w": 365
					},
					{
						"n": 17,
						"h": 277,
						"w": 326
					},
					{
						"n": 19,
						"h": 291,
						"w": 280
					},
					{
						"n": 11,
						"h": 280,
						"w": 375
					}
				],
				"ball": {
					"n": 0,
					"h": 155,
					"w": 119,
					"z": 0,
					"r": 0,
					"p": 2,
					"x": 0
				}
			},
			"interval": 33
		},
		{
			"num": 1167,
			"minute": 56,
			"messages": [
				{
					"owner": 2,
					"mes": "Нир Мансур[23](Опава) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 706
					},
					{
						"n": 2,
						"h": 330,
						"w": 459
					},
					{
						"n": 3,
						"h": 232,
						"w": 459
					},
					{
						"n": 4,
						"h": 158,
						"w": 455
					},
					{
						"n": 5,
						"h": 120,
						"w": 466
					},
					{
						"n": 6,
						"h": 394,
						"w": 350
					},
					{
						"n": 7,
						"h": 268,
						"w": 372
					},
					{
						"n": 8,
						"h": 186,
						"w": 389
					},
					{
						"n": 17,
						"h": 61,
						"w": 360
					},
					{
						"n": 10,
						"h": 315,
						"w": 270
					},
					{
						"n": 11,
						"h": 145,
						"w": 217
					}
				],
				"away": [
					{
						"n": 1,
						"h": 233,
						"w": 666
					},
					{
						"n": 13,
						"h": 415,
						"w": 494
					},
					{
						"n": 3,
						"h": 309,
						"w": 575,
						"m": 650
					},
					{
						"n": 14,
						"h": 148,
						"w": 565
					},
					{
						"n": 5,
						"h": 33,
						"w": 565
					},
					{
						"n": 6,
						"h": 233,
						"w": 494
					},
					{
						"n": 7,
						"h": 215,
						"w": 423
					},
					{
						"n": 8,
						"h": 35,
						"w": 385
					},
					{
						"n": 17,
						"h": 297,
						"w": 330
					},
					{
						"n": 19,
						"h": 297,
						"w": 280
					},
					{
						"n": 11,
						"h": 265,
						"w": 362
					}
				],
				"ball": {
					"n": 0,
					"h": 141,
					"w": 145,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 20
		},
		{
			"num": 1168,
			"minute": 57,
			"possession": 44,
			"messages": [
				{
					"owner": 2,
					"mes": "Пас направо..."
				},
				{
					"owner": 2,
					"mes": "Вацлав Сланина[34](Опава) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 704,
						"f": 93
					},
					{
						"n": 2,
						"h": 330,
						"w": 464,
						"f": 84,
						"c": 2
					},
					{
						"n": 3,
						"h": 220,
						"w": 454
					},
					{
						"n": 4,
						"h": 186,
						"w": 455
					},
					{
						"n": 5,
						"h": 120,
						"w": 465
					},
					{
						"n": 6,
						"h": 400,
						"w": 360
					},
					{
						"n": 7,
						"h": 257,
						"w": 376,
						"f": 84,
						"c": 2
					},
					{
						"n": 8,
						"h": 223,
						"w": 402
					},
					{
						"n": 17,
						"h": 58,
						"w": 360
					},
					{
						"n": 10,
						"h": 319,
						"w": 270
					},
					{
						"n": 11,
						"h": 146,
						"w": 264,
						"f": 83
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 703,
						"f": 84,
						"c": 2
					},
					{
						"n": 13,
						"h": 407,
						"w": 501
					},
					{
						"n": 3,
						"h": 302,
						"w": 575
					},
					{
						"n": 14,
						"h": 169,
						"w": 585
					},
					{
						"n": 5,
						"h": 40,
						"w": 575
					},
					{
						"n": 6,
						"h": 220,
						"w": 501
					},
					{
						"n": 7,
						"h": 222,
						"w": 427
					},
					{
						"n": 8,
						"h": 48,
						"w": 427
					},
					{
						"n": 17,
						"h": 343,
						"w": 339
					},
					{
						"n": 19,
						"h": 282,
						"w": 280
					},
					{
						"n": 11,
						"h": 227,
						"w": 334
					}
				],
				"ball": {
					"n": 0,
					"h": 281,
					"w": 135,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 47
		},
		{
			"num": 1169,
			"minute": 57,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 708
					},
					{
						"n": 2,
						"h": 330,
						"w": 470
					},
					{
						"n": 3,
						"h": 240,
						"w": 454
					},
					{
						"n": 4,
						"h": 167,
						"w": 454
					},
					{
						"n": 5,
						"h": 120,
						"w": 468
					},
					{
						"n": 6,
						"h": 388,
						"w": 360
					},
					{
						"n": 7,
						"h": 248,
						"w": 398
					},
					{
						"n": 8,
						"h": 197,
						"w": 372
					},
					{
						"n": 17,
						"h": 66,
						"w": 399
					},
					{
						"n": 10,
						"h": 316,
						"w": 270
					},
					{
						"n": 11,
						"h": 145,
						"w": 270
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 687
					},
					{
						"n": 13,
						"h": 406,
						"w": 494
					},
					{
						"n": 3,
						"h": 295,
						"w": 565
					},
					{
						"n": 14,
						"h": 151,
						"w": 554
					},
					{
						"n": 5,
						"h": 50,
						"w": 565
					},
					{
						"n": 6,
						"h": 218,
						"w": 494
					},
					{
						"n": 7,
						"h": 217,
						"w": 422
					},
					{
						"n": 8,
						"h": 51,
						"w": 422
					},
					{
						"n": 17,
						"h": 382,
						"w": 346
					},
					{
						"n": 19,
						"h": 300,
						"w": 280
					},
					{
						"n": 11,
						"h": 198,
						"w": 307
					}
				],
				"ball": {
					"n": 0,
					"h": 299,
					"w": 166,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1170,
			"minute": 57,
			"messages": [
				{
					"owner": 2,
					"mes": "Вацлав Сланина[34](Опава) делает передачу направо на Т.Прохазку[25](Опава)..."
				},
				{
					"owner": 2,
					"mes": "Неточный пас..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 703
					},
					{
						"n": 2,
						"h": 330,
						"w": 455
					},
					{
						"n": 3,
						"h": 282,
						"w": 458
					},
					{
						"n": 4,
						"h": 167,
						"w": 465
					},
					{
						"n": 5,
						"h": 120,
						"w": 461
					},
					{
						"n": 6,
						"h": 393,
						"w": 360
					},
					{
						"n": 7,
						"h": 281,
						"w": 368
					},
					{
						"n": 8,
						"h": 212,
						"w": 384
					},
					{
						"n": 17,
						"h": 56,
						"w": 406
					},
					{
						"n": 10,
						"h": 370,
						"w": 247
					},
					{
						"n": 11,
						"h": 162,
						"w": 270
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 668
					},
					{
						"n": 13,
						"h": 412,
						"w": 486
					},
					{
						"n": 3,
						"h": 288,
						"w": 555
					},
					{
						"n": 14,
						"h": 161,
						"w": 555,
						"m": 620
					},
					{
						"n": 5,
						"h": 15,
						"w": 518
					},
					{
						"n": 6,
						"h": 225,
						"w": 486
					},
					{
						"n": 7,
						"h": 235,
						"w": 417
					},
					{
						"n": 8,
						"h": 47,
						"w": 417
					},
					{
						"n": 17,
						"h": 400,
						"w": 349
					},
					{
						"n": 19,
						"h": 300,
						"w": 280
					},
					{
						"n": 11,
						"h": 157,
						"w": 280
					}
				],
				"ball": {
					"n": 0,
					"h": 470,
					"w": 215,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 59
		},
		{
			"num": 1171,
			"minute": 57,
			"messages": [
				{
					"owner": 1,
					"mes": "К.Колман[06](Галвэй Юнайтед) вбрасывает аут..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 244,
						"w": 680
					},
					{
						"n": 2,
						"h": 398,
						"w": 284
					},
					{
						"n": 3,
						"h": 330,
						"w": 474
					},
					{
						"n": 4,
						"h": 160,
						"w": 473
					},
					{
						"n": 5,
						"h": 53,
						"w": 464
					},
					{
						"n": 6,
						"h": 450,
						"w": 215
					},
					{
						"n": 7,
						"h": 354,
						"w": 340
					},
					{
						"n": 8,
						"h": 166,
						"w": 358
					},
					{
						"n": 17,
						"h": 60,
						"w": 357
					},
					{
						"n": 10,
						"h": 349,
						"w": 251
					},
					{
						"n": 11,
						"h": 168,
						"w": 233
					}
				],
				"away": [
					{
						"n": 1,
						"h": 205,
						"w": 644
					},
					{
						"n": 13,
						"h": 390,
						"w": 399
					},
					{
						"n": 3,
						"h": 188,
						"w": 661
					},
					{
						"n": 14,
						"h": 119,
						"w": 673
					},
					{
						"n": 5,
						"h": 86,
						"w": 653
					},
					{
						"n": 6,
						"h": 139,
						"w": 607
					},
					{
						"n": 7,
						"h": 205,
						"w": 522
					},
					{
						"n": 8,
						"h": 52,
						"w": 472
					},
					{
						"n": 17,
						"h": 423,
						"w": 448
					},
					{
						"n": 19,
						"h": 295,
						"w": 377
					},
					{
						"n": 11,
						"h": 170,
						"w": 373
					}
				],
				"ball": {
					"n": 0,
					"h": 450,
					"w": 215,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 147
		},
		{
			"num": 1172,
			"minute": 57,
			"messages": [
				{
					"owner": 1,
					"mes": "Джо Квигли[10](Галвэй Юнайтед) получает мяч..."
				}
			],
			"A": {
				"team": 1
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 709
					},
					{
						"n": 2,
						"h": 392,
						"w": 320
					},
					{
						"n": 3,
						"h": 308,
						"w": 445
					},
					{
						"n": 4,
						"h": 171,
						"w": 438
					},
					{
						"n": 5,
						"h": 59,
						"w": 428
					},
					{
						"n": 6,
						"h": 450,
						"w": 215
					},
					{
						"n": 7,
						"h": 347,
						"w": 304
					},
					{
						"n": 8,
						"h": 160,
						"w": 323
					},
					{
						"n": 17,
						"h": 61,
						"w": 321
					},
					{
						"n": 10,
						"h": 349,
						"w": 251
					},
					{
						"n": 11,
						"h": 167,
						"w": 197
					}
				],
				"away": [
					{
						"n": 1,
						"h": 216,
						"w": 678
					},
					{
						"n": 13,
						"h": 389,
						"w": 435
					},
					{
						"n": 3,
						"h": 224,
						"w": 659
					},
					{
						"n": 14,
						"h": 155,
						"w": 669
					},
					{
						"n": 5,
						"h": 110,
						"w": 658
					},
					{
						"n": 6,
						"h": 171,
						"w": 591
					},
					{
						"n": 7,
						"h": 240,
						"w": 529
					},
					{
						"n": 8,
						"h": 88,
						"w": 470
					},
					{
						"n": 17,
						"h": 407,
						"w": 481
					},
					{
						"n": 19,
						"h": 290,
						"w": 413
					},
					{
						"n": 11,
						"h": 144,
						"w": 398
					}
				],
				"ball": {
					"n": 0,
					"h": 349,
					"w": 251,
					"z": 1,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 36
		},
		{
			"num": 1173,
			"minute": 57,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 708
					},
					{
						"n": 2,
						"h": 380,
						"w": 358
					},
					{
						"n": 3,
						"h": 285,
						"w": 413
					},
					{
						"n": 4,
						"h": 168,
						"w": 399
					},
					{
						"n": 5,
						"h": 59,
						"w": 388
					},
					{
						"n": 6,
						"h": 422,
						"w": 186
					},
					{
						"n": 7,
						"h": 334,
						"w": 266
					},
					{
						"n": 8,
						"h": 154,
						"w": 283
					},
					{
						"n": 17,
						"h": 62,
						"w": 281
					},
					{
						"n": 10,
						"h": 335,
						"w": 208
					},
					{
						"n": 11,
						"h": 158,
						"w": 158
					}
				],
				"away": [
					{
						"n": 1,
						"h": 228,
						"w": 707
					},
					{
						"n": 13,
						"h": 388,
						"w": 475
					},
					{
						"n": 3,
						"h": 264,
						"w": 654
					},
					{
						"n": 14,
						"h": 195,
						"w": 668
					},
					{
						"n": 5,
						"h": 110,
						"w": 659
					},
					{
						"n": 6,
						"h": 138,
						"w": 557
					},
					{
						"n": 7,
						"h": 271,
						"w": 555
					},
					{
						"n": 8,
						"h": 102,
						"w": 488
					},
					{
						"n": 17,
						"h": 409,
						"w": 504
					},
					{
						"n": 19,
						"h": 295,
						"w": 452
					},
					{
						"n": 11,
						"h": 130,
						"w": 435
					}
				],
				"ball": {
					"n": 0,
					"h": 335,
					"w": 208,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1174,
			"minute": 57,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 701
					},
					{
						"n": 2,
						"h": 387,
						"w": 349
					},
					{
						"n": 3,
						"h": 269,
						"w": 394
					},
					{
						"n": 4,
						"h": 184,
						"w": 400
					},
					{
						"n": 5,
						"h": 72,
						"w": 355
					},
					{
						"n": 6,
						"h": 411,
						"w": 211
					},
					{
						"n": 7,
						"h": 327,
						"w": 227
					},
					{
						"n": 8,
						"h": 144,
						"w": 244
					},
					{
						"n": 17,
						"h": 52,
						"w": 242
					},
					{
						"n": 10,
						"h": 320,
						"w": 171
					},
					{
						"n": 11,
						"h": 160,
						"w": 118
					}
				],
				"away": [
					{
						"n": 1,
						"h": 218,
						"w": 707
					},
					{
						"n": 13,
						"h": 398,
						"w": 514
					},
					{
						"n": 3,
						"h": 252,
						"w": 618
					},
					{
						"n": 14,
						"h": 172,
						"w": 635
					},
					{
						"n": 5,
						"h": 110,
						"w": 657
					},
					{
						"n": 6,
						"h": 132,
						"w": 568
					},
					{
						"n": 7,
						"h": 289,
						"w": 589
					},
					{
						"n": 8,
						"h": 73,
						"w": 516
					},
					{
						"n": 17,
						"h": 395,
						"w": 503
					},
					{
						"n": 19,
						"h": 305,
						"w": 491
					},
					{
						"n": 11,
						"h": 158,
						"w": 429
					}
				],
				"ball": {
					"n": 0,
					"h": 320,
					"w": 171,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1175,
			"minute": 57,
			"messages": [
				{
					"owner": 1,
					"mes": "Джо Квигли[10](Галвэй Юнайтед) отдает пас К.Нолану[08](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 703
					},
					{
						"n": 2,
						"h": 389,
						"w": 355
					},
					{
						"n": 3,
						"h": 279,
						"w": 390
					},
					{
						"n": 4,
						"h": 171,
						"w": 398
					},
					{
						"n": 5,
						"h": 69,
						"w": 346
					},
					{
						"n": 6,
						"h": 413,
						"w": 147
					},
					{
						"n": 7,
						"h": 269,
						"w": 204
					},
					{
						"n": 8,
						"h": 201,
						"w": 273
					},
					{
						"n": 17,
						"h": 54,
						"w": 178
					},
					{
						"n": 10,
						"h": 316,
						"w": 162
					},
					{
						"n": 11,
						"h": 151,
						"w": 88
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 705
					},
					{
						"n": 13,
						"h": 396,
						"w": 578
					},
					{
						"n": 3,
						"h": 267,
						"w": 651
					},
					{
						"n": 14,
						"h": 180,
						"w": 658
					},
					{
						"n": 5,
						"h": 110,
						"w": 657
					},
					{
						"n": 6,
						"h": 164,
						"w": 580
					},
					{
						"n": 7,
						"h": 245,
						"w": 542
					},
					{
						"n": 8,
						"h": 54,
						"w": 577
					},
					{
						"n": 17,
						"h": 408,
						"w": 501
					},
					{
						"n": 19,
						"h": 249,
						"w": 467
					},
					{
						"n": 11,
						"h": 169,
						"w": 419
					}
				],
				"ball": {
					"n": 0,
					"h": 201,
					"w": 273,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 64
		},
		{
			"num": 1176,
			"minute": 57,
			"messages": [
				{
					"owner": 1,
					"mes": "Пас в штрафную..."
				},
				{
					"owner": 1,
					"mes": "Адам Гилберт[11](Галвэй Юнайтед) получает передачу..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 703
					},
					{
						"n": 2,
						"h": 382,
						"w": 345
					},
					{
						"n": 3,
						"h": 273,
						"w": 407
					},
					{
						"n": 4,
						"h": 172,
						"w": 400
					},
					{
						"n": 5,
						"h": 78,
						"w": 345
					},
					{
						"n": 6,
						"h": 388,
						"w": 68
					},
					{
						"n": 7,
						"h": 261,
						"w": 121
					},
					{
						"n": 8,
						"h": 194,
						"w": 251
					},
					{
						"n": 17,
						"h": 58,
						"w": 95
					},
					{
						"n": 10,
						"h": 258,
						"w": 103
					},
					{
						"n": 11,
						"h": 106,
						"w": 43
					}
				],
				"away": [
					{
						"n": 1,
						"h": 239,
						"w": 715
					},
					{
						"n": 13,
						"h": 392,
						"w": 661
					},
					{
						"n": 3,
						"h": 326,
						"w": 684
					},
					{
						"n": 14,
						"h": 195,
						"w": 689
					},
					{
						"n": 5,
						"h": 110,
						"w": 678
					},
					{
						"n": 6,
						"h": 190,
						"w": 620
					},
					{
						"n": 7,
						"h": 192,
						"w": 569
					},
					{
						"n": 8,
						"h": 30,
						"w": 580
					},
					{
						"n": 17,
						"h": 395,
						"w": 530
					},
					{
						"n": 19,
						"h": 256,
						"w": 489
					},
					{
						"n": 11,
						"h": 170,
						"w": 418
					}
				],
				"ball": {
					"n": 0,
					"h": 106,
					"w": 43,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 83
		},
		{
			"num": 1177,
			"minute": 57,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 709
					},
					{
						"n": 2,
						"h": 384,
						"w": 347
					},
					{
						"n": 3,
						"h": 284,
						"w": 406
					},
					{
						"n": 4,
						"h": 185,
						"w": 407
					},
					{
						"n": 5,
						"h": 67,
						"w": 357
					},
					{
						"n": 6,
						"h": 397,
						"w": 60
					},
					{
						"n": 7,
						"h": 272,
						"w": 105
					},
					{
						"n": 8,
						"h": 194,
						"w": 231
					},
					{
						"n": 17,
						"h": 55,
						"w": 76
					},
					{
						"n": 10,
						"h": 260,
						"w": 83
					},
					{
						"n": 11,
						"h": 106,
						"w": 13
					}
				],
				"away": [
					{
						"n": 1,
						"h": 240,
						"w": 718
					},
					{
						"n": 13,
						"h": 379,
						"w": 665
					},
					{
						"n": 3,
						"h": 326,
						"w": 691
					},
					{
						"n": 14,
						"h": 180,
						"w": 689
					},
					{
						"n": 5,
						"h": 110,
						"w": 683
					},
					{
						"n": 6,
						"h": 196,
						"w": 640
					},
					{
						"n": 7,
						"h": 190,
						"w": 589
					},
					{
						"n": 8,
						"h": 21,
						"w": 580
					},
					{
						"n": 17,
						"h": 415,
						"w": 530
					},
					{
						"n": 19,
						"h": 256,
						"w": 509
					},
					{
						"n": 11,
						"h": 172,
						"w": 410
					}
				],
				"ball": {
					"n": 0,
					"h": 106,
					"w": 13,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 20
		},
		{
			"num": 1178,
			"minute": 57,
			"messages": [
				{
					"owner": 1,
					"mes": "А.Гилберт[11](Галвэй Юнайтед) замечает набегающего партнера... Пас вдоль ворот..."
				},
				{
					"owner": 1,
					"mes": "Оливье Дюмон[26](Опава) прерывает передачу и выносит мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 704
					},
					{
						"n": 2,
						"h": 392,
						"w": 344
					},
					{
						"n": 3,
						"h": 280,
						"w": 410
					},
					{
						"n": 4,
						"h": 180,
						"w": 410
					},
					{
						"n": 5,
						"h": 76,
						"w": 343
					},
					{
						"n": 6,
						"h": 407,
						"w": 60
					},
					{
						"n": 7,
						"h": 284,
						"w": 92
					},
					{
						"n": 8,
						"h": 192,
						"w": 201
					},
					{
						"n": 17,
						"h": 45,
						"w": 64
					},
					{
						"n": 10,
						"h": 253,
						"w": 53
					},
					{
						"n": 11,
						"h": 106,
						"w": 13
					}
				],
				"away": [
					{
						"n": 1,
						"h": 240,
						"w": 718
					},
					{
						"n": 13,
						"h": 389,
						"w": 665
					},
					{
						"n": 3,
						"h": 324,
						"w": 709
					},
					{
						"n": 14,
						"h": 199,
						"w": 674
					},
					{
						"n": 5,
						"h": 110,
						"w": 684
					},
					{
						"n": 6,
						"h": 199,
						"w": 674
					},
					{
						"n": 7,
						"h": 181,
						"w": 618
					},
					{
						"n": 8,
						"h": 51,
						"w": 580
					},
					{
						"n": 17,
						"h": 427,
						"w": 530
					},
					{
						"n": 19,
						"h": 267,
						"w": 481
					},
					{
						"n": 11,
						"h": 162,
						"w": 413
					}
				],
				"ball": {
					"n": 0,
					"h": 251,
					"w": 46,
					"z": 0,
					"r": 0,
					"p": 1,
					"x": 0
				}
			},
			"interval": 30
		},
		{
			"num": 1179,
			"minute": 57,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 708
					},
					{
						"n": 2,
						"h": 372,
						"w": 342
					},
					{
						"n": 3,
						"h": 270,
						"w": 396
					},
					{
						"n": 4,
						"h": 166,
						"w": 405
					},
					{
						"n": 5,
						"h": 68,
						"w": 360
					},
					{
						"n": 6,
						"h": 394,
						"w": 80
					},
					{
						"n": 7,
						"h": 286,
						"w": 149
					},
					{
						"n": 8,
						"h": 136,
						"w": 232
					},
					{
						"n": 17,
						"h": 60,
						"w": 100
					},
					{
						"n": 10,
						"h": 297,
						"w": 90
					},
					{
						"n": 11,
						"h": 141,
						"w": 58
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 702
					},
					{
						"n": 13,
						"h": 374,
						"w": 645
					},
					{
						"n": 3,
						"h": 293,
						"w": 667
					},
					{
						"n": 14,
						"h": 173,
						"w": 658
					},
					{
						"n": 5,
						"h": 110,
						"w": 666
					},
					{
						"n": 6,
						"h": 188,
						"w": 661
					},
					{
						"n": 7,
						"h": 224,
						"w": 630
					},
					{
						"n": 8,
						"h": 69,
						"w": 634
					},
					{
						"n": 17,
						"h": 410,
						"w": 510
					},
					{
						"n": 19,
						"h": 331,
						"w": 463
					},
					{
						"n": 11,
						"h": 173,
						"w": 420
					}
				],
				"ball": {
					"n": 0,
					"h": 104,
					"w": 221,
					"z": 1,
					"r": 0,
					"p": 1,
					"x": 1
				}
			},
			"interval": 57
		},
		{
			"num": 1180,
			"minute": 57,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 704
					},
					{
						"n": 2,
						"h": 376,
						"w": 349
					},
					{
						"n": 3,
						"h": 284,
						"w": 390
					},
					{
						"n": 4,
						"h": 176,
						"w": 405
					},
					{
						"n": 5,
						"h": 69,
						"w": 359
					},
					{
						"n": 6,
						"h": 407,
						"w": 81
					},
					{
						"n": 7,
						"h": 291,
						"w": 165
					},
					{
						"n": 8,
						"h": 119,
						"w": 241
					},
					{
						"n": 17,
						"h": 43,
						"w": 100
					},
					{
						"n": 10,
						"h": 280,
						"w": 86
					},
					{
						"n": 11,
						"h": 147,
						"w": 74
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 707
					},
					{
						"n": 13,
						"h": 391,
						"w": 645
					},
					{
						"n": 3,
						"h": 285,
						"w": 658
					},
					{
						"n": 14,
						"h": 182,
						"w": 645
					},
					{
						"n": 5,
						"h": 110,
						"w": 655
					},
					{
						"n": 6,
						"h": 175,
						"w": 650
					},
					{
						"n": 7,
						"h": 241,
						"w": 630
					},
					{
						"n": 8,
						"h": 60,
						"w": 619
					},
					{
						"n": 17,
						"h": 399,
						"w": 510
					},
					{
						"n": 19,
						"h": 351,
						"w": 458
					},
					{
						"n": 11,
						"h": 170,
						"w": 413
					}
				],
				"ball": {
					"n": 0,
					"h": 60,
					"w": 273,
					"z": 0,
					"r": 0,
					"p": 1,
					"x": 0
				}
			},
			"interval": 17
		},
		{
			"num": 1181,
			"minute": 57,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 701
					},
					{
						"n": 2,
						"h": 356,
						"w": 397
					},
					{
						"n": 3,
						"h": 320,
						"w": 396
					},
					{
						"n": 4,
						"h": 219,
						"w": 400
					},
					{
						"n": 5,
						"h": 52,
						"w": 310
					},
					{
						"n": 6,
						"h": 410,
						"w": 133
					},
					{
						"n": 7,
						"h": 300,
						"w": 217
					},
					{
						"n": 8,
						"h": 142,
						"w": 288
					},
					{
						"n": 17,
						"h": 47,
						"w": 152
					},
					{
						"n": 10,
						"h": 276,
						"w": 137
					},
					{
						"n": 11,
						"h": 166,
						"w": 123
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 708
					},
					{
						"n": 13,
						"h": 392,
						"w": 593
					},
					{
						"n": 3,
						"h": 274,
						"w": 630
					},
					{
						"n": 14,
						"h": 181,
						"w": 617
					},
					{
						"n": 5,
						"h": 89,
						"w": 625
					},
					{
						"n": 6,
						"h": 218,
						"w": 620,
						"m": 670
					},
					{
						"n": 7,
						"h": 248,
						"w": 578
					},
					{
						"n": 8,
						"h": 47,
						"w": 569
					},
					{
						"n": 17,
						"h": 413,
						"w": 550
					},
					{
						"n": 19,
						"h": 405,
						"w": 429
					},
					{
						"n": 11,
						"h": 126,
						"w": 386
					}
				],
				"ball": {
					"n": 0,
					"h": 45,
					"w": 291,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 52
		},
		{
			"num": 1182,
			"minute": 57,
			"messages": [
				{
					"owner": 2,
					"mes": "Мяч подбирает А.Фрешль[39](Опава)..."
				},
				{
					"owner": 2,
					"mes": "Справа открывается Мирослав Манолов[27](Опава)... Передача..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 706
					},
					{
						"n": 2,
						"h": 368,
						"w": 363
					},
					{
						"n": 3,
						"h": 270,
						"w": 415
					},
					{
						"n": 4,
						"h": 168,
						"w": 418
					},
					{
						"n": 5,
						"h": 66,
						"w": 362
					},
					{
						"n": 6,
						"h": 407,
						"w": 187
					},
					{
						"n": 7,
						"h": 246,
						"w": 215
					},
					{
						"n": 8,
						"h": 174,
						"w": 331
					},
					{
						"n": 17,
						"h": 49,
						"w": 179
					},
					{
						"n": 10,
						"h": 275,
						"w": 191
					},
					{
						"n": 11,
						"h": 183,
						"w": 152
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 710
					},
					{
						"n": 13,
						"h": 391,
						"w": 539
					},
					{
						"n": 3,
						"h": 286,
						"w": 617
					},
					{
						"n": 14,
						"h": 176,
						"w": 627
					},
					{
						"n": 5,
						"h": 66,
						"w": 598
					},
					{
						"n": 6,
						"h": 199,
						"w": 569
					},
					{
						"n": 7,
						"h": 243,
						"w": 524
					},
					{
						"n": 8,
						"h": 48,
						"w": 515
					},
					{
						"n": 17,
						"h": 395,
						"w": 499
					},
					{
						"n": 19,
						"h": 397,
						"w": 422
					},
					{
						"n": 11,
						"h": 73,
						"w": 377
					}
				],
				"ball": {
					"n": 0,
					"h": 207,
					"w": 196,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 54
		},
		{
			"num": 1183,
			"minute": 57,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 701
					},
					{
						"n": 2,
						"h": 378,
						"w": 382
					},
					{
						"n": 3,
						"h": 265,
						"w": 455
					},
					{
						"n": 4,
						"h": 176,
						"w": 457
					},
					{
						"n": 5,
						"h": 81,
						"w": 399
					},
					{
						"n": 6,
						"h": 410,
						"w": 227
					},
					{
						"n": 7,
						"h": 219,
						"w": 246
					},
					{
						"n": 8,
						"h": 175,
						"w": 371
					},
					{
						"n": 17,
						"h": 51,
						"w": 199
					},
					{
						"n": 10,
						"h": 277,
						"w": 231
					},
					{
						"n": 11,
						"h": 180,
						"w": 192
					}
				],
				"away": [
					{
						"n": 1,
						"h": 226,
						"w": 706
					},
					{
						"n": 13,
						"h": 390,
						"w": 499
					},
					{
						"n": 3,
						"h": 276,
						"w": 606
					},
					{
						"n": 14,
						"h": 171,
						"w": 592
					},
					{
						"n": 5,
						"h": 74,
						"w": 582
					},
					{
						"n": 6,
						"h": 199,
						"w": 529
					},
					{
						"n": 7,
						"h": 241,
						"w": 489
					},
					{
						"n": 8,
						"h": 51,
						"w": 475
					},
					{
						"n": 17,
						"h": 396,
						"w": 459
					},
					{
						"n": 19,
						"h": 377,
						"w": 388
					},
					{
						"n": 11,
						"h": 42,
						"w": 358
					}
				],
				"ball": {
					"n": 0,
					"h": 209,
					"w": 231,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1184,
			"minute": 58,
			"possession": 44,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 709
					},
					{
						"n": 2,
						"h": 378,
						"w": 422
					},
					{
						"n": 3,
						"h": 262,
						"w": 451
					},
					{
						"n": 4,
						"h": 181,
						"w": 462,
						"f": 86
					},
					{
						"n": 5,
						"h": 72,
						"w": 390,
						"f": 84,
						"c": 2
					},
					{
						"n": 6,
						"h": 409,
						"w": 267,
						"f": 83
					},
					{
						"n": 7,
						"h": 235,
						"w": 282
					},
					{
						"n": 8,
						"h": 190,
						"w": 365,
						"f": 81
					},
					{
						"n": 17,
						"h": 51,
						"w": 219,
						"f": 95
					},
					{
						"n": 10,
						"h": 308,
						"w": 257,
						"f": 82
					},
					{
						"n": 11,
						"h": 161,
						"w": 227
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 666
					},
					{
						"n": 13,
						"h": 401,
						"w": 463,
						"f": 94
					},
					{
						"n": 3,
						"h": 279,
						"w": 566
					},
					{
						"n": 14,
						"h": 168,
						"w": 552,
						"f": 93
					},
					{
						"n": 5,
						"h": 59,
						"w": 579,
						"f": 83
					},
					{
						"n": 6,
						"h": 199,
						"w": 489,
						"f": 83
					},
					{
						"n": 7,
						"h": 211,
						"w": 507
					},
					{
						"n": 8,
						"h": 58,
						"w": 448
					},
					{
						"n": 17,
						"h": 378,
						"w": 424,
						"f": 93
					},
					{
						"n": 19,
						"h": 387,
						"w": 350
					},
					{
						"n": 11,
						"h": 42,
						"w": 318
					}
				],
				"ball": {
					"n": 0,
					"h": 239,
					"w": 213,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1185,
			"minute": 58,
			"messages": [
				{
					"owner": 2,
					"mes": "Пасом в ноги М.Манолов[27](Опава) пытается найти Н.Мансура[23](Опава)..."
				},
				{
					"owner": 2,
					"mes": "Нир Мансур[23](Опава) получил мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 706
					},
					{
						"n": 2,
						"h": 388,
						"w": 395
					},
					{
						"n": 3,
						"h": 270,
						"w": 468
					},
					{
						"n": 4,
						"h": 176,
						"w": 460
					},
					{
						"n": 5,
						"h": 96,
						"w": 406
					},
					{
						"n": 6,
						"h": 409,
						"w": 296
					},
					{
						"n": 7,
						"h": 246,
						"w": 309
					},
					{
						"n": 8,
						"h": 192,
						"w": 365
					},
					{
						"n": 17,
						"h": 46,
						"w": 247
					},
					{
						"n": 10,
						"h": 310,
						"w": 270
					},
					{
						"n": 11,
						"h": 148,
						"w": 253
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 695
					},
					{
						"n": 13,
						"h": 405,
						"w": 434
					},
					{
						"n": 3,
						"h": 256,
						"w": 544
					},
					{
						"n": 14,
						"h": 174,
						"w": 581
					},
					{
						"n": 5,
						"h": 71,
						"w": 605
					},
					{
						"n": 6,
						"h": 201,
						"w": 460
					},
					{
						"n": 7,
						"h": 211,
						"w": 507,
						"m": 550
					},
					{
						"n": 8,
						"h": 50,
						"w": 420
					},
					{
						"n": 17,
						"h": 378,
						"w": 395
					},
					{
						"n": 19,
						"h": 363,
						"w": 334
					},
					{
						"n": 11,
						"h": 32,
						"w": 345
					}
				],
				"ball": {
					"n": 0,
					"h": 194,
					"w": 176,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 29
		},
		{
			"num": 1186,
			"minute": 58,
			"messages": [
				{
					"owner": 2,
					"mes": "Н.Мансур[23](Опава) пасует В.Сланине[34](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 701
					},
					{
						"n": 2,
						"h": 361,
						"w": 410
					},
					{
						"n": 3,
						"h": 240,
						"w": 459
					},
					{
						"n": 4,
						"h": 145,
						"w": 457
					},
					{
						"n": 5,
						"h": 89,
						"w": 436
					},
					{
						"n": 6,
						"h": 411,
						"w": 307
					},
					{
						"n": 7,
						"h": 254,
						"w": 339
					},
					{
						"n": 8,
						"h": 176,
						"w": 368
					},
					{
						"n": 17,
						"h": 48,
						"w": 278
					},
					{
						"n": 10,
						"h": 306,
						"w": 270
					},
					{
						"n": 11,
						"h": 146,
						"w": 270
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 704
					},
					{
						"n": 13,
						"h": 405,
						"w": 465
					},
					{
						"n": 3,
						"h": 265,
						"w": 549
					},
					{
						"n": 14,
						"h": 193,
						"w": 556
					},
					{
						"n": 5,
						"h": 42,
						"w": 576
					},
					{
						"n": 6,
						"h": 216,
						"w": 487
					},
					{
						"n": 7,
						"h": 213,
						"w": 476
					},
					{
						"n": 8,
						"h": 44,
						"w": 437
					},
					{
						"n": 17,
						"h": 400,
						"w": 373
					},
					{
						"n": 19,
						"h": 338,
						"w": 316
					},
					{
						"n": 11,
						"h": 59,
						"w": 330
					}
				],
				"ball": {
					"n": 0,
					"h": 257,
					"w": 164,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 31
		},
		{
			"num": 1187,
			"minute": 58,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 703
					},
					{
						"n": 2,
						"h": 347,
						"w": 448
					},
					{
						"n": 3,
						"h": 251,
						"w": 459
					},
					{
						"n": 4,
						"h": 160,
						"w": 458
					},
					{
						"n": 5,
						"h": 78,
						"w": 397
					},
					{
						"n": 6,
						"h": 420,
						"w": 346
					},
					{
						"n": 7,
						"h": 270,
						"w": 365
					},
					{
						"n": 8,
						"h": 188,
						"w": 391
					},
					{
						"n": 17,
						"h": 54,
						"w": 318
					},
					{
						"n": 10,
						"h": 277,
						"w": 297
					},
					{
						"n": 11,
						"h": 139,
						"w": 270
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 681
					},
					{
						"n": 13,
						"h": 400,
						"w": 494
					},
					{
						"n": 3,
						"h": 297,
						"w": 566
					},
					{
						"n": 14,
						"h": 176,
						"w": 526
					},
					{
						"n": 5,
						"h": 43,
						"w": 566
					},
					{
						"n": 6,
						"h": 235,
						"w": 494
					},
					{
						"n": 7,
						"h": 227,
						"w": 438
					},
					{
						"n": 8,
						"h": 31,
						"w": 423
					},
					{
						"n": 17,
						"h": 404,
						"w": 351
					},
					{
						"n": 19,
						"h": 305,
						"w": 293
					},
					{
						"n": 11,
						"h": 95,
						"w": 313
					}
				],
				"ball": {
					"n": 0,
					"h": 274,
					"w": 194,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1188,
			"minute": 58,
			"messages": [
				{
					"owner": 2,
					"mes": "Вацлав Сланина[34](Опава) пасует вперед на М.Манолова[27](Опава)..."
				},
				{
					"owner": 2,
					"mes": "Джо Квигли[10](Галвэй Юнайтед) показывает хорошее позиционное чутье и перехватывает мяч!..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 702
					},
					{
						"n": 2,
						"h": 321,
						"w": 455
					},
					{
						"n": 3,
						"h": 247,
						"w": 463
					},
					{
						"n": 4,
						"h": 175,
						"w": 457
					},
					{
						"n": 5,
						"h": 81,
						"w": 391
					},
					{
						"n": 6,
						"h": 413,
						"w": 360
					},
					{
						"n": 7,
						"h": 257,
						"w": 383
					},
					{
						"n": 8,
						"h": 190,
						"w": 388
					},
					{
						"n": 17,
						"h": 50,
						"w": 324
					},
					{
						"n": 10,
						"h": 263,
						"w": 274
					},
					{
						"n": 11,
						"h": 160,
						"w": 270
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 656
					},
					{
						"n": 13,
						"h": 405,
						"w": 487
					},
					{
						"n": 3,
						"h": 290,
						"w": 556
					},
					{
						"n": 14,
						"h": 172,
						"w": 535,
						"m": 610
					},
					{
						"n": 5,
						"h": 36,
						"w": 556
					},
					{
						"n": 6,
						"h": 215,
						"w": 487
					},
					{
						"n": 7,
						"h": 204,
						"w": 443,
						"m": 540
					},
					{
						"n": 8,
						"h": 41,
						"w": 418
					},
					{
						"n": 17,
						"h": 399,
						"w": 349
					},
					{
						"n": 19,
						"h": 293,
						"w": 280
					},
					{
						"n": 11,
						"h": 120,
						"w": 302
					}
				],
				"ball": {
					"n": 0,
					"h": 263,
					"w": 274,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 27
		},
		{
			"num": 1189,
			"minute": 58,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 707
					},
					{
						"n": 2,
						"h": 354,
						"w": 431
					},
					{
						"n": 3,
						"h": 280,
						"w": 469
					},
					{
						"n": 4,
						"h": 179,
						"w": 452
					},
					{
						"n": 5,
						"h": 63,
						"w": 414
					},
					{
						"n": 6,
						"h": 401,
						"w": 322
					},
					{
						"n": 7,
						"h": 262,
						"w": 343
					},
					{
						"n": 8,
						"h": 179,
						"w": 350
					},
					{
						"n": 17,
						"h": 52,
						"w": 284
					},
					{
						"n": 10,
						"h": 291,
						"w": 246,
						"m": 790
					},
					{
						"n": 11,
						"h": 158,
						"w": 230
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 648
					},
					{
						"n": 13,
						"h": 398,
						"w": 472
					},
					{
						"n": 3,
						"h": 276,
						"w": 593
					},
					{
						"n": 14,
						"h": 175,
						"w": 574
					},
					{
						"n": 5,
						"h": 69,
						"w": 578
					},
					{
						"n": 6,
						"h": 255,
						"w": 514
					},
					{
						"n": 7,
						"h": 174,
						"w": 473
					},
					{
						"n": 8,
						"h": 49,
						"w": 434
					},
					{
						"n": 17,
						"h": 403,
						"w": 389
					},
					{
						"n": 19,
						"h": 285,
						"w": 319
					},
					{
						"n": 11,
						"h": 96,
						"w": 309
					}
				],
				"ball": {
					"n": 0,
					"h": 291,
					"w": 246,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1190,
			"minute": 58,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 705
					},
					{
						"n": 2,
						"h": 368,
						"w": 397
					},
					{
						"n": 3,
						"h": 270,
						"w": 439
					},
					{
						"n": 4,
						"h": 179,
						"w": 434
					},
					{
						"n": 5,
						"h": 65,
						"w": 387
					},
					{
						"n": 6,
						"h": 400,
						"w": 285
					},
					{
						"n": 7,
						"h": 271,
						"w": 307
					},
					{
						"n": 8,
						"h": 173,
						"w": 313
					},
					{
						"n": 17,
						"h": 49,
						"w": 247
					},
					{
						"n": 10,
						"h": 311,
						"w": 211
					},
					{
						"n": 11,
						"h": 155,
						"w": 193
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 643
					},
					{
						"n": 13,
						"h": 401,
						"w": 509
					},
					{
						"n": 3,
						"h": 275,
						"w": 607
					},
					{
						"n": 14,
						"h": 167,
						"w": 608
					},
					{
						"n": 5,
						"h": 96,
						"w": 604
					},
					{
						"n": 6,
						"h": 282,
						"w": 540
					},
					{
						"n": 7,
						"h": 151,
						"w": 506
					},
					{
						"n": 8,
						"h": 50,
						"w": 471
					},
					{
						"n": 17,
						"h": 409,
						"w": 405
					},
					{
						"n": 19,
						"h": 282,
						"w": 356
					},
					{
						"n": 11,
						"h": 117,
						"w": 339
					}
				],
				"ball": {
					"n": 0,
					"h": 311,
					"w": 211,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 37
		},
		{
			"num": 1191,
			"minute": 58,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 707
					},
					{
						"n": 2,
						"h": 376,
						"w": 358
					},
					{
						"n": 3,
						"h": 276,
						"w": 416
					},
					{
						"n": 4,
						"h": 181,
						"w": 413
					},
					{
						"n": 5,
						"h": 75,
						"w": 354
					},
					{
						"n": 6,
						"h": 402,
						"w": 245
					},
					{
						"n": 7,
						"h": 276,
						"w": 268
					},
					{
						"n": 8,
						"h": 164,
						"w": 314
					},
					{
						"n": 17,
						"h": 52,
						"w": 207
					},
					{
						"n": 10,
						"h": 311,
						"w": 167
					},
					{
						"n": 11,
						"h": 158,
						"w": 153
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 682
					},
					{
						"n": 13,
						"h": 398,
						"w": 549
					},
					{
						"n": 3,
						"h": 247,
						"w": 621
					},
					{
						"n": 14,
						"h": 154,
						"w": 613
					},
					{
						"n": 5,
						"h": 110,
						"w": 622
					},
					{
						"n": 6,
						"h": 296,
						"w": 570
					},
					{
						"n": 7,
						"h": 144,
						"w": 548
					},
					{
						"n": 8,
						"h": 48,
						"w": 511
					},
					{
						"n": 17,
						"h": 420,
						"w": 443
					},
					{
						"n": 19,
						"h": 284,
						"w": 396
					},
					{
						"n": 11,
						"h": 135,
						"w": 375
					}
				],
				"ball": {
					"n": 0,
					"h": 311,
					"w": 167,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1192,
			"minute": 58,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 704
					},
					{
						"n": 2,
						"h": 391,
						"w": 377
					},
					{
						"n": 3,
						"h": 283,
						"w": 416
					},
					{
						"n": 4,
						"h": 165,
						"w": 415
					},
					{
						"n": 5,
						"h": 72,
						"w": 368
					},
					{
						"n": 6,
						"h": 399,
						"w": 219
					},
					{
						"n": 7,
						"h": 283,
						"w": 243
					},
					{
						"n": 8,
						"h": 161,
						"w": 288
					},
					{
						"n": 17,
						"h": 54,
						"w": 181
					},
					{
						"n": 10,
						"h": 305,
						"w": 142
					},
					{
						"n": 11,
						"h": 165,
						"w": 128
					}
				],
				"away": [
					{
						"n": 1,
						"h": 218,
						"w": 707
					},
					{
						"n": 13,
						"h": 398,
						"w": 549
					},
					{
						"n": 3,
						"h": 248,
						"w": 617
					},
					{
						"n": 14,
						"h": 148,
						"w": 588
					},
					{
						"n": 5,
						"h": 110,
						"w": 614
					},
					{
						"n": 6,
						"h": 293,
						"w": 568
					},
					{
						"n": 7,
						"h": 139,
						"w": 548
					},
					{
						"n": 8,
						"h": 48,
						"w": 511
					},
					{
						"n": 17,
						"h": 415,
						"w": 463
					},
					{
						"n": 19,
						"h": 286,
						"w": 422
					},
					{
						"n": 11,
						"h": 152,
						"w": 395
					}
				],
				"ball": {
					"n": 0,
					"h": 305,
					"w": 142,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 26
		},
		{
			"num": 1193,
			"minute": 58,
			"messages": [
				{
					"owner": 1,
					"mes": "В.Сланина[34](Опава) вступает в единоборство с Д.Квигли[10](Галвэй Юнайтед)..."
				},
				{
					"owner": 1,
					"mes": "Вацлав Сланина[34](Опава) обкрадывает Д.Квигли[10](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 704
					},
					{
						"n": 2,
						"h": 391,
						"w": 377
					},
					{
						"n": 3,
						"h": 283,
						"w": 416
					},
					{
						"n": 4,
						"h": 165,
						"w": 415
					},
					{
						"n": 5,
						"h": 72,
						"w": 368
					},
					{
						"n": 6,
						"h": 398,
						"w": 214
					},
					{
						"n": 7,
						"h": 285,
						"w": 238
					},
					{
						"n": 8,
						"h": 160,
						"w": 283
					},
					{
						"n": 17,
						"h": 55,
						"w": 176
					},
					{
						"n": 10,
						"h": 303,
						"w": 132
					},
					{
						"n": 11,
						"h": 166,
						"w": 123
					}
				],
				"away": [
					{
						"n": 1,
						"h": 218,
						"w": 707
					},
					{
						"n": 13,
						"h": 398,
						"w": 549
					},
					{
						"n": 3,
						"h": 248,
						"w": 617
					},
					{
						"n": 14,
						"h": 147,
						"w": 583,
						"m": 620
					},
					{
						"n": 5,
						"h": 110,
						"w": 614
					},
					{
						"n": 6,
						"h": 293,
						"w": 568
					},
					{
						"n": 7,
						"h": 139,
						"w": 548
					},
					{
						"n": 8,
						"h": 48,
						"w": 511
					},
					{
						"n": 17,
						"h": 415,
						"w": 463
					},
					{
						"n": 19,
						"h": 286,
						"w": 426
					},
					{
						"n": 11,
						"h": 155,
						"w": 398
					}
				],
				"ball": {
					"n": 0,
					"h": 303,
					"w": 137,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 5
		},
		{
			"num": 1194,
			"minute": 58,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 704
					},
					{
						"n": 2,
						"h": 391,
						"w": 377
					},
					{
						"n": 3,
						"h": 283,
						"w": 416
					},
					{
						"n": 4,
						"h": 165,
						"w": 415
					},
					{
						"n": 5,
						"h": 72,
						"w": 368
					},
					{
						"n": 6,
						"h": 396,
						"w": 204
					},
					{
						"n": 7,
						"h": 287,
						"w": 228
					},
					{
						"n": 8,
						"h": 159,
						"w": 273
					},
					{
						"n": 17,
						"h": 55,
						"w": 166
					},
					{
						"n": 10,
						"h": 303,
						"w": 132
					},
					{
						"n": 11,
						"h": 169,
						"w": 114
					}
				],
				"away": [
					{
						"n": 1,
						"h": 218,
						"w": 707
					},
					{
						"n": 13,
						"h": 398,
						"w": 549
					},
					{
						"n": 3,
						"h": 248,
						"w": 617
					},
					{
						"n": 14,
						"h": 144,
						"w": 573
					},
					{
						"n": 5,
						"h": 110,
						"w": 614
					},
					{
						"n": 6,
						"h": 293,
						"w": 568
					},
					{
						"n": 7,
						"h": 139,
						"w": 548
					},
					{
						"n": 8,
						"h": 48,
						"w": 511
					},
					{
						"n": 17,
						"h": 415,
						"w": 463
					},
					{
						"n": 19,
						"h": 286,
						"w": 426
					},
					{
						"n": 11,
						"h": 162,
						"w": 406
					}
				],
				"ball": {
					"n": 0,
					"h": 306,
					"w": 147,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 10
		},
		{
			"num": 1195,
			"minute": 58,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 704
					},
					{
						"n": 2,
						"h": 366,
						"w": 408
					},
					{
						"n": 3,
						"h": 289,
						"w": 452
					},
					{
						"n": 4,
						"h": 169,
						"w": 448
					},
					{
						"n": 5,
						"h": 96,
						"w": 400
					},
					{
						"n": 6,
						"h": 405,
						"w": 243
					},
					{
						"n": 7,
						"h": 290,
						"w": 268
					},
					{
						"n": 8,
						"h": 172,
						"w": 311
					},
					{
						"n": 17,
						"h": 49,
						"w": 206
					},
					{
						"n": 10,
						"h": 308,
						"w": 141
					},
					{
						"n": 11,
						"h": 163,
						"w": 153
					}
				],
				"away": [
					{
						"n": 1,
						"h": 226,
						"w": 706
					},
					{
						"n": 13,
						"h": 403,
						"w": 509
					},
					{
						"n": 3,
						"h": 273,
						"w": 627
					},
					{
						"n": 14,
						"h": 119,
						"w": 548
					},
					{
						"n": 5,
						"h": 73,
						"w": 621
					},
					{
						"n": 6,
						"h": 260,
						"w": 545
					},
					{
						"n": 7,
						"h": 166,
						"w": 518
					},
					{
						"n": 8,
						"h": 38,
						"w": 472
					},
					{
						"n": 17,
						"h": 412,
						"w": 423
					},
					{
						"n": 19,
						"h": 291,
						"w": 386
					},
					{
						"n": 11,
						"h": 151,
						"w": 367
					}
				],
				"ball": {
					"n": 0,
					"h": 331,
					"w": 172,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1196,
			"minute": 58,
			"messages": [
				{
					"owner": 2,
					"mes": "Вацлав Сланина[34](Опава) пасует Т.Прохазке[25](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 701
					},
					{
						"n": 2,
						"h": 350,
						"w": 441
					},
					{
						"n": 3,
						"h": 300,
						"w": 452
					},
					{
						"n": 4,
						"h": 183,
						"w": 453
					},
					{
						"n": 5,
						"h": 91,
						"w": 437
					},
					{
						"n": 6,
						"h": 404,
						"w": 280
					},
					{
						"n": 7,
						"h": 286,
						"w": 305
					},
					{
						"n": 8,
						"h": 189,
						"w": 344
					},
					{
						"n": 17,
						"h": 51,
						"w": 243
					},
					{
						"n": 10,
						"h": 311,
						"w": 178
					},
					{
						"n": 11,
						"h": 165,
						"w": 190
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 704
					},
					{
						"n": 13,
						"h": 400,
						"w": 472
					},
					{
						"n": 3,
						"h": 281,
						"w": 604
					},
					{
						"n": 14,
						"h": 123,
						"w": 552,
						"m": 630
					},
					{
						"n": 5,
						"h": 85,
						"w": 613
					},
					{
						"n": 6,
						"h": 232,
						"w": 521
					},
					{
						"n": 7,
						"h": 180,
						"w": 484
					},
					{
						"n": 8,
						"h": 37,
						"w": 435
					},
					{
						"n": 17,
						"h": 408,
						"w": 386
					},
					{
						"n": 19,
						"h": 298,
						"w": 350
					},
					{
						"n": 11,
						"h": 117,
						"w": 382
					}
				],
				"ball": {
					"n": 0,
					"h": 365,
					"w": 107,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 37
		},
		{
			"num": 1197,
			"minute": 58,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 709
					},
					{
						"n": 2,
						"h": 350,
						"w": 452
					},
					{
						"n": 3,
						"h": 312,
						"w": 451
					},
					{
						"n": 4,
						"h": 190,
						"w": 469
					},
					{
						"n": 5,
						"h": 120,
						"w": 457
					},
					{
						"n": 6,
						"h": 397,
						"w": 320
					},
					{
						"n": 7,
						"h": 295,
						"w": 344
					},
					{
						"n": 8,
						"h": 210,
						"w": 378
					},
					{
						"n": 17,
						"h": 54,
						"w": 283
					},
					{
						"n": 10,
						"h": 315,
						"w": 218
					},
					{
						"n": 11,
						"h": 148,
						"w": 227
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 702
					},
					{
						"n": 13,
						"h": 395,
						"w": 456
					},
					{
						"n": 3,
						"h": 271,
						"w": 612
					},
					{
						"n": 14,
						"h": 152,
						"w": 579
					},
					{
						"n": 5,
						"h": 73,
						"w": 579
					},
					{
						"n": 6,
						"h": 194,
						"w": 509
					},
					{
						"n": 7,
						"h": 195,
						"w": 447
					},
					{
						"n": 8,
						"h": 43,
						"w": 396
					},
					{
						"n": 17,
						"h": 410,
						"w": 346
					},
					{
						"n": 19,
						"h": 306,
						"w": 311
					},
					{
						"n": 11,
						"h": 98,
						"w": 347
					}
				],
				"ball": {
					"n": 0,
					"h": 377,
					"w": 141,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1198,
			"minute": 58,
			"messages": [
				{
					"owner": 2,
					"mes": "Пас налево на Н.Мансура[23](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 708
					},
					{
						"n": 2,
						"h": 366,
						"w": 438
					},
					{
						"n": 3,
						"h": 263,
						"w": 458
					},
					{
						"n": 4,
						"h": 143,
						"w": 452
					},
					{
						"n": 5,
						"h": 79,
						"w": 443
					},
					{
						"n": 6,
						"h": 413,
						"w": 360
					},
					{
						"n": 7,
						"h": 268,
						"w": 372
					},
					{
						"n": 8,
						"h": 160,
						"w": 384
					},
					{
						"n": 17,
						"h": 44,
						"w": 332
					},
					{
						"n": 10,
						"h": 307,
						"w": 267
					},
					{
						"n": 11,
						"h": 136,
						"w": 270
					}
				],
				"away": [
					{
						"n": 1,
						"h": 229,
						"w": 706
					},
					{
						"n": 13,
						"h": 415,
						"w": 475
					},
					{
						"n": 3,
						"h": 271,
						"w": 612
					},
					{
						"n": 14,
						"h": 168,
						"w": 592
					},
					{
						"n": 5,
						"h": 74,
						"w": 589
					},
					{
						"n": 6,
						"h": 215,
						"w": 508
					},
					{
						"n": 7,
						"h": 224,
						"w": 437
					},
					{
						"n": 8,
						"h": 49,
						"w": 445
					},
					{
						"n": 17,
						"h": 401,
						"w": 297
					},
					{
						"n": 19,
						"h": 303,
						"w": 292
					},
					{
						"n": 11,
						"h": 75,
						"w": 302
					}
				],
				"ball": {
					"n": 0,
					"h": 179,
					"w": 108,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 50
		},
		{
			"num": 1199,
			"minute": 58,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 701
					},
					{
						"n": 2,
						"h": 381,
						"w": 440
					},
					{
						"n": 3,
						"h": 235,
						"w": 469
					},
					{
						"n": 4,
						"h": 182,
						"w": 462
					},
					{
						"n": 5,
						"h": 73,
						"w": 440
					},
					{
						"n": 6,
						"h": 420,
						"w": 360
					},
					{
						"n": 7,
						"h": 271,
						"w": 386
					},
					{
						"n": 8,
						"h": 184,
						"w": 402
					},
					{
						"n": 17,
						"h": 53,
						"w": 360
					},
					{
						"n": 10,
						"h": 321,
						"w": 270
					},
					{
						"n": 11,
						"h": 140,
						"w": 270
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 708
					},
					{
						"n": 13,
						"h": 402,
						"w": 443
					},
					{
						"n": 3,
						"h": 279,
						"w": 578
					},
					{
						"n": 14,
						"h": 168,
						"w": 588
					},
					{
						"n": 5,
						"h": 75,
						"w": 585
					},
					{
						"n": 6,
						"h": 215,
						"w": 489
					},
					{
						"n": 7,
						"h": 222,
						"w": 397
					},
					{
						"n": 8,
						"h": 44,
						"w": 405
					},
					{
						"n": 17,
						"h": 407,
						"w": 300
					},
					{
						"n": 19,
						"h": 273,
						"w": 290
					},
					{
						"n": 11,
						"h": 39,
						"w": 300
					}
				],
				"ball": {
					"n": 0,
					"h": 171,
					"w": 142,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1200,
			"minute": 58,
			"messages": [
				{
					"owner": 2,
					"mes": "Н.Мансур[23](Опава) пасует К.Ласаку[21](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 706
					},
					{
						"n": 2,
						"h": 384,
						"w": 440
					},
					{
						"n": 3,
						"h": 217,
						"w": 471
					},
					{
						"n": 4,
						"h": 166,
						"w": 460
					},
					{
						"n": 5,
						"h": 65,
						"w": 440
					},
					{
						"n": 6,
						"h": 421,
						"w": 367
					},
					{
						"n": 7,
						"h": 270,
						"w": 395
					},
					{
						"n": 8,
						"h": 218,
						"w": 386
					},
					{
						"n": 17,
						"h": 50,
						"w": 367
					},
					{
						"n": 10,
						"h": 306,
						"w": 277
					},
					{
						"n": 11,
						"h": 132,
						"w": 270
					}
				],
				"away": [
					{
						"n": 1,
						"h": 243,
						"w": 685
					},
					{
						"n": 13,
						"h": 402,
						"w": 459
					},
					{
						"n": 3,
						"h": 281,
						"w": 588
					},
					{
						"n": 14,
						"h": 183,
						"w": 602
					},
					{
						"n": 5,
						"h": 58,
						"w": 611
					},
					{
						"n": 6,
						"h": 232,
						"w": 504
					},
					{
						"n": 7,
						"h": 230,
						"w": 363
					},
					{
						"n": 8,
						"h": 46,
						"w": 367
					},
					{
						"n": 17,
						"h": 415,
						"w": 300
					},
					{
						"n": 19,
						"h": 296,
						"w": 270
					},
					{
						"n": 11,
						"h": 36,
						"w": 300
					}
				],
				"ball": {
					"n": 0,
					"h": 207,
					"w": 35,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 38
		},
		{
			"num": 1201,
			"minute": 58,
			"messages": [
				{
					"owner": 2,
					"mes": "Крыштоф Ласак[21](Опава) смотрит направо... Пас Т.Прохазке[25](Опава)..."
				},
				{
					"owner": 2,
					"mes": "Томаш Прохазка[25](Опава) получил мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 707
					},
					{
						"n": 2,
						"h": 380,
						"w": 440
					},
					{
						"n": 3,
						"h": 237,
						"w": 469
					},
					{
						"n": 4,
						"h": 191,
						"w": 466
					},
					{
						"n": 5,
						"h": 120,
						"w": 456
					},
					{
						"n": 6,
						"h": 400,
						"w": 360
					},
					{
						"n": 7,
						"h": 257,
						"w": 383
					},
					{
						"n": 8,
						"h": 173,
						"w": 410
					},
					{
						"n": 17,
						"h": 33,
						"w": 360
					},
					{
						"n": 10,
						"h": 271,
						"w": 270
					},
					{
						"n": 11,
						"h": 147,
						"w": 270
					}
				],
				"away": [
					{
						"n": 1,
						"h": 231,
						"w": 700
					},
					{
						"n": 13,
						"h": 390,
						"w": 451
					},
					{
						"n": 3,
						"h": 278,
						"w": 585
					},
					{
						"n": 14,
						"h": 179,
						"w": 589
					},
					{
						"n": 5,
						"h": 51,
						"w": 545
					},
					{
						"n": 6,
						"h": 179,
						"w": 483
					},
					{
						"n": 7,
						"h": 198,
						"w": 343
					},
					{
						"n": 8,
						"h": 38,
						"w": 407
					},
					{
						"n": 17,
						"h": 408,
						"w": 300
					},
					{
						"n": 19,
						"h": 275,
						"w": 299
					},
					{
						"n": 11,
						"h": 40,
						"w": 300
					}
				],
				"ball": {
					"n": 0,
					"h": 399,
					"w": 175,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 79
		},
		{
			"num": 1202,
			"minute": 58,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 709
					},
					{
						"n": 2,
						"h": 380,
						"w": 440
					},
					{
						"n": 3,
						"h": 245,
						"w": 469
					},
					{
						"n": 4,
						"h": 170,
						"w": 461
					},
					{
						"n": 5,
						"h": 120,
						"w": 459
					},
					{
						"n": 6,
						"h": 392,
						"w": 360
					},
					{
						"n": 7,
						"h": 252,
						"w": 367
					},
					{
						"n": 8,
						"h": 197,
						"w": 378
					},
					{
						"n": 17,
						"h": 34,
						"w": 360
					},
					{
						"n": 10,
						"h": 274,
						"w": 270
					},
					{
						"n": 11,
						"h": 174,
						"w": 270
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 710
					},
					{
						"n": 13,
						"h": 414,
						"w": 451
					},
					{
						"n": 3,
						"h": 276,
						"w": 600
					},
					{
						"n": 14,
						"h": 176,
						"w": 595
					},
					{
						"n": 5,
						"h": 67,
						"w": 513
					},
					{
						"n": 6,
						"h": 193,
						"w": 463
					},
					{
						"n": 7,
						"h": 203,
						"w": 363
					},
					{
						"n": 8,
						"h": 38,
						"w": 367
					},
					{
						"n": 17,
						"h": 399,
						"w": 284
					},
					{
						"n": 19,
						"h": 301,
						"w": 285
					},
					{
						"n": 11,
						"h": 40,
						"w": 300
					}
				],
				"ball": {
					"n": 0,
					"h": 383,
					"w": 207,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1203,
			"minute": 58,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 708
					},
					{
						"n": 2,
						"h": 385,
						"w": 479
					},
					{
						"n": 3,
						"h": 246,
						"w": 508
					},
					{
						"n": 4,
						"h": 170,
						"w": 500
					},
					{
						"n": 5,
						"h": 120,
						"w": 498
					},
					{
						"n": 6,
						"h": 392,
						"w": 379
					},
					{
						"n": 7,
						"h": 252,
						"w": 406
					},
					{
						"n": 8,
						"h": 202,
						"w": 417
					},
					{
						"n": 17,
						"h": 36,
						"w": 379
					},
					{
						"n": 10,
						"h": 281,
						"w": 308
					},
					{
						"n": 11,
						"h": 146,
						"w": 270
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 706
					},
					{
						"n": 13,
						"h": 413,
						"w": 412
					},
					{
						"n": 3,
						"h": 272,
						"w": 561
					},
					{
						"n": 14,
						"h": 167,
						"w": 557
					},
					{
						"n": 5,
						"h": 62,
						"w": 479
					},
					{
						"n": 6,
						"h": 199,
						"w": 425
					},
					{
						"n": 7,
						"h": 201,
						"w": 324
					},
					{
						"n": 8,
						"h": 51,
						"w": 404
					},
					{
						"n": 17,
						"h": 409,
						"w": 246
					},
					{
						"n": 19,
						"h": 296,
						"w": 246
					},
					{
						"n": 11,
						"h": 35,
						"w": 261
					}
				],
				"ball": {
					"n": 0,
					"h": 388,
					"w": 241,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 1204,
			"minute": 58,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 702
					},
					{
						"n": 2,
						"h": 393,
						"w": 517
					},
					{
						"n": 3,
						"h": 248,
						"w": 547
					},
					{
						"n": 4,
						"h": 173,
						"w": 539
					},
					{
						"n": 5,
						"h": 120,
						"w": 537
					},
					{
						"n": 6,
						"h": 385,
						"w": 341
					},
					{
						"n": 7,
						"h": 248,
						"w": 445
					},
					{
						"n": 8,
						"h": 207,
						"w": 456
					},
					{
						"n": 17,
						"h": 40,
						"w": 418
					},
					{
						"n": 10,
						"h": 279,
						"w": 320
					},
					{
						"n": 11,
						"h": 130,
						"w": 270
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 686
					},
					{
						"n": 13,
						"h": 410,
						"w": 373
					},
					{
						"n": 3,
						"h": 281,
						"w": 523
					},
					{
						"n": 14,
						"h": 171,
						"w": 525
					},
					{
						"n": 5,
						"h": 67,
						"w": 445
					},
					{
						"n": 6,
						"h": 200,
						"w": 386
					},
					{
						"n": 7,
						"h": 203,
						"w": 285
					},
					{
						"n": 8,
						"h": 51,
						"w": 365
					},
					{
						"n": 17,
						"h": 416,
						"w": 208
					},
					{
						"n": 19,
						"h": 283,
						"w": 210
					},
					{
						"n": 11,
						"h": 27,
						"w": 223
					}
				],
				"ball": {
					"n": 0,
					"h": 383,
					"w": 275,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 1205,
			"minute": 58,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 709
					},
					{
						"n": 2,
						"h": 394,
						"w": 539
					},
					{
						"n": 3,
						"h": 250,
						"w": 586
					},
					{
						"n": 4,
						"h": 181,
						"w": 577
					},
					{
						"n": 5,
						"h": 120,
						"w": 576
					},
					{
						"n": 6,
						"h": 380,
						"w": 324
					},
					{
						"n": 7,
						"h": 249,
						"w": 484
					},
					{
						"n": 8,
						"h": 211,
						"w": 495
					},
					{
						"n": 17,
						"h": 38,
						"w": 457
					},
					{
						"n": 10,
						"h": 272,
						"w": 320
					},
					{
						"n": 11,
						"h": 136,
						"w": 270
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 668
					},
					{
						"n": 13,
						"h": 413,
						"w": 334
					},
					{
						"n": 3,
						"h": 282,
						"w": 484
					},
					{
						"n": 14,
						"h": 178,
						"w": 487
					},
					{
						"n": 5,
						"h": 62,
						"w": 411
					},
					{
						"n": 6,
						"h": 219,
						"w": 380
					},
					{
						"n": 7,
						"h": 201,
						"w": 246
					},
					{
						"n": 8,
						"h": 51,
						"w": 326
					},
					{
						"n": 17,
						"h": 423,
						"w": 170
					},
					{
						"n": 19,
						"h": 274,
						"w": 172
					},
					{
						"n": 11,
						"h": 28,
						"w": 187
					}
				],
				"ball": {
					"n": 0,
					"h": 388,
					"w": 309,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 1206,
			"minute": 58,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 705
					},
					{
						"n": 2,
						"h": 394,
						"w": 544
					},
					{
						"n": 3,
						"h": 251,
						"w": 613
					},
					{
						"n": 4,
						"h": 200,
						"w": 607
					},
					{
						"n": 5,
						"h": 120,
						"w": 606
					},
					{
						"n": 6,
						"h": 394,
						"w": 341
					},
					{
						"n": 7,
						"h": 255,
						"w": 523
					},
					{
						"n": 8,
						"h": 201,
						"w": 521
					},
					{
						"n": 17,
						"h": 56,
						"w": 441
					},
					{
						"n": 10,
						"h": 285,
						"w": 320
					},
					{
						"n": 11,
						"h": 128,
						"w": 288
					}
				],
				"away": [
					{
						"n": 1,
						"h": 223,
						"w": 643
					},
					{
						"n": 13,
						"h": 417,
						"w": 294
					},
					{
						"n": 3,
						"h": 277,
						"w": 459
					},
					{
						"n": 14,
						"h": 165,
						"w": 458
					},
					{
						"n": 5,
						"h": 32,
						"w": 394
					},
					{
						"n": 6,
						"h": 194,
						"w": 349
					},
					{
						"n": 7,
						"h": 202,
						"w": 206
					},
					{
						"n": 8,
						"h": 52,
						"w": 286
					},
					{
						"n": 17,
						"h": 435,
						"w": 149
					},
					{
						"n": 19,
						"h": 263,
						"w": 144
					},
					{
						"n": 11,
						"h": 19,
						"w": 196
					}
				],
				"ball": {
					"n": 0,
					"h": 418,
					"w": 326,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1207,
			"minute": 58,
			"messages": [
				{
					"owner": 2,
					"mes": "Томаш Прохазка[25](Опава) переводит игру в центр..."
				},
				{
					"owner": 2,
					"mes": "Теперь с мячом Вацлав Сланина[34](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 705
					},
					{
						"n": 2,
						"h": 361,
						"w": 540
					},
					{
						"n": 3,
						"h": 245,
						"w": 570
					},
					{
						"n": 4,
						"h": 177,
						"w": 565
					},
					{
						"n": 5,
						"h": 120,
						"w": 562
					},
					{
						"n": 6,
						"h": 394,
						"w": 390
					},
					{
						"n": 7,
						"h": 233,
						"w": 493
					},
					{
						"n": 8,
						"h": 161,
						"w": 497
					},
					{
						"n": 17,
						"h": 41,
						"w": 460
					},
					{
						"n": 10,
						"h": 285,
						"w": 282
					},
					{
						"n": 11,
						"h": 133,
						"w": 270
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 624
					},
					{
						"n": 13,
						"h": 415,
						"w": 328
					},
					{
						"n": 3,
						"h": 284,
						"w": 507
					},
					{
						"n": 14,
						"h": 165,
						"w": 458
					},
					{
						"n": 5,
						"h": 35,
						"w": 403
					},
					{
						"n": 6,
						"h": 229,
						"w": 326
					},
					{
						"n": 7,
						"h": 210,
						"w": 239
					},
					{
						"n": 8,
						"h": 45,
						"w": 238
					},
					{
						"n": 17,
						"h": 395,
						"w": 177
					},
					{
						"n": 19,
						"h": 290,
						"w": 185
					},
					{
						"n": 11,
						"h": 59,
						"w": 200
					}
				],
				"ball": {
					"n": 0,
					"h": 285,
					"w": 262,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 49
		},
		{
			"num": 1208,
			"minute": 58,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 710
					},
					{
						"n": 2,
						"h": 394,
						"w": 542
					},
					{
						"n": 3,
						"h": 231,
						"w": 608
					},
					{
						"n": 4,
						"h": 168,
						"w": 604
					},
					{
						"n": 5,
						"h": 120,
						"w": 602
					},
					{
						"n": 6,
						"h": 394,
						"w": 430
					},
					{
						"n": 7,
						"h": 257,
						"w": 525
					},
					{
						"n": 8,
						"h": 180,
						"w": 523
					},
					{
						"n": 17,
						"h": 56,
						"w": 447
					},
					{
						"n": 10,
						"h": 316,
						"w": 299
					},
					{
						"n": 11,
						"h": 129,
						"w": 273
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 599
					},
					{
						"n": 13,
						"h": 413,
						"w": 288
					},
					{
						"n": 3,
						"h": 280,
						"w": 474
					},
					{
						"n": 14,
						"h": 134,
						"w": 441
					},
					{
						"n": 5,
						"h": 52,
						"w": 439
					},
					{
						"n": 6,
						"h": 224,
						"w": 366
					},
					{
						"n": 7,
						"h": 228,
						"w": 204
					},
					{
						"n": 8,
						"h": 55,
						"w": 218
					},
					{
						"n": 17,
						"h": 431,
						"w": 160
					},
					{
						"n": 19,
						"h": 312,
						"w": 152
					},
					{
						"n": 11,
						"h": 24,
						"w": 183
					}
				],
				"ball": {
					"n": 0,
					"h": 316,
					"w": 279,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1209,
			"minute": 59,
			"possession": 44,
			"messages": [
				{
					"owner": 2,
					"mes": "Пас налево на О.Дюмона[26](Опава)..."
				},
				{
					"owner": 2,
					"mes": "Оливье Дюмон[26](Опава) достает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 708
					},
					{
						"n": 2,
						"h": 380,
						"w": 568
					},
					{
						"n": 3,
						"h": 228,
						"w": 602,
						"f": 87
					},
					{
						"n": 4,
						"h": 188,
						"w": 614
					},
					{
						"n": 5,
						"h": 90,
						"w": 599
					},
					{
						"n": 6,
						"h": 394,
						"w": 460
					},
					{
						"n": 7,
						"h": 263,
						"w": 523
					},
					{
						"n": 8,
						"h": 190,
						"w": 495
					},
					{
						"n": 17,
						"h": 56,
						"w": 477
					},
					{
						"n": 10,
						"h": 306,
						"w": 320
					},
					{
						"n": 11,
						"h": 158,
						"w": 279
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 600
					},
					{
						"n": 13,
						"h": 394,
						"w": 272
					},
					{
						"n": 3,
						"h": 278,
						"w": 454
					},
					{
						"n": 14,
						"h": 144,
						"w": 440
					},
					{
						"n": 5,
						"h": 62,
						"w": 442
					},
					{
						"n": 6,
						"h": 206,
						"w": 386
					},
					{
						"n": 7,
						"h": 226,
						"w": 234,
						"f": 85
					},
					{
						"n": 8,
						"h": 57,
						"w": 188
					},
					{
						"n": 17,
						"h": 406,
						"w": 143
					},
					{
						"n": 19,
						"h": 282,
						"w": 148
					},
					{
						"n": 11,
						"h": 46,
						"w": 162,
						"f": 82
					}
				],
				"ball": {
					"n": 0,
					"h": 244,
					"w": 334,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 30
		},
		{
			"num": 1210,
			"minute": 59,
			"messages": [
				{
					"owner": 2,
					"mes": "Оливье Дюмон[26](Опава) отправляет мяч вперед в расчете на М.Манолова[27](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 709
					},
					{
						"n": 2,
						"h": 392,
						"w": 605
					},
					{
						"n": 3,
						"h": 224,
						"w": 612
					},
					{
						"n": 4,
						"h": 182,
						"w": 618
					},
					{
						"n": 5,
						"h": 92,
						"w": 612
					},
					{
						"n": 6,
						"h": 394,
						"w": 499
					},
					{
						"n": 7,
						"h": 258,
						"w": 544
					},
					{
						"n": 8,
						"h": 211,
						"w": 467
					},
					{
						"n": 17,
						"h": 56,
						"w": 471
					},
					{
						"n": 10,
						"h": 276,
						"w": 320
					},
					{
						"n": 11,
						"h": 144,
						"w": 292
					}
				],
				"away": [
					{
						"n": 1,
						"h": 229,
						"w": 593
					},
					{
						"n": 13,
						"h": 414,
						"w": 264
					},
					{
						"n": 3,
						"h": 280,
						"w": 452
					},
					{
						"n": 14,
						"h": 174,
						"w": 440
					},
					{
						"n": 5,
						"h": 71,
						"w": 433
					},
					{
						"n": 6,
						"h": 211,
						"w": 377
					},
					{
						"n": 7,
						"h": 238,
						"w": 272
					},
					{
						"n": 8,
						"h": 43,
						"w": 157
					},
					{
						"n": 17,
						"h": 374,
						"w": 120
					},
					{
						"n": 19,
						"h": 274,
						"w": 120
					},
					{
						"n": 11,
						"h": 34,
						"w": 125
					}
				],
				"ball": {
					"n": 0,
					"h": 212,
					"w": 448,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 1211,
			"minute": 59,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 703
					},
					{
						"n": 2,
						"h": 394,
						"w": 611
					},
					{
						"n": 3,
						"h": 222,
						"w": 631
					},
					{
						"n": 4,
						"h": 178,
						"w": 637
					},
					{
						"n": 5,
						"h": 73,
						"w": 612
					},
					{
						"n": 6,
						"h": 394,
						"w": 518
					},
					{
						"n": 7,
						"h": 266,
						"w": 561
					},
					{
						"n": 8,
						"h": 196,
						"w": 466
					},
					{
						"n": 17,
						"h": 56,
						"w": 490
					},
					{
						"n": 10,
						"h": 281,
						"w": 330
					},
					{
						"n": 11,
						"h": 143,
						"w": 311
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 595
					},
					{
						"n": 13,
						"h": 402,
						"w": 262
					},
					{
						"n": 3,
						"h": 278,
						"w": 433
					},
					{
						"n": 14,
						"h": 169,
						"w": 422
					},
					{
						"n": 5,
						"h": 68,
						"w": 414
					},
					{
						"n": 6,
						"h": 218,
						"w": 359
					},
					{
						"n": 7,
						"h": 254,
						"w": 272
					},
					{
						"n": 8,
						"h": 33,
						"w": 149
					},
					{
						"n": 17,
						"h": 387,
						"w": 120
					},
					{
						"n": 19,
						"h": 264,
						"w": 120
					},
					{
						"n": 11,
						"h": 38,
						"w": 120
					}
				],
				"ball": {
					"n": 0,
					"h": 196,
					"w": 448,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 19
		},
		{
			"num": 1212,
			"minute": 59,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 702
					},
					{
						"n": 2,
						"h": 392,
						"w": 626
					},
					{
						"n": 3,
						"h": 221,
						"w": 651
					},
					{
						"n": 4,
						"h": 183,
						"w": 633
					},
					{
						"n": 5,
						"h": 90,
						"w": 609
					},
					{
						"n": 6,
						"h": 394,
						"w": 538
					},
					{
						"n": 7,
						"h": 268,
						"w": 574
					},
					{
						"n": 8,
						"h": 206,
						"w": 468
					},
					{
						"n": 17,
						"h": 56,
						"w": 478
					},
					{
						"n": 10,
						"h": 266,
						"w": 330
					},
					{
						"n": 11,
						"h": 135,
						"w": 320
					}
				],
				"away": [
					{
						"n": 1,
						"h": 228,
						"w": 595
					},
					{
						"n": 13,
						"h": 408,
						"w": 277
					},
					{
						"n": 3,
						"h": 283,
						"w": 426
					},
					{
						"n": 14,
						"h": 184,
						"w": 428
					},
					{
						"n": 5,
						"h": 59,
						"w": 418
					},
					{
						"n": 6,
						"h": 215,
						"w": 340
					},
					{
						"n": 7,
						"h": 237,
						"w": 269
					},
					{
						"n": 8,
						"h": 51,
						"w": 152
					},
					{
						"n": 17,
						"h": 368,
						"w": 122
					},
					{
						"n": 19,
						"h": 272,
						"w": 102
					},
					{
						"n": 11,
						"h": 50,
						"w": 104
					}
				],
				"ball": {
					"n": 0,
					"h": 213,
					"w": 451,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 20
		},
		{
			"num": 1213,
			"minute": 59,
			"messages": [
				{
					"owner": 2,
					"mes": "Пас вперед..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 705
					},
					{
						"n": 2,
						"h": 377,
						"w": 626
					},
					{
						"n": 3,
						"h": 215,
						"w": 632
					},
					{
						"n": 4,
						"h": 209,
						"w": 595
					},
					{
						"n": 5,
						"h": 80,
						"w": 604
					},
					{
						"n": 6,
						"h": 391,
						"w": 585
					},
					{
						"n": 7,
						"h": 261,
						"w": 564
					},
					{
						"n": 8,
						"h": 197,
						"w": 514
					},
					{
						"n": 17,
						"h": 56,
						"w": 478
					},
					{
						"n": 10,
						"h": 284,
						"w": 327
					},
					{
						"n": 11,
						"h": 127,
						"w": 317
					}
				],
				"away": [
					{
						"n": 1,
						"h": 229,
						"w": 602
					},
					{
						"n": 13,
						"h": 410,
						"w": 277
					},
					{
						"n": 3,
						"h": 281,
						"w": 430
					},
					{
						"n": 14,
						"h": 166,
						"w": 409
					},
					{
						"n": 5,
						"h": 76,
						"w": 421
					},
					{
						"n": 6,
						"h": 186,
						"w": 337
					},
					{
						"n": 7,
						"h": 236,
						"w": 259
					},
					{
						"n": 8,
						"h": 60,
						"w": 159
					},
					{
						"n": 17,
						"h": 379,
						"w": 136
					},
					{
						"n": 19,
						"h": 243,
						"w": 127
					},
					{
						"n": 11,
						"h": 43,
						"w": 114
					}
				],
				"ball": {
					"n": 0,
					"h": 207,
					"w": 593,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 47
		},
		{
			"num": 1214,
			"minute": 59,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 705
					},
					{
						"n": 2,
						"h": 389,
						"w": 610
					},
					{
						"n": 3,
						"h": 230,
						"w": 624
					},
					{
						"n": 4,
						"h": 217,
						"w": 602
					},
					{
						"n": 5,
						"h": 91,
						"w": 588
					},
					{
						"n": 6,
						"h": 394,
						"w": 596
					},
					{
						"n": 7,
						"h": 257,
						"w": 552
					},
					{
						"n": 8,
						"h": 207,
						"w": 531
					},
					{
						"n": 17,
						"h": 56,
						"w": 491
					},
					{
						"n": 10,
						"h": 286,
						"w": 320
					},
					{
						"n": 11,
						"h": 146,
						"w": 310
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 593
					},
					{
						"n": 13,
						"h": 412,
						"w": 264
					},
					{
						"n": 3,
						"h": 269,
						"w": 437
					},
					{
						"n": 14,
						"h": 164,
						"w": 429
					},
					{
						"n": 5,
						"h": 62,
						"w": 435
					},
					{
						"n": 6,
						"h": 206,
						"w": 339
					},
					{
						"n": 7,
						"h": 234,
						"w": 239
					},
					{
						"n": 8,
						"h": 50,
						"w": 159
					},
					{
						"n": 17,
						"h": 361,
						"w": 146
					},
					{
						"n": 19,
						"h": 233,
						"w": 128
					},
					{
						"n": 11,
						"h": 35,
						"w": 124
					}
				],
				"ball": {
					"n": 0,
					"h": 217,
					"w": 592,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 20
		},
		{
			"num": 1215,
			"minute": 59,
			"messages": [
				{
					"owner": 2,
					"mes": "Александр Фрешль[39](Опава) закрывает мяч от соперника..."
				},
				{
					"owner": 2,
					"mes": "Александр Фрешль[39](Опава) резко разворачивается... Р.Дриссенс[04](Галвэй Юнайтед) остается не у дел..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 705
					},
					{
						"n": 2,
						"h": 394,
						"w": 604
					},
					{
						"n": 3,
						"h": 230,
						"w": 624
					},
					{
						"n": 4,
						"h": 217,
						"w": 602,
						"m": 660
					},
					{
						"n": 5,
						"h": 97,
						"w": 580
					},
					{
						"n": 6,
						"h": 394,
						"w": 596
					},
					{
						"n": 7,
						"h": 257,
						"w": 552
					},
					{
						"n": 8,
						"h": 207,
						"w": 531
					},
					{
						"n": 17,
						"h": 56,
						"w": 491
					},
					{
						"n": 10,
						"h": 286,
						"w": 320
					},
					{
						"n": 11,
						"h": 160,
						"w": 305
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 593
					},
					{
						"n": 13,
						"h": 412,
						"w": 264
					},
					{
						"n": 3,
						"h": 269,
						"w": 437
					},
					{
						"n": 14,
						"h": 163,
						"w": 443
					},
					{
						"n": 5,
						"h": 60,
						"w": 437
					},
					{
						"n": 6,
						"h": 220,
						"w": 341
					},
					{
						"n": 7,
						"h": 232,
						"w": 224
					},
					{
						"n": 8,
						"h": 50,
						"w": 159
					},
					{
						"n": 17,
						"h": 348,
						"w": 153
					},
					{
						"n": 19,
						"h": 223,
						"w": 118,
						"m": 630
					},
					{
						"n": 11,
						"h": 35,
						"w": 124
					}
				],
				"ball": {
					"n": 0,
					"h": 227,
					"w": 602,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 15
		},
		{
			"num": 1216,
			"minute": 59,
			"messages": [
				{
					"owner": 2,
					"mes": "Александр Фрешль[39](Опава) бьет из-за штрафной..."
				},
				{
					"owner": 2,
					"mes": "Для М.Глэдхилла[01](Галвэй Юнайтед) не составляет особого труда поймать этот мяч."
				}
			],
			"U": {
				"team": 2,
				"player": 19,
				"xg": "0.09"
			},
			"V": {
				"team": 2,
				"player": 19
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 705,
						"m": 650
					},
					{
						"n": 2,
						"h": 379,
						"w": 619
					},
					{
						"n": 3,
						"h": 220,
						"w": 633
					},
					{
						"n": 4,
						"h": 226,
						"w": 621
					},
					{
						"n": 5,
						"h": 97,
						"w": 601
					},
					{
						"n": 6,
						"h": 392,
						"w": 598
					},
					{
						"n": 7,
						"h": 268,
						"w": 548
					},
					{
						"n": 8,
						"h": 218,
						"w": 549
					},
					{
						"n": 17,
						"h": 56,
						"w": 512
					},
					{
						"n": 10,
						"h": 275,
						"w": 320
					},
					{
						"n": 11,
						"h": 140,
						"w": 307
					}
				],
				"away": [
					{
						"n": 1,
						"h": 228,
						"w": 596
					},
					{
						"n": 13,
						"h": 410,
						"w": 243
					},
					{
						"n": 3,
						"h": 274,
						"w": 440
					},
					{
						"n": 14,
						"h": 175,
						"w": 436
					},
					{
						"n": 5,
						"h": 57,
						"w": 416
					},
					{
						"n": 6,
						"h": 224,
						"w": 344
					},
					{
						"n": 7,
						"h": 233,
						"w": 203
					},
					{
						"n": 8,
						"h": 58,
						"w": 157
					},
					{
						"n": 17,
						"h": 327,
						"w": 151
					},
					{
						"n": 19,
						"h": 223,
						"w": 118,
						"m": 640
					},
					{
						"n": 11,
						"h": 38,
						"w": 128
					}
				],
				"ball": {
					"n": 0,
					"h": 224,
					"w": 705,
					"z": 1,
					"r": 0,
					"p": 0,
					"x": 5
				}
			},
			"interval": 21
		},
		{
			"num": 1217,
			"minute": 59,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 705
					},
					{
						"n": 2,
						"h": 364,
						"w": 628
					},
					{
						"n": 3,
						"h": 220,
						"w": 630
					},
					{
						"n": 4,
						"h": 226,
						"w": 640
					},
					{
						"n": 5,
						"h": 95,
						"w": 621
					},
					{
						"n": 6,
						"h": 392,
						"w": 601
					},
					{
						"n": 7,
						"h": 265,
						"w": 568
					},
					{
						"n": 8,
						"h": 221,
						"w": 555
					},
					{
						"n": 17,
						"h": 56,
						"w": 532
					},
					{
						"n": 10,
						"h": 274,
						"w": 330
					},
					{
						"n": 11,
						"h": 132,
						"w": 320
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 598
					},
					{
						"n": 13,
						"h": 411,
						"w": 223
					},
					{
						"n": 3,
						"h": 276,
						"w": 420
					},
					{
						"n": 14,
						"h": 176,
						"w": 429
					},
					{
						"n": 5,
						"h": 72,
						"w": 414
					},
					{
						"n": 6,
						"h": 230,
						"w": 325
					},
					{
						"n": 7,
						"h": 229,
						"w": 184
					},
					{
						"n": 8,
						"h": 58,
						"w": 154
					},
					{
						"n": 17,
						"h": 308,
						"w": 148
					},
					{
						"n": 19,
						"h": 224,
						"w": 100
					},
					{
						"n": 11,
						"h": 53,
						"w": 115
					}
				],
				"ball": {
					"n": 0,
					"h": 224,
					"w": 705,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 20
		},
		{
			"num": 1218,
			"minute": 59,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 697,
						"m": 660
					},
					{
						"n": 2,
						"h": 390,
						"w": 515
					},
					{
						"n": 3,
						"h": 288,
						"w": 515
					},
					{
						"n": 4,
						"h": 166,
						"w": 515
					},
					{
						"n": 5,
						"h": 58,
						"w": 515
					},
					{
						"n": 6,
						"h": 393,
						"w": 388
					},
					{
						"n": 7,
						"h": 275,
						"w": 368
					},
					{
						"n": 8,
						"h": 174,
						"w": 368
					},
					{
						"n": 17,
						"h": 70,
						"w": 388
					},
					{
						"n": 10,
						"h": 276,
						"w": 220
					},
					{
						"n": 11,
						"h": 156,
						"w": 220
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 680
					},
					{
						"n": 13,
						"h": 384,
						"w": 491
					},
					{
						"n": 3,
						"h": 275,
						"w": 590
					},
					{
						"n": 14,
						"h": 172,
						"w": 590
					},
					{
						"n": 5,
						"h": 77,
						"w": 568
					},
					{
						"n": 6,
						"h": 216,
						"w": 520
					},
					{
						"n": 7,
						"h": 215,
						"w": 372
					},
					{
						"n": 8,
						"h": 65,
						"w": 348
					},
					{
						"n": 17,
						"h": 388,
						"w": 300
					},
					{
						"n": 19,
						"h": 281,
						"w": 272
					},
					{
						"n": 11,
						"h": 167,
						"w": 272
					}
				],
				"ball": {
					"n": 0,
					"h": 226,
					"w": 697,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 100
		},
		{
			"num": 1219,
			"minute": 59,
			"messages": [
				{
					"owner": 1,
					"mes": "Мэттью Глэдхилл[01](Галвэй Юнайтед) выбивает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 709
					},
					{
						"n": 2,
						"h": 383,
						"w": 460
					},
					{
						"n": 3,
						"h": 285,
						"w": 523
					},
					{
						"n": 4,
						"h": 181,
						"w": 509
					},
					{
						"n": 5,
						"h": 72,
						"w": 467
					},
					{
						"n": 6,
						"h": 404,
						"w": 288
					},
					{
						"n": 7,
						"h": 252,
						"w": 297
					},
					{
						"n": 8,
						"h": 174,
						"w": 368
					},
					{
						"n": 17,
						"h": 49,
						"w": 294
					},
					{
						"n": 10,
						"h": 282,
						"w": 220
					},
					{
						"n": 11,
						"h": 161,
						"w": 218
					}
				],
				"away": [
					{
						"n": 1,
						"h": 226,
						"w": 650
					},
					{
						"n": 13,
						"h": 401,
						"w": 462
					},
					{
						"n": 3,
						"h": 272,
						"w": 620
					},
					{
						"n": 14,
						"h": 184,
						"w": 633
					},
					{
						"n": 5,
						"h": 110,
						"w": 611
					},
					{
						"n": 6,
						"h": 164,
						"w": 562
					},
					{
						"n": 7,
						"h": 198,
						"w": 423
					},
					{
						"n": 8,
						"h": 49,
						"w": 446
					},
					{
						"n": 17,
						"h": 394,
						"w": 400
					},
					{
						"n": 19,
						"h": 276,
						"w": 372
					},
					{
						"n": 11,
						"h": 158,
						"w": 372
					}
				],
				"ball": {
					"n": 0,
					"h": 252,
					"w": 297,
					"z": 1,
					"r": 0,
					"p": 4,
					"x": 0
				}
			},
			"interval": 100
		},
		{
			"num": 1220,
			"minute": 59,
			"messages": [
				{
					"owner": 1,
					"mes": "Агуст Хлинссон[07](Галвэй Юнайтед) в борьбе с М.Маноловом[27](Опава) скидывает мяч головой..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 708
					},
					{
						"n": 2,
						"h": 383,
						"w": 468
					},
					{
						"n": 3,
						"h": 281,
						"w": 519
					},
					{
						"n": 4,
						"h": 184,
						"w": 514
					},
					{
						"n": 5,
						"h": 66,
						"w": 458
					},
					{
						"n": 6,
						"h": 399,
						"w": 244
					},
					{
						"n": 7,
						"h": 259,
						"w": 280,
						"m": 760
					},
					{
						"n": 8,
						"h": 174,
						"w": 389
					},
					{
						"n": 17,
						"h": 93,
						"w": 294
					},
					{
						"n": 10,
						"h": 238,
						"w": 222
					},
					{
						"n": 11,
						"h": 162,
						"w": 199
					}
				],
				"away": [
					{
						"n": 1,
						"h": 229,
						"w": 694
					},
					{
						"n": 13,
						"h": 401,
						"w": 506
					},
					{
						"n": 3,
						"h": 279,
						"w": 577
					},
					{
						"n": 14,
						"h": 217,
						"w": 630
					},
					{
						"n": 5,
						"h": 110,
						"w": 618
					},
					{
						"n": 6,
						"h": 206,
						"w": 547
					},
					{
						"n": 7,
						"h": 198,
						"w": 423
					},
					{
						"n": 8,
						"h": 50,
						"w": 490
					},
					{
						"n": 17,
						"h": 396,
						"w": 424
					},
					{
						"n": 19,
						"h": 309,
						"w": 402
					},
					{
						"n": 11,
						"h": 173,
						"w": 413
					}
				],
				"ball": {
					"n": 0,
					"h": 162,
					"w": 199,
					"z": 1,
					"r": 0,
					"p": 4,
					"x": 0
				}
			},
			"interval": 44
		},
		{
			"num": 1221,
			"minute": 59,
			"messages": [
				{
					"owner": 1,
					"mes": "Адам Гилберт[11](Галвэй Юнайтед) достает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 704
					},
					{
						"n": 2,
						"h": 385,
						"w": 428
					},
					{
						"n": 3,
						"h": 275,
						"w": 479
					},
					{
						"n": 4,
						"h": 181,
						"w": 474
					},
					{
						"n": 5,
						"h": 65,
						"w": 418
					},
					{
						"n": 6,
						"h": 401,
						"w": 204
					},
					{
						"n": 7,
						"h": 266,
						"w": 240
					},
					{
						"n": 8,
						"h": 178,
						"w": 394
					},
					{
						"n": 17,
						"h": 84,
						"w": 255
					},
					{
						"n": 10,
						"h": 254,
						"w": 185
					},
					{
						"n": 11,
						"h": 177,
						"w": 162
					}
				],
				"away": [
					{
						"n": 1,
						"h": 229,
						"w": 706
					},
					{
						"n": 13,
						"h": 366,
						"w": 501
					},
					{
						"n": 3,
						"h": 269,
						"w": 578
					},
					{
						"n": 14,
						"h": 209,
						"w": 630
					},
					{
						"n": 5,
						"h": 110,
						"w": 620
					},
					{
						"n": 6,
						"h": 199,
						"w": 561
					},
					{
						"n": 7,
						"h": 190,
						"w": 462
					},
					{
						"n": 8,
						"h": 50,
						"w": 530
					},
					{
						"n": 17,
						"h": 407,
						"w": 440
					},
					{
						"n": 19,
						"h": 291,
						"w": 406
					},
					{
						"n": 11,
						"h": 155,
						"w": 403
					}
				],
				"ball": {
					"n": 0,
					"h": 177,
					"w": 162,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1222,
			"minute": 59,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 708
					},
					{
						"n": 2,
						"h": 385,
						"w": 423
					},
					{
						"n": 3,
						"h": 275,
						"w": 475
					},
					{
						"n": 4,
						"h": 181,
						"w": 469
					},
					{
						"n": 5,
						"h": 64,
						"w": 413
					},
					{
						"n": 6,
						"h": 400,
						"w": 200
					},
					{
						"n": 7,
						"h": 268,
						"w": 236
					},
					{
						"n": 8,
						"h": 177,
						"w": 389
					},
					{
						"n": 17,
						"h": 82,
						"w": 251
					},
					{
						"n": 10,
						"h": 256,
						"w": 181
					},
					{
						"n": 11,
						"h": 177,
						"w": 158
					}
				],
				"away": [
					{
						"n": 1,
						"h": 229,
						"w": 706
					},
					{
						"n": 13,
						"h": 366,
						"w": 501
					},
					{
						"n": 3,
						"h": 270,
						"w": 573
					},
					{
						"n": 14,
						"h": 209,
						"w": 625
					},
					{
						"n": 5,
						"h": 110,
						"w": 615
					},
					{
						"n": 6,
						"h": 204,
						"w": 562
					},
					{
						"n": 7,
						"h": 189,
						"w": 467
					},
					{
						"n": 8,
						"h": 50,
						"w": 535
					},
					{
						"n": 17,
						"h": 407,
						"w": 440
					},
					{
						"n": 19,
						"h": 288,
						"w": 403
					},
					{
						"n": 11,
						"h": 157,
						"w": 407
					}
				],
				"ball": {
					"n": 0,
					"h": 177,
					"w": 158,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 5
		},
		{
			"num": 1223,
			"minute": 59,
			"messages": [
				{
					"owner": 1,
					"mes": "Адам Гилберт[11](Галвэй Юнайтед) один в один пытается обыграть Н.Мансура[23](Опава)..."
				},
				{
					"owner": 1,
					"mes": "Адам Гилберт[11](Галвэй Юнайтед) пробрасывает мяч мимо Н.Мансура[23](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 706
					},
					{
						"n": 2,
						"h": 379,
						"w": 383
					},
					{
						"n": 3,
						"h": 273,
						"w": 435
					},
					{
						"n": 4,
						"h": 172,
						"w": 430
					},
					{
						"n": 5,
						"h": 71,
						"w": 374
					},
					{
						"n": 6,
						"h": 400,
						"w": 160
					},
					{
						"n": 7,
						"h": 269,
						"w": 196
					},
					{
						"n": 8,
						"h": 172,
						"w": 349
					},
					{
						"n": 17,
						"h": 74,
						"w": 212
					},
					{
						"n": 10,
						"h": 256,
						"w": 141
					},
					{
						"n": 11,
						"h": 185,
						"w": 118,
						"m": 830
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 706
					},
					{
						"n": 13,
						"h": 375,
						"w": 540
					},
					{
						"n": 3,
						"h": 270,
						"w": 573,
						"m": 640
					},
					{
						"n": 14,
						"h": 253,
						"w": 622
					},
					{
						"n": 5,
						"h": 150,
						"w": 615
					},
					{
						"n": 6,
						"h": 232,
						"w": 601
					},
					{
						"n": 7,
						"h": 202,
						"w": 505
					},
					{
						"n": 8,
						"h": 50,
						"w": 575
					},
					{
						"n": 17,
						"h": 407,
						"w": 460
					},
					{
						"n": 19,
						"h": 278,
						"w": 391
					},
					{
						"n": 11,
						"h": 161,
						"w": 411
					}
				],
				"ball": {
					"n": 0,
					"h": 185,
					"w": 118,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1224,
			"minute": 59,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 710
					},
					{
						"n": 2,
						"h": 385,
						"w": 371
					},
					{
						"n": 3,
						"h": 270,
						"w": 421
					},
					{
						"n": 4,
						"h": 170,
						"w": 416
					},
					{
						"n": 5,
						"h": 65,
						"w": 361
					},
					{
						"n": 6,
						"h": 398,
						"w": 146
					},
					{
						"n": 7,
						"h": 276,
						"w": 184
					},
					{
						"n": 8,
						"h": 170,
						"w": 336
					},
					{
						"n": 17,
						"h": 70,
						"w": 198
					},
					{
						"n": 10,
						"h": 264,
						"w": 129
					},
					{
						"n": 11,
						"h": 185,
						"w": 106
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 706
					},
					{
						"n": 13,
						"h": 379,
						"w": 553
					},
					{
						"n": 3,
						"h": 260,
						"w": 583
					},
					{
						"n": 14,
						"h": 265,
						"w": 614
					},
					{
						"n": 5,
						"h": 137,
						"w": 611
					},
					{
						"n": 6,
						"h": 243,
						"w": 614
					},
					{
						"n": 7,
						"h": 201,
						"w": 519
					},
					{
						"n": 8,
						"h": 46,
						"w": 562
					},
					{
						"n": 17,
						"h": 407,
						"w": 460
					},
					{
						"n": 19,
						"h": 280,
						"w": 404
					},
					{
						"n": 11,
						"h": 158,
						"w": 422
					}
				],
				"ball": {
					"n": 0,
					"h": 185,
					"w": 106,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 14
		},
		{
			"num": 1225,
			"minute": 59,
			"messages": [
				{
					"owner": 1,
					"mes": "А.Гилберт[11](Галвэй Юнайтед) пытается переиграть В.Сланину[34](Опава)..."
				},
				{
					"owner": 1,
					"mes": "Вацлав Сланина[34](Опава) надежно играет в отборе..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 710
					},
					{
						"n": 2,
						"h": 389,
						"w": 362
					},
					{
						"n": 3,
						"h": 268,
						"w": 411
					},
					{
						"n": 4,
						"h": 168,
						"w": 406
					},
					{
						"n": 5,
						"h": 61,
						"w": 351
					},
					{
						"n": 6,
						"h": 396,
						"w": 136
					},
					{
						"n": 7,
						"h": 281,
						"w": 175
					},
					{
						"n": 8,
						"h": 169,
						"w": 326
					},
					{
						"n": 17,
						"h": 67,
						"w": 189
					},
					{
						"n": 10,
						"h": 269,
						"w": 121
					},
					{
						"n": 11,
						"h": 185,
						"w": 96
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 706
					},
					{
						"n": 13,
						"h": 380,
						"w": 558
					},
					{
						"n": 3,
						"h": 252,
						"w": 591
					},
					{
						"n": 14,
						"h": 273,
						"w": 608,
						"m": 640
					},
					{
						"n": 5,
						"h": 127,
						"w": 608
					},
					{
						"n": 6,
						"h": 251,
						"w": 623
					},
					{
						"n": 7,
						"h": 200,
						"w": 528
					},
					{
						"n": 8,
						"h": 43,
						"w": 552
					},
					{
						"n": 17,
						"h": 409,
						"w": 464
					},
					{
						"n": 19,
						"h": 280,
						"w": 404
					},
					{
						"n": 11,
						"h": 158,
						"w": 422
					}
				],
				"ball": {
					"n": 0,
					"h": 177,
					"w": 112,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 4
				}
			},
			"interval": 10
		},
		{
			"num": 1226,
			"minute": 59,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 710
					},
					{
						"n": 2,
						"h": 358,
						"w": 386
					},
					{
						"n": 3,
						"h": 234,
						"w": 407
					},
					{
						"n": 4,
						"h": 168,
						"w": 412
					},
					{
						"n": 5,
						"h": 78,
						"w": 388
					},
					{
						"n": 6,
						"h": 399,
						"w": 176
					},
					{
						"n": 7,
						"h": 278,
						"w": 215
					},
					{
						"n": 8,
						"h": 160,
						"w": 351
					},
					{
						"n": 17,
						"h": 57,
						"w": 227
					},
					{
						"n": 10,
						"h": 275,
						"w": 160
					},
					{
						"n": 11,
						"h": 181,
						"w": 105
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 705
					},
					{
						"n": 13,
						"h": 391,
						"w": 519
					},
					{
						"n": 3,
						"h": 278,
						"w": 617
					},
					{
						"n": 14,
						"h": 297,
						"w": 583
					},
					{
						"n": 5,
						"h": 88,
						"w": 597
					},
					{
						"n": 6,
						"h": 228,
						"w": 591
					},
					{
						"n": 7,
						"h": 214,
						"w": 491
					},
					{
						"n": 8,
						"h": 43,
						"w": 512
					},
					{
						"n": 17,
						"h": 370,
						"w": 453
					},
					{
						"n": 19,
						"h": 296,
						"w": 368
					},
					{
						"n": 11,
						"h": 196,
						"w": 410
					}
				],
				"ball": {
					"n": 0,
					"h": 153,
					"w": 137,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1227,
			"minute": 59,
			"messages": [
				{
					"owner": 2,
					"mes": "В.Сланина[34](Опава) пасует О.Дюмону[26](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 708
					},
					{
						"n": 2,
						"h": 344,
						"w": 415
					},
					{
						"n": 3,
						"h": 228,
						"w": 435
					},
					{
						"n": 4,
						"h": 176,
						"w": 441
					},
					{
						"n": 5,
						"h": 99,
						"w": 412
					},
					{
						"n": 6,
						"h": 400,
						"w": 208
					},
					{
						"n": 7,
						"h": 276,
						"w": 247
					},
					{
						"n": 8,
						"h": 188,
						"w": 367
					},
					{
						"n": 17,
						"h": 55,
						"w": 259
					},
					{
						"n": 10,
						"h": 243,
						"w": 160
					},
					{
						"n": 11,
						"h": 175,
						"w": 137
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 703
					},
					{
						"n": 13,
						"h": 403,
						"w": 489
					},
					{
						"n": 3,
						"h": 267,
						"w": 619
					},
					{
						"n": 14,
						"h": 293,
						"w": 584,
						"m": 650
					},
					{
						"n": 5,
						"h": 65,
						"w": 605
					},
					{
						"n": 6,
						"h": 234,
						"w": 581
					},
					{
						"n": 7,
						"h": 227,
						"w": 462
					},
					{
						"n": 8,
						"h": 46,
						"w": 480
					},
					{
						"n": 17,
						"h": 339,
						"w": 446
					},
					{
						"n": 19,
						"h": 292,
						"w": 336
					},
					{
						"n": 11,
						"h": 227,
						"w": 400
					}
				],
				"ball": {
					"n": 0,
					"h": 216,
					"w": 139,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 32
		},
		{
			"num": 1228,
			"minute": 59,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 701
					},
					{
						"n": 2,
						"h": 330,
						"w": 449
					},
					{
						"n": 3,
						"h": 215,
						"w": 457
					},
					{
						"n": 4,
						"h": 169,
						"w": 462
					},
					{
						"n": 5,
						"h": 116,
						"w": 449
					},
					{
						"n": 6,
						"h": 400,
						"w": 248
					},
					{
						"n": 7,
						"h": 271,
						"w": 287
					},
					{
						"n": 8,
						"h": 189,
						"w": 370
					},
					{
						"n": 17,
						"h": 48,
						"w": 299
					},
					{
						"n": 10,
						"h": 211,
						"w": 169
					},
					{
						"n": 11,
						"h": 164,
						"w": 175
					}
				],
				"away": [
					{
						"n": 1,
						"h": 226,
						"w": 702
					},
					{
						"n": 13,
						"h": 402,
						"w": 473
					},
					{
						"n": 3,
						"h": 291,
						"w": 587
					},
					{
						"n": 14,
						"h": 253,
						"w": 587
					},
					{
						"n": 5,
						"h": 64,
						"w": 596
					},
					{
						"n": 6,
						"h": 239,
						"w": 546
					},
					{
						"n": 7,
						"h": 197,
						"w": 488
					},
					{
						"n": 8,
						"h": 47,
						"w": 440
					},
					{
						"n": 17,
						"h": 300,
						"w": 436
					},
					{
						"n": 19,
						"h": 295,
						"w": 296
					},
					{
						"n": 11,
						"h": 260,
						"w": 379
					}
				],
				"ball": {
					"n": 0,
					"h": 211,
					"w": 174,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1229,
			"minute": 59,
			"messages": [
				{
					"owner": 2,
					"mes": "Пас вперед..."
				},
				{
					"owner": 2,
					"mes": "Агуст Хлинссон[07](Галвэй Юнайтед) в подкате перехватывает мяч!..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 704
					},
					{
						"n": 2,
						"h": 330,
						"w": 458
					},
					{
						"n": 3,
						"h": 235,
						"w": 470
					},
					{
						"n": 4,
						"h": 156,
						"w": 452
					},
					{
						"n": 5,
						"h": 120,
						"w": 467
					},
					{
						"n": 6,
						"h": 398,
						"w": 288
					},
					{
						"n": 7,
						"h": 231,
						"w": 294
					},
					{
						"n": 8,
						"h": 160,
						"w": 398
					},
					{
						"n": 17,
						"h": 51,
						"w": 339
					},
					{
						"n": 10,
						"h": 221,
						"w": 208
					},
					{
						"n": 11,
						"h": 150,
						"w": 213
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 704
					},
					{
						"n": 13,
						"h": 392,
						"w": 454
					},
					{
						"n": 3,
						"h": 273,
						"w": 611
					},
					{
						"n": 14,
						"h": 214,
						"w": 596
					},
					{
						"n": 5,
						"h": 69,
						"w": 579
					},
					{
						"n": 6,
						"h": 237,
						"w": 536,
						"m": 660
					},
					{
						"n": 7,
						"h": 230,
						"w": 465
					},
					{
						"n": 8,
						"h": 46,
						"w": 400
					},
					{
						"n": 17,
						"h": 316,
						"w": 400
					},
					{
						"n": 19,
						"h": 289,
						"w": 298
					},
					{
						"n": 11,
						"h": 237,
						"w": 405,
						"m": 650
					}
				],
				"ball": {
					"n": 0,
					"h": 231,
					"w": 294,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1230,
			"minute": 59,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 704
					},
					{
						"n": 2,
						"h": 349,
						"w": 423
					},
					{
						"n": 3,
						"h": 255,
						"w": 435
					},
					{
						"n": 4,
						"h": 175,
						"w": 422
					},
					{
						"n": 5,
						"h": 105,
						"w": 430
					},
					{
						"n": 6,
						"h": 391,
						"w": 248
					},
					{
						"n": 7,
						"h": 266,
						"w": 294,
						"m": 770
					},
					{
						"n": 8,
						"h": 157,
						"w": 358
					},
					{
						"n": 17,
						"h": 55,
						"w": 299
					},
					{
						"n": 10,
						"h": 246,
						"w": 177
					},
					{
						"n": 11,
						"h": 144,
						"w": 173
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 664
					},
					{
						"n": 13,
						"h": 395,
						"w": 457
					},
					{
						"n": 3,
						"h": 287,
						"w": 612
					},
					{
						"n": 14,
						"h": 209,
						"w": 620
					},
					{
						"n": 5,
						"h": 98,
						"w": 606
					},
					{
						"n": 6,
						"h": 199,
						"w": 548
					},
					{
						"n": 7,
						"h": 193,
						"w": 449
					},
					{
						"n": 8,
						"h": 50,
						"w": 440
					},
					{
						"n": 17,
						"h": 293,
						"w": 432
					},
					{
						"n": 19,
						"h": 291,
						"w": 338
					},
					{
						"n": 11,
						"h": 263,
						"w": 436
					}
				],
				"ball": {
					"n": 0,
					"h": 266,
					"w": 294,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1231,
			"minute": 60,
			"possession": 44,
			"messages": [
				{
					"owner": 1,
					"mes": "Передача А.Гилберту[11](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 710
					},
					{
						"n": 2,
						"h": 369,
						"w": 380,
						"f": 83
					},
					{
						"n": 3,
						"h": 284,
						"w": 418
					},
					{
						"n": 4,
						"h": 180,
						"w": 426
					},
					{
						"n": 5,
						"h": 76,
						"w": 393
					},
					{
						"n": 6,
						"h": 391,
						"w": 201
					},
					{
						"n": 7,
						"h": 258,
						"w": 247,
						"f": 83
					},
					{
						"n": 8,
						"h": 161,
						"w": 311
					},
					{
						"n": 17,
						"h": 55,
						"w": 252,
						"f": 94
					},
					{
						"n": 10,
						"h": 268,
						"w": 135
					},
					{
						"n": 11,
						"h": 166,
						"w": 196,
						"f": 82
					}
				],
				"away": [
					{
						"n": 1,
						"h": 229,
						"w": 706
					},
					{
						"n": 13,
						"h": 395,
						"w": 504
					},
					{
						"n": 3,
						"h": 271,
						"w": 617,
						"f": 85
					},
					{
						"n": 14,
						"h": 198,
						"w": 600
					},
					{
						"n": 5,
						"h": 110,
						"w": 608,
						"m": 680
					},
					{
						"n": 6,
						"h": 246,
						"w": 545
					},
					{
						"n": 7,
						"h": 193,
						"w": 496
					},
					{
						"n": 8,
						"h": 54,
						"w": 487,
						"f": 83
					},
					{
						"n": 17,
						"h": 331,
						"w": 459
					},
					{
						"n": 19,
						"h": 290,
						"w": 385,
						"f": 95
					},
					{
						"n": 11,
						"h": 217,
						"w": 430
					}
				],
				"ball": {
					"n": 0,
					"h": 166,
					"w": 196,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 47
		},
		{
			"num": 1232,
			"minute": 60,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 705
					},
					{
						"n": 2,
						"h": 391,
						"w": 372
					},
					{
						"n": 3,
						"h": 269,
						"w": 415
					},
					{
						"n": 4,
						"h": 172,
						"w": 431
					},
					{
						"n": 5,
						"h": 59,
						"w": 367
					},
					{
						"n": 6,
						"h": 395,
						"w": 168
					},
					{
						"n": 7,
						"h": 265,
						"w": 214
					},
					{
						"n": 8,
						"h": 159,
						"w": 277
					},
					{
						"n": 17,
						"h": 53,
						"w": 218
					},
					{
						"n": 10,
						"h": 292,
						"w": 124
					},
					{
						"n": 11,
						"h": 166,
						"w": 156
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 686
					},
					{
						"n": 13,
						"h": 397,
						"w": 538
					},
					{
						"n": 3,
						"h": 237,
						"w": 617
					},
					{
						"n": 14,
						"h": 169,
						"w": 612
					},
					{
						"n": 5,
						"h": 110,
						"w": 605
					},
					{
						"n": 6,
						"h": 273,
						"w": 576
					},
					{
						"n": 7,
						"h": 187,
						"w": 530
					},
					{
						"n": 8,
						"h": 55,
						"w": 521
					},
					{
						"n": 17,
						"h": 345,
						"w": 460
					},
					{
						"n": 19,
						"h": 291,
						"w": 413
					},
					{
						"n": 11,
						"h": 183,
						"w": 426
					}
				],
				"ball": {
					"n": 0,
					"h": 166,
					"w": 156,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 34
		},
		{
			"num": 1233,
			"minute": 60,
			"messages": [
				{
					"owner": 1,
					"mes": "Адам Гилберт[11](Галвэй Юнайтед) смещается вправо..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 709
					},
					{
						"n": 2,
						"h": 378,
						"w": 356
					},
					{
						"n": 3,
						"h": 269,
						"w": 416
					},
					{
						"n": 4,
						"h": 167,
						"w": 410
					},
					{
						"n": 5,
						"h": 75,
						"w": 357
					},
					{
						"n": 6,
						"h": 403,
						"w": 147
					},
					{
						"n": 7,
						"h": 275,
						"w": 195
					},
					{
						"n": 8,
						"h": 174,
						"w": 293
					},
					{
						"n": 17,
						"h": 50,
						"w": 196
					},
					{
						"n": 10,
						"h": 288,
						"w": 117
					},
					{
						"n": 11,
						"h": 156,
						"w": 136
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 689
					},
					{
						"n": 13,
						"h": 400,
						"w": 560
					},
					{
						"n": 3,
						"h": 259,
						"w": 615
					},
					{
						"n": 14,
						"h": 178,
						"w": 632
					},
					{
						"n": 5,
						"h": 110,
						"w": 627
					},
					{
						"n": 6,
						"h": 279,
						"w": 589
					},
					{
						"n": 7,
						"h": 182,
						"w": 533
					},
					{
						"n": 8,
						"h": 57,
						"w": 543
					},
					{
						"n": 17,
						"h": 347,
						"w": 460
					},
					{
						"n": 19,
						"h": 282,
						"w": 433
					},
					{
						"n": 11,
						"h": 161,
						"w": 424
					}
				],
				"ball": {
					"n": 0,
					"h": 156,
					"w": 136,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 22
		},
		{
			"num": 1234,
			"minute": 60,
			"messages": [
				{
					"owner": 1,
					"mes": "Мощнейший удар А.Гилберта[11](Галвэй Юнайтед) издали..."
				},
				{
					"owner": 1,
					"mes": "Мяч летит выше ворот."
				}
			],
			"U": {
				"team": 1,
				"player": 11,
				"xg": "0.05"
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 710
					},
					{
						"n": 2,
						"h": 377,
						"w": 365
					},
					{
						"n": 3,
						"h": 273,
						"w": 413
					},
					{
						"n": 4,
						"h": 171,
						"w": 417
					},
					{
						"n": 5,
						"h": 75,
						"w": 355
					},
					{
						"n": 6,
						"h": 396,
						"w": 117
					},
					{
						"n": 7,
						"h": 292,
						"w": 172
					},
					{
						"n": 8,
						"h": 173,
						"w": 254
					},
					{
						"n": 17,
						"h": 56,
						"w": 157
					},
					{
						"n": 10,
						"h": 292,
						"w": 107
					},
					{
						"n": 11,
						"h": 156,
						"w": 136
					}
				],
				"away": [
					{
						"n": 1,
						"h": 205,
						"w": 700
					},
					{
						"n": 13,
						"h": 394,
						"w": 599
					},
					{
						"n": 3,
						"h": 278,
						"w": 637
					},
					{
						"n": 14,
						"h": 177,
						"w": 626
					},
					{
						"n": 5,
						"h": 110,
						"w": 638
					},
					{
						"n": 6,
						"h": 285,
						"w": 590
					},
					{
						"n": 7,
						"h": 166,
						"w": 552
					},
					{
						"n": 8,
						"h": 52,
						"w": 532
					},
					{
						"n": 17,
						"h": 365,
						"w": 466
					},
					{
						"n": 19,
						"h": 294,
						"w": 418
					},
					{
						"n": 11,
						"h": 158,
						"w": 419
					}
				],
				"ball": {
					"n": 0,
					"h": 257,
					"w": -31,
					"z": 1,
					"r": 0,
					"p": 0,
					"x": 4
				}
			},
			"interval": 39
		},
		{
			"num": 1235,
			"minute": 60,
			"possession": 44,
			"messages": [
				{
					"owner": 1,
					"mes": "Галвэй Юнайтед вводит свежую кровь:"
				}
			],
			"S": {
				"team": 1,
				"out": 7,
				"in": 18
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 690
					},
					{
						"n": 2,
						"h": 376,
						"w": 385
					},
					{
						"n": 3,
						"h": 233,
						"w": 409
					},
					{
						"n": 4,
						"h": 132,
						"w": 408
					},
					{
						"n": 5,
						"h": 74,
						"w": 375
					},
					{
						"n": 6,
						"h": 395,
						"w": 137
					},
					{
						"n": 7,
						"h": 258,
						"w": 193
					},
					{
						"n": 8,
						"h": 136,
						"w": 270
					},
					{
						"n": 17,
						"h": 57,
						"w": 177
					},
					{
						"n": 10,
						"h": 261,
						"w": 132
					},
					{
						"n": 11,
						"h": 133,
						"w": 169
					},
					{
						"n": 18,
						"h": -1,
						"w": 358
					},
					{
						"n": 14,
						"h": -10,
						"w": 320
					},
					{
						"n": 13,
						"h": -10,
						"w": 300
					},
					{
						"n": 15,
						"h": -10,
						"w": 280
					},
					{
						"n": 19,
						"h": -10,
						"w": 260
					},
					{
						"n": 20,
						"h": -10,
						"w": 240
					}
				],
				"away": [
					{
						"n": 1,
						"h": 188,
						"w": 705
					},
					{
						"n": 13,
						"h": 394,
						"w": 579
					},
					{
						"n": 3,
						"h": 281,
						"w": 617
					},
					{
						"n": 14,
						"h": 172,
						"w": 607
					},
					{
						"n": 5,
						"h": 99,
						"w": 621
					},
					{
						"n": 6,
						"h": 277,
						"w": 572
					},
					{
						"n": 7,
						"h": 170,
						"w": 533
					},
					{
						"n": 8,
						"h": 89,
						"w": 517
					},
					{
						"n": 17,
						"h": 368,
						"w": 446
					},
					{
						"n": 19,
						"h": 293,
						"w": 398
					},
					{
						"n": 11,
						"h": 198,
						"w": 416,
						"m": 660
					},
					{
						"n": 18,
						"h": 460,
						"w": 340,
						"m": 660
					},
					{
						"n": 20,
						"h": 460,
						"w": 320,
						"m": 660
					}
				],
				"ball": {
					"n": 0,
					"h": 260,
					"w": 34,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 20
		},
		{
			"num": 1236,
			"minute": 60,
			"messages": [
				{
					"owner": 1,
					"mes": "Райан Уотсон[18](Галвэй Юнайтед) появляется вместо А.Хлинссона[07](Галвэй Юнайтед)."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 680
					},
					{
						"n": 2,
						"h": 370,
						"w": 539
					},
					{
						"n": 3,
						"h": 7,
						"w": 385
					},
					{
						"n": 4,
						"h": 18,
						"w": 382
					},
					{
						"n": 5,
						"h": 68,
						"w": 529
					},
					{
						"n": 6,
						"h": 385,
						"w": 291
					},
					{
						"n": 7,
						"h": 0,
						"w": 360
					},
					{
						"n": 8,
						"h": 11,
						"w": 326
					},
					{
						"n": 17,
						"h": 69,
						"w": 331
					},
					{
						"n": 10,
						"h": 24,
						"w": 323
					},
					{
						"n": 11,
						"h": 11,
						"w": 342
					},
					{
						"n": 18,
						"h": 0,
						"w": 360
					},
					{
						"n": 14,
						"h": -10,
						"w": 320
					},
					{
						"n": 13,
						"h": -10,
						"w": 300
					},
					{
						"n": 15,
						"h": -10,
						"w": 280
					},
					{
						"n": 19,
						"h": -10,
						"w": 260
					},
					{
						"n": 20,
						"h": -10,
						"w": 240
					}
				],
				"away": [
					{
						"n": 1,
						"h": 185,
						"w": 706
					},
					{
						"n": 13,
						"h": 392,
						"w": 437
					},
					{
						"n": 3,
						"h": 293,
						"w": 545
					},
					{
						"n": 14,
						"h": 155,
						"w": 545
					},
					{
						"n": 5,
						"h": 49,
						"w": 545
					},
					{
						"n": 6,
						"h": 222,
						"w": 437
					},
					{
						"n": 7,
						"h": 204,
						"w": 382
					},
					{
						"n": 8,
						"h": 375,
						"w": 402
					},
					{
						"n": 17,
						"h": 390,
						"w": 298
					},
					{
						"n": 19,
						"h": 290,
						"w": 244
					},
					{
						"n": 11,
						"h": 426,
						"w": 397
					},
					{
						"n": 18,
						"h": 460,
						"w": 340
					},
					{
						"n": 20,
						"h": 460,
						"w": 320
					}
				],
				"ball": {
					"n": 0,
					"h": 260,
					"w": 34,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 154
		},
		{
			"num": 1237,
			"minute": 60,
			"possession": 44,
			"messages": [
				{
					"owner": 1,
					"mes": "В команде Галвэй Юнайтед замена:"
				}
			],
			"S": {
				"team": 1,
				"out": 3,
				"in": 14
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 680
					},
					{
						"n": 2,
						"h": 370,
						"w": 545
					},
					{
						"n": 3,
						"h": 0,
						"w": 360
					},
					{
						"n": 4,
						"h": 18,
						"w": 382
					},
					{
						"n": 5,
						"h": 68,
						"w": 541
					},
					{
						"n": 6,
						"h": 382,
						"w": 332
					},
					{
						"n": 18,
						"h": 38,
						"w": 375,
						"f": 100,
						"m": 600,
						"c": 0
					},
					{
						"n": 8,
						"h": 11,
						"w": 326
					},
					{
						"n": 17,
						"h": 72,
						"w": 372
					},
					{
						"n": 10,
						"h": 24,
						"w": 323
					},
					{
						"n": 11,
						"h": 11,
						"w": 342
					},
					{
						"n": 14,
						"h": 0,
						"w": 360
					},
					{
						"n": 13,
						"h": -10,
						"w": 300
					},
					{
						"n": 15,
						"h": -10,
						"w": 280
					},
					{
						"n": 19,
						"h": -10,
						"w": 260
					},
					{
						"n": 20,
						"h": -10,
						"w": 240
					}
				],
				"away": [
					{
						"n": 1,
						"h": 185,
						"w": 706
					},
					{
						"n": 13,
						"h": 392,
						"w": 437
					},
					{
						"n": 3,
						"h": 293,
						"w": 545
					},
					{
						"n": 14,
						"h": 155,
						"w": 545
					},
					{
						"n": 5,
						"h": 49,
						"w": 545
					},
					{
						"n": 6,
						"h": 222,
						"w": 437
					},
					{
						"n": 7,
						"h": 213,
						"w": 342
					},
					{
						"n": 8,
						"h": 443,
						"w": 375
					},
					{
						"n": 17,
						"h": 390,
						"w": 298
					},
					{
						"n": 19,
						"h": 289,
						"w": 220
					},
					{
						"n": 11,
						"h": 426,
						"w": 397
					},
					{
						"n": 18,
						"h": 460,
						"w": 340
					},
					{
						"n": 20,
						"h": 460,
						"w": 320
					}
				],
				"ball": {
					"n": 0,
					"h": 260,
					"w": 34,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 41
		},
		{
			"num": 1238,
			"minute": 60,
			"messages": [
				{
					"owner": 1,
					"mes": "Патрик Клинтон[03](Галвэй Юнайтед) уходит с поля... Вместо него Том Смит[14](Галвэй Юнайтед)."
				}
			]
		},
		{
			"num": 1239,
			"minute": 60,
			"possession": 44,
			"messages": [
				{
					"owner": 1,
					"mes": "Галвэй Юнайтед производит замену:"
				}
			],
			"S": {
				"team": 1,
				"out": 4,
				"in": 13
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 680
					},
					{
						"n": 2,
						"h": 370,
						"w": 545
					},
					{
						"n": 14,
						"h": 48,
						"w": 397,
						"f": 100,
						"m": 600,
						"c": 0
					},
					{
						"n": 4,
						"h": 0,
						"w": 360
					},
					{
						"n": 5,
						"h": 68,
						"w": 541
					},
					{
						"n": 6,
						"h": 378,
						"w": 393
					},
					{
						"n": 18,
						"h": 95,
						"w": 397
					},
					{
						"n": 8,
						"h": 11,
						"w": 326
					},
					{
						"n": 17,
						"h": 76,
						"w": 433
					},
					{
						"n": 10,
						"h": 24,
						"w": 323
					},
					{
						"n": 11,
						"h": 11,
						"w": 342
					},
					{
						"n": 13,
						"h": 0,
						"w": 360
					},
					{
						"n": 15,
						"h": -10,
						"w": 280
					},
					{
						"n": 19,
						"h": -10,
						"w": 260
					},
					{
						"n": 20,
						"h": -10,
						"w": 240
					}
				],
				"away": [
					{
						"n": 1,
						"h": 185,
						"w": 706
					},
					{
						"n": 13,
						"h": 392,
						"w": 437
					},
					{
						"n": 3,
						"h": 293,
						"w": 545
					},
					{
						"n": 14,
						"h": 155,
						"w": 545
					},
					{
						"n": 5,
						"h": 49,
						"w": 545
					},
					{
						"n": 6,
						"h": 222,
						"w": 437
					},
					{
						"n": 7,
						"h": 216,
						"w": 328
					},
					{
						"n": 8,
						"h": 443,
						"w": 375
					},
					{
						"n": 17,
						"h": 390,
						"w": 298
					},
					{
						"n": 19,
						"h": 289,
						"w": 220
					},
					{
						"n": 11,
						"h": 426,
						"w": 397
					},
					{
						"n": 18,
						"h": 460,
						"w": 340
					},
					{
						"n": 20,
						"h": 460,
						"w": 320
					}
				],
				"ball": {
					"n": 0,
					"h": 260,
					"w": 34,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 61
		},
		{
			"num": 1240,
			"minute": 60,
			"messages": [
				{
					"owner": 1,
					"mes": "Билли Реган[13](Галвэй Юнайтед) вместо Р.Дриссенса[04](Галвэй Юнайтед)."
				}
			]
		},
		{
			"num": 1241,
			"minute": 60,
			"possession": 44,
			"messages": [
				{
					"owner": 1,
					"mes": "Галвэй Юнайтед вводит свежую кровь:"
				}
			],
			"S": {
				"team": 1,
				"out": 8,
				"in": 15
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 680
					},
					{
						"n": 2,
						"h": 370,
						"w": 545
					},
					{
						"n": 14,
						"h": 112,
						"w": 447
					},
					{
						"n": 13,
						"h": 44,
						"w": 428,
						"f": 100,
						"m": 600,
						"c": 0
					},
					{
						"n": 5,
						"h": 68,
						"w": 541
					},
					{
						"n": 6,
						"h": 375,
						"w": 447
					},
					{
						"n": 18,
						"h": 171,
						"w": 426
					},
					{
						"n": 8,
						"h": 0,
						"w": 360
					},
					{
						"n": 17,
						"h": 77,
						"w": 443
					},
					{
						"n": 10,
						"h": 24,
						"w": 323
					},
					{
						"n": 11,
						"h": 11,
						"w": 342
					},
					{
						"n": 15,
						"h": 0,
						"w": 360
					},
					{
						"n": 19,
						"h": -10,
						"w": 260
					},
					{
						"n": 20,
						"h": -10,
						"w": 240
					}
				],
				"away": [
					{
						"n": 1,
						"h": 185,
						"w": 706
					},
					{
						"n": 13,
						"h": 392,
						"w": 437
					},
					{
						"n": 3,
						"h": 293,
						"w": 545
					},
					{
						"n": 14,
						"h": 155,
						"w": 545
					},
					{
						"n": 5,
						"h": 49,
						"w": 545
					},
					{
						"n": 6,
						"h": 222,
						"w": 437
					},
					{
						"n": 7,
						"h": 216,
						"w": 328
					},
					{
						"n": 8,
						"h": 443,
						"w": 375
					},
					{
						"n": 17,
						"h": 390,
						"w": 298
					},
					{
						"n": 19,
						"h": 289,
						"w": 220
					},
					{
						"n": 11,
						"h": 426,
						"w": 397
					},
					{
						"n": 18,
						"h": 460,
						"w": 340
					},
					{
						"n": 20,
						"h": 460,
						"w": 320
					}
				],
				"ball": {
					"n": 0,
					"h": 260,
					"w": 34,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 81
		},
		{
			"num": 1242,
			"minute": 60,
			"messages": [
				{
					"owner": 1,
					"mes": "Кевин Келли[15](Галвэй Юнайтед) меняет К.Нолана[08](Галвэй Юнайтед)."
				}
			]
		},
		{
			"num": 1243,
			"minute": 60,
			"possession": 43,
			"messages": [
				{
					"owner": 1,
					"mes": "В команде Галвэй Юнайтед замена:"
				}
			],
			"S": {
				"team": 1,
				"out": 11,
				"in": 19
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 680
					},
					{
						"n": 2,
						"h": 370,
						"w": 545
					},
					{
						"n": 14,
						"h": 191,
						"w": 509
					},
					{
						"n": 13,
						"h": 98,
						"w": 512
					},
					{
						"n": 5,
						"h": 68,
						"w": 541
					},
					{
						"n": 6,
						"h": 375,
						"w": 447
					},
					{
						"n": 18,
						"h": 264,
						"w": 463
					},
					{
						"n": 15,
						"h": 79,
						"w": 421,
						"f": 100,
						"m": 600,
						"c": 0
					},
					{
						"n": 17,
						"h": 77,
						"w": 443
					},
					{
						"n": 10,
						"h": 24,
						"w": 323
					},
					{
						"n": 11,
						"h": 0,
						"w": 360
					},
					{
						"n": 19,
						"h": 0,
						"w": 360
					},
					{
						"n": 20,
						"h": -10,
						"w": 240
					}
				],
				"away": [
					{
						"n": 1,
						"h": 185,
						"w": 706
					},
					{
						"n": 13,
						"h": 392,
						"w": 437
					},
					{
						"n": 3,
						"h": 293,
						"w": 545
					},
					{
						"n": 14,
						"h": 155,
						"w": 545
					},
					{
						"n": 5,
						"h": 49,
						"w": 545
					},
					{
						"n": 6,
						"h": 222,
						"w": 437
					},
					{
						"n": 7,
						"h": 216,
						"w": 328
					},
					{
						"n": 8,
						"h": 443,
						"w": 375
					},
					{
						"n": 17,
						"h": 390,
						"w": 298
					},
					{
						"n": 19,
						"h": 289,
						"w": 220
					},
					{
						"n": 11,
						"h": 426,
						"w": 397
					},
					{
						"n": 18,
						"h": 460,
						"w": 340
					},
					{
						"n": 20,
						"h": 460,
						"w": 320
					}
				],
				"ball": {
					"n": 0,
					"h": 260,
					"w": 34,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 100
		},
		{
			"num": 1244,
			"minute": 60,
			"messages": [
				{
					"owner": 1,
					"mes": "вместо А.Гилберта[11](Галвэй Юнайтед) на поле выходит Байрон О`Горман[19](Галвэй Юнайтед)."
				}
			]
		},
		{
			"num": 1245,
			"minute": 60,
			"possession": 43,
			"messages": [
				{
					"owner": 1,
					"mes": "Замена в команде Галвэй Юнайтед:"
				}
			],
			"S": {
				"team": 1,
				"out": 10,
				"in": 20
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 680
					},
					{
						"n": 2,
						"h": 370,
						"w": 545
					},
					{
						"n": 14,
						"h": 285,
						"w": 583
					},
					{
						"n": 13,
						"h": 155,
						"w": 600
					},
					{
						"n": 5,
						"h": 68,
						"w": 541
					},
					{
						"n": 6,
						"h": 375,
						"w": 447
					},
					{
						"n": 18,
						"h": 308,
						"w": 480
					},
					{
						"n": 15,
						"h": 157,
						"w": 480
					},
					{
						"n": 17,
						"h": 77,
						"w": 443
					},
					{
						"n": 10,
						"h": 0,
						"w": 360
					},
					{
						"n": 19,
						"h": 120,
						"w": 360,
						"f": 100,
						"m": 600,
						"c": 0
					},
					{
						"n": 20,
						"h": 0,
						"w": 360,
						"f": 100,
						"m": 600,
						"c": 0
					}
				],
				"away": [
					{
						"n": 1,
						"h": 185,
						"w": 706
					},
					{
						"n": 13,
						"h": 392,
						"w": 437
					},
					{
						"n": 3,
						"h": 293,
						"w": 545
					},
					{
						"n": 14,
						"h": 155,
						"w": 545
					},
					{
						"n": 5,
						"h": 49,
						"w": 545
					},
					{
						"n": 6,
						"h": 222,
						"w": 437
					},
					{
						"n": 7,
						"h": 216,
						"w": 328
					},
					{
						"n": 8,
						"h": 443,
						"w": 375
					},
					{
						"n": 17,
						"h": 390,
						"w": 298
					},
					{
						"n": 19,
						"h": 289,
						"w": 220
					},
					{
						"n": 11,
						"h": 426,
						"w": 397
					},
					{
						"n": 18,
						"h": 460,
						"w": 340
					},
					{
						"n": 20,
						"h": 460,
						"w": 320
					}
				],
				"ball": {
					"n": 0,
					"h": 260,
					"w": 34,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 120
		},
		{
			"num": 1246,
			"minute": 60,
			"messages": [
				{
					"owner": 1,
					"mes": "Джо Квигли[10](Галвэй Юнайтед) уходит с поля... Вместо него Том Дэвлин[20](Галвэй Юнайтед)."
				},
				{
					"owner": 1,
					"mes": "Патрик Клинтон[03](Галвэй Юнайтед) надевает капитанскую повязку на руку Р.Уотсону[18](Галвэй Юнайтед)."
				}
			]
		},
		{
			"num": 1247,
			"minute": 60,
			"possession": 43,
			"messages": [
				{
					"owner": 2,
					"mes": "В команде Опава замена:"
				}
			],
			"S": {
				"team": 2,
				"out": 8,
				"in": 18
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 680
					},
					{
						"n": 2,
						"h": 370,
						"w": 545
					},
					{
						"n": 14,
						"h": 302,
						"w": 596
					},
					{
						"n": 13,
						"h": 155,
						"w": 600
					},
					{
						"n": 5,
						"h": 68,
						"w": 541
					},
					{
						"n": 6,
						"h": 375,
						"w": 447
					},
					{
						"n": 18,
						"h": 308,
						"w": 480
					},
					{
						"n": 15,
						"h": 157,
						"w": 480
					},
					{
						"n": 17,
						"h": 77,
						"w": 443
					},
					{
						"n": 20,
						"h": 22,
						"w": 360,
						"f": 94,
						"m": 600,
						"c": 0
					},
					{
						"n": 19,
						"h": 142,
						"w": 360
					}
				],
				"away": [
					{
						"n": 1,
						"h": 185,
						"w": 706
					},
					{
						"n": 13,
						"h": 392,
						"w": 437
					},
					{
						"n": 3,
						"h": 293,
						"w": 545
					},
					{
						"n": 14,
						"h": 155,
						"w": 545
					},
					{
						"n": 5,
						"h": 49,
						"w": 545
					},
					{
						"n": 6,
						"h": 222,
						"w": 437
					},
					{
						"n": 7,
						"h": 216,
						"w": 328
					},
					{
						"n": 8,
						"h": 450,
						"w": 360
					},
					{
						"n": 17,
						"h": 390,
						"w": 298
					},
					{
						"n": 19,
						"h": 289,
						"w": 220
					},
					{
						"n": 11,
						"h": 426,
						"w": 397
					},
					{
						"n": 18,
						"h": 450,
						"w": 360
					},
					{
						"n": 20,
						"h": 460,
						"w": 320
					}
				],
				"ball": {
					"n": 0,
					"h": 260,
					"w": 34,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 22
		},
		{
			"num": 1248,
			"minute": 60,
			"messages": [
				{
					"owner": 2,
					"mes": "Ньялл Томпсон[38](Опава) вместо Д.Прохазки[28](Опава)."
				}
			]
		},
		{
			"num": 1249,
			"minute": 60,
			"possession": 43,
			"messages": [
				{
					"owner": 2,
					"mes": "В составе Опава происходит замена:"
				}
			],
			"S": {
				"team": 2,
				"out": 11,
				"in": 20
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 680
					},
					{
						"n": 2,
						"h": 370,
						"w": 545
					},
					{
						"n": 14,
						"h": 307,
						"w": 600
					},
					{
						"n": 13,
						"h": 155,
						"w": 600
					},
					{
						"n": 5,
						"h": 68,
						"w": 541
					},
					{
						"n": 6,
						"h": 375,
						"w": 447
					},
					{
						"n": 18,
						"h": 308,
						"w": 480
					},
					{
						"n": 15,
						"h": 157,
						"w": 480
					},
					{
						"n": 17,
						"h": 77,
						"w": 443
					},
					{
						"n": 20,
						"h": 63,
						"w": 360
					},
					{
						"n": 19,
						"h": 145,
						"w": 360
					}
				],
				"away": [
					{
						"n": 1,
						"h": 185,
						"w": 706
					},
					{
						"n": 13,
						"h": 392,
						"w": 437
					},
					{
						"n": 3,
						"h": 293,
						"w": 545
					},
					{
						"n": 14,
						"h": 155,
						"w": 545
					},
					{
						"n": 5,
						"h": 49,
						"w": 545
					},
					{
						"n": 6,
						"h": 222,
						"w": 437
					},
					{
						"n": 7,
						"h": 216,
						"w": 328
					},
					{
						"n": 18,
						"h": 411,
						"w": 372,
						"f": 98,
						"m": 600,
						"c": 0
					},
					{
						"n": 17,
						"h": 390,
						"w": 298
					},
					{
						"n": 19,
						"h": 289,
						"w": 220
					},
					{
						"n": 11,
						"h": 450,
						"w": 360
					},
					{
						"n": 20,
						"h": 450,
						"w": 360
					}
				],
				"ball": {
					"n": 0,
					"h": 260,
					"w": 34,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 41
		},
		{
			"num": 1250,
			"minute": 60,
			"messages": [
				{
					"owner": 2,
					"mes": "Тома Анри[40](Опава) появляется вместо Ш.Товарека[31](Опава)."
				}
			]
		},
		{
			"num": 1251,
			"minute": 60,
			"possession": 43,
			"messages": [
				{
					"owner": 2,
					"mes": "Удар от ворот..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 680
					},
					{
						"n": 2,
						"h": 369,
						"w": 549
					},
					{
						"n": 14,
						"h": 279,
						"w": 570
					},
					{
						"n": 13,
						"h": 170,
						"w": 570
					},
					{
						"n": 5,
						"h": 79,
						"w": 542
					},
					{
						"n": 6,
						"h": 366,
						"w": 442
					},
					{
						"n": 18,
						"h": 288,
						"w": 470
					},
					{
						"n": 15,
						"h": 179,
						"w": 470
					},
					{
						"n": 17,
						"h": 72,
						"w": 450
					},
					{
						"n": 20,
						"h": 289,
						"w": 370
					},
					{
						"n": 19,
						"h": 170,
						"w": 370
					}
				],
				"away": [
					{
						"n": 1,
						"h": 188,
						"w": 706
					},
					{
						"n": 13,
						"h": 392,
						"w": 437
					},
					{
						"n": 3,
						"h": 293,
						"w": 545
					},
					{
						"n": 14,
						"h": 161,
						"w": 545
					},
					{
						"n": 5,
						"h": 56,
						"w": 545
					},
					{
						"n": 6,
						"h": 220,
						"w": 437
					},
					{
						"n": 7,
						"h": 222,
						"w": 328
					},
					{
						"n": 18,
						"h": 58,
						"w": 348
					},
					{
						"n": 17,
						"h": 386,
						"w": 298
					},
					{
						"n": 19,
						"h": 290,
						"w": 220
					},
					{
						"n": 20,
						"h": 156,
						"w": 220,
						"f": 98,
						"m": 600,
						"c": 0
					}
				],
				"ball": {
					"n": 0,
					"h": 260,
					"w": 34,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 150
		},
		{
			"num": 1252,
			"minute": 60,
			"messages": [],
			"T": {
				"team": 2
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 678
					},
					{
						"n": 2,
						"h": 363,
						"w": 550
					},
					{
						"n": 14,
						"h": 279,
						"w": 569
					},
					{
						"n": 13,
						"h": 177,
						"w": 569
					},
					{
						"n": 5,
						"h": 79,
						"w": 538
					},
					{
						"n": 6,
						"h": 368,
						"w": 447
					},
					{
						"n": 18,
						"h": 287,
						"w": 475
					},
					{
						"n": 15,
						"h": 181,
						"w": 468
					},
					{
						"n": 17,
						"h": 72,
						"w": 454
					},
					{
						"n": 20,
						"h": 291,
						"w": 368
					},
					{
						"n": 19,
						"h": 174,
						"w": 376
					}
				],
				"away": [
					{
						"n": 1,
						"h": 190,
						"w": 686
					},
					{
						"n": 13,
						"h": 397,
						"w": 433
					},
					{
						"n": 3,
						"h": 293,
						"w": 546
					},
					{
						"n": 14,
						"h": 155,
						"w": 544
					},
					{
						"n": 5,
						"h": 60,
						"w": 552
					},
					{
						"n": 6,
						"h": 226,
						"w": 442
					},
					{
						"n": 7,
						"h": 215,
						"w": 326
					},
					{
						"n": 18,
						"h": 63,
						"w": 344
					},
					{
						"n": 17,
						"h": 387,
						"w": 301
					},
					{
						"n": 19,
						"h": 286,
						"w": 225
					},
					{
						"n": 20,
						"h": 160,
						"w": 220
					}
				],
				"ball": {
					"n": 0,
					"h": 260,
					"w": 34,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 15
		},
		{
			"num": 1253,
			"minute": 60,
			"messages": [
				{
					"owner": 2,
					"mes": "Крыштоф Ласак[21](Опава) бьет далеко вперед..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 704
					},
					{
						"n": 2,
						"h": 336,
						"w": 574
					},
					{
						"n": 14,
						"h": 301,
						"w": 572
					},
					{
						"n": 13,
						"h": 223,
						"w": 578
					},
					{
						"n": 5,
						"h": 120,
						"w": 584
					},
					{
						"n": 6,
						"h": 394,
						"w": 499
					},
					{
						"n": 18,
						"h": 309,
						"w": 504
					},
					{
						"n": 15,
						"h": 186,
						"w": 482
					},
					{
						"n": 17,
						"h": 58,
						"w": 513
					},
					{
						"n": 20,
						"h": 229,
						"w": 387
					},
					{
						"n": 19,
						"h": 204,
						"w": 389
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 670
					},
					{
						"n": 13,
						"h": 398,
						"w": 384
					},
					{
						"n": 3,
						"h": 270,
						"w": 535
					},
					{
						"n": 14,
						"h": 167,
						"w": 545
					},
					{
						"n": 5,
						"h": 58,
						"w": 523
					},
					{
						"n": 6,
						"h": 221,
						"w": 353
					},
					{
						"n": 7,
						"h": 246,
						"w": 331
					},
					{
						"n": 18,
						"h": 45,
						"w": 256
					},
					{
						"n": 17,
						"h": 392,
						"w": 242
					},
					{
						"n": 19,
						"h": 281,
						"w": 315
					},
					{
						"n": 20,
						"h": 148,
						"w": 229
					}
				],
				"ball": {
					"n": 0,
					"h": 204,
					"w": 389,
					"z": 1,
					"r": 0,
					"p": 4,
					"x": 0
				}
			},
			"interval": 90
		},
		{
			"num": 1254,
			"minute": 60,
			"messages": [
				{
					"owner": 1,
					"mes": "Байрон О`Горман[19](Галвэй Юнайтед) в борьбе с М.Маноловом[27](Опава) кивком головы скидывает мяч..."
				},
				{
					"owner": 1,
					"mes": "Том Дэвлин[20](Галвэй Юнайтед) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 708
					},
					{
						"n": 2,
						"h": 334,
						"w": 590
					},
					{
						"n": 14,
						"h": 297,
						"w": 588
					},
					{
						"n": 13,
						"h": 224,
						"w": 593
					},
					{
						"n": 5,
						"h": 120,
						"w": 600
					},
					{
						"n": 6,
						"h": 394,
						"w": 515
					},
					{
						"n": 18,
						"h": 299,
						"w": 516
					},
					{
						"n": 15,
						"h": 191,
						"w": 493
					},
					{
						"n": 17,
						"h": 56,
						"w": 528
					},
					{
						"n": 20,
						"h": 237,
						"w": 387
					},
					{
						"n": 19,
						"h": 204,
						"w": 389,
						"m": 610
					}
				],
				"away": [
					{
						"n": 1,
						"h": 223,
						"w": 656
					},
					{
						"n": 13,
						"h": 407,
						"w": 371
					},
					{
						"n": 3,
						"h": 275,
						"w": 550
					},
					{
						"n": 14,
						"h": 173,
						"w": 549
					},
					{
						"n": 5,
						"h": 65,
						"w": 523
					},
					{
						"n": 6,
						"h": 214,
						"w": 367
					},
					{
						"n": 7,
						"h": 246,
						"w": 331,
						"m": 530
					},
					{
						"n": 18,
						"h": 43,
						"w": 240
					},
					{
						"n": 17,
						"h": 398,
						"w": 227
					},
					{
						"n": 19,
						"h": 281,
						"w": 329
					},
					{
						"n": 20,
						"h": 158,
						"w": 216
					}
				],
				"ball": {
					"n": 0,
					"h": 237,
					"w": 387,
					"z": 1,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 16
		},
		{
			"num": 1255,
			"minute": 61,
			"possession": 43,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 708
					},
					{
						"n": 2,
						"h": 351,
						"w": 554
					},
					{
						"n": 14,
						"h": 283,
						"w": 551
					},
					{
						"n": 13,
						"h": 205,
						"w": 558
					},
					{
						"n": 5,
						"h": 107,
						"w": 562,
						"f": 83
					},
					{
						"n": 6,
						"h": 400,
						"w": 475
					},
					{
						"n": 18,
						"h": 299,
						"w": 476
					},
					{
						"n": 15,
						"h": 182,
						"w": 454
					},
					{
						"n": 17,
						"h": 52,
						"w": 488
					},
					{
						"n": 20,
						"h": 272,
						"w": 387
					},
					{
						"n": 19,
						"h": 196,
						"w": 364
					}
				],
				"away": [
					{
						"n": 1,
						"h": 226,
						"w": 649,
						"f": 83
					},
					{
						"n": 13,
						"h": 407,
						"w": 411
					},
					{
						"n": 3,
						"h": 260,
						"w": 559
					},
					{
						"n": 14,
						"h": 185,
						"w": 553,
						"f": 92
					},
					{
						"n": 5,
						"h": 100,
						"w": 542
					},
					{
						"n": 6,
						"h": 179,
						"w": 350
					},
					{
						"n": 7,
						"h": 241,
						"w": 357
					},
					{
						"n": 18,
						"h": 44,
						"w": 280
					},
					{
						"n": 17,
						"h": 405,
						"w": 266
					},
					{
						"n": 19,
						"h": 261,
						"w": 364
					},
					{
						"n": 20,
						"h": 152,
						"w": 256
					}
				],
				"ball": {
					"n": 0,
					"h": 272,
					"w": 387,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1256,
			"minute": 61,
			"messages": [
				{
					"owner": 1,
					"mes": "Передача направо..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 702
					},
					{
						"n": 2,
						"h": 363,
						"w": 512
					},
					{
						"n": 14,
						"h": 282,
						"w": 507
					},
					{
						"n": 13,
						"h": 191,
						"w": 516
					},
					{
						"n": 5,
						"h": 93,
						"w": 520
					},
					{
						"n": 6,
						"h": 399,
						"w": 431
					},
					{
						"n": 18,
						"h": 296,
						"w": 432
					},
					{
						"n": 15,
						"h": 178,
						"w": 410
					},
					{
						"n": 17,
						"h": 74,
						"w": 450
					},
					{
						"n": 20,
						"h": 275,
						"w": 373
					},
					{
						"n": 19,
						"h": 186,
						"w": 321
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 641
					},
					{
						"n": 13,
						"h": 407,
						"w": 455
					},
					{
						"n": 3,
						"h": 295,
						"w": 564
					},
					{
						"n": 14,
						"h": 212,
						"w": 540
					},
					{
						"n": 5,
						"h": 110,
						"w": 556
					},
					{
						"n": 6,
						"h": 191,
						"w": 392
					},
					{
						"n": 7,
						"h": 228,
						"w": 399
					},
					{
						"n": 18,
						"h": 40,
						"w": 324
					},
					{
						"n": 17,
						"h": 372,
						"w": 296
					},
					{
						"n": 19,
						"h": 272,
						"w": 330
					},
					{
						"n": 20,
						"h": 161,
						"w": 299
					}
				],
				"ball": {
					"n": 0,
					"h": 139,
					"w": 402,
					"z": 0,
					"r": 0,
					"p": 2,
					"x": 0
				}
			},
			"interval": 44
		},
		{
			"num": 1257,
			"minute": 61,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 703
					},
					{
						"n": 2,
						"h": 367,
						"w": 486
					},
					{
						"n": 14,
						"h": 274,
						"w": 482
					},
					{
						"n": 13,
						"h": 176,
						"w": 495
					},
					{
						"n": 5,
						"h": 85,
						"w": 495
					},
					{
						"n": 6,
						"h": 400,
						"w": 405
					},
					{
						"n": 18,
						"h": 296,
						"w": 406
					},
					{
						"n": 15,
						"h": 177,
						"w": 387
					},
					{
						"n": 17,
						"h": 87,
						"w": 428
					},
					{
						"n": 20,
						"h": 279,
						"w": 348
					},
					{
						"n": 19,
						"h": 178,
						"w": 297
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 643
					},
					{
						"n": 13,
						"h": 414,
						"w": 480
					},
					{
						"n": 3,
						"h": 275,
						"w": 556
					},
					{
						"n": 14,
						"h": 219,
						"w": 553
					},
					{
						"n": 5,
						"h": 110,
						"w": 560
					},
					{
						"n": 6,
						"h": 199,
						"w": 417
					},
					{
						"n": 7,
						"h": 232,
						"w": 425
					},
					{
						"n": 18,
						"h": 38,
						"w": 350
					},
					{
						"n": 17,
						"h": 352,
						"w": 312
					},
					{
						"n": 19,
						"h": 273,
						"w": 353
					},
					{
						"n": 20,
						"h": 164,
						"w": 325
					}
				],
				"ball": {
					"n": 0,
					"h": 100,
					"w": 406,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 26
		},
		{
			"num": 1258,
			"minute": 61,
			"messages": [
				{
					"owner": 2,
					"mes": "Марин Томасов[37](Опава) удачно выбирает позицию и подбирает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 705
					},
					{
						"n": 2,
						"h": 368,
						"w": 484
					},
					{
						"n": 14,
						"h": 276,
						"w": 482
					},
					{
						"n": 13,
						"h": 175,
						"w": 493
					},
					{
						"n": 5,
						"h": 85,
						"w": 493
					},
					{
						"n": 6,
						"h": 400,
						"w": 403
					},
					{
						"n": 18,
						"h": 296,
						"w": 404
					},
					{
						"n": 15,
						"h": 176,
						"w": 385
					},
					{
						"n": 17,
						"h": 88,
						"w": 426
					},
					{
						"n": 20,
						"h": 280,
						"w": 346,
						"m": 590
					},
					{
						"n": 19,
						"h": 177,
						"w": 295
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 642
					},
					{
						"n": 13,
						"h": 413,
						"w": 481
					},
					{
						"n": 3,
						"h": 274,
						"w": 555
					},
					{
						"n": 14,
						"h": 219,
						"w": 555
					},
					{
						"n": 5,
						"h": 110,
						"w": 558
					},
					{
						"n": 6,
						"h": 200,
						"w": 419
					},
					{
						"n": 7,
						"h": 232,
						"w": 427
					},
					{
						"n": 18,
						"h": 38,
						"w": 352
					},
					{
						"n": 17,
						"h": 350,
						"w": 314,
						"m": 640
					},
					{
						"n": 19,
						"h": 274,
						"w": 355
					},
					{
						"n": 20,
						"h": 164,
						"w": 327
					}
				],
				"ball": {
					"n": 0,
					"h": 100,
					"w": 406,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 2
		},
		{
			"num": 1259,
			"minute": 61,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 706
					},
					{
						"n": 2,
						"h": 330,
						"w": 490
					},
					{
						"n": 14,
						"h": 278,
						"w": 493
					},
					{
						"n": 13,
						"h": 187,
						"w": 500
					},
					{
						"n": 5,
						"h": 120,
						"w": 500
					},
					{
						"n": 6,
						"h": 394,
						"w": 442
					},
					{
						"n": 18,
						"h": 297,
						"w": 439
					},
					{
						"n": 15,
						"h": 175,
						"w": 392
					},
					{
						"n": 17,
						"h": 124,
						"w": 444
					},
					{
						"n": 20,
						"h": 259,
						"w": 311
					},
					{
						"n": 19,
						"h": 172,
						"w": 302
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 682
					},
					{
						"n": 13,
						"h": 418,
						"w": 442
					},
					{
						"n": 3,
						"h": 284,
						"w": 567
					},
					{
						"n": 14,
						"h": 182,
						"w": 572
					},
					{
						"n": 5,
						"h": 70,
						"w": 564
					},
					{
						"n": 6,
						"h": 208,
						"w": 458
					},
					{
						"n": 7,
						"h": 244,
						"w": 405
					},
					{
						"n": 18,
						"h": 47,
						"w": 313
					},
					{
						"n": 17,
						"h": 326,
						"w": 289
					},
					{
						"n": 19,
						"h": 275,
						"w": 315
					},
					{
						"n": 20,
						"h": 154,
						"w": 288
					}
				],
				"ball": {
					"n": 0,
					"h": 124,
					"w": 431,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1260,
			"minute": 61,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 708
					},
					{
						"n": 2,
						"h": 330,
						"w": 510
					},
					{
						"n": 14,
						"h": 268,
						"w": 526
					},
					{
						"n": 13,
						"h": 189,
						"w": 527
					},
					{
						"n": 5,
						"h": 120,
						"w": 515
					},
					{
						"n": 6,
						"h": 394,
						"w": 482
					},
					{
						"n": 18,
						"h": 293,
						"w": 455
					},
					{
						"n": 15,
						"h": 170,
						"w": 424
					},
					{
						"n": 17,
						"h": 162,
						"w": 455
					},
					{
						"n": 20,
						"h": 237,
						"w": 322
					},
					{
						"n": 19,
						"h": 162,
						"w": 325
					}
				],
				"away": [
					{
						"n": 1,
						"h": 226,
						"w": 666
					},
					{
						"n": 13,
						"h": 416,
						"w": 402
					},
					{
						"n": 3,
						"h": 286,
						"w": 554
					},
					{
						"n": 14,
						"h": 165,
						"w": 539
					},
					{
						"n": 5,
						"h": 62,
						"w": 554
					},
					{
						"n": 6,
						"h": 213,
						"w": 418
					},
					{
						"n": 7,
						"h": 239,
						"w": 365
					},
					{
						"n": 18,
						"h": 46,
						"w": 273
					},
					{
						"n": 17,
						"h": 291,
						"w": 280
					},
					{
						"n": 19,
						"h": 275,
						"w": 275
					},
					{
						"n": 20,
						"h": 163,
						"w": 249
					}
				],
				"ball": {
					"n": 0,
					"h": 159,
					"w": 440,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1261,
			"minute": 61,
			"messages": [
				{
					"owner": 2,
					"mes": "М.Томасов[37](Опава) пасует на М.Манолова[27](Опава)..."
				},
				{
					"owner": 2,
					"mes": "Мирослав Манолов[27](Опава) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 701
					},
					{
						"n": 2,
						"h": 330,
						"w": 546
					},
					{
						"n": 14,
						"h": 286,
						"w": 538
					},
					{
						"n": 13,
						"h": 174,
						"w": 560
					},
					{
						"n": 5,
						"h": 120,
						"w": 538
					},
					{
						"n": 6,
						"h": 394,
						"w": 500
					},
					{
						"n": 18,
						"h": 302,
						"w": 495
					},
					{
						"n": 15,
						"h": 210,
						"w": 419
					},
					{
						"n": 17,
						"h": 126,
						"w": 435
					},
					{
						"n": 20,
						"h": 263,
						"w": 353
					},
					{
						"n": 19,
						"h": 203,
						"w": 323
					}
				],
				"away": [
					{
						"n": 1,
						"h": 223,
						"w": 642
					},
					{
						"n": 13,
						"h": 412,
						"w": 361
					},
					{
						"n": 3,
						"h": 273,
						"w": 526
					},
					{
						"n": 14,
						"h": 171,
						"w": 518
					},
					{
						"n": 5,
						"h": 62,
						"w": 513
					},
					{
						"n": 6,
						"h": 226,
						"w": 419
					},
					{
						"n": 7,
						"h": 224,
						"w": 325
					},
					{
						"n": 18,
						"h": 42,
						"w": 255
					},
					{
						"n": 17,
						"h": 291,
						"w": 280
					},
					{
						"n": 19,
						"h": 296,
						"w": 239
					},
					{
						"n": 20,
						"h": 151,
						"w": 210
					}
				],
				"ball": {
					"n": 0,
					"h": 226,
					"w": 395,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 41
		},
		{
			"num": 1262,
			"minute": 61,
			"messages": [
				{
					"owner": 2,
					"mes": "Пас налево на К.Удре[33](Опава)..."
				},
				{
					"owner": 2,
					"mes": "Кеннет Удре[33](Опава) технично принимает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 704
					},
					{
						"n": 2,
						"h": 330,
						"w": 588
					},
					{
						"n": 14,
						"h": 280,
						"w": 588
					},
					{
						"n": 13,
						"h": 196,
						"w": 575
					},
					{
						"n": 5,
						"h": 165,
						"w": 561
					},
					{
						"n": 6,
						"h": 394,
						"w": 437
					},
					{
						"n": 18,
						"h": 251,
						"w": 492
					},
					{
						"n": 15,
						"h": 172,
						"w": 470
					},
					{
						"n": 17,
						"h": 102,
						"w": 390
					},
					{
						"n": 20,
						"h": 244,
						"w": 337
					},
					{
						"n": 19,
						"h": 180,
						"w": 383
					}
				],
				"away": [
					{
						"n": 1,
						"h": 228,
						"w": 623
					},
					{
						"n": 13,
						"h": 350,
						"w": 345
					},
					{
						"n": 3,
						"h": 268,
						"w": 489
					},
					{
						"n": 14,
						"h": 171,
						"w": 486
					},
					{
						"n": 5,
						"h": 56,
						"w": 462
					},
					{
						"n": 6,
						"h": 206,
						"w": 403
					},
					{
						"n": 7,
						"h": 215,
						"w": 321,
						"m": 540
					},
					{
						"n": 18,
						"h": 52,
						"w": 318
					},
					{
						"n": 17,
						"h": 355,
						"w": 289
					},
					{
						"n": 19,
						"h": 289,
						"w": 179
					},
					{
						"n": 20,
						"h": 140,
						"w": 161
					}
				],
				"ball": {
					"n": 0,
					"h": 100,
					"w": 375,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 64
		},
		{
			"num": 1263,
			"minute": 61,
			"messages": [
				{
					"owner": 2,
					"mes": "Пас направо В.Сланине[34](Опава)..."
				},
				{
					"owner": 2,
					"mes": "Вацлав Сланина[34](Опава) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 707
					},
					{
						"n": 2,
						"h": 330,
						"w": 565
					},
					{
						"n": 14,
						"h": 274,
						"w": 566
					},
					{
						"n": 13,
						"h": 180,
						"w": 561
					},
					{
						"n": 5,
						"h": 120,
						"w": 572
					},
					{
						"n": 6,
						"h": 394,
						"w": 483
					},
					{
						"n": 18,
						"h": 296,
						"w": 506
					},
					{
						"n": 15,
						"h": 179,
						"w": 441
					},
					{
						"n": 17,
						"h": 91,
						"w": 435
					},
					{
						"n": 20,
						"h": 283,
						"w": 364
					},
					{
						"n": 19,
						"h": 144,
						"w": 379
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 600
					},
					{
						"n": 13,
						"h": 359,
						"w": 343,
						"m": 620
					},
					{
						"n": 3,
						"h": 283,
						"w": 460
					},
					{
						"n": 14,
						"h": 201,
						"w": 461
					},
					{
						"n": 5,
						"h": 66,
						"w": 468
					},
					{
						"n": 6,
						"h": 239,
						"w": 383
					},
					{
						"n": 7,
						"h": 221,
						"w": 319
					},
					{
						"n": 18,
						"h": 45,
						"w": 272
					},
					{
						"n": 17,
						"h": 377,
						"w": 247
					},
					{
						"n": 19,
						"h": 300,
						"w": 173
					},
					{
						"n": 20,
						"h": 145,
						"w": 200
					}
				],
				"ball": {
					"n": 0,
					"h": 249,
					"w": 259,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 47
		},
		{
			"num": 1264,
			"minute": 61,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 705
					},
					{
						"n": 2,
						"h": 330,
						"w": 604
					},
					{
						"n": 14,
						"h": 283,
						"w": 604
					},
					{
						"n": 13,
						"h": 171,
						"w": 599
					},
					{
						"n": 5,
						"h": 120,
						"w": 603
					},
					{
						"n": 6,
						"h": 394,
						"w": 501
					},
					{
						"n": 18,
						"h": 299,
						"w": 538
					},
					{
						"n": 15,
						"h": 181,
						"w": 480
					},
					{
						"n": 17,
						"h": 79,
						"w": 472
					},
					{
						"n": 20,
						"h": 279,
						"w": 403
					},
					{
						"n": 19,
						"h": 182,
						"w": 389
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 602
					},
					{
						"n": 13,
						"h": 371,
						"w": 306
					},
					{
						"n": 3,
						"h": 269,
						"w": 458
					},
					{
						"n": 14,
						"h": 196,
						"w": 427
					},
					{
						"n": 5,
						"h": 72,
						"w": 449
					},
					{
						"n": 6,
						"h": 240,
						"w": 344
					},
					{
						"n": 7,
						"h": 220,
						"w": 280
					},
					{
						"n": 18,
						"h": 35,
						"w": 234
					},
					{
						"n": 17,
						"h": 399,
						"w": 215
					},
					{
						"n": 19,
						"h": 293,
						"w": 144
					},
					{
						"n": 20,
						"h": 151,
						"w": 161
					}
				],
				"ball": {
					"n": 0,
					"h": 254,
					"w": 293,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 1265,
			"minute": 61,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 709
					},
					{
						"n": 2,
						"h": 300,
						"w": 584
					},
					{
						"n": 14,
						"h": 277,
						"w": 617
					},
					{
						"n": 13,
						"h": 176,
						"w": 632
					},
					{
						"n": 5,
						"h": 91,
						"w": 577
					},
					{
						"n": 6,
						"h": 394,
						"w": 538
					},
					{
						"n": 18,
						"h": 305,
						"w": 568
					},
					{
						"n": 15,
						"h": 183,
						"w": 519
					},
					{
						"n": 17,
						"h": 56,
						"w": 477
					},
					{
						"n": 20,
						"h": 261,
						"w": 368
					},
					{
						"n": 19,
						"h": 158,
						"w": 420
					}
				],
				"away": [
					{
						"n": 1,
						"h": 229,
						"w": 598
					},
					{
						"n": 13,
						"h": 398,
						"w": 278
					},
					{
						"n": 3,
						"h": 283,
						"w": 446
					},
					{
						"n": 14,
						"h": 201,
						"w": 393
					},
					{
						"n": 5,
						"h": 63,
						"w": 423
					},
					{
						"n": 6,
						"h": 204,
						"w": 329
					},
					{
						"n": 7,
						"h": 218,
						"w": 242
					},
					{
						"n": 18,
						"h": 23,
						"w": 197
					},
					{
						"n": 17,
						"h": 420,
						"w": 182
					},
					{
						"n": 19,
						"h": 317,
						"w": 144
					},
					{
						"n": 20,
						"h": 142,
						"w": 144
					}
				],
				"ball": {
					"n": 0,
					"h": 249,
					"w": 327,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 1266,
			"minute": 61,
			"messages": [
				{
					"owner": 2,
					"mes": "Пас правее на Н.Томпсона[38](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 710
					},
					{
						"n": 2,
						"h": 352,
						"w": 596
					},
					{
						"n": 14,
						"h": 263,
						"w": 606
					},
					{
						"n": 13,
						"h": 181,
						"w": 618
					},
					{
						"n": 5,
						"h": 120,
						"w": 616
					},
					{
						"n": 6,
						"h": 389,
						"w": 486
					},
					{
						"n": 18,
						"h": 295,
						"w": 534
					},
					{
						"n": 15,
						"h": 201,
						"w": 501
					},
					{
						"n": 17,
						"h": 33,
						"w": 501
					},
					{
						"n": 20,
						"h": 269,
						"w": 399
					},
					{
						"n": 19,
						"h": 165,
						"w": 387
					}
				],
				"away": [
					{
						"n": 1,
						"h": 223,
						"w": 593
					},
					{
						"n": 13,
						"h": 400,
						"w": 331
					},
					{
						"n": 3,
						"h": 277,
						"w": 456
					},
					{
						"n": 14,
						"h": 193,
						"w": 414,
						"m": 640
					},
					{
						"n": 5,
						"h": 70,
						"w": 446
					},
					{
						"n": 6,
						"h": 181,
						"w": 341
					},
					{
						"n": 7,
						"h": 200,
						"w": 237
					},
					{
						"n": 18,
						"h": 61,
						"w": 234
					},
					{
						"n": 17,
						"h": 373,
						"w": 157
					},
					{
						"n": 19,
						"h": 300,
						"w": 131
					},
					{
						"n": 20,
						"h": 153,
						"w": 147
					}
				],
				"ball": {
					"n": 0,
					"h": 389,
					"w": 486,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 53
		},
		{
			"num": 1267,
			"minute": 61,
			"messages": [
				{
					"owner": 2,
					"mes": "Киэн Колман[06](Галвэй Юнайтед) делает рывок и перехватывает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 701
					},
					{
						"n": 2,
						"h": 359,
						"w": 556
					},
					{
						"n": 14,
						"h": 265,
						"w": 566
					},
					{
						"n": 13,
						"h": 181,
						"w": 578
					},
					{
						"n": 5,
						"h": 107,
						"w": 578
					},
					{
						"n": 6,
						"h": 364,
						"w": 461,
						"m": 720
					},
					{
						"n": 18,
						"h": 309,
						"w": 496
					},
					{
						"n": 15,
						"h": 199,
						"w": 461
					},
					{
						"n": 17,
						"h": 34,
						"w": 461
					},
					{
						"n": 20,
						"h": 278,
						"w": 360
					},
					{
						"n": 19,
						"h": 161,
						"w": 347
					}
				],
				"away": [
					{
						"n": 1,
						"h": 208,
						"w": 633
					},
					{
						"n": 13,
						"h": 404,
						"w": 371
					},
					{
						"n": 3,
						"h": 270,
						"w": 457
					},
					{
						"n": 14,
						"h": 184,
						"w": 453
					},
					{
						"n": 5,
						"h": 107,
						"w": 462
					},
					{
						"n": 6,
						"h": 215,
						"w": 361
					},
					{
						"n": 7,
						"h": 197,
						"w": 277
					},
					{
						"n": 18,
						"h": 86,
						"w": 265
					},
					{
						"n": 17,
						"h": 385,
						"w": 195
					},
					{
						"n": 19,
						"h": 287,
						"w": 169
					},
					{
						"n": 20,
						"h": 148,
						"w": 187
					}
				],
				"ball": {
					"n": 0,
					"h": 364,
					"w": 461,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1268,
			"minute": 61,
			"messages": [
				{
					"owner": 1,
					"mes": "Пас назад..."
				},
				{
					"owner": 1,
					"mes": "Тимо Эверс[02](Галвэй Юнайтед) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 708
					},
					{
						"n": 2,
						"h": 376,
						"w": 529
					},
					{
						"n": 14,
						"h": 278,
						"w": 574
					},
					{
						"n": 13,
						"h": 173,
						"w": 582
					},
					{
						"n": 5,
						"h": 90,
						"w": 551
					},
					{
						"n": 6,
						"h": 369,
						"w": 452
					},
					{
						"n": 18,
						"h": 308,
						"w": 464
					},
					{
						"n": 15,
						"h": 196,
						"w": 429
					},
					{
						"n": 17,
						"h": 40,
						"w": 430
					},
					{
						"n": 20,
						"h": 291,
						"w": 331
					},
					{
						"n": 19,
						"h": 151,
						"w": 317
					}
				],
				"away": [
					{
						"n": 1,
						"h": 205,
						"w": 648
					},
					{
						"n": 13,
						"h": 407,
						"w": 403
					},
					{
						"n": 3,
						"h": 287,
						"w": 475
					},
					{
						"n": 14,
						"h": 172,
						"w": 482
					},
					{
						"n": 5,
						"h": 110,
						"w": 492
					},
					{
						"n": 6,
						"h": 238,
						"w": 384
					},
					{
						"n": 7,
						"h": 199,
						"w": 309
					},
					{
						"n": 18,
						"h": 76,
						"w": 295
					},
					{
						"n": 17,
						"h": 395,
						"w": 226
					},
					{
						"n": 19,
						"h": 287,
						"w": 201
					},
					{
						"n": 20,
						"h": 144,
						"w": 218
					}
				],
				"ball": {
					"n": 0,
					"h": 376,
					"w": 529,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 32
		},
		{
			"num": 1269,
			"minute": 61,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 703
					},
					{
						"n": 2,
						"h": 360,
						"w": 498
					},
					{
						"n": 14,
						"h": 273,
						"w": 542
					},
					{
						"n": 13,
						"h": 175,
						"w": 542
					},
					{
						"n": 5,
						"h": 76,
						"w": 513
					},
					{
						"n": 6,
						"h": 383,
						"w": 414
					},
					{
						"n": 18,
						"h": 304,
						"w": 445
					},
					{
						"n": 15,
						"h": 202,
						"w": 390
					},
					{
						"n": 17,
						"h": 39,
						"w": 390
					},
					{
						"n": 20,
						"h": 305,
						"w": 294
					},
					{
						"n": 19,
						"h": 157,
						"w": 277
					}
				],
				"away": [
					{
						"n": 1,
						"h": 205,
						"w": 641
					},
					{
						"n": 13,
						"h": 406,
						"w": 366
					},
					{
						"n": 3,
						"h": 281,
						"w": 514
					},
					{
						"n": 14,
						"h": 172,
						"w": 501
					},
					{
						"n": 5,
						"h": 110,
						"w": 518
					},
					{
						"n": 6,
						"h": 266,
						"w": 413
					},
					{
						"n": 7,
						"h": 201,
						"w": 349
					},
					{
						"n": 18,
						"h": 59,
						"w": 332
					},
					{
						"n": 17,
						"h": 397,
						"w": 266
					},
					{
						"n": 19,
						"h": 283,
						"w": 241
					},
					{
						"n": 20,
						"h": 141,
						"w": 258
					}
				],
				"ball": {
					"n": 0,
					"h": 360,
					"w": 498,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1270,
			"minute": 61,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 707
					},
					{
						"n": 2,
						"h": 378,
						"w": 467
					},
					{
						"n": 14,
						"h": 270,
						"w": 509
					},
					{
						"n": 13,
						"h": 184,
						"w": 524
					},
					{
						"n": 5,
						"h": 71,
						"w": 474
					},
					{
						"n": 6,
						"h": 387,
						"w": 375
					},
					{
						"n": 18,
						"h": 293,
						"w": 410
					},
					{
						"n": 15,
						"h": 195,
						"w": 350
					},
					{
						"n": 17,
						"h": 53,
						"w": 352
					},
					{
						"n": 20,
						"h": 298,
						"w": 254
					},
					{
						"n": 19,
						"h": 157,
						"w": 237
					}
				],
				"away": [
					{
						"n": 1,
						"h": 205,
						"w": 647
					},
					{
						"n": 13,
						"h": 397,
						"w": 404
					},
					{
						"n": 3,
						"h": 275,
						"w": 549
					},
					{
						"n": 14,
						"h": 166,
						"w": 540
					},
					{
						"n": 5,
						"h": 110,
						"w": 547
					},
					{
						"n": 6,
						"h": 230,
						"w": 431
					},
					{
						"n": 7,
						"h": 195,
						"w": 389
					},
					{
						"n": 18,
						"h": 63,
						"w": 372
					},
					{
						"n": 17,
						"h": 405,
						"w": 305
					},
					{
						"n": 19,
						"h": 280,
						"w": 281
					},
					{
						"n": 20,
						"h": 102,
						"w": 266
					}
				],
				"ball": {
					"n": 0,
					"h": 378,
					"w": 467,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1271,
			"minute": 61,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 709
					},
					{
						"n": 2,
						"h": 375,
						"w": 450
					},
					{
						"n": 14,
						"h": 265,
						"w": 491
					},
					{
						"n": 13,
						"h": 181,
						"w": 484
					},
					{
						"n": 5,
						"h": 63,
						"w": 435
					},
					{
						"n": 6,
						"h": 389,
						"w": 335
					},
					{
						"n": 18,
						"h": 291,
						"w": 373
					},
					{
						"n": 15,
						"h": 211,
						"w": 314
					},
					{
						"n": 17,
						"h": 48,
						"w": 312
					},
					{
						"n": 20,
						"h": 283,
						"w": 217
					},
					{
						"n": 19,
						"h": 178,
						"w": 203
					}
				],
				"away": [
					{
						"n": 1,
						"h": 205,
						"w": 643
					},
					{
						"n": 13,
						"h": 402,
						"w": 444
					},
					{
						"n": 3,
						"h": 254,
						"w": 548
					},
					{
						"n": 14,
						"h": 184,
						"w": 545
					},
					{
						"n": 5,
						"h": 110,
						"w": 554
					},
					{
						"n": 6,
						"h": 207,
						"w": 463
					},
					{
						"n": 7,
						"h": 204,
						"w": 428
					},
					{
						"n": 18,
						"h": 61,
						"w": 421
					},
					{
						"n": 17,
						"h": 410,
						"w": 324
					},
					{
						"n": 19,
						"h": 281,
						"w": 321
					},
					{
						"n": 20,
						"h": 75,
						"w": 290
					}
				],
				"ball": {
					"n": 0,
					"h": 375,
					"w": 450,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1272,
			"minute": 61,
			"messages": [
				{
					"owner": 1,
					"mes": "Т.Эверс[02](Галвэй Юнайтед) делает передачу К.Колману[06](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 707
					},
					{
						"n": 2,
						"h": 378,
						"w": 441
					},
					{
						"n": 14,
						"h": 272,
						"w": 489
					},
					{
						"n": 13,
						"h": 177,
						"w": 472
					},
					{
						"n": 5,
						"h": 63,
						"w": 437
					},
					{
						"n": 6,
						"h": 424,
						"w": 352
					},
					{
						"n": 18,
						"h": 294,
						"w": 395
					},
					{
						"n": 15,
						"h": 193,
						"w": 285
					},
					{
						"n": 17,
						"h": 52,
						"w": 273
					},
					{
						"n": 20,
						"h": 300,
						"w": 183
					},
					{
						"n": 19,
						"h": 172,
						"w": 184
					}
				],
				"away": [
					{
						"n": 1,
						"h": 205,
						"w": 643
					},
					{
						"n": 13,
						"h": 398,
						"w": 483
					},
					{
						"n": 3,
						"h": 261,
						"w": 584
					},
					{
						"n": 14,
						"h": 169,
						"w": 581
					},
					{
						"n": 5,
						"h": 84,
						"w": 559
					},
					{
						"n": 6,
						"h": 234,
						"w": 491
					},
					{
						"n": 7,
						"h": 205,
						"w": 443
					},
					{
						"n": 18,
						"h": 45,
						"w": 386
					},
					{
						"n": 17,
						"h": 407,
						"w": 363
					},
					{
						"n": 19,
						"h": 276,
						"w": 359
					},
					{
						"n": 20,
						"h": 107,
						"w": 312
					}
				],
				"ball": {
					"n": 0,
					"h": 424,
					"w": 352,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 1273,
			"minute": 61,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 703
					},
					{
						"n": 2,
						"h": 385,
						"w": 401
					},
					{
						"n": 14,
						"h": 275,
						"w": 458
					},
					{
						"n": 13,
						"h": 173,
						"w": 461
					},
					{
						"n": 5,
						"h": 74,
						"w": 399
					},
					{
						"n": 6,
						"h": 406,
						"w": 321
					},
					{
						"n": 18,
						"h": 307,
						"w": 357
					},
					{
						"n": 15,
						"h": 217,
						"w": 269
					},
					{
						"n": 17,
						"h": 47,
						"w": 234
					},
					{
						"n": 20,
						"h": 292,
						"w": 169
					},
					{
						"n": 19,
						"h": 169,
						"w": 184
					}
				],
				"away": [
					{
						"n": 1,
						"h": 205,
						"w": 644
					},
					{
						"n": 13,
						"h": 403,
						"w": 522
					},
					{
						"n": 3,
						"h": 262,
						"w": 612
					},
					{
						"n": 14,
						"h": 168,
						"w": 621
					},
					{
						"n": 5,
						"h": 82,
						"w": 599
					},
					{
						"n": 6,
						"h": 206,
						"w": 520
					},
					{
						"n": 7,
						"h": 214,
						"w": 482
					},
					{
						"n": 18,
						"h": 62,
						"w": 415
					},
					{
						"n": 17,
						"h": 402,
						"w": 403
					},
					{
						"n": 19,
						"h": 286,
						"w": 398
					},
					{
						"n": 20,
						"h": 125,
						"w": 348
					}
				],
				"ball": {
					"n": 0,
					"h": 406,
					"w": 321,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1274,
			"minute": 61,
			"messages": [
				{
					"owner": 1,
					"mes": "Киэн Колман[06](Галвэй Юнайтед) пасует на Т.Дэвлина[20](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 706
					},
					{
						"n": 2,
						"h": 380,
						"w": 380
					},
					{
						"n": 14,
						"h": 278,
						"w": 412
					},
					{
						"n": 13,
						"h": 168,
						"w": 405
					},
					{
						"n": 5,
						"h": 67,
						"w": 364
					},
					{
						"n": 6,
						"h": 407,
						"w": 309
					},
					{
						"n": 18,
						"h": 300,
						"w": 301
					},
					{
						"n": 15,
						"h": 192,
						"w": 218
					},
					{
						"n": 17,
						"h": 38,
						"w": 177
					},
					{
						"n": 20,
						"h": 349,
						"w": 197
					},
					{
						"n": 19,
						"h": 160,
						"w": 165
					}
				],
				"away": [
					{
						"n": 1,
						"h": 216,
						"w": 700
					},
					{
						"n": 13,
						"h": 406,
						"w": 579
					},
					{
						"n": 3,
						"h": 283,
						"w": 607
					},
					{
						"n": 14,
						"h": 225,
						"w": 619
					},
					{
						"n": 5,
						"h": 108,
						"w": 548
					},
					{
						"n": 6,
						"h": 254,
						"w": 550
					},
					{
						"n": 7,
						"h": 260,
						"w": 505
					},
					{
						"n": 18,
						"h": 44,
						"w": 447
					},
					{
						"n": 17,
						"h": 426,
						"w": 455
					},
					{
						"n": 19,
						"h": 279,
						"w": 416
					},
					{
						"n": 20,
						"h": 140,
						"w": 402
					}
				],
				"ball": {
					"n": 0,
					"h": 349,
					"w": 197,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 57
		},
		{
			"num": 1275,
			"minute": 61,
			"messages": [
				{
					"owner": 1,
					"mes": "Т.Дэвлин[20](Галвэй Юнайтед) пасует К.Келли[15](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 705
					},
					{
						"n": 2,
						"h": 380,
						"w": 380
					},
					{
						"n": 14,
						"h": 278,
						"w": 421
					},
					{
						"n": 13,
						"h": 164,
						"w": 405
					},
					{
						"n": 5,
						"h": 70,
						"w": 374
					},
					{
						"n": 6,
						"h": 407,
						"w": 268
					},
					{
						"n": 18,
						"h": 291,
						"w": 261
					},
					{
						"n": 15,
						"h": 243,
						"w": 205
					},
					{
						"n": 17,
						"h": 43,
						"w": 147
					},
					{
						"n": 20,
						"h": 348,
						"w": 196
					},
					{
						"n": 19,
						"h": 175,
						"w": 182
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 659
					},
					{
						"n": 13,
						"h": 391,
						"w": 598
					},
					{
						"n": 3,
						"h": 275,
						"w": 608
					},
					{
						"n": 14,
						"h": 220,
						"w": 633
					},
					{
						"n": 5,
						"h": 93,
						"w": 586
					},
					{
						"n": 6,
						"h": 279,
						"w": 561
					},
					{
						"n": 7,
						"h": 224,
						"w": 524
					},
					{
						"n": 18,
						"h": 44,
						"w": 488
					},
					{
						"n": 17,
						"h": 430,
						"w": 463
					},
					{
						"n": 19,
						"h": 291,
						"w": 430
					},
					{
						"n": 20,
						"h": 171,
						"w": 430
					}
				],
				"ball": {
					"n": 0,
					"h": 243,
					"w": 205,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 41
		},
		{
			"num": 1276,
			"minute": 61,
			"messages": [
				{
					"owner": 1,
					"mes": "Кевин Келли[15](Галвэй Юнайтед) пасует направо..."
				},
				{
					"owner": 1,
					"mes": "Вацлав Сланина[34](Опава) показывает хорошее позиционное чутье и перехватывает мяч!..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 708
					},
					{
						"n": 2,
						"h": 381,
						"w": 381
					},
					{
						"n": 14,
						"h": 270,
						"w": 420
					},
					{
						"n": 13,
						"h": 172,
						"w": 410
					},
					{
						"n": 5,
						"h": 64,
						"w": 378
					},
					{
						"n": 6,
						"h": 407,
						"w": 226
					},
					{
						"n": 18,
						"h": 274,
						"w": 285
					},
					{
						"n": 15,
						"h": 232,
						"w": 201,
						"m": 590
					},
					{
						"n": 17,
						"h": 48,
						"w": 147
					},
					{
						"n": 20,
						"h": 319,
						"w": 166
					},
					{
						"n": 19,
						"h": 197,
						"w": 153,
						"m": 600
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 689
					},
					{
						"n": 13,
						"h": 386,
						"w": 598
					},
					{
						"n": 3,
						"h": 261,
						"w": 603
					},
					{
						"n": 14,
						"h": 234,
						"w": 594
					},
					{
						"n": 5,
						"h": 132,
						"w": 602
					},
					{
						"n": 6,
						"h": 249,
						"w": 584
					},
					{
						"n": 7,
						"h": 213,
						"w": 534
					},
					{
						"n": 18,
						"h": 44,
						"w": 530
					},
					{
						"n": 17,
						"h": 431,
						"w": 463
					},
					{
						"n": 19,
						"h": 284,
						"w": 420
					},
					{
						"n": 20,
						"h": 175,
						"w": 424
					}
				],
				"ball": {
					"n": 0,
					"h": 216,
					"w": 126,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 42
		},
		{
			"num": 1277,
			"minute": 62,
			"possession": 43,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 704
					},
					{
						"n": 2,
						"h": 353,
						"w": 409,
						"m": 660
					},
					{
						"n": 14,
						"h": 273,
						"w": 419,
						"f": 99
					},
					{
						"n": 13,
						"h": 175,
						"w": 436,
						"f": 99
					},
					{
						"n": 5,
						"h": 97,
						"w": 401
					},
					{
						"n": 6,
						"h": 406,
						"w": 266,
						"f": 82
					},
					{
						"n": 18,
						"h": 280,
						"w": 325,
						"f": 99
					},
					{
						"n": 15,
						"h": 215,
						"w": 237,
						"f": 99
					},
					{
						"n": 17,
						"h": 48,
						"w": 187
					},
					{
						"n": 20,
						"h": 290,
						"w": 194,
						"f": 93
					},
					{
						"n": 19,
						"h": 234,
						"w": 168,
						"f": 99
					}
				],
				"away": [
					{
						"n": 1,
						"h": 229,
						"w": 703
					},
					{
						"n": 13,
						"h": 391,
						"w": 558
					},
					{
						"n": 3,
						"h": 272,
						"w": 627
					},
					{
						"n": 14,
						"h": 209,
						"w": 569,
						"m": 660
					},
					{
						"n": 5,
						"h": 95,
						"w": 617,
						"f": 82
					},
					{
						"n": 6,
						"h": 253,
						"w": 545,
						"f": 82
					},
					{
						"n": 7,
						"h": 212,
						"w": 494
					},
					{
						"n": 18,
						"h": 45,
						"w": 490,
						"f": 97
					},
					{
						"n": 17,
						"h": 420,
						"w": 425,
						"f": 92
					},
					{
						"n": 19,
						"h": 288,
						"w": 380
					},
					{
						"n": 20,
						"h": 160,
						"w": 387,
						"f": 97
					}
				],
				"ball": {
					"n": 0,
					"h": 241,
					"w": 151,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1278,
			"minute": 62,
			"messages": [
				{
					"owner": 2,
					"mes": "Пас левее на О.Дюмона[26](Опава)..."
				},
				{
					"owner": 2,
					"mes": "Оливье Дюмон[26](Опава) сбрасывает мяч себе на ход..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 701
					},
					{
						"n": 2,
						"h": 342,
						"w": 427
					},
					{
						"n": 14,
						"h": 273,
						"w": 440
					},
					{
						"n": 13,
						"h": 178,
						"w": 452
					},
					{
						"n": 5,
						"h": 106,
						"w": 420
					},
					{
						"n": 6,
						"h": 406,
						"w": 287
					},
					{
						"n": 18,
						"h": 284,
						"w": 345
					},
					{
						"n": 15,
						"h": 209,
						"w": 257
					},
					{
						"n": 17,
						"h": 45,
						"w": 208
					},
					{
						"n": 20,
						"h": 277,
						"w": 210
					},
					{
						"n": 19,
						"h": 213,
						"w": 171
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 710
					},
					{
						"n": 13,
						"h": 391,
						"w": 537
					},
					{
						"n": 3,
						"h": 278,
						"w": 607
					},
					{
						"n": 14,
						"h": 202,
						"w": 576
					},
					{
						"n": 5,
						"h": 81,
						"w": 601
					},
					{
						"n": 6,
						"h": 246,
						"w": 550
					},
					{
						"n": 7,
						"h": 217,
						"w": 473
					},
					{
						"n": 18,
						"h": 45,
						"w": 469
					},
					{
						"n": 17,
						"h": 417,
						"w": 404
					},
					{
						"n": 19,
						"h": 288,
						"w": 359
					},
					{
						"n": 20,
						"h": 160,
						"w": 366
					}
				],
				"ball": {
					"n": 0,
					"h": 204,
					"w": 170,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 21
		},
		{
			"num": 1279,
			"minute": 62,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 702
					},
					{
						"n": 2,
						"h": 330,
						"w": 453
					},
					{
						"n": 14,
						"h": 279,
						"w": 466
					},
					{
						"n": 13,
						"h": 172,
						"w": 440
					},
					{
						"n": 5,
						"h": 119,
						"w": 458
					},
					{
						"n": 6,
						"h": 416,
						"w": 326
					},
					{
						"n": 18,
						"h": 296,
						"w": 383
					},
					{
						"n": 15,
						"h": 201,
						"w": 296
					},
					{
						"n": 17,
						"h": 48,
						"w": 248
					},
					{
						"n": 20,
						"h": 284,
						"w": 250
					},
					{
						"n": 19,
						"h": 197,
						"w": 208
					}
				],
				"away": [
					{
						"n": 1,
						"h": 223,
						"w": 703
					},
					{
						"n": 13,
						"h": 393,
						"w": 497
					},
					{
						"n": 3,
						"h": 285,
						"w": 612
					},
					{
						"n": 14,
						"h": 168,
						"w": 597
					},
					{
						"n": 5,
						"h": 76,
						"w": 601
					},
					{
						"n": 6,
						"h": 260,
						"w": 517
					},
					{
						"n": 7,
						"h": 220,
						"w": 434
					},
					{
						"n": 18,
						"h": 45,
						"w": 429
					},
					{
						"n": 17,
						"h": 414,
						"w": 364
					},
					{
						"n": 19,
						"h": 290,
						"w": 319
					},
					{
						"n": 20,
						"h": 155,
						"w": 326
					}
				],
				"ball": {
					"n": 0,
					"h": 190,
					"w": 203,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1280,
			"minute": 62,
			"messages": [
				{
					"owner": 2,
					"mes": "О.Дюмон[26](Опава) делает передачу К.Ласаку[21](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 708
					},
					{
						"n": 2,
						"h": 330,
						"w": 468
					},
					{
						"n": 14,
						"h": 284,
						"w": 466
					},
					{
						"n": 13,
						"h": 175,
						"w": 442
					},
					{
						"n": 5,
						"h": 81,
						"w": 429
					},
					{
						"n": 6,
						"h": 396,
						"w": 377
					},
					{
						"n": 18,
						"h": 305,
						"w": 391
					},
					{
						"n": 15,
						"h": 225,
						"w": 346
					},
					{
						"n": 17,
						"h": 39,
						"w": 302
					},
					{
						"n": 20,
						"h": 288,
						"w": 305
					},
					{
						"n": 19,
						"h": 160,
						"w": 248
					}
				],
				"away": [
					{
						"n": 1,
						"h": 247,
						"w": 682
					},
					{
						"n": 13,
						"h": 419,
						"w": 449
					},
					{
						"n": 3,
						"h": 283,
						"w": 596
					},
					{
						"n": 14,
						"h": 174,
						"w": 614
					},
					{
						"n": 5,
						"h": 59,
						"w": 590
					},
					{
						"n": 6,
						"h": 250,
						"w": 517
					},
					{
						"n": 7,
						"h": 228,
						"w": 385
					},
					{
						"n": 18,
						"h": 50,
						"w": 374
					},
					{
						"n": 17,
						"h": 399,
						"w": 311
					},
					{
						"n": 19,
						"h": 292,
						"w": 276
					},
					{
						"n": 20,
						"h": 149,
						"w": 294
					}
				],
				"ball": {
					"n": 0,
					"h": 203,
					"w": 38,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 55
		},
		{
			"num": 1281,
			"minute": 62,
			"messages": [
				{
					"owner": 2,
					"mes": "Крыштоф Ласак[21](Опава) играет направо..."
				},
				{
					"owner": 2,
					"mes": "Вацлав Сланина[34](Опава) сбрасывает мяч себе на ход..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 707
					},
					{
						"n": 2,
						"h": 330,
						"w": 464
					},
					{
						"n": 14,
						"h": 272,
						"w": 454
					},
					{
						"n": 13,
						"h": 175,
						"w": 467
					},
					{
						"n": 5,
						"h": 75,
						"w": 440
					},
					{
						"n": 6,
						"h": 394,
						"w": 402
					},
					{
						"n": 18,
						"h": 280,
						"w": 387
					},
					{
						"n": 15,
						"h": 202,
						"w": 355
					},
					{
						"n": 17,
						"h": 42,
						"w": 327
					},
					{
						"n": 20,
						"h": 291,
						"w": 295
					},
					{
						"n": 19,
						"h": 145,
						"w": 269
					}
				],
				"away": [
					{
						"n": 1,
						"h": 239,
						"w": 689
					},
					{
						"n": 13,
						"h": 402,
						"w": 440
					},
					{
						"n": 3,
						"h": 270,
						"w": 605
					},
					{
						"n": 14,
						"h": 194,
						"w": 629
					},
					{
						"n": 5,
						"h": 64,
						"w": 610
					},
					{
						"n": 6,
						"h": 226,
						"w": 509
					},
					{
						"n": 7,
						"h": 222,
						"w": 406
					},
					{
						"n": 18,
						"h": 53,
						"w": 349
					},
					{
						"n": 17,
						"h": 405,
						"w": 300
					},
					{
						"n": 19,
						"h": 301,
						"w": 298
					},
					{
						"n": 20,
						"h": 167,
						"w": 280
					}
				],
				"ball": {
					"n": 0,
					"h": 256,
					"w": 91,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 25
		},
		{
			"num": 1282,
			"minute": 62,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 709
					},
					{
						"n": 2,
						"h": 330,
						"w": 454
					},
					{
						"n": 14,
						"h": 269,
						"w": 460
					},
					{
						"n": 13,
						"h": 166,
						"w": 458
					},
					{
						"n": 5,
						"h": 90,
						"w": 424
					},
					{
						"n": 6,
						"h": 386,
						"w": 441
					},
					{
						"n": 18,
						"h": 257,
						"w": 376
					},
					{
						"n": 15,
						"h": 210,
						"w": 361
					},
					{
						"n": 17,
						"h": 48,
						"w": 360
					},
					{
						"n": 20,
						"h": 308,
						"w": 280
					},
					{
						"n": 19,
						"h": 169,
						"w": 297
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 701
					},
					{
						"n": 13,
						"h": 399,
						"w": 449
					},
					{
						"n": 3,
						"h": 274,
						"w": 580
					},
					{
						"n": 14,
						"h": 186,
						"w": 595
					},
					{
						"n": 5,
						"h": 67,
						"w": 582
					},
					{
						"n": 6,
						"h": 211,
						"w": 500
					},
					{
						"n": 7,
						"h": 234,
						"w": 370
					},
					{
						"n": 18,
						"h": 50,
						"w": 309
					},
					{
						"n": 17,
						"h": 369,
						"w": 316
					},
					{
						"n": 19,
						"h": 296,
						"w": 287
					},
					{
						"n": 20,
						"h": 169,
						"w": 283
					}
				],
				"ball": {
					"n": 0,
					"h": 264,
					"w": 125,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1283,
			"minute": 62,
			"messages": [
				{
					"owner": 2,
					"mes": "Вацлав Сланина[34](Опава) отдает на Н.Мансура[23](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 704
					},
					{
						"n": 2,
						"h": 330,
						"w": 457
					},
					{
						"n": 14,
						"h": 271,
						"w": 468
					},
					{
						"n": 13,
						"h": 174,
						"w": 478
					},
					{
						"n": 5,
						"h": 117,
						"w": 460
					},
					{
						"n": 6,
						"h": 394,
						"w": 435
					},
					{
						"n": 18,
						"h": 237,
						"w": 372
					},
					{
						"n": 15,
						"h": 192,
						"w": 352
					},
					{
						"n": 17,
						"h": 28,
						"w": 360
					},
					{
						"n": 20,
						"h": 288,
						"w": 301
					},
					{
						"n": 19,
						"h": 140,
						"w": 280
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 709
					},
					{
						"n": 13,
						"h": 413,
						"w": 459
					},
					{
						"n": 3,
						"h": 270,
						"w": 535
					},
					{
						"n": 14,
						"h": 176,
						"w": 594
					},
					{
						"n": 5,
						"h": 76,
						"w": 605
					},
					{
						"n": 6,
						"h": 234,
						"w": 461
					},
					{
						"n": 7,
						"h": 211,
						"w": 382
					},
					{
						"n": 18,
						"h": 32,
						"w": 300
					},
					{
						"n": 17,
						"h": 337,
						"w": 349
					},
					{
						"n": 19,
						"h": 293,
						"w": 296
					},
					{
						"n": 20,
						"h": 169,
						"w": 279
					}
				],
				"ball": {
					"n": 0,
					"h": 180,
					"w": 185,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 45
		},
		{
			"num": 1284,
			"minute": 62,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 707
					},
					{
						"n": 2,
						"h": 330,
						"w": 468
					},
					{
						"n": 14,
						"h": 259,
						"w": 464
					},
					{
						"n": 13,
						"h": 173,
						"w": 471
					},
					{
						"n": 5,
						"h": 120,
						"w": 450
					},
					{
						"n": 6,
						"h": 394,
						"w": 435
					},
					{
						"n": 18,
						"h": 236,
						"w": 389
					},
					{
						"n": 15,
						"h": 157,
						"w": 371
					},
					{
						"n": 17,
						"h": 30,
						"w": 360
					},
					{
						"n": 20,
						"h": 313,
						"w": 280
					},
					{
						"n": 19,
						"h": 166,
						"w": 250
					}
				],
				"away": [
					{
						"n": 1,
						"h": 228,
						"w": 703
					},
					{
						"n": 13,
						"h": 417,
						"w": 456
					},
					{
						"n": 3,
						"h": 274,
						"w": 500
					},
					{
						"n": 14,
						"h": 180,
						"w": 565
					},
					{
						"n": 5,
						"h": 68,
						"w": 566
					},
					{
						"n": 6,
						"h": 210,
						"w": 493
					},
					{
						"n": 7,
						"h": 211,
						"w": 400
					},
					{
						"n": 18,
						"h": 39,
						"w": 300
					},
					{
						"n": 17,
						"h": 298,
						"w": 359
					},
					{
						"n": 19,
						"h": 293,
						"w": 298
					},
					{
						"n": 20,
						"h": 178,
						"w": 286
					}
				],
				"ball": {
					"n": 0,
					"h": 176,
					"w": 220,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1285,
			"minute": 62,
			"messages": [
				{
					"owner": 2,
					"mes": "Н.Мансур[23](Опава) делает передачу О.Дюмону[26](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 705
					},
					{
						"n": 2,
						"h": 330,
						"w": 465
					},
					{
						"n": 14,
						"h": 277,
						"w": 467
					},
					{
						"n": 13,
						"h": 176,
						"w": 452
					},
					{
						"n": 5,
						"h": 120,
						"w": 467
					},
					{
						"n": 6,
						"h": 394,
						"w": 408
					},
					{
						"n": 18,
						"h": 257,
						"w": 372
					},
					{
						"n": 15,
						"h": 131,
						"w": 378
					},
					{
						"n": 17,
						"h": 57,
						"w": 360
					},
					{
						"n": 20,
						"h": 309,
						"w": 280
					},
					{
						"n": 19,
						"h": 152,
						"w": 273
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 688
					},
					{
						"n": 13,
						"h": 414,
						"w": 483
					},
					{
						"n": 3,
						"h": 278,
						"w": 510
					},
					{
						"n": 14,
						"h": 168,
						"w": 556
					},
					{
						"n": 5,
						"h": 49,
						"w": 556
					},
					{
						"n": 6,
						"h": 220,
						"w": 507
					},
					{
						"n": 7,
						"h": 225,
						"w": 418
					},
					{
						"n": 18,
						"h": 42,
						"w": 327
					},
					{
						"n": 17,
						"h": 325,
						"w": 357
					},
					{
						"n": 19,
						"h": 290,
						"w": 280
					},
					{
						"n": 20,
						"h": 163,
						"w": 280
					}
				],
				"ball": {
					"n": 0,
					"h": 230,
					"w": 213,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 27
		},
		{
			"num": 1286,
			"minute": 62,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 701
					},
					{
						"n": 2,
						"h": 330,
						"w": 476
					},
					{
						"n": 14,
						"h": 282,
						"w": 482
					},
					{
						"n": 13,
						"h": 171,
						"w": 470
					},
					{
						"n": 5,
						"h": 120,
						"w": 488
					},
					{
						"n": 6,
						"h": 394,
						"w": 388
					},
					{
						"n": 18,
						"h": 274,
						"w": 394
					},
					{
						"n": 15,
						"h": 170,
						"w": 371
					},
					{
						"n": 17,
						"h": 77,
						"w": 394
					},
					{
						"n": 20,
						"h": 270,
						"w": 270
					},
					{
						"n": 19,
						"h": 165,
						"w": 311
					}
				],
				"away": [
					{
						"n": 1,
						"h": 221,
						"w": 668
					},
					{
						"n": 13,
						"h": 413,
						"w": 474
					},
					{
						"n": 3,
						"h": 295,
						"w": 546
					},
					{
						"n": 14,
						"h": 166,
						"w": 546
					},
					{
						"n": 5,
						"h": 39,
						"w": 546
					},
					{
						"n": 6,
						"h": 205,
						"w": 476
					},
					{
						"n": 7,
						"h": 231,
						"w": 403
					},
					{
						"n": 18,
						"h": 44,
						"w": 367
					},
					{
						"n": 17,
						"h": 364,
						"w": 345
					},
					{
						"n": 19,
						"h": 290,
						"w": 260
					},
					{
						"n": 20,
						"h": 157,
						"w": 260
					}
				],
				"ball": {
					"n": 0,
					"h": 245,
					"w": 244,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1287,
			"minute": 62,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 702
					},
					{
						"n": 2,
						"h": 330,
						"w": 516
					},
					{
						"n": 14,
						"h": 277,
						"w": 511
					},
					{
						"n": 13,
						"h": 186,
						"w": 508
					},
					{
						"n": 5,
						"h": 120,
						"w": 518
					},
					{
						"n": 6,
						"h": 394,
						"w": 428
					},
					{
						"n": 18,
						"h": 271,
						"w": 434
					},
					{
						"n": 15,
						"h": 207,
						"w": 386
					},
					{
						"n": 17,
						"h": 59,
						"w": 401
					},
					{
						"n": 20,
						"h": 246,
						"w": 300
					},
					{
						"n": 19,
						"h": 159,
						"w": 350
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 648
					},
					{
						"n": 13,
						"h": 416,
						"w": 434
					},
					{
						"n": 3,
						"h": 268,
						"w": 561
					},
					{
						"n": 14,
						"h": 183,
						"w": 549
					},
					{
						"n": 5,
						"h": 66,
						"w": 551
					},
					{
						"n": 6,
						"h": 204,
						"w": 440
					},
					{
						"n": 7,
						"h": 226,
						"w": 363
					},
					{
						"n": 18,
						"h": 43,
						"w": 327
					},
					{
						"n": 17,
						"h": 351,
						"w": 308
					},
					{
						"n": 19,
						"h": 309,
						"w": 224
					},
					{
						"n": 20,
						"h": 139,
						"w": 224
					}
				],
				"ball": {
					"n": 0,
					"h": 246,
					"w": 280,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1288,
			"minute": 62,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 702
					},
					{
						"n": 2,
						"h": 330,
						"w": 537
					},
					{
						"n": 14,
						"h": 277,
						"w": 537
					},
					{
						"n": 13,
						"h": 174,
						"w": 546
					},
					{
						"n": 5,
						"h": 120,
						"w": 546
					},
					{
						"n": 6,
						"h": 394,
						"w": 468
					},
					{
						"n": 18,
						"h": 272,
						"w": 455
					},
					{
						"n": 15,
						"h": 186,
						"w": 420
					},
					{
						"n": 17,
						"h": 57,
						"w": 361
					},
					{
						"n": 20,
						"h": 227,
						"w": 293
					},
					{
						"n": 19,
						"h": 191,
						"w": 326
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 632
					},
					{
						"n": 13,
						"h": 414,
						"w": 394
					},
					{
						"n": 3,
						"h": 285,
						"w": 528
					},
					{
						"n": 14,
						"h": 172,
						"w": 527
					},
					{
						"n": 5,
						"h": 60,
						"w": 513
					},
					{
						"n": 6,
						"h": 238,
						"w": 431
					},
					{
						"n": 7,
						"h": 207,
						"w": 398
					},
					{
						"n": 18,
						"h": 44,
						"w": 287
					},
					{
						"n": 17,
						"h": 360,
						"w": 269
					},
					{
						"n": 19,
						"h": 289,
						"w": 247
					},
					{
						"n": 20,
						"h": 159,
						"w": 215
					}
				],
				"ball": {
					"n": 0,
					"h": 212,
					"w": 289,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1289,
			"minute": 62,
			"messages": [
				{
					"owner": 2,
					"mes": "Оливье Дюмон[26](Опава) переправляет мяч на ход М.Манолову[27](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 703
					},
					{
						"n": 2,
						"h": 330,
						"w": 561
					},
					{
						"n": 14,
						"h": 266,
						"w": 569
					},
					{
						"n": 13,
						"h": 179,
						"w": 582
					},
					{
						"n": 5,
						"h": 93,
						"w": 518
					},
					{
						"n": 6,
						"h": 394,
						"w": 507
					},
					{
						"n": 18,
						"h": 264,
						"w": 494
					},
					{
						"n": 15,
						"h": 217,
						"w": 397
					},
					{
						"n": 17,
						"h": 53,
						"w": 400
					},
					{
						"n": 20,
						"h": 244,
						"w": 329
					},
					{
						"n": 19,
						"h": 212,
						"w": 309
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 617
					},
					{
						"n": 13,
						"h": 411,
						"w": 355
					},
					{
						"n": 3,
						"h": 282,
						"w": 496
					},
					{
						"n": 14,
						"h": 178,
						"w": 492
					},
					{
						"n": 5,
						"h": 63,
						"w": 507
					},
					{
						"n": 6,
						"h": 238,
						"w": 431,
						"m": 670
					},
					{
						"n": 7,
						"h": 212,
						"w": 358
					},
					{
						"n": 18,
						"h": 49,
						"w": 248
					},
					{
						"n": 17,
						"h": 379,
						"w": 235
					},
					{
						"n": 19,
						"h": 287,
						"w": 208
					},
					{
						"n": 20,
						"h": 166,
						"w": 182
					}
				],
				"ball": {
					"n": 0,
					"h": 238,
					"w": 362,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 1290,
			"minute": 62,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 709
					},
					{
						"n": 2,
						"h": 330,
						"w": 601
					},
					{
						"n": 14,
						"h": 273,
						"w": 604
					},
					{
						"n": 13,
						"h": 181,
						"w": 593
					},
					{
						"n": 5,
						"h": 84,
						"w": 541
					},
					{
						"n": 6,
						"h": 394,
						"w": 546
					},
					{
						"n": 18,
						"h": 262,
						"w": 524
					},
					{
						"n": 15,
						"h": 205,
						"w": 379
					},
					{
						"n": 17,
						"h": 49,
						"w": 440
					},
					{
						"n": 20,
						"h": 232,
						"w": 343
					},
					{
						"n": 19,
						"h": 195,
						"w": 345
					}
				],
				"away": [
					{
						"n": 1,
						"h": 228,
						"w": 600
					},
					{
						"n": 13,
						"h": 415,
						"w": 316
					},
					{
						"n": 3,
						"h": 287,
						"w": 468
					},
					{
						"n": 14,
						"h": 182,
						"w": 466
					},
					{
						"n": 5,
						"h": 67,
						"w": 467
					},
					{
						"n": 6,
						"h": 218,
						"w": 397
					},
					{
						"n": 7,
						"h": 247,
						"w": 360
					},
					{
						"n": 18,
						"h": 43,
						"w": 209
					},
					{
						"n": 17,
						"h": 396,
						"w": 199
					},
					{
						"n": 19,
						"h": 281,
						"w": 178
					},
					{
						"n": 20,
						"h": 161,
						"w": 142
					}
				],
				"ball": {
					"n": 0,
					"h": 203,
					"w": 360,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1291,
			"minute": 62,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 706
					},
					{
						"n": 2,
						"h": 330,
						"w": 612
					},
					{
						"n": 14,
						"h": 278,
						"w": 611
					},
					{
						"n": 13,
						"h": 184,
						"w": 606
					},
					{
						"n": 5,
						"h": 79,
						"w": 581
					},
					{
						"n": 6,
						"h": 394,
						"w": 586
					},
					{
						"n": 18,
						"h": 257,
						"w": 510
					},
					{
						"n": 15,
						"h": 170,
						"w": 389
					},
					{
						"n": 17,
						"h": 56,
						"w": 477
					},
					{
						"n": 20,
						"h": 229,
						"w": 383
					},
					{
						"n": 19,
						"h": 176,
						"w": 380
					}
				],
				"away": [
					{
						"n": 1,
						"h": 228,
						"w": 595
					},
					{
						"n": 13,
						"h": 401,
						"w": 278
					},
					{
						"n": 3,
						"h": 278,
						"w": 441
					},
					{
						"n": 14,
						"h": 174,
						"w": 427
					},
					{
						"n": 5,
						"h": 73,
						"w": 455
					},
					{
						"n": 6,
						"h": 221,
						"w": 357
					},
					{
						"n": 7,
						"h": 281,
						"w": 351
					},
					{
						"n": 18,
						"h": 43,
						"w": 169
					},
					{
						"n": 17,
						"h": 401,
						"w": 159
					},
					{
						"n": 19,
						"h": 296,
						"w": 141
					},
					{
						"n": 20,
						"h": 141,
						"w": 129
					}
				],
				"ball": {
					"n": 0,
					"h": 169,
					"w": 369,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1292,
			"minute": 62,
			"messages": [
				{
					"owner": 2,
					"mes": "Коротким пасом М.Манолов[27](Опава) отправляет мяч на В.Сланину[34](Опава)..."
				},
				{
					"owner": 2,
					"mes": "Вацлав Сланина[34](Опава) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 710
					},
					{
						"n": 2,
						"h": 330,
						"w": 607
					},
					{
						"n": 14,
						"h": 266,
						"w": 605
					},
					{
						"n": 13,
						"h": 170,
						"w": 608
					},
					{
						"n": 5,
						"h": 87,
						"w": 590
					},
					{
						"n": 6,
						"h": 391,
						"w": 595
					},
					{
						"n": 18,
						"h": 264,
						"w": 540
					},
					{
						"n": 15,
						"h": 173,
						"w": 434
					},
					{
						"n": 17,
						"h": 59,
						"w": 495
					},
					{
						"n": 20,
						"h": 244,
						"w": 363
					},
					{
						"n": 19,
						"h": 169,
						"w": 389
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 602
					},
					{
						"n": 13,
						"h": 391,
						"w": 260
					},
					{
						"n": 3,
						"h": 277,
						"w": 440
					},
					{
						"n": 14,
						"h": 199,
						"w": 387
					},
					{
						"n": 5,
						"h": 57,
						"w": 414
					},
					{
						"n": 6,
						"h": 209,
						"w": 316
					},
					{
						"n": 7,
						"h": 281,
						"w": 351
					},
					{
						"n": 18,
						"h": 44,
						"w": 150
					},
					{
						"n": 17,
						"h": 393,
						"w": 150
					},
					{
						"n": 19,
						"h": 299,
						"w": 148
					},
					{
						"n": 20,
						"h": 164,
						"w": 146
					}
				],
				"ball": {
					"n": 0,
					"h": 251,
					"w": 333,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 45
		},
		{
			"num": 1293,
			"minute": 62,
			"messages": [
				{
					"owner": 2,
					"mes": "Справа открывается Томаш Прохазка[25](Опава)... Передача..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 708
					},
					{
						"n": 2,
						"h": 354,
						"w": 640
					},
					{
						"n": 14,
						"h": 259,
						"w": 605
					},
					{
						"n": 13,
						"h": 187,
						"w": 592
					},
					{
						"n": 5,
						"h": 120,
						"w": 603
					},
					{
						"n": 6,
						"h": 388,
						"w": 593
					},
					{
						"n": 18,
						"h": 293,
						"w": 525
					},
					{
						"n": 15,
						"h": 195,
						"w": 480
					},
					{
						"n": 17,
						"h": 56,
						"w": 469
					},
					{
						"n": 20,
						"h": 259,
						"w": 412
					},
					{
						"n": 19,
						"h": 198,
						"w": 431
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 599
					},
					{
						"n": 13,
						"h": 419,
						"w": 266
					},
					{
						"n": 3,
						"h": 275,
						"w": 427
					},
					{
						"n": 14,
						"h": 191,
						"w": 393
					},
					{
						"n": 5,
						"h": 47,
						"w": 366
					},
					{
						"n": 6,
						"h": 188,
						"w": 319
					},
					{
						"n": 7,
						"h": 252,
						"w": 309
					},
					{
						"n": 18,
						"h": 47,
						"w": 144
					},
					{
						"n": 17,
						"h": 346,
						"w": 131
					},
					{
						"n": 19,
						"h": 273,
						"w": 131
					},
					{
						"n": 20,
						"h": 172,
						"w": 126
					}
				],
				"ball": {
					"n": 0,
					"h": 403,
					"w": 354,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 51
		},
		{
			"num": 1294,
			"minute": 62,
			"messages": [
				{
					"owner": 2,
					"mes": "Т.Прохазка[25](Опава) пасует Н.Томпсону[38](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 235,
						"w": 709
					},
					{
						"n": 2,
						"h": 366,
						"w": 651
					},
					{
						"n": 14,
						"h": 272,
						"w": 651
					},
					{
						"n": 13,
						"h": 175,
						"w": 639
					},
					{
						"n": 5,
						"h": 130,
						"w": 650
					},
					{
						"n": 6,
						"h": 394,
						"w": 545
					},
					{
						"n": 18,
						"h": 289,
						"w": 573
					},
					{
						"n": 15,
						"h": 180,
						"w": 525
					},
					{
						"n": 17,
						"h": 56,
						"w": 517
					},
					{
						"n": 20,
						"h": 244,
						"w": 449
					},
					{
						"n": 19,
						"h": 219,
						"w": 475
					}
				],
				"away": [
					{
						"n": 1,
						"h": 228,
						"w": 601
					},
					{
						"n": 13,
						"h": 397,
						"w": 223
					},
					{
						"n": 3,
						"h": 269,
						"w": 427
					},
					{
						"n": 14,
						"h": 161,
						"w": 429
					},
					{
						"n": 5,
						"h": 56,
						"w": 381
					},
					{
						"n": 6,
						"h": 206,
						"w": 291
					},
					{
						"n": 7,
						"h": 231,
						"w": 265
					},
					{
						"n": 18,
						"h": 56,
						"w": 175
					},
					{
						"n": 17,
						"h": 324,
						"w": 88
					},
					{
						"n": 19,
						"h": 293,
						"w": 92
					},
					{
						"n": 20,
						"h": 165,
						"w": 87
					}
				],
				"ball": {
					"n": 0,
					"h": 394,
					"w": 545,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 48
		},
		{
			"num": 1295,
			"minute": 62,
			"messages": [
				{
					"owner": 2,
					"mes": "Ньялл Томпсон[38](Опава) пытается выиграть позицию..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 235,
						"w": 709
					},
					{
						"n": 2,
						"h": 357,
						"w": 646
					},
					{
						"n": 14,
						"h": 279,
						"w": 655
					},
					{
						"n": 13,
						"h": 176,
						"w": 649
					},
					{
						"n": 5,
						"h": 133,
						"w": 653
					},
					{
						"n": 6,
						"h": 393,
						"w": 548
					},
					{
						"n": 18,
						"h": 286,
						"w": 575
					},
					{
						"n": 15,
						"h": 186,
						"w": 533
					},
					{
						"n": 17,
						"h": 56,
						"w": 527
					},
					{
						"n": 20,
						"h": 249,
						"w": 440
					},
					{
						"n": 19,
						"h": 222,
						"w": 484
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 600
					},
					{
						"n": 13,
						"h": 397,
						"w": 213
					},
					{
						"n": 3,
						"h": 269,
						"w": 427
					},
					{
						"n": 14,
						"h": 164,
						"w": 419
					},
					{
						"n": 5,
						"h": 61,
						"w": 390
					},
					{
						"n": 6,
						"h": 201,
						"w": 300
					},
					{
						"n": 7,
						"h": 228,
						"w": 256
					},
					{
						"n": 18,
						"h": 56,
						"w": 185
					},
					{
						"n": 17,
						"h": 325,
						"w": 78
					},
					{
						"n": 19,
						"h": 286,
						"w": 99
					},
					{
						"n": 20,
						"h": 155,
						"w": 88
					}
				],
				"ball": {
					"n": 0,
					"h": 394,
					"w": 535,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 10
		},
		{
			"num": 1296,
			"minute": 62,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 237,
						"w": 710
					},
					{
						"n": 2,
						"h": 360,
						"w": 665
					},
					{
						"n": 14,
						"h": 288,
						"w": 672
					},
					{
						"n": 13,
						"h": 203,
						"w": 675
					},
					{
						"n": 5,
						"h": 143,
						"w": 645
					},
					{
						"n": 6,
						"h": 407,
						"w": 572
					},
					{
						"n": 18,
						"h": 286,
						"w": 612
					},
					{
						"n": 15,
						"h": 197,
						"w": 572
					},
					{
						"n": 17,
						"h": 56,
						"w": 567
					},
					{
						"n": 20,
						"h": 247,
						"w": 480
					},
					{
						"n": 19,
						"h": 204,
						"w": 448
					}
				],
				"away": [
					{
						"n": 1,
						"h": 223,
						"w": 600
					},
					{
						"n": 13,
						"h": 400,
						"w": 174
					},
					{
						"n": 3,
						"h": 270,
						"w": 426
					},
					{
						"n": 14,
						"h": 170,
						"w": 423
					},
					{
						"n": 5,
						"h": 71,
						"w": 395
					},
					{
						"n": 6,
						"h": 203,
						"w": 260
					},
					{
						"n": 7,
						"h": 221,
						"w": 217
					},
					{
						"n": 18,
						"h": 27,
						"w": 163
					},
					{
						"n": 17,
						"h": 315,
						"w": 81
					},
					{
						"n": 19,
						"h": 249,
						"w": 83
					},
					{
						"n": 20,
						"h": 144,
						"w": 56
					}
				],
				"ball": {
					"n": 0,
					"h": 423,
					"w": 557,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1297,
			"minute": 62,
			"messages": [
				{
					"owner": 2,
					"mes": "Н.Томпсон[38](Опава) делает навес в штрафную..."
				},
				{
					"owner": 2,
					"mes": "Самуэль Кари Фридйонссон[05](Галвэй Юнайтед) головой выбивает мяч из штрафной..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 706
					},
					{
						"n": 2,
						"h": 365,
						"w": 679
					},
					{
						"n": 14,
						"h": 293,
						"w": 688
					},
					{
						"n": 13,
						"h": 203,
						"w": 694
					},
					{
						"n": 5,
						"h": 135,
						"w": 687
					},
					{
						"n": 6,
						"h": 411,
						"w": 575
					},
					{
						"n": 18,
						"h": 283,
						"w": 647
					},
					{
						"n": 15,
						"h": 214,
						"w": 570
					},
					{
						"n": 17,
						"h": 56,
						"w": 616
					},
					{
						"n": 20,
						"h": 259,
						"w": 437
					},
					{
						"n": 19,
						"h": 178,
						"w": 407
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 601
					},
					{
						"n": 13,
						"h": 406,
						"w": 125
					},
					{
						"n": 3,
						"h": 275,
						"w": 420
					},
					{
						"n": 14,
						"h": 167,
						"w": 405
					},
					{
						"n": 5,
						"h": 57,
						"w": 420
					},
					{
						"n": 6,
						"h": 191,
						"w": 303
					},
					{
						"n": 7,
						"h": 226,
						"w": 168
					},
					{
						"n": 18,
						"h": 23,
						"w": 160
					},
					{
						"n": 17,
						"h": 307,
						"w": 33
					},
					{
						"n": 19,
						"h": 256,
						"w": 40
					},
					{
						"n": 20,
						"h": 156,
						"w": 34
					}
				],
				"ball": {
					"n": 0,
					"h": 135,
					"w": 687,
					"z": 1,
					"r": 2,
					"p": 4,
					"x": 1
				}
			},
			"interval": 49
		},
		{
			"num": 1298,
			"minute": 62,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 706
					},
					{
						"n": 2,
						"h": 348,
						"w": 674
					},
					{
						"n": 14,
						"h": 284,
						"w": 672
					},
					{
						"n": 13,
						"h": 188,
						"w": 704
					},
					{
						"n": 5,
						"h": 147,
						"w": 696,
						"m": 670
					},
					{
						"n": 6,
						"h": 403,
						"w": 591
					},
					{
						"n": 18,
						"h": 289,
						"w": 630
					},
					{
						"n": 15,
						"h": 200,
						"w": 564
					},
					{
						"n": 17,
						"h": 56,
						"w": 612
					},
					{
						"n": 20,
						"h": 275,
						"w": 430
					},
					{
						"n": 19,
						"h": 173,
						"w": 419
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 600
					},
					{
						"n": 13,
						"h": 408,
						"w": 143
					},
					{
						"n": 3,
						"h": 282,
						"w": 425
					},
					{
						"n": 14,
						"h": 176,
						"w": 410
					},
					{
						"n": 5,
						"h": 57,
						"w": 420
					},
					{
						"n": 6,
						"h": 192,
						"w": 318
					},
					{
						"n": 7,
						"h": 215,
						"w": 182
					},
					{
						"n": 18,
						"h": 30,
						"w": 144
					},
					{
						"n": 17,
						"h": 296,
						"w": 22
					},
					{
						"n": 19,
						"h": 265,
						"w": 56
					},
					{
						"n": 20,
						"h": 154,
						"w": 52
					}
				],
				"ball": {
					"n": 0,
					"h": 172,
					"w": 750,
					"z": 1,
					"r": 0,
					"p": 1,
					"x": 0
				}
			},
			"interval": 18
		},
		{
			"num": 1299,
			"minute": 63,
			"possession": 43,
			"messages": [
				{
					"owner": 2,
					"mes": "Боковой судья показывает на угловой..."
				}
			],
			"C": {
				"team": 2
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 710
					},
					{
						"n": 2,
						"h": 260,
						"w": 690
					},
					{
						"n": 14,
						"h": 240,
						"w": 670
					},
					{
						"n": 13,
						"h": 230,
						"w": 658
					},
					{
						"n": 5,
						"h": 215,
						"w": 682
					},
					{
						"n": 6,
						"h": 370,
						"w": 320
					},
					{
						"n": 18,
						"h": 190,
						"w": 670
					},
					{
						"n": 15,
						"h": 150,
						"w": 465
					},
					{
						"n": 17,
						"h": 80,
						"w": 320,
						"f": 93
					},
					{
						"n": 20,
						"h": 205,
						"w": 670
					},
					{
						"n": 19,
						"h": 225,
						"w": 610
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 680
					},
					{
						"n": 13,
						"h": 300,
						"w": 440,
						"f": 93
					},
					{
						"n": 3,
						"h": 235,
						"w": 48
					},
					{
						"n": 14,
						"h": 225,
						"w": 120
					},
					{
						"n": 5,
						"h": 220,
						"w": 72
					},
					{
						"n": 6,
						"h": 225,
						"w": 270
					},
					{
						"n": 7,
						"h": 150,
						"w": 440,
						"f": 84,
						"c": 2
					},
					{
						"n": 18,
						"h": 458,
						"w": -16
					},
					{
						"n": 17,
						"h": 260,
						"w": 60
					},
					{
						"n": 19,
						"h": 210,
						"w": 60
					},
					{
						"n": 20,
						"h": 190,
						"w": 40
					}
				],
				"ball": {
					"n": 0,
					"h": 0,
					"w": 720,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 100
		},
		{
			"num": 1300,
			"minute": 63,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 700
					},
					{
						"n": 2,
						"h": 259,
						"w": 684
					},
					{
						"n": 14,
						"h": 243,
						"w": 669
					},
					{
						"n": 13,
						"h": 236,
						"w": 665
					},
					{
						"n": 5,
						"h": 212,
						"w": 677
					},
					{
						"n": 6,
						"h": 363,
						"w": 321
					},
					{
						"n": 18,
						"h": 189,
						"w": 665
					},
					{
						"n": 15,
						"h": 143,
						"w": 462
					},
					{
						"n": 17,
						"h": 84,
						"w": 326
					},
					{
						"n": 20,
						"h": 207,
						"w": 667
					},
					{
						"n": 19,
						"h": 225,
						"w": 609
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 676
					},
					{
						"n": 13,
						"h": 300,
						"w": 441
					},
					{
						"n": 3,
						"h": 240,
						"w": 48
					},
					{
						"n": 14,
						"h": 223,
						"w": 127
					},
					{
						"n": 5,
						"h": 221,
						"w": 74
					},
					{
						"n": 6,
						"h": 230,
						"w": 272
					},
					{
						"n": 7,
						"h": 148,
						"w": 445
					},
					{
						"n": 18,
						"h": 450,
						"w": 0
					},
					{
						"n": 17,
						"h": 257,
						"w": 59
					},
					{
						"n": 19,
						"h": 208,
						"w": 66
					},
					{
						"n": 20,
						"h": 192,
						"w": 46
					}
				],
				"ball": {
					"n": 0,
					"h": 0,
					"w": 720,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 15
		},
		{
			"num": 1301,
			"minute": 63,
			"messages": [
				{
					"owner": 2,
					"mes": "Корнер подает Ньялл Томпсон[38](Опава)..."
				},
				{
					"owner": 2,
					"mes": "Н.Томпсон[38](Опава) закручивает мяч в штрафную..."
				},
				{
					"owner": 2,
					"mes": "Тимо Эверс[02](Галвэй Юнайтед) головой разряжает обстановку в штрафной..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 713
					},
					{
						"n": 2,
						"h": 262,
						"w": 672
					},
					{
						"n": 14,
						"h": 257,
						"w": 650
					},
					{
						"n": 13,
						"h": 242,
						"w": 653
					},
					{
						"n": 5,
						"h": 212,
						"w": 685
					},
					{
						"n": 6,
						"h": 368,
						"w": 366
					},
					{
						"n": 18,
						"h": 182,
						"w": 662
					},
					{
						"n": 15,
						"h": 152,
						"w": 507
					},
					{
						"n": 17,
						"h": 79,
						"w": 371
					},
					{
						"n": 20,
						"h": 213,
						"w": 660
					},
					{
						"n": 19,
						"h": 222,
						"w": 563
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 653
					},
					{
						"n": 13,
						"h": 289,
						"w": 396
					},
					{
						"n": 3,
						"h": 248,
						"w": 38
					},
					{
						"n": 14,
						"h": 257,
						"w": 146
					},
					{
						"n": 5,
						"h": 218,
						"w": 71
					},
					{
						"n": 6,
						"h": 232,
						"w": 237
					},
					{
						"n": 7,
						"h": 175,
						"w": 410
					},
					{
						"n": 18,
						"h": 448,
						"w": 5
					},
					{
						"n": 17,
						"h": 262,
						"w": 63
					},
					{
						"n": 19,
						"h": 201,
						"w": 78
					},
					{
						"n": 20,
						"h": 184,
						"w": 56
					}
				],
				"ball": {
					"n": 0,
					"h": 262,
					"w": 672,
					"z": 1,
					"r": 2,
					"p": 4,
					"x": 1
				}
			},
			"interval": 46
		},
		{
			"num": 1302,
			"minute": 63,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 705
					},
					{
						"n": 2,
						"h": 262,
						"w": 672
					},
					{
						"n": 14,
						"h": 268,
						"w": 658
					},
					{
						"n": 13,
						"h": 215,
						"w": 643
					},
					{
						"n": 5,
						"h": 181,
						"w": 675
					},
					{
						"n": 6,
						"h": 375,
						"w": 398
					},
					{
						"n": 18,
						"h": 182,
						"w": 657
					},
					{
						"n": 15,
						"h": 173,
						"w": 530
					},
					{
						"n": 17,
						"h": 76,
						"w": 403
					},
					{
						"n": 20,
						"h": 224,
						"w": 630
					},
					{
						"n": 19,
						"h": 241,
						"w": 528
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 635
					},
					{
						"n": 13,
						"h": 273,
						"w": 370
					},
					{
						"n": 3,
						"h": 251,
						"w": 70
					},
					{
						"n": 14,
						"h": 236,
						"w": 169
					},
					{
						"n": 5,
						"h": 203,
						"w": 100
					},
					{
						"n": 6,
						"h": 217,
						"w": 265
					},
					{
						"n": 7,
						"h": 181,
						"w": 387
					},
					{
						"n": 18,
						"h": 444,
						"w": 36
					},
					{
						"n": 17,
						"h": 272,
						"w": 80
					},
					{
						"n": 19,
						"h": 230,
						"w": 93
					},
					{
						"n": 20,
						"h": 164,
						"w": 81
					}
				],
				"ball": {
					"n": 0,
					"h": 256,
					"w": 545,
					"z": 1,
					"r": 0,
					"p": 1,
					"x": 0
				}
			},
			"interval": 32
		},
		{
			"num": 1303,
			"minute": 63,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 708
					},
					{
						"n": 2,
						"h": 271,
						"w": 669
					},
					{
						"n": 14,
						"h": 278,
						"w": 655
					},
					{
						"n": 13,
						"h": 211,
						"w": 643
					},
					{
						"n": 5,
						"h": 171,
						"w": 676
					},
					{
						"n": 6,
						"h": 377,
						"w": 407
					},
					{
						"n": 18,
						"h": 175,
						"w": 653
					},
					{
						"n": 15,
						"h": 179,
						"w": 539
					},
					{
						"n": 17,
						"h": 75,
						"w": 413
					},
					{
						"n": 20,
						"h": 233,
						"w": 627
					},
					{
						"n": 19,
						"h": 248,
						"w": 517
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 625
					},
					{
						"n": 13,
						"h": 271,
						"w": 380
					},
					{
						"n": 3,
						"h": 251,
						"w": 80
					},
					{
						"n": 14,
						"h": 233,
						"w": 179
					},
					{
						"n": 5,
						"h": 199,
						"w": 109
					},
					{
						"n": 6,
						"h": 214,
						"w": 257
					},
					{
						"n": 7,
						"h": 172,
						"w": 383
					},
					{
						"n": 18,
						"h": 435,
						"w": 39
					},
					{
						"n": 17,
						"h": 281,
						"w": 85
					},
					{
						"n": 19,
						"h": 240,
						"w": 94
					},
					{
						"n": 20,
						"h": 154,
						"w": 80
					}
				],
				"ball": {
					"n": 0,
					"h": 254,
					"w": 506,
					"z": 0,
					"r": 0,
					"p": 1,
					"x": 0
				}
			},
			"interval": 10
		},
		{
			"num": 1304,
			"minute": 63,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 702
					},
					{
						"n": 2,
						"h": 285,
						"w": 656
					},
					{
						"n": 14,
						"h": 278,
						"w": 655
					},
					{
						"n": 13,
						"h": 211,
						"w": 643
					},
					{
						"n": 5,
						"h": 157,
						"w": 663
					},
					{
						"n": 6,
						"h": 384,
						"w": 389
					},
					{
						"n": 18,
						"h": 182,
						"w": 636
					},
					{
						"n": 15,
						"h": 176,
						"w": 520
					},
					{
						"n": 17,
						"h": 69,
						"w": 395
					},
					{
						"n": 20,
						"h": 238,
						"w": 609
					},
					{
						"n": 19,
						"h": 253,
						"w": 494
					}
				],
				"away": [
					{
						"n": 1,
						"h": 223,
						"w": 644
					},
					{
						"n": 13,
						"h": 274,
						"w": 379
					},
					{
						"n": 3,
						"h": 252,
						"w": 99
					},
					{
						"n": 14,
						"h": 228,
						"w": 197
					},
					{
						"n": 5,
						"h": 190,
						"w": 128
					},
					{
						"n": 6,
						"h": 204,
						"w": 240
					},
					{
						"n": 7,
						"h": 171,
						"w": 383
					},
					{
						"n": 18,
						"h": 419,
						"w": 50
					},
					{
						"n": 17,
						"h": 287,
						"w": 102
					},
					{
						"n": 19,
						"h": 245,
						"w": 112
					},
					{
						"n": 20,
						"h": 168,
						"w": 93
					}
				],
				"ball": {
					"n": 0,
					"h": 253,
					"w": 494,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 19
		},
		{
			"num": 1305,
			"minute": 63,
			"messages": [
				{
					"owner": 1,
					"mes": "Байрон О`Горман[19](Галвэй Юнайтед) устремляется к свободному мячу и подхватывает его..."
				},
				{
					"owner": 1,
					"mes": "Байрон О`Горман[19](Галвэй Юнайтед) переводит мяч на свободное место направо..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 702
					},
					{
						"n": 2,
						"h": 321,
						"w": 608
					},
					{
						"n": 14,
						"h": 282,
						"w": 615
					},
					{
						"n": 13,
						"h": 182,
						"w": 615
					},
					{
						"n": 5,
						"h": 122,
						"w": 614
					},
					{
						"n": 6,
						"h": 401,
						"w": 349
					},
					{
						"n": 18,
						"h": 196,
						"w": 577
					},
					{
						"n": 15,
						"h": 175,
						"w": 480
					},
					{
						"n": 17,
						"h": 67,
						"w": 343
					},
					{
						"n": 20,
						"h": 275,
						"w": 574
					},
					{
						"n": 19,
						"h": 279,
						"w": 466,
						"m": 610
					}
				],
				"away": [
					{
						"n": 1,
						"h": 245,
						"w": 650
					},
					{
						"n": 13,
						"h": 333,
						"w": 414
					},
					{
						"n": 3,
						"h": 256,
						"w": 159
					},
					{
						"n": 14,
						"h": 222,
						"w": 257
					},
					{
						"n": 5,
						"h": 177,
						"w": 187
					},
					{
						"n": 6,
						"h": 213,
						"w": 300
					},
					{
						"n": 7,
						"h": 180,
						"w": 447
					},
					{
						"n": 18,
						"h": 381,
						"w": 96
					},
					{
						"n": 17,
						"h": 305,
						"w": 160
					},
					{
						"n": 19,
						"h": 254,
						"w": 163
					},
					{
						"n": 20,
						"h": 174,
						"w": 152
					}
				],
				"ball": {
					"n": 0,
					"h": 67,
					"w": 343,
					"z": 1,
					"r": 2,
					"p": 0,
					"x": 0
				}
			},
			"interval": 60
		},
		{
			"num": 1306,
			"minute": 63,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 705
					},
					{
						"n": 2,
						"h": 338,
						"w": 575
					},
					{
						"n": 14,
						"h": 283,
						"w": 578
					},
					{
						"n": 13,
						"h": 180,
						"w": 578
					},
					{
						"n": 5,
						"h": 109,
						"w": 580
					},
					{
						"n": 6,
						"h": 407,
						"w": 309
					},
					{
						"n": 18,
						"h": 206,
						"w": 542
					},
					{
						"n": 15,
						"h": 157,
						"w": 440
					},
					{
						"n": 17,
						"h": 33,
						"w": 323
					},
					{
						"n": 20,
						"h": 276,
						"w": 537
					},
					{
						"n": 19,
						"h": 281,
						"w": 426
					}
				],
				"away": [
					{
						"n": 1,
						"h": 245,
						"w": 650
					},
					{
						"n": 13,
						"h": 375,
						"w": 416
					},
					{
						"n": 3,
						"h": 256,
						"w": 196
					},
					{
						"n": 14,
						"h": 217,
						"w": 293
					},
					{
						"n": 5,
						"h": 169,
						"w": 223
					},
					{
						"n": 6,
						"h": 216,
						"w": 336
					},
					{
						"n": 7,
						"h": 184,
						"w": 486
					},
					{
						"n": 18,
						"h": 362,
						"w": 128
					},
					{
						"n": 17,
						"h": 316,
						"w": 195
					},
					{
						"n": 19,
						"h": 244,
						"w": 198
					},
					{
						"n": 20,
						"h": 174,
						"w": 189
					}
				],
				"ball": {
					"n": 0,
					"h": 33,
					"w": 323,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 37
		},
		{
			"num": 1307,
			"minute": 63,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 704
					},
					{
						"n": 2,
						"h": 352,
						"w": 538
					},
					{
						"n": 14,
						"h": 271,
						"w": 540
					},
					{
						"n": 13,
						"h": 183,
						"w": 538
					},
					{
						"n": 5,
						"h": 94,
						"w": 542
					},
					{
						"n": 6,
						"h": 364,
						"w": 281
					},
					{
						"n": 18,
						"h": 209,
						"w": 502
					},
					{
						"n": 15,
						"h": 169,
						"w": 400
					},
					{
						"n": 17,
						"h": 33,
						"w": 279
					},
					{
						"n": 20,
						"h": 272,
						"w": 497
					},
					{
						"n": 19,
						"h": 267,
						"w": 386
					}
				],
				"away": [
					{
						"n": 1,
						"h": 245,
						"w": 644
					},
					{
						"n": 13,
						"h": 392,
						"w": 458
					},
					{
						"n": 3,
						"h": 260,
						"w": 236
					},
					{
						"n": 14,
						"h": 209,
						"w": 332
					},
					{
						"n": 5,
						"h": 159,
						"w": 262
					},
					{
						"n": 6,
						"h": 224,
						"w": 376
					},
					{
						"n": 7,
						"h": 204,
						"w": 524
					},
					{
						"n": 18,
						"h": 339,
						"w": 161
					},
					{
						"n": 17,
						"h": 335,
						"w": 231
					},
					{
						"n": 19,
						"h": 241,
						"w": 238
					},
					{
						"n": 20,
						"h": 177,
						"w": 229
					}
				],
				"ball": {
					"n": 0,
					"h": 33,
					"w": 279,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1308,
			"minute": 63,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 708
					},
					{
						"n": 2,
						"h": 367,
						"w": 500
					},
					{
						"n": 14,
						"h": 278,
						"w": 510
					},
					{
						"n": 13,
						"h": 179,
						"w": 498
					},
					{
						"n": 5,
						"h": 87,
						"w": 503
					},
					{
						"n": 6,
						"h": 385,
						"w": 234
					},
					{
						"n": 18,
						"h": 212,
						"w": 462
					},
					{
						"n": 15,
						"h": 164,
						"w": 349
					},
					{
						"n": 17,
						"h": 49,
						"w": 243
					},
					{
						"n": 20,
						"h": 275,
						"w": 457
					},
					{
						"n": 19,
						"h": 262,
						"w": 337
					}
				],
				"away": [
					{
						"n": 1,
						"h": 245,
						"w": 643
					},
					{
						"n": 13,
						"h": 376,
						"w": 497
					},
					{
						"n": 3,
						"h": 263,
						"w": 276
					},
					{
						"n": 14,
						"h": 202,
						"w": 372
					},
					{
						"n": 5,
						"h": 149,
						"w": 300
					},
					{
						"n": 6,
						"h": 228,
						"w": 415
					},
					{
						"n": 7,
						"h": 210,
						"w": 558
					},
					{
						"n": 18,
						"h": 316,
						"w": 193
					},
					{
						"n": 17,
						"h": 348,
						"w": 268
					},
					{
						"n": 19,
						"h": 238,
						"w": 278
					},
					{
						"n": 20,
						"h": 176,
						"w": 269
					}
				],
				"ball": {
					"n": 0,
					"h": 49,
					"w": 243,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1309,
			"minute": 63,
			"messages": [
				{
					"owner": 1,
					"mes": "М.Раум[17](Галвэй Юнайтед) пытается пройти К.Удре[33](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 703
					},
					{
						"n": 2,
						"h": 374,
						"w": 478
					},
					{
						"n": 14,
						"h": 280,
						"w": 487
					},
					{
						"n": 13,
						"h": 175,
						"w": 476
					},
					{
						"n": 5,
						"h": 83,
						"w": 480
					},
					{
						"n": 6,
						"h": 365,
						"w": 213
					},
					{
						"n": 18,
						"h": 214,
						"w": 439
					},
					{
						"n": 15,
						"h": 158,
						"w": 320
					},
					{
						"n": 17,
						"h": 49,
						"w": 222
					},
					{
						"n": 20,
						"h": 271,
						"w": 434
					},
					{
						"n": 19,
						"h": 280,
						"w": 314
					}
				],
				"away": [
					{
						"n": 1,
						"h": 245,
						"w": 641
					},
					{
						"n": 13,
						"h": 401,
						"w": 498
					},
					{
						"n": 3,
						"h": 264,
						"w": 299
					},
					{
						"n": 14,
						"h": 198,
						"w": 395
					},
					{
						"n": 5,
						"h": 143,
						"w": 323
					},
					{
						"n": 6,
						"h": 232,
						"w": 438
					},
					{
						"n": 7,
						"h": 207,
						"w": 566
					},
					{
						"n": 18,
						"h": 304,
						"w": 213
					},
					{
						"n": 17,
						"h": 357,
						"w": 290
					},
					{
						"n": 19,
						"h": 236,
						"w": 301
					},
					{
						"n": 20,
						"h": 178,
						"w": 292
					}
				],
				"ball": {
					"n": 0,
					"h": 49,
					"w": 222,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 23
		},
		{
			"num": 1310,
			"minute": 63,
			"messages": [
				{
					"owner": 1,
					"mes": "Маттиас Раум[17](Галвэй Юнайтед) пробрасывает мяч вперед мимо К.Удре[33](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 706
					},
					{
						"n": 2,
						"h": 378,
						"w": 459
					},
					{
						"n": 14,
						"h": 267,
						"w": 472
					},
					{
						"n": 13,
						"h": 185,
						"w": 460
					},
					{
						"n": 5,
						"h": 78,
						"w": 461
					},
					{
						"n": 6,
						"h": 351,
						"w": 192
					},
					{
						"n": 18,
						"h": 214,
						"w": 419
					},
					{
						"n": 15,
						"h": 164,
						"w": 295
					},
					{
						"n": 17,
						"h": 49,
						"w": 194
					},
					{
						"n": 20,
						"h": 263,
						"w": 416
					},
					{
						"n": 19,
						"h": 279,
						"w": 290
					}
				],
				"away": [
					{
						"n": 1,
						"h": 240,
						"w": 662
					},
					{
						"n": 13,
						"h": 401,
						"w": 510
					},
					{
						"n": 3,
						"h": 264,
						"w": 319
					},
					{
						"n": 14,
						"h": 195,
						"w": 414
					},
					{
						"n": 5,
						"h": 138,
						"w": 342
					},
					{
						"n": 6,
						"h": 228,
						"w": 458
					},
					{
						"n": 7,
						"h": 227,
						"w": 574
					},
					{
						"n": 18,
						"h": 293,
						"w": 230
					},
					{
						"n": 17,
						"h": 363,
						"w": 309
					},
					{
						"n": 19,
						"h": 236,
						"w": 321
					},
					{
						"n": 20,
						"h": 183,
						"w": 311
					}
				],
				"ball": {
					"n": 0,
					"h": 49,
					"w": 166,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 20
		},
		{
			"num": 1311,
			"minute": 63,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 707
					},
					{
						"n": 2,
						"h": 383,
						"w": 439
					},
					{
						"n": 14,
						"h": 267,
						"w": 458
					},
					{
						"n": 13,
						"h": 184,
						"w": 457
					},
					{
						"n": 5,
						"h": 74,
						"w": 441
					},
					{
						"n": 6,
						"h": 341,
						"w": 169
					},
					{
						"n": 18,
						"h": 212,
						"w": 399
					},
					{
						"n": 15,
						"h": 169,
						"w": 270
					},
					{
						"n": 17,
						"h": 49,
						"w": 166
					},
					{
						"n": 20,
						"h": 270,
						"w": 397
					},
					{
						"n": 19,
						"h": 279,
						"w": 265
					}
				],
				"away": [
					{
						"n": 1,
						"h": 236,
						"w": 683
					},
					{
						"n": 13,
						"h": 401,
						"w": 522
					},
					{
						"n": 3,
						"h": 265,
						"w": 339
					},
					{
						"n": 14,
						"h": 191,
						"w": 434
					},
					{
						"n": 5,
						"h": 133,
						"w": 362
					},
					{
						"n": 6,
						"h": 225,
						"w": 477
					},
					{
						"n": 7,
						"h": 247,
						"w": 583
					},
					{
						"n": 18,
						"h": 282,
						"w": 247
					},
					{
						"n": 17,
						"h": 368,
						"w": 328
					},
					{
						"n": 19,
						"h": 238,
						"w": 341
					},
					{
						"n": 20,
						"h": 181,
						"w": 331
					}
				],
				"ball": {
					"n": 0,
					"h": 49,
					"w": 166,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 20
		},
		{
			"num": 1312,
			"minute": 63,
			"messages": [
				{
					"owner": 1,
					"mes": "Пас налево К.Колману[06](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 710
					},
					{
						"n": 2,
						"h": 373,
						"w": 383
					},
					{
						"n": 14,
						"h": 282,
						"w": 434
					},
					{
						"n": 13,
						"h": 164,
						"w": 451
					},
					{
						"n": 5,
						"h": 61,
						"w": 385
					},
					{
						"n": 6,
						"h": 406,
						"w": 201
					},
					{
						"n": 18,
						"h": 262,
						"w": 325
					},
					{
						"n": 15,
						"h": 160,
						"w": 230
					},
					{
						"n": 17,
						"h": 85,
						"w": 154,
						"m": 610
					},
					{
						"n": 20,
						"h": 283,
						"w": 362
					},
					{
						"n": 19,
						"h": 274,
						"w": 225
					}
				],
				"away": [
					{
						"n": 1,
						"h": 205,
						"w": 643
					},
					{
						"n": 13,
						"h": 340,
						"w": 583,
						"m": 610
					},
					{
						"n": 3,
						"h": 269,
						"w": 429
					},
					{
						"n": 14,
						"h": 187,
						"w": 484
					},
					{
						"n": 5,
						"h": 112,
						"w": 449
					},
					{
						"n": 6,
						"h": 140,
						"w": 546
					},
					{
						"n": 7,
						"h": 214,
						"w": 594
					},
					{
						"n": 18,
						"h": 236,
						"w": 324
					},
					{
						"n": 17,
						"h": 399,
						"w": 413
					},
					{
						"n": 19,
						"h": 287,
						"w": 417
					},
					{
						"n": 20,
						"h": 188,
						"w": 415
					}
				],
				"ball": {
					"n": 0,
					"h": 406,
					"w": 201,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 90
		},
		{
			"num": 1313,
			"minute": 63,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 705
					},
					{
						"n": 2,
						"h": 389,
						"w": 356
					},
					{
						"n": 14,
						"h": 281,
						"w": 397
					},
					{
						"n": 13,
						"h": 175,
						"w": 412
					},
					{
						"n": 5,
						"h": 76,
						"w": 359
					},
					{
						"n": 6,
						"h": 406,
						"w": 156
					},
					{
						"n": 18,
						"h": 282,
						"w": 284
					},
					{
						"n": 15,
						"h": 180,
						"w": 183
					},
					{
						"n": 17,
						"h": 117,
						"w": 116
					},
					{
						"n": 20,
						"h": 303,
						"w": 357
					},
					{
						"n": 19,
						"h": 267,
						"w": 181
					}
				],
				"away": [
					{
						"n": 1,
						"h": 214,
						"w": 685
					},
					{
						"n": 13,
						"h": 317,
						"w": 605
					},
					{
						"n": 3,
						"h": 270,
						"w": 469
					},
					{
						"n": 14,
						"h": 186,
						"w": 524
					},
					{
						"n": 5,
						"h": 102,
						"w": 493
					},
					{
						"n": 6,
						"h": 102,
						"w": 576
					},
					{
						"n": 7,
						"h": 178,
						"w": 618
					},
					{
						"n": 18,
						"h": 217,
						"w": 359
					},
					{
						"n": 17,
						"h": 414,
						"w": 450
					},
					{
						"n": 19,
						"h": 278,
						"w": 416
					},
					{
						"n": 20,
						"h": 156,
						"w": 390
					}
				],
				"ball": {
					"n": 0,
					"h": 406,
					"w": 156,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1314,
			"minute": 63,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 710
					},
					{
						"n": 2,
						"h": 372,
						"w": 349
					},
					{
						"n": 14,
						"h": 266,
						"w": 395
					},
					{
						"n": 13,
						"h": 185,
						"w": 403
					},
					{
						"n": 5,
						"h": 77,
						"w": 355
					},
					{
						"n": 6,
						"h": 406,
						"w": 111
					},
					{
						"n": 18,
						"h": 286,
						"w": 238
					},
					{
						"n": 15,
						"h": 173,
						"w": 132
					},
					{
						"n": 17,
						"h": 123,
						"w": 76
					},
					{
						"n": 20,
						"h": 277,
						"w": 327
					},
					{
						"n": 19,
						"h": 272,
						"w": 136
					}
				],
				"away": [
					{
						"n": 1,
						"h": 212,
						"w": 712
					},
					{
						"n": 13,
						"h": 316,
						"w": 651
					},
					{
						"n": 3,
						"h": 273,
						"w": 509
					},
					{
						"n": 14,
						"h": 184,
						"w": 563
					},
					{
						"n": 5,
						"h": 94,
						"w": 538
					},
					{
						"n": 6,
						"h": 69,
						"w": 611
					},
					{
						"n": 7,
						"h": 175,
						"w": 661
					},
					{
						"n": 18,
						"h": 201,
						"w": 396
					},
					{
						"n": 17,
						"h": 423,
						"w": 489
					},
					{
						"n": 19,
						"h": 294,
						"w": 418
					},
					{
						"n": 20,
						"h": 173,
						"w": 413
					}
				],
				"ball": {
					"n": 0,
					"h": 406,
					"w": 111,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1315,
			"minute": 63,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 704
					},
					{
						"n": 2,
						"h": 372,
						"w": 352
					},
					{
						"n": 14,
						"h": 285,
						"w": 410
					},
					{
						"n": 13,
						"h": 187,
						"w": 398
					},
					{
						"n": 5,
						"h": 58,
						"w": 358
					},
					{
						"n": 6,
						"h": 369,
						"w": 126
					},
					{
						"n": 18,
						"h": 301,
						"w": 201
					},
					{
						"n": 15,
						"h": 212,
						"w": 127
					},
					{
						"n": 17,
						"h": 113,
						"w": 84
					},
					{
						"n": 20,
						"h": 280,
						"w": 287
					},
					{
						"n": 19,
						"h": 244,
						"w": 108
					}
				],
				"away": [
					{
						"n": 1,
						"h": 214,
						"w": 710
					},
					{
						"n": 13,
						"h": 319,
						"w": 647
					},
					{
						"n": 3,
						"h": 272,
						"w": 549
					},
					{
						"n": 14,
						"h": 192,
						"w": 603
					},
					{
						"n": 5,
						"h": 91,
						"w": 584
					},
					{
						"n": 6,
						"h": 76,
						"w": 613
					},
					{
						"n": 7,
						"h": 180,
						"w": 660
					},
					{
						"n": 18,
						"h": 183,
						"w": 431
					},
					{
						"n": 17,
						"h": 419,
						"w": 506
					},
					{
						"n": 19,
						"h": 280,
						"w": 418
					},
					{
						"n": 20,
						"h": 170,
						"w": 453
					}
				],
				"ball": {
					"n": 0,
					"h": 369,
					"w": 126,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1316,
			"minute": 63,
			"messages": [
				{
					"owner": 1,
					"mes": "Киэн Колман[06](Галвэй Юнайтед) сближается с О.Дюмоном[26](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 707
					},
					{
						"n": 2,
						"h": 381,
						"w": 360
					},
					{
						"n": 14,
						"h": 283,
						"w": 397
					},
					{
						"n": 13,
						"h": 173,
						"w": 389
					},
					{
						"n": 5,
						"h": 74,
						"w": 353
					},
					{
						"n": 6,
						"h": 365,
						"w": 98
					},
					{
						"n": 18,
						"h": 286,
						"w": 177
					},
					{
						"n": 15,
						"h": 208,
						"w": 155
					},
					{
						"n": 17,
						"h": 103,
						"w": 94
					},
					{
						"n": 20,
						"h": 282,
						"w": 259
					},
					{
						"n": 19,
						"h": 218,
						"w": 97
					}
				],
				"away": [
					{
						"n": 1,
						"h": 213,
						"w": 711
					},
					{
						"n": 13,
						"h": 318,
						"w": 646
					},
					{
						"n": 3,
						"h": 259,
						"w": 573
					},
					{
						"n": 14,
						"h": 207,
						"w": 627
					},
					{
						"n": 5,
						"h": 91,
						"w": 612
					},
					{
						"n": 6,
						"h": 76,
						"w": 622
					},
					{
						"n": 7,
						"h": 196,
						"w": 637
					},
					{
						"n": 18,
						"h": 170,
						"w": 456
					},
					{
						"n": 17,
						"h": 400,
						"w": 501
					},
					{
						"n": 19,
						"h": 275,
						"w": 423
					},
					{
						"n": 20,
						"h": 168,
						"w": 481
					}
				],
				"ball": {
					"n": 0,
					"h": 365,
					"w": 98,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 28
		},
		{
			"num": 1317,
			"minute": 63,
			"messages": [
				{
					"owner": 1,
					"mes": "Резко ускорившись, Киэн Колман[06](Галвэй Юнайтед) уходит от О.Дюмона[26](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 708
					},
					{
						"n": 2,
						"h": 383,
						"w": 346
					},
					{
						"n": 14,
						"h": 270,
						"w": 402
					},
					{
						"n": 13,
						"h": 181,
						"w": 407
					},
					{
						"n": 5,
						"h": 69,
						"w": 356
					},
					{
						"n": 6,
						"h": 357,
						"w": 76
					},
					{
						"n": 18,
						"h": 302,
						"w": 165
					},
					{
						"n": 15,
						"h": 202,
						"w": 148
					},
					{
						"n": 17,
						"h": 93,
						"w": 87
					},
					{
						"n": 20,
						"h": 282,
						"w": 239
					},
					{
						"n": 19,
						"h": 225,
						"w": 78
					}
				],
				"away": [
					{
						"n": 1,
						"h": 212,
						"w": 713
					},
					{
						"n": 13,
						"h": 329,
						"w": 661
					},
					{
						"n": 3,
						"h": 242,
						"w": 584
					},
					{
						"n": 14,
						"h": 210,
						"w": 647
					},
					{
						"n": 5,
						"h": 98,
						"w": 634
					},
					{
						"n": 6,
						"h": 76,
						"w": 637
					},
					{
						"n": 7,
						"h": 176,
						"w": 643
					},
					{
						"n": 18,
						"h": 161,
						"w": 474
					},
					{
						"n": 17,
						"h": 407,
						"w": 519
					},
					{
						"n": 19,
						"h": 290,
						"w": 422
					},
					{
						"n": 20,
						"h": 164,
						"w": 461
					}
				],
				"ball": {
					"n": 0,
					"h": 350,
					"w": 53,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 20
		},
		{
			"num": 1318,
			"minute": 63,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 710
					},
					{
						"n": 2,
						"h": 376,
						"w": 353
					},
					{
						"n": 14,
						"h": 275,
						"w": 393
					},
					{
						"n": 13,
						"h": 185,
						"w": 400
					},
					{
						"n": 5,
						"h": 60,
						"w": 353
					},
					{
						"n": 6,
						"h": 350,
						"w": 53
					},
					{
						"n": 18,
						"h": 290,
						"w": 149
					},
					{
						"n": 15,
						"h": 182,
						"w": 146
					},
					{
						"n": 17,
						"h": 83,
						"w": 74
					},
					{
						"n": 20,
						"h": 283,
						"w": 219
					},
					{
						"n": 19,
						"h": 208,
						"w": 68
					}
				],
				"away": [
					{
						"n": 1,
						"h": 211,
						"w": 714
					},
					{
						"n": 13,
						"h": 352,
						"w": 664
					},
					{
						"n": 3,
						"h": 248,
						"w": 594
					},
					{
						"n": 14,
						"h": 224,
						"w": 661
					},
					{
						"n": 5,
						"h": 99,
						"w": 656
					},
					{
						"n": 6,
						"h": 76,
						"w": 652
					},
					{
						"n": 7,
						"h": 183,
						"w": 624
					},
					{
						"n": 18,
						"h": 153,
						"w": 493
					},
					{
						"n": 17,
						"h": 402,
						"w": 539
					},
					{
						"n": 19,
						"h": 292,
						"w": 417
					},
					{
						"n": 20,
						"h": 169,
						"w": 442
					}
				],
				"ball": {
					"n": 0,
					"h": 350,
					"w": 53,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 20
		},
		{
			"num": 1319,
			"minute": 63,
			"messages": [
				{
					"owner": 1,
					"mes": "Киэн Колман[06](Галвэй Юнайтед) входит в штрафную..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 709
					},
					{
						"n": 2,
						"h": 373,
						"w": 346
					},
					{
						"n": 14,
						"h": 265,
						"w": 403
					},
					{
						"n": 13,
						"h": 171,
						"w": 386
					},
					{
						"n": 5,
						"h": 68,
						"w": 344
					},
					{
						"n": 6,
						"h": 310,
						"w": 51,
						"m": 740
					},
					{
						"n": 18,
						"h": 274,
						"w": 153
					},
					{
						"n": 15,
						"h": 171,
						"w": 112
					},
					{
						"n": 17,
						"h": 73,
						"w": 80
					},
					{
						"n": 20,
						"h": 285,
						"w": 183
					},
					{
						"n": 19,
						"h": 172,
						"w": 64
					}
				],
				"away": [
					{
						"n": 1,
						"h": 212,
						"w": 712
					},
					{
						"n": 13,
						"h": 365,
						"w": 665
					},
					{
						"n": 3,
						"h": 255,
						"w": 632
					},
					{
						"n": 14,
						"h": 185,
						"w": 672
					},
					{
						"n": 5,
						"h": 137,
						"w": 674
					},
					{
						"n": 6,
						"h": 110,
						"w": 641,
						"m": 650
					},
					{
						"n": 7,
						"h": 217,
						"w": 614
					},
					{
						"n": 18,
						"h": 137,
						"w": 534
					},
					{
						"n": 17,
						"h": 410,
						"w": 530
					},
					{
						"n": 19,
						"h": 280,
						"w": 421
					},
					{
						"n": 20,
						"h": 166,
						"w": 427
					}
				],
				"ball": {
					"n": 0,
					"h": 310,
					"w": 51,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 36
		},
		{
			"num": 1320,
			"minute": 63,
			"messages": [
				{
					"owner": 1,
					"mes": "Несмотря на острый угол, Киэн Колман[06](Галвэй Юнайтед) бьет по воротам..."
				},
				{
					"owner": 1,
					"mes": "Гол!!!"
				},
				{
					"owner": 1,
					"mes": " СЧЕТ 3:0"
				}
			],
			"U": {
				"team": 1,
				"player": 6,
				"xg": "0.07"
			},
			"V": {
				"team": 1,
				"player": 6
			},
			"G": {
				"team": 1,
				"player": 6,
				"assist": 17
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 704
					},
					{
						"n": 2,
						"h": 390,
						"w": 344
					},
					{
						"n": 14,
						"h": 266,
						"w": 392
					},
					{
						"n": 13,
						"h": 174,
						"w": 387
					},
					{
						"n": 5,
						"h": 73,
						"w": 360
					},
					{
						"n": 6,
						"h": 310,
						"w": 51,
						"m": 870
					},
					{
						"n": 18,
						"h": 293,
						"w": 138
					},
					{
						"n": 15,
						"h": 153,
						"w": 120
					},
					{
						"n": 17,
						"h": 63,
						"w": 80,
						"m": 670
					},
					{
						"n": 20,
						"h": 283,
						"w": 159
					},
					{
						"n": 19,
						"h": 157,
						"w": 50
					}
				],
				"away": [
					{
						"n": 1,
						"h": 195,
						"w": 712,
						"m": 620
					},
					{
						"n": 13,
						"h": 371,
						"w": 665
					},
					{
						"n": 3,
						"h": 272,
						"w": 651
					},
					{
						"n": 14,
						"h": 172,
						"w": 674
					},
					{
						"n": 5,
						"h": 144,
						"w": 671
					},
					{
						"n": 6,
						"h": 134,
						"w": 637
					},
					{
						"n": 7,
						"h": 229,
						"w": 593
					},
					{
						"n": 18,
						"h": 126,
						"w": 562
					},
					{
						"n": 17,
						"h": 398,
						"w": 530
					},
					{
						"n": 19,
						"h": 280,
						"w": 419
					},
					{
						"n": 20,
						"h": 168,
						"w": 419
					}
				],
				"ball": {
					"n": 0,
					"h": 229,
					"w": -12,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 9
				}
			},
			"interval": 24
		},
		{
			"num": 1321,
			"minute": 64,
			"possession": 43,
			"messages": [],
			"N": {
				"team": 2
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 705
					},
					{
						"n": 2,
						"h": 405,
						"w": 630,
						"f": 82
					},
					{
						"n": 14,
						"h": 315,
						"w": 630
					},
					{
						"n": 13,
						"h": 135,
						"w": 630
					},
					{
						"n": 5,
						"h": 45,
						"w": 630
					},
					{
						"n": 6,
						"h": 405,
						"w": 510
					},
					{
						"n": 18,
						"h": 315,
						"w": 510,
						"f": 98
					},
					{
						"n": 15,
						"h": 135,
						"w": 510,
						"f": 98
					},
					{
						"n": 17,
						"h": 45,
						"w": 510
					},
					{
						"n": 20,
						"h": 350,
						"w": 390,
						"f": 92
					},
					{
						"n": 19,
						"h": 100,
						"w": 390,
						"f": 98
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 705,
						"m": 600
					},
					{
						"n": 13,
						"h": 413,
						"w": 570
					},
					{
						"n": 3,
						"h": 319,
						"w": 630
					},
					{
						"n": 14,
						"h": 131,
						"w": 630
					},
					{
						"n": 5,
						"h": 37,
						"w": 630
					},
					{
						"n": 6,
						"h": 225,
						"w": 570
					},
					{
						"n": 7,
						"h": 225,
						"w": 510
					},
					{
						"n": 18,
						"h": 37,
						"w": 510
					},
					{
						"n": 17,
						"h": 413,
						"w": 450,
						"m": 650
					},
					{
						"n": 19,
						"h": 235,
						"w": 365,
						"f": 94
					},
					{
						"n": 20,
						"h": 211,
						"w": 387
					}
				],
				"ball": {
					"n": 0,
					"h": 225,
					"w": 360,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 300
		},
		{
			"num": 1322,
			"minute": 64,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 705
					},
					{
						"n": 2,
						"h": 405,
						"w": 630
					},
					{
						"n": 14,
						"h": 315,
						"w": 630
					},
					{
						"n": 13,
						"h": 135,
						"w": 630
					},
					{
						"n": 5,
						"h": 45,
						"w": 630
					},
					{
						"n": 6,
						"h": 405,
						"w": 510
					},
					{
						"n": 18,
						"h": 315,
						"w": 510
					},
					{
						"n": 15,
						"h": 135,
						"w": 510
					},
					{
						"n": 17,
						"h": 45,
						"w": 510
					},
					{
						"n": 20,
						"h": 350,
						"w": 390
					},
					{
						"n": 19,
						"h": 100,
						"w": 390
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 705
					},
					{
						"n": 13,
						"h": 413,
						"w": 570
					},
					{
						"n": 3,
						"h": 319,
						"w": 630
					},
					{
						"n": 14,
						"h": 131,
						"w": 630
					},
					{
						"n": 5,
						"h": 37,
						"w": 630
					},
					{
						"n": 6,
						"h": 225,
						"w": 570
					},
					{
						"n": 7,
						"h": 225,
						"w": 510
					},
					{
						"n": 18,
						"h": 37,
						"w": 510
					},
					{
						"n": 17,
						"h": 413,
						"w": 450
					},
					{
						"n": 19,
						"h": 235,
						"w": 365
					},
					{
						"n": 20,
						"h": 211,
						"w": 387
					}
				],
				"ball": {
					"n": 0,
					"h": 225,
					"w": 360,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 30
		},
		{
			"num": 1323,
			"minute": 64,
			"messages": [
				{
					"owner": 2,
					"mes": "Опава разыгрывает мяч..."
				},
				{
					"owner": 2,
					"mes": "Тома Анри[40](Опава) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 705
					},
					{
						"n": 2,
						"h": 405,
						"w": 630
					},
					{
						"n": 14,
						"h": 315,
						"w": 630
					},
					{
						"n": 13,
						"h": 135,
						"w": 630
					},
					{
						"n": 5,
						"h": 45,
						"w": 630
					},
					{
						"n": 6,
						"h": 405,
						"w": 510
					},
					{
						"n": 18,
						"h": 315,
						"w": 510
					},
					{
						"n": 15,
						"h": 135,
						"w": 510
					},
					{
						"n": 17,
						"h": 45,
						"w": 510
					},
					{
						"n": 20,
						"h": 350,
						"w": 390
					},
					{
						"n": 19,
						"h": 100,
						"w": 390
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 705
					},
					{
						"n": 13,
						"h": 413,
						"w": 570
					},
					{
						"n": 3,
						"h": 319,
						"w": 630
					},
					{
						"n": 14,
						"h": 131,
						"w": 630
					},
					{
						"n": 5,
						"h": 37,
						"w": 630
					},
					{
						"n": 6,
						"h": 225,
						"w": 570
					},
					{
						"n": 7,
						"h": 225,
						"w": 510
					},
					{
						"n": 18,
						"h": 37,
						"w": 510
					},
					{
						"n": 17,
						"h": 413,
						"w": 450
					},
					{
						"n": 19,
						"h": 235,
						"w": 365
					},
					{
						"n": 20,
						"h": 211,
						"w": 387
					}
				],
				"ball": {
					"n": 0,
					"h": 239,
					"w": 333,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 15
		},
		{
			"num": 1324,
			"minute": 64,
			"messages": [
				{
					"owner": 2,
					"mes": "Пас назад..."
				},
				{
					"owner": 2,
					"mes": "Нир Мансур[23](Опава) сбрасывает мяч себе на ход..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 707
					},
					{
						"n": 2,
						"h": 363,
						"w": 589
					},
					{
						"n": 14,
						"h": 282,
						"w": 581
					},
					{
						"n": 13,
						"h": 162,
						"w": 578
					},
					{
						"n": 5,
						"h": 85,
						"w": 587
					},
					{
						"n": 6,
						"h": 417,
						"w": 452
					},
					{
						"n": 18,
						"h": 270,
						"w": 472
					},
					{
						"n": 15,
						"h": 170,
						"w": 463
					},
					{
						"n": 17,
						"h": 49,
						"w": 451
					},
					{
						"n": 20,
						"h": 293,
						"w": 400
					},
					{
						"n": 19,
						"h": 136,
						"w": 365
					}
				],
				"away": [
					{
						"n": 1,
						"h": 228,
						"w": 706
					},
					{
						"n": 13,
						"h": 414,
						"w": 550
					},
					{
						"n": 3,
						"h": 302,
						"w": 603
					},
					{
						"n": 14,
						"h": 169,
						"w": 643
					},
					{
						"n": 5,
						"h": 26,
						"w": 613
					},
					{
						"n": 6,
						"h": 231,
						"w": 533
					},
					{
						"n": 7,
						"h": 230,
						"w": 451
					},
					{
						"n": 18,
						"h": 37,
						"w": 451
					},
					{
						"n": 17,
						"h": 408,
						"w": 391
					},
					{
						"n": 19,
						"h": 273,
						"w": 320
					},
					{
						"n": 20,
						"h": 208,
						"w": 377
					}
				],
				"ball": {
					"n": 0,
					"h": 148,
					"w": 117,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 59
		},
		{
			"num": 1325,
			"minute": 64,
			"messages": [
				{
					"owner": 2,
					"mes": "Н.Мансур[23](Опава) отдает передачу О.Дюмону[26](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 701
					},
					{
						"n": 2,
						"h": 353,
						"w": 562
					},
					{
						"n": 14,
						"h": 266,
						"w": 558
					},
					{
						"n": 13,
						"h": 165,
						"w": 550
					},
					{
						"n": 5,
						"h": 97,
						"w": 561
					},
					{
						"n": 6,
						"h": 412,
						"w": 425
					},
					{
						"n": 18,
						"h": 266,
						"w": 444
					},
					{
						"n": 15,
						"h": 166,
						"w": 435
					},
					{
						"n": 17,
						"h": 51,
						"w": 423
					},
					{
						"n": 20,
						"h": 301,
						"w": 373
					},
					{
						"n": 19,
						"h": 161,
						"w": 356
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 702
					},
					{
						"n": 13,
						"h": 430,
						"w": 550
					},
					{
						"n": 3,
						"h": 294,
						"w": 602
					},
					{
						"n": 14,
						"h": 176,
						"w": 606
					},
					{
						"n": 5,
						"h": 25,
						"w": 585
					},
					{
						"n": 6,
						"h": 247,
						"w": 556
					},
					{
						"n": 7,
						"h": 233,
						"w": 423
					},
					{
						"n": 18,
						"h": 37,
						"w": 423
					},
					{
						"n": 17,
						"h": 409,
						"w": 363
					},
					{
						"n": 19,
						"h": 281,
						"w": 293
					},
					{
						"n": 20,
						"h": 198,
						"w": 351
					}
				],
				"ball": {
					"n": 0,
					"h": 203,
					"w": 164,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 28
		},
		{
			"num": 1326,
			"minute": 64,
			"messages": [
				{
					"owner": 2,
					"mes": "О.Дюмон[26](Опава) отдает передачу В.Сланине[34](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 706
					},
					{
						"n": 2,
						"h": 344,
						"w": 529
					},
					{
						"n": 14,
						"h": 251,
						"w": 526
					},
					{
						"n": 13,
						"h": 157,
						"w": 516
					},
					{
						"n": 5,
						"h": 104,
						"w": 527
					},
					{
						"n": 6,
						"h": 404,
						"w": 391
					},
					{
						"n": 18,
						"h": 264,
						"w": 416
					},
					{
						"n": 15,
						"h": 156,
						"w": 401
					},
					{
						"n": 17,
						"h": 56,
						"w": 406
					},
					{
						"n": 20,
						"h": 304,
						"w": 338
					},
					{
						"n": 19,
						"h": 158,
						"w": 330
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 702
					},
					{
						"n": 13,
						"h": 412,
						"w": 550
					},
					{
						"n": 3,
						"h": 281,
						"w": 600
					},
					{
						"n": 14,
						"h": 187,
						"w": 593
					},
					{
						"n": 5,
						"h": 50,
						"w": 590
					},
					{
						"n": 6,
						"h": 241,
						"w": 548,
						"m": 660
					},
					{
						"n": 7,
						"h": 219,
						"w": 391
					},
					{
						"n": 18,
						"h": 30,
						"w": 389
					},
					{
						"n": 17,
						"h": 416,
						"w": 329
					},
					{
						"n": 19,
						"h": 302,
						"w": 280
					},
					{
						"n": 20,
						"h": 182,
						"w": 320
					}
				],
				"ball": {
					"n": 0,
					"h": 263,
					"w": 127,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 35
		},
		{
			"num": 1327,
			"minute": 64,
			"messages": [
				{
					"owner": 2,
					"mes": "Вацлав Сланина[34](Опава) отдает пас на Н.Мансура[23](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 710
					},
					{
						"n": 2,
						"h": 339,
						"w": 505
					},
					{
						"n": 14,
						"h": 254,
						"w": 502
					},
					{
						"n": 13,
						"h": 167,
						"w": 494
					},
					{
						"n": 5,
						"h": 109,
						"w": 504
					},
					{
						"n": 6,
						"h": 394,
						"w": 370
					},
					{
						"n": 18,
						"h": 280,
						"w": 409
					},
					{
						"n": 15,
						"h": 175,
						"w": 387
					},
					{
						"n": 17,
						"h": 56,
						"w": 430
					},
					{
						"n": 20,
						"h": 290,
						"w": 319
					},
					{
						"n": 19,
						"h": 147,
						"w": 309
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 701
					},
					{
						"n": 13,
						"h": 433,
						"w": 550
					},
					{
						"n": 3,
						"h": 261,
						"w": 587
					},
					{
						"n": 14,
						"h": 182,
						"w": 591,
						"m": 670
					},
					{
						"n": 5,
						"h": 31,
						"w": 576
					},
					{
						"n": 6,
						"h": 236,
						"w": 524
					},
					{
						"n": 7,
						"h": 229,
						"w": 396
					},
					{
						"n": 18,
						"h": 35,
						"w": 365
					},
					{
						"n": 17,
						"h": 417,
						"w": 305
					},
					{
						"n": 19,
						"h": 278,
						"w": 284
					},
					{
						"n": 20,
						"h": 171,
						"w": 299
					}
				],
				"ball": {
					"n": 0,
					"h": 189,
					"w": 133,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 24
		},
		{
			"num": 1328,
			"minute": 64,
			"messages": [
				{
					"owner": 2,
					"mes": "Передача вперед..."
				},
				{
					"owner": 2,
					"mes": "Оливье Дюмон[26](Опава) получает передачу..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 702
					},
					{
						"n": 2,
						"h": 315,
						"w": 489
					},
					{
						"n": 14,
						"h": 239,
						"w": 478
					},
					{
						"n": 13,
						"h": 173,
						"w": 469
					},
					{
						"n": 5,
						"h": 117,
						"w": 476
					},
					{
						"n": 6,
						"h": 394,
						"w": 399
					},
					{
						"n": 18,
						"h": 292,
						"w": 406
					},
					{
						"n": 15,
						"h": 191,
						"w": 366
					},
					{
						"n": 17,
						"h": 56,
						"w": 435
					},
					{
						"n": 20,
						"h": 295,
						"w": 299
					},
					{
						"n": 19,
						"h": 170,
						"w": 306
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 701
					},
					{
						"n": 13,
						"h": 428,
						"w": 521
					},
					{
						"n": 3,
						"h": 266,
						"w": 595
					},
					{
						"n": 14,
						"h": 171,
						"w": 602
					},
					{
						"n": 5,
						"h": 57,
						"w": 588
					},
					{
						"n": 6,
						"h": 243,
						"w": 531
					},
					{
						"n": 7,
						"h": 233,
						"w": 368
					},
					{
						"n": 18,
						"h": 38,
						"w": 336
					},
					{
						"n": 17,
						"h": 408,
						"w": 300
					},
					{
						"n": 19,
						"h": 290,
						"w": 272
					},
					{
						"n": 20,
						"h": 151,
						"w": 285
					}
				],
				"ball": {
					"n": 0,
					"h": 207,
					"w": 189,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 29
		},
		{
			"num": 1329,
			"minute": 64,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 708
					},
					{
						"n": 2,
						"h": 330,
						"w": 503
					},
					{
						"n": 14,
						"h": 273,
						"w": 498
					},
					{
						"n": 13,
						"h": 170,
						"w": 495
					},
					{
						"n": 5,
						"h": 120,
						"w": 500
					},
					{
						"n": 6,
						"h": 394,
						"w": 438
					},
					{
						"n": 18,
						"h": 272,
						"w": 420
					},
					{
						"n": 15,
						"h": 182,
						"w": 395
					},
					{
						"n": 17,
						"h": 67,
						"w": 473
					},
					{
						"n": 20,
						"h": 282,
						"w": 337
					},
					{
						"n": 19,
						"h": 132,
						"w": 319
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 704
					},
					{
						"n": 13,
						"h": 420,
						"w": 482
					},
					{
						"n": 3,
						"h": 280,
						"w": 558
					},
					{
						"n": 14,
						"h": 173,
						"w": 562
					},
					{
						"n": 5,
						"h": 70,
						"w": 555
					},
					{
						"n": 6,
						"h": 238,
						"w": 496
					},
					{
						"n": 7,
						"h": 224,
						"w": 358
					},
					{
						"n": 18,
						"h": 34,
						"w": 297
					},
					{
						"n": 17,
						"h": 393,
						"w": 263
					},
					{
						"n": 19,
						"h": 298,
						"w": 250
					},
					{
						"n": 20,
						"h": 154,
						"w": 245
					}
				],
				"ball": {
					"n": 0,
					"h": 212,
					"w": 224,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1330,
			"minute": 64,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 710
					},
					{
						"n": 2,
						"h": 330,
						"w": 542
					},
					{
						"n": 14,
						"h": 274,
						"w": 537
					},
					{
						"n": 13,
						"h": 173,
						"w": 534
					},
					{
						"n": 5,
						"h": 82,
						"w": 511
					},
					{
						"n": 6,
						"h": 394,
						"w": 477
					},
					{
						"n": 18,
						"h": 270,
						"w": 459
					},
					{
						"n": 15,
						"h": 200,
						"w": 430
					},
					{
						"n": 17,
						"h": 61,
						"w": 491
					},
					{
						"n": 20,
						"h": 285,
						"w": 376
					},
					{
						"n": 19,
						"h": 137,
						"w": 358
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 684
					},
					{
						"n": 13,
						"h": 414,
						"w": 444
					},
					{
						"n": 3,
						"h": 279,
						"w": 519
					},
					{
						"n": 14,
						"h": 174,
						"w": 523
					},
					{
						"n": 5,
						"h": 66,
						"w": 516
					},
					{
						"n": 6,
						"h": 233,
						"w": 462
					},
					{
						"n": 7,
						"h": 227,
						"w": 319
					},
					{
						"n": 18,
						"h": 32,
						"w": 258
					},
					{
						"n": 17,
						"h": 408,
						"w": 226
					},
					{
						"n": 19,
						"h": 301,
						"w": 211
					},
					{
						"n": 20,
						"h": 157,
						"w": 206
					}
				],
				"ball": {
					"n": 0,
					"h": 217,
					"w": 258,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 1331,
			"minute": 64,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 703
					},
					{
						"n": 2,
						"h": 330,
						"w": 581
					},
					{
						"n": 14,
						"h": 276,
						"w": 576
					},
					{
						"n": 13,
						"h": 171,
						"w": 573
					},
					{
						"n": 5,
						"h": 58,
						"w": 541
					},
					{
						"n": 6,
						"h": 394,
						"w": 516
					},
					{
						"n": 18,
						"h": 250,
						"w": 493
					},
					{
						"n": 15,
						"h": 194,
						"w": 468
					},
					{
						"n": 17,
						"h": 63,
						"w": 510
					},
					{
						"n": 20,
						"h": 279,
						"w": 414
					},
					{
						"n": 19,
						"h": 171,
						"w": 339
					}
				],
				"away": [
					{
						"n": 1,
						"h": 223,
						"w": 667
					},
					{
						"n": 13,
						"h": 412,
						"w": 405
					},
					{
						"n": 3,
						"h": 281,
						"w": 480
					},
					{
						"n": 14,
						"h": 170,
						"w": 484
					},
					{
						"n": 5,
						"h": 72,
						"w": 478
					},
					{
						"n": 6,
						"h": 229,
						"w": 428
					},
					{
						"n": 7,
						"h": 223,
						"w": 280
					},
					{
						"n": 18,
						"h": 27,
						"w": 219
					},
					{
						"n": 17,
						"h": 421,
						"w": 190
					},
					{
						"n": 19,
						"h": 308,
						"w": 172
					},
					{
						"n": 20,
						"h": 152,
						"w": 168
					}
				],
				"ball": {
					"n": 0,
					"h": 221,
					"w": 292,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 1332,
			"minute": 64,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 708
					},
					{
						"n": 2,
						"h": 330,
						"w": 609
					},
					{
						"n": 14,
						"h": 281,
						"w": 615
					},
					{
						"n": 13,
						"h": 175,
						"w": 612
					},
					{
						"n": 5,
						"h": 56,
						"w": 561
					},
					{
						"n": 6,
						"h": 394,
						"w": 554
					},
					{
						"n": 18,
						"h": 237,
						"w": 530
					},
					{
						"n": 15,
						"h": 190,
						"w": 493
					},
					{
						"n": 17,
						"h": 44,
						"w": 513
					},
					{
						"n": 20,
						"h": 278,
						"w": 416
					},
					{
						"n": 19,
						"h": 210,
						"w": 345
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 646
					},
					{
						"n": 13,
						"h": 411,
						"w": 366
					},
					{
						"n": 3,
						"h": 285,
						"w": 456
					},
					{
						"n": 14,
						"h": 178,
						"w": 451
					},
					{
						"n": 5,
						"h": 64,
						"w": 439
					},
					{
						"n": 6,
						"h": 233,
						"w": 394
					},
					{
						"n": 7,
						"h": 223,
						"w": 241
					},
					{
						"n": 18,
						"h": 17,
						"w": 181
					},
					{
						"n": 17,
						"h": 434,
						"w": 169
					},
					{
						"n": 19,
						"h": 290,
						"w": 144
					},
					{
						"n": 20,
						"h": 152,
						"w": 144
					}
				],
				"ball": {
					"n": 0,
					"h": 217,
					"w": 326,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 1333,
			"minute": 64,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 708
					},
					{
						"n": 2,
						"h": 330,
						"w": 608
					},
					{
						"n": 14,
						"h": 270,
						"w": 603
					},
					{
						"n": 13,
						"h": 184,
						"w": 612
					},
					{
						"n": 5,
						"h": 56,
						"w": 585
					},
					{
						"n": 6,
						"h": 394,
						"w": 544
					},
					{
						"n": 18,
						"h": 261,
						"w": 547
					},
					{
						"n": 15,
						"h": 211,
						"w": 525
					},
					{
						"n": 17,
						"h": 53,
						"w": 513
					},
					{
						"n": 20,
						"h": 278,
						"w": 425
					},
					{
						"n": 19,
						"h": 245,
						"w": 362
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 627
					},
					{
						"n": 13,
						"h": 408,
						"w": 326
					},
					{
						"n": 3,
						"h": 274,
						"w": 445
					},
					{
						"n": 14,
						"h": 168,
						"w": 449
					},
					{
						"n": 5,
						"h": 61,
						"w": 437
					},
					{
						"n": 6,
						"h": 203,
						"w": 377
					},
					{
						"n": 7,
						"h": 238,
						"w": 204
					},
					{
						"n": 18,
						"h": 23,
						"w": 191
					},
					{
						"n": 17,
						"h": 422,
						"w": 145
					},
					{
						"n": 19,
						"h": 307,
						"w": 144
					},
					{
						"n": 20,
						"h": 146,
						"w": 144
					}
				],
				"ball": {
					"n": 0,
					"h": 247,
					"w": 343,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1334,
			"minute": 64,
			"messages": [
				{
					"owner": 2,
					"mes": "Оливье Дюмон[26](Опава) играет налево на К.Удре[33](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 705
					},
					{
						"n": 2,
						"h": 330,
						"w": 601
					},
					{
						"n": 14,
						"h": 267,
						"w": 617
					},
					{
						"n": 13,
						"h": 184,
						"w": 597
					},
					{
						"n": 5,
						"h": 69,
						"w": 590
					},
					{
						"n": 6,
						"h": 392,
						"w": 589
					},
					{
						"n": 18,
						"h": 239,
						"w": 538
					},
					{
						"n": 15,
						"h": 196,
						"w": 500
					},
					{
						"n": 17,
						"h": 62,
						"w": 469
					},
					{
						"n": 20,
						"h": 252,
						"w": 388
					},
					{
						"n": 19,
						"h": 211,
						"w": 392
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 603
					},
					{
						"n": 13,
						"h": 380,
						"w": 353
					},
					{
						"n": 3,
						"h": 274,
						"w": 447
					},
					{
						"n": 14,
						"h": 170,
						"w": 446
					},
					{
						"n": 5,
						"h": 72,
						"w": 440
					},
					{
						"n": 6,
						"h": 209,
						"w": 369
					},
					{
						"n": 7,
						"h": 264,
						"w": 241
					},
					{
						"n": 18,
						"h": 44,
						"w": 151
					},
					{
						"n": 17,
						"h": 411,
						"w": 150
					},
					{
						"n": 19,
						"h": 277,
						"w": 137
					},
					{
						"n": 20,
						"h": 168,
						"w": 135
					}
				],
				"ball": {
					"n": 0,
					"h": 70,
					"w": 367,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 45
		},
		{
			"num": 1335,
			"minute": 64,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 701
					},
					{
						"n": 2,
						"h": 330,
						"w": 619
					},
					{
						"n": 14,
						"h": 265,
						"w": 604
					},
					{
						"n": 13,
						"h": 157,
						"w": 612
					},
					{
						"n": 5,
						"h": 56,
						"w": 567
					},
					{
						"n": 6,
						"h": 394,
						"w": 584
					},
					{
						"n": 18,
						"h": 273,
						"w": 557
					},
					{
						"n": 15,
						"h": 180,
						"w": 530
					},
					{
						"n": 17,
						"h": 70,
						"w": 431
					},
					{
						"n": 20,
						"h": 281,
						"w": 415
					},
					{
						"n": 19,
						"h": 202,
						"w": 376
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 599
					},
					{
						"n": 13,
						"h": 384,
						"w": 319
					},
					{
						"n": 3,
						"h": 278,
						"w": 442
					},
					{
						"n": 14,
						"h": 183,
						"w": 454
					},
					{
						"n": 5,
						"h": 71,
						"w": 456
					},
					{
						"n": 6,
						"h": 248,
						"w": 364
					},
					{
						"n": 7,
						"h": 269,
						"w": 204
					},
					{
						"n": 18,
						"h": 23,
						"w": 171
					},
					{
						"n": 17,
						"h": 434,
						"w": 161
					},
					{
						"n": 19,
						"h": 315,
						"w": 143
					},
					{
						"n": 20,
						"h": 169,
						"w": 144
					}
				],
				"ball": {
					"n": 0,
					"h": 66,
					"w": 401,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 1336,
			"minute": 64,
			"messages": [
				{
					"owner": 2,
					"mes": "Передача вперед на М.Томасова[37](Опава)..."
				},
				{
					"owner": 2,
					"mes": "Маттиас Раум[17](Галвэй Юнайтед) неплохо выбирает позицию и перехватывает мяч!..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 217,
						"w": 707
					},
					{
						"n": 2,
						"h": 330,
						"w": 610
					},
					{
						"n": 14,
						"h": 273,
						"w": 600
					},
					{
						"n": 13,
						"h": 161,
						"w": 604
					},
					{
						"n": 5,
						"h": 49,
						"w": 572
					},
					{
						"n": 6,
						"h": 394,
						"w": 586
					},
					{
						"n": 18,
						"h": 281,
						"w": 552
					},
					{
						"n": 15,
						"h": 185,
						"w": 523
					},
					{
						"n": 17,
						"h": 63,
						"w": 427
					},
					{
						"n": 20,
						"h": 280,
						"w": 406
					},
					{
						"n": 19,
						"h": 201,
						"w": 385
					}
				],
				"away": [
					{
						"n": 1,
						"h": 229,
						"w": 596
					},
					{
						"n": 13,
						"h": 384,
						"w": 319,
						"m": 600
					},
					{
						"n": 3,
						"h": 281,
						"w": 451
					},
					{
						"n": 14,
						"h": 174,
						"w": 454
					},
					{
						"n": 5,
						"h": 64,
						"w": 462
					},
					{
						"n": 6,
						"h": 249,
						"w": 355
					},
					{
						"n": 7,
						"h": 260,
						"w": 205
					},
					{
						"n": 18,
						"h": 27,
						"w": 163
					},
					{
						"n": 17,
						"h": 431,
						"w": 168,
						"m": 640
					},
					{
						"n": 19,
						"h": 308,
						"w": 139
					},
					{
						"n": 20,
						"h": 161,
						"w": 141
					}
				],
				"ball": {
					"n": 0,
					"h": 63,
					"w": 427,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 9
		},
		{
			"num": 1337,
			"minute": 64,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 710
					},
					{
						"n": 2,
						"h": 341,
						"w": 587
					},
					{
						"n": 14,
						"h": 281,
						"w": 561
					},
					{
						"n": 13,
						"h": 178,
						"w": 569
					},
					{
						"n": 5,
						"h": 58,
						"w": 533
					},
					{
						"n": 6,
						"h": 398,
						"w": 547
					},
					{
						"n": 18,
						"h": 272,
						"w": 513
					},
					{
						"n": 15,
						"h": 172,
						"w": 485
					},
					{
						"n": 17,
						"h": 32,
						"w": 410,
						"m": 690
					},
					{
						"n": 20,
						"h": 288,
						"w": 367
					},
					{
						"n": 19,
						"h": 183,
						"w": 349
					}
				],
				"away": [
					{
						"n": 1,
						"h": 241,
						"w": 637
					},
					{
						"n": 13,
						"h": 400,
						"w": 326
					},
					{
						"n": 3,
						"h": 264,
						"w": 487
					},
					{
						"n": 14,
						"h": 176,
						"w": 494
					},
					{
						"n": 5,
						"h": 93,
						"w": 490
					},
					{
						"n": 6,
						"h": 258,
						"w": 394
					},
					{
						"n": 7,
						"h": 258,
						"w": 245
					},
					{
						"n": 18,
						"h": 29,
						"w": 203
					},
					{
						"n": 17,
						"h": 425,
						"w": 208
					},
					{
						"n": 19,
						"h": 298,
						"w": 177
					},
					{
						"n": 20,
						"h": 169,
						"w": 180
					}
				],
				"ball": {
					"n": 0,
					"h": 32,
					"w": 410,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1338,
			"minute": 64,
			"messages": [
				{
					"owner": 1,
					"mes": "М.Раум[17](Галвэй Юнайтед) отдает передачу С.Фридйонссону[05](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 709
					},
					{
						"n": 2,
						"h": 359,
						"w": 549
					},
					{
						"n": 14,
						"h": 282,
						"w": 540
					},
					{
						"n": 13,
						"h": 165,
						"w": 529
					},
					{
						"n": 5,
						"h": 88,
						"w": 503
					},
					{
						"n": 6,
						"h": 403,
						"w": 505
					},
					{
						"n": 18,
						"h": 267,
						"w": 471
					},
					{
						"n": 15,
						"h": 160,
						"w": 445
					},
					{
						"n": 17,
						"h": 34,
						"w": 400
					},
					{
						"n": 20,
						"h": 293,
						"w": 325
					},
					{
						"n": 19,
						"h": 166,
						"w": 311
					}
				],
				"away": [
					{
						"n": 1,
						"h": 245,
						"w": 644
					},
					{
						"n": 13,
						"h": 407,
						"w": 368
					},
					{
						"n": 3,
						"h": 266,
						"w": 490
					},
					{
						"n": 14,
						"h": 169,
						"w": 502
					},
					{
						"n": 5,
						"h": 110,
						"w": 495
					},
					{
						"n": 6,
						"h": 275,
						"w": 425
					},
					{
						"n": 7,
						"h": 254,
						"w": 287
					},
					{
						"n": 18,
						"h": 32,
						"w": 244
					},
					{
						"n": 17,
						"h": 420,
						"w": 250
					},
					{
						"n": 19,
						"h": 304,
						"w": 219
					},
					{
						"n": 20,
						"h": 175,
						"w": 222
					}
				],
				"ball": {
					"n": 0,
					"h": 88,
					"w": 503,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 42
		},
		{
			"num": 1339,
			"minute": 64,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 710
					},
					{
						"n": 2,
						"h": 376,
						"w": 514
					},
					{
						"n": 14,
						"h": 268,
						"w": 543
					},
					{
						"n": 13,
						"h": 181,
						"w": 529
					},
					{
						"n": 5,
						"h": 91,
						"w": 468
					},
					{
						"n": 6,
						"h": 401,
						"w": 465
					},
					{
						"n": 18,
						"h": 255,
						"w": 433
					},
					{
						"n": 15,
						"h": 150,
						"w": 406
					},
					{
						"n": 17,
						"h": 38,
						"w": 360
					},
					{
						"n": 20,
						"h": 290,
						"w": 285
					},
					{
						"n": 19,
						"h": 158,
						"w": 272
					}
				],
				"away": [
					{
						"n": 1,
						"h": 245,
						"w": 641
					},
					{
						"n": 13,
						"h": 406,
						"w": 396
					},
					{
						"n": 3,
						"h": 274,
						"w": 504
					},
					{
						"n": 14,
						"h": 170,
						"w": 499
					},
					{
						"n": 5,
						"h": 110,
						"w": 498
					},
					{
						"n": 6,
						"h": 286,
						"w": 463
					},
					{
						"n": 7,
						"h": 255,
						"w": 327
					},
					{
						"n": 18,
						"h": 28,
						"w": 284
					},
					{
						"n": 17,
						"h": 423,
						"w": 290
					},
					{
						"n": 19,
						"h": 308,
						"w": 259
					},
					{
						"n": 20,
						"h": 184,
						"w": 261
					}
				],
				"ball": {
					"n": 0,
					"h": 91,
					"w": 468,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1340,
			"minute": 64,
			"messages": [
				{
					"owner": 1,
					"mes": "Самуэль Кари Фридйонссон[05](Галвэй Юнайтед) переправляет мяч на ход К.Келли[15](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 703
					},
					{
						"n": 2,
						"h": 375,
						"w": 484
					},
					{
						"n": 14,
						"h": 266,
						"w": 538
					},
					{
						"n": 13,
						"h": 168,
						"w": 520
					},
					{
						"n": 5,
						"h": 91,
						"w": 468
					},
					{
						"n": 6,
						"h": 400,
						"w": 420
					},
					{
						"n": 18,
						"h": 269,
						"w": 390
					},
					{
						"n": 15,
						"h": 165,
						"w": 356
					},
					{
						"n": 17,
						"h": 43,
						"w": 315
					},
					{
						"n": 20,
						"h": 274,
						"w": 246
					},
					{
						"n": 19,
						"h": 168,
						"w": 243
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 643
					},
					{
						"n": 13,
						"h": 406,
						"w": 441
					},
					{
						"n": 3,
						"h": 265,
						"w": 527
					},
					{
						"n": 14,
						"h": 195,
						"w": 532
					},
					{
						"n": 5,
						"h": 110,
						"w": 540
					},
					{
						"n": 6,
						"h": 275,
						"w": 487
					},
					{
						"n": 7,
						"h": 268,
						"w": 348
					},
					{
						"n": 18,
						"h": 33,
						"w": 329
					},
					{
						"n": 17,
						"h": 413,
						"w": 334
					},
					{
						"n": 19,
						"h": 352,
						"w": 270
					},
					{
						"n": 20,
						"h": 174,
						"w": 304
					}
				],
				"ball": {
					"n": 0,
					"h": 165,
					"w": 356,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 45
		},
		{
			"num": 1341,
			"minute": 64,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 709
					},
					{
						"n": 2,
						"h": 378,
						"w": 445
					},
					{
						"n": 14,
						"h": 268,
						"w": 498
					},
					{
						"n": 13,
						"h": 178,
						"w": 493
					},
					{
						"n": 5,
						"h": 60,
						"w": 443
					},
					{
						"n": 6,
						"h": 402,
						"w": 380
					},
					{
						"n": 18,
						"h": 279,
						"w": 352
					},
					{
						"n": 15,
						"h": 165,
						"w": 321
					},
					{
						"n": 17,
						"h": 50,
						"w": 276
					},
					{
						"n": 20,
						"h": 293,
						"w": 215
					},
					{
						"n": 19,
						"h": 158,
						"w": 204
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 643
					},
					{
						"n": 13,
						"h": 400,
						"w": 480
					},
					{
						"n": 3,
						"h": 281,
						"w": 556
					},
					{
						"n": 14,
						"h": 179,
						"w": 569
					},
					{
						"n": 5,
						"h": 110,
						"w": 567
					},
					{
						"n": 6,
						"h": 280,
						"w": 447
					},
					{
						"n": 7,
						"h": 280,
						"w": 381
					},
					{
						"n": 18,
						"h": 45,
						"w": 367
					},
					{
						"n": 17,
						"h": 413,
						"w": 374
					},
					{
						"n": 19,
						"h": 333,
						"w": 306
					},
					{
						"n": 20,
						"h": 168,
						"w": 344
					}
				],
				"ball": {
					"n": 0,
					"h": 165,
					"w": 321,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1342,
			"minute": 64,
			"messages": [
				{
					"owner": 1,
					"mes": "Пас вперед..."
				},
				{
					"owner": 1,
					"mes": "Том Дэвлин[20](Галвэй Юнайтед) подрабатывает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 707
					},
					{
						"n": 2,
						"h": 390,
						"w": 415
					},
					{
						"n": 14,
						"h": 274,
						"w": 463
					},
					{
						"n": 13,
						"h": 178,
						"w": 451
					},
					{
						"n": 5,
						"h": 68,
						"w": 422
					},
					{
						"n": 6,
						"h": 406,
						"w": 328
					},
					{
						"n": 18,
						"h": 283,
						"w": 373
					},
					{
						"n": 15,
						"h": 166,
						"w": 305
					},
					{
						"n": 17,
						"h": 54,
						"w": 224
					},
					{
						"n": 20,
						"h": 312,
						"w": 271
					},
					{
						"n": 19,
						"h": 164,
						"w": 167
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 645
					},
					{
						"n": 13,
						"h": 396,
						"w": 532
					},
					{
						"n": 3,
						"h": 276,
						"w": 601
					},
					{
						"n": 14,
						"h": 166,
						"w": 587
					},
					{
						"n": 5,
						"h": 110,
						"w": 593
					},
					{
						"n": 6,
						"h": 281,
						"w": 499
					},
					{
						"n": 7,
						"h": 260,
						"w": 429
					},
					{
						"n": 18,
						"h": 44,
						"w": 419
					},
					{
						"n": 17,
						"h": 418,
						"w": 425
					},
					{
						"n": 19,
						"h": 309,
						"w": 352
					},
					{
						"n": 20,
						"h": 154,
						"w": 394
					}
				],
				"ball": {
					"n": 0,
					"h": 312,
					"w": 271,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 52
		},
		{
			"num": 1343,
			"minute": 65,
			"possession": 43,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 707,
						"m": 670
					},
					{
						"n": 2,
						"h": 383,
						"w": 376
					},
					{
						"n": 14,
						"h": 268,
						"w": 425
					},
					{
						"n": 13,
						"h": 170,
						"w": 437,
						"f": 98
					},
					{
						"n": 5,
						"h": 69,
						"w": 390,
						"f": 82
					},
					{
						"n": 6,
						"h": 403,
						"w": 288,
						"f": 81
					},
					{
						"n": 18,
						"h": 278,
						"w": 333
					},
					{
						"n": 15,
						"h": 165,
						"w": 265
					},
					{
						"n": 17,
						"h": 45,
						"w": 185
					},
					{
						"n": 20,
						"h": 308,
						"w": 232
					},
					{
						"n": 19,
						"h": 167,
						"w": 129
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 649,
						"f": 82
					},
					{
						"n": 13,
						"h": 405,
						"w": 571
					},
					{
						"n": 3,
						"h": 245,
						"w": 603,
						"f": 84,
						"c": 2
					},
					{
						"n": 14,
						"h": 156,
						"w": 544,
						"f": 91
					},
					{
						"n": 5,
						"h": 110,
						"w": 606,
						"f": 81
					},
					{
						"n": 6,
						"h": 247,
						"w": 520,
						"f": 81
					},
					{
						"n": 7,
						"h": 274,
						"w": 467
					},
					{
						"n": 18,
						"h": 47,
						"w": 459,
						"f": 96
					},
					{
						"n": 17,
						"h": 407,
						"w": 463
					},
					{
						"n": 19,
						"h": 295,
						"w": 389
					},
					{
						"n": 20,
						"h": 151,
						"w": 419,
						"f": 96
					}
				],
				"ball": {
					"n": 0,
					"h": 308,
					"w": 232,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1344,
			"minute": 65,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 709
					},
					{
						"n": 2,
						"h": 379,
						"w": 376
					},
					{
						"n": 14,
						"h": 279,
						"w": 408
					},
					{
						"n": 13,
						"h": 183,
						"w": 424
					},
					{
						"n": 5,
						"h": 61,
						"w": 371
					},
					{
						"n": 6,
						"h": 403,
						"w": 248
					},
					{
						"n": 18,
						"h": 281,
						"w": 293
					},
					{
						"n": 15,
						"h": 161,
						"w": 226
					},
					{
						"n": 17,
						"h": 58,
						"w": 147
					},
					{
						"n": 20,
						"h": 293,
						"w": 196
					},
					{
						"n": 19,
						"h": 156,
						"w": 117
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 685
					},
					{
						"n": 13,
						"h": 380,
						"w": 602
					},
					{
						"n": 3,
						"h": 248,
						"w": 630
					},
					{
						"n": 14,
						"h": 162,
						"w": 544
					},
					{
						"n": 5,
						"h": 110,
						"w": 631
					},
					{
						"n": 6,
						"h": 231,
						"w": 553
					},
					{
						"n": 7,
						"h": 280,
						"w": 506
					},
					{
						"n": 18,
						"h": 47,
						"w": 499
					},
					{
						"n": 17,
						"h": 397,
						"w": 472
					},
					{
						"n": 19,
						"h": 292,
						"w": 429
					},
					{
						"n": 20,
						"h": 170,
						"w": 416
					}
				],
				"ball": {
					"n": 0,
					"h": 293,
					"w": 196,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1345,
			"minute": 65,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 701
					},
					{
						"n": 2,
						"h": 377,
						"w": 364
					},
					{
						"n": 14,
						"h": 273,
						"w": 400
					},
					{
						"n": 13,
						"h": 176,
						"w": 414
					},
					{
						"n": 5,
						"h": 68,
						"w": 361
					},
					{
						"n": 6,
						"h": 402,
						"w": 236
					},
					{
						"n": 18,
						"h": 282,
						"w": 281
					},
					{
						"n": 15,
						"h": 161,
						"w": 214
					},
					{
						"n": 17,
						"h": 49,
						"w": 139
					},
					{
						"n": 20,
						"h": 293,
						"w": 187
					},
					{
						"n": 19,
						"h": 166,
						"w": 110
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 697
					},
					{
						"n": 13,
						"h": 384,
						"w": 613
					},
					{
						"n": 3,
						"h": 243,
						"w": 627
					},
					{
						"n": 14,
						"h": 157,
						"w": 533
					},
					{
						"n": 5,
						"h": 110,
						"w": 621
					},
					{
						"n": 6,
						"h": 232,
						"w": 565
					},
					{
						"n": 7,
						"h": 287,
						"w": 516
					},
					{
						"n": 18,
						"h": 47,
						"w": 511
					},
					{
						"n": 17,
						"h": 407,
						"w": 479
					},
					{
						"n": 19,
						"h": 290,
						"w": 417
					},
					{
						"n": 20,
						"h": 169,
						"w": 428
					}
				],
				"ball": {
					"n": 0,
					"h": 293,
					"w": 187,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 12
		},
		{
			"num": 1346,
			"minute": 65,
			"messages": [
				{
					"owner": 1,
					"mes": "Т.Дэвлин[20](Галвэй Юнайтед) пытается пройти В.Сланину[34](Опава)..."
				},
				{
					"owner": 1,
					"mes": "Том Дэвлин[20](Галвэй Юнайтед) эффектным финтом уходит от В.Сланины[34](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 707
					},
					{
						"n": 2,
						"h": 372,
						"w": 356
					},
					{
						"n": 14,
						"h": 276,
						"w": 405
					},
					{
						"n": 13,
						"h": 185,
						"w": 389
					},
					{
						"n": 5,
						"h": 59,
						"w": 346
					},
					{
						"n": 6,
						"h": 404,
						"w": 196
					},
					{
						"n": 18,
						"h": 280,
						"w": 241
					},
					{
						"n": 15,
						"h": 162,
						"w": 174
					},
					{
						"n": 17,
						"h": 51,
						"w": 130
					},
					{
						"n": 20,
						"h": 281,
						"w": 149,
						"m": 620
					},
					{
						"n": 19,
						"h": 157,
						"w": 105
					}
				],
				"away": [
					{
						"n": 1,
						"h": 217,
						"w": 698
					},
					{
						"n": 13,
						"h": 383,
						"w": 615
					},
					{
						"n": 3,
						"h": 242,
						"w": 639
					},
					{
						"n": 14,
						"h": 157,
						"w": 533,
						"m": 640
					},
					{
						"n": 5,
						"h": 110,
						"w": 628
					},
					{
						"n": 6,
						"h": 187,
						"w": 582
					},
					{
						"n": 7,
						"h": 291,
						"w": 556
					},
					{
						"n": 18,
						"h": 46,
						"w": 551
					},
					{
						"n": 17,
						"h": 411,
						"w": 480
					},
					{
						"n": 19,
						"h": 282,
						"w": 427
					},
					{
						"n": 20,
						"h": 163,
						"w": 420
					}
				],
				"ball": {
					"n": 0,
					"h": 281,
					"w": 149,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1347,
			"minute": 65,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 708
					},
					{
						"n": 2,
						"h": 390,
						"w": 356
					},
					{
						"n": 14,
						"h": 274,
						"w": 390
					},
					{
						"n": 13,
						"h": 166,
						"w": 395
					},
					{
						"n": 5,
						"h": 59,
						"w": 342
					},
					{
						"n": 6,
						"h": 404,
						"w": 157
					},
					{
						"n": 18,
						"h": 281,
						"w": 269
					},
					{
						"n": 15,
						"h": 172,
						"w": 154
					},
					{
						"n": 17,
						"h": 41,
						"w": 125
					},
					{
						"n": 20,
						"h": 300,
						"w": 116
					},
					{
						"n": 19,
						"h": 169,
						"w": 95
					}
				],
				"away": [
					{
						"n": 1,
						"h": 217,
						"w": 707
					},
					{
						"n": 13,
						"h": 393,
						"w": 629
					},
					{
						"n": 3,
						"h": 270,
						"w": 644
					},
					{
						"n": 14,
						"h": 165,
						"w": 572
					},
					{
						"n": 5,
						"h": 110,
						"w": 649
					},
					{
						"n": 6,
						"h": 157,
						"w": 618
					},
					{
						"n": 7,
						"h": 275,
						"w": 575
					},
					{
						"n": 18,
						"h": 46,
						"w": 590
					},
					{
						"n": 17,
						"h": 434,
						"w": 494
					},
					{
						"n": 19,
						"h": 283,
						"w": 430
					},
					{
						"n": 20,
						"h": 168,
						"w": 459
					}
				],
				"ball": {
					"n": 0,
					"h": 300,
					"w": 116,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 1348,
			"minute": 65,
			"messages": [
				{
					"owner": 1,
					"mes": "Том Дэвлин[20](Галвэй Юнайтед) уходит правее..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 710
					},
					{
						"n": 2,
						"h": 386,
						"w": 345
					},
					{
						"n": 14,
						"h": 272,
						"w": 406
					},
					{
						"n": 13,
						"h": 166,
						"w": 383
					},
					{
						"n": 5,
						"h": 68,
						"w": 345
					},
					{
						"n": 6,
						"h": 398,
						"w": 138
					},
					{
						"n": 18,
						"h": 297,
						"w": 270
					},
					{
						"n": 15,
						"h": 160,
						"w": 143
					},
					{
						"n": 17,
						"h": 36,
						"w": 115
					},
					{
						"n": 20,
						"h": 280,
						"w": 116
					},
					{
						"n": 19,
						"h": 158,
						"w": 85
					}
				],
				"away": [
					{
						"n": 1,
						"h": 219,
						"w": 706
					},
					{
						"n": 13,
						"h": 398,
						"w": 639
					},
					{
						"n": 3,
						"h": 273,
						"w": 661
					},
					{
						"n": 14,
						"h": 169,
						"w": 591
					},
					{
						"n": 5,
						"h": 110,
						"w": 651
					},
					{
						"n": 6,
						"h": 176,
						"w": 618
					},
					{
						"n": 7,
						"h": 283,
						"w": 583
					},
					{
						"n": 18,
						"h": 51,
						"w": 609
					},
					{
						"n": 17,
						"h": 434,
						"w": 504
					},
					{
						"n": 19,
						"h": 289,
						"w": 424
					},
					{
						"n": 20,
						"h": 153,
						"w": 470
					}
				],
				"ball": {
					"n": 0,
					"h": 280,
					"w": 116,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 20
		},
		{
			"num": 1349,
			"minute": 65,
			"messages": [
				{
					"owner": 1,
					"mes": "Том Дэвлин[20](Галвэй Юнайтед) наносит мощный удар издали..."
				},
				{
					"owner": 1,
					"mes": "Оливье Дюмон[26](Опава) блокирует удар..."
				}
			],
			"U": {
				"team": 3,
				"player": 20
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 710
					},
					{
						"n": 2,
						"h": 381,
						"w": 351
					},
					{
						"n": 14,
						"h": 273,
						"w": 395
					},
					{
						"n": 13,
						"h": 173,
						"w": 387
					},
					{
						"n": 5,
						"h": 65,
						"w": 353
					},
					{
						"n": 6,
						"h": 400,
						"w": 131
					},
					{
						"n": 18,
						"h": 294,
						"w": 263
					},
					{
						"n": 15,
						"h": 159,
						"w": 135
					},
					{
						"n": 17,
						"h": 42,
						"w": 110
					},
					{
						"n": 20,
						"h": 280,
						"w": 116,
						"m": 610
					},
					{
						"n": 19,
						"h": 166,
						"w": 86
					}
				],
				"away": [
					{
						"n": 1,
						"h": 219,
						"w": 706
					},
					{
						"n": 13,
						"h": 392,
						"w": 639
					},
					{
						"n": 3,
						"h": 269,
						"w": 654
					},
					{
						"n": 14,
						"h": 169,
						"w": 600
					},
					{
						"n": 5,
						"h": 104,
						"w": 645
					},
					{
						"n": 6,
						"h": 174,
						"w": 614
					},
					{
						"n": 7,
						"h": 291,
						"w": 585
					},
					{
						"n": 18,
						"h": 51,
						"w": 601
					},
					{
						"n": 17,
						"h": 426,
						"w": 504
					},
					{
						"n": 19,
						"h": 283,
						"w": 418
					},
					{
						"n": 20,
						"h": 156,
						"w": 477
					}
				],
				"ball": {
					"n": 0,
					"h": 276,
					"w": 106,
					"z": 0,
					"r": 0,
					"p": 1,
					"x": 0
				}
			},
			"interval": 8
		},
		{
			"num": 1350,
			"minute": 65,
			"messages": [
				{
					"owner": 1,
					"mes": "Киэн Колман[06](Галвэй Юнайтед) подхватывает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 708
					},
					{
						"n": 2,
						"h": 374,
						"w": 360
					},
					{
						"n": 14,
						"h": 265,
						"w": 409
					},
					{
						"n": 13,
						"h": 179,
						"w": 409
					},
					{
						"n": 5,
						"h": 77,
						"w": 347
					},
					{
						"n": 6,
						"h": 357,
						"w": 133,
						"m": 880
					},
					{
						"n": 18,
						"h": 305,
						"w": 267
					},
					{
						"n": 15,
						"h": 200,
						"w": 146
					},
					{
						"n": 17,
						"h": 38,
						"w": 106
					},
					{
						"n": 20,
						"h": 299,
						"w": 86
					},
					{
						"n": 19,
						"h": 177,
						"w": 83
					}
				],
				"away": [
					{
						"n": 1,
						"h": 214,
						"w": 709
					},
					{
						"n": 13,
						"h": 396,
						"w": 641
					},
					{
						"n": 3,
						"h": 255,
						"w": 662
					},
					{
						"n": 14,
						"h": 163,
						"w": 639
					},
					{
						"n": 5,
						"h": 110,
						"w": 664
					},
					{
						"n": 6,
						"h": 179,
						"w": 611
					},
					{
						"n": 7,
						"h": 253,
						"w": 565
					},
					{
						"n": 18,
						"h": 93,
						"w": 602
					},
					{
						"n": 17,
						"h": 418,
						"w": 506
					},
					{
						"n": 19,
						"h": 285,
						"w": 414
					},
					{
						"n": 20,
						"h": 145,
						"w": 473
					}
				],
				"ball": {
					"n": 0,
					"h": 357,
					"w": 133,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 42
		},
		{
			"num": 1351,
			"minute": 65,
			"messages": [
				{
					"owner": 1,
					"mes": "Пас на К.Келли[15](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 701
					},
					{
						"n": 2,
						"h": 375,
						"w": 341
					},
					{
						"n": 14,
						"h": 281,
						"w": 397
					},
					{
						"n": 13,
						"h": 175,
						"w": 387
					},
					{
						"n": 5,
						"h": 73,
						"w": 349
					},
					{
						"n": 6,
						"h": 334,
						"w": 89
					},
					{
						"n": 18,
						"h": 295,
						"w": 289
					},
					{
						"n": 15,
						"h": 239,
						"w": 143
					},
					{
						"n": 17,
						"h": 64,
						"w": 103
					},
					{
						"n": 20,
						"h": 273,
						"w": 87
					},
					{
						"n": 19,
						"h": 178,
						"w": 85
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 705
					},
					{
						"n": 13,
						"h": 370,
						"w": 640
					},
					{
						"n": 3,
						"h": 256,
						"w": 664
					},
					{
						"n": 14,
						"h": 193,
						"w": 650
					},
					{
						"n": 5,
						"h": 131,
						"w": 650
					},
					{
						"n": 6,
						"h": 217,
						"w": 599
					},
					{
						"n": 7,
						"h": 224,
						"w": 591
					},
					{
						"n": 18,
						"h": 64,
						"w": 576
					},
					{
						"n": 17,
						"h": 398,
						"w": 505
					},
					{
						"n": 19,
						"h": 289,
						"w": 428
					},
					{
						"n": 20,
						"h": 155,
						"w": 451
					}
				],
				"ball": {
					"n": 0,
					"h": 239,
					"w": 143,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 1352,
			"minute": 65,
			"messages": [
				{
					"owner": 1,
					"mes": "Пас в штрафную..."
				},
				{
					"owner": 1,
					"mes": "Байрон О`Горман[19](Галвэй Юнайтед) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 708
					},
					{
						"n": 2,
						"h": 391,
						"w": 347
					},
					{
						"n": 14,
						"h": 277,
						"w": 404
					},
					{
						"n": 13,
						"h": 180,
						"w": 389
					},
					{
						"n": 5,
						"h": 70,
						"w": 342
					},
					{
						"n": 6,
						"h": 344,
						"w": 91
					},
					{
						"n": 18,
						"h": 288,
						"w": 248
					},
					{
						"n": 15,
						"h": 229,
						"w": 146,
						"m": 600
					},
					{
						"n": 17,
						"h": 60,
						"w": 104
					},
					{
						"n": 20,
						"h": 287,
						"w": 89
					},
					{
						"n": 19,
						"h": 141,
						"w": 104
					}
				],
				"away": [
					{
						"n": 1,
						"h": 234,
						"w": 708
					},
					{
						"n": 13,
						"h": 374,
						"w": 636
					},
					{
						"n": 3,
						"h": 239,
						"w": 659
					},
					{
						"n": 14,
						"h": 189,
						"w": 635
					},
					{
						"n": 5,
						"h": 121,
						"w": 646
					},
					{
						"n": 6,
						"h": 255,
						"w": 616
					},
					{
						"n": 7,
						"h": 215,
						"w": 593
					},
					{
						"n": 18,
						"h": 51,
						"w": 551
					},
					{
						"n": 17,
						"h": 408,
						"w": 501
					},
					{
						"n": 19,
						"h": 288,
						"w": 425
					},
					{
						"n": 20,
						"h": 162,
						"w": 492
					}
				],
				"ball": {
					"n": 0,
					"h": 141,
					"w": 104,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 42
		},
		{
			"num": 1353,
			"minute": 65,
			"messages": [
				{
					"owner": 1,
					"mes": "Байрон О`Горман[19](Галвэй Юнайтед) приближается к воротам..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 703
					},
					{
						"n": 2,
						"h": 374,
						"w": 346
					},
					{
						"n": 14,
						"h": 275,
						"w": 393
					},
					{
						"n": 13,
						"h": 170,
						"w": 394
					},
					{
						"n": 5,
						"h": 69,
						"w": 355
					},
					{
						"n": 6,
						"h": 354,
						"w": 91
					},
					{
						"n": 18,
						"h": 275,
						"w": 269
					},
					{
						"n": 15,
						"h": 204,
						"w": 128
					},
					{
						"n": 17,
						"h": 64,
						"w": 80
					},
					{
						"n": 20,
						"h": 294,
						"w": 61
					},
					{
						"n": 19,
						"h": 160,
						"w": 80
					}
				],
				"away": [
					{
						"n": 1,
						"h": 234,
						"w": 708
					},
					{
						"n": 13,
						"h": 370,
						"w": 663
					},
					{
						"n": 3,
						"h": 268,
						"w": 667
					},
					{
						"n": 14,
						"h": 178,
						"w": 664
					},
					{
						"n": 5,
						"h": 102,
						"w": 634
					},
					{
						"n": 6,
						"h": 276,
						"w": 647
					},
					{
						"n": 7,
						"h": 236,
						"w": 599
					},
					{
						"n": 18,
						"h": 41,
						"w": 578
					},
					{
						"n": 17,
						"h": 395,
						"w": 528
					},
					{
						"n": 19,
						"h": 285,
						"w": 418
					},
					{
						"n": 20,
						"h": 175,
						"w": 471
					}
				],
				"ball": {
					"n": 0,
					"h": 160,
					"w": 80,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 31
		},
		{
			"num": 1354,
			"minute": 65,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 704
					},
					{
						"n": 2,
						"h": 387,
						"w": 348
					},
					{
						"n": 14,
						"h": 269,
						"w": 406
					},
					{
						"n": 13,
						"h": 184,
						"w": 406
					},
					{
						"n": 5,
						"h": 65,
						"w": 348
					},
					{
						"n": 6,
						"h": 364,
						"w": 82
					},
					{
						"n": 18,
						"h": 277,
						"w": 249
					},
					{
						"n": 15,
						"h": 187,
						"w": 139
					},
					{
						"n": 17,
						"h": 59,
						"w": 80
					},
					{
						"n": 20,
						"h": 279,
						"w": 52
					},
					{
						"n": 19,
						"h": 170,
						"w": 82
					}
				],
				"away": [
					{
						"n": 1,
						"h": 233,
						"w": 708
					},
					{
						"n": 13,
						"h": 375,
						"w": 672
					},
					{
						"n": 3,
						"h": 250,
						"w": 675
					},
					{
						"n": 14,
						"h": 174,
						"w": 681
					},
					{
						"n": 5,
						"h": 92,
						"w": 646
					},
					{
						"n": 6,
						"h": 274,
						"w": 646
					},
					{
						"n": 7,
						"h": 254,
						"w": 608
					},
					{
						"n": 18,
						"h": 41,
						"w": 578
					},
					{
						"n": 17,
						"h": 395,
						"w": 537
					},
					{
						"n": 19,
						"h": 295,
						"w": 420
					},
					{
						"n": 20,
						"h": 173,
						"w": 491
					}
				],
				"ball": {
					"n": 0,
					"h": 170,
					"w": 82,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 20
		},
		{
			"num": 1355,
			"minute": 65,
			"messages": [
				{
					"owner": 1,
					"mes": "Байрон О`Горман[19](Галвэй Юнайтед) укрывает мяч корпусом..."
				},
				{
					"owner": 1,
					"mes": "Байрон О`Горман[19](Галвэй Юнайтед) резко разворачивается... О.Дюмон[26](Опава) остается не у дел..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 704
					},
					{
						"n": 2,
						"h": 387,
						"w": 348
					},
					{
						"n": 14,
						"h": 269,
						"w": 406
					},
					{
						"n": 13,
						"h": 184,
						"w": 406
					},
					{
						"n": 5,
						"h": 65,
						"w": 348
					},
					{
						"n": 6,
						"h": 364,
						"w": 82
					},
					{
						"n": 18,
						"h": 279,
						"w": 234
					},
					{
						"n": 15,
						"h": 175,
						"w": 148
					},
					{
						"n": 17,
						"h": 59,
						"w": 80
					},
					{
						"n": 20,
						"h": 279,
						"w": 52
					},
					{
						"n": 19,
						"h": 183,
						"w": 75,
						"m": 630
					}
				],
				"away": [
					{
						"n": 1,
						"h": 233,
						"w": 708
					},
					{
						"n": 13,
						"h": 375,
						"w": 672
					},
					{
						"n": 3,
						"h": 237,
						"w": 681
					},
					{
						"n": 14,
						"h": 174,
						"w": 681
					},
					{
						"n": 5,
						"h": 92,
						"w": 646
					},
					{
						"n": 6,
						"h": 274,
						"w": 646,
						"m": 640
					},
					{
						"n": 7,
						"h": 266,
						"w": 613
					},
					{
						"n": 18,
						"h": 54,
						"w": 586
					},
					{
						"n": 17,
						"h": 395,
						"w": 537
					},
					{
						"n": 19,
						"h": 295,
						"w": 420
					},
					{
						"n": 20,
						"h": 173,
						"w": 491
					}
				],
				"ball": {
					"n": 0,
					"h": 183,
					"w": 75,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 15
		},
		{
			"num": 1356,
			"minute": 65,
			"messages": [
				{
					"owner": 1,
					"mes": "Байрон О`Горман[19](Галвэй Юнайтед), выворачивая ногу, бьет по воротам..."
				},
				{
					"owner": 1,
					"mes": "Рядом со штангой!"
				}
			],
			"U": {
				"team": 1,
				"player": 19,
				"xg": "0.13"
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 707
					},
					{
						"n": 2,
						"h": 372,
						"w": 351
					},
					{
						"n": 14,
						"h": 267,
						"w": 397
					},
					{
						"n": 13,
						"h": 167,
						"w": 402
					},
					{
						"n": 5,
						"h": 77,
						"w": 349
					},
					{
						"n": 6,
						"h": 374,
						"w": 80
					},
					{
						"n": 18,
						"h": 278,
						"w": 263
					},
					{
						"n": 15,
						"h": 167,
						"w": 120
					},
					{
						"n": 17,
						"h": 49,
						"w": 75
					},
					{
						"n": 20,
						"h": 278,
						"w": 50
					},
					{
						"n": 19,
						"h": 183,
						"w": 75
					}
				],
				"away": [
					{
						"n": 1,
						"h": 205,
						"w": 708
					},
					{
						"n": 13,
						"h": 385,
						"w": 665
					},
					{
						"n": 3,
						"h": 265,
						"w": 688
					},
					{
						"n": 14,
						"h": 185,
						"w": 693
					},
					{
						"n": 5,
						"h": 89,
						"w": 671
					},
					{
						"n": 6,
						"h": 264,
						"w": 649
					},
					{
						"n": 7,
						"h": 258,
						"w": 641
					},
					{
						"n": 18,
						"h": 39,
						"w": 580
					},
					{
						"n": 17,
						"h": 397,
						"w": 530
					},
					{
						"n": 19,
						"h": 291,
						"w": 416
					},
					{
						"n": 20,
						"h": 172,
						"w": 477
					}
				],
				"ball": {
					"n": 0,
					"h": 281,
					"w": -31,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 6
				}
			},
			"interval": 29
		},
		{
			"num": 1357,
			"minute": 66,
			"possession": 43,
			"messages": [
				{
					"owner": 2,
					"mes": "Удар от ворот... Крыштоф Ласак[21](Опава) устанавливает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 680,
						"f": 92
					},
					{
						"n": 2,
						"h": 378,
						"w": 543,
						"m": 670
					},
					{
						"n": 14,
						"h": 289,
						"w": 570,
						"f": 98
					},
					{
						"n": 13,
						"h": 162,
						"w": 570
					},
					{
						"n": 5,
						"h": 68,
						"w": 545
					},
					{
						"n": 6,
						"h": 381,
						"w": 447
					},
					{
						"n": 18,
						"h": 285,
						"w": 470
					},
					{
						"n": 15,
						"h": 170,
						"w": 470
					},
					{
						"n": 17,
						"h": 79,
						"w": 446,
						"f": 92
					},
					{
						"n": 20,
						"h": 286,
						"w": 370,
						"f": 91
					},
					{
						"n": 19,
						"h": 166,
						"w": 370,
						"f": 97
					}
				],
				"away": [
					{
						"n": 1,
						"h": 186,
						"w": 706
					},
					{
						"n": 13,
						"h": 388,
						"w": 437
					},
					{
						"n": 3,
						"h": 286,
						"w": 545
					},
					{
						"n": 14,
						"h": 166,
						"w": 545
					},
					{
						"n": 5,
						"h": 55,
						"w": 545
					},
					{
						"n": 6,
						"h": 226,
						"w": 437
					},
					{
						"n": 7,
						"h": 225,
						"w": 328
					},
					{
						"n": 18,
						"h": 50,
						"w": 348
					},
					{
						"n": 17,
						"h": 393,
						"w": 298,
						"f": 91
					},
					{
						"n": 19,
						"h": 287,
						"w": 220
					},
					{
						"n": 20,
						"h": 172,
						"w": 220
					}
				],
				"ball": {
					"n": 0,
					"h": 260,
					"w": 34,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 150
		},
		{
			"num": 1358,
			"minute": 66,
			"messages": [],
			"T": {
				"team": 2
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 677
					},
					{
						"n": 2,
						"h": 379,
						"w": 542
					},
					{
						"n": 14,
						"h": 292,
						"w": 577
					},
					{
						"n": 13,
						"h": 156,
						"w": 566
					},
					{
						"n": 5,
						"h": 75,
						"w": 538
					},
					{
						"n": 6,
						"h": 381,
						"w": 443
					},
					{
						"n": 18,
						"h": 286,
						"w": 473
					},
					{
						"n": 15,
						"h": 167,
						"w": 474
					},
					{
						"n": 17,
						"h": 75,
						"w": 440
					},
					{
						"n": 20,
						"h": 284,
						"w": 364
					},
					{
						"n": 19,
						"h": 163,
						"w": 374
					}
				],
				"away": [
					{
						"n": 1,
						"h": 190,
						"w": 686
					},
					{
						"n": 13,
						"h": 390,
						"w": 433
					},
					{
						"n": 3,
						"h": 287,
						"w": 538
					},
					{
						"n": 14,
						"h": 169,
						"w": 542
					},
					{
						"n": 5,
						"h": 57,
						"w": 538
					},
					{
						"n": 6,
						"h": 225,
						"w": 434
					},
					{
						"n": 7,
						"h": 227,
						"w": 325
					},
					{
						"n": 18,
						"h": 44,
						"w": 349
					},
					{
						"n": 17,
						"h": 386,
						"w": 295
					},
					{
						"n": 19,
						"h": 291,
						"w": 227
					},
					{
						"n": 20,
						"h": 173,
						"w": 223
					}
				],
				"ball": {
					"n": 0,
					"h": 260,
					"w": 34,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 15
		},
		{
			"num": 1359,
			"minute": 66,
			"messages": [
				{
					"owner": 2,
					"mes": "Крыштоф Ласак[21](Опава) выбивает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 707
					},
					{
						"n": 2,
						"h": 364,
						"w": 530
					},
					{
						"n": 14,
						"h": 230,
						"w": 575
					},
					{
						"n": 13,
						"h": 137,
						"w": 572
					},
					{
						"n": 5,
						"h": 93,
						"w": 585
					},
					{
						"n": 6,
						"h": 395,
						"w": 485
					},
					{
						"n": 18,
						"h": 286,
						"w": 499
					},
					{
						"n": 15,
						"h": 131,
						"w": 490
					},
					{
						"n": 17,
						"h": 24,
						"w": 485
					},
					{
						"n": 20,
						"h": 341,
						"w": 415
					},
					{
						"n": 19,
						"h": 168,
						"w": 383
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 670
					},
					{
						"n": 13,
						"h": 417,
						"w": 375
					},
					{
						"n": 3,
						"h": 276,
						"w": 542
					},
					{
						"n": 14,
						"h": 181,
						"w": 546
					},
					{
						"n": 5,
						"h": 63,
						"w": 541
					},
					{
						"n": 6,
						"h": 171,
						"w": 456
					},
					{
						"n": 7,
						"h": 109,
						"w": 325
					},
					{
						"n": 18,
						"h": 54,
						"w": 245
					},
					{
						"n": 17,
						"h": 400,
						"w": 229
					},
					{
						"n": 19,
						"h": 317,
						"w": 220
					},
					{
						"n": 20,
						"h": 56,
						"w": 210
					}
				],
				"ball": {
					"n": 0,
					"h": 395,
					"w": 485,
					"z": 1,
					"r": 0,
					"p": 4,
					"x": 0
				}
			},
			"interval": 118
		},
		{
			"num": 1360,
			"minute": 66,
			"messages": [
				{
					"owner": 1,
					"mes": "Киэн Колман[06](Галвэй Юнайтед) скидывает мяч головой..."
				},
				{
					"owner": 1,
					"mes": "Тимо Эверс[02](Галвэй Юнайтед) подрабатывает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 708
					},
					{
						"n": 2,
						"h": 366,
						"w": 528
					},
					{
						"n": 14,
						"h": 229,
						"w": 591
					},
					{
						"n": 13,
						"h": 143,
						"w": 588
					},
					{
						"n": 5,
						"h": 107,
						"w": 594
					},
					{
						"n": 6,
						"h": 395,
						"w": 485
					},
					{
						"n": 18,
						"h": 269,
						"w": 503
					},
					{
						"n": 15,
						"h": 144,
						"w": 499
					},
					{
						"n": 17,
						"h": 32,
						"w": 500
					},
					{
						"n": 20,
						"h": 327,
						"w": 406
					},
					{
						"n": 19,
						"h": 162,
						"w": 399
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 654
					},
					{
						"n": 13,
						"h": 405,
						"w": 363
					},
					{
						"n": 3,
						"h": 270,
						"w": 539
					},
					{
						"n": 14,
						"h": 180,
						"w": 534
					},
					{
						"n": 5,
						"h": 71,
						"w": 526
					},
					{
						"n": 6,
						"h": 171,
						"w": 456
					},
					{
						"n": 7,
						"h": 126,
						"w": 326
					},
					{
						"n": 18,
						"h": 54,
						"w": 245
					},
					{
						"n": 17,
						"h": 401,
						"w": 212
					},
					{
						"n": 19,
						"h": 301,
						"w": 215
					},
					{
						"n": 20,
						"h": 72,
						"w": 213
					}
				],
				"ball": {
					"n": 0,
					"h": 366,
					"w": 528,
					"z": 1,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 17
		},
		{
			"num": 1361,
			"minute": 66,
			"messages": [
				{
					"owner": 1,
					"mes": "Тимо Эверс[02](Галвэй Юнайтед) отправляет мяч направо Т.Смиту[14](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 702
					},
					{
						"n": 2,
						"h": 372,
						"w": 520
					},
					{
						"n": 14,
						"h": 255,
						"w": 574
					},
					{
						"n": 13,
						"h": 161,
						"w": 551
					},
					{
						"n": 5,
						"h": 94,
						"w": 556
					},
					{
						"n": 6,
						"h": 396,
						"w": 461
					},
					{
						"n": 18,
						"h": 288,
						"w": 467
					},
					{
						"n": 15,
						"h": 148,
						"w": 459
					},
					{
						"n": 17,
						"h": 36,
						"w": 460
					},
					{
						"n": 20,
						"h": 323,
						"w": 366
					},
					{
						"n": 19,
						"h": 157,
						"w": 359
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 650
					},
					{
						"n": 13,
						"h": 415,
						"w": 402
					},
					{
						"n": 3,
						"h": 248,
						"w": 506
					},
					{
						"n": 14,
						"h": 158,
						"w": 500
					},
					{
						"n": 5,
						"h": 104,
						"w": 503
					},
					{
						"n": 6,
						"h": 209,
						"w": 442
					},
					{
						"n": 7,
						"h": 158,
						"w": 350
					},
					{
						"n": 18,
						"h": 51,
						"w": 272
					},
					{
						"n": 17,
						"h": 407,
						"w": 252
					},
					{
						"n": 19,
						"h": 305,
						"w": 254
					},
					{
						"n": 20,
						"h": 93,
						"w": 247
					}
				],
				"ball": {
					"n": 0,
					"h": 255,
					"w": 574,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1362,
			"minute": 66,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 708
					},
					{
						"n": 2,
						"h": 377,
						"w": 480
					},
					{
						"n": 14,
						"h": 244,
						"w": 540
					},
					{
						"n": 13,
						"h": 172,
						"w": 524
					},
					{
						"n": 5,
						"h": 80,
						"w": 519
					},
					{
						"n": 6,
						"h": 393,
						"w": 421
					},
					{
						"n": 18,
						"h": 287,
						"w": 452
					},
					{
						"n": 15,
						"h": 148,
						"w": 419
					},
					{
						"n": 17,
						"h": 48,
						"w": 422
					},
					{
						"n": 20,
						"h": 314,
						"w": 327
					},
					{
						"n": 19,
						"h": 153,
						"w": 319
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 642
					},
					{
						"n": 13,
						"h": 404,
						"w": 440
					},
					{
						"n": 3,
						"h": 264,
						"w": 492
					},
					{
						"n": 14,
						"h": 182,
						"w": 508
					},
					{
						"n": 5,
						"h": 110,
						"w": 494
					},
					{
						"n": 6,
						"h": 169,
						"w": 440
					},
					{
						"n": 7,
						"h": 195,
						"w": 365
					},
					{
						"n": 18,
						"h": 41,
						"w": 311
					},
					{
						"n": 17,
						"h": 405,
						"w": 292
					},
					{
						"n": 19,
						"h": 310,
						"w": 294
					},
					{
						"n": 20,
						"h": 112,
						"w": 282
					}
				],
				"ball": {
					"n": 0,
					"h": 244,
					"w": 540,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1363,
			"minute": 66,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 701
					},
					{
						"n": 2,
						"h": 372,
						"w": 486
					},
					{
						"n": 14,
						"h": 238,
						"w": 505
					},
					{
						"n": 13,
						"h": 166,
						"w": 536
					},
					{
						"n": 5,
						"h": 69,
						"w": 481
					},
					{
						"n": 6,
						"h": 396,
						"w": 381
					},
					{
						"n": 18,
						"h": 287,
						"w": 420
					},
					{
						"n": 15,
						"h": 142,
						"w": 380
					},
					{
						"n": 17,
						"h": 51,
						"w": 382
					},
					{
						"n": 20,
						"h": 309,
						"w": 287
					},
					{
						"n": 19,
						"h": 149,
						"w": 280
					}
				],
				"away": [
					{
						"n": 1,
						"h": 226,
						"w": 643
					},
					{
						"n": 13,
						"h": 401,
						"w": 400
					},
					{
						"n": 3,
						"h": 265,
						"w": 491
					},
					{
						"n": 14,
						"h": 182,
						"w": 485
					},
					{
						"n": 5,
						"h": 110,
						"w": 507
					},
					{
						"n": 6,
						"h": 131,
						"w": 448
					},
					{
						"n": 7,
						"h": 227,
						"w": 366
					},
					{
						"n": 18,
						"h": 49,
						"w": 350
					},
					{
						"n": 17,
						"h": 423,
						"w": 328
					},
					{
						"n": 19,
						"h": 294,
						"w": 309
					},
					{
						"n": 20,
						"h": 135,
						"w": 315
					}
				],
				"ball": {
					"n": 0,
					"h": 238,
					"w": 505,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1364,
			"minute": 66,
			"messages": [
				{
					"owner": 1,
					"mes": "Пас направо С.Фридйонссону[05](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 709
					},
					{
						"n": 2,
						"h": 376,
						"w": 470
					},
					{
						"n": 14,
						"h": 248,
						"w": 508
					},
					{
						"n": 13,
						"h": 164,
						"w": 512
					},
					{
						"n": 5,
						"h": 124,
						"w": 467
					},
					{
						"n": 6,
						"h": 405,
						"w": 325
					},
					{
						"n": 18,
						"h": 295,
						"w": 425
					},
					{
						"n": 15,
						"h": 168,
						"w": 329
					},
					{
						"n": 17,
						"h": 36,
						"w": 332
					},
					{
						"n": 20,
						"h": 290,
						"w": 233
					},
					{
						"n": 19,
						"h": 155,
						"w": 224
					}
				],
				"away": [
					{
						"n": 1,
						"h": 245,
						"w": 641
					},
					{
						"n": 13,
						"h": 406,
						"w": 424
					},
					{
						"n": 3,
						"h": 279,
						"w": 546
					},
					{
						"n": 14,
						"h": 174,
						"w": 528
					},
					{
						"n": 5,
						"h": 110,
						"w": 550
					},
					{
						"n": 6,
						"h": 184,
						"w": 469
					},
					{
						"n": 7,
						"h": 231,
						"w": 423
					},
					{
						"n": 18,
						"h": 46,
						"w": 407
					},
					{
						"n": 17,
						"h": 411,
						"w": 363
					},
					{
						"n": 19,
						"h": 326,
						"w": 273
					},
					{
						"n": 20,
						"h": 155,
						"w": 315
					}
				],
				"ball": {
					"n": 0,
					"h": 124,
					"w": 467,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 57
		},
		{
			"num": 1365,
			"minute": 66,
			"messages": [
				{
					"owner": 1,
					"mes": "Передача Б.Регану[13](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 710
					},
					{
						"n": 2,
						"h": 374,
						"w": 442
					},
					{
						"n": 14,
						"h": 269,
						"w": 485
					},
					{
						"n": 13,
						"h": 154,
						"w": 482
					},
					{
						"n": 5,
						"h": 115,
						"w": 462
					},
					{
						"n": 6,
						"h": 404,
						"w": 293
					},
					{
						"n": 18,
						"h": 287,
						"w": 394
					},
					{
						"n": 15,
						"h": 167,
						"w": 297
					},
					{
						"n": 17,
						"h": 50,
						"w": 303
					},
					{
						"n": 20,
						"h": 296,
						"w": 203
					},
					{
						"n": 19,
						"h": 171,
						"w": 200
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 645
					},
					{
						"n": 13,
						"h": 400,
						"w": 453
					},
					{
						"n": 3,
						"h": 264,
						"w": 575
					},
					{
						"n": 14,
						"h": 174,
						"w": 560
					},
					{
						"n": 5,
						"h": 110,
						"w": 564
					},
					{
						"n": 6,
						"h": 168,
						"w": 497
					},
					{
						"n": 7,
						"h": 218,
						"w": 451
					},
					{
						"n": 18,
						"h": 46,
						"w": 439
					},
					{
						"n": 17,
						"h": 415,
						"w": 374
					},
					{
						"n": 19,
						"h": 315,
						"w": 303
					},
					{
						"n": 20,
						"h": 147,
						"w": 346
					}
				],
				"ball": {
					"n": 0,
					"h": 154,
					"w": 482,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 32
		},
		{
			"num": 1366,
			"minute": 66,
			"messages": [
				{
					"owner": 1,
					"mes": "Билли Реган[13](Галвэй Юнайтед) не смог зацепиться за мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 706
					},
					{
						"n": 2,
						"h": 375,
						"w": 438
					},
					{
						"n": 14,
						"h": 271,
						"w": 482
					},
					{
						"n": 13,
						"h": 154,
						"w": 482
					},
					{
						"n": 5,
						"h": 119,
						"w": 463
					},
					{
						"n": 6,
						"h": 404,
						"w": 289
					},
					{
						"n": 18,
						"h": 284,
						"w": 391
					},
					{
						"n": 15,
						"h": 168,
						"w": 293
					},
					{
						"n": 17,
						"h": 50,
						"w": 299
					},
					{
						"n": 20,
						"h": 294,
						"w": 200
					},
					{
						"n": 19,
						"h": 172,
						"w": 196
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 647
					},
					{
						"n": 13,
						"h": 400,
						"w": 457
					},
					{
						"n": 3,
						"h": 268,
						"w": 577
					},
					{
						"n": 14,
						"h": 178,
						"w": 560
					},
					{
						"n": 5,
						"h": 114,
						"w": 563
					},
					{
						"n": 6,
						"h": 168,
						"w": 501
					},
					{
						"n": 7,
						"h": 216,
						"w": 447
					},
					{
						"n": 18,
						"h": 46,
						"w": 443
					},
					{
						"n": 17,
						"h": 415,
						"w": 374
					},
					{
						"n": 19,
						"h": 314,
						"w": 299
					},
					{
						"n": 20,
						"h": 146,
						"w": 350
					}
				],
				"ball": {
					"n": 0,
					"h": 144,
					"w": 472,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 4
		},
		{
			"num": 1367,
			"minute": 66,
			"messages": [
				{
					"owner": 1,
					"mes": "Билли Реган[13](Галвэй Юнайтед) все же подбирает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 704
					},
					{
						"n": 2,
						"h": 377,
						"w": 425
					},
					{
						"n": 14,
						"h": 277,
						"w": 469
					},
					{
						"n": 13,
						"h": 144,
						"w": 472
					},
					{
						"n": 5,
						"h": 132,
						"w": 468
					},
					{
						"n": 6,
						"h": 401,
						"w": 275
					},
					{
						"n": 18,
						"h": 291,
						"w": 379
					},
					{
						"n": 15,
						"h": 172,
						"w": 280
					},
					{
						"n": 17,
						"h": 49,
						"w": 285
					},
					{
						"n": 20,
						"h": 286,
						"w": 188
					},
					{
						"n": 19,
						"h": 167,
						"w": 183
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 646
					},
					{
						"n": 13,
						"h": 401,
						"w": 471
					},
					{
						"n": 3,
						"h": 270,
						"w": 576
					},
					{
						"n": 14,
						"h": 176,
						"w": 574
					},
					{
						"n": 5,
						"h": 112,
						"w": 577
					},
					{
						"n": 6,
						"h": 163,
						"w": 514
					},
					{
						"n": 7,
						"h": 223,
						"w": 454
					},
					{
						"n": 18,
						"h": 47,
						"w": 457
					},
					{
						"n": 17,
						"h": 415,
						"w": 374
					},
					{
						"n": 19,
						"h": 312,
						"w": 285
					},
					{
						"n": 20,
						"h": 143,
						"w": 364
					}
				],
				"ball": {
					"n": 0,
					"h": 144,
					"w": 472,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 14
		},
		{
			"num": 1368,
			"minute": 66,
			"messages": [
				{
					"owner": 1,
					"mes": "Билли Реган[13](Галвэй Юнайтед) пасует на левый фланг на ход Т.Эверсу[02](Галвэй Юнайтед)..."
				},
				{
					"owner": 1,
					"mes": "Тимо Эверс[02](Галвэй Юнайтед) подрабатывает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 708
					},
					{
						"n": 2,
						"h": 419,
						"w": 383
					},
					{
						"n": 14,
						"h": 285,
						"w": 456
					},
					{
						"n": 13,
						"h": 153,
						"w": 464
					},
					{
						"n": 5,
						"h": 79,
						"w": 420
					},
					{
						"n": 6,
						"h": 398,
						"w": 203
					},
					{
						"n": 18,
						"h": 309,
						"w": 353
					},
					{
						"n": 15,
						"h": 221,
						"w": 246
					},
					{
						"n": 17,
						"h": 59,
						"w": 276
					},
					{
						"n": 20,
						"h": 287,
						"w": 167
					},
					{
						"n": 19,
						"h": 180,
						"w": 164
					}
				],
				"away": [
					{
						"n": 1,
						"h": 205,
						"w": 650
					},
					{
						"n": 13,
						"h": 391,
						"w": 480
					},
					{
						"n": 3,
						"h": 256,
						"w": 621
					},
					{
						"n": 14,
						"h": 176,
						"w": 640
					},
					{
						"n": 5,
						"h": 80,
						"w": 620
					},
					{
						"n": 6,
						"h": 173,
						"w": 565
					},
					{
						"n": 7,
						"h": 205,
						"w": 515
					},
					{
						"n": 18,
						"h": 49,
						"w": 385
					},
					{
						"n": 17,
						"h": 409,
						"w": 426
					},
					{
						"n": 19,
						"h": 300,
						"w": 356
					},
					{
						"n": 20,
						"h": 141,
						"w": 387
					}
				],
				"ball": {
					"n": 0,
					"h": 419,
					"w": 383,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 72
		},
		{
			"num": 1369,
			"minute": 66,
			"messages": [
				{
					"owner": 1,
					"mes": "Справа открывается Том Смит[14](Галвэй Юнайтед)... Передача..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 710
					},
					{
						"n": 2,
						"h": 401,
						"w": 380
					},
					{
						"n": 14,
						"h": 249,
						"w": 424
					},
					{
						"n": 13,
						"h": 183,
						"w": 426
					},
					{
						"n": 5,
						"h": 65,
						"w": 378
					},
					{
						"n": 6,
						"h": 404,
						"w": 160
					},
					{
						"n": 18,
						"h": 294,
						"w": 340
					},
					{
						"n": 15,
						"h": 174,
						"w": 239
					},
					{
						"n": 17,
						"h": 54,
						"w": 228
					},
					{
						"n": 20,
						"h": 282,
						"w": 133
					},
					{
						"n": 19,
						"h": 152,
						"w": 133
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 694
					},
					{
						"n": 13,
						"h": 396,
						"w": 528
					},
					{
						"n": 3,
						"h": 288,
						"w": 612
					},
					{
						"n": 14,
						"h": 186,
						"w": 604
					},
					{
						"n": 5,
						"h": 71,
						"w": 580
					},
					{
						"n": 6,
						"h": 220,
						"w": 556
					},
					{
						"n": 7,
						"h": 220,
						"w": 472
					},
					{
						"n": 18,
						"h": 48,
						"w": 433
					},
					{
						"n": 17,
						"h": 403,
						"w": 453
					},
					{
						"n": 19,
						"h": 257,
						"w": 333
					},
					{
						"n": 20,
						"h": 156,
						"w": 400
					}
				],
				"ball": {
					"n": 0,
					"h": 278,
					"w": 405,
					"z": 0,
					"r": 0,
					"p": 2,
					"x": 0
				}
			},
			"interval": 48
		},
		{
			"num": 1370,
			"minute": 66,
			"messages": [
				{
					"owner": 1,
					"mes": "Том Смит[14](Галвэй Юнайтед) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 701
					},
					{
						"n": 2,
						"h": 379,
						"w": 387
					},
					{
						"n": 14,
						"h": 236,
						"w": 412,
						"m": 610
					},
					{
						"n": 13,
						"h": 179,
						"w": 436
					},
					{
						"n": 5,
						"h": 75,
						"w": 377
					},
					{
						"n": 6,
						"h": 412,
						"w": 160
					},
					{
						"n": 18,
						"h": 286,
						"w": 329
					},
					{
						"n": 15,
						"h": 177,
						"w": 252
					},
					{
						"n": 17,
						"h": 48,
						"w": 201
					},
					{
						"n": 20,
						"h": 276,
						"w": 148
					},
					{
						"n": 19,
						"h": 161,
						"w": 138
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 666
					},
					{
						"n": 13,
						"h": 402,
						"w": 555
					},
					{
						"n": 3,
						"h": 272,
						"w": 597
					},
					{
						"n": 14,
						"h": 185,
						"w": 583
					},
					{
						"n": 5,
						"h": 45,
						"w": 569
					},
					{
						"n": 6,
						"h": 233,
						"w": 531
					},
					{
						"n": 7,
						"h": 235,
						"w": 468
					},
					{
						"n": 18,
						"h": 47,
						"w": 461
					},
					{
						"n": 17,
						"h": 405,
						"w": 451
					},
					{
						"n": 19,
						"h": 233,
						"w": 320
					},
					{
						"n": 20,
						"h": 164,
						"w": 411
					}
				],
				"ball": {
					"n": 0,
					"h": 236,
					"w": 412,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 28
		},
		{
			"num": 1371,
			"minute": 66,
			"messages": [
				{
					"owner": 1,
					"mes": "Том Смит[14](Галвэй Юнайтед) посылает мяч направо в направлении С.Фридйонссона[05](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 703
					},
					{
						"n": 2,
						"h": 388,
						"w": 370
					},
					{
						"n": 14,
						"h": 246,
						"w": 412
					},
					{
						"n": 13,
						"h": 184,
						"w": 411
					},
					{
						"n": 5,
						"h": 89,
						"w": 394
					},
					{
						"n": 6,
						"h": 392,
						"w": 160
					},
					{
						"n": 18,
						"h": 237,
						"w": 322
					},
					{
						"n": 15,
						"h": 150,
						"w": 235
					},
					{
						"n": 17,
						"h": 57,
						"w": 160
					},
					{
						"n": 20,
						"h": 282,
						"w": 156
					},
					{
						"n": 19,
						"h": 179,
						"w": 136
					}
				],
				"away": [
					{
						"n": 1,
						"h": 245,
						"w": 647
					},
					{
						"n": 13,
						"h": 393,
						"w": 596
					},
					{
						"n": 3,
						"h": 252,
						"w": 636
					},
					{
						"n": 14,
						"h": 185,
						"w": 632
					},
					{
						"n": 5,
						"h": 80,
						"w": 604
					},
					{
						"n": 6,
						"h": 257,
						"w": 573
					},
					{
						"n": 7,
						"h": 241,
						"w": 510
					},
					{
						"n": 18,
						"h": 30,
						"w": 507
					},
					{
						"n": 17,
						"h": 384,
						"w": 407
					},
					{
						"n": 19,
						"h": 257,
						"w": 363
					},
					{
						"n": 20,
						"h": 213,
						"w": 418
					}
				],
				"ball": {
					"n": 0,
					"h": 89,
					"w": 394,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 49
		},
		{
			"num": 1372,
			"minute": 66,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 709
					},
					{
						"n": 2,
						"h": 373,
						"w": 349
					},
					{
						"n": 14,
						"h": 284,
						"w": 424
					},
					{
						"n": 13,
						"h": 173,
						"w": 385
					},
					{
						"n": 5,
						"h": 92,
						"w": 359
					},
					{
						"n": 6,
						"h": 394,
						"w": 200
					},
					{
						"n": 18,
						"h": 251,
						"w": 360
					},
					{
						"n": 15,
						"h": 144,
						"w": 195
					},
					{
						"n": 17,
						"h": 55,
						"w": 200
					},
					{
						"n": 20,
						"h": 296,
						"w": 118
					},
					{
						"n": 19,
						"h": 175,
						"w": 176
					}
				],
				"away": [
					{
						"n": 1,
						"h": 234,
						"w": 685
					},
					{
						"n": 13,
						"h": 395,
						"w": 556
					},
					{
						"n": 3,
						"h": 225,
						"w": 629
					},
					{
						"n": 14,
						"h": 154,
						"w": 638
					},
					{
						"n": 5,
						"h": 109,
						"w": 631
					},
					{
						"n": 6,
						"h": 282,
						"w": 560
					},
					{
						"n": 7,
						"h": 277,
						"w": 517
					},
					{
						"n": 18,
						"h": 48,
						"w": 542
					},
					{
						"n": 17,
						"h": 353,
						"w": 381
					},
					{
						"n": 19,
						"h": 274,
						"w": 399
					},
					{
						"n": 20,
						"h": 173,
						"w": 413
					}
				],
				"ball": {
					"n": 0,
					"h": 92,
					"w": 359,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1373,
			"minute": 66,
			"messages": [
				{
					"owner": 1,
					"mes": "Пас правее на М.Раума[17](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 710
					},
					{
						"n": 2,
						"h": 377,
						"w": 348
					},
					{
						"n": 14,
						"h": 275,
						"w": 395
					},
					{
						"n": 13,
						"h": 186,
						"w": 391
					},
					{
						"n": 5,
						"h": 82,
						"w": 359,
						"m": 680
					},
					{
						"n": 6,
						"h": 390,
						"w": 158
					},
					{
						"n": 18,
						"h": 240,
						"w": 319
					},
					{
						"n": 15,
						"h": 156,
						"w": 213
					},
					{
						"n": 17,
						"h": 48,
						"w": 241
					},
					{
						"n": 20,
						"h": 287,
						"w": 137
					},
					{
						"n": 19,
						"h": 157,
						"w": 138
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 702
					},
					{
						"n": 13,
						"h": 388,
						"w": 515
					},
					{
						"n": 3,
						"h": 264,
						"w": 614
					},
					{
						"n": 14,
						"h": 177,
						"w": 609
					},
					{
						"n": 5,
						"h": 110,
						"w": 605
					},
					{
						"n": 6,
						"h": 285,
						"w": 583
					},
					{
						"n": 7,
						"h": 300,
						"w": 509
					},
					{
						"n": 18,
						"h": 57,
						"w": 583
					},
					{
						"n": 17,
						"h": 379,
						"w": 414
					},
					{
						"n": 19,
						"h": 295,
						"w": 424
					},
					{
						"n": 20,
						"h": 210,
						"w": 421
					}
				],
				"ball": {
					"n": 0,
					"h": 48,
					"w": 241,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 42
		},
		{
			"num": 1374,
			"minute": 67,
			"possession": 44,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 708
					},
					{
						"n": 2,
						"h": 381,
						"w": 376,
						"f": 81
					},
					{
						"n": 14,
						"h": 275,
						"w": 420
					},
					{
						"n": 13,
						"h": 184,
						"w": 399
					},
					{
						"n": 5,
						"h": 69,
						"w": 363
					},
					{
						"n": 6,
						"h": 403,
						"w": 120
					},
					{
						"n": 18,
						"h": 250,
						"w": 280
					},
					{
						"n": 15,
						"h": 144,
						"w": 175
					},
					{
						"n": 17,
						"h": 71,
						"w": 215
					},
					{
						"n": 20,
						"h": 307,
						"w": 122
					},
					{
						"n": 19,
						"h": 137,
						"w": 120
					}
				],
				"away": [
					{
						"n": 1,
						"h": 238,
						"w": 665
					},
					{
						"n": 13,
						"h": 370,
						"w": 521,
						"f": 92
					},
					{
						"n": 3,
						"h": 278,
						"w": 609,
						"m": 650
					},
					{
						"n": 14,
						"h": 188,
						"w": 631
					},
					{
						"n": 5,
						"h": 110,
						"w": 610
					},
					{
						"n": 6,
						"h": 297,
						"w": 558
					},
					{
						"n": 7,
						"h": 260,
						"w": 509,
						"f": 83
					},
					{
						"n": 18,
						"h": 55,
						"w": 543
					},
					{
						"n": 17,
						"h": 401,
						"w": 447
					},
					{
						"n": 19,
						"h": 294,
						"w": 412
					},
					{
						"n": 20,
						"h": 170,
						"w": 413
					}
				],
				"ball": {
					"n": 0,
					"h": 71,
					"w": 215,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1375,
			"minute": 67,
			"messages": [
				{
					"owner": 1,
					"mes": "М.Раум[17](Галвэй Юнайтед) пытается пройти К.Удре[33](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 708
					},
					{
						"n": 2,
						"h": 378,
						"w": 366
					},
					{
						"n": 14,
						"h": 280,
						"w": 423
					},
					{
						"n": 13,
						"h": 182,
						"w": 409
					},
					{
						"n": 5,
						"h": 64,
						"w": 369
					},
					{
						"n": 6,
						"h": 410,
						"w": 127
					},
					{
						"n": 18,
						"h": 247,
						"w": 271
					},
					{
						"n": 15,
						"h": 153,
						"w": 177
					},
					{
						"n": 17,
						"h": 71,
						"w": 205
					},
					{
						"n": 20,
						"h": 298,
						"w": 117
					},
					{
						"n": 19,
						"h": 147,
						"w": 119
					}
				],
				"away": [
					{
						"n": 1,
						"h": 236,
						"w": 675
					},
					{
						"n": 13,
						"h": 379,
						"w": 515
					},
					{
						"n": 3,
						"h": 288,
						"w": 613
					},
					{
						"n": 14,
						"h": 198,
						"w": 632
					},
					{
						"n": 5,
						"h": 119,
						"w": 614
					},
					{
						"n": 6,
						"h": 297,
						"w": 548
					},
					{
						"n": 7,
						"h": 250,
						"w": 507
					},
					{
						"n": 18,
						"h": 55,
						"w": 553
					},
					{
						"n": 17,
						"h": 401,
						"w": 447
					},
					{
						"n": 19,
						"h": 286,
						"w": 418
					},
					{
						"n": 20,
						"h": 175,
						"w": 422
					}
				],
				"ball": {
					"n": 0,
					"h": 71,
					"w": 205,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 10
		},
		{
			"num": 1376,
			"minute": 67,
			"messages": [
				{
					"owner": 1,
					"mes": "Маттиас Раум[17](Галвэй Юнайтед) убегает от К.Удре[33](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 707
					},
					{
						"n": 2,
						"h": 390,
						"w": 350
					},
					{
						"n": 14,
						"h": 271,
						"w": 405
					},
					{
						"n": 13,
						"h": 165,
						"w": 399
					},
					{
						"n": 5,
						"h": 59,
						"w": 350
					},
					{
						"n": 6,
						"h": 406,
						"w": 118
					},
					{
						"n": 18,
						"h": 257,
						"w": 288
					},
					{
						"n": 15,
						"h": 145,
						"w": 180
					},
					{
						"n": 17,
						"h": 71,
						"w": 177
					},
					{
						"n": 20,
						"h": 281,
						"w": 108
					},
					{
						"n": 19,
						"h": 156,
						"w": 107
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 695
					},
					{
						"n": 13,
						"h": 379,
						"w": 527
					},
					{
						"n": 3,
						"h": 282,
						"w": 629
					},
					{
						"n": 14,
						"h": 181,
						"w": 623
					},
					{
						"n": 5,
						"h": 110,
						"w": 629
					},
					{
						"n": 6,
						"h": 311,
						"w": 558
					},
					{
						"n": 7,
						"h": 250,
						"w": 497
					},
					{
						"n": 18,
						"h": 38,
						"w": 543
					},
					{
						"n": 17,
						"h": 401,
						"w": 447
					},
					{
						"n": 19,
						"h": 290,
						"w": 430
					},
					{
						"n": 20,
						"h": 186,
						"w": 439
					}
				],
				"ball": {
					"n": 0,
					"h": 71,
					"w": 149,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 20
		},
		{
			"num": 1377,
			"minute": 67,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 704
					},
					{
						"n": 2,
						"h": 376,
						"w": 354
					},
					{
						"n": 14,
						"h": 271,
						"w": 407
					},
					{
						"n": 13,
						"h": 182,
						"w": 409
					},
					{
						"n": 5,
						"h": 67,
						"w": 362
					},
					{
						"n": 6,
						"h": 387,
						"w": 121
					},
					{
						"n": 18,
						"h": 251,
						"w": 269
					},
					{
						"n": 15,
						"h": 162,
						"w": 169
					},
					{
						"n": 17,
						"h": 71,
						"w": 149
					},
					{
						"n": 20,
						"h": 299,
						"w": 98
					},
					{
						"n": 19,
						"h": 158,
						"w": 98
					}
				],
				"away": [
					{
						"n": 1,
						"h": 243,
						"w": 703
					},
					{
						"n": 13,
						"h": 379,
						"w": 539
					},
					{
						"n": 3,
						"h": 272,
						"w": 644
					},
					{
						"n": 14,
						"h": 170,
						"w": 629
					},
					{
						"n": 5,
						"h": 110,
						"w": 637
					},
					{
						"n": 6,
						"h": 328,
						"w": 569
					},
					{
						"n": 7,
						"h": 245,
						"w": 516
					},
					{
						"n": 18,
						"h": 47,
						"w": 541
					},
					{
						"n": 17,
						"h": 401,
						"w": 447
					},
					{
						"n": 19,
						"h": 283,
						"w": 426
					},
					{
						"n": 20,
						"h": 171,
						"w": 426
					}
				],
				"ball": {
					"n": 0,
					"h": 71,
					"w": 149,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 20
		},
		{
			"num": 1378,
			"minute": 67,
			"messages": [
				{
					"owner": 1,
					"mes": "Маттиас Раум[17](Галвэй Юнайтед) смещается в центр..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 702
					},
					{
						"n": 2,
						"h": 386,
						"w": 356
					},
					{
						"n": 14,
						"h": 273,
						"w": 400
					},
					{
						"n": 13,
						"h": 181,
						"w": 405
					},
					{
						"n": 5,
						"h": 60,
						"w": 356
					},
					{
						"n": 6,
						"h": 388,
						"w": 114
					},
					{
						"n": 18,
						"h": 220,
						"w": 287
					},
					{
						"n": 15,
						"h": 136,
						"w": 153
					},
					{
						"n": 17,
						"h": 108,
						"w": 134,
						"m": 710
					},
					{
						"n": 20,
						"h": 282,
						"w": 88
					},
					{
						"n": 19,
						"h": 179,
						"w": 90
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 709
					},
					{
						"n": 13,
						"h": 366,
						"w": 553,
						"m": 590
					},
					{
						"n": 3,
						"h": 255,
						"w": 641
					},
					{
						"n": 14,
						"h": 178,
						"w": 654
					},
					{
						"n": 5,
						"h": 110,
						"w": 656
					},
					{
						"n": 6,
						"h": 341,
						"w": 605
					},
					{
						"n": 7,
						"h": 277,
						"w": 541
					},
					{
						"n": 18,
						"h": 46,
						"w": 551
					},
					{
						"n": 17,
						"h": 408,
						"w": 466
					},
					{
						"n": 19,
						"h": 247,
						"w": 444
					},
					{
						"n": 20,
						"h": 162,
						"w": 422
					}
				],
				"ball": {
					"n": 0,
					"h": 108,
					"w": 134,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1379,
			"minute": 67,
			"messages": [
				{
					"owner": 1,
					"mes": "Пас К.Келли[15](Галвэй Юнайтед)..."
				},
				{
					"owner": 1,
					"mes": "Кевин Келли[15](Галвэй Юнайтед) получил мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 708
					},
					{
						"n": 2,
						"h": 391,
						"w": 345
					},
					{
						"n": 14,
						"h": 275,
						"w": 392
					},
					{
						"n": 13,
						"h": 171,
						"w": 393
					},
					{
						"n": 5,
						"h": 75,
						"w": 351
					},
					{
						"n": 6,
						"h": 396,
						"w": 96
					},
					{
						"n": 18,
						"h": 231,
						"w": 270
					},
					{
						"n": 15,
						"h": 148,
						"w": 141
					},
					{
						"n": 17,
						"h": 110,
						"w": 125
					},
					{
						"n": 20,
						"h": 279,
						"w": 83
					},
					{
						"n": 19,
						"h": 159,
						"w": 91
					}
				],
				"away": [
					{
						"n": 1,
						"h": 232,
						"w": 707
					},
					{
						"n": 13,
						"h": 366,
						"w": 553
					},
					{
						"n": 3,
						"h": 273,
						"w": 650
					},
					{
						"n": 14,
						"h": 190,
						"w": 652
					},
					{
						"n": 5,
						"h": 110,
						"w": 647
					},
					{
						"n": 6,
						"h": 321,
						"w": 604
					},
					{
						"n": 7,
						"h": 287,
						"w": 558
					},
					{
						"n": 18,
						"h": 26,
						"w": 555
					},
					{
						"n": 17,
						"h": 408,
						"w": 466
					},
					{
						"n": 19,
						"h": 266,
						"w": 438
					},
					{
						"n": 20,
						"h": 177,
						"w": 435
					}
				],
				"ball": {
					"n": 0,
					"h": 148,
					"w": 141,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 20
		},
		{
			"num": 1380,
			"minute": 67,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 705
					},
					{
						"n": 2,
						"h": 389,
						"w": 352
					},
					{
						"n": 14,
						"h": 274,
						"w": 400
					},
					{
						"n": 13,
						"h": 166,
						"w": 410
					},
					{
						"n": 5,
						"h": 67,
						"w": 346
					},
					{
						"n": 6,
						"h": 400,
						"w": 95
					},
					{
						"n": 18,
						"h": 239,
						"w": 251
					},
					{
						"n": 15,
						"h": 148,
						"w": 124
					},
					{
						"n": 17,
						"h": 104,
						"w": 104
					},
					{
						"n": 20,
						"h": 296,
						"w": 90
					},
					{
						"n": 19,
						"h": 161,
						"w": 90
					}
				],
				"away": [
					{
						"n": 1,
						"h": 233,
						"w": 707
					},
					{
						"n": 13,
						"h": 378,
						"w": 571
					},
					{
						"n": 3,
						"h": 269,
						"w": 642
					},
					{
						"n": 14,
						"h": 171,
						"w": 643
					},
					{
						"n": 5,
						"h": 110,
						"w": 644
					},
					{
						"n": 6,
						"h": 302,
						"w": 596
					},
					{
						"n": 7,
						"h": 294,
						"w": 573
					},
					{
						"n": 18,
						"h": 27,
						"w": 554
					},
					{
						"n": 17,
						"h": 408,
						"w": 467
					},
					{
						"n": 19,
						"h": 276,
						"w": 419
					},
					{
						"n": 20,
						"h": 188,
						"w": 453
					}
				],
				"ball": {
					"n": 0,
					"h": 148,
					"w": 124,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 21
		},
		{
			"num": 1381,
			"minute": 67,
			"messages": [
				{
					"owner": 1,
					"mes": "К.Келли[15](Галвэй Юнайтед) пытается пройти О.Дюмона[26](Опава)..."
				},
				{
					"owner": 1,
					"mes": "Кевин Келли[15](Галвэй Юнайтед) обманным движением уходит от О.Дюмона[26](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 706
					},
					{
						"n": 2,
						"h": 391,
						"w": 345
					},
					{
						"n": 14,
						"h": 269,
						"w": 391
					},
					{
						"n": 13,
						"h": 188,
						"w": 382
					},
					{
						"n": 5,
						"h": 69,
						"w": 346
					},
					{
						"n": 6,
						"h": 392,
						"w": 95
					},
					{
						"n": 18,
						"h": 273,
						"w": 272
					},
					{
						"n": 15,
						"h": 148,
						"w": 84,
						"m": 620
					},
					{
						"n": 17,
						"h": 94,
						"w": 84
					},
					{
						"n": 20,
						"h": 276,
						"w": 65
					},
					{
						"n": 19,
						"h": 183,
						"w": 79
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 709
					},
					{
						"n": 13,
						"h": 371,
						"w": 610
					},
					{
						"n": 3,
						"h": 302,
						"w": 641
					},
					{
						"n": 14,
						"h": 207,
						"w": 660
					},
					{
						"n": 5,
						"h": 110,
						"w": 666
					},
					{
						"n": 6,
						"h": 293,
						"w": 592,
						"m": 630
					},
					{
						"n": 7,
						"h": 293,
						"w": 593
					},
					{
						"n": 18,
						"h": 27,
						"w": 565
					},
					{
						"n": 17,
						"h": 417,
						"w": 506
					},
					{
						"n": 19,
						"h": 292,
						"w": 427
					},
					{
						"n": 20,
						"h": 177,
						"w": 468
					}
				],
				"ball": {
					"n": 0,
					"h": 148,
					"w": 84,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1382,
			"minute": 67,
			"messages": [
				{
					"owner": 1,
					"mes": "Н.Мансур[23](Опава) вступает в единоборство с К.Келли[15](Галвэй Юнайтед)..."
				},
				{
					"owner": 1,
					"mes": "Классный отбор Н.Мансура[23](Опава)!.."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 703
					},
					{
						"n": 2,
						"h": 386,
						"w": 346
					},
					{
						"n": 14,
						"h": 272,
						"w": 395
					},
					{
						"n": 13,
						"h": 185,
						"w": 386
					},
					{
						"n": 5,
						"h": 74,
						"w": 344
					},
					{
						"n": 6,
						"h": 397,
						"w": 94
					},
					{
						"n": 18,
						"h": 274,
						"w": 267
					},
					{
						"n": 15,
						"h": 148,
						"w": 79
					},
					{
						"n": 17,
						"h": 89,
						"w": 84
					},
					{
						"n": 20,
						"h": 274,
						"w": 65
					},
					{
						"n": 19,
						"h": 182,
						"w": 74
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 709
					},
					{
						"n": 13,
						"h": 371,
						"w": 615
					},
					{
						"n": 3,
						"h": 302,
						"w": 636,
						"m": 660
					},
					{
						"n": 14,
						"h": 212,
						"w": 662
					},
					{
						"n": 5,
						"h": 110,
						"w": 667
					},
					{
						"n": 6,
						"h": 288,
						"w": 595
					},
					{
						"n": 7,
						"h": 293,
						"w": 598
					},
					{
						"n": 18,
						"h": 31,
						"w": 568
					},
					{
						"n": 17,
						"h": 415,
						"w": 510
					},
					{
						"n": 19,
						"h": 287,
						"w": 427
					},
					{
						"n": 20,
						"h": 177,
						"w": 468
					}
				],
				"ball": {
					"n": 0,
					"h": 148,
					"w": 84,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 4
				}
			},
			"interval": 5
		},
		{
			"num": 1383,
			"minute": 67,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 703
					},
					{
						"n": 2,
						"h": 376,
						"w": 348
					},
					{
						"n": 14,
						"h": 275,
						"w": 400
					},
					{
						"n": 13,
						"h": 179,
						"w": 394
					},
					{
						"n": 5,
						"h": 78,
						"w": 343
					},
					{
						"n": 6,
						"h": 398,
						"w": 94
					},
					{
						"n": 18,
						"h": 276,
						"w": 257
					},
					{
						"n": 15,
						"h": 148,
						"w": 79
					},
					{
						"n": 17,
						"h": 84,
						"w": 84
					},
					{
						"n": 20,
						"h": 274,
						"w": 65
					},
					{
						"n": 19,
						"h": 179,
						"w": 65
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 709
					},
					{
						"n": 13,
						"h": 369,
						"w": 625
					},
					{
						"n": 3,
						"h": 302,
						"w": 626
					},
					{
						"n": 14,
						"h": 221,
						"w": 665
					},
					{
						"n": 5,
						"h": 110,
						"w": 667
					},
					{
						"n": 6,
						"h": 277,
						"w": 601
					},
					{
						"n": 7,
						"h": 292,
						"w": 608
					},
					{
						"n": 18,
						"h": 38,
						"w": 574
					},
					{
						"n": 17,
						"h": 410,
						"w": 519
					},
					{
						"n": 19,
						"h": 277,
						"w": 428
					},
					{
						"n": 20,
						"h": 177,
						"w": 468
					}
				],
				"ball": {
					"n": 0,
					"h": 148,
					"w": 94,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 10
		},
		{
			"num": 1384,
			"minute": 67,
			"messages": [
				{
					"owner": 2,
					"mes": "Нир Мансур[23](Опава), не глядя, бьет вперед..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 702
					},
					{
						"n": 2,
						"h": 342,
						"w": 390
					},
					{
						"n": 14,
						"h": 269,
						"w": 398
					},
					{
						"n": 13,
						"h": 177,
						"w": 392
					},
					{
						"n": 5,
						"h": 109,
						"w": 387
					},
					{
						"n": 6,
						"h": 398,
						"w": 148
					},
					{
						"n": 18,
						"h": 222,
						"w": 256
					},
					{
						"n": 15,
						"h": 152,
						"w": 103
					},
					{
						"n": 17,
						"h": 71,
						"w": 136
					},
					{
						"n": 20,
						"h": 262,
						"w": 118
					},
					{
						"n": 19,
						"h": 173,
						"w": 119
					}
				],
				"away": [
					{
						"n": 1,
						"h": 223,
						"w": 707
					},
					{
						"n": 13,
						"h": 387,
						"w": 574
					},
					{
						"n": 3,
						"h": 276,
						"w": 616
					},
					{
						"n": 14,
						"h": 188,
						"w": 622
					},
					{
						"n": 5,
						"h": 70,
						"w": 630
					},
					{
						"n": 6,
						"h": 241,
						"w": 560
					},
					{
						"n": 7,
						"h": 284,
						"w": 554
					},
					{
						"n": 18,
						"h": 39,
						"w": 520
					},
					{
						"n": 17,
						"h": 360,
						"w": 499
					},
					{
						"n": 19,
						"h": 281,
						"w": 465
					},
					{
						"n": 20,
						"h": 231,
						"w": 475
					}
				],
				"ball": {
					"n": 0,
					"h": 169,
					"w": 255,
					"z": 1,
					"r": 0,
					"p": 4,
					"x": 0
				}
			},
			"interval": 54
		},
		{
			"num": 1385,
			"minute": 67,
			"messages": [
				{
					"owner": 2,
					"mes": "Александр Фрешль[39](Опава) головой скидывает мяч..."
				},
				{
					"owner": 2,
					"mes": "Тома Анри[40](Опава) подрабатывает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 707
					},
					{
						"n": 2,
						"h": 338,
						"w": 406
					},
					{
						"n": 14,
						"h": 256,
						"w": 410
					},
					{
						"n": 13,
						"h": 173,
						"w": 409
					},
					{
						"n": 5,
						"h": 113,
						"w": 403
					},
					{
						"n": 6,
						"h": 397,
						"w": 165
					},
					{
						"n": 18,
						"h": 222,
						"w": 256
					},
					{
						"n": 15,
						"h": 159,
						"w": 118
					},
					{
						"n": 17,
						"h": 69,
						"w": 153
					},
					{
						"n": 20,
						"h": 253,
						"w": 132
					},
					{
						"n": 19,
						"h": 173,
						"w": 136
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 703
					},
					{
						"n": 13,
						"h": 390,
						"w": 557
					},
					{
						"n": 3,
						"h": 285,
						"w": 610
					},
					{
						"n": 14,
						"h": 180,
						"w": 622
					},
					{
						"n": 5,
						"h": 72,
						"w": 613
					},
					{
						"n": 6,
						"h": 224,
						"w": 561
					},
					{
						"n": 7,
						"h": 280,
						"w": 538
					},
					{
						"n": 18,
						"h": 38,
						"w": 503
					},
					{
						"n": 17,
						"h": 364,
						"w": 482
					},
					{
						"n": 19,
						"h": 281,
						"w": 465,
						"m": 650
					},
					{
						"n": 20,
						"h": 231,
						"w": 472
					}
				],
				"ball": {
					"n": 0,
					"h": 219,
					"w": 248,
					"z": 1,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 17
		},
		{
			"num": 1386,
			"minute": 67,
			"messages": [
				{
					"owner": 2,
					"mes": "Пас М.Томасову[37](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 708
					},
					{
						"n": 2,
						"h": 330,
						"w": 446
					},
					{
						"n": 14,
						"h": 227,
						"w": 443
					},
					{
						"n": 13,
						"h": 164,
						"w": 452
					},
					{
						"n": 5,
						"h": 120,
						"w": 438
					},
					{
						"n": 6,
						"h": 398,
						"w": 209
					},
					{
						"n": 18,
						"h": 191,
						"w": 256
					},
					{
						"n": 15,
						"h": 165,
						"w": 162
					},
					{
						"n": 17,
						"h": 67,
						"w": 197
					},
					{
						"n": 20,
						"h": 251,
						"w": 176
					},
					{
						"n": 19,
						"h": 176,
						"w": 180
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 701
					},
					{
						"n": 13,
						"h": 392,
						"w": 513
					},
					{
						"n": 3,
						"h": 280,
						"w": 611
					},
					{
						"n": 14,
						"h": 171,
						"w": 606
					},
					{
						"n": 5,
						"h": 74,
						"w": 610
					},
					{
						"n": 6,
						"h": 201,
						"w": 524
					},
					{
						"n": 7,
						"h": 269,
						"w": 495
					},
					{
						"n": 18,
						"h": 43,
						"w": 459
					},
					{
						"n": 17,
						"h": 319,
						"w": 482
					},
					{
						"n": 19,
						"h": 282,
						"w": 434
					},
					{
						"n": 20,
						"h": 227,
						"w": 463,
						"m": 610
					}
				],
				"ball": {
					"n": 0,
					"h": 131,
					"w": 238,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 44
		},
		{
			"num": 1387,
			"minute": 67,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 706
					},
					{
						"n": 2,
						"h": 330,
						"w": 461
					},
					{
						"n": 14,
						"h": 232,
						"w": 454
					},
					{
						"n": 13,
						"h": 162,
						"w": 433
					},
					{
						"n": 5,
						"h": 120,
						"w": 461
					},
					{
						"n": 6,
						"h": 405,
						"w": 248
					},
					{
						"n": 18,
						"h": 155,
						"w": 273
					},
					{
						"n": 15,
						"h": 166,
						"w": 202
					},
					{
						"n": 17,
						"h": 62,
						"w": 237
					},
					{
						"n": 20,
						"h": 261,
						"w": 215
					},
					{
						"n": 19,
						"h": 161,
						"w": 217
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 709
					},
					{
						"n": 13,
						"h": 399,
						"w": 474
					},
					{
						"n": 3,
						"h": 285,
						"w": 606
					},
					{
						"n": 14,
						"h": 173,
						"w": 593
					},
					{
						"n": 5,
						"h": 57,
						"w": 604
					},
					{
						"n": 6,
						"h": 234,
						"w": 507
					},
					{
						"n": 7,
						"h": 270,
						"w": 455
					},
					{
						"n": 18,
						"h": 43,
						"w": 419
					},
					{
						"n": 17,
						"h": 335,
						"w": 451
					},
					{
						"n": 19,
						"h": 284,
						"w": 394
					},
					{
						"n": 20,
						"h": 209,
						"w": 427
					}
				],
				"ball": {
					"n": 0,
					"h": 115,
					"w": 269,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1388,
			"minute": 67,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 707
					},
					{
						"n": 2,
						"h": 330,
						"w": 462
					},
					{
						"n": 14,
						"h": 241,
						"w": 461
					},
					{
						"n": 13,
						"h": 178,
						"w": 470
					},
					{
						"n": 5,
						"h": 120,
						"w": 458
					},
					{
						"n": 6,
						"h": 401,
						"w": 288
					},
					{
						"n": 18,
						"h": 119,
						"w": 290
					},
					{
						"n": 15,
						"h": 165,
						"w": 212
					},
					{
						"n": 17,
						"h": 51,
						"w": 275
					},
					{
						"n": 20,
						"h": 228,
						"w": 223
					},
					{
						"n": 19,
						"h": 184,
						"w": 250
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 707
					},
					{
						"n": 13,
						"h": 413,
						"w": 511
					},
					{
						"n": 3,
						"h": 282,
						"w": 596
					},
					{
						"n": 14,
						"h": 159,
						"w": 596
					},
					{
						"n": 5,
						"h": 45,
						"w": 596
					},
					{
						"n": 6,
						"h": 222,
						"w": 517
					},
					{
						"n": 7,
						"h": 233,
						"w": 440
					},
					{
						"n": 18,
						"h": 51,
						"w": 437
					},
					{
						"n": 17,
						"h": 366,
						"w": 433
					},
					{
						"n": 19,
						"h": 287,
						"w": 354
					},
					{
						"n": 20,
						"h": 197,
						"w": 389
					}
				],
				"ball": {
					"n": 0,
					"h": 84,
					"w": 287,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1389,
			"minute": 67,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 702
					},
					{
						"n": 2,
						"h": 330,
						"w": 467
					},
					{
						"n": 14,
						"h": 248,
						"w": 480
					},
					{
						"n": 13,
						"h": 173,
						"w": 469
					},
					{
						"n": 5,
						"h": 91,
						"w": 459
					},
					{
						"n": 6,
						"h": 394,
						"w": 327
					},
					{
						"n": 18,
						"h": 96,
						"w": 323
					},
					{
						"n": 15,
						"h": 167,
						"w": 252
					},
					{
						"n": 17,
						"h": 73,
						"w": 308
					},
					{
						"n": 20,
						"h": 235,
						"w": 233
					},
					{
						"n": 19,
						"h": 171,
						"w": 288
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 707
					},
					{
						"n": 13,
						"h": 402,
						"w": 507
					},
					{
						"n": 3,
						"h": 290,
						"w": 586
					},
					{
						"n": 14,
						"h": 156,
						"w": 586
					},
					{
						"n": 5,
						"h": 41,
						"w": 586
					},
					{
						"n": 6,
						"h": 215,
						"w": 507
					},
					{
						"n": 7,
						"h": 225,
						"w": 428
					},
					{
						"n": 18,
						"h": 40,
						"w": 428
					},
					{
						"n": 17,
						"h": 366,
						"w": 398
					},
					{
						"n": 19,
						"h": 293,
						"w": 314
					},
					{
						"n": 20,
						"h": 187,
						"w": 350
					}
				],
				"ball": {
					"n": 0,
					"h": 84,
					"w": 322,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1390,
			"minute": 67,
			"messages": [
				{
					"owner": 2,
					"mes": "Марин Томасов[37](Опава) отыгрывает назад..."
				},
				{
					"owner": 2,
					"mes": "Кеннет Удре[33](Опава) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 703
					},
					{
						"n": 2,
						"h": 330,
						"w": 472
					},
					{
						"n": 14,
						"h": 259,
						"w": 487
					},
					{
						"n": 13,
						"h": 172,
						"w": 490
					},
					{
						"n": 5,
						"h": 119,
						"w": 478
					},
					{
						"n": 6,
						"h": 390,
						"w": 361
					},
					{
						"n": 18,
						"h": 85,
						"w": 290
					},
					{
						"n": 15,
						"h": 165,
						"w": 286
					},
					{
						"n": 17,
						"h": 77,
						"w": 342
					},
					{
						"n": 20,
						"h": 255,
						"w": 260
					},
					{
						"n": 19,
						"h": 195,
						"w": 264
					}
				],
				"away": [
					{
						"n": 1,
						"h": 228,
						"w": 709
					},
					{
						"n": 13,
						"h": 375,
						"w": 485
					},
					{
						"n": 3,
						"h": 296,
						"w": 576
					},
					{
						"n": 14,
						"h": 166,
						"w": 576
					},
					{
						"n": 5,
						"h": 44,
						"w": 576
					},
					{
						"n": 6,
						"h": 233,
						"w": 497
					},
					{
						"n": 7,
						"h": 225,
						"w": 418
					},
					{
						"n": 18,
						"h": 42,
						"w": 418
					},
					{
						"n": 17,
						"h": 371,
						"w": 390,
						"m": 650
					},
					{
						"n": 19,
						"h": 293,
						"w": 280
					},
					{
						"n": 20,
						"h": 176,
						"w": 318
					}
				],
				"ball": {
					"n": 0,
					"h": 75,
					"w": 235,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 34
		},
		{
			"num": 1391,
			"minute": 67,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 704
					},
					{
						"n": 2,
						"h": 330,
						"w": 482
					},
					{
						"n": 14,
						"h": 271,
						"w": 494
					},
					{
						"n": 13,
						"h": 173,
						"w": 471
					},
					{
						"n": 5,
						"h": 120,
						"w": 480
					},
					{
						"n": 6,
						"h": 402,
						"w": 390
					},
					{
						"n": 18,
						"h": 63,
						"w": 288
					},
					{
						"n": 15,
						"h": 165,
						"w": 326
					},
					{
						"n": 17,
						"h": 63,
						"w": 380
					},
					{
						"n": 20,
						"h": 229,
						"w": 253
					},
					{
						"n": 19,
						"h": 175,
						"w": 298
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 694
					},
					{
						"n": 13,
						"h": 389,
						"w": 452
					},
					{
						"n": 3,
						"h": 297,
						"w": 566
					},
					{
						"n": 14,
						"h": 155,
						"w": 566
					},
					{
						"n": 5,
						"h": 40,
						"w": 566
					},
					{
						"n": 6,
						"h": 221,
						"w": 487
					},
					{
						"n": 7,
						"h": 228,
						"w": 408
					},
					{
						"n": 18,
						"h": 33,
						"w": 408
					},
					{
						"n": 17,
						"h": 394,
						"w": 357
					},
					{
						"n": 19,
						"h": 293,
						"w": 250
					},
					{
						"n": 20,
						"h": 162,
						"w": 280
					}
				],
				"ball": {
					"n": 0,
					"h": 61,
					"w": 268,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1392,
			"minute": 67,
			"messages": [
				{
					"owner": 2,
					"mes": "Кеннет Удре[33](Опава) отыгрывает назад..."
				},
				{
					"owner": 2,
					"mes": "Нир Мансур[23](Опава) с мячом..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 703
					},
					{
						"n": 2,
						"h": 330,
						"w": 469
					},
					{
						"n": 14,
						"h": 278,
						"w": 464
					},
					{
						"n": 13,
						"h": 187,
						"w": 454
					},
					{
						"n": 5,
						"h": 120,
						"w": 466
					},
					{
						"n": 6,
						"h": 404,
						"w": 360
					},
					{
						"n": 18,
						"h": 100,
						"w": 308
					},
					{
						"n": 15,
						"h": 179,
						"w": 352
					},
					{
						"n": 17,
						"h": 56,
						"w": 386
					},
					{
						"n": 20,
						"h": 269,
						"w": 265
					},
					{
						"n": 19,
						"h": 141,
						"w": 280
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 676
					},
					{
						"n": 13,
						"h": 394,
						"w": 461
					},
					{
						"n": 3,
						"h": 315,
						"w": 556
					},
					{
						"n": 14,
						"h": 160,
						"w": 556
					},
					{
						"n": 5,
						"h": 45,
						"w": 556
					},
					{
						"n": 6,
						"h": 234,
						"w": 487
					},
					{
						"n": 7,
						"h": 224,
						"w": 418
					},
					{
						"n": 18,
						"h": 38,
						"w": 418
					},
					{
						"n": 17,
						"h": 413,
						"w": 349
					},
					{
						"n": 19,
						"h": 282,
						"w": 280
					},
					{
						"n": 20,
						"h": 162,
						"w": 280
					}
				],
				"ball": {
					"n": 0,
					"h": 135,
					"w": 164,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 42
		},
		{
			"num": 1393,
			"minute": 67,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 704
					},
					{
						"n": 2,
						"h": 330,
						"w": 457
					},
					{
						"n": 14,
						"h": 280,
						"w": 462
					},
					{
						"n": 13,
						"h": 183,
						"w": 464
					},
					{
						"n": 5,
						"h": 120,
						"w": 450
					},
					{
						"n": 6,
						"h": 392,
						"w": 360
					},
					{
						"n": 18,
						"h": 135,
						"w": 327
					},
					{
						"n": 15,
						"h": 172,
						"w": 353
					},
					{
						"n": 17,
						"h": 56,
						"w": 409
					},
					{
						"n": 20,
						"h": 290,
						"w": 298
					},
					{
						"n": 19,
						"h": 135,
						"w": 280
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 658
					},
					{
						"n": 13,
						"h": 407,
						"w": 479
					},
					{
						"n": 3,
						"h": 331,
						"w": 525
					},
					{
						"n": 14,
						"h": 160,
						"w": 546
					},
					{
						"n": 5,
						"h": 48,
						"w": 546
					},
					{
						"n": 6,
						"h": 232,
						"w": 479
					},
					{
						"n": 7,
						"h": 226,
						"w": 413
					},
					{
						"n": 18,
						"h": 49,
						"w": 413
					},
					{
						"n": 17,
						"h": 401,
						"w": 346
					},
					{
						"n": 19,
						"h": 282,
						"w": 280
					},
					{
						"n": 20,
						"h": 155,
						"w": 280
					}
				],
				"ball": {
					"n": 0,
					"h": 119,
					"w": 195,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1394,
			"minute": 67,
			"messages": [
				{
					"owner": 2,
					"mes": "Нир Мансур[23](Опава) отдает пас на О.Дюмона[26](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 701
					},
					{
						"n": 2,
						"h": 330,
						"w": 462
					},
					{
						"n": 14,
						"h": 284,
						"w": 458
					},
					{
						"n": 13,
						"h": 173,
						"w": 481
					},
					{
						"n": 5,
						"h": 120,
						"w": 454
					},
					{
						"n": 6,
						"h": 399,
						"w": 361
					},
					{
						"n": 18,
						"h": 159,
						"w": 339
					},
					{
						"n": 15,
						"h": 187,
						"w": 347
					},
					{
						"n": 17,
						"h": 56,
						"w": 414
					},
					{
						"n": 20,
						"h": 294,
						"w": 296
					},
					{
						"n": 19,
						"h": 159,
						"w": 268
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 640
					},
					{
						"n": 13,
						"h": 418,
						"w": 471
					},
					{
						"n": 3,
						"h": 322,
						"w": 527
					},
					{
						"n": 14,
						"h": 154,
						"w": 536
					},
					{
						"n": 5,
						"h": 50,
						"w": 536
					},
					{
						"n": 6,
						"h": 257,
						"w": 490
					},
					{
						"n": 7,
						"h": 216,
						"w": 406
					},
					{
						"n": 18,
						"h": 45,
						"w": 406
					},
					{
						"n": 17,
						"h": 402,
						"w": 341
					},
					{
						"n": 19,
						"h": 288,
						"w": 276
					},
					{
						"n": 20,
						"h": 154,
						"w": 276
					}
				],
				"ball": {
					"n": 0,
					"h": 193,
					"w": 230,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 27
		},
		{
			"num": 1395,
			"minute": 67,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 706
					},
					{
						"n": 2,
						"h": 330,
						"w": 481
					},
					{
						"n": 14,
						"h": 281,
						"w": 490
					},
					{
						"n": 13,
						"h": 164,
						"w": 461
					},
					{
						"n": 5,
						"h": 120,
						"w": 486
					},
					{
						"n": 6,
						"h": 394,
						"w": 343
					},
					{
						"n": 18,
						"h": 191,
						"w": 363
					},
					{
						"n": 15,
						"h": 190,
						"w": 357
					},
					{
						"n": 17,
						"h": 56,
						"w": 409
					},
					{
						"n": 20,
						"h": 284,
						"w": 311
					},
					{
						"n": 19,
						"h": 198,
						"w": 278
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 628
					},
					{
						"n": 13,
						"h": 417,
						"w": 459
					},
					{
						"n": 3,
						"h": 298,
						"w": 526
					},
					{
						"n": 14,
						"h": 159,
						"w": 526
					},
					{
						"n": 5,
						"h": 42,
						"w": 526
					},
					{
						"n": 6,
						"h": 241,
						"w": 458
					},
					{
						"n": 7,
						"h": 217,
						"w": 392
					},
					{
						"n": 18,
						"h": 35,
						"w": 392
					},
					{
						"n": 17,
						"h": 412,
						"w": 326
					},
					{
						"n": 19,
						"h": 296,
						"w": 259
					},
					{
						"n": 20,
						"h": 149,
						"w": 259
					}
				],
				"ball": {
					"n": 0,
					"h": 209,
					"w": 262,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1396,
			"minute": 67,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 710
					},
					{
						"n": 2,
						"h": 330,
						"w": 521
					},
					{
						"n": 14,
						"h": 282,
						"w": 530
					},
					{
						"n": 13,
						"h": 165,
						"w": 501
					},
					{
						"n": 5,
						"h": 120,
						"w": 526
					},
					{
						"n": 6,
						"h": 394,
						"w": 382
					},
					{
						"n": 18,
						"h": 201,
						"w": 402
					},
					{
						"n": 15,
						"h": 186,
						"w": 397
					},
					{
						"n": 17,
						"h": 56,
						"w": 449
					},
					{
						"n": 20,
						"h": 300,
						"w": 348
					},
					{
						"n": 19,
						"h": 233,
						"w": 296
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 612
					},
					{
						"n": 13,
						"h": 412,
						"w": 419
					},
					{
						"n": 3,
						"h": 284,
						"w": 488
					},
					{
						"n": 14,
						"h": 162,
						"w": 486
					},
					{
						"n": 5,
						"h": 55,
						"w": 488
					},
					{
						"n": 6,
						"h": 211,
						"w": 441
					},
					{
						"n": 7,
						"h": 220,
						"w": 353
					},
					{
						"n": 18,
						"h": 31,
						"w": 353
					},
					{
						"n": 17,
						"h": 415,
						"w": 286
					},
					{
						"n": 19,
						"h": 301,
						"w": 219
					},
					{
						"n": 20,
						"h": 151,
						"w": 219
					}
				],
				"ball": {
					"n": 0,
					"h": 239,
					"w": 279,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1397,
			"minute": 67,
			"messages": [
				{
					"owner": 2,
					"mes": "Оливье Дюмон[26](Опава) подключает к атаке по левому флангу К.Удре[33](Опава)..."
				},
				{
					"owner": 2,
					"mes": "Кеннет Удре[33](Опава) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 706
					},
					{
						"n": 2,
						"h": 330,
						"w": 556
					},
					{
						"n": 14,
						"h": 280,
						"w": 570
					},
					{
						"n": 13,
						"h": 168,
						"w": 545
					},
					{
						"n": 5,
						"h": 120,
						"w": 569
					},
					{
						"n": 6,
						"h": 394,
						"w": 426
					},
					{
						"n": 18,
						"h": 224,
						"w": 440
					},
					{
						"n": 15,
						"h": 165,
						"w": 435
					},
					{
						"n": 17,
						"h": 56,
						"w": 493
					},
					{
						"n": 20,
						"h": 262,
						"w": 325
					},
					{
						"n": 19,
						"h": 205,
						"w": 330
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 612
					},
					{
						"n": 13,
						"h": 387,
						"w": 444
					},
					{
						"n": 3,
						"h": 271,
						"w": 514
					},
					{
						"n": 14,
						"h": 168,
						"w": 493
					},
					{
						"n": 5,
						"h": 65,
						"w": 501
					},
					{
						"n": 6,
						"h": 216,
						"w": 433
					},
					{
						"n": 7,
						"h": 251,
						"w": 322
					},
					{
						"n": 18,
						"h": 34,
						"w": 309
					},
					{
						"n": 17,
						"h": 404,
						"w": 243
					},
					{
						"n": 19,
						"h": 294,
						"w": 192
					},
					{
						"n": 20,
						"h": 150,
						"w": 186
					}
				],
				"ball": {
					"n": 0,
					"h": 63,
					"w": 276,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 44
		},
		{
			"num": 1398,
			"minute": 67,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 706
					},
					{
						"n": 2,
						"h": 330,
						"w": 595
					},
					{
						"n": 14,
						"h": 273,
						"w": 608
					},
					{
						"n": 13,
						"h": 167,
						"w": 584
					},
					{
						"n": 5,
						"h": 120,
						"w": 608
					},
					{
						"n": 6,
						"h": 394,
						"w": 465
					},
					{
						"n": 18,
						"h": 234,
						"w": 477
					},
					{
						"n": 15,
						"h": 168,
						"w": 474
					},
					{
						"n": 17,
						"h": 56,
						"w": 529
					},
					{
						"n": 20,
						"h": 271,
						"w": 363
					},
					{
						"n": 19,
						"h": 221,
						"w": 344
					}
				],
				"away": [
					{
						"n": 1,
						"h": 229,
						"w": 597
					},
					{
						"n": 13,
						"h": 382,
						"w": 410
					},
					{
						"n": 3,
						"h": 274,
						"w": 475
					},
					{
						"n": 14,
						"h": 169,
						"w": 474
					},
					{
						"n": 5,
						"h": 68,
						"w": 462
					},
					{
						"n": 6,
						"h": 229,
						"w": 396
					},
					{
						"n": 7,
						"h": 249,
						"w": 283
					},
					{
						"n": 18,
						"h": 30,
						"w": 270
					},
					{
						"n": 17,
						"h": 415,
						"w": 206
					},
					{
						"n": 19,
						"h": 311,
						"w": 157
					},
					{
						"n": 20,
						"h": 165,
						"w": 150
					}
				],
				"ball": {
					"n": 0,
					"h": 68,
					"w": 310,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 1399,
			"minute": 67,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 701
					},
					{
						"n": 2,
						"h": 330,
						"w": 618
					},
					{
						"n": 14,
						"h": 246,
						"w": 611
					},
					{
						"n": 13,
						"h": 164,
						"w": 623
					},
					{
						"n": 5,
						"h": 118,
						"w": 583
					},
					{
						"n": 6,
						"h": 394,
						"w": 504
					},
					{
						"n": 18,
						"h": 218,
						"w": 513
					},
					{
						"n": 15,
						"h": 134,
						"w": 493
					},
					{
						"n": 17,
						"h": 56,
						"w": 566
					},
					{
						"n": 20,
						"h": 287,
						"w": 398
					},
					{
						"n": 19,
						"h": 194,
						"w": 373
					}
				],
				"away": [
					{
						"n": 1,
						"h": 221,
						"w": 600
					},
					{
						"n": 13,
						"h": 378,
						"w": 376
					},
					{
						"n": 3,
						"h": 267,
						"w": 456
					},
					{
						"n": 14,
						"h": 163,
						"w": 446
					},
					{
						"n": 5,
						"h": 71,
						"w": 430
					},
					{
						"n": 6,
						"h": 256,
						"w": 367
					},
					{
						"n": 7,
						"h": 244,
						"w": 244
					},
					{
						"n": 18,
						"h": 23,
						"w": 231
					},
					{
						"n": 17,
						"h": 426,
						"w": 169
					},
					{
						"n": 19,
						"h": 340,
						"w": 144
					},
					{
						"n": 20,
						"h": 187,
						"w": 144
					}
				],
				"ball": {
					"n": 0,
					"h": 72,
					"w": 344,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 1400,
			"minute": 67,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 704
					},
					{
						"n": 2,
						"h": 330,
						"w": 609
					},
					{
						"n": 14,
						"h": 275,
						"w": 612
					},
					{
						"n": 13,
						"h": 166,
						"w": 620
					},
					{
						"n": 5,
						"h": 119,
						"w": 584
					},
					{
						"n": 6,
						"h": 394,
						"w": 543
					},
					{
						"n": 18,
						"h": 201,
						"w": 526
					},
					{
						"n": 15,
						"h": 115,
						"w": 459
					},
					{
						"n": 17,
						"h": 56,
						"w": 598
					},
					{
						"n": 20,
						"h": 278,
						"w": 411
					},
					{
						"n": 19,
						"h": 197,
						"w": 381
					}
				],
				"away": [
					{
						"n": 1,
						"h": 223,
						"w": 601
					},
					{
						"n": 13,
						"h": 374,
						"w": 342
					},
					{
						"n": 3,
						"h": 269,
						"w": 445
					},
					{
						"n": 14,
						"h": 176,
						"w": 432
					},
					{
						"n": 5,
						"h": 76,
						"w": 450
					},
					{
						"n": 6,
						"h": 253,
						"w": 359
					},
					{
						"n": 7,
						"h": 253,
						"w": 206
					},
					{
						"n": 18,
						"h": 24,
						"w": 192
					},
					{
						"n": 17,
						"h": 426,
						"w": 153
					},
					{
						"n": 19,
						"h": 339,
						"w": 144
					},
					{
						"n": 20,
						"h": 162,
						"w": 144
					}
				],
				"ball": {
					"n": 0,
					"h": 76,
					"w": 378,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 1401,
			"minute": 67,
			"messages": [
				{
					"owner": 2,
					"mes": "Кеннет Удре[33](Опава) отдает пас М.Томасову[37](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 214,
						"w": 710
					},
					{
						"n": 2,
						"h": 330,
						"w": 615
					},
					{
						"n": 14,
						"h": 269,
						"w": 619
					},
					{
						"n": 13,
						"h": 170,
						"w": 618
					},
					{
						"n": 5,
						"h": 95,
						"w": 638
					},
					{
						"n": 6,
						"h": 394,
						"w": 594
					},
					{
						"n": 18,
						"h": 245,
						"w": 535
					},
					{
						"n": 15,
						"h": 163,
						"w": 494
					},
					{
						"n": 17,
						"h": 51,
						"w": 554
					},
					{
						"n": 20,
						"h": 276,
						"w": 371
					},
					{
						"n": 19,
						"h": 193,
						"w": 414
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 593
					},
					{
						"n": 13,
						"h": 391,
						"w": 331
					},
					{
						"n": 3,
						"h": 273,
						"w": 474
					},
					{
						"n": 14,
						"h": 163,
						"w": 473
					},
					{
						"n": 5,
						"h": 72,
						"w": 442
					},
					{
						"n": 6,
						"h": 257,
						"w": 326
					},
					{
						"n": 7,
						"h": 247,
						"w": 198
					},
					{
						"n": 18,
						"h": 41,
						"w": 136
					},
					{
						"n": 17,
						"h": 399,
						"w": 166
					},
					{
						"n": 19,
						"h": 293,
						"w": 135
					},
					{
						"n": 20,
						"h": 161,
						"w": 131
					}
				],
				"ball": {
					"n": 0,
					"h": 51,
					"w": 554,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 59
		},
		{
			"num": 1402,
			"minute": 67,
			"messages": [
				{
					"owner": 2,
					"mes": "Марин Томасов[37](Опава) пытается выиграть позицию..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 214,
						"w": 709
					},
					{
						"n": 2,
						"h": 330,
						"w": 623
					},
					{
						"n": 14,
						"h": 265,
						"w": 610
					},
					{
						"n": 13,
						"h": 174,
						"w": 627
					},
					{
						"n": 5,
						"h": 95,
						"w": 628
					},
					{
						"n": 6,
						"h": 386,
						"w": 600
					},
					{
						"n": 18,
						"h": 251,
						"w": 543
					},
					{
						"n": 15,
						"h": 163,
						"w": 504
					},
					{
						"n": 17,
						"h": 53,
						"w": 557
					},
					{
						"n": 20,
						"h": 283,
						"w": 378
					},
					{
						"n": 19,
						"h": 198,
						"w": 405
					}
				],
				"away": [
					{
						"n": 1,
						"h": 221,
						"w": 594
					},
					{
						"n": 13,
						"h": 391,
						"w": 321
					},
					{
						"n": 3,
						"h": 271,
						"w": 464
					},
					{
						"n": 14,
						"h": 170,
						"w": 466
					},
					{
						"n": 5,
						"h": 66,
						"w": 440
					},
					{
						"n": 6,
						"h": 252,
						"w": 335
					},
					{
						"n": 7,
						"h": 257,
						"w": 200
					},
					{
						"n": 18,
						"h": 49,
						"w": 130
					},
					{
						"n": 17,
						"h": 398,
						"w": 176
					},
					{
						"n": 19,
						"h": 292,
						"w": 125
					},
					{
						"n": 20,
						"h": 169,
						"w": 125
					}
				],
				"ball": {
					"n": 0,
					"h": 52,
					"w": 544,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 10
		},
		{
			"num": 1403,
			"minute": 68,
			"possession": 44,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 215,
						"w": 709
					},
					{
						"n": 2,
						"h": 330,
						"w": 637
					},
					{
						"n": 14,
						"h": 258,
						"w": 630
					},
					{
						"n": 13,
						"h": 178,
						"w": 614,
						"f": 97
					},
					{
						"n": 5,
						"h": 85,
						"w": 621,
						"f": 81
					},
					{
						"n": 6,
						"h": 404,
						"w": 564,
						"f": 80
					},
					{
						"n": 18,
						"h": 234,
						"w": 558,
						"f": 97
					},
					{
						"n": 15,
						"h": 191,
						"w": 533,
						"f": 97
					},
					{
						"n": 17,
						"h": 95,
						"w": 575,
						"f": 91
					},
					{
						"n": 20,
						"h": 287,
						"w": 379,
						"f": 90
					},
					{
						"n": 19,
						"h": 191,
						"w": 396
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 597
					},
					{
						"n": 13,
						"h": 397,
						"w": 282
					},
					{
						"n": 3,
						"h": 285,
						"w": 444
					},
					{
						"n": 14,
						"h": 175,
						"w": 448,
						"f": 90
					},
					{
						"n": 5,
						"h": 67,
						"w": 412,
						"f": 80
					},
					{
						"n": 6,
						"h": 259,
						"w": 344,
						"f": 80
					},
					{
						"n": 7,
						"h": 256,
						"w": 179
					},
					{
						"n": 18,
						"h": 48,
						"w": 103
					},
					{
						"n": 17,
						"h": 363,
						"w": 160
					},
					{
						"n": 19,
						"h": 285,
						"w": 103,
						"f": 93
					},
					{
						"n": 20,
						"h": 173,
						"w": 110
					}
				],
				"ball": {
					"n": 0,
					"h": 87,
					"w": 560,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1404,
			"minute": 68,
			"messages": [
				{
					"owner": 2,
					"mes": "Марин Томасов[37](Опава) уходит в центр..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 217,
						"w": 707
					},
					{
						"n": 2,
						"h": 330,
						"w": 653
					},
					{
						"n": 14,
						"h": 261,
						"w": 646
					},
					{
						"n": 13,
						"h": 169,
						"w": 641
					},
					{
						"n": 5,
						"h": 114,
						"w": 639
					},
					{
						"n": 6,
						"h": 422,
						"w": 545
					},
					{
						"n": 18,
						"h": 251,
						"w": 570
					},
					{
						"n": 15,
						"h": 210,
						"w": 561
					},
					{
						"n": 17,
						"h": 120,
						"w": 560
					},
					{
						"n": 20,
						"h": 289,
						"w": 378
					},
					{
						"n": 19,
						"h": 205,
						"w": 427
					}
				],
				"away": [
					{
						"n": 1,
						"h": 221,
						"w": 600
					},
					{
						"n": 13,
						"h": 403,
						"w": 268
					},
					{
						"n": 3,
						"h": 280,
						"w": 427
					},
					{
						"n": 14,
						"h": 173,
						"w": 414
					},
					{
						"n": 5,
						"h": 60,
						"w": 405
					},
					{
						"n": 6,
						"h": 245,
						"w": 313
					},
					{
						"n": 7,
						"h": 241,
						"w": 149
					},
					{
						"n": 18,
						"h": 43,
						"w": 103
					},
					{
						"n": 17,
						"h": 333,
						"w": 175
					},
					{
						"n": 19,
						"h": 300,
						"w": 94
					},
					{
						"n": 20,
						"h": 172,
						"w": 92
					}
				],
				"ball": {
					"n": 0,
					"h": 117,
					"w": 545,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 34
		},
		{
			"num": 1405,
			"minute": 68,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 218,
						"w": 707
					},
					{
						"n": 2,
						"h": 330,
						"w": 659
					},
					{
						"n": 14,
						"h": 269,
						"w": 662
					},
					{
						"n": 13,
						"h": 176,
						"w": 639
					},
					{
						"n": 5,
						"h": 120,
						"w": 653
					},
					{
						"n": 6,
						"h": 426,
						"w": 556
					},
					{
						"n": 18,
						"h": 225,
						"w": 598
					},
					{
						"n": 15,
						"h": 164,
						"w": 577
					},
					{
						"n": 17,
						"h": 141,
						"w": 567
					},
					{
						"n": 20,
						"h": 266,
						"w": 408
					},
					{
						"n": 19,
						"h": 177,
						"w": 401
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 596
					},
					{
						"n": 13,
						"h": 403,
						"w": 230
					},
					{
						"n": 3,
						"h": 280,
						"w": 415
					},
					{
						"n": 14,
						"h": 172,
						"w": 427
					},
					{
						"n": 5,
						"h": 70,
						"w": 418
					},
					{
						"n": 6,
						"h": 221,
						"w": 284
					},
					{
						"n": 7,
						"h": 226,
						"w": 141
					},
					{
						"n": 18,
						"h": 48,
						"w": 97
					},
					{
						"n": 17,
						"h": 304,
						"w": 152
					},
					{
						"n": 19,
						"h": 290,
						"w": 86
					},
					{
						"n": 20,
						"h": 170,
						"w": 81
					}
				],
				"ball": {
					"n": 0,
					"h": 146,
					"w": 568,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 38
		},
		{
			"num": 1406,
			"minute": 68,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 219,
						"w": 706
					},
					{
						"n": 2,
						"h": 367,
						"w": 645
					},
					{
						"n": 14,
						"h": 251,
						"w": 662
					},
					{
						"n": 13,
						"h": 186,
						"w": 647
					},
					{
						"n": 5,
						"h": 120,
						"w": 662
					},
					{
						"n": 6,
						"h": 418,
						"w": 571
					},
					{
						"n": 18,
						"h": 235,
						"w": 598
					},
					{
						"n": 15,
						"h": 171,
						"w": 616
					},
					{
						"n": 17,
						"h": 101,
						"w": 566
					},
					{
						"n": 20,
						"h": 232,
						"w": 430
					},
					{
						"n": 19,
						"h": 171,
						"w": 370
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 593
					},
					{
						"n": 13,
						"h": 401,
						"w": 190
					},
					{
						"n": 3,
						"h": 285,
						"w": 420
					},
					{
						"n": 14,
						"h": 180,
						"w": 405
					},
					{
						"n": 5,
						"h": 73,
						"w": 421
					},
					{
						"n": 6,
						"h": 219,
						"w": 309
					},
					{
						"n": 7,
						"h": 210,
						"w": 144
					},
					{
						"n": 18,
						"h": 60,
						"w": 89
					},
					{
						"n": 17,
						"h": 278,
						"w": 123
					},
					{
						"n": 19,
						"h": 280,
						"w": 86
					},
					{
						"n": 20,
						"h": 188,
						"w": 66
					}
				],
				"ball": {
					"n": 0,
					"h": 172,
					"w": 597,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1407,
			"minute": 68,
			"messages": [
				{
					"owner": 2,
					"mes": "Марин Томасов[37](Опава) смещается влево..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 217,
						"w": 707
					},
					{
						"n": 2,
						"h": 350,
						"w": 655
					},
					{
						"n": 14,
						"h": 267,
						"w": 658
					},
					{
						"n": 13,
						"h": 181,
						"w": 640
					},
					{
						"n": 5,
						"h": 120,
						"w": 662
					},
					{
						"n": 6,
						"h": 401,
						"w": 561
					},
					{
						"n": 18,
						"h": 254,
						"w": 591
					},
					{
						"n": 15,
						"h": 167,
						"w": 602
					},
					{
						"n": 17,
						"h": 83,
						"w": 574
					},
					{
						"n": 20,
						"h": 246,
						"w": 416
					},
					{
						"n": 19,
						"h": 182,
						"w": 386
					}
				],
				"away": [
					{
						"n": 1,
						"h": 226,
						"w": 597
					},
					{
						"n": 13,
						"h": 404,
						"w": 170
					},
					{
						"n": 3,
						"h": 279,
						"w": 422
					},
					{
						"n": 14,
						"h": 172,
						"w": 415
					},
					{
						"n": 5,
						"h": 73,
						"w": 421
					},
					{
						"n": 6,
						"h": 230,
						"w": 295
					},
					{
						"n": 7,
						"h": 215,
						"w": 164
					},
					{
						"n": 18,
						"h": 50,
						"w": 89
					},
					{
						"n": 17,
						"h": 298,
						"w": 123
					},
					{
						"n": 19,
						"h": 283,
						"w": 91
					},
					{
						"n": 20,
						"h": 173,
						"w": 80
					}
				],
				"ball": {
					"n": 0,
					"h": 152,
					"w": 597,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 20
		},
		{
			"num": 1408,
			"minute": 68,
			"messages": [
				{
					"owner": 2,
					"mes": "Марин Томасов[37](Опава) наносит удар с дальней дистанции..."
				},
				{
					"owner": 2,
					"mes": "Мяч проходит гораздо выше перекладины."
				}
			],
			"U": {
				"team": 2,
				"player": 17,
				"xg": "0.06"
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 205,
						"w": 707
					},
					{
						"n": 2,
						"h": 330,
						"w": 643
					},
					{
						"n": 14,
						"h": 278,
						"w": 657
					},
					{
						"n": 13,
						"h": 190,
						"w": 652
					},
					{
						"n": 5,
						"h": 120,
						"w": 644
					},
					{
						"n": 6,
						"h": 390,
						"w": 553
					},
					{
						"n": 18,
						"h": 263,
						"w": 568
					},
					{
						"n": 15,
						"h": 153,
						"w": 607
					},
					{
						"n": 17,
						"h": 65,
						"w": 603
					},
					{
						"n": 20,
						"h": 275,
						"w": 398
					},
					{
						"n": 19,
						"h": 196,
						"w": 418
					}
				],
				"away": [
					{
						"n": 1,
						"h": 226,
						"w": 602
					},
					{
						"n": 13,
						"h": 408,
						"w": 136
					},
					{
						"n": 3,
						"h": 277,
						"w": 422
					},
					{
						"n": 14,
						"h": 175,
						"w": 419
					},
					{
						"n": 5,
						"h": 74,
						"w": 391
					},
					{
						"n": 6,
						"h": 228,
						"w": 261
					},
					{
						"n": 7,
						"h": 235,
						"w": 191
					},
					{
						"n": 18,
						"h": 40,
						"w": 84
					},
					{
						"n": 17,
						"h": 298,
						"w": 123,
						"m": 640
					},
					{
						"n": 19,
						"h": 280,
						"w": 93
					},
					{
						"n": 20,
						"h": 160,
						"w": 89
					}
				],
				"ball": {
					"n": 0,
					"h": 224,
					"w": 751,
					"z": 1,
					"r": 0,
					"p": 0,
					"x": 4
				}
			},
			"interval": 34
		},
		{
			"num": 1409,
			"minute": 68,
			"messages": [
				{
					"owner": 1,
					"mes": "Удар от ворот..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 190,
						"w": 706
					},
					{
						"n": 2,
						"h": 385,
						"w": 515
					},
					{
						"n": 14,
						"h": 292,
						"w": 515
					},
					{
						"n": 13,
						"h": 165,
						"w": 515
					},
					{
						"n": 5,
						"h": 73,
						"w": 515
					},
					{
						"n": 6,
						"h": 389,
						"w": 388
					},
					{
						"n": 18,
						"h": 283,
						"w": 368
					},
					{
						"n": 15,
						"h": 170,
						"w": 368
					},
					{
						"n": 17,
						"h": 76,
						"w": 388
					},
					{
						"n": 20,
						"h": 291,
						"w": 220
					},
					{
						"n": 19,
						"h": 158,
						"w": 220
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 680
					},
					{
						"n": 13,
						"h": 377,
						"w": 492
					},
					{
						"n": 3,
						"h": 288,
						"w": 590
					},
					{
						"n": 14,
						"h": 158,
						"w": 590,
						"m": 650
					},
					{
						"n": 5,
						"h": 57,
						"w": 564
					},
					{
						"n": 6,
						"h": 215,
						"w": 520
					},
					{
						"n": 7,
						"h": 222,
						"w": 372
					},
					{
						"n": 18,
						"h": 75,
						"w": 350
					},
					{
						"n": 17,
						"h": 376,
						"w": 300
					},
					{
						"n": 19,
						"h": 280,
						"w": 272
					},
					{
						"n": 20,
						"h": 157,
						"w": 272
					}
				],
				"ball": {
					"n": 0,
					"h": 190,
					"w": 686,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 150
		},
		{
			"num": 1410,
			"minute": 68,
			"messages": [],
			"T": {
				"team": 1
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 190,
						"w": 686
					},
					{
						"n": 2,
						"h": 381,
						"w": 517
					},
					{
						"n": 14,
						"h": 297,
						"w": 511
					},
					{
						"n": 13,
						"h": 171,
						"w": 513
					},
					{
						"n": 5,
						"h": 70,
						"w": 521
					},
					{
						"n": 6,
						"h": 391,
						"w": 382
					},
					{
						"n": 18,
						"h": 285,
						"w": 366
					},
					{
						"n": 15,
						"h": 175,
						"w": 366
					},
					{
						"n": 17,
						"h": 77,
						"w": 388
					},
					{
						"n": 20,
						"h": 292,
						"w": 226
					},
					{
						"n": 19,
						"h": 152,
						"w": 222
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 683
					},
					{
						"n": 13,
						"h": 379,
						"w": 498
					},
					{
						"n": 3,
						"h": 286,
						"w": 587
					},
					{
						"n": 14,
						"h": 152,
						"w": 593
					},
					{
						"n": 5,
						"h": 51,
						"w": 562
					},
					{
						"n": 6,
						"h": 209,
						"w": 516
					},
					{
						"n": 7,
						"h": 220,
						"w": 370
					},
					{
						"n": 18,
						"h": 75,
						"w": 343
					},
					{
						"n": 17,
						"h": 381,
						"w": 302
					},
					{
						"n": 19,
						"h": 276,
						"w": 275
					},
					{
						"n": 20,
						"h": 156,
						"w": 274
					}
				],
				"ball": {
					"n": 0,
					"h": 190,
					"w": 686,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 15
		},
		{
			"num": 1411,
			"minute": 68,
			"messages": [
				{
					"owner": 1,
					"mes": "Мэттью Глэдхилл[01](Галвэй Юнайтед) далеко выбивает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 706
					},
					{
						"n": 2,
						"h": 377,
						"w": 469
					},
					{
						"n": 14,
						"h": 273,
						"w": 525
					},
					{
						"n": 13,
						"h": 170,
						"w": 495
					},
					{
						"n": 5,
						"h": 71,
						"w": 455
					},
					{
						"n": 6,
						"h": 394,
						"w": 291
					},
					{
						"n": 18,
						"h": 243,
						"w": 327
					},
					{
						"n": 15,
						"h": 175,
						"w": 357
					},
					{
						"n": 17,
						"h": 58,
						"w": 299
					},
					{
						"n": 20,
						"h": 283,
						"w": 317
					},
					{
						"n": 19,
						"h": 135,
						"w": 219
					}
				],
				"away": [
					{
						"n": 1,
						"h": 223,
						"w": 648
					},
					{
						"n": 13,
						"h": 392,
						"w": 457
					},
					{
						"n": 3,
						"h": 315,
						"w": 595
					},
					{
						"n": 14,
						"h": 218,
						"w": 595
					},
					{
						"n": 5,
						"h": 110,
						"w": 593
					},
					{
						"n": 6,
						"h": 297,
						"w": 539
					},
					{
						"n": 7,
						"h": 207,
						"w": 393
					},
					{
						"n": 18,
						"h": 61,
						"w": 433
					},
					{
						"n": 17,
						"h": 404,
						"w": 391
					},
					{
						"n": 19,
						"h": 275,
						"w": 366
					},
					{
						"n": 20,
						"h": 162,
						"w": 365
					}
				],
				"ball": {
					"n": 0,
					"h": 243,
					"w": 327,
					"z": 1,
					"r": 0,
					"p": 4,
					"x": 0
				}
			},
			"interval": 91
		},
		{
			"num": 1412,
			"minute": 68,
			"messages": [
				{
					"owner": 1,
					"mes": "Нарушение! Мирослав Манолов[27](Опава) подсел под Р.Уотсона[18](Галвэй Юнайтед)..."
				}
			],
			"L": {
				"team": 2
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 700
					},
					{
						"n": 2,
						"h": 376,
						"w": 471
					},
					{
						"n": 14,
						"h": 273,
						"w": 523
					},
					{
						"n": 13,
						"h": 170,
						"w": 500
					},
					{
						"n": 5,
						"h": 67,
						"w": 456
					},
					{
						"n": 6,
						"h": 397,
						"w": 296
					},
					{
						"n": 18,
						"h": 241,
						"w": 327,
						"m": 610
					},
					{
						"n": 15,
						"h": 176,
						"w": 362
					},
					{
						"n": 17,
						"h": 56,
						"w": 303
					},
					{
						"n": 20,
						"h": 282,
						"w": 312
					},
					{
						"n": 19,
						"h": 139,
						"w": 216
					}
				],
				"away": [
					{
						"n": 1,
						"h": 228,
						"w": 648
					},
					{
						"n": 13,
						"h": 389,
						"w": 452
					},
					{
						"n": 3,
						"h": 317,
						"w": 597
					},
					{
						"n": 14,
						"h": 222,
						"w": 592
					},
					{
						"n": 5,
						"h": 111,
						"w": 596
					},
					{
						"n": 6,
						"h": 296,
						"w": 543
					},
					{
						"n": 7,
						"h": 203,
						"w": 397
					},
					{
						"n": 18,
						"h": 61,
						"w": 437
					},
					{
						"n": 17,
						"h": 407,
						"w": 386
					},
					{
						"n": 19,
						"h": 276,
						"w": 363
					},
					{
						"n": 20,
						"h": 167,
						"w": 366
					}
				],
				"ball": {
					"n": 0,
					"h": 241,
					"w": 327,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 10
		},
		{
			"num": 1413,
			"minute": 68,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 680
					},
					{
						"n": 2,
						"h": 376,
						"w": 471
					},
					{
						"n": 14,
						"h": 273,
						"w": 523
					},
					{
						"n": 13,
						"h": 170,
						"w": 500
					},
					{
						"n": 5,
						"h": 67,
						"w": 456
					},
					{
						"n": 6,
						"h": 397,
						"w": 296
					},
					{
						"n": 18,
						"h": 242,
						"w": 335
					},
					{
						"n": 15,
						"h": 176,
						"w": 362
					},
					{
						"n": 17,
						"h": 56,
						"w": 303
					},
					{
						"n": 20,
						"h": 282,
						"w": 312
					},
					{
						"n": 19,
						"h": 139,
						"w": 216
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 710
					},
					{
						"n": 13,
						"h": 389,
						"w": 452
					},
					{
						"n": 3,
						"h": 317,
						"w": 597
					},
					{
						"n": 14,
						"h": 222,
						"w": 592
					},
					{
						"n": 5,
						"h": 111,
						"w": 596
					},
					{
						"n": 6,
						"h": 296,
						"w": 543
					},
					{
						"n": 7,
						"h": 211,
						"w": 438
					},
					{
						"n": 18,
						"h": 61,
						"w": 437
					},
					{
						"n": 17,
						"h": 407,
						"w": 386
					},
					{
						"n": 19,
						"h": 276,
						"w": 363
					},
					{
						"n": 20,
						"h": 162,
						"w": 363
					}
				],
				"ball": {
					"n": 0,
					"h": 241,
					"w": 327,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 100
		},
		{
			"num": 1414,
			"minute": 68,
			"messages": [
				{
					"owner": 1,
					"mes": "Штрафной в пользу команды Галвэй Юнайтед..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 681
					},
					{
						"n": 2,
						"h": 373,
						"w": 477
					},
					{
						"n": 14,
						"h": 276,
						"w": 527
					},
					{
						"n": 13,
						"h": 170,
						"w": 499
					},
					{
						"n": 5,
						"h": 65,
						"w": 464
					},
					{
						"n": 6,
						"h": 399,
						"w": 300
					},
					{
						"n": 18,
						"h": 241,
						"w": 327
					},
					{
						"n": 15,
						"h": 171,
						"w": 358
					},
					{
						"n": 17,
						"h": 50,
						"w": 298
					},
					{
						"n": 20,
						"h": 284,
						"w": 310
					},
					{
						"n": 19,
						"h": 136,
						"w": 218
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 700
					},
					{
						"n": 13,
						"h": 392,
						"w": 458
					},
					{
						"n": 3,
						"h": 313,
						"w": 594
					},
					{
						"n": 14,
						"h": 224,
						"w": 600
					},
					{
						"n": 5,
						"h": 108,
						"w": 594
					},
					{
						"n": 6,
						"h": 299,
						"w": 536
					},
					{
						"n": 7,
						"h": 204,
						"w": 445
					},
					{
						"n": 18,
						"h": 63,
						"w": 432
					},
					{
						"n": 17,
						"h": 401,
						"w": 393
					},
					{
						"n": 19,
						"h": 269,
						"w": 366
					},
					{
						"n": 20,
						"h": 159,
						"w": 370
					}
				],
				"ball": {
					"n": 0,
					"h": 241,
					"w": 327,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 15
		},
		{
			"num": 1415,
			"minute": 68,
			"messages": [
				{
					"owner": 1,
					"mes": "Мяч разыгран..."
				},
				{
					"owner": 1,
					"mes": "Райан Уотсон[18](Галвэй Юнайтед) посылает мяч налево в направлении Т.Дэвлина[20](Галвэй Юнайтед)..."
				},
				{
					"owner": 1,
					"mes": "Том Дэвлин[20](Галвэй Юнайтед) получает мяч..."
				}
			],
			"F": {
				"team": 1
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 708
					},
					{
						"n": 2,
						"h": 381,
						"w": 447
					},
					{
						"n": 14,
						"h": 274,
						"w": 486
					},
					{
						"n": 13,
						"h": 169,
						"w": 488
					},
					{
						"n": 5,
						"h": 70,
						"w": 433
					},
					{
						"n": 6,
						"h": 402,
						"w": 269
					},
					{
						"n": 18,
						"h": 243,
						"w": 317
					},
					{
						"n": 15,
						"h": 148,
						"w": 378
					},
					{
						"n": 17,
						"h": 40,
						"w": 269
					},
					{
						"n": 20,
						"h": 289,
						"w": 287
					},
					{
						"n": 19,
						"h": 147,
						"w": 189
					}
				],
				"away": [
					{
						"n": 1,
						"h": 221,
						"w": 670
					},
					{
						"n": 13,
						"h": 405,
						"w": 486
					},
					{
						"n": 3,
						"h": 286,
						"w": 608
					},
					{
						"n": 14,
						"h": 194,
						"w": 609
					},
					{
						"n": 5,
						"h": 110,
						"w": 616
					},
					{
						"n": 6,
						"h": 297,
						"w": 567
					},
					{
						"n": 7,
						"h": 174,
						"w": 438
					},
					{
						"n": 18,
						"h": 55,
						"w": 461
					},
					{
						"n": 17,
						"h": 404,
						"w": 404
					},
					{
						"n": 19,
						"h": 300,
						"w": 362
					},
					{
						"n": 20,
						"h": 180,
						"w": 393
					}
				],
				"ball": {
					"n": 0,
					"h": 289,
					"w": 287,
					"z": 0,
					"r": 2,
					"p": 0,
					"x": 0
				}
			},
			"interval": 31
		},
		{
			"num": 1416,
			"minute": 68,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 710
					},
					{
						"n": 2,
						"h": 380,
						"w": 408
					},
					{
						"n": 14,
						"h": 281,
						"w": 447
					},
					{
						"n": 13,
						"h": 169,
						"w": 449
					},
					{
						"n": 5,
						"h": 70,
						"w": 394
					},
					{
						"n": 6,
						"h": 414,
						"w": 233
					},
					{
						"n": 18,
						"h": 252,
						"w": 279
					},
					{
						"n": 15,
						"h": 146,
						"w": 339
					},
					{
						"n": 17,
						"h": 57,
						"w": 240
					},
					{
						"n": 20,
						"h": 306,
						"w": 257
					},
					{
						"n": 19,
						"h": 148,
						"w": 150
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 643
					},
					{
						"n": 13,
						"h": 393,
						"w": 516
					},
					{
						"n": 3,
						"h": 290,
						"w": 620
					},
					{
						"n": 14,
						"h": 174,
						"w": 603
					},
					{
						"n": 5,
						"h": 110,
						"w": 606
					},
					{
						"n": 6,
						"h": 310,
						"w": 579
					},
					{
						"n": 7,
						"h": 152,
						"w": 470
					},
					{
						"n": 18,
						"h": 48,
						"w": 500
					},
					{
						"n": 17,
						"h": 404,
						"w": 423
					},
					{
						"n": 19,
						"h": 304,
						"w": 401
					},
					{
						"n": 20,
						"h": 168,
						"w": 428
					}
				],
				"ball": {
					"n": 0,
					"h": 306,
					"w": 257,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 1417,
			"minute": 68,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 703
					},
					{
						"n": 2,
						"h": 382,
						"w": 369
					},
					{
						"n": 14,
						"h": 265,
						"w": 427
					},
					{
						"n": 13,
						"h": 169,
						"w": 430
					},
					{
						"n": 5,
						"h": 77,
						"w": 379
					},
					{
						"n": 6,
						"h": 406,
						"w": 195
					},
					{
						"n": 18,
						"h": 265,
						"w": 242
					},
					{
						"n": 15,
						"h": 148,
						"w": 300
					},
					{
						"n": 17,
						"h": 51,
						"w": 201
					},
					{
						"n": 20,
						"h": 333,
						"w": 230
					},
					{
						"n": 19,
						"h": 156,
						"w": 135
					}
				],
				"away": [
					{
						"n": 1,
						"h": 221,
						"w": 682
					},
					{
						"n": 13,
						"h": 399,
						"w": 555
					},
					{
						"n": 3,
						"h": 299,
						"w": 620
					},
					{
						"n": 14,
						"h": 212,
						"w": 609
					},
					{
						"n": 5,
						"h": 110,
						"w": 610
					},
					{
						"n": 6,
						"h": 271,
						"w": 575
					},
					{
						"n": 7,
						"h": 126,
						"w": 503
					},
					{
						"n": 18,
						"h": 45,
						"w": 548
					},
					{
						"n": 17,
						"h": 410,
						"w": 441
					},
					{
						"n": 19,
						"h": 302,
						"w": 440
					},
					{
						"n": 20,
						"h": 171,
						"w": 416
					}
				],
				"ball": {
					"n": 0,
					"h": 333,
					"w": 230,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 1418,
			"minute": 68,
			"messages": [
				{
					"owner": 1,
					"mes": "Пас К.Колману[06](Галвэй Юнайтед)..."
				},
				{
					"owner": 1,
					"mes": "Но Ньялл Томпсон[38](Опава) перехватывает мяч!..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 709
					},
					{
						"n": 2,
						"h": 387,
						"w": 371
					},
					{
						"n": 14,
						"h": 278,
						"w": 419
					},
					{
						"n": 13,
						"h": 178,
						"w": 402
					},
					{
						"n": 5,
						"h": 58,
						"w": 373
					},
					{
						"n": 6,
						"h": 383,
						"w": 194
					},
					{
						"n": 18,
						"h": 273,
						"w": 212
					},
					{
						"n": 15,
						"h": 179,
						"w": 303
					},
					{
						"n": 17,
						"h": 53,
						"w": 170
					},
					{
						"n": 20,
						"h": 329,
						"w": 221,
						"m": 600
					},
					{
						"n": 19,
						"h": 173,
						"w": 126
					}
				],
				"away": [
					{
						"n": 1,
						"h": 216,
						"w": 708
					},
					{
						"n": 13,
						"h": 397,
						"w": 586
					},
					{
						"n": 3,
						"h": 269,
						"w": 611
					},
					{
						"n": 14,
						"h": 192,
						"w": 629
					},
					{
						"n": 5,
						"h": 85,
						"w": 607
					},
					{
						"n": 6,
						"h": 241,
						"w": 568
					},
					{
						"n": 7,
						"h": 157,
						"w": 504
					},
					{
						"n": 18,
						"h": 67,
						"w": 526
					},
					{
						"n": 17,
						"h": 414,
						"w": 464
					},
					{
						"n": 19,
						"h": 271,
						"w": 437
					},
					{
						"n": 20,
						"h": 175,
						"w": 416
					}
				],
				"ball": {
					"n": 0,
					"h": 383,
					"w": 194,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 31
		},
		{
			"num": 1419,
			"minute": 68,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 704
					},
					{
						"n": 2,
						"h": 360,
						"w": 401
					},
					{
						"n": 14,
						"h": 263,
						"w": 429
					},
					{
						"n": 13,
						"h": 188,
						"w": 441
					},
					{
						"n": 5,
						"h": 86,
						"w": 402
					},
					{
						"n": 6,
						"h": 394,
						"w": 209
					},
					{
						"n": 18,
						"h": 279,
						"w": 252
					},
					{
						"n": 15,
						"h": 174,
						"w": 329
					},
					{
						"n": 17,
						"h": 47,
						"w": 210
					},
					{
						"n": 20,
						"h": 291,
						"w": 210
					},
					{
						"n": 19,
						"h": 171,
						"w": 166
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 710
					},
					{
						"n": 13,
						"h": 405,
						"w": 546
					},
					{
						"n": 3,
						"h": 269,
						"w": 615
					},
					{
						"n": 14,
						"h": 174,
						"w": 618
					},
					{
						"n": 5,
						"h": 76,
						"w": 614
					},
					{
						"n": 6,
						"h": 209,
						"w": 544
					},
					{
						"n": 7,
						"h": 182,
						"w": 473
					},
					{
						"n": 18,
						"h": 31,
						"w": 526,
						"m": 620
					},
					{
						"n": 17,
						"h": 409,
						"w": 424
					},
					{
						"n": 19,
						"h": 278,
						"w": 397
					},
					{
						"n": 20,
						"h": 169,
						"w": 377
					}
				],
				"ball": {
					"n": 0,
					"h": 419,
					"w": 194,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1420,
			"minute": 68,
			"messages": [
				{
					"owner": 2,
					"mes": "Ньялл Томпсон[38](Опава) посылает мяч налево в направлении В.Сланины[34](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 705
					},
					{
						"n": 2,
						"h": 338,
						"w": 439
					},
					{
						"n": 14,
						"h": 285,
						"w": 459
					},
					{
						"n": 13,
						"h": 180,
						"w": 478
					},
					{
						"n": 5,
						"h": 106,
						"w": 441
					},
					{
						"n": 6,
						"h": 393,
						"w": 253
					},
					{
						"n": 18,
						"h": 275,
						"w": 296
					},
					{
						"n": 15,
						"h": 160,
						"w": 367
					},
					{
						"n": 17,
						"h": 49,
						"w": 254
					},
					{
						"n": 20,
						"h": 308,
						"w": 251
					},
					{
						"n": 19,
						"h": 168,
						"w": 210
					}
				],
				"away": [
					{
						"n": 1,
						"h": 228,
						"w": 701
					},
					{
						"n": 13,
						"h": 405,
						"w": 502
					},
					{
						"n": 3,
						"h": 276,
						"w": 605
					},
					{
						"n": 14,
						"h": 145,
						"w": 594
					},
					{
						"n": 5,
						"h": 69,
						"w": 600
					},
					{
						"n": 6,
						"h": 215,
						"w": 500
					},
					{
						"n": 7,
						"h": 199,
						"w": 433
					},
					{
						"n": 18,
						"h": 35,
						"w": 516
					},
					{
						"n": 17,
						"h": 402,
						"w": 381
					},
					{
						"n": 19,
						"h": 290,
						"w": 355
					},
					{
						"n": 20,
						"h": 153,
						"w": 336
					}
				],
				"ball": {
					"n": 0,
					"h": 305,
					"w": 126,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 44
		},
		{
			"num": 1421,
			"minute": 68,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 704
					},
					{
						"n": 2,
						"h": 330,
						"w": 461
					},
					{
						"n": 14,
						"h": 279,
						"w": 456
					},
					{
						"n": 13,
						"h": 169,
						"w": 441
					},
					{
						"n": 5,
						"h": 120,
						"w": 456
					},
					{
						"n": 6,
						"h": 392,
						"w": 293
					},
					{
						"n": 18,
						"h": 262,
						"w": 333
					},
					{
						"n": 15,
						"h": 145,
						"w": 376
					},
					{
						"n": 17,
						"h": 50,
						"w": 294
					},
					{
						"n": 20,
						"h": 287,
						"w": 285
					},
					{
						"n": 19,
						"h": 149,
						"w": 245
					}
				],
				"away": [
					{
						"n": 1,
						"h": 223,
						"w": 703
					},
					{
						"n": 13,
						"h": 405,
						"w": 470
					},
					{
						"n": 3,
						"h": 271,
						"w": 595
					},
					{
						"n": 14,
						"h": 146,
						"w": 559
					},
					{
						"n": 5,
						"h": 73,
						"w": 595
					},
					{
						"n": 6,
						"h": 231,
						"w": 491
					},
					{
						"n": 7,
						"h": 209,
						"w": 394
					},
					{
						"n": 18,
						"h": 33,
						"w": 476
					},
					{
						"n": 17,
						"h": 399,
						"w": 341
					},
					{
						"n": 19,
						"h": 302,
						"w": 317
					},
					{
						"n": 20,
						"h": 157,
						"w": 296
					}
				],
				"ball": {
					"n": 0,
					"h": 304,
					"w": 161,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1422,
			"minute": 68,
			"messages": [
				{
					"owner": 2,
					"mes": "Пас налево..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 703
					},
					{
						"n": 2,
						"h": 330,
						"w": 456
					},
					{
						"n": 14,
						"h": 262,
						"w": 466
					},
					{
						"n": 13,
						"h": 181,
						"w": 447
					},
					{
						"n": 5,
						"h": 88,
						"w": 440
					},
					{
						"n": 6,
						"h": 405,
						"w": 327
					},
					{
						"n": 18,
						"h": 260,
						"w": 369
					},
					{
						"n": 15,
						"h": 178,
						"w": 362
					},
					{
						"n": 17,
						"h": 55,
						"w": 330
					},
					{
						"n": 20,
						"h": 289,
						"w": 300
					},
					{
						"n": 19,
						"h": 165,
						"w": 213
					}
				],
				"away": [
					{
						"n": 1,
						"h": 226,
						"w": 704
					},
					{
						"n": 13,
						"h": 396,
						"w": 457
					},
					{
						"n": 3,
						"h": 269,
						"w": 596
					},
					{
						"n": 14,
						"h": 152,
						"w": 567
					},
					{
						"n": 5,
						"h": 66,
						"w": 607
					},
					{
						"n": 6,
						"h": 263,
						"w": 508
					},
					{
						"n": 7,
						"h": 228,
						"w": 393
					},
					{
						"n": 18,
						"h": 37,
						"w": 441
					},
					{
						"n": 17,
						"h": 404,
						"w": 305
					},
					{
						"n": 19,
						"h": 285,
						"w": 285
					},
					{
						"n": 20,
						"h": 171,
						"w": 294
					}
				],
				"ball": {
					"n": 0,
					"h": 199,
					"w": 192,
					"z": 0,
					"r": 0,
					"p": 2,
					"x": 0
				}
			},
			"interval": 36
		},
		{
			"num": 1423,
			"minute": 68,
			"messages": [
				{
					"owner": 1,
					"mes": "Байрон О`Горман[19](Галвэй Юнайтед) подхватывает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 707
					},
					{
						"n": 2,
						"h": 318,
						"w": 457
					},
					{
						"n": 14,
						"h": 250,
						"w": 464
					},
					{
						"n": 13,
						"h": 181,
						"w": 459
					},
					{
						"n": 5,
						"h": 77,
						"w": 440
					},
					{
						"n": 6,
						"h": 400,
						"w": 338
					},
					{
						"n": 18,
						"h": 270,
						"w": 371
					},
					{
						"n": 15,
						"h": 178,
						"w": 353
					},
					{
						"n": 17,
						"h": 47,
						"w": 339
					},
					{
						"n": 20,
						"h": 294,
						"w": 302
					},
					{
						"n": 19,
						"h": 168,
						"w": 201,
						"m": 640
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 701
					},
					{
						"n": 13,
						"h": 405,
						"w": 450
					},
					{
						"n": 3,
						"h": 268,
						"w": 603
					},
					{
						"n": 14,
						"h": 155,
						"w": 579,
						"m": 640
					},
					{
						"n": 5,
						"h": 71,
						"w": 605
					},
					{
						"n": 6,
						"h": 273,
						"w": 514
					},
					{
						"n": 7,
						"h": 227,
						"w": 402
					},
					{
						"n": 18,
						"h": 37,
						"w": 429
					},
					{
						"n": 17,
						"h": 403,
						"w": 300
					},
					{
						"n": 19,
						"h": 274,
						"w": 282
					},
					{
						"n": 20,
						"h": 160,
						"w": 298
					}
				],
				"ball": {
					"n": 0,
					"h": 168,
					"w": 201,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 12
		},
		{
			"num": 1424,
			"minute": 68,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 709
					},
					{
						"n": 2,
						"h": 340,
						"w": 424
					},
					{
						"n": 14,
						"h": 265,
						"w": 427
					},
					{
						"n": 13,
						"h": 183,
						"w": 419
					},
					{
						"n": 5,
						"h": 75,
						"w": 400
					},
					{
						"n": 6,
						"h": 402,
						"w": 298
					},
					{
						"n": 18,
						"h": 277,
						"w": 332
					},
					{
						"n": 15,
						"h": 171,
						"w": 314
					},
					{
						"n": 17,
						"h": 50,
						"w": 299
					},
					{
						"n": 20,
						"h": 290,
						"w": 262
					},
					{
						"n": 19,
						"h": 171,
						"w": 158
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 683
					},
					{
						"n": 13,
						"h": 400,
						"w": 457
					},
					{
						"n": 3,
						"h": 291,
						"w": 610
					},
					{
						"n": 14,
						"h": 188,
						"w": 600
					},
					{
						"n": 5,
						"h": 107,
						"w": 622
					},
					{
						"n": 6,
						"h": 278,
						"w": 562
					},
					{
						"n": 7,
						"h": 228,
						"w": 442
					},
					{
						"n": 18,
						"h": 48,
						"w": 458
					},
					{
						"n": 17,
						"h": 401,
						"w": 340
					},
					{
						"n": 19,
						"h": 275,
						"w": 322
					},
					{
						"n": 20,
						"h": 164,
						"w": 338
					}
				],
				"ball": {
					"n": 0,
					"h": 171,
					"w": 158,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1425,
			"minute": 68,
			"messages": [
				{
					"owner": 1,
					"mes": "Оливье Дюмон[26](Опава) пытается отобрать мяч у Б.О`Гормана[19](Галвэй Юнайтед)..."
				},
				{
					"owner": 1,
					"mes": "О.Дюмон[26](Опава) выбивает мяч у Б.О`Гормана[19](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 708
					},
					{
						"n": 2,
						"h": 355,
						"w": 401
					},
					{
						"n": 14,
						"h": 267,
						"w": 424
					},
					{
						"n": 13,
						"h": 183,
						"w": 432
					},
					{
						"n": 5,
						"h": 71,
						"w": 373
					},
					{
						"n": 6,
						"h": 400,
						"w": 271
					},
					{
						"n": 18,
						"h": 282,
						"w": 305
					},
					{
						"n": 15,
						"h": 170,
						"w": 287
					},
					{
						"n": 17,
						"h": 52,
						"w": 272
					},
					{
						"n": 20,
						"h": 291,
						"w": 235
					},
					{
						"n": 19,
						"h": 169,
						"w": 155
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 706
					},
					{
						"n": 13,
						"h": 398,
						"w": 484
					},
					{
						"n": 3,
						"h": 265,
						"w": 606
					},
					{
						"n": 14,
						"h": 178,
						"w": 625
					},
					{
						"n": 5,
						"h": 110,
						"w": 615
					},
					{
						"n": 6,
						"h": 279,
						"w": 568,
						"m": 640
					},
					{
						"n": 7,
						"h": 245,
						"w": 463
					},
					{
						"n": 18,
						"h": 50,
						"w": 485
					},
					{
						"n": 17,
						"h": 400,
						"w": 367
					},
					{
						"n": 19,
						"h": 276,
						"w": 349
					},
					{
						"n": 20,
						"h": 165,
						"w": 365
					}
				],
				"ball": {
					"n": 0,
					"h": 168,
					"w": 211,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 27
		},
		{
			"num": 1426,
			"minute": 68,
			"messages": [
				{
					"owner": 2,
					"mes": "Оливье Дюмон[26](Опава) первый на подборе..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 706
					},
					{
						"n": 2,
						"h": 373,
						"w": 378
					},
					{
						"n": 14,
						"h": 269,
						"w": 413
					},
					{
						"n": 13,
						"h": 171,
						"w": 406
					},
					{
						"n": 5,
						"h": 76,
						"w": 378
					},
					{
						"n": 6,
						"h": 405,
						"w": 222
					},
					{
						"n": 18,
						"h": 277,
						"w": 256
					},
					{
						"n": 15,
						"h": 169,
						"w": 238
					},
					{
						"n": 17,
						"h": 47,
						"w": 224
					},
					{
						"n": 20,
						"h": 282,
						"w": 187
					},
					{
						"n": 19,
						"h": 164,
						"w": 151
					}
				],
				"away": [
					{
						"n": 1,
						"h": 231,
						"w": 706
					},
					{
						"n": 13,
						"h": 403,
						"w": 532
					},
					{
						"n": 3,
						"h": 273,
						"w": 623
					},
					{
						"n": 14,
						"h": 184,
						"w": 623
					},
					{
						"n": 5,
						"h": 110,
						"w": 615
					},
					{
						"n": 6,
						"h": 282,
						"w": 509
					},
					{
						"n": 7,
						"h": 229,
						"w": 510
					},
					{
						"n": 18,
						"h": 45,
						"w": 534
					},
					{
						"n": 17,
						"h": 413,
						"w": 414
					},
					{
						"n": 19,
						"h": 287,
						"w": 396
					},
					{
						"n": 20,
						"h": 159,
						"w": 414
					}
				],
				"ball": {
					"n": 0,
					"h": 168,
					"w": 211,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 49
		},
		{
			"num": 1427,
			"minute": 69,
			"possession": 44,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 708
					},
					{
						"n": 2,
						"h": 348,
						"w": 409
					},
					{
						"n": 14,
						"h": 285,
						"w": 417
					},
					{
						"n": 13,
						"h": 166,
						"w": 440
					},
					{
						"n": 5,
						"h": 105,
						"w": 405
					},
					{
						"n": 6,
						"h": 402,
						"w": 262
					},
					{
						"n": 18,
						"h": 267,
						"w": 295
					},
					{
						"n": 15,
						"h": 157,
						"w": 263
					},
					{
						"n": 17,
						"h": 38,
						"w": 262,
						"m": 720
					},
					{
						"n": 20,
						"h": 281,
						"w": 227
					},
					{
						"n": 19,
						"h": 165,
						"w": 191,
						"f": 96
					}
				],
				"away": [
					{
						"n": 1,
						"h": 228,
						"w": 704,
						"f": 81
					},
					{
						"n": 13,
						"h": 397,
						"w": 493
					},
					{
						"n": 3,
						"h": 280,
						"w": 613
					},
					{
						"n": 14,
						"h": 167,
						"w": 612
					},
					{
						"n": 5,
						"h": 72,
						"w": 603
					},
					{
						"n": 6,
						"h": 297,
						"w": 477
					},
					{
						"n": 7,
						"h": 233,
						"w": 470
					},
					{
						"n": 18,
						"h": 46,
						"w": 494,
						"f": 95
					},
					{
						"n": 17,
						"h": 413,
						"w": 438
					},
					{
						"n": 19,
						"h": 300,
						"w": 359
					},
					{
						"n": 20,
						"h": 150,
						"w": 375,
						"f": 95
					}
				],
				"ball": {
					"n": 0,
					"h": 153,
					"w": 243,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1428,
			"minute": 69,
			"messages": [
				{
					"owner": 2,
					"mes": "Передача М.Манолову[27](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 705
					},
					{
						"n": 2,
						"h": 340,
						"w": 434
					},
					{
						"n": 14,
						"h": 282,
						"w": 443
					},
					{
						"n": 13,
						"h": 183,
						"w": 440
					},
					{
						"n": 5,
						"h": 112,
						"w": 430
					},
					{
						"n": 6,
						"h": 400,
						"w": 288
					},
					{
						"n": 18,
						"h": 246,
						"w": 280
					},
					{
						"n": 15,
						"h": 166,
						"w": 287
					},
					{
						"n": 17,
						"h": 36,
						"w": 275
					},
					{
						"n": 20,
						"h": 282,
						"w": 253
					},
					{
						"n": 19,
						"h": 163,
						"w": 217
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 708
					},
					{
						"n": 13,
						"h": 396,
						"w": 467
					},
					{
						"n": 3,
						"h": 282,
						"w": 602
					},
					{
						"n": 14,
						"h": 178,
						"w": 615
					},
					{
						"n": 5,
						"h": 72,
						"w": 614
					},
					{
						"n": 6,
						"h": 290,
						"w": 485
					},
					{
						"n": 7,
						"h": 245,
						"w": 482
					},
					{
						"n": 18,
						"h": 39,
						"w": 469
					},
					{
						"n": 17,
						"h": 406,
						"w": 413
					},
					{
						"n": 19,
						"h": 300,
						"w": 333
					},
					{
						"n": 20,
						"h": 139,
						"w": 351
					}
				],
				"ball": {
					"n": 0,
					"h": 205,
					"w": 238,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 26
		},
		{
			"num": 1429,
			"minute": 69,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 703
					},
					{
						"n": 2,
						"h": 330,
						"w": 453
					},
					{
						"n": 14,
						"h": 281,
						"w": 451
					},
					{
						"n": 13,
						"h": 161,
						"w": 436
					},
					{
						"n": 5,
						"h": 120,
						"w": 448
					},
					{
						"n": 6,
						"h": 412,
						"w": 326
					},
					{
						"n": 18,
						"h": 206,
						"w": 288
					},
					{
						"n": 15,
						"h": 173,
						"w": 326
					},
					{
						"n": 17,
						"h": 33,
						"w": 295
					},
					{
						"n": 20,
						"h": 282,
						"w": 276
					},
					{
						"n": 19,
						"h": 193,
						"w": 233
					}
				],
				"away": [
					{
						"n": 1,
						"h": 228,
						"w": 702
					},
					{
						"n": 13,
						"h": 390,
						"w": 449
					},
					{
						"n": 3,
						"h": 275,
						"w": 621
					},
					{
						"n": 14,
						"h": 179,
						"w": 625
					},
					{
						"n": 5,
						"h": 73,
						"w": 615
					},
					{
						"n": 6,
						"h": 257,
						"w": 507
					},
					{
						"n": 7,
						"h": 252,
						"w": 447
					},
					{
						"n": 18,
						"h": 39,
						"w": 429
					},
					{
						"n": 17,
						"h": 369,
						"w": 428
					},
					{
						"n": 19,
						"h": 300,
						"w": 316
					},
					{
						"n": 20,
						"h": 150,
						"w": 388
					}
				],
				"ball": {
					"n": 0,
					"h": 198,
					"w": 273,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1430,
			"minute": 69,
			"messages": [
				{
					"owner": 2,
					"mes": "Мирослав Манолов[27](Опава) делает передачу на правый край..."
				},
				{
					"owner": 2,
					"mes": "Томаш Прохазка[25](Опава) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 704
					},
					{
						"n": 2,
						"h": 330,
						"w": 444
					},
					{
						"n": 14,
						"h": 293,
						"w": 447
					},
					{
						"n": 13,
						"h": 174,
						"w": 454
					},
					{
						"n": 5,
						"h": 120,
						"w": 451
					},
					{
						"n": 6,
						"h": 394,
						"w": 377
					},
					{
						"n": 18,
						"h": 238,
						"w": 332
					},
					{
						"n": 15,
						"h": 208,
						"w": 348
					},
					{
						"n": 17,
						"h": 36,
						"w": 322
					},
					{
						"n": 20,
						"h": 248,
						"w": 234
					},
					{
						"n": 19,
						"h": 152,
						"w": 268
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 702
					},
					{
						"n": 13,
						"h": 405,
						"w": 445
					},
					{
						"n": 3,
						"h": 273,
						"w": 622
					},
					{
						"n": 14,
						"h": 162,
						"w": 604
					},
					{
						"n": 5,
						"h": 89,
						"w": 586
					},
					{
						"n": 6,
						"h": 203,
						"w": 508
					},
					{
						"n": 7,
						"h": 245,
						"w": 441
					},
					{
						"n": 18,
						"h": 53,
						"w": 377
					},
					{
						"n": 17,
						"h": 326,
						"w": 449
					},
					{
						"n": 19,
						"h": 296,
						"w": 289
					},
					{
						"n": 20,
						"h": 143,
						"w": 334
					}
				],
				"ball": {
					"n": 0,
					"h": 361,
					"w": 134,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 54
		},
		{
			"num": 1431,
			"minute": 69,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 706
					},
					{
						"n": 2,
						"h": 330,
						"w": 463
					},
					{
						"n": 14,
						"h": 283,
						"w": 453
					},
					{
						"n": 13,
						"h": 165,
						"w": 473
					},
					{
						"n": 5,
						"h": 120,
						"w": 461
					},
					{
						"n": 6,
						"h": 394,
						"w": 381
					},
					{
						"n": 18,
						"h": 268,
						"w": 359
					},
					{
						"n": 15,
						"h": 215,
						"w": 358
					},
					{
						"n": 17,
						"h": 34,
						"w": 360
					},
					{
						"n": 20,
						"h": 252,
						"w": 253
					},
					{
						"n": 19,
						"h": 170,
						"w": 303
					}
				],
				"away": [
					{
						"n": 1,
						"h": 229,
						"w": 704
					},
					{
						"n": 13,
						"h": 415,
						"w": 466
					},
					{
						"n": 3,
						"h": 272,
						"w": 597
					},
					{
						"n": 14,
						"h": 169,
						"w": 609
					},
					{
						"n": 5,
						"h": 72,
						"w": 555
					},
					{
						"n": 6,
						"h": 198,
						"w": 487
					},
					{
						"n": 7,
						"h": 213,
						"w": 417
					},
					{
						"n": 18,
						"h": 33,
						"w": 354
					},
					{
						"n": 17,
						"h": 289,
						"w": 433
					},
					{
						"n": 19,
						"h": 314,
						"w": 294
					},
					{
						"n": 20,
						"h": 153,
						"w": 296
					}
				],
				"ball": {
					"n": 0,
					"h": 378,
					"w": 165,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1432,
			"minute": 69,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 705
					},
					{
						"n": 2,
						"h": 330,
						"w": 463
					},
					{
						"n": 14,
						"h": 276,
						"w": 451
					},
					{
						"n": 13,
						"h": 176,
						"w": 473
					},
					{
						"n": 5,
						"h": 120,
						"w": 453
					},
					{
						"n": 6,
						"h": 394,
						"w": 400
					},
					{
						"n": 18,
						"h": 287,
						"w": 387
					},
					{
						"n": 15,
						"h": 220,
						"w": 345
					},
					{
						"n": 17,
						"h": 62,
						"w": 360
					},
					{
						"n": 20,
						"h": 253,
						"w": 297
					},
					{
						"n": 19,
						"h": 156,
						"w": 295
					}
				],
				"away": [
					{
						"n": 1,
						"h": 223,
						"w": 705
					},
					{
						"n": 13,
						"h": 403,
						"w": 462
					},
					{
						"n": 3,
						"h": 273,
						"w": 614
					},
					{
						"n": 14,
						"h": 177,
						"w": 596
					},
					{
						"n": 5,
						"h": 67,
						"w": 515
					},
					{
						"n": 6,
						"h": 216,
						"w": 509
					},
					{
						"n": 7,
						"h": 196,
						"w": 427
					},
					{
						"n": 18,
						"h": 48,
						"w": 354
					},
					{
						"n": 17,
						"h": 254,
						"w": 413
					},
					{
						"n": 19,
						"h": 294,
						"w": 300
					},
					{
						"n": 20,
						"h": 156,
						"w": 293
					}
				],
				"ball": {
					"n": 0,
					"h": 383,
					"w": 205,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1433,
			"minute": 69,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 707
					},
					{
						"n": 2,
						"h": 330,
						"w": 472
					},
					{
						"n": 14,
						"h": 273,
						"w": 472
					},
					{
						"n": 13,
						"h": 181,
						"w": 475
					},
					{
						"n": 5,
						"h": 120,
						"w": 479
					},
					{
						"n": 6,
						"h": 394,
						"w": 420
					},
					{
						"n": 18,
						"h": 302,
						"w": 405
					},
					{
						"n": 15,
						"h": 191,
						"w": 364
					},
					{
						"n": 17,
						"h": 54,
						"w": 375
					},
					{
						"n": 20,
						"h": 282,
						"w": 284
					},
					{
						"n": 19,
						"h": 171,
						"w": 314
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 703
					},
					{
						"n": 13,
						"h": 395,
						"w": 423
					},
					{
						"n": 3,
						"h": 284,
						"w": 596
					},
					{
						"n": 14,
						"h": 178,
						"w": 587
					},
					{
						"n": 5,
						"h": 62,
						"w": 475
					},
					{
						"n": 6,
						"h": 211,
						"w": 502
					},
					{
						"n": 7,
						"h": 168,
						"w": 456
					},
					{
						"n": 18,
						"h": 42,
						"w": 315
					},
					{
						"n": 17,
						"h": 220,
						"w": 392
					},
					{
						"n": 19,
						"h": 283,
						"w": 280
					},
					{
						"n": 20,
						"h": 158,
						"w": 262
					}
				],
				"ball": {
					"n": 0,
					"h": 388,
					"w": 245,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1434,
			"minute": 69,
			"messages": [
				{
					"owner": 2,
					"mes": "Т.Прохазка[25](Опава) пасует К.Ласаку[21](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 707
					},
					{
						"n": 2,
						"h": 330,
						"w": 461
					},
					{
						"n": 14,
						"h": 271,
						"w": 470
					},
					{
						"n": 13,
						"h": 172,
						"w": 452
					},
					{
						"n": 5,
						"h": 120,
						"w": 464
					},
					{
						"n": 6,
						"h": 394,
						"w": 435
					},
					{
						"n": 18,
						"h": 293,
						"w": 385
					},
					{
						"n": 15,
						"h": 191,
						"w": 370
					},
					{
						"n": 17,
						"h": 58,
						"w": 365
					},
					{
						"n": 20,
						"h": 316,
						"w": 285
					},
					{
						"n": 19,
						"h": 174,
						"w": 309
					}
				],
				"away": [
					{
						"n": 1,
						"h": 209,
						"w": 691
					},
					{
						"n": 13,
						"h": 418,
						"w": 458
					},
					{
						"n": 3,
						"h": 269,
						"w": 567
					},
					{
						"n": 14,
						"h": 177,
						"w": 572
					},
					{
						"n": 5,
						"h": 62,
						"w": 485,
						"m": 690
					},
					{
						"n": 6,
						"h": 225,
						"w": 493
					},
					{
						"n": 7,
						"h": 217,
						"w": 413
					},
					{
						"n": 18,
						"h": 37,
						"w": 300
					},
					{
						"n": 17,
						"h": 163,
						"w": 363
					},
					{
						"n": 19,
						"h": 293,
						"w": 272
					},
					{
						"n": 20,
						"h": 169,
						"w": 292
					}
				],
				"ball": {
					"n": 0,
					"h": 241,
					"w": 29,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 65
		},
		{
			"num": 1435,
			"minute": 69,
			"messages": [
				{
					"owner": 2,
					"mes": "Передача вперед..."
				},
				{
					"owner": 2,
					"mes": "Оливье Дюмон[26](Опава) принимает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 707
					},
					{
						"n": 2,
						"h": 330,
						"w": 472
					},
					{
						"n": 14,
						"h": 277,
						"w": 460
					},
					{
						"n": 13,
						"h": 177,
						"w": 489
					},
					{
						"n": 5,
						"h": 120,
						"w": 461
					},
					{
						"n": 6,
						"h": 379,
						"w": 455
					},
					{
						"n": 18,
						"h": 256,
						"w": 380
					},
					{
						"n": 15,
						"h": 183,
						"w": 356
					},
					{
						"n": 17,
						"h": 64,
						"w": 370
					},
					{
						"n": 20,
						"h": 282,
						"w": 307
					},
					{
						"n": 19,
						"h": 161,
						"w": 263
					}
				],
				"away": [
					{
						"n": 1,
						"h": 221,
						"w": 702
					},
					{
						"n": 13,
						"h": 419,
						"w": 459
					},
					{
						"n": 3,
						"h": 271,
						"w": 605
					},
					{
						"n": 14,
						"h": 171,
						"w": 580
					},
					{
						"n": 5,
						"h": 67,
						"w": 561
					},
					{
						"n": 6,
						"h": 289,
						"w": 477
					},
					{
						"n": 7,
						"h": 240,
						"w": 411
					},
					{
						"n": 18,
						"h": 56,
						"w": 290
					},
					{
						"n": 17,
						"h": 202,
						"w": 345
					},
					{
						"n": 19,
						"h": 285,
						"w": 278
					},
					{
						"n": 20,
						"h": 161,
						"w": 269
					}
				],
				"ball": {
					"n": 0,
					"h": 161,
					"w": 243,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 76
		},
		{
			"num": 1436,
			"minute": 69,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 707
					},
					{
						"n": 2,
						"h": 366,
						"w": 489
					},
					{
						"n": 14,
						"h": 274,
						"w": 500
					},
					{
						"n": 13,
						"h": 181,
						"w": 519
					},
					{
						"n": 5,
						"h": 120,
						"w": 501
					},
					{
						"n": 6,
						"h": 405,
						"w": 427
					},
					{
						"n": 18,
						"h": 268,
						"w": 418
					},
					{
						"n": 15,
						"h": 184,
						"w": 396
					},
					{
						"n": 17,
						"h": 55,
						"w": 388
					},
					{
						"n": 20,
						"h": 283,
						"w": 347
					},
					{
						"n": 19,
						"h": 196,
						"w": 263
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 703
					},
					{
						"n": 13,
						"h": 403,
						"w": 422
					},
					{
						"n": 3,
						"h": 280,
						"w": 556
					},
					{
						"n": 14,
						"h": 177,
						"w": 561
					},
					{
						"n": 5,
						"h": 63,
						"w": 545
					},
					{
						"n": 6,
						"h": 254,
						"w": 477
					},
					{
						"n": 7,
						"h": 231,
						"w": 372
					},
					{
						"n": 18,
						"h": 53,
						"w": 250
					},
					{
						"n": 17,
						"h": 175,
						"w": 316
					},
					{
						"n": 19,
						"h": 289,
						"w": 238
					},
					{
						"n": 20,
						"h": 168,
						"w": 230
					}
				],
				"ball": {
					"n": 0,
					"h": 196,
					"w": 243,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1437,
			"minute": 69,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 706
					},
					{
						"n": 2,
						"h": 374,
						"w": 529
					},
					{
						"n": 14,
						"h": 277,
						"w": 540
					},
					{
						"n": 13,
						"h": 170,
						"w": 533
					},
					{
						"n": 5,
						"h": 120,
						"w": 541
					},
					{
						"n": 6,
						"h": 415,
						"w": 445
					},
					{
						"n": 18,
						"h": 283,
						"w": 455
					},
					{
						"n": 15,
						"h": 188,
						"w": 436
					},
					{
						"n": 17,
						"h": 56,
						"w": 373
					},
					{
						"n": 20,
						"h": 308,
						"w": 362
					},
					{
						"n": 19,
						"h": 188,
						"w": 302
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 680
					},
					{
						"n": 13,
						"h": 403,
						"w": 382
					},
					{
						"n": 3,
						"h": 276,
						"w": 523
					},
					{
						"n": 14,
						"h": 161,
						"w": 524
					},
					{
						"n": 5,
						"h": 71,
						"w": 506
					},
					{
						"n": 6,
						"h": 220,
						"w": 468
					},
					{
						"n": 7,
						"h": 225,
						"w": 412
					},
					{
						"n": 18,
						"h": 46,
						"w": 211
					},
					{
						"n": 17,
						"h": 167,
						"w": 277
					},
					{
						"n": 19,
						"h": 304,
						"w": 201
					},
					{
						"n": 20,
						"h": 153,
						"w": 193
					}
				],
				"ball": {
					"n": 0,
					"h": 230,
					"w": 252,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1438,
			"minute": 69,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 706
					},
					{
						"n": 2,
						"h": 394,
						"w": 538
					},
					{
						"n": 14,
						"h": 285,
						"w": 566
					},
					{
						"n": 13,
						"h": 175,
						"w": 544
					},
					{
						"n": 5,
						"h": 120,
						"w": 567
					},
					{
						"n": 6,
						"h": 420,
						"w": 460
					},
					{
						"n": 18,
						"h": 286,
						"w": 495
					},
					{
						"n": 15,
						"h": 186,
						"w": 443
					},
					{
						"n": 17,
						"h": 56,
						"w": 413
					},
					{
						"n": 20,
						"h": 319,
						"w": 375
					},
					{
						"n": 19,
						"h": 227,
						"w": 306
					}
				],
				"away": [
					{
						"n": 1,
						"h": 223,
						"w": 657
					},
					{
						"n": 13,
						"h": 403,
						"w": 342
					},
					{
						"n": 3,
						"h": 271,
						"w": 503
					},
					{
						"n": 14,
						"h": 174,
						"w": 493
					},
					{
						"n": 5,
						"h": 58,
						"w": 509
					},
					{
						"n": 6,
						"h": 218,
						"w": 433
					},
					{
						"n": 7,
						"h": 200,
						"w": 444
					},
					{
						"n": 18,
						"h": 44,
						"w": 188
					},
					{
						"n": 17,
						"h": 158,
						"w": 238
					},
					{
						"n": 19,
						"h": 324,
						"w": 218
					},
					{
						"n": 20,
						"h": 133,
						"w": 179
					}
				],
				"ball": {
					"n": 0,
					"h": 232,
					"w": 287,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1439,
			"minute": 69,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 710
					},
					{
						"n": 2,
						"h": 394,
						"w": 543
					},
					{
						"n": 14,
						"h": 266,
						"w": 601
					},
					{
						"n": 13,
						"h": 176,
						"w": 584
					},
					{
						"n": 5,
						"h": 137,
						"w": 553
					},
					{
						"n": 6,
						"h": 415,
						"w": 479
					},
					{
						"n": 18,
						"h": 308,
						"w": 529
					},
					{
						"n": 15,
						"h": 158,
						"w": 472
					},
					{
						"n": 17,
						"h": 56,
						"w": 453
					},
					{
						"n": 20,
						"h": 284,
						"w": 356
					},
					{
						"n": 19,
						"h": 263,
						"w": 324
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 639
					},
					{
						"n": 13,
						"h": 407,
						"w": 302
					},
					{
						"n": 3,
						"h": 268,
						"w": 463
					},
					{
						"n": 14,
						"h": 176,
						"w": 454
					},
					{
						"n": 5,
						"h": 61,
						"w": 469
					},
					{
						"n": 6,
						"h": 187,
						"w": 416
					},
					{
						"n": 7,
						"h": 203,
						"w": 404
					},
					{
						"n": 18,
						"h": 18,
						"w": 197
					},
					{
						"n": 17,
						"h": 144,
						"w": 200
					},
					{
						"n": 19,
						"h": 321,
						"w": 178
					},
					{
						"n": 20,
						"h": 153,
						"w": 145
					}
				],
				"ball": {
					"n": 0,
					"h": 263,
					"w": 304,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1440,
			"minute": 69,
			"messages": [
				{
					"owner": 2,
					"mes": "Оливье Дюмон[26](Опава) делает передачу направо на Т.Прохазку[25](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 705
					},
					{
						"n": 2,
						"h": 362,
						"w": 540
					},
					{
						"n": 14,
						"h": 264,
						"w": 567
					},
					{
						"n": 13,
						"h": 177,
						"w": 572
					},
					{
						"n": 5,
						"h": 120,
						"w": 570
					},
					{
						"n": 6,
						"h": 399,
						"w": 467
					},
					{
						"n": 18,
						"h": 313,
						"w": 489
					},
					{
						"n": 15,
						"h": 195,
						"w": 456
					},
					{
						"n": 17,
						"h": 59,
						"w": 429
					},
					{
						"n": 20,
						"h": 256,
						"w": 375
					},
					{
						"n": 19,
						"h": 232,
						"w": 350
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 618
					},
					{
						"n": 13,
						"h": 391,
						"w": 326
					},
					{
						"n": 3,
						"h": 273,
						"w": 495
					},
					{
						"n": 14,
						"h": 176,
						"w": 491
					},
					{
						"n": 5,
						"h": 74,
						"w": 451
					},
					{
						"n": 6,
						"h": 177,
						"w": 415
					},
					{
						"n": 7,
						"h": 194,
						"w": 365
					},
					{
						"n": 18,
						"h": 58,
						"w": 200
					},
					{
						"n": 17,
						"h": 146,
						"w": 240
					},
					{
						"n": 19,
						"h": 286,
						"w": 170
					},
					{
						"n": 20,
						"h": 168,
						"w": 182
					}
				],
				"ball": {
					"n": 0,
					"h": 376,
					"w": 269,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1441,
			"minute": 69,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 709
					},
					{
						"n": 2,
						"h": 394,
						"w": 543
					},
					{
						"n": 14,
						"h": 290,
						"w": 596
					},
					{
						"n": 13,
						"h": 186,
						"w": 594
					},
					{
						"n": 5,
						"h": 120,
						"w": 604
					},
					{
						"n": 6,
						"h": 397,
						"w": 486
					},
					{
						"n": 18,
						"h": 307,
						"w": 528
					},
					{
						"n": 15,
						"h": 209,
						"w": 492
					},
					{
						"n": 17,
						"h": 56,
						"w": 467
					},
					{
						"n": 20,
						"h": 246,
						"w": 354
					},
					{
						"n": 19,
						"h": 203,
						"w": 376
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 596
					},
					{
						"n": 13,
						"h": 398,
						"w": 288
					},
					{
						"n": 3,
						"h": 276,
						"w": 460
					},
					{
						"n": 14,
						"h": 176,
						"w": 452
					},
					{
						"n": 5,
						"h": 78,
						"w": 417
					},
					{
						"n": 6,
						"h": 204,
						"w": 386
					},
					{
						"n": 7,
						"h": 196,
						"w": 326
					},
					{
						"n": 18,
						"h": 23,
						"w": 184
					},
					{
						"n": 17,
						"h": 124,
						"w": 208
					},
					{
						"n": 19,
						"h": 277,
						"w": 144
					},
					{
						"n": 20,
						"h": 137,
						"w": 158
					}
				],
				"ball": {
					"n": 0,
					"h": 372,
					"w": 303,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 1442,
			"minute": 69,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 702
					},
					{
						"n": 2,
						"h": 394,
						"w": 558
					},
					{
						"n": 14,
						"h": 299,
						"w": 610
					},
					{
						"n": 13,
						"h": 205,
						"w": 608
					},
					{
						"n": 5,
						"h": 158,
						"w": 594
					},
					{
						"n": 6,
						"h": 388,
						"w": 448
					},
					{
						"n": 18,
						"h": 337,
						"w": 549
					},
					{
						"n": 15,
						"h": 215,
						"w": 501
					},
					{
						"n": 17,
						"h": 56,
						"w": 506
					},
					{
						"n": 20,
						"h": 259,
						"w": 391
					},
					{
						"n": 19,
						"h": 183,
						"w": 409
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 599
					},
					{
						"n": 13,
						"h": 405,
						"w": 249
					},
					{
						"n": 3,
						"h": 280,
						"w": 452
					},
					{
						"n": 14,
						"h": 166,
						"w": 457
					},
					{
						"n": 5,
						"h": 74,
						"w": 382
					},
					{
						"n": 6,
						"h": 191,
						"w": 349
					},
					{
						"n": 7,
						"h": 200,
						"w": 287
					},
					{
						"n": 18,
						"h": 17,
						"w": 173
					},
					{
						"n": 17,
						"h": 114,
						"w": 174
					},
					{
						"n": 19,
						"h": 280,
						"w": 144
					},
					{
						"n": 20,
						"h": 120,
						"w": 144
					}
				],
				"ball": {
					"n": 0,
					"h": 376,
					"w": 338,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 1443,
			"minute": 69,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 701
					},
					{
						"n": 2,
						"h": 394,
						"w": 550
					},
					{
						"n": 14,
						"h": 280,
						"w": 607
					},
					{
						"n": 13,
						"h": 178,
						"w": 593
					},
					{
						"n": 5,
						"h": 120,
						"w": 605
					},
					{
						"n": 6,
						"h": 379,
						"w": 410
					},
					{
						"n": 18,
						"h": 339,
						"w": 544
					},
					{
						"n": 15,
						"h": 202,
						"w": 497
					},
					{
						"n": 17,
						"h": 56,
						"w": 544
					},
					{
						"n": 20,
						"h": 233,
						"w": 419
					},
					{
						"n": 19,
						"h": 166,
						"w": 426
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 586
					},
					{
						"n": 13,
						"h": 412,
						"w": 211
					},
					{
						"n": 3,
						"h": 270,
						"w": 414
					},
					{
						"n": 14,
						"h": 177,
						"w": 420
					},
					{
						"n": 5,
						"h": 69,
						"w": 348
					},
					{
						"n": 6,
						"h": 217,
						"w": 321
					},
					{
						"n": 7,
						"h": 205,
						"w": 249
					},
					{
						"n": 18,
						"h": 17,
						"w": 184
					},
					{
						"n": 17,
						"h": 112,
						"w": 174
					},
					{
						"n": 19,
						"h": 287,
						"w": 144
					},
					{
						"n": 20,
						"h": 111,
						"w": 144
					}
				],
				"ball": {
					"n": 0,
					"h": 381,
					"w": 372,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 1444,
			"minute": 69,
			"messages": [
				{
					"owner": 2,
					"mes": "Т.Прохазка[25](Опава) пасует Н.Томпсону[38](Опава)..."
				},
				{
					"owner": 2,
					"mes": "Киэн Колман[06](Галвэй Юнайтед) показывает хорошее позиционное чутье и перехватывает мяч!..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 235,
						"w": 709
					},
					{
						"n": 2,
						"h": 400,
						"w": 548
					},
					{
						"n": 14,
						"h": 290,
						"w": 607
					},
					{
						"n": 13,
						"h": 187,
						"w": 590
					},
					{
						"n": 5,
						"h": 120,
						"w": 602
					},
					{
						"n": 6,
						"h": 385,
						"w": 402
					},
					{
						"n": 18,
						"h": 335,
						"w": 551
					},
					{
						"n": 15,
						"h": 212,
						"w": 497
					},
					{
						"n": 17,
						"h": 56,
						"w": 554
					},
					{
						"n": 20,
						"h": 240,
						"w": 413
					},
					{
						"n": 19,
						"h": 167,
						"w": 416
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 596
					},
					{
						"n": 13,
						"h": 411,
						"w": 201
					},
					{
						"n": 3,
						"h": 273,
						"w": 424
					},
					{
						"n": 14,
						"h": 178,
						"w": 429
					},
					{
						"n": 5,
						"h": 69,
						"w": 348,
						"m": 680
					},
					{
						"n": 6,
						"h": 210,
						"w": 327
					},
					{
						"n": 7,
						"h": 201,
						"w": 239
					},
					{
						"n": 18,
						"h": 20,
						"w": 192
					},
					{
						"n": 17,
						"h": 112,
						"w": 184
					},
					{
						"n": 19,
						"h": 286,
						"w": 137
					},
					{
						"n": 20,
						"h": 121,
						"w": 141
					}
				],
				"ball": {
					"n": 0,
					"h": 385,
					"w": 402,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 10
		},
		{
			"num": 1445,
			"minute": 69,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 708
					},
					{
						"n": 2,
						"h": 388,
						"w": 519
					},
					{
						"n": 14,
						"h": 278,
						"w": 569
					},
					{
						"n": 13,
						"h": 171,
						"w": 559
					},
					{
						"n": 5,
						"h": 98,
						"w": 569
					},
					{
						"n": 6,
						"h": 416,
						"w": 384,
						"m": 890
					},
					{
						"n": 18,
						"h": 323,
						"w": 513
					},
					{
						"n": 15,
						"h": 209,
						"w": 457
					},
					{
						"n": 17,
						"h": 56,
						"w": 514
					},
					{
						"n": 20,
						"h": 252,
						"w": 374
					},
					{
						"n": 19,
						"h": 161,
						"w": 376
					}
				],
				"away": [
					{
						"n": 1,
						"h": 211,
						"w": 635
					},
					{
						"n": 13,
						"h": 409,
						"w": 241
					},
					{
						"n": 3,
						"h": 275,
						"w": 464
					},
					{
						"n": 14,
						"h": 195,
						"w": 466
					},
					{
						"n": 5,
						"h": 59,
						"w": 356
					},
					{
						"n": 6,
						"h": 203,
						"w": 367
					},
					{
						"n": 7,
						"h": 201,
						"w": 279
					},
					{
						"n": 18,
						"h": 22,
						"w": 232
					},
					{
						"n": 17,
						"h": 128,
						"w": 221
					},
					{
						"n": 19,
						"h": 280,
						"w": 177
					},
					{
						"n": 20,
						"h": 123,
						"w": 181
					}
				],
				"ball": {
					"n": 0,
					"h": 416,
					"w": 384,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1446,
			"minute": 70,
			"possession": 43,
			"messages": [
				{
					"owner": 1,
					"mes": "Справа просит мяч Том Дэвлин[20](Галвэй Юнайтед)... Пас ему..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 708
					},
					{
						"n": 2,
						"h": 384,
						"w": 478
					},
					{
						"n": 14,
						"h": 267,
						"w": 529
					},
					{
						"n": 13,
						"h": 173,
						"w": 532
					},
					{
						"n": 5,
						"h": 84,
						"w": 530
					},
					{
						"n": 6,
						"h": 415,
						"w": 374
					},
					{
						"n": 18,
						"h": 316,
						"w": 472
					},
					{
						"n": 15,
						"h": 194,
						"w": 419
					},
					{
						"n": 17,
						"h": 56,
						"w": 473
					},
					{
						"n": 20,
						"h": 293,
						"w": 377,
						"f": 89,
						"c": 1
					},
					{
						"n": 19,
						"h": 158,
						"w": 336
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 641
					},
					{
						"n": 13,
						"h": 412,
						"w": 282
					},
					{
						"n": 3,
						"h": 284,
						"w": 504
					},
					{
						"n": 14,
						"h": 205,
						"w": 505
					},
					{
						"n": 5,
						"h": 65,
						"w": 396
					},
					{
						"n": 6,
						"h": 163,
						"w": 361
					},
					{
						"n": 7,
						"h": 206,
						"w": 320,
						"f": 82
					},
					{
						"n": 18,
						"h": 28,
						"w": 273
					},
					{
						"n": 17,
						"h": 162,
						"w": 243,
						"m": 650
					},
					{
						"n": 19,
						"h": 277,
						"w": 208
					},
					{
						"n": 20,
						"h": 128,
						"w": 222
					}
				],
				"ball": {
					"n": 0,
					"h": 293,
					"w": 377,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 41
		},
		{
			"num": 1447,
			"minute": 70,
			"messages": [
				{
					"owner": 1,
					"mes": "Т.Дэвлин[20](Галвэй Юнайтед) отдает передачу Б.О`Горману[19](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 704
					},
					{
						"n": 2,
						"h": 386,
						"w": 481
					},
					{
						"n": 14,
						"h": 285,
						"w": 527
					},
					{
						"n": 13,
						"h": 186,
						"w": 527
					},
					{
						"n": 5,
						"h": 67,
						"w": 492
					},
					{
						"n": 6,
						"h": 410,
						"w": 333
					},
					{
						"n": 18,
						"h": 310,
						"w": 431
					},
					{
						"n": 15,
						"h": 194,
						"w": 377
					},
					{
						"n": 17,
						"h": 57,
						"w": 431
					},
					{
						"n": 20,
						"h": 294,
						"w": 367,
						"m": 610
					},
					{
						"n": 19,
						"h": 170,
						"w": 351
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 644
					},
					{
						"n": 13,
						"h": 415,
						"w": 324
					},
					{
						"n": 3,
						"h": 282,
						"w": 539
					},
					{
						"n": 14,
						"h": 215,
						"w": 526
					},
					{
						"n": 5,
						"h": 69,
						"w": 438
					},
					{
						"n": 6,
						"h": 181,
						"w": 399
					},
					{
						"n": 7,
						"h": 217,
						"w": 361
					},
					{
						"n": 18,
						"h": 33,
						"w": 315
					},
					{
						"n": 17,
						"h": 198,
						"w": 264
					},
					{
						"n": 19,
						"h": 283,
						"w": 250
					},
					{
						"n": 20,
						"h": 134,
						"w": 264
					}
				],
				"ball": {
					"n": 0,
					"h": 170,
					"w": 351,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 42
		},
		{
			"num": 1448,
			"minute": 70,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 701
					},
					{
						"n": 2,
						"h": 385,
						"w": 441
					},
					{
						"n": 14,
						"h": 278,
						"w": 506
					},
					{
						"n": 13,
						"h": 166,
						"w": 502
					},
					{
						"n": 5,
						"h": 60,
						"w": 452
					},
					{
						"n": 6,
						"h": 408,
						"w": 322
					},
					{
						"n": 18,
						"h": 312,
						"w": 391
					},
					{
						"n": 15,
						"h": 168,
						"w": 346
					},
					{
						"n": 17,
						"h": 47,
						"w": 392
					},
					{
						"n": 20,
						"h": 296,
						"w": 327
					},
					{
						"n": 19,
						"h": 171,
						"w": 316
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 643
					},
					{
						"n": 13,
						"h": 403,
						"w": 362
					},
					{
						"n": 3,
						"h": 276,
						"w": 558
					},
					{
						"n": 14,
						"h": 194,
						"w": 560
					},
					{
						"n": 5,
						"h": 72,
						"w": 478
					},
					{
						"n": 6,
						"h": 220,
						"w": 409
					},
					{
						"n": 7,
						"h": 245,
						"w": 389
					},
					{
						"n": 18,
						"h": 36,
						"w": 354
					},
					{
						"n": 17,
						"h": 231,
						"w": 288
					},
					{
						"n": 19,
						"h": 285,
						"w": 290
					},
					{
						"n": 20,
						"h": 136,
						"w": 303
					}
				],
				"ball": {
					"n": 0,
					"h": 171,
					"w": 316,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1449,
			"minute": 70,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 710
					},
					{
						"n": 2,
						"h": 378,
						"w": 435
					},
					{
						"n": 14,
						"h": 281,
						"w": 480
					},
					{
						"n": 13,
						"h": 167,
						"w": 466
					},
					{
						"n": 5,
						"h": 59,
						"w": 415
					},
					{
						"n": 6,
						"h": 414,
						"w": 291
					},
					{
						"n": 18,
						"h": 307,
						"w": 351
					},
					{
						"n": 15,
						"h": 144,
						"w": 314
					},
					{
						"n": 17,
						"h": 48,
						"w": 352
					},
					{
						"n": 20,
						"h": 300,
						"w": 287
					},
					{
						"n": 19,
						"h": 172,
						"w": 281
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 644
					},
					{
						"n": 13,
						"h": 402,
						"w": 402
					},
					{
						"n": 3,
						"h": 276,
						"w": 518
					},
					{
						"n": 14,
						"h": 203,
						"w": 599
					},
					{
						"n": 5,
						"h": 77,
						"w": 518
					},
					{
						"n": 6,
						"h": 252,
						"w": 423
					},
					{
						"n": 7,
						"h": 259,
						"w": 426
					},
					{
						"n": 18,
						"h": 39,
						"w": 394
					},
					{
						"n": 17,
						"h": 261,
						"w": 314
					},
					{
						"n": 19,
						"h": 282,
						"w": 330
					},
					{
						"n": 20,
						"h": 139,
						"w": 343
					}
				],
				"ball": {
					"n": 0,
					"h": 172,
					"w": 281,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1450,
			"minute": 70,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 702
					},
					{
						"n": 2,
						"h": 390,
						"w": 397
					},
					{
						"n": 14,
						"h": 272,
						"w": 441
					},
					{
						"n": 13,
						"h": 177,
						"w": 446
					},
					{
						"n": 5,
						"h": 78,
						"w": 380
					},
					{
						"n": 6,
						"h": 392,
						"w": 259
					},
					{
						"n": 18,
						"h": 310,
						"w": 311
					},
					{
						"n": 15,
						"h": 138,
						"w": 275
					},
					{
						"n": 17,
						"h": 43,
						"w": 313
					},
					{
						"n": 20,
						"h": 297,
						"w": 247
					},
					{
						"n": 19,
						"h": 174,
						"w": 246
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 642
					},
					{
						"n": 13,
						"h": 406,
						"w": 442
					},
					{
						"n": 3,
						"h": 273,
						"w": 494
					},
					{
						"n": 14,
						"h": 209,
						"w": 602
					},
					{
						"n": 5,
						"h": 79,
						"w": 558
					},
					{
						"n": 6,
						"h": 268,
						"w": 454
					},
					{
						"n": 7,
						"h": 264,
						"w": 466
					},
					{
						"n": 18,
						"h": 46,
						"w": 434
					},
					{
						"n": 17,
						"h": 290,
						"w": 341
					},
					{
						"n": 19,
						"h": 279,
						"w": 369
					},
					{
						"n": 20,
						"h": 139,
						"w": 383
					}
				],
				"ball": {
					"n": 0,
					"h": 174,
					"w": 246,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1451,
			"minute": 70,
			"messages": [
				{
					"owner": 1,
					"mes": "Байрон О`Горман[19](Галвэй Юнайтед) делает пас на К.Келли[15](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 702
					},
					{
						"n": 2,
						"h": 389,
						"w": 372
					},
					{
						"n": 14,
						"h": 283,
						"w": 425
					},
					{
						"n": 13,
						"h": 180,
						"w": 431
					},
					{
						"n": 5,
						"h": 76,
						"w": 377
					},
					{
						"n": 6,
						"h": 411,
						"w": 256
					},
					{
						"n": 18,
						"h": 294,
						"w": 321
					},
					{
						"n": 15,
						"h": 129,
						"w": 252
					},
					{
						"n": 17,
						"h": 47,
						"w": 288
					},
					{
						"n": 20,
						"h": 298,
						"w": 222
					},
					{
						"n": 19,
						"h": 171,
						"w": 236
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 649
					},
					{
						"n": 13,
						"h": 403,
						"w": 467
					},
					{
						"n": 3,
						"h": 274,
						"w": 519
					},
					{
						"n": 14,
						"h": 233,
						"w": 607
					},
					{
						"n": 5,
						"h": 93,
						"w": 578
					},
					{
						"n": 6,
						"h": 248,
						"w": 469
					},
					{
						"n": 7,
						"h": 287,
						"w": 475
					},
					{
						"n": 18,
						"h": 45,
						"w": 459
					},
					{
						"n": 17,
						"h": 309,
						"w": 358
					},
					{
						"n": 19,
						"h": 279,
						"w": 394
					},
					{
						"n": 20,
						"h": 150,
						"w": 406
					}
				],
				"ball": {
					"n": 0,
					"h": 129,
					"w": 252,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 25
		},
		{
			"num": 1452,
			"minute": 70,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 705
					},
					{
						"n": 2,
						"h": 372,
						"w": 381
					},
					{
						"n": 14,
						"h": 268,
						"w": 428
					},
					{
						"n": 13,
						"h": 183,
						"w": 418
					},
					{
						"n": 5,
						"h": 63,
						"w": 374
					},
					{
						"n": 6,
						"h": 389,
						"w": 223
					},
					{
						"n": 18,
						"h": 291,
						"w": 281
					},
					{
						"n": 15,
						"h": 144,
						"w": 215
					},
					{
						"n": 17,
						"h": 48,
						"w": 248
					},
					{
						"n": 20,
						"h": 296,
						"w": 182
					},
					{
						"n": 19,
						"h": 166,
						"w": 196
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 648
					},
					{
						"n": 13,
						"h": 402,
						"w": 506
					},
					{
						"n": 3,
						"h": 273,
						"w": 562
					},
					{
						"n": 14,
						"h": 200,
						"w": 621
					},
					{
						"n": 5,
						"h": 110,
						"w": 614
					},
					{
						"n": 6,
						"h": 267,
						"w": 513
					},
					{
						"n": 7,
						"h": 301,
						"w": 516
					},
					{
						"n": 18,
						"h": 54,
						"w": 498
					},
					{
						"n": 17,
						"h": 339,
						"w": 384
					},
					{
						"n": 19,
						"h": 279,
						"w": 424
					},
					{
						"n": 20,
						"h": 175,
						"w": 418
					}
				],
				"ball": {
					"n": 0,
					"h": 144,
					"w": 215,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1453,
			"minute": 70,
			"messages": [
				{
					"owner": 1,
					"mes": "Передача вперед..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 704
					},
					{
						"n": 2,
						"h": 379,
						"w": 372
					},
					{
						"n": 14,
						"h": 273,
						"w": 427
					},
					{
						"n": 13,
						"h": 190,
						"w": 425
					},
					{
						"n": 5,
						"h": 73,
						"w": 370
					},
					{
						"n": 6,
						"h": 390,
						"w": 185
					},
					{
						"n": 18,
						"h": 284,
						"w": 298
					},
					{
						"n": 15,
						"h": 144,
						"w": 203
					},
					{
						"n": 17,
						"h": 53,
						"w": 210
					},
					{
						"n": 20,
						"h": 298,
						"w": 144
					},
					{
						"n": 19,
						"h": 145,
						"w": 171
					}
				],
				"away": [
					{
						"n": 1,
						"h": 233,
						"w": 686
					},
					{
						"n": 13,
						"h": 397,
						"w": 544
					},
					{
						"n": 3,
						"h": 280,
						"w": 565
					},
					{
						"n": 14,
						"h": 202,
						"w": 622
					},
					{
						"n": 5,
						"h": 145,
						"w": 600
					},
					{
						"n": 6,
						"h": 295,
						"w": 539
					},
					{
						"n": 7,
						"h": 263,
						"w": 516
					},
					{
						"n": 18,
						"h": 57,
						"w": 536
					},
					{
						"n": 17,
						"h": 366,
						"w": 411
					},
					{
						"n": 19,
						"h": 282,
						"w": 409
					},
					{
						"n": 20,
						"h": 166,
						"w": 442
					}
				],
				"ball": {
					"n": 0,
					"h": 116,
					"w": 145,
					"z": 0,
					"r": 0,
					"p": 1,
					"x": 0
				}
			},
			"interval": 38
		},
		{
			"num": 1454,
			"minute": 70,
			"messages": [
				{
					"owner": 1,
					"mes": "Байрон О`Горман[19](Галвэй Юнайтед) с мячом..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 710
					},
					{
						"n": 2,
						"h": 388,
						"w": 359
					},
					{
						"n": 14,
						"h": 274,
						"w": 395
					},
					{
						"n": 13,
						"h": 169,
						"w": 412
					},
					{
						"n": 5,
						"h": 77,
						"w": 343
					},
					{
						"n": 6,
						"h": 388,
						"w": 139
					},
					{
						"n": 18,
						"h": 283,
						"w": 305
					},
					{
						"n": 15,
						"h": 149,
						"w": 158
					},
					{
						"n": 17,
						"h": 44,
						"w": 165
					},
					{
						"n": 20,
						"h": 279,
						"w": 102
					},
					{
						"n": 19,
						"h": 109,
						"w": 127
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 709
					},
					{
						"n": 13,
						"h": 405,
						"w": 589
					},
					{
						"n": 3,
						"h": 286,
						"w": 582
					},
					{
						"n": 14,
						"h": 248,
						"w": 627
					},
					{
						"n": 5,
						"h": 187,
						"w": 620
					},
					{
						"n": 6,
						"h": 331,
						"w": 581
					},
					{
						"n": 7,
						"h": 291,
						"w": 553
					},
					{
						"n": 18,
						"h": 60,
						"w": 582
					},
					{
						"n": 17,
						"h": 396,
						"w": 446
					},
					{
						"n": 19,
						"h": 291,
						"w": 413
					},
					{
						"n": 20,
						"h": 167,
						"w": 435
					}
				],
				"ball": {
					"n": 0,
					"h": 109,
					"w": 127,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 46
		},
		{
			"num": 1455,
			"minute": 70,
			"messages": [
				{
					"owner": 1,
					"mes": "Байрон О`Горман[19](Галвэй Юнайтед) на скорости врывается в штрафную..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 710
					},
					{
						"n": 2,
						"h": 373,
						"w": 342
					},
					{
						"n": 14,
						"h": 273,
						"w": 404
					},
					{
						"n": 13,
						"h": 186,
						"w": 383
					},
					{
						"n": 5,
						"h": 63,
						"w": 351
					},
					{
						"n": 6,
						"h": 398,
						"w": 101
					},
					{
						"n": 18,
						"h": 276,
						"w": 266
					},
					{
						"n": 15,
						"h": 176,
						"w": 137
					},
					{
						"n": 17,
						"h": 44,
						"w": 125
					},
					{
						"n": 20,
						"h": 288,
						"w": 71
					},
					{
						"n": 19,
						"h": 133,
						"w": 90
					}
				],
				"away": [
					{
						"n": 1,
						"h": 236,
						"w": 709
					},
					{
						"n": 13,
						"h": 406,
						"w": 629
					},
					{
						"n": 3,
						"h": 282,
						"w": 625
					},
					{
						"n": 14,
						"h": 214,
						"w": 655
					},
					{
						"n": 5,
						"h": 163,
						"w": 658
					},
					{
						"n": 6,
						"h": 318,
						"w": 628
					},
					{
						"n": 7,
						"h": 277,
						"w": 590
					},
					{
						"n": 18,
						"h": 54,
						"w": 568
					},
					{
						"n": 17,
						"h": 395,
						"w": 486
					},
					{
						"n": 19,
						"h": 284,
						"w": 410
					},
					{
						"n": 20,
						"h": 168,
						"w": 414
					}
				],
				"ball": {
					"n": 0,
					"h": 133,
					"w": 90,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1456,
			"minute": 70,
			"messages": [
				{
					"owner": 1,
					"mes": "Байрон О`Горман[19](Галвэй Юнайтед) решает пробить низом..."
				},
				{
					"owner": 1,
					"mes": "Крыштоф Ласак[21](Опава) прыгает вправо и берет мяч намертво!"
				}
			],
			"U": {
				"team": 1,
				"player": 19,
				"xg": "0.08"
			},
			"V": {
				"team": 1,
				"player": 19
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 710
					},
					{
						"n": 2,
						"h": 379,
						"w": 348
					},
					{
						"n": 14,
						"h": 265,
						"w": 400
					},
					{
						"n": 13,
						"h": 176,
						"w": 398
					},
					{
						"n": 5,
						"h": 62,
						"w": 340
					},
					{
						"n": 6,
						"h": 399,
						"w": 92
					},
					{
						"n": 18,
						"h": 280,
						"w": 243
					},
					{
						"n": 15,
						"h": 172,
						"w": 114
					},
					{
						"n": 17,
						"h": 41,
						"w": 102
					},
					{
						"n": 20,
						"h": 280,
						"w": 62
					},
					{
						"n": 19,
						"h": 133,
						"w": 90,
						"m": 660
					}
				],
				"away": [
					{
						"n": 1,
						"h": 236,
						"w": 709,
						"m": 620
					},
					{
						"n": 13,
						"h": 406,
						"w": 652
					},
					{
						"n": 3,
						"h": 275,
						"w": 648
					},
					{
						"n": 14,
						"h": 196,
						"w": 668
					},
					{
						"n": 5,
						"h": 141,
						"w": 667
					},
					{
						"n": 6,
						"h": 313,
						"w": 633
					},
					{
						"n": 7,
						"h": 284,
						"w": 604
					},
					{
						"n": 18,
						"h": 57,
						"w": 591
					},
					{
						"n": 17,
						"h": 404,
						"w": 507
					},
					{
						"n": 19,
						"h": 284,
						"w": 424
					},
					{
						"n": 20,
						"h": 169,
						"w": 437
					}
				],
				"ball": {
					"n": 0,
					"h": 214,
					"w": 11,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 6
				}
			},
			"interval": 23
		},
		{
			"num": 1457,
			"minute": 70,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 703
					},
					{
						"n": 2,
						"h": 387,
						"w": 357
					},
					{
						"n": 14,
						"h": 275,
						"w": 390
					},
					{
						"n": 13,
						"h": 180,
						"w": 402
					},
					{
						"n": 5,
						"h": 70,
						"w": 344
					},
					{
						"n": 6,
						"h": 390,
						"w": 83
					},
					{
						"n": 18,
						"h": 285,
						"w": 262
					},
					{
						"n": 15,
						"h": 177,
						"w": 103
					},
					{
						"n": 17,
						"h": 35,
						"w": 83
					},
					{
						"n": 20,
						"h": 276,
						"w": 53
					},
					{
						"n": 19,
						"h": 151,
						"w": 73
					}
				],
				"away": [
					{
						"n": 1,
						"h": 236,
						"w": 709
					},
					{
						"n": 13,
						"h": 399,
						"w": 671
					},
					{
						"n": 3,
						"h": 262,
						"w": 664
					},
					{
						"n": 14,
						"h": 187,
						"w": 673
					},
					{
						"n": 5,
						"h": 122,
						"w": 673
					},
					{
						"n": 6,
						"h": 301,
						"w": 654
					},
					{
						"n": 7,
						"h": 268,
						"w": 616
					},
					{
						"n": 18,
						"h": 62,
						"w": 610
					},
					{
						"n": 17,
						"h": 399,
						"w": 526
					},
					{
						"n": 19,
						"h": 283,
						"w": 425
					},
					{
						"n": 20,
						"h": 167,
						"w": 457
					}
				],
				"ball": {
					"n": 0,
					"h": 214,
					"w": 11,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 20
		},
		{
			"num": 1458,
			"minute": 70,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 680
					},
					{
						"n": 2,
						"h": 372,
						"w": 545
					},
					{
						"n": 14,
						"h": 277,
						"w": 570
					},
					{
						"n": 13,
						"h": 160,
						"w": 570
					},
					{
						"n": 5,
						"h": 77,
						"w": 542
					},
					{
						"n": 6,
						"h": 366,
						"w": 444
					},
					{
						"n": 18,
						"h": 273,
						"w": 470
					},
					{
						"n": 15,
						"h": 170,
						"w": 470
					},
					{
						"n": 17,
						"h": 70,
						"w": 449
					},
					{
						"n": 20,
						"h": 290,
						"w": 370
					},
					{
						"n": 19,
						"h": 165,
						"w": 370
					}
				],
				"away": [
					{
						"n": 1,
						"h": 229,
						"w": 693,
						"m": 630
					},
					{
						"n": 13,
						"h": 385,
						"w": 437
					},
					{
						"n": 3,
						"h": 284,
						"w": 545
					},
					{
						"n": 14,
						"h": 167,
						"w": 545
					},
					{
						"n": 5,
						"h": 63,
						"w": 545
					},
					{
						"n": 6,
						"h": 222,
						"w": 437
					},
					{
						"n": 7,
						"h": 218,
						"w": 328
					},
					{
						"n": 18,
						"h": 65,
						"w": 348
					},
					{
						"n": 17,
						"h": 393,
						"w": 298
					},
					{
						"n": 19,
						"h": 295,
						"w": 220
					},
					{
						"n": 20,
						"h": 163,
						"w": 220
					}
				],
				"ball": {
					"n": 0,
					"h": 221,
					"w": 27,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 100
		},
		{
			"num": 1459,
			"minute": 70,
			"messages": [
				{
					"owner": 2,
					"mes": "Крыштоф Ласак[21](Опава) далеко выбивает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 701
					},
					{
						"n": 2,
						"h": 370,
						"w": 562
					},
					{
						"n": 14,
						"h": 275,
						"w": 570
					},
					{
						"n": 13,
						"h": 173,
						"w": 562
					},
					{
						"n": 5,
						"h": 120,
						"w": 574
					},
					{
						"n": 6,
						"h": 359,
						"w": 488
					},
					{
						"n": 18,
						"h": 291,
						"w": 498
					},
					{
						"n": 15,
						"h": 152,
						"w": 476
					},
					{
						"n": 17,
						"h": 45,
						"w": 470
					},
					{
						"n": 20,
						"h": 291,
						"w": 360
					},
					{
						"n": 19,
						"h": 157,
						"w": 374
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 678
					},
					{
						"n": 13,
						"h": 396,
						"w": 327
					},
					{
						"n": 3,
						"h": 270,
						"w": 553
					},
					{
						"n": 14,
						"h": 174,
						"w": 539
					},
					{
						"n": 5,
						"h": 61,
						"w": 523
					},
					{
						"n": 6,
						"h": 175,
						"w": 441
					},
					{
						"n": 7,
						"h": 98,
						"w": 328
					},
					{
						"n": 18,
						"h": 88,
						"w": 245
					},
					{
						"n": 17,
						"h": 406,
						"w": 190
					},
					{
						"n": 19,
						"h": 290,
						"w": 180
					},
					{
						"n": 20,
						"h": 163,
						"w": 202
					}
				],
				"ball": {
					"n": 0,
					"h": 359,
					"w": 488,
					"z": 1,
					"r": 0,
					"p": 4,
					"x": 0
				}
			},
			"interval": 120
		},
		{
			"num": 1460,
			"minute": 70,
			"messages": [
				{
					"owner": 1,
					"mes": "Киэн Колман[06](Галвэй Юнайтед) скидывает мяч головой..."
				},
				{
					"owner": 1,
					"mes": "Райан Уотсон[18](Галвэй Юнайтед) технично принимает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 706
					},
					{
						"n": 2,
						"h": 364,
						"w": 541
					},
					{
						"n": 14,
						"h": 270,
						"w": 591
					},
					{
						"n": 13,
						"h": 172,
						"w": 584
					},
					{
						"n": 5,
						"h": 98,
						"w": 573
					},
					{
						"n": 6,
						"h": 359,
						"w": 488
					},
					{
						"n": 18,
						"h": 293,
						"w": 493
					},
					{
						"n": 15,
						"h": 155,
						"w": 498
					},
					{
						"n": 17,
						"h": 41,
						"w": 492
					},
					{
						"n": 20,
						"h": 305,
						"w": 377
					},
					{
						"n": 19,
						"h": 165,
						"w": 394
					}
				],
				"away": [
					{
						"n": 1,
						"h": 221,
						"w": 656
					},
					{
						"n": 13,
						"h": 414,
						"w": 325
					},
					{
						"n": 3,
						"h": 278,
						"w": 542
					},
					{
						"n": 14,
						"h": 179,
						"w": 539
					},
					{
						"n": 5,
						"h": 68,
						"w": 531
					},
					{
						"n": 6,
						"h": 175,
						"w": 441
					},
					{
						"n": 7,
						"h": 120,
						"w": 328
					},
					{
						"n": 18,
						"h": 88,
						"w": 245
					},
					{
						"n": 17,
						"h": 407,
						"w": 168
					},
					{
						"n": 19,
						"h": 293,
						"w": 158
					},
					{
						"n": 20,
						"h": 169,
						"w": 181
					}
				],
				"ball": {
					"n": 0,
					"h": 293,
					"w": 493,
					"z": 1,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 22
		},
		{
			"num": 1461,
			"minute": 70,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 703
					},
					{
						"n": 2,
						"h": 378,
						"w": 503
					},
					{
						"n": 14,
						"h": 276,
						"w": 552
					},
					{
						"n": 13,
						"h": 173,
						"w": 544
					},
					{
						"n": 5,
						"h": 91,
						"w": 534
					},
					{
						"n": 6,
						"h": 363,
						"w": 456
					},
					{
						"n": 18,
						"h": 275,
						"w": 463
					},
					{
						"n": 15,
						"h": 152,
						"w": 458
					},
					{
						"n": 17,
						"h": 42,
						"w": 452
					},
					{
						"n": 20,
						"h": 301,
						"w": 337
					},
					{
						"n": 19,
						"h": 159,
						"w": 355
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 647
					},
					{
						"n": 13,
						"h": 418,
						"w": 365
					},
					{
						"n": 3,
						"h": 239,
						"w": 534
					},
					{
						"n": 14,
						"h": 145,
						"w": 531
					},
					{
						"n": 5,
						"h": 104,
						"w": 548
					},
					{
						"n": 6,
						"h": 209,
						"w": 462
					},
					{
						"n": 7,
						"h": 152,
						"w": 352
					},
					{
						"n": 18,
						"h": 79,
						"w": 276
					},
					{
						"n": 17,
						"h": 408,
						"w": 208
					},
					{
						"n": 19,
						"h": 297,
						"w": 198
					},
					{
						"n": 20,
						"h": 171,
						"w": 221
					}
				],
				"ball": {
					"n": 0,
					"h": 275,
					"w": 463,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1462,
			"minute": 70,
			"messages": [
				{
					"owner": 1,
					"mes": "Райан Уотсон[18](Галвэй Юнайтед) пасует Т.Дэвлину[20](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 702
					},
					{
						"n": 2,
						"h": 379,
						"w": 458
					},
					{
						"n": 14,
						"h": 281,
						"w": 507
					},
					{
						"n": 13,
						"h": 168,
						"w": 499
					},
					{
						"n": 5,
						"h": 81,
						"w": 490
					},
					{
						"n": 6,
						"h": 374,
						"w": 412
					},
					{
						"n": 18,
						"h": 277,
						"w": 453,
						"m": 620
					},
					{
						"n": 15,
						"h": 151,
						"w": 413
					},
					{
						"n": 17,
						"h": 46,
						"w": 407
					},
					{
						"n": 20,
						"h": 260,
						"w": 327
					},
					{
						"n": 19,
						"h": 160,
						"w": 310
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 644
					},
					{
						"n": 13,
						"h": 415,
						"w": 410
					},
					{
						"n": 3,
						"h": 283,
						"w": 543
					},
					{
						"n": 14,
						"h": 189,
						"w": 542
					},
					{
						"n": 5,
						"h": 110,
						"w": 544
					},
					{
						"n": 6,
						"h": 192,
						"w": 420
					},
					{
						"n": 7,
						"h": 188,
						"w": 378
					},
					{
						"n": 18,
						"h": 67,
						"w": 319
					},
					{
						"n": 17,
						"h": 409,
						"w": 253
					},
					{
						"n": 19,
						"h": 298,
						"w": 243
					},
					{
						"n": 20,
						"h": 173,
						"w": 266
					}
				],
				"ball": {
					"n": 0,
					"h": 260,
					"w": 327,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 45
		},
		{
			"num": 1463,
			"minute": 71,
			"possession": 44,
			"messages": [
				{
					"owner": 1,
					"mes": "Том Дэвлин[20](Галвэй Юнайтед) играет направо..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 701
					},
					{
						"n": 2,
						"h": 388,
						"w": 436,
						"f": 80
					},
					{
						"n": 14,
						"h": 285,
						"w": 484,
						"f": 97
					},
					{
						"n": 13,
						"h": 174,
						"w": 497,
						"f": 96
					},
					{
						"n": 5,
						"h": 74,
						"w": 457,
						"f": 80
					},
					{
						"n": 6,
						"h": 382,
						"w": 380,
						"f": 79,
						"c": 3
					},
					{
						"n": 18,
						"h": 281,
						"w": 420,
						"f": 96
					},
					{
						"n": 15,
						"h": 149,
						"w": 380,
						"f": 96
					},
					{
						"n": 17,
						"h": 50,
						"w": 374,
						"f": 90
					},
					{
						"n": 20,
						"h": 262,
						"w": 317
					},
					{
						"n": 19,
						"h": 167,
						"w": 278,
						"f": 95
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 644
					},
					{
						"n": 13,
						"h": 400,
						"w": 382,
						"f": 91
					},
					{
						"n": 3,
						"h": 275,
						"w": 511,
						"f": 83
					},
					{
						"n": 14,
						"h": 221,
						"w": 550,
						"f": 89,
						"c": 1
					},
					{
						"n": 5,
						"h": 110,
						"w": 564
					},
					{
						"n": 6,
						"h": 192,
						"w": 420
					},
					{
						"n": 7,
						"h": 188,
						"w": 378
					},
					{
						"n": 18,
						"h": 61,
						"w": 352
					},
					{
						"n": 17,
						"h": 406,
						"w": 286,
						"f": 90
					},
					{
						"n": 19,
						"h": 299,
						"w": 276
					},
					{
						"n": 20,
						"h": 170,
						"w": 299
					}
				],
				"ball": {
					"n": 0,
					"h": 196,
					"w": 250,
					"z": 0,
					"r": 0,
					"p": 2,
					"x": 0
				}
			},
			"interval": 33
		},
		{
			"num": 1464,
			"minute": 71,
			"messages": [
				{
					"owner": 2,
					"mes": "Нир Мансур[23](Опава) устремляется к свободному мячу и подхватывает его..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 707
					},
					{
						"n": 2,
						"h": 391,
						"w": 423
					},
					{
						"n": 14,
						"h": 285,
						"w": 467
					},
					{
						"n": 13,
						"h": 179,
						"w": 480
					},
					{
						"n": 5,
						"h": 66,
						"w": 443
					},
					{
						"n": 6,
						"h": 387,
						"w": 364
					},
					{
						"n": 18,
						"h": 284,
						"w": 403
					},
					{
						"n": 15,
						"h": 147,
						"w": 363
					},
					{
						"n": 17,
						"h": 53,
						"w": 357
					},
					{
						"n": 20,
						"h": 266,
						"w": 301,
						"m": 600
					},
					{
						"n": 19,
						"h": 170,
						"w": 261,
						"m": 650
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 646
					},
					{
						"n": 13,
						"h": 397,
						"w": 399
					},
					{
						"n": 3,
						"h": 273,
						"w": 494,
						"m": 670
					},
					{
						"n": 14,
						"h": 231,
						"w": 563
					},
					{
						"n": 5,
						"h": 110,
						"w": 577
					},
					{
						"n": 6,
						"h": 197,
						"w": 436
					},
					{
						"n": 7,
						"h": 197,
						"w": 393
					},
					{
						"n": 18,
						"h": 62,
						"w": 369
					},
					{
						"n": 17,
						"h": 406,
						"w": 286
					},
					{
						"n": 19,
						"h": 299,
						"w": 293
					},
					{
						"n": 20,
						"h": 169,
						"w": 316
					}
				],
				"ball": {
					"n": 0,
					"h": 177,
					"w": 226,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 17
		},
		{
			"num": 1465,
			"minute": 71,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 705
					},
					{
						"n": 2,
						"h": 373,
						"w": 459
					},
					{
						"n": 14,
						"h": 282,
						"w": 474
					},
					{
						"n": 13,
						"h": 178,
						"w": 496
					},
					{
						"n": 5,
						"h": 56,
						"w": 475
					},
					{
						"n": 6,
						"h": 392,
						"w": 404
					},
					{
						"n": 18,
						"h": 245,
						"w": 393
					},
					{
						"n": 15,
						"h": 182,
						"w": 372
					},
					{
						"n": 17,
						"h": 38,
						"w": 371
					},
					{
						"n": 20,
						"h": 306,
						"w": 301
					},
					{
						"n": 19,
						"h": 208,
						"w": 248
					}
				],
				"away": [
					{
						"n": 1,
						"h": 229,
						"w": 685
					},
					{
						"n": 13,
						"h": 410,
						"w": 383
					},
					{
						"n": 3,
						"h": 238,
						"w": 494
					},
					{
						"n": 14,
						"h": 212,
						"w": 568
					},
					{
						"n": 5,
						"h": 70,
						"w": 578
					},
					{
						"n": 6,
						"h": 187,
						"w": 454
					},
					{
						"n": 7,
						"h": 221,
						"w": 361
					},
					{
						"n": 18,
						"h": 56,
						"w": 329
					},
					{
						"n": 17,
						"h": 414,
						"w": 260
					},
					{
						"n": 19,
						"h": 302,
						"w": 277
					},
					{
						"n": 20,
						"h": 155,
						"w": 278
					}
				],
				"ball": {
					"n": 0,
					"h": 212,
					"w": 226,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1466,
			"minute": 71,
			"messages": [
				{
					"owner": 2,
					"mes": "Справа открывается Оливье Дюмон[26](Опава)... Передача..."
				},
				{
					"owner": 2,
					"mes": "Оливье Дюмон[26](Опава) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 702
					},
					{
						"n": 2,
						"h": 358,
						"w": 480
					},
					{
						"n": 14,
						"h": 277,
						"w": 500
					},
					{
						"n": 13,
						"h": 174,
						"w": 512
					},
					{
						"n": 5,
						"h": 62,
						"w": 496
					},
					{
						"n": 6,
						"h": 393,
						"w": 430
					},
					{
						"n": 18,
						"h": 254,
						"w": 417
					},
					{
						"n": 15,
						"h": 192,
						"w": 397
					},
					{
						"n": 17,
						"h": 35,
						"w": 397
					},
					{
						"n": 20,
						"h": 284,
						"w": 288
					},
					{
						"n": 19,
						"h": 234,
						"w": 252
					}
				],
				"away": [
					{
						"n": 1,
						"h": 226,
						"w": 664
					},
					{
						"n": 13,
						"h": 405,
						"w": 390
					},
					{
						"n": 3,
						"h": 244,
						"w": 501
					},
					{
						"n": 14,
						"h": 201,
						"w": 561
					},
					{
						"n": 5,
						"h": 69,
						"w": 552
					},
					{
						"n": 6,
						"h": 193,
						"w": 467
					},
					{
						"n": 7,
						"h": 231,
						"w": 337
					},
					{
						"n": 18,
						"h": 49,
						"w": 304
					},
					{
						"n": 17,
						"h": 418,
						"w": 244
					},
					{
						"n": 19,
						"h": 295,
						"w": 252
					},
					{
						"n": 20,
						"h": 163,
						"w": 254
					}
				],
				"ball": {
					"n": 0,
					"h": 257,
					"w": 253,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 26
		},
		{
			"num": 1467,
			"minute": 71,
			"messages": [
				{
					"owner": 2,
					"mes": "Оливье Дюмон[26](Опава) пасует Т.Прохазке[25](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 701
					},
					{
						"n": 2,
						"h": 330,
						"w": 471
					},
					{
						"n": 14,
						"h": 276,
						"w": 468
					},
					{
						"n": 13,
						"h": 184,
						"w": 471
					},
					{
						"n": 5,
						"h": 102,
						"w": 480
					},
					{
						"n": 6,
						"h": 389,
						"w": 449
					},
					{
						"n": 18,
						"h": 262,
						"w": 375
					},
					{
						"n": 15,
						"h": 216,
						"w": 362
					},
					{
						"n": 17,
						"h": 51,
						"w": 437
					},
					{
						"n": 20,
						"h": 258,
						"w": 283
					},
					{
						"n": 19,
						"h": 199,
						"w": 278
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 703
					},
					{
						"n": 13,
						"h": 411,
						"w": 433
					},
					{
						"n": 3,
						"h": 261,
						"w": 541
					},
					{
						"n": 14,
						"h": 184,
						"w": 575
					},
					{
						"n": 5,
						"h": 85,
						"w": 536
					},
					{
						"n": 6,
						"h": 192,
						"w": 457
					},
					{
						"n": 7,
						"h": 193,
						"w": 357
					},
					{
						"n": 18,
						"h": 46,
						"w": 300
					},
					{
						"n": 17,
						"h": 408,
						"w": 285
					},
					{
						"n": 19,
						"h": 278,
						"w": 273
					},
					{
						"n": 20,
						"h": 161,
						"w": 276
					}
				],
				"ball": {
					"n": 0,
					"h": 365,
					"w": 184,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 43
		},
		{
			"num": 1468,
			"minute": 71,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 705
					},
					{
						"n": 2,
						"h": 330,
						"w": 471
					},
					{
						"n": 14,
						"h": 272,
						"w": 463
					},
					{
						"n": 13,
						"h": 169,
						"w": 470
					},
					{
						"n": 5,
						"h": 120,
						"w": 468
					},
					{
						"n": 6,
						"h": 379,
						"w": 451
					},
					{
						"n": 18,
						"h": 274,
						"w": 385
					},
					{
						"n": 15,
						"h": 229,
						"w": 353
					},
					{
						"n": 17,
						"h": 59,
						"w": 451
					},
					{
						"n": 20,
						"h": 235,
						"w": 260
					},
					{
						"n": 19,
						"h": 165,
						"w": 299
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 706
					},
					{
						"n": 13,
						"h": 395,
						"w": 443
					},
					{
						"n": 3,
						"h": 272,
						"w": 579
					},
					{
						"n": 14,
						"h": 179,
						"w": 603
					},
					{
						"n": 5,
						"h": 74,
						"w": 502
					},
					{
						"n": 6,
						"h": 215,
						"w": 480
					},
					{
						"n": 7,
						"h": 215,
						"w": 390
					},
					{
						"n": 18,
						"h": 56,
						"w": 300
					},
					{
						"n": 17,
						"h": 406,
						"w": 300
					},
					{
						"n": 19,
						"h": 298,
						"w": 271
					},
					{
						"n": 20,
						"h": 159,
						"w": 274
					}
				],
				"ball": {
					"n": 0,
					"h": 376,
					"w": 218,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1469,
			"minute": 71,
			"messages": [
				{
					"owner": 2,
					"mes": "Томаш Прохазка[25](Опава) пасует налево на В.Сланину[34](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 704
					},
					{
						"n": 2,
						"h": 330,
						"w": 463
					},
					{
						"n": 14,
						"h": 273,
						"w": 472
					},
					{
						"n": 13,
						"h": 185,
						"w": 465
					},
					{
						"n": 5,
						"h": 120,
						"w": 471
					},
					{
						"n": 6,
						"h": 394,
						"w": 435
					},
					{
						"n": 18,
						"h": 264,
						"w": 380
					},
					{
						"n": 15,
						"h": 230,
						"w": 367
					},
					{
						"n": 17,
						"h": 56,
						"w": 435
					},
					{
						"n": 20,
						"h": 272,
						"w": 272
					},
					{
						"n": 19,
						"h": 169,
						"w": 305
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 706
					},
					{
						"n": 13,
						"h": 420,
						"w": 442
					},
					{
						"n": 3,
						"h": 277,
						"w": 597
					},
					{
						"n": 14,
						"h": 166,
						"w": 575
					},
					{
						"n": 5,
						"h": 74,
						"w": 512
					},
					{
						"n": 6,
						"h": 220,
						"w": 516
					},
					{
						"n": 7,
						"h": 226,
						"w": 393
					},
					{
						"n": 18,
						"h": 36,
						"w": 300
					},
					{
						"n": 17,
						"h": 415,
						"w": 300
					},
					{
						"n": 19,
						"h": 281,
						"w": 275
					},
					{
						"n": 20,
						"h": 162,
						"w": 271
					}
				],
				"ball": {
					"n": 0,
					"h": 284,
					"w": 145,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 1470,
			"minute": 71,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 704
					},
					{
						"n": 2,
						"h": 330,
						"w": 469
					},
					{
						"n": 14,
						"h": 267,
						"w": 450
					},
					{
						"n": 13,
						"h": 176,
						"w": 444
					},
					{
						"n": 5,
						"h": 120,
						"w": 467
					},
					{
						"n": 6,
						"h": 394,
						"w": 435
					},
					{
						"n": 18,
						"h": 255,
						"w": 385
					},
					{
						"n": 15,
						"h": 212,
						"w": 377
					},
					{
						"n": 17,
						"h": 58,
						"w": 445
					},
					{
						"n": 20,
						"h": 281,
						"w": 290
					},
					{
						"n": 19,
						"h": 135,
						"w": 283
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 687
					},
					{
						"n": 13,
						"h": 418,
						"w": 452
					},
					{
						"n": 3,
						"h": 269,
						"w": 549
					},
					{
						"n": 14,
						"h": 155,
						"w": 541
					},
					{
						"n": 5,
						"h": 59,
						"w": 543
					},
					{
						"n": 6,
						"h": 232,
						"w": 477
					},
					{
						"n": 7,
						"h": 239,
						"w": 356
					},
					{
						"n": 18,
						"h": 41,
						"w": 300
					},
					{
						"n": 17,
						"h": 407,
						"w": 300
					},
					{
						"n": 19,
						"h": 293,
						"w": 291
					},
					{
						"n": 20,
						"h": 164,
						"w": 288
					}
				],
				"ball": {
					"n": 0,
					"h": 295,
					"w": 179,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1471,
			"minute": 71,
			"messages": [
				{
					"owner": 2,
					"mes": "Вацлав Сланина[34](Опава) посылает мяч направо в направлении Т.Прохазки[25](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 710
					},
					{
						"n": 2,
						"h": 330,
						"w": 464
					},
					{
						"n": 14,
						"h": 272,
						"w": 467
					},
					{
						"n": 13,
						"h": 185,
						"w": 466
					},
					{
						"n": 5,
						"h": 120,
						"w": 455
					},
					{
						"n": 6,
						"h": 394,
						"w": 435
					},
					{
						"n": 18,
						"h": 280,
						"w": 368
					},
					{
						"n": 15,
						"h": 227,
						"w": 356
					},
					{
						"n": 17,
						"h": 56,
						"w": 435
					},
					{
						"n": 20,
						"h": 310,
						"w": 281
					},
					{
						"n": 19,
						"h": 156,
						"w": 301
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 707
					},
					{
						"n": 13,
						"h": 397,
						"w": 457
					},
					{
						"n": 3,
						"h": 270,
						"w": 579
					},
					{
						"n": 14,
						"h": 157,
						"w": 551
					},
					{
						"n": 5,
						"h": 61,
						"w": 513
					},
					{
						"n": 6,
						"h": 202,
						"w": 477
					},
					{
						"n": 7,
						"h": 216,
						"w": 375
					},
					{
						"n": 18,
						"h": 41,
						"w": 300
					},
					{
						"n": 17,
						"h": 415,
						"w": 300
					},
					{
						"n": 19,
						"h": 277,
						"w": 278
					},
					{
						"n": 20,
						"h": 160,
						"w": 293
					}
				],
				"ball": {
					"n": 0,
					"h": 365,
					"w": 236,
					"z": 0,
					"r": 0,
					"p": 2,
					"x": 0
				}
			},
			"interval": 30
		},
		{
			"num": 1472,
			"minute": 71,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 710
					},
					{
						"n": 2,
						"h": 330,
						"w": 482
					},
					{
						"n": 14,
						"h": 269,
						"w": 478
					},
					{
						"n": 13,
						"h": 185,
						"w": 484
					},
					{
						"n": 5,
						"h": 120,
						"w": 473
					},
					{
						"n": 6,
						"h": 391,
						"w": 453
					},
					{
						"n": 18,
						"h": 278,
						"w": 386
					},
					{
						"n": 15,
						"h": 215,
						"w": 369
					},
					{
						"n": 17,
						"h": 59,
						"w": 453
					},
					{
						"n": 20,
						"h": 327,
						"w": 275
					},
					{
						"n": 19,
						"h": 162,
						"w": 318
					}
				],
				"away": [
					{
						"n": 1,
						"h": 215,
						"w": 702
					},
					{
						"n": 13,
						"h": 396,
						"w": 439
					},
					{
						"n": 3,
						"h": 284,
						"w": 577
					},
					{
						"n": 14,
						"h": 160,
						"w": 564
					},
					{
						"n": 5,
						"h": 62,
						"w": 496
					},
					{
						"n": 6,
						"h": 190,
						"w": 491
					},
					{
						"n": 7,
						"h": 198,
						"w": 376
					},
					{
						"n": 18,
						"h": 47,
						"w": 283
					},
					{
						"n": 17,
						"h": 404,
						"w": 286
					},
					{
						"n": 19,
						"h": 282,
						"w": 274
					},
					{
						"n": 20,
						"h": 170,
						"w": 278
					}
				],
				"ball": {
					"n": 0,
					"h": 386,
					"w": 253,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 18
		},
		{
			"num": 1473,
			"minute": 71,
			"messages": [
				{
					"owner": 2,
					"mes": "Томаш Прохазка[25](Опава) сбрасывает мяч себе на ход..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 705
					},
					{
						"n": 2,
						"h": 330,
						"w": 492
					},
					{
						"n": 14,
						"h": 277,
						"w": 489
					},
					{
						"n": 13,
						"h": 178,
						"w": 497
					},
					{
						"n": 5,
						"h": 120,
						"w": 498
					},
					{
						"n": 6,
						"h": 394,
						"w": 468
					},
					{
						"n": 18,
						"h": 279,
						"w": 402
					},
					{
						"n": 15,
						"h": 231,
						"w": 393
					},
					{
						"n": 17,
						"h": 74,
						"w": 478
					},
					{
						"n": 20,
						"h": 354,
						"w": 266
					},
					{
						"n": 19,
						"h": 163,
						"w": 339
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 703
					},
					{
						"n": 13,
						"h": 398,
						"w": 410
					},
					{
						"n": 3,
						"h": 270,
						"w": 574
					},
					{
						"n": 14,
						"h": 162,
						"w": 576
					},
					{
						"n": 5,
						"h": 64,
						"w": 467
					},
					{
						"n": 6,
						"h": 204,
						"w": 477
					},
					{
						"n": 7,
						"h": 210,
						"w": 351
					},
					{
						"n": 18,
						"h": 39,
						"w": 267
					},
					{
						"n": 17,
						"h": 391,
						"w": 267
					},
					{
						"n": 19,
						"h": 282,
						"w": 263
					},
					{
						"n": 20,
						"h": 157,
						"w": 253
					}
				],
				"ball": {
					"n": 0,
					"h": 386,
					"w": 253,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 29
		},
		{
			"num": 1474,
			"minute": 71,
			"messages": [
				{
					"owner": 2,
					"mes": "Томаш Прохазка[25](Опава) делает передачу налево на О.Дюмона[26](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 708
					},
					{
						"n": 2,
						"h": 330,
						"w": 506
					},
					{
						"n": 14,
						"h": 263,
						"w": 512
					},
					{
						"n": 13,
						"h": 165,
						"w": 518
					},
					{
						"n": 5,
						"h": 120,
						"w": 508
					},
					{
						"n": 6,
						"h": 394,
						"w": 421
					},
					{
						"n": 18,
						"h": 268,
						"w": 436
					},
					{
						"n": 15,
						"h": 185,
						"w": 396
					},
					{
						"n": 17,
						"h": 58,
						"w": 433
					},
					{
						"n": 20,
						"h": 332,
						"w": 307
					},
					{
						"n": 19,
						"h": 159,
						"w": 354
					}
				],
				"away": [
					{
						"n": 1,
						"h": 226,
						"w": 682
					},
					{
						"n": 13,
						"h": 399,
						"w": 457
					},
					{
						"n": 3,
						"h": 290,
						"w": 532
					},
					{
						"n": 14,
						"h": 157,
						"w": 529
					},
					{
						"n": 5,
						"h": 62,
						"w": 477,
						"m": 690
					},
					{
						"n": 6,
						"h": 204,
						"w": 477
					},
					{
						"n": 7,
						"h": 231,
						"w": 393
					},
					{
						"n": 18,
						"h": 38,
						"w": 314
					},
					{
						"n": 17,
						"h": 413,
						"w": 308
					},
					{
						"n": 19,
						"h": 300,
						"w": 228
					},
					{
						"n": 20,
						"h": 167,
						"w": 228
					}
				],
				"ball": {
					"n": 0,
					"h": 246,
					"w": 243,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 47
		},
		{
			"num": 1475,
			"minute": 71,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 704
					},
					{
						"n": 2,
						"h": 330,
						"w": 545
					},
					{
						"n": 14,
						"h": 273,
						"w": 544
					},
					{
						"n": 13,
						"h": 172,
						"w": 527
					},
					{
						"n": 5,
						"h": 120,
						"w": 541
					},
					{
						"n": 6,
						"h": 394,
						"w": 402
					},
					{
						"n": 18,
						"h": 262,
						"w": 451
					},
					{
						"n": 15,
						"h": 182,
						"w": 436
					},
					{
						"n": 17,
						"h": 56,
						"w": 440
					},
					{
						"n": 20,
						"h": 292,
						"w": 300
					},
					{
						"n": 19,
						"h": 169,
						"w": 379
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 666
					},
					{
						"n": 13,
						"h": 416,
						"w": 446
					},
					{
						"n": 3,
						"h": 299,
						"w": 522
					},
					{
						"n": 14,
						"h": 157,
						"w": 522
					},
					{
						"n": 5,
						"h": 48,
						"w": 514
					},
					{
						"n": 6,
						"h": 188,
						"w": 445
					},
					{
						"n": 7,
						"h": 217,
						"w": 371
					},
					{
						"n": 18,
						"h": 44,
						"w": 353
					},
					{
						"n": 17,
						"h": 414,
						"w": 295
					},
					{
						"n": 19,
						"h": 288,
						"w": 220
					},
					{
						"n": 20,
						"h": 167,
						"w": 220
					}
				],
				"ball": {
					"n": 0,
					"h": 262,
					"w": 275,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1476,
			"minute": 71,
			"messages": [
				{
					"owner": 2,
					"mes": "О.Дюмон[26](Опава) отдает передачу В.Сланине[34](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 702
					},
					{
						"n": 2,
						"h": 330,
						"w": 509
					},
					{
						"n": 14,
						"h": 272,
						"w": 508
					},
					{
						"n": 13,
						"h": 171,
						"w": 497
					},
					{
						"n": 5,
						"h": 120,
						"w": 505
					},
					{
						"n": 6,
						"h": 394,
						"w": 366
					},
					{
						"n": 18,
						"h": 282,
						"w": 421
					},
					{
						"n": 15,
						"h": 167,
						"w": 403
					},
					{
						"n": 17,
						"h": 56,
						"w": 425
					},
					{
						"n": 20,
						"h": 312,
						"w": 301
					},
					{
						"n": 19,
						"h": 160,
						"w": 344
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 646
					},
					{
						"n": 13,
						"h": 415,
						"w": 452
					},
					{
						"n": 3,
						"h": 286,
						"w": 512
					},
					{
						"n": 14,
						"h": 163,
						"w": 513
					},
					{
						"n": 5,
						"h": 46,
						"w": 512
					},
					{
						"n": 6,
						"h": 198,
						"w": 447
					},
					{
						"n": 7,
						"h": 217,
						"w": 393
					},
					{
						"n": 18,
						"h": 40,
						"w": 389
					},
					{
						"n": 17,
						"h": 403,
						"w": 330
					},
					{
						"n": 19,
						"h": 293,
						"w": 256
					},
					{
						"n": 20,
						"h": 166,
						"w": 256
					}
				],
				"ball": {
					"n": 0,
					"h": 287,
					"w": 207,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 36
		},
		{
			"num": 1477,
			"minute": 71,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 705
					},
					{
						"n": 2,
						"h": 330,
						"w": 522
					},
					{
						"n": 14,
						"h": 280,
						"w": 524
					},
					{
						"n": 13,
						"h": 174,
						"w": 537
					},
					{
						"n": 5,
						"h": 120,
						"w": 521
					},
					{
						"n": 6,
						"h": 394,
						"w": 374
					},
					{
						"n": 18,
						"h": 258,
						"w": 434
					},
					{
						"n": 15,
						"h": 176,
						"w": 422
					},
					{
						"n": 17,
						"h": 56,
						"w": 445
					},
					{
						"n": 20,
						"h": 297,
						"w": 264
					},
					{
						"n": 19,
						"h": 164,
						"w": 377
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 627
					},
					{
						"n": 13,
						"h": 399,
						"w": 431
					},
					{
						"n": 3,
						"h": 292,
						"w": 502
					},
					{
						"n": 14,
						"h": 154,
						"w": 479
					},
					{
						"n": 5,
						"h": 49,
						"w": 502
					},
					{
						"n": 6,
						"h": 220,
						"w": 431
					},
					{
						"n": 7,
						"h": 223,
						"w": 361
					},
					{
						"n": 18,
						"h": 41,
						"w": 361
					},
					{
						"n": 17,
						"h": 409,
						"w": 290
					},
					{
						"n": 19,
						"h": 302,
						"w": 220
					},
					{
						"n": 20,
						"h": 157,
						"w": 220
					}
				],
				"ball": {
					"n": 0,
					"h": 296,
					"w": 241,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1478,
			"minute": 71,
			"messages": [
				{
					"owner": 2,
					"mes": "Вацлав Сланина[34](Опава) делает пас на 50 метров на М.Томасова[37](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 707
					},
					{
						"n": 2,
						"h": 330,
						"w": 549
					},
					{
						"n": 14,
						"h": 247,
						"w": 558
					},
					{
						"n": 13,
						"h": 154,
						"w": 571
					},
					{
						"n": 5,
						"h": 96,
						"w": 551
					},
					{
						"n": 6,
						"h": 394,
						"w": 470
					},
					{
						"n": 18,
						"h": 245,
						"w": 462
					},
					{
						"n": 15,
						"h": 186,
						"w": 462
					},
					{
						"n": 17,
						"h": 21,
						"w": 511
					},
					{
						"n": 20,
						"h": 282,
						"w": 359
					},
					{
						"n": 19,
						"h": 178,
						"w": 330
					}
				],
				"away": [
					{
						"n": 1,
						"h": 226,
						"w": 609
					},
					{
						"n": 13,
						"h": 394,
						"w": 335
					},
					{
						"n": 3,
						"h": 276,
						"w": 514
					},
					{
						"n": 14,
						"h": 171,
						"w": 505
					},
					{
						"n": 5,
						"h": 71,
						"w": 494
					},
					{
						"n": 6,
						"h": 272,
						"w": 410
					},
					{
						"n": 7,
						"h": 260,
						"w": 288
					},
					{
						"n": 18,
						"h": 48,
						"w": 265
					},
					{
						"n": 17,
						"h": 429,
						"w": 211
					},
					{
						"n": 19,
						"h": 302,
						"w": 183
					},
					{
						"n": 20,
						"h": 176,
						"w": 183
					}
				],
				"ball": {
					"n": 0,
					"h": 21,
					"w": 509,
					"z": 1,
					"r": 2,
					"p": 0,
					"x": 0
				}
			},
			"interval": 96
		},
		{
			"num": 1479,
			"minute": 71,
			"messages": [
				{
					"owner": 2,
					"mes": "Марин Томасов[37](Опава) закрывает мяч от соперника..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 708
					},
					{
						"n": 2,
						"h": 330,
						"w": 559
					},
					{
						"n": 14,
						"h": 251,
						"w": 568
					},
					{
						"n": 13,
						"h": 159,
						"w": 580
					},
					{
						"n": 5,
						"h": 95,
						"w": 561
					},
					{
						"n": 6,
						"h": 394,
						"w": 480
					},
					{
						"n": 18,
						"h": 244,
						"w": 472
					},
					{
						"n": 15,
						"h": 189,
						"w": 472
					},
					{
						"n": 17,
						"h": 21,
						"w": 514
					},
					{
						"n": 20,
						"h": 280,
						"w": 369
					},
					{
						"n": 19,
						"h": 181,
						"w": 339
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 599
					},
					{
						"n": 13,
						"h": 404,
						"w": 334
					},
					{
						"n": 3,
						"h": 275,
						"w": 504
					},
					{
						"n": 14,
						"h": 173,
						"w": 495
					},
					{
						"n": 5,
						"h": 70,
						"w": 484
					},
					{
						"n": 6,
						"h": 269,
						"w": 401
					},
					{
						"n": 7,
						"h": 257,
						"w": 279
					},
					{
						"n": 18,
						"h": 48,
						"w": 255
					},
					{
						"n": 17,
						"h": 422,
						"w": 219
					},
					{
						"n": 19,
						"h": 300,
						"w": 173
					},
					{
						"n": 20,
						"h": 173,
						"w": 173
					}
				],
				"ball": {
					"n": 0,
					"h": 28,
					"w": 501,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 10
		},
		{
			"num": 1480,
			"minute": 71,
			"messages": [
				{
					"owner": 2,
					"mes": "Не найдя свободных партнеров, Марин Томасов[37](Опава) отдает пас назад..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 701
					},
					{
						"n": 2,
						"h": 330,
						"w": 596
					},
					{
						"n": 14,
						"h": 270,
						"w": 600
					},
					{
						"n": 13,
						"h": 168,
						"w": 603
					},
					{
						"n": 5,
						"h": 91,
						"w": 588
					},
					{
						"n": 6,
						"h": 394,
						"w": 518
					},
					{
						"n": 18,
						"h": 217,
						"w": 499
					},
					{
						"n": 15,
						"h": 162,
						"w": 491
					},
					{
						"n": 17,
						"h": 49,
						"w": 540
					},
					{
						"n": 20,
						"h": 291,
						"w": 405
					},
					{
						"n": 19,
						"h": 147,
						"w": 355
					}
				],
				"away": [
					{
						"n": 1,
						"h": 229,
						"w": 598
					},
					{
						"n": 13,
						"h": 367,
						"w": 343
					},
					{
						"n": 3,
						"h": 276,
						"w": 466
					},
					{
						"n": 14,
						"h": 178,
						"w": 468
					},
					{
						"n": 5,
						"h": 76,
						"w": 463
					},
					{
						"n": 6,
						"h": 249,
						"w": 369
					},
					{
						"n": 7,
						"h": 239,
						"w": 263
					},
					{
						"n": 18,
						"h": 47,
						"w": 217
					},
					{
						"n": 17,
						"h": 421,
						"w": 209
					},
					{
						"n": 19,
						"h": 297,
						"w": 139
					},
					{
						"n": 20,
						"h": 163,
						"w": 138
					}
				],
				"ball": {
					"n": 0,
					"h": 85,
					"w": 402,
					"z": 0,
					"r": 0,
					"p": 2,
					"x": 0
				}
			},
			"interval": 38
		},
		{
			"num": 1481,
			"minute": 71,
			"messages": [
				{
					"owner": 2,
					"mes": "Кеннет Удре[33](Опава) принимает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 708
					},
					{
						"n": 2,
						"h": 330,
						"w": 614
					},
					{
						"n": 14,
						"h": 275,
						"w": 618
					},
					{
						"n": 13,
						"h": 176,
						"w": 609
					},
					{
						"n": 5,
						"h": 107,
						"w": 604
					},
					{
						"n": 6,
						"h": 394,
						"w": 540
					},
					{
						"n": 18,
						"h": 224,
						"w": 519
					},
					{
						"n": 15,
						"h": 151,
						"w": 472
					},
					{
						"n": 17,
						"h": 55,
						"w": 561
					},
					{
						"n": 20,
						"h": 279,
						"w": 415
					},
					{
						"n": 19,
						"h": 127,
						"w": 364
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 596
					},
					{
						"n": 13,
						"h": 348,
						"w": 348,
						"m": 600
					},
					{
						"n": 3,
						"h": 267,
						"w": 451
					},
					{
						"n": 14,
						"h": 176,
						"w": 446
					},
					{
						"n": 5,
						"h": 72,
						"w": 453
					},
					{
						"n": 6,
						"h": 241,
						"w": 348
					},
					{
						"n": 7,
						"h": 227,
						"w": 245
					},
					{
						"n": 18,
						"h": 46,
						"w": 195
					},
					{
						"n": 17,
						"h": 419,
						"w": 192
					},
					{
						"n": 19,
						"h": 302,
						"w": 128
					},
					{
						"n": 20,
						"h": 159,
						"w": 125
					}
				],
				"ball": {
					"n": 0,
					"h": 102,
					"w": 372,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 22
		},
		{
			"num": 1482,
			"minute": 71,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 705
					},
					{
						"n": 2,
						"h": 330,
						"w": 628
					},
					{
						"n": 14,
						"h": 251,
						"w": 625
					},
					{
						"n": 13,
						"h": 141,
						"w": 600
					},
					{
						"n": 5,
						"h": 98,
						"w": 609
					},
					{
						"n": 6,
						"h": 394,
						"w": 580
					},
					{
						"n": 18,
						"h": 230,
						"w": 537
					},
					{
						"n": 15,
						"h": 150,
						"w": 512
					},
					{
						"n": 17,
						"h": 64,
						"w": 587
					},
					{
						"n": 20,
						"h": 240,
						"w": 408
					},
					{
						"n": 19,
						"h": 113,
						"w": 402
					}
				],
				"away": [
					{
						"n": 1,
						"h": 226,
						"w": 595
					},
					{
						"n": 13,
						"h": 346,
						"w": 313
					},
					{
						"n": 3,
						"h": 281,
						"w": 429
					},
					{
						"n": 14,
						"h": 165,
						"w": 440
					},
					{
						"n": 5,
						"h": 56,
						"w": 416
					},
					{
						"n": 6,
						"h": 221,
						"w": 333
					},
					{
						"n": 7,
						"h": 219,
						"w": 206
					},
					{
						"n": 18,
						"h": 45,
						"w": 155
					},
					{
						"n": 17,
						"h": 386,
						"w": 168
					},
					{
						"n": 19,
						"h": 322,
						"w": 125
					},
					{
						"n": 20,
						"h": 179,
						"w": 119
					}
				],
				"ball": {
					"n": 0,
					"h": 104,
					"w": 407,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1483,
			"minute": 71,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 706
					},
					{
						"n": 2,
						"h": 330,
						"w": 606
					},
					{
						"n": 14,
						"h": 276,
						"w": 594
					},
					{
						"n": 13,
						"h": 166,
						"w": 612
					},
					{
						"n": 5,
						"h": 120,
						"w": 606
					},
					{
						"n": 6,
						"h": 390,
						"w": 584
					},
					{
						"n": 18,
						"h": 264,
						"w": 515
					},
					{
						"n": 15,
						"h": 189,
						"w": 501
					},
					{
						"n": 17,
						"h": 56,
						"w": 549
					},
					{
						"n": 20,
						"h": 231,
						"w": 401
					},
					{
						"n": 19,
						"h": 119,
						"w": 441
					}
				],
				"away": [
					{
						"n": 1,
						"h": 221,
						"w": 601
					},
					{
						"n": 13,
						"h": 328,
						"w": 282
					},
					{
						"n": 3,
						"h": 267,
						"w": 456
					},
					{
						"n": 14,
						"h": 171,
						"w": 470
					},
					{
						"n": 5,
						"h": 70,
						"w": 454
					},
					{
						"n": 6,
						"h": 219,
						"w": 339
					},
					{
						"n": 7,
						"h": 230,
						"w": 244
					},
					{
						"n": 18,
						"h": 45,
						"w": 161
					},
					{
						"n": 17,
						"h": 399,
						"w": 206
					},
					{
						"n": 19,
						"h": 298,
						"w": 149
					},
					{
						"n": 20,
						"h": 158,
						"w": 151
					}
				],
				"ball": {
					"n": 0,
					"h": 122,
					"w": 438,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1484,
			"minute": 72,
			"possession": 43,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 703,
						"m": 680
					},
					{
						"n": 2,
						"h": 330,
						"w": 643
					},
					{
						"n": 14,
						"h": 270,
						"w": 633
					},
					{
						"n": 13,
						"h": 183,
						"w": 622
					},
					{
						"n": 5,
						"h": 144,
						"w": 606
					},
					{
						"n": 6,
						"h": 394,
						"w": 584
					},
					{
						"n": 18,
						"h": 241,
						"w": 548
					},
					{
						"n": 15,
						"h": 167,
						"w": 534
					},
					{
						"n": 17,
						"h": 56,
						"w": 585
					},
					{
						"n": 20,
						"h": 264,
						"w": 379,
						"f": 88
					},
					{
						"n": 19,
						"h": 99,
						"w": 444
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 601
					},
					{
						"n": 13,
						"h": 351,
						"w": 296
					},
					{
						"n": 3,
						"h": 286,
						"w": 425
					},
					{
						"n": 14,
						"h": 172,
						"w": 434
					},
					{
						"n": 5,
						"h": 59,
						"w": 415,
						"f": 79,
						"c": 3
					},
					{
						"n": 6,
						"h": 259,
						"w": 334,
						"f": 79,
						"c": 3
					},
					{
						"n": 7,
						"h": 225,
						"w": 204
					},
					{
						"n": 18,
						"h": 21,
						"w": 171
					},
					{
						"n": 17,
						"h": 416,
						"w": 170
					},
					{
						"n": 19,
						"h": 314,
						"w": 120,
						"f": 92
					},
					{
						"n": 20,
						"h": 151,
						"w": 120
					}
				],
				"ball": {
					"n": 0,
					"h": 99,
					"w": 424,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1485,
			"minute": 72,
			"messages": [
				{
					"owner": 2,
					"mes": "К.Удре[33](Опава) пасует О.Дюмону[26](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 706
					},
					{
						"n": 2,
						"h": 330,
						"w": 603
					},
					{
						"n": 14,
						"h": 284,
						"w": 615
					},
					{
						"n": 13,
						"h": 215,
						"w": 625
					},
					{
						"n": 5,
						"h": 146,
						"w": 611
					},
					{
						"n": 6,
						"h": 394,
						"w": 597
					},
					{
						"n": 18,
						"h": 223,
						"w": 542
					},
					{
						"n": 15,
						"h": 176,
						"w": 495
					},
					{
						"n": 17,
						"h": 56,
						"w": 597
					},
					{
						"n": 20,
						"h": 275,
						"w": 418
					},
					{
						"n": 19,
						"h": 138,
						"w": 437
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 597
					},
					{
						"n": 13,
						"h": 354,
						"w": 288
					},
					{
						"n": 3,
						"h": 268,
						"w": 454
					},
					{
						"n": 14,
						"h": 181,
						"w": 440
					},
					{
						"n": 5,
						"h": 58,
						"w": 432
					},
					{
						"n": 6,
						"h": 272,
						"w": 310
					},
					{
						"n": 7,
						"h": 217,
						"w": 218
					},
					{
						"n": 18,
						"h": 33,
						"w": 150
					},
					{
						"n": 17,
						"h": 420,
						"w": 150
					},
					{
						"n": 19,
						"h": 324,
						"w": 141
					},
					{
						"n": 20,
						"h": 151,
						"w": 125
					}
				],
				"ball": {
					"n": 0,
					"h": 178,
					"w": 410,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1486,
			"minute": 72,
			"messages": [
				{
					"owner": 2,
					"mes": "Оливье Дюмон[26](Опава) отдает на К.Удре[33](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 710
					},
					{
						"n": 2,
						"h": 330,
						"w": 607
					},
					{
						"n": 14,
						"h": 286,
						"w": 615
					},
					{
						"n": 13,
						"h": 173,
						"w": 620
					},
					{
						"n": 5,
						"h": 107,
						"w": 594
					},
					{
						"n": 6,
						"h": 389,
						"w": 591
					},
					{
						"n": 18,
						"h": 249,
						"w": 511
					},
					{
						"n": 15,
						"h": 184,
						"w": 492
					},
					{
						"n": 17,
						"h": 60,
						"w": 555
					},
					{
						"n": 20,
						"h": 280,
						"w": 376
					},
					{
						"n": 19,
						"h": 178,
						"w": 424
					}
				],
				"away": [
					{
						"n": 1,
						"h": 225,
						"w": 599
					},
					{
						"n": 13,
						"h": 395,
						"w": 278
					},
					{
						"n": 3,
						"h": 286,
						"w": 426
					},
					{
						"n": 14,
						"h": 182,
						"w": 442
					},
					{
						"n": 5,
						"h": 76,
						"w": 431
					},
					{
						"n": 6,
						"h": 270,
						"w": 317,
						"m": 650
					},
					{
						"n": 7,
						"h": 257,
						"w": 232
					},
					{
						"n": 18,
						"h": 46,
						"w": 131
					},
					{
						"n": 17,
						"h": 408,
						"w": 161
					},
					{
						"n": 19,
						"h": 296,
						"w": 143
					},
					{
						"n": 20,
						"h": 154,
						"w": 151
					}
				],
				"ball": {
					"n": 0,
					"h": 55,
					"w": 442,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 42
		},
		{
			"num": 1487,
			"minute": 72,
			"messages": [
				{
					"owner": 2,
					"mes": "Кеннет Удре[33](Опава) с подкруткой пасует А.Фрешлю[39](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 706
					},
					{
						"n": 2,
						"h": 330,
						"w": 617
					},
					{
						"n": 14,
						"h": 263,
						"w": 619
					},
					{
						"n": 13,
						"h": 214,
						"w": 614
					},
					{
						"n": 5,
						"h": 92,
						"w": 573
					},
					{
						"n": 6,
						"h": 394,
						"w": 594
					},
					{
						"n": 18,
						"h": 221,
						"w": 533
					},
					{
						"n": 15,
						"h": 152,
						"w": 517
					},
					{
						"n": 17,
						"h": 56,
						"w": 555
					},
					{
						"n": 20,
						"h": 282,
						"w": 384
					},
					{
						"n": 19,
						"h": 218,
						"w": 435
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 598
					},
					{
						"n": 13,
						"h": 395,
						"w": 289,
						"m": 590
					},
					{
						"n": 3,
						"h": 283,
						"w": 465
					},
					{
						"n": 14,
						"h": 168,
						"w": 465
					},
					{
						"n": 5,
						"h": 64,
						"w": 470
					},
					{
						"n": 6,
						"h": 231,
						"w": 305
					},
					{
						"n": 7,
						"h": 233,
						"w": 199
					},
					{
						"n": 18,
						"h": 36,
						"w": 141
					},
					{
						"n": 17,
						"h": 367,
						"w": 167
					},
					{
						"n": 19,
						"h": 297,
						"w": 184,
						"m": 640
					},
					{
						"n": 20,
						"h": 171,
						"w": 131
					}
				],
				"ball": {
					"n": 0,
					"h": 152,
					"w": 517,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 41
		},
		{
			"num": 1488,
			"minute": 72,
			"messages": [
				{
					"owner": 2,
					"mes": "Но Кевин Келли[15](Галвэй Юнайтед) бросается наперерез и перехватывает мяч!..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 704
					},
					{
						"n": 2,
						"h": 340,
						"w": 594
					},
					{
						"n": 14,
						"h": 264,
						"w": 579
					},
					{
						"n": 13,
						"h": 201,
						"w": 576
					},
					{
						"n": 5,
						"h": 86,
						"w": 548
					},
					{
						"n": 6,
						"h": 396,
						"w": 554
					},
					{
						"n": 18,
						"h": 237,
						"w": 496
					},
					{
						"n": 15,
						"h": 127,
						"w": 492,
						"m": 630
					},
					{
						"n": 17,
						"h": 57,
						"w": 515
					},
					{
						"n": 20,
						"h": 287,
						"w": 344
					},
					{
						"n": 19,
						"h": 205,
						"w": 397
					}
				],
				"away": [
					{
						"n": 1,
						"h": 234,
						"w": 640
					},
					{
						"n": 13,
						"h": 400,
						"w": 328
					},
					{
						"n": 3,
						"h": 243,
						"w": 461
					},
					{
						"n": 14,
						"h": 165,
						"w": 476
					},
					{
						"n": 5,
						"h": 103,
						"w": 474
					},
					{
						"n": 6,
						"h": 211,
						"w": 339
					},
					{
						"n": 7,
						"h": 230,
						"w": 239
					},
					{
						"n": 18,
						"h": 34,
						"w": 181
					},
					{
						"n": 17,
						"h": 360,
						"w": 207
					},
					{
						"n": 19,
						"h": 312,
						"w": 221
					},
					{
						"n": 20,
						"h": 161,
						"w": 170
					}
				],
				"ball": {
					"n": 0,
					"h": 127,
					"w": 492,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1489,
			"minute": 72,
			"messages": [
				{
					"owner": 1,
					"mes": "К.Келли[15](Галвэй Юнайтед) делает передачу Б.Регану[13](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 704
					},
					{
						"n": 2,
						"h": 349,
						"w": 574
					},
					{
						"n": 14,
						"h": 273,
						"w": 554
					},
					{
						"n": 13,
						"h": 165,
						"w": 567
					},
					{
						"n": 5,
						"h": 76,
						"w": 529
					},
					{
						"n": 6,
						"h": 395,
						"w": 517
					},
					{
						"n": 18,
						"h": 267,
						"w": 475
					},
					{
						"n": 15,
						"h": 130,
						"w": 483,
						"m": 640
					},
					{
						"n": 17,
						"h": 54,
						"w": 478
					},
					{
						"n": 20,
						"h": 290,
						"w": 307
					},
					{
						"n": 19,
						"h": 189,
						"w": 364
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 649
					},
					{
						"n": 13,
						"h": 403,
						"w": 365
					},
					{
						"n": 3,
						"h": 243,
						"w": 498
					},
					{
						"n": 14,
						"h": 171,
						"w": 506
					},
					{
						"n": 5,
						"h": 110,
						"w": 491
					},
					{
						"n": 6,
						"h": 194,
						"w": 372
					},
					{
						"n": 7,
						"h": 231,
						"w": 276
					},
					{
						"n": 18,
						"h": 35,
						"w": 218
					},
					{
						"n": 17,
						"h": 374,
						"w": 241
					},
					{
						"n": 19,
						"h": 317,
						"w": 258
					},
					{
						"n": 20,
						"h": 154,
						"w": 206
					}
				],
				"ball": {
					"n": 0,
					"h": 165,
					"w": 567,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 37
		},
		{
			"num": 1490,
			"minute": 72,
			"messages": [
				{
					"owner": 1,
					"mes": "Билли Реган[13](Галвэй Юнайтед) не смог остановить мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 705
					},
					{
						"n": 2,
						"h": 351,
						"w": 568
					},
					{
						"n": 14,
						"h": 273,
						"w": 548
					},
					{
						"n": 13,
						"h": 165,
						"w": 567,
						"m": 590
					},
					{
						"n": 5,
						"h": 82,
						"w": 531
					},
					{
						"n": 6,
						"h": 396,
						"w": 511
					},
					{
						"n": 18,
						"h": 270,
						"w": 469
					},
					{
						"n": 15,
						"h": 131,
						"w": 477
					},
					{
						"n": 17,
						"h": 54,
						"w": 472
					},
					{
						"n": 20,
						"h": 291,
						"w": 302
					},
					{
						"n": 19,
						"h": 187,
						"w": 358
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 643
					},
					{
						"n": 13,
						"h": 403,
						"w": 371
					},
					{
						"n": 3,
						"h": 237,
						"w": 498
					},
					{
						"n": 14,
						"h": 167,
						"w": 501
					},
					{
						"n": 5,
						"h": 110,
						"w": 490
					},
					{
						"n": 6,
						"h": 192,
						"w": 378
					},
					{
						"n": 7,
						"h": 231,
						"w": 282
					},
					{
						"n": 18,
						"h": 35,
						"w": 224
					},
					{
						"n": 17,
						"h": 376,
						"w": 246
					},
					{
						"n": 19,
						"h": 316,
						"w": 252
					},
					{
						"n": 20,
						"h": 152,
						"w": 212
					}
				],
				"ball": {
					"n": 0,
					"h": 145,
					"w": 557,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 6
		},
		{
			"num": 1491,
			"minute": 72,
			"messages": [
				{
					"owner": 1,
					"mes": "Билли Реган[13](Галвэй Юнайтед) все же подбирает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 704
					},
					{
						"n": 2,
						"h": 359,
						"w": 548
					},
					{
						"n": 14,
						"h": 272,
						"w": 546
					},
					{
						"n": 13,
						"h": 145,
						"w": 557
					},
					{
						"n": 5,
						"h": 102,
						"w": 540
					},
					{
						"n": 6,
						"h": 395,
						"w": 489
					},
					{
						"n": 18,
						"h": 284,
						"w": 453
					},
					{
						"n": 15,
						"h": 134,
						"w": 455
					},
					{
						"n": 17,
						"h": 49,
						"w": 451
					},
					{
						"n": 20,
						"h": 295,
						"w": 280
					},
					{
						"n": 19,
						"h": 179,
						"w": 337
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 644
					},
					{
						"n": 13,
						"h": 403,
						"w": 393
					},
					{
						"n": 3,
						"h": 258,
						"w": 503
					},
					{
						"n": 14,
						"h": 188,
						"w": 508
					},
					{
						"n": 5,
						"h": 132,
						"w": 491
					},
					{
						"n": 6,
						"h": 181,
						"w": 397
					},
					{
						"n": 7,
						"h": 231,
						"w": 304
					},
					{
						"n": 18,
						"h": 35,
						"w": 246
					},
					{
						"n": 17,
						"h": 384,
						"w": 267
					},
					{
						"n": 19,
						"h": 314,
						"w": 230
					},
					{
						"n": 20,
						"h": 148,
						"w": 234
					}
				],
				"ball": {
					"n": 0,
					"h": 145,
					"w": 557,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 22
		},
		{
			"num": 1492,
			"minute": 72,
			"messages": [
				{
					"owner": 1,
					"mes": "Б.Реган[13](Галвэй Юнайтед) пасует Т.Эверсу[02](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 706
					},
					{
						"n": 2,
						"h": 336,
						"w": 559
					},
					{
						"n": 14,
						"h": 269,
						"w": 533
					},
					{
						"n": 13,
						"h": 152,
						"w": 550,
						"m": 600
					},
					{
						"n": 5,
						"h": 77,
						"w": 499
					},
					{
						"n": 6,
						"h": 399,
						"w": 441
					},
					{
						"n": 18,
						"h": 295,
						"w": 447
					},
					{
						"n": 15,
						"h": 137,
						"w": 407
					},
					{
						"n": 17,
						"h": 55,
						"w": 403
					},
					{
						"n": 20,
						"h": 304,
						"w": 250
					},
					{
						"n": 19,
						"h": 171,
						"w": 290
					}
				],
				"away": [
					{
						"n": 1,
						"h": 205,
						"w": 649
					},
					{
						"n": 13,
						"h": 406,
						"w": 441
					},
					{
						"n": 3,
						"h": 260,
						"w": 505
					},
					{
						"n": 14,
						"h": 176,
						"w": 498
					},
					{
						"n": 5,
						"h": 110,
						"w": 494
					},
					{
						"n": 6,
						"h": 224,
						"w": 417
					},
					{
						"n": 7,
						"h": 214,
						"w": 348
					},
					{
						"n": 18,
						"h": 29,
						"w": 294
					},
					{
						"n": 17,
						"h": 407,
						"w": 309
					},
					{
						"n": 19,
						"h": 314,
						"w": 278
					},
					{
						"n": 20,
						"h": 143,
						"w": 281
					}
				],
				"ball": {
					"n": 0,
					"h": 336,
					"w": 559,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 48
		},
		{
			"num": 1493,
			"minute": 72,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 705
					},
					{
						"n": 2,
						"h": 339,
						"w": 524
					},
					{
						"n": 14,
						"h": 284,
						"w": 536
					},
					{
						"n": 13,
						"h": 184,
						"w": 533
					},
					{
						"n": 5,
						"h": 66,
						"w": 479
					},
					{
						"n": 6,
						"h": 404,
						"w": 402
					},
					{
						"n": 18,
						"h": 315,
						"w": 453
					},
					{
						"n": 15,
						"h": 137,
						"w": 367
					},
					{
						"n": 17,
						"h": 44,
						"w": 365
					},
					{
						"n": 20,
						"h": 305,
						"w": 258
					},
					{
						"n": 19,
						"h": 167,
						"w": 250
					}
				],
				"away": [
					{
						"n": 1,
						"h": 205,
						"w": 645
					},
					{
						"n": 13,
						"h": 406,
						"w": 401
					},
					{
						"n": 3,
						"h": 264,
						"w": 507
					},
					{
						"n": 14,
						"h": 175,
						"w": 503
					},
					{
						"n": 5,
						"h": 110,
						"w": 509
					},
					{
						"n": 6,
						"h": 190,
						"w": 438
					},
					{
						"n": 7,
						"h": 216,
						"w": 365
					},
					{
						"n": 18,
						"h": 33,
						"w": 333
					},
					{
						"n": 17,
						"h": 423,
						"w": 346
					},
					{
						"n": 19,
						"h": 286,
						"w": 299
					},
					{
						"n": 20,
						"h": 143,
						"w": 320
					}
				],
				"ball": {
					"n": 0,
					"h": 339,
					"w": 524,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1494,
			"minute": 72,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 706
					},
					{
						"n": 2,
						"h": 338,
						"w": 489
					},
					{
						"n": 14,
						"h": 277,
						"w": 523
					},
					{
						"n": 13,
						"h": 170,
						"w": 524
					},
					{
						"n": 5,
						"h": 75,
						"w": 465
					},
					{
						"n": 6,
						"h": 405,
						"w": 362
					},
					{
						"n": 18,
						"h": 284,
						"w": 428
					},
					{
						"n": 15,
						"h": 145,
						"w": 328
					},
					{
						"n": 17,
						"h": 46,
						"w": 325
					},
					{
						"n": 20,
						"h": 325,
						"w": 226
					},
					{
						"n": 19,
						"h": 147,
						"w": 233
					}
				],
				"away": [
					{
						"n": 1,
						"h": 205,
						"w": 642
					},
					{
						"n": 13,
						"h": 404,
						"w": 431
					},
					{
						"n": 3,
						"h": 264,
						"w": 547
					},
					{
						"n": 14,
						"h": 167,
						"w": 519
					},
					{
						"n": 5,
						"h": 110,
						"w": 538
					},
					{
						"n": 6,
						"h": 161,
						"w": 466
					},
					{
						"n": 7,
						"h": 203,
						"w": 403
					},
					{
						"n": 18,
						"h": 41,
						"w": 373
					},
					{
						"n": 17,
						"h": 426,
						"w": 366
					},
					{
						"n": 19,
						"h": 276,
						"w": 334
					},
					{
						"n": 20,
						"h": 142,
						"w": 353
					}
				],
				"ball": {
					"n": 0,
					"h": 338,
					"w": 489,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1495,
			"minute": 72,
			"messages": [
				{
					"owner": 1,
					"mes": "Тимо Эверс[02](Галвэй Юнайтед) переправляет мяч на ход Р.Уотсону[18](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 707
					},
					{
						"n": 2,
						"h": 338,
						"w": 489,
						"m": 680
					},
					{
						"n": 14,
						"h": 274,
						"w": 496
					},
					{
						"n": 13,
						"h": 178,
						"w": 481
					},
					{
						"n": 5,
						"h": 78,
						"w": 439
					},
					{
						"n": 6,
						"h": 406,
						"w": 318
					},
					{
						"n": 18,
						"h": 254,
						"w": 388
					},
					{
						"n": 15,
						"h": 149,
						"w": 284
					},
					{
						"n": 17,
						"h": 47,
						"w": 281
					},
					{
						"n": 20,
						"h": 287,
						"w": 203
					},
					{
						"n": 19,
						"h": 150,
						"w": 212
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 642
					},
					{
						"n": 13,
						"h": 403,
						"w": 475
					},
					{
						"n": 3,
						"h": 287,
						"w": 570
					},
					{
						"n": 14,
						"h": 176,
						"w": 556
					},
					{
						"n": 5,
						"h": 110,
						"w": 576
					},
					{
						"n": 6,
						"h": 164,
						"w": 510
					},
					{
						"n": 7,
						"h": 218,
						"w": 444
					},
					{
						"n": 18,
						"h": 43,
						"w": 417
					},
					{
						"n": 17,
						"h": 428,
						"w": 390
					},
					{
						"n": 19,
						"h": 287,
						"w": 377
					},
					{
						"n": 20,
						"h": 180,
						"w": 352
					}
				],
				"ball": {
					"n": 0,
					"h": 254,
					"w": 388,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 44
		},
		{
			"num": 1496,
			"minute": 72,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 703
					},
					{
						"n": 2,
						"h": 347,
						"w": 474
					},
					{
						"n": 14,
						"h": 274,
						"w": 479
					},
					{
						"n": 13,
						"h": 166,
						"w": 470
					},
					{
						"n": 5,
						"h": 76,
						"w": 422
					},
					{
						"n": 6,
						"h": 406,
						"w": 301
					},
					{
						"n": 18,
						"h": 254,
						"w": 373
					},
					{
						"n": 15,
						"h": 165,
						"w": 277
					},
					{
						"n": 17,
						"h": 48,
						"w": 264
					},
					{
						"n": 20,
						"h": 281,
						"w": 187
					},
					{
						"n": 19,
						"h": 157,
						"w": 197
					}
				],
				"away": [
					{
						"n": 1,
						"h": 228,
						"w": 642
					},
					{
						"n": 13,
						"h": 402,
						"w": 492
					},
					{
						"n": 3,
						"h": 279,
						"w": 585
					},
					{
						"n": 14,
						"h": 179,
						"w": 573
					},
					{
						"n": 5,
						"h": 110,
						"w": 591
					},
					{
						"n": 6,
						"h": 161,
						"w": 527
					},
					{
						"n": 7,
						"h": 217,
						"w": 461
					},
					{
						"n": 18,
						"h": 44,
						"w": 433
					},
					{
						"n": 17,
						"h": 428,
						"w": 390
					},
					{
						"n": 19,
						"h": 290,
						"w": 393
					},
					{
						"n": 20,
						"h": 196,
						"w": 347
					}
				],
				"ball": {
					"n": 0,
					"h": 254,
					"w": 373,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 17
		},
		{
			"num": 1497,
			"minute": 72,
			"messages": [
				{
					"owner": 1,
					"mes": "Тома Анри[40](Опава) отбирает мяч у Р.Уотсона[18](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 703
					},
					{
						"n": 2,
						"h": 352,
						"w": 466
					},
					{
						"n": 14,
						"h": 274,
						"w": 470
					},
					{
						"n": 13,
						"h": 166,
						"w": 470
					},
					{
						"n": 5,
						"h": 74,
						"w": 412
					},
					{
						"n": 6,
						"h": 405,
						"w": 291
					},
					{
						"n": 18,
						"h": 254,
						"w": 363,
						"m": 610
					},
					{
						"n": 15,
						"h": 165,
						"w": 277
					},
					{
						"n": 17,
						"h": 49,
						"w": 254
					},
					{
						"n": 20,
						"h": 277,
						"w": 180
					},
					{
						"n": 19,
						"h": 162,
						"w": 188
					}
				],
				"away": [
					{
						"n": 1,
						"h": 228,
						"w": 642
					},
					{
						"n": 13,
						"h": 402,
						"w": 492
					},
					{
						"n": 3,
						"h": 275,
						"w": 593
					},
					{
						"n": 14,
						"h": 180,
						"w": 583
					},
					{
						"n": 5,
						"h": 110,
						"w": 591
					},
					{
						"n": 6,
						"h": 160,
						"w": 537
					},
					{
						"n": 7,
						"h": 217,
						"w": 471
					},
					{
						"n": 18,
						"h": 44,
						"w": 443
					},
					{
						"n": 17,
						"h": 428,
						"w": 397
					},
					{
						"n": 19,
						"h": 291,
						"w": 396
					},
					{
						"n": 20,
						"h": 205,
						"w": 343,
						"m": 620
					}
				],
				"ball": {
					"n": 0,
					"h": 245,
					"w": 377,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 10
		},
		{
			"num": 1498,
			"minute": 72,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 707
					},
					{
						"n": 2,
						"h": 330,
						"w": 484
					},
					{
						"n": 14,
						"h": 234,
						"w": 472
					},
					{
						"n": 13,
						"h": 176,
						"w": 484
					},
					{
						"n": 5,
						"h": 84,
						"w": 451
					},
					{
						"n": 6,
						"h": 401,
						"w": 331
					},
					{
						"n": 18,
						"h": 248,
						"w": 372
					},
					{
						"n": 15,
						"h": 187,
						"w": 310
					},
					{
						"n": 17,
						"h": 51,
						"w": 294
					},
					{
						"n": 20,
						"h": 264,
						"w": 217
					},
					{
						"n": 19,
						"h": 163,
						"w": 228
					}
				],
				"away": [
					{
						"n": 1,
						"h": 229,
						"w": 682
					},
					{
						"n": 13,
						"h": 403,
						"w": 452
					},
					{
						"n": 3,
						"h": 272,
						"w": 588
					},
					{
						"n": 14,
						"h": 185,
						"w": 592
					},
					{
						"n": 5,
						"h": 71,
						"w": 582
					},
					{
						"n": 6,
						"h": 193,
						"w": 515
					},
					{
						"n": 7,
						"h": 218,
						"w": 431
					},
					{
						"n": 18,
						"h": 42,
						"w": 404
					},
					{
						"n": 17,
						"h": 423,
						"w": 357
					},
					{
						"n": 19,
						"h": 294,
						"w": 356
					},
					{
						"n": 20,
						"h": 230,
						"w": 318
					}
				],
				"ball": {
					"n": 0,
					"h": 220,
					"w": 402,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1499,
			"minute": 72,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 706
					},
					{
						"n": 2,
						"h": 330,
						"w": 508
					},
					{
						"n": 14,
						"h": 234,
						"w": 459
					},
					{
						"n": 13,
						"h": 203,
						"w": 498
					},
					{
						"n": 5,
						"h": 104,
						"w": 486
					},
					{
						"n": 6,
						"h": 397,
						"w": 370
					},
					{
						"n": 18,
						"h": 241,
						"w": 411
					},
					{
						"n": 15,
						"h": 186,
						"w": 350
					},
					{
						"n": 17,
						"h": 52,
						"w": 334
					},
					{
						"n": 20,
						"h": 245,
						"w": 252
					},
					{
						"n": 19,
						"h": 168,
						"w": 267
					}
				],
				"away": [
					{
						"n": 1,
						"h": 226,
						"w": 663
					},
					{
						"n": 13,
						"h": 411,
						"w": 430
					},
					{
						"n": 3,
						"h": 281,
						"w": 570
					},
					{
						"n": 14,
						"h": 172,
						"w": 566
					},
					{
						"n": 5,
						"h": 65,
						"w": 568
					},
					{
						"n": 6,
						"h": 210,
						"w": 478
					},
					{
						"n": 7,
						"h": 217,
						"w": 391
					},
					{
						"n": 18,
						"h": 46,
						"w": 364
					},
					{
						"n": 17,
						"h": 420,
						"w": 317
					},
					{
						"n": 19,
						"h": 300,
						"w": 317
					},
					{
						"n": 20,
						"h": 215,
						"w": 281
					}
				],
				"ball": {
					"n": 0,
					"h": 235,
					"w": 439,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1500,
			"minute": 72,
			"messages": [
				{
					"owner": 2,
					"mes": "Тома Анри[40](Опава) пасует М.Томасову[37](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 702
					},
					{
						"n": 2,
						"h": 330,
						"w": 550
					},
					{
						"n": 14,
						"h": 237,
						"w": 500
					},
					{
						"n": 13,
						"h": 179,
						"w": 533
					},
					{
						"n": 5,
						"h": 108,
						"w": 444
					},
					{
						"n": 6,
						"h": 395,
						"w": 412
					},
					{
						"n": 18,
						"h": 240,
						"w": 453
					},
					{
						"n": 15,
						"h": 172,
						"w": 390
					},
					{
						"n": 17,
						"h": 58,
						"w": 355
					},
					{
						"n": 20,
						"h": 265,
						"w": 289
					},
					{
						"n": 19,
						"h": 205,
						"w": 288
					}
				],
				"away": [
					{
						"n": 1,
						"h": 228,
						"w": 640
					},
					{
						"n": 13,
						"h": 412,
						"w": 408
					},
					{
						"n": 3,
						"h": 283,
						"w": 536
					},
					{
						"n": 14,
						"h": 178,
						"w": 525
					},
					{
						"n": 5,
						"h": 70,
						"w": 526
					},
					{
						"n": 6,
						"h": 241,
						"w": 451
					},
					{
						"n": 7,
						"h": 241,
						"w": 357
					},
					{
						"n": 18,
						"h": 46,
						"w": 322
					},
					{
						"n": 17,
						"h": 383,
						"w": 298,
						"m": 640
					},
					{
						"n": 19,
						"h": 296,
						"w": 275
					},
					{
						"n": 20,
						"h": 207,
						"w": 273,
						"m": 610
					}
				],
				"ball": {
					"n": 0,
					"h": 108,
					"w": 444,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 42
		},
		{
			"num": 1501,
			"minute": 72,
			"messages": [
				{
					"owner": 2,
					"mes": "Самуэль Кари Фридйонссон[05](Галвэй Юнайтед) читает комбинацию и перехватывает мяч!..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 701
					},
					{
						"n": 2,
						"h": 344,
						"w": 512
					},
					{
						"n": 14,
						"h": 253,
						"w": 489
					},
					{
						"n": 13,
						"h": 167,
						"w": 495
					},
					{
						"n": 5,
						"h": 136,
						"w": 416,
						"m": 690
					},
					{
						"n": 6,
						"h": 396,
						"w": 372
					},
					{
						"n": 18,
						"h": 265,
						"w": 422
					},
					{
						"n": 15,
						"h": 166,
						"w": 351
					},
					{
						"n": 17,
						"h": 40,
						"w": 320
					},
					{
						"n": 20,
						"h": 277,
						"w": 251
					},
					{
						"n": 19,
						"h": 190,
						"w": 251
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 644
					},
					{
						"n": 13,
						"h": 406,
						"w": 436
					},
					{
						"n": 3,
						"h": 260,
						"w": 568
					},
					{
						"n": 14,
						"h": 189,
						"w": 563
					},
					{
						"n": 5,
						"h": 91,
						"w": 560
					},
					{
						"n": 6,
						"h": 254,
						"w": 488
					},
					{
						"n": 7,
						"h": 235,
						"w": 396
					},
					{
						"n": 18,
						"h": 51,
						"w": 361
					},
					{
						"n": 17,
						"h": 391,
						"w": 337
					},
					{
						"n": 19,
						"h": 310,
						"w": 313
					},
					{
						"n": 20,
						"h": 189,
						"w": 309
					}
				],
				"ball": {
					"n": 0,
					"h": 136,
					"w": 416,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1502,
			"minute": 72,
			"messages": [
				{
					"owner": 1,
					"mes": "С.Фридйонссон[05](Галвэй Юнайтед) пасует Б.Регану[13](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 702
					},
					{
						"n": 2,
						"h": 356,
						"w": 469
					},
					{
						"n": 14,
						"h": 263,
						"w": 478
					},
					{
						"n": 13,
						"h": 156,
						"w": 482
					},
					{
						"n": 5,
						"h": 126,
						"w": 415
					},
					{
						"n": 6,
						"h": 400,
						"w": 337
					},
					{
						"n": 18,
						"h": 278,
						"w": 390
					},
					{
						"n": 15,
						"h": 163,
						"w": 316
					},
					{
						"n": 17,
						"h": 44,
						"w": 286
					},
					{
						"n": 20,
						"h": 280,
						"w": 216
					},
					{
						"n": 19,
						"h": 176,
						"w": 218
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 644
					},
					{
						"n": 13,
						"h": 406,
						"w": 470
					},
					{
						"n": 3,
						"h": 259,
						"w": 603
					},
					{
						"n": 14,
						"h": 180,
						"w": 593
					},
					{
						"n": 5,
						"h": 108,
						"w": 591
					},
					{
						"n": 6,
						"h": 269,
						"w": 520
					},
					{
						"n": 7,
						"h": 231,
						"w": 431
					},
					{
						"n": 18,
						"h": 51,
						"w": 396
					},
					{
						"n": 17,
						"h": 392,
						"w": 352
					},
					{
						"n": 19,
						"h": 310,
						"w": 348
					},
					{
						"n": 20,
						"h": 175,
						"w": 341
					}
				],
				"ball": {
					"n": 0,
					"h": 156,
					"w": 482,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 35
		},
		{
			"num": 1503,
			"minute": 72,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 707
					},
					{
						"n": 2,
						"h": 364,
						"w": 430
					},
					{
						"n": 14,
						"h": 266,
						"w": 438
					},
					{
						"n": 13,
						"h": 157,
						"w": 447
					},
					{
						"n": 5,
						"h": 90,
						"w": 397
					},
					{
						"n": 6,
						"h": 397,
						"w": 298
					},
					{
						"n": 18,
						"h": 299,
						"w": 356
					},
					{
						"n": 15,
						"h": 158,
						"w": 276
					},
					{
						"n": 17,
						"h": 43,
						"w": 275
					},
					{
						"n": 20,
						"h": 286,
						"w": 177
					},
					{
						"n": 19,
						"h": 167,
						"w": 179
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 644
					},
					{
						"n": 13,
						"h": 406,
						"w": 481
					},
					{
						"n": 3,
						"h": 273,
						"w": 605
					},
					{
						"n": 14,
						"h": 184,
						"w": 592
					},
					{
						"n": 5,
						"h": 110,
						"w": 596
					},
					{
						"n": 6,
						"h": 291,
						"w": 554
					},
					{
						"n": 7,
						"h": 225,
						"w": 471
					},
					{
						"n": 18,
						"h": 52,
						"w": 436
					},
					{
						"n": 17,
						"h": 401,
						"w": 391
					},
					{
						"n": 19,
						"h": 286,
						"w": 380
					},
					{
						"n": 20,
						"h": 156,
						"w": 376
					}
				],
				"ball": {
					"n": 0,
					"h": 157,
					"w": 447,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1504,
			"minute": 72,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 703
					},
					{
						"n": 2,
						"h": 383,
						"w": 394
					},
					{
						"n": 14,
						"h": 269,
						"w": 444
					},
					{
						"n": 13,
						"h": 152,
						"w": 412
					},
					{
						"n": 5,
						"h": 75,
						"w": 385
					},
					{
						"n": 6,
						"h": 399,
						"w": 258
					},
					{
						"n": 18,
						"h": 297,
						"w": 323
					},
					{
						"n": 15,
						"h": 163,
						"w": 254
					},
					{
						"n": 17,
						"h": 48,
						"w": 235
					},
					{
						"n": 20,
						"h": 294,
						"w": 138
					},
					{
						"n": 19,
						"h": 158,
						"w": 158
					}
				],
				"away": [
					{
						"n": 1,
						"h": 235,
						"w": 650
					},
					{
						"n": 13,
						"h": 402,
						"w": 521
					},
					{
						"n": 3,
						"h": 273,
						"w": 608
					},
					{
						"n": 14,
						"h": 169,
						"w": 581
					},
					{
						"n": 5,
						"h": 110,
						"w": 608
					},
					{
						"n": 6,
						"h": 295,
						"w": 564
					},
					{
						"n": 7,
						"h": 222,
						"w": 480
					},
					{
						"n": 18,
						"h": 52,
						"w": 476
					},
					{
						"n": 17,
						"h": 409,
						"w": 409
					},
					{
						"n": 19,
						"h": 295,
						"w": 341
					},
					{
						"n": 20,
						"h": 153,
						"w": 415
					}
				],
				"ball": {
					"n": 0,
					"h": 152,
					"w": 412,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1505,
			"minute": 72,
			"messages": [
				{
					"owner": 1,
					"mes": "Билли Реган[13](Галвэй Юнайтед) пасует налево на Т.Эверса[02](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 708
					},
					{
						"n": 2,
						"h": 362,
						"w": 412
					},
					{
						"n": 14,
						"h": 268,
						"w": 434
					},
					{
						"n": 13,
						"h": 170,
						"w": 411
					},
					{
						"n": 5,
						"h": 62,
						"w": 377
					},
					{
						"n": 6,
						"h": 399,
						"w": 206
					},
					{
						"n": 18,
						"h": 315,
						"w": 324
					},
					{
						"n": 15,
						"h": 205,
						"w": 237
					},
					{
						"n": 17,
						"h": 49,
						"w": 183
					},
					{
						"n": 20,
						"h": 291,
						"w": 132
					},
					{
						"n": 19,
						"h": 157,
						"w": 155
					}
				],
				"away": [
					{
						"n": 1,
						"h": 205,
						"w": 642
					},
					{
						"n": 13,
						"h": 401,
						"w": 573
					},
					{
						"n": 3,
						"h": 274,
						"w": 601
					},
					{
						"n": 14,
						"h": 179,
						"w": 619
					},
					{
						"n": 5,
						"h": 110,
						"w": 606
					},
					{
						"n": 6,
						"h": 295,
						"w": 573
					},
					{
						"n": 7,
						"h": 246,
						"w": 502
					},
					{
						"n": 18,
						"h": 51,
						"w": 528
					},
					{
						"n": 17,
						"h": 417,
						"w": 457
					},
					{
						"n": 19,
						"h": 285,
						"w": 392
					},
					{
						"n": 20,
						"h": 122,
						"w": 374
					}
				],
				"ball": {
					"n": 0,
					"h": 362,
					"w": 412,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 52
		},
		{
			"num": 1506,
			"minute": 73,
			"possession": 43,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 703
					},
					{
						"n": 2,
						"h": 362,
						"w": 372
					},
					{
						"n": 14,
						"h": 274,
						"w": 419
					},
					{
						"n": 13,
						"h": 174,
						"w": 415
					},
					{
						"n": 5,
						"h": 67,
						"w": 359
					},
					{
						"n": 6,
						"h": 398,
						"w": 166
					},
					{
						"n": 18,
						"h": 279,
						"w": 307
					},
					{
						"n": 15,
						"h": 209,
						"w": 219,
						"f": 95
					},
					{
						"n": 17,
						"h": 53,
						"w": 143,
						"f": 89,
						"c": 1
					},
					{
						"n": 20,
						"h": 273,
						"w": 127
					},
					{
						"n": 19,
						"h": 167,
						"w": 132,
						"f": 94
					}
				],
				"away": [
					{
						"n": 1,
						"h": 205,
						"w": 643,
						"f": 80
					},
					{
						"n": 13,
						"h": 397,
						"w": 613
					},
					{
						"n": 3,
						"h": 266,
						"w": 640
					},
					{
						"n": 14,
						"h": 187,
						"w": 634
					},
					{
						"n": 5,
						"h": 78,
						"w": 623
					},
					{
						"n": 6,
						"h": 291,
						"w": 575
					},
					{
						"n": 7,
						"h": 249,
						"w": 507
					},
					{
						"n": 18,
						"h": 52,
						"w": 568,
						"f": 94
					},
					{
						"n": 17,
						"h": 424,
						"w": 480
					},
					{
						"n": 19,
						"h": 275,
						"w": 420,
						"m": 650
					},
					{
						"n": 20,
						"h": 88,
						"w": 368,
						"f": 94
					}
				],
				"ball": {
					"n": 0,
					"h": 362,
					"w": 372,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1507,
			"minute": 73,
			"messages": [
				{
					"owner": 1,
					"mes": "Тимо Эверс[02](Галвэй Юнайтед) отправляет мяч направо Р.Уотсону[18](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 709
					},
					{
						"n": 2,
						"h": 372,
						"w": 370
					},
					{
						"n": 14,
						"h": 278,
						"w": 424
					},
					{
						"n": 13,
						"h": 177,
						"w": 403
					},
					{
						"n": 5,
						"h": 72,
						"w": 375
					},
					{
						"n": 6,
						"h": 406,
						"w": 147
					},
					{
						"n": 18,
						"h": 276,
						"w": 272
					},
					{
						"n": 15,
						"h": 170,
						"w": 214
					},
					{
						"n": 17,
						"h": 64,
						"w": 147
					},
					{
						"n": 20,
						"h": 280,
						"w": 137
					},
					{
						"n": 19,
						"h": 154,
						"w": 137
					}
				],
				"away": [
					{
						"n": 1,
						"h": 216,
						"w": 686
					},
					{
						"n": 13,
						"h": 370,
						"w": 598
					},
					{
						"n": 3,
						"h": 276,
						"w": 619
					},
					{
						"n": 14,
						"h": 184,
						"w": 618
					},
					{
						"n": 5,
						"h": 69,
						"w": 593
					},
					{
						"n": 6,
						"h": 274,
						"w": 560
					},
					{
						"n": 7,
						"h": 210,
						"w": 486
					},
					{
						"n": 18,
						"h": 60,
						"w": 598
					},
					{
						"n": 17,
						"h": 425,
						"w": 463
					},
					{
						"n": 19,
						"h": 283,
						"w": 410
					},
					{
						"n": 20,
						"h": 127,
						"w": 389
					}
				],
				"ball": {
					"n": 0,
					"h": 276,
					"w": 272,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 44
		},
		{
			"num": 1508,
			"minute": 73,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 703
					},
					{
						"n": 2,
						"h": 377,
						"w": 364
					},
					{
						"n": 14,
						"h": 268,
						"w": 428
					},
					{
						"n": 13,
						"h": 185,
						"w": 422
					},
					{
						"n": 5,
						"h": 74,
						"w": 372
					},
					{
						"n": 6,
						"h": 405,
						"w": 147
					},
					{
						"n": 18,
						"h": 256,
						"w": 237
					},
					{
						"n": 15,
						"h": 166,
						"w": 214
					},
					{
						"n": 17,
						"h": 50,
						"w": 147
					},
					{
						"n": 20,
						"h": 280,
						"w": 137
					},
					{
						"n": 19,
						"h": 162,
						"w": 130
					}
				],
				"away": [
					{
						"n": 1,
						"h": 229,
						"w": 648
					},
					{
						"n": 13,
						"h": 384,
						"w": 598
					},
					{
						"n": 3,
						"h": 269,
						"w": 607
					},
					{
						"n": 14,
						"h": 182,
						"w": 624
					},
					{
						"n": 5,
						"h": 51,
						"w": 588
					},
					{
						"n": 6,
						"h": 286,
						"w": 546
					},
					{
						"n": 7,
						"h": 192,
						"w": 503
					},
					{
						"n": 18,
						"h": 56,
						"w": 578
					},
					{
						"n": 17,
						"h": 395,
						"w": 463
					},
					{
						"n": 19,
						"h": 275,
						"w": 413
					},
					{
						"n": 20,
						"h": 157,
						"w": 415
					}
				],
				"ball": {
					"n": 0,
					"h": 256,
					"w": 237,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1509,
			"minute": 73,
			"messages": [
				{
					"owner": 1,
					"mes": "Райан Уотсон[18](Галвэй Юнайтед) пасует вперед Т.Дэвлину[20](Галвэй Юнайтед)..."
				},
				{
					"owner": 1,
					"mes": "Мирослав Манолов[27](Опава) преграждает путь мячу!..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 706
					},
					{
						"n": 2,
						"h": 377,
						"w": 359
					},
					{
						"n": 14,
						"h": 270,
						"w": 424
					},
					{
						"n": 13,
						"h": 184,
						"w": 417
					},
					{
						"n": 5,
						"h": 74,
						"w": 367
					},
					{
						"n": 6,
						"h": 403,
						"w": 143
					},
					{
						"n": 18,
						"h": 256,
						"w": 237,
						"m": 600
					},
					{
						"n": 15,
						"h": 165,
						"w": 209
					},
					{
						"n": 17,
						"h": 50,
						"w": 147
					},
					{
						"n": 20,
						"h": 279,
						"w": 141,
						"m": 590
					},
					{
						"n": 19,
						"h": 161,
						"w": 125
					}
				],
				"away": [
					{
						"n": 1,
						"h": 228,
						"w": 653
					},
					{
						"n": 13,
						"h": 384,
						"w": 600
					},
					{
						"n": 3,
						"h": 264,
						"w": 609
					},
					{
						"n": 14,
						"h": 181,
						"w": 619
					},
					{
						"n": 5,
						"h": 56,
						"w": 590
					},
					{
						"n": 6,
						"h": 284,
						"w": 551
					},
					{
						"n": 7,
						"h": 192,
						"w": 498
					},
					{
						"n": 18,
						"h": 55,
						"w": 573
					},
					{
						"n": 17,
						"h": 400,
						"w": 463
					},
					{
						"n": 19,
						"h": 280,
						"w": 415
					},
					{
						"n": 20,
						"h": 160,
						"w": 411
					}
				],
				"ball": {
					"n": 0,
					"h": 258,
					"w": 222,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 5
		},
		{
			"num": 1510,
			"minute": 73,
			"messages": [
				{
					"owner": 2,
					"mes": "Мирослав Манолов[27](Опава) пасует Н.Томпсону[38](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 706
					},
					{
						"n": 2,
						"h": 371,
						"w": 401
					},
					{
						"n": 14,
						"h": 276,
						"w": 418
					},
					{
						"n": 13,
						"h": 183,
						"w": 434
					},
					{
						"n": 5,
						"h": 87,
						"w": 407
					},
					{
						"n": 6,
						"h": 374,
						"w": 173
					},
					{
						"n": 18,
						"h": 270,
						"w": 271
					},
					{
						"n": 15,
						"h": 177,
						"w": 250
					},
					{
						"n": 17,
						"h": 46,
						"w": 189
					},
					{
						"n": 20,
						"h": 270,
						"w": 182
					},
					{
						"n": 19,
						"h": 181,
						"w": 162
					}
				],
				"away": [
					{
						"n": 1,
						"h": 226,
						"w": 695
					},
					{
						"n": 13,
						"h": 393,
						"w": 559
					},
					{
						"n": 3,
						"h": 273,
						"w": 623
					},
					{
						"n": 14,
						"h": 177,
						"w": 605
					},
					{
						"n": 5,
						"h": 68,
						"w": 591
					},
					{
						"n": 6,
						"h": 245,
						"w": 535
					},
					{
						"n": 7,
						"h": 196,
						"w": 488,
						"m": 550
					},
					{
						"n": 18,
						"h": 84,
						"w": 544
					},
					{
						"n": 17,
						"h": 406,
						"w": 422
					},
					{
						"n": 19,
						"h": 285,
						"w": 373
					},
					{
						"n": 20,
						"h": 160,
						"w": 369
					}
				],
				"ball": {
					"n": 0,
					"h": 366,
					"w": 176,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 42
		},
		{
			"num": 1511,
			"minute": 73,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 709
					},
					{
						"n": 2,
						"h": 346,
						"w": 432
					},
					{
						"n": 14,
						"h": 284,
						"w": 456
					},
					{
						"n": 13,
						"h": 165,
						"w": 456
					},
					{
						"n": 5,
						"h": 108,
						"w": 441
					},
					{
						"n": 6,
						"h": 363,
						"w": 212
					},
					{
						"n": 18,
						"h": 277,
						"w": 311
					},
					{
						"n": 15,
						"h": 187,
						"w": 288
					},
					{
						"n": 17,
						"h": 48,
						"w": 229
					},
					{
						"n": 20,
						"h": 245,
						"w": 214
					},
					{
						"n": 19,
						"h": 177,
						"w": 202
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 703
					},
					{
						"n": 13,
						"h": 400,
						"w": 520
					},
					{
						"n": 3,
						"h": 274,
						"w": 620
					},
					{
						"n": 14,
						"h": 178,
						"w": 594
					},
					{
						"n": 5,
						"h": 66,
						"w": 613
					},
					{
						"n": 6,
						"h": 207,
						"w": 523
					},
					{
						"n": 7,
						"h": 196,
						"w": 448
					},
					{
						"n": 18,
						"h": 83,
						"w": 509
					},
					{
						"n": 17,
						"h": 399,
						"w": 382
					},
					{
						"n": 19,
						"h": 296,
						"w": 335
					},
					{
						"n": 20,
						"h": 152,
						"w": 330
					}
				],
				"ball": {
					"n": 0,
					"h": 367,
					"w": 211,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1512,
			"minute": 73,
			"messages": [
				{
					"owner": 2,
					"mes": "Ньялл Томпсон[38](Опава) отдает передачу налево Н.Мансуру[23](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 707
					},
					{
						"n": 2,
						"h": 330,
						"w": 451
					},
					{
						"n": 14,
						"h": 276,
						"w": 451
					},
					{
						"n": 13,
						"h": 173,
						"w": 440
					},
					{
						"n": 5,
						"h": 83,
						"w": 407
					},
					{
						"n": 6,
						"h": 380,
						"w": 258
					},
					{
						"n": 18,
						"h": 271,
						"w": 360
					},
					{
						"n": 15,
						"h": 179,
						"w": 337
					},
					{
						"n": 17,
						"h": 46,
						"w": 278
					},
					{
						"n": 20,
						"h": 270,
						"w": 257
					},
					{
						"n": 19,
						"h": 158,
						"w": 247
					}
				],
				"away": [
					{
						"n": 1,
						"h": 224,
						"w": 710
					},
					{
						"n": 13,
						"h": 406,
						"w": 471
					},
					{
						"n": 3,
						"h": 254,
						"w": 602
					},
					{
						"n": 14,
						"h": 172,
						"w": 591
					},
					{
						"n": 5,
						"h": 60,
						"w": 611
					},
					{
						"n": 6,
						"h": 231,
						"w": 482
					},
					{
						"n": 7,
						"h": 218,
						"w": 404
					},
					{
						"n": 18,
						"h": 79,
						"w": 499
					},
					{
						"n": 17,
						"h": 397,
						"w": 333
					},
					{
						"n": 19,
						"h": 296,
						"w": 298
					},
					{
						"n": 20,
						"h": 160,
						"w": 297
					}
				],
				"ball": {
					"n": 0,
					"h": 196,
					"w": 118,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 49
		},
		{
			"num": 1513,
			"minute": 73,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 703
					},
					{
						"n": 2,
						"h": 330,
						"w": 462
					},
					{
						"n": 14,
						"h": 265,
						"w": 456
					},
					{
						"n": 13,
						"h": 177,
						"w": 473
					},
					{
						"n": 5,
						"h": 70,
						"w": 440
					},
					{
						"n": 6,
						"h": 395,
						"w": 295
					},
					{
						"n": 18,
						"h": 240,
						"w": 384
					},
					{
						"n": 15,
						"h": 189,
						"w": 353
					},
					{
						"n": 17,
						"h": 51,
						"w": 317
					},
					{
						"n": 20,
						"h": 282,
						"w": 294
					},
					{
						"n": 19,
						"h": 136,
						"w": 280
					}
				],
				"away": [
					{
						"n": 1,
						"h": 223,
						"w": 709
					},
					{
						"n": 13,
						"h": 398,
						"w": 445
					},
					{
						"n": 3,
						"h": 267,
						"w": 570
					},
					{
						"n": 14,
						"h": 171,
						"w": 600
					},
					{
						"n": 5,
						"h": 56,
						"w": 580
					},
					{
						"n": 6,
						"h": 227,
						"w": 484
					},
					{
						"n": 7,
						"h": 223,
						"w": 373
					},
					{
						"n": 18,
						"h": 74,
						"w": 460
					},
					{
						"n": 17,
						"h": 410,
						"w": 300
					},
					{
						"n": 19,
						"h": 288,
						"w": 284
					},
					{
						"n": 20,
						"h": 169,
						"w": 279
					}
				],
				"ball": {
					"n": 0,
					"h": 183,
					"w": 150,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1514,
			"minute": 73,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 701
					},
					{
						"n": 2,
						"h": 330,
						"w": 465
					},
					{
						"n": 14,
						"h": 283,
						"w": 470
					},
					{
						"n": 13,
						"h": 167,
						"w": 457
					},
					{
						"n": 5,
						"h": 64,
						"w": 466
					},
					{
						"n": 6,
						"h": 406,
						"w": 333
					},
					{
						"n": 18,
						"h": 266,
						"w": 397
					},
					{
						"n": 15,
						"h": 214,
						"w": 368
					},
					{
						"n": 17,
						"h": 35,
						"w": 354
					},
					{
						"n": 20,
						"h": 307,
						"w": 291
					},
					{
						"n": 19,
						"h": 164,
						"w": 308
					}
				],
				"away": [
					{
						"n": 1,
						"h": 227,
						"w": 708
					},
					{
						"n": 13,
						"h": 400,
						"w": 449
					},
					{
						"n": 3,
						"h": 266,
						"w": 534
					},
					{
						"n": 14,
						"h": 161,
						"w": 604
					},
					{
						"n": 5,
						"h": 56,
						"w": 577
					},
					{
						"n": 6,
						"h": 218,
						"w": 482
					},
					{
						"n": 7,
						"h": 234,
						"w": 335
					},
					{
						"n": 18,
						"h": 68,
						"w": 420
					},
					{
						"n": 17,
						"h": 402,
						"w": 266
					},
					{
						"n": 19,
						"h": 308,
						"w": 269
					},
					{
						"n": 20,
						"h": 149,
						"w": 269
					}
				],
				"ball": {
					"n": 0,
					"h": 184,
					"w": 186,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1515,
			"minute": 73,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 709
					},
					{
						"n": 2,
						"h": 330,
						"w": 500
					},
					{
						"n": 14,
						"h": 252,
						"w": 495
					},
					{
						"n": 13,
						"h": 165,
						"w": 497
					},
					{
						"n": 5,
						"h": 97,
						"w": 476
					},
					{
						"n": 6,
						"h": 390,
						"w": 370
					},
					{
						"n": 18,
						"h": 243,
						"w": 430
					},
					{
						"n": 15,
						"h": 176,
						"w": 379
					},
					{
						"n": 17,
						"h": 37,
						"w": 391
					},
					{
						"n": 20,
						"h": 286,
						"w": 325
					},
					{
						"n": 19,
						"h": 144,
						"w": 311
					}
				],
				"away": [
					{
						"n": 1,
						"h": 220,
						"w": 702
					},
					{
						"n": 13,
						"h": 408,
						"w": 410
					},
					{
						"n": 3,
						"h": 265,
						"w": 499
					},
					{
						"n": 14,
						"h": 184,
						"w": 559
					},
					{
						"n": 5,
						"h": 73,
						"w": 570
					},
					{
						"n": 6,
						"h": 228,
						"w": 443
					},
					{
						"n": 7,
						"h": 216,
						"w": 299
					},
					{
						"n": 18,
						"h": 61,
						"w": 381
					},
					{
						"n": 17,
						"h": 362,
						"w": 264
					},
					{
						"n": 19,
						"h": 328,
						"w": 261
					},
					{
						"n": 20,
						"h": 169,
						"w": 262
					}
				],
				"ball": {
					"n": 0,
					"h": 185,
					"w": 221,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1516,
			"minute": 73,
			"messages": [
				{
					"owner": 2,
					"mes": "Нир Мансур[23](Опава) подключает к атаке О.Дюмона[26](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 707
					},
					{
						"n": 2,
						"h": 330,
						"w": 530
					},
					{
						"n": 14,
						"h": 256,
						"w": 518
					},
					{
						"n": 13,
						"h": 171,
						"w": 518
					},
					{
						"n": 5,
						"h": 87,
						"w": 490
					},
					{
						"n": 6,
						"h": 391,
						"w": 404
					},
					{
						"n": 18,
						"h": 237,
						"w": 447
					},
					{
						"n": 15,
						"h": 187,
						"w": 412
					},
					{
						"n": 17,
						"h": 46,
						"w": 401
					},
					{
						"n": 20,
						"h": 257,
						"w": 326
					},
					{
						"n": 19,
						"h": 152,
						"w": 344
					}
				],
				"away": [
					{
						"n": 1,
						"h": 222,
						"w": 686
					},
					{
						"n": 13,
						"h": 391,
						"w": 382
					},
					{
						"n": 3,
						"h": 265,
						"w": 499,
						"m": 680
					},
					{
						"n": 14,
						"h": 182,
						"w": 552
					},
					{
						"n": 5,
						"h": 63,
						"w": 538
					},
					{
						"n": 6,
						"h": 208,
						"w": 413
					},
					{
						"n": 7,
						"h": 217,
						"w": 327
					},
					{
						"n": 18,
						"h": 59,
						"w": 347
					},
					{
						"n": 17,
						"h": 393,
						"w": 250
					},
					{
						"n": 19,
						"h": 303,
						"w": 238
					},
					{
						"n": 20,
						"h": 174,
						"w": 228
					}
				],
				"ball": {
					"n": 0,
					"h": 242,
					"w": 307,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 34
		},
		{
			"num": 1517,
			"minute": 73,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 710
					},
					{
						"n": 2,
						"h": 330,
						"w": 556
					},
					{
						"n": 14,
						"h": 261,
						"w": 554
					},
					{
						"n": 13,
						"h": 173,
						"w": 554
					},
					{
						"n": 5,
						"h": 79,
						"w": 529
					},
					{
						"n": 6,
						"h": 393,
						"w": 444
					},
					{
						"n": 18,
						"h": 231,
						"w": 476
					},
					{
						"n": 15,
						"h": 152,
						"w": 432
					},
					{
						"n": 17,
						"h": 50,
						"w": 421
					},
					{
						"n": 20,
						"h": 223,
						"w": 348
					},
					{
						"n": 19,
						"h": 160,
						"w": 383
					}
				],
				"away": [
					{
						"n": 1,
						"h": 223,
						"w": 668
					},
					{
						"n": 13,
						"h": 398,
						"w": 343
					},
					{
						"n": 3,
						"h": 269,
						"w": 528
					},
					{
						"n": 14,
						"h": 164,
						"w": 527
					},
					{
						"n": 5,
						"h": 70,
						"w": 516
					},
					{
						"n": 6,
						"h": 233,
						"w": 388
					},
					{
						"n": 7,
						"h": 222,
						"w": 288
					},
					{
						"n": 18,
						"h": 56,
						"w": 307
					},
					{
						"n": 17,
						"h": 401,
						"w": 211
					},
					{
						"n": 19,
						"h": 323,
						"w": 210
					},
					{
						"n": 20,
						"h": 158,
						"w": 192
					}
				],
				"ball": {
					"n": 0,
					"h": 217,
					"w": 332,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1518,
			"minute": 73,
			"messages": [
				{
					"owner": 2,
					"mes": "Оливье Дюмон[26](Опава) смотрит направо... Пас Н.Томпсону[38](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 708
					},
					{
						"n": 2,
						"h": 357,
						"w": 576
					},
					{
						"n": 14,
						"h": 267,
						"w": 582
					},
					{
						"n": 13,
						"h": 176,
						"w": 574
					},
					{
						"n": 5,
						"h": 103,
						"w": 562
					},
					{
						"n": 6,
						"h": 362,
						"w": 416
					},
					{
						"n": 18,
						"h": 286,
						"w": 485
					},
					{
						"n": 15,
						"h": 199,
						"w": 462
					},
					{
						"n": 17,
						"h": 56,
						"w": 425
					},
					{
						"n": 20,
						"h": 241,
						"w": 343
					},
					{
						"n": 19,
						"h": 158,
						"w": 418
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 647
					},
					{
						"n": 13,
						"h": 407,
						"w": 330
					},
					{
						"n": 3,
						"h": 284,
						"w": 484
					},
					{
						"n": 14,
						"h": 168,
						"w": 499
					},
					{
						"n": 5,
						"h": 68,
						"w": 471
					},
					{
						"n": 6,
						"h": 209,
						"w": 397
					},
					{
						"n": 7,
						"h": 192,
						"w": 288
					},
					{
						"n": 18,
						"h": 88,
						"w": 304
					},
					{
						"n": 17,
						"h": 356,
						"w": 178
					},
					{
						"n": 19,
						"h": 294,
						"w": 162
					},
					{
						"n": 20,
						"h": 163,
						"w": 174
					}
				],
				"ball": {
					"n": 0,
					"h": 362,
					"w": 416,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 56
		},
		{
			"num": 1519,
			"minute": 73,
			"messages": [
				{
					"owner": 2,
					"mes": "Ньялл Томпсон[38](Опава) пробрасывает мяч..."
				},
				{
					"owner": 2,
					"mes": "Явный толчок со стороны К.Колмана[06](Галвэй Юнайтед)... Ньялл Томпсон[38](Опава) падает на газон..."
				}
			],
			"L": {
				"team": 1
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 708
					},
					{
						"n": 2,
						"h": 357,
						"w": 576
					},
					{
						"n": 14,
						"h": 267,
						"w": 582
					},
					{
						"n": 13,
						"h": 176,
						"w": 574
					},
					{
						"n": 5,
						"h": 103,
						"w": 562
					},
					{
						"n": 6,
						"h": 362,
						"w": 416
					},
					{
						"n": 18,
						"h": 286,
						"w": 485
					},
					{
						"n": 15,
						"h": 199,
						"w": 462
					},
					{
						"n": 17,
						"h": 56,
						"w": 425
					},
					{
						"n": 20,
						"h": 241,
						"w": 343
					},
					{
						"n": 19,
						"h": 158,
						"w": 418
					}
				],
				"away": [
					{
						"n": 1,
						"h": 230,
						"w": 647
					},
					{
						"n": 13,
						"h": 407,
						"w": 330
					},
					{
						"n": 3,
						"h": 284,
						"w": 484
					},
					{
						"n": 14,
						"h": 168,
						"w": 499
					},
					{
						"n": 5,
						"h": 68,
						"w": 471
					},
					{
						"n": 6,
						"h": 209,
						"w": 397
					},
					{
						"n": 7,
						"h": 192,
						"w": 288
					},
					{
						"n": 18,
						"h": 88,
						"w": 304,
						"m": 630
					},
					{
						"n": 17,
						"h": 356,
						"w": 178
					},
					{
						"n": 19,
						"h": 294,
						"w": 162
					},
					{
						"n": 20,
						"h": 163,
						"w": 174
					}
				],
				"ball": {
					"n": 0,
					"h": 362,
					"w": 416,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 5
		},
		{
			"num": 1520,
			"minute": 74,
			"possession": 43,
			"messages": [
				{
					"owner": 2,
					"mes": "В команде Опава замена:"
				}
			],
			"K": {
				"team": 2,
				"player": 7,
				"player2": 19
			},
			"S": {
				"team": 2,
				"out": 1,
				"in": 12
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 710,
						"f": 91
					},
					{
						"n": 2,
						"h": 365,
						"w": 592,
						"f": 79,
						"c": 3
					},
					{
						"n": 14,
						"h": 286,
						"w": 587
					},
					{
						"n": 13,
						"h": 158,
						"w": 584,
						"f": 95
					},
					{
						"n": 5,
						"h": 88,
						"w": 576
					},
					{
						"n": 6,
						"h": 361,
						"w": 467,
						"f": 78
					},
					{
						"n": 18,
						"h": 297,
						"w": 472,
						"f": 95,
						"m": 610
					},
					{
						"n": 15,
						"h": 180,
						"w": 465
					},
					{
						"n": 17,
						"h": 67,
						"w": 442
					},
					{
						"n": 20,
						"h": 261,
						"w": 346,
						"f": 87
					},
					{
						"n": 19,
						"h": 157,
						"w": 398
					}
				],
				"away": [
					{
						"n": 1,
						"h": 248,
						"w": 647
					},
					{
						"n": 13,
						"h": 402,
						"w": 349
					},
					{
						"n": 3,
						"h": 298,
						"w": 498
					},
					{
						"n": 14,
						"h": 151,
						"w": 509
					},
					{
						"n": 5,
						"h": 73,
						"w": 490
					},
					{
						"n": 6,
						"h": 249,
						"w": 397
					},
					{
						"n": 7,
						"h": 231,
						"w": 298,
						"f": 81
					},
					{
						"n": 18,
						"h": 89,
						"w": 312
					},
					{
						"n": 17,
						"h": 358,
						"w": 197
					},
					{
						"n": 19,
						"h": 296,
						"w": 182
					},
					{
						"n": 20,
						"h": 159,
						"w": 194
					},
					{
						"n": 12,
						"h": 451,
						"w": 358
					},
					{
						"n": 15,
						"h": 460,
						"w": 320
					},
					{
						"n": 16,
						"h": 460,
						"w": 300
					}
				],
				"ball": {
					"n": 0,
					"h": 362,
					"w": 416,
					"z": 0,
					"r": 2,
					"p": 0,
					"x": 0
				}
			},
			"interval": 20
		},
		{
			"num": 1521,
			"minute": 74,
			"messages": [
				{
					"owner": 2,
					"mes": "Тим Крамарж[32](Опава) входит в игру вместо К.Ласака[21](Опава)."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 710
					},
					{
						"n": 2,
						"h": 365,
						"w": 592
					},
					{
						"n": 14,
						"h": 309,
						"w": 592
					},
					{
						"n": 13,
						"h": 145,
						"w": 592
					},
					{
						"n": 5,
						"h": 70,
						"w": 592
					},
					{
						"n": 6,
						"h": 369,
						"w": 472
					},
					{
						"n": 18,
						"h": 297,
						"w": 472
					},
					{
						"n": 15,
						"h": 140,
						"w": 472
					},
					{
						"n": 17,
						"h": 85,
						"w": 472
					},
					{
						"n": 20,
						"h": 309,
						"w": 352
					},
					{
						"n": 19,
						"h": 156,
						"w": 352
					}
				],
				"away": [
					{
						"n": 1,
						"h": 450,
						"w": 360
					},
					{
						"n": 13,
						"h": 373,
						"w": 449
					},
					{
						"n": 3,
						"h": 309,
						"w": 509
					},
					{
						"n": 14,
						"h": 150,
						"w": 509
					},
					{
						"n": 5,
						"h": 78,
						"w": 509
					},
					{
						"n": 6,
						"h": 435,
						"w": 398
					},
					{
						"n": 7,
						"h": 437,
						"w": 350
					},
					{
						"n": 18,
						"h": 89,
						"w": 312
					},
					{
						"n": 17,
						"h": 371,
						"w": 329
					},
					{
						"n": 19,
						"h": 302,
						"w": 269
					},
					{
						"n": 20,
						"h": 146,
						"w": 269
					},
					{
						"n": 12,
						"h": 450,
						"w": 360
					},
					{
						"n": 15,
						"h": 460,
						"w": 320
					},
					{
						"n": 16,
						"h": 460,
						"w": 300
					}
				],
				"ball": {
					"n": 0,
					"h": 362,
					"w": 416,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 176
		},
		{
			"num": 1522,
			"minute": 74,
			"possession": 43,
			"messages": [
				{
					"owner": 2,
					"mes": "Опава производит замену:"
				}
			],
			"S": {
				"team": 2,
				"out": 7,
				"in": 15
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 710
					},
					{
						"n": 2,
						"h": 365,
						"w": 592
					},
					{
						"n": 14,
						"h": 309,
						"w": 592
					},
					{
						"n": 13,
						"h": 145,
						"w": 592
					},
					{
						"n": 5,
						"h": 70,
						"w": 592
					},
					{
						"n": 6,
						"h": 369,
						"w": 472
					},
					{
						"n": 18,
						"h": 297,
						"w": 472
					},
					{
						"n": 15,
						"h": 140,
						"w": 472
					},
					{
						"n": 17,
						"h": 85,
						"w": 472
					},
					{
						"n": 20,
						"h": 309,
						"w": 352
					},
					{
						"n": 19,
						"h": 156,
						"w": 352
					}
				],
				"away": [
					{
						"n": 12,
						"h": 427,
						"w": 394,
						"f": 95,
						"m": 600,
						"c": 0
					},
					{
						"n": 13,
						"h": 373,
						"w": 449
					},
					{
						"n": 3,
						"h": 309,
						"w": 509
					},
					{
						"n": 14,
						"h": 150,
						"w": 509
					},
					{
						"n": 5,
						"h": 78,
						"w": 509
					},
					{
						"n": 6,
						"h": 435,
						"w": 398
					},
					{
						"n": 7,
						"h": 450,
						"w": 360
					},
					{
						"n": 18,
						"h": 89,
						"w": 312
					},
					{
						"n": 17,
						"h": 371,
						"w": 329
					},
					{
						"n": 19,
						"h": 302,
						"w": 269
					},
					{
						"n": 20,
						"h": 146,
						"w": 269
					},
					{
						"n": 15,
						"h": 450,
						"w": 360
					},
					{
						"n": 16,
						"h": 460,
						"w": 300
					}
				],
				"ball": {
					"n": 0,
					"h": 362,
					"w": 416,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 41
		},
		{
			"num": 1523,
			"minute": 74,
			"messages": [
				{
					"owner": 2,
					"mes": "Мирослав Манолов[27](Опава) покидает поле, его меняет Адам Карабец[35](Опава)."
				},
				{
					"owner": 2,
					"mes": "И занимает позицию под нападающими."
				}
			],
			"ZT": {
				"team": 2,
				"positions": [
					1,
					8,
					4,
					6,
					7,
					10,
					20,
					17,
					18,
					23,
					25
				],
				"text": ""
			}
		},
		{
			"num": 1524,
			"minute": 74,
			"possession": 43,
			"messages": [
				{
					"owner": 2,
					"mes": "Опава собирается внести в игру коррективы:"
				}
			],
			"S": {
				"team": 2,
				"out": 6,
				"in": 16
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 710
					},
					{
						"n": 2,
						"h": 365,
						"w": 592
					},
					{
						"n": 14,
						"h": 309,
						"w": 592
					},
					{
						"n": 13,
						"h": 145,
						"w": 592
					},
					{
						"n": 5,
						"h": 70,
						"w": 592
					},
					{
						"n": 6,
						"h": 369,
						"w": 472
					},
					{
						"n": 18,
						"h": 297,
						"w": 472
					},
					{
						"n": 15,
						"h": 140,
						"w": 472
					},
					{
						"n": 17,
						"h": 85,
						"w": 472
					},
					{
						"n": 20,
						"h": 309,
						"w": 352
					},
					{
						"n": 19,
						"h": 156,
						"w": 352
					}
				],
				"away": [
					{
						"n": 12,
						"h": 393,
						"w": 444
					},
					{
						"n": 13,
						"h": 373,
						"w": 449
					},
					{
						"n": 3,
						"h": 309,
						"w": 509
					},
					{
						"n": 14,
						"h": 150,
						"w": 509
					},
					{
						"n": 5,
						"h": 78,
						"w": 509
					},
					{
						"n": 6,
						"h": 450,
						"w": 360
					},
					{
						"n": 15,
						"h": 390,
						"w": 352,
						"f": 98,
						"m": 600,
						"c": 0
					},
					{
						"n": 18,
						"h": 89,
						"w": 312
					},
					{
						"n": 17,
						"h": 371,
						"w": 329
					},
					{
						"n": 19,
						"h": 302,
						"w": 269
					},
					{
						"n": 20,
						"h": 146,
						"w": 269
					},
					{
						"n": 16,
						"h": 450,
						"w": 360
					}
				],
				"ball": {
					"n": 0,
					"h": 362,
					"w": 416,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 61
		},
		{
			"num": 1525,
			"minute": 74,
			"messages": [
				{
					"owner": 2,
					"mes": "Оливье Дюмон[26](Опава) уходит с поля... Михаэль Владарж[36](Опава) в игре."
				},
				{
					"owner": 2,
					"mes": "И занимает место центрального хавбека."
				},
				{
					"owner": 2,
					"mes": "Александр Фрешль[39](Опава) получает капитанскую повязку."
				}
			],
			"ZT": {
				"team": 2,
				"positions": [
					1,
					8,
					4,
					6,
					7,
					15,
					20,
					17,
					18,
					23,
					25
				],
				"text": ""
			}
		},
		{
			"num": 1526,
			"minute": 74,
			"possession": 43,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 710
					},
					{
						"n": 2,
						"h": 365,
						"w": 592
					},
					{
						"n": 14,
						"h": 309,
						"w": 592
					},
					{
						"n": 13,
						"h": 145,
						"w": 592
					},
					{
						"n": 5,
						"h": 70,
						"w": 592
					},
					{
						"n": 6,
						"h": 369,
						"w": 472
					},
					{
						"n": 18,
						"h": 297,
						"w": 472
					},
					{
						"n": 15,
						"h": 140,
						"w": 472
					},
					{
						"n": 17,
						"h": 85,
						"w": 472
					},
					{
						"n": 20,
						"h": 309,
						"w": 352
					},
					{
						"n": 19,
						"h": 156,
						"w": 352
					}
				],
				"away": [
					{
						"n": 12,
						"h": 331,
						"w": 535
					},
					{
						"n": 13,
						"h": 373,
						"w": 449
					},
					{
						"n": 3,
						"h": 309,
						"w": 509
					},
					{
						"n": 14,
						"h": 150,
						"w": 509
					},
					{
						"n": 5,
						"h": 78,
						"w": 509
					},
					{
						"n": 16,
						"h": 341,
						"w": 375,
						"f": 96,
						"m": 600,
						"c": 0
					},
					{
						"n": 15,
						"h": 281,
						"w": 337
					},
					{
						"n": 18,
						"h": 89,
						"w": 312
					},
					{
						"n": 17,
						"h": 371,
						"w": 329
					},
					{
						"n": 19,
						"h": 302,
						"w": 269
					},
					{
						"n": 20,
						"h": 146,
						"w": 269
					}
				],
				"ball": {
					"n": 0,
					"h": 362,
					"w": 416,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 110
		},
		{
			"num": 1527,
			"minute": 74,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 710
					},
					{
						"n": 2,
						"h": 365,
						"w": 592
					},
					{
						"n": 14,
						"h": 309,
						"w": 592
					},
					{
						"n": 13,
						"h": 145,
						"w": 592
					},
					{
						"n": 5,
						"h": 70,
						"w": 592
					},
					{
						"n": 6,
						"h": 369,
						"w": 472
					},
					{
						"n": 18,
						"h": 297,
						"w": 472
					},
					{
						"n": 15,
						"h": 140,
						"w": 472
					},
					{
						"n": 17,
						"h": 85,
						"w": 472
					},
					{
						"n": 20,
						"h": 309,
						"w": 352
					},
					{
						"n": 19,
						"h": 156,
						"w": 352
					}
				],
				"away": [
					{
						"n": 12,
						"h": 236,
						"w": 673
					},
					{
						"n": 13,
						"h": 373,
						"w": 449
					},
					{
						"n": 3,
						"h": 309,
						"w": 509
					},
					{
						"n": 14,
						"h": 150,
						"w": 509
					},
					{
						"n": 5,
						"h": 78,
						"w": 509
					},
					{
						"n": 16,
						"h": 232,
						"w": 389
					},
					{
						"n": 15,
						"h": 221,
						"w": 329
					},
					{
						"n": 18,
						"h": 89,
						"w": 312
					},
					{
						"n": 17,
						"h": 371,
						"w": 329
					},
					{
						"n": 19,
						"h": 302,
						"w": 269
					},
					{
						"n": 20,
						"h": 146,
						"w": 269
					}
				],
				"ball": {
					"n": 0,
					"h": 362,
					"w": 416,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 167
		},
		{
			"num": 1528,
			"minute": 74,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 710
					},
					{
						"n": 2,
						"h": 365,
						"w": 592
					},
					{
						"n": 14,
						"h": 309,
						"w": 592
					},
					{
						"n": 13,
						"h": 145,
						"w": 592
					},
					{
						"n": 5,
						"h": 70,
						"w": 592
					},
					{
						"n": 6,
						"h": 369,
						"w": 472
					},
					{
						"n": 18,
						"h": 297,
						"w": 472
					},
					{
						"n": 15,
						"h": 140,
						"w": 472
					},
					{
						"n": 17,
						"h": 85,
						"w": 472
					},
					{
						"n": 20,
						"h": 309,
						"w": 352
					},
					{
						"n": 19,
						"h": 156,
						"w": 352
					}
				],
				"away": [
					{
						"n": 12,
						"h": 236,
						"w": 673
					},
					{
						"n": 13,
						"h": 373,
						"w": 449
					},
					{
						"n": 3,
						"h": 309,
						"w": 509
					},
					{
						"n": 14,
						"h": 150,
						"w": 509
					},
					{
						"n": 5,
						"h": 78,
						"w": 509
					},
					{
						"n": 16,
						"h": 232,
						"w": 389
					},
					{
						"n": 15,
						"h": 221,
						"w": 329
					},
					{
						"n": 18,
						"h": 89,
						"w": 312
					},
					{
						"n": 17,
						"h": 371,
						"w": 329
					},
					{
						"n": 19,
						"h": 302,
						"w": 269
					},
					{
						"n": 20,
						"h": 146,
						"w": 269
					}
				],
				"ball": {
					"n": 0,
					"h": 362,
					"w": 416,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 100
		},
		{
			"num": 1529,
			"minute": 74,
			"messages": [
				{
					"owner": 2,
					"mes": "Штрафной удар в пользу команды Опава..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 700
					},
					{
						"n": 2,
						"h": 361,
						"w": 595
					},
					{
						"n": 14,
						"h": 312,
						"w": 594
					},
					{
						"n": 13,
						"h": 148,
						"w": 585
					},
					{
						"n": 5,
						"h": 72,
						"w": 598
					},
					{
						"n": 6,
						"h": 362,
						"w": 475
					},
					{
						"n": 18,
						"h": 302,
						"w": 471
					},
					{
						"n": 15,
						"h": 137,
						"w": 468
					},
					{
						"n": 17,
						"h": 84,
						"w": 470
					},
					{
						"n": 20,
						"h": 312,
						"w": 357
					},
					{
						"n": 19,
						"h": 150,
						"w": 355
					}
				],
				"away": [
					{
						"n": 12,
						"h": 222,
						"w": 675
					},
					{
						"n": 13,
						"h": 376,
						"w": 442
					},
					{
						"n": 3,
						"h": 308,
						"w": 508
					},
					{
						"n": 14,
						"h": 156,
						"w": 506
					},
					{
						"n": 5,
						"h": 81,
						"w": 504
					},
					{
						"n": 16,
						"h": 229,
						"w": 393
					},
					{
						"n": 15,
						"h": 217,
						"w": 322
					},
					{
						"n": 18,
						"h": 88,
						"w": 304
					},
					{
						"n": 17,
						"h": 374,
						"w": 327
					},
					{
						"n": 19,
						"h": 302,
						"w": 269
					},
					{
						"n": 20,
						"h": 149,
						"w": 268
					}
				],
				"ball": {
					"n": 0,
					"h": 362,
					"w": 416,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 15
		},
		{
			"num": 1530,
			"minute": 74,
			"messages": [
				{
					"owner": 2,
					"mes": "Мяч разыгран..."
				},
				{
					"owner": 2,
					"mes": "Передача в центр..."
				},
				{
					"owner": 2,
					"mes": "Михаэль Владарж[36](Опава) получает передачу..."
				}
			],
			"F": {
				"team": 2
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 704
					},
					{
						"n": 2,
						"h": 330,
						"w": 605
					},
					{
						"n": 14,
						"h": 285,
						"w": 592
					},
					{
						"n": 13,
						"h": 177,
						"w": 591
					},
					{
						"n": 5,
						"h": 120,
						"w": 603
					},
					{
						"n": 6,
						"h": 366,
						"w": 460
					},
					{
						"n": 18,
						"h": 312,
						"w": 525
					},
					{
						"n": 15,
						"h": 140,
						"w": 508
					},
					{
						"n": 17,
						"h": 59,
						"w": 481
					},
					{
						"n": 20,
						"h": 298,
						"w": 412
					},
					{
						"n": 19,
						"h": 197,
						"w": 386
					}
				],
				"away": [
					{
						"n": 12,
						"h": 227,
						"w": 650
					},
					{
						"n": 13,
						"h": 390,
						"w": 388
					},
					{
						"n": 3,
						"h": 286,
						"w": 460
					},
					{
						"n": 14,
						"h": 159,
						"w": 478
					},
					{
						"n": 5,
						"h": 73,
						"w": 475
					},
					{
						"n": 16,
						"h": 227,
						"w": 337
					},
					{
						"n": 15,
						"h": 217,
						"w": 266
					},
					{
						"n": 18,
						"h": 84,
						"w": 295,
						"m": 640
					},
					{
						"n": 17,
						"h": 391,
						"w": 274
					},
					{
						"n": 19,
						"h": 301,
						"w": 213
					},
					{
						"n": 20,
						"h": 147,
						"w": 212
					}
				],
				"ball": {
					"n": 0,
					"h": 223,
					"w": 383,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 56
		},
		{
			"num": 1531,
			"minute": 74,
			"messages": [
				{
					"owner": 2,
					"mes": "Михаэль Владарж[36](Опава) пасует на В.Сланину[34](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 710
					},
					{
						"n": 2,
						"h": 330,
						"w": 563
					},
					{
						"n": 14,
						"h": 274,
						"w": 551
					},
					{
						"n": 13,
						"h": 165,
						"w": 564
					},
					{
						"n": 5,
						"h": 120,
						"w": 565
					},
					{
						"n": 6,
						"h": 380,
						"w": 420
					},
					{
						"n": 18,
						"h": 291,
						"w": 510
					},
					{
						"n": 15,
						"h": 153,
						"w": 468
					},
					{
						"n": 17,
						"h": 56,
						"w": 440
					},
					{
						"n": 20,
						"h": 321,
						"w": 377
					},
					{
						"n": 19,
						"h": 155,
						"w": 379
					}
				],
				"away": [
					{
						"n": 12,
						"h": 226,
						"w": 671
					},
					{
						"n": 13,
						"h": 394,
						"w": 430
					},
					{
						"n": 3,
						"h": 285,
						"w": 502
					},
					{
						"n": 14,
						"h": 176,
						"w": 453
					},
					{
						"n": 5,
						"h": 65,
						"w": 517
					},
					{
						"n": 16,
						"h": 227,
						"w": 347
					},
					{
						"n": 15,
						"h": 218,
						"w": 308
					},
					{
						"n": 18,
						"h": 70,
						"w": 335
					},
					{
						"n": 17,
						"h": 402,
						"w": 315
					},
					{
						"n": 19,
						"h": 298,
						"w": 220
					},
					{
						"n": 20,
						"h": 164,
						"w": 220
					}
				],
				"ball": {
					"n": 0,
					"h": 274,
					"w": 267,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 42
		},
		{
			"num": 1532,
			"minute": 75,
			"possession": 43,
			"messages": [
				{
					"owner": 2,
					"mes": "Вацлав Сланина[34](Опава) отдает на Н.Мансура[23](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 704
					},
					{
						"n": 2,
						"h": 330,
						"w": 560
					},
					{
						"n": 14,
						"h": 285,
						"w": 567,
						"f": 96
					},
					{
						"n": 13,
						"h": 168,
						"w": 573
					},
					{
						"n": 5,
						"h": 120,
						"w": 569,
						"f": 79,
						"c": 3
					},
					{
						"n": 6,
						"h": 394,
						"w": 397
					},
					{
						"n": 18,
						"h": 288,
						"w": 489
					},
					{
						"n": 15,
						"h": 143,
						"w": 466
					},
					{
						"n": 17,
						"h": 56,
						"w": 463
					},
					{
						"n": 20,
						"h": 316,
						"w": 375
					},
					{
						"n": 19,
						"h": 158,
						"w": 405
					}
				],
				"away": [
					{
						"n": 12,
						"h": 225,
						"w": 647
					},
					{
						"n": 13,
						"h": 402,
						"w": 435,
						"f": 90
					},
					{
						"n": 3,
						"h": 263,
						"w": 477
					},
					{
						"n": 14,
						"h": 175,
						"w": 463,
						"f": 88,
						"m": 650
					},
					{
						"n": 5,
						"h": 41,
						"w": 493
					},
					{
						"n": 16,
						"h": 223,
						"w": 363
					},
					{
						"n": 15,
						"h": 226,
						"w": 292
					},
					{
						"n": 18,
						"h": 46,
						"w": 358
					},
					{
						"n": 17,
						"h": 403,
						"w": 292,
						"f": 89,
						"m": 650,
						"c": 1
					},
					{
						"n": 19,
						"h": 298,
						"w": 220
					},
					{
						"n": 20,
						"h": 154,
						"w": 220
					}
				],
				"ball": {
					"n": 0,
					"h": 187,
					"w": 243,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 34
		},
		{
			"num": 1533,
			"minute": 75,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 707
					},
					{
						"n": 2,
						"h": 330,
						"w": 563
					},
					{
						"n": 14,
						"h": 272,
						"w": 555
					},
					{
						"n": 13,
						"h": 191,
						"w": 573
					},
					{
						"n": 5,
						"h": 120,
						"w": 553
					},
					{
						"n": 6,
						"h": 394,
						"w": 357
					},
					{
						"n": 18,
						"h": 292,
						"w": 503
					},
					{
						"n": 15,
						"h": 160,
						"w": 470
					},
					{
						"n": 17,
						"h": 56,
						"w": 424
					},
					{
						"n": 20,
						"h": 323,
						"w": 375
					},
					{
						"n": 19,
						"h": 162,
						"w": 365
					}
				],
				"away": [
					{
						"n": 12,
						"h": 226,
						"w": 687
					},
					{
						"n": 13,
						"h": 403,
						"w": 475
					},
					{
						"n": 3,
						"h": 280,
						"w": 446
					},
					{
						"n": 14,
						"h": 169,
						"w": 503
					},
					{
						"n": 5,
						"h": 39,
						"w": 533
					},
					{
						"n": 16,
						"h": 219,
						"w": 403
					},
					{
						"n": 15,
						"h": 225,
						"w": 331
					},
					{
						"n": 18,
						"h": 45,
						"w": 398
					},
					{
						"n": 17,
						"h": 399,
						"w": 331
					},
					{
						"n": 19,
						"h": 297,
						"w": 220
					},
					{
						"n": 20,
						"h": 148,
						"w": 220
					}
				],
				"ball": {
					"n": 0,
					"h": 170,
					"w": 274,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1534,
			"minute": 75,
			"messages": [
				{
					"owner": 2,
					"mes": "Пас направо на М.Владаржа[36](Опава)..."
				},
				{
					"owner": 2,
					"mes": "Михаэль Владарж[36](Опава) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 708
					},
					{
						"n": 2,
						"h": 330,
						"w": 560
					},
					{
						"n": 14,
						"h": 269,
						"w": 560
					},
					{
						"n": 13,
						"h": 173,
						"w": 574
					},
					{
						"n": 5,
						"h": 120,
						"w": 565
					},
					{
						"n": 6,
						"h": 394,
						"w": 364
					},
					{
						"n": 18,
						"h": 293,
						"w": 496
					},
					{
						"n": 15,
						"h": 155,
						"w": 473
					},
					{
						"n": 17,
						"h": 56,
						"w": 454
					},
					{
						"n": 20,
						"h": 298,
						"w": 393
					},
					{
						"n": 19,
						"h": 188,
						"w": 348
					}
				],
				"away": [
					{
						"n": 12,
						"h": 223,
						"w": 665
					},
					{
						"n": 13,
						"h": 406,
						"w": 447
					},
					{
						"n": 3,
						"h": 282,
						"w": 456
					},
					{
						"n": 14,
						"h": 151,
						"w": 523
					},
					{
						"n": 5,
						"h": 32,
						"w": 523
					},
					{
						"n": 16,
						"h": 227,
						"w": 415
					},
					{
						"n": 15,
						"h": 224,
						"w": 300
					},
					{
						"n": 18,
						"h": 36,
						"w": 371
					},
					{
						"n": 17,
						"h": 403,
						"w": 301
					},
					{
						"n": 19,
						"h": 297,
						"w": 220
					},
					{
						"n": 20,
						"h": 165,
						"w": 220
					}
				],
				"ball": {
					"n": 0,
					"h": 223,
					"w": 305,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 31
		},
		{
			"num": 1535,
			"minute": 75,
			"messages": [
				{
					"owner": 2,
					"mes": "Михаэль Владарж[36](Опава) отдает пас назад..."
				},
				{
					"owner": 2,
					"mes": "Вацлав Сланина[34](Опава) технично принимает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 707
					},
					{
						"n": 2,
						"h": 330,
						"w": 524
					},
					{
						"n": 14,
						"h": 274,
						"w": 524
					},
					{
						"n": 13,
						"h": 174,
						"w": 538
					},
					{
						"n": 5,
						"h": 120,
						"w": 529
					},
					{
						"n": 6,
						"h": 394,
						"w": 356
					},
					{
						"n": 18,
						"h": 289,
						"w": 460
					},
					{
						"n": 15,
						"h": 154,
						"w": 437
					},
					{
						"n": 17,
						"h": 56,
						"w": 422
					},
					{
						"n": 20,
						"h": 294,
						"w": 357
					},
					{
						"n": 19,
						"h": 158,
						"w": 328
					}
				],
				"away": [
					{
						"n": 12,
						"h": 220,
						"w": 649
					},
					{
						"n": 13,
						"h": 400,
						"w": 446
					},
					{
						"n": 3,
						"h": 288,
						"w": 491
					},
					{
						"n": 14,
						"h": 173,
						"w": 508
					},
					{
						"n": 5,
						"h": 35,
						"w": 487
					},
					{
						"n": 16,
						"h": 228,
						"w": 405,
						"m": 610
					},
					{
						"n": 15,
						"h": 219,
						"w": 313
					},
					{
						"n": 18,
						"h": 32,
						"w": 379
					},
					{
						"n": 17,
						"h": 408,
						"w": 313
					},
					{
						"n": 19,
						"h": 288,
						"w": 246
					},
					{
						"n": 20,
						"h": 160,
						"w": 246
					}
				],
				"ball": {
					"n": 0,
					"h": 277,
					"w": 212,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 36
		},
		{
			"num": 1536,
			"minute": 75,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 702
					},
					{
						"n": 2,
						"h": 330,
						"w": 549
					},
					{
						"n": 14,
						"h": 277,
						"w": 550
					},
					{
						"n": 13,
						"h": 163,
						"w": 556
					},
					{
						"n": 5,
						"h": 120,
						"w": 554
					},
					{
						"n": 6,
						"h": 393,
						"w": 396
					},
					{
						"n": 18,
						"h": 290,
						"w": 500
					},
					{
						"n": 15,
						"h": 182,
						"w": 434
					},
					{
						"n": 17,
						"h": 56,
						"w": 404
					},
					{
						"n": 20,
						"h": 287,
						"w": 396
					},
					{
						"n": 19,
						"h": 147,
						"w": 366
					}
				],
				"away": [
					{
						"n": 12,
						"h": 220,
						"w": 689
					},
					{
						"n": 13,
						"h": 404,
						"w": 486
					},
					{
						"n": 3,
						"h": 290,
						"w": 531
					},
					{
						"n": 14,
						"h": 159,
						"w": 476
					},
					{
						"n": 5,
						"h": 38,
						"w": 527
					},
					{
						"n": 16,
						"h": 228,
						"w": 442
					},
					{
						"n": 15,
						"h": 224,
						"w": 331
					},
					{
						"n": 18,
						"h": 42,
						"w": 418
					},
					{
						"n": 17,
						"h": 418,
						"w": 331
					},
					{
						"n": 19,
						"h": 299,
						"w": 220
					},
					{
						"n": 20,
						"h": 153,
						"w": 220
					}
				],
				"ball": {
					"n": 0,
					"h": 291,
					"w": 244,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1537,
			"minute": 75,
			"messages": [
				{
					"owner": 2,
					"mes": "Справа открывается Томаш Прохазка[25](Опава)... Передача..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 701
					},
					{
						"n": 2,
						"h": 330,
						"w": 514
					},
					{
						"n": 14,
						"h": 277,
						"w": 515
					},
					{
						"n": 13,
						"h": 169,
						"w": 522
					},
					{
						"n": 5,
						"h": 120,
						"w": 519
					},
					{
						"n": 6,
						"h": 392,
						"w": 361
					},
					{
						"n": 18,
						"h": 290,
						"w": 465
					},
					{
						"n": 15,
						"h": 162,
						"w": 405
					},
					{
						"n": 17,
						"h": 56,
						"w": 407
					},
					{
						"n": 20,
						"h": 264,
						"w": 370
					},
					{
						"n": 19,
						"h": 158,
						"w": 333
					}
				],
				"away": [
					{
						"n": 12,
						"h": 215,
						"w": 665
					},
					{
						"n": 13,
						"h": 409,
						"w": 457
					},
					{
						"n": 3,
						"h": 289,
						"w": 521
					},
					{
						"n": 14,
						"h": 160,
						"w": 486
					},
					{
						"n": 5,
						"h": 54,
						"w": 557
					},
					{
						"n": 16,
						"h": 219,
						"w": 409
					},
					{
						"n": 15,
						"h": 230,
						"w": 328
					},
					{
						"n": 18,
						"h": 43,
						"w": 393
					},
					{
						"n": 17,
						"h": 412,
						"w": 328
					},
					{
						"n": 19,
						"h": 291,
						"w": 254
					},
					{
						"n": 20,
						"h": 161,
						"w": 254
					}
				],
				"ball": {
					"n": 0,
					"h": 366,
					"w": 171,
					"z": 0,
					"r": 0,
					"p": 2,
					"x": 0
				}
			},
			"interval": 35
		},
		{
			"num": 1538,
			"minute": 75,
			"messages": [
				{
					"owner": 2,
					"mes": "Томаш Прохазка[25](Опава) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 710
					},
					{
						"n": 2,
						"h": 330,
						"w": 494
					},
					{
						"n": 14,
						"h": 276,
						"w": 495
					},
					{
						"n": 13,
						"h": 173,
						"w": 502
					},
					{
						"n": 5,
						"h": 120,
						"w": 499
					},
					{
						"n": 6,
						"h": 392,
						"w": 341
					},
					{
						"n": 18,
						"h": 291,
						"w": 445
					},
					{
						"n": 15,
						"h": 174,
						"w": 390
					},
					{
						"n": 17,
						"h": 56,
						"w": 387
					},
					{
						"n": 20,
						"h": 268,
						"w": 350
					},
					{
						"n": 19,
						"h": 177,
						"w": 328
					}
				],
				"away": [
					{
						"n": 12,
						"h": 215,
						"w": 645
					},
					{
						"n": 13,
						"h": 407,
						"w": 477
					},
					{
						"n": 3,
						"h": 283,
						"w": 531
					},
					{
						"n": 14,
						"h": 162,
						"w": 501
					},
					{
						"n": 5,
						"h": 62,
						"w": 571
					},
					{
						"n": 16,
						"h": 233,
						"w": 421
					},
					{
						"n": 15,
						"h": 231,
						"w": 348
					},
					{
						"n": 18,
						"h": 45,
						"w": 412
					},
					{
						"n": 17,
						"h": 412,
						"w": 348
					},
					{
						"n": 19,
						"h": 290,
						"w": 274
					},
					{
						"n": 20,
						"h": 164,
						"w": 274
					}
				],
				"ball": {
					"n": 0,
					"h": 388,
					"w": 149,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 20
		},
		{
			"num": 1539,
			"minute": 75,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 702
					},
					{
						"n": 2,
						"h": 330,
						"w": 459
					},
					{
						"n": 14,
						"h": 264,
						"w": 470
					},
					{
						"n": 13,
						"h": 181,
						"w": 463
					},
					{
						"n": 5,
						"h": 120,
						"w": 462
					},
					{
						"n": 6,
						"h": 394,
						"w": 362
					},
					{
						"n": 18,
						"h": 291,
						"w": 405
					},
					{
						"n": 15,
						"h": 206,
						"w": 365
					},
					{
						"n": 17,
						"h": 56,
						"w": 427
					},
					{
						"n": 20,
						"h": 256,
						"w": 312
					},
					{
						"n": 19,
						"h": 172,
						"w": 299
					}
				],
				"away": [
					{
						"n": 12,
						"h": 215,
						"w": 685
					},
					{
						"n": 13,
						"h": 402,
						"w": 458
					},
					{
						"n": 3,
						"h": 280,
						"w": 571
					},
					{
						"n": 14,
						"h": 166,
						"w": 540
					},
					{
						"n": 5,
						"h": 58,
						"w": 534
					},
					{
						"n": 16,
						"h": 196,
						"w": 436
					},
					{
						"n": 15,
						"h": 192,
						"w": 359
					},
					{
						"n": 18,
						"h": 42,
						"w": 373
					},
					{
						"n": 17,
						"h": 413,
						"w": 308
					},
					{
						"n": 19,
						"h": 299,
						"w": 277
					},
					{
						"n": 20,
						"h": 154,
						"w": 295
					}
				],
				"ball": {
					"n": 0,
					"h": 392,
					"w": 186,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1540,
			"minute": 75,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 707
					},
					{
						"n": 2,
						"h": 330,
						"w": 476
					},
					{
						"n": 14,
						"h": 284,
						"w": 466
					},
					{
						"n": 13,
						"h": 195,
						"w": 469
					},
					{
						"n": 5,
						"h": 120,
						"w": 480
					},
					{
						"n": 6,
						"h": 394,
						"w": 402
					},
					{
						"n": 18,
						"h": 281,
						"w": 408
					},
					{
						"n": 15,
						"h": 234,
						"w": 379
					},
					{
						"n": 17,
						"h": 56,
						"w": 445
					},
					{
						"n": 20,
						"h": 284,
						"w": 318
					},
					{
						"n": 19,
						"h": 174,
						"w": 321
					}
				],
				"away": [
					{
						"n": 12,
						"h": 215,
						"w": 708
					},
					{
						"n": 13,
						"h": 404,
						"w": 434
					},
					{
						"n": 3,
						"h": 275,
						"w": 588
					},
					{
						"n": 14,
						"h": 165,
						"w": 580
					},
					{
						"n": 5,
						"h": 54,
						"w": 497
					},
					{
						"n": 16,
						"h": 198,
						"w": 421
					},
					{
						"n": 15,
						"h": 212,
						"w": 332
					},
					{
						"n": 18,
						"h": 38,
						"w": 333
					},
					{
						"n": 17,
						"h": 408,
						"w": 290
					},
					{
						"n": 19,
						"h": 275,
						"w": 289
					},
					{
						"n": 20,
						"h": 156,
						"w": 261
					}
				],
				"ball": {
					"n": 0,
					"h": 396,
					"w": 223,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1541,
			"minute": 75,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 710
					},
					{
						"n": 2,
						"h": 330,
						"w": 515
					},
					{
						"n": 14,
						"h": 285,
						"w": 505
					},
					{
						"n": 13,
						"h": 194,
						"w": 508
					},
					{
						"n": 5,
						"h": 120,
						"w": 519
					},
					{
						"n": 6,
						"h": 394,
						"w": 441
					},
					{
						"n": 18,
						"h": 280,
						"w": 447
					},
					{
						"n": 15,
						"h": 235,
						"w": 418
					},
					{
						"n": 17,
						"h": 48,
						"w": 462
					},
					{
						"n": 20,
						"h": 283,
						"w": 357
					},
					{
						"n": 19,
						"h": 171,
						"w": 360
					}
				],
				"away": [
					{
						"n": 12,
						"h": 227,
						"w": 685
					},
					{
						"n": 13,
						"h": 406,
						"w": 395
					},
					{
						"n": 3,
						"h": 282,
						"w": 550
					},
					{
						"n": 14,
						"h": 176,
						"w": 543
					},
					{
						"n": 5,
						"h": 50,
						"w": 463
					},
					{
						"n": 16,
						"h": 199,
						"w": 382
					},
					{
						"n": 15,
						"h": 208,
						"w": 293
					},
					{
						"n": 18,
						"h": 36,
						"w": 294
					},
					{
						"n": 17,
						"h": 415,
						"w": 252
					},
					{
						"n": 19,
						"h": 274,
						"w": 250
					},
					{
						"n": 20,
						"h": 142,
						"w": 224
					}
				],
				"ball": {
					"n": 0,
					"h": 400,
					"w": 257,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 1542,
			"minute": 75,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 709
					},
					{
						"n": 2,
						"h": 330,
						"w": 554
					},
					{
						"n": 14,
						"h": 290,
						"w": 544
					},
					{
						"n": 13,
						"h": 192,
						"w": 547
					},
					{
						"n": 5,
						"h": 120,
						"w": 558
					},
					{
						"n": 6,
						"h": 394,
						"w": 480
					},
					{
						"n": 18,
						"h": 277,
						"w": 486
					},
					{
						"n": 15,
						"h": 234,
						"w": 457
					},
					{
						"n": 17,
						"h": 47,
						"w": 481
					},
					{
						"n": 20,
						"h": 290,
						"w": 395
					},
					{
						"n": 19,
						"h": 165,
						"w": 398
					}
				],
				"away": [
					{
						"n": 12,
						"h": 226,
						"w": 669
					},
					{
						"n": 13,
						"h": 404,
						"w": 356
					},
					{
						"n": 3,
						"h": 278,
						"w": 511
					},
					{
						"n": 14,
						"h": 168,
						"w": 506
					},
					{
						"n": 5,
						"h": 54,
						"w": 429
					},
					{
						"n": 16,
						"h": 199,
						"w": 343
					},
					{
						"n": 15,
						"h": 207,
						"w": 254
					},
					{
						"n": 18,
						"h": 33,
						"w": 255
					},
					{
						"n": 17,
						"h": 419,
						"w": 213
					},
					{
						"n": 19,
						"h": 272,
						"w": 211
					},
					{
						"n": 20,
						"h": 136,
						"w": 186
					}
				],
				"ball": {
					"n": 0,
					"h": 396,
					"w": 291,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 1543,
			"minute": 75,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 702
					},
					{
						"n": 2,
						"h": 327,
						"w": 575
					},
					{
						"n": 14,
						"h": 284,
						"w": 582
					},
					{
						"n": 13,
						"h": 188,
						"w": 586
					},
					{
						"n": 5,
						"h": 120,
						"w": 597
					},
					{
						"n": 6,
						"h": 394,
						"w": 519
					},
					{
						"n": 18,
						"h": 277,
						"w": 524
					},
					{
						"n": 15,
						"h": 239,
						"w": 496
					},
					{
						"n": 17,
						"h": 46,
						"w": 500
					},
					{
						"n": 20,
						"h": 281,
						"w": 416
					},
					{
						"n": 19,
						"h": 162,
						"w": 419
					}
				],
				"away": [
					{
						"n": 12,
						"h": 228,
						"w": 653
					},
					{
						"n": 13,
						"h": 399,
						"w": 318
					},
					{
						"n": 3,
						"h": 279,
						"w": 472
					},
					{
						"n": 14,
						"h": 180,
						"w": 472
					},
					{
						"n": 5,
						"h": 50,
						"w": 395
					},
					{
						"n": 16,
						"h": 194,
						"w": 305
					},
					{
						"n": 15,
						"h": 206,
						"w": 215
					},
					{
						"n": 18,
						"h": 29,
						"w": 216
					},
					{
						"n": 17,
						"h": 428,
						"w": 175
					},
					{
						"n": 19,
						"h": 274,
						"w": 172
					},
					{
						"n": 20,
						"h": 115,
						"w": 153
					}
				],
				"ball": {
					"n": 0,
					"h": 400,
					"w": 325,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 1544,
			"minute": 75,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 702
					},
					{
						"n": 2,
						"h": 353,
						"w": 596
					},
					{
						"n": 14,
						"h": 310,
						"w": 610
					},
					{
						"n": 13,
						"h": 202,
						"w": 594
					},
					{
						"n": 5,
						"h": 120,
						"w": 612
					},
					{
						"n": 6,
						"h": 394,
						"w": 557
					},
					{
						"n": 18,
						"h": 284,
						"w": 532
					},
					{
						"n": 15,
						"h": 252,
						"w": 514
					},
					{
						"n": 17,
						"h": 56,
						"w": 476
					},
					{
						"n": 20,
						"h": 284,
						"w": 426
					},
					{
						"n": 19,
						"h": 160,
						"w": 430
					}
				],
				"away": [
					{
						"n": 12,
						"h": 223,
						"w": 629
					},
					{
						"n": 13,
						"h": 397,
						"w": 279
					},
					{
						"n": 3,
						"h": 272,
						"w": 434
					},
					{
						"n": 14,
						"h": 185,
						"w": 433
					},
					{
						"n": 5,
						"h": 45,
						"w": 361
					},
					{
						"n": 16,
						"h": 193,
						"w": 266
					},
					{
						"n": 15,
						"h": 207,
						"w": 176
					},
					{
						"n": 18,
						"h": 22,
						"w": 178
					},
					{
						"n": 17,
						"h": 426,
						"w": 169
					},
					{
						"n": 19,
						"h": 266,
						"w": 144
					},
					{
						"n": 20,
						"h": 122,
						"w": 144
					}
				],
				"ball": {
					"n": 0,
					"h": 405,
					"w": 359,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 1545,
			"minute": 75,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 701
					},
					{
						"n": 2,
						"h": 336,
						"w": 581
					},
					{
						"n": 14,
						"h": 288,
						"w": 604
					},
					{
						"n": 13,
						"h": 187,
						"w": 602
					},
					{
						"n": 5,
						"h": 120,
						"w": 618
					},
					{
						"n": 6,
						"h": 394,
						"w": 570
					},
					{
						"n": 18,
						"h": 246,
						"w": 539
					},
					{
						"n": 15,
						"h": 216,
						"w": 507
					},
					{
						"n": 17,
						"h": 56,
						"w": 488
					},
					{
						"n": 20,
						"h": 294,
						"w": 419
					},
					{
						"n": 19,
						"h": 155,
						"w": 414
					}
				],
				"away": [
					{
						"n": 12,
						"h": 220,
						"w": 611
					},
					{
						"n": 13,
						"h": 417,
						"w": 267
					},
					{
						"n": 3,
						"h": 277,
						"w": 395
					},
					{
						"n": 14,
						"h": 168,
						"w": 399
					},
					{
						"n": 5,
						"h": 50,
						"w": 327
					},
					{
						"n": 16,
						"h": 199,
						"w": 227
					},
					{
						"n": 15,
						"h": 203,
						"w": 174
					},
					{
						"n": 18,
						"h": 16,
						"w": 185
					},
					{
						"n": 17,
						"h": 434,
						"w": 169
					},
					{
						"n": 19,
						"h": 281,
						"w": 144
					},
					{
						"n": 20,
						"h": 106,
						"w": 144
					}
				],
				"ball": {
					"n": 0,
					"h": 400,
					"w": 393,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 1546,
			"minute": 75,
			"messages": [
				{
					"owner": 2,
					"mes": "Томаш Прохазка[25](Опава) пасует на Н.Томпсона[38](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 235,
						"w": 709
					},
					{
						"n": 2,
						"h": 363,
						"w": 615
					},
					{
						"n": 14,
						"h": 284,
						"w": 611
					},
					{
						"n": 13,
						"h": 173,
						"w": 608
					},
					{
						"n": 5,
						"h": 120,
						"w": 601
					},
					{
						"n": 6,
						"h": 405,
						"w": 527
					},
					{
						"n": 18,
						"h": 274,
						"w": 559
					},
					{
						"n": 15,
						"h": 228,
						"w": 509
					},
					{
						"n": 17,
						"h": 58,
						"w": 533
					},
					{
						"n": 20,
						"h": 277,
						"w": 384
					},
					{
						"n": 19,
						"h": 173,
						"w": 381
					}
				],
				"away": [
					{
						"n": 12,
						"h": 227,
						"w": 601
					},
					{
						"n": 13,
						"h": 401,
						"w": 309
					},
					{
						"n": 3,
						"h": 281,
						"w": 440
					},
					{
						"n": 14,
						"h": 171,
						"w": 444
					},
					{
						"n": 5,
						"h": 51,
						"w": 342,
						"m": 700
					},
					{
						"n": 16,
						"h": 217,
						"w": 268
					},
					{
						"n": 15,
						"h": 181,
						"w": 176
					},
					{
						"n": 18,
						"h": 45,
						"w": 193
					},
					{
						"n": 17,
						"h": 389,
						"w": 164
					},
					{
						"n": 19,
						"h": 287,
						"w": 133
					},
					{
						"n": 20,
						"h": 149,
						"w": 132
					}
				],
				"ball": {
					"n": 0,
					"h": 405,
					"w": 527,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 45
		},
		{
			"num": 1547,
			"minute": 75,
			"messages": [
				{
					"owner": 2,
					"mes": "Ньялл Томпсон[38](Опава) борется за позицию..."
				},
				{
					"owner": 2,
					"mes": "К.Колман[06](Галвэй Юнайтед) выбивает мяч у Н.Томпсона[38](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 235,
						"w": 709
					},
					{
						"n": 2,
						"h": 367,
						"w": 596
					},
					{
						"n": 14,
						"h": 259,
						"w": 612
					},
					{
						"n": 13,
						"h": 188,
						"w": 610
					},
					{
						"n": 5,
						"h": 120,
						"w": 618
					},
					{
						"n": 6,
						"h": 404,
						"w": 529,
						"m": 900
					},
					{
						"n": 18,
						"h": 261,
						"w": 567
					},
					{
						"n": 15,
						"h": 218,
						"w": 498
					},
					{
						"n": 17,
						"h": 57,
						"w": 506
					},
					{
						"n": 20,
						"h": 264,
						"w": 408
					},
					{
						"n": 19,
						"h": 160,
						"w": 386
					}
				],
				"away": [
					{
						"n": 12,
						"h": 225,
						"w": 593
					},
					{
						"n": 13,
						"h": 399,
						"w": 282
					},
					{
						"n": 3,
						"h": 274,
						"w": 456
					},
					{
						"n": 14,
						"h": 175,
						"w": 449
					},
					{
						"n": 5,
						"h": 50,
						"w": 315
					},
					{
						"n": 16,
						"h": 206,
						"w": 293
					},
					{
						"n": 15,
						"h": 193,
						"w": 163
					},
					{
						"n": 18,
						"h": 45,
						"w": 193
					},
					{
						"n": 17,
						"h": 362,
						"w": 160
					},
					{
						"n": 19,
						"h": 272,
						"w": 122
					},
					{
						"n": 20,
						"h": 172,
						"w": 122
					}
				],
				"ball": {
					"n": 0,
					"h": 402,
					"w": 473,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 27
		},
		{
			"num": 1548,
			"minute": 75,
			"messages": [
				{
					"owner": 1,
					"mes": "Киэн Колман[06](Галвэй Юнайтед) завладевает мячом..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 235,
						"w": 709
					},
					{
						"n": 2,
						"h": 375,
						"w": 548
					},
					{
						"n": 14,
						"h": 280,
						"w": 617
					},
					{
						"n": 13,
						"h": 166,
						"w": 618
					},
					{
						"n": 5,
						"h": 144,
						"w": 582
					},
					{
						"n": 6,
						"h": 402,
						"w": 473
					},
					{
						"n": 18,
						"h": 246,
						"w": 551
					},
					{
						"n": 15,
						"h": 173,
						"w": 517
					},
					{
						"n": 17,
						"h": 56,
						"w": 476
					},
					{
						"n": 20,
						"h": 259,
						"w": 411
					},
					{
						"n": 19,
						"h": 173,
						"w": 387
					}
				],
				"away": [
					{
						"n": 12,
						"h": 222,
						"w": 583
					},
					{
						"n": 13,
						"h": 403,
						"w": 279
					},
					{
						"n": 3,
						"h": 269,
						"w": 413
					},
					{
						"n": 14,
						"h": 181,
						"w": 405
					},
					{
						"n": 5,
						"h": 49,
						"w": 266
					},
					{
						"n": 16,
						"h": 191,
						"w": 329
					},
					{
						"n": 15,
						"h": 194,
						"w": 155
					},
					{
						"n": 18,
						"h": 45,
						"w": 193
					},
					{
						"n": 17,
						"h": 314,
						"w": 150
					},
					{
						"n": 19,
						"h": 299,
						"w": 112
					},
					{
						"n": 20,
						"h": 158,
						"w": 119
					}
				],
				"ball": {
					"n": 0,
					"h": 402,
					"w": 473,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 49
		},
		{
			"num": 1549,
			"minute": 75,
			"messages": [
				{
					"owner": 1,
					"mes": "Киэн Колман[06](Галвэй Юнайтед) посылает мяч в направлении К.Келли[15](Галвэй Юнайтед)..."
				},
				{
					"owner": 1,
					"mes": "Кевин Келли[15](Галвэй Юнайтед) с мячом..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 703
					},
					{
						"n": 2,
						"h": 373,
						"w": 543
					},
					{
						"n": 14,
						"h": 272,
						"w": 592
					},
					{
						"n": 13,
						"h": 184,
						"w": 601
					},
					{
						"n": 5,
						"h": 89,
						"w": 559
					},
					{
						"n": 6,
						"h": 401,
						"w": 463
					},
					{
						"n": 18,
						"h": 263,
						"w": 495
					},
					{
						"n": 15,
						"h": 177,
						"w": 458
					},
					{
						"n": 17,
						"h": 42,
						"w": 419
					},
					{
						"n": 20,
						"h": 284,
						"w": 358
					},
					{
						"n": 19,
						"h": 149,
						"w": 334
					}
				],
				"away": [
					{
						"n": 12,
						"h": 228,
						"w": 642
					},
					{
						"n": 13,
						"h": 415,
						"w": 337
					},
					{
						"n": 3,
						"h": 289,
						"w": 468
					},
					{
						"n": 14,
						"h": 182,
						"w": 463
					},
					{
						"n": 5,
						"h": 52,
						"w": 295
					},
					{
						"n": 16,
						"h": 241,
						"w": 297
					},
					{
						"n": 15,
						"h": 201,
						"w": 213
					},
					{
						"n": 18,
						"h": 43,
						"w": 232
					},
					{
						"n": 17,
						"h": 288,
						"w": 203
					},
					{
						"n": 19,
						"h": 266,
						"w": 139
					},
					{
						"n": 20,
						"h": 171,
						"w": 176
					}
				],
				"ball": {
					"n": 0,
					"h": 177,
					"w": 458,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 59
		},
		{
			"num": 1550,
			"minute": 75,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 705
					},
					{
						"n": 2,
						"h": 382,
						"w": 511
					},
					{
						"n": 14,
						"h": 278,
						"w": 570
					},
					{
						"n": 13,
						"h": 177,
						"w": 561
					},
					{
						"n": 5,
						"h": 74,
						"w": 522
					},
					{
						"n": 6,
						"h": 400,
						"w": 423
					},
					{
						"n": 18,
						"h": 273,
						"w": 456
					},
					{
						"n": 15,
						"h": 166,
						"w": 425
					},
					{
						"n": 17,
						"h": 59,
						"w": 390
					},
					{
						"n": 20,
						"h": 297,
						"w": 320
					},
					{
						"n": 19,
						"h": 144,
						"w": 294
					}
				],
				"away": [
					{
						"n": 12,
						"h": 235,
						"w": 647
					},
					{
						"n": 13,
						"h": 391,
						"w": 366
					},
					{
						"n": 3,
						"h": 276,
						"w": 465
					},
					{
						"n": 14,
						"h": 186,
						"w": 449
					},
					{
						"n": 5,
						"h": 55,
						"w": 315
					},
					{
						"n": 16,
						"h": 278,
						"w": 310
					},
					{
						"n": 15,
						"h": 206,
						"w": 253
					},
					{
						"n": 18,
						"h": 41,
						"w": 252
					},
					{
						"n": 17,
						"h": 317,
						"w": 230
					},
					{
						"n": 19,
						"h": 273,
						"w": 179
					},
					{
						"n": 20,
						"h": 173,
						"w": 216
					}
				],
				"ball": {
					"n": 0,
					"h": 166,
					"w": 425,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1551,
			"minute": 75,
			"messages": [
				{
					"owner": 1,
					"mes": "К.Келли[15](Галвэй Юнайтед) пасует на Р.Уотсона[18](Галвэй Юнайтед)..."
				},
				{
					"owner": 1,
					"mes": "Райан Уотсон[18](Галвэй Юнайтед) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 705
					},
					{
						"n": 2,
						"h": 379,
						"w": 515
					},
					{
						"n": 14,
						"h": 273,
						"w": 575
					},
					{
						"n": 13,
						"h": 178,
						"w": 566
					},
					{
						"n": 5,
						"h": 63,
						"w": 519
					},
					{
						"n": 6,
						"h": 396,
						"w": 378
					},
					{
						"n": 18,
						"h": 254,
						"w": 409
					},
					{
						"n": 15,
						"h": 166,
						"w": 425,
						"m": 650
					},
					{
						"n": 17,
						"h": 51,
						"w": 346
					},
					{
						"n": 20,
						"h": 296,
						"w": 286
					},
					{
						"n": 19,
						"h": 150,
						"w": 292
					}
				],
				"away": [
					{
						"n": 12,
						"h": 223,
						"w": 646
					},
					{
						"n": 13,
						"h": 399,
						"w": 410
					},
					{
						"n": 3,
						"h": 281,
						"w": 500
					},
					{
						"n": 14,
						"h": 167,
						"w": 479
					},
					{
						"n": 5,
						"h": 58,
						"w": 337
					},
					{
						"n": 16,
						"h": 255,
						"w": 349
					},
					{
						"n": 15,
						"h": 213,
						"w": 291
					},
					{
						"n": 18,
						"h": 46,
						"w": 297
					},
					{
						"n": 17,
						"h": 346,
						"w": 265
					},
					{
						"n": 19,
						"h": 278,
						"w": 223
					},
					{
						"n": 20,
						"h": 170,
						"w": 261
					}
				],
				"ball": {
					"n": 0,
					"h": 254,
					"w": 409,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 45
		},
		{
			"num": 1552,
			"minute": 76,
			"possession": 43,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 708
					},
					{
						"n": 2,
						"h": 389,
						"w": 476
					},
					{
						"n": 14,
						"h": 281,
						"w": 536,
						"m": 620
					},
					{
						"n": 13,
						"h": 173,
						"w": 526
					},
					{
						"n": 5,
						"h": 67,
						"w": 479,
						"m": 700
					},
					{
						"n": 6,
						"h": 399,
						"w": 338
					},
					{
						"n": 18,
						"h": 254,
						"w": 374
					},
					{
						"n": 15,
						"h": 161,
						"w": 385
					},
					{
						"n": 17,
						"h": 47,
						"w": 306,
						"f": 88
					},
					{
						"n": 20,
						"h": 311,
						"w": 249,
						"f": 86
					},
					{
						"n": 19,
						"h": 138,
						"w": 254,
						"f": 93,
						"m": 660
					}
				],
				"away": [
					{
						"n": 12,
						"h": 227,
						"w": 647,
						"f": 94
					},
					{
						"n": 13,
						"h": 403,
						"w": 450,
						"m": 600
					},
					{
						"n": 3,
						"h": 274,
						"w": 497,
						"f": 82
					},
					{
						"n": 14,
						"h": 187,
						"w": 494
					},
					{
						"n": 5,
						"h": 69,
						"w": 376,
						"f": 78
					},
					{
						"n": 16,
						"h": 217,
						"w": 360,
						"f": 95
					},
					{
						"n": 15,
						"h": 215,
						"w": 331,
						"f": 97
					},
					{
						"n": 18,
						"h": 43,
						"w": 317
					},
					{
						"n": 17,
						"h": 374,
						"w": 294
					},
					{
						"n": 19,
						"h": 283,
						"w": 263
					},
					{
						"n": 20,
						"h": 166,
						"w": 301
					}
				],
				"ball": {
					"n": 0,
					"h": 254,
					"w": 374,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1553,
			"minute": 76,
			"messages": [
				{
					"owner": 1,
					"mes": "Пасует вперед..."
				},
				{
					"owner": 1,
					"mes": "Том Дэвлин[20](Галвэй Юнайтед) принимает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 701
					},
					{
						"n": 2,
						"h": 390,
						"w": 416
					},
					{
						"n": 14,
						"h": 274,
						"w": 476
					},
					{
						"n": 13,
						"h": 168,
						"w": 466
					},
					{
						"n": 5,
						"h": 77,
						"w": 420
					},
					{
						"n": 6,
						"h": 398,
						"w": 278
					},
					{
						"n": 18,
						"h": 256,
						"w": 364
					},
					{
						"n": 15,
						"h": 166,
						"w": 406
					},
					{
						"n": 17,
						"h": 45,
						"w": 246
					},
					{
						"n": 20,
						"h": 343,
						"w": 216
					},
					{
						"n": 19,
						"h": 147,
						"w": 194
					}
				],
				"away": [
					{
						"n": 12,
						"h": 205,
						"w": 644
					},
					{
						"n": 13,
						"h": 405,
						"w": 510
					},
					{
						"n": 3,
						"h": 260,
						"w": 556
					},
					{
						"n": 14,
						"h": 141,
						"w": 524
					},
					{
						"n": 5,
						"h": 70,
						"w": 436
					},
					{
						"n": 16,
						"h": 211,
						"w": 420
					},
					{
						"n": 15,
						"h": 219,
						"w": 391
					},
					{
						"n": 18,
						"h": 47,
						"w": 377
					},
					{
						"n": 17,
						"h": 385,
						"w": 353
					},
					{
						"n": 19,
						"h": 284,
						"w": 323
					},
					{
						"n": 20,
						"h": 176,
						"w": 264
					}
				],
				"ball": {
					"n": 0,
					"h": 343,
					"w": 216,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 60
		},
		{
			"num": 1554,
			"minute": 76,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 707
					},
					{
						"n": 2,
						"h": 391,
						"w": 376
					},
					{
						"n": 14,
						"h": 270,
						"w": 436
					},
					{
						"n": 13,
						"h": 169,
						"w": 426
					},
					{
						"n": 5,
						"h": 64,
						"w": 382
					},
					{
						"n": 6,
						"h": 399,
						"w": 238
					},
					{
						"n": 18,
						"h": 266,
						"w": 325
					},
					{
						"n": 15,
						"h": 164,
						"w": 366
					},
					{
						"n": 17,
						"h": 48,
						"w": 206
					},
					{
						"n": 20,
						"h": 329,
						"w": 181
					},
					{
						"n": 19,
						"h": 158,
						"w": 156
					}
				],
				"away": [
					{
						"n": 12,
						"h": 215,
						"w": 683
					},
					{
						"n": 13,
						"h": 402,
						"w": 550
					},
					{
						"n": 3,
						"h": 253,
						"w": 595
					},
					{
						"n": 14,
						"h": 130,
						"w": 559
					},
					{
						"n": 5,
						"h": 74,
						"w": 476
					},
					{
						"n": 16,
						"h": 218,
						"w": 460
					},
					{
						"n": 15,
						"h": 217,
						"w": 431
					},
					{
						"n": 18,
						"h": 48,
						"w": 417
					},
					{
						"n": 17,
						"h": 401,
						"w": 389
					},
					{
						"n": 19,
						"h": 285,
						"w": 363
					},
					{
						"n": 20,
						"h": 180,
						"w": 304
					}
				],
				"ball": {
					"n": 0,
					"h": 329,
					"w": 181,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1555,
			"minute": 76,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 709
					},
					{
						"n": 2,
						"h": 383,
						"w": 368
					},
					{
						"n": 14,
						"h": 281,
						"w": 429
					},
					{
						"n": 13,
						"h": 169,
						"w": 414
					},
					{
						"n": 5,
						"h": 71,
						"w": 382
					},
					{
						"n": 6,
						"h": 401,
						"w": 225
					},
					{
						"n": 18,
						"h": 270,
						"w": 313
					},
					{
						"n": 15,
						"h": 164,
						"w": 353
					},
					{
						"n": 17,
						"h": 47,
						"w": 193
					},
					{
						"n": 20,
						"h": 329,
						"w": 171
					},
					{
						"n": 19,
						"h": 160,
						"w": 143
					}
				],
				"away": [
					{
						"n": 12,
						"h": 215,
						"w": 684
					},
					{
						"n": 13,
						"h": 403,
						"w": 563
					},
					{
						"n": 3,
						"h": 251,
						"w": 608
					},
					{
						"n": 14,
						"h": 121,
						"w": 549
					},
					{
						"n": 5,
						"h": 75,
						"w": 489
					},
					{
						"n": 16,
						"h": 219,
						"w": 472
					},
					{
						"n": 15,
						"h": 220,
						"w": 443
					},
					{
						"n": 18,
						"h": 48,
						"w": 430
					},
					{
						"n": 17,
						"h": 405,
						"w": 402
					},
					{
						"n": 19,
						"h": 286,
						"w": 376
					},
					{
						"n": 20,
						"h": 180,
						"w": 317
					}
				],
				"ball": {
					"n": 0,
					"h": 329,
					"w": 171,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 13
		},
		{
			"num": 1556,
			"minute": 76,
			"messages": [
				{
					"owner": 1,
					"mes": "Вацлав Сланина[34](Опава) пытается отобрать мяч у Т.Дэвлина[20](Галвэй Юнайтед)..."
				},
				{
					"owner": 1,
					"mes": "Вацлав Сланина[34](Опава) буквально вырывает мяч у Т.Дэвлина[20](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 709
					},
					{
						"n": 2,
						"h": 383,
						"w": 368
					},
					{
						"n": 14,
						"h": 282,
						"w": 428
					},
					{
						"n": 13,
						"h": 170,
						"w": 404
					},
					{
						"n": 5,
						"h": 71,
						"w": 382
					},
					{
						"n": 6,
						"h": 402,
						"w": 215
					},
					{
						"n": 18,
						"h": 272,
						"w": 303
					},
					{
						"n": 15,
						"h": 163,
						"w": 343
					},
					{
						"n": 17,
						"h": 46,
						"w": 183
					},
					{
						"n": 20,
						"h": 329,
						"w": 161
					},
					{
						"n": 19,
						"h": 162,
						"w": 133
					}
				],
				"away": [
					{
						"n": 12,
						"h": 215,
						"w": 684
					},
					{
						"n": 13,
						"h": 403,
						"w": 563
					},
					{
						"n": 3,
						"h": 250,
						"w": 612
					},
					{
						"n": 14,
						"h": 114,
						"w": 542,
						"m": 660
					},
					{
						"n": 5,
						"h": 75,
						"w": 499
					},
					{
						"n": 16,
						"h": 220,
						"w": 482
					},
					{
						"n": 15,
						"h": 223,
						"w": 453
					},
					{
						"n": 18,
						"h": 48,
						"w": 440
					},
					{
						"n": 17,
						"h": 407,
						"w": 412
					},
					{
						"n": 19,
						"h": 286,
						"w": 386
					},
					{
						"n": 20,
						"h": 180,
						"w": 327
					}
				],
				"ball": {
					"n": 0,
					"h": 336,
					"w": 178,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 10
		},
		{
			"num": 1557,
			"minute": 76,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 701
					},
					{
						"n": 2,
						"h": 365,
						"w": 404
					},
					{
						"n": 14,
						"h": 274,
						"w": 438
					},
					{
						"n": 13,
						"h": 182,
						"w": 425
					},
					{
						"n": 5,
						"h": 98,
						"w": 412
					},
					{
						"n": 6,
						"h": 400,
						"w": 255
					},
					{
						"n": 18,
						"h": 246,
						"w": 333
					},
					{
						"n": 15,
						"h": 169,
						"w": 354
					},
					{
						"n": 17,
						"h": 50,
						"w": 223
					},
					{
						"n": 20,
						"h": 326,
						"w": 170
					},
					{
						"n": 19,
						"h": 172,
						"w": 159
					}
				],
				"away": [
					{
						"n": 12,
						"h": 226,
						"w": 709
					},
					{
						"n": 13,
						"h": 408,
						"w": 523
					},
					{
						"n": 3,
						"h": 278,
						"w": 581
					},
					{
						"n": 14,
						"h": 139,
						"w": 517
					},
					{
						"n": 5,
						"h": 73,
						"w": 539
					},
					{
						"n": 16,
						"h": 197,
						"w": 472
					},
					{
						"n": 15,
						"h": 224,
						"w": 413
					},
					{
						"n": 18,
						"h": 52,
						"w": 400
					},
					{
						"n": 17,
						"h": 406,
						"w": 372
					},
					{
						"n": 19,
						"h": 287,
						"w": 346
					},
					{
						"n": 20,
						"h": 160,
						"w": 302
					}
				],
				"ball": {
					"n": 0,
					"h": 311,
					"w": 203,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1558,
			"minute": 76,
			"messages": [
				{
					"owner": 2,
					"mes": "В.Сланина[34](Опава) делает передачу М.Владаржу[36](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 708
					},
					{
						"n": 2,
						"h": 348,
						"w": 431
					},
					{
						"n": 14,
						"h": 278,
						"w": 461
					},
					{
						"n": 13,
						"h": 174,
						"w": 456
					},
					{
						"n": 5,
						"h": 72,
						"w": 400
					},
					{
						"n": 6,
						"h": 398,
						"w": 287
					},
					{
						"n": 18,
						"h": 253,
						"w": 302
					},
					{
						"n": 15,
						"h": 188,
						"w": 353
					},
					{
						"n": 17,
						"h": 48,
						"w": 239
					},
					{
						"n": 20,
						"h": 312,
						"w": 199
					},
					{
						"n": 19,
						"h": 165,
						"w": 190
					}
				],
				"away": [
					{
						"n": 12,
						"h": 221,
						"w": 689
					},
					{
						"n": 13,
						"h": 407,
						"w": 491
					},
					{
						"n": 3,
						"h": 286,
						"w": 547
					},
					{
						"n": 14,
						"h": 149,
						"w": 518,
						"m": 670
					},
					{
						"n": 5,
						"h": 63,
						"w": 547
					},
					{
						"n": 16,
						"h": 189,
						"w": 477
					},
					{
						"n": 15,
						"h": 233,
						"w": 383
					},
					{
						"n": 18,
						"h": 48,
						"w": 368
					},
					{
						"n": 17,
						"h": 408,
						"w": 340
					},
					{
						"n": 19,
						"h": 300,
						"w": 317
					},
					{
						"n": 20,
						"h": 161,
						"w": 288
					}
				],
				"ball": {
					"n": 0,
					"h": 261,
					"w": 243,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 32
		},
		{
			"num": 1559,
			"minute": 76,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 704
					},
					{
						"n": 2,
						"h": 370,
						"w": 412
					},
					{
						"n": 14,
						"h": 278,
						"w": 469
					},
					{
						"n": 13,
						"h": 180,
						"w": 469
					},
					{
						"n": 5,
						"h": 86,
						"w": 416
					},
					{
						"n": 6,
						"h": 410,
						"w": 325
					},
					{
						"n": 18,
						"h": 279,
						"w": 291
					},
					{
						"n": 15,
						"h": 183,
						"w": 370
					},
					{
						"n": 17,
						"h": 49,
						"w": 259
					},
					{
						"n": 20,
						"h": 305,
						"w": 239
					},
					{
						"n": 19,
						"h": 167,
						"w": 230
					}
				],
				"away": [
					{
						"n": 12,
						"h": 220,
						"w": 710
					},
					{
						"n": 13,
						"h": 417,
						"w": 453
					},
					{
						"n": 3,
						"h": 279,
						"w": 581
					},
					{
						"n": 14,
						"h": 166,
						"w": 554
					},
					{
						"n": 5,
						"h": 67,
						"w": 583
					},
					{
						"n": 16,
						"h": 171,
						"w": 447
					},
					{
						"n": 15,
						"h": 216,
						"w": 388
					},
					{
						"n": 18,
						"h": 50,
						"w": 328
					},
					{
						"n": 17,
						"h": 394,
						"w": 324
					},
					{
						"n": 19,
						"h": 300,
						"w": 280
					},
					{
						"n": 20,
						"h": 135,
						"w": 277
					}
				],
				"ball": {
					"n": 0,
					"h": 279,
					"w": 273,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1560,
			"minute": 76,
			"messages": [
				{
					"owner": 2,
					"mes": "Михаэль Владарж[36](Опава) пасует вперед на А.Карабеца[35](Опава)..."
				},
				{
					"owner": 2,
					"mes": "Райан Уотсон[18](Галвэй Юнайтед) делает рывок и перехватывает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 701
					},
					{
						"n": 2,
						"h": 367,
						"w": 418
					},
					{
						"n": 14,
						"h": 277,
						"w": 476
					},
					{
						"n": 13,
						"h": 184,
						"w": 475
					},
					{
						"n": 5,
						"h": 79,
						"w": 418
					},
					{
						"n": 6,
						"h": 410,
						"w": 325
					},
					{
						"n": 18,
						"h": 273,
						"w": 287
					},
					{
						"n": 15,
						"h": 190,
						"w": 368
					},
					{
						"n": 17,
						"h": 49,
						"w": 262
					},
					{
						"n": 20,
						"h": 302,
						"w": 245
					},
					{
						"n": 19,
						"h": 167,
						"w": 237
					}
				],
				"away": [
					{
						"n": 12,
						"h": 221,
						"w": 703
					},
					{
						"n": 13,
						"h": 414,
						"w": 447
					},
					{
						"n": 3,
						"h": 280,
						"w": 574
					},
					{
						"n": 14,
						"h": 166,
						"w": 554
					},
					{
						"n": 5,
						"h": 65,
						"w": 576
					},
					{
						"n": 16,
						"h": 171,
						"w": 447,
						"m": 600
					},
					{
						"n": 15,
						"h": 212,
						"w": 393
					},
					{
						"n": 18,
						"h": 53,
						"w": 322
					},
					{
						"n": 17,
						"h": 401,
						"w": 322
					},
					{
						"n": 19,
						"h": 303,
						"w": 274
					},
					{
						"n": 20,
						"h": 138,
						"w": 271
					}
				],
				"ball": {
					"n": 0,
					"h": 273,
					"w": 287,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 7
		},
		{
			"num": 1561,
			"minute": 76,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 709
					},
					{
						"n": 2,
						"h": 375,
						"w": 411
					},
					{
						"n": 14,
						"h": 285,
						"w": 461
					},
					{
						"n": 13,
						"h": 173,
						"w": 436
					},
					{
						"n": 5,
						"h": 78,
						"w": 411
					},
					{
						"n": 6,
						"h": 411,
						"w": 298
					},
					{
						"n": 18,
						"h": 237,
						"w": 287,
						"m": 620
					},
					{
						"n": 15,
						"h": 179,
						"w": 329
					},
					{
						"n": 17,
						"h": 50,
						"w": 242
					},
					{
						"n": 20,
						"h": 298,
						"w": 205
					},
					{
						"n": 19,
						"h": 168,
						"w": 197
					}
				],
				"away": [
					{
						"n": 12,
						"h": 224,
						"w": 663
					},
					{
						"n": 13,
						"h": 405,
						"w": 486
					},
					{
						"n": 3,
						"h": 268,
						"w": 605
					},
					{
						"n": 14,
						"h": 165,
						"w": 581
					},
					{
						"n": 5,
						"h": 96,
						"w": 602
					},
					{
						"n": 16,
						"h": 197,
						"w": 473
					},
					{
						"n": 15,
						"h": 215,
						"w": 433
					},
					{
						"n": 18,
						"h": 50,
						"w": 362
					},
					{
						"n": 17,
						"h": 399,
						"w": 362
					},
					{
						"n": 19,
						"h": 294,
						"w": 313
					},
					{
						"n": 20,
						"h": 147,
						"w": 310
					}
				],
				"ball": {
					"n": 0,
					"h": 237,
					"w": 287,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1562,
			"minute": 76,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 710
					},
					{
						"n": 2,
						"h": 390,
						"w": 375
					},
					{
						"n": 14,
						"h": 278,
						"w": 436
					},
					{
						"n": 13,
						"h": 171,
						"w": 417
					},
					{
						"n": 5,
						"h": 69,
						"w": 378
					},
					{
						"n": 6,
						"h": 411,
						"w": 258
					},
					{
						"n": 18,
						"h": 241,
						"w": 252
					},
					{
						"n": 15,
						"h": 175,
						"w": 289
					},
					{
						"n": 17,
						"h": 48,
						"w": 202
					},
					{
						"n": 20,
						"h": 314,
						"w": 168
					},
					{
						"n": 19,
						"h": 158,
						"w": 158
					}
				],
				"away": [
					{
						"n": 12,
						"h": 230,
						"w": 648
					},
					{
						"n": 13,
						"h": 403,
						"w": 526
					},
					{
						"n": 3,
						"h": 277,
						"w": 608
					},
					{
						"n": 14,
						"h": 164,
						"w": 603
					},
					{
						"n": 5,
						"h": 110,
						"w": 608
					},
					{
						"n": 16,
						"h": 203,
						"w": 512
					},
					{
						"n": 15,
						"h": 208,
						"w": 472
					},
					{
						"n": 18,
						"h": 48,
						"w": 402
					},
					{
						"n": 17,
						"h": 412,
						"w": 400
					},
					{
						"n": 19,
						"h": 290,
						"w": 352
					},
					{
						"n": 20,
						"h": 151,
						"w": 349
					}
				],
				"ball": {
					"n": 0,
					"h": 241,
					"w": 252,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1563,
			"minute": 76,
			"messages": [
				{
					"owner": 1,
					"mes": "Изящный пас на К.Келли[15](Галвэй Юнайтед)..."
				},
				{
					"owner": 1,
					"mes": "Кевин Келли[15](Галвэй Юнайтед) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 701
					},
					{
						"n": 2,
						"h": 387,
						"w": 364
					},
					{
						"n": 14,
						"h": 277,
						"w": 432
					},
					{
						"n": 13,
						"h": 174,
						"w": 414
					},
					{
						"n": 5,
						"h": 78,
						"w": 372
					},
					{
						"n": 6,
						"h": 413,
						"w": 217
					},
					{
						"n": 18,
						"h": 241,
						"w": 252,
						"m": 630
					},
					{
						"n": 15,
						"h": 160,
						"w": 240
					},
					{
						"n": 17,
						"h": 53,
						"w": 161
					},
					{
						"n": 20,
						"h": 284,
						"w": 140
					},
					{
						"n": 19,
						"h": 177,
						"w": 130
					}
				],
				"away": [
					{
						"n": 12,
						"h": 235,
						"w": 647
					},
					{
						"n": 13,
						"h": 399,
						"w": 567
					},
					{
						"n": 3,
						"h": 260,
						"w": 613
					},
					{
						"n": 14,
						"h": 184,
						"w": 610
					},
					{
						"n": 5,
						"h": 110,
						"w": 615
					},
					{
						"n": 16,
						"h": 244,
						"w": 508
					},
					{
						"n": 15,
						"h": 226,
						"w": 509
					},
					{
						"n": 18,
						"h": 47,
						"w": 442
					},
					{
						"n": 17,
						"h": 418,
						"w": 441
					},
					{
						"n": 19,
						"h": 285,
						"w": 393
					},
					{
						"n": 20,
						"h": 160,
						"w": 390
					}
				],
				"ball": {
					"n": 0,
					"h": 160,
					"w": 240,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 41
		},
		{
			"num": 1564,
			"minute": 76,
			"messages": [
				{
					"owner": 1,
					"mes": "Пас налево К.Колману[06](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 706
					},
					{
						"n": 2,
						"h": 383,
						"w": 361
					},
					{
						"n": 14,
						"h": 275,
						"w": 404
					},
					{
						"n": 13,
						"h": 176,
						"w": 408
					},
					{
						"n": 5,
						"h": 72,
						"w": 365
					},
					{
						"n": 6,
						"h": 435,
						"w": 202
					},
					{
						"n": 18,
						"h": 302,
						"w": 284
					},
					{
						"n": 15,
						"h": 168,
						"w": 233
					},
					{
						"n": 17,
						"h": 39,
						"w": 147
					},
					{
						"n": 20,
						"h": 293,
						"w": 117
					},
					{
						"n": 19,
						"h": 176,
						"w": 118
					}
				],
				"away": [
					{
						"n": 12,
						"h": 205,
						"w": 653
					},
					{
						"n": 13,
						"h": 395,
						"w": 607
					},
					{
						"n": 3,
						"h": 257,
						"w": 613
					},
					{
						"n": 14,
						"h": 175,
						"w": 630
					},
					{
						"n": 5,
						"h": 74,
						"w": 621
					},
					{
						"n": 16,
						"h": 175,
						"w": 512
					},
					{
						"n": 15,
						"h": 224,
						"w": 469
					},
					{
						"n": 18,
						"h": 37,
						"w": 511
					},
					{
						"n": 17,
						"h": 400,
						"w": 472
					},
					{
						"n": 19,
						"h": 290,
						"w": 416
					},
					{
						"n": 20,
						"h": 170,
						"w": 419
					}
				],
				"ball": {
					"n": 0,
					"h": 435,
					"w": 202,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 69
		},
		{
			"num": 1565,
			"minute": 76,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 702
					},
					{
						"n": 2,
						"h": 380,
						"w": 351
					},
					{
						"n": 14,
						"h": 269,
						"w": 417
					},
					{
						"n": 13,
						"h": 167,
						"w": 414
					},
					{
						"n": 5,
						"h": 72,
						"w": 356
					},
					{
						"n": 6,
						"h": 436,
						"w": 161
					},
					{
						"n": 18,
						"h": 277,
						"w": 284
					},
					{
						"n": 15,
						"h": 188,
						"w": 199
					},
					{
						"n": 17,
						"h": 60,
						"w": 136
					},
					{
						"n": 20,
						"h": 284,
						"w": 113
					},
					{
						"n": 19,
						"h": 159,
						"w": 106
					}
				],
				"away": [
					{
						"n": 12,
						"h": 211,
						"w": 693
					},
					{
						"n": 13,
						"h": 374,
						"w": 618
					},
					{
						"n": 3,
						"h": 280,
						"w": 643
					},
					{
						"n": 14,
						"h": 181,
						"w": 651
					},
					{
						"n": 5,
						"h": 78,
						"w": 632
					},
					{
						"n": 16,
						"h": 205,
						"w": 539
					},
					{
						"n": 15,
						"h": 219,
						"w": 491
					},
					{
						"n": 18,
						"h": 33,
						"w": 560
					},
					{
						"n": 17,
						"h": 423,
						"w": 483
					},
					{
						"n": 19,
						"h": 283,
						"w": 417
					},
					{
						"n": 20,
						"h": 173,
						"w": 456
					}
				],
				"ball": {
					"n": 0,
					"h": 436,
					"w": 161,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1566,
			"minute": 76,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 705
					},
					{
						"n": 2,
						"h": 386,
						"w": 348
					},
					{
						"n": 14,
						"h": 269,
						"w": 397
					},
					{
						"n": 13,
						"h": 173,
						"w": 395
					},
					{
						"n": 5,
						"h": 58,
						"w": 352
					},
					{
						"n": 6,
						"h": 436,
						"w": 181
					},
					{
						"n": 18,
						"h": 296,
						"w": 290
					},
					{
						"n": 15,
						"h": 202,
						"w": 184
					},
					{
						"n": 17,
						"h": 57,
						"w": 116
					},
					{
						"n": 20,
						"h": 286,
						"w": 93
					},
					{
						"n": 19,
						"h": 169,
						"w": 89
					}
				],
				"away": [
					{
						"n": 12,
						"h": 214,
						"w": 710
					},
					{
						"n": 13,
						"h": 377,
						"w": 636
					},
					{
						"n": 3,
						"h": 265,
						"w": 653
					},
					{
						"n": 14,
						"h": 181,
						"w": 639
					},
					{
						"n": 5,
						"h": 78,
						"w": 646
					},
					{
						"n": 16,
						"h": 201,
						"w": 559
					},
					{
						"n": 15,
						"h": 234,
						"w": 489
					},
					{
						"n": 18,
						"h": 33,
						"w": 560
					},
					{
						"n": 17,
						"h": 419,
						"w": 501
					},
					{
						"n": 19,
						"h": 294,
						"w": 422
					},
					{
						"n": 20,
						"h": 154,
						"w": 450
					}
				],
				"ball": {
					"n": 0,
					"h": 436,
					"w": 181,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 20
		},
		{
			"num": 1567,
			"minute": 76,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 704
					},
					{
						"n": 2,
						"h": 384,
						"w": 354
					},
					{
						"n": 14,
						"h": 272,
						"w": 403
					},
					{
						"n": 13,
						"h": 169,
						"w": 382
					},
					{
						"n": 5,
						"h": 74,
						"w": 340
					},
					{
						"n": 6,
						"h": 406,
						"w": 164
					},
					{
						"n": 18,
						"h": 297,
						"w": 256
					},
					{
						"n": 15,
						"h": 192,
						"w": 151
					},
					{
						"n": 17,
						"h": 49,
						"w": 92
					},
					{
						"n": 20,
						"h": 290,
						"w": 71
					},
					{
						"n": 19,
						"h": 164,
						"w": 92
					}
				],
				"away": [
					{
						"n": 12,
						"h": 214,
						"w": 710
					},
					{
						"n": 13,
						"h": 385,
						"w": 653
					},
					{
						"n": 3,
						"h": 266,
						"w": 647
					},
					{
						"n": 14,
						"h": 178,
						"w": 673
					},
					{
						"n": 5,
						"h": 88,
						"w": 652
					},
					{
						"n": 16,
						"h": 216,
						"w": 585
					},
					{
						"n": 15,
						"h": 223,
						"w": 488
					},
					{
						"n": 18,
						"h": 62,
						"w": 572
					},
					{
						"n": 17,
						"h": 401,
						"w": 518
					},
					{
						"n": 19,
						"h": 277,
						"w": 419
					},
					{
						"n": 20,
						"h": 153,
						"w": 484
					}
				],
				"ball": {
					"n": 0,
					"h": 406,
					"w": 164,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 34
		},
		{
			"num": 1568,
			"minute": 76,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 701
					},
					{
						"n": 2,
						"h": 379,
						"w": 351
					},
					{
						"n": 14,
						"h": 282,
						"w": 394
					},
					{
						"n": 13,
						"h": 175,
						"w": 382
					},
					{
						"n": 5,
						"h": 73,
						"w": 358
					},
					{
						"n": 6,
						"h": 376,
						"w": 180
					},
					{
						"n": 18,
						"h": 313,
						"w": 262
					},
					{
						"n": 15,
						"h": 205,
						"w": 134
					},
					{
						"n": 17,
						"h": 58,
						"w": 77
					},
					{
						"n": 20,
						"h": 291,
						"w": 56
					},
					{
						"n": 19,
						"h": 153,
						"w": 92
					}
				],
				"away": [
					{
						"n": 12,
						"h": 215,
						"w": 709
					},
					{
						"n": 13,
						"h": 376,
						"w": 665
					},
					{
						"n": 3,
						"h": 284,
						"w": 655
					},
					{
						"n": 14,
						"h": 179,
						"w": 672
					},
					{
						"n": 5,
						"h": 76,
						"w": 674
					},
					{
						"n": 16,
						"h": 232,
						"w": 607
					},
					{
						"n": 15,
						"h": 225,
						"w": 500
					},
					{
						"n": 18,
						"h": 83,
						"w": 556
					},
					{
						"n": 17,
						"h": 420,
						"w": 530
					},
					{
						"n": 19,
						"h": 283,
						"w": 417
					},
					{
						"n": 20,
						"h": 137,
						"w": 478
					}
				],
				"ball": {
					"n": 0,
					"h": 376,
					"w": 180,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 34
		},
		{
			"num": 1569,
			"minute": 76,
			"messages": [
				{
					"owner": 1,
					"mes": "Киэн Колман[06](Галвэй Юнайтед) уходит в центр..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 701
					},
					{
						"n": 2,
						"h": 377,
						"w": 341
					},
					{
						"n": 14,
						"h": 270,
						"w": 404
					},
					{
						"n": 13,
						"h": 165,
						"w": 405
					},
					{
						"n": 5,
						"h": 59,
						"w": 360
					},
					{
						"n": 6,
						"h": 346,
						"w": 190
					},
					{
						"n": 18,
						"h": 299,
						"w": 233
					},
					{
						"n": 15,
						"h": 175,
						"w": 125
					},
					{
						"n": 17,
						"h": 35,
						"w": 80
					},
					{
						"n": 20,
						"h": 282,
						"w": 44
					},
					{
						"n": 19,
						"h": 156,
						"w": 91
					}
				],
				"away": [
					{
						"n": 12,
						"h": 217,
						"w": 707
					},
					{
						"n": 13,
						"h": 399,
						"w": 665
					},
					{
						"n": 3,
						"h": 278,
						"w": 656
					},
					{
						"n": 14,
						"h": 181,
						"w": 673
					},
					{
						"n": 5,
						"h": 105,
						"w": 688
					},
					{
						"n": 16,
						"h": 214,
						"w": 598
					},
					{
						"n": 15,
						"h": 234,
						"w": 511
					},
					{
						"n": 18,
						"h": 107,
						"w": 546
					},
					{
						"n": 17,
						"h": 409,
						"w": 530
					},
					{
						"n": 19,
						"h": 280,
						"w": 415
					},
					{
						"n": 20,
						"h": 151,
						"w": 507
					}
				],
				"ball": {
					"n": 0,
					"h": 346,
					"w": 190,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 32
		},
		{
			"num": 1570,
			"minute": 76,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 706
					},
					{
						"n": 2,
						"h": 379,
						"w": 357
					},
					{
						"n": 14,
						"h": 282,
						"w": 392
					},
					{
						"n": 13,
						"h": 167,
						"w": 387
					},
					{
						"n": 5,
						"h": 67,
						"w": 354
					},
					{
						"n": 6,
						"h": 310,
						"w": 175
					},
					{
						"n": 18,
						"h": 297,
						"w": 273
					},
					{
						"n": 15,
						"h": 175,
						"w": 120
					},
					{
						"n": 17,
						"h": 46,
						"w": 80
					},
					{
						"n": 20,
						"h": 259,
						"w": 47
					},
					{
						"n": 19,
						"h": 161,
						"w": 89
					}
				],
				"away": [
					{
						"n": 12,
						"h": 218,
						"w": 706
					},
					{
						"n": 13,
						"h": 388,
						"w": 665
					},
					{
						"n": 3,
						"h": 274,
						"w": 670
					},
					{
						"n": 14,
						"h": 206,
						"w": 691
					},
					{
						"n": 5,
						"h": 110,
						"w": 689
					},
					{
						"n": 16,
						"h": 229,
						"w": 614
					},
					{
						"n": 15,
						"h": 219,
						"w": 493
					},
					{
						"n": 18,
						"h": 144,
						"w": 561
					},
					{
						"n": 17,
						"h": 413,
						"w": 530
					},
					{
						"n": 19,
						"h": 278,
						"w": 421
					},
					{
						"n": 20,
						"h": 144,
						"w": 546
					}
				],
				"ball": {
					"n": 0,
					"h": 310,
					"w": 175,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1571,
			"minute": 76,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 707
					},
					{
						"n": 2,
						"h": 390,
						"w": 342
					},
					{
						"n": 14,
						"h": 269,
						"w": 393
					},
					{
						"n": 13,
						"h": 171,
						"w": 393
					},
					{
						"n": 5,
						"h": 78,
						"w": 347
					},
					{
						"n": 6,
						"h": 280,
						"w": 192
					},
					{
						"n": 18,
						"h": 301,
						"w": 239
					},
					{
						"n": 15,
						"h": 168,
						"w": 126
					},
					{
						"n": 17,
						"h": 38,
						"w": 80
					},
					{
						"n": 20,
						"h": 262,
						"w": 40
					},
					{
						"n": 19,
						"h": 167,
						"w": 84
					}
				],
				"away": [
					{
						"n": 12,
						"h": 221,
						"w": 706
					},
					{
						"n": 13,
						"h": 396,
						"w": 665
					},
					{
						"n": 3,
						"h": 267,
						"w": 656
					},
					{
						"n": 14,
						"h": 199,
						"w": 661
					},
					{
						"n": 5,
						"h": 110,
						"w": 683
					},
					{
						"n": 16,
						"h": 221,
						"w": 605
					},
					{
						"n": 15,
						"h": 220,
						"w": 508
					},
					{
						"n": 18,
						"h": 154,
						"w": 551
					},
					{
						"n": 17,
						"h": 419,
						"w": 530
					},
					{
						"n": 19,
						"h": 276,
						"w": 428
					},
					{
						"n": 20,
						"h": 170,
						"w": 548
					}
				],
				"ball": {
					"n": 0,
					"h": 280,
					"w": 192,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 34
		},
		{
			"num": 1572,
			"minute": 76,
			"messages": [
				{
					"owner": 1,
					"mes": "Киэн Колман[06](Галвэй Юнайтед) смещается левее..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 704
					},
					{
						"n": 2,
						"h": 381,
						"w": 352
					},
					{
						"n": 14,
						"h": 277,
						"w": 404
					},
					{
						"n": 13,
						"h": 174,
						"w": 385
					},
					{
						"n": 5,
						"h": 75,
						"w": 353
					},
					{
						"n": 6,
						"h": 310,
						"w": 172
					},
					{
						"n": 18,
						"h": 284,
						"w": 271
					},
					{
						"n": 15,
						"h": 168,
						"w": 126
					},
					{
						"n": 17,
						"h": 46,
						"w": 85
					},
					{
						"n": 20,
						"h": 270,
						"w": 75
					},
					{
						"n": 19,
						"h": 179,
						"w": 87
					}
				],
				"away": [
					{
						"n": 12,
						"h": 218,
						"w": 707
					},
					{
						"n": 13,
						"h": 388,
						"w": 650
					},
					{
						"n": 3,
						"h": 256,
						"w": 648
					},
					{
						"n": 14,
						"h": 191,
						"w": 668
					},
					{
						"n": 5,
						"h": 110,
						"w": 666
					},
					{
						"n": 16,
						"h": 222,
						"w": 584
					},
					{
						"n": 15,
						"h": 215,
						"w": 493
					},
					{
						"n": 18,
						"h": 109,
						"w": 556
					},
					{
						"n": 17,
						"h": 413,
						"w": 515
					},
					{
						"n": 19,
						"h": 280,
						"w": 419
					},
					{
						"n": 20,
						"h": 147,
						"w": 562
					}
				],
				"ball": {
					"n": 0,
					"h": 310,
					"w": 172,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 36
		},
		{
			"num": 1573,
			"minute": 76,
			"messages": [
				{
					"owner": 1,
					"mes": "Дальний удар К.Колмана[06](Галвэй Юнайтед)..."
				},
				{
					"owner": 1,
					"mes": "Тома Анри[40](Опава) отчаянно бросается под мяч..."
				}
			],
			"U": {
				"team": 3,
				"player": 6
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 710
					},
					{
						"n": 2,
						"h": 381,
						"w": 345
					},
					{
						"n": 14,
						"h": 271,
						"w": 398
					},
					{
						"n": 13,
						"h": 169,
						"w": 391
					},
					{
						"n": 5,
						"h": 77,
						"w": 345
					},
					{
						"n": 6,
						"h": 310,
						"w": 172
					},
					{
						"n": 18,
						"h": 284,
						"w": 263
					},
					{
						"n": 15,
						"h": 168,
						"w": 134
					},
					{
						"n": 17,
						"h": 47,
						"w": 93
					},
					{
						"n": 20,
						"h": 277,
						"w": 79
					},
					{
						"n": 19,
						"h": 171,
						"w": 88
					}
				],
				"away": [
					{
						"n": 12,
						"h": 218,
						"w": 707
					},
					{
						"n": 13,
						"h": 387,
						"w": 646
					},
					{
						"n": 3,
						"h": 264,
						"w": 650
					},
					{
						"n": 14,
						"h": 192,
						"w": 660
					},
					{
						"n": 5,
						"h": 110,
						"w": 658
					},
					{
						"n": 16,
						"h": 228,
						"w": 578
					},
					{
						"n": 15,
						"h": 222,
						"w": 496
					},
					{
						"n": 18,
						"h": 101,
						"w": 556
					},
					{
						"n": 17,
						"h": 421,
						"w": 513
					},
					{
						"n": 19,
						"h": 284,
						"w": 426
					},
					{
						"n": 20,
						"h": 145,
						"w": 557,
						"m": 620
					}
				],
				"ball": {
					"n": 0,
					"h": 305,
					"w": 163,
					"z": 0,
					"r": 0,
					"p": 1,
					"x": 0
				}
			},
			"interval": 8
		},
		{
			"num": 1574,
			"minute": 76,
			"messages": [
				{
					"owner": 2,
					"mes": "Ньялл Томпсон[38](Опава) подхватывает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 703
					},
					{
						"n": 2,
						"h": 375,
						"w": 343
					},
					{
						"n": 14,
						"h": 281,
						"w": 396
					},
					{
						"n": 13,
						"h": 177,
						"w": 407
					},
					{
						"n": 5,
						"h": 76,
						"w": 343
					},
					{
						"n": 6,
						"h": 340,
						"w": 193
					},
					{
						"n": 18,
						"h": 285,
						"w": 231
					},
					{
						"n": 15,
						"h": 167,
						"w": 170
					},
					{
						"n": 17,
						"h": 47,
						"w": 114
					},
					{
						"n": 20,
						"h": 286,
						"w": 84
					},
					{
						"n": 19,
						"h": 168,
						"w": 104
					}
				],
				"away": [
					{
						"n": 12,
						"h": 220,
						"w": 703
					},
					{
						"n": 13,
						"h": 387,
						"w": 640
					},
					{
						"n": 3,
						"h": 267,
						"w": 638
					},
					{
						"n": 14,
						"h": 183,
						"w": 653
					},
					{
						"n": 5,
						"h": 110,
						"w": 654
					},
					{
						"n": 16,
						"h": 229,
						"w": 571
					},
					{
						"n": 15,
						"h": 187,
						"w": 504
					},
					{
						"n": 18,
						"h": 85,
						"w": 518
					},
					{
						"n": 17,
						"h": 422,
						"w": 505
					},
					{
						"n": 19,
						"h": 275,
						"w": 421
					},
					{
						"n": 20,
						"h": 151,
						"w": 522,
						"m": 630
					}
				],
				"ball": {
					"n": 0,
					"h": 365,
					"w": 202,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 36
		},
		{
			"num": 1575,
			"minute": 77,
			"possession": 43,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 709
					},
					{
						"n": 2,
						"h": 368,
						"w": 382
					},
					{
						"n": 14,
						"h": 241,
						"w": 397
					},
					{
						"n": 13,
						"h": 169,
						"w": 422
					},
					{
						"n": 5,
						"h": 86,
						"w": 382
					},
					{
						"n": 6,
						"h": 368,
						"w": 222,
						"f": 77
					},
					{
						"n": 18,
						"h": 270,
						"w": 268
					},
					{
						"n": 15,
						"h": 174,
						"w": 209,
						"f": 94
					},
					{
						"n": 17,
						"h": 46,
						"w": 154
					},
					{
						"n": 20,
						"h": 280,
						"w": 123
					},
					{
						"n": 19,
						"h": 169,
						"w": 144
					}
				],
				"away": [
					{
						"n": 12,
						"h": 228,
						"w": 707
					},
					{
						"n": 13,
						"h": 390,
						"w": 600
					},
					{
						"n": 3,
						"h": 286,
						"w": 622
					},
					{
						"n": 14,
						"h": 170,
						"w": 617
					},
					{
						"n": 5,
						"h": 85,
						"w": 622
					},
					{
						"n": 16,
						"h": 220,
						"w": 532
					},
					{
						"n": 15,
						"h": 196,
						"w": 465
					},
					{
						"n": 18,
						"h": 54,
						"w": 501,
						"f": 93
					},
					{
						"n": 17,
						"h": 421,
						"w": 465
					},
					{
						"n": 19,
						"h": 284,
						"w": 382,
						"f": 91
					},
					{
						"n": 20,
						"h": 140,
						"w": 483,
						"f": 93
					}
				],
				"ball": {
					"n": 0,
					"h": 396,
					"w": 219,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1576,
			"minute": 77,
			"messages": [
				{
					"owner": 2,
					"mes": "Передача Т.Крамаржу[32](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 707
					},
					{
						"n": 2,
						"h": 334,
						"w": 440
					},
					{
						"n": 14,
						"h": 231,
						"w": 438
					},
					{
						"n": 13,
						"h": 151,
						"w": 434
					},
					{
						"n": 5,
						"h": 117,
						"w": 441
					},
					{
						"n": 6,
						"h": 380,
						"w": 288
					},
					{
						"n": 18,
						"h": 291,
						"w": 332
					},
					{
						"n": 15,
						"h": 182,
						"w": 276
					},
					{
						"n": 17,
						"h": 49,
						"w": 221
					},
					{
						"n": 20,
						"h": 257,
						"w": 60
					},
					{
						"n": 19,
						"h": 172,
						"w": 211
					}
				],
				"away": [
					{
						"n": 12,
						"h": 163,
						"w": 691
					},
					{
						"n": 13,
						"h": 390,
						"w": 533
					},
					{
						"n": 3,
						"h": 270,
						"w": 610
					},
					{
						"n": 14,
						"h": 171,
						"w": 611
					},
					{
						"n": 5,
						"h": 75,
						"w": 610
					},
					{
						"n": 16,
						"h": 231,
						"w": 466
					},
					{
						"n": 15,
						"h": 217,
						"w": 402
					},
					{
						"n": 18,
						"h": 54,
						"w": 491,
						"m": 650
					},
					{
						"n": 17,
						"h": 414,
						"w": 398
					},
					{
						"n": 19,
						"h": 304,
						"w": 318
					},
					{
						"n": 20,
						"h": 143,
						"w": 416
					}
				],
				"ball": {
					"n": 0,
					"h": 287,
					"w": 29,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 67
		},
		{
			"num": 1577,
			"minute": 77,
			"messages": [
				{
					"owner": 2,
					"mes": "Пас вперед..."
				},
				{
					"owner": 2,
					"mes": "Вацлав Сланина[34](Опава) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 707
					},
					{
						"n": 2,
						"h": 330,
						"w": 463
					},
					{
						"n": 14,
						"h": 225,
						"w": 470
					},
					{
						"n": 13,
						"h": 141,
						"w": 450
					},
					{
						"n": 5,
						"h": 104,
						"w": 461
					},
					{
						"n": 6,
						"h": 387,
						"w": 322
					},
					{
						"n": 18,
						"h": 310,
						"w": 361
					},
					{
						"n": 15,
						"h": 184,
						"w": 311
					},
					{
						"n": 17,
						"h": 51,
						"w": 256
					},
					{
						"n": 20,
						"h": 272,
						"w": 92
					},
					{
						"n": 19,
						"h": 157,
						"w": 243
					}
				],
				"away": [
					{
						"n": 12,
						"h": 172,
						"w": 693
					},
					{
						"n": 13,
						"h": 391,
						"w": 498
					},
					{
						"n": 3,
						"h": 282,
						"w": 604
					},
					{
						"n": 14,
						"h": 166,
						"w": 622
					},
					{
						"n": 5,
						"h": 61,
						"w": 591
					},
					{
						"n": 16,
						"h": 232,
						"w": 490
					},
					{
						"n": 15,
						"h": 219,
						"w": 367
					},
					{
						"n": 18,
						"h": 43,
						"w": 458
					},
					{
						"n": 17,
						"h": 410,
						"w": 363
					},
					{
						"n": 19,
						"h": 307,
						"w": 283
					},
					{
						"n": 20,
						"h": 141,
						"w": 381
					}
				],
				"ball": {
					"n": 0,
					"h": 284,
					"w": 98,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 35
		},
		{
			"num": 1578,
			"minute": 77,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 703
					},
					{
						"n": 2,
						"h": 330,
						"w": 458
					},
					{
						"n": 14,
						"h": 264,
						"w": 462
					},
					{
						"n": 13,
						"h": 180,
						"w": 441
					},
					{
						"n": 5,
						"h": 78,
						"w": 431
					},
					{
						"n": 6,
						"h": 410,
						"w": 354
					},
					{
						"n": 18,
						"h": 296,
						"w": 382
					},
					{
						"n": 15,
						"h": 214,
						"w": 337
					},
					{
						"n": 17,
						"h": 45,
						"w": 296
					},
					{
						"n": 20,
						"h": 276,
						"w": 132
					},
					{
						"n": 19,
						"h": 144,
						"w": 281
					}
				],
				"away": [
					{
						"n": 12,
						"h": 212,
						"w": 701
					},
					{
						"n": 13,
						"h": 391,
						"w": 458
					},
					{
						"n": 3,
						"h": 275,
						"w": 598
					},
					{
						"n": 14,
						"h": 171,
						"w": 587
					},
					{
						"n": 5,
						"h": 75,
						"w": 594
					},
					{
						"n": 16,
						"h": 230,
						"w": 450
					},
					{
						"n": 15,
						"h": 225,
						"w": 371
					},
					{
						"n": 18,
						"h": 41,
						"w": 418
					},
					{
						"n": 17,
						"h": 414,
						"w": 324
					},
					{
						"n": 19,
						"h": 288,
						"w": 276
					},
					{
						"n": 20,
						"h": 146,
						"w": 342
					}
				],
				"ball": {
					"n": 0,
					"h": 279,
					"w": 133,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1579,
			"minute": 77,
			"messages": [
				{
					"owner": 2,
					"mes": "Пасует вперед..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 702
					},
					{
						"n": 2,
						"h": 330,
						"w": 472
					},
					{
						"n": 14,
						"h": 278,
						"w": 466
					},
					{
						"n": 13,
						"h": 161,
						"w": 481
					},
					{
						"n": 5,
						"h": 98,
						"w": 414
					},
					{
						"n": 6,
						"h": 394,
						"w": 370
					},
					{
						"n": 18,
						"h": 270,
						"w": 378
					},
					{
						"n": 15,
						"h": 227,
						"w": 285
					},
					{
						"n": 17,
						"h": 36,
						"w": 348
					},
					{
						"n": 20,
						"h": 278,
						"w": 184
					},
					{
						"n": 19,
						"h": 159,
						"w": 300
					}
				],
				"away": [
					{
						"n": 12,
						"h": 223,
						"w": 708
					},
					{
						"n": 13,
						"h": 398,
						"w": 463
					},
					{
						"n": 3,
						"h": 270,
						"w": 609
					},
					{
						"n": 14,
						"h": 183,
						"w": 606
					},
					{
						"n": 5,
						"h": 58,
						"w": 592
					},
					{
						"n": 16,
						"h": 223,
						"w": 435
					},
					{
						"n": 15,
						"h": 188,
						"w": 374
					},
					{
						"n": 18,
						"h": 34,
						"w": 365
					},
					{
						"n": 17,
						"h": 361,
						"w": 326
					},
					{
						"n": 19,
						"h": 315,
						"w": 276
					},
					{
						"n": 20,
						"h": 154,
						"w": 289
					}
				],
				"ball": {
					"n": 0,
					"h": 227,
					"w": 285,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 53
		},
		{
			"num": 1580,
			"minute": 77,
			"messages": [
				{
					"owner": 2,
					"mes": "Михаэль Владарж[36](Опава) укрывает мяч корпусом..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 701
					},
					{
						"n": 2,
						"h": 330,
						"w": 482
					},
					{
						"n": 14,
						"h": 278,
						"w": 476
					},
					{
						"n": 13,
						"h": 161,
						"w": 491
					},
					{
						"n": 5,
						"h": 96,
						"w": 424
					},
					{
						"n": 6,
						"h": 394,
						"w": 361
					},
					{
						"n": 18,
						"h": 268,
						"w": 387
					},
					{
						"n": 15,
						"h": 227,
						"w": 288
					},
					{
						"n": 17,
						"h": 36,
						"w": 348
					},
					{
						"n": 20,
						"h": 278,
						"w": 194
					},
					{
						"n": 19,
						"h": 161,
						"w": 309
					}
				],
				"away": [
					{
						"n": 12,
						"h": 228,
						"w": 709
					},
					{
						"n": 13,
						"h": 401,
						"w": 453
					},
					{
						"n": 3,
						"h": 271,
						"w": 599
					},
					{
						"n": 14,
						"h": 182,
						"w": 597
					},
					{
						"n": 5,
						"h": 60,
						"w": 583
					},
					{
						"n": 16,
						"h": 221,
						"w": 445
					},
					{
						"n": 15,
						"h": 195,
						"w": 367
					},
					{
						"n": 18,
						"h": 38,
						"w": 374
					},
					{
						"n": 17,
						"h": 351,
						"w": 325
					},
					{
						"n": 19,
						"h": 311,
						"w": 267
					},
					{
						"n": 20,
						"h": 153,
						"w": 279
					}
				],
				"ball": {
					"n": 0,
					"h": 229,
					"w": 275,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 10
		},
		{
			"num": 1581,
			"minute": 77,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 705
					},
					{
						"n": 2,
						"h": 330,
						"w": 515
					},
					{
						"n": 14,
						"h": 272,
						"w": 502
					},
					{
						"n": 13,
						"h": 183,
						"w": 524
					},
					{
						"n": 5,
						"h": 89,
						"w": 463
					},
					{
						"n": 6,
						"h": 394,
						"w": 342
					},
					{
						"n": 18,
						"h": 268,
						"w": 422
					},
					{
						"n": 15,
						"h": 264,
						"w": 292
					},
					{
						"n": 17,
						"h": 35,
						"w": 368
					},
					{
						"n": 20,
						"h": 278,
						"w": 234
					},
					{
						"n": 19,
						"h": 157,
						"w": 349
					}
				],
				"away": [
					{
						"n": 12,
						"h": 222,
						"w": 690
					},
					{
						"n": 13,
						"h": 409,
						"w": 417
					},
					{
						"n": 3,
						"h": 269,
						"w": 559
					},
					{
						"n": 14,
						"h": 187,
						"w": 557
					},
					{
						"n": 5,
						"h": 62,
						"w": 543
					},
					{
						"n": 16,
						"h": 185,
						"w": 445
					},
					{
						"n": 15,
						"h": 214,
						"w": 388
					},
					{
						"n": 18,
						"h": 39,
						"w": 393
					},
					{
						"n": 17,
						"h": 313,
						"w": 314
					},
					{
						"n": 19,
						"h": 297,
						"w": 230
					},
					{
						"n": 20,
						"h": 145,
						"w": 240
					}
				],
				"ball": {
					"n": 0,
					"h": 265,
					"w": 275,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1582,
			"minute": 77,
			"messages": [
				{
					"owner": 2,
					"mes": "Михаэль Владарж[36](Опава) навесной передачей отправляет мяч вперед на М.Томасова[37](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 710
					},
					{
						"n": 2,
						"h": 330,
						"w": 546
					},
					{
						"n": 14,
						"h": 274,
						"w": 539
					},
					{
						"n": 13,
						"h": 191,
						"w": 547
					},
					{
						"n": 5,
						"h": 125,
						"w": 512
					},
					{
						"n": 6,
						"h": 394,
						"w": 403
					},
					{
						"n": 18,
						"h": 213,
						"w": 450
					},
					{
						"n": 15,
						"h": 249,
						"w": 351
					},
					{
						"n": 17,
						"h": 56,
						"w": 369
					},
					{
						"n": 20,
						"h": 263,
						"w": 293
					},
					{
						"n": 19,
						"h": 162,
						"w": 334
					}
				],
				"away": [
					{
						"n": 12,
						"h": 226,
						"w": 666
					},
					{
						"n": 13,
						"h": 418,
						"w": 386
					},
					{
						"n": 3,
						"h": 272,
						"w": 515
					},
					{
						"n": 14,
						"h": 176,
						"w": 513
					},
					{
						"n": 5,
						"h": 59,
						"w": 521
					},
					{
						"n": 16,
						"h": 195,
						"w": 416
					},
					{
						"n": 15,
						"h": 226,
						"w": 329
					},
					{
						"n": 18,
						"h": 46,
						"w": 332
					},
					{
						"n": 17,
						"h": 262,
						"w": 280
					},
					{
						"n": 19,
						"h": 307,
						"w": 201
					},
					{
						"n": 20,
						"h": 145,
						"w": 193
					}
				],
				"ball": {
					"n": 0,
					"h": 188,
					"w": 440,
					"z": 1,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 61
		},
		{
			"num": 1583,
			"minute": 77,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 701
					},
					{
						"n": 2,
						"h": 330,
						"w": 568
					},
					{
						"n": 14,
						"h": 275,
						"w": 573
					},
					{
						"n": 13,
						"h": 190,
						"w": 587
					},
					{
						"n": 5,
						"h": 152,
						"w": 541
					},
					{
						"n": 6,
						"h": 394,
						"w": 443
					},
					{
						"n": 18,
						"h": 181,
						"w": 472
					},
					{
						"n": 15,
						"h": 229,
						"w": 386
					},
					{
						"n": 17,
						"h": 56,
						"w": 404
					},
					{
						"n": 20,
						"h": 254,
						"w": 333
					},
					{
						"n": 19,
						"h": 156,
						"w": 373
					}
				],
				"away": [
					{
						"n": 12,
						"h": 222,
						"w": 646
					},
					{
						"n": 13,
						"h": 403,
						"w": 351
					},
					{
						"n": 3,
						"h": 277,
						"w": 497
					},
					{
						"n": 14,
						"h": 168,
						"w": 485
					},
					{
						"n": 5,
						"h": 71,
						"w": 483
					},
					{
						"n": 16,
						"h": 202,
						"w": 376
					},
					{
						"n": 15,
						"h": 219,
						"w": 289
					},
					{
						"n": 18,
						"h": 40,
						"w": 293
					},
					{
						"n": 17,
						"h": 287,
						"w": 255
					},
					{
						"n": 19,
						"h": 291,
						"w": 176
					},
					{
						"n": 20,
						"h": 145,
						"w": 170
					}
				],
				"ball": {
					"n": 0,
					"h": 163,
					"w": 465,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1584,
			"minute": 77,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 701
					},
					{
						"n": 2,
						"h": 330,
						"w": 597
					},
					{
						"n": 14,
						"h": 287,
						"w": 591
					},
					{
						"n": 13,
						"h": 169,
						"w": 593
					},
					{
						"n": 5,
						"h": 134,
						"w": 574
					},
					{
						"n": 6,
						"h": 394,
						"w": 481
					},
					{
						"n": 18,
						"h": 155,
						"w": 500
					},
					{
						"n": 15,
						"h": 216,
						"w": 422
					},
					{
						"n": 17,
						"h": 56,
						"w": 428
					},
					{
						"n": 20,
						"h": 249,
						"w": 370
					},
					{
						"n": 19,
						"h": 159,
						"w": 382
					}
				],
				"away": [
					{
						"n": 12,
						"h": 220,
						"w": 630
					},
					{
						"n": 13,
						"h": 410,
						"w": 328
					},
					{
						"n": 3,
						"h": 276,
						"w": 474
					},
					{
						"n": 14,
						"h": 166,
						"w": 461
					},
					{
						"n": 5,
						"h": 60,
						"w": 447
					},
					{
						"n": 16,
						"h": 206,
						"w": 338
					},
					{
						"n": 15,
						"h": 213,
						"w": 252
					},
					{
						"n": 18,
						"h": 47,
						"w": 255
					},
					{
						"n": 17,
						"h": 304,
						"w": 226
					},
					{
						"n": 19,
						"h": 306,
						"w": 156
					},
					{
						"n": 20,
						"h": 146,
						"w": 156
					}
				],
				"ball": {
					"n": 0,
					"h": 146,
					"w": 494,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 38
		},
		{
			"num": 1585,
			"minute": 77,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 218,
						"w": 707
					},
					{
						"n": 2,
						"h": 330,
						"w": 601
					},
					{
						"n": 14,
						"h": 288,
						"w": 614
					},
					{
						"n": 13,
						"h": 176,
						"w": 594
					},
					{
						"n": 5,
						"h": 120,
						"w": 603
					},
					{
						"n": 6,
						"h": 394,
						"w": 519
					},
					{
						"n": 18,
						"h": 130,
						"w": 536
					},
					{
						"n": 15,
						"h": 222,
						"w": 459
					},
					{
						"n": 17,
						"h": 56,
						"w": 440
					},
					{
						"n": 20,
						"h": 277,
						"w": 383
					},
					{
						"n": 19,
						"h": 195,
						"w": 394
					}
				],
				"away": [
					{
						"n": 12,
						"h": 228,
						"w": 611
					},
					{
						"n": 13,
						"h": 420,
						"w": 316
					},
					{
						"n": 3,
						"h": 277,
						"w": 466
					},
					{
						"n": 14,
						"h": 174,
						"w": 470
					},
					{
						"n": 5,
						"h": 64,
						"w": 474
					},
					{
						"n": 16,
						"h": 240,
						"w": 341
					},
					{
						"n": 15,
						"h": 214,
						"w": 214
					},
					{
						"n": 18,
						"h": 49,
						"w": 217
					},
					{
						"n": 17,
						"h": 321,
						"w": 195
					},
					{
						"n": 19,
						"h": 288,
						"w": 133
					},
					{
						"n": 20,
						"h": 145,
						"w": 146
					}
				],
				"ball": {
					"n": 0,
					"h": 129,
					"w": 525,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 38
		},
		{
			"num": 1586,
			"minute": 77,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 706
					},
					{
						"n": 2,
						"h": 330,
						"w": 625
					},
					{
						"n": 14,
						"h": 293,
						"w": 607
					},
					{
						"n": 13,
						"h": 186,
						"w": 611
					},
					{
						"n": 5,
						"h": 150,
						"w": 578
					},
					{
						"n": 6,
						"h": 394,
						"w": 559
					},
					{
						"n": 18,
						"h": 162,
						"w": 557
					},
					{
						"n": 15,
						"h": 226,
						"w": 499
					},
					{
						"n": 17,
						"h": 56,
						"w": 479
					},
					{
						"n": 20,
						"h": 293,
						"w": 384
					},
					{
						"n": 19,
						"h": 212,
						"w": 430
					}
				],
				"away": [
					{
						"n": 12,
						"h": 228,
						"w": 599
					},
					{
						"n": 13,
						"h": 416,
						"w": 276
					},
					{
						"n": 3,
						"h": 279,
						"w": 458
					},
					{
						"n": 14,
						"h": 185,
						"w": 432
					},
					{
						"n": 5,
						"h": 63,
						"w": 434
					},
					{
						"n": 16,
						"h": 235,
						"w": 301
					},
					{
						"n": 15,
						"h": 223,
						"w": 175
					},
					{
						"n": 18,
						"h": 48,
						"w": 177
					},
					{
						"n": 17,
						"h": 285,
						"w": 186
					},
					{
						"n": 19,
						"h": 308,
						"w": 150
					},
					{
						"n": 20,
						"h": 125,
						"w": 122
					}
				],
				"ball": {
					"n": 0,
					"h": 165,
					"w": 534,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1587,
			"minute": 77,
			"messages": [
				{
					"owner": 2,
					"mes": "М.Томасов[37](Опава) снабжает мячом открывшегося А.Карабеца[35](Опава)..."
				},
				{
					"owner": 2,
					"mes": "Адам Карабец[35](Опава) достает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 705
					},
					{
						"n": 2,
						"h": 330,
						"w": 617
					},
					{
						"n": 14,
						"h": 267,
						"w": 632
					},
					{
						"n": 13,
						"h": 221,
						"w": 606
					},
					{
						"n": 5,
						"h": 175,
						"w": 609
					},
					{
						"n": 6,
						"h": 381,
						"w": 597
					},
					{
						"n": 18,
						"h": 202,
						"w": 556
					},
					{
						"n": 15,
						"h": 187,
						"w": 511
					},
					{
						"n": 17,
						"h": 56,
						"w": 518
					},
					{
						"n": 20,
						"h": 262,
						"w": 409
					},
					{
						"n": 19,
						"h": 186,
						"w": 400
					}
				],
				"away": [
					{
						"n": 12,
						"h": 222,
						"w": 601
					},
					{
						"n": 13,
						"h": 408,
						"w": 237
					},
					{
						"n": 3,
						"h": 279,
						"w": 440
					},
					{
						"n": 14,
						"h": 174,
						"w": 437
					},
					{
						"n": 5,
						"h": 65,
						"w": 430
					},
					{
						"n": 16,
						"h": 211,
						"w": 312
					},
					{
						"n": 15,
						"h": 223,
						"w": 135
					},
					{
						"n": 18,
						"h": 59,
						"w": 139
					},
					{
						"n": 17,
						"h": 285,
						"w": 186
					},
					{
						"n": 19,
						"h": 282,
						"w": 119
					},
					{
						"n": 20,
						"h": 164,
						"w": 113
					}
				],
				"ball": {
					"n": 0,
					"h": 227,
					"w": 585,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1588,
			"minute": 77,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 705
					},
					{
						"n": 2,
						"h": 330,
						"w": 625
					},
					{
						"n": 14,
						"h": 277,
						"w": 633
					},
					{
						"n": 13,
						"h": 227,
						"w": 596
					},
					{
						"n": 5,
						"h": 181,
						"w": 620
					},
					{
						"n": 6,
						"h": 378,
						"w": 608
					},
					{
						"n": 18,
						"h": 214,
						"w": 554
					},
					{
						"n": 15,
						"h": 185,
						"w": 523
					},
					{
						"n": 17,
						"h": 56,
						"w": 530
					},
					{
						"n": 20,
						"h": 255,
						"w": 419
					},
					{
						"n": 19,
						"h": 175,
						"w": 394
					}
				],
				"away": [
					{
						"n": 12,
						"h": 221,
						"w": 602
					},
					{
						"n": 13,
						"h": 406,
						"w": 225
					},
					{
						"n": 3,
						"h": 286,
						"w": 436
					},
					{
						"n": 14,
						"h": 177,
						"w": 436
					},
					{
						"n": 5,
						"h": 58,
						"w": 440
					},
					{
						"n": 16,
						"h": 212,
						"w": 300
					},
					{
						"n": 15,
						"h": 223,
						"w": 124
					},
					{
						"n": 18,
						"h": 60,
						"w": 133
					},
					{
						"n": 17,
						"h": 273,
						"w": 186
					},
					{
						"n": 19,
						"h": 276,
						"w": 109
					},
					{
						"n": 20,
						"h": 162,
						"w": 103
					}
				],
				"ball": {
					"n": 0,
					"h": 227,
					"w": 596,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 12
		},
		{
			"num": 1589,
			"minute": 77,
			"messages": [
				{
					"owner": 2,
					"mes": "А.Карабец[35](Опава) пытается пройти Б.Регана[13](Галвэй Юнайтед)..."
				},
				{
					"owner": 2,
					"mes": "Б.Реган[13](Галвэй Юнайтед) своевременно выбивает мяч у А.Карабеца[35](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 705
					},
					{
						"n": 2,
						"h": 330,
						"w": 625
					},
					{
						"n": 14,
						"h": 277,
						"w": 633
					},
					{
						"n": 13,
						"h": 233,
						"w": 588,
						"m": 620
					},
					{
						"n": 5,
						"h": 185,
						"w": 629
					},
					{
						"n": 6,
						"h": 375,
						"w": 618
					},
					{
						"n": 18,
						"h": 224,
						"w": 552
					},
					{
						"n": 15,
						"h": 183,
						"w": 533
					},
					{
						"n": 17,
						"h": 56,
						"w": 530
					},
					{
						"n": 20,
						"h": 249,
						"w": 427
					},
					{
						"n": 19,
						"h": 167,
						"w": 389
					}
				],
				"away": [
					{
						"n": 12,
						"h": 221,
						"w": 602
					},
					{
						"n": 13,
						"h": 404,
						"w": 216
					},
					{
						"n": 3,
						"h": 286,
						"w": 436
					},
					{
						"n": 14,
						"h": 177,
						"w": 436
					},
					{
						"n": 5,
						"h": 57,
						"w": 442
					},
					{
						"n": 16,
						"h": 213,
						"w": 290
					},
					{
						"n": 15,
						"h": 223,
						"w": 114,
						"m": 590
					},
					{
						"n": 18,
						"h": 60,
						"w": 133
					},
					{
						"n": 17,
						"h": 263,
						"w": 187
					},
					{
						"n": 19,
						"h": 273,
						"w": 105
					},
					{
						"n": 20,
						"h": 162,
						"w": 103
					}
				],
				"ball": {
					"n": 0,
					"h": 233,
					"w": 588,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 10
		},
		{
			"num": 1590,
			"minute": 77,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 708
					},
					{
						"n": 2,
						"h": 343,
						"w": 604
					},
					{
						"n": 14,
						"h": 278,
						"w": 594
					},
					{
						"n": 13,
						"h": 257,
						"w": 563
					},
					{
						"n": 5,
						"h": 155,
						"w": 603
					},
					{
						"n": 6,
						"h": 381,
						"w": 579
					},
					{
						"n": 18,
						"h": 243,
						"w": 517
					},
					{
						"n": 15,
						"h": 174,
						"w": 494
					},
					{
						"n": 17,
						"h": 52,
						"w": 490
					},
					{
						"n": 20,
						"h": 264,
						"w": 390
					},
					{
						"n": 19,
						"h": 157,
						"w": 350
					}
				],
				"away": [
					{
						"n": 12,
						"h": 229,
						"w": 641
					},
					{
						"n": 13,
						"h": 409,
						"w": 256
					},
					{
						"n": 3,
						"h": 277,
						"w": 471
					},
					{
						"n": 14,
						"h": 201,
						"w": 465
					},
					{
						"n": 5,
						"h": 89,
						"w": 466
					},
					{
						"n": 16,
						"h": 216,
						"w": 330
					},
					{
						"n": 15,
						"h": 223,
						"w": 124
					},
					{
						"n": 18,
						"h": 53,
						"w": 172
					},
					{
						"n": 17,
						"h": 224,
						"w": 180
					},
					{
						"n": 19,
						"h": 274,
						"w": 145
					},
					{
						"n": 20,
						"h": 176,
						"w": 140
					}
				],
				"ball": {
					"n": 0,
					"h": 257,
					"w": 563,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1591,
			"minute": 77,
			"messages": [
				{
					"owner": 1,
					"mes": "Передача направо..."
				},
				{
					"owner": 1,
					"mes": "Теперь с мячом Кевин Келли[15](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 702
					},
					{
						"n": 2,
						"h": 351,
						"w": 584
					},
					{
						"n": 14,
						"h": 277,
						"w": 557
					},
					{
						"n": 13,
						"h": 241,
						"w": 559
					},
					{
						"n": 5,
						"h": 130,
						"w": 575
					},
					{
						"n": 6,
						"h": 382,
						"w": 542
					},
					{
						"n": 18,
						"h": 258,
						"w": 483
					},
					{
						"n": 15,
						"h": 199,
						"w": 468
					},
					{
						"n": 17,
						"h": 47,
						"w": 454
					},
					{
						"n": 20,
						"h": 272,
						"w": 354
					},
					{
						"n": 19,
						"h": 148,
						"w": 314
					}
				],
				"away": [
					{
						"n": 12,
						"h": 226,
						"w": 647
					},
					{
						"n": 13,
						"h": 410,
						"w": 293
					},
					{
						"n": 3,
						"h": 288,
						"w": 467
					},
					{
						"n": 14,
						"h": 191,
						"w": 481
					},
					{
						"n": 5,
						"h": 110,
						"w": 461
					},
					{
						"n": 16,
						"h": 194,
						"w": 360
					},
					{
						"n": 15,
						"h": 225,
						"w": 161
					},
					{
						"n": 18,
						"h": 52,
						"w": 209
					},
					{
						"n": 17,
						"h": 254,
						"w": 201
					},
					{
						"n": 19,
						"h": 270,
						"w": 161
					},
					{
						"n": 20,
						"h": 181,
						"w": 177
					}
				],
				"ball": {
					"n": 0,
					"h": 199,
					"w": 468,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 37
		},
		{
			"num": 1592,
			"minute": 77,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 709
					},
					{
						"n": 2,
						"h": 365,
						"w": 546
					},
					{
						"n": 14,
						"h": 271,
						"w": 561
					},
					{
						"n": 13,
						"h": 221,
						"w": 560
					},
					{
						"n": 5,
						"h": 102,
						"w": 547
					},
					{
						"n": 6,
						"h": 390,
						"w": 502
					},
					{
						"n": 18,
						"h": 272,
						"w": 446
					},
					{
						"n": 15,
						"h": 199,
						"w": 433
					},
					{
						"n": 17,
						"h": 52,
						"w": 414
					},
					{
						"n": 20,
						"h": 278,
						"w": 314
					},
					{
						"n": 19,
						"h": 151,
						"w": 274
					}
				],
				"away": [
					{
						"n": 12,
						"h": 222,
						"w": 650
					},
					{
						"n": 13,
						"h": 406,
						"w": 332
					},
					{
						"n": 3,
						"h": 285,
						"w": 482
					},
					{
						"n": 14,
						"h": 192,
						"w": 491
					},
					{
						"n": 5,
						"h": 110,
						"w": 484
					},
					{
						"n": 16,
						"h": 175,
						"w": 395
					},
					{
						"n": 15,
						"h": 224,
						"w": 201
					},
					{
						"n": 18,
						"h": 46,
						"w": 248
					},
					{
						"n": 17,
						"h": 284,
						"w": 227
					},
					{
						"n": 19,
						"h": 265,
						"w": 201
					},
					{
						"n": 20,
						"h": 180,
						"w": 217
					}
				],
				"ball": {
					"n": 0,
					"h": 199,
					"w": 433,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1593,
			"minute": 77,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 704
					},
					{
						"n": 2,
						"h": 382,
						"w": 510
					},
					{
						"n": 14,
						"h": 270,
						"w": 547
					},
					{
						"n": 13,
						"h": 187,
						"w": 539
					},
					{
						"n": 5,
						"h": 79,
						"w": 514
					},
					{
						"n": 6,
						"h": 393,
						"w": 463
					},
					{
						"n": 18,
						"h": 280,
						"w": 407
					},
					{
						"n": 15,
						"h": 199,
						"w": 398
					},
					{
						"n": 17,
						"h": 52,
						"w": 374
					},
					{
						"n": 20,
						"h": 277,
						"w": 274
					},
					{
						"n": 19,
						"h": 151,
						"w": 256
					}
				],
				"away": [
					{
						"n": 12,
						"h": 224,
						"w": 646
					},
					{
						"n": 13,
						"h": 399,
						"w": 372
					},
					{
						"n": 3,
						"h": 282,
						"w": 493
					},
					{
						"n": 14,
						"h": 192,
						"w": 509
					},
					{
						"n": 5,
						"h": 110,
						"w": 500
					},
					{
						"n": 16,
						"h": 209,
						"w": 373
					},
					{
						"n": 15,
						"h": 222,
						"w": 241
					},
					{
						"n": 18,
						"h": 39,
						"w": 288
					},
					{
						"n": 17,
						"h": 315,
						"w": 253
					},
					{
						"n": 19,
						"h": 271,
						"w": 240
					},
					{
						"n": 20,
						"h": 175,
						"w": 256
					}
				],
				"ball": {
					"n": 0,
					"h": 199,
					"w": 398,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1594,
			"minute": 77,
			"messages": [
				{
					"owner": 1,
					"mes": "Пас вперед..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 709
					},
					{
						"n": 2,
						"h": 379,
						"w": 478
					},
					{
						"n": 14,
						"h": 285,
						"w": 536
					},
					{
						"n": 13,
						"h": 189,
						"w": 522
					},
					{
						"n": 5,
						"h": 71,
						"w": 479
					},
					{
						"n": 6,
						"h": 396,
						"w": 427
					},
					{
						"n": 18,
						"h": 295,
						"w": 419
					},
					{
						"n": 15,
						"h": 196,
						"w": 387
					},
					{
						"n": 17,
						"h": 55,
						"w": 338
					},
					{
						"n": 20,
						"h": 291,
						"w": 241
					},
					{
						"n": 19,
						"h": 130,
						"w": 279
					}
				],
				"away": [
					{
						"n": 12,
						"h": 235,
						"w": 647
					},
					{
						"n": 13,
						"h": 394,
						"w": 377
					},
					{
						"n": 3,
						"h": 288,
						"w": 522
					},
					{
						"n": 14,
						"h": 193,
						"w": 513
					},
					{
						"n": 5,
						"h": 110,
						"w": 536
					},
					{
						"n": 16,
						"h": 236,
						"w": 396
					},
					{
						"n": 15,
						"h": 221,
						"w": 277
					},
					{
						"n": 18,
						"h": 37,
						"w": 324
					},
					{
						"n": 17,
						"h": 337,
						"w": 281
					},
					{
						"n": 19,
						"h": 280,
						"w": 275
					},
					{
						"n": 20,
						"h": 165,
						"w": 291
					}
				],
				"ball": {
					"n": 0,
					"h": 138,
					"w": 308,
					"z": 0,
					"r": 0,
					"p": 1,
					"x": 0
				}
			},
			"interval": 36
		},
		{
			"num": 1595,
			"minute": 77,
			"messages": [
				{
					"owner": 1,
					"mes": "Байрон О`Горман[19](Галвэй Юнайтед) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 703
					},
					{
						"n": 2,
						"h": 376,
						"w": 464
					},
					{
						"n": 14,
						"h": 284,
						"w": 522
					},
					{
						"n": 13,
						"h": 181,
						"w": 510
					},
					{
						"n": 5,
						"h": 66,
						"w": 466
					},
					{
						"n": 6,
						"h": 397,
						"w": 413
					},
					{
						"n": 18,
						"h": 294,
						"w": 405
					},
					{
						"n": 15,
						"h": 194,
						"w": 373
					},
					{
						"n": 17,
						"h": 53,
						"w": 324
					},
					{
						"n": 20,
						"h": 288,
						"w": 227
					},
					{
						"n": 19,
						"h": 130,
						"w": 296
					}
				],
				"away": [
					{
						"n": 12,
						"h": 235,
						"w": 646
					},
					{
						"n": 13,
						"h": 395,
						"w": 391
					},
					{
						"n": 3,
						"h": 288,
						"w": 536
					},
					{
						"n": 14,
						"h": 194,
						"w": 527
					},
					{
						"n": 5,
						"h": 110,
						"w": 550
					},
					{
						"n": 16,
						"h": 248,
						"w": 404
					},
					{
						"n": 15,
						"h": 223,
						"w": 291
					},
					{
						"n": 18,
						"h": 39,
						"w": 338
					},
					{
						"n": 17,
						"h": 337,
						"w": 281
					},
					{
						"n": 19,
						"h": 276,
						"w": 289
					},
					{
						"n": 20,
						"h": 162,
						"w": 304
					}
				],
				"ball": {
					"n": 0,
					"h": 130,
					"w": 296,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 14
		},
		{
			"num": 1596,
			"minute": 78,
			"possession": 43,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 707
					},
					{
						"n": 2,
						"h": 389,
						"w": 426,
						"f": 78
					},
					{
						"n": 14,
						"h": 283,
						"w": 487
					},
					{
						"n": 13,
						"h": 171,
						"w": 471,
						"f": 94
					},
					{
						"n": 5,
						"h": 59,
						"w": 430
					},
					{
						"n": 6,
						"h": 396,
						"w": 373
					},
					{
						"n": 18,
						"h": 284,
						"w": 366,
						"f": 94
					},
					{
						"n": 15,
						"h": 182,
						"w": 335
					},
					{
						"n": 17,
						"h": 54,
						"w": 284,
						"f": 87
					},
					{
						"n": 20,
						"h": 282,
						"w": 195,
						"f": 85
					},
					{
						"n": 19,
						"h": 135,
						"w": 261,
						"f": 92
					}
				],
				"away": [
					{
						"n": 12,
						"h": 235,
						"w": 642
					},
					{
						"n": 13,
						"h": 395,
						"w": 431
					},
					{
						"n": 3,
						"h": 302,
						"w": 498
					},
					{
						"n": 14,
						"h": 203,
						"w": 564
					},
					{
						"n": 5,
						"h": 110,
						"w": 569
					},
					{
						"n": 16,
						"h": 272,
						"w": 436,
						"f": 94
					},
					{
						"n": 15,
						"h": 223,
						"w": 331
					},
					{
						"n": 18,
						"h": 51,
						"w": 376
					},
					{
						"n": 17,
						"h": 356,
						"w": 309,
						"m": 660
					},
					{
						"n": 19,
						"h": 281,
						"w": 328
					},
					{
						"n": 20,
						"h": 164,
						"w": 344
					}
				],
				"ball": {
					"n": 0,
					"h": 135,
					"w": 261,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1597,
			"minute": 78,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 703
					},
					{
						"n": 2,
						"h": 376,
						"w": 418
					},
					{
						"n": 14,
						"h": 279,
						"w": 460
					},
					{
						"n": 13,
						"h": 172,
						"w": 468
					},
					{
						"n": 5,
						"h": 58,
						"w": 404
					},
					{
						"n": 6,
						"h": 399,
						"w": 333
					},
					{
						"n": 18,
						"h": 286,
						"w": 326
					},
					{
						"n": 15,
						"h": 173,
						"w": 296
					},
					{
						"n": 17,
						"h": 53,
						"w": 244
					},
					{
						"n": 20,
						"h": 273,
						"w": 164
					},
					{
						"n": 19,
						"h": 163,
						"w": 233
					}
				],
				"away": [
					{
						"n": 12,
						"h": 235,
						"w": 647
					},
					{
						"n": 13,
						"h": 396,
						"w": 471
					},
					{
						"n": 3,
						"h": 283,
						"w": 507
					},
					{
						"n": 14,
						"h": 201,
						"w": 604
					},
					{
						"n": 5,
						"h": 110,
						"w": 603
					},
					{
						"n": 16,
						"h": 251,
						"w": 470
					},
					{
						"n": 15,
						"h": 227,
						"w": 371
					},
					{
						"n": 18,
						"h": 51,
						"w": 416
					},
					{
						"n": 17,
						"h": 375,
						"w": 344
					},
					{
						"n": 19,
						"h": 288,
						"w": 368
					},
					{
						"n": 20,
						"h": 171,
						"w": 384
					}
				],
				"ball": {
					"n": 0,
					"h": 163,
					"w": 233,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1598,
			"minute": 78,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 704
					},
					{
						"n": 2,
						"h": 377,
						"w": 413
					},
					{
						"n": 14,
						"h": 279,
						"w": 455
					},
					{
						"n": 13,
						"h": 171,
						"w": 463
					},
					{
						"n": 5,
						"h": 58,
						"w": 399
					},
					{
						"n": 6,
						"h": 398,
						"w": 328
					},
					{
						"n": 18,
						"h": 287,
						"w": 331
					},
					{
						"n": 15,
						"h": 173,
						"w": 291
					},
					{
						"n": 17,
						"h": 52,
						"w": 239
					},
					{
						"n": 20,
						"h": 277,
						"w": 161
					},
					{
						"n": 19,
						"h": 164,
						"w": 228
					}
				],
				"away": [
					{
						"n": 12,
						"h": 235,
						"w": 645
					},
					{
						"n": 13,
						"h": 396,
						"w": 476
					},
					{
						"n": 3,
						"h": 284,
						"w": 502
					},
					{
						"n": 14,
						"h": 203,
						"w": 600
					},
					{
						"n": 5,
						"h": 110,
						"w": 602
					},
					{
						"n": 16,
						"h": 248,
						"w": 474
					},
					{
						"n": 15,
						"h": 226,
						"w": 376
					},
					{
						"n": 18,
						"h": 51,
						"w": 421
					},
					{
						"n": 17,
						"h": 378,
						"w": 349
					},
					{
						"n": 19,
						"h": 287,
						"w": 373
					},
					{
						"n": 20,
						"h": 170,
						"w": 389
					}
				],
				"ball": {
					"n": 0,
					"h": 164,
					"w": 228,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 5
		},
		{
			"num": 1599,
			"minute": 78,
			"messages": [
				{
					"owner": 1,
					"mes": "Байрон О`Горман[19](Галвэй Юнайтед) один в один пытается обыграть Н.Мансура[23](Опава)..."
				},
				{
					"owner": 1,
					"mes": "Нир Мансур[23](Опава) отбирает мяч у Б.О`Гормана[19](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 705
					},
					{
						"n": 2,
						"h": 379,
						"w": 408
					},
					{
						"n": 14,
						"h": 278,
						"w": 450
					},
					{
						"n": 13,
						"h": 170,
						"w": 458
					},
					{
						"n": 5,
						"h": 58,
						"w": 394
					},
					{
						"n": 6,
						"h": 398,
						"w": 323
					},
					{
						"n": 18,
						"h": 288,
						"w": 336
					},
					{
						"n": 15,
						"h": 173,
						"w": 286
					},
					{
						"n": 17,
						"h": 52,
						"w": 234
					},
					{
						"n": 20,
						"h": 281,
						"w": 157
					},
					{
						"n": 19,
						"h": 165,
						"w": 219,
						"m": 650
					}
				],
				"away": [
					{
						"n": 12,
						"h": 235,
						"w": 645
					},
					{
						"n": 13,
						"h": 396,
						"w": 481
					},
					{
						"n": 3,
						"h": 285,
						"w": 497,
						"m": 690
					},
					{
						"n": 14,
						"h": 205,
						"w": 595
					},
					{
						"n": 5,
						"h": 110,
						"w": 602
					},
					{
						"n": 16,
						"h": 245,
						"w": 478
					},
					{
						"n": 15,
						"h": 226,
						"w": 381
					},
					{
						"n": 18,
						"h": 51,
						"w": 423
					},
					{
						"n": 17,
						"h": 380,
						"w": 353
					},
					{
						"n": 19,
						"h": 286,
						"w": 378
					},
					{
						"n": 20,
						"h": 169,
						"w": 394
					}
				],
				"ball": {
					"n": 0,
					"h": 165,
					"w": 223,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 5
		},
		{
			"num": 1600,
			"minute": 78,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 705
					},
					{
						"n": 2,
						"h": 381,
						"w": 398
					},
					{
						"n": 14,
						"h": 277,
						"w": 440
					},
					{
						"n": 13,
						"h": 168,
						"w": 448
					},
					{
						"n": 5,
						"h": 59,
						"w": 384
					},
					{
						"n": 6,
						"h": 397,
						"w": 313
					},
					{
						"n": 18,
						"h": 289,
						"w": 340
					},
					{
						"n": 15,
						"h": 173,
						"w": 276
					},
					{
						"n": 17,
						"h": 50,
						"w": 225
					},
					{
						"n": 20,
						"h": 289,
						"w": 151
					},
					{
						"n": 19,
						"h": 165,
						"w": 219
					}
				],
				"away": [
					{
						"n": 12,
						"h": 235,
						"w": 645
					},
					{
						"n": 13,
						"h": 396,
						"w": 491
					},
					{
						"n": 3,
						"h": 287,
						"w": 487
					},
					{
						"n": 14,
						"h": 210,
						"w": 586
					},
					{
						"n": 5,
						"h": 110,
						"w": 602
					},
					{
						"n": 16,
						"h": 239,
						"w": 486
					},
					{
						"n": 15,
						"h": 225,
						"w": 391
					},
					{
						"n": 18,
						"h": 51,
						"w": 423
					},
					{
						"n": 17,
						"h": 384,
						"w": 362
					},
					{
						"n": 19,
						"h": 285,
						"w": 388
					},
					{
						"n": 20,
						"h": 166,
						"w": 403
					}
				],
				"ball": {
					"n": 0,
					"h": 163,
					"w": 233,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 10
		},
		{
			"num": 1601,
			"minute": 78,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 706
					},
					{
						"n": 2,
						"h": 358,
						"w": 431
					},
					{
						"n": 14,
						"h": 243,
						"w": 460
					},
					{
						"n": 13,
						"h": 166,
						"w": 463
					},
					{
						"n": 5,
						"h": 67,
						"w": 398
					},
					{
						"n": 6,
						"h": 394,
						"w": 351
					},
					{
						"n": 18,
						"h": 255,
						"w": 360
					},
					{
						"n": 15,
						"h": 179,
						"w": 316
					},
					{
						"n": 17,
						"h": 54,
						"w": 264
					},
					{
						"n": 20,
						"h": 288,
						"w": 191
					},
					{
						"n": 19,
						"h": 157,
						"w": 225
					}
				],
				"away": [
					{
						"n": 12,
						"h": 227,
						"w": 684
					},
					{
						"n": 13,
						"h": 401,
						"w": 461
					},
					{
						"n": 3,
						"h": 322,
						"w": 487
					},
					{
						"n": 14,
						"h": 194,
						"w": 598
					},
					{
						"n": 5,
						"h": 73,
						"w": 591
					},
					{
						"n": 16,
						"h": 225,
						"w": 449
					},
					{
						"n": 15,
						"h": 219,
						"w": 351
					},
					{
						"n": 18,
						"h": 41,
						"w": 384
					},
					{
						"n": 17,
						"h": 413,
						"w": 342
					},
					{
						"n": 19,
						"h": 296,
						"w": 349
					},
					{
						"n": 20,
						"h": 150,
						"w": 367
					}
				],
				"ball": {
					"n": 0,
					"h": 128,
					"w": 233,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1602,
			"minute": 78,
			"messages": [
				{
					"owner": 2,
					"mes": "Справа просит мяч Михаэль Владарж[36](Опава)... Пас ему..."
				},
				{
					"owner": 2,
					"mes": "Михаэль Владарж[36](Опава) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 701
					},
					{
						"n": 2,
						"h": 345,
						"w": 457
					},
					{
						"n": 14,
						"h": 235,
						"w": 488
					},
					{
						"n": 13,
						"h": 152,
						"w": 487
					},
					{
						"n": 5,
						"h": 73,
						"w": 426
					},
					{
						"n": 6,
						"h": 394,
						"w": 364
					},
					{
						"n": 18,
						"h": 247,
						"w": 388
					},
					{
						"n": 15,
						"h": 195,
						"w": 292
					},
					{
						"n": 17,
						"h": 56,
						"w": 293
					},
					{
						"n": 20,
						"h": 289,
						"w": 220
					},
					{
						"n": 19,
						"h": 153,
						"w": 254
					}
				],
				"away": [
					{
						"n": 12,
						"h": 228,
						"w": 661
					},
					{
						"n": 13,
						"h": 402,
						"w": 432
					},
					{
						"n": 3,
						"h": 317,
						"w": 495
					},
					{
						"n": 14,
						"h": 185,
						"w": 586
					},
					{
						"n": 5,
						"h": 66,
						"w": 563
					},
					{
						"n": 16,
						"h": 239,
						"w": 461
					},
					{
						"n": 15,
						"h": 219,
						"w": 375
					},
					{
						"n": 18,
						"h": 53,
						"w": 391
					},
					{
						"n": 17,
						"h": 384,
						"w": 340
					},
					{
						"n": 19,
						"h": 303,
						"w": 321
					},
					{
						"n": 20,
						"h": 149,
						"w": 338
					}
				],
				"ball": {
					"n": 0,
					"h": 211,
					"w": 259,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 29
		},
		{
			"num": 1603,
			"minute": 78,
			"messages": [
				{
					"owner": 2,
					"mes": "Михаэль Владарж[36](Опава) отдает пас назад..."
				},
				{
					"owner": 2,
					"mes": "Теперь с мячом Вацлав Сланина[34](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 708
					},
					{
						"n": 2,
						"h": 309,
						"w": 461
					},
					{
						"n": 14,
						"h": 223,
						"w": 456
					},
					{
						"n": 13,
						"h": 167,
						"w": 475
					},
					{
						"n": 5,
						"h": 71,
						"w": 391
					},
					{
						"n": 6,
						"h": 408,
						"w": 360
					},
					{
						"n": 18,
						"h": 220,
						"w": 385
					},
					{
						"n": 15,
						"h": 191,
						"w": 329
					},
					{
						"n": 17,
						"h": 56,
						"w": 330
					},
					{
						"n": 20,
						"h": 286,
						"w": 257
					},
					{
						"n": 19,
						"h": 143,
						"w": 280
					}
				],
				"away": [
					{
						"n": 12,
						"h": 225,
						"w": 638
					},
					{
						"n": 13,
						"h": 413,
						"w": 468
					},
					{
						"n": 3,
						"h": 305,
						"w": 531
					},
					{
						"n": 14,
						"h": 197,
						"w": 565
					},
					{
						"n": 5,
						"h": 48,
						"w": 530
					},
					{
						"n": 16,
						"h": 235,
						"w": 452
					},
					{
						"n": 15,
						"h": 222,
						"w": 349
					},
					{
						"n": 18,
						"h": 33,
						"w": 418
					},
					{
						"n": 17,
						"h": 409,
						"w": 349
					},
					{
						"n": 19,
						"h": 296,
						"w": 285
					},
					{
						"n": 20,
						"h": 158,
						"w": 302
					}
				],
				"ball": {
					"n": 0,
					"h": 253,
					"w": 155,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 37
		},
		{
			"num": 1604,
			"minute": 78,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 709
					},
					{
						"n": 2,
						"h": 330,
						"w": 470
					},
					{
						"n": 14,
						"h": 263,
						"w": 454
					},
					{
						"n": 13,
						"h": 178,
						"w": 465
					},
					{
						"n": 5,
						"h": 72,
						"w": 399
					},
					{
						"n": 6,
						"h": 388,
						"w": 360
					},
					{
						"n": 18,
						"h": 260,
						"w": 388
					},
					{
						"n": 15,
						"h": 222,
						"w": 354
					},
					{
						"n": 17,
						"h": 42,
						"w": 344
					},
					{
						"n": 20,
						"h": 289,
						"w": 292
					},
					{
						"n": 19,
						"h": 160,
						"w": 309
					}
				],
				"away": [
					{
						"n": 12,
						"h": 225,
						"w": 630
					},
					{
						"n": 13,
						"h": 402,
						"w": 463
					},
					{
						"n": 3,
						"h": 291,
						"w": 524
					},
					{
						"n": 14,
						"h": 213,
						"w": 534
					},
					{
						"n": 5,
						"h": 37,
						"w": 524
					},
					{
						"n": 16,
						"h": 233,
						"w": 412
					},
					{
						"n": 15,
						"h": 229,
						"w": 341
					},
					{
						"n": 18,
						"h": 34,
						"w": 402
					},
					{
						"n": 17,
						"h": 408,
						"w": 341
					},
					{
						"n": 19,
						"h": 291,
						"w": 280
					},
					{
						"n": 20,
						"h": 166,
						"w": 280
					}
				],
				"ball": {
					"n": 0,
					"h": 237,
					"w": 186,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1605,
			"minute": 78,
			"messages": [
				{
					"owner": 2,
					"mes": "Вацлав Сланина[34](Опава) пасует на Т.Крамаржа[32](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 710
					},
					{
						"n": 2,
						"h": 330,
						"w": 456
					},
					{
						"n": 14,
						"h": 278,
						"w": 455
					},
					{
						"n": 13,
						"h": 168,
						"w": 440
					},
					{
						"n": 5,
						"h": 76,
						"w": 399
					},
					{
						"n": 6,
						"h": 403,
						"w": 360
					},
					{
						"n": 18,
						"h": 232,
						"w": 389
					},
					{
						"n": 15,
						"h": 213,
						"w": 358
					},
					{
						"n": 17,
						"h": 50,
						"w": 360
					},
					{
						"n": 20,
						"h": 275,
						"w": 297
					},
					{
						"n": 19,
						"h": 158,
						"w": 302
					}
				],
				"away": [
					{
						"n": 12,
						"h": 215,
						"w": 615
					},
					{
						"n": 13,
						"h": 416,
						"w": 463
					},
					{
						"n": 3,
						"h": 299,
						"w": 524
					},
					{
						"n": 14,
						"h": 209,
						"w": 533
					},
					{
						"n": 5,
						"h": 45,
						"w": 524
					},
					{
						"n": 16,
						"h": 229,
						"w": 402
					},
					{
						"n": 15,
						"h": 221,
						"w": 341
					},
					{
						"n": 18,
						"h": 32,
						"w": 402
					},
					{
						"n": 17,
						"h": 404,
						"w": 341
					},
					{
						"n": 19,
						"h": 292,
						"w": 280
					},
					{
						"n": 20,
						"h": 161,
						"w": 280
					}
				],
				"ball": {
					"n": 0,
					"h": 235,
					"w": 105,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1606,
			"minute": 78,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 704
					},
					{
						"n": 2,
						"h": 330,
						"w": 463
					},
					{
						"n": 14,
						"h": 273,
						"w": 450
					},
					{
						"n": 13,
						"h": 180,
						"w": 460
					},
					{
						"n": 5,
						"h": 82,
						"w": 439
					},
					{
						"n": 6,
						"h": 388,
						"w": 360
					},
					{
						"n": 18,
						"h": 266,
						"w": 368
					},
					{
						"n": 15,
						"h": 226,
						"w": 361
					},
					{
						"n": 17,
						"h": 56,
						"w": 394
					},
					{
						"n": 20,
						"h": 259,
						"w": 260
					},
					{
						"n": 19,
						"h": 132,
						"w": 280
					}
				],
				"away": [
					{
						"n": 12,
						"h": 250,
						"w": 615
					},
					{
						"n": 13,
						"h": 405,
						"w": 462
					},
					{
						"n": 3,
						"h": 301,
						"w": 523
					},
					{
						"n": 14,
						"h": 169,
						"w": 525
					},
					{
						"n": 5,
						"h": 43,
						"w": 523
					},
					{
						"n": 16,
						"h": 218,
						"w": 402
					},
					{
						"n": 15,
						"h": 229,
						"w": 341
					},
					{
						"n": 18,
						"h": 47,
						"w": 402
					},
					{
						"n": 17,
						"h": 414,
						"w": 341
					},
					{
						"n": 19,
						"h": 289,
						"w": 280
					},
					{
						"n": 20,
						"h": 159,
						"w": 280
					}
				],
				"ball": {
					"n": 0,
					"h": 200,
					"w": 105,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1607,
			"minute": 78,
			"messages": [
				{
					"owner": 2,
					"mes": "Передача направо..."
				},
				{
					"owner": 2,
					"mes": "Томаш Прохазка[25](Опава) с мячом..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 707
					},
					{
						"n": 2,
						"h": 330,
						"w": 451
					},
					{
						"n": 14,
						"h": 271,
						"w": 457
					},
					{
						"n": 13,
						"h": 176,
						"w": 465
					},
					{
						"n": 5,
						"h": 120,
						"w": 457
					},
					{
						"n": 6,
						"h": 402,
						"w": 360
					},
					{
						"n": 18,
						"h": 283,
						"w": 373
					},
					{
						"n": 15,
						"h": 220,
						"w": 358
					},
					{
						"n": 17,
						"h": 56,
						"w": 410
					},
					{
						"n": 20,
						"h": 292,
						"w": 295
					},
					{
						"n": 19,
						"h": 162,
						"w": 309
					}
				],
				"away": [
					{
						"n": 12,
						"h": 245,
						"w": 617,
						"m": 610
					},
					{
						"n": 13,
						"h": 402,
						"w": 475
					},
					{
						"n": 3,
						"h": 286,
						"w": 539
					},
					{
						"n": 14,
						"h": 167,
						"w": 539
					},
					{
						"n": 5,
						"h": 68,
						"w": 549
					},
					{
						"n": 16,
						"h": 232,
						"w": 410
					},
					{
						"n": 15,
						"h": 231,
						"w": 345
					},
					{
						"n": 18,
						"h": 33,
						"w": 410
					},
					{
						"n": 17,
						"h": 406,
						"w": 345
					},
					{
						"n": 19,
						"h": 302,
						"w": 280
					},
					{
						"n": 20,
						"h": 165,
						"w": 280
					}
				],
				"ball": {
					"n": 0,
					"h": 382,
					"w": 171,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 48
		},
		{
			"num": 1608,
			"minute": 78,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 705
					},
					{
						"n": 2,
						"h": 330,
						"w": 470
					},
					{
						"n": 14,
						"h": 272,
						"w": 470
					},
					{
						"n": 13,
						"h": 186,
						"w": 480
					},
					{
						"n": 5,
						"h": 120,
						"w": 477
					},
					{
						"n": 6,
						"h": 425,
						"w": 360
					},
					{
						"n": 18,
						"h": 287,
						"w": 376
					},
					{
						"n": 15,
						"h": 229,
						"w": 377
					},
					{
						"n": 17,
						"h": 56,
						"w": 413
					},
					{
						"n": 20,
						"h": 294,
						"w": 309
					},
					{
						"n": 19,
						"h": 157,
						"w": 292
					}
				],
				"away": [
					{
						"n": 12,
						"h": 215,
						"w": 627
					},
					{
						"n": 13,
						"h": 411,
						"w": 467
					},
					{
						"n": 3,
						"h": 293,
						"w": 529
					},
					{
						"n": 14,
						"h": 155,
						"w": 529
					},
					{
						"n": 5,
						"h": 50,
						"w": 519
					},
					{
						"n": 16,
						"h": 220,
						"w": 405
					},
					{
						"n": 15,
						"h": 220,
						"w": 342
					},
					{
						"n": 18,
						"h": 42,
						"w": 405
					},
					{
						"n": 17,
						"h": 399,
						"w": 342
					},
					{
						"n": 19,
						"h": 300,
						"w": 280
					},
					{
						"n": 20,
						"h": 148,
						"w": 280
					}
				],
				"ball": {
					"n": 0,
					"h": 400,
					"w": 201,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1609,
			"minute": 78,
			"messages": [
				{
					"owner": 2,
					"mes": "Томаш Прохазка[25](Опава) смотрит налево... Пас В.Сланине[34](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 703
					},
					{
						"n": 2,
						"h": 330,
						"w": 464
					},
					{
						"n": 14,
						"h": 287,
						"w": 470
					},
					{
						"n": 13,
						"h": 186,
						"w": 470
					},
					{
						"n": 5,
						"h": 120,
						"w": 454
					},
					{
						"n": 6,
						"h": 396,
						"w": 356
					},
					{
						"n": 18,
						"h": 258,
						"w": 375
					},
					{
						"n": 15,
						"h": 203,
						"w": 364
					},
					{
						"n": 17,
						"h": 56,
						"w": 415
					},
					{
						"n": 20,
						"h": 306,
						"w": 283
					},
					{
						"n": 19,
						"h": 174,
						"w": 303
					}
				],
				"away": [
					{
						"n": 12,
						"h": 220,
						"w": 614
					},
					{
						"n": 13,
						"h": 417,
						"w": 460
					},
					{
						"n": 3,
						"h": 300,
						"w": 519
					},
					{
						"n": 14,
						"h": 137,
						"w": 506
					},
					{
						"n": 5,
						"h": 40,
						"w": 519
					},
					{
						"n": 16,
						"h": 217,
						"w": 400
					},
					{
						"n": 15,
						"h": 216,
						"w": 340
					},
					{
						"n": 18,
						"h": 48,
						"w": 400
					},
					{
						"n": 17,
						"h": 403,
						"w": 340
					},
					{
						"n": 19,
						"h": 284,
						"w": 280
					},
					{
						"n": 20,
						"h": 151,
						"w": 280
					}
				],
				"ball": {
					"n": 0,
					"h": 313,
					"w": 214,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 29
		},
		{
			"num": 1610,
			"minute": 78,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 703
					},
					{
						"n": 2,
						"h": 330,
						"w": 499
					},
					{
						"n": 14,
						"h": 282,
						"w": 499
					},
					{
						"n": 13,
						"h": 173,
						"w": 508
					},
					{
						"n": 5,
						"h": 120,
						"w": 494
					},
					{
						"n": 6,
						"h": 394,
						"w": 380
					},
					{
						"n": 18,
						"h": 234,
						"w": 407
					},
					{
						"n": 15,
						"h": 210,
						"w": 403
					},
					{
						"n": 17,
						"h": 56,
						"w": 447
					},
					{
						"n": 20,
						"h": 330,
						"w": 264
					},
					{
						"n": 19,
						"h": 136,
						"w": 316
					}
				],
				"away": [
					{
						"n": 12,
						"h": 215,
						"w": 610
					},
					{
						"n": 13,
						"h": 400,
						"w": 442
					},
					{
						"n": 3,
						"h": 289,
						"w": 509
					},
					{
						"n": 14,
						"h": 120,
						"w": 476
					},
					{
						"n": 5,
						"h": 39,
						"w": 509
					},
					{
						"n": 16,
						"h": 220,
						"w": 375
					},
					{
						"n": 15,
						"h": 229,
						"w": 308
					},
					{
						"n": 18,
						"h": 46,
						"w": 375
					},
					{
						"n": 17,
						"h": 399,
						"w": 308
					},
					{
						"n": 19,
						"h": 292,
						"w": 241
					},
					{
						"n": 20,
						"h": 150,
						"w": 241
					}
				],
				"ball": {
					"n": 0,
					"h": 330,
					"w": 244,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1611,
			"minute": 78,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 708
					},
					{
						"n": 2,
						"h": 330,
						"w": 539
					},
					{
						"n": 14,
						"h": 280,
						"w": 539
					},
					{
						"n": 13,
						"h": 173,
						"w": 548
					},
					{
						"n": 5,
						"h": 120,
						"w": 534
					},
					{
						"n": 6,
						"h": 394,
						"w": 400
					},
					{
						"n": 18,
						"h": 253,
						"w": 442
					},
					{
						"n": 15,
						"h": 211,
						"w": 443
					},
					{
						"n": 17,
						"h": 56,
						"w": 486
					},
					{
						"n": 20,
						"h": 318,
						"w": 302
					},
					{
						"n": 19,
						"h": 161,
						"w": 284
					}
				],
				"away": [
					{
						"n": 12,
						"h": 215,
						"w": 594
					},
					{
						"n": 13,
						"h": 401,
						"w": 402
					},
					{
						"n": 3,
						"h": 277,
						"w": 471
					},
					{
						"n": 14,
						"h": 89,
						"w": 458
					},
					{
						"n": 5,
						"h": 52,
						"w": 471
					},
					{
						"n": 16,
						"h": 223,
						"w": 335
					},
					{
						"n": 15,
						"h": 228,
						"w": 268
					},
					{
						"n": 18,
						"h": 41,
						"w": 335
					},
					{
						"n": 17,
						"h": 405,
						"w": 269
					},
					{
						"n": 19,
						"h": 296,
						"w": 201
					},
					{
						"n": 20,
						"h": 152,
						"w": 201
					}
				],
				"ball": {
					"n": 0,
					"h": 361,
					"w": 262,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1612,
			"minute": 78,
			"messages": [
				{
					"owner": 2,
					"mes": "Вацлав Сланина[34](Опава) отправляет мяч налево Н.Мансуру[23](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 707
					},
					{
						"n": 2,
						"h": 330,
						"w": 557
					},
					{
						"n": 14,
						"h": 274,
						"w": 556
					},
					{
						"n": 13,
						"h": 176,
						"w": 546
					},
					{
						"n": 5,
						"h": 120,
						"w": 563
					},
					{
						"n": 6,
						"h": 394,
						"w": 446
					},
					{
						"n": 18,
						"h": 241,
						"w": 476
					},
					{
						"n": 15,
						"h": 186,
						"w": 449
					},
					{
						"n": 17,
						"h": 56,
						"w": 439
					},
					{
						"n": 20,
						"h": 313,
						"w": 349
					},
					{
						"n": 19,
						"h": 161,
						"w": 331
					}
				],
				"away": [
					{
						"n": 12,
						"h": 225,
						"w": 617
					},
					{
						"n": 13,
						"h": 406,
						"w": 356
					},
					{
						"n": 3,
						"h": 230,
						"w": 468
					},
					{
						"n": 14,
						"h": 99,
						"w": 462,
						"m": 680
					},
					{
						"n": 5,
						"h": 58,
						"w": 501
					},
					{
						"n": 16,
						"h": 222,
						"w": 382
					},
					{
						"n": 15,
						"h": 219,
						"w": 276
					},
					{
						"n": 18,
						"h": 38,
						"w": 289
					},
					{
						"n": 17,
						"h": 358,
						"w": 268
					},
					{
						"n": 19,
						"h": 290,
						"w": 172
					},
					{
						"n": 20,
						"h": 166,
						"w": 173
					}
				],
				"ball": {
					"n": 0,
					"h": 220,
					"w": 252,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 47
		},
		{
			"num": 1613,
			"minute": 78,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 706
					},
					{
						"n": 2,
						"h": 330,
						"w": 596
					},
					{
						"n": 14,
						"h": 269,
						"w": 595
					},
					{
						"n": 13,
						"h": 179,
						"w": 585
					},
					{
						"n": 5,
						"h": 140,
						"w": 582
					},
					{
						"n": 6,
						"h": 394,
						"w": 485
					},
					{
						"n": 18,
						"h": 234,
						"w": 514
					},
					{
						"n": 15,
						"h": 155,
						"w": 473
					},
					{
						"n": 17,
						"h": 56,
						"w": 418
					},
					{
						"n": 20,
						"h": 294,
						"w": 383
					},
					{
						"n": 19,
						"h": 197,
						"w": 317
					}
				],
				"away": [
					{
						"n": 12,
						"h": 225,
						"w": 602
					},
					{
						"n": 13,
						"h": 411,
						"w": 317
					},
					{
						"n": 3,
						"h": 226,
						"w": 434
					},
					{
						"n": 14,
						"h": 118,
						"w": 462
					},
					{
						"n": 5,
						"h": 76,
						"w": 460
					},
					{
						"n": 16,
						"h": 226,
						"w": 343
					},
					{
						"n": 15,
						"h": 223,
						"w": 238
					},
					{
						"n": 18,
						"h": 32,
						"w": 250
					},
					{
						"n": 17,
						"h": 324,
						"w": 250
					},
					{
						"n": 19,
						"h": 318,
						"w": 144
					},
					{
						"n": 20,
						"h": 149,
						"w": 144
					}
				],
				"ball": {
					"n": 0,
					"h": 224,
					"w": 286,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 1614,
			"minute": 78,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 706
					},
					{
						"n": 2,
						"h": 330,
						"w": 608
					},
					{
						"n": 14,
						"h": 287,
						"w": 603
					},
					{
						"n": 13,
						"h": 187,
						"w": 616
					},
					{
						"n": 5,
						"h": 151,
						"w": 582
					},
					{
						"n": 6,
						"h": 394,
						"w": 524
					},
					{
						"n": 18,
						"h": 232,
						"w": 541
					},
					{
						"n": 15,
						"h": 178,
						"w": 504
					},
					{
						"n": 17,
						"h": 56,
						"w": 457
					},
					{
						"n": 20,
						"h": 292,
						"w": 414
					},
					{
						"n": 19,
						"h": 220,
						"w": 340
					}
				],
				"away": [
					{
						"n": 12,
						"h": 228,
						"w": 595
					},
					{
						"n": 13,
						"h": 416,
						"w": 278
					},
					{
						"n": 3,
						"h": 230,
						"w": 400
					},
					{
						"n": 14,
						"h": 155,
						"w": 451
					},
					{
						"n": 5,
						"h": 56,
						"w": 426
					},
					{
						"n": 16,
						"h": 226,
						"w": 304
					},
					{
						"n": 15,
						"h": 218,
						"w": 199
					},
					{
						"n": 18,
						"h": 28,
						"w": 211
					},
					{
						"n": 17,
						"h": 286,
						"w": 259
					},
					{
						"n": 19,
						"h": 307,
						"w": 144
					},
					{
						"n": 20,
						"h": 133,
						"w": 144
					}
				],
				"ball": {
					"n": 0,
					"h": 220,
					"w": 320,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 1615,
			"minute": 78,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 702
					},
					{
						"n": 2,
						"h": 304,
						"w": 583
					},
					{
						"n": 14,
						"h": 273,
						"w": 610
					},
					{
						"n": 13,
						"h": 192,
						"w": 617
					},
					{
						"n": 5,
						"h": 153,
						"w": 583
					},
					{
						"n": 6,
						"h": 394,
						"w": 536
					},
					{
						"n": 18,
						"h": 267,
						"w": 530
					},
					{
						"n": 15,
						"h": 167,
						"w": 489
					},
					{
						"n": 17,
						"h": 56,
						"w": 497
					},
					{
						"n": 20,
						"h": 286,
						"w": 421
					},
					{
						"n": 19,
						"h": 190,
						"w": 357
					}
				],
				"away": [
					{
						"n": 12,
						"h": 230,
						"w": 599
					},
					{
						"n": 13,
						"h": 419,
						"w": 238
					},
					{
						"n": 3,
						"h": 260,
						"w": 383
					},
					{
						"n": 14,
						"h": 176,
						"w": 440
					},
					{
						"n": 5,
						"h": 57,
						"w": 437
					},
					{
						"n": 16,
						"h": 224,
						"w": 265
					},
					{
						"n": 15,
						"h": 226,
						"w": 174
					},
					{
						"n": 18,
						"h": 26,
						"w": 199
					},
					{
						"n": 17,
						"h": 279,
						"w": 238
					},
					{
						"n": 19,
						"h": 305,
						"w": 144
					},
					{
						"n": 20,
						"h": 138,
						"w": 144
					}
				],
				"ball": {
					"n": 0,
					"h": 190,
					"w": 337,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1616,
			"minute": 78,
			"messages": [
				{
					"owner": 2,
					"mes": "Пас направо Т.Прохазке[25](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 707
					},
					{
						"n": 2,
						"h": 330,
						"w": 569
					},
					{
						"n": 14,
						"h": 267,
						"w": 571
					},
					{
						"n": 13,
						"h": 190,
						"w": 583
					},
					{
						"n": 5,
						"h": 120,
						"w": 560
					},
					{
						"n": 6,
						"h": 394,
						"w": 535
					},
					{
						"n": 18,
						"h": 291,
						"w": 488
					},
					{
						"n": 15,
						"h": 193,
						"w": 449
					},
					{
						"n": 17,
						"h": 56,
						"w": 450
					},
					{
						"n": 20,
						"h": 257,
						"w": 439
					},
					{
						"n": 19,
						"h": 172,
						"w": 402
					}
				],
				"away": [
					{
						"n": 12,
						"h": 215,
						"w": 610
					},
					{
						"n": 13,
						"h": 408,
						"w": 285
					},
					{
						"n": 3,
						"h": 262,
						"w": 392
					},
					{
						"n": 14,
						"h": 171,
						"w": 488
					},
					{
						"n": 5,
						"h": 71,
						"w": 417
					},
					{
						"n": 16,
						"h": 193,
						"w": 301
					},
					{
						"n": 15,
						"h": 215,
						"w": 221
					},
					{
						"n": 18,
						"h": 40,
						"w": 200
					},
					{
						"n": 17,
						"h": 261,
						"w": 283
					},
					{
						"n": 19,
						"h": 276,
						"w": 173
					},
					{
						"n": 20,
						"h": 171,
						"w": 175
					}
				],
				"ball": {
					"n": 0,
					"h": 379,
					"w": 303,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 48
		},
		{
			"num": 1617,
			"minute": 78,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 707
					},
					{
						"n": 2,
						"h": 357,
						"w": 598
					},
					{
						"n": 14,
						"h": 289,
						"w": 603
					},
					{
						"n": 13,
						"h": 185,
						"w": 608
					},
					{
						"n": 5,
						"h": 120,
						"w": 599
					},
					{
						"n": 6,
						"h": 394,
						"w": 555
					},
					{
						"n": 18,
						"h": 290,
						"w": 526
					},
					{
						"n": 15,
						"h": 206,
						"w": 486
					},
					{
						"n": 17,
						"h": 56,
						"w": 489
					},
					{
						"n": 20,
						"h": 280,
						"w": 411
					},
					{
						"n": 19,
						"h": 169,
						"w": 429
					}
				],
				"away": [
					{
						"n": 12,
						"h": 228,
						"w": 593
					},
					{
						"n": 13,
						"h": 413,
						"w": 246
					},
					{
						"n": 3,
						"h": 277,
						"w": 428
					},
					{
						"n": 14,
						"h": 167,
						"w": 442
					},
					{
						"n": 5,
						"h": 75,
						"w": 383
					},
					{
						"n": 16,
						"h": 195,
						"w": 262
					},
					{
						"n": 15,
						"h": 203,
						"w": 183
					},
					{
						"n": 18,
						"h": 26,
						"w": 180
					},
					{
						"n": 17,
						"h": 231,
						"w": 257
					},
					{
						"n": 19,
						"h": 275,
						"w": 144
					},
					{
						"n": 20,
						"h": 137,
						"w": 156
					}
				],
				"ball": {
					"n": 0,
					"h": 375,
					"w": 337,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 1618,
			"minute": 78,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 705
					},
					{
						"n": 2,
						"h": 339,
						"w": 585
					},
					{
						"n": 14,
						"h": 294,
						"w": 609
					},
					{
						"n": 13,
						"h": 206,
						"w": 622
					},
					{
						"n": 5,
						"h": 120,
						"w": 617
					},
					{
						"n": 6,
						"h": 394,
						"w": 583
					},
					{
						"n": 18,
						"h": 252,
						"w": 536
					},
					{
						"n": 15,
						"h": 192,
						"w": 489
					},
					{
						"n": 17,
						"h": 56,
						"w": 528
					},
					{
						"n": 20,
						"h": 318,
						"w": 403
					},
					{
						"n": 19,
						"h": 169,
						"w": 422
					}
				],
				"away": [
					{
						"n": 12,
						"h": 229,
						"w": 594
					},
					{
						"n": 13,
						"h": 420,
						"w": 208
					},
					{
						"n": 3,
						"h": 281,
						"w": 452
					},
					{
						"n": 14,
						"h": 179,
						"w": 462
					},
					{
						"n": 5,
						"h": 79,
						"w": 349
					},
					{
						"n": 16,
						"h": 188,
						"w": 224
					},
					{
						"n": 15,
						"h": 200,
						"w": 174
					},
					{
						"n": 18,
						"h": 29,
						"w": 172
					},
					{
						"n": 17,
						"h": 252,
						"w": 241
					},
					{
						"n": 19,
						"h": 260,
						"w": 144
					},
					{
						"n": 20,
						"h": 103,
						"w": 144
					}
				],
				"ball": {
					"n": 0,
					"h": 371,
					"w": 371,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 1619,
			"minute": 78,
			"messages": [
				{
					"owner": 2,
					"mes": "Томаш Прохазка[25](Опава) отдает на Н.Томпсона[38](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 235,
						"w": 709
					},
					{
						"n": 2,
						"h": 364,
						"w": 628
					},
					{
						"n": 14,
						"h": 285,
						"w": 606
					},
					{
						"n": 13,
						"h": 186,
						"w": 608
					},
					{
						"n": 5,
						"h": 120,
						"w": 603
					},
					{
						"n": 6,
						"h": 397,
						"w": 540
					},
					{
						"n": 18,
						"h": 270,
						"w": 530
					},
					{
						"n": 15,
						"h": 234,
						"w": 497
					},
					{
						"n": 17,
						"h": 56,
						"w": 584
					},
					{
						"n": 20,
						"h": 288,
						"w": 381
					},
					{
						"n": 19,
						"h": 220,
						"w": 447
					}
				],
				"away": [
					{
						"n": 12,
						"h": 222,
						"w": 581
					},
					{
						"n": 13,
						"h": 396,
						"w": 171
					},
					{
						"n": 3,
						"h": 282,
						"w": 420
					},
					{
						"n": 14,
						"h": 170,
						"w": 435
					},
					{
						"n": 5,
						"h": 72,
						"w": 375
					},
					{
						"n": 16,
						"h": 214,
						"w": 229
					},
					{
						"n": 15,
						"h": 190,
						"w": 200
					},
					{
						"n": 18,
						"h": 53,
						"w": 180
					},
					{
						"n": 17,
						"h": 229,
						"w": 293
					},
					{
						"n": 19,
						"h": 279,
						"w": 131
					},
					{
						"n": 20,
						"h": 149,
						"w": 131
					}
				],
				"ball": {
					"n": 0,
					"h": 397,
					"w": 540,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 57
		},
		{
			"num": 1620,
			"minute": 78,
			"messages": [
				{
					"owner": 2,
					"mes": "Ньялл Томпсон[38](Опава) пробрасывает мяч влево..."
				},
				{
					"owner": 2,
					"mes": "Киэн Колман[06](Галвэй Юнайтед) выцарапывает мяч у Н.Томпсона[38](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 236,
						"w": 709
					},
					{
						"n": 2,
						"h": 365,
						"w": 623
					},
					{
						"n": 14,
						"h": 285,
						"w": 611
					},
					{
						"n": 13,
						"h": 186,
						"w": 613
					},
					{
						"n": 5,
						"h": 120,
						"w": 608
					},
					{
						"n": 6,
						"h": 397,
						"w": 535,
						"m": 910
					},
					{
						"n": 18,
						"h": 265,
						"w": 528
					},
					{
						"n": 15,
						"h": 235,
						"w": 502
					},
					{
						"n": 17,
						"h": 56,
						"w": 588
					},
					{
						"n": 20,
						"h": 284,
						"w": 378
					},
					{
						"n": 19,
						"h": 221,
						"w": 442
					}
				],
				"away": [
					{
						"n": 12,
						"h": 222,
						"w": 586
					},
					{
						"n": 13,
						"h": 399,
						"w": 167
					},
					{
						"n": 3,
						"h": 282,
						"w": 425
					},
					{
						"n": 14,
						"h": 171,
						"w": 440
					},
					{
						"n": 5,
						"h": 72,
						"w": 380
					},
					{
						"n": 16,
						"h": 213,
						"w": 224
					},
					{
						"n": 15,
						"h": 195,
						"w": 198
					},
					{
						"n": 18,
						"h": 53,
						"w": 175
					},
					{
						"n": 17,
						"h": 229,
						"w": 298
					},
					{
						"n": 19,
						"h": 283,
						"w": 128
					},
					{
						"n": 20,
						"h": 154,
						"w": 129
					}
				],
				"ball": {
					"n": 0,
					"h": 397,
					"w": 535,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 5
		},
		{
			"num": 1621,
			"minute": 79,
			"possession": 43,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 701
					},
					{
						"n": 2,
						"h": 373,
						"w": 584,
						"m": 690
					},
					{
						"n": 14,
						"h": 268,
						"w": 586
					},
					{
						"n": 13,
						"h": 171,
						"w": 576
					},
					{
						"n": 5,
						"h": 106,
						"w": 587,
						"f": 78
					},
					{
						"n": 6,
						"h": 428,
						"w": 518
					},
					{
						"n": 18,
						"h": 292,
						"w": 498
					},
					{
						"n": 15,
						"h": 220,
						"w": 465,
						"f": 93
					},
					{
						"n": 17,
						"h": 53,
						"w": 548
					},
					{
						"n": 20,
						"h": 292,
						"w": 338
					},
					{
						"n": 19,
						"h": 202,
						"w": 406
					}
				],
				"away": [
					{
						"n": 12,
						"h": 211,
						"w": 629,
						"f": 93
					},
					{
						"n": 13,
						"h": 404,
						"w": 207
					},
					{
						"n": 3,
						"h": 264,
						"w": 461
					},
					{
						"n": 14,
						"h": 175,
						"w": 473,
						"f": 87
					},
					{
						"n": 5,
						"h": 78,
						"w": 420,
						"f": 77
					},
					{
						"n": 16,
						"h": 208,
						"w": 264
					},
					{
						"n": 15,
						"h": 205,
						"w": 237,
						"f": 96
					},
					{
						"n": 18,
						"h": 50,
						"w": 189
					},
					{
						"n": 17,
						"h": 207,
						"w": 331,
						"f": 88
					},
					{
						"n": 19,
						"h": 269,
						"w": 165
					},
					{
						"n": 20,
						"h": 155,
						"w": 169
					}
				],
				"ball": {
					"n": 0,
					"h": 428,
					"w": 518,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1622,
			"minute": 79,
			"messages": [
				{
					"owner": 1,
					"mes": "Передача назад..."
				},
				{
					"owner": 1,
					"mes": "Тимо Эверс[02](Галвэй Юнайтед) останавливает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 703
					},
					{
						"n": 2,
						"h": 414,
						"w": 573
					},
					{
						"n": 14,
						"h": 273,
						"w": 545
					},
					{
						"n": 13,
						"h": 177,
						"w": 534
					},
					{
						"n": 5,
						"h": 94,
						"w": 562
					},
					{
						"n": 6,
						"h": 427,
						"w": 508
					},
					{
						"n": 18,
						"h": 319,
						"w": 465
					},
					{
						"n": 15,
						"h": 204,
						"w": 425
					},
					{
						"n": 17,
						"h": 56,
						"w": 505
					},
					{
						"n": 20,
						"h": 299,
						"w": 296
					},
					{
						"n": 19,
						"h": 187,
						"w": 366
					}
				],
				"away": [
					{
						"n": 12,
						"h": 205,
						"w": 646
					},
					{
						"n": 13,
						"h": 406,
						"w": 250
					},
					{
						"n": 3,
						"h": 245,
						"w": 499
					},
					{
						"n": 14,
						"h": 170,
						"w": 500
					},
					{
						"n": 5,
						"h": 77,
						"w": 463
					},
					{
						"n": 16,
						"h": 204,
						"w": 306
					},
					{
						"n": 15,
						"h": 211,
						"w": 279
					},
					{
						"n": 18,
						"h": 38,
						"w": 149
					},
					{
						"n": 17,
						"h": 249,
						"w": 335
					},
					{
						"n": 19,
						"h": 273,
						"w": 206
					},
					{
						"n": 20,
						"h": 146,
						"w": 211
					}
				],
				"ball": {
					"n": 0,
					"h": 414,
					"w": 573,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 43
		},
		{
			"num": 1623,
			"minute": 79,
			"messages": [
				{
					"owner": 1,
					"mes": "Тимо Эверс[02](Галвэй Юнайтед) отдает пас на Б.Регана[13](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 705
					},
					{
						"n": 2,
						"h": 405,
						"w": 539
					},
					{
						"n": 14,
						"h": 277,
						"w": 530
					},
					{
						"n": 13,
						"h": 172,
						"w": 473
					},
					{
						"n": 5,
						"h": 73,
						"w": 499
					},
					{
						"n": 6,
						"h": 424,
						"w": 442
					},
					{
						"n": 18,
						"h": 293,
						"w": 427
					},
					{
						"n": 15,
						"h": 168,
						"w": 369
					},
					{
						"n": 17,
						"h": 47,
						"w": 440
					},
					{
						"n": 20,
						"h": 307,
						"w": 258
					},
					{
						"n": 19,
						"h": 162,
						"w": 305
					}
				],
				"away": [
					{
						"n": 12,
						"h": 235,
						"w": 642
					},
					{
						"n": 13,
						"h": 406,
						"w": 316
					},
					{
						"n": 3,
						"h": 271,
						"w": 500
					},
					{
						"n": 14,
						"h": 165,
						"w": 489
					},
					{
						"n": 5,
						"h": 110,
						"w": 501
					},
					{
						"n": 16,
						"h": 245,
						"w": 358
					},
					{
						"n": 15,
						"h": 214,
						"w": 345
					},
					{
						"n": 18,
						"h": 38,
						"w": 215
					},
					{
						"n": 17,
						"h": 315,
						"w": 341
					},
					{
						"n": 19,
						"h": 278,
						"w": 267
					},
					{
						"n": 20,
						"h": 139,
						"w": 277
					}
				],
				"ball": {
					"n": 0,
					"h": 172,
					"w": 473,
					"z": 1,
					"r": 1,
					"p": 0,
					"x": 0
				}
			},
			"interval": 66
		},
		{
			"num": 1624,
			"minute": 79,
			"messages": [
				{
					"owner": 1,
					"mes": "Билли Реган[13](Галвэй Юнайтед) теряет контроль над мячом..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 706
					},
					{
						"n": 2,
						"h": 403,
						"w": 532
					},
					{
						"n": 14,
						"h": 271,
						"w": 527
					},
					{
						"n": 13,
						"h": 172,
						"w": 473
					},
					{
						"n": 5,
						"h": 71,
						"w": 492
					},
					{
						"n": 6,
						"h": 424,
						"w": 435
					},
					{
						"n": 18,
						"h": 291,
						"w": 433
					},
					{
						"n": 15,
						"h": 164,
						"w": 364
					},
					{
						"n": 17,
						"h": 48,
						"w": 433
					},
					{
						"n": 20,
						"h": 302,
						"w": 253
					},
					{
						"n": 19,
						"h": 159,
						"w": 298
					}
				],
				"away": [
					{
						"n": 12,
						"h": 235,
						"w": 641
					},
					{
						"n": 13,
						"h": 407,
						"w": 323
					},
					{
						"n": 3,
						"h": 272,
						"w": 495
					},
					{
						"n": 14,
						"h": 168,
						"w": 495
					},
					{
						"n": 5,
						"h": 110,
						"w": 494
					},
					{
						"n": 16,
						"h": 243,
						"w": 365
					},
					{
						"n": 15,
						"h": 218,
						"w": 351
					},
					{
						"n": 18,
						"h": 38,
						"w": 222
					},
					{
						"n": 17,
						"h": 322,
						"w": 342
					},
					{
						"n": 19,
						"h": 275,
						"w": 260
					},
					{
						"n": 20,
						"h": 139,
						"w": 284
					}
				],
				"ball": {
					"n": 0,
					"h": 192,
					"w": 493,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 7
		},
		{
			"num": 1625,
			"minute": 79,
			"messages": [
				{
					"owner": 1,
					"mes": "Билли Реган[13](Галвэй Юнайтед) все же подбирает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 705
					},
					{
						"n": 2,
						"h": 391,
						"w": 507
					},
					{
						"n": 14,
						"h": 245,
						"w": 516
					},
					{
						"n": 13,
						"h": 192,
						"w": 493
					},
					{
						"n": 5,
						"h": 70,
						"w": 498
					},
					{
						"n": 6,
						"h": 420,
						"w": 407
					},
					{
						"n": 18,
						"h": 300,
						"w": 428
					},
					{
						"n": 15,
						"h": 146,
						"w": 343
					},
					{
						"n": 17,
						"h": 49,
						"w": 405
					},
					{
						"n": 20,
						"h": 286,
						"w": 240
					},
					{
						"n": 19,
						"h": 159,
						"w": 270
					}
				],
				"away": [
					{
						"n": 12,
						"h": 229,
						"w": 649
					},
					{
						"n": 13,
						"h": 412,
						"w": 350
					},
					{
						"n": 3,
						"h": 277,
						"w": 486
					},
					{
						"n": 14,
						"h": 174,
						"w": 482
					},
					{
						"n": 5,
						"h": 110,
						"w": 493
					},
					{
						"n": 16,
						"h": 235,
						"w": 391
					},
					{
						"n": 15,
						"h": 232,
						"w": 350
					},
					{
						"n": 18,
						"h": 37,
						"w": 249
					},
					{
						"n": 17,
						"h": 350,
						"w": 343
					},
					{
						"n": 19,
						"h": 262,
						"w": 235
					},
					{
						"n": 20,
						"h": 137,
						"w": 312
					}
				],
				"ball": {
					"n": 0,
					"h": 192,
					"w": 493,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 28
		},
		{
			"num": 1626,
			"minute": 79,
			"messages": [
				{
					"owner": 1,
					"mes": "Б.Реган[13](Галвэй Юнайтед) пасует Т.Смиту[14](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 701
					},
					{
						"n": 2,
						"h": 386,
						"w": 493
					},
					{
						"n": 14,
						"h": 255,
						"w": 487
					},
					{
						"n": 13,
						"h": 190,
						"w": 503
					},
					{
						"n": 5,
						"h": 74,
						"w": 496
					},
					{
						"n": 6,
						"h": 413,
						"w": 376
					},
					{
						"n": 18,
						"h": 268,
						"w": 429
					},
					{
						"n": 15,
						"h": 163,
						"w": 337
					},
					{
						"n": 17,
						"h": 51,
						"w": 373
					},
					{
						"n": 20,
						"h": 292,
						"w": 252
					},
					{
						"n": 19,
						"h": 176,
						"w": 244
					}
				],
				"away": [
					{
						"n": 12,
						"h": 230,
						"w": 644
					},
					{
						"n": 13,
						"h": 401,
						"w": 380
					},
					{
						"n": 3,
						"h": 263,
						"w": 515
					},
					{
						"n": 14,
						"h": 172,
						"w": 514
					},
					{
						"n": 5,
						"h": 110,
						"w": 519
					},
					{
						"n": 16,
						"h": 224,
						"w": 422
					},
					{
						"n": 15,
						"h": 227,
						"w": 382
					},
					{
						"n": 18,
						"h": 39,
						"w": 281
					},
					{
						"n": 17,
						"h": 360,
						"w": 350
					},
					{
						"n": 19,
						"h": 270,
						"w": 266
					},
					{
						"n": 20,
						"h": 128,
						"w": 320
					}
				],
				"ball": {
					"n": 0,
					"h": 255,
					"w": 487,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 32
		},
		{
			"num": 1627,
			"minute": 79,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 710
					},
					{
						"n": 2,
						"h": 380,
						"w": 455
					},
					{
						"n": 14,
						"h": 243,
						"w": 454
					},
					{
						"n": 13,
						"h": 181,
						"w": 512
					},
					{
						"n": 5,
						"h": 68,
						"w": 460
					},
					{
						"n": 6,
						"h": 406,
						"w": 337
					},
					{
						"n": 18,
						"h": 307,
						"w": 422
					},
					{
						"n": 15,
						"h": 164,
						"w": 297
					},
					{
						"n": 17,
						"h": 52,
						"w": 333
					},
					{
						"n": 20,
						"h": 281,
						"w": 214
					},
					{
						"n": 19,
						"h": 178,
						"w": 226
					}
				],
				"away": [
					{
						"n": 12,
						"h": 223,
						"w": 645
					},
					{
						"n": 13,
						"h": 398,
						"w": 420
					},
					{
						"n": 3,
						"h": 254,
						"w": 554
					},
					{
						"n": 14,
						"h": 180,
						"w": 544
					},
					{
						"n": 5,
						"h": 110,
						"w": 547
					},
					{
						"n": 16,
						"h": 228,
						"w": 462
					},
					{
						"n": 15,
						"h": 231,
						"w": 406
					},
					{
						"n": 18,
						"h": 40,
						"w": 321
					},
					{
						"n": 17,
						"h": 373,
						"w": 365
					},
					{
						"n": 19,
						"h": 277,
						"w": 306
					},
					{
						"n": 20,
						"h": 165,
						"w": 304
					}
				],
				"ball": {
					"n": 0,
					"h": 243,
					"w": 454,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1628,
			"minute": 79,
			"messages": [
				{
					"owner": 1,
					"mes": "Том Смит[14](Галвэй Юнайтед) пасует вперед на Т.Дэвлина[20](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 703
					},
					{
						"n": 2,
						"h": 391,
						"w": 420
					},
					{
						"n": 14,
						"h": 252,
						"w": 458
					},
					{
						"n": 13,
						"h": 180,
						"w": 482
					},
					{
						"n": 5,
						"h": 62,
						"w": 428
					},
					{
						"n": 6,
						"h": 399,
						"w": 276
					},
					{
						"n": 18,
						"h": 299,
						"w": 377
					},
					{
						"n": 15,
						"h": 168,
						"w": 236
					},
					{
						"n": 17,
						"h": 43,
						"w": 272
					},
					{
						"n": 20,
						"h": 281,
						"w": 214
					},
					{
						"n": 19,
						"h": 178,
						"w": 186
					}
				],
				"away": [
					{
						"n": 12,
						"h": 215,
						"w": 641
					},
					{
						"n": 13,
						"h": 406,
						"w": 480
					},
					{
						"n": 3,
						"h": 244,
						"w": 593
					},
					{
						"n": 14,
						"h": 171,
						"w": 508
					},
					{
						"n": 5,
						"h": 110,
						"w": 587
					},
					{
						"n": 16,
						"h": 234,
						"w": 510
					},
					{
						"n": 15,
						"h": 230,
						"w": 458
					},
					{
						"n": 18,
						"h": 44,
						"w": 382
					},
					{
						"n": 17,
						"h": 391,
						"w": 402
					},
					{
						"n": 19,
						"h": 283,
						"w": 366
					},
					{
						"n": 20,
						"h": 151,
						"w": 363
					}
				],
				"ball": {
					"n": 0,
					"h": 281,
					"w": 214,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 61
		},
		{
			"num": 1629,
			"minute": 79,
			"messages": [
				{
					"owner": 1,
					"mes": "Том Дэвлин[20](Галвэй Юнайтед) обрабатывает мяч одним касанием..."
				},
				{
					"owner": 1,
					"mes": "Т.Дэвлин[20](Галвэй Юнайтед) теряет мяч. Вацлав Сланина[34](Опава) жестко ставит ногу..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 706
					},
					{
						"n": 2,
						"h": 389,
						"w": 399
					},
					{
						"n": 14,
						"h": 259,
						"w": 456
					},
					{
						"n": 13,
						"h": 178,
						"w": 448
					},
					{
						"n": 5,
						"h": 64,
						"w": 401
					},
					{
						"n": 6,
						"h": 373,
						"w": 271
					},
					{
						"n": 18,
						"h": 299,
						"w": 350
					},
					{
						"n": 15,
						"h": 156,
						"w": 212
					},
					{
						"n": 17,
						"h": 44,
						"w": 245
					},
					{
						"n": 20,
						"h": 281,
						"w": 214
					},
					{
						"n": 19,
						"h": 176,
						"w": 159
					}
				],
				"away": [
					{
						"n": 12,
						"h": 215,
						"w": 648
					},
					{
						"n": 13,
						"h": 406,
						"w": 507
					},
					{
						"n": 3,
						"h": 249,
						"w": 619
					},
					{
						"n": 14,
						"h": 172,
						"w": 511,
						"m": 690
					},
					{
						"n": 5,
						"h": 110,
						"w": 604
					},
					{
						"n": 16,
						"h": 234,
						"w": 528
					},
					{
						"n": 15,
						"h": 203,
						"w": 458
					},
					{
						"n": 18,
						"h": 52,
						"w": 408
					},
					{
						"n": 17,
						"h": 392,
						"w": 409
					},
					{
						"n": 19,
						"h": 279,
						"w": 393
					},
					{
						"n": 20,
						"h": 151,
						"w": 390
					}
				],
				"ball": {
					"n": 0,
					"h": 309,
					"w": 261,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 27
		},
		{
			"num": 1630,
			"minute": 79,
			"messages": [
				{
					"owner": 2,
					"mes": "Адам Карабец[35](Опава) удачно выбирает позицию и подбирает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 701
					},
					{
						"n": 2,
						"h": 388,
						"w": 366
					},
					{
						"n": 14,
						"h": 271,
						"w": 413
					},
					{
						"n": 13,
						"h": 171,
						"w": 428
					},
					{
						"n": 5,
						"h": 76,
						"w": 370
					},
					{
						"n": 6,
						"h": 324,
						"w": 263
					},
					{
						"n": 18,
						"h": 290,
						"w": 302
					},
					{
						"n": 15,
						"h": 171,
						"w": 165
					},
					{
						"n": 17,
						"h": 43,
						"w": 196
					},
					{
						"n": 20,
						"h": 281,
						"w": 214
					},
					{
						"n": 19,
						"h": 152,
						"w": 127
					}
				],
				"away": [
					{
						"n": 12,
						"h": 215,
						"w": 647
					},
					{
						"n": 13,
						"h": 406,
						"w": 556
					},
					{
						"n": 3,
						"h": 240,
						"w": 613
					},
					{
						"n": 14,
						"h": 178,
						"w": 526
					},
					{
						"n": 5,
						"h": 110,
						"w": 616
					},
					{
						"n": 16,
						"h": 271,
						"w": 559
					},
					{
						"n": 15,
						"h": 141,
						"w": 459
					},
					{
						"n": 18,
						"h": 62,
						"w": 390
					},
					{
						"n": 17,
						"h": 406,
						"w": 434
					},
					{
						"n": 19,
						"h": 295,
						"w": 411
					},
					{
						"n": 20,
						"h": 160,
						"w": 438
					}
				],
				"ball": {
					"n": 0,
					"h": 309,
					"w": 261,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 49
		},
		{
			"num": 1631,
			"minute": 79,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 707
					},
					{
						"n": 2,
						"h": 370,
						"w": 402
					},
					{
						"n": 14,
						"h": 273,
						"w": 435
					},
					{
						"n": 13,
						"h": 166,
						"w": 409
					},
					{
						"n": 5,
						"h": 83,
						"w": 409
					},
					{
						"n": 6,
						"h": 346,
						"w": 297
					},
					{
						"n": 18,
						"h": 310,
						"w": 317
					},
					{
						"n": 15,
						"h": 174,
						"w": 205
					},
					{
						"n": 17,
						"h": 45,
						"w": 216
					},
					{
						"n": 20,
						"h": 288,
						"w": 253
					},
					{
						"n": 19,
						"h": 168,
						"w": 164
					}
				],
				"away": [
					{
						"n": 12,
						"h": 218,
						"w": 667
					},
					{
						"n": 13,
						"h": 397,
						"w": 517
					},
					{
						"n": 3,
						"h": 278,
						"w": 626
					},
					{
						"n": 14,
						"h": 180,
						"w": 566
					},
					{
						"n": 5,
						"h": 71,
						"w": 623
					},
					{
						"n": 16,
						"h": 257,
						"w": 522
					},
					{
						"n": 15,
						"h": 141,
						"w": 424
					},
					{
						"n": 18,
						"h": 54,
						"w": 382
					},
					{
						"n": 17,
						"h": 409,
						"w": 394
					},
					{
						"n": 19,
						"h": 296,
						"w": 371
					},
					{
						"n": 20,
						"h": 164,
						"w": 398
					}
				],
				"ball": {
					"n": 0,
					"h": 309,
					"w": 296,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1632,
			"minute": 79,
			"messages": [
				{
					"owner": 2,
					"mes": "Справа открывается Ньялл Томпсон[38](Опава)... Передача..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 708
					},
					{
						"n": 2,
						"h": 372,
						"w": 389
					},
					{
						"n": 14,
						"h": 272,
						"w": 448
					},
					{
						"n": 13,
						"h": 166,
						"w": 422
					},
					{
						"n": 5,
						"h": 90,
						"w": 420
					},
					{
						"n": 6,
						"h": 334,
						"w": 303
					},
					{
						"n": 18,
						"h": 305,
						"w": 329
					},
					{
						"n": 15,
						"h": 176,
						"w": 218
					},
					{
						"n": 17,
						"h": 46,
						"w": 229
					},
					{
						"n": 20,
						"h": 288,
						"w": 266
					},
					{
						"n": 19,
						"h": 174,
						"w": 175
					}
				],
				"away": [
					{
						"n": 12,
						"h": 220,
						"w": 680
					},
					{
						"n": 13,
						"h": 403,
						"w": 506
					},
					{
						"n": 3,
						"h": 270,
						"w": 619
					},
					{
						"n": 14,
						"h": 180,
						"w": 579
					},
					{
						"n": 5,
						"h": 65,
						"w": 611
					},
					{
						"n": 16,
						"h": 249,
						"w": 512
					},
					{
						"n": 15,
						"h": 143,
						"w": 423,
						"m": 580
					},
					{
						"n": 18,
						"h": 65,
						"w": 388,
						"m": 640
					},
					{
						"n": 17,
						"h": 404,
						"w": 382
					},
					{
						"n": 19,
						"h": 299,
						"w": 358
					},
					{
						"n": 20,
						"h": 164,
						"w": 385
					}
				],
				"ball": {
					"n": 0,
					"h": 334,
					"w": 303,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 13
		},
		{
			"num": 1633,
			"minute": 79,
			"messages": [
				{
					"owner": 2,
					"mes": "Киэн Колман[06](Галвэй Юнайтед) демонстрирует позиционное чутье и перехватывает мяч!..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 705
					},
					{
						"n": 2,
						"h": 384,
						"w": 372
					},
					{
						"n": 14,
						"h": 284,
						"w": 422
					},
					{
						"n": 13,
						"h": 163,
						"w": 424
					},
					{
						"n": 5,
						"h": 76,
						"w": 383
					},
					{
						"n": 6,
						"h": 365,
						"w": 286,
						"m": 920
					},
					{
						"n": 18,
						"h": 294,
						"w": 290
					},
					{
						"n": 15,
						"h": 208,
						"w": 193
					},
					{
						"n": 17,
						"h": 44,
						"w": 209
					},
					{
						"n": 20,
						"h": 286,
						"w": 226
					},
					{
						"n": 19,
						"h": 165,
						"w": 137
					}
				],
				"away": [
					{
						"n": 12,
						"h": 205,
						"w": 644
					},
					{
						"n": 13,
						"h": 406,
						"w": 546
					},
					{
						"n": 3,
						"h": 273,
						"w": 623
					},
					{
						"n": 14,
						"h": 212,
						"w": 603
					},
					{
						"n": 5,
						"h": 77,
						"w": 612
					},
					{
						"n": 16,
						"h": 243,
						"w": 542
					},
					{
						"n": 15,
						"h": 178,
						"w": 444
					},
					{
						"n": 18,
						"h": 82,
						"w": 424
					},
					{
						"n": 17,
						"h": 415,
						"w": 420
					},
					{
						"n": 19,
						"h": 287,
						"w": 396
					},
					{
						"n": 20,
						"h": 159,
						"w": 425
					}
				],
				"ball": {
					"n": 0,
					"h": 365,
					"w": 286,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1634,
			"minute": 79,
			"messages": [
				{
					"owner": 1,
					"mes": "Пас в центр поля на Р.Уотсона[18](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 702
					},
					{
						"n": 2,
						"h": 374,
						"w": 370
					},
					{
						"n": 14,
						"h": 279,
						"w": 418
					},
					{
						"n": 13,
						"h": 180,
						"w": 409
					},
					{
						"n": 5,
						"h": 71,
						"w": 374
					},
					{
						"n": 6,
						"h": 366,
						"w": 276
					},
					{
						"n": 18,
						"h": 315,
						"w": 291
					},
					{
						"n": 15,
						"h": 189,
						"w": 209
					},
					{
						"n": 17,
						"h": 45,
						"w": 197
					},
					{
						"n": 20,
						"h": 289,
						"w": 201
					},
					{
						"n": 19,
						"h": 155,
						"w": 131
					}
				],
				"away": [
					{
						"n": 12,
						"h": 212,
						"w": 668
					},
					{
						"n": 13,
						"h": 405,
						"w": 559
					},
					{
						"n": 3,
						"h": 276,
						"w": 615
					},
					{
						"n": 14,
						"h": 189,
						"w": 611
					},
					{
						"n": 5,
						"h": 101,
						"w": 607
					},
					{
						"n": 16,
						"h": 218,
						"w": 539
					},
					{
						"n": 15,
						"h": 199,
						"w": 457
					},
					{
						"n": 18,
						"h": 83,
						"w": 449
					},
					{
						"n": 17,
						"h": 415,
						"w": 445
					},
					{
						"n": 19,
						"h": 284,
						"w": 413
					},
					{
						"n": 20,
						"h": 135,
						"w": 429
					}
				],
				"ball": {
					"n": 0,
					"h": 315,
					"w": 291,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 25
		},
		{
			"num": 1635,
			"minute": 79,
			"messages": [
				{
					"owner": 1,
					"mes": "Райан Уотсон[18](Галвэй Юнайтед) обрабатывает мяч одним касанием..."
				},
				{
					"owner": 1,
					"mes": "Тома Анри[40](Опава) отбирает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 707
					},
					{
						"n": 2,
						"h": 379,
						"w": 368
					},
					{
						"n": 14,
						"h": 277,
						"w": 422
					},
					{
						"n": 13,
						"h": 180,
						"w": 414
					},
					{
						"n": 5,
						"h": 76,
						"w": 375
					},
					{
						"n": 6,
						"h": 368,
						"w": 271
					},
					{
						"n": 18,
						"h": 315,
						"w": 286
					},
					{
						"n": 15,
						"h": 184,
						"w": 210
					},
					{
						"n": 17,
						"h": 45,
						"w": 195
					},
					{
						"n": 20,
						"h": 288,
						"w": 196
					},
					{
						"n": 19,
						"h": 159,
						"w": 128
					}
				],
				"away": [
					{
						"n": 12,
						"h": 212,
						"w": 663
					},
					{
						"n": 13,
						"h": 405,
						"w": 561
					},
					{
						"n": 3,
						"h": 273,
						"w": 613
					},
					{
						"n": 14,
						"h": 184,
						"w": 609
					},
					{
						"n": 5,
						"h": 105,
						"w": 610
					},
					{
						"n": 16,
						"h": 215,
						"w": 535
					},
					{
						"n": 15,
						"h": 204,
						"w": 458
					},
					{
						"n": 18,
						"h": 83,
						"w": 454
					},
					{
						"n": 17,
						"h": 418,
						"w": 449
					},
					{
						"n": 19,
						"h": 283,
						"w": 418
					},
					{
						"n": 20,
						"h": 135,
						"w": 424,
						"m": 640
					}
				],
				"ball": {
					"n": 0,
					"h": 315,
					"w": 296,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 5
		},
		{
			"num": 1636,
			"minute": 79,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 706
					},
					{
						"n": 2,
						"h": 366,
						"w": 406
					},
					{
						"n": 14,
						"h": 237,
						"w": 429
					},
					{
						"n": 13,
						"h": 154,
						"w": 409
					},
					{
						"n": 5,
						"h": 103,
						"w": 404
					},
					{
						"n": 6,
						"h": 383,
						"w": 284
					},
					{
						"n": 18,
						"h": 323,
						"w": 299
					},
					{
						"n": 15,
						"h": 192,
						"w": 249
					},
					{
						"n": 17,
						"h": 44,
						"w": 215
					},
					{
						"n": 20,
						"h": 286,
						"w": 236
					},
					{
						"n": 19,
						"h": 179,
						"w": 163
					}
				],
				"away": [
					{
						"n": 12,
						"h": 228,
						"w": 700
					},
					{
						"n": 13,
						"h": 407,
						"w": 521
					},
					{
						"n": 3,
						"h": 272,
						"w": 617
					},
					{
						"n": 14,
						"h": 164,
						"w": 608
					},
					{
						"n": 5,
						"h": 74,
						"w": 592
					},
					{
						"n": 16,
						"h": 226,
						"w": 496
					},
					{
						"n": 15,
						"h": 218,
						"w": 421
					},
					{
						"n": 18,
						"h": 67,
						"w": 418
					},
					{
						"n": 17,
						"h": 412,
						"w": 409
					},
					{
						"n": 19,
						"h": 293,
						"w": 379
					},
					{
						"n": 20,
						"h": 110,
						"w": 399
					}
				],
				"ball": {
					"n": 0,
					"h": 340,
					"w": 321,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1637,
			"minute": 79,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 703
					},
					{
						"n": 2,
						"h": 335,
						"w": 419
					},
					{
						"n": 14,
						"h": 234,
						"w": 440
					},
					{
						"n": 13,
						"h": 160,
						"w": 449
					},
					{
						"n": 5,
						"h": 116,
						"w": 442
					},
					{
						"n": 6,
						"h": 388,
						"w": 324
					},
					{
						"n": 18,
						"h": 334,
						"w": 332
					},
					{
						"n": 15,
						"h": 196,
						"w": 289
					},
					{
						"n": 17,
						"h": 41,
						"w": 254
					},
					{
						"n": 20,
						"h": 281,
						"w": 276
					},
					{
						"n": 19,
						"h": 176,
						"w": 203
					}
				],
				"away": [
					{
						"n": 12,
						"h": 227,
						"w": 701
					},
					{
						"n": 13,
						"h": 401,
						"w": 482
					},
					{
						"n": 3,
						"h": 279,
						"w": 610
					},
					{
						"n": 14,
						"h": 181,
						"w": 611
					},
					{
						"n": 5,
						"h": 65,
						"w": 623
					},
					{
						"n": 16,
						"h": 229,
						"w": 456
					},
					{
						"n": 15,
						"h": 217,
						"w": 381
					},
					{
						"n": 18,
						"h": 50,
						"w": 381
					},
					{
						"n": 17,
						"h": 414,
						"w": 369
					},
					{
						"n": 19,
						"h": 298,
						"w": 340
					},
					{
						"n": 20,
						"h": 110,
						"w": 364
					}
				],
				"ball": {
					"n": 0,
					"h": 340,
					"w": 356,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1638,
			"minute": 79,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 708
					},
					{
						"n": 2,
						"h": 338,
						"w": 390
					},
					{
						"n": 14,
						"h": 238,
						"w": 470
					},
					{
						"n": 13,
						"h": 162,
						"w": 479
					},
					{
						"n": 5,
						"h": 120,
						"w": 472
					},
					{
						"n": 6,
						"h": 391,
						"w": 354
					},
					{
						"n": 18,
						"h": 341,
						"w": 361
					},
					{
						"n": 15,
						"h": 201,
						"w": 318
					},
					{
						"n": 17,
						"h": 45,
						"w": 284
					},
					{
						"n": 20,
						"h": 292,
						"w": 304
					},
					{
						"n": 19,
						"h": 191,
						"w": 229
					}
				],
				"away": [
					{
						"n": 12,
						"h": 224,
						"w": 704
					},
					{
						"n": 13,
						"h": 406,
						"w": 466
					},
					{
						"n": 3,
						"h": 287,
						"w": 597
					},
					{
						"n": 14,
						"h": 167,
						"w": 597
					},
					{
						"n": 5,
						"h": 64,
						"w": 593
					},
					{
						"n": 16,
						"h": 214,
						"w": 482
					},
					{
						"n": 15,
						"h": 221,
						"w": 351
					},
					{
						"n": 18,
						"h": 80,
						"w": 383
					},
					{
						"n": 17,
						"h": 414,
						"w": 339
					},
					{
						"n": 19,
						"h": 296,
						"w": 310
					},
					{
						"n": 20,
						"h": 112,
						"w": 334
					}
				],
				"ball": {
					"n": 0,
					"h": 338,
					"w": 386,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 30
		},
		{
			"num": 1639,
			"minute": 79,
			"messages": [
				{
					"owner": 2,
					"mes": "Т.Эверс[02](Галвэй Юнайтед) выбивает мяч у Т.Анри[40](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 703
					},
					{
						"n": 2,
						"h": 337,
						"w": 394,
						"m": 700
					},
					{
						"n": 14,
						"h": 229,
						"w": 490
					},
					{
						"n": 13,
						"h": 177,
						"w": 478
					},
					{
						"n": 5,
						"h": 120,
						"w": 494
					},
					{
						"n": 6,
						"h": 392,
						"w": 356
					},
					{
						"n": 18,
						"h": 321,
						"w": 354
					},
					{
						"n": 15,
						"h": 206,
						"w": 340
					},
					{
						"n": 17,
						"h": 41,
						"w": 306
					},
					{
						"n": 20,
						"h": 271,
						"w": 295
					},
					{
						"n": 19,
						"h": 185,
						"w": 250
					}
				],
				"away": [
					{
						"n": 12,
						"h": 220,
						"w": 709
					},
					{
						"n": 13,
						"h": 405,
						"w": 444
					},
					{
						"n": 3,
						"h": 279,
						"w": 576
					},
					{
						"n": 14,
						"h": 169,
						"w": 575
					},
					{
						"n": 5,
						"h": 69,
						"w": 571
					},
					{
						"n": 16,
						"h": 223,
						"w": 462
					},
					{
						"n": 15,
						"h": 229,
						"w": 331
					},
					{
						"n": 18,
						"h": 101,
						"w": 378
					},
					{
						"n": 17,
						"h": 410,
						"w": 318
					},
					{
						"n": 19,
						"h": 301,
						"w": 288
					},
					{
						"n": 20,
						"h": 112,
						"w": 334
					}
				],
				"ball": {
					"n": 0,
					"h": 313,
					"w": 351,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 22
		},
		{
			"num": 1640,
			"minute": 79,
			"messages": [
				{
					"owner": 1,
					"mes": "Райан Уотсон[18](Галвэй Юнайтед) устремляется к свободному мячу и подхватывает его..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 708
					},
					{
						"n": 2,
						"h": 337,
						"w": 401
					},
					{
						"n": 14,
						"h": 235,
						"w": 494
					},
					{
						"n": 13,
						"h": 184,
						"w": 481
					},
					{
						"n": 5,
						"h": 127,
						"w": 494
					},
					{
						"n": 6,
						"h": 392,
						"w": 356
					},
					{
						"n": 18,
						"h": 313,
						"w": 351
					},
					{
						"n": 15,
						"h": 206,
						"w": 347
					},
					{
						"n": 17,
						"h": 42,
						"w": 313
					},
					{
						"n": 20,
						"h": 265,
						"w": 294
					},
					{
						"n": 19,
						"h": 183,
						"w": 257
					}
				],
				"away": [
					{
						"n": 12,
						"h": 220,
						"w": 702
					},
					{
						"n": 13,
						"h": 406,
						"w": 437
					},
					{
						"n": 3,
						"h": 280,
						"w": 569
					},
					{
						"n": 14,
						"h": 175,
						"w": 571
					},
					{
						"n": 5,
						"h": 64,
						"w": 567
					},
					{
						"n": 16,
						"h": 223,
						"w": 455
					},
					{
						"n": 15,
						"h": 225,
						"w": 326
					},
					{
						"n": 18,
						"h": 108,
						"w": 376
					},
					{
						"n": 17,
						"h": 410,
						"w": 311
					},
					{
						"n": 19,
						"h": 302,
						"w": 281
					},
					{
						"n": 20,
						"h": 112,
						"w": 334
					}
				],
				"ball": {
					"n": 0,
					"h": 313,
					"w": 351,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 7
		},
		{
			"num": 1641,
			"minute": 79,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 706
					},
					{
						"n": 2,
						"h": 376,
						"w": 407
					},
					{
						"n": 14,
						"h": 266,
						"w": 469
					},
					{
						"n": 13,
						"h": 178,
						"w": 449
					},
					{
						"n": 5,
						"h": 104,
						"w": 461
					},
					{
						"n": 6,
						"h": 395,
						"w": 329
					},
					{
						"n": 18,
						"h": 288,
						"w": 326
					},
					{
						"n": 15,
						"h": 182,
						"w": 315
					},
					{
						"n": 17,
						"h": 45,
						"w": 276
					},
					{
						"n": 20,
						"h": 277,
						"w": 256
					},
					{
						"n": 19,
						"h": 166,
						"w": 220
					}
				],
				"away": [
					{
						"n": 12,
						"h": 217,
						"w": 662
					},
					{
						"n": 13,
						"h": 405,
						"w": 477
					},
					{
						"n": 3,
						"h": 270,
						"w": 575
					},
					{
						"n": 14,
						"h": 190,
						"w": 558
					},
					{
						"n": 5,
						"h": 103,
						"w": 576
					},
					{
						"n": 16,
						"h": 190,
						"w": 433
					},
					{
						"n": 15,
						"h": 224,
						"w": 366
					},
					{
						"n": 18,
						"h": 79,
						"w": 404
					},
					{
						"n": 17,
						"h": 414,
						"w": 351
					},
					{
						"n": 19,
						"h": 296,
						"w": 321
					},
					{
						"n": 20,
						"h": 135,
						"w": 367
					}
				],
				"ball": {
					"n": 0,
					"h": 288,
					"w": 326,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1642,
			"minute": 79,
			"messages": [
				{
					"owner": 1,
					"mes": "Пас на К.Келли[15](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 702
					},
					{
						"n": 2,
						"h": 390,
						"w": 401
					},
					{
						"n": 14,
						"h": 283,
						"w": 457
					},
					{
						"n": 13,
						"h": 172,
						"w": 468
					},
					{
						"n": 5,
						"h": 86,
						"w": 431
					},
					{
						"n": 6,
						"h": 395,
						"w": 294
					},
					{
						"n": 18,
						"h": 282,
						"w": 291,
						"m": 640
					},
					{
						"n": 15,
						"h": 182,
						"w": 315
					},
					{
						"n": 17,
						"h": 51,
						"w": 242
					},
					{
						"n": 20,
						"h": 274,
						"w": 221
					},
					{
						"n": 19,
						"h": 174,
						"w": 186
					}
				],
				"away": [
					{
						"n": 12,
						"h": 229,
						"w": 646
					},
					{
						"n": 13,
						"h": 400,
						"w": 511
					},
					{
						"n": 3,
						"h": 258,
						"w": 582
					},
					{
						"n": 14,
						"h": 189,
						"w": 562
					},
					{
						"n": 5,
						"h": 110,
						"w": 580
					},
					{
						"n": 16,
						"h": 225,
						"w": 429
					},
					{
						"n": 15,
						"h": 222,
						"w": 401
					},
					{
						"n": 18,
						"h": 66,
						"w": 436
					},
					{
						"n": 17,
						"h": 420,
						"w": 385
					},
					{
						"n": 19,
						"h": 293,
						"w": 356
					},
					{
						"n": 20,
						"h": 151,
						"w": 398
					}
				],
				"ball": {
					"n": 0,
					"h": 182,
					"w": 315,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 35
		},
		{
			"num": 1643,
			"minute": 79,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 707
					},
					{
						"n": 2,
						"h": 389,
						"w": 404
					},
					{
						"n": 14,
						"h": 266,
						"w": 451
					},
					{
						"n": 13,
						"h": 171,
						"w": 445
					},
					{
						"n": 5,
						"h": 78,
						"w": 408
					},
					{
						"n": 6,
						"h": 402,
						"w": 255
					},
					{
						"n": 18,
						"h": 281,
						"w": 270
					},
					{
						"n": 15,
						"h": 182,
						"w": 280
					},
					{
						"n": 17,
						"h": 42,
						"w": 203
					},
					{
						"n": 20,
						"h": 287,
						"w": 183
					},
					{
						"n": 19,
						"h": 179,
						"w": 157
					}
				],
				"away": [
					{
						"n": 12,
						"h": 229,
						"w": 650
					},
					{
						"n": 13,
						"h": 406,
						"w": 551
					},
					{
						"n": 3,
						"h": 260,
						"w": 613
					},
					{
						"n": 14,
						"h": 179,
						"w": 601
					},
					{
						"n": 5,
						"h": 110,
						"w": 612
					},
					{
						"n": 16,
						"h": 258,
						"w": 452
					},
					{
						"n": 15,
						"h": 226,
						"w": 440
					},
					{
						"n": 18,
						"h": 55,
						"w": 475
					},
					{
						"n": 17,
						"h": 421,
						"w": 425
					},
					{
						"n": 19,
						"h": 290,
						"w": 396
					},
					{
						"n": 20,
						"h": 171,
						"w": 425
					}
				],
				"ball": {
					"n": 0,
					"h": 182,
					"w": 280,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1644,
			"minute": 80,
			"possession": 43,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 707
					},
					{
						"n": 2,
						"h": 377,
						"w": 367
					},
					{
						"n": 14,
						"h": 268,
						"w": 425,
						"f": 95
					},
					{
						"n": 13,
						"h": 173,
						"w": 432
					},
					{
						"n": 5,
						"h": 69,
						"w": 378
					},
					{
						"n": 6,
						"h": 402,
						"w": 215,
						"f": 76
					},
					{
						"n": 18,
						"h": 278,
						"w": 230
					},
					{
						"n": 15,
						"h": 154,
						"w": 252
					},
					{
						"n": 17,
						"h": 54,
						"w": 164
					},
					{
						"n": 20,
						"h": 281,
						"w": 143,
						"f": 84,
						"c": 2
					},
					{
						"n": 19,
						"h": 161,
						"w": 133,
						"f": 91
					}
				],
				"away": [
					{
						"n": 12,
						"h": 235,
						"w": 643
					},
					{
						"n": 13,
						"h": 396,
						"w": 592,
						"f": 89,
						"c": 1
					},
					{
						"n": 3,
						"h": 276,
						"w": 617
					},
					{
						"n": 14,
						"h": 184,
						"w": 603
					},
					{
						"n": 5,
						"h": 110,
						"w": 606
					},
					{
						"n": 16,
						"h": 293,
						"w": 484
					},
					{
						"n": 15,
						"h": 231,
						"w": 480
					},
					{
						"n": 18,
						"h": 51,
						"w": 515
					},
					{
						"n": 17,
						"h": 427,
						"w": 463
					},
					{
						"n": 19,
						"h": 275,
						"w": 416
					},
					{
						"n": 20,
						"h": 164,
						"w": 421,
						"f": 92
					}
				],
				"ball": {
					"n": 0,
					"h": 154,
					"w": 252,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1645,
			"minute": 80,
			"messages": [
				{
					"owner": 1,
					"mes": "Передача вперед..."
				},
				{
					"owner": 1,
					"mes": "Том Дэвлин[20](Галвэй Юнайтед) подрабатывает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 701
					},
					{
						"n": 2,
						"h": 392,
						"w": 356
					},
					{
						"n": 14,
						"h": 275,
						"w": 418
					},
					{
						"n": 13,
						"h": 173,
						"w": 405
					},
					{
						"n": 5,
						"h": 71,
						"w": 366
					},
					{
						"n": 6,
						"h": 402,
						"w": 174
					},
					{
						"n": 18,
						"h": 297,
						"w": 194
					},
					{
						"n": 15,
						"h": 158,
						"w": 263,
						"m": 660
					},
					{
						"n": 17,
						"h": 58,
						"w": 147
					},
					{
						"n": 20,
						"h": 254,
						"w": 182
					},
					{
						"n": 19,
						"h": 153,
						"w": 117
					}
				],
				"away": [
					{
						"n": 12,
						"h": 226,
						"w": 683
					},
					{
						"n": 13,
						"h": 376,
						"w": 607
					},
					{
						"n": 3,
						"h": 278,
						"w": 632
					},
					{
						"n": 14,
						"h": 168,
						"w": 623
					},
					{
						"n": 5,
						"h": 110,
						"w": 630
					},
					{
						"n": 16,
						"h": 260,
						"w": 508
					},
					{
						"n": 15,
						"h": 210,
						"w": 515
					},
					{
						"n": 18,
						"h": 49,
						"w": 556
					},
					{
						"n": 17,
						"h": 415,
						"w": 472
					},
					{
						"n": 19,
						"h": 277,
						"w": 420
					},
					{
						"n": 20,
						"h": 174,
						"w": 420
					}
				],
				"ball": {
					"n": 0,
					"h": 254,
					"w": 182,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 41
		},
		{
			"num": 1646,
			"minute": 80,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 705
					},
					{
						"n": 2,
						"h": 384,
						"w": 341
					},
					{
						"n": 14,
						"h": 285,
						"w": 398
					},
					{
						"n": 13,
						"h": 181,
						"w": 381
					},
					{
						"n": 5,
						"h": 64,
						"w": 350
					},
					{
						"n": 6,
						"h": 406,
						"w": 134
					},
					{
						"n": 18,
						"h": 273,
						"w": 164
					},
					{
						"n": 15,
						"h": 150,
						"w": 285
					},
					{
						"n": 17,
						"h": 60,
						"w": 125
					},
					{
						"n": 20,
						"h": 245,
						"w": 145
					},
					{
						"n": 19,
						"h": 152,
						"w": 95
					}
				],
				"away": [
					{
						"n": 12,
						"h": 223,
						"w": 705
					},
					{
						"n": 13,
						"h": 374,
						"w": 629
					},
					{
						"n": 3,
						"h": 282,
						"w": 640
					},
					{
						"n": 14,
						"h": 203,
						"w": 597
					},
					{
						"n": 5,
						"h": 110,
						"w": 639
					},
					{
						"n": 16,
						"h": 230,
						"w": 535
					},
					{
						"n": 15,
						"h": 207,
						"w": 550
					},
					{
						"n": 18,
						"h": 46,
						"w": 596
					},
					{
						"n": 17,
						"h": 418,
						"w": 494
					},
					{
						"n": 19,
						"h": 299,
						"w": 453
					},
					{
						"n": 20,
						"h": 168,
						"w": 426
					}
				],
				"ball": {
					"n": 0,
					"h": 245,
					"w": 145,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1647,
			"minute": 80,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 702
					},
					{
						"n": 2,
						"h": 380,
						"w": 344
					},
					{
						"n": 14,
						"h": 283,
						"w": 392
					},
					{
						"n": 13,
						"h": 181,
						"w": 387
					},
					{
						"n": 5,
						"h": 67,
						"w": 349
					},
					{
						"n": 6,
						"h": 403,
						"w": 128
					},
					{
						"n": 18,
						"h": 275,
						"w": 158
					},
					{
						"n": 15,
						"h": 150,
						"w": 279
					},
					{
						"n": 17,
						"h": 56,
						"w": 121
					},
					{
						"n": 20,
						"h": 245,
						"w": 139
					},
					{
						"n": 19,
						"h": 158,
						"w": 93
					}
				],
				"away": [
					{
						"n": 12,
						"h": 223,
						"w": 705
					},
					{
						"n": 13,
						"h": 374,
						"w": 629
					},
					{
						"n": 3,
						"h": 280,
						"w": 646
					},
					{
						"n": 14,
						"h": 203,
						"w": 592
					},
					{
						"n": 5,
						"h": 105,
						"w": 636
					},
					{
						"n": 16,
						"h": 225,
						"w": 539
					},
					{
						"n": 15,
						"h": 207,
						"w": 551
					},
					{
						"n": 18,
						"h": 43,
						"w": 590
					},
					{
						"n": 17,
						"h": 424,
						"w": 494
					},
					{
						"n": 19,
						"h": 300,
						"w": 455
					},
					{
						"n": 20,
						"h": 170,
						"w": 420
					}
				],
				"ball": {
					"n": 0,
					"h": 245,
					"w": 139,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 6
		},
		{
			"num": 1648,
			"minute": 80,
			"messages": [
				{
					"owner": 1,
					"mes": "Т.Дэвлин[20](Галвэй Юнайтед) пытается переиграть В.Сланину[34](Опава)..."
				},
				{
					"owner": 1,
					"mes": "Вацлав Сланина[34](Опава) буквально вырывает мяч у Т.Дэвлина[20](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 702
					},
					{
						"n": 2,
						"h": 380,
						"w": 344
					},
					{
						"n": 14,
						"h": 283,
						"w": 392
					},
					{
						"n": 13,
						"h": 181,
						"w": 392
					},
					{
						"n": 5,
						"h": 67,
						"w": 349
					},
					{
						"n": 6,
						"h": 401,
						"w": 124
					},
					{
						"n": 18,
						"h": 277,
						"w": 154
					},
					{
						"n": 15,
						"h": 151,
						"w": 274
					},
					{
						"n": 17,
						"h": 52,
						"w": 117
					},
					{
						"n": 20,
						"h": 246,
						"w": 129
					},
					{
						"n": 19,
						"h": 162,
						"w": 91
					}
				],
				"away": [
					{
						"n": 12,
						"h": 223,
						"w": 705
					},
					{
						"n": 13,
						"h": 374,
						"w": 629
					},
					{
						"n": 3,
						"h": 279,
						"w": 651
					},
					{
						"n": 14,
						"h": 204,
						"w": 587,
						"m": 710
					},
					{
						"n": 5,
						"h": 101,
						"w": 632
					},
					{
						"n": 16,
						"h": 221,
						"w": 542
					},
					{
						"n": 15,
						"h": 207,
						"w": 556
					},
					{
						"n": 18,
						"h": 41,
						"w": 586
					},
					{
						"n": 17,
						"h": 427,
						"w": 494
					},
					{
						"n": 19,
						"h": 300,
						"w": 455
					},
					{
						"n": 20,
						"h": 172,
						"w": 416
					}
				],
				"ball": {
					"n": 0,
					"h": 246,
					"w": 133,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 5
		},
		{
			"num": 1649,
			"minute": 80,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 702
					},
					{
						"n": 2,
						"h": 380,
						"w": 344
					},
					{
						"n": 14,
						"h": 283,
						"w": 392
					},
					{
						"n": 13,
						"h": 180,
						"w": 402
					},
					{
						"n": 5,
						"h": 67,
						"w": 349
					},
					{
						"n": 6,
						"h": 397,
						"w": 116
					},
					{
						"n": 18,
						"h": 277,
						"w": 154
					},
					{
						"n": 15,
						"h": 151,
						"w": 264
					},
					{
						"n": 17,
						"h": 50,
						"w": 116
					},
					{
						"n": 20,
						"h": 246,
						"w": 129
					},
					{
						"n": 19,
						"h": 171,
						"w": 88
					}
				],
				"away": [
					{
						"n": 12,
						"h": 223,
						"w": 705
					},
					{
						"n": 13,
						"h": 374,
						"w": 629
					},
					{
						"n": 3,
						"h": 278,
						"w": 654
					},
					{
						"n": 14,
						"h": 205,
						"w": 577
					},
					{
						"n": 5,
						"h": 94,
						"w": 626
					},
					{
						"n": 16,
						"h": 213,
						"w": 547
					},
					{
						"n": 15,
						"h": 206,
						"w": 566
					},
					{
						"n": 18,
						"h": 36,
						"w": 577
					},
					{
						"n": 17,
						"h": 427,
						"w": 494
					},
					{
						"n": 19,
						"h": 300,
						"w": 455
					},
					{
						"n": 20,
						"h": 172,
						"w": 416
					}
				],
				"ball": {
					"n": 0,
					"h": 245,
					"w": 143,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 10
		},
		{
			"num": 1650,
			"minute": 80,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 705
					},
					{
						"n": 2,
						"h": 371,
						"w": 383
					},
					{
						"n": 14,
						"h": 280,
						"w": 404
					},
					{
						"n": 13,
						"h": 174,
						"w": 393
					},
					{
						"n": 5,
						"h": 78,
						"w": 388
					},
					{
						"n": 6,
						"h": 396,
						"w": 156
					},
					{
						"n": 18,
						"h": 276,
						"w": 194
					},
					{
						"n": 15,
						"h": 155,
						"w": 304
					},
					{
						"n": 17,
						"h": 47,
						"w": 156
					},
					{
						"n": 20,
						"h": 242,
						"w": 138
					},
					{
						"n": 19,
						"h": 164,
						"w": 127
					}
				],
				"away": [
					{
						"n": 12,
						"h": 228,
						"w": 704
					},
					{
						"n": 13,
						"h": 380,
						"w": 590
					},
					{
						"n": 3,
						"h": 286,
						"w": 612
					},
					{
						"n": 14,
						"h": 230,
						"w": 552
					},
					{
						"n": 5,
						"h": 67,
						"w": 605
					},
					{
						"n": 16,
						"h": 197,
						"w": 511
					},
					{
						"n": 15,
						"h": 216,
						"w": 527
					},
					{
						"n": 18,
						"h": 36,
						"w": 537
					},
					{
						"n": 17,
						"h": 418,
						"w": 455
					},
					{
						"n": 19,
						"h": 303,
						"w": 415
					},
					{
						"n": 20,
						"h": 157,
						"w": 379
					}
				],
				"ball": {
					"n": 0,
					"h": 220,
					"w": 168,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1651,
			"minute": 80,
			"messages": [
				{
					"owner": 2,
					"mes": "Не найдя свободных партнеров, Вацлав Сланина[34](Опава) отдает пас назад..."
				},
				{
					"owner": 2,
					"mes": "Тим Крамарж[32](Опава) останавливает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 708
					},
					{
						"n": 2,
						"h": 345,
						"w": 418
					},
					{
						"n": 14,
						"h": 278,
						"w": 435
					},
					{
						"n": 13,
						"h": 167,
						"w": 421
					},
					{
						"n": 5,
						"h": 104,
						"w": 422
					},
					{
						"n": 6,
						"h": 396,
						"w": 199
					},
					{
						"n": 18,
						"h": 273,
						"w": 237
					},
					{
						"n": 15,
						"h": 143,
						"w": 345
					},
					{
						"n": 17,
						"h": 42,
						"w": 198
					},
					{
						"n": 20,
						"h": 227,
						"w": 179
					},
					{
						"n": 19,
						"h": 191,
						"w": 94
					}
				],
				"away": [
					{
						"n": 12,
						"h": 257,
						"w": 679
					},
					{
						"n": 13,
						"h": 387,
						"w": 547
					},
					{
						"n": 3,
						"h": 270,
						"w": 622
					},
					{
						"n": 14,
						"h": 224,
						"w": 560
					},
					{
						"n": 5,
						"h": 75,
						"w": 628
					},
					{
						"n": 16,
						"h": 215,
						"w": 471
					},
					{
						"n": 15,
						"h": 233,
						"w": 488
					},
					{
						"n": 18,
						"h": 36,
						"w": 494
					},
					{
						"n": 17,
						"h": 380,
						"w": 475
					},
					{
						"n": 19,
						"h": 304,
						"w": 372
					},
					{
						"n": 20,
						"h": 155,
						"w": 336
					}
				],
				"ball": {
					"n": 0,
					"h": 193,
					"w": 41,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 43
		},
		{
			"num": 1652,
			"minute": 80,
			"messages": [
				{
					"owner": 2,
					"mes": "Слева открывается Кеннет Удре[33](Опава)... Передача..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 703
					},
					{
						"n": 2,
						"h": 330,
						"w": 456
					},
					{
						"n": 14,
						"h": 284,
						"w": 463
					},
					{
						"n": 13,
						"h": 171,
						"w": 459
					},
					{
						"n": 5,
						"h": 120,
						"w": 449
					},
					{
						"n": 6,
						"h": 394,
						"w": 246
					},
					{
						"n": 18,
						"h": 265,
						"w": 283
					},
					{
						"n": 15,
						"h": 146,
						"w": 370
					},
					{
						"n": 17,
						"h": 83,
						"w": 176
					},
					{
						"n": 20,
						"h": 246,
						"w": 221
					},
					{
						"n": 19,
						"h": 171,
						"w": 136
					}
				],
				"away": [
					{
						"n": 12,
						"h": 253,
						"w": 682
					},
					{
						"n": 13,
						"h": 348,
						"w": 572
					},
					{
						"n": 3,
						"h": 278,
						"w": 611
					},
					{
						"n": 14,
						"h": 204,
						"w": 572
					},
					{
						"n": 5,
						"h": 73,
						"w": 611
					},
					{
						"n": 16,
						"h": 218,
						"w": 435
					},
					{
						"n": 15,
						"h": 239,
						"w": 441
					},
					{
						"n": 18,
						"h": 35,
						"w": 447
					},
					{
						"n": 17,
						"h": 335,
						"w": 490
					},
					{
						"n": 19,
						"h": 297,
						"w": 326
					},
					{
						"n": 20,
						"h": 149,
						"w": 301
					}
				],
				"ball": {
					"n": 0,
					"h": 102,
					"w": 148,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 47
		},
		{
			"num": 1653,
			"minute": 80,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 703
					},
					{
						"n": 2,
						"h": 330,
						"w": 458
					},
					{
						"n": 14,
						"h": 278,
						"w": 455
					},
					{
						"n": 13,
						"h": 193,
						"w": 475
					},
					{
						"n": 5,
						"h": 120,
						"w": 463
					},
					{
						"n": 6,
						"h": 405,
						"w": 284
					},
					{
						"n": 18,
						"h": 255,
						"w": 322
					},
					{
						"n": 15,
						"h": 176,
						"w": 349
					},
					{
						"n": 17,
						"h": 103,
						"w": 180
					},
					{
						"n": 20,
						"h": 265,
						"w": 256
					},
					{
						"n": 19,
						"h": 160,
						"w": 174
					}
				],
				"away": [
					{
						"n": 12,
						"h": 224,
						"w": 705
					},
					{
						"n": 13,
						"h": 334,
						"w": 540
					},
					{
						"n": 3,
						"h": 278,
						"w": 601
					},
					{
						"n": 14,
						"h": 173,
						"w": 597
					},
					{
						"n": 5,
						"h": 71,
						"w": 575
					},
					{
						"n": 16,
						"h": 233,
						"w": 432
					},
					{
						"n": 15,
						"h": 247,
						"w": 402
					},
					{
						"n": 18,
						"h": 38,
						"w": 408
					},
					{
						"n": 17,
						"h": 295,
						"w": 491
					},
					{
						"n": 19,
						"h": 288,
						"w": 288
					},
					{
						"n": 20,
						"h": 136,
						"w": 290
					}
				],
				"ball": {
					"n": 0,
					"h": 116,
					"w": 180,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1654,
			"minute": 80,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 706
					},
					{
						"n": 2,
						"h": 330,
						"w": 460
					},
					{
						"n": 14,
						"h": 274,
						"w": 458
					},
					{
						"n": 13,
						"h": 165,
						"w": 452
					},
					{
						"n": 5,
						"h": 120,
						"w": 465
					},
					{
						"n": 6,
						"h": 401,
						"w": 324
					},
					{
						"n": 18,
						"h": 238,
						"w": 358
					},
					{
						"n": 15,
						"h": 210,
						"w": 370
					},
					{
						"n": 17,
						"h": 90,
						"w": 218
					},
					{
						"n": 20,
						"h": 300,
						"w": 277
					},
					{
						"n": 19,
						"h": 150,
						"w": 213
					}
				],
				"away": [
					{
						"n": 12,
						"h": 223,
						"w": 709
					},
					{
						"n": 13,
						"h": 330,
						"w": 505
					},
					{
						"n": 3,
						"h": 279,
						"w": 606
					},
					{
						"n": 14,
						"h": 165,
						"w": 603
					},
					{
						"n": 5,
						"h": 66,
						"w": 603
					},
					{
						"n": 16,
						"h": 219,
						"w": 443
					},
					{
						"n": 15,
						"h": 239,
						"w": 363
					},
					{
						"n": 18,
						"h": 44,
						"w": 368
					},
					{
						"n": 17,
						"h": 255,
						"w": 495
					},
					{
						"n": 19,
						"h": 308,
						"w": 280
					},
					{
						"n": 20,
						"h": 162,
						"w": 273
					}
				],
				"ball": {
					"n": 0,
					"h": 120,
					"w": 215,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1655,
			"minute": 80,
			"messages": [
				{
					"owner": 2,
					"mes": "Изящный пас на М.Томасова[37](Опава)..."
				},
				{
					"owner": 2,
					"mes": "Байрон О`Горман[19](Галвэй Юнайтед) читает комбинацию и перехватывает мяч!..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 710
					},
					{
						"n": 2,
						"h": 330,
						"w": 467
					},
					{
						"n": 14,
						"h": 283,
						"w": 458
					},
					{
						"n": 13,
						"h": 173,
						"w": 446
					},
					{
						"n": 5,
						"h": 120,
						"w": 471
					},
					{
						"n": 6,
						"h": 400,
						"w": 334
					},
					{
						"n": 18,
						"h": 245,
						"w": 365
					},
					{
						"n": 15,
						"h": 215,
						"w": 379
					},
					{
						"n": 17,
						"h": 88,
						"w": 228
					},
					{
						"n": 20,
						"h": 296,
						"w": 286
					},
					{
						"n": 19,
						"h": 140,
						"w": 216
					}
				],
				"away": [
					{
						"n": 12,
						"h": 222,
						"w": 710
					},
					{
						"n": 13,
						"h": 330,
						"w": 505,
						"m": 590
					},
					{
						"n": 3,
						"h": 275,
						"w": 597
					},
					{
						"n": 14,
						"h": 170,
						"w": 594
					},
					{
						"n": 5,
						"h": 68,
						"w": 593
					},
					{
						"n": 16,
						"h": 224,
						"w": 435
					},
					{
						"n": 15,
						"h": 232,
						"w": 357
					},
					{
						"n": 18,
						"h": 43,
						"w": 358
					},
					{
						"n": 17,
						"h": 264,
						"w": 497,
						"m": 650
					},
					{
						"n": 19,
						"h": 300,
						"w": 273
					},
					{
						"n": 20,
						"h": 155,
						"w": 280
					}
				],
				"ball": {
					"n": 0,
					"h": 140,
					"w": 216,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 10
		},
		{
			"num": 1656,
			"minute": 80,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 701
					},
					{
						"n": 2,
						"h": 347,
						"w": 431
					},
					{
						"n": 14,
						"h": 278,
						"w": 420
					},
					{
						"n": 13,
						"h": 176,
						"w": 426
					},
					{
						"n": 5,
						"h": 105,
						"w": 434
					},
					{
						"n": 6,
						"h": 403,
						"w": 294
					},
					{
						"n": 18,
						"h": 255,
						"w": 326
					},
					{
						"n": 15,
						"h": 195,
						"w": 344
					},
					{
						"n": 17,
						"h": 49,
						"w": 222
					},
					{
						"n": 20,
						"h": 295,
						"w": 246
					},
					{
						"n": 19,
						"h": 140,
						"w": 172,
						"m": 670
					}
				],
				"away": [
					{
						"n": 12,
						"h": 230,
						"w": 689
					},
					{
						"n": 13,
						"h": 372,
						"w": 522
					},
					{
						"n": 3,
						"h": 307,
						"w": 568
					},
					{
						"n": 14,
						"h": 210,
						"w": 596
					},
					{
						"n": 5,
						"h": 105,
						"w": 609
					},
					{
						"n": 16,
						"h": 228,
						"w": 474
					},
					{
						"n": 15,
						"h": 230,
						"w": 397
					},
					{
						"n": 18,
						"h": 44,
						"w": 398
					},
					{
						"n": 17,
						"h": 287,
						"w": 533
					},
					{
						"n": 19,
						"h": 287,
						"w": 311
					},
					{
						"n": 20,
						"h": 166,
						"w": 318
					}
				],
				"ball": {
					"n": 0,
					"h": 140,
					"w": 172,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1657,
			"minute": 80,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 704
					},
					{
						"n": 2,
						"h": 350,
						"w": 427
					},
					{
						"n": 14,
						"h": 273,
						"w": 419
					},
					{
						"n": 13,
						"h": 180,
						"w": 423
					},
					{
						"n": 5,
						"h": 103,
						"w": 429
					},
					{
						"n": 6,
						"h": 403,
						"w": 289
					},
					{
						"n": 18,
						"h": 256,
						"w": 321
					},
					{
						"n": 15,
						"h": 193,
						"w": 339
					},
					{
						"n": 17,
						"h": 49,
						"w": 217
					},
					{
						"n": 20,
						"h": 294,
						"w": 241
					},
					{
						"n": 19,
						"h": 141,
						"w": 167
					}
				],
				"away": [
					{
						"n": 12,
						"h": 230,
						"w": 689
					},
					{
						"n": 13,
						"h": 377,
						"w": 524
					},
					{
						"n": 3,
						"h": 308,
						"w": 563
					},
					{
						"n": 14,
						"h": 214,
						"w": 599
					},
					{
						"n": 5,
						"h": 106,
						"w": 613
					},
					{
						"n": 16,
						"h": 224,
						"w": 477
					},
					{
						"n": 15,
						"h": 229,
						"w": 402
					},
					{
						"n": 18,
						"h": 45,
						"w": 403
					},
					{
						"n": 17,
						"h": 287,
						"w": 533
					},
					{
						"n": 19,
						"h": 285,
						"w": 316
					},
					{
						"n": 20,
						"h": 168,
						"w": 323
					}
				],
				"ball": {
					"n": 0,
					"h": 141,
					"w": 167,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 5
		},
		{
			"num": 1658,
			"minute": 80,
			"messages": [
				{
					"owner": 1,
					"mes": "Байрон О`Горман[19](Галвэй Юнайтед) один в один пытается обыграть Н.Мансура[23](Опава)..."
				},
				{
					"owner": 1,
					"mes": "Классный отбор Н.Мансура[23](Опава)!.."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 704
					},
					{
						"n": 2,
						"h": 352,
						"w": 422
					},
					{
						"n": 14,
						"h": 271,
						"w": 418
					},
					{
						"n": 13,
						"h": 182,
						"w": 421
					},
					{
						"n": 5,
						"h": 102,
						"w": 425
					},
					{
						"n": 6,
						"h": 403,
						"w": 284
					},
					{
						"n": 18,
						"h": 257,
						"w": 316
					},
					{
						"n": 15,
						"h": 191,
						"w": 335
					},
					{
						"n": 17,
						"h": 49,
						"w": 212
					},
					{
						"n": 20,
						"h": 293,
						"w": 236
					},
					{
						"n": 19,
						"h": 142,
						"w": 157,
						"m": 660
					}
				],
				"away": [
					{
						"n": 12,
						"h": 230,
						"w": 689
					},
					{
						"n": 13,
						"h": 382,
						"w": 526
					},
					{
						"n": 3,
						"h": 308,
						"w": 558,
						"m": 700
					},
					{
						"n": 14,
						"h": 218,
						"w": 602
					},
					{
						"n": 5,
						"h": 108,
						"w": 618
					},
					{
						"n": 16,
						"h": 219,
						"w": 479
					},
					{
						"n": 15,
						"h": 228,
						"w": 407
					},
					{
						"n": 18,
						"h": 45,
						"w": 408
					},
					{
						"n": 17,
						"h": 287,
						"w": 533
					},
					{
						"n": 19,
						"h": 283,
						"w": 320
					},
					{
						"n": 20,
						"h": 169,
						"w": 328
					}
				],
				"ball": {
					"n": 0,
					"h": 142,
					"w": 162,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 5
		},
		{
			"num": 1659,
			"minute": 80,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 704
					},
					{
						"n": 2,
						"h": 358,
						"w": 414
					},
					{
						"n": 14,
						"h": 271,
						"w": 418
					},
					{
						"n": 13,
						"h": 182,
						"w": 421
					},
					{
						"n": 5,
						"h": 98,
						"w": 415
					},
					{
						"n": 6,
						"h": 403,
						"w": 274
					},
					{
						"n": 18,
						"h": 260,
						"w": 307
					},
					{
						"n": 15,
						"h": 186,
						"w": 326
					},
					{
						"n": 17,
						"h": 50,
						"w": 202
					},
					{
						"n": 20,
						"h": 291,
						"w": 227
					},
					{
						"n": 19,
						"h": 142,
						"w": 157
					}
				],
				"away": [
					{
						"n": 12,
						"h": 230,
						"w": 689
					},
					{
						"n": 13,
						"h": 391,
						"w": 530
					},
					{
						"n": 3,
						"h": 310,
						"w": 548
					},
					{
						"n": 14,
						"h": 226,
						"w": 608
					},
					{
						"n": 5,
						"h": 110,
						"w": 623
					},
					{
						"n": 16,
						"h": 211,
						"w": 484
					},
					{
						"n": 15,
						"h": 227,
						"w": 417
					},
					{
						"n": 18,
						"h": 45,
						"w": 418
					},
					{
						"n": 17,
						"h": 287,
						"w": 533
					},
					{
						"n": 19,
						"h": 280,
						"w": 330
					},
					{
						"n": 20,
						"h": 172,
						"w": 337
					}
				],
				"ball": {
					"n": 0,
					"h": 140,
					"w": 172,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 10
		},
		{
			"num": 1660,
			"minute": 80,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 707
					},
					{
						"n": 2,
						"h": 330,
						"w": 442
					},
					{
						"n": 14,
						"h": 279,
						"w": 434
					},
					{
						"n": 13,
						"h": 169,
						"w": 445
					},
					{
						"n": 5,
						"h": 120,
						"w": 425
					},
					{
						"n": 6,
						"h": 399,
						"w": 314
					},
					{
						"n": 18,
						"h": 261,
						"w": 347
					},
					{
						"n": 15,
						"h": 204,
						"w": 334
					},
					{
						"n": 17,
						"h": 46,
						"w": 241
					},
					{
						"n": 20,
						"h": 291,
						"w": 267
					},
					{
						"n": 19,
						"h": 145,
						"w": 166
					}
				],
				"away": [
					{
						"n": 12,
						"h": 222,
						"w": 702
					},
					{
						"n": 13,
						"h": 404,
						"w": 492
					},
					{
						"n": 3,
						"h": 285,
						"w": 523
					},
					{
						"n": 14,
						"h": 206,
						"w": 608
					},
					{
						"n": 5,
						"h": 77,
						"w": 601
					},
					{
						"n": 16,
						"h": 214,
						"w": 461
					},
					{
						"n": 15,
						"h": 236,
						"w": 378
					},
					{
						"n": 18,
						"h": 45,
						"w": 378
					},
					{
						"n": 17,
						"h": 313,
						"w": 502
					},
					{
						"n": 19,
						"h": 300,
						"w": 317
					},
					{
						"n": 20,
						"h": 154,
						"w": 308
					}
				],
				"ball": {
					"n": 0,
					"h": 165,
					"w": 197,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1661,
			"minute": 80,
			"messages": [
				{
					"owner": 2,
					"mes": "Нир Мансур[23](Опава) отдает пас назад..."
				},
				{
					"owner": 2,
					"mes": "Вацлав Сланина[34](Опава) подрабатывает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 707
					},
					{
						"n": 2,
						"h": 330,
						"w": 457
					},
					{
						"n": 14,
						"h": 278,
						"w": 465
					},
					{
						"n": 13,
						"h": 164,
						"w": 466
					},
					{
						"n": 5,
						"h": 120,
						"w": 452
					},
					{
						"n": 6,
						"h": 398,
						"w": 345
					},
					{
						"n": 18,
						"h": 241,
						"w": 370
					},
					{
						"n": 15,
						"h": 177,
						"w": 347
					},
					{
						"n": 17,
						"h": 45,
						"w": 272
					},
					{
						"n": 20,
						"h": 285,
						"w": 297
					},
					{
						"n": 19,
						"h": 141,
						"w": 197
					}
				],
				"away": [
					{
						"n": 12,
						"h": 228,
						"w": 701
					},
					{
						"n": 13,
						"h": 405,
						"w": 461
					},
					{
						"n": 3,
						"h": 284,
						"w": 533,
						"m": 710
					},
					{
						"n": 14,
						"h": 229,
						"w": 596
					},
					{
						"n": 5,
						"h": 74,
						"w": 604
					},
					{
						"n": 16,
						"h": 210,
						"w": 434
					},
					{
						"n": 15,
						"h": 213,
						"w": 364
					},
					{
						"n": 18,
						"h": 46,
						"w": 347
					},
					{
						"n": 17,
						"h": 328,
						"w": 475
					},
					{
						"n": 19,
						"h": 310,
						"w": 288
					},
					{
						"n": 20,
						"h": 154,
						"w": 282
					}
				],
				"ball": {
					"n": 0,
					"h": 221,
					"w": 124,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 31
		},
		{
			"num": 1662,
			"minute": 80,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 706
					},
					{
						"n": 2,
						"h": 330,
						"w": 468
					},
					{
						"n": 14,
						"h": 287,
						"w": 461
					},
					{
						"n": 13,
						"h": 173,
						"w": 485
					},
					{
						"n": 5,
						"h": 120,
						"w": 462
					},
					{
						"n": 6,
						"h": 396,
						"w": 385
					},
					{
						"n": 18,
						"h": 239,
						"w": 393
					},
					{
						"n": 15,
						"h": 181,
						"w": 365
					},
					{
						"n": 17,
						"h": 51,
						"w": 312
					},
					{
						"n": 20,
						"h": 290,
						"w": 305
					},
					{
						"n": 19,
						"h": 137,
						"w": 237
					}
				],
				"away": [
					{
						"n": 12,
						"h": 223,
						"w": 706
					},
					{
						"n": 13,
						"h": 404,
						"w": 454
					},
					{
						"n": 3,
						"h": 276,
						"w": 572
					},
					{
						"n": 14,
						"h": 211,
						"w": 566
					},
					{
						"n": 5,
						"h": 65,
						"w": 577
					},
					{
						"n": 16,
						"h": 230,
						"w": 426
					},
					{
						"n": 15,
						"h": 216,
						"w": 359
					},
					{
						"n": 18,
						"h": 53,
						"w": 308
					},
					{
						"n": 17,
						"h": 347,
						"w": 439
					},
					{
						"n": 19,
						"h": 295,
						"w": 278
					},
					{
						"n": 20,
						"h": 147,
						"w": 271
					}
				],
				"ball": {
					"n": 0,
					"h": 239,
					"w": 154,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1663,
			"minute": 80,
			"messages": [
				{
					"owner": 2,
					"mes": "Вацлав Сланина[34](Опава) отправляет мяч вперед М.Владаржу[36](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 709
					},
					{
						"n": 2,
						"h": 330,
						"w": 485
					},
					{
						"n": 14,
						"h": 290,
						"w": 487
					},
					{
						"n": 13,
						"h": 173,
						"w": 479
					},
					{
						"n": 5,
						"h": 120,
						"w": 488
					},
					{
						"n": 6,
						"h": 395,
						"w": 425
					},
					{
						"n": 18,
						"h": 275,
						"w": 405
					},
					{
						"n": 15,
						"h": 213,
						"w": 389
					},
					{
						"n": 17,
						"h": 42,
						"w": 351
					},
					{
						"n": 20,
						"h": 253,
						"w": 289
					},
					{
						"n": 19,
						"h": 151,
						"w": 275
					}
				],
				"away": [
					{
						"n": 12,
						"h": 226,
						"w": 701
					},
					{
						"n": 13,
						"h": 407,
						"w": 436
					},
					{
						"n": 3,
						"h": 275,
						"w": 571
					},
					{
						"n": 14,
						"h": 206,
						"w": 567,
						"m": 720
					},
					{
						"n": 5,
						"h": 61,
						"w": 572
					},
					{
						"n": 16,
						"h": 200,
						"w": 453
					},
					{
						"n": 15,
						"h": 233,
						"w": 323
					},
					{
						"n": 18,
						"h": 42,
						"w": 269
					},
					{
						"n": 17,
						"h": 377,
						"w": 413
					},
					{
						"n": 19,
						"h": 307,
						"w": 255
					},
					{
						"n": 20,
						"h": 149,
						"w": 255
					}
				],
				"ball": {
					"n": 0,
					"h": 250,
					"w": 267,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1664,
			"minute": 80,
			"messages": [
				{
					"owner": 2,
					"mes": "Михаэль Владарж[36](Опава) делает пас на В.Сланину[34](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 708
					},
					{
						"n": 2,
						"h": 330,
						"w": 466
					},
					{
						"n": 14,
						"h": 277,
						"w": 465
					},
					{
						"n": 13,
						"h": 171,
						"w": 465
					},
					{
						"n": 5,
						"h": 120,
						"w": 470
					},
					{
						"n": 6,
						"h": 392,
						"w": 452
					},
					{
						"n": 18,
						"h": 244,
						"w": 398
					},
					{
						"n": 15,
						"h": 197,
						"w": 361
					},
					{
						"n": 17,
						"h": 54,
						"w": 367
					},
					{
						"n": 20,
						"h": 285,
						"w": 288
					},
					{
						"n": 19,
						"h": 166,
						"w": 303
					}
				],
				"away": [
					{
						"n": 12,
						"h": 225,
						"w": 702
					},
					{
						"n": 13,
						"h": 412,
						"w": 442
					},
					{
						"n": 3,
						"h": 275,
						"w": 603
					},
					{
						"n": 14,
						"h": 186,
						"w": 542
					},
					{
						"n": 5,
						"h": 73,
						"w": 602
					},
					{
						"n": 16,
						"h": 207,
						"w": 445,
						"m": 610
					},
					{
						"n": 15,
						"h": 217,
						"w": 341
					},
					{
						"n": 18,
						"h": 43,
						"w": 270
					},
					{
						"n": 17,
						"h": 373,
						"w": 443
					},
					{
						"n": 19,
						"h": 301,
						"w": 276
					},
					{
						"n": 20,
						"h": 153,
						"w": 285
					}
				],
				"ball": {
					"n": 0,
					"h": 264,
					"w": 178,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 32
		},
		{
			"num": 1665,
			"minute": 80,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 708
					},
					{
						"n": 2,
						"h": 330,
						"w": 464
					},
					{
						"n": 14,
						"h": 284,
						"w": 460
					},
					{
						"n": 13,
						"h": 171,
						"w": 466
					},
					{
						"n": 5,
						"h": 120,
						"w": 470
					},
					{
						"n": 6,
						"h": 394,
						"w": 425
					},
					{
						"n": 18,
						"h": 241,
						"w": 396
					},
					{
						"n": 15,
						"h": 175,
						"w": 365
					},
					{
						"n": 17,
						"h": 51,
						"w": 360
					},
					{
						"n": 20,
						"h": 283,
						"w": 248
					},
					{
						"n": 19,
						"h": 175,
						"w": 307
					}
				],
				"away": [
					{
						"n": 12,
						"h": 228,
						"w": 707
					},
					{
						"n": 13,
						"h": 411,
						"w": 402
					},
					{
						"n": 3,
						"h": 283,
						"w": 592
					},
					{
						"n": 14,
						"h": 168,
						"w": 511
					},
					{
						"n": 5,
						"h": 69,
						"w": 574
					},
					{
						"n": 16,
						"h": 211,
						"w": 423
					},
					{
						"n": 15,
						"h": 211,
						"w": 329
					},
					{
						"n": 18,
						"h": 38,
						"w": 310
					},
					{
						"n": 17,
						"h": 412,
						"w": 434
					},
					{
						"n": 19,
						"h": 309,
						"w": 281
					},
					{
						"n": 20,
						"h": 149,
						"w": 295
					}
				],
				"ball": {
					"n": 0,
					"h": 282,
					"w": 209,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1666,
			"minute": 80,
			"messages": [
				{
					"owner": 2,
					"mes": "Передача налево..."
				},
				{
					"owner": 2,
					"mes": "Марин Томасов[37](Опава) принимает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 709
					},
					{
						"n": 2,
						"h": 330,
						"w": 471
					},
					{
						"n": 14,
						"h": 274,
						"w": 474
					},
					{
						"n": 13,
						"h": 187,
						"w": 452
					},
					{
						"n": 5,
						"h": 120,
						"w": 464
					},
					{
						"n": 6,
						"h": 394,
						"w": 422
					},
					{
						"n": 18,
						"h": 245,
						"w": 379
					},
					{
						"n": 15,
						"h": 192,
						"w": 381
					},
					{
						"n": 17,
						"h": 56,
						"w": 391
					},
					{
						"n": 20,
						"h": 277,
						"w": 306
					},
					{
						"n": 19,
						"h": 168,
						"w": 316
					}
				],
				"away": [
					{
						"n": 12,
						"h": 226,
						"w": 708
					},
					{
						"n": 13,
						"h": 411,
						"w": 344
					},
					{
						"n": 3,
						"h": 283,
						"w": 586
					},
					{
						"n": 14,
						"h": 169,
						"w": 521
					},
					{
						"n": 5,
						"h": 61,
						"w": 592
					},
					{
						"n": 16,
						"h": 269,
						"w": 428
					},
					{
						"n": 15,
						"h": 252,
						"w": 328
					},
					{
						"n": 18,
						"h": 49,
						"w": 332
					},
					{
						"n": 17,
						"h": 394,
						"w": 458
					},
					{
						"n": 19,
						"h": 297,
						"w": 282
					},
					{
						"n": 20,
						"h": 146,
						"w": 268
					}
				],
				"ball": {
					"n": 0,
					"h": 56,
					"w": 262,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 58
		},
		{
			"num": 1667,
			"minute": 80,
			"messages": [
				{
					"owner": 2,
					"mes": "М.Томасов[37](Опава) делает передачу К.Удре[33](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 701
					},
					{
						"n": 2,
						"h": 330,
						"w": 500
					},
					{
						"n": 14,
						"h": 286,
						"w": 497
					},
					{
						"n": 13,
						"h": 176,
						"w": 479
					},
					{
						"n": 5,
						"h": 99,
						"w": 485
					},
					{
						"n": 6,
						"h": 394,
						"w": 394
					},
					{
						"n": 18,
						"h": 234,
						"w": 406
					},
					{
						"n": 15,
						"h": 178,
						"w": 404
					},
					{
						"n": 17,
						"h": 55,
						"w": 362
					},
					{
						"n": 20,
						"h": 284,
						"w": 334
					},
					{
						"n": 19,
						"h": 172,
						"w": 333
					}
				],
				"away": [
					{
						"n": 12,
						"h": 225,
						"w": 706
					},
					{
						"n": 13,
						"h": 398,
						"w": 370
					},
					{
						"n": 3,
						"h": 282,
						"w": 557
					},
					{
						"n": 14,
						"h": 162,
						"w": 549
					},
					{
						"n": 5,
						"h": 50,
						"w": 565
					},
					{
						"n": 16,
						"h": 242,
						"w": 417
					},
					{
						"n": 15,
						"h": 231,
						"w": 323
					},
					{
						"n": 18,
						"h": 43,
						"w": 361
					},
					{
						"n": 17,
						"h": 396,
						"w": 449
					},
					{
						"n": 19,
						"h": 293,
						"w": 253
					},
					{
						"n": 20,
						"h": 151,
						"w": 239
					}
				],
				"ball": {
					"n": 0,
					"h": 52,
					"w": 350,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 29
		},
		{
			"num": 1668,
			"minute": 80,
			"messages": [
				{
					"owner": 2,
					"mes": "Кеннет Удре[33](Опава) пасует назад..."
				},
				{
					"owner": 2,
					"mes": "Нир Мансур[23](Опава) технично принимает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 710
					},
					{
						"n": 2,
						"h": 330,
						"w": 452
					},
					{
						"n": 14,
						"h": 285,
						"w": 465
					},
					{
						"n": 13,
						"h": 178,
						"w": 451
					},
					{
						"n": 5,
						"h": 120,
						"w": 453
					},
					{
						"n": 6,
						"h": 419,
						"w": 360
					},
					{
						"n": 18,
						"h": 224,
						"w": 389
					},
					{
						"n": 15,
						"h": 187,
						"w": 357
					},
					{
						"n": 17,
						"h": 56,
						"w": 375
					},
					{
						"n": 20,
						"h": 303,
						"w": 290
					},
					{
						"n": 19,
						"h": 169,
						"w": 303
					}
				],
				"away": [
					{
						"n": 12,
						"h": 230,
						"w": 688
					},
					{
						"n": 13,
						"h": 399,
						"w": 380
					},
					{
						"n": 3,
						"h": 297,
						"w": 534
					},
					{
						"n": 14,
						"h": 159,
						"w": 555
					},
					{
						"n": 5,
						"h": 46,
						"w": 555
					},
					{
						"n": 16,
						"h": 218,
						"w": 418
					},
					{
						"n": 15,
						"h": 220,
						"w": 349
					},
					{
						"n": 18,
						"h": 49,
						"w": 409
					},
					{
						"n": 17,
						"h": 406,
						"w": 402
					},
					{
						"n": 19,
						"h": 284,
						"w": 280
					},
					{
						"n": 20,
						"h": 154,
						"w": 280
					}
				],
				"ball": {
					"n": 0,
					"h": 153,
					"w": 186,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 48
		},
		{
			"num": 1669,
			"minute": 80,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 708
					},
					{
						"n": 2,
						"h": 330,
						"w": 469
					},
					{
						"n": 14,
						"h": 276,
						"w": 470
					},
					{
						"n": 13,
						"h": 168,
						"w": 457
					},
					{
						"n": 5,
						"h": 120,
						"w": 455
					},
					{
						"n": 6,
						"h": 422,
						"w": 360
					},
					{
						"n": 18,
						"h": 256,
						"w": 390
					},
					{
						"n": 15,
						"h": 221,
						"w": 377
					},
					{
						"n": 17,
						"h": 56,
						"w": 373
					},
					{
						"n": 20,
						"h": 290,
						"w": 291
					},
					{
						"n": 19,
						"h": 147,
						"w": 280
					}
				],
				"away": [
					{
						"n": 12,
						"h": 230,
						"w": 669
					},
					{
						"n": 13,
						"h": 403,
						"w": 420
					},
					{
						"n": 3,
						"h": 315,
						"w": 504
					},
					{
						"n": 14,
						"h": 158,
						"w": 545
					},
					{
						"n": 5,
						"h": 40,
						"w": 545
					},
					{
						"n": 16,
						"h": 229,
						"w": 413
					},
					{
						"n": 15,
						"h": 232,
						"w": 346
					},
					{
						"n": 18,
						"h": 42,
						"w": 413
					},
					{
						"n": 17,
						"h": 413,
						"w": 362
					},
					{
						"n": 19,
						"h": 298,
						"w": 280
					},
					{
						"n": 20,
						"h": 158,
						"w": 280
					}
				],
				"ball": {
					"n": 0,
					"h": 135,
					"w": 216,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1670,
			"minute": 81,
			"possession": 43,
			"messages": [
				{
					"owner": 2,
					"mes": "Пас правее на В.Сланину[34](Опава)..."
				},
				{
					"owner": 2,
					"mes": "Вацлав Сланина[34](Опава) получает передачу..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 704
					},
					{
						"n": 2,
						"h": 330,
						"w": 472,
						"f": 77
					},
					{
						"n": 14,
						"h": 260,
						"w": 468
					},
					{
						"n": 13,
						"h": 195,
						"w": 475,
						"f": 93
					},
					{
						"n": 5,
						"h": 120,
						"w": 465
					},
					{
						"n": 6,
						"h": 394,
						"w": 376
					},
					{
						"n": 18,
						"h": 271,
						"w": 397,
						"f": 93
					},
					{
						"n": 15,
						"h": 217,
						"w": 378
					},
					{
						"n": 17,
						"h": 56,
						"w": 427,
						"f": 86
					},
					{
						"n": 20,
						"h": 291,
						"w": 249
					},
					{
						"n": 19,
						"h": 141,
						"w": 290
					}
				],
				"away": [
					{
						"n": 12,
						"h": 220,
						"w": 649
					},
					{
						"n": 13,
						"h": 391,
						"w": 460
					},
					{
						"n": 3,
						"h": 285,
						"w": 495
					},
					{
						"n": 14,
						"h": 159,
						"w": 491
					},
					{
						"n": 5,
						"h": 60,
						"w": 495
					},
					{
						"n": 16,
						"h": 199,
						"w": 406,
						"f": 93
					},
					{
						"n": 15,
						"h": 235,
						"w": 352
					},
					{
						"n": 18,
						"h": 42,
						"w": 359,
						"f": 92
					},
					{
						"n": 17,
						"h": 401,
						"w": 310
					},
					{
						"n": 19,
						"h": 275,
						"w": 281,
						"f": 90
					},
					{
						"n": 20,
						"h": 170,
						"w": 282
					}
				],
				"ball": {
					"n": 0,
					"h": 291,
					"w": 229,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 54
		},
		{
			"num": 1671,
			"minute": 81,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 702
					},
					{
						"n": 2,
						"h": 330,
						"w": 512
					},
					{
						"n": 14,
						"h": 266,
						"w": 508
					},
					{
						"n": 13,
						"h": 186,
						"w": 514
					},
					{
						"n": 5,
						"h": 83,
						"w": 470
					},
					{
						"n": 6,
						"h": 394,
						"w": 416
					},
					{
						"n": 18,
						"h": 262,
						"w": 436
					},
					{
						"n": 15,
						"h": 221,
						"w": 412
					},
					{
						"n": 17,
						"h": 38,
						"w": 429
					},
					{
						"n": 20,
						"h": 256,
						"w": 249
					},
					{
						"n": 19,
						"h": 154,
						"w": 328
					}
				],
				"away": [
					{
						"n": 12,
						"h": 225,
						"w": 629
					},
					{
						"n": 13,
						"h": 393,
						"w": 420
					},
					{
						"n": 3,
						"h": 282,
						"w": 535
					},
					{
						"n": 14,
						"h": 194,
						"w": 491
					},
					{
						"n": 5,
						"h": 70,
						"w": 534
					},
					{
						"n": 16,
						"h": 237,
						"w": 393
					},
					{
						"n": 15,
						"h": 234,
						"w": 312
					},
					{
						"n": 18,
						"h": 40,
						"w": 319
					},
					{
						"n": 17,
						"h": 397,
						"w": 270
					},
					{
						"n": 19,
						"h": 281,
						"w": 241
					},
					{
						"n": 20,
						"h": 165,
						"w": 242
					}
				],
				"ball": {
					"n": 0,
					"h": 256,
					"w": 229,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1672,
			"minute": 81,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 708
					},
					{
						"n": 2,
						"h": 330,
						"w": 552
					},
					{
						"n": 14,
						"h": 272,
						"w": 547
					},
					{
						"n": 13,
						"h": 180,
						"w": 554
					},
					{
						"n": 5,
						"h": 94,
						"w": 509
					},
					{
						"n": 6,
						"h": 394,
						"w": 456
					},
					{
						"n": 18,
						"h": 266,
						"w": 476
					},
					{
						"n": 15,
						"h": 215,
						"w": 452
					},
					{
						"n": 17,
						"h": 35,
						"w": 449
					},
					{
						"n": 20,
						"h": 286,
						"w": 266
					},
					{
						"n": 19,
						"h": 158,
						"w": 368
					}
				],
				"away": [
					{
						"n": 12,
						"h": 220,
						"w": 607
					},
					{
						"n": 13,
						"h": 399,
						"w": 380
					},
					{
						"n": 3,
						"h": 277,
						"w": 495
					},
					{
						"n": 14,
						"h": 164,
						"w": 474
					},
					{
						"n": 5,
						"h": 69,
						"w": 494
					},
					{
						"n": 16,
						"h": 232,
						"w": 354
					},
					{
						"n": 15,
						"h": 234,
						"w": 272
					},
					{
						"n": 18,
						"h": 36,
						"w": 279
					},
					{
						"n": 17,
						"h": 360,
						"w": 254
					},
					{
						"n": 19,
						"h": 294,
						"w": 204
					},
					{
						"n": 20,
						"h": 154,
						"w": 204
					}
				],
				"ball": {
					"n": 0,
					"h": 286,
					"w": 246,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1673,
			"minute": 81,
			"messages": [
				{
					"owner": 2,
					"mes": "Вацлав Сланина[34](Опава) пасует вперед М.Владаржу[36](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 706
					},
					{
						"n": 2,
						"h": 330,
						"w": 596
					},
					{
						"n": 14,
						"h": 279,
						"w": 591
					},
					{
						"n": 13,
						"h": 175,
						"w": 597
					},
					{
						"n": 5,
						"h": 104,
						"w": 551
					},
					{
						"n": 6,
						"h": 394,
						"w": 500
					},
					{
						"n": 18,
						"h": 249,
						"w": 516
					},
					{
						"n": 15,
						"h": 193,
						"w": 489
					},
					{
						"n": 17,
						"h": 72,
						"w": 473
					},
					{
						"n": 20,
						"h": 287,
						"w": 310
					},
					{
						"n": 19,
						"h": 196,
						"w": 345
					}
				],
				"away": [
					{
						"n": 12,
						"h": 222,
						"w": 594
					},
					{
						"n": 13,
						"h": 403,
						"w": 337
					},
					{
						"n": 3,
						"h": 281,
						"w": 453
					},
					{
						"n": 14,
						"h": 168,
						"w": 462
					},
					{
						"n": 5,
						"h": 65,
						"w": 450
					},
					{
						"n": 16,
						"h": 254,
						"w": 375
					},
					{
						"n": 15,
						"h": 216,
						"w": 232
					},
					{
						"n": 18,
						"h": 42,
						"w": 235
					},
					{
						"n": 17,
						"h": 368,
						"w": 275
					},
					{
						"n": 19,
						"h": 295,
						"w": 160
					},
					{
						"n": 20,
						"h": 158,
						"w": 160
					}
				],
				"ball": {
					"n": 0,
					"h": 196,
					"w": 345,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 44
		},
		{
			"num": 1674,
			"minute": 81,
			"messages": [
				{
					"owner": 2,
					"mes": "Михаэль Владарж[36](Опава) укрывает мяч корпусом..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 707
					},
					{
						"n": 2,
						"h": 330,
						"w": 606
					},
					{
						"n": 14,
						"h": 274,
						"w": 599
					},
					{
						"n": 13,
						"h": 177,
						"w": 607
					},
					{
						"n": 5,
						"h": 107,
						"w": 561
					},
					{
						"n": 6,
						"h": 394,
						"w": 510
					},
					{
						"n": 18,
						"h": 254,
						"w": 524
					},
					{
						"n": 15,
						"h": 184,
						"w": 494
					},
					{
						"n": 17,
						"h": 68,
						"w": 463
					},
					{
						"n": 20,
						"h": 287,
						"w": 320
					},
					{
						"n": 19,
						"h": 196,
						"w": 348
					}
				],
				"away": [
					{
						"n": 12,
						"h": 226,
						"w": 597
					},
					{
						"n": 13,
						"h": 401,
						"w": 327
					},
					{
						"n": 3,
						"h": 273,
						"w": 456
					},
					{
						"n": 14,
						"h": 162,
						"w": 455
					},
					{
						"n": 5,
						"h": 65,
						"w": 440
					},
					{
						"n": 16,
						"h": 246,
						"w": 382
					},
					{
						"n": 15,
						"h": 216,
						"w": 242
					},
					{
						"n": 18,
						"h": 44,
						"w": 225
					},
					{
						"n": 17,
						"h": 358,
						"w": 275
					},
					{
						"n": 19,
						"h": 290,
						"w": 151
					},
					{
						"n": 20,
						"h": 165,
						"w": 153
					}
				],
				"ball": {
					"n": 0,
					"h": 204,
					"w": 338,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 10
		},
		{
			"num": 1675,
			"minute": 81,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 701
					},
					{
						"n": 2,
						"h": 297,
						"w": 596
					},
					{
						"n": 14,
						"h": 265,
						"w": 619
					},
					{
						"n": 13,
						"h": 184,
						"w": 629
					},
					{
						"n": 5,
						"h": 135,
						"w": 590
					},
					{
						"n": 6,
						"h": 394,
						"w": 547
					},
					{
						"n": 18,
						"h": 244,
						"w": 524
					},
					{
						"n": 15,
						"h": 184,
						"w": 510
					},
					{
						"n": 17,
						"h": 56,
						"w": 448
					},
					{
						"n": 20,
						"h": 290,
						"w": 360
					},
					{
						"n": 19,
						"h": 228,
						"w": 371
					}
				],
				"away": [
					{
						"n": 12,
						"h": 220,
						"w": 600
					},
					{
						"n": 13,
						"h": 409,
						"w": 287
					},
					{
						"n": 3,
						"h": 285,
						"w": 454
					},
					{
						"n": 14,
						"h": 171,
						"w": 448
					},
					{
						"n": 5,
						"h": 66,
						"w": 455
					},
					{
						"n": 16,
						"h": 216,
						"w": 365
					},
					{
						"n": 15,
						"h": 213,
						"w": 202
					},
					{
						"n": 18,
						"h": 29,
						"w": 188
					},
					{
						"n": 17,
						"h": 320,
						"w": 262
					},
					{
						"n": 19,
						"h": 309,
						"w": 144
					},
					{
						"n": 20,
						"h": 152,
						"w": 144
					}
				],
				"ball": {
					"n": 0,
					"h": 234,
					"w": 355,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1676,
			"minute": 81,
			"messages": [
				{
					"owner": 2,
					"mes": "Передача Н.Мансуру[23](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 706
					},
					{
						"n": 2,
						"h": 317,
						"w": 573
					},
					{
						"n": 14,
						"h": 270,
						"w": 588
					},
					{
						"n": 13,
						"h": 176,
						"w": 599
					},
					{
						"n": 5,
						"h": 121,
						"w": 562
					},
					{
						"n": 6,
						"h": 394,
						"w": 535
					},
					{
						"n": 18,
						"h": 274,
						"w": 518
					},
					{
						"n": 15,
						"h": 210,
						"w": 493
					},
					{
						"n": 17,
						"h": 56,
						"w": 417
					},
					{
						"n": 20,
						"h": 317,
						"w": 376
					},
					{
						"n": 19,
						"h": 207,
						"w": 348
					}
				],
				"away": [
					{
						"n": 12,
						"h": 225,
						"w": 610
					},
					{
						"n": 13,
						"h": 412,
						"w": 318
					},
					{
						"n": 3,
						"h": 273,
						"w": 425
					},
					{
						"n": 14,
						"h": 176,
						"w": 479
					},
					{
						"n": 5,
						"h": 66,
						"w": 486
					},
					{
						"n": 16,
						"h": 217,
						"w": 355
					},
					{
						"n": 15,
						"h": 230,
						"w": 228
					},
					{
						"n": 18,
						"h": 36,
						"w": 200
					},
					{
						"n": 17,
						"h": 313,
						"w": 292
					},
					{
						"n": 19,
						"h": 298,
						"w": 173
					},
					{
						"n": 20,
						"h": 162,
						"w": 173
					}
				],
				"ball": {
					"n": 0,
					"h": 177,
					"w": 295,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 31
		},
		{
			"num": 1677,
			"minute": 81,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 708
					},
					{
						"n": 2,
						"h": 304,
						"w": 588
					},
					{
						"n": 14,
						"h": 276,
						"w": 604
					},
					{
						"n": 13,
						"h": 178,
						"w": 601
					},
					{
						"n": 5,
						"h": 145,
						"w": 591
					},
					{
						"n": 6,
						"h": 394,
						"w": 545
					},
					{
						"n": 18,
						"h": 237,
						"w": 529
					},
					{
						"n": 15,
						"h": 182,
						"w": 507
					},
					{
						"n": 17,
						"h": 56,
						"w": 456
					},
					{
						"n": 20,
						"h": 283,
						"w": 395
					},
					{
						"n": 19,
						"h": 172,
						"w": 349
					}
				],
				"away": [
					{
						"n": 12,
						"h": 225,
						"w": 599
					},
					{
						"n": 13,
						"h": 415,
						"w": 279
					},
					{
						"n": 3,
						"h": 278,
						"w": 391
					},
					{
						"n": 14,
						"h": 170,
						"w": 440
					},
					{
						"n": 5,
						"h": 75,
						"w": 450
					},
					{
						"n": 16,
						"h": 220,
						"w": 316
					},
					{
						"n": 15,
						"h": 220,
						"w": 190
					},
					{
						"n": 18,
						"h": 22,
						"w": 190
					},
					{
						"n": 17,
						"h": 283,
						"w": 268
					},
					{
						"n": 19,
						"h": 313,
						"w": 144
					},
					{
						"n": 20,
						"h": 138,
						"w": 144
					}
				],
				"ball": {
					"n": 0,
					"h": 172,
					"w": 329,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 1678,
			"minute": 81,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 706
					},
					{
						"n": 2,
						"h": 330,
						"w": 613
					},
					{
						"n": 14,
						"h": 286,
						"w": 615
					},
					{
						"n": 13,
						"h": 170,
						"w": 593
					},
					{
						"n": 5,
						"h": 120,
						"w": 606
					},
					{
						"n": 6,
						"h": 394,
						"w": 552
					},
					{
						"n": 18,
						"h": 241,
						"w": 540
					},
					{
						"n": 15,
						"h": 178,
						"w": 490
					},
					{
						"n": 17,
						"h": 56,
						"w": 495
					},
					{
						"n": 20,
						"h": 275,
						"w": 412
					},
					{
						"n": 19,
						"h": 142,
						"w": 367
					}
				],
				"away": [
					{
						"n": 12,
						"h": 225,
						"w": 597
					},
					{
						"n": 13,
						"h": 419,
						"w": 240
					},
					{
						"n": 3,
						"h": 308,
						"w": 373
					},
					{
						"n": 14,
						"h": 177,
						"w": 443
					},
					{
						"n": 5,
						"h": 62,
						"w": 425
					},
					{
						"n": 16,
						"h": 217,
						"w": 276
					},
					{
						"n": 15,
						"h": 215,
						"w": 174
					},
					{
						"n": 18,
						"h": 21,
						"w": 183
					},
					{
						"n": 17,
						"h": 297,
						"w": 248
					},
					{
						"n": 19,
						"h": 291,
						"w": 144
					},
					{
						"n": 20,
						"h": 154,
						"w": 144
					}
				],
				"ball": {
					"n": 0,
					"h": 142,
					"w": 347,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1679,
			"minute": 81,
			"messages": [
				{
					"owner": 2,
					"mes": "Нир Мансур[23](Опава) отправляет мяч направо Т.Прохазке[25](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 703
					},
					{
						"n": 2,
						"h": 330,
						"w": 570
					},
					{
						"n": 14,
						"h": 275,
						"w": 561
					},
					{
						"n": 13,
						"h": 190,
						"w": 557
					},
					{
						"n": 5,
						"h": 120,
						"w": 551
					},
					{
						"n": 6,
						"h": 394,
						"w": 535
					},
					{
						"n": 18,
						"h": 278,
						"w": 500
					},
					{
						"n": 15,
						"h": 232,
						"w": 477
					},
					{
						"n": 17,
						"h": 56,
						"w": 440
					},
					{
						"n": 20,
						"h": 316,
						"w": 375
					},
					{
						"n": 19,
						"h": 160,
						"w": 419
					}
				],
				"away": [
					{
						"n": 12,
						"h": 215,
						"w": 614
					},
					{
						"n": 13,
						"h": 417,
						"w": 295
					},
					{
						"n": 3,
						"h": 306,
						"w": 383
					},
					{
						"n": 14,
						"h": 177,
						"w": 470
					},
					{
						"n": 5,
						"h": 92,
						"w": 405
					},
					{
						"n": 16,
						"h": 192,
						"w": 318
					},
					{
						"n": 15,
						"h": 211,
						"w": 222
					},
					{
						"n": 18,
						"h": 34,
						"w": 200
					},
					{
						"n": 17,
						"h": 284,
						"w": 301
					},
					{
						"n": 19,
						"h": 272,
						"w": 179
					},
					{
						"n": 20,
						"h": 163,
						"w": 186
					}
				],
				"ball": {
					"n": 0,
					"h": 358,
					"w": 315,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 55
		},
		{
			"num": 1680,
			"minute": 81,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 704
					},
					{
						"n": 2,
						"h": 358,
						"w": 597
					},
					{
						"n": 14,
						"h": 283,
						"w": 599
					},
					{
						"n": 13,
						"h": 185,
						"w": 596
					},
					{
						"n": 5,
						"h": 120,
						"w": 590
					},
					{
						"n": 6,
						"h": 394,
						"w": 536
					},
					{
						"n": 18,
						"h": 287,
						"w": 538
					},
					{
						"n": 15,
						"h": 225,
						"w": 516
					},
					{
						"n": 17,
						"h": 56,
						"w": 479
					},
					{
						"n": 20,
						"h": 354,
						"w": 370
					},
					{
						"n": 19,
						"h": 161,
						"w": 380
					}
				],
				"away": [
					{
						"n": 12,
						"h": 223,
						"w": 594
					},
					{
						"n": 13,
						"h": 421,
						"w": 256
					},
					{
						"n": 3,
						"h": 287,
						"w": 417
					},
					{
						"n": 14,
						"h": 178,
						"w": 438
					},
					{
						"n": 5,
						"h": 87,
						"w": 371
					},
					{
						"n": 16,
						"h": 207,
						"w": 282
					},
					{
						"n": 15,
						"h": 220,
						"w": 184
					},
					{
						"n": 18,
						"h": 24,
						"w": 199
					},
					{
						"n": 17,
						"h": 245,
						"w": 301
					},
					{
						"n": 19,
						"h": 289,
						"w": 144
					},
					{
						"n": 20,
						"h": 151,
						"w": 149
					}
				],
				"ball": {
					"n": 0,
					"h": 363,
					"w": 349,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 1681,
			"minute": 81,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 704
					},
					{
						"n": 2,
						"h": 331,
						"w": 582
					},
					{
						"n": 14,
						"h": 287,
						"w": 615
					},
					{
						"n": 13,
						"h": 180,
						"w": 597
					},
					{
						"n": 5,
						"h": 120,
						"w": 609
					},
					{
						"n": 6,
						"h": 394,
						"w": 566
					},
					{
						"n": 18,
						"h": 258,
						"w": 557
					},
					{
						"n": 15,
						"h": 214,
						"w": 518
					},
					{
						"n": 17,
						"h": 56,
						"w": 519
					},
					{
						"n": 20,
						"h": 391,
						"w": 386
					},
					{
						"n": 19,
						"h": 158,
						"w": 418
					}
				],
				"away": [
					{
						"n": 12,
						"h": 225,
						"w": 598
					},
					{
						"n": 13,
						"h": 423,
						"w": 216
					},
					{
						"n": 3,
						"h": 276,
						"w": 448
					},
					{
						"n": 14,
						"h": 169,
						"w": 449
					},
					{
						"n": 5,
						"h": 57,
						"w": 353
					},
					{
						"n": 16,
						"h": 197,
						"w": 244
					},
					{
						"n": 15,
						"h": 186,
						"w": 174
					},
					{
						"n": 18,
						"h": 21,
						"w": 189
					},
					{
						"n": 17,
						"h": 243,
						"w": 294
					},
					{
						"n": 19,
						"h": 288,
						"w": 144
					},
					{
						"n": 20,
						"h": 111,
						"w": 144
					}
				],
				"ball": {
					"n": 0,
					"h": 393,
					"w": 367,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1682,
			"minute": 81,
			"messages": [
				{
					"owner": 2,
					"mes": "Томаш Прохазка[25](Опава) отдает передачу в центр..."
				},
				{
					"owner": 2,
					"mes": "Вацлав Сланина[34](Опава) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 703
					},
					{
						"n": 2,
						"h": 378,
						"w": 596
					},
					{
						"n": 14,
						"h": 282,
						"w": 617
					},
					{
						"n": 13,
						"h": 173,
						"w": 605
					},
					{
						"n": 5,
						"h": 120,
						"w": 613
					},
					{
						"n": 6,
						"h": 394,
						"w": 601
					},
					{
						"n": 18,
						"h": 220,
						"w": 530
					},
					{
						"n": 15,
						"h": 184,
						"w": 495
					},
					{
						"n": 17,
						"h": 56,
						"w": 491
					},
					{
						"n": 20,
						"h": 345,
						"w": 403
					},
					{
						"n": 19,
						"h": 199,
						"w": 391
					}
				],
				"away": [
					{
						"n": 12,
						"h": 220,
						"w": 598
					},
					{
						"n": 13,
						"h": 416,
						"w": 264
					},
					{
						"n": 3,
						"h": 287,
						"w": 425
					},
					{
						"n": 14,
						"h": 174,
						"w": 400
					},
					{
						"n": 5,
						"h": 59,
						"w": 363,
						"m": 710
					},
					{
						"n": 16,
						"h": 240,
						"w": 267
					},
					{
						"n": 15,
						"h": 221,
						"w": 208
					},
					{
						"n": 18,
						"h": 40,
						"w": 144
					},
					{
						"n": 17,
						"h": 284,
						"w": 321
					},
					{
						"n": 19,
						"h": 294,
						"w": 121
					},
					{
						"n": 20,
						"h": 152,
						"w": 125
					}
				],
				"ball": {
					"n": 0,
					"h": 276,
					"w": 320,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 49
		},
		{
			"num": 1683,
			"minute": 81,
			"messages": [
				{
					"owner": 2,
					"mes": "В.Сланина[34](Опава) пасует Т.Крамаржу[32](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 703
					},
					{
						"n": 2,
						"h": 338,
						"w": 576
					},
					{
						"n": 14,
						"h": 266,
						"w": 577
					},
					{
						"n": 13,
						"h": 176,
						"w": 560
					},
					{
						"n": 5,
						"h": 120,
						"w": 580
					},
					{
						"n": 6,
						"h": 394,
						"w": 556
					},
					{
						"n": 18,
						"h": 229,
						"w": 491
					},
					{
						"n": 15,
						"h": 182,
						"w": 469
					},
					{
						"n": 17,
						"h": 56,
						"w": 446
					},
					{
						"n": 20,
						"h": 301,
						"w": 413
					},
					{
						"n": 19,
						"h": 154,
						"w": 388
					}
				],
				"away": [
					{
						"n": 12,
						"h": 205,
						"w": 578
					},
					{
						"n": 13,
						"h": 408,
						"w": 309
					},
					{
						"n": 3,
						"h": 278,
						"w": 469
					},
					{
						"n": 14,
						"h": 175,
						"w": 410,
						"m": 730
					},
					{
						"n": 5,
						"h": 61,
						"w": 408
					},
					{
						"n": 16,
						"h": 240,
						"w": 312
					},
					{
						"n": 15,
						"h": 224,
						"w": 253
					},
					{
						"n": 18,
						"h": 39,
						"w": 189
					},
					{
						"n": 17,
						"h": 298,
						"w": 364
					},
					{
						"n": 19,
						"h": 291,
						"w": 166
					},
					{
						"n": 20,
						"h": 164,
						"w": 168
					}
				],
				"ball": {
					"n": 0,
					"h": 245,
					"w": 142,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 45
		},
		{
			"num": 1684,
			"minute": 81,
			"messages": [
				{
					"owner": 2,
					"mes": "Пас вперед..."
				},
				{
					"owner": 2,
					"mes": "Нир Мансур[23](Опава) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 706
					},
					{
						"n": 2,
						"h": 330,
						"w": 567
					},
					{
						"n": 14,
						"h": 274,
						"w": 572
					},
					{
						"n": 13,
						"h": 191,
						"w": 546
					},
					{
						"n": 5,
						"h": 120,
						"w": 571
					},
					{
						"n": 6,
						"h": 385,
						"w": 548
					},
					{
						"n": 18,
						"h": 265,
						"w": 481
					},
					{
						"n": 15,
						"h": 212,
						"w": 465
					},
					{
						"n": 17,
						"h": 56,
						"w": 409
					},
					{
						"n": 20,
						"h": 284,
						"w": 394
					},
					{
						"n": 19,
						"h": 144,
						"w": 378
					}
				],
				"away": [
					{
						"n": 12,
						"h": 208,
						"w": 581
					},
					{
						"n": 13,
						"h": 411,
						"w": 328
					},
					{
						"n": 3,
						"h": 260,
						"w": 480
					},
					{
						"n": 14,
						"h": 174,
						"w": 428
					},
					{
						"n": 5,
						"h": 72,
						"w": 432
					},
					{
						"n": 16,
						"h": 228,
						"w": 310
					},
					{
						"n": 15,
						"h": 228,
						"w": 247
					},
					{
						"n": 18,
						"h": 50,
						"w": 200
					},
					{
						"n": 17,
						"h": 300,
						"w": 358
					},
					{
						"n": 19,
						"h": 273,
						"w": 175
					},
					{
						"n": 20,
						"h": 156,
						"w": 174
					}
				],
				"ball": {
					"n": 0,
					"h": 190,
					"w": 240,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 37
		},
		{
			"num": 1685,
			"minute": 81,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 709
					},
					{
						"n": 2,
						"h": 330,
						"w": 553
					},
					{
						"n": 14,
						"h": 257,
						"w": 555
					},
					{
						"n": 13,
						"h": 186,
						"w": 577
					},
					{
						"n": 5,
						"h": 120,
						"w": 564
					},
					{
						"n": 6,
						"h": 394,
						"w": 535
					},
					{
						"n": 18,
						"h": 275,
						"w": 477
					},
					{
						"n": 15,
						"h": 208,
						"w": 465
					},
					{
						"n": 17,
						"h": 56,
						"w": 417
					},
					{
						"n": 20,
						"h": 317,
						"w": 375
					},
					{
						"n": 19,
						"h": 163,
						"w": 343
					}
				],
				"away": [
					{
						"n": 12,
						"h": 225,
						"w": 616
					},
					{
						"n": 13,
						"h": 404,
						"w": 338
					},
					{
						"n": 3,
						"h": 261,
						"w": 445
					},
					{
						"n": 14,
						"h": 177,
						"w": 468
					},
					{
						"n": 5,
						"h": 61,
						"w": 471
					},
					{
						"n": 16,
						"h": 222,
						"w": 338
					},
					{
						"n": 15,
						"h": 236,
						"w": 256
					},
					{
						"n": 18,
						"h": 35,
						"w": 200
					},
					{
						"n": 17,
						"h": 269,
						"w": 382
					},
					{
						"n": 19,
						"h": 281,
						"w": 186
					},
					{
						"n": 20,
						"h": 175,
						"w": 185
					}
				],
				"ball": {
					"n": 0,
					"h": 189,
					"w": 275,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1686,
			"minute": 81,
			"messages": [
				{
					"owner": 2,
					"mes": "Пас Т.Прохазке[25](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 704
					},
					{
						"n": 2,
						"h": 330,
						"w": 558
					},
					{
						"n": 14,
						"h": 260,
						"w": 559
					},
					{
						"n": 13,
						"h": 163,
						"w": 548
					},
					{
						"n": 5,
						"h": 120,
						"w": 563
					},
					{
						"n": 6,
						"h": 394,
						"w": 535
					},
					{
						"n": 18,
						"h": 251,
						"w": 475
					},
					{
						"n": 15,
						"h": 201,
						"w": 470
					},
					{
						"n": 17,
						"h": 56,
						"w": 397
					},
					{
						"n": 20,
						"h": 273,
						"w": 404
					},
					{
						"n": 19,
						"h": 165,
						"w": 396
					}
				],
				"away": [
					{
						"n": 12,
						"h": 215,
						"w": 611
					},
					{
						"n": 13,
						"h": 410,
						"w": 338
					},
					{
						"n": 3,
						"h": 263,
						"w": 455
					},
					{
						"n": 14,
						"h": 165,
						"w": 486
					},
					{
						"n": 5,
						"h": 51,
						"w": 420
					},
					{
						"n": 16,
						"h": 179,
						"w": 334
					},
					{
						"n": 15,
						"h": 197,
						"w": 253
					},
					{
						"n": 18,
						"h": 42,
						"w": 200
					},
					{
						"n": 17,
						"h": 219,
						"w": 400
					},
					{
						"n": 19,
						"h": 297,
						"w": 186
					},
					{
						"n": 20,
						"h": 177,
						"w": 171
					}
				],
				"ball": {
					"n": 0,
					"h": 399,
					"w": 300,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 53
		},
		{
			"num": 1687,
			"minute": 81,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 704
					},
					{
						"n": 2,
						"h": 370,
						"w": 554
					},
					{
						"n": 14,
						"h": 275,
						"w": 570
					},
					{
						"n": 13,
						"h": 179,
						"w": 585
					},
					{
						"n": 5,
						"h": 120,
						"w": 562
					},
					{
						"n": 6,
						"h": 406,
						"w": 497
					},
					{
						"n": 18,
						"h": 289,
						"w": 486
					},
					{
						"n": 15,
						"h": 241,
						"w": 470
					},
					{
						"n": 17,
						"h": 56,
						"w": 437
					},
					{
						"n": 20,
						"h": 284,
						"w": 405
					},
					{
						"n": 19,
						"h": 182,
						"w": 360
					}
				],
				"away": [
					{
						"n": 12,
						"h": 215,
						"w": 618
					},
					{
						"n": 13,
						"h": 400,
						"w": 314
					},
					{
						"n": 3,
						"h": 271,
						"w": 494
					},
					{
						"n": 14,
						"h": 175,
						"w": 496
					},
					{
						"n": 5,
						"h": 54,
						"w": 383
					},
					{
						"n": 16,
						"h": 216,
						"w": 334
					},
					{
						"n": 15,
						"h": 211,
						"w": 258
					},
					{
						"n": 18,
						"h": 46,
						"w": 177
					},
					{
						"n": 17,
						"h": 259,
						"w": 399
					},
					{
						"n": 19,
						"h": 285,
						"w": 188
					},
					{
						"n": 20,
						"h": 161,
						"w": 169
					}
				],
				"ball": {
					"n": 0,
					"h": 396,
					"w": 337,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1688,
			"minute": 81,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 708
					},
					{
						"n": 2,
						"h": 386,
						"w": 577
					},
					{
						"n": 14,
						"h": 271,
						"w": 609
					},
					{
						"n": 13,
						"h": 177,
						"w": 611
					},
					{
						"n": 5,
						"h": 120,
						"w": 596
					},
					{
						"n": 6,
						"h": 403,
						"w": 505
					},
					{
						"n": 18,
						"h": 259,
						"w": 511
					},
					{
						"n": 15,
						"h": 211,
						"w": 484
					},
					{
						"n": 17,
						"h": 56,
						"w": 477
					},
					{
						"n": 20,
						"h": 287,
						"w": 423
					},
					{
						"n": 19,
						"h": 207,
						"w": 378
					}
				],
				"away": [
					{
						"n": 12,
						"h": 228,
						"w": 602
					},
					{
						"n": 13,
						"h": 404,
						"w": 275
					},
					{
						"n": 3,
						"h": 286,
						"w": 457
					},
					{
						"n": 14,
						"h": 177,
						"w": 456
					},
					{
						"n": 5,
						"h": 54,
						"w": 346
					},
					{
						"n": 16,
						"h": 188,
						"w": 306
					},
					{
						"n": 15,
						"h": 199,
						"w": 228
					},
					{
						"n": 18,
						"h": 56,
						"w": 155
					},
					{
						"n": 17,
						"h": 243,
						"w": 362
					},
					{
						"n": 19,
						"h": 292,
						"w": 149
					},
					{
						"n": 20,
						"h": 166,
						"w": 134
					}
				],
				"ball": {
					"n": 0,
					"h": 396,
					"w": 374,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1689,
			"minute": 82,
			"possession": 42,
			"messages": [
				{
					"owner": 2,
					"mes": "Длинная передача на Н.Томпсона[38](Опава)..."
				},
				{
					"owner": 2,
					"mes": "Неточный пас..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 239,
						"w": 714,
						"m": 690
					},
					{
						"n": 2,
						"h": 445,
						"w": 632
					},
					{
						"n": 14,
						"h": 288,
						"w": 668
					},
					{
						"n": 13,
						"h": 200,
						"w": 661
					},
					{
						"n": 5,
						"h": 120,
						"w": 665,
						"f": 77
					},
					{
						"n": 6,
						"h": 390,
						"w": 567
					},
					{
						"n": 18,
						"h": 257,
						"w": 599
					},
					{
						"n": 15,
						"h": 239,
						"w": 568,
						"f": 92
					},
					{
						"n": 17,
						"h": 56,
						"w": 566
					},
					{
						"n": 20,
						"h": 280,
						"w": 385
					},
					{
						"n": 19,
						"h": 163,
						"w": 437
					}
				],
				"away": [
					{
						"n": 12,
						"h": 226,
						"w": 596
					},
					{
						"n": 13,
						"h": 407,
						"w": 186
					},
					{
						"n": 3,
						"h": 274,
						"w": 428,
						"f": 81
					},
					{
						"n": 14,
						"h": 171,
						"w": 419,
						"f": 86
					},
					{
						"n": 5,
						"h": 56,
						"w": 356,
						"f": 76,
						"m": 700
					},
					{
						"n": 16,
						"h": 202,
						"w": 218
					},
					{
						"n": 15,
						"h": 207,
						"w": 139,
						"f": 95
					},
					{
						"n": 18,
						"h": 5,
						"w": 88
					},
					{
						"n": 17,
						"h": 287,
						"w": 303
					},
					{
						"n": 19,
						"h": 284,
						"w": 70
					},
					{
						"n": 20,
						"h": 158,
						"w": 70
					}
				],
				"ball": {
					"n": 0,
					"h": 470,
					"w": 632,
					"z": 1,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 89
		},
		{
			"num": 1690,
			"minute": 82,
			"messages": [
				{
					"owner": 1,
					"mes": "Мяч из аута будет вводить в игру Т.Эверс[02](Галвэй Юнайтед)..."
				},
				{
					"owner": 1,
					"mes": "Т.Эверс[02](Галвэй Юнайтед) вбрасывает мяч из аута..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 231,
						"w": 680
					},
					{
						"n": 2,
						"h": 450,
						"w": 632
					},
					{
						"n": 14,
						"h": 339,
						"w": 663
					},
					{
						"n": 13,
						"h": 164,
						"w": 661
					},
					{
						"n": 5,
						"h": 64,
						"w": 652
					},
					{
						"n": 6,
						"h": 412,
						"w": 589
					},
					{
						"n": 18,
						"h": 318,
						"w": 576
					},
					{
						"n": 15,
						"h": 174,
						"w": 556
					},
					{
						"n": 17,
						"h": 69,
						"w": 548
					},
					{
						"n": 20,
						"h": 334,
						"w": 423
					},
					{
						"n": 19,
						"h": 168,
						"w": 434
					}
				],
				"away": [
					{
						"n": 12,
						"h": 205,
						"w": 649
					},
					{
						"n": 13,
						"h": 411,
						"w": 252
					},
					{
						"n": 3,
						"h": 234,
						"w": 412
					},
					{
						"n": 14,
						"h": 143,
						"w": 427
					},
					{
						"n": 5,
						"h": 99,
						"w": 406
					},
					{
						"n": 16,
						"h": 215,
						"w": 238
					},
					{
						"n": 15,
						"h": 216,
						"w": 171
					},
					{
						"n": 18,
						"h": 20,
						"w": 153
					},
					{
						"n": 17,
						"h": 332,
						"w": 255
					},
					{
						"n": 19,
						"h": 282,
						"w": 82
					},
					{
						"n": 20,
						"h": 169,
						"w": 84
					}
				],
				"ball": {
					"n": 0,
					"h": 450,
					"w": 632,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 53
		},
		{
			"num": 1691,
			"minute": 82,
			"messages": [
				{
					"owner": 1,
					"mes": "Том Смит[14](Галвэй Юнайтед) технично принимает мяч..."
				}
			],
			"A": {
				"team": 1
			},
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 705
					},
					{
						"n": 2,
						"h": 450,
						"w": 632
					},
					{
						"n": 14,
						"h": 339,
						"w": 663
					},
					{
						"n": 13,
						"h": 167,
						"w": 623
					},
					{
						"n": 5,
						"h": 63,
						"w": 614
					},
					{
						"n": 6,
						"h": 413,
						"w": 551
					},
					{
						"n": 18,
						"h": 310,
						"w": 539
					},
					{
						"n": 15,
						"h": 170,
						"w": 518
					},
					{
						"n": 17,
						"h": 67,
						"w": 510
					},
					{
						"n": 20,
						"h": 327,
						"w": 386
					},
					{
						"n": 19,
						"h": 163,
						"w": 397
					}
				],
				"away": [
					{
						"n": 12,
						"h": 205,
						"w": 646
					},
					{
						"n": 13,
						"h": 412,
						"w": 270
					},
					{
						"n": 3,
						"h": 243,
						"w": 449
					},
					{
						"n": 14,
						"h": 158,
						"w": 462
					},
					{
						"n": 5,
						"h": 103,
						"w": 444
					},
					{
						"n": 16,
						"h": 230,
						"w": 273
					},
					{
						"n": 15,
						"h": 219,
						"w": 209
					},
					{
						"n": 18,
						"h": 20,
						"w": 191
					},
					{
						"n": 17,
						"h": 355,
						"w": 284
					},
					{
						"n": 19,
						"h": 282,
						"w": 120
					},
					{
						"n": 20,
						"h": 135,
						"w": 68
					}
				],
				"ball": {
					"n": 0,
					"h": 339,
					"w": 663,
					"z": 1,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 38
		},
		{
			"num": 1692,
			"minute": 82,
			"messages": [
				{
					"owner": 1,
					"mes": "Том Смит[14](Галвэй Юнайтед) пытается найти Р.Уотсона[18](Галвэй Юнайтед) с помощью обводящего паса..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 709
					},
					{
						"n": 2,
						"h": 427,
						"w": 605
					},
					{
						"n": 14,
						"h": 332,
						"w": 656
					},
					{
						"n": 13,
						"h": 167,
						"w": 608
					},
					{
						"n": 5,
						"h": 68,
						"w": 580
					},
					{
						"n": 6,
						"h": 411,
						"w": 516
					},
					{
						"n": 18,
						"h": 338,
						"w": 560
					},
					{
						"n": 15,
						"h": 164,
						"w": 484
					},
					{
						"n": 17,
						"h": 62,
						"w": 475
					},
					{
						"n": 20,
						"h": 322,
						"w": 351
					},
					{
						"n": 19,
						"h": 158,
						"w": 362
					}
				],
				"away": [
					{
						"n": 12,
						"h": 205,
						"w": 647
					},
					{
						"n": 13,
						"h": 412,
						"w": 285
					},
					{
						"n": 3,
						"h": 256,
						"w": 482
					},
					{
						"n": 14,
						"h": 171,
						"w": 494
					},
					{
						"n": 5,
						"h": 108,
						"w": 479
					},
					{
						"n": 16,
						"h": 245,
						"w": 305
					},
					{
						"n": 15,
						"h": 220,
						"w": 244
					},
					{
						"n": 18,
						"h": 25,
						"w": 225
					},
					{
						"n": 17,
						"h": 382,
						"w": 307
					},
					{
						"n": 19,
						"h": 288,
						"w": 154
					},
					{
						"n": 20,
						"h": 136,
						"w": 103
					}
				],
				"ball": {
					"n": 0,
					"h": 338,
					"w": 560,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 35
		},
		{
			"num": 1693,
			"minute": 82,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 708
					},
					{
						"n": 2,
						"h": 402,
						"w": 574
					},
					{
						"n": 14,
						"h": 292,
						"w": 626
					},
					{
						"n": 13,
						"h": 176,
						"w": 617
					},
					{
						"n": 5,
						"h": 71,
						"w": 560
					},
					{
						"n": 6,
						"h": 402,
						"w": 477
					},
					{
						"n": 18,
						"h": 320,
						"w": 530
					},
					{
						"n": 15,
						"h": 157,
						"w": 444
					},
					{
						"n": 17,
						"h": 42,
						"w": 441
					},
					{
						"n": 20,
						"h": 310,
						"w": 313
					},
					{
						"n": 19,
						"h": 160,
						"w": 322
					}
				],
				"away": [
					{
						"n": 12,
						"h": 215,
						"w": 648
					},
					{
						"n": 13,
						"h": 413,
						"w": 305
					},
					{
						"n": 3,
						"h": 278,
						"w": 492
					},
					{
						"n": 14,
						"h": 166,
						"w": 512
					},
					{
						"n": 5,
						"h": 110,
						"w": 494
					},
					{
						"n": 16,
						"h": 237,
						"w": 344
					},
					{
						"n": 15,
						"h": 222,
						"w": 284
					},
					{
						"n": 18,
						"h": 24,
						"w": 265
					},
					{
						"n": 17,
						"h": 396,
						"w": 345
					},
					{
						"n": 19,
						"h": 293,
						"w": 194
					},
					{
						"n": 20,
						"h": 135,
						"w": 143
					}
				],
				"ball": {
					"n": 0,
					"h": 320,
					"w": 530,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1694,
			"minute": 82,
			"messages": [
				{
					"owner": 1,
					"mes": "Райан Уотсон[18](Галвэй Юнайтед) отправляет мяч вперед... Т.Дэвлин[20](Галвэй Юнайтед) готов принять передачу..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 707
					},
					{
						"n": 2,
						"h": 394,
						"w": 528
					},
					{
						"n": 14,
						"h": 285,
						"w": 580
					},
					{
						"n": 13,
						"h": 170,
						"w": 570
					},
					{
						"n": 5,
						"h": 76,
						"w": 513
					},
					{
						"n": 6,
						"h": 396,
						"w": 430
					},
					{
						"n": 18,
						"h": 319,
						"w": 520
					},
					{
						"n": 15,
						"h": 151,
						"w": 398
					},
					{
						"n": 17,
						"h": 42,
						"w": 394
					},
					{
						"n": 20,
						"h": 326,
						"w": 342
					},
					{
						"n": 19,
						"h": 159,
						"w": 275
					}
				],
				"away": [
					{
						"n": 12,
						"h": 205,
						"w": 646
					},
					{
						"n": 13,
						"h": 407,
						"w": 351
					},
					{
						"n": 3,
						"h": 289,
						"w": 537
					},
					{
						"n": 14,
						"h": 210,
						"w": 530
					},
					{
						"n": 5,
						"h": 129,
						"w": 511
					},
					{
						"n": 16,
						"h": 231,
						"w": 391
					},
					{
						"n": 15,
						"h": 227,
						"w": 331
					},
					{
						"n": 18,
						"h": 22,
						"w": 312
					},
					{
						"n": 17,
						"h": 407,
						"w": 391
					},
					{
						"n": 19,
						"h": 295,
						"w": 241
					},
					{
						"n": 20,
						"h": 133,
						"w": 190
					}
				],
				"ball": {
					"n": 0,
					"h": 326,
					"w": 342,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 47
		},
		{
			"num": 1695,
			"minute": 82,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 709
					},
					{
						"n": 2,
						"h": 383,
						"w": 489
					},
					{
						"n": 14,
						"h": 285,
						"w": 540
					},
					{
						"n": 13,
						"h": 167,
						"w": 530
					},
					{
						"n": 5,
						"h": 67,
						"w": 474
					},
					{
						"n": 6,
						"h": 394,
						"w": 390
					},
					{
						"n": 18,
						"h": 296,
						"w": 487
					},
					{
						"n": 15,
						"h": 152,
						"w": 358
					},
					{
						"n": 17,
						"h": 53,
						"w": 356
					},
					{
						"n": 20,
						"h": 321,
						"w": 307
					},
					{
						"n": 19,
						"h": 152,
						"w": 235
					}
				],
				"away": [
					{
						"n": 12,
						"h": 215,
						"w": 648
					},
					{
						"n": 13,
						"h": 399,
						"w": 390
					},
					{
						"n": 3,
						"h": 301,
						"w": 570
					},
					{
						"n": 14,
						"h": 215,
						"w": 570
					},
					{
						"n": 5,
						"h": 134,
						"w": 532
					},
					{
						"n": 16,
						"h": 194,
						"w": 405
					},
					{
						"n": 15,
						"h": 230,
						"w": 370
					},
					{
						"n": 18,
						"h": 43,
						"w": 346
					},
					{
						"n": 17,
						"h": 396,
						"w": 412
					},
					{
						"n": 19,
						"h": 294,
						"w": 281
					},
					{
						"n": 20,
						"h": 145,
						"w": 228
					}
				],
				"ball": {
					"n": 0,
					"h": 321,
					"w": 307,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1696,
			"minute": 82,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 704
					},
					{
						"n": 2,
						"h": 378,
						"w": 450
					},
					{
						"n": 14,
						"h": 285,
						"w": 500
					},
					{
						"n": 13,
						"h": 172,
						"w": 491
					},
					{
						"n": 5,
						"h": 65,
						"w": 434
					},
					{
						"n": 6,
						"h": 396,
						"w": 350
					},
					{
						"n": 18,
						"h": 294,
						"w": 447
					},
					{
						"n": 15,
						"h": 153,
						"w": 318
					},
					{
						"n": 17,
						"h": 55,
						"w": 316
					},
					{
						"n": 20,
						"h": 317,
						"w": 272
					},
					{
						"n": 19,
						"h": 158,
						"w": 196
					}
				],
				"away": [
					{
						"n": 12,
						"h": 215,
						"w": 650
					},
					{
						"n": 13,
						"h": 400,
						"w": 410
					},
					{
						"n": 3,
						"h": 295,
						"w": 585
					},
					{
						"n": 14,
						"h": 223,
						"w": 609
					},
					{
						"n": 5,
						"h": 137,
						"w": 492
					},
					{
						"n": 16,
						"h": 169,
						"w": 437
					},
					{
						"n": 15,
						"h": 223,
						"w": 410
					},
					{
						"n": 18,
						"h": 51,
						"w": 385
					},
					{
						"n": 17,
						"h": 395,
						"w": 440
					},
					{
						"n": 19,
						"h": 290,
						"w": 321
					},
					{
						"n": 20,
						"h": 152,
						"w": 267
					}
				],
				"ball": {
					"n": 0,
					"h": 317,
					"w": 272,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1697,
			"minute": 82,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 705
					},
					{
						"n": 2,
						"h": 382,
						"w": 410
					},
					{
						"n": 14,
						"h": 279,
						"w": 460
					},
					{
						"n": 13,
						"h": 175,
						"w": 451
					},
					{
						"n": 5,
						"h": 71,
						"w": 394
					},
					{
						"n": 6,
						"h": 405,
						"w": 311
					},
					{
						"n": 18,
						"h": 306,
						"w": 409
					},
					{
						"n": 15,
						"h": 148,
						"w": 278
					},
					{
						"n": 17,
						"h": 49,
						"w": 276
					},
					{
						"n": 20,
						"h": 303,
						"w": 237
					},
					{
						"n": 19,
						"h": 147,
						"w": 157
					}
				],
				"away": [
					{
						"n": 12,
						"h": 215,
						"w": 641
					},
					{
						"n": 13,
						"h": 400,
						"w": 430
					},
					{
						"n": 3,
						"h": 302,
						"w": 609
					},
					{
						"n": 14,
						"h": 218,
						"w": 598
					},
					{
						"n": 5,
						"h": 152,
						"w": 503
					},
					{
						"n": 16,
						"h": 189,
						"w": 472
					},
					{
						"n": 15,
						"h": 219,
						"w": 450
					},
					{
						"n": 18,
						"h": 47,
						"w": 425
					},
					{
						"n": 17,
						"h": 401,
						"w": 480
					},
					{
						"n": 19,
						"h": 290,
						"w": 361
					},
					{
						"n": 20,
						"h": 147,
						"w": 307
					}
				],
				"ball": {
					"n": 0,
					"h": 303,
					"w": 237,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1698,
			"minute": 82,
			"messages": [
				{
					"owner": 1,
					"mes": "Том Дэвлин[20](Галвэй Юнайтед) отправляет мяч направо..."
				},
				{
					"owner": 1,
					"mes": "Вацлав Сланина[34](Опава) делает важный перехват..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 705
					},
					{
						"n": 2,
						"h": 382,
						"w": 382
					},
					{
						"n": 14,
						"h": 272,
						"w": 418
					},
					{
						"n": 13,
						"h": 165,
						"w": 419
					},
					{
						"n": 5,
						"h": 73,
						"w": 375
					},
					{
						"n": 6,
						"h": 407,
						"w": 268
					},
					{
						"n": 18,
						"h": 281,
						"w": 373
					},
					{
						"n": 15,
						"h": 160,
						"w": 237
					},
					{
						"n": 17,
						"h": 52,
						"w": 233
					},
					{
						"n": 20,
						"h": 299,
						"w": 225,
						"m": 580
					},
					{
						"n": 19,
						"h": 185,
						"w": 156
					}
				],
				"away": [
					{
						"n": 12,
						"h": 224,
						"w": 683
					},
					{
						"n": 13,
						"h": 400,
						"w": 453
					},
					{
						"n": 3,
						"h": 260,
						"w": 618
					},
					{
						"n": 14,
						"h": 245,
						"w": 565
					},
					{
						"n": 5,
						"h": 126,
						"w": 537
					},
					{
						"n": 16,
						"h": 165,
						"w": 507
					},
					{
						"n": 15,
						"h": 226,
						"w": 486
					},
					{
						"n": 18,
						"h": 45,
						"w": 468
					},
					{
						"n": 17,
						"h": 398,
						"w": 523
					},
					{
						"n": 19,
						"h": 284,
						"w": 403
					},
					{
						"n": 20,
						"h": 162,
						"w": 347
					}
				],
				"ball": {
					"n": 0,
					"h": 205,
					"w": 155,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 43
		},
		{
			"num": 1699,
			"minute": 82,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 710
					},
					{
						"n": 2,
						"h": 351,
						"w": 407
					},
					{
						"n": 14,
						"h": 293,
						"w": 432
					},
					{
						"n": 13,
						"h": 177,
						"w": 438
					},
					{
						"n": 5,
						"h": 101,
						"w": 403
					},
					{
						"n": 6,
						"h": 401,
						"w": 308
					},
					{
						"n": 18,
						"h": 310,
						"w": 362
					},
					{
						"n": 15,
						"h": 175,
						"w": 274
					},
					{
						"n": 17,
						"h": 40,
						"w": 271
					},
					{
						"n": 20,
						"h": 333,
						"w": 202
					},
					{
						"n": 19,
						"h": 213,
						"w": 184
					}
				],
				"away": [
					{
						"n": 12,
						"h": 222,
						"w": 707
					},
					{
						"n": 13,
						"h": 406,
						"w": 448
					},
					{
						"n": 3,
						"h": 276,
						"w": 581
					},
					{
						"n": 14,
						"h": 220,
						"w": 540,
						"m": 740
					},
					{
						"n": 5,
						"h": 91,
						"w": 555
					},
					{
						"n": 16,
						"h": 174,
						"w": 468
					},
					{
						"n": 15,
						"h": 231,
						"w": 446
					},
					{
						"n": 18,
						"h": 39,
						"w": 428
					},
					{
						"n": 17,
						"h": 401,
						"w": 483
					},
					{
						"n": 19,
						"h": 292,
						"w": 364
					},
					{
						"n": 20,
						"h": 141,
						"w": 337
					}
				],
				"ball": {
					"n": 0,
					"h": 230,
					"w": 180,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1700,
			"minute": 82,
			"messages": [
				{
					"owner": 2,
					"mes": "Передача М.Владаржу[36](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 702
					},
					{
						"n": 2,
						"h": 338,
						"w": 439
					},
					{
						"n": 14,
						"h": 271,
						"w": 456
					},
					{
						"n": 13,
						"h": 186,
						"w": 440
					},
					{
						"n": 5,
						"h": 114,
						"w": 435
					},
					{
						"n": 6,
						"h": 394,
						"w": 341
					},
					{
						"n": 18,
						"h": 279,
						"w": 375
					},
					{
						"n": 15,
						"h": 208,
						"w": 268
					},
					{
						"n": 17,
						"h": 38,
						"w": 305
					},
					{
						"n": 20,
						"h": 299,
						"w": 199
					},
					{
						"n": 19,
						"h": 201,
						"w": 215
					}
				],
				"away": [
					{
						"n": 12,
						"h": 226,
						"w": 705
					},
					{
						"n": 13,
						"h": 404,
						"w": 414
					},
					{
						"n": 3,
						"h": 274,
						"w": 614
					},
					{
						"n": 14,
						"h": 213,
						"w": 547
					},
					{
						"n": 5,
						"h": 66,
						"w": 578
					},
					{
						"n": 16,
						"h": 188,
						"w": 479
					},
					{
						"n": 15,
						"h": 232,
						"w": 412
					},
					{
						"n": 18,
						"h": 40,
						"w": 394
					},
					{
						"n": 17,
						"h": 402,
						"w": 449
					},
					{
						"n": 19,
						"h": 297,
						"w": 331
					},
					{
						"n": 20,
						"h": 146,
						"w": 303
					}
				],
				"ball": {
					"n": 0,
					"h": 262,
					"w": 241,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 34
		},
		{
			"num": 1701,
			"minute": 82,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 707
					},
					{
						"n": 2,
						"h": 330,
						"w": 447
					},
					{
						"n": 14,
						"h": 288,
						"w": 464
					},
					{
						"n": 13,
						"h": 187,
						"w": 461
					},
					{
						"n": 5,
						"h": 120,
						"w": 454
					},
					{
						"n": 6,
						"h": 394,
						"w": 381
					},
					{
						"n": 18,
						"h": 257,
						"w": 367
					},
					{
						"n": 15,
						"h": 246,
						"w": 281
					},
					{
						"n": 17,
						"h": 43,
						"w": 345
					},
					{
						"n": 20,
						"h": 290,
						"w": 238
					},
					{
						"n": 19,
						"h": 181,
						"w": 250
					}
				],
				"away": [
					{
						"n": 12,
						"h": 226,
						"w": 707
					},
					{
						"n": 13,
						"h": 411,
						"w": 453
					},
					{
						"n": 3,
						"h": 274,
						"w": 617
					},
					{
						"n": 14,
						"h": 193,
						"w": 582
					},
					{
						"n": 5,
						"h": 65,
						"w": 592
					},
					{
						"n": 16,
						"h": 174,
						"w": 447
					},
					{
						"n": 15,
						"h": 212,
						"w": 394
					},
					{
						"n": 18,
						"h": 49,
						"w": 355
					},
					{
						"n": 17,
						"h": 403,
						"w": 409
					},
					{
						"n": 19,
						"h": 281,
						"w": 296
					},
					{
						"n": 20,
						"h": 151,
						"w": 286
					}
				],
				"ball": {
					"n": 0,
					"h": 276,
					"w": 273,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1702,
			"minute": 82,
			"messages": [
				{
					"owner": 2,
					"mes": "Найдя свободного А.Карабеца[35](Опава), Михаэль Владарж[36](Опава) пасует вперед..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 709
					},
					{
						"n": 2,
						"h": 330,
						"w": 479
					},
					{
						"n": 14,
						"h": 282,
						"w": 482
					},
					{
						"n": 13,
						"h": 168,
						"w": 486
					},
					{
						"n": 5,
						"h": 120,
						"w": 486
					},
					{
						"n": 6,
						"h": 394,
						"w": 368
					},
					{
						"n": 18,
						"h": 257,
						"w": 335
					},
					{
						"n": 15,
						"h": 229,
						"w": 307
					},
					{
						"n": 17,
						"h": 56,
						"w": 357
					},
					{
						"n": 20,
						"h": 278,
						"w": 268
					},
					{
						"n": 19,
						"h": 172,
						"w": 281
					}
				],
				"away": [
					{
						"n": 12,
						"h": 222,
						"w": 707
					},
					{
						"n": 13,
						"h": 413,
						"w": 485
					},
					{
						"n": 3,
						"h": 295,
						"w": 607
					},
					{
						"n": 14,
						"h": 183,
						"w": 588
					},
					{
						"n": 5,
						"h": 40,
						"w": 607
					},
					{
						"n": 16,
						"h": 184,
						"w": 444
					},
					{
						"n": 15,
						"h": 193,
						"w": 385
					},
					{
						"n": 18,
						"h": 46,
						"w": 387
					},
					{
						"n": 17,
						"h": 411,
						"w": 378
					},
					{
						"n": 19,
						"h": 295,
						"w": 267
					},
					{
						"n": 20,
						"h": 154,
						"w": 256
					}
				],
				"ball": {
					"n": 0,
					"h": 257,
					"w": 335,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 32
		},
		{
			"num": 1703,
			"minute": 82,
			"messages": [
				{
					"owner": 2,
					"mes": "Адам Карабец[35](Опава) борется за позицию..."
				},
				{
					"owner": 2,
					"mes": "Райан Уотсон[18](Галвэй Юнайтед) выбивает мяч из-под ноги А.Карабеца[35](Опава)..."
				},
				{
					"owner": 2,
					"mes": "Михаэль Владарж[36](Опава) удачно выбирает позицию и подбирает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 703
					},
					{
						"n": 2,
						"h": 330,
						"w": 478
					},
					{
						"n": 14,
						"h": 281,
						"w": 486
					},
					{
						"n": 13,
						"h": 171,
						"w": 487
					},
					{
						"n": 5,
						"h": 120,
						"w": 479
					},
					{
						"n": 6,
						"h": 410,
						"w": 379
					},
					{
						"n": 18,
						"h": 257,
						"w": 338,
						"m": 660
					},
					{
						"n": 15,
						"h": 216,
						"w": 321
					},
					{
						"n": 17,
						"h": 56,
						"w": 376
					},
					{
						"n": 20,
						"h": 270,
						"w": 285
					},
					{
						"n": 19,
						"h": 166,
						"w": 299
					}
				],
				"away": [
					{
						"n": 12,
						"h": 228,
						"w": 707
					},
					{
						"n": 13,
						"h": 404,
						"w": 502
					},
					{
						"n": 3,
						"h": 286,
						"w": 597
					},
					{
						"n": 14,
						"h": 166,
						"w": 596
					},
					{
						"n": 5,
						"h": 45,
						"w": 597
					},
					{
						"n": 16,
						"h": 193,
						"w": 427,
						"m": 620
					},
					{
						"n": 15,
						"h": 193,
						"w": 385
					},
					{
						"n": 18,
						"h": 45,
						"w": 406
					},
					{
						"n": 17,
						"h": 413,
						"w": 359
					},
					{
						"n": 19,
						"h": 298,
						"w": 254
					},
					{
						"n": 20,
						"h": 155,
						"w": 254
					}
				],
				"ball": {
					"n": 0,
					"h": 257,
					"w": 293,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 19
		},
		{
			"num": 1704,
			"minute": 82,
			"messages": [
				{
					"owner": 2,
					"mes": "Михаэль Владарж[36](Опава) посылает мяч направо в направлении Н.Томпсона[38](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 706
					},
					{
						"n": 2,
						"h": 362,
						"w": 481
					},
					{
						"n": 14,
						"h": 272,
						"w": 497
					},
					{
						"n": 13,
						"h": 178,
						"w": 481
					},
					{
						"n": 5,
						"h": 120,
						"w": 494
					},
					{
						"n": 6,
						"h": 379,
						"w": 347
					},
					{
						"n": 18,
						"h": 276,
						"w": 378
					},
					{
						"n": 15,
						"h": 233,
						"w": 362
					},
					{
						"n": 17,
						"h": 56,
						"w": 399
					},
					{
						"n": 20,
						"h": 244,
						"w": 316
					},
					{
						"n": 19,
						"h": 173,
						"w": 330
					}
				],
				"away": [
					{
						"n": 12,
						"h": 222,
						"w": 706
					},
					{
						"n": 13,
						"h": 405,
						"w": 503
					},
					{
						"n": 3,
						"h": 291,
						"w": 587
					},
					{
						"n": 14,
						"h": 152,
						"w": 587
					},
					{
						"n": 5,
						"h": 50,
						"w": 587
					},
					{
						"n": 16,
						"h": 206,
						"w": 424
					},
					{
						"n": 15,
						"h": 208,
						"w": 356
					},
					{
						"n": 18,
						"h": 71,
						"w": 373
					},
					{
						"n": 17,
						"h": 411,
						"w": 336
					},
					{
						"n": 19,
						"h": 282,
						"w": 253
					},
					{
						"n": 20,
						"h": 161,
						"w": 253
					}
				],
				"ball": {
					"n": 0,
					"h": 379,
					"w": 347,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 44
		},
		{
			"num": 1705,
			"minute": 82,
			"messages": [
				{
					"owner": 2,
					"mes": "Ньялл Томпсон[38](Опава) контролирует мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 705
					},
					{
						"n": 2,
						"h": 371,
						"w": 485
					},
					{
						"n": 14,
						"h": 282,
						"w": 497
					},
					{
						"n": 13,
						"h": 181,
						"w": 491
					},
					{
						"n": 5,
						"h": 120,
						"w": 500
					},
					{
						"n": 6,
						"h": 379,
						"w": 350
					},
					{
						"n": 18,
						"h": 281,
						"w": 386
					},
					{
						"n": 15,
						"h": 232,
						"w": 372
					},
					{
						"n": 17,
						"h": 56,
						"w": 409
					},
					{
						"n": 20,
						"h": 235,
						"w": 320
					},
					{
						"n": 19,
						"h": 164,
						"w": 334
					}
				],
				"away": [
					{
						"n": 12,
						"h": 221,
						"w": 709
					},
					{
						"n": 13,
						"h": 413,
						"w": 498
					},
					{
						"n": 3,
						"h": 289,
						"w": 577
					},
					{
						"n": 14,
						"h": 150,
						"w": 577
					},
					{
						"n": 5,
						"h": 42,
						"w": 582
					},
					{
						"n": 16,
						"h": 215,
						"w": 420
					},
					{
						"n": 15,
						"h": 213,
						"w": 347
					},
					{
						"n": 18,
						"h": 80,
						"w": 377
					},
					{
						"n": 17,
						"h": 404,
						"w": 329
					},
					{
						"n": 19,
						"h": 282,
						"w": 243
					},
					{
						"n": 20,
						"h": 153,
						"w": 246
					}
				],
				"ball": {
					"n": 0,
					"h": 370,
					"w": 343,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 10
		},
		{
			"num": 1706,
			"minute": 82,
			"messages": [
				{
					"owner": 2,
					"mes": "Пасует вперед..."
				},
				{
					"owner": 2,
					"mes": "Тома Анри[40](Опава) получает передачу..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 708
					},
					{
						"n": 2,
						"h": 334,
						"w": 500
					},
					{
						"n": 14,
						"h": 276,
						"w": 508
					},
					{
						"n": 13,
						"h": 220,
						"w": 500
					},
					{
						"n": 5,
						"h": 120,
						"w": 504
					},
					{
						"n": 6,
						"h": 374,
						"w": 387
					},
					{
						"n": 18,
						"h": 246,
						"w": 406
					},
					{
						"n": 15,
						"h": 198,
						"w": 394
					},
					{
						"n": 17,
						"h": 56,
						"w": 446
					},
					{
						"n": 20,
						"h": 225,
						"w": 283
					},
					{
						"n": 19,
						"h": 168,
						"w": 309
					}
				],
				"away": [
					{
						"n": 12,
						"h": 228,
						"w": 690
					},
					{
						"n": 13,
						"h": 414,
						"w": 458
					},
					{
						"n": 3,
						"h": 275,
						"w": 566
					},
					{
						"n": 14,
						"h": 166,
						"w": 552
					},
					{
						"n": 5,
						"h": 76,
						"w": 565
					},
					{
						"n": 16,
						"h": 225,
						"w": 457
					},
					{
						"n": 15,
						"h": 218,
						"w": 323
					},
					{
						"n": 18,
						"h": 76,
						"w": 368,
						"m": 650
					},
					{
						"n": 17,
						"h": 408,
						"w": 289
					},
					{
						"n": 19,
						"h": 280,
						"w": 234
					},
					{
						"n": 20,
						"h": 135,
						"w": 269
					}
				],
				"ball": {
					"n": 0,
					"h": 315,
					"w": 451,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1707,
			"minute": 82,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 708
					},
					{
						"n": 2,
						"h": 330,
						"w": 540
					},
					{
						"n": 14,
						"h": 295,
						"w": 508
					},
					{
						"n": 13,
						"h": 246,
						"w": 518
					},
					{
						"n": 5,
						"h": 158,
						"w": 516
					},
					{
						"n": 6,
						"h": 382,
						"w": 427
					},
					{
						"n": 18,
						"h": 265,
						"w": 437
					},
					{
						"n": 15,
						"h": 208,
						"w": 433
					},
					{
						"n": 17,
						"h": 56,
						"w": 486
					},
					{
						"n": 20,
						"h": 229,
						"w": 323
					},
					{
						"n": 19,
						"h": 173,
						"w": 330
					}
				],
				"away": [
					{
						"n": 12,
						"h": 226,
						"w": 672
					},
					{
						"n": 13,
						"h": 417,
						"w": 418
					},
					{
						"n": 3,
						"h": 278,
						"w": 528
					},
					{
						"n": 14,
						"h": 175,
						"w": 531
					},
					{
						"n": 5,
						"h": 59,
						"w": 539
					},
					{
						"n": 16,
						"h": 221,
						"w": 417
					},
					{
						"n": 15,
						"h": 240,
						"w": 293
					},
					{
						"n": 18,
						"h": 68,
						"w": 328
					},
					{
						"n": 17,
						"h": 406,
						"w": 249
					},
					{
						"n": 19,
						"h": 272,
						"w": 205
					},
					{
						"n": 20,
						"h": 150,
						"w": 232
					}
				],
				"ball": {
					"n": 0,
					"h": 300,
					"w": 488,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1708,
			"minute": 83,
			"possession": 42,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 706,
						"f": 90
					},
					{
						"n": 2,
						"h": 330,
						"w": 573
					},
					{
						"n": 14,
						"h": 263,
						"w": 517
					},
					{
						"n": 13,
						"h": 240,
						"w": 554
					},
					{
						"n": 5,
						"h": 166,
						"w": 555
					},
					{
						"n": 6,
						"h": 388,
						"w": 466,
						"f": 75
					},
					{
						"n": 18,
						"h": 260,
						"w": 477
					},
					{
						"n": 15,
						"h": 215,
						"w": 471
					},
					{
						"n": 17,
						"h": 56,
						"w": 526,
						"f": 85
					},
					{
						"n": 20,
						"h": 233,
						"w": 362,
						"f": 83
					},
					{
						"n": 19,
						"h": 165,
						"w": 358,
						"f": 90
					}
				],
				"away": [
					{
						"n": 12,
						"h": 223,
						"w": 653,
						"f": 92
					},
					{
						"n": 13,
						"h": 406,
						"w": 379
					},
					{
						"n": 3,
						"h": 281,
						"w": 488
					},
					{
						"n": 14,
						"h": 167,
						"w": 491,
						"m": 750
					},
					{
						"n": 5,
						"h": 71,
						"w": 508
					},
					{
						"n": 16,
						"h": 217,
						"w": 378,
						"f": 92
					},
					{
						"n": 15,
						"h": 233,
						"w": 253
					},
					{
						"n": 18,
						"h": 62,
						"w": 289
					},
					{
						"n": 17,
						"h": 404,
						"w": 209,
						"f": 87
					},
					{
						"n": 19,
						"h": 292,
						"w": 172
					},
					{
						"n": 20,
						"h": 184,
						"w": 223
					}
				],
				"ball": {
					"n": 0,
					"h": 266,
					"w": 497,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1709,
			"minute": 83,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 706
					},
					{
						"n": 2,
						"h": 330,
						"w": 593
					},
					{
						"n": 14,
						"h": 231,
						"w": 526
					},
					{
						"n": 13,
						"h": 223,
						"w": 575
					},
					{
						"n": 5,
						"h": 136,
						"w": 581
					},
					{
						"n": 6,
						"h": 394,
						"w": 506
					},
					{
						"n": 18,
						"h": 267,
						"w": 501
					},
					{
						"n": 15,
						"h": 218,
						"w": 492
					},
					{
						"n": 17,
						"h": 62,
						"w": 566
					},
					{
						"n": 20,
						"h": 229,
						"w": 402
					},
					{
						"n": 19,
						"h": 168,
						"w": 384
					}
				],
				"away": [
					{
						"n": 12,
						"h": 220,
						"w": 632
					},
					{
						"n": 13,
						"h": 413,
						"w": 340
					},
					{
						"n": 3,
						"h": 284,
						"w": 448
					},
					{
						"n": 14,
						"h": 168,
						"w": 478
					},
					{
						"n": 5,
						"h": 62,
						"w": 469
					},
					{
						"n": 16,
						"h": 221,
						"w": 338
					},
					{
						"n": 15,
						"h": 233,
						"w": 213
					},
					{
						"n": 18,
						"h": 55,
						"w": 249
					},
					{
						"n": 17,
						"h": 401,
						"w": 170
					},
					{
						"n": 19,
						"h": 312,
						"w": 199
					},
					{
						"n": 20,
						"h": 218,
						"w": 214
					}
				],
				"ball": {
					"n": 0,
					"h": 232,
					"w": 506,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1710,
			"minute": 83,
			"messages": [
				{
					"owner": 2,
					"mes": "Игра накоротке..."
				},
				{
					"owner": 2,
					"mes": "Теперь с мячом Адам Карабец[35](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 705
					},
					{
						"n": 2,
						"h": 330,
						"w": 604
					},
					{
						"n": 14,
						"h": 226,
						"w": 530
					},
					{
						"n": 13,
						"h": 221,
						"w": 586
					},
					{
						"n": 5,
						"h": 130,
						"w": 591
					},
					{
						"n": 6,
						"h": 394,
						"w": 516
					},
					{
						"n": 18,
						"h": 272,
						"w": 506
					},
					{
						"n": 15,
						"h": 207,
						"w": 489
					},
					{
						"n": 17,
						"h": 58,
						"w": 576
					},
					{
						"n": 20,
						"h": 230,
						"w": 413
					},
					{
						"n": 19,
						"h": 163,
						"w": 381
					}
				],
				"away": [
					{
						"n": 12,
						"h": 221,
						"w": 627
					},
					{
						"n": 13,
						"h": 403,
						"w": 336
					},
					{
						"n": 3,
						"h": 283,
						"w": 459
					},
					{
						"n": 14,
						"h": 179,
						"w": 476
					},
					{
						"n": 5,
						"h": 65,
						"w": 464
					},
					{
						"n": 16,
						"h": 220,
						"w": 327
					},
					{
						"n": 15,
						"h": 241,
						"w": 198
					},
					{
						"n": 18,
						"h": 53,
						"w": 239
					},
					{
						"n": 17,
						"h": 393,
						"w": 178
					},
					{
						"n": 19,
						"h": 308,
						"w": 189
					},
					{
						"n": 20,
						"h": 218,
						"w": 214,
						"m": 650
					}
				],
				"ball": {
					"n": 0,
					"h": 209,
					"w": 522,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 11
		},
		{
			"num": 1711,
			"minute": 83,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 705
					},
					{
						"n": 2,
						"h": 330,
						"w": 595
					},
					{
						"n": 14,
						"h": 209,
						"w": 538
					},
					{
						"n": 13,
						"h": 213,
						"w": 603
					},
					{
						"n": 5,
						"h": 143,
						"w": 576
					},
					{
						"n": 6,
						"h": 394,
						"w": 535
					},
					{
						"n": 18,
						"h": 258,
						"w": 519
					},
					{
						"n": 15,
						"h": 188,
						"w": 493
					},
					{
						"n": 17,
						"h": 69,
						"w": 563
					},
					{
						"n": 20,
						"h": 239,
						"w": 401
					},
					{
						"n": 19,
						"h": 158,
						"w": 373
					}
				],
				"away": [
					{
						"n": 12,
						"h": 225,
						"w": 608
					},
					{
						"n": 13,
						"h": 401,
						"w": 333
					},
					{
						"n": 3,
						"h": 269,
						"w": 460
					},
					{
						"n": 14,
						"h": 171,
						"w": 459
					},
					{
						"n": 5,
						"h": 61,
						"w": 445
					},
					{
						"n": 16,
						"h": 211,
						"w": 339
					},
					{
						"n": 15,
						"h": 241,
						"w": 182
					},
					{
						"n": 18,
						"h": 49,
						"w": 220
					},
					{
						"n": 17,
						"h": 381,
						"w": 192
					},
					{
						"n": 19,
						"h": 300,
						"w": 172
					},
					{
						"n": 20,
						"h": 206,
						"w": 199
					}
				],
				"ball": {
					"n": 0,
					"h": 209,
					"w": 538,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 19
		},
		{
			"num": 1712,
			"minute": 83,
			"messages": [
				{
					"owner": 2,
					"mes": "Адам Карабец[35](Опава) сближается с Т.Смитом[14](Галвэй Юнайтед)..."
				},
				{
					"owner": 2,
					"mes": "Том Смит[14](Галвэй Юнайтед) отбирает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 705
					},
					{
						"n": 2,
						"h": 330,
						"w": 595
					},
					{
						"n": 14,
						"h": 200,
						"w": 543,
						"m": 640
					},
					{
						"n": 13,
						"h": 212,
						"w": 606
					},
					{
						"n": 5,
						"h": 149,
						"w": 569
					},
					{
						"n": 6,
						"h": 394,
						"w": 535
					},
					{
						"n": 18,
						"h": 251,
						"w": 526
					},
					{
						"n": 15,
						"h": 178,
						"w": 496
					},
					{
						"n": 17,
						"h": 69,
						"w": 563
					},
					{
						"n": 20,
						"h": 239,
						"w": 401
					},
					{
						"n": 19,
						"h": 158,
						"w": 373
					}
				],
				"away": [
					{
						"n": 12,
						"h": 225,
						"w": 606
					},
					{
						"n": 13,
						"h": 401,
						"w": 333
					},
					{
						"n": 3,
						"h": 269,
						"w": 460
					},
					{
						"n": 14,
						"h": 167,
						"w": 451
					},
					{
						"n": 5,
						"h": 59,
						"w": 438
					},
					{
						"n": 16,
						"h": 211,
						"w": 339
					},
					{
						"n": 15,
						"h": 241,
						"w": 172
					},
					{
						"n": 18,
						"h": 47,
						"w": 210
					},
					{
						"n": 17,
						"h": 374,
						"w": 200
					},
					{
						"n": 19,
						"h": 296,
						"w": 163
					},
					{
						"n": 20,
						"h": 200,
						"w": 192
					}
				],
				"ball": {
					"n": 0,
					"h": 200,
					"w": 543,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 10
		},
		{
			"num": 1713,
			"minute": 83,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 710
					},
					{
						"n": 2,
						"h": 352,
						"w": 561
					},
					{
						"n": 14,
						"h": 175,
						"w": 518
					},
					{
						"n": 13,
						"h": 195,
						"w": 570
					},
					{
						"n": 5,
						"h": 119,
						"w": 542
					},
					{
						"n": 6,
						"h": 393,
						"w": 495
					},
					{
						"n": 18,
						"h": 280,
						"w": 498
					},
					{
						"n": 15,
						"h": 171,
						"w": 456
					},
					{
						"n": 17,
						"h": 64,
						"w": 523
					},
					{
						"n": 20,
						"h": 252,
						"w": 364
					},
					{
						"n": 19,
						"h": 154,
						"w": 333
					}
				],
				"away": [
					{
						"n": 12,
						"h": 227,
						"w": 644
					},
					{
						"n": 13,
						"h": 406,
						"w": 373
					},
					{
						"n": 3,
						"h": 281,
						"w": 498
					},
					{
						"n": 14,
						"h": 196,
						"w": 479
					},
					{
						"n": 5,
						"h": 85,
						"w": 469
					},
					{
						"n": 16,
						"h": 220,
						"w": 378
					},
					{
						"n": 15,
						"h": 241,
						"w": 182
					},
					{
						"n": 18,
						"h": 45,
						"w": 250
					},
					{
						"n": 17,
						"h": 347,
						"w": 229
					},
					{
						"n": 19,
						"h": 283,
						"w": 200
					},
					{
						"n": 20,
						"h": 180,
						"w": 226
					}
				],
				"ball": {
					"n": 0,
					"h": 175,
					"w": 518,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1714,
			"minute": 83,
			"messages": [
				{
					"owner": 1,
					"mes": "Т.Смит[14](Галвэй Юнайтед) пасует Б.Регану[13](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 703
					},
					{
						"n": 2,
						"h": 361,
						"w": 543
					},
					{
						"n": 14,
						"h": 185,
						"w": 519
					},
					{
						"n": 13,
						"h": 185,
						"w": 556
					},
					{
						"n": 5,
						"h": 116,
						"w": 538
					},
					{
						"n": 6,
						"h": 395,
						"w": 475
					},
					{
						"n": 18,
						"h": 287,
						"w": 479
					},
					{
						"n": 15,
						"h": 166,
						"w": 437
					},
					{
						"n": 17,
						"h": 63,
						"w": 503
					},
					{
						"n": 20,
						"h": 260,
						"w": 345
					},
					{
						"n": 19,
						"h": 154,
						"w": 313
					}
				],
				"away": [
					{
						"n": 12,
						"h": 224,
						"w": 643
					},
					{
						"n": 13,
						"h": 410,
						"w": 392
					},
					{
						"n": 3,
						"h": 282,
						"w": 500
					},
					{
						"n": 14,
						"h": 203,
						"w": 487
					},
					{
						"n": 5,
						"h": 99,
						"w": 483
					},
					{
						"n": 16,
						"h": 223,
						"w": 397
					},
					{
						"n": 15,
						"h": 239,
						"w": 201
					},
					{
						"n": 18,
						"h": 46,
						"w": 270
					},
					{
						"n": 17,
						"h": 357,
						"w": 246
					},
					{
						"n": 19,
						"h": 286,
						"w": 220
					},
					{
						"n": 20,
						"h": 171,
						"w": 244
					}
				],
				"ball": {
					"n": 0,
					"h": 185,
					"w": 556,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 20
		},
		{
			"num": 1715,
			"minute": 83,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 703
					},
					{
						"n": 2,
						"h": 374,
						"w": 506
					},
					{
						"n": 14,
						"h": 224,
						"w": 529
					},
					{
						"n": 13,
						"h": 170,
						"w": 524
					},
					{
						"n": 5,
						"h": 99,
						"w": 520
					},
					{
						"n": 6,
						"h": 392,
						"w": 435
					},
					{
						"n": 18,
						"h": 294,
						"w": 440
					},
					{
						"n": 15,
						"h": 159,
						"w": 397
					},
					{
						"n": 17,
						"h": 61,
						"w": 463
					},
					{
						"n": 20,
						"h": 273,
						"w": 307
					},
					{
						"n": 19,
						"h": 156,
						"w": 273
					}
				],
				"away": [
					{
						"n": 12,
						"h": 235,
						"w": 649
					},
					{
						"n": 13,
						"h": 425,
						"w": 429
					},
					{
						"n": 3,
						"h": 276,
						"w": 494
					},
					{
						"n": 14,
						"h": 192,
						"w": 518
					},
					{
						"n": 5,
						"h": 110,
						"w": 498
					},
					{
						"n": 16,
						"h": 234,
						"w": 405
					},
					{
						"n": 15,
						"h": 234,
						"w": 241
					},
					{
						"n": 18,
						"h": 44,
						"w": 310
					},
					{
						"n": 17,
						"h": 376,
						"w": 281
					},
					{
						"n": 19,
						"h": 289,
						"w": 260
					},
					{
						"n": 20,
						"h": 155,
						"w": 281
					}
				],
				"ball": {
					"n": 0,
					"h": 170,
					"w": 524,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1716,
			"minute": 83,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 709
					},
					{
						"n": 2,
						"h": 373,
						"w": 466
					},
					{
						"n": 14,
						"h": 263,
						"w": 519
					},
					{
						"n": 13,
						"h": 178,
						"w": 490
					},
					{
						"n": 5,
						"h": 76,
						"w": 487
					},
					{
						"n": 6,
						"h": 400,
						"w": 396
					},
					{
						"n": 18,
						"h": 293,
						"w": 424
					},
					{
						"n": 15,
						"h": 153,
						"w": 358
					},
					{
						"n": 17,
						"h": 59,
						"w": 423
					},
					{
						"n": 20,
						"h": 283,
						"w": 269
					},
					{
						"n": 19,
						"h": 157,
						"w": 241
					}
				],
				"away": [
					{
						"n": 12,
						"h": 229,
						"w": 641
					},
					{
						"n": 13,
						"h": 425,
						"w": 469
					},
					{
						"n": 3,
						"h": 281,
						"w": 534
					},
					{
						"n": 14,
						"h": 187,
						"w": 539
					},
					{
						"n": 5,
						"h": 110,
						"w": 533
					},
					{
						"n": 16,
						"h": 228,
						"w": 445
					},
					{
						"n": 15,
						"h": 234,
						"w": 281
					},
					{
						"n": 18,
						"h": 49,
						"w": 350
					},
					{
						"n": 17,
						"h": 384,
						"w": 320
					},
					{
						"n": 19,
						"h": 286,
						"w": 300
					},
					{
						"n": 20,
						"h": 134,
						"w": 315
					}
				],
				"ball": {
					"n": 0,
					"h": 178,
					"w": 490,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1717,
			"minute": 83,
			"messages": [
				{
					"owner": 1,
					"mes": "Билли Реган[13](Галвэй Юнайтед) пасует направо на М.Раума[17](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 703
					},
					{
						"n": 2,
						"h": 373,
						"w": 432
					},
					{
						"n": 14,
						"h": 273,
						"w": 493
					},
					{
						"n": 13,
						"h": 173,
						"w": 482
					},
					{
						"n": 5,
						"h": 66,
						"w": 453
					},
					{
						"n": 6,
						"h": 400,
						"w": 361
					},
					{
						"n": 18,
						"h": 272,
						"w": 396
					},
					{
						"n": 15,
						"h": 141,
						"w": 325
					},
					{
						"n": 17,
						"h": 85,
						"w": 440
					},
					{
						"n": 20,
						"h": 294,
						"w": 235
					},
					{
						"n": 19,
						"h": 159,
						"w": 206
					}
				],
				"away": [
					{
						"n": 12,
						"h": 245,
						"w": 648
					},
					{
						"n": 13,
						"h": 408,
						"w": 500
					},
					{
						"n": 3,
						"h": 272,
						"w": 559
					},
					{
						"n": 14,
						"h": 168,
						"w": 546
					},
					{
						"n": 5,
						"h": 110,
						"w": 568
					},
					{
						"n": 16,
						"h": 255,
						"w": 467
					},
					{
						"n": 15,
						"h": 234,
						"w": 316
					},
					{
						"n": 18,
						"h": 50,
						"w": 385
					},
					{
						"n": 17,
						"h": 368,
						"w": 290
					},
					{
						"n": 19,
						"h": 288,
						"w": 335
					},
					{
						"n": 20,
						"h": 163,
						"w": 334
					}
				],
				"ball": {
					"n": 0,
					"h": 85,
					"w": 440,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 35
		},
		{
			"num": 1718,
			"minute": 83,
			"messages": [
				{
					"owner": 1,
					"mes": "Пас налево Т.Смиту[14](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 706
					},
					{
						"n": 2,
						"h": 379,
						"w": 407
					},
					{
						"n": 14,
						"h": 245,
						"w": 482
					},
					{
						"n": 13,
						"h": 184,
						"w": 475
					},
					{
						"n": 5,
						"h": 78,
						"w": 415
					},
					{
						"n": 6,
						"h": 398,
						"w": 306
					},
					{
						"n": 18,
						"h": 292,
						"w": 363
					},
					{
						"n": 15,
						"h": 147,
						"w": 270
					},
					{
						"n": 17,
						"h": 83,
						"w": 430,
						"m": 730
					},
					{
						"n": 20,
						"h": 315,
						"w": 190
					},
					{
						"n": 19,
						"h": 147,
						"w": 184
					}
				],
				"away": [
					{
						"n": 12,
						"h": 221,
						"w": 649
					},
					{
						"n": 13,
						"h": 420,
						"w": 550
					},
					{
						"n": 3,
						"h": 267,
						"w": 593
					},
					{
						"n": 14,
						"h": 176,
						"w": 585
					},
					{
						"n": 5,
						"h": 110,
						"w": 594
					},
					{
						"n": 16,
						"h": 238,
						"w": 520
					},
					{
						"n": 15,
						"h": 229,
						"w": 371
					},
					{
						"n": 18,
						"h": 52,
						"w": 440
					},
					{
						"n": 17,
						"h": 386,
						"w": 341
					},
					{
						"n": 19,
						"h": 284,
						"w": 389
					},
					{
						"n": 20,
						"h": 128,
						"w": 320
					}
				],
				"ball": {
					"n": 0,
					"h": 245,
					"w": 482,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 55
		},
		{
			"num": 1719,
			"minute": 83,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 706
					},
					{
						"n": 2,
						"h": 376,
						"w": 388
					},
					{
						"n": 14,
						"h": 257,
						"w": 449
					},
					{
						"n": 13,
						"h": 176,
						"w": 436
					},
					{
						"n": 5,
						"h": 62,
						"w": 392
					},
					{
						"n": 6,
						"h": 397,
						"w": 266
					},
					{
						"n": 18,
						"h": 292,
						"w": 357
					},
					{
						"n": 15,
						"h": 157,
						"w": 234
					},
					{
						"n": 17,
						"h": 75,
						"w": 391
					},
					{
						"n": 20,
						"h": 297,
						"w": 154
					},
					{
						"n": 19,
						"h": 172,
						"w": 153
					}
				],
				"away": [
					{
						"n": 12,
						"h": 223,
						"w": 644
					},
					{
						"n": 13,
						"h": 430,
						"w": 550
					},
					{
						"n": 3,
						"h": 265,
						"w": 598
					},
					{
						"n": 14,
						"h": 169,
						"w": 584
					},
					{
						"n": 5,
						"h": 110,
						"w": 590
					},
					{
						"n": 16,
						"h": 217,
						"w": 523
					},
					{
						"n": 15,
						"h": 225,
						"w": 411
					},
					{
						"n": 18,
						"h": 53,
						"w": 480
					},
					{
						"n": 17,
						"h": 375,
						"w": 365
					},
					{
						"n": 19,
						"h": 278,
						"w": 419
					},
					{
						"n": 20,
						"h": 165,
						"w": 304
					}
				],
				"ball": {
					"n": 0,
					"h": 257,
					"w": 449,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1720,
			"minute": 83,
			"messages": [
				{
					"owner": 1,
					"mes": "Том Смит[14](Галвэй Юнайтед) посылает мяч налево в направлении Т.Эверса[02](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 702
					},
					{
						"n": 2,
						"h": 352,
						"w": 403
					},
					{
						"n": 14,
						"h": 265,
						"w": 443,
						"m": 650
					},
					{
						"n": 13,
						"h": 179,
						"w": 432
					},
					{
						"n": 5,
						"h": 71,
						"w": 389
					},
					{
						"n": 6,
						"h": 396,
						"w": 231
					},
					{
						"n": 18,
						"h": 307,
						"w": 325
					},
					{
						"n": 15,
						"h": 191,
						"w": 228
					},
					{
						"n": 17,
						"h": 69,
						"w": 356
					},
					{
						"n": 20,
						"h": 281,
						"w": 138
					},
					{
						"n": 19,
						"h": 178,
						"w": 154
					}
				],
				"away": [
					{
						"n": 12,
						"h": 205,
						"w": 649
					},
					{
						"n": 13,
						"h": 433,
						"w": 551
					},
					{
						"n": 3,
						"h": 255,
						"w": 600
					},
					{
						"n": 14,
						"h": 184,
						"w": 591
					},
					{
						"n": 5,
						"h": 110,
						"w": 599
					},
					{
						"n": 16,
						"h": 252,
						"w": 517
					},
					{
						"n": 15,
						"h": 224,
						"w": 446
					},
					{
						"n": 18,
						"h": 53,
						"w": 515
					},
					{
						"n": 17,
						"h": 381,
						"w": 400
					},
					{
						"n": 19,
						"h": 281,
						"w": 407
					},
					{
						"n": 20,
						"h": 133,
						"w": 320
					}
				],
				"ball": {
					"n": 0,
					"h": 352,
					"w": 403,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 35
		},
		{
			"num": 1721,
			"minute": 83,
			"messages": [
				{
					"owner": 1,
					"mes": "Тимо Эверс[02](Галвэй Юнайтед) пасует на ход Р.Уотсону[18](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 703
					},
					{
						"n": 2,
						"h": 352,
						"w": 403
					},
					{
						"n": 14,
						"h": 283,
						"w": 431
					},
					{
						"n": 13,
						"h": 174,
						"w": 424
					},
					{
						"n": 5,
						"h": 77,
						"w": 379
					},
					{
						"n": 6,
						"h": 391,
						"w": 184
					},
					{
						"n": 18,
						"h": 277,
						"w": 285
					},
					{
						"n": 15,
						"h": 176,
						"w": 230
					},
					{
						"n": 17,
						"h": 64,
						"w": 310
					},
					{
						"n": 20,
						"h": 288,
						"w": 148
					},
					{
						"n": 19,
						"h": 153,
						"w": 136
					}
				],
				"away": [
					{
						"n": 12,
						"h": 215,
						"w": 646
					},
					{
						"n": 13,
						"h": 414,
						"w": 508
					},
					{
						"n": 3,
						"h": 285,
						"w": 606
					},
					{
						"n": 14,
						"h": 174,
						"w": 620
					},
					{
						"n": 5,
						"h": 110,
						"w": 605
					},
					{
						"n": 16,
						"h": 218,
						"w": 518
					},
					{
						"n": 15,
						"h": 184,
						"w": 453
					},
					{
						"n": 18,
						"h": 58,
						"w": 562
					},
					{
						"n": 17,
						"h": 395,
						"w": 444
					},
					{
						"n": 19,
						"h": 289,
						"w": 430
					},
					{
						"n": 20,
						"h": 143,
						"w": 366
					}
				],
				"ball": {
					"n": 0,
					"h": 277,
					"w": 285,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 47
		},
		{
			"num": 1722,
			"minute": 83,
			"messages": [
				{
					"owner": 1,
					"mes": "Справа открывается Кевин Келли[15](Галвэй Юнайтед)... Передача..."
				},
				{
					"owner": 1,
					"mes": "Кевин Келли[15](Галвэй Юнайтед) принимает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 710
					},
					{
						"n": 2,
						"h": 381,
						"w": 367
					},
					{
						"n": 14,
						"h": 281,
						"w": 426
					},
					{
						"n": 13,
						"h": 181,
						"w": 424
					},
					{
						"n": 5,
						"h": 73,
						"w": 367
					},
					{
						"n": 6,
						"h": 401,
						"w": 147
					},
					{
						"n": 18,
						"h": 279,
						"w": 275
					},
					{
						"n": 15,
						"h": 149,
						"w": 203
					},
					{
						"n": 17,
						"h": 55,
						"w": 261
					},
					{
						"n": 20,
						"h": 287,
						"w": 127
					},
					{
						"n": 19,
						"h": 157,
						"w": 117
					}
				],
				"away": [
					{
						"n": 12,
						"h": 225,
						"w": 695
					},
					{
						"n": 13,
						"h": 395,
						"w": 495
					},
					{
						"n": 3,
						"h": 274,
						"w": 624
					},
					{
						"n": 14,
						"h": 175,
						"w": 609
					},
					{
						"n": 5,
						"h": 110,
						"w": 628
					},
					{
						"n": 16,
						"h": 267,
						"w": 528
					},
					{
						"n": 15,
						"h": 218,
						"w": 489
					},
					{
						"n": 18,
						"h": 42,
						"w": 522
					},
					{
						"n": 17,
						"h": 413,
						"w": 469
					},
					{
						"n": 19,
						"h": 279,
						"w": 413
					},
					{
						"n": 20,
						"h": 167,
						"w": 409
					}
				],
				"ball": {
					"n": 0,
					"h": 149,
					"w": 203,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 50
		},
		{
			"num": 1723,
			"minute": 83,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 707
					},
					{
						"n": 2,
						"h": 385,
						"w": 355
					},
					{
						"n": 14,
						"h": 279,
						"w": 403
					},
					{
						"n": 13,
						"h": 175,
						"w": 401
					},
					{
						"n": 5,
						"h": 74,
						"w": 357
					},
					{
						"n": 6,
						"h": 395,
						"w": 117
					},
					{
						"n": 18,
						"h": 296,
						"w": 304
					},
					{
						"n": 15,
						"h": 169,
						"w": 168
					},
					{
						"n": 17,
						"h": 50,
						"w": 221
					},
					{
						"n": 20,
						"h": 300,
						"w": 107
					},
					{
						"n": 19,
						"h": 165,
						"w": 116
					}
				],
				"away": [
					{
						"n": 12,
						"h": 230,
						"w": 706
					},
					{
						"n": 13,
						"h": 400,
						"w": 535
					},
					{
						"n": 3,
						"h": 272,
						"w": 625
					},
					{
						"n": 14,
						"h": 170,
						"w": 640
					},
					{
						"n": 5,
						"h": 110,
						"w": 634
					},
					{
						"n": 16,
						"h": 280,
						"w": 572
					},
					{
						"n": 15,
						"h": 232,
						"w": 503
					},
					{
						"n": 18,
						"h": 55,
						"w": 532
					},
					{
						"n": 17,
						"h": 420,
						"w": 482
					},
					{
						"n": 19,
						"h": 286,
						"w": 430
					},
					{
						"n": 20,
						"h": 154,
						"w": 436
					}
				],
				"ball": {
					"n": 0,
					"h": 169,
					"w": 168,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1724,
			"minute": 83,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 704
					},
					{
						"n": 2,
						"h": 380,
						"w": 352
					},
					{
						"n": 14,
						"h": 278,
						"w": 405
					},
					{
						"n": 13,
						"h": 172,
						"w": 394
					},
					{
						"n": 5,
						"h": 78,
						"w": 357
					},
					{
						"n": 6,
						"h": 402,
						"w": 114
					},
					{
						"n": 18,
						"h": 295,
						"w": 296
					},
					{
						"n": 15,
						"h": 169,
						"w": 160
					},
					{
						"n": 17,
						"h": 49,
						"w": 213
					},
					{
						"n": 20,
						"h": 293,
						"w": 104
					},
					{
						"n": 19,
						"h": 170,
						"w": 109
					}
				],
				"away": [
					{
						"n": 12,
						"h": 230,
						"w": 706
					},
					{
						"n": 13,
						"h": 400,
						"w": 535
					},
					{
						"n": 3,
						"h": 269,
						"w": 633
					},
					{
						"n": 14,
						"h": 167,
						"w": 635
					},
					{
						"n": 5,
						"h": 110,
						"w": 626
					},
					{
						"n": 16,
						"h": 280,
						"w": 564
					},
					{
						"n": 15,
						"h": 224,
						"w": 504
					},
					{
						"n": 18,
						"h": 47,
						"w": 533
					},
					{
						"n": 17,
						"h": 420,
						"w": 482
					},
					{
						"n": 19,
						"h": 291,
						"w": 424
					},
					{
						"n": 20,
						"h": 154,
						"w": 436
					}
				],
				"ball": {
					"n": 0,
					"h": 169,
					"w": 160,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 8
		},
		{
			"num": 1725,
			"minute": 83,
			"messages": [
				{
					"owner": 1,
					"mes": "К.Келли[15](Галвэй Юнайтед) пасует Т.Дэвлину[20](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 709
					},
					{
						"n": 2,
						"h": 373,
						"w": 354
					},
					{
						"n": 14,
						"h": 283,
						"w": 415
					},
					{
						"n": 13,
						"h": 168,
						"w": 406
					},
					{
						"n": 5,
						"h": 63,
						"w": 356
					},
					{
						"n": 6,
						"h": 388,
						"w": 124
					},
					{
						"n": 18,
						"h": 277,
						"w": 255
					},
					{
						"n": 15,
						"h": 176,
						"w": 153
					},
					{
						"n": 17,
						"h": 47,
						"w": 168
					},
					{
						"n": 20,
						"h": 252,
						"w": 124
					},
					{
						"n": 19,
						"h": 151,
						"w": 105
					}
				],
				"away": [
					{
						"n": 12,
						"h": 222,
						"w": 705
					},
					{
						"n": 13,
						"h": 403,
						"w": 580
					},
					{
						"n": 3,
						"h": 248,
						"w": 625
					},
					{
						"n": 14,
						"h": 197,
						"w": 601
					},
					{
						"n": 5,
						"h": 70,
						"w": 616
					},
					{
						"n": 16,
						"h": 296,
						"w": 606
					},
					{
						"n": 15,
						"h": 224,
						"w": 494
					},
					{
						"n": 18,
						"h": 47,
						"w": 535
					},
					{
						"n": 17,
						"h": 431,
						"w": 485
					},
					{
						"n": 19,
						"h": 288,
						"w": 430
					},
					{
						"n": 20,
						"h": 161,
						"w": 416
					}
				],
				"ball": {
					"n": 0,
					"h": 252,
					"w": 124,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 45
		},
		{
			"num": 1726,
			"minute": 83,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 705
					},
					{
						"n": 2,
						"h": 375,
						"w": 358
					},
					{
						"n": 14,
						"h": 282,
						"w": 394
					},
					{
						"n": 13,
						"h": 183,
						"w": 410
					},
					{
						"n": 5,
						"h": 73,
						"w": 351
					},
					{
						"n": 6,
						"h": 398,
						"w": 124
					},
					{
						"n": 18,
						"h": 292,
						"w": 286
					},
					{
						"n": 15,
						"h": 173,
						"w": 165
					},
					{
						"n": 17,
						"h": 49,
						"w": 128
					},
					{
						"n": 20,
						"h": 289,
						"w": 124
					},
					{
						"n": 19,
						"h": 172,
						"w": 95
					}
				],
				"away": [
					{
						"n": 12,
						"h": 218,
						"w": 707
					},
					{
						"n": 13,
						"h": 401,
						"w": 620
					},
					{
						"n": 3,
						"h": 268,
						"w": 643
					},
					{
						"n": 14,
						"h": 169,
						"w": 616
					},
					{
						"n": 5,
						"h": 58,
						"w": 606
					},
					{
						"n": 16,
						"h": 282,
						"w": 568
					},
					{
						"n": 15,
						"h": 228,
						"w": 490
					},
					{
						"n": 18,
						"h": 28,
						"w": 542
					},
					{
						"n": 17,
						"h": 423,
						"w": 494
					},
					{
						"n": 19,
						"h": 287,
						"w": 426
					},
					{
						"n": 20,
						"h": 158,
						"w": 454
					}
				],
				"ball": {
					"n": 0,
					"h": 289,
					"w": 124,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1727,
			"minute": 83,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 706
					},
					{
						"n": 2,
						"h": 382,
						"w": 348
					},
					{
						"n": 14,
						"h": 284,
						"w": 406
					},
					{
						"n": 13,
						"h": 181,
						"w": 398
					},
					{
						"n": 5,
						"h": 68,
						"w": 359
					},
					{
						"n": 6,
						"h": 400,
						"w": 116
					},
					{
						"n": 18,
						"h": 294,
						"w": 274
					},
					{
						"n": 15,
						"h": 167,
						"w": 155
					},
					{
						"n": 17,
						"h": 41,
						"w": 119
					},
					{
						"n": 20,
						"h": 289,
						"w": 114
					},
					{
						"n": 19,
						"h": 167,
						"w": 86
					}
				],
				"away": [
					{
						"n": 12,
						"h": 218,
						"w": 707
					},
					{
						"n": 13,
						"h": 405,
						"w": 632
					},
					{
						"n": 3,
						"h": 268,
						"w": 648
					},
					{
						"n": 14,
						"h": 161,
						"w": 606
					},
					{
						"n": 5,
						"h": 56,
						"w": 614
					},
					{
						"n": 16,
						"h": 274,
						"w": 567
					},
					{
						"n": 15,
						"h": 228,
						"w": 502
					},
					{
						"n": 18,
						"h": 28,
						"w": 542
					},
					{
						"n": 17,
						"h": 417,
						"w": 503
					},
					{
						"n": 19,
						"h": 285,
						"w": 421
					},
					{
						"n": 20,
						"h": 156,
						"w": 466
					}
				],
				"ball": {
					"n": 0,
					"h": 289,
					"w": 114,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 12
		},
		{
			"num": 1728,
			"minute": 83,
			"messages": [
				{
					"owner": 1,
					"mes": "Т.Дэвлин[20](Галвэй Юнайтед) пытается пройти В.Сланину[34](Опава)..."
				},
				{
					"owner": 1,
					"mes": "Вацлав Сланина[34](Опава) отбирает мяч у Т.Дэвлина[20](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 706
					},
					{
						"n": 2,
						"h": 387,
						"w": 341
					},
					{
						"n": 14,
						"h": 284,
						"w": 409
					},
					{
						"n": 13,
						"h": 180,
						"w": 391
					},
					{
						"n": 5,
						"h": 68,
						"w": 359
					},
					{
						"n": 6,
						"h": 400,
						"w": 116
					},
					{
						"n": 18,
						"h": 296,
						"w": 265
					},
					{
						"n": 15,
						"h": 162,
						"w": 146
					},
					{
						"n": 17,
						"h": 39,
						"w": 116
					},
					{
						"n": 20,
						"h": 289,
						"w": 104
					},
					{
						"n": 19,
						"h": 167,
						"w": 86
					}
				],
				"away": [
					{
						"n": 12,
						"h": 218,
						"w": 707
					},
					{
						"n": 13,
						"h": 406,
						"w": 637
					},
					{
						"n": 3,
						"h": 268,
						"w": 648
					},
					{
						"n": 14,
						"h": 155,
						"w": 598,
						"m": 760
					},
					{
						"n": 5,
						"h": 56,
						"w": 614
					},
					{
						"n": 16,
						"h": 274,
						"w": 567
					},
					{
						"n": 15,
						"h": 228,
						"w": 511
					},
					{
						"n": 18,
						"h": 30,
						"w": 543
					},
					{
						"n": 17,
						"h": 417,
						"w": 503
					},
					{
						"n": 19,
						"h": 285,
						"w": 421
					},
					{
						"n": 20,
						"h": 156,
						"w": 466
					}
				],
				"ball": {
					"n": 0,
					"h": 295,
					"w": 122,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 10
		},
		{
			"num": 1729,
			"minute": 83,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 702
					},
					{
						"n": 2,
						"h": 373,
						"w": 378
					},
					{
						"n": 14,
						"h": 276,
						"w": 405
					},
					{
						"n": 13,
						"h": 163,
						"w": 411
					},
					{
						"n": 5,
						"h": 89,
						"w": 393
					},
					{
						"n": 6,
						"h": 398,
						"w": 156
					},
					{
						"n": 18,
						"h": 295,
						"w": 305
					},
					{
						"n": 15,
						"h": 168,
						"w": 185
					},
					{
						"n": 17,
						"h": 38,
						"w": 156
					},
					{
						"n": 20,
						"h": 286,
						"w": 114
					},
					{
						"n": 19,
						"h": 175,
						"w": 125
					}
				],
				"away": [
					{
						"n": 12,
						"h": 230,
						"w": 704
					},
					{
						"n": 13,
						"h": 404,
						"w": 597
					},
					{
						"n": 3,
						"h": 283,
						"w": 616
					},
					{
						"n": 14,
						"h": 180,
						"w": 573
					},
					{
						"n": 5,
						"h": 70,
						"w": 607
					},
					{
						"n": 16,
						"h": 257,
						"w": 530
					},
					{
						"n": 15,
						"h": 224,
						"w": 471
					},
					{
						"n": 18,
						"h": 43,
						"w": 505
					},
					{
						"n": 17,
						"h": 411,
						"w": 463
					},
					{
						"n": 19,
						"h": 297,
						"w": 383
					},
					{
						"n": 20,
						"h": 157,
						"w": 426
					}
				],
				"ball": {
					"n": 0,
					"h": 270,
					"w": 147,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1730,
			"minute": 83,
			"messages": [
				{
					"owner": 2,
					"mes": "Вацлав Сланина[34](Опава) отправляет мяч направо Н.Томпсону[38](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 702
					},
					{
						"n": 2,
						"h": 343,
						"w": 420
					},
					{
						"n": 14,
						"h": 274,
						"w": 428
					},
					{
						"n": 13,
						"h": 173,
						"w": 425
					},
					{
						"n": 5,
						"h": 120,
						"w": 430
					},
					{
						"n": 6,
						"h": 403,
						"w": 207
					},
					{
						"n": 18,
						"h": 298,
						"w": 355
					},
					{
						"n": 15,
						"h": 186,
						"w": 233
					},
					{
						"n": 17,
						"h": 43,
						"w": 207
					},
					{
						"n": 20,
						"h": 272,
						"w": 157
					},
					{
						"n": 19,
						"h": 194,
						"w": 173
					}
				],
				"away": [
					{
						"n": 12,
						"h": 226,
						"w": 703
					},
					{
						"n": 13,
						"h": 403,
						"w": 546
					},
					{
						"n": 3,
						"h": 277,
						"w": 625
					},
					{
						"n": 14,
						"h": 178,
						"w": 583
					},
					{
						"n": 5,
						"h": 76,
						"w": 629
					},
					{
						"n": 16,
						"h": 225,
						"w": 491
					},
					{
						"n": 15,
						"h": 210,
						"w": 422
					},
					{
						"n": 18,
						"h": 43,
						"w": 505
					},
					{
						"n": 17,
						"h": 407,
						"w": 412
					},
					{
						"n": 19,
						"h": 293,
						"w": 332
					},
					{
						"n": 20,
						"h": 156,
						"w": 375
					}
				],
				"ball": {
					"n": 0,
					"h": 407,
					"w": 215,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 51
		},
		{
			"num": 1731,
			"minute": 83,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 709
					},
					{
						"n": 2,
						"h": 332,
						"w": 458
					},
					{
						"n": 14,
						"h": 284,
						"w": 467
					},
					{
						"n": 13,
						"h": 175,
						"w": 465
					},
					{
						"n": 5,
						"h": 120,
						"w": 462
					},
					{
						"n": 6,
						"h": 396,
						"w": 253
					},
					{
						"n": 18,
						"h": 300,
						"w": 394
					},
					{
						"n": 15,
						"h": 194,
						"w": 272
					},
					{
						"n": 17,
						"h": 46,
						"w": 247
					},
					{
						"n": 20,
						"h": 276,
						"w": 197
					},
					{
						"n": 19,
						"h": 186,
						"w": 212
					}
				],
				"away": [
					{
						"n": 12,
						"h": 220,
						"w": 702
					},
					{
						"n": 13,
						"h": 404,
						"w": 506
					},
					{
						"n": 3,
						"h": 274,
						"w": 604
					},
					{
						"n": 14,
						"h": 183,
						"w": 602
					},
					{
						"n": 5,
						"h": 66,
						"w": 590
					},
					{
						"n": 16,
						"h": 206,
						"w": 456
					},
					{
						"n": 15,
						"h": 193,
						"w": 386
					},
					{
						"n": 18,
						"h": 24,
						"w": 470
					},
					{
						"n": 17,
						"h": 405,
						"w": 373
					},
					{
						"n": 19,
						"h": 302,
						"w": 293
					},
					{
						"n": 20,
						"h": 149,
						"w": 335
					}
				],
				"ball": {
					"n": 0,
					"h": 426,
					"w": 250,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1732,
			"minute": 84,
			"possession": 43,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 703
					},
					{
						"n": 2,
						"h": 330,
						"w": 474,
						"m": 710
					},
					{
						"n": 14,
						"h": 286,
						"w": 461
					},
					{
						"n": 13,
						"h": 183,
						"w": 469,
						"f": 92
					},
					{
						"n": 5,
						"h": 120,
						"w": 470
					},
					{
						"n": 6,
						"h": 394,
						"w": 291
					},
					{
						"n": 18,
						"h": 262,
						"w": 393,
						"f": 92
					},
					{
						"n": 15,
						"h": 201,
						"w": 312
					},
					{
						"n": 17,
						"h": 39,
						"w": 286
					},
					{
						"n": 20,
						"h": 275,
						"w": 237
					},
					{
						"n": 19,
						"h": 176,
						"w": 251
					}
				],
				"away": [
					{
						"n": 12,
						"h": 226,
						"w": 704
					},
					{
						"n": 13,
						"h": 415,
						"w": 468,
						"f": 88
					},
					{
						"n": 3,
						"h": 280,
						"w": 599
					},
					{
						"n": 14,
						"h": 177,
						"w": 599
					},
					{
						"n": 5,
						"h": 72,
						"w": 572
					},
					{
						"n": 16,
						"h": 176,
						"w": 482
					},
					{
						"n": 15,
						"h": 198,
						"w": 346
					},
					{
						"n": 18,
						"h": 24,
						"w": 444
					},
					{
						"n": 17,
						"h": 407,
						"w": 333
					},
					{
						"n": 19,
						"h": 279,
						"w": 281
					},
					{
						"n": 20,
						"h": 151,
						"w": 295,
						"f": 91
					}
				],
				"ball": {
					"n": 0,
					"h": 426,
					"w": 276,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1733,
			"minute": 84,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 710
					},
					{
						"n": 2,
						"h": 330,
						"w": 513
					},
					{
						"n": 14,
						"h": 289,
						"w": 499
					},
					{
						"n": 13,
						"h": 185,
						"w": 508
					},
					{
						"n": 5,
						"h": 120,
						"w": 509
					},
					{
						"n": 6,
						"h": 394,
						"w": 317
					},
					{
						"n": 18,
						"h": 259,
						"w": 431
					},
					{
						"n": 15,
						"h": 205,
						"w": 351
					},
					{
						"n": 17,
						"h": 43,
						"w": 325
					},
					{
						"n": 20,
						"h": 272,
						"w": 276
					},
					{
						"n": 19,
						"h": 172,
						"w": 289
					}
				],
				"away": [
					{
						"n": 12,
						"h": 220,
						"w": 683
					},
					{
						"n": 13,
						"h": 414,
						"w": 429
					},
					{
						"n": 3,
						"h": 281,
						"w": 560
					},
					{
						"n": 14,
						"h": 175,
						"w": 560
					},
					{
						"n": 5,
						"h": 68,
						"w": 534
					},
					{
						"n": 16,
						"h": 179,
						"w": 443
					},
					{
						"n": 15,
						"h": 200,
						"w": 307
					},
					{
						"n": 18,
						"h": 21,
						"w": 418
					},
					{
						"n": 17,
						"h": 411,
						"w": 294
					},
					{
						"n": 19,
						"h": 276,
						"w": 243
					},
					{
						"n": 20,
						"h": 142,
						"w": 258
					}
				],
				"ball": {
					"n": 0,
					"h": 429,
					"w": 302,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 1734,
			"minute": 84,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 709
					},
					{
						"n": 2,
						"h": 342,
						"w": 550
					},
					{
						"n": 14,
						"h": 291,
						"w": 538
					},
					{
						"n": 13,
						"h": 188,
						"w": 546
					},
					{
						"n": 5,
						"h": 120,
						"w": 548
					},
					{
						"n": 6,
						"h": 394,
						"w": 342
					},
					{
						"n": 18,
						"h": 257,
						"w": 470
					},
					{
						"n": 15,
						"h": 206,
						"w": 390
					},
					{
						"n": 17,
						"h": 46,
						"w": 364
					},
					{
						"n": 20,
						"h": 271,
						"w": 315
					},
					{
						"n": 19,
						"h": 170,
						"w": 328
					}
				],
				"away": [
					{
						"n": 12,
						"h": 220,
						"w": 664
					},
					{
						"n": 13,
						"h": 412,
						"w": 390
					},
					{
						"n": 3,
						"h": 284,
						"w": 522
					},
					{
						"n": 14,
						"h": 171,
						"w": 522
					},
					{
						"n": 5,
						"h": 64,
						"w": 495
					},
					{
						"n": 16,
						"h": 180,
						"w": 404
					},
					{
						"n": 15,
						"h": 200,
						"w": 268
					},
					{
						"n": 18,
						"h": 24,
						"w": 393
					},
					{
						"n": 17,
						"h": 417,
						"w": 255
					},
					{
						"n": 19,
						"h": 273,
						"w": 204
					},
					{
						"n": 20,
						"h": 137,
						"w": 219
					}
				],
				"ball": {
					"n": 0,
					"h": 426,
					"w": 327,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 1735,
			"minute": 84,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 709
					},
					{
						"n": 2,
						"h": 357,
						"w": 586
					},
					{
						"n": 14,
						"h": 295,
						"w": 577
					},
					{
						"n": 13,
						"h": 190,
						"w": 585
					},
					{
						"n": 5,
						"h": 120,
						"w": 587
					},
					{
						"n": 6,
						"h": 394,
						"w": 367
					},
					{
						"n": 18,
						"h": 259,
						"w": 509
					},
					{
						"n": 15,
						"h": 213,
						"w": 428
					},
					{
						"n": 17,
						"h": 50,
						"w": 403
					},
					{
						"n": 20,
						"h": 268,
						"w": 354
					},
					{
						"n": 19,
						"h": 167,
						"w": 367
					}
				],
				"away": [
					{
						"n": 12,
						"h": 229,
						"w": 641
					},
					{
						"n": 13,
						"h": 405,
						"w": 351
					},
					{
						"n": 3,
						"h": 276,
						"w": 483
					},
					{
						"n": 14,
						"h": 173,
						"w": 483
					},
					{
						"n": 5,
						"h": 69,
						"w": 456
					},
					{
						"n": 16,
						"h": 184,
						"w": 365
					},
					{
						"n": 15,
						"h": 192,
						"w": 230
					},
					{
						"n": 18,
						"h": 21,
						"w": 368
					},
					{
						"n": 17,
						"h": 419,
						"w": 216
					},
					{
						"n": 19,
						"h": 278,
						"w": 165
					},
					{
						"n": 20,
						"h": 131,
						"w": 180
					}
				],
				"ball": {
					"n": 0,
					"h": 429,
					"w": 352,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 1736,
			"minute": 84,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 710
					},
					{
						"n": 2,
						"h": 318,
						"w": 583
					},
					{
						"n": 14,
						"h": 283,
						"w": 607
					},
					{
						"n": 13,
						"h": 198,
						"w": 623
					},
					{
						"n": 5,
						"h": 120,
						"w": 611
					},
					{
						"n": 6,
						"h": 394,
						"w": 393
					},
					{
						"n": 18,
						"h": 257,
						"w": 529
					},
					{
						"n": 15,
						"h": 209,
						"w": 467
					},
					{
						"n": 17,
						"h": 51,
						"w": 442
					},
					{
						"n": 20,
						"h": 267,
						"w": 393
					},
					{
						"n": 19,
						"h": 160,
						"w": 406
					}
				],
				"away": [
					{
						"n": 12,
						"h": 228,
						"w": 620
					},
					{
						"n": 13,
						"h": 406,
						"w": 312
					},
					{
						"n": 3,
						"h": 283,
						"w": 445
					},
					{
						"n": 14,
						"h": 162,
						"w": 446
					},
					{
						"n": 5,
						"h": 72,
						"w": 443
					},
					{
						"n": 16,
						"h": 184,
						"w": 326
					},
					{
						"n": 15,
						"h": 197,
						"w": 192
					},
					{
						"n": 18,
						"h": 24,
						"w": 342
					},
					{
						"n": 17,
						"h": 427,
						"w": 178
					},
					{
						"n": 19,
						"h": 288,
						"w": 144
					},
					{
						"n": 20,
						"h": 130,
						"w": 144
					}
				],
				"ball": {
					"n": 0,
					"h": 426,
					"w": 378,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 1737,
			"minute": 84,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 702
					},
					{
						"n": 2,
						"h": 350,
						"w": 606
					},
					{
						"n": 14,
						"h": 322,
						"w": 610
					},
					{
						"n": 13,
						"h": 210,
						"w": 596
					},
					{
						"n": 5,
						"h": 120,
						"w": 613
					},
					{
						"n": 6,
						"h": 394,
						"w": 418
					},
					{
						"n": 18,
						"h": 243,
						"w": 550
					},
					{
						"n": 15,
						"h": 194,
						"w": 503
					},
					{
						"n": 17,
						"h": 56,
						"w": 480
					},
					{
						"n": 20,
						"h": 263,
						"w": 432
					},
					{
						"n": 19,
						"h": 160,
						"w": 428
					}
				],
				"away": [
					{
						"n": 12,
						"h": 230,
						"w": 600
					},
					{
						"n": 13,
						"h": 410,
						"w": 274
					},
					{
						"n": 3,
						"h": 281,
						"w": 456
					},
					{
						"n": 14,
						"h": 168,
						"w": 456
					},
					{
						"n": 5,
						"h": 73,
						"w": 433
					},
					{
						"n": 16,
						"h": 189,
						"w": 287
					},
					{
						"n": 15,
						"h": 199,
						"w": 174
					},
					{
						"n": 18,
						"h": 27,
						"w": 317
					},
					{
						"n": 17,
						"h": 428,
						"w": 149
					},
					{
						"n": 19,
						"h": 260,
						"w": 144
					},
					{
						"n": 20,
						"h": 109,
						"w": 144
					}
				],
				"ball": {
					"n": 0,
					"h": 423,
					"w": 403,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 1738,
			"minute": 84,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 705
					},
					{
						"n": 2,
						"h": 326,
						"w": 615
					},
					{
						"n": 14,
						"h": 289,
						"w": 631
					},
					{
						"n": 13,
						"h": 180,
						"w": 620
					},
					{
						"n": 5,
						"h": 120,
						"w": 627
					},
					{
						"n": 6,
						"h": 394,
						"w": 443
					},
					{
						"n": 18,
						"h": 267,
						"w": 573
					},
					{
						"n": 15,
						"h": 168,
						"w": 532
					},
					{
						"n": 17,
						"h": 56,
						"w": 490
					},
					{
						"n": 20,
						"h": 277,
						"w": 395
					},
					{
						"n": 19,
						"h": 168,
						"w": 390
					}
				],
				"away": [
					{
						"n": 12,
						"h": 224,
						"w": 593
					},
					{
						"n": 13,
						"h": 416,
						"w": 265
					},
					{
						"n": 3,
						"h": 283,
						"w": 424
					},
					{
						"n": 14,
						"h": 162,
						"w": 427
					},
					{
						"n": 5,
						"h": 72,
						"w": 418
					},
					{
						"n": 16,
						"h": 196,
						"w": 249
					},
					{
						"n": 15,
						"h": 193,
						"w": 150
					},
					{
						"n": 18,
						"h": 31,
						"w": 292
					},
					{
						"n": 17,
						"h": 435,
						"w": 118
					},
					{
						"n": 19,
						"h": 288,
						"w": 120
					},
					{
						"n": 20,
						"h": 116,
						"w": 120
					}
				],
				"ball": {
					"n": 0,
					"h": 419,
					"w": 428,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 1739,
			"minute": 84,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 705
					},
					{
						"n": 2,
						"h": 329,
						"w": 605
					},
					{
						"n": 14,
						"h": 284,
						"w": 628
					},
					{
						"n": 13,
						"h": 201,
						"w": 628
					},
					{
						"n": 5,
						"h": 120,
						"w": 643
					},
					{
						"n": 6,
						"h": 394,
						"w": 469
					},
					{
						"n": 18,
						"h": 252,
						"w": 580
					},
					{
						"n": 15,
						"h": 196,
						"w": 533
					},
					{
						"n": 17,
						"h": 60,
						"w": 477
					},
					{
						"n": 20,
						"h": 279,
						"w": 388
					},
					{
						"n": 19,
						"h": 159,
						"w": 372
					}
				],
				"away": [
					{
						"n": 12,
						"h": 230,
						"w": 601
					},
					{
						"n": 13,
						"h": 390,
						"w": 278
					},
					{
						"n": 3,
						"h": 270,
						"w": 429
					},
					{
						"n": 14,
						"h": 176,
						"w": 430
					},
					{
						"n": 5,
						"h": 68,
						"w": 425
					},
					{
						"n": 16,
						"h": 201,
						"w": 210
					},
					{
						"n": 15,
						"h": 201,
						"w": 150
					},
					{
						"n": 18,
						"h": 34,
						"w": 266
					},
					{
						"n": 17,
						"h": 431,
						"w": 132
					},
					{
						"n": 19,
						"h": 260,
						"w": 120
					},
					{
						"n": 20,
						"h": 113,
						"w": 120
					}
				],
				"ball": {
					"n": 0,
					"h": 416,
					"w": 454,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 1740,
			"minute": 84,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 706
					},
					{
						"n": 2,
						"h": 367,
						"w": 592
					},
					{
						"n": 14,
						"h": 289,
						"w": 604
					},
					{
						"n": 13,
						"h": 187,
						"w": 605
					},
					{
						"n": 5,
						"h": 120,
						"w": 603
					},
					{
						"n": 6,
						"h": 382,
						"w": 498
					},
					{
						"n": 18,
						"h": 272,
						"w": 546
					},
					{
						"n": 15,
						"h": 204,
						"w": 494
					},
					{
						"n": 17,
						"h": 47,
						"w": 506
					},
					{
						"n": 20,
						"h": 285,
						"w": 387
					},
					{
						"n": 19,
						"h": 162,
						"w": 376
					}
				],
				"away": [
					{
						"n": 12,
						"h": 230,
						"w": 600
					},
					{
						"n": 13,
						"h": 393,
						"w": 318
					},
					{
						"n": 3,
						"h": 280,
						"w": 468
					},
					{
						"n": 14,
						"h": 169,
						"w": 446
					},
					{
						"n": 5,
						"h": 71,
						"w": 438
					},
					{
						"n": 16,
						"h": 200,
						"w": 250
					},
					{
						"n": 15,
						"h": 187,
						"w": 187
					},
					{
						"n": 18,
						"h": 52,
						"w": 237
					},
					{
						"n": 17,
						"h": 391,
						"w": 131
					},
					{
						"n": 19,
						"h": 279,
						"w": 135
					},
					{
						"n": 20,
						"h": 149,
						"w": 138
					}
				],
				"ball": {
					"n": 0,
					"h": 398,
					"w": 483,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1741,
			"minute": 84,
			"messages": [
				{
					"owner": 2,
					"mes": "Передача А.Карабецу[35](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 702
					},
					{
						"n": 2,
						"h": 333,
						"w": 611
					},
					{
						"n": 14,
						"h": 278,
						"w": 609
					},
					{
						"n": 13,
						"h": 170,
						"w": 595
					},
					{
						"n": 5,
						"h": 120,
						"w": 609
					},
					{
						"n": 6,
						"h": 394,
						"w": 522
					},
					{
						"n": 18,
						"h": 289,
						"w": 538
					},
					{
						"n": 15,
						"h": 187,
						"w": 507
					},
					{
						"n": 17,
						"h": 52,
						"w": 544
					},
					{
						"n": 20,
						"h": 286,
						"w": 387
					},
					{
						"n": 19,
						"h": 157,
						"w": 387
					}
				],
				"away": [
					{
						"n": 12,
						"h": 220,
						"w": 598
					},
					{
						"n": 13,
						"h": 401,
						"w": 337
					},
					{
						"n": 3,
						"h": 281,
						"w": 447
					},
					{
						"n": 14,
						"h": 167,
						"w": 448
					},
					{
						"n": 5,
						"h": 68,
						"w": 445
					},
					{
						"n": 16,
						"h": 213,
						"w": 287
					},
					{
						"n": 15,
						"h": 164,
						"w": 200
					},
					{
						"n": 18,
						"h": 53,
						"w": 233
					},
					{
						"n": 17,
						"h": 406,
						"w": 155
					},
					{
						"n": 19,
						"h": 302,
						"w": 131
					},
					{
						"n": 20,
						"h": 159,
						"w": 155
					}
				],
				"ball": {
					"n": 0,
					"h": 286,
					"w": 520,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 1742,
			"minute": 84,
			"messages": [
				{
					"owner": 2,
					"mes": "Пас вперед..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 706
					},
					{
						"n": 2,
						"h": 330,
						"w": 621
					},
					{
						"n": 14,
						"h": 268,
						"w": 617
					},
					{
						"n": 13,
						"h": 176,
						"w": 613
					},
					{
						"n": 5,
						"h": 120,
						"w": 613
					},
					{
						"n": 6,
						"h": 394,
						"w": 541
					},
					{
						"n": 18,
						"h": 277,
						"w": 553
					},
					{
						"n": 15,
						"h": 181,
						"w": 501
					},
					{
						"n": 17,
						"h": 55,
						"w": 563
					},
					{
						"n": 20,
						"h": 272,
						"w": 400
					},
					{
						"n": 19,
						"h": 163,
						"w": 380
					}
				],
				"away": [
					{
						"n": 12,
						"h": 224,
						"w": 593
					},
					{
						"n": 13,
						"h": 403,
						"w": 318
					},
					{
						"n": 3,
						"h": 275,
						"w": 446
					},
					{
						"n": 14,
						"h": 171,
						"w": 466
					},
					{
						"n": 5,
						"h": 70,
						"w": 464
					},
					{
						"n": 16,
						"h": 213,
						"w": 306
					},
					{
						"n": 15,
						"h": 167,
						"w": 192
					},
					{
						"n": 18,
						"h": 51,
						"w": 214
					},
					{
						"n": 17,
						"h": 404,
						"w": 144
					},
					{
						"n": 19,
						"h": 284,
						"w": 125
					},
					{
						"n": 20,
						"h": 178,
						"w": 154
					}
				],
				"ball": {
					"n": 0,
					"h": 271,
					"w": 555,
					"z": 0,
					"r": 0,
					"p": 2,
					"x": 0
				}
			},
			"interval": 19
		},
		{
			"num": 1743,
			"minute": 84,
			"messages": [
				{
					"owner": 2,
					"mes": "Тома Анри[40](Опава) технично принимает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 706
					},
					{
						"n": 2,
						"h": 330,
						"w": 609
					},
					{
						"n": 14,
						"h": 270,
						"w": 616
					},
					{
						"n": 13,
						"h": 188,
						"w": 613
					},
					{
						"n": 5,
						"h": 120,
						"w": 601
					},
					{
						"n": 6,
						"h": 394,
						"w": 553
					},
					{
						"n": 18,
						"h": 269,
						"w": 562
					},
					{
						"n": 15,
						"h": 193,
						"w": 501
					},
					{
						"n": 17,
						"h": 59,
						"w": 574
					},
					{
						"n": 20,
						"h": 262,
						"w": 406
					},
					{
						"n": 19,
						"h": 174,
						"w": 385
					}
				],
				"away": [
					{
						"n": 12,
						"h": 229,
						"w": 601
					},
					{
						"n": 13,
						"h": 405,
						"w": 306
					},
					{
						"n": 3,
						"h": 268,
						"w": 440
					},
					{
						"n": 14,
						"h": 168,
						"w": 454
					},
					{
						"n": 5,
						"h": 66,
						"w": 452
					},
					{
						"n": 16,
						"h": 222,
						"w": 314
					},
					{
						"n": 15,
						"h": 168,
						"w": 185
					},
					{
						"n": 18,
						"h": 49,
						"w": 202
					},
					{
						"n": 17,
						"h": 395,
						"w": 136
					},
					{
						"n": 19,
						"h": 294,
						"w": 118
					},
					{
						"n": 20,
						"h": 184,
						"w": 154,
						"m": 660
					}
				],
				"ball": {
					"n": 0,
					"h": 266,
					"w": 566,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 12
		},
		{
			"num": 1744,
			"minute": 84,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 705
					},
					{
						"n": 2,
						"h": 330,
						"w": 612
					},
					{
						"n": 14,
						"h": 264,
						"w": 616
					},
					{
						"n": 13,
						"h": 192,
						"w": 613
					},
					{
						"n": 5,
						"h": 100,
						"w": 602
					},
					{
						"n": 6,
						"h": 394,
						"w": 573
					},
					{
						"n": 18,
						"h": 257,
						"w": 578
					},
					{
						"n": 15,
						"h": 193,
						"w": 519
					},
					{
						"n": 17,
						"h": 59,
						"w": 554
					},
					{
						"n": 20,
						"h": 243,
						"w": 413
					},
					{
						"n": 19,
						"h": 175,
						"w": 384
					}
				],
				"away": [
					{
						"n": 12,
						"h": 222,
						"w": 602
					},
					{
						"n": 13,
						"h": 407,
						"w": 286
					},
					{
						"n": 3,
						"h": 276,
						"w": 443
					},
					{
						"n": 14,
						"h": 179,
						"w": 437
					},
					{
						"n": 5,
						"h": 61,
						"w": 433
					},
					{
						"n": 16,
						"h": 225,
						"w": 320
					},
					{
						"n": 15,
						"h": 174,
						"w": 166
					},
					{
						"n": 18,
						"h": 51,
						"w": 182
					},
					{
						"n": 17,
						"h": 405,
						"w": 129
					},
					{
						"n": 19,
						"h": 270,
						"w": 118
					},
					{
						"n": 20,
						"h": 202,
						"w": 152
					}
				],
				"ball": {
					"n": 0,
					"h": 248,
					"w": 568,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 20
		},
		{
			"num": 1745,
			"minute": 84,
			"messages": [
				{
					"owner": 2,
					"mes": "Тома Анри[40](Опава) отправляет мяч налево..."
				},
				{
					"owner": 2,
					"mes": "Билли Реган[13](Галвэй Юнайтед) оказывается первым на мяче..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 705
					},
					{
						"n": 2,
						"h": 330,
						"w": 634
					},
					{
						"n": 14,
						"h": 241,
						"w": 619
					},
					{
						"n": 13,
						"h": 209,
						"w": 596
					},
					{
						"n": 5,
						"h": 80,
						"w": 616
					},
					{
						"n": 6,
						"h": 394,
						"w": 596
					},
					{
						"n": 18,
						"h": 273,
						"w": 576
					},
					{
						"n": 15,
						"h": 186,
						"w": 520
					},
					{
						"n": 17,
						"h": 58,
						"w": 530
					},
					{
						"n": 20,
						"h": 231,
						"w": 434
					},
					{
						"n": 19,
						"h": 161,
						"w": 388
					}
				],
				"away": [
					{
						"n": 12,
						"h": 225,
						"w": 599
					},
					{
						"n": 13,
						"h": 405,
						"w": 264
					},
					{
						"n": 3,
						"h": 276,
						"w": 428
					},
					{
						"n": 14,
						"h": 165,
						"w": 433
					},
					{
						"n": 5,
						"h": 72,
						"w": 412
					},
					{
						"n": 16,
						"h": 225,
						"w": 296
					},
					{
						"n": 15,
						"h": 180,
						"w": 162
					},
					{
						"n": 18,
						"h": 47,
						"w": 159
					},
					{
						"n": 17,
						"h": 390,
						"w": 118
					},
					{
						"n": 19,
						"h": 246,
						"w": 123,
						"m": 640
					},
					{
						"n": 20,
						"h": 194,
						"w": 146,
						"m": 640
					}
				],
				"ball": {
					"n": 0,
					"h": 209,
					"w": 596,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 24
		},
		{
			"num": 1746,
			"minute": 84,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 706
					},
					{
						"n": 2,
						"h": 342,
						"w": 612
					},
					{
						"n": 14,
						"h": 263,
						"w": 585
					},
					{
						"n": 13,
						"h": 184,
						"w": 571,
						"m": 640
					},
					{
						"n": 5,
						"h": 71,
						"w": 577
					},
					{
						"n": 6,
						"h": 396,
						"w": 556
					},
					{
						"n": 18,
						"h": 280,
						"w": 536
					},
					{
						"n": 15,
						"h": 173,
						"w": 482
					},
					{
						"n": 17,
						"h": 56,
						"w": 490
					},
					{
						"n": 20,
						"h": 248,
						"w": 398
					},
					{
						"n": 19,
						"h": 159,
						"w": 348
					}
				],
				"away": [
					{
						"n": 12,
						"h": 230,
						"w": 643
					},
					{
						"n": 13,
						"h": 404,
						"w": 304
					},
					{
						"n": 3,
						"h": 275,
						"w": 468
					},
					{
						"n": 14,
						"h": 197,
						"w": 458
					},
					{
						"n": 5,
						"h": 91,
						"w": 447
					},
					{
						"n": 16,
						"h": 222,
						"w": 336
					},
					{
						"n": 15,
						"h": 191,
						"w": 201
					},
					{
						"n": 18,
						"h": 48,
						"w": 199
					},
					{
						"n": 17,
						"h": 396,
						"w": 157
					},
					{
						"n": 19,
						"h": 262,
						"w": 160
					},
					{
						"n": 20,
						"h": 179,
						"w": 183
					}
				],
				"ball": {
					"n": 0,
					"h": 184,
					"w": 571,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1747,
			"minute": 84,
			"messages": [
				{
					"owner": 1,
					"mes": "Билли Реган[13](Галвэй Юнайтед) отдает пас Т.Смиту[14](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 705
					},
					{
						"n": 2,
						"h": 358,
						"w": 570
					},
					{
						"n": 14,
						"h": 254,
						"w": 578
					},
					{
						"n": 13,
						"h": 176,
						"w": 572
					},
					{
						"n": 5,
						"h": 69,
						"w": 542
					},
					{
						"n": 6,
						"h": 398,
						"w": 522
					},
					{
						"n": 18,
						"h": 286,
						"w": 502
					},
					{
						"n": 15,
						"h": 170,
						"w": 447
					},
					{
						"n": 17,
						"h": 50,
						"w": 456
					},
					{
						"n": 20,
						"h": 261,
						"w": 365
					},
					{
						"n": 19,
						"h": 150,
						"w": 314
					}
				],
				"away": [
					{
						"n": 12,
						"h": 228,
						"w": 646
					},
					{
						"n": 13,
						"h": 410,
						"w": 338
					},
					{
						"n": 3,
						"h": 283,
						"w": 485
					},
					{
						"n": 14,
						"h": 200,
						"w": 493
					},
					{
						"n": 5,
						"h": 102,
						"w": 480
					},
					{
						"n": 16,
						"h": 220,
						"w": 371
					},
					{
						"n": 15,
						"h": 198,
						"w": 235
					},
					{
						"n": 18,
						"h": 42,
						"w": 233
					},
					{
						"n": 17,
						"h": 399,
						"w": 192
					},
					{
						"n": 19,
						"h": 272,
						"w": 193
					},
					{
						"n": 20,
						"h": 166,
						"w": 215
					}
				],
				"ball": {
					"n": 0,
					"h": 254,
					"w": 578,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 35
		},
		{
			"num": 1748,
			"minute": 84,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 701
					},
					{
						"n": 2,
						"h": 368,
						"w": 531
					},
					{
						"n": 14,
						"h": 240,
						"w": 546
					},
					{
						"n": 13,
						"h": 182,
						"w": 532
					},
					{
						"n": 5,
						"h": 71,
						"w": 502
					},
					{
						"n": 6,
						"h": 402,
						"w": 482
					},
					{
						"n": 18,
						"h": 302,
						"w": 465
					},
					{
						"n": 15,
						"h": 158,
						"w": 409
					},
					{
						"n": 17,
						"h": 51,
						"w": 416
					},
					{
						"n": 20,
						"h": 276,
						"w": 328
					},
					{
						"n": 19,
						"h": 149,
						"w": 274
					}
				],
				"away": [
					{
						"n": 12,
						"h": 223,
						"w": 647
					},
					{
						"n": 13,
						"h": 408,
						"w": 378
					},
					{
						"n": 3,
						"h": 285,
						"w": 498
					},
					{
						"n": 14,
						"h": 187,
						"w": 512
					},
					{
						"n": 5,
						"h": 110,
						"w": 510
					},
					{
						"n": 16,
						"h": 191,
						"w": 398
					},
					{
						"n": 15,
						"h": 205,
						"w": 274
					},
					{
						"n": 18,
						"h": 45,
						"w": 273
					},
					{
						"n": 17,
						"h": 406,
						"w": 232
					},
					{
						"n": 19,
						"h": 284,
						"w": 232
					},
					{
						"n": 20,
						"h": 156,
						"w": 254
					}
				],
				"ball": {
					"n": 0,
					"h": 240,
					"w": 546,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1749,
			"minute": 84,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 704
					},
					{
						"n": 2,
						"h": 380,
						"w": 493
					},
					{
						"n": 14,
						"h": 248,
						"w": 512
					},
					{
						"n": 13,
						"h": 170,
						"w": 517
					},
					{
						"n": 5,
						"h": 78,
						"w": 481
					},
					{
						"n": 6,
						"h": 401,
						"w": 442
					},
					{
						"n": 18,
						"h": 294,
						"w": 454
					},
					{
						"n": 15,
						"h": 157,
						"w": 369
					},
					{
						"n": 17,
						"h": 52,
						"w": 376
					},
					{
						"n": 20,
						"h": 281,
						"w": 288
					},
					{
						"n": 19,
						"h": 163,
						"w": 249
					}
				],
				"away": [
					{
						"n": 12,
						"h": 227,
						"w": 641
					},
					{
						"n": 13,
						"h": 398,
						"w": 380
					},
					{
						"n": 3,
						"h": 276,
						"w": 510
					},
					{
						"n": 14,
						"h": 184,
						"w": 491
					},
					{
						"n": 5,
						"h": 110,
						"w": 502
					},
					{
						"n": 16,
						"h": 165,
						"w": 429
					},
					{
						"n": 15,
						"h": 213,
						"w": 313
					},
					{
						"n": 18,
						"h": 41,
						"w": 313
					},
					{
						"n": 17,
						"h": 415,
						"w": 271
					},
					{
						"n": 19,
						"h": 287,
						"w": 271
					},
					{
						"n": 20,
						"h": 148,
						"w": 293
					}
				],
				"ball": {
					"n": 0,
					"h": 248,
					"w": 512,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1750,
			"minute": 84,
			"messages": [
				{
					"owner": 1,
					"mes": "Том Смит[14](Галвэй Юнайтед) отдает передачу налево Т.Эверсу[02](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 708
					},
					{
						"n": 2,
						"h": 357,
						"w": 518
					},
					{
						"n": 14,
						"h": 256,
						"w": 518
					},
					{
						"n": 13,
						"h": 187,
						"w": 527
					},
					{
						"n": 5,
						"h": 62,
						"w": 477
					},
					{
						"n": 6,
						"h": 399,
						"w": 405
					},
					{
						"n": 18,
						"h": 292,
						"w": 419
					},
					{
						"n": 15,
						"h": 185,
						"w": 345
					},
					{
						"n": 17,
						"h": 49,
						"w": 339
					},
					{
						"n": 20,
						"h": 287,
						"w": 252
					},
					{
						"n": 19,
						"h": 164,
						"w": 260
					}
				],
				"away": [
					{
						"n": 12,
						"h": 205,
						"w": 645
					},
					{
						"n": 13,
						"h": 401,
						"w": 417
					},
					{
						"n": 3,
						"h": 271,
						"w": 500
					},
					{
						"n": 14,
						"h": 176,
						"w": 493
					},
					{
						"n": 5,
						"h": 110,
						"w": 506
					},
					{
						"n": 16,
						"h": 196,
						"w": 428
					},
					{
						"n": 15,
						"h": 227,
						"w": 348
					},
					{
						"n": 18,
						"h": 39,
						"w": 350
					},
					{
						"n": 17,
						"h": 405,
						"w": 306
					},
					{
						"n": 19,
						"h": 285,
						"w": 308
					},
					{
						"n": 20,
						"h": 129,
						"w": 320
					}
				],
				"ball": {
					"n": 0,
					"h": 357,
					"w": 518,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 37
		},
		{
			"num": 1751,
			"minute": 84,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 710
					},
					{
						"n": 2,
						"h": 355,
						"w": 483
					},
					{
						"n": 14,
						"h": 270,
						"w": 531
					},
					{
						"n": 13,
						"h": 177,
						"w": 517
					},
					{
						"n": 5,
						"h": 64,
						"w": 480
					},
					{
						"n": 6,
						"h": 401,
						"w": 365
					},
					{
						"n": 18,
						"h": 305,
						"w": 422
					},
					{
						"n": 15,
						"h": 205,
						"w": 337
					},
					{
						"n": 17,
						"h": 48,
						"w": 299
					},
					{
						"n": 20,
						"h": 274,
						"w": 235
					},
					{
						"n": 19,
						"h": 177,
						"w": 251
					}
				],
				"away": [
					{
						"n": 12,
						"h": 205,
						"w": 642
					},
					{
						"n": 13,
						"h": 402,
						"w": 457
					},
					{
						"n": 3,
						"h": 259,
						"w": 537
					},
					{
						"n": 14,
						"h": 184,
						"w": 532
					},
					{
						"n": 5,
						"h": 110,
						"w": 523
					},
					{
						"n": 16,
						"h": 205,
						"w": 437
					},
					{
						"n": 15,
						"h": 218,
						"w": 380
					},
					{
						"n": 18,
						"h": 48,
						"w": 389
					},
					{
						"n": 17,
						"h": 410,
						"w": 346
					},
					{
						"n": 19,
						"h": 294,
						"w": 335
					},
					{
						"n": 20,
						"h": 140,
						"w": 320
					}
				],
				"ball": {
					"n": 0,
					"h": 355,
					"w": 483,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1752,
			"minute": 84,
			"messages": [
				{
					"owner": 1,
					"mes": "Пас направо..."
				},
				{
					"owner": 1,
					"mes": "Билли Реган[13](Галвэй Юнайтед) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 708
					},
					{
						"n": 2,
						"h": 361,
						"w": 475
					},
					{
						"n": 14,
						"h": 284,
						"w": 492
					},
					{
						"n": 13,
						"h": 181,
						"w": 456
					},
					{
						"n": 5,
						"h": 71,
						"w": 436
					},
					{
						"n": 6,
						"h": 404,
						"w": 304
					},
					{
						"n": 18,
						"h": 279,
						"w": 405
					},
					{
						"n": 15,
						"h": 173,
						"w": 285
					},
					{
						"n": 17,
						"h": 55,
						"w": 239
					},
					{
						"n": 20,
						"h": 293,
						"w": 210
					},
					{
						"n": 19,
						"h": 168,
						"w": 221
					}
				],
				"away": [
					{
						"n": 12,
						"h": 225,
						"w": 641
					},
					{
						"n": 13,
						"h": 395,
						"w": 517
					},
					{
						"n": 3,
						"h": 272,
						"w": 567
					},
					{
						"n": 14,
						"h": 171,
						"w": 568
					},
					{
						"n": 5,
						"h": 110,
						"w": 579
					},
					{
						"n": 16,
						"h": 230,
						"w": 493
					},
					{
						"n": 15,
						"h": 226,
						"w": 435
					},
					{
						"n": 18,
						"h": 46,
						"w": 450
					},
					{
						"n": 17,
						"h": 414,
						"w": 407
					},
					{
						"n": 19,
						"h": 284,
						"w": 394
					},
					{
						"n": 20,
						"h": 171,
						"w": 335
					}
				],
				"ball": {
					"n": 0,
					"h": 181,
					"w": 456,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 61
		},
		{
			"num": 1753,
			"minute": 84,
			"messages": [
				{
					"owner": 1,
					"mes": "Билли Реган[13](Галвэй Юнайтед) не смог обработать мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 709
					},
					{
						"n": 2,
						"h": 362,
						"w": 468
					},
					{
						"n": 14,
						"h": 277,
						"w": 491
					},
					{
						"n": 13,
						"h": 181,
						"w": 456
					},
					{
						"n": 5,
						"h": 71,
						"w": 429
					},
					{
						"n": 6,
						"h": 403,
						"w": 297
					},
					{
						"n": 18,
						"h": 281,
						"w": 398
					},
					{
						"n": 15,
						"h": 168,
						"w": 280
					},
					{
						"n": 17,
						"h": 53,
						"w": 232
					},
					{
						"n": 20,
						"h": 293,
						"w": 203
					},
					{
						"n": 19,
						"h": 169,
						"w": 214
					}
				],
				"away": [
					{
						"n": 12,
						"h": 221,
						"w": 643
					},
					{
						"n": 13,
						"h": 397,
						"w": 524
					},
					{
						"n": 3,
						"h": 268,
						"w": 573
					},
					{
						"n": 14,
						"h": 172,
						"w": 575
					},
					{
						"n": 5,
						"h": 110,
						"w": 586
					},
					{
						"n": 16,
						"h": 226,
						"w": 498
					},
					{
						"n": 15,
						"h": 221,
						"w": 430
					},
					{
						"n": 18,
						"h": 46,
						"w": 457
					},
					{
						"n": 17,
						"h": 414,
						"w": 414
					},
					{
						"n": 19,
						"h": 291,
						"w": 394
					},
					{
						"n": 20,
						"h": 176,
						"w": 330
					}
				],
				"ball": {
					"n": 0,
					"h": 201,
					"w": 476,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 7
		},
		{
			"num": 1754,
			"minute": 84,
			"messages": [
				{
					"owner": 1,
					"mes": "Билли Реган[13](Галвэй Юнайтед) сам подхватывает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 701
					},
					{
						"n": 2,
						"h": 369,
						"w": 441
					},
					{
						"n": 14,
						"h": 250,
						"w": 486
					},
					{
						"n": 13,
						"h": 201,
						"w": 476
					},
					{
						"n": 5,
						"h": 70,
						"w": 401
					},
					{
						"n": 6,
						"h": 403,
						"w": 269
					},
					{
						"n": 18,
						"h": 277,
						"w": 370
					},
					{
						"n": 15,
						"h": 152,
						"w": 257
					},
					{
						"n": 17,
						"h": 56,
						"w": 204
					},
					{
						"n": 20,
						"h": 284,
						"w": 177
					},
					{
						"n": 19,
						"h": 173,
						"w": 186
					}
				],
				"away": [
					{
						"n": 12,
						"h": 227,
						"w": 644
					},
					{
						"n": 13,
						"h": 394,
						"w": 552
					},
					{
						"n": 3,
						"h": 265,
						"w": 592
					},
					{
						"n": 14,
						"h": 178,
						"w": 603
					},
					{
						"n": 5,
						"h": 110,
						"w": 599
					},
					{
						"n": 16,
						"h": 228,
						"w": 526
					},
					{
						"n": 15,
						"h": 223,
						"w": 458
					},
					{
						"n": 18,
						"h": 47,
						"w": 485
					},
					{
						"n": 17,
						"h": 425,
						"w": 440
					},
					{
						"n": 19,
						"h": 287,
						"w": 407
					},
					{
						"n": 20,
						"h": 194,
						"w": 308
					}
				],
				"ball": {
					"n": 0,
					"h": 201,
					"w": 476,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 28
		},
		{
			"num": 1755,
			"minute": 85,
			"possession": 43,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 708
					},
					{
						"n": 2,
						"h": 379,
						"w": 402,
						"f": 76
					},
					{
						"n": 14,
						"h": 280,
						"w": 456,
						"f": 94
					},
					{
						"n": 13,
						"h": 192,
						"w": 442
					},
					{
						"n": 5,
						"h": 76,
						"w": 392,
						"f": 76
					},
					{
						"n": 6,
						"h": 399,
						"w": 229
					},
					{
						"n": 18,
						"h": 286,
						"w": 343
					},
					{
						"n": 15,
						"h": 139,
						"w": 261,
						"f": 91
					},
					{
						"n": 17,
						"h": 38,
						"w": 168
					},
					{
						"n": 20,
						"h": 273,
						"w": 146,
						"f": 82
					},
					{
						"n": 19,
						"h": 154,
						"w": 155,
						"f": 89,
						"c": 1
					}
				],
				"away": [
					{
						"n": 12,
						"h": 226,
						"w": 645
					},
					{
						"n": 13,
						"h": 396,
						"w": 585
					},
					{
						"n": 3,
						"h": 286,
						"w": 609
					},
					{
						"n": 14,
						"h": 191,
						"w": 614,
						"f": 85
					},
					{
						"n": 5,
						"h": 110,
						"w": 598
					},
					{
						"n": 16,
						"h": 221,
						"w": 515
					},
					{
						"n": 15,
						"h": 234,
						"w": 445
					},
					{
						"n": 18,
						"h": 51,
						"w": 524,
						"f": 91
					},
					{
						"n": 17,
						"h": 429,
						"w": 450
					},
					{
						"n": 19,
						"h": 277,
						"w": 412,
						"f": 89,
						"m": 650,
						"c": 1
					},
					{
						"n": 20,
						"h": 233,
						"w": 302,
						"m": 650
					}
				],
				"ball": {
					"n": 0,
					"h": 192,
					"w": 442,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1756,
			"minute": 85,
			"messages": [
				{
					"owner": 1,
					"mes": "Билли Реган[13](Галвэй Юнайтед) пасует на К.Келли[15](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 710
					},
					{
						"n": 2,
						"h": 386,
						"w": 375
					},
					{
						"n": 14,
						"h": 276,
						"w": 428
					},
					{
						"n": 13,
						"h": 185,
						"w": 436,
						"m": 630
					},
					{
						"n": 5,
						"h": 77,
						"w": 381
					},
					{
						"n": 6,
						"h": 398,
						"w": 201
					},
					{
						"n": 18,
						"h": 288,
						"w": 315
					},
					{
						"n": 15,
						"h": 149,
						"w": 288,
						"m": 650
					},
					{
						"n": 17,
						"h": 36,
						"w": 147
					},
					{
						"n": 20,
						"h": 296,
						"w": 137
					},
					{
						"n": 19,
						"h": 151,
						"w": 127
					}
				],
				"away": [
					{
						"n": 12,
						"h": 235,
						"w": 643
					},
					{
						"n": 13,
						"h": 398,
						"w": 598
					},
					{
						"n": 3,
						"h": 268,
						"w": 610
					},
					{
						"n": 14,
						"h": 184,
						"w": 629
					},
					{
						"n": 5,
						"h": 138,
						"w": 601
					},
					{
						"n": 16,
						"h": 235,
						"w": 538
					},
					{
						"n": 15,
						"h": 262,
						"w": 449
					},
					{
						"n": 18,
						"h": 52,
						"w": 552
					},
					{
						"n": 17,
						"h": 412,
						"w": 463
					},
					{
						"n": 19,
						"h": 283,
						"w": 385
					},
					{
						"n": 20,
						"h": 219,
						"w": 326
					}
				],
				"ball": {
					"n": 0,
					"h": 167,
					"w": 335,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 28
		},
		{
			"num": 1757,
			"minute": 85,
			"messages": [
				{
					"owner": 1,
					"mes": "Александр Фрешль[39](Опава) неплохо выбирает позицию и перехватывает мяч!..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 704
					},
					{
						"n": 2,
						"h": 373,
						"w": 413
					},
					{
						"n": 14,
						"h": 254,
						"w": 427
					},
					{
						"n": 13,
						"h": 205,
						"w": 439
					},
					{
						"n": 5,
						"h": 95,
						"w": 417
					},
					{
						"n": 6,
						"h": 396,
						"w": 241
					},
					{
						"n": 18,
						"h": 267,
						"w": 344
					},
					{
						"n": 15,
						"h": 171,
						"w": 321
					},
					{
						"n": 17,
						"h": 37,
						"w": 187
					},
					{
						"n": 20,
						"h": 293,
						"w": 177
					},
					{
						"n": 19,
						"h": 170,
						"w": 162
					}
				],
				"away": [
					{
						"n": 12,
						"h": 230,
						"w": 683
					},
					{
						"n": 13,
						"h": 403,
						"w": 558
					},
					{
						"n": 3,
						"h": 277,
						"w": 610
					},
					{
						"n": 14,
						"h": 173,
						"w": 629
					},
					{
						"n": 5,
						"h": 98,
						"w": 600
					},
					{
						"n": 16,
						"h": 235,
						"w": 498
					},
					{
						"n": 15,
						"h": 234,
						"w": 420
					},
					{
						"n": 18,
						"h": 49,
						"w": 512
					},
					{
						"n": 17,
						"h": 414,
						"w": 423
					},
					{
						"n": 19,
						"h": 259,
						"w": 360,
						"m": 660
					},
					{
						"n": 20,
						"h": 179,
						"w": 322
					}
				],
				"ball": {
					"n": 0,
					"h": 191,
					"w": 360,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1758,
			"minute": 85,
			"messages": [
				{
					"owner": 2,
					"mes": "Александр Фрешль[39](Опава) посылает мяч налево в направлении М.Томасова[37](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 705
					},
					{
						"n": 2,
						"h": 338,
						"w": 457
					},
					{
						"n": 14,
						"h": 290,
						"w": 464
					},
					{
						"n": 13,
						"h": 196,
						"w": 473
					},
					{
						"n": 5,
						"h": 120,
						"w": 458
					},
					{
						"n": 6,
						"h": 397,
						"w": 297
					},
					{
						"n": 18,
						"h": 245,
						"w": 384
					},
					{
						"n": 15,
						"h": 115,
						"w": 319
					},
					{
						"n": 17,
						"h": 41,
						"w": 243
					},
					{
						"n": 20,
						"h": 290,
						"w": 233
					},
					{
						"n": 19,
						"h": 168,
						"w": 218
					}
				],
				"away": [
					{
						"n": 12,
						"h": 223,
						"w": 703
					},
					{
						"n": 13,
						"h": 398,
						"w": 503
					},
					{
						"n": 3,
						"h": 273,
						"w": 616
					},
					{
						"n": 14,
						"h": 168,
						"w": 586
					},
					{
						"n": 5,
						"h": 68,
						"w": 600
					},
					{
						"n": 16,
						"h": 267,
						"w": 452
					},
					{
						"n": 15,
						"h": 224,
						"w": 394
					},
					{
						"n": 18,
						"h": 40,
						"w": 457
					},
					{
						"n": 17,
						"h": 358,
						"w": 422
					},
					{
						"n": 19,
						"h": 264,
						"w": 352
					},
					{
						"n": 20,
						"h": 147,
						"w": 277
					}
				],
				"ball": {
					"n": 0,
					"h": 92,
					"w": 298,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 56
		},
		{
			"num": 1759,
			"minute": 85,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 707
					},
					{
						"n": 2,
						"h": 331,
						"w": 496
					},
					{
						"n": 14,
						"h": 290,
						"w": 504
					},
					{
						"n": 13,
						"h": 187,
						"w": 494
					},
					{
						"n": 5,
						"h": 97,
						"w": 488
					},
					{
						"n": 6,
						"h": 402,
						"w": 337
					},
					{
						"n": 18,
						"h": 236,
						"w": 415
					},
					{
						"n": 15,
						"h": 83,
						"w": 340
					},
					{
						"n": 17,
						"h": 47,
						"w": 282
					},
					{
						"n": 20,
						"h": 291,
						"w": 273
					},
					{
						"n": 19,
						"h": 190,
						"w": 251
					}
				],
				"away": [
					{
						"n": 12,
						"h": 224,
						"w": 706
					},
					{
						"n": 13,
						"h": 401,
						"w": 463
					},
					{
						"n": 3,
						"h": 278,
						"w": 577
					},
					{
						"n": 14,
						"h": 167,
						"w": 566
					},
					{
						"n": 5,
						"h": 61,
						"w": 567
					},
					{
						"n": 16,
						"h": 245,
						"w": 466
					},
					{
						"n": 15,
						"h": 229,
						"w": 354
					},
					{
						"n": 18,
						"h": 39,
						"w": 417
					},
					{
						"n": 17,
						"h": 369,
						"w": 398
					},
					{
						"n": 19,
						"h": 282,
						"w": 316
					},
					{
						"n": 20,
						"h": 145,
						"w": 238
					}
				],
				"ball": {
					"n": 0,
					"h": 81,
					"w": 322,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1760,
			"minute": 85,
			"messages": [
				{
					"owner": 2,
					"mes": "Передача назад..."
				},
				{
					"owner": 2,
					"mes": "Нир Мансур[23](Опава) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 707
					},
					{
						"n": 2,
						"h": 330,
						"w": 466
					},
					{
						"n": 14,
						"h": 267,
						"w": 467
					},
					{
						"n": 13,
						"h": 173,
						"w": 456
					},
					{
						"n": 5,
						"h": 120,
						"w": 462
					},
					{
						"n": 6,
						"h": 394,
						"w": 362
					},
					{
						"n": 18,
						"h": 226,
						"w": 397
					},
					{
						"n": 15,
						"h": 127,
						"w": 342
					},
					{
						"n": 17,
						"h": 54,
						"w": 303
					},
					{
						"n": 20,
						"h": 290,
						"w": 313
					},
					{
						"n": 19,
						"h": 153,
						"w": 275
					}
				],
				"away": [
					{
						"n": 12,
						"h": 230,
						"w": 685
					},
					{
						"n": 13,
						"h": 402,
						"w": 503
					},
					{
						"n": 3,
						"h": 305,
						"w": 560
					},
					{
						"n": 14,
						"h": 163,
						"w": 549
					},
					{
						"n": 5,
						"h": 75,
						"w": 543
					},
					{
						"n": 16,
						"h": 236,
						"w": 423
					},
					{
						"n": 15,
						"h": 222,
						"w": 329
					},
					{
						"n": 18,
						"h": 42,
						"w": 373
					},
					{
						"n": 17,
						"h": 373,
						"w": 389,
						"m": 660
					},
					{
						"n": 19,
						"h": 292,
						"w": 298
					},
					{
						"n": 20,
						"h": 174,
						"w": 271
					}
				],
				"ball": {
					"n": 0,
					"h": 145,
					"w": 160,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 44
		},
		{
			"num": 1761,
			"minute": 85,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 710
					},
					{
						"n": 2,
						"h": 330,
						"w": 460
					},
					{
						"n": 14,
						"h": 264,
						"w": 470
					},
					{
						"n": 13,
						"h": 177,
						"w": 460
					},
					{
						"n": 5,
						"h": 120,
						"w": 464
					},
					{
						"n": 6,
						"h": 394,
						"w": 402
					},
					{
						"n": 18,
						"h": 262,
						"w": 380
					},
					{
						"n": 15,
						"h": 167,
						"w": 344
					},
					{
						"n": 17,
						"h": 56,
						"w": 323
					},
					{
						"n": 20,
						"h": 283,
						"w": 310
					},
					{
						"n": 19,
						"h": 142,
						"w": 280
					}
				],
				"away": [
					{
						"n": 12,
						"h": 230,
						"w": 705
					},
					{
						"n": 13,
						"h": 408,
						"w": 463
					},
					{
						"n": 3,
						"h": 321,
						"w": 529
					},
					{
						"n": 14,
						"h": 173,
						"w": 588
					},
					{
						"n": 5,
						"h": 67,
						"w": 582
					},
					{
						"n": 16,
						"h": 236,
						"w": 441
					},
					{
						"n": 15,
						"h": 233,
						"w": 342
					},
					{
						"n": 18,
						"h": 50,
						"w": 334
					},
					{
						"n": 17,
						"h": 389,
						"w": 352
					},
					{
						"n": 19,
						"h": 287,
						"w": 288
					},
					{
						"n": 20,
						"h": 169,
						"w": 294
					}
				],
				"ball": {
					"n": 0,
					"h": 129,
					"w": 191,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1762,
			"minute": 85,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 701
					},
					{
						"n": 2,
						"h": 330,
						"w": 467
					},
					{
						"n": 14,
						"h": 291,
						"w": 476
					},
					{
						"n": 13,
						"h": 171,
						"w": 451
					},
					{
						"n": 5,
						"h": 120,
						"w": 474
					},
					{
						"n": 6,
						"h": 390,
						"w": 442
					},
					{
						"n": 18,
						"h": 244,
						"w": 403
					},
					{
						"n": 15,
						"h": 195,
						"w": 353
					},
					{
						"n": 17,
						"h": 56,
						"w": 343
					},
					{
						"n": 20,
						"h": 284,
						"w": 313
					},
					{
						"n": 19,
						"h": 134,
						"w": 246
					}
				],
				"away": [
					{
						"n": 12,
						"h": 230,
						"w": 705
					},
					{
						"n": 13,
						"h": 405,
						"w": 457
					},
					{
						"n": 3,
						"h": 316,
						"w": 494
					},
					{
						"n": 14,
						"h": 185,
						"w": 599
					},
					{
						"n": 5,
						"h": 57,
						"w": 590
					},
					{
						"n": 16,
						"h": 235,
						"w": 412
					},
					{
						"n": 15,
						"h": 214,
						"w": 307
					},
					{
						"n": 18,
						"h": 46,
						"w": 294
					},
					{
						"n": 17,
						"h": 397,
						"w": 313
					},
					{
						"n": 19,
						"h": 307,
						"w": 271
					},
					{
						"n": 20,
						"h": 149,
						"w": 271
					}
				],
				"ball": {
					"n": 0,
					"h": 134,
					"w": 226,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1763,
			"minute": 85,
			"messages": [
				{
					"owner": 2,
					"mes": "Нир Мансур[23](Опава) отдает пас В.Сланине[34](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 703
					},
					{
						"n": 2,
						"h": 330,
						"w": 467
					},
					{
						"n": 14,
						"h": 257,
						"w": 461
					},
					{
						"n": 13,
						"h": 165,
						"w": 445
					},
					{
						"n": 5,
						"h": 120,
						"w": 465
					},
					{
						"n": 6,
						"h": 376,
						"w": 445
					},
					{
						"n": 18,
						"h": 219,
						"w": 393
					},
					{
						"n": 15,
						"h": 179,
						"w": 359
					},
					{
						"n": 17,
						"h": 56,
						"w": 389
					},
					{
						"n": 20,
						"h": 275,
						"w": 290
					},
					{
						"n": 19,
						"h": 133,
						"w": 280
					}
				],
				"away": [
					{
						"n": 12,
						"h": 225,
						"w": 703
					},
					{
						"n": 13,
						"h": 401,
						"w": 460
					},
					{
						"n": 3,
						"h": 312,
						"w": 503,
						"m": 720
					},
					{
						"n": 14,
						"h": 205,
						"w": 576
					},
					{
						"n": 5,
						"h": 74,
						"w": 607
					},
					{
						"n": 16,
						"h": 211,
						"w": 404
					},
					{
						"n": 15,
						"h": 222,
						"w": 342
					},
					{
						"n": 18,
						"h": 59,
						"w": 300
					},
					{
						"n": 17,
						"h": 420,
						"w": 300
					},
					{
						"n": 19,
						"h": 296,
						"w": 281
					},
					{
						"n": 20,
						"h": 178,
						"w": 280
					}
				],
				"ball": {
					"n": 0,
					"h": 245,
					"w": 144,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 46
		},
		{
			"num": 1764,
			"minute": 85,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 704
					},
					{
						"n": 2,
						"h": 330,
						"w": 468
					},
					{
						"n": 14,
						"h": 267,
						"w": 468
					},
					{
						"n": 13,
						"h": 185,
						"w": 460
					},
					{
						"n": 5,
						"h": 120,
						"w": 465
					},
					{
						"n": 6,
						"h": 375,
						"w": 445
					},
					{
						"n": 18,
						"h": 255,
						"w": 375
					},
					{
						"n": 15,
						"h": 216,
						"w": 373
					},
					{
						"n": 17,
						"h": 59,
						"w": 429
					},
					{
						"n": 20,
						"h": 284,
						"w": 296
					},
					{
						"n": 19,
						"h": 172,
						"w": 290
					}
				],
				"away": [
					{
						"n": 12,
						"h": 229,
						"w": 706
					},
					{
						"n": 13,
						"h": 403,
						"w": 441
					},
					{
						"n": 3,
						"h": 295,
						"w": 539
					},
					{
						"n": 14,
						"h": 203,
						"w": 540
					},
					{
						"n": 5,
						"h": 70,
						"w": 557
					},
					{
						"n": 16,
						"h": 222,
						"w": 418
					},
					{
						"n": 15,
						"h": 233,
						"w": 330
					},
					{
						"n": 18,
						"h": 60,
						"w": 300
					},
					{
						"n": 17,
						"h": 405,
						"w": 300
					},
					{
						"n": 19,
						"h": 279,
						"w": 279
					},
					{
						"n": 20,
						"h": 171,
						"w": 293
					}
				],
				"ball": {
					"n": 0,
					"h": 247,
					"w": 180,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1765,
			"minute": 85,
			"messages": [
				{
					"owner": 2,
					"mes": "Пасует вперед..."
				},
				{
					"owner": 2,
					"mes": "Михаэль Владарж[36](Опава) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 706
					},
					{
						"n": 2,
						"h": 330,
						"w": 473
					},
					{
						"n": 14,
						"h": 262,
						"w": 461
					},
					{
						"n": 13,
						"h": 181,
						"w": 480
					},
					{
						"n": 5,
						"h": 120,
						"w": 470
					},
					{
						"n": 6,
						"h": 394,
						"w": 443
					},
					{
						"n": 18,
						"h": 250,
						"w": 391
					},
					{
						"n": 15,
						"h": 183,
						"w": 354
					},
					{
						"n": 17,
						"h": 66,
						"w": 453
					},
					{
						"n": 20,
						"h": 292,
						"w": 300
					},
					{
						"n": 19,
						"h": 207,
						"w": 311
					}
				],
				"away": [
					{
						"n": 12,
						"h": 226,
						"w": 709
					},
					{
						"n": 13,
						"h": 391,
						"w": 444
					},
					{
						"n": 3,
						"h": 288,
						"w": 580
					},
					{
						"n": 14,
						"h": 200,
						"w": 550
					},
					{
						"n": 5,
						"h": 65,
						"w": 577
					},
					{
						"n": 16,
						"h": 222,
						"w": 418
					},
					{
						"n": 15,
						"h": 204,
						"w": 359
					},
					{
						"n": 18,
						"h": 38,
						"w": 292
					},
					{
						"n": 17,
						"h": 399,
						"w": 292
					},
					{
						"n": 19,
						"h": 289,
						"w": 281
					},
					{
						"n": 20,
						"h": 169,
						"w": 281
					}
				],
				"ball": {
					"n": 0,
					"h": 228,
					"w": 302,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 41
		},
		{
			"num": 1766,
			"minute": 85,
			"messages": [
				{
					"owner": 2,
					"mes": "Михаэль Владарж[36](Опава) пасует назад..."
				},
				{
					"owner": 2,
					"mes": "Нир Мансур[23](Опава) принимает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 701
					},
					{
						"n": 2,
						"h": 330,
						"w": 458
					},
					{
						"n": 14,
						"h": 267,
						"w": 470
					},
					{
						"n": 13,
						"h": 183,
						"w": 453
					},
					{
						"n": 5,
						"h": 120,
						"w": 460
					},
					{
						"n": 6,
						"h": 394,
						"w": 393
					},
					{
						"n": 18,
						"h": 261,
						"w": 374
					},
					{
						"n": 15,
						"h": 224,
						"w": 382
					},
					{
						"n": 17,
						"h": 58,
						"w": 404
					},
					{
						"n": 20,
						"h": 282,
						"w": 290
					},
					{
						"n": 19,
						"h": 161,
						"w": 291
					}
				],
				"away": [
					{
						"n": 12,
						"h": 230,
						"w": 690
					},
					{
						"n": 13,
						"h": 404,
						"w": 492
					},
					{
						"n": 3,
						"h": 277,
						"w": 556
					},
					{
						"n": 14,
						"h": 153,
						"w": 567
					},
					{
						"n": 5,
						"h": 50,
						"w": 567
					},
					{
						"n": 16,
						"h": 231,
						"w": 422
					},
					{
						"n": 15,
						"h": 235,
						"w": 352
					},
					{
						"n": 18,
						"h": 36,
						"w": 342
					},
					{
						"n": 17,
						"h": 409,
						"w": 341
					},
					{
						"n": 19,
						"h": 285,
						"w": 280
					},
					{
						"n": 20,
						"h": 166,
						"w": 280
					}
				],
				"ball": {
					"n": 0,
					"h": 173,
					"w": 164,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 50
		},
		{
			"num": 1767,
			"minute": 85,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 707
					},
					{
						"n": 2,
						"h": 330,
						"w": 453
					},
					{
						"n": 14,
						"h": 273,
						"w": 468
					},
					{
						"n": 13,
						"h": 177,
						"w": 443
					},
					{
						"n": 5,
						"h": 120,
						"w": 464
					},
					{
						"n": 6,
						"h": 394,
						"w": 353
					},
					{
						"n": 18,
						"h": 240,
						"w": 374
					},
					{
						"n": 15,
						"h": 197,
						"w": 353
					},
					{
						"n": 17,
						"h": 56,
						"w": 386
					},
					{
						"n": 20,
						"h": 286,
						"w": 295
					},
					{
						"n": 19,
						"h": 160,
						"w": 299
					}
				],
				"away": [
					{
						"n": 12,
						"h": 225,
						"w": 669
					},
					{
						"n": 13,
						"h": 415,
						"w": 488
					},
					{
						"n": 3,
						"h": 264,
						"w": 524
					},
					{
						"n": 14,
						"h": 151,
						"w": 557
					},
					{
						"n": 5,
						"h": 47,
						"w": 557
					},
					{
						"n": 16,
						"h": 228,
						"w": 418
					},
					{
						"n": 15,
						"h": 217,
						"w": 349
					},
					{
						"n": 18,
						"h": 33,
						"w": 382
					},
					{
						"n": 17,
						"h": 409,
						"w": 349
					},
					{
						"n": 19,
						"h": 291,
						"w": 280
					},
					{
						"n": 20,
						"h": 165,
						"w": 280
					}
				],
				"ball": {
					"n": 0,
					"h": 186,
					"w": 196,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1768,
			"minute": 85,
			"messages": [
				{
					"owner": 2,
					"mes": "Нир Мансур[23](Опава) делает передачу налево на К.Удре[33](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 704
					},
					{
						"n": 2,
						"h": 330,
						"w": 454
					},
					{
						"n": 14,
						"h": 272,
						"w": 467
					},
					{
						"n": 13,
						"h": 182,
						"w": 479
					},
					{
						"n": 5,
						"h": 120,
						"w": 456
					},
					{
						"n": 6,
						"h": 396,
						"w": 360
					},
					{
						"n": 18,
						"h": 231,
						"w": 393
					},
					{
						"n": 15,
						"h": 173,
						"w": 362
					},
					{
						"n": 17,
						"h": 56,
						"w": 408
					},
					{
						"n": 20,
						"h": 286,
						"w": 306
					},
					{
						"n": 19,
						"h": 164,
						"w": 291
					}
				],
				"away": [
					{
						"n": 12,
						"h": 235,
						"w": 646
					},
					{
						"n": 13,
						"h": 393,
						"w": 501
					},
					{
						"n": 3,
						"h": 271,
						"w": 531
					},
					{
						"n": 14,
						"h": 148,
						"w": 547
					},
					{
						"n": 5,
						"h": 45,
						"w": 547
					},
					{
						"n": 16,
						"h": 228,
						"w": 414
					},
					{
						"n": 15,
						"h": 215,
						"w": 347
					},
					{
						"n": 18,
						"h": 46,
						"w": 414
					},
					{
						"n": 17,
						"h": 402,
						"w": 347
					},
					{
						"n": 19,
						"h": 288,
						"w": 280
					},
					{
						"n": 20,
						"h": 162,
						"w": 280
					}
				],
				"ball": {
					"n": 0,
					"h": 57,
					"w": 219,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 44
		},
		{
			"num": 1769,
			"minute": 85,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 701
					},
					{
						"n": 2,
						"h": 330,
						"w": 493
					},
					{
						"n": 14,
						"h": 277,
						"w": 504
					},
					{
						"n": 13,
						"h": 169,
						"w": 491
					},
					{
						"n": 5,
						"h": 120,
						"w": 496
					},
					{
						"n": 6,
						"h": 394,
						"w": 367
					},
					{
						"n": 18,
						"h": 232,
						"w": 425
					},
					{
						"n": 15,
						"h": 178,
						"w": 402
					},
					{
						"n": 17,
						"h": 56,
						"w": 422
					},
					{
						"n": 20,
						"h": 283,
						"w": 346
					},
					{
						"n": 19,
						"h": 157,
						"w": 330
					}
				],
				"away": [
					{
						"n": 12,
						"h": 235,
						"w": 627
					},
					{
						"n": 13,
						"h": 408,
						"w": 469
					},
					{
						"n": 3,
						"h": 301,
						"w": 537
					},
					{
						"n": 14,
						"h": 161,
						"w": 537
					},
					{
						"n": 5,
						"h": 40,
						"w": 537
					},
					{
						"n": 16,
						"h": 221,
						"w": 388
					},
					{
						"n": 15,
						"h": 219,
						"w": 314
					},
					{
						"n": 18,
						"h": 44,
						"w": 388
					},
					{
						"n": 17,
						"h": 408,
						"w": 314
					},
					{
						"n": 19,
						"h": 299,
						"w": 242
					},
					{
						"n": 20,
						"h": 161,
						"w": 240
					}
				],
				"ball": {
					"n": 0,
					"h": 42,
					"w": 251,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1770,
			"minute": 85,
			"messages": [
				{
					"owner": 2,
					"mes": "Кеннет Удре[33](Опава) посылает мяч направо в направлении Т.Крамаржа[32](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 707
					},
					{
						"n": 2,
						"h": 330,
						"w": 465
					},
					{
						"n": 14,
						"h": 270,
						"w": 459
					},
					{
						"n": 13,
						"h": 184,
						"w": 463
					},
					{
						"n": 5,
						"h": 120,
						"w": 452
					},
					{
						"n": 6,
						"h": 400,
						"w": 360
					},
					{
						"n": 18,
						"h": 239,
						"w": 394
					},
					{
						"n": 15,
						"h": 180,
						"w": 359
					},
					{
						"n": 17,
						"h": 56,
						"w": 393
					},
					{
						"n": 20,
						"h": 309,
						"w": 298
					},
					{
						"n": 19,
						"h": 159,
						"w": 305
					}
				],
				"away": [
					{
						"n": 12,
						"h": 249,
						"w": 614
					},
					{
						"n": 13,
						"h": 407,
						"w": 465
					},
					{
						"n": 3,
						"h": 293,
						"w": 527
					},
					{
						"n": 14,
						"h": 168,
						"w": 527
					},
					{
						"n": 5,
						"h": 41,
						"w": 527
					},
					{
						"n": 16,
						"h": 218,
						"w": 404
					},
					{
						"n": 15,
						"h": 220,
						"w": 342
					},
					{
						"n": 18,
						"h": 45,
						"w": 404
					},
					{
						"n": 17,
						"h": 412,
						"w": 342
					},
					{
						"n": 19,
						"h": 285,
						"w": 280
					},
					{
						"n": 20,
						"h": 164,
						"w": 280
					}
				],
				"ball": {
					"n": 0,
					"h": 201,
					"w": 106,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 54
		},
		{
			"num": 1771,
			"minute": 85,
			"messages": [
				{
					"owner": 2,
					"mes": "Найдя свободного Н.Мансура[23](Опава), Тим Крамарж[32](Опава) пасует вперед..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 709
					},
					{
						"n": 2,
						"h": 330,
						"w": 466
					},
					{
						"n": 14,
						"h": 268,
						"w": 457
					},
					{
						"n": 13,
						"h": 174,
						"w": 444
					},
					{
						"n": 5,
						"h": 120,
						"w": 452
					},
					{
						"n": 6,
						"h": 394,
						"w": 356
					},
					{
						"n": 18,
						"h": 236,
						"w": 398
					},
					{
						"n": 15,
						"h": 192,
						"w": 342
					},
					{
						"n": 17,
						"h": 56,
						"w": 414
					},
					{
						"n": 20,
						"h": 305,
						"w": 280
					},
					{
						"n": 19,
						"h": 167,
						"w": 286
					}
				],
				"away": [
					{
						"n": 12,
						"h": 239,
						"w": 613
					},
					{
						"n": 13,
						"h": 410,
						"w": 458
					},
					{
						"n": 3,
						"h": 275,
						"w": 538
					},
					{
						"n": 14,
						"h": 149,
						"w": 518
					},
					{
						"n": 5,
						"h": 49,
						"w": 517
					},
					{
						"n": 16,
						"h": 223,
						"w": 398
					},
					{
						"n": 15,
						"h": 216,
						"w": 339
					},
					{
						"n": 18,
						"h": 49,
						"w": 398
					},
					{
						"n": 17,
						"h": 406,
						"w": 339
					},
					{
						"n": 19,
						"h": 301,
						"w": 280
					},
					{
						"n": 20,
						"h": 166,
						"w": 280
					}
				],
				"ball": {
					"n": 0,
					"h": 214,
					"w": 146,
					"z": 0,
					"r": 0,
					"p": 2,
					"x": 0
				}
			},
			"interval": 21
		},
		{
			"num": 1772,
			"minute": 85,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 701
					},
					{
						"n": 2,
						"h": 330,
						"w": 463
					},
					{
						"n": 14,
						"h": 273,
						"w": 468
					},
					{
						"n": 13,
						"h": 180,
						"w": 442
					},
					{
						"n": 5,
						"h": 120,
						"w": 458
					},
					{
						"n": 6,
						"h": 390,
						"w": 360
					},
					{
						"n": 18,
						"h": 243,
						"w": 389
					},
					{
						"n": 15,
						"h": 193,
						"w": 339
					},
					{
						"n": 17,
						"h": 56,
						"w": 413
					},
					{
						"n": 20,
						"h": 294,
						"w": 285
					},
					{
						"n": 19,
						"h": 172,
						"w": 275
					}
				],
				"away": [
					{
						"n": 12,
						"h": 234,
						"w": 618
					},
					{
						"n": 13,
						"h": 403,
						"w": 466
					},
					{
						"n": 3,
						"h": 265,
						"w": 544
					},
					{
						"n": 14,
						"h": 158,
						"w": 525
					},
					{
						"n": 5,
						"h": 39,
						"w": 524
					},
					{
						"n": 16,
						"h": 218,
						"w": 404
					},
					{
						"n": 15,
						"h": 228,
						"w": 341
					},
					{
						"n": 18,
						"h": 49,
						"w": 404
					},
					{
						"n": 17,
						"h": 405,
						"w": 342
					},
					{
						"n": 19,
						"h": 289,
						"w": 280
					},
					{
						"n": 20,
						"h": 161,
						"w": 280
					}
				],
				"ball": {
					"n": 0,
					"h": 217,
					"w": 157,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 12
		},
		{
			"num": 1773,
			"minute": 85,
			"messages": [
				{
					"owner": 2,
					"mes": "Нир Мансур[23](Опава) получает передачу..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 710
					},
					{
						"n": 2,
						"h": 330,
						"w": 451
					},
					{
						"n": 14,
						"h": 272,
						"w": 469
					},
					{
						"n": 13,
						"h": 173,
						"w": 452
					},
					{
						"n": 5,
						"h": 120,
						"w": 455
					},
					{
						"n": 6,
						"h": 392,
						"w": 360
					},
					{
						"n": 18,
						"h": 259,
						"w": 368
					},
					{
						"n": 15,
						"h": 214,
						"w": 369
					},
					{
						"n": 17,
						"h": 56,
						"w": 387
					},
					{
						"n": 20,
						"h": 283,
						"w": 301
					},
					{
						"n": 19,
						"h": 186,
						"w": 240
					}
				],
				"away": [
					{
						"n": 12,
						"h": 225,
						"w": 627,
						"m": 620
					},
					{
						"n": 13,
						"h": 405,
						"w": 484
					},
					{
						"n": 3,
						"h": 233,
						"w": 563
					},
					{
						"n": 14,
						"h": 162,
						"w": 553
					},
					{
						"n": 5,
						"h": 48,
						"w": 553
					},
					{
						"n": 16,
						"h": 233,
						"w": 416
					},
					{
						"n": 15,
						"h": 227,
						"w": 348
					},
					{
						"n": 18,
						"h": 45,
						"w": 416
					},
					{
						"n": 17,
						"h": 419,
						"w": 348
					},
					{
						"n": 19,
						"h": 288,
						"w": 280
					},
					{
						"n": 20,
						"h": 162,
						"w": 280
					}
				],
				"ball": {
					"n": 0,
					"h": 217,
					"w": 157,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 37
		},
		{
			"num": 1774,
			"minute": 86,
			"possession": 42,
			"messages": [
				{
					"owner": 2,
					"mes": "Пас вперед..."
				},
				{
					"owner": 2,
					"mes": "Михаэль Владарж[36](Опава) сбрасывает мяч себе на ход..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 709
					},
					{
						"n": 2,
						"h": 330,
						"w": 471
					},
					{
						"n": 14,
						"h": 273,
						"w": 460
					},
					{
						"n": 13,
						"h": 181,
						"w": 454
					},
					{
						"n": 5,
						"h": 120,
						"w": 479
					},
					{
						"n": 6,
						"h": 394,
						"w": 388,
						"f": 74,
						"c": 4
					},
					{
						"n": 18,
						"h": 248,
						"w": 382
					},
					{
						"n": 15,
						"h": 189,
						"w": 370
					},
					{
						"n": 17,
						"h": 56,
						"w": 436,
						"f": 84,
						"c": 2
					},
					{
						"n": 20,
						"h": 237,
						"w": 317
					},
					{
						"n": 19,
						"h": 168,
						"w": 286
					}
				],
				"away": [
					{
						"n": 12,
						"h": 224,
						"w": 676,
						"f": 91
					},
					{
						"n": 13,
						"h": 398,
						"w": 452
					},
					{
						"n": 3,
						"h": 241,
						"w": 567,
						"f": 80
					},
					{
						"n": 14,
						"h": 178,
						"w": 599
					},
					{
						"n": 5,
						"h": 72,
						"w": 595,
						"f": 75
					},
					{
						"n": 16,
						"h": 233,
						"w": 416,
						"f": 91
					},
					{
						"n": 15,
						"h": 203,
						"w": 358,
						"f": 94
					},
					{
						"n": 18,
						"h": 49,
						"w": 367
					},
					{
						"n": 17,
						"h": 414,
						"w": 299
					},
					{
						"n": 19,
						"h": 280,
						"w": 274
					},
					{
						"n": 20,
						"h": 159,
						"w": 268
					}
				],
				"ball": {
					"n": 0,
					"h": 217,
					"w": 304,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 49
		},
		{
			"num": 1775,
			"minute": 86,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 706
					},
					{
						"n": 2,
						"h": 330,
						"w": 511
					},
					{
						"n": 14,
						"h": 275,
						"w": 500
					},
					{
						"n": 13,
						"h": 187,
						"w": 494
					},
					{
						"n": 5,
						"h": 80,
						"w": 480
					},
					{
						"n": 6,
						"h": 394,
						"w": 427
					},
					{
						"n": 18,
						"h": 232,
						"w": 419
					},
					{
						"n": 15,
						"h": 192,
						"w": 406
					},
					{
						"n": 17,
						"h": 58,
						"w": 404
					},
					{
						"n": 20,
						"h": 198,
						"w": 328
					},
					{
						"n": 19,
						"h": 165,
						"w": 326
					}
				],
				"away": [
					{
						"n": 12,
						"h": 225,
						"w": 659
					},
					{
						"n": 13,
						"h": 412,
						"w": 415
					},
					{
						"n": 3,
						"h": 261,
						"w": 564
					},
					{
						"n": 14,
						"h": 179,
						"w": 559
					},
					{
						"n": 5,
						"h": 70,
						"w": 560
					},
					{
						"n": 16,
						"h": 267,
						"w": 408
					},
					{
						"n": 15,
						"h": 223,
						"w": 345
					},
					{
						"n": 18,
						"h": 51,
						"w": 328
					},
					{
						"n": 17,
						"h": 407,
						"w": 260
					},
					{
						"n": 19,
						"h": 275,
						"w": 248
					},
					{
						"n": 20,
						"h": 155,
						"w": 236
					}
				],
				"ball": {
					"n": 0,
					"h": 183,
					"w": 312,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1776,
			"minute": 86,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 709
					},
					{
						"n": 2,
						"h": 330,
						"w": 534
					},
					{
						"n": 14,
						"h": 272,
						"w": 521
					},
					{
						"n": 13,
						"h": 185,
						"w": 516
					},
					{
						"n": 5,
						"h": 67,
						"w": 499
					},
					{
						"n": 6,
						"h": 394,
						"w": 450
					},
					{
						"n": 18,
						"h": 249,
						"w": 433
					},
					{
						"n": 15,
						"h": 183,
						"w": 419
					},
					{
						"n": 17,
						"h": 56,
						"w": 406
					},
					{
						"n": 20,
						"h": 219,
						"w": 337
					},
					{
						"n": 19,
						"h": 165,
						"w": 322
					}
				],
				"away": [
					{
						"n": 12,
						"h": 226,
						"w": 636
					},
					{
						"n": 13,
						"h": 416,
						"w": 394
					},
					{
						"n": 3,
						"h": 276,
						"w": 547
					},
					{
						"n": 14,
						"h": 173,
						"w": 537
					},
					{
						"n": 5,
						"h": 75,
						"w": 538
					},
					{
						"n": 16,
						"h": 285,
						"w": 418
					},
					{
						"n": 15,
						"h": 234,
						"w": 324
					},
					{
						"n": 18,
						"h": 53,
						"w": 305
					},
					{
						"n": 17,
						"h": 415,
						"w": 238
					},
					{
						"n": 19,
						"h": 288,
						"w": 230
					},
					{
						"n": 20,
						"h": 166,
						"w": 216
					}
				],
				"ball": {
					"n": 0,
					"h": 165,
					"w": 302,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 23
		},
		{
			"num": 1777,
			"minute": 86,
			"messages": [
				{
					"owner": 2,
					"mes": "Передача А.Карабецу[35](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 710
					},
					{
						"n": 2,
						"h": 330,
						"w": 536
					},
					{
						"n": 14,
						"h": 267,
						"w": 546
					},
					{
						"n": 13,
						"h": 164,
						"w": 545
					},
					{
						"n": 5,
						"h": 79,
						"w": 503
					},
					{
						"n": 6,
						"h": 394,
						"w": 485
					},
					{
						"n": 18,
						"h": 264,
						"w": 465
					},
					{
						"n": 15,
						"h": 213,
						"w": 401
					},
					{
						"n": 17,
						"h": 53,
						"w": 421
					},
					{
						"n": 20,
						"h": 246,
						"w": 359
					},
					{
						"n": 19,
						"h": 169,
						"w": 332
					}
				],
				"away": [
					{
						"n": 12,
						"h": 229,
						"w": 621
					},
					{
						"n": 13,
						"h": 413,
						"w": 359
					},
					{
						"n": 3,
						"h": 273,
						"w": 516
					},
					{
						"n": 14,
						"h": 170,
						"w": 514
					},
					{
						"n": 5,
						"h": 63,
						"w": 508
					},
					{
						"n": 16,
						"h": 281,
						"w": 408,
						"m": 630
					},
					{
						"n": 15,
						"h": 234,
						"w": 324
					},
					{
						"n": 18,
						"h": 56,
						"w": 270
					},
					{
						"n": 17,
						"h": 380,
						"w": 237
					},
					{
						"n": 19,
						"h": 297,
						"w": 206
					},
					{
						"n": 20,
						"h": 172,
						"w": 202
					}
				],
				"ball": {
					"n": 0,
					"h": 216,
					"w": 396,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 35
		},
		{
			"num": 1778,
			"minute": 86,
			"messages": [
				{
					"owner": 2,
					"mes": "Адам Карабец[35](Опава) смотрит налево... Пас К.Удре[33](Опава)..."
				},
				{
					"owner": 2,
					"mes": "Маттиас Раум[17](Галвэй Юнайтед) в подкате дотягивается до мяча и прерывает передачу!..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 710
					},
					{
						"n": 2,
						"h": 330,
						"w": 560
					},
					{
						"n": 14,
						"h": 288,
						"w": 563
					},
					{
						"n": 13,
						"h": 184,
						"w": 558
					},
					{
						"n": 5,
						"h": 83,
						"w": 543
					},
					{
						"n": 6,
						"h": 394,
						"w": 526
					},
					{
						"n": 18,
						"h": 250,
						"w": 494
					},
					{
						"n": 15,
						"h": 184,
						"w": 430
					},
					{
						"n": 17,
						"h": 93,
						"w": 411
					},
					{
						"n": 20,
						"h": 274,
						"w": 390
					},
					{
						"n": 19,
						"h": 188,
						"w": 368
					}
				],
				"away": [
					{
						"n": 12,
						"h": 227,
						"w": 614
					},
					{
						"n": 13,
						"h": 386,
						"w": 335
					},
					{
						"n": 3,
						"h": 272,
						"w": 495
					},
					{
						"n": 14,
						"h": 173,
						"w": 500
					},
					{
						"n": 5,
						"h": 72,
						"w": 486
					},
					{
						"n": 16,
						"h": 262,
						"w": 372
					},
					{
						"n": 15,
						"h": 236,
						"w": 314,
						"m": 570
					},
					{
						"n": 18,
						"h": 56,
						"w": 229
					},
					{
						"n": 17,
						"h": 339,
						"w": 229
					},
					{
						"n": 19,
						"h": 285,
						"w": 190
					},
					{
						"n": 20,
						"h": 150,
						"w": 186
					}
				],
				"ball": {
					"n": 0,
					"h": 93,
					"w": 411,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 41
		},
		{
			"num": 1779,
			"minute": 86,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 709
					},
					{
						"n": 2,
						"h": 344,
						"w": 539
					},
					{
						"n": 14,
						"h": 285,
						"w": 536
					},
					{
						"n": 13,
						"h": 188,
						"w": 518
					},
					{
						"n": 5,
						"h": 77,
						"w": 504
					},
					{
						"n": 6,
						"h": 392,
						"w": 486
					},
					{
						"n": 18,
						"h": 281,
						"w": 469
					},
					{
						"n": 15,
						"h": 182,
						"w": 390
					},
					{
						"n": 17,
						"h": 118,
						"w": 386,
						"m": 740
					},
					{
						"n": 20,
						"h": 283,
						"w": 351
					},
					{
						"n": 19,
						"h": 174,
						"w": 331
					}
				],
				"away": [
					{
						"n": 12,
						"h": 245,
						"w": 645
					},
					{
						"n": 13,
						"h": 396,
						"w": 374
					},
					{
						"n": 3,
						"h": 256,
						"w": 509
					},
					{
						"n": 14,
						"h": 179,
						"w": 496
					},
					{
						"n": 5,
						"h": 110,
						"w": 500
					},
					{
						"n": 16,
						"h": 301,
						"w": 360
					},
					{
						"n": 15,
						"h": 228,
						"w": 353
					},
					{
						"n": 18,
						"h": 53,
						"w": 269
					},
					{
						"n": 17,
						"h": 311,
						"w": 257
					},
					{
						"n": 19,
						"h": 262,
						"w": 222
					},
					{
						"n": 20,
						"h": 159,
						"w": 225
					}
				],
				"ball": {
					"n": 0,
					"h": 118,
					"w": 386,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1780,
			"minute": 86,
			"messages": [
				{
					"owner": 1,
					"mes": "Маттиас Раум[17](Галвэй Юнайтед) смотрит направо... Пас С.Фридйонссону[05](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 703
					},
					{
						"n": 2,
						"h": 362,
						"w": 510
					},
					{
						"n": 14,
						"h": 271,
						"w": 526
					},
					{
						"n": 13,
						"h": 174,
						"w": 515
					},
					{
						"n": 5,
						"h": 100,
						"w": 487
					},
					{
						"n": 6,
						"h": 397,
						"w": 453
					},
					{
						"n": 18,
						"h": 284,
						"w": 435
					},
					{
						"n": 15,
						"h": 167,
						"w": 360
					},
					{
						"n": 17,
						"h": 110,
						"w": 381,
						"m": 750
					},
					{
						"n": 20,
						"h": 286,
						"w": 317
					},
					{
						"n": 19,
						"h": 167,
						"w": 297
					}
				],
				"away": [
					{
						"n": 12,
						"h": 245,
						"w": 641
					},
					{
						"n": 13,
						"h": 404,
						"w": 407
					},
					{
						"n": 3,
						"h": 265,
						"w": 515
					},
					{
						"n": 14,
						"h": 176,
						"w": 490
					},
					{
						"n": 5,
						"h": 110,
						"w": 514
					},
					{
						"n": 16,
						"h": 309,
						"w": 327
					},
					{
						"n": 15,
						"h": 216,
						"w": 365
					},
					{
						"n": 18,
						"h": 45,
						"w": 302
					},
					{
						"n": 17,
						"h": 340,
						"w": 239
					},
					{
						"n": 19,
						"h": 278,
						"w": 252
					},
					{
						"n": 20,
						"h": 148,
						"w": 258
					}
				],
				"ball": {
					"n": 0,
					"h": 100,
					"w": 487,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 34
		},
		{
			"num": 1781,
			"minute": 86,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 703
					},
					{
						"n": 2,
						"h": 380,
						"w": 475
					},
					{
						"n": 14,
						"h": 272,
						"w": 510
					},
					{
						"n": 13,
						"h": 171,
						"w": 523
					},
					{
						"n": 5,
						"h": 75,
						"w": 462
					},
					{
						"n": 6,
						"h": 396,
						"w": 413
					},
					{
						"n": 18,
						"h": 259,
						"w": 412
					},
					{
						"n": 15,
						"h": 141,
						"w": 340
					},
					{
						"n": 17,
						"h": 83,
						"w": 352
					},
					{
						"n": 20,
						"h": 292,
						"w": 278
					},
					{
						"n": 19,
						"h": 164,
						"w": 257
					}
				],
				"away": [
					{
						"n": 12,
						"h": 245,
						"w": 642
					},
					{
						"n": 13,
						"h": 422,
						"w": 442
					},
					{
						"n": 3,
						"h": 272,
						"w": 515
					},
					{
						"n": 14,
						"h": 169,
						"w": 506
					},
					{
						"n": 5,
						"h": 110,
						"w": 516
					},
					{
						"n": 16,
						"h": 323,
						"w": 290
					},
					{
						"n": 15,
						"h": 234,
						"w": 367
					},
					{
						"n": 18,
						"h": 43,
						"w": 342
					},
					{
						"n": 17,
						"h": 347,
						"w": 279
					},
					{
						"n": 19,
						"h": 280,
						"w": 292
					},
					{
						"n": 20,
						"h": 169,
						"w": 292
					}
				],
				"ball": {
					"n": 0,
					"h": 75,
					"w": 462,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1782,
			"minute": 86,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 707
					},
					{
						"n": 2,
						"h": 379,
						"w": 462
					},
					{
						"n": 14,
						"h": 271,
						"w": 524
					},
					{
						"n": 13,
						"h": 169,
						"w": 509
					},
					{
						"n": 5,
						"h": 59,
						"w": 431
					},
					{
						"n": 6,
						"h": 403,
						"w": 373
					},
					{
						"n": 18,
						"h": 252,
						"w": 417
					},
					{
						"n": 15,
						"h": 162,
						"w": 325
					},
					{
						"n": 17,
						"h": 70,
						"w": 314
					},
					{
						"n": 20,
						"h": 302,
						"w": 239
					},
					{
						"n": 19,
						"h": 141,
						"w": 230
					}
				],
				"away": [
					{
						"n": 12,
						"h": 245,
						"w": 644
					},
					{
						"n": 13,
						"h": 410,
						"w": 466
					},
					{
						"n": 3,
						"h": 291,
						"w": 519
					},
					{
						"n": 14,
						"h": 173,
						"w": 503
					},
					{
						"n": 5,
						"h": 110,
						"w": 513
					},
					{
						"n": 16,
						"h": 305,
						"w": 326
					},
					{
						"n": 15,
						"h": 216,
						"w": 373
					},
					{
						"n": 18,
						"h": 47,
						"w": 381
					},
					{
						"n": 17,
						"h": 354,
						"w": 318
					},
					{
						"n": 19,
						"h": 281,
						"w": 328
					},
					{
						"n": 20,
						"h": 196,
						"w": 321
					}
				],
				"ball": {
					"n": 0,
					"h": 59,
					"w": 431,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1783,
			"minute": 86,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 702
					},
					{
						"n": 2,
						"h": 379,
						"w": 460
					},
					{
						"n": 14,
						"h": 271,
						"w": 512
					},
					{
						"n": 13,
						"h": 182,
						"w": 512
					},
					{
						"n": 5,
						"h": 63,
						"w": 392
					},
					{
						"n": 6,
						"h": 407,
						"w": 333
					},
					{
						"n": 18,
						"h": 245,
						"w": 419
					},
					{
						"n": 15,
						"h": 130,
						"w": 325
					},
					{
						"n": 17,
						"h": 67,
						"w": 274
					},
					{
						"n": 20,
						"h": 283,
						"w": 233
					},
					{
						"n": 19,
						"h": 156,
						"w": 220
					}
				],
				"away": [
					{
						"n": 12,
						"h": 245,
						"w": 644
					},
					{
						"n": 13,
						"h": 383,
						"w": 482
					},
					{
						"n": 3,
						"h": 283,
						"w": 524
					},
					{
						"n": 14,
						"h": 179,
						"w": 533
					},
					{
						"n": 5,
						"h": 110,
						"w": 517
					},
					{
						"n": 16,
						"h": 283,
						"w": 359
					},
					{
						"n": 15,
						"h": 231,
						"w": 377
					},
					{
						"n": 18,
						"h": 44,
						"w": 421
					},
					{
						"n": 17,
						"h": 378,
						"w": 344
					},
					{
						"n": 19,
						"h": 278,
						"w": 334
					},
					{
						"n": 20,
						"h": 205,
						"w": 321
					}
				],
				"ball": {
					"n": 0,
					"h": 63,
					"w": 392,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1784,
			"minute": 86,
			"messages": [
				{
					"owner": 1,
					"mes": "Пас в центр Т.Дэвлину[20](Галвэй Юнайтед)..."
				},
				{
					"owner": 1,
					"mes": "Том Дэвлин[20](Галвэй Юнайтед) останавливает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 706
					},
					{
						"n": 2,
						"h": 377,
						"w": 451
					},
					{
						"n": 14,
						"h": 282,
						"w": 501
					},
					{
						"n": 13,
						"h": 177,
						"w": 502
					},
					{
						"n": 5,
						"h": 65,
						"w": 402
					},
					{
						"n": 6,
						"h": 402,
						"w": 280
					},
					{
						"n": 18,
						"h": 266,
						"w": 369
					},
					{
						"n": 15,
						"h": 169,
						"w": 288
					},
					{
						"n": 17,
						"h": 45,
						"w": 227
					},
					{
						"n": 20,
						"h": 239,
						"w": 265
					},
					{
						"n": 19,
						"h": 170,
						"w": 213
					}
				],
				"away": [
					{
						"n": 12,
						"h": 229,
						"w": 648
					},
					{
						"n": 13,
						"h": 405,
						"w": 529
					},
					{
						"n": 3,
						"h": 252,
						"w": 568
					},
					{
						"n": 14,
						"h": 206,
						"w": 486
					},
					{
						"n": 5,
						"h": 110,
						"w": 570
					},
					{
						"n": 16,
						"h": 260,
						"w": 408
					},
					{
						"n": 15,
						"h": 226,
						"w": 427
					},
					{
						"n": 18,
						"h": 48,
						"w": 475
					},
					{
						"n": 17,
						"h": 406,
						"w": 390
					},
					{
						"n": 19,
						"h": 278,
						"w": 373
					},
					{
						"n": 20,
						"h": 184,
						"w": 371
					}
				],
				"ball": {
					"n": 0,
					"h": 239,
					"w": 265,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 54
		},
		{
			"num": 1785,
			"minute": 86,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 706
					},
					{
						"n": 2,
						"h": 386,
						"w": 425
					},
					{
						"n": 14,
						"h": 280,
						"w": 466
					},
					{
						"n": 13,
						"h": 184,
						"w": 465
					},
					{
						"n": 5,
						"h": 67,
						"w": 410
					},
					{
						"n": 6,
						"h": 397,
						"w": 242
					},
					{
						"n": 18,
						"h": 272,
						"w": 381
					},
					{
						"n": 15,
						"h": 175,
						"w": 251
					},
					{
						"n": 17,
						"h": 37,
						"w": 190
					},
					{
						"n": 20,
						"h": 257,
						"w": 234
					},
					{
						"n": 19,
						"h": 173,
						"w": 178
					}
				],
				"away": [
					{
						"n": 12,
						"h": 229,
						"w": 643
					},
					{
						"n": 13,
						"h": 406,
						"w": 566
					},
					{
						"n": 3,
						"h": 249,
						"w": 586
					},
					{
						"n": 14,
						"h": 195,
						"w": 506
					},
					{
						"n": 5,
						"h": 110,
						"w": 596
					},
					{
						"n": 16,
						"h": 249,
						"w": 444
					},
					{
						"n": 15,
						"h": 227,
						"w": 450
					},
					{
						"n": 18,
						"h": 53,
						"w": 513
					},
					{
						"n": 17,
						"h": 414,
						"w": 427
					},
					{
						"n": 19,
						"h": 277,
						"w": 394
					},
					{
						"n": 20,
						"h": 178,
						"w": 359
					}
				],
				"ball": {
					"n": 0,
					"h": 257,
					"w": 234,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 38
		},
		{
			"num": 1786,
			"minute": 86,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 704
					},
					{
						"n": 2,
						"h": 388,
						"w": 396
					},
					{
						"n": 14,
						"h": 279,
						"w": 444
					},
					{
						"n": 13,
						"h": 171,
						"w": 426
					},
					{
						"n": 5,
						"h": 76,
						"w": 386
					},
					{
						"n": 6,
						"h": 406,
						"w": 203
					},
					{
						"n": 18,
						"h": 266,
						"w": 341
					},
					{
						"n": 15,
						"h": 158,
						"w": 215
					},
					{
						"n": 17,
						"h": 35,
						"w": 164
					},
					{
						"n": 20,
						"h": 220,
						"w": 242
					},
					{
						"n": 19,
						"h": 156,
						"w": 154
					}
				],
				"away": [
					{
						"n": 12,
						"h": 227,
						"w": 645
					},
					{
						"n": 13,
						"h": 406,
						"w": 592
					},
					{
						"n": 3,
						"h": 248,
						"w": 621
					},
					{
						"n": 14,
						"h": 229,
						"w": 498
					},
					{
						"n": 5,
						"h": 110,
						"w": 609
					},
					{
						"n": 16,
						"h": 263,
						"w": 482
					},
					{
						"n": 15,
						"h": 222,
						"w": 468
					},
					{
						"n": 18,
						"h": 44,
						"w": 552
					},
					{
						"n": 17,
						"h": 412,
						"w": 463
					},
					{
						"n": 19,
						"h": 285,
						"w": 429
					},
					{
						"n": 20,
						"h": 184,
						"w": 399
					}
				],
				"ball": {
					"n": 0,
					"h": 220,
					"w": 242,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1787,
			"minute": 86,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 701
					},
					{
						"n": 2,
						"h": 391,
						"w": 368
					},
					{
						"n": 14,
						"h": 265,
						"w": 426
					},
					{
						"n": 13,
						"h": 187,
						"w": 429
					},
					{
						"n": 5,
						"h": 62,
						"w": 373
					},
					{
						"n": 6,
						"h": 399,
						"w": 172
					},
					{
						"n": 18,
						"h": 276,
						"w": 311
					},
					{
						"n": 15,
						"h": 140,
						"w": 205
					},
					{
						"n": 17,
						"h": 42,
						"w": 147
					},
					{
						"n": 20,
						"h": 192,
						"w": 254
					},
					{
						"n": 19,
						"h": 169,
						"w": 124
					}
				],
				"away": [
					{
						"n": 12,
						"h": 225,
						"w": 677
					},
					{
						"n": 13,
						"h": 392,
						"w": 600
					},
					{
						"n": 3,
						"h": 249,
						"w": 625
					},
					{
						"n": 14,
						"h": 256,
						"w": 486
					},
					{
						"n": 5,
						"h": 110,
						"w": 605
					},
					{
						"n": 16,
						"h": 286,
						"w": 513
					},
					{
						"n": 15,
						"h": 220,
						"w": 467
					},
					{
						"n": 18,
						"h": 51,
						"w": 583
					},
					{
						"n": 17,
						"h": 411,
						"w": 465
					},
					{
						"n": 19,
						"h": 285,
						"w": 415
					},
					{
						"n": 20,
						"h": 174,
						"w": 429
					}
				],
				"ball": {
					"n": 0,
					"h": 192,
					"w": 254,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 32
		},
		{
			"num": 1788,
			"minute": 86,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 701
					},
					{
						"n": 2,
						"h": 375,
						"w": 360
					},
					{
						"n": 14,
						"h": 265,
						"w": 419
					},
					{
						"n": 13,
						"h": 175,
						"w": 410
					},
					{
						"n": 5,
						"h": 73,
						"w": 361
					},
					{
						"n": 6,
						"h": 396,
						"w": 147
					},
					{
						"n": 18,
						"h": 284,
						"w": 272
					},
					{
						"n": 15,
						"h": 142,
						"w": 198
					},
					{
						"n": 17,
						"h": 37,
						"w": 147
					},
					{
						"n": 20,
						"h": 157,
						"w": 241
					},
					{
						"n": 19,
						"h": 165,
						"w": 131
					}
				],
				"away": [
					{
						"n": 12,
						"h": 224,
						"w": 701
					},
					{
						"n": 13,
						"h": 397,
						"w": 598
					},
					{
						"n": 3,
						"h": 247,
						"w": 623
					},
					{
						"n": 14,
						"h": 284,
						"w": 499
					},
					{
						"n": 5,
						"h": 110,
						"w": 604
					},
					{
						"n": 16,
						"h": 295,
						"w": 496
					},
					{
						"n": 15,
						"h": 222,
						"w": 490
					},
					{
						"n": 18,
						"h": 39,
						"w": 545
					},
					{
						"n": 17,
						"h": 414,
						"w": 463
					},
					{
						"n": 19,
						"h": 289,
						"w": 411
					},
					{
						"n": 20,
						"h": 155,
						"w": 427
					}
				],
				"ball": {
					"n": 0,
					"h": 157,
					"w": 241,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1789,
			"minute": 86,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 702
					},
					{
						"n": 2,
						"h": 376,
						"w": 362
					},
					{
						"n": 14,
						"h": 277,
						"w": 432
					},
					{
						"n": 13,
						"h": 174,
						"w": 413
					},
					{
						"n": 5,
						"h": 60,
						"w": 365
					},
					{
						"n": 6,
						"h": 388,
						"w": 129
					},
					{
						"n": 18,
						"h": 296,
						"w": 290
					},
					{
						"n": 15,
						"h": 144,
						"w": 197
					},
					{
						"n": 17,
						"h": 34,
						"w": 147
					},
					{
						"n": 20,
						"h": 190,
						"w": 224
					},
					{
						"n": 19,
						"h": 155,
						"w": 133
					}
				],
				"away": [
					{
						"n": 12,
						"h": 223,
						"w": 704
					},
					{
						"n": 13,
						"h": 400,
						"w": 598
					},
					{
						"n": 3,
						"h": 245,
						"w": 613
					},
					{
						"n": 14,
						"h": 253,
						"w": 528
					},
					{
						"n": 5,
						"h": 70,
						"w": 604
					},
					{
						"n": 16,
						"h": 262,
						"w": 517
					},
					{
						"n": 15,
						"h": 233,
						"w": 498
					},
					{
						"n": 18,
						"h": 33,
						"w": 513
					},
					{
						"n": 17,
						"h": 400,
						"w": 463
					},
					{
						"n": 19,
						"h": 291,
						"w": 411
					},
					{
						"n": 20,
						"h": 154,
						"w": 450
					}
				],
				"ball": {
					"n": 0,
					"h": 190,
					"w": 224,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1790,
			"minute": 86,
			"messages": [
				{
					"owner": 1,
					"mes": "Т.Дэвлин[20](Галвэй Юнайтед) отдает передачу К.Келли[15](Галвэй Юнайтед)..."
				},
				{
					"owner": 1,
					"mes": "Но Михаэль Владарж[36](Опава) перехватывает пас!..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 707
					},
					{
						"n": 2,
						"h": 385,
						"w": 358
					},
					{
						"n": 14,
						"h": 277,
						"w": 422
					},
					{
						"n": 13,
						"h": 177,
						"w": 415
					},
					{
						"n": 5,
						"h": 65,
						"w": 369
					},
					{
						"n": 6,
						"h": 395,
						"w": 136
					},
					{
						"n": 18,
						"h": 286,
						"w": 291
					},
					{
						"n": 15,
						"h": 152,
						"w": 199,
						"m": 640
					},
					{
						"n": 17,
						"h": 44,
						"w": 147
					},
					{
						"n": 20,
						"h": 190,
						"w": 224,
						"m": 570
					},
					{
						"n": 19,
						"h": 161,
						"w": 125
					}
				],
				"away": [
					{
						"n": 12,
						"h": 226,
						"w": 695
					},
					{
						"n": 13,
						"h": 390,
						"w": 599
					},
					{
						"n": 3,
						"h": 242,
						"w": 622
					},
					{
						"n": 14,
						"h": 246,
						"w": 535
					},
					{
						"n": 5,
						"h": 80,
						"w": 604
					},
					{
						"n": 16,
						"h": 271,
						"w": 513
					},
					{
						"n": 15,
						"h": 227,
						"w": 506
					},
					{
						"n": 18,
						"h": 33,
						"w": 513
					},
					{
						"n": 17,
						"h": 410,
						"w": 464
					},
					{
						"n": 19,
						"h": 292,
						"w": 421
					},
					{
						"n": 20,
						"h": 164,
						"w": 449
					}
				],
				"ball": {
					"n": 0,
					"h": 179,
					"w": 207,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 10
		},
		{
			"num": 1791,
			"minute": 86,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 703
					},
					{
						"n": 2,
						"h": 368,
						"w": 394
					},
					{
						"n": 14,
						"h": 275,
						"w": 418
					},
					{
						"n": 13,
						"h": 175,
						"w": 417
					},
					{
						"n": 5,
						"h": 85,
						"w": 403
					},
					{
						"n": 6,
						"h": 393,
						"w": 176
					},
					{
						"n": 18,
						"h": 282,
						"w": 330
					},
					{
						"n": 15,
						"h": 156,
						"w": 239
					},
					{
						"n": 17,
						"h": 44,
						"w": 187
					},
					{
						"n": 20,
						"h": 226,
						"w": 241
					},
					{
						"n": 19,
						"h": 187,
						"w": 155
					}
				],
				"away": [
					{
						"n": 12,
						"h": 228,
						"w": 703
					},
					{
						"n": 13,
						"h": 400,
						"w": 560
					},
					{
						"n": 3,
						"h": 268,
						"w": 612
					},
					{
						"n": 14,
						"h": 234,
						"w": 551
					},
					{
						"n": 5,
						"h": 66,
						"w": 629
					},
					{
						"n": 16,
						"h": 296,
						"w": 488,
						"m": 650
					},
					{
						"n": 15,
						"h": 221,
						"w": 466
					},
					{
						"n": 18,
						"h": 31,
						"w": 483
					},
					{
						"n": 17,
						"h": 412,
						"w": 424
					},
					{
						"n": 19,
						"h": 290,
						"w": 381
					},
					{
						"n": 20,
						"h": 158,
						"w": 409
					}
				],
				"ball": {
					"n": 0,
					"h": 154,
					"w": 232,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1792,
			"minute": 86,
			"messages": [
				{
					"owner": 2,
					"mes": "Пас левее на М.Томасова[37](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 701
					},
					{
						"n": 2,
						"h": 343,
						"w": 420
					},
					{
						"n": 14,
						"h": 281,
						"w": 435
					},
					{
						"n": 13,
						"h": 178,
						"w": 433
					},
					{
						"n": 5,
						"h": 85,
						"w": 367
					},
					{
						"n": 6,
						"h": 393,
						"w": 212
					},
					{
						"n": 18,
						"h": 284,
						"w": 366
					},
					{
						"n": 15,
						"h": 154,
						"w": 275
					},
					{
						"n": 17,
						"h": 47,
						"w": 223
					},
					{
						"n": 20,
						"h": 254,
						"w": 263
					},
					{
						"n": 19,
						"h": 179,
						"w": 190
					}
				],
				"away": [
					{
						"n": 12,
						"h": 230,
						"w": 703
					},
					{
						"n": 13,
						"h": 399,
						"w": 524
					},
					{
						"n": 3,
						"h": 269,
						"w": 622
					},
					{
						"n": 14,
						"h": 211,
						"w": 579
					},
					{
						"n": 5,
						"h": 66,
						"w": 601
					},
					{
						"n": 16,
						"h": 287,
						"w": 484
					},
					{
						"n": 15,
						"h": 239,
						"w": 435
					},
					{
						"n": 18,
						"h": 34,
						"w": 447
					},
					{
						"n": 17,
						"h": 396,
						"w": 448
					},
					{
						"n": 19,
						"h": 292,
						"w": 345
					},
					{
						"n": 20,
						"h": 156,
						"w": 373
					}
				],
				"ball": {
					"n": 0,
					"h": 54,
					"w": 272,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 36
		},
		{
			"num": 1793,
			"minute": 86,
			"messages": [
				{
					"owner": 2,
					"mes": "Марин Томасов[37](Опава) отдает передачу назад..."
				},
				{
					"owner": 2,
					"mes": "Нир Мансур[23](Опава) сбрасывает мяч себе на ход..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 705
					},
					{
						"n": 2,
						"h": 332,
						"w": 464
					},
					{
						"n": 14,
						"h": 274,
						"w": 461
					},
					{
						"n": 13,
						"h": 186,
						"w": 477
					},
					{
						"n": 5,
						"h": 91,
						"w": 412
					},
					{
						"n": 6,
						"h": 400,
						"w": 257
					},
					{
						"n": 18,
						"h": 312,
						"w": 402
					},
					{
						"n": 15,
						"h": 178,
						"w": 313
					},
					{
						"n": 17,
						"h": 52,
						"w": 268
					},
					{
						"n": 20,
						"h": 289,
						"w": 291
					},
					{
						"n": 19,
						"h": 163,
						"w": 148
					}
				],
				"away": [
					{
						"n": 12,
						"h": 230,
						"w": 705
					},
					{
						"n": 13,
						"h": 394,
						"w": 480
					},
					{
						"n": 3,
						"h": 288,
						"w": 594
					},
					{
						"n": 14,
						"h": 193,
						"w": 593
					},
					{
						"n": 5,
						"h": 73,
						"w": 590
					},
					{
						"n": 16,
						"h": 255,
						"w": 452
					},
					{
						"n": 15,
						"h": 236,
						"w": 390
					},
					{
						"n": 18,
						"h": 39,
						"w": 402
					},
					{
						"n": 17,
						"h": 395,
						"w": 438
					},
					{
						"n": 19,
						"h": 308,
						"w": 303
					},
					{
						"n": 20,
						"h": 144,
						"w": 330
					}
				],
				"ball": {
					"n": 0,
					"h": 162,
					"w": 126,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 45
		},
		{
			"num": 1794,
			"minute": 86,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 705
					},
					{
						"n": 2,
						"h": 330,
						"w": 461
					},
					{
						"n": 14,
						"h": 271,
						"w": 454
					},
					{
						"n": 13,
						"h": 183,
						"w": 477
					},
					{
						"n": 5,
						"h": 89,
						"w": 452
					},
					{
						"n": 6,
						"h": 398,
						"w": 297
					},
					{
						"n": 18,
						"h": 281,
						"w": 396
					},
					{
						"n": 15,
						"h": 185,
						"w": 345
					},
					{
						"n": 17,
						"h": 54,
						"w": 308
					},
					{
						"n": 20,
						"h": 323,
						"w": 280
					},
					{
						"n": 19,
						"h": 161,
						"w": 188
					}
				],
				"away": [
					{
						"n": 12,
						"h": 230,
						"w": 703
					},
					{
						"n": 13,
						"h": 400,
						"w": 519
					},
					{
						"n": 3,
						"h": 323,
						"w": 594
					},
					{
						"n": 14,
						"h": 171,
						"w": 587
					},
					{
						"n": 5,
						"h": 61,
						"w": 594
					},
					{
						"n": 16,
						"h": 224,
						"w": 473
					},
					{
						"n": 15,
						"h": 230,
						"w": 351
					},
					{
						"n": 18,
						"h": 44,
						"w": 363
					},
					{
						"n": 17,
						"h": 401,
						"w": 399
					},
					{
						"n": 19,
						"h": 287,
						"w": 295
					},
					{
						"n": 20,
						"h": 166,
						"w": 296
					}
				],
				"ball": {
					"n": 0,
					"h": 127,
					"w": 126,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1795,
			"minute": 87,
			"possession": 42,
			"messages": [
				{
					"owner": 2,
					"mes": "Нир Мансур[23](Опава) пасует налево на К.Удре[33](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 710
					},
					{
						"n": 2,
						"h": 330,
						"w": 451
					},
					{
						"n": 14,
						"h": 271,
						"w": 466
					},
					{
						"n": 13,
						"h": 176,
						"w": 470,
						"f": 91
					},
					{
						"n": 5,
						"h": 120,
						"w": 451
					},
					{
						"n": 6,
						"h": 396,
						"w": 329
					},
					{
						"n": 18,
						"h": 252,
						"w": 382,
						"f": 91
					},
					{
						"n": 15,
						"h": 153,
						"w": 343
					},
					{
						"n": 17,
						"h": 55,
						"w": 340
					},
					{
						"n": 20,
						"h": 294,
						"w": 293,
						"f": 81
					},
					{
						"n": 19,
						"h": 154,
						"w": 219
					}
				],
				"away": [
					{
						"n": 12,
						"h": 235,
						"w": 709
					},
					{
						"n": 13,
						"h": 386,
						"w": 548
					},
					{
						"n": 3,
						"h": 314,
						"w": 591,
						"m": 730
					},
					{
						"n": 14,
						"h": 166,
						"w": 584
					},
					{
						"n": 5,
						"h": 39,
						"w": 584
					},
					{
						"n": 16,
						"h": 231,
						"w": 441
					},
					{
						"n": 15,
						"h": 222,
						"w": 356
					},
					{
						"n": 18,
						"h": 43,
						"w": 395
					},
					{
						"n": 17,
						"h": 410,
						"w": 368,
						"f": 86
					},
					{
						"n": 19,
						"h": 287,
						"w": 280,
						"m": 670
					},
					{
						"n": 20,
						"h": 167,
						"w": 280
					}
				],
				"ball": {
					"n": 0,
					"h": 64,
					"w": 172,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 32
		},
		{
			"num": 1796,
			"minute": 87,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 708
					},
					{
						"n": 2,
						"h": 330,
						"w": 457
					},
					{
						"n": 14,
						"h": 273,
						"w": 457
					},
					{
						"n": 13,
						"h": 170,
						"w": 475
					},
					{
						"n": 5,
						"h": 120,
						"w": 464
					},
					{
						"n": 6,
						"h": 421,
						"w": 360
					},
					{
						"n": 18,
						"h": 233,
						"w": 389
					},
					{
						"n": 15,
						"h": 174,
						"w": 336
					},
					{
						"n": 17,
						"h": 56,
						"w": 380
					},
					{
						"n": 20,
						"h": 286,
						"w": 309
					},
					{
						"n": 19,
						"h": 176,
						"w": 252
					}
				],
				"away": [
					{
						"n": 12,
						"h": 235,
						"w": 702
					},
					{
						"n": 13,
						"h": 400,
						"w": 516
					},
					{
						"n": 3,
						"h": 291,
						"w": 581
					},
					{
						"n": 14,
						"h": 161,
						"w": 581
					},
					{
						"n": 5,
						"h": 48,
						"w": 581
					},
					{
						"n": 16,
						"h": 235,
						"w": 431
					},
					{
						"n": 15,
						"h": 224,
						"w": 355
					},
					{
						"n": 18,
						"h": 38,
						"w": 431
					},
					{
						"n": 17,
						"h": 416,
						"w": 355
					},
					{
						"n": 19,
						"h": 298,
						"w": 280
					},
					{
						"n": 20,
						"h": 157,
						"w": 280
					}
				],
				"ball": {
					"n": 0,
					"h": 50,
					"w": 204,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1797,
			"minute": 87,
			"messages": [
				{
					"owner": 2,
					"mes": "Пас В.Сланине[34](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 701
					},
					{
						"n": 2,
						"h": 330,
						"w": 453
					},
					{
						"n": 14,
						"h": 273,
						"w": 461
					},
					{
						"n": 13,
						"h": 175,
						"w": 469
					},
					{
						"n": 5,
						"h": 120,
						"w": 467
					},
					{
						"n": 6,
						"h": 421,
						"w": 360
					},
					{
						"n": 18,
						"h": 263,
						"w": 377
					},
					{
						"n": 15,
						"h": 223,
						"w": 364
					},
					{
						"n": 17,
						"h": 56,
						"w": 382
					},
					{
						"n": 20,
						"h": 306,
						"w": 280
					},
					{
						"n": 19,
						"h": 163,
						"w": 305
					}
				],
				"away": [
					{
						"n": 12,
						"h": 225,
						"w": 705
					},
					{
						"n": 13,
						"h": 405,
						"w": 508
					},
					{
						"n": 3,
						"h": 299,
						"w": 571
					},
					{
						"n": 14,
						"h": 179,
						"w": 555
					},
					{
						"n": 5,
						"h": 45,
						"w": 571
					},
					{
						"n": 16,
						"h": 219,
						"w": 426
					},
					{
						"n": 15,
						"h": 230,
						"w": 353
					},
					{
						"n": 18,
						"h": 50,
						"w": 426
					},
					{
						"n": 17,
						"h": 413,
						"w": 353
					},
					{
						"n": 19,
						"h": 301,
						"w": 280
					},
					{
						"n": 20,
						"h": 164,
						"w": 280
					}
				],
				"ball": {
					"n": 0,
					"h": 271,
					"w": 165,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 56
		},
		{
			"num": 1798,
			"minute": 87,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 708
					},
					{
						"n": 2,
						"h": 330,
						"w": 465
					},
					{
						"n": 14,
						"h": 277,
						"w": 469
					},
					{
						"n": 13,
						"h": 177,
						"w": 466
					},
					{
						"n": 5,
						"h": 120,
						"w": 462
					},
					{
						"n": 6,
						"h": 388,
						"w": 360
					},
					{
						"n": 18,
						"h": 261,
						"w": 370
					},
					{
						"n": 15,
						"h": 230,
						"w": 370
					},
					{
						"n": 17,
						"h": 56,
						"w": 385
					},
					{
						"n": 20,
						"h": 292,
						"w": 299
					},
					{
						"n": 19,
						"h": 175,
						"w": 293
					}
				],
				"away": [
					{
						"n": 12,
						"h": 225,
						"w": 683
					},
					{
						"n": 13,
						"h": 415,
						"w": 491
					},
					{
						"n": 3,
						"h": 295,
						"w": 561
					},
					{
						"n": 14,
						"h": 194,
						"w": 523
					},
					{
						"n": 5,
						"h": 51,
						"w": 561
					},
					{
						"n": 16,
						"h": 228,
						"w": 421
					},
					{
						"n": 15,
						"h": 226,
						"w": 350
					},
					{
						"n": 18,
						"h": 33,
						"w": 421
					},
					{
						"n": 17,
						"h": 413,
						"w": 350
					},
					{
						"n": 19,
						"h": 283,
						"w": 280
					},
					{
						"n": 20,
						"h": 154,
						"w": 280
					}
				],
				"ball": {
					"n": 0,
					"h": 256,
					"w": 197,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1799,
			"minute": 87,
			"messages": [
				{
					"owner": 2,
					"mes": "Вацлав Сланина[34](Опава) делает передачу налево..."
				},
				{
					"owner": 2,
					"mes": "Нир Мансур[23](Опава) достает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 707
					},
					{
						"n": 2,
						"h": 330,
						"w": 451
					},
					{
						"n": 14,
						"h": 274,
						"w": 451
					},
					{
						"n": 13,
						"h": 180,
						"w": 471
					},
					{
						"n": 5,
						"h": 120,
						"w": 464
					},
					{
						"n": 6,
						"h": 404,
						"w": 360
					},
					{
						"n": 18,
						"h": 261,
						"w": 380
					},
					{
						"n": 15,
						"h": 226,
						"w": 378
					},
					{
						"n": 17,
						"h": 56,
						"w": 387
					},
					{
						"n": 20,
						"h": 286,
						"w": 293
					},
					{
						"n": 19,
						"h": 172,
						"w": 302
					}
				],
				"away": [
					{
						"n": 12,
						"h": 230,
						"w": 664
					},
					{
						"n": 13,
						"h": 411,
						"w": 483
					},
					{
						"n": 3,
						"h": 282,
						"w": 536
					},
					{
						"n": 14,
						"h": 186,
						"w": 529
					},
					{
						"n": 5,
						"h": 39,
						"w": 551
					},
					{
						"n": 16,
						"h": 215,
						"w": 416
					},
					{
						"n": 15,
						"h": 227,
						"w": 348
					},
					{
						"n": 18,
						"h": 34,
						"w": 416
					},
					{
						"n": 17,
						"h": 416,
						"w": 348
					},
					{
						"n": 19,
						"h": 290,
						"w": 280
					},
					{
						"n": 20,
						"h": 163,
						"w": 280
					}
				],
				"ball": {
					"n": 0,
					"h": 168,
					"w": 184,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 29
		},
		{
			"num": 1800,
			"minute": 87,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 709
					},
					{
						"n": 2,
						"h": 330,
						"w": 459
					},
					{
						"n": 14,
						"h": 271,
						"w": 457
					},
					{
						"n": 13,
						"h": 166,
						"w": 447
					},
					{
						"n": 5,
						"h": 120,
						"w": 467
					},
					{
						"n": 6,
						"h": 399,
						"w": 360
					},
					{
						"n": 18,
						"h": 265,
						"w": 392
					},
					{
						"n": 15,
						"h": 221,
						"w": 385
					},
					{
						"n": 17,
						"h": 56,
						"w": 410
					},
					{
						"n": 20,
						"h": 275,
						"w": 306
					},
					{
						"n": 19,
						"h": 137,
						"w": 282
					}
				],
				"away": [
					{
						"n": 12,
						"h": 225,
						"w": 645
					},
					{
						"n": 13,
						"h": 410,
						"w": 476
					},
					{
						"n": 3,
						"h": 269,
						"w": 503
					},
					{
						"n": 14,
						"h": 151,
						"w": 541
					},
					{
						"n": 5,
						"h": 38,
						"w": 541
					},
					{
						"n": 16,
						"h": 231,
						"w": 411
					},
					{
						"n": 15,
						"h": 232,
						"w": 345
					},
					{
						"n": 18,
						"h": 44,
						"w": 411
					},
					{
						"n": 17,
						"h": 403,
						"w": 345
					},
					{
						"n": 19,
						"h": 298,
						"w": 280
					},
					{
						"n": 20,
						"h": 162,
						"w": 280
					}
				],
				"ball": {
					"n": 0,
					"h": 181,
					"w": 217,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1801,
			"minute": 87,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 703
					},
					{
						"n": 2,
						"h": 330,
						"w": 464
					},
					{
						"n": 14,
						"h": 277,
						"w": 466
					},
					{
						"n": 13,
						"h": 175,
						"w": 447
					},
					{
						"n": 5,
						"h": 120,
						"w": 463
					},
					{
						"n": 6,
						"h": 394,
						"w": 384
					},
					{
						"n": 18,
						"h": 235,
						"w": 404
					},
					{
						"n": 15,
						"h": 193,
						"w": 356
					},
					{
						"n": 17,
						"h": 77,
						"w": 437
					},
					{
						"n": 20,
						"h": 282,
						"w": 311
					},
					{
						"n": 19,
						"h": 176,
						"w": 274
					}
				],
				"away": [
					{
						"n": 12,
						"h": 225,
						"w": 685
					},
					{
						"n": 13,
						"h": 409,
						"w": 444
					},
					{
						"n": 3,
						"h": 267,
						"w": 468
					},
					{
						"n": 14,
						"h": 171,
						"w": 576
					},
					{
						"n": 5,
						"h": 59,
						"w": 575
					},
					{
						"n": 16,
						"h": 231,
						"w": 411
					},
					{
						"n": 15,
						"h": 216,
						"w": 308
					},
					{
						"n": 18,
						"h": 44,
						"w": 371
					},
					{
						"n": 17,
						"h": 373,
						"w": 318
					},
					{
						"n": 19,
						"h": 318,
						"w": 272
					},
					{
						"n": 20,
						"h": 142,
						"w": 272
					}
				],
				"ball": {
					"n": 0,
					"h": 183,
					"w": 252,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1802,
			"minute": 87,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 705
					},
					{
						"n": 2,
						"h": 330,
						"w": 496
					},
					{
						"n": 14,
						"h": 238,
						"w": 477
					},
					{
						"n": 13,
						"h": 172,
						"w": 487
					},
					{
						"n": 5,
						"h": 120,
						"w": 482
					},
					{
						"n": 6,
						"h": 394,
						"w": 404
					},
					{
						"n": 18,
						"h": 272,
						"w": 418
					},
					{
						"n": 15,
						"h": 211,
						"w": 387
					},
					{
						"n": 17,
						"h": 56,
						"w": 470
					},
					{
						"n": 20,
						"h": 295,
						"w": 317
					},
					{
						"n": 19,
						"h": 216,
						"w": 281
					}
				],
				"away": [
					{
						"n": 12,
						"h": 227,
						"w": 668
					},
					{
						"n": 13,
						"h": 398,
						"w": 405
					},
					{
						"n": 3,
						"h": 233,
						"w": 459
					},
					{
						"n": 14,
						"h": 177,
						"w": 539
					},
					{
						"n": 5,
						"h": 58,
						"w": 539
					},
					{
						"n": 16,
						"h": 225,
						"w": 378
					},
					{
						"n": 15,
						"h": 233,
						"w": 272
					},
					{
						"n": 18,
						"h": 43,
						"w": 331
					},
					{
						"n": 17,
						"h": 396,
						"w": 285
					},
					{
						"n": 19,
						"h": 298,
						"w": 260
					},
					{
						"n": 20,
						"h": 162,
						"w": 298
					}
				],
				"ball": {
					"n": 0,
					"h": 217,
					"w": 261,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1803,
			"minute": 87,
			"messages": [
				{
					"owner": 2,
					"mes": "Передача вперед..."
				},
				{
					"owner": 2,
					"mes": "Михаэль Владарж[36](Опава) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 703
					},
					{
						"n": 2,
						"h": 330,
						"w": 529
					},
					{
						"n": 14,
						"h": 261,
						"w": 510
					},
					{
						"n": 13,
						"h": 182,
						"w": 526
					},
					{
						"n": 5,
						"h": 120,
						"w": 522
					},
					{
						"n": 6,
						"h": 394,
						"w": 364
					},
					{
						"n": 18,
						"h": 233,
						"w": 425
					},
					{
						"n": 15,
						"h": 248,
						"w": 373
					},
					{
						"n": 17,
						"h": 56,
						"w": 435
					},
					{
						"n": 20,
						"h": 282,
						"w": 355
					},
					{
						"n": 19,
						"h": 210,
						"w": 274
					}
				],
				"away": [
					{
						"n": 12,
						"h": 221,
						"w": 650
					},
					{
						"n": 13,
						"h": 407,
						"w": 444
					},
					{
						"n": 3,
						"h": 240,
						"w": 466
					},
					{
						"n": 14,
						"h": 162,
						"w": 502
					},
					{
						"n": 5,
						"h": 40,
						"w": 503
					},
					{
						"n": 16,
						"h": 196,
						"w": 350
					},
					{
						"n": 15,
						"h": 234,
						"w": 300
					},
					{
						"n": 18,
						"h": 42,
						"w": 371
					},
					{
						"n": 17,
						"h": 414,
						"w": 300
					},
					{
						"n": 19,
						"h": 284,
						"w": 224
					},
					{
						"n": 20,
						"h": 165,
						"w": 258
					}
				],
				"ball": {
					"n": 0,
					"h": 254,
					"w": 370,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1804,
			"minute": 87,
			"messages": [
				{
					"owner": 2,
					"mes": "Михаэль Владарж[36](Опава) отправляет мяч вперед... Т.Анри[40](Опава) готов принять передачу..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 701
					},
					{
						"n": 2,
						"h": 320,
						"w": 498
					},
					{
						"n": 14,
						"h": 239,
						"w": 535
					},
					{
						"n": 13,
						"h": 166,
						"w": 537
					},
					{
						"n": 5,
						"h": 120,
						"w": 555
					},
					{
						"n": 6,
						"h": 381,
						"w": 395
					},
					{
						"n": 18,
						"h": 255,
						"w": 450
					},
					{
						"n": 15,
						"h": 248,
						"w": 373
					},
					{
						"n": 17,
						"h": 56,
						"w": 468
					},
					{
						"n": 20,
						"h": 278,
						"w": 340
					},
					{
						"n": 19,
						"h": 192,
						"w": 302
					}
				],
				"away": [
					{
						"n": 12,
						"h": 230,
						"w": 626
					},
					{
						"n": 13,
						"h": 410,
						"w": 412
					},
					{
						"n": 3,
						"h": 261,
						"w": 492
					},
					{
						"n": 14,
						"h": 184,
						"w": 524
					},
					{
						"n": 5,
						"h": 68,
						"w": 521
					},
					{
						"n": 16,
						"h": 206,
						"w": 349
					},
					{
						"n": 15,
						"h": 235,
						"w": 267
					},
					{
						"n": 18,
						"h": 40,
						"w": 338
					},
					{
						"n": 17,
						"h": 416,
						"w": 267
					},
					{
						"n": 19,
						"h": 299,
						"w": 201
					},
					{
						"n": 20,
						"h": 133,
						"w": 266
					}
				],
				"ball": {
					"n": 0,
					"h": 337,
					"w": 426,
					"z": 0,
					"r": 0,
					"p": 2,
					"x": 0
				}
			},
			"interval": 33
		},
		{
			"num": 1805,
			"minute": 87,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 707
					},
					{
						"n": 2,
						"h": 326,
						"w": 479
					},
					{
						"n": 14,
						"h": 236,
						"w": 554
					},
					{
						"n": 13,
						"h": 174,
						"w": 554
					},
					{
						"n": 5,
						"h": 120,
						"w": 575
					},
					{
						"n": 6,
						"h": 373,
						"w": 413
					},
					{
						"n": 18,
						"h": 246,
						"w": 468
					},
					{
						"n": 15,
						"h": 238,
						"w": 391
					},
					{
						"n": 17,
						"h": 56,
						"w": 488
					},
					{
						"n": 20,
						"h": 263,
						"w": 353
					},
					{
						"n": 19,
						"h": 187,
						"w": 321
					}
				],
				"away": [
					{
						"n": 12,
						"h": 226,
						"w": 612
					},
					{
						"n": 13,
						"h": 409,
						"w": 392
					},
					{
						"n": 3,
						"h": 269,
						"w": 502
					},
					{
						"n": 14,
						"h": 174,
						"w": 507
					},
					{
						"n": 5,
						"h": 70,
						"w": 501
					},
					{
						"n": 16,
						"h": 217,
						"w": 360
					},
					{
						"n": 15,
						"h": 218,
						"w": 255
					},
					{
						"n": 18,
						"h": 39,
						"w": 318
					},
					{
						"n": 17,
						"h": 416,
						"w": 247
					},
					{
						"n": 19,
						"h": 288,
						"w": 184
					},
					{
						"n": 20,
						"h": 113,
						"w": 271
					}
				],
				"ball": {
					"n": 0,
					"h": 362,
					"w": 442,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 20
		},
		{
			"num": 1806,
			"minute": 87,
			"messages": [
				{
					"owner": 2,
					"mes": "Тома Анри[40](Опава) останавливает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 709
					},
					{
						"n": 2,
						"h": 303,
						"w": 491
					},
					{
						"n": 14,
						"h": 247,
						"w": 578
					},
					{
						"n": 13,
						"h": 168,
						"w": 578
					},
					{
						"n": 5,
						"h": 120,
						"w": 576
					},
					{
						"n": 6,
						"h": 363,
						"w": 437
					},
					{
						"n": 18,
						"h": 267,
						"w": 483
					},
					{
						"n": 15,
						"h": 227,
						"w": 414
					},
					{
						"n": 17,
						"h": 56,
						"w": 514
					},
					{
						"n": 20,
						"h": 257,
						"w": 368
					},
					{
						"n": 19,
						"h": 175,
						"w": 344
					}
				],
				"away": [
					{
						"n": 12,
						"h": 225,
						"w": 617
					},
					{
						"n": 13,
						"h": 404,
						"w": 366
					},
					{
						"n": 3,
						"h": 283,
						"w": 482
					},
					{
						"n": 14,
						"h": 165,
						"w": 482
					},
					{
						"n": 5,
						"h": 74,
						"w": 476
					},
					{
						"n": 16,
						"h": 193,
						"w": 372
					},
					{
						"n": 15,
						"h": 205,
						"w": 233
					},
					{
						"n": 18,
						"h": 28,
						"w": 294
					},
					{
						"n": 17,
						"h": 415,
						"w": 221
					},
					{
						"n": 19,
						"h": 294,
						"w": 159
					},
					{
						"n": 20,
						"h": 88,
						"w": 278
					}
				],
				"ball": {
					"n": 0,
					"h": 362,
					"w": 442,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 26
		},
		{
			"num": 1807,
			"minute": 87,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 707
					},
					{
						"n": 2,
						"h": 321,
						"w": 531
					},
					{
						"n": 14,
						"h": 263,
						"w": 600
					},
					{
						"n": 13,
						"h": 188,
						"w": 612
					},
					{
						"n": 5,
						"h": 120,
						"w": 602
					},
					{
						"n": 6,
						"h": 361,
						"w": 483
					},
					{
						"n": 18,
						"h": 272,
						"w": 523
					},
					{
						"n": 15,
						"h": 209,
						"w": 450
					},
					{
						"n": 17,
						"h": 56,
						"w": 554
					},
					{
						"n": 20,
						"h": 258,
						"w": 408
					},
					{
						"n": 19,
						"h": 163,
						"w": 381
					}
				],
				"away": [
					{
						"n": 12,
						"h": 230,
						"w": 595
					},
					{
						"n": 13,
						"h": 408,
						"w": 328
					},
					{
						"n": 3,
						"h": 271,
						"w": 467
					},
					{
						"n": 14,
						"h": 172,
						"w": 469
					},
					{
						"n": 5,
						"h": 64,
						"w": 450
					},
					{
						"n": 16,
						"h": 192,
						"w": 332
					},
					{
						"n": 15,
						"h": 177,
						"w": 215
					},
					{
						"n": 18,
						"h": 17,
						"w": 256
					},
					{
						"n": 17,
						"h": 400,
						"w": 184
					},
					{
						"n": 19,
						"h": 274,
						"w": 138
					},
					{
						"n": 20,
						"h": 82,
						"w": 233
					}
				],
				"ball": {
					"n": 0,
					"h": 368,
					"w": 487,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1808,
			"minute": 87,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 234,
						"w": 708
					},
					{
						"n": 2,
						"h": 343,
						"w": 569
					},
					{
						"n": 14,
						"h": 243,
						"w": 612
					},
					{
						"n": 13,
						"h": 172,
						"w": 600
					},
					{
						"n": 5,
						"h": 120,
						"w": 614
					},
					{
						"n": 6,
						"h": 368,
						"w": 528
					},
					{
						"n": 18,
						"h": 253,
						"w": 539
					},
					{
						"n": 15,
						"h": 205,
						"w": 490
					},
					{
						"n": 17,
						"h": 56,
						"w": 514
					},
					{
						"n": 20,
						"h": 235,
						"w": 441
					},
					{
						"n": 19,
						"h": 164,
						"w": 377
					}
				],
				"away": [
					{
						"n": 12,
						"h": 223,
						"w": 597
					},
					{
						"n": 13,
						"h": 400,
						"w": 289
					},
					{
						"n": 3,
						"h": 285,
						"w": 443
					},
					{
						"n": 14,
						"h": 167,
						"w": 435
					},
					{
						"n": 5,
						"h": 63,
						"w": 420
					},
					{
						"n": 16,
						"h": 215,
						"w": 299
					},
					{
						"n": 15,
						"h": 195,
						"w": 180
					},
					{
						"n": 18,
						"h": 12,
						"w": 216
					},
					{
						"n": 17,
						"h": 367,
						"w": 162
					},
					{
						"n": 19,
						"h": 296,
						"w": 128
					},
					{
						"n": 20,
						"h": 71,
						"w": 189,
						"m": 660
					}
				],
				"ball": {
					"n": 0,
					"h": 379,
					"w": 531,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1809,
			"minute": 87,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 236,
						"w": 710
					},
					{
						"n": 2,
						"h": 347,
						"w": 574
					},
					{
						"n": 14,
						"h": 232,
						"w": 622
					},
					{
						"n": 13,
						"h": 176,
						"w": 636
					},
					{
						"n": 5,
						"h": 117,
						"w": 590
					},
					{
						"n": 6,
						"h": 372,
						"w": 544
					},
					{
						"n": 18,
						"h": 284,
						"w": 530
					},
					{
						"n": 15,
						"h": 171,
						"w": 503
					},
					{
						"n": 17,
						"h": 56,
						"w": 490
					},
					{
						"n": 20,
						"h": 256,
						"w": 411
					},
					{
						"n": 19,
						"h": 157,
						"w": 384
					}
				],
				"away": [
					{
						"n": 12,
						"h": 227,
						"w": 596
					},
					{
						"n": 13,
						"h": 415,
						"w": 265
					},
					{
						"n": 3,
						"h": 277,
						"w": 463
					},
					{
						"n": 14,
						"h": 164,
						"w": 463
					},
					{
						"n": 5,
						"h": 72,
						"w": 426
					},
					{
						"n": 16,
						"h": 207,
						"w": 262
					},
					{
						"n": 15,
						"h": 218,
						"w": 166
					},
					{
						"n": 18,
						"h": 10,
						"w": 179
					},
					{
						"n": 17,
						"h": 341,
						"w": 136
					},
					{
						"n": 19,
						"h": 294,
						"w": 118
					},
					{
						"n": 20,
						"h": 61,
						"w": 149
					}
				],
				"ball": {
					"n": 0,
					"h": 389,
					"w": 571,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 37
		},
		{
			"num": 1810,
			"minute": 87,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 238,
						"w": 712
					},
					{
						"n": 2,
						"h": 371,
						"w": 611
					},
					{
						"n": 14,
						"h": 256,
						"w": 664
					},
					{
						"n": 13,
						"h": 209,
						"w": 659
					},
					{
						"n": 5,
						"h": 130,
						"w": 630
					},
					{
						"n": 6,
						"h": 373,
						"w": 590
					},
					{
						"n": 18,
						"h": 284,
						"w": 570
					},
					{
						"n": 15,
						"h": 186,
						"w": 540
					},
					{
						"n": 17,
						"h": 56,
						"w": 530
					},
					{
						"n": 20,
						"h": 253,
						"w": 439
					},
					{
						"n": 19,
						"h": 168,
						"w": 375
					}
				],
				"away": [
					{
						"n": 12,
						"h": 226,
						"w": 601
					},
					{
						"n": 13,
						"h": 411,
						"w": 225
					},
					{
						"n": 3,
						"h": 283,
						"w": 423
					},
					{
						"n": 14,
						"h": 166,
						"w": 427
					},
					{
						"n": 5,
						"h": 73,
						"w": 406
					},
					{
						"n": 16,
						"h": 197,
						"w": 301
					},
					{
						"n": 15,
						"h": 198,
						"w": 131
					},
					{
						"n": 18,
						"h": 8,
						"w": 139
					},
					{
						"n": 17,
						"h": 328,
						"w": 98
					},
					{
						"n": 19,
						"h": 260,
						"w": 96
					},
					{
						"n": 20,
						"h": 61,
						"w": 104
					}
				],
				"ball": {
					"n": 0,
					"h": 389,
					"w": 616,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1811,
			"minute": 87,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 239,
						"w": 715
					},
					{
						"n": 2,
						"h": 379,
						"w": 654
					},
					{
						"n": 14,
						"h": 260,
						"w": 688
					},
					{
						"n": 13,
						"h": 224,
						"w": 669
					},
					{
						"n": 5,
						"h": 142,
						"w": 672
					},
					{
						"n": 6,
						"h": 376,
						"w": 630
					},
					{
						"n": 18,
						"h": 269,
						"w": 607
					},
					{
						"n": 15,
						"h": 213,
						"w": 563
					},
					{
						"n": 17,
						"h": 56,
						"w": 570
					},
					{
						"n": 20,
						"h": 236,
						"w": 437
					},
					{
						"n": 19,
						"h": 155,
						"w": 375
					}
				],
				"away": [
					{
						"n": 12,
						"h": 228,
						"w": 598
					},
					{
						"n": 13,
						"h": 407,
						"w": 185
					},
					{
						"n": 3,
						"h": 276,
						"w": 422
					},
					{
						"n": 14,
						"h": 173,
						"w": 423
					},
					{
						"n": 5,
						"h": 75,
						"w": 414
					},
					{
						"n": 16,
						"h": 214,
						"w": 303
					},
					{
						"n": 15,
						"h": 194,
						"w": 100
					},
					{
						"n": 18,
						"h": 7,
						"w": 99
					},
					{
						"n": 17,
						"h": 321,
						"w": 89
					},
					{
						"n": 19,
						"h": 230,
						"w": 76
					},
					{
						"n": 20,
						"h": 61,
						"w": 59
					}
				],
				"ball": {
					"n": 0,
					"h": 389,
					"w": 661,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1812,
			"minute": 87,
			"messages": [
				{
					"owner": 2,
					"mes": "Т.Анри[40](Опава) навешивает во вратарскую..."
				},
				{
					"owner": 2,
					"mes": "Том Смит[14](Галвэй Юнайтед) показывает свою прыгучесть и выбивает мяч из штрафной..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 711
					},
					{
						"n": 2,
						"h": 381,
						"w": 679
					},
					{
						"n": 14,
						"h": 258,
						"w": 687
					},
					{
						"n": 13,
						"h": 222,
						"w": 679
					},
					{
						"n": 5,
						"h": 138,
						"w": 675
					},
					{
						"n": 6,
						"h": 391,
						"w": 659
					},
					{
						"n": 18,
						"h": 270,
						"w": 640
					},
					{
						"n": 15,
						"h": 212,
						"w": 561
					},
					{
						"n": 17,
						"h": 56,
						"w": 603
					},
					{
						"n": 20,
						"h": 235,
						"w": 470
					},
					{
						"n": 19,
						"h": 174,
						"w": 372
					}
				],
				"away": [
					{
						"n": 12,
						"h": 221,
						"w": 602
					},
					{
						"n": 13,
						"h": 408,
						"w": 152
					},
					{
						"n": 3,
						"h": 278,
						"w": 414
					},
					{
						"n": 14,
						"h": 183,
						"w": 402
					},
					{
						"n": 5,
						"h": 73,
						"w": 393
					},
					{
						"n": 16,
						"h": 215,
						"w": 270
					},
					{
						"n": 15,
						"h": 197,
						"w": 67
					},
					{
						"n": 18,
						"h": 7,
						"w": 66
					},
					{
						"n": 17,
						"h": 311,
						"w": 57
					},
					{
						"n": 19,
						"h": 236,
						"w": 44
					},
					{
						"n": 20,
						"h": 61,
						"w": 53
					}
				],
				"ball": {
					"n": 0,
					"h": 258,
					"w": 687,
					"z": 1,
					"r": 2,
					"p": 4,
					"x": 1
				}
			},
			"interval": 33
		},
		{
			"num": 1813,
			"minute": 87,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 706
					},
					{
						"n": 2,
						"h": 356,
						"w": 662
					},
					{
						"n": 14,
						"h": 258,
						"w": 687,
						"m": 660
					},
					{
						"n": 13,
						"h": 200,
						"w": 674
					},
					{
						"n": 5,
						"h": 143,
						"w": 665
					},
					{
						"n": 6,
						"h": 394,
						"w": 645
					},
					{
						"n": 18,
						"h": 283,
						"w": 608
					},
					{
						"n": 15,
						"h": 186,
						"w": 565
					},
					{
						"n": 17,
						"h": 56,
						"w": 632
					},
					{
						"n": 20,
						"h": 239,
						"w": 458
					},
					{
						"n": 19,
						"h": 156,
						"w": 389
					}
				],
				"away": [
					{
						"n": 12,
						"h": 222,
						"w": 600
					},
					{
						"n": 13,
						"h": 415,
						"w": 123
					},
					{
						"n": 3,
						"h": 269,
						"w": 429
					},
					{
						"n": 14,
						"h": 167,
						"w": 422
					},
					{
						"n": 5,
						"h": 61,
						"w": 412
					},
					{
						"n": 16,
						"h": 211,
						"w": 282
					},
					{
						"n": 15,
						"h": 182,
						"w": 97
					},
					{
						"n": 18,
						"h": 28,
						"w": 88
					},
					{
						"n": 17,
						"h": 322,
						"w": 79
					},
					{
						"n": 19,
						"h": 260,
						"w": 62
					},
					{
						"n": 20,
						"h": 89,
						"w": 63
					}
				],
				"ball": {
					"n": 0,
					"h": 298,
					"w": 573,
					"z": 1,
					"r": 0,
					"p": 1,
					"x": 0
				}
			},
			"interval": 30
		},
		{
			"num": 1814,
			"minute": 87,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 705
					},
					{
						"n": 2,
						"h": 347,
						"w": 662
					},
					{
						"n": 14,
						"h": 260,
						"w": 676
					},
					{
						"n": 13,
						"h": 193,
						"w": 668
					},
					{
						"n": 5,
						"h": 137,
						"w": 658
					},
					{
						"n": 6,
						"h": 394,
						"w": 645
					},
					{
						"n": 18,
						"h": 286,
						"w": 599
					},
					{
						"n": 15,
						"h": 177,
						"w": 565
					},
					{
						"n": 17,
						"h": 56,
						"w": 639
					},
					{
						"n": 20,
						"h": 236,
						"w": 450
					},
					{
						"n": 19,
						"h": 165,
						"w": 387
					}
				],
				"away": [
					{
						"n": 12,
						"h": 224,
						"w": 596
					},
					{
						"n": 13,
						"h": 410,
						"w": 116
					},
					{
						"n": 3,
						"h": 273,
						"w": 426
					},
					{
						"n": 14,
						"h": 171,
						"w": 414
					},
					{
						"n": 5,
						"h": 69,
						"w": 416
					},
					{
						"n": 16,
						"h": 214,
						"w": 290
					},
					{
						"n": 15,
						"h": 178,
						"w": 105
					},
					{
						"n": 18,
						"h": 36,
						"w": 91
					},
					{
						"n": 17,
						"h": 331,
						"w": 80
					},
					{
						"n": 19,
						"h": 265,
						"w": 70
					},
					{
						"n": 20,
						"h": 97,
						"w": 67
					}
				],
				"ball": {
					"n": 0,
					"h": 310,
					"w": 539,
					"z": 0,
					"r": 0,
					"p": 1,
					"x": 0
				}
			},
			"interval": 9
		},
		{
			"num": 1815,
			"minute": 87,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 704
					},
					{
						"n": 2,
						"h": 361,
						"w": 612
					},
					{
						"n": 14,
						"h": 271,
						"w": 610
					},
					{
						"n": 13,
						"h": 189,
						"w": 605
					},
					{
						"n": 5,
						"h": 97,
						"w": 604
					},
					{
						"n": 6,
						"h": 403,
						"w": 579
					},
					{
						"n": 18,
						"h": 314,
						"w": 527
					},
					{
						"n": 15,
						"h": 168,
						"w": 499
					},
					{
						"n": 17,
						"h": 53,
						"w": 573
					},
					{
						"n": 20,
						"h": 261,
						"w": 388
					},
					{
						"n": 19,
						"h": 173,
						"w": 322
					}
				],
				"away": [
					{
						"n": 12,
						"h": 215,
						"w": 641
					},
					{
						"n": 13,
						"h": 408,
						"w": 182
					},
					{
						"n": 3,
						"h": 264,
						"w": 476
					},
					{
						"n": 14,
						"h": 200,
						"w": 475
					},
					{
						"n": 5,
						"h": 110,
						"w": 464
					},
					{
						"n": 16,
						"h": 155,
						"w": 235
					},
					{
						"n": 15,
						"h": 142,
						"w": 181
					},
					{
						"n": 18,
						"h": 39,
						"w": 158
					},
					{
						"n": 17,
						"h": 344,
						"w": 125
					},
					{
						"n": 19,
						"h": 271,
						"w": 136
					},
					{
						"n": 20,
						"h": 150,
						"w": 108
					}
				],
				"ball": {
					"n": 0,
					"h": 314,
					"w": 527,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 67
		},
		{
			"num": 1816,
			"minute": 87,
			"messages": [
				{
					"owner": 1,
					"mes": "Райан Уотсон[18](Галвэй Юнайтед) завладевает мячом..."
				}
			]
		},
		{
			"num": 1817,
			"minute": 88,
			"possession": 42,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 708
					},
					{
						"n": 2,
						"h": 365,
						"w": 588,
						"f": 75
					},
					{
						"n": 14,
						"h": 275,
						"w": 570
					},
					{
						"n": 13,
						"h": 186,
						"w": 565
					},
					{
						"n": 5,
						"h": 91,
						"w": 580,
						"m": 710
					},
					{
						"n": 6,
						"h": 401,
						"w": 539
					},
					{
						"n": 18,
						"h": 332,
						"w": 497
					},
					{
						"n": 15,
						"h": 160,
						"w": 460
					},
					{
						"n": 17,
						"h": 53,
						"w": 533,
						"f": 83
					},
					{
						"n": 20,
						"h": 274,
						"w": 350
					},
					{
						"n": 19,
						"h": 149,
						"w": 290,
						"f": 88
					}
				],
				"away": [
					{
						"n": 12,
						"h": 205,
						"w": 648
					},
					{
						"n": 13,
						"h": 406,
						"w": 222,
						"f": 87
					},
					{
						"n": 3,
						"h": 289,
						"w": 480
					},
					{
						"n": 14,
						"h": 188,
						"w": 492
					},
					{
						"n": 5,
						"h": 110,
						"w": 470
					},
					{
						"n": 16,
						"h": 164,
						"w": 274,
						"f": 90
					},
					{
						"n": 15,
						"h": 162,
						"w": 215
					},
					{
						"n": 18,
						"h": 36,
						"w": 197
					},
					{
						"n": 17,
						"h": 352,
						"w": 143
					},
					{
						"n": 19,
						"h": 281,
						"w": 175
					},
					{
						"n": 20,
						"h": 147,
						"w": 148,
						"f": 90
					}
				],
				"ball": {
					"n": 0,
					"h": 332,
					"w": 497,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1818,
			"minute": 88,
			"messages": [
				{
					"owner": 1,
					"mes": "Райан Уотсон[18](Галвэй Юнайтед) делает пас на К.Келли[15](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 708
					},
					{
						"n": 2,
						"h": 371,
						"w": 529
					},
					{
						"n": 14,
						"h": 271,
						"w": 534
					},
					{
						"n": 13,
						"h": 163,
						"w": 548
					},
					{
						"n": 5,
						"h": 73,
						"w": 524
					},
					{
						"n": 6,
						"h": 406,
						"w": 480
					},
					{
						"n": 18,
						"h": 329,
						"w": 487
					},
					{
						"n": 15,
						"h": 160,
						"w": 460
					},
					{
						"n": 17,
						"h": 49,
						"w": 474
					},
					{
						"n": 20,
						"h": 286,
						"w": 292
					},
					{
						"n": 19,
						"h": 153,
						"w": 248
					}
				],
				"away": [
					{
						"n": 12,
						"h": 235,
						"w": 649
					},
					{
						"n": 13,
						"h": 405,
						"w": 281
					},
					{
						"n": 3,
						"h": 285,
						"w": 494
					},
					{
						"n": 14,
						"h": 179,
						"w": 508
					},
					{
						"n": 5,
						"h": 110,
						"w": 500
					},
					{
						"n": 16,
						"h": 185,
						"w": 329
					},
					{
						"n": 15,
						"h": 192,
						"w": 266
					},
					{
						"n": 18,
						"h": 35,
						"w": 256
					},
					{
						"n": 17,
						"h": 364,
						"w": 180
					},
					{
						"n": 19,
						"h": 293,
						"w": 233
					},
					{
						"n": 20,
						"h": 133,
						"w": 205
					}
				],
				"ball": {
					"n": 0,
					"h": 160,
					"w": 460,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 59
		},
		{
			"num": 1819,
			"minute": 88,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 706
					},
					{
						"n": 2,
						"h": 382,
						"w": 490
					},
					{
						"n": 14,
						"h": 275,
						"w": 518
					},
					{
						"n": 13,
						"h": 163,
						"w": 532
					},
					{
						"n": 5,
						"h": 63,
						"w": 486
					},
					{
						"n": 6,
						"h": 409,
						"w": 440
					},
					{
						"n": 18,
						"h": 321,
						"w": 448
					},
					{
						"n": 15,
						"h": 160,
						"w": 425
					},
					{
						"n": 17,
						"h": 55,
						"w": 434
					},
					{
						"n": 20,
						"h": 290,
						"w": 252
					},
					{
						"n": 19,
						"h": 147,
						"w": 224
					}
				],
				"away": [
					{
						"n": 12,
						"h": 235,
						"w": 641
					},
					{
						"n": 13,
						"h": 404,
						"w": 321
					},
					{
						"n": 3,
						"h": 286,
						"w": 504
					},
					{
						"n": 14,
						"h": 170,
						"w": 496
					},
					{
						"n": 5,
						"h": 110,
						"w": 516
					},
					{
						"n": 16,
						"h": 201,
						"w": 366
					},
					{
						"n": 15,
						"h": 208,
						"w": 303
					},
					{
						"n": 18,
						"h": 33,
						"w": 296
					},
					{
						"n": 17,
						"h": 373,
						"w": 219
					},
					{
						"n": 19,
						"h": 292,
						"w": 273
					},
					{
						"n": 20,
						"h": 131,
						"w": 245
					}
				],
				"ball": {
					"n": 0,
					"h": 160,
					"w": 425,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1820,
			"minute": 88,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 704
					},
					{
						"n": 2,
						"h": 386,
						"w": 466
					},
					{
						"n": 14,
						"h": 271,
						"w": 516
					},
					{
						"n": 13,
						"h": 168,
						"w": 502
					},
					{
						"n": 5,
						"h": 71,
						"w": 460
					},
					{
						"n": 6,
						"h": 410,
						"w": 400
					},
					{
						"n": 18,
						"h": 313,
						"w": 409
					},
					{
						"n": 15,
						"h": 160,
						"w": 389
					},
					{
						"n": 17,
						"h": 56,
						"w": 394
					},
					{
						"n": 20,
						"h": 292,
						"w": 218
					},
					{
						"n": 19,
						"h": 136,
						"w": 236
					}
				],
				"away": [
					{
						"n": 12,
						"h": 235,
						"w": 642
					},
					{
						"n": 13,
						"h": 394,
						"w": 360
					},
					{
						"n": 3,
						"h": 280,
						"w": 522
					},
					{
						"n": 14,
						"h": 192,
						"w": 529
					},
					{
						"n": 5,
						"h": 110,
						"w": 524
					},
					{
						"n": 16,
						"h": 240,
						"w": 358
					},
					{
						"n": 15,
						"h": 215,
						"w": 342
					},
					{
						"n": 18,
						"h": 32,
						"w": 336
					},
					{
						"n": 17,
						"h": 388,
						"w": 257
					},
					{
						"n": 19,
						"h": 291,
						"w": 308
					},
					{
						"n": 20,
						"h": 134,
						"w": 285
					}
				],
				"ball": {
					"n": 0,
					"h": 160,
					"w": 389,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1821,
			"minute": 88,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 706
					},
					{
						"n": 2,
						"h": 383,
						"w": 442
					},
					{
						"n": 14,
						"h": 267,
						"w": 494
					},
					{
						"n": 13,
						"h": 172,
						"w": 496
					},
					{
						"n": 5,
						"h": 60,
						"w": 448
					},
					{
						"n": 6,
						"h": 411,
						"w": 360
					},
					{
						"n": 18,
						"h": 307,
						"w": 369
					},
					{
						"n": 15,
						"h": 160,
						"w": 354
					},
					{
						"n": 17,
						"h": 56,
						"w": 354
					},
					{
						"n": 20,
						"h": 281,
						"w": 227
					},
					{
						"n": 19,
						"h": 159,
						"w": 203
					}
				],
				"away": [
					{
						"n": 12,
						"h": 235,
						"w": 650
					},
					{
						"n": 13,
						"h": 394,
						"w": 400
					},
					{
						"n": 3,
						"h": 280,
						"w": 533
					},
					{
						"n": 14,
						"h": 180,
						"w": 523
					},
					{
						"n": 5,
						"h": 110,
						"w": 531
					},
					{
						"n": 16,
						"h": 274,
						"w": 379
					},
					{
						"n": 15,
						"h": 215,
						"w": 382
					},
					{
						"n": 18,
						"h": 40,
						"w": 376
					},
					{
						"n": 17,
						"h": 402,
						"w": 294
					},
					{
						"n": 19,
						"h": 290,
						"w": 343
					},
					{
						"n": 20,
						"h": 144,
						"w": 323
					}
				],
				"ball": {
					"n": 0,
					"h": 160,
					"w": 354,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1822,
			"minute": 88,
			"messages": [
				{
					"owner": 1,
					"mes": "Передача вперед..."
				},
				{
					"owner": 1,
					"mes": "Байрон О`Горман[19](Галвэй Юнайтед) сбрасывает мяч себе на ход..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 703
					},
					{
						"n": 2,
						"h": 385,
						"w": 444
					},
					{
						"n": 14,
						"h": 275,
						"w": 495
					},
					{
						"n": 13,
						"h": 164,
						"w": 498
					},
					{
						"n": 5,
						"h": 77,
						"w": 456
					},
					{
						"n": 6,
						"h": 408,
						"w": 323
					},
					{
						"n": 18,
						"h": 270,
						"w": 374
					},
					{
						"n": 15,
						"h": 160,
						"w": 343,
						"m": 650
					},
					{
						"n": 17,
						"h": 55,
						"w": 317
					},
					{
						"n": 20,
						"h": 281,
						"w": 217
					},
					{
						"n": 19,
						"h": 138,
						"w": 244
					}
				],
				"away": [
					{
						"n": 12,
						"h": 235,
						"w": 641
					},
					{
						"n": 13,
						"h": 395,
						"w": 437
					},
					{
						"n": 3,
						"h": 302,
						"w": 558
					},
					{
						"n": 14,
						"h": 186,
						"w": 560
					},
					{
						"n": 5,
						"h": 110,
						"w": 562
					},
					{
						"n": 16,
						"h": 288,
						"w": 413
					},
					{
						"n": 15,
						"h": 217,
						"w": 419
					},
					{
						"n": 18,
						"h": 43,
						"w": 413
					},
					{
						"n": 17,
						"h": 406,
						"w": 331
					},
					{
						"n": 19,
						"h": 285,
						"w": 379
					},
					{
						"n": 20,
						"h": 168,
						"w": 352
					}
				],
				"ball": {
					"n": 0,
					"h": 138,
					"w": 244,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 37
		},
		{
			"num": 1823,
			"minute": 88,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 708
					},
					{
						"n": 2,
						"h": 392,
						"w": 418
					},
					{
						"n": 14,
						"h": 276,
						"w": 475
					},
					{
						"n": 13,
						"h": 175,
						"w": 460
					},
					{
						"n": 5,
						"h": 74,
						"w": 428
					},
					{
						"n": 6,
						"h": 401,
						"w": 284
					},
					{
						"n": 18,
						"h": 280,
						"w": 375
					},
					{
						"n": 15,
						"h": 160,
						"w": 303
					},
					{
						"n": 17,
						"h": 53,
						"w": 277
					},
					{
						"n": 20,
						"h": 287,
						"w": 178
					},
					{
						"n": 19,
						"h": 153,
						"w": 207
					}
				],
				"away": [
					{
						"n": 12,
						"h": 235,
						"w": 648
					},
					{
						"n": 13,
						"h": 397,
						"w": 477
					},
					{
						"n": 3,
						"h": 292,
						"w": 533
					},
					{
						"n": 14,
						"h": 219,
						"w": 581
					},
					{
						"n": 5,
						"h": 142,
						"w": 586
					},
					{
						"n": 16,
						"h": 287,
						"w": 453
					},
					{
						"n": 15,
						"h": 215,
						"w": 454
					},
					{
						"n": 18,
						"h": 47,
						"w": 452
					},
					{
						"n": 17,
						"h": 402,
						"w": 371
					},
					{
						"n": 19,
						"h": 276,
						"w": 388
					},
					{
						"n": 20,
						"h": 170,
						"w": 365
					}
				],
				"ball": {
					"n": 0,
					"h": 153,
					"w": 207,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1824,
			"minute": 88,
			"messages": [
				{
					"owner": 1,
					"mes": "Байрон О`Горман[19](Галвэй Юнайтед) отдает пас на К.Келли[15](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 709
					},
					{
						"n": 2,
						"h": 382,
						"w": 386
					},
					{
						"n": 14,
						"h": 268,
						"w": 432
					},
					{
						"n": 13,
						"h": 169,
						"w": 447
					},
					{
						"n": 5,
						"h": 72,
						"w": 384
					},
					{
						"n": 6,
						"h": 404,
						"w": 240
					},
					{
						"n": 18,
						"h": 285,
						"w": 331
					},
					{
						"n": 15,
						"h": 165,
						"w": 260
					},
					{
						"n": 17,
						"h": 89,
						"w": 301
					},
					{
						"n": 20,
						"h": 283,
						"w": 143
					},
					{
						"n": 19,
						"h": 156,
						"w": 193
					}
				],
				"away": [
					{
						"n": 12,
						"h": 235,
						"w": 642
					},
					{
						"n": 13,
						"h": 361,
						"w": 455
					},
					{
						"n": 3,
						"h": 286,
						"w": 576
					},
					{
						"n": 14,
						"h": 181,
						"w": 602
					},
					{
						"n": 5,
						"h": 110,
						"w": 611
					},
					{
						"n": 16,
						"h": 285,
						"w": 480
					},
					{
						"n": 15,
						"h": 224,
						"w": 490
					},
					{
						"n": 18,
						"h": 46,
						"w": 496
					},
					{
						"n": 17,
						"h": 369,
						"w": 400
					},
					{
						"n": 19,
						"h": 277,
						"w": 425
					},
					{
						"n": 20,
						"h": 165,
						"w": 409
					}
				],
				"ball": {
					"n": 0,
					"h": 110,
					"w": 284,
					"z": 0,
					"r": 0,
					"p": 2,
					"x": 0
				}
			},
			"interval": 44
		},
		{
			"num": 1825,
			"minute": 88,
			"messages": [
				{
					"owner": 1,
					"mes": "Маттиас Раум[17](Галвэй Юнайтед) удачно выбирает позицию и подбирает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 706
					},
					{
						"n": 2,
						"h": 378,
						"w": 377
					},
					{
						"n": 14,
						"h": 273,
						"w": 425
					},
					{
						"n": 13,
						"h": 168,
						"w": 421
					},
					{
						"n": 5,
						"h": 63,
						"w": 373
					},
					{
						"n": 6,
						"h": 406,
						"w": 214
					},
					{
						"n": 18,
						"h": 282,
						"w": 305
					},
					{
						"n": 15,
						"h": 168,
						"w": 234
					},
					{
						"n": 17,
						"h": 98,
						"w": 307
					},
					{
						"n": 20,
						"h": 278,
						"w": 137
					},
					{
						"n": 19,
						"h": 162,
						"w": 174
					}
				],
				"away": [
					{
						"n": 12,
						"h": 235,
						"w": 650
					},
					{
						"n": 13,
						"h": 375,
						"w": 477
					},
					{
						"n": 3,
						"h": 279,
						"w": 601
					},
					{
						"n": 14,
						"h": 187,
						"w": 627
					},
					{
						"n": 5,
						"h": 110,
						"w": 606
					},
					{
						"n": 16,
						"h": 281,
						"w": 504
					},
					{
						"n": 15,
						"h": 225,
						"w": 500
					},
					{
						"n": 18,
						"h": 45,
						"w": 522
					},
					{
						"n": 17,
						"h": 350,
						"w": 416
					},
					{
						"n": 19,
						"h": 303,
						"w": 428
					},
					{
						"n": 20,
						"h": 168,
						"w": 435
					}
				],
				"ball": {
					"n": 0,
					"h": 98,
					"w": 307,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 26
		},
		{
			"num": 1826,
			"minute": 88,
			"messages": [
				{
					"owner": 1,
					"mes": "М.Раум[17](Галвэй Юнайтед) стелящимся пасом отдает мяч С.Фридйонссону[05](Галвэй Юнайтед)..."
				},
				{
					"owner": 1,
					"mes": "Теперь с мячом Самуэль Кари Фридйонссон[05](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 709
					},
					{
						"n": 2,
						"h": 382,
						"w": 358
					},
					{
						"n": 14,
						"h": 273,
						"w": 414
					},
					{
						"n": 13,
						"h": 178,
						"w": 408
					},
					{
						"n": 5,
						"h": 66,
						"w": 346
					},
					{
						"n": 6,
						"h": 408,
						"w": 189
					},
					{
						"n": 18,
						"h": 273,
						"w": 282
					},
					{
						"n": 15,
						"h": 153,
						"w": 214
					},
					{
						"n": 17,
						"h": 98,
						"w": 307,
						"m": 760
					},
					{
						"n": 20,
						"h": 286,
						"w": 113
					},
					{
						"n": 19,
						"h": 159,
						"w": 149
					}
				],
				"away": [
					{
						"n": 12,
						"h": 230,
						"w": 674
					},
					{
						"n": 13,
						"h": 387,
						"w": 499
					},
					{
						"n": 3,
						"h": 277,
						"w": 625
					},
					{
						"n": 14,
						"h": 181,
						"w": 617
					},
					{
						"n": 5,
						"h": 110,
						"w": 627
					},
					{
						"n": 16,
						"h": 268,
						"w": 526
					},
					{
						"n": 15,
						"h": 234,
						"w": 487
					},
					{
						"n": 18,
						"h": 44,
						"w": 547
					},
					{
						"n": 17,
						"h": 367,
						"w": 398
					},
					{
						"n": 19,
						"h": 328,
						"w": 431
					},
					{
						"n": 20,
						"h": 177,
						"w": 458
					}
				],
				"ball": {
					"n": 0,
					"h": 66,
					"w": 346,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 25
		},
		{
			"num": 1827,
			"minute": 88,
			"messages": [
				{
					"owner": 1,
					"mes": "Пас Б.Регану[13](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 705
					},
					{
						"n": 2,
						"h": 384,
						"w": 363
					},
					{
						"n": 14,
						"h": 273,
						"w": 400
					},
					{
						"n": 13,
						"h": 206,
						"w": 381
					},
					{
						"n": 5,
						"h": 73,
						"w": 353
					},
					{
						"n": 6,
						"h": 402,
						"w": 151
					},
					{
						"n": 18,
						"h": 273,
						"w": 243
					},
					{
						"n": 15,
						"h": 175,
						"w": 215
					},
					{
						"n": 17,
						"h": 90,
						"w": 268
					},
					{
						"n": 20,
						"h": 280,
						"w": 109
					},
					{
						"n": 19,
						"h": 174,
						"w": 118
					}
				],
				"away": [
					{
						"n": 12,
						"h": 221,
						"w": 710
					},
					{
						"n": 13,
						"h": 396,
						"w": 536
					},
					{
						"n": 3,
						"h": 259,
						"w": 620
					},
					{
						"n": 14,
						"h": 188,
						"w": 622
					},
					{
						"n": 5,
						"h": 110,
						"w": 640
					},
					{
						"n": 16,
						"h": 268,
						"w": 542
					},
					{
						"n": 15,
						"h": 229,
						"w": 510
					},
					{
						"n": 18,
						"h": 47,
						"w": 586
					},
					{
						"n": 17,
						"h": 377,
						"w": 403
					},
					{
						"n": 19,
						"h": 295,
						"w": 428
					},
					{
						"n": 20,
						"h": 195,
						"w": 423
					}
				],
				"ball": {
					"n": 0,
					"h": 182,
					"w": 366,
					"z": 0,
					"r": 0,
					"p": 2,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 1828,
			"minute": 88,
			"messages": [
				{
					"owner": 1,
					"mes": "Билли Реган[13](Галвэй Юнайтед) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 703
					},
					{
						"n": 2,
						"h": 379,
						"w": 364
					},
					{
						"n": 14,
						"h": 266,
						"w": 414
					},
					{
						"n": 13,
						"h": 217,
						"w": 371,
						"m": 640
					},
					{
						"n": 5,
						"h": 68,
						"w": 355
					},
					{
						"n": 6,
						"h": 410,
						"w": 130
					},
					{
						"n": 18,
						"h": 281,
						"w": 222
					},
					{
						"n": 15,
						"h": 165,
						"w": 194
					},
					{
						"n": 17,
						"h": 85,
						"w": 245
					},
					{
						"n": 20,
						"h": 291,
						"w": 102
					},
					{
						"n": 19,
						"h": 165,
						"w": 112
					}
				],
				"away": [
					{
						"n": 12,
						"h": 226,
						"w": 707
					},
					{
						"n": 13,
						"h": 378,
						"w": 521
					},
					{
						"n": 3,
						"h": 274,
						"w": 630
					},
					{
						"n": 14,
						"h": 170,
						"w": 636
					},
					{
						"n": 5,
						"h": 110,
						"w": 634
					},
					{
						"n": 16,
						"h": 288,
						"w": 543
					},
					{
						"n": 15,
						"h": 218,
						"w": 496
					},
					{
						"n": 18,
						"h": 53,
						"w": 609
					},
					{
						"n": 17,
						"h": 390,
						"w": 423
					},
					{
						"n": 19,
						"h": 290,
						"w": 410
					},
					{
						"n": 20,
						"h": 206,
						"w": 402
					}
				],
				"ball": {
					"n": 0,
					"h": 217,
					"w": 371,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 24
		},
		{
			"num": 1829,
			"minute": 88,
			"messages": [
				{
					"owner": 1,
					"mes": "Билли Реган[13](Галвэй Юнайтед) пасует на С.Фридйонссона[05](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 706
					},
					{
						"n": 2,
						"h": 390,
						"w": 360
					},
					{
						"n": 14,
						"h": 283,
						"w": 398
					},
					{
						"n": 13,
						"h": 206,
						"w": 375
					},
					{
						"n": 5,
						"h": 91,
						"w": 383
					},
					{
						"n": 6,
						"h": 404,
						"w": 130
					},
					{
						"n": 18,
						"h": 259,
						"w": 258
					},
					{
						"n": 15,
						"h": 136,
						"w": 221
					},
					{
						"n": 17,
						"h": 88,
						"w": 246
					},
					{
						"n": 20,
						"h": 275,
						"w": 130
					},
					{
						"n": 19,
						"h": 180,
						"w": 124
					}
				],
				"away": [
					{
						"n": 12,
						"h": 230,
						"w": 702
					},
					{
						"n": 13,
						"h": 362,
						"w": 510
					},
					{
						"n": 3,
						"h": 257,
						"w": 629
					},
					{
						"n": 14,
						"h": 188,
						"w": 650
					},
					{
						"n": 5,
						"h": 110,
						"w": 629
					},
					{
						"n": 16,
						"h": 267,
						"w": 579
					},
					{
						"n": 15,
						"h": 230,
						"w": 485
					},
					{
						"n": 18,
						"h": 36,
						"w": 571
					},
					{
						"n": 17,
						"h": 402,
						"w": 442
					},
					{
						"n": 19,
						"h": 323,
						"w": 384
					},
					{
						"n": 20,
						"h": 169,
						"w": 421
					}
				],
				"ball": {
					"n": 0,
					"h": 91,
					"w": 383,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 42
		},
		{
			"num": 1830,
			"minute": 88,
			"messages": [
				{
					"owner": 1,
					"mes": "Пас вперед..."
				},
				{
					"owner": 1,
					"mes": "Неточно..."
				},
				{
					"owner": 1,
					"mes": "Маттиас Раум[17](Галвэй Юнайтед) удачно выбирает позицию и подбирает мяч..."
				},
				{
					"owner": 1,
					"mes": "Маттиас Раум[17](Галвэй Юнайтед) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 710
					},
					{
						"n": 2,
						"h": 392,
						"w": 363
					},
					{
						"n": 14,
						"h": 269,
						"w": 424
					},
					{
						"n": 13,
						"h": 180,
						"w": 405
					},
					{
						"n": 5,
						"h": 81,
						"w": 382,
						"m": 700
					},
					{
						"n": 6,
						"h": 402,
						"w": 127
					},
					{
						"n": 18,
						"h": 279,
						"w": 293
					},
					{
						"n": 15,
						"h": 166,
						"w": 228
					},
					{
						"n": 17,
						"h": 111,
						"w": 265
					},
					{
						"n": 20,
						"h": 271,
						"w": 137
					},
					{
						"n": 19,
						"h": 173,
						"w": 117
					}
				],
				"away": [
					{
						"n": 12,
						"h": 230,
						"w": 704
					},
					{
						"n": 13,
						"h": 339,
						"w": 477
					},
					{
						"n": 3,
						"h": 261,
						"w": 632
					},
					{
						"n": 14,
						"h": 194,
						"w": 621
					},
					{
						"n": 5,
						"h": 110,
						"w": 632
					},
					{
						"n": 16,
						"h": 250,
						"w": 543
					},
					{
						"n": 15,
						"h": 219,
						"w": 490
					},
					{
						"n": 18,
						"h": 61,
						"w": 603
					},
					{
						"n": 17,
						"h": 369,
						"w": 442
					},
					{
						"n": 19,
						"h": 292,
						"w": 409
					},
					{
						"n": 20,
						"h": 171,
						"w": 447
					}
				],
				"ball": {
					"n": 0,
					"h": 111,
					"w": 265,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1831,
			"minute": 88,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 705
					},
					{
						"n": 2,
						"h": 386,
						"w": 363
					},
					{
						"n": 14,
						"h": 269,
						"w": 418
					},
					{
						"n": 13,
						"h": 178,
						"w": 399
					},
					{
						"n": 5,
						"h": 78,
						"w": 377
					},
					{
						"n": 6,
						"h": 398,
						"w": 132
					},
					{
						"n": 18,
						"h": 278,
						"w": 299
					},
					{
						"n": 15,
						"h": 160,
						"w": 229
					},
					{
						"n": 17,
						"h": 111,
						"w": 259
					},
					{
						"n": 20,
						"h": 273,
						"w": 131
					},
					{
						"n": 19,
						"h": 169,
						"w": 121
					}
				],
				"away": [
					{
						"n": 12,
						"h": 225,
						"w": 707
					},
					{
						"n": 13,
						"h": 339,
						"w": 471
					},
					{
						"n": 3,
						"h": 261,
						"w": 626
					},
					{
						"n": 14,
						"h": 199,
						"w": 621
					},
					{
						"n": 5,
						"h": 110,
						"w": 626
					},
					{
						"n": 16,
						"h": 248,
						"w": 537
					},
					{
						"n": 15,
						"h": 219,
						"w": 484
					},
					{
						"n": 18,
						"h": 60,
						"w": 597
					},
					{
						"n": 17,
						"h": 369,
						"w": 442
					},
					{
						"n": 19,
						"h": 293,
						"w": 415
					},
					{
						"n": 20,
						"h": 171,
						"w": 447
					}
				],
				"ball": {
					"n": 0,
					"h": 111,
					"w": 259,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 6
		},
		{
			"num": 1832,
			"minute": 88,
			"messages": [
				{
					"owner": 1,
					"mes": "М.Раум[17](Галвэй Юнайтед) пытается обыграть К.Удре[33](Опава)..."
				},
				{
					"owner": 1,
					"mes": "Маттиас Раум[17](Галвэй Юнайтед) обманным движением уходит от К.Удре[33](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 705
					},
					{
						"n": 2,
						"h": 381,
						"w": 376
					},
					{
						"n": 14,
						"h": 268,
						"w": 414
					},
					{
						"n": 13,
						"h": 171,
						"w": 405
					},
					{
						"n": 5,
						"h": 69,
						"w": 380
					},
					{
						"n": 6,
						"h": 412,
						"w": 147
					},
					{
						"n": 18,
						"h": 284,
						"w": 259
					},
					{
						"n": 15,
						"h": 160,
						"w": 189
					},
					{
						"n": 17,
						"h": 111,
						"w": 219,
						"m": 770
					},
					{
						"n": 20,
						"h": 285,
						"w": 117
					},
					{
						"n": 19,
						"h": 180,
						"w": 117
					}
				],
				"away": [
					{
						"n": 12,
						"h": 230,
						"w": 705
					},
					{
						"n": 13,
						"h": 339,
						"w": 471,
						"m": 580
					},
					{
						"n": 3,
						"h": 256,
						"w": 612
					},
					{
						"n": 14,
						"h": 185,
						"w": 632
					},
					{
						"n": 5,
						"h": 110,
						"w": 604
					},
					{
						"n": 16,
						"h": 288,
						"w": 530
					},
					{
						"n": 15,
						"h": 235,
						"w": 499
					},
					{
						"n": 18,
						"h": 52,
						"w": 557
					},
					{
						"n": 17,
						"h": 388,
						"w": 448
					},
					{
						"n": 19,
						"h": 288,
						"w": 425
					},
					{
						"n": 20,
						"h": 172,
						"w": 413
					}
				],
				"ball": {
					"n": 0,
					"h": 111,
					"w": 219,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1833,
			"minute": 88,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 709
					},
					{
						"n": 2,
						"h": 375,
						"w": 363
					},
					{
						"n": 14,
						"h": 267,
						"w": 418
					},
					{
						"n": 13,
						"h": 178,
						"w": 421
					},
					{
						"n": 5,
						"h": 78,
						"w": 357
					},
					{
						"n": 6,
						"h": 416,
						"w": 121
					},
					{
						"n": 18,
						"h": 292,
						"w": 285
					},
					{
						"n": 15,
						"h": 168,
						"w": 173
					},
					{
						"n": 17,
						"h": 111,
						"w": 178
					},
					{
						"n": 20,
						"h": 274,
						"w": 107
					},
					{
						"n": 19,
						"h": 177,
						"w": 107
					}
				],
				"away": [
					{
						"n": 12,
						"h": 233,
						"w": 707
					},
					{
						"n": 13,
						"h": 334,
						"w": 515
					},
					{
						"n": 3,
						"h": 257,
						"w": 631
					},
					{
						"n": 14,
						"h": 188,
						"w": 638
					},
					{
						"n": 5,
						"h": 110,
						"w": 626
					},
					{
						"n": 16,
						"h": 330,
						"w": 554
					},
					{
						"n": 15,
						"h": 216,
						"w": 497
					},
					{
						"n": 18,
						"h": 27,
						"w": 532
					},
					{
						"n": 17,
						"h": 398,
						"w": 465
					},
					{
						"n": 19,
						"h": 293,
						"w": 423
					},
					{
						"n": 20,
						"h": 159,
						"w": 451
					}
				],
				"ball": {
					"n": 0,
					"h": 111,
					"w": 178,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1834,
			"minute": 88,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 702
					},
					{
						"n": 2,
						"h": 373,
						"w": 357
					},
					{
						"n": 14,
						"h": 278,
						"w": 399
					},
					{
						"n": 13,
						"h": 184,
						"w": 384
					},
					{
						"n": 5,
						"h": 77,
						"w": 346
					},
					{
						"n": 6,
						"h": 398,
						"w": 112
					},
					{
						"n": 18,
						"h": 254,
						"w": 296
					},
					{
						"n": 15,
						"h": 147,
						"w": 158
					},
					{
						"n": 17,
						"h": 83,
						"w": 150
					},
					{
						"n": 20,
						"h": 291,
						"w": 97
					},
					{
						"n": 19,
						"h": 160,
						"w": 106
					}
				],
				"away": [
					{
						"n": 12,
						"h": 235,
						"w": 709
					},
					{
						"n": 13,
						"h": 350,
						"w": 556
					},
					{
						"n": 3,
						"h": 280,
						"w": 636
					},
					{
						"n": 14,
						"h": 179,
						"w": 636
					},
					{
						"n": 5,
						"h": 110,
						"w": 640
					},
					{
						"n": 16,
						"h": 362,
						"w": 587
					},
					{
						"n": 15,
						"h": 215,
						"w": 496
					},
					{
						"n": 18,
						"h": 23,
						"w": 542
					},
					{
						"n": 17,
						"h": 411,
						"w": 480
					},
					{
						"n": 19,
						"h": 284,
						"w": 426
					},
					{
						"n": 20,
						"h": 196,
						"w": 444
					}
				],
				"ball": {
					"n": 0,
					"h": 83,
					"w": 150,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1835,
			"minute": 88,
			"messages": [
				{
					"owner": 1,
					"mes": "Маттиас Раум[17](Галвэй Юнайтед) переправляет мяч на ход Б.О`Горману[19](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 707
					},
					{
						"n": 2,
						"h": 382,
						"w": 360
					},
					{
						"n": 14,
						"h": 275,
						"w": 395
					},
					{
						"n": 13,
						"h": 163,
						"w": 404
					},
					{
						"n": 5,
						"h": 67,
						"w": 357
					},
					{
						"n": 6,
						"h": 397,
						"w": 80
					},
					{
						"n": 18,
						"h": 264,
						"w": 263
					},
					{
						"n": 15,
						"h": 154,
						"w": 124
					},
					{
						"n": 17,
						"h": 83,
						"w": 150,
						"m": 780
					},
					{
						"n": 20,
						"h": 284,
						"w": 63
					},
					{
						"n": 19,
						"h": 145,
						"w": 67
					}
				],
				"away": [
					{
						"n": 12,
						"h": 237,
						"w": 710
					},
					{
						"n": 13,
						"h": 361,
						"w": 589
					},
					{
						"n": 3,
						"h": 290,
						"w": 664
					},
					{
						"n": 14,
						"h": 195,
						"w": 667
					},
					{
						"n": 5,
						"h": 110,
						"w": 675
					},
					{
						"n": 16,
						"h": 328,
						"w": 594
					},
					{
						"n": 15,
						"h": 221,
						"w": 512
					},
					{
						"n": 18,
						"h": 29,
						"w": 556
					},
					{
						"n": 17,
						"h": 406,
						"w": 494
					},
					{
						"n": 19,
						"h": 288,
						"w": 426
					},
					{
						"n": 20,
						"h": 186,
						"w": 477
					}
				],
				"ball": {
					"n": 0,
					"h": 145,
					"w": 67,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 35
		},
		{
			"num": 1836,
			"minute": 88,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 703
					},
					{
						"n": 2,
						"h": 386,
						"w": 351
					},
					{
						"n": 14,
						"h": 267,
						"w": 400
					},
					{
						"n": 13,
						"h": 174,
						"w": 391
					},
					{
						"n": 5,
						"h": 68,
						"w": 344
					},
					{
						"n": 6,
						"h": 387,
						"w": 75
					},
					{
						"n": 18,
						"h": 283,
						"w": 269
					},
					{
						"n": 15,
						"h": 167,
						"w": 119
					},
					{
						"n": 17,
						"h": 80,
						"w": 130
					},
					{
						"n": 20,
						"h": 287,
						"w": 50
					},
					{
						"n": 19,
						"h": 155,
						"w": 68
					}
				],
				"away": [
					{
						"n": 12,
						"h": 236,
						"w": 710
					},
					{
						"n": 13,
						"h": 366,
						"w": 609
					},
					{
						"n": 3,
						"h": 288,
						"w": 659
					},
					{
						"n": 14,
						"h": 180,
						"w": 661
					},
					{
						"n": 5,
						"h": 110,
						"w": 670
					},
					{
						"n": 16,
						"h": 309,
						"w": 600
					},
					{
						"n": 15,
						"h": 215,
						"w": 493
					},
					{
						"n": 18,
						"h": 28,
						"w": 576
					},
					{
						"n": 17,
						"h": 406,
						"w": 494
					},
					{
						"n": 19,
						"h": 277,
						"w": 416
					},
					{
						"n": 20,
						"h": 167,
						"w": 471
					}
				],
				"ball": {
					"n": 0,
					"h": 155,
					"w": 68,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 20
		},
		{
			"num": 1837,
			"minute": 88,
			"messages": [
				{
					"owner": 1,
					"mes": "Байрон О`Горман[19](Галвэй Юнайтед) укрывает мяч корпусом..."
				},
				{
					"owner": 1,
					"mes": "Нир Мансур[23](Опава) отнимает у него мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 703
					},
					{
						"n": 2,
						"h": 386,
						"w": 351
					},
					{
						"n": 14,
						"h": 267,
						"w": 400
					},
					{
						"n": 13,
						"h": 174,
						"w": 391
					},
					{
						"n": 5,
						"h": 68,
						"w": 344
					},
					{
						"n": 6,
						"h": 387,
						"w": 75
					},
					{
						"n": 18,
						"h": 297,
						"w": 274
					},
					{
						"n": 15,
						"h": 167,
						"w": 119
					},
					{
						"n": 17,
						"h": 79,
						"w": 115
					},
					{
						"n": 20,
						"h": 287,
						"w": 50
					},
					{
						"n": 19,
						"h": 170,
						"w": 64,
						"m": 640
					}
				],
				"away": [
					{
						"n": 12,
						"h": 236,
						"w": 710
					},
					{
						"n": 13,
						"h": 369,
						"w": 624
					},
					{
						"n": 3,
						"h": 288,
						"w": 659,
						"m": 740
					},
					{
						"n": 14,
						"h": 180,
						"w": 661
					},
					{
						"n": 5,
						"h": 110,
						"w": 670
					},
					{
						"n": 16,
						"h": 295,
						"w": 604
					},
					{
						"n": 15,
						"h": 215,
						"w": 492
					},
					{
						"n": 18,
						"h": 28,
						"w": 580
					},
					{
						"n": 17,
						"h": 405,
						"w": 509
					},
					{
						"n": 19,
						"h": 277,
						"w": 416
					},
					{
						"n": 20,
						"h": 167,
						"w": 471
					}
				],
				"ball": {
					"n": 0,
					"h": 162,
					"w": 61,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 15
		},
		{
			"num": 1838,
			"minute": 88,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 701
					},
					{
						"n": 2,
						"h": 359,
						"w": 380
					},
					{
						"n": 14,
						"h": 273,
						"w": 406
					},
					{
						"n": 13,
						"h": 175,
						"w": 424
					},
					{
						"n": 5,
						"h": 84,
						"w": 381
					},
					{
						"n": 6,
						"h": 393,
						"w": 115
					},
					{
						"n": 18,
						"h": 296,
						"w": 314
					},
					{
						"n": 15,
						"h": 172,
						"w": 159
					},
					{
						"n": 17,
						"h": 69,
						"w": 154
					},
					{
						"n": 20,
						"h": 277,
						"w": 89
					},
					{
						"n": 19,
						"h": 156,
						"w": 70
					}
				],
				"away": [
					{
						"n": 12,
						"h": 225,
						"w": 708
					},
					{
						"n": 13,
						"h": 377,
						"w": 584
					},
					{
						"n": 3,
						"h": 323,
						"w": 659
					},
					{
						"n": 14,
						"h": 176,
						"w": 642
					},
					{
						"n": 5,
						"h": 87,
						"w": 637
					},
					{
						"n": 16,
						"h": 273,
						"w": 570
					},
					{
						"n": 15,
						"h": 221,
						"w": 452
					},
					{
						"n": 18,
						"h": 29,
						"w": 540
					},
					{
						"n": 17,
						"h": 408,
						"w": 469
					},
					{
						"n": 19,
						"h": 292,
						"w": 379
					},
					{
						"n": 20,
						"h": 162,
						"w": 431
					}
				],
				"ball": {
					"n": 0,
					"h": 127,
					"w": 61,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1839,
			"minute": 89,
			"possession": 0,
			"messages": [
				{
					"owner": 0,
					"mes": "К основному времени матча добавлено 3 минуты."
				}
			],
			"D": 3
		},
		{
			"num": 1840,
			"minute": 89,
			"possession": 43,
			"messages": [
				{
					"owner": 2,
					"mes": "Видя свободного А.Фрешля[39](Опава), Нир Мансур[23](Опава) отдает пас вперед..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 710
					},
					{
						"n": 2,
						"h": 333,
						"w": 440
					},
					{
						"n": 14,
						"h": 284,
						"w": 446,
						"f": 93
					},
					{
						"n": 13,
						"h": 222,
						"w": 444
					},
					{
						"n": 5,
						"h": 141,
						"w": 412,
						"f": 75
					},
					{
						"n": 6,
						"h": 401,
						"w": 179,
						"f": 73
					},
					{
						"n": 18,
						"h": 289,
						"w": 366
					},
					{
						"n": 15,
						"h": 186,
						"w": 222,
						"f": 90
					},
					{
						"n": 17,
						"h": 65,
						"w": 219
					},
					{
						"n": 20,
						"h": 279,
						"w": 131,
						"f": 80
					},
					{
						"n": 19,
						"h": 172,
						"w": 132
					}
				],
				"away": [
					{
						"n": 12,
						"h": 226,
						"w": 707
					},
					{
						"n": 13,
						"h": 392,
						"w": 521
					},
					{
						"n": 3,
						"h": 315,
						"w": 653
					},
					{
						"n": 14,
						"h": 171,
						"w": 609,
						"f": 84,
						"c": 2
					},
					{
						"n": 5,
						"h": 63,
						"w": 627,
						"f": 74,
						"c": 4
					},
					{
						"n": 16,
						"h": 252,
						"w": 509
					},
					{
						"n": 15,
						"h": 233,
						"w": 389,
						"f": 93
					},
					{
						"n": 18,
						"h": 35,
						"w": 475,
						"f": 90
					},
					{
						"n": 17,
						"h": 398,
						"w": 405
					},
					{
						"n": 19,
						"h": 309,
						"w": 400,
						"f": 88
					},
					{
						"n": 20,
						"h": 154,
						"w": 367,
						"m": 670
					}
				],
				"ball": {
					"n": 0,
					"h": 141,
					"w": 320,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 65
		},
		{
			"num": 1841,
			"minute": 89,
			"messages": [
				{
					"owner": 2,
					"mes": "Александр Фрешль[39](Опава) делает передачу налево на М.Томасова[37](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 704
					},
					{
						"n": 2,
						"h": 334,
						"w": 456
					},
					{
						"n": 14,
						"h": 294,
						"w": 458
					},
					{
						"n": 13,
						"h": 220,
						"w": 460
					},
					{
						"n": 5,
						"h": 136,
						"w": 427
					},
					{
						"n": 6,
						"h": 403,
						"w": 195
					},
					{
						"n": 18,
						"h": 295,
						"w": 382
					},
					{
						"n": 15,
						"h": 182,
						"w": 238
					},
					{
						"n": 17,
						"h": 73,
						"w": 233
					},
					{
						"n": 20,
						"h": 280,
						"w": 147
					},
					{
						"n": 19,
						"h": 176,
						"w": 148
					}
				],
				"away": [
					{
						"n": 12,
						"h": 224,
						"w": 706
					},
					{
						"n": 13,
						"h": 394,
						"w": 505
					},
					{
						"n": 3,
						"h": 303,
						"w": 635
					},
					{
						"n": 14,
						"h": 171,
						"w": 609
					},
					{
						"n": 5,
						"h": 67,
						"w": 612
					},
					{
						"n": 16,
						"h": 251,
						"w": 493
					},
					{
						"n": 15,
						"h": 238,
						"w": 373
					},
					{
						"n": 18,
						"h": 36,
						"w": 459
					},
					{
						"n": 17,
						"h": 383,
						"w": 411
					},
					{
						"n": 19,
						"h": 309,
						"w": 394
					},
					{
						"n": 20,
						"h": 151,
						"w": 351
					}
				],
				"ball": {
					"n": 0,
					"h": 116,
					"w": 300,
					"z": 0,
					"r": 0,
					"p": 2,
					"x": 0
				}
			},
			"interval": 16
		},
		{
			"num": 1842,
			"minute": 89,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 702
					},
					{
						"n": 2,
						"h": 331,
						"w": 466
					},
					{
						"n": 14,
						"h": 289,
						"w": 466
					},
					{
						"n": 13,
						"h": 210,
						"w": 457
					},
					{
						"n": 5,
						"h": 132,
						"w": 418
					},
					{
						"n": 6,
						"h": 403,
						"w": 205
					},
					{
						"n": 18,
						"h": 305,
						"w": 383
					},
					{
						"n": 15,
						"h": 178,
						"w": 247
					},
					{
						"n": 17,
						"h": 78,
						"w": 241
					},
					{
						"n": 20,
						"h": 280,
						"w": 157
					},
					{
						"n": 19,
						"h": 178,
						"w": 158
					}
				],
				"away": [
					{
						"n": 12,
						"h": 227,
						"w": 704
					},
					{
						"n": 13,
						"h": 396,
						"w": 495
					},
					{
						"n": 3,
						"h": 295,
						"w": 624
					},
					{
						"n": 14,
						"h": 171,
						"w": 609
					},
					{
						"n": 5,
						"h": 73,
						"w": 605
					},
					{
						"n": 16,
						"h": 252,
						"w": 483
					},
					{
						"n": 15,
						"h": 247,
						"w": 369
					},
					{
						"n": 18,
						"h": 36,
						"w": 449
					},
					{
						"n": 17,
						"h": 374,
						"w": 414
					},
					{
						"n": 19,
						"h": 308,
						"w": 389
					},
					{
						"n": 20,
						"h": 151,
						"w": 341
					}
				],
				"ball": {
					"n": 0,
					"h": 108,
					"w": 294,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 10
		},
		{
			"num": 1843,
			"minute": 89,
			"messages": [
				{
					"owner": 2,
					"mes": "Марин Томасов[37](Опава) принимает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 707
					},
					{
						"n": 2,
						"h": 330,
						"w": 463
					},
					{
						"n": 14,
						"h": 291,
						"w": 472
					},
					{
						"n": 13,
						"h": 224,
						"w": 457
					},
					{
						"n": 5,
						"h": 113,
						"w": 436
					},
					{
						"n": 6,
						"h": 404,
						"w": 239
					},
					{
						"n": 18,
						"h": 296,
						"w": 416
					},
					{
						"n": 15,
						"h": 170,
						"w": 280
					},
					{
						"n": 17,
						"h": 95,
						"w": 271
					},
					{
						"n": 20,
						"h": 282,
						"w": 191
					},
					{
						"n": 19,
						"h": 189,
						"w": 190
					}
				],
				"away": [
					{
						"n": 12,
						"h": 225,
						"w": 707
					},
					{
						"n": 13,
						"h": 395,
						"w": 461
					},
					{
						"n": 3,
						"h": 283,
						"w": 600
					},
					{
						"n": 14,
						"h": 164,
						"w": 594
					},
					{
						"n": 5,
						"h": 73,
						"w": 583
					},
					{
						"n": 16,
						"h": 239,
						"w": 489
					},
					{
						"n": 15,
						"h": 228,
						"w": 342
					},
					{
						"n": 18,
						"h": 38,
						"w": 415
					},
					{
						"n": 17,
						"h": 342,
						"w": 426,
						"m": 670
					},
					{
						"n": 19,
						"h": 305,
						"w": 356
					},
					{
						"n": 20,
						"h": 158,
						"w": 308
					}
				],
				"ball": {
					"n": 0,
					"h": 108,
					"w": 294,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 34
		},
		{
			"num": 1844,
			"minute": 89,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 702
					},
					{
						"n": 2,
						"h": 330,
						"w": 474
					},
					{
						"n": 14,
						"h": 286,
						"w": 479
					},
					{
						"n": 13,
						"h": 187,
						"w": 460
					},
					{
						"n": 5,
						"h": 113,
						"w": 442
					},
					{
						"n": 6,
						"h": 401,
						"w": 279
					},
					{
						"n": 18,
						"h": 307,
						"w": 414
					},
					{
						"n": 15,
						"h": 165,
						"w": 320
					},
					{
						"n": 17,
						"h": 82,
						"w": 308
					},
					{
						"n": 20,
						"h": 283,
						"w": 231
					},
					{
						"n": 19,
						"h": 198,
						"w": 229
					}
				],
				"away": [
					{
						"n": 12,
						"h": 225,
						"w": 702
					},
					{
						"n": 13,
						"h": 420,
						"w": 441
					},
					{
						"n": 3,
						"h": 267,
						"w": 597
					},
					{
						"n": 14,
						"h": 166,
						"w": 589
					},
					{
						"n": 5,
						"h": 58,
						"w": 570
					},
					{
						"n": 16,
						"h": 238,
						"w": 449
					},
					{
						"n": 15,
						"h": 234,
						"w": 351
					},
					{
						"n": 18,
						"h": 43,
						"w": 376
					},
					{
						"n": 17,
						"h": 342,
						"w": 400
					},
					{
						"n": 19,
						"h": 297,
						"w": 316
					},
					{
						"n": 20,
						"h": 134,
						"w": 285
					}
				],
				"ball": {
					"n": 0,
					"h": 108,
					"w": 320,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1845,
			"minute": 89,
			"messages": [
				{
					"owner": 2,
					"mes": "Марин Томасов[37](Опава) пасует на ход А.Карабецу[35](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 710
					},
					{
						"n": 2,
						"h": 330,
						"w": 496
					},
					{
						"n": 14,
						"h": 285,
						"w": 491
					},
					{
						"n": 13,
						"h": 169,
						"w": 500
					},
					{
						"n": 5,
						"h": 119,
						"w": 491
					},
					{
						"n": 6,
						"h": 399,
						"w": 328
					},
					{
						"n": 18,
						"h": 305,
						"w": 438
					},
					{
						"n": 15,
						"h": 174,
						"w": 368
					},
					{
						"n": 17,
						"h": 60,
						"w": 353
					},
					{
						"n": 20,
						"h": 246,
						"w": 263
					},
					{
						"n": 19,
						"h": 182,
						"w": 275
					}
				],
				"away": [
					{
						"n": 12,
						"h": 222,
						"w": 681
					},
					{
						"n": 13,
						"h": 401,
						"w": 481
					},
					{
						"n": 3,
						"h": 274,
						"w": 565
					},
					{
						"n": 14,
						"h": 178,
						"w": 553
					},
					{
						"n": 5,
						"h": 74,
						"w": 564
					},
					{
						"n": 16,
						"h": 213,
						"w": 469
					},
					{
						"n": 15,
						"h": 234,
						"w": 301
					},
					{
						"n": 18,
						"h": 45,
						"w": 327
					},
					{
						"n": 17,
						"h": 342,
						"w": 400,
						"m": 680
					},
					{
						"n": 19,
						"h": 295,
						"w": 268
					},
					{
						"n": 20,
						"h": 149,
						"w": 251
					}
				],
				"ball": {
					"n": 0,
					"h": 216,
					"w": 419,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 49
		},
		{
			"num": 1846,
			"minute": 89,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 706
					},
					{
						"n": 2,
						"h": 358,
						"w": 468
					},
					{
						"n": 14,
						"h": 277,
						"w": 519
					},
					{
						"n": 13,
						"h": 204,
						"w": 481
					},
					{
						"n": 5,
						"h": 152,
						"w": 514
					},
					{
						"n": 6,
						"h": 402,
						"w": 368
					},
					{
						"n": 18,
						"h": 269,
						"w": 455
					},
					{
						"n": 15,
						"h": 190,
						"w": 404
					},
					{
						"n": 17,
						"h": 43,
						"w": 388
					},
					{
						"n": 20,
						"h": 238,
						"w": 302
					},
					{
						"n": 19,
						"h": 175,
						"w": 315
					}
				],
				"away": [
					{
						"n": 12,
						"h": 220,
						"w": 658
					},
					{
						"n": 13,
						"h": 393,
						"w": 520
					},
					{
						"n": 3,
						"h": 284,
						"w": 547
					},
					{
						"n": 14,
						"h": 185,
						"w": 532
					},
					{
						"n": 5,
						"h": 60,
						"w": 532
					},
					{
						"n": 16,
						"h": 214,
						"w": 429
					},
					{
						"n": 15,
						"h": 234,
						"w": 266
					},
					{
						"n": 18,
						"h": 47,
						"w": 287
					},
					{
						"n": 17,
						"h": 357,
						"w": 363
					},
					{
						"n": 19,
						"h": 293,
						"w": 228
					},
					{
						"n": 20,
						"h": 155,
						"w": 211
					}
				],
				"ball": {
					"n": 0,
					"h": 216,
					"w": 454,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1847,
			"minute": 89,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 704
					},
					{
						"n": 2,
						"h": 377,
						"w": 493
					},
					{
						"n": 14,
						"h": 273,
						"w": 551
					},
					{
						"n": 13,
						"h": 233,
						"w": 505
					},
					{
						"n": 5,
						"h": 184,
						"w": 538
					},
					{
						"n": 6,
						"h": 405,
						"w": 407
					},
					{
						"n": 18,
						"h": 267,
						"w": 457
					},
					{
						"n": 15,
						"h": 191,
						"w": 432
					},
					{
						"n": 17,
						"h": 70,
						"w": 418
					},
					{
						"n": 20,
						"h": 267,
						"w": 330
					},
					{
						"n": 19,
						"h": 208,
						"w": 338
					}
				],
				"away": [
					{
						"n": 12,
						"h": 220,
						"w": 639
					},
					{
						"n": 13,
						"h": 395,
						"w": 480
					},
					{
						"n": 3,
						"h": 272,
						"w": 525
					},
					{
						"n": 14,
						"h": 168,
						"w": 512
					},
					{
						"n": 5,
						"h": 58,
						"w": 519
					},
					{
						"n": 16,
						"h": 225,
						"w": 390
					},
					{
						"n": 15,
						"h": 217,
						"w": 235
					},
					{
						"n": 18,
						"h": 43,
						"w": 247
					},
					{
						"n": 17,
						"h": 368,
						"w": 324
					},
					{
						"n": 19,
						"h": 280,
						"w": 190
					},
					{
						"n": 20,
						"h": 158,
						"w": 200
					}
				],
				"ball": {
					"n": 0,
					"h": 233,
					"w": 485,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1848,
			"minute": 89,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 704
					},
					{
						"n": 2,
						"h": 379,
						"w": 533
					},
					{
						"n": 14,
						"h": 290,
						"w": 580
					},
					{
						"n": 13,
						"h": 200,
						"w": 514
					},
					{
						"n": 5,
						"h": 171,
						"w": 576
					},
					{
						"n": 6,
						"h": 406,
						"w": 427
					},
					{
						"n": 18,
						"h": 257,
						"w": 496
					},
					{
						"n": 15,
						"h": 184,
						"w": 464
					},
					{
						"n": 17,
						"h": 64,
						"w": 457
					},
					{
						"n": 20,
						"h": 246,
						"w": 363
					},
					{
						"n": 19,
						"h": 181,
						"w": 368
					}
				],
				"away": [
					{
						"n": 12,
						"h": 228,
						"w": 622
					},
					{
						"n": 13,
						"h": 401,
						"w": 441
					},
					{
						"n": 3,
						"h": 282,
						"w": 496
					},
					{
						"n": 14,
						"h": 165,
						"w": 472
					},
					{
						"n": 5,
						"h": 75,
						"w": 483
					},
					{
						"n": 16,
						"h": 221,
						"w": 350
					},
					{
						"n": 15,
						"h": 251,
						"w": 226
					},
					{
						"n": 18,
						"h": 41,
						"w": 207
					},
					{
						"n": 17,
						"h": 357,
						"w": 286
					},
					{
						"n": 19,
						"h": 300,
						"w": 159
					},
					{
						"n": 20,
						"h": 141,
						"w": 164
					}
				],
				"ball": {
					"n": 0,
					"h": 199,
					"w": 494,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1849,
			"minute": 89,
			"messages": [
				{
					"owner": 2,
					"mes": "Пасом в ноги А.Карабец[35](Опава) пытается найти М.Томасова[37](Опава)..."
				},
				{
					"owner": 2,
					"mes": "Марин Томасов[37](Опава) останавливает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 704
					},
					{
						"n": 2,
						"h": 353,
						"w": 567
					},
					{
						"n": 14,
						"h": 262,
						"w": 591
					},
					{
						"n": 13,
						"h": 186,
						"w": 554
					},
					{
						"n": 5,
						"h": 186,
						"w": 595
					},
					{
						"n": 6,
						"h": 398,
						"w": 470
					},
					{
						"n": 18,
						"h": 216,
						"w": 508
					},
					{
						"n": 15,
						"h": 143,
						"w": 476
					},
					{
						"n": 17,
						"h": 38,
						"w": 485
					},
					{
						"n": 20,
						"h": 282,
						"w": 378
					},
					{
						"n": 19,
						"h": 211,
						"w": 388
					}
				],
				"away": [
					{
						"n": 12,
						"h": 221,
						"w": 600
					},
					{
						"n": 13,
						"h": 398,
						"w": 398
					},
					{
						"n": 3,
						"h": 274,
						"w": 460
					},
					{
						"n": 14,
						"h": 172,
						"w": 465
					},
					{
						"n": 5,
						"h": 62,
						"w": 447
					},
					{
						"n": 16,
						"h": 239,
						"w": 352
					},
					{
						"n": 15,
						"h": 251,
						"w": 226,
						"m": 580
					},
					{
						"n": 18,
						"h": 50,
						"w": 165
					},
					{
						"n": 17,
						"h": 332,
						"w": 256
					},
					{
						"n": 19,
						"h": 281,
						"w": 151
					},
					{
						"n": 20,
						"h": 168,
						"w": 140
					}
				],
				"ball": {
					"n": 0,
					"h": 118,
					"w": 464,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 43
		},
		{
			"num": 1850,
			"minute": 89,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 705
					},
					{
						"n": 2,
						"h": 335,
						"w": 601
					},
					{
						"n": 14,
						"h": 254,
						"w": 593
					},
					{
						"n": 13,
						"h": 168,
						"w": 588
					},
					{
						"n": 5,
						"h": 148,
						"w": 596
					},
					{
						"n": 6,
						"h": 393,
						"w": 487
					},
					{
						"n": 18,
						"h": 235,
						"w": 519
					},
					{
						"n": 15,
						"h": 139,
						"w": 513
					},
					{
						"n": 17,
						"h": 56,
						"w": 485
					},
					{
						"n": 20,
						"h": 252,
						"w": 402
					},
					{
						"n": 19,
						"h": 175,
						"w": 377
					}
				],
				"away": [
					{
						"n": 12,
						"h": 226,
						"w": 593
					},
					{
						"n": 13,
						"h": 408,
						"w": 361
					},
					{
						"n": 3,
						"h": 280,
						"w": 476
					},
					{
						"n": 14,
						"h": 165,
						"w": 462
					},
					{
						"n": 5,
						"h": 61,
						"w": 461
					},
					{
						"n": 16,
						"h": 224,
						"w": 317
					},
					{
						"n": 15,
						"h": 222,
						"w": 201
					},
					{
						"n": 18,
						"h": 54,
						"w": 147
					},
					{
						"n": 17,
						"h": 315,
						"w": 227
					},
					{
						"n": 19,
						"h": 299,
						"w": 141
					},
					{
						"n": 20,
						"h": 178,
						"w": 151
					}
				],
				"ball": {
					"n": 0,
					"h": 135,
					"w": 493,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 38
		},
		{
			"num": 1851,
			"minute": 89,
			"messages": [
				{
					"owner": 2,
					"mes": "Передача вперед..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 216,
						"w": 708
					},
					{
						"n": 2,
						"h": 330,
						"w": 617
					},
					{
						"n": 14,
						"h": 257,
						"w": 600
					},
					{
						"n": 13,
						"h": 197,
						"w": 607
					},
					{
						"n": 5,
						"h": 140,
						"w": 597
					},
					{
						"n": 6,
						"h": 388,
						"w": 510
					},
					{
						"n": 18,
						"h": 259,
						"w": 534
					},
					{
						"n": 15,
						"h": 126,
						"w": 514
					},
					{
						"n": 17,
						"h": 56,
						"w": 450
					},
					{
						"n": 20,
						"h": 281,
						"w": 381
					},
					{
						"n": 19,
						"h": 206,
						"w": 392
					}
				],
				"away": [
					{
						"n": 12,
						"h": 226,
						"w": 600
					},
					{
						"n": 13,
						"h": 409,
						"w": 326
					},
					{
						"n": 3,
						"h": 270,
						"w": 459
					},
					{
						"n": 14,
						"h": 170,
						"w": 445
					},
					{
						"n": 5,
						"h": 72,
						"w": 450
					},
					{
						"n": 16,
						"h": 231,
						"w": 342
					},
					{
						"n": 15,
						"h": 228,
						"w": 167
					},
					{
						"n": 18,
						"h": 44,
						"w": 143
					},
					{
						"n": 17,
						"h": 323,
						"w": 220
					},
					{
						"n": 19,
						"h": 328,
						"w": 132
					},
					{
						"n": 20,
						"h": 163,
						"w": 130
					}
				],
				"ball": {
					"n": 0,
					"h": 80,
					"w": 583,
					"z": 0,
					"r": 0,
					"p": 1,
					"x": 0
				}
			},
			"interval": 35
		},
		{
			"num": 1852,
			"minute": 89,
			"messages": [
				{
					"owner": 2,
					"mes": "Александр Фрешль[39](Опава) принимает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 213,
						"w": 711
					},
					{
						"n": 2,
						"h": 330,
						"w": 633
					},
					{
						"n": 14,
						"h": 227,
						"w": 631
					},
					{
						"n": 13,
						"h": 185,
						"w": 627
					},
					{
						"n": 5,
						"h": 91,
						"w": 610
					},
					{
						"n": 6,
						"h": 405,
						"w": 539
					},
					{
						"n": 18,
						"h": 242,
						"w": 549
					},
					{
						"n": 15,
						"h": 135,
						"w": 550
					},
					{
						"n": 17,
						"h": 61,
						"w": 500
					},
					{
						"n": 20,
						"h": 284,
						"w": 387
					},
					{
						"n": 19,
						"h": 186,
						"w": 437
					}
				],
				"away": [
					{
						"n": 12,
						"h": 225,
						"w": 596
					},
					{
						"n": 13,
						"h": 397,
						"w": 277
					},
					{
						"n": 3,
						"h": 276,
						"w": 426
					},
					{
						"n": 14,
						"h": 163,
						"w": 422
					},
					{
						"n": 5,
						"h": 56,
						"w": 436
					},
					{
						"n": 16,
						"h": 264,
						"w": 303
					},
					{
						"n": 15,
						"h": 261,
						"w": 145
					},
					{
						"n": 18,
						"h": 50,
						"w": 98
					},
					{
						"n": 17,
						"h": 325,
						"w": 169
					},
					{
						"n": 19,
						"h": 383,
						"w": 115
					},
					{
						"n": 20,
						"h": 208,
						"w": 106
					}
				],
				"ball": {
					"n": 0,
					"h": 67,
					"w": 605,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 51
		},
		{
			"num": 1853,
			"minute": 89,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 212,
						"w": 713
					},
					{
						"n": 2,
						"h": 330,
						"w": 666
					},
					{
						"n": 14,
						"h": 236,
						"w": 670
					},
					{
						"n": 13,
						"h": 185,
						"w": 660
					},
					{
						"n": 5,
						"h": 67,
						"w": 633
					},
					{
						"n": 6,
						"h": 412,
						"w": 550
					},
					{
						"n": 18,
						"h": 249,
						"w": 580
					},
					{
						"n": 15,
						"h": 128,
						"w": 582
					},
					{
						"n": 17,
						"h": 56,
						"w": 511
					},
					{
						"n": 20,
						"h": 287,
						"w": 379
					},
					{
						"n": 19,
						"h": 190,
						"w": 470
					}
				],
				"away": [
					{
						"n": 12,
						"h": 230,
						"w": 600
					},
					{
						"n": 13,
						"h": 394,
						"w": 244
					},
					{
						"n": 3,
						"h": 269,
						"w": 414
					},
					{
						"n": 14,
						"h": 188,
						"w": 430
					},
					{
						"n": 5,
						"h": 72,
						"w": 428
					},
					{
						"n": 16,
						"h": 260,
						"w": 270
					},
					{
						"n": 15,
						"h": 235,
						"w": 124
					},
					{
						"n": 18,
						"h": 42,
						"w": 71
					},
					{
						"n": 17,
						"h": 327,
						"w": 136
					},
					{
						"n": 19,
						"h": 383,
						"w": 87
					},
					{
						"n": 20,
						"h": 223,
						"w": 77
					}
				],
				"ball": {
					"n": 0,
					"h": 67,
					"w": 633,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 33
		},
		{
			"num": 1854,
			"minute": 89,
			"messages": [
				{
					"owner": 2,
					"mes": "А.Фрешль[39](Опава) пытается пройти С.Фридйонссона[05](Галвэй Юнайтед)..."
				},
				{
					"owner": 2,
					"mes": "Классный отбор С.Фридйонссона[05](Галвэй Юнайтед)!.."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 212,
						"w": 713
					},
					{
						"n": 2,
						"h": 330,
						"w": 670
					},
					{
						"n": 14,
						"h": 237,
						"w": 674
					},
					{
						"n": 13,
						"h": 185,
						"w": 660
					},
					{
						"n": 5,
						"h": 59,
						"w": 640,
						"m": 710
					},
					{
						"n": 6,
						"h": 418,
						"w": 558
					},
					{
						"n": 18,
						"h": 249,
						"w": 580
					},
					{
						"n": 15,
						"h": 127,
						"w": 584
					},
					{
						"n": 17,
						"h": 56,
						"w": 511
					},
					{
						"n": 20,
						"h": 287,
						"w": 379
					},
					{
						"n": 19,
						"h": 190,
						"w": 470
					}
				],
				"away": [
					{
						"n": 12,
						"h": 230,
						"w": 600
					},
					{
						"n": 13,
						"h": 393,
						"w": 234
					},
					{
						"n": 3,
						"h": 269,
						"w": 414
					},
					{
						"n": 14,
						"h": 188,
						"w": 430
					},
					{
						"n": 5,
						"h": 72,
						"w": 428
					},
					{
						"n": 16,
						"h": 259,
						"w": 260
					},
					{
						"n": 15,
						"h": 234,
						"w": 123
					},
					{
						"n": 18,
						"h": 42,
						"w": 71
					},
					{
						"n": 17,
						"h": 327,
						"w": 126
					},
					{
						"n": 19,
						"h": 383,
						"w": 77,
						"m": 660
					},
					{
						"n": 20,
						"h": 228,
						"w": 68
					}
				],
				"ball": {
					"n": 0,
					"h": 59,
					"w": 640,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 10
		},
		{
			"num": 1855,
			"minute": 89,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 707
					},
					{
						"n": 2,
						"h": 344,
						"w": 633
					},
					{
						"n": 14,
						"h": 256,
						"w": 639
					},
					{
						"n": 13,
						"h": 183,
						"w": 620
					},
					{
						"n": 5,
						"h": 29,
						"w": 623
					},
					{
						"n": 6,
						"h": 415,
						"w": 518
					},
					{
						"n": 18,
						"h": 259,
						"w": 541
					},
					{
						"n": 15,
						"h": 130,
						"w": 544
					},
					{
						"n": 17,
						"h": 52,
						"w": 471
					},
					{
						"n": 20,
						"h": 298,
						"w": 341
					},
					{
						"n": 19,
						"h": 179,
						"w": 431
					}
				],
				"away": [
					{
						"n": 12,
						"h": 242,
						"w": 638
					},
					{
						"n": 13,
						"h": 396,
						"w": 274
					},
					{
						"n": 3,
						"h": 251,
						"w": 450
					},
					{
						"n": 14,
						"h": 164,
						"w": 462
					},
					{
						"n": 5,
						"h": 97,
						"w": 459
					},
					{
						"n": 16,
						"h": 255,
						"w": 300
					},
					{
						"n": 15,
						"h": 234,
						"w": 163
					},
					{
						"n": 18,
						"h": 41,
						"w": 111
					},
					{
						"n": 17,
						"h": 343,
						"w": 162
					},
					{
						"n": 19,
						"h": 390,
						"w": 84
					},
					{
						"n": 20,
						"h": 217,
						"w": 106
					}
				],
				"ball": {
					"n": 0,
					"h": 29,
					"w": 623,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1856,
			"minute": 89,
			"messages": [
				{
					"owner": 1,
					"mes": "Пас вперед..."
				},
				{
					"owner": 1,
					"mes": "Байрон О`Горман[19](Галвэй Юнайтед) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 701
					},
					{
						"n": 2,
						"h": 359,
						"w": 573
					},
					{
						"n": 14,
						"h": 270,
						"w": 579
					},
					{
						"n": 13,
						"h": 168,
						"w": 561
					},
					{
						"n": 5,
						"h": 31,
						"w": 613,
						"m": 720
					},
					{
						"n": 6,
						"h": 409,
						"w": 458
					},
					{
						"n": 18,
						"h": 275,
						"w": 482
					},
					{
						"n": 15,
						"h": 142,
						"w": 484
					},
					{
						"n": 17,
						"h": 53,
						"w": 410
					},
					{
						"n": 20,
						"h": 299,
						"w": 280
					},
					{
						"n": 19,
						"h": 120,
						"w": 416
					}
				],
				"away": [
					{
						"n": 12,
						"h": 245,
						"w": 644
					},
					{
						"n": 13,
						"h": 396,
						"w": 335
					},
					{
						"n": 3,
						"h": 228,
						"w": 471
					},
					{
						"n": 14,
						"h": 153,
						"w": 452
					},
					{
						"n": 5,
						"h": 110,
						"w": 454
					},
					{
						"n": 16,
						"h": 313,
						"w": 320
					},
					{
						"n": 15,
						"h": 234,
						"w": 224
					},
					{
						"n": 18,
						"h": 45,
						"w": 172
					},
					{
						"n": 17,
						"h": 370,
						"w": 217
					},
					{
						"n": 19,
						"h": 364,
						"w": 139
					},
					{
						"n": 20,
						"h": 201,
						"w": 165
					}
				],
				"ball": {
					"n": 0,
					"h": 120,
					"w": 416,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 61
		},
		{
			"num": 1857,
			"minute": 89,
			"messages": [
				{
					"owner": 1,
					"mes": "Байрон О`Горман[19](Галвэй Юнайтед) низом отдает на К.Келли[15](Галвэй Юнайтед)..."
				},
				{
					"owner": 1,
					"mes": "Кевин Келли[15](Галвэй Юнайтед) принимает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 701
					},
					{
						"n": 2,
						"h": 363,
						"w": 552
					},
					{
						"n": 14,
						"h": 269,
						"w": 577
					},
					{
						"n": 13,
						"h": 170,
						"w": 560
					},
					{
						"n": 5,
						"h": 43,
						"w": 586
					},
					{
						"n": 6,
						"h": 408,
						"w": 436
					},
					{
						"n": 18,
						"h": 282,
						"w": 461
					},
					{
						"n": 15,
						"h": 129,
						"w": 459
					},
					{
						"n": 17,
						"h": 46,
						"w": 404
					},
					{
						"n": 20,
						"h": 305,
						"w": 271
					},
					{
						"n": 19,
						"h": 120,
						"w": 416,
						"m": 650
					}
				],
				"away": [
					{
						"n": 12,
						"h": 235,
						"w": 641
					},
					{
						"n": 13,
						"h": 379,
						"w": 322
					},
					{
						"n": 3,
						"h": 228,
						"w": 484
					},
					{
						"n": 14,
						"h": 145,
						"w": 472
					},
					{
						"n": 5,
						"h": 110,
						"w": 476
					},
					{
						"n": 16,
						"h": 297,
						"w": 335
					},
					{
						"n": 15,
						"h": 232,
						"w": 246
					},
					{
						"n": 18,
						"h": 45,
						"w": 194
					},
					{
						"n": 17,
						"h": 379,
						"w": 237
					},
					{
						"n": 19,
						"h": 359,
						"w": 161
					},
					{
						"n": 20,
						"h": 195,
						"w": 186
					}
				],
				"ball": {
					"n": 0,
					"h": 129,
					"w": 459,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 22
		},
		{
			"num": 1858,
			"minute": 89,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 706
					},
					{
						"n": 2,
						"h": 378,
						"w": 518
					},
					{
						"n": 14,
						"h": 278,
						"w": 547
					},
					{
						"n": 13,
						"h": 178,
						"w": 549
					},
					{
						"n": 5,
						"h": 58,
						"w": 552
					},
					{
						"n": 6,
						"h": 409,
						"w": 399
					},
					{
						"n": 18,
						"h": 245,
						"w": 457
					},
					{
						"n": 15,
						"h": 141,
						"w": 424
					},
					{
						"n": 17,
						"h": 44,
						"w": 367
					},
					{
						"n": 20,
						"h": 289,
						"w": 269
					},
					{
						"n": 19,
						"h": 126,
						"w": 380
					}
				],
				"away": [
					{
						"n": 12,
						"h": 235,
						"w": 643
					},
					{
						"n": 13,
						"h": 366,
						"w": 311
					},
					{
						"n": 3,
						"h": 225,
						"w": 480
					},
					{
						"n": 14,
						"h": 146,
						"w": 492
					},
					{
						"n": 5,
						"h": 110,
						"w": 476
					},
					{
						"n": 16,
						"h": 308,
						"w": 300
					},
					{
						"n": 15,
						"h": 229,
						"w": 283
					},
					{
						"n": 18,
						"h": 43,
						"w": 231
					},
					{
						"n": 17,
						"h": 385,
						"w": 253
					},
					{
						"n": 19,
						"h": 344,
						"w": 195
					},
					{
						"n": 20,
						"h": 185,
						"w": 222
					}
				],
				"ball": {
					"n": 0,
					"h": 141,
					"w": 424,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 37
		},
		{
			"num": 1859,
			"minute": 89,
			"messages": [
				{
					"owner": 1,
					"mes": "Михаэль Владарж[36](Опава) выбивает мяч из-под ног К.Келли[15](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 706
					},
					{
						"n": 2,
						"h": 387,
						"w": 502
					},
					{
						"n": 14,
						"h": 275,
						"w": 552
					},
					{
						"n": 13,
						"h": 169,
						"w": 547
					},
					{
						"n": 5,
						"h": 62,
						"w": 532
					},
					{
						"n": 6,
						"h": 409,
						"w": 378
					},
					{
						"n": 18,
						"h": 224,
						"w": 454
					},
					{
						"n": 15,
						"h": 141,
						"w": 424,
						"m": 640
					},
					{
						"n": 17,
						"h": 47,
						"w": 347
					},
					{
						"n": 20,
						"h": 291,
						"w": 260
					},
					{
						"n": 19,
						"h": 125,
						"w": 401
					}
				],
				"away": [
					{
						"n": 12,
						"h": 235,
						"w": 649
					},
					{
						"n": 13,
						"h": 373,
						"w": 330
					},
					{
						"n": 3,
						"h": 230,
						"w": 492
					},
					{
						"n": 14,
						"h": 161,
						"w": 488
					},
					{
						"n": 5,
						"h": 110,
						"w": 489
					},
					{
						"n": 16,
						"h": 310,
						"w": 304,
						"m": 670
					},
					{
						"n": 15,
						"h": 229,
						"w": 304
					},
					{
						"n": 18,
						"h": 43,
						"w": 252
					},
					{
						"n": 17,
						"h": 364,
						"w": 255
					},
					{
						"n": 19,
						"h": 327,
						"w": 207
					},
					{
						"n": 20,
						"h": 183,
						"w": 243
					}
				],
				"ball": {
					"n": 0,
					"h": 123,
					"w": 462,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 21
		},
		{
			"num": 1860,
			"minute": 89,
			"messages": [
				{
					"owner": 2,
					"mes": "Марин Томасов[37](Опава) завладевает мячом..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 702
					},
					{
						"n": 2,
						"h": 382,
						"w": 486
					},
					{
						"n": 14,
						"h": 282,
						"w": 542
					},
					{
						"n": 13,
						"h": 171,
						"w": 553
					},
					{
						"n": 5,
						"h": 60,
						"w": 497
					},
					{
						"n": 6,
						"h": 406,
						"w": 343
					},
					{
						"n": 18,
						"h": 244,
						"w": 425
					},
					{
						"n": 15,
						"h": 141,
						"w": 424
					},
					{
						"n": 17,
						"h": 51,
						"w": 312
					},
					{
						"n": 20,
						"h": 300,
						"w": 257
					},
					{
						"n": 19,
						"h": 124,
						"w": 436
					}
				],
				"away": [
					{
						"n": 12,
						"h": 235,
						"w": 650
					},
					{
						"n": 13,
						"h": 381,
						"w": 365
					},
					{
						"n": 3,
						"h": 233,
						"w": 501
					},
					{
						"n": 14,
						"h": 152,
						"w": 479
					},
					{
						"n": 5,
						"h": 110,
						"w": 488
					},
					{
						"n": 16,
						"h": 307,
						"w": 316
					},
					{
						"n": 15,
						"h": 226,
						"w": 338
					},
					{
						"n": 18,
						"h": 43,
						"w": 287
					},
					{
						"n": 17,
						"h": 327,
						"w": 258
					},
					{
						"n": 19,
						"h": 327,
						"w": 242
					},
					{
						"n": 20,
						"h": 194,
						"w": 276
					}
				],
				"ball": {
					"n": 0,
					"h": 123,
					"w": 462,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 35
		},
		{
			"num": 1861,
			"minute": 90,
			"possession": 42,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 703
					},
					{
						"n": 2,
						"h": 374,
						"w": 493
					},
					{
						"n": 14,
						"h": 248,
						"w": 557
					},
					{
						"n": 13,
						"h": 165,
						"w": 536,
						"f": 90
					},
					{
						"n": 5,
						"h": 99,
						"w": 501
					},
					{
						"n": 6,
						"h": 406,
						"w": 383
					},
					{
						"n": 18,
						"h": 253,
						"w": 464,
						"m": 670
					},
					{
						"n": 15,
						"h": 166,
						"w": 448
					},
					{
						"n": 17,
						"h": 46,
						"w": 352
					},
					{
						"n": 20,
						"h": 294,
						"w": 297,
						"m": 580
					},
					{
						"n": 19,
						"h": 105,
						"w": 471
					}
				],
				"away": [
					{
						"n": 12,
						"h": 221,
						"w": 633,
						"f": 90
					},
					{
						"n": 13,
						"h": 405,
						"w": 333
					},
					{
						"n": 3,
						"h": 268,
						"w": 510
					},
					{
						"n": 14,
						"h": 165,
						"w": 505
					},
					{
						"n": 5,
						"h": 72,
						"w": 486
					},
					{
						"n": 16,
						"h": 268,
						"w": 324
					},
					{
						"n": 15,
						"h": 237,
						"w": 377
					},
					{
						"n": 18,
						"h": 46,
						"w": 247
					},
					{
						"n": 17,
						"h": 360,
						"w": 239
					},
					{
						"n": 19,
						"h": 306,
						"w": 208
					},
					{
						"n": 20,
						"h": 185,
						"w": 237
					}
				],
				"ball": {
					"n": 0,
					"h": 90,
					"w": 481,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1862,
			"minute": 90,
			"messages": [
				{
					"owner": 2,
					"mes": "Пас правее на М.Владаржа[36](Опава)..."
				},
				{
					"owner": 2,
					"mes": "Байрон О`Горман[19](Галвэй Юнайтед) легко перехватывает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 704
					},
					{
						"n": 2,
						"h": 374,
						"w": 499
					},
					{
						"n": 14,
						"h": 248,
						"w": 563
					},
					{
						"n": 13,
						"h": 167,
						"w": 542
					},
					{
						"n": 5,
						"h": 99,
						"w": 501
					},
					{
						"n": 6,
						"h": 405,
						"w": 389
					},
					{
						"n": 18,
						"h": 254,
						"w": 470
					},
					{
						"n": 15,
						"h": 168,
						"w": 443
					},
					{
						"n": 17,
						"h": 45,
						"w": 358
					},
					{
						"n": 20,
						"h": 293,
						"w": 303
					},
					{
						"n": 19,
						"h": 101,
						"w": 475
					}
				],
				"away": [
					{
						"n": 12,
						"h": 223,
						"w": 628
					},
					{
						"n": 13,
						"h": 405,
						"w": 327
					},
					{
						"n": 3,
						"h": 272,
						"w": 505
					},
					{
						"n": 14,
						"h": 168,
						"w": 500
					},
					{
						"n": 5,
						"h": 69,
						"w": 480
					},
					{
						"n": 16,
						"h": 272,
						"w": 320,
						"m": 660
					},
					{
						"n": 15,
						"h": 232,
						"w": 380
					},
					{
						"n": 18,
						"h": 46,
						"w": 241
					},
					{
						"n": 17,
						"h": 360,
						"w": 239,
						"m": 670
					},
					{
						"n": 19,
						"h": 302,
						"w": 204
					},
					{
						"n": 20,
						"h": 183,
						"w": 231
					}
				],
				"ball": {
					"n": 0,
					"h": 101,
					"w": 475,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 6
		},
		{
			"num": 1863,
			"minute": 90,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 705
					},
					{
						"n": 2,
						"h": 372,
						"w": 475
					},
					{
						"n": 14,
						"h": 265,
						"w": 537
					},
					{
						"n": 13,
						"h": 179,
						"w": 526
					},
					{
						"n": 5,
						"h": 71,
						"w": 480
					},
					{
						"n": 6,
						"h": 405,
						"w": 349
					},
					{
						"n": 18,
						"h": 255,
						"w": 430
					},
					{
						"n": 15,
						"h": 160,
						"w": 403
					},
					{
						"n": 17,
						"h": 48,
						"w": 318
					},
					{
						"n": 20,
						"h": 300,
						"w": 264
					},
					{
						"n": 19,
						"h": 100,
						"w": 435,
						"m": 670
					}
				],
				"away": [
					{
						"n": 12,
						"h": 245,
						"w": 645
					},
					{
						"n": 13,
						"h": 404,
						"w": 371
					},
					{
						"n": 3,
						"h": 232,
						"w": 506
					},
					{
						"n": 14,
						"h": 150,
						"w": 525
					},
					{
						"n": 5,
						"h": 94,
						"w": 511
					},
					{
						"n": 16,
						"h": 262,
						"w": 359
					},
					{
						"n": 15,
						"h": 228,
						"w": 350
					},
					{
						"n": 18,
						"h": 45,
						"w": 281
					},
					{
						"n": 17,
						"h": 368,
						"w": 277
					},
					{
						"n": 19,
						"h": 319,
						"w": 240
					},
					{
						"n": 20,
						"h": 189,
						"w": 271
					}
				],
				"ball": {
					"n": 0,
					"h": 100,
					"w": 435,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1864,
			"minute": 90,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 710
					},
					{
						"n": 2,
						"h": 379,
						"w": 454
					},
					{
						"n": 14,
						"h": 281,
						"w": 501
					},
					{
						"n": 13,
						"h": 175,
						"w": 519
					},
					{
						"n": 5,
						"h": 67,
						"w": 461
					},
					{
						"n": 6,
						"h": 407,
						"w": 309
					},
					{
						"n": 18,
						"h": 275,
						"w": 395
					},
					{
						"n": 15,
						"h": 163,
						"w": 364
					},
					{
						"n": 17,
						"h": 45,
						"w": 278
					},
					{
						"n": 20,
						"h": 286,
						"w": 226
					},
					{
						"n": 19,
						"h": 138,
						"w": 422
					}
				],
				"away": [
					{
						"n": 12,
						"h": 235,
						"w": 645
					},
					{
						"n": 13,
						"h": 404,
						"w": 411
					},
					{
						"n": 3,
						"h": 225,
						"w": 528
					},
					{
						"n": 14,
						"h": 165,
						"w": 505
					},
					{
						"n": 5,
						"h": 110,
						"w": 520
					},
					{
						"n": 16,
						"h": 243,
						"w": 394
					},
					{
						"n": 15,
						"h": 227,
						"w": 376
					},
					{
						"n": 18,
						"h": 45,
						"w": 321
					},
					{
						"n": 17,
						"h": 332,
						"w": 300
					},
					{
						"n": 19,
						"h": 316,
						"w": 280
					},
					{
						"n": 20,
						"h": 182,
						"w": 310
					}
				],
				"ball": {
					"n": 0,
					"h": 138,
					"w": 422,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1865,
			"minute": 90,
			"messages": [
				{
					"owner": 1,
					"mes": "Передача вперед..."
				},
				{
					"owner": 1,
					"mes": "Кевин Келли[15](Галвэй Юнайтед) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 708
					},
					{
						"n": 2,
						"h": 378,
						"w": 463
					},
					{
						"n": 14,
						"h": 283,
						"w": 503
					},
					{
						"n": 13,
						"h": 174,
						"w": 503
					},
					{
						"n": 5,
						"h": 59,
						"w": 447
					},
					{
						"n": 6,
						"h": 401,
						"w": 283
					},
					{
						"n": 18,
						"h": 281,
						"w": 369
					},
					{
						"n": 15,
						"h": 155,
						"w": 372
					},
					{
						"n": 17,
						"h": 44,
						"w": 251
					},
					{
						"n": 20,
						"h": 273,
						"w": 231
					},
					{
						"n": 19,
						"h": 138,
						"w": 412
					}
				],
				"away": [
					{
						"n": 12,
						"h": 235,
						"w": 647
					},
					{
						"n": 13,
						"h": 404,
						"w": 438
					},
					{
						"n": 3,
						"h": 233,
						"w": 520
					},
					{
						"n": 14,
						"h": 177,
						"w": 527
					},
					{
						"n": 5,
						"h": 110,
						"w": 524
					},
					{
						"n": 16,
						"h": 238,
						"w": 420
					},
					{
						"n": 15,
						"h": 254,
						"w": 374
					},
					{
						"n": 18,
						"h": 47,
						"w": 348
					},
					{
						"n": 17,
						"h": 352,
						"w": 319
					},
					{
						"n": 19,
						"h": 314,
						"w": 307
					},
					{
						"n": 20,
						"h": 174,
						"w": 336
					}
				],
				"ball": {
					"n": 0,
					"h": 155,
					"w": 372,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 27
		},
		{
			"num": 1866,
			"minute": 90,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 707
					},
					{
						"n": 2,
						"h": 381,
						"w": 454
					},
					{
						"n": 14,
						"h": 267,
						"w": 515
					},
					{
						"n": 13,
						"h": 180,
						"w": 501
					},
					{
						"n": 5,
						"h": 62,
						"w": 447
					},
					{
						"n": 6,
						"h": 391,
						"w": 242
					},
					{
						"n": 18,
						"h": 275,
						"w": 327
					},
					{
						"n": 15,
						"h": 155,
						"w": 337
					},
					{
						"n": 17,
						"h": 35,
						"w": 220
					},
					{
						"n": 20,
						"h": 299,
						"w": 227
					},
					{
						"n": 19,
						"h": 140,
						"w": 370
					}
				],
				"away": [
					{
						"n": 12,
						"h": 235,
						"w": 647
					},
					{
						"n": 13,
						"h": 405,
						"w": 480
					},
					{
						"n": 3,
						"h": 207,
						"w": 552
					},
					{
						"n": 14,
						"h": 155,
						"w": 554
					},
					{
						"n": 5,
						"h": 110,
						"w": 546
					},
					{
						"n": 16,
						"h": 229,
						"w": 462
					},
					{
						"n": 15,
						"h": 295,
						"w": 383
					},
					{
						"n": 18,
						"h": 36,
						"w": 388
					},
					{
						"n": 17,
						"h": 371,
						"w": 356
					},
					{
						"n": 19,
						"h": 300,
						"w": 346
					},
					{
						"n": 20,
						"h": 164,
						"w": 377
					}
				],
				"ball": {
					"n": 0,
					"h": 155,
					"w": 337,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 42
		},
		{
			"num": 1867,
			"minute": 90,
			"messages": [
				{
					"owner": 1,
					"mes": "К.Келли[15](Галвэй Юнайтед) пытается пройти А.Карабеца[35](Опава)..."
				},
				{
					"owner": 1,
					"mes": "Кевин Келли[15](Галвэй Юнайтед) демонстрирует отличный дриблинг..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 707
					},
					{
						"n": 2,
						"h": 377,
						"w": 426
					},
					{
						"n": 14,
						"h": 266,
						"w": 475
					},
					{
						"n": 13,
						"h": 179,
						"w": 463
					},
					{
						"n": 5,
						"h": 70,
						"w": 424
					},
					{
						"n": 6,
						"h": 386,
						"w": 204
					},
					{
						"n": 18,
						"h": 294,
						"w": 295
					},
					{
						"n": 15,
						"h": 155,
						"w": 297,
						"m": 660
					},
					{
						"n": 17,
						"h": 37,
						"w": 204
					},
					{
						"n": 20,
						"h": 300,
						"w": 187
					},
					{
						"n": 19,
						"h": 136,
						"w": 330
					}
				],
				"away": [
					{
						"n": 12,
						"h": 235,
						"w": 641
					},
					{
						"n": 13,
						"h": 406,
						"w": 520
					},
					{
						"n": 3,
						"h": 244,
						"w": 566
					},
					{
						"n": 14,
						"h": 162,
						"w": 593
					},
					{
						"n": 5,
						"h": 110,
						"w": 584
					},
					{
						"n": 16,
						"h": 268,
						"w": 453
					},
					{
						"n": 15,
						"h": 304,
						"w": 385,
						"m": 570
					},
					{
						"n": 18,
						"h": 32,
						"w": 428
					},
					{
						"n": 17,
						"h": 396,
						"w": 387
					},
					{
						"n": 19,
						"h": 292,
						"w": 385
					},
					{
						"n": 20,
						"h": 162,
						"w": 413
					}
				],
				"ball": {
					"n": 0,
					"h": 155,
					"w": 297,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1868,
			"minute": 90,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 705
					},
					{
						"n": 2,
						"h": 374,
						"w": 392
					},
					{
						"n": 14,
						"h": 280,
						"w": 439
					},
					{
						"n": 13,
						"h": 185,
						"w": 451
					},
					{
						"n": 5,
						"h": 59,
						"w": 394
					},
					{
						"n": 6,
						"h": 403,
						"w": 169
					},
					{
						"n": 18,
						"h": 283,
						"w": 258
					},
					{
						"n": 15,
						"h": 151,
						"w": 263
					},
					{
						"n": 17,
						"h": 48,
						"w": 167
					},
					{
						"n": 20,
						"h": 288,
						"w": 150
					},
					{
						"n": 19,
						"h": 135,
						"w": 291
					}
				],
				"away": [
					{
						"n": 12,
						"h": 235,
						"w": 650
					},
					{
						"n": 13,
						"h": 404,
						"w": 559
					},
					{
						"n": 3,
						"h": 269,
						"w": 596
					},
					{
						"n": 14,
						"h": 177,
						"w": 594
					},
					{
						"n": 5,
						"h": 110,
						"w": 610
					},
					{
						"n": 16,
						"h": 299,
						"w": 477
					},
					{
						"n": 15,
						"h": 282,
						"w": 417
					},
					{
						"n": 18,
						"h": 35,
						"w": 467
					},
					{
						"n": 17,
						"h": 402,
						"w": 426
					},
					{
						"n": 19,
						"h": 282,
						"w": 421
					},
					{
						"n": 20,
						"h": 157,
						"w": 420
					}
				],
				"ball": {
					"n": 0,
					"h": 151,
					"w": 263,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 39
		},
		{
			"num": 1869,
			"minute": 90,
			"messages": [
				{
					"owner": 1,
					"mes": "Пас налево К.Колману[06](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 702
					},
					{
						"n": 2,
						"h": 382,
						"w": 381
					},
					{
						"n": 14,
						"h": 275,
						"w": 417
					},
					{
						"n": 13,
						"h": 178,
						"w": 424
					},
					{
						"n": 5,
						"h": 61,
						"w": 378
					},
					{
						"n": 6,
						"h": 435,
						"w": 153
					},
					{
						"n": 18,
						"h": 309,
						"w": 186
					},
					{
						"n": 15,
						"h": 163,
						"w": 252
					},
					{
						"n": 17,
						"h": 38,
						"w": 147
					},
					{
						"n": 20,
						"h": 291,
						"w": 127
					},
					{
						"n": 19,
						"h": 141,
						"w": 215
					}
				],
				"away": [
					{
						"n": 12,
						"h": 215,
						"w": 685
					},
					{
						"n": 13,
						"h": 396,
						"w": 598
					},
					{
						"n": 3,
						"h": 233,
						"w": 621
					},
					{
						"n": 14,
						"h": 154,
						"w": 618
					},
					{
						"n": 5,
						"h": 40,
						"w": 587
					},
					{
						"n": 16,
						"h": 306,
						"w": 524
					},
					{
						"n": 15,
						"h": 232,
						"w": 462
					},
					{
						"n": 18,
						"h": 26,
						"w": 513
					},
					{
						"n": 17,
						"h": 401,
						"w": 463
					},
					{
						"n": 19,
						"h": 280,
						"w": 425
					},
					{
						"n": 20,
						"h": 162,
						"w": 410
					}
				],
				"ball": {
					"n": 0,
					"h": 435,
					"w": 153,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 76
		},
		{
			"num": 1870,
			"minute": 90,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 704
					},
					{
						"n": 2,
						"h": 387,
						"w": 345
					},
					{
						"n": 14,
						"h": 274,
						"w": 406
					},
					{
						"n": 13,
						"h": 175,
						"w": 406
					},
					{
						"n": 5,
						"h": 58,
						"w": 353
					},
					{
						"n": 6,
						"h": 398,
						"w": 168
					},
					{
						"n": 18,
						"h": 278,
						"w": 161
					},
					{
						"n": 15,
						"h": 193,
						"w": 279
					},
					{
						"n": 17,
						"h": 43,
						"w": 147
					},
					{
						"n": 20,
						"h": 294,
						"w": 117
					},
					{
						"n": 19,
						"h": 152,
						"w": 177
					}
				],
				"away": [
					{
						"n": 12,
						"h": 214,
						"w": 710
					},
					{
						"n": 13,
						"h": 391,
						"w": 607
					},
					{
						"n": 3,
						"h": 229,
						"w": 624
					},
					{
						"n": 14,
						"h": 154,
						"w": 638
					},
					{
						"n": 5,
						"h": 58,
						"w": 558
					},
					{
						"n": 16,
						"h": 293,
						"w": 562
					},
					{
						"n": 15,
						"h": 228,
						"w": 475
					},
					{
						"n": 18,
						"h": 45,
						"w": 521
					},
					{
						"n": 17,
						"h": 396,
						"w": 472
					},
					{
						"n": 19,
						"h": 258,
						"w": 459
					},
					{
						"n": 20,
						"h": 163,
						"w": 422
					}
				],
				"ball": {
					"n": 0,
					"h": 398,
					"w": 168,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1871,
			"minute": 90,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 708
					},
					{
						"n": 2,
						"h": 385,
						"w": 350
					},
					{
						"n": 14,
						"h": 271,
						"w": 404
					},
					{
						"n": 13,
						"h": 175,
						"w": 412
					},
					{
						"n": 5,
						"h": 63,
						"w": 356
					},
					{
						"n": 6,
						"h": 398,
						"w": 163
					},
					{
						"n": 18,
						"h": 284,
						"w": 163
					},
					{
						"n": 15,
						"h": 199,
						"w": 280
					},
					{
						"n": 17,
						"h": 46,
						"w": 142
					},
					{
						"n": 20,
						"h": 288,
						"w": 115
					},
					{
						"n": 19,
						"h": 154,
						"w": 171
					}
				],
				"away": [
					{
						"n": 12,
						"h": 214,
						"w": 710
					},
					{
						"n": 13,
						"h": 388,
						"w": 610
					},
					{
						"n": 3,
						"h": 227,
						"w": 620
					},
					{
						"n": 14,
						"h": 157,
						"w": 633
					},
					{
						"n": 5,
						"h": 52,
						"w": 557
					},
					{
						"n": 16,
						"h": 298,
						"w": 558
					},
					{
						"n": 15,
						"h": 229,
						"w": 481
					},
					{
						"n": 18,
						"h": 45,
						"w": 521
					},
					{
						"n": 17,
						"h": 401,
						"w": 475
					},
					{
						"n": 19,
						"h": 252,
						"w": 459
					},
					{
						"n": 20,
						"h": 164,
						"w": 421
					}
				],
				"ball": {
					"n": 0,
					"h": 398,
					"w": 163,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 6
		},
		{
			"num": 1872,
			"minute": 90,
			"messages": [
				{
					"owner": 1,
					"mes": "Киэн Колман[06](Галвэй Юнайтед) ускоряется и уходит от Т.Прохазки[25](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 702
					},
					{
						"n": 2,
						"h": 381,
						"w": 357
					},
					{
						"n": 14,
						"h": 281,
						"w": 404
					},
					{
						"n": 13,
						"h": 179,
						"w": 392
					},
					{
						"n": 5,
						"h": 65,
						"w": 356
					},
					{
						"n": 6,
						"h": 391,
						"w": 142
					},
					{
						"n": 18,
						"h": 302,
						"w": 170
					},
					{
						"n": 15,
						"h": 219,
						"w": 284
					},
					{
						"n": 17,
						"h": 43,
						"w": 135
					},
					{
						"n": 20,
						"h": 290,
						"w": 105
					},
					{
						"n": 19,
						"h": 155,
						"w": 151
					}
				],
				"away": [
					{
						"n": 12,
						"h": 214,
						"w": 710
					},
					{
						"n": 13,
						"h": 391,
						"w": 619
					},
					{
						"n": 3,
						"h": 246,
						"w": 625
					},
					{
						"n": 14,
						"h": 172,
						"w": 633
					},
					{
						"n": 5,
						"h": 52,
						"w": 566
					},
					{
						"n": 16,
						"h": 293,
						"w": 578
					},
					{
						"n": 15,
						"h": 216,
						"w": 489
					},
					{
						"n": 18,
						"h": 48,
						"w": 527
					},
					{
						"n": 17,
						"h": 419,
						"w": 484
					},
					{
						"n": 19,
						"h": 233,
						"w": 457
					},
					{
						"n": 20,
						"h": 165,
						"w": 430
					}
				],
				"ball": {
					"n": 0,
					"h": 384,
					"w": 121,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 20
		},
		{
			"num": 1873,
			"minute": 90,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 705
					},
					{
						"n": 2,
						"h": 375,
						"w": 359
					},
					{
						"n": 14,
						"h": 280,
						"w": 403
					},
					{
						"n": 13,
						"h": 177,
						"w": 389
					},
					{
						"n": 5,
						"h": 72,
						"w": 351
					},
					{
						"n": 6,
						"h": 384,
						"w": 121
					},
					{
						"n": 18,
						"h": 290,
						"w": 183
					},
					{
						"n": 15,
						"h": 216,
						"w": 264
					},
					{
						"n": 17,
						"h": 53,
						"w": 126
					},
					{
						"n": 20,
						"h": 272,
						"w": 96
					},
					{
						"n": 19,
						"h": 154,
						"w": 131
					}
				],
				"away": [
					{
						"n": 12,
						"h": 213,
						"w": 711
					},
					{
						"n": 13,
						"h": 381,
						"w": 628
					},
					{
						"n": 3,
						"h": 228,
						"w": 632
					},
					{
						"n": 14,
						"h": 152,
						"w": 627
					},
					{
						"n": 5,
						"h": 52,
						"w": 575
					},
					{
						"n": 16,
						"h": 276,
						"w": 588
					},
					{
						"n": 15,
						"h": 227,
						"w": 506
					},
					{
						"n": 18,
						"h": 55,
						"w": 551
					},
					{
						"n": 17,
						"h": 424,
						"w": 493
					},
					{
						"n": 19,
						"h": 251,
						"w": 448
					},
					{
						"n": 20,
						"h": 171,
						"w": 430
					}
				],
				"ball": {
					"n": 0,
					"h": 384,
					"w": 121,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 20
		},
		{
			"num": 1874,
			"minute": 90,
			"messages": [
				{
					"owner": 1,
					"mes": "Пас правее на Т.Дэвлина[20](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 705
					},
					{
						"n": 2,
						"h": 376,
						"w": 367
					},
					{
						"n": 14,
						"h": 280,
						"w": 400
					},
					{
						"n": 13,
						"h": 177,
						"w": 400
					},
					{
						"n": 5,
						"h": 70,
						"w": 353
					},
					{
						"n": 6,
						"h": 379,
						"w": 112,
						"m": 930
					},
					{
						"n": 18,
						"h": 318,
						"w": 165
					},
					{
						"n": 15,
						"h": 183,
						"w": 267
					},
					{
						"n": 17,
						"h": 43,
						"w": 135
					},
					{
						"n": 20,
						"h": 284,
						"w": 124
					},
					{
						"n": 19,
						"h": 165,
						"w": 112
					}
				],
				"away": [
					{
						"n": 12,
						"h": 219,
						"w": 706
					},
					{
						"n": 13,
						"h": 391,
						"w": 613
					},
					{
						"n": 3,
						"h": 243,
						"w": 632
					},
					{
						"n": 14,
						"h": 168,
						"w": 598
					},
					{
						"n": 5,
						"h": 71,
						"w": 602,
						"m": 690
					},
					{
						"n": 16,
						"h": 290,
						"w": 610
					},
					{
						"n": 15,
						"h": 225,
						"w": 489
					},
					{
						"n": 18,
						"h": 29,
						"w": 531
					},
					{
						"n": 17,
						"h": 419,
						"w": 478
					},
					{
						"n": 19,
						"h": 276,
						"w": 427
					},
					{
						"n": 20,
						"h": 155,
						"w": 419
					}
				],
				"ball": {
					"n": 0,
					"h": 284,
					"w": 124,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 33
		},
		{
			"num": 1875,
			"minute": 90,
			"messages": [
				{
					"owner": 1,
					"mes": "Том Дэвлин[20](Галвэй Юнайтед) быстро обрабатывает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 706
					},
					{
						"n": 2,
						"h": 375,
						"w": 357
					},
					{
						"n": 14,
						"h": 277,
						"w": 398
					},
					{
						"n": 13,
						"h": 179,
						"w": 405
					},
					{
						"n": 5,
						"h": 75,
						"w": 351
					},
					{
						"n": 6,
						"h": 386,
						"w": 119
					},
					{
						"n": 18,
						"h": 316,
						"w": 155
					},
					{
						"n": 15,
						"h": 181,
						"w": 277
					},
					{
						"n": 17,
						"h": 53,
						"w": 134
					},
					{
						"n": 20,
						"h": 294,
						"w": 123
					},
					{
						"n": 19,
						"h": 166,
						"w": 103
					}
				],
				"away": [
					{
						"n": 12,
						"h": 218,
						"w": 707
					},
					{
						"n": 13,
						"h": 383,
						"w": 619
					},
					{
						"n": 3,
						"h": 242,
						"w": 639
					},
					{
						"n": 14,
						"h": 170,
						"w": 599
					},
					{
						"n": 5,
						"h": 70,
						"w": 612
					},
					{
						"n": 16,
						"h": 284,
						"w": 618
					},
					{
						"n": 15,
						"h": 232,
						"w": 496
					},
					{
						"n": 18,
						"h": 29,
						"w": 531
					},
					{
						"n": 17,
						"h": 411,
						"w": 483
					},
					{
						"n": 19,
						"h": 274,
						"w": 437
					},
					{
						"n": 20,
						"h": 165,
						"w": 418
					}
				],
				"ball": {
					"n": 0,
					"h": 294,
					"w": 123,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 10
		},
		{
			"num": 1876,
			"minute": 90,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 702
					},
					{
						"n": 2,
						"h": 374,
						"w": 359
					},
					{
						"n": 14,
						"h": 276,
						"w": 394
					},
					{
						"n": 13,
						"h": 168,
						"w": 408
					},
					{
						"n": 5,
						"h": 65,
						"w": 349
					},
					{
						"n": 6,
						"h": 396,
						"w": 117
					},
					{
						"n": 18,
						"h": 297,
						"w": 150
					},
					{
						"n": 15,
						"h": 161,
						"w": 278
					},
					{
						"n": 17,
						"h": 43,
						"w": 117
					},
					{
						"n": 20,
						"h": 294,
						"w": 106
					},
					{
						"n": 19,
						"h": 167,
						"w": 87
					}
				],
				"away": [
					{
						"n": 12,
						"h": 217,
						"w": 707
					},
					{
						"n": 13,
						"h": 391,
						"w": 637
					},
					{
						"n": 3,
						"h": 257,
						"w": 651
					},
					{
						"n": 14,
						"h": 156,
						"w": 614
					},
					{
						"n": 5,
						"h": 60,
						"w": 616
					},
					{
						"n": 16,
						"h": 264,
						"w": 613
					},
					{
						"n": 15,
						"h": 230,
						"w": 501
					},
					{
						"n": 18,
						"h": 29,
						"w": 531
					},
					{
						"n": 17,
						"h": 398,
						"w": 499
					},
					{
						"n": 19,
						"h": 284,
						"w": 454
					},
					{
						"n": 20,
						"h": 160,
						"w": 417
					}
				],
				"ball": {
					"n": 0,
					"h": 294,
					"w": 106,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 20
		},
		{
			"num": 1877,
			"minute": 90,
			"messages": [
				{
					"owner": 1,
					"mes": "Том Дэвлин[20](Галвэй Юнайтед) сближается с В.Сланиной[34](Опава)..."
				},
				{
					"owner": 1,
					"mes": "Вацлав Сланина[34](Опава) отбирает мяч у Т.Дэвлина[20](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 702
					},
					{
						"n": 2,
						"h": 374,
						"w": 359
					},
					{
						"n": 14,
						"h": 276,
						"w": 394
					},
					{
						"n": 13,
						"h": 168,
						"w": 408
					},
					{
						"n": 5,
						"h": 65,
						"w": 349
					},
					{
						"n": 6,
						"h": 396,
						"w": 117
					},
					{
						"n": 18,
						"h": 287,
						"w": 148
					},
					{
						"n": 15,
						"h": 159,
						"w": 278
					},
					{
						"n": 17,
						"h": 43,
						"w": 117
					},
					{
						"n": 20,
						"h": 294,
						"w": 96,
						"m": 570
					},
					{
						"n": 19,
						"h": 167,
						"w": 87
					}
				],
				"away": [
					{
						"n": 12,
						"h": 217,
						"w": 707
					},
					{
						"n": 13,
						"h": 391,
						"w": 637
					},
					{
						"n": 3,
						"h": 265,
						"w": 658
					},
					{
						"n": 14,
						"h": 149,
						"w": 621,
						"m": 770
					},
					{
						"n": 5,
						"h": 60,
						"w": 616
					},
					{
						"n": 16,
						"h": 254,
						"w": 611
					},
					{
						"n": 15,
						"h": 230,
						"w": 501
					},
					{
						"n": 18,
						"h": 32,
						"w": 540
					},
					{
						"n": 17,
						"h": 395,
						"w": 502
					},
					{
						"n": 19,
						"h": 289,
						"w": 462
					},
					{
						"n": 20,
						"h": 160,
						"w": 417
					}
				],
				"ball": {
					"n": 0,
					"h": 301,
					"w": 99,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 4
				}
			},
			"interval": 10
		},
		{
			"num": 1878,
			"minute": 90,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 706
					},
					{
						"n": 2,
						"h": 351,
						"w": 392
					},
					{
						"n": 14,
						"h": 281,
						"w": 418
					},
					{
						"n": 13,
						"h": 171,
						"w": 417
					},
					{
						"n": 5,
						"h": 84,
						"w": 384
					},
					{
						"n": 6,
						"h": 401,
						"w": 157
					},
					{
						"n": 18,
						"h": 284,
						"w": 188
					},
					{
						"n": 15,
						"h": 163,
						"w": 317
					},
					{
						"n": 17,
						"h": 41,
						"w": 157
					},
					{
						"n": 20,
						"h": 300,
						"w": 104
					},
					{
						"n": 19,
						"h": 184,
						"w": 123
					}
				],
				"away": [
					{
						"n": 12,
						"h": 228,
						"w": 701
					},
					{
						"n": 13,
						"h": 392,
						"w": 597
					},
					{
						"n": 3,
						"h": 282,
						"w": 612
					},
					{
						"n": 14,
						"h": 124,
						"w": 596
					},
					{
						"n": 5,
						"h": 62,
						"w": 619
					},
					{
						"n": 16,
						"h": 245,
						"w": 572
					},
					{
						"n": 15,
						"h": 231,
						"w": 461
					},
					{
						"n": 18,
						"h": 43,
						"w": 502
					},
					{
						"n": 17,
						"h": 386,
						"w": 463
					},
					{
						"n": 19,
						"h": 291,
						"w": 422
					},
					{
						"n": 20,
						"h": 156,
						"w": 377
					}
				],
				"ball": {
					"n": 0,
					"h": 326,
					"w": 124,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1879,
			"minute": 90,
			"messages": [
				{
					"owner": 2,
					"mes": "Вацлав Сланина[34](Опава) отпасовывает вперед Т.Анри[40](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 708
					},
					{
						"n": 2,
						"h": 316,
						"w": 408
					},
					{
						"n": 14,
						"h": 230,
						"w": 429
					},
					{
						"n": 13,
						"h": 175,
						"w": 439
					},
					{
						"n": 5,
						"h": 110,
						"w": 429
					},
					{
						"n": 6,
						"h": 399,
						"w": 209
					},
					{
						"n": 18,
						"h": 268,
						"w": 237
					},
					{
						"n": 15,
						"h": 159,
						"w": 347
					},
					{
						"n": 17,
						"h": 47,
						"w": 209
					},
					{
						"n": 20,
						"h": 321,
						"w": 143
					},
					{
						"n": 19,
						"h": 200,
						"w": 173
					}
				],
				"away": [
					{
						"n": 12,
						"h": 222,
						"w": 709
					},
					{
						"n": 13,
						"h": 399,
						"w": 545
					},
					{
						"n": 3,
						"h": 278,
						"w": 613
					},
					{
						"n": 14,
						"h": 129,
						"w": 597
					},
					{
						"n": 5,
						"h": 72,
						"w": 598
					},
					{
						"n": 16,
						"h": 236,
						"w": 521
					},
					{
						"n": 15,
						"h": 219,
						"w": 410
					},
					{
						"n": 18,
						"h": 44,
						"w": 450
					},
					{
						"n": 17,
						"h": 377,
						"w": 412
					},
					{
						"n": 19,
						"h": 290,
						"w": 370
					},
					{
						"n": 20,
						"h": 130,
						"w": 389
					}
				],
				"ball": {
					"n": 0,
					"h": 320,
					"w": 331,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 52
		},
		{
			"num": 1880,
			"minute": 90,
			"messages": [
				{
					"owner": 2,
					"mes": "Справа открывается Ньялл Томпсон[38](Опава)... Передача..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 704
					},
					{
						"n": 2,
						"h": 336,
						"w": 379
					},
					{
						"n": 14,
						"h": 228,
						"w": 463
					},
					{
						"n": 13,
						"h": 148,
						"w": 445
					},
					{
						"n": 5,
						"h": 116,
						"w": 464
					},
					{
						"n": 6,
						"h": 402,
						"w": 243
					},
					{
						"n": 18,
						"h": 277,
						"w": 271
					},
					{
						"n": 15,
						"h": 147,
						"w": 377
					},
					{
						"n": 17,
						"h": 52,
						"w": 243
					},
					{
						"n": 20,
						"h": 299,
						"w": 170
					},
					{
						"n": 19,
						"h": 193,
						"w": 207
					}
				],
				"away": [
					{
						"n": 12,
						"h": 226,
						"w": 702
					},
					{
						"n": 13,
						"h": 401,
						"w": 510
					},
					{
						"n": 3,
						"h": 275,
						"w": 609
					},
					{
						"n": 14,
						"h": 163,
						"w": 605
					},
					{
						"n": 5,
						"h": 57,
						"w": 586
					},
					{
						"n": 16,
						"h": 219,
						"w": 490
					},
					{
						"n": 15,
						"h": 206,
						"w": 378
					},
					{
						"n": 18,
						"h": 46,
						"w": 415
					},
					{
						"n": 17,
						"h": 380,
						"w": 377
					},
					{
						"n": 19,
						"h": 298,
						"w": 336
					},
					{
						"n": 20,
						"h": 132,
						"w": 379
					}
				],
				"ball": {
					"n": 0,
					"h": 404,
					"w": 305,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 35
		},
		{
			"num": 1881,
			"minute": 90,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 702
					},
					{
						"n": 2,
						"h": 374,
						"w": 369
					},
					{
						"n": 14,
						"h": 229,
						"w": 470
					},
					{
						"n": 13,
						"h": 155,
						"w": 459
					},
					{
						"n": 5,
						"h": 120,
						"w": 458
					},
					{
						"n": 6,
						"h": 407,
						"w": 283
					},
					{
						"n": 18,
						"h": 290,
						"w": 309
					},
					{
						"n": 15,
						"h": 144,
						"w": 369
					},
					{
						"n": 17,
						"h": 55,
						"w": 283
					},
					{
						"n": 20,
						"h": 283,
						"w": 207
					},
					{
						"n": 19,
						"h": 181,
						"w": 245
					}
				],
				"away": [
					{
						"n": 12,
						"h": 224,
						"w": 710
					},
					{
						"n": 13,
						"h": 395,
						"w": 471
					},
					{
						"n": 3,
						"h": 274,
						"w": 596
					},
					{
						"n": 14,
						"h": 178,
						"w": 585
					},
					{
						"n": 5,
						"h": 67,
						"w": 572
					},
					{
						"n": 16,
						"h": 202,
						"w": 454
					},
					{
						"n": 15,
						"h": 200,
						"w": 338
					},
					{
						"n": 18,
						"h": 46,
						"w": 371
					},
					{
						"n": 17,
						"h": 358,
						"w": 344
					},
					{
						"n": 19,
						"h": 296,
						"w": 296
					},
					{
						"n": 20,
						"h": 139,
						"w": 340
					}
				],
				"ball": {
					"n": 0,
					"h": 404,
					"w": 349,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1882,
			"minute": 90,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 704
					},
					{
						"n": 2,
						"h": 374,
						"w": 396
					},
					{
						"n": 14,
						"h": 267,
						"w": 484
					},
					{
						"n": 13,
						"h": 185,
						"w": 474
					},
					{
						"n": 5,
						"h": 120,
						"w": 498
					},
					{
						"n": 6,
						"h": 407,
						"w": 303
					},
					{
						"n": 18,
						"h": 295,
						"w": 348
					},
					{
						"n": 15,
						"h": 180,
						"w": 387
					},
					{
						"n": 17,
						"h": 47,
						"w": 322
					},
					{
						"n": 20,
						"h": 270,
						"w": 244
					},
					{
						"n": 19,
						"h": 170,
						"w": 284
					}
				],
				"away": [
					{
						"n": 12,
						"h": 225,
						"w": 707
					},
					{
						"n": 13,
						"h": 396,
						"w": 431
					},
					{
						"n": 3,
						"h": 276,
						"w": 566
					},
					{
						"n": 14,
						"h": 175,
						"w": 556
					},
					{
						"n": 5,
						"h": 58,
						"w": 572
					},
					{
						"n": 16,
						"h": 191,
						"w": 465
					},
					{
						"n": 15,
						"h": 198,
						"w": 341
					},
					{
						"n": 18,
						"h": 36,
						"w": 331
					},
					{
						"n": 17,
						"h": 329,
						"w": 316
					},
					{
						"n": 19,
						"h": 297,
						"w": 262
					},
					{
						"n": 20,
						"h": 143,
						"w": 300
					}
				],
				"ball": {
					"n": 0,
					"h": 414,
					"w": 389,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1883,
			"minute": 90,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 702
					},
					{
						"n": 2,
						"h": 382,
						"w": 440
					},
					{
						"n": 14,
						"h": 284,
						"w": 508
					},
					{
						"n": 13,
						"h": 174,
						"w": 502
					},
					{
						"n": 5,
						"h": 120,
						"w": 509
					},
					{
						"n": 6,
						"h": 409,
						"w": 323
					},
					{
						"n": 18,
						"h": 295,
						"w": 388
					},
					{
						"n": 15,
						"h": 154,
						"w": 418
					},
					{
						"n": 17,
						"h": 56,
						"w": 357
					},
					{
						"n": 20,
						"h": 259,
						"w": 283
					},
					{
						"n": 19,
						"h": 173,
						"w": 310
					}
				],
				"away": [
					{
						"n": 12,
						"h": 220,
						"w": 692
					},
					{
						"n": 13,
						"h": 397,
						"w": 398
					},
					{
						"n": 3,
						"h": 284,
						"w": 548
					},
					{
						"n": 14,
						"h": 166,
						"w": 527
					},
					{
						"n": 5,
						"h": 73,
						"w": 549
					},
					{
						"n": 16,
						"h": 199,
						"w": 426
					},
					{
						"n": 15,
						"h": 208,
						"w": 345
					},
					{
						"n": 18,
						"h": 36,
						"w": 287
					},
					{
						"n": 17,
						"h": 301,
						"w": 288
					},
					{
						"n": 19,
						"h": 292,
						"w": 225
					},
					{
						"n": 20,
						"h": 149,
						"w": 260
					}
				],
				"ball": {
					"n": 0,
					"h": 414,
					"w": 433,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1884,
			"minute": 90,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 706
					},
					{
						"n": 2,
						"h": 383,
						"w": 484
					},
					{
						"n": 14,
						"h": 291,
						"w": 544
					},
					{
						"n": 13,
						"h": 199,
						"w": 524
					},
					{
						"n": 5,
						"h": 120,
						"w": 543
					},
					{
						"n": 6,
						"h": 407,
						"w": 363
					},
					{
						"n": 18,
						"h": 283,
						"w": 427
					},
					{
						"n": 15,
						"h": 191,
						"w": 434
					},
					{
						"n": 17,
						"h": 57,
						"w": 397
					},
					{
						"n": 20,
						"h": 275,
						"w": 320
					},
					{
						"n": 19,
						"h": 157,
						"w": 346
					}
				],
				"away": [
					{
						"n": 12,
						"h": 230,
						"w": 672
					},
					{
						"n": 13,
						"h": 393,
						"w": 358
					},
					{
						"n": 3,
						"h": 284,
						"w": 517
					},
					{
						"n": 14,
						"h": 170,
						"w": 516
					},
					{
						"n": 5,
						"h": 64,
						"w": 519
					},
					{
						"n": 16,
						"h": 205,
						"w": 386
					},
					{
						"n": 15,
						"h": 197,
						"w": 307
					},
					{
						"n": 18,
						"h": 36,
						"w": 243
					},
					{
						"n": 17,
						"h": 315,
						"w": 250
					},
					{
						"n": 19,
						"h": 282,
						"w": 207
					},
					{
						"n": 20,
						"h": 162,
						"w": 222
					}
				],
				"ball": {
					"n": 0,
					"h": 414,
					"w": 477,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1885,
			"minute": 90,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 235,
						"w": 709
					},
					{
						"n": 2,
						"h": 384,
						"w": 528
					},
					{
						"n": 14,
						"h": 294,
						"w": 591
					},
					{
						"n": 13,
						"h": 195,
						"w": 564
					},
					{
						"n": 5,
						"h": 120,
						"w": 583
					},
					{
						"n": 6,
						"h": 401,
						"w": 403
					},
					{
						"n": 18,
						"h": 289,
						"w": 466
					},
					{
						"n": 15,
						"h": 207,
						"w": 470
					},
					{
						"n": 17,
						"h": 56,
						"w": 436
					},
					{
						"n": 20,
						"h": 259,
						"w": 344
					},
					{
						"n": 19,
						"h": 164,
						"w": 374
					}
				],
				"away": [
					{
						"n": 12,
						"h": 225,
						"w": 657
					},
					{
						"n": 13,
						"h": 399,
						"w": 319
					},
					{
						"n": 3,
						"h": 286,
						"w": 487
					},
					{
						"n": 14,
						"h": 179,
						"w": 477
					},
					{
						"n": 5,
						"h": 70,
						"w": 487
					},
					{
						"n": 16,
						"h": 191,
						"w": 396
					},
					{
						"n": 15,
						"h": 200,
						"w": 267
					},
					{
						"n": 18,
						"h": 36,
						"w": 200
					},
					{
						"n": 17,
						"h": 301,
						"w": 213
					},
					{
						"n": 19,
						"h": 283,
						"w": 167
					},
					{
						"n": 20,
						"h": 159,
						"w": 182
					}
				],
				"ball": {
					"n": 0,
					"h": 414,
					"w": 520,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1886,
			"minute": 90,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 237,
						"w": 710
					},
					{
						"n": 2,
						"h": 401,
						"w": 568
					},
					{
						"n": 14,
						"h": 289,
						"w": 609
					},
					{
						"n": 13,
						"h": 186,
						"w": 603
					},
					{
						"n": 5,
						"h": 158,
						"w": 597
					},
					{
						"n": 6,
						"h": 402,
						"w": 443
					},
					{
						"n": 18,
						"h": 295,
						"w": 506
					},
					{
						"n": 15,
						"h": 214,
						"w": 506
					},
					{
						"n": 17,
						"h": 56,
						"w": 476
					},
					{
						"n": 20,
						"h": 256,
						"w": 384
					},
					{
						"n": 19,
						"h": 169,
						"w": 371
					}
				],
				"away": [
					{
						"n": 12,
						"h": 222,
						"w": 638
					},
					{
						"n": 13,
						"h": 400,
						"w": 279
					},
					{
						"n": 3,
						"h": 283,
						"w": 447
					},
					{
						"n": 14,
						"h": 178,
						"w": 437
					},
					{
						"n": 5,
						"h": 63,
						"w": 447
					},
					{
						"n": 16,
						"h": 194,
						"w": 356
					},
					{
						"n": 15,
						"h": 196,
						"w": 276
					},
					{
						"n": 18,
						"h": 36,
						"w": 156
					},
					{
						"n": 17,
						"h": 292,
						"w": 174
					},
					{
						"n": 19,
						"h": 295,
						"w": 128
					},
					{
						"n": 20,
						"h": 165,
						"w": 143
					}
				],
				"ball": {
					"n": 0,
					"h": 414,
					"w": 564,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1887,
			"minute": 90,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 238,
						"w": 712
					},
					{
						"n": 2,
						"h": 401,
						"w": 610
					},
					{
						"n": 14,
						"h": 281,
						"w": 642
					},
					{
						"n": 13,
						"h": 215,
						"w": 628
					},
					{
						"n": 5,
						"h": 127,
						"w": 625
					},
					{
						"n": 6,
						"h": 397,
						"w": 480
					},
					{
						"n": 18,
						"h": 268,
						"w": 533
					},
					{
						"n": 15,
						"h": 214,
						"w": 512
					},
					{
						"n": 17,
						"h": 56,
						"w": 514
					},
					{
						"n": 20,
						"h": 245,
						"w": 421
					},
					{
						"n": 19,
						"h": 161,
						"w": 372
					}
				],
				"away": [
					{
						"n": 12,
						"h": 221,
						"w": 616
					},
					{
						"n": 13,
						"h": 398,
						"w": 241
					},
					{
						"n": 3,
						"h": 280,
						"w": 424
					},
					{
						"n": 14,
						"h": 166,
						"w": 410
					},
					{
						"n": 5,
						"h": 64,
						"w": 422
					},
					{
						"n": 16,
						"h": 205,
						"w": 319
					},
					{
						"n": 15,
						"h": 195,
						"w": 238
					},
					{
						"n": 18,
						"h": 26,
						"w": 116
					},
					{
						"n": 17,
						"h": 262,
						"w": 150
					},
					{
						"n": 19,
						"h": 262,
						"w": 110
					},
					{
						"n": 20,
						"h": 170,
						"w": 105
					}
				],
				"ball": {
					"n": 0,
					"h": 424,
					"w": 604,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 38
		},
		{
			"num": 1888,
			"minute": 90,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 239,
						"w": 715
					},
					{
						"n": 2,
						"h": 415,
						"w": 651
					},
					{
						"n": 14,
						"h": 278,
						"w": 677
					},
					{
						"n": 13,
						"h": 228,
						"w": 664
					},
					{
						"n": 5,
						"h": 120,
						"w": 665
					},
					{
						"n": 6,
						"h": 409,
						"w": 519
					},
					{
						"n": 18,
						"h": 258,
						"w": 572
					},
					{
						"n": 15,
						"h": 211,
						"w": 552
					},
					{
						"n": 17,
						"h": 56,
						"w": 554
					},
					{
						"n": 20,
						"h": 247,
						"w": 461
					},
					{
						"n": 19,
						"h": 162,
						"w": 385
					}
				],
				"away": [
					{
						"n": 12,
						"h": 222,
						"w": 595
					},
					{
						"n": 13,
						"h": 396,
						"w": 201
					},
					{
						"n": 3,
						"h": 275,
						"w": 412
					},
					{
						"n": 14,
						"h": 176,
						"w": 416
					},
					{
						"n": 5,
						"h": 67,
						"w": 397
					},
					{
						"n": 16,
						"h": 203,
						"w": 279
					},
					{
						"n": 15,
						"h": 197,
						"w": 198
					},
					{
						"n": 18,
						"h": 26,
						"w": 72
					},
					{
						"n": 17,
						"h": 240,
						"w": 117
					},
					{
						"n": 19,
						"h": 237,
						"w": 78
					},
					{
						"n": 20,
						"h": 174,
						"w": 65
					}
				],
				"ball": {
					"n": 0,
					"h": 424,
					"w": 648,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1889,
			"minute": 90,
			"messages": [
				{
					"owner": 2,
					"mes": "Передача в штрафную..."
				},
				{
					"owner": 2,
					"mes": "Тома Анри[40](Опава) получил мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 236,
						"w": 710
					},
					{
						"n": 2,
						"h": 385,
						"w": 663
					},
					{
						"n": 14,
						"h": 307,
						"w": 647
					},
					{
						"n": 13,
						"h": 217,
						"w": 691
					},
					{
						"n": 5,
						"h": 168,
						"w": 657
					},
					{
						"n": 6,
						"h": 395,
						"w": 566
					},
					{
						"n": 18,
						"h": 236,
						"w": 606
					},
					{
						"n": 15,
						"h": 185,
						"w": 564
					},
					{
						"n": 17,
						"h": 56,
						"w": 603
					},
					{
						"n": 20,
						"h": 238,
						"w": 448
					},
					{
						"n": 19,
						"h": 167,
						"w": 390
					}
				],
				"away": [
					{
						"n": 12,
						"h": 228,
						"w": 602
					},
					{
						"n": 13,
						"h": 404,
						"w": 152
					},
					{
						"n": 3,
						"h": 273,
						"w": 425
					},
					{
						"n": 14,
						"h": 183,
						"w": 401
					},
					{
						"n": 5,
						"h": 71,
						"w": 412
					},
					{
						"n": 16,
						"h": 212,
						"w": 292
					},
					{
						"n": 15,
						"h": 219,
						"w": 154
					},
					{
						"n": 18,
						"h": 35,
						"w": 77,
						"m": 660
					},
					{
						"n": 17,
						"h": 259,
						"w": 88
					},
					{
						"n": 19,
						"h": 226,
						"w": 62
					},
					{
						"n": 20,
						"h": 130,
						"w": 87
					}
				],
				"ball": {
					"n": 0,
					"h": 320,
					"w": 633,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 49
		},
		{
			"num": 1890,
			"minute": 91,
			"possession": 42,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 235,
						"w": 709,
						"f": 89,
						"m": 700,
						"c": 1
					},
					{
						"n": 2,
						"h": 394,
						"w": 645,
						"f": 74,
						"c": 4
					},
					{
						"n": 14,
						"h": 303,
						"w": 640
					},
					{
						"n": 13,
						"h": 221,
						"w": 672
					},
					{
						"n": 5,
						"h": 186,
						"w": 666
					},
					{
						"n": 6,
						"h": 395,
						"w": 566
					},
					{
						"n": 18,
						"h": 255,
						"w": 600,
						"f": 90
					},
					{
						"n": 15,
						"h": 183,
						"w": 556
					},
					{
						"n": 17,
						"h": 56,
						"w": 622,
						"f": 82
					},
					{
						"n": 20,
						"h": 236,
						"w": 468,
						"f": 79,
						"c": 3
					},
					{
						"n": 19,
						"h": 164,
						"w": 376,
						"f": 87
					}
				],
				"away": [
					{
						"n": 12,
						"h": 220,
						"w": 594
					},
					{
						"n": 13,
						"h": 408,
						"w": 133
					},
					{
						"n": 3,
						"h": 284,
						"w": 421,
						"f": 79,
						"c": 3
					},
					{
						"n": 14,
						"h": 181,
						"w": 416,
						"m": 780
					},
					{
						"n": 5,
						"h": 65,
						"w": 393
					},
					{
						"n": 16,
						"h": 214,
						"w": 272,
						"f": 89,
						"c": 1
					},
					{
						"n": 15,
						"h": 232,
						"w": 169
					},
					{
						"n": 18,
						"h": 43,
						"w": 82
					},
					{
						"n": 17,
						"h": 240,
						"w": 83,
						"f": 85
					},
					{
						"n": 19,
						"h": 246,
						"w": 58
					},
					{
						"n": 20,
						"h": 140,
						"w": 87
					}
				],
				"ball": {
					"n": 0,
					"h": 310,
					"w": 633,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 20
		},
		{
			"num": 1891,
			"minute": 91,
			"messages": [
				{
					"owner": 2,
					"mes": "Тома Анри[40](Опава) укрывает мяч корпусом..."
				},
				{
					"owner": 2,
					"mes": "Том Смит[14](Галвэй Юнайтед) обкрадывает Т.Анри[40](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 235,
						"w": 709
					},
					{
						"n": 2,
						"h": 394,
						"w": 645
					},
					{
						"n": 14,
						"h": 303,
						"w": 640,
						"m": 680
					},
					{
						"n": 13,
						"h": 225,
						"w": 657
					},
					{
						"n": 5,
						"h": 195,
						"w": 670
					},
					{
						"n": 6,
						"h": 393,
						"w": 580
					},
					{
						"n": 18,
						"h": 268,
						"w": 596
					},
					{
						"n": 15,
						"h": 183,
						"w": 556
					},
					{
						"n": 17,
						"h": 56,
						"w": 622
					},
					{
						"n": 20,
						"h": 236,
						"w": 468
					},
					{
						"n": 19,
						"h": 164,
						"w": 376
					}
				],
				"away": [
					{
						"n": 12,
						"h": 220,
						"w": 594
					},
					{
						"n": 13,
						"h": 410,
						"w": 118
					},
					{
						"n": 3,
						"h": 284,
						"w": 421
					},
					{
						"n": 14,
						"h": 181,
						"w": 416
					},
					{
						"n": 5,
						"h": 65,
						"w": 392
					},
					{
						"n": 16,
						"h": 216,
						"w": 257
					},
					{
						"n": 15,
						"h": 235,
						"w": 172
					},
					{
						"n": 18,
						"h": 43,
						"w": 82
					},
					{
						"n": 17,
						"h": 240,
						"w": 83
					},
					{
						"n": 19,
						"h": 260,
						"w": 56
					},
					{
						"n": 20,
						"h": 154,
						"w": 83,
						"m": 650
					}
				],
				"ball": {
					"n": 0,
					"h": 303,
					"w": 640,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 15
		},
		{
			"num": 1892,
			"minute": 91,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 704
					},
					{
						"n": 2,
						"h": 393,
						"w": 605
					},
					{
						"n": 14,
						"h": 328,
						"w": 615
					},
					{
						"n": 13,
						"h": 204,
						"w": 622
					},
					{
						"n": 5,
						"h": 165,
						"w": 644
					},
					{
						"n": 6,
						"h": 396,
						"w": 540
					},
					{
						"n": 18,
						"h": 278,
						"w": 557
					},
					{
						"n": 15,
						"h": 173,
						"w": 517
					},
					{
						"n": 17,
						"h": 54,
						"w": 582
					},
					{
						"n": 20,
						"h": 248,
						"w": 430
					},
					{
						"n": 19,
						"h": 156,
						"w": 337
					}
				],
				"away": [
					{
						"n": 12,
						"h": 207,
						"w": 636
					},
					{
						"n": 13,
						"h": 413,
						"w": 158
					},
					{
						"n": 3,
						"h": 283,
						"w": 461
					},
					{
						"n": 14,
						"h": 193,
						"w": 454
					},
					{
						"n": 5,
						"h": 84,
						"w": 427
					},
					{
						"n": 16,
						"h": 220,
						"w": 297
					},
					{
						"n": 15,
						"h": 235,
						"w": 212
					},
					{
						"n": 18,
						"h": 43,
						"w": 122
					},
					{
						"n": 17,
						"h": 237,
						"w": 123
					},
					{
						"n": 19,
						"h": 251,
						"w": 94
					},
					{
						"n": 20,
						"h": 145,
						"w": 95
					}
				],
				"ball": {
					"n": 0,
					"h": 328,
					"w": 615,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1893,
			"minute": 91,
			"messages": [
				{
					"owner": 1,
					"mes": "Том Смит[14](Галвэй Юнайтед) делает передачу налево на К.Колмана[06](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 709
					},
					{
						"n": 2,
						"h": 388,
						"w": 563
					},
					{
						"n": 14,
						"h": 312,
						"w": 600
					},
					{
						"n": 13,
						"h": 197,
						"w": 602
					},
					{
						"n": 5,
						"h": 132,
						"w": 604
					},
					{
						"n": 6,
						"h": 394,
						"w": 506
					},
					{
						"n": 18,
						"h": 289,
						"w": 517
					},
					{
						"n": 15,
						"h": 177,
						"w": 476
					},
					{
						"n": 17,
						"h": 51,
						"w": 540
					},
					{
						"n": 20,
						"h": 264,
						"w": 391
					},
					{
						"n": 19,
						"h": 150,
						"w": 295
					}
				],
				"away": [
					{
						"n": 12,
						"h": 205,
						"w": 648
					},
					{
						"n": 13,
						"h": 412,
						"w": 200
					},
					{
						"n": 3,
						"h": 285,
						"w": 489
					},
					{
						"n": 14,
						"h": 201,
						"w": 475
					},
					{
						"n": 5,
						"h": 100,
						"w": 466
					},
					{
						"n": 16,
						"h": 210,
						"w": 338
					},
					{
						"n": 15,
						"h": 231,
						"w": 254
					},
					{
						"n": 18,
						"h": 39,
						"w": 164
					},
					{
						"n": 17,
						"h": 263,
						"w": 156
					},
					{
						"n": 19,
						"h": 256,
						"w": 136
					},
					{
						"n": 20,
						"h": 150,
						"w": 137
					}
				],
				"ball": {
					"n": 0,
					"h": 394,
					"w": 506,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 42
		},
		{
			"num": 1894,
			"minute": 91,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 701
					},
					{
						"n": 2,
						"h": 380,
						"w": 524
					},
					{
						"n": 14,
						"h": 292,
						"w": 565
					},
					{
						"n": 13,
						"h": 181,
						"w": 565
					},
					{
						"n": 5,
						"h": 114,
						"w": 568
					},
					{
						"n": 6,
						"h": 400,
						"w": 467
					},
					{
						"n": 18,
						"h": 304,
						"w": 480
					},
					{
						"n": 15,
						"h": 187,
						"w": 437
					},
					{
						"n": 17,
						"h": 50,
						"w": 500
					},
					{
						"n": 20,
						"h": 274,
						"w": 352
					},
					{
						"n": 19,
						"h": 149,
						"w": 257
					}
				],
				"away": [
					{
						"n": 12,
						"h": 205,
						"w": 641
					},
					{
						"n": 13,
						"h": 410,
						"w": 240
					},
					{
						"n": 3,
						"h": 285,
						"w": 493
					},
					{
						"n": 14,
						"h": 189,
						"w": 480
					},
					{
						"n": 5,
						"h": 110,
						"w": 483
					},
					{
						"n": 16,
						"h": 192,
						"w": 374
					},
					{
						"n": 15,
						"h": 231,
						"w": 304
					},
					{
						"n": 18,
						"h": 35,
						"w": 214
					},
					{
						"n": 17,
						"h": 289,
						"w": 187
					},
					{
						"n": 19,
						"h": 258,
						"w": 176
					},
					{
						"n": 20,
						"h": 149,
						"w": 177
					}
				],
				"ball": {
					"n": 0,
					"h": 400,
					"w": 467,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1895,
			"minute": 91,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 702
					},
					{
						"n": 2,
						"h": 390,
						"w": 498
					},
					{
						"n": 14,
						"h": 281,
						"w": 544
					},
					{
						"n": 13,
						"h": 173,
						"w": 533
					},
					{
						"n": 5,
						"h": 91,
						"w": 535
					},
					{
						"n": 6,
						"h": 400,
						"w": 427
					},
					{
						"n": 18,
						"h": 315,
						"w": 449
					},
					{
						"n": 15,
						"h": 192,
						"w": 397
					},
					{
						"n": 17,
						"h": 51,
						"w": 461
					},
					{
						"n": 20,
						"h": 282,
						"w": 313
					},
					{
						"n": 19,
						"h": 149,
						"w": 238
					}
				],
				"away": [
					{
						"n": 12,
						"h": 205,
						"w": 641
					},
					{
						"n": 13,
						"h": 414,
						"w": 280
					},
					{
						"n": 3,
						"h": 284,
						"w": 486
					},
					{
						"n": 14,
						"h": 185,
						"w": 479
					},
					{
						"n": 5,
						"h": 110,
						"w": 491
					},
					{
						"n": 16,
						"h": 166,
						"w": 415
					},
					{
						"n": 15,
						"h": 224,
						"w": 343
					},
					{
						"n": 18,
						"h": 46,
						"w": 262
					},
					{
						"n": 17,
						"h": 312,
						"w": 219
					},
					{
						"n": 19,
						"h": 277,
						"w": 207
					},
					{
						"n": 20,
						"h": 144,
						"w": 217
					}
				],
				"ball": {
					"n": 0,
					"h": 400,
					"w": 427,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1896,
			"minute": 91,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 707
					},
					{
						"n": 2,
						"h": 385,
						"w": 467
					},
					{
						"n": 14,
						"h": 283,
						"w": 531
					},
					{
						"n": 13,
						"h": 168,
						"w": 523
					},
					{
						"n": 5,
						"h": 80,
						"w": 497
					},
					{
						"n": 6,
						"h": 400,
						"w": 387
					},
					{
						"n": 18,
						"h": 299,
						"w": 442
					},
					{
						"n": 15,
						"h": 203,
						"w": 359
					},
					{
						"n": 17,
						"h": 44,
						"w": 421
					},
					{
						"n": 20,
						"h": 284,
						"w": 273
					},
					{
						"n": 19,
						"h": 162,
						"w": 241
					}
				],
				"away": [
					{
						"n": 12,
						"h": 205,
						"w": 646
					},
					{
						"n": 13,
						"h": 409,
						"w": 319
					},
					{
						"n": 3,
						"h": 278,
						"w": 495
					},
					{
						"n": 14,
						"h": 180,
						"w": 508
					},
					{
						"n": 5,
						"h": 78,
						"w": 473
					},
					{
						"n": 16,
						"h": 170,
						"w": 443
					},
					{
						"n": 15,
						"h": 224,
						"w": 343
					},
					{
						"n": 18,
						"h": 53,
						"w": 311
					},
					{
						"n": 17,
						"h": 340,
						"w": 248
					},
					{
						"n": 19,
						"h": 284,
						"w": 247
					},
					{
						"n": 20,
						"h": 147,
						"w": 256
					}
				],
				"ball": {
					"n": 0,
					"h": 400,
					"w": 387,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1897,
			"minute": 91,
			"messages": [
				{
					"owner": 1,
					"mes": "Киэн Колман[06](Галвэй Юнайтед) отправляет мяч в центр..."
				},
				{
					"owner": 1,
					"mes": "Вацлав Сланина[34](Опава) демонстрирует позиционное чутье и перехватывает мяч!..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 704
					},
					{
						"n": 2,
						"h": 380,
						"w": 467
					},
					{
						"n": 14,
						"h": 273,
						"w": 521
					},
					{
						"n": 13,
						"h": 175,
						"w": 533
					},
					{
						"n": 5,
						"h": 59,
						"w": 467
					},
					{
						"n": 6,
						"h": 397,
						"w": 370,
						"m": 920
					},
					{
						"n": 18,
						"h": 294,
						"w": 395
					},
					{
						"n": 15,
						"h": 178,
						"w": 319
					},
					{
						"n": 17,
						"h": 45,
						"w": 374
					},
					{
						"n": 20,
						"h": 305,
						"w": 238
					},
					{
						"n": 19,
						"h": 146,
						"w": 252
					}
				],
				"away": [
					{
						"n": 12,
						"h": 215,
						"w": 644
					},
					{
						"n": 13,
						"h": 406,
						"w": 366
					},
					{
						"n": 3,
						"h": 283,
						"w": 542
					},
					{
						"n": 14,
						"h": 134,
						"w": 501
					},
					{
						"n": 5,
						"h": 98,
						"w": 515
					},
					{
						"n": 16,
						"h": 151,
						"w": 486
					},
					{
						"n": 15,
						"h": 228,
						"w": 390
					},
					{
						"n": 18,
						"h": 53,
						"w": 358
					},
					{
						"n": 17,
						"h": 350,
						"w": 273
					},
					{
						"n": 19,
						"h": 285,
						"w": 294
					},
					{
						"n": 20,
						"h": 151,
						"w": 303
					}
				],
				"ball": {
					"n": 0,
					"h": 316,
					"w": 219,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 47
		},
		{
			"num": 1898,
			"minute": 91,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 709
					},
					{
						"n": 2,
						"h": 366,
						"w": 504
					},
					{
						"n": 14,
						"h": 280,
						"w": 537
					},
					{
						"n": 13,
						"h": 178,
						"w": 517
					},
					{
						"n": 5,
						"h": 79,
						"w": 494
					},
					{
						"n": 6,
						"h": 395,
						"w": 410
					},
					{
						"n": 18,
						"h": 289,
						"w": 434
					},
					{
						"n": 15,
						"h": 185,
						"w": 359
					},
					{
						"n": 17,
						"h": 49,
						"w": 394
					},
					{
						"n": 20,
						"h": 337,
						"w": 262
					},
					{
						"n": 19,
						"h": 152,
						"w": 291
					}
				],
				"away": [
					{
						"n": 12,
						"h": 215,
						"w": 630
					},
					{
						"n": 13,
						"h": 416,
						"w": 400
					},
					{
						"n": 3,
						"h": 275,
						"w": 529
					},
					{
						"n": 14,
						"h": 109,
						"w": 476,
						"m": 790
					},
					{
						"n": 5,
						"h": 62,
						"w": 531
					},
					{
						"n": 16,
						"h": 170,
						"w": 451
					},
					{
						"n": 15,
						"h": 229,
						"w": 350
					},
					{
						"n": 18,
						"h": 54,
						"w": 318
					},
					{
						"n": 17,
						"h": 380,
						"w": 246
					},
					{
						"n": 19,
						"h": 288,
						"w": 254
					},
					{
						"n": 20,
						"h": 154,
						"w": 272
					}
				],
				"ball": {
					"n": 0,
					"h": 341,
					"w": 244,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1899,
			"minute": 91,
			"messages": [
				{
					"owner": 2,
					"mes": "В.Сланина[34](Опава) делает передачу М.Владаржу[36](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 709
					},
					{
						"n": 2,
						"h": 352,
						"w": 525
					},
					{
						"n": 14,
						"h": 281,
						"w": 552
					},
					{
						"n": 13,
						"h": 184,
						"w": 541
					},
					{
						"n": 5,
						"h": 92,
						"w": 516
					},
					{
						"n": 6,
						"h": 395,
						"w": 435
					},
					{
						"n": 18,
						"h": 297,
						"w": 458
					},
					{
						"n": 15,
						"h": 185,
						"w": 384
					},
					{
						"n": 17,
						"h": 51,
						"w": 419
					},
					{
						"n": 20,
						"h": 313,
						"w": 260
					},
					{
						"n": 19,
						"h": 154,
						"w": 316
					}
				],
				"away": [
					{
						"n": 12,
						"h": 220,
						"w": 610
					},
					{
						"n": 13,
						"h": 406,
						"w": 377
					},
					{
						"n": 3,
						"h": 268,
						"w": 508
					},
					{
						"n": 14,
						"h": 113,
						"w": 478
					},
					{
						"n": 5,
						"h": 57,
						"w": 507
					},
					{
						"n": 16,
						"h": 156,
						"w": 463
					},
					{
						"n": 15,
						"h": 233,
						"w": 325
					},
					{
						"n": 18,
						"h": 53,
						"w": 293
					},
					{
						"n": 17,
						"h": 389,
						"w": 223
					},
					{
						"n": 19,
						"h": 283,
						"w": 229
					},
					{
						"n": 20,
						"h": 153,
						"w": 247
					}
				],
				"ball": {
					"n": 0,
					"h": 294,
					"w": 257,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 25
		},
		{
			"num": 1900,
			"minute": 91,
			"messages": [
				{
					"owner": 2,
					"mes": "Михаэль Владарж[36](Опава) пасует на Т.Крамаржа[32](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 705
					},
					{
						"n": 2,
						"h": 337,
						"w": 485
					},
					{
						"n": 14,
						"h": 273,
						"w": 510
					},
					{
						"n": 13,
						"h": 175,
						"w": 499
					},
					{
						"n": 5,
						"h": 120,
						"w": 483
					},
					{
						"n": 6,
						"h": 383,
						"w": 459
					},
					{
						"n": 18,
						"h": 290,
						"w": 416
					},
					{
						"n": 15,
						"h": 193,
						"w": 370
					},
					{
						"n": 17,
						"h": 62,
						"w": 459
					},
					{
						"n": 20,
						"h": 305,
						"w": 294
					},
					{
						"n": 19,
						"h": 156,
						"w": 315
					}
				],
				"away": [
					{
						"n": 12,
						"h": 204,
						"w": 582
					},
					{
						"n": 13,
						"h": 411,
						"w": 420
					},
					{
						"n": 3,
						"h": 274,
						"w": 551
					},
					{
						"n": 14,
						"h": 133,
						"w": 516
					},
					{
						"n": 5,
						"h": 67,
						"w": 549
					},
					{
						"n": 16,
						"h": 165,
						"w": 458,
						"m": 670
					},
					{
						"n": 15,
						"h": 220,
						"w": 348
					},
					{
						"n": 18,
						"h": 52,
						"w": 288
					},
					{
						"n": 17,
						"h": 403,
						"w": 263
					},
					{
						"n": 19,
						"h": 294,
						"w": 264
					},
					{
						"n": 20,
						"h": 164,
						"w": 276
					}
				],
				"ball": {
					"n": 0,
					"h": 246,
					"w": 138,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 43
		},
		{
			"num": 1901,
			"minute": 91,
			"messages": [
				{
					"owner": 2,
					"mes": "Передача налево..."
				},
				{
					"owner": 2,
					"mes": "Нир Мансур[23](Опава) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 701
					},
					{
						"n": 2,
						"h": 330,
						"w": 463
					},
					{
						"n": 14,
						"h": 268,
						"w": 480
					},
					{
						"n": 13,
						"h": 170,
						"w": 469
					},
					{
						"n": 5,
						"h": 120,
						"w": 470
					},
					{
						"n": 6,
						"h": 394,
						"w": 435
					},
					{
						"n": 18,
						"h": 277,
						"w": 408
					},
					{
						"n": 15,
						"h": 215,
						"w": 369
					},
					{
						"n": 17,
						"h": 71,
						"w": 445
					},
					{
						"n": 20,
						"h": 309,
						"w": 280
					},
					{
						"n": 19,
						"h": 157,
						"w": 302
					}
				],
				"away": [
					{
						"n": 12,
						"h": 211,
						"w": 589
					},
					{
						"n": 13,
						"h": 400,
						"w": 448
					},
					{
						"n": 3,
						"h": 261,
						"w": 564
					},
					{
						"n": 14,
						"h": 146,
						"w": 543
					},
					{
						"n": 5,
						"h": 66,
						"w": 577
					},
					{
						"n": 16,
						"h": 194,
						"w": 451
					},
					{
						"n": 15,
						"h": 235,
						"w": 347
					},
					{
						"n": 18,
						"h": 37,
						"w": 300
					},
					{
						"n": 17,
						"h": 394,
						"w": 292
					},
					{
						"n": 19,
						"h": 296,
						"w": 288
					},
					{
						"n": 20,
						"h": 165,
						"w": 286
					}
				],
				"ball": {
					"n": 0,
					"h": 189,
					"w": 156,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 30
		},
		{
			"num": 1902,
			"minute": 91,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 701
					},
					{
						"n": 2,
						"h": 330,
						"w": 456
					},
					{
						"n": 14,
						"h": 263,
						"w": 452
					},
					{
						"n": 13,
						"h": 184,
						"w": 455
					},
					{
						"n": 5,
						"h": 120,
						"w": 462
					},
					{
						"n": 6,
						"h": 394,
						"w": 435
					},
					{
						"n": 18,
						"h": 273,
						"w": 384
					},
					{
						"n": 15,
						"h": 192,
						"w": 350
					},
					{
						"n": 17,
						"h": 63,
						"w": 406
					},
					{
						"n": 20,
						"h": 314,
						"w": 280
					},
					{
						"n": 19,
						"h": 166,
						"w": 309
					}
				],
				"away": [
					{
						"n": 12,
						"h": 225,
						"w": 617
					},
					{
						"n": 13,
						"h": 399,
						"w": 454
					},
					{
						"n": 3,
						"h": 266,
						"w": 529
					},
					{
						"n": 14,
						"h": 156,
						"w": 582
					},
					{
						"n": 5,
						"h": 62,
						"w": 614
					},
					{
						"n": 16,
						"h": 180,
						"w": 444
					},
					{
						"n": 15,
						"h": 214,
						"w": 367
					},
					{
						"n": 18,
						"h": 35,
						"w": 300
					},
					{
						"n": 17,
						"h": 357,
						"w": 278
					},
					{
						"n": 19,
						"h": 284,
						"w": 298
					},
					{
						"n": 20,
						"h": 172,
						"w": 287
					}
				],
				"ball": {
					"n": 0,
					"h": 184,
					"w": 191,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1903,
			"minute": 91,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 708
					},
					{
						"n": 2,
						"h": 330,
						"w": 468
					},
					{
						"n": 14,
						"h": 258,
						"w": 473
					},
					{
						"n": 13,
						"h": 201,
						"w": 461
					},
					{
						"n": 5,
						"h": 120,
						"w": 477
					},
					{
						"n": 6,
						"h": 394,
						"w": 437
					},
					{
						"n": 18,
						"h": 278,
						"w": 422
					},
					{
						"n": 15,
						"h": 208,
						"w": 387
					},
					{
						"n": 17,
						"h": 59,
						"w": 374
					},
					{
						"n": 20,
						"h": 287,
						"w": 310
					},
					{
						"n": 19,
						"h": 129,
						"w": 294
					}
				],
				"away": [
					{
						"n": 12,
						"h": 225,
						"w": 657
					},
					{
						"n": 13,
						"h": 410,
						"w": 460
					},
					{
						"n": 3,
						"h": 266,
						"w": 494
					},
					{
						"n": 14,
						"h": 172,
						"w": 602
					},
					{
						"n": 5,
						"h": 74,
						"w": 593
					},
					{
						"n": 16,
						"h": 211,
						"w": 419
					},
					{
						"n": 15,
						"h": 231,
						"w": 336
					},
					{
						"n": 18,
						"h": 33,
						"w": 298
					},
					{
						"n": 17,
						"h": 326,
						"w": 303
					},
					{
						"n": 19,
						"h": 264,
						"w": 263
					},
					{
						"n": 20,
						"h": 173,
						"w": 281
					}
				],
				"ball": {
					"n": 0,
					"h": 184,
					"w": 226,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1904,
			"minute": 91,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 708
					},
					{
						"n": 2,
						"h": 369,
						"w": 478
					},
					{
						"n": 14,
						"h": 278,
						"w": 507
					},
					{
						"n": 13,
						"h": 179,
						"w": 494
					},
					{
						"n": 5,
						"h": 120,
						"w": 495
					},
					{
						"n": 6,
						"h": 407,
						"w": 402
					},
					{
						"n": 18,
						"h": 246,
						"w": 416
					},
					{
						"n": 15,
						"h": 182,
						"w": 400
					},
					{
						"n": 17,
						"h": 50,
						"w": 402
					},
					{
						"n": 20,
						"h": 289,
						"w": 333
					},
					{
						"n": 19,
						"h": 168,
						"w": 285
					}
				],
				"away": [
					{
						"n": 12,
						"h": 224,
						"w": 697
					},
					{
						"n": 13,
						"h": 409,
						"w": 420
					},
					{
						"n": 3,
						"h": 265,
						"w": 459
					},
					{
						"n": 14,
						"h": 168,
						"w": 562
					},
					{
						"n": 5,
						"h": 68,
						"w": 563
					},
					{
						"n": 16,
						"h": 214,
						"w": 392
					},
					{
						"n": 15,
						"h": 210,
						"w": 305
					},
					{
						"n": 18,
						"h": 39,
						"w": 259
					},
					{
						"n": 17,
						"h": 309,
						"w": 267
					},
					{
						"n": 19,
						"h": 284,
						"w": 235
					},
					{
						"n": 20,
						"h": 156,
						"w": 245
					}
				],
				"ball": {
					"n": 0,
					"h": 185,
					"w": 261,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1905,
			"minute": 91,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 707
					},
					{
						"n": 2,
						"h": 375,
						"w": 507
					},
					{
						"n": 14,
						"h": 275,
						"w": 535
					},
					{
						"n": 13,
						"h": 190,
						"w": 520
					},
					{
						"n": 5,
						"h": 120,
						"w": 519
					},
					{
						"n": 6,
						"h": 396,
						"w": 419
					},
					{
						"n": 18,
						"h": 241,
						"w": 456
					},
					{
						"n": 15,
						"h": 194,
						"w": 430
					},
					{
						"n": 17,
						"h": 55,
						"w": 362
					},
					{
						"n": 20,
						"h": 285,
						"w": 372
					},
					{
						"n": 19,
						"h": 192,
						"w": 316
					}
				],
				"away": [
					{
						"n": 12,
						"h": 223,
						"w": 678
					},
					{
						"n": 13,
						"h": 408,
						"w": 380
					},
					{
						"n": 3,
						"h": 258,
						"w": 424
					},
					{
						"n": 14,
						"h": 179,
						"w": 524
					},
					{
						"n": 5,
						"h": 67,
						"w": 523
					},
					{
						"n": 16,
						"h": 216,
						"w": 352
					},
					{
						"n": 15,
						"h": 210,
						"w": 281
					},
					{
						"n": 18,
						"h": 45,
						"w": 233
					},
					{
						"n": 17,
						"h": 290,
						"w": 232
					},
					{
						"n": 19,
						"h": 304,
						"w": 233
					},
					{
						"n": 20,
						"h": 136,
						"w": 256
					}
				],
				"ball": {
					"n": 0,
					"h": 192,
					"w": 296,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1906,
			"minute": 91,
			"messages": [
				{
					"owner": 2,
					"mes": "Пас направо на Т.Прохазку[25](Опава)..."
				},
				{
					"owner": 2,
					"mes": "Томаш Прохазка[25](Опава) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 704
					},
					{
						"n": 2,
						"h": 366,
						"w": 536
					},
					{
						"n": 14,
						"h": 277,
						"w": 555
					},
					{
						"n": 13,
						"h": 171,
						"w": 552
					},
					{
						"n": 5,
						"h": 120,
						"w": 562
					},
					{
						"n": 6,
						"h": 400,
						"w": 445
					},
					{
						"n": 18,
						"h": 286,
						"w": 470
					},
					{
						"n": 15,
						"h": 199,
						"w": 476
					},
					{
						"n": 17,
						"h": 56,
						"w": 409
					},
					{
						"n": 20,
						"h": 293,
						"w": 400
					},
					{
						"n": 19,
						"h": 190,
						"w": 306
					}
				],
				"away": [
					{
						"n": 12,
						"h": 215,
						"w": 655
					},
					{
						"n": 13,
						"h": 404,
						"w": 333
					},
					{
						"n": 3,
						"h": 260,
						"w": 434
					},
					{
						"n": 14,
						"h": 182,
						"w": 517
					},
					{
						"n": 5,
						"h": 84,
						"w": 496
					},
					{
						"n": 16,
						"h": 210,
						"w": 340
					},
					{
						"n": 15,
						"h": 164,
						"w": 291
					},
					{
						"n": 18,
						"h": 54,
						"w": 204
					},
					{
						"n": 17,
						"h": 243,
						"w": 237
					},
					{
						"n": 19,
						"h": 301,
						"w": 187
					},
					{
						"n": 20,
						"h": 160,
						"w": 216
					}
				],
				"ball": {
					"n": 0,
					"h": 366,
					"w": 224,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 47
		},
		{
			"num": 1907,
			"minute": 91,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 701
					},
					{
						"n": 2,
						"h": 382,
						"w": 540
					},
					{
						"n": 14,
						"h": 265,
						"w": 558
					},
					{
						"n": 13,
						"h": 189,
						"w": 552
					},
					{
						"n": 5,
						"h": 120,
						"w": 567
					},
					{
						"n": 6,
						"h": 403,
						"w": 461
					},
					{
						"n": 18,
						"h": 263,
						"w": 467
					},
					{
						"n": 15,
						"h": 231,
						"w": 476
					},
					{
						"n": 17,
						"h": 56,
						"w": 422
					},
					{
						"n": 20,
						"h": 255,
						"w": 386
					},
					{
						"n": 19,
						"h": 181,
						"w": 345
					}
				],
				"away": [
					{
						"n": 12,
						"h": 215,
						"w": 635
					},
					{
						"n": 13,
						"h": 400,
						"w": 333
					},
					{
						"n": 3,
						"h": 268,
						"w": 473
					},
					{
						"n": 14,
						"h": 167,
						"w": 482
					},
					{
						"n": 5,
						"h": 72,
						"w": 463
					},
					{
						"n": 16,
						"h": 201,
						"w": 356
					},
					{
						"n": 15,
						"h": 179,
						"w": 277
					},
					{
						"n": 18,
						"h": 38,
						"w": 200
					},
					{
						"n": 17,
						"h": 225,
						"w": 227
					},
					{
						"n": 19,
						"h": 281,
						"w": 197
					},
					{
						"n": 20,
						"h": 166,
						"w": 176
					}
				],
				"ball": {
					"n": 0,
					"h": 378,
					"w": 257,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1908,
			"minute": 91,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 705
					},
					{
						"n": 2,
						"h": 368,
						"w": 540
					},
					{
						"n": 14,
						"h": 258,
						"w": 568
					},
					{
						"n": 13,
						"h": 192,
						"w": 568
					},
					{
						"n": 5,
						"h": 120,
						"w": 564
					},
					{
						"n": 6,
						"h": 408,
						"w": 460
					},
					{
						"n": 18,
						"h": 280,
						"w": 487
					},
					{
						"n": 15,
						"h": 205,
						"w": 464
					},
					{
						"n": 17,
						"h": 56,
						"w": 420
					},
					{
						"n": 20,
						"h": 279,
						"w": 394
					},
					{
						"n": 19,
						"h": 166,
						"w": 382
					}
				],
				"away": [
					{
						"n": 12,
						"h": 222,
						"w": 613
					},
					{
						"n": 13,
						"h": 402,
						"w": 335
					},
					{
						"n": 3,
						"h": 274,
						"w": 501
					},
					{
						"n": 14,
						"h": 181,
						"w": 486
					},
					{
						"n": 5,
						"h": 69,
						"w": 428
					},
					{
						"n": 16,
						"h": 216,
						"w": 319
					},
					{
						"n": 15,
						"h": 161,
						"w": 281
					},
					{
						"n": 18,
						"h": 52,
						"w": 200
					},
					{
						"n": 17,
						"h": 241,
						"w": 254
					},
					{
						"n": 19,
						"h": 278,
						"w": 200
					},
					{
						"n": 20,
						"h": 175,
						"w": 199
					}
				],
				"ball": {
					"n": 0,
					"h": 381,
					"w": 292,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1909,
			"minute": 91,
			"messages": [
				{
					"owner": 2,
					"mes": "Томаш Прохазка[25](Опава) отдает передачу налево В.Сланине[34](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 704
					},
					{
						"n": 2,
						"h": 388,
						"w": 540
					},
					{
						"n": 14,
						"h": 275,
						"w": 551
					},
					{
						"n": 13,
						"h": 186,
						"w": 551
					},
					{
						"n": 5,
						"h": 120,
						"w": 562
					},
					{
						"n": 6,
						"h": 423,
						"w": 461
					},
					{
						"n": 18,
						"h": 264,
						"w": 488
					},
					{
						"n": 15,
						"h": 178,
						"w": 479
					},
					{
						"n": 17,
						"h": 56,
						"w": 411
					},
					{
						"n": 20,
						"h": 303,
						"w": 376
					},
					{
						"n": 19,
						"h": 173,
						"w": 393
					}
				],
				"away": [
					{
						"n": 12,
						"h": 220,
						"w": 597
					},
					{
						"n": 13,
						"h": 408,
						"w": 324
					},
					{
						"n": 3,
						"h": 277,
						"w": 466
					},
					{
						"n": 14,
						"h": 171,
						"w": 458
					},
					{
						"n": 5,
						"h": 65,
						"w": 436,
						"m": 700
					},
					{
						"n": 16,
						"h": 224,
						"w": 338
					},
					{
						"n": 15,
						"h": 187,
						"w": 257
					},
					{
						"n": 18,
						"h": 32,
						"w": 200
					},
					{
						"n": 17,
						"h": 276,
						"w": 254
					},
					{
						"n": 19,
						"h": 274,
						"w": 187
					},
					{
						"n": 20,
						"h": 156,
						"w": 176
					}
				],
				"ball": {
					"n": 0,
					"h": 279,
					"w": 262,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 35
		},
		{
			"num": 1910,
			"minute": 91,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 708
					},
					{
						"n": 2,
						"h": 372,
						"w": 540
					},
					{
						"n": 14,
						"h": 275,
						"w": 569
					},
					{
						"n": 13,
						"h": 177,
						"w": 562
					},
					{
						"n": 5,
						"h": 120,
						"w": 555
					},
					{
						"n": 6,
						"h": 396,
						"w": 460
					},
					{
						"n": 18,
						"h": 257,
						"w": 470
					},
					{
						"n": 15,
						"h": 184,
						"w": 470
					},
					{
						"n": 17,
						"h": 56,
						"w": 398
					},
					{
						"n": 20,
						"h": 316,
						"w": 375
					},
					{
						"n": 19,
						"h": 159,
						"w": 394
					}
				],
				"away": [
					{
						"n": 12,
						"h": 220,
						"w": 613
					},
					{
						"n": 13,
						"h": 416,
						"w": 337
					},
					{
						"n": 3,
						"h": 284,
						"w": 496
					},
					{
						"n": 14,
						"h": 171,
						"w": 423
					},
					{
						"n": 5,
						"h": 71,
						"w": 476
					},
					{
						"n": 16,
						"h": 245,
						"w": 334
					},
					{
						"n": 15,
						"h": 202,
						"w": 287
					},
					{
						"n": 18,
						"h": 48,
						"w": 200
					},
					{
						"n": 17,
						"h": 270,
						"w": 269
					},
					{
						"n": 19,
						"h": 289,
						"w": 196
					},
					{
						"n": 20,
						"h": 159,
						"w": 190
					}
				],
				"ball": {
					"n": 0,
					"h": 279,
					"w": 297,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1911,
			"minute": 92,
			"possession": 42,
			"messages": [
				{
					"owner": 2,
					"mes": "Вацлав Сланина[34](Опава) отдает пас назад..."
				},
				{
					"owner": 2,
					"mes": "Тим Крамарж[32](Опава) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 710
					},
					{
						"n": 2,
						"h": 332,
						"w": 495
					},
					{
						"n": 14,
						"h": 271,
						"w": 509
					},
					{
						"n": 13,
						"h": 177,
						"w": 502
					},
					{
						"n": 5,
						"h": 120,
						"w": 495,
						"f": 74,
						"c": 4
					},
					{
						"n": 6,
						"h": 387,
						"w": 474,
						"f": 72
					},
					{
						"n": 18,
						"h": 228,
						"w": 421
					},
					{
						"n": 15,
						"h": 163,
						"w": 414,
						"f": 89,
						"c": 1
					},
					{
						"n": 17,
						"h": 56,
						"w": 339
					},
					{
						"n": 20,
						"h": 320,
						"w": 315
					},
					{
						"n": 19,
						"h": 170,
						"w": 335
					}
				],
				"away": [
					{
						"n": 12,
						"h": 196,
						"w": 601
					},
					{
						"n": 13,
						"h": 418,
						"w": 396,
						"f": 86
					},
					{
						"n": 3,
						"h": 270,
						"w": 554
					},
					{
						"n": 14,
						"h": 171,
						"w": 433,
						"f": 83
					},
					{
						"n": 5,
						"h": 61,
						"w": 535,
						"f": 73
					},
					{
						"n": 16,
						"h": 225,
						"w": 378
					},
					{
						"n": 15,
						"h": 218,
						"w": 313
					},
					{
						"n": 18,
						"h": 48,
						"w": 260
					},
					{
						"n": 17,
						"h": 279,
						"w": 322
					},
					{
						"n": 19,
						"h": 300,
						"w": 255,
						"m": 670
					},
					{
						"n": 20,
						"h": 164,
						"w": 250,
						"f": 89,
						"c": 1
					}
				],
				"ball": {
					"n": 0,
					"h": 254,
					"w": 119,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 60
		},
		{
			"num": 1912,
			"minute": 92,
			"messages": [
				{
					"owner": 2,
					"mes": "Тим Крамарж[32](Опава) посылает мяч направо в направлении Т.Прохазки[25](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 703
					},
					{
						"n": 2,
						"h": 330,
						"w": 514
					},
					{
						"n": 14,
						"h": 281,
						"w": 500
					},
					{
						"n": 13,
						"h": 180,
						"w": 520
					},
					{
						"n": 5,
						"h": 120,
						"w": 518
					},
					{
						"n": 6,
						"h": 378,
						"w": 494
					},
					{
						"n": 18,
						"h": 264,
						"w": 454
					},
					{
						"n": 15,
						"h": 192,
						"w": 406
					},
					{
						"n": 17,
						"h": 56,
						"w": 346
					},
					{
						"n": 20,
						"h": 280,
						"w": 279
					},
					{
						"n": 19,
						"h": 165,
						"w": 350
					}
				],
				"away": [
					{
						"n": 12,
						"h": 204,
						"w": 607
					},
					{
						"n": 13,
						"h": 420,
						"w": 389
					},
					{
						"n": 3,
						"h": 274,
						"w": 520
					},
					{
						"n": 14,
						"h": 170,
						"w": 461
					},
					{
						"n": 5,
						"h": 69,
						"w": 485
					},
					{
						"n": 16,
						"h": 199,
						"w": 352
					},
					{
						"n": 15,
						"h": 196,
						"w": 283
					},
					{
						"n": 18,
						"h": 57,
						"w": 251
					},
					{
						"n": 17,
						"h": 249,
						"w": 314
					},
					{
						"n": 19,
						"h": 288,
						"w": 237
					},
					{
						"n": 20,
						"h": 151,
						"w": 235
					}
				],
				"ball": {
					"n": 0,
					"h": 381,
					"w": 235,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 57
		},
		{
			"num": 1913,
			"minute": 92,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 704
					},
					{
						"n": 2,
						"h": 367,
						"w": 528
					},
					{
						"n": 14,
						"h": 269,
						"w": 538
					},
					{
						"n": 13,
						"h": 170,
						"w": 556
					},
					{
						"n": 5,
						"h": 120,
						"w": 553
					},
					{
						"n": 6,
						"h": 390,
						"w": 456
					},
					{
						"n": 18,
						"h": 290,
						"w": 473
					},
					{
						"n": 15,
						"h": 161,
						"w": 432
					},
					{
						"n": 17,
						"h": 56,
						"w": 386
					},
					{
						"n": 20,
						"h": 283,
						"w": 319
					},
					{
						"n": 19,
						"h": 167,
						"w": 390
					}
				],
				"away": [
					{
						"n": 12,
						"h": 215,
						"w": 613
					},
					{
						"n": 13,
						"h": 403,
						"w": 353
					},
					{
						"n": 3,
						"h": 272,
						"w": 470
					},
					{
						"n": 14,
						"h": 171,
						"w": 475
					},
					{
						"n": 5,
						"h": 60,
						"w": 451
					},
					{
						"n": 16,
						"h": 193,
						"w": 333
					},
					{
						"n": 15,
						"h": 220,
						"w": 266
					},
					{
						"n": 18,
						"h": 51,
						"w": 211
					},
					{
						"n": 17,
						"h": 283,
						"w": 294
					},
					{
						"n": 19,
						"h": 295,
						"w": 198
					},
					{
						"n": 20,
						"h": 173,
						"w": 205
					}
				],
				"ball": {
					"n": 0,
					"h": 390,
					"w": 269,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1914,
			"minute": 92,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 702
					},
					{
						"n": 2,
						"h": 367,
						"w": 540
					},
					{
						"n": 14,
						"h": 261,
						"w": 573
					},
					{
						"n": 13,
						"h": 162,
						"w": 559
					},
					{
						"n": 5,
						"h": 120,
						"w": 574
					},
					{
						"n": 6,
						"h": 401,
						"w": 466
					},
					{
						"n": 18,
						"h": 278,
						"w": 499
					},
					{
						"n": 15,
						"h": 184,
						"w": 464
					},
					{
						"n": 17,
						"h": 56,
						"w": 401
					},
					{
						"n": 20,
						"h": 269,
						"w": 356
					},
					{
						"n": 19,
						"h": 167,
						"w": 399
					}
				],
				"away": [
					{
						"n": 12,
						"h": 215,
						"w": 615
					},
					{
						"n": 13,
						"h": 415,
						"w": 334
					},
					{
						"n": 3,
						"h": 278,
						"w": 506
					},
					{
						"n": 14,
						"h": 162,
						"w": 505
					},
					{
						"n": 5,
						"h": 58,
						"w": 416
					},
					{
						"n": 16,
						"h": 194,
						"w": 350
					},
					{
						"n": 15,
						"h": 180,
						"w": 271
					},
					{
						"n": 18,
						"h": 53,
						"w": 200
					},
					{
						"n": 17,
						"h": 257,
						"w": 264
					},
					{
						"n": 19,
						"h": 300,
						"w": 176
					},
					{
						"n": 20,
						"h": 170,
						"w": 171
					}
				],
				"ball": {
					"n": 0,
					"h": 392,
					"w": 304,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1915,
			"minute": 92,
			"messages": [
				{
					"owner": 2,
					"mes": "Пас в центр на В.Сланину[34](Опава)..."
				},
				{
					"owner": 2,
					"mes": "Вацлав Сланина[34](Опава) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 707
					},
					{
						"n": 2,
						"h": 368,
						"w": 540
					},
					{
						"n": 14,
						"h": 280,
						"w": 565
					},
					{
						"n": 13,
						"h": 179,
						"w": 579
					},
					{
						"n": 5,
						"h": 120,
						"w": 562
					},
					{
						"n": 6,
						"h": 400,
						"w": 461
					},
					{
						"n": 18,
						"h": 245,
						"w": 481
					},
					{
						"n": 15,
						"h": 163,
						"w": 466
					},
					{
						"n": 17,
						"h": 56,
						"w": 410
					},
					{
						"n": 20,
						"h": 303,
						"w": 371
					},
					{
						"n": 19,
						"h": 155,
						"w": 405
					}
				],
				"away": [
					{
						"n": 12,
						"h": 220,
						"w": 615
					},
					{
						"n": 13,
						"h": 419,
						"w": 325
					},
					{
						"n": 3,
						"h": 270,
						"w": 489
					},
					{
						"n": 14,
						"h": 141,
						"w": 489
					},
					{
						"n": 5,
						"h": 59,
						"w": 426
					},
					{
						"n": 16,
						"h": 225,
						"w": 369
					},
					{
						"n": 15,
						"h": 214,
						"w": 255
					},
					{
						"n": 18,
						"h": 52,
						"w": 200
					},
					{
						"n": 17,
						"h": 291,
						"w": 251
					},
					{
						"n": 19,
						"h": 289,
						"w": 186
					},
					{
						"n": 20,
						"h": 152,
						"w": 176
					}
				],
				"ball": {
					"n": 0,
					"h": 309,
					"w": 231,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 37
		},
		{
			"num": 1916,
			"minute": 92,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 702
					},
					{
						"n": 2,
						"h": 365,
						"w": 540
					},
					{
						"n": 14,
						"h": 269,
						"w": 559
					},
					{
						"n": 13,
						"h": 187,
						"w": 543
					},
					{
						"n": 5,
						"h": 120,
						"w": 557
					},
					{
						"n": 6,
						"h": 405,
						"w": 460
					},
					{
						"n": 18,
						"h": 256,
						"w": 473
					},
					{
						"n": 15,
						"h": 196,
						"w": 459
					},
					{
						"n": 17,
						"h": 56,
						"w": 419
					},
					{
						"n": 20,
						"h": 295,
						"w": 405
					},
					{
						"n": 19,
						"h": 144,
						"w": 375
					}
				],
				"away": [
					{
						"n": 12,
						"h": 220,
						"w": 613
					},
					{
						"n": 13,
						"h": 395,
						"w": 336
					},
					{
						"n": 3,
						"h": 281,
						"w": 500
					},
					{
						"n": 14,
						"h": 156,
						"w": 457
					},
					{
						"n": 5,
						"h": 65,
						"w": 465
					},
					{
						"n": 16,
						"h": 243,
						"w": 333
					},
					{
						"n": 15,
						"h": 197,
						"w": 290
					},
					{
						"n": 18,
						"h": 55,
						"w": 200
					},
					{
						"n": 17,
						"h": 256,
						"w": 265
					},
					{
						"n": 19,
						"h": 282,
						"w": 180
					},
					{
						"n": 20,
						"h": 170,
						"w": 199
					}
				],
				"ball": {
					"n": 0,
					"h": 294,
					"w": 263,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1917,
			"minute": 92,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 708
					},
					{
						"n": 2,
						"h": 372,
						"w": 540
					},
					{
						"n": 14,
						"h": 274,
						"w": 568
					},
					{
						"n": 13,
						"h": 175,
						"w": 555
					},
					{
						"n": 5,
						"h": 120,
						"w": 567
					},
					{
						"n": 6,
						"h": 401,
						"w": 464
					},
					{
						"n": 18,
						"h": 260,
						"w": 495
					},
					{
						"n": 15,
						"h": 227,
						"w": 471
					},
					{
						"n": 17,
						"h": 56,
						"w": 407
					},
					{
						"n": 20,
						"h": 315,
						"w": 379
					},
					{
						"n": 19,
						"h": 182,
						"w": 386
					}
				],
				"away": [
					{
						"n": 12,
						"h": 220,
						"w": 613
					},
					{
						"n": 13,
						"h": 416,
						"w": 328
					},
					{
						"n": 3,
						"h": 273,
						"w": 511
					},
					{
						"n": 14,
						"h": 156,
						"w": 422
					},
					{
						"n": 5,
						"h": 59,
						"w": 499
					},
					{
						"n": 16,
						"h": 230,
						"w": 343
					},
					{
						"n": 15,
						"h": 234,
						"w": 276
					},
					{
						"n": 18,
						"h": 48,
						"w": 200
					},
					{
						"n": 17,
						"h": 225,
						"w": 240
					},
					{
						"n": 19,
						"h": 293,
						"w": 194
					},
					{
						"n": 20,
						"h": 157,
						"w": 173
					}
				],
				"ball": {
					"n": 0,
					"h": 294,
					"w": 298,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1918,
			"minute": 92,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 701
					},
					{
						"n": 2,
						"h": 361,
						"w": 548
					},
					{
						"n": 14,
						"h": 273,
						"w": 574
					},
					{
						"n": 13,
						"h": 162,
						"w": 560
					},
					{
						"n": 5,
						"h": 120,
						"w": 558
					},
					{
						"n": 6,
						"h": 420,
						"w": 468
					},
					{
						"n": 18,
						"h": 225,
						"w": 503
					},
					{
						"n": 15,
						"h": 210,
						"w": 447
					},
					{
						"n": 17,
						"h": 56,
						"w": 417
					},
					{
						"n": 20,
						"h": 284,
						"w": 353
					},
					{
						"n": 19,
						"h": 197,
						"w": 393
					}
				],
				"away": [
					{
						"n": 12,
						"h": 220,
						"w": 609
					},
					{
						"n": 13,
						"h": 402,
						"w": 338
					},
					{
						"n": 3,
						"h": 269,
						"w": 498
					},
					{
						"n": 14,
						"h": 168,
						"w": 389
					},
					{
						"n": 5,
						"h": 75,
						"w": 492
					},
					{
						"n": 16,
						"h": 253,
						"w": 347
					},
					{
						"n": 15,
						"h": 241,
						"w": 283
					},
					{
						"n": 18,
						"h": 59,
						"w": 192
					},
					{
						"n": 17,
						"h": 221,
						"w": 200
					},
					{
						"n": 19,
						"h": 299,
						"w": 177
					},
					{
						"n": 20,
						"h": 157,
						"w": 183
					}
				],
				"ball": {
					"n": 0,
					"h": 282,
					"w": 331,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1919,
			"minute": 92,
			"messages": [
				{
					"owner": 2,
					"mes": "Вацлав Сланина[34](Опава) посылает мяч вперед в направлении М.Томасова[37](Опава)..."
				},
				{
					"owner": 2,
					"mes": "Том Смит[14](Галвэй Юнайтед) читает комбинацию и перехватывает мяч!..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 706
					},
					{
						"n": 2,
						"h": 387,
						"w": 579
					},
					{
						"n": 14,
						"h": 273,
						"w": 548,
						"m": 690
					},
					{
						"n": 13,
						"h": 192,
						"w": 612
					},
					{
						"n": 5,
						"h": 120,
						"w": 598
					},
					{
						"n": 6,
						"h": 389,
						"w": 499
					},
					{
						"n": 18,
						"h": 259,
						"w": 567
					},
					{
						"n": 15,
						"h": 220,
						"w": 495
					},
					{
						"n": 17,
						"h": 56,
						"w": 490
					},
					{
						"n": 20,
						"h": 286,
						"w": 380
					},
					{
						"n": 19,
						"h": 165,
						"w": 388
					}
				],
				"away": [
					{
						"n": 12,
						"h": 229,
						"w": 596
					},
					{
						"n": 13,
						"h": 399,
						"w": 265
					},
					{
						"n": 3,
						"h": 285,
						"w": 452
					},
					{
						"n": 14,
						"h": 180,
						"w": 448
					},
					{
						"n": 5,
						"h": 60,
						"w": 446
					},
					{
						"n": 16,
						"h": 233,
						"w": 299
					},
					{
						"n": 15,
						"h": 224,
						"w": 212
					},
					{
						"n": 18,
						"h": 33,
						"w": 161
					},
					{
						"n": 17,
						"h": 179,
						"w": 151
					},
					{
						"n": 19,
						"h": 274,
						"w": 141
					},
					{
						"n": 20,
						"h": 133,
						"w": 141
					}
				],
				"ball": {
					"n": 0,
					"h": 273,
					"w": 548,
					"z": 1,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 73
		},
		{
			"num": 1920,
			"minute": 92,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 225,
						"w": 701
					},
					{
						"n": 2,
						"h": 383,
						"w": 539
					},
					{
						"n": 14,
						"h": 298,
						"w": 524
					},
					{
						"n": 13,
						"h": 186,
						"w": 572
					},
					{
						"n": 5,
						"h": 103,
						"w": 562
					},
					{
						"n": 6,
						"h": 389,
						"w": 459
					},
					{
						"n": 18,
						"h": 264,
						"w": 528
					},
					{
						"n": 15,
						"h": 204,
						"w": 459
					},
					{
						"n": 17,
						"h": 49,
						"w": 451
					},
					{
						"n": 20,
						"h": 293,
						"w": 341
					},
					{
						"n": 19,
						"h": 159,
						"w": 349
					}
				],
				"away": [
					{
						"n": 12,
						"h": 216,
						"w": 638
					},
					{
						"n": 13,
						"h": 402,
						"w": 305
					},
					{
						"n": 3,
						"h": 282,
						"w": 492
					},
					{
						"n": 14,
						"h": 178,
						"w": 488
					},
					{
						"n": 5,
						"h": 90,
						"w": 472
					},
					{
						"n": 16,
						"h": 227,
						"w": 339
					},
					{
						"n": 15,
						"h": 225,
						"w": 252
					},
					{
						"n": 18,
						"h": 30,
						"w": 201
					},
					{
						"n": 17,
						"h": 183,
						"w": 161
					},
					{
						"n": 19,
						"h": 282,
						"w": 180
					},
					{
						"n": 20,
						"h": 143,
						"w": 180
					}
				],
				"ball": {
					"n": 0,
					"h": 298,
					"w": 524,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1921,
			"minute": 92,
			"messages": [
				{
					"owner": 1,
					"mes": "Том Смит[14](Галвэй Юнайтед) отдает передачу налево К.Колману[06](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 704
					},
					{
						"n": 2,
						"h": 385,
						"w": 495
					},
					{
						"n": 14,
						"h": 288,
						"w": 527
					},
					{
						"n": 13,
						"h": 181,
						"w": 529
					},
					{
						"n": 5,
						"h": 86,
						"w": 521
					},
					{
						"n": 6,
						"h": 382,
						"w": 422
					},
					{
						"n": 18,
						"h": 279,
						"w": 486
					},
					{
						"n": 15,
						"h": 193,
						"w": 416
					},
					{
						"n": 17,
						"h": 46,
						"w": 407
					},
					{
						"n": 20,
						"h": 291,
						"w": 297
					},
					{
						"n": 19,
						"h": 157,
						"w": 305
					}
				],
				"away": [
					{
						"n": 12,
						"h": 205,
						"w": 650
					},
					{
						"n": 13,
						"h": 404,
						"w": 349
					},
					{
						"n": 3,
						"h": 279,
						"w": 484
					},
					{
						"n": 14,
						"h": 176,
						"w": 481
					},
					{
						"n": 5,
						"h": 86,
						"w": 429
					},
					{
						"n": 16,
						"h": 212,
						"w": 380
					},
					{
						"n": 15,
						"h": 220,
						"w": 296
					},
					{
						"n": 18,
						"h": 35,
						"w": 245
					},
					{
						"n": 17,
						"h": 216,
						"w": 189
					},
					{
						"n": 19,
						"h": 274,
						"w": 224
					},
					{
						"n": 20,
						"h": 159,
						"w": 221
					}
				],
				"ball": {
					"n": 0,
					"h": 382,
					"w": 422,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 44
		},
		{
			"num": 1922,
			"minute": 92,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 702
					},
					{
						"n": 2,
						"h": 391,
						"w": 502
					},
					{
						"n": 14,
						"h": 276,
						"w": 547
					},
					{
						"n": 13,
						"h": 171,
						"w": 546
					},
					{
						"n": 5,
						"h": 76,
						"w": 492
					},
					{
						"n": 6,
						"h": 382,
						"w": 387
					},
					{
						"n": 18,
						"h": 309,
						"w": 460
					},
					{
						"n": 15,
						"h": 210,
						"w": 380
					},
					{
						"n": 17,
						"h": 50,
						"w": 367
					},
					{
						"n": 20,
						"h": 293,
						"w": 257
					},
					{
						"n": 19,
						"h": 164,
						"w": 265
					}
				],
				"away": [
					{
						"n": 12,
						"h": 205,
						"w": 643
					},
					{
						"n": 13,
						"h": 400,
						"w": 389
					},
					{
						"n": 3,
						"h": 276,
						"w": 491
					},
					{
						"n": 14,
						"h": 168,
						"w": 498
					},
					{
						"n": 5,
						"h": 81,
						"w": 389
					},
					{
						"n": 16,
						"h": 230,
						"w": 411
					},
					{
						"n": 15,
						"h": 228,
						"w": 335
					},
					{
						"n": 18,
						"h": 36,
						"w": 285
					},
					{
						"n": 17,
						"h": 248,
						"w": 213
					},
					{
						"n": 19,
						"h": 280,
						"w": 263
					},
					{
						"n": 20,
						"h": 148,
						"w": 259
					}
				],
				"ball": {
					"n": 0,
					"h": 382,
					"w": 387,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1923,
			"minute": 92,
			"messages": [
				{
					"owner": 1,
					"mes": "Р.Уотсон[18](Галвэй Юнайтед) открывается поблизости... Пас ему..."
				},
				{
					"owner": 1,
					"mes": "Райан Уотсон[18](Галвэй Юнайтед) получает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 703
					},
					{
						"n": 2,
						"h": 374,
						"w": 494
					},
					{
						"n": 14,
						"h": 271,
						"w": 544
					},
					{
						"n": 13,
						"h": 171,
						"w": 533
					},
					{
						"n": 5,
						"h": 63,
						"w": 490
					},
					{
						"n": 6,
						"h": 382,
						"w": 387,
						"m": 930
					},
					{
						"n": 18,
						"h": 299,
						"w": 411
					},
					{
						"n": 15,
						"h": 175,
						"w": 355
					},
					{
						"n": 17,
						"h": 50,
						"w": 324
					},
					{
						"n": 20,
						"h": 297,
						"w": 242
					},
					{
						"n": 19,
						"h": 176,
						"w": 262
					}
				],
				"away": [
					{
						"n": 12,
						"h": 215,
						"w": 644
					},
					{
						"n": 13,
						"h": 400,
						"w": 432
					},
					{
						"n": 3,
						"h": 261,
						"w": 521
					},
					{
						"n": 14,
						"h": 173,
						"w": 533
					},
					{
						"n": 5,
						"h": 80,
						"w": 432
					},
					{
						"n": 16,
						"h": 220,
						"w": 453
					},
					{
						"n": 15,
						"h": 233,
						"w": 373
					},
					{
						"n": 18,
						"h": 51,
						"w": 325
					},
					{
						"n": 17,
						"h": 279,
						"w": 243
					},
					{
						"n": 19,
						"h": 286,
						"w": 306
					},
					{
						"n": 20,
						"h": 149,
						"w": 296
					}
				],
				"ball": {
					"n": 0,
					"h": 299,
					"w": 411,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 43
		},
		{
			"num": 1924,
			"minute": 92,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 706
					},
					{
						"n": 2,
						"h": 382,
						"w": 455
					},
					{
						"n": 14,
						"h": 280,
						"w": 505
					},
					{
						"n": 13,
						"h": 167,
						"w": 493
					},
					{
						"n": 5,
						"h": 62,
						"w": 450
					},
					{
						"n": 6,
						"h": 388,
						"w": 347
					},
					{
						"n": 18,
						"h": 299,
						"w": 376
					},
					{
						"n": 15,
						"h": 178,
						"w": 315
					},
					{
						"n": 17,
						"h": 45,
						"w": 284
					},
					{
						"n": 20,
						"h": 276,
						"w": 208
					},
					{
						"n": 19,
						"h": 179,
						"w": 227
					}
				],
				"away": [
					{
						"n": 12,
						"h": 215,
						"w": 648
					},
					{
						"n": 13,
						"h": 405,
						"w": 471
					},
					{
						"n": 3,
						"h": 255,
						"w": 557
					},
					{
						"n": 14,
						"h": 190,
						"w": 563
					},
					{
						"n": 5,
						"h": 77,
						"w": 472
					},
					{
						"n": 16,
						"h": 225,
						"w": 470
					},
					{
						"n": 15,
						"h": 193,
						"w": 370
					},
					{
						"n": 18,
						"h": 56,
						"w": 365
					},
					{
						"n": 17,
						"h": 303,
						"w": 275
					},
					{
						"n": 19,
						"h": 283,
						"w": 346
					},
					{
						"n": 20,
						"h": 151,
						"w": 331
					}
				],
				"ball": {
					"n": 0,
					"h": 299,
					"w": 376,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1925,
			"minute": 92,
			"messages": [
				{
					"owner": 1,
					"mes": "Пас вперед..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 703
					},
					{
						"n": 2,
						"h": 380,
						"w": 419
					},
					{
						"n": 14,
						"h": 274,
						"w": 477
					},
					{
						"n": 13,
						"h": 171,
						"w": 467
					},
					{
						"n": 5,
						"h": 70,
						"w": 428
					},
					{
						"n": 6,
						"h": 393,
						"w": 303
					},
					{
						"n": 18,
						"h": 296,
						"w": 363
					},
					{
						"n": 15,
						"h": 168,
						"w": 272
					},
					{
						"n": 17,
						"h": 46,
						"w": 240
					},
					{
						"n": 20,
						"h": 315,
						"w": 212
					},
					{
						"n": 19,
						"h": 158,
						"w": 189
					}
				],
				"away": [
					{
						"n": 12,
						"h": 215,
						"w": 644
					},
					{
						"n": 13,
						"h": 404,
						"w": 515
					},
					{
						"n": 3,
						"h": 288,
						"w": 586
					},
					{
						"n": 14,
						"h": 166,
						"w": 600
					},
					{
						"n": 5,
						"h": 94,
						"w": 483
					},
					{
						"n": 16,
						"h": 233,
						"w": 500
					},
					{
						"n": 15,
						"h": 209,
						"w": 411
					},
					{
						"n": 18,
						"h": 57,
						"w": 409
					},
					{
						"n": 17,
						"h": 329,
						"w": 311
					},
					{
						"n": 19,
						"h": 285,
						"w": 390
					},
					{
						"n": 20,
						"h": 154,
						"w": 375
					}
				],
				"ball": {
					"n": 0,
					"h": 312,
					"w": 246,
					"z": 0,
					"r": 0,
					"p": 1,
					"x": 0
				}
			},
			"interval": 44
		},
		{
			"num": 1926,
			"minute": 92,
			"messages": [
				{
					"owner": 1,
					"mes": "Том Дэвлин[20](Галвэй Юнайтед) останавливает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 705
					},
					{
						"n": 2,
						"h": 381,
						"w": 402
					},
					{
						"n": 14,
						"h": 279,
						"w": 461
					},
					{
						"n": 13,
						"h": 177,
						"w": 451
					},
					{
						"n": 5,
						"h": 66,
						"w": 412
					},
					{
						"n": 6,
						"h": 394,
						"w": 286
					},
					{
						"n": 18,
						"h": 296,
						"w": 346
					},
					{
						"n": 15,
						"h": 167,
						"w": 255
					},
					{
						"n": 17,
						"h": 46,
						"w": 223
					},
					{
						"n": 20,
						"h": 314,
						"w": 229
					},
					{
						"n": 19,
						"h": 165,
						"w": 173
					}
				],
				"away": [
					{
						"n": 12,
						"h": 215,
						"w": 643
					},
					{
						"n": 13,
						"h": 404,
						"w": 532
					},
					{
						"n": 3,
						"h": 272,
						"w": 594
					},
					{
						"n": 14,
						"h": 162,
						"w": 583
					},
					{
						"n": 5,
						"h": 93,
						"w": 499
					},
					{
						"n": 16,
						"h": 232,
						"w": 517
					},
					{
						"n": 15,
						"h": 214,
						"w": 427
					},
					{
						"n": 18,
						"h": 57,
						"w": 426
					},
					{
						"n": 17,
						"h": 338,
						"w": 325
					},
					{
						"n": 19,
						"h": 287,
						"w": 406
					},
					{
						"n": 20,
						"h": 154,
						"w": 392
					}
				],
				"ball": {
					"n": 0,
					"h": 314,
					"w": 229,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 17
		},
		{
			"num": 1927,
			"minute": 92,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 701
					},
					{
						"n": 2,
						"h": 379,
						"w": 363
					},
					{
						"n": 14,
						"h": 267,
						"w": 426
					},
					{
						"n": 13,
						"h": 187,
						"w": 431
					},
					{
						"n": 5,
						"h": 60,
						"w": 372
					},
					{
						"n": 6,
						"h": 396,
						"w": 246
					},
					{
						"n": 18,
						"h": 290,
						"w": 307
					},
					{
						"n": 15,
						"h": 161,
						"w": 216
					},
					{
						"n": 17,
						"h": 45,
						"w": 183
					},
					{
						"n": 20,
						"h": 308,
						"w": 194
					},
					{
						"n": 19,
						"h": 159,
						"w": 133
					}
				],
				"away": [
					{
						"n": 12,
						"h": 220,
						"w": 683
					},
					{
						"n": 13,
						"h": 405,
						"w": 572
					},
					{
						"n": 3,
						"h": 247,
						"w": 618
					},
					{
						"n": 14,
						"h": 148,
						"w": 546
					},
					{
						"n": 5,
						"h": 90,
						"w": 542
					},
					{
						"n": 16,
						"h": 271,
						"w": 525
					},
					{
						"n": 15,
						"h": 220,
						"w": 467
					},
					{
						"n": 18,
						"h": 55,
						"w": 466
					},
					{
						"n": 17,
						"h": 358,
						"w": 360
					},
					{
						"n": 19,
						"h": 287,
						"w": 421
					},
					{
						"n": 20,
						"h": 160,
						"w": 432
					}
				],
				"ball": {
					"n": 0,
					"h": 308,
					"w": 194,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1928,
			"minute": 92,
			"messages": [
				{
					"owner": 1,
					"mes": "Т.Дэвлин[20](Галвэй Юнайтед) делает передачу Б.О`Горману[19](Галвэй Юнайтед)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 709
					},
					{
						"n": 2,
						"h": 376,
						"w": 355
					},
					{
						"n": 14,
						"h": 271,
						"w": 415
					},
					{
						"n": 13,
						"h": 178,
						"w": 418
					},
					{
						"n": 5,
						"h": 60,
						"w": 359
					},
					{
						"n": 6,
						"h": 399,
						"w": 218
					},
					{
						"n": 18,
						"h": 287,
						"w": 278
					},
					{
						"n": 15,
						"h": 157,
						"w": 187
					},
					{
						"n": 17,
						"h": 50,
						"w": 155
					},
					{
						"n": 20,
						"h": 306,
						"w": 184,
						"m": 560
					},
					{
						"n": 19,
						"h": 188,
						"w": 131,
						"m": 660
					}
				],
				"away": [
					{
						"n": 12,
						"h": 225,
						"w": 688
					},
					{
						"n": 13,
						"h": 400,
						"w": 601
					},
					{
						"n": 3,
						"h": 235,
						"w": 592
					},
					{
						"n": 14,
						"h": 167,
						"w": 568
					},
					{
						"n": 5,
						"h": 90,
						"w": 571
					},
					{
						"n": 16,
						"h": 298,
						"w": 536
					},
					{
						"n": 15,
						"h": 233,
						"w": 481
					},
					{
						"n": 18,
						"h": 53,
						"w": 494
					},
					{
						"n": 17,
						"h": 367,
						"w": 387
					},
					{
						"n": 19,
						"h": 281,
						"w": 429
					},
					{
						"n": 20,
						"h": 170,
						"w": 410
					}
				],
				"ball": {
					"n": 0,
					"h": 215,
					"w": 128,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 29
		},
		{
			"num": 1929,
			"minute": 92,
			"messages": [
				{
					"owner": 1,
					"mes": "Нир Мансур[23](Опава) делает рывок и перехватывает мяч..."
				}
			]
		},
		{
			"num": 1930,
			"minute": 93,
			"possession": 42,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 227,
						"w": 702
					},
					{
						"n": 2,
						"h": 367,
						"w": 394
					},
					{
						"n": 14,
						"h": 268,
						"w": 408
					},
					{
						"n": 13,
						"h": 178,
						"w": 420,
						"f": 89,
						"c": 1
					},
					{
						"n": 5,
						"h": 83,
						"w": 355
					},
					{
						"n": 6,
						"h": 399,
						"w": 258
					},
					{
						"n": 18,
						"h": 272,
						"w": 315
					},
					{
						"n": 15,
						"h": 167,
						"w": 226
					},
					{
						"n": 17,
						"h": 52,
						"w": 195,
						"f": 81
					},
					{
						"n": 20,
						"h": 292,
						"w": 222,
						"f": 78
					},
					{
						"n": 19,
						"h": 219,
						"w": 156,
						"f": 86
					}
				],
				"away": [
					{
						"n": 12,
						"h": 228,
						"w": 702
					},
					{
						"n": 13,
						"h": 399,
						"w": 551
					},
					{
						"n": 3,
						"h": 210,
						"w": 567,
						"m": 750
					},
					{
						"n": 14,
						"h": 170,
						"w": 608
					},
					{
						"n": 5,
						"h": 75,
						"w": 608
					},
					{
						"n": 16,
						"h": 269,
						"w": 509,
						"f": 88
					},
					{
						"n": 15,
						"h": 228,
						"w": 442,
						"f": 92
					},
					{
						"n": 18,
						"h": 49,
						"w": 455,
						"f": 89,
						"c": 1
					},
					{
						"n": 17,
						"h": 397,
						"w": 385
					},
					{
						"n": 19,
						"h": 291,
						"w": 390,
						"f": 87
					},
					{
						"n": 20,
						"h": 162,
						"w": 371
					}
				],
				"ball": {
					"n": 0,
					"h": 240,
					"w": 153,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1931,
			"minute": 93,
			"messages": [
				{
					"owner": 2,
					"mes": "Нир Мансур[23](Опава) смотрит направо... Пас Т.Прохазке[25](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 710
					},
					{
						"n": 2,
						"h": 345,
						"w": 425
					},
					{
						"n": 14,
						"h": 268,
						"w": 439
					},
					{
						"n": 13,
						"h": 187,
						"w": 449
					},
					{
						"n": 5,
						"h": 82,
						"w": 363
					},
					{
						"n": 6,
						"h": 404,
						"w": 295
					},
					{
						"n": 18,
						"h": 288,
						"w": 350
					},
					{
						"n": 15,
						"h": 182,
						"w": 261
					},
					{
						"n": 17,
						"h": 50,
						"w": 233
					},
					{
						"n": 20,
						"h": 315,
						"w": 191
					},
					{
						"n": 19,
						"h": 204,
						"w": 191
					}
				],
				"away": [
					{
						"n": 12,
						"h": 230,
						"w": 702
					},
					{
						"n": 13,
						"h": 406,
						"w": 513
					},
					{
						"n": 3,
						"h": 218,
						"w": 572,
						"m": 760
					},
					{
						"n": 14,
						"h": 184,
						"w": 620
					},
					{
						"n": 5,
						"h": 100,
						"w": 596
					},
					{
						"n": 16,
						"h": 252,
						"w": 475
					},
					{
						"n": 15,
						"h": 227,
						"w": 404
					},
					{
						"n": 18,
						"h": 49,
						"w": 417
					},
					{
						"n": 17,
						"h": 398,
						"w": 377
					},
					{
						"n": 19,
						"h": 297,
						"w": 353
					},
					{
						"n": 20,
						"h": 145,
						"w": 337
					}
				],
				"ball": {
					"n": 0,
					"h": 350,
					"w": 124,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 38
		},
		{
			"num": 1932,
			"minute": 93,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 707
					},
					{
						"n": 2,
						"h": 330,
						"w": 450
					},
					{
						"n": 14,
						"h": 288,
						"w": 457
					},
					{
						"n": 13,
						"h": 175,
						"w": 473
					},
					{
						"n": 5,
						"h": 84,
						"w": 403
					},
					{
						"n": 6,
						"h": 399,
						"w": 335
					},
					{
						"n": 18,
						"h": 280,
						"w": 386
					},
					{
						"n": 15,
						"h": 190,
						"w": 300
					},
					{
						"n": 17,
						"h": 42,
						"w": 272
					},
					{
						"n": 20,
						"h": 305,
						"w": 230
					},
					{
						"n": 19,
						"h": 193,
						"w": 229
					}
				],
				"away": [
					{
						"n": 12,
						"h": 228,
						"w": 706
					},
					{
						"n": 13,
						"h": 401,
						"w": 474
					},
					{
						"n": 3,
						"h": 258,
						"w": 575
					},
					{
						"n": 14,
						"h": 171,
						"w": 587
					},
					{
						"n": 5,
						"h": 83,
						"w": 565
					},
					{
						"n": 16,
						"h": 221,
						"w": 449
					},
					{
						"n": 15,
						"h": 212,
						"w": 367
					},
					{
						"n": 18,
						"h": 52,
						"w": 377
					},
					{
						"n": 17,
						"h": 396,
						"w": 337
					},
					{
						"n": 19,
						"h": 300,
						"w": 313
					},
					{
						"n": 20,
						"h": 149,
						"w": 297
					}
				],
				"ball": {
					"n": 0,
					"h": 367,
					"w": 155,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1933,
			"minute": 93,
			"messages": [
				{
					"owner": 2,
					"mes": "Пас В.Сланине[34](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 705
					},
					{
						"n": 2,
						"h": 330,
						"w": 460
					},
					{
						"n": 14,
						"h": 269,
						"w": 471
					},
					{
						"n": 13,
						"h": 184,
						"w": 452
					},
					{
						"n": 5,
						"h": 70,
						"w": 430
					},
					{
						"n": 6,
						"h": 397,
						"w": 365
					},
					{
						"n": 18,
						"h": 250,
						"w": 391
					},
					{
						"n": 15,
						"h": 189,
						"w": 330
					},
					{
						"n": 17,
						"h": 46,
						"w": 302
					},
					{
						"n": 20,
						"h": 309,
						"w": 260
					},
					{
						"n": 19,
						"h": 181,
						"w": 256
					}
				],
				"away": [
					{
						"n": 12,
						"h": 220,
						"w": 710
					},
					{
						"n": 13,
						"h": 401,
						"w": 455
					},
					{
						"n": 3,
						"h": 278,
						"w": 598
					},
					{
						"n": 14,
						"h": 150,
						"w": 567
					},
					{
						"n": 5,
						"h": 75,
						"w": 571
					},
					{
						"n": 16,
						"h": 211,
						"w": 455
					},
					{
						"n": 15,
						"h": 219,
						"w": 370
					},
					{
						"n": 18,
						"h": 51,
						"w": 347
					},
					{
						"n": 17,
						"h": 410,
						"w": 310
					},
					{
						"n": 19,
						"h": 282,
						"w": 300
					},
					{
						"n": 20,
						"h": 169,
						"w": 274
					}
				],
				"ball": {
					"n": 0,
					"h": 300,
					"w": 153,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 30
		},
		{
			"num": 1934,
			"minute": 93,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 707
					},
					{
						"n": 2,
						"h": 330,
						"w": 487
					},
					{
						"n": 14,
						"h": 268,
						"w": 459
					},
					{
						"n": 13,
						"h": 179,
						"w": 480
					},
					{
						"n": 5,
						"h": 101,
						"w": 455
					},
					{
						"n": 6,
						"h": 392,
						"w": 404
					},
					{
						"n": 18,
						"h": 224,
						"w": 390
					},
					{
						"n": 15,
						"h": 193,
						"w": 364
					},
					{
						"n": 17,
						"h": 36,
						"w": 341
					},
					{
						"n": 20,
						"h": 285,
						"w": 292
					},
					{
						"n": 19,
						"h": 176,
						"w": 296
					}
				],
				"away": [
					{
						"n": 12,
						"h": 220,
						"w": 709
					},
					{
						"n": 13,
						"h": 396,
						"w": 457
					},
					{
						"n": 3,
						"h": 275,
						"w": 611
					},
					{
						"n": 14,
						"h": 168,
						"w": 536
					},
					{
						"n": 5,
						"h": 56,
						"w": 598
					},
					{
						"n": 16,
						"h": 232,
						"w": 421
					},
					{
						"n": 15,
						"h": 218,
						"w": 357
					},
					{
						"n": 18,
						"h": 48,
						"w": 307
					},
					{
						"n": 17,
						"h": 417,
						"w": 300
					},
					{
						"n": 19,
						"h": 288,
						"w": 298
					},
					{
						"n": 20,
						"h": 172,
						"w": 277
					}
				],
				"ball": {
					"n": 0,
					"h": 282,
					"w": 184,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1935,
			"minute": 93,
			"messages": [
				{
					"owner": 2,
					"mes": "Пас налево..."
				},
				{
					"owner": 2,
					"mes": "Нир Мансур[23](Опава) останавливает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 709
					},
					{
						"n": 2,
						"h": 330,
						"w": 460
					},
					{
						"n": 14,
						"h": 277,
						"w": 450
					},
					{
						"n": 13,
						"h": 164,
						"w": 472
					},
					{
						"n": 5,
						"h": 85,
						"w": 430
					},
					{
						"n": 6,
						"h": 394,
						"w": 435
					},
					{
						"n": 18,
						"h": 228,
						"w": 385
					},
					{
						"n": 15,
						"h": 184,
						"w": 358
					},
					{
						"n": 17,
						"h": 61,
						"w": 360
					},
					{
						"n": 20,
						"h": 290,
						"w": 301
					},
					{
						"n": 19,
						"h": 135,
						"w": 280
					}
				],
				"away": [
					{
						"n": 12,
						"h": 225,
						"w": 705
					},
					{
						"n": 13,
						"h": 416,
						"w": 441
					},
					{
						"n": 3,
						"h": 271,
						"w": 567
					},
					{
						"n": 14,
						"h": 171,
						"w": 546
					},
					{
						"n": 5,
						"h": 68,
						"w": 581
					},
					{
						"n": 16,
						"h": 226,
						"w": 428
					},
					{
						"n": 15,
						"h": 217,
						"w": 365
					},
					{
						"n": 18,
						"h": 31,
						"w": 300
					},
					{
						"n": 17,
						"h": 374,
						"w": 310
					},
					{
						"n": 19,
						"h": 296,
						"w": 285
					},
					{
						"n": 20,
						"h": 162,
						"w": 300
					}
				],
				"ball": {
					"n": 0,
					"h": 179,
					"w": 153,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 44
		},
		{
			"num": 1936,
			"minute": 93,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 709
					},
					{
						"n": 2,
						"h": 330,
						"w": 472
					},
					{
						"n": 14,
						"h": 277,
						"w": 468
					},
					{
						"n": 13,
						"h": 173,
						"w": 483
					},
					{
						"n": 5,
						"h": 110,
						"w": 461
					},
					{
						"n": 6,
						"h": 383,
						"w": 449
					},
					{
						"n": 18,
						"h": 268,
						"w": 390
					},
					{
						"n": 15,
						"h": 202,
						"w": 365
					},
					{
						"n": 17,
						"h": 41,
						"w": 362
					},
					{
						"n": 20,
						"h": 315,
						"w": 284
					},
					{
						"n": 19,
						"h": 161,
						"w": 305
					}
				],
				"away": [
					{
						"n": 12,
						"h": 225,
						"w": 703
					},
					{
						"n": 13,
						"h": 392,
						"w": 446
					},
					{
						"n": 3,
						"h": 268,
						"w": 532
					},
					{
						"n": 14,
						"h": 167,
						"w": 585
					},
					{
						"n": 5,
						"h": 62,
						"w": 602
					},
					{
						"n": 16,
						"h": 205,
						"w": 454
					},
					{
						"n": 15,
						"h": 240,
						"w": 369
					},
					{
						"n": 18,
						"h": 52,
						"w": 300
					},
					{
						"n": 17,
						"h": 336,
						"w": 322
					},
					{
						"n": 19,
						"h": 289,
						"w": 273
					},
					{
						"n": 20,
						"h": 161,
						"w": 274
					}
				],
				"ball": {
					"n": 0,
					"h": 182,
					"w": 188,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1937,
			"minute": 93,
			"messages": [
				{
					"owner": 2,
					"mes": "Нир Мансур[23](Опава) пасует на М.Владаржа[36](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 707
					},
					{
						"n": 2,
						"h": 330,
						"w": 489
					},
					{
						"n": 14,
						"h": 270,
						"w": 493
					},
					{
						"n": 13,
						"h": 169,
						"w": 500
					},
					{
						"n": 5,
						"h": 120,
						"w": 474
					},
					{
						"n": 6,
						"h": 394,
						"w": 458
					},
					{
						"n": 18,
						"h": 265,
						"w": 388
					},
					{
						"n": 15,
						"h": 227,
						"w": 388
					},
					{
						"n": 17,
						"h": 32,
						"w": 373
					},
					{
						"n": 20,
						"h": 321,
						"w": 303
					},
					{
						"n": 19,
						"h": 167,
						"w": 330
					}
				],
				"away": [
					{
						"n": 12,
						"h": 222,
						"w": 710
					},
					{
						"n": 13,
						"h": 400,
						"w": 413
					},
					{
						"n": 3,
						"h": 271,
						"w": 542
					},
					{
						"n": 14,
						"h": 185,
						"w": 566
					},
					{
						"n": 5,
						"h": 61,
						"w": 568
					},
					{
						"n": 16,
						"h": 222,
						"w": 484
					},
					{
						"n": 15,
						"h": 229,
						"w": 337
					},
					{
						"n": 18,
						"h": 36,
						"w": 277
					},
					{
						"n": 17,
						"h": 314,
						"w": 348
					},
					{
						"n": 19,
						"h": 294,
						"w": 268
					},
					{
						"n": 20,
						"h": 164,
						"w": 260
					}
				],
				"ball": {
					"n": 0,
					"h": 228,
					"w": 236,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 34
		},
		{
			"num": 1938,
			"minute": 93,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 701
					},
					{
						"n": 2,
						"h": 370,
						"w": 495
					},
					{
						"n": 14,
						"h": 277,
						"w": 515
					},
					{
						"n": 13,
						"h": 191,
						"w": 512
					},
					{
						"n": 5,
						"h": 120,
						"w": 514
					},
					{
						"n": 6,
						"h": 397,
						"w": 418
					},
					{
						"n": 18,
						"h": 262,
						"w": 428
					},
					{
						"n": 15,
						"h": 224,
						"w": 414
					},
					{
						"n": 17,
						"h": 56,
						"w": 346
					},
					{
						"n": 20,
						"h": 322,
						"w": 332
					},
					{
						"n": 19,
						"h": 172,
						"w": 355
					}
				],
				"away": [
					{
						"n": 12,
						"h": 222,
						"w": 694
					},
					{
						"n": 13,
						"h": 417,
						"w": 389
					},
					{
						"n": 3,
						"h": 276,
						"w": 554
					},
					{
						"n": 14,
						"h": 166,
						"w": 532
					},
					{
						"n": 5,
						"h": 63,
						"w": 545
					},
					{
						"n": 16,
						"h": 214,
						"w": 450
					},
					{
						"n": 15,
						"h": 235,
						"w": 297
					},
					{
						"n": 18,
						"h": 37,
						"w": 243
					},
					{
						"n": 17,
						"h": 324,
						"w": 349
					},
					{
						"n": 19,
						"h": 275,
						"w": 233
					},
					{
						"n": 20,
						"h": 154,
						"w": 227
					}
				],
				"ball": {
					"n": 0,
					"h": 236,
					"w": 270,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1939,
			"minute": 93,
			"messages": [
				{
					"owner": 2,
					"mes": "Михаэль Владарж[36](Опава) делает передачу направо на Т.Прохазку[25](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 220,
						"w": 705
					},
					{
						"n": 2,
						"h": 379,
						"w": 517
					},
					{
						"n": 14,
						"h": 283,
						"w": 544
					},
					{
						"n": 13,
						"h": 175,
						"w": 546
					},
					{
						"n": 5,
						"h": 120,
						"w": 547
					},
					{
						"n": 6,
						"h": 390,
						"w": 438
					},
					{
						"n": 18,
						"h": 269,
						"w": 467
					},
					{
						"n": 15,
						"h": 218,
						"w": 418
					},
					{
						"n": 17,
						"h": 56,
						"w": 370
					},
					{
						"n": 20,
						"h": 266,
						"w": 310
					},
					{
						"n": 19,
						"h": 173,
						"w": 373
					}
				],
				"away": [
					{
						"n": 12,
						"h": 227,
						"w": 674
					},
					{
						"n": 13,
						"h": 397,
						"w": 385
					},
					{
						"n": 3,
						"h": 284,
						"w": 530
					},
					{
						"n": 14,
						"h": 176,
						"w": 515
					},
					{
						"n": 5,
						"h": 57,
						"w": 486
					},
					{
						"n": 16,
						"h": 210,
						"w": 440
					},
					{
						"n": 15,
						"h": 188,
						"w": 280
					},
					{
						"n": 18,
						"h": 41,
						"w": 223
					},
					{
						"n": 17,
						"h": 264,
						"w": 350
					},
					{
						"n": 19,
						"h": 302,
						"w": 207
					},
					{
						"n": 20,
						"h": 152,
						"w": 199
					}
				],
				"ball": {
					"n": 0,
					"h": 393,
					"w": 234,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 60
		},
		{
			"num": 1940,
			"minute": 93,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 229,
						"w": 706
					},
					{
						"n": 2,
						"h": 385,
						"w": 540
					},
					{
						"n": 14,
						"h": 281,
						"w": 569
					},
					{
						"n": 13,
						"h": 171,
						"w": 577
					},
					{
						"n": 5,
						"h": 120,
						"w": 557
					},
					{
						"n": 6,
						"h": 405,
						"w": 451
					},
					{
						"n": 18,
						"h": 246,
						"w": 470
					},
					{
						"n": 15,
						"h": 215,
						"w": 437
					},
					{
						"n": 17,
						"h": 56,
						"w": 410
					},
					{
						"n": 20,
						"h": 273,
						"w": 322
					},
					{
						"n": 19,
						"h": 173,
						"w": 408
					}
				],
				"away": [
					{
						"n": 12,
						"h": 221,
						"w": 650
					},
					{
						"n": 13,
						"h": 400,
						"w": 345
					},
					{
						"n": 3,
						"h": 285,
						"w": 497
					},
					{
						"n": 14,
						"h": 167,
						"w": 497
					},
					{
						"n": 5,
						"h": 43,
						"w": 453
					},
					{
						"n": 16,
						"h": 177,
						"w": 418
					},
					{
						"n": 15,
						"h": 197,
						"w": 266
					},
					{
						"n": 18,
						"h": 35,
						"w": 200
					},
					{
						"n": 17,
						"h": 227,
						"w": 340
					},
					{
						"n": 19,
						"h": 301,
						"w": 178
					},
					{
						"n": 20,
						"h": 153,
						"w": 184
					}
				],
				"ball": {
					"n": 0,
					"h": 407,
					"w": 267,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1941,
			"minute": 93,
			"messages": [
				{
					"owner": 2,
					"mes": "Томаш Прохазка[25](Опава) отдает передачу налево Н.Мансуру[23](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 226,
						"w": 702
					},
					{
						"n": 2,
						"h": 365,
						"w": 540
					},
					{
						"n": 14,
						"h": 280,
						"w": 568
					},
					{
						"n": 13,
						"h": 174,
						"w": 566
					},
					{
						"n": 5,
						"h": 120,
						"w": 560
					},
					{
						"n": 6,
						"h": 398,
						"w": 460
					},
					{
						"n": 18,
						"h": 271,
						"w": 468
					},
					{
						"n": 15,
						"h": 223,
						"w": 471
					},
					{
						"n": 17,
						"h": 56,
						"w": 409
					},
					{
						"n": 20,
						"h": 278,
						"w": 378
					},
					{
						"n": 19,
						"h": 147,
						"w": 375
					}
				],
				"away": [
					{
						"n": 12,
						"h": 225,
						"w": 635
					},
					{
						"n": 13,
						"h": 417,
						"w": 326
					},
					{
						"n": 3,
						"h": 265,
						"w": 471
					},
					{
						"n": 14,
						"h": 167,
						"w": 505
					},
					{
						"n": 5,
						"h": 48,
						"w": 462
					},
					{
						"n": 16,
						"h": 226,
						"w": 394
					},
					{
						"n": 15,
						"h": 225,
						"w": 240
					},
					{
						"n": 18,
						"h": 55,
						"w": 200
					},
					{
						"n": 17,
						"h": 283,
						"w": 337
					},
					{
						"n": 19,
						"h": 294,
						"w": 182
					},
					{
						"n": 20,
						"h": 150,
						"w": 177
					}
				],
				"ball": {
					"n": 0,
					"h": 185,
					"w": 249,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 56
		},
		{
			"num": 1942,
			"minute": 93,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 221,
						"w": 703
					},
					{
						"n": 2,
						"h": 335,
						"w": 566
					},
					{
						"n": 14,
						"h": 260,
						"w": 551
					},
					{
						"n": 13,
						"h": 191,
						"w": 580
					},
					{
						"n": 5,
						"h": 120,
						"w": 577
					},
					{
						"n": 6,
						"h": 404,
						"w": 460
					},
					{
						"n": 18,
						"h": 232,
						"w": 476
					},
					{
						"n": 15,
						"h": 192,
						"w": 445
					},
					{
						"n": 17,
						"h": 56,
						"w": 430
					},
					{
						"n": 20,
						"h": 313,
						"w": 375
					},
					{
						"n": 19,
						"h": 158,
						"w": 337
					}
				],
				"away": [
					{
						"n": 12,
						"h": 230,
						"w": 616
					},
					{
						"n": 13,
						"h": 401,
						"w": 325
					},
					{
						"n": 3,
						"h": 282,
						"w": 440
					},
					{
						"n": 14,
						"h": 167,
						"w": 472
					},
					{
						"n": 5,
						"h": 72,
						"w": 443
					},
					{
						"n": 16,
						"h": 222,
						"w": 377
					},
					{
						"n": 15,
						"h": 213,
						"w": 257
					},
					{
						"n": 18,
						"h": 52,
						"w": 200
					},
					{
						"n": 17,
						"h": 314,
						"w": 311
					},
					{
						"n": 19,
						"h": 272,
						"w": 191
					},
					{
						"n": 20,
						"h": 178,
						"w": 187
					}
				],
				"ball": {
					"n": 0,
					"h": 168,
					"w": 280,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1943,
			"minute": 93,
			"messages": [
				{
					"owner": 2,
					"mes": "Н.Мансур[23](Опава) делает передачу В.Сланине[34](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 705
					},
					{
						"n": 2,
						"h": 330,
						"w": 563
					},
					{
						"n": 14,
						"h": 272,
						"w": 569
					},
					{
						"n": 13,
						"h": 186,
						"w": 557
					},
					{
						"n": 5,
						"h": 120,
						"w": 561
					},
					{
						"n": 6,
						"h": 400,
						"w": 496
					},
					{
						"n": 18,
						"h": 268,
						"w": 473
					},
					{
						"n": 15,
						"h": 208,
						"w": 461
					},
					{
						"n": 17,
						"h": 56,
						"w": 421
					},
					{
						"n": 20,
						"h": 310,
						"w": 339
					},
					{
						"n": 19,
						"h": 148,
						"w": 371
					}
				],
				"away": [
					{
						"n": 12,
						"h": 220,
						"w": 614
					},
					{
						"n": 13,
						"h": 396,
						"w": 334
					},
					{
						"n": 3,
						"h": 282,
						"w": 450
					},
					{
						"n": 14,
						"h": 148,
						"w": 441
					},
					{
						"n": 5,
						"h": 68,
						"w": 479
					},
					{
						"n": 16,
						"h": 220,
						"w": 383
					},
					{
						"n": 15,
						"h": 238,
						"w": 261
					},
					{
						"n": 18,
						"h": 39,
						"w": 180
					},
					{
						"n": 17,
						"h": 307,
						"w": 324
					},
					{
						"n": 19,
						"h": 275,
						"w": 196
					},
					{
						"n": 20,
						"h": 165,
						"w": 178
					}
				],
				"ball": {
					"n": 0,
					"h": 276,
					"w": 288,
					"z": 0,
					"r": 0,
					"p": 2,
					"x": 0
				}
			},
			"interval": 36
		},
		{
			"num": 1944,
			"minute": 93,
			"messages": [
				{
					"owner": 2,
					"mes": "Вацлав Сланина[34](Опава) принимает мяч..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 228,
						"w": 704
					},
					{
						"n": 2,
						"h": 330,
						"w": 561
					},
					{
						"n": 14,
						"h": 265,
						"w": 564
					},
					{
						"n": 13,
						"h": 195,
						"w": 562
					},
					{
						"n": 5,
						"h": 120,
						"w": 568
					},
					{
						"n": 6,
						"h": 397,
						"w": 518
					},
					{
						"n": 18,
						"h": 246,
						"w": 474
					},
					{
						"n": 15,
						"h": 186,
						"w": 460
					},
					{
						"n": 17,
						"h": 56,
						"w": 428
					},
					{
						"n": 20,
						"h": 308,
						"w": 317
					},
					{
						"n": 19,
						"h": 168,
						"w": 362
					}
				],
				"away": [
					{
						"n": 12,
						"h": 220,
						"w": 609
					},
					{
						"n": 13,
						"h": 395,
						"w": 327
					},
					{
						"n": 3,
						"h": 282,
						"w": 467
					},
					{
						"n": 14,
						"h": 142,
						"w": 430
					},
					{
						"n": 5,
						"h": 71,
						"w": 501
					},
					{
						"n": 16,
						"h": 225,
						"w": 404
					},
					{
						"n": 15,
						"h": 222,
						"w": 247
					},
					{
						"n": 18,
						"h": 33,
						"w": 185
					},
					{
						"n": 17,
						"h": 321,
						"w": 316
					},
					{
						"n": 19,
						"h": 274,
						"w": 188
					},
					{
						"n": 20,
						"h": 167,
						"w": 175
					}
				],
				"ball": {
					"n": 0,
					"h": 308,
					"w": 290,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 22
		},
		{
			"num": 1945,
			"minute": 93,
			"messages": [
				{
					"owner": 2,
					"mes": "Вацлав Сланина[34](Опава) отдает пас М.Владаржу[36](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 224,
						"w": 710
					},
					{
						"n": 2,
						"h": 330,
						"w": 550
					},
					{
						"n": 14,
						"h": 269,
						"w": 554
					},
					{
						"n": 13,
						"h": 167,
						"w": 564
					},
					{
						"n": 5,
						"h": 120,
						"w": 567
					},
					{
						"n": 6,
						"h": 379,
						"w": 545
					},
					{
						"n": 18,
						"h": 257,
						"w": 467
					},
					{
						"n": 15,
						"h": 219,
						"w": 456
					},
					{
						"n": 17,
						"h": 56,
						"w": 416
					},
					{
						"n": 20,
						"h": 299,
						"w": 353
					},
					{
						"n": 19,
						"h": 202,
						"w": 346
					}
				],
				"away": [
					{
						"n": 12,
						"h": 225,
						"w": 618
					},
					{
						"n": 13,
						"h": 406,
						"w": 339
					},
					{
						"n": 3,
						"h": 275,
						"w": 486
					},
					{
						"n": 14,
						"h": 147,
						"w": 439
					},
					{
						"n": 5,
						"h": 60,
						"w": 482
					},
					{
						"n": 16,
						"h": 214,
						"w": 410
					},
					{
						"n": 15,
						"h": 226,
						"w": 254
					},
					{
						"n": 18,
						"h": 56,
						"w": 186
					},
					{
						"n": 17,
						"h": 284,
						"w": 322
					},
					{
						"n": 19,
						"h": 295,
						"w": 199
					},
					{
						"n": 20,
						"h": 161,
						"w": 197
					}
				],
				"ball": {
					"n": 0,
					"h": 236,
					"w": 310,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 37
		},
		{
			"num": 1946,
			"minute": 93,
			"messages": [
				{
					"owner": 2,
					"mes": "Пас направо на Т.Прохазку[25](Опава)..."
				}
			],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 230,
						"w": 706
					},
					{
						"n": 2,
						"h": 330,
						"w": 565
					},
					{
						"n": 14,
						"h": 267,
						"w": 557
					},
					{
						"n": 13,
						"h": 170,
						"w": 565
					},
					{
						"n": 5,
						"h": 120,
						"w": 567
					},
					{
						"n": 6,
						"h": 378,
						"w": 545
					},
					{
						"n": 18,
						"h": 270,
						"w": 470
					},
					{
						"n": 15,
						"h": 207,
						"w": 453
					},
					{
						"n": 17,
						"h": 56,
						"w": 434
					},
					{
						"n": 20,
						"h": 244,
						"w": 338
					},
					{
						"n": 19,
						"h": 168,
						"w": 392
					}
				],
				"away": [
					{
						"n": 12,
						"h": 215,
						"w": 598
					},
					{
						"n": 13,
						"h": 404,
						"w": 321
					},
					{
						"n": 3,
						"h": 276,
						"w": 443
					},
					{
						"n": 14,
						"h": 166,
						"w": 442
					},
					{
						"n": 5,
						"h": 68,
						"w": 425
					},
					{
						"n": 16,
						"h": 207,
						"w": 402
					},
					{
						"n": 15,
						"h": 176,
						"w": 258
					},
					{
						"n": 18,
						"h": 57,
						"w": 200
					},
					{
						"n": 17,
						"h": 248,
						"w": 315
					},
					{
						"n": 19,
						"h": 297,
						"w": 190
					},
					{
						"n": 20,
						"h": 170,
						"w": 180
					}
				],
				"ball": {
					"n": 0,
					"h": 382,
					"w": 295,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 57
		},
		{
			"num": 1947,
			"minute": 93,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 222,
						"w": 708
					},
					{
						"n": 2,
						"h": 369,
						"w": 558
					},
					{
						"n": 14,
						"h": 270,
						"w": 558
					},
					{
						"n": 13,
						"h": 196,
						"w": 582
					},
					{
						"n": 5,
						"h": 120,
						"w": 561
					},
					{
						"n": 6,
						"h": 399,
						"w": 511
					},
					{
						"n": 18,
						"h": 286,
						"w": 499
					},
					{
						"n": 15,
						"h": 229,
						"w": 464
					},
					{
						"n": 17,
						"h": 56,
						"w": 436
					},
					{
						"n": 20,
						"h": 277,
						"w": 353
					},
					{
						"n": 19,
						"h": 163,
						"w": 415
					}
				],
				"away": [
					{
						"n": 12,
						"h": 215,
						"w": 615
					},
					{
						"n": 13,
						"h": 403,
						"w": 319
					},
					{
						"n": 3,
						"h": 271,
						"w": 482
					},
					{
						"n": 14,
						"h": 168,
						"w": 481
					},
					{
						"n": 5,
						"h": 68,
						"w": 388
					},
					{
						"n": 16,
						"h": 173,
						"w": 387
					},
					{
						"n": 15,
						"h": 214,
						"w": 265
					},
					{
						"n": 18,
						"h": 54,
						"w": 173
					},
					{
						"n": 17,
						"h": 249,
						"w": 326
					},
					{
						"n": 19,
						"h": 273,
						"w": 173
					},
					{
						"n": 20,
						"h": 165,
						"w": 192
					}
				],
				"ball": {
					"n": 0,
					"h": 382,
					"w": 332,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1948,
			"minute": 93,
			"messages": [],
			"coordinates": {
				"home": [
					{
						"n": 1,
						"h": 223,
						"w": 703
					},
					{
						"n": 2,
						"h": 394,
						"w": 567
					},
					{
						"n": 14,
						"h": 273,
						"w": 598
					},
					{
						"n": 13,
						"h": 163,
						"w": 587
					},
					{
						"n": 5,
						"h": 120,
						"w": 601
					},
					{
						"n": 6,
						"h": 426,
						"w": 502
					},
					{
						"n": 18,
						"h": 249,
						"w": 511
					},
					{
						"n": 15,
						"h": 207,
						"w": 497
					},
					{
						"n": 17,
						"h": 56,
						"w": 476
					},
					{
						"n": 20,
						"h": 255,
						"w": 387
					},
					{
						"n": 19,
						"h": 162,
						"w": 411
					}
				],
				"away": [
					{
						"n": 12,
						"h": 229,
						"w": 595
					},
					{
						"n": 13,
						"h": 399,
						"w": 279
					},
					{
						"n": 3,
						"h": 287,
						"w": 469
					},
					{
						"n": 14,
						"h": 182,
						"w": 468
					},
					{
						"n": 5,
						"h": 71,
						"w": 351
					},
					{
						"n": 16,
						"h": 195,
						"w": 353
					},
					{
						"n": 15,
						"h": 195,
						"w": 230
					},
					{
						"n": 18,
						"h": 37,
						"w": 158
					},
					{
						"n": 17,
						"h": 252,
						"w": 287
					},
					{
						"n": 19,
						"h": 298,
						"w": 141
					},
					{
						"n": 20,
						"h": 156,
						"w": 153
					}
				],
				"ball": {
					"n": 0,
					"h": 379,
					"w": 369,
					"z": 0,
					"r": 0,
					"p": 0,
					"x": 0
				}
			},
			"interval": 40
		},
		{
			"num": 1949,
			"minute": 93,
			"messages": [
				{
					"owner": 0,
					"mes": "Матч завершен."
				}
			],
			"M": "0"
		}
	],
	"online_games": [
		{
			"team1": "Витязь",
			"team2": "Фейеноорд",
			"flag1": "system/img/club/1872.gif",
			"flag2": "system/img/club/460.gif",
			"goals": null
		},
		{
			"team1": "Глазго Рэйнджерс",
			"team2": "Тревизо",
			"flag1": "system/img/club/782.gif",
			"flag2": "system/img/club/564.gif",
			"goals": [
				{
					"min": 91,
					"team": 1,
					"own": 0,
					"player": "Д.Ахерн"
				}
			]
		},
		{
			"team1": "Академика",
			"team2": "Гронинген",
			"flag1": "system/img/club/677.gif",
			"flag2": "system/img/club/463.gif",
			"goals": [
				{
					"min": 20,
					"team": 1,
					"own": 0,
					"player": "О.Оврелид"
				},
				{
					"min": 35,
					"team": 2,
					"own": 0,
					"player": "Я.Туре"
				},
				{
					"min": 55,
					"team": 2,
					"own": 0,
					"player": "Я.Туре"
				},
				{
					"min": 79,
					"team": 1,
					"own": 0,
					"player": "О.Оврелид"
				},
				{
					"min": 91,
					"team": 1,
					"own": 0,
					"player": "Ф.Рашид"
				}
			]
		},
		{
			"team1": "Шилуте",
			"team2": "Харелбеке",
			"flag1": "system/img/club/1657.gif",
			"flag2": "system/img/club/1799.gif",
			"goals": [
				{
					"min": 82,
					"team": 1,
					"own": 0,
					"player": "А.Нечаев"
				},
				{
					"min": 84,
					"team": 1,
					"own": 0,
					"player": "Г.Купрейкис"
				}
			]
		},
		{
			"team1": "Зета",
			"team2": "Кильмес",
			"flag1": "system/img/club/1119.gif",
			"flag2": "system/img/club/32.gif",
			"goals": [
				{
					"min": 7,
					"team": 1,
					"own": 0,
					"player": "П.Петек"
				},
				{
					"min": 41,
					"team": 1,
					"own": 0,
					"player": "Ф.Калачевич"
				},
				{
					"min": 91,
					"team": 1,
					"own": 0,
					"player": "Ш.Новак"
				}
			]
		},
		{
			"team1": "Туран Т",
			"team2": "Рудар П",
			"flag1": "system/img/club/1411.gif",
			"flag2": "system/img/club/1064.gif",
			"goals": [
				{
					"min": 15,
					"team": 2,
					"own": 0,
					"player": "К.Бьюгре"
				},
				{
					"min": 20,
					"team": 2,
					"own": 0,
					"player": "К.Бьюгре"
				},
				{
					"min": 48,
					"team": 2,
					"own": 0,
					"player": "С.Голубович"
				}
			]
		},
		{
			"team1": "Саутенд",
			"team2": "Халифакс",
			"flag1": "system/img/club/297.gif",
			"flag2": "system/img/club/1332.gif",
			"goals": [
				{
					"min": 13,
					"team": 2,
					"own": 0,
					"player": "Л.Грегори"
				},
				{
					"min": 21,
					"team": 1,
					"own": 0,
					"player": "М.Ройс"
				},
				{
					"min": 54,
					"team": 1,
					"own": 0,
					"player": "М.Ройс"
				},
				{
					"min": 73,
					"team": 2,
					"own": 0,
					"player": "Д.Дин"
				},
				{
					"min": 78,
					"team": 2,
					"own": 0,
					"player": "Л.Грегори"
				}
			]
		},
		{
			"team1": "Карлайл",
			"team2": "Колос",
			"flag1": "system/img/club/242.gif",
			"flag2": "system/img/club/1145.gif",
			"goals": [
				{
					"min": 2,
					"team": 1,
					"own": 0,
					"player": "Ф.Курт"
				},
				{
					"min": 42,
					"team": 2,
					"own": 0,
					"player": "Д.Осадец"
				},
				{
					"min": 68,
					"team": 1,
					"own": 0,
					"player": "Д.Линч"
				},
				{
					"min": 80,
					"team": 2,
					"own": 0,
					"player": "А.Цыганков"
				}
			]
		},
		{
			"team1": "Джубило Ивата",
			"team2": "Сайлия",
			"flag1": "system/img/club/587.gif",
			"flag2": "system/img/club/2224.gif",
			"goals": null
		},
		{
			"team1": "Подолье Хм",
			"team2": "Свит",
			"flag1": "system/img/club/1155.gif",
			"flag2": "system/img/club/670.gif",
			"goals": [
				{
					"min": 41,
					"team": 1,
					"own": 0,
					"player": "Й.Лауритс"
				},
				{
					"min": 47,
					"team": 1,
					"own": 0,
					"player": "И.Белосорочко"
				},
				{
					"min": 84,
					"team": 1,
					"own": 0,
					"player": "Ю.Пазюк"
				}
			]
		},
		{
			"team1": "Аукас",
			"team2": "Спартаний",
			"flag1": "system/img/club/924.gif",
			"flag2": "system/img/club/1388.gif",
			"goals": null
		},
		{
			"team1": "Комо",
			"team2": "Сидней",
			"flag1": "system/img/club/517.gif",
			"flag2": "system/img/club/52.gif",
			"goals": [
				{
					"min": 9,
					"team": 2,
					"own": 0,
					"player": "М.Бах"
				},
				{
					"min": 24,
					"team": 2,
					"own": 0,
					"player": "Л.Смит"
				},
				{
					"min": 45,
					"team": 2,
					"own": 0,
					"player": "Л.Смит"
				},
				{
					"min": 55,
					"team": 1,
					"own": 0,
					"player": "Л.ЗуаЗуа"
				},
				{
					"min": 70,
					"team": 2,
					"own": 0,
					"player": "М.Бах"
				}
			]
		}
	]
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/sources/game_full.json
 ** module id = 315
 ** module chunks = 0
 **/